
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2596"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2596"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("boZNq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e4b14ad7ed75be8c$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $jjYvL = parcelRequire("jjYvL");
var $e4b14ad7ed75be8c$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $TusQn.defineComponent)({
    __name: 'App',
    setup (__props, { expose: __expose }) {
        __expose();
        const drawer = (0, $01W3b.ref)(false);
        const graphViewRef = (0, $01W3b.ref)(null);
        function openSavedDialog() {
            if (graphViewRef.value) {
                graphViewRef.value.savedStatesDialog = true;
                graphViewRef.value.loadSavedStates();
            }
        }
        const __returned__ = {
            drawer: drawer,
            graphViewRef: graphViewRef,
            openSavedDialog: openSavedDialog,
            GraphView: $jjYvL.default
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("ecd4d", function(module, exports) {
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "capitalize", () => (parcelRequire("8POXm")).capitalize);
$parcel$export(module.exports, "cloneVNode", () => (parcelRequire("TusQn")).cloneVNode);
$parcel$export(module.exports, "Comment", () => (parcelRequire("TusQn")).Comment);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("TusQn")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("TusQn")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isProxy", () => (parcelRequire("01W3b")).isProxy);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isVNode", () => (parcelRequire("TusQn")).isVNode);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useId", () => (parcelRequire("TusQn")).useId);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "createApp", () => (parcelRequire("eeJ70")).createApp);
$parcel$export(module.exports, "render", () => (parcelRequire("eeJ70")).render);
$parcel$export(module.exports, "Transition", () => (parcelRequire("eeJ70")).Transition);
$parcel$export(module.exports, "TransitionGroup", () => (parcelRequire("eeJ70")).TransitionGroup);
$parcel$export(module.exports, "vModelText", () => (parcelRequire("eeJ70")).vModelText);
$parcel$export(module.exports, "vShow", () => (parcelRequire("eeJ70")).vShow);
$parcel$export(module.exports, "withKeys", () => (parcelRequire("eeJ70")).withKeys);
$parcel$export(module.exports, "withModifiers", () => (parcelRequire("eeJ70")).withModifiers);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8POXm")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);
/**
* vue v3.5.28
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");parcelRequire("eeJ70");parcelRequire("01W3b");parcelRequire("8POXm");
function $a55c527d369bf9c1$var$initDev() {
    (0, $TusQn.initCustomFormatter)();
}
const $a55c527d369bf9c1$export$ef7acd7185315e22 = ()=>{};

});
parcelRegister("TusQn", function(module, exports) {

$parcel$export(module.exports, "callWithAsyncErrorHandling", () => $0a6cc4ba868319ae$export$dae85862a8d94378);
$parcel$export(module.exports, "nextTick", () => $0a6cc4ba868319ae$export$bdd553fddd433dcb);
$parcel$export(module.exports, "queuePostFlushCb", () => $0a6cc4ba868319ae$export$59536a0199721cab);
$parcel$export(module.exports, "Fragment", () => $0a6cc4ba868319ae$export$ffb0004e005737fa);
$parcel$export(module.exports, "Text", () => $0a6cc4ba868319ae$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Comment", () => $0a6cc4ba868319ae$export$4d299b491347818a);
$parcel$export(module.exports, "Static", () => $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6);
$parcel$export(module.exports, "withCtx", () => $0a6cc4ba868319ae$export$694b237e827a3d23);
$parcel$export(module.exports, "withDirectives", () => $0a6cc4ba868319ae$export$49729353e7c1e6c5);
$parcel$export(module.exports, "provide", () => $0a6cc4ba868319ae$export$abe1e183e22e10ad);
$parcel$export(module.exports, "inject", () => $0a6cc4ba868319ae$export$a976684a0efeb93f);
$parcel$export(module.exports, "getCurrentInstance", () => $0a6cc4ba868319ae$export$f13e630aa3915748);
$parcel$export(module.exports, "hasInjectionContext", () => $0a6cc4ba868319ae$export$caf6761f24fc571a);
$parcel$export(module.exports, "watchEffect", () => $0a6cc4ba868319ae$export$ede35fc0e5500309);
$parcel$export(module.exports, "watch", () => $0a6cc4ba868319ae$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "Teleport", () => $0a6cc4ba868319ae$export$76d55a0304a371f4);
$parcel$export(module.exports, "useTransitionState", () => $0a6cc4ba868319ae$export$d2a0a1bc267c90f6);
$parcel$export(module.exports, "onMounted", () => $0a6cc4ba868319ae$export$6d1641039221b5cb);
$parcel$export(module.exports, "onBeforeUnmount", () => $0a6cc4ba868319ae$export$40c420df62d2614);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => $0a6cc4ba868319ae$export$b876c99684f8cf3b);
$parcel$export(module.exports, "getTransitionRawChildren", () => $0a6cc4ba868319ae$export$a67f9b1229c7c97a);
$parcel$export(module.exports, "resolveTransitionHooks", () => $0a6cc4ba868319ae$export$76ac1779589cd824);
$parcel$export(module.exports, "setTransitionHooks", () => $0a6cc4ba868319ae$export$7770a22486565649);
$parcel$export(module.exports, "BaseTransition", () => $0a6cc4ba868319ae$export$abd95b5f5e8a8837);
$parcel$export(module.exports, "cloneVNode", () => $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a);
$parcel$export(module.exports, "defineComponent", () => $0a6cc4ba868319ae$export$afa64b67e5a01c3b);
$parcel$export(module.exports, "useId", () => $0a6cc4ba868319ae$export$f680877a34711e37);
$parcel$export(module.exports, "createVNode", () => $0a6cc4ba868319ae$export$bf5c4cf060303d58);
$parcel$export(module.exports, "createTextVNode", () => $0a6cc4ba868319ae$export$22f9b5ffd89dac9);
$parcel$export(module.exports, "onUpdated", () => $0a6cc4ba868319ae$export$5876c47052fb88b1);
$parcel$export(module.exports, "isVNode", () => $0a6cc4ba868319ae$export$3868d13f8734ae81);
$parcel$export(module.exports, "onActivated", () => $0a6cc4ba868319ae$export$ba52d824b95a2154);
$parcel$export(module.exports, "onDeactivated", () => $0a6cc4ba868319ae$export$bf1440eeaf5fa709);
$parcel$export(module.exports, "onUnmounted", () => $0a6cc4ba868319ae$export$13348a43ccacfe58);
$parcel$export(module.exports, "onBeforeMount", () => $0a6cc4ba868319ae$export$23b7aeb0d671f804);
$parcel$export(module.exports, "onBeforeUpdate", () => $0a6cc4ba868319ae$export$ab91988a13872e4c);
$parcel$export(module.exports, "resolveComponent", () => $0a6cc4ba868319ae$export$681d65eec9d1d1e8);
$parcel$export(module.exports, "resolveDynamicComponent", () => $0a6cc4ba868319ae$export$b44c564a05ca975);
$parcel$export(module.exports, "renderList", () => $0a6cc4ba868319ae$export$4bf387f59bfc6d67);
$parcel$export(module.exports, "openBlock", () => $0a6cc4ba868319ae$export$e7eaa45e502fe5cc);
$parcel$export(module.exports, "createBlock", () => $0a6cc4ba868319ae$export$9f2dfe8048dfb22b);
$parcel$export(module.exports, "computed", () => $0a6cc4ba868319ae$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "createRenderer", () => $0a6cc4ba868319ae$export$53ae2f996c64e9a);
$parcel$export(module.exports, "createHydrationRenderer", () => $0a6cc4ba868319ae$export$200524cf0d997ff0);
$parcel$export(module.exports, "createElementBlock", () => $0a6cc4ba868319ae$export$167055419fc69ec1);
$parcel$export(module.exports, "createElementVNode", () => $0a6cc4ba868319ae$export$42098e0eaa15c48e);
$parcel$export(module.exports, "guardReactiveProps", () => $0a6cc4ba868319ae$export$1f1be0e0e384d7d2);
$parcel$export(module.exports, "mergeProps", () => $0a6cc4ba868319ae$export$9d1611c77c2fe928);
$parcel$export(module.exports, "createCommentVNode", () => $0a6cc4ba868319ae$export$49553837c7236d3c);
$parcel$export(module.exports, "isRuntimeOnly", () => $0a6cc4ba868319ae$export$c93a9c496c5211fa);
$parcel$export(module.exports, "h", () => $0a6cc4ba868319ae$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "initCustomFormatter", () => $0a6cc4ba868319ae$export$aed4979be6a60047);
$parcel$export(module.exports, "warn", () => $0a6cc4ba868319ae$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "isProxy", () => (parcelRequire("01W3b")).isProxy);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "capitalize", () => (parcelRequire("8POXm")).capitalize);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
/**
* @vue/runtime-core v3.5.28
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $01W3b = parcelRequire("01W3b");

var $8POXm = parcelRequire("8POXm");
const $0a6cc4ba868319ae$var$stack = [];
function $0a6cc4ba868319ae$var$pushWarningContext(vnode) {
    $0a6cc4ba868319ae$var$stack.push(vnode);
}
function $0a6cc4ba868319ae$var$popWarningContext() {
    $0a6cc4ba868319ae$var$stack.pop();
}
let $0a6cc4ba868319ae$var$isWarning = false;
function $0a6cc4ba868319ae$var$warn$1(msg, ...args) {
    if ($0a6cc4ba868319ae$var$isWarning) return;
    $0a6cc4ba868319ae$var$isWarning = true;
    (0, $01W3b.pauseTracking)();
    const instance = $0a6cc4ba868319ae$var$stack.length ? $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1].component : null;
    const appWarnHandler = instance && instance.appContext.config.warnHandler;
    const trace = $0a6cc4ba868319ae$var$getComponentTrace();
    if (appWarnHandler) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(appWarnHandler, instance, 11, [
        // eslint-disable-next-line no-restricted-syntax
        msg + args.map((a)=>{
            var _a, _b;
            return (_b = (_a = a.toString) == null ? void 0 : _a.call(a)) != null ? _b : JSON.stringify(a);
        }).join(""),
        instance && instance.proxy,
        trace.map(({ vnode: vnode })=>`at <${$0a6cc4ba868319ae$var$formatComponentName(instance, vnode.type)}>`).join("\n"),
        trace
    ]);
    else {
        const warnArgs = [
            `[Vue warn]: ${msg}`,
            ...args
        ];
        if (trace.length && // avoid spamming console during tests
        true) warnArgs.push(`
`, ...$0a6cc4ba868319ae$var$formatTrace(trace));
        console.warn(...warnArgs);
    }
    (0, $01W3b.resetTracking)();
    $0a6cc4ba868319ae$var$isWarning = false;
}
function $0a6cc4ba868319ae$var$getComponentTrace() {
    let currentVNode = $0a6cc4ba868319ae$var$stack[$0a6cc4ba868319ae$var$stack.length - 1];
    if (!currentVNode) return [];
    const normalizedStack = [];
    while(currentVNode){
        const last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        const parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $0a6cc4ba868319ae$var$formatTrace(trace) {
    const logs = [];
    trace.forEach((entry, i)=>{
        logs.push(...i === 0 ? [] : [
            `
`
        ], ...$0a6cc4ba868319ae$var$formatTraceEntry(entry));
    });
    return logs;
}
function $0a6cc4ba868319ae$var$formatTraceEntry({ vnode: vnode, recurseCount: recurseCount }) {
    const postfix = recurseCount > 0 ? `... (${recurseCount} recursive calls)` : ``;
    const isRoot = vnode.component ? vnode.component.parent == null : false;
    const open = ` at <${$0a6cc4ba868319ae$var$formatComponentName(vnode.component, vnode.type, isRoot)}`;
    const close = `>` + postfix;
    return vnode.props ? [
        open,
        ...$0a6cc4ba868319ae$var$formatProps(vnode.props),
        close
    ] : [
        open + close
    ];
}
function $0a6cc4ba868319ae$var$formatProps(props) {
    const res = [];
    const keys = Object.keys(props);
    keys.slice(0, 3).forEach((key)=>{
        res.push(...$0a6cc4ba868319ae$var$formatProp(key, props[key]));
    });
    if (keys.length > 3) res.push(` ...`);
    return res;
}
function $0a6cc4ba868319ae$var$formatProp(key, value, raw) {
    if ((0, $8POXm.isString)(value)) {
        value = JSON.stringify(value);
        return raw ? value : [
            `${key}=${value}`
        ];
    } else if (typeof value === "number" || typeof value === "boolean" || value == null) return raw ? value : [
        `${key}=${value}`
    ];
    else if ((0, $01W3b.isRef)(value)) {
        value = $0a6cc4ba868319ae$var$formatProp(key, (0, $01W3b.toRaw)(value.value), true);
        return raw ? value : [
            `${key}=Ref<`,
            value,
            `>`
        ];
    } else if ((0, $8POXm.isFunction)(value)) return [
        `${key}=fn${value.name ? `<${value.name}>` : ``}`
    ];
    else {
        value = (0, $01W3b.toRaw)(value);
        return raw ? value : [
            `${key}=`,
            value
        ];
    }
}
function $0a6cc4ba868319ae$export$dfbcecb440255e4a(val, type) {
    return;
}
const $0a6cc4ba868319ae$export$10e8e1cf990558d7 = {
    "SETUP_FUNCTION": 0,
    "0": "SETUP_FUNCTION",
    "RENDER_FUNCTION": 1,
    "1": "RENDER_FUNCTION",
    "NATIVE_EVENT_HANDLER": 5,
    "5": "NATIVE_EVENT_HANDLER",
    "COMPONENT_EVENT_HANDLER": 6,
    "6": "COMPONENT_EVENT_HANDLER",
    "VNODE_HOOK": 7,
    "7": "VNODE_HOOK",
    "DIRECTIVE_HOOK": 8,
    "8": "DIRECTIVE_HOOK",
    "TRANSITION_HOOK": 9,
    "9": "TRANSITION_HOOK",
    "APP_ERROR_HANDLER": 10,
    "10": "APP_ERROR_HANDLER",
    "APP_WARN_HANDLER": 11,
    "11": "APP_WARN_HANDLER",
    "FUNCTION_REF": 12,
    "12": "FUNCTION_REF",
    "ASYNC_COMPONENT_LOADER": 13,
    "13": "ASYNC_COMPONENT_LOADER",
    "SCHEDULER": 14,
    "14": "SCHEDULER",
    "COMPONENT_UPDATE": 15,
    "15": "COMPONENT_UPDATE",
    "APP_UNMOUNT_CLEANUP": 16,
    "16": "APP_UNMOUNT_CLEANUP"
};
const $0a6cc4ba868319ae$var$ErrorTypeStrings$1 = {
    ["sp"]: "serverPrefetch hook",
    ["bc"]: "beforeCreate hook",
    ["c"]: "created hook",
    ["bm"]: "beforeMount hook",
    ["m"]: "mounted hook",
    ["bu"]: "beforeUpdate hook",
    ["u"]: "updated",
    ["bum"]: "beforeUnmount hook",
    ["um"]: "unmounted hook",
    ["a"]: "activated hook",
    ["da"]: "deactivated hook",
    ["ec"]: "errorCaptured hook",
    ["rtc"]: "renderTracked hook",
    ["rtg"]: "renderTriggered hook",
    [0]: "setup function",
    [1]: "render function",
    [2]: "watcher getter",
    [3]: "watcher callback",
    [4]: "watcher cleanup function",
    [5]: "native event handler",
    [6]: "component event handler",
    [7]: "vnode hook",
    [8]: "directive hook",
    [9]: "transition hook",
    [10]: "app errorHandler",
    [11]: "app warnHandler",
    [12]: "ref function",
    [13]: "async component loader",
    [14]: "scheduler flush",
    [15]: "component update",
    [16]: "app unmount cleanup function"
};
function $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args) {
    try {
        return args ? fn(...args) : fn();
    } catch (err) {
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
    }
}
function $0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $8POXm.isFunction)(fn)) {
        const res = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $8POXm.isPromise)(res)) res.catch((err)=>{
            $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    if ((0, $8POXm.isArray)(fn)) {
        const values = [];
        for(let i = 0; i < fn.length; i++)values.push($0a6cc4ba868319ae$export$dae85862a8d94378(fn[i], instance, type, args));
        return values;
    }
}
function $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, type, throwInDev = true) {
    const contextVNode = instance ? instance.vnode : null;
    const { errorHandler: errorHandler, throwUnhandledErrorInProduction: throwUnhandledErrorInProduction } = instance && instance.appContext.config || (0, $8POXm.EMPTY_OBJ);
    if (instance) {
        let cur = instance.parent;
        const exposedInstance = instance.proxy;
        const errorInfo = `https://vuejs.org/error-reference/#runtime-${type}`;
        while(cur){
            const errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(let i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        if (errorHandler) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$b22fcaf88446e9bf(errorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            (0, $01W3b.resetTracking)();
            return;
        }
    }
    $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev, throwUnhandledErrorInProduction);
}
function $0a6cc4ba868319ae$var$logError(err, type, contextVNode, throwInDev = true, throwInProd = false) {
    if (throwInProd) throw err;
    else console.error(err);
}
const $0a6cc4ba868319ae$var$queue = [];
let $0a6cc4ba868319ae$var$flushIndex = -1;
const $0a6cc4ba868319ae$var$pendingPostFlushCbs = [];
let $0a6cc4ba868319ae$var$activePostFlushCbs = null;
let $0a6cc4ba868319ae$var$postFlushIndex = 0;
const $0a6cc4ba868319ae$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
let $0a6cc4ba868319ae$var$currentFlushPromise = null;
const $0a6cc4ba868319ae$var$RECURSION_LIMIT = 100;
function $0a6cc4ba868319ae$export$bdd553fddd433dcb(fn) {
    const p = $0a6cc4ba868319ae$var$currentFlushPromise || $0a6cc4ba868319ae$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $0a6cc4ba868319ae$var$findInsertionIndex(id) {
    let start = $0a6cc4ba868319ae$var$flushIndex + 1;
    let end = $0a6cc4ba868319ae$var$queue.length;
    while(start < end){
        const middle = start + end >>> 1;
        const middleJob = $0a6cc4ba868319ae$var$queue[middle];
        const middleJobId = $0a6cc4ba868319ae$var$getId(middleJob);
        if (middleJobId < id || middleJobId === id && middleJob.flags & 2) start = middle + 1;
        else end = middle;
    }
    return start;
}
function $0a6cc4ba868319ae$var$queueJob(job) {
    if (!(job.flags & 1)) {
        const jobId = $0a6cc4ba868319ae$var$getId(job);
        const lastJob = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$queue.length - 1];
        if (!lastJob || // fast path when the job id is larger than the tail
        !(job.flags & 2) && jobId >= $0a6cc4ba868319ae$var$getId(lastJob)) $0a6cc4ba868319ae$var$queue.push(job);
        else $0a6cc4ba868319ae$var$queue.splice($0a6cc4ba868319ae$var$findInsertionIndex(jobId), 0, job);
        job.flags |= 1;
        $0a6cc4ba868319ae$var$queueFlush();
    }
}
function $0a6cc4ba868319ae$var$queueFlush() {
    if (!$0a6cc4ba868319ae$var$currentFlushPromise) $0a6cc4ba868319ae$var$currentFlushPromise = $0a6cc4ba868319ae$var$resolvedPromise.then($0a6cc4ba868319ae$var$flushJobs);
}
function $0a6cc4ba868319ae$export$59536a0199721cab(cb) {
    if (!(0, $8POXm.isArray)(cb)) {
        if ($0a6cc4ba868319ae$var$activePostFlushCbs && cb.id === -1) $0a6cc4ba868319ae$var$activePostFlushCbs.splice($0a6cc4ba868319ae$var$postFlushIndex + 1, 0, cb);
        else if (!(cb.flags & 1)) {
            $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(cb);
            cb.flags |= 1;
        }
    } else $0a6cc4ba868319ae$var$pendingPostFlushCbs.push(...cb);
    $0a6cc4ba868319ae$var$queueFlush();
}
function $0a6cc4ba868319ae$var$flushPreFlushCbs(instance, seen, i = $0a6cc4ba868319ae$var$flushIndex + 1) {
    for(; i < $0a6cc4ba868319ae$var$queue.length; i++){
        const cb = $0a6cc4ba868319ae$var$queue[i];
        if (cb && cb.flags & 2) {
            if (instance && cb.id !== instance.uid) continue;
            $0a6cc4ba868319ae$var$queue.splice(i, 1);
            i--;
            if (cb.flags & 4) cb.flags &= -2;
            cb();
            if (!(cb.flags & 4)) cb.flags &= -2;
        }
    }
}
function $0a6cc4ba868319ae$var$flushPostFlushCbs(seen) {
    if ($0a6cc4ba868319ae$var$pendingPostFlushCbs.length) {
        const deduped = [
            ...new Set($0a6cc4ba868319ae$var$pendingPostFlushCbs)
        ].sort((a, b)=>$0a6cc4ba868319ae$var$getId(a) - $0a6cc4ba868319ae$var$getId(b));
        $0a6cc4ba868319ae$var$pendingPostFlushCbs.length = 0;
        if ($0a6cc4ba868319ae$var$activePostFlushCbs) {
            $0a6cc4ba868319ae$var$activePostFlushCbs.push(...deduped);
            return;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = deduped;
        for($0a6cc4ba868319ae$var$postFlushIndex = 0; $0a6cc4ba868319ae$var$postFlushIndex < $0a6cc4ba868319ae$var$activePostFlushCbs.length; $0a6cc4ba868319ae$var$postFlushIndex++){
            const cb = $0a6cc4ba868319ae$var$activePostFlushCbs[$0a6cc4ba868319ae$var$postFlushIndex];
            if (cb.flags & 4) cb.flags &= -2;
            if (!(cb.flags & 8)) cb();
            cb.flags &= -2;
        }
        $0a6cc4ba868319ae$var$activePostFlushCbs = null;
        $0a6cc4ba868319ae$var$postFlushIndex = 0;
    }
}
const $0a6cc4ba868319ae$var$getId = (job)=>job.id == null ? job.flags & 2 ? -1 : Infinity : job.id;
function $0a6cc4ba868319ae$var$flushJobs(seen) {
    const check = (0, $8POXm.NOOP);
    try {
        for($0a6cc4ba868319ae$var$flushIndex = 0; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job && !(job.flags & 8)) {
                if (job.flags & 4) job.flags &= -2;
                $0a6cc4ba868319ae$export$b22fcaf88446e9bf(job, job.i, job.i ? 15 : 14);
                if (!(job.flags & 4)) job.flags &= -2;
            }
        }
    } finally{
        for(; $0a6cc4ba868319ae$var$flushIndex < $0a6cc4ba868319ae$var$queue.length; $0a6cc4ba868319ae$var$flushIndex++){
            const job = $0a6cc4ba868319ae$var$queue[$0a6cc4ba868319ae$var$flushIndex];
            if (job) job.flags &= -2;
        }
        $0a6cc4ba868319ae$var$flushIndex = -1;
        $0a6cc4ba868319ae$var$queue.length = 0;
        $0a6cc4ba868319ae$var$flushPostFlushCbs(seen);
        $0a6cc4ba868319ae$var$currentFlushPromise = null;
        if ($0a6cc4ba868319ae$var$queue.length || $0a6cc4ba868319ae$var$pendingPostFlushCbs.length) $0a6cc4ba868319ae$var$flushJobs(seen);
    }
}
function $0a6cc4ba868319ae$var$checkRecursiveUpdates(seen, fn) {
    const count = seen.get(fn) || 0;
    if (count > $0a6cc4ba868319ae$var$RECURSION_LIMIT) {
        const instance = fn.i;
        const componentName = instance && $0a6cc4ba868319ae$var$getComponentName(instance.type);
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(`Maximum recursive updates exceeded${componentName ? ` in component <${componentName}>` : ``}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`, null, 10);
        return true;
    }
    seen.set(fn, count + 1);
    return false;
}
let $0a6cc4ba868319ae$var$isHmrUpdating = false;
const $0a6cc4ba868319ae$var$hmrDirtyComponents = /* @__PURE__ */ new Map();
const $0a6cc4ba868319ae$var$map = /* @__PURE__ */ new Map();
function $0a6cc4ba868319ae$var$registerHMR(instance) {
    const id = instance.type.__hmrId;
    let record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) {
        $0a6cc4ba868319ae$var$createRecord(id, instance.type);
        record = $0a6cc4ba868319ae$var$map.get(id);
    }
    record.instances.add(instance);
}
function $0a6cc4ba868319ae$var$unregisterHMR(instance) {
    $0a6cc4ba868319ae$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $0a6cc4ba868319ae$var$createRecord(id, initialDef) {
    if ($0a6cc4ba868319ae$var$map.has(id)) return false;
    $0a6cc4ba868319ae$var$map.set(id, {
        initialDef: $0a6cc4ba868319ae$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $0a6cc4ba868319ae$var$normalizeClassComponent(component) {
    return $0a6cc4ba868319ae$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $0a6cc4ba868319ae$var$rerender(id, newRender) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    [
        ...record.instances
    ].forEach((instance)=>{
        if (newRender) {
            instance.render = newRender;
            $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $0a6cc4ba868319ae$var$isHmrUpdating = true;
        if (!(instance.job.flags & 8)) instance.update();
        $0a6cc4ba868319ae$var$isHmrUpdating = false;
    });
}
function $0a6cc4ba868319ae$var$reload(id, newComp) {
    const record = $0a6cc4ba868319ae$var$map.get(id);
    if (!record) return;
    newComp = $0a6cc4ba868319ae$var$normalizeClassComponent(newComp);
    $0a6cc4ba868319ae$var$updateComponentDef(record.initialDef, newComp);
    const instances = [
        ...record.instances
    ];
    for(let i = 0; i < instances.length; i++){
        const instance = instances[i];
        const oldComp = $0a6cc4ba868319ae$var$normalizeClassComponent(instance.type);
        let dirtyInstances = $0a6cc4ba868319ae$var$hmrDirtyComponents.get(oldComp);
        if (!dirtyInstances) {
            if (oldComp !== record.initialDef) $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp);
            $0a6cc4ba868319ae$var$hmrDirtyComponents.set(oldComp, dirtyInstances = /* @__PURE__ */ new Set());
        }
        dirtyInstances.add(instance);
        instance.appContext.propsCache.delete(instance.type);
        instance.appContext.emitsCache.delete(instance.type);
        instance.appContext.optionsCache.delete(instance.type);
        if (instance.ceReload) {
            dirtyInstances.add(instance);
            instance.ceReload(newComp.styles);
            dirtyInstances.delete(instance);
        } else if (instance.parent) $0a6cc4ba868319ae$var$queueJob(()=>{
            if (!(instance.job.flags & 8)) {
                $0a6cc4ba868319ae$var$isHmrUpdating = true;
                instance.parent.update();
                $0a6cc4ba868319ae$var$isHmrUpdating = false;
                dirtyInstances.delete(instance);
            }
        });
        else if (instance.appContext.reload) instance.appContext.reload();
        else if (typeof window !== "undefined") window.location.reload();
        else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        if (instance.root.ce && instance !== instance.root) instance.root.ce._removeChildStyle(oldComp);
    }
    $0a6cc4ba868319ae$export$59536a0199721cab(()=>{
        $0a6cc4ba868319ae$var$hmrDirtyComponents.clear();
    });
}
function $0a6cc4ba868319ae$var$updateComponentDef(oldComp, newComp) {
    (0, $8POXm.extend)(oldComp, newComp);
    for(const key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $0a6cc4ba868319ae$var$tryWrap(fn) {
    return (id, arg)=>{
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn(`[HMR] Something went wrong during Vue component hot-reload. Full reload required.`);
        }
    };
}
let $0a6cc4ba868319ae$var$devtools$1;
let $0a6cc4ba868319ae$var$buffer = [];
let $0a6cc4ba868319ae$var$devtoolsNotInstalled = false;
function $0a6cc4ba868319ae$var$emit$1(event, ...args) {
    if ($0a6cc4ba868319ae$var$devtools$1) $0a6cc4ba868319ae$var$devtools$1.emit(event, ...args);
    else if (!$0a6cc4ba868319ae$var$devtoolsNotInstalled) $0a6cc4ba868319ae$var$buffer.push({
        event: event,
        args: args
    });
}
function $0a6cc4ba868319ae$var$setDevtoolsHook$1(hook, target) {
    var _a, _b;
    $0a6cc4ba868319ae$var$devtools$1 = hook;
    if ($0a6cc4ba868319ae$var$devtools$1) {
        $0a6cc4ba868319ae$var$devtools$1.enabled = true;
        $0a6cc4ba868319ae$var$buffer.forEach(({ event: event, args: args })=>$0a6cc4ba868319ae$var$devtools$1.emit(event, ...args));
        $0a6cc4ba868319ae$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    // eslint-disable-next-line no-restricted-syntax
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        const replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push((newHook)=>{
            $0a6cc4ba868319ae$var$setDevtoolsHook$1(newHook, target);
        });
        setTimeout(()=>{
            if (!$0a6cc4ba868319ae$var$devtools$1) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
                $0a6cc4ba868319ae$var$buffer = [];
            }
        }, 3e3);
    } else {
        $0a6cc4ba868319ae$var$devtoolsNotInstalled = true;
        $0a6cc4ba868319ae$var$buffer = [];
    }
}
function $0a6cc4ba868319ae$var$devtoolsInitApp(app, version) {
    $0a6cc4ba868319ae$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $0a6cc4ba868319ae$export$ffb0004e005737fa,
        Text: $0a6cc4ba868319ae$export$5f1af8db9871e1d6,
        Comment: $0a6cc4ba868319ae$export$4d299b491347818a,
        Static: $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6
    });
}
function $0a6cc4ba868319ae$var$devtoolsUnmountApp(app) {
    $0a6cc4ba868319ae$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
const $0a6cc4ba868319ae$var$devtoolsComponentAdded = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentUpdated = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
const $0a6cc4ba868319ae$var$_devtoolsComponentRemoved = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
const $0a6cc4ba868319ae$var$devtoolsComponentRemoved = (component)=>{
    if ($0a6cc4ba868319ae$var$devtools$1 && typeof $0a6cc4ba868319ae$var$devtools$1.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$0a6cc4ba868319ae$var$devtools$1.cleanupBuffer(component)) $0a6cc4ba868319ae$var$_devtoolsComponentRemoved(component);
};
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$var$createDevtoolsComponentHook(hook) {
    return (component)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
const $0a6cc4ba868319ae$var$devtoolsPerfStart = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
const $0a6cc4ba868319ae$var$devtoolsPerfEnd = /* @__PURE__ */ $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $0a6cc4ba868319ae$var$createDevtoolsPerformanceHook(hook) {
    return (component, type, time)=>{
        $0a6cc4ba868319ae$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $0a6cc4ba868319ae$var$devtoolsComponentEmit(component, event, params) {
    $0a6cc4ba868319ae$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
let $0a6cc4ba868319ae$var$currentRenderingInstance = null;
let $0a6cc4ba868319ae$var$currentScopeId = null;
function $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance) {
    const prev = $0a6cc4ba868319ae$var$currentRenderingInstance;
    $0a6cc4ba868319ae$var$currentRenderingInstance = instance;
    $0a6cc4ba868319ae$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $0a6cc4ba868319ae$export$ac020265ca2cc4cd(id) {
    $0a6cc4ba868319ae$var$currentScopeId = id;
}
function $0a6cc4ba868319ae$export$f2dc6805dc11834e() {
    $0a6cc4ba868319ae$var$currentScopeId = null;
}
const $0a6cc4ba868319ae$export$15ba313e13f3dd04 = (_id)=>$0a6cc4ba868319ae$export$694b237e827a3d23;
function $0a6cc4ba868319ae$export$694b237e827a3d23(fn, ctx = $0a6cc4ba868319ae$var$currentRenderingInstance, isNonScopedSlot) {
    if (!ctx) return fn;
    if (fn._n) return fn;
    const renderFnWithContext = (...args)=>{
        if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const prevInstance = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(ctx);
        let res;
        try {
            res = fn(...args);
        } finally{
            $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
function $0a6cc4ba868319ae$var$validateDirectiveName(name) {
    if ((0, $8POXm.isBuiltInDirective)(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in directive ids as custom directive id: " + name);
}
function $0a6cc4ba868319ae$export$49729353e7c1e6c5(vnode, directives) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance === null) return vnode;
    const instance = $0a6cc4ba868319ae$var$getComponentPublicInstance($0a6cc4ba868319ae$var$currentRenderingInstance);
    const bindings = vnode.dirs || (vnode.dirs = []);
    for(let i = 0; i < directives.length; i++){
        let [dir, value, arg, modifiers = (0, $8POXm.EMPTY_OBJ)] = directives[i];
        if (dir) {
            if ((0, $8POXm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) (0, $01W3b.traverse)(value);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    const bindings = vnode.dirs;
    const oldBindings = prevVNode && prevVNode.dirs;
    for(let i = 0; i < bindings.length; i++){
        const binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        let hook = binding.dir[name];
        if (hook) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $01W3b.resetTracking)();
        }
    }
}
function $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, value) {
    if ($0a6cc4ba868319ae$var$currentInstance) {
        let provides = $0a6cc4ba868319ae$var$currentInstance.provides;
        const parentProvides = $0a6cc4ba868319ae$var$currentInstance.parent && $0a6cc4ba868319ae$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $0a6cc4ba868319ae$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value;
    }
}
function $0a6cc4ba868319ae$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory = false) {
    const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (instance || $0a6cc4ba868319ae$var$currentApp) {
        let provides = $0a6cc4ba868319ae$var$currentApp ? $0a6cc4ba868319ae$var$currentApp._context.provides : instance ? instance.parent == null || instance.ce ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : void 0;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $8POXm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $0a6cc4ba868319ae$export$caf6761f24fc571a() {
    return !!($0a6cc4ba868319ae$export$f13e630aa3915748() || $0a6cc4ba868319ae$var$currentApp);
}
const $0a6cc4ba868319ae$export$f2549a27e18acf2d = /* @__PURE__ */ Symbol.for("v-scx");
const $0a6cc4ba868319ae$export$6b1c54dc4befcda = ()=>{
    {
        const ctx = $0a6cc4ba868319ae$export$a976684a0efeb93f($0a6cc4ba868319ae$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $0a6cc4ba868319ae$export$ede35fc0e5500309(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, options);
}
function $0a6cc4ba868319ae$export$b7f27ea67102d543(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0a6cc4ba868319ae$export$2035654f31b0e555(effect, options) {
    return $0a6cc4ba868319ae$var$doWatch(effect, null, {
        flush: "sync"
    });
}
function $0a6cc4ba868319ae$export$3db5d71bdb2d5499(source, cb, options) {
    return $0a6cc4ba868319ae$var$doWatch(source, cb, options);
}
function $0a6cc4ba868319ae$var$doWatch(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, flush: flush, once: once } = options;
    const baseWatchOptions = (0, $8POXm.extend)({}, options);
    const runsImmediately = cb && immediate || !cb && flush !== "post";
    let ssrCleanup;
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (flush === "sync") {
            const ctx = $0a6cc4ba868319ae$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else if (!runsImmediately) {
            const watchStopHandle = ()=>{};
            watchStopHandle.stop = (0, $8POXm.NOOP);
            watchStopHandle.resume = (0, $8POXm.NOOP);
            watchStopHandle.pause = (0, $8POXm.NOOP);
            return watchStopHandle;
        }
    }
    const instance = $0a6cc4ba868319ae$var$currentInstance;
    baseWatchOptions.call = (fn, type, args)=>$0a6cc4ba868319ae$export$dae85862a8d94378(fn, instance, type, args);
    let isPre = false;
    if (flush === "post") baseWatchOptions.scheduler = (job)=>{
        $0a6cc4ba868319ae$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else if (flush !== "sync") {
        isPre = true;
        baseWatchOptions.scheduler = (job, isFirstRun)=>{
            if (isFirstRun) job();
            else $0a6cc4ba868319ae$var$queueJob(job);
        };
    }
    baseWatchOptions.augmentJob = (job)=>{
        if (cb) job.flags |= 4;
        if (isPre) {
            job.flags |= 2;
            if (instance) {
                job.id = instance.uid;
                job.i = instance;
            }
        }
    };
    const watchHandle = (0, $01W3b.watch)(source, cb, baseWatchOptions);
    if ($0a6cc4ba868319ae$var$isInSSRComponentSetup) {
        if (ssrCleanup) ssrCleanup.push(watchHandle);
        else if (runsImmediately) watchHandle();
    }
    return watchHandle;
}
function $0a6cc4ba868319ae$var$instanceWatch(source, value, options) {
    const publicThis = this.proxy;
    const getter = (0, $8POXm.isString)(source) ? source.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, source) : ()=>publicThis[source] : source.bind(publicThis, publicThis);
    let cb;
    if ((0, $8POXm.isFunction)(value)) cb = value;
    else {
        cb = value.handler;
        options = value;
    }
    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(this);
    const res = $0a6cc4ba868319ae$var$doWatch(getter, cb.bind(publicThis), options);
    reset();
    return res;
}
function $0a6cc4ba868319ae$var$createPathGetter(ctx, path) {
    const segments = path.split(".");
    return ()=>{
        let cur = ctx;
        for(let i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
const $0a6cc4ba868319ae$var$TeleportEndKey = /* @__PURE__ */ Symbol("_vte");
const $0a6cc4ba868319ae$var$isTeleport = (type)=>type.__isTeleport;
const $0a6cc4ba868319ae$var$isTeleportDisabled = (props)=>props && (props.disabled || props.disabled === "");
const $0a6cc4ba868319ae$var$isTeleportDeferred = (props)=>props && (props.defer || props.defer === "");
const $0a6cc4ba868319ae$var$isTargetSVG = (target)=>typeof SVGElement !== "undefined" && target instanceof SVGElement;
const $0a6cc4ba868319ae$var$isTargetMathML = (target)=>typeof MathMLElement === "function" && target instanceof MathMLElement;
const $0a6cc4ba868319ae$var$resolveTarget = (props, select)=>{
    const targetSelector = props && props.to;
    if ((0, $8POXm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            const target = select(targetSelector);
            return target;
        }
    } else return targetSelector;
};
const $0a6cc4ba868319ae$var$TeleportImpl = {
    name: "Teleport",
    __isTeleport: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals) {
        const { mc: mountChildren, pc: patchChildren, pbc: patchBlockChildren, o: { insert: insert, querySelector: querySelector, createText: createText, createComment: createComment } } = internals;
        const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n2.props);
        let { shapeFlag: shapeFlag, children: children, dynamicChildren: dynamicChildren } = n2;
        if (n1 == null) {
            const placeholder = n2.el = createText("");
            const mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            const mount = (container2, anchor2)=>{
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            };
            const mountToTarget = ()=>{
                const target = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                const targetAnchor = $0a6cc4ba868319ae$var$prepareAnchor(target, n2, createText, insert);
                if (target) {
                    if (namespace !== "svg" && $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
                    else if (namespace !== "mathml" && $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
                    if (parentComponent && parentComponent.isCE) (parentComponent.ce._teleportTargets || (parentComponent.ce._teleportTargets = /* @__PURE__ */ new Set())).add(target);
                    if (!disabled) {
                        mount(target, targetAnchor);
                        $0a6cc4ba868319ae$var$updateCssVars(n2, false);
                    }
                }
            };
            if (disabled) {
                mount(container, mainAnchor);
                $0a6cc4ba868319ae$var$updateCssVars(n2, true);
            }
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props)) {
                n2.el.__isMounted = false;
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    mountToTarget();
                    delete n2.el.__isMounted;
                }, parentSuspense);
            } else mountToTarget();
        } else {
            if ($0a6cc4ba868319ae$var$isTeleportDeferred(n2.props) && n1.el.__isMounted === false) {
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    $0a6cc4ba868319ae$var$TeleportImpl.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                }, parentSuspense);
                return;
            }
            n2.el = n1.el;
            n2.targetStart = n1.targetStart;
            const mainAnchor = n2.anchor = n1.anchor;
            const target = n2.target = n1.target;
            const targetAnchor = n2.targetAnchor = n1.targetAnchor;
            const wasDisabled = $0a6cc4ba868319ae$var$isTeleportDisabled(n1.props);
            const currentContainer = wasDisabled ? container : target;
            const currentAnchor = wasDisabled ? mainAnchor : targetAnchor;
            if (namespace === "svg" || $0a6cc4ba868319ae$var$isTargetSVG(target)) namespace = "svg";
            else if (namespace === "mathml" || $0a6cc4ba868319ae$var$isTargetMathML(target)) namespace = "mathml";
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, namespace, slotScopeIds);
                $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, container, mainAnchor, internals, 1);
                else if (n2.props && n1.props && n2.props.to !== n1.props.to) n2.props.to = n1.props.to;
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    const nextTarget = n2.target = $0a6cc4ba868319ae$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $0a6cc4ba868319ae$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $0a6cc4ba868319ae$var$moveTeleport(n2, target, targetAnchor, internals, 1);
            }
            $0a6cc4ba868319ae$var$updateCssVars(n2, disabled);
        }
    },
    remove (vnode, parentComponent, parentSuspense, { um: unmount, o: { remove: hostRemove } }, doRemove) {
        const { shapeFlag: shapeFlag, children: children, anchor: anchor, targetStart: targetStart, targetAnchor: targetAnchor, target: target, props: props } = vnode;
        if (target) {
            hostRemove(targetStart);
            hostRemove(targetAnchor);
        }
        doRemove && hostRemove(anchor);
        if (shapeFlag & 16) {
            const shouldRemove = doRemove || !$0a6cc4ba868319ae$var$isTeleportDisabled(props);
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                unmount(child, parentComponent, parentSuspense, shouldRemove, !!child.dynamicChildren);
            }
        }
    },
    move: $0a6cc4ba868319ae$var$moveTeleport,
    hydrate: $0a6cc4ba868319ae$var$hydrateTeleport
};
function $0a6cc4ba868319ae$var$moveTeleport(vnode, container, parentAnchor, { o: { insert: insert }, m: move }, moveType = 2) {
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    const { el: el, anchor: anchor, shapeFlag: shapeFlag, children: children, props: props } = vnode;
    const isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $0a6cc4ba868319ae$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(let i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $0a6cc4ba868319ae$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, { o: { nextSibling: nextSibling, parentNode: parentNode, querySelector: querySelector, insert: insert, createText: createText } }, hydrateChildren) {
    function hydrateAnchor(target2, targetNode) {
        let targetAnchor = targetNode;
        while(targetAnchor){
            if (targetAnchor && targetAnchor.nodeType === 8) {
                if (targetAnchor.data === "teleport start anchor") vnode.targetStart = targetAnchor;
                else if (targetAnchor.data === "teleport anchor") {
                    vnode.targetAnchor = targetAnchor;
                    target2._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                    break;
                }
            }
            targetAnchor = nextSibling(targetAnchor);
        }
    }
    function hydrateDisabledTeleport(node2, vnode2) {
        vnode2.anchor = hydrateChildren(nextSibling(node2), vnode2, parentNode(node2), parentComponent, parentSuspense, slotScopeIds, optimized);
    }
    const target = vnode.target = $0a6cc4ba868319ae$var$resolveTarget(vnode.props, querySelector);
    const disabled = $0a6cc4ba868319ae$var$isTeleportDisabled(vnode.props);
    if (target) {
        const targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if (disabled) {
                hydrateDisabledTeleport(node, vnode);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, // if target is the same as the main view, insert anchors before current node
                // to avoid hydrating mismatch
                parentNode(node) === target ? node : null);
            } else {
                vnode.anchor = nextSibling(node);
                hydrateAnchor(target, targetNode);
                if (!vnode.targetAnchor) $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert);
                hydrateChildren(targetNode && nextSibling(targetNode), vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $0a6cc4ba868319ae$var$updateCssVars(vnode, disabled);
    } else if (disabled) {
        if (vnode.shapeFlag & 16) {
            hydrateDisabledTeleport(node, vnode);
            vnode.targetStart = node;
            vnode.targetAnchor = nextSibling(node);
        }
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
const $0a6cc4ba868319ae$export$76d55a0304a371f4 = $0a6cc4ba868319ae$var$TeleportImpl;
function $0a6cc4ba868319ae$var$updateCssVars(vnode, isDisabled) {
    const ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        let node, anchor;
        if (isDisabled) {
            node = vnode.el;
            anchor = vnode.anchor;
        } else {
            node = vnode.targetStart;
            anchor = vnode.targetAnchor;
        }
        while(node && node !== anchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
function $0a6cc4ba868319ae$var$prepareAnchor(target, vnode, createText, insert, anchor = null) {
    const targetStart = vnode.targetStart = createText("");
    const targetAnchor = vnode.targetAnchor = createText("");
    targetStart[$0a6cc4ba868319ae$var$TeleportEndKey] = targetAnchor;
    if (target) {
        insert(targetStart, target, anchor);
        insert(targetAnchor, target, anchor);
    }
    return targetAnchor;
}
const $0a6cc4ba868319ae$var$leaveCbKey = /* @__PURE__ */ Symbol("_leaveCb");
const $0a6cc4ba868319ae$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
function $0a6cc4ba868319ae$export$d2a0a1bc267c90f6() {
    const state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $0a6cc4ba868319ae$export$6d1641039221b5cb(()=>{
        state.isMounted = true;
    });
    $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
        state.isUnmounting = true;
    });
    return state;
}
const $0a6cc4ba868319ae$var$TransitionHookValidator = [
    Function,
    Array
];
const $0a6cc4ba868319ae$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterEnter: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onEnterCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterLeave: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onLeaveCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAfterAppear: $0a6cc4ba868319ae$var$TransitionHookValidator,
    onAppearCancelled: $0a6cc4ba868319ae$var$TransitionHookValidator
};
const $0a6cc4ba868319ae$var$recursiveGetSubtree = (instance)=>{
    const subTree = instance.subTree;
    return subTree.component ? $0a6cc4ba868319ae$var$recursiveGetSubtree(subTree.component) : subTree;
};
const $0a6cc4ba868319ae$var$BaseTransitionImpl = {
    name: `BaseTransition`,
    props: $0a6cc4ba868319ae$export$b876c99684f8cf3b,
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const state = $0a6cc4ba868319ae$export$d2a0a1bc267c90f6();
        return ()=>{
            const children = slots.default && $0a6cc4ba868319ae$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            const child = $0a6cc4ba868319ae$var$findNonCommentChild(children);
            const rawProps = (0, $01W3b.toRaw)(props);
            const { mode: mode } = rawProps;
            if (state.isLeaving) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            const innerChild = $0a6cc4ba868319ae$var$getInnerChild$1(child);
            if (!innerChild) return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
            let enterHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(innerChild, rawProps, state, instance, // #11061, ensure enterHooks is fresh after clone
            (hooks)=>enterHooks = hooks);
            if (innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) $0a6cc4ba868319ae$export$7770a22486565649(innerChild, enterHooks);
            let oldInnerChild = instance.subTree && $0a6cc4ba868319ae$var$getInnerChild$1(instance.subTree);
            if (oldInnerChild && oldInnerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a && !$0a6cc4ba868319ae$var$isSameVNodeType(oldInnerChild, innerChild) && $0a6cc4ba868319ae$var$recursiveGetSubtree(instance).type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                let leavingHooks = $0a6cc4ba868319ae$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $0a6cc4ba868319ae$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = ()=>{
                        state.isLeaving = false;
                        if (!(instance.job.flags & 8)) instance.update();
                        delete leavingHooks.afterLeave;
                        oldInnerChild = void 0;
                    };
                    return $0a6cc4ba868319ae$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $0a6cc4ba868319ae$export$4d299b491347818a) leavingHooks.delayLeave = (el, earlyRemove, delayedLeave)=>{
                    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el[$0a6cc4ba868319ae$var$leaveCbKey] = ()=>{
                        earlyRemove();
                        el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                    enterHooks.delayedLeave = ()=>{
                        delayedLeave();
                        delete enterHooks.delayedLeave;
                        oldInnerChild = void 0;
                    };
                };
                else oldInnerChild = void 0;
            } else if (oldInnerChild) oldInnerChild = void 0;
            return child;
        };
    }
};
function $0a6cc4ba868319ae$var$findNonCommentChild(children) {
    let child = children[0];
    if (children.length > 1) {
        let hasFound = false;
        for (const c of children)if (c.type !== $0a6cc4ba868319ae$export$4d299b491347818a) {
            child = c;
            hasFound = true;
            break;
        }
    }
    return child;
}
const $0a6cc4ba868319ae$export$abd95b5f5e8a8837 = $0a6cc4ba868319ae$var$BaseTransitionImpl;
function $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode) {
    const { leavingVNodes: leavingVNodes } = state;
    let leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $0a6cc4ba868319ae$export$76ac1779589cd824(vnode, props, state, instance, postClone) {
    const { appear: appear, mode: mode, persisted: persisted = false, onBeforeEnter: onBeforeEnter, onEnter: onEnter, onAfterEnter: onAfterEnter, onEnterCancelled: onEnterCancelled, onBeforeLeave: onBeforeLeave, onLeave: onLeave, onAfterLeave: onAfterLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear, onAppear: onAppear, onAfterAppear: onAfterAppear, onAppearCancelled: onAppearCancelled } = props;
    const key = String(vnode.key);
    const leavingVNodesCache = $0a6cc4ba868319ae$var$getLeavingNodesForType(state, vnode);
    const callHook = (hook, args)=>{
        hook && $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 9, args);
    };
    const callAsyncHook = (hook, args)=>{
        const done = args[1];
        callHook(hook, args);
        if ((0, $8POXm.isArray)(hook)) {
            if (hook.every((hook2)=>hook2.length <= 1)) done();
        } else if (hook.length <= 1) done();
    };
    const hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter (el) {
            let hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el[$0a6cc4ba868319ae$var$leaveCbKey]) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
            const leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $0a6cc4ba868319ae$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]) leavingVNode.el[$0a6cc4ba868319ae$var$leaveCbKey]();
            callHook(hook, [
                el
            ]);
        },
        enter (el) {
            let hook = onEnter;
            let afterHook = onAfterEnter;
            let cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            let called = false;
            el[$0a6cc4ba868319ae$var$enterCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el[$0a6cc4ba868319ae$var$enterCbKey] = void 0;
            };
            const done = el[$0a6cc4ba868319ae$var$enterCbKey].bind(null, false);
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave (el, remove) {
            const key2 = String(vnode.key);
            if (el[$0a6cc4ba868319ae$var$enterCbKey]) el[$0a6cc4ba868319ae$var$enterCbKey](true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            let called = false;
            el[$0a6cc4ba868319ae$var$leaveCbKey] = (cancelled)=>{
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el[$0a6cc4ba868319ae$var$leaveCbKey] = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            const done = el[$0a6cc4ba868319ae$var$leaveCbKey].bind(null, false);
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone (vnode2) {
            const hooks2 = $0a6cc4ba868319ae$export$76ac1779589cd824(vnode2, props, state, instance, postClone);
            if (postClone) postClone(hooks2);
            return hooks2;
        }
    };
    return hooks;
}
function $0a6cc4ba868319ae$var$emptyPlaceholder(vnode) {
    if ($0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $0a6cc4ba868319ae$var$getInnerChild$1(vnode) {
    if (!$0a6cc4ba868319ae$var$isKeepAlive(vnode)) {
        if ($0a6cc4ba868319ae$var$isTeleport(vnode.type) && vnode.children) return $0a6cc4ba868319ae$var$findNonCommentChild(vnode.children);
        return vnode;
    }
    if (vnode.component) return vnode.component.subTree;
    const { shapeFlag: shapeFlag, children: children } = vnode;
    if (children) {
        if (shapeFlag & 16) return children[0];
        if (shapeFlag & 32 && (0, $8POXm.isFunction)(children.default)) return children.default();
    }
}
function $0a6cc4ba868319ae$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) {
        vnode.transition = hooks;
        $0a6cc4ba868319ae$export$7770a22486565649(vnode.component.subTree, hooks);
    } else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $0a6cc4ba868319ae$export$a67f9b1229c7c97a(children, keepComment = false, parentKey) {
    let ret = [];
    let keyedFragmentCount = 0;
    for(let i = 0; i < children.length; i++){
        let child = children[i];
        const key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($0a6cc4ba868319ae$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $0a6cc4ba868319ae$export$4d299b491347818a) ret.push(key != null ? $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(let i = 0; i < ret.length; i++)ret[i].patchFlag = -2;
    return ret;
}
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $8POXm.isFunction)(options) ? // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ (()=>(0, $8POXm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        }))() : options;
}
function $0a6cc4ba868319ae$export$f680877a34711e37() {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    if (i) return (i.appContext.config.idPrefix || "v") + "-" + i.ids[0] + i.ids[1]++;
    return "";
}
function $0a6cc4ba868319ae$var$markAsyncBoundary(instance) {
    instance.ids = [
        instance.ids[0] + instance.ids[2]++ + "-",
        0,
        0
    ];
}
const $0a6cc4ba868319ae$var$knownTemplateRefs = /* @__PURE__ */ new WeakSet();
function $0a6cc4ba868319ae$export$83a5dbc1f35517ca(key) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const r = (0, $01W3b.shallowRef)(null);
    if (i) {
        const refs = i.refs === (0, $8POXm.EMPTY_OBJ) ? i.refs = {} : i.refs;
        Object.defineProperty(refs, key, {
            enumerable: true,
            get: ()=>r.value,
            set: (val)=>r.value = val
        });
    }
    const ret = r;
    return ret;
}
function $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key) {
    let desc;
    return !!((desc = Object.getOwnPropertyDescriptor(refs, key)) && !desc.configurable);
}
const $0a6cc4ba868319ae$var$pendingSetRefMap = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode, isUnmount = false) {
    if ((0, $8POXm.isArray)(rawRef)) {
        rawRef.forEach((r, i)=>$0a6cc4ba868319ae$var$setRef(r, oldRawRef && ((0, $8POXm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount));
        return;
    }
    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !isUnmount) {
        if (vnode.shapeFlag & 512 && vnode.type.__asyncResolved && vnode.component.subTree.component) $0a6cc4ba868319ae$var$setRef(rawRef, oldRawRef, parentSuspense, vnode.component.subTree);
        return;
    }
    const refValue = vnode.shapeFlag & 4 ? $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component) : vnode.el;
    const value = isUnmount ? null : refValue;
    const { i: owner, r: ref } = rawRef;
    const oldRef = oldRawRef && oldRawRef.r;
    const refs = owner.refs === (0, $8POXm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    const setupState = owner.setupState;
    const rawSetupState = (0, $01W3b.toRaw)(setupState);
    const canSetSetupRef = setupState === (0, $8POXm.EMPTY_OBJ) ? (0, $8POXm.NO) : (key)=>{
        if ($0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return (0, $8POXm.hasOwn)(rawSetupState, key);
    };
    const canSetRef = (ref2, key)=>{
        if (key && $0a6cc4ba868319ae$var$isTemplateRefKey(refs, key)) return false;
        return true;
    };
    if (oldRef != null && oldRef !== ref) {
        $0a6cc4ba868319ae$var$invalidatePendingSetRef(oldRawRef);
        if ((0, $8POXm.isString)(oldRef)) {
            refs[oldRef] = null;
            if (canSetSetupRef(oldRef)) setupState[oldRef] = null;
        } else if ((0, $01W3b.isRef)(oldRef)) {
            const oldRawRefAtom = oldRawRef;
            if (canSetRef(oldRef, oldRawRefAtom.k)) oldRef.value = null;
            if (oldRawRefAtom.k) refs[oldRawRefAtom.k] = null;
        }
    }
    if ((0, $8POXm.isFunction)(ref)) $0a6cc4ba868319ae$export$b22fcaf88446e9bf(ref, owner, 12, [
        value,
        refs
    ]);
    else {
        const _isString = (0, $8POXm.isString)(ref);
        const _isRef = (0, $01W3b.isRef)(ref);
        if (_isString || _isRef) {
            const doSet = ()=>{
                if (rawRef.f) {
                    const existing = _isString ? canSetSetupRef(ref) ? setupState[ref] : refs[ref] : canSetRef(ref) || !rawRef.k ? ref.value : refs[rawRef.k];
                    if (isUnmount) (0, $8POXm.isArray)(existing) && (0, $8POXm.remove)(existing, refValue);
                    else {
                        if (!(0, $8POXm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if (canSetSetupRef(ref)) setupState[ref] = refs[ref];
                            } else {
                                const newVal = [
                                    refValue
                                ];
                                if (canSetRef(ref, rawRef.k)) ref.value = newVal;
                                if (rawRef.k) refs[rawRef.k] = newVal;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value;
                    if (canSetSetupRef(ref)) setupState[ref] = value;
                } else if (_isRef) {
                    if (canSetRef(ref, rawRef.k)) ref.value = value;
                    if (rawRef.k) refs[rawRef.k] = value;
                }
            };
            if (value) {
                const job = ()=>{
                    doSet();
                    $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
                };
                job.id = -1;
                $0a6cc4ba868319ae$var$pendingSetRefMap.set(rawRef, job);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(job, parentSuspense);
            } else {
                $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef);
                doSet();
            }
        }
    }
}
function $0a6cc4ba868319ae$var$invalidatePendingSetRef(rawRef) {
    const pendingSetRef = $0a6cc4ba868319ae$var$pendingSetRefMap.get(rawRef);
    if (pendingSetRef) {
        pendingSetRef.flags |= 8;
        $0a6cc4ba868319ae$var$pendingSetRefMap.delete(rawRef);
    }
}
let $0a6cc4ba868319ae$var$hasLoggedMismatchError = false;
const $0a6cc4ba868319ae$var$logMismatchError = ()=>{
    if ($0a6cc4ba868319ae$var$hasLoggedMismatchError) return;
    console.error("Hydration completed but contains mismatches.");
    $0a6cc4ba868319ae$var$hasLoggedMismatchError = true;
};
const $0a6cc4ba868319ae$var$isSVGContainer = (container)=>container.namespaceURI.includes("svg") && container.tagName !== "foreignObject";
const $0a6cc4ba868319ae$var$isMathMLContainer = (container)=>container.namespaceURI.includes("MathML");
const $0a6cc4ba868319ae$var$getContainerType = (container)=>{
    if (container.nodeType !== 1) return void 0;
    if ($0a6cc4ba868319ae$var$isSVGContainer(container)) return "svg";
    if ($0a6cc4ba868319ae$var$isMathMLContainer(container)) return "mathml";
    return void 0;
};
const $0a6cc4ba868319ae$var$isComment = (node)=>node.nodeType === 8;
function $0a6cc4ba868319ae$var$createHydrationFunctions(rendererInternals) {
    const { mt: mountComponent, p: patch, o: { patchProp: patchProp, createText: createText, nextSibling: nextSibling, parentNode: parentNode, remove: remove, insert: insert, createComment: createComment } } = rendererInternals;
    const hydrate = (vnode, container)=>{
        if (!container.hasChildNodes()) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Attempting to hydrate existing markup but container is empty. Performing full mount instead.`);
            patch(null, vnode, container);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        hydrateNode(container.firstChild, vnode, null, null, null);
        $0a6cc4ba868319ae$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    const hydrateNode = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized = false)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const isFragmentStart = $0a6cc4ba868319ae$var$isComment(node) && node.data === "[";
        const onMismatch = ()=>handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        const { type: type, ref: ref, shapeFlag: shapeFlag, patchFlag: patchFlag } = vnode;
        let domType = node.nodeType;
        vnode.el = node;
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(node, "__vnode", vnode, true);
            (0, $8POXm.def)(node, "__vueParentComponent", parentComponent, true);
        }
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        let nextNode = null;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                if (domType !== 3) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text mismatch in`, node.parentNode, `
  - rendered on server: ${JSON.stringify(node.data)}
  - expected on client: ${JSON.stringify(vnode.children)}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                if (isTemplateNode(node)) {
                    nextNode = nextSibling(node);
                    replaceNode(vnode.el = node.content.firstChild, node, parentComponent);
                } else if (domType !== 8 || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 || domType === 3) {
                    nextNode = node;
                    const needToAdoptContent = !vnode.children.length;
                    for(let i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if ((domType !== 1 || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) && !isTemplateNode(node)) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    const container = parentNode(node);
                    if (isFragmentStart) nextNode = locateClosingAnchor(node);
                    else if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "teleport start") nextNode = locateClosingAnchor(node, node.data, "teleport end");
                    else nextNode = nextSibling(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), optimized);
                    if ($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) && !vnode.type.__asyncResolved) {
                        let subTree;
                        if (isFragmentStart) {
                            subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $0a6cc4ba868319ae$export$22f9b5ffd89dac9("") : $0a6cc4ba868319ae$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
                else if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__) $0a6cc4ba868319ae$var$warn$1("Invalid HostVNode type:", type, `(${typeof type})`);
        }
        if (ref != null) $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    const hydrateElement = (el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!vnode.dynamicChildren;
        const { type: type, props: props, patchFlag: patchFlag, shapeFlag: shapeFlag, dirs: dirs, transition: transition } = vnode;
        const forcePatch = type === "input" || type === "option";
        if (forcePatch || patchFlag !== -1) {
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            let needCallTransitionHooks = false;
            if (isTemplateNode(el)) {
                needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(null, // no need check parentSuspense in hydration
                transition) && parentComponent && parentComponent.vnode.props && parentComponent.vnode.props.appear;
                const content = el.content.firstChild;
                if (needCallTransitionHooks) {
                    const cls = content.getAttribute("class");
                    if (cls) content.$cls = cls;
                    transition.beforeEnter(content);
                }
                replaceNode(content, el, parentComponent);
                vnode.el = el = content;
            }
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                let next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                let hasWarned = false;
                while(next){
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 1 /* CHILDREN */ )) {
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                            $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, el, `
Server rendered element contains more child nodes than client vdom.`);
                            hasWarned = true;
                        }
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    const cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                let clientText = vnode.children;
                if (clientText[0] === "\n" && (el.tagName === "PRE" || el.tagName === "TEXTAREA")) clientText = clientText.slice(1);
                const { textContent: textContent } = el;
                if (textContent !== clientText && // innerHTML normalize \r\n or \r into a single \n in the DOM
                textContent !== clientText.replace(/\r\n|\r/g, "\n")) {
                    if (!$0a6cc4ba868319ae$var$isMismatchAllowed(el, 0 /* TEXT */ )) {
                        __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration text content mismatch on`, el, `
  - rendered on server: ${textContent}
  - expected on client: ${clientText}`);
                        $0a6cc4ba868319ae$var$logMismatchError();
                    }
                    el.textContent = vnode.children;
                }
            }
            if (props) {
                if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ || forcePatch || !optimized || patchFlag & 48) {
                    const isCustomElement = el.tagName.includes("-");
                    for(const key in props){
                        if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && // #11189 skip if this node has directives that have created hooks
                        // as it could have mutated the DOM in any possible way
                        !(dirs && dirs.some((d)=>d.dir.created)) && $0a6cc4ba868319ae$var$propHasMismatch(el, key, props[key], vnode, parentComponent)) $0a6cc4ba868319ae$var$logMismatchError();
                        if (forcePatch && (key.endsWith("value") || key === "indeterminate") || (0, $8POXm.isOn)(key) && !(0, $8POXm.isReservedProp)(key) || // force hydrate v-bind with .prop modifiers
                        key[0] === "." || isCustomElement && !(0, $8POXm.isReservedProp)(key)) patchProp(el, key, null, props[key], void 0, parentComponent);
                    }
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, void 0, parentComponent);
                else if (patchFlag & 4 && (0, $01W3b.isReactive)(props.style)) for(const key in props.style)props.style[key];
            }
            let vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs || needCallTransitionHooks) $0a6cc4ba868319ae$var$queueEffectWithSuspense(()=>{
                vnodeHooks && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                needCallTransitionHooks && transition.enter(el);
                dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
        }
        return el.nextSibling;
    };
    const hydrateChildren = (node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        optimized = optimized || !!parentVNode.dynamicChildren;
        const children = parentVNode.children;
        const l = children.length;
        let hasWarned = false;
        for(let i = 0; i < l; i++){
            const vnode = optimized ? children[i] : children[i] = $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            const isText = vnode.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6;
            if (node) {
                if (isText && !optimized) {
                    if (i + 1 < l && $0a6cc4ba868319ae$var$normalizeVNode(children[i + 1]).type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
                        insert(createText(node.data.slice(vnode.children.length)), container, nextSibling(node));
                        node.data = vnode.children;
                    }
                }
                node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            } else if (isText && !vnode.children) insert(vnode.el = createText(""), container);
            else {
                if (!$0a6cc4ba868319ae$var$isMismatchAllowed(container, 1 /* CHILDREN */ )) {
                    if (__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && !hasWarned) {
                        $0a6cc4ba868319ae$var$warn$1(`Hydration children mismatch on`, container, `
Server rendered element contains fewer child nodes than client vdom.`);
                        hasWarned = true;
                    }
                    $0a6cc4ba868319ae$var$logMismatchError();
                }
                patch(null, vnode, container, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
            }
        }
        return node;
    };
    const hydrateFragment = (node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized)=>{
        const { slotScopeIds: fragmentSlotScopeIds } = vnode;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        const container = parentNode(node);
        const next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $0a6cc4ba868319ae$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $0a6cc4ba868319ae$var$logMismatchError();
            insert(vnode.anchor = createComment(`]`), container, next);
            return next;
        }
    };
    const handleMismatch = (node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment)=>{
        if (!$0a6cc4ba868319ae$var$isMismatchAllowed(node.parentElement, 1 /* CHILDREN */ )) {
            __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ && $0a6cc4ba868319ae$var$warn$1(`Hydration node mismatch:
- rendered on server:`, node, node.nodeType === 3 ? `(text)` : $0a6cc4ba868319ae$var$isComment(node) && node.data === "[" ? `(start of fragment)` : ``, `
- expected on client:`, vnode.type);
            $0a6cc4ba868319ae$var$logMismatchError();
        }
        vnode.el = null;
        if (isFragment) {
            const end = locateClosingAnchor(node);
            while(true){
                const next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        const next = nextSibling(node);
        const container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$getContainerType(container), slotScopeIds);
        if (parentComponent) {
            parentComponent.vnode.el = vnode.el;
            $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, vnode.el);
        }
        return next;
    };
    const locateClosingAnchor = (node, open = "[", close = "]")=>{
        let match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $0a6cc4ba868319ae$var$isComment(node)) {
                if (node.data === open) match++;
                if (node.data === close) {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    const replaceNode = (newNode, oldNode, parentComponent)=>{
        const parentNode2 = oldNode.parentNode;
        if (parentNode2) parentNode2.replaceChild(newNode, oldNode);
        let parent = parentComponent;
        while(parent){
            if (parent.vnode.el === oldNode) parent.vnode.el = parent.subTree.el = newNode;
            parent = parent.parent;
        }
    };
    const isTemplateNode = (node)=>{
        return node.nodeType === 1 && node.tagName === "TEMPLATE";
    };
    return [
        hydrate,
        hydrateNode
    ];
}
function $0a6cc4ba868319ae$var$propHasMismatch(el, key, clientValue, vnode, instance) {
    let mismatchType;
    let mismatchKey;
    let actual;
    let expected;
    if (key === "class") {
        if (el.$cls) {
            actual = el.$cls;
            delete el.$cls;
        } else actual = el.getAttribute("class");
        expected = (0, $8POXm.normalizeClass)(clientValue);
        if (!$0a6cc4ba868319ae$var$isSetEqual($0a6cc4ba868319ae$var$toClassSet(actual || ""), $0a6cc4ba868319ae$var$toClassSet(expected))) {
            mismatchType = 2 /* CLASS */ ;
            mismatchKey = `class`;
        }
    } else if (key === "style") {
        actual = el.getAttribute("style") || "";
        expected = (0, $8POXm.isString)(clientValue) ? clientValue : (0, $8POXm.stringifyStyle)((0, $8POXm.normalizeStyle)(clientValue));
        const actualMap = $0a6cc4ba868319ae$var$toStyleMap(actual);
        const expectedMap = $0a6cc4ba868319ae$var$toStyleMap(expected);
        if (vnode.dirs) {
            for (const { dir: dir, value: value } of vnode.dirs)if (dir.name === "show" && !value) expectedMap.set("display", "none");
        }
        if (instance) $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap);
        if (!$0a6cc4ba868319ae$var$isMapEqual(actualMap, expectedMap)) {
            mismatchType = 3 /* STYLE */ ;
            mismatchKey = "style";
        }
    } else if (el instanceof SVGElement && (0, $8POXm.isKnownSvgAttr)(key) || el instanceof HTMLElement && ((0, $8POXm.isBooleanAttr)(key) || (0, $8POXm.isKnownHtmlAttr)(key))) {
        if ((0, $8POXm.isBooleanAttr)(key)) {
            actual = el.hasAttribute(key);
            expected = (0, $8POXm.includeBooleanAttr)(clientValue);
        } else if (clientValue == null) {
            actual = el.hasAttribute(key);
            expected = false;
        } else {
            if (el.hasAttribute(key)) actual = el.getAttribute(key);
            else if (key === "value" && el.tagName === "TEXTAREA") actual = el.value;
            else actual = false;
            expected = (0, $8POXm.isRenderableAttrValue)(clientValue) ? String(clientValue) : false;
        }
        if (actual !== expected) {
            mismatchType = 4 /* ATTRIBUTE */ ;
            mismatchKey = key;
        }
    }
    if (mismatchType != null && !$0a6cc4ba868319ae$var$isMismatchAllowed(el, mismatchType)) {
        const format = (v1)=>v1 === false ? `(not rendered)` : `${mismatchKey}="${v1}"`;
        const preSegment = `Hydration ${$0a6cc4ba868319ae$var$MismatchTypeString[mismatchType]} mismatch on`;
        const postSegment = `
  - rendered on server: ${format(actual)}
  - expected on client: ${format(expected)}
  Note: this mismatch is check-only. The DOM will not be rectified in production due to performance overhead.
  You should fix the source of the mismatch.`;
        $0a6cc4ba868319ae$var$warn$1(preSegment, el, postSegment);
        return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$toClassSet(str) {
    return new Set(str.trim().split(/\s+/));
}
function $0a6cc4ba868319ae$var$isSetEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const s of a){
        if (!b.has(s)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$toStyleMap(str) {
    const styleMap = /* @__PURE__ */ new Map();
    for (const item of str.split(";")){
        let [key, value] = item.split(":");
        key = key.trim();
        value = value && value.trim();
        if (key && value) styleMap.set(key, value);
    }
    return styleMap;
}
function $0a6cc4ba868319ae$var$isMapEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const [key, value] of a){
        if (value !== b.get(key)) return false;
    }
    return true;
}
function $0a6cc4ba868319ae$var$resolveCssVars(instance, vnode, expectedMap) {
    const root = instance.subTree;
    if (instance.getCssVars && (vnode === root || root && root.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && root.children.includes(vnode))) {
        const cssVars = instance.getCssVars();
        for(const key in cssVars){
            const value = (0, $8POXm.normalizeCssVarValue)(cssVars[key]);
            expectedMap.set(`--${(0, $8POXm.getEscapedCssVarName)(key, false)}`, value);
        }
    }
    if (vnode === root && instance.parent) $0a6cc4ba868319ae$var$resolveCssVars(instance.parent, instance.vnode, expectedMap);
}
const $0a6cc4ba868319ae$var$allowMismatchAttr = "data-allow-mismatch";
const $0a6cc4ba868319ae$var$MismatchTypeString = {
    [0 /* TEXT */ ]: "text",
    [1 /* CHILDREN */ ]: "children",
    [2 /* CLASS */ ]: "class",
    [3 /* STYLE */ ]: "style",
    [4 /* ATTRIBUTE */ ]: "attribute"
};
function $0a6cc4ba868319ae$var$isMismatchAllowed(el, allowedType) {
    if (allowedType === 0 /* TEXT */  || allowedType === 1 /* CHILDREN */ ) while(el && !el.hasAttribute($0a6cc4ba868319ae$var$allowMismatchAttr))el = el.parentElement;
    const allowedAttr = el && el.getAttribute($0a6cc4ba868319ae$var$allowMismatchAttr);
    if (allowedAttr == null) return false;
    else if (allowedAttr === "") return true;
    else {
        const list = allowedAttr.split(",");
        if (allowedType === 0 /* TEXT */  && list.includes("children")) return true;
        return list.includes($0a6cc4ba868319ae$var$MismatchTypeString[allowedType]);
    }
}
const $0a6cc4ba868319ae$var$requestIdleCallback = (0, $8POXm.getGlobalThis)().requestIdleCallback || ((cb)=>setTimeout(cb, 1));
const $0a6cc4ba868319ae$var$cancelIdleCallback = (0, $8POXm.getGlobalThis)().cancelIdleCallback || ((id)=>clearTimeout(id));
const $0a6cc4ba868319ae$export$8bfca283fd254627 = (timeout = 1e4)=>(hydrate)=>{
        const id = $0a6cc4ba868319ae$var$requestIdleCallback(hydrate, {
            timeout: timeout
        });
        return ()=>$0a6cc4ba868319ae$var$cancelIdleCallback(id);
    };
function $0a6cc4ba868319ae$var$elementIsVisibleInViewport(el) {
    const { top: top, left: left, bottom: bottom, right: right } = el.getBoundingClientRect();
    const { innerHeight: innerHeight, innerWidth: innerWidth } = window;
    return (top > 0 && top < innerHeight || bottom > 0 && bottom < innerHeight) && (left > 0 && left < innerWidth || right > 0 && right < innerWidth);
}
const $0a6cc4ba868319ae$export$2b04cd335e660930 = (opts)=>(hydrate, forEach)=>{
        const ob = new IntersectionObserver((entries)=>{
            for (const e of entries){
                if (!e.isIntersecting) continue;
                ob.disconnect();
                hydrate();
                break;
            }
        }, opts);
        forEach((el)=>{
            if (!(el instanceof Element)) return;
            if ($0a6cc4ba868319ae$var$elementIsVisibleInViewport(el)) {
                hydrate();
                ob.disconnect();
                return false;
            }
            ob.observe(el);
        });
        return ()=>ob.disconnect();
    };
const $0a6cc4ba868319ae$export$804dbb6002787b74 = (query)=>(hydrate)=>{
        if (query) {
            const mql = matchMedia(query);
            if (mql.matches) hydrate();
            else {
                mql.addEventListener("change", hydrate, {
                    once: true
                });
                return ()=>mql.removeEventListener("change", hydrate);
            }
        }
    };
const $0a6cc4ba868319ae$export$288f5a9b4248e114 = (interactions = [])=>(hydrate, forEach)=>{
        if ((0, $8POXm.isString)(interactions)) interactions = [
            interactions
        ];
        let hasHydrated = false;
        const doHydrate = (e)=>{
            if (!hasHydrated) {
                hasHydrated = true;
                teardown();
                hydrate();
                e.target.dispatchEvent(new e.constructor(e.type, e));
            }
        };
        const teardown = ()=>{
            forEach((el)=>{
                for (const i of interactions)el.removeEventListener(i, doHydrate);
            });
        };
        forEach((el)=>{
            for (const i of interactions)el.addEventListener(i, doHydrate, {
                once: true
            });
        });
        return teardown;
    };
function $0a6cc4ba868319ae$var$forEachElement(node, cb) {
    if ($0a6cc4ba868319ae$var$isComment(node) && node.data === "[") {
        let depth = 1;
        let next = node.nextSibling;
        while(next){
            if (next.nodeType === 1) {
                const result = cb(next);
                if (result === false) break;
            } else if ($0a6cc4ba868319ae$var$isComment(next)) {
                if (next.data === "]") {
                    if (--depth === 0) break;
                } else if (next.data === "[") depth++;
            }
            next = next.nextSibling;
        }
    } else cb(node);
}
const $0a6cc4ba868319ae$var$isAsyncWrapper = (i)=>!!i.type.__asyncLoader;
// @__NO_SIDE_EFFECTS__
function $0a6cc4ba868319ae$export$d75d499b4c16cf21(source) {
    if ((0, $8POXm.isFunction)(source)) source = {
        loader: source
    };
    const { loader: loader, loadingComponent: loadingComponent, errorComponent: errorComponent, delay: delay = 200, hydrate: hydrateStrategy, timeout: timeout, suspensible: // undefined = never times out
    suspensible = true, onError: userOnError } = source;
    let pendingRequest = null;
    let resolvedComp;
    let retries = 0;
    const retry = ()=>{
        retries++;
        pendingRequest = null;
        return load();
    };
    const load = ()=>{
        let thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch((err)=>{
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise((resolve, reject)=>{
                const userRetry = ()=>resolve(retry());
                const userFail = ()=>reject(err);
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then((comp)=>{
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $0a6cc4ba868319ae$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        __asyncHydrate (el, instance, hydrate) {
            let patched = false;
            (instance.bu || (instance.bu = [])).push(()=>patched = true);
            const performHydrate = ()=>{
                if (patched) return;
                hydrate();
            };
            const doHydrate = hydrateStrategy ? ()=>{
                const teardown = hydrateStrategy(performHydrate, (cb)=>$0a6cc4ba868319ae$var$forEachElement(el, cb));
                if (teardown) (instance.bum || (instance.bum = [])).push(teardown);
            } : performHydrate;
            if (resolvedComp) doHydrate();
            else load().then(()=>!instance.isUnmounted && doHydrate());
        },
        get __asyncResolved () {
            return resolvedComp;
        },
        setup () {
            const instance = $0a6cc4ba868319ae$var$currentInstance;
            $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
            if (resolvedComp) return ()=>$0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
            const onError = (err)=>{
                pendingRequest = null;
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $0a6cc4ba868319ae$var$isInSSRComponentSetup) return load().then((comp)=>{
                return ()=>$0a6cc4ba868319ae$var$createInnerComp(comp, instance);
            }).catch((err)=>{
                onError(err);
                return ()=>errorComponent ? $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
            });
            const loaded = (0, $01W3b.ref)(false);
            const error = (0, $01W3b.ref)();
            const delayed = (0, $01W3b.ref)(!!delay);
            if (delay) setTimeout(()=>{
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(()=>{
                if (!loaded.value && !error.value) {
                    const err = new Error(`Async component timed out after ${timeout}ms.`);
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(()=>{
                loaded.value = true;
                if (instance.parent && $0a6cc4ba868319ae$var$isKeepAlive(instance.parent.vnode)) instance.parent.update();
            }).catch((err)=>{
                onError(err);
                error.value = err;
            });
            return ()=>{
                if (loaded.value && resolvedComp) return $0a6cc4ba868319ae$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $0a6cc4ba868319ae$var$createInnerComp(loadingComponent, instance);
            };
        }
    });
}
function $0a6cc4ba868319ae$var$createInnerComp(comp, parent) {
    const { ref: ref2, props: props, children: children, ce: ce } = parent.vnode;
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
const $0a6cc4ba868319ae$var$isKeepAlive = (vnode)=>vnode.type.__isKeepAlive;
const $0a6cc4ba868319ae$var$KeepAliveImpl = {
    name: `KeepAlive`,
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup (props, { slots: slots }) {
        const instance = $0a6cc4ba868319ae$export$f13e630aa3915748();
        const sharedContext = instance.ctx;
        if (!sharedContext.renderer) return ()=>{
            const children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        const cache = /* @__PURE__ */ new Map();
        const keys = /* @__PURE__ */ new Set();
        let current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        const parentSuspense = instance.suspense;
        const { renderer: { p: patch, m: move, um: _unmount, o: { createElement: createElement } } } = sharedContext;
        const storageContainer = createElement("div");
        sharedContext.activate = (vnode, container, anchor, namespace, optimized)=>{
            const instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, namespace, vnode.slotScopeIds, optimized);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                instance2.isDeactivated = false;
                if (instance2.a) (0, $8POXm.invokeArrayFns)(instance2.a);
                const vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = (vnode)=>{
            const instance2 = vnode.component;
            $0a6cc4ba868319ae$var$invalidateMount(instance2.m);
            $0a6cc4ba868319ae$var$invalidateMount(instance2.a);
            move(vnode, storageContainer, null, 1, parentSuspense);
            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                if (instance2.da) (0, $8POXm.invokeArrayFns)(instance2.da);
                const vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance2);
        };
        function unmount(vnode) {
            $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        }
        function pruneCache(filter) {
            cache.forEach((vnode, key)=>{
                const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : vnode.type);
                if (name && !filter(name)) pruneCacheEntry(key);
            });
        }
        function pruneCacheEntry(key) {
            const cached = cache.get(key);
            if (cached && (!current || !$0a6cc4ba868319ae$var$isSameVNodeType(cached, current))) unmount(cached);
            else if (current) $0a6cc4ba868319ae$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        }
        $0a6cc4ba868319ae$export$3db5d71bdb2d5499(()=>[
                props.include,
                props.exclude
            ], ([include, exclude])=>{
            include && pruneCache((name)=>$0a6cc4ba868319ae$var$matches(include, name));
            exclude && pruneCache((name)=>!$0a6cc4ba868319ae$var$matches(exclude, name));
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        let pendingCacheKey = null;
        const cacheSubtree = ()=>{
            if (pendingCacheKey != null) {
                if ($0a6cc4ba868319ae$var$isSuspense(instance.subTree.type)) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                    cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
                }, instance.subTree.suspense);
                else cache.set(pendingCacheKey, $0a6cc4ba868319ae$var$getInnerChild(instance.subTree));
            }
        };
        $0a6cc4ba868319ae$export$6d1641039221b5cb(cacheSubtree);
        $0a6cc4ba868319ae$export$5876c47052fb88b1(cacheSubtree);
        $0a6cc4ba868319ae$export$40c420df62d2614(()=>{
            cache.forEach((cached)=>{
                const { subTree: subTree, suspense: suspense } = instance;
                const vnode = $0a6cc4ba868319ae$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $0a6cc4ba868319ae$var$resetShapeFlag(vnode);
                    const da = vnode.component.da;
                    da && $0a6cc4ba868319ae$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return ()=>{
            pendingCacheKey = null;
            if (!slots.default) return current = null;
            const children = slots.default();
            const rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            let vnode = $0a6cc4ba868319ae$var$getInnerChild(rawVNode);
            if (vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a) {
                current = null;
                return vnode;
            }
            const comp = vnode.type;
            const name = $0a6cc4ba868319ae$var$getComponentName($0a6cc4ba868319ae$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            const { include: include, exclude: exclude, max: max } = props;
            if (include && (!name || !$0a6cc4ba868319ae$var$matches(include, name)) || exclude && name && $0a6cc4ba868319ae$var$matches(exclude, name)) {
                vnode.shapeFlag &= -257;
                current = vnode;
                return rawVNode;
            }
            const key = vnode.key == null ? comp : vnode.key;
            const cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $0a6cc4ba868319ae$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
const $0a6cc4ba868319ae$export$70eb8a58709972df = $0a6cc4ba868319ae$var$KeepAliveImpl;
function $0a6cc4ba868319ae$var$matches(pattern, name) {
    if ((0, $8POXm.isArray)(pattern)) return pattern.some((p)=>$0a6cc4ba868319ae$var$matches(p, name));
    else if ((0, $8POXm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $8POXm.isRegExp)(pattern)) {
        pattern.lastIndex = 0;
        return pattern.test(name);
    }
    return false;
}
function $0a6cc4ba868319ae$export$ba52d824b95a2154(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "a", target);
}
function $0a6cc4ba868319ae$export$bf1440eeaf5fa709(hook, target) {
    $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, "da", target);
}
function $0a6cc4ba868319ae$var$registerKeepAliveHook(hook, type, target = $0a6cc4ba868319ae$var$currentInstance) {
    const wrappedHook = hook.__wdc || (hook.__wdc = ()=>{
        let current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $0a6cc4ba868319ae$var$injectHook(type, wrappedHook, target);
    if (target) {
        let current = target.parent;
        while(current && current.parent){
            if ($0a6cc4ba868319ae$var$isKeepAlive(current.parent.vnode)) $0a6cc4ba868319ae$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $0a6cc4ba868319ae$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    const injected = $0a6cc4ba868319ae$var$injectHook(type, hook, keepAliveRoot, true);
    $0a6cc4ba868319ae$export$13348a43ccacfe58(()=>{
        (0, $8POXm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $0a6cc4ba868319ae$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $0a6cc4ba868319ae$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $0a6cc4ba868319ae$var$injectHook(type, hook, target = $0a6cc4ba868319ae$var$currentInstance, prepend = false) {
    if (target) {
        const hooks = target[type] || (target[type] = []);
        const wrappedHook = hook.__weh || (hook.__weh = (...args)=>{
            (0, $01W3b.pauseTracking)();
            const reset = $0a6cc4ba868319ae$var$setCurrentInstance(target);
            const res = $0a6cc4ba868319ae$export$dae85862a8d94378(hook, target, type, args);
            reset();
            (0, $01W3b.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
const $0a6cc4ba868319ae$var$createHook = (lifecycle)=>(hook, target = $0a6cc4ba868319ae$var$currentInstance)=>{
        if (!$0a6cc4ba868319ae$var$isInSSRComponentSetup || lifecycle === "sp") $0a6cc4ba868319ae$var$injectHook(lifecycle, (...args)=>hook(...args), target);
    };
const $0a6cc4ba868319ae$export$23b7aeb0d671f804 = $0a6cc4ba868319ae$var$createHook("bm");
const $0a6cc4ba868319ae$export$6d1641039221b5cb = $0a6cc4ba868319ae$var$createHook("m");
const $0a6cc4ba868319ae$export$ab91988a13872e4c = $0a6cc4ba868319ae$var$createHook("bu");
const $0a6cc4ba868319ae$export$5876c47052fb88b1 = $0a6cc4ba868319ae$var$createHook("u");
const $0a6cc4ba868319ae$export$40c420df62d2614 = $0a6cc4ba868319ae$var$createHook("bum");
const $0a6cc4ba868319ae$export$13348a43ccacfe58 = $0a6cc4ba868319ae$var$createHook("um");
const $0a6cc4ba868319ae$export$ebf0c601f267bceb = $0a6cc4ba868319ae$var$createHook("sp");
const $0a6cc4ba868319ae$export$898295a813d662eb = $0a6cc4ba868319ae$var$createHook("rtg");
const $0a6cc4ba868319ae$export$2b41f4235363e921 = $0a6cc4ba868319ae$var$createHook("rtc");
function $0a6cc4ba868319ae$export$6a3a15856e50ad19(hook, target = $0a6cc4ba868319ae$var$currentInstance) {
    $0a6cc4ba868319ae$var$injectHook("ec", hook, target);
}
const $0a6cc4ba868319ae$var$COMPONENTS = "components";
const $0a6cc4ba868319ae$var$DIRECTIVES = "directives";
function $0a6cc4ba868319ae$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
const $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT = /* @__PURE__ */ Symbol.for("v-ndc");
function $0a6cc4ba868319ae$export$b44c564a05ca975(component) {
    if ((0, $8POXm.isString)(component)) return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$COMPONENTS, component, false) || component;
    else return component || $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT;
}
function $0a6cc4ba868319ae$export$a1989e995cd481be(name) {
    return $0a6cc4ba868319ae$var$resolveAsset($0a6cc4ba868319ae$var$DIRECTIVES, name);
}
function $0a6cc4ba868319ae$var$resolveAsset(type, name, warnMissing = true, maybeSelfReference = false) {
    const instance = $0a6cc4ba868319ae$var$currentRenderingInstance || $0a6cc4ba868319ae$var$currentInstance;
    if (instance) {
        const Component = instance.type;
        if (type === $0a6cc4ba868319ae$var$COMPONENTS) {
            const selfName = $0a6cc4ba868319ae$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $8POXm.camelize)(name) || selfName === (0, $8POXm.capitalize)((0, $8POXm.camelize)(name)))) return Component;
        }
        const res = // local registration
        // check instance[type] first which is resolved for options API
        $0a6cc4ba868319ae$var$resolve(instance[type] || Component[type], name) || // global registration
        $0a6cc4ba868319ae$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $0a6cc4ba868319ae$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $8POXm.camelize)(name)] || registry[(0, $8POXm.capitalize)((0, $8POXm.camelize)(name))]);
}
function $0a6cc4ba868319ae$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    let ret;
    const cached = cache && cache[index];
    const sourceIsArray = (0, $8POXm.isArray)(source);
    if (sourceIsArray || (0, $8POXm.isString)(source)) {
        const sourceIsReactiveArray = sourceIsArray && (0, $01W3b.isReactive)(source);
        let needsWrap = false;
        let isReadonlySource = false;
        if (sourceIsReactiveArray) {
            needsWrap = !(0, $01W3b.isShallow)(source);
            isReadonlySource = (0, $01W3b.isReadonly)(source);
            source = (0, $01W3b.shallowReadArray)(source);
        }
        ret = new Array(source.length);
        for(let i = 0, l = source.length; i < l; i++)ret[i] = renderItem(needsWrap ? isReadonlySource ? (0, $01W3b.toReadonly)((0, $01W3b.toReactive)(source[i])) : (0, $01W3b.toReactive)(source[i]) : source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(let i = 0; i < source; i++)ret[i] = renderItem(i + 1, i, void 0, cached && cached[i]);
    } else if ((0, $8POXm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, (item, i)=>renderItem(item, i, void 0, cached && cached[i]));
        else {
            const keys = Object.keys(source);
            ret = new Array(keys.length);
            for(let i = 0, l = keys.length; i < l; i++){
                const key = keys[i];
                ret[i] = renderItem(source[key], key, i, cached && cached[i]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $0a6cc4ba868319ae$export$85738f8fcd0a5430(slots, dynamicSlots) {
    for(let i = 0; i < dynamicSlots.length; i++){
        const slot = dynamicSlots[i];
        if ((0, $8POXm.isArray)(slot)) for(let j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? (...args)=>{
            const res = slot.fn(...args);
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    }
    return slots;
}
function $0a6cc4ba868319ae$export$4abee4c34694ada1(slots, name, props = {}, fallback, noSlotted) {
    if ($0a6cc4ba868319ae$var$currentRenderingInstance.ce || $0a6cc4ba868319ae$var$currentRenderingInstance.parent && $0a6cc4ba868319ae$var$isAsyncWrapper($0a6cc4ba868319ae$var$currentRenderingInstance.parent) && $0a6cc4ba868319ae$var$currentRenderingInstance.parent.ce) {
        const hasProps = Object.keys(props).length > 0;
        if (name !== "default") props.name = name;
        return $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, null, [
            $0a6cc4ba868319ae$export$bf5c4cf060303d58("slot", props, fallback && fallback())
        ], hasProps ? -2 : 64);
    }
    let slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
    const validSlotContent = slot && $0a6cc4ba868319ae$var$ensureValidVNode(slot(props));
    const slotKey = props.key || // slot content array of a dynamic conditional slot may have a branch
    // key attached in the `createSlots` helper, respect that
    validSlotContent && validSlotContent.key;
    const rendered = $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$ffb0004e005737fa, {
        key: (slotKey && !(0, $8POXm.isSymbol)(slotKey) ? slotKey : `_${name}`) + // #7256 force differentiate fallback content from actual content
        (!validSlotContent && fallback ? "_fb" : "")
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $0a6cc4ba868319ae$var$ensureValidVNode(vnodes) {
    return vnodes.some((child)=>{
        if (!$0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return true;
        if (child.type === $0a6cc4ba868319ae$export$4d299b491347818a) return false;
        if (child.type === $0a6cc4ba868319ae$export$ffb0004e005737fa && !$0a6cc4ba868319ae$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $0a6cc4ba868319ae$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    const ret = {};
    for(const key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? `on:${key}` : (0, $8POXm.toHandlerKey)(key)] = obj[key];
    return ret;
}
const $0a6cc4ba868319ae$var$getPublicInstance = (i)=>{
    if (!i) return null;
    if ($0a6cc4ba868319ae$var$isStatefulComponent(i)) return $0a6cc4ba868319ae$var$getComponentPublicInstance(i);
    return $0a6cc4ba868319ae$var$getPublicInstance(i.parent);
};
const $0a6cc4ba868319ae$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), {
    $: (i)=>i,
    $el: (i)=>i.vnode.el,
    $data: (i)=>i.data,
    $props: (i)=>(0, i.props),
    $attrs: (i)=>(0, i.attrs),
    $slots: (i)=>(0, i.slots),
    $refs: (i)=>(0, i.refs),
    $parent: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.parent),
    $root: (i)=>$0a6cc4ba868319ae$var$getPublicInstance(i.root),
    $host: (i)=>i.ce,
    $emit: (i)=>i.emit,
    $options: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$resolveMergedOptions(i) : i.type,
    $forceUpdate: (i)=>i.f || (i.f = ()=>{
            $0a6cc4ba868319ae$var$queueJob(i.update);
        }),
    $nextTick: (i)=>i.n || (i.n = $0a6cc4ba868319ae$export$bdd553fddd433dcb.bind(i.proxy)),
    $watch: (i)=>__VUE_OPTIONS_API__ ? $0a6cc4ba868319ae$var$instanceWatch.bind(i) : (0, $8POXm.NOOP)
});
const $0a6cc4ba868319ae$var$isReservedPrefix = (key)=>key === "_" || key === "$";
const $0a6cc4ba868319ae$var$hasSetupBinding = (state, key)=>state !== (0, $8POXm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $8POXm.hasOwn)(state, key);
const $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers = {
    get ({ _: instance }, key) {
        if (key === "__v_skip") return true;
        const { ctx: ctx, setupState: setupState, data: data, props: props, accessCache: accessCache, type: type, appContext: appContext } = instance;
        if (key[0] !== "$") {
            const n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if ((0, $8POXm.hasOwn)(props, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $0a6cc4ba868319ae$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        const publicGetter = $0a6cc4ba868319ae$var$publicPropertiesMap[key];
        let cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $01W3b.track)(instance.attrs, "get", "");
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $8POXm.hasOwn)(globalProperties, key)) return globalProperties[key];
    },
    set ({ _: instance }, key, value) {
        const { data: data, setupState: setupState, ctx: ctx } = instance;
        if ($0a6cc4ba868319ae$var$hasSetupBinding(setupState, key)) {
            setupState[key] = value;
            return true;
        } else {
            if (__VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasOwn)(data, key)) {
                data[key] = value;
                return true;
            } else if ((0, $8POXm.hasOwn)(instance.props, key)) return false;
        }
        if (key[0] === "$" && key.slice(1) in instance) return false;
        else ctx[key] = value;
        return true;
    },
    has ({ _: { data: data, setupState: setupState, accessCache: accessCache, ctx: ctx, appContext: appContext, props: props, type: type } }, key) {
        let cssModules;
        return !!(accessCache[key] || __VUE_OPTIONS_API__ && data !== (0, $8POXm.EMPTY_OBJ) && key[0] !== "$" && (0, $8POXm.hasOwn)(data, key) || $0a6cc4ba868319ae$var$hasSetupBinding(setupState, key) || (0, $8POXm.hasOwn)(props, key) || (0, $8POXm.hasOwn)(ctx, key) || (0, $8POXm.hasOwn)($0a6cc4ba868319ae$var$publicPropertiesMap, key) || (0, $8POXm.hasOwn)(appContext.config.globalProperties, key) || (cssModules = type.__cssModules) && cssModules[key]);
    },
    defineProperty (target, key, descriptor) {
        if (descriptor.get != null) target._.accessCache[key] = 0;
        else if ((0, $8POXm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
        return Reflect.defineProperty(target, key, descriptor);
    }
};
var $0a6cc4ba868319ae$var$target;
const $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers, {
    get (target, key) {
        if (key === Symbol.unscopables) return;
        return $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has (_, key) {
        const has = key[0] !== "_" && !(0, $8POXm.isGloballyAllowed)(key);
        return has;
    }
});
function $0a6cc4ba868319ae$var$createDevRenderContext(instance) {
    const target = {};
    Object.defineProperty(target, `_`, {
        configurable: true,
        enumerable: false,
        get: ()=>instance
    });
    Object.keys($0a6cc4ba868319ae$var$publicPropertiesMap).forEach((key)=>{
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: ()=>$0a6cc4ba868319ae$var$publicPropertiesMap[key](instance),
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $8POXm.NOOP)
        });
    });
    return target;
}
function $0a6cc4ba868319ae$var$exposePropsOnRenderContext(instance) {
    const { ctx: ctx, propsOptions: [propsOptions] } = instance;
    if (propsOptions) Object.keys(propsOptions).forEach((key)=>{
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>instance.props[key],
            set: (0, $8POXm.NOOP)
        });
    });
}
function $0a6cc4ba868319ae$var$exposeSetupStateOnRenderContext(instance) {
    const { ctx: ctx, setupState: setupState } = instance;
    Object.keys((0, $01W3b.toRaw)(setupState)).forEach((key)=>{
        if (!setupState.__isScriptSetup) {
            if ($0a6cc4ba868319ae$var$isReservedPrefix(key[0])) {
                $0a6cc4ba868319ae$var$warn$1(`setup() return property ${JSON.stringify(key)} should not start with "$" or "_" which are reserved prefixes for Vue internals.`);
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: ()=>setupState[key],
                set: (0, $8POXm.NOOP)
            });
        }
    });
}
const $0a6cc4ba868319ae$var$warnRuntimeUsage = (method)=>$0a6cc4ba868319ae$var$warn$1(`${method}() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect.`);
function $0a6cc4ba868319ae$export$80b33eababae110e() {
    return null;
}
function $0a6cc4ba868319ae$export$51ecece22fc17ddc() {
    return null;
}
function $0a6cc4ba868319ae$export$da25b65ca24b518a(exposed) {}
function $0a6cc4ba868319ae$export$77e79129327f3d0d(options) {}
function $0a6cc4ba868319ae$export$1b3acd4bb805b712() {
    return null;
}
function $0a6cc4ba868319ae$export$acd55aa037e791bb() {}
function $0a6cc4ba868319ae$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $0a6cc4ba868319ae$export$9203a8e84125433c() {
    return $0a6cc4ba868319ae$var$getContext("useSlots").slots;
}
function $0a6cc4ba868319ae$export$75e29435042cd2ea() {
    return $0a6cc4ba868319ae$var$getContext("useAttrs").attrs;
}
function $0a6cc4ba868319ae$var$getContext(calledFunctionName) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $0a6cc4ba868319ae$var$createSetupContext(i));
}
function $0a6cc4ba868319ae$var$normalizePropsOrEmits(props) {
    return (0, $8POXm.isArray)(props) ? props.reduce((normalized, p)=>(normalized[p] = null, normalized), {}) : props;
}
function $0a6cc4ba868319ae$export$ec60f47d4a8a2e7f(raw, defaults) {
    const props = $0a6cc4ba868319ae$var$normalizePropsOrEmits(raw);
    for(const key in defaults){
        if (key.startsWith("__skip")) continue;
        let opt = props[key];
        if (opt) {
            if ((0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults[`__skip_${key}`]) opt.skipFactory = true;
    }
    return props;
}
function $0a6cc4ba868319ae$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $8POXm.isArray)(a) && (0, $8POXm.isArray)(b)) return a.concat(b);
    return (0, $8POXm.extend)({}, $0a6cc4ba868319ae$var$normalizePropsOrEmits(a), $0a6cc4ba868319ae$var$normalizePropsOrEmits(b));
}
function $0a6cc4ba868319ae$export$7c343e855c563faa(props, excludedKeys) {
    const ret = {};
    for(const key in props)if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
        enumerable: true,
        get: ()=>props[key]
    });
    return ret;
}
function $0a6cc4ba868319ae$export$d6d6f7369f1fb104(getAwaitable) {
    const ctx = $0a6cc4ba868319ae$export$f13e630aa3915748();
    let awaitable = getAwaitable();
    $0a6cc4ba868319ae$var$unsetCurrentInstance();
    if ((0, $8POXm.isPromise)(awaitable)) awaitable = awaitable.catch((e)=>{
        $0a6cc4ba868319ae$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        ()=>$0a6cc4ba868319ae$var$setCurrentInstance(ctx)
    ];
}
function $0a6cc4ba868319ae$var$createDuplicateChecker() {
    const cache = /* @__PURE__ */ Object.create(null);
    return (type, key)=>{
        if (cache[key]) $0a6cc4ba868319ae$var$warn$1(`${type} property "${key}" is already defined in ${cache[key]}.`);
        else cache[key] = type;
    };
}
let $0a6cc4ba868319ae$var$shouldCacheAccess = true;
function $0a6cc4ba868319ae$var$applyOptions(instance) {
    const options = $0a6cc4ba868319ae$var$resolveMergedOptions(instance);
    const publicThis = instance.proxy;
    const ctx = instance.ctx;
    $0a6cc4ba868319ae$var$shouldCacheAccess = false;
    if (options.beforeCreate) $0a6cc4ba868319ae$var$callHook(options.beforeCreate, instance, "bc");
    const { // state
    data: dataOptions, computed: computedOptions, methods: methods, watch: watchOptions, provide: provideOptions, inject: injectOptions, created: // lifecycle
    created, beforeMount: beforeMount, mounted: mounted, beforeUpdate: beforeUpdate, updated: updated, activated: activated, deactivated: deactivated, beforeDestroy: beforeDestroy, beforeUnmount: beforeUnmount, destroyed: destroyed, unmounted: unmounted, render: render, renderTracked: renderTracked, renderTriggered: renderTriggered, errorCaptured: errorCaptured, serverPrefetch: serverPrefetch, expose: // public API
    expose, inheritAttrs: inheritAttrs, components: // assets
    components, directives: directives, filters: filters } = options;
    const checkDuplicateProperties = null;
    if (injectOptions) $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(const key in methods){
        const methodHandler = methods[key];
        if ((0, $8POXm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        const data = dataOptions.call(publicThis, publicThis);
        if (!(0, $8POXm.isObject)(data)) ;
        else instance.data = (0, $01W3b.reactive)(data);
    }
    $0a6cc4ba868319ae$var$shouldCacheAccess = true;
    if (computedOptions) for(const key in computedOptions){
        const opt = computedOptions[key];
        const get = (0, $8POXm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $8POXm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $8POXm.NOOP);
        const set = !(0, $8POXm.isFunction)(opt) && (0, $8POXm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $8POXm.NOOP);
        const c = $0a6cc4ba868319ae$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>c.value,
            set: (v1)=>c.value = v1
        });
    }
    if (watchOptions) for(const key in watchOptions)$0a6cc4ba868319ae$var$createWatcher(watchOptions[key], ctx, publicThis, key);
    if (provideOptions) {
        const provides = (0, $8POXm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach((key)=>{
            $0a6cc4ba868319ae$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $0a6cc4ba868319ae$var$callHook(created, instance, "c");
    function registerLifecycleHook(register, hook) {
        if ((0, $8POXm.isArray)(hook)) hook.forEach((_hook)=>register(_hook.bind(publicThis)));
        else if (hook) register(hook.bind(publicThis));
    }
    registerLifecycleHook($0a6cc4ba868319ae$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($0a6cc4ba868319ae$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($0a6cc4ba868319ae$export$5876c47052fb88b1, updated);
    registerLifecycleHook($0a6cc4ba868319ae$export$ba52d824b95a2154, activated);
    registerLifecycleHook($0a6cc4ba868319ae$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($0a6cc4ba868319ae$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($0a6cc4ba868319ae$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($0a6cc4ba868319ae$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($0a6cc4ba868319ae$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($0a6cc4ba868319ae$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($0a6cc4ba868319ae$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $8POXm.isArray)(expose)) {
        if (expose.length) {
            const exposed = instance.exposed || (instance.exposed = {});
            expose.forEach((key)=>{
                Object.defineProperty(exposed, key, {
                    get: ()=>publicThis[key],
                    set: (val)=>publicThis[key] = val,
                    enumerable: true
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $8POXm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
    if (serverPrefetch) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
}
function $0a6cc4ba868319ae$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties = (0, $8POXm.NOOP)) {
    if ((0, $8POXm.isArray)(injectOptions)) injectOptions = $0a6cc4ba868319ae$var$normalizeInject(injectOptions);
    for(const key in injectOptions){
        const opt = injectOptions[key];
        let injected;
        if ((0, $8POXm.isObject)(opt)) {
            if ("default" in opt) injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt.from || key);
        } else injected = $0a6cc4ba868319ae$export$a976684a0efeb93f(opt);
        if ((0, $01W3b.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: ()=>injected.value,
            set: (v1)=>injected.value = v1
        });
        else ctx[key] = injected;
    }
}
function $0a6cc4ba868319ae$var$callHook(hook, instance, type) {
    $0a6cc4ba868319ae$export$dae85862a8d94378((0, $8POXm.isArray)(hook) ? hook.map((h)=>h.bind(instance.proxy)) : hook.bind(instance.proxy), instance, type);
}
function $0a6cc4ba868319ae$var$createWatcher(raw, ctx, publicThis, key) {
    let getter = key.includes(".") ? $0a6cc4ba868319ae$var$createPathGetter(publicThis, key) : ()=>publicThis[key];
    if ((0, $8POXm.isString)(raw)) {
        const handler = ctx[raw];
        if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $8POXm.isFunction)(raw)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $8POXm.isObject)(raw)) {
        if ((0, $8POXm.isArray)(raw)) raw.forEach((r)=>$0a6cc4ba868319ae$var$createWatcher(r, ctx, publicThis, key));
        else {
            const handler = (0, $8POXm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $8POXm.isFunction)(handler)) $0a6cc4ba868319ae$export$3db5d71bdb2d5499(getter, handler, raw);
        }
    } else ;
}
function $0a6cc4ba868319ae$var$resolveMergedOptions(instance) {
    const base = instance.type;
    const { mixins: mixins, extends: extendsOptions } = base;
    const { mixins: globalMixins, optionsCache: cache, config: { optionMergeStrategies: optionMergeStrategies } } = instance.appContext;
    const cached = cache.get(base);
    let resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(resolved, m, optionMergeStrategies, true));
        $0a6cc4ba868319ae$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $8POXm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $0a6cc4ba868319ae$var$mergeOptions(to, from, strats, asMixin = false) {
    const { mixins: mixins, extends: extendsOptions } = from;
    if (extendsOptions) $0a6cc4ba868319ae$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach((m)=>$0a6cc4ba868319ae$var$mergeOptions(to, m, strats, true));
    for(const key in from){
        if (asMixin && key === "expose") ;
        else {
            const strat = $0a6cc4ba868319ae$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
const $0a6cc4ba868319ae$var$internalOptionMergeStrats = {
    data: $0a6cc4ba868319ae$var$mergeDataFn,
    props: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    emits: $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $0a6cc4ba868319ae$var$mergeObjectOptions,
    computed: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $0a6cc4ba868319ae$var$mergeAsArray,
    created: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeMount: $0a6cc4ba868319ae$var$mergeAsArray,
    mounted: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUpdate: $0a6cc4ba868319ae$var$mergeAsArray,
    updated: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeDestroy: $0a6cc4ba868319ae$var$mergeAsArray,
    beforeUnmount: $0a6cc4ba868319ae$var$mergeAsArray,
    destroyed: $0a6cc4ba868319ae$var$mergeAsArray,
    unmounted: $0a6cc4ba868319ae$var$mergeAsArray,
    activated: $0a6cc4ba868319ae$var$mergeAsArray,
    deactivated: $0a6cc4ba868319ae$var$mergeAsArray,
    errorCaptured: $0a6cc4ba868319ae$var$mergeAsArray,
    serverPrefetch: $0a6cc4ba868319ae$var$mergeAsArray,
    // assets
    components: $0a6cc4ba868319ae$var$mergeObjectOptions,
    directives: $0a6cc4ba868319ae$var$mergeObjectOptions,
    // watch
    watch: $0a6cc4ba868319ae$var$mergeWatchOptions,
    // provide / inject
    provide: $0a6cc4ba868319ae$var$mergeDataFn,
    inject: $0a6cc4ba868319ae$var$mergeInject
};
function $0a6cc4ba868319ae$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $8POXm.extend)((0, $8POXm.isFunction)(to) ? to.call(this, this) : to, (0, $8POXm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $0a6cc4ba868319ae$var$mergeInject(to, from) {
    return $0a6cc4ba868319ae$var$mergeObjectOptions($0a6cc4ba868319ae$var$normalizeInject(to), $0a6cc4ba868319ae$var$normalizeInject(from));
}
function $0a6cc4ba868319ae$var$normalizeInject(raw) {
    if ((0, $8POXm.isArray)(raw)) {
        const res = {};
        for(let i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $0a6cc4ba868319ae$var$mergeAsArray(to, from) {
    return to ? [
        ...new Set([].concat(to, from))
    ] : from;
}
function $0a6cc4ba868319ae$var$mergeObjectOptions(to, from) {
    return to ? (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $0a6cc4ba868319ae$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $8POXm.isArray)(to) && (0, $8POXm.isArray)(from)) return [
            .../* @__PURE__ */ new Set([
                ...to,
                ...from
            ])
        ];
        return (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), $0a6cc4ba868319ae$var$normalizePropsOrEmits(to), $0a6cc4ba868319ae$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $0a6cc4ba868319ae$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    const merged = (0, $8POXm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(const key in from)merged[key] = $0a6cc4ba868319ae$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $0a6cc4ba868319ae$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $8POXm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
let $0a6cc4ba868319ae$var$uid$1 = 0;
function $0a6cc4ba868319ae$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent, rootProps = null) {
        if (!(0, $8POXm.isFunction)(rootComponent)) rootComponent = (0, $8POXm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $8POXm.isObject)(rootProps)) rootProps = null;
        const context = $0a6cc4ba868319ae$var$createAppContext();
        const installedPlugins = /* @__PURE__ */ new WeakSet();
        const pluginCleanupFns = [];
        let isMounted = false;
        const app = context.app = {
            _uid: $0a6cc4ba868319ae$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $0a6cc4ba868319ae$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use (plugin, ...options) {
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $8POXm.isFunction)(plugin.install)) {
                    installedPlugins.add(plugin);
                    plugin.install(app, ...options);
                } else if ((0, $8POXm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin(app, ...options);
                }
                return app;
            },
            mixin (mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component (name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive (name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount (rootContainer, isHydrate, namespace) {
                if (!isMounted) {
                    const vnode = app._ceVNode || $0a6cc4ba868319ae$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (namespace === true) namespace = "svg";
                    else if (namespace === false) namespace = void 0;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, namespace);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $0a6cc4ba868319ae$var$devtoolsInitApp(app, $0a6cc4ba868319ae$export$83d89fbfd8236492);
                    }
                    return $0a6cc4ba868319ae$var$getComponentPublicInstance(vnode.component);
                }
            },
            onUnmount (cleanupFn) {
                pluginCleanupFns.push(cleanupFn);
            },
            unmount () {
                if (isMounted) {
                    $0a6cc4ba868319ae$export$dae85862a8d94378(pluginCleanupFns, app._instance, 16);
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $0a6cc4ba868319ae$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide (key, value) {
                context.provides[key] = value;
                return app;
            },
            runWithContext (fn) {
                const lastApp = $0a6cc4ba868319ae$var$currentApp;
                $0a6cc4ba868319ae$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $0a6cc4ba868319ae$var$currentApp = lastApp;
                }
            }
        };
        return app;
    };
}
let $0a6cc4ba868319ae$var$currentApp = null;
function $0a6cc4ba868319ae$export$fb78bd113157f1a1(props, name, options = (0, $8POXm.EMPTY_OBJ)) {
    const i = $0a6cc4ba868319ae$export$f13e630aa3915748();
    const camelizedName = (0, $8POXm.camelize)(name);
    const hyphenatedName = (0, $8POXm.hyphenate)(name);
    const modifiers = $0a6cc4ba868319ae$var$getModelModifiers(props, camelizedName);
    const res = (0, $01W3b.customRef)((track, trigger)=>{
        let localValue;
        let prevSetValue = (0, $8POXm.EMPTY_OBJ);
        let prevEmittedValue;
        $0a6cc4ba868319ae$export$2035654f31b0e555(()=>{
            const propValue = props[camelizedName];
            if ((0, $8POXm.hasChanged)(localValue, propValue)) {
                localValue = propValue;
                trigger();
            }
        });
        return {
            get () {
                track();
                return options.get ? options.get(localValue) : localValue;
            },
            set (value) {
                const emittedValue = options.set ? options.set(value) : value;
                if (!(0, $8POXm.hasChanged)(emittedValue, localValue) && !(prevSetValue !== (0, $8POXm.EMPTY_OBJ) && (0, $8POXm.hasChanged)(value, prevSetValue))) return;
                const rawProps = i.vnode.props;
                if (!(rawProps && // check if parent has passed v-model
                (name in rawProps || camelizedName in rawProps || hyphenatedName in rawProps) && (`onUpdate:${name}` in rawProps || `onUpdate:${camelizedName}` in rawProps || `onUpdate:${hyphenatedName}` in rawProps))) {
                    localValue = value;
                    trigger();
                }
                i.emit(`update:${name}`, emittedValue);
                if ((0, $8POXm.hasChanged)(value, emittedValue) && (0, $8POXm.hasChanged)(value, prevSetValue) && !(0, $8POXm.hasChanged)(emittedValue, prevEmittedValue)) trigger();
                prevSetValue = value;
                prevEmittedValue = emittedValue;
            }
        };
    });
    res[Symbol.iterator] = ()=>{
        let i2 = 0;
        return {
            next () {
                if (i2 < 2) return {
                    value: i2++ ? modifiers || (0, $8POXm.EMPTY_OBJ) : res,
                    done: false
                };
                else return {
                    done: true
                };
            }
        };
    };
    return res;
}
const $0a6cc4ba868319ae$var$getModelModifiers = (props, modelName)=>{
    return modelName === "modelValue" || modelName === "model-value" ? props.modelModifiers : props[`${modelName}Modifiers`] || props[`${(0, $8POXm.camelize)(modelName)}Modifiers`] || props[`${(0, $8POXm.hyphenate)(modelName)}Modifiers`];
};
function $0a6cc4ba868319ae$var$emit(instance, event, ...rawArgs) {
    if (instance.isUnmounted) return;
    const props = instance.vnode.props || (0, $8POXm.EMPTY_OBJ);
    let args = rawArgs;
    const isModelListener = event.startsWith("update:");
    const modifiers = isModelListener && $0a6cc4ba868319ae$var$getModelModifiers(props, event.slice(7));
    if (modifiers) {
        if (modifiers.trim) args = rawArgs.map((a)=>(0, $8POXm.isString)(a) ? a.trim() : a);
        if (modifiers.number) args = rawArgs.map((0, $8POXm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentEmit(instance, event, args);
    let handlerName;
    let handler = props[handlerName = (0, $8POXm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $8POXm.toHandlerKey)((0, $8POXm.hyphenate)(event))];
    if (handler) $0a6cc4ba868319ae$export$dae85862a8d94378(handler, instance, 6, args);
    const onceHandler = props[handlerName + `Once`];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $0a6cc4ba868319ae$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
const $0a6cc4ba868319ae$var$mixinEmitsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizeEmitsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinEmitsCache : appContext.emitsCache;
    const cached = cache.get(comp);
    if (cached !== void 0) return cached;
    const raw = comp.emits;
    let normalized = {};
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendEmits = (raw2)=>{
            const normalizedFromExtend = $0a6cc4ba868319ae$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $8POXm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $8POXm.isArray)(raw)) raw.forEach((key)=>normalized[key] = null);
    else (0, $8POXm.extend)(normalized, raw);
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $0a6cc4ba868319ae$var$isEmitListener(options, key) {
    if (!options || !(0, $8POXm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $8POXm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $8POXm.hasOwn)(options, (0, $8POXm.hyphenate)(key)) || (0, $8POXm.hasOwn)(options, key);
}
let $0a6cc4ba868319ae$var$accessedAttrs = false;
function $0a6cc4ba868319ae$var$markAttrsAccessed() {
    $0a6cc4ba868319ae$var$accessedAttrs = true;
}
function $0a6cc4ba868319ae$var$renderComponentRoot(instance) {
    const { type: Component, vnode: vnode, proxy: proxy, withProxy: withProxy, propsOptions: [propsOptions], slots: slots, attrs: attrs, emit: emit, render: render, renderCache: renderCache, props: props, data: data, setupState: setupState, ctx: ctx, inheritAttrs: inheritAttrs } = instance;
    const prev = $0a6cc4ba868319ae$var$setCurrentRenderingInstance(instance);
    let result;
    let fallthroughAttrs;
    try {
        if (vnode.shapeFlag & 4) {
            const proxyToUse = withProxy || proxy;
            const thisProxy = proxyToUse;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render.call(thisProxy, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            const render2 = Component;
            result = $0a6cc4ba868319ae$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $0a6cc4ba868319ae$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $0a6cc4ba868319ae$var$blockStack.length = 0;
        $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 1);
        result = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    }
    let root = result;
    let setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        const keys = Object.keys(fallthroughAttrs);
        const { shapeFlag: shapeFlag } = root;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $8POXm.isModelListener))) fallthroughAttrs = $0a6cc4ba868319ae$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, fallthroughAttrs, false, true);
            }
        }
    }
    if (vnode.dirs) {
        root = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(root, null, false, true);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) $0a6cc4ba868319ae$export$7770a22486565649(root, vnode.transition);
    result = root;
    $0a6cc4ba868319ae$var$setCurrentRenderingInstance(prev);
    return result;
}
const $0a6cc4ba868319ae$var$getChildRoot = (vnode)=>{
    const rawChildren = vnode.children;
    const dynamicChildren = vnode.dynamicChildren;
    const childRoot = $0a6cc4ba868319ae$var$filterSingleRoot(rawChildren, false);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    const index = rawChildren.indexOf(childRoot);
    const dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    const setRoot = (updatedRoot)=>{
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = [
                ...dynamicChildren,
                updatedRoot
            ];
        }
    };
    return [
        $0a6cc4ba868319ae$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $0a6cc4ba868319ae$var$filterSingleRoot(children, recurse = true) {
    let singleRoot;
    for(let i = 0; i < children.length; i++){
        const child = children[i];
        if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) {
            if (child.type !== $0a6cc4ba868319ae$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
const $0a6cc4ba868319ae$var$getFunctionalFallthrough = (attrs)=>{
    let res;
    for(const key in attrs)if (key === "class" || key === "style" || (0, $8POXm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$filterModelListeners = (attrs, props)=>{
    const res = {};
    for(const key in attrs)if (!(0, $8POXm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
const $0a6cc4ba868319ae$var$isElementRoot = (vnode)=>{
    return vnode.shapeFlag & 7 || vnode.type === $0a6cc4ba868319ae$export$4d299b491347818a;
};
function $0a6cc4ba868319ae$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    const { props: prevProps, children: prevChildren, component: component } = prevVNode;
    const { props: nextProps, children: nextChildren, patchFlag: patchFlag } = nextVNode;
    const emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            const dynamicProps = nextVNode.dynamicProps;
            for(let i = 0; i < dynamicProps.length; i++){
                const key = dynamicProps[i];
                if ($0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    const nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(let i = 0; i < nextKeys.length; i++){
        const key = nextKeys[i];
        if ($0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) && !$0a6cc4ba868319ae$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $0a6cc4ba868319ae$var$hasPropValueChanged(nextProps, prevProps, key) {
    const nextProp = nextProps[key];
    const prevProp = prevProps[key];
    if (key === "style" && (0, $8POXm.isObject)(nextProp) && (0, $8POXm.isObject)(prevProp)) return !(0, $8POXm.looseEqual)(nextProp, prevProp);
    return nextProp !== prevProp;
}
function $0a6cc4ba868319ae$var$updateHOCHostEl({ vnode: vnode, parent: parent }, el) {
    while(parent){
        const root = parent.subTree;
        if (root.suspense && root.suspense.activeBranch === vnode) root.el = vnode.el;
        if (root === vnode) {
            (vnode = parent.vnode).el = el;
            parent = parent.parent;
        } else break;
    }
}
const $0a6cc4ba868319ae$var$internalObjectProto = {};
const $0a6cc4ba868319ae$var$createInternalObject = ()=>Object.create($0a6cc4ba868319ae$var$internalObjectProto);
const $0a6cc4ba868319ae$var$isInternalObject = (obj)=>Object.getPrototypeOf(obj) === $0a6cc4ba868319ae$var$internalObjectProto;
function $0a6cc4ba868319ae$var$initProps(instance, rawProps, isStateful, isSSR = false) {
    const props = {};
    const attrs = $0a6cc4ba868319ae$var$createInternalObject();
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs);
    for(const key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $01W3b.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $0a6cc4ba868319ae$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $0a6cc4ba868319ae$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    const { props: props, attrs: attrs, vnode: { patchFlag: patchFlag } } = instance;
    const rawCurrentProps = (0, $01W3b.toRaw)(props);
    const [options] = instance.propsOptions;
    let hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            const propsToUpdate = instance.vnode.dynamicProps;
            for(let i = 0; i < propsToUpdate.length; i++){
                let key = propsToUpdate[i];
                if ($0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) continue;
                const value = rawProps[key];
                if (options) {
                    if ((0, $8POXm.hasOwn)(attrs, key)) {
                        if (value !== attrs[key]) {
                            attrs[key] = value;
                            hasAttrsChanged = true;
                        }
                    } else {
                        const camelizedKey = (0, $8POXm.camelize)(key);
                        props[camelizedKey] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value, instance, false);
                    }
                } else if (value !== attrs[key]) {
                    attrs[key] = value;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        let kebabKey;
        for(const key in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $8POXm.hasOwn)(rawProps, key) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $8POXm.hyphenate)(key)) === key || !(0, $8POXm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, void 0, instance, true);
            } else delete props[key];
        }
        if (attrs !== rawCurrentProps) {
            for(const key in attrs)if (!rawProps || !(0, $8POXm.hasOwn)(rawProps, key) && true) {
                delete attrs[key];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $01W3b.trigger)(instance.attrs, "set", "");
}
function $0a6cc4ba868319ae$var$setFullProps(instance, rawProps, props, attrs) {
    const [options, needCastKeys] = instance.propsOptions;
    let hasAttrsChanged = false;
    let rawCastValues;
    if (rawProps) for(let key in rawProps){
        if ((0, $8POXm.isReservedProp)(key)) continue;
        const value = rawProps[key];
        let camelKey;
        if (options && (0, $8POXm.hasOwn)(options, camelKey = (0, $8POXm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value;
        } else if (!$0a6cc4ba868319ae$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value !== attrs[key]) {
                attrs[key] = value;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        const rawCurrentProps = (0, $01W3b.toRaw)(props);
        const castValues = rawCastValues || (0, $8POXm.EMPTY_OBJ);
        for(let i = 0; i < needCastKeys.length; i++){
            const key = needCastKeys[i];
            props[key] = $0a6cc4ba868319ae$var$resolvePropValue(options, rawCurrentProps, key, castValues[key], instance, !(0, $8POXm.hasOwn)(castValues, key));
        }
    }
    return hasAttrsChanged;
}
function $0a6cc4ba868319ae$var$resolvePropValue(options, props, key, value, instance, isAbsent) {
    const opt = options[key];
    if (opt != null) {
        const hasDefault = (0, $8POXm.hasOwn)(opt, "default");
        if (hasDefault && value === void 0) {
            const defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $8POXm.isFunction)(defaultValue)) {
                const { propsDefaults: propsDefaults } = instance;
                if (key in propsDefaults) value = propsDefaults[key];
                else {
                    const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
                    value = propsDefaults[key] = defaultValue.call(null, props);
                    reset();
                }
            } else value = defaultValue;
            if (instance.ce) instance.ce._setProp(key, value);
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value === "" || value === (0, $8POXm.hyphenate)(key))) value = true;
        }
    }
    return value;
}
const $0a6cc4ba868319ae$var$mixinPropsCache = /* @__PURE__ */ new WeakMap();
function $0a6cc4ba868319ae$var$normalizePropsOptions(comp, appContext, asMixin = false) {
    const cache = __VUE_OPTIONS_API__ && asMixin ? $0a6cc4ba868319ae$var$mixinPropsCache : appContext.propsCache;
    const cached = cache.get(comp);
    if (cached) return cached;
    const raw = comp.props;
    const normalized = {};
    const needCastKeys = [];
    let hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $8POXm.isFunction)(comp)) {
        const extendProps = (raw2)=>{
            hasExtends = true;
            const [props, keys] = $0a6cc4ba868319ae$var$normalizePropsOptions(raw2, appContext, true);
            (0, $8POXm.extend)(normalized, props);
            if (keys) needCastKeys.push(...keys);
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $8POXm.isObject)(comp)) cache.set(comp, (0, $8POXm.EMPTY_ARR));
        return 0, $8POXm.EMPTY_ARR;
    }
    if ((0, $8POXm.isArray)(raw)) for(let i = 0; i < raw.length; i++){
        const normalizedKey = (0, $8POXm.camelize)(raw[i]);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $8POXm.EMPTY_OBJ);
    }
    else if (raw) for(const key in raw){
        const normalizedKey = (0, $8POXm.camelize)(key);
        if ($0a6cc4ba868319ae$var$validatePropName(normalizedKey)) {
            const opt = raw[key];
            const prop = normalized[normalizedKey] = (0, $8POXm.isArray)(opt) || (0, $8POXm.isFunction)(opt) ? {
                type: opt
            } : (0, $8POXm.extend)({}, opt);
            const propType = prop.type;
            let shouldCast = false;
            let shouldCastTrue = true;
            if ((0, $8POXm.isArray)(propType)) for(let index = 0; index < propType.length; ++index){
                const type = propType[index];
                const typeName = (0, $8POXm.isFunction)(type) && type.name;
                if (typeName === "Boolean") {
                    shouldCast = true;
                    break;
                } else if (typeName === "String") shouldCastTrue = false;
            }
            else shouldCast = (0, $8POXm.isFunction)(propType) && propType.name === "Boolean";
            prop[0 /* shouldCast */ ] = shouldCast;
            prop[1 /* shouldCastTrue */ ] = shouldCastTrue;
            if (shouldCast || (0, $8POXm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey);
        }
    }
    const res = [
        normalized,
        needCastKeys
    ];
    if ((0, $8POXm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $0a6cc4ba868319ae$var$validatePropName(key) {
    if (key[0] !== "$" && !(0, $8POXm.isReservedProp)(key)) return true;
    return false;
}
function $0a6cc4ba868319ae$var$getType(ctor) {
    if (ctor === null) return "null";
    if (typeof ctor === "function") return ctor.name || "";
    else if (typeof ctor === "object") {
        const name = ctor.constructor && ctor.constructor.name;
        return name || "";
    }
    return "";
}
function $0a6cc4ba868319ae$var$validateProps(rawProps, props, instance) {
    const resolvedValues = (0, $01W3b.toRaw)(props);
    const options = instance.propsOptions[0];
    const camelizePropsKey = Object.keys(rawProps).map((key)=>(0, $8POXm.camelize)(key));
    for(const key in options){
        let opt = options[key];
        if (opt == null) continue;
        $0a6cc4ba868319ae$var$validateProp(key, resolvedValues[key], opt, resolvedValues, !camelizePropsKey.includes(key));
    }
}
function $0a6cc4ba868319ae$var$validateProp(name, value, prop, props, isAbsent) {
    const { type: type, required: required, validator: validator, skipCheck: skipCheck } = prop;
    if (required && isAbsent) {
        $0a6cc4ba868319ae$var$warn$1('Missing required prop: "' + name + '"');
        return;
    }
    if (value == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        let isValid = false;
        const types = (0, $8POXm.isArray)(type) ? type : [
            type
        ];
        const expectedTypes = [];
        for(let i = 0; i < types.length && !isValid; i++){
            const { valid: valid, expectedType: expectedType } = $0a6cc4ba868319ae$var$assertType(value, types[i]);
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $0a6cc4ba868319ae$var$warn$1($0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value, props)) $0a6cc4ba868319ae$var$warn$1('Invalid prop: custom validator check failed for prop "' + name + '".');
}
const $0a6cc4ba868319ae$var$isSimpleType = /* @__PURE__ */ (0, $8POXm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $0a6cc4ba868319ae$var$assertType(value, type) {
    let valid;
    const expectedType = $0a6cc4ba868319ae$var$getType(type);
    if (expectedType === "null") valid = value === null;
    else if ($0a6cc4ba868319ae$var$isSimpleType(expectedType)) {
        const t = typeof value;
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = (0, $8POXm.isObject)(value);
    else if (expectedType === "Array") valid = (0, $8POXm.isArray)(value);
    else valid = value instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $0a6cc4ba868319ae$var$getInvalidTypeMessage(name, value, expectedTypes) {
    if (expectedTypes.length === 0) return `Prop type [] for prop "${name}" won't match anything. Did you mean to use type Array instead?`;
    let message = `Invalid prop: type check failed for prop "${name}". Expected ${expectedTypes.map((0, $8POXm.capitalize)).join(" | ")}`;
    const expectedType = expectedTypes[0];
    const receivedType = (0, $8POXm.toRawType)(value);
    const expectedValue = $0a6cc4ba868319ae$var$styleValue(value, expectedType);
    const receivedValue = $0a6cc4ba868319ae$var$styleValue(value, receivedType);
    if (expectedTypes.length === 1 && $0a6cc4ba868319ae$var$isExplicable(expectedType) && !$0a6cc4ba868319ae$var$isBoolean(expectedType, receivedType)) message += ` with value ${expectedValue}`;
    message += `, got ${receivedType} `;
    if ($0a6cc4ba868319ae$var$isExplicable(receivedType)) message += `with value ${receivedValue}.`;
    return message;
}
function $0a6cc4ba868319ae$var$styleValue(value, type) {
    if (type === "String") return `"${value}"`;
    else if (type === "Number") return `${Number(value)}`;
    else return `${value}`;
}
function $0a6cc4ba868319ae$var$isExplicable(type) {
    const explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some((elem)=>type.toLowerCase() === elem);
}
function $0a6cc4ba868319ae$var$isBoolean(...args) {
    return args.some((elem)=>elem.toLowerCase() === "boolean");
}
const $0a6cc4ba868319ae$var$isInternalKey = (key)=>key === "_" || key === "_ctx" || key === "$stable";
const $0a6cc4ba868319ae$var$normalizeSlotValue = (value)=>(0, $8POXm.isArray)(value) ? value.map($0a6cc4ba868319ae$var$normalizeVNode) : [
        $0a6cc4ba868319ae$var$normalizeVNode(value)
    ];
const $0a6cc4ba868319ae$var$normalizeSlot = (key, rawSlot, ctx)=>{
    if (rawSlot._n) return rawSlot;
    const normalized = $0a6cc4ba868319ae$export$694b237e827a3d23((...args)=>{
        return $0a6cc4ba868319ae$var$normalizeSlotValue(rawSlot(...args));
    }, ctx);
    normalized._c = false;
    return normalized;
};
const $0a6cc4ba868319ae$var$normalizeObjectSlots = (rawSlots, slots, instance)=>{
    const ctx = rawSlots._ctx;
    for(const key in rawSlots){
        if ($0a6cc4ba868319ae$var$isInternalKey(key)) continue;
        const value = rawSlots[key];
        if ((0, $8POXm.isFunction)(value)) slots[key] = $0a6cc4ba868319ae$var$normalizeSlot(key, value, ctx);
        else if (value != null) {
            const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(value);
            slots[key] = ()=>normalized;
        }
    }
};
const $0a6cc4ba868319ae$var$normalizeVNodeSlots = (instance, children)=>{
    const normalized = $0a6cc4ba868319ae$var$normalizeSlotValue(children);
    instance.slots.default = ()=>normalized;
};
const $0a6cc4ba868319ae$var$assignSlots = (slots, children, optimized)=>{
    for(const key in children)if (optimized || !$0a6cc4ba868319ae$var$isInternalKey(key)) slots[key] = children[key];
};
const $0a6cc4ba868319ae$var$initSlots = (instance, children, optimized)=>{
    const slots = instance.slots = $0a6cc4ba868319ae$var$createInternalObject();
    if (instance.vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
            if (optimized) (0, $8POXm.def)(slots, "_", type, true);
        } else $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
    } else if (children) $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
};
const $0a6cc4ba868319ae$var$updateSlots = (instance, children, optimized)=>{
    const { vnode: vnode, slots: slots } = instance;
    let needDeletionCheck = true;
    let deletionComparisonTarget = (0, $8POXm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        const type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else $0a6cc4ba868319ae$var$assignSlots(slots, children, optimized);
        } else {
            needDeletionCheck = !children.$stable;
            $0a6cc4ba868319ae$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $0a6cc4ba868319ae$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(const key in slots)if (!$0a6cc4ba868319ae$var$isInternalKey(key) && deletionComparisonTarget[key] == null) delete slots[key];
    }
};
let $0a6cc4ba868319ae$var$supported;
let $0a6cc4ba868319ae$var$perf;
function $0a6cc4ba868319ae$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) $0a6cc4ba868319ae$var$perf.mark(`vue-${type}-${instance.uid}`);
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfStart(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $0a6cc4ba868319ae$var$isSupported()) {
        const startTag = `vue-${type}-${instance.uid}`;
        const endTag = startTag + `:end`;
        const measureName = `<${$0a6cc4ba868319ae$var$formatComponentName(instance, instance.type)}> ${type}`;
        $0a6cc4ba868319ae$var$perf.mark(endTag);
        $0a6cc4ba868319ae$var$perf.measure(measureName, startTag, endTag);
        $0a6cc4ba868319ae$var$perf.clearMeasures(measureName);
        $0a6cc4ba868319ae$var$perf.clearMarks(startTag);
        $0a6cc4ba868319ae$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsPerfEnd(instance, type, $0a6cc4ba868319ae$var$isSupported() ? $0a6cc4ba868319ae$var$perf.now() : Date.now());
}
function $0a6cc4ba868319ae$var$isSupported() {
    if ($0a6cc4ba868319ae$var$supported !== void 0) return $0a6cc4ba868319ae$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $0a6cc4ba868319ae$var$supported = true;
        $0a6cc4ba868319ae$var$perf = window.performance;
    } else $0a6cc4ba868319ae$var$supported = false;
    return $0a6cc4ba868319ae$var$supported;
}
function $0a6cc4ba868319ae$var$initFeatureFlags() {
    const needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
    if (typeof __VUE_PROD_HYDRATION_MISMATCH_DETAILS__ !== "boolean") (0, $8POXm.getGlobalThis)().__VUE_PROD_HYDRATION_MISMATCH_DETAILS__ = false;
}
const $0a6cc4ba868319ae$var$queuePostRenderEffect = $0a6cc4ba868319ae$var$queueEffectWithSuspense;
function $0a6cc4ba868319ae$export$53ae2f996c64e9a(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options);
}
function $0a6cc4ba868319ae$export$200524cf0d997ff0(options) {
    return $0a6cc4ba868319ae$var$baseCreateRenderer(options, $0a6cc4ba868319ae$var$createHydrationFunctions);
}
function $0a6cc4ba868319ae$var$baseCreateRenderer(options, createHydrationFns) {
    $0a6cc4ba868319ae$var$initFeatureFlags();
    const target = (0, $8POXm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$setDevtoolsHook$1(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    const { insert: hostInsert, remove: hostRemove, patchProp: hostPatchProp, createElement: hostCreateElement, createText: hostCreateText, createComment: hostCreateComment, setText: hostSetText, setElementText: hostSetElementText, parentNode: hostParentNode, nextSibling: hostNextSibling, setScopeId: hostSetScopeId = (0, $8POXm.NOOP), insertStaticContent: hostInsertStaticContent } = options;
    const patch = (n1, n2, container, anchor = null, parentComponent = null, parentSuspense = null, namespace, slotScopeIds = null, optimized = !!n2.dynamicChildren)=>{
        if (n1 === n2) return;
        if (n1 && !$0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        const { type: type, ref: ref, shapeFlag: shapeFlag } = n2;
        switch(type){
            case $0a6cc4ba868319ae$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, namespace);
                break;
            case $0a6cc4ba868319ae$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $0a6cc4ba868319ae$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
        else if (ref == null && n1 && n1.ref != null) $0a6cc4ba868319ae$var$setRef(n1.ref, null, parentSuspense, n1, true);
    };
    const processText = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            const el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    const processCommentNode = (n1, n2, container, anchor)=>{
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    const mountStaticNode = (n2, container, anchor, namespace)=>{
        [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace, n2.el, n2.anchor);
    };
    const patchStaticNode = (n1, n2, container, namespace)=>{
        if (n2.children !== n1.children) {
            const anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            [n2.el, n2.anchor] = hostInsertStaticContent(n2.children, container, anchor, namespace);
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    const moveStaticNode = ({ el: el, anchor: anchor }, container, nextSibling)=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    const removeStaticNode = ({ el: el, anchor: anchor })=>{
        let next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    const processElement = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        if (n2.type === "svg") namespace = "svg";
        else if (n2.type === "math") namespace = "mathml";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        else {
            const customElement = n1.el && n1.el._isVueCE ? n1.el : null;
            try {
                if (customElement) customElement._beginPatch();
                patchElement(n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            } finally{
                if (customElement) customElement._endPatch();
            }
        }
    };
    const mountElement = (vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let el;
        let vnodeHook;
        const { props: props, shapeFlag: shapeFlag, transition: transition, dirs: dirs } = vnode;
        el = vnode.el = hostCreateElement(vnode.type, namespace, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(vnode, namespace), slotScopeIds, optimized);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(const key in props)if (key !== "value" && !(0, $8POXm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], namespace, parentComponent);
            if ("value" in props) hostPatchProp(el, "value", null, props.value, namespace);
            if (vnodeHook = props.onVnodeBeforeMount) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            (0, $8POXm.def)(el, "__vnode", vnode, true);
            (0, $8POXm.def)(el, "__vueParentComponent", parentComponent, true);
        }
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        const needCallTransitionHooks = $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition);
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    const setScopeId = (el, vnode, scopeId, slotScopeIds, parentComponent)=>{
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(let i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            let subTree = parentComponent.subTree;
            if (vnode === subTree || $0a6cc4ba868319ae$var$isSuspense(subTree.type) && (subTree.ssContent === vnode || subTree.ssFallback === vnode)) {
                const parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    const mountChildren = (children, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, start = 0)=>{
        for(let i = start; i < children.length; i++){
            const child = children[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(children[i]) : $0a6cc4ba868319ae$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchElement = (n1, n2, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const el = n2.el = n1.el;
        if (__VUE_PROD_DEVTOOLS__) el.__vnode = n2;
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, dirs: dirs } = n2;
        patchFlag |= n1.patchFlag & 16;
        const oldProps = n1.props || (0, $8POXm.EMPTY_OBJ);
        const newProps = n2.props || (0, $8POXm.EMPTY_OBJ);
        let vnodeHook;
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $0a6cc4ba868319ae$var$toggleRecurse(parentComponent, true);
        if (oldProps.innerHTML && newProps.innerHTML == null || oldProps.textContent && newProps.textContent == null) hostSetElementText(el, "");
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, $0a6cc4ba868319ae$var$resolveChildrenNamespace(n2, namespace), slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, oldProps, newProps, parentComponent, namespace);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, namespace);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, namespace);
                if (patchFlag & 8) {
                    const propsToUpdate = n2.dynamicProps;
                    for(let i = 0; i < propsToUpdate.length; i++){
                        const key = propsToUpdate[i];
                        const prev = oldProps[key];
                        const next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, oldProps, newProps, parentComponent, namespace);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    const patchBlockChildren = (oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, namespace, slotScopeIds)=>{
        for(let i = 0; i < newChildren.length; i++){
            const oldVNode = oldChildren[i];
            const newVNode = newChildren[i];
            const container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $0a6cc4ba868319ae$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$0a6cc4ba868319ae$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 198) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, true);
        }
    };
    const patchProps = (el, oldProps, newProps, parentComponent, namespace)=>{
        if (oldProps !== newProps) {
            if (oldProps !== (0, $8POXm.EMPTY_OBJ)) {
                for(const key in oldProps)if (!(0, $8POXm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, namespace, parentComponent);
            }
            for(const key in newProps){
                if ((0, $8POXm.isReservedProp)(key)) continue;
                const next = newProps[key];
                const prev = oldProps[key];
                if (next !== prev && key !== "value") hostPatchProp(el, key, prev, next, namespace, parentComponent);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value, namespace);
        }
    };
    const processFragment = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        const fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        const fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        let { patchFlag: patchFlag, dynamicChildren: dynamicChildren, slotScopeIds: fragmentSlotScopeIds } = n2;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(// #10007
            // such fragment like `<></>` will be compiled into
            // a fragment which doesn't have a children.
            // In this case fallback to an empty array
            n2.children || [], container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren && n1.dynamicChildren.length === dynamicChildren.length) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, namespace, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
    };
    const processComponent = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, namespace, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, namespace, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    const mountComponent = (initialVNode, container, anchor, parentComponent, parentSuspense, namespace, optimized)=>{
        const instance = initialVNode.component = $0a6cc4ba868319ae$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($0a6cc4ba868319ae$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $0a6cc4ba868319ae$var$setupComponent(instance, false, optimized);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect, optimized);
            if (!initialVNode.el) {
                const placeholder = instance.subTree = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
                initialVNode.placeholder = placeholder.el;
            }
        } else setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, namespace, optimized);
    };
    const updateComponent = (n1, n2, optimized)=>{
        const instance = n2.component = n1.component;
        if ($0a6cc4ba868319ae$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    const setupRenderEffect = (instance, initialVNode, container, anchor, parentSuspense, namespace, optimized)=>{
        const componentUpdateFn = ()=>{
            if (!instance.isMounted) {
                let vnodeHook;
                const { el: el, props: props } = initialVNode;
                const { bm: bm, m: m, parent: parent, root: root, type: type } = instance;
                const isAsyncWrapperVNode = $0a6cc4ba868319ae$var$isAsyncWrapper(initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (bm) (0, $8POXm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    const hydrateSubTree = ()=>{
                        instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode && type.__asyncHydrate) type.__asyncHydrate(el, instance, hydrateSubTree);
                    else hydrateSubTree();
                } else {
                    if (root.ce && root.ce._hasShadowRoot()) root.ce._injectChildStyle(type);
                    const subTree = instance.subTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, namespace);
                    initialVNode.el = subTree.el;
                }
                if (m) $0a6cc4ba868319ae$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    const scopedInitialVNode = initialVNode;
                    $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode), parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $0a6cc4ba868319ae$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $0a6cc4ba868319ae$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                let { next: next, bu: bu, u: u, parent: parent, vnode: vnode } = instance;
                {
                    const nonHydratedAsyncRoot = $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance);
                    if (nonHydratedAsyncRoot) {
                        if (next) {
                            next.el = vnode.el;
                            updateComponentPreRender(instance, next, optimized);
                        }
                        nonHydratedAsyncRoot.asyncDep.then(()=>{
                            $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
                                if (!instance.isUnmounted) update();
                            }, parentSuspense);
                        });
                        return;
                    }
                }
                let originNext = next;
                let vnodeHook;
                $0a6cc4ba868319ae$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $8POXm.invokeArrayFns)(bu);
                if (vnodeHook = next.props && next.props.onVnodeBeforeUpdate) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode);
                $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
                const nextTree = $0a6cc4ba868319ae$var$renderComponentRoot(instance);
                const prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, namespace);
                next.el = nextTree.el;
                if (originNext === null) $0a6cc4ba868319ae$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $0a6cc4ba868319ae$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook = next.props && next.props.onVnodeUpdated) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>$0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parent, next, vnode), parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentUpdated(instance);
            }
        };
        instance.scope.on();
        const effect = instance.effect = new (0, $01W3b.ReactiveEffect)(componentUpdateFn);
        instance.scope.off();
        const update = instance.update = effect.run.bind(effect);
        const job = instance.job = effect.runIfDirty.bind(effect);
        job.i = instance;
        job.id = instance.uid;
        effect.scheduler = ()=>$0a6cc4ba868319ae$var$queueJob(job);
        $0a6cc4ba868319ae$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    const updateComponentPreRender = (instance, nextVNode, optimized)=>{
        nextVNode.component = instance;
        const prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $0a6cc4ba868319ae$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $0a6cc4ba868319ae$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $01W3b.pauseTracking)();
        $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
        (0, $01W3b.resetTracking)();
    };
    const patchChildren = (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized = false)=>{
        const c1 = n1 && n1.children;
        const prevShapeFlag = n1 ? n1.shapeFlag : 0;
        const c2 = n2.children;
        const { patchFlag: patchFlag, shapeFlag: shapeFlag } = n2;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
    };
    const patchUnkeyedChildren = (c1, c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        c1 = c1 || (0, $8POXm.EMPTY_ARR);
        c2 = c2 || (0, $8POXm.EMPTY_ARR);
        const oldLength = c1.length;
        const newLength = c2.length;
        const commonLength = Math.min(oldLength, newLength);
        let i;
        for(i = 0; i < commonLength; i++){
            const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, commonLength);
    };
    const patchKeyedChildren = (c1, c2, container, parentAnchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized)=>{
        let i = 0;
        const l2 = c2.length;
        let e1 = c1.length - 1;
        let e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            const n1 = c1[i];
            const n2 = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            const n1 = c1[e1];
            const n2 = c2[e2] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[e2]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[e2]);
            if ($0a6cc4ba868319ae$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                const nextPos = e2 + 1;
                const anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            const s1 = i;
            const s2 = i;
            const keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                const nextChild = c2[i] = optimized ? $0a6cc4ba868319ae$var$cloneIfMounted(c2[i]) : $0a6cc4ba868319ae$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            let j;
            let patched = 0;
            const toBePatched = e2 - s2 + 1;
            let moved = false;
            let maxNewIndexSoFar = 0;
            const newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                const prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                let newIndex;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $0a6cc4ba868319ae$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                    patched++;
                }
            }
            const increasingNewIndexSequence = moved ? $0a6cc4ba868319ae$var$getSequence(newIndexToOldIndexMap) : (0, $8POXm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                const nextIndex = s2 + i;
                const nextChild = c2[nextIndex];
                const anchorVNode = c2[nextIndex + 1];
                const anchor = nextIndex + 1 < l2 ? // #13559, #14173 fallback to el placeholder for unresolved async component
                anchorVNode.el || $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVNode) : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild, container, anchor, 2);
                    else j--;
                }
            }
        }
    };
    const move = (vnode, container, anchor, moveType, parentSuspense = null)=>{
        const { el: el, type: type, transition: transition, children: children, shapeFlag: shapeFlag } = vnode;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(let i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        const needTransition2 = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition2) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>transition.enter(el), parentSuspense);
            } else {
                const { leave: leave, delayLeave: delayLeave, afterLeave: afterLeave } = transition;
                const remove2 = ()=>{
                    if (vnode.ctx.isUnmounted) hostRemove(el);
                    else hostInsert(el, container, anchor);
                };
                const performLeave = ()=>{
                    if (el._isLeaving) el[$0a6cc4ba868319ae$var$leaveCbKey](true);
                    leave(el, ()=>{
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    const unmount = (vnode, parentComponent, parentSuspense, doRemove = false, optimized = false)=>{
        const { type: type, props: props, ref: ref, children: children, dynamicChildren: dynamicChildren, shapeFlag: shapeFlag, patchFlag: patchFlag, dirs: dirs, cacheIndex: cacheIndex } = vnode;
        if (patchFlag === -2) optimized = false;
        if (ref != null) {
            (0, $01W3b.pauseTracking)();
            $0a6cc4ba868319ae$var$setRef(ref, null, parentSuspense, vnode, true);
            (0, $01W3b.resetTracking)();
        }
        if (cacheIndex != null) parentComponent.renderCache[cacheIndex] = void 0;
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        const shouldInvokeDirs = shapeFlag & 1 && dirs;
        const shouldInvokeVnodeHook = !$0a6cc4ba868319ae$var$isAsyncWrapper(vnode);
        let vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, internals, doRemove);
            else if (dynamicChildren && // #5154
            // when v-once is used inside a block, setBlockTracking(-1) marks the
            // parent block with hasOnce: true
            // so that it doesn't take the fast path during unmount - otherwise
            // components nested in v-once are never unmounted.
            !dynamicChildren.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $0a6cc4ba868319ae$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            vnodeHook && $0a6cc4ba868319ae$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $0a6cc4ba868319ae$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    const remove = (vnode)=>{
        const { type: type, el: el, anchor: anchor, transition: transition } = vnode;
        if (type === $0a6cc4ba868319ae$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        const performRemove = ()=>{
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            const { leave: leave, delayLeave: delayLeave } = transition;
            const performLeave = ()=>leave(el, performRemove);
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    const removeFragment = (cur, end)=>{
        let next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    const unmountComponent = (instance, parentSuspense, doRemove)=>{
        const { bum: bum, scope: scope, job: job, subTree: subTree, um: um, m: m, a: a } = instance;
        $0a6cc4ba868319ae$var$invalidateMount(m);
        $0a6cc4ba868319ae$var$invalidateMount(a);
        if (bum) (0, $8POXm.invokeArrayFns)(bum);
        scope.stop();
        if (job) {
            job.flags |= 8;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $0a6cc4ba868319ae$var$queuePostRenderEffect(um, parentSuspense);
        $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>{
            instance.isUnmounted = true;
        }, parentSuspense);
        if (__VUE_PROD_DEVTOOLS__) $0a6cc4ba868319ae$var$devtoolsComponentRemoved(instance);
    };
    const unmountChildren = (children, parentComponent, parentSuspense, doRemove = false, optimized = false, start = 0)=>{
        for(let i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    const getNextHostNode = (vnode)=>{
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        const el = hostNextSibling(vnode.anchor || vnode.el);
        const teleportEnd = el && el[$0a6cc4ba868319ae$var$TeleportEndKey];
        return teleportEnd ? hostNextSibling(teleportEnd) : el;
    };
    let isFlushing = false;
    const render = (vnode, container, namespace)=>{
        let instance;
        if (vnode == null) {
            if (container._vnode) {
                unmount(container._vnode, null, null, true);
                instance = container._vnode.component;
            }
        } else patch(container._vnode || null, vnode, container, null, null, null, namespace);
        container._vnode = vnode;
        if (!isFlushing) {
            isFlushing = true;
            $0a6cc4ba868319ae$var$flushPreFlushCbs(instance);
            $0a6cc4ba868319ae$var$flushPostFlushCbs();
            isFlushing = false;
        }
    };
    const internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    let hydrate;
    let hydrateNode;
    if (createHydrationFns) [hydrate, hydrateNode] = createHydrationFns(internals);
    return {
        render: render,
        hydrate: hydrate,
        createApp: $0a6cc4ba868319ae$var$createAppAPI(render, hydrate)
    };
}
function $0a6cc4ba868319ae$var$resolveChildrenNamespace({ type: type, props: props }, currentNamespace) {
    return currentNamespace === "svg" && type === "foreignObject" || currentNamespace === "mathml" && type === "annotation-xml" && props && props.encoding && props.encoding.includes("html") ? void 0 : currentNamespace;
}
function $0a6cc4ba868319ae$var$toggleRecurse({ effect: effect, job: job }, allowed) {
    if (allowed) {
        effect.flags |= 32;
        job.flags |= 4;
    } else {
        effect.flags &= -33;
        job.flags &= -5;
    }
}
function $0a6cc4ba868319ae$var$needTransition(parentSuspense, transition) {
    return (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
}
function $0a6cc4ba868319ae$var$traverseStaticChildren(n1, n2, shallow = false) {
    const ch1 = n1.children;
    const ch2 = n2.children;
    if ((0, $8POXm.isArray)(ch1) && (0, $8POXm.isArray)(ch2)) for(let i = 0; i < ch1.length; i++){
        const c1 = ch1[i];
        let c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow && c2.patchFlag !== -2) $0a6cc4ba868319ae$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $0a6cc4ba868319ae$export$5f1af8db9871e1d6) {
            if (c2.patchFlag === -1) c2 = ch2[i] = $0a6cc4ba868319ae$var$cloneIfMounted(c2);
            c2.el = c1.el;
        }
        if (c2.type === $0a6cc4ba868319ae$export$4d299b491347818a && !c2.el) c2.el = c1.el;
    }
}
function $0a6cc4ba868319ae$var$getSequence(arr) {
    const p = arr.slice();
    const result = [
        0
    ];
    let i, j, u, v1, c;
    const len = arr.length;
    for(i = 0; i < len; i++){
        const arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
function $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(instance) {
    const subComponent = instance.subTree.component;
    if (subComponent) {
        if (subComponent.asyncDep && !subComponent.asyncResolved) return subComponent;
        else return $0a6cc4ba868319ae$var$locateNonHydratedAsyncRoot(subComponent);
    }
}
function $0a6cc4ba868319ae$var$invalidateMount(hooks) {
    if (hooks) for(let i = 0; i < hooks.length; i++)hooks[i].flags |= 8;
}
function $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(anchorVnode) {
    if (anchorVnode.placeholder) return anchorVnode.placeholder;
    const instance = anchorVnode.component;
    if (instance) return $0a6cc4ba868319ae$var$resolveAsyncComponentPlaceholder(instance.subTree);
    return null;
}
const $0a6cc4ba868319ae$var$isSuspense = (type)=>type.__isSuspense;
let $0a6cc4ba868319ae$var$suspenseId = 0;
const $0a6cc4ba868319ae$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process (n1, n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $0a6cc4ba868319ae$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals);
        else {
            if (parentSuspense && parentSuspense.deps > 0 && !n1.suspense.isInFallback) {
                n2.suspense = n1.suspense;
                n2.suspense.vnode = n2;
                n2.el = n1.el;
                return;
            }
            $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, rendererInternals);
        }
    },
    hydrate: $0a6cc4ba868319ae$var$hydrateSuspense,
    normalize: $0a6cc4ba868319ae$var$normalizeSuspenseChildren
};
const $0a6cc4ba868319ae$export$74bf444e3cd11ea5 = $0a6cc4ba868319ae$var$SuspenseImpl;
function $0a6cc4ba868319ae$var$triggerEvent(vnode, name) {
    const eventListener = vnode.props && vnode.props[name];
    if ((0, $8POXm.isFunction)(eventListener)) eventListener();
}
function $0a6cc4ba868319ae$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals) {
    const { p: patch, o: { createElement: createElement } } = rendererInternals;
    const hiddenContainer = createElement("div");
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds);
    if (suspense.deps > 0) {
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onPending");
        $0a6cc4ba868319ae$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        namespace, slotScopeIds);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $0a6cc4ba868319ae$var$patchSuspense(n1, n2, container, anchor, parentComponent, namespace, slotScopeIds, optimized, { p: patch, um: unmount, o: { createElement: createElement } }) {
    const suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    const newBranch = n2.ssContent;
    const newFallback = n2.ssFallback;
    const { activeBranch: activeBranch, pendingBranch: pendingBranch, isInFallback: isInFallback, isHydrating: isHydrating } = suspense;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($0a6cc4ba868319ae$var$isSameVNodeType(pendingBranch, newBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                if (!isHydrating) {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            }
        } else {
            suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    namespace, slotScopeIds, optimized);
                    $0a6cc4ba868319ae$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $0a6cc4ba868319ae$var$isSameVNodeType(activeBranch, newBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, namespace, slotScopeIds, optimized);
        $0a6cc4ba868319ae$var$setActiveBranch(suspense, newBranch);
    } else {
        $0a6cc4ba868319ae$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        if (newBranch.shapeFlag & 512) suspense.pendingId = newBranch.component.suspenseId;
        else suspense.pendingId = $0a6cc4ba868319ae$var$suspenseId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, namespace, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            const { timeout: timeout, pendingId: pendingId } = suspense;
            if (timeout > 0) setTimeout(()=>{
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
let $0a6cc4ba868319ae$var$hasWarned = false;
function $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, namespace, slotScopeIds, optimized, rendererInternals, isHydrating = false) {
    const { p: patch, m: move, um: unmount, n: next, o: { parentNode: parentNode, remove: remove } } = rendererInternals;
    let parentSuspenseId;
    const isSuspensible = $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense && parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    const timeout = vnode.props ? (0, $8POXm.toNumber)(vnode.props.timeout) : void 0;
    const initialAnchor = anchor;
    const suspense = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        namespace: namespace,
        container: container,
        hiddenContainer: hiddenContainer,
        deps: 0,
        pendingId: $0a6cc4ba868319ae$var$suspenseId++,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: !isHydrating,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: [],
        resolve (resume = false, sync = false) {
            const { vnode: vnode2, activeBranch: activeBranch, pendingBranch: pendingBranch, pendingId: pendingId, effects: effects, parentComponent: parentComponent2, container: container2, isInFallback: isInFallback } = suspense;
            let delayEnter = false;
            if (suspense.isHydrating) suspense.isHydrating = false;
            else if (!resume) {
                delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
                if (delayEnter) activeBranch.transition.afterLeave = ()=>{
                    if (pendingId === suspense.pendingId) {
                        move(pendingBranch, container2, anchor === initialAnchor ? next(activeBranch) : anchor, 0);
                        $0a6cc4ba868319ae$export$59536a0199721cab(effects);
                        if (isInFallback && vnode2.ssFallback) vnode2.ssFallback.el = null;
                    }
                };
                if (activeBranch) {
                    if (parentNode(activeBranch.el) === container2) anchor = next(activeBranch);
                    unmount(activeBranch, parentComponent2, suspense, true);
                    if (!delayEnter && isInFallback && vnode2.ssFallback) $0a6cc4ba868319ae$var$queuePostRenderEffect(()=>vnode2.ssFallback.el = null, suspense);
                }
                if (!delayEnter) move(pendingBranch, container2, anchor, 0);
            }
            $0a6cc4ba868319ae$var$setActiveBranch(suspense, pendingBranch);
            suspense.pendingBranch = null;
            suspense.isInFallback = false;
            let parent = suspense.parent;
            let hasUnresolvedAncestor = false;
            while(parent){
                if (parent.pendingBranch) {
                    parent.effects.push(...effects);
                    hasUnresolvedAncestor = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!hasUnresolvedAncestor && !delayEnter) $0a6cc4ba868319ae$export$59536a0199721cab(effects);
            suspense.effects = [];
            if (isSuspensible) {
                if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                    parentSuspense.deps--;
                    if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
                }
            }
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onResolve");
        },
        fallback (fallbackVNode) {
            if (!suspense.pendingBranch) return;
            const { vnode: vnode2, activeBranch: activeBranch, parentComponent: parentComponent2, container: container2, namespace: namespace2 } = suspense;
            $0a6cc4ba868319ae$var$triggerEvent(vnode2, "onFallback");
            const anchor2 = next(activeBranch);
            const mountFallback = ()=>{
                if (!suspense.isInFallback) return;
                patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
                namespace2, slotScopeIds, optimized);
                $0a6cc4ba868319ae$var$setActiveBranch(suspense, fallbackVNode);
            };
            const delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
            suspense.isInFallback = true;
            unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
            true);
            if (!delayEnter) mountFallback();
        },
        move (container2, anchor2, type) {
            suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
            suspense.container = container2;
        },
        next () {
            return suspense.activeBranch && next(suspense.activeBranch);
        },
        registerDep (instance, setupRenderEffect, optimized2) {
            const isInPendingSuspense = !!suspense.pendingBranch;
            if (isInPendingSuspense) suspense.deps++;
            const hydratedEl = instance.vnode.el;
            instance.asyncDep.catch((err)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(err, instance, 0);
            }).then((asyncSetupResult)=>{
                if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
                instance.asyncResolved = true;
                const { vnode: vnode2 } = instance;
                $0a6cc4ba868319ae$var$handleSetupResult(instance, asyncSetupResult, false);
                if (hydratedEl) vnode2.el = hydratedEl;
                const placeholder = !hydratedEl && instance.subTree.el;
                setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
                // if this is not a hydration, instance.subTree will be the comment
                // placeholder.
                parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
                // consider the comment placeholder case.
                hydratedEl ? null : next(instance.subTree), suspense, namespace, optimized2);
                if (placeholder) {
                    vnode2.placeholder = null;
                    remove(placeholder);
                }
                $0a6cc4ba868319ae$var$updateHOCHostEl(instance, vnode2.el);
                if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
            });
        },
        unmount (parentSuspense2, doRemove) {
            suspense.isUnmounted = true;
            if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
            if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
        }
    };
    return suspense;
}
function $0a6cc4ba868319ae$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, namespace, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    const suspense = vnode.suspense = $0a6cc4ba868319ae$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, // eslint-disable-next-line no-restricted-globals
    document.createElement("div"), null, namespace, slotScopeIds, optimized, rendererInternals, true);
    const result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $0a6cc4ba868319ae$var$normalizeSuspenseChildren(vnode) {
    const { shapeFlag: shapeFlag, children: children } = vnode;
    const isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $0a6cc4ba868319ae$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $0a6cc4ba868319ae$var$normalizeSuspenseSlot(children.fallback) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
}
function $0a6cc4ba868319ae$var$normalizeSuspenseSlot(s) {
    let block;
    if ((0, $8POXm.isFunction)(s)) {
        const trackBlock = $0a6cc4ba868319ae$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $0a6cc4ba868319ae$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $0a6cc4ba868319ae$var$currentBlock;
            $0a6cc4ba868319ae$var$closeBlock();
        }
    }
    if ((0, $8POXm.isArray)(s)) {
        const singleChild = $0a6cc4ba868319ae$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $0a6cc4ba868319ae$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter((c)=>c !== s);
    return s;
}
function $0a6cc4ba868319ae$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        if ((0, $8POXm.isArray)(fn)) suspense.effects.push(...fn);
        else suspense.effects.push(fn);
    } else $0a6cc4ba868319ae$export$59536a0199721cab(fn);
}
function $0a6cc4ba868319ae$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    const { vnode: vnode, parentComponent: parentComponent } = suspense;
    let el = branch.el;
    while(!el && branch.component){
        branch = branch.component.subTree;
        el = branch.el;
    }
    vnode.el = el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $0a6cc4ba868319ae$var$updateHOCHostEl(parentComponent, el);
    }
}
function $0a6cc4ba868319ae$var$isVNodeSuspensible(vnode) {
    const suspensible = vnode.props && vnode.props.suspensible;
    return suspensible != null && suspensible !== false;
}
const $0a6cc4ba868319ae$export$ffb0004e005737fa = /* @__PURE__ */ Symbol.for("v-fgt");
const $0a6cc4ba868319ae$export$5f1af8db9871e1d6 = /* @__PURE__ */ Symbol.for("v-txt");
const $0a6cc4ba868319ae$export$4d299b491347818a = /* @__PURE__ */ Symbol.for("v-cmt");
const $0a6cc4ba868319ae$export$c1b9a1d3af45b7b6 = /* @__PURE__ */ Symbol.for("v-stc");
const $0a6cc4ba868319ae$var$blockStack = [];
let $0a6cc4ba868319ae$var$currentBlock = null;
function $0a6cc4ba868319ae$export$e7eaa45e502fe5cc(disableTracking = false) {
    $0a6cc4ba868319ae$var$blockStack.push($0a6cc4ba868319ae$var$currentBlock = disableTracking ? null : []);
}
function $0a6cc4ba868319ae$var$closeBlock() {
    $0a6cc4ba868319ae$var$blockStack.pop();
    $0a6cc4ba868319ae$var$currentBlock = $0a6cc4ba868319ae$var$blockStack[$0a6cc4ba868319ae$var$blockStack.length - 1] || null;
}
let $0a6cc4ba868319ae$var$isBlockTreeEnabled = 1;
function $0a6cc4ba868319ae$export$c20bee82f26f1e27(value, inVOnce = false) {
    $0a6cc4ba868319ae$var$isBlockTreeEnabled += value;
    if (value < 0 && $0a6cc4ba868319ae$var$currentBlock && inVOnce) $0a6cc4ba868319ae$var$currentBlock.hasOnce = true;
}
function $0a6cc4ba868319ae$var$setupBlock(vnode) {
    vnode.dynamicChildren = $0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 ? $0a6cc4ba868319ae$var$currentBlock || (0, $8POXm.EMPTY_ARR) : null;
    $0a6cc4ba868319ae$var$closeBlock();
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
function $0a6cc4ba868319ae$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $0a6cc4ba868319ae$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $0a6cc4ba868319ae$var$setupBlock($0a6cc4ba868319ae$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $0a6cc4ba868319ae$export$3868d13f8734ae81(value) {
    return value ? value.__v_isVNode === true : false;
}
function $0a6cc4ba868319ae$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
let $0a6cc4ba868319ae$var$vnodeArgsTransformer;
function $0a6cc4ba868319ae$export$83beccd3afeeb809(transformer) {
    $0a6cc4ba868319ae$var$vnodeArgsTransformer = transformer;
}
const $0a6cc4ba868319ae$var$createVNodeWithArgsTransform = (...args)=>{
    return $0a6cc4ba868319ae$var$_createVNode(...$0a6cc4ba868319ae$var$vnodeArgsTransformer ? $0a6cc4ba868319ae$var$vnodeArgsTransformer(args, $0a6cc4ba868319ae$var$currentRenderingInstance) : args);
};
const $0a6cc4ba868319ae$var$normalizeKey = ({ key: key })=>key != null ? key : null;
const $0a6cc4ba868319ae$var$normalizeRef = ({ ref: ref, ref_key: ref_key, ref_for: ref_for })=>{
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $8POXm.isString)(ref) || (0, $01W3b.isRef)(ref) || (0, $8POXm.isFunction)(ref) ? {
        i: $0a6cc4ba868319ae$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props = null, children = null, patchFlag = 0, dynamicProps = null, shapeFlag = type === $0a6cc4ba868319ae$export$ffb0004e005737fa ? 0 : 1, isBlockNode = false, needFullChildrenNormalization = false) {
    const vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $0a6cc4ba868319ae$var$normalizeKey(props),
        ref: props && $0a6cc4ba868319ae$var$normalizeRef(props),
        scopeId: $0a6cc4ba868319ae$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetStart: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $0a6cc4ba868319ae$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $8POXm.isString)(children) ? 8 : 16;
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $0a6cc4ba868319ae$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $0a6cc4ba868319ae$var$currentBlock.push(vnode);
    return vnode;
}
const $0a6cc4ba868319ae$export$bf5c4cf060303d58 = $0a6cc4ba868319ae$var$_createVNode;
function $0a6cc4ba868319ae$var$_createVNode(type, props = null, children = null, patchFlag = 0, dynamicProps = null, isBlockNode = false) {
    if (!type || type === $0a6cc4ba868319ae$var$NULL_DYNAMIC_COMPONENT) type = $0a6cc4ba868319ae$export$4d299b491347818a;
    if ($0a6cc4ba868319ae$export$3868d13f8734ae81(type)) {
        const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $0a6cc4ba868319ae$var$normalizeChildren(cloned, children);
        if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && !isBlockNode && $0a6cc4ba868319ae$var$currentBlock) {
            if (cloned.shapeFlag & 6) $0a6cc4ba868319ae$var$currentBlock[$0a6cc4ba868319ae$var$currentBlock.indexOf(type)] = cloned;
            else $0a6cc4ba868319ae$var$currentBlock.push(cloned);
        }
        cloned.patchFlag = -2;
        return cloned;
    }
    if ($0a6cc4ba868319ae$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props);
        let { class: klass, style: style } = props;
        if (klass && !(0, $8POXm.isString)(klass)) props.class = (0, $8POXm.normalizeClass)(klass);
        if ((0, $8POXm.isObject)(style)) {
            if ((0, $01W3b.isProxy)(style) && !(0, $8POXm.isArray)(style)) style = (0, $8POXm.extend)({}, style);
            props.style = (0, $8POXm.normalizeStyle)(style);
        }
    }
    const shapeFlag = (0, $8POXm.isString)(type) ? 1 : $0a6cc4ba868319ae$var$isSuspense(type) ? 128 : $0a6cc4ba868319ae$var$isTeleport(type) ? 64 : (0, $8POXm.isObject)(type) ? 4 : (0, $8POXm.isFunction)(type) ? 2 : 0;
    return $0a6cc4ba868319ae$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $0a6cc4ba868319ae$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $01W3b.isProxy)(props) || $0a6cc4ba868319ae$var$isInternalObject(props) ? (0, $8POXm.extend)({}, props) : props;
}
function $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode, extraProps, mergeRef = false, cloneTransition = false) {
    const { props: props, ref: ref, patchFlag: patchFlag, children: children, transition: transition } = vnode;
    const mergedProps = extraProps ? $0a6cc4ba868319ae$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    const cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $0a6cc4ba868319ae$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $8POXm.isArray)(ref) ? ref.concat($0a6cc4ba868319ae$var$normalizeRef(extraProps)) : [
            ref,
            $0a6cc4ba868319ae$var$normalizeRef(extraProps)
        ] : $0a6cc4ba868319ae$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetStart: vnode.targetStart,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $0a6cc4ba868319ae$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        placeholder: vnode.placeholder,
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    if (transition && cloneTransition) $0a6cc4ba868319ae$export$7770a22486565649(cloned, transition.clone(cloned));
    return cloned;
}
function $0a6cc4ba868319ae$var$deepCloneVNode(vnode) {
    const cloned = $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $8POXm.isArray)(vnode.children)) cloned.children = vnode.children.map($0a6cc4ba868319ae$var$deepCloneVNode);
    return cloned;
}
function $0a6cc4ba868319ae$export$22f9b5ffd89dac9(text = " ", flag = 0) {
    return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, text, flag);
}
function $0a6cc4ba868319ae$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    const vnode = $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $0a6cc4ba868319ae$export$49553837c7236d3c(text = "", asBlock = false) {
    return asBlock ? ($0a6cc4ba868319ae$export$e7eaa45e502fe5cc(), $0a6cc4ba868319ae$export$9f2dfe8048dfb22b($0a6cc4ba868319ae$export$4d299b491347818a, null, text)) : $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a, null, text);
}
function $0a6cc4ba868319ae$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$4d299b491347818a);
    else if ((0, $8POXm.isArray)(child)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if ($0a6cc4ba868319ae$export$3868d13f8734ae81(child)) return $0a6cc4ba868319ae$var$cloneIfMounted(child);
    else return $0a6cc4ba868319ae$export$bf5c4cf060303d58($0a6cc4ba868319ae$export$5f1af8db9871e1d6, null, String(child));
}
function $0a6cc4ba868319ae$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $0a6cc4ba868319ae$export$ee4f9e12c0a92a1a(child);
}
function $0a6cc4ba868319ae$var$normalizeChildren(vnode, children) {
    let type = 0;
    const { shapeFlag: shapeFlag } = vnode;
    if (children == null) children = null;
    else if ((0, $8POXm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            const slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $0a6cc4ba868319ae$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            const slotFlag = children._;
            if (!slotFlag && !$0a6cc4ba868319ae$var$isInternalObject(children)) children._ctx = $0a6cc4ba868319ae$var$currentRenderingInstance;
            else if (slotFlag === 3 && $0a6cc4ba868319ae$var$currentRenderingInstance) {
                if ($0a6cc4ba868319ae$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $8POXm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $0a6cc4ba868319ae$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $0a6cc4ba868319ae$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $0a6cc4ba868319ae$export$9d1611c77c2fe928(...args) {
    const ret = {};
    for(let i = 0; i < args.length; i++){
        const toMerge = args[i];
        for(const key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $8POXm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $8POXm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $8POXm.isOn)(key)) {
                const existing = ret[key];
                const incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $8POXm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $0a6cc4ba868319ae$var$invokeVNodeHook(hook, instance, vnode, prevVNode = null) {
    $0a6cc4ba868319ae$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
const $0a6cc4ba868319ae$var$emptyAppContext = $0a6cc4ba868319ae$var$createAppContext();
let $0a6cc4ba868319ae$var$uid = 0;
function $0a6cc4ba868319ae$var$createComponentInstance(vnode, parent, suspense) {
    const type = vnode.type;
    const appContext = (parent ? parent.appContext : vnode.appContext) || $0a6cc4ba868319ae$var$emptyAppContext;
    const instance = {
        uid: $0a6cc4ba868319ae$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        job: null,
        scope: new (0, $01W3b.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        ids: parent ? parent.ids : [
            "",
            0,
            0
        ],
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $0a6cc4ba868319ae$var$normalizePropsOptions(type, appContext),
        emitsOptions: $0a6cc4ba868319ae$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $8POXm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $8POXm.EMPTY_OBJ),
        data: (0, $8POXm.EMPTY_OBJ),
        props: (0, $8POXm.EMPTY_OBJ),
        attrs: (0, $8POXm.EMPTY_OBJ),
        slots: (0, $8POXm.EMPTY_OBJ),
        refs: (0, $8POXm.EMPTY_OBJ),
        setupState: (0, $8POXm.EMPTY_OBJ),
        setupContext: null,
        suspense: // suspense related
        suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $0a6cc4ba868319ae$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
let $0a6cc4ba868319ae$var$currentInstance = null;
const $0a6cc4ba868319ae$export$f13e630aa3915748 = ()=>$0a6cc4ba868319ae$var$currentInstance || $0a6cc4ba868319ae$var$currentRenderingInstance;
let $0a6cc4ba868319ae$var$internalSetCurrentInstance;
let $0a6cc4ba868319ae$var$setInSSRSetupState;
{
    const g = (0, $8POXm.getGlobalThis)();
    const registerGlobalSetter = (key, setter)=>{
        let setters;
        if (!(setters = g[key])) setters = g[key] = [];
        setters.push(setter);
        return (v1)=>{
            if (setters.length > 1) setters.forEach((set)=>set(v1));
            else setters[0](v1);
        };
    };
    $0a6cc4ba868319ae$var$internalSetCurrentInstance = registerGlobalSetter(`__VUE_INSTANCE_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$currentInstance = v1);
    $0a6cc4ba868319ae$var$setInSSRSetupState = registerGlobalSetter(`__VUE_SSR_SETTERS__`, (v1)=>$0a6cc4ba868319ae$var$isInSSRComponentSetup = v1);
}const $0a6cc4ba868319ae$var$setCurrentInstance = (instance)=>{
    const prev = $0a6cc4ba868319ae$var$currentInstance;
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(instance);
    instance.scope.on();
    return ()=>{
        instance.scope.off();
        $0a6cc4ba868319ae$var$internalSetCurrentInstance(prev);
    };
};
const $0a6cc4ba868319ae$var$unsetCurrentInstance = ()=>{
    $0a6cc4ba868319ae$var$currentInstance && $0a6cc4ba868319ae$var$currentInstance.scope.off();
    $0a6cc4ba868319ae$var$internalSetCurrentInstance(null);
};
const $0a6cc4ba868319ae$var$isBuiltInTag = /* @__PURE__ */ (0, $8POXm.makeMap)("slot,component");
function $0a6cc4ba868319ae$var$validateComponentName(name, { isNativeTag: isNativeTag }) {
    if ($0a6cc4ba868319ae$var$isBuiltInTag(name) || isNativeTag(name)) $0a6cc4ba868319ae$var$warn$1("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $0a6cc4ba868319ae$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
let $0a6cc4ba868319ae$var$isInSSRComponentSetup = false;
function $0a6cc4ba868319ae$var$setupComponent(instance, isSSR = false, optimized = false) {
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(isSSR);
    const { props: props, children: children } = instance.vnode;
    const isStateful = $0a6cc4ba868319ae$var$isStatefulComponent(instance);
    $0a6cc4ba868319ae$var$initProps(instance, props, isStateful, isSSR);
    $0a6cc4ba868319ae$var$initSlots(instance, children, optimized || isSSR);
    const setupResult = isStateful ? $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) : void 0;
    isSSR && $0a6cc4ba868319ae$var$setInSSRSetupState(false);
    return setupResult;
}
function $0a6cc4ba868319ae$var$setupStatefulComponent(instance, isSSR) {
    const Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = new Proxy(instance.ctx, $0a6cc4ba868319ae$var$PublicInstanceProxyHandlers);
    const { setup: setup } = Component;
    if (setup) {
        (0, $01W3b.pauseTracking)();
        const setupContext = instance.setupContext = setup.length > 1 ? $0a6cc4ba868319ae$var$createSetupContext(instance) : null;
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        const setupResult = $0a6cc4ba868319ae$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        const isAsyncSetup = (0, $8POXm.isPromise)(setupResult);
        (0, $01W3b.resetTracking)();
        reset();
        if ((isAsyncSetup || instance.sp) && !$0a6cc4ba868319ae$var$isAsyncWrapper(instance)) $0a6cc4ba868319ae$var$markAsyncBoundary(instance);
        if (isAsyncSetup) {
            setupResult.then($0a6cc4ba868319ae$var$unsetCurrentInstance, $0a6cc4ba868319ae$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then((resolvedResult)=>{
                $0a6cc4ba868319ae$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch((e)=>{
                $0a6cc4ba868319ae$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR);
    } else $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
function $0a6cc4ba868319ae$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $8POXm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $8POXm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $01W3b.proxyRefs)(setupResult);
    }
    $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR);
}
let $0a6cc4ba868319ae$var$compile;
let $0a6cc4ba868319ae$var$installWithProxy;
function $0a6cc4ba868319ae$export$667bb5a67822b941(_compile) {
    $0a6cc4ba868319ae$var$compile = _compile;
    $0a6cc4ba868319ae$var$installWithProxy = (i)=>{
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $0a6cc4ba868319ae$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
const $0a6cc4ba868319ae$export$c93a9c496c5211fa = ()=>!$0a6cc4ba868319ae$var$compile;
function $0a6cc4ba868319ae$var$finishComponentSetup(instance, isSSR, skipOptions) {
    const Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $0a6cc4ba868319ae$var$compile && !Component.render) {
            const template = Component.template || __VUE_OPTIONS_API__ && $0a6cc4ba868319ae$var$resolveMergedOptions(instance).template;
            if (template) {
                const { isCustomElement: isCustomElement, compilerOptions: compilerOptions } = instance.appContext.config;
                const { delimiters: delimiters, compilerOptions: componentCompilerOptions } = Component;
                const finalCompilerOptions = (0, $8POXm.extend)((0, $8POXm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $0a6cc4ba868319ae$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $8POXm.NOOP);
        if ($0a6cc4ba868319ae$var$installWithProxy) $0a6cc4ba868319ae$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        const reset = $0a6cc4ba868319ae$var$setCurrentInstance(instance);
        (0, $01W3b.pauseTracking)();
        try {
            $0a6cc4ba868319ae$var$applyOptions(instance);
        } finally{
            (0, $01W3b.resetTracking)();
            reset();
        }
    }
}
const $0a6cc4ba868319ae$var$attrsProxyHandlers = {
    get (target, key) {
        (0, $01W3b.track)(target, "get", "");
        return target[key];
    }
};
function $0a6cc4ba868319ae$var$getSlotsProxy(instance) {
    return new Proxy(instance.slots, {
        get (target, key) {
            (0, $01W3b.track)(instance, "get", "$slots");
            return target[key];
        }
    });
}
function $0a6cc4ba868319ae$var$createSetupContext(instance) {
    const expose = (exposed)=>{
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        attrs: new Proxy(instance.attrs, $0a6cc4ba868319ae$var$attrsProxyHandlers),
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $0a6cc4ba868319ae$var$getComponentPublicInstance(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $01W3b.proxyRefs)((0, $01W3b.markRaw)(instance.exposed)), {
        get (target, key) {
            if (key in target) return target[key];
            else if (key in $0a6cc4ba868319ae$var$publicPropertiesMap) return $0a6cc4ba868319ae$var$publicPropertiesMap[key](instance);
        },
        has (target, key) {
            return key in target || key in $0a6cc4ba868319ae$var$publicPropertiesMap;
        }
    }));
    else return instance.proxy;
}
const $0a6cc4ba868319ae$var$classifyRE = /(?:^|[-_])\w/g;
const $0a6cc4ba868319ae$var$classify = (str)=>str.replace($0a6cc4ba868319ae$var$classifyRE, (c)=>c.toUpperCase()).replace(/[-_]/g, "");
function $0a6cc4ba868319ae$var$getComponentName(Component, includeInferred = true) {
    return (0, $8POXm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $0a6cc4ba868319ae$var$formatComponentName(instance, Component, isRoot = false) {
    let name = $0a6cc4ba868319ae$var$getComponentName(Component);
    if (!name && Component.__file) {
        const match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance) {
        const inferFromRegistry = (registry)=>{
            for(const key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components) || instance.parent && inferFromRegistry(instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $0a6cc4ba868319ae$var$classify(name) : isRoot ? `App` : `Anonymous`;
}
function $0a6cc4ba868319ae$var$isClassComponent(value) {
    return (0, $8POXm.isFunction)(value) && "__vccOpts" in value;
}
const $0a6cc4ba868319ae$export$2983e091f1a1e8e2 = (getterOrOptions, debugOptions)=>{
    const c = (0, $01W3b.computed)(getterOrOptions, debugOptions, $0a6cc4ba868319ae$var$isInSSRComponentSetup);
    return c;
};
function $0a6cc4ba868319ae$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    try {
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(-1);
        const l = arguments.length;
        if (l === 2) {
            if ((0, $8POXm.isObject)(propsOrChildren) && !(0, $8POXm.isArray)(propsOrChildren)) {
                if ($0a6cc4ba868319ae$export$3868d13f8734ae81(propsOrChildren)) return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, [
                    propsOrChildren
                ]);
                return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren);
            } else return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, null, propsOrChildren);
        } else {
            if (l > 3) children = Array.prototype.slice.call(arguments, 2);
            else if (l === 3 && $0a6cc4ba868319ae$export$3868d13f8734ae81(children)) children = [
                children
            ];
            return $0a6cc4ba868319ae$export$bf5c4cf060303d58(type, propsOrChildren, children);
        }
    } finally{
        $0a6cc4ba868319ae$export$c20bee82f26f1e27(1);
    }
}
function $0a6cc4ba868319ae$export$aed4979be6a60047() {
    return;
    function formatInstance(instance) {
        const blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $01W3b.toRaw)(instance.props)));
        if (instance.setupState !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $8POXm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $01W3b.toRaw)(instance.data)));
        const computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        const injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    }
    function createInstanceBlock(type, target) {
        target = (0, $8POXm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                },
                ...Object.keys(target).map((key)=>{
                    return [
                        "div",
                        {},
                        [
                            "span",
                            keywordStyle,
                            key + ": "
                        ],
                        formatValue(target[key], false)
                    ];
                })
            ]
        ];
    }
    function formatValue(v1, asRaw = true) {
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $8POXm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $01W3b.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    }
    function extractKeys(instance, type) {
        const Comp = instance.type;
        if ((0, $8POXm.isFunction)(Comp)) return;
        const extracted = {};
        for(const key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    }
    function isKeyOfType(Comp, key, type) {
        const opts = Comp[type];
        if ((0, $8POXm.isArray)(opts) && opts.includes(key) || (0, $8POXm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some((m)=>isKeyOfType(m, key, type))) return true;
    }
    function genRefFlag(v1) {
        if ((0, $01W3b.isShallow)(v1)) return `ShallowRef`;
        if (v1.effect) return `ComputedRef`;
        return `Ref`;
    }
}
function $0a6cc4ba868319ae$export$2a6d714a4d738ae(memo, render, cache, index) {
    const cached = cache[index];
    if (cached && $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo)) return cached;
    const ret = render();
    ret.memo = memo.slice();
    ret.cacheIndex = index;
    return cache[index] = ret;
}
function $0a6cc4ba868319ae$export$bf525184d622787c(cached, memo) {
    const prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(let i = 0; i < prev.length; i++){
        if ((0, $8POXm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($0a6cc4ba868319ae$var$isBlockTreeEnabled > 0 && $0a6cc4ba868319ae$var$currentBlock) $0a6cc4ba868319ae$var$currentBlock.push(cached);
    return true;
}
const $0a6cc4ba868319ae$export$83d89fbfd8236492 = "3.5.28";
const $0a6cc4ba868319ae$export$c106dd0671a0fc2d = (0, $8POXm.NOOP);
const $0a6cc4ba868319ae$export$795e0ad4a0e2ed30 = $0a6cc4ba868319ae$var$ErrorTypeStrings$1;
const $0a6cc4ba868319ae$export$6922d3b3a607469e = $0a6cc4ba868319ae$var$devtools$1;
const $0a6cc4ba868319ae$export$b0c258b32c26c785 = $0a6cc4ba868319ae$var$setDevtoolsHook$1;
const $0a6cc4ba868319ae$var$_ssrUtils = {
    createComponentInstance: $0a6cc4ba868319ae$var$createComponentInstance,
    setupComponent: $0a6cc4ba868319ae$var$setupComponent,
    renderComponentRoot: $0a6cc4ba868319ae$var$renderComponentRoot,
    setCurrentRenderingInstance: $0a6cc4ba868319ae$var$setCurrentRenderingInstance,
    isVNode: $0a6cc4ba868319ae$export$3868d13f8734ae81,
    normalizeVNode: $0a6cc4ba868319ae$var$normalizeVNode,
    getComponentPublicInstance: $0a6cc4ba868319ae$var$getComponentPublicInstance,
    ensureValidVNode: $0a6cc4ba868319ae$var$ensureValidVNode,
    pushWarningContext: $0a6cc4ba868319ae$var$pushWarningContext,
    popWarningContext: $0a6cc4ba868319ae$var$popWarningContext
};
const $0a6cc4ba868319ae$export$a9679033567b336d = $0a6cc4ba868319ae$var$_ssrUtils;
const $0a6cc4ba868319ae$export$83cf26e06ea620e1 = null;
const $0a6cc4ba868319ae$export$dc678eddf276286e = null;
const $0a6cc4ba868319ae$export$22072a82865312f6 = null;

});
parcelRegister("01W3b", function(module, exports) {

$parcel$export(module.exports, "EffectScope", () => $005d1fb7704e278c$export$1168ed9dbc71ddbd);
$parcel$export(module.exports, "effectScope", () => $005d1fb7704e278c$export$7056603ea81600be);
$parcel$export(module.exports, "getCurrentScope", () => $005d1fb7704e278c$export$c7be4b0125a10cba);
$parcel$export(module.exports, "onScopeDispose", () => $005d1fb7704e278c$export$a780418acd4762da);
$parcel$export(module.exports, "ReactiveEffect", () => $005d1fb7704e278c$export$28352bb4dd362521);
$parcel$export(module.exports, "pauseTracking", () => $005d1fb7704e278c$export$938a971395fef855);
$parcel$export(module.exports, "resetTracking", () => $005d1fb7704e278c$export$c39176b1babaa8b8);
$parcel$export(module.exports, "track", () => $005d1fb7704e278c$export$6b2a7d5132615086);
$parcel$export(module.exports, "trigger", () => $005d1fb7704e278c$export$e614dc9140f7ae71);
$parcel$export(module.exports, "toRaw", () => $005d1fb7704e278c$export$ab18938b9fc5f28e);
$parcel$export(module.exports, "isShallow", () => $005d1fb7704e278c$export$7f3fe6025abfa26e);
$parcel$export(module.exports, "toReactive", () => $005d1fb7704e278c$export$45c769cf449a508c);
$parcel$export(module.exports, "shallowReadArray", () => $005d1fb7704e278c$export$5eb48af14254449e);
$parcel$export(module.exports, "isReadonly", () => $005d1fb7704e278c$export$92d09b48637741e7);
$parcel$export(module.exports, "isReactive", () => $005d1fb7704e278c$export$352205f445242f02);
$parcel$export(module.exports, "toReadonly", () => $005d1fb7704e278c$export$4a78e7a2a4fb689f);
$parcel$export(module.exports, "isProxy", () => $005d1fb7704e278c$export$5f3ca29d057519b3);
$parcel$export(module.exports, "isRef", () => $005d1fb7704e278c$export$4f9f5282de18fc69);
$parcel$export(module.exports, "readonly", () => $005d1fb7704e278c$export$6ec456bd5b7b3c51);
$parcel$export(module.exports, "reactive", () => $005d1fb7704e278c$export$90a44edba14e47be);
$parcel$export(module.exports, "shallowReactive", () => $005d1fb7704e278c$export$8d81cefd22d22260);
$parcel$export(module.exports, "markRaw", () => $005d1fb7704e278c$export$995ab8b13ad7a9d0);
$parcel$export(module.exports, "ref", () => $005d1fb7704e278c$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "shallowRef", () => $005d1fb7704e278c$export$9b7bc5fe3b17c8b3);
$parcel$export(module.exports, "unref", () => $005d1fb7704e278c$export$a239a76781616204);
$parcel$export(module.exports, "toValue", () => $005d1fb7704e278c$export$30bdcc2218aa9458);
$parcel$export(module.exports, "proxyRefs", () => $005d1fb7704e278c$export$f353fd1b97db3fa0);
$parcel$export(module.exports, "customRef", () => $005d1fb7704e278c$export$a20c2dd6199824cb);
$parcel$export(module.exports, "toRefs", () => $005d1fb7704e278c$export$2e9533675e5e70e0);
$parcel$export(module.exports, "toRef", () => $005d1fb7704e278c$export$1f60508e4f47b4b7);
$parcel$export(module.exports, "computed", () => $005d1fb7704e278c$export$2983e091f1a1e8e2);
$parcel$export(module.exports, "watch", () => $005d1fb7704e278c$export$3db5d71bdb2d5499);
$parcel$export(module.exports, "traverse", () => $005d1fb7704e278c$export$df3f009e3d155b20);
/**
* @vue/reactivity v3.5.28
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $8POXm = parcelRequire("8POXm");
function $005d1fb7704e278c$var$warn(msg, ...args) {
    console.warn(`[Vue warn] ${msg}`, ...args);
}
let $005d1fb7704e278c$var$activeEffectScope;
class $005d1fb7704e278c$export$1168ed9dbc71ddbd {
    // TODO isolatedDeclarations "__v_skip"
    constructor(detached = false){
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal track `on` calls, allow `on` call multiple times
     */ this._on = 0;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this._isPaused = false;
        this.__v_skip = true;
        this.parent = $005d1fb7704e278c$var$activeEffectScope;
        if (!detached && $005d1fb7704e278c$var$activeEffectScope) this.index = ($005d1fb7704e278c$var$activeEffectScope.scopes || ($005d1fb7704e278c$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    get active() {
        return this._active;
    }
    pause() {
        if (this._active) {
            this._isPaused = true;
            let i, l;
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].pause();
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].pause();
        }
    }
    /**
   * Resumes the effect scope, including all child scopes and effects.
   */ resume() {
        if (this._active) {
            if (this._isPaused) {
                this._isPaused = false;
                let i, l;
                if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].resume();
                for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].resume();
            }
        }
    }
    run(fn) {
        if (this._active) {
            const currentEffectScope = $005d1fb7704e278c$var$activeEffectScope;
            try {
                $005d1fb7704e278c$var$activeEffectScope = this;
                return fn();
            } finally{
                $005d1fb7704e278c$var$activeEffectScope = currentEffectScope;
            }
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ on() {
        if (++this._on === 1) {
            this.prevScope = $005d1fb7704e278c$var$activeEffectScope;
            $005d1fb7704e278c$var$activeEffectScope = this;
        }
    }
    /**
   * This should only be called on non-detached scopes
   * @internal
   */ off() {
        if (this._on > 0 && --this._on === 0) {
            $005d1fb7704e278c$var$activeEffectScope = this.prevScope;
            this.prevScope = void 0;
        }
    }
    stop(fromParent) {
        if (this._active) {
            this._active = false;
            let i, l;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
            this.effects.length = 0;
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            this.cleanups.length = 0;
            if (this.scopes) {
                for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                this.scopes.length = 0;
            }
            if (!this.detached && this.parent && !fromParent) {
                const last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = void 0;
        }
    }
}
function $005d1fb7704e278c$export$7056603ea81600be(detached) {
    return new $005d1fb7704e278c$export$1168ed9dbc71ddbd(detached);
}
function $005d1fb7704e278c$export$c7be4b0125a10cba() {
    return $005d1fb7704e278c$var$activeEffectScope;
}
function $005d1fb7704e278c$export$a780418acd4762da(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeEffectScope) $005d1fb7704e278c$var$activeEffectScope.cleanups.push(fn);
}
let $005d1fb7704e278c$var$activeSub;
const $005d1fb7704e278c$export$37ee493b2f34ee54 = {
    "ACTIVE": 1,
    "1": "ACTIVE",
    "RUNNING": 2,
    "2": "RUNNING",
    "TRACKING": 4,
    "4": "TRACKING",
    "NOTIFIED": 8,
    "8": "NOTIFIED",
    "DIRTY": 16,
    "16": "DIRTY",
    "ALLOW_RECURSE": 32,
    "32": "ALLOW_RECURSE",
    "PAUSED": 64,
    "64": "PAUSED",
    "EVALUATED": 128,
    "128": "EVALUATED"
};
const $005d1fb7704e278c$var$pausedQueueEffects = /* @__PURE__ */ new WeakSet();
class $005d1fb7704e278c$export$28352bb4dd362521 {
    constructor(fn){
        this.fn = fn;
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 5;
        /**
     * @internal
     */ this.next = void 0;
        /**
     * @internal
     */ this.cleanup = void 0;
        this.scheduler = void 0;
        if ($005d1fb7704e278c$var$activeEffectScope && $005d1fb7704e278c$var$activeEffectScope.active) $005d1fb7704e278c$var$activeEffectScope.effects.push(this);
    }
    pause() {
        this.flags |= 64;
    }
    resume() {
        if (this.flags & 64) {
            this.flags &= -65;
            if ($005d1fb7704e278c$var$pausedQueueEffects.has(this)) {
                $005d1fb7704e278c$var$pausedQueueEffects.delete(this);
                this.trigger();
            }
        }
    }
    /**
   * @internal
   */ notify() {
        if (this.flags & 2 && !(this.flags & 32)) return;
        if (!(this.flags & 8)) $005d1fb7704e278c$var$batch(this);
    }
    run() {
        if (!(this.flags & 1)) return this.fn();
        this.flags |= 2;
        $005d1fb7704e278c$var$cleanupEffect(this);
        $005d1fb7704e278c$var$prepareDeps(this);
        const prevEffect = $005d1fb7704e278c$var$activeSub;
        const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
        $005d1fb7704e278c$var$activeSub = this;
        $005d1fb7704e278c$var$shouldTrack = true;
        try {
            return this.fn();
        } finally{
            $005d1fb7704e278c$var$cleanupDeps(this);
            $005d1fb7704e278c$var$activeSub = prevEffect;
            $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
            this.flags &= -3;
        }
    }
    stop() {
        if (this.flags & 1) {
            for(let link = this.deps; link; link = link.nextDep)$005d1fb7704e278c$var$removeSub(link);
            this.deps = this.depsTail = void 0;
            $005d1fb7704e278c$var$cleanupEffect(this);
            this.onStop && this.onStop();
            this.flags &= -2;
        }
    }
    trigger() {
        if (this.flags & 64) $005d1fb7704e278c$var$pausedQueueEffects.add(this);
        else if (this.scheduler) this.scheduler();
        else this.runIfDirty();
    }
    /**
   * @internal
   */ runIfDirty() {
        if ($005d1fb7704e278c$var$isDirty(this)) this.run();
    }
    get dirty() {
        return $005d1fb7704e278c$var$isDirty(this);
    }
}
let $005d1fb7704e278c$var$batchDepth = 0;
let $005d1fb7704e278c$var$batchedSub;
let $005d1fb7704e278c$var$batchedComputed;
function $005d1fb7704e278c$var$batch(sub, isComputed = false) {
    sub.flags |= 8;
    if (isComputed) {
        sub.next = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = sub;
        return;
    }
    sub.next = $005d1fb7704e278c$var$batchedSub;
    $005d1fb7704e278c$var$batchedSub = sub;
}
function $005d1fb7704e278c$var$startBatch() {
    $005d1fb7704e278c$var$batchDepth++;
}
function $005d1fb7704e278c$var$endBatch() {
    if (--$005d1fb7704e278c$var$batchDepth > 0) return;
    if ($005d1fb7704e278c$var$batchedComputed) {
        let e = $005d1fb7704e278c$var$batchedComputed;
        $005d1fb7704e278c$var$batchedComputed = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            e = next;
        }
    }
    let error;
    while($005d1fb7704e278c$var$batchedSub){
        let e = $005d1fb7704e278c$var$batchedSub;
        $005d1fb7704e278c$var$batchedSub = void 0;
        while(e){
            const next = e.next;
            e.next = void 0;
            e.flags &= -9;
            if (e.flags & 1) try {
                e.trigger();
            } catch (err) {
                if (!error) error = err;
            }
            e = next;
        }
    }
    if (error) throw error;
}
function $005d1fb7704e278c$var$prepareDeps(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        link.version = -1;
        link.prevActiveLink = link.dep.activeLink;
        link.dep.activeLink = link;
    }
}
function $005d1fb7704e278c$var$cleanupDeps(sub) {
    let head;
    let tail = sub.depsTail;
    let link = tail;
    while(link){
        const prev = link.prevDep;
        if (link.version === -1) {
            if (link === tail) tail = prev;
            $005d1fb7704e278c$var$removeSub(link);
            $005d1fb7704e278c$var$removeDep(link);
        } else head = link;
        link.dep.activeLink = link.prevActiveLink;
        link.prevActiveLink = void 0;
        link = prev;
    }
    sub.deps = head;
    sub.depsTail = tail;
}
function $005d1fb7704e278c$var$isDirty(sub) {
    for(let link = sub.deps; link; link = link.nextDep){
        if (link.dep.version !== link.version || link.dep.computed && ($005d1fb7704e278c$var$refreshComputed(link.dep.computed) || link.dep.version !== link.version)) return true;
    }
    if (sub._dirty) return true;
    return false;
}
function $005d1fb7704e278c$var$refreshComputed(computed) {
    if (computed.flags & 4 && !(computed.flags & 16)) return;
    computed.flags &= -17;
    if (computed.globalVersion === $005d1fb7704e278c$var$globalVersion) return;
    computed.globalVersion = $005d1fb7704e278c$var$globalVersion;
    if (!computed.isSSR && computed.flags & 128 && (!computed.deps && !computed._dirty || !$005d1fb7704e278c$var$isDirty(computed))) return;
    computed.flags |= 2;
    const dep = computed.dep;
    const prevSub = $005d1fb7704e278c$var$activeSub;
    const prevShouldTrack = $005d1fb7704e278c$var$shouldTrack;
    $005d1fb7704e278c$var$activeSub = computed;
    $005d1fb7704e278c$var$shouldTrack = true;
    try {
        $005d1fb7704e278c$var$prepareDeps(computed);
        const value = computed.fn(computed._value);
        if (dep.version === 0 || (0, $8POXm.hasChanged)(value, computed._value)) {
            computed.flags |= 128;
            computed._value = value;
            dep.version++;
        }
    } catch (err) {
        dep.version++;
        throw err;
    } finally{
        $005d1fb7704e278c$var$activeSub = prevSub;
        $005d1fb7704e278c$var$shouldTrack = prevShouldTrack;
        $005d1fb7704e278c$var$cleanupDeps(computed);
        computed.flags &= -3;
    }
}
function $005d1fb7704e278c$var$removeSub(link, soft = false) {
    const { dep: dep, prevSub: prevSub, nextSub: nextSub } = link;
    if (prevSub) {
        prevSub.nextSub = nextSub;
        link.prevSub = void 0;
    }
    if (nextSub) {
        nextSub.prevSub = prevSub;
        link.nextSub = void 0;
    }
    if (dep.subs === link) {
        dep.subs = prevSub;
        if (!prevSub && dep.computed) {
            dep.computed.flags &= -5;
            for(let l = dep.computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$removeSub(l, true);
        }
    }
    if (!soft && !--dep.sc && dep.map) dep.map.delete(dep.key);
}
function $005d1fb7704e278c$var$removeDep(link) {
    const { prevDep: prevDep, nextDep: nextDep } = link;
    if (prevDep) {
        prevDep.nextDep = nextDep;
        link.prevDep = void 0;
    }
    if (nextDep) {
        nextDep.prevDep = prevDep;
        link.nextDep = void 0;
    }
}
function $005d1fb7704e278c$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect instanceof $005d1fb7704e278c$export$28352bb4dd362521) fn = fn.effect.fn;
    const e = new $005d1fb7704e278c$export$28352bb4dd362521(fn);
    if (options) (0, $8POXm.extend)(e, options);
    try {
        e.run();
    } catch (err) {
        e.stop();
        throw err;
    }
    const runner = e.run.bind(e);
    runner.effect = e;
    return runner;
}
function $005d1fb7704e278c$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
let $005d1fb7704e278c$var$shouldTrack = true;
const $005d1fb7704e278c$var$trackStack = [];
function $005d1fb7704e278c$export$938a971395fef855() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = false;
}
function $005d1fb7704e278c$export$1f8ffc6fd33b1d16() {
    $005d1fb7704e278c$var$trackStack.push($005d1fb7704e278c$var$shouldTrack);
    $005d1fb7704e278c$var$shouldTrack = true;
}
function $005d1fb7704e278c$export$c39176b1babaa8b8() {
    const last = $005d1fb7704e278c$var$trackStack.pop();
    $005d1fb7704e278c$var$shouldTrack = last === void 0 ? true : last;
}
function $005d1fb7704e278c$export$92b6a62b33d94031(fn, failSilently = false) {
    if ($005d1fb7704e278c$var$activeSub instanceof $005d1fb7704e278c$export$28352bb4dd362521) $005d1fb7704e278c$var$activeSub.cleanup = fn;
}
function $005d1fb7704e278c$var$cleanupEffect(e) {
    const { cleanup: cleanup } = e;
    e.cleanup = void 0;
    if (cleanup) {
        const prevSub = $005d1fb7704e278c$var$activeSub;
        $005d1fb7704e278c$var$activeSub = void 0;
        try {
            cleanup();
        } finally{
            $005d1fb7704e278c$var$activeSub = prevSub;
        }
    }
}
let $005d1fb7704e278c$var$globalVersion = 0;
class $005d1fb7704e278c$var$Link {
    constructor(sub, dep){
        this.sub = sub;
        this.dep = dep;
        this.version = dep.version;
        this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
    }
}
class $005d1fb7704e278c$var$Dep {
    // TODO isolatedDeclarations "__v_skip"
    constructor(computed){
        this.computed = computed;
        this.version = 0;
        /**
     * Link between this dep and the current active effect
     */ this.activeLink = void 0;
        /**
     * Doubly linked list representing the subscribing effects (tail)
     */ this.subs = void 0;
        /**
     * For object property deps cleanup
     */ this.map = void 0;
        this.key = void 0;
        /**
     * Subscriber counter
     */ this.sc = 0;
        /**
     * @internal
     */ this.__v_skip = true;
    }
    track(debugInfo) {
        if (!$005d1fb7704e278c$var$activeSub || !$005d1fb7704e278c$var$shouldTrack || $005d1fb7704e278c$var$activeSub === this.computed) return;
        let link = this.activeLink;
        if (link === void 0 || link.sub !== $005d1fb7704e278c$var$activeSub) {
            link = this.activeLink = new $005d1fb7704e278c$var$Link($005d1fb7704e278c$var$activeSub, this);
            if (!$005d1fb7704e278c$var$activeSub.deps) $005d1fb7704e278c$var$activeSub.deps = $005d1fb7704e278c$var$activeSub.depsTail = link;
            else {
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
            }
            $005d1fb7704e278c$var$addSub(link);
        } else if (link.version === -1) {
            link.version = this.version;
            if (link.nextDep) {
                const next = link.nextDep;
                next.prevDep = link.prevDep;
                if (link.prevDep) link.prevDep.nextDep = next;
                link.prevDep = $005d1fb7704e278c$var$activeSub.depsTail;
                link.nextDep = void 0;
                $005d1fb7704e278c$var$activeSub.depsTail.nextDep = link;
                $005d1fb7704e278c$var$activeSub.depsTail = link;
                if ($005d1fb7704e278c$var$activeSub.deps === link) $005d1fb7704e278c$var$activeSub.deps = next;
            }
        }
        return link;
    }
    trigger(debugInfo) {
        this.version++;
        $005d1fb7704e278c$var$globalVersion++;
        this.notify(debugInfo);
    }
    notify(debugInfo) {
        $005d1fb7704e278c$var$startBatch();
        try {
            for(let link = this.subs; link; link = link.prevSub)if (link.sub.notify()) link.sub.dep.notify();
        } finally{
            $005d1fb7704e278c$var$endBatch();
        }
    }
}
function $005d1fb7704e278c$var$addSub(link) {
    link.dep.sc++;
    if (link.sub.flags & 4) {
        const computed = link.dep.computed;
        if (computed && !link.dep.subs) {
            computed.flags |= 20;
            for(let l = computed.deps; l; l = l.nextDep)$005d1fb7704e278c$var$addSub(l);
        }
        const currentTail = link.dep.subs;
        if (currentTail !== link) {
            link.prevSub = currentTail;
            if (currentTail) currentTail.nextSub = link;
        }
        link.dep.subs = link;
    }
}
const $005d1fb7704e278c$var$targetMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$export$3c41b1a4e06acc14 = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$49093fa1cddcb78d = /* @__PURE__ */ Symbol("");
const $005d1fb7704e278c$export$4f926f0baab682cd = /* @__PURE__ */ Symbol("");
function $005d1fb7704e278c$export$6b2a7d5132615086(target, type, key) {
    if ($005d1fb7704e278c$var$shouldTrack && $005d1fb7704e278c$var$activeSub) {
        let depsMap = $005d1fb7704e278c$var$targetMap.get(target);
        if (!depsMap) $005d1fb7704e278c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        let dep = depsMap.get(key);
        if (!dep) {
            depsMap.set(key, dep = new $005d1fb7704e278c$var$Dep());
            dep.map = depsMap;
            dep.key = key;
        }
        dep.track();
    }
}
function $005d1fb7704e278c$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $005d1fb7704e278c$var$targetMap.get(target);
    if (!depsMap) {
        $005d1fb7704e278c$var$globalVersion++;
        return;
    }
    const run = (dep)=>{
        if (dep) dep.trigger();
    };
    $005d1fb7704e278c$var$startBatch();
    if (type === "clear") depsMap.forEach(run);
    else {
        const targetIsArray = (0, $8POXm.isArray)(target);
        const isArrayIndex = targetIsArray && (0, $8POXm.isIntegerKey)(key);
        if (targetIsArray && key === "length") {
            const newLength = Number(newValue);
            depsMap.forEach((dep, key2)=>{
                if (key2 === "length" || key2 === $005d1fb7704e278c$export$4f926f0baab682cd || !(0, $8POXm.isSymbol)(key2) && key2 >= newLength) run(dep);
            });
        } else {
            if (key !== void 0 || depsMap.has(void 0)) run(depsMap.get(key));
            if (isArrayIndex) run(depsMap.get($005d1fb7704e278c$export$4f926f0baab682cd));
            switch(type){
                case "add":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    } else if (isArrayIndex) run(depsMap.get("length"));
                    break;
                case "delete":
                    if (!targetIsArray) {
                        run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                        if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$49093fa1cddcb78d));
                    }
                    break;
                case "set":
                    if ((0, $8POXm.isMap)(target)) run(depsMap.get($005d1fb7704e278c$export$3c41b1a4e06acc14));
                    break;
            }
        }
    }
    $005d1fb7704e278c$var$endBatch();
}
function $005d1fb7704e278c$var$getDepFromReactive(object, key) {
    const depMap = $005d1fb7704e278c$var$targetMap.get(object);
    return depMap && depMap.get(key);
}
function $005d1fb7704e278c$export$1544eab4943788e4(array) {
    const raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(array);
    if (raw === array) return raw;
    $005d1fb7704e278c$export$6b2a7d5132615086(raw, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return $005d1fb7704e278c$export$7f3fe6025abfa26e(array) ? raw : raw.map($005d1fb7704e278c$export$45c769cf449a508c);
}
function $005d1fb7704e278c$export$5eb48af14254449e(arr) {
    $005d1fb7704e278c$export$6b2a7d5132615086(arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(arr), "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    return arr;
}
function $005d1fb7704e278c$var$toWrapped(target, item) {
    if ($005d1fb7704e278c$export$92d09b48637741e7(target)) return $005d1fb7704e278c$export$352205f445242f02(target) ? $005d1fb7704e278c$export$4a78e7a2a4fb689f($005d1fb7704e278c$export$45c769cf449a508c(item)) : $005d1fb7704e278c$export$4a78e7a2a4fb689f(item);
    return $005d1fb7704e278c$export$45c769cf449a508c(item);
}
const $005d1fb7704e278c$var$arrayInstrumentations = {
    __proto__: null,
    [Symbol.iterator] () {
        return $005d1fb7704e278c$var$iterator(this, Symbol.iterator, (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    },
    concat (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).concat(...args.map((x)=>(0, $8POXm.isArray)(x) ? $005d1fb7704e278c$export$1544eab4943788e4(x) : x));
    },
    entries () {
        return $005d1fb7704e278c$var$iterator(this, "entries", (value)=>{
            value[1] = $005d1fb7704e278c$var$toWrapped(this, value[1]);
            return value;
        });
    },
    every (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "every", fn, thisArg, void 0, arguments);
    },
    filter (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "filter", fn, thisArg, (v)=>v.map((item)=>$005d1fb7704e278c$var$toWrapped(this, item)), arguments);
    },
    find (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "find", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findIndex", fn, thisArg, void 0, arguments);
    },
    findLast (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLast", fn, thisArg, (item)=>$005d1fb7704e278c$var$toWrapped(this, item), arguments);
    },
    findLastIndex (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "findLastIndex", fn, thisArg, void 0, arguments);
    },
    // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
    forEach (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "forEach", fn, thisArg, void 0, arguments);
    },
    includes (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "includes", args);
    },
    indexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "indexOf", args);
    },
    join (separator) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).join(separator);
    },
    // keys() iterator only reads `length`, no optimization required
    lastIndexOf (...args) {
        return $005d1fb7704e278c$var$searchProxy(this, "lastIndexOf", args);
    },
    map (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "map", fn, thisArg, void 0, arguments);
    },
    pop () {
        return $005d1fb7704e278c$var$noTracking(this, "pop");
    },
    push (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "push", args);
    },
    reduce (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduce", fn, args);
    },
    reduceRight (fn, ...args) {
        return $005d1fb7704e278c$var$reduce(this, "reduceRight", fn, args);
    },
    shift () {
        return $005d1fb7704e278c$var$noTracking(this, "shift");
    },
    // slice could use ARRAY_ITERATE but also seems to beg for range tracking
    some (fn, thisArg) {
        return $005d1fb7704e278c$var$apply(this, "some", fn, thisArg, void 0, arguments);
    },
    splice (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "splice", args);
    },
    toReversed () {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toReversed();
    },
    toSorted (comparer) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSorted(comparer);
    },
    toSpliced (...args) {
        return $005d1fb7704e278c$export$1544eab4943788e4(this).toSpliced(...args);
    },
    unshift (...args) {
        return $005d1fb7704e278c$var$noTracking(this, "unshift", args);
    },
    values () {
        return $005d1fb7704e278c$var$iterator(this, "values", (item)=>$005d1fb7704e278c$var$toWrapped(this, item));
    }
};
function $005d1fb7704e278c$var$iterator(self, method, wrapValue) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const iter = arr[method]();
    if (arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) {
        iter._next = iter.next;
        iter.next = ()=>{
            const result = iter._next();
            if (!result.done) result.value = wrapValue(result.value);
            return result;
        };
    }
    return iter;
}
const $005d1fb7704e278c$var$arrayProto = Array.prototype;
function $005d1fb7704e278c$var$apply(self, method, fn, thisArg, wrappedRetFn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    const needsWrap = arr !== self && !$005d1fb7704e278c$export$7f3fe6025abfa26e(self);
    const methodFn = arr[method];
    if (methodFn !== $005d1fb7704e278c$var$arrayProto[method]) {
        const result2 = methodFn.apply(self, args);
        return needsWrap ? $005d1fb7704e278c$export$45c769cf449a508c(result2) : result2;
    }
    let wrappedFn = fn;
    if (arr !== self) {
        if (needsWrap) wrappedFn = function(item, index) {
            return fn.call(this, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 2) wrappedFn = function(item, index) {
            return fn.call(this, item, index, self);
        };
    }
    const result = methodFn.call(arr, wrappedFn, thisArg);
    return needsWrap && wrappedRetFn ? wrappedRetFn(result) : result;
}
function $005d1fb7704e278c$var$reduce(self, method, fn, args) {
    const arr = $005d1fb7704e278c$export$5eb48af14254449e(self);
    let wrappedFn = fn;
    if (arr !== self) {
        if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(self)) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, $005d1fb7704e278c$var$toWrapped(self, item), index, self);
        };
        else if (fn.length > 3) wrappedFn = function(acc, item, index) {
            return fn.call(this, acc, item, index, self);
        };
    }
    return arr[method](wrappedFn, ...args);
}
function $005d1fb7704e278c$var$searchProxy(self, method, args) {
    const arr = $005d1fb7704e278c$export$ab18938b9fc5f28e(self);
    $005d1fb7704e278c$export$6b2a7d5132615086(arr, "iterate", $005d1fb7704e278c$export$4f926f0baab682cd);
    const res = arr[method](...args);
    if ((res === -1 || res === false) && $005d1fb7704e278c$export$5f3ca29d057519b3(args[0])) {
        args[0] = $005d1fb7704e278c$export$ab18938b9fc5f28e(args[0]);
        return arr[method](...args);
    }
    return res;
}
function $005d1fb7704e278c$var$noTracking(self, method, args = []) {
    $005d1fb7704e278c$export$938a971395fef855();
    $005d1fb7704e278c$var$startBatch();
    const res = $005d1fb7704e278c$export$ab18938b9fc5f28e(self)[method].apply(self, args);
    $005d1fb7704e278c$var$endBatch();
    $005d1fb7704e278c$export$c39176b1babaa8b8();
    return res;
}
const $005d1fb7704e278c$var$isNonTrackableKeys = /* @__PURE__ */ (0, $8POXm.makeMap)(`__proto__,__v_isRef,__isVue`);
const $005d1fb7704e278c$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((key)=>key !== "arguments" && key !== "caller").map((key)=>Symbol[key]).filter((0, $8POXm.isSymbol)));
function $005d1fb7704e278c$var$hasOwnProperty(key) {
    if (!(0, $8POXm.isSymbol)(key)) key = String(key);
    const obj = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
    $005d1fb7704e278c$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
class $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(_isReadonly = false, _isShallow = false){
        this._isReadonly = _isReadonly;
        this._isShallow = _isShallow;
    }
    get(target, key, receiver) {
        if (key === "__v_skip") return target["__v_skip"];
        const isReadonly2 = this._isReadonly, isShallow2 = this._isShallow;
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return isShallow2;
        else if (key === "__v_raw") {
            if (receiver === (isReadonly2 ? isShallow2 ? $005d1fb7704e278c$var$shallowReadonlyMap : $005d1fb7704e278c$var$readonlyMap : isShallow2 ? $005d1fb7704e278c$var$shallowReactiveMap : $005d1fb7704e278c$var$reactiveMap).get(target) || // receiver is not the reactive proxy, but has the same prototype
            // this means the receiver is a user proxy of the reactive proxy
            Object.getPrototypeOf(target) === Object.getPrototypeOf(receiver)) return target;
            return;
        }
        const targetIsArray = (0, $8POXm.isArray)(target);
        if (!isReadonly2) {
            let fn;
            if (targetIsArray && (fn = $005d1fb7704e278c$var$arrayInstrumentations[key])) return fn;
            if (key === "hasOwnProperty") return $005d1fb7704e278c$var$hasOwnProperty;
        }
        const res = Reflect.get(target, key, // if this is a proxy wrapping a ref, return methods using the raw ref
        // as receiver so that we don't have to call `toRaw` on the ref in all
        // its class methods
        $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if ((0, $8POXm.isSymbol)(key) ? $005d1fb7704e278c$var$builtInSymbols.has(key) : $005d1fb7704e278c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $005d1fb7704e278c$export$6b2a7d5132615086(target, "get", key);
        if (isShallow2) return res;
        if ($005d1fb7704e278c$export$4f9f5282de18fc69(res)) {
            const value = targetIsArray && (0, $8POXm.isIntegerKey)(key) ? res : res.value;
            return isReadonly2 && (0, $8POXm.isObject)(value) ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
        }
        if ((0, $8POXm.isObject)(res)) return isReadonly2 ? $005d1fb7704e278c$export$6ec456bd5b7b3c51(res) : $005d1fb7704e278c$export$90a44edba14e47be(res);
        return res;
    }
}
class $005d1fb7704e278c$var$MutableReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(false, isShallow2);
    }
    set(target, key, value, receiver) {
        let oldValue = target[key];
        const isArrayWithIntegerKey = (0, $8POXm.isArray)(target) && (0, $8POXm.isIntegerKey)(key);
        if (!this._isShallow) {
            const isOldValueReadonly = $005d1fb7704e278c$export$92d09b48637741e7(oldValue);
            if (!$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) {
                oldValue = $005d1fb7704e278c$export$ab18938b9fc5f28e(oldValue);
                value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            }
            if (!isArrayWithIntegerKey && $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !$005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
                if (isOldValueReadonly) return true;
                else {
                    oldValue.value = value;
                    return true;
                }
            }
        }
        const hadKey = isArrayWithIntegerKey ? Number(key) < target.length : (0, $8POXm.hasOwn)(target, key);
        const result = Reflect.set(target, key, value, $005d1fb7704e278c$export$4f9f5282de18fc69(target) ? target : receiver);
        if (target === $005d1fb7704e278c$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    }
    deleteProperty(target, key) {
        const hadKey = (0, $8POXm.hasOwn)(target, key);
        const oldValue = target[key];
        const result = Reflect.deleteProperty(target, key);
        if (result && hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
        return result;
    }
    has(target, key) {
        const result = Reflect.has(target, key);
        if (!(0, $8POXm.isSymbol)(key) || !$005d1fb7704e278c$var$builtInSymbols.has(key)) $005d1fb7704e278c$export$6b2a7d5132615086(target, "has", key);
        return result;
    }
    ownKeys(target) {
        $005d1fb7704e278c$export$6b2a7d5132615086(target, "iterate", (0, $8POXm.isArray)(target) ? "length" : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return Reflect.ownKeys(target);
    }
}
class $005d1fb7704e278c$var$ReadonlyReactiveHandler extends $005d1fb7704e278c$var$BaseReactiveHandler {
    constructor(isShallow2 = false){
        super(true, isShallow2);
    }
    set(target, key) {
        return true;
    }
    deleteProperty(target, key) {
        return true;
    }
}
const $005d1fb7704e278c$var$mutableHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler();
const $005d1fb7704e278c$var$readonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler();
const $005d1fb7704e278c$var$shallowReactiveHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$MutableReactiveHandler(true);
const $005d1fb7704e278c$var$shallowReadonlyHandlers = /* @__PURE__ */ new $005d1fb7704e278c$var$ReadonlyReactiveHandler(true);
const $005d1fb7704e278c$var$toShallow = (value)=>value;
const $005d1fb7704e278c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $005d1fb7704e278c$var$createIterableMethod(method, isReadonly2, isShallow2) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
        const targetIsMap = (0, $8POXm.isMap)(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow2 ? $005d1fb7704e278c$var$toShallow : isReadonly2 ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
        !isReadonly2 && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $005d1fb7704e278c$export$49093fa1cddcb78d : $005d1fb7704e278c$export$3c41b1a4e06acc14);
        return (0, $8POXm.extend)(// inheriting all iterator properties
        Object.create(innerIterator), {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        });
    };
}
function $005d1fb7704e278c$var$createReadonlyMethod(type) {
    return function(...args) {
        return type === "delete" ? false : type === "clear" ? void 0 : this;
    };
}
function $005d1fb7704e278c$var$createInstrumentations(readonly, shallow) {
    const instrumentations = {
        get (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "get", rawKey);
            }
            const { has: has } = $005d1fb7704e278c$var$getProto(rawTarget);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            if (has.call(rawTarget, key)) return wrap(target.get(key));
            else if (has.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
            else if (target !== rawTarget) target.get(key);
        },
        get size () {
            const target = this["__v_raw"];
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086($005d1fb7704e278c$export$ab18938b9fc5f28e(target), "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.size;
        },
        has (key) {
            const target = this["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
            if (!readonly) {
                if ((0, $8POXm.hasChanged)(key, rawKey)) $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", key);
                $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "has", rawKey);
            }
            return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
        },
        forEach (callback, thisArg) {
            const observed = this;
            const target = observed["__v_raw"];
            const rawTarget = $005d1fb7704e278c$export$ab18938b9fc5f28e(target);
            const wrap = shallow ? $005d1fb7704e278c$var$toShallow : readonly ? $005d1fb7704e278c$export$4a78e7a2a4fb689f : $005d1fb7704e278c$export$45c769cf449a508c;
            !readonly && $005d1fb7704e278c$export$6b2a7d5132615086(rawTarget, "iterate", $005d1fb7704e278c$export$3c41b1a4e06acc14);
            return target.forEach((value, key)=>{
                return callback.call(thisArg, wrap(value), wrap(key), observed);
            });
        }
    };
    (0, $8POXm.extend)(instrumentations, readonly ? {
        add: $005d1fb7704e278c$var$createReadonlyMethod("add"),
        set: $005d1fb7704e278c$var$createReadonlyMethod("set"),
        delete: $005d1fb7704e278c$var$createReadonlyMethod("delete"),
        clear: $005d1fb7704e278c$var$createReadonlyMethod("clear")
    } : {
        add (value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const proto = $005d1fb7704e278c$var$getProto(target);
            const hadKey = proto.has.call(target, value);
            if (!hadKey) {
                target.add(value);
                $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", value, value);
            }
            return this;
        },
        set (key, value) {
            if (!shallow && !$005d1fb7704e278c$export$7f3fe6025abfa26e(value) && !$005d1fb7704e278c$export$92d09b48637741e7(value)) value = $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get.call(target, key);
            target.set(key, value);
            if (!hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $8POXm.hasChanged)(value, oldValue)) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
            return this;
        },
        delete (key) {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const { has: has, get: get } = $005d1fb7704e278c$var$getProto(target);
            let hadKey = has.call(target, key);
            if (!hadKey) {
                key = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
                hadKey = has.call(target, key);
            }
            const oldValue = get ? get.call(target, key) : void 0;
            const result = target.delete(key);
            if (hadKey) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
            return result;
        },
        clear () {
            const target = $005d1fb7704e278c$export$ab18938b9fc5f28e(this);
            const hadItems = target.size !== 0;
            const oldTarget = void 0;
            const result = target.clear();
            if (hadItems) $005d1fb7704e278c$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
            return result;
        }
    });
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        instrumentations[method] = $005d1fb7704e278c$var$createIterableMethod(method, readonly, shallow);
    });
    return instrumentations;
}
function $005d1fb7704e278c$var$createInstrumentationGetter(isReadonly2, shallow) {
    const instrumentations = $005d1fb7704e278c$var$createInstrumentations(isReadonly2, shallow);
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $8POXm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
const $005d1fb7704e278c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, false)
};
const $005d1fb7704e278c$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(false, true)
};
const $005d1fb7704e278c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, false)
};
const $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $005d1fb7704e278c$var$createInstrumentationGetter(true, true)
};
function $005d1fb7704e278c$var$checkIdentityKeys(target, has, key) {
    const rawKey = $005d1fb7704e278c$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has.call(target, rawKey)) {
        const type = (0, $8POXm.toRawType)(target);
        $005d1fb7704e278c$var$warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
const $005d1fb7704e278c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
const $005d1fb7704e278c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $005d1fb7704e278c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $005d1fb7704e278c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $005d1fb7704e278c$var$targetTypeMap((0, $8POXm.toRawType)(value));
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$90a44edba14e47be(target) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(target)) return target;
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$mutableHandlers, $005d1fb7704e278c$var$mutableCollectionHandlers, $005d1fb7704e278c$var$reactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$8d81cefd22d22260(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, false, $005d1fb7704e278c$var$shallowReactiveHandlers, $005d1fb7704e278c$var$shallowCollectionHandlers, $005d1fb7704e278c$var$shallowReactiveMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$6ec456bd5b7b3c51(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$readonlyHandlers, $005d1fb7704e278c$var$readonlyCollectionHandlers, $005d1fb7704e278c$var$readonlyMap);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7c4b5f2b50f09f6b(target) {
    return $005d1fb7704e278c$var$createReactiveObject(target, true, $005d1fb7704e278c$var$shallowReadonlyHandlers, $005d1fb7704e278c$var$shallowReadonlyCollectionHandlers, $005d1fb7704e278c$var$shallowReadonlyMap);
}
function $005d1fb7704e278c$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $8POXm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    const targetType = $005d1fb7704e278c$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$352205f445242f02(value) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$92d09b48637741e7(value)) return /* @__PURE__ */ $005d1fb7704e278c$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$5f3ca29d057519b3(value) {
    return value ? !!value["__v_raw"] : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$ab18938b9fc5f28e(observed) {
    const raw = observed && observed["__v_raw"];
    return raw ? /* @__PURE__ */ $005d1fb7704e278c$export$ab18938b9fc5f28e(raw) : observed;
}
function $005d1fb7704e278c$export$995ab8b13ad7a9d0(value) {
    if (!(0, $8POXm.hasOwn)(value, "__v_skip") && Object.isExtensible(value)) (0, $8POXm.def)(value, "__v_skip", true);
    return value;
}
const $005d1fb7704e278c$export$45c769cf449a508c = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$90a44edba14e47be(value) : value;
const $005d1fb7704e278c$export$4a78e7a2a4fb689f = (value)=>(0, $8POXm.isObject)(value) ? /* @__PURE__ */ $005d1fb7704e278c$export$6ec456bd5b7b3c51(value) : value;
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$4f9f5282de18fc69(r) {
    return r ? r["__v_isRef"] === true : false;
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$eff4d24c3ff7876e(value) {
    return $005d1fb7704e278c$var$createRef(value, false);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$9b7bc5fe3b17c8b3(value) {
    return $005d1fb7704e278c$var$createRef(value, true);
}
function $005d1fb7704e278c$var$createRef(rawValue, shallow) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $005d1fb7704e278c$var$RefImpl(rawValue, shallow);
}
class $005d1fb7704e278c$var$RefImpl {
    constructor(value, isShallow2){
        this.dep = new $005d1fb7704e278c$var$Dep();
        this["__v_isRef"] = true;
        this["__v_isShallow"] = false;
        this._rawValue = isShallow2 ? value : $005d1fb7704e278c$export$ab18938b9fc5f28e(value);
        this._value = isShallow2 ? value : $005d1fb7704e278c$export$45c769cf449a508c(value);
        this["__v_isShallow"] = isShallow2;
    }
    get value() {
        this.dep.track();
        return this._value;
    }
    set value(newValue) {
        const oldValue = this._rawValue;
        const useDirectValue = this["__v_isShallow"] || $005d1fb7704e278c$export$7f3fe6025abfa26e(newValue) || $005d1fb7704e278c$export$92d09b48637741e7(newValue);
        newValue = useDirectValue ? newValue : $005d1fb7704e278c$export$ab18938b9fc5f28e(newValue);
        if ((0, $8POXm.hasChanged)(newValue, oldValue)) {
            this._rawValue = newValue;
            this._value = useDirectValue ? newValue : $005d1fb7704e278c$export$45c769cf449a508c(newValue);
            this.dep.trigger();
        }
    }
}
function $005d1fb7704e278c$export$f402f86588575ccc(ref2) {
    if (ref2.dep) ref2.dep.trigger();
}
function $005d1fb7704e278c$export$a239a76781616204(ref2) {
    return /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $005d1fb7704e278c$export$30bdcc2218aa9458(source) {
    return (0, $8POXm.isFunction)(source) ? source() : $005d1fb7704e278c$export$a239a76781616204(source);
}
const $005d1fb7704e278c$var$shallowUnwrapHandlers = {
    get: (target, key, receiver)=>key === "__v_raw" ? target : $005d1fb7704e278c$export$a239a76781616204(Reflect.get(target, key, receiver)),
    set: (target, key, value, receiver)=>{
        const oldValue = target[key];
        if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(oldValue) && !/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $005d1fb7704e278c$export$f353fd1b97db3fa0(objectWithRefs) {
    return $005d1fb7704e278c$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $005d1fb7704e278c$var$shallowUnwrapHandlers);
}
class $005d1fb7704e278c$var$CustomRefImpl {
    constructor(factory){
        this["__v_isRef"] = true;
        this._value = void 0;
        const dep = this.dep = new $005d1fb7704e278c$var$Dep();
        const { get: get, set: set } = factory(dep.track.bind(dep), dep.trigger.bind(dep));
        this._get = get;
        this._set = set;
    }
    get value() {
        return this._value = this._get();
    }
    set value(newVal) {
        this._set(newVal);
    }
}
function $005d1fb7704e278c$export$a20c2dd6199824cb(factory) {
    return new $005d1fb7704e278c$var$CustomRefImpl(factory);
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2e9533675e5e70e0(object) {
    const ret = (0, $8POXm.isArray)(object) ? new Array(object.length) : {};
    for(const key in object)ret[key] = $005d1fb7704e278c$var$propertyToRef(object, key);
    return ret;
}
class $005d1fb7704e278c$var$ObjectRefImpl {
    constructor(_object, _key, _defaultValue){
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this["__v_isRef"] = true;
        this._value = void 0;
        this._raw = $005d1fb7704e278c$export$ab18938b9fc5f28e(_object);
        let shallow = true;
        let obj = _object;
        if (!(0, $8POXm.isArray)(_object) || !(0, $8POXm.isIntegerKey)(String(_key))) do shallow = !$005d1fb7704e278c$export$5f3ca29d057519b3(obj) || $005d1fb7704e278c$export$7f3fe6025abfa26e(obj);
        while (shallow && (obj = obj["__v_raw"]));
        this._shallow = shallow;
    }
    get value() {
        let val = this._object[this._key];
        if (this._shallow) val = $005d1fb7704e278c$export$a239a76781616204(val);
        return this._value = val === void 0 ? this._defaultValue : val;
    }
    set value(newVal) {
        if (this._shallow && /* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(this._raw[this._key])) {
            const nestedRef = this._object[this._key];
            if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(nestedRef)) {
                nestedRef.value = newVal;
                return;
            }
        }
        this._object[this._key] = newVal;
    }
    get dep() {
        return $005d1fb7704e278c$var$getDepFromReactive(this._raw, this._key);
    }
}
class $005d1fb7704e278c$var$GetterRefImpl {
    constructor(_getter){
        this._getter = _getter;
        this["__v_isRef"] = true;
        this["__v_isReadonly"] = true;
        this._value = void 0;
    }
    get value() {
        return this._value = this._getter();
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if (/* @__PURE__ */ $005d1fb7704e278c$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $8POXm.isFunction)(source)) return new $005d1fb7704e278c$var$GetterRefImpl(source);
    else if ((0, $8POXm.isObject)(source) && arguments.length > 1) return $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue);
    else return /* @__PURE__ */ $005d1fb7704e278c$export$eff4d24c3ff7876e(source);
}
function $005d1fb7704e278c$var$propertyToRef(source, key, defaultValue) {
    return new $005d1fb7704e278c$var$ObjectRefImpl(source, key, defaultValue);
}
class $005d1fb7704e278c$var$ComputedRefImpl {
    constructor(fn, setter, isSSR){
        this.fn = fn;
        this.setter = setter;
        /**
     * @internal
     */ this._value = void 0;
        /**
     * @internal
     */ this.dep = new $005d1fb7704e278c$var$Dep(this);
        /**
     * @internal
     */ this.__v_isRef = true;
        // TODO isolatedDeclarations "__v_isReadonly"
        // A computed is also a subscriber that tracks other deps
        /**
     * @internal
     */ this.deps = void 0;
        /**
     * @internal
     */ this.depsTail = void 0;
        /**
     * @internal
     */ this.flags = 16;
        /**
     * @internal
     */ this.globalVersion = $005d1fb7704e278c$var$globalVersion - 1;
        /**
     * @internal
     */ this.next = void 0;
        // for backwards compat
        this.effect = this;
        this["__v_isReadonly"] = !setter;
        this.isSSR = isSSR;
    }
    /**
   * @internal
   */ notify() {
        this.flags |= 16;
        if (!(this.flags & 8) && // avoid infinite self recursion
        $005d1fb7704e278c$var$activeSub !== this) {
            $005d1fb7704e278c$var$batch(this, true);
            return true;
        }
    }
    get value() {
        const link = this.dep.track();
        $005d1fb7704e278c$var$refreshComputed(this);
        if (link) link.version = this.dep.version;
        return this._value;
    }
    set value(newValue) {
        if (this.setter) this.setter(newValue);
    }
}
// @__NO_SIDE_EFFECTS__
function $005d1fb7704e278c$export$2983e091f1a1e8e2(getterOrOptions, debugOptions, isSSR = false) {
    let getter;
    let setter;
    if ((0, $8POXm.isFunction)(getterOrOptions)) getter = getterOrOptions;
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    const cRef = new $005d1fb7704e278c$var$ComputedRefImpl(getter, setter, isSSR);
    return cRef;
}
const $005d1fb7704e278c$export$2ac2bd0a56e04551 = {
    "GET": "get",
    "HAS": "has",
    "ITERATE": "iterate"
};
const $005d1fb7704e278c$export$1e8941c92696a26 = {
    "SET": "set",
    "ADD": "add",
    "DELETE": "delete",
    "CLEAR": "clear"
};
const $005d1fb7704e278c$export$e738ba173768902d = {
    "SKIP": "__v_skip",
    "IS_REACTIVE": "__v_isReactive",
    "IS_READONLY": "__v_isReadonly",
    "IS_SHALLOW": "__v_isShallow",
    "RAW": "__v_raw",
    "IS_REF": "__v_isRef"
};
const $005d1fb7704e278c$export$c54ef203cb79e75f = {
    "WATCH_GETTER": 2,
    "2": "WATCH_GETTER",
    "WATCH_CALLBACK": 3,
    "3": "WATCH_CALLBACK",
    "WATCH_CLEANUP": 4,
    "4": "WATCH_CLEANUP"
};
const $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE = {};
const $005d1fb7704e278c$var$cleanupMap = /* @__PURE__ */ new WeakMap();
let $005d1fb7704e278c$var$activeWatcher = void 0;
function $005d1fb7704e278c$export$2532f7acfca7c82d() {
    return $005d1fb7704e278c$var$activeWatcher;
}
function $005d1fb7704e278c$export$8ddeeb083684a9d0(cleanupFn, failSilently = false, owner = $005d1fb7704e278c$var$activeWatcher) {
    if (owner) {
        let cleanups = $005d1fb7704e278c$var$cleanupMap.get(owner);
        if (!cleanups) $005d1fb7704e278c$var$cleanupMap.set(owner, cleanups = []);
        cleanups.push(cleanupFn);
    }
}
function $005d1fb7704e278c$export$3db5d71bdb2d5499(source, cb, options = (0, $8POXm.EMPTY_OBJ)) {
    const { immediate: immediate, deep: deep, once: once, scheduler: scheduler, augmentJob: augmentJob, call: call } = options;
    const warnInvalidSource = (s)=>{
        (options.onWarn || $005d1fb7704e278c$var$warn)(`Invalid watch source: `, s, `A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.`);
    };
    const reactiveGetter = (source2)=>{
        if (deep) return source2;
        if ($005d1fb7704e278c$export$7f3fe6025abfa26e(source2) || deep === false || deep === 0) return $005d1fb7704e278c$export$df3f009e3d155b20(source2, 1);
        return $005d1fb7704e278c$export$df3f009e3d155b20(source2);
    };
    let effect;
    let getter;
    let cleanup;
    let boundCleanup;
    let forceTrigger = false;
    let isMultiSource = false;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(source)) {
        getter = ()=>source.value;
        forceTrigger = $005d1fb7704e278c$export$7f3fe6025abfa26e(source);
    } else if ($005d1fb7704e278c$export$352205f445242f02(source)) {
        getter = ()=>reactiveGetter(source);
        forceTrigger = true;
    } else if ((0, $8POXm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some((s)=>$005d1fb7704e278c$export$352205f445242f02(s) || $005d1fb7704e278c$export$7f3fe6025abfa26e(s));
        getter = ()=>source.map((s)=>{
                if ($005d1fb7704e278c$export$4f9f5282de18fc69(s)) return s.value;
                else if ($005d1fb7704e278c$export$352205f445242f02(s)) return reactiveGetter(s);
                else if ((0, $8POXm.isFunction)(s)) return call ? call(s, 2) : s();
            });
    } else if ((0, $8POXm.isFunction)(source)) {
        if (cb) getter = call ? ()=>call(source, 2) : source;
        else getter = ()=>{
            if (cleanup) {
                $005d1fb7704e278c$export$938a971395fef855();
                try {
                    cleanup();
                } finally{
                    $005d1fb7704e278c$export$c39176b1babaa8b8();
                }
            }
            const currentEffect = $005d1fb7704e278c$var$activeWatcher;
            $005d1fb7704e278c$var$activeWatcher = effect;
            try {
                return call ? call(source, 3, [
                    boundCleanup
                ]) : source(boundCleanup);
            } finally{
                $005d1fb7704e278c$var$activeWatcher = currentEffect;
            }
        };
    } else getter = (0, $8POXm.NOOP);
    if (cb && deep) {
        const baseGetter = getter;
        const depth = deep === true ? Infinity : deep;
        getter = ()=>$005d1fb7704e278c$export$df3f009e3d155b20(baseGetter(), depth);
    }
    const scope = $005d1fb7704e278c$export$c7be4b0125a10cba();
    const watchHandle = ()=>{
        effect.stop();
        if (scope && scope.active) (0, $8POXm.remove)(scope.effects, effect);
    };
    if (once && cb) {
        const _cb = cb;
        cb = (...args)=>{
            _cb(...args);
            watchHandle();
        };
    }
    let oldValue = isMultiSource ? new Array(source.length).fill($005d1fb7704e278c$var$INITIAL_WATCHER_VALUE) : $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE;
    const job = (immediateFirstRun)=>{
        if (!(effect.flags & 1) || !effect.dirty && !immediateFirstRun) return;
        if (cb) {
            const newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some((v, i)=>(0, $8POXm.hasChanged)(v, oldValue[i])) : (0, $8POXm.hasChanged)(newValue, oldValue))) {
                if (cleanup) cleanup();
                const currentWatcher = $005d1fb7704e278c$var$activeWatcher;
                $005d1fb7704e278c$var$activeWatcher = effect;
                try {
                    const args = [
                        newValue,
                        // pass undefined as the old value when it's changed for the first time
                        oldValue === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $005d1fb7704e278c$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                        boundCleanup
                    ];
                    oldValue = newValue;
                    call ? call(cb, 3, args) : // @ts-expect-error
                    cb(...args);
                } finally{
                    $005d1fb7704e278c$var$activeWatcher = currentWatcher;
                }
            }
        } else effect.run();
    };
    if (augmentJob) augmentJob(job);
    effect = new $005d1fb7704e278c$export$28352bb4dd362521(getter);
    effect.scheduler = scheduler ? ()=>scheduler(job, false) : job;
    boundCleanup = (fn)=>$005d1fb7704e278c$export$8ddeeb083684a9d0(fn, false, effect);
    cleanup = effect.onStop = ()=>{
        const cleanups = $005d1fb7704e278c$var$cleanupMap.get(effect);
        if (cleanups) {
            if (call) call(cleanups, 4);
            else for (const cleanup2 of cleanups)cleanup2();
            $005d1fb7704e278c$var$cleanupMap.delete(effect);
        }
    };
    if (cb) {
        if (immediate) job(true);
        else oldValue = effect.run();
    } else if (scheduler) scheduler(job.bind(null, true), true);
    else effect.run();
    watchHandle.pause = effect.pause.bind(effect);
    watchHandle.resume = effect.resume.bind(effect);
    watchHandle.stop = watchHandle;
    return watchHandle;
}
function $005d1fb7704e278c$export$df3f009e3d155b20(value, depth = Infinity, seen) {
    if (depth <= 0 || !(0, $8POXm.isObject)(value) || value["__v_skip"]) return value;
    seen = seen || /* @__PURE__ */ new Map();
    if ((seen.get(value) || 0) >= depth) return value;
    seen.set(value, depth);
    depth--;
    if ($005d1fb7704e278c$export$4f9f5282de18fc69(value)) $005d1fb7704e278c$export$df3f009e3d155b20(value.value, depth, seen);
    else if ((0, $8POXm.isArray)(value)) for(let i = 0; i < value.length; i++)$005d1fb7704e278c$export$df3f009e3d155b20(value[i], depth, seen);
    else if ((0, $8POXm.isSet)(value) || (0, $8POXm.isMap)(value)) value.forEach((v)=>{
        $005d1fb7704e278c$export$df3f009e3d155b20(v, depth, seen);
    });
    else if ((0, $8POXm.isPlainObject)(value)) {
        for(const key in value)$005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
        for (const key of Object.getOwnPropertySymbols(value))if (Object.prototype.propertyIsEnumerable.call(value, key)) $005d1fb7704e278c$export$df3f009e3d155b20(value[key], depth, seen);
    }
    return value;
}

});
parcelRegister("8POXm", function(module, exports) {

$parcel$export(module.exports, "makeMap", () => $66ea9d0aaa418c4d$export$b41394a5437791c8);
$parcel$export(module.exports, "EMPTY_OBJ", () => $66ea9d0aaa418c4d$export$cf583d23ab39677c);
$parcel$export(module.exports, "EMPTY_ARR", () => $66ea9d0aaa418c4d$export$6bd8558f433f1cc1);
$parcel$export(module.exports, "NOOP", () => $66ea9d0aaa418c4d$export$5702a91a6f42969f);
$parcel$export(module.exports, "NO", () => $66ea9d0aaa418c4d$export$c01351c0af048e39);
$parcel$export(module.exports, "isOn", () => $66ea9d0aaa418c4d$export$1a2d97de39ecbb75);
$parcel$export(module.exports, "isModelListener", () => $66ea9d0aaa418c4d$export$793aa5469768d691);
$parcel$export(module.exports, "extend", () => $66ea9d0aaa418c4d$export$8b58be045bf06082);
$parcel$export(module.exports, "remove", () => $66ea9d0aaa418c4d$export$cd7f480d6b8286c3);
$parcel$export(module.exports, "hasOwn", () => $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "isArray", () => $66ea9d0aaa418c4d$export$43bee75e5e14138e);
$parcel$export(module.exports, "isMap", () => $66ea9d0aaa418c4d$export$5c90113a285f2241);
$parcel$export(module.exports, "isSet", () => $66ea9d0aaa418c4d$export$6750766a7c7ec627);
$parcel$export(module.exports, "isRegExp", () => $66ea9d0aaa418c4d$export$49841c62b9eff15);
$parcel$export(module.exports, "isFunction", () => $66ea9d0aaa418c4d$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isString", () => $66ea9d0aaa418c4d$export$844ec244b1367d54);
$parcel$export(module.exports, "isSymbol", () => $66ea9d0aaa418c4d$export$a244864fd9645c7f);
$parcel$export(module.exports, "isObject", () => $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "isPromise", () => $66ea9d0aaa418c4d$export$4369c812aac99591);
$parcel$export(module.exports, "toRawType", () => $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5);
$parcel$export(module.exports, "isPlainObject", () => $66ea9d0aaa418c4d$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isIntegerKey", () => $66ea9d0aaa418c4d$export$e2a2b93446ec9fe);
$parcel$export(module.exports, "isReservedProp", () => $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85);
$parcel$export(module.exports, "isBuiltInDirective", () => $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b);
$parcel$export(module.exports, "camelize", () => $66ea9d0aaa418c4d$export$161d051f5dd25de7);
$parcel$export(module.exports, "hyphenate", () => $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb);
$parcel$export(module.exports, "capitalize", () => $66ea9d0aaa418c4d$export$9a00dee1beb8f576);
$parcel$export(module.exports, "toHandlerKey", () => $66ea9d0aaa418c4d$export$8c022799eeaaefcd);
$parcel$export(module.exports, "hasChanged", () => $66ea9d0aaa418c4d$export$f619eb8b89076d23);
$parcel$export(module.exports, "invokeArrayFns", () => $66ea9d0aaa418c4d$export$39951422d618a9d3);
$parcel$export(module.exports, "def", () => $66ea9d0aaa418c4d$export$8afb76124cf08683);
$parcel$export(module.exports, "looseToNumber", () => $66ea9d0aaa418c4d$export$d3be7195bcc2f31b);
$parcel$export(module.exports, "toNumber", () => $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3);
$parcel$export(module.exports, "getGlobalThis", () => $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14);
$parcel$export(module.exports, "isGloballyAllowed", () => $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf);
$parcel$export(module.exports, "normalizeStyle", () => $66ea9d0aaa418c4d$export$8756898546458274);
$parcel$export(module.exports, "stringifyStyle", () => $66ea9d0aaa418c4d$export$9466a5a0ee6f1479);
$parcel$export(module.exports, "normalizeClass", () => $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a);
$parcel$export(module.exports, "normalizeProps", () => $66ea9d0aaa418c4d$export$601abcd8103db5e4);
$parcel$export(module.exports, "isHTMLTag", () => $66ea9d0aaa418c4d$export$1ccf854a0984f890);
$parcel$export(module.exports, "isSVGTag", () => $66ea9d0aaa418c4d$export$6328ce7565ea1049);
$parcel$export(module.exports, "isMathMLTag", () => $66ea9d0aaa418c4d$export$4a46ca4c5be17b20);
$parcel$export(module.exports, "isSpecialBooleanAttr", () => $66ea9d0aaa418c4d$export$d186f5eb2e810715);
$parcel$export(module.exports, "isBooleanAttr", () => $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c);
$parcel$export(module.exports, "includeBooleanAttr", () => $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce);
$parcel$export(module.exports, "isKnownHtmlAttr", () => $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9);
$parcel$export(module.exports, "isKnownSvgAttr", () => $66ea9d0aaa418c4d$export$80da416f43933831);
$parcel$export(module.exports, "isRenderableAttrValue", () => $66ea9d0aaa418c4d$export$921dd2acf0d386a3);
$parcel$export(module.exports, "getEscapedCssVarName", () => $66ea9d0aaa418c4d$export$ad9a320bfb7ba440);
$parcel$export(module.exports, "looseEqual", () => $66ea9d0aaa418c4d$export$ae8015769846262c);
$parcel$export(module.exports, "looseIndexOf", () => $66ea9d0aaa418c4d$export$42912a80cedb8bd4);
$parcel$export(module.exports, "toDisplayString", () => $66ea9d0aaa418c4d$export$b5b1545233b45293);
$parcel$export(module.exports, "normalizeCssVarValue", () => $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e);
/**
* @vue/shared v3.5.28
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ // @__NO_SIDE_EFFECTS__
function $66ea9d0aaa418c4d$export$b41394a5437791c8(str) {
    const map = /* @__PURE__ */ Object.create(null);
    for (const key of str.split(","))map[key] = 1;
    return (val)=>val in map;
}
const $66ea9d0aaa418c4d$export$cf583d23ab39677c = {};
const $66ea9d0aaa418c4d$export$6bd8558f433f1cc1 = [];
const $66ea9d0aaa418c4d$export$5702a91a6f42969f = ()=>{};
const $66ea9d0aaa418c4d$export$c01351c0af048e39 = ()=>false;
const $66ea9d0aaa418c4d$export$1a2d97de39ecbb75 = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // uppercase letter
    (key.charCodeAt(2) > 122 || key.charCodeAt(2) < 97);
const $66ea9d0aaa418c4d$export$793aa5469768d691 = (key)=>key.startsWith("onUpdate:");
const $66ea9d0aaa418c4d$export$8b58be045bf06082 = Object.assign;
const $66ea9d0aaa418c4d$export$cd7f480d6b8286c3 = (arr, el)=>{
    const i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
const $66ea9d0aaa418c4d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $66ea9d0aaa418c4d$export$b5a638e9b3fff9f3 = (val, key)=>$66ea9d0aaa418c4d$var$hasOwnProperty.call(val, key);
const $66ea9d0aaa418c4d$export$43bee75e5e14138e = Array.isArray;
const $66ea9d0aaa418c4d$export$5c90113a285f2241 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Map]";
const $66ea9d0aaa418c4d$export$6750766a7c7ec627 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Set]";
const $66ea9d0aaa418c4d$export$871608497c498473 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Date]";
const $66ea9d0aaa418c4d$export$49841c62b9eff15 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object RegExp]";
const $66ea9d0aaa418c4d$export$f6e2535fb5126e54 = (val)=>typeof val === "function";
const $66ea9d0aaa418c4d$export$844ec244b1367d54 = (val)=>typeof val === "string";
const $66ea9d0aaa418c4d$export$a244864fd9645c7f = (val)=>typeof val === "symbol";
const $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a = (val)=>val !== null && typeof val === "object";
const $66ea9d0aaa418c4d$export$4369c812aac99591 = (val)=>{
    return ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) || $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val)) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.then) && $66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.catch);
};
const $66ea9d0aaa418c4d$export$830c053460e5ddf6 = Object.prototype.toString;
const $66ea9d0aaa418c4d$export$1dccc787cc36538b = (value)=>$66ea9d0aaa418c4d$export$830c053460e5ddf6.call(value);
const $66ea9d0aaa418c4d$export$5ad0a3c360b8fbb5 = (value)=>{
    return $66ea9d0aaa418c4d$export$1dccc787cc36538b(value).slice(8, -1);
};
const $66ea9d0aaa418c4d$export$53b83ca8eaab0383 = (val)=>$66ea9d0aaa418c4d$export$1dccc787cc36538b(val) === "[object Object]";
const $66ea9d0aaa418c4d$export$e2a2b93446ec9fe = (key)=>$66ea9d0aaa418c4d$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
const $66ea9d0aaa418c4d$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
const $66ea9d0aaa418c4d$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
const $66ea9d0aaa418c4d$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
const $66ea9d0aaa418c4d$var$camelizeRE = /-\w/g;
const $66ea9d0aaa418c4d$export$161d051f5dd25de7 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.replace($66ea9d0aaa418c4d$var$camelizeRE, (c)=>c.slice(1).toUpperCase());
});
const $66ea9d0aaa418c4d$var$hyphenateRE = /\B([A-Z])/g;
const $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>str.replace($66ea9d0aaa418c4d$var$hyphenateRE, "-$1").toLowerCase());
const $66ea9d0aaa418c4d$export$9a00dee1beb8f576 = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    return str.charAt(0).toUpperCase() + str.slice(1);
});
const $66ea9d0aaa418c4d$export$8c022799eeaaefcd = $66ea9d0aaa418c4d$var$cacheStringFunction((str)=>{
    const s = str ? `on${$66ea9d0aaa418c4d$export$9a00dee1beb8f576(str)}` : ``;
    return s;
});
const $66ea9d0aaa418c4d$export$f619eb8b89076d23 = (value, oldValue)=>!Object.is(value, oldValue);
const $66ea9d0aaa418c4d$export$39951422d618a9d3 = (fns, ...arg)=>{
    for(let i = 0; i < fns.length; i++)fns[i](...arg);
};
const $66ea9d0aaa418c4d$export$8afb76124cf08683 = (obj, key, value, writable = false)=>{
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        writable: writable,
        value: value
    });
};
const $66ea9d0aaa418c4d$export$d3be7195bcc2f31b = (val)=>{
    const n = parseFloat(val);
    return isNaN(n) ? val : n;
};
const $66ea9d0aaa418c4d$export$a0a81dc3380ce7d3 = (val)=>{
    const n = $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
let $66ea9d0aaa418c4d$var$_globalThis;
const $66ea9d0aaa418c4d$export$ff5f2eeb11fc7e14 = ()=>{
    return $66ea9d0aaa418c4d$var$_globalThis || ($66ea9d0aaa418c4d$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
const $66ea9d0aaa418c4d$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $66ea9d0aaa418c4d$export$53d5e12f9a1d3cde(name) {
    return $66ea9d0aaa418c4d$var$identRE.test(name) ? `__props.${name}` : `__props[${JSON.stringify(name)}]`;
}
function $66ea9d0aaa418c4d$export$abc5374c10a73a04(source, options) {
    return source + JSON.stringify(options, (_, val)=>typeof val === "function" ? val.toString() : val);
}
const $66ea9d0aaa418c4d$export$4bcc674e2ac54ab0 = {
    "TEXT": 1,
    "1": "TEXT",
    "CLASS": 2,
    "2": "CLASS",
    "STYLE": 4,
    "4": "STYLE",
    "PROPS": 8,
    "8": "PROPS",
    "FULL_PROPS": 16,
    "16": "FULL_PROPS",
    "NEED_HYDRATION": 32,
    "32": "NEED_HYDRATION",
    "STABLE_FRAGMENT": 64,
    "64": "STABLE_FRAGMENT",
    "KEYED_FRAGMENT": 128,
    "128": "KEYED_FRAGMENT",
    "UNKEYED_FRAGMENT": 256,
    "256": "UNKEYED_FRAGMENT",
    "NEED_PATCH": 512,
    "512": "NEED_PATCH",
    "DYNAMIC_SLOTS": 1024,
    "1024": "DYNAMIC_SLOTS",
    "DEV_ROOT_FRAGMENT": 2048,
    "2048": "DEV_ROOT_FRAGMENT",
    "CACHED": -1,
    "-1": "CACHED",
    "BAIL": -2,
    "-2": "BAIL"
};
const $66ea9d0aaa418c4d$export$def7dc2c2e95a08a = {
    [1]: `TEXT`,
    [2]: `CLASS`,
    [4]: `STYLE`,
    [8]: `PROPS`,
    [16]: `FULL_PROPS`,
    [32]: `NEED_HYDRATION`,
    [64]: `STABLE_FRAGMENT`,
    [128]: `KEYED_FRAGMENT`,
    [256]: `UNKEYED_FRAGMENT`,
    [512]: `NEED_PATCH`,
    [1024]: `DYNAMIC_SLOTS`,
    [2048]: `DEV_ROOT_FRAGMENT`,
    [-1]: `CACHED`,
    [-2]: `BAIL`
};
const $66ea9d0aaa418c4d$export$ff27c1ebf2311072 = {
    "ELEMENT": 1,
    "1": "ELEMENT",
    "FUNCTIONAL_COMPONENT": 2,
    "2": "FUNCTIONAL_COMPONENT",
    "STATEFUL_COMPONENT": 4,
    "4": "STATEFUL_COMPONENT",
    "TEXT_CHILDREN": 8,
    "8": "TEXT_CHILDREN",
    "ARRAY_CHILDREN": 16,
    "16": "ARRAY_CHILDREN",
    "SLOTS_CHILDREN": 32,
    "32": "SLOTS_CHILDREN",
    "TELEPORT": 64,
    "64": "TELEPORT",
    "SUSPENSE": 128,
    "128": "SUSPENSE",
    "COMPONENT_SHOULD_KEEP_ALIVE": 256,
    "256": "COMPONENT_SHOULD_KEEP_ALIVE",
    "COMPONENT_KEPT_ALIVE": 512,
    "512": "COMPONENT_KEPT_ALIVE",
    "COMPONENT": 6,
    "6": "COMPONENT"
};
const $66ea9d0aaa418c4d$export$b1e6fe37bcdef5be = {
    "STABLE": 1,
    "1": "STABLE",
    "DYNAMIC": 2,
    "2": "DYNAMIC",
    "FORWARDED": 3,
    "3": "FORWARDED"
};
const $66ea9d0aaa418c4d$export$624972196ed3745f = {
    [1]: "STABLE",
    [2]: "DYNAMIC",
    [3]: "FORWARDED"
};
const $66ea9d0aaa418c4d$var$GLOBALS_ALLOWED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console,Error,Symbol";
const $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$GLOBALS_ALLOWED);
const $66ea9d0aaa418c4d$export$d6571a1911e4f27e = $66ea9d0aaa418c4d$export$f73b8c13b7f97ebf;
const $66ea9d0aaa418c4d$var$range = 2;
function $66ea9d0aaa418c4d$export$f9c0d8b6684a279b(source, start = 0, end = source.length) {
    start = Math.max(0, Math.min(start, source.length));
    end = Math.max(0, Math.min(end, source.length));
    if (start > end) return "";
    let lines = source.split(/(\r?\n)/);
    const newlineSequences = lines.filter((_, idx)=>idx % 2 === 1);
    lines = lines.filter((_, idx)=>idx % 2 === 0);
    let count = 0;
    const res = [];
    for(let i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(let j = i - $66ea9d0aaa418c4d$var$range; j <= i + $66ea9d0aaa418c4d$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                const line = j + 1;
                res.push(`${line}${" ".repeat(Math.max(3 - String(line).length, 0))}|  ${lines[j]}`);
                const lineLength = lines[j].length;
                const newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    const pad = start - (count - (lineLength + newLineSeqLength));
                    const length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push(`   |  ` + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        const length = Math.max(Math.min(end - count, lineLength), 1);
                        res.push(`   |  ` + "^".repeat(length));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $66ea9d0aaa418c4d$export$8756898546458274(value) {
    if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) {
        const res = {};
        for(let i = 0; i < value.length; i++){
            const item = value[i];
            const normalized = $66ea9d0aaa418c4d$export$844ec244b1367d54(item) ? $66ea9d0aaa418c4d$export$76a205ce979d066a(item) : $66ea9d0aaa418c4d$export$8756898546458274(item);
            if (normalized) for(const key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) return value;
}
const $66ea9d0aaa418c4d$var$listDelimiterRE = /;(?![^(]*\))/g;
const $66ea9d0aaa418c4d$var$propertyDelimiterRE = /:([^]+)/;
const $66ea9d0aaa418c4d$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $66ea9d0aaa418c4d$export$76a205ce979d066a(cssText) {
    const ret = {};
    cssText.replace($66ea9d0aaa418c4d$var$styleCommentRE, "").split($66ea9d0aaa418c4d$var$listDelimiterRE).forEach((item)=>{
        if (item) {
            const tmp = item.split($66ea9d0aaa418c4d$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $66ea9d0aaa418c4d$export$9466a5a0ee6f1479(styles) {
    if (!styles) return "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(styles)) return styles;
    let ret = "";
    for(const key in styles){
        const value = styles[key];
        if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value) || typeof value === "number") {
            const normalizedKey = key.startsWith(`--`) ? key : $66ea9d0aaa418c4d$export$6e6a0a3676c4b8bb(key);
            ret += `${normalizedKey}:${value};`;
        }
    }
    return ret;
}
function $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value) {
    let res = "";
    if ($66ea9d0aaa418c4d$export$844ec244b1367d54(value)) res = value;
    else if ($66ea9d0aaa418c4d$export$43bee75e5e14138e(value)) for(let i = 0; i < value.length; i++){
        const normalized = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(value)) {
        for(const name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $66ea9d0aaa418c4d$export$601abcd8103db5e4(props) {
    if (!props) return null;
    let { class: klass, style: style } = props;
    if (klass && !$66ea9d0aaa418c4d$export$844ec244b1367d54(klass)) props.class = $66ea9d0aaa418c4d$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $66ea9d0aaa418c4d$export$8756898546458274(style);
    return props;
}
const $66ea9d0aaa418c4d$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
const $66ea9d0aaa418c4d$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
const $66ea9d0aaa418c4d$var$MATH_TAGS = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics";
const $66ea9d0aaa418c4d$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
const $66ea9d0aaa418c4d$export$1ccf854a0984f890 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$HTML_TAGS);
const $66ea9d0aaa418c4d$export$6328ce7565ea1049 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$SVG_TAGS);
const $66ea9d0aaa418c4d$export$4a46ca4c5be17b20 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$MATH_TAGS);
const $66ea9d0aaa418c4d$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$VOID_TAGS);
const $66ea9d0aaa418c4d$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
const $66ea9d0aaa418c4d$export$d186f5eb2e810715 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs);
const $66ea9d0aaa418c4d$export$f763ba3b84e9cd8c = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8($66ea9d0aaa418c4d$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
function $66ea9d0aaa418c4d$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
const $66ea9d0aaa418c4d$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
const $66ea9d0aaa418c4d$var$attrValidationCache = {};
function $66ea9d0aaa418c4d$export$d55ef77660f30d12(name) {
    if ($66ea9d0aaa418c4d$var$attrValidationCache.hasOwnProperty(name)) return $66ea9d0aaa418c4d$var$attrValidationCache[name];
    const isUnsafe = $66ea9d0aaa418c4d$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error(`unsafe attribute name: ${name}`);
    return $66ea9d0aaa418c4d$var$attrValidationCache[name] = !isUnsafe;
}
const $66ea9d0aaa418c4d$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
const $66ea9d0aaa418c4d$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap`);
const $66ea9d0aaa418c4d$export$80da416f43933831 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xmlns:xlink,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan`);
const $66ea9d0aaa418c4d$export$fc0748a8e0014066 = /* @__PURE__ */ $66ea9d0aaa418c4d$export$b41394a5437791c8(`accent,accentunder,actiontype,align,alignmentscope,altimg,altimg-height,altimg-valign,altimg-width,alttext,bevelled,close,columnsalign,columnlines,columnspan,denomalign,depth,dir,display,displaystyle,encoding,equalcolumns,equalrows,fence,fontstyle,fontweight,form,frame,framespacing,groupalign,height,href,id,indentalign,indentalignfirst,indentalignlast,indentshift,indentshiftfirst,indentshiftlast,indextype,justify,largetop,largeop,lquote,lspace,mathbackground,mathcolor,mathsize,mathvariant,maxsize,minlabelspacing,mode,other,overflow,position,rowalign,rowlines,rowspan,rquote,rspace,scriptlevel,scriptminsize,scriptsizemultiplier,selection,separator,separators,shift,side,src,stackalign,stretchy,subscriptshift,superscriptshift,symmetric,voffset,width,widths,xlink:href,xlink:show,xlink:type,xmlns`);
function $66ea9d0aaa418c4d$export$921dd2acf0d386a3(value) {
    if (value == null) return false;
    const type = typeof value;
    return type === "string" || type === "number" || type === "boolean";
}
const $66ea9d0aaa418c4d$var$escapeRE = /["'&<>]/;
function $66ea9d0aaa418c4d$export$4cf11838cdc2a8a8(string) {
    const str = "" + string;
    const match = $66ea9d0aaa418c4d$var$escapeRE.exec(str);
    if (!match) return str;
    let html = "";
    let escaped;
    let index;
    let lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
const $66ea9d0aaa418c4d$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $66ea9d0aaa418c4d$export$7b105034a53bde5f(src) {
    return src.replace($66ea9d0aaa418c4d$var$commentStripRE, "");
}
const $66ea9d0aaa418c4d$export$9320a7246b331080 = /[ !"#$%&'()*+,./:;<=>?@[\\\]^`{|}~]/g;
function $66ea9d0aaa418c4d$export$ad9a320bfb7ba440(key, doubleEscape) {
    return key.replace($66ea9d0aaa418c4d$export$9320a7246b331080, (s)=>doubleEscape ? s === '"' ? '\\\\\\"' : `\\\\${s}` : `\\${s}`);
}
function $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    let equal = true;
    for(let i = 0; equal && i < a.length; i++)equal = $66ea9d0aaa418c4d$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $66ea9d0aaa418c4d$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    let aValidType = $66ea9d0aaa418c4d$export$871608497c498473(a);
    let bValidType = $66ea9d0aaa418c4d$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(a);
    bValidType = $66ea9d0aaa418c4d$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(a);
    bValidType = $66ea9d0aaa418c4d$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $66ea9d0aaa418c4d$var$looseCompareArrays(a, b) : false;
    aValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(a);
    bValidType = $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        const aKeysCount = Object.keys(a).length;
        const bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(const key in a){
            const aHasKey = a.hasOwnProperty(key);
            const bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$66ea9d0aaa418c4d$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $66ea9d0aaa418c4d$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex((item)=>$66ea9d0aaa418c4d$export$ae8015769846262c(item, val));
}
const $66ea9d0aaa418c4d$var$isRef = (val)=>{
    return !!(val && val["__v_isRef"] === true);
};
const $66ea9d0aaa418c4d$export$b5b1545233b45293 = (val)=>{
    return $66ea9d0aaa418c4d$export$844ec244b1367d54(val) ? val : val == null ? "" : $66ea9d0aaa418c4d$export$43bee75e5e14138e(val) || $66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && (val.toString === $66ea9d0aaa418c4d$export$830c053460e5ddf6 || !$66ea9d0aaa418c4d$export$f6e2535fb5126e54(val.toString)) ? $66ea9d0aaa418c4d$var$isRef(val) ? $66ea9d0aaa418c4d$export$b5b1545233b45293(val.value) : JSON.stringify(val, $66ea9d0aaa418c4d$var$replacer, 2) : String(val);
};
const $66ea9d0aaa418c4d$var$replacer = (_key, val)=>{
    if ($66ea9d0aaa418c4d$var$isRef(val)) return $66ea9d0aaa418c4d$var$replacer(_key, val.value);
    else if ($66ea9d0aaa418c4d$export$5c90113a285f2241(val)) return {
        [`Map(${val.size})`]: [
            ...val.entries()
        ].reduce((entries, [key, val2], i)=>{
            entries[$66ea9d0aaa418c4d$var$stringifySymbol(key, i) + " =>"] = val2;
            return entries;
        }, {})
    };
    else if ($66ea9d0aaa418c4d$export$6750766a7c7ec627(val)) return {
        [`Set(${val.size})`]: [
            ...val.values()
        ].map((v)=>$66ea9d0aaa418c4d$var$stringifySymbol(v))
    };
    else if ($66ea9d0aaa418c4d$export$a244864fd9645c7f(val)) return $66ea9d0aaa418c4d$var$stringifySymbol(val);
    else if ($66ea9d0aaa418c4d$export$a6cdc56e425d0d0a(val) && !$66ea9d0aaa418c4d$export$43bee75e5e14138e(val) && !$66ea9d0aaa418c4d$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};
const $66ea9d0aaa418c4d$var$stringifySymbol = (v, i = "")=>{
    var _a;
    return(// Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    $66ea9d0aaa418c4d$export$a244864fd9645c7f(v) ? `Symbol(${(_a = v.description) != null ? _a : i})` : v);
};
function $66ea9d0aaa418c4d$export$97fe3d6453ee2f5e(value) {
    if (value == null) return "initial";
    if (typeof value === "string") return value === "" ? " " : value;
    typeof value !== "number" || Number.isFinite(value);
    return String(value);
}

});



parcelRegister("eeJ70", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", () => (parcelRequire("TusQn")).BaseTransition);
$parcel$export(module.exports, "BaseTransitionPropsValidators", () => (parcelRequire("TusQn")).BaseTransitionPropsValidators);
$parcel$export(module.exports, "callWithAsyncErrorHandling", () => (parcelRequire("TusQn")).callWithAsyncErrorHandling);
$parcel$export(module.exports, "camelize", () => (parcelRequire("8POXm")).camelize);
$parcel$export(module.exports, "capitalize", () => (parcelRequire("8POXm")).capitalize);
$parcel$export(module.exports, "cloneVNode", () => (parcelRequire("TusQn")).cloneVNode);
$parcel$export(module.exports, "Comment", () => (parcelRequire("TusQn")).Comment);
$parcel$export(module.exports, "computed", () => (parcelRequire("TusQn")).computed);
$parcel$export(module.exports, "createBlock", () => (parcelRequire("TusQn")).createBlock);
$parcel$export(module.exports, "createCommentVNode", () => (parcelRequire("TusQn")).createCommentVNode);
$parcel$export(module.exports, "createElementBlock", () => (parcelRequire("TusQn")).createElementBlock);
$parcel$export(module.exports, "createElementVNode", () => (parcelRequire("TusQn")).createElementVNode);
$parcel$export(module.exports, "createHydrationRenderer", () => (parcelRequire("TusQn")).createHydrationRenderer);
$parcel$export(module.exports, "createRenderer", () => (parcelRequire("TusQn")).createRenderer);
$parcel$export(module.exports, "createTextVNode", () => (parcelRequire("TusQn")).createTextVNode);
$parcel$export(module.exports, "createVNode", () => (parcelRequire("TusQn")).createVNode);
$parcel$export(module.exports, "defineComponent", () => (parcelRequire("TusQn")).defineComponent);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("TusQn")).Fragment);
$parcel$export(module.exports, "getCurrentInstance", () => (parcelRequire("TusQn")).getCurrentInstance);
$parcel$export(module.exports, "getTransitionRawChildren", () => (parcelRequire("TusQn")).getTransitionRawChildren);
$parcel$export(module.exports, "guardReactiveProps", () => (parcelRequire("TusQn")).guardReactiveProps);
$parcel$export(module.exports, "h", () => (parcelRequire("TusQn")).h);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("TusQn")).hasInjectionContext);
$parcel$export(module.exports, "initCustomFormatter", () => (parcelRequire("TusQn")).initCustomFormatter);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isProxy", () => (parcelRequire("01W3b")).isProxy);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "isRuntimeOnly", () => (parcelRequire("TusQn")).isRuntimeOnly);
$parcel$export(module.exports, "isVNode", () => (parcelRequire("TusQn")).isVNode);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "mergeProps", () => (parcelRequire("TusQn")).mergeProps);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "normalizeClass", () => (parcelRequire("8POXm")).normalizeClass);
$parcel$export(module.exports, "normalizeStyle", () => (parcelRequire("8POXm")).normalizeStyle);
$parcel$export(module.exports, "onActivated", () => (parcelRequire("TusQn")).onActivated);
$parcel$export(module.exports, "onBeforeMount", () => (parcelRequire("TusQn")).onBeforeMount);
$parcel$export(module.exports, "onBeforeUnmount", () => (parcelRequire("TusQn")).onBeforeUnmount);
$parcel$export(module.exports, "onBeforeUpdate", () => (parcelRequire("TusQn")).onBeforeUpdate);
$parcel$export(module.exports, "onDeactivated", () => (parcelRequire("TusQn")).onDeactivated);
$parcel$export(module.exports, "onMounted", () => (parcelRequire("TusQn")).onMounted);
$parcel$export(module.exports, "onUnmounted", () => (parcelRequire("TusQn")).onUnmounted);
$parcel$export(module.exports, "onUpdated", () => (parcelRequire("TusQn")).onUpdated);
$parcel$export(module.exports, "openBlock", () => (parcelRequire("TusQn")).openBlock);
$parcel$export(module.exports, "provide", () => (parcelRequire("TusQn")).provide);
$parcel$export(module.exports, "queuePostFlushCb", () => (parcelRequire("TusQn")).queuePostFlushCb);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "renderList", () => (parcelRequire("TusQn")).renderList);
$parcel$export(module.exports, "resolveComponent", () => (parcelRequire("TusQn")).resolveComponent);
$parcel$export(module.exports, "resolveDynamicComponent", () => (parcelRequire("TusQn")).resolveDynamicComponent);
$parcel$export(module.exports, "resolveTransitionHooks", () => (parcelRequire("TusQn")).resolveTransitionHooks);
$parcel$export(module.exports, "setTransitionHooks", () => (parcelRequire("TusQn")).setTransitionHooks);
$parcel$export(module.exports, "shallowRef", () => (parcelRequire("01W3b")).shallowRef);
$parcel$export(module.exports, "Static", () => (parcelRequire("TusQn")).Static);
$parcel$export(module.exports, "Teleport", () => (parcelRequire("TusQn")).Teleport);
$parcel$export(module.exports, "Text", () => (parcelRequire("TusQn")).Text);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "useId", () => (parcelRequire("TusQn")).useId);
$parcel$export(module.exports, "useTransitionState", () => (parcelRequire("TusQn")).useTransitionState);
$parcel$export(module.exports, "warn", () => (parcelRequire("TusQn")).warn);
$parcel$export(module.exports, "watch", () => (parcelRequire("TusQn")).watch);
$parcel$export(module.exports, "watchEffect", () => (parcelRequire("TusQn")).watchEffect);
$parcel$export(module.exports, "withCtx", () => (parcelRequire("TusQn")).withCtx);
$parcel$export(module.exports, "withDirectives", () => (parcelRequire("TusQn")).withDirectives);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "readonly", () => (parcelRequire("01W3b")).readonly);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "toValue", () => (parcelRequire("01W3b")).toValue);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "normalizeProps", () => (parcelRequire("8POXm")).normalizeProps);
$parcel$export(module.exports, "toDisplayString", () => (parcelRequire("8POXm")).toDisplayString);

$parcel$export(module.exports, "Transition", () => $a5d55dc64ccb07cf$export$be58926105124dd4);
$parcel$export(module.exports, "vShow", () => $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1);
$parcel$export(module.exports, "createApp", () => $a5d55dc64ccb07cf$export$4e373c34abfa8c68);
$parcel$export(module.exports, "render", () => $a5d55dc64ccb07cf$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "TransitionGroup", () => $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e);
$parcel$export(module.exports, "vModelText", () => $a5d55dc64ccb07cf$export$f1f88689f5728478);
$parcel$export(module.exports, "withModifiers", () => $a5d55dc64ccb07cf$export$26bd3b8e29e6f273);
$parcel$export(module.exports, "withKeys", () => $a5d55dc64ccb07cf$export$f691a8759658f782);
/**
* @vue/runtime-dom v3.5.28
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/ 
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
var $01W3b = parcelRequire("01W3b");parcelRequire("8POXm");

var $8POXm = parcelRequire("8POXm");
let $a5d55dc64ccb07cf$var$policy = void 0;
const $a5d55dc64ccb07cf$var$tt = typeof window !== "undefined" && window.trustedTypes;
if ($a5d55dc64ccb07cf$var$tt) try {
    $a5d55dc64ccb07cf$var$policy = /* @__PURE__ */ $a5d55dc64ccb07cf$var$tt.createPolicy("vue", {
        createHTML: (val)=>val
    });
} catch (e) {}
const $a5d55dc64ccb07cf$var$unsafeToTrustedHTML = $a5d55dc64ccb07cf$var$policy ? (val)=>$a5d55dc64ccb07cf$var$policy.createHTML(val) : (val)=>val;
const $a5d55dc64ccb07cf$var$svgNS = "http://www.w3.org/2000/svg";
const $a5d55dc64ccb07cf$var$mathmlNS = "http://www.w3.org/1998/Math/MathML";
const $a5d55dc64ccb07cf$var$doc = typeof document !== "undefined" ? document : null;
const $a5d55dc64ccb07cf$var$templateContainer = $a5d55dc64ccb07cf$var$doc && /* @__PURE__ */ $a5d55dc64ccb07cf$var$doc.createElement("template");
const $a5d55dc64ccb07cf$export$de4fb7f5030605d3 = {
    insert: (child, parent, anchor)=>{
        parent.insertBefore(child, anchor || null);
    },
    remove: (child)=>{
        const parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: (tag, namespace, is, props)=>{
        const el = namespace === "svg" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$svgNS, tag) : namespace === "mathml" ? $a5d55dc64ccb07cf$var$doc.createElementNS($a5d55dc64ccb07cf$var$mathmlNS, tag) : is ? $a5d55dc64ccb07cf$var$doc.createElement(tag, {
            is: is
        }) : $a5d55dc64ccb07cf$var$doc.createElement(tag);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: (text)=>$a5d55dc64ccb07cf$var$doc.createTextNode(text),
    createComment: (text)=>$a5d55dc64ccb07cf$var$doc.createComment(text),
    setText: (node, text)=>{
        node.nodeValue = text;
    },
    setElementText: (el, text)=>{
        el.textContent = text;
    },
    parentNode: (node)=>node.parentNode,
    nextSibling: (node)=>node.nextSibling,
    querySelector: (selector)=>$a5d55dc64ccb07cf$var$doc.querySelector(selector),
    setScopeId (el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent (content, parent, anchor, namespace, start, end) {
        const before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $a5d55dc64ccb07cf$var$templateContainer.innerHTML = $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(namespace === "svg" ? `<svg>${content}</svg>` : namespace === "mathml" ? `<math>${content}</math>` : content);
            const template = $a5d55dc64ccb07cf$var$templateContainer.content;
            if (namespace === "svg" || namespace === "mathml") {
                const wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
const $a5d55dc64ccb07cf$var$TRANSITION = "transition";
const $a5d55dc64ccb07cf$var$ANIMATION = "animation";
const $a5d55dc64ccb07cf$var$vtcKey = /* @__PURE__ */ Symbol("_vtc");
const $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
const $a5d55dc64ccb07cf$var$TransitionPropsValidators = /* @__PURE__ */ (0, $8POXm.extend)({}, (0, $TusQn.BaseTransitionPropsValidators), $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators);
const $a5d55dc64ccb07cf$var$decorate$1 = (t)=>{
    t.displayName = "Transition";
    t.props = $a5d55dc64ccb07cf$var$TransitionPropsValidators;
    return t;
};
const $a5d55dc64ccb07cf$export$be58926105124dd4 = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate$1((props, { slots: slots })=>(0, $TusQn.h)((0, $TusQn.BaseTransition), $a5d55dc64ccb07cf$var$resolveTransitionProps(props), slots));
const $a5d55dc64ccb07cf$var$callHook = (hook, args = [])=>{
    if ((0, $8POXm.isArray)(hook)) hook.forEach((h2)=>h2(...args));
    else if (hook) hook(...args);
};
const $a5d55dc64ccb07cf$var$hasExplicitCallback = (hook)=>{
    return hook ? (0, $8POXm.isArray)(hook) ? hook.some((h2)=>h2.length > 1) : hook.length > 1 : false;
};
function $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps) {
    const baseProps = {};
    for(const key in rawProps)if (!(key in $a5d55dc64ccb07cf$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    const { name: name = "v", type: type, duration: duration, enterFromClass: enterFromClass = `${name}-enter-from`, enterActiveClass: enterActiveClass = `${name}-enter-active`, enterToClass: enterToClass = `${name}-enter-to`, appearFromClass: appearFromClass = enterFromClass, appearActiveClass: appearActiveClass = enterActiveClass, appearToClass: appearToClass = enterToClass, leaveFromClass: leaveFromClass = `${name}-leave-from`, leaveActiveClass: leaveActiveClass = `${name}-leave-active`, leaveToClass: leaveToClass = `${name}-leave-to` } = rawProps;
    const durations = $a5d55dc64ccb07cf$var$normalizeDuration(duration);
    const enterDuration = durations && durations[0];
    const leaveDuration = durations && durations[1];
    const { onBeforeEnter: onBeforeEnter, onEnter: onEnter, onEnterCancelled: onEnterCancelled, onLeave: onLeave, onLeaveCancelled: onLeaveCancelled, onBeforeAppear: onBeforeAppear = onBeforeEnter, onAppear: onAppear = onEnter, onAppearCancelled: onAppearCancelled = onEnterCancelled } = baseProps;
    const finishEnter = (el, isAppear, done, isCancelled)=>{
        el._enterCancelled = isCancelled;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    const finishLeave = (el, done)=>{
        el._isLeaving = false;
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveToClass);
        $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    const makeEnterHook = (isAppear)=>{
        return (el, done)=>{
            const hook = isAppear ? onAppear : onEnter;
            const resolve = ()=>finishEnter(el, isAppear, done);
            $a5d55dc64ccb07cf$var$callHook(hook, [
                el,
                resolve
            ]);
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(hook)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $8POXm.extend)(baseProps, {
        onBeforeEnter (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeEnter, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear (el) {
            $a5d55dc64ccb07cf$var$callHook(onBeforeAppear, [
                el
            ]);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearFromClass);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave (el, done) {
            el._isLeaving = true;
            const resolve = ()=>finishLeave(el, done);
            $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveFromClass);
            if (!el._enterCancelled) {
                $a5d55dc64ccb07cf$var$forceReflow(el);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
            } else {
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveActiveClass);
                $a5d55dc64ccb07cf$var$forceReflow(el);
            }
            $a5d55dc64ccb07cf$var$nextFrame(()=>{
                if (!el._isLeaving) return;
                $a5d55dc64ccb07cf$var$removeTransitionClass(el, leaveFromClass);
                $a5d55dc64ccb07cf$var$addTransitionClass(el, leaveToClass);
                if (!$a5d55dc64ccb07cf$var$hasExplicitCallback(onLeave)) $a5d55dc64ccb07cf$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $a5d55dc64ccb07cf$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled (el) {
            finishEnter(el, false, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled (el) {
            finishEnter(el, true, void 0, true);
            $a5d55dc64ccb07cf$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled (el) {
            finishLeave(el);
            $a5d55dc64ccb07cf$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $a5d55dc64ccb07cf$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $8POXm.isObject)(duration)) return [
        $a5d55dc64ccb07cf$var$NumberOf(duration.enter),
        $a5d55dc64ccb07cf$var$NumberOf(duration.leave)
    ];
    else {
        const n = $a5d55dc64ccb07cf$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $a5d55dc64ccb07cf$var$NumberOf(val) {
    const res = (0, $8POXm.toNumber)(val);
    return res;
}
function $a5d55dc64ccb07cf$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.add(c));
    (el[$a5d55dc64ccb07cf$var$vtcKey] || (el[$a5d55dc64ccb07cf$var$vtcKey] = /* @__PURE__ */ new Set())).add(cls);
}
function $a5d55dc64ccb07cf$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach((c)=>c && el.classList.remove(c));
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el[$a5d55dc64ccb07cf$var$vtcKey] = void 0;
    }
}
function $a5d55dc64ccb07cf$var$nextFrame(cb) {
    requestAnimationFrame(()=>{
        requestAnimationFrame(cb);
    });
}
let $a5d55dc64ccb07cf$var$endId = 0;
function $a5d55dc64ccb07cf$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    const id = el._endId = ++$a5d55dc64ccb07cf$var$endId;
    const resolveIfNotStale = ()=>{
        if (id === el._endId) resolve();
    };
    if (explicitTimeout != null) return setTimeout(resolveIfNotStale, explicitTimeout);
    const { type: type, timeout: timeout, propCount: propCount } = $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType);
    if (!type) return resolve();
    const endEvent = type + "end";
    let ended = 0;
    const end = ()=>{
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    const onEnd = (e)=>{
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(()=>{
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $a5d55dc64ccb07cf$var$getTransitionInfo(el, expectedType) {
    const styles = window.getComputedStyle(el);
    const getStyleProperties = (key)=>(styles[key] || "").split(", ");
    const transitionDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Delay`);
    const transitionDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Duration`);
    const transitionTimeout = $a5d55dc64ccb07cf$var$getTimeout(transitionDelays, transitionDurations);
    const animationDelays = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Delay`);
    const animationDurations = getStyleProperties(`${$a5d55dc64ccb07cf$var$ANIMATION}Duration`);
    const animationTimeout = $a5d55dc64ccb07cf$var$getTimeout(animationDelays, animationDurations);
    let type = null;
    let timeout = 0;
    let propCount = 0;
    if (expectedType === $a5d55dc64ccb07cf$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $a5d55dc64ccb07cf$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $a5d55dc64ccb07cf$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $a5d55dc64ccb07cf$var$TRANSITION : $a5d55dc64ccb07cf$var$ANIMATION : null;
        propCount = type ? type === $a5d55dc64ccb07cf$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    const hasTransform = type === $a5d55dc64ccb07cf$var$TRANSITION && /\b(?:transform|all)(?:,|$)/.test(getStyleProperties(`${$a5d55dc64ccb07cf$var$TRANSITION}Property`).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $a5d55dc64ccb07cf$var$getTimeout(delays, durations) {
    while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max(...durations.map((d, i)=>$a5d55dc64ccb07cf$var$toMs(d) + $a5d55dc64ccb07cf$var$toMs(delays[i])));
}
function $a5d55dc64ccb07cf$var$toMs(s) {
    if (s === "auto") return 0;
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $a5d55dc64ccb07cf$var$forceReflow(el) {
    const targetDocument = el ? el.ownerDocument : document;
    return targetDocument.body.offsetHeight;
}
function $a5d55dc64ccb07cf$var$patchClass(el, value, isSVG) {
    const transitionClasses = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (transitionClasses) value = (value ? [
        value,
        ...transitionClasses
    ] : [
        ...transitionClasses
    ]).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
const $a5d55dc64ccb07cf$var$vShowOriginalDisplay = /* @__PURE__ */ Symbol("_vod");
const $a5d55dc64ccb07cf$var$vShowHidden = /* @__PURE__ */ Symbol("_vsh");
const $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1 = {
    // used for prop mismatch check during hydration
    name: "show",
    beforeMount (el, { value: value }, { transition: transition }) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    mounted (el, { value: value }, { transition: transition }) {
        if (transition && value) transition.enter(el);
    },
    updated (el, { value: value, oldValue: oldValue }, { transition: transition }) {
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $a5d55dc64ccb07cf$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, ()=>{
                $a5d55dc64ccb07cf$var$setDisplay(el, false);
            });
        } else $a5d55dc64ccb07cf$var$setDisplay(el, value);
    },
    beforeUnmount (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setDisplay(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setDisplay(el, value) {
    el.style.display = value ? el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] : "none";
    el[$a5d55dc64ccb07cf$var$vShowHidden] = !value;
}
function $a5d55dc64ccb07cf$var$initVShowForSSR() {
    $a5d55dc64ccb07cf$export$5cb4fcdc6937d7e1.getSSRProps = ({ value: value })=>{
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
const $a5d55dc64ccb07cf$var$CSS_VAR_TEXT = /* @__PURE__ */ Symbol("");
function $a5d55dc64ccb07cf$export$ef28b76f07940108(getter) {
    const instance = (0, $TusQn.getCurrentInstance)();
    if (!instance) return;
    const updateTeleports = instance.ut = (vars = getter(instance.proxy))=>{
        Array.from(document.querySelectorAll(`[data-v-owner="${instance.uid}"]`)).forEach((node)=>$a5d55dc64ccb07cf$var$setVarsOnNode(node, vars));
    };
    const setVars = ()=>{
        const vars = getter(instance.proxy);
        if (instance.ce) $a5d55dc64ccb07cf$var$setVarsOnNode(instance.ce, vars);
        else $a5d55dc64ccb07cf$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $TusQn.onBeforeUpdate)(()=>{
        (0, $TusQn.queuePostFlushCb)(setVars);
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $TusQn.watch)(setVars, (0, $8POXm.NOOP), {
            flush: "post"
        });
        const ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $TusQn.onUnmounted)(()=>ob.disconnect());
    });
}
function $a5d55dc64ccb07cf$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        const suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(()=>{
            $a5d55dc64ccb07cf$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $a5d55dc64ccb07cf$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $TusQn.Fragment)) vnode.children.forEach((c)=>$a5d55dc64ccb07cf$var$setVarsOnVNode(c, vars));
    else if (vnode.type === (0, $TusQn.Static)) {
        let { el: el, anchor: anchor } = vnode;
        while(el){
            $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $a5d55dc64ccb07cf$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        const style = el.style;
        let cssText = "";
        for(const key in vars){
            const value = (0, $8POXm.normalizeCssVarValue)(vars[key]);
            style.setProperty(`--${key}`, value);
            cssText += `--${key}: ${value};`;
        }
        style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT] = cssText;
    }
}
const $a5d55dc64ccb07cf$var$displayRE = /(?:^|;)\s*display\s*:/;
function $a5d55dc64ccb07cf$var$patchStyle(el, prev, next) {
    const style = el.style;
    const isCssString = (0, $8POXm.isString)(next);
    let hasControlledDisplay = false;
    if (next && !isCssString) {
        if (prev) {
            if (!(0, $8POXm.isString)(prev)) {
                for(const key in prev)if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            } else for (const prevStyle of prev.split(";")){
                const key = prevStyle.slice(0, prevStyle.indexOf(":")).trim();
                if (next[key] == null) $a5d55dc64ccb07cf$var$setStyle(style, key, "");
            }
        }
        for(const key in next){
            if (key === "display") hasControlledDisplay = true;
            $a5d55dc64ccb07cf$var$setStyle(style, key, next[key]);
        }
    } else {
        if (isCssString) {
            if (prev !== next) {
                const cssVarText = style[$a5d55dc64ccb07cf$var$CSS_VAR_TEXT];
                if (cssVarText) next += ";" + cssVarText;
                style.cssText = next;
                hasControlledDisplay = $a5d55dc64ccb07cf$var$displayRE.test(next);
            }
        } else if (prev) el.removeAttribute("style");
    }
    if ($a5d55dc64ccb07cf$var$vShowOriginalDisplay in el) {
        el[$a5d55dc64ccb07cf$var$vShowOriginalDisplay] = hasControlledDisplay ? style.display : "";
        if (el[$a5d55dc64ccb07cf$var$vShowHidden]) style.display = "none";
    }
}
const $a5d55dc64ccb07cf$var$semicolonRE = /[^\\];\s*$/;
const $a5d55dc64ccb07cf$var$importantRE = /\s*!important$/;
function $a5d55dc64ccb07cf$var$setStyle(style, name, val) {
    if ((0, $8POXm.isArray)(val)) val.forEach((v)=>$a5d55dc64ccb07cf$var$setStyle(style, name, v));
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            const prefixed = $a5d55dc64ccb07cf$var$autoPrefix(style, name);
            if ($a5d55dc64ccb07cf$var$importantRE.test(val)) style.setProperty((0, $8POXm.hyphenate)(prefixed), val.replace($a5d55dc64ccb07cf$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
const $a5d55dc64ccb07cf$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
const $a5d55dc64ccb07cf$var$prefixCache = {};
function $a5d55dc64ccb07cf$var$autoPrefix(style, rawName) {
    const cached = $a5d55dc64ccb07cf$var$prefixCache[rawName];
    if (cached) return cached;
    let name = (0, $8POXm.camelize)(rawName);
    if (name !== "filter" && name in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = name;
    name = (0, $8POXm.capitalize)(name);
    for(let i = 0; i < $a5d55dc64ccb07cf$var$prefixes.length; i++){
        const prefixed = $a5d55dc64ccb07cf$var$prefixes[i] + name;
        if (prefixed in style) return $a5d55dc64ccb07cf$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
const $a5d55dc64ccb07cf$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $a5d55dc64ccb07cf$var$patchAttr(el, key, value, isSVG, instance, isBoolean = (0, $8POXm.isSpecialBooleanAttr)(key)) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($a5d55dc64ccb07cf$var$xlinkNS, key, value);
    } else if (value == null || isBoolean && !(0, $8POXm.includeBooleanAttr)(value)) el.removeAttribute(key);
    else el.setAttribute(key, isBoolean ? "" : (0, $8POXm.isSymbol)(value) ? String(value) : value);
}
function $a5d55dc64ccb07cf$var$patchDOMProp(el, key, value, parentComponent, attrName) {
    if (key === "innerHTML" || key === "textContent") {
        if (value != null) el[key] = key === "innerHTML" ? $a5d55dc64ccb07cf$var$unsafeToTrustedHTML(value) : value;
        return;
    }
    const tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        const oldValue = tag === "OPTION" ? el.getAttribute("value") || "" : el.value;
        const newValue = value == null ? // #11647: value should be set as empty string for null and undefined,
        // but <input type="checkbox"> should be set as 'on'.
        el.type === "checkbox" ? "on" : "" : String(value);
        if (oldValue !== newValue || !("_value" in el)) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        el._value = value;
        return;
    }
    let needRemove = false;
    if (value === "" || value == null) {
        const type = typeof el[key];
        if (type === "boolean") value = (0, $8POXm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(attrName || key);
}
function $a5d55dc64ccb07cf$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $a5d55dc64ccb07cf$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
const $a5d55dc64ccb07cf$var$veiKey = /* @__PURE__ */ Symbol("_vei");
function $a5d55dc64ccb07cf$var$patchEvent(el, rawName, prevValue, nextValue, instance = null) {
    const invokers = el[$a5d55dc64ccb07cf$var$veiKey] || (el[$a5d55dc64ccb07cf$var$veiKey] = {});
    const existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        const [name, options] = $a5d55dc64ccb07cf$var$parseName(rawName);
        if (nextValue) {
            const invoker = invokers[rawName] = $a5d55dc64ccb07cf$var$createInvoker(nextValue, instance);
            $a5d55dc64ccb07cf$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $a5d55dc64ccb07cf$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
const $a5d55dc64ccb07cf$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $a5d55dc64ccb07cf$var$parseName(name) {
    let options;
    if ($a5d55dc64ccb07cf$var$optionsModifierRE.test(name)) {
        options = {};
        let m;
        while(m = name.match($a5d55dc64ccb07cf$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    const event = name[2] === ":" ? name.slice(3) : (0, $8POXm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
let $a5d55dc64ccb07cf$var$cachedNow = 0;
const $a5d55dc64ccb07cf$var$p = /* @__PURE__ */ Promise.resolve();
const $a5d55dc64ccb07cf$var$getNow = ()=>$a5d55dc64ccb07cf$var$cachedNow || ($a5d55dc64ccb07cf$var$p.then(()=>$a5d55dc64ccb07cf$var$cachedNow = 0), $a5d55dc64ccb07cf$var$cachedNow = Date.now());
function $a5d55dc64ccb07cf$var$createInvoker(initialValue, instance) {
    const invoker = (e)=>{
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $TusQn.callWithAsyncErrorHandling)($a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $a5d55dc64ccb07cf$var$getNow();
    return invoker;
}
function $a5d55dc64ccb07cf$var$sanitizeEventValue(value, propName) {
    if ((0, $8POXm.isFunction)(value) || (0, $8POXm.isArray)(value)) return value;
    (0, $TusQn.warn)(`Wrong type passed as event handler to ${propName} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof value}.`);
    return 0, $8POXm.NOOP;
}
function $a5d55dc64ccb07cf$var$patchStopImmediatePropagation(e, value) {
    if ((0, $8POXm.isArray)(value)) {
        const originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = ()=>{
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map((fn)=>(e2)=>!e2._stopped && fn && fn(e2));
    } else return value;
}
const $a5d55dc64ccb07cf$var$isNativeOn = (key)=>key.charCodeAt(0) === 111 && key.charCodeAt(1) === 110 && // lowercase letter
    key.charCodeAt(2) > 96 && key.charCodeAt(2) < 123;
const $a5d55dc64ccb07cf$export$cd4aa0842d13df8b = (el, key, prevValue, nextValue, namespace, parentComponent)=>{
    const isSVG = namespace === "svg";
    if (key === "class") $a5d55dc64ccb07cf$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $a5d55dc64ccb07cf$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $8POXm.isOn)(key)) {
        if (!(0, $8POXm.isModelListener)(key)) $a5d55dc64ccb07cf$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, nextValue, isSVG)) {
        $a5d55dc64ccb07cf$var$patchDOMProp(el, key, nextValue);
        if (!el.tagName.includes("-") && (key === "value" || key === "checked" || key === "selected")) $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG, parentComponent, key !== "value");
    } else if (// #11081 force set props for possible async custom element
    el._isVueCE && (/[A-Z]/.test(key) || !(0, $8POXm.isString)(nextValue))) $a5d55dc64ccb07cf$var$patchDOMProp(el, (0, $8POXm.camelize)(key), nextValue, parentComponent, key);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $a5d55dc64ccb07cf$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $a5d55dc64ccb07cf$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate" || key === "autocorrect") return false;
    if (key === "sandbox" && el.tagName === "IFRAME") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if (key === "width" || key === "height") {
        const tag = el.tagName;
        if (tag === "IMG" || tag === "VIDEO" || tag === "CANVAS" || tag === "SOURCE") return false;
    }
    if ($a5d55dc64ccb07cf$var$isNativeOn(key) && (0, $8POXm.isString)(value)) return false;
    return key in el;
}
const $a5d55dc64ccb07cf$var$REMOVAL = {};
// @__NO_SIDE_EFFECTS__
function $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, _createApp) {
    let Comp = (0, $TusQn.defineComponent)(options, extraOptions);
    if ((0, $8POXm.isPlainObject)(Comp)) Comp = (0, $8POXm.extend)({}, Comp, extraOptions);
    class VueCustomElement extends $a5d55dc64ccb07cf$export$b337c1a55163dbe3 {
        constructor(initialProps){
            super(Comp, initialProps, _createApp);
        }
    }
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
const $a5d55dc64ccb07cf$export$6debb2e68f212638 = /* @__NO_SIDE_EFFECTS__ */ (options, extraOptions)=>{
    return /* @__PURE__ */ $a5d55dc64ccb07cf$export$a00e2346eabbdbef(options, extraOptions, $a5d55dc64ccb07cf$export$35800275c0037383);
};
const $a5d55dc64ccb07cf$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : class {
};
class $a5d55dc64ccb07cf$export$b337c1a55163dbe3 extends $a5d55dc64ccb07cf$var$BaseClass {
    constructor(_def, _props = {}, _createApp = $a5d55dc64ccb07cf$export$4e373c34abfa8c68){
        super();
        this._def = _def;
        this._props = _props;
        this._createApp = _createApp;
        this._isVueCE = true;
        /**
     * @internal
     */ this._instance = null;
        /**
     * @internal
     */ this._app = null;
        /**
     * @internal
     */ this._nonce = this._def.nonce;
        this._connected = false;
        this._resolved = false;
        this._patching = false;
        this._dirty = false;
        this._numberProps = null;
        this._styleChildren = /* @__PURE__ */ new WeakSet();
        this._ob = null;
        if (this.shadowRoot && _createApp !== $a5d55dc64ccb07cf$export$4e373c34abfa8c68) this._root = this.shadowRoot;
        else if (_def.shadowRoot !== false) {
            this.attachShadow((0, $8POXm.extend)({}, _def.shadowRootOptions, {
                mode: "open"
            }));
            this._root = this.shadowRoot;
        } else this._root = this;
    }
    connectedCallback() {
        if (!this.isConnected) return;
        if (!this.shadowRoot && !this._resolved) this._parseSlots();
        this._connected = true;
        let parent = this;
        while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof $a5d55dc64ccb07cf$export$b337c1a55163dbe3) {
            this._parent = parent;
            break;
        }
        if (!this._instance) {
            if (this._resolved) this._mount(this._def);
            else if (parent && parent._pendingResolve) this._pendingResolve = parent._pendingResolve.then(()=>{
                this._pendingResolve = void 0;
                this._resolveDef();
            });
            else this._resolveDef();
        }
    }
    _setParent(parent = this._parent) {
        if (parent) {
            this._instance.parent = parent._instance;
            this._inheritParentContext(parent);
        }
    }
    _inheritParentContext(parent = this._parent) {
        if (parent && this._app) Object.setPrototypeOf(this._app._context.provides, parent._instance.provides);
    }
    disconnectedCallback() {
        this._connected = false;
        (0, $TusQn.nextTick)(()=>{
            if (!this._connected) {
                if (this._ob) {
                    this._ob.disconnect();
                    this._ob = null;
                }
                this._app && this._app.unmount();
                if (this._instance) this._instance.ce = void 0;
                this._app = this._instance = null;
                if (this._teleportTargets) {
                    this._teleportTargets.clear();
                    this._teleportTargets = void 0;
                }
            }
        });
    }
    _processMutations(mutations) {
        for (const m of mutations)this._setAttr(m.attributeName);
    }
    /**
   * resolve inner component definition (handle possible async component)
   */ _resolveDef() {
        if (this._pendingResolve) return;
        for(let i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
        this._ob = new MutationObserver(this._processMutations.bind(this));
        this._ob.observe(this, {
            attributes: true
        });
        const resolve = (def, isAsync = false)=>{
            this._resolved = true;
            this._pendingResolve = void 0;
            const { props: props, styles: styles } = def;
            let numberProps;
            if (props && !(0, $8POXm.isArray)(props)) for(const key in props){
                const opt = props[key];
                if (opt === Number || opt && opt.type === Number) {
                    if (key in this._props) this._props[key] = (0, $8POXm.toNumber)(this._props[key]);
                    (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $8POXm.camelize)(key)] = true;
                }
            }
            this._numberProps = numberProps;
            this._resolveProps(def);
            if (this.shadowRoot) this._applyStyles(styles);
            this._mount(def);
        };
        const asyncDef = this._def.__asyncLoader;
        if (asyncDef) this._pendingResolve = asyncDef().then((def)=>{
            def.configureApp = this._def.configureApp;
            resolve(this._def = def, true);
        });
        else resolve(this._def);
    }
    _mount(def) {
        if (__VUE_PROD_DEVTOOLS__ && !def.name) def.name = "VueElement";
        this._app = this._createApp(def);
        this._inheritParentContext();
        if (def.configureApp) def.configureApp(this._app);
        this._app._ceVNode = this._createVNode();
        this._app.mount(this._root);
        const exposed = this._instance && this._instance.exposed;
        if (!exposed) return;
        for(const key in exposed)if (!(0, $8POXm.hasOwn)(this, key)) Object.defineProperty(this, key, {
            // unwrap ref to be consistent with public instance behavior
            get: ()=>(0, $01W3b.unref)(exposed[key])
        });
    }
    _resolveProps(def) {
        const { props: props } = def;
        const declaredPropKeys = (0, $8POXm.isArray)(props) ? props : Object.keys(props || {});
        for (const key of Object.keys(this))if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key]);
        for (const key of declaredPropKeys.map((0, $8POXm.camelize)))Object.defineProperty(this, key, {
            get () {
                return this._getProp(key);
            },
            set (val) {
                this._setProp(key, val, true, !this._patching);
            }
        });
    }
    _setAttr(key) {
        if (key.startsWith("data-v-")) return;
        const has = this.hasAttribute(key);
        let value = has ? this.getAttribute(key) : $a5d55dc64ccb07cf$var$REMOVAL;
        const camelKey = (0, $8POXm.camelize)(key);
        if (has && this._numberProps && this._numberProps[camelKey]) value = (0, $8POXm.toNumber)(value);
        this._setProp(camelKey, value, false, true);
    }
    /**
   * @internal
   */ _getProp(key) {
        return this._props[key];
    }
    /**
   * @internal
   */ _setProp(key, val, shouldReflect = true, shouldUpdate = false) {
        if (val !== this._props[key]) {
            this._dirty = true;
            if (val === $a5d55dc64ccb07cf$var$REMOVAL) delete this._props[key];
            else {
                this._props[key] = val;
                if (key === "key" && this._app) this._app._ceVNode.key = val;
            }
            if (shouldUpdate && this._instance) this._update();
            if (shouldReflect) {
                const ob = this._ob;
                if (ob) {
                    this._processMutations(ob.takeRecords());
                    ob.disconnect();
                }
                if (val === true) this.setAttribute((0, $8POXm.hyphenate)(key), "");
                else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $8POXm.hyphenate)(key), val + "");
                else if (!val) this.removeAttribute((0, $8POXm.hyphenate)(key));
                ob && ob.observe(this, {
                    attributes: true
                });
            }
        }
    }
    _update() {
        const vnode = this._createVNode();
        if (this._app) vnode.appContext = this._app._context;
        $a5d55dc64ccb07cf$export$b3890eb0ae9dca99(vnode, this._root);
    }
    _createVNode() {
        const baseProps = {};
        if (!this.shadowRoot) baseProps.onVnodeMounted = baseProps.onVnodeUpdated = this._renderSlots.bind(this);
        const vnode = (0, $TusQn.createVNode)(this._def, (0, $8POXm.extend)(baseProps, this._props));
        if (!this._instance) vnode.ce = (instance)=>{
            this._instance = instance;
            instance.ce = this;
            instance.isCE = true;
            var newStyles, s;
            const dispatch = (event, args)=>{
                this.dispatchEvent(new CustomEvent(event, (0, $8POXm.isPlainObject)(args[0]) ? (0, $8POXm.extend)({
                    detail: args
                }, args[0]) : {
                    detail: args
                }));
            };
            instance.emit = (event, ...args)=>{
                dispatch(event, args);
                if ((0, $8POXm.hyphenate)(event) !== event) dispatch((0, $8POXm.hyphenate)(event), args);
            };
            this._setParent();
        };
        return vnode;
    }
    _applyStyles(styles, owner) {
        if (!styles) return;
        if (owner) {
            if (owner === this._def || this._styleChildren.has(owner)) return;
            this._styleChildren.add(owner);
        }
        const nonce = this._nonce;
        for(let i = styles.length - 1; i >= 0; i--){
            const s = document.createElement("style");
            if (nonce) s.setAttribute("nonce", nonce);
            s.textContent = styles[i];
            this.shadowRoot.prepend(s);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _parseSlots() {
        const slots = this._slots = {};
        let n;
        while(n = this.firstChild){
            const slotName = n.nodeType === 1 && n.getAttribute("slot") || "default";
            (slots[slotName] || (slots[slotName] = [])).push(n);
            this.removeChild(n);
        }
    }
    /**
   * Only called when shadowRoot is false
   */ _renderSlots() {
        const outlets = this._getSlots();
        const scopeId = this._instance.type.__scopeId;
        for(let i = 0; i < outlets.length; i++){
            const o = outlets[i];
            const slotName = o.getAttribute("name") || "default";
            const content = this._slots[slotName];
            const parent = o.parentNode;
            if (content) for (const n of content){
                if (scopeId && n.nodeType === 1) {
                    const id = scopeId + "-s";
                    const walker = document.createTreeWalker(n, 1);
                    n.setAttribute(id, "");
                    let child;
                    while(child = walker.nextNode())child.setAttribute(id, "");
                }
                parent.insertBefore(n, o);
            }
            else while(o.firstChild)parent.insertBefore(o.firstChild, o);
            parent.removeChild(o);
        }
    }
    /**
   * @internal
   */ _getSlots() {
        const roots = [
            this
        ];
        if (this._teleportTargets) roots.push(...this._teleportTargets);
        const slots = /* @__PURE__ */ new Set();
        for (const root of roots){
            const found = root.querySelectorAll("slot");
            for(let i = 0; i < found.length; i++)slots.add(found[i]);
        }
        return Array.from(slots);
    }
    /**
   * @internal
   */ _injectChildStyle(comp) {
        this._applyStyles(comp.styles, comp);
    }
    /**
   * @internal
   */ _beginPatch() {
        this._patching = true;
        this._dirty = false;
    }
    /**
   * @internal
   */ _endPatch() {
        this._patching = false;
        if (this._dirty && this._instance) this._update();
    }
    /**
   * @internal
   */ _hasShadowRoot() {
        return this._def.shadowRoot !== false;
    }
    /**
   * @internal
   */ _removeChildStyle(comp) {
        var s;
    }
}
function $a5d55dc64ccb07cf$export$da5acfe93a94e37d(caller) {
    const instance = (0, $TusQn.getCurrentInstance)();
    const el = instance && instance.ce;
    if (el) return el;
    else if (false) {
        if (!instance) (0, $TusQn.warn)(`${caller || "useHost"} called without an active component instance.`);
        else (0, $TusQn.warn)(`${caller || "useHost"} can only be used in components defined via defineCustomElement.`);
    }
    return null;
}
function $a5d55dc64ccb07cf$export$64d45095031fa749() {
    const el = $a5d55dc64ccb07cf$export$da5acfe93a94e37d();
    return el && el.shadowRoot;
}
function $a5d55dc64ccb07cf$export$9300d5b90d56e3d1(name = "$style") {
    {
        const instance = (0, $TusQn.getCurrentInstance)();
        if (!instance) return 0, $8POXm.EMPTY_OBJ;
        const modules = instance.type.__cssModules;
        if (!modules) return 0, $8POXm.EMPTY_OBJ;
        const mod = modules[name];
        if (!mod) return 0, $8POXm.EMPTY_OBJ;
        return mod;
    }
}
const $a5d55dc64ccb07cf$var$positionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$newPositionMap = /* @__PURE__ */ new WeakMap();
const $a5d55dc64ccb07cf$var$moveCbKey = /* @__PURE__ */ Symbol("_moveCb");
const $a5d55dc64ccb07cf$var$enterCbKey = /* @__PURE__ */ Symbol("_enterCb");
const $a5d55dc64ccb07cf$var$decorate = (t)=>{
    delete t.props.mode;
    return t;
};
const $a5d55dc64ccb07cf$var$TransitionGroupImpl = /* @__PURE__ */ $a5d55dc64ccb07cf$var$decorate({
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $8POXm.extend)({}, $a5d55dc64ccb07cf$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup (props, { slots: slots }) {
        const instance = (0, $TusQn.getCurrentInstance)();
        const state = (0, $TusQn.useTransitionState)();
        let prevChildren;
        let children;
        (0, $TusQn.onUpdated)(()=>{
            if (!prevChildren.length) return;
            const moveClass = props.moveClass || `${props.name || "v"}-move`;
            if (!$a5d55dc64ccb07cf$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) {
                prevChildren = [];
                return;
            }
            prevChildren.forEach($a5d55dc64ccb07cf$var$callPendingCbs);
            prevChildren.forEach($a5d55dc64ccb07cf$var$recordPosition);
            const movedChildren = prevChildren.filter($a5d55dc64ccb07cf$var$applyTranslation);
            $a5d55dc64ccb07cf$var$forceReflow(instance.vnode.el);
            movedChildren.forEach((c)=>{
                const el = c.el;
                const style = el.style;
                $a5d55dc64ccb07cf$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                const cb = el[$a5d55dc64ccb07cf$var$moveCbKey] = (e)=>{
                    if (e && e.target !== el) return;
                    if (!e || e.propertyName.endsWith("transform")) {
                        el.removeEventListener("transitionend", cb);
                        el[$a5d55dc64ccb07cf$var$moveCbKey] = null;
                        $a5d55dc64ccb07cf$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
            prevChildren = [];
        });
        return ()=>{
            const rawProps = (0, $01W3b.toRaw)(props);
            const cssTransitionProps = $a5d55dc64ccb07cf$var$resolveTransitionProps(rawProps);
            let tag = rawProps.tag || (0, $TusQn.Fragment);
            prevChildren = [];
            if (children) for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.el && child.el instanceof Element) {
                    prevChildren.push(child);
                    (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
                    $a5d55dc64ccb07cf$var$positionMap.set(child, $a5d55dc64ccb07cf$var$getPosition(child.el));
                }
            }
            children = slots.default ? (0, $TusQn.getTransitionRawChildren)(slots.default()) : [];
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                if (child.key != null) (0, $TusQn.setTransitionHooks)(child, (0, $TusQn.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            return (0, $TusQn.createVNode)(tag, null, children);
        };
    }
});
const $a5d55dc64ccb07cf$export$19ffa8f511f7bc2e = $a5d55dc64ccb07cf$var$TransitionGroupImpl;
function $a5d55dc64ccb07cf$var$callPendingCbs(c) {
    const el = c.el;
    if (el[$a5d55dc64ccb07cf$var$moveCbKey]) el[$a5d55dc64ccb07cf$var$moveCbKey]();
    if (el[$a5d55dc64ccb07cf$var$enterCbKey]) el[$a5d55dc64ccb07cf$var$enterCbKey]();
}
function $a5d55dc64ccb07cf$var$recordPosition(c) {
    $a5d55dc64ccb07cf$var$newPositionMap.set(c, $a5d55dc64ccb07cf$var$getPosition(c.el));
}
function $a5d55dc64ccb07cf$var$applyTranslation(c) {
    const oldPos = $a5d55dc64ccb07cf$var$positionMap.get(c);
    const newPos = $a5d55dc64ccb07cf$var$newPositionMap.get(c);
    const dx = oldPos.left - newPos.left;
    const dy = oldPos.top - newPos.top;
    if (dx || dy) {
        const el = c.el;
        const s = el.style;
        const rect = el.getBoundingClientRect();
        let scaleX = 1;
        let scaleY = 1;
        if (el.offsetWidth) scaleX = rect.width / el.offsetWidth;
        if (el.offsetHeight) scaleY = rect.height / el.offsetHeight;
        if (!Number.isFinite(scaleX) || scaleX === 0) scaleX = 1;
        if (!Number.isFinite(scaleY) || scaleY === 0) scaleY = 1;
        if (Math.abs(scaleX - 1) < 0.01) scaleX = 1;
        if (Math.abs(scaleY - 1) < 0.01) scaleY = 1;
        s.transform = s.webkitTransform = `translate(${dx / scaleX}px,${dy / scaleY}px)`;
        s.transitionDuration = "0s";
        return c;
    }
}
function $a5d55dc64ccb07cf$var$getPosition(el) {
    const rect = el.getBoundingClientRect();
    return {
        left: rect.left,
        top: rect.top
    };
}
function $a5d55dc64ccb07cf$var$hasCSSTransform(el, root, moveClass) {
    const clone = el.cloneNode();
    const _vtc = el[$a5d55dc64ccb07cf$var$vtcKey];
    if (_vtc) _vtc.forEach((cls)=>{
        cls.split(/\s+/).forEach((c)=>c && clone.classList.remove(c));
    });
    moveClass.split(/\s+/).forEach((c)=>c && clone.classList.add(c));
    clone.style.display = "none";
    const container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    const { hasTransform: hasTransform } = $a5d55dc64ccb07cf$var$getTransitionInfo(clone);
    container.removeChild(clone);
    return hasTransform;
}
const $a5d55dc64ccb07cf$var$getModelAssigner = (vnode)=>{
    const fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $8POXm.isArray)(fn) ? (value)=>(0, $8POXm.invokeArrayFns)(fn, value) : fn;
};
function $a5d55dc64ccb07cf$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $a5d55dc64ccb07cf$var$onCompositionEnd(e) {
    const target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
const $a5d55dc64ccb07cf$var$assignKey = /* @__PURE__ */ Symbol("_assign");
function $a5d55dc64ccb07cf$var$castValue(value, trim, number) {
    if (trim) value = value.trim();
    if (number) value = (0, $8POXm.looseToNumber)(value);
    return value;
}
const $a5d55dc64ccb07cf$export$f1f88689f5728478 = {
    created (el, { modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        const castToNumber = number || vnode.props && vnode.props.type === "number";
        $a5d55dc64ccb07cf$var$addEventListener(el, lazy ? "change" : "input", (e)=>{
            if (e.target.composing) return;
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber));
        });
        if (trim || castToNumber) $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el.value = $a5d55dc64ccb07cf$var$castValue(el.value, trim, castToNumber);
        });
        if (!lazy) {
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionstart", $a5d55dc64ccb07cf$var$onCompositionStart);
            $a5d55dc64ccb07cf$var$addEventListener(el, "compositionend", $a5d55dc64ccb07cf$var$onCompositionEnd);
            $a5d55dc64ccb07cf$var$addEventListener(el, "change", $a5d55dc64ccb07cf$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted (el, { value: value }) {
        el.value = value == null ? "" : value;
    },
    beforeUpdate (el, { value: value, oldValue: oldValue, modifiers: { lazy: lazy, trim: trim, number: number } }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (el.composing) return;
        const elValue = (number || el.type === "number") && !/^0\d/.test(el.value) ? (0, $8POXm.looseToNumber)(el.value) : el.value;
        const newValue = value == null ? "" : value;
        if (elValue === newValue) return;
        if (document.activeElement === el && el.type !== "range") {
            if (lazy && value === oldValue) return;
            if (trim && el.value.trim() === newValue) return;
        }
        el.value = newValue;
    }
};
const $a5d55dc64ccb07cf$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created (el, _, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const modelValue = el._modelValue;
            const elementValue = $a5d55dc64ccb07cf$var$getValue(el);
            const checked = el.checked;
            const assign = el[$a5d55dc64ccb07cf$var$assignKey];
            if ((0, $8POXm.isArray)(modelValue)) {
                const index = (0, $8POXm.looseIndexOf)(modelValue, elementValue);
                const found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    const filtered = [
                        ...modelValue
                    ];
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $8POXm.isSet)(modelValue)) {
                const cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($a5d55dc64ccb07cf$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $a5d55dc64ccb07cf$var$setChecked,
    beforeUpdate (el, binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$setChecked(el, binding, vnode);
    }
};
function $a5d55dc64ccb07cf$var$setChecked(el, { value: value, oldValue: oldValue }, vnode) {
    el._modelValue = value;
    let checked;
    if ((0, $8POXm.isArray)(value)) checked = (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $8POXm.isSet)(value)) checked = value.has(vnode.props.value);
    else {
        if (value === oldValue) return;
        checked = (0, $8POXm.looseEqual)(value, $a5d55dc64ccb07cf$var$getCheckboxValue(el, true));
    }
    if (el.checked !== checked) el.checked = checked;
}
const $a5d55dc64ccb07cf$export$b4356c59b38b7aa9 = {
    created (el, { value: value }, vnode) {
        el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            el[$a5d55dc64ccb07cf$var$assignKey]($a5d55dc64ccb07cf$var$getValue(el));
        });
    },
    beforeUpdate (el, { value: value, oldValue: oldValue }, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $8POXm.looseEqual)(value, vnode.props.value);
    }
};
const $a5d55dc64ccb07cf$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created (el, { value: value, modifiers: { number: number } }, vnode) {
        const isSetModel = (0, $8POXm.isSet)(value);
        $a5d55dc64ccb07cf$var$addEventListener(el, "change", ()=>{
            const selectedVal = Array.prototype.filter.call(el.options, (o)=>o.selected).map((o)=>number ? (0, $8POXm.looseToNumber)($a5d55dc64ccb07cf$var$getValue(o)) : $a5d55dc64ccb07cf$var$getValue(o));
            el[$a5d55dc64ccb07cf$var$assignKey](el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
            el._assigning = true;
            (0, $TusQn.nextTick)(()=>{
                el._assigning = false;
            });
        });
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted (el, { value: value }) {
        $a5d55dc64ccb07cf$var$setSelected(el, value);
    },
    beforeUpdate (el, _binding, vnode) {
        el[$a5d55dc64ccb07cf$var$assignKey] = $a5d55dc64ccb07cf$var$getModelAssigner(vnode);
    },
    updated (el, { value: value }) {
        if (!el._assigning) $a5d55dc64ccb07cf$var$setSelected(el, value);
    }
};
function $a5d55dc64ccb07cf$var$setSelected(el, value) {
    const isMultiple = el.multiple;
    const isArrayValue = (0, $8POXm.isArray)(value);
    if (isMultiple && !isArrayValue && !(0, $8POXm.isSet)(value)) return;
    for(let i = 0, l = el.options.length; i < l; i++){
        const option = el.options[i];
        const optionValue = $a5d55dc64ccb07cf$var$getValue(option);
        if (isMultiple) {
            if (isArrayValue) {
                const optionType = typeof optionValue;
                if (optionType === "string" || optionType === "number") option.selected = value.some((v)=>String(v) === String(optionValue));
                else option.selected = (0, $8POXm.looseIndexOf)(value, optionValue) > -1;
            } else option.selected = value.has(optionValue);
        } else if ((0, $8POXm.looseEqual)($a5d55dc64ccb07cf$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $a5d55dc64ccb07cf$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $a5d55dc64ccb07cf$var$getCheckboxValue(el, checked) {
    const key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
const $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5 = {
    created (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted (el, binding, vnode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated (el, binding, vnode, prevVNode) {
        $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $a5d55dc64ccb07cf$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $a5d55dc64ccb07cf$export$87d227567b51ca39;
        case "TEXTAREA":
            return $a5d55dc64ccb07cf$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $a5d55dc64ccb07cf$export$8847c2e532b35714;
                case "radio":
                    return $a5d55dc64ccb07cf$export$b4356c59b38b7aa9;
                default:
                    return $a5d55dc64ccb07cf$export$f1f88689f5728478;
            }
    }
}
function $a5d55dc64ccb07cf$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    const fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $a5d55dc64ccb07cf$var$initVModelForSSR() {
    $a5d55dc64ccb07cf$export$f1f88689f5728478.getSSRProps = ({ value: value })=>({
            value: value
        });
    $a5d55dc64ccb07cf$export$b4356c59b38b7aa9.getSSRProps = ({ value: value }, vnode)=>{
        if (vnode.props && (0, $8POXm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$8847c2e532b35714.getSSRProps = ({ value: value }, vnode)=>{
        if ((0, $8POXm.isArray)(value)) {
            if (vnode.props && (0, $8POXm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $8POXm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $a5d55dc64ccb07cf$export$5ad5c0e01ff62c5.getSSRProps = (binding, vnode)=>{
        if (typeof vnode.type !== "string") return;
        const modelToUse = $a5d55dc64ccb07cf$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
const $a5d55dc64ccb07cf$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
const $a5d55dc64ccb07cf$var$modifierGuards = {
    stop: (e)=>e.stopPropagation(),
    prevent: (e)=>e.preventDefault(),
    self: (e)=>e.target !== e.currentTarget,
    ctrl: (e)=>!e.ctrlKey,
    shift: (e)=>!e.shiftKey,
    alt: (e)=>!e.altKey,
    meta: (e)=>!e.metaKey,
    left: (e)=>"button" in e && e.button !== 0,
    middle: (e)=>"button" in e && e.button !== 1,
    right: (e)=>"button" in e && e.button !== 2,
    exact: (e, modifiers)=>$a5d55dc64ccb07cf$var$systemModifiers.some((m)=>e[`${m}Key`] && !modifiers.includes(m))
};
const $a5d55dc64ccb07cf$export$26bd3b8e29e6f273 = (fn, modifiers)=>{
    if (!fn) return fn;
    const cache = fn._withMods || (fn._withMods = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event, ...args)=>{
        for(let i = 0; i < modifiers.length; i++){
            const guard = $a5d55dc64ccb07cf$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn(event, ...args);
    });
};
const $a5d55dc64ccb07cf$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
const $a5d55dc64ccb07cf$export$f691a8759658f782 = (fn, modifiers)=>{
    const cache = fn._withKeys || (fn._withKeys = {});
    const cacheKey = modifiers.join(".");
    return cache[cacheKey] || (cache[cacheKey] = (event)=>{
        if (!("key" in event)) return;
        const eventKey = (0, $8POXm.hyphenate)(event.key);
        if (modifiers.some((k)=>k === eventKey || $a5d55dc64ccb07cf$var$keyNames[k] === eventKey)) return fn(event);
    });
};
const $a5d55dc64ccb07cf$var$rendererOptions = /* @__PURE__ */ (0, $8POXm.extend)({
    patchProp: $a5d55dc64ccb07cf$export$cd4aa0842d13df8b
}, $a5d55dc64ccb07cf$export$de4fb7f5030605d3);
let $a5d55dc64ccb07cf$var$renderer;
let $a5d55dc64ccb07cf$var$enabledHydration = false;
function $a5d55dc64ccb07cf$var$ensureRenderer() {
    return $a5d55dc64ccb07cf$var$renderer || ($a5d55dc64ccb07cf$var$renderer = (0, $TusQn.createRenderer)($a5d55dc64ccb07cf$var$rendererOptions));
}
function $a5d55dc64ccb07cf$var$ensureHydrationRenderer() {
    $a5d55dc64ccb07cf$var$renderer = $a5d55dc64ccb07cf$var$enabledHydration ? $a5d55dc64ccb07cf$var$renderer : (0, $TusQn.createHydrationRenderer)($a5d55dc64ccb07cf$var$rendererOptions);
    $a5d55dc64ccb07cf$var$enabledHydration = true;
    return $a5d55dc64ccb07cf$var$renderer;
}
const $a5d55dc64ccb07cf$export$b3890eb0ae9dca99 = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureRenderer().render(...args);
};
const $a5d55dc64ccb07cf$export$fa8d919ba61d84db = (...args)=>{
    $a5d55dc64ccb07cf$var$ensureHydrationRenderer().hydrate(...args);
};
const $a5d55dc64ccb07cf$export$4e373c34abfa8c68 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        const component = app._component;
        if (!(0, $8POXm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        if (container.nodeType === 1) container.textContent = "";
        const proxy = mount(container, false, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
const $a5d55dc64ccb07cf$export$35800275c0037383 = (...args)=>{
    const app = $a5d55dc64ccb07cf$var$ensureHydrationRenderer().createApp(...args);
    const { mount: mount } = app;
    app.mount = (containerOrSelector)=>{
        const container = $a5d55dc64ccb07cf$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, $a5d55dc64ccb07cf$var$resolveRootNamespace(container));
    };
    return app;
};
function $a5d55dc64ccb07cf$var$resolveRootNamespace(container) {
    if (container instanceof SVGElement) return "svg";
    if (typeof MathMLElement === "function" && container instanceof MathMLElement) return "mathml";
}
function $a5d55dc64ccb07cf$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: (tag)=>(0, $8POXm.isHTMLTag)(tag) || (0, $8POXm.isSVGTag)(tag) || (0, $8POXm.isMathMLTag)(tag),
        writable: false
    });
}
function $a5d55dc64ccb07cf$var$injectCompilerOptionsCheck(app) {
    if ((0, $TusQn.isRuntimeOnly)()) {
        const isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get () {
                return isCustomElement;
            },
            set () {
                (0, $TusQn.warn)(`The \`isCustomElement\` config option is deprecated. Use \`compilerOptions.isCustomElement\` instead.`);
            }
        });
        const compilerOptions = app.config.compilerOptions;
        const msg = `The \`compilerOptions\` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, \`compilerOptions\` must be passed to \`@vue/compiler-dom\` in the build setup instead.
- For vue-loader: pass it via vue-loader's \`compilerOptions\` loader option.
- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader
- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc`;
        Object.defineProperty(app.config, "compilerOptions", {
            get () {
                (0, $TusQn.warn)(msg);
                return compilerOptions;
            },
            set () {
                (0, $TusQn.warn)(msg);
            }
        });
    }
}
function $a5d55dc64ccb07cf$var$normalizeContainer(container) {
    if ((0, $8POXm.isString)(container)) {
        const res = document.querySelector(container);
        return res;
    }
    return container;
}
let $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = false;
const $a5d55dc64ccb07cf$export$800b28255aa678d9 = ()=>{
    if (!$a5d55dc64ccb07cf$var$ssrDirectiveInitialized) {
        $a5d55dc64ccb07cf$var$ssrDirectiveInitialized = true;
        $a5d55dc64ccb07cf$var$initVModelForSSR();
        $a5d55dc64ccb07cf$var$initVShowForSSR();
    }
};

});


parcelRegister("jjYvL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e10ebaf719388faf$export$2e2bcd8739ae039);
let $e10ebaf719388faf$var$script;




let $e10ebaf719388faf$var$initialize = ()=>{
    $e10ebaf719388faf$var$script = (parcelRequire("4cDGr"));
    if ($e10ebaf719388faf$var$script.__esModule) $e10ebaf719388faf$var$script = $e10ebaf719388faf$var$script.default;
    $e10ebaf719388faf$var$script.render = (parcelRequire("98nnt")).render;
    $e10ebaf719388faf$var$script.__cssModules = {};
    (parcelRequire("lAtD9")).default($e10ebaf719388faf$var$script);
    $e10ebaf719388faf$var$script.__scopeId = 'data-v-25ce2f';
    $e10ebaf719388faf$var$script.__file = "GraphView.vue";
};
$e10ebaf719388faf$var$initialize();
var $e10ebaf719388faf$export$2e2bcd8739ae039 = $e10ebaf719388faf$var$script;

});
parcelRegister("4cDGr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d9e7dfaae45ed279$export$2e2bcd8739ae039);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
parcelRequire("2p9oc");
var $cA8ew = parcelRequire("cA8ew");

var $83ubA = parcelRequire("83ubA");

var $2ySf9 = parcelRequire("2ySf9");

var $dAcw4 = parcelRequire("dAcw4");

var $ccy11 = parcelRequire("ccy11");

var $jYHYW = parcelRequire("jYHYW");

var $i0TKe = parcelRequire("i0TKe");
parcelRequire("6zZma");
var $5ycI5 = parcelRequire("5ycI5");

var $59sLQ = parcelRequire("59sLQ");


var $d9e7dfaae45ed279$export$2e2bcd8739ae039 = /*@__PURE__*/ (0, $TusQn.defineComponent)({
    __name: 'GraphView',
    setup (__props, { expose: __expose }) {
        const md = new (0, $5ycI5.default)({
            html: false,
            linkify: true,
            breaks: true
        });
        const graphRef = (0, $01W3b.ref)(null);
        let graph = null;
        let layoutSettingsDebounceTimer = null;
        const layoutMode = (0, $01W3b.ref)("mds");
        // All layout options with tree/non-tree classification
        const allLayoutOptions = [
            {
                label: "Circular Layout",
                value: "circular",
                requiresTree: false
            },
            {
                label: "Concentric Layout",
                value: "concentric",
                requiresTree: false
            },
            {
                label: "D3 Force-Directed Layout",
                value: "d3-force",
                requiresTree: false
            },
            {
                label: "Force-directed Layout",
                value: "force",
                requiresTree: false
            },
            {
                label: "ForceAtlas2 Layout",
                value: "force-atlas2",
                requiresTree: false
            },
            {
                label: "Fruchterman Layout",
                value: "fruchterman",
                requiresTree: false
            },
            {
                label: "Grid Layout",
                value: "grid",
                requiresTree: false
            },
            {
                label: "MDS Layout",
                value: "mds",
                requiresTree: false
            },
            {
                label: "Radial Layout",
                value: "radial",
                requiresTree: false
            },
            {
                label: "Random Layout",
                value: "random",
                requiresTree: false
            },
            {
                label: "AntV Dagre Layout",
                value: "dagre",
                requiresTree: true
            },
            {
                label: "CompactBox Tree",
                value: "compact-box",
                requiresTree: true
            },
            {
                label: "Dendrogram Tree",
                value: "dendrogram",
                requiresTree: true
            },
            {
                label: "Mindmap Tree",
                value: "mindmap",
                requiresTree: true
            },
            {
                label: "Indented Tree",
                value: "indented",
                requiresTree: true
            },
            {
                label: "Fishbone Diagram",
                value: "fishbone",
                requiresTree: true
            }
        ];
        // Layout settings with defaults
        const layoutSettings = (0, $01W3b.ref)({
            d3Force: {
                // Link force
                linkDistance: 150,
                linkStrength: 0.6,
                linkIterations: 1,
                // Many-body force (node repulsion/attraction)
                manyBodyStrength: -300,
                manyBodyTheta: 0.9,
                manyBodyDistanceMin: 1,
                manyBodyDistanceMax: 1000,
                // Center force
                centerX: 0,
                centerY: 0,
                centerStrength: 0.1,
                // Collision force
                collideRadius: 30,
                collideStrength: 0.8,
                collideIterations: 1,
                // ForceX (horizontal positioning)
                forceXEnabled: false,
                forceXX: 0,
                forceXStrength: 0.1,
                // ForceY (vertical positioning)
                forceYEnabled: false,
                forceYY: 0,
                forceYStrength: 0.1,
                // Radial force
                radialEnabled: false,
                radialX: 0,
                radialY: 0,
                radialRadius: 200,
                radialStrength: 0.1,
                // Iteration control
                alpha: 1,
                alphaMin: 0.001,
                alphaDecay: 0.06,
                alphaTarget: 0,
                velocityDecay: 0.3
            },
            force: {
                // Center position
                centerX: 0,
                centerY: 0,
                // Link/Edge properties
                linkDistance: 150,
                edgeStrength: 0.6,
                // Node properties
                nodeStrength: 30,
                nodeSize: 60,
                nodeSpacing: 20,
                preventOverlap: true,
                // Clustering
                clustering: false,
                clusterNodeStrength: 20,
                // Iteration control
                alpha: 0.3,
                alphaDecay: 0.028,
                alphaMin: 0.001
            },
            circular: {
                radius: 600,
                startRadius: 300,
                endRadius: 900,
                divisions: 5,
                angleRatio: 1,
                clockwise: true,
                ordering: "degree",
                startAngle: 0,
                endAngle: 6.28,
                nodeSize: 60,
                nodeSpacing: 10
            },
            compactBox: {
                direction: "LR",
                nodeWidth: 60,
                nodeHeight: 60,
                hGap: 120,
                vGap: 80
            },
            dagre: {
                rankdir: "LR",
                nodesep: 100,
                ranksep: 200
            },
            concentric: {
                minNodeSpacing: 50,
                preventOverlap: true
            },
            grid: {
                rows: 5,
                cols: 5,
                preventOverlap: true
            },
            radial: {
                unitRadius: 100,
                preventOverlap: true
            },
            dendrogram: {
                direction: "LR",
                nodeSep: 50,
                rankSep: 100,
                radial: false
            },
            mindmap: {
                direction: "H",
                hGap: 50,
                vGap: 50,
                getHeight: 30,
                getWidth: 100
            },
            fruchterman: {
                centerX: 0,
                centerY: 0,
                maxIteration: 1000,
                gravity: 10,
                speed: 5,
                clustering: false,
                clusterGravity: 10
            },
            mds: {
                linkDistance: 200,
                center: {
                    x: 0,
                    y: 0
                }
            },
            fishbone: {
                direction: "LR",
                hGap: 50,
                vGap: 50
            }
        });
        const graphStore = (0, $83ubA.useGraphStore)();
        const { nodeCount: nodeCount, edgeCount: edgeCount, graphData: graphData } = (0, $i0TKe.storeToRefs)(graphStore);
        // Check if the current graph structure is tree-compatible (acyclic)
        const isTreeCompatible = (0, $01W3b.computed)(()=>{
            if (!graphData.value || !graphData.value.edges || !graphData.value.nodes) return false; // Empty graph is not a tree
            const edges = graphData.value.edges;
            const nodes = graphData.value.nodes;
            if (edges.length === 0 || nodes.length === 0) return false;
            // Build adjacency list
            const adj = new Map();
            const inDegree = new Map();
            nodes.forEach((node)=>{
                adj.set(node.id, []);
                inDegree.set(node.id, 0);
            });
            edges.forEach((edge)=>{
                const neighbors = adj.get(edge.source) || [];
                neighbors.push(edge.target);
                adj.set(edge.source, neighbors);
                inDegree.set(edge.target, (inDegree.get(edge.target) || 0) + 1);
            });
            // For a tree: each node (except root) should have exactly one parent
            // and there should be no cycles
            const visited = new Set();
            const recStack = new Set();
            function hasCycle(nodeId) {
                visited.add(nodeId);
                recStack.add(nodeId);
                const neighbors = adj.get(nodeId) || [];
                for (const neighbor of neighbors){
                    if (!visited.has(neighbor)) {
                        if (hasCycle(neighbor)) return true;
                    } else if (recStack.has(neighbor)) return true; // Cycle detected
                }
                recStack.delete(nodeId);
                return false;
            }
            // Check for cycles starting from nodes with 0 in-degree (potential roots)
            for (const node of nodes)if (!visited.has(node.id)) {
                if (hasCycle(node.id)) return false; // Cycle found
            }
            return true; // No cycles, tree-compatible
        });
        // All layout options are always available
        // Tree layouts will create a spanning tree from any graph structure
        const layoutOptions = (0, $01W3b.computed)(()=>{
            return allLayoutOptions;
        });
        const { fetchGlobalFeed: fetchGlobalFeed, fetchInitialEvents: fetchInitialEvents, fetchByAuthor: fetchByAuthor, expandAroundEvent: expandAroundEvent, fetchUserGraph: fetchUserGraph, isFetching: isFetching, expandReactions: expandReactions, expandReplies: expandReplies, expandReposts: expandReposts, expandMentions: expandMentions, expandThread: expandThread } = (0, $2ySf9.useEventFetcher)();
        const { testAllRelayConnections: testAllRelayConnections, loadRelaysFromDB: loadRelaysFromDB, getPool: getPool, relays: nostrRelays } = (0, $ccy11.useNostr)();
        const snackbar = (0, $01W3b.ref)({
            show: false,
            message: "",
            color: "success",
            timeout: 3000
        });
        // Context menu state
        const contextMenu = (0, $01W3b.ref)({
            show: false,
            x: 0,
            y: 0,
            title: "",
            actions: []
        });
        // Search state
        const searchQuery = (0, $01W3b.ref)("");
        const searchResults = (0, $01W3b.ref)(new Set());
        const searchActive = (0, $01W3b.ref)(false);
        const searchMode = (0, $01W3b.ref)("AND");
        const isSearching = (0, $01W3b.ref)(false);
        // Investigation state management
        const currentInvestigationId = (0, $01W3b.ref)(null);
        const currentInvestigationName = (0, $01W3b.ref)("Untitled Investigation");
        const isEditingName = (0, $01W3b.ref)(false);
        const savedStatesDialog = (0, $01W3b.ref)(false);
        const savedStates = (0, $01W3b.ref)([]);
        const loadingStates = (0, $01W3b.ref)(false);
        // Expanding nodes state (for loading indicators)
        const expandingNodes = (0, $01W3b.ref)(new Set());
        // Track which stats have been expanded for each event
        const expandedStats = (0, $01W3b.ref)(new Map());
        // Tree layout state - keep graph data, show tree as projection
        const treeRootId = (0, $01W3b.ref)(null); // Root node for tree layouts
        const originalGraphData = (0, $01W3b.ref)(null); // Keep original graph data
        const selectedCardId = (0, $01W3b.ref)(null); // Currently selected card for scrolling
        const selectedCollapsedNodeId = (0, $01W3b.ref)(null); // Currently selected collapsed node for visual feedback
        // Multi-selection state (synced with G6's selection state)
        const selectedNodeIds = (0, $01W3b.ref)(new Set()); // Multiple selected nodes
        // Animation state
        const isAnimating = (0, $01W3b.ref)(true);
        // Timebar state
        const timebarTimeRange = (0, $01W3b.ref)(null);
        // Computed: Generate time distribution data for timebar
        const timebarData = (0, $01W3b.computed)(()=>{
            const nodes = graphStore.nodes;
            if (!nodes || nodes.length === 0) {
                // Return dummy data when no nodes exist (timebar needs at least one data point)
                const now = Date.now();
                return [
                    {
                        time: now - 86400000,
                        value: 1
                    },
                    {
                        time: now,
                        value: 1
                    }
                ];
            }
            // Get all timestamps and group by day
            const dayMap = new Map();
            nodes.forEach((node)=>{
                const event = node.data?.event;
                if (!event?.created_at) return;
                const timestamp = event.created_at * 1000; // Convert to ms
                const dayKey = new Date(timestamp).toISOString().split('T')[0]; // YYYY-MM-DD
                dayMap.set(dayKey, (dayMap.get(dayKey) || 0) + 1);
            });
            // Convert to timebar format
            const result = Array.from(dayMap.entries()).map(([day, count])=>({
                    time: new Date(day).getTime(),
                    value: count
                })).sort((a, b)=>a.time - b.time);
            // Ensure we have at least 2 data points
            if (result.length < 2) {
                const now = Date.now();
                return [
                    {
                        time: now - 86400000,
                        value: 1
                    },
                    {
                        time: now,
                        value: 1
                    }
                ];
            }
            return result;
        });
        // Computed: Default time range (last 90 days)
        const defaultTimeRange = (0, $01W3b.computed)(()=>{
            const now = Date.now();
            const ninetyDaysAgo = now - 7776000000;
            return [
                ninetyDaysAgo,
                now
            ];
        });
        // Edge styling configuration based on relationship hierarchy
        const edgeStyles = {
            "authored-by": {
                stroke: "#8b5cf6",
                lineWidth: 3,
                lineDash: [
                    0
                ],
                label: "authored by",
                opacity: 0.9
            },
            reply: {
                stroke: "#10b981",
                lineWidth: 2.5,
                lineDash: [
                    0
                ],
                label: "replies to",
                opacity: 0.85
            },
            reference: {
                stroke: "#3b82f6",
                lineWidth: 2,
                lineDash: [
                    0
                ],
                label: "references",
                opacity: 0.8
            },
            mention: {
                stroke: "#f97316",
                lineWidth: 2,
                lineDash: [
                    5,
                    3
                ],
                label: "mentions",
                opacity: 0.7
            },
            repost: {
                stroke: "#06b6d4",
                lineWidth: 1.5,
                lineDash: [
                    5,
                    3
                ],
                label: "reposts",
                opacity: 0.6
            },
            reaction: {
                stroke: "#ec4899",
                lineWidth: 1,
                lineDash: [
                    2,
                    2
                ],
                label: "reacts to",
                opacity: 0.5
            },
            "board-card": {
                stroke: "#0ea5e9",
                lineWidth: 2.5,
                lineDash: [
                    0
                ],
                label: "has card",
                opacity: 0.85
            },
            default: {
                stroke: "#999",
                lineWidth: 1.5,
                lineDash: [
                    0
                ],
                label: "connected to",
                opacity: 0.6
            }
        };
        // Helper: Get edge style based on type and marker
        function getEdgeStyle(edge) {
            const type = edge.data?.type;
            const marker = edge.data?.marker;
            // Determine edge category
            let category = "default";
            if (type === "authored-by") category = "authored-by";
            else if (type === "reference") // Differentiate reply from general reference
            category = marker === "reply" ? "reply" : "reference";
            else if (type === "mention") category = "mention";
            else if (type === "repost") category = "repost";
            else if (type === "reaction") category = "reaction";
            else if (type === "board-card") category = "board-card";
            return edgeStyles[category];
        }
        // Relay manager
        const relayManager = (0, $dAcw4.useRelayManager)();
        const relayDialog = (0, $01W3b.ref)({
            show: false
        });
        const newRelayUrl = (0, $01W3b.ref)("");
        const testingConnections = (0, $01W3b.ref)(false);
        // Helper: Get border color for event kind
        function getKindColor(kind) {
            const colors = {
                0: "#3b82f6",
                1: "#10b981",
                3: "#f59e0b",
                4: "#8b5cf6",
                5: "#ef4444",
                6: "#06b6d4",
                7: "#ec4899",
                9735: "#f59e0b",
                30023: "#6366f1",
                30301: "#0ea5e9",
                30302: "#14b8a6",
                30303: "#a78bfa"
            };
            return colors[kind] || "#6b7280"; // gray default
        }
        // Helper: Get CSS class for tree root node marker
        function getNodeMarkerClass(nodeId) {
            const isRoot = treeRootId.value === nodeId;
            if (isRoot && isTreeLayout(layoutMode.value)) return " tree-root-node"; // Red border for tree root
            return "";
        }
        // Helper: Extract tags from event
        function extractTags(event) {
            if (!event.tags) return [];
            return event.tags.filter((tag)=>tag[0] === "t" && tag[1]).map((tag)=>tag[1]);
        }
        // Helper: Extract mentions from event
        function extractMentions(event) {
            if (!event.tags) return [];
            return event.tags.filter((tag)=>tag[0] === "p" && tag[1]).map((tag)=>({
                    pubkey: tag[1],
                    relay: tag[2]
                }));
        }
        // Helper: Check if event is a reply
        function isReply(event) {
            if (!event.tags) return {
                isReply: false
            };
            const eTags = event.tags.filter((tag)=>tag[0] === "e" && tag[1]);
            if (eTags.length === 0) return {
                isReply: false
            };
            // Find root and reply markers
            const rootTag = eTags.find((tag)=>tag[3] === "root");
            const replyTag = eTags.find((tag)=>tag[3] === "reply");
            return {
                isReply: true,
                root: rootTag ? rootTag[1] : eTags[0][1],
                replyTo: replyTag ? replyTag[1] : eTags.length > 1 ? eTags[eTags.length - 1][1] : undefined
            };
        }
        // Helper: Format relative time
        function getRelativeTime(timestamp) {
            const seconds = Math.floor(Date.now() / 1000 - timestamp);
            if (seconds < 60) return "just now";
            if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
            if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
            if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
            if (seconds < 2592000) return `${Math.floor(seconds / 604800)}w ago`;
            return new Date(timestamp * 1000).toLocaleDateString();
        }
        // Helper: Count engagement metrics for an event
        function getEngagementMetrics(eventId) {
            const metrics = {
                replies: 0,
                reactions: 0,
                reposts: 0,
                zaps: 0
            };
            // Count from all nodes in the graph
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                if (!event) return;
                // Check if this event references the target event
                const eTags = event.tags?.filter((t)=>t[0] === "e") || [];
                const referencesEvent = eTags.some((t)=>t[1] === eventId);
                if (referencesEvent) {
                    if (event.kind === 1) metrics.replies++;
                    else if (event.kind === 7) metrics.reactions++;
                    else if (event.kind === 6) metrics.reposts++;
                    else if (event.kind === 9735) metrics.zaps++;
                }
            });
            return metrics;
        }
        // Helper: Render HTML for event node
        function renderEventNode(d) {
            // Handle virtual tree root
            if (d.id === "__tree_super_root__" && d.data?.isVirtualRoot) return `
      <div class="node-circle virtual-root-node" data-item-id="${d.id}" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); border: 4px solid #667eea;">
        <span class="node-emoji" style="font-size: 32px;">\u{1F333}</span>
      </div>
    `;
            // Handle tag nodes
            if (d.data?.type === "tag") {
                const tag = d.data?.tag || "";
                const nodeId = d.id || "";
                const tagColor = d.data?.color || "#f59e0b";
                const markerClass = getNodeMarkerClass(nodeId);
                return `
      <div class="node-circle tag-node${markerClass}" data-item-id="${nodeId}" data-tag="${tag}" style="background: ${tagColor}; border: 4px solid ${tagColor};">
        <span class="node-tag-label">#${tag}</span>
      </div>
    `;
            }
            // Handle pubkey (author) nodes
            if (d.data?.type === "pubkey") {
                const profile = d.data?.profile;
                const expanded = !!d.data?.expanded;
                // If collapsed, show compact profile circle
                if (!expanded) {
                    const nodeId = d.id || "";
                    const pubkey = d.data?.pubkey || "";
                    const markerClass = getNodeMarkerClass(nodeId);
                    if (profile?.picture) // Show profile picture
                    return `
          <div class="node-circle pubkey-node with-picture${markerClass}" data-item-id="${nodeId}" data-pubkey="${pubkey}" style="background: #fff;">
            <img src="${profile.picture}" class="profile-picture" alt="${profile.name || "User"}" />
          </div>
        `;
                    else // Show default user icon
                    return `
          <div class="node-circle pubkey-node${markerClass}" data-item-id="${nodeId}" data-pubkey="${pubkey}" style="background: #6366f1;">
            <span class="node-emoji">\u{1F464}</span>
          </div>
        `;
                }
                // Expanded: show profile details if available
                if (profile) {
                    const safe = (s)=>String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
                    const displayName = safe(profile.name || profile.display_name || "Unknown User");
                    const about = safe(profile.about || "No bio available");
                    const nip05 = safe(profile.nip05 || "");
                    const pubkey = safe(d.data?.pubkey || "");
                    const nodeId = safe(d.id || "");
                    return `
        <div class="event-node expanded profile-card" data-item-id="${nodeId}" data-pubkey="${pubkey}">
          <div class="event-titlebar" data-role="titlebar">
            <div class="event-left">
              <span class="event-badge">\u{1F464} Profile</span>
              <span class="event-title">${displayName}</span>
            </div>
            <div class="event-close" data-role="close">\xd7</div>
          </div>
          <div class="event-body">
            ${profile.picture ? `
              <div class="profile-picture-large">
                <img src="${profile.picture}" alt="${displayName}" />
              </div>
            ` : ""}
            <div class="event-meta">
              <div><strong>Name:</strong> ${displayName}</div>
              ${nip05 ? `<div><strong>NIP-05:</strong> ${nip05}</div>` : ""}
              <div><strong>Pubkey:</strong> ${pubkey.slice(0, 16)}...</div>
            </div>
            <div class="event-content profile-bio">${about}</div>
          </div>
        </div>
      `;
                }
                // No profile data available
                const noProfNodeId = d.id || "";
                const noProfPubkey = d.data?.pubkey || "";
                const markerClass = getNodeMarkerClass(noProfNodeId);
                return `
      <div class="node-circle pubkey-node${markerClass}" data-item-id="${noProfNodeId}" data-pubkey="${noProfPubkey}" style="background: #6366f1;">
        <span class="node-emoji">\u{1F464}</span>
      </div>
    `;
            }
            // Handle event nodes
            const event = d.data?.event;
            if (!event) return '<div class="node-circle loading"><span>?</span></div>';
            const expanded = !!d.data?.expanded;
            const kind = event.kind;
            const typeLabel = getEventTypeLabel(kind);
            const kindColor = getKindColor(kind);
            // If collapsed, render as simple circle
            if (!expanded) {
                const emoji = typeLabel.split(" ")[0]; // Get just the emoji
                const nodeId = d.id || "";
                const markerClass = getNodeMarkerClass(nodeId);
                return `
      <div class="node-circle kind-${kind}${markerClass}" data-item-id="${nodeId}" style="background: ${kindColor}; border: 3px solid ${kindColor};">
        <span class="node-emoji">${emoji}</span>
      </div>
    `;
            }
            // Helper for HTML-safe strings (used in expanded views below)
            const safe = (s)=>String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
            // Kanban Board (kind 30301) - expanded
            if (kind === 30301) {
                const nodeId = safe(d.id || "");
                const title = safe(event.tags?.find((t)=>t[0] === "title")?.[1] || "Untitled Board");
                const description = safe(event.tags?.find((t)=>t[0] === "description")?.[1] || event.content || "");
                const columns = event.tags?.filter((t)=>t[0] === "col") || [];
                const maintainers = event.tags?.filter((t)=>t[0] === "p").map((t)=>t[1]) || [];
                const timestamp = getRelativeTime(event.created_at);
                const absoluteTime = new Date(event.created_at * 1000).toLocaleString();
                const isLoading = expandingNodes.value.has(nodeId);
                const columnsHtml = columns.length > 0 ? `<div class="kanban-columns">
          ${columns.map((col)=>{
                    const colName = safe(col[2] || col[1] || "?");
                    const colColor = col[3] || "#64748b";
                    return `<span class="kanban-col-badge" style="background: ${colColor}; color: #fff; padding: 2px 8px; border-radius: 10px; font-size: 11px; margin: 2px;">${colName}</span>`;
                }).join("")}
        </div>` : "";
                return `
      <div class="event-node expanded kanban-board${isLoading ? " node-loading" : ""}" data-item-id="${nodeId}" data-kind="30301">
        <div class="event-titlebar" data-role="titlebar" style="background: ${kindColor};">
          <div class="event-left">
            <span class="event-badge">\u{1F4CB} Board</span>
            <span class="event-title" title="${absoluteTime}">${timestamp}</span>
          </div>
          <div class="event-close" data-role="close">\xd7</div>
        </div>
        <div class="event-body">
          <div class="kanban-board-title" style="font-size: 15px; font-weight: 600; margin-bottom: 6px;">${title}</div>
          ${description ? `<div class="event-content" style="font-size: 12px; color: #94a3b8; margin-bottom: 6px;">${description}</div>` : ""}
          ${columnsHtml}
          <div class="event-meta" style="font-size: 11px; color: #64748b; margin-top: 6px;">
            ${maintainers.length > 0 ? `<span>\u{1F465} ${maintainers.length} maintainer${maintainers.length > 1 ? "s" : ""}</span>` : ""}
          </div>
        </div>
        <div class="event-footer">
          <div class="event-stats">
            <span class="stat-item" data-role="stat-replies" data-event-id="${nodeId}" title="Fetch cards">\u{1F5C2}\u{FE0F} Cards</span>
          </div>
        </div>
      </div>
    `;
            }
            // Kanban Card (kind 30302) - expanded
            if (kind === 30302) {
                const nodeId = safe(d.id || "");
                const title = safe(event.tags?.find((t)=>t[0] === "title")?.[1] || "Untitled Card");
                const description = event.tags?.find((t)=>t[0] === "description")?.[1] || event.content || "";
                const colLabel = safe(event.tags?.find((t)=>t[0] === "col_label")?.[1] || "");
                const status = safe(event.tags?.find((t)=>t[0] === "s")?.[1] || "");
                const assignees = event.tags?.filter((t)=>t[0] === "p").map((t)=>t[1]) || [];
                const attachments = event.tags?.filter((t)=>t[0] === "u").map((t)=>t[1]) || [];
                const isTracker = event.tags?.some((t)=>t[0] === "k");
                const timestamp = getRelativeTime(event.created_at);
                const absoluteTime = new Date(event.created_at * 1000).toLocaleString();
                const bodyContent = md.render(description);
                return `
      <div class="event-node expanded kanban-card" data-item-id="${nodeId}" data-kind="30302">
        <div class="event-titlebar" data-role="titlebar" style="background: ${kindColor};">
          <div class="event-left">
            <span class="event-badge">${isTracker ? "\uD83D\uDD17 Tracker" : "\uD83D\uDDC2\uFE0F Card"}</span>
            ${colLabel ? `<span class="kanban-col-badge" style="background: rgba(255,255,255,0.2); color: #fff; padding: 1px 6px; border-radius: 8px; font-size: 10px;">${colLabel}</span>` : ""}
            <span class="event-title" title="${absoluteTime}">${timestamp}</span>
          </div>
          <div class="event-close" data-role="close">\xd7</div>
        </div>
        <div class="event-body">
          <div style="font-size: 14px; font-weight: 600; margin-bottom: 4px;">${safe(title)}</div>
          ${bodyContent ? `<div class="event-content markdown-content">${bodyContent}</div>` : ""}
          ${assignees.length > 0 ? `<div style="font-size: 11px; color: #94a3b8; margin-top: 4px;">\u{1F464} ${assignees.map((a)=>safe(a.slice(0, 8)) + "\u2026").join(", ")}</div>` : ""}
          ${attachments.length > 0 ? `<div style="font-size: 11px; color: #94a3b8; margin-top: 2px;">\u{1F4CE} ${attachments.length} attachment${attachments.length > 1 ? "s" : ""}</div>` : ""}
        </div>
      </div>
    `;
            }
            const nodeId = safe(d.id || "");
            const timestamp = getRelativeTime(event.created_at);
            const absoluteTime = new Date(event.created_at * 1000).toLocaleString();
            // Extract metadata
            const tags = extractTags(event);
            const mentions = extractMentions(event);
            const threadInfo = isReply(event);
            // Get engagement metrics
            const metrics = getEngagementMetrics(event.id);
            // Count mentions (e tags in this event)
            const mentionsCount = event.tags?.filter((t)=>t[0] === "e").length || 0;
            // Check if part of thread (has parent or replies)
            const hasThread = threadInfo.isReply || metrics.replies > 0;
            // Get author info (from graph data if available)
            const authorPubkey = safe(event.pubkey);
            const authorDisplay = authorPubkey.slice(0, 8) + "...";
            // Format content with markdown for kind 1 and 30023
            let bodyContent = "";
            if (kind === 1 || kind === 30023) bodyContent = md.render(event.content);
            else if (kind === 0) try {
                const profile = JSON.parse(event.content);
                bodyContent = `<pre>${safe(JSON.stringify(profile, null, 2))}</pre>`;
            } catch  {
                bodyContent = safe(event.content);
            }
            else bodyContent = md.render(event.content);
            // Calculate dynamic height based on content
            const contentLength = event.content.length;
            const baseHeight = 200;
            const heightPerChar = 0.3;
            const maxHeight = 600;
            const minHeight = 200;
            const dynamicHeight = Math.min(maxHeight, Math.max(minHeight, baseHeight + contentLength * heightPerChar));
            const isLoading = expandingNodes.value.has(nodeId);
            return `
    <div class="event-node expanded${isLoading ? " node-loading" : ""}"
         data-item-id="${nodeId}"
         data-kind="${kind}"
         data-author="${authorPubkey}">

      <!-- Titlebar matching profile card design -->
      <div class="event-titlebar" data-role="titlebar" style="background: ${kindColor};">
        <div class="event-left">
          <span class="event-badge">${typeLabel}</span>
          ${threadInfo.isReply ? '<span class="thread-indicator" title="Reply">\u21A9\uFE0F</span>' : ""}
          ${kind === 6 ? '<span class="thread-indicator" title="Repost">\uD83D\uDD04</span>' : ""}
          <span class="event-title" title="${absoluteTime}">${timestamp}</span>
        </div>
        <div class="event-close" data-role="close">\xd7</div>
      </div>

      <!-- Event Body -->
      <div class="event-body">
        <!-- Author Info -->
        <div class="event-author" data-author-pubkey="${authorPubkey}">
          <div class="author-avatar" style="background: ${kindColor};">\u{1F464}</div>
          <div class="author-info">
            <div class="author-name" title="${authorPubkey}">${authorDisplay}</div>
          </div>
        </div>

        <!-- Content -->
        <div class="event-content markdown-content">
          ${bodyContent}
        </div>

        <!-- Tags -->
        ${tags.length > 0 ? `
          <div class="event-tags">
            ${tags.map((tag)=>`<span class="tag-badge" data-tag="${safe(tag)}">#${safe(tag)}</span>`).join("")}
          </div>
        ` : ""}

        <!-- Mentions -->
        ${mentions.length > 0 ? `
          <div class="event-mentions">
            <span class="mentions-label">Mentioned:</span>
            ${mentions.slice(0, 3).map((m)=>`<span class="mention-badge" data-mention="${m.pubkey}" title="${m.pubkey}">@${m.pubkey.slice(0, 8)}...</span>`).join("")}
            ${mentions.length > 3 ? `<span class="mention-more">+${mentions.length - 3} more</span>` : ""}
          </div>
        ` : ""}
      </div>

      <!-- Footer: Always visible engagement metrics -->
      <div class="event-footer">
        <div class="event-stats">
          <span class="stat-item${metrics.replies > 0 ? " has-count" : ""}"
                data-role="stat-replies"
                data-event-id="${nodeId}"
                title="Left-click: refresh | Right-click: expand/hide/update">
            \u{1F4AC} ${metrics.replies || 0}
          </span>
          <span class="stat-item${metrics.reactions > 0 ? " has-count" : ""}"
                data-role="stat-reactions"
                data-event-id="${nodeId}"
                title="Left-click: refresh | Right-click: expand/hide/update">
            \u{2764}\u{FE0F} ${metrics.reactions || 0}
          </span>
          <span class="stat-item${metrics.reposts > 0 ? " has-count" : ""}"
                data-role="stat-reposts"
                data-event-id="${nodeId}"
                title="Left-click: refresh | Right-click: expand/hide/update">
            \u{1F504} ${metrics.reposts || 0}
          </span>
          <span class="stat-item${mentionsCount > 0 ? " has-count" : ""}"
                data-role="stat-mentions"
                data-event-id="${nodeId}"
                title="Left-click: refresh | Right-click: expand/hide/update">
            \u{1F517} ${mentionsCount || 0}
          </span>
          <span class="stat-item${hasThread ? " has-count" : ""}"
                data-role="stat-thread"
                data-event-id="${nodeId}"
                title="Left-click: refresh | Right-click: expand/hide/update">
            \u{1F9F5} ${hasThread ? "\u2022" : "\u25CB"}
          </span>
        </div>
      </div>

    </div>
  `;
        }
        function getEventTypeLabel(kind) {
            const labels = {
                0: "\uD83D\uDC64 Profile",
                1: "\uD83D\uDCDD Note",
                3: "\uD83D\uDC65 Contacts",
                4: "\uD83D\uDCAC DM",
                5: "\uD83D\uDDD1\uFE0F Delete",
                6: "\uD83D\uDD04 Repost",
                7: "\u2764\uFE0F Reaction",
                9735: "\u26A1 Zap",
                30023: "\uD83D\uDCC4 Article",
                30301: "\uD83D\uDCCB Board",
                30302: "\uD83D\uDDC2\uFE0F Card",
                30303: "\uD83D\uDCF8 Snapshot"
            };
            return labels[kind] || `Kind ${kind}`;
        }
        // Tree layout helpers
        // Check if a layout requires tree data structure
        function isTreeLayout(layoutType) {
            const treeLayouts = [
                "mindmap",
                "dendrogram",
                "compact-box",
                "indented",
                "dagre",
                "fishbone"
            ];
            return treeLayouts.includes(layoutType);
        }
        // Find best root node for tree layout
        // Priority: 1) Previously set tree root, 2) Node with most outgoing edges, 3) Node with no incoming edges
        function findBestRoot(nodes, edges) {
            if (nodes.length === 0) return null;
            // If there's a previously set tree root, use it
            if (treeRootId.value && nodes.some((n)=>n.id === treeRootId.value)) {
                console.log("[Tree] Using previously set root:", treeRootId.value);
                return treeRootId.value;
            }
            // Count incoming and outgoing edges for each node
            const inDegree = new Map();
            const outDegree = new Map();
            nodes.forEach((n)=>{
                inDegree.set(n.id, 0);
                outDegree.set(n.id, 0);
            });
            edges.forEach((e)=>{
                outDegree.set(e.source, (outDegree.get(e.source) || 0) + 1);
                inDegree.set(e.target, (inDegree.get(e.target) || 0) + 1);
            });
            // Find nodes with no incoming edges (potential roots)
            const rootCandidates = nodes.filter((n)=>(inDegree.get(n.id) || 0) === 0);
            if (rootCandidates.length > 0) {
                // From root candidates, pick the one with most outgoing edges
                const bestRoot = rootCandidates.reduce((best, node)=>{
                    const bestOut = outDegree.get(best.id) || 0;
                    const nodeOut = outDegree.get(node.id) || 0;
                    return nodeOut > bestOut ? node : best;
                });
                console.log("[Tree] Found root node (no incoming edges):", bestRoot.id);
                return bestRoot.id;
            }
            // No clear root - pick node with best outgoing/incoming ratio
            const bestNode = nodes.reduce((best, node)=>{
                const bestOut = outDegree.get(best.id) || 0;
                const nodeOut = outDegree.get(node.id) || 0;
                return nodeOut > bestOut ? node : best;
            });
            console.log("[Tree] Using node with most outgoing edges as root:", bestNode.id);
            return bestNode.id;
        }
        // Convert any graph to tree-compatible format for G6 layouts
        // Creates a spanning tree that includes all nodes, handling cycles and disconnected components
        function prepareTreeData(nodes, edges, rootId) {
            console.log("[Tree] Preparing tree data with root:", rootId, "nodes:", nodes.length, "edges:", edges.length);
            // Build directed adjacency map for tree structure: parent -> children IDs
            const childrenMap = new Map();
            edges.forEach((edge)=>{
                if (!childrenMap.has(edge.source)) childrenMap.set(edge.source, []);
                childrenMap.get(edge.source).push(edge.target);
            });
            // Build bidirectional adjacency map for finding connected components
            const adjacencyMap = new Map();
            nodes.forEach((node)=>{
                adjacencyMap.set(node.id, []);
            });
            edges.forEach((edge)=>{
                // Add edge in both directions for connectivity checking
                adjacencyMap.get(edge.source).push(edge.target);
                adjacencyMap.get(edge.target).push(edge.source);
            });
            // First pass: Find all nodes in the connected component containing the root
            // This uses bidirectional edges to ensure we find all connected nodes
            const connectedNodes = new Set();
            const connectivityQueue = [
                rootId
            ];
            while(connectivityQueue.length > 0){
                const nodeId = connectivityQueue.shift();
                if (connectedNodes.has(nodeId)) continue;
                connectedNodes.add(nodeId);
                const neighbors = adjacencyMap.get(nodeId) || [];
                neighbors.forEach((neighborId)=>{
                    if (!connectedNodes.has(neighborId)) connectivityQueue.push(neighborId);
                });
            }
            // Second pass: Build spanning tree using directed edges (for proper parent-child relationships)
            const depthMap = new Map();
            const treeChildren = new Map(); // Tree edges only (no cycles)
            const queue = [
                {
                    id: rootId,
                    depth: 0
                }
            ];
            const visited = new Set();
            while(queue.length > 0){
                const { id: id, depth: depth } = queue.shift();
                if (visited.has(id)) continue; // Skip already visited (breaks cycles)
                visited.add(id);
                depthMap.set(id, depth);
                const children = childrenMap.get(id) || [];
                const validChildren = [];
                children.forEach((childId)=>{
                    if (!visited.has(childId)) {
                        validChildren.push(childId);
                        queue.push({
                            id: childId,
                            depth: depth + 1
                        });
                    }
                });
                if (validChildren.length > 0) treeChildren.set(id, validChildren);
            }
            // Find truly orphaned nodes (in disconnected components)
            const orphanedNodes = [];
            nodes.forEach((node)=>{
                if (!connectedNodes.has(node.id)) orphanedNodes.push(node.id);
            });
            // Find nodes that are connected but not visited by directed BFS
            // These need to be added to the tree using reverse edges
            const unvisitedConnected = [];
            connectedNodes.forEach((nodeId)=>{
                if (!visited.has(nodeId)) unvisitedConnected.push(nodeId);
            });
            // Add unvisited connected nodes to the tree by finding paths using bidirectional edges
            if (unvisitedConnected.length > 0) {
                console.log("[Tree] Found", unvisitedConnected.length, "connected but unreachable nodes (using bidirectional edges to add them)");
                unvisitedConnected.forEach((nodeId)=>{
                    // Find a visited node that's adjacent to this unvisited node
                    const neighbors = adjacencyMap.get(nodeId) || [];
                    const visitedNeighbor = neighbors.find((n)=>visited.has(n));
                    if (visitedNeighbor) {
                        // Add this node as a child of a visited neighbor (check for duplicates)
                        const existingChildren = treeChildren.get(visitedNeighbor) || [];
                        if (!existingChildren.includes(nodeId)) treeChildren.set(visitedNeighbor, [
                            ...existingChildren,
                            nodeId
                        ]);
                        // Set depth one level deeper than the parent
                        const parentDepth = depthMap.get(visitedNeighbor) || 0;
                        depthMap.set(nodeId, parentDepth + 1);
                        visited.add(nodeId);
                        // Also check if this newly added node has children via directed edges
                        const newNodeQueue = [
                            {
                                id: nodeId,
                                depth: parentDepth + 1
                            }
                        ];
                        while(newNodeQueue.length > 0){
                            const { id: id, depth: depth } = newNodeQueue.shift();
                            const children = childrenMap.get(id) || [];
                            const validChildren = [];
                            children.forEach((childId)=>{
                                if (!visited.has(childId) && connectedNodes.has(childId)) {
                                    validChildren.push(childId);
                                    visited.add(childId);
                                    depthMap.set(childId, depth + 1);
                                    newNodeQueue.push({
                                        id: childId,
                                        depth: depth + 1
                                    });
                                }
                            });
                            if (validChildren.length > 0) {
                                // Merge with existing children, avoiding duplicates
                                const existing = treeChildren.get(id) || [];
                                const merged = [
                                    ...existing
                                ];
                                validChildren.forEach((child)=>{
                                    if (!merged.includes(child)) merged.push(child);
                                });
                                treeChildren.set(id, merged);
                            }
                        }
                    }
                });
            }
            // Create a virtual super-root if there are orphaned nodes (disconnected components)
            if (orphanedNodes.length > 0) {
                console.log("[Tree] Found", orphanedNodes.length, "orphaned nodes. Creating virtual super-root.");
                // Ensure rootId is not in orphanedNodes (should never happen, but safety check)
                const cleanOrphans = orphanedNodes.filter((id)=>id !== rootId);
                // Add virtual root
                const superRoot = {
                    id: "__tree_super_root__",
                    label: "\uD83C\uDF33 Graph Root",
                    data: {
                        isVirtualRoot: true,
                        kind: -1
                    },
                    children: [
                        rootId,
                        ...cleanOrphans
                    ],
                    depth: 0
                };
                // Add main root and orphans as children of super-root
                treeChildren.set("__tree_super_root__", [
                    rootId,
                    ...cleanOrphans
                ]);
                // Process orphaned nodes with BFS to find their subtrees
                cleanOrphans.forEach((orphanId)=>{
                    const orphanQueue = [
                        {
                            id: orphanId,
                            depth: 1
                        }
                    ];
                    while(orphanQueue.length > 0){
                        const { id: id, depth: depth } = orphanQueue.shift();
                        if (visited.has(id)) continue;
                        visited.add(id);
                        depthMap.set(id, depth);
                        const children = childrenMap.get(id) || [];
                        const validChildren = [];
                        children.forEach((childId)=>{
                            if (!visited.has(childId)) {
                                validChildren.push(childId);
                                orphanQueue.push({
                                    id: childId,
                                    depth: depth + 1
                                });
                            }
                        });
                        if (validChildren.length > 0) treeChildren.set(id, validChildren);
                    }
                });
                // Increment all depths by 1 to make room for super-root
                const newDepthMap = new Map();
                depthMap.forEach((depth, nodeId)=>{
                    newDepthMap.set(nodeId, depth + 1);
                });
                newDepthMap.set("__tree_super_root__", 0);
                // Deduplicate all children arrays in treeChildren to prevent duplicate edges
                const deduplicatedTreeChildren = new Map();
                treeChildren.forEach((children, parent)=>{
                    deduplicatedTreeChildren.set(parent, Array.from(new Set(children)));
                });
                // Create enriched nodes including super-root (using deduplicated children)
                const enrichedNodes = [
                    superRoot,
                    ...nodes.map((node)=>({
                            ...node,
                            children: deduplicatedTreeChildren.get(node.id) || [],
                            depth: newDepthMap.get(node.id) ?? 0
                        }))
                ];
                // Build tree edges based on treeChildren relationships
                // Start with super-root edges
                const treeEdges = [
                    {
                        source: "__tree_super_root__",
                        target: rootId,
                        data: {
                            type: "tree-structure"
                        }
                    },
                    ...cleanOrphans.map((id)=>({
                            source: "__tree_super_root__",
                            target: id,
                            data: {
                                type: "tree-structure"
                            }
                        }))
                ];
                // Track added edges to prevent duplicates and cycles
                const addedEdges = new Set();
                treeEdges.forEach((e)=>addedEdges.add(`${e.source}->${e.target}`));
                // Add edges for all other parent-child relationships
                deduplicatedTreeChildren.forEach((children, parent)=>{
                    // Skip super-root edges (already added above)
                    if (parent === "__tree_super_root__") return;
                    children.forEach((child)=>{
                        const edgeKey = `${parent}->${child}`;
                        const reverseEdgeKey = `${child}->${parent}`;
                        // Skip if we've already added this edge or its reverse (prevents cycles)
                        if (addedEdges.has(edgeKey) || addedEdges.has(reverseEdgeKey)) {
                            console.warn("[Tree] Skipping duplicate/reverse edge:", edgeKey);
                            return;
                        }
                        // Validate: child should have greater depth than parent (no cycles)
                        const parentDepth = newDepthMap.get(parent) ?? -1;
                        const childDepth = newDepthMap.get(child) ?? -1;
                        if (childDepth <= parentDepth && child !== "__tree_super_root__" && parent !== "__tree_super_root__") {
                            console.warn("[Tree] Skipping edge with invalid depth:", parent, "\u2192", child, "depths:", parentDepth, "\u2192", childDepth);
                            return;
                        }
                        addedEdges.add(edgeKey);
                        // Look for an edge in either direction between parent and child
                        const existingEdge = edges.find((e)=>e.source === parent && e.target === child || e.source === child && e.target === parent);
                        if (existingEdge) // Use existing edge but ensure correct direction (parent → child)
                        treeEdges.push({
                            ...existingEdge,
                            source: parent,
                            target: child
                        });
                        else // Create synthetic edge if none exists
                        treeEdges.push({
                            source: parent,
                            target: child,
                            data: {
                                type: "tree-structure"
                            }
                        });
                    });
                });
                console.log("[Tree] Created", treeEdges.length, "tree edges for", enrichedNodes.length, "nodes (with super-root)");
                // ALWAYS validate tree structure to prevent cycles (even if count is correct)
                // Build parent map and detect cycles by ensuring each node has at most one parent
                const parentMap = new Map();
                const seenEdges = new Set();
                const validEdges = [];
                treeEdges.forEach((edge)=>{
                    const edgeKey = `${edge.source}->${edge.target}`;
                    // Skip duplicates
                    if (seenEdges.has(edgeKey)) {
                        console.warn("[Tree] Removing duplicate edge:", edgeKey);
                        return;
                    }
                    // Check for cycle: target should not already have a parent
                    if (parentMap.has(edge.target)) {
                        console.warn("[Tree] Removing edge that creates multiple parents:", edgeKey, "(target already has parent:", parentMap.get(edge.target), ")");
                        return;
                    }
                    seenEdges.add(edgeKey);
                    parentMap.set(edge.target, edge.source);
                    validEdges.push(edge);
                });
                // Check if validation removed any edges
                if (validEdges.length !== treeEdges.length) console.warn("[Tree] Removed", treeEdges.length - validEdges.length, "invalid edges. New count:", validEdges.length);
                // Verify final edge count
                if (validEdges.length !== enrichedNodes.length - 1) console.warn("[Tree] Invalid tree (super-root): expected", enrichedNodes.length - 1, "edges but got", validEdges.length);
                // Update enriched nodes to match validated edges
                const validatedChildrenMap = new Map();
                validEdges.forEach((edge)=>{
                    const children = validatedChildrenMap.get(edge.source) || [];
                    children.push(edge.target);
                    validatedChildrenMap.set(edge.source, children);
                });
                const cleanedNodes = enrichedNodes.map((node)=>({
                        ...node,
                        children: validatedChildrenMap.get(node.id) || []
                    }));
                console.log("[Tree] Returning validated tree with", cleanedNodes.length, "nodes and", validEdges.length, "edges");
                return {
                    nodes: cleanedNodes,
                    edges: validEdges
                };
            }
            // No orphaned nodes - return simple tree
            // Deduplicate all children arrays in treeChildren to prevent duplicate edges
            const deduplicatedTreeChildren = new Map();
            treeChildren.forEach((children, parent)=>{
                deduplicatedTreeChildren.set(parent, Array.from(new Set(children)));
            });
            const enrichedNodes = nodes.map((node)=>({
                    ...node,
                    children: deduplicatedTreeChildren.get(node.id) || [],
                    depth: depthMap.get(node.id) ?? 0
                }));
            // Build tree edges based on treeChildren relationships
            // For each parent-child relationship, find or create an edge
            // Add cycle detection to prevent infinite recursion
            const treeEdges = [];
            const addedEdges = new Set(); // Track edges to prevent duplicates
            deduplicatedTreeChildren.forEach((children, parent)=>{
                children.forEach((child)=>{
                    const edgeKey = `${parent}->${child}`;
                    const reverseEdgeKey = `${child}->${parent}`;
                    // Skip if we've already added this edge or its reverse (prevents cycles)
                    if (addedEdges.has(edgeKey) || addedEdges.has(reverseEdgeKey)) {
                        console.warn("[Tree] Skipping duplicate/reverse edge:", edgeKey);
                        return;
                    }
                    // Validate: child should have greater depth than parent (no cycles)
                    const parentDepth = depthMap.get(parent) ?? -1;
                    const childDepth = depthMap.get(child) ?? -1;
                    if (childDepth <= parentDepth && child !== "__tree_super_root__" && parent !== "__tree_super_root__") {
                        console.warn("[Tree] Skipping edge with invalid depth:", parent, "\u2192", child, "depths:", parentDepth, "\u2192", childDepth);
                        return;
                    }
                    addedEdges.add(edgeKey);
                    // Look for an edge in either direction between parent and child
                    const existingEdge = edges.find((e)=>e.source === parent && e.target === child || e.source === child && e.target === parent);
                    if (existingEdge) // Use existing edge but ensure correct direction (parent → child)
                    treeEdges.push({
                        ...existingEdge,
                        source: parent,
                        target: child
                    });
                    else // Create synthetic edge if none exists (shouldn't happen in connected graph)
                    treeEdges.push({
                        source: parent,
                        target: child,
                        data: {
                            type: "tree-structure"
                        }
                    });
                });
            });
            console.log("[Tree] Created", treeEdges.length, "tree edges for", enrichedNodes.length, "nodes");
            // ALWAYS validate tree structure to prevent cycles (even if count is correct)
            // Build parent map and detect cycles by ensuring each node has at most one parent
            const parentMap = new Map();
            const seenEdges = new Set();
            const validEdges = [];
            treeEdges.forEach((edge)=>{
                const edgeKey = `${edge.source}->${edge.target}`;
                // Skip duplicates
                if (seenEdges.has(edgeKey)) {
                    console.warn("[Tree] Removing duplicate edge:", edgeKey);
                    return;
                }
                // Check for cycle: target should not already have a parent
                if (parentMap.has(edge.target)) {
                    console.warn("[Tree] Removing edge that creates multiple parents:", edgeKey, "(target already has parent:", parentMap.get(edge.target), ")");
                    return;
                }
                seenEdges.add(edgeKey);
                parentMap.set(edge.target, edge.source);
                validEdges.push(edge);
            });
            // Check if validation removed any edges
            if (validEdges.length !== treeEdges.length) console.warn("[Tree] Removed", treeEdges.length - validEdges.length, "invalid edges. New count:", validEdges.length);
            // Verify final edge count
            if (validEdges.length !== enrichedNodes.length - 1) console.warn("[Tree] Invalid tree: expected", enrichedNodes.length - 1, "edges but got", validEdges.length);
            // Update enriched nodes to match validated edges
            const validatedChildrenMap = new Map();
            validEdges.forEach((edge)=>{
                const children = validatedChildrenMap.get(edge.source) || [];
                children.push(edge.target);
                validatedChildrenMap.set(edge.source, children);
            });
            const cleanedNodes = enrichedNodes.map((node)=>({
                    ...node,
                    children: validatedChildrenMap.get(node.id) || []
                }));
            console.log("[Tree] Returning validated tree with", cleanedNodes.length, "nodes and", validEdges.length, "edges");
            return {
                nodes: cleanedNodes,
                edges: validEdges
            };
        }
        // Helper: Get layout config based on layout type
        function getLayoutConfig(type) {
            const settings = layoutSettings.value;
            // Helper: Get actual node size - always use card size for layout spacing
            // (Visual rendering stays small when collapsed, but layout reserves full card space)
            const getNodeSize = (_node)=>{
                return Math.max(400, 300); // Use max dimension for radius calculations (always card size)
            };
            const getNodeWidth = (_node)=>{
                return 400; // Always reserve card width
            };
            const getNodeHeight = (_node)=>{
                return 300; // Always reserve card height
            };
            switch(type){
                case "force":
                    return {
                        type: "force",
                        center: [
                            settings.force.centerX,
                            settings.force.centerY
                        ],
                        linkDistance: settings.force.linkDistance,
                        edgeStrength: settings.force.edgeStrength,
                        nodeStrength: settings.force.nodeStrength,
                        preventOverlap: settings.force.preventOverlap,
                        nodeSize: getNodeSize,
                        nodeSpacing: settings.force.nodeSpacing,
                        clustering: settings.force.clustering,
                        clusterNodeStrength: settings.force.clusterNodeStrength,
                        alpha: settings.force.alpha,
                        alphaDecay: settings.force.alphaDecay,
                        alphaMin: settings.force.alphaMin
                    };
                case "d3-force":
                    return {
                        type: "d3-force",
                        link: {
                            distance: settings.d3Force.linkDistance,
                            strength: settings.d3Force.linkStrength,
                            iterations: settings.d3Force.linkIterations
                        },
                        manyBody: {
                            strength: settings.d3Force.manyBodyStrength,
                            theta: settings.d3Force.manyBodyTheta,
                            distanceMin: settings.d3Force.manyBodyDistanceMin,
                            distanceMax: settings.d3Force.manyBodyDistanceMax
                        },
                        center: {
                            x: settings.d3Force.centerX,
                            y: settings.d3Force.centerY,
                            strength: settings.d3Force.centerStrength
                        },
                        collide: {
                            radius: (node)=>{
                                const baseSize = getNodeSize(node);
                                // Add collision radius offset to the actual node size
                                return baseSize / 2 + settings.d3Force.collideRadius;
                            },
                            strength: settings.d3Force.collideStrength,
                            iterations: settings.d3Force.collideIterations
                        },
                        forceX: settings.d3Force.forceXEnabled ? {
                            x: settings.d3Force.forceXX,
                            strength: settings.d3Force.forceXStrength
                        } : undefined,
                        forceY: settings.d3Force.forceYEnabled ? {
                            y: settings.d3Force.forceYY,
                            strength: settings.d3Force.forceYStrength
                        } : undefined,
                        radial: settings.d3Force.radialEnabled ? {
                            x: settings.d3Force.radialX,
                            y: settings.d3Force.radialY,
                            radius: settings.d3Force.radialRadius,
                            strength: settings.d3Force.radialStrength
                        } : undefined,
                        alpha: settings.d3Force.alpha,
                        alphaMin: settings.d3Force.alphaMin,
                        alphaDecay: settings.d3Force.alphaDecay,
                        alphaTarget: settings.d3Force.alphaTarget,
                        velocityDecay: settings.d3Force.velocityDecay
                    };
                case "circular":
                    return {
                        type: "circular",
                        radius: settings.circular.radius,
                        startRadius: settings.circular.startRadius,
                        endRadius: settings.circular.endRadius,
                        divisions: settings.circular.divisions,
                        angleRatio: settings.circular.angleRatio,
                        clockwise: settings.circular.clockwise,
                        ordering: settings.circular.ordering,
                        startAngle: settings.circular.startAngle,
                        endAngle: settings.circular.endAngle,
                        nodeSize: getNodeSize,
                        nodeSpacing: settings.circular.nodeSpacing
                    };
                case "compact-box":
                    return {
                        type: "compact-box",
                        direction: settings.compactBox.direction,
                        getHeight: (node)=>getNodeHeight(node),
                        getWidth: (node)=>getNodeWidth(node),
                        getVGap: ()=>settings.compactBox.vGap,
                        getHGap: ()=>settings.compactBox.hGap
                    };
                case "dagre":
                    return {
                        type: "dagre",
                        rankdir: settings.dagre.rankdir,
                        nodesep: settings.dagre.nodesep,
                        ranksep: settings.dagre.ranksep
                    };
                case "concentric":
                    return {
                        type: "concentric",
                        minNodeSpacing: settings.concentric.minNodeSpacing,
                        preventOverlap: settings.concentric.preventOverlap,
                        nodeSize: getNodeSize
                    };
                case "grid":
                    return {
                        type: "grid",
                        rows: settings.grid.rows,
                        cols: settings.grid.cols,
                        preventOverlap: settings.grid.preventOverlap,
                        nodeSize: getNodeSize
                    };
                case "radial":
                    return {
                        type: "radial",
                        unitRadius: settings.radial.unitRadius,
                        preventOverlap: settings.radial.preventOverlap,
                        nodeSize: getNodeSize
                    };
                case "dendrogram":
                    return {
                        type: "dendrogram",
                        direction: settings.dendrogram.direction,
                        nodeSep: settings.dendrogram.nodeSep,
                        rankSep: settings.dendrogram.rankSep,
                        radial: settings.dendrogram.radial
                    };
                case "mindmap":
                    return {
                        type: "mindmap",
                        direction: settings.mindmap.direction,
                        getHGap: ()=>settings.mindmap.hGap,
                        getVGap: ()=>settings.mindmap.vGap,
                        getHeight: ()=>settings.mindmap.getHeight,
                        getWidth: ()=>settings.mindmap.getWidth
                    };
                case "indented":
                    return {
                        type: "indented",
                        indent: 80
                    };
                case "fruchterman":
                    return {
                        type: "fruchterman",
                        center: [
                            settings.fruchterman.centerX,
                            settings.fruchterman.centerY
                        ],
                        maxIteration: settings.fruchterman.maxIteration,
                        gravity: settings.fruchterman.gravity,
                        speed: settings.fruchterman.speed,
                        clustering: settings.fruchterman.clustering,
                        clusterGravity: settings.fruchterman.clusterGravity
                    };
                case "force-atlas2":
                    return {
                        type: "force-atlas2",
                        kr: 100,
                        kg: 1
                    };
                case "mds":
                    return {
                        type: "mds",
                        linkDistance: settings.mds.linkDistance,
                        center: [
                            settings.mds.center.x,
                            settings.mds.center.y
                        ]
                    };
                case "fishbone":
                    return {
                        type: "fishbone",
                        direction: layoutSettings.value.fishbone.direction,
                        hGap: layoutSettings.value.fishbone.hGap,
                        vGap: layoutSettings.value.fishbone.vGap
                    };
                case "random":
                    return {
                        type: "random"
                    };
                default:
                    return {
                        type: type,
                        preventOverlap: true
                    };
            }
        }
        // Apply layout settings
        function applyLayoutSettings() {
            if (graph) {
                // Stop current layout to prevent glitches from multiple simultaneous animations
                graph.stopLayout();
                graph.setLayout(getLayoutConfig(layoutMode.value));
                graph.layout();
                isAnimating.value = true;
            }
        }
        // Watch for tree compatibility changes and switch layout if needed
        (0, $01W3b.watch)(isTreeCompatible, (isTree)=>{
            const currentOption = allLayoutOptions.find((opt)=>opt.value === layoutMode.value);
            if (currentOption?.requiresTree && !isTree) {
                // Current layout requires tree but graph is not tree-compatible
                // Switch to a safe default layout
                layoutMode.value = "circular";
                showMessage("Graph structure changed - switched to circular layout", "info");
            }
        });
        // Context menu helper functions
        function showContextMenu(x, y, title, actions) {
            contextMenu.value = {
                show: true,
                x: x,
                y: y,
                title: title,
                actions: actions
            };
        }
        // Show multi-selection context menu
        function showMultiSelectionContextMenu(x, y) {
            const count = selectedNodeIds.value.size;
            // Count node types in selection
            let authorCount = 0;
            let eventCount = 0;
            selectedNodeIds.value.forEach((nodeId)=>{
                const nodeData = graph?.getNodeData(nodeId);
                if (nodeData?.data?.type === "pubkey") authorCount++;
                else eventCount++;
            });
            const actions = [
                {
                    label: `Expand all (${count} nodes)`,
                    icon: "mdi-arrow-expand-all",
                    handler: ()=>{
                        expandAllSelected();
                        contextMenu.value.show = false;
                    }
                },
                {
                    label: `Collapse all (${count} nodes)`,
                    icon: "mdi-arrow-collapse-all",
                    handler: ()=>{
                        collapseAllSelected();
                        contextMenu.value.show = false;
                    }
                }
            ];
            // Add author-specific actions if any authors are selected
            if (authorCount > 0) actions.push({
                label: `Expand posts (${authorCount} authors)`,
                icon: "mdi-post-outline",
                handler: ()=>{
                    expandPostsBySelectedAuthors();
                    contextMenu.value.show = false;
                }
            }, {
                label: `Expand articles (${authorCount} authors)`,
                icon: "mdi-book-open",
                handler: ()=>{
                    expandArticlesBySelectedAuthors();
                    contextMenu.value.show = false;
                }
            }, {
                label: `Expand network (${authorCount} authors)`,
                icon: "mdi-account-group",
                handler: ()=>{
                    expandNetworkForSelectedAuthors();
                    contextMenu.value.show = false;
                }
            });
            actions.push({
                label: `Copy all IDs (${count})`,
                icon: "mdi-content-copy",
                handler: ()=>{
                    copySelectedIds();
                    contextMenu.value.show = false;
                }
            }, {
                label: `Remove all (${count} nodes)`,
                icon: "mdi-delete",
                handler: ()=>{
                    removeAllSelected();
                    contextMenu.value.show = false;
                }
            });
            const title = `${count} nodes selected${authorCount > 0 ? ` (${authorCount} authors, ${eventCount} events)` : ''}`;
            showContextMenu(x, y, title, actions);
        }
        // Make a node the root for tree layouts
        function makeTreeRoot(nodeId) {
            console.log("[Tree] Setting new root node:", nodeId);
            treeRootId.value = nodeId;
            // If we're currently in a tree layout, rebuild the tree with new root
            if (isTreeLayout(layoutMode.value) && graph && originalGraphData.value) {
                const nodes = originalGraphData.value.nodes;
                const edges = originalGraphData.value.edges;
                const treeData = prepareTreeData(nodes, edges, nodeId);
                graph.setData(treeData);
                graph.layout();
                graph.render();
                setTimeout(()=>{
                    graph.fitView();
                }, 500);
            }
            contextMenu.value.show = false;
        }
        // Show stat context menu (right-click on stat)
        function showStatContextMenu(x, y, eventId, statType) {
            const labels = {
                reactions: "Reactions",
                replies: "Replies",
                reposts: "Reposts",
                mentions: "Mentions",
                thread: "Thread"
            };
            const icons = {
                reactions: "mdi-heart",
                replies: "mdi-comment",
                reposts: "mdi-repeat",
                mentions: "mdi-at",
                thread: "mdi-message-outline"
            };
            // Check if this stat is already expanded
            const isExpanded = expandedStats.value.get(eventId)?.has(statType) || false;
            const actions = [];
            if (!isExpanded) actions.push({
                label: `Expand ${labels[statType]}`,
                icon: icons[statType],
                handler: ()=>handleExpandStat(eventId, statType)
            });
            else actions.push({
                label: `Hide ${labels[statType]}`,
                icon: "mdi-eye-off",
                handler: ()=>handleHideStat(eventId, statType)
            });
            actions.push({
                label: `Update ${labels[statType]}`,
                icon: "mdi-refresh",
                handler: ()=>handleRefreshStat(eventId, statType)
            });
            showContextMenu(x, y, labels[statType], actions);
        }
        // Helper: Create or get author node
        function createAuthorNode(pubkey, profile, createdAt) {
            // Check if author node already exists
            const existingNode = graphStore.nodes.find((n)=>n.id === pubkey);
            if (existingNode) {
                // Update profile if provided
                if (profile) {
                    existingNode.data.profile = profile;
                    existingNode.label = `\u{1F464} ${profile.name || profile.display_name || pubkey.slice(0, 8)}`;
                }
                // Update created_at if provided and not already set
                if (createdAt && !existingNode.data.created_at) existingNode.data.created_at = createdAt;
                return pubkey;
            }
            // Create new author node
            const displayName = profile?.name || profile?.display_name || pubkey.slice(0, 8);
            const authorNode = {
                id: pubkey,
                label: `\u{1F464} ${displayName}`,
                data: {
                    type: "pubkey",
                    pubkey: pubkey,
                    profile: profile || null,
                    created_at: createdAt || null
                }
            };
            graphStore.addNode(authorNode);
            return pubkey;
        }
        // Helper: Connect events to author node
        function connectEventsToAuthor(pubkey) {
            const edges = [];
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                if (!event) return;
                // Check if this event is by this author
                if (event.pubkey === pubkey) {
                    // Create edge from author to event (author created it)
                    const edge = {
                        source: pubkey,
                        target: event.id,
                        data: {
                            type: "authored-by"
                        }
                    };
                    edges.push(edge);
                }
            });
            edges.forEach((edge)=>graphStore.addEdge(edge));
            return edges.length;
        }
        // Helper: Connect events that mention this pubkey
        function connectMentionsToAuthor(pubkey) {
            const edges = [];
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                if (!event) return;
                // Check if this event mentions this pubkey (has a 'p' tag)
                const mentions = event.tags?.filter((tag)=>tag[0] === "p" && tag[1] === pubkey);
                if (mentions && mentions.length > 0) {
                    // Create edge from event to mentioned author
                    const edge = {
                        source: event.id,
                        target: pubkey,
                        data: {
                            type: "mention",
                            pubkey: pubkey
                        }
                    };
                    edges.push(edge);
                }
            });
            edges.forEach((edge)=>graphStore.addEdge(edge));
            return edges.length;
        }
        // Helper: Create or get tag node
        function createTagNode(tag) {
            const tagNodeId = `tag:${tag.toLowerCase()}`;
            // Check if tag node already exists
            const existingNode = graphStore.nodes.find((n)=>n.id === tagNodeId);
            if (existingNode) return tagNodeId;
            // Create new tag node
            const tagNode = {
                id: tagNodeId,
                label: `#${tag}`,
                data: {
                    type: "tag",
                    tag: tag,
                    color: "#f59e0b"
                }
            };
            graphStore.addNode(tagNode);
            return tagNodeId;
        }
        // Helper: Connect events with tag to tag node
        function connectEventsToTag(tag, tagNodeId) {
            const edges = [];
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                if (!event) return;
                // Check if this event has the tag
                const hasTag = event.tags?.some((t)=>t[0] === "t" && t[1]?.toLowerCase() === tag.toLowerCase());
                if (hasTag) {
                    // Create edge from event to tag node
                    const edge = {
                        source: event.id,
                        target: tagNodeId,
                        data: {
                            type: "has-tag"
                        }
                    };
                    edges.push(edge);
                }
            });
            // Add all edges
            edges.forEach((edge)=>graphStore.addEdge(edge));
            return edges.length;
        }
        // Helper: Connect kanban cards to their board node via 'a' tag
        function connectCardsToBoard(boardEventId, boardAddress) {
            const edges = [];
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                if (!event || event.kind !== 30302) return;
                // Check if this card references the board via 'a' tag
                const aTag = event.tags?.find((t)=>t[0] === "a" && t[1] === boardAddress);
                if (aTag) {
                    const edgeId = `${boardEventId}->${event.id}`;
                    // Avoid duplicate edges
                    if (!graphStore.edges.some((e)=>e.source === boardEventId && e.target === event.id && e.data?.type === "board-card")) edges.push({
                        source: boardEventId,
                        target: event.id,
                        data: {
                            type: "board-card",
                            aTag: boardAddress
                        }
                    });
                }
            });
            edges.forEach((edge)=>graphStore.addEdge(edge));
            return edges.length;
        }
        // Expand kanban cards for a board event
        async function expandKanbanCards(boardEventId, relayHints) {
            showMessage("Fetching kanban cards...", "info");
            try {
                // Find the board event to get the 'a' address
                const boardNode = graphStore.nodes.find((n)=>n.id === boardEventId);
                const boardEvent = boardNode?.data?.event;
                if (!boardEvent || boardEvent.kind !== 30301) {
                    showMessage("Board event not found", "warning");
                    return;
                }
                const dTag = boardEvent.tags?.find((t)=>t[0] === "d")?.[1];
                if (!dTag) {
                    showMessage("Board has no d-tag identifier", "warning");
                    return;
                }
                const boardAddress = `30301:${boardEvent.pubkey}:${dTag}`;
                console.log("[Kanban] Fetching cards for board:", boardAddress);
                // Fetch cards that reference this board
                const cardFilter = {
                    kinds: [
                        30302
                    ],
                    "#a": [
                        boardAddress
                    ],
                    limit: 200
                };
                let cardEvents;
                if (relayHints && relayHints.length > 0) {
                    const pool = getPool();
                    const combinedRelays = [
                        ...new Set([
                            ...nostrRelays.value,
                            ...relayHints
                        ])
                    ];
                    cardEvents = await pool.querySync(combinedRelays, cardFilter);
                    if (cardEvents.length > 0) {
                        const { storeEvents: storeEvents } = await Promise.resolve((parcelRequire("cAQvd")));
                        await storeEvents(cardEvents);
                    }
                } else cardEvents = await fetchInitialEvents([
                    cardFilter
                ]);
                if (cardEvents.length > 0) {
                    graphStore.updateWithEvents(cardEvents);
                    const connectedCount = connectCardsToBoard(boardEventId, boardAddress);
                    showMessage(`Added ${cardEvents.length} cards (${connectedCount} connected)`, "success");
                } else showMessage("No cards found for this board", "info");
            } catch (error) {
                console.error("Failed to fetch kanban cards:", error);
                showMessage("Failed to fetch kanban cards", "error");
            }
        }
        // Expansion functions
        async function expandByTag(tag) {
            contextMenu.value.show = false;
            showMessage(`Expanding posts with #${tag}...`, "info");
            try {
                // Create tag node
                const tagNodeId = createTagNode(tag);
                // Fetch events with this t-tag
                const events = await fetchInitialEvents([
                    {
                        "#t": [
                            tag.toLowerCase()
                        ],
                        kinds: [
                            1,
                            30023
                        ],
                        limit: 50
                    }
                ]);
                if (events.length > 0) {
                    graphStore.updateWithEvents(events);
                    // Connect all events (new and existing) to tag node
                    const connectedCount = connectEventsToTag(tag, tagNodeId);
                    showMessage(`Added ${events.length} posts with #${tag} (${connectedCount} connections)`, "success");
                } else {
                    // Still create connections to existing events
                    const connectedCount = connectEventsToTag(tag, tagNodeId);
                    showMessage(`No new posts found, but connected ${connectedCount} existing posts to #${tag}`, "info");
                }
            } catch (error) {
                console.error("Failed to expand tag posts:", error);
                showMessage("Failed to expand tag posts", "error");
            }
        }
        async function expandAuthorPosts(pubkey) {
            contextMenu.value.show = false;
            showMessage(`Expanding posts by ${pubkey.slice(0, 8)}...`, "info");
            try {
                const events = await fetchByAuthor(pubkey, 50);
                const notes = events.filter((e)=>e.kind === 1);
                if (notes.length > 0) {
                    graphStore.updateWithEvents(notes);
                    // Create author node and connect all events by this author
                    createAuthorNode(pubkey);
                    const connectedCount = connectEventsToAuthor(pubkey);
                    const mentionCount = connectMentionsToAuthor(pubkey);
                    showMessage(`Added ${notes.length} posts (${connectedCount} authored, ${mentionCount} mentioned)`, "success");
                } else {
                    // Still create author node even if no new posts
                    createAuthorNode(pubkey);
                    const connectedCount = connectEventsToAuthor(pubkey);
                    const mentionCount = connectMentionsToAuthor(pubkey);
                    showMessage(`No new posts (${connectedCount} authored, ${mentionCount} mentioned)`, "info");
                }
            } catch (error) {
                console.error("Failed to expand author posts:", error);
                showMessage("Failed to expand author posts", "error");
            }
        }
        async function expandAuthorArticles(pubkey) {
            contextMenu.value.show = false;
            showMessage(`Expanding articles by ${pubkey.slice(0, 8)}...`, "info");
            try {
                const events = await fetchInitialEvents([
                    {
                        authors: [
                            pubkey
                        ],
                        kinds: [
                            30023
                        ],
                        limit: 20
                    }
                ]);
                if (events.length > 0) {
                    graphStore.updateWithEvents(events);
                    // Create author node and connect all events by this author
                    createAuthorNode(pubkey);
                    const connectedCount = connectEventsToAuthor(pubkey);
                    const mentionCount = connectMentionsToAuthor(pubkey);
                    showMessage(`Added ${events.length} articles (${connectedCount} authored, ${mentionCount} mentioned)`, "success");
                } else {
                    // Still create author node even if no new articles
                    createAuthorNode(pubkey);
                    const connectedCount = connectEventsToAuthor(pubkey);
                    const mentionCount = connectMentionsToAuthor(pubkey);
                    showMessage(`No new articles (${connectedCount} authored, ${mentionCount} mentioned)`, "info");
                }
            } catch (error) {
                console.error("Failed to expand author articles:", error);
                showMessage("Failed to expand author articles", "error");
            }
        }
        async function expandAuthorProfile(pubkey) {
            contextMenu.value.show = false;
            showMessage(`Fetching profile for ${pubkey.slice(0, 8)}...`, "info");
            try {
                const events = await fetchInitialEvents([
                    {
                        authors: [
                            pubkey
                        ],
                        kinds: [
                            0
                        ],
                        limit: 1
                    }
                ]);
                if (events.length > 0) {
                    // Parse profile data
                    let profile = null;
                    try {
                        profile = JSON.parse(events[0].content);
                    } catch (e) {
                        console.warn("Failed to parse profile:", e);
                    }
                    // Create/update author node with profile data and timestamp
                    createAuthorNode(pubkey, profile, events[0].created_at);
                    const connectedCount = connectEventsToAuthor(pubkey);
                    const mentionCount = connectMentionsToAuthor(pubkey);
                    showMessage(`Profile loaded (${connectedCount} authored, ${mentionCount} mentioned)`, "success");
                } else {
                    // Create author node without profile
                    createAuthorNode(pubkey);
                    const connectedCount = connectEventsToAuthor(pubkey);
                    const mentionCount = connectMentionsToAuthor(pubkey);
                    showMessage(`Profile not found (${connectedCount} authored, ${mentionCount} mentioned)`, "info");
                }
            } catch (error) {
                console.error("Failed to fetch author profile:", error);
                showMessage("Failed to fetch author profile", "error");
            }
        }
        async function expandAuthorNetwork(pubkey) {
            contextMenu.value.show = false;
            showMessage(`Expanding social network for ${pubkey.slice(0, 8)}...`, "info");
            try {
                const { follows: follows, events: events } = await fetchUserGraph(pubkey);
                if (events.length > 0) {
                    graphStore.updateWithEvents(events);
                    // Create author node and connect events
                    createAuthorNode(pubkey);
                    const connectedCount = connectEventsToAuthor(pubkey);
                    const mentionCount = connectMentionsToAuthor(pubkey);
                    showMessage(`Added ${events.length} events from network (${follows.length} contacts, ${connectedCount} authored, ${mentionCount} mentioned)`, "success");
                } else {
                    // Still create author node
                    createAuthorNode(pubkey);
                    const connectedCount = connectEventsToAuthor(pubkey);
                    const mentionCount = connectMentionsToAuthor(pubkey);
                    showMessage(`No new network data (${connectedCount} authored, ${mentionCount} mentioned)`, "info");
                }
            } catch (error) {
                console.error("Failed to expand social network:", error);
                showMessage("Failed to expand social network", "error");
            }
        }
        async function expandOriginalPost(eventId) {
            contextMenu.value.show = false;
            showMessage("Finding original post...", "info");
            try {
                // Get the current event to find what it references
                const currentNode = graphStore.nodes.find((n)=>n.id === eventId);
                if (!currentNode?.data?.event) {
                    showMessage("Event not found in graph", "warning");
                    return;
                }
                const event = currentNode.data.event;
                const eTag = event.tags.find((t)=>t[0] === "e");
                if (eTag && eTag[1]) {
                    const referencedId = eTag[1];
                    const events = await fetchInitialEvents([
                        {
                            ids: [
                                referencedId
                            ]
                        }
                    ]);
                    if (events.length > 0) {
                        graphStore.updateWithEvents(events);
                        showMessage("Original post added", "success");
                    } else showMessage("Original post not found", "info");
                } else showMessage("No referenced post found", "warning");
            } catch (error) {
                console.error("Failed to find original post:", error);
                showMessage("Failed to find original post", "error");
            }
        }
        // Handler functions for stat interactions
        // Refresh stat count (left-click)
        async function handleRefreshStat(eventId, statType) {
            contextMenu.value.show = false;
            if (statType === "reactions") await handleRefreshReactions(eventId);
            else if (statType === "replies") await handleRefreshReplies(eventId);
            else if (statType === "reposts") await handleRefreshReposts(eventId);
            else if (statType === "mentions") await handleRefreshMentions(eventId);
            else if (statType === "thread") await handleRefreshThread(eventId);
        }
        // Expand stat (right-click > Expand)
        async function handleExpandStat(eventId, statType) {
            contextMenu.value.show = false;
            // Mark as expanded
            if (!expandedStats.value.has(eventId)) expandedStats.value.set(eventId, new Set());
            expandedStats.value.get(eventId).add(statType);
            if (statType === "reactions") await handleExpandReactions(eventId);
            else if (statType === "replies") await handleExpandReplies(eventId);
            else if (statType === "reposts") await handleExpandReposts(eventId);
            else if (statType === "mentions") await handleExpandMentions(eventId);
            else if (statType === "thread") await handleExpandThread(eventId);
        }
        // Hide stat nodes (right-click > Hide)
        function handleHideStat(eventId, statType) {
            contextMenu.value.show = false;
            // Mark as not expanded
            expandedStats.value.get(eventId)?.delete(statType);
            // Remove nodes related to this stat type
            const nodesToRemove = [];
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                if (!event) return;
                // Check if this node is related to the stat type
                const eTags = event.tags?.filter((t)=>t[0] === "e") || [];
                const referencesEvent = eTags.some((t)=>t[1] === eventId);
                if (referencesEvent) {
                    if (statType === "reactions" && event.kind === 7) nodesToRemove.push(node.id);
                    else if (statType === "replies" && (event.kind === 1 || event.kind === 30023)) nodesToRemove.push(node.id);
                    else if (statType === "reposts" && event.kind === 6) nodesToRemove.push(node.id);
                    else if (statType === "mentions") {
                        // For mentions, check if this event was mentioned in the source event's tags
                        const sourceNode = graphStore.nodes.find((n)=>n.id === eventId);
                        if (sourceNode?.data?.event) {
                            const mentionedIds = sourceNode.data.event.tags.filter((t)=>t[0] === "e").map((t)=>t[1]);
                            if (mentionedIds.includes(event.id)) nodesToRemove.push(node.id);
                        }
                    }
                }
                // For thread, remove parent and replies
                if (statType === "thread") {
                    // Check if this is a parent or reply
                    const isParentOf = event.tags?.some((t)=>t[0] === "e" && t[1] === eventId);
                    const sourceEvent = graphStore.nodes.find((n)=>n.id === eventId)?.data?.event;
                    const isChildOf = sourceEvent?.tags?.some((t)=>t[0] === "e" && t[1] === event.id);
                    if (isParentOf || isChildOf) nodesToRemove.push(node.id);
                }
            });
            // Remove nodes and their edges
            nodesToRemove.forEach((nodeId)=>{
                graphStore.removeNode(nodeId);
            });
            showMessage(`Hidden ${nodesToRemove.length} ${statType} nodes`, "success");
        }
        // Refresh handlers (fetch new count, update graph if expanded)
        async function handleRefreshReactions(eventId) {
            expandingNodes.value.add(eventId);
            showMessage("Refreshing reactions...", "info");
            try {
                const events = await expandReactions(eventId);
                // If expanded, update graph
                const isExpanded = expandedStats.value.get(eventId)?.has("reactions");
                if (isExpanded && events.length > 0) {
                    graphStore.updateWithEvents(events);
                    showMessage(`Updated ${events.length} reactions`, "success");
                } else {
                    showMessage(`Found ${events.length} reactions`, "info");
                    // Trigger re-render to update count
                    if (graph) graph.render();
                }
            } catch (error) {
                console.error("Failed to refresh reactions:", error);
                showMessage("Failed to refresh reactions", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        async function handleRefreshReplies(eventId) {
            expandingNodes.value.add(eventId);
            showMessage("Refreshing replies...", "info");
            try {
                const events = await expandReplies(eventId);
                const isExpanded = expandedStats.value.get(eventId)?.has("replies");
                if (isExpanded && events.length > 0) {
                    graphStore.updateWithEvents(events);
                    showMessage(`Updated ${events.length} replies`, "success");
                } else {
                    showMessage(`Found ${events.length} replies`, "info");
                    if (graph) graph.render();
                }
            } catch (error) {
                console.error("Failed to refresh replies:", error);
                showMessage("Failed to refresh replies", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        async function handleRefreshReposts(eventId) {
            expandingNodes.value.add(eventId);
            showMessage("Refreshing reposts...", "info");
            try {
                const events = await expandReposts(eventId);
                const isExpanded = expandedStats.value.get(eventId)?.has("reposts");
                if (isExpanded && events.length > 0) {
                    graphStore.updateWithEvents(events);
                    showMessage(`Updated ${events.length} reposts`, "success");
                } else {
                    showMessage(`Found ${events.length} reposts`, "info");
                    if (graph) graph.render();
                }
            } catch (error) {
                console.error("Failed to refresh reposts:", error);
                showMessage("Failed to refresh reposts", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        async function handleRefreshMentions(eventId) {
            expandingNodes.value.add(eventId);
            showMessage("Refreshing mentions...", "info");
            try {
                const events = await expandMentions(eventId);
                const isExpanded = expandedStats.value.get(eventId)?.has("mentions");
                if (isExpanded && events.length > 0) {
                    graphStore.updateWithEvents(events);
                    showMessage(`Updated ${events.length} mentions`, "success");
                } else {
                    showMessage(`Found ${events.length} mentions`, "info");
                    if (graph) graph.render();
                }
            } catch (error) {
                console.error("Failed to refresh mentions:", error);
                showMessage("Failed to refresh mentions", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        async function handleRefreshThread(eventId) {
            expandingNodes.value.add(eventId);
            showMessage("Refreshing thread...", "info");
            try {
                const { parent: parent, replies: replies } = await expandThread(eventId);
                const allEvents = [
                    ...parent ? [
                        parent
                    ] : [],
                    ...replies
                ];
                const isExpanded = expandedStats.value.get(eventId)?.has("thread");
                if (isExpanded && allEvents.length > 0) {
                    graphStore.updateWithEvents(allEvents);
                    const parts = [];
                    if (parent) parts.push("parent");
                    if (replies.length > 0) parts.push(`${replies.length} replies`);
                    showMessage(`Updated ${parts.join(" and ")}`, "success");
                } else {
                    showMessage(`Found ${allEvents.length} thread events`, "info");
                    if (graph) graph.render();
                }
            } catch (error) {
                console.error("Failed to refresh thread:", error);
                showMessage("Failed to refresh thread", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        // Expand handlers (add to graph and mark as expanded)
        async function handleExpandReactions(eventId) {
            contextMenu.value.show = false;
            expandingNodes.value.add(eventId);
            showMessage("Expanding reactions...", "info");
            try {
                const events = await expandReactions(eventId);
                if (events.length > 0) {
                    graphStore.updateWithEvents(events);
                    showMessage(`Added ${events.length} reactions`, "success");
                } else showMessage("No reactions found", "info");
            } catch (error) {
                console.error("Failed to expand reactions:", error);
                showMessage("Failed to expand reactions", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        async function handleExpandReplies(eventId) {
            contextMenu.value.show = false;
            expandingNodes.value.add(eventId);
            showMessage("Expanding replies...", "info");
            try {
                const events = await expandReplies(eventId);
                if (events.length > 0) {
                    graphStore.updateWithEvents(events);
                    showMessage(`Added ${events.length} replies`, "success");
                } else showMessage("No replies found", "info");
            } catch (error) {
                console.error("Failed to expand replies:", error);
                showMessage("Failed to expand replies", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        async function handleExpandReposts(eventId) {
            contextMenu.value.show = false;
            expandingNodes.value.add(eventId);
            showMessage("Expanding reposts...", "info");
            try {
                const events = await expandReposts(eventId);
                if (events.length > 0) {
                    graphStore.updateWithEvents(events);
                    showMessage(`Added ${events.length} reposts`, "success");
                } else showMessage("No reposts found", "info");
            } catch (error) {
                console.error("Failed to expand reposts:", error);
                showMessage("Failed to expand reposts", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        async function handleExpandMentions(eventId) {
            contextMenu.value.show = false;
            expandingNodes.value.add(eventId);
            showMessage("Expanding mentions...", "info");
            try {
                const events = await expandMentions(eventId);
                if (events.length > 0) {
                    graphStore.updateWithEvents(events);
                    showMessage(`Added ${events.length} mentions`, "success");
                } else showMessage("No mentions found", "info");
            } catch (error) {
                console.error("Failed to expand mentions:", error);
                showMessage("Failed to expand mentions", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        async function handleExpandThread(eventId) {
            contextMenu.value.show = false;
            expandingNodes.value.add(eventId);
            showMessage("Expanding thread...", "info");
            try {
                const { parent: parent, replies: replies } = await expandThread(eventId);
                const allEvents = [
                    ...parent ? [
                        parent
                    ] : [],
                    ...replies
                ];
                if (allEvents.length > 0) {
                    graphStore.updateWithEvents(allEvents);
                    const parts = [];
                    if (parent) parts.push("parent");
                    if (replies.length > 0) parts.push(`${replies.length} replies`);
                    showMessage(`Added ${parts.join(" and ")}`, "success");
                } else showMessage("No thread context found", "info");
            } catch (error) {
                console.error("Failed to expand thread:", error);
                showMessage("Failed to expand thread", "error");
            } finally{
                expandingNodes.value.delete(eventId);
            }
        }
        // Filter functions
        function filterByTag(tag) {
            contextMenu.value.show = false;
            showMessage(`Filtering to show only #${tag}`, "info");
            if (!graph) return;
            // Create tag node
            const tagNodeId = createTagNode(tag);
            // Connect all events with this tag to the tag node
            const connectedCount = connectEventsToTag(tag, tagNodeId);
            // Use visibility property to hide/show nodes
            const updates = [];
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                const isTagNode = node.data?.type === "tag";
                const hasTags = event?.tags?.some((t)=>t[0] === "t" && t[1]?.toLowerCase() === tag.toLowerCase());
                updates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        visibility: hasTags || isTagNode ? "visible" : "hidden"
                    }
                });
            });
            if (updates.length > 0) {
                graph.updateNodeData(updates);
                graph.render();
            }
            showMessage(`Filtered to #${tag} (${connectedCount} connections)`, "success");
        }
        function filterByAuthor(pubkey) {
            contextMenu.value.show = false;
            showMessage(`Filtering to show only ${pubkey.slice(0, 8)}...`, "info");
            if (!graph) return;
            // Use visibility property to hide/show nodes
            const updates = [];
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                updates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        visibility: event?.pubkey === pubkey ? "visible" : "hidden"
                    }
                });
            });
            if (updates.length > 0) {
                graph.updateNodeData(updates);
                graph.render();
            }
            showMessage("Filtered to author", "success");
        }
        function filterRelated(eventId) {
            contextMenu.value.show = false;
            showMessage("Filtering to show related content...", "info");
            if (!graph) return;
            // Find all connected nodes (1 hop away)
            const connectedIds = new Set([
                eventId
            ]);
            graphStore.edges.forEach((edge)=>{
                if (edge.source === eventId) connectedIds.add(edge.target);
                if (edge.target === eventId) connectedIds.add(edge.source);
            });
            // Use visibility to hide unconnected nodes
            const updates = [];
            graphStore.nodes.forEach((node)=>{
                updates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        visibility: connectedIds.has(node.id) ? "visible" : "hidden"
                    }
                });
            });
            if (updates.length > 0) {
                graph.updateNodeData(updates);
                graph.render();
            }
            showMessage(`Showing ${connectedIds.size} related nodes`, "success");
        }
        // Highlight functions
        function highlightByTag(tag) {
            contextMenu.value.show = false;
            showMessage(`Highlighting posts with #${tag}`, "info");
            if (!graph) return;
            // Add highlight style to matching nodes
            const updates = [];
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                const hasTags = event?.tags?.some((t)=>t[0] === "t" && t[1]?.toLowerCase() === tag.toLowerCase());
                if (hasTags) updates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        stroke: "#fbbf24",
                        lineWidth: 4
                    }
                });
                else // Reset to default style
                updates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        stroke: undefined,
                        lineWidth: undefined
                    }
                });
            });
            if (updates.length > 0) {
                graph.updateNodeData(updates);
                graph.render();
            }
            showMessage(`Highlighted #${tag}`, "success");
        }
        function highlightByAuthor(pubkey) {
            contextMenu.value.show = false;
            showMessage(`Highlighting content by ${pubkey.slice(0, 8)}...`, "info");
            if (!graph) return;
            // Add highlight style to author's nodes
            const updates = [];
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                if (event?.pubkey === pubkey) updates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        stroke: "#8b5cf6",
                        lineWidth: 4
                    }
                });
                else // Reset to default style
                updates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        stroke: undefined,
                        lineWidth: undefined
                    }
                });
            });
            if (updates.length > 0) {
                graph.updateNodeData(updates);
                graph.render();
            }
            showMessage("Highlighted author", "success");
        }
        // Clear all filters - show all nodes
        function clearFilters() {
            if (!graph) return;
            // Don't clear search - it's independent
            // Only clear other filters (visibility from filterBy* functions)
            const updates = [];
            graphStore.nodes.forEach((node)=>{
                // If search is active, preserve search visibility state
                // Otherwise, make all nodes visible
                const visibility = searchActive.value ? searchResults.value.has(node.id) ? "visible" : "hidden" : "visible";
                updates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        visibility: visibility
                    }
                });
            });
            if (updates.length > 0) {
                graph.updateNodeData(updates);
                graph.render();
            }
            const message = searchActive.value ? "Filters cleared (search still active)" : "All filters cleared";
            showMessage(message, "success");
        }
        // Reset all highlights - remove custom styles
        function resetHighlights() {
            if (!graph) return;
            // Don't clear search - only remove highlight styles
            // Search has its own clear button
            const updates = [];
            graphStore.nodes.forEach((node)=>{
                updates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        stroke: undefined,
                        lineWidth: undefined
                    }
                });
            });
            if (updates.length > 0) {
                graph.updateNodeData(updates);
                graph.render();
            }
            showMessage("Highlights cleared", "success");
        }
        // Search Functions
        // ================
        // Perform local search on current graph
        function performSearch() {
            if (!graph || !searchQuery.value.trim()) {
                clearSearch();
                return;
            }
            const queryText = searchQuery.value.trim();
            const parsedFilter = (0, $jYHYW.parseNostrQuery)(queryText);
            const searchText = parsedFilter.search?.toLowerCase() || "";
            console.log("[Local Search] Parsed filter:", parsedFilter);
            const matchingNodeIds = new Set();
            // Search through all nodes
            graphStore.nodes.forEach((node)=>{
                const event = node.data?.event;
                if (!event) {
                    // Check if it's an author/tag node
                    if (node.data?.type === "pubkey") {
                        const pubkey = node.data?.pubkey || "";
                        const profile = node.data?.profile;
                        const name = profile?.name || profile?.display_name || "";
                        // Check author filter
                        if (parsedFilter.authors && parsedFilter.authors.length > 0) {
                            if (parsedFilter.authors.some((a)=>pubkey.toLowerCase().includes(a.toLowerCase()))) {
                                matchingNodeIds.add(node.id);
                                return;
                            }
                        }
                        // Check search text
                        if (searchText && (pubkey.toLowerCase().includes(searchText) || name.toLowerCase().includes(searchText))) matchingNodeIds.add(node.id);
                    } else if (node.data?.type === "tag") {
                        const tag = node.data?.tag || "";
                        // Check tag filter
                        if (parsedFilter['#t'] && parsedFilter['#t'].length > 0) {
                            if (parsedFilter['#t'].some((t)=>tag.toLowerCase().includes(t.toLowerCase()))) {
                                matchingNodeIds.add(node.id);
                                return;
                            }
                        }
                        // Check search text
                        if (searchText && tag.toLowerCase().includes(searchText)) matchingNodeIds.add(node.id);
                    }
                    return;
                }
                let matches = false;
                // Check kind filter
                if (parsedFilter.kinds && parsedFilter.kinds.length > 0) {
                    if (!parsedFilter.kinds.includes(event.kind)) return; // Skip if kind doesn't match
                }
                // Check author filter
                if (parsedFilter.authors && parsedFilter.authors.length > 0) {
                    if (parsedFilter.authors.some((a)=>event.pubkey?.toLowerCase().includes(a.toLowerCase()))) matches = true;
                    else return; // Skip if author doesn't match
                }
                // Check ID filter
                if (parsedFilter.ids && parsedFilter.ids.length > 0) {
                    if (parsedFilter.ids.some((id)=>event.id?.toLowerCase().includes(id.toLowerCase()))) matches = true;
                    else return; // Skip if ID doesn't match
                }
                // Check hashtag filter (#t)
                if (parsedFilter['#t'] && parsedFilter['#t'].length > 0) {
                    const eventHashtags = event.tags?.filter((t)=>t[0] === 't').map((t)=>t[1]?.toLowerCase()) || [];
                    if (parsedFilter['#t'].some((tag)=>eventHashtags.includes(tag.toLowerCase()))) matches = true;
                    else if (!searchText) return; // Skip if hashtag doesn't match and no search text
                }
                // Check mention filter (#p)
                if (parsedFilter['#p'] && parsedFilter['#p'].length > 0) {
                    const eventMentions = event.tags?.filter((t)=>t[0] === 'p').map((t)=>t[1]?.toLowerCase()) || [];
                    if (parsedFilter['#p'].some((pubkey)=>eventMentions.some((m)=>m.includes(pubkey.toLowerCase())))) matches = true;
                    else if (!searchText) return; // Skip if mention doesn't match and no search text
                }
                // Check event reference filter (#e)
                if (parsedFilter['#e'] && parsedFilter['#e'].length > 0) {
                    const eventRefs = event.tags?.filter((t)=>t[0] === 'e').map((t)=>t[1]?.toLowerCase()) || [];
                    if (parsedFilter['#e'].some((eventId)=>eventRefs.includes(eventId.toLowerCase()))) matches = true;
                    else if (!searchText) return; // Skip if event ref doesn't match and no search text
                }
                // Check time filters
                if (parsedFilter.since && event.created_at < parsedFilter.since) return; // Skip if too old
                if (parsedFilter.until && event.created_at > parsedFilter.until) return; // Skip if too new
                // Check search text in content
                if (searchText) {
                    if (event.content?.toLowerCase().includes(searchText)) matches = true;
                    // Search all tags
                    if (!matches && event.tags) {
                        const hasMatchingTag = event.tags.some((t)=>t.some((val)=>val?.toLowerCase().includes(searchText)));
                        if (hasMatchingTag) matches = true;
                    }
                    // Search author pubkey
                    if (!matches && event.pubkey?.toLowerCase().includes(searchText)) matches = true;
                    // Search event ID
                    if (!matches && event.id?.toLowerCase().includes(searchText)) matches = true;
                }
                if (matches) matchingNodeIds.add(node.id);
            });
            searchResults.value = matchingNodeIds;
            searchActive.value = true;
            applySearchResults();
            showMessage(`Found ${matchingNodeIds.size} matching ${matchingNodeIds.size === 1 ? "node" : "nodes"}`, "success");
        }
        // Apply search results - hide non-matching nodes and edges
        function applySearchResults() {
            if (!graph || !searchActive.value) return;
            const nodeUpdates = [];
            const edgeUpdates = [];
            // Hide/show nodes based on search results
            graphStore.nodes.forEach((node)=>{
                const isMatch = searchResults.value.has(node.id);
                nodeUpdates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        visibility: isMatch ? "visible" : "hidden",
                        stroke: isMatch ? "#3b82f6" : undefined,
                        lineWidth: isMatch ? 3 : undefined
                    }
                });
            });
            // Hide edges where either source or target is hidden
            graphStore.edges.forEach((edge)=>{
                const sourceVisible = searchResults.value.has(edge.source);
                const targetVisible = searchResults.value.has(edge.target);
                const isVisible = sourceVisible && targetVisible;
                edgeUpdates.push({
                    id: edge.id || `${edge.source}-${edge.target}`,
                    style: {
                        ...edge.style,
                        visibility: isVisible ? "visible" : "hidden"
                    }
                });
            });
            if (nodeUpdates.length > 0) graph.updateNodeData(nodeUpdates);
            if (edgeUpdates.length > 0) graph.updateEdgeData(edgeUpdates);
            graph.render();
        }
        // Clear search
        function clearSearch() {
            searchQuery.value = "";
            searchResults.value.clear();
            searchActive.value = false;
            if (!graph) return;
            // Show all nodes and edges, remove search highlighting
            const nodeUpdates = [];
            const edgeUpdates = [];
            graphStore.nodes.forEach((node)=>{
                nodeUpdates.push({
                    id: node.id,
                    style: {
                        ...node.style,
                        visibility: "visible",
                        stroke: undefined,
                        lineWidth: undefined
                    }
                });
            });
            graphStore.edges.forEach((edge)=>{
                edgeUpdates.push({
                    id: edge.id || `${edge.source}-${edge.target}`,
                    style: {
                        ...edge.style,
                        visibility: "visible"
                    }
                });
            });
            if (nodeUpdates.length > 0) graph.updateNodeData(nodeUpdates);
            if (edgeUpdates.length > 0) graph.updateEdgeData(edgeUpdates);
            graph.render();
        }
        // Toggle search mode between AND/OR
        function toggleSearchMode() {
            searchMode.value = searchMode.value === "AND" ? "OR" : "AND";
            showMessage(`Search mode: ${searchMode.value}`, "info");
            // Re-apply search if active
            if (searchActive.value) performSearch();
        }
        // Search Nostr relays for matching events
        async function searchNostrRelays() {
            if (!searchQuery.value.trim()) {
                showMessage("Please enter a search query", "warning");
                return;
            }
            isSearching.value = true;
            contextMenu.value.show = false;
            try {
                const query = searchQuery.value.trim();
                // Parse the query using nostr-dsl
                const parsedFilter = (0, $jYHYW.parseNostrQuery)(query);
                parsedFilter.kinds = undefined;
                console.log("[Search] Parsed filter:", parsedFilter);
                // Extract search text for client-side filtering
                const searchText = parsedFilter.search?.toLowerCase() || "";
                // Build Nostr filter for relay query
                // Start with parsed filter but ensure we have default kinds if none specified
                // Keep 'search' field for NIP-50 full-text search support on relays
                const relayFilter = {
                    ...parsedFilter
                };
                // Extract naddr relay hints before sending filter to relay
                const naddrRelays = relayFilter._relays || [];
                delete relayFilter._relays;
                if (!relayFilter.limit) relayFilter.limit = 100; // Default limit
                console.log("[Search] Relay filter:", relayFilter);
                if (naddrRelays.length > 0) console.log("[Search] Using naddr relay hints:", naddrRelays);
                // Fetch events from relays using the parsed filter
                // If naddr relay hints exist, query those relays directly via pool
                let events;
                if (naddrRelays.length > 0) {
                    const pool = getPool();
                    const combinedRelays = [
                        ...new Set([
                            ...nostrRelays.value,
                            ...naddrRelays
                        ])
                    ];
                    console.log("[Search] Querying combined relays:", combinedRelays);
                    events = await pool.querySync(combinedRelays, relayFilter);
                    // Also store events
                    if (events.length > 0) {
                        const { storeEvents: storeEvents } = await Promise.resolve((parcelRequire("cAQvd")));
                        await storeEvents(events);
                    }
                } else events = await fetchInitialEvents([
                    relayFilter
                ]);
                // Apply client-side text search if search text exists
                let matchingEvents = events;
                if (searchText) matchingEvents = events.filter((event)=>{
                    // Search content
                    if (event.content?.toLowerCase().includes(searchText)) return true;
                    // Search tags
                    if (event.tags?.some((t)=>t.some((val)=>val?.toLowerCase().includes(searchText)))) return true;
                    return false;
                });
                if (matchingEvents.length > 0) {
                    graphStore.updateWithEvents(matchingEvents);
                    showMessage(`Added ${matchingEvents.length} events from Nostr relays`, "success");
                    // Auto-fetch kanban cards for any board events (kind 30301)
                    const boardEvents = matchingEvents.filter((e)=>e.kind === 30301);
                    if (boardEvents.length > 0) for (const board of boardEvents)await expandKanbanCards(board.id, naddrRelays.length > 0 ? naddrRelays : undefined);
                    // Also connect any loaded cards (30302) to their boards
                    const cardEvents = matchingEvents.filter((e)=>e.kind === 30302);
                    if (cardEvents.length > 0) // Find board addresses from card 'a' tags and connect
                    for (const card of cardEvents){
                        const aTag = card.tags?.find((t)=>t[0] === "a" && t[1]?.startsWith("30301:"));
                        if (aTag) {
                            // Find the board node by matching the 'a' address
                            const boardNode = graphStore.nodes.find((n)=>{
                                const evt = n.data?.event;
                                if (!evt || evt.kind !== 30301) return false;
                                const dTag = evt.tags?.find((t)=>t[0] === "d")?.[1];
                                return dTag && aTag[1] === `30301:${evt.pubkey}:${dTag}`;
                            });
                            if (boardNode) connectCardsToBoard(boardNode.id, aTag[1]);
                        }
                    }
                } else showMessage("No matching events found on Nostr relays", "info");
            } catch (error) {
                console.error("Failed to search Nostr relays:", error);
                showMessage("Failed to search Nostr relays", "error");
            } finally{
                isSearching.value = false;
            }
        }
        // Start investigation - focus on single event
        function startInvestigation(eventId) {
            contextMenu.value.show = false;
            if (!graph) return;
            // Find the selected node
            const selectedNode = graphStore.nodes.find((node)=>node.id === eventId);
            if (!selectedNode) {
                showMessage("Event not found in graph", "error");
                return;
            }
            // Clear the graph and keep only the selected event node (no author node)
            graphStore.setGraphData({
                nodes: [
                    selectedNode
                ],
                edges: []
            });
            showMessage("Investigation started from this event. Use expansion options to build the graph.", "success", 5000);
        }
        // Remove node from graph
        function removeNode(nodeId) {
            contextMenu.value.show = false;
            // Check how many nodes would remain
            const remainingCount = graphStore.nodes.length - 1;
            if (remainingCount === 0) {
                showMessage("Cannot remove the last node from graph", "warning");
                return;
            }
            // Remove from graph store (also removes connected edges)
            graphStore.removeNode(nodeId);
            showMessage("Node removed from graph", "success");
        }
        // Watch for settings changes and auto-apply with debounce
        (0, $01W3b.watch)(layoutSettings, ()=>{
            // Clear existing timer to debounce rapid changes (e.g., dragging sliders)
            if (layoutSettingsDebounceTimer) clearTimeout(layoutSettingsDebounceTimer);
            // Apply settings after 150ms of no changes
            layoutSettingsDebounceTimer = setTimeout(()=>{
                applyLayoutSettings();
                layoutSettingsDebounceTimer = null;
            }, 150);
        }, {
            deep: true
        });
        // Handle Escape key to clear selection
        function handleEscapeKey(e) {
            if (e.key === 'Escape' && selectedNodeIds.value.size > 0) clearSelection();
        }
        (0, $TusQn.onMounted)(()=>{
            if (!graphRef.value) return;
            // Initialize G6 graph with HTML nodes
            graph = new (0, $cA8ew.Graph)({
                container: graphRef.value,
                width: graphRef.value.offsetWidth,
                height: graphRef.value.offsetHeight,
                layout: getLayoutConfig(layoutMode.value),
                // Reserve space at the bottom for the timebar
                padding: [
                    10,
                    10,
                    120,
                    10
                ],
                // Speed up animations globally
                animation: {
                    duration: 300
                },
                plugins: [
                    // Timebar plugin - always visible
                    {
                        type: "timebar",
                        key: "timebar",
                        className: "g6-timebar",
                        zIndex: 100,
                        padding: 66,
                        data: timebarData.value,
                        width: graphRef.value.offsetWidth - 20,
                        height: 100,
                        position: "bottom",
                        timebarType: "chart",
                        elementTypes: [
                            "node"
                        ],
                        mode: "visibility",
                        values: timebarTimeRange.value || defaultTimeRange.value,
                        getTime: (datum)=>{
                            // Author/pubkey nodes are timeless — always keep them visible by
                            // returning the midpoint of the current active window so they are
                            // never outside the selected range.
                            if (datum.data?.type === 'pubkey') {
                                const range = timebarTimeRange.value || defaultTimeRange.value;
                                return (range[0] + range[1]) / 2;
                            }
                            // Regular event nodes
                            const t = datum.data?.event?.created_at || datum.data?.created_at;
                            if (t) return t * 1000;
                            return null;
                        },
                        labelFormatter: (time)=>{
                            const date = new Date(time);
                            return date.toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric'
                            });
                        },
                        onChange: (values)=>{
                            timebarTimeRange.value = values;
                            // onChange fires after the timebar has already applied node visibility,
                            // so we can sync edge visibility synchronously here.
                            syncEdgeVisibility();
                            if (!graph) return;
                            graph.layout();
                            setTimeout(()=>{
                                graph?.fitView();
                            }, 350);
                        },
                        onPlay: ()=>{},
                        onPause: ()=>{
                            graph?.layout();
                            setTimeout(()=>{
                                graph?.fitView();
                            }, 350);
                        },
                        onReset: ()=>{
                            graph?.layout();
                            setTimeout(()=>{
                                graph?.fitView();
                            }, 350);
                        }
                    },
                    {
                        type: "tooltip",
                        enable: (event)=>event.targetType === "edge",
                        getContent: (_event, items)=>{
                            if (!items || items.length === 0) return "";
                            const edge = items[0];
                            const style = getEdgeStyle(edge);
                            const type = edge.data?.type || "unknown";
                            const marker = edge.data?.marker || "";
                            let description = style.label;
                            let details = "";
                            // Add contextual information based on edge type
                            if (type === "authored-by") details = "Identity relationship - connects content to its creator";
                            else if (type === "reference" && marker === "reply") details = "Conversation thread - this is a direct reply";
                            else if (type === "reference") details = "Content reference - links to related content";
                            else if (type === "mention") details = "User mention - references another user";
                            else if (type === "repost") details = "Amplification - shares content to wider audience";
                            else if (type === "reaction") details = "Engagement - expresses reaction to content";
                            else if (type === "tree-structure") details = "Tree layout structural edge";
                            else details = "Connection between nodes";
                            return `
            <div style="padding: 8px 12px; background: rgba(0, 0, 0, 0.85); color: white; border-radius: 6px; font-size: 12px; max-width: 250px;">
              <div style="font-weight: 600; margin-bottom: 4px; color: ${style.stroke};">${description}</div>
              <div style="opacity: 0.9; line-height: 1.4;">${details}</div>
            </div>
          `;
                        }
                    }
                ],
                behaviors: [
                    "drag-canvas",
                    "zoom-canvas",
                    {
                        type: "drag-element",
                        enable: (event)=>{
                            // Only allow dragging when shift is NOT held (shift is for selection)
                            return !event.shiftKey;
                        }
                    },
                    {
                        type: "click-select",
                        multiple: true,
                        trigger: [
                            "shift"
                        ],
                        state: "selected"
                    },
                    {
                        type: "brush-select",
                        trigger: [
                            "shift"
                        ],
                        immediately: true,
                        state: "selected",
                        mode: "union",
                        style: {
                            fill: "rgba(59, 130, 246, 0.1)",
                            stroke: "#3b82f6",
                            lineWidth: 2,
                            lineDash: [
                                4,
                                4
                            ]
                        }
                    }
                ],
                node: {
                    type: "html",
                    style: {
                        size: (d)=>{
                            const expanded = d.data?.expanded;
                            return expanded ? [
                                400,
                                300
                            ] : [
                                60,
                                60
                            ];
                        },
                        dx: (d)=>{
                            const expanded = d.data?.expanded;
                            const width = expanded ? 400 : 60;
                            return -width / 2;
                        },
                        dy: (d)=>{
                            const expanded = d.data?.expanded;
                            const height = expanded ? 300 : 60;
                            return -height / 2;
                        },
                        innerHTML: (d)=>renderEventNode(d)
                    },
                    state: {
                        selected: {
                            halo: true,
                            haloStroke: "#10b981",
                            haloStrokeWidth: 8,
                            haloOpacity: 0.5
                        }
                    }
                },
                edge: {
                    style: {
                        stroke: (d)=>getEdgeStyle(d).stroke,
                        lineWidth: (d)=>getEdgeStyle(d).lineWidth,
                        lineDash: (d)=>getEdgeStyle(d).lineDash,
                        opacity: (d)=>getEdgeStyle(d).opacity,
                        endArrow: true,
                        labelText: ()=>"",
                        labelFill: "#666",
                        labelFontSize: 10,
                        labelBackground: true,
                        labelBackgroundFill: "#fff",
                        labelBackgroundOpacity: 0.9,
                        labelBackgroundRadius: 3,
                        labelBackgroundPadding: [
                            2,
                            4
                        ]
                    },
                    state: {
                        hover: {
                            stroke: (d)=>getEdgeStyle(d).stroke,
                            lineWidth: (d)=>getEdgeStyle(d).lineWidth + 1,
                            opacity: 1,
                            labelText: (d)=>getEdgeStyle(d).label
                        }
                    }
                }
            });
            // Load initial data
            graph.setData(graphData.value);
            graph.render();
            // Animation starts automatically and runs until it stabilizes naturally
            isAnimating.value = true;
            // Single click to mark node as active (for tree root selection)
            graph.on("node:click", (evt)=>{
                const nodeId = evt.target?.id || evt.item?.id;
                if (!nodeId) return;
                // Handle shift+click for multi-selection (manual implementation since HTML nodes don't work with click-select behavior)
                if (evt.shiftKey) {
                    console.log("[Selection] Shift+click on:", nodeId);
                    const currentState = graph?.getElementState(nodeId);
                    const isSelected = currentState?.includes("selected");
                    if (isSelected) {
                        // Deselect
                        graph?.setElementState(nodeId, "selected", false);
                        selectedNodeIds.value.delete(nodeId);
                        console.log("[Selection] Deselected:", nodeId, "Total:", selectedNodeIds.value.size);
                        // Remove CSS class
                        const element = graphRef.value?.querySelector(`[data-item-id="${nodeId}"]`);
                        element?.classList.remove("g6-selected");
                    } else {
                        // Select
                        graph?.setElementState(nodeId, "selected", true);
                        selectedNodeIds.value.add(nodeId);
                        console.log("[Selection] Selected:", nodeId, "Total:", selectedNodeIds.value.size);
                        // Add CSS class
                        setTimeout(()=>{
                            const element = graphRef.value?.querySelector(`[data-item-id="${nodeId}"]`);
                            if (element && !element.classList.contains("g6-selected")) {
                                element.classList.add("g6-selected");
                                console.log("[Selection] Applied g6-selected class to:", nodeId);
                            }
                        }, 10);
                    }
                    return;
                }
                // Normal click: clear multi-selection and select this node only
                console.log("[Selection] Single click on:", nodeId);
                // Clear all previous selections
                if (selectedNodeIds.value.size > 0) {
                    selectedNodeIds.value.forEach((id)=>{
                        graph?.setElementState(id, "selected", false);
                    });
                    selectedNodeIds.value.clear();
                    // Clear CSS classes
                    const allElements = graphRef.value?.querySelectorAll("[data-item-id]");
                    allElements?.forEach((el)=>{
                        el.classList.remove("g6-selected");
                    });
                }
                // Select the clicked node
                graph?.setElementState(nodeId, "selected", true);
                selectedNodeIds.value.add(nodeId);
                console.log("[Selection] Selected single node:", nodeId);
                // Add CSS class
                setTimeout(()=>{
                    const element = graphRef.value?.querySelector(`[data-item-id="${nodeId}"]`);
                    if (element && !element.classList.contains("g6-selected")) element.classList.add("g6-selected");
                }, 10);
                // Check if node is collapsed and select it for visual feedback
                const nodeData = graph.getNodeData(nodeId);
                if (nodeData && !nodeData.data?.expanded) selectedCollapsedNodeId.value = nodeId;
                else selectedCollapsedNodeId.value = null; // Deselect if expanded
            });
            // Double-click to expand/collapse node
            graph.on("node:dblclick", (evt)=>{
                const nodeId = evt.target?.id || evt.item?.id;
                if (!nodeId) return;
                const nodeData = graph.getNodeData(nodeId);
                if (!nodeData) return;
                // For pubkey nodes, only expand if they have profile data
                if (nodeData.data?.type === "pubkey") {
                    if (!nodeData.data?.profile) return;
                }
                // For event nodes, only expand if there's event data
                if (nodeData.data?.type !== "pubkey" && !nodeData.data?.event) return;
                const expanded = !nodeData.data?.expanded;
                const updated = {
                    ...nodeData,
                    data: {
                        ...nodeData.data,
                        expanded: expanded
                    },
                    style: {
                        ...nodeData.style,
                        size: expanded ? [
                            400,
                            300
                        ] : [
                            60,
                            60
                        ],
                        dx: expanded ? -200 : -30,
                        dy: expanded ? -150 : -30
                    }
                };
                graph.updateNodeData([
                    updated
                ]);
                graph.render();
                // Wait for DOM to update before applying selected class
                (0, $TusQn.nextTick)(()=>{
                    if (expanded) {
                        selectedCardId.value = nodeId;
                        selectedCollapsedNodeId.value = null; // Clear collapsed selection when expanding
                        console.log("[Card] Auto-selected card after expand:", nodeId);
                    } else {
                        selectedCardId.value = null; // Deselect when collapsing
                        selectedCollapsedNodeId.value = nodeId; // Select collapsed node
                    }
                });
            // No need to rerun layout - space is always reserved for card size
            });
            // Handle canvas click (deselect)
            graph.on("canvas:click", ()=>{
                selectedCardId.value = null; // Deselect card when clicking on canvas
                selectedCollapsedNodeId.value = null; // Deselect collapsed node
                clearSelection(); // Clear multi-selection
            });
            // Close button click (DOM event delegation)
            graphRef.value.addEventListener("click", (e)=>{
                const target = e.target;
                // Check for stat clicks FIRST (left-click = refresh count)
                const stat = target.closest('[data-role^="stat-"]');
                if (stat) {
                    e.stopPropagation(); // Prevent card selection
                    const role = stat.getAttribute("data-role");
                    const eventId = stat.getAttribute("data-event-id");
                    if (eventId) {
                        // Map stat role to refresh handler
                        if (role === "stat-reactions") handleRefreshReactions(eventId);
                        else if (role === "stat-replies") handleRefreshReplies(eventId);
                        else if (role === "stat-reposts") handleRefreshReposts(eventId);
                        else if (role === "stat-mentions") handleRefreshMentions(eventId);
                        else if (role === "stat-thread") handleRefreshThread(eventId);
                    }
                    return;
                }
                // Check for close button
                const closeBtn = target.closest('[data-role="close"]');
                if (closeBtn) {
                    e.stopPropagation(); // Prevent card selection
                    const itemEl = closeBtn.closest("[data-item-id]");
                    const nodeId = itemEl?.getAttribute("data-item-id");
                    if (!nodeId) return;
                    const nodeData = graph.getNodeData(nodeId);
                    if (!nodeData) return;
                    const updated = {
                        ...nodeData,
                        data: {
                            ...nodeData.data,
                            expanded: false
                        },
                        style: {
                            ...nodeData.style,
                            size: [
                                60,
                                60
                            ],
                            dx: -30,
                            dy: -30
                        }
                    };
                    graph.updateNodeData([
                        updated
                    ]);
                    graph.render();
                    return;
                }
                // Check for tags
                const tagEl = target.closest("[data-tag]");
                if (tagEl) {
                    e.stopPropagation(); // Prevent card selection
                    return;
                }
                // Check for mentions
                const mentionEl = target.closest("[data-mention]");
                if (mentionEl) {
                    e.stopPropagation(); // Prevent card selection
                    return;
                }
                // Check for author section
                const authorEl = target.closest("[data-author-pubkey]");
                if (authorEl) {
                    e.stopPropagation(); // Prevent card selection
                    return;
                }
                // Finally, check for card click to select it (only if no interactive elements were clicked)
                const card = target.closest(".event-node.expanded");
                if (card) {
                    const cardId = card.getAttribute("data-item-id");
                    if (cardId) {
                        selectedCardId.value = cardId;
                        console.log("[Card] Selected card:", cardId);
                        return;
                    }
                }
            });
            // Right-click context menu (DOM event delegation)
            graphRef.value.addEventListener("contextmenu", (e)=>{
                e.preventDefault();
                const target = e.target;
                // Don't show context menu for virtual root node
                const virtualRoot = target.closest('[data-item-id="__tree_super_root__"]');
                if (virtualRoot) return;
                // Check if we have multiple nodes selected
                if (selectedNodeIds.value.size > 1) {
                    // Check if right-clicking on a selected node
                    const clickedNode = target.closest('.node-circle[data-item-id], .event-node.expanded[data-item-id]');
                    if (clickedNode) {
                        const nodeId = clickedNode.getAttribute('data-item-id');
                        if (nodeId && selectedNodeIds.value.has(nodeId)) {
                            // Show multi-selection context menu
                            showMultiSelectionContextMenu(e.clientX, e.clientY);
                            return;
                        }
                    }
                }
                // Check if right-clicking on a stat (reactions, replies, etc.)
                const stat = target.closest('[data-role^="stat-"]');
                if (stat) {
                    const role = stat.getAttribute("data-role");
                    const eventId = stat.getAttribute("data-event-id");
                    if (eventId && role) {
                        const statType = role.replace("stat-", "");
                        showStatContextMenu(e.clientX, e.clientY, eventId, statType);
                        return;
                    }
                }
                // Check if clicking on a pubkey node (author circle)
                const pubkeyNodeEl = target.closest(".pubkey-node[data-item-id][data-pubkey]");
                if (pubkeyNodeEl) {
                    const nodeId = pubkeyNodeEl.getAttribute("data-item-id");
                    const pubkey = pubkeyNodeEl.getAttribute("data-pubkey");
                    if (nodeId && pubkey) {
                        const actions = [
                            {
                                label: "Expand all posts by author",
                                icon: "mdi-post-outline",
                                handler: ()=>expandAuthorPosts(pubkey)
                            },
                            {
                                label: "Expand blog articles (kind 30023)",
                                icon: "mdi-book-open",
                                handler: ()=>expandAuthorArticles(pubkey)
                            },
                            {
                                label: "Expand author profile",
                                icon: "mdi-account-details",
                                handler: ()=>expandAuthorProfile(pubkey)
                            },
                            {
                                label: "Show followers/following",
                                icon: "mdi-account-group",
                                handler: ()=>expandAuthorNetwork(pubkey)
                            },
                            {
                                label: "Filter to show only this author",
                                icon: "mdi-filter",
                                handler: ()=>filterByAuthor(pubkey)
                            },
                            {
                                label: "Start investigation from here",
                                icon: "mdi-target",
                                handler: ()=>startInvestigation(nodeId)
                            },
                            {
                                label: "Make tree root",
                                icon: "mdi-tree",
                                handler: ()=>makeTreeRoot(nodeId)
                            },
                            {
                                label: "Remove this node",
                                icon: "mdi-delete",
                                handler: ()=>removeNode(nodeId)
                            }
                        ];
                        showContextMenu(e.clientX, e.clientY, `Author ${pubkey.slice(0, 8)}...`, actions);
                        return;
                    }
                }
                // Check if clicking on a tag node (tag circle)
                const tagNodeEl = target.closest(".tag-node[data-item-id][data-tag]");
                if (tagNodeEl) {
                    const nodeId = tagNodeEl.getAttribute("data-item-id");
                    const tag = tagNodeEl.getAttribute("data-tag");
                    if (nodeId && tag) {
                        const actions = [
                            {
                                label: "Expand more posts with this tag",
                                icon: "mdi-tag-plus",
                                handler: ()=>expandByTag(tag)
                            },
                            {
                                label: "Filter to show only this tag",
                                icon: "mdi-filter",
                                handler: ()=>filterByTag(tag)
                            },
                            {
                                label: "Highlight posts with this tag",
                                icon: "mdi-marker",
                                handler: ()=>highlightByTag(tag)
                            },
                            {
                                label: "Start investigation from here",
                                icon: "mdi-target",
                                handler: ()=>startInvestigation(nodeId)
                            },
                            {
                                label: "Make tree root",
                                icon: "mdi-tree",
                                handler: ()=>makeTreeRoot(nodeId)
                            },
                            {
                                label: "Remove this tag node",
                                icon: "mdi-delete",
                                handler: ()=>removeNode(nodeId)
                            }
                        ];
                        showContextMenu(e.clientX, e.clientY, `Tag: #${tag}`, actions);
                        return;
                    }
                }
                // Check if clicking on a collapsed event node (kind-X circle)
                const eventNodeEl = target.closest(".node-circle[data-item-id]:not(.pubkey-node):not(.tag-node)");
                if (eventNodeEl) {
                    const nodeId = eventNodeEl.getAttribute("data-item-id");
                    if (nodeId) {
                        const nodeData = graph?.getNodeData(nodeId);
                        // Only show menu if node is collapsed
                        if (nodeData && !nodeData.data?.expanded) {
                            const event = nodeData.data?.event; // Nostr event
                            const isExpanded = nodeData.data?.expanded || false;
                            const actions = [
                                {
                                    label: isExpanded ? "Collapse card" : "Expand card",
                                    icon: isExpanded ? "mdi-arrow-collapse" : "mdi-arrow-expand",
                                    handler: ()=>{
                                        // Simulate double-click to toggle expansion
                                        graph?.emit("node:dblclick", {
                                            item: {
                                                id: nodeId
                                            },
                                            target: {
                                                id: nodeId
                                            }
                                        });
                                    }
                                }
                            ];
                            if (event) {
                                // Get author pubkey
                                const authorPubkey = event.pubkey;
                                actions.push({
                                    label: "Expand author profile",
                                    icon: "mdi-account-details",
                                    handler: ()=>expandAuthorProfile(authorPubkey)
                                }, {
                                    label: "Expand all posts by author",
                                    icon: "mdi-post-outline",
                                    handler: ()=>expandAuthorPosts(authorPubkey)
                                });
                                // Add stat expansion options
                                actions.push({
                                    label: "Expand replies",
                                    icon: "mdi-comment",
                                    handler: ()=>handleExpandStat(nodeId, "replies")
                                }, {
                                    label: "Expand reactions",
                                    icon: "mdi-heart",
                                    handler: ()=>handleExpandStat(nodeId, "reactions")
                                }, {
                                    label: "Expand reposts",
                                    icon: "mdi-repeat",
                                    handler: ()=>handleExpandStat(nodeId, "reposts")
                                });
                                // Copy event ID/link
                                actions.push({
                                    label: "Copy event ID",
                                    icon: "mdi-content-copy",
                                    handler: async ()=>{
                                        try {
                                            await navigator.clipboard.writeText(event.id);
                                            showMessage("Event ID copied to clipboard", "success");
                                        } catch (err) {
                                            console.error("Failed to copy:", err);
                                            showMessage("Failed to copy event ID", "error");
                                        }
                                    }
                                });
                                // Kanban board: expand cards
                                if (event.kind === 30301) actions.push({
                                    label: "Expand kanban cards",
                                    icon: "mdi-cards",
                                    handler: ()=>expandKanbanCards(nodeId)
                                });
                            }
                            actions.push({
                                label: "Start investigation from here",
                                icon: "mdi-target",
                                handler: ()=>startInvestigation(nodeId)
                            }, {
                                label: "Make tree root",
                                icon: "mdi-tree",
                                handler: ()=>makeTreeRoot(nodeId)
                            }, {
                                label: "Remove from graph",
                                icon: "mdi-delete",
                                handler: ()=>removeNode(nodeId)
                            });
                            const kindLabel = event ? `Event (kind ${event.kind})` : "Event";
                            showContextMenu(e.clientX, e.clientY, kindLabel, actions);
                            return;
                        }
                    }
                }
                // Check if clicking on a tag
                const tagEl = target.closest("[data-tag]");
                if (tagEl) {
                    const tag = tagEl.getAttribute("data-tag");
                    if (tag) {
                        // Get the node ID from the card
                        const cardEl = tagEl.closest("[data-item-id]");
                        const nodeId = cardEl?.getAttribute("data-item-id");
                        const actions = [
                            {
                                label: "Expand posts with this tag",
                                icon: "mdi-tag-plus",
                                handler: ()=>expandByTag(tag)
                            },
                            {
                                label: "Filter to show only this tag",
                                icon: "mdi-filter",
                                handler: ()=>filterByTag(tag)
                            },
                            {
                                label: "Highlight posts with this tag",
                                icon: "mdi-marker",
                                handler: ()=>highlightByTag(tag)
                            }
                        ];
                        if (nodeId) actions.push({
                            label: "Start investigation from here",
                            icon: "mdi-target",
                            handler: ()=>startInvestigation(nodeId)
                        }, {
                            label: "Make tree root",
                            icon: "mdi-tree",
                            handler: ()=>makeTreeRoot(nodeId)
                        }, {
                            label: "Remove this node",
                            icon: "mdi-delete",
                            handler: ()=>removeNode(nodeId)
                        });
                        showContextMenu(e.clientX, e.clientY, `Tag: #${tag}`, actions);
                        return;
                    }
                }
                // Check if clicking on a mention
                const mentionEl = target.closest("[data-mention]");
                if (mentionEl) {
                    const pubkey = mentionEl.getAttribute("data-mention");
                    if (pubkey) {
                        // Get the node ID from the card
                        const cardEl = mentionEl.closest("[data-item-id]");
                        const nodeId = cardEl?.getAttribute("data-item-id");
                        const actions = [
                            {
                                label: "Expand user posts",
                                icon: "mdi-post",
                                handler: ()=>expandAuthorPosts(pubkey)
                            },
                            {
                                label: "Expand user profile",
                                icon: "mdi-account",
                                handler: ()=>expandAuthorProfile(pubkey)
                            },
                            {
                                label: "Filter to show only this user",
                                icon: "mdi-filter",
                                handler: ()=>filterByAuthor(pubkey)
                            },
                            {
                                label: "Highlight user content",
                                icon: "mdi-marker",
                                handler: ()=>highlightByAuthor(pubkey)
                            }
                        ];
                        if (nodeId) actions.push({
                            label: "Start investigation from here",
                            icon: "mdi-target",
                            handler: ()=>startInvestigation(nodeId)
                        }, {
                            label: "Make tree root",
                            icon: "mdi-tree",
                            handler: ()=>makeTreeRoot(nodeId)
                        }, {
                            label: "Remove this node",
                            icon: "mdi-delete",
                            handler: ()=>removeNode(nodeId)
                        });
                        showContextMenu(e.clientX, e.clientY, `User ${pubkey.slice(0, 8)}...`, actions);
                        return;
                    }
                }
                // Check if clicking on author section
                const authorEl = target.closest("[data-author-pubkey]");
                if (authorEl) {
                    const pubkey = authorEl.getAttribute("data-author-pubkey");
                    if (pubkey) {
                        // Get the node ID from the card
                        const cardEl = authorEl.closest("[data-item-id]");
                        const nodeId = cardEl?.getAttribute("data-item-id");
                        const actions = [
                            {
                                label: "Expand all posts by author",
                                icon: "mdi-post-outline",
                                handler: ()=>expandAuthorPosts(pubkey)
                            },
                            {
                                label: "Expand blog articles (kind 30023)",
                                icon: "mdi-book-open",
                                handler: ()=>expandAuthorArticles(pubkey)
                            },
                            {
                                label: "Expand author profile",
                                icon: "mdi-account-details",
                                handler: ()=>expandAuthorProfile(pubkey)
                            },
                            {
                                label: "Show followers/following",
                                icon: "mdi-account-group",
                                handler: ()=>expandAuthorNetwork(pubkey)
                            },
                            {
                                label: "Filter to show only this author",
                                icon: "mdi-filter",
                                handler: ()=>filterByAuthor(pubkey)
                            }
                        ];
                        if (nodeId) actions.push({
                            label: "Start investigation from here",
                            icon: "mdi-target",
                            handler: ()=>startInvestigation(nodeId)
                        }, {
                            label: "Make tree root",
                            icon: "mdi-tree",
                            handler: ()=>makeTreeRoot(nodeId)
                        }, {
                            label: "Remove this node",
                            icon: "mdi-delete",
                            handler: ()=>removeNode(nodeId)
                        });
                        showContextMenu(e.clientX, e.clientY, `Author ${pubkey.slice(0, 8)}...`, actions);
                        return;
                    }
                }
                // Check if clicking on an expanded profile card
                const profileCardEl = target.closest(".profile-card[data-item-id][data-pubkey]");
                if (profileCardEl) {
                    const nodeId = profileCardEl.getAttribute("data-item-id");
                    const pubkey = profileCardEl.getAttribute("data-pubkey");
                    if (nodeId && pubkey) {
                        const actions = [
                            {
                                label: "Expand all posts by author",
                                icon: "mdi-post-outline",
                                handler: ()=>expandAuthorPosts(pubkey)
                            },
                            {
                                label: "Expand blog articles (kind 30023)",
                                icon: "mdi-book-open",
                                handler: ()=>expandAuthorArticles(pubkey)
                            },
                            {
                                label: "Show followers/following",
                                icon: "mdi-account-group",
                                handler: ()=>expandAuthorNetwork(pubkey)
                            },
                            {
                                label: "Filter to show only this author",
                                icon: "mdi-filter",
                                handler: ()=>filterByAuthor(pubkey)
                            },
                            {
                                label: "Copy pubkey",
                                icon: "mdi-content-copy",
                                handler: async ()=>{
                                    try {
                                        await navigator.clipboard.writeText(pubkey);
                                        showMessage("Pubkey copied to clipboard", "success");
                                    } catch (err) {
                                        console.error("Failed to copy:", err);
                                        showMessage("Failed to copy pubkey", "error");
                                    }
                                }
                            },
                            {
                                label: "Start investigation from here",
                                icon: "mdi-target",
                                handler: ()=>startInvestigation(nodeId)
                            },
                            {
                                label: "Make tree root",
                                icon: "mdi-tree",
                                handler: ()=>makeTreeRoot(nodeId)
                            },
                            {
                                label: "Remove this profile",
                                icon: "mdi-delete",
                                handler: ()=>removeNode(nodeId)
                            }
                        ];
                        showContextMenu(e.clientX, e.clientY, `Profile: ${pubkey.slice(0, 8)}...`, actions);
                        return;
                    }
                }
                // Check if clicking on a card (general note context menu)
                const cardEl = target.closest("[data-item-id][data-kind][data-author]");
                if (cardEl) {
                    const kind = cardEl.getAttribute("data-kind");
                    const author = cardEl.getAttribute("data-author");
                    const itemId = cardEl.getAttribute("data-item-id");
                    if (kind && author && itemId) {
                        const kindNum = parseInt(kind);
                        let title = "Note Options";
                        const actions = [];
                        // Add kind-specific options
                        if (kindNum === 6) // Repost
                        actions.push({
                            label: "Show original post",
                            icon: "mdi-bookmark",
                            handler: ()=>expandOriginalPost(itemId)
                        });
                        if (kindNum === 1 || kindNum === 30023) {
                            // Note or Article
                            actions.push({
                                label: "Show thread/replies",
                                icon: "mdi-comment-multiple",
                                handler: ()=>expandThread(itemId)
                            });
                            actions.push({
                                label: "Show reactions",
                                icon: "mdi-heart",
                                handler: ()=>expandReactions(itemId)
                            });
                            actions.push({
                                label: "Show reposts",
                                icon: "mdi-repeat",
                                handler: ()=>expandReposts(itemId)
                            });
                        }
                        // Always add author expand option
                        actions.push({
                            label: "Start investigation from here",
                            icon: "mdi-target",
                            handler: ()=>startInvestigation(itemId)
                        });
                        actions.push({
                            label: "Expand author profile",
                            icon: "mdi-account",
                            handler: ()=>expandAuthorProfile(author)
                        });
                        actions.push({
                            label: "Filter to show related",
                            icon: "mdi-filter",
                            handler: ()=>filterRelated(itemId)
                        });
                        actions.push({
                            label: "Make tree root",
                            icon: "mdi-tree",
                            handler: ()=>makeTreeRoot(itemId)
                        });
                        actions.push({
                            label: "Remove this node",
                            icon: "mdi-delete",
                            handler: ()=>removeNode(itemId)
                        });
                        showContextMenu(e.clientX, e.clientY, title, actions);
                        return;
                    }
                }
            });
            // Handle mouse wheel for scrolling cards
            graphRef.value.addEventListener("wheel", (e)=>{
                // Find which card (if any) the mouse is currently over
                const target = e.target;
                const expandedCard = target.closest(".event-node.expanded");
                if (!expandedCard) // Mouse is not over an expanded card, allow normal zoom behavior
                return;
                // Find the card body (scrollable content area)
                const cardBody = expandedCard.querySelector(".event-body");
                if (!cardBody) return;
                // Check if we're actually over the content area (not just the card container)
                const bodyRect = cardBody.getBoundingClientRect();
                const isOverBody = e.clientX >= bodyRect.left && e.clientX <= bodyRect.right && e.clientY >= bodyRect.top && e.clientY <= bodyRect.bottom;
                if (isOverBody) {
                    // Prevent canvas zoom and scroll the card instead
                    e.preventDefault();
                    e.stopPropagation();
                    cardBody.scrollTop += e.deltaY;
                }
            // If mouse is over card but not over scrollable body (e.g., header/footer),
            // allow normal zoom behavior by not preventing default
            }, {
                passive: false
            });
            // Deselect card when clicking outside
            graphRef.value.addEventListener("click", (e)=>{
                const target = e.target;
                const card = target.closest(".event-node.expanded");
                if (!card) selectedCardId.value = null;
            });
            // Handle window resize
            window.addEventListener("resize", handleResize);
            // Listen to G6 selection events to sync with our state
            graph.on("afteritemselected", (_evt)=>{
                // Sync selectedNodeIds for batch operations menu
                if (!graph) return;
                const allNodes = graphData.value.nodes;
                if (!allNodes) return;
                const selected = new Set();
                allNodes.forEach((node)=>{
                    const state = graph?.getElementState(node.id);
                    if (state && state.includes('selected')) selected.add(node.id);
                });
                selectedNodeIds.value = selected;
                console.log("[Selection] Nodes selected:", selected.size);
                // Apply CSS class for visual feedback on HTML nodes (halo doesn't work with HTML)
                setTimeout(()=>{
                    selected.forEach((nodeId)=>{
                        const element = graphRef.value?.querySelector(`[data-item-id="${nodeId}"]`);
                        if (element && !element.classList.contains("g6-selected")) element.classList.add("g6-selected");
                    });
                }, 10);
            });
            graph.on("afteritemsunselected", (_evt)=>{
                // Sync selectedNodeIds for batch operations menu
                if (!graph) return;
                const allNodes = graphData.value.nodes;
                if (!allNodes) return;
                const selected = new Set();
                allNodes.forEach((node)=>{
                    const state = graph?.getElementState(node.id);
                    if (state && state.includes('selected')) selected.add(node.id);
                });
                selectedNodeIds.value = selected;
                console.log("[Selection] Nodes after unselect:", selected.size);
                // Remove CSS class from all nodes first
                const allElements = graphRef.value?.querySelectorAll("[data-item-id]");
                allElements?.forEach((el)=>{
                    el.classList.remove("g6-selected");
                });
                // Re-apply to still-selected nodes
                setTimeout(()=>{
                    selected.forEach((nodeId)=>{
                        const element = graphRef.value?.querySelector(`[data-item-id="${nodeId}"]`);
                        if (element) element.classList.add("g6-selected");
                    });
                }, 10);
            });
            // Set up Escape key handler to clear selection
            window.addEventListener("keydown", handleEscapeKey);
            // Restore last active investigation if available
            (async ()=>{
                const lastStateId = (0, $59sLQ.getLastActiveState)();
                if (lastStateId) try {
                    const state = await (0, $59sLQ.loadGraphState)(lastStateId);
                    if (state) {
                        console.log("[Investigation] Restoring last active state:", state.name);
                        await restoreInvestigation(lastStateId);
                        return; // Don't load from DB, we're restoring saved state
                    }
                } catch (error) {
                    console.warn("[Investigation] Failed to restore last state:", error);
                }
                // If no saved state or restoring failed, try loading from database
                loadFromDb();
            })();
        });
        (0, $TusQn.onUnmounted)(()=>{
            if (graph) graph.destroy();
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("keydown", handleEscapeKey);
        });
        // Cascades node visibility to their edges.
        // G6's timebar mode:"visibility" only hides nodes; edges must be synced manually.
        function syncEdgeVisibility() {
            if (!graph) return;
            const range = timebarTimeRange.value;
            const allData = graph.getData();
            const nodes = allData.nodes ?? [];
            const edges = allData.edges ?? [];
            // Mirror the timebar's own getTime logic to know which nodes are visible
            const visibleNodeIds = new Set();
            if (!range) nodes.forEach((n)=>visibleNodeIds.add(n.id));
            else {
                const [start, end] = range;
                nodes.forEach((node)=>{
                    if (node.data?.type === 'pubkey') {
                        visibleNodeIds.add(node.id);
                        return;
                    }
                    const t = node.data?.event?.created_at || node.data?.created_at;
                    const ms = t ? t * 1000 : null;
                    if (ms !== null && ms >= start && ms <= end) visibleNodeIds.add(node.id);
                });
            }
            const toShow = [];
            const toHide = [];
            edges.forEach((edge)=>{
                if (!edge.id) return;
                if (visibleNodeIds.has(edge.source) && visibleNodeIds.has(edge.target)) toShow.push(edge.id);
                else toHide.push(edge.id);
            });
            if (toShow.length > 0) graph.showElement(toShow);
            if (toHide.length > 0) graph.hideElement(toHide);
        }
        // Helper: re-apply the active time filter after setData() replaces graph data.
        // With mode:"visibility" updatePlugin correctly re-hides out-of-range nodes after
        // any setData() call because nodes stay in the data graph (just hidden/shown)
        // and the timebar re-evaluates all of them when values are set.
        function refreshTimebar() {
            if (!graph) return;
            graph.updatePlugin({
                key: 'timebar',
                data: timebarData.value,
                values: timebarTimeRange.value || defaultTimeRange.value
            });
            // updatePlugin triggers async re-evaluation; sync edges after the tick
            setTimeout(()=>syncEdgeVisibility(), 0);
        }
        // Watch for timebarData changes and update the timebar plugin dynamically
        (0, $01W3b.watch)(timebarData, (newData)=>{
            if (!graph) return;
            console.log('[Timebar] Updating data with', newData.length, 'points');
            graph.updatePlugin({
                key: 'timebar',
                data: newData
            });
        }, {
            deep: true
        });
        // Watch for layout changes
        (0, $01W3b.watch)(layoutMode, (newLayout, oldLayout)=>{
            if (!graph || !graphData.value) return;
            const newIsTree = isTreeLayout(newLayout);
            const oldIsTree = oldLayout ? isTreeLayout(oldLayout) : false;
            console.log("[Layout Switch]", oldLayout, "->", newLayout, "newIsTree:", newIsTree, "oldIsTree:", oldIsTree);
            // Preserve original graph data if not already saved
            // Use currently rendered graph data, not all data from store
            if (!originalGraphData.value) {
                const currentData = graph.getData();
                console.log("[Layout] Saving current graph data:", currentData.nodes?.length, "nodes,", currentData.edges?.length, "edges");
                if (currentData.nodes && currentData.edges) originalGraphData.value = {
                    nodes: JSON.parse(JSON.stringify(currentData.nodes)),
                    edges: JSON.parse(JSON.stringify(currentData.edges))
                };
            }
            // Switching to tree layout
            if (newIsTree && !oldIsTree) {
                console.log("[Layout] Switching to tree layout, converting data");
                // Use current data from graphStore to ensure we have all nodes
                const nodes = graphStore.nodes;
                const edges = graphStore.edges;
                // Save a snapshot for potential restoration (though we now use graphStore directly)
                if (!originalGraphData.value) originalGraphData.value = {
                    nodes: JSON.parse(JSON.stringify(nodes)),
                    edges: JSON.parse(JSON.stringify(edges))
                };
                console.log("[Layout] Converting", nodes.length, "nodes and", edges.length, "edges to tree");
                // Find root node (or ask user if no active node)
                let rootId = findBestRoot(nodes, edges);
                if (!rootId && nodes.length > 0) {
                    // TODO: Show dialog to let user select root
                    console.warn("[Layout] No root found, using first node");
                    rootId = nodes[0].id;
                }
                if (rootId) {
                    treeRootId.value = rootId;
                    const treeData = prepareTreeData(nodes, edges, rootId);
                    console.log("[Layout] Tree data:", treeData);
                    graph.setData(treeData);
                    graph.setLayout(getLayoutConfig(newLayout));
                    graph.layout();
                    graph.render();
                    refreshTimebar();
                    // Fit view after tree layout
                    setTimeout(()=>{
                        graph.fitView();
                    }, 500);
                }
            } else if (!newIsTree && oldIsTree) {
                console.log("[Layout] Switching to graph layout, restoring all data");
                // Use current data from graphStore (which includes all nodes added during tree layout)
                // Don't use originalGraphData as it's a stale snapshot from before tree layout
                const currentGraphData = {
                    nodes: graphStore.nodes,
                    edges: graphStore.edges
                };
                console.log("[Layout] Restoring", currentGraphData.nodes.length, "nodes and", currentGraphData.edges.length, "edges");
                graph.setData(currentGraphData);
                graph.setLayout(getLayoutConfig(newLayout));
                graph.layout();
                graph.render();
                refreshTimebar();
                // Clear the cached originalGraphData since we're back to normal graph mode
                originalGraphData.value = null;
            } else {
                if (newIsTree && treeRootId.value) {
                    // Tree to tree - rebuild tree with same root using current graph data
                    console.log("[Layout] Tree to tree switch, rebuilding with root:", treeRootId.value);
                    // Use current data from graphStore to include any nodes added during tree layout
                    const nodes = graphStore.nodes;
                    const edges = graphStore.edges;
                    console.log("[Layout] Using current graph data:", nodes.length, "nodes,", edges.length, "edges");
                    const treeData = prepareTreeData(nodes, edges, treeRootId.value);
                    graph.setData(treeData);
                }
                graph.setLayout(getLayoutConfig(newLayout));
                graph.layout();
                refreshTimebar();
            }
            // Start animation on layout change
            isAnimating.value = true;
        });
        // Watch for data changes
        (0, $01W3b.watch)(graphData, (newData)=>{
            console.log("[Watch] Graph data changed, nodes:", newData.nodes?.length, "edges:", newData.edges?.length);
            if (graph) {
                graph.setData(newData);
                graph.render();
                refreshTimebar();
                // Don't auto-start animation on data updates
                // User can manually start if needed
                // Reset original graph data when graph data changes (e.g., after "investigate from here")
                // This ensures tree layouts use the current graph, not old cached data
                if (!isTreeLayout(layoutMode.value)) {
                    console.log("[Data] Graph data changed, resetting originalGraphData cache");
                    originalGraphData.value = null;
                }
                // Check for pending restore (e.g., after loading investigation)
                const pendingRestore = window.__pendingRestore;
                if (pendingRestore) {
                    console.log("[Restore] Applying pending expanded cards:", pendingRestore.expandedCardIds);
                    // Clear pending restore flag immediately to prevent duplicate processing
                    delete window.__pendingRestore;
                    // Wait for graph to fully render before restoring expanded cards
                    setTimeout(()=>{
                        if (!graph) return;
                        // Restore expanded cards
                        if (pendingRestore.expandedCardIds && pendingRestore.expandedCardIds.length > 0) {
                            const nodeUpdates = [];
                            pendingRestore.expandedCardIds.forEach((nodeId)=>{
                                const nodeData = graph.getNodeData(nodeId);
                                if (nodeData) {
                                    console.log("[Restore] Expanding node:", nodeId);
                                    nodeUpdates.push({
                                        ...nodeData,
                                        data: {
                                            ...nodeData.data,
                                            expanded: true
                                        },
                                        style: {
                                            ...nodeData.style,
                                            size: [
                                                400,
                                                300
                                            ],
                                            dx: -200,
                                            dy: -150
                                        }
                                    });
                                } else console.warn("[Restore] Node not found:", nodeId);
                            });
                            if (nodeUpdates.length > 0) {
                                graph.updateNodeData(nodeUpdates);
                                graph.render();
                                console.log("[Restore] Restored", nodeUpdates.length, "expanded cards");
                            }
                        }
                        // Restore zoom
                        if (pendingRestore.zoom) try {
                            graph.zoomTo(pendingRestore.zoom, {
                                x: 0,
                                y: 0
                            });
                        } catch (e) {
                            console.warn("[Restore] Could not restore zoom:", e);
                        }
                    }, 100);
                }
            }
        }, {
            deep: true
        });
        // Watch for relay dialog open to refresh data
        (0, $01W3b.watch)(()=>relayDialog.value.show, async (isOpen)=>{
            if (isOpen) {
                await relayManager.loadRelays();
                relayManager.updateStats();
            }
        });
        // Watch for selected card changes to update CSS classes
        (0, $01W3b.watch)(selectedCardId, (newCardId, oldCardId)=>{
            if (!graphRef.value) return;
            // Remove selected class from previous card immediately
            if (oldCardId) {
                const oldCard = graphRef.value.querySelector(`[data-item-id="${oldCardId}"]`);
                if (oldCard) oldCard.classList.remove("selected");
            }
            // Add selected class to new card
            if (newCardId) {
                const tryAddClass = ()=>{
                    const newCard = graphRef.value?.querySelector(`[data-item-id="${newCardId}"]`);
                    if (newCard) {
                        newCard.classList.add("selected");
                        console.log("[Card] Applied selected class to:", newCardId);
                        return true;
                    }
                    return false;
                };
                // Try immediately first (for already expanded cards)
                if (!tryAddClass()) // If not found, wait for G6 to render (for newly expanded cards)
                setTimeout(()=>{
                    if (!tryAddClass()) console.warn("[Card] Could not find card element after delay:", newCardId);
                }, 50);
            }
        });
        // Watch for selected collapsed node changes to update CSS classes
        (0, $01W3b.watch)(selectedCollapsedNodeId, (newNodeId, oldNodeId)=>{
            if (!graphRef.value) return;
            // Remove selected class from previous node
            if (oldNodeId) {
                const oldNode = graphRef.value.querySelector(`.node-circle[data-item-id="${oldNodeId}"]`);
                if (oldNode) {
                    oldNode.classList.remove("selected-collapsed");
                    console.log("[Node] Removed selected-collapsed class from:", oldNodeId);
                }
            }
            // Add selected class to new node
            if (newNodeId) {
                const newNode = graphRef.value.querySelector(`.node-circle[data-item-id="${newNodeId}"]`);
                if (newNode) {
                    newNode.classList.add("selected-collapsed");
                    console.log("[Node] Applied selected-collapsed class to:", newNodeId, "- type:", newNode.className);
                } else console.warn("[Node] Could not find node to select:", newNodeId);
            }
        });
        // Clear multi-selection using G6 API
        function clearSelection() {
            if (!graph) return;
            // Clear state for all selected nodes
            selectedNodeIds.value.forEach((nodeId)=>{
                const state = graph?.getElementState(nodeId);
                if (state && state.includes('selected')) graph?.setElementState(nodeId, 'selected', false);
            });
            selectedNodeIds.value.clear();
            // Remove CSS classes
            const allElements = graphRef.value?.querySelectorAll("[data-item-id]");
            allElements?.forEach((el)=>{
                el.classList.remove("g6-selected");
            });
            console.log("[Selection] Cleared");
        }
        // Batch operations for multi-selection
        async function expandAllSelected() {
            if (!graph || selectedNodeIds.value.size === 0) return;
            console.log("[Batch] Expanding", selectedNodeIds.value.size, "nodes");
            const updates = [];
            selectedNodeIds.value.forEach((nodeId)=>{
                const nodeData = graph?.getNodeData(nodeId);
                if (nodeData && !nodeData.data?.expanded) {
                    // Only expand if has profile or event data
                    if (nodeData.data?.type === "pubkey" && !nodeData.data?.profile) return;
                    if (nodeData.data?.type !== "pubkey" && !nodeData.data?.event) return;
                    updates.push({
                        ...nodeData,
                        data: {
                            ...nodeData.data,
                            expanded: true
                        },
                        style: {
                            ...nodeData.style,
                            size: [
                                400,
                                300
                            ],
                            dx: -200,
                            dy: -150
                        }
                    });
                }
            });
            if (updates.length > 0) {
                graph.updateNodeData(updates);
                graph.render();
                showMessage(`Expanded ${updates.length} nodes`, "success");
            }
        }
        async function collapseAllSelected() {
            if (!graph || selectedNodeIds.value.size === 0) return;
            console.log("[Batch] Collapsing", selectedNodeIds.value.size, "nodes");
            const updates = [];
            selectedNodeIds.value.forEach((nodeId)=>{
                const nodeData = graph?.getNodeData(nodeId);
                if (nodeData && nodeData.data?.expanded) updates.push({
                    ...nodeData,
                    data: {
                        ...nodeData.data,
                        expanded: false
                    },
                    style: {
                        ...nodeData.style,
                        size: [
                            60,
                            60
                        ],
                        dx: -30,
                        dy: -30
                    }
                });
            });
            if (updates.length > 0) {
                graph.updateNodeData(updates);
                graph.render();
                showMessage(`Collapsed ${updates.length} nodes`, "success");
            }
        }
        async function expandPostsBySelectedAuthors() {
            if (!graph || selectedNodeIds.value.size === 0) return;
            const pubkeys = [];
            selectedNodeIds.value.forEach((nodeId)=>{
                const nodeData = graph?.getNodeData(nodeId);
                if (nodeData?.data?.type === "pubkey" && typeof nodeData.data.pubkey === 'string') pubkeys.push(nodeData.data.pubkey);
            });
            if (pubkeys.length === 0) {
                showMessage("No author nodes selected", "warning");
                return;
            }
            console.log("[Batch] Expanding posts for", pubkeys.length, "authors");
            showMessage(`Expanding posts for ${pubkeys.length} authors...`, "info");
            for (const pubkey of pubkeys)await expandAuthorPosts(pubkey);
        }
        async function expandArticlesBySelectedAuthors() {
            if (!graph || selectedNodeIds.value.size === 0) return;
            const pubkeys = [];
            selectedNodeIds.value.forEach((nodeId)=>{
                const nodeData = graph?.getNodeData(nodeId);
                if (nodeData?.data?.type === "pubkey" && typeof nodeData.data.pubkey === 'string') pubkeys.push(nodeData.data.pubkey);
            });
            if (pubkeys.length === 0) {
                showMessage("No author nodes selected", "warning");
                return;
            }
            console.log("[Batch] Expanding articles for", pubkeys.length, "authors");
            showMessage(`Expanding articles for ${pubkeys.length} authors...`, "info");
            for (const pubkey of pubkeys)await expandAuthorArticles(pubkey);
        }
        async function expandNetworkForSelectedAuthors() {
            if (!graph || selectedNodeIds.value.size === 0) return;
            const pubkeys = [];
            selectedNodeIds.value.forEach((nodeId)=>{
                const nodeData = graph?.getNodeData(nodeId);
                if (nodeData?.data?.type === "pubkey" && typeof nodeData.data.pubkey === 'string') pubkeys.push(nodeData.data.pubkey);
            });
            if (pubkeys.length === 0) {
                showMessage("No author nodes selected", "warning");
                return;
            }
            console.log("[Batch] Expanding network for", pubkeys.length, "authors");
            showMessage(`Expanding network for ${pubkeys.length} authors...`, "info");
            for (const pubkey of pubkeys)await expandAuthorNetwork(pubkey);
        }
        async function removeAllSelected() {
            if (!graph || selectedNodeIds.value.size === 0) return;
            const count = selectedNodeIds.value.size;
            console.log("[Batch] Removing", count, "nodes");
            // Convert to array to avoid modification during iteration
            const nodesToRemove = Array.from(selectedNodeIds.value);
            for (const nodeId of nodesToRemove)removeNode(nodeId);
            clearSelection();
            showMessage(`Removed ${count} nodes`, "success");
        }
        async function copySelectedIds() {
            if (!graph || selectedNodeIds.value.size === 0) return;
            const ids = [];
            selectedNodeIds.value.forEach((nodeId)=>{
                const nodeData = graph?.getNodeData(nodeId);
                if (nodeData) {
                    if (nodeData.data?.type === "pubkey" && typeof nodeData.data.pubkey === 'string') ids.push(nodeData.data.pubkey);
                    else if (nodeData.data?.event && typeof nodeData.data.event.id === 'string') ids.push(nodeData.data.event.id);
                    else ids.push(nodeId);
                }
            });
            const text = ids.join('\n');
            await navigator.clipboard.writeText(text);
            showMessage(`Copied ${ids.length} IDs to clipboard`, "success");
        }
        function handleResize() {
            if (graph && graphRef.value) graph.setSize(graphRef.value.offsetWidth, graphRef.value.offsetHeight);
        }
        function fitView() {
            if (graph) graph.fitView();
        }
        function toggleAnimation() {
            if (!graph) return;
            if (isAnimating.value) {
                graph.stopLayout();
                isAnimating.value = false;
                showMessage("Animation stopped", "info");
            } else {
                graph.layout();
                isAnimating.value = true;
                showMessage("Animation resumed", "info");
            }
        }
        function refreshGraph() {
            if (graph) {
                graph.layout();
                // Start animation on explicit refresh
                isAnimating.value = true;
            }
        }
        // Fetch global feed from Nostr relays
        async function fetchGlobal() {
            try {
                showMessage("Connecting to Nostr relays...", "info", 5000);
                const events = await fetchGlobalFeed(20);
                if (events.length === 0) {
                    showMessage("No events found. Relays may be slow or empty.", "warning", 5000);
                    return;
                }
                // After fetching, reload from database to show new events
                await loadFromDb();
                fitView();
                showMessage(`Fetched ${events.length} events successfully!`, "success");
            } catch (error) {
                console.error("Failed to fetch global feed:", error);
                showMessage("Failed to fetch events. Check console for details.", "error", 5000);
            }
        }
        // Load graph from IndexedDB
        async function loadFromDb() {
            try {
                await graphStore.loadFromDatabase();
                const count = graphStore.nodeCount;
                if (count === 0) showMessage("Database is empty. Try fetching events first.", "info", 4000);
                else showMessage(`Loaded ${count} events from database`, "success");
                fitView();
            } catch (error) {
                console.error("Failed to load from database:", error);
                showMessage("Failed to load from database", "error");
            }
        }
        // Clear all graph data
        function clearAll() {
            graphStore.clearGraph();
            showMessage("Graph cleared", "info");
        }
        // Relay Manager Functions
        // ========================
        // Handle adding a new relay
        async function handleAddRelay() {
            if (!newRelayUrl.value.trim()) return;
            const url = newRelayUrl.value.trim();
            console.log(`[GraphView] Adding relay: ${url}`);
            const success = await relayManager.addRelay(url);
            if (success) {
                console.log(`[GraphView] Relay added to database, reloading relay list...`);
                newRelayUrl.value = "";
                // Reload relay list in useNostr so it includes the new relay
                await loadRelaysFromDB();
                // Reload relay manager view
                await relayManager.loadRelays();
                relayManager.updateStats();
                // Test the connection for the new relay
                console.log(`[GraphView] Testing connections for updated relay list...`);
                await testAllRelayConnections();
                // Reload relay manager view again to show test results
                await relayManager.loadRelays();
                relayManager.updateStats();
                showMessage("Relay added successfully", "success");
            } else console.error(`[GraphView] Failed to add relay: ${url}`);
        }
        // Test all relay connections
        async function handleTestConnections() {
            testingConnections.value = true;
            try {
                // Reload relay list first to ensure we have latest from database
                await loadRelaysFromDB();
                await testAllRelayConnections();
                await relayManager.loadRelays();
                relayManager.updateStats();
                showMessage("Relay connections tested", "success");
            } catch (error) {
                console.error("Failed to test relay connections:", error);
                showMessage("Failed to test connections", "error");
            } finally{
                testingConnections.value = false;
            }
        }
        // Handle toggling relay enabled/disabled
        async function handleToggleRelay(url) {
            try {
                console.log(`[GraphView] Toggling relay: ${url}`);
                await relayManager.toggleRelay(url);
                // Reload relay list in useNostr to reflect the change
                await loadRelaysFromDB();
                // Reload relay manager view
                await relayManager.loadRelays();
                relayManager.updateStats();
                // Test connections for updated relay list
                console.log(`[GraphView] Testing connections after toggle...`);
                await testAllRelayConnections();
                // Reload relay manager view again to show test results
                await relayManager.loadRelays();
                relayManager.updateStats();
            } catch (error) {
                console.error("Failed to toggle relay:", error);
                showMessage("Failed to toggle relay", "error");
            }
        }
        // Handle removing a relay
        async function handleRemoveRelay(url) {
            try {
                console.log(`[GraphView] Removing relay: ${url}`);
                await relayManager.removeRelay(url);
                console.log(`[GraphView] Relay removed, reloading relay list...`);
                // Reload relay list in useNostr to remove the relay
                await loadRelaysFromDB();
                // Reload relay manager view
                await relayManager.loadRelays();
                relayManager.updateStats();
                showMessage("Relay removed", "info");
            } catch (error) {
                console.error("Failed to remove relay:", error);
                showMessage("Failed to remove relay", "error");
            }
        }
        // Get relay status color
        function getRelayStatusColor(status) {
            switch(status){
                case "connected":
                    return "success";
                case "connecting":
                    return "info";
                case "error":
                    return "error";
                case "disconnected":
                default:
                    return "grey";
            }
        }
        // Get relay status icon
        function getRelayStatusIcon(status) {
            switch(status){
                case "connected":
                    return "mdi-check-circle";
                case "connecting":
                    return "mdi-loading mdi-spin";
                case "error":
                    return "mdi-alert-circle";
                case "disconnected":
                default:
                    return "mdi-circle-outline";
            }
        }
        // Format relative time
        function formatRelativeTime(timestamp) {
            const now = Date.now();
            const diff = now - timestamp;
            const seconds = Math.floor(diff / 1000);
            const minutes = Math.floor(seconds / 60);
            const hours = Math.floor(minutes / 60);
            const days = Math.floor(hours / 24);
            if (seconds < 60) return "just now";
            if (minutes < 60) return `${minutes}m ago`;
            if (hours < 24) return `${hours}h ago`;
            return `${days}d ago`;
        }
        // Show notification message
        function showMessage(message, color = "success", timeout = 3000) {
            snackbar.value = {
                show: true,
                message: message,
                color: color,
                timeout: timeout
            };
        }
        // Handle expand request (from external UI if needed)
        async function handleExpand(eventId) {
            try {
                showMessage("Loading connected events...", "info", 5000);
                await graphStore.expandNode(eventId);
                fitView();
                showMessage("Graph expanded successfully", "success");
            } catch (error) {
                console.error("Failed to expand node:", error);
                showMessage("Failed to expand node", "error");
            }
        }
        // ===== Investigation State Management =====
        /**
 * Capture current graph state
 */ function captureCurrentState() {
            // Get expanded card IDs from the actual graph (not from store)
            const expandedCardIds = [];
            if (graph) // Iterate through all nodes and check their current state in the graph
            graphStore.nodes.forEach((node)=>{
                const nodeData = graph.getNodeData(node.id);
                if (nodeData?.data?.expanded) {
                    expandedCardIds.push(node.id);
                    console.log("[Save] Found expanded card:", node.id);
                }
            });
            console.log("[Save] Total expanded cards:", expandedCardIds.length);
            // Get camera position if available
            let zoom = null;
            let pan = null;
            if (graph) try {
                zoom = graph.getZoom();
            // TODO: G6 v5 camera API might differ, skip pan for now
            // const camera = graph.getCanvas().getCamera();
            // pan = { x: camera.x || 0, y: camera.y || 0 };
            } catch (e) {
                console.warn("Could not capture camera state:", e);
            }
            return {
                name: currentInvestigationName.value,
                description: "",
                graphData: {
                    nodes: JSON.parse(JSON.stringify(graphStore.nodes)),
                    edges: JSON.parse(JSON.stringify(graphStore.edges))
                },
                layoutType: layoutMode.value,
                selectedNodeId: graphStore.selectedNodeId,
                treeRootId: treeRootId.value,
                expandedCardIds: expandedCardIds,
                selectedCardId: selectedCardId.value,
                zoom: zoom,
                pan: pan,
                filters: {}
            };
        }
        /**
 * Save current investigation
 */ async function saveCurrentInvestigation() {
            try {
                const state = captureCurrentState();
                if (currentInvestigationId.value) {
                    // Update existing
                    await (0, $59sLQ.updateGraphState)(currentInvestigationId.value, state);
                    showMessage(`Saved "${currentInvestigationName.value}"`, "success");
                } else {
                    // Create new
                    const saved = await (0, $59sLQ.saveGraphState)(state);
                    currentInvestigationId.value = saved.id;
                    (0, $59sLQ.setLastActiveState)(saved.id);
                    showMessage(`Created "${currentInvestigationName.value}"`, "success");
                }
            } catch (error) {
                console.error("Failed to save investigation:", error);
                showMessage("Failed to save investigation", "error");
            }
        }
        /**
 * Restore investigation from saved state
 */ async function restoreInvestigation(stateId) {
            try {
                const state = await (0, $59sLQ.loadGraphState)(stateId);
                if (!state) {
                    showMessage("Investigation not found", "error");
                    return;
                }
                // Set pending restore BEFORE changing graph data (so watch can pick it up)
                window.__pendingRestore = {
                    expandedCardIds: state.expandedCardIds,
                    zoom: state.zoom,
                    pan: state.pan
                };
                console.log("[Restore] Set pending restore with expanded cards:", state.expandedCardIds);
                // Restore graph data (this will trigger the watch)
                graphStore.setGraphData({
                    nodes: state.graphData.nodes,
                    edges: state.graphData.edges
                });
                // Restore UI state
                layoutMode.value = state.layoutType;
                graphStore.selectedNodeId = state.selectedNodeId;
                treeRootId.value = state.treeRootId;
                selectedCardId.value = state.selectedCardId;
                // Set current investigation
                currentInvestigationId.value = state.id;
                currentInvestigationName.value = state.name;
                (0, $59sLQ.setLastActiveState)(state.id);
                showMessage(`Loaded "${state.name}"`, "success");
                savedStatesDialog.value = false;
            } catch (error) {
                console.error("Failed to restore investigation:", error);
                showMessage("Failed to restore investigation", "error");
            }
        }
        /**
 * Load all saved states for dialog
 */ async function loadSavedStates() {
            loadingStates.value = true;
            try {
                savedStates.value = await (0, $59sLQ.getAllGraphStates)();
            } catch (error) {
                console.error("Failed to load saved states:", error);
                showMessage("Failed to load saved states", "error");
            } finally{
                loadingStates.value = false;
            }
        }
        /**
 * Delete a saved investigation
 */ async function deleteInvestigation(stateId) {
            try {
                await (0, $59sLQ.deleteGraphState)(stateId);
                // If we deleted the current investigation, reset
                if (currentInvestigationId.value === stateId) {
                    currentInvestigationId.value = null;
                    currentInvestigationName.value = "Untitled Investigation";
                    (0, $59sLQ.setLastActiveState)(null);
                }
                await loadSavedStates();
                showMessage("Investigation deleted", "success");
            } catch (error) {
                console.error("Failed to delete investigation:", error);
                showMessage("Failed to delete investigation", "error");
            }
        }
        /**
 * Duplicate an investigation
 */ async function duplicateInvestigation(stateId) {
            try {
                const duplicate = await (0, $59sLQ.duplicateGraphState)(stateId);
                await loadSavedStates();
                showMessage(`Duplicated as "${duplicate.name}"`, "success");
            } catch (error) {
                console.error("Failed to duplicate investigation:", error);
                showMessage("Failed to duplicate investigation", "error");
            }
        }
        /**
 * Export investigation to JSON file
 */ async function exportInvestigation(stateId) {
            try {
                const state = await (0, $59sLQ.loadGraphState)(stateId);
                if (!state) return;
                const json = (0, $59sLQ.exportGraphState)(state);
                const blob = new Blob([
                    json
                ], {
                    type: "application/json"
                });
                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${state.name.replace(/[^a-z0-9]/gi, "_")}.json`;
                a.click();
                URL.revokeObjectURL(url);
                showMessage("Investigation exported", "success");
            } catch (error) {
                console.error("Failed to export investigation:", error);
                showMessage("Failed to export investigation", "error");
            }
        }
        /**
 * Import investigation from JSON file
 */ function importInvestigation() {
            const input = document.createElement("input");
            input.type = "file";
            input.accept = "application/json";
            input.onchange = async (e)=>{
                const file = e.target?.files?.[0];
                if (!file) return;
                try {
                    const text = await file.text();
                    const imported = await (0, $59sLQ.importGraphState)(text);
                    await loadSavedStates();
                    showMessage(`Imported "${imported.name}"`, "success");
                } catch (error) {
                    console.error("Failed to import investigation:", error);
                    showMessage("Failed to import investigation", "error");
                }
            };
            input.click();
        }
        /**
 * Create new investigation
 */ function createNewInvestigation() {
            currentInvestigationId.value = null;
            currentInvestigationName.value = "Untitled Investigation";
            (0, $59sLQ.setLastActiveState)(null);
            graphStore.clearGraph();
            showMessage("Started new investigation", "info");
        }
        /**
 * Rename investigation inline
 */ function startRenaming() {
            isEditingName.value = true;
        }
        function finishRenaming() {
            isEditingName.value = false;
        }
        // Expose investigation state and functions for parent component (App.vue)
        __expose({
            currentInvestigationId: // State
            currentInvestigationId,
            currentInvestigationName: currentInvestigationName,
            isEditingName: isEditingName,
            savedStatesDialog: savedStatesDialog,
            savedStates: savedStates,
            loadingStates: loadingStates,
            saveCurrentInvestigation: // Functions
            saveCurrentInvestigation,
            loadSavedStates: loadSavedStates,
            restoreInvestigation: restoreInvestigation,
            deleteInvestigation: deleteInvestigation,
            duplicateInvestigation: duplicateInvestigation,
            exportInvestigation: exportInvestigation,
            importInvestigation: importInvestigation,
            createNewInvestigation: createNewInvestigation,
            startRenaming: startRenaming,
            finishRenaming: finishRenaming
        });
        const __returned__ = {
            md: md,
            graphRef: graphRef,
            get graph () {
                return graph;
            },
            set graph (v){
                graph = v;
            },
            get layoutSettingsDebounceTimer () {
                return layoutSettingsDebounceTimer;
            },
            set layoutSettingsDebounceTimer (v){
                layoutSettingsDebounceTimer = v;
            },
            layoutMode: layoutMode,
            allLayoutOptions: allLayoutOptions,
            layoutSettings: layoutSettings,
            graphStore: graphStore,
            nodeCount: nodeCount,
            edgeCount: edgeCount,
            graphData: graphData,
            isTreeCompatible: isTreeCompatible,
            layoutOptions: layoutOptions,
            fetchGlobalFeed: fetchGlobalFeed,
            fetchInitialEvents: fetchInitialEvents,
            fetchByAuthor: fetchByAuthor,
            expandAroundEvent: expandAroundEvent,
            fetchUserGraph: fetchUserGraph,
            isFetching: isFetching,
            expandReactions: expandReactions,
            expandReplies: expandReplies,
            expandReposts: expandReposts,
            expandMentions: expandMentions,
            expandThread: expandThread,
            testAllRelayConnections: testAllRelayConnections,
            loadRelaysFromDB: loadRelaysFromDB,
            getPool: getPool,
            nostrRelays: nostrRelays,
            snackbar: snackbar,
            contextMenu: contextMenu,
            searchQuery: searchQuery,
            searchResults: searchResults,
            searchActive: searchActive,
            searchMode: searchMode,
            isSearching: isSearching,
            currentInvestigationId: currentInvestigationId,
            currentInvestigationName: currentInvestigationName,
            isEditingName: isEditingName,
            savedStatesDialog: savedStatesDialog,
            savedStates: savedStates,
            loadingStates: loadingStates,
            expandingNodes: expandingNodes,
            expandedStats: expandedStats,
            treeRootId: treeRootId,
            originalGraphData: originalGraphData,
            selectedCardId: selectedCardId,
            selectedCollapsedNodeId: selectedCollapsedNodeId,
            selectedNodeIds: selectedNodeIds,
            isAnimating: isAnimating,
            timebarTimeRange: timebarTimeRange,
            timebarData: timebarData,
            defaultTimeRange: defaultTimeRange,
            edgeStyles: edgeStyles,
            getEdgeStyle: getEdgeStyle,
            relayManager: relayManager,
            relayDialog: relayDialog,
            newRelayUrl: newRelayUrl,
            testingConnections: testingConnections,
            getKindColor: getKindColor,
            getNodeMarkerClass: getNodeMarkerClass,
            extractTags: extractTags,
            extractMentions: extractMentions,
            isReply: isReply,
            getRelativeTime: getRelativeTime,
            getEngagementMetrics: getEngagementMetrics,
            renderEventNode: renderEventNode,
            getEventTypeLabel: getEventTypeLabel,
            isTreeLayout: isTreeLayout,
            findBestRoot: findBestRoot,
            prepareTreeData: prepareTreeData,
            getLayoutConfig: getLayoutConfig,
            applyLayoutSettings: applyLayoutSettings,
            showContextMenu: showContextMenu,
            showMultiSelectionContextMenu: showMultiSelectionContextMenu,
            makeTreeRoot: makeTreeRoot,
            showStatContextMenu: showStatContextMenu,
            createAuthorNode: createAuthorNode,
            connectEventsToAuthor: connectEventsToAuthor,
            connectMentionsToAuthor: connectMentionsToAuthor,
            createTagNode: createTagNode,
            connectEventsToTag: connectEventsToTag,
            connectCardsToBoard: connectCardsToBoard,
            expandKanbanCards: expandKanbanCards,
            expandByTag: expandByTag,
            expandAuthorPosts: expandAuthorPosts,
            expandAuthorArticles: expandAuthorArticles,
            expandAuthorProfile: expandAuthorProfile,
            expandAuthorNetwork: expandAuthorNetwork,
            expandOriginalPost: expandOriginalPost,
            handleRefreshStat: handleRefreshStat,
            handleExpandStat: handleExpandStat,
            handleHideStat: handleHideStat,
            handleRefreshReactions: handleRefreshReactions,
            handleRefreshReplies: handleRefreshReplies,
            handleRefreshReposts: handleRefreshReposts,
            handleRefreshMentions: handleRefreshMentions,
            handleRefreshThread: handleRefreshThread,
            handleExpandReactions: handleExpandReactions,
            handleExpandReplies: handleExpandReplies,
            handleExpandReposts: handleExpandReposts,
            handleExpandMentions: handleExpandMentions,
            handleExpandThread: handleExpandThread,
            filterByTag: filterByTag,
            filterByAuthor: filterByAuthor,
            filterRelated: filterRelated,
            highlightByTag: highlightByTag,
            highlightByAuthor: highlightByAuthor,
            clearFilters: clearFilters,
            resetHighlights: resetHighlights,
            performSearch: performSearch,
            applySearchResults: applySearchResults,
            clearSearch: clearSearch,
            toggleSearchMode: toggleSearchMode,
            searchNostrRelays: searchNostrRelays,
            startInvestigation: startInvestigation,
            removeNode: removeNode,
            handleEscapeKey: handleEscapeKey,
            syncEdgeVisibility: syncEdgeVisibility,
            refreshTimebar: refreshTimebar,
            clearSelection: clearSelection,
            expandAllSelected: expandAllSelected,
            collapseAllSelected: collapseAllSelected,
            expandPostsBySelectedAuthors: expandPostsBySelectedAuthors,
            expandArticlesBySelectedAuthors: expandArticlesBySelectedAuthors,
            expandNetworkForSelectedAuthors: expandNetworkForSelectedAuthors,
            removeAllSelected: removeAllSelected,
            copySelectedIds: copySelectedIds,
            handleResize: handleResize,
            fitView: fitView,
            toggleAnimation: toggleAnimation,
            refreshGraph: refreshGraph,
            fetchGlobal: fetchGlobal,
            loadFromDb: loadFromDb,
            clearAll: clearAll,
            handleAddRelay: handleAddRelay,
            handleTestConnections: handleTestConnections,
            handleToggleRelay: handleToggleRelay,
            handleRemoveRelay: handleRemoveRelay,
            getRelayStatusColor: getRelayStatusColor,
            getRelayStatusIcon: getRelayStatusIcon,
            formatRelativeTime: formatRelativeTime,
            showMessage: showMessage,
            handleExpand: handleExpand,
            captureCurrentState: captureCurrentState,
            saveCurrentInvestigation: saveCurrentInvestigation,
            restoreInvestigation: restoreInvestigation,
            loadSavedStates: loadSavedStates,
            deleteInvestigation: deleteInvestigation,
            duplicateInvestigation: duplicateInvestigation,
            exportInvestigation: exportInvestigation,
            importInvestigation: importInvestigation,
            createNewInvestigation: createNewInvestigation,
            startRenaming: startRenaming,
            finishRenaming: finishRenaming
        };
        Object.defineProperty(__returned__, '__isScriptSetup', {
            enumerable: false,
            value: true
        });
        return __returned__;
    }
});

});
parcelRegister("2p9oc", function(module, exports) {
$parcel$export(module.exports, "Graph", () => (parcelRequire("cA8ew")).Graph);
parcelRequire("9feWW");
parcelRequire("7ElQg");

var $j2xPB = parcelRequire("j2xPB");
const $1c0533188dd74e2b$export$4078876fe7d0570b = {
    css: '//at.alicdn.com/t/a/font_470089_8hnbbf8n4u8.css',
    js: '//at.alicdn.com/t/a/font_470089_8hnbbf8n4u8.js'
};

});
parcelRegister("9feWW", function(module, exports) {

var $9YW1U = parcelRequire("9YW1U");
(0, $9YW1U.registerBuiltInExtensions)();

});
parcelRegister("9YW1U", function(module, exports) {

$parcel$export(module.exports, "registerBuiltInExtensions", () => $7446bb2b37b0a8a0$export$e0c749fb9cc441ad);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $am5xm = parcelRequire("am5xm");
parcelRequire("kVOIy");
var $cAn0T = parcelRequire("cAn0T");
var $8FmDy = parcelRequire("8FmDy");
var $hgdlM = parcelRequire("hgdlM");
var $0y4XY = parcelRequire("0y4XY");
var $h3bBs = parcelRequire("h3bBs");
var $1hotb = parcelRequire("1hotb");
var $hDdHF = parcelRequire("hDdHF");
var $g3gkU = parcelRequire("g3gkU");
var $apMdk = parcelRequire("apMdk");
var $hDdip = parcelRequire("hDdip");
var $5DaKb = parcelRequire("5DaKb");
var $8yr5d = parcelRequire("8yr5d");
var $bC6xM = parcelRequire("bC6xM");
var $62Rza = parcelRequire("62Rza");
var $02HiP = parcelRequire("02HiP");
parcelRequire("2zk86");
var $dbxRO = parcelRequire("dbxRO");
var $f2zuq = parcelRequire("f2zuq");
var $4tI2g = parcelRequire("4tI2g");
var $hjONv = parcelRequire("hjONv");
var $bs4me = parcelRequire("bs4me");
var $ln2PG = parcelRequire("ln2PG");
var $8nW3T = parcelRequire("8nW3T");
var $483tH = parcelRequire("483tH");
var $hoxMw = parcelRequire("hoxMw");
var $R3ntv = parcelRequire("R3ntv");
var $bHEt9 = parcelRequire("bHEt9");
var $gF4ts = parcelRequire("gF4ts");
var $95A9Q = parcelRequire("95A9Q");
var $5felS = parcelRequire("5felS");
var $Fb2Dh = parcelRequire("Fb2Dh");
var $3VmXJ = parcelRequire("3VmXJ");
var $4zzq7 = parcelRequire("4zzq7");
var $d1sdh = parcelRequire("d1sdh");
var $dIvRz = parcelRequire("dIvRz");
parcelRequire("hIZ0D");
var $2jk2f = parcelRequire("2jk2f");
var $hy6NM = parcelRequire("hy6NM");
var $1DkzN = parcelRequire("1DkzN");
parcelRequire("2oT5h");
var $3MWMO = parcelRequire("3MWMO");
var $1IlsW = parcelRequire("1IlsW");
var $5n8Ib = parcelRequire("5n8Ib");
var $hFThh = parcelRequire("hFThh");
var $kd0OI = parcelRequire("kd0OI");
var $hhpea = parcelRequire("hhpea");
var $iMTgF = parcelRequire("iMTgF");
var $7C1fc = parcelRequire("7C1fc");
var $eyWFr = parcelRequire("eyWFr");
var $irTWF = parcelRequire("irTWF");
var $eifoa = parcelRequire("eifoa");
var $e7HzC = parcelRequire("e7HzC");
var $k9H1V = parcelRequire("k9H1V");
var $1aclp = parcelRequire("1aclp");
var $4JXd9 = parcelRequire("4JXd9");
var $2D9MF = parcelRequire("2D9MF");

var $sm1F8 = parcelRequire("sm1F8");
parcelRequire("i257J");
var $3uNWk = parcelRequire("3uNWk");
var $isds8 = parcelRequire("isds8");
var $4XBSa = parcelRequire("4XBSa");
var $1uN78 = parcelRequire("1uN78");
var $cCF4r = parcelRequire("cCF4r");
var $5OSjO = parcelRequire("5OSjO");
var $bbw6O = parcelRequire("bbw6O");
var $86w7z = parcelRequire("86w7z");
var $cqIFg = parcelRequire("cqIFg");
var $7ZR3h = parcelRequire("7ZR3h");
var $7C4rJ = parcelRequire("7C4rJ");
var $gICz0 = parcelRequire("gICz0");
var $bU3Ie = parcelRequire("bU3Ie");
var $7Ns1A = parcelRequire("7Ns1A");
var $ly6UE = parcelRequire("ly6UE");
var $4Phbm = parcelRequire("4Phbm");
var $fha4x = parcelRequire("fha4x");
var $7mp9z = parcelRequire("7mp9z");
parcelRequire("jQdow");
var $92uCt = parcelRequire("92uCt");
var $cbrrv = parcelRequire("cbrrv");
parcelRequire("dVtfL");
var $5OxDh = parcelRequire("5OxDh");
var $hBwIB = parcelRequire("hBwIB");
var $5wIhF = parcelRequire("5wIhF");
var $3ykVL = parcelRequire("3ykVL");
var $7Sobs = parcelRequire("7Sobs");
var $5EwC3 = parcelRequire("5EwC3");
var $96oLK = parcelRequire("96oLK");
var $inULK = parcelRequire("inULK");

var $4H9Ri = parcelRequire("4H9Ri");
/**
 * <zh/> 内置插件统一在这里注册。
 * <en/> Built-in extensions are registered here.
 */ const $7446bb2b37b0a8a0$var$BUILT_IN_EXTENSIONS = {
    animation: {
        'combo-collapse': (0, $am5xm.ComboCollapse),
        'combo-expand': (0, $am5xm.ComboExpand),
        'node-collapse': (0, $am5xm.NodeCollapse),
        'node-expand': (0, $am5xm.NodeExpand),
        'path-in': (0, $am5xm.PathIn),
        'path-out': (0, $am5xm.PathOut),
        fade: (0, $am5xm.Fade),
        translate: (0, $am5xm.Translate)
    },
    behavior: {
        'brush-select': (0, $8FmDy.BrushSelect),
        'click-select': (0, $hgdlM.ClickSelect),
        'collapse-expand': (0, $0y4XY.CollapseExpand),
        'create-edge': (0, $h3bBs.CreateEdge),
        'drag-canvas': (0, $1hotb.DragCanvas),
        'drag-element-force': (0, $g3gkU.DragElementForce),
        'drag-element': (0, $hDdHF.DragElement),
        'fix-element-size': (0, $apMdk.FixElementSize),
        'focus-element': (0, $hDdip.FocusElement),
        'hover-activate': (0, $5DaKb.HoverActivate),
        'lasso-select': (0, $8yr5d.LassoSelect),
        'auto-adapt-label': (0, $cAn0T.AutoAdaptLabel),
        'optimize-viewport-transform': (0, $bC6xM.OptimizeViewportTransform),
        'scroll-canvas': (0, $62Rza.ScrollCanvas),
        'zoom-canvas': (0, $02HiP.ZoomCanvas)
    },
    combo: {
        circle: (0, $f2zuq.CircleCombo),
        rect: (0, $4zzq7.RectCombo)
    },
    edge: {
        cubic: (0, $4tI2g.Cubic),
        line: (0, $95A9Q.Line),
        polyline: (0, $5felS.Polyline),
        quadratic: (0, $Fb2Dh.Quadratic),
        'cubic-horizontal': (0, $hjONv.CubicHorizontal),
        'cubic-radial': (0, $bs4me.CubicRadial),
        'cubic-vertical': (0, $ln2PG.CubicVertical)
    },
    layout: {
        'antv-dagre': (0, $3MWMO.AntVDagreLayout),
        'combo-combined': (0, $5n8Ib.ComboCombinedLayout),
        'compact-box': (0, $hFThh.compactBox),
        'd3-force': (0, $hhpea.D3ForceLayout),
        'force-atlas2': (0, $eyWFr.ForceAtlas2Layout),
        circular: (0, $1IlsW.CircularLayout),
        concentric: (0, $kd0OI.ConcentricLayout),
        dagre: (0, $iMTgF.DagreLayout),
        dendrogram: (0, $hFThh.dendrogram),
        fishbone: (0, $7C1fc.FishboneLayout),
        force: (0, $irTWF.ForceLayout),
        fruchterman: (0, $eifoa.FruchtermanLayout),
        grid: (0, $e7HzC.GridLayout),
        indented: (0, $hFThh.indented),
        mds: (0, $k9H1V.MDSLayout),
        mindmap: (0, $hFThh.mindmap),
        radial: (0, $1aclp.RadialLayout),
        random: (0, $4JXd9.RandomLayout),
        snake: (0, $2D9MF.SnakeLayout)
    },
    node: {
        circle: (0, $dbxRO.Circle),
        diamond: (0, $8nW3T.Diamond),
        ellipse: (0, $hoxMw.Ellipse),
        hexagon: (0, $R3ntv.Hexagon),
        html: (0, $bHEt9.HTML),
        image: (0, $gF4ts.Image),
        rect: (0, $3VmXJ.Rect),
        star: (0, $d1sdh.Star),
        donut: (0, $483tH.Donut),
        triangle: (0, $dIvRz.Triangle)
    },
    palette: {
        spectral: $sm1F8.spectral,
        tableau: $sm1F8.tableau,
        oranges: $sm1F8.oranges,
        greens: $sm1F8.greens,
        blues: $sm1F8.blues
    },
    theme: {
        dark: $92uCt.dark,
        light: $cbrrv.light
    },
    plugin: {
        'bubble-sets': (0, $isds8.BubbleSets),
        'edge-bundling': (0, $1uN78.EdgeBundling),
        'edge-filter-lens': (0, $cCF4r.EdgeFilterLens),
        'grid-line': (0, $86w7z.GridLine),
        background: (0, $3uNWk.Background),
        contextmenu: (0, $4XBSa.Contextmenu),
        fisheye: (0, $5OSjO.Fisheye),
        fullscreen: (0, $bbw6O.Fullscreen),
        history: (0, $cqIFg.History),
        hull: (0, $7ZR3h.Hull),
        legend: (0, $7C4rJ.Legend),
        minimap: (0, $gICz0.Minimap),
        snapline: (0, $bU3Ie.Snapline),
        timebar: (0, $7Ns1A.Timebar),
        title: (0, $ly6UE.Title),
        toolbar: (0, $4Phbm.Toolbar),
        tooltip: (0, $fha4x.Tooltip),
        watermark: (0, $7mp9z.Watermark)
    },
    transform: {
        'arrange-draw-order': (0, $5OxDh.ArrangeDrawOrder),
        'collapse-expand-combo': (0, $hBwIB.CollapseExpandCombo),
        'collapse-expand-node': (0, $5wIhF.CollapseExpandNode),
        'get-edge-actual-ends': (0, $3ykVL.GetEdgeActualEnds),
        'map-node-size': (0, $7Sobs.MapNodeSize),
        'place-radial-labels': (0, $5EwC3.PlaceRadialLabels),
        'process-parallel-edges': (0, $96oLK.ProcessParallelEdges),
        'update-related-edges': (0, $inULK.UpdateRelatedEdge)
    },
    shape: {
        circle: (0, $2eDEB.Circle),
        ellipse: (0, $2eDEB.Ellipse),
        group: (0, $2eDEB.Group),
        html: (0, $2eDEB.HTML),
        image: (0, $hy6NM.Image),
        line: (0, $2eDEB.Line),
        path: (0, $2eDEB.Path),
        polygon: (0, $2eDEB.Polygon),
        polyline: (0, $2eDEB.Polyline),
        rect: (0, $2eDEB.Rect),
        text: (0, $2eDEB.Text),
        label: (0, $1DkzN.Label),
        badge: (0, $2jk2f.Badge)
    }
};
function $7446bb2b37b0a8a0$export$e0c749fb9cc441ad() {
    Object.entries($7446bb2b37b0a8a0$var$BUILT_IN_EXTENSIONS).forEach(([category, extensions])=>{
        Object.entries(extensions).forEach(([type, extension])=>{
            (0, $4H9Ri.register)(category, type, extension);
        });
    });
}

});
parcelRegister("cvVku", function(module, exports) {
/*!
 * @antv/g
 * @description A core module for rendering engine implements DOM API.
 * @version 6.3.1
 * @date 12/24/2025, 11:55:39 AM
 * @author AntVis
 * @docs https://g.antv.antgroup.com/
 */ 
var $2eDEB = parcelRequire("2eDEB");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $jLNr1 = parcelRequire("jLNr1");

var $f8wIT = parcelRequire("f8wIT");

var $fUHKi = parcelRequire("fUHKi");

var $02Ztr = parcelRequire("02Ztr");

var $8hhuV = parcelRequire("8hhuV");
var $geZBG = parcelRequire("geZBG");
var $jyI49 = parcelRequire("jyI49");
var $dFv1j = parcelRequire("dFv1j");
var $kVcyu = parcelRequire("kVcyu");

var $3iqbd = parcelRequire("3iqbd");
var $k1dpP = parcelRequire("k1dpP");
var $eIStk = parcelRequire("eIStk");

var $8HV7i = parcelRequire("8HV7i");

var $gZU1N = parcelRequire("gZU1N");

var $fOd0O = parcelRequire("fOd0O");

var $7JB23 = parcelRequire("7JB23");

var $8QL5z = parcelRequire("8QL5z");

var $cbdLd = parcelRequire("cbdLd");

var $g5Zhu = parcelRequire("g5Zhu");

var $dPop6 = parcelRequire("dPop6");
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationPlaybackEvent
 */ // @ts-ignore
var $91c4d9c00005fe28$export$5edd24b0d5bb3e56 = /*#__PURE__*/ function(_FederatedEvent) {
    function AnimationEvent(manager, target, currentTime, timelineTime) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnimationEvent);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, AnimationEvent, [
            manager
        ]);
        // @ts-ignore
        _this.currentTime = currentTime;
        _this.timelineTime = timelineTime;
        _this.target = target;
        _this.type = 'finish';
        _this.bubbles = false;
        // @ts-ignore
        _this.currentTarget = target;
        _this.defaultPrevented = false;
        _this.eventPhase = _this.AT_TARGET;
        _this.timeStamp = Date.now();
        _this.currentTime = currentTime;
        _this.timelineTime = timelineTime;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(AnimationEvent, _FederatedEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnimationEvent);
}((0, $2eDEB.FederatedEvent));
var $91c4d9c00005fe28$var$sequenceNumber = 0;
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Animation/Animation
 */ var $91c4d9c00005fe28$export$c35d437ae5945fcd = /*#__PURE__*/ function() {
    function Animation(effect, timeline) {
        var _this$effect;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Animation);
        this.currentTimePending = false;
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Animation/playState
     */ // playState: AnimationPlayState;
        this._idle = true;
        this._paused = false;
        this._finishedFlag = true;
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Animation/currentTime
     */ this._currentTime = 0;
        this._playbackRate = 1;
        this._inTimeline = true;
        this.effect = effect;
        effect.animation = this;
        this.timeline = timeline;
        this.id = "".concat($91c4d9c00005fe28$var$sequenceNumber++);
        this._inEffect = !!this.effect.update(0);
        this._totalDuration = Number((_this$effect = this.effect) === null || _this$effect === void 0 ? void 0 : _this$effect.getComputedTiming().endTime);
        this._holdTime = 0;
        this._paused = false;
        this.oldPlayState = 'idle';
        this.updatePromises();
    }
    /**
   * state machine,
   * resolve/reject ready/finished Promise according to current state
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Animation, [
        {
            key: "pending",
            get: /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Animation/effect
     */ /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Animation/timeline
     */ /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Animation/id
     */ // animation: InternalAnimation | null;
            /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Animation/pending
     */ function get() {
                return this._startTime === null && !this._paused && this.playbackRate !== 0 || this.currentTimePending;
            }
        },
        {
            key: "playState",
            get: function get() {
                if (this._idle) return 'idle';
                if (this._isFinished) return 'finished';
                if (this._paused) return 'paused';
                return 'running';
            }
        },
        {
            key: "ready",
            get: /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Animation/ready
     * @example
      animation.pause();
      animation.ready.then(function() {
        // Displays 'running'
        alert(animation.playState);
      });
      animation.play();
     */ function get() {
                var _this = this;
                if (!this.readyPromise) {
                    if (this.timeline.animationsWithPromises.indexOf(this) === -1) this.timeline.animationsWithPromises.push(this);
                    this.readyPromise = new Promise(function(resolve, reject) {
                        _this.resolveReadyPromise = function() {
                            resolve(_this);
                        };
                        _this.rejectReadyPromise = function() {
                            reject(new Error());
                        };
                    });
                    if (!this.pending) this.resolveReadyPromise();
                }
                return this.readyPromise;
            }
        },
        {
            key: "finished",
            get: function get() {
                var _this2 = this;
                if (!this.finishedPromise) {
                    if (this.timeline.animationsWithPromises.indexOf(this) === -1) this.timeline.animationsWithPromises.push(this);
                    this.finishedPromise = new Promise(function(resolve, reject) {
                        _this2.resolveFinishedPromise = function() {
                            resolve(_this2);
                        };
                        _this2.rejectFinishedPromise = function() {
                            reject(new Error());
                        };
                    });
                    if (this.playState === 'finished') this.resolveFinishedPromise();
                }
                return this.finishedPromise;
            }
        },
        {
            key: "currentTime",
            get: function get() {
                this.updatePromises();
                return this._idle || this.currentTimePending ? null : this._currentTime;
            },
            set: function set(newTime) {
                newTime = Number(newTime);
                if (isNaN(newTime)) return;
                this.timeline.restart();
                if (!this._paused && this._startTime !== null) {
                    var _this$timeline;
                    this._startTime = Number((_this$timeline = this.timeline) === null || _this$timeline === void 0 ? void 0 : _this$timeline.currentTime) - newTime / this.playbackRate;
                }
                this.currentTimePending = false;
                if (this._currentTime === newTime) return;
                if (this._idle) {
                    this._idle = false;
                    this._paused = true;
                }
                this.tickCurrentTime(newTime, true);
                this.timeline.applyDirtiedAnimation(this);
            }
        },
        {
            key: "startTime",
            get: function get() {
                return this._startTime;
            },
            set: function set(newTime) {
                if (newTime !== null) {
                    this.updatePromises();
                    newTime = Number(newTime);
                    if (isNaN(newTime)) return;
                    if (this._paused || this._idle) return;
                    this._startTime = newTime;
                    this.tickCurrentTime((Number(this.timeline.currentTime) - this._startTime) * this.playbackRate);
                    this.timeline.applyDirtiedAnimation(this);
                    this.updatePromises();
                }
            }
        },
        {
            key: "playbackRate",
            get: function get() {
                return this._playbackRate;
            },
            set: function set(value) {
                if (value === this._playbackRate) return;
                this.updatePromises();
                var oldCurrentTime = this.currentTime;
                this._playbackRate = value;
                this.startTime = null;
                if (this.playState !== 'paused' && this.playState !== 'idle') {
                    this._finishedFlag = false;
                    this._idle = false;
                    this.ensureAlive();
                    this.timeline.applyDirtiedAnimation(this);
                }
                if (oldCurrentTime !== null) this.currentTime = oldCurrentTime;
                this.updatePromises();
            }
        },
        {
            key: "_isFinished",
            get: function get() {
                return !this._idle && (this._playbackRate > 0 && Number(this._currentTime) >= this._totalDuration || this._playbackRate < 0 && Number(this._currentTime) <= 0);
            }
        },
        {
            key: "totalDuration",
            get: function get() {
                return this._totalDuration;
            }
        },
        {
            key: "_needsTick",
            get: function get() {
                return this.pending || this.playState === 'running' || !this._finishedFlag;
            }
        },
        {
            key: "updatePromises",
            value: function updatePromises() {
                var _this$effect$target;
                if ((_this$effect$target = this.effect.target) !== null && _this$effect$target !== void 0 && _this$effect$target.destroyed) {
                    this.readyPromise = undefined;
                    this.finishedPromise = undefined;
                    return false;
                }
                var oldPlayState = this.oldPlayState;
                var newPlayState = this.pending ? 'pending' : this.playState;
                if (this.readyPromise && newPlayState !== oldPlayState) {
                    if (newPlayState === 'idle') {
                        this.rejectReadyPromise();
                        this.readyPromise = undefined;
                    } else if (oldPlayState === 'pending') this.resolveReadyPromise();
                    else if (newPlayState === 'pending') this.readyPromise = undefined;
                }
                if (this.finishedPromise && newPlayState !== oldPlayState) {
                    if (newPlayState === 'idle') {
                        this.rejectFinishedPromise();
                        this.finishedPromise = undefined;
                    } else if (newPlayState === 'finished') this.resolveFinishedPromise();
                    else if (oldPlayState === 'finished') this.finishedPromise = undefined;
                }
                this.oldPlayState = newPlayState;
                return this.readyPromise || this.finishedPromise;
            }
        },
        {
            key: "play",
            value: function play() {
                this.updatePromises();
                this._paused = false;
                if (this._isFinished || this._idle) {
                    this.rewind();
                    this._startTime = null;
                }
                this._finishedFlag = false;
                this._idle = false;
                this.ensureAlive();
                this.timeline.applyDirtiedAnimation(this);
                if (this.timeline.animations.indexOf(this) === -1) this.timeline.animations.push(this);
                this.updatePromises();
            }
        },
        {
            key: "pause",
            value: function pause() {
                this.updatePromises();
                if (this.currentTime) this._holdTime = this.currentTime;
                if (!this._isFinished && !this._paused && !this._idle) this.currentTimePending = true;
                else if (this._idle) {
                    this.rewind();
                    this._idle = false;
                }
                this._startTime = null;
                this._paused = true;
                this.updatePromises();
            }
        },
        {
            key: "finish",
            value: function finish() {
                this.updatePromises();
                if (this._idle) return;
                this.currentTime = this._playbackRate > 0 ? this._totalDuration : 0;
                this._startTime = this._totalDuration - this.currentTime;
                this.currentTimePending = false;
                this.timeline.applyDirtiedAnimation(this);
                this.updatePromises();
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this3 = this;
                this.updatePromises();
                if (!this._inEffect) return;
                this._inEffect = false;
                this._idle = true;
                this._paused = false;
                this._finishedFlag = true;
                this._currentTime = null;
                this._startTime = null;
                this.effect.update(null);
                // effects are invalid after cancellation as the animation state
                // needs to un-apply.
                this.timeline.applyDirtiedAnimation(this);
                this.updatePromises();
                /**
       * 1. Reject the current finished promise with a DOMException named "AbortError".
       * 2. Let current finished promise be a new promise
       * @see https://w3c.github.io/csswg-drafts/web-animations-1/#canceling-an-animation-section
       */ // if (this.finishedPromise) {
                //   this.rejectFinishedPromise();
                //   this.finishedPromise = undefined;
                // }
                if (this.oncancel) {
                    var event = new $91c4d9c00005fe28$export$5edd24b0d5bb3e56(null, this, this.currentTime, null);
                    setTimeout(function() {
                        _this3.oncancel(event);
                    });
                }
            }
        },
        {
            key: "reverse",
            value: function reverse() {
                this.updatePromises();
                var oldCurrentTime = this.currentTime;
                this.playbackRate *= -1;
                this.play();
                if (oldCurrentTime !== null) this.currentTime = oldCurrentTime;
                this.updatePromises();
            }
        },
        {
            key: "updatePlaybackRate",
            value: function updatePlaybackRate(playbackRate) {
                this.playbackRate = playbackRate;
            }
        },
        {
            key: "targetAnimations",
            value: function targetAnimations() {
                var _this$effect2;
                var target = (_this$effect2 = this.effect) === null || _this$effect2 === void 0 ? void 0 : _this$effect2.target;
                return target.getAnimations();
            }
        },
        {
            key: "markTarget",
            value: function markTarget() {
                var animations = this.targetAnimations();
                if (animations.indexOf(this) === -1) animations.push(this);
            }
        },
        {
            key: "unmarkTarget",
            value: function unmarkTarget() {
                var animations = this.targetAnimations();
                var index = animations.indexOf(this);
                if (index !== -1) animations.splice(index, 1);
            }
        },
        {
            key: "tick",
            value: function tick(timelineTime, isAnimationFrame) {
                if (!this._idle && !this._paused) {
                    if (this._startTime === null) {
                        if (isAnimationFrame) this.startTime = timelineTime - this._currentTime / this.playbackRate;
                    } else if (!this._isFinished) this.tickCurrentTime((timelineTime - this._startTime) * this.playbackRate);
                }
                if (isAnimationFrame) {
                    this.currentTimePending = false;
                    this.fireEvents(timelineTime);
                }
            }
        },
        {
            key: "rewind",
            value: function rewind() {
                if (this.playbackRate >= 0) this.currentTime = 0;
                else if (this._totalDuration < Infinity) this.currentTime = this._totalDuration;
                else throw new Error('Unable to rewind negative playback rate animation with infinite duration');
            }
        },
        {
            key: "persist",
            value: function persist() {
                throw new Error((0, $2eDEB.ERROR_MSG_METHOD_NOT_IMPLEMENTED));
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                throw new Error((0, $2eDEB.ERROR_MSG_METHOD_NOT_IMPLEMENTED));
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(type, listener, options) {
                throw new Error((0, $2eDEB.ERROR_MSG_METHOD_NOT_IMPLEMENTED));
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(event) {
                throw new Error((0, $2eDEB.ERROR_MSG_METHOD_NOT_IMPLEMENTED));
            }
        },
        {
            key: "commitStyles",
            value: // replaceState: AnimationReplaceState;
            function commitStyles() {
                throw new Error((0, $2eDEB.ERROR_MSG_METHOD_NOT_IMPLEMENTED));
            }
        },
        {
            key: "ensureAlive",
            value: function ensureAlive() {
                // If an animation is playing backwards and is not fill backwards/both
                // then it should go out of effect when it reaches the start of its
                // active interval (currentTime === 0).
                if (this.playbackRate < 0 && this.currentTime === 0) {
                    var _this$effect3;
                    this._inEffect = !!((_this$effect3 = this.effect) !== null && _this$effect3 !== void 0 && _this$effect3.update(-1));
                } else {
                    var _this$effect4;
                    this._inEffect = !!((_this$effect4 = this.effect) !== null && _this$effect4 !== void 0 && _this$effect4.update(this.currentTime));
                }
                if (!this._inTimeline && (this._inEffect || !this._finishedFlag)) {
                    this._inTimeline = true;
                    this.timeline.animations.push(this);
                }
            }
        },
        {
            key: "tickCurrentTime",
            value: function tickCurrentTime(newTime, ignoreLimit) {
                if (newTime !== this._currentTime) {
                    this._currentTime = newTime;
                    if (this._isFinished && !ignoreLimit) this._currentTime = this._playbackRate > 0 ? this._totalDuration : 0;
                    this.ensureAlive();
                }
            }
        },
        {
            key: "fireEvents",
            value: function fireEvents(baseTime) {
                var _this4 = this;
                if (this._isFinished) {
                    if (!this._finishedFlag) {
                        if (this.onfinish) {
                            var event = new $91c4d9c00005fe28$export$5edd24b0d5bb3e56(null, this, this.currentTime, baseTime);
                            setTimeout(function() {
                                if (_this4.onfinish) _this4.onfinish(event);
                            });
                        }
                        this._finishedFlag = true;
                    }
                } else {
                    if (this.onframe && this.playState === 'running') {
                        var _event = new $91c4d9c00005fe28$export$5edd24b0d5bb3e56(null, this, this.currentTime, baseTime);
                        this.onframe(_event);
                    }
                    this._finishedFlag = false;
                }
            }
        }
    ]);
}();
/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */ // These values are established by empiricism with tests (tradeoff: performance VS precision)
var $91c4d9c00005fe28$var$NEWTON_ITERATIONS = 4;
var $91c4d9c00005fe28$var$NEWTON_MIN_SLOPE = 0.001;
var $91c4d9c00005fe28$var$SUBDIVISION_PRECISION = 0.0000001;
var $91c4d9c00005fe28$var$SUBDIVISION_MAX_ITERATIONS = 10;
var $91c4d9c00005fe28$var$kSplineTableSize = 11;
var $91c4d9c00005fe28$var$kSampleStepSize = 1.0 / ($91c4d9c00005fe28$var$kSplineTableSize - 1.0);
var $91c4d9c00005fe28$var$float32ArraySupported = typeof Float32Array === 'function';
var $91c4d9c00005fe28$var$A = function A(aA1, aA2) {
    return 1.0 - 3.0 * aA2 + 3.0 * aA1;
};
var $91c4d9c00005fe28$var$B = function B(aA1, aA2) {
    return 3.0 * aA2 - 6.0 * aA1;
};
var $91c4d9c00005fe28$var$C = function C(aA1) {
    return 3.0 * aA1;
};
// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
var $91c4d9c00005fe28$var$calcBezier = function calcBezier(aT, aA1, aA2) {
    return (($91c4d9c00005fe28$var$A(aA1, aA2) * aT + $91c4d9c00005fe28$var$B(aA1, aA2)) * aT + $91c4d9c00005fe28$var$C(aA1)) * aT;
};
// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
var $91c4d9c00005fe28$var$getSlope = function getSlope(aT, aA1, aA2) {
    return 3.0 * $91c4d9c00005fe28$var$A(aA1, aA2) * aT * aT + 2.0 * $91c4d9c00005fe28$var$B(aA1, aA2) * aT + $91c4d9c00005fe28$var$C(aA1);
};
var $91c4d9c00005fe28$var$binarySubdivide = function binarySubdivide(aX, aA, aB, mX1, mX2) {
    var currentX;
    var currentT;
    var i = 0;
    do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = $91c4d9c00005fe28$var$calcBezier(currentT, mX1, mX2) - aX;
        if (currentX > 0.0) aB = currentT;
        else aA = currentT;
    }while (Math.abs(currentX) > $91c4d9c00005fe28$var$SUBDIVISION_PRECISION && ++i < $91c4d9c00005fe28$var$SUBDIVISION_MAX_ITERATIONS);
    return currentT;
};
var $91c4d9c00005fe28$var$newtonRaphsonIterate = function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
    for(var i = 0; i < $91c4d9c00005fe28$var$NEWTON_ITERATIONS; ++i){
        var currentSlope = $91c4d9c00005fe28$var$getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = $91c4d9c00005fe28$var$calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
    }
    return aGuessT;
};
var $91c4d9c00005fe28$var$bezier = function bezier(mX1, mY1, mX2, mY2) {
    if (!(mX1 >= 0 && mX1 <= 1 && mX2 >= 0 && mX2 <= 1)) throw new Error('bezier x values must be in [0, 1] range');
    if (mX1 === mY1 && mX2 === mY2) return function(t) {
        return t;
    };
    // Precompute samples table
    var sampleValues = $91c4d9c00005fe28$var$float32ArraySupported ? new Float32Array($91c4d9c00005fe28$var$kSplineTableSize) : new Array($91c4d9c00005fe28$var$kSplineTableSize);
    for(var i = 0; i < $91c4d9c00005fe28$var$kSplineTableSize; ++i)sampleValues[i] = $91c4d9c00005fe28$var$calcBezier(i * $91c4d9c00005fe28$var$kSampleStepSize, mX1, mX2);
    var getTForX = function getTForX(aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = $91c4d9c00005fe28$var$kSplineTableSize - 1;
        for(; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample)intervalStart += $91c4d9c00005fe28$var$kSampleStepSize;
        --currentSample;
        // Interpolate to provide an initial guess for t
        var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        var guessForT = intervalStart + dist * $91c4d9c00005fe28$var$kSampleStepSize;
        var initialSlope = $91c4d9c00005fe28$var$getSlope(guessForT, mX1, mX2);
        if (initialSlope >= $91c4d9c00005fe28$var$NEWTON_MIN_SLOPE) return $91c4d9c00005fe28$var$newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        if (initialSlope === 0.0) return guessForT;
        return $91c4d9c00005fe28$var$binarySubdivide(aX, intervalStart, intervalStart + $91c4d9c00005fe28$var$kSampleStepSize, mX1, mX2);
    };
    return function(t) {
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.
        if (t === 0 || t === 1) return t;
        return $91c4d9c00005fe28$var$calcBezier(getTForX(t), mY1, mY2);
    };
};
var $91c4d9c00005fe28$var$convertToDash = function convertToDash(str) {
    str = str.replace(/([A-Z])/g, function(letter) {
        return "-".concat(letter.toLowerCase());
    });
    // Remove first dash
    return str.charAt(0) === '-' ? str.substring(1) : str;
};
/**
  Easing Functions from anime.js, they are tried and true, so, its better to use them instead of other alternatives
*/ var $91c4d9c00005fe28$var$Quad = function Quad(t) {
    return Math.pow(t, 2);
};
var $91c4d9c00005fe28$var$Cubic = function Cubic(t) {
    return Math.pow(t, 3);
};
var $91c4d9c00005fe28$var$Quart = function Quart(t) {
    return Math.pow(t, 4);
};
var $91c4d9c00005fe28$var$Quint = function Quint(t) {
    return Math.pow(t, 5);
};
var $91c4d9c00005fe28$var$Expo = function Expo(t) {
    return Math.pow(t, 6);
};
var $91c4d9c00005fe28$var$Sine = function Sine(t) {
    return 1 - Math.cos(t * Math.PI / 2);
};
var $91c4d9c00005fe28$var$Circ = function Circ(t) {
    return 1 - Math.sqrt(1 - t * t);
};
var $91c4d9c00005fe28$var$Back = function Back(t) {
    return t * t * (3 * t - 2);
};
var $91c4d9c00005fe28$var$Bounce = function Bounce(t) {
    var pow2;
    var b = 4;
    while(t < ((pow2 = Math.pow(2, --b)) - 1) / 11);
    return 1 / Math.pow(4, 3 - b) - 7.5625 * Math.pow((pow2 * 3 - 2) / 22 - t, 2);
};
var $91c4d9c00005fe28$var$Elastic = function Elastic(t) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _params = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(params, 2), _params$ = _params[0], amplitude = _params$ === void 0 ? 1 : _params$, _params$2 = _params[1], period = _params$2 === void 0 ? 0.5 : _params$2;
    var a = (0, $8hhuV.default)(Number(amplitude), 1, 10);
    var p = (0, $8hhuV.default)(Number(period), 0.1, 2);
    if (t === 0 || t === 1) return t;
    return -a * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - p / (Math.PI * 2) * Math.asin(1 / a)) * (Math.PI * 2) / p);
};
var $91c4d9c00005fe28$var$Spring = function Spring(t) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var duration = arguments.length > 2 ? arguments[2] : undefined;
    var _params2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(params, 4), _params2$ = _params2[0], mass = _params2$ === void 0 ? 1 : _params2$, _params2$2 = _params2[1], stiffness = _params2$2 === void 0 ? 100 : _params2$2, _params2$3 = _params2[2], damping = _params2$3 === void 0 ? 10 : _params2$3, _params2$4 = _params2[3], velocity = _params2$4 === void 0 ? 0 : _params2$4;
    mass = (0, $8hhuV.default)(mass, 0.1, 1000);
    stiffness = (0, $8hhuV.default)(stiffness, 0.1, 1000);
    damping = (0, $8hhuV.default)(damping, 0.1, 1000);
    velocity = (0, $8hhuV.default)(velocity, 0.1, 1000);
    var w0 = Math.sqrt(stiffness / mass);
    var zeta = damping / (2 * Math.sqrt(stiffness * mass));
    var wd = zeta < 1 ? w0 * Math.sqrt(1 - zeta * zeta) : 0;
    var a = 1;
    var b = zeta < 1 ? (zeta * w0 + -velocity) / wd : -velocity + w0;
    var progress = duration ? duration * t / 1000 : t;
    if (zeta < 1) progress = Math.exp(-progress * zeta * w0) * (a * Math.cos(wd * progress) + b * Math.sin(wd * progress));
    else progress = (a + b * progress) * Math.exp(-progress * w0);
    if (t === 0 || t === 1) return t;
    return 1 - progress;
};
/**
 * Cache the durations at set easing parameters
 */ // export const EasingDurationCache: Map<string | TypeEasingFunction, number> = new Map();
/**
 * The threshold for an infinite loop
 */ // const INTINITE_LOOP_LIMIT = 10000;
/** Convert easing parameters to Array of numbers, e.g. "spring(2, 500)" to [2, 500] */ // export const parseEasingParameters = (str: string) => {
//   const match = /(\(|\s)([^)]+)\)?/.exec(str);
//   return match
//     ? match[2].split(',').map((value) => {
//         const num = parseFloat(value);
//         return !Number.isNaN(num) ? num : value.trim();
//       })
//     : [];
// };
/**
 * The spring easing function will only look smooth at certain durations, with certain parameters.
 * This functions returns the optimal duration to create a smooth springy animation based on physics
 *
 * Note: it can also be used to determine the optimal duration of other types of easing function, but be careful of 'in-'
 * easing functions, because of the nature of the function it can sometimes create an infinite loop, I suggest only using
 * `getEasingDuration` for `spring`, specifically 'out-spring' and 'spring'
 */ // export const getEasingDuration = (easing: string | TypeEasingFunction = 'spring') => {
//   if (EasingDurationCache.has(easing)) return EasingDurationCache.get(easing);
//   // eslint-disable-next-line @typescript-eslint/no-use-before-define
//   const easingFunction = typeof easing == 'function' ? easing : getEasingFunction(easing as string);
//   const params = typeof easing == 'function' ? [] : parseEasingParameters(easing);
//   const frame = 1 / 6;
//   let elapsed = 0;
//   let rest = 0;
//   let count = 0;
//   while (++count < INTINITE_LOOP_LIMIT) {
//     elapsed += frame;
//     if (easingFunction(elapsed, params, undefined) === 1) {
//       rest++;
//       if (rest >= 16) break;
//     } else {
//       rest = 0;
//     }
//   }
//   const duration = elapsed * frame * 1000;
//   EasingDurationCache.set(easing, duration);
//   return duration;
// };
/**
  These Easing Functions are based off of the Sozi Project's easing functions
  https://github.com/sozi-projects/Sozi/blob/d72e44ebd580dc7579d1e177406ad41e632f961d/src/js/player/Timing.js
*/ var $91c4d9c00005fe28$var$Steps = function Steps(t) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _ref = params, _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), _ref2$ = _ref2[0], steps = _ref2$ === void 0 ? 10 : _ref2$, type = _ref2[1];
    var trunc = type === 'start' ? Math.ceil : Math.floor;
    return trunc((0, $8hhuV.default)(t, 0, 1) * steps) / steps;
};
// @ts-ignore
var $91c4d9c00005fe28$var$Bezier = function Bezier(t) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var _params3 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(params, 4), mX1 = _params3[0], mY1 = _params3[1], mX2 = _params3[2], mY2 = _params3[3];
    return $91c4d9c00005fe28$var$bezier(mX1, mY1, mX2, mY2)(t);
};
/** The default `ease-in` easing function */ var $91c4d9c00005fe28$var$easein = $91c4d9c00005fe28$var$bezier(0.42, 0.0, 1.0, 1.0);
/** Converts easing functions to their `out`counter parts */ var $91c4d9c00005fe28$var$EaseOut = function EaseOut(ease) {
    return function(t) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var duration = arguments.length > 2 ? arguments[2] : undefined;
        return 1 - ease(1 - t, params, duration);
    };
};
/** Converts easing functions to their `in-out` counter parts */ var $91c4d9c00005fe28$var$EaseInOut = function EaseInOut(ease) {
    return function(t) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var duration = arguments.length > 2 ? arguments[2] : undefined;
        return t < 0.5 ? ease(t * 2, params, duration) / 2 : 1 - ease(t * -2 + 2, params, duration) / 2;
    };
};
/** Converts easing functions to their `out-in` counter parts */ var $91c4d9c00005fe28$var$EaseOutIn = function EaseOutIn(ease) {
    return function(t) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var duration = arguments.length > 2 ? arguments[2] : undefined;
        return t < 0.5 ? (1 - ease(1 - t * 2, params, duration)) / 2 : (ease(t * 2 - 1, params, duration) + 1) / 2;
    };
};
/**
 * The default list of easing functions, do note this is different from {@link EASING}
 */ var $91c4d9c00005fe28$export$6ff391a2049fdf40 = {
    steps: $91c4d9c00005fe28$var$Steps,
    'step-start': function stepStart(t) {
        return $91c4d9c00005fe28$var$Steps(t, [
            1,
            'start'
        ]);
    },
    'step-end': function stepEnd(t) {
        return $91c4d9c00005fe28$var$Steps(t, [
            1,
            'end'
        ]);
    },
    linear: function linear(t) {
        return t;
    },
    'cubic-bezier': $91c4d9c00005fe28$var$Bezier,
    ease: function ease(t) {
        return $91c4d9c00005fe28$var$Bezier(t, [
            0.25,
            0.1,
            0.25,
            1.0
        ]);
    },
    "in": $91c4d9c00005fe28$var$easein,
    out: $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$easein),
    'in-out': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$easein),
    'out-in': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$easein),
    'in-quad': $91c4d9c00005fe28$var$Quad,
    'out-quad': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Quad),
    'in-out-quad': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Quad),
    'out-in-quad': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Quad),
    'in-cubic': $91c4d9c00005fe28$var$Cubic,
    'out-cubic': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Cubic),
    'in-out-cubic': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Cubic),
    'out-in-cubic': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Cubic),
    'in-quart': $91c4d9c00005fe28$var$Quart,
    'out-quart': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Quart),
    'in-out-quart': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Quart),
    'out-in-quart': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Quart),
    'in-quint': $91c4d9c00005fe28$var$Quint,
    'out-quint': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Quint),
    'in-out-quint': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Quint),
    'out-in-quint': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Quint),
    'in-expo': $91c4d9c00005fe28$var$Expo,
    'out-expo': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Expo),
    'in-out-expo': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Expo),
    'out-in-expo': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Expo),
    'in-sine': $91c4d9c00005fe28$var$Sine,
    'out-sine': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Sine),
    'in-out-sine': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Sine),
    'out-in-sine': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Sine),
    'in-circ': $91c4d9c00005fe28$var$Circ,
    'out-circ': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Circ),
    'in-out-circ': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Circ),
    'out-in-circ': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Circ),
    'in-back': $91c4d9c00005fe28$var$Back,
    'out-back': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Back),
    'in-out-back': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Back),
    'out-in-back': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Back),
    'in-bounce': $91c4d9c00005fe28$var$Bounce,
    'out-bounce': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Bounce),
    'in-out-bounce': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Bounce),
    'out-in-bounce': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Bounce),
    'in-elastic': $91c4d9c00005fe28$var$Elastic,
    'out-elastic': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Elastic),
    'in-out-elastic': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Elastic),
    'out-in-elastic': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Elastic),
    spring: $91c4d9c00005fe28$var$Spring,
    'spring-in': $91c4d9c00005fe28$var$Spring,
    'spring-out': $91c4d9c00005fe28$var$EaseOut($91c4d9c00005fe28$var$Spring),
    'spring-in-out': $91c4d9c00005fe28$var$EaseInOut($91c4d9c00005fe28$var$Spring),
    'spring-out-in': $91c4d9c00005fe28$var$EaseOutIn($91c4d9c00005fe28$var$Spring)
};
/**
 * Convert string easing to their proper form
 */ var $91c4d9c00005fe28$var$complexEasingSyntax = function complexEasingSyntax(ease) {
    return $91c4d9c00005fe28$var$convertToDash(ease).replace(/^ease-/, '') // Remove the "ease-" keyword
    .replace(/(\(|\s).+/, '') // Remove the function brackets and parameters
    .toLowerCase().trim();
};
/** Re-maps a number from one range to another. Numbers outside the range are not clamped to 0 and 1, because out-of-range values are often intentional and useful. */ var $91c4d9c00005fe28$var$getEasingFunction = function getEasingFunction(ease) {
    return $91c4d9c00005fe28$export$6ff391a2049fdf40[$91c4d9c00005fe28$var$complexEasingSyntax(ease)] || $91c4d9c00005fe28$export$6ff391a2049fdf40.linear;
};
// /**
//  * Allows you to register new easing functions
//  */
// export const registerEasingFunction = (key: string, fn: TypeEasingFunction) => {
//   Object.assign(EasingFunctions, {
//     [key]: fn,
//   });
// };
// /**
//  * Allows you to register multiple new easing functions
//  */
// export const registerEasingFunctions = (...obj: typeof EasingFunctions[]) => {
//   Object.assign(EasingFunctions, ...obj);
// };
var $91c4d9c00005fe28$var$linear = function linear(x) {
    return x;
};
var $91c4d9c00005fe28$var$Start = 1;
var $91c4d9c00005fe28$var$Middle = 0.5;
var $91c4d9c00005fe28$var$End = 0;
function $91c4d9c00005fe28$var$step(count, pos) {
    return function(x) {
        if (x >= 1) return 1;
        var stepSize = 1 / count;
        x += pos * stepSize;
        return x - x % stepSize;
    };
}
var $91c4d9c00005fe28$var$numberString = '\\s*(-?\\d+\\.?\\d*|-?\\.\\d+)\\s*';
var $91c4d9c00005fe28$var$cubicBezierRe = new RegExp("cubic-bezier\\(".concat($91c4d9c00005fe28$var$numberString, ",").concat($91c4d9c00005fe28$var$numberString, ",").concat($91c4d9c00005fe28$var$numberString, ",").concat($91c4d9c00005fe28$var$numberString, "\\)"));
var $91c4d9c00005fe28$var$step1Re = /steps\(\s*(\d+)\s*\)/;
var $91c4d9c00005fe28$var$step2Re = /steps\(\s*(\d+)\s*,\s*(start|middle|end)\s*\)/;
function $91c4d9c00005fe28$var$parseEasingFunction(normalizedEasing) {
    var cubicData = $91c4d9c00005fe28$var$cubicBezierRe.exec(normalizedEasing);
    if (cubicData) // @ts-ignore
    return $91c4d9c00005fe28$var$bezier.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(cubicData.slice(1).map(Number)));
    var step1Data = $91c4d9c00005fe28$var$step1Re.exec(normalizedEasing);
    if (step1Data) return $91c4d9c00005fe28$var$step(Number(step1Data[1]), $91c4d9c00005fe28$var$End);
    var step2Data = $91c4d9c00005fe28$var$step2Re.exec(normalizedEasing);
    if (step2Data) // @ts-ignore
    return $91c4d9c00005fe28$var$step(Number(step2Data[1]), {
        start: $91c4d9c00005fe28$var$Start,
        middle: $91c4d9c00005fe28$var$Middle,
        end: $91c4d9c00005fe28$var$End
    }[step2Data[2]]);
    return $91c4d9c00005fe28$var$getEasingFunction(normalizedEasing);
}
function $91c4d9c00005fe28$var$calculateActiveDuration(timing) {
    // @ts-ignore
    return Math.abs($91c4d9c00005fe28$var$repeatedDuration(timing) / (timing.playbackRate || 1));
}
function $91c4d9c00005fe28$var$repeatedDuration(timing) {
    var _timing$iterations;
    // https://drafts.csswg.org/web-animations/#calculating-the-active-duration
    if (timing.duration === 0 || timing.iterations === 0) return 0;
    // @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/duration#value
    // if (timing.duration === 'auto') {
    //   timing.duration = 0;
    // }
    return (timing.duration === 'auto' ? 0 : Number(timing.duration)) * ((_timing$iterations = timing.iterations) !== null && _timing$iterations !== void 0 ? _timing$iterations : 1);
}
var $91c4d9c00005fe28$var$PhaseNone = 0;
var $91c4d9c00005fe28$var$PhaseBefore = 1;
var $91c4d9c00005fe28$var$PhaseAfter = 2;
var $91c4d9c00005fe28$var$PhaseActive = 3;
function $91c4d9c00005fe28$var$calculatePhase(activeDuration, localTime, timing) {
    // https://drafts.csswg.org/web-animations/#animation-effect-phases-and-states
    if (localTime === null) return $91c4d9c00005fe28$var$PhaseNone;
    var endTime = timing.endTime;
    if (localTime < Math.min(timing.delay, endTime)) return $91c4d9c00005fe28$var$PhaseBefore;
    if (localTime >= Math.min(timing.delay + activeDuration + timing.endDelay, endTime)) return $91c4d9c00005fe28$var$PhaseAfter;
    return $91c4d9c00005fe28$var$PhaseActive;
}
function $91c4d9c00005fe28$var$calculateActiveTime(activeDuration, fillMode, localTime, phase, delay) {
    // https://drafts.csswg.org/web-animations/#calculating-the-active-time
    switch(phase){
        case $91c4d9c00005fe28$var$PhaseBefore:
            if (fillMode === 'backwards' || fillMode === 'both') return 0;
            return null;
        case $91c4d9c00005fe28$var$PhaseActive:
            return localTime - delay;
        case $91c4d9c00005fe28$var$PhaseAfter:
            if (fillMode === 'forwards' || fillMode === 'both') return activeDuration;
            return null;
        case $91c4d9c00005fe28$var$PhaseNone:
            return null;
    }
}
function $91c4d9c00005fe28$var$calculateOverallProgress(iterationDuration, phase, iterations, activeTime, iterationStart) {
    // https://drafts.csswg.org/web-animations/#calculating-the-overall-progress
    var overallProgress = iterationStart;
    if (iterationDuration === 0) {
        if (phase !== $91c4d9c00005fe28$var$PhaseBefore) overallProgress += iterations;
    } else overallProgress += activeTime / iterationDuration;
    return overallProgress;
}
function $91c4d9c00005fe28$var$calculateSimpleIterationProgress(overallProgress, iterationStart, phase, iterations, activeTime, iterationDuration) {
    // https://drafts.csswg.org/web-animations/#calculating-the-simple-iteration-progress
    var simpleIterationProgress = overallProgress === Infinity ? iterationStart % 1 : overallProgress % 1;
    if (simpleIterationProgress === 0 && phase === $91c4d9c00005fe28$var$PhaseAfter && iterations !== 0 && (activeTime !== 0 || iterationDuration === 0)) simpleIterationProgress = 1;
    return simpleIterationProgress;
}
function $91c4d9c00005fe28$var$calculateCurrentIteration(phase, iterations, simpleIterationProgress, overallProgress) {
    // https://drafts.csswg.org/web-animations/#calculating-the-current-iteration
    if (phase === $91c4d9c00005fe28$var$PhaseAfter && iterations === Infinity) return Infinity;
    if (simpleIterationProgress === 1) return Math.floor(overallProgress) - 1;
    return Math.floor(overallProgress);
}
function $91c4d9c00005fe28$var$calculateDirectedProgress(playbackDirection, currentIteration, simpleIterationProgress) {
    // https://drafts.csswg.org/web-animations/#calculating-the-directed-progress
    var currentDirection = playbackDirection;
    if (playbackDirection !== 'normal' && playbackDirection !== 'reverse') {
        var d = currentIteration;
        if (playbackDirection === 'alternate-reverse') d += 1;
        currentDirection = 'normal';
        if (d !== Infinity && d % 2 !== 0) currentDirection = 'reverse';
    }
    if (currentDirection === 'normal') return simpleIterationProgress;
    return 1 - simpleIterationProgress;
}
function $91c4d9c00005fe28$var$calculateIterationProgress(activeDuration, localTime, timing) {
    var phase = $91c4d9c00005fe28$var$calculatePhase(activeDuration, localTime, timing);
    var activeTime = $91c4d9c00005fe28$var$calculateActiveTime(activeDuration, timing.fill, localTime, phase, timing.delay);
    if (activeTime === null) return null;
    var duration = timing.duration === 'auto' ? 0 : timing.duration;
    var overallProgress = $91c4d9c00005fe28$var$calculateOverallProgress(duration, phase, timing.iterations, activeTime, timing.iterationStart);
    var simpleIterationProgress = $91c4d9c00005fe28$var$calculateSimpleIterationProgress(overallProgress, timing.iterationStart, phase, timing.iterations, activeTime, duration);
    var currentIteration = $91c4d9c00005fe28$var$calculateCurrentIteration(phase, timing.iterations, simpleIterationProgress, overallProgress);
    var directedProgress = $91c4d9c00005fe28$var$calculateDirectedProgress(timing.direction, currentIteration, simpleIterationProgress);
    timing.currentIteration = currentIteration;
    timing.progress = directedProgress;
    // https://drafts.csswg.org/web-animations/#calculating-the-transformed-progress
    // https://drafts.csswg.org/web-animations/#calculating-the-iteration-progress
    return timing.easingFunction(directedProgress);
}
function $91c4d9c00005fe28$var$convertEffectInput(keyframes, timing, target) {
    var propertySpecificKeyframeGroups = $91c4d9c00005fe28$var$makePropertySpecificKeyframeGroups(keyframes, timing);
    var interpolations = $91c4d9c00005fe28$var$makeInterpolations(propertySpecificKeyframeGroups, target);
    return function(target, fraction) {
        if (fraction !== null) interpolations.filter(function(interpolation) {
            return fraction >= interpolation.applyFrom && fraction < interpolation.applyTo;
        }).forEach(function(interpolation) {
            var offsetFraction = fraction - interpolation.startOffset;
            var localDuration = interpolation.endOffset - interpolation.startOffset;
            var scaledLocalTime = localDuration === 0 ? 0 : offsetFraction / localDuration;
            // apply updated attribute
            target.setAttribute(interpolation.property, interpolation.interpolation(scaledLocalTime), false, false // disable memoize
            );
        // if (interpolation.property === 'visibility') {
        //   console.log(
        //     scaledLocalTime,
        //     interpolation.interpolation(scaledLocalTime),
        //   );
        // }
        });
        else {
            for(var property in propertySpecificKeyframeGroups)if ($91c4d9c00005fe28$var$isNotReservedWord(property)) // clear attribute
            target.setAttribute(property, null);
        }
    };
}
function $91c4d9c00005fe28$var$isNotReservedWord(member) {
    return member !== 'offset' && member !== 'easing' && member !== 'composite' && member !== 'computedOffset';
}
function $91c4d9c00005fe28$var$makePropertySpecificKeyframeGroups(keyframes, timing) {
    var propertySpecificKeyframeGroups = {};
    for(var i = 0; i < keyframes.length; i++){
        for(var member in keyframes[i])if ($91c4d9c00005fe28$var$isNotReservedWord(member)) {
            var propertySpecificKeyframe = {
                offset: keyframes[i].offset,
                computedOffset: keyframes[i].computedOffset,
                easing: keyframes[i].easing,
                easingFunction: $91c4d9c00005fe28$var$parseEasingFunction(keyframes[i].easing) || timing.easingFunction,
                value: keyframes[i][member]
            };
            propertySpecificKeyframeGroups[member] = propertySpecificKeyframeGroups[member] || [];
            propertySpecificKeyframeGroups[member].push(propertySpecificKeyframe);
        }
    }
    return propertySpecificKeyframeGroups;
}
function $91c4d9c00005fe28$var$makeInterpolations(propertySpecificKeyframeGroups, target) {
    var interpolations = [];
    for(var groupName in propertySpecificKeyframeGroups){
        var keyframes = propertySpecificKeyframeGroups[groupName];
        for(var i = 0; i < keyframes.length - 1; i++){
            var startIndex = i;
            var endIndex = i + 1;
            var startOffset = keyframes[startIndex].computedOffset;
            var endOffset = keyframes[endIndex].computedOffset;
            var applyFrom = startOffset;
            var applyTo = endOffset;
            if (i === 0) {
                applyFrom = -Infinity;
                if (endOffset === 0) endIndex = startIndex;
            }
            if (i === keyframes.length - 2) {
                applyTo = Infinity;
                if (startOffset === 1) startIndex = endIndex;
            }
            interpolations.push({
                applyFrom: applyFrom,
                applyTo: applyTo,
                startOffset: keyframes[startIndex].computedOffset,
                endOffset: keyframes[endIndex].computedOffset,
                easingFunction: keyframes[startIndex].easingFunction,
                property: groupName,
                interpolation: $91c4d9c00005fe28$var$propertyInterpolation(groupName, keyframes[startIndex].value, keyframes[endIndex].value, target)
            });
        }
    }
    interpolations.sort(function(leftInterpolation, rightInterpolation) {
        return leftInterpolation.startOffset - rightInterpolation.startOffset;
    });
    return interpolations;
}
var $91c4d9c00005fe28$var$InterpolationFactory = function InterpolationFactory(from, to, convertToString) {
    return function(f) {
        var interpolated = $91c4d9c00005fe28$var$interpolate(from, to, f);
        return (0, $jyI49.default)(interpolated) ? interpolated : convertToString(interpolated);
    };
};
function $91c4d9c00005fe28$var$propertyInterpolation(property, left, right, target) {
    var metadata = (0, $2eDEB.propertyMetadataCache)[property];
    if (metadata && metadata.syntax && metadata["int"]) {
        var propertyHandler = (0, $2eDEB.runtime).styleValueRegistry.getPropertySyntax(metadata.syntax);
        if (propertyHandler) {
            var parser = propertyHandler.parser;
            var usedLeft = parser ? parser(left, target) : left;
            var usedRight = parser ? parser(right, target) : right;
            // merger [left, right, n2string()]
            var interpolationArgs = propertyHandler.mixer(usedLeft, usedRight, target);
            if (interpolationArgs) {
                var interp = $91c4d9c00005fe28$var$InterpolationFactory.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(interpolationArgs));
                return function(t) {
                    if (t === 0) return left;
                    if (t === 1) return right;
                    return interp(t);
                };
            }
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $91c4d9c00005fe28$var$InterpolationFactory(false, true, function(bool) {
        return bool ? right : left;
    });
}
/**
 * interpolate with number, boolean, number[], boolean[]
 */ function $91c4d9c00005fe28$var$interpolate(from, to, f) {
    if (typeof from === 'number' && typeof to === 'number') return from * (1 - f) + to * f;
    if (typeof from === 'boolean' && typeof to === 'boolean' || typeof from === 'string' && typeof to === 'string' // skip string, eg. path ['M', 10, 10]
    ) return f < 0.5 ? from : to;
    if (Array.isArray(from) && Array.isArray(to)) {
        // interpolate arrays/matrix
        var fromLength = from.length;
        var toLength = to.length;
        var length = Math.max(fromLength, toLength);
        var r = [];
        for(var i = 0; i < length; i++)r.push($91c4d9c00005fe28$var$interpolate(from[i < fromLength ? i : fromLength - 1], to[i < toLength ? i : toLength - 1], f));
        return r;
    }
    throw new Error("Mismatched interpolation arguments ".concat(from, ":").concat(to));
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming
 */ var $91c4d9c00005fe28$var$AnimationEffectTiming = /*#__PURE__*/ function() {
    function AnimationEffectTiming() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnimationEffectTiming);
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/delay
     */ this.delay = 0;
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/direction
     */ this.direction = 'normal';
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/duration
     */ this.duration = 'auto';
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/easing
     */ this._easing = 'linear';
        this.easingFunction = $91c4d9c00005fe28$var$linear;
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/endDelay
     */ this.endDelay = 0;
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/fill
     */ this.fill = 'auto';
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/iterationStart
     */ this.iterationStart = 0;
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/EffectTiming/iterations
     */ this.iterations = 1;
        this.currentIteration = null;
        this.progress = null;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnimationEffectTiming, [
        {
            key: "easing",
            get: function get() {
                return this._easing;
            },
            set: function set(value) {
                this.easingFunction = $91c4d9c00005fe28$var$parseEasingFunction(value);
                this._easing = value;
            }
        }
    ]);
}();
/**
 * @example
  {
    translateY: [200, 300],
    scale: [1, 10],
  }

 * groups' length can be different, the following config should generate 3 frames:
  @example
  {
    translateY: [200, 300, 400],
    scale: [1, 10],
  }
 */ function $91c4d9c00005fe28$var$convertToArrayForm(effectInput) {
    var normalizedEffectInput = [];
    for(var property in effectInput){
        // skip reserved props
        if (property in [
            'easing',
            'offset',
            'composite'
        ]) continue;
        // @ts-ignore
        var values = effectInput[property];
        if (!Array.isArray(values)) values = [
            values
        ];
        var numKeyframes = values.length;
        for(var i = 0; i < numKeyframes; i++){
            if (!normalizedEffectInput[i]) {
                var keyframe = {};
                if ('offset' in effectInput) keyframe.offset = Number(effectInput.offset);
                if ('easing' in effectInput) // @ts-ignore
                keyframe.easing = effectInput.easing;
                if ('composite' in effectInput) // @ts-ignore
                keyframe.composite = effectInput.composite;
                normalizedEffectInput[i] = keyframe;
            }
            if (values[i] !== undefined && values[i] !== null) normalizedEffectInput[i][property] = values[i];
        }
    }
    normalizedEffectInput.sort(function(a, b) {
        return (a.computedOffset || 0) - (b.computedOffset || 0);
    });
    return normalizedEffectInput;
}
function $91c4d9c00005fe28$export$976d021dfa8d1031(effectInput, timing) {
    if (effectInput === null) return [];
    if (!Array.isArray(effectInput)) effectInput = $91c4d9c00005fe28$var$convertToArrayForm(effectInput);
    var keyframes = effectInput.map(function(originalKeyframe) {
        var keyframe = {};
        if (timing !== null && timing !== void 0 && timing.composite) // This will be auto if the composite operation specified on the effect is being used.
        // @see https://developer.mozilla.org/en-US/docs/Web/API/Web_Animations_API/Keyframe_Formats
        keyframe.composite = 'auto';
        for(var member in originalKeyframe){
            var memberValue = originalKeyframe[member];
            if (member === 'offset') {
                if (memberValue !== null) {
                    memberValue = Number(memberValue);
                    if (!isFinite(memberValue)) throw new Error('Keyframe offsets must be numbers.');
                    if (memberValue < 0 || memberValue > 1) throw new Error('Keyframe offsets must be between 0 and 1.');
                    keyframe.computedOffset = memberValue;
                }
            } else if (member === 'composite') {
                // TODO: Support add & accumulate in KeyframeEffect.composite
                // @see https://developer.mozilla.org/en-US/docs/Web/API/KeyframeEffect/composite
                if ([
                    'replace',
                    'add',
                    'accumulate',
                    'auto'
                ].indexOf(memberValue) === -1) throw new Error("".concat(memberValue, " compositing is not supported"));
            }
            // assign to keyframe, no need to parse shorthand value
            keyframe[member] = memberValue;
        }
        if (keyframe.offset === undefined) keyframe.offset = null;
        if (keyframe.easing === undefined) // override with timing.easing
        keyframe.easing = (timing === null || timing === void 0 ? void 0 : timing.easing) || 'linear';
        if (keyframe.composite === undefined) keyframe.composite = 'auto';
        return keyframe;
    });
    var everyFrameHasOffset = true;
    var previousOffset = -Infinity;
    for(var i = 0; i < keyframes.length; i++){
        var offset = keyframes[i].offset;
        if (!(0, $geZBG.default)(offset)) {
            if (offset < previousOffset) throw new TypeError('Keyframes are not loosely sorted by offset. Sort or specify offsets.');
            previousOffset = offset;
        } else everyFrameHasOffset = false;
    }
    keyframes = keyframes.filter(function(keyframe) {
        return Number(keyframe.offset) >= 0 && Number(keyframe.offset) <= 1;
    });
    function spaceKeyframes() {
        var _keyframes$offset;
        var _keyframes = keyframes, length = _keyframes.length;
        keyframes[length - 1].computedOffset = Number((_keyframes$offset = keyframes[length - 1].offset) !== null && _keyframes$offset !== void 0 ? _keyframes$offset : 1);
        if (length > 1) {
            var _keyframes$0$offset;
            keyframes[0].computedOffset = Number((_keyframes$0$offset = keyframes[0].offset) !== null && _keyframes$0$offset !== void 0 ? _keyframes$0$offset : 0);
        }
        var previousIndex = 0;
        var previousOffset = Number(keyframes[0].computedOffset);
        for(var _i = 1; _i < length; _i++){
            var _offset = keyframes[_i].computedOffset;
            if (!(0, $geZBG.default)(_offset) && !(0, $geZBG.default)(previousOffset)) {
                for(var j = 1; j < _i - previousIndex; j++)keyframes[previousIndex + j].computedOffset = previousOffset + (Number(_offset) - previousOffset) * j / (_i - previousIndex);
                previousIndex = _i;
                previousOffset = Number(_offset);
            }
        }
    }
    if (!everyFrameHasOffset) spaceKeyframes();
    return keyframes;
}
var $91c4d9c00005fe28$var$fills = 'backwards|forwards|both|none'.split('|');
var $91c4d9c00005fe28$var$directions = 'reverse|alternate|alternate-reverse'.split('|');
function $91c4d9c00005fe28$export$1e26836fb8cf240b(timingInput, forGroup) {
    var timing = new $91c4d9c00005fe28$var$AnimationEffectTiming();
    if (forGroup) {
        timing.fill = 'both';
        timing.duration = 'auto';
    }
    if (typeof timingInput === 'number' && !isNaN(timingInput)) timing.duration = timingInput;
    else if (timingInput !== undefined) Object.keys(timingInput).forEach(function(property) {
        if (timingInput[property] !== undefined && timingInput[property] !== null && timingInput[property] !== 'auto') {
            if (typeof timing[property] === 'number' || property === 'duration') {
                if (typeof timingInput[property] !== 'number' || isNaN(timingInput[property])) return;
            }
            if (property === 'fill' && $91c4d9c00005fe28$var$fills.indexOf(timingInput[property]) === -1) return;
            if (property === 'direction' && $91c4d9c00005fe28$var$directions.indexOf(timingInput[property]) === -1) return;
            // @ts-ignore
            timing[property] = timingInput[property];
        }
    });
    return timing;
}
function $91c4d9c00005fe28$export$bdea0cb05beafd11(timingInput, forGroup) {
    timingInput = $91c4d9c00005fe28$export$83d46a6c4a2560a6(timingInput !== null && timingInput !== void 0 ? timingInput : {
        duration: 'auto'
    });
    return $91c4d9c00005fe28$export$1e26836fb8cf240b(timingInput, forGroup);
}
function $91c4d9c00005fe28$export$83d46a6c4a2560a6(timingInput) {
    if (typeof timingInput === 'number') {
        if (isNaN(timingInput)) timingInput = {
            duration: 'auto'
        };
        else timingInput = {
            duration: timingInput
        };
    }
    return timingInput;
}
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyframeEffect
 * @example
  const circleDownKeyframes = new KeyframeEffect(
    circle, // element to animate
    [
      { transform: 'translateY(0)' }, // keyframe
      { transform: 'translateY(100)' } // keyframe
    ],
    { duration: 3000, fill: 'forwards' } // keyframe options
  );
 *
 */ var $91c4d9c00005fe28$export$93101f886258b9e7 = /*#__PURE__*/ function() {
    // pseudoElement: string | null;
    function KeyframeEffect(target, effectInput, timingInput) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, KeyframeEffect);
        this.composite = 'replace';
        this.iterationComposite = 'replace';
        this.target = target;
        this.timing = $91c4d9c00005fe28$export$bdea0cb05beafd11(timingInput, false);
        this.timing.effect = this;
        this.timing.activeDuration = $91c4d9c00005fe28$var$calculateActiveDuration(this.timing);
        this.timing.endTime = Math.max(0, this.timing.delay + this.timing.activeDuration + this.timing.endDelay);
        this.normalizedKeyframes = $91c4d9c00005fe28$export$976d021dfa8d1031(effectInput, this.timing);
        this.interpolations = $91c4d9c00005fe28$var$convertEffectInput(this.normalizedKeyframes, this.timing, this.target);
        // 不支持 proxy 时降级成 this.timing
        var Proxy = (0, $2eDEB.runtime).globalThis.Proxy;
        this.computedTiming = Proxy ? new Proxy(this.timing, {
            get: function get(target, prop) {
                if (prop === 'duration') return target.duration === 'auto' ? 0 : target.duration;
                if (prop === 'fill') return target.fill === 'auto' ? 'none' : target.fill;
                if (prop === 'localTime') return _this.animation && _this.animation.currentTime || null;
                if (prop === 'currentIteration') {
                    if (!_this.animation || _this.animation.playState !== 'running') return null;
                    return target.currentIteration || 0;
                }
                if (prop === 'progress') {
                    if (!_this.animation || _this.animation.playState !== 'running') return null;
                    return target.progress || 0;
                }
                return target[prop];
            },
            set: function set() {
                return true;
            }
        }) : this.timing;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(KeyframeEffect, [
        {
            key: "applyInterpolations",
            value: function applyInterpolations() {
                this.interpolations(this.target, Number(this.timeFraction));
            }
        },
        {
            key: "update",
            value: function update(localTime) {
                if (localTime === null) return false;
                this.timeFraction = $91c4d9c00005fe28$var$calculateIterationProgress(this.timing.activeDuration, localTime, this.timing);
                return this.timeFraction !== null;
            }
        },
        {
            key: "getKeyframes",
            value: function getKeyframes() {
                return this.normalizedKeyframes;
            }
        },
        {
            key: "setKeyframes",
            value: function setKeyframes(keyframes) {
                this.normalizedKeyframes = $91c4d9c00005fe28$export$976d021dfa8d1031(keyframes);
            }
        },
        {
            key: "getComputedTiming",
            value: function getComputedTiming() {
                return this.computedTiming;
            }
        },
        {
            key: "getTiming",
            value: function getTiming() {
                return this.timing;
            }
        },
        {
            key: "updateTiming",
            value: function updateTiming(timing) {
                var _this2 = this;
                Object.keys(timing || {}).forEach(function(name) {
                    _this2.timing[name] = timing[name];
                });
            }
        }
    ]);
}();
function $91c4d9c00005fe28$export$7db4d6203789ec2e(leftAnimation, rightAnimation) {
    return Number(leftAnimation.id) - Number(rightAnimation.id);
}
/**
 * @see https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/web-animations-js/index.d.ts
 */ var $91c4d9c00005fe28$export$f0e5b6e12b84fd6b = /*#__PURE__*/ function() {
    function AnimationTimeline(document1) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AnimationTimeline);
        /**
     * all active animations
     */ this.animations = [];
        this.ticking = false;
        this.timelineTicking = false;
        this.hasRestartedThisFrame = false;
        this.animationsWithPromises = [];
        this.inTick = false;
        this.pendingEffects = [];
        this.currentTime = null;
        this.rafId = 0;
        this.rafCallbacks = [];
        this.webAnimationsNextTick = function(t) {
            _this.currentTime = t;
            _this.discardAnimations();
            if (_this.animations.length === 0) _this.timelineTicking = false;
            else _this.requestAnimationFrame(_this.webAnimationsNextTick);
        };
        this.processRafCallbacks = function(t) {
            var processing = _this.rafCallbacks;
            _this.rafCallbacks = [];
            if (t < Number(_this.currentTime)) t = Number(_this.currentTime);
            _this.animations.sort($91c4d9c00005fe28$export$7db4d6203789ec2e);
            _this.animations = _this.tick(t, true, _this.animations)[0];
            processing.forEach(function(entry) {
                entry[1](t);
            });
            _this.applyPendingEffects();
        };
        this.document = document1;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AnimationTimeline, [
        {
            key: "getAnimations",
            value: function getAnimations() {
                this.discardAnimations();
                return this.animations.slice();
            }
        },
        {
            key: "isTicking",
            value: function isTicking() {
                return this.inTick;
            }
        },
        {
            key: "play",
            value: function play(target, keyframes, options) {
                var effect = new $91c4d9c00005fe28$export$93101f886258b9e7(target, keyframes, options);
                var animation = new $91c4d9c00005fe28$export$c35d437ae5945fcd(effect, this);
                this.animations.push(animation);
                this.restartWebAnimationsNextTick();
                animation.updatePromises();
                animation.play();
                animation.updatePromises();
                return animation;
            }
        },
        {
            key: "applyDirtiedAnimation",
            value: function applyDirtiedAnimation(animation) {
                var _this2 = this;
                if (this.inTick) return;
                // update active animations in displayobject
                animation.markTarget();
                var animations = animation.targetAnimations();
                animations.sort($91c4d9c00005fe28$export$7db4d6203789ec2e);
                // clear inactive animations
                var inactiveAnimations = this.tick(Number(this.currentTime), false, animations.slice())[1];
                inactiveAnimations.forEach(function(animation) {
                    var index = _this2.animations.indexOf(animation);
                    if (index !== -1) _this2.animations.splice(index, 1);
                });
                this.applyPendingEffects();
            }
        },
        {
            key: "restart",
            value: function restart() {
                if (!this.ticking) {
                    this.ticking = true;
                    this.requestAnimationFrame(function() {});
                    this.hasRestartedThisFrame = true;
                }
                return this.hasRestartedThisFrame;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.document.defaultView.cancelAnimationFrame(this.frameId);
            }
        },
        {
            key: "applyPendingEffects",
            value: function applyPendingEffects() {
                this.pendingEffects.forEach(function(effect) {
                    effect === null || effect === void 0 || effect.applyInterpolations();
                });
                this.pendingEffects = [];
            }
        },
        {
            key: "updateAnimationsPromises",
            value: function updateAnimationsPromises() {
                this.animationsWithPromises = this.animationsWithPromises.filter(function(animation) {
                    return animation.updatePromises();
                });
            }
        },
        {
            key: "discardAnimations",
            value: function discardAnimations() {
                this.updateAnimationsPromises();
                this.animations = this.animations.filter(function(animation) {
                    return animation.playState !== 'finished' && animation.playState !== 'idle';
                });
            }
        },
        {
            key: "restartWebAnimationsNextTick",
            value: function restartWebAnimationsNextTick() {
                if (!this.timelineTicking) {
                    this.timelineTicking = true;
                    this.requestAnimationFrame(this.webAnimationsNextTick);
                }
            }
        },
        {
            key: "rAF",
            value: function rAF(f) {
                var id = this.rafId++;
                if (this.rafCallbacks.length === 0) this.frameId = this.document.defaultView.requestAnimationFrame(this.processRafCallbacks);
                this.rafCallbacks.push([
                    id,
                    f
                ]);
                return id;
            }
        },
        {
            key: "requestAnimationFrame",
            value: function requestAnimationFrame(f) {
                var _this3 = this;
                return this.rAF(function(x) {
                    _this3.updateAnimationsPromises();
                    f(x);
                    _this3.updateAnimationsPromises();
                });
            }
        },
        {
            key: "tick",
            value: function tick(t, isAnimationFrame, updatingAnimations) {
                var _this4 = this, _this$pendingEffects, _this$pendingEffects2;
                this.inTick = true;
                this.hasRestartedThisFrame = false;
                this.currentTime = t;
                this.ticking = false;
                var newPendingClears = [];
                var newPendingEffects = [];
                var activeAnimations = [];
                var inactiveAnimations = [];
                updatingAnimations.forEach(function(animation) {
                    animation.tick(t, isAnimationFrame);
                    if (!animation._inEffect) {
                        newPendingClears.push(animation.effect);
                        animation.unmarkTarget();
                    } else {
                        newPendingEffects.push(animation.effect);
                        animation.markTarget();
                    }
                    if (animation._needsTick) _this4.ticking = true;
                    var alive = animation._inEffect || animation._needsTick;
                    animation._inTimeline = alive;
                    if (alive) activeAnimations.push(animation);
                    else inactiveAnimations.push(animation);
                });
                (_this$pendingEffects = this.pendingEffects).push.apply(_this$pendingEffects, newPendingClears);
                (_this$pendingEffects2 = this.pendingEffects).push.apply(_this$pendingEffects2, newPendingEffects);
                if (this.ticking) this.requestAnimationFrame(function() {});
                this.inTick = false;
                return [
                    activeAnimations,
                    inactiveAnimations
                ];
            }
        }
    ]);
}();
(0, $2eDEB.runtime).EasingFunction = $91c4d9c00005fe28$var$parseEasingFunction;
(0, $2eDEB.runtime).AnimationTimeline = $91c4d9c00005fe28$export$f0e5b6e12b84fd6b;
/**
 * Provides camera action & animation.
 */ var $91c4d9c00005fe28$export$772470837aca7ae7 = /*#__PURE__*/ function(_Camera) {
    function AdvancedCamera() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AdvancedCamera);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, AdvancedCamera, [].concat(args));
        /**
     * switch between multiple landmarks
     */ _this.landmarks = [];
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(AdvancedCamera, _Camera);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AdvancedCamera, [
        {
            key: "rotate",
            value: /**
     * Changes the azimuth and elevation with respect to the current camera axes
     * @param {Number} azimuth the relative azimuth
     * @param {Number} elevation the relative elevation
     * @param {Number} roll the relative roll
     */ function rotate(azimuth, elevation, roll) {
                this.relElevation = (0, $2eDEB.getAngle)(elevation);
                this.relAzimuth = (0, $2eDEB.getAngle)(azimuth);
                this.relRoll = (0, $2eDEB.getAngle)(roll);
                this.elevation += this.relElevation;
                this.azimuth += this.relAzimuth;
                this.roll += this.relRoll;
                if (this.type === (0, $2eDEB.CameraType).EXPLORING) {
                    var rotX = (0, $k1dpP).setAxisAngle((0, $k1dpP).create(), [
                        1,
                        0,
                        0
                    ], (0, $2eDEB.deg2rad)((this.rotateWorld ? 1 : -1) * this.relElevation));
                    var rotY = (0, $k1dpP).setAxisAngle((0, $k1dpP).create(), [
                        0,
                        1,
                        0
                    ], (0, $2eDEB.deg2rad)((this.rotateWorld ? 1 : -1) * this.relAzimuth));
                    var rotZ = (0, $k1dpP).setAxisAngle((0, $k1dpP).create(), [
                        0,
                        0,
                        1
                    ], (0, $2eDEB.deg2rad)(this.relRoll));
                    var rotQ = (0, $k1dpP).multiply((0, $k1dpP).create(), rotY, rotX);
                    rotQ = (0, $k1dpP).multiply((0, $k1dpP).create(), rotQ, rotZ);
                    var rotMatrix = (0, $3iqbd).fromQuat((0, $3iqbd).create(), rotQ);
                    (0, $3iqbd).translate(this.matrix, this.matrix, [
                        0,
                        0,
                        -this.distance
                    ]);
                    (0, $3iqbd).multiply(this.matrix, this.matrix, rotMatrix);
                    (0, $3iqbd).translate(this.matrix, this.matrix, [
                        0,
                        0,
                        this.distance
                    ]);
                } else {
                    if (Math.abs(this.elevation) > 90) return this;
                    this.computeMatrix();
                }
                this._getAxes();
                if (this.type === (0, $2eDEB.CameraType).ORBITING || this.type === (0, $2eDEB.CameraType).EXPLORING) this._getPosition();
                else if (this.type === (0, $2eDEB.CameraType).TRACKING) this._getFocalPoint();
                this._update();
                return this;
            }
        },
        {
            key: "pan",
            value: function pan(tx, ty) {
                var coords = (0, $2eDEB.createVec3)(tx, ty, 0);
                var pos = (0, $eIStk).clone(this.position);
                (0, $eIStk).add(pos, pos, (0, $eIStk).scale((0, $eIStk).create(), this.right, coords[0]));
                (0, $eIStk).add(pos, pos, (0, $eIStk).scale((0, $eIStk).create(), this.up, coords[1]));
                this._setPosition(pos);
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "dolly",
            value: function dolly(value) {
                var n = this.forward;
                var pos = (0, $eIStk).clone(this.position);
                var step = value * this.dollyingStep;
                var updatedDistance = this.distance + value * this.dollyingStep;
                // 限制视点距离范围
                step = Math.max(Math.min(updatedDistance, this.maxDistance), this.minDistance) - this.distance;
                pos[0] += step * n[0];
                pos[1] += step * n[1];
                pos[2] += step * n[2];
                this._setPosition(pos);
                if (this.type === (0, $2eDEB.CameraType).ORBITING || this.type === (0, $2eDEB.CameraType).EXPLORING) // 重新计算视点距离
                this._getDistance();
                else if (this.type === (0, $2eDEB.CameraType).TRACKING) // 保持视距，移动视点位置
                (0, $eIStk).add(this.focalPoint, pos, this.distanceVector);
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "cancelLandmarkAnimation",
            value: function cancelLandmarkAnimation() {
                if (this.landmarkAnimationID !== undefined) this.canvas.cancelAnimationFrame(this.landmarkAnimationID);
            }
        },
        {
            key: "createLandmark",
            value: function createLandmark(name) {
                var _position$, _position$2, _focalPoint$, _focalPoint$2;
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$position = params.position, position = _params$position === void 0 ? this.position : _params$position, _params$focalPoint = params.focalPoint, focalPoint = _params$focalPoint === void 0 ? this.focalPoint : _params$focalPoint, roll = params.roll, zoom = params.zoom;
                var camera = new (0, $2eDEB.runtime).CameraContribution();
                camera.setType(this.type, undefined);
                camera.setPosition(position[0], (_position$ = position[1]) !== null && _position$ !== void 0 ? _position$ : this.position[1], (_position$2 = position[2]) !== null && _position$2 !== void 0 ? _position$2 : this.position[2]);
                camera.setFocalPoint(focalPoint[0], (_focalPoint$ = focalPoint[1]) !== null && _focalPoint$ !== void 0 ? _focalPoint$ : this.focalPoint[1], (_focalPoint$2 = focalPoint[2]) !== null && _focalPoint$2 !== void 0 ? _focalPoint$2 : this.focalPoint[2]);
                camera.setRoll(roll !== null && roll !== void 0 ? roll : this.roll);
                camera.setZoom(zoom !== null && zoom !== void 0 ? zoom : this.zoom);
                var landmark = {
                    name: name,
                    matrix: (0, $3iqbd).clone(camera.getWorldTransform()),
                    right: (0, $eIStk).clone(camera.right),
                    up: (0, $eIStk).clone(camera.up),
                    forward: (0, $eIStk).clone(camera.forward),
                    position: (0, $eIStk).clone(camera.getPosition()),
                    focalPoint: (0, $eIStk).clone(camera.getFocalPoint()),
                    distanceVector: (0, $eIStk).clone(camera.getDistanceVector()),
                    distance: camera.getDistance(),
                    dollyingStep: camera.getDollyingStep(),
                    azimuth: camera.getAzimuth(),
                    elevation: camera.getElevation(),
                    roll: camera.getRoll(),
                    relAzimuth: camera.relAzimuth,
                    relElevation: camera.relElevation,
                    relRoll: camera.relRoll,
                    zoom: camera.getZoom()
                };
                this.landmarks.push(landmark);
                return landmark;
            }
        },
        {
            key: "gotoLandmark",
            value: function gotoLandmark(name) {
                var _this2 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var landmark = (0, $kVcyu.default)(name) ? this.landmarks.find(function(l) {
                    return l.name === name;
                }) : name;
                if (landmark) {
                    var _ref = (0, $jyI49.default)(options) ? {
                        duration: options
                    } : options, _ref$easing = _ref.easing, easing = _ref$easing === void 0 ? 'linear' : _ref$easing, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 100 : _ref$duration, _ref$easingFunction = _ref.easingFunction, easingFunction = _ref$easingFunction === void 0 ? undefined : _ref$easingFunction, _ref$onfinish = _ref.onfinish, onfinish = _ref$onfinish === void 0 ? undefined : _ref$onfinish, _ref$onframe = _ref.onframe, onframe = _ref$onframe === void 0 ? undefined : _ref$onframe;
                    var epsilon = 0.01;
                    // cancel ongoing animation
                    this.cancelLandmarkAnimation();
                    var destPosition = landmark.position;
                    var destFocalPoint = landmark.focalPoint;
                    var destZoom = landmark.zoom;
                    var destRoll = landmark.roll;
                    var easingFunc = easingFunction || (0, $2eDEB.runtime).EasingFunction(easing);
                    var timeStart;
                    var end = function end() {
                        _this2.setFocalPoint(destFocalPoint);
                        _this2.setPosition(destPosition);
                        _this2.setRoll(destRoll);
                        _this2.setZoom(destZoom);
                        _this2.computeMatrix();
                        _this2.triggerUpdate();
                        onfinish === null || onfinish === void 0 || onfinish();
                    };
                    if (duration === 0) return end();
                    var _animate = function animate(timestamp) {
                        if (timeStart === undefined) timeStart = timestamp;
                        var elapsed = timestamp - timeStart;
                        if (elapsed >= duration) {
                            end();
                            return;
                        }
                        // use the same ease function in animation system
                        var t = easingFunc(elapsed / duration);
                        var interFocalPoint = (0, $eIStk).create();
                        var interPosition = (0, $eIStk).create();
                        var interZoom = 1;
                        var interRoll = 0;
                        (0, $eIStk).lerp(interFocalPoint, _this2.focalPoint, destFocalPoint, t);
                        (0, $eIStk).lerp(interPosition, _this2.position, destPosition, t);
                        interRoll = _this2.roll * (1 - t) + destRoll * t;
                        interZoom = _this2.zoom * (1 - t) + destZoom * t;
                        _this2.setFocalPoint(interFocalPoint);
                        _this2.setPosition(interPosition);
                        _this2.setRoll(interRoll);
                        _this2.setZoom(interZoom);
                        var dist = (0, $eIStk).dist(interFocalPoint, destFocalPoint) + (0, $eIStk).dist(interPosition, destPosition);
                        if (dist <= epsilon && destZoom === undefined && destRoll === undefined) return end();
                        _this2.computeMatrix();
                        _this2.triggerUpdate();
                        if (elapsed < duration) {
                            onframe === null || onframe === void 0 || onframe(t);
                            _this2.landmarkAnimationID = _this2.canvas.requestAnimationFrame(_animate);
                        }
                    };
                    this.canvas.requestAnimationFrame(_animate);
                }
            }
        }
    ]);
}((0, $2eDEB.Camera));
(0, $2eDEB.runtime).CameraContribution = $91c4d9c00005fe28$export$772470837aca7ae7;
var $91c4d9c00005fe28$var$_excluded$1 = [
    "clippingRegion",
    "beforeDrawImage",
    "afterDrawImage",
    "ignoreElements"
];
var $91c4d9c00005fe28$export$a74e97f1c2ad600a = /*#__PURE__*/ function() {
    function ImageExporter(options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ImageExporter);
        this.options = options;
    }
    /**
   * return a HTMLCanvasElement which you can call `toDataURL` later
   *
   * @example
   * const canvas = await exporter.toCanvas();
   * canvas.toDataURL(); // data:
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ImageExporter, [
        {
            key: "toCanvas",
            value: function() {
                var _toCanvas = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee() {
                    var options, _this$options$canvas$, width, height, doc, dpr, _options$clippingRegi, clippingRegion, beforeDrawImage, afterDrawImage, _ignoreElements, rest, dataURL, image, sx, sy, sWidth, sHeight, canvas, context, sourceImageMultipiler, $dom, _canvas, _image, _args = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                                _this$options$canvas$ = this.options.canvas.getConfig(), width = _this$options$canvas$.width, height = _this$options$canvas$.height, doc = _this$options$canvas$.document;
                                dpr = this.options.canvas.getContextService().getDPR();
                                _options$clippingRegi = options.clippingRegion, clippingRegion = _options$clippingRegi === void 0 ? new (0, $2eDEB.Rectangle)(0, 0, width, height) : _options$clippingRegi, beforeDrawImage = options.beforeDrawImage, afterDrawImage = options.afterDrawImage, _ignoreElements = options.ignoreElements, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(options, $91c4d9c00005fe28$var$_excluded$1);
                                _context.next = 1;
                                return this.toDataURL(rest);
                            case 1:
                                dataURL = _context.sent;
                                _context.next = 2;
                                return this.getOrCreateImage(dataURL);
                            case 2:
                                image = _context.sent;
                                sx = clippingRegion.x, sy = clippingRegion.y, sWidth = clippingRegion.width, sHeight = clippingRegion.height; // TODO: provide custom `createCanvas` method like `createImage`
                                canvas = (doc || document).createElement('canvas');
                                canvas.width = sWidth * dpr;
                                canvas.height = sHeight * dpr;
                                context = canvas.getContext('2d');
                                context.scale(dpr, dpr);
                                if (beforeDrawImage) beforeDrawImage(context);
                                sourceImageMultipiler = image.width > width ? dpr : 1;
                                context.drawImage(image, sx * sourceImageMultipiler, sy * sourceImageMultipiler, sWidth * sourceImageMultipiler, sHeight * sourceImageMultipiler, 0, 0, sWidth, sHeight);
                                if (this.isSVG()) {
                                    _context.next = 5;
                                    break;
                                }
                                $dom = this.options.canvas.getContextService().getDomElement();
                                if (!($dom && $dom.parentElement)) {
                                    _context.next = 5;
                                    break;
                                }
                                _context.next = 3;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))($dom.parentElement, {
                                    backgroundColor: null,
                                    width: width,
                                    height: height,
                                    x: 0,
                                    y: 0,
                                    ignoreElements: function ignoreElements(element) {
                                        if (element === $dom) return true;
                                        return _ignoreElements && _ignoreElements(element);
                                    }
                                });
                            case 3:
                                _canvas = _context.sent;
                                _context.next = 4;
                                return this.getOrCreateImage(_canvas.toDataURL());
                            case 4:
                                _image = _context.sent;
                                context.drawImage(_image, sx * sourceImageMultipiler, sy * sourceImageMultipiler, sWidth * sourceImageMultipiler, sHeight * sourceImageMultipiler, 0, 0, sWidth, sHeight);
                            case 5:
                                if (afterDrawImage) afterDrawImage(context);
                                return _context.abrupt("return", canvas);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function toCanvas() {
                    return _toCanvas.apply(this, arguments);
                }
                return toCanvas;
            }()
        },
        {
            key: "toDataURL",
            value: function() {
                var _toDataURL = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee2() {
                    var options, _args2 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                options = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
                                return _context2.abrupt("return", this.options.canvas.getContextService().toDataURL(options));
                            case 1:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function toDataURL() {
                    return _toDataURL.apply(this, arguments);
                }
                return toDataURL;
            }()
        },
        {
            key: "isSVG",
            value: function isSVG() {
                return (0, $2eDEB.isBrowser) && this.options.canvas.getContextService().getDomElement() instanceof SVGSVGElement;
            }
        },
        {
            key: "toSVGDataURL",
            value: function() {
                var _toSVGDataURL = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee3() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (!this.isSVG()) {
                                    _context3.next = 1;
                                    break;
                                }
                                return _context3.abrupt("return", this.toDataURL());
                            case 1:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function toSVGDataURL() {
                    return _toSVGDataURL.apply(this, arguments);
                }
                return toSVGDataURL;
            }()
        },
        {
            key: "downloadImage",
            value: function downloadImage(options) {
                var _this$options$canvas$2 = this.options.canvas.getConfig(), doc = _this$options$canvas$2.document;
                // retrieve context at runtime
                var defaultFilename = this.options.defaultFilename;
                var dataURL = options.dataURL, _options$name = options.name, name = _options$name === void 0 ? defaultFilename || 'g' : _options$name;
                var mimeType = dataURL.substring(dataURL.indexOf(':') + 1, dataURL.indexOf(';'));
                var suffix = mimeType.split('/')[1];
                // g-svg only support .svg
                var isSVG = dataURL.startsWith('data:image/svg');
                var fileName = "".concat(name, ".").concat(isSVG ? 'svg' : suffix);
                var link = (doc || document).createElement('a');
                if (isSVG) link.addEventListener('click', function() {
                    link.download = fileName;
                    link.href = dataURL;
                });
                else if (window.Blob && window.URL) {
                    var arr = dataURL.split(',');
                    var mime = '';
                    if (arr && arr.length > 0) {
                        var match = arr[0].match(/:(.*?);/);
                        // eslint-disable-next-line prefer-destructuring
                        if (match && match.length >= 2) mime = match[1];
                    }
                    var bstr = atob(arr[1]);
                    var n = bstr.length;
                    var u8arr = new Uint8Array(n);
                    while(n--)u8arr[n] = bstr.charCodeAt(n);
                    var blobObj = new Blob([
                        u8arr
                    ], {
                        type: mime
                    });
                    // account for IE
                    // @see https://stackoverflow.com/a/41434373
                    if ((0, $2eDEB.runtime).globalThis.navigator.msSaveBlob) (0, $2eDEB.runtime).globalThis.navigator.msSaveBlob(blobObj, fileName);
                    else link.addEventListener('click', function() {
                        link.download = fileName;
                        link.href = window.URL.createObjectURL(blobObj);
                    });
                }
                // trigger click
                if (link.click) link.click();
                else {
                    var e = (doc || document).createEvent('MouseEvents');
                    e.initEvent('click', false, false);
                    link.dispatchEvent(e);
                }
            }
        },
        {
            key: "getOrCreateImage",
            value: function getOrCreateImage(src) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    // @see https://github.com/antvis/g/issues/938
                    var image = _this.options.canvas.getConfig().createImage();
                    if (image) {
                        image.onload = function() {
                            resolve(image);
                        };
                        image.onerror = function(ev) {
                            reject(ev);
                        };
                        image.crossOrigin = 'Anonymous';
                        image.src = src;
                    }
                });
            }
        }
    ]);
}();
/**
 * 计算贴图单元大小
 *
 * @param size 元素大小
 * @param padding 圆点间隔
 * @param isStagger 是否交错
 * @reutrn 返回贴图单元大小
 */ function $91c4d9c00005fe28$var$getUnitPatternSize(size, padding, isStagger) {
    // 如果交错, unitSize 放大两倍
    var unitSize = size + padding;
    return isStagger ? unitSize * 2 : unitSize;
}
/**
 * 计算有交错情况的元素坐标
 *
 * @param unitSize 贴图单元大小
 * @param isStagger 是否交错
 * @reutrn 元素中心坐标 x,y 数组集合
 */ function $91c4d9c00005fe28$var$getSymbolsPosition(unitSize, isStagger) {
    // 如果交错, 交错绘制 dot
    var symbolsPos = isStagger ? [
        [
            unitSize * (1 / 4),
            unitSize * (1 / 4)
        ],
        [
            unitSize * (3 / 4),
            unitSize * (3 / 4)
        ]
    ] : [
        [
            unitSize * 0.5,
            unitSize * 0.5
        ]
    ];
    return symbolsPos;
}
var $91c4d9c00005fe28$export$ad542a5891657514 = {
    size: 6,
    padding: 2,
    backgroundColor: 'transparent',
    opacity: 1,
    fill: '#fff',
    fillOpacity: 1,
    stroke: 'transparent',
    strokeOpacity: 1,
    lineWidth: 0,
    isStagger: true
};
function $91c4d9c00005fe28$export$e5383273bc7bedd(cfg) {
    var dotCfg = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, $91c4d9c00005fe28$export$ad542a5891657514), cfg);
    var size = dotCfg.size, padding = dotCfg.padding, isStagger = dotCfg.isStagger, backgroundColor = dotCfg.backgroundColor, backgroundOpacity = dotCfg.backgroundOpacity, opacity = dotCfg.opacity, fill = dotCfg.fill, fillOpacity = dotCfg.fillOpacity, lineWidth = dotCfg.lineWidth, stroke = dotCfg.stroke, strokeOpacity = dotCfg.strokeOpacity;
    // 计算 画布大小，dots的位置
    var unitSize = $91c4d9c00005fe28$var$getUnitPatternSize(size, padding, isStagger);
    var dots = $91c4d9c00005fe28$var$getSymbolsPosition(unitSize, isStagger);
    var background = new (0, $2eDEB.Rect)({
        style: {
            width: unitSize,
            height: unitSize,
            fill: backgroundColor,
            opacity: 1,
            fillOpacity: backgroundOpacity
        }
    });
    var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(dots), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_step.value, 2), cx = _step$value[0], cy = _step$value[1];
            var circle = new (0, $2eDEB.Circle)({
                style: {
                    opacity: opacity,
                    fill: fill,
                    fillOpacity: fillOpacity,
                    cx: cx,
                    cy: cy,
                    r: size / 2,
                    lineWidth: lineWidth,
                    stroke: stroke,
                    strokeOpacity: strokeOpacity
                }
            });
            background.appendChild(circle);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return background;
}
/**
 * linePattern 的 默认配置
 */ var $91c4d9c00005fe28$export$b7682649bd417bc5 = {
    spacing: 5,
    opacity: 1,
    backgroundColor: 'transparent',
    backgroundOpacity: 1,
    strokeOpacity: 1,
    stroke: '#fff',
    lineWidth: 2
};
/**
 * 创建 linePattern
 */ function $91c4d9c00005fe28$export$7846a41871731830(cfg) {
    var lineCfg = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, $91c4d9c00005fe28$export$b7682649bd417bc5), cfg);
    var spacing = lineCfg.spacing, lineWidth = lineCfg.lineWidth, backgroundColor = lineCfg.backgroundColor, backgroundOpacity = lineCfg.backgroundOpacity, opacity = lineCfg.opacity, stroke = lineCfg.stroke, strokeOpacity = lineCfg.strokeOpacity;
    // 计算 pattern 画布的大小， path 所需的 d
    var width = spacing + lineWidth || 1;
    var height = spacing + lineWidth || 1;
    var d = "\n            M 0 0 L ".concat(width, " 0\n            M 0 ").concat(height, " L ").concat(width, " ").concat(height, "\n            ");
    var background = new (0, $2eDEB.Rect)({
        style: {
            width: width,
            height: height,
            fill: backgroundColor,
            opacity: 1,
            fillOpacity: backgroundOpacity
        }
    });
    var path = new (0, $2eDEB.Path)({
        style: {
            d: d,
            opacity: opacity,
            stroke: stroke,
            strokeOpacity: strokeOpacity,
            fillOpacity: 1,
            lineWidth: lineWidth
        }
    });
    background.appendChild(path);
    return background;
}
/**
 * squarePattern 的 默认配置
 */ var $91c4d9c00005fe28$export$f893ca70e76c32db = {
    size: 6,
    padding: 1,
    isStagger: true,
    backgroundColor: 'transparent',
    opacity: 1,
    fill: '#fff',
    fillOpacity: 1,
    stroke: 'transparent',
    lineWidth: 0
};
/**
 * 创建 squarePattern
 */ function $91c4d9c00005fe28$export$d06855d6297d83d2(cfg) {
    var squareCfg = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, $91c4d9c00005fe28$export$f893ca70e76c32db), cfg);
    var size = squareCfg.size, padding = squareCfg.padding, isStagger = squareCfg.isStagger, backgroundColor = squareCfg.backgroundColor, backgroundOpacity = squareCfg.backgroundOpacity, opacity = squareCfg.opacity, fill = squareCfg.fill, fillOpacity = squareCfg.fillOpacity, stroke = squareCfg.stroke, strokeOpacity = squareCfg.strokeOpacity, lineWidth = squareCfg.lineWidth;
    // 计算 画布大小，squares的位置
    var unitSize = $91c4d9c00005fe28$var$getUnitPatternSize(size, padding, isStagger);
    var squares = $91c4d9c00005fe28$var$getSymbolsPosition(unitSize, isStagger); // 计算方法与 dots 一样
    var background = new (0, $2eDEB.Rect)({
        style: {
            width: unitSize,
            height: unitSize,
            fill: backgroundColor,
            opacity: 1,
            fillOpacity: backgroundOpacity
        }
    });
    var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(squares), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_step.value, 2), x = _step$value[0], y = _step$value[1];
            var square = new (0, $2eDEB.Rect)({
                style: {
                    opacity: opacity,
                    fill: fill,
                    fillOpacity: fillOpacity,
                    x: x - size / 2,
                    y: y - size / 2,
                    width: size,
                    height: size,
                    lineWidth: lineWidth,
                    stroke: stroke,
                    strokeOpacity: strokeOpacity
                }
            });
            background.appendChild(square);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return background;
}
var $91c4d9c00005fe28$var$_excluded = [
    "body",
    "startHead",
    "endHead",
    "startHeadOffset",
    "endHeadOffset"
], $91c4d9c00005fe28$var$_excluded2 = [
    "body",
    "startHead",
    "endHead",
    "startHeadOffset",
    "endHeadOffset"
], $91c4d9c00005fe28$var$_excluded3 = [
    "body",
    "startHead",
    "endHead",
    "startHeadOffset",
    "endHeadOffset"
];
/**
 * support 3 types of arrow line:
 * 1. Line
 * 2. Polyline
 * 3. Path
 *
 * support 2 types of arrow head:
 * 1. default(Path)
 * 2. custom
 */ var $91c4d9c00005fe28$export$21b07c8f274aebd5 = /*#__PURE__*/ function(_CustomElement) {
    function Arrow(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Arrow);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Arrow, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, config), {}, {
                type: Arrow.tag
            })
        ]);
        var _this$attributes = _this.attributes, body = _this$attributes.body, startHead = _this$attributes.startHead, endHead = _this$attributes.endHead;
        _this$attributes.startHeadOffset;
        _this$attributes.endHeadOffset;
        var rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$attributes, $91c4d9c00005fe28$var$_excluded);
        if (!body) throw new Error("Arrow's body is required");
        // append arrow body
        _this.body = body;
        _this.appendChild(_this.body);
        _this.handleBodyAttributeChanged(_this.body);
        if (startHead) _this.appendArrowHead(_this.getArrowHeadType(startHead), true);
        if (endHead) _this.appendArrowHead(_this.getArrowHeadType(endHead), false);
        _this.applyArrowStyle(rest, [
            _this.body,
            _this.startHead,
            _this.endHead
        ]);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Arrow, _CustomElement);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Arrow, [
        {
            key: "handleBodyAttributeChanged",
            value: function handleBodyAttributeChanged(body) {
                var _this2 = this;
                body.addEventListener((0, $2eDEB.ElementEvent).ATTR_MODIFIED, function(e) {
                    var attrName = e.attrName;
                    if (attrName === 'x1' || attrName === 'y1') {
                        if (_this2.startHead) _this2.transformArrowHead(_this2.startHead, true);
                    } else if (attrName === 'x2' || attrName === 'y2') {
                        if (_this2.endHead) _this2.transformArrowHead(_this2.endHead, false);
                    }
                // const { nodeName } = body;
                // if (nodeName === Shape.LINE) {
                //   body
                // }
                });
            }
        },
        {
            key: "getBody",
            value: function getBody() {
                return this.body;
            }
        },
        {
            key: "getStartHead",
            value: function getStartHead() {
                return this.startHead;
            }
        },
        {
            key: "getEndHead",
            value: function getEndHead() {
                return this.endHead;
            }
        },
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(name, oldValue, newValue) {
                if (name === 'opacity' || name === 'strokeOpacity' || name === 'stroke' || name === 'lineWidth' || name === 'increasedLineWidthForHitTesting') this.applyArrowStyle((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, name, newValue), [
                    this.body,
                    this.startHead,
                    this.endHead
                ]);
                else if (name === 'startHead' || name === 'endHead') {
                    var isStart = name === 'startHead';
                    // delete existed arrow head first
                    this.destroyArrowHead(isStart);
                    if (newValue) {
                        var _this$attributes2 = this.attributes;
                        _this$attributes2.body;
                        _this$attributes2.startHead;
                        _this$attributes2.endHead;
                        _this$attributes2.startHeadOffset;
                        _this$attributes2.endHeadOffset;
                        var rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$attributes2, $91c4d9c00005fe28$var$_excluded2);
                        // append new arrow head
                        this.appendArrowHead(this.getArrowHeadType(newValue), isStart);
                        this.applyArrowStyle(rest, [
                            isStart ? this.startHead : this.endHead
                        ]);
                    }
                } else if (name === 'body') {
                    var _this$attributes3 = this.attributes;
                    _this$attributes3.body;
                    _this$attributes3.startHead;
                    _this$attributes3.endHead;
                    _this$attributes3.startHeadOffset;
                    _this$attributes3.endHeadOffset;
                    var _rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_this$attributes3, $91c4d9c00005fe28$var$_excluded3);
                    this.body.destroy();
                    // @ts-ignore
                    this.body = newValue;
                    this.appendChild(this.body);
                    this.applyArrowStyle(_rest, [
                        this.body
                    ]);
                } else if (name === 'startHeadOffset') this.moveArrowHeadAlongTangent(newValue, true);
                else if (name === 'endHeadOffset') this.moveArrowHeadAlongTangent(newValue, false);
            }
        },
        {
            key: "getArrowHeadType",
            value: function getArrowHeadType(head) {
                if (typeof head === 'boolean') return 'default';
                return 'custom';
            }
        },
        {
            key: "appendArrowHead",
            value: function appendArrowHead(type, isStart) {
                var head;
                if (type === 'default') head = this.createDefaultArrowHead();
                else // @ts-ignore
                head = isStart ? this.attributes.startHead : this.attributes.endHead;
                // set position & rotation
                this.transformArrowHead(head, isStart);
                // heads should display on top of body
                head.setAttribute('zIndex', 1);
                if (isStart) this.startHead = head;
                else this.endHead = head;
                this.appendChild(head);
                var offset = isStart ? this.attributes.startHeadOffset : this.attributes.endHeadOffset;
                if (offset) this.moveArrowHeadAlongTangent(offset, isStart);
            }
        },
        {
            key: "transformArrowHead",
            value: function transformArrowHead(head, isStart) {
                var position = (0, $eIStk).create();
                var rad = 0;
                var x1 = 0;
                var x2 = 0;
                var y1 = 0;
                var y2 = 0;
                var bodyType = this.body && this.body.nodeName;
                if (bodyType === (0, $2eDEB.Shape).LINE) {
                    var _attributes = this.body.attributes, _x1 = _attributes.x1, _x2 = _attributes.x2, _y1 = _attributes.y1, _y2 = _attributes.y2;
                    x1 = isStart ? _x2 : _x1;
                    x2 = isStart ? _x1 : _x2;
                    y1 = isStart ? _y2 : _y1;
                    y2 = isStart ? _y1 : _y2;
                } else if (bodyType === (0, $2eDEB.Shape).POLYLINE) {
                    var points = this.body.attributes.points;
                    var length = points.length;
                    x1 = isStart ? points[1][0] : points[length - 2][0];
                    y1 = isStart ? points[1][1] : points[length - 2][1];
                    x2 = isStart ? points[0][0] : points[length - 1][0];
                    y2 = isStart ? points[0][1] : points[length - 1][1];
                } else if (bodyType === (0, $2eDEB.Shape).PATH) {
                    var _this$getTangent = this.getTangent(this.body, isStart), _this$getTangent2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_this$getTangent, 2), p1 = _this$getTangent2[0], p2 = _this$getTangent2[1];
                    x1 = p1[0];
                    y1 = p1[1];
                    x2 = p2[0];
                    y2 = p2[1];
                }
                var x = x1 - x2;
                var y = y1 - y2;
                rad = Math.atan2(y, x);
                position = (0, $eIStk).fromValues(x2, y2, 0);
                if (isStart) {
                    this.startHeadPosition = position;
                    this.startHeadRad = rad;
                } else {
                    this.endHeadPosition = position;
                    this.endHeadRad = rad;
                }
                head.setLocalPosition(position);
                head.setLocalEulerAngles(rad * 180 / Math.PI + head.getLocalEulerAngles());
            }
        },
        {
            key: "moveArrowHeadAlongTangent",
            value: function moveArrowHeadAlongTangent(offset, isStart) {
                var head = isStart ? this.startHead : this.endHead;
                if (head) head.setLocalPosition((0, $eIStk).sub((0, $eIStk).create(), isStart ? this.startHeadPosition : this.endHeadPosition, (0, $eIStk).fromValues(Math.cos(isStart ? this.startHeadRad : this.endHeadRad) * offset, Math.sin(isStart ? this.startHeadRad : this.endHeadRad) * offset, 0)));
                // cut body
                this.body;
            }
        },
        {
            key: "destroyArrowHead",
            value: function destroyArrowHead(isStart) {
                if (isStart && this.startHead) {
                    this.startHead.destroy();
                    this.startHead = undefined;
                }
                if (!isStart && this.endHead) {
                    this.endHead.destroy();
                    this.endHead = undefined;
                }
            }
        },
        {
            key: "getTangent",
            value: function getTangent(path, isStart) {
                return isStart ? path.getStartTangent() : path.getEndTangent();
            }
        },
        {
            key: "createDefaultArrowHead",
            value: function createDefaultArrowHead() {
                var _this$attributes4 = this.attributes, stroke = _this$attributes4.stroke, lineWidth = _this$attributes4.lineWidth;
                var sin = Math.sin, cos = Math.cos, PI = Math.PI;
                var width = 10 * cos(PI / 6);
                return new (0, $2eDEB.Path)({
                    style: {
                        // draw an angle '<'
                        d: "M".concat(width / 2, ",").concat(10 * sin(PI / 6), " L-").concat(width / 2, ",0 L").concat(width / 2, ",-").concat(10 * sin(PI / 6)),
                        stroke: stroke,
                        lineWidth: lineWidth,
                        transformOrigin: 'center'
                    }
                });
            }
        },
        {
            key: "applyArrowStyle",
            value: function applyArrowStyle(attributes, objects) {
                var opacity = attributes.opacity, stroke = attributes.stroke, strokeOpacity = attributes.strokeOpacity, lineWidth = attributes.lineWidth, increasedLineWidthForHitTesting = attributes.increasedLineWidthForHitTesting;
                objects.forEach(function(shape) {
                    if (shape) {
                        if (!(0, $geZBG.default)(opacity)) shape.style.opacity = opacity;
                        if (!(0, $geZBG.default)(stroke)) shape.style.stroke = stroke;
                        if (!(0, $geZBG.default)(strokeOpacity)) shape.style.strokeOpacity = strokeOpacity;
                        if (!(0, $geZBG.default)(lineWidth)) shape.style.lineWidth = lineWidth;
                        if (!(0, $geZBG.default)(increasedLineWidthForHitTesting)) shape.style.increasedLineWidthForHitTesting = increasedLineWidthForHitTesting;
                    }
                });
            }
        }
    ]);
}((0, $2eDEB.CustomElement));
$91c4d9c00005fe28$export$21b07c8f274aebd5.tag = 'arrow';
$91c4d9c00005fe28$export$21b07c8f274aebd5.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((0, $2eDEB.CustomElement).PARSED_STYLE_LIST), [
    'body',
    'startHead',
    'endHead',
    'startHeadOffset',
    'endHeadOffset',
    'stroke',
    'lineWidth',
    'opacity',
    'strokeOpacity'
]));
var $91c4d9c00005fe28$var$PI = Math.PI;
var $91c4d9c00005fe28$var$PI2 = $91c4d9c00005fe28$var$PI * 2;
var $91c4d9c00005fe28$var$mathSin = Math.sin;
var $91c4d9c00005fe28$var$mathCos = Math.cos;
var $91c4d9c00005fe28$var$mathACos = Math.acos;
var $91c4d9c00005fe28$var$mathATan2 = Math.atan2;
// const mathAbs = Math.abs;
var $91c4d9c00005fe28$var$mathSqrt = Math.sqrt;
var $91c4d9c00005fe28$var$mathMax = Math.max;
var $91c4d9c00005fe28$var$mathMin = Math.min;
var $91c4d9c00005fe28$var$e = 1e-4;
// 注册 css 属性
var $91c4d9c00005fe28$var$SECTOR_CSS_PROPERTY = [
    {
        name: 'sr',
        inherits: false,
        interpolable: true,
        syntax: (0, $2eDEB.PropertySyntax).LENGTH_PERCENTAGE
    },
    {
        name: 'sr0',
        inherits: false,
        interpolable: true,
        syntax: (0, $2eDEB.PropertySyntax).LENGTH_PERCENTAGE
    },
    {
        name: 'startAngle',
        inherits: false,
        interpolable: true,
        syntax: (0, $2eDEB.PropertySyntax).ANGLE
    },
    {
        name: 'endAngle',
        inherits: false,
        interpolable: true,
        syntax: (0, $2eDEB.PropertySyntax).ANGLE
    }
];
$91c4d9c00005fe28$var$SECTOR_CSS_PROPERTY.forEach(function(property) {
    (0, $2eDEB.CSS).registerProperty(property);
});
var $91c4d9c00005fe28$var$polarToCartesian = function polarToCartesian(centerX, centerY, radius, angleInRadian) {
    return {
        x: centerX + radius * Math.cos(angleInRadian),
        y: centerY + radius * Math.sin(angleInRadian)
    };
};
function $91c4d9c00005fe28$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var dx10 = x1 - x0;
    var dy10 = y1 - y0;
    var dx32 = x3 - x2;
    var dy32 = y3 - y2;
    var t = dy32 * dx10 - dx32 * dy10;
    if (t * t < $91c4d9c00005fe28$var$e) return;
    t = (dx32 * (y0 - y2) - dy32 * (x0 - x2)) / t;
    return [
        x0 + t * dx10,
        y0 + t * dy10
    ];
}
// Compute perpendicular offset line of length rc.
function $91c4d9c00005fe28$var$computeCornerTangents(x0, y0, x1, y1, radius, cr, clockwise) {
    var x01 = x0 - x1;
    var y01 = y0 - y1;
    var lo = (clockwise ? cr : -cr) / $91c4d9c00005fe28$var$mathSqrt(x01 * x01 + y01 * y01);
    var ox = lo * y01;
    var oy = -lo * x01;
    var x11 = x0 + ox;
    var y11 = y0 + oy;
    var x10 = x1 + ox;
    var y10 = y1 + oy;
    var x00 = (x11 + x10) / 2;
    var y00 = (y11 + y10) / 2;
    var dx = x10 - x11;
    var dy = y10 - y11;
    var d2 = dx * dx + dy * dy;
    var r = radius - cr;
    var s = x11 * y10 - x10 * y11;
    var d = (dy < 0 ? -1 : 1) * $91c4d9c00005fe28$var$mathSqrt($91c4d9c00005fe28$var$mathMax(0, r * r * d2 - s * s));
    var cx0 = (s * dy - dx * d) / d2;
    var cy0 = (-s * dx - dy * d) / d2;
    var cx1 = (s * dy + dx * d) / d2;
    var cy1 = (-s * dx + dy * d) / d2;
    var dx0 = cx0 - x00;
    var dy0 = cy0 - y00;
    var dx1 = cx1 - x00;
    var dy1 = cy1 - y00;
    // Pick the closer of the two intersection points
    // TODO: Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) {
        cx0 = cx1;
        cy0 = cy1;
    }
    return {
        cx: cx0,
        cy: cy0,
        x0: -ox,
        y0: -oy,
        x1: cx0 * (radius / r - 1),
        y1: cy0 * (radius / r - 1)
    };
}
function $91c4d9c00005fe28$var$computeArcSweep(startAngle, endAngle) {
    endAngle = endAngle < 0 && startAngle >= 0 ? endAngle + $91c4d9c00005fe28$var$PI2 : endAngle;
    return endAngle - startAngle <= $91c4d9c00005fe28$var$PI ? 0 : 1;
}
var $91c4d9c00005fe28$export$e98c2c7eb2b14f45 = /*#__PURE__*/ function(_Path) {
    // parsedStyle: any;
    function Sector(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Sector);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Sector, [
            config
        ]);
        _this.updatePath();
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Sector, _Path);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Sector, [
        {
            key: "setAttribute",
            value: function setAttribute(name, value, force) {
                (0, (/*@__PURE__*/$parcel$interopDefault($dPop6)))(Sector, "setAttribute", this, 3)([
                    name,
                    value,
                    force
                ]);
                if ([
                    'startAngle',
                    'endAngle',
                    'sr',
                    'sr0',
                    'radius'
                ].indexOf(name) > -1) this.updatePath();
            }
        },
        {
            key: "updatePath",
            value: function updatePath() {
                // @ts-ignore
                var _this$parsedStyle = this.parsedStyle, x = _this$parsedStyle.x, y = _this$parsedStyle.y, startAngle = _this$parsedStyle.startAngle, endAngle = _this$parsedStyle.endAngle, sr = _this$parsedStyle.sr, sr0 = _this$parsedStyle.sr0, radius = _this$parsedStyle.radius;
                var path = this.createPath(x, y, startAngle ? (0, $2eDEB.deg2rad)(startAngle) : 0, endAngle ? (0, $2eDEB.deg2rad)(endAngle) : Math.PI * 2, sr || 0, sr0 || 0, radius || [
                    0,
                    0,
                    0,
                    0
                ]);
                (0, (/*@__PURE__*/$parcel$interopDefault($dPop6)))(Sector, "setAttribute", this, 3)([
                    'd',
                    path
                ]);
            }
        },
        {
            key: "createPath",
            value: function createPath(x, y, startAngle, endAngle, r, r0, borderRadius) {
                if (r <= 0) return;
                var start = $91c4d9c00005fe28$var$polarToCartesian(x, y, r, startAngle);
                var end = $91c4d9c00005fe28$var$polarToCartesian(x, y, r, endAngle);
                var innerStart = $91c4d9c00005fe28$var$polarToCartesian(x, y, r0, startAngle);
                var innerEnd = $91c4d9c00005fe28$var$polarToCartesian(x, y, r0, endAngle);
                // 整圆
                if ((0, $dFv1j.default)(endAngle - startAngle, Math.PI * 2)) {
                    // 整个圆是分割成两个圆
                    var middlePoint = $91c4d9c00005fe28$var$polarToCartesian(x, y, r, startAngle + Math.PI);
                    var innerMiddlePoint = $91c4d9c00005fe28$var$polarToCartesian(x, y, r0, startAngle + Math.PI);
                    var circlePathCommands = [
                        [
                            'M',
                            start.x,
                            start.y
                        ],
                        [
                            'A',
                            r,
                            r,
                            0,
                            1,
                            1,
                            middlePoint.x,
                            middlePoint.y
                        ],
                        [
                            'A',
                            r,
                            r,
                            0,
                            1,
                            1,
                            end.x,
                            end.y
                        ],
                        [
                            'M',
                            innerStart.x,
                            innerStart.y
                        ]
                    ];
                    if (r0) {
                        circlePathCommands.push([
                            'A',
                            r0,
                            r0,
                            0,
                            1,
                            0,
                            innerMiddlePoint.x,
                            innerMiddlePoint.y
                        ]);
                        circlePathCommands.push([
                            'A',
                            r0,
                            r0,
                            0,
                            1,
                            0,
                            innerEnd.x,
                            innerEnd.y
                        ]);
                    }
                    circlePathCommands.push([
                        'M',
                        start.x,
                        start.y
                    ]);
                    circlePathCommands.push([
                        'Z'
                    ]);
                    return circlePathCommands;
                }
                var angle = endAngle - startAngle;
                var xrs = r * $91c4d9c00005fe28$var$mathCos(startAngle);
                var yrs = r * $91c4d9c00005fe28$var$mathSin(startAngle);
                var xire = r0 * $91c4d9c00005fe28$var$mathCos(endAngle);
                var yire = r0 * $91c4d9c00005fe28$var$mathSin(endAngle);
                var xre = r * $91c4d9c00005fe28$var$mathCos(endAngle);
                var yre = r * $91c4d9c00005fe28$var$mathSin(endAngle);
                var xirs = r0 * $91c4d9c00005fe28$var$mathCos(startAngle);
                var yirs = r0 * $91c4d9c00005fe28$var$mathSin(startAngle);
                // 顺时针反向，同 radius
                var _borderRadius = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(borderRadius, 4), outStartRadius = _borderRadius[0], outEndRadius = _borderRadius[1], innerEndRadius = _borderRadius[2], innerStartRadius = _borderRadius[3];
                var halfRadius = (r - r0) / 2;
                var outStartBorderRadius = $91c4d9c00005fe28$var$mathMin(halfRadius, outStartRadius);
                var outEndBorderRadius = $91c4d9c00005fe28$var$mathMin(halfRadius, outEndRadius);
                var innerEndBorderRadius = $91c4d9c00005fe28$var$mathMin(halfRadius, innerEndRadius);
                var innerStartBorderRadius = $91c4d9c00005fe28$var$mathMin(halfRadius, innerStartRadius);
                var outBorderRadiusMax = $91c4d9c00005fe28$var$mathMax(outStartBorderRadius, outEndBorderRadius);
                var innerBorderRadiusMax = $91c4d9c00005fe28$var$mathMax(innerEndBorderRadius, innerStartBorderRadius);
                var limitedOutBorderRadiusMax = outBorderRadiusMax;
                var limitedInnerBorderRadiusMax = innerBorderRadiusMax;
                // draw corner radius
                if (outBorderRadiusMax > $91c4d9c00005fe28$var$e || innerBorderRadiusMax > $91c4d9c00005fe28$var$e) // restrict the max value of corner radius
                {
                    if (angle < $91c4d9c00005fe28$var$PI) {
                        var it = $91c4d9c00005fe28$var$intersect(xrs, yrs, xirs, yirs, xre, yre, xire, yire);
                        if (it) {
                            var x0 = xrs - it[0];
                            var y0 = yrs - it[1];
                            var x1 = xre - it[0];
                            var y1 = yre - it[1];
                            var a = 1 / $91c4d9c00005fe28$var$mathSin($91c4d9c00005fe28$var$mathACos((x0 * x1 + y0 * y1) / ($91c4d9c00005fe28$var$mathSqrt(x0 * x0 + y0 * y0) * $91c4d9c00005fe28$var$mathSqrt(x1 * x1 + y1 * y1))) / 2);
                            var b = $91c4d9c00005fe28$var$mathSqrt(it[0] * it[0] + it[1] * it[1]);
                            limitedOutBorderRadiusMax = $91c4d9c00005fe28$var$mathMin(outBorderRadiusMax, (r - b) / (a + 1));
                            limitedInnerBorderRadiusMax = $91c4d9c00005fe28$var$mathMin(innerBorderRadiusMax, (r0 - b) / (a - 1));
                        }
                    }
                }
                var arcSweep = $91c4d9c00005fe28$var$computeArcSweep(startAngle, endAngle);
                var clockwise = true;
                var sectorPathCommands = [];
                if (limitedOutBorderRadiusMax > $91c4d9c00005fe28$var$e) {
                    var crStart = $91c4d9c00005fe28$var$mathMin(outStartRadius, limitedOutBorderRadiusMax);
                    var crEnd = $91c4d9c00005fe28$var$mathMin(outEndRadius, limitedOutBorderRadiusMax);
                    var ct0 = $91c4d9c00005fe28$var$computeCornerTangents(xirs, yirs, xrs, yrs, r, crStart, clockwise);
                    var ct1 = $91c4d9c00005fe28$var$computeCornerTangents(xre, yre, xire, yire, r, crEnd, clockwise);
                    sectorPathCommands.push([
                        'M',
                        x + ct0.cx + ct0.x0,
                        y + ct0.cy + ct0.y0
                    ]);
                    // Have the corners merged?
                    if (limitedOutBorderRadiusMax < outBorderRadiusMax && crStart === crEnd) {
                        var outStartBorderRadiusStartAngle = $91c4d9c00005fe28$var$mathATan2(ct0.y0, ct0.x0);
                        var outStartBorderRadiusEndAngle = $91c4d9c00005fe28$var$mathATan2(ct1.y0, ct1.x0);
                        sectorPathCommands.push([
                            'A',
                            limitedOutBorderRadiusMax,
                            limitedOutBorderRadiusMax,
                            0,
                            $91c4d9c00005fe28$var$computeArcSweep(outStartBorderRadiusStartAngle, outStartBorderRadiusEndAngle),
                            1,
                            x + ct1.cx + ct1.x0,
                            y + ct1.cy + ct1.y0
                        ]);
                    } else {
                        // draw the two corners and the ring
                        if (crStart > 0) {
                            var _outStartBorderRadiusStartAngle = $91c4d9c00005fe28$var$mathATan2(ct0.y0, ct0.x0);
                            var _outStartBorderRadiusEndAngle = $91c4d9c00005fe28$var$mathATan2(ct0.y1, ct0.x1);
                            var outStartBorderRadiusEndPoint = $91c4d9c00005fe28$var$polarToCartesian(x, y, r, _outStartBorderRadiusEndAngle);
                            sectorPathCommands.push([
                                'A',
                                crStart,
                                crStart,
                                0,
                                $91c4d9c00005fe28$var$computeArcSweep(_outStartBorderRadiusStartAngle, _outStartBorderRadiusEndAngle),
                                1,
                                outStartBorderRadiusEndPoint.x,
                                outStartBorderRadiusEndPoint.y
                            ]);
                        }
                        var outRadiusStartAngle = $91c4d9c00005fe28$var$mathATan2(ct0.cy + ct0.y1, ct0.cx + ct0.x1);
                        var outRadiusEndAngle = $91c4d9c00005fe28$var$mathATan2(ct1.cy + ct1.y1, ct1.cx + ct1.x1);
                        var outRadiusEndPoint = $91c4d9c00005fe28$var$polarToCartesian(x, y, r, outRadiusEndAngle);
                        sectorPathCommands.push([
                            'A',
                            r,
                            r,
                            0,
                            $91c4d9c00005fe28$var$computeArcSweep(outRadiusStartAngle, outRadiusEndAngle),
                            1,
                            outRadiusEndPoint.x,
                            outRadiusEndPoint.y
                        ]);
                        if (crEnd > 0) {
                            var outEndBorderRadiusStartAngle = $91c4d9c00005fe28$var$mathATan2(ct1.y1, ct1.x1);
                            var outEndBorderRadiusEndAngle = $91c4d9c00005fe28$var$mathATan2(ct1.y0, ct1.x0);
                            sectorPathCommands.push([
                                'A',
                                crEnd,
                                crEnd,
                                0,
                                $91c4d9c00005fe28$var$computeArcSweep(outEndBorderRadiusStartAngle, outEndBorderRadiusEndAngle),
                                1,
                                x + ct1.cx + ct1.x0,
                                y + ct1.cy + ct1.y0
                            ]);
                        }
                    }
                } else {
                    sectorPathCommands.push([
                        'M',
                        start.x,
                        start.y
                    ]);
                    sectorPathCommands.push([
                        'A',
                        r,
                        r,
                        0,
                        arcSweep,
                        1,
                        end.x,
                        end.y
                    ]);
                }
                // no inner ring, is a circular sector
                if (r0 < $91c4d9c00005fe28$var$e) sectorPathCommands.push([
                    'L',
                    innerEnd.x,
                    innerEnd.y
                ]);
                else if (limitedInnerBorderRadiusMax > $91c4d9c00005fe28$var$e) {
                    var _crStart = $91c4d9c00005fe28$var$mathMin(innerStartRadius, limitedInnerBorderRadiusMax);
                    var _crEnd = $91c4d9c00005fe28$var$mathMin(innerEndRadius, limitedInnerBorderRadiusMax);
                    var _ct = $91c4d9c00005fe28$var$computeCornerTangents(xire, yire, 0, 0, r0 - r, _crEnd, clockwise);
                    var _ct2 = $91c4d9c00005fe28$var$computeCornerTangents(0, 0, xirs, yirs, r0 - r, _crStart, clockwise);
                    sectorPathCommands.push([
                        'L',
                        x + _ct.cx + _ct.x0,
                        y + _ct.cy + _ct.y0
                    ]);
                    // Have the corners merged?
                    if (limitedInnerBorderRadiusMax < innerBorderRadiusMax && _crStart === _crEnd) {
                        var innerStartBorderRadiusStartAngle = $91c4d9c00005fe28$var$mathATan2(_ct.y0, _ct.x0);
                        var innerStartBorderRadiusEndAngle = $91c4d9c00005fe28$var$mathATan2(_ct2.y0, _ct2.x0);
                        var innerStartBorderRadiusEndPoint = $91c4d9c00005fe28$var$polarToCartesian(x, y, r0, innerStartBorderRadiusEndAngle);
                        sectorPathCommands.push([
                            'A',
                            limitedOutBorderRadiusMax,
                            limitedOutBorderRadiusMax,
                            0,
                            $91c4d9c00005fe28$var$computeArcSweep(innerStartBorderRadiusStartAngle, innerStartBorderRadiusEndAngle),
                            1,
                            innerStartBorderRadiusEndPoint.x,
                            innerStartBorderRadiusEndPoint.y
                        ]);
                    } else {
                        if (_crEnd > 0) {
                            var _innerStartBorderRadiusStartAngle = $91c4d9c00005fe28$var$mathATan2(_ct.y0, _ct.x0);
                            var _innerStartBorderRadiusEndAngle = $91c4d9c00005fe28$var$mathATan2(_ct.y1, _ct.x1);
                            var _innerStartBorderRadiusEndPoint = $91c4d9c00005fe28$var$polarToCartesian(x, y, r0 - r, _innerStartBorderRadiusEndAngle);
                            sectorPathCommands.push([
                                'A',
                                _crEnd,
                                _crEnd,
                                0,
                                $91c4d9c00005fe28$var$computeArcSweep(_innerStartBorderRadiusStartAngle, _innerStartBorderRadiusEndAngle),
                                1,
                                _innerStartBorderRadiusEndPoint.x,
                                _innerStartBorderRadiusEndPoint.y
                            ]);
                        }
                        var innerRadiusStartAngle = $91c4d9c00005fe28$var$mathATan2(_ct.cy + _ct.y1, _ct.cx + _ct.x1);
                        var innerRadiusEndAngle = $91c4d9c00005fe28$var$mathATan2(_ct2.cy + _ct2.y1, _ct2.cx + _ct2.x1);
                        var innerRadiusEndPoint = $91c4d9c00005fe28$var$polarToCartesian(x, y, r0, innerRadiusEndAngle);
                        sectorPathCommands.push([
                            'A',
                            r0,
                            r0,
                            0,
                            $91c4d9c00005fe28$var$computeArcSweep(innerRadiusEndAngle, innerRadiusStartAngle),
                            0,
                            innerRadiusEndPoint.x,
                            innerRadiusEndPoint.y
                        ]);
                        sectorPathCommands.push([
                            'L',
                            innerRadiusEndPoint.x,
                            innerRadiusEndPoint.y
                        ]);
                        if (_crStart > 0) {
                            var innerEndBorderRadiusStartAngle = $91c4d9c00005fe28$var$mathATan2(_ct2.y1, _ct2.x1);
                            var innerEndBorderRadiusEndAngle = $91c4d9c00005fe28$var$mathATan2(_ct2.y0, _ct2.x0);
                            sectorPathCommands.push([
                                'A',
                                _crStart,
                                _crStart,
                                0,
                                $91c4d9c00005fe28$var$computeArcSweep(innerEndBorderRadiusStartAngle, innerEndBorderRadiusEndAngle),
                                1,
                                x + _ct2.cx + _ct2.x0,
                                y + _ct2.cy + _ct2.y0
                            ]);
                        }
                    }
                } else {
                    sectorPathCommands.push([
                        'L',
                        innerEnd.x,
                        innerEnd.y
                    ]);
                    sectorPathCommands.push([
                        'A',
                        r0,
                        r0,
                        0,
                        arcSweep,
                        0,
                        innerStart.x,
                        innerStart.y
                    ]);
                }
                sectorPathCommands.push([
                    'Z'
                ]);
                return sectorPathCommands;
            }
        }
    ]);
}((0, $2eDEB.Path));
$91c4d9c00005fe28$export$e98c2c7eb2b14f45.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((0, $2eDEB.Path).PARSED_STYLE_LIST), [
    'x',
    'y',
    'sr',
    'sr0',
    'radius',
    'startAngle',
    'endAngle'
]));
$parcel$exportWildcard(module.exports, $2eDEB);

});
parcelRegister("2eDEB", function(module, exports) {

$parcel$export(module.exports, "Shape", () => Shape);
$parcel$export(module.exports, "AbstractRendererPlugin", () => AbstractRendererPlugin);
$parcel$export(module.exports, "AbstractRenderer", () => AbstractRenderer);
$parcel$export(module.exports, "AABB", () => AABB);
$parcel$export(module.exports, "Point", () => Point);
$parcel$export(module.exports, "Rectangle", () => Rectangle);
$parcel$export(module.exports, "ERROR_MSG_METHOD_NOT_IMPLEMENTED", () => ERROR_MSG_METHOD_NOT_IMPLEMENTED);
$parcel$export(module.exports, "getAngle", () => getAngle);
$parcel$export(module.exports, "createVec3", () => createVec3);
$parcel$export(module.exports, "deg2rad", () => deg2rad);
$parcel$export(module.exports, "rad2deg", () => rad2deg);
$parcel$export(module.exports, "CameraType", () => CameraType);
$parcel$export(module.exports, "Camera", () => Camera);
$parcel$export(module.exports, "PropertySyntax", () => PropertySyntax);
$parcel$export(module.exports, "GradientType", () => GradientType);
$parcel$export(module.exports, "isPattern", () => isPattern);
$parcel$export(module.exports, "getOrCalculatePathTotalLength", () => getOrCalculatePathTotalLength);
$parcel$export(module.exports, "propertyMetadataCache", () => propertyMetadataCache);
$parcel$export(module.exports, "isBrowser", () => isBrowser);
$parcel$export(module.exports, "findClosestClipPathTarget", () => findClosestClipPathTarget);
$parcel$export(module.exports, "setDOMSize", () => setDOMSize);
$parcel$export(module.exports, "isFillOrStrokeAffected", () => isFillOrStrokeAffected);
$parcel$export(module.exports, "runtime", () => runtime);
$parcel$export(module.exports, "FederatedEvent", () => FederatedEvent);
$parcel$export(module.exports, "FederatedPointerEvent", () => FederatedPointerEvent);
$parcel$export(module.exports, "CustomEvent", () => CustomEvent);
$parcel$export(module.exports, "Node", () => Node);
$parcel$export(module.exports, "RenderReason", () => RenderReason);
$parcel$export(module.exports, "ElementEvent", () => ElementEvent);
$parcel$export(module.exports, "isDisplayObject", () => isDisplayObject);
$parcel$export(module.exports, "DisplayObject", () => DisplayObject);
$parcel$export(module.exports, "Circle", () => Circle);
$parcel$export(module.exports, "CustomElement", () => CustomElement);
$parcel$export(module.exports, "Ellipse", () => Ellipse);
$parcel$export(module.exports, "Group", () => Group);
$parcel$export(module.exports, "HTML", () => HTML);
$parcel$export(module.exports, "Image", () => Image);
$parcel$export(module.exports, "Line", () => Line);
$parcel$export(module.exports, "Path", () => Path);
$parcel$export(module.exports, "Polygon", () => Polygon);
$parcel$export(module.exports, "Polyline", () => Polyline);
$parcel$export(module.exports, "Rect", () => Rect);
$parcel$export(module.exports, "Text", () => Text);
$parcel$export(module.exports, "CSS", () => CSS);
$parcel$export(module.exports, "Document", () => Document);
$parcel$export(module.exports, "CanvasEvent", () => CanvasEvent);
$parcel$export(module.exports, "Canvas", () => Canvas);
$parcel$export(module.exports, "ImageLoader", () => index$3);
$parcel$export(module.exports, "HTMLRenderer", () => index$2);
$parcel$export(module.exports, "DomInteraction", () => index$1);
/*!
 * @antv/g-lite
 * @description A core module for rendering engine implements DOM API.
 * @version 2.7.0
 * @date 12/24/2025, 11:55:20 AM
 * @author AntVis
 * @docs https://g.antv.antgroup.com/
 */ 
var $cbdLd = parcelRequire("cbdLd");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $fUHKi = parcelRequire("fUHKi");

var $jLNr1 = parcelRequire("jLNr1");

var $f8wIT = parcelRequire("f8wIT");

var $02Ztr = parcelRequire("02Ztr");

var $3vRz3 = parcelRequire("3vRz3");

var $bDSmI = parcelRequire("bDSmI");
var $3iqbd = parcelRequire("3iqbd");
var $k1dpP = parcelRequire("k1dpP");
var $6BoVD = parcelRequire("6BoVD");
var $eIStk = parcelRequire("eIStk");
var $jxhwV = parcelRequire("jxhwV");
parcelRequire("bnGdl");

var $8hhuV = parcelRequire("8hhuV");
var $lIA8Y = parcelRequire("lIA8Y");
var $aoFex = parcelRequire("aoFex");
var $gAC5x = parcelRequire("gAC5x");
var $bqypU = parcelRequire("bqypU");
var $3O2w1 = parcelRequire("3O2w1");
var $ctnG0 = parcelRequire("ctnG0");
var $iJzUi = parcelRequire("iJzUi");
var $1uF5a = parcelRequire("1uF5a");
var $2LrCM = parcelRequire("2LrCM");
var $ky7aH = parcelRequire("ky7aH");
var $geZBG = parcelRequire("geZBG");
var $jyI49 = parcelRequire("jyI49");
var $dFv1j = parcelRequire("dFv1j");
var $6JKSc = parcelRequire("6JKSc");
var $kVcyu = parcelRequire("kVcyu");
var $aFcWQ = parcelRequire("aFcWQ");
var $bFgqX = parcelRequire("bFgqX");
var $04Wz9 = parcelRequire("04Wz9");
var $fo9PZ = parcelRequire("fo9PZ");
var $dnxxK = parcelRequire("dnxxK");
var $7Tbfw = parcelRequire("7Tbfw");
var $6kBPW = parcelRequire("6kBPW");

var $g5Zhu = parcelRequire("g5Zhu");

var $dPop6 = parcelRequire("dPop6");

var $2zZPz = parcelRequire("2zZPz");

var $11s8J = parcelRequire("11s8J");

var $8HV7i = parcelRequire("8HV7i");

var $fOd0O = parcelRequire("fOd0O");

var $8QL5z = parcelRequire("8QL5z");

var $gZU1N = parcelRequire("gZU1N");
/// <reference types="webxr" />
var Shape = /*#__PURE__*/ function(Shape) {
    Shape["GROUP"] = "g";
    Shape["FRAGMENT"] = "fragment";
    Shape["CIRCLE"] = "circle";
    Shape["ELLIPSE"] = "ellipse";
    Shape["IMAGE"] = "image";
    Shape["RECT"] = "rect";
    Shape["LINE"] = "line";
    Shape["POLYLINE"] = "polyline";
    Shape["POLYGON"] = "polygon";
    Shape["TEXT"] = "text";
    Shape["PATH"] = "path";
    Shape["HTML"] = "html";
    Shape["MESH"] = "mesh";
    return Shape;
}({});
// prettier-ignore
// prettier-ignore
// Cursor style
// See: https://developer.mozilla.org/en-US/docs/Web/CSS/cursor
var ClipSpaceNearZ = /*#__PURE__*/ function(ClipSpaceNearZ) {
    ClipSpaceNearZ[ClipSpaceNearZ["ZERO"] = 0] = "ZERO";
    ClipSpaceNearZ[ClipSpaceNearZ["NEGATIVE_ONE"] = 1] = "NEGATIVE_ONE";
    return ClipSpaceNearZ;
}({});
/**
 * eg. NodeCanvas, OffscreenCanvas, HTMLCanvasElement
 */ /**
 * The format to use when defining custom easing functions
 */ // @see https://github.com/zhanba/pailye/blob/master/packages/flex/src/types.ts
var AbstractRendererPlugin = /*#__PURE__*/ function() {
    function AbstractRendererPlugin() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AbstractRendererPlugin);
        this.plugins = [];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AbstractRendererPlugin, [
        {
            key: "addRenderingPlugin",
            value: function addRenderingPlugin(plugin) {
                this.plugins.push(plugin);
                this.context.renderingPlugins.push(plugin);
            }
        },
        {
            key: "removeAllRenderingPlugins",
            value: function removeAllRenderingPlugins() {
                var _this = this;
                this.plugins.forEach(function(plugin) {
                    var index = _this.context.renderingPlugins.indexOf(plugin);
                    if (index >= 0) _this.context.renderingPlugins.splice(index, 1);
                });
            }
        }
    ]);
}();
var AbstractRenderer = /*#__PURE__*/ function() {
    function AbstractRenderer(config) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AbstractRenderer);
        this.clipSpaceNearZ = ClipSpaceNearZ.NEGATIVE_ONE;
        this.plugins = [];
        this.config = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
            /**
       * only dirty object will cause re-render
       */ enableDirtyCheck: true,
            enableCulling: false,
            /**
       * enable auto rendering by default
       */ enableAutoRendering: true,
            /**
       * enable dirty rectangle rendering by default
       */ enableDirtyRectangleRendering: true,
            enableDirtyRectangleRenderingDebug: false,
            enableSizeAttenuation: true,
            enableRenderingOptimization: false
        }, config);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AbstractRenderer, [
        {
            key: "registerPlugin",
            value: function registerPlugin(plugin) {
                var index = this.plugins.findIndex(function(p) {
                    return p === plugin;
                });
                if (index === -1) this.plugins.push(plugin);
            }
        },
        {
            key: "unregisterPlugin",
            value: function unregisterPlugin(plugin) {
                var index = this.plugins.findIndex(function(p) {
                    return p === plugin;
                });
                if (index > -1) this.plugins.splice(index, 1);
            }
        },
        {
            key: "getPlugins",
            value: function getPlugins() {
                return this.plugins;
            }
        },
        {
            key: "getPlugin",
            value: function getPlugin(name) {
                return this.plugins.find(function(plugin) {
                    return plugin.name === name;
                });
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                return this.config;
            }
        },
        {
            key: "setConfig",
            value: function setConfig(config) {
                Object.assign(this.config, config);
            }
        }
    ]);
}();
var addVec3 = (0, $eIStk).add, copyVec3 = (0, $eIStk).copy, maxVec3 = (0, $eIStk).max, minVec3 = (0, $eIStk).min, scaleVec3 = (0, $eIStk).scale, subVec3 = (0, $eIStk).sub;
/**
 * Axis-Aligned Bounding Box
 * 为了便于后续 Frustum Culling，通过查找表定义 p-vertex 和 n-vertex
 * @see https://github.com/antvis/GWebGPUEngine/issues/3
 */ var AABB = /*#__PURE__*/ function() {
    function AABB() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AABB);
        this.center = [
            0,
            0,
            0
        ];
        this.halfExtents = [
            0,
            0,
            0
        ];
        this.min = [
            0,
            0,
            0
        ];
        this.max = [
            0,
            0,
            0
        ];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AABB, [
        {
            key: "update",
            value: function update(center, halfExtents) {
                copyVec3(this.center, center);
                copyVec3(this.halfExtents, halfExtents);
                subVec3(this.min, this.center, this.halfExtents);
                addVec3(this.max, this.center, this.halfExtents);
            }
        },
        {
            key: "setMinMax",
            value: function setMinMax(min, max) {
                addVec3(this.center, max, min);
                scaleVec3(this.center, this.center, 0.5);
                subVec3(this.halfExtents, max, min);
                scaleVec3(this.halfExtents, this.halfExtents, 0.5);
                copyVec3(this.min, min);
                copyVec3(this.max, max);
            }
        },
        {
            key: "getMin",
            value: function getMin() {
                return this.min;
            }
        },
        {
            key: "getMax",
            value: function getMax() {
                return this.max;
            }
        },
        {
            key: "add",
            value: function add(aabb) {
                if (AABB.isEmpty(aabb)) return;
                if (AABB.isEmpty(this)) {
                    this.setMinMax(aabb.getMin(), aabb.getMax());
                    return;
                }
                var tc = this.center;
                var tcx = tc[0];
                var tcy = tc[1];
                var tcz = tc[2];
                var th = this.halfExtents;
                var thx = th[0];
                var thy = th[1];
                var thz = th[2];
                var tminx = tcx - thx;
                var tmaxx = tcx + thx;
                var tminy = tcy - thy;
                var tmaxy = tcy + thy;
                var tminz = tcz - thz;
                var tmaxz = tcz + thz;
                var oc = aabb.center;
                var ocx = oc[0];
                var ocy = oc[1];
                var ocz = oc[2];
                var oh = aabb.halfExtents;
                var ohx = oh[0];
                var ohy = oh[1];
                var ohz = oh[2];
                var ominx = ocx - ohx;
                var omaxx = ocx + ohx;
                var ominy = ocy - ohy;
                var omaxy = ocy + ohy;
                var ominz = ocz - ohz;
                var omaxz = ocz + ohz;
                if (ominx < tminx) tminx = ominx;
                if (omaxx > tmaxx) tmaxx = omaxx;
                if (ominy < tminy) tminy = ominy;
                if (omaxy > tmaxy) tmaxy = omaxy;
                if (ominz < tminz) tminz = ominz;
                if (omaxz > tmaxz) tmaxz = omaxz;
                tc[0] = (tminx + tmaxx) * 0.5;
                tc[1] = (tminy + tmaxy) * 0.5;
                tc[2] = (tminz + tmaxz) * 0.5;
                th[0] = (tmaxx - tminx) * 0.5;
                th[1] = (tmaxy - tminy) * 0.5;
                th[2] = (tmaxz - tminz) * 0.5;
                this.min[0] = tminx;
                this.min[1] = tminy;
                this.min[2] = tminz;
                this.max[0] = tmaxx;
                this.max[1] = tmaxy;
                this.max[2] = tmaxz;
            }
        },
        {
            key: "setFromTransformedAABB",
            value: function setFromTransformedAABB(aabb, m) {
                var bc = this.center;
                var br = this.halfExtents;
                var ac = aabb.center;
                var ar = aabb.halfExtents;
                var mx0 = m[0];
                var mx1 = m[4];
                var mx2 = m[8];
                var my0 = m[1];
                var my1 = m[5];
                var my2 = m[9];
                var mz0 = m[2];
                var mz1 = m[6];
                var mz2 = m[10];
                var mx0a = Math.abs(mx0);
                var mx1a = Math.abs(mx1);
                var mx2a = Math.abs(mx2);
                var my0a = Math.abs(my0);
                var my1a = Math.abs(my1);
                var my2a = Math.abs(my2);
                var mz0a = Math.abs(mz0);
                var mz1a = Math.abs(mz1);
                var mz2a = Math.abs(mz2);
                bc[0] = m[12] + mx0 * ac[0] + mx1 * ac[1] + mx2 * ac[2];
                bc[1] = m[13] + my0 * ac[0] + my1 * ac[1] + my2 * ac[2];
                bc[2] = m[14] + mz0 * ac[0] + mz1 * ac[1] + mz2 * ac[2];
                // vec3.set(
                //   bc,
                //   m[12] + mx0 * ac[0] + mx1 * ac[1] + mx2 * ac[2],
                //   m[13] + my0 * ac[0] + my1 * ac[1] + my2 * ac[2],
                //   m[14] + mz0 * ac[0] + mz1 * ac[1] + mz2 * ac[2],
                // );
                br[0] = mx0a * ar[0] + mx1a * ar[1] + mx2a * ar[2];
                br[1] = my0a * ar[0] + my1a * ar[1] + my2a * ar[2];
                br[2] = mz0a * ar[0] + mz1a * ar[1] + mz2a * ar[2];
                // vec3.set(
                //   br,
                //   mx0a * ar[0] + mx1a * ar[1] + mx2a * ar[2],
                //   my0a * ar[0] + my1a * ar[1] + my2a * ar[2],
                //   mz0a * ar[0] + mz1a * ar[1] + mz2a * ar[2],
                // );
                // this.min = vec3.sub(this.min, bc, br);
                // this.max = vec3.add(this.max, bc, br);
                subVec3(this.min, bc, br);
                addVec3(this.max, bc, br);
            }
        },
        {
            key: "intersects",
            value: function intersects(aabb) {
                var aMax = this.getMax();
                var aMin = this.getMin();
                var bMax = aabb.getMax();
                var bMin = aabb.getMin();
                return aMin[0] <= bMax[0] && aMax[0] >= bMin[0] && aMin[1] <= bMax[1] && aMax[1] >= bMin[1] && aMin[2] <= bMax[2] && aMax[2] >= bMin[2];
            }
        },
        {
            key: "intersection",
            value: function intersection(aabb) {
                if (!this.intersects(aabb)) return null;
                var intersection = new AABB();
                var min = maxVec3([
                    0,
                    0,
                    0
                ], this.getMin(), aabb.getMin());
                var max = minVec3([
                    0,
                    0,
                    0
                ], this.getMax(), aabb.getMax());
                intersection.setMinMax(min, max);
                return intersection;
            }
        },
        {
            key: "getNegativeFarPoint",
            value: function getNegativeFarPoint(plane) {
                if (plane.pnVertexFlag === 0x111) return copyVec3([
                    0,
                    0,
                    0
                ], this.min);
                if (plane.pnVertexFlag === 0x110) return [
                    this.min[0],
                    this.min[1],
                    this.max[2]
                ];
                if (plane.pnVertexFlag === 0x101) return [
                    this.min[0],
                    this.max[1],
                    this.min[2]
                ];
                if (plane.pnVertexFlag === 0x100) return [
                    this.min[0],
                    this.max[1],
                    this.max[2]
                ];
                if (plane.pnVertexFlag === 0x011) return [
                    this.max[0],
                    this.min[1],
                    this.min[2]
                ];
                if (plane.pnVertexFlag === 0x010) return [
                    this.max[0],
                    this.min[1],
                    this.max[2]
                ];
                if (plane.pnVertexFlag === 0x001) return [
                    this.max[0],
                    this.max[1],
                    this.min[2]
                ];
                return [
                    this.max[0],
                    this.max[1],
                    this.max[2]
                ];
            // return vec3.fromValues(this.max[0], this.max[1], this.max[2]);
            }
        },
        {
            key: "getPositiveFarPoint",
            value: function getPositiveFarPoint(plane) {
                if (plane.pnVertexFlag === 0x111) return copyVec3([
                    0,
                    0,
                    0
                ], this.max);
                if (plane.pnVertexFlag === 0x110) return [
                    this.max[0],
                    this.max[1],
                    this.min[2]
                ];
                if (plane.pnVertexFlag === 0x101) return [
                    this.max[0],
                    this.min[1],
                    this.max[2]
                ];
                if (plane.pnVertexFlag === 0x100) return [
                    this.max[0],
                    this.min[1],
                    this.min[2]
                ];
                if (plane.pnVertexFlag === 0x011) return [
                    this.min[0],
                    this.max[1],
                    this.max[2]
                ];
                if (plane.pnVertexFlag === 0x010) return [
                    this.min[0],
                    this.max[1],
                    this.min[2]
                ];
                if (plane.pnVertexFlag === 0x001) return [
                    this.min[0],
                    this.min[1],
                    this.max[2]
                ];
                return [
                    this.min[0],
                    this.min[1],
                    this.min[2]
                ];
            // return vec3.fromValues(this.min[0], this.min[1], this.min[2]);
            }
        }
    ], [
        {
            key: "isEmpty",
            value: function isEmpty(aabb) {
                return !aabb || aabb.halfExtents[0] === 0 && aabb.halfExtents[1] === 0 && aabb.halfExtents[2] === 0;
            }
        }
    ]);
}();
var Plane = /*#__PURE__*/ function() {
    /**
   * lookup table for p-vertex & n-vertex when doing frustum culling
   */ function Plane(distance, normal) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Plane);
        this.distance = distance || 0;
        this.normal = normal || (0, $eIStk).fromValues(0, 1, 0);
        this.updatePNVertexFlag();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Plane, [
        {
            key: "updatePNVertexFlag",
            value: function updatePNVertexFlag() {
                this.pnVertexFlag = (Number(this.normal[0] >= 0) << 8) + (Number(this.normal[1] >= 0) << 4) + Number(this.normal[2] >= 0);
            }
        },
        {
            key: "distanceToPoint",
            value: function distanceToPoint(point) {
                return (0, $eIStk).dot(point, this.normal) - this.distance;
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                var invLen = 1 / (0, $eIStk).len(this.normal);
                (0, $eIStk).scale(this.normal, this.normal, invLen);
                this.distance *= invLen;
            }
        },
        {
            key: "intersectsLine",
            value: function intersectsLine(start, end, point) {
                var d0 = this.distanceToPoint(start);
                var d1 = this.distanceToPoint(end);
                var t = d0 / (d0 - d1);
                var intersects = t >= 0 && t <= 1;
                if (intersects && point) (0, $eIStk).lerp(point, start, end, t);
                return intersects;
            }
        }
    ]);
}();
var Mask = /*#__PURE__*/ function(Mask) {
    Mask[Mask["OUTSIDE"] = 4294967295] = "OUTSIDE";
    Mask[Mask["INSIDE"] = 0] = "INSIDE";
    Mask[Mask["INDETERMINATE"] = 2147483647] = "INDETERMINATE";
    return Mask;
}({});
var Frustum = /*#__PURE__*/ function() {
    function Frustum(planes) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Frustum);
        this.planes = [];
        if (planes) this.planes = planes;
        else for(var i = 0; i < 6; i++)this.planes.push(new Plane());
    }
    /**
   * extract 6 planes from projectionMatrix
   * @see http://www8.cs.umu.se/kurser/5DV051/HT12/lab/plane_extraction.pdf
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Frustum, [
        {
            key: "extractFromVPMatrix",
            value: function extractFromVPMatrix(projectionMatrix) {
                // @ts-ignore
                var _projectionMatrix = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(projectionMatrix, 16), m0 = _projectionMatrix[0], m1 = _projectionMatrix[1], m2 = _projectionMatrix[2], m3 = _projectionMatrix[3], m4 = _projectionMatrix[4], m5 = _projectionMatrix[5], m6 = _projectionMatrix[6], m7 = _projectionMatrix[7], m8 = _projectionMatrix[8], m9 = _projectionMatrix[9], m10 = _projectionMatrix[10], m11 = _projectionMatrix[11], m12 = _projectionMatrix[12], m13 = _projectionMatrix[13], m14 = _projectionMatrix[14], m15 = _projectionMatrix[15];
                // right
                (0, $eIStk).set(this.planes[0].normal, m3 - m0, m7 - m4, m11 - m8);
                this.planes[0].distance = m15 - m12;
                // left
                (0, $eIStk).set(this.planes[1].normal, m3 + m0, m7 + m4, m11 + m8);
                this.planes[1].distance = m15 + m12;
                // bottom
                (0, $eIStk).set(this.planes[2].normal, m3 + m1, m7 + m5, m11 + m9);
                this.planes[2].distance = m15 + m13;
                // top
                (0, $eIStk).set(this.planes[3].normal, m3 - m1, m7 - m5, m11 - m9);
                this.planes[3].distance = m15 - m13;
                // far
                (0, $eIStk).set(this.planes[4].normal, m3 - m2, m7 - m6, m11 - m10);
                this.planes[4].distance = m15 - m14;
                // near
                (0, $eIStk).set(this.planes[5].normal, m3 + m2, m7 + m6, m11 + m10);
                this.planes[5].distance = m15 + m14;
                this.planes.forEach(function(plane) {
                    plane.normalize();
                    plane.updatePNVertexFlag();
                });
            }
        }
    ]);
}();
var Point = /*#__PURE__*/ function() {
    function Point() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Point);
        this.x = 0;
        this.y = 0;
        this.x = x;
        this.y = y;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Point, [
        {
            key: "clone",
            value: function clone() {
                return new Point(this.x, this.y);
            }
        },
        {
            key: "copyFrom",
            value: function copyFrom(p) {
                this.x = p.x;
                this.y = p.y;
            }
        }
    ]);
}();
var Rectangle = /*#__PURE__*/ function() {
    function Rectangle(x, y, width, height) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Rectangle);
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.left = x;
        this.right = x + width;
        this.top = y;
        this.bottom = y + height;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Rectangle, [
        {
            key: "toJSON",
            value: function toJSON() {}
        }
    ], [
        {
            key: "fromRect",
            value: /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMRect/fromRect_static
     */ function fromRect(rect) {
                return new Rectangle(rect.x, rect.y, rect.width, rect.height);
            }
        },
        {
            key: "applyTransform",
            value: function applyTransform(rect, matrix) {
                var topLeft = (0, $jxhwV).fromValues(rect.x, rect.y, 0, 1);
                var topRight = (0, $jxhwV).fromValues(rect.x + rect.width, rect.y, 0, 1);
                var bottomLeft = (0, $jxhwV).fromValues(rect.x, rect.y + rect.height, 0, 1);
                var bottomRight = (0, $jxhwV).fromValues(rect.x + rect.width, rect.y + rect.height, 0, 1);
                var transformedTopLeft = (0, $jxhwV).create();
                var transformedTopRight = (0, $jxhwV).create();
                var transformedBottomLeft = (0, $jxhwV).create();
                var transformedBottomRight = (0, $jxhwV).create();
                (0, $jxhwV).transformMat4(transformedTopLeft, topLeft, matrix);
                (0, $jxhwV).transformMat4(transformedTopRight, topRight, matrix);
                (0, $jxhwV).transformMat4(transformedBottomLeft, bottomLeft, matrix);
                (0, $jxhwV).transformMat4(transformedBottomRight, bottomRight, matrix);
                var minX = Math.min(transformedTopLeft[0], transformedTopRight[0], transformedBottomLeft[0], transformedBottomRight[0]);
                var minY = Math.min(transformedTopLeft[1], transformedTopRight[1], transformedBottomLeft[1], transformedBottomRight[1]);
                var maxX = Math.max(transformedTopLeft[0], transformedTopRight[0], transformedBottomLeft[0], transformedBottomRight[0]);
                var maxY = Math.max(transformedTopLeft[1], transformedTopRight[1], transformedBottomLeft[1], transformedBottomRight[1]);
                return Rectangle.fromRect({
                    x: minX,
                    y: minY,
                    width: maxX - minX,
                    height: maxY - minY
                });
            }
        }
    ]);
}();
var ERROR_MSG_METHOD_NOT_IMPLEMENTED = 'Method not implemented.';
var ERROR_MSG_USE_DOCUMENT_ELEMENT = 'Use document.documentElement instead.';
var ERROR_MSG_APPEND_DESTROYED_ELEMENT = 'Cannot append a destroyed element.';
function getAngle(angle) {
    if (angle === undefined) return 0;
    if (angle > 360 || angle < -360) return angle % 360;
    return angle;
}
var $vec3$3 = (0, $eIStk).create();
function createVec3(x) {
    var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var clone = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    if (Array.isArray(x) && x.length === 3) return clone ? (0, $eIStk).clone(x) : (0, $eIStk).copy($vec3$3, x);
    if ((0, $jyI49.default)(x)) return clone ? (0, $eIStk).fromValues(x, y, z) : (0, $eIStk).set($vec3$3, x, y, z);
    return clone ? (0, $eIStk).fromValues(x[0], x[1] || y, x[2] || z) : (0, $eIStk).set($vec3$3, x[0], x[1] || y, x[2] || z);
}
var DEG_RAD = Math.PI / 180;
function deg2rad(deg) {
    return deg * DEG_RAD;
}
var RAD_DEG = 180 / Math.PI;
function rad2deg(rad) {
    return rad * RAD_DEG;
}
var GRAD_DEG = 0.9; // 360 / 400;
function grad2deg(grads) {
    grads %= 400;
    if (grads < 0) grads += 400;
    return grads * GRAD_DEG;
}
function deg2turn(deg) {
    return deg / 360;
}
function turn2deg(turn) {
    return 360 * turn;
}
var HALF_PI = Math.PI / 2;
function getEulerFromQuat(out, quat) {
    var x = quat[0];
    var y = quat[1];
    var z = quat[2];
    var w = quat[3];
    var x2 = x * x;
    var y2 = y * y;
    var z2 = z * z;
    var w2 = w * w;
    var unit = x2 + y2 + z2 + w2;
    var test = x * w - y * z;
    if (test > 0.499995 * unit) {
        // TODO: Use glmatrix.EPSILON
        // singularity at the north pole
        out[0] = HALF_PI;
        out[1] = 2 * Math.atan2(y, x);
        out[2] = 0;
    } else if (test < -0.499995 * unit) {
        // TODO: Use glmatrix.EPSILON
        // singularity at the south pole
        out[0] = -HALF_PI;
        out[1] = 2 * Math.atan2(y, x);
        out[2] = 0;
    } else {
        out[0] = Math.asin(2 * (x * z - w * y));
        out[1] = Math.atan2(2 * (x * w + y * z), 1 - 2 * (z2 + w2));
        out[2] = Math.atan2(2 * (x * y + z * w), 1 - 2 * (y2 + z2));
    }
    // TODO: Return them as degrees and not as radians
    return out;
}
function getEulerFromMat4(out, m) {
    var x;
    var z;
    var _mat4$getScaling = (0, $3iqbd).getScaling((0, $eIStk).create(), m), _mat4$getScaling2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_mat4$getScaling, 3), sx = _mat4$getScaling2[0], sy = _mat4$getScaling2[1], sz = _mat4$getScaling2[2];
    var y = Math.asin(-m[2] / sx);
    if (y < HALF_PI) {
        if (y > -HALF_PI) {
            x = Math.atan2(m[6] / sy, m[10] / sz);
            z = Math.atan2(m[1] / sx, m[0] / sx);
        } else {
            // Not a unique solution
            z = 0;
            x = -Math.atan2(m[4] / sy, m[5] / sy);
        }
    } else {
        // Not a unique solution
        z = 0;
        x = Math.atan2(m[4] / sy, m[5] / sy);
    }
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
/**
 * @see https://github.com/toji/gl-matrix/issues/329
 * @see https://doc.babylonjs.com/divingDeeper/mesh/transforms/center_origin/rotation_conventions
 */ function getEuler(out, quat) {
    if (quat.length === 16) return getEulerFromMat4(out, quat);
    return getEulerFromQuat(out, quat);
}
function fromRotationTranslationScale(rotation, x, y, scaleX, scaleY) {
    var cos = Math.cos(rotation);
    var sin = Math.sin(rotation);
    return (0, $bDSmI).fromValues(scaleX * cos, scaleY * sin, 0, -scaleX * sin, scaleY * cos, 0, x, y, 1);
}
function makePerspective(out, left, right, top, bottom, near, far) {
    var zero = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    var twoNear = 2 * near;
    var rightMinusLeft = right - left;
    var topMinusBottom = top - bottom;
    var x = twoNear / rightMinusLeft;
    var y = twoNear / topMinusBottom;
    var a = (right + left) / rightMinusLeft;
    var b = (top + bottom) / topMinusBottom;
    var c;
    var d;
    var farMinusNear = far - near;
    var farMulNear = far * near;
    if (zero) {
        c = -far / farMinusNear;
        d = -farMulNear / farMinusNear;
    } else {
        c = -(far + near) / farMinusNear;
        d = -2 * farMulNear / farMinusNear;
    }
    out[0] = x;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = y;
    out[6] = 0;
    out[7] = 0;
    out[8] = a;
    out[9] = b;
    out[10] = c;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = d;
    out[15] = 0;
    return out;
}
function decompose(mat) {
    var row0x = mat[0];
    var row0y = mat[1];
    var row1x = mat[3];
    var row1y = mat[4];
    // decompose 3x3 matrix
    // @see https://www.w3.org/TR/css-transforms-1/#decomposing-a-2d-matrix
    var scalingX = Math.sqrt(row0x * row0x + row0y * row0y);
    var scalingY = Math.sqrt(row1x * row1x + row1y * row1y);
    // If determinant is negative, one axis was flipped.
    var determinant = row0x * row1y - row0y * row1x;
    if (determinant < 0) {
        // Flip axis with minimum unit vector dot product.
        if (row0x < row1y) scalingX = -scalingX;
        else scalingY = -scalingY;
    }
    // Renormalize matrix to remove scale.
    if (scalingX) {
        var invScalingX = 1 / scalingX;
        row0x *= invScalingX;
        row0y *= invScalingX;
    }
    if (scalingY) {
        var invScalingY = 1 / scalingY;
        row1x *= invScalingY;
        row1y *= invScalingY;
    }
    // Compute rotation and renormalize matrix.
    var rotation = Math.atan2(row0y, row0x);
    var angle = rad2deg(rotation);
    return [
        mat[6],
        mat[7],
        scalingX,
        scalingY,
        angle
    ];
}
var tmp = (0, $3iqbd).create();
var perspectiveMatrix = (0, $3iqbd).create();
var tmpVec4 = (0, $jxhwV).create();
var row = [
    (0, $eIStk).create(),
    (0, $eIStk).create(),
    (0, $eIStk).create()
];
var pdum3 = (0, $eIStk).create();
/*
Input:  matrix      ; a 4x4 matrix
Output: translation ; a 3 component vector
        scale       ; a 3 component vector
        skew        ; skew factors XY,XZ,YZ represented as a 3 component vector
        perspective ; a 4 component vector
        quaternion  ; a 4 component vector
Returns false if the matrix cannot be decomposed, true if it can


References:
https://github.com/kamicane/matrix3d/blob/master/lib/Matrix3d.js
https://github.com/ChromiumWebApps/chromium/blob/master/ui/gfx/transform_util.cc
http://www.w3.org/TR/css3-transforms/#decomposing-a-3d-matrix
*/ function decomposeMat4(matrix, translation, scale, skew, perspective, quaternion) {
    // normalize, if not possible then bail out early
    if (!normalize(tmp, matrix)) return false;
    // perspectiveMatrix is used to solve for perspective, but it also provides
    // an easy way to test for singularity of the upper 3x3 component.
    (0, $3iqbd).copy(perspectiveMatrix, tmp);
    perspectiveMatrix[3] = 0;
    perspectiveMatrix[7] = 0;
    perspectiveMatrix[11] = 0;
    perspectiveMatrix[15] = 1;
    // If the perspectiveMatrix is not invertible, we are also unable to
    // decompose, so we'll bail early. Constant taken from SkMatrix44::invert.
    if (Math.abs((0, $3iqbd).determinant(perspectiveMatrix)) < 1e-8) return false;
    var a03 = tmp[3];
    var a13 = tmp[7];
    var a23 = tmp[11];
    var a30 = tmp[12];
    var a31 = tmp[13];
    var a32 = tmp[14];
    var a33 = tmp[15];
    // First, isolate perspective.
    if (a03 !== 0 || a13 !== 0 || a23 !== 0) {
        tmpVec4[0] = a03;
        tmpVec4[1] = a13;
        tmpVec4[2] = a23;
        tmpVec4[3] = a33;
        // Solve the equation by inverting perspectiveMatrix and multiplying
        // rightHandSide by the inverse.
        // resuing the perspectiveMatrix here since it's no longer needed
        var ret = (0, $3iqbd).invert(perspectiveMatrix, perspectiveMatrix);
        if (!ret) return false;
        (0, $3iqbd).transpose(perspectiveMatrix, perspectiveMatrix);
        // multiply by transposed inverse perspective matrix, into perspective vec4
        (0, $jxhwV).transformMat4(perspective, tmpVec4, perspectiveMatrix);
    } else {
        // no perspective
        perspective[0] = perspective[1] = perspective[2] = 0;
        perspective[3] = 1;
    }
    // Next take care of translation
    translation[0] = a30;
    translation[1] = a31;
    translation[2] = a32;
    // Now get scale and shear. 'row' is a 3 element array of 3 component vectors
    mat3from4(row, tmp);
    // Compute X scale factor and normalize first row.
    scale[0] = (0, $eIStk).length(row[0]);
    (0, $eIStk).normalize(row[0], row[0]);
    // Compute XY shear factor and make 2nd row orthogonal to 1st.
    skew[0] = (0, $eIStk).dot(row[0], row[1]);
    combine(row[1], row[1], row[0], 1.0, -skew[0]);
    // Now, compute Y scale and normalize 2nd row.
    scale[1] = (0, $eIStk).length(row[1]);
    (0, $eIStk).normalize(row[1], row[1]);
    skew[0] /= scale[1];
    // Compute XZ and YZ shears, orthogonalize 3rd row
    skew[1] = (0, $eIStk).dot(row[0], row[2]);
    combine(row[2], row[2], row[0], 1.0, -skew[1]);
    skew[2] = (0, $eIStk).dot(row[1], row[2]);
    combine(row[2], row[2], row[1], 1.0, -skew[2]);
    // Next, get Z scale and normalize 3rd row.
    scale[2] = (0, $eIStk).length(row[2]);
    (0, $eIStk).normalize(row[2], row[2]);
    skew[1] /= scale[2];
    skew[2] /= scale[2];
    // At this point, the matrix (in rows) is orthonormal.
    // Check for a coordinate system flip.  If the determinant
    // is -1, then negate the matrix and the scaling factors.
    (0, $eIStk).cross(pdum3, row[1], row[2]);
    if ((0, $eIStk).dot(row[0], pdum3) < 0) for(var i = 0; i < 3; i++){
        scale[i] *= -1;
        row[i][0] *= -1;
        row[i][1] *= -1;
        row[i][2] *= -1;
    }
    // Now, get the rotations out
    quaternion[0] = 0.5 * Math.sqrt(Math.max(1 + row[0][0] - row[1][1] - row[2][2], 0));
    quaternion[1] = 0.5 * Math.sqrt(Math.max(1 - row[0][0] + row[1][1] - row[2][2], 0));
    quaternion[2] = 0.5 * Math.sqrt(Math.max(1 - row[0][0] - row[1][1] + row[2][2], 0));
    quaternion[3] = 0.5 * Math.sqrt(Math.max(1 + row[0][0] + row[1][1] + row[2][2], 0));
    if (row[2][1] > row[1][2]) quaternion[0] = -quaternion[0];
    if (row[0][2] > row[2][0]) quaternion[1] = -quaternion[1];
    if (row[1][0] > row[0][1]) quaternion[2] = -quaternion[2];
    return true;
}
function normalize(out, mat) {
    var m44 = mat[15];
    // Cannot normalize.
    if (m44 === 0) return false;
    var scale = 1 / m44;
    for(var i = 0; i < 16; i++)out[i] = mat[i] * scale;
    return true;
}
// gets upper-left of a 4x4 matrix into a 3x3 of vectors
function mat3from4(out, mat4x4) {
    out[0][0] = mat4x4[0];
    out[0][1] = mat4x4[1];
    out[0][2] = mat4x4[2];
    out[1][0] = mat4x4[4];
    out[1][1] = mat4x4[5];
    out[1][2] = mat4x4[6];
    out[2][0] = mat4x4[8];
    out[2][1] = mat4x4[9];
    out[2][2] = mat4x4[10];
}
function combine(out, a, b, scale1, scale2) {
    out[0] = a[0] * scale1 + b[0] * scale2;
    out[1] = a[1] * scale1 + b[1] * scale2;
    out[2] = a[2] * scale1 + b[2] * scale2;
}
/**
 * Different type of cameras, eg. simple camera used in 2D scene or
 * advanced camera which can do actions & switch between landmarks.
 */ var CameraType = /*#__PURE__*/ function(CameraType) {
    /**
   * Performs all the rotational operations with the focal point instead of the camera position.
   * This type of camera is useful in applications(like CAD) where 3D objects are being designed or explored.
   * Camera cannot orbits over the north & south poles.
   * @see http://voxelent.com/tutorial-cameras/
   *
   * In Three.js it's used in OrbitControls.
   * @see https://threejs.org/docs/#examples/zh/controls/OrbitControls
   */ CameraType[CameraType["ORBITING"] = 0] = "ORBITING";
    /**
   * It's similar to the ORBITING camera, but it allows the camera to orbit over the north or south poles.
   *
   * In Three.js it's used in OrbitControls.
   * @see https://threejs.org/docs/#examples/en/controls/TrackballControls
   */ CameraType[CameraType["EXPLORING"] = 1] = "EXPLORING";
    /**
   * Performs all the rotational operations with the camera position.
   * It's useful in first person shooting games.
   * Camera cannot orbits over the north & south poles.
   *
   * In Three.js it's used in FirstPersonControls.
   * @see https://threejs.org/docs/#examples/en/controls/FirstPersonControls
   */ CameraType[CameraType["TRACKING"] = 2] = "TRACKING";
    return CameraType;
}({});
/**
 * CameraType must be TRACKING
 */ var CameraTrackingMode = /*#__PURE__*/ function(CameraTrackingMode) {
    CameraTrackingMode[CameraTrackingMode["DEFAULT"] = 0] = "DEFAULT";
    CameraTrackingMode[CameraTrackingMode["ROTATIONAL"] = 1] = "ROTATIONAL";
    CameraTrackingMode[CameraTrackingMode["TRANSLATIONAL"] = 2] = "TRANSLATIONAL";
    CameraTrackingMode[CameraTrackingMode["CINEMATIC"] = 3] = "CINEMATIC";
    return CameraTrackingMode;
}({});
var CameraProjectionMode = /*#__PURE__*/ function(CameraProjectionMode) {
    CameraProjectionMode[CameraProjectionMode["ORTHOGRAPHIC"] = 0] = "ORTHOGRAPHIC";
    CameraProjectionMode[CameraProjectionMode["PERSPECTIVE"] = 1] = "PERSPECTIVE";
    return CameraProjectionMode;
}({});
var CameraEvent = {
    UPDATED: 'updated'
};
var MIN_DISTANCE = 0.0002;
/**
 * 参考「WebGL Insights - 23.Designing Cameras for WebGL Applications」，基于 Responsible Camera 思路设计
 * @see https://github.com/d13g0/nucleo.js/blob/master/source/camera/Camera.js
 *
 * 保存相机参数，定义相机动作：
 * 1. dolly 沿 n 轴移动
 * 2. pan 沿 u v 轴移动
 * 3. rotate 以方位角旋转
 * 4. 移动到 Landmark，具有平滑的动画效果，其间禁止其他用户交互
 */ var Camera = /*#__PURE__*/ function() {
    function Camera() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Camera);
        /**
     * Clip space near Z, default to range `[-1, 1]`
     */ this.clipSpaceNearZ = ClipSpaceNearZ.NEGATIVE_ONE;
        this.eventEmitter = new (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)))();
        /**
     * Matrix of camera
     */ this.matrix = (0, $3iqbd).create();
        /**
     * u axis +X is right
     * @see http://learnwebgl.brown37.net/07_cameras/camera_introduction.html#a-camera-definition
     */ this.right = (0, $eIStk).fromValues(1, 0, 0);
        /**
     * v axis +Y is up
     */ this.up = (0, $eIStk).fromValues(0, 1, 0);
        /**
     * n axis +Z is inside
     */ this.forward = (0, $eIStk).fromValues(0, 0, 1);
        /**
     * Position of camera.
     */ this.position = (0, $eIStk).fromValues(0, 0, 1);
        /**
     * Position of focal point.
     */ this.focalPoint = (0, $eIStk).fromValues(0, 0, 0);
        /**
     * vector from focalPoint to position
     */ this.distanceVector = (0, $eIStk).fromValues(0, 0, -1);
        /**
     * length(focalPoint - position)
     */ this.distance = 1;
        /**
     * @see https://en.wikipedia.org/wiki/Azimuth
     */ this.azimuth = 0;
        this.elevation = 0;
        this.roll = 0;
        this.relAzimuth = 0;
        this.relElevation = 0;
        this.relRoll = 0;
        /**
     * 沿 n 轴移动时，保证移动速度从快到慢
     */ this.dollyingStep = 0;
        this.maxDistance = Infinity;
        this.minDistance = -Infinity;
        /**
     * zoom factor of the camera, default is 1
     * eg. https://threejs.org/docs/#api/en/cameras/OrthographicCamera.zoom
     */ this.zoom = 1;
        /**
     * invert the horizontal coordinate system HCS
     */ this.rotateWorld = false;
        /**
     * 投影矩阵参数
     */ /**
     * field of view [0-360]
     * @see http://en.wikipedia.org/wiki/Angle_of_view
     */ this.fov = 30;
        this.near = 0.1;
        this.far = 1000;
        this.aspect = 1;
        this.projectionMatrix = (0, $3iqbd).create();
        this.projectionMatrixInverse = (0, $3iqbd).create();
        this.jitteredProjectionMatrix = undefined;
        this.enableUpdate = true;
        // protected following = undefined;
        this.type = CameraType.EXPLORING;
        this.trackingMode = CameraTrackingMode.DEFAULT;
        this.projectionMode = CameraProjectionMode.PERSPECTIVE;
        /**
     * for culling use
     */ this.frustum = new Frustum();
        /**
     * ortho matrix for Canvas2D & SVG
     */ this.orthoMatrix = (0, $3iqbd).create();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Camera, [
        {
            key: "isOrtho",
            value: // constructor(type = CameraType.EXPLORING, trackingMode = CameraTrackingMode.DEFAULT) {
            //   this.setType(type, trackingMode);
            // }
            function isOrtho() {
                return this.projectionMode === CameraProjectionMode.ORTHOGRAPHIC;
            }
        },
        {
            key: "getProjectionMode",
            value: function getProjectionMode() {
                return this.projectionMode;
            }
        },
        {
            key: "getPerspective",
            value: function getPerspective() {
                // account for TAA
                return this.jitteredProjectionMatrix || this.projectionMatrix;
            }
        },
        {
            key: "getPerspectiveInverse",
            value: function getPerspectiveInverse() {
                return this.projectionMatrixInverse;
            }
        },
        {
            key: "getFrustum",
            value: function getFrustum() {
                return this.frustum;
            }
        },
        {
            key: "getPosition",
            value: function getPosition() {
                return this.position;
            }
        },
        {
            key: "getFocalPoint",
            value: function getFocalPoint() {
                return this.focalPoint;
            }
        },
        {
            key: "getDollyingStep",
            value: function getDollyingStep() {
                return this.dollyingStep;
            }
        },
        {
            key: "getNear",
            value: function getNear() {
                return this.near;
            }
        },
        {
            key: "getFar",
            value: function getFar() {
                return this.far;
            }
        },
        {
            key: "getZoom",
            value: function getZoom() {
                return this.zoom;
            }
        },
        {
            key: "getOrthoMatrix",
            value: function getOrthoMatrix() {
                return this.orthoMatrix;
            }
        },
        {
            key: "getView",
            value: function getView() {
                return this.view;
            }
        },
        {
            key: "setEnableUpdate",
            value: function setEnableUpdate(enabled) {
                this.enableUpdate = enabled;
            }
        },
        {
            key: "setType",
            value: function setType(type, trackingMode) {
                this.type = type;
                if (this.type === CameraType.EXPLORING) this.setWorldRotation(true);
                else this.setWorldRotation(false);
                this._getAngles();
                if (this.type === CameraType.TRACKING && trackingMode !== undefined) this.setTrackingMode(trackingMode);
                return this;
            }
        },
        {
            key: "setProjectionMode",
            value: function setProjectionMode(projectionMode) {
                this.projectionMode = projectionMode;
                return this;
            }
        },
        {
            key: "setTrackingMode",
            value: function setTrackingMode(trackingMode) {
                if (this.type !== CameraType.TRACKING) throw new Error('Impossible to set a tracking mode if the camera is not of tracking type');
                this.trackingMode = trackingMode;
                return this;
            }
        },
        {
            key: "setWorldRotation",
            value: function setWorldRotation(flag) {
                this.rotateWorld = flag;
                this._getAngles();
                return this;
            }
        },
        {
            key: "getViewTransform",
            value: function getViewTransform() {
                // mat4.scale(this.matrix, this.matrix, vec3.fromValues(1, -1, 1));
                return (0, $3iqbd).invert((0, $3iqbd).create(), this.matrix);
            }
        },
        {
            key: "getWorldTransform",
            value: function getWorldTransform() {
                return this.matrix;
            }
        },
        {
            key: "jitterProjectionMatrix",
            value: function jitterProjectionMatrix(x, y) {
                var translation = (0, $3iqbd).fromTranslation((0, $3iqbd).create(), [
                    x,
                    y,
                    0
                ]);
                this.jitteredProjectionMatrix = (0, $3iqbd).multiply((0, $3iqbd).create(), translation, this.projectionMatrix);
            }
        },
        {
            key: "clearJitterProjectionMatrix",
            value: function clearJitterProjectionMatrix() {
                this.jitteredProjectionMatrix = undefined;
            }
        },
        {
            key: "setMatrix",
            value: function setMatrix(matrix) {
                this.matrix = matrix;
                this._update();
                return this;
            }
        },
        {
            key: "setProjectionMatrix",
            value: function setProjectionMatrix(matrix) {
                this.projectionMatrix = matrix;
            }
        },
        {
            key: "setFov",
            value: function setFov(fov) {
                this.setPerspective(this.near, this.far, fov, this.aspect);
                return this;
            }
        },
        {
            key: "setAspect",
            value: function setAspect(aspect) {
                this.setPerspective(this.near, this.far, this.fov, aspect);
                return this;
            }
        },
        {
            key: "setNear",
            value: function setNear(near) {
                if (this.projectionMode === CameraProjectionMode.PERSPECTIVE) this.setPerspective(near, this.far, this.fov, this.aspect);
                else this.setOrthographic(this.left, this.rright, this.top, this.bottom, near, this.far);
                return this;
            }
        },
        {
            key: "setFar",
            value: function setFar(far) {
                if (this.projectionMode === CameraProjectionMode.PERSPECTIVE) this.setPerspective(this.near, far, this.fov, this.aspect);
                else this.setOrthographic(this.left, this.rright, this.top, this.bottom, this.near, far);
                return this;
            }
        },
        {
            key: "setViewOffset",
            value: function setViewOffset(fullWidth, fullHeight, x, y, width, height) {
                this.aspect = fullWidth / fullHeight;
                if (this.view === undefined) this.view = {
                    enabled: true,
                    fullWidth: 1,
                    fullHeight: 1,
                    offsetX: 0,
                    offsetY: 0,
                    width: 1,
                    height: 1
                };
                this.view.enabled = true;
                this.view.fullWidth = fullWidth;
                this.view.fullHeight = fullHeight;
                this.view.offsetX = x;
                this.view.offsetY = y;
                this.view.width = width;
                this.view.height = height;
                if (this.projectionMode === CameraProjectionMode.PERSPECTIVE) this.setPerspective(this.near, this.far, this.fov, this.aspect);
                else this.setOrthographic(this.left, this.rright, this.top, this.bottom, this.near, this.far);
                return this;
            }
        },
        {
            key: "clearViewOffset",
            value: function clearViewOffset() {
                if (this.view !== undefined) this.view.enabled = false;
                if (this.projectionMode === CameraProjectionMode.PERSPECTIVE) this.setPerspective(this.near, this.far, this.fov, this.aspect);
                else this.setOrthographic(this.left, this.rright, this.top, this.bottom, this.near, this.far);
                return this;
            }
        },
        {
            key: "setZoom",
            value: function setZoom(zoom) {
                this.zoom = zoom;
                if (this.projectionMode === CameraProjectionMode.ORTHOGRAPHIC) this.setOrthographic(this.left, this.rright, this.top, this.bottom, this.near, this.far);
                else if (this.projectionMode === CameraProjectionMode.PERSPECTIVE) this.setPerspective(this.near, this.far, this.fov, this.aspect);
                return this;
            }
        },
        {
            key: "setZoomByViewportPoint",
            value: function setZoomByViewportPoint(zoom, viewportPoint) {
                var _this$canvas$viewport = this.canvas.viewport2Canvas({
                    x: viewportPoint[0],
                    y: viewportPoint[1]
                }), ox = _this$canvas$viewport.x, oy = _this$canvas$viewport.y;
                var roll = this.roll;
                this.rotate(0, 0, -roll);
                this.setPosition(ox, oy);
                this.setFocalPoint(ox, oy);
                this.setZoom(zoom);
                this.rotate(0, 0, roll);
                var _this$canvas$viewport2 = this.canvas.viewport2Canvas({
                    x: viewportPoint[0],
                    y: viewportPoint[1]
                }), cx = _this$canvas$viewport2.x, cy = _this$canvas$viewport2.y;
                // project to rotated axis
                var dvec = (0, $eIStk).fromValues(cx - ox, cy - oy, 0);
                var dx = (0, $eIStk).dot(dvec, this.right) / (0, $eIStk).length(this.right);
                var dy = (0, $eIStk).dot(dvec, this.up) / (0, $eIStk).length(this.up);
                var _this$getPosition = this.getPosition(), _this$getPosition2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_this$getPosition, 2), px = _this$getPosition2[0], py = _this$getPosition2[1];
                var _this$getFocalPoint = this.getFocalPoint(), _this$getFocalPoint2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_this$getFocalPoint, 2), fx = _this$getFocalPoint2[0], fy = _this$getFocalPoint2[1];
                this.setPosition(px - dx, py - dy);
                this.setFocalPoint(fx - dx, fy - dy);
                return this;
            }
        },
        {
            key: "setPerspective",
            value: function setPerspective(near, far, fov, aspect) {
                var _this$view;
                this.projectionMode = CameraProjectionMode.PERSPECTIVE;
                this.fov = fov;
                this.near = near;
                this.far = far;
                this.aspect = aspect;
                var top = this.near * Math.tan(deg2rad(0.5 * this.fov)) / this.zoom;
                var height = 2 * top;
                var width = this.aspect * height;
                var left = -0.5 * width;
                if ((_this$view = this.view) !== null && _this$view !== void 0 && _this$view.enabled) {
                    var fullWidth = this.view.fullWidth;
                    var fullHeight = this.view.fullHeight;
                    left += this.view.offsetX * width / fullWidth;
                    top -= this.view.offsetY * height / fullHeight;
                    width *= this.view.width / fullWidth;
                    height *= this.view.height / fullHeight;
                }
                makePerspective(this.projectionMatrix, left, left + width, top - height, top, near, this.far, this.clipSpaceNearZ === ClipSpaceNearZ.ZERO);
                (0, $3iqbd).invert(this.projectionMatrixInverse, this.projectionMatrix);
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "setOrthographic",
            value: function setOrthographic(l, r, t, b, near, far) {
                var _this$view2;
                this.projectionMode = CameraProjectionMode.ORTHOGRAPHIC;
                this.rright = r;
                this.left = l;
                this.top = t;
                this.bottom = b;
                this.near = near;
                this.far = far;
                var dx = (this.rright - this.left) / (2 * this.zoom);
                var dy = (this.top - this.bottom) / (2 * this.zoom);
                var cx = (this.rright + this.left) / 2;
                var cy = (this.top + this.bottom) / 2;
                var left = cx - dx;
                var right = cx + dx;
                var top = cy + dy;
                var bottom = cy - dy;
                if ((_this$view2 = this.view) !== null && _this$view2 !== void 0 && _this$view2.enabled) {
                    var scaleW = (this.rright - this.left) / this.view.fullWidth / this.zoom;
                    var scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                    left += scaleW * this.view.offsetX;
                    right = left + scaleW * this.view.width;
                    top -= scaleH * this.view.offsetY;
                    bottom = top - scaleH * this.view.height;
                }
                if (this.clipSpaceNearZ === ClipSpaceNearZ.NEGATIVE_ONE) // FlipY with switching bottom & top.
                // @see https://stackoverflow.com/a/4886656
                (0, $3iqbd).ortho(this.projectionMatrix, left, right, top, bottom, near, far);
                else (0, $3iqbd).orthoZO(this.projectionMatrix, left, right, top, bottom, near, far);
                (0, $3iqbd).invert(this.projectionMatrixInverse, this.projectionMatrix);
                this._getOrthoMatrix();
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "setPosition",
            value: function setPosition(x) {
                var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.position[1];
                var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.position[2];
                var position = createVec3(x, y, z);
                this._setPosition(position);
                this.setFocalPoint(this.focalPoint);
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "setFocalPoint",
            value: function setFocalPoint(x) {
                var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.focalPoint[1];
                var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.focalPoint[2];
                var up = (0, $eIStk).fromValues(0, 1, 0);
                this.focalPoint = createVec3(x, y, z);
                if (this.trackingMode === CameraTrackingMode.CINEMATIC) {
                    var d = (0, $eIStk).subtract((0, $eIStk).create(), this.focalPoint, this.position);
                    x = d[0];
                    y = d[1];
                    z = d[2];
                    var r = (0, $eIStk).length(d);
                    var el = rad2deg(Math.asin(y / r));
                    var az = 90 + rad2deg(Math.atan2(z, x));
                    var m = (0, $3iqbd).create();
                    (0, $3iqbd).rotateY(m, m, deg2rad(az));
                    (0, $3iqbd).rotateX(m, m, deg2rad(el));
                    up = (0, $eIStk).transformMat4((0, $eIStk).create(), [
                        0,
                        1,
                        0
                    ], m);
                }
                (0, $3iqbd).invert(this.matrix, (0, $3iqbd).lookAt((0, $3iqbd).create(), this.position, this.focalPoint, up));
                this._getAxes();
                this._getDistance();
                this._getAngles();
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "getDistance",
            value: function getDistance() {
                return this.distance;
            }
        },
        {
            key: "getDistanceVector",
            value: function getDistanceVector() {
                return this.distanceVector;
            }
        },
        {
            key: "setDistance",
            value: function setDistance(d) {
                if (this.distance === d || d < 0) return this;
                this.distance = d;
                if (this.distance < MIN_DISTANCE) this.distance = MIN_DISTANCE;
                this.dollyingStep = this.distance / 100;
                var pos = (0, $eIStk).create();
                d = this.distance;
                var n = this.forward;
                var f = this.focalPoint;
                pos[0] = d * n[0] + f[0];
                pos[1] = d * n[1] + f[1];
                pos[2] = d * n[2] + f[2];
                this._setPosition(pos);
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "setMaxDistance",
            value: function setMaxDistance(d) {
                this.maxDistance = d;
                return this;
            }
        },
        {
            key: "setMinDistance",
            value: function setMinDistance(d) {
                this.minDistance = d;
                return this;
            }
        },
        {
            key: "setAzimuth",
            value: function setAzimuth(az) {
                this.azimuth = getAngle(az);
                this.computeMatrix();
                this._getAxes();
                if (this.type === CameraType.ORBITING || this.type === CameraType.EXPLORING) this._getPosition();
                else if (this.type === CameraType.TRACKING) this._getFocalPoint();
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "getAzimuth",
            value: function getAzimuth() {
                return this.azimuth;
            }
        },
        {
            key: "setElevation",
            value: function setElevation(el) {
                this.elevation = getAngle(el);
                this.computeMatrix();
                this._getAxes();
                if (this.type === CameraType.ORBITING || this.type === CameraType.EXPLORING) this._getPosition();
                else if (this.type === CameraType.TRACKING) this._getFocalPoint();
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "getElevation",
            value: function getElevation() {
                return this.elevation;
            }
        },
        {
            key: "setRoll",
            value: function setRoll(angle) {
                this.roll = getAngle(angle);
                this.computeMatrix();
                this._getAxes();
                if (this.type === CameraType.ORBITING || this.type === CameraType.EXPLORING) this._getPosition();
                else if (this.type === CameraType.TRACKING) this._getFocalPoint();
                this.triggerUpdate();
                return this;
            }
        },
        {
            key: "getRoll",
            value: function getRoll() {
                return this.roll;
            }
        },
        {
            key: "_update",
            value: function _update() {
                this._getAxes();
                this._getPosition();
                this._getDistance();
                this._getAngles();
                this._getOrthoMatrix();
                this.triggerUpdate();
            }
        },
        {
            key: "computeMatrix",
            value: function computeMatrix() {
                // 使用四元数描述 3D 旋转
                // @see https://xiaoiver.github.io/coding/2018/12/28/Camera-%E8%AE%BE%E8%AE%A1-%E4%B8%80.html
                var rotZ = (0, $k1dpP).setAxisAngle((0, $k1dpP).create(), [
                    0,
                    0,
                    1
                ], deg2rad(this.roll));
                (0, $3iqbd).identity(this.matrix);
                // only consider HCS for EXPLORING and ORBITING cameras
                var rotX = (0, $k1dpP).setAxisAngle((0, $k1dpP).create(), [
                    1,
                    0,
                    0
                ], deg2rad((this.rotateWorld && this.type !== CameraType.TRACKING || this.type === CameraType.TRACKING ? 1 : -1) * this.elevation));
                var rotY = (0, $k1dpP).setAxisAngle((0, $k1dpP).create(), [
                    0,
                    1,
                    0
                ], deg2rad((this.rotateWorld && this.type !== CameraType.TRACKING || this.type === CameraType.TRACKING ? 1 : -1) * this.azimuth));
                var rotQ = (0, $k1dpP).multiply((0, $k1dpP).create(), rotY, rotX);
                rotQ = (0, $k1dpP).multiply((0, $k1dpP).create(), rotQ, rotZ);
                var rotMatrix = (0, $3iqbd).fromQuat((0, $3iqbd).create(), rotQ);
                if (this.type === CameraType.ORBITING || this.type === CameraType.EXPLORING) {
                    (0, $3iqbd).translate(this.matrix, this.matrix, this.focalPoint);
                    (0, $3iqbd).multiply(this.matrix, this.matrix, rotMatrix);
                    (0, $3iqbd).translate(this.matrix, this.matrix, [
                        0,
                        0,
                        this.distance
                    ]);
                } else if (this.type === CameraType.TRACKING) {
                    (0, $3iqbd).translate(this.matrix, this.matrix, this.position);
                    (0, $3iqbd).multiply(this.matrix, this.matrix, rotMatrix);
                }
            }
        },
        {
            key: "_setPosition",
            value: function _setPosition(x, y, z) {
                this.position = createVec3(x, y, z);
                var m = this.matrix;
                m[12] = this.position[0];
                m[13] = this.position[1];
                m[14] = this.position[2];
                m[15] = 1;
                this._getOrthoMatrix();
            }
        },
        {
            key: "_getAxes",
            value: function _getAxes() {
                (0, $eIStk).copy(this.right, createVec3((0, $jxhwV).transformMat4((0, $jxhwV).create(), [
                    1,
                    0,
                    0,
                    0
                ], this.matrix)));
                (0, $eIStk).copy(this.up, createVec3((0, $jxhwV).transformMat4((0, $jxhwV).create(), [
                    0,
                    1,
                    0,
                    0
                ], this.matrix)));
                (0, $eIStk).copy(this.forward, createVec3((0, $jxhwV).transformMat4((0, $jxhwV).create(), [
                    0,
                    0,
                    1,
                    0
                ], this.matrix)));
                (0, $eIStk).normalize(this.right, this.right);
                (0, $eIStk).normalize(this.up, this.up);
                (0, $eIStk).normalize(this.forward, this.forward);
            }
        },
        {
            key: "_getAngles",
            value: function _getAngles() {
                // Recalculates angles
                var x = this.distanceVector[0];
                var y = this.distanceVector[1];
                var z = this.distanceVector[2];
                var r = (0, $eIStk).length(this.distanceVector);
                // FAST FAIL: If there is no distance we cannot compute angles
                if (r === 0) {
                    this.elevation = 0;
                    this.azimuth = 0;
                    return;
                }
                if (this.type === CameraType.TRACKING) {
                    this.elevation = rad2deg(Math.asin(y / r));
                    this.azimuth = rad2deg(Math.atan2(-x, -z));
                } else if (this.rotateWorld) {
                    this.elevation = rad2deg(Math.asin(y / r));
                    this.azimuth = rad2deg(Math.atan2(-x, -z));
                } else {
                    this.elevation = -rad2deg(Math.asin(y / r));
                    this.azimuth = -rad2deg(Math.atan2(-x, -z));
                }
            }
        },
        {
            key: "_getPosition",
            value: function _getPosition() {
                (0, $eIStk).copy(this.position, createVec3((0, $jxhwV).transformMat4((0, $jxhwV).create(), [
                    0,
                    0,
                    0,
                    1
                ], this.matrix)));
                // 相机位置变化，需要重新计算视距
                this._getDistance();
            }
        },
        {
            key: "_getFocalPoint",
            value: function _getFocalPoint() {
                (0, $eIStk).transformMat3(this.distanceVector, [
                    0,
                    0,
                    -this.distance
                ], (0, $bDSmI).fromMat4((0, $bDSmI).create(), this.matrix));
                (0, $eIStk).add(this.focalPoint, this.position, this.distanceVector);
                // 视点变化，需要重新计算视距
                this._getDistance();
            }
        },
        {
            key: "_getDistance",
            value: function _getDistance() {
                this.distanceVector = (0, $eIStk).subtract((0, $eIStk).create(), this.focalPoint, this.position);
                this.distance = (0, $eIStk).length(this.distanceVector);
                this.dollyingStep = this.distance / 100;
            }
        },
        {
            key: "_getOrthoMatrix",
            value: function _getOrthoMatrix() {
                if (this.projectionMode !== CameraProjectionMode.ORTHOGRAPHIC) return;
                var position = this.position;
                var rotZ = (0, $k1dpP).setAxisAngle((0, $k1dpP).create(), [
                    0,
                    0,
                    1
                ], -this.roll * Math.PI / 180);
                (0, $3iqbd).fromRotationTranslationScaleOrigin(this.orthoMatrix, rotZ, (0, $eIStk).fromValues((this.rright - this.left) / 2 - position[0], (this.top - this.bottom) / 2 - position[1], 0), (0, $eIStk).fromValues(this.zoom, this.zoom, 1), position);
            }
        },
        {
            key: "triggerUpdate",
            value: function triggerUpdate() {
                if (this.enableUpdate) {
                    // update frustum
                    var viewMatrix = this.getViewTransform();
                    var vpMatrix = (0, $3iqbd).multiply((0, $3iqbd).create(), this.getPerspective(), viewMatrix);
                    this.getFrustum().extractFromVPMatrix(vpMatrix);
                    this.eventEmitter.emit(CameraEvent.UPDATED);
                }
            }
        },
        {
            key: "rotate",
            value: function rotate(azimuth, elevation, roll) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "pan",
            value: function pan(tx, ty) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "dolly",
            value: function dolly(value) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "createLandmark",
            value: function createLandmark(name, params) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "gotoLandmark",
            value: function gotoLandmark(name, options) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "cancelLandmarkAnimation",
            value: function cancelLandmarkAnimation() {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        }
    ]);
}();
/**
 * @see https://doc.babylonjs.com/how_to/optimizing_your_scene#changing-mesh-culling-strategy
 */ var Strategy = /*#__PURE__*/ function(Strategy) {
    Strategy[Strategy["Standard"] = 0] = "Standard";
    return Strategy;
}({});
var SortReason = /*#__PURE__*/ function(SortReason) {
    SortReason[SortReason["ADDED"] = 0] = "ADDED";
    SortReason[SortReason["REMOVED"] = 1] = "REMOVED";
    SortReason[SortReason["Z_INDEX_CHANGED"] = 2] = "Z_INDEX_CHANGED";
    return SortReason;
}({});
/**
 * do RTS transformation for 2D/3D
 */ /** shared objects */ var $vec3$2 = (0, $eIStk).create();
/** shared objects */ var $mat4$1 = (0, $3iqbd).create();
/** shared objects */ var $quat$2 = (0, $k1dpP).create();
function updateLocalTransform(transform) {
    if (!transform.localDirtyFlag) return;
    var hasSkew = transform.localSkew[0] !== 0 || transform.localSkew[1] !== 0;
    if (hasSkew) {
        (0, $3iqbd).fromRotationTranslationScaleOrigin(transform.localTransform, transform.localRotation, transform.localPosition, (0, $eIStk).fromValues(1, 1, 1), transform.origin);
        // apply skew2D
        if (transform.localSkew[0] !== 0 || transform.localSkew[1] !== 0) {
            (0, $3iqbd).identity($mat4$1);
            $mat4$1[4] = Math.tan(transform.localSkew[0]);
            $mat4$1[1] = Math.tan(transform.localSkew[1]);
            (0, $3iqbd).multiply(transform.localTransform, transform.localTransform, $mat4$1);
        }
        var scaling = (0, $3iqbd).fromRotationTranslationScaleOrigin($mat4$1, (0, $k1dpP).set($quat$2, 0, 0, 0, 1), (0, $eIStk).set($vec3$2, 1, 1, 1), transform.localScale, transform.origin);
        (0, $3iqbd).multiply(transform.localTransform, transform.localTransform, scaling);
    } else {
        var localTransform = transform.localTransform, localPosition = transform.localPosition, localRotation = transform.localRotation, localScale = transform.localScale, origin = transform.origin;
        var hasPosition = localPosition[0] !== 0 || localPosition[1] !== 0 || localPosition[2] !== 0;
        var hasRotation = localRotation[3] !== 1 || localRotation[0] !== 0 || localRotation[1] !== 0 || localRotation[2] !== 0;
        var hasScale = localScale[0] !== 1 || localScale[1] !== 1 || localScale[2] !== 1;
        var hasOrigin = origin[0] !== 0 || origin[1] !== 0 || origin[2] !== 0;
        if (!hasRotation && !hasScale && !hasOrigin) {
            if (hasPosition) (0, $3iqbd).fromTranslation(localTransform, localPosition);
            else (0, $3iqbd).identity(localTransform);
        } else // @see https://github.com/mattdesl/css-mat4/blob/master/index.js
        (0, $3iqbd).fromRotationTranslationScaleOrigin(localTransform, localRotation, localPosition, localScale, origin);
    }
    transform.localDirtyFlag = false;
}
function updateWorldTransform(transform, parentTransform) {
    if (!transform.dirtyFlag) return;
    if (!parentTransform) (0, $3iqbd).copy(transform.worldTransform, transform.localTransform);
    else // TODO: should we support scale compensation?
    // @see https://github.com/playcanvas/engine/issues/1077#issuecomment-359765557
    (0, $3iqbd).multiply(transform.worldTransform, parentTransform.worldTransform, transform.localTransform);
    transform.dirtyFlag = false;
}
var EMPTY_PARSED_PATH = {
    absolutePath: [],
    hasArc: false,
    segments: [],
    polygons: [],
    polylines: [],
    curve: null,
    totalLength: 0,
    rect: new Rectangle(0, 0, 0, 0)
};
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Content_type
 */ var PropertySyntax = /*#__PURE__*/ function(PropertySyntax) {
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Content_type#coordinate
   */ PropertySyntax["COORDINATE"] = "<coordinate>";
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Content_type#color
   */ PropertySyntax["COLOR"] = "<color>";
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Content_type#paint
   */ PropertySyntax["PAINT"] = "<paint>";
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Content_type#number
   */ PropertySyntax["NUMBER"] = "<number>";
    /**
   * @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/angle
   */ PropertySyntax["ANGLE"] = "<angle>";
    /**
   * <number> with range 0..1
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Content_type#opacity_value
   */ PropertySyntax["OPACITY_VALUE"] = "<opacity-value>";
    /**
   * <number> with range 0..Infinity
   */ PropertySyntax["SHADOW_BLUR"] = "<shadow-blur>";
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Content_type#length
   */ PropertySyntax["LENGTH"] = "<length>";
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Content_type#percentage
   */ PropertySyntax["PERCENTAGE"] = "<percentage>";
    PropertySyntax["LENGTH_PERCENTAGE"] = "<length> | <percentage>";
    PropertySyntax["LENGTH_PERCENTAGE_12"] = "[<length> | <percentage>]{1,2}";
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/margin#formal_syntax
   */ PropertySyntax["LENGTH_PERCENTAGE_14"] = "[<length> | <percentage>]{1,4}";
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Content_type#list-of-ts
   */ PropertySyntax["LIST_OF_POINTS"] = "<list-of-points>";
    PropertySyntax["PATH"] = "<path>";
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/filter#formal_syntax
   */ PropertySyntax["FILTER"] = "<filter>";
    PropertySyntax["Z_INDEX"] = "<z-index>";
    PropertySyntax["OFFSET_DISTANCE"] = "<offset-distance>";
    PropertySyntax["DEFINED_PATH"] = "<defined-path>";
    PropertySyntax["MARKER"] = "<marker>";
    PropertySyntax["TRANSFORM"] = "<transform>";
    PropertySyntax["TRANSFORM_ORIGIN"] = "<transform-origin>";
    PropertySyntax["TEXT"] = "<text>";
    PropertySyntax["TEXT_TRANSFORM"] = "<text-transform>";
    return PropertySyntax;
}({});
function define(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}
function Color() {}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
define(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb;
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
define(Rgb, rgb, extend(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl;
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
define(Hsl, hsl, extend(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}
function memoize(func, resolver) {
    if (typeof func !== 'function' || resolver != null && typeof resolver !== 'function') throw new TypeError('Expected a function');
    var _memoized = function memoized() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var key = resolver ? resolver.apply(this, args) : args[0];
        var cache = _memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        _memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    _memoized.cache = new (memoize.Cache || Map)();
    memoize.cacheList.push(_memoized.cache);
    return _memoized;
}
memoize.Cache = Map;
memoize.cacheList = [];
memoize.clearCache = function() {
    memoize.cacheList.forEach(function(cache) {
        return cache.clear();
    });
};
// These units are iterated through, so be careful when adding or changing the
// order.
var UnitType = /*#__PURE__*/ function(UnitType) {
    UnitType[UnitType["kUnknown"] = 0] = "kUnknown";
    UnitType[UnitType["kNumber"] = 1] = "kNumber";
    UnitType[UnitType["kPercentage"] = 2] = "kPercentage";
    // Length units
    UnitType[UnitType["kEms"] = 3] = "kEms";
    // kExs,
    UnitType[UnitType["kPixels"] = 4] = "kPixels";
    // kCentimeters,
    // kMillimeters,
    // kInches,
    // kPoints,
    // kPicas,
    // kQuarterMillimeters,
    // https://drafts.csswg.org/css-values-4/#viewport-relative-lengths
    //
    // See also IsViewportPercentageLength.
    // kViewportWidth,
    // kViewportHeight,
    // kViewportInlineSize,
    // kViewportBlockSize,
    // kViewportMin,
    // kViewportMax,
    // kSmallViewportWidth,
    // kSmallViewportHeight,
    // kSmallViewportInlineSize,
    // kSmallViewportBlockSize,
    // kSmallViewportMin,
    // kSmallViewportMax,
    // kLargeViewportWidth,
    // kLargeViewportHeight,
    // kLargeViewportInlineSize,
    // kLargeViewportBlockSize,
    // kLargeViewportMin,
    // kLargeViewportMax,
    // kDynamicViewportWidth,
    // kDynamicViewportHeight,
    // kDynamicViewportInlineSize,
    // kDynamicViewportBlockSize,
    // kDynamicViewportMin,
    // kDynamicViewportMax,
    // https://drafts.csswg.org/css-contain-3/#container-lengths
    //
    // See also IsContainerPercentageLength.
    // kContainerWidth,
    // kContainerHeight,
    // kContainerInlineSize,
    // kContainerBlockSize,
    // kContainerMin,
    // kContainerMax,
    UnitType[UnitType["kRems"] = 5] = "kRems";
    // kChs,
    // kUserUnits, // The SVG term for unitless lengths
    // Angle units
    UnitType[UnitType["kDegrees"] = 6] = "kDegrees";
    UnitType[UnitType["kRadians"] = 7] = "kRadians";
    UnitType[UnitType["kGradians"] = 8] = "kGradians";
    UnitType[UnitType["kTurns"] = 9] = "kTurns";
    // Time units
    UnitType[UnitType["kMilliseconds"] = 10] = "kMilliseconds";
    UnitType[UnitType["kSeconds"] = 11] = "kSeconds";
    // kHertz,
    // kKilohertz,
    // Resolution
    // kDotsPerPixel,
    // kDotsPerInch,
    // kDotsPerCentimeter,
    // Other units
    // kFraction,
    UnitType[UnitType["kInteger"] = 12] = "kInteger"; // This value is used to handle quirky margins in reflow roots (body, td,
    // and th) like WinIE. The basic idea is that a stylesheet can use the value
    // __qem (for quirky em) instead of em. When the quirky value is used, if
    // you're in quirks mode, the margin will collapse away inside a table cell.
    // This quirk is specified in the HTML spec but our impl is different.
    // TODO: Remove this. crbug.com/443952
    // kQuirkyEms,
    return UnitType;
}({});
var UnitCategory = /*#__PURE__*/ function(UnitCategory) {
    UnitCategory[UnitCategory["kUNumber"] = 0] = "kUNumber";
    UnitCategory[UnitCategory["kUPercent"] = 1] = "kUPercent";
    UnitCategory[UnitCategory["kULength"] = 2] = "kULength";
    UnitCategory[UnitCategory["kUAngle"] = 3] = "kUAngle";
    UnitCategory[UnitCategory["kUTime"] = 4] = "kUTime";
    // kUFrequency,
    // kUResolution,
    UnitCategory[UnitCategory["kUOther"] = 5] = "kUOther";
    return UnitCategory;
}({});
var Nested = /*#__PURE__*/ function(Nested) {
    Nested[Nested["kYes"] = 0] = "kYes";
    Nested[Nested["kNo"] = 1] = "kNo";
    return Nested;
}({});
var ParenLess = /*#__PURE__*/ function(ParenLess) {
    ParenLess[ParenLess["kYes"] = 0] = "kYes";
    ParenLess[ParenLess["kNo"] = 1] = "kNo";
    return ParenLess;
}({});
// This file specifies the unit strings used in CSSPrimitiveValues.
var data = [
    {
        name: 'em',
        unit_type: UnitType.kEms
    },
    // {
    //   name: 'ex',
    //   unit_type: UnitType.kExs,
    // },
    {
        name: 'px',
        unit_type: UnitType.kPixels
    },
    // {
    //   name: "cm",
    //   unit_type: UnitType.kCentimeters,
    // },
    // {
    //   name: "mm",
    //   unit_type: UnitType.kMillimeters,
    // },
    // {
    //   name: "q",
    //   unit_type: UnitType.kQuarterMillimeters,
    // },
    // {
    //   name: "in",
    //   unit_type: UnitType.kInches,
    // },
    // {
    //   name: "pt",
    //   unit_type: UnitType.kPoints,
    // },
    // {
    //   name: "pc",
    //   unit_type: UnitType.kPicas,
    // },
    {
        name: 'deg',
        unit_type: UnitType.kDegrees
    },
    {
        name: 'rad',
        unit_type: UnitType.kRadians
    },
    {
        name: 'grad',
        unit_type: UnitType.kGradians
    },
    {
        name: 'ms',
        unit_type: UnitType.kMilliseconds
    },
    {
        name: 's',
        unit_type: UnitType.kSeconds
    },
    // {
    //   name: "hz",
    //   unit_type: UnitType.kHertz,
    // },
    // {
    //   name: "khz",
    //   unit_type: UnitType.kKilohertz,
    // },
    // {
    //   name: "dpi",
    //   unit_type: "kDotsPerInch",
    // },
    // {
    //   name: "dpcm",
    //   unit_type: "kDotsPerCentimeter",
    // },
    // {
    //   name: "dppx",
    //   unit_type: "kDotsPerPixel",
    // },
    // {
    //   name: "x",
    //   unit_type: "kDotsPerPixel",
    // },
    // {
    //   name: "vw",
    //   unit_type: "kViewportWidth",
    // },
    // {
    //   name: "vh",
    //   unit_type: "kViewportHeight",
    // },
    // {
    //   name: "vi",
    //   unit_type: "kViewportInlineSize",
    // },
    // {
    //   name: "vb",
    //   unit_type: "kViewportBlockSize",
    // },
    // {
    //   name: "vmin",
    //   unit_type: UnitType.kViewportMin,
    // },
    // {
    //   name: "vmax",
    //   unit_type: UnitType.kViewportMax,
    // },
    // {
    //   name: "svw",
    //   unit_type: "kSmallViewportWidth",
    // },
    // {
    //   name: "svh",
    //   unit_type: "kSmallViewportHeight",
    // },
    // {
    //   name: "svi",
    //   unit_type: "kSmallViewportInlineSize",
    // },
    // {
    //   name: "svb",
    //   unit_type: "kSmallViewportBlockSize",
    // },
    // {
    //   name: "svmin",
    //   unit_type: "kSmallViewportMin",
    // },
    // {
    //   name: "svmax",
    //   unit_type: "kSmallViewportMax",
    // },
    // {
    //   name: "lvw",
    //   unit_type: "kLargeViewportWidth",
    // },
    // {
    //   name: "lvh",
    //   unit_type: "kLargeViewportHeight",
    // },
    // {
    //   name: "lvi",
    //   unit_type: "kLargeViewportInlineSize",
    // },
    // {
    //   name: "lvb",
    //   unit_type: "kLargeViewportBlockSize",
    // },
    // {
    //   name: "lvmin",
    //   unit_type: UnitType.kLargeViewportMin,
    // },
    // {
    //   name: "lvmax",
    //   unit_type: UnitType.kLargeViewportMax,
    // },
    // {
    //   name: "dvw",
    //   unit_type: UnitType.kDynamicViewportWidth,
    // },
    // {
    //   name: "dvh",
    //   unit_type: UnitType.kDynamicViewportHeight,
    // },
    // {
    //   name: "dvi",
    //   unit_type: UnitType.kDynamicViewportInlineSize,
    // },
    // {
    //   name: "dvb",
    //   unit_type: UnitType.kDynamicViewportBlockSize,
    // },
    // {
    //   name: "dvmin",
    //   unit_type: UnitType.kDynamicViewportMin,
    // },
    // {
    //   name: "dvmax",
    //   unit_type: UnitType.kDynamicViewportMax,
    // },
    // {
    //   name: "cqw",
    //   unit_type: UnitType.kContainerWidth,
    // },
    // {
    //   name: "cqh",
    //   unit_type: UnitType.kContainerHeight,
    // },
    // {
    //   name: "cqi",
    //   unit_type: UnitType.kContainerInlineSize,
    // },
    // {
    //   name: "cqb",
    //   unit_type: UnitType.kContainerBlockSize,
    // },
    // {
    //   name: "cqmin",
    //   unit_type: UnitType.kContainerMin,
    // },
    // {
    //   name: "cqmax",
    //   unit_type: UnitType.kContainerMax,
    // },
    {
        name: 'rem',
        unit_type: UnitType.kRems
    },
    // {
    //   name: 'fr',
    //   unit_type: UnitType.kFraction,
    // },
    {
        name: 'turn',
        unit_type: UnitType.kTurns
    }
];
var CSSStyleValueType = /*#__PURE__*/ function(CSSStyleValueType) {
    CSSStyleValueType[CSSStyleValueType["kUnknownType"] = 0] = "kUnknownType";
    CSSStyleValueType[CSSStyleValueType["kUnparsedType"] = 1] = "kUnparsedType";
    CSSStyleValueType[CSSStyleValueType["kKeywordType"] = 2] = "kKeywordType";
    // Start of CSSNumericValue subclasses
    CSSStyleValueType[CSSStyleValueType["kUnitType"] = 3] = "kUnitType";
    CSSStyleValueType[CSSStyleValueType["kSumType"] = 4] = "kSumType";
    CSSStyleValueType[CSSStyleValueType["kProductType"] = 5] = "kProductType";
    CSSStyleValueType[CSSStyleValueType["kNegateType"] = 6] = "kNegateType";
    CSSStyleValueType[CSSStyleValueType["kInvertType"] = 7] = "kInvertType";
    CSSStyleValueType[CSSStyleValueType["kMinType"] = 8] = "kMinType";
    CSSStyleValueType[CSSStyleValueType["kMaxType"] = 9] = "kMaxType";
    CSSStyleValueType[CSSStyleValueType["kClampType"] = 10] = "kClampType";
    // End of CSSNumericValue subclasses
    CSSStyleValueType[CSSStyleValueType["kTransformType"] = 11] = "kTransformType";
    CSSStyleValueType[CSSStyleValueType["kPositionType"] = 12] = "kPositionType";
    CSSStyleValueType[CSSStyleValueType["kURLImageType"] = 13] = "kURLImageType";
    CSSStyleValueType[CSSStyleValueType["kColorType"] = 14] = "kColorType";
    CSSStyleValueType[CSSStyleValueType["kUnsupportedColorType"] = 15] = "kUnsupportedColorType";
    return CSSStyleValueType;
}({});
// function parseCSSStyleValue(propertyName: string, value: string): CSSStyleValue[] {
//   // const propertyId = cssPropertyID(propertyName);
//   // if (propertyId === CSSPropertyID.kInvalid) {
//   //   return [];
//   // }
//   // const customPropertyName = propertyId === CSSPropertyID.kVariable ? propertyName : null;
//   // return fromString(propertyId, customPropertyName, value);
//   return [];
// }
var stringToUnitType = function stringToUnitType(name) {
    return data.find(function(item) {
        return item.name === name;
    }).unit_type;
};
var unitFromName = function unitFromName(name) {
    if (!name) return UnitType.kUnknown;
    if (name === 'number') return UnitType.kNumber;
    if (name === 'percent' || name === '%') return UnitType.kPercentage;
    return stringToUnitType(name);
};
var unitTypeToUnitCategory = function unitTypeToUnitCategory(type) {
    switch(type){
        case UnitType.kNumber:
        case UnitType.kInteger:
            return UnitCategory.kUNumber;
        case UnitType.kPercentage:
            return UnitCategory.kUPercent;
        case UnitType.kPixels:
            // case UnitType.kCentimeters:
            // case UnitType.kMillimeters:
            // case UnitType.kQuarterMillimeters:
            // case UnitType.kInches:
            // case UnitType.kPoints:
            // case UnitType.kPicas:
            // case UnitType.kUserUnits:
            return UnitCategory.kULength;
        case UnitType.kMilliseconds:
        case UnitType.kSeconds:
            return UnitCategory.kUTime;
        case UnitType.kDegrees:
        case UnitType.kRadians:
        case UnitType.kGradians:
        case UnitType.kTurns:
            return UnitCategory.kUAngle;
        // case UnitType.kHertz:
        // case UnitType.kKilohertz:
        //   return UnitCategory.kUFrequency;
        // case UnitType.kDotsPerPixel:
        // case UnitType.kDotsPerInch:
        // case UnitType.kDotsPerCentimeter:
        //   return UnitCategory.kUResolution;
        default:
            return UnitCategory.kUOther;
    }
};
var canonicalUnitTypeForCategory = function canonicalUnitTypeForCategory(category) {
    // The canonical unit type is chosen according to the way
    // CSSPropertyParser.ValidUnit() chooses the default unit in each category
    // (based on unitflags).
    switch(category){
        case UnitCategory.kUNumber:
            return UnitType.kNumber;
        case UnitCategory.kULength:
            return UnitType.kPixels;
        case UnitCategory.kUPercent:
            return UnitType.kPercentage;
        // return UnitType.kUnknown; // Cannot convert between numbers and percent.
        case UnitCategory.kUTime:
            return UnitType.kSeconds;
        case UnitCategory.kUAngle:
            return UnitType.kDegrees;
        // case UnitCategory.kUFrequency:
        //   return UnitType.kHertz;
        // case UnitCategory.kUResolution:
        //   return UnitType.kDotsPerPixel;
        default:
            return UnitType.kUnknown;
    }
};
/**
 * @see https://chromium.googlesource.com/chromium/src/+/refs/heads/main/third_party/blink/renderer/core/css/css_primitive_value.cc#353
 */ var conversionToCanonicalUnitsScaleFactor = function conversionToCanonicalUnitsScaleFactor(unit_type) {
    var factor = 1.0;
    // FIXME: the switch can be replaced by an array of scale factors.
    switch(unit_type){
        // These are "canonical" units in their respective categories.
        case UnitType.kPixels:
        // case UnitType.kUserUnits:
        case UnitType.kDegrees:
        case UnitType.kSeconds:
            break;
        case UnitType.kMilliseconds:
            factor = 0.001;
            break;
        // case UnitType.kCentimeters:
        //   // factor = kCssPixelsPerCentimeter;
        //   break;
        // case UnitType.kDotsPerCentimeter:
        //   // factor = 1 / kCssPixelsPerCentimeter;
        //   break;
        // case UnitType.kMillimeters:
        //   // factor = kCssPixelsPerMillimeter;
        //   break;
        // case UnitType.kQuarterMillimeters:
        //   // factor = kCssPixelsPerQuarterMillimeter;
        //   break;
        // case UnitType.kInches:
        //   // factor = kCssPixelsPerInch;
        //   break;
        // case UnitType.kDotsPerInch:
        //   // factor = 1 / kCssPixelsPerInch;
        //   break;
        // case UnitType.kPoints:
        //   // factor = kCssPixelsPerPoint;
        //   break;
        // case UnitType.kPicas:
        //   // factor = kCssPixelsPerPica;
        //   break;
        case UnitType.kRadians:
            factor = 180 / Math.PI;
            break;
        case UnitType.kGradians:
            factor = 0.9;
            break;
        case UnitType.kTurns:
            factor = 360;
            break;
    }
    return factor;
};
var unitTypeToString = function unitTypeToString(type) {
    switch(type){
        case UnitType.kNumber:
        case UnitType.kInteger:
            // case UnitType.kUserUnits:
            return '';
        case UnitType.kPercentage:
            return '%';
        case UnitType.kEms:
            // case UnitType.kQuirkyEms:
            return 'em';
        // case UnitType.kExs:
        //   return 'ex';
        case UnitType.kRems:
            return 'rem';
        // case UnitType.kChs:
        //   return 'ch';
        case UnitType.kPixels:
            return 'px';
        // case UnitType.kCentimeters:
        //   return 'cm';
        // case UnitType.kDotsPerPixel:
        //   return 'dppx';
        // case UnitType.kDotsPerInch:
        //   return 'dpi';
        // case UnitType.kDotsPerCentimeter:
        //   return 'dpcm';
        // case UnitType.kMillimeters:
        //   return 'mm';
        // case UnitType.kQuarterMillimeters:
        //   return 'q';
        // case UnitType.kInches:
        //   return 'in';
        // case UnitType.kPoints:
        //   return 'pt';
        // case UnitType.kPicas:
        //   return 'pc';
        case UnitType.kDegrees:
            return 'deg';
        case UnitType.kRadians:
            return 'rad';
        case UnitType.kGradians:
            return 'grad';
        case UnitType.kMilliseconds:
            return 'ms';
        case UnitType.kSeconds:
            return 's';
        // case UnitType.kHertz:
        //   return 'hz';
        // case UnitType.kKilohertz:
        //   return 'khz';
        case UnitType.kTurns:
            return 'turn';
    }
    return '';
};
/**
 * CSSStyleValue is the base class for all CSS values accessible from Typed OM.
 * Values that are not yet supported as specific types are also returned as base CSSStyleValues.
 *
 * Spec @see https://drafts.css-houdini.org/css-typed-om/#stylevalue-objects
 * Docs @see https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleValue
 */ var CSSStyleValue = /*#__PURE__*/ function() {
    function CSSStyleValue() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSStyleValue);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSStyleValue, [
        {
            key: "toString",
            value: // protected abstract toCSSValue(): CSSValue;
            function toString() {
                return this.buildCSSText(Nested.kNo, ParenLess.kNo, '');
            }
        },
        {
            key: "isNumericValue",
            value: function isNumericValue() {
                return this.getType() >= CSSStyleValueType.kUnitType && this.getType() <= CSSStyleValueType.kClampType;
            }
        }
    ], [
        {
            key: "isAngle",
            value: // static parse(propertyName: string, value: string): CSSStyleValue {
            //   return parseCSSStyleValue(propertyName, value)[0];
            // }
            // static parseAll(propertyName: string, value: string): CSSStyleValue[] {
            //   return parseCSSStyleValue(propertyName, value);
            // }
            function isAngle(unit) {
                return unit === UnitType.kDegrees || unit === UnitType.kRadians || unit === UnitType.kGradians || unit === UnitType.kTurns;
            }
        },
        {
            key: "isLength",
            value: function isLength(type) {
                // return (type >= UnitType.kEms && type <= UnitType.kUserUnits) || type == UnitType.kQuirkyEms;
                return type >= UnitType.kEms && type < UnitType.kDegrees;
            }
        },
        {
            key: "isRelativeUnit",
            value: function isRelativeUnit(type) {
                return type === UnitType.kPercentage || type === UnitType.kEms || // type === UnitType.kExs ||
                type === UnitType.kRems;
            }
        },
        {
            key: "isTime",
            value: function isTime(unit) {
                return unit === UnitType.kSeconds || unit === UnitType.kMilliseconds;
            }
        }
    ]);
}();
/**
 * @see https://drafts.css-houdini.org/css-typed-om-1/#dom-csscolorvalue-colorspace
 */ /**
 * CSSColorValue is the base class used for the various CSS color interfaces.
 *
 * @see https://drafts.css-houdini.org/css-typed-om-1/#colorvalue-objects
 */ var CSSColorValue = /*#__PURE__*/ function(_CSSStyleValue) {
    function CSSColorValue(colorSpace) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSColorValue);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, CSSColorValue);
        _this.colorSpace = colorSpace;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(CSSColorValue, _CSSStyleValue);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSColorValue, [
        {
            key: "getType",
            value: function getType() {
                return CSSStyleValueType.kColorType;
            }
        },
        {
            key: "to",
            value: function to(colorSpace) {
                return this;
            }
        }
    ]);
}(CSSStyleValue);
var GradientType = /*#__PURE__*/ function(GradientType) {
    GradientType[GradientType["Constant"] = 0] = "Constant";
    GradientType[GradientType["LinearGradient"] = 1] = "LinearGradient";
    GradientType[GradientType["RadialGradient"] = 2] = "RadialGradient";
    return GradientType;
}({});
var CSSGradientValue = /*#__PURE__*/ function(_CSSStyleValue) {
    function CSSGradientValue(type, value) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSGradientValue);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, CSSGradientValue);
        _this.type = type;
        _this.value = value;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(CSSGradientValue, _CSSStyleValue);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSGradientValue, [
        {
            key: "clone",
            value: function clone() {
                return new CSSGradientValue(this.type, this.value);
            }
        },
        {
            key: "buildCSSText",
            value: function buildCSSText(n, p, result) {
                return result;
            }
        },
        {
            key: "getType",
            value: function getType() {
                return CSSStyleValueType.kColorType;
            }
        }
    ]);
}(CSSStyleValue);
/**
 * CSSKeywordValue represents CSS Values that are specified as keywords
 * eg. 'initial'
 * @see https://developer.mozilla.org/en-US/docs/Web/API/CSSKeywordValue
 * @see https://chromium.googlesource.com/chromium/src/+/refs/heads/main/third_party/blink/renderer/core/css/cssom/css_keyword_value.idl
 */ var CSSKeywordValue = /*#__PURE__*/ function(_CSSStyleValue) {
    function CSSKeywordValue(value) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSKeywordValue);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, CSSKeywordValue);
        _this.value = value;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(CSSKeywordValue, _CSSStyleValue);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSKeywordValue, [
        {
            key: "clone",
            value: function clone() {
                return new CSSKeywordValue(this.value);
            }
        },
        {
            key: "getType",
            value: function getType() {
                return CSSStyleValueType.kKeywordType;
            }
        },
        {
            key: "buildCSSText",
            value: function buildCSSText(n, p, result) {
                return result + this.value;
            }
        }
    ]);
}(CSSStyleValue);
var formatInfinityOrNaN = function formatInfinityOrNaN(number) {
    var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var result = '';
    if (!Number.isFinite(number)) {
        if (number > 0) result = 'infinity';
        else result = '-infinity';
    } else result = 'NaN';
    return result += suffix;
};
var toCanonicalUnit = function toCanonicalUnit(unit) {
    return canonicalUnitTypeForCategory(unitTypeToUnitCategory(unit));
};
/**
 * CSSNumericValue is the base class for numeric and length typed CSS Values.
 * @see https://drafts.css-houdini.org/css-typed-om/#numeric-objects
 * @see https://developer.mozilla.org/en-US/docs/Web/API/CSSNumericValue
 * @see https://chromium.googlesource.com/chromium/src/+/refs/heads/main/third_party/blink/renderer/core/css/cssom/css_numeric_value.idl
 */ /**
 * Represents numeric values that can be expressed as a single number plus a
 * unit (or a naked number or percentage).
 * @see https://drafts.css-houdini.org/css-typed-om/#cssunitvalue
 */ var CSSUnitValue = /*#__PURE__*/ function(_CSSStyleValue) {
    function CSSUnitValue(value) {
        var _this;
        var unitOrName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UnitType.kNumber;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSUnitValue);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, CSSUnitValue);
        var unit;
        if (typeof unitOrName === 'string') unit = unitFromName(unitOrName);
        else unit = unitOrName;
        _this.unit = unit;
        _this.value = value;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(CSSUnitValue, _CSSStyleValue);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSUnitValue, [
        {
            key: "clone",
            value: function clone() {
                return new CSSUnitValue(this.value, this.unit);
            }
        },
        {
            key: "equals",
            value: function equals(other) {
                var other_unit_value = other;
                return this.value === other_unit_value.value && this.unit === other_unit_value.unit;
            }
        },
        {
            key: "getType",
            value: function getType() {
                return CSSStyleValueType.kUnitType;
            }
        },
        {
            key: "convertTo",
            value: function convertTo(target_unit) {
                if (this.unit === target_unit) return new CSSUnitValue(this.value, this.unit);
                // Instead of defining the scale factors for every unit to every other unit,
                // we simply convert to the canonical unit and back since we already have
                // the scale factors for canonical units.
                var canonical_unit = toCanonicalUnit(this.unit);
                if (canonical_unit !== toCanonicalUnit(target_unit) || canonical_unit === UnitType.kUnknown) return null;
                var scale_factor = conversionToCanonicalUnitsScaleFactor(this.unit) / conversionToCanonicalUnitsScaleFactor(target_unit);
                return new CSSUnitValue(this.value * scale_factor, target_unit);
            }
        },
        {
            key: "buildCSSText",
            value: function buildCSSText(n, p, result) {
                var text;
                switch(this.unit){
                    case UnitType.kUnknown:
                        break;
                    case UnitType.kInteger:
                        text = Number(this.value).toFixed(0);
                        break;
                    case UnitType.kNumber:
                    case UnitType.kPercentage:
                    case UnitType.kEms:
                    // case UnitType.kQuirkyEms:
                    // case UnitType.kExs:
                    case UnitType.kRems:
                    // case UnitType.kChs:
                    case UnitType.kPixels:
                    // case UnitType.kCentimeters:
                    // case UnitType.kDotsPerPixel:
                    // case UnitType.kDotsPerInch:
                    // case UnitType.kDotsPerCentimeter:
                    // case UnitType.kMillimeters:
                    // case UnitType.kQuarterMillimeters:
                    // case UnitType.kInches:
                    // case UnitType.kPoints:
                    // case UnitType.kPicas:
                    // case UnitType.kUserUnits:
                    case UnitType.kDegrees:
                    case UnitType.kRadians:
                    case UnitType.kGradians:
                    case UnitType.kMilliseconds:
                    case UnitType.kSeconds:
                    // case UnitType.kHertz:
                    // case UnitType.kKilohertz:
                    case UnitType.kTurns:
                        // case UnitType.kContainerMax: { // case UnitType.kContainerMin: // case UnitType.kContainerBlockSize: // case UnitType.kContainerInlineSize: // case UnitType.kContainerHeight: // case UnitType.kContainerWidth: // case UnitType.kDynamicViewportMax: // case UnitType.kDynamicViewportMin: // case UnitType.kDynamicViewportBlockSize: // case UnitType.kDynamicViewportInlineSize: // case UnitType.kDynamicViewportHeight: // case UnitType.kDynamicViewportWidth: // case UnitType.kLargeViewportMax: // case UnitType.kLargeViewportMin: // case UnitType.kLargeViewportBlockSize: // case UnitType.kLargeViewportInlineSize: // case UnitType.kLargeViewportHeight: // case UnitType.kLargeViewportWidth: // case UnitType.kSmallViewportMax: // case UnitType.kSmallViewportMin: // case UnitType.kSmallViewportBlockSize: // case UnitType.kSmallViewportInlineSize: // case UnitType.kSmallViewportHeight: // case UnitType.kSmallViewportWidth: // case UnitType.kViewportMax: // case UnitType.kViewportMin: // case UnitType.kViewportBlockSize: // case UnitType.kViewportInlineSize: // case UnitType.kViewportHeight: // case UnitType.kViewportWidth: // case UnitType.kFraction:
                        var kMinInteger = -999999;
                        var kMaxInteger = 999999;
                        var value = this.value;
                        var unit = unitTypeToString(this.unit);
                        if (value < kMinInteger || value > kMaxInteger) {
                            var _unit = unitTypeToString(this.unit);
                            if (!Number.isFinite(value) || Number.isNaN(value)) text = formatInfinityOrNaN(value, _unit);
                            else text = value + (_unit || '');
                        } else text = "".concat(value).concat(unit);
                }
                result += text;
                return result;
            }
        }
    ]);
}(CSSStyleValue);
var Opx = new CSSUnitValue(0, 'px');
new CSSUnitValue(1, 'px');
var Odeg = new CSSUnitValue(0, 'deg');
/**
 * The CSSRGB class represents the CSS rgb()/rgba() functions.
 *
 * @see https://drafts.css-houdini.org/css-typed-om-1/#cssrgb
 */ var CSSRGB = /*#__PURE__*/ function(_CSSColorValue) {
    function CSSRGB(r, g, b) {
        var _this;
        var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        var isNone = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSRGB);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, CSSRGB, [
            'rgb'
        ]);
        _this.r = r;
        _this.g = g;
        _this.b = b;
        _this.alpha = alpha;
        _this.isNone = isNone;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(CSSRGB, _CSSColorValue);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSRGB, [
        {
            key: "clone",
            value: function clone() {
                return new CSSRGB(this.r, this.g, this.b, this.alpha);
            }
        },
        {
            key: "buildCSSText",
            value: function buildCSSText(n, p, result) {
                return "".concat(result, "rgba(").concat(this.r, ",").concat(this.g, ",").concat(this.b, ",").concat(this.alpha, ")");
            }
        }
    ]);
}(CSSColorValue);
/**
 * CSSKeywordValue
 */ var unsetKeywordValue = new CSSKeywordValue('unset');
var initialKeywordValue = new CSSKeywordValue('initial');
var inheritKeywordValue = new CSSKeywordValue('inherit');
var keywordCache = {
    '': unsetKeywordValue,
    unset: unsetKeywordValue,
    initial: initialKeywordValue,
    inherit: inheritKeywordValue
};
var getOrCreateKeyword = function getOrCreateKeyword(name) {
    if (!keywordCache[name]) keywordCache[name] = new CSSKeywordValue(name);
    return keywordCache[name];
};
/**
 * CSSColor
 */ var noneColor = new CSSRGB(0, 0, 0, 0, true);
var transparentColor = new CSSRGB(0, 0, 0, 0);
var getOrCreateRGBA = memoize(function(r, g, b, a) {
    return new CSSRGB(r, g, b, a);
}, function(r, g, b, a) {
    return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(a, ")");
});
// export const getOrCreateUnitValue = memoize(
//   (value: number, unitOrName: UnitType | string = UnitType.kNumber) => {
//     return new CSSUnitValue(value, unitOrName);
//   },
//   (value: number, unitOrName: UnitType | string = UnitType.kNumber) => {
//     return `${value}${unitOrName}`;
//   },
// );
var getOrCreateUnitValue = function getOrCreateUnitValue(value) {
    var unitOrName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : UnitType.kNumber;
    return new CSSUnitValue(value, unitOrName);
};
new CSSUnitValue(50, '%');
/**
 * borrow from gradient-parser, but we delete some browser compatible prefix such as `-webkit-`
 * @see https://github.com/rafaelcaricio/gradient-parser
 */ function colorStopToString(colorStop) {
    var type = colorStop.type, value = colorStop.value;
    if (type === 'hex') return "#".concat(value);
    if (type === 'literal') return value;
    if (type === 'rgb') return "rgb(".concat(value.join(','), ")");
    return "rgba(".concat(value.join(','), ")");
}
var parseGradient$1 = function() {
    var tokens = {
        linearGradient: /^(linear\-gradient)/i,
        repeatingLinearGradient: /^(repeating\-linear\-gradient)/i,
        radialGradient: /^(radial\-gradient)/i,
        repeatingRadialGradient: /^(repeating\-radial\-gradient)/i,
        /**
     * @see https://projects.verou.me/conic-gradient/
     */ conicGradient: /^(conic\-gradient)/i,
        sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|top (left|right)|bottom (left|right)|left|right|top|bottom)/i,
        extentKeywords: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/,
        positionKeywords: /^(left|center|right|top|bottom)/i,
        pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
        percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))\%/,
        emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
        angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
        startCall: /^\(/,
        endCall: /^\)/,
        comma: /^,/,
        hexColor: /^\#([0-9a-fA-F]+)/,
        literalColor: /^([a-zA-Z]+)/,
        rgbColor: /^rgb/i,
        rgbaColor: /^rgba/i,
        number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    };
    var input = '';
    function error(msg) {
        throw new Error("".concat(input, ": ").concat(msg));
    }
    function getAST() {
        var ast = matchListDefinitions();
        if (input.length > 0) error('Invalid input not EOF');
        return ast;
    }
    function matchListDefinitions() {
        return matchListing(matchDefinition);
    }
    function matchDefinition() {
        return matchGradient('linear-gradient', tokens.linearGradient, matchLinearOrientation) || matchGradient('repeating-linear-gradient', tokens.repeatingLinearGradient, matchLinearOrientation) || matchGradient('radial-gradient', tokens.radialGradient, matchListRadialOrientations) || matchGradient('repeating-radial-gradient', tokens.repeatingRadialGradient, matchListRadialOrientations) || matchGradient('conic-gradient', tokens.conicGradient, matchListRadialOrientations);
    }
    function matchGradient(gradientType, pattern, orientationMatcher) {
        return matchCall(pattern, function(captures) {
            var orientation = orientationMatcher();
            if (orientation) {
                if (!scan(tokens.comma)) error('Missing comma before color stops');
            }
            return {
                type: gradientType,
                orientation: orientation,
                colorStops: matchListing(matchColorStop)
            };
        });
    }
    function matchCall(pattern, callback) {
        var captures = scan(pattern);
        if (captures) {
            if (!scan(tokens.startCall)) error('Missing (');
            var result = callback(captures);
            if (!scan(tokens.endCall)) error('Missing )');
            return result;
        }
    }
    function matchLinearOrientation() {
        return matchSideOrCorner() || matchAngle();
    }
    function matchSideOrCorner() {
        return match('directional', tokens.sideOrCorner, 1);
    }
    function matchAngle() {
        return match('angular', tokens.angleValue, 1);
    }
    function matchListRadialOrientations() {
        var radialOrientations;
        var radialOrientation = matchRadialOrientation();
        var lookaheadCache;
        if (radialOrientation) {
            radialOrientations = [];
            radialOrientations.push(radialOrientation);
            lookaheadCache = input;
            if (scan(tokens.comma)) {
                radialOrientation = matchRadialOrientation();
                if (radialOrientation) radialOrientations.push(radialOrientation);
                else input = lookaheadCache;
            }
        }
        return radialOrientations;
    }
    function matchRadialOrientation() {
        var radialType = matchCircle() || matchEllipse();
        if (radialType) // @ts-ignore
        radialType.at = matchAtPosition();
        else {
            var extent = matchExtentKeyword();
            if (extent) {
                radialType = extent;
                var positionAt = matchAtPosition();
                if (positionAt) // @ts-ignore
                radialType.at = positionAt;
            } else {
                var defaultPosition = matchPositioning();
                if (defaultPosition) radialType = {
                    type: 'default-radial',
                    // @ts-ignore
                    at: defaultPosition
                };
            }
        }
        return radialType;
    }
    function matchCircle() {
        var circle = match('shape', /^(circle)/i, 0);
        if (circle) // @ts-ignore
        circle.style = matchLength() || matchExtentKeyword();
        return circle;
    }
    function matchEllipse() {
        var ellipse = match('shape', /^(ellipse)/i, 0);
        if (ellipse) // @ts-ignore
        ellipse.style = matchDistance() || matchExtentKeyword();
        return ellipse;
    }
    function matchExtentKeyword() {
        return match('extent-keyword', tokens.extentKeywords, 1);
    }
    function matchAtPosition() {
        if (match('position', /^at/, 0)) {
            var positioning = matchPositioning();
            if (!positioning) error('Missing positioning value');
            return positioning;
        }
    }
    function matchPositioning() {
        var location = matchCoordinates();
        if (location.x || location.y) return {
            type: 'position',
            value: location
        };
    }
    function matchCoordinates() {
        return {
            x: matchDistance(),
            y: matchDistance()
        };
    }
    function matchListing(matcher) {
        var captures = matcher();
        var result = [];
        if (captures) {
            result.push(captures);
            while(scan(tokens.comma)){
                captures = matcher();
                if (captures) result.push(captures);
                else error('One extra comma');
            }
        }
        return result;
    }
    function matchColorStop() {
        var color = matchColor();
        if (!color) error('Expected color definition');
        color.length = matchDistance();
        return color;
    }
    function matchColor() {
        return matchHexColor() || matchRGBAColor() || matchRGBColor() || matchLiteralColor();
    }
    function matchLiteralColor() {
        return match('literal', tokens.literalColor, 0);
    }
    function matchHexColor() {
        return match('hex', tokens.hexColor, 1);
    }
    function matchRGBColor() {
        return matchCall(tokens.rgbColor, function() {
            return {
                type: 'rgb',
                value: matchListing(matchNumber)
            };
        });
    }
    function matchRGBAColor() {
        return matchCall(tokens.rgbaColor, function() {
            return {
                type: 'rgba',
                value: matchListing(matchNumber)
            };
        });
    }
    function matchNumber() {
        return scan(tokens.number)[1];
    }
    function matchDistance() {
        return match('%', tokens.percentageValue, 1) || matchPositionKeyword() || matchLength();
    }
    function matchPositionKeyword() {
        return match('position-keyword', tokens.positionKeywords, 1);
    }
    function matchLength() {
        return match('px', tokens.pixelValue, 1) || match('em', tokens.emValue, 1);
    }
    function match(type, pattern, captureIndex) {
        var captures = scan(pattern);
        if (captures) return {
            type: type,
            value: captures[captureIndex]
        };
    }
    function scan(regexp) {
        var blankCaptures = /^[\n\r\t\s]+/.exec(input);
        if (blankCaptures) consume(blankCaptures[0].length);
        var captures = regexp.exec(input);
        if (captures) consume(captures[0].length);
        return captures;
    }
    function consume(size) {
        input = input.substring(size);
    }
    return function(code) {
        input = code;
        return getAST();
    };
}();
function computeLinearGradient(min, width, height, angle) {
    var rad = deg2rad(angle.value);
    var rx = 0;
    var ry = 0;
    var rcx = rx + width / 2;
    var rcy = ry + height / 2;
    // get the length of gradient line
    // @see https://observablehq.com/@danburzo/css-gradient-line
    var length = Math.abs(width * Math.cos(rad)) + Math.abs(height * Math.sin(rad));
    var x1 = min[0] + rcx - Math.cos(rad) * length / 2;
    var y1 = min[1] + rcy - Math.sin(rad) * length / 2;
    var x2 = min[0] + rcx + Math.cos(rad) * length / 2;
    var y2 = min[1] + rcy + Math.sin(rad) * length / 2;
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function computeRadialGradient(min, width, height, cx, cy, size) {
    // 'px'
    var x = cx.value;
    var y = cy.value;
    // TODO: 'em'
    // '%'
    if (cx.unit === UnitType.kPercentage) x = cx.value / 100 * width;
    if (cy.unit === UnitType.kPercentage) y = cy.value / 100 * height;
    // default to farthest-side
    var r = Math.max((0, $aoFex.distanceSquareRoot)([
        0,
        0
    ], [
        x,
        y
    ]), (0, $aoFex.distanceSquareRoot)([
        0,
        height
    ], [
        x,
        y
    ]), (0, $aoFex.distanceSquareRoot)([
        width,
        height
    ], [
        x,
        y
    ]), (0, $aoFex.distanceSquareRoot)([
        width,
        0
    ], [
        x,
        y
    ]));
    if (size) {
        if (size instanceof CSSUnitValue) r = size.value;
        else if (size instanceof CSSKeywordValue) {
            // @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/CSS_Images/Using_CSS_gradients#example_closest-side_for_circles
            if (size.value === 'closest-side') r = Math.min(x, width - x, y, height - y);
            else if (size.value === 'farthest-side') r = Math.max(x, width - x, y, height - y);
            else if (size.value === 'closest-corner') r = Math.min((0, $aoFex.distanceSquareRoot)([
                0,
                0
            ], [
                x,
                y
            ]), (0, $aoFex.distanceSquareRoot)([
                0,
                height
            ], [
                x,
                y
            ]), (0, $aoFex.distanceSquareRoot)([
                width,
                height
            ], [
                x,
                y
            ]), (0, $aoFex.distanceSquareRoot)([
                width,
                0
            ], [
                x,
                y
            ]));
        }
    }
    return {
        x: x + min[0],
        y: y + min[1],
        r: r
    };
}
var regexLG = /^l\s*\(\s*([\d.]+)\s*\)\s*(.*)/i;
var regexRG = /^r\s*\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)\s*\)\s*(.*)/i;
var regexPR = /^p\s*\(\s*([axyn])\s*\)\s*(.*)/i;
var regexColorStop = /[\d.]+:(#[^\s]+|[^\)]+\))/gi;
function spaceColorStops(colorStops) {
    var _colorStops$length;
    var length = colorStops.length;
    colorStops[length - 1].length = (_colorStops$length = colorStops[length - 1].length) !== null && _colorStops$length !== void 0 ? _colorStops$length : {
        type: '%',
        value: '100'
    };
    if (length > 1) {
        var _colorStops$0$length;
        colorStops[0].length = (_colorStops$0$length = colorStops[0].length) !== null && _colorStops$0$length !== void 0 ? _colorStops$0$length : {
            type: '%',
            value: '0'
        };
    }
    var previousIndex = 0;
    var previousOffset = Number(colorStops[0].length.value);
    for(var i = 1; i < length; i++){
        var _colorStops$i$length;
        // support '%' & 'px'
        var offset = (_colorStops$i$length = colorStops[i].length) === null || _colorStops$i$length === void 0 ? void 0 : _colorStops$i$length.value;
        if (!(0, $geZBG.default)(offset) && !(0, $geZBG.default)(previousOffset)) {
            for(var j = 1; j < i - previousIndex; j++)colorStops[previousIndex + j].length = {
                type: '%',
                value: "".concat(previousOffset + (Number(offset) - previousOffset) * j / (i - previousIndex))
            };
            previousIndex = i;
            previousOffset = Number(offset);
        }
    }
}
// The position of the gradient line's starting point.
// different from CSS side(to top) @see https://developer.mozilla.org/en-US/docs/Web/CSS/gradient/linear-gradient#values
var SideOrCornerToDegMap = {
    left: 180,
    top: -90,
    bottom: 90,
    right: 0,
    'left top': 225,
    'top left': 225,
    'left bottom': 135,
    'bottom left': 135,
    'right top': -45,
    'top right': -45,
    'right bottom': 45,
    'bottom right': 45
};
var angleToDeg = memoize(function(orientation) {
    var angle;
    if (orientation.type === 'angular') angle = Number(orientation.value);
    else angle = SideOrCornerToDegMap[orientation.value] || 0;
    return getOrCreateUnitValue(angle, 'deg');
});
var positonToCSSUnitValue = memoize(function(position) {
    var cx = 50;
    var cy = 50;
    var unitX = '%';
    var unitY = '%';
    if ((position === null || position === void 0 ? void 0 : position.type) === 'position') {
        var _position$value = position.value, x = _position$value.x, y = _position$value.y;
        if ((x === null || x === void 0 ? void 0 : x.type) === 'position-keyword') {
            if (x.value === 'left') cx = 0;
            else if (x.value === 'center') cx = 50;
            else if (x.value === 'right') cx = 100;
            else if (x.value === 'top') cy = 0;
            else if (x.value === 'bottom') cy = 100;
        }
        if ((y === null || y === void 0 ? void 0 : y.type) === 'position-keyword') {
            if (y.value === 'left') cx = 0;
            else if (y.value === 'center') cy = 50;
            else if (y.value === 'right') cx = 100;
            else if (y.value === 'top') cy = 0;
            else if (y.value === 'bottom') cy = 100;
        }
        if ((x === null || x === void 0 ? void 0 : x.type) === 'px' || (x === null || x === void 0 ? void 0 : x.type) === '%' || (x === null || x === void 0 ? void 0 : x.type) === 'em') {
            unitX = x === null || x === void 0 ? void 0 : x.type;
            cx = Number(x.value);
        }
        if ((y === null || y === void 0 ? void 0 : y.type) === 'px' || (y === null || y === void 0 ? void 0 : y.type) === '%' || (y === null || y === void 0 ? void 0 : y.type) === 'em') {
            unitY = y === null || y === void 0 ? void 0 : y.type;
            cy = Number(y.value);
        }
    }
    return {
        cx: getOrCreateUnitValue(cx, unitX),
        cy: getOrCreateUnitValue(cy, unitY)
    };
});
var parseGradient = memoize(function(colorStr) {
    if (colorStr.indexOf('linear') > -1 || colorStr.indexOf('radial') > -1) {
        var ast = parseGradient$1(colorStr);
        return ast.map(function(_ref) {
            var type = _ref.type, orientation = _ref.orientation, colorStops = _ref.colorStops;
            spaceColorStops(colorStops);
            var steps = colorStops.map(function(colorStop) {
                // TODO: only support % for now, should calc percentage of axis length when using px/em
                return {
                    offset: getOrCreateUnitValue(Number(colorStop.length.value), '%'),
                    color: colorStopToString(colorStop)
                };
            });
            if (type === 'linear-gradient') return new CSSGradientValue(GradientType.LinearGradient, {
                angle: orientation ? angleToDeg(orientation) : Odeg,
                steps: steps
            });
            if (type === 'radial-gradient') {
                if (!orientation) orientation = [
                    {
                        type: 'shape',
                        value: 'circle'
                    }
                ];
                if (orientation[0].type === 'shape' && orientation[0].value === 'circle') {
                    var _positonToCSSUnitValu = positonToCSSUnitValue(orientation[0].at), cx = _positonToCSSUnitValu.cx, cy = _positonToCSSUnitValu.cy;
                    var size;
                    if (orientation[0].style) {
                        var _orientation$0$style = orientation[0].style, _type = _orientation$0$style.type, value = _orientation$0$style.value;
                        if (_type === 'extent-keyword') size = getOrCreateKeyword(value);
                        else size = getOrCreateUnitValue(value, _type);
                    }
                    return new CSSGradientValue(GradientType.RadialGradient, {
                        cx: cx,
                        cy: cy,
                        size: size,
                        steps: steps
                    });
                }
            // TODO: support ellipse shape
            // TODO: repeating-linear-gradient & repeating-radial-gradient
            // } else if (type === 'repeating-linear-gradient') {
            // } else if (type === 'repeating-radial-gradient') {
            }
            return undefined;
        });
    }
    // legacy format, should be deprecated later
    var type = colorStr[0];
    if (colorStr[1] === '(' || colorStr[2] === '(') {
        if (type === 'l') {
            var arr = regexLG.exec(colorStr);
            if (arr) {
                var _arr$2$match;
                var steps = ((_arr$2$match = arr[2].match(regexColorStop)) === null || _arr$2$match === void 0 ? void 0 : _arr$2$match.map(function(stop) {
                    return stop.split(':');
                })) || [];
                return [
                    new CSSGradientValue(GradientType.LinearGradient, {
                        angle: getOrCreateUnitValue(parseFloat(arr[1]), 'deg'),
                        steps: steps.map(function(_ref2) {
                            var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref2, 2), offset = _ref3[0], color = _ref3[1];
                            return {
                                offset: getOrCreateUnitValue(Number(offset) * 100, '%'),
                                color: color
                            };
                        })
                    })
                ];
            }
        } else if (type === 'r') {
            var parsedRadialGradient = parseRadialGradient(colorStr);
            if (parsedRadialGradient) {
                if ((0, $kVcyu.default)(parsedRadialGradient)) colorStr = parsedRadialGradient;
                else return [
                    new CSSGradientValue(GradientType.RadialGradient, parsedRadialGradient)
                ];
            }
        } else if (type === 'p') return parsePattern(colorStr);
    }
});
function parseRadialGradient(gradientStr) {
    var arr = regexRG.exec(gradientStr);
    if (arr) {
        var _arr$4$match;
        var steps = ((_arr$4$match = arr[4].match(regexColorStop)) === null || _arr$4$match === void 0 ? void 0 : _arr$4$match.map(function(stop) {
            return stop.split(':');
        })) || [];
        return {
            cx: getOrCreateUnitValue(50, '%'),
            cy: getOrCreateUnitValue(50, '%'),
            steps: steps.map(function(_ref4) {
                var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref4, 2), offset = _ref5[0], color = _ref5[1];
                return {
                    offset: getOrCreateUnitValue(Number(offset) * 100, '%'),
                    color: color
                };
            })
        };
    }
    return null;
}
function parsePattern(patternStr) {
    var arr = regexPR.exec(patternStr);
    if (arr) {
        var repetition = arr[1];
        var src = arr[2];
        switch(repetition){
            case 'a':
                repetition = 'repeat';
                break;
            case 'x':
                repetition = 'repeat-x';
                break;
            case 'y':
                repetition = 'repeat-y';
                break;
            case 'n':
                repetition = 'no-repeat';
                break;
            default:
                repetition = 'no-repeat';
        }
        return {
            image: src,
            // @ts-ignore
            repetition: repetition
        };
    }
    return null;
}
/**
 * @see https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/createPattern
 */ function isCSSGradientValue(object) {
    return !!object.type && !!object.value;
}
function isPattern(object) {
    return object && !!object.image;
}
function isCSSRGB(object) {
    return object && !(0, $geZBG.default)(object.r) && !(0, $geZBG.default)(object.g) && !(0, $geZBG.default)(object.b);
}
/**
 * @see https://github.com/WebKit/WebKit/blob/main/Source/WebCore/css/parser/CSSParser.cpp#L97
 */ var parseColor = memoize(function(colorStr) {
    if (isPattern(colorStr)) return (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
        repetition: 'repeat'
    }, colorStr);
    if ((0, $geZBG.default)(colorStr)) colorStr = '';
    if (colorStr === 'transparent') // transparent black
    return transparentColor;
    if (colorStr === 'currentColor') // @see https://github.com/adobe-webplatform/Snap.svg/issues/526
    colorStr = 'black';
    else if (colorStr === 'none') return noneColor;
    // support CSS gradient syntax
    var g = parseGradient(colorStr);
    if (g) return g;
    // constants
    var color$1 = color(colorStr);
    var rgba = [
        0,
        0,
        0,
        0
    ];
    if (color$1 !== null) {
        rgba[0] = color$1.r || 0;
        rgba[1] = color$1.g || 0;
        rgba[2] = color$1.b || 0;
        rgba[3] = color$1.opacity;
    }
    // return new CSSRGB(...rgba);
    return getOrCreateRGBA.apply(void 0, rgba);
});
function mergeColors(left, right) {
    // only support constant value, exclude gradient & pattern
    if (!isCSSRGB(left) || !isCSSRGB(right)) return;
    return [
        [
            Number(left.r),
            Number(left.g),
            Number(left.b),
            Number(left.alpha)
        ],
        [
            Number(right.r),
            Number(right.g),
            Number(right.b),
            Number(right.alpha)
        ],
        function(color) {
            var rgba = color.slice();
            if (rgba[3]) for(var i = 0; i < 3; i++)rgba[i] = Math.round((0, $8hhuV.default)(rgba[i], 0, 255));
            rgba[3] = (0, $8hhuV.default)(rgba[3], 0, 1);
            return "rgba(".concat(rgba.join(','), ")");
        }
    ];
}
function parseDimension(unitRegExp, string) {
    if ((0, $geZBG.default)(string)) return getOrCreateUnitValue(0, 'px');
    string = "".concat(string).trim().toLowerCase();
    if (isFinite(Number(string))) {
        if ('px'.search(unitRegExp) >= 0) return getOrCreateUnitValue(Number(string), 'px');
        if ('deg'.search(unitRegExp) >= 0) return getOrCreateUnitValue(Number(string), 'deg');
    }
    var matchedUnits = [];
    string = string.replace(unitRegExp, function(match) {
        matchedUnits.push(match);
        return "U".concat(match);
    });
    var taggedUnitRegExp = "U(".concat(unitRegExp.source, ")");
    return matchedUnits.map(function(unit) {
        return getOrCreateUnitValue(Number(string.replace(new RegExp("U".concat(unit), 'g'), '').replace(new RegExp(taggedUnitRegExp, 'g'), '*0')), unit);
    })[0];
}
/**
 * <length>
 * @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/length
 * length with only absolute unit, eg. 1px
 */ var parseLengthUnmemoize = function parseLengthUnmemoize(css) {
    return parseDimension(new RegExp('px', 'g'), css);
};
var parseLength = memoize(parseLengthUnmemoize);
/**
 * <percentage>
 * @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/percentage
 */ var parserPercentageUnmemoize = function parserPercentageUnmemoize(css) {
    return parseDimension(new RegExp('%', 'g'), css);
};
memoize(parserPercentageUnmemoize);
/**
 * length with absolute or relative unit,
 * eg. 1px, 0.7em, 50%, calc(100% - 200px);
 *
 * @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/length-percentage
 */ var parseLengthOrPercentageUnmemoize = function parseLengthOrPercentageUnmemoize(css) {
    if ((0, $jyI49.default)(css) || isFinite(Number(css))) // Number(css) is NaN
    return getOrCreateUnitValue(Number(css) || 0, 'px');
    return parseDimension(new RegExp('px|%|em|rem', 'g'), css);
};
var parseLengthOrPercentage = memoize(parseLengthOrPercentageUnmemoize);
var parseAngleUnmemoize = function parseAngleUnmemoize(css) {
    return parseDimension(new RegExp('deg|rad|grad|turn', 'g'), css);
};
var parseAngle = memoize(parseAngleUnmemoize);
/**
 * merge CSSUnitValue
 *
 * @example
 * 10px + 20px = 30px
 * 10deg + 10rad
 * 10% + 20% = 30%
 */ function mergeDimensions(left, right, target, nonNegative) {
    var index = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var unit = '';
    var leftValue = left.value || 0;
    var rightValue = right.value || 0;
    var canonicalUnit = toCanonicalUnit(left.unit);
    var leftCanonicalUnitValue = left.convertTo(canonicalUnit);
    var rightCanonicalUnitValue = right.convertTo(canonicalUnit);
    if (leftCanonicalUnitValue && rightCanonicalUnitValue) {
        leftValue = leftCanonicalUnitValue.value;
        rightValue = rightCanonicalUnitValue.value;
        unit = unitTypeToString(left.unit);
    } else if (CSSUnitValue.isLength(left.unit) || CSSUnitValue.isLength(right.unit)) {
        leftValue = convertPercentUnit(left, index, target);
        rightValue = convertPercentUnit(right, index, target);
        unit = 'px';
    }
    return [
        leftValue,
        rightValue,
        function(value) {
            if (nonNegative) value = Math.max(value, 0);
            return value + unit;
        }
    ];
}
function convertAngleUnit(value) {
    var deg = 0;
    if (value.unit === UnitType.kDegrees) deg = value.value;
    else if (value.unit === UnitType.kRadians) deg = rad2deg(Number(value.value));
    else if (value.unit === UnitType.kTurns) deg = turn2deg(Number(value.value));
    else if (value.value) deg = value.value;
    return deg;
}
function parseDimensionArrayFormat(string, size) {
    var parsed;
    if (Array.isArray(string)) // [1, '2px', 3]
    parsed = string.map(function(segment) {
        return Number(segment);
    });
    else if ((0, $kVcyu.default)(string)) parsed = string.split(' ').map(function(segment) {
        return Number(segment);
    });
    else if ((0, $jyI49.default)(string)) parsed = [
        string
    ];
    if (size === 2) {
        if (parsed.length === 1) return [
            parsed[0],
            parsed[0]
        ];
        return [
            parsed[0],
            parsed[1]
        ];
    }
    if (size === 4) {
        if (parsed.length === 1) return [
            parsed[0],
            parsed[0],
            parsed[0],
            parsed[0]
        ];
        if (parsed.length === 2) return [
            parsed[0],
            parsed[1],
            parsed[0],
            parsed[1]
        ];
        if (parsed.length === 3) return [
            parsed[0],
            parsed[1],
            parsed[2],
            parsed[1]
        ];
        return [
            parsed[0],
            parsed[1],
            parsed[2],
            parsed[3]
        ];
    }
    if (size === 'even' && parsed.length % 2 === 1) return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(parsed), (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(parsed));
    return parsed;
}
// export function mergeDimensionList(
//   left: CSSUnitValue[],
//   right: CSSUnitValue[],
//   target: IElement | null,
// ): [number[], number[], (list: number[]) => string] | undefined {
//   if (left.length !== right.length) {
//     return;
//   }
//   const unit = left[0].unit;
//   return [
//     left.map((l) => l.value),
//     right.map((l) => l.value),
//     (values: number[]) => {
//       return values.map((n) => new CSSUnitValue(n, unit)).join(' ');
//     },
//   ];
// }
function convertPercentUnit(valueWithUnit, vec3Index, target) {
    var useMin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (valueWithUnit.unit === UnitType.kPixels) return Number(valueWithUnit.value);
    if (valueWithUnit.unit === UnitType.kPercentage && target) {
        var bounds = target.nodeName === Shape.GROUP ? target.getLocalBounds() : target.getGeometryBounds();
        return (useMin ? bounds.min[vec3Index] : 0) + valueWithUnit.value / 100 * bounds.halfExtents[vec3Index] * 2;
    }
    return 0;
}
var parseParam = function parseParam(css) {
    return parseDimension(/deg|rad|grad|turn|px|%/g, css);
};
var supportedFilters = [
    'blur',
    'brightness',
    'drop-shadow',
    'contrast',
    'grayscale',
    'sepia',
    'saturate',
    'hue-rotate',
    'invert'
];
function parseFilter() {
    var filterStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    filterStr = filterStr.toLowerCase().trim();
    if (filterStr === 'none') return [];
    var filterRegExp = /\s*([\w-]+)\(([^)]*)\)/g;
    var result = [];
    var match;
    var prevLastIndex = 0;
    while(match = filterRegExp.exec(filterStr)){
        if (match.index !== prevLastIndex) return [];
        prevLastIndex = match.index + match[0].length;
        if (supportedFilters.indexOf(match[1]) > -1) result.push({
            name: match[1],
            params: match[2].split(' ').map(function(p) {
                return parseParam(p) || parseColor(p);
            })
        });
        if (filterRegExp.lastIndex === filterStr.length) return result;
    }
    return [];
}
function numberToString(x) {
    // scale(0.00000001) -> scale(0)
    // return x.toFixed(6).replace(/0+$/, '').replace(/\.$/, '');
    return x.toString();
}
/**
 * parse string or number to CSSUnitValue(numeric)
 *
 * eg.
 * * 0 -> CSSUnitValue(0)
 * * '2' -> CSSUnitValue(2)
 */ var parseNumberUnmemoize = function parseNumberUnmemoize(string) {
    if (typeof string === 'number') return getOrCreateUnitValue(string);
    if (/^\s*[-+]?(\d*\.)?\d+\s*$/.test(string)) return getOrCreateUnitValue(Number(string));
    return getOrCreateUnitValue(0);
};
var parseNumber = memoize(parseNumberUnmemoize);
memoize(function(string) {
    if ((0, $kVcyu.default)(string)) return string.split(' ').map(parseNumber);
    return string.map(parseNumber);
});
function mergeNumbers(left, right) {
    return [
        left,
        right,
        numberToString
    ];
}
function clampedMergeNumbers(min, max) {
    return function(left, right) {
        return [
            left,
            right,
            function(x) {
                return numberToString((0, $8hhuV.default)(x, min, max));
            }
        ];
    };
}
function mergeNumberLists(left, right) {
    if (left.length !== right.length) return;
    return [
        left,
        right,
        function(numberList) {
            return numberList;
        }
    ];
}
function getOrCalculatePathTotalLength(path) {
    if (path.parsedStyle.d.totalLength === 0) path.parsedStyle.d.totalLength = (0, $iJzUi.getTotalLength)(path.parsedStyle.d.absolutePath);
    return path.parsedStyle.d.totalLength;
}
function getOrCalculatePolylineTotalLength(polyline) {
    if (polyline.parsedStyle.points.totalLength === 0) polyline.parsedStyle.points.totalLength = (0, $11s8J.polylineLength)(polyline.parsedStyle.points.points);
    return polyline.parsedStyle.points.totalLength;
}
function removeRedundantMCommand(path) {
    for(var i = 0; i < path.length; i++){
        var prevSegment = path[i - 1];
        var segment = path[i];
        var cmd = segment[0];
        if (cmd === 'M') {
            if (prevSegment) {
                var prevCmd = prevSegment[0];
                var srcPoint = [
                    segment[1],
                    segment[2]
                ];
                var destPoint = void 0;
                if (prevCmd === 'L' || prevCmd === 'M') destPoint = [
                    prevSegment[1],
                    prevSegment[2]
                ];
                else if (prevCmd === 'C' || prevCmd === 'A' || prevCmd === 'Q') destPoint = [
                    prevSegment[prevSegment.length - 2],
                    prevSegment[prevSegment.length - 1]
                ];
                if (destPoint && isSamePoint(srcPoint, destPoint)) {
                    path.splice(i, 1);
                    i--;
                }
            }
        }
    }
}
function hasArcOrBezier(path) {
    var hasArc = false;
    var count = path.length;
    for(var i = 0; i < count; i++){
        var params = path[i];
        var cmd = params[0];
        if (cmd === 'C' || cmd === 'A' || cmd === 'Q') {
            hasArc = true;
            break;
        }
    }
    return hasArc;
}
function extractPolygons(pathArray) {
    var polygons = [];
    var polylines = [];
    var points = []; // 防止第一个命令不是 'M'
    for(var i = 0; i < pathArray.length; i++){
        var params = pathArray[i];
        var cmd = params[0];
        if (cmd === 'M') {
            // 遇到 'M' 判定是否是新数组，新数组中没有点
            if (points.length) {
                // 如果存在点，则说明没有遇到 'Z'，开始了一个新的多边形
                polylines.push(points);
                points = []; // 创建新的点
            }
            points.push([
                params[1],
                params[2]
            ]);
        } else if (cmd === 'Z') {
            if (points.length) {
                // 存在点
                polygons.push(points);
                points = []; // 开始新的点集合
            }
        } else points.push([
            params[1],
            params[2]
        ]);
    }
    // 说明 points 未放入 polygons 或者 polyline
    // 仅当只有一个 M，没有 Z 时会发生这种情况
    if (points.length > 0) polylines.push(points);
    return {
        polygons: polygons,
        polylines: polylines
    };
}
function isSamePoint(point1, point2) {
    return point1[0] === point2[0] && point1[1] === point2[1];
}
function getPathBBox(segments, lineWidth) {
    var xArr = [];
    var yArr = [];
    var segmentsWithAngle = [];
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        var currentPoint = segment.currentPoint, params = segment.params, prePoint = segment.prePoint;
        var box = void 0;
        switch(segment.command){
            case 'Q':
                box = (0, $11s8J.quadBox)(prePoint[0], prePoint[1], params[1], params[2], params[3], params[4]);
                break;
            case 'C':
                box = (0, $11s8J.cubicBox)(prePoint[0], prePoint[1], params[1], params[2], params[3], params[4], params[5], params[6]);
                break;
            case 'A':
                var arcParams = segment.arcParams;
                box = (0, $11s8J.arcBox)(arcParams.cx, arcParams.cy, arcParams.rx, arcParams.ry, arcParams.xRotation, arcParams.startAngle, arcParams.endAngle);
                break;
            default:
                xArr.push(currentPoint[0]);
                yArr.push(currentPoint[1]);
                break;
        }
        if (box) {
            segment.box = box;
            xArr.push(box.x, box.x + box.width);
            yArr.push(box.y, box.y + box.height);
        }
        if (lineWidth && (segment.command === 'L' || segment.command === 'M') && segment.prePoint && segment.nextPoint) segmentsWithAngle.push(segment);
    }
    // bbox calculation should ignore NaN for path attribute
    // ref: https://github.com/antvis/g/issues/210
    // ref: https://github.com/antvis/G2/issues/3109
    xArr = xArr.filter(function(item) {
        return !Number.isNaN(item) && item !== Infinity && item !== -Infinity;
    });
    yArr = yArr.filter(function(item) {
        return !Number.isNaN(item) && item !== Infinity && item !== -Infinity;
    });
    var minX = (0, $04Wz9.default)(xArr);
    var minY = (0, $04Wz9.default)(yArr);
    var maxX = (0, $bFgqX.default)(xArr);
    var maxY = (0, $bFgqX.default)(yArr);
    if (segmentsWithAngle.length === 0) return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
    for(var _i = 0; _i < segmentsWithAngle.length; _i++){
        var _segment = segmentsWithAngle[_i];
        var _currentPoint = _segment.currentPoint;
        var extra = void 0;
        if (_currentPoint[0] === minX) {
            extra = getExtraFromSegmentWithAngle(_segment, lineWidth);
            minX -= extra.xExtra;
        } else if (_currentPoint[0] === maxX) {
            extra = getExtraFromSegmentWithAngle(_segment, lineWidth);
            maxX += extra.xExtra;
        }
        if (_currentPoint[1] === minY) {
            extra = getExtraFromSegmentWithAngle(_segment, lineWidth);
            minY -= extra.yExtra;
        } else if (_currentPoint[1] === maxY) {
            extra = getExtraFromSegmentWithAngle(_segment, lineWidth);
            maxY += extra.yExtra;
        }
    }
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function getExtraFromSegmentWithAngle(segment, lineWidth) {
    var prePoint = segment.prePoint, currentPoint = segment.currentPoint, nextPoint = segment.nextPoint;
    var currentAndPre = Math.pow(currentPoint[0] - prePoint[0], 2) + Math.pow(currentPoint[1] - prePoint[1], 2);
    var currentAndNext = Math.pow(currentPoint[0] - nextPoint[0], 2) + Math.pow(currentPoint[1] - nextPoint[1], 2);
    var preAndNext = Math.pow(prePoint[0] - nextPoint[0], 2) + Math.pow(prePoint[1] - nextPoint[1], 2);
    // 以 currentPoint 为顶点的夹角
    var currentAngle = Math.acos((currentAndPre + currentAndNext - preAndNext) / (2 * Math.sqrt(currentAndPre) * Math.sqrt(currentAndNext)));
    // 夹角为空、 0 或 PI 时，不需要计算夹角处的额外宽度
    // 注意: 由于计算精度问题，夹角为 0 的情况计算出来的角度可能是一个很小的值，还需要判断其与 0 是否近似相等
    if (!currentAngle || Math.sin(currentAngle) === 0 || (0, $dFv1j.default)(currentAngle, 0)) return {
        xExtra: 0,
        yExtra: 0
    };
    var xAngle = Math.abs(Math.atan2(nextPoint[1] - currentPoint[1], nextPoint[0] - currentPoint[0]));
    var yAngle = Math.abs(Math.atan2(nextPoint[0] - currentPoint[0], nextPoint[1] - currentPoint[1]));
    // 将夹角转为锐角
    xAngle = xAngle > Math.PI / 2 ? Math.PI - xAngle : xAngle;
    yAngle = yAngle > Math.PI / 2 ? Math.PI - yAngle : yAngle;
    // 这里不考虑在水平和垂直方向的投影，直接使用最大差值
    // 由于上层统一加减了二分之一线宽，这里需要进行弥补
    var extra = {
        // 水平方向投影
        xExtra: Math.cos(currentAngle / 2 - xAngle) * (lineWidth / 2 * (1 / Math.sin(currentAngle / 2))) - lineWidth / 2 || 0,
        // 垂直方向投影
        yExtra: Math.cos(yAngle - currentAngle / 2) * (lineWidth / 2 * (1 / Math.sin(currentAngle / 2))) - lineWidth / 2 || 0
    };
    return extra;
}
// 点对称
function toSymmetry(point, center) {
    return [
        center[0] + (center[0] - point[0]),
        center[1] + (center[1] - point[1])
    ];
}
var angleBetween = function angleBetween(v0, v1) {
    var p = v0.x * v1.x + v0.y * v1.y;
    var n = Math.sqrt((Math.pow(v0.x, 2) + Math.pow(v0.y, 2)) * (Math.pow(v1.x, 2) + Math.pow(v1.y, 2)));
    var sign = v0.x * v1.y - v0.y * v1.x < 0 ? -1 : 1;
    var angle = sign * Math.acos(p / n);
    return angle;
};
/**
 * @see https://github.com/rveciana/svg-path-properties/blob/b6bd9a322966f6ef7a311872d80c56e3718de861/src/arc.ts#L121
 */ var pointOnEllipticalArc = function pointOnEllipticalArc(p0, rx, ry, xAxisRotation, largeArcFlag, sweepFlag, p1, t) {
    // In accordance to: http://www.w3.org/TR/SVG/implnote.html#ArcOutOfRangeParameters
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    xAxisRotation = (0, $fo9PZ.default)(xAxisRotation, 360);
    var xAxisRotationRadians = deg2rad(xAxisRotation);
    // If the endpoints are identical, then this is equivalent to omitting the elliptical arc segment entirely.
    if (p0.x === p1.x && p0.y === p1.y) return {
        x: p0.x,
        y: p0.y,
        ellipticalArcAngle: 0
    }; // Check if angle is correct
    // If rx = 0 or ry = 0 then this arc is treated as a straight line segment joining the endpoints.
    if (rx === 0 || ry === 0) // return this.pointOnLine(p0, p1, t);
    return {
        x: 0,
        y: 0,
        ellipticalArcAngle: 0
    }; // Check if angle is correct
    // Following "Conversion from endpoint to center parameterization"
    // http://www.w3.org/TR/SVG/implnote.html#ArcConversionEndpointToCenter
    // Step #1: Compute transformedPoint
    var dx = (p0.x - p1.x) / 2;
    var dy = (p0.y - p1.y) / 2;
    var transformedPoint = {
        x: Math.cos(xAxisRotationRadians) * dx + Math.sin(xAxisRotationRadians) * dy,
        y: -Math.sin(xAxisRotationRadians) * dx + Math.cos(xAxisRotationRadians) * dy
    };
    // Ensure radii are large enough
    var radiiCheck = Math.pow(transformedPoint.x, 2) / Math.pow(rx, 2) + Math.pow(transformedPoint.y, 2) / Math.pow(ry, 2);
    if (radiiCheck > 1) {
        rx *= Math.sqrt(radiiCheck);
        ry *= Math.sqrt(radiiCheck);
    }
    // Step #2: Compute transformedCenter
    var cSquareNumerator = Math.pow(rx, 2) * Math.pow(ry, 2) - Math.pow(rx, 2) * Math.pow(transformedPoint.y, 2) - Math.pow(ry, 2) * Math.pow(transformedPoint.x, 2);
    var cSquareRootDenom = Math.pow(rx, 2) * Math.pow(transformedPoint.y, 2) + Math.pow(ry, 2) * Math.pow(transformedPoint.x, 2);
    var cRadicand = cSquareNumerator / cSquareRootDenom;
    // Make sure this never drops below zero because of precision
    cRadicand = cRadicand < 0 ? 0 : cRadicand;
    var cCoef = (largeArcFlag !== sweepFlag ? 1 : -1) * Math.sqrt(cRadicand);
    var transformedCenter = {
        x: cCoef * (rx * transformedPoint.y / ry),
        y: cCoef * (-(ry * transformedPoint.x) / rx)
    };
    // Step #3: Compute center
    var center = {
        x: Math.cos(xAxisRotationRadians) * transformedCenter.x - Math.sin(xAxisRotationRadians) * transformedCenter.y + (p0.x + p1.x) / 2,
        y: Math.sin(xAxisRotationRadians) * transformedCenter.x + Math.cos(xAxisRotationRadians) * transformedCenter.y + (p0.y + p1.y) / 2
    };
    // Step #4: Compute start/sweep angles
    // Start angle of the elliptical arc prior to the stretch and rotate operations.
    // Difference between the start and end angles
    var startVector = {
        x: (transformedPoint.x - transformedCenter.x) / rx,
        y: (transformedPoint.y - transformedCenter.y) / ry
    };
    var startAngle = angleBetween({
        x: 1,
        y: 0
    }, startVector);
    var endVector = {
        x: (-transformedPoint.x - transformedCenter.x) / rx,
        y: (-transformedPoint.y - transformedCenter.y) / ry
    };
    var sweepAngle = angleBetween(startVector, endVector);
    if (!sweepFlag && sweepAngle > 0) sweepAngle -= 2 * Math.PI;
    else if (sweepFlag && sweepAngle < 0) sweepAngle += 2 * Math.PI;
    // We use % instead of `mod(..)` because we want it to be -360deg to 360deg(but actually in radians)
    sweepAngle %= 2 * Math.PI;
    // From http://www.w3.org/TR/SVG/implnote.html#ArcParameterizationAlternatives
    var angle = startAngle + sweepAngle * t;
    var ellipseComponentX = rx * Math.cos(angle);
    var ellipseComponentY = ry * Math.sin(angle);
    var point = {
        x: Math.cos(xAxisRotationRadians) * ellipseComponentX - Math.sin(xAxisRotationRadians) * ellipseComponentY + center.x,
        y: Math.sin(xAxisRotationRadians) * ellipseComponentX + Math.cos(xAxisRotationRadians) * ellipseComponentY + center.y,
        ellipticalArcStartAngle: startAngle,
        ellipticalArcEndAngle: startAngle + sweepAngle,
        ellipticalArcAngle: angle,
        ellipticalArcCenter: center,
        resultantRx: rx,
        resultantRy: ry
    };
    return point;
};
function path2Segments(path) {
    var segments = [];
    var currentPoint = null; // 当前图形
    var nextParams = null; // 下一节点的 path 参数
    var startMovePoint = null; // 开始 M 的点，可能会有多个
    var lastStartMovePointIndex = 0; // 最近一个开始点 M 的索引
    var count = path.length;
    for(var i = 0; i < count; i++){
        var params = path[i];
        nextParams = path[i + 1];
        var command = params[0];
        // 数学定义上的参数，便于后面的计算
        var segment = {
            command: command,
            prePoint: currentPoint,
            params: params,
            startTangent: null,
            endTangent: null,
            currentPoint: null,
            nextPoint: null,
            arcParams: null,
            box: null,
            cubicParams: null
        };
        switch(command){
            case 'M':
                startMovePoint = [
                    params[1],
                    params[2]
                ];
                lastStartMovePointIndex = i;
                break;
            case 'A':
                var arcParams = getArcParams(currentPoint, params);
                segment.arcParams = arcParams;
                break;
        }
        if (command === 'Z') {
            // 有了 Z 后，当前节点从开始 M 的点开始
            currentPoint = startMovePoint;
            // 如果当前点的命令为 Z，相当于当前点为最近一个 M 点，则下一个点直接指向最近一个 M 点的下一个点
            nextParams = path[lastStartMovePointIndex + 1];
        } else {
            var len = params.length;
            currentPoint = [
                params[len - 2],
                params[len - 1]
            ];
        }
        if (nextParams && nextParams[0] === 'Z') {
            // 如果下一个点的命令为 Z，则下一个点直接指向最近一个 M 点
            nextParams = path[lastStartMovePointIndex];
            if (segments[lastStartMovePointIndex]) // 如果下一个点的命令为 Z，则最近一个 M 点的前一个点为当前点
            segments[lastStartMovePointIndex].prePoint = currentPoint;
        }
        segment.currentPoint = currentPoint;
        // 如果当前点与最近一个 M 点相同，则最近一个 M 点的前一个点为当前点的前一个点
        if (segments[lastStartMovePointIndex] && isSamePoint(currentPoint, segments[lastStartMovePointIndex].currentPoint)) segments[lastStartMovePointIndex].prePoint = segment.prePoint;
        var nextPoint = nextParams ? [
            nextParams[nextParams.length - 2],
            nextParams[nextParams.length - 1]
        ] : null;
        segment.nextPoint = nextPoint;
        // Add startTangent and endTangent
        var prePoint = segment.prePoint;
        if ([
            'L',
            'H',
            'V'
        ].includes(command)) {
            segment.startTangent = [
                prePoint[0] - currentPoint[0],
                prePoint[1] - currentPoint[1]
            ];
            segment.endTangent = [
                currentPoint[0] - prePoint[0],
                currentPoint[1] - prePoint[1]
            ];
        } else if (command === 'Q') {
            // 二次贝塞尔曲线只有一个控制点
            var cp = [
                params[1],
                params[2]
            ];
            // 二次贝塞尔曲线的终点为 currentPoint
            segment.startTangent = [
                prePoint[0] - cp[0],
                prePoint[1] - cp[1]
            ];
            segment.endTangent = [
                currentPoint[0] - cp[0],
                currentPoint[1] - cp[1]
            ];
        } else if (command === 'T') {
            var preSegment = segments[i - 1];
            var _cp = toSymmetry(preSegment.currentPoint, prePoint);
            if (preSegment.command === 'Q') {
                segment.command = 'Q';
                segment.startTangent = [
                    prePoint[0] - _cp[0],
                    prePoint[1] - _cp[1]
                ];
                segment.endTangent = [
                    currentPoint[0] - _cp[0],
                    currentPoint[1] - _cp[1]
                ];
            } else {
                // @ts-ignore
                segment.command = 'TL';
                segment.startTangent = [
                    prePoint[0] - currentPoint[0],
                    prePoint[1] - currentPoint[1]
                ];
                segment.endTangent = [
                    currentPoint[0] - prePoint[0],
                    currentPoint[1] - prePoint[1]
                ];
            }
        } else if (command === 'C') {
            // 三次贝塞尔曲线有两个控制点
            var cp1 = [
                params[1],
                params[2]
            ];
            var cp2 = [
                params[3],
                params[4]
            ];
            segment.startTangent = [
                prePoint[0] - cp1[0],
                prePoint[1] - cp1[1]
            ];
            segment.endTangent = [
                currentPoint[0] - cp2[0],
                currentPoint[1] - cp2[1]
            ];
            // horizontal line, eg. ['C', 100, 100, 100, 100, 200, 200]
            if (segment.startTangent[0] === 0 && segment.startTangent[1] === 0) segment.startTangent = [
                cp1[0] - cp2[0],
                cp1[1] - cp2[1]
            ];
            if (segment.endTangent[0] === 0 && segment.endTangent[1] === 0) segment.endTangent = [
                cp2[0] - cp1[0],
                cp2[1] - cp1[1]
            ];
        } else if (command === 'S') {
            var _preSegment = segments[i - 1];
            var _cp2 = toSymmetry(_preSegment.currentPoint, prePoint);
            var _cp3 = [
                params[1],
                params[2]
            ];
            if (_preSegment.command === 'C') {
                segment.command = 'C'; // 将 S 命令变换为 C 命令
                segment.startTangent = [
                    prePoint[0] - _cp2[0],
                    prePoint[1] - _cp2[1]
                ];
                segment.endTangent = [
                    currentPoint[0] - _cp3[0],
                    currentPoint[1] - _cp3[1]
                ];
            } else {
                // @ts-ignore
                segment.command = 'SQ'; // 将 S 命令变换为 SQ 命令
                segment.startTangent = [
                    prePoint[0] - _cp3[0],
                    prePoint[1] - _cp3[1]
                ];
                segment.endTangent = [
                    currentPoint[0] - _cp3[0],
                    currentPoint[1] - _cp3[1]
                ];
            }
        } else if (command === 'A') {
            var _getTangentAtRatio = getTangentAtRatio(segment, 0), dx1 = _getTangentAtRatio.x, dy1 = _getTangentAtRatio.y;
            var _getTangentAtRatio2 = getTangentAtRatio(segment, 1, false), dx2 = _getTangentAtRatio2.x, dy2 = _getTangentAtRatio2.y;
            segment.startTangent = [
                dx1,
                dy1
            ];
            segment.endTangent = [
                dx2,
                dy2
            ];
        }
        segments.push(segment);
    }
    return segments;
}
/**
 * Use length instead of ratio
 */ function getTangentAtRatio(segment, ratio) {
    var sign = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _segment$arcParams = segment.arcParams, _segment$arcParams$rx = _segment$arcParams.rx, rx = _segment$arcParams$rx === void 0 ? 0 : _segment$arcParams$rx, _segment$arcParams$ry = _segment$arcParams.ry, ry = _segment$arcParams$ry === void 0 ? 0 : _segment$arcParams$ry, xRotation = _segment$arcParams.xRotation, arcFlag = _segment$arcParams.arcFlag, sweepFlag = _segment$arcParams.sweepFlag;
    var p1 = pointOnEllipticalArc({
        x: segment.prePoint[0],
        y: segment.prePoint[1]
    }, rx, ry, xRotation, !!arcFlag, !!sweepFlag, {
        x: segment.currentPoint[0],
        y: segment.currentPoint[1]
    }, ratio);
    var p2 = pointOnEllipticalArc({
        x: segment.prePoint[0],
        y: segment.prePoint[1]
    }, rx, ry, xRotation, !!arcFlag, !!sweepFlag, {
        x: segment.currentPoint[0],
        y: segment.currentPoint[1]
    }, sign ? ratio + 0.005 : ratio - 0.005);
    var xDist = p2.x - p1.x;
    var yDist = p2.y - p1.y;
    var dist = Math.sqrt(xDist * xDist + yDist * yDist);
    return {
        x: -xDist / dist,
        y: -yDist / dist
    };
}
// 向量长度
function vMag(v) {
    return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
}
// u.v/|u||v|，计算夹角的余弦值
function vRatio(u, v) {
    // 当存在一个向量的长度为 0 时，夹角也为 0，即夹角的余弦值为 1
    return vMag(u) * vMag(v) ? (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v)) : 1;
}
// 向量角度
function vAngle(u, v) {
    return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
}
function getArcParams(startPoint, params) {
    var rx = params[1];
    var ry = params[2];
    var xRotation = (0, $fo9PZ.default)(deg2rad(params[3]), Math.PI * 2);
    var arcFlag = params[4];
    var sweepFlag = params[5];
    // 弧形起点坐标
    var x1 = startPoint[0];
    var y1 = startPoint[1];
    // 弧形终点坐标
    var x2 = params[6];
    var y2 = params[7];
    var xp = Math.cos(xRotation) * (x1 - x2) / 2.0 + Math.sin(xRotation) * (y1 - y2) / 2.0;
    var yp = -1 * Math.sin(xRotation) * (x1 - x2) / 2.0 + Math.cos(xRotation) * (y1 - y2) / 2.0;
    var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
    if (lambda > 1) {
        rx *= Math.sqrt(lambda);
        ry *= Math.sqrt(lambda);
    }
    var diff = rx * rx * (yp * yp) + ry * ry * (xp * xp);
    var f = diff ? Math.sqrt((rx * rx * (ry * ry) - diff) / diff) : 1;
    if (arcFlag === sweepFlag) f *= -1;
    if (isNaN(f)) f = 0;
    // 旋转前的起点坐标，且当长半轴和短半轴的长度为 0 时，坐标按 (0, 0) 处理
    var cxp = ry ? f * rx * yp / ry : 0;
    var cyp = rx ? f * -ry * xp / rx : 0;
    // 椭圆圆心坐标
    var cx = (x1 + x2) / 2.0 + Math.cos(xRotation) * cxp - Math.sin(xRotation) * cyp;
    var cy = (y1 + y2) / 2.0 + Math.sin(xRotation) * cxp + Math.cos(xRotation) * cyp;
    // 起始点的单位向量
    var u = [
        (xp - cxp) / rx,
        (yp - cyp) / ry
    ];
    // 终止点的单位向量
    var v = [
        (-1 * xp - cxp) / rx,
        (-1 * yp - cyp) / ry
    ];
    // 计算起始点和圆心的连线，与 x 轴正方向的夹角
    var theta = vAngle([
        1,
        0
    ], u);
    // 计算圆弧起始点和终止点与椭圆圆心连线的夹角
    var dTheta = vAngle(u, v);
    if (vRatio(u, v) <= -1) dTheta = Math.PI;
    if (vRatio(u, v) >= 1) dTheta = 0;
    if (sweepFlag === 0 && dTheta > 0) dTheta -= 2 * Math.PI;
    if (sweepFlag === 1 && dTheta < 0) dTheta += 2 * Math.PI;
    return {
        cx: cx,
        cy: cy,
        // 弧形的起点和终点相同时，长轴和短轴的长度按 0 处理
        rx: isSamePoint(startPoint, [
            x2,
            y2
        ]) ? 0 : rx,
        ry: isSamePoint(startPoint, [
            x2,
            y2
        ]) ? 0 : ry,
        startAngle: theta,
        endAngle: theta + dTheta,
        xRotation: xRotation,
        arcFlag: arcFlag,
        sweepFlag: sweepFlag
    };
}
function commandsToPathString(commands, object, transform) {
    return commands.reduce(function(prev, cur) {
        var path = '';
        if (cur[0] === 'M' || cur[0] === 'L') {
            var p = (0, $eIStk).fromValues(cur[1], cur[2], 0);
            if (transform) (0, $eIStk).transformMat4(p, p, transform);
            path = "".concat(cur[0]).concat(p[0], ",").concat(p[1]);
        } else if (cur[0] === 'Z') path = cur[0];
        else if (cur[0] === 'C') {
            var p1 = (0, $eIStk).fromValues(cur[1], cur[2], 0);
            var p2 = (0, $eIStk).fromValues(cur[3], cur[4], 0);
            var p3 = (0, $eIStk).fromValues(cur[5], cur[6], 0);
            if (transform) {
                (0, $eIStk).transformMat4(p1, p1, transform);
                (0, $eIStk).transformMat4(p2, p2, transform);
                (0, $eIStk).transformMat4(p3, p3, transform);
            }
            path = "".concat(cur[0]).concat(p1[0], ",").concat(p1[1], ",").concat(p2[0], ",").concat(p2[1], ",").concat(p3[0], ",").concat(p3[1]);
        } else if (cur[0] === 'A') {
            var c = (0, $eIStk).fromValues(cur[6], cur[7], 0);
            if (transform) (0, $eIStk).transformMat4(c, c, transform);
            path = "".concat(cur[0]).concat(cur[1], ",").concat(cur[2], ",").concat(cur[3], ",").concat(cur[4], ",").concat(cur[5], ",").concat(c[0], ",").concat(c[1]);
        } else if (cur[0] === 'Q') {
            var _p = (0, $eIStk).fromValues(cur[1], cur[2], 0);
            var _p2 = (0, $eIStk).fromValues(cur[3], cur[4], 0);
            if (transform) {
                (0, $eIStk).transformMat4(_p, _p, transform);
                (0, $eIStk).transformMat4(_p2, _p2, transform);
            }
            path = "".concat(cur[0]).concat(cur[1], ",").concat(cur[2], ",").concat(cur[3], ",").concat(cur[4], "}");
        }
        return prev += path;
    }, '');
}
function lineToCommands(x1, y1, x2, y2) {
    return [
        [
            'M',
            x1,
            y1
        ],
        [
            'L',
            x2,
            y2
        ]
    ];
}
function ellipseToCommands(rx, ry, cx, cy) {
    var factor = (-1 + Math.sqrt(2)) / 3 * 4;
    var dx = rx * factor;
    var dy = ry * factor;
    var left = cx - rx;
    var right = cx + rx;
    var top = cy - ry;
    var bottom = cy + ry;
    return [
        [
            'M',
            left,
            cy
        ],
        [
            'C',
            left,
            cy - dy,
            cx - dx,
            top,
            cx,
            top
        ],
        [
            'C',
            cx + dx,
            top,
            right,
            cy - dy,
            right,
            cy
        ],
        [
            'C',
            right,
            cy + dy,
            cx + dx,
            bottom,
            cx,
            bottom
        ],
        [
            'C',
            cx - dx,
            bottom,
            left,
            cy + dy,
            left,
            cy
        ],
        [
            'Z'
        ]
    ];
}
function polygonToCommands(points, closed) {
    var result = points.map(function(point, i) {
        return [
            i === 0 ? 'M' : 'L',
            point[0],
            point[1]
        ];
    });
    if (closed) result.push([
        'Z'
    ]);
    return result;
}
function rectToCommands(width, height, x, y, radius) {
    // @see https://gist.github.com/danielpquinn/dd966af424030d47e476
    if (radius) {
        var _radius = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(radius, 4), tlr = _radius[0], trr = _radius[1], brr = _radius[2], blr = _radius[3];
        var signX = width > 0 ? 1 : -1;
        var signY = height > 0 ? 1 : -1;
        // sweep-flag @see https://developer.mozilla.org/zh-CN/docs/Web/SVG/Tutorial/Paths#arcs
        var sweepFlag = signX + signY !== 0 ? 1 : 0;
        return [
            [
                'M',
                signX * tlr + x,
                y
            ],
            [
                'L',
                width - signX * trr + x,
                y
            ],
            trr ? [
                'A',
                trr,
                trr,
                0,
                0,
                sweepFlag,
                width + x,
                signY * trr + y
            ] : null,
            [
                'L',
                width + x,
                height - signY * brr + y
            ],
            brr ? [
                'A',
                brr,
                brr,
                0,
                0,
                sweepFlag,
                width + x - signX * brr,
                height + y
            ] : null,
            [
                'L',
                x + signX * blr,
                height + y
            ],
            blr ? [
                'A',
                blr,
                blr,
                0,
                0,
                sweepFlag,
                x,
                height + y - signY * blr
            ] : null,
            [
                'L',
                x,
                signY * tlr + y
            ],
            tlr ? [
                'A',
                tlr,
                tlr,
                0,
                0,
                sweepFlag,
                signX * tlr + x,
                y
            ] : null,
            [
                'Z'
            ]
        ].filter(function(command) {
            return command;
        });
    }
    return [
        [
            'M',
            x,
            y
        ],
        [
            'L',
            x + width,
            y
        ],
        [
            'L',
            x + width,
            y + height
        ],
        [
            'L',
            x,
            y + height
        ],
        [
            'Z'
        ]
    ];
}
/**
 * convert object to path, should account for:
 * * transform & origin
 * * lineWidth
 */ function convertToPath(object) {
    var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object.getLocalTransform();
    var commands = [];
    switch(object.nodeName){
        case Shape.LINE:
            var _parsedStyle = object.parsedStyle, _parsedStyle$x = _parsedStyle.x1, x1 = _parsedStyle$x === void 0 ? 0 : _parsedStyle$x, _parsedStyle$y = _parsedStyle.y1, y1 = _parsedStyle$y === void 0 ? 0 : _parsedStyle$y, _parsedStyle$x2 = _parsedStyle.x2, x2 = _parsedStyle$x2 === void 0 ? 0 : _parsedStyle$x2, _parsedStyle$y2 = _parsedStyle.y2, y2 = _parsedStyle$y2 === void 0 ? 0 : _parsedStyle$y2;
            commands = lineToCommands(x1, y1, x2, y2);
            break;
        case Shape.CIRCLE:
            var _parsedStyle2 = object.parsedStyle, _parsedStyle2$r = _parsedStyle2.r, r = _parsedStyle2$r === void 0 ? 0 : _parsedStyle2$r, _parsedStyle2$cx = _parsedStyle2.cx, cx = _parsedStyle2$cx === void 0 ? 0 : _parsedStyle2$cx, _parsedStyle2$cy = _parsedStyle2.cy, cy = _parsedStyle2$cy === void 0 ? 0 : _parsedStyle2$cy;
            commands = ellipseToCommands(r, r, cx, cy);
            break;
        case Shape.ELLIPSE:
            var _parsedStyle3 = object.parsedStyle, _parsedStyle3$rx = _parsedStyle3.rx, rx = _parsedStyle3$rx === void 0 ? 0 : _parsedStyle3$rx, _parsedStyle3$ry = _parsedStyle3.ry, ry = _parsedStyle3$ry === void 0 ? 0 : _parsedStyle3$ry, _parsedStyle3$cx = _parsedStyle3.cx, _cx = _parsedStyle3$cx === void 0 ? 0 : _parsedStyle3$cx, _parsedStyle3$cy = _parsedStyle3.cy, _cy = _parsedStyle3$cy === void 0 ? 0 : _parsedStyle3$cy;
            commands = ellipseToCommands(rx, ry, _cx, _cy);
            break;
        case Shape.POLYLINE:
        case Shape.POLYGON:
            var points = object.parsedStyle.points;
            commands = polygonToCommands(points.points, object.nodeName === Shape.POLYGON);
            break;
        case Shape.RECT:
            var _parsedStyle4 = object.parsedStyle, _parsedStyle4$width = _parsedStyle4.width, width = _parsedStyle4$width === void 0 ? 0 : _parsedStyle4$width, _parsedStyle4$height = _parsedStyle4.height, height = _parsedStyle4$height === void 0 ? 0 : _parsedStyle4$height, _parsedStyle4$x = _parsedStyle4.x, x = _parsedStyle4$x === void 0 ? 0 : _parsedStyle4$x, _parsedStyle4$y = _parsedStyle4.y, y = _parsedStyle4$y === void 0 ? 0 : _parsedStyle4$y, radius = _parsedStyle4.radius;
            var hasRadius = radius && radius.some(function(r) {
                return r !== 0;
            });
            commands = rectToCommands(width, height, x, y, hasRadius && radius.map(function(r) {
                return (0, $8hhuV.default)(r, 0, Math.min(Math.abs(width) / 2, Math.abs(height) / 2));
            }));
            break;
        case Shape.PATH:
            var absolutePath = object.parsedStyle.d.absolutePath;
            commands = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(absolutePath);
            break;
    }
    if (commands.length) return commandsToPathString(commands, object, transform);
}
function translatePathToString(absolutePath) {
    var startOffsetX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var startOffsetY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var endOffsetX = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var endOffsetY = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var newValue = absolutePath.map(function(params, i) {
        var command = params[0];
        var nextSegment = absolutePath[i + 1];
        var useStartOffset = i === 0 && (startOffsetX !== 0 || startOffsetY !== 0);
        var useEndOffset = (i === absolutePath.length - 1 || nextSegment && (nextSegment[0] === 'M' || nextSegment[0] === 'Z')) && endOffsetX !== 0 && endOffsetY !== 0;
        var _ref = useStartOffset ? [
            startOffsetX,
            startOffsetY
        ] : [
            0,
            0
        ], _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), startOffsetXTemp = _ref2[0], startOffsetYTemp = _ref2[1];
        var _ref3 = useEndOffset ? [
            endOffsetX,
            endOffsetY
        ] : [
            0,
            0
        ], _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), endOffsetXTemp = _ref4[0], endOffsetYTemp = _ref4[1];
        switch(command){
            case 'M':
                return "M ".concat(params[1] + startOffsetXTemp, ",").concat(params[2] + startOffsetYTemp);
            case 'L':
                return "L ".concat(params[1] + endOffsetXTemp, ",").concat(params[2] + endOffsetYTemp);
            case 'Q':
                return "Q ".concat(params[1], " ").concat(params[2], ",").concat(params[3] + endOffsetXTemp, " ").concat(params[4] + endOffsetYTemp);
            case 'C':
                return "C ".concat(params[1], " ").concat(params[2], ",").concat(params[3], " ").concat(params[4], ",").concat(params[5] + endOffsetXTemp, " ").concat(params[6] + endOffsetYTemp);
            case 'A':
                return "A ".concat(params[1], " ").concat(params[2], " ").concat(params[3], " ").concat(params[4], " ").concat(params[5], " ").concat(params[6], " ").concat(params[7]).concat(useEndOffset ? " L ".concat(params[6] + endOffsetX, ",").concat(params[7] + endOffsetY) : '');
            case 'Z':
                return 'Z';
            default:
                return null;
        }
    }).filter(function(item) {
        return item !== null;
    }).join(' ');
    if (~newValue.indexOf('NaN')) return '';
    return newValue;
}
var internalParsePath = function internalParsePath(path) {
    // empty path
    if (path === '' || Array.isArray(path) && path.length === 0) return {
        absolutePath: [],
        hasArc: false,
        segments: [],
        polygons: [],
        polylines: [],
        curve: null,
        totalLength: 0,
        rect: {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        }
    };
    var absolutePath;
    try {
        absolutePath = (0, $dnxxK.normalizePath)(path);
    } catch (_unused) {
        absolutePath = (0, $dnxxK.normalizePath)('');
        console.error("[g]: Invalid SVG Path definition: ".concat(path));
    }
    removeRedundantMCommand(absolutePath);
    var hasArc = hasArcOrBezier(absolutePath);
    var _extractPolygons = extractPolygons(absolutePath), polygons = _extractPolygons.polygons, polylines = _extractPolygons.polylines;
    // for later use
    var segments = path2Segments(absolutePath);
    // Only calculate bbox here since we don't need length now.
    var _getPathBBox = getPathBBox(segments, 0), x = _getPathBBox.x, y = _getPathBBox.y, width = _getPathBBox.width, height = _getPathBBox.height;
    return {
        absolutePath: absolutePath,
        hasArc: hasArc,
        segments: segments,
        polygons: polygons,
        polylines: polylines,
        // curve,
        // Delay the calculation of length.
        totalLength: 0,
        rect: {
            x: Number.isFinite(x) ? x : 0,
            y: Number.isFinite(y) ? y : 0,
            width: Number.isFinite(width) ? width : 0,
            height: Number.isFinite(height) ? height : 0
        }
    };
};
var memoizedParsePath = memoize(internalParsePath);
function parsePath(path) {
    return (0, $kVcyu.default)(path) ? memoizedParsePath(path) : internalParsePath(path);
}
function mergePaths(left, right, object) {
    var curve1 = left.curve;
    var curve2 = right.curve;
    if (!curve1 || curve1.length === 0) {
        // convert to curves to do morphing & picking later
        // @see http://thednp.github.io/kute.js/svgCubicMorph.html
        curve1 = (0, $7Tbfw.path2Curve)(left.absolutePath, false);
        left.curve = curve1;
    }
    if (!curve2 || curve2.length === 0) {
        curve2 = (0, $7Tbfw.path2Curve)(right.absolutePath, false);
        right.curve = curve2;
    }
    var curves = [
        curve1,
        curve2
    ];
    if (curve1.length !== curve2.length) curves = (0, $gAC5x.equalizeSegments)(curve1, curve2);
    var curve0 = (0, $bqypU.getDrawDirection)(curves[0]) !== (0, $bqypU.getDrawDirection)(curves[1]) ? (0, $6kBPW.reverseCurve)(curves[0]) : (0, $lIA8Y.clonePath)(curves[0]);
    return [
        curve0,
        (0, $ctnG0.getRotatedCurve)(curves[1], curve0),
        function(pathArray) {
            // need converting to path string?
            return pathArray;
        }
    ];
}
/**
 * @see https://developer.mozilla.org/zh-CN/docs/Web/SVG/Attribute/points
 *
 * @example
 * points="100,10 250,150 200,110"
 */ function parsePoints(pointsOrStr, object) {
    var points;
    if ((0, $kVcyu.default)(pointsOrStr)) points = pointsOrStr.split(' ').map(function(pointStr) {
        var _pointStr$split = pointStr.split(','), _pointStr$split2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_pointStr$split, 2), x = _pointStr$split2[0], y = _pointStr$split2[1];
        return [
            Number(x),
            Number(y)
        ];
    });
    else points = pointsOrStr;
    return {
        points: points,
        totalLength: 0,
        segments: []
    };
}
function mergePoints(left, right) {
    return [
        left.points,
        right.points,
        function(points) {
            return points;
        }
    ];
}
// eg. { t: 'scale', d: [CSSUnitValue(1), CSSUnitValue(2)] }
var _ = null;
var TRANSFORM_REGEXP = /\s*(\w+)\(([^)]*)\)/g;
function cast(pattern) {
    return function(contents) {
        var i = 0;
        return pattern.map(function(x) {
            return x === _ ? contents[i++] : x;
        });
    };
}
function id(x) {
    return x;
}
// type: [argTypes, convertTo3D, convertTo2D]
// In the argument types string, lowercase characters represent optional arguments
var transformFunctions = {
    // @ts-ignore
    matrix: [
        'NNNNNN',
        [
            _,
            _,
            0,
            0,
            _,
            _,
            0,
            0,
            0,
            0,
            1,
            0,
            _,
            _,
            0,
            1
        ],
        id
    ],
    matrix3d: [
        'NNNNNNNNNNNNNNNN',
        id
    ],
    rotate: [
        'A'
    ],
    rotateX: [
        'A'
    ],
    rotateY: [
        'A'
    ],
    rotateZ: [
        'A'
    ],
    rotate3d: [
        'NNNA'
    ],
    perspective: [
        'L'
    ],
    scale: [
        'Nn',
        cast([
            _,
            _,
            new CSSUnitValue(1)
        ]),
        id
    ],
    scaleX: [
        'N',
        cast([
            _,
            new CSSUnitValue(1),
            new CSSUnitValue(1)
        ]),
        cast([
            _,
            new CSSUnitValue(1)
        ])
    ],
    scaleY: [
        'N',
        cast([
            new CSSUnitValue(1),
            _,
            new CSSUnitValue(1)
        ]),
        cast([
            new CSSUnitValue(1),
            _
        ])
    ],
    scaleZ: [
        'N',
        cast([
            new CSSUnitValue(1),
            new CSSUnitValue(1),
            _
        ])
    ],
    scale3d: [
        'NNN',
        id
    ],
    skew: [
        'Aa',
        null,
        id
    ],
    skewX: [
        'A',
        null,
        cast([
            _,
            Odeg
        ])
    ],
    skewY: [
        'A',
        null,
        cast([
            Odeg,
            _
        ])
    ],
    translate: [
        'Tt',
        cast([
            _,
            _,
            Opx
        ]),
        id
    ],
    translateX: [
        'T',
        cast([
            _,
            Opx,
            Opx
        ]),
        cast([
            _,
            Opx
        ])
    ],
    translateY: [
        'T',
        cast([
            Opx,
            _,
            Opx
        ]),
        cast([
            Opx,
            _
        ])
    ],
    translateZ: [
        'L',
        cast([
            Opx,
            Opx,
            _
        ])
    ],
    translate3d: [
        'TTL',
        id
    ]
};
function parseArrayTransform(transform) {
    var result = [];
    var length = transform.length;
    for(var i = 0; i < length; i++){
        var item = transform[i];
        var name = item[0];
        var args = item.slice(1);
        // infer default value
        if (name === 'translate' || name === 'skew') {
            if (args.length === 1) args.push(0);
        } else if (name === 'scale') {
            if (args.length === 1) args.push(args[0]);
        }
        var functionData = transformFunctions[name];
        if (!functionData) return [];
        var parsedArgs = args.map(function(value) {
            return getOrCreateUnitValue(value);
        });
        result.push({
            t: name,
            d: parsedArgs
        });
    }
    return result;
}
/**
 * none
 * scale(1) scale(1, 2)
 * scaleX(1)
 */ function parseTransform(transform) {
    if (Array.isArray(transform)) return parseArrayTransform(transform);
    transform = (transform || 'none').trim();
    if (transform === 'none') return [];
    var result = [];
    var match;
    var prevLastIndex = 0;
    TRANSFORM_REGEXP.lastIndex = 0;
    while(match = TRANSFORM_REGEXP.exec(transform)){
        if (match.index !== prevLastIndex) return [];
        prevLastIndex = match.index + match[0].length;
        var functionName = match[1]; // scale
        var functionData = transformFunctions[functionName]; // scale(1, 2)
        if (!functionData) // invalid, eg. scale()
        return [];
        var args = match[2].split(','); // 1,2
        var argTypes = functionData[0]; // Nn
        if (argTypes.length < args.length) // scale(N, n)
        return [];
        var parsedArgs = [];
        for(var i = 0; i < argTypes.length; i++){
            var arg = args[i];
            var type = argTypes[i];
            var parsedArg = void 0;
            if (!arg) // @ts-ignore
            parsedArg = ({
                a: Odeg,
                n: parsedArgs[0],
                t: Opx
            })[type];
            else // @ts-ignore
            parsedArg = ({
                A: function A(s) {
                    return s.trim() === '0' ? Odeg : parseAngle(s);
                },
                N: parseNumber,
                T: parseLengthOrPercentage,
                L: parseLength
            })[type.toUpperCase()](arg);
            if (parsedArg === undefined) return [];
            parsedArgs.push(parsedArg);
        }
        result.push({
            t: functionName,
            d: parsedArgs
        }); // { t: scale, d: [1, 2] }
        if (TRANSFORM_REGEXP.lastIndex === transform.length) return result;
    }
    return [];
}
function parseTransformUnmemoize(transform) {
    if (Array.isArray(transform)) return parseArrayTransform(transform);
    transform = (transform || 'none').trim();
    if (transform === 'none') return [];
    var result = [];
    var match;
    var prevLastIndex = 0;
    TRANSFORM_REGEXP.lastIndex = 0;
    while(match = TRANSFORM_REGEXP.exec(transform)){
        if (match.index !== prevLastIndex) return [];
        prevLastIndex = match.index + match[0].length;
        var functionName = match[1]; // scale
        var functionData = transformFunctions[functionName]; // scale(1, 2)
        if (!functionData) // invalid, eg. scale()
        return [];
        var args = match[2].split(','); // 1,2
        var argTypes = functionData[0]; // Nn
        if (argTypes.length < args.length) // scale(N, n)
        return [];
        var parsedArgs = [];
        for(var i = 0; i < argTypes.length; i++){
            var arg = args[i];
            var type = argTypes[i];
            var parsedArg = void 0;
            if (!arg) // @ts-ignore
            parsedArg = ({
                a: Odeg,
                n: parsedArgs[0],
                t: Opx
            })[type];
            else // @ts-ignore
            parsedArg = ({
                A: function A(s) {
                    return s.trim() === '0' ? Odeg : parseAngleUnmemoize(s);
                },
                N: parseNumberUnmemoize,
                T: parseLengthOrPercentageUnmemoize,
                L: parseLengthUnmemoize
            })[type.toUpperCase()](arg);
            if (parsedArg === undefined) return [];
            parsedArgs.push(parsedArg);
        }
        result.push({
            t: functionName,
            d: parsedArgs
        }); // { t: scale, d: [1, 2] }
        if (TRANSFORM_REGEXP.lastIndex === transform.length) return result;
    }
    return [];
}
function convertItemToMatrix(item) {
    var x;
    var y;
    var z;
    var angle;
    switch(item.t){
        case 'rotateX':
            angle = deg2rad(convertAngleUnit(item.d[0]));
            return [
                1,
                0,
                0,
                0,
                0,
                Math.cos(angle),
                Math.sin(angle),
                0,
                0,
                -Math.sin(angle),
                Math.cos(angle),
                0,
                0,
                0,
                0,
                1
            ];
        case 'rotateY':
            angle = deg2rad(convertAngleUnit(item.d[0]));
            return [
                Math.cos(angle),
                0,
                -Math.sin(angle),
                0,
                0,
                1,
                0,
                0,
                Math.sin(angle),
                0,
                Math.cos(angle),
                0,
                0,
                0,
                0,
                1
            ];
        case 'rotate':
        case 'rotateZ':
            angle = deg2rad(convertAngleUnit(item.d[0]));
            return [
                Math.cos(angle),
                Math.sin(angle),
                0,
                0,
                -Math.sin(angle),
                Math.cos(angle),
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ];
        case 'rotate3d':
            x = item.d[0].value;
            y = item.d[1].value;
            z = item.d[2].value;
            angle = deg2rad(convertAngleUnit(item.d[3]));
            var sqrLength = x * x + y * y + z * z;
            if (sqrLength === 0) {
                x = 1;
                y = 0;
                z = 0;
            } else if (sqrLength !== 1) {
                var length = Math.sqrt(sqrLength);
                x /= length;
                y /= length;
                z /= length;
            }
            var s = Math.sin(angle / 2);
            var sc = s * Math.cos(angle / 2);
            var sq = s * s;
            return [
                1 - 2 * (y * y + z * z) * sq,
                2 * (x * y * sq + z * sc),
                2 * (x * z * sq - y * sc),
                0,
                2 * (x * y * sq - z * sc),
                1 - 2 * (x * x + z * z) * sq,
                2 * (y * z * sq + x * sc),
                0,
                2 * (x * z * sq + y * sc),
                2 * (y * z * sq - x * sc),
                1 - 2 * (x * x + y * y) * sq,
                0,
                0,
                0,
                0,
                1
            ];
        case 'scale':
            return [
                item.d[0].value,
                0,
                0,
                0,
                0,
                item.d[1].value,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ];
        case 'scaleX':
            return [
                item.d[0].value,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ];
        case 'scaleY':
            return [
                1,
                0,
                0,
                0,
                0,
                item.d[0].value,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ];
        case 'scaleZ':
            return [
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                item.d[0].value,
                0,
                0,
                0,
                0,
                1
            ];
        case 'scale3d':
            return [
                item.d[0].value,
                0,
                0,
                0,
                0,
                item.d[1].value,
                0,
                0,
                0,
                0,
                item.d[2].value,
                0,
                0,
                0,
                0,
                1
            ];
        case 'skew':
            var xAngle = deg2rad(convertAngleUnit(item.d[0]));
            var yAngle = deg2rad(convertAngleUnit(item.d[1]));
            return [
                1,
                Math.tan(yAngle),
                0,
                0,
                Math.tan(xAngle),
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ];
        case 'skewX':
            angle = deg2rad(convertAngleUnit(item.d[0]));
            return [
                1,
                0,
                0,
                0,
                Math.tan(angle),
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ];
        case 'skewY':
            angle = deg2rad(convertAngleUnit(item.d[0]));
            return [
                1,
                Math.tan(angle),
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ];
        case 'translate':
            // TODO: pass target
            x = convertPercentUnit(item.d[0], 0, null) || 0;
            y = convertPercentUnit(item.d[1], 0, null) || 0;
            return [
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                x,
                y,
                0,
                1
            ];
        case 'translateX':
            x = convertPercentUnit(item.d[0], 0, null) || 0;
            return [
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                x,
                0,
                0,
                1
            ];
        case 'translateY':
            y = convertPercentUnit(item.d[0], 0, null) || 0;
            return [
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                y,
                0,
                1
            ];
        case 'translateZ':
            z = convertPercentUnit(item.d[0], 0, null) || 0;
            return [
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                z,
                1
            ];
        case 'translate3d':
            x = convertPercentUnit(item.d[0], 0, null) || 0;
            y = convertPercentUnit(item.d[1], 0, null) || 0;
            z = convertPercentUnit(item.d[2], 0, null) || 0;
            return [
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                x,
                y,
                z,
                1
            ];
        case 'perspective':
            var t = convertPercentUnit(item.d[0], 0, null) || 0;
            var p = t ? -1 / t : 0;
            return [
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                p,
                0,
                0,
                0,
                1
            ];
        case 'matrix':
            return [
                item.d[0].value,
                item.d[1].value,
                0,
                0,
                item.d[2].value,
                item.d[3].value,
                0,
                0,
                0,
                0,
                1,
                0,
                item.d[4].value,
                item.d[5].value,
                0,
                1
            ];
        case 'matrix3d':
            return item.d.map(function(d) {
                return d.value;
            });
    }
}
function multiplyMatrices(a, b) {
    return [
        a[0] * b[0] + a[4] * b[1] + a[8] * b[2] + a[12] * b[3],
        a[1] * b[0] + a[5] * b[1] + a[9] * b[2] + a[13] * b[3],
        a[2] * b[0] + a[6] * b[1] + a[10] * b[2] + a[14] * b[3],
        a[3] * b[0] + a[7] * b[1] + a[11] * b[2] + a[15] * b[3],
        a[0] * b[4] + a[4] * b[5] + a[8] * b[6] + a[12] * b[7],
        a[1] * b[4] + a[5] * b[5] + a[9] * b[6] + a[13] * b[7],
        a[2] * b[4] + a[6] * b[5] + a[10] * b[6] + a[14] * b[7],
        a[3] * b[4] + a[7] * b[5] + a[11] * b[6] + a[15] * b[7],
        a[0] * b[8] + a[4] * b[9] + a[8] * b[10] + a[12] * b[11],
        a[1] * b[8] + a[5] * b[9] + a[9] * b[10] + a[13] * b[11],
        a[2] * b[8] + a[6] * b[9] + a[10] * b[10] + a[14] * b[11],
        a[3] * b[8] + a[7] * b[9] + a[11] * b[10] + a[15] * b[11],
        a[0] * b[12] + a[4] * b[13] + a[8] * b[14] + a[12] * b[15],
        a[1] * b[12] + a[5] * b[13] + a[9] * b[14] + a[13] * b[15],
        a[2] * b[12] + a[6] * b[13] + a[10] * b[14] + a[14] * b[15],
        a[3] * b[12] + a[7] * b[13] + a[11] * b[14] + a[15] * b[15]
    ];
}
function convertToMatrix(transformList) {
    if (transformList.length === 0) return [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
    return transformList.map(convertItemToMatrix).reduce(multiplyMatrices);
}
function makeMatrixDecomposition(transformList) {
    var translate = [
        0,
        0,
        0
    ];
    var scale = [
        1,
        1,
        1
    ];
    var skew = [
        0,
        0,
        0
    ];
    var perspective = [
        0,
        0,
        0,
        1
    ];
    var quaternion = [
        0,
        0,
        0,
        1
    ];
    decomposeMat4(// @ts-ignore
    convertToMatrix(transformList), translate, scale, skew, perspective, quaternion);
    return [
        [
            translate,
            scale,
            skew,
            quaternion,
            perspective
        ]
    ];
}
var composeMatrix = function() {
    function multiply(a, b) {
        var result = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        for(var i = 0; i < 4; i++){
            for(var j = 0; j < 4; j++)for(var k = 0; k < 4; k++)result[i][j] += b[i][k] * a[k][j];
        }
        return result;
    }
    function is2D(m) {
        return m[0][2] === 0 && m[0][3] === 0 && m[1][2] === 0 && m[1][3] === 0 && m[2][0] === 0 && m[2][1] === 0 && m[2][2] === 1 && m[2][3] === 0 && m[3][2] === 0 && m[3][3] === 1;
    }
    function composeMatrix(translate, scale, skew, quat, perspective) {
        var matrix = [
            [
                1,
                0,
                0,
                0
            ],
            [
                0,
                1,
                0,
                0
            ],
            [
                0,
                0,
                1,
                0
            ],
            [
                0,
                0,
                0,
                1
            ]
        ];
        for(var i = 0; i < 4; i++)matrix[i][3] = perspective[i];
        for(var _i = 0; _i < 3; _i++)for(var j = 0; j < 3; j++)matrix[3][_i] += translate[j] * matrix[j][_i];
        var x = quat[0];
        var y = quat[1];
        var z = quat[2];
        var w = quat[3];
        var rotMatrix = [
            [
                1,
                0,
                0,
                0
            ],
            [
                0,
                1,
                0,
                0
            ],
            [
                0,
                0,
                1,
                0
            ],
            [
                0,
                0,
                0,
                1
            ]
        ];
        rotMatrix[0][0] = 1 - 2 * (y * y + z * z);
        rotMatrix[0][1] = 2 * (x * y - z * w);
        rotMatrix[0][2] = 2 * (x * z + y * w);
        rotMatrix[1][0] = 2 * (x * y + z * w);
        rotMatrix[1][1] = 1 - 2 * (x * x + z * z);
        rotMatrix[1][2] = 2 * (y * z - x * w);
        rotMatrix[2][0] = 2 * (x * z - y * w);
        rotMatrix[2][1] = 2 * (y * z + x * w);
        rotMatrix[2][2] = 1 - 2 * (x * x + y * y);
        matrix = multiply(matrix, rotMatrix);
        var temp = [
            [
                1,
                0,
                0,
                0
            ],
            [
                0,
                1,
                0,
                0
            ],
            [
                0,
                0,
                1,
                0
            ],
            [
                0,
                0,
                0,
                1
            ]
        ];
        if (skew[2]) {
            temp[2][1] = skew[2];
            matrix = multiply(matrix, temp);
        }
        if (skew[1]) {
            temp[2][1] = 0;
            temp[2][0] = skew[0];
            matrix = multiply(matrix, temp);
        }
        if (skew[0]) {
            temp[2][0] = 0;
            temp[1][0] = skew[0];
            matrix = multiply(matrix, temp);
        }
        for(var _i2 = 0; _i2 < 3; _i2++)for(var _j = 0; _j < 3; _j++)matrix[_i2][_j] *= scale[_i2];
        if (is2D(matrix)) return [
            matrix[0][0],
            matrix[0][1],
            matrix[1][0],
            matrix[1][1],
            matrix[3][0],
            matrix[3][1]
        ];
        return matrix[0].concat(matrix[1], matrix[2], matrix[3]);
    }
    return composeMatrix;
}();
function numberToLongString(x) {
    return x.toFixed(6).replace('.000000', '');
}
function mergeMatrices(left, right) {
    var leftArgs;
    var rightArgs;
    // @ts-ignore
    if (left.decompositionPair !== right) {
        // @ts-ignore
        left.decompositionPair = right;
        // @ts-ignore
        leftArgs = makeMatrixDecomposition(left);
    }
    // @ts-ignore
    if (right.decompositionPair !== left) {
        // @ts-ignore
        right.decompositionPair = left;
        // @ts-ignore
        rightArgs = makeMatrixDecomposition(right);
    }
    if (leftArgs[0] === null || rightArgs[0] === null) return [
        // @ts-ignore
        [
            false
        ],
        // @ts-ignore
        [
            true
        ],
        // @ts-ignore
        function(x) {
            return x ? right[0].d : left[0].d;
        }
    ];
    leftArgs[0].push(0);
    rightArgs[0].push(1);
    return [
        leftArgs,
        rightArgs,
        // @ts-ignore
        function(list) {
            // @ts-ignore
            var q = quat(leftArgs[0][3], rightArgs[0][3], list[5]);
            var mat = composeMatrix(list[0], list[1], list[2], q, list[4]);
            var stringifiedArgs = mat.map(numberToLongString).join(',');
            return stringifiedArgs;
        }
    ];
}
function dot(v1, v2) {
    var result = 0;
    for(var i = 0; i < v1.length; i++)result += v1[i] * v2[i];
    return result;
}
function quat(fromQ, toQ, f) {
    var product = dot(fromQ, toQ);
    product = (0, $8hhuV.default)(product, -1, 1.0);
    var quat = [];
    if (product === 1.0) quat = fromQ;
    else {
        var theta = Math.acos(product);
        var w = Math.sin(f * theta) * 1 / Math.sqrt(1 - product * product);
        for(var i = 0; i < 4; i++)quat.push(fromQ[i] * (Math.cos(f * theta) - product * w) + toQ[i] * w);
    }
    return quat;
}
// scaleX/Y/Z -> scale
function typeTo2D(type) {
    return type.replace(/[XY]/, '');
}
// scaleX/Y/Z -> scale3d
function typeTo3D(type) {
    return type.replace(/(X|Y|Z|3d)?$/, '3d');
}
var isMatrixOrPerspective = function isMatrixOrPerspective(lt, rt) {
    return lt === 'perspective' && rt === 'perspective' || (lt === 'matrix' || lt === 'matrix3d') && (rt === 'matrix' || rt === 'matrix3d');
};
function mergeTransforms(left, right, target) {
    var flipResults = false;
    // padding empty transform, eg. merge 'scale(10)' with 'none' -> scale(1)
    if (!left.length || !right.length) {
        if (!left.length) {
            flipResults = true;
            left = right;
            right = [];
        }
        var _loop = function _loop() {
            var _left$i = left[i], type = _left$i.t, args = _left$i.d;
            // none -> scale(1)/translateX(0)
            var defaultValue = type.substring(0, 5) === 'scale' ? 1 : 0;
            right.push({
                t: type,
                d: args.map(function(arg) {
                    if (typeof arg === 'number') return getOrCreateUnitValue(defaultValue);
                    return getOrCreateUnitValue(defaultValue, arg.unit);
                //   {
                //     unit: arg.unit,
                //     value: defaultValue,
                //   };
                })
            });
        };
        for(var i = 0; i < left.length; i++)_loop();
    }
    var leftResult = [];
    var rightResult = [];
    var types = [];
    // merge matrix() with matrix3d()
    if (left.length !== right.length) {
        var merged = mergeMatrices(left, right);
        // @ts-ignore
        leftResult = [
            merged[0]
        ];
        // @ts-ignore
        rightResult = [
            merged[1]
        ];
        types = [
            [
                'matrix',
                [
                    merged[2]
                ]
            ]
        ];
    } else for(var _i3 = 0; _i3 < left.length; _i3++){
        var leftType = left[_i3].t;
        var rightType = right[_i3].t;
        var leftArgs = left[_i3].d;
        var rightArgs = right[_i3].d;
        var leftFunctionData = transformFunctions[leftType];
        var rightFunctionData = transformFunctions[rightType];
        var type = void 0;
        if (isMatrixOrPerspective(leftType, rightType)) {
            var _merged = mergeMatrices([
                left[_i3]
            ], [
                right[_i3]
            ]);
            // @ts-ignore
            leftResult.push(_merged[0]);
            // @ts-ignore
            rightResult.push(_merged[1]);
            types.push([
                'matrix',
                [
                    _merged[2]
                ]
            ]);
            continue;
        } else if (leftType === rightType) type = leftType;
        else if (leftFunctionData[2] && rightFunctionData[2] && typeTo2D(leftType) === typeTo2D(rightType)) {
            type = typeTo2D(leftType);
            // @ts-ignore
            leftArgs = leftFunctionData[2](leftArgs);
            // @ts-ignore
            rightArgs = rightFunctionData[2](rightArgs);
        } else if (leftFunctionData[1] && rightFunctionData[1] && typeTo3D(leftType) === typeTo3D(rightType)) {
            type = typeTo3D(leftType);
            // @ts-ignore
            leftArgs = leftFunctionData[1](leftArgs);
            // @ts-ignore
            rightArgs = rightFunctionData[1](rightArgs);
        } else {
            var _merged2 = mergeMatrices(left, right);
            // @ts-ignore
            leftResult = [
                _merged2[0]
            ];
            // @ts-ignore
            rightResult = [
                _merged2[1]
            ];
            types = [
                [
                    'matrix',
                    [
                        _merged2[2]
                    ]
                ]
            ];
            break;
        }
        var leftArgsCopy = [];
        var rightArgsCopy = [];
        var stringConversions = [];
        for(var j = 0; j < leftArgs.length; j++){
            // const merge = leftArgs[j].unit === UnitType.kNumber ? mergeDimensions : mergeDimensions;
            var _merged3 = mergeDimensions(leftArgs[j], rightArgs[j], target, false, j);
            leftArgsCopy[j] = _merged3[0];
            rightArgsCopy[j] = _merged3[1];
            stringConversions.push(_merged3[2]);
        }
        leftResult.push(leftArgsCopy);
        rightResult.push(rightArgsCopy);
        types.push([
            type,
            stringConversions
        ]);
    }
    if (flipResults) {
        var tmp = leftResult;
        leftResult = rightResult;
        rightResult = tmp;
    }
    return [
        leftResult,
        rightResult,
        function(list) {
            return list.map(function(args, i) {
                var stringifiedArgs = args.map(function(arg, j) {
                    return types[i][1][j](arg);
                }).join(',');
                if (types[i][0] === 'matrix' && stringifiedArgs.split(',').length === 16) types[i][0] = 'matrix3d';
                if (types[i][0] === 'matrix3d' && stringifiedArgs.split(',').length === 6) types[i][0] = 'matrix';
                return "".concat(types[i][0], "(").concat(stringifiedArgs, ")");
            }).join(' ');
        }
    ];
}
/**
 * @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/transform-origin
 * eg. 'center' 'top left' '50px 50px'
 */ var parseTransformOrigin = memoize(function(value) {
    if ((0, $kVcyu.default)(value)) {
        if (value === 'text-anchor') return [
            getOrCreateUnitValue(0, 'px'),
            getOrCreateUnitValue(0, 'px')
        ];
        var values = value.split(' ');
        if (values.length === 1) {
            if (values[0] === 'top' || values[0] === 'bottom') {
                // 'top' -> 'center top'
                values[1] = values[0];
                values[0] = 'center';
            } else // '50px' -> '50px center'
            values[1] = 'center';
        }
        if (values.length !== 2) return null;
        // eg. center bottom
        return [
            parseLengthOrPercentage(convertKeyword2Percent(values[0])),
            parseLengthOrPercentage(convertKeyword2Percent(values[1]))
        ];
    }
    return [
        getOrCreateUnitValue(value[0] || 0, 'px'),
        getOrCreateUnitValue(value[1] || 0, 'px')
    ];
});
function convertKeyword2Percent(keyword) {
    if (keyword === 'center') return '50%';
    if (keyword === 'left' || keyword === 'top') return '0%';
    if (keyword === 'right' || keyword === 'bottom') return '100%';
    return keyword;
}
/**
 * Blink used them in code generation(css_properties.json5)
 */ var BUILT_IN_PROPERTIES = [
    {
        /**
   * used in CSS Layout API
   * eg. `display: 'flex'`
   */ n: 'display',
        k: [
            'none'
        ]
    },
    {
        /**
   * range [0.0, 1.0]
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/opacity
   */ n: 'opacity',
        "int": true,
        inh: true,
        d: '1',
        syntax: PropertySyntax.OPACITY_VALUE
    },
    {
        /**
   * inheritable, range [0.0, 1.0]
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill-opacity
   * @see https://svgwg.org/svg2-draft/painting.html#FillOpacity
   */ n: 'fillOpacity',
        "int": true,
        inh: true,
        d: '1',
        syntax: PropertySyntax.OPACITY_VALUE
    },
    {
        /**
   * inheritable, range [0.0, 1.0]
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-opacity
   * @see https://svgwg.org/svg2-draft/painting.html#StrokeOpacity
   */ n: 'strokeOpacity',
        "int": true,
        inh: true,
        d: '1',
        syntax: PropertySyntax.OPACITY_VALUE
    },
    {
        /**
   * background-color is not inheritable
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Tutorial/Fills_and_Strokes
   */ n: 'fill',
        "int": true,
        k: [
            'none'
        ],
        d: 'none',
        syntax: PropertySyntax.PAINT
    },
    {
        n: 'fillRule',
        k: [
            'nonzero',
            'evenodd'
        ],
        d: 'nonzero'
    },
    /**
 * default to none
 * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke#usage_notes
 */ {
        n: 'stroke',
        "int": true,
        k: [
            'none'
        ],
        d: 'none',
        syntax: PropertySyntax.PAINT,
        /**
   * Stroke 'none' won't affect geometry but others will.
   */ l: true
    },
    {
        n: 'shadowType',
        k: [
            'inner',
            'outer',
            'both'
        ],
        d: 'outer',
        l: true
    },
    {
        n: 'shadowColor',
        "int": true,
        syntax: PropertySyntax.COLOR
    },
    {
        n: 'shadowOffsetX',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'shadowOffsetY',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'shadowBlur',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.SHADOW_BLUR
    },
    {
        /**
   * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-width
   */ n: 'lineWidth',
        "int": true,
        inh: true,
        d: '1',
        l: true,
        a: [
            'strokeWidth'
        ],
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'increasedLineWidthForHitTesting',
        inh: true,
        d: '0',
        l: true,
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'lineJoin',
        inh: true,
        l: true,
        a: [
            'strokeLinejoin'
        ],
        k: [
            'miter',
            'bevel',
            'round'
        ],
        d: 'miter'
    },
    {
        n: 'lineCap',
        inh: true,
        l: true,
        a: [
            'strokeLinecap'
        ],
        k: [
            'butt',
            'round',
            'square'
        ],
        d: 'butt'
    },
    {
        n: 'lineDash',
        "int": true,
        inh: true,
        k: [
            'none'
        ],
        a: [
            'strokeDasharray'
        ],
        syntax: PropertySyntax.LENGTH_PERCENTAGE_12
    },
    {
        n: 'lineDashOffset',
        "int": true,
        inh: true,
        d: '0',
        a: [
            'strokeDashoffset'
        ],
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'offsetPath',
        syntax: PropertySyntax.DEFINED_PATH
    },
    {
        n: 'offsetDistance',
        "int": true,
        syntax: PropertySyntax.OFFSET_DISTANCE
    },
    {
        n: 'dx',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'dy',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'zIndex',
        ind: true,
        "int": true,
        d: '0',
        k: [
            'auto'
        ],
        syntax: PropertySyntax.Z_INDEX
    },
    {
        n: 'visibility',
        k: [
            'visible',
            'hidden'
        ],
        ind: true,
        inh: true,
        /**
   * support interpolation
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/visibility#interpolation
   */ "int": true,
        d: 'visible'
    },
    {
        n: 'pointerEvents',
        inh: true,
        k: [
            'none',
            'auto',
            'stroke',
            'fill',
            'painted',
            'visible',
            'visiblestroke',
            'visiblefill',
            'visiblepainted',
            // 'bounding-box',
            'all'
        ],
        d: 'auto'
    },
    {
        n: 'filter',
        ind: true,
        l: true,
        k: [
            'none'
        ],
        d: 'none',
        syntax: PropertySyntax.FILTER
    },
    {
        n: 'clipPath',
        syntax: PropertySyntax.DEFINED_PATH
    },
    {
        n: 'textPath',
        syntax: PropertySyntax.DEFINED_PATH
    },
    {
        n: 'textPathSide',
        k: [
            'left',
            'right'
        ],
        d: 'left'
    },
    {
        n: 'textPathStartOffset',
        l: true,
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'transform',
        p: 100,
        "int": true,
        k: [
            'none'
        ],
        d: 'none',
        syntax: PropertySyntax.TRANSFORM
    },
    {
        n: 'transformOrigin',
        p: 100,
        d: '0 0',
        // // int: true,
        // d: (nodeName: string) => {
        //   if (nodeName === Shape.CIRCLE || nodeName === Shape.ELLIPSE) {
        //     return 'center';
        //   }
        //   if (nodeName === Shape.TEXT) {
        //     return 'text-anchor';
        //   }
        //   return 'left top';
        // },
        l: true,
        syntax: PropertySyntax.TRANSFORM_ORIGIN
    },
    {
        n: 'cx',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.COORDINATE
    },
    {
        n: 'cy',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.COORDINATE
    },
    {
        n: 'cz',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.COORDINATE
    },
    {
        n: 'r',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'rx',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'ry',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    // Rect Image Group
    {
        // x in local space
        n: 'x',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.COORDINATE
    },
    {
        // y in local space
        n: 'y',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.COORDINATE
    },
    {
        // z in local space
        n: 'z',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.COORDINATE
    },
    {
        n: 'width',
        "int": true,
        l: true,
        /**
   * @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/width
   */ k: [
            'auto',
            'fit-content',
            'min-content',
            'max-content'
        ],
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'height',
        "int": true,
        l: true,
        /**
   * @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/height
   */ k: [
            'auto',
            'fit-content',
            'min-content',
            'max-content'
        ],
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'radius',
        "int": true,
        l: true,
        d: '0',
        syntax: PropertySyntax.LENGTH_PERCENTAGE_14
    },
    // Line
    {
        n: 'x1',
        "int": true,
        l: true,
        syntax: PropertySyntax.COORDINATE
    },
    {
        n: 'y1',
        "int": true,
        l: true,
        syntax: PropertySyntax.COORDINATE
    },
    {
        n: 'z1',
        "int": true,
        l: true,
        syntax: PropertySyntax.COORDINATE
    },
    {
        n: 'x2',
        "int": true,
        l: true,
        syntax: PropertySyntax.COORDINATE
    },
    {
        n: 'y2',
        "int": true,
        l: true,
        syntax: PropertySyntax.COORDINATE
    },
    {
        n: 'z2',
        "int": true,
        l: true,
        syntax: PropertySyntax.COORDINATE
    },
    // Path
    {
        n: 'd',
        "int": true,
        l: true,
        d: '',
        syntax: PropertySyntax.PATH,
        p: 50
    },
    // Polyline & Polygon
    {
        n: 'points',
        /**
   * support interpolation
   */ "int": true,
        l: true,
        syntax: PropertySyntax.LIST_OF_POINTS,
        p: 50
    },
    // Text
    {
        n: 'text',
        l: true,
        d: '',
        syntax: PropertySyntax.TEXT,
        p: 50
    },
    {
        n: 'textTransform',
        l: true,
        inh: true,
        k: [
            'capitalize',
            'uppercase',
            'lowercase',
            'none'
        ],
        d: 'none',
        syntax: PropertySyntax.TEXT_TRANSFORM,
        p: 51 // it must get parsed after text
    },
    {
        n: 'font',
        l: true
    },
    {
        n: 'fontSize',
        "int": true,
        inh: true,
        /**
   * @see https://www.w3schools.com/css/css_font_size.asp
   */ d: '16px',
        l: true,
        syntax: PropertySyntax.LENGTH_PERCENTAGE
    },
    {
        n: 'fontFamily',
        l: true,
        inh: true,
        d: 'sans-serif'
    },
    {
        n: 'fontStyle',
        l: true,
        inh: true,
        k: [
            'normal',
            'italic',
            'oblique'
        ],
        d: 'normal'
    },
    {
        n: 'fontWeight',
        l: true,
        inh: true,
        k: [
            'normal',
            'bold',
            'bolder',
            'lighter'
        ],
        d: 'normal'
    },
    {
        n: 'fontVariant',
        l: true,
        inh: true,
        k: [
            'normal',
            'small-caps'
        ],
        d: 'normal'
    },
    {
        n: 'lineHeight',
        l: true,
        syntax: PropertySyntax.LENGTH,
        "int": true,
        d: '0'
    },
    {
        n: 'letterSpacing',
        l: true,
        syntax: PropertySyntax.LENGTH,
        "int": true,
        d: '0'
    },
    {
        n: 'miterLimit',
        l: true,
        syntax: PropertySyntax.NUMBER,
        d: function d(nodeName) {
            if (nodeName === Shape.PATH || nodeName === Shape.POLYGON || nodeName === Shape.POLYLINE) return '4';
            return '10';
        }
    },
    {
        n: 'wordWrap',
        l: true
    },
    {
        n: 'wordWrapWidth',
        l: true
    },
    {
        n: 'maxLines',
        l: true
    },
    {
        n: 'textOverflow',
        l: true,
        d: 'clip'
    },
    {
        n: 'leading',
        l: true
    },
    {
        n: 'textBaseline',
        l: true,
        inh: true,
        k: [
            'top',
            'hanging',
            'middle',
            'alphabetic',
            'ideographic',
            'bottom'
        ],
        d: 'alphabetic'
    },
    {
        n: 'textAlign',
        l: true,
        inh: true,
        k: [
            'start',
            'center',
            'middle',
            'end',
            'left',
            'right'
        ],
        d: 'start'
    },
    // {
    //   n: 'whiteSpace',
    //   l: true,
    // },
    {
        n: 'markerStart',
        syntax: PropertySyntax.MARKER
    },
    {
        n: 'markerEnd',
        syntax: PropertySyntax.MARKER
    },
    {
        n: 'markerMid',
        syntax: PropertySyntax.MARKER
    },
    {
        n: 'markerStartOffset',
        syntax: PropertySyntax.LENGTH,
        l: true,
        "int": true,
        d: '0'
    },
    {
        n: 'markerEndOffset',
        syntax: PropertySyntax.LENGTH,
        l: true,
        "int": true,
        d: '0'
    }
];
var GEOMETRY_ATTRIBUTE_NAMES = new Set(BUILT_IN_PROPERTIES.filter(function(n) {
    return !!n.l;
}).map(function(n) {
    return n.n;
}));
var propertyMetadataCache = {};
var DefaultStyleValueRegistry = /*#__PURE__*/ function() {
    function DefaultStyleValueRegistry(runtime) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DefaultStyleValueRegistry);
        this.runtime = runtime;
        BUILT_IN_PROPERTIES.forEach(function(property) {
            _this.registerMetadata(property);
        });
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DefaultStyleValueRegistry, [
        {
            key: "registerMetadata",
            value: function registerMetadata(metadata) {
                [
                    metadata.n
                ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(metadata.a || [])).forEach(function(name) {
                    propertyMetadataCache[name] = metadata;
                });
            }
        },
        {
            key: "getPropertySyntax",
            value: function getPropertySyntax(syntax) {
                return this.runtime.CSSPropertySyntaxFactory[syntax];
            }
        },
        {
            key: "processProperties",
            value: function processProperties(object, attributes) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    skipUpdateAttribute: false,
                    skipParse: false,
                    forceUpdateGeometry: false,
                    usedAttributes: [],
                    memoize: true
                };
                Object.assign(object.attributes, attributes);
                // clipPath
                var oldClipPath = object.parsedStyle.clipPath;
                var oldOffsetPath = object.parsedStyle.offsetPath;
                assignParsedStyle(object, attributes);
                var needUpdateGeometry = !!options.forceUpdateGeometry;
                if (!needUpdateGeometry) {
                    for(var i in attributes)if (GEOMETRY_ATTRIBUTE_NAMES.has(i)) {
                        needUpdateGeometry = true;
                        break;
                    }
                }
                var list = getParsedStyleListOf(object);
                if (list.has('fill') && attributes.fill) object.parsedStyle.fill = parseColor(attributes.fill);
                if (list.has('stroke') && attributes.stroke) object.parsedStyle.stroke = parseColor(attributes.stroke);
                if (list.has('shadowColor') && attributes.shadowColor) object.parsedStyle.shadowColor = parseColor(attributes.shadowColor);
                if (list.has('filter') && attributes.filter) object.parsedStyle.filter = parseFilter(attributes.filter);
                // Rect
                // @ts-ignore
                if (list.has('radius') && !(0, $geZBG.default)(attributes.radius)) // @ts-ignore
                object.parsedStyle.radius = parseDimensionArrayFormat(// @ts-ignore
                attributes.radius, 4);
                // Polyline
                if (list.has('lineDash') && !(0, $geZBG.default)(attributes.lineDash)) // dom标准自动转化奇数长度数组,webgl需要手动处理
                object.parsedStyle.lineDash = parseDimensionArrayFormat(attributes.lineDash, 'even');
                // @ts-ignore
                if (list.has('points') && attributes.points) // @ts-ignore
                object.parsedStyle.points = parsePoints(attributes.points);
                // Path
                // @ts-ignore
                if (list.has('d') && attributes.d === '') object.parsedStyle.d = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, EMPTY_PARSED_PATH);
                // @ts-ignore
                if (list.has('d') && attributes.d) object.parsedStyle.d = parsePath(// @ts-ignore
                attributes.d);
                // Text
                if (list.has('textTransform') && attributes.textTransform) this.runtime.CSSPropertySyntaxFactory[PropertySyntax.TEXT_TRANSFORM].calculator(null, null, {
                    value: attributes.textTransform
                }, object, null);
                if (list.has('clipPath') && !(0, $aFcWQ.default)(attributes.clipPath)) this.runtime.CSSPropertySyntaxFactory[PropertySyntax.DEFINED_PATH].calculator('clipPath', oldClipPath, attributes.clipPath, object, this.runtime);
                if (list.has('offsetPath') && attributes.offsetPath) this.runtime.CSSPropertySyntaxFactory[PropertySyntax.DEFINED_PATH].calculator('offsetPath', oldOffsetPath, attributes.offsetPath, object, this.runtime);
                if (list.has('transform') && attributes.transform) object.parsedStyle.transform = parseTransform(attributes.transform);
                if (list.has('transformOrigin') && attributes.transformOrigin) object.parsedStyle.transformOrigin = parseTransformOrigin(attributes.transformOrigin);
                // Marker
                // @ts-ignore
                if (list.has('markerStart') && attributes.markerStart) object.parsedStyle.markerStart = this.runtime.CSSPropertySyntaxFactory[PropertySyntax.MARKER].calculator(null, // @ts-ignore
                attributes.markerStart, // @ts-ignore
                attributes.markerStart, null, null);
                // @ts-ignore
                if (list.has('markerEnd') && attributes.markerEnd) object.parsedStyle.markerEnd = this.runtime.CSSPropertySyntaxFactory[PropertySyntax.MARKER].calculator(null, // @ts-ignore
                attributes.markerEnd, // @ts-ignore
                attributes.markerEnd, null, null);
                // @ts-ignore
                if (list.has('markerMid') && attributes.markerMid) object.parsedStyle.markerMid = this.runtime.CSSPropertySyntaxFactory[PropertySyntax.MARKER].calculator('', // @ts-ignore
                attributes.markerMid, // @ts-ignore
                attributes.markerMid, null, null);
                if (list.has('zIndex') && !(0, $geZBG.default)(attributes.zIndex)) this.runtime.CSSPropertySyntaxFactory[PropertySyntax.Z_INDEX].postProcessor(object);
                if (list.has('offsetDistance') && !(0, $geZBG.default)(attributes.offsetDistance)) this.runtime.CSSPropertySyntaxFactory[PropertySyntax.OFFSET_DISTANCE].postProcessor(object);
                if (list.has('transform') && attributes.transform) this.runtime.CSSPropertySyntaxFactory[PropertySyntax.TRANSFORM].postProcessor(object);
                if (list.has('transformOrigin') && attributes.transformOrigin) this.runtime.CSSPropertySyntaxFactory[PropertySyntax.TRANSFORM_ORIGIN].postProcessor(object);
                if (needUpdateGeometry) {
                    object.dirty(true, true);
                    if (!options.forceUpdateGeometry) this.runtime.sceneGraphService.dirtyToRoot(object);
                }
            }
        },
        {
            key: "updateGeometry",
            value: function updateGeometry(object) {
                var nodeName = object.nodeName;
                var geometryUpdater = this.runtime.geometryUpdaterFactory[nodeName];
                if (geometryUpdater) {
                    var geometry = object.geometry;
                    if (!geometry.contentBounds) geometry.contentBounds = new AABB();
                    if (!geometry.renderBounds) geometry.renderBounds = new AABB();
                    var parsedStyle = object.parsedStyle;
                    var _geometryUpdater$upda = geometryUpdater.update(parsedStyle, object), _geometryUpdater$upda2 = _geometryUpdater$upda.cx, cx = _geometryUpdater$upda2 === void 0 ? 0 : _geometryUpdater$upda2, _geometryUpdater$upda3 = _geometryUpdater$upda.cy, cy = _geometryUpdater$upda3 === void 0 ? 0 : _geometryUpdater$upda3, _geometryUpdater$upda4 = _geometryUpdater$upda.cz, cz = _geometryUpdater$upda4 === void 0 ? 0 : _geometryUpdater$upda4, _geometryUpdater$upda5 = _geometryUpdater$upda.hwidth, hwidth = _geometryUpdater$upda5 === void 0 ? 0 : _geometryUpdater$upda5, _geometryUpdater$upda6 = _geometryUpdater$upda.hheight, hheight = _geometryUpdater$upda6 === void 0 ? 0 : _geometryUpdater$upda6, _geometryUpdater$upda7 = _geometryUpdater$upda.hdepth, hdepth = _geometryUpdater$upda7 === void 0 ? 0 : _geometryUpdater$upda7;
                    // init with content box
                    var halfExtents = [
                        Math.abs(hwidth),
                        Math.abs(hheight),
                        hdepth
                    ];
                    // anchor is center by default, don't account for lineWidth here
                    var stroke = parsedStyle.stroke, _parsedStyle$lineWidt = parsedStyle.lineWidth, lineWidth = _parsedStyle$lineWidt === void 0 ? 1 : _parsedStyle$lineWidt, _parsedStyle$increase = parsedStyle.increasedLineWidthForHitTesting, increasedLineWidthForHitTesting = _parsedStyle$increase === void 0 ? 0 : _parsedStyle$increase, _parsedStyle$shadowTy = parsedStyle.shadowType, shadowType = _parsedStyle$shadowTy === void 0 ? 'outer' : _parsedStyle$shadowTy, shadowColor = parsedStyle.shadowColor, _parsedStyle$filter = parsedStyle.filter, filter = _parsedStyle$filter === void 0 ? [] : _parsedStyle$filter, transformOrigin = parsedStyle.transformOrigin;
                    var center = [
                        cx,
                        cy,
                        cz
                    ];
                    // update geometry's AABB
                    geometry.contentBounds.update(center, halfExtents);
                    // @see https://github.molgen.mpg.de/git-mirror/cairo/blob/master/src/cairo-stroke-style.c#L97..L128
                    var expansion = nodeName === Shape.POLYLINE || nodeName === Shape.POLYGON || nodeName === Shape.PATH ? Math.SQRT2 : 0.5;
                    // append border only if stroke existed
                    var hasStroke = stroke && !stroke.isNone;
                    if (hasStroke) {
                        var halfLineWidth = ((lineWidth || 0) + (increasedLineWidthForHitTesting || 0)) * expansion;
                        halfExtents[0] += halfLineWidth;
                        halfExtents[1] += halfLineWidth;
                    }
                    geometry.renderBounds.update(center, halfExtents);
                    // account for shadow, only support constant value now
                    if (shadowColor && shadowType && shadowType !== 'inner') {
                        var _geometry$renderBound = geometry.renderBounds, min = _geometry$renderBound.min, max = _geometry$renderBound.max;
                        var shadowBlur = parsedStyle.shadowBlur, shadowOffsetX = parsedStyle.shadowOffsetX, shadowOffsetY = parsedStyle.shadowOffsetY;
                        var shadowBlurInPixels = shadowBlur || 0;
                        var shadowOffsetXInPixels = shadowOffsetX || 0;
                        var shadowOffsetYInPixels = shadowOffsetY || 0;
                        var shadowLeft = min[0] - shadowBlurInPixels + shadowOffsetXInPixels;
                        var shadowRight = max[0] + shadowBlurInPixels + shadowOffsetXInPixels;
                        var shadowTop = min[1] - shadowBlurInPixels + shadowOffsetYInPixels;
                        var shadowBottom = max[1] + shadowBlurInPixels + shadowOffsetYInPixels;
                        min[0] = Math.min(min[0], shadowLeft);
                        max[0] = Math.max(max[0], shadowRight);
                        min[1] = Math.min(min[1], shadowTop);
                        max[1] = Math.max(max[1], shadowBottom);
                        geometry.renderBounds.setMinMax(min, max);
                    }
                    // account for filter, eg. blur(5px), drop-shadow()
                    filter.forEach(function(_ref) {
                        var name = _ref.name, params = _ref.params;
                        if (name === 'blur') {
                            var blurRadius = params[0].value;
                            geometry.renderBounds.update(geometry.renderBounds.center, (0, $eIStk).add(geometry.renderBounds.halfExtents, geometry.renderBounds.halfExtents, [
                                blurRadius,
                                blurRadius,
                                0
                            ]));
                        } else if (name === 'drop-shadow') {
                            var _shadowOffsetX = params[0].value;
                            var _shadowOffsetY = params[1].value;
                            var _shadowBlur = params[2].value;
                            var _geometry$renderBound2 = geometry.renderBounds, _min = _geometry$renderBound2.min, _max = _geometry$renderBound2.max;
                            var _shadowLeft = _min[0] - _shadowBlur + _shadowOffsetX;
                            var _shadowRight = _max[0] + _shadowBlur + _shadowOffsetX;
                            var _shadowTop = _min[1] - _shadowBlur + _shadowOffsetY;
                            var _shadowBottom = _max[1] + _shadowBlur + _shadowOffsetY;
                            _min[0] = Math.min(_min[0], _shadowLeft);
                            _max[0] = Math.max(_max[0], _shadowRight);
                            _min[1] = Math.min(_min[1], _shadowTop);
                            _max[1] = Math.max(_max[1], _shadowBottom);
                            geometry.renderBounds.setMinMax(_min, _max);
                        }
                    });
                    object.geometry.dirty = false;
                    // @see https://github.com/antvis/g/issues/957
                    var flipY = hwidth < 0;
                    var flipX = hheight < 0;
                    // set transform origin
                    var usedOriginXValue = (flipY ? -1 : 1) * (transformOrigin ? convertPercentUnit(transformOrigin[0], 0, object, true) : 0);
                    var usedOriginYValue = (flipX ? -1 : 1) * (transformOrigin ? convertPercentUnit(transformOrigin[1], 1, object, true) : 0);
                    if (usedOriginXValue || usedOriginYValue) object.setOrigin(usedOriginXValue, usedOriginYValue);
                }
            }
        },
        {
            key: "updateSizeAttenuation",
            value: function updateSizeAttenuation(node, zoom) {
                if (node.style.isSizeAttenuation) {
                    if (!node.style.rawLineWidth) node.style.rawLineWidth = node.style.lineWidth;
                    node.style.lineWidth = (node.style.rawLineWidth || 1) / zoom;
                    if (node.nodeName === Shape.CIRCLE) {
                        if (!node.style.rawR) node.style.rawR = node.style.r;
                        node.style.r = (node.style.rawR || 1) / zoom;
                    }
                } else {
                    if (node.style.rawLineWidth) {
                        node.style.lineWidth = node.style.rawLineWidth;
                        delete node.style.rawLineWidth;
                    }
                    if (node.nodeName === Shape.CIRCLE) {
                        if (node.style.rawR) {
                            node.style.r = node.style.rawR;
                            delete node.style.rawR;
                        }
                    }
                }
            }
        }
    ]);
}();
function assignParsedStyle(object, attributes) {
    var list = getParsedStyleListOf(object);
    for(var key in attributes)if (list.has(key)) object.parsedStyle[key] = attributes[key];
}
function getParsedStyleListOf(object) {
    return object.constructor.PARSED_STYLE_LIST;
}
var CSSPropertyAngle = /*#__PURE__*/ function() {
    function CSSPropertyAngle() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyAngle);
        this.mixer = mergeNumbers;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyAngle, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, parsed, object) {
                return convertAngleUnit(parsed);
            }
        }
    ]);
}();
/**
 * clipPath / textPath / offsetPath
 */ var CSSPropertyClipPath = /*#__PURE__*/ function() {
    function CSSPropertyClipPath() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyClipPath);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyClipPath, [
        {
            key: "calculator",
            value: function calculator(name, oldPath, newPath, object, runtime) {
                // unset
                if (newPath instanceof CSSKeywordValue) newPath = null;
                runtime.sceneGraphService.updateDisplayObjectDependency(name, oldPath, newPath, object);
                if (name === 'clipPath') // should affect children
                object.forEach(function(leaf) {
                    if (leaf.childNodes.length === 0) runtime.sceneGraphService.dirtyToRoot(leaf);
                });
                return newPath;
            }
        }
    ]);
}();
var CSSPropertyColor = /*#__PURE__*/ function() {
    function CSSPropertyColor() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyColor);
        this.parser = parseColor;
        this.mixer = mergeColors;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyColor, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, parsed, object) {
                if (parsed instanceof CSSKeywordValue) // 'unset' 'none'
                return parsed.value === 'none' ? noneColor : transparentColor;
                return parsed;
            }
        }
    ]);
}();
var CSSPropertyFilter = /*#__PURE__*/ function() {
    function CSSPropertyFilter() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyFilter);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyFilter, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, parsed) {
                // unset or none
                if (parsed instanceof CSSKeywordValue) return [];
                return parsed;
            }
        }
    ]);
}();
function getFontSize(object) {
    var _ref = object.parsedStyle, fontSize = _ref.fontSize;
    return (0, $geZBG.default)(fontSize) ? null : fontSize;
}
/**
 * <length> & <percentage>
 */ var CSSPropertyLengthOrPercentage = /*#__PURE__*/ function() {
    function CSSPropertyLengthOrPercentage() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyLengthOrPercentage);
        this.mixer = mergeNumbers;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyLengthOrPercentage, [
        {
            key: "calculator",
            value: /**
     * according to parent's bounds
     *
     * @example
     * CSS.percent(50) -> CSS.px(0.5 * parent.width)
     */ function calculator(name, oldParsed, computed, object, runtime) {
                if ((0, $jyI49.default)(computed)) return computed;
                if (CSSUnitValue.isRelativeUnit(computed.unit)) {
                    if (computed.unit === UnitType.kPercentage) // TODO: merge dimensions
                    return 0;
                    if (computed.unit === UnitType.kEms) {
                        if (object.parentNode) {
                            var fontSize = getFontSize(object.parentNode);
                            if (fontSize) {
                                fontSize *= computed.value;
                                return fontSize;
                            }
                        }
                        return 0;
                    }
                    if (computed.unit === UnitType.kRems) {
                        var _object$ownerDocument;
                        if (object !== null && object !== void 0 && (_object$ownerDocument = object.ownerDocument) !== null && _object$ownerDocument !== void 0 && _object$ownerDocument.documentElement) {
                            var _fontSize = getFontSize(object.ownerDocument.documentElement);
                            if (_fontSize) {
                                _fontSize *= computed.value;
                                return _fontSize;
                            }
                        }
                        return 0;
                    }
                } else // remove listener if exists
                // registry.unregisterParentGeometryBoundsChangedHandler(object, name);
                // return absolute value
                return computed.value;
            }
        }
    ]);
}();
/**
 * format to Tuple2<CSSUnitValue>
 *
 * @example
 * rect.style.lineDash = 10;
 * rect.style.lineDash = [10, 10];
 * rect.style.lineDash = '10 10';
 */ var CSSPropertyLengthOrPercentage12 = /*#__PURE__*/ function() {
    function CSSPropertyLengthOrPercentage12() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyLengthOrPercentage12);
        this.mixer = mergeNumberLists;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyLengthOrPercentage12, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, computed) {
                return computed.map(function(c) {
                    return c.value;
                });
            }
        }
    ]);
}();
/**
 * used in rounded rect
 *
 * @example
 * rect.style.radius = 10;
 * rect.style.radius = '10 10';
 * rect.style.radius = '10 10 10 10';
 */ var CSSPropertyLengthOrPercentage14 = /*#__PURE__*/ function() {
    function CSSPropertyLengthOrPercentage14() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyLengthOrPercentage14);
        this.mixer = mergeNumberLists;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyLengthOrPercentage14, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, computed) {
                return computed.map(function(c) {
                    return c.value;
                });
            }
        }
    ]);
}();
var CSSPropertyMarker = /*#__PURE__*/ function() {
    function CSSPropertyMarker() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyMarker);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyMarker, [
        {
            key: "calculator",
            value: function calculator(name, oldMarker, newMarker, object) {
                var _newMarker;
                // unset
                if (newMarker instanceof CSSKeywordValue) newMarker = null;
                var cloned = (_newMarker = newMarker) === null || _newMarker === void 0 ? void 0 : _newMarker.cloneNode(true);
                if (cloned) // FIXME: SVG should not inherit parent's style, add a flag here
                cloned.style.isMarker = true;
                return cloned;
            }
        }
    ]);
}();
var CSSPropertyNumber = /*#__PURE__*/ function() {
    function CSSPropertyNumber() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyNumber);
        this.mixer = mergeNumbers;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyNumber, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, computed) {
                return computed.value;
            }
        }
    ]);
}();
var CSSPropertyOffsetDistance = /*#__PURE__*/ function() {
    function CSSPropertyOffsetDistance() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyOffsetDistance);
        this.mixer = clampedMergeNumbers(0, 1);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyOffsetDistance, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, computed) {
                return computed.value;
            }
        },
        {
            key: "postProcessor",
            value: function postProcessor(object) {
                var _object$parsedStyle = object.parsedStyle, offsetPath = _object$parsedStyle.offsetPath, offsetDistance = _object$parsedStyle.offsetDistance;
                if (!offsetPath) return;
                var nodeName = offsetPath.nodeName;
                if (nodeName === Shape.LINE || nodeName === Shape.PATH || nodeName === Shape.POLYLINE) {
                    // set position in world space
                    var point = offsetPath.getPoint(offsetDistance);
                    if (point) object.setLocalPosition(point.x, point.y);
                }
            }
        }
    ]);
}();
/**
 * opacity
 */ var CSSPropertyOpacity = /*#__PURE__*/ function() {
    function CSSPropertyOpacity() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyOpacity);
        this.mixer = clampedMergeNumbers(0, 1);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyOpacity, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, computed) {
                return computed.value;
            }
        }
    ]);
}();
var CSSPropertyPath = /*#__PURE__*/ function() {
    function CSSPropertyPath() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyPath);
        /**
     * path2Curve
     */ this.parser = parsePath;
        this.mixer = mergePaths;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyPath, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, parsed) {
                // unset
                if (parsed instanceof CSSKeywordValue && parsed.value === 'unset') return {
                    absolutePath: [],
                    hasArc: false,
                    segments: [],
                    polygons: [],
                    polylines: [],
                    curve: null,
                    totalLength: 0,
                    rect: new Rectangle(0, 0, 0, 0)
                };
                return parsed;
            }
        }
    ]);
}();
var CSSPropertyPoints = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(function CSSPropertyPoints() {
    (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyPoints);
    this.mixer = mergePoints;
});
var CSSPropertyShadowBlur = /*#__PURE__*/ function(_CSSPropertyLengthOrP) {
    function CSSPropertyShadowBlur() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyShadowBlur);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, CSSPropertyShadowBlur, [].concat(args));
        _this.mixer = clampedMergeNumbers(0, Infinity);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(CSSPropertyShadowBlur, _CSSPropertyLengthOrP);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyShadowBlur);
}(CSSPropertyLengthOrPercentage);
var CSSPropertyText = /*#__PURE__*/ function() {
    function CSSPropertyText() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyText);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyText, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, parsed, object) {
                if (parsed instanceof CSSKeywordValue) {
                    if (parsed.value === 'unset') return '';
                    return parsed.value;
                }
                // allow number as valid text content
                return "".concat(parsed);
            }
        },
        {
            key: "postProcessor",
            value: function postProcessor(object) {
                object.nodeValue = "".concat(object.parsedStyle.text) || '';
            }
        }
    ]);
}();
/**
 * it must transform after text get parsed
 * @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/text-transform
 */ var CSSPropertyTextTransform = /*#__PURE__*/ function() {
    function CSSPropertyTextTransform() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyTextTransform);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyTextTransform, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, parsed, object) {
                var rawText = object.getAttribute('text');
                if (rawText) {
                    var transformedText = rawText;
                    if (parsed.value === 'capitalize') transformedText = rawText.charAt(0).toUpperCase() + rawText.slice(1);
                    else if (parsed.value === 'lowercase') transformedText = rawText.toLowerCase();
                    else if (parsed.value === 'uppercase') transformedText = rawText.toUpperCase();
                    object.parsedStyle.text = transformedText;
                }
                return parsed.value;
            }
        }
    ]);
}();
var definedProps = function definedProps(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), v = _ref2[1];
        return v !== undefined;
    }));
};
var CANVAS_Map = new WeakMap();
/**
 * destroy existed canvas with the same id
 */ function cleanExistedCanvas(container, canvas, cleanUp) {
    if (container) {
        var $dom = typeof container === 'string' ? document.getElementById(container) : container;
        if (CANVAS_Map.has($dom)) CANVAS_Map.get($dom).destroy(cleanUp);
        CANVAS_Map.set($dom, canvas);
    }
}
var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
function isElement(target) {
    return !!target.getAttribute;
}
function sortedIndex(array, value) {
    var low = 0;
    var high = array.length;
    while(low < high){
        var mid = low + high >>> 1;
        if (sortByZIndex(array[mid], value) < 0) low = mid + 1;
        else high = mid;
    }
    return low;
}
function sortByZIndex(o1, o2) {
    var zIndex1 = Number(o1.parsedStyle.zIndex || 0);
    var zIndex2 = Number(o2.parsedStyle.zIndex || 0);
    if (zIndex1 === zIndex2) {
        var parent = o1.parentNode;
        if (parent) {
            var children = parent.childNodes || [];
            return children.indexOf(o1) - children.indexOf(o2);
        }
    }
    return zIndex1 - zIndex2;
}
function findClosestClipPathTarget(object) {
    var el = object;
    do {
        var _el$parsedStyle;
        var clipPath = (_el$parsedStyle = el.parsedStyle) === null || _el$parsedStyle === void 0 ? void 0 : _el$parsedStyle.clipPath;
        if (clipPath) return el;
        el = el.parentElement;
    }while (el !== null);
    return null;
}
var PX_SUFFIX = 'px';
function setDOMSize($el, width, height) {
    if (isBrowser && $el.style) {
        $el.style.width = width + PX_SUFFIX;
        $el.style.height = height + PX_SUFFIX;
    }
}
function getStyle($el, property) {
    if (isBrowser) return document.defaultView.getComputedStyle($el, null).getPropertyValue(property);
}
function getWidth($el) {
    var width = getStyle($el, 'width');
    if (width === 'auto') return $el.offsetWidth;
    return parseFloat(width);
}
function getHeight($el) {
    var height = getStyle($el, 'height');
    if (height === 'auto') return $el.offsetHeight;
    return parseFloat(height);
}
// borrow from hammer.js
var MOUSE_POINTER_ID = 1;
var TOUCH_TO_POINTER = {
    touchstart: 'pointerdown',
    touchend: 'pointerup',
    touchendoutside: 'pointerupoutside',
    touchmove: 'pointermove',
    touchcancel: 'pointercancel'
};
var clock = typeof performance === 'object' && performance.now ? performance : Date;
function isInFragment(node) {
    if (node.nodeName === Shape.FRAGMENT) return true;
    return node.getRootNode().nodeName === Shape.FRAGMENT;
}
function isFillOrStrokeAffected() {
    var pointerEvents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto';
    var fill = arguments.length > 1 ? arguments[1] : undefined;
    var stroke = arguments.length > 2 ? arguments[2] : undefined;
    // account for pointerEvents
    // @see https://developer.mozilla.org/en-US/docs/Web/CSS/pointer-events
    var hasFill = false;
    var hasStroke = false;
    var isFillOtherThanNone = !!fill && !fill.isNone;
    var isStrokeOtherThanNone = !!stroke && !stroke.isNone;
    if (pointerEvents === 'visiblepainted' || pointerEvents === 'painted' || pointerEvents === 'auto') {
        hasFill = isFillOtherThanNone;
        hasStroke = isStrokeOtherThanNone;
    } else if (pointerEvents === 'visiblefill' || pointerEvents === 'fill') hasFill = true;
    else if (pointerEvents === 'visiblestroke' || pointerEvents === 'stroke') hasStroke = true;
    else if (pointerEvents === 'visible' || pointerEvents === 'all') {
        // The values of the fill and stroke do not affect event processing.
        hasFill = true;
        hasStroke = true;
    }
    return [
        hasFill,
        hasStroke
    ];
}
/**
 * Thanks for following contributor of codes
 * https://gist.github.com/1866474
 * http://paulirish.com/2011/requestanimationframe-for-smart-animating/
 * http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
 * https://github.com/Financial-Times/polyfill-library/blob/master/polyfills/requestAnimationFrame/polyfill.js
 * */ var uId = 1;
var uniqueId = function uniqueId() {
    return uId++;
};
// We use `self` instead of `window` for `WebWorker` support.
var root = // eslint-disable-next-line no-nested-ternary
typeof self === 'object' && self.self === self ? self : // @ts-ignore
typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global ? // @ts-ignore
$parcel$global : {};
var nowOffset = Date.now();
// use performance api if exist, otherwise use Date.now.
// Date.now polyfill required.
var pnow = function pnow() {
    if (root.performance && typeof root.performance.now === 'function') return root.performance.now();
    // fallback
    return Date.now() - nowOffset;
};
var reservedCBs = {};
var lastTime = Date.now();
var polyfillRaf = function polyfillRaf(callback) {
    if (typeof callback !== 'function') throw new TypeError("".concat(callback, " is not a function"));
    var currentTime = Date.now();
    var gap = currentTime - lastTime;
    var delay = gap > 16 ? 0 : 16 - gap;
    var id = uniqueId();
    reservedCBs[id] = callback;
    // keys(reservedCBs).length > 1 의미는 이미 setTimeout 이 걸려있는 경우.
    // 함께 callback 이 실행될 수 있게 reservedCBs 에만 추가해주고 return
    if (Object.keys(reservedCBs).length > 1) return id;
    setTimeout(function() {
        lastTime = currentTime;
        var copied = reservedCBs;
        reservedCBs = {};
        Object.keys(copied).forEach(function(key) {
            return copied[key](pnow());
        });
    }, delay);
    return id;
};
var polyfillCaf = function polyfillCaf(id) {
    delete reservedCBs[id];
};
var vendorPrefixes = [
    '',
    'webkit',
    'moz',
    'ms',
    'o'
];
var getRequestAnimationFrame = function getRequestAnimationFrame(vp) {
    if (typeof vp !== 'string') return polyfillRaf;
    if (vp === '') return root.requestAnimationFrame;
    return root["".concat(vp, "RequestAnimationFrame")];
};
var getCancelAnimationFrame = function getCancelAnimationFrame(vp) {
    if (typeof vp !== 'string') return polyfillCaf;
    if (vp === '') return root.cancelAnimationFrame;
    return root["".concat(vp, "CancelAnimationFrame")] || root["".concat(vp, "CancelRequestAnimationFrame")];
};
var find = function find(arr, predicate) {
    var i = 0;
    while(arr[i] !== undefined){
        if (predicate(arr[i])) return arr[i];
        i += 1;
    }
};
var vp = find(vendorPrefixes, function(vp) {
    return !!getRequestAnimationFrame(vp);
});
var raf = getRequestAnimationFrame(vp);
var caf = getCancelAnimationFrame(vp);
root.requestAnimationFrame = raf;
root.cancelAnimationFrame = caf;
var AsyncParallelHook = /*#__PURE__*/ function() {
    function AsyncParallelHook() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AsyncParallelHook);
        this.callbacks = [];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AsyncParallelHook, [
        {
            key: "getCallbacksNum",
            value: function getCallbacksNum() {
                return this.callbacks.length;
            }
        },
        {
            key: "tapPromise",
            value: function tapPromise(options, fn) {
                this.callbacks.push(fn);
            }
        },
        {
            key: "promise",
            value: function promise() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return Promise.all(this.callbacks.map(function(callback) {
                    return callback.apply(void 0, args);
                }));
            }
        }
    ]);
}();
var AsyncSeriesWaterfallHook = /*#__PURE__*/ function() {
    function AsyncSeriesWaterfallHook() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, AsyncSeriesWaterfallHook);
        this.callbacks = [];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(AsyncSeriesWaterfallHook, [
        {
            key: "tapPromise",
            value: function tapPromise(options, fn) {
                this.callbacks.push(fn);
            }
        },
        {
            key: "promise",
            value: function() {
                var _promise = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee() {
                    var _this$callbacks, result, i, callback, _args = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!this.callbacks.length) {
                                    _context.next = 6;
                                    break;
                                }
                                _context.next = 1;
                                return (_this$callbacks = this.callbacks)[0].apply(_this$callbacks, _args);
                            case 1:
                                result = _context.sent;
                                i = 1;
                            case 2:
                                if (!(i < this.callbacks.length)) {
                                    _context.next = 5;
                                    break;
                                }
                                callback = this.callbacks[i]; // @ts-ignore
                                // eslint-disable-next-line no-await-in-loop
                                _context.next = 3;
                                return callback(result);
                            case 3:
                                result = _context.sent;
                            case 4:
                                i++;
                                _context.next = 2;
                                break;
                            case 5:
                                return _context.abrupt("return", result);
                            case 6:
                                return _context.abrupt("return", null);
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function promise() {
                    return _promise.apply(this, arguments);
                }
                return promise;
            }()
        }
    ]);
}();
var SyncHook = /*#__PURE__*/ function() {
    function SyncHook() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, SyncHook);
        this.callbacks = [];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(SyncHook, [
        {
            key: "tap",
            value: function tap(options, fn) {
                this.callbacks.push(fn);
            }
        },
        {
            key: "call",
            value: function call() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                /* eslint-disable-next-line prefer-rest-params */ var argsArr = arguments;
                this.callbacks.forEach(function(callback) {
                    /* eslint-disable-next-line prefer-spread */ callback.apply(undefined, argsArr);
                });
            }
        }
    ]);
}();
var SyncWaterfallHook = /*#__PURE__*/ function() {
    function SyncWaterfallHook() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, SyncWaterfallHook);
        this.callbacks = [];
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(SyncWaterfallHook, [
        {
            key: "tap",
            value: function tap(options, fn) {
                this.callbacks.push(fn);
            }
        },
        {
            key: "call",
            value: function call() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                if (this.callbacks.length) {
                    /* eslint-disable-next-line prefer-rest-params */ var argsArr = arguments;
                    /* eslint-disable-next-line prefer-spread */ var result = this.callbacks[0].apply(undefined, argsArr);
                    for(var i = 1; i < this.callbacks.length; i++){
                        var callback = this.callbacks[i];
                        // @ts-ignore
                        result = callback(result);
                    }
                    return result;
                }
                return null;
            }
        }
    ]);
}();
var genericFontFamilies = [
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui'
];
var stringRegExp = /([\"\'])[^\'\"]+\1/;
function getFontAttr(attributes) {
    var _attributes$fontSize = attributes.fontSize, fontSize = _attributes$fontSize === void 0 ? 16 : _attributes$fontSize, _attributes$fontFamil = attributes.fontFamily, fontFamily = _attributes$fontFamil === void 0 ? 'sans-serif' : _attributes$fontFamil, _attributes$fontStyle = attributes.fontStyle, fontStyle = _attributes$fontStyle === void 0 ? 'normal' : _attributes$fontStyle, _attributes$fontVaria = attributes.fontVariant, fontVariant = _attributes$fontVaria === void 0 ? 'normal' : _attributes$fontVaria, _attributes$fontWeigh = attributes.fontWeight, fontWeight = _attributes$fontWeigh === void 0 ? 'normal' : _attributes$fontWeigh;
    return {
        fontSize: fontSize,
        fontFamily: fontFamily,
        fontStyle: fontStyle,
        fontVariant: fontVariant,
        fontWeight: fontWeight
    };
}
var toFontString = memoize(function toFontStringRaw(attributes) {
    var _getFontAttr = getFontAttr(attributes), fontSize = _getFontAttr.fontSize, fontFamily = _getFontAttr.fontFamily, fontStyle = _getFontAttr.fontStyle, fontVariant = _getFontAttr.fontVariant, fontWeight = _getFontAttr.fontWeight;
    // build canvas api font setting from individual components. Convert a numeric this.fontSize to px
    // const fontSizeString: string = isNumber(fontSize) ? `${fontSize}px` : fontSize.toString();
    var fontSizeString = (0, $jyI49.default)(fontSize) && "".concat(fontSize, "px") || '16px';
    // Clean-up fontFamily property by quoting each font name
    // this will support font names with spaces
    var fontFamilies = fontFamily.split(',');
    for(var i = fontFamilies.length - 1; i >= 0; i--){
        // Trim any extra white-space
        var _fontFamily = fontFamilies[i].trim();
        // Check if font already contains strings
        if (!stringRegExp.test(_fontFamily) && genericFontFamilies.indexOf(_fontFamily) < 0) _fontFamily = "\"".concat(_fontFamily, "\"");
        fontFamilies[i] = _fontFamily;
    }
    return "".concat(fontStyle, " ").concat(fontVariant, " ").concat(fontWeight, " ").concat(fontSizeString, " ").concat(fontFamilies.join(','));
}, function(attributes) {
    var _getFontAttr2 = getFontAttr(attributes), fontSize = _getFontAttr2.fontSize, fontFamily = _getFontAttr2.fontFamily, fontStyle = _getFontAttr2.fontStyle, fontVariant = _getFontAttr2.fontVariant, fontWeight = _getFontAttr2.fontWeight;
    return "".concat(fontStyle, "_").concat(fontVariant, "_").concat(fontWeight, "_").concat(fontSize, "_").concat(fontFamily);
});
/**
 * Minimum scaling limit
 *
 * When `scale` is 0, the matrix will become an irreversible matrix,
 * and `NaN` will appear during matrix calculation and decomposition,
 * causing exceptions
 */ var MIN_SCALE = 0.000001;
var clampScale = function clampScale(item) {
    return Math.max(item, MIN_SCALE);
};
function createSkewMatrix(skewMatrix, skewX, skewY) {
    // Create an identity matrix
    (0, $3iqbd).identity(skewMatrix);
    // Apply skew to the matrix
    skewMatrix[4] = Math.tan(skewX); // Skew Y axis in X direction
    skewMatrix[1] = Math.tan(skewY); // Skew X axis in Y direction
    return skewMatrix;
}
var $mat4_1 = (0, $3iqbd).create();
var $mat4_2 = (0, $3iqbd).create();
var parser = {
    scale: function scale(d) {
        (0, $3iqbd).fromScaling($mat4_1, [
            d[0].value,
            d[1].value,
            1
        ].map(function(item) {
            return clampScale(item);
        }));
    },
    scaleX: function scaleX(d) {
        (0, $3iqbd).fromScaling($mat4_1, [
            d[0].value,
            1,
            1
        ].map(function(item) {
            return clampScale(item);
        }));
    },
    scaleY: function scaleY(d) {
        (0, $3iqbd).fromScaling($mat4_1, [
            1,
            d[0].value,
            1
        ].map(function(item) {
            return clampScale(item);
        }));
    },
    scaleZ: function scaleZ(d) {
        (0, $3iqbd).fromScaling($mat4_1, [
            1,
            1,
            d[0].value
        ].map(function(item) {
            return clampScale(item);
        }));
    },
    scale3d: function scale3d(d) {
        (0, $3iqbd).fromScaling($mat4_1, [
            d[0].value,
            d[1].value,
            d[2].value
        ].map(function(item) {
            return clampScale(item);
        }));
    },
    translate: function translate(d) {
        (0, $3iqbd).fromTranslation($mat4_1, [
            d[0].value,
            d[1].value,
            0
        ]);
    },
    translateX: function translateX(d) {
        (0, $3iqbd).fromTranslation($mat4_1, [
            d[0].value,
            0,
            0
        ]);
    },
    translateY: function translateY(d) {
        (0, $3iqbd).fromTranslation($mat4_1, [
            0,
            d[0].value,
            0
        ]);
    },
    translateZ: function translateZ(d) {
        (0, $3iqbd).fromTranslation($mat4_1, [
            0,
            0,
            d[0].value
        ]);
    },
    translate3d: function translate3d(d) {
        (0, $3iqbd).fromTranslation($mat4_1, [
            d[0].value,
            d[1].value,
            d[2].value
        ]);
    },
    rotate: function rotate(d) {
        (0, $3iqbd).fromZRotation($mat4_1, deg2rad(convertAngleUnit(d[0])));
    },
    rotateX: function rotateX(d) {
        (0, $3iqbd).fromXRotation($mat4_1, deg2rad(convertAngleUnit(d[0])));
    },
    rotateY: function rotateY(d) {
        (0, $3iqbd).fromYRotation($mat4_1, deg2rad(convertAngleUnit(d[0])));
    },
    rotateZ: function rotateZ(d) {
        (0, $3iqbd).fromZRotation($mat4_1, deg2rad(convertAngleUnit(d[0])));
    },
    rotate3d: function rotate3d(d) {
        (0, $3iqbd).fromRotation($mat4_1, deg2rad(convertAngleUnit(d[3])), [
            d[0].value,
            d[1].value,
            d[2].value
        ]);
    },
    skew: function skew(d) {
        createSkewMatrix($mat4_1, deg2rad(d[0].value), deg2rad(d[1].value));
    },
    skewX: function skewX(d) {
        createSkewMatrix($mat4_1, deg2rad(d[0].value), 0);
    },
    skewY: function skewY(d) {
        createSkewMatrix($mat4_1, 0, deg2rad(d[0].value));
    },
    matrix: function matrix(d) {
        // prettier-ignore
        (0, $3iqbd).set($mat4_1, d[0].value, d[1].value, 0, 0, d[2].value, d[3].value, 0, 0, 0, 0, 1, 0, d[4].value, d[5].value, 0, 1);
    },
    matrix3d: function matrix3d(d) {
        // @ts-ignore
        (0, $3iqbd).set.apply((0, $3iqbd), [
            $mat4_1
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(d.map(function(s) {
            return s.value;
        }))));
    }
};
var $vec3One$1 = (0, $eIStk).fromValues(1, 1, 1);
var $vec3Zero$1 = (0, $eIStk).create();
var optimizer = {
    translate: function translate(object, d) {
        runtime.sceneGraphService.setLocalScale(object, $vec3One$1, false);
        runtime.sceneGraphService.setLocalEulerAngles(object, $vec3Zero$1, undefined, undefined, false);
        runtime.sceneGraphService.setLocalPosition(object, [
            d[0].value,
            d[1].value,
            0
        ], false);
        runtime.sceneGraphService.dirtyLocalTransform(object, object.transformable);
    }
};
function parsedTransformToMat4(transform, object) {
    if (transform.length) {
        if (transform.length === 1 && optimizer[transform[0].t]) {
            optimizer[transform[0].t](object, transform[0].d);
            return;
        }
        var m = (0, $3iqbd).identity($mat4_2);
        for(var i = 0; i < transform.length; i++){
            var _transform$i = transform[i], t = _transform$i.t, d = _transform$i.d;
            var p = parser[t];
            if (p) {
                p(d);
                (0, $3iqbd).mul(m, m, $mat4_1);
            }
        }
        object.setLocalTransform(m);
    } else object.resetLocalTransform();
    return object.getLocalTransform();
}
/**
 * @see /zh/docs/api/animation#支持变换的属性
 *
 * support the following formats like CSS Transform:
 *
 * scale
 * * scale(x, y)
 * * scaleX(x)
 * * scaleY(x)
 * * scaleZ(z)
 * * scale3d(x, y, z)
 *
 * translate (unit: none, px, %(relative to its bounds))
 * * translate(x, y) eg. translate(0, 0) translate(0, 30px) translate(100%, 100%)
 * * translateX(0)
 * * translateY(0)
 * * translateZ(0)
 * * translate3d(0, 0, 0)
 *
 * rotate (unit: deg rad turn)
 * * rotate(0.5turn) rotate(30deg) rotate(1rad)
 *
 * none
 *
 * unsupported for now:
 * * calc() eg. translate(calc(100% + 10px))
 * * matrix/matrix3d()
 * * skew/skewX/skewY
 * * perspective
 */ var CSSPropertyTransform = /*#__PURE__*/ function() {
    function CSSPropertyTransform() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyTransform);
        this.parser = parseTransformUnmemoize;
        this.mixer = mergeTransforms;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyTransform, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, parsed, object) {
                // 'none'
                if (parsed instanceof CSSKeywordValue) return [];
                return parsed;
            }
        },
        {
            key: "postProcessor",
            value: function postProcessor(object) {
                parsedTransformToMat4(object.parsedStyle.transform, object);
            }
        }
    ]);
}();
/**
 * @see https://developer.mozilla.org/zh-CN/docs/Web/CSS/transform-origin
 * @example
 * [10px, 10px] [10%, 10%]
 */ var CSSPropertyTransformOrigin = /*#__PURE__*/ function() {
    function CSSPropertyTransformOrigin() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyTransformOrigin);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyTransformOrigin, [
        {
            key: "postProcessor",
            value: function postProcessor(object) {
                var transformOrigin = object.parsedStyle.transformOrigin;
                if (transformOrigin[0].unit === UnitType.kPixels && transformOrigin[1].unit === UnitType.kPixels) object.setOrigin(transformOrigin[0].value, transformOrigin[1].value);
                else // Relative to geometry bounds, calculate later.
                object.getGeometryBounds();
            }
        }
    ]);
}();
var CSSPropertyZIndex = /*#__PURE__*/ function() {
    function CSSPropertyZIndex() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CSSPropertyZIndex);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CSSPropertyZIndex, [
        {
            key: "calculator",
            value: function calculator(name, oldParsed, computed, object) {
                return computed.value;
            }
        },
        {
            key: "postProcessor",
            value: function postProcessor(object) {
                if (object.parentNode) {
                    var parentEntity = object.parentNode;
                    var parentRenderable = parentEntity.renderable;
                    var parentSortable = parentEntity.sortable;
                    if (parentRenderable) parentEntity.dirty();
                    // need re-sort on parent
                    if (parentSortable) {
                        parentSortable.dirty = true;
                        parentSortable.dirtyReason = SortReason.Z_INDEX_CHANGED;
                    }
                }
            }
        }
    ]);
}();
var CircleUpdater = /*#__PURE__*/ function() {
    function CircleUpdater() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CircleUpdater);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CircleUpdater, [
        {
            key: "update",
            value: function update(parsedStyle, object) {
                var _parsedStyle$cx = parsedStyle.cx, cx = _parsedStyle$cx === void 0 ? 0 : _parsedStyle$cx, _parsedStyle$cy = parsedStyle.cy, cy = _parsedStyle$cy === void 0 ? 0 : _parsedStyle$cy, _parsedStyle$r = parsedStyle.r, r = _parsedStyle$r === void 0 ? 0 : _parsedStyle$r;
                return {
                    cx: cx,
                    cy: cy,
                    hwidth: r,
                    hheight: r
                };
            }
        }
    ]);
}();
var EllipseUpdater = /*#__PURE__*/ function() {
    function EllipseUpdater() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, EllipseUpdater);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(EllipseUpdater, [
        {
            key: "update",
            value: function update(parsedStyle, object) {
                var _parsedStyle$cx = parsedStyle.cx, cx = _parsedStyle$cx === void 0 ? 0 : _parsedStyle$cx, _parsedStyle$cy = parsedStyle.cy, cy = _parsedStyle$cy === void 0 ? 0 : _parsedStyle$cy, _parsedStyle$rx = parsedStyle.rx, rx = _parsedStyle$rx === void 0 ? 0 : _parsedStyle$rx, _parsedStyle$ry = parsedStyle.ry, ry = _parsedStyle$ry === void 0 ? 0 : _parsedStyle$ry;
                return {
                    cx: cx,
                    cy: cy,
                    hwidth: rx,
                    hheight: ry
                };
            }
        }
    ]);
}();
var LineUpdater = /*#__PURE__*/ function() {
    function LineUpdater() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, LineUpdater);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(LineUpdater, [
        {
            key: "update",
            value: function update(parsedStyle) {
                var x1 = parsedStyle.x1, y1 = parsedStyle.y1, x2 = parsedStyle.x2, y2 = parsedStyle.y2;
                var minX = Math.min(x1, x2);
                var maxX = Math.max(x1, x2);
                var minY = Math.min(y1, y2);
                var maxY = Math.max(y1, y2);
                var width = maxX - minX;
                var height = maxY - minY;
                var hwidth = width / 2;
                var hheight = height / 2;
                return {
                    cx: minX + hwidth,
                    cy: minY + hheight,
                    hwidth: hwidth,
                    hheight: hheight
                };
            }
        }
    ]);
}();
var PathUpdater = /*#__PURE__*/ function() {
    function PathUpdater() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, PathUpdater);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(PathUpdater, [
        {
            key: "update",
            value: function update(parsedStyle) {
                var d = parsedStyle.d;
                var _d$rect = d.rect, x = _d$rect.x, y = _d$rect.y, width = _d$rect.width, height = _d$rect.height;
                var hwidth = width / 2;
                var hheight = height / 2;
                return {
                    cx: x + hwidth,
                    cy: y + hheight,
                    hwidth: hwidth,
                    hheight: hheight
                };
            }
        }
    ]);
}();
var PolylineUpdater = /*#__PURE__*/ function() {
    function PolylineUpdater() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, PolylineUpdater);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(PolylineUpdater, [
        {
            key: "update",
            value: function update(parsedStyle) {
                if (parsedStyle.points && (0, $1uF5a.default)(parsedStyle.points.points)) {
                    var points = parsedStyle.points.points;
                    // FIXME: account for miter lineJoin
                    var minX = Math.min.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(points.map(function(point) {
                        return point[0];
                    })));
                    var maxX = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(points.map(function(point) {
                        return point[0];
                    })));
                    var minY = Math.min.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(points.map(function(point) {
                        return point[1];
                    })));
                    var maxY = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(points.map(function(point) {
                        return point[1];
                    })));
                    var width = maxX - minX;
                    var height = maxY - minY;
                    var hwidth = width / 2;
                    var hheight = height / 2;
                    return {
                        cx: minX + hwidth,
                        cy: minY + hheight,
                        hwidth: hwidth,
                        hheight: hheight
                    };
                }
                return {
                    cx: 0,
                    cy: 0,
                    hwidth: 0,
                    hheight: 0
                };
            }
        }
    ]);
}();
var RectUpdater = /*#__PURE__*/ function() {
    function RectUpdater() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RectUpdater);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RectUpdater, [
        {
            key: "update",
            value: function update(parsedStyle, object) {
                var _parsedStyle$x = parsedStyle.x, x = _parsedStyle$x === void 0 ? 0 : _parsedStyle$x, _parsedStyle$y = parsedStyle.y, y = _parsedStyle$y === void 0 ? 0 : _parsedStyle$y, src = parsedStyle.src, _parsedStyle$width = parsedStyle.width, width = _parsedStyle$width === void 0 ? 0 : _parsedStyle$width, _parsedStyle$height = parsedStyle.height, height = _parsedStyle$height === void 0 ? 0 : _parsedStyle$height;
                var contentWidth = width;
                var contentHeight = height;
                // resize with HTMLImageElement's size
                if (src && !(0, $kVcyu.default)(src)) {
                    if (!contentWidth) {
                        contentWidth = src.width;
                        parsedStyle.width = contentWidth;
                    }
                    if (!contentHeight) {
                        contentHeight = src.height;
                        parsedStyle.height = contentHeight;
                    }
                }
                return {
                    cx: x + contentWidth / 2,
                    cy: y + contentHeight / 2,
                    hwidth: contentWidth / 2,
                    hheight: contentHeight / 2
                };
            }
        }
    ]);
}();
var TextUpdater = /*#__PURE__*/ function() {
    function TextUpdater(globalRuntime) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, TextUpdater);
        this.globalRuntime = globalRuntime;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(TextUpdater, [
        {
            key: "isReadyToMeasure",
            value: function isReadyToMeasure(parsedStyle, object) {
                var text = parsedStyle.text;
                return text;
            }
        },
        {
            key: "update",
            value: function update(parsedStyle, object) {
                var _object$ownerDocument;
                var text = parsedStyle.text, _parsedStyle$textAlig = parsedStyle.textAlign, textAlign = _parsedStyle$textAlig === void 0 ? 'start' : _parsedStyle$textAlig, _parsedStyle$lineWidt = parsedStyle.lineWidth, lineWidth = _parsedStyle$lineWidt === void 0 ? 1 : _parsedStyle$lineWidt, _parsedStyle$textBase = parsedStyle.textBaseline, textBaseline = _parsedStyle$textBase === void 0 ? 'alphabetic' : _parsedStyle$textBase, _parsedStyle$dx = parsedStyle.dx, dx = _parsedStyle$dx === void 0 ? 0 : _parsedStyle$dx, _parsedStyle$dy = parsedStyle.dy, dy = _parsedStyle$dy === void 0 ? 0 : _parsedStyle$dy, _parsedStyle$x = parsedStyle.x, x = _parsedStyle$x === void 0 ? 0 : _parsedStyle$x, _parsedStyle$y = parsedStyle.y, y = _parsedStyle$y === void 0 ? 0 : _parsedStyle$y;
                if (!this.isReadyToMeasure(parsedStyle, object)) {
                    parsedStyle.metrics = {
                        font: '',
                        width: 0,
                        height: 0,
                        lines: [],
                        lineWidths: [],
                        lineHeight: 0,
                        maxLineWidth: 0,
                        fontProperties: {
                            ascent: 0,
                            descent: 0,
                            fontSize: 0
                        },
                        lineMetrics: []
                    };
                    return {
                        hwidth: 0,
                        hheight: 0,
                        cx: 0,
                        cy: 0
                    };
                }
                var _ref = (object === null || object === void 0 || (_object$ownerDocument = object.ownerDocument) === null || _object$ownerDocument === void 0 || (_object$ownerDocument = _object$ownerDocument.defaultView) === null || _object$ownerDocument === void 0 ? void 0 : _object$ownerDocument.getConfig()) || {}, offscreenCanvas = _ref.offscreenCanvas;
                var metrics = this.globalRuntime.textService.measureText(text, parsedStyle, offscreenCanvas);
                parsedStyle.metrics = metrics;
                var width = metrics.width, height = metrics.height;
                var hwidth = width / 2;
                var hheight = height / 2;
                // default 'left'
                var lineXOffset = x + hwidth;
                if (textAlign === 'center' || textAlign === 'middle') lineXOffset += lineWidth / 2 - hwidth;
                else if (textAlign === 'right' || textAlign === 'end') lineXOffset += lineWidth - hwidth * 2;
                var lineYOffset = y - hheight;
                if (textBaseline === 'middle') lineYOffset += hheight;
                else if (textBaseline === 'top' || textBaseline === 'hanging') lineYOffset += hheight * 2;
                else if (textBaseline === 'alphabetic') ;
                else if (textBaseline === 'bottom' || textBaseline === 'ideographic') lineYOffset += 0;
                // TODO: ideographic & bottom
                if (dx) lineXOffset += dx;
                if (dy) lineYOffset += dy;
                return {
                    cx: lineXOffset,
                    cy: lineYOffset,
                    hwidth: hwidth,
                    hheight: hheight
                };
            }
        }
    ]);
}();
var GroupUpdater = /*#__PURE__*/ function() {
    function GroupUpdater() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, GroupUpdater);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(GroupUpdater, [
        {
            key: "update",
            value: function update(parsedStyle, object) {
                return {
                    cx: 0,
                    cy: 0,
                    hwidth: 0,
                    hheight: 0
                };
            }
        }
    ]);
}();
var HTMLUpdater = /*#__PURE__*/ function() {
    function HTMLUpdater() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, HTMLUpdater);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(HTMLUpdater, [
        {
            key: "update",
            value: function update(parsedStyle, object) {
                var _parsedStyle$x = parsedStyle.x, x = _parsedStyle$x === void 0 ? 0 : _parsedStyle$x, _parsedStyle$y = parsedStyle.y, y = _parsedStyle$y === void 0 ? 0 : _parsedStyle$y, _parsedStyle$width = parsedStyle.width, width = _parsedStyle$width === void 0 ? 0 : _parsedStyle$width, _parsedStyle$height = parsedStyle.height, height = _parsedStyle$height === void 0 ? 0 : _parsedStyle$height;
                return {
                    cx: x + width / 2,
                    cy: y + height / 2,
                    hwidth: width / 2,
                    hheight: height / 2
                };
            }
        }
    ]);
}();
function isFederatedEvent(value) {
    return !!value.type;
}
/**
 * An DOM-compatible synthetic event implementation that is "forwarded" on behalf of an original
 * FederatedEvent or native Event.
 */ var FederatedEvent = /*#__PURE__*/ function() {
    /**
   * The event boundary which manages this event. Propagation can only occur
   *  within the boundary's jurisdiction.
   */ function FederatedEvent(manager) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FederatedEvent);
        /**
     * The propagation phase.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Event/eventPhase
     */ this.eventPhase = FederatedEvent.prototype.NONE;
        /**
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Event/bubbles
     */ this.bubbles = true;
        /**
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Event/cancelBubble
     */ this.cancelBubble = true;
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Event/cancelable
     */ this.cancelable = false;
        /** Flags whether the default response of the user agent was prevent through this event. */ this.defaultPrevented = false;
        /** Flags whether propagation was stopped. */ this.propagationStopped = false;
        /** Flags whether propagation was immediately stopped. */ this.propagationImmediatelyStopped = false;
        /**
     * The coordinates of the evnet relative to the nearest DOM layer.
     * This is a non-standard property.
     */ this.layer = new Point();
        /**
     * The coordinates of the event relative to the DOM document.
     * This is a non-standard property.
     * relative to the DOM document.
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/MouseEvent/pageX
     */ this.page = new Point();
        /**
     * relative to Canvas, origin is left-top
     */ this.canvas = new Point();
        /**
     * relative to Viewport, account for Camera
     */ this.viewport = new Point();
        this.composed = false;
        this.NONE = 0;
        this.CAPTURING_PHASE = 1;
        this.AT_TARGET = 2;
        this.BUBBLING_PHASE = 3;
        this.manager = manager;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FederatedEvent, [
        {
            key: "name",
            get: /**
     * The type of event, supports the following:
     * * pointerdown
     * * touchstart
     * * mousedown
     * * rightdown
     * * ...
     */ /**
     * @deprecated
     */ function get() {
                return this.type;
            }
        },
        {
            key: "layerX",
            get: function get() {
                return this.layer.x;
            }
        },
        {
            key: "layerY",
            get: function get() {
                return this.layer.y;
            }
        },
        {
            key: "pageX",
            get: function get() {
                return this.page.x;
            }
        },
        {
            key: "pageY",
            get: function get() {
                return this.page.y;
            }
        },
        {
            key: "x",
            get: function get() {
                return this.canvas.x;
            }
        },
        {
            key: "y",
            get: function get() {
                return this.canvas.y;
            }
        },
        {
            key: "canvasX",
            get: function get() {
                return this.canvas.x;
            }
        },
        {
            key: "canvasY",
            get: function get() {
                return this.canvas.y;
            }
        },
        {
            key: "viewportX",
            get: function get() {
                return this.viewport.x;
            }
        },
        {
            key: "viewportY",
            get: function get() {
                return this.viewport.y;
            }
        },
        {
            key: "composedPath",
            value: /**
     * The propagation path for this event
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Event/composedPath
     *
     * So composedPath()[0] represents the original target.
     * @see https://polymer-library.polymer-project.org/3.0/docs/devguide/events#retargeting
     */ function composedPath() {
                if (this.manager && (!this.path || this.path[0] !== this.target)) this.path = this.target ? this.manager.propagationPath(this.target) : [];
                return this.path;
            }
        },
        {
            key: "propagationPath",
            get: function get() {
                return this.composedPath();
            }
        },
        {
            key: "preventDefault",
            value: function preventDefault() {
                if (this.nativeEvent instanceof Event && this.nativeEvent.cancelable) this.nativeEvent.preventDefault();
                this.defaultPrevented = true;
            }
        },
        {
            key: "stopImmediatePropagation",
            value: function stopImmediatePropagation() {
                this.propagationImmediatelyStopped = true;
            }
        },
        {
            key: "stopPropagation",
            value: function stopPropagation() {
                this.propagationStopped = true;
            }
        },
        {
            key: "initEvent",
            value: /**
     * added for compatibility with DOM Event,
     * deprecated props and methods
     */ function initEvent() {}
        },
        {
            key: "initUIEvent",
            value: function initUIEvent() {}
        },
        {
            key: "clone",
            value: function clone() {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        }
    ]);
}();
var FederatedMouseEvent = /*#__PURE__*/ function(_ref) {
    function FederatedMouseEvent() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FederatedMouseEvent);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, FederatedMouseEvent, [].concat(args));
        /** Whether the "alt" key was pressed when this mouse event occurred. */ /** The specific button that was pressed in this mouse event. */ /** The button depressed when this event occurred. */ /** Whether the "control" key was pressed when this mouse event occurred. */ /** Whether the "meta" key was pressed when this mouse event occurred. */ /** This is currently not implemented in the Federated Events API. */ // @ts-ignore
        /** Whether the "shift" key was pressed when this mouse event occurred. */ /**
     * The coordinates of the mouse event relative to the canvas.
     */ _this.client = new Point();
        /**
     * The movement in this pointer relative to the last `mousemove` event.
     */ _this.movement = new Point();
        /**
     * The offset of the pointer coordinates w.r.t. target DisplayObject in world space. This is
     * not supported at the moment.
     */ _this.offset = new Point();
        /**
     * The pointer coordinates in world space.
     */ _this.global = new Point();
        /**
     * The pointer coordinates in sceen space.
     */ _this.screen = new Point();
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(FederatedMouseEvent, _ref);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FederatedMouseEvent, [
        {
            key: "clientX",
            get: function get() {
                return this.client.x;
            }
        },
        {
            key: "clientY",
            get: function get() {
                return this.client.y;
            }
        },
        {
            key: "movementX",
            get: function get() {
                return this.movement.x;
            }
        },
        {
            key: "movementY",
            get: function get() {
                return this.movement.y;
            }
        },
        {
            key: "offsetX",
            get: function get() {
                return this.offset.x;
            }
        },
        {
            key: "offsetY",
            get: function get() {
                return this.offset.y;
            }
        },
        {
            key: "globalX",
            get: function get() {
                return this.global.x;
            }
        },
        {
            key: "globalY",
            get: function get() {
                return this.global.y;
            }
        },
        {
            key: "screenX",
            get: function get() {
                return this.screen.x;
            }
        },
        {
            key: "screenY",
            get: function get() {
                return this.screen.y;
            }
        },
        {
            key: "getModifierState",
            value: function getModifierState(key) {
                return 'getModifierState' in this.nativeEvent && this.nativeEvent.getModifierState(key);
            }
        },
        {
            key: "initMouseEvent",
            value: function initMouseEvent() {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        }
    ]);
}(FederatedEvent);
// @ts-ignore
var FederatedPointerEvent = /*#__PURE__*/ function(_FederatedMouseEvent) {
    function FederatedPointerEvent() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FederatedPointerEvent);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, FederatedPointerEvent, [].concat(args));
        /**
     * The unique identifier of the pointer.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerId
     */ /**
     * The width of the pointer's contact along the x-axis, measured in CSS pixels.
     * radiusX of TouchEvents will be represented by this value.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/width
     */ _this.width = 0;
        /**
     * The height of the pointer's contact along the y-axis, measured in CSS pixels.
     * radiusY of TouchEvents will be represented by this value.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/height
     */ _this.height = 0;
        /**
     * Indicates whether or not the pointer device that created the event is the primary pointer.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/isPrimary
     */ _this.isPrimary = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(FederatedPointerEvent, _FederatedMouseEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FederatedPointerEvent, [
        {
            key: "getCoalescedEvents",
            value: /**
     * The type of pointer that triggered the event.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pointerType
     */ /**
     * Pressure applied by the pointing device during the event.
     *s
     * A Touch's force property will be represented by this value.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/pressure
     */ /**
     * Barrel pressure on a stylus pointer.
     *
     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
     */ /**
     * The angle, in degrees, between the pointer device and the screen.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltX
     */ /**
     * The angle, in degrees, between the pointer device and the screen.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/tiltY
     */ /**
     * Twist of a stylus pointer.
     *
     * @see https://w3c.github.io/pointerevents/#pointerevent-interface
     */ /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PointerEvent/getCoalescedEvents
     */ function getCoalescedEvents() {
                if (this.type === 'pointermove' || this.type === 'mousemove' || this.type === 'touchmove') // @ts-ignore
                return [
                    this
                ];
                return [];
            }
        },
        {
            key: "getPredictedEvents",
            value: function getPredictedEvents() {
                throw new Error('getPredictedEvents is not supported!');
            }
        },
        {
            key: "clone",
            value: function clone() {
                return this.manager.clonePointerEvent(this);
            }
        }
    ]);
}(FederatedMouseEvent);
// @ts-ignore
var FederatedWheelEvent = /*#__PURE__*/ function(_FederatedMouseEvent) {
    function FederatedWheelEvent() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FederatedWheelEvent);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, FederatedWheelEvent, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(FederatedWheelEvent, _FederatedMouseEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FederatedWheelEvent, [
        {
            key: "clone",
            value: /**
     * The units of `deltaX`, `deltaY`, and `deltaZ`. This is one of `DOM_DELTA_LINE`,
     * `DOM_DELTA_PAGE`, `DOM_DELTA_PIXEL`.
     */ /** Horizontal scroll amount */ /** Vertical scroll amount */ /** z-axis scroll amount. */ function clone() {
                return this.manager.cloneWheelEvent(this);
            }
        }
    ]);
}(FederatedMouseEvent);
/**
 * @link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent
 * @link https://developer.mozilla.org/en-US/docs/Web/Events/Creating_and_triggering_events
 *
 * @example
  const event = new CustomEvent('build', { detail: { prop1: 'xx' } });
  circle.addEventListener('build', (e) => {
    e.target; // circle
    e.detail; // { prop1: 'xx' }
  });

  circle.dispatchEvent(event);
 */ var CustomEvent = /*#__PURE__*/ function(_FederatedEvent) {
    function CustomEvent(eventName, options) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CustomEvent);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, CustomEvent, [
            null
        ]);
        _this.type = eventName;
        _this.detail = options === null || options === void 0 ? void 0 : options.detail;
        // compatible
        if (options && !('detail' in options)) _this.detail = options;
        // compatible with G 3.0
        Object.assign(_this, options);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(CustomEvent, _FederatedEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CustomEvent);
}(FederatedEvent);
/**
 * Objects that can receive events and may have listeners for them.
 * eg. Element, Canvas, DisplayObject
 * @docs https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
 */ var EventTarget = /*#__PURE__*/ function() {
    function EventTarget() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, EventTarget);
        /**
     * event emitter
     */ this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($3vRz3)))();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(EventTarget, [
        {
            key: "on",
            value: /**
     * @deprecated
     * @alias addEventListener
     */ function on(type, listener, options) {
                this.addEventListener(type, listener, options);
                return this;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(type, listener, options) {
                var capture = false;
                var once = false;
                if ((0, $2LrCM.default)(options)) capture = options;
                else if (options) {
                    var _options$capture = options.capture;
                    capture = _options$capture === void 0 ? false : _options$capture;
                    var _options$once = options.once;
                    once = _options$once === void 0 ? false : _options$once;
                }
                if (capture) type += 'capture';
                // eslint-disable-next-line @typescript-eslint/unbound-method
                listener = (0, $ky7aH.default)(listener) ? listener : listener.handleEvent;
                var context = (0, $ky7aH.default)(listener) ? undefined : listener;
                if (once) this.emitter.once(type, listener, context);
                else this.emitter.on(type, listener, context);
                return this;
            }
        },
        {
            key: "off",
            value: function off(type, listener, options) {
                if (type) this.removeEventListener(type, listener, options);
                else // remove all listeners
                this.removeAllEventListeners();
                return this;
            }
        },
        {
            key: "removeAllEventListeners",
            value: function removeAllEventListeners() {
                var _this$emitter;
                (_this$emitter = this.emitter) === null || _this$emitter === void 0 || _this$emitter.removeAllListeners();
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(type, listener, options) {
                var _listener;
                if (!this.emitter) return this;
                var capture = (0, $2LrCM.default)(options) ? options : options === null || options === void 0 ? void 0 : options.capture;
                if (capture) type += 'capture';
                // eslint-disable-next-line @typescript-eslint/unbound-method
                listener = (0, $ky7aH.default)(listener) ? listener : (_listener = listener) === null || _listener === void 0 ? void 0 : _listener.handleEvent;
                var context = (0, $ky7aH.default)(listener) ? undefined : listener;
                this.emitter.off(type, listener, context);
                return this;
            }
        },
        {
            key: "emit",
            value: function emit(eventName, object) {
                this.dispatchEvent(new CustomEvent(eventName, object));
            }
        },
        {
            key: "dispatchEventToSelf",
            value: function dispatchEventToSelf(e) {
                e.target || (e.target = this);
                e.currentTarget = this;
                this.emitter.emit(e.type, e);
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(e) {
                var skipPropagate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var dispatchToSelf = arguments.length > 2 ? arguments[2] : undefined;
                if (dispatchToSelf) {
                    this.dispatchEventToSelf(e);
                    return true;
                }
                var canvas;
                if (this.document) canvas = this;
                else if (this.defaultView) canvas = this.defaultView;
                else {
                    var _ownerDocument;
                    canvas = (_ownerDocument = this.ownerDocument) === null || _ownerDocument === void 0 ? void 0 : _ownerDocument.defaultView;
                }
                if (canvas) {
                    e.manager = canvas.getEventService();
                    if (!e.manager) return false;
                    e.defaultPrevented = false;
                    if (e.path) e.path.length = 0;
                    else // @ts-ignore
                    e.page = [];
                    if (!skipPropagate) e.target = this;
                    e.manager.dispatchEvent(e, e.type, skipPropagate);
                } else // HACK Fixed the issue that after an element leaves the DOM tree, there is no associated canvas,
                // which causes the removed and destroy events to not be triggered
                this.dispatchEventToSelf(e);
                return !e.defaultPrevented;
            }
        }
    ]);
}();
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Node
 */ var Node = /*#__PURE__*/ function(_EventTarget) {
    function Node() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Node);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Node, [].concat(args));
        _this.shadow = false;
        /**
     * points to canvas.document
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Node/ownerDocument
     */ _this.ownerDocument = null;
        /**
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Node/isConnected
     * @example
        circle.isConnected; // false
        canvas.appendChild(circle);
        circle.isConnected; // true
     */ _this.isConnected = false;
        /**
     * Returns node's node document's document base URL.
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Node
     */ _this.baseURI = '';
        /**
     * Returns the children.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Node/childNodes
     */ _this.childNodes = [];
        /**
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Node/nodeType
     */ _this.nodeType = 0;
        /**
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Node/nodeName
     */ _this.nodeName = '';
        /**
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Node/nodeValue
     */ _this.nodeValue = null;
        _this.mutations = undefined;
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/ParentNode
     */ _this.parentNode = null;
        _this.destroyed = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Node, _EventTarget);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Node, [
        {
            key: "textContent",
            get: /**
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/Node/textContent
     */ function get() {
                var out = '';
                if (this.nodeName === Shape.TEXT) // @ts-ignore
                out += this.style.text;
                var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(this.childNodes), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _child = _step.value;
                        if (_child.nodeName === Shape.TEXT) out += _child.nodeValue;
                        else out += _child.textContent;
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                return out;
            },
            set: function set(content) {
                var _this2 = this;
                // remove all children
                this.childNodes.slice().forEach(function(child) {
                    _this2.removeChild(child);
                });
                if (this.nodeName === Shape.TEXT) // @ts-ignore
                this.style.text = "".concat(content);
            }
        },
        {
            key: "getRootNode",
            value: function getRootNode() {
                var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (this.parentNode) return this.parentNode.getRootNode(opts);
                if (opts.composed && this.host) return this.host.getRootNode(opts);
                return this;
            }
        },
        {
            key: "hasChildNodes",
            value: function hasChildNodes() {
                return this.childNodes.length > 0;
            }
        },
        {
            key: "isDefaultNamespace",
            value: function isDefaultNamespace(namespace) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "lookupNamespaceURI",
            value: function lookupNamespaceURI(prefix) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "lookupPrefix",
            value: function lookupPrefix(namespace) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "normalize",
            value: function normalize() {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "isEqualNode",
            value: function isEqualNode(otherNode) {
                // TODO: compare 2 nodes, not sameness
                return this === otherNode;
            }
        },
        {
            key: "isSameNode",
            value: function isSameNode(otherNode) {
                return this.isEqualNode(otherNode);
            }
        },
        {
            key: "parent",
            get: /**
     * @deprecated
     * @alias parentNode
     */ function get() {
                return this.parentNode;
            }
        },
        {
            key: "parentElement",
            get: function get() {
                return null;
            }
        },
        {
            key: "nextSibling",
            get: function get() {
                return null;
            }
        },
        {
            key: "previousSibling",
            get: function get() {
                return null;
            }
        },
        {
            key: "firstChild",
            get: function get() {
                return this.childNodes.length > 0 ? this.childNodes[0] : null;
            }
        },
        {
            key: "lastChild",
            get: function get() {
                return this.childNodes.length > 0 ? this.childNodes[this.childNodes.length - 1] : null;
            }
        },
        {
            key: "compareDocumentPosition",
            value: function compareDocumentPosition(other) {
                if (other === this) // same node
                return 0;
                // if (!(other instanceof Node)) {
                //   throw new TypeError(
                //     'Node.compareDocumentPosition: Argument 1 does not implement interface Node.',
                //   );
                // }
                var node1Root = other;
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var node2Root = this;
                var node1Hierarchy = [
                    node1Root
                ];
                var node2Hierarchy = [
                    node2Root
                ];
                while((_node1Root$parentNode = node1Root.parentNode) !== null && _node1Root$parentNode !== void 0 ? _node1Root$parentNode : node2Root.parentNode){
                    var _node1Root$parentNode;
                    node1Root = node1Root.parentNode ? (node1Hierarchy.push(node1Root.parentNode), node1Root.parentNode) : node1Root;
                    node2Root = node2Root.parentNode ? (node2Hierarchy.push(node2Root.parentNode), node2Root.parentNode) : node2Root;
                }
                // Check if they don't share the same root node
                if (node1Root !== node2Root) return Node.DOCUMENT_POSITION_DISCONNECTED | Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC | Node.DOCUMENT_POSITION_PRECEDING;
                var longerHierarchy = node1Hierarchy.length > node2Hierarchy.length ? node1Hierarchy : node2Hierarchy;
                var shorterHierarchy = longerHierarchy === node1Hierarchy ? node2Hierarchy : node1Hierarchy;
                // Check if either is a container of the other
                if (longerHierarchy[longerHierarchy.length - shorterHierarchy.length] === shorterHierarchy[0]) return longerHierarchy === node1Hierarchy ? // other is a child of this
                Node.DOCUMENT_POSITION_CONTAINED_BY | Node.DOCUMENT_POSITION_FOLLOWING : // this is a child of other
                Node.DOCUMENT_POSITION_CONTAINS | Node.DOCUMENT_POSITION_PRECEDING;
                // Find their first common ancestor and see whether they
                // are preceding or following
                var longerStart = longerHierarchy.length - shorterHierarchy.length;
                for(var i = shorterHierarchy.length - 1; i >= 0; i--){
                    var shorterHierarchyNode = shorterHierarchy[i];
                    var longerHierarchyNode = longerHierarchy[longerStart + i];
                    // We found the first common ancestor
                    if (longerHierarchyNode !== shorterHierarchyNode) {
                        var siblings = shorterHierarchyNode.parentNode.childNodes;
                        if (siblings.indexOf(shorterHierarchyNode) < siblings.indexOf(longerHierarchyNode)) {
                            // Shorter is before longer
                            if (shorterHierarchy === node1Hierarchy) // Other is before this
                            return Node.DOCUMENT_POSITION_PRECEDING;
                            // This is before other
                            return Node.DOCUMENT_POSITION_FOLLOWING;
                        }
                        // Longer is before shorter
                        if (longerHierarchy === node1Hierarchy) // Other is before this
                        return Node.DOCUMENT_POSITION_PRECEDING;
                        // Other is after this
                        return Node.DOCUMENT_POSITION_FOLLOWING;
                    }
                }
                return Node.DOCUMENT_POSITION_FOLLOWING;
            }
        },
        {
            key: "contain",
            value: /**
     * @deprecated
     * @alias contains
     */ function contain(other) {
                return this.contains(other);
            }
        },
        {
            key: "contains",
            value: function contains(other) {
                // the node itself, one of its direct children
                var tmp = other;
                // @see https://developer.mozilla.org/en-US/docs/Web/API/Node/contains
                while(tmp && this !== tmp)tmp = tmp.parentNode;
                return !!tmp;
            }
        },
        {
            key: "getAncestor",
            value: function getAncestor(n) {
                // eslint-disable-next-line @typescript-eslint/no-this-alias
                var temp = this;
                while(n > 0 && temp){
                    temp = temp.parentNode;
                    n--;
                }
                return temp;
            }
        },
        {
            key: "forEach",
            value: function forEach(callback) {
                var stack = [
                    this
                ];
                while(stack.length > 0){
                    var node = stack.pop();
                    var result = callback(node);
                    if (result === false) break;
                    for(var i = node.childNodes.length - 1; i >= 0; i--)stack.push(node.childNodes[i]);
                }
            }
        }
    ], [
        {
            key: "isNode",
            value: function isNode(target) {
                return !!target.childNodes;
            }
        }
    ]);
}(EventTarget);
/**
 * Both nodes are in different documents or different trees in the same document.
 */ Node.DOCUMENT_POSITION_DISCONNECTED = 1;
/**
 * otherNode precedes the node in either a pre-order depth-first traversal
 * of a tree containing both (e.g., as an ancestor or previous sibling or a descendant of a previous sibling or previous sibling of an ancestor) or (if they are disconnected) in an arbitrary but consistent ordering.
 */ Node.DOCUMENT_POSITION_PRECEDING = 2;
/**
 * otherNode follows the node in either a pre-order depth-first traversal of a tree containing both (e.g., as a descendant or following sibling or a descendant of a following sibling or following sibling of an ancestor) or (if they are disconnected) in an arbitrary but consistent ordering.
 */ Node.DOCUMENT_POSITION_FOLLOWING = 4;
/**
 * otherNode is an ancestor of the node.
 */ Node.DOCUMENT_POSITION_CONTAINS = 8;
/**
 * otherNode is a descendant of the node.
 */ Node.DOCUMENT_POSITION_CONTAINED_BY = 16;
/**
 * The result relies upon arbitrary and/or implementation-specific behavior and is not guaranteed to be portable.
 */ Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC = 32;
var PROPAGATION_LIMIT = 2048;
var EventService = /*#__PURE__*/ function() {
    function EventService(globalRuntime, context) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, EventService);
        /**
     * Store HTML elements in current canvas.
     */ this.nativeHTMLMap = new WeakMap();
        this.cursor = 'default';
        this.mappingTable = {};
        this.mappingState = {
            trackingData: {}
        };
        this.eventPool = new Map();
        this.tmpMatrix = (0, $3iqbd).create();
        this.tmpVec3 = (0, $eIStk).create();
        this.onPointerDown = function(from) {
            var e = _this.createPointerEvent(from);
            _this.dispatchEvent(e, 'pointerdown');
            if (e.pointerType === 'touch') _this.dispatchEvent(e, 'touchstart');
            else if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
                var isRightButton = e.button === 2;
                _this.dispatchEvent(e, isRightButton ? 'rightdown' : 'mousedown');
            }
            var trackingData = _this.trackingData(from.pointerId);
            trackingData.pressTargetsByButton[from.button] = e.composedPath();
            _this.freeEvent(e);
        };
        this.onPointerUp = function(from) {
            var now = clock.now();
            var e = _this.createPointerEvent(from, undefined, undefined, _this.context.config.alwaysTriggerPointerEventOnCanvas ? _this.rootTarget : undefined);
            _this.dispatchEvent(e, 'pointerup');
            if (e.pointerType === 'touch') _this.dispatchEvent(e, 'touchend');
            else if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
                var isRightButton = e.button === 2;
                _this.dispatchEvent(e, isRightButton ? 'rightup' : 'mouseup');
            }
            var trackingData = _this.trackingData(from.pointerId);
            var pressTarget = _this.findMountedTarget(trackingData.pressTargetsByButton[from.button]);
            var clickTarget = pressTarget;
            // pointerupoutside only bubbles. It only bubbles upto the parent that doesn't contain
            // the pointerup location.
            if (pressTarget && !e.composedPath().includes(pressTarget)) {
                var currentTarget = pressTarget;
                while(currentTarget && !e.composedPath().includes(currentTarget)){
                    e.currentTarget = currentTarget;
                    _this.notifyTarget(e, 'pointerupoutside');
                    if (e.pointerType === 'touch') _this.notifyTarget(e, 'touchendoutside');
                    else if (e.pointerType === 'mouse' || e.pointerType === 'pen') {
                        var _isRightButton = e.button === 2;
                        _this.notifyTarget(e, _isRightButton ? 'rightupoutside' : 'mouseupoutside');
                    }
                    if (Node.isNode(currentTarget)) currentTarget = currentTarget.parentNode;
                }
                delete trackingData.pressTargetsByButton[from.button];
                // currentTarget is the most specific ancestor holding both the pointerdown and pointerup
                // targets. That is - it's our click target!
                clickTarget = currentTarget;
            }
            if (clickTarget) {
                var _e$detail;
                var clickEvent = _this.clonePointerEvent(e, 'click');
                clickEvent.target = clickTarget;
                clickEvent.path = [];
                if (!trackingData.clicksByButton[from.button]) trackingData.clicksByButton[from.button] = {
                    clickCount: 0,
                    target: clickEvent.target,
                    timeStamp: now
                };
                var canvas = _this.context.renderingContext.root.ownerDocument.defaultView;
                var clickHistory = trackingData.clicksByButton[from.button];
                if (clickHistory.target === clickEvent.target && now - clickHistory.timeStamp < canvas.getConfig().dblClickSpeed) ++clickHistory.clickCount;
                else clickHistory.clickCount = 1;
                clickHistory.target = clickEvent.target;
                clickHistory.timeStamp = now;
                clickEvent.detail = clickHistory.clickCount;
                // @see https://github.com/antvis/G/issues/1091
                if (!((_e$detail = e.detail) !== null && _e$detail !== void 0 && _e$detail.preventClick)) {
                    if (!_this.context.config.useNativeClickEvent && (clickEvent.pointerType === 'mouse' || clickEvent.pointerType === 'touch')) _this.dispatchEvent(clickEvent, 'click');
                    _this.dispatchEvent(clickEvent, 'pointertap');
                }
                _this.freeEvent(clickEvent);
            }
            _this.freeEvent(e);
        };
        this.onPointerMove = function(from) {
            var e = _this.createPointerEvent(from, undefined, undefined, _this.context.config.alwaysTriggerPointerEventOnCanvas ? _this.rootTarget : undefined);
            var isMouse = e.pointerType === 'mouse' || e.pointerType === 'pen';
            var trackingData = _this.trackingData(from.pointerId);
            var outTarget = _this.findMountedTarget(trackingData.overTargets);
            // First pointerout/pointerleave
            if (trackingData.overTargets && outTarget !== e.target) {
                // pointerout always occurs on the overTarget when the pointer hovers over another element.
                var outType = from.type === 'mousemove' ? 'mouseout' : 'pointerout';
                var outEvent = _this.createPointerEvent(from, outType, outTarget || undefined);
                _this.dispatchEvent(outEvent, 'pointerout');
                if (isMouse) _this.dispatchEvent(outEvent, 'mouseout');
                // If the pointer exits overTarget and its descendants, then a pointerleave event is also fired. This event
                // is dispatched to all ancestors that no longer capture the pointer.
                if (!e.composedPath().includes(outTarget)) {
                    var leaveEvent = _this.createPointerEvent(from, 'pointerleave', outTarget || undefined);
                    leaveEvent.eventPhase = leaveEvent.AT_TARGET;
                    while(leaveEvent.target && !e.composedPath().includes(leaveEvent.target)){
                        leaveEvent.currentTarget = leaveEvent.target;
                        _this.notifyTarget(leaveEvent);
                        if (isMouse) _this.notifyTarget(leaveEvent, 'mouseleave');
                        if (Node.isNode(leaveEvent.target)) leaveEvent.target = leaveEvent.target.parentNode;
                    }
                    _this.freeEvent(leaveEvent);
                }
                _this.freeEvent(outEvent);
            }
            // Then pointerover
            if (outTarget !== e.target) {
                // pointerover always occurs on the new overTarget
                var overType = from.type === 'mousemove' ? 'mouseover' : 'pointerover';
                var overEvent = _this.clonePointerEvent(e, overType); // clone faster
                _this.dispatchEvent(overEvent, 'pointerover');
                if (isMouse) _this.dispatchEvent(overEvent, 'mouseover');
                // Probe whether the newly hovered Node is an ancestor of the original overTarget.
                var overTargetAncestor = outTarget && Node.isNode(outTarget) && outTarget.parentNode;
                while(overTargetAncestor && overTargetAncestor !== (Node.isNode(_this.rootTarget) && _this.rootTarget.parentNode)){
                    if (overTargetAncestor === e.target) break;
                    overTargetAncestor = overTargetAncestor.parentNode;
                }
                // The pointer has entered a non-ancestor of the original overTarget. This means we need a pointerentered
                // event.
                var didPointerEnter = !overTargetAncestor || overTargetAncestor === (Node.isNode(_this.rootTarget) && _this.rootTarget.parentNode);
                if (didPointerEnter) {
                    var enterEvent = _this.clonePointerEvent(e, 'pointerenter');
                    enterEvent.eventPhase = enterEvent.AT_TARGET;
                    while(enterEvent.target && enterEvent.target !== outTarget && enterEvent.target !== (Node.isNode(_this.rootTarget) && _this.rootTarget.parentNode)){
                        enterEvent.currentTarget = enterEvent.target;
                        _this.notifyTarget(enterEvent);
                        if (isMouse) _this.notifyTarget(enterEvent, 'mouseenter');
                        if (Node.isNode(enterEvent.target)) enterEvent.target = enterEvent.target.parentNode;
                    }
                    _this.freeEvent(enterEvent);
                }
                _this.freeEvent(overEvent);
            }
            // Then pointermove
            _this.dispatchEvent(e, 'pointermove');
            if (e.pointerType === 'touch') _this.dispatchEvent(e, 'touchmove');
            if (isMouse) {
                _this.dispatchEvent(e, 'mousemove');
                _this.cursor = _this.getCursor(e.target);
            }
            trackingData.overTargets = e.composedPath();
            _this.freeEvent(e);
        };
        this.onPointerOut = function(from) {
            var trackingData = _this.trackingData(from.pointerId);
            if (trackingData.overTargets) {
                var isMouse = from.pointerType === 'mouse' || from.pointerType === 'pen';
                var outTarget = _this.findMountedTarget(trackingData.overTargets);
                // pointerout first
                var outEvent = _this.createPointerEvent(from, 'pointerout', outTarget || undefined);
                _this.dispatchEvent(outEvent);
                if (isMouse) _this.dispatchEvent(outEvent, 'mouseout');
                // pointerleave(s) are also dispatched b/c the pointer must've left rootTarget and its descendants to
                // get an upstream pointerout event (upstream events do not know rootTarget has descendants).
                var leaveEvent = _this.createPointerEvent(from, 'pointerleave', outTarget || undefined);
                leaveEvent.eventPhase = leaveEvent.AT_TARGET;
                while(leaveEvent.target && leaveEvent.target !== (Node.isNode(_this.rootTarget) && _this.rootTarget.parentNode)){
                    leaveEvent.currentTarget = leaveEvent.target;
                    _this.notifyTarget(leaveEvent);
                    if (isMouse) _this.notifyTarget(leaveEvent, 'mouseleave');
                    if (Node.isNode(leaveEvent.target)) leaveEvent.target = leaveEvent.target.parentNode;
                }
                trackingData.overTargets = null;
                _this.freeEvent(outEvent);
                _this.freeEvent(leaveEvent);
            }
            _this.cursor = null;
        };
        this.onPointerOver = function(from) {
            var trackingData = _this.trackingData(from.pointerId);
            var e = _this.createPointerEvent(from);
            var isMouse = e.pointerType === 'mouse' || e.pointerType === 'pen';
            _this.dispatchEvent(e, 'pointerover');
            if (isMouse) _this.dispatchEvent(e, 'mouseover');
            if (e.pointerType === 'mouse') _this.cursor = _this.getCursor(e.target);
            // pointerenter events must be fired since the pointer entered from upstream.
            var enterEvent = _this.clonePointerEvent(e, 'pointerenter');
            enterEvent.eventPhase = enterEvent.AT_TARGET;
            while(enterEvent.target && enterEvent.target !== (Node.isNode(_this.rootTarget) && _this.rootTarget.parentNode)){
                enterEvent.currentTarget = enterEvent.target;
                _this.notifyTarget(enterEvent);
                if (isMouse) // mouseenter should not bubble
                // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/mouseenter_event#usage_notes
                _this.notifyTarget(enterEvent, 'mouseenter');
                if (Node.isNode(enterEvent.target)) enterEvent.target = enterEvent.target.parentNode;
            }
            trackingData.overTargets = e.composedPath();
            _this.freeEvent(e);
            _this.freeEvent(enterEvent);
        };
        this.onPointerUpOutside = function(from) {
            var trackingData = _this.trackingData(from.pointerId);
            var pressTarget = _this.findMountedTarget(trackingData.pressTargetsByButton[from.button]);
            var e = _this.createPointerEvent(from);
            if (pressTarget) {
                var currentTarget = pressTarget;
                while(currentTarget){
                    e.currentTarget = currentTarget;
                    _this.notifyTarget(e, 'pointerupoutside');
                    if (e.pointerType === 'touch') ;
                    else if (e.pointerType === 'mouse' || e.pointerType === 'pen') _this.notifyTarget(e, e.button === 2 ? 'rightupoutside' : 'mouseupoutside');
                    if (Node.isNode(currentTarget)) currentTarget = currentTarget.parentNode;
                }
                delete trackingData.pressTargetsByButton[from.button];
            }
            _this.freeEvent(e);
        };
        this.onWheel = function(from) {
            var wheelEvent = _this.createWheelEvent(from);
            _this.dispatchEvent(wheelEvent);
            _this.freeEvent(wheelEvent);
        };
        this.onClick = function(from) {
            if (_this.context.config.useNativeClickEvent) {
                var e = _this.createPointerEvent(from);
                _this.dispatchEvent(e);
                _this.freeEvent(e);
            }
        };
        this.onPointerCancel = function(from) {
            var e = _this.createPointerEvent(from, undefined, undefined, _this.context.config.alwaysTriggerPointerEventOnCanvas ? _this.rootTarget : undefined);
            _this.dispatchEvent(e);
            _this.freeEvent(e);
        };
        this.globalRuntime = globalRuntime;
        this.context = context;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(EventService, [
        {
            key: "init",
            value: function init() {
                this.rootTarget = this.context.renderingContext.root.parentNode; // document
                this.addEventMapping('pointerdown', this.onPointerDown);
                this.addEventMapping('pointerup', this.onPointerUp);
                this.addEventMapping('pointermove', this.onPointerMove);
                this.addEventMapping('pointerout', this.onPointerOut);
                this.addEventMapping('pointerleave', this.onPointerOut);
                this.addEventMapping('pointercancel', this.onPointerCancel);
                this.addEventMapping('pointerover', this.onPointerOver);
                this.addEventMapping('pointerupoutside', this.onPointerUpOutside);
                this.addEventMapping('wheel', this.onWheel);
                this.addEventMapping('click', this.onClick);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.mappingTable = {};
                this.mappingState = {};
                this.eventPool.clear();
            }
        },
        {
            key: "getScale",
            value: function getScale() {
                var bbox = this.context.contextService.getBoundingClientRect();
                var scaleX = 1;
                var scaleY = 1;
                var $el = this.context.contextService.getDomElement();
                if ($el && bbox) {
                    var offsetWidth = $el.offsetWidth, offsetHeight = $el.offsetHeight;
                    if (offsetWidth && offsetHeight) {
                        scaleX = bbox.width / offsetWidth;
                        scaleY = bbox.height / offsetHeight;
                    }
                }
                return {
                    scaleX: scaleX,
                    scaleY: scaleY,
                    bbox: bbox
                };
            }
        },
        {
            key: "client2Viewport",
            value: function client2Viewport(client) {
                var _this$getScale = this.getScale(), scaleX = _this$getScale.scaleX, scaleY = _this$getScale.scaleY, bbox = _this$getScale.bbox;
                return new Point((client.x - ((bbox === null || bbox === void 0 ? void 0 : bbox.left) || 0)) / scaleX, (client.y - ((bbox === null || bbox === void 0 ? void 0 : bbox.top) || 0)) / scaleY);
            }
        },
        {
            key: "viewport2Client",
            value: function viewport2Client(canvas) {
                var _this$getScale2 = this.getScale(), scaleX = _this$getScale2.scaleX, scaleY = _this$getScale2.scaleY, bbox = _this$getScale2.bbox;
                return new Point((canvas.x + ((bbox === null || bbox === void 0 ? void 0 : bbox.left) || 0)) * scaleX, (canvas.y + ((bbox === null || bbox === void 0 ? void 0 : bbox.top) || 0)) * scaleY);
            }
        },
        {
            key: "viewport2Canvas",
            value: function viewport2Canvas(_ref) {
                var x = _ref.x, y = _ref.y;
                var canvas = this.rootTarget.defaultView;
                var camera = canvas.getCamera();
                var _this$context$config = this.context.config, width = _this$context$config.width, height = _this$context$config.height;
                var projectionMatrixInverse = camera.getPerspectiveInverse();
                var worldMatrix = camera.getWorldTransform();
                var vpMatrix = (0, $3iqbd).multiply(this.tmpMatrix, worldMatrix, projectionMatrixInverse);
                var viewport = (0, $eIStk).set(this.tmpVec3, x / width * 2 - 1, (1 - y / height) * 2 - 1, 0);
                (0, $eIStk).transformMat4(viewport, viewport, vpMatrix);
                return new Point(viewport[0], viewport[1]);
            }
        },
        {
            key: "canvas2Viewport",
            value: function canvas2Viewport(canvasP) {
                var canvas = this.rootTarget.defaultView;
                var camera = canvas.getCamera();
                // World -> Clip
                var projectionMatrix = camera.getPerspective();
                var viewMatrix = camera.getViewTransform();
                var vpMatrix = (0, $3iqbd).multiply(this.tmpMatrix, projectionMatrix, viewMatrix);
                var clip = (0, $eIStk).set(this.tmpVec3, canvasP.x, canvasP.y, 0);
                (0, $eIStk).transformMat4(this.tmpVec3, this.tmpVec3, vpMatrix);
                // Clip -> NDC -> Viewport, flip Y
                var _this$context$config2 = this.context.config, width = _this$context$config2.width, height = _this$context$config2.height;
                return new Point((clip[0] + 1) / 2 * width, (1 - (clip[1] + 1) / 2) * height);
            }
        },
        {
            key: "setPickHandler",
            value: function setPickHandler(pickHandler) {
                this.pickHandler = pickHandler;
            }
        },
        {
            key: "addEventMapping",
            value: function addEventMapping(type, fn) {
                if (!this.mappingTable[type]) this.mappingTable[type] = [];
                this.mappingTable[type].push({
                    fn: fn,
                    priority: 0
                });
                this.mappingTable[type].sort(function(a, b) {
                    return a.priority - b.priority;
                });
            }
        },
        {
            key: "mapEvent",
            value: function mapEvent(e) {
                if (!this.rootTarget) return;
                var mappers = this.mappingTable[e.type];
                if (mappers) for(var i = 0, j = mappers.length; i < j; i++)mappers[i].fn(e);
                else console.warn("[EventService]: Event mapping not defined for ".concat(e.type));
            }
        },
        {
            key: "dispatchEvent",
            value: function dispatchEvent(e, type, skipPropagate) {
                // Canvas should skip
                if (!skipPropagate) {
                    e.propagationStopped = false;
                    e.propagationImmediatelyStopped = false;
                    this.propagate(e, type);
                } else {
                    // target phase
                    e.eventPhase = e.AT_TARGET;
                    var canvas = this.rootTarget.defaultView || null;
                    e.currentTarget = canvas;
                    this.notifyListeners(e, type);
                }
            }
        },
        {
            key: "propagate",
            value: function propagate(e, type) {
                if (!e.target) return;
                // [target, parent, root, Canvas]
                var composedPath = e.composedPath();
                // event flow: capture -> target -> bubbling
                // capture phase
                e.eventPhase = e.CAPTURING_PHASE;
                for(var i = composedPath.length - 1; i >= 1; i--){
                    e.currentTarget = composedPath[i];
                    this.notifyTarget(e, type);
                    if (e.propagationStopped || e.propagationImmediatelyStopped) return;
                }
                // target phase
                e.eventPhase = e.AT_TARGET;
                e.currentTarget = e.target;
                this.notifyTarget(e, type);
                if (e.propagationStopped || e.propagationImmediatelyStopped) return;
                // find current target in composed path
                var index = composedPath.indexOf(e.currentTarget);
                // bubbling phase
                e.eventPhase = e.BUBBLING_PHASE;
                for(var _i = index + 1; _i < composedPath.length; _i++){
                    e.currentTarget = composedPath[_i];
                    this.notifyTarget(e, type);
                    if (e.propagationStopped || e.propagationImmediatelyStopped) return;
                }
            }
        },
        {
            key: "propagationPath",
            value: function propagationPath(target) {
                var propagationPath = [
                    target
                ];
                var canvas = this.rootTarget.defaultView || null;
                if (canvas && canvas === target) {
                    propagationPath.unshift(canvas.document);
                    return propagationPath;
                }
                for(var i = 0; i < PROPAGATION_LIMIT && target !== this.rootTarget; i++)// if (Node.isNode(target) && !target.parentNode) {
                //   throw new Error('Cannot find propagation path to disconnected target');
                // }
                if (Node.isNode(target) && target.parentNode) {
                    // [target, parent, parent, root]
                    propagationPath.push(target.parentNode);
                    target = target.parentNode;
                }
                if (canvas) // @ts-ignore
                propagationPath.push(canvas);
                return propagationPath;
            }
        },
        {
            key: "hitTest",
            value: function hitTest(position) {
                var viewportX = position.viewportX, viewportY = position.viewportY;
                var _this$context$config3 = this.context.config, width = _this$context$config3.width, height = _this$context$config3.height, disableHitTesting = _this$context$config3.disableHitTesting;
                // outside canvas
                if (viewportX < 0 || viewportY < 0 || viewportX > width || viewportY > height) return null;
                return !disableHitTesting && this.pickHandler(position) || this.rootTarget || // return Document
                null;
            }
        },
        {
            key: "isNativeEventFromCanvas",
            value: function isNativeEventFromCanvas($el, nativeEvent) {
                var _target;
                var target = nativeEvent === null || nativeEvent === void 0 ? void 0 : nativeEvent.target;
                // Get event target inside a web component.
                // @see https://stackoverflow.com/questions/57963312/get-event-target-inside-a-web-component
                if ((_target = target) !== null && _target !== void 0 && _target.shadowRoot) target = nativeEvent.composedPath()[0];
                if (target) {
                    // from <canvas>
                    if (target === $el) return true;
                    // from <svg>
                    if ($el && $el.contains) return $el.contains(target);
                }
                if (nativeEvent !== null && nativeEvent !== void 0 && nativeEvent.composedPath) return nativeEvent.composedPath().indexOf($el) > -1;
                // account for Touch
                return false;
            }
        },
        {
            key: "getExistedHTML",
            value: function getExistedHTML(event) {
                if (event.nativeEvent.composedPath) for(var _i2 = 0, _arr = event.nativeEvent.composedPath(); _i2 < _arr.length; _i2++){
                    var eventTarget = _arr[_i2];
                    var existed = this.nativeHTMLMap.get(eventTarget);
                    if (existed) return existed;
                }
                return null;
            }
        },
        {
            key: "pickTarget",
            value: function pickTarget(event) {
                return this.hitTest({
                    clientX: event.clientX,
                    clientY: event.clientY,
                    viewportX: event.viewportX,
                    viewportY: event.viewportY,
                    x: event.canvasX,
                    y: event.canvasY
                });
            }
        },
        {
            key: "createPointerEvent",
            value: function createPointerEvent(from, type, target, fallbackTarget) {
                var event = this.allocateEvent(FederatedPointerEvent);
                this.copyPointerData(from, event);
                this.copyMouseData(from, event);
                this.copyData(from, event);
                event.nativeEvent = from.nativeEvent;
                event.originalEvent = from;
                var existedHTML = this.getExistedHTML(event);
                var $el = this.context.contextService.getDomElement();
                event.target = target !== null && target !== void 0 ? target : existedHTML || this.isNativeEventFromCanvas($el, event.nativeEvent) && this.pickTarget(event) || fallbackTarget;
                if (typeof type === 'string') event.type = type;
                return event;
            }
        },
        {
            key: "createWheelEvent",
            value: function createWheelEvent(from) {
                var event = this.allocateEvent(FederatedWheelEvent);
                this.copyWheelData(from, event);
                this.copyMouseData(from, event);
                this.copyData(from, event);
                event.nativeEvent = from.nativeEvent;
                event.originalEvent = from;
                var existedHTML = this.getExistedHTML(event);
                var $el = this.context.contextService.getDomElement();
                event.target = existedHTML || this.isNativeEventFromCanvas($el, event.nativeEvent) && this.pickTarget(event);
                return event;
            }
        },
        {
            key: "trackingData",
            value: function trackingData(id) {
                if (!this.mappingState.trackingData[id]) this.mappingState.trackingData[id] = {
                    pressTargetsByButton: {},
                    clicksByButton: {},
                    overTarget: null
                };
                return this.mappingState.trackingData[id];
            }
        },
        {
            key: "cloneWheelEvent",
            value: function cloneWheelEvent(from) {
                var event = this.allocateEvent(FederatedWheelEvent);
                event.nativeEvent = from.nativeEvent;
                event.originalEvent = from.originalEvent;
                this.copyWheelData(from, event);
                this.copyMouseData(from, event);
                this.copyData(from, event);
                event.target = from.target;
                event.path = from.composedPath().slice();
                event.type = from.type;
                return event;
            }
        },
        {
            key: "clonePointerEvent",
            value: function clonePointerEvent(from, type) {
                var event = this.allocateEvent(FederatedPointerEvent);
                event.nativeEvent = from.nativeEvent;
                event.originalEvent = from.originalEvent;
                this.copyPointerData(from, event);
                this.copyMouseData(from, event);
                this.copyData(from, event);
                event.target = from.target;
                event.path = from.composedPath().slice();
                event.type = type !== null && type !== void 0 ? type : event.type;
                return event;
            }
        },
        {
            key: "copyPointerData",
            value: function copyPointerData(from, to) {
                // if (
                //   !(
                //     from instanceof FederatedPointerEvent &&
                //     to instanceof FederatedPointerEvent
                //   )
                // )
                //   return;
                to.pointerId = from.pointerId;
                to.width = from.width;
                to.height = from.height;
                to.isPrimary = from.isPrimary;
                to.pointerType = from.pointerType;
                to.pressure = from.pressure;
                to.tangentialPressure = from.tangentialPressure;
                to.tiltX = from.tiltX;
                to.tiltY = from.tiltY;
                to.twist = from.twist;
            }
        },
        {
            key: "copyMouseData",
            value: function copyMouseData(from, to) {
                // if (
                //   !(
                //     from instanceof FederatedMouseEvent && to instanceof FederatedMouseEvent
                //   )
                // )
                //   return;
                to.altKey = from.altKey;
                to.button = from.button;
                to.buttons = from.buttons;
                to.ctrlKey = from.ctrlKey;
                to.metaKey = from.metaKey;
                to.shiftKey = from.shiftKey;
                to.client.copyFrom(from.client);
                to.movement.copyFrom(from.movement);
                to.canvas.copyFrom(from.canvas);
                to.screen.copyFrom(from.screen);
                to.global.copyFrom(from.global);
                to.offset.copyFrom(from.offset);
            }
        },
        {
            key: "copyWheelData",
            value: function copyWheelData(from, to) {
                to.deltaMode = from.deltaMode;
                to.deltaX = from.deltaX;
                to.deltaY = from.deltaY;
                to.deltaZ = from.deltaZ;
            }
        },
        {
            key: "copyData",
            value: function copyData(from, to) {
                to.isTrusted = from.isTrusted;
                to.timeStamp = clock.now();
                to.type = from.type;
                to.detail = from.detail;
                to.view = from.view;
                to.page.copyFrom(from.page);
                to.viewport.copyFrom(from.viewport);
            }
        },
        {
            key: "allocateEvent",
            value: function allocateEvent(constructor) {
                if (!this.eventPool.has(constructor)) this.eventPool.set(constructor, []);
                // @ts-ignore
                var event = this.eventPool.get(constructor).pop() || new constructor(this);
                event.eventPhase = event.NONE;
                event.currentTarget = null;
                event.path = [];
                event.target = null;
                return event;
            }
        },
        {
            key: "freeEvent",
            value: function freeEvent(event) {
                if (event.manager !== this) throw new Error('It is illegal to free an event not managed by this EventBoundary!');
                var constructor = event.constructor;
                if (!this.eventPool.has(constructor)) this.eventPool.set(constructor, []);
                // @ts-ignore
                this.eventPool.get(constructor).push(event);
            }
        },
        {
            key: "notifyTarget",
            value: function notifyTarget(e, type) {
                type = type !== null && type !== void 0 ? type : e.type;
                var key = e.eventPhase === e.CAPTURING_PHASE || e.eventPhase === e.AT_TARGET ? "".concat(type, "capture") : type;
                this.notifyListeners(e, key);
                if (e.eventPhase === e.AT_TARGET) this.notifyListeners(e, type);
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners(e, type) {
                // hack EventEmitter, stops if the `propagationImmediatelyStopped` flag is set
                var emitter = e.currentTarget.emitter;
                // @ts-ignore
                var listeners = emitter._events[type];
                if (!listeners) return;
                if ('fn' in listeners) {
                    if (listeners.once) emitter.removeListener(type, listeners.fn, undefined, true);
                    listeners.fn.call(e.currentTarget || listeners.context, e);
                // listeners.fn.call(listeners.context, e);
                } else for(var i = 0; i < listeners.length && !e.propagationImmediatelyStopped; i++){
                    if (listeners[i].once) emitter.removeListener(type, listeners[i].fn, undefined, true);
                    listeners[i].fn.call(e.currentTarget || listeners[i].context, e);
                // listeners[i].fn.call(listeners[i].context, e);
                }
            }
        },
        {
            key: "findMountedTarget",
            value: function findMountedTarget(propagationPath) {
                if (!propagationPath) return null;
                var currentTarget = propagationPath[propagationPath.length - 1];
                for(var i = propagationPath.length - 2; i >= 0; i--){
                    var target = propagationPath[i];
                    if (target === this.rootTarget || Node.isNode(target) && target.parentNode === currentTarget) currentTarget = propagationPath[i];
                    else break;
                }
                return currentTarget;
            }
        },
        {
            key: "getCursor",
            value: function getCursor(target) {
                var tmp = target;
                while(tmp){
                    var cursor = isElement(tmp) && tmp.getAttribute('cursor');
                    if (cursor) return cursor;
                    tmp = Node.isNode(tmp) && tmp.parentNode;
                }
            }
        }
    ]);
}();
/**
 * used in following scenes:
 * - g `ctx.measureText`
 * - canvas-picker `ctx.isPointInPath`
 * - g-plugin-device-renderer `ctx.createLinearGradient` and generate texture
 *
 * @see https://blog.scottlogic.com/2020/03/19/offscreen-canvas.html
 */ var OffscreenCanvasCreator = /*#__PURE__*/ function() {
    function OffscreenCanvasCreator() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, OffscreenCanvasCreator);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(OffscreenCanvasCreator, [
        {
            key: "getOrCreateCanvas",
            value: function getOrCreateCanvas(offscreenCanvas, contextAttributes) {
                if (this.canvas) return this.canvas;
                // user-defined offscreen canvas
                if (offscreenCanvas || runtime.offscreenCanvas) {
                    this.canvas = offscreenCanvas || runtime.offscreenCanvas;
                    this.context = this.canvas.getContext('2d', (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                        willReadFrequently: true
                    }, contextAttributes));
                } else try {
                    // OffscreenCanvas2D measureText can be up to 40% faster.
                    this.canvas = new window.OffscreenCanvas(0, 0);
                    this.context = this.canvas.getContext('2d', (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                        willReadFrequently: true
                    }, contextAttributes));
                    if (!this.context || !this.context.measureText) {
                        this.canvas = document.createElement('canvas');
                        this.context = this.canvas.getContext('2d');
                    }
                } catch (_unused) {
                    this.canvas = document.createElement('canvas');
                    this.context = this.canvas.getContext('2d', (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                        willReadFrequently: true
                    }, contextAttributes));
                }
                this.canvas.width = 10;
                this.canvas.height = 10;
                return this.canvas;
            }
        },
        {
            key: "getOrCreateContext",
            value: function getOrCreateContext(offscreenCanvas, contextAttributes) {
                if (this.context) return this.context;
                this.getOrCreateCanvas(offscreenCanvas, contextAttributes);
                return this.context;
            }
        }
    ], [
        {
            key: "createCanvas",
            value: /**
     * @returns new canvas instance
     */ function createCanvas() {
                try {
                    return new window.OffscreenCanvas(0, 0);
                } catch (_unused2) {
                //
                }
                try {
                    return document.createElement('canvas');
                } catch (_unused3) {
                //
                }
                return null;
            }
        }
    ]);
}();
/**
 * why we need re-render
 */ var RenderReason = /*#__PURE__*/ function(RenderReason) {
    RenderReason[RenderReason["CAMERA_CHANGED"] = 0] = "CAMERA_CHANGED";
    RenderReason[RenderReason["DISPLAY_OBJECT_CHANGED"] = 1] = "DISPLAY_OBJECT_CHANGED";
    RenderReason[RenderReason["NONE"] = 2] = "NONE";
    return RenderReason;
}({});
/**
 * Use frame renderer implemented by `g-canvas/svg/webgl`, in every frame we do followings:
 * * update & merge dirty rectangles
 * * begin frame
 * * filter by visible
 * * sort by z-index in scene graph
 * * culling with strategies registered in `g-canvas/webgl`
 * * end frame
 */ var RenderingService = /*#__PURE__*/ function() {
    function RenderingService(globalRuntime, context) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RenderingService);
        this.inited = false;
        this.stats = {
            /**
       * total display objects in scenegraph
       */ total: 0,
            /**
       * number of display objects need to render in current frame
       */ rendered: 0
        };
        this.zIndexCounter = 0;
        this.hooks = {
            /**
       * called before any frame rendered
       */ init: new SyncHook(),
            initAsync: new AsyncParallelHook(),
            /**
       * only dirty object which has sth changed will be rendered
       */ dirtycheck: new SyncWaterfallHook(),
            /**
       * do culling
       */ cull: new SyncWaterfallHook(),
            /**
       * called at beginning of each frame, won't get called if nothing to re-render
       */ beginFrame: new SyncHook(),
            /**
       * called before every dirty object get rendered
       */ beforeRender: new SyncHook(),
            /**
       * called when every dirty object rendering even it's culled
       */ render: new SyncHook(),
            /**
       * called after every dirty object get rendered
       */ afterRender: new SyncHook(),
            /**
       * commit - draw the result on the canvas
       */ endFrame: new SyncHook(),
            destroy: new SyncHook(),
            /**
       * use async but faster method such as GPU-based picking in `g-plugin-device-renderer`
       */ pick: new AsyncSeriesWaterfallHook(),
            /**
       * Unsafe but sync version of pick.
       */ pickSync: new SyncWaterfallHook(),
            /**
       * used in event system
       */ pointerDown: new SyncHook(),
            pointerUp: new SyncHook(),
            pointerMove: new SyncHook(),
            pointerOut: new SyncHook(),
            pointerOver: new SyncHook(),
            pointerWheel: new SyncHook(),
            pointerCancel: new SyncHook(),
            click: new SyncHook()
        };
        this.globalRuntime = globalRuntime;
        this.context = context;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RenderingService, [
        {
            key: "init",
            value: function init(callback) {
                var _this = this;
                var context = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, this.globalRuntime), this.context);
                // register rendering plugins
                this.context.renderingPlugins.forEach(function(plugin) {
                    plugin.apply(context, _this.globalRuntime);
                });
                this.hooks.init.call();
                if (this.hooks.initAsync.getCallbacksNum() === 0) {
                    this.inited = true;
                    callback();
                } else this.hooks.initAsync.promise().then(function() {
                    _this.inited = true;
                    callback();
                })["catch"](function(err) {});
            }
        },
        {
            key: "getStats",
            value: function getStats() {
                return this.stats;
            }
        },
        {
            key: "disableDirtyRectangleRendering",
            value: function disableDirtyRectangleRendering() {
                var renderer = this.context.config.renderer;
                var _renderer$getConfig = renderer.getConfig(), enableDirtyRectangleRendering = _renderer$getConfig.enableDirtyRectangleRendering;
                return !enableDirtyRectangleRendering || this.context.renderingContext.renderReasons.has(RenderReason.CAMERA_CHANGED);
            }
        },
        {
            key: "render",
            value: function render(canvas, frame, rerenderCallback) {
                var _this2 = this;
                var canvasConfig = canvas.getConfig();
                var renderingContext = this.context.renderingContext;
                this.stats.total = 0;
                this.stats.rendered = 0;
                this.zIndexCounter = 0;
                this.globalRuntime.sceneGraphService.syncHierarchy(renderingContext.root);
                this.globalRuntime.sceneGraphService.notifyMutationObservers(canvas);
                if (renderingContext.renderReasons.size && this.inited) {
                    // @ts-ignore
                    renderingContext.dirtyRectangleRenderingDisabled = this.disableDirtyRectangleRendering();
                    var onlyCameraChanged = renderingContext.renderReasons.size === 1 && renderingContext.renderReasons.has(RenderReason.CAMERA_CHANGED);
                    var shouldTriggerRenderHooks = !canvasConfig.disableRenderHooks || !onlyCameraChanged;
                    if (shouldTriggerRenderHooks) this.renderDisplayObject(renderingContext.root, canvasConfig, renderingContext);
                    this.hooks.beginFrame.call(frame);
                    if (shouldTriggerRenderHooks) renderingContext.renderListCurrentFrame.forEach(function(object) {
                        _this2.hooks.beforeRender.call(object);
                        _this2.hooks.render.call(object);
                        _this2.hooks.afterRender.call(object);
                    });
                    this.hooks.endFrame.call(frame);
                    renderingContext.renderListCurrentFrame = [];
                    renderingContext.renderReasons.clear();
                    rerenderCallback();
                }
            }
        },
        {
            key: "renderDisplayObject",
            value: function renderDisplayObject(displayObject, canvasConfig, renderingContext) {
                var self1 = this;
                var _canvasConfig$rendere = canvasConfig.renderer.getConfig(), enableDirtyCheck = _canvasConfig$rendere.enableDirtyCheck, enableCulling = _canvasConfig$rendere.enableCulling;
                function internalRenderSingleDisplayObject(object) {
                    // TODO: relayout
                    // dirtycheck first
                    var renderable = object.renderable, sortable = object.sortable;
                    // eslint-disable-next-line no-nested-ternary
                    var objectChanged = enableDirtyCheck ? // @ts-ignore
                    renderable.dirty || renderingContext.dirtyRectangleRenderingDisabled ? object : null : object;
                    var objectToRender = null;
                    if (objectChanged) {
                        objectToRender = enableCulling ? self1.hooks.cull.call(objectChanged, self1.context.camera) : objectChanged;
                        if (objectToRender) {
                            self1.stats.rendered += 1;
                            renderingContext.renderListCurrentFrame.push(objectToRender);
                        }
                    }
                    object.dirty(false);
                    sortable.renderOrder = self1.zIndexCounter;
                    self1.zIndexCounter += 1;
                    self1.stats.total += 1;
                    // sort is very expensive, use cached result if possible
                    if (sortable.dirty) {
                        self1.sort(object, sortable);
                        sortable.dirty = false;
                        sortable.dirtyChildren = [];
                        sortable.dirtyReason = undefined;
                    }
                }
                var stack = [
                    displayObject
                ];
                while(stack.length > 0){
                    var _currentObject$sortab;
                    var currentObject = stack.pop();
                    internalRenderSingleDisplayObject(currentObject);
                    // recursive rendering its children
                    var objects = ((_currentObject$sortab = currentObject.sortable) === null || _currentObject$sortab === void 0 || (_currentObject$sortab = _currentObject$sortab.sorted) === null || _currentObject$sortab === void 0 ? void 0 : _currentObject$sortab.length) > 0 ? currentObject.sortable.sorted : currentObject.childNodes;
                    for(var i = objects.length - 1; i >= 0; i--)stack.push(objects[i]);
                }
            }
        },
        {
            key: "sort",
            value: function sort(displayObject, sortable) {
                var _sortable$sorted, _sortable$sorted2;
                if ((sortable === null || sortable === void 0 || (_sortable$sorted = sortable.sorted) === null || _sortable$sorted === void 0 ? void 0 : _sortable$sorted.length) > 0 && sortable.dirtyReason !== SortReason.Z_INDEX_CHANGED) // avoid re-sorting the whole children list
                sortable.dirtyChildren.forEach(function(child) {
                    // remove from sorted list
                    var sortIndex = sortable.sorted.indexOf(child);
                    if (sortIndex > -1) sortable.sorted.splice(sortIndex, 1);
                    var index = displayObject.childNodes.indexOf(child);
                    if (index > -1) {
                        if (sortable.sorted.length === 0) sortable.sorted.push(child);
                        else {
                            var _index = sortedIndex(sortable.sorted, child);
                            sortable.sorted.splice(_index, 0, child);
                        }
                    }
                });
                else sortable.sorted = displayObject.childNodes.slice().sort(sortByZIndex);
                // When the child elements are changed and sorted, if there are no more stacked elements in the child elements (i.e. zIndex != 0), clear the sort list
                if (((_sortable$sorted2 = sortable.sorted) === null || _sortable$sorted2 === void 0 ? void 0 : _sortable$sorted2.length) > 0 && displayObject.childNodes.filter(function(child) {
                    return child.parsedStyle.zIndex;
                }).length === 0) sortable.sorted = [];
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.inited = false;
                this.hooks.destroy.call();
            }
        },
        {
            key: "dirty",
            value: function dirty() {
                // need re-render
                this.context.renderingContext.renderReasons.add(RenderReason.DISPLAY_OBJECT_CHANGED);
            }
        }
    ]);
}();
var ATTRIBUTE_REGEXP = /\[\s*(.*)=(.*)\s*\]/;
/**
 * support the following DOM API:
 * * getElementById
 * * getElementsByClassName
 * * getElementsByName
 * * getElementsByTag
 * * querySelector
 * * querySelectorAll
 */ var DefaultSceneGraphSelector = /*#__PURE__*/ function() {
    function DefaultSceneGraphSelector() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DefaultSceneGraphSelector);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DefaultSceneGraphSelector, [
        {
            key: "selectOne",
            value: function selectOne(query, root) {
                var _this = this;
                if (query.startsWith('.')) return root.find(function(node) {
                    // return !node.shadow && node.id === query.substring(1);
                    return ((node === null || node === void 0 ? void 0 : node.classList) || []).indexOf(_this.getIdOrClassname(query)) > -1;
                });
                if (query.startsWith('#')) // getElementById('id')
                return root.find(function(node) {
                    // return !node.shadow && node.id === query.substring(1);
                    return node.id === _this.getIdOrClassname(query);
                });
                if (query.startsWith('[')) {
                    var _this$getAttribute = this.getAttribute(query), name = _this$getAttribute.name, value = _this$getAttribute.value;
                    if (name) // getElementByName();
                    return root.find(function(node) {
                        return root !== node && (name === 'name' ? node.name === value : _this.attributeToString(node, name) === value);
                    });
                    return null;
                }
                // getElementsByTag('circle');
                return root.find(function(node) {
                    return root !== node && node.nodeName === query;
                });
            }
        },
        {
            key: "selectAll",
            value: function selectAll(query, root) {
                var _this2 = this;
                // only support `[name="${name}"]` `.className` `#id`
                if (query.startsWith('.')) // getElementsByClassName('className');
                // should not include itself
                return root.findAll(function(node) {
                    return root !== node && ((node === null || node === void 0 ? void 0 : node.classList) || []).indexOf(_this2.getIdOrClassname(query)) > -1;
                });
                if (query.startsWith('#')) return root.findAll(function(node) {
                    return root !== node && node.id === _this2.getIdOrClassname(query);
                });
                if (query.startsWith('[')) {
                    var _this$getAttribute2 = this.getAttribute(query), name = _this$getAttribute2.name, value = _this$getAttribute2.value;
                    if (name) // getElementsByName();
                    return root.findAll(function(node) {
                        return root !== node && (name === 'name' ? node.name === value : _this2.attributeToString(node, name) === value);
                    });
                    return [];
                }
                // getElementsByTag('circle');
                return root.findAll(function(node) {
                    return root !== node && node.nodeName === query;
                });
            }
        },
        {
            key: "is",
            value: function is(query, node) {
                // a simple `matches` implementation
                if (query.startsWith('.')) return node.className === this.getIdOrClassname(query);
                if (query.startsWith('#')) return node.id === this.getIdOrClassname(query);
                if (query.startsWith('[')) {
                    var _this$getAttribute3 = this.getAttribute(query), name = _this$getAttribute3.name, value = _this$getAttribute3.value;
                    return name === 'name' ? node.name === value : this.attributeToString(node, name) === value;
                }
                return node.nodeName === query;
            }
        },
        {
            key: "getIdOrClassname",
            value: function getIdOrClassname(query) {
                return query.substring(1);
            }
        },
        {
            key: "getAttribute",
            value: function getAttribute(query) {
                var matches = query.match(ATTRIBUTE_REGEXP);
                var name = '';
                var value = '';
                if (matches && matches.length > 2) {
                    name = matches[1].replace(/"/g, '');
                    value = matches[2].replace(/"/g, '');
                }
                return {
                    name: name,
                    value: value
                };
            }
        },
        {
            key: "attributeToString",
            value: function attributeToString(node, name) {
                if (!node.getAttribute) return '';
                var value = node.getAttribute(name);
                if ((0, $geZBG.default)(value)) return '';
                if (value.toString) return value.toString();
                return '';
            }
        }
    ]);
}();
/**
 * built-in events for element
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MutationEvent
 *
 * TODO: use MutationObserver instead
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
 */ var ElementEvent = /*#__PURE__*/ function(ElementEvent) {
    // --- @see https://developer.mozilla.org/en-US/docs/Web/API/MutationEvent
    /**
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#event-type-DOMAttrModified
   */ ElementEvent["ATTR_MODIFIED"] = "DOMAttrModified";
    /**
   * it has been inserted
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#event-type-DOMNodeInserted
   */ ElementEvent["INSERTED"] = "DOMNodeInserted";
    /**
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#domnodeinsertedintodocument
   */ ElementEvent["MOUNTED"] = "DOMNodeInsertedIntoDocument";
    /**
   * it is being removed
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#event-type-DOMNodeRemoved
   */ ElementEvent["REMOVED"] = "removed";
    /**
   * @see https://www.w3.org/TR/DOM-Level-3-Events/#domnoderemovedfromdocument
   */ ElementEvent["UNMOUNTED"] = "DOMNodeRemovedFromDocument";
    // ---
    ElementEvent["REPARENT"] = "reparent";
    ElementEvent["DESTROY"] = "destroy";
    ElementEvent["BOUNDS_CHANGED"] = "bounds-changed";
    ElementEvent["CULLED"] = "culled";
    return ElementEvent;
}({});
// #region EventTarget
// #region Node
// #region Element
// #region AnimationTimeline
// #region Document
// #region CSSStyleDeclaration
/**
 * @see https://developer.mozilla.org/zh-CN/docs/Web/API/CSSStyleDeclaration
 */ // #region Canvas
/**
 * @deprecated https://developer.chrome.com/blog/mutation-events-deprecation
 */ var MutationEvent = /*#__PURE__*/ function(_FederatedEvent) {
    function MutationEvent(typeArg, relatedNode, prevValue, newValue, attrName, attrChange, prevParsedValue, newParsedValue) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, MutationEvent);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, MutationEvent, [
            null
        ]);
        _this.relatedNode = relatedNode;
        _this.prevValue = prevValue;
        _this.newValue = newValue;
        _this.attrName = attrName;
        _this.attrChange = attrChange;
        _this.prevParsedValue = prevParsedValue;
        _this.newParsedValue = newParsedValue;
        _this.type = typeArg;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(MutationEvent, _FederatedEvent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(MutationEvent);
}(FederatedEvent);
MutationEvent.ADDITION = 2;
MutationEvent.MODIFICATION = 1;
MutationEvent.REMOVAL = 3;
var reparentEvent = new MutationEvent(ElementEvent.REPARENT, null, '', '', '', 0, '', '');
// Object pooling
/** do not modify this objects */ var $vec2Zero = (0, $6BoVD).create();
/** do not modify this objects */ var $vec3Zero = (0, $eIStk).create();
/** do not modify this objects */ var $vec3One = (0, $eIStk).fromValues(1, 1, 1);
/** do not modify this objects */ var $mat4Identity = (0, $3iqbd).create();
/** shared objects */ var $vec2 = (0, $6BoVD).create();
/** shared objects */ var $vec3$1 = (0, $eIStk).create();
/** shared objects */ var $mat4 = (0, $3iqbd).create();
/** shared objects */ var $quat$1 = (0, $k1dpP).create();
var $setLocalTransform_1 = (0, $eIStk).create();
var $setLocalTransform_2 = (0, $k1dpP).create();
var $setLocalTransform_3 = (0, $eIStk).create();
var $setLocalPosition = (0, $eIStk).create();
var $setPosition_1 = (0, $eIStk).create();
var $setPosition_ParentInvertMatrix = (0, $3iqbd).create();
var $setEulerAngles_InvParentRot = (0, $k1dpP).create();
var $rotateLocal = (0, $k1dpP).create();
var $rotate_ParentInvertRotation = (0, $k1dpP).create();
/**
 * update transform in scene graph
 *
 * @see https://community.khronos.org/t/scene-graphs/50542/7
 */ var DefaultSceneGraphService = /*#__PURE__*/ function() {
    function DefaultSceneGraphService(runtime) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DefaultSceneGraphService);
        this.displayObjectDependencyMap = new WeakMap();
        this.runtime = runtime;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DefaultSceneGraphService, [
        {
            key: "matches",
            value: function matches(query, root) {
                return this.runtime.sceneGraphSelector.is(query, root);
            }
        },
        {
            key: "querySelector",
            value: function querySelector(query, root) {
                return this.runtime.sceneGraphSelector.selectOne(query, root);
            }
        },
        {
            key: "querySelectorAll",
            value: function querySelectorAll(query, root) {
                return this.runtime.sceneGraphSelector.selectAll(query, root);
            // .filter((node) => !node.shadow);
            }
        },
        {
            key: "attach",
            value: function attach(child, parent, index) {
                var _sortable$sorted;
                var detached = false;
                if (child.parentNode) {
                    detached = child.parentNode !== parent;
                    this.detach(child);
                }
                var isChildFragment = child.nodeName === Shape.FRAGMENT;
                var isAttachToFragment = isInFragment(parent);
                child.parentNode = parent;
                var nodes = isChildFragment ? child.childNodes : [
                    child
                ];
                if ((0, $jyI49.default)(index)) nodes.forEach(function(node) {
                    parent.childNodes.splice(index, 0, node);
                    node.parentNode = parent;
                });
                else nodes.forEach(function(node) {
                    parent.childNodes.push(node);
                    node.parentNode = parent;
                });
                // parent needs re-sort
                var _ref = parent, sortable = _ref.sortable;
                if (sortable !== null && sortable !== void 0 && (_sortable$sorted = sortable.sorted) !== null && _sortable$sorted !== void 0 && _sortable$sorted.length || sortable.dirty || child.parsedStyle.zIndex) {
                    if (sortable.dirtyChildren.indexOf(child) === -1) sortable.dirtyChildren.push(child);
                    // if (sortable) {
                    // only child has z-Index
                    sortable.dirty = true;
                    sortable.dirtyReason = SortReason.ADDED;
                }
                if (isAttachToFragment) return;
                if (isChildFragment) this.dirtyFragment(child);
                else {
                    var transform = child.transformable;
                    if (transform) this.dirtyWorldTransform(child, transform);
                }
                if (detached) {
                    var _parent$ownerDocument;
                    var enableCancelEventPropagation = ((_parent$ownerDocument = parent.ownerDocument) === null || _parent$ownerDocument === void 0 || (_parent$ownerDocument = _parent$ownerDocument.defaultView) === null || _parent$ownerDocument === void 0 || (_parent$ownerDocument = _parent$ownerDocument.getConfig()) === null || _parent$ownerDocument === void 0 || (_parent$ownerDocument = _parent$ownerDocument.future) === null || _parent$ownerDocument === void 0 ? void 0 : _parent$ownerDocument.experimentalCancelEventPropagation) === true;
                    child.dispatchEvent(reparentEvent, enableCancelEventPropagation, enableCancelEventPropagation);
                }
            }
        },
        {
            key: "detach",
            value: function detach(child) {
                var _sortable$sorted2, _style;
                if (!child.parentNode) return;
                var transform = child.transformable;
                // if (transform) {
                //   const worldTransform = this.getWorldTransform(child, transform);
                //   mat4.getScaling(transform.localScale, worldTransform);
                //   mat4.getTranslation(transform.localPosition, worldTransform);
                //   mat4.getRotation(transform.localRotation, worldTransform);
                //   transform.localDirtyFlag = true;
                // }
                // parent needs re-sort
                var _ref2 = child.parentNode, sortable = _ref2.sortable;
                // if (sortable) {
                if (sortable !== null && sortable !== void 0 && (_sortable$sorted2 = sortable.sorted) !== null && _sortable$sorted2 !== void 0 && _sortable$sorted2.length || (_style = child.style) !== null && _style !== void 0 && _style.zIndex) {
                    if (sortable.dirtyChildren.indexOf(child) === -1) sortable.dirtyChildren.push(child);
                    sortable.dirty = true;
                    sortable.dirtyReason = SortReason.REMOVED;
                }
                var index = child.parentNode.childNodes.indexOf(child);
                if (index > -1) child.parentNode.childNodes.splice(index, 1);
                if (transform) this.dirtyWorldTransform(child, transform);
                child.parentNode = null;
            }
        },
        {
            key: "getLocalPosition",
            value: function getLocalPosition(element) {
                return element.transformable.localPosition;
            }
        },
        {
            key: "getLocalRotation",
            value: function getLocalRotation(element) {
                return element.transformable.localRotation;
            }
        },
        {
            key: "getLocalScale",
            value: function getLocalScale(element) {
                return element.transformable.localScale;
            }
        },
        {
            key: "getLocalSkew",
            value: function getLocalSkew(element) {
                return element.transformable.localSkew;
            }
        },
        {
            key: "getLocalTransform",
            value: function getLocalTransform(element) {
                var transform = element.transformable;
                updateLocalTransform(transform);
                return transform.localTransform;
            }
        },
        {
            key: "setLocalPosition",
            value: function setLocalPosition(element, position) {
                var _position$;
                var dirtify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                var transform = element.transformable;
                $setLocalPosition[0] = position[0];
                $setLocalPosition[1] = position[1];
                $setLocalPosition[2] = (_position$ = position[2]) !== null && _position$ !== void 0 ? _position$ : 0;
                if ((0, $eIStk).equals(transform.localPosition, $setLocalPosition)) return;
                (0, $eIStk).copy(transform.localPosition, $setLocalPosition);
                if (dirtify) this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "translateLocal",
            value: function translateLocal(element, translation) {
                var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                if (typeof translation === 'number') translation = (0, $eIStk).fromValues(translation, y, z);
                var transform = element.transformable;
                if ((0, $eIStk).equals(translation, $vec3Zero)) return;
                (0, $eIStk).transformQuat(translation, translation, transform.localRotation);
                (0, $eIStk).add(transform.localPosition, transform.localPosition, translation);
                this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "setLocalRotation",
            value: function setLocalRotation(element, rotation, y, z, w) {
                var dirtify = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
                if (typeof rotation === 'number') rotation = (0, $k1dpP).set($quat$1, rotation, y, z, w);
                var transform = element.transformable;
                (0, $k1dpP).copy(transform.localRotation, rotation);
                if (dirtify) this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "rotateLocal",
            value: function rotateLocal(element, degrees) {
                var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                if (typeof degrees === 'number') degrees = (0, $eIStk).fromValues(degrees, y, z);
                var transform = element.transformable;
                (0, $k1dpP).fromEuler($rotateLocal, degrees[0], degrees[1], degrees[2]);
                (0, $k1dpP).mul(transform.localRotation, transform.localRotation, $rotateLocal);
                this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "setLocalScale",
            value: function setLocalScale(element, scaling) {
                var _scaling$;
                var dirtify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                var transform = element.transformable;
                (0, $eIStk).set($vec3$1, scaling[0], scaling[1], (_scaling$ = scaling[2]) !== null && _scaling$ !== void 0 ? _scaling$ : transform.localScale[2]);
                if ((0, $eIStk).equals($vec3$1, transform.localScale)) return;
                (0, $eIStk).copy(transform.localScale, $vec3$1);
                if (dirtify) this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "scaleLocal",
            value: function scaleLocal(element, scaling) {
                var _scaling$2;
                var transform = element.transformable;
                (0, $eIStk).multiply(transform.localScale, transform.localScale, (0, $eIStk).set($vec3$1, scaling[0], scaling[1], (_scaling$2 = scaling[2]) !== null && _scaling$2 !== void 0 ? _scaling$2 : 1));
                this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "setLocalSkew",
            value: function setLocalSkew(element, skew, y) {
                var dirtify = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                if (typeof skew === 'number') skew = (0, $6BoVD).set($vec2, skew, y);
                var transform = element.transformable;
                (0, $6BoVD).copy(transform.localSkew, skew);
                if (dirtify) this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "setLocalEulerAngles",
            value: function setLocalEulerAngles(element, degrees) {
                var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var dirtify = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
                if (typeof degrees === 'number') degrees = (0, $eIStk).fromValues(degrees, y, z);
                var transform = element.transformable;
                (0, $k1dpP).fromEuler(transform.localRotation, degrees[0], degrees[1], degrees[2]);
                if (dirtify) this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "setLocalTransform",
            value: function setLocalTransform(element, transform) {
                var t = (0, $3iqbd).getTranslation($setLocalTransform_1, transform);
                var r = (0, $3iqbd).getRotation($setLocalTransform_2, transform);
                var s = (0, $3iqbd).getScaling($setLocalTransform_3, transform);
                this.setLocalScale(element, s, false);
                this.setLocalPosition(element, t, false);
                this.setLocalRotation(element, r, undefined, undefined, undefined, false);
                this.dirtyLocalTransform(element, element.transformable);
            }
        },
        {
            key: "resetLocalTransform",
            value: function resetLocalTransform(element) {
                this.setLocalScale(element, $vec3One, false);
                this.setLocalPosition(element, $vec3Zero, false);
                this.setLocalEulerAngles(element, $vec3Zero, undefined, undefined, false);
                this.setLocalSkew(element, $vec2Zero, undefined, false);
                this.dirtyLocalTransform(element, element.transformable);
            }
        },
        {
            key: "getPosition",
            value: function getPosition(element) {
                var transform = element.transformable;
                return (0, $3iqbd).getTranslation(transform.position, this.getWorldTransform(element, transform));
            }
        },
        {
            key: "getRotation",
            value: function getRotation(element) {
                var transform = element.transformable;
                return (0, $3iqbd).getRotation(transform.rotation, this.getWorldTransform(element, transform));
            }
        },
        {
            key: "getScale",
            value: function getScale(element) {
                var transform = element.transformable;
                return (0, $3iqbd).getScaling(transform.scaling, this.getWorldTransform(element, transform));
            }
        },
        {
            key: "getOrigin",
            value: function getOrigin(element) {
                element.getGeometryBounds();
                return element.transformable.origin;
            }
        },
        {
            key: "getWorldTransform",
            value: function getWorldTransform(element) {
                var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : element.transformable;
                if (!transform.localDirtyFlag && !transform.dirtyFlag) return transform.worldTransform;
                if (element.parentNode && element.parentNode.transformable) this.getWorldTransform(element.parentNode);
                this.internalUpdateTransform(element);
                return transform.worldTransform;
            }
        },
        {
            key: "setPosition",
            value: function setPosition(element, position) {
                var _position$2;
                var transform = element.transformable;
                $setPosition_1[0] = position[0];
                $setPosition_1[1] = position[1];
                $setPosition_1[2] = (_position$2 = position[2]) !== null && _position$2 !== void 0 ? _position$2 : 0;
                if ((0, $eIStk).equals(this.getPosition(element), $setPosition_1)) return;
                (0, $eIStk).copy(transform.position, $setPosition_1);
                if (element.parentNode === null || !element.parentNode.transformable) (0, $eIStk).copy(transform.localPosition, $setPosition_1);
                else {
                    var parentTransform = element.parentNode.transformable;
                    (0, $3iqbd).copy($setPosition_ParentInvertMatrix, parentTransform.worldTransform);
                    (0, $3iqbd).invert($setPosition_ParentInvertMatrix, $setPosition_ParentInvertMatrix);
                    (0, $eIStk).transformMat4(transform.localPosition, $setPosition_1, $setPosition_ParentInvertMatrix);
                }
                this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "translate",
            value: function translate(element, translation) {
                var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                if (typeof translation === 'number') translation = (0, $eIStk).set($vec3$1, translation, y, z);
                if ((0, $eIStk).equals(translation, $vec3Zero)) return;
                (0, $eIStk).add($vec3$1, this.getPosition(element), translation);
                this.setPosition(element, $vec3$1);
            }
        },
        {
            key: "setRotation",
            value: function setRotation(element, rotation, y, z, w) {
                var transform = element.transformable;
                if (typeof rotation === 'number') rotation = (0, $k1dpP).fromValues(rotation, y, z, w);
                if (element.parentNode === null || !element.parentNode.transformable) this.setLocalRotation(element, rotation);
                else {
                    var parentRot = this.getRotation(element.parentNode);
                    (0, $k1dpP).copy($quat$1, parentRot);
                    (0, $k1dpP).invert($quat$1, $quat$1);
                    (0, $k1dpP).multiply(transform.localRotation, $quat$1, rotation);
                    (0, $k1dpP).normalize(transform.localRotation, transform.localRotation);
                    this.dirtyLocalTransform(element, transform);
                }
            }
        },
        {
            key: "rotate",
            value: function rotate(element, degrees) {
                var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                if (typeof degrees === 'number') degrees = (0, $eIStk).fromValues(degrees, y, z);
                var transform = element.transformable;
                if (element.parentNode === null || !element.parentNode.transformable) this.rotateLocal(element, degrees);
                else {
                    var rotation = $quat$1;
                    (0, $k1dpP).fromEuler(rotation, degrees[0], degrees[1], degrees[2]);
                    var rot = this.getRotation(element);
                    var parentRot = this.getRotation(element.parentNode);
                    (0, $k1dpP).copy($rotate_ParentInvertRotation, parentRot);
                    (0, $k1dpP).invert($rotate_ParentInvertRotation, $rotate_ParentInvertRotation);
                    (0, $k1dpP).multiply(rotation, $rotate_ParentInvertRotation, rotation);
                    (0, $k1dpP).multiply(transform.localRotation, rotation, rot);
                    (0, $k1dpP).normalize(transform.localRotation, transform.localRotation);
                    this.dirtyLocalTransform(element, transform);
                }
            }
        },
        {
            key: "setOrigin",
            value: function setOrigin(element, origin) {
                var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                if (typeof origin === 'number') origin = [
                    origin,
                    y,
                    z
                ];
                var transform = element.transformable;
                if (origin[0] === transform.origin[0] && origin[1] === transform.origin[1] && origin[2] === transform.origin[2]) return;
                var originVec = transform.origin;
                // const delta = vec3.subtract(vec3.create(), origin, originVec);
                // vec3.add(transform.localPosition, transform.localPosition, delta);
                // update origin
                originVec[0] = origin[0];
                originVec[1] = origin[1];
                originVec[2] = origin[2] || 0;
                this.dirtyLocalTransform(element, transform);
            }
        },
        {
            key: "setEulerAngles",
            value: function setEulerAngles(element, degrees) {
                var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                var z = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                if (typeof degrees === 'number') degrees = (0, $eIStk).fromValues(degrees, y, z);
                var transform = element.transformable;
                if (element.parentNode === null || !element.parentNode.transformable) this.setLocalEulerAngles(element, degrees);
                else {
                    (0, $k1dpP).fromEuler(transform.localRotation, degrees[0], degrees[1], degrees[2]);
                    var parentRotation = this.getRotation(element.parentNode);
                    (0, $k1dpP).copy($setEulerAngles_InvParentRot, (0, $k1dpP).invert($quat$1, parentRotation));
                    (0, $k1dpP).mul(transform.localRotation, transform.localRotation, $setEulerAngles_InvParentRot);
                    this.dirtyLocalTransform(element, transform);
                }
            }
        },
        {
            key: "getGeometryBounds",
            value: function getGeometryBounds(element) {
                var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var _ref3 = element, geometry = _ref3.geometry;
                if (geometry.dirty) runtime.styleValueRegistry.updateGeometry(element);
                var bounds = render ? geometry.renderBounds : geometry.contentBounds || null;
                // return (bounds && new AABB(bounds.center, bounds.halfExtents)) || new AABB();
                return bounds || new AABB();
            }
        },
        {
            key: "getTransformedGeometryBounds",
            value: function getTransformedGeometryBounds(element) {
                var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var existedAABB = arguments.length > 2 ? arguments[2] : undefined;
                var bounds = this.getGeometryBounds(element, render);
                if (!AABB.isEmpty(bounds)) {
                    var aabb = existedAABB || new AABB();
                    aabb.setFromTransformedAABB(bounds, this.getWorldTransform(element));
                    return aabb;
                }
                return null;
            }
        },
        {
            key: "getBounds",
            value: function getBounds(element) {
                var _this = this;
                var render = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var _ref4 = element, renderable = _ref4.renderable;
                if (!renderable.boundsDirty && !render && renderable.bounds) return renderable.bounds;
                if (!renderable.renderBoundsDirty && render && renderable.renderBounds) return renderable.renderBounds;
                // reuse existed if possible
                var existedAABB = render ? renderable.renderBounds : renderable.bounds;
                // reset with geometry's aabb
                var aabb = this.getTransformedGeometryBounds(element, render, existedAABB);
                // merge children's aabbs
                var children = element.childNodes;
                children.forEach(function(child) {
                    var childBounds = _this.getBounds(child, render);
                    if (childBounds) {
                        if (!aabb) {
                            aabb = existedAABB || new AABB();
                            aabb.update(childBounds.center, childBounds.halfExtents);
                        } else aabb.add(childBounds);
                    }
                });
                if (!aabb) aabb = new AABB();
                if (render) {
                    // FIXME: account for clip path
                    var clipped = findClosestClipPathTarget(element);
                    if (clipped) {
                        // use bounds under world space
                        var clipPathBounds = clipped.parsedStyle.clipPath.getBounds(render);
                        if (!aabb) aabb.update(clipPathBounds.center, clipPathBounds.halfExtents);
                        else if (clipPathBounds) aabb = clipPathBounds.intersection(aabb);
                    }
                }
                if (render) {
                    renderable.renderBounds = aabb;
                    renderable.renderBoundsDirty = false;
                } else {
                    renderable.bounds = aabb;
                    renderable.boundsDirty = false;
                }
                return aabb;
            }
        },
        {
            key: "getLocalBounds",
            value: function getLocalBounds(element) {
                if (element.parentNode) {
                    var parentInvert = $mat4Identity;
                    if (element.parentNode.transformable) parentInvert = (0, $3iqbd).invert($mat4, this.getWorldTransform(element.parentNode));
                    var bounds = this.getBounds(element);
                    if (!AABB.isEmpty(bounds)) {
                        var localBounds = new AABB();
                        localBounds.setFromTransformedAABB(bounds, parentInvert);
                        return localBounds;
                    }
                }
                return this.getBounds(element);
            }
        },
        {
            key: "getBoundingClientRect",
            value: function getBoundingClientRect(element) {
                var _element$ownerDocumen;
                var aabb;
                var bounds = this.getGeometryBounds(element);
                if (!AABB.isEmpty(bounds)) {
                    aabb = new AABB();
                    // apply transformation to aabb
                    aabb.setFromTransformedAABB(bounds, this.getWorldTransform(element));
                }
                // calc context's offset
                var bbox = (_element$ownerDocumen = element.ownerDocument) === null || _element$ownerDocumen === void 0 || (_element$ownerDocumen = _element$ownerDocumen.defaultView) === null || _element$ownerDocumen === void 0 ? void 0 : _element$ownerDocumen.getContextService().getBoundingClientRect();
                if (aabb) {
                    var _aabb$getMin = aabb.getMin(), _aabb$getMin2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_aabb$getMin, 2), left = _aabb$getMin2[0], top = _aabb$getMin2[1];
                    var _aabb$getMax = aabb.getMax(), _aabb$getMax2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_aabb$getMax, 2), right = _aabb$getMax2[0], bottom = _aabb$getMax2[1];
                    return new Rectangle(left + ((bbox === null || bbox === void 0 ? void 0 : bbox.left) || 0), top + ((bbox === null || bbox === void 0 ? void 0 : bbox.top) || 0), right - left, bottom - top);
                }
                return new Rectangle((bbox === null || bbox === void 0 ? void 0 : bbox.left) || 0, (bbox === null || bbox === void 0 ? void 0 : bbox.top) || 0, 0, 0);
            }
        },
        {
            key: "internalUpdateTransform",
            value: function internalUpdateTransform(element) {
                var _element$parentNode;
                var parentTransform = (_element$parentNode = element.parentNode) === null || _element$parentNode === void 0 ? void 0 : _element$parentNode.transformable;
                updateLocalTransform(element.transformable);
                updateWorldTransform(element.transformable, parentTransform);
            }
        },
        {
            key: "internalUpdateElement",
            value: function internalUpdateElement(element, ancestors) {
                var _element$ownerDocumen2, _element$transformabl, _element$renderable, _element$renderable2;
                var enableAttributeUpdateOptimization = ((_element$ownerDocumen2 = element.ownerDocument) === null || _element$ownerDocumen2 === void 0 || (_element$ownerDocumen2 = _element$ownerDocumen2.defaultView) === null || _element$ownerDocumen2 === void 0 || (_element$ownerDocumen2 = _element$ownerDocumen2.getConfig()) === null || _element$ownerDocumen2 === void 0 || (_element$ownerDocumen2 = _element$ownerDocumen2.future) === null || _element$ownerDocumen2 === void 0 ? void 0 : _element$ownerDocumen2.experimentalAttributeUpdateOptimization) === true;
                var parent = ancestors[ancestors.length - 1];
                // parent nodes affect child nodes
                var transformDirty = (parent === null || parent === void 0 ? void 0 : parent.transformDirty) || ((_element$transformabl = element.transformable) === null || _element$transformabl === void 0 ? void 0 : _element$transformabl.localDirtyFlag);
                if (element.transformable) {
                    var _element$transformabl2;
                    (_element$transformabl2 = element.transformable).dirtyFlag || (_element$transformabl2.dirtyFlag = transformDirty);
                }
                this.internalUpdateTransform(element);
                if (transformDirty) {
                    var _element$dirty;
                    (_element$dirty = element.dirty) === null || _element$dirty === void 0 || _element$dirty.call(element, true, true);
                }
                var shapeUpdated = ((_element$renderable = element.renderable) === null || _element$renderable === void 0 ? void 0 : _element$renderable.boundsDirty) || ((_element$renderable2 = element.renderable) === null || _element$renderable2 === void 0 ? void 0 : _element$renderable2.renderBoundsDirty);
                // The transformation matrix of the child node changes,
                // which will cause the bounding box data of the ancestor node to become outdated.
                if ((transformDirty || shapeUpdated) && (parent === null || parent === void 0 ? void 0 : parent.shapeUpdated) === false && enableAttributeUpdateOptimization) {
                    var tempElIndex = ancestors.length - 1;
                    while(tempElIndex >= 0){
                        var _dirty, _ref5;
                        var tempEl = ancestors[tempElIndex];
                        if (tempEl.shapeUpdated) break;
                        (_dirty = (_ref5 = tempEl.node).dirty) === null || _dirty === void 0 || _dirty.call(_ref5, true, true);
                        tempEl.shapeUpdated = true;
                        tempElIndex -= 1;
                    }
                }
                return transformDirty;
            }
        },
        {
            key: "syncHierarchy",
            value: function syncHierarchy(rootNode) {
                var _transformable, _transformable2;
                var stack = [
                    rootNode
                ];
                var ancestors = rootNode.parentNode ? [
                    {
                        node: rootNode.parentNode,
                        transformDirty: ((_transformable = rootNode.parentNode.transformable) === null || _transformable === void 0 ? void 0 : _transformable.localDirtyFlag) || ((_transformable2 = rootNode.parentNode.transformable) === null || _transformable2 === void 0 ? void 0 : _transformable2.dirtyFlag),
                        shapeUpdated: false
                    }
                ] : [];
                while(stack.length > 0){
                    var node = stack.pop();
                    var parent = ancestors[ancestors.length - 1];
                    while(ancestors.length > 0 && node.parentNode !== parent.node)parent = ancestors.pop();
                    var transformDirty = this.internalUpdateElement(node, ancestors);
                    if (node.childNodes.length > 0) {
                        for(var i = node.childNodes.length - 1; i >= 0; i--)stack.push(node.childNodes[i]);
                        ancestors.push({
                            node: node,
                            transformDirty: transformDirty,
                            shapeUpdated: false
                        });
                    }
                }
            }
        },
        {
            key: "dirtyLocalTransform",
            value: function dirtyLocalTransform(element, transform) {
                if (isInFragment(element)) return;
                if (!transform.localDirtyFlag) {
                    transform.localDirtyFlag = true;
                    if (!transform.dirtyFlag) this.dirtyWorldTransform(element, transform);
                }
            }
        },
        {
            key: "dirtyWorldTransform",
            value: function dirtyWorldTransform(element, transform) {
                this.dirtyWorldInternal(element, transform);
                this.dirtyToRoot(element, true);
            }
        },
        {
            key: "dirtyWorldInternal",
            value: function dirtyWorldInternal(element, transform) {
                var _element$ownerDocumen3, _this2 = this;
                var enableAttributeUpdateOptimization = ((_element$ownerDocumen3 = element.ownerDocument) === null || _element$ownerDocumen3 === void 0 || (_element$ownerDocumen3 = _element$ownerDocumen3.defaultView) === null || _element$ownerDocumen3 === void 0 || (_element$ownerDocumen3 = _element$ownerDocumen3.getConfig()) === null || _element$ownerDocumen3 === void 0 || (_element$ownerDocumen3 = _element$ownerDocumen3.future) === null || _element$ownerDocumen3 === void 0 ? void 0 : _element$ownerDocumen3.experimentalAttributeUpdateOptimization) === true;
                if (!transform.dirtyFlag) {
                    transform.dirtyFlag = true;
                    element.dirty(true, true);
                    if (!enableAttributeUpdateOptimization) element.childNodes.forEach(function(child) {
                        var childTransform = child.transformable;
                        _this2.dirtyWorldInternal(child, childTransform);
                    });
                }
            }
        },
        {
            key: "dirtyToRoot",
            value: function dirtyToRoot(element) {
                var _element$ownerDocumen4;
                var affectChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var p = element;
                var enableAttributeUpdateOptimization = ((_element$ownerDocumen4 = element.ownerDocument) === null || _element$ownerDocumen4 === void 0 || (_element$ownerDocumen4 = _element$ownerDocumen4.defaultView) === null || _element$ownerDocumen4 === void 0 || (_element$ownerDocumen4 = _element$ownerDocumen4.getConfig()) === null || _element$ownerDocumen4 === void 0 || (_element$ownerDocumen4 = _element$ownerDocumen4.future) === null || _element$ownerDocumen4 === void 0 ? void 0 : _element$ownerDocumen4.experimentalAttributeUpdateOptimization) === true;
                while(p){
                    var _dirty2, _ref6;
                    (_dirty2 = (_ref6 = p).dirty) === null || _dirty2 === void 0 || _dirty2.call(_ref6, true, true);
                    if (enableAttributeUpdateOptimization) break;
                    else p = p.parentNode;
                }
                if (affectChildren) element.forEach(function(e) {
                    var _e$dirty;
                    (_e$dirty = e.dirty) === null || _e$dirty === void 0 || _e$dirty.call(e, true, true);
                });
                this.informDependentDisplayObjects(element);
                var mutations = element.mutations || [];
                var boundChangeMutation = mutations.find(function(item) {
                    return item.type === 'attributes' && item._boundsChangeData;
                });
                if (!boundChangeMutation) {
                    boundChangeMutation = {
                        type: 'attributes',
                        target: element,
                        _boundsChangeData: {
                            affectChildren: affectChildren
                        }
                    };
                    mutations.push(boundChangeMutation);
                } else boundChangeMutation._boundsChangeData = {
                    affectChildren: boundChangeMutation._boundsChangeData.affectChildren || affectChildren
                };
                element.mutations = mutations;
            }
        },
        {
            key: "dirtyFragment",
            value: function dirtyFragment(element) {
                var _dirty3, _ref7;
                var transform = element.transformable;
                if (transform) {
                    transform.dirtyFlag = true;
                    transform.localDirtyFlag = true;
                }
                (_dirty3 = (_ref7 = element).dirty) === null || _dirty3 === void 0 || _dirty3.call(_ref7, true, true);
                var length = element.childNodes.length;
                for(var i = 0; i < length; i++)this.dirtyFragment(element.childNodes[i]);
            }
        },
        {
            key: "notifyMutationObservers",
            value: function notifyMutationObservers(canvas) {
                var mutations = new Set();
                canvas.getRoot().forEach(function(item) {
                    (item.mutations || []).forEach(function(mutation) {
                        if (mutation.type === 'attributes' && mutation._boundsChangeData) {
                            if (mutation._boundsChangeData.affectChildren) item.forEach(function(node) {
                                var newMutation = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, mutation);
                                newMutation.target = node;
                                mutations.add(newMutation);
                            });
                            else mutations.add(mutation);
                        }
                    });
                    item.mutations = undefined;
                });
                if (mutations.size > 0) {
                    var event = new CustomEvent(ElementEvent.BOUNDS_CHANGED, {
                        detail: Array.from(mutations)
                    });
                    canvas.dispatchEvent(event, true, true);
                }
            }
        },
        {
            key: "updateDisplayObjectDependency",
            value: function updateDisplayObjectDependency(name, oldPath, newPath, object) {
                // clear ref to old clip path
                if (oldPath && oldPath !== newPath) {
                    var oldDependencyMap = this.displayObjectDependencyMap.get(oldPath);
                    if (oldDependencyMap && oldDependencyMap[name]) {
                        var index = oldDependencyMap[name].indexOf(object);
                        oldDependencyMap[name].splice(index, 1);
                    }
                }
                if (newPath) {
                    var newDependencyMap = this.displayObjectDependencyMap.get(newPath);
                    if (!newDependencyMap) {
                        this.displayObjectDependencyMap.set(newPath, {});
                        newDependencyMap = this.displayObjectDependencyMap.get(newPath);
                    }
                    if (!newDependencyMap[name]) newDependencyMap[name] = [];
                    newDependencyMap[name].push(object);
                }
            }
        },
        {
            key: "informDependentDisplayObjects",
            value: function informDependentDisplayObjects(object) {
                var _object$ownerDocument, _this3 = this;
                var dependencyMap = this.displayObjectDependencyMap.get(object);
                if (!dependencyMap) return;
                var enableCancelEventPropagation = (_object$ownerDocument = object.ownerDocument) === null || _object$ownerDocument === void 0 || (_object$ownerDocument = _object$ownerDocument.defaultView) === null || _object$ownerDocument === void 0 || (_object$ownerDocument = _object$ownerDocument.getConfig()) === null || _object$ownerDocument === void 0 || (_object$ownerDocument = _object$ownerDocument.future) === null || _object$ownerDocument === void 0 ? void 0 : _object$ownerDocument.experimentalCancelEventPropagation;
                Object.keys(dependencyMap).forEach(function(name) {
                    dependencyMap[name].forEach(function(target) {
                        _this3.dirtyToRoot(target, true);
                        target.dispatchEvent(new MutationEvent(ElementEvent.ATTR_MODIFIED, target, _this3, _this3, name, MutationEvent.MODIFICATION, _this3, _this3), enableCancelEventPropagation, enableCancelEventPropagation);
                        if (target.isCustomElement && target.isConnected) {
                            if (target.attributeChangedCallback) target.attributeChangedCallback(name, _this3, _this3);
                        }
                    });
                });
            }
        }
    ]);
}();
/**
 * A classic LRU (Least Recently Used) cache implementation.
 * It evicts the least recently used item when the cache is full.
 *
 * It uses a Map for O(1) key-based access
 * to maintain the usage order of items.
 *
 * 通过利用 JavaScript 内置 Map 的特性（按插入顺序迭代），我们不再需要手动维护一个双向链表
 */ var LRU = /*#__PURE__*/ function() {
    function LRU(capacity) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, LRU);
        if (capacity <= 0) throw new Error('LRU capacity must be a positive number.');
        this.capacity = capacity;
        // Using a Map directly simplifies the implementation significantly.
        // A Map in modern JS engines iterates in insertion order, which is exactly what we need.
        this.cache = new Map();
    }
    /**
   * Retrieves an item from the cache. Marks the item as recently used.
   * @param key The key of the item to retrieve.
   * @returns The value of the item, or undefined if not found.
   */ return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(LRU, [
        {
            key: "get",
            value: function get(key) {
                if (!this.cache.has(key)) return undefined;
                // Get the value.
                var value = this.cache.get(key);
                // Mark as recently used by deleting and re-setting the key.
                // This moves the key to the end of the Map's internal order.
                this.cache["delete"](key);
                this.cache.set(key, value);
                return value;
            }
        },
        {
            key: "put",
            value: function put(key, value) {
                // If the key already exists, delete it first to ensure it's moved to the end.
                if (this.cache.has(key)) this.cache["delete"](key);
                // Add the new item. It will be the most recently used.
                this.cache.set(key, value);
                // Check if the cache has exceeded its capacity.
                if (this.cache.size > this.capacity) {
                    // Evict the least recently used item, which is the first one in the Map's iteration order.
                    var leastRecentlyUsedKey = this.cache.keys().next().value;
                    this.cache["delete"](leastRecentlyUsedKey);
                }
            }
        },
        {
            key: "len",
            value: function len() {
                return this.cache.size;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.cache.clear();
            }
        }
    ]);
}();
var TEXT_METRICS = {
    MetricsString: "|\xc9q\xc5",
    BaselineSymbol: 'M',
    BaselineMultiplier: 1.4,
    HeightMultiplier: 2,
    Newlines: [
        0x000a,
        // line feed
        0x000d // carriage return
    ],
    BreakingSpaces: [
        0x0009,
        // character tabulation
        0x0020,
        // space
        0x2000,
        // en quad
        0x2001,
        // em quad
        0x2002,
        // en space
        0x2003,
        // em space
        0x2004,
        // three-per-em space
        0x2005,
        // four-per-em space
        0x2006,
        // six-per-em space
        0x2008,
        // punctuation space
        0x2009,
        // thin space
        0x200a,
        // hair space
        0x205f,
        // medium mathematical space
        0x3000 // ideographic space
    ]
};
var LATIN_REGEX = /[a-zA-Z0-9\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff!"#$%&'()*+,-./:;]/;
// Line breaking rules in CJK (Kinsoku Shori)
// Refer from https://en.wikipedia.org/wiki/Line_breaking_rules_in_East_Asian_languages
var regexCannotStartZhCn = /[!%),.:;?\]}¢°·'""†‡›℃∶、。〃〆〕〗〞﹚﹜！＂％＇），．：；？！］｝～]/;
var regexCannotEndZhCn = /[$(£¥·'"〈《「『【〔〖〝﹙﹛＄（．［｛￡￥]/;
var regexCannotStartZhTw = /[!),.:;?\]}¢·–—'"•"、。〆〞〕〉》」︰︱︲︳﹐﹑﹒﹓﹔﹕﹖﹘﹚﹜！），．：；？︶︸︺︼︾﹀﹂﹗］｜｝､]/;
var regexCannotEndZhTw = /[([{£¥'"‵〈《「『〔〝︴﹙﹛（｛︵︷︹︻︽︿﹁﹃﹏]/;
var regexCannotStartJaJp = /[)\]｝〕〉》」』】〙〗〟'"｠»ヽヾーァィゥェォッャュョヮヵヶぁぃぅぇぉっゃゅょゎゕゖㇰㇱㇲㇳㇴㇵㇶㇷㇸㇹㇺㇻㇼㇽㇾㇿ々〻‐゠–〜?!‼⁇⁈⁉・、:;,。.]/;
var regexCannotEndJaJp = /[([｛〔〈《「『【〘〖〝'"｟«—...‥〳〴〵]/;
var regexCannotStartKoKr = /[!%),.:;?\]}¢°'"†‡℃〆〈《「『〕！％），．：；？］｝]/;
var regexCannotEndKoKr = /[$([{£¥'"々〇〉》」〔＄（［｛｠￥￦#]/;
var regexCannotStart = new RegExp("".concat(regexCannotStartZhCn.source, "|").concat(regexCannotStartZhTw.source, "|").concat(regexCannotStartJaJp.source, "|").concat(regexCannotStartKoKr.source));
var regexCannotEnd = new RegExp("".concat(regexCannotEndZhCn.source, "|").concat(regexCannotEndZhTw.source, "|").concat(regexCannotEndJaJp.source, "|").concat(regexCannotEndKoKr.source));
/**
 * Borrow from pixi/packages/text/src/TextMetrics.ts
 */ var TextService = /*#__PURE__*/ function() {
    function TextService(runtime) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, TextService);
        /**
     * font metrics cache
     */ this.fontMetricsCache = {};
        this.shouldBreakByKinsokuShorui = function(_char, nextChar) {
            if (_this.isBreakingSpace(nextChar)) return false;
            if (_char) {
                // Line breaking rules in CJK (Kinsoku Shori)
                if (regexCannotEnd.exec(nextChar) || regexCannotStart.exec(_char)) return true;
            }
            return false;
        };
        this.trimByKinsokuShorui = function(prev) {
            var next = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(prev);
            var prevLine = next[next.length - 2];
            if (!prevLine) return prev;
            var lastChar = prevLine[prevLine.length - 1];
            next[next.length - 2] = prevLine.slice(0, -1);
            next[next.length - 1] = lastChar + next[next.length - 1];
            return next;
        };
        this.runtime = runtime;
        this.charWidthCache = new LRU(100);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(TextService, [
        {
            key: "measureFont",
            value: /**
     * A global cache for character widths, keyed by font string.
     * e.g. { '16px Arial': { 'a': 8, 'b': 9 } }
     */ /**
     * Calculates the ascent, descent and fontSize of a given font-style.
     */ function measureFont(font, offscreenCanvas) {
                // as this method is used for preparing assets, don't recalculate things if we don't need to
                if (this.fontMetricsCache[font]) return this.fontMetricsCache[font];
                var properties = {
                    ascent: 0,
                    descent: 0,
                    fontSize: 0
                };
                var canvas = this.runtime.offscreenCanvasCreator.getOrCreateCanvas(offscreenCanvas);
                var context = this.runtime.offscreenCanvasCreator.getOrCreateContext(offscreenCanvas, {
                    willReadFrequently: true
                });
                context.font = font;
                var metricsString = TEXT_METRICS.MetricsString + TEXT_METRICS.BaselineSymbol;
                var width = Math.ceil(context.measureText(metricsString).width);
                var baseline = Math.ceil(context.measureText(TEXT_METRICS.BaselineSymbol).width);
                var height = TEXT_METRICS.HeightMultiplier * baseline;
                baseline = baseline * TEXT_METRICS.BaselineMultiplier | 0;
                // @ts-ignore
                canvas.width = width;
                // @ts-ignore
                canvas.height = height;
                context.fillStyle = '#f00';
                context.fillRect(0, 0, width, height);
                context.font = font;
                context.textBaseline = 'alphabetic';
                context.fillStyle = '#000';
                context.fillText(metricsString, 0, baseline);
                var imagedata = context.getImageData(0, 0, width || 1, height || 1).data;
                var pixels = imagedata.length;
                var line = width * 4;
                var i = 0;
                var idx = 0;
                var stop = false;
                // ascent. scan from top to bottom until we find a non red pixel
                for(i = 0; i < baseline; ++i){
                    for(var j = 0; j < line; j += 4)if (imagedata[idx + j] !== 255) {
                        stop = true;
                        break;
                    }
                    if (!stop) idx += line;
                    else break;
                }
                properties.ascent = baseline - i;
                idx = pixels - line;
                stop = false;
                // descent. scan from bottom to top until we find a non red pixel
                for(i = height; i > baseline; --i){
                    for(var _j = 0; _j < line; _j += 4)if (imagedata[idx + _j] !== 255) {
                        stop = true;
                        break;
                    }
                    if (!stop) idx -= line;
                    else break;
                }
                properties.descent = i - baseline;
                properties.fontSize = properties.ascent + properties.descent;
                this.fontMetricsCache[font] = properties;
                return properties;
            }
        },
        {
            key: "measureText",
            value: function measureText(text, parsedStyle, offscreenCanvas) {
                var _parsedStyle$fontSize = parsedStyle.fontSize, fontSize = _parsedStyle$fontSize === void 0 ? 16 : _parsedStyle$fontSize, _parsedStyle$wordWrap = parsedStyle.wordWrap, wordWrap = _parsedStyle$wordWrap === void 0 ? false : _parsedStyle$wordWrap, strokeHeight = parsedStyle.lineHeight, _parsedStyle$lineWidt = parsedStyle.lineWidth, lineWidth = _parsedStyle$lineWidt === void 0 ? 1 : _parsedStyle$lineWidt, _parsedStyle$textBase = parsedStyle.textBaseline, textBaseline = _parsedStyle$textBase === void 0 ? 'alphabetic' : _parsedStyle$textBase, _parsedStyle$textAlig = parsedStyle.textAlign, textAlign = _parsedStyle$textAlig === void 0 ? 'start' : _parsedStyle$textAlig, _parsedStyle$letterSp = parsedStyle.letterSpacing, letterSpacing = _parsedStyle$letterSp === void 0 ? 0 : _parsedStyle$letterSp, textPath = parsedStyle.textPath;
                parsedStyle.textPathSide;
                parsedStyle.textPathStartOffset;
                var _parsedStyle$leading = parsedStyle.leading, leading = _parsedStyle$leading === void 0 ? 0 : _parsedStyle$leading;
                var font = toFontString(parsedStyle);
                var fontProperties = this.measureFont(font, offscreenCanvas);
                // fallback in case UA disallow canvas data extraction
                if (fontProperties.fontSize === 0) {
                    fontProperties.fontSize = fontSize;
                    fontProperties.ascent = fontSize;
                }
                var context = this.runtime.offscreenCanvasCreator.getOrCreateContext(offscreenCanvas);
                context.font = font;
                // no overflowing by default
                parsedStyle.isOverflowing = false;
                var outputText = wordWrap ? this.wordWrap(text, parsedStyle, offscreenCanvas) : text;
                var lines = outputText.split(/(?:\r\n|\r|\n)/);
                var lineWidths = new Array(lines.length);
                var maxLineWidth = 0;
                // account for textPath
                if (textPath) {
                    textPath.getTotalLength();
                    // const startingPoint = textPath.getPoint(0);
                    for(var i = 0; i < lines.length; i++)context.measureText(lines[i]).width, lines[i].length;
                } else {
                    for(var _i = 0; _i < lines.length; _i++){
                        // char width + letterSpacing
                        var _lineWidth = context.measureText(lines[_i]).width + (lines[_i].length - 1) * letterSpacing;
                        lineWidths[_i] = _lineWidth;
                        maxLineWidth = Math.max(maxLineWidth, _lineWidth);
                    }
                    var _width = maxLineWidth + lineWidth;
                    // if (dropShadow) {
                    //   width += dropShadowDistance;
                    // }
                    var lineHeight = strokeHeight || fontProperties.fontSize + lineWidth;
                    var height = Math.max(lineHeight, fontProperties.fontSize + lineWidth) + (lines.length - 1) * (lineHeight + leading);
                    // if (dropShadow) {
                    //   height += dropShadowDistance;
                    // }
                    lineHeight += leading;
                    // handle vertical text baseline
                    var offsetY = 0;
                    if (textBaseline === 'middle') offsetY = -height / 2;
                    else if (textBaseline === 'bottom' || textBaseline === 'alphabetic' || textBaseline === 'ideographic') offsetY = -height;
                    else if (textBaseline === 'top' || textBaseline === 'hanging') offsetY = 0;
                    return {
                        font: font,
                        width: _width,
                        height: height,
                        lines: lines,
                        lineWidths: lineWidths,
                        lineHeight: lineHeight,
                        maxLineWidth: maxLineWidth,
                        fontProperties: fontProperties,
                        lineMetrics: lineWidths.map(function(width, i) {
                            var offsetX = 0;
                            // handle horizontal text align
                            if (textAlign === 'center' || textAlign === 'middle') offsetX -= width / 2;
                            else if (textAlign === 'right' || textAlign === 'end') offsetX -= width;
                            return new Rectangle(offsetX - lineWidth / 2, offsetY + i * lineHeight, width + lineWidth, lineHeight);
                        })
                    };
                }
            }
        },
        {
            key: "wordWrap",
            value: function wordWrap(text, parsedStyle, offscreenCanvas) {
                var _this2 = this;
                var chars = Array.from(text);
                if (chars.length === 0) return '';
                var self1 = this;
                var _parsedStyle$wordWrap2 = parsedStyle.wordWrapWidth, wordWrapWidth = _parsedStyle$wordWrap2 === void 0 ? 0 : _parsedStyle$wordWrap2, _parsedStyle$letterSp2 = parsedStyle.letterSpacing, letterSpacing = _parsedStyle$letterSp2 === void 0 ? 0 : _parsedStyle$letterSp2, _parsedStyle$maxLines = parsedStyle.maxLines, maxLines = _parsedStyle$maxLines === void 0 ? Infinity : _parsedStyle$maxLines, textOverflow = parsedStyle.textOverflow;
                var context = this.runtime.offscreenCanvasCreator.getOrCreateContext(offscreenCanvas);
                var maxWidth = wordWrapWidth + letterSpacing;
                var ellipsis = '';
                if (textOverflow === 'ellipsis') ellipsis = '...';
                else if (textOverflow && textOverflow !== 'clip') ellipsis = textOverflow;
                var lines = [
                    ''
                ];
                var currentLineIndex = 0;
                var currentLineWidth = 0;
                // @see https://github.com/antvis/G/issues/1932
                var prevLineLastCharIndex = -1;
                // --- 优化核心 ---
                // 1. 获取或创建当前字体对应的字符缓存
                var font = toFontString(parsedStyle);
                var charCache = this.charWidthCache.get(font);
                if (!charCache) {
                    charCache = new LRU(500);
                    this.charWidthCache.put(font, charCache);
                }
                // 2. calcWidth 现在直接使用持久化的 charCache
                var calcWidth = function calcWidth(_char2) {
                    return _this2.getFromCache(_char2, letterSpacing, charCache, context);
                };
                var ellipsisWidth = calcWidth(ellipsis);
                /**
       * Find text fragments that will take up as much of the given line width as possible when rendered.
       *
       * @see https://github.com/antvis/G/issues/1833
       *
       * @param lineTxt - Current line of text
       * @param txtLastCharIndex - The index of the last character of the current line in the entire text
       * @param txtStartCharIndex - The index of the start character of the current line in the entire text
       */ function findCharIndexClosestWidthThreshold(lineTxt, txtLastCharIndex, txtStartCharIndex, widthThreshold) {
                    while(calcWidth(lineTxt) < widthThreshold && txtLastCharIndex < chars.length - 1){
                        if (self1.isNewline(chars[txtLastCharIndex + 1])) break;
                        txtLastCharIndex += 1;
                        lineTxt += chars[txtLastCharIndex];
                    }
                    while(calcWidth(lineTxt) > widthThreshold && // @see https://github.com/antvis/G/issues/1932
                    txtLastCharIndex >= txtStartCharIndex){
                        txtLastCharIndex -= 1;
                        lineTxt = lineTxt.slice(0, -1);
                    }
                    return {
                        lineTxt: lineTxt,
                        txtLastCharIndex: txtLastCharIndex
                    };
                }
                function appendEllipsis(lineIndex, textCharIndex) {
                    // If there is not enough space to display the string itself, it is clipped.
                    // @see https://developer.mozilla.org/en-US/docs/Web/CSS/text-overflow#values
                    if (ellipsisWidth <= 0 || ellipsisWidth > maxWidth) return;
                    if (!lines[lineIndex]) {
                        lines[lineIndex] = ellipsis;
                        return;
                    }
                    var result = findCharIndexClosestWidthThreshold(lines[lineIndex], textCharIndex, prevLineLastCharIndex + 1, maxWidth - ellipsisWidth);
                    lines[lineIndex] = result.lineTxt + ellipsis;
                }
                for(var i = 0; i < chars.length; i++){
                    var _char3 = chars[i];
                    var prevChar = chars[i - 1];
                    var nextChar = chars[i + 1];
                    var charWidth = calcWidth(_char3);
                    if (this.isNewline(_char3)) {
                        // exceed maxLines, break immediately
                        if (currentLineIndex + 1 >= maxLines) {
                            if (i < chars.length - 1) appendEllipsis(currentLineIndex, i - 1);
                            parsedStyle.isOverflowing = true;
                            break;
                        }
                        prevLineLastCharIndex = i - 1;
                        currentLineIndex += 1;
                        currentLineWidth = 0;
                        lines[currentLineIndex] = '';
                        continue;
                    }
                    // If char width exceeds max width, no need to continue
                    if (charWidth > maxWidth) {
                        appendEllipsis(currentLineIndex, i - 1);
                        parsedStyle.isOverflowing = true;
                        break;
                    }
                    if (currentLineWidth > 0 && currentLineWidth + charWidth > maxWidth) {
                        var result = findCharIndexClosestWidthThreshold(lines[currentLineIndex], i - 1, prevLineLastCharIndex + 1, maxWidth);
                        if (result.txtLastCharIndex !== i - 1) {
                            lines[currentLineIndex] = result.lineTxt;
                            if (result.txtLastCharIndex === chars.length - 1) break;
                            i = result.txtLastCharIndex + 1;
                            _char3 = chars[i];
                            prevChar = chars[i - 1];
                            nextChar = chars[i + 1];
                            charWidth = calcWidth(_char3);
                        }
                        if (currentLineIndex + 1 >= maxLines) {
                            appendEllipsis(currentLineIndex, i - 1);
                            parsedStyle.isOverflowing = true;
                            break;
                        }
                        prevLineLastCharIndex = i - 1;
                        currentLineIndex += 1;
                        currentLineWidth = 0;
                        lines[currentLineIndex] = '';
                        if (this.isBreakingSpace(_char3)) continue;
                        if (!this.canBreakInLastChar(_char3)) {
                            lines = this.trimToBreakable(lines);
                            currentLineWidth = this.sumTextWidthByCache(lines[currentLineIndex] || '', calcWidth);
                        }
                        if (this.shouldBreakByKinsokuShorui(_char3, nextChar)) {
                            lines = this.trimByKinsokuShorui(lines);
                            currentLineWidth += calcWidth(prevChar || '');
                        }
                    }
                    currentLineWidth += charWidth;
                    lines[currentLineIndex] += _char3;
                }
                return lines.join('\n');
            }
        },
        {
            key: "isBreakingSpace",
            value: function isBreakingSpace(_char4) {
                if (typeof _char4 !== 'string') return false;
                return TEXT_METRICS.BreakingSpaces.indexOf(_char4.charCodeAt(0)) >= 0;
            }
        },
        {
            key: "isNewline",
            value: function isNewline(_char5) {
                if (typeof _char5 !== 'string') return false;
                return TEXT_METRICS.Newlines.indexOf(_char5.charCodeAt(0)) >= 0;
            }
        },
        {
            key: "trimToBreakable",
            value: function trimToBreakable(prev) {
                var next = (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(prev);
                var prevLine = next[next.length - 2];
                var index = this.findBreakableIndex(prevLine);
                if (index === -1 || !prevLine) return next;
                var trimmedChar = prevLine.slice(index, index + 1);
                var isTrimmedWithSpace = this.isBreakingSpace(trimmedChar);
                var trimFrom = index + 1;
                var trimTo = index + (isTrimmedWithSpace ? 0 : 1);
                next[next.length - 1] += prevLine.slice(trimFrom, prevLine.length);
                next[next.length - 2] = prevLine.slice(0, trimTo);
                return next;
            }
        },
        {
            key: "canBreakInLastChar",
            value: function canBreakInLastChar(_char6) {
                if (_char6 && LATIN_REGEX.test(_char6)) return false;
                return true;
            }
        },
        {
            key: "sumTextWidthByCache",
            value: function sumTextWidthByCache(text, calcWidthWithCache) {
                return text.split('').reduce(function(sum, c) {
                    return sum + calcWidthWithCache(c);
                }, 0);
            }
        },
        {
            key: "findBreakableIndex",
            value: function findBreakableIndex(line) {
                for(var i = line.length - 1; i >= 0; i--){
                    if (!LATIN_REGEX.test(line[i])) return i;
                }
                return -1;
            }
        },
        {
            key: "getFromCache",
            value: function getFromCache(key, letterSpacing, cache, context) {
                var width = cache.get(key);
                if (typeof width !== 'number') {
                    var spacing = key.length * letterSpacing;
                    var metrics = context.measureText(key);
                    width = metrics.width + spacing;
                    cache.put(key, width);
                }
                return width;
            }
        },
        {
            key: "clearCache",
            value: function clearCache() {
                this.fontMetricsCache = {};
                this.charWidthCache.clear();
            }
        }
    ]);
}();
var runtime = {};
/**
 * Replace with IoC container
 */ var geometryUpdaterFactory = function(_ref) {
    var rectUpdater = new RectUpdater();
    var polylineUpdater = new PolylineUpdater();
    return _ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref, Shape.FRAGMENT, null), Shape.CIRCLE, new CircleUpdater()), Shape.ELLIPSE, new EllipseUpdater()), Shape.RECT, rectUpdater), Shape.IMAGE, rectUpdater), Shape.GROUP, new GroupUpdater()), Shape.LINE, new LineUpdater()), Shape.TEXT, new TextUpdater(runtime)), Shape.POLYLINE, polylineUpdater), Shape.POLYGON, polylineUpdater), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref, Shape.PATH, new PathUpdater()), Shape.HTML, new HTMLUpdater()), Shape.MESH, null);
}();
var CSSPropertySyntaxFactory = function(_ref2) {
    var color = new CSSPropertyColor();
    var length = new CSSPropertyLengthOrPercentage();
    return _ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref2, PropertySyntax.PERCENTAGE, null), PropertySyntax.NUMBER, new CSSPropertyNumber()), PropertySyntax.ANGLE, new CSSPropertyAngle()), PropertySyntax.DEFINED_PATH, new CSSPropertyClipPath()), PropertySyntax.PAINT, color), PropertySyntax.COLOR, color), PropertySyntax.FILTER, new CSSPropertyFilter()), PropertySyntax.LENGTH, length), PropertySyntax.LENGTH_PERCENTAGE, length), PropertySyntax.LENGTH_PERCENTAGE_12, new CSSPropertyLengthOrPercentage12()), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref2, PropertySyntax.LENGTH_PERCENTAGE_14, new CSSPropertyLengthOrPercentage14()), PropertySyntax.COORDINATE, new CSSPropertyLengthOrPercentage()), PropertySyntax.OFFSET_DISTANCE, new CSSPropertyOffsetDistance()), PropertySyntax.OPACITY_VALUE, new CSSPropertyOpacity()), PropertySyntax.PATH, new CSSPropertyPath()), PropertySyntax.LIST_OF_POINTS, new CSSPropertyPoints()), PropertySyntax.SHADOW_BLUR, new CSSPropertyShadowBlur()), PropertySyntax.TEXT, new CSSPropertyText()), PropertySyntax.TEXT_TRANSFORM, new CSSPropertyTextTransform()), PropertySyntax.TRANSFORM, new CSSPropertyTransform()), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_ref2, PropertySyntax.TRANSFORM_ORIGIN, new CSSPropertyTransformOrigin()), PropertySyntax.Z_INDEX, new CSSPropertyZIndex()), PropertySyntax.MARKER, new CSSPropertyMarker());
}();
var getGlobalThis = function getGlobalThis() {
    if (typeof globalThis !== 'undefined') return globalThis;
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    // @ts-ignore
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return {};
// [!] Error: The 'this' keyword is equivalent to 'undefined' at the top level of an ES module, and has been rewritten
// @see https://rollupjs.org/troubleshooting/#error-this-is-undefined
// if (typeof this !== 'undefined') return this;
};
/**
 * Camera
 * `camera-api` will provide an advanced implementation
 */ runtime.CameraContribution = Camera;
/**
 * `web-animations-api` will provide an AnimationTimeline
 */ runtime.AnimationTimeline = null;
runtime.EasingFunction = null;
runtime.offscreenCanvasCreator = new OffscreenCanvasCreator();
runtime.sceneGraphSelector = new DefaultSceneGraphSelector();
runtime.sceneGraphService = new DefaultSceneGraphService(runtime);
runtime.textService = new TextService(runtime);
runtime.geometryUpdaterFactory = geometryUpdaterFactory;
runtime.CSSPropertySyntaxFactory = CSSPropertySyntaxFactory;
runtime.styleValueRegistry = new DefaultStyleValueRegistry(runtime);
runtime.layoutRegistry = null;
runtime.globalThis = getGlobalThis();
runtime.enableStyleSyntax = true;
runtime.enableSizeAttenuation = false;
var entityCounter = 0;
function resetEntityCounter() {
    entityCounter = 0;
}
var insertedEvent = new MutationEvent(ElementEvent.INSERTED, null, '', '', '', 0, '', '');
var removedEvent = new MutationEvent(ElementEvent.REMOVED, null, '', '', '', 0, '', '');
var destroyEvent = new CustomEvent(ElementEvent.DESTROY);
/**
 * Has following capabilities:
 * * Node insert/remove, eg. appendChild, removeChild, remove...
 * * Query eg. querySelector getElementById...
 * * Animation
 */ var Element = /*#__PURE__*/ function(_Node) {
    function Element() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Element);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Element, [].concat(args));
        /**
     * Unique id.
     */ _this.entity = entityCounter++;
        _this.transformable = {
            dirtyFlag: false,
            localDirtyFlag: false,
            localPosition: [
                0,
                0,
                0
            ],
            localRotation: [
                0,
                0,
                0,
                1
            ],
            localScale: [
                1,
                1,
                1
            ],
            localTransform: [
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ],
            localSkew: [
                0,
                0
            ],
            position: [
                0,
                0,
                0
            ],
            rotation: [
                0,
                0,
                0,
                1
            ],
            scaling: [
                1,
                1,
                1
            ],
            worldTransform: [
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                1
            ],
            origin: [
                0,
                0,
                0
            ]
        };
        _this.renderable = {
            bounds: undefined,
            boundsDirty: true,
            renderBounds: undefined,
            renderBoundsDirty: true,
            dirtyRenderBounds: undefined,
            dirty: false
        };
        _this.geometry = {
            contentBounds: undefined,
            renderBounds: undefined,
            dirty: true
        };
        _this.cullable = {
            strategy: Strategy.Standard,
            visibilityPlaneMask: -1,
            visible: true,
            enable: true
        };
        _this.sortable = {
            dirty: false,
            sorted: undefined,
            renderOrder: 0,
            dirtyChildren: [],
            dirtyReason: undefined
        };
        /**
     * https://developer.mozilla.org/zh-CN/docs/Web/API/Element/namespaceURI
     */ _this.namespaceURI = 'g';
        _this.scrollLeft = 0;
        _this.scrollTop = 0;
        /**
     * We don't support border now
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/clientTop
     */ _this.clientTop = 0;
        _this.clientLeft = 0;
        /**
     * compatible with `style`
     * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/style
     */ _this.style = {};
        _this.computedStyle = {};
        /**
     * Renderers will use these used values.
     */ _this.parsedStyle = {
        };
        /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/attributes
     */ _this.attributes = {};
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Element, _Node);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Element, [
        {
            key: "dirty",
            value: /**
     * Marks the element as dirty, indicating it needs re-rendering or relayout.
     *
     * @param styleFlag - Whether to update style state (default: true).
     *                   When true, sets `renderable.dirty` to true.
     * @param layoutFlag - Optional. When provided, updates layout-related dirty flags:
     *                    - `renderable.boundsDirty`
     *                    - `renderable.renderBoundsDirty`
     *                    - `geometry.dirty`
     */ function dirty() {
                var styleFlag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var layoutFlag = arguments.length > 1 ? arguments[1] : undefined;
                this.renderable.dirty = styleFlag;
                if (layoutFlag !== undefined) {
                    this.renderable.boundsDirty = layoutFlag;
                    this.renderable.renderBoundsDirty = layoutFlag;
                    this.geometry.dirty = layoutFlag;
                }
            }
        },
        {
            key: "className",
            get: /**
     * used with `getElementById()`
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/id
     */ /**
     * used in `getElementsByClassName`
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
     */ function get() {
                // @ts-ignore
                return this.getAttribute('class') || '';
            },
            set: function set(className) {
                this.setAttribute('class', className);
            }
        },
        {
            key: "classList",
            get: /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/classList
     */ function get() {
                return this.className.split(' ').filter(function(c) {
                    return c !== '';
                });
            }
        },
        {
            key: "tagName",
            get: function get() {
                return this.nodeName;
            }
        },
        {
            key: "children",
            get: function get() {
                return this.childNodes;
            }
        },
        {
            key: "childElementCount",
            get: function get() {
                return this.childNodes.length;
            }
        },
        {
            key: "firstElementChild",
            get: function get() {
                return this.firstChild;
            }
        },
        {
            key: "lastElementChild",
            get: function get() {
                return this.lastChild;
            }
        },
        {
            key: "parentElement",
            get: function get() {
                return this.parentNode;
            }
        },
        {
            key: "nextSibling",
            get: function get() {
                if (this.parentNode) {
                    var index = this.parentNode.childNodes.indexOf(this);
                    return this.parentNode.childNodes[index + 1] || null;
                }
                return null;
            }
        },
        {
            key: "previousSibling",
            get: function get() {
                if (this.parentNode) {
                    var index = this.parentNode.childNodes.indexOf(this);
                    return this.parentNode.childNodes[index - 1] || null;
                }
                return null;
            }
        },
        {
            key: "cloneNode",
            value: function cloneNode(deep) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "appendChild",
            value: function appendChild(child, index) {
                var _this$ownerDocument;
                if (child.destroyed) throw new Error(ERROR_MSG_APPEND_DESTROYED_ELEMENT);
                runtime.sceneGraphService.attach(child, this, index);
                if ((_this$ownerDocument = this.ownerDocument) !== null && _this$ownerDocument !== void 0 && _this$ownerDocument.defaultView) {
                    if (!isInFragment(this) && child.nodeName === Shape.FRAGMENT) this.ownerDocument.defaultView.mountFragment(child);
                    else this.ownerDocument.defaultView.mountChildren(child);
                }
                // @ts-ignore
                if (this.isMutationObserved) {
                    insertedEvent.relatedNode = this;
                    child.dispatchEvent(insertedEvent);
                }
                return child;
            }
        },
        {
            key: "insertBefore",
            value: function insertBefore(newChild, refChild) {
                if (!refChild) this.appendChild(newChild);
                else {
                    if (newChild.parentElement) newChild.parentElement.removeChild(newChild);
                    var index = this.childNodes.indexOf(refChild);
                    if (index === -1) this.appendChild(newChild);
                    else this.appendChild(newChild, index);
                }
                return newChild;
            }
        },
        {
            key: "replaceChild",
            value: function replaceChild(newChild, oldChild) {
                var index = this.childNodes.indexOf(oldChild);
                this.removeChild(oldChild);
                this.appendChild(newChild, index);
                return oldChild;
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child) {
                var _this$ownerDocument2, _child$ownerDocument;
                var enableCancelEventPropagation = ((_this$ownerDocument2 = this.ownerDocument) === null || _this$ownerDocument2 === void 0 || (_this$ownerDocument2 = _this$ownerDocument2.defaultView) === null || _this$ownerDocument2 === void 0 || (_this$ownerDocument2 = _this$ownerDocument2.getConfig().future) === null || _this$ownerDocument2 === void 0 ? void 0 : _this$ownerDocument2.experimentalCancelEventPropagation) === true;
                // should emit on itself before detach
                removedEvent.relatedNode = this;
                child.dispatchEvent(removedEvent, enableCancelEventPropagation, enableCancelEventPropagation);
                if ((_child$ownerDocument = child.ownerDocument) !== null && _child$ownerDocument !== void 0 && _child$ownerDocument.defaultView) child.ownerDocument.defaultView.unmountChildren(child);
                // remove from scene graph
                runtime.sceneGraphService.detach(child);
                return child;
            }
        },
        {
            key: "removeChildren",
            value: function removeChildren() {
                for(var i = this.childNodes.length - 1; i >= 0; i--){
                    var child = this.childNodes[i];
                    this.removeChild(child);
                }
            }
        },
        {
            key: "destroyChildren",
            value: function destroyChildren() {
                for(var i = this.childNodes.length - 1; i >= 0; i--){
                    var child = this.childNodes[i];
                    if (child.childNodes.length > 0) child.destroyChildren();
                    child.destroy();
                }
            }
        },
        {
            key: "matches",
            value: function matches(selector) {
                return runtime.sceneGraphService.matches(selector, this);
            }
        },
        {
            key: "getElementById",
            value: function getElementById(id) {
                return runtime.sceneGraphService.querySelector("#".concat(id), this);
            }
        },
        {
            key: "getElementsByName",
            value: function getElementsByName(name) {
                return runtime.sceneGraphService.querySelectorAll("[name=\"".concat(name, "\"]"), this);
            }
        },
        {
            key: "getElementsByClassName",
            value: function getElementsByClassName(className) {
                return runtime.sceneGraphService.querySelectorAll(".".concat(className), this);
            }
        },
        {
            key: "getElementsByTagName",
            value: function getElementsByTagName(tagName) {
                return runtime.sceneGraphService.querySelectorAll(tagName, this);
            }
        },
        {
            key: "querySelector",
            value: function querySelector(selectors) {
                return runtime.sceneGraphService.querySelector(selectors, this);
            }
        },
        {
            key: "querySelectorAll",
            value: function querySelectorAll(selectors) {
                return runtime.sceneGraphService.querySelectorAll(selectors, this);
            }
        },
        {
            key: "closest",
            value: function closest(selectors) {
                var el = this;
                do {
                    if (runtime.sceneGraphService.matches(selectors, el)) return el;
                    el = el.parentElement;
                }while (el !== null);
                return null;
            }
        },
        {
            key: "find",
            value: function find(filter) {
                var _this2 = this;
                var target = null;
                this.forEach(function(object) {
                    if (object !== _this2 && filter(object)) {
                        target = object;
                        return false;
                    }
                    return true;
                });
                return target;
            }
        },
        {
            key: "findAll",
            value: function findAll(filter) {
                var _this3 = this;
                var objects = [];
                this.forEach(function(object) {
                    if (object !== _this3 && filter(object)) objects.push(object);
                });
                return objects;
            }
        },
        {
            key: "after",
            value: function after() {
                var _this4 = this;
                if (this.parentNode) {
                    var index = this.parentNode.childNodes.indexOf(this);
                    for(var _len2 = arguments.length, nodes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)nodes[_key2] = arguments[_key2];
                    nodes.forEach(function(node, i) {
                        var _this4$parentNode;
                        return (_this4$parentNode = _this4.parentNode) === null || _this4$parentNode === void 0 ? void 0 : _this4$parentNode.appendChild(node, index + i + 1);
                    });
                }
            }
        },
        {
            key: "before",
            value: function before() {
                if (this.parentNode) {
                    var _ref;
                    var index = this.parentNode.childNodes.indexOf(this);
                    for(var _len3 = arguments.length, nodes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)nodes[_key3] = arguments[_key3];
                    var first = nodes[0], rest = (0, (/*@__PURE__*/$parcel$interopDefault($2zZPz)))(nodes).slice(1);
                    this.parentNode.appendChild(first, index);
                    (_ref = first).after.apply(_ref, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(rest));
                }
            }
        },
        {
            key: "replaceWith",
            value: function replaceWith() {
                this.after.apply(this, arguments);
                this.remove();
            }
        },
        {
            key: "append",
            value: function append() {
                var _this5 = this;
                for(var _len4 = arguments.length, nodes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)nodes[_key4] = arguments[_key4];
                nodes.forEach(function(node) {
                    return _this5.appendChild(node);
                });
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                var _this6 = this;
                for(var _len5 = arguments.length, nodes = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)nodes[_key5] = arguments[_key5];
                nodes.forEach(function(node, i) {
                    return _this6.appendChild(node, i);
                });
            }
        },
        {
            key: "replaceChildren",
            value: function replaceChildren() {
                while(this.childNodes.length && this.firstChild)this.removeChild(this.firstChild);
                this.append.apply(this, arguments);
            }
        },
        {
            key: "remove",
            value: function remove() {
                if (this.parentNode) return this.parentNode.removeChild(this);
                return this;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this$ownerDocument3;
                var enableCancelEventPropagation = ((_this$ownerDocument3 = this.ownerDocument) === null || _this$ownerDocument3 === void 0 || (_this$ownerDocument3 = _this$ownerDocument3.defaultView) === null || _this$ownerDocument3 === void 0 || (_this$ownerDocument3 = _this$ownerDocument3.getConfig().future) === null || _this$ownerDocument3 === void 0 ? void 0 : _this$ownerDocument3.experimentalCancelEventPropagation) === true;
                // fix https://github.com/antvis/G/issues/1813
                this.destroyChildren();
                // destroy itself before remove
                this.dispatchEvent(destroyEvent, enableCancelEventPropagation, enableCancelEventPropagation);
                // remove from scenegraph first
                this.remove();
                // remove event listeners
                this.emitter.removeAllListeners();
                this.destroyed = true;
            }
        },
        {
            key: "getGeometryBounds",
            value: function getGeometryBounds() {
                var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                return runtime.sceneGraphService.getGeometryBounds(this, render);
            }
        },
        {
            key: "getTransformedGeometryBounds",
            value: function getTransformedGeometryBounds() {
                var render = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                return runtime.sceneGraphService.getTransformedGeometryBounds(this, render);
            }
        },
        {
            key: "getBounds",
            value: function getBounds() {
                return runtime.sceneGraphService.getBounds(this);
            }
        },
        {
            key: "getRenderBounds",
            value: function getRenderBounds() {
                return runtime.sceneGraphService.getBounds(this, true);
            }
        },
        {
            key: "getLocalBounds",
            value: function getLocalBounds() {
                return runtime.sceneGraphService.getLocalBounds(this);
            }
        },
        {
            key: "getBoundingClientRect",
            value: function getBoundingClientRect() {
                return runtime.sceneGraphService.getBoundingClientRect(this);
            }
        },
        {
            key: "getClientRects",
            value: function getClientRects() {
                return [
                    this.getBoundingClientRect()
                ];
            }
        },
        {
            key: "computedStyleMap",
            value: /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/computedStyleMap
     * eg. circle.computedStyleMap().get('fill');
     */ function computedStyleMap() {
                return new Map(Object.entries(this.computedStyle));
            }
        },
        {
            key: "getAttributeNames",
            value: /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttributeNames
     */ function getAttributeNames() {
                return Object.keys(this.attributes);
            }
        },
        {
            key: "getAttribute",
            value: function getAttribute(name) {
                // @see https://github.com/antvis/G/issues/1267
                if (typeof name === 'symbol') return undefined;
                var value = this.attributes[name];
                if (value === undefined) // if the given attribute does not exist, the value returned will either be null or ""
                return value;
                return value;
            }
        },
        {
            key: "hasAttribute",
            value: function hasAttribute(qualifiedName) {
                return this.getAttributeNames().includes(qualifiedName);
            }
        },
        {
            key: "hasAttributes",
            value: function hasAttributes() {
                return !!this.getAttributeNames().length;
            }
        },
        {
            key: "removeAttribute",
            value: function removeAttribute(attributeName) {
                this.setAttribute(attributeName, null);
                delete this.attributes[attributeName];
            }
        },
        {
            key: "setAttribute",
            value: function setAttribute(attributeName, value) {
                this.attributes[attributeName] = value;
            }
        },
        {
            key: "getAttributeNS",
            value: function getAttributeNS(namespace, localName) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "getAttributeNode",
            value: function getAttributeNode(qualifiedName) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "getAttributeNodeNS",
            value: function getAttributeNodeNS(namespace, localName) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "hasAttributeNS",
            value: function hasAttributeNS(namespace, localName) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "removeAttributeNS",
            value: function removeAttributeNS(namespace, localName) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "removeAttributeNode",
            value: function removeAttributeNode(attr) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "setAttributeNS",
            value: function setAttributeNS(namespace, qualifiedName, value) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "setAttributeNode",
            value: function setAttributeNode(attr) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "setAttributeNodeNS",
            value: function setAttributeNodeNS(attr) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "toggleAttribute",
            value: function toggleAttribute(qualifiedName, force) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        }
    ]);
}(Node);
function isDisplayObject(value) {
    return !!(value !== null && value !== void 0 && value.nodeName);
}
var Proxy = runtime.globalThis.Proxy ? runtime.globalThis.Proxy : function() {};
var attrModifiedEvent = new MutationEvent(ElementEvent.ATTR_MODIFIED, null, null, null, null, MutationEvent.MODIFICATION, null, null);
var $vec3 = (0, $eIStk).create();
var $quat = (0, $k1dpP).create();
/**
 * prototype chains: DisplayObject -> Element -> Node -> EventTarget
 *
 * mixins: Animatable, Transformable, Visible
 * @see https://github.com/tannerntannern/ts-mixer/blob/master/README.md#mixing-generic-classes
 *
 * Provide abilities in scene graph, such as:
 * * transform `translate/rotate/scale`
 * * add/remove child
 * * visibility and z-index
 *
 * Those abilities are implemented with those components: `Transform/Sortable/Visible`.
 *
 * Emit following events:
 * * init
 * * destroy
 * * attributeChanged
 */ var DisplayObject = /*#__PURE__*/ function(_Element) {
    function DisplayObject(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DisplayObject);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, DisplayObject);
        // assign name, id to config
        // eg. group.get('name')
        _this.isCustomElement = false;
        _this.isMutationObserved = false;
        /**
     * push to active animations after calling `animate()`
     */ _this.activeAnimations = [];
        _this.config = config;
        // init scene graph node
        _this.id = config.id || '';
        _this.name = config.name || '';
        if (config.className || config["class"]) _this.className = config.className || config["class"];
        _this.nodeName = config.type || Shape.GROUP;
        if (config.initialParsedStyle) Object.assign(_this.parsedStyle, config.initialParsedStyle);
        // start to process attributes
        _this.initAttributes(config.style);
        if (runtime.enableStyleSyntax) _this.style = new Proxy(// @ts-ignore
        {
            // ...this.attributes,
            setProperty: function setProperty(propertyName, value) {
                _this.setAttribute(propertyName, value);
            },
            getPropertyValue: function getPropertyValue(propertyName) {
                return _this.getAttribute(propertyName);
            },
            removeProperty: function removeProperty(propertyName) {
                _this.removeAttribute(propertyName);
            },
            item: function item() {
                return '';
            }
        }, {
            get: function get(target, name) {
                if (target[name] !== undefined) // if (name in target) {
                return target[name];
                return _this.getAttribute(name);
            },
            set: function set(_, prop, value) {
                _this.setAttribute(prop, value);
                return true;
            }
        });
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(DisplayObject, _Element);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DisplayObject, [
        {
            key: "destroy",
            value: function destroy() {
                (0, (/*@__PURE__*/$parcel$interopDefault($dPop6)))(DisplayObject, "destroy", this, 3)([]);
                // stop all active animations
                this.getAnimations().forEach(function(animation) {
                    animation.cancel();
                });
            }
        },
        {
            key: "cloneNode",
            value: function cloneNode(deep, customCloneFunc) {
                var clonedStyle = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, this.attributes);
                for(var attributeName in clonedStyle){
                    var attribute = clonedStyle[attributeName];
                    // @see https://github.com/antvis/G/issues/1095
                    if (isDisplayObject(attribute) && // share the same clipPath if possible
                    attributeName !== 'clipPath' && attributeName !== 'offsetPath' && attributeName !== 'textPath') clonedStyle[attributeName] = attribute.cloneNode(deep);
                    // TODO: clone other type
                    if (customCloneFunc) clonedStyle[attributeName] = customCloneFunc(attributeName, attribute);
                }
                var cloned = new this.constructor((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, this.config), {}, {
                    style: clonedStyle
                }));
                // apply transform
                cloned.setLocalTransform(this.getLocalTransform());
                if (deep) this.children.forEach(function(child) {
                    // skip marker
                    if (!child.style.isMarker) {
                        var clonedChild = child.cloneNode(deep);
                        cloned.appendChild(clonedChild);
                    }
                });
                return cloned;
            }
        },
        {
            key: "initAttributes",
            value: function initAttributes() {
                var attributes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var options = {
                    forceUpdateGeometry: true
                };
                runtime.styleValueRegistry.processProperties(this, attributes, options);
                // redraw at next frame
                this.dirty();
            }
        },
        {
            key: "setAttribute",
            value: function setAttribute(name, value) {
                var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var memoize = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
                // ignore undefined value
                if ((0, $aFcWQ.default)(value)) return;
                if (force || value !== this.attributes[name]) {
                    this.internalSetAttribute(name, value, {
                        memoize: memoize
                    });
                    (0, (/*@__PURE__*/$parcel$interopDefault($dPop6)))(DisplayObject, "setAttribute", this, 3)([
                        name,
                        value
                    ]);
                }
            }
        },
        {
            key: "setAttributes",
            value: function setAttributes(attributes) {
                var parseOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _parseOptions$skipDis = parseOptions.skipDispatchAttrModifiedEvent, skipDispatchAttrModifiedEvent = _parseOptions$skipDis === void 0 ? false : _parseOptions$skipDis;
                var oldAttributes;
                var oldParsedValues;
                if (!skipDispatchAttrModifiedEvent) {
                    oldAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, this.attributes);
                    oldParsedValues = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, this.parsedStyle);
                }
                runtime.styleValueRegistry.processProperties(this, attributes, parseOptions);
                // redraw at next frame
                this.dirty();
                if (!skipDispatchAttrModifiedEvent) for(var key in attributes)this.dispatchAttrModifiedEvent(key, oldAttributes[key], attributes[key], oldParsedValues[key]);
            }
        },
        {
            key: "internalSetAttribute",
            value: function internalSetAttribute(name, value) {
                var parseOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var oldValue = this.attributes[name];
                var oldParsedValue = this.parsedStyle[name];
                runtime.styleValueRegistry.processProperties(this, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))({}, name, value), parseOptions);
                // redraw at next frame
                this.dirty();
                // return;
                this.dispatchAttrModifiedEvent(name, oldValue, value, oldParsedValue);
            }
        },
        {
            key: "dispatchAttrModifiedEvent",
            value: function dispatchAttrModifiedEvent(name, oldValue, value, oldParsedValue) {
                var newParsedValue = this.parsedStyle[name];
                if (this.isConnected) {
                    attrModifiedEvent.relatedNode = this;
                    attrModifiedEvent.prevValue = oldValue;
                    attrModifiedEvent.newValue = value;
                    attrModifiedEvent.attrName = name;
                    attrModifiedEvent.prevParsedValue = oldParsedValue;
                    attrModifiedEvent.newParsedValue = newParsedValue;
                    if (this.isMutationObserved) this.dispatchEvent(attrModifiedEvent);
                    else {
                        var _this$ownerDocument$d;
                        var enableCancelEventPropagation = ((_this$ownerDocument$d = this.ownerDocument.defaultView.getConfig().future) === null || _this$ownerDocument$d === void 0 ? void 0 : _this$ownerDocument$d.experimentalCancelEventPropagation) === true;
                        attrModifiedEvent.target = this;
                        this.ownerDocument.defaultView.dispatchEvent(attrModifiedEvent, true, enableCancelEventPropagation);
                    }
                }
                if (this.isCustomElement && this.isConnected || !this.isCustomElement) {
                    var _attributeChangedCall, _ref;
                    (_attributeChangedCall = (_ref = this).attributeChangedCallback) === null || _attributeChangedCall === void 0 || _attributeChangedCall.call(_ref, name, oldValue, value, oldParsedValue, newParsedValue);
                }
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                var aabb = this.getBounds();
                var _aabb$getMin = aabb.getMin(), _aabb$getMin2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_aabb$getMin, 2), left = _aabb$getMin2[0], top = _aabb$getMin2[1];
                var _aabb$getMax = aabb.getMax(), _aabb$getMax2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_aabb$getMax, 2), right = _aabb$getMax2[0], bottom = _aabb$getMax2[1];
                return new Rectangle(left, top, right - left, bottom - top);
            }
        },
        {
            key: "setOrigin",
            value: function setOrigin(position) {
                var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                runtime.sceneGraphService.setOrigin(this, createVec3(position, y, z, false));
                return this;
            }
        },
        {
            key: "getOrigin",
            value: function getOrigin() {
                return runtime.sceneGraphService.getOrigin(this);
            }
        },
        {
            key: "setPosition",
            value: function setPosition(position) {
                var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                runtime.sceneGraphService.setPosition(this, createVec3(position, y, z, false));
                return this;
            }
        },
        {
            key: "setLocalPosition",
            value: function setLocalPosition(position) {
                var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                runtime.sceneGraphService.setLocalPosition(this, createVec3(position, y, z, false));
                return this;
            }
        },
        {
            key: "translate",
            value: function translate(position) {
                var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                runtime.sceneGraphService.translate(this, createVec3(position, y, z, false));
                return this;
            }
        },
        {
            key: "translateLocal",
            value: function translateLocal(position) {
                var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                runtime.sceneGraphService.translateLocal(this, createVec3(position, y, z, false));
                return this;
            }
        },
        {
            key: "getPosition",
            value: function getPosition() {
                return runtime.sceneGraphService.getPosition(this);
            }
        },
        {
            key: "getLocalPosition",
            value: function getLocalPosition() {
                return runtime.sceneGraphService.getLocalPosition(this);
            }
        },
        {
            key: "scale",
            value: function scale(scaling, y, z) {
                return this.scaleLocal(scaling, y, z);
            }
        },
        {
            key: "scaleLocal",
            value: function scaleLocal(scaling, y, z) {
                if (typeof scaling === 'number') {
                    y = y || scaling;
                    z = z || scaling;
                    scaling = createVec3(scaling, y, z, false);
                }
                runtime.sceneGraphService.scaleLocal(this, scaling);
                return this;
            }
        },
        {
            key: "setLocalScale",
            value: function setLocalScale(scaling, y, z) {
                if (typeof scaling === 'number') {
                    y = y || scaling;
                    z = z || scaling;
                    scaling = createVec3(scaling, y, z, false);
                }
                runtime.sceneGraphService.setLocalScale(this, scaling);
                return this;
            }
        },
        {
            key: "getLocalScale",
            value: function getLocalScale() {
                return runtime.sceneGraphService.getLocalScale(this);
            }
        },
        {
            key: "getScale",
            value: function getScale() {
                return runtime.sceneGraphService.getScale(this);
            }
        },
        {
            key: "getEulerAngles",
            value: function getEulerAngles() {
                var _getEuler = getEuler($vec3, runtime.sceneGraphService.getWorldTransform(this)), _getEuler2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_getEuler, 3), ez = _getEuler2[2];
                return rad2deg(ez);
            }
        },
        {
            key: "getLocalEulerAngles",
            value: function getLocalEulerAngles() {
                var _getEuler3 = getEuler($vec3, runtime.sceneGraphService.getLocalRotation(this)), _getEuler4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_getEuler3, 3), ez = _getEuler4[2];
                return rad2deg(ez);
            }
        },
        {
            key: "setEulerAngles",
            value: function setEulerAngles(z) {
                runtime.sceneGraphService.setEulerAngles(this, 0, 0, z);
                return this;
            }
        },
        {
            key: "setLocalEulerAngles",
            value: function setLocalEulerAngles(z) {
                runtime.sceneGraphService.setLocalEulerAngles(this, 0, 0, z);
                return this;
            }
        },
        {
            key: "rotateLocal",
            value: function rotateLocal(x, y, z) {
                if ((0, $geZBG.default)(y) && (0, $geZBG.default)(z)) runtime.sceneGraphService.rotateLocal(this, 0, 0, x);
                else runtime.sceneGraphService.rotateLocal(this, x, y, z);
                return this;
            }
        },
        {
            key: "rotate",
            value: function rotate(x, y, z) {
                if ((0, $geZBG.default)(y) && (0, $geZBG.default)(z)) runtime.sceneGraphService.rotate(this, 0, 0, x);
                else runtime.sceneGraphService.rotate(this, x, y, z);
                return this;
            }
        },
        {
            key: "setRotation",
            value: function setRotation(rotation, y, z, w) {
                runtime.sceneGraphService.setRotation(this, rotation, y, z, w);
                return this;
            }
        },
        {
            key: "setLocalRotation",
            value: function setLocalRotation(rotation, y, z, w) {
                runtime.sceneGraphService.setLocalRotation(this, rotation, y, z, w);
                return this;
            }
        },
        {
            key: "setLocalSkew",
            value: function setLocalSkew(skew, y) {
                runtime.sceneGraphService.setLocalSkew(this, skew, y);
                return this;
            }
        },
        {
            key: "getRotation",
            value: function getRotation() {
                return runtime.sceneGraphService.getRotation(this);
            }
        },
        {
            key: "getLocalRotation",
            value: function getLocalRotation() {
                return runtime.sceneGraphService.getLocalRotation(this);
            }
        },
        {
            key: "getLocalSkew",
            value: function getLocalSkew() {
                return runtime.sceneGraphService.getLocalSkew(this);
            }
        },
        {
            key: "getLocalTransform",
            value: function getLocalTransform() {
                return runtime.sceneGraphService.getLocalTransform(this);
            }
        },
        {
            key: "getWorldTransform",
            value: function getWorldTransform() {
                return runtime.sceneGraphService.getWorldTransform(this);
            }
        },
        {
            key: "setLocalTransform",
            value: function setLocalTransform(transform) {
                runtime.sceneGraphService.setLocalTransform(this, transform);
                return this;
            }
        },
        {
            key: "resetLocalTransform",
            value: function resetLocalTransform() {
                runtime.sceneGraphService.resetLocalTransform(this);
            }
        },
        {
            key: "getAnimations",
            value: function getAnimations() {
                return this.activeAnimations;
            }
        },
        {
            key: "animate",
            value: function animate(keyframes, options) {
                var _this$ownerDocument;
                var timeline = (_this$ownerDocument = this.ownerDocument) === null || _this$ownerDocument === void 0 ? void 0 : _this$ownerDocument.timeline;
                if (timeline) return timeline.play(this, keyframes, options);
                return null;
            }
        },
        {
            key: "isVisible",
            value: function isVisible() {
                var _this$parsedStyle;
                return ((_this$parsedStyle = this.parsedStyle) === null || _this$parsedStyle === void 0 ? void 0 : _this$parsedStyle.visibility) !== 'hidden';
            }
        },
        {
            key: "interactive",
            get: function get() {
                return this.isInteractive();
            },
            set: function set(b) {
                this.style.pointerEvents = b ? 'auto' : 'none';
            }
        },
        {
            key: "isInteractive",
            value: function isInteractive() {
                var _this$parsedStyle2;
                return ((_this$parsedStyle2 = this.parsedStyle) === null || _this$parsedStyle2 === void 0 ? void 0 : _this$parsedStyle2.pointerEvents) !== 'none';
            }
        },
        {
            key: "isCulled",
            value: function isCulled() {
                return !!(this.cullable && this.cullable.enable && !this.cullable.visible);
            }
        },
        {
            key: "toFront",
            value: function toFront() {
                if (this.parentNode) this.style.zIndex = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(this.parentNode.children.map(function(child) {
                    return Number(child.style.zIndex);
                }))) + 1;
                return this;
            }
        },
        {
            key: "toBack",
            value: function toBack() {
                if (this.parentNode) this.style.zIndex = Math.min.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(this.parentNode.children.map(function(child) {
                    return Number(child.style.zIndex);
                }))) - 1;
                return this;
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                return this.config;
            }
        },
        {
            key: "attr",
            value: function attr() {
                var _this2 = this;
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var name = args[0], value = args[1];
                if (!name) return this.attributes;
                if ((0, $6JKSc.default)(name)) {
                    Object.keys(name).forEach(function(key) {
                        _this2.setAttribute(key, name[key]);
                    });
                    return this;
                }
                if (args.length === 2) {
                    this.setAttribute(name, value);
                    return this;
                }
                return this.attributes[name];
            }
        },
        {
            key: "getMatrix",
            value: function getMatrix(transformMat4) {
                var transform = transformMat4 || this.getWorldTransform();
                var _mat4$getTranslation = (0, $3iqbd).getTranslation($vec3, transform), _mat4$getTranslation2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_mat4$getTranslation, 2), tx = _mat4$getTranslation2[0], ty = _mat4$getTranslation2[1];
                var _mat4$getScaling = (0, $3iqbd).getScaling($vec3, transform), _mat4$getScaling2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_mat4$getScaling, 2), sx = _mat4$getScaling2[0], sy = _mat4$getScaling2[1];
                var rotation = (0, $3iqbd).getRotation($quat, transform);
                var _getEuler5 = getEuler($vec3, rotation), _getEuler6 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_getEuler5, 3), eux = _getEuler6[0], euz = _getEuler6[2];
                // gimbal lock at 90 degrees
                return fromRotationTranslationScale(eux || euz, tx, ty, sx, sy);
            }
        },
        {
            key: "getLocalMatrix",
            value: function getLocalMatrix() {
                return this.getMatrix(this.getLocalTransform());
            }
        },
        {
            key: "setMatrix",
            value: function setMatrix(mat) {
                var _decompose = decompose(mat), _decompose2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_decompose, 5), tx = _decompose2[0], ty = _decompose2[1], scalingX = _decompose2[2], scalingY = _decompose2[3], angle = _decompose2[4];
                this.setEulerAngles(angle).setPosition(tx, ty).setLocalScale(scalingX, scalingY);
            }
        },
        {
            key: "setLocalMatrix",
            value: function setLocalMatrix(mat) {
                var _decompose3 = decompose(mat), _decompose4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_decompose3, 5), tx = _decompose4[0], ty = _decompose4[1], scalingX = _decompose4[2], scalingY = _decompose4[3], angle = _decompose4[4];
                this.setLocalEulerAngles(angle).setLocalPosition(tx, ty).setLocalScale(scalingX, scalingY);
            }
        },
        {
            key: "show",
            value: function show() {
                this.forEach(function(object) {
                    object.style.visibility = 'visible';
                });
            }
        },
        {
            key: "hide",
            value: function hide() {
                this.forEach(function(object) {
                    object.style.visibility = 'hidden';
                });
            }
        },
        {
            key: "getCount",
            value: function getCount() {
                return this.childElementCount;
            }
        },
        {
            key: "getParent",
            value: function getParent() {
                return this.parentElement;
            }
        },
        {
            key: "getChildren",
            value: function getChildren() {
                return this.children;
            }
        },
        {
            key: "getFirst",
            value: function getFirst() {
                return this.firstElementChild;
            }
        },
        {
            key: "getLast",
            value: function getLast() {
                return this.lastElementChild;
            }
        },
        {
            key: "getChildByIndex",
            value: function getChildByIndex(index) {
                return this.children[index] || null;
            }
        },
        {
            key: "add",
            value: function add(child, index) {
                return this.appendChild(child, index);
            }
        },
        {
            key: "set",
            value: function set(name, value) {
                // @ts-ignore
                this.config[name] = value;
            }
        },
        {
            key: "get",
            value: function get(name) {
                return this.config[name];
            }
        },
        {
            key: "moveTo",
            value: function moveTo(position) {
                var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                this.setPosition(position, y, z);
                return this;
            }
        },
        {
            key: "move",
            value: function move(position) {
                var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                this.setPosition(position, y, z);
                return this;
            }
        },
        {
            key: "setZIndex",
            value: function setZIndex(zIndex) {
                this.style.zIndex = zIndex;
                return this;
            }
        }
    ]);
}(Element);
DisplayObject.PARSED_STYLE_LIST = new Set([
    'class',
    'className',
    'clipPath',
    'cursor',
    'display',
    'draggable',
    'droppable',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'increasedLineWidthForHitTesting',
    'lineCap',
    'lineDash',
    'lineDashOffset',
    'lineJoin',
    'lineWidth',
    'miterLimit',
    'hitArea',
    'offsetDistance',
    'offsetPath',
    'offsetX',
    'offsetY',
    'opacity',
    'pointerEvents',
    'shadowColor',
    'shadowType',
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY',
    'stroke',
    'strokeOpacity',
    'strokeWidth',
    'strokeLinecap',
    'strokeLineJoin',
    'strokeDasharray',
    'strokeDashoffset',
    'transform',
    'transformOrigin',
    'textTransform',
    'visibility',
    'zIndex'
]);
var Circle = /*#__PURE__*/ function(_DisplayObject) {
    function Circle() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Circle);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Circle, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.CIRCLE
            }, options)
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Circle, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Circle);
}(DisplayObject);
Circle.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(DisplayObject.PARSED_STYLE_LIST), [
    'cx',
    'cy',
    'cz',
    'r',
    'isBillboard',
    'isSizeAttenuation'
]));
var _excluded$6 = [
    "style"
];
/**
 * shadow root
 * @see https://yuque.antfin-inc.com/antv/czqvg5/pgqipg
 */ var CustomElement = /*#__PURE__*/ function(_DisplayObject) {
    // private shadowNodes: DisplayObject[] = [];
    function CustomElement() {
        var _this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, style = _ref.style, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, _excluded$6);
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CustomElement);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, CustomElement, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                style: style
            }, rest)
        ]);
        _this.isCustomElement = true;
        return _this;
    }
    /**
   * fired after element insert into DOM tree
   */ (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(CustomElement, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CustomElement);
}(DisplayObject);
CustomElement.PARSED_STYLE_LIST = new Set([
    'class',
    'className',
    'clipPath',
    'cursor',
    'draggable',
    'droppable',
    'opacity',
    'pointerEvents',
    'transform',
    'transformOrigin',
    'zIndex',
    'visibility'
]);
var Ellipse = /*#__PURE__*/ function(_DisplayObject) {
    function Ellipse() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Ellipse);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Ellipse, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.ELLIPSE
            }, options)
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Ellipse, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Ellipse);
}(DisplayObject);
Ellipse.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(DisplayObject.PARSED_STYLE_LIST), [
    'cx',
    'cy',
    'cz',
    'rx',
    'ry',
    'isBillboard',
    'isSizeAttenuation'
]));
/**
 * 节点片段，用于包裹多个节点并批量操作
 *
 *  向 Fragment 或者根节点为 Fragment 的节点添加子节点时，不会触发渲染和事件。
 *
 * 当 Fragment 被挂载到 Canvas 中的节点时，其子节点会一次性被渲染，并触发合并事件。
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/DocumentFragment
 */ var Fragment = /*#__PURE__*/ function(_DisplayObject) {
    function Fragment() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Fragment);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Fragment, [
            {
                type: Shape.FRAGMENT
            }
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Fragment, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Fragment);
}(DisplayObject);
Fragment.PARSED_STYLE_LIST = new Set([
    'class',
    'className'
]);
/**
 * its attributes are inherited by its children.
 * @see https://developer.mozilla.org/zh-CN/docs/Web/SVG/Element/g
 * 
 * @example
 * <g fill="white" stroke="green" stroke-width="5">
    <circle cx="40" cy="40" r="25" />
    <circle cx="60" cy="60" r="25" />
  </g>
 */ var Group = /*#__PURE__*/ function(_DisplayObject) {
    function Group() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Group);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Group, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.GROUP
            }, options)
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Group, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Group);
}(DisplayObject);
Group.PARSED_STYLE_LIST = new Set([
    'class',
    'className',
    'clipPath',
    'cursor',
    'draggable',
    'droppable',
    'opacity',
    'pointerEvents',
    'transform',
    'transformOrigin',
    'zIndex',
    'visibility'
]);
var _excluded$5 = [
    "style"
];
/**
 * HTML container
 * @see https://github.com/pmndrs/drei#html
 */ var HTML = /*#__PURE__*/ function(_DisplayObject) {
    function HTML() {
        var _this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, style = _ref.style, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, _excluded$5);
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, HTML);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, HTML, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.HTML,
                style: style
            }, rest)
        ]);
        _this.cullable.enable = false;
        return _this;
    }
    /**
   * return wrapper HTMLElement
   * * <div> in g-webgl/canvas
   * * <foreignObject> in g-svg
   */ (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(HTML, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(HTML, [
        {
            key: "getDomElement",
            value: function getDomElement() {
                return this.parsedStyle.$el;
            }
        },
        {
            key: "getClientRects",
            value: function getClientRects() {
                return [
                    this.getBoundingClientRect()
                ];
            }
        },
        {
            key: "getLocalBounds",
            value: function getLocalBounds() {
                if (this.parentNode) {
                    var parentInvert = (0, $3iqbd).invert((0, $3iqbd).create(), this.parentNode.getWorldTransform());
                    var bounds = this.getBounds();
                    if (!AABB.isEmpty(bounds)) {
                        var localBounds = new AABB();
                        localBounds.setFromTransformedAABB(bounds, parentInvert);
                        return localBounds;
                    }
                }
                return this.getBounds();
            }
        }
    ]);
}(DisplayObject);
HTML.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(DisplayObject.PARSED_STYLE_LIST), [
    'x',
    'y',
    '$el',
    'innerHTML',
    'width',
    'height'
]));
var Image = /*#__PURE__*/ function(_DisplayObject) {
    function Image() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Image);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Image, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.IMAGE
            }, options)
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Image, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Image);
}(DisplayObject);
Image.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(DisplayObject.PARSED_STYLE_LIST), [
    'x',
    'y',
    'z',
    'src',
    'width',
    'height',
    'isBillboard',
    'billboardRotation',
    'isSizeAttenuation',
    'keepAspectRatio'
]));
var _excluded$4 = [
    "style"
];
/**
 * Create a line connecting two points.
 * @see https://developer.mozilla.org/en-US/docs/Web/SVG/Element/line
 *
 * Also support for using marker.
 */ var Line = /*#__PURE__*/ function(_DisplayObject) {
    function Line() {
        var _this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, style = _ref.style, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, _excluded$4);
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Line);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Line, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.LINE,
                style: (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 0,
                    z1: 0,
                    z2: 0
                }, style)
            }, rest)
        ]);
        _this.markerStartAngle = 0;
        _this.markerEndAngle = 0;
        var _this$parsedStyle = _this.parsedStyle, markerStart = _this$parsedStyle.markerStart, markerEnd = _this$parsedStyle.markerEnd;
        if (markerStart && isDisplayObject(markerStart)) {
            _this.markerStartAngle = markerStart.getLocalEulerAngles();
            _this.appendChild(markerStart);
        }
        if (markerEnd && isDisplayObject(markerEnd)) {
            _this.markerEndAngle = markerEnd.getLocalEulerAngles();
            _this.appendChild(markerEnd);
        }
        _this.transformMarker(true);
        _this.transformMarker(false);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Line, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Line, [
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(attrName, oldValue, newValue, prevParsedValue, newParsedValue) {
                if (attrName === 'x1' || attrName === 'y1' || attrName === 'x2' || attrName === 'y2' || attrName === 'markerStartOffset' || attrName === 'markerEndOffset') {
                    this.transformMarker(true);
                    this.transformMarker(false);
                } else if (attrName === 'markerStart') {
                    if (prevParsedValue && isDisplayObject(prevParsedValue)) {
                        this.markerStartAngle = 0;
                        prevParsedValue.remove();
                    }
                    // CSSKeyword 'unset'
                    if (newParsedValue && isDisplayObject(newParsedValue)) {
                        this.markerStartAngle = newParsedValue.getLocalEulerAngles();
                        this.appendChild(newParsedValue);
                        this.transformMarker(true);
                    }
                } else if (attrName === 'markerEnd') {
                    if (prevParsedValue && isDisplayObject(prevParsedValue)) {
                        this.markerEndAngle = 0;
                        prevParsedValue.remove();
                    }
                    if (newParsedValue && isDisplayObject(newParsedValue)) {
                        this.markerEndAngle = newParsedValue.getLocalEulerAngles();
                        this.appendChild(newParsedValue);
                        this.transformMarker(false);
                    }
                }
            }
        },
        {
            key: "transformMarker",
            value: function transformMarker(isStart) {
                var _this$parsedStyle2 = this.parsedStyle, markerStart = _this$parsedStyle2.markerStart, markerEnd = _this$parsedStyle2.markerEnd, markerStartOffset = _this$parsedStyle2.markerStartOffset, markerEndOffset = _this$parsedStyle2.markerEndOffset, x1 = _this$parsedStyle2.x1, x2 = _this$parsedStyle2.x2, y1 = _this$parsedStyle2.y1, y2 = _this$parsedStyle2.y2;
                var marker = isStart ? markerStart : markerEnd;
                if (!marker || !isDisplayObject(marker)) return;
                var rad = 0;
                var x;
                var y;
                var ox;
                var oy;
                var offset;
                var originalAngle;
                if (isStart) {
                    ox = x1;
                    oy = y1;
                    x = x2 - x1;
                    y = y2 - y1;
                    offset = markerStartOffset || 0;
                    originalAngle = this.markerStartAngle;
                } else {
                    ox = x2;
                    oy = y2;
                    x = x1 - x2;
                    y = y1 - y2;
                    offset = markerEndOffset || 0;
                    originalAngle = this.markerEndAngle;
                }
                rad = Math.atan2(y, x);
                // account for markerOffset
                marker.setLocalEulerAngles(rad * 180 / Math.PI + originalAngle);
                marker.setLocalPosition(ox + Math.cos(rad) * offset, oy + Math.sin(rad) * offset);
            }
        },
        {
            key: "getPoint",
            value: function getPoint(ratio) {
                var inWorldSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                // TODO: account for z1/z2 in 3D line
                var _this$parsedStyle3 = this.parsedStyle, x1 = _this$parsedStyle3.x1, y1 = _this$parsedStyle3.y1, x2 = _this$parsedStyle3.x2, y2 = _this$parsedStyle3.y2;
                var _linePointAt = (0, $11s8J.linePointAt)(x1, y1, x2, y2, ratio), x = _linePointAt.x, y = _linePointAt.y;
                var transformed = (0, $eIStk).transformMat4((0, $eIStk).create(), (0, $eIStk).fromValues(x, y, 0), inWorldSpace ? this.getWorldTransform() : this.getLocalTransform());
                // apply local transformation
                return new Point(transformed[0], transformed[1]);
            }
        },
        {
            key: "getPointAtLength",
            value: function getPointAtLength(distance) {
                var inWorldSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                return this.getPoint(distance / this.getTotalLength(), inWorldSpace);
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                // TODO: account for z1/z2 in 3D line
                var _this$parsedStyle4 = this.parsedStyle, x1 = _this$parsedStyle4.x1, y1 = _this$parsedStyle4.y1, x2 = _this$parsedStyle4.x2, y2 = _this$parsedStyle4.y2;
                return (0, $11s8J.lineLength)(x1, y1, x2, y2);
            }
        }
    ]);
}(DisplayObject);
Line.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(DisplayObject.PARSED_STYLE_LIST), [
    'x1',
    'y1',
    'x2',
    'y2',
    'z1',
    'z2',
    'isBillboard',
    'isSizeAttenuation',
    'markerStart',
    'markerEnd',
    'markerStartOffset',
    'markerEndOffset'
]));
var _excluded$3 = [
    "style"
];
var Path = /*#__PURE__*/ function(_DisplayObject) {
    function Path() {
        var _this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, style = _ref.style, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, _excluded$3);
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Path);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Path, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.PATH,
                style: style,
                initialParsedStyle: {
                    miterLimit: 4,
                    d: (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, EMPTY_PARSED_PATH)
                }
            }, rest)
        ]);
        _this.markerStartAngle = 0;
        _this.markerEndAngle = 0;
        /**
     * markers placed at the mid
     */ _this.markerMidList = [];
        var _this$parsedStyle = _this.parsedStyle, markerStart = _this$parsedStyle.markerStart, markerEnd = _this$parsedStyle.markerEnd, markerMid = _this$parsedStyle.markerMid;
        if (markerStart && isDisplayObject(markerStart)) {
            _this.markerStartAngle = markerStart.getLocalEulerAngles();
            _this.appendChild(markerStart);
        }
        if (markerMid && isDisplayObject(markerMid)) _this.placeMarkerMid(markerMid);
        if (markerEnd && isDisplayObject(markerEnd)) {
            _this.markerEndAngle = markerEnd.getLocalEulerAngles();
            _this.appendChild(markerEnd);
        }
        _this.transformMarker(true);
        _this.transformMarker(false);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Path, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Path, [
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(attrName, oldValue, newValue, prevParsedValue, newParsedValue) {
                if (attrName === 'd') {
                    // recalc markers
                    this.transformMarker(true);
                    this.transformMarker(false);
                    this.placeMarkerMid(this.parsedStyle.markerMid);
                } else if (attrName === 'markerStartOffset' || attrName === 'markerEndOffset') {
                    this.transformMarker(true);
                    this.transformMarker(false);
                } else if (attrName === 'markerStart') {
                    if (prevParsedValue && isDisplayObject(prevParsedValue)) {
                        this.markerStartAngle = 0;
                        prevParsedValue.remove();
                    }
                    // CSSKeyword 'unset'
                    if (newParsedValue && isDisplayObject(newParsedValue)) {
                        this.markerStartAngle = newParsedValue.getLocalEulerAngles();
                        this.appendChild(newParsedValue);
                        this.transformMarker(true);
                    }
                } else if (attrName === 'markerEnd') {
                    if (prevParsedValue && isDisplayObject(prevParsedValue)) {
                        this.markerEndAngle = 0;
                        prevParsedValue.remove();
                    }
                    if (newParsedValue && isDisplayObject(newParsedValue)) {
                        this.markerEndAngle = newParsedValue.getLocalEulerAngles();
                        this.appendChild(newParsedValue);
                        this.transformMarker(false);
                    }
                } else if (attrName === 'markerMid') this.placeMarkerMid(newParsedValue);
            }
        },
        {
            key: "transformMarker",
            value: function transformMarker(isStart) {
                var _this$parsedStyle2 = this.parsedStyle, markerStart = _this$parsedStyle2.markerStart, markerEnd = _this$parsedStyle2.markerEnd, markerStartOffset = _this$parsedStyle2.markerStartOffset, markerEndOffset = _this$parsedStyle2.markerEndOffset;
                var marker = isStart ? markerStart : markerEnd;
                if (!marker || !isDisplayObject(marker)) return;
                var rad = 0;
                var x;
                var y;
                var ox;
                var oy;
                var offset;
                var originalAngle;
                if (isStart) {
                    var _this$getStartTangent = this.getStartTangent(), _this$getStartTangent2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_this$getStartTangent, 2), p1 = _this$getStartTangent2[0], p2 = _this$getStartTangent2[1];
                    ox = p2[0];
                    oy = p2[1];
                    x = p1[0] - p2[0];
                    y = p1[1] - p2[1];
                    offset = markerStartOffset || 0;
                    originalAngle = this.markerStartAngle;
                } else {
                    var _this$getEndTangent = this.getEndTangent(), _this$getEndTangent2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_this$getEndTangent, 2), _p = _this$getEndTangent2[0], _p2 = _this$getEndTangent2[1];
                    ox = _p2[0];
                    oy = _p2[1];
                    x = _p[0] - _p2[0];
                    y = _p[1] - _p2[1];
                    offset = markerEndOffset || 0;
                    originalAngle = this.markerEndAngle;
                }
                rad = Math.atan2(y, x);
                // account for markerOffset
                marker.setLocalEulerAngles(rad * 180 / Math.PI + originalAngle);
                marker.setLocalPosition(ox + Math.cos(rad) * offset, oy + Math.sin(rad) * offset);
            }
        },
        {
            key: "placeMarkerMid",
            value: function placeMarkerMid(marker) {
                var segments = this.parsedStyle.d.segments;
                // clear all existed markers
                this.markerMidList.forEach(function(marker) {
                    marker.remove();
                });
                if (marker && isDisplayObject(marker)) for(var i = 1; i < segments.length - 1; i++){
                    var _segments$i$currentPo = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(segments[i].currentPoint, 2), ox = _segments$i$currentPo[0], oy = _segments$i$currentPo[1];
                    var cloned = i === 1 ? marker : marker.cloneNode(true);
                    this.markerMidList.push(cloned);
                    this.appendChild(cloned);
                    cloned.setLocalPosition(ox, oy);
                // TODO: orient of marker
                }
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                return getOrCalculatePathTotalLength(this);
            }
        },
        {
            key: "getPointAtLength",
            value: function getPointAtLength$1(distance) {
                var inWorldSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var absolutePath = this.parsedStyle.d.absolutePath;
                var _getPointAtLength2 = (0, $3O2w1.getPointAtLength)(absolutePath, distance), x = _getPointAtLength2.x, y = _getPointAtLength2.y;
                var transformed = (0, $eIStk).transformMat4((0, $eIStk).create(), (0, $eIStk).fromValues(x, y, 0), inWorldSpace ? this.getWorldTransform() : this.getLocalTransform());
                // apply local transformation
                return new Point(transformed[0], transformed[1]);
            }
        },
        {
            key: "getPoint",
            value: function getPoint(ratio) {
                var inWorldSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                return this.getPointAtLength(ratio * getOrCalculatePathTotalLength(this), inWorldSpace);
            }
        },
        {
            key: "getStartTangent",
            value: function getStartTangent() {
                var segments = this.parsedStyle.d.segments;
                var result = [];
                if (segments.length > 1) {
                    var startPoint = segments[0].currentPoint;
                    var endPoint = segments[1].currentPoint;
                    var tangent = segments[1].startTangent;
                    result = [];
                    if (tangent) {
                        result.push([
                            startPoint[0] - tangent[0],
                            startPoint[1] - tangent[1]
                        ]);
                        result.push([
                            startPoint[0],
                            startPoint[1]
                        ]);
                    } else {
                        result.push([
                            endPoint[0],
                            endPoint[1]
                        ]);
                        result.push([
                            startPoint[0],
                            startPoint[1]
                        ]);
                    }
                }
                return result;
            }
        },
        {
            key: "getEndTangent",
            value: function getEndTangent() {
                var segments = this.parsedStyle.d.segments;
                var length = segments.length;
                var result = [];
                if (length > 1) {
                    var startPoint = segments[length - 2].currentPoint;
                    var endPoint = segments[length - 1].currentPoint;
                    var tangent = segments[length - 1].endTangent;
                    result = [];
                    if (tangent) {
                        result.push([
                            endPoint[0] - tangent[0],
                            endPoint[1] - tangent[1]
                        ]);
                        result.push([
                            endPoint[0],
                            endPoint[1]
                        ]);
                    } else {
                        result.push([
                            startPoint[0],
                            startPoint[1]
                        ]);
                        result.push([
                            endPoint[0],
                            endPoint[1]
                        ]);
                    }
                }
                return result;
            }
        }
    ]);
}(DisplayObject);
Path.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(DisplayObject.PARSED_STYLE_LIST), [
    'd',
    'markerStart',
    'markerMid',
    'markerEnd',
    'markerStartOffset',
    'markerEndOffset',
    'isBillboard',
    'isSizeAttenuation'
]));
var _excluded$2 = [
    "style"
];
var Polygon = /*#__PURE__*/ function(_DisplayObject) {
    function Polygon() {
        var _this;
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, style = _ref.style, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, _excluded$2);
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Polygon);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Polygon, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.POLYGON,
                style: style,
                initialParsedStyle: {
                    points: {
                        points: [],
                        totalLength: 0,
                        segments: []
                    },
                    miterLimit: 4,
                    isClosed: true
                }
            }, rest)
        ]);
        _this.markerStartAngle = 0;
        _this.markerEndAngle = 0;
        /**
     * markers placed at the mid
     */ _this.markerMidList = [];
        var _this$parsedStyle = _this.parsedStyle, markerStart = _this$parsedStyle.markerStart, markerEnd = _this$parsedStyle.markerEnd, markerMid = _this$parsedStyle.markerMid;
        if (markerStart && isDisplayObject(markerStart)) {
            _this.markerStartAngle = markerStart.getLocalEulerAngles();
            _this.appendChild(markerStart);
        }
        if (markerMid && isDisplayObject(markerMid)) _this.placeMarkerMid(markerMid);
        if (markerEnd && isDisplayObject(markerEnd)) {
            _this.markerEndAngle = markerEnd.getLocalEulerAngles();
            _this.appendChild(markerEnd);
        }
        _this.transformMarker(true);
        _this.transformMarker(false);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Polygon, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Polygon, [
        {
            key: "attributeChangedCallback",
            value: function attributeChangedCallback(attrName, oldValue, newValue, prevParsedValue, newParsedValue) {
                if (attrName === 'points') {
                    // recalc markers
                    this.transformMarker(true);
                    this.transformMarker(false);
                    this.placeMarkerMid(this.parsedStyle.markerMid);
                } else if (attrName === 'markerStartOffset' || attrName === 'markerEndOffset') {
                    this.transformMarker(true);
                    this.transformMarker(false);
                } else if (attrName === 'markerStart') {
                    if (prevParsedValue && isDisplayObject(prevParsedValue)) {
                        this.markerStartAngle = 0;
                        prevParsedValue.remove();
                    }
                    // CSSKeyword 'unset'
                    if (newParsedValue && isDisplayObject(newParsedValue)) {
                        this.markerStartAngle = newParsedValue.getLocalEulerAngles();
                        this.appendChild(newParsedValue);
                        this.transformMarker(true);
                    }
                } else if (attrName === 'markerEnd') {
                    if (prevParsedValue && isDisplayObject(prevParsedValue)) {
                        this.markerEndAngle = 0;
                        prevParsedValue.remove();
                    }
                    if (newParsedValue && isDisplayObject(newParsedValue)) {
                        this.markerEndAngle = newParsedValue.getLocalEulerAngles();
                        this.appendChild(newParsedValue);
                        this.transformMarker(false);
                    }
                } else if (attrName === 'markerMid') this.placeMarkerMid(newParsedValue);
            }
        },
        {
            key: "transformMarker",
            value: function transformMarker(isStart) {
                var _this$parsedStyle2 = this.parsedStyle, markerStart = _this$parsedStyle2.markerStart, markerEnd = _this$parsedStyle2.markerEnd, markerStartOffset = _this$parsedStyle2.markerStartOffset, markerEndOffset = _this$parsedStyle2.markerEndOffset, P = _this$parsedStyle2.points;
                var _ref2 = P || {}, points = _ref2.points;
                var marker = isStart ? markerStart : markerEnd;
                if (!marker || !isDisplayObject(marker) || !points) return;
                var rad = 0;
                var x;
                var y;
                var ox;
                var oy;
                var offset;
                var originalAngle;
                ox = points[0][0];
                oy = points[0][1];
                if (isStart) {
                    x = points[1][0] - points[0][0];
                    y = points[1][1] - points[0][1];
                    offset = markerStartOffset || 0;
                    originalAngle = this.markerStartAngle;
                } else {
                    var length = points.length;
                    if (!this.parsedStyle.isClosed) {
                        ox = points[length - 1][0];
                        oy = points[length - 1][1];
                        x = points[length - 2][0] - points[length - 1][0];
                        y = points[length - 2][1] - points[length - 1][1];
                    } else {
                        x = points[length - 1][0] - points[0][0];
                        y = points[length - 1][1] - points[0][1];
                    }
                    offset = markerEndOffset || 0;
                    originalAngle = this.markerEndAngle;
                }
                rad = Math.atan2(y, x);
                // account for markerOffset
                marker.setLocalEulerAngles(rad * 180 / Math.PI + originalAngle);
                marker.setLocalPosition(ox + Math.cos(rad) * offset, oy + Math.sin(rad) * offset);
            }
        },
        {
            key: "placeMarkerMid",
            value: function placeMarkerMid(marker) {
                var P = this.parsedStyle.points;
                var _ref3 = P || {}, points = _ref3.points;
                // clear all existed markers
                this.markerMidList.forEach(function(marker) {
                    marker.remove();
                });
                this.markerMidList = [];
                if (marker && isDisplayObject(marker) && points) for(var i = 1; i < (this.parsedStyle.isClosed ? points.length : points.length - 1); i++){
                    var ox = points[i][0];
                    var oy = points[i][1];
                    var cloned = i === 1 ? marker : marker.cloneNode(true);
                    this.markerMidList.push(cloned);
                    this.appendChild(cloned);
                    cloned.setLocalPosition(ox, oy);
                // TODO: orient of marker
                }
            }
        }
    ]);
}(DisplayObject);
Polygon.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(DisplayObject.PARSED_STYLE_LIST), [
    'points',
    'markerStart',
    'markerMid',
    'markerEnd',
    'markerStartOffset',
    'markerEndOffset',
    'isClosed',
    'isBillboard',
    'isSizeAttenuation'
]));
var _excluded$1 = [
    "style"
];
/**
 * Polyline inherits the marker-related capabilities of Polygon.
 */ var Polyline = /*#__PURE__*/ function(_Polygon) {
    function Polyline() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, style = _ref.style, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, _excluded$1);
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Polyline);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Polyline, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.POLYLINE,
                style: style,
                initialParsedStyle: {
                    points: {
                        points: [],
                        totalLength: 0,
                        segments: []
                    },
                    miterLimit: 4,
                    isClosed: false
                }
            }, rest)
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Polyline, _Polygon);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Polyline, [
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                return getOrCalculatePolylineTotalLength(this);
            }
        },
        {
            key: "getPointAtLength",
            value: function getPointAtLength(distance) {
                var inWorldSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                return this.getPoint(distance / this.getTotalLength(), inWorldSpace);
            }
        },
        {
            key: "getPoint",
            value: function getPoint(ratio) {
                var inWorldSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var points = this.parsedStyle.points.points;
                if (this.parsedStyle.points.segments.length === 0) {
                    var segments = [];
                    var tempLength = 0;
                    var segmentT;
                    var segmentL;
                    var totalLength = this.getTotalLength();
                    points.forEach(function(p, i) {
                        if (points[i + 1]) {
                            segmentT = [
                                0,
                                0
                            ];
                            segmentT[0] = tempLength / totalLength;
                            segmentL = (0, $11s8J.lineLength)(p[0], p[1], points[i + 1][0], points[i + 1][1]);
                            tempLength += segmentL;
                            segmentT[1] = tempLength / totalLength;
                            segments.push(segmentT);
                        }
                    });
                    this.parsedStyle.points.segments = segments;
                }
                var subt = 0;
                var index = 0;
                this.parsedStyle.points.segments.forEach(function(v, i) {
                    if (ratio >= v[0] && ratio <= v[1]) {
                        subt = (ratio - v[0]) / (v[1] - v[0]);
                        index = i;
                    }
                });
                var _linePointAt = (0, $11s8J.linePointAt)(points[index][0], points[index][1], points[index + 1][0], points[index + 1][1], subt), x = _linePointAt.x, y = _linePointAt.y;
                var transformed = (0, $eIStk).transformMat4((0, $eIStk).create(), (0, $eIStk).fromValues(x, y, 0), inWorldSpace ? this.getWorldTransform() : this.getLocalTransform());
                // apply local transformation
                return new Point(transformed[0], transformed[1]);
            }
        },
        {
            key: "getStartTangent",
            value: function getStartTangent() {
                var points = this.parsedStyle.points.points;
                var result = [];
                result.push([
                    points[1][0],
                    points[1][1]
                ]);
                result.push([
                    points[0][0],
                    points[0][1]
                ]);
                return result;
            }
        },
        {
            key: "getEndTangent",
            value: function getEndTangent() {
                var points = this.parsedStyle.points.points;
                var l = points.length - 1;
                var result = [];
                result.push([
                    points[l - 1][0],
                    points[l - 1][1]
                ]);
                result.push([
                    points[l][0],
                    points[l][1]
                ]);
                return result;
            }
        }
    ]);
}(Polygon);
Polyline.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(Polygon.PARSED_STYLE_LIST), [
    'points',
    'markerStart',
    'markerMid',
    'markerEnd',
    'markerStartOffset',
    'markerEndOffset',
    'isBillboard'
]));
var Rect = /*#__PURE__*/ function(_DisplayObject) {
    function Rect() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Rect);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Rect, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.RECT
            }, options)
        ]);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Rect, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Rect);
}(DisplayObject);
Rect.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(DisplayObject.PARSED_STYLE_LIST), [
    'x',
    'y',
    'z',
    'width',
    'height',
    'isBillboard',
    'isSizeAttenuation',
    'radius'
]));
var _excluded = [
    "style"
];
/**
 * <text> @see https://developer.mozilla.org/en-US/docs/Web/API/SVGTextElement
 */ var Text = /*#__PURE__*/ function(_DisplayObject) {
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/API/SVGTextContentElement#constants
   */ // LENGTHADJUST_SPACING: number = 1;
    // LENGTHADJUST_SPACINGANDGLYPHS: number = 2;
    // LENGTHADJUST_UNKNOWN: number = 0;
    function Text() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, style = _ref.style, rest = (0, (/*@__PURE__*/$parcel$interopDefault($gZU1N)))(_ref, _excluded);
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Text);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Text, [
            (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                type: Shape.TEXT,
                style: (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                    fill: 'black'
                }, style)
            }, rest)
        ]);
    }
    /**
   * @see https://developer.mozilla.org/en-US/docs/Web/API/SVGTextContentElement
   */ (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Text, _DisplayObject);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Text, [
        {
            key: "getComputedTextLength",
            value: function getComputedTextLength() {
                var _this$parsedStyle$met;
                this.getGeometryBounds();
                return ((_this$parsedStyle$met = this.parsedStyle.metrics) === null || _this$parsedStyle$met === void 0 ? void 0 : _this$parsedStyle$met.maxLineWidth) || 0;
            }
        },
        {
            key: "getLineBoundingRects",
            value: function getLineBoundingRects() {
                var _this$parsedStyle$met2;
                this.getGeometryBounds();
                return ((_this$parsedStyle$met2 = this.parsedStyle.metrics) === null || _this$parsedStyle$met2 === void 0 ? void 0 : _this$parsedStyle$met2.lineMetrics) || [];
            }
        },
        {
            key: "isOverflowing",
            value: function isOverflowing() {
                this.getGeometryBounds();
                return !!this.parsedStyle.isOverflowing;
            }
        }
    ]);
}(DisplayObject);
Text.PARSED_STYLE_LIST = new Set([].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(DisplayObject.PARSED_STYLE_LIST), [
    'x',
    'y',
    'z',
    'isBillboard',
    'billboardRotation',
    'isSizeAttenuation',
    'text',
    'textAlign',
    'textBaseline',
    'fontStyle',
    'fontSize',
    'fontFamily',
    'fontWeight',
    'fontVariant',
    'lineHeight',
    'letterSpacing',
    'leading',
    'wordWrap',
    'wordWrapWidth',
    'maxLines',
    'textOverflow',
    'isOverflowing',
    'textPath',
    'textDecorationLine',
    'textDecorationColor',
    'textDecorationStyle',
    'textDecorationThickness',
    'textPathSide',
    'textPathStartOffset',
    'metrics',
    'dx',
    'dy'
]));
/**
 * canvas.customElements
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry
 */ var CustomElementRegistry = /*#__PURE__*/ function() {
    function CustomElementRegistry() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CustomElementRegistry);
        this.registry = {};
        this.define(Shape.CIRCLE, Circle);
        this.define(Shape.ELLIPSE, Ellipse);
        this.define(Shape.RECT, Rect);
        this.define(Shape.IMAGE, Image);
        this.define(Shape.LINE, Line);
        this.define(Shape.GROUP, Group);
        this.define(Shape.PATH, Path);
        this.define(Shape.POLYGON, Polygon);
        this.define(Shape.POLYLINE, Polyline);
        this.define(Shape.TEXT, Text);
        this.define(Shape.HTML, HTML);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CustomElementRegistry, [
        {
            key: "define",
            value: function define(name, constructor) {
                this.registry[name] = constructor;
            }
        },
        {
            key: "get",
            value: function get(name) {
                return this.registry[name];
            }
        }
    ]);
}();
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/CSS/RegisterProperty#parameters
 */ /**
 * holds useful CSS-related methods.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/CSS
 *
 * * CSS Typed OM @see https://developer.mozilla.org/en-US/docs/Web/API/CSS/factory_functions
 * * register property @see https://developer.mozilla.org/en-US/docs/Web/API/CSS/RegisterProperty
 * * CSS Layout API
 */ var CSS = {
    /**
   * <number>
   * @see https://drafts.csswg.org/css-values-4/#number-value
   */ number: function number(n) {
        return new CSSUnitValue(n);
    },
    /**
   * <percentage>
   * @see https://drafts.csswg.org/css-values-4/#percentage-value
   */ percent: function percent(n) {
        return new CSSUnitValue(n, '%');
    },
    /**
   * <length>
   */ px: function px(n) {
        return new CSSUnitValue(n, 'px');
    },
    /**
   * <length>
   */ em: function em(n) {
        return new CSSUnitValue(n, 'em');
    },
    rem: function rem(n) {
        return new CSSUnitValue(n, 'rem');
    },
    /**
   * <angle>
   */ deg: function deg(n) {
        return new CSSUnitValue(n, 'deg');
    },
    /**
   * <angle>
   */ grad: function grad(n) {
        return new CSSUnitValue(n, 'grad');
    },
    /**
   * <angle>
   */ rad: function rad(n) {
        return new CSSUnitValue(n, 'rad');
    },
    /**
   * <angle>
   */ turn: function turn(n) {
        return new CSSUnitValue(n, 'turn');
    },
    /**
   * <time>
   */ s: function s(n) {
        return new CSSUnitValue(n, 's');
    },
    /**
   * <time>
   */ ms: function ms(n) {
        return new CSSUnitValue(n, 'ms');
    },
    /**
   * CSS Properties & Values API
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CSS_Properties_and_Values_API
   * @see https://drafts.css-houdini.org/css-properties-values-api/#registering-custom-properties
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CSS/RegisterProperty
   */ registerProperty: function registerProperty(definition) {
        var name = definition.name, inherits = definition.inherits, interpolable = definition.interpolable, initialValue = definition.initialValue, syntax = definition.syntax;
        runtime.styleValueRegistry.registerMetadata({
            n: name,
            inh: inherits,
            "int": interpolable,
            d: initialValue,
            syntax: syntax
        });
    },
    /**
   * CSS Layout API
   * register layout
   *
   * @see https://github.com/w3c/css-houdini-drafts/blob/main/css-layout-api/EXPLAINER.md
   * @see https://developer.mozilla.org/en-US/docs/Web/Guide/Houdini#css_layout_api
   */ registerLayout: function registerLayout(name, clazz) {
        runtime.layoutRegistry.registerLayout(name, clazz);
    }
};
/**
 * the entry of DOM tree
 * Document -> Node -> EventTarget
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Document
 */ var Document = /*#__PURE__*/ function(_Node) {
    function Document() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Document);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Document);
        /**
     * only document has defaultView, points to canvas,
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/defaultView
     */ _this.defaultView = null;
        _this.ownerDocument = null;
        _this.nodeName = 'document';
        // create timeline
        try {
            _this.timeline = new runtime.AnimationTimeline(_this);
        } catch (_unused) {}
        /**
     * for inherited properties, the initial value is used on the root element only,
     * as long as no specified value is supplied.
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/initial_value
     */ var initialStyle = {};
        BUILT_IN_PROPERTIES.forEach(function(_ref) {
            var n = _ref.n, inh = _ref.inh, d = _ref.d;
            if (inh && d) initialStyle[n] = (0, $ky7aH.default)(d) ? d(Shape.GROUP) : d;
        });
        // like <html> in DOM tree
        _this.documentElement = new Group({
            id: 'g-root',
            style: initialStyle
        });
        _this.documentElement.ownerDocument = _this;
        _this.documentElement.parentNode = _this;
        _this.childNodes = [
            _this.documentElement
        ];
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Document, _Node);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Document, [
        {
            key: "children",
            get: function get() {
                return this.childNodes;
            }
        },
        {
            key: "childElementCount",
            get: function get() {
                return this.childNodes.length;
            }
        },
        {
            key: "firstElementChild",
            get: function get() {
                return this.firstChild;
            }
        },
        {
            key: "lastElementChild",
            get: function get() {
                return this.lastChild;
            }
        },
        {
            key: "createElement",
            value: /**
     * @example const circle = document.createElement('circle', { style: { r: 10 } });
     */ function createElement(tagName, options) {
                // @observablehq/plot will create <svg>
                if (tagName === 'svg') return this.documentElement;
                // d3 will use <tspan>
                var clazz = this.defaultView.customElements.get(tagName);
                if (!clazz) {
                    console.warn('Unsupported tagName: ', tagName);
                    clazz = tagName === 'tspan' ? Text : Group;
                }
                var shape = new clazz(options);
                shape.ownerDocument = this;
                return shape;
            }
        },
        {
            key: "createElementNS",
            value: function createElementNS(namespaceURI, tagName, options) {
                return this.createElement(tagName, options);
            }
        },
        {
            key: "cloneNode",
            value: function cloneNode(deep) {
                throw new Error(ERROR_MSG_METHOD_NOT_IMPLEMENTED);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                try {
                    this.documentElement.destroyChildren();
                    this.timeline.destroy();
                } catch (_unused2) {}
            }
        },
        {
            key: "elementsFromBBox",
            value: function elementsFromBBox(minX, minY, maxX, maxY) {
                var hitTestList = [];
                // Traverse all elements in the document
                var _traverse = function traverse(node) {
                    if (!node.isInteractive() || node.isCulled()) return;
                    var _node$parsedStyle$poi = node.parsedStyle.pointerEvents, pointerEvents = _node$parsedStyle$poi === void 0 ? 'auto' : _node$parsedStyle$poi;
                    // Account for `visibility`
                    // @see https://developer.mozilla.org/en-US/docs/Web/CSS/pointer-events
                    var isVisibilityAffected = [
                        'auto',
                        'visiblepainted',
                        'visiblefill',
                        'visiblestroke',
                        'visible'
                    ].includes(pointerEvents);
                    if (!isVisibilityAffected || node.isVisible()) {
                        var bounds = node.getTransformedGeometryBounds(true);
                        if (bounds && !AABB.isEmpty(bounds)) {
                            if (bounds.max[0] >= minX && bounds.min[0] <= maxX && bounds.max[1] >= minY && bounds.min[1] <= maxY) hitTestList.push(node);
                        }
                    }
                    // Traverse children if it's a container
                    if (node.childNodes) node.childNodes.forEach(function(child) {
                        if (child instanceof DisplayObject) _traverse(child);
                    });
                };
                // Start traversal from documentElement
                _traverse(this.documentElement);
                // Sort by render order (z-index)
                hitTestList.sort(function(a, b) {
                    return b.sortable.renderOrder - a.sortable.renderOrder;
                });
                return hitTestList;
            }
        },
        {
            key: "elementFromPointSync",
            value: function elementFromPointSync(x, y) {
                var _this$defaultView$can = this.defaultView.canvas2Viewport({
                    x: x,
                    y: y
                }), viewportX = _this$defaultView$can.x, viewportY = _this$defaultView$can.y;
                var _this$defaultView$get = this.defaultView.getConfig(), width = _this$defaultView$get.width, height = _this$defaultView$get.height;
                // outside canvas' viewport
                if (viewportX < 0 || viewportY < 0 || viewportX > width || viewportY > height) return null;
                var _this$defaultView$vie = this.defaultView.viewport2Client({
                    x: viewportX,
                    y: viewportY
                }), clientX = _this$defaultView$vie.x, clientY = _this$defaultView$vie.y;
                var _this$defaultView$get2 = this.defaultView.getRenderingService().hooks.pickSync.call({
                    topmost: true,
                    position: {
                        x: x,
                        y: y,
                        viewportX: viewportX,
                        viewportY: viewportY,
                        clientX: clientX,
                        clientY: clientY
                    },
                    picked: []
                }), picked = _this$defaultView$get2.picked;
                return picked && picked[0] || this.documentElement;
            }
        },
        {
            key: "elementFromPoint",
            value: function() {
                var _elementFromPoint = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee(x, y) {
                    var _this$defaultView$can2, viewportX, viewportY, _this$defaultView$get3, width, height, _this$defaultView$vie2, clientX, clientY, _yield$this$defaultVi, picked;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _this$defaultView$can2 = this.defaultView.canvas2Viewport({
                                    x: x,
                                    y: y
                                }), viewportX = _this$defaultView$can2.x, viewportY = _this$defaultView$can2.y;
                                _this$defaultView$get3 = this.defaultView.getConfig(), width = _this$defaultView$get3.width, height = _this$defaultView$get3.height; // outside canvas' viewport
                                if (!(viewportX < 0 || viewportY < 0 || viewportX > width || viewportY > height)) {
                                    _context.next = 1;
                                    break;
                                }
                                return _context.abrupt("return", null);
                            case 1:
                                _this$defaultView$vie2 = this.defaultView.viewport2Client({
                                    x: viewportX,
                                    y: viewportY
                                }), clientX = _this$defaultView$vie2.x, clientY = _this$defaultView$vie2.y;
                                _context.next = 2;
                                return this.defaultView.getRenderingService().hooks.pick.promise({
                                    topmost: true,
                                    position: {
                                        x: x,
                                        y: y,
                                        viewportX: viewportX,
                                        viewportY: viewportY,
                                        clientX: clientX,
                                        clientY: clientY
                                    },
                                    picked: []
                                });
                            case 2:
                                _yield$this$defaultVi = _context.sent;
                                picked = _yield$this$defaultVi.picked;
                                return _context.abrupt("return", picked && picked[0] || this.documentElement);
                            case 3:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function elementFromPoint(_x, _x2) {
                    return _elementFromPoint.apply(this, arguments);
                }
                return elementFromPoint;
            }()
        },
        {
            key: "elementsFromPointSync",
            value: function elementsFromPointSync(x, y) {
                var _this$defaultView$can3 = this.defaultView.canvas2Viewport({
                    x: x,
                    y: y
                }), viewportX = _this$defaultView$can3.x, viewportY = _this$defaultView$can3.y;
                var _this$defaultView$get4 = this.defaultView.getConfig(), width = _this$defaultView$get4.width, height = _this$defaultView$get4.height;
                // outside canvas' viewport
                if (viewportX < 0 || viewportY < 0 || viewportX > width || viewportY > height) return [];
                var _this$defaultView$vie3 = this.defaultView.viewport2Client({
                    x: viewportX,
                    y: viewportY
                }), clientX = _this$defaultView$vie3.x, clientY = _this$defaultView$vie3.y;
                var _this$defaultView$get5 = this.defaultView.getRenderingService().hooks.pickSync.call({
                    topmost: false,
                    position: {
                        x: x,
                        y: y,
                        viewportX: viewportX,
                        viewportY: viewportY,
                        clientX: clientX,
                        clientY: clientY
                    },
                    picked: []
                }), picked = _this$defaultView$get5.picked;
                if (picked[picked.length - 1] !== this.documentElement) picked.push(this.documentElement);
                return picked;
            }
        },
        {
            key: "elementsFromPoint",
            value: function() {
                var _elementsFromPoint = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee2(x, y) {
                    var _this$defaultView$can4, viewportX, viewportY, _this$defaultView$get6, width, height, _this$defaultView$vie4, clientX, clientY, _yield$this$defaultVi2, picked;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _this$defaultView$can4 = this.defaultView.canvas2Viewport({
                                    x: x,
                                    y: y
                                }), viewportX = _this$defaultView$can4.x, viewportY = _this$defaultView$can4.y;
                                _this$defaultView$get6 = this.defaultView.getConfig(), width = _this$defaultView$get6.width, height = _this$defaultView$get6.height; // outside canvas' viewport
                                if (!(viewportX < 0 || viewportY < 0 || viewportX > width || viewportY > height)) {
                                    _context2.next = 1;
                                    break;
                                }
                                return _context2.abrupt("return", []);
                            case 1:
                                _this$defaultView$vie4 = this.defaultView.viewport2Client({
                                    x: viewportX,
                                    y: viewportY
                                }), clientX = _this$defaultView$vie4.x, clientY = _this$defaultView$vie4.y;
                                _context2.next = 2;
                                return this.defaultView.getRenderingService().hooks.pick.promise({
                                    topmost: false,
                                    position: {
                                        x: x,
                                        y: y,
                                        viewportX: viewportX,
                                        viewportY: viewportY,
                                        clientX: clientX,
                                        clientY: clientY
                                    },
                                    picked: []
                                });
                            case 2:
                                _yield$this$defaultVi2 = _context2.sent;
                                picked = _yield$this$defaultVi2.picked;
                                if (picked[picked.length - 1] !== this.documentElement) picked.push(this.documentElement);
                                return _context2.abrupt("return", picked);
                            case 3:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function elementsFromPoint(_x3, _x4) {
                    return _elementsFromPoint.apply(this, arguments);
                }
                return elementsFromPoint;
            }()
        },
        {
            key: "appendChild",
            value: function appendChild(newChild, index) {
                throw new Error(ERROR_MSG_USE_DOCUMENT_ELEMENT);
            }
        },
        {
            key: "insertBefore",
            value: function insertBefore(newChild, refChild) {
                throw new Error(ERROR_MSG_USE_DOCUMENT_ELEMENT);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(oldChild, destroy) {
                throw new Error(ERROR_MSG_USE_DOCUMENT_ELEMENT);
            }
        },
        {
            key: "replaceChild",
            value: function replaceChild(newChild, oldChild, destroy) {
                throw new Error(ERROR_MSG_USE_DOCUMENT_ELEMENT);
            }
        },
        {
            key: "append",
            value: function append() {
                throw new Error(ERROR_MSG_USE_DOCUMENT_ELEMENT);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                throw new Error(ERROR_MSG_USE_DOCUMENT_ELEMENT);
            }
        },
        {
            key: "getElementById",
            value: function getElementById(id) {
                return this.documentElement.getElementById(id);
            }
        },
        {
            key: "getElementsByName",
            value: function getElementsByName(name) {
                return this.documentElement.getElementsByName(name);
            }
        },
        {
            key: "getElementsByTagName",
            value: function getElementsByTagName(tagName) {
                return this.documentElement.getElementsByTagName(tagName);
            }
        },
        {
            key: "getElementsByClassName",
            value: function getElementsByClassName(className) {
                return this.documentElement.getElementsByClassName(className);
            }
        },
        {
            key: "querySelector",
            value: function querySelector(selectors) {
                return this.documentElement.querySelector(selectors);
            }
        },
        {
            key: "querySelectorAll",
            value: function querySelectorAll(selectors) {
                return this.documentElement.querySelectorAll(selectors);
            }
        },
        {
            key: "find",
            value: function find(filter) {
                return this.documentElement.find(filter);
            }
        },
        {
            key: "findAll",
            value: function findAll(filter) {
                return this.documentElement.findAll(filter);
            }
        }
    ]);
}(Node);
/**
 * apply following rules:
 * 1. `visibility` in scenegraph node
 * 2. other custom culling strategies, eg. frustum culling
 */ var CullingPlugin = /*#__PURE__*/ function() {
    function CullingPlugin(strategies) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CullingPlugin);
        this.strategies = strategies;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CullingPlugin, [
        {
            key: "apply",
            value: function apply(context) {
                var config = context.config, camera = context.camera, renderingService = context.renderingService, renderingContext = context.renderingContext;
                var strategies = this.strategies;
                renderingService.hooks.cull.tap(CullingPlugin.tag, function(object) {
                    if (object) {
                        var _config$future;
                        var cullable = object.cullable;
                        // cullable.visible = true;
                        // const renderBounds = object.getRenderBounds();
                        // if (AABB.isEmpty(renderBounds)) {
                        //   cullable.visible = false;
                        // } else {
                        //   const isShape2D = shape2D.indexOf(object.nodeName as Shape) > -1;
                        //   const [p0, p1, p2, p3] = camera.getFrustum().planes;
                        //   tmpAABB.setMinMax([-p1.distance, -p3.distance, 0], [p0.distance, p2.distance, 0]);
                        //   cullable.visible = isShape2D ? renderBounds.intersects(tmpAABB) : true;
                        // }
                        if (strategies.length === 0) cullable.visible = renderingContext.unculledEntities.indexOf(object.entity) > -1;
                        else // eg. implemented by g-webgl(frustum culling)
                        cullable.visible = strategies.every(function(strategy) {
                            return strategy.isVisible(camera, object);
                        });
                        if (!object.isCulled() && object.isVisible()) return object;
                        var enableCancelEventPropagation = ((_config$future = config.future) === null || _config$future === void 0 ? void 0 : _config$future.experimentalCancelEventPropagation) === true;
                        // if (this.renderingContext.renderListLastFrame.indexOf(object) > -1) {
                        object.dispatchEvent(new CustomEvent(ElementEvent.CULLED), enableCancelEventPropagation, enableCancelEventPropagation);
                        // }
                        return null;
                    }
                    return object;
                });
                renderingService.hooks.afterRender.tap(CullingPlugin.tag, function(object) {
                    object.cullable.visibilityPlaneMask = -1;
                });
            }
        }
    ]);
}();
CullingPlugin.tag = 'Culling';
/**
 * support mouse & touch events
 * @see https://github.com/pixijs/pixi.js/blob/dev/packages/interaction/README.md
 *
 * also provide some extra events such as `drag`
 */ var EventPlugin = /*#__PURE__*/ function() {
    function EventPlugin() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, EventPlugin);
        this.autoPreventDefault = false;
        this.rootPointerEvent = new FederatedPointerEvent(null);
        this.rootWheelEvent = new FederatedWheelEvent(null);
        this.onPointerMove = function(nativeEvent) {
            var _this$context$renderi;
            var canvas = (_this$context$renderi = _this.context.renderingContext.root) === null || _this$context$renderi === void 0 || (_this$context$renderi = _this$context$renderi.ownerDocument) === null || _this$context$renderi === void 0 ? void 0 : _this$context$renderi.defaultView;
            if (canvas.supportsTouchEvents && nativeEvent.pointerType === 'touch') return;
            var normalizedEvents = _this.normalizeToPointerEvent(nativeEvent, canvas);
            var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(normalizedEvents), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var normalizedEvent = _step.value;
                    var event = _this.bootstrapEvent(_this.rootPointerEvent, normalizedEvent, canvas, nativeEvent);
                    _this.context.eventService.mapEvent(event);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
            _this.setCursor(_this.context.eventService.cursor);
        };
        this.onClick = function(nativeEvent) {
            var _this$context$renderi2;
            var canvas = (_this$context$renderi2 = _this.context.renderingContext.root) === null || _this$context$renderi2 === void 0 || (_this$context$renderi2 = _this$context$renderi2.ownerDocument) === null || _this$context$renderi2 === void 0 ? void 0 : _this$context$renderi2.defaultView;
            var normalizedEvents = _this.normalizeToPointerEvent(nativeEvent, canvas);
            var _iterator2 = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(normalizedEvents), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var normalizedEvent = _step2.value;
                    var event = _this.bootstrapEvent(_this.rootPointerEvent, normalizedEvent, canvas, nativeEvent);
                    _this.context.eventService.mapEvent(event);
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this.setCursor(_this.context.eventService.cursor);
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(EventPlugin, [
        {
            key: "apply",
            value: function apply(context) {
                var _this2 = this;
                this.context = context;
                var renderingService = context.renderingService;
                var canvas = this.context.renderingContext.root.ownerDocument.defaultView;
                this.context.eventService.setPickHandler(function(position) {
                    var _this2$context$render = _this2.context.renderingService.hooks.pickSync.call({
                        position: position,
                        picked: [],
                        topmost: true // we only concern the topmost element
                    }), picked = _this2$context$render.picked;
                    return picked[0] || null;
                });
                renderingService.hooks.pointerWheel.tap(EventPlugin.tag, function(nativeEvent) {
                    var wheelEvent = _this2.normalizeWheelEvent(nativeEvent);
                    _this2.context.eventService.mapEvent(wheelEvent);
                });
                renderingService.hooks.pointerDown.tap(EventPlugin.tag, function(nativeEvent) {
                    if (canvas.supportsTouchEvents && nativeEvent.pointerType === 'touch') return;
                    var events = _this2.normalizeToPointerEvent(nativeEvent, canvas);
                    if (_this2.autoPreventDefault && events[0].isNormalized) {
                        var cancelable = nativeEvent.cancelable || !('cancelable' in nativeEvent);
                        if (cancelable) nativeEvent.preventDefault();
                    }
                    var _iterator3 = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(events), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var event = _step3.value;
                            var federatedEvent = _this2.bootstrapEvent(_this2.rootPointerEvent, event, canvas, nativeEvent);
                            _this2.context.eventService.mapEvent(federatedEvent);
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                    _this2.setCursor(_this2.context.eventService.cursor);
                });
                renderingService.hooks.pointerUp.tap(EventPlugin.tag, function(nativeEvent) {
                    if (canvas.supportsTouchEvents && nativeEvent.pointerType === 'touch') return;
                    // account for element in SVG
                    var $element = _this2.context.contextService.getDomElement();
                    var isNativeEventFromCanvas = _this2.context.eventService.isNativeEventFromCanvas($element, nativeEvent);
                    var outside = !isNativeEventFromCanvas ? 'outside' : '';
                    var normalizedEvents = _this2.normalizeToPointerEvent(nativeEvent, canvas);
                    var _iterator4 = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(normalizedEvents), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var normalizedEvent = _step4.value;
                            var event = _this2.bootstrapEvent(_this2.rootPointerEvent, normalizedEvent, canvas, nativeEvent);
                            event.type += outside;
                            _this2.context.eventService.mapEvent(event);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                    _this2.setCursor(_this2.context.eventService.cursor);
                });
                renderingService.hooks.pointerMove.tap(EventPlugin.tag, this.onPointerMove);
                renderingService.hooks.pointerOver.tap(EventPlugin.tag, this.onPointerMove);
                renderingService.hooks.pointerOut.tap(EventPlugin.tag, this.onPointerMove);
                renderingService.hooks.click.tap(EventPlugin.tag, this.onClick);
                renderingService.hooks.pointerCancel.tap(EventPlugin.tag, function(nativeEvent) {
                    var normalizedEvents = _this2.normalizeToPointerEvent(nativeEvent, canvas);
                    var _iterator5 = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(normalizedEvents), _step5;
                    try {
                        for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                            var normalizedEvent = _step5.value;
                            var event = _this2.bootstrapEvent(_this2.rootPointerEvent, normalizedEvent, canvas, nativeEvent);
                            _this2.context.eventService.mapEvent(event);
                        }
                    } catch (err) {
                        _iterator5.e(err);
                    } finally{
                        _iterator5.f();
                    }
                    _this2.setCursor(_this2.context.eventService.cursor);
                });
            }
        },
        {
            key: "bootstrapEvent",
            value: function bootstrapEvent(event, normalizedEvent, view, nativeEvent) {
                event.view = view;
                event.originalEvent = null;
                event.nativeEvent = nativeEvent;
                event.pointerId = normalizedEvent.pointerId;
                event.width = normalizedEvent.width;
                event.height = normalizedEvent.height;
                event.isPrimary = normalizedEvent.isPrimary;
                event.pointerType = normalizedEvent.pointerType;
                event.pressure = normalizedEvent.pressure;
                event.tangentialPressure = normalizedEvent.tangentialPressure;
                event.tiltX = normalizedEvent.tiltX;
                event.tiltY = normalizedEvent.tiltY;
                event.twist = normalizedEvent.twist;
                this.transferMouseData(event, normalizedEvent);
                var _this$context$eventSe = this.context.eventService.client2Viewport({
                    x: normalizedEvent.clientX,
                    y: normalizedEvent.clientY
                }), x = _this$context$eventSe.x, y = _this$context$eventSe.y;
                event.viewport.x = x;
                event.viewport.y = y;
                var _this$context$eventSe2 = this.context.eventService.viewport2Canvas(event.viewport), canvasX = _this$context$eventSe2.x, canvasY = _this$context$eventSe2.y;
                event.canvas.x = canvasX;
                event.canvas.y = canvasY;
                event.global.copyFrom(event.canvas);
                event.offset.copyFrom(event.canvas);
                event.isTrusted = nativeEvent.isTrusted;
                if (event.type === 'pointerleave') event.type = 'pointerout';
                if (event.type.startsWith('mouse')) event.type = event.type.replace('mouse', 'pointer');
                if (event.type.startsWith('touch')) event.type = TOUCH_TO_POINTER[event.type] || event.type;
                return event;
            }
        },
        {
            key: "normalizeWheelEvent",
            value: function normalizeWheelEvent(nativeEvent) {
                var event = this.rootWheelEvent;
                this.transferMouseData(event, nativeEvent);
                event.deltaMode = nativeEvent.deltaMode;
                event.deltaX = nativeEvent.deltaX;
                event.deltaY = nativeEvent.deltaY;
                event.deltaZ = nativeEvent.deltaZ;
                var _this$context$eventSe3 = this.context.eventService.client2Viewport({
                    x: nativeEvent.clientX,
                    y: nativeEvent.clientY
                }), x = _this$context$eventSe3.x, y = _this$context$eventSe3.y;
                event.viewport.x = x;
                event.viewport.y = y;
                var _this$context$eventSe4 = this.context.eventService.viewport2Canvas(event.viewport), canvasX = _this$context$eventSe4.x, canvasY = _this$context$eventSe4.y;
                event.canvas.x = canvasX;
                event.canvas.y = canvasY;
                event.global.copyFrom(event.canvas);
                event.offset.copyFrom(event.canvas);
                event.nativeEvent = nativeEvent;
                event.type = nativeEvent.type;
                return event;
            }
        },
        {
            key: "transferMouseData",
            value: function transferMouseData(event, nativeEvent) {
                event.isTrusted = nativeEvent.isTrusted;
                event.srcElement = nativeEvent.srcElement;
                event.timeStamp = clock.now();
                event.type = nativeEvent.type;
                event.altKey = nativeEvent.altKey;
                event.metaKey = nativeEvent.metaKey;
                event.shiftKey = nativeEvent.shiftKey;
                event.ctrlKey = nativeEvent.ctrlKey;
                event.button = nativeEvent.button;
                event.buttons = nativeEvent.buttons;
                event.client.x = nativeEvent.clientX;
                event.client.y = nativeEvent.clientY;
                event.movement.x = nativeEvent.movementX;
                event.movement.y = nativeEvent.movementY;
                event.page.x = nativeEvent.pageX;
                event.page.y = nativeEvent.pageY;
                event.screen.x = nativeEvent.screenX;
                event.screen.y = nativeEvent.screenY;
                event.relatedTarget = null;
            }
        },
        {
            key: "setCursor",
            value: function setCursor(cursor) {
                this.context.contextService.applyCursorStyle(cursor || this.context.config.cursor || 'default');
            }
        },
        {
            key: "normalizeToPointerEvent",
            value: function normalizeToPointerEvent(event, canvas) {
                var normalizedEvents = [];
                if (canvas.isTouchEvent(event)) for(var i = 0; i < event.changedTouches.length; i++){
                    var touch = event.changedTouches[i];
                    // use changedTouches instead of touches since touchend has no touches
                    // @see https://stackoverflow.com/a/10079076
                    if ((0, $aFcWQ.default)(touch.button)) touch.button = 0;
                    if ((0, $aFcWQ.default)(touch.buttons)) touch.buttons = 1;
                    if ((0, $aFcWQ.default)(touch.isPrimary)) touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
                    if ((0, $aFcWQ.default)(touch.width)) touch.width = touch.radiusX || 1;
                    if ((0, $aFcWQ.default)(touch.height)) touch.height = touch.radiusY || 1;
                    if ((0, $aFcWQ.default)(touch.tiltX)) touch.tiltX = 0;
                    if ((0, $aFcWQ.default)(touch.tiltY)) touch.tiltY = 0;
                    if ((0, $aFcWQ.default)(touch.pointerType)) touch.pointerType = 'touch';
                    // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Touch/identifier
                    if ((0, $aFcWQ.default)(touch.pointerId)) touch.pointerId = touch.identifier || 0;
                    if ((0, $aFcWQ.default)(touch.pressure)) touch.pressure = touch.force || 0.5;
                    if ((0, $aFcWQ.default)(touch.twist)) touch.twist = 0;
                    if ((0, $aFcWQ.default)(touch.tangentialPressure)) touch.tangentialPressure = 0;
                    touch.isNormalized = true;
                    touch.type = event.type;
                    normalizedEvents.push(touch);
                }
                else if (canvas.isMouseEvent(event)) {
                    var tempEvent = event;
                    if ((0, $aFcWQ.default)(tempEvent.isPrimary)) tempEvent.isPrimary = true;
                    if ((0, $aFcWQ.default)(tempEvent.width)) tempEvent.width = 1;
                    if ((0, $aFcWQ.default)(tempEvent.height)) tempEvent.height = 1;
                    if ((0, $aFcWQ.default)(tempEvent.tiltX)) tempEvent.tiltX = 0;
                    if ((0, $aFcWQ.default)(tempEvent.tiltY)) tempEvent.tiltY = 0;
                    if ((0, $aFcWQ.default)(tempEvent.pointerType)) tempEvent.pointerType = 'mouse';
                    if ((0, $aFcWQ.default)(tempEvent.pointerId)) tempEvent.pointerId = MOUSE_POINTER_ID;
                    if ((0, $aFcWQ.default)(tempEvent.pressure)) tempEvent.pressure = 0.5;
                    if ((0, $aFcWQ.default)(tempEvent.twist)) tempEvent.twist = 0;
                    if ((0, $aFcWQ.default)(tempEvent.tangentialPressure)) tempEvent.tangentialPressure = 0;
                    tempEvent.isNormalized = true;
                    normalizedEvents.push(tempEvent);
                } else normalizedEvents.push(event);
                return normalizedEvents;
            }
        }
    ]);
}();
EventPlugin.tag = 'Event';
// group is not a 2d shape
var shape2D = [
    Shape.CIRCLE,
    Shape.ELLIPSE,
    Shape.IMAGE,
    Shape.RECT,
    Shape.LINE,
    Shape.POLYLINE,
    Shape.POLYGON,
    Shape.TEXT,
    Shape.PATH,
    Shape.HTML
];
var FrustumCullingStrategy = /*#__PURE__*/ function() {
    function FrustumCullingStrategy() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, FrustumCullingStrategy);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(FrustumCullingStrategy, [
        {
            key: "isVisible",
            value: function isVisible(camera, object) {
                var _object$parentNode;
                // return true;
                var cullable = object.cullable;
                if (!cullable.enable) return true;
                var renderBounds = object.getRenderBounds();
                if (AABB.isEmpty(renderBounds)) return false;
                // get VP matrix from camera
                var frustum = camera.getFrustum();
                var parentVisibilityPlaneMask = (_object$parentNode = object.parentNode) === null || _object$parentNode === void 0 || (_object$parentNode = _object$parentNode.cullable) === null || _object$parentNode === void 0 ? void 0 : _object$parentNode.visibilityPlaneMask;
                cullable.visibilityPlaneMask = this.computeVisibilityWithPlaneMask(object, renderBounds, parentVisibilityPlaneMask || Mask.INDETERMINATE, frustum.planes);
                cullable.visible = cullable.visibilityPlaneMask !== Mask.OUTSIDE;
                return cullable.visible;
            }
        },
        {
            key: "computeVisibilityWithPlaneMask",
            value: function computeVisibilityWithPlaneMask(object, aabb, parentPlaneMask, planes) {
                if (parentPlaneMask === Mask.OUTSIDE || parentPlaneMask === Mask.INSIDE) // 父节点完全位于视锥内或者外部，直接返回
                return parentPlaneMask;
                // Start with MASK_INSIDE (all zeros) so that after the loop, the return value can be compared with MASK_INSIDE.
                // (Because if there are fewer than 31 planes, the upper bits wont be changed.)
                var mask = Mask.INSIDE;
                var isShape2D = shape2D.indexOf(object.nodeName) > -1;
                // Use viewport culling for 2D shapes
                // @see https://github.com/antvis/g/issues/914
                for(var k = 0, len = planes.length; k < len; ++k){
                    // For k greater than 31 (since 31 is the maximum number of INSIDE/INTERSECTING bits we can store), skip the optimization.
                    var flag = 1 << k;
                    if ((parentPlaneMask & flag) === 0) continue;
                    // skip near & far planes when testing 2D shapes
                    if (isShape2D && (k === 4 || k === 5)) continue;
                    // p-vertex n-vertex <-|plane p-vertex n-vertex
                    // 使用 p-vertex 和 n-vertex 加速，避免进行平面和 aabb 全部顶点的相交检测
                    var _planes$k = planes[k], normal = _planes$k.normal, distance = _planes$k.distance;
                    if ((0, $eIStk).dot(normal, aabb.getPositiveFarPoint(planes[k])) + distance < 0) return Mask.OUTSIDE;
                    if ((0, $eIStk).dot(normal, aabb.getNegativeFarPoint(planes[k])) + distance < 0) // 和当前面相交，对应位置为1，继续检测下一个面
                    mask |= flag;
                }
                return mask;
            }
        }
    ]);
}();
/**
 * PrepareRendererPlugin handles rendering preparation tasks
 * Simplified implementation focused on core rendering needs
 */ var PrepareRendererPlugin = /*#__PURE__*/ function() {
    function PrepareRendererPlugin() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, PrepareRendererPlugin);
        this.mutationRecords = [];
        this.isFirstTimeRendering = true;
        this.isFirstTimeRenderingFinished = false;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(PrepareRendererPlugin, [
        {
            key: "apply",
            value: function apply(context) {
                var _this = this, _runtime$globalThis$r;
                var renderingService = context.renderingService, renderingContext = context.renderingContext;
                var canvas = renderingContext.root.ownerDocument.defaultView;
                var handleAttributeChanged = function handleAttributeChanged(e) {
                    renderingService.dirty();
                };
                var handleBoundsChanged = function handleBoundsChanged(e) {
                    var _this$mutationRecords;
                    var records = e.detail;
                    // Store mutation records for potential future processing
                    (_this$mutationRecords = _this.mutationRecords).push.apply(_this$mutationRecords, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(records));
                    renderingService.dirty();
                };
                var handleMounted = function handleMounted(e) {
                    var object = e.target;
                    if (runtime.enableSizeAttenuation) runtime.styleValueRegistry.updateSizeAttenuation(object, canvas.getCamera().getZoom());
                };
                var handleUnmounted = function handleUnmounted(e) {
                    var object = e.target;
                    // No spatial index cleanup needed
                    runtime.sceneGraphService.dirtyToRoot(object);
                    renderingService.dirty();
                };
                renderingService.hooks.init.tap(PrepareRendererPlugin.tag, function() {
                    canvas.addEventListener(ElementEvent.MOUNTED, handleMounted);
                    canvas.addEventListener(ElementEvent.UNMOUNTED, handleUnmounted);
                    canvas.addEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);
                    canvas.addEventListener(ElementEvent.BOUNDS_CHANGED, handleBoundsChanged);
                });
                renderingService.hooks.destroy.tap(PrepareRendererPlugin.tag, function() {
                    canvas.removeEventListener(ElementEvent.MOUNTED, handleMounted);
                    canvas.removeEventListener(ElementEvent.UNMOUNTED, handleUnmounted);
                    canvas.removeEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);
                    canvas.removeEventListener(ElementEvent.BOUNDS_CHANGED, handleBoundsChanged);
                    _this.mutationRecords = [];
                });
                var ric = (_runtime$globalThis$r = runtime.globalThis.requestIdleCallback) !== null && _runtime$globalThis$r !== void 0 ? _runtime$globalThis$r : raf.bind(runtime.globalThis);
                renderingService.hooks.endFrame.tap(PrepareRendererPlugin.tag, function() {
                    if (_this.isFirstTimeRendering) {
                        _this.isFirstTimeRendering = false;
                        ric(function() {
                            _this.isFirstTimeRenderingFinished = true;
                        });
                    }
                    // Clear mutation records after each frame
                    _this.mutationRecords = [];
                });
            }
        }
    ]);
}();
PrepareRendererPlugin.tag = 'Prepare';
function isCanvas(value) {
    return !!value.document;
}
var CanvasEvent = /*#__PURE__*/ function(CanvasEvent) {
    CanvasEvent["READY"] = "ready";
    CanvasEvent["BEFORE_RENDER"] = "beforerender";
    CanvasEvent["RERENDER"] = "rerender";
    CanvasEvent["AFTER_RENDER"] = "afterrender";
    CanvasEvent["BEFORE_DESTROY"] = "beforedestroy";
    CanvasEvent["AFTER_DESTROY"] = "afterdestroy";
    CanvasEvent["RESIZE"] = "resize";
    CanvasEvent["DIRTY_RECTANGLE"] = "dirtyrectangle";
    CanvasEvent["RENDERER_CHANGED"] = "rendererchanged";
    return CanvasEvent;
}({});
var DEFAULT_CAMERA_Z = 500;
var DEFAULT_CAMERA_NEAR = 0.1;
var DEFAULT_CAMERA_FAR = 1000;
/**
 * reuse custom event preventing from re-create them in every frame
 */ var mountedEvent = new CustomEvent(ElementEvent.MOUNTED);
var unmountedEvent = new CustomEvent(ElementEvent.UNMOUNTED);
var beforeRenderEvent = new CustomEvent(CanvasEvent.BEFORE_RENDER);
var rerenderEvent = new CustomEvent(CanvasEvent.RERENDER);
var afterRenderEvent = new CustomEvent(CanvasEvent.AFTER_RENDER);
/**
 * can be treated like Window in DOM
 * provide some extra methods like `window`, such as:
 * * `window.requestAnimationFrame`
 * * `window.devicePixelRatio`
 *
 * prototype chains: Canvas(Window) -> EventTarget
 *
 * @docs https://g.antv.antgroup.com/api/canvas/intro
 */ var Canvas = /*#__PURE__*/ function(_EventTarget) {
    function Canvas(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Canvas);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Canvas);
        // #region environment
        /**
     * window.document
     */ /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element
     */ _this.Element = DisplayObject;
        _this.inited = false;
        _this.context = {};
        var container = config.container, canvas = config.canvas, renderer = config.renderer, width = config.width, height = config.height, background = config.background, cursor = config.cursor, supportsMutipleCanvasesInOneContainer = config.supportsMutipleCanvasesInOneContainer, _config$cleanUpOnDest = config.cleanUpOnDestroy, cleanUpOnDestroy = _config$cleanUpOnDest === void 0 ? true : _config$cleanUpOnDest, offscreenCanvas = config.offscreenCanvas, devicePixelRatio = config.devicePixelRatio, requestAnimationFrame = config.requestAnimationFrame, cancelAnimationFrame = config.cancelAnimationFrame, createImage = config.createImage, supportsTouchEvents = config.supportsTouchEvents, supportsPointerEvents = config.supportsPointerEvents, isTouchEvent = config.isTouchEvent, isMouseEvent = config.isMouseEvent, dblClickSpeed = config.dblClickSpeed;
        var canvasWidth = width;
        var canvasHeight = height;
        var dpr = devicePixelRatio || isBrowser && window.devicePixelRatio || 1;
        dpr = dpr >= 1 ? Math.ceil(dpr) : 1;
        // use user-defined <canvas> or OffscreenCanvas
        if (canvas) {
            // infer width & height with dpr
            canvasWidth = width || getWidth(canvas) || canvas.width / dpr;
            canvasHeight = height || getHeight(canvas) || canvas.height / dpr;
        }
        /**
     * implements `Window` interface
     */ _this.customElements = new CustomElementRegistry();
        _this.devicePixelRatio = dpr;
        _this.requestAnimationFrame = requestAnimationFrame !== null && requestAnimationFrame !== void 0 ? requestAnimationFrame : raf.bind(runtime.globalThis);
        _this.cancelAnimationFrame = cancelAnimationFrame !== null && cancelAnimationFrame !== void 0 ? cancelAnimationFrame : caf.bind(runtime.globalThis);
        _this.createImage = createImage !== null && createImage !== void 0 ? createImage : function() {
            return new window.Image();
        };
        // the following feature-detect from hammer.js
        // @see https://github.com/hammerjs/hammer.js/blob/master/src/inputjs/input-consts.js#L5
        _this.supportsTouchEvents = supportsTouchEvents !== null && supportsTouchEvents !== void 0 ? supportsTouchEvents : 'ontouchstart' in runtime.globalThis;
        _this.supportsPointerEvents = supportsPointerEvents !== null && supportsPointerEvents !== void 0 ? supportsPointerEvents : !!runtime.globalThis.PointerEvent;
        _this.isTouchEvent = isTouchEvent !== null && isTouchEvent !== void 0 ? isTouchEvent : function(event) {
            return _this.supportsTouchEvents && event instanceof runtime.globalThis.TouchEvent;
        };
        _this.isMouseEvent = isMouseEvent !== null && isMouseEvent !== void 0 ? isMouseEvent : function(event) {
            return !runtime.globalThis.MouseEvent || event instanceof runtime.globalThis.MouseEvent && (!_this.supportsPointerEvents || !(event instanceof runtime.globalThis.PointerEvent));
        };
        // override it in runtime
        if (offscreenCanvas) runtime.offscreenCanvas = offscreenCanvas;
        // create document
        _this.document = new Document();
        _this.document.defaultView = _this;
        if (!supportsMutipleCanvasesInOneContainer) cleanExistedCanvas(container, _this, cleanUpOnDestroy);
        _this.initRenderingContext((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, config), {}, {
            width: canvasWidth,
            height: canvasHeight,
            background: background !== null && background !== void 0 ? background : 'transparent',
            cursor: cursor !== null && cursor !== void 0 ? cursor : 'default',
            cleanUpOnDestroy: cleanUpOnDestroy,
            devicePixelRatio: dpr,
            requestAnimationFrame: _this.requestAnimationFrame,
            cancelAnimationFrame: _this.cancelAnimationFrame,
            createImage: _this.createImage,
            supportsTouchEvents: _this.supportsTouchEvents,
            supportsPointerEvents: _this.supportsPointerEvents,
            isTouchEvent: _this.isTouchEvent,
            isMouseEvent: _this.isMouseEvent,
            dblClickSpeed: dblClickSpeed !== null && dblClickSpeed !== void 0 ? dblClickSpeed : 200
        }));
        _this.initDefaultCamera(canvasWidth, canvasHeight, renderer.clipSpaceNearZ);
        _this.initRenderer(renderer, true);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Canvas, _EventTarget);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Canvas, [
        {
            key: "initRenderingContext",
            value: function initRenderingContext(mergedConfig) {
                this.context.config = mergedConfig;
                // bind rendering context, shared by all renderers
                this.context.renderingContext = {
                    /**
         * the root node in scene graph
         */ root: this.document.documentElement,
                    unculledEntities: [],
                    renderListCurrentFrame: [],
                    renderReasons: new Set(),
                    force: false,
                    dirty: false
                };
            }
        },
        {
            key: "initDefaultCamera",
            value: function initDefaultCamera(width, height, clipSpaceNearZ) {
                var _this2 = this;
                // set a default ortho camera
                var camera = new runtime.CameraContribution();
                camera.clipSpaceNearZ = clipSpaceNearZ;
                camera.setType(CameraType.EXPLORING, CameraTrackingMode.DEFAULT).setPosition(width / 2, height / 2, DEFAULT_CAMERA_Z).setFocalPoint(width / 2, height / 2, 0).setOrthographic(width / -2, width / 2, height / 2, height / -2, DEFAULT_CAMERA_NEAR, DEFAULT_CAMERA_FAR);
                // keep ref since it will use raf in camera animation
                camera.canvas = this;
                // redraw when camera changed
                camera.eventEmitter.on(CameraEvent.UPDATED, function() {
                    _this2.context.renderingContext.renderReasons.add(RenderReason.CAMERA_CHANGED);
                    if (runtime.enableSizeAttenuation && _this2.getConfig().renderer.getConfig().enableSizeAttenuation) _this2.updateSizeAttenuation();
                });
                // bind camera
                this.context.camera = camera;
            }
        },
        {
            key: "updateSizeAttenuation",
            value: function updateSizeAttenuation() {
                var zoom = this.getCamera().getZoom();
                this.document.documentElement.forEach(function(node) {
                    runtime.styleValueRegistry.updateSizeAttenuation(node, zoom);
                });
            }
        },
        {
            key: "getConfig",
            value: function getConfig() {
                return this.context.config;
            }
        },
        {
            key: "getRoot",
            value: function getRoot() {
                return this.document.documentElement;
            }
        },
        {
            key: "getCamera",
            value: function getCamera() {
                return this.context.camera;
            }
        },
        {
            key: "getContextService",
            value: function getContextService() {
                return this.context.contextService;
            }
        },
        {
            key: "getEventService",
            value: function getEventService() {
                return this.context.eventService;
            }
        },
        {
            key: "getRenderingService",
            value: function getRenderingService() {
                return this.context.renderingService;
            }
        },
        {
            key: "getRenderingContext",
            value: function getRenderingContext() {
                return this.context.renderingContext;
            }
        },
        {
            key: "getStats",
            value: function getStats() {
                return this.getRenderingService().getStats();
            }
        },
        {
            key: "ready",
            get: function get() {
                var _this3 = this;
                if (!this.readyPromise) {
                    this.readyPromise = new Promise(function(resolve) {
                        _this3.resolveReadyPromise = function() {
                            resolve(_this3);
                        };
                    });
                    if (this.inited) this.resolveReadyPromise();
                }
                return this.readyPromise;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var _this$getConfig$futur;
                var cleanUp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var skipTriggerEvent = arguments.length > 1 ? arguments[1] : undefined;
                memoize.clearCache();
                var enableCancelEventPropagation = ((_this$getConfig$futur = this.getConfig().future) === null || _this$getConfig$futur === void 0 ? void 0 : _this$getConfig$futur.experimentalCancelEventPropagation) === true;
                if (!skipTriggerEvent) this.dispatchEvent(new CustomEvent(CanvasEvent.BEFORE_DESTROY), enableCancelEventPropagation, enableCancelEventPropagation);
                if (this.frameId) this.cancelAnimationFrame(this.frameId);
                // unmount all children
                var root = this.getRoot();
                if (cleanUp) {
                    this.unmountChildren(root);
                    // destroy Document
                    this.document.destroy();
                    this.getEventService().destroy();
                }
                // destroy services
                this.getRenderingService().destroy();
                this.getContextService().destroy();
                // clear root after render service destroyed
                if (!skipTriggerEvent) this.dispatchEvent(new CustomEvent(CanvasEvent.AFTER_DESTROY), enableCancelEventPropagation, enableCancelEventPropagation);
                var clearEventRetain = function clearEventRetain(event) {
                    event.currentTarget = null;
                    event.manager = null;
                    event.target = null;
                    event.relatedNode = null;
                };
                clearEventRetain(mountedEvent);
                clearEventRetain(unmountedEvent);
                clearEventRetain(beforeRenderEvent);
                clearEventRetain(rerenderEvent);
                clearEventRetain(afterRenderEvent);
                clearEventRetain(attrModifiedEvent);
                clearEventRetain(insertedEvent);
                clearEventRetain(removedEvent);
                clearEventRetain(destroyEvent);
                runtime.textService.clearCache();
            }
        },
        {
            key: "changeSize",
            value: function changeSize(width, height) {
                this.resize(width, height);
            }
        },
        {
            key: "resize",
            value: function resize(width, height) {
                var _canvasConfig$future;
                // update canvas' config
                var canvasConfig = this.context.config;
                canvasConfig.width = width;
                canvasConfig.height = height;
                // resize context
                this.getContextService().resize(width, height);
                // resize camera
                var camera = this.context.camera;
                var projectionMode = camera.getProjectionMode();
                camera.setPosition(width / 2, height / 2, DEFAULT_CAMERA_Z).setFocalPoint(width / 2, height / 2, 0);
                if (projectionMode === CameraProjectionMode.ORTHOGRAPHIC) camera.setOrthographic(width / -2, width / 2, height / 2, height / -2, camera.getNear(), camera.getFar());
                else camera.setAspect(width / height);
                var enableCancelEventPropagation = ((_canvasConfig$future = canvasConfig.future) === null || _canvasConfig$future === void 0 ? void 0 : _canvasConfig$future.experimentalCancelEventPropagation) === true;
                this.dispatchEvent(new CustomEvent(CanvasEvent.RESIZE, {
                    width: width,
                    height: height
                }), enableCancelEventPropagation, enableCancelEventPropagation);
            }
        },
        {
            key: "appendChild",
            value: function appendChild(child, index) {
                return this.document.documentElement.appendChild(child, index);
            }
        },
        {
            key: "insertBefore",
            value: function insertBefore(newChild, refChild) {
                return this.document.documentElement.insertBefore(newChild, refChild);
            }
        },
        {
            key: "removeChild",
            value: function removeChild(child) {
                return this.document.documentElement.removeChild(child);
            }
        },
        {
            key: "removeChildren",
            value: function removeChildren() {
                this.document.documentElement.removeChildren();
            }
        },
        {
            key: "destroyChildren",
            value: function destroyChildren() {
                this.document.documentElement.destroyChildren();
            }
        },
        {
            key: "render",
            value: function render(frame) {
                var _this$getConfig$futur2, _this4 = this;
                if (frame) {
                    beforeRenderEvent.detail = frame;
                    afterRenderEvent.detail = frame;
                }
                var enableCancelEventPropagation = ((_this$getConfig$futur2 = this.getConfig().future) === null || _this$getConfig$futur2 === void 0 ? void 0 : _this$getConfig$futur2.experimentalCancelEventPropagation) === true;
                this.dispatchEvent(beforeRenderEvent, enableCancelEventPropagation, enableCancelEventPropagation);
                var renderingService = this.getRenderingService();
                renderingService.render(this, frame, function() {
                    // trigger actual rerender event
                    // @see https://github.com/antvis/G/issues/1268
                    _this4.dispatchEvent(rerenderEvent, enableCancelEventPropagation, enableCancelEventPropagation);
                });
                this.dispatchEvent(afterRenderEvent, enableCancelEventPropagation, enableCancelEventPropagation);
            }
        },
        {
            key: "run",
            value: function run() {
                var _this5 = this;
                var _tick = function tick(time, frame) {
                    _this5.render(frame);
                    _this5.frameId = _this5.requestAnimationFrame(_tick);
                };
                _tick();
            }
        },
        {
            key: "initRenderer",
            value: function initRenderer(renderer) {
                var _this6 = this;
                var firstContentfullPaint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (!renderer) throw new Error('Renderer is required.');
                // reset
                this.inited = false;
                this.readyPromise = undefined;
                // reset rendering plugins
                this.context.renderingPlugins = [];
                this.context.renderingPlugins.push(new EventPlugin(), new PrepareRendererPlugin(), // new DirtyCheckPlugin(),
                new CullingPlugin([
                    new FrustumCullingStrategy()
                ]));
                //
                this.loadRendererContainerModule(renderer);
                // init context service
                this.context.contextService = new this.context.ContextService((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, runtime), this.context));
                // init rendering service
                this.context.renderingService = new RenderingService(runtime, this.context);
                // init event service
                this.context.eventService = new EventService(runtime, this.context);
                this.context.eventService.init();
                if (this.context.contextService.init) {
                    this.context.contextService.init();
                    this.initRenderingService(renderer, firstContentfullPaint, true);
                } else this.context.contextService.initAsync().then(function() {
                    _this6.initRenderingService(renderer, firstContentfullPaint);
                })["catch"](function(err) {
                    console.error(err);
                });
            }
        },
        {
            key: "initRenderingService",
            value: function initRenderingService(renderer) {
                var _this7 = this;
                var firstContentfullPaint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var async = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                this.context.renderingService.init(function() {
                    var _this7$getConfig$futu;
                    _this7.inited = true;
                    var enableCancelEventPropagation = ((_this7$getConfig$futu = _this7.getConfig().future) === null || _this7$getConfig$futu === void 0 ? void 0 : _this7$getConfig$futu.experimentalCancelEventPropagation) === true;
                    if (firstContentfullPaint) {
                        if (async) _this7.requestAnimationFrame(function() {
                            _this7.dispatchEvent(new CustomEvent(CanvasEvent.READY), enableCancelEventPropagation, enableCancelEventPropagation);
                        });
                        else _this7.dispatchEvent(new CustomEvent(CanvasEvent.READY), enableCancelEventPropagation, enableCancelEventPropagation);
                    } else _this7.dispatchEvent(new CustomEvent(CanvasEvent.RENDERER_CHANGED), enableCancelEventPropagation, enableCancelEventPropagation);
                    if (_this7.readyPromise) _this7.resolveReadyPromise();
                    if (!firstContentfullPaint) _this7.getRoot().forEach(function(node) {
                        var _dirty, _ref;
                        (_dirty = (_ref = node).dirty) === null || _dirty === void 0 || _dirty.call(_ref, true, true);
                    });
                    // keep current scenegraph unchanged, just trigger mounted event
                    _this7.mountChildren(_this7.getRoot());
                    if (renderer.getConfig().enableAutoRendering) _this7.run();
                });
            }
        },
        {
            key: "loadRendererContainerModule",
            value: function loadRendererContainerModule(renderer) {
                var _this8 = this;
                // load other container modules provided by g-canvas/g-svg/g-webgl
                var plugins = renderer.getPlugins();
                plugins.forEach(function(plugin) {
                    plugin.context = _this8.context;
                    plugin.init(runtime);
                });
            }
        },
        {
            key: "setRenderer",
            value: function setRenderer(renderer) {
                // update canvas' config
                var canvasConfig = this.getConfig();
                if (canvasConfig.renderer === renderer) return;
                var oldRenderer = canvasConfig.renderer;
                canvasConfig.renderer = renderer;
                // keep all children undestroyed
                this.destroy(false, true);
                // destroy all plugins, reverse will mutate origin array
                (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))((oldRenderer === null || oldRenderer === void 0 ? void 0 : oldRenderer.getPlugins()) || []).reverse().forEach(function(plugin) {
                    plugin.destroy(runtime);
                });
                this.initRenderer(renderer);
            }
        },
        {
            key: "setCursor",
            value: function setCursor(cursor) {
                var canvasConfig = this.getConfig();
                canvasConfig.cursor = cursor;
                this.getContextService().applyCursorStyle(cursor);
            }
        },
        {
            key: "unmountChildren",
            value: function unmountChildren(parent) {
                var _this9 = this;
                // unmountChildren recursively
                parent.childNodes.forEach(function(child) {
                    _this9.unmountChildren(child);
                });
                if (this.inited) {
                    if (parent.isMutationObserved) parent.dispatchEvent(unmountedEvent);
                    else {
                        var _this$getConfig$futur3;
                        var enableCancelEventPropagation = ((_this$getConfig$futur3 = this.getConfig().future) === null || _this$getConfig$futur3 === void 0 ? void 0 : _this$getConfig$futur3.experimentalCancelEventPropagation) === true;
                        unmountedEvent.target = parent;
                        this.dispatchEvent(unmountedEvent, true, enableCancelEventPropagation);
                    }
                    // skip document.documentElement
                    if (parent !== this.document.documentElement) parent.ownerDocument = null;
                    parent.isConnected = false;
                }
                // trigger after unmounted
                if (parent.isCustomElement) {
                    if (parent.disconnectedCallback) parent.disconnectedCallback();
                }
            }
        },
        {
            key: "mountChildren",
            value: function mountChildren(child) {
                var _this0 = this;
                var skipTriggerEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isInFragment(child);
                if (this.inited) {
                    if (!child.isConnected) {
                        child.ownerDocument = this.document;
                        child.isConnected = true;
                        if (!skipTriggerEvent) {
                            if (child.isMutationObserved) child.dispatchEvent(mountedEvent);
                            else {
                                var _this$getConfig$futur4;
                                var enableCancelEventPropagation = ((_this$getConfig$futur4 = this.getConfig().future) === null || _this$getConfig$futur4 === void 0 ? void 0 : _this$getConfig$futur4.experimentalCancelEventPropagation) === true;
                                mountedEvent.target = child;
                                this.dispatchEvent(mountedEvent, true, enableCancelEventPropagation);
                            }
                        }
                    }
                } else console.warn("[g]: You are trying to call `canvas.appendChild` before canvas' initialization finished. You can either await `canvas.ready` or listen to `CanvasEvent.READY` manually.", 'appended child: ', child.nodeName);
                // recursively mount children
                child.childNodes.forEach(function(c) {
                    _this0.mountChildren(c, skipTriggerEvent);
                });
                // trigger after mounted
                if (child.isCustomElement) {
                    if (child.connectedCallback) child.connectedCallback();
                }
            }
        },
        {
            key: "mountFragment",
            value: function mountFragment(child) {
                this.mountChildren(child, false);
            }
        },
        {
            key: "client2Viewport",
            value: function client2Viewport(client) {
                return this.getEventService().client2Viewport(client);
            }
        },
        {
            key: "viewport2Client",
            value: function viewport2Client(canvas) {
                return this.getEventService().viewport2Client(canvas);
            }
        },
        {
            key: "viewport2Canvas",
            value: function viewport2Canvas(viewport) {
                return this.getEventService().viewport2Canvas(viewport);
            }
        },
        {
            key: "canvas2Viewport",
            value: function canvas2Viewport(canvas) {
                return this.getEventService().canvas2Viewport(canvas);
            }
        },
        {
            key: "getPointByClient",
            value: function getPointByClient(clientX, clientY) {
                return this.client2Viewport({
                    x: clientX,
                    y: clientY
                });
            }
        },
        {
            key: "getClientByPoint",
            value: function getClientByPoint(x, y) {
                return this.viewport2Client({
                    x: x,
                    y: y
                });
            }
        }
    ]);
}(EventTarget);
var uidCounter = 0;
var registrationsTable = new WeakMap();
var MutationRecord = /*#__PURE__*/ function() {
    function MutationRecord(type, target) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, MutationRecord);
        this.addedNodes = [];
        this.attributeName = null;
        this.attributeNamespace = null;
        this.nextSibling = null;
        this.oldValue = null;
        this.previousSibling = null;
        this.removedNodes = [];
        this.type = type;
        this.target = target;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(MutationRecord, null, [
        {
            key: "copy",
            value: function copy(original) {
                var record = new MutationRecord(original.type, original.target);
                record.addedNodes = original.addedNodes.slice();
                record.removedNodes = original.removedNodes.slice();
                record.previousSibling = original.previousSibling;
                record.nextSibling = original.nextSibling;
                record.attributeName = original.attributeName;
                record.attributeNamespace = original.attributeNamespace;
                record.oldValue = original.oldValue;
                return record;
            }
        }
    ]);
}();
var Registration = /*#__PURE__*/ function() {
    function Registration(observer, target, options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Registration);
        this.transientObservedNodes = [];
        this.observer = observer;
        this.target = target;
        this.options = options;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Registration, [
        {
            key: "enqueue",
            value: function enqueue(record) {
                var records = this.observer.records;
                var length = records.length;
                // There are cases where we replace the last record with the new record.
                // For example if the record represents the same mutation we need to use
                // the one with the oldValue. If we get same record (this can happen as we
                // walk up the tree) we ignore the new record.
                if (records.length > 0) {
                    var lastRecord = records[length - 1];
                    var recordToReplaceLast = selectRecord(lastRecord, record);
                    if (recordToReplaceLast) {
                        records[length - 1] = recordToReplaceLast;
                        return;
                    }
                } else scheduleCallback(this.observer);
                records[length] = record;
            }
        },
        {
            key: "addListeners",
            value: function addListeners() {
                this.addListeners_(this.target);
            }
        },
        {
            key: "addListeners_",
            value: function addListeners_(node) {
                var options = this.options;
                if (options.attributes) node.addEventListener(ElementEvent.ATTR_MODIFIED, this, true);
                // if (options.characterData) node.addEventListener('DOMCharacterDataModified', this, true);
                if (options.childList) node.addEventListener(ElementEvent.INSERTED, this, true);
                if (options.childList || options.subtree) node.addEventListener(ElementEvent.REMOVED, this, true);
            }
        },
        {
            key: "removeListeners",
            value: function removeListeners() {
                this.removeListeners_(this.target);
            }
        },
        {
            key: "removeListeners_",
            value: function removeListeners_(node) {
                var options = this.options;
                if (options.attributes) node.removeEventListener(ElementEvent.ATTR_MODIFIED, this, true);
                // if (options.characterData) node.removeEventListener('DOMCharacterDataModified', this, true);
                if (options.childList) node.removeEventListener(ElementEvent.INSERTED, this, true);
                if (options.childList || options.subtree) node.removeEventListener(ElementEvent.REMOVED, this, true);
            }
        },
        {
            key: "removeTransientObservers",
            value: function removeTransientObservers() {
                var transientObservedNodes = this.transientObservedNodes;
                this.transientObservedNodes = [];
                transientObservedNodes.forEach(function(node) {
                    // Transient observers are never added to the target.
                    this.removeListeners_(node);
                    var registrations = registrationsTable.get(node);
                    for(var i = 0; i < registrations.length; i++)if (registrations[i] === this) {
                        registrations.splice(i, 1);
                        break;
                    }
                }, this);
            }
        },
        {
            key: "handleEvent",
            value: function handleEvent(e) {
                // Stop propagation since we are managing the propagation manually.
                // This means that other mutation events on the page will not work
                // correctly but that is by design.
                e.stopImmediatePropagation();
                var record;
                var target;
                switch(e.type){
                    case ElementEvent.ATTR_MODIFIED:
                        // http://dom.spec.whatwg.org/#concept-mo-queue-attributes
                        var name = e.attrName;
                        // @ts-ignore
                        var namespace = e.relatedNode.namespaceURI;
                        target = e.target;
                        // 1.
                        record = getRecord('attributes', target);
                        record.attributeName = name;
                        record.attributeNamespace = namespace;
                        // 2.
                        var oldValue = e.attrChange === MutationEvent.ADDITION ? null : e.prevValue;
                        forEachAncestorAndObserverEnqueueRecord(target, function(options) {
                            // 3.1, 4.2
                            if (!options.attributes) return;
                            // 3.2, 4.3
                            if (options.attributeFilter && options.attributeFilter.length && options.attributeFilter.indexOf(name) === -1 && options.attributeFilter.indexOf(namespace) === -1) return;
                            // 3.3, 4.4
                            if (options.attributeOldValue) return getRecordWithOldValue(oldValue);
                            // 3.4, 4.5
                            return record;
                        });
                        break;
                    // case 'DOMCharacterDataModified':
                    //   // http://dom.spec.whatwg.org/#concept-mo-queue-characterdata
                    //   var target = e.target;
                    //   // 1.
                    //   var record = getRecord('characterData', target);
                    //   // 2.
                    //   var oldValue = e.prevValue;
                    //   forEachAncestorAndObserverEnqueueRecord(target, function(options) {
                    //     // 3.1, 4.2
                    //     if (!options.characterData)
                    //       return;
                    //     // 3.2, 4.3
                    //     if (options.characterDataOldValue)
                    //       return getRecordWithOldValue(oldValue);
                    //     // 3.3, 4.4
                    //     return record;
                    //   });
                    //   break;
                    case ElementEvent.REMOVED:
                    // this.addTransientObserver(e.target as Node);
                    // Fall through.
                    case ElementEvent.INSERTED:
                        // http://dom.spec.whatwg.org/#concept-mo-queue-childlist
                        target = e.relatedNode;
                        var changedNode = e.target;
                        var addedNodes;
                        var removedNodes;
                        if (e.type === ElementEvent.INSERTED) {
                            addedNodes = [
                                changedNode
                            ];
                            removedNodes = [];
                        } else {
                            addedNodes = [];
                            removedNodes = [
                                changedNode
                            ];
                        }
                        var previousSibling = changedNode.previousSibling;
                        var nextSibling = changedNode.nextSibling;
                        // 1.
                        record = getRecord('childList', target);
                        record.addedNodes = addedNodes;
                        record.removedNodes = removedNodes;
                        record.previousSibling = previousSibling;
                        record.nextSibling = nextSibling;
                        forEachAncestorAndObserverEnqueueRecord(target, function(options) {
                            // 2.1, 3.2
                            if (!options.childList) return;
                            // 2.2, 3.3
                            return record;
                        });
                }
                clearRecords();
            }
        }
    ]);
}();
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
 * @see https://github.com/googlearchive/MutationObservers/blob/master/MutationObserver.js
 */ var MutationObserver = /*#__PURE__*/ function() {
    function MutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, MutationObserver);
        this.nodes = [];
        this.records = [];
        this.uid = uidCounter++;
        this.callback = callback;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(MutationObserver, [
        {
            key: "observe",
            value: function observe(target, options) {
                // 1.1
                if (!options.childList && !options.attributes && !options.characterData || // 1.2
                options.attributeOldValue && !options.attributes || // 1.3
                options.attributeFilter && options.attributeFilter.length && !options.attributes || // 1.4
                options.characterDataOldValue && !options.characterData) throw new SyntaxError();
                var registrations = registrationsTable.get(target);
                if (!registrations) registrationsTable.set(target, registrations = []);
                // 2
                // If target's list of registered observers already includes a registered
                // observer associated with the context object, replace that registered
                // observer's options with options.
                var registration;
                for(var i = 0; i < registrations.length; i++)if (registrations[i].observer === this) {
                    registration = registrations[i];
                    registration.removeListeners();
                    registration.options = options;
                    break;
                }
                // 3.
                // Otherwise, add a new registered observer to target's list of registered
                // observers with the context object as the observer and options as the
                // options, and add target to context object's list of nodes on which it
                // is registered.
                if (!registration) {
                    registration = new Registration(this, target, options);
                    registrations.push(registration);
                    this.nodes.push(target);
                }
                registration.addListeners();
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this = this;
                this.nodes.forEach(function(node) {
                    var registrations = registrationsTable.get(node);
                    for(var i = 0; i < registrations.length; i++){
                        var registration = registrations[i];
                        if (registration.observer === _this) {
                            registration.removeListeners();
                            registrations.splice(i, 1);
                            break;
                        }
                    }
                }, this);
                this.records = [];
            }
        },
        {
            key: "takeRecords",
            value: function takeRecords() {
                var copyOfRecords = this.records;
                this.records = [];
                return copyOfRecords;
            }
        }
    ]);
}();
// We keep track of the two (possibly one) records used in a single mutation.
var currentRecord;
var recordWithOldValue;
/**
 * Creates a record without |oldValue| and caches it as |currentRecord| for
 * later use.
 */ function getRecord(type, target) {
    return currentRecord = new MutationRecord(type, target);
}
/**
 * Gets or creates a record with |oldValue| based in the |currentRecord|
 */ function getRecordWithOldValue(oldValue) {
    if (recordWithOldValue) return recordWithOldValue;
    recordWithOldValue = MutationRecord.copy(currentRecord);
    recordWithOldValue.oldValue = oldValue;
    return recordWithOldValue;
}
function clearRecords() {
    currentRecord = recordWithOldValue = undefined;
}
/**
 * Whether the record represents a record from the current
 * mutation event.
 */ function recordRepresentsCurrentMutation(record) {
    return record === recordWithOldValue || record === currentRecord;
}
/**
 * Selects which record, if any, to replace the last record in the queue.
 * This returns |null| if no record should be replaced.
 */ function selectRecord(lastRecord, newRecord) {
    if (lastRecord === newRecord) return lastRecord;
    // Check if the the record we are adding represents the same record. If
    // so, we keep the one with the oldValue in it.
    if (recordWithOldValue && recordRepresentsCurrentMutation(lastRecord)) return recordWithOldValue;
    return null;
}
function removeTransientObserversFor(observer) {
    observer.nodes.forEach(function(node) {
        var registrations = registrationsTable.get(node);
        if (!registrations) return;
        registrations.forEach(function(registration) {
            if (registration.observer === observer) registration.removeTransientObservers();
        });
    });
}
/**
 * This function is used for the "For each registered observer observer (with
 * observer's options as options) in target's list of registered observers,
 * run these substeps:" and the "For each ancestor ancestor of target, and for
 * each registered observer observer (with options options) in ancestor's list
 * of registered observers, run these substeps:" part of the algorithms. The
 * |options.subtree| is checked to ensure that the callback is called
 * correctly.
 *
 * @param {Node} target
 * @param {function(MutationObserverInit):MutationRecord} callback
 */ function forEachAncestorAndObserverEnqueueRecord(target, callback) {
    for(var node = target; node; node = node.parentNode){
        var registrations = registrationsTable.get(node);
        if (registrations) for(var j = 0; j < registrations.length; j++){
            var registration = registrations[j];
            var _options = registration.options;
            // Only target ignores subtree.
            if (node !== target && !_options.subtree) continue;
            var record = callback(_options);
            if (record) registration.enqueue(record);
        }
    }
}
// This is used to ensure that we never schedule 2 callas to setImmediate
var isScheduled = false;
// Keep track of observers that needs to be notified next time.
var scheduledObservers = [];
/**
 * Schedules |dispatchCallback| to be called in the future.
 */ function scheduleCallback(observer) {
    scheduledObservers.push(observer);
    if (!isScheduled) {
        isScheduled = true;
        // setImmediate(dispatchCallbacks);
        if (typeof runtime.globalThis !== 'undefined') runtime.globalThis.setTimeout(dispatchCallbacks);
        else dispatchCallbacks();
    }
}
function dispatchCallbacks() {
    // http://dom.spec.whatwg.org/#mutation-observers
    isScheduled = false; // Used to allow a new setImmediate call above.
    var observers = scheduledObservers;
    scheduledObservers = [];
    // Sort observers based on their creation UID (incremental).
    observers.sort(function(o1, o2) {
        return o1.uid - o2.uid;
    });
    var anyNonEmpty = false;
    observers.forEach(function(observer) {
        // 2.1, 2.2
        var queue = observer.takeRecords();
        // 2.3. Remove all transient registered observers whose observer is mo.
        removeTransientObserversFor(observer);
        // 2.4
        if (queue.length) {
            // @ts-ignore
            observer.callback(queue, observer);
            anyNonEmpty = true;
        }
    });
    // 3.
    if (anyNonEmpty) dispatchCallbacks();
}
var RefCountCache = /*#__PURE__*/ function() {
    function RefCountCache() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, RefCountCache);
        this.cacheStore = new Map();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(RefCountCache, [
        {
            key: "onRefAdded",
            value: function onRefAdded(ref) {}
        },
        {
            key: "has",
            value: function has(key) {
                return this.cacheStore.has(key);
            }
        },
        {
            key: "put",
            value: function put(key, item, ref) {
                if (this.cacheStore.has(key)) return false;
                this.cacheStore.set(key, {
                    value: item,
                    counter: new Set([
                        ref.entity
                    ])
                });
                this.onRefAdded(ref);
                return true;
            }
        },
        {
            key: "get",
            value: function get(key, ref) {
                var cacheItem = this.cacheStore.get(key);
                if (!cacheItem) return null;
                if (!cacheItem.counter.has(ref.entity)) {
                    cacheItem.counter.add(ref.entity);
                    this.onRefAdded(ref);
                }
                return cacheItem.value;
            }
        },
        {
            key: "update",
            value: function update(key, value, ref) {
                var cacheItem = this.cacheStore.get(key);
                if (!cacheItem) return false;
                cacheItem.value = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, cacheItem.value), value);
                if (!cacheItem.counter.has(ref.entity)) {
                    cacheItem.counter.add(ref.entity);
                    this.onRefAdded(ref);
                }
                return true;
            }
        },
        {
            key: "release",
            value: function release(key, ref) {
                var cacheItem = this.cacheStore.get(key);
                if (!cacheItem) return false;
                cacheItem.counter["delete"](ref.entity);
                if (cacheItem.counter.size <= 0) this.cacheStore["delete"](key);
                return true;
            }
        },
        {
            key: "releaseRef",
            value: function releaseRef(ref) {
                var _this = this;
                Array.from(this.cacheStore.keys()).forEach(function(key) {
                    _this.release(key, ref);
                });
            }
        },
        {
            key: "getSize",
            value: function getSize() {
                return this.cacheStore.size;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.cacheStore.clear();
            }
        }
    ]);
}();
var tasks = [];
var nextFrameTasks = [];
var ImageSlicer = /*#__PURE__*/ function() {
    function ImageSlicer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ImageSlicer);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ImageSlicer, null, [
        {
            key: "stop",
            value: function stop() {
                var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ImageSlicer.api;
                if (ImageSlicer.rafId) {
                    api.cancelAnimationFrame(ImageSlicer.rafId);
                    ImageSlicer.rafId = null;
                }
            }
        },
        {
            key: "executeTask",
            value: function executeTask() {
                var api = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ImageSlicer.api;
                if (tasks.length <= 0 && nextFrameTasks.length <= 0) return;
                nextFrameTasks.forEach(function(task) {
                    return task();
                });
                nextFrameTasks = tasks.splice(0, ImageSlicer.TASK_NUM_PER_FRAME);
                ImageSlicer.rafId = api.requestAnimationFrame(function() {
                    ImageSlicer.executeTask(api);
                });
            }
        },
        {
            key: "sliceImage",
            value: function sliceImage(image, sliceWidth, sliceHeight, rerender) {
                var overlap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
                var api = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : ImageSlicer.api;
                var imageWidth = image.naturalWidth || image.width;
                var imageHeight = image.naturalHeight || image.height;
                // 计算步长(考虑重叠区域)
                var strideW = sliceWidth - overlap;
                var strideH = sliceHeight - overlap;
                // 计算网格尺寸
                var gridCols = Math.ceil(imageWidth / strideW);
                var gridRows = Math.ceil(imageHeight / strideH);
                var result = {
                    tileSize: [
                        sliceWidth,
                        sliceHeight
                    ],
                    gridSize: [
                        gridRows,
                        gridCols
                    ],
                    tiles: Array(gridRows).fill(null).map(function() {
                        return Array(gridCols).fill(null);
                    })
                };
                // 遍历网格创建切片
                var _loop = function _loop(row) {
                    var _loop2 = function _loop2(col) {
                        tasks.push(function() {
                            // 计算当前切片的坐标
                            var startX = col * strideW;
                            var startY = row * strideH;
                            // 处理最后一列/行的特殊情况
                            var _ref = [
                                Math.min(sliceWidth, imageWidth - startX),
                                Math.min(sliceHeight, imageHeight - startY)
                            ], tempSliceWidth = _ref[0], tempSliceHeight = _ref[1];
                            // 创建切片canvas
                            var sliceCanvas = api.createCanvas();
                            sliceCanvas.width = sliceWidth;
                            sliceCanvas.height = sliceHeight;
                            var sliceCtx = sliceCanvas.getContext('2d');
                            // 将图像部分绘制到切片canvas上
                            sliceCtx.drawImage(image, startX, startY, tempSliceWidth, tempSliceHeight, 0, 0, tempSliceWidth, tempSliceHeight);
                            // 存储切片信息
                            result.tiles[row][col] = {
                                x: startX,
                                y: startY,
                                tileX: col,
                                tileY: row,
                                data: sliceCanvas
                            };
                            rerender();
                        });
                    };
                    for(var col = 0; col < gridCols; col++)_loop2(col);
                };
                for(var row = 0; row < gridRows; row++)_loop(row);
                ImageSlicer.stop();
                ImageSlicer.executeTask();
                return result;
            }
        }
    ]);
}();
ImageSlicer.TASK_NUM_PER_FRAME = 10;
var IMAGE_CACHE = new RefCountCache();
IMAGE_CACHE.onRefAdded = function onRefAdded(ref) {
    var _this = this;
    ref.addEventListener(ElementEvent.DESTROY, function() {
        _this.releaseRef(ref);
    }, {
        once: true
    });
};
var ImagePool = /*#__PURE__*/ function() {
    function ImagePool(context, runtime) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ImagePool);
        this.gradientCache = {};
        this.patternCache = {};
        this.context = context;
        this.runtime = runtime;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ImagePool, [
        {
            key: "getImageSync",
            value: function getImageSync(src, ref, callback) {
                var imageSource = (0, $kVcyu.default)(src) ? src : src.src;
                if (IMAGE_CACHE.has(imageSource)) {
                    var imageCache = IMAGE_CACHE.get(imageSource, ref);
                    if (imageCache.img.complete) {
                        callback === null || callback === void 0 || callback(imageCache);
                        return imageCache;
                    }
                }
                this.getOrCreateImage(src, ref).then(function(cache) {
                    callback === null || callback === void 0 || callback(cache);
                })["catch"](function(reason) {
                    console.error(reason);
                });
                return null;
            }
        },
        {
            key: "getOrCreateImage",
            value: function getOrCreateImage(src, ref) {
                var _this2 = this;
                var imageSource = (0, $kVcyu.default)(src) ? src : src.src;
                if (!(0, $kVcyu.default)(src) && !IMAGE_CACHE.has(imageSource)) {
                    var imageCache = {
                        img: src,
                        size: [
                            src.naturalWidth || src.width,
                            src.naturalHeight || src.height
                        ],
                        tileSize: calculateImageTileSize(src)
                    };
                    IMAGE_CACHE.put(imageSource, imageCache, ref);
                }
                if (IMAGE_CACHE.has(imageSource)) {
                    var _imageCache = IMAGE_CACHE.get(imageSource, ref);
                    if (_imageCache.img.complete) return Promise.resolve(_imageCache);
                    return new Promise(function(resolve, reject) {
                        _imageCache.img.addEventListener('load', function() {
                            _imageCache.size = [
                                _imageCache.img.naturalWidth || _imageCache.img.width,
                                _imageCache.img.naturalHeight || _imageCache.img.height
                            ];
                            _imageCache.tileSize = calculateImageTileSize(_imageCache.img);
                            resolve(_imageCache);
                        });
                        _imageCache.img.addEventListener('error', function(ev) {
                            reject(ev);
                        });
                    });
                }
                return new Promise(function(resolve, reject) {
                    // @see https://github.com/antvis/g/issues/938
                    var image = _this2.context.config.createImage();
                    if (image) {
                        var _imageCache2 = {
                            img: image,
                            size: [
                                0,
                                0
                            ],
                            tileSize: calculateImageTileSize(image)
                        };
                        IMAGE_CACHE.put(imageSource, _imageCache2, ref);
                        image.onload = function() {
                            _imageCache2.size = [
                                image.naturalWidth || image.width,
                                image.naturalHeight || image.height
                            ];
                            _imageCache2.tileSize = calculateImageTileSize(_imageCache2.img);
                            resolve(_imageCache2);
                        };
                        image.onerror = function(ev) {
                            reject(ev);
                        };
                        image.crossOrigin = 'Anonymous';
                        image.src = imageSource;
                    }
                });
            }
        },
        {
            key: "createDownSampledImage",
            value: function() {
                var _createDownSampledImage = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee(src, ref) {
                    var imageCache, enableLargeImageOptimization, _ref, _ref$maxDownSampledIm, maxDownSampledImageSize, _ref$downSamplingRate, downSamplingRateThreshold, createImageBitmapFunc, _imageCache$size, originWidth, originHeight, resizedImage, downSamplingRate, updateCache;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.next = 1;
                                return this.getOrCreateImage(src, ref);
                            case 1:
                                imageCache = _context.sent;
                                if (!(typeof imageCache.downSamplingRate !== 'undefined')) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", imageCache);
                            case 2:
                                enableLargeImageOptimization = this.context.config.enableLargeImageOptimization;
                                _ref = typeof enableLargeImageOptimization === 'boolean' ? {} : enableLargeImageOptimization, _ref$maxDownSampledIm = _ref.maxDownSampledImageSize, maxDownSampledImageSize = _ref$maxDownSampledIm === void 0 ? 2048 : _ref$maxDownSampledIm, _ref$downSamplingRate = _ref.downSamplingRateThreshold, downSamplingRateThreshold = _ref$downSamplingRate === void 0 ? 0.5 : _ref$downSamplingRate;
                                createImageBitmapFunc = this.runtime.globalThis.createImageBitmap;
                                _imageCache$size = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(imageCache.size, 2), originWidth = _imageCache$size[0], originHeight = _imageCache$size[1];
                                resizedImage = imageCache.img;
                                downSamplingRate = Math.min((maxDownSampledImageSize + maxDownSampledImageSize) / (originWidth + originHeight), Math.max(0.01, Math.min(downSamplingRateThreshold, 0.5)));
                                updateCache = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, imageCache), {}, {
                                    downSamplingRate: downSamplingRate
                                });
                                IMAGE_CACHE.update(imageCache.img.src, updateCache, ref);
                                if (!createImageBitmapFunc) {
                                    _context.next = 7;
                                    break;
                                }
                                _context.prev = 3;
                                _context.next = 4;
                                return createImageBitmapFunc(imageCache.img, {
                                    resizeWidth: originWidth * downSamplingRate,
                                    resizeHeight: originHeight * downSamplingRate
                                });
                            case 4:
                                resizedImage = _context.sent;
                                _context.next = 6;
                                break;
                            case 5:
                                _context.prev = 5;
                                _context["catch"](3);
                                downSamplingRate = 1;
                            case 6:
                                _context.next = 8;
                                break;
                            case 7:
                                downSamplingRate = 1;
                            case 8:
                                updateCache = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, this.getImageSync(src, ref)), {}, {
                                    downSampled: resizedImage,
                                    downSamplingRate: downSamplingRate
                                });
                                IMAGE_CACHE.update(imageCache.img.src, updateCache, ref);
                                return _context.abrupt("return", updateCache);
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            3,
                            5
                        ]
                    ]);
                }));
                function createDownSampledImage(_x, _x2) {
                    return _createDownSampledImage.apply(this, arguments);
                }
                return createDownSampledImage;
            }()
        },
        {
            key: "createImageTiles",
            value: function() {
                var _createImageTiles = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee2(src, tiles, rerender, ref) {
                    var imageCache, _ref$ownerDocument$de, requestAnimationFrame, cancelAnimationFrame, updateCache;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.next = 1;
                                return this.getOrCreateImage(src, ref);
                            case 1:
                                imageCache = _context2.sent;
                                _ref$ownerDocument$de = ref.ownerDocument.defaultView, requestAnimationFrame = _ref$ownerDocument$de.requestAnimationFrame, cancelAnimationFrame = _ref$ownerDocument$de.cancelAnimationFrame;
                                ImageSlicer.api = {
                                    requestAnimationFrame: requestAnimationFrame,
                                    cancelAnimationFrame: cancelAnimationFrame,
                                    createCanvas: function createCanvas() {
                                        return OffscreenCanvasCreator.createCanvas();
                                    }
                                };
                                updateCache = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, imageCache), ImageSlicer.sliceImage(imageCache.img, imageCache.tileSize[0], imageCache.tileSize[0], rerender));
                                IMAGE_CACHE.update(imageCache.img.src, updateCache, ref);
                                return _context2.abrupt("return", updateCache);
                            case 2:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function createImageTiles(_x3, _x4, _x5, _x6) {
                    return _createImageTiles.apply(this, arguments);
                }
                return createImageTiles;
            }()
        },
        {
            key: "releaseImage",
            value: function releaseImage(src, ref) {
                IMAGE_CACHE.release((0, $kVcyu.default)(src) ? src : src.src, ref);
            }
        },
        {
            key: "releaseImageRef",
            value: function releaseImageRef(ref) {
                IMAGE_CACHE.releaseRef(ref);
            }
        },
        {
            key: "getOrCreatePatternSync",
            value: function getOrCreatePatternSync(object, pattern, context, $offscreenCanvas, dpr, min, callback) {
                var patternKey = this.generatePatternKey(pattern);
                if (patternKey && this.patternCache[patternKey]) return this.patternCache[patternKey];
                var image = pattern.image, repetition = pattern.repetition, transform = pattern.transform;
                var src;
                var needScaleWithDPR = false;
                // Image URL
                if ((0, $kVcyu.default)(image)) {
                    var imageCache = this.getImageSync(image, object, callback);
                    src = imageCache === null || imageCache === void 0 ? void 0 : imageCache.img;
                } else if ($offscreenCanvas) {
                    src = $offscreenCanvas;
                    needScaleWithDPR = true;
                } else src = image;
                // @see https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/createPattern
                var canvasPattern = src && context.createPattern(src, repetition);
                if (canvasPattern) {
                    var mat;
                    // @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasPattern/setTransform
                    if (transform) mat = parsedTransformToMat4(parseTransform(transform), new DisplayObject({}));
                    else mat = (0, $3iqbd).identity((0, $3iqbd).create());
                    if (needScaleWithDPR) (0, $3iqbd).scale(mat, mat, [
                        1 / dpr,
                        1 / dpr,
                        1
                    ]);
                    canvasPattern.setTransform({
                        a: mat[0],
                        b: mat[1],
                        c: mat[4],
                        d: mat[5],
                        e: mat[12] + min[0],
                        f: mat[13] + min[1]
                    });
                }
                if (patternKey && canvasPattern) this.patternCache[patternKey] = canvasPattern;
                return canvasPattern;
            }
        },
        {
            key: "getOrCreateGradient",
            value: function getOrCreateGradient(params, context) {
                var key = this.generateGradientKey(params);
                var type = params.type, steps = params.steps, min = params.min, width = params.width, height = params.height, angle = params.angle, cx = params.cx, cy = params.cy, size = params.size;
                if (this.gradientCache[key]) return this.gradientCache[key];
                var gradient = null;
                if (type === GradientType.LinearGradient) {
                    var _computeLinearGradien = computeLinearGradient(min, width, height, angle), x1 = _computeLinearGradien.x1, y1 = _computeLinearGradien.y1, x2 = _computeLinearGradien.x2, y2 = _computeLinearGradien.y2;
                    // @see https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/createLinearGradient
                    gradient = context.createLinearGradient(x1, y1, x2, y2);
                } else if (type === GradientType.RadialGradient) {
                    var _computeRadialGradien = computeRadialGradient(min, width, height, cx, cy, size), x = _computeRadialGradien.x, y = _computeRadialGradien.y, r = _computeRadialGradien.r;
                    // @see https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/createRadialGradient
                    gradient = context.createRadialGradient(x, y, 0, x, y, r);
                }
                if (gradient) {
                    steps.forEach(function(_ref2) {
                        var offset = _ref2.offset, color = _ref2.color;
                        if (offset.unit === UnitType.kPercentage) {
                            var _gradient;
                            (_gradient = gradient) === null || _gradient === void 0 || _gradient.addColorStop(offset.value / 100, color.toString());
                        }
                    });
                    this.gradientCache[key] = gradient;
                }
                return this.gradientCache[key];
            }
        },
        {
            key: "generateGradientKey",
            value: function generateGradientKey(params) {
                var type = params.type, min = params.min, width = params.width, height = params.height, steps = params.steps, angle = params.angle, cx = params.cx, cy = params.cy, size = params.size;
                return "gradient-".concat(type, "-").concat((angle === null || angle === void 0 ? void 0 : angle.toString()) || 0, "-").concat((cx === null || cx === void 0 ? void 0 : cx.toString()) || 0, "-").concat((cy === null || cy === void 0 ? void 0 : cy.toString()) || 0, "-").concat((size === null || size === void 0 ? void 0 : size.toString()) || 0, "-").concat(min[0], "-").concat(min[1], "-").concat(width, "-").concat(height, "-").concat(steps.map(function(_ref3) {
                    var offset = _ref3.offset, color = _ref3.color;
                    return "".concat(offset).concat(color);
                }).join('-'));
            }
        },
        {
            key: "generatePatternKey",
            value: function generatePatternKey(pattern) {
                var image = pattern.image, repetition = pattern.repetition;
                // only generate cache for Image
                if ((0, $kVcyu.default)(image)) return "pattern-".concat(image, "-").concat(repetition);
                if (image.nodeName === 'rect') return "pattern-".concat(image.entity, "-").concat(repetition);
            }
        }
    ]);
}();
ImagePool.isSupportTile = !!OffscreenCanvasCreator.createCanvas();
function calculateImageTileSize(img) {
    if (!img.complete) return [
        0,
        0
    ];
    var width = img.naturalWidth || img.width, height = img.naturalHeight || img.height;
    var tileSize = 256;
    [
        256,
        512
    ].forEach(function(size) {
        var rows = Math.ceil(height / size);
        var cols = Math.ceil(width / size);
        if (rows * cols < 1e3) tileSize = size;
    });
    return [
        tileSize,
        tileSize
    ];
}
var LoadImagePlugin = /*#__PURE__*/ function() {
    function LoadImagePlugin() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, LoadImagePlugin);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(LoadImagePlugin, [
        {
            key: "apply",
            value: function apply(context) {
                var renderingService = context.renderingService, renderingContext = context.renderingContext, imagePool = context.imagePool;
                var canvas = renderingContext.root.ownerDocument.defaultView;
                var calculateWithAspectRatio = function calculateWithAspectRatio(object, imageWidth, imageHeight) {
                    var _object$parsedStyle = object.parsedStyle, width = _object$parsedStyle.width, height = _object$parsedStyle.height;
                    if (width && !height) object.setAttribute('height', imageHeight / imageWidth * width);
                    else if (!width && height) object.setAttribute('width', imageWidth / imageHeight * height);
                };
                var handleMounted = function handleMounted(e) {
                    var object = e.target;
                    var nodeName = object.nodeName, attributes = object.attributes;
                    if (nodeName === Shape.IMAGE) {
                        var src = attributes.src, keepAspectRatio = attributes.keepAspectRatio;
                        imagePool.getImageSync(src, object, function(_ref) {
                            var _ref$img = _ref.img, width = _ref$img.width, height = _ref$img.height;
                            if (keepAspectRatio) calculateWithAspectRatio(object, width, height);
                            object.dirty();
                            renderingService.dirty();
                        });
                    }
                };
                var handleAttributeChanged = function handleAttributeChanged(e) {
                    var object = e.target;
                    var attrName = e.attrName, prevValue = e.prevValue, newValue = e.newValue;
                    if (object.nodeName !== Shape.IMAGE || attrName !== 'src') return;
                    if (prevValue !== newValue) imagePool.releaseImage(prevValue, object);
                    if ((0, $kVcyu.default)(newValue)) imagePool.getOrCreateImage(newValue, object).then(function(_ref2) {
                        var _ref2$img = _ref2.img, width = _ref2$img.width, height = _ref2$img.height;
                        if (object.attributes.keepAspectRatio) calculateWithAspectRatio(object, width, height);
                        object.dirty();
                        renderingService.dirty();
                    })["catch"](function() {
                    //
                    });
                };
                renderingService.hooks.init.tap(LoadImagePlugin.tag, function() {
                    canvas.addEventListener(ElementEvent.MOUNTED, handleMounted);
                    canvas.addEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);
                });
                renderingService.hooks.destroy.tap(LoadImagePlugin.tag, function() {
                    canvas.removeEventListener(ElementEvent.MOUNTED, handleMounted);
                    canvas.removeEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);
                });
            }
        }
    ]);
}();
LoadImagePlugin.tag = 'LoadImage';
var Plugin$3 = /*#__PURE__*/ function(_AbstractRendererPlug) {
    function Plugin() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Plugin);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Plugin, [].concat(args));
        _this.name = 'image-loader';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Plugin, _AbstractRendererPlug);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Plugin, [
        {
            key: "init",
            value: function init(runtime) {
                // @ts-ignore
                this.context.imagePool = new ImagePool(this.context, runtime);
                this.addRenderingPlugin(new LoadImagePlugin());
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.removeAllRenderingPlugins();
            }
        }
    ]);
}(AbstractRendererPlugin);
var index$3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ImagePool: ImagePool,
    Plugin: Plugin$3
});
var CANVAS_CAMERA_ID = 'g-canvas-camera';
var HTMLRenderingPlugin = /*#__PURE__*/ function() {
    function HTMLRenderingPlugin() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, HTMLRenderingPlugin);
        this.displayObjectHTMLElementMap = new WeakMap();
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(HTMLRenderingPlugin, [
        {
            key: "joinTransformMatrix",
            value: /**
     * ! The reason for adding `offset` is that the `transform-origin` coordinate system of DOM is the local coordinate system of the element, while the `transform-origin` coordinate system of canvas drawing is the local coordinate system of the element's parent element. At the same time, the `transform` attribute value of the DOM element does not include `transform-origin`.
     */ function joinTransformMatrix(matrix) {
                var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [
                    0,
                    0,
                    0
                ];
                return "matrix(".concat([
                    matrix[0],
                    matrix[1],
                    matrix[4],
                    matrix[5],
                    matrix[12] + offset[0],
                    matrix[13] + offset[1]
                ].join(','), ")");
            }
        },
        {
            key: "apply",
            value: function apply(context, runtime) {
                var _this = this;
                var camera = context.camera, renderingContext = context.renderingContext, renderingService = context.renderingService;
                this.context = context;
                var canvas = renderingContext.root.ownerDocument.defaultView;
                var nativeHTMLMap = canvas.context.eventService.nativeHTMLMap;
                var setTransform = function setTransform(object, $el) {
                    $el.style.transform = _this.joinTransformMatrix(object.getWorldTransform(), object.getOrigin());
                };
                var handleMounted = function handleMounted(e) {
                    var object = e.target;
                    if (object.nodeName === Shape.HTML) {
                        if (!_this.$camera) _this.$camera = _this.createCamera(camera);
                        // create DOM element
                        var $el = _this.getOrCreateEl(object);
                        _this.$camera.appendChild($el);
                        Object.keys(object.attributes).forEach(function(name) {
                            _this.updateAttribute(name, object);
                        });
                        setTransform(object, $el);
                        nativeHTMLMap.set($el, object);
                    }
                };
                var handleUnmounted = function handleUnmounted(e) {
                    var object = e.target;
                    if (object.nodeName === Shape.HTML && _this.$camera) {
                        var $el = _this.getOrCreateEl(object);
                        if ($el) {
                            $el.remove();
                            nativeHTMLMap["delete"]($el);
                        }
                    }
                };
                var handleAttributeChanged = function handleAttributeChanged(e) {
                    var object = e.target;
                    if (object.nodeName === Shape.HTML) {
                        var attrName = e.attrName;
                        _this.updateAttribute(attrName, object);
                    }
                };
                var handleBoundsChanged = function handleBoundsChanged(e) {
                    var records = e.detail;
                    for(var i = 0; i < records.length; i++){
                        var record = records[i];
                        var object = record.target;
                        var nodes = object.nodeName === Shape.FRAGMENT ? object.childNodes : [
                            object
                        ];
                        nodes.forEach(function(node) {
                            if (node.nodeName === Shape.HTML) {
                                var $el = _this.getOrCreateEl(node);
                                setTransform(node, $el);
                            }
                        });
                    }
                };
                var handleCanvasResize = function handleCanvasResize() {
                    if (_this.$camera) {
                        var _this$context$config = _this.context.config, width = _this$context$config.width, height = _this$context$config.height;
                        _this.$camera.parentElement.style.width = "".concat(width || 0, "px");
                        _this.$camera.parentElement.style.height = "".concat(height || 0, "px");
                    }
                };
                renderingService.hooks.init.tap(HTMLRenderingPlugin.tag, function() {
                    canvas.addEventListener(CanvasEvent.RESIZE, handleCanvasResize);
                    canvas.addEventListener(ElementEvent.MOUNTED, handleMounted);
                    canvas.addEventListener(ElementEvent.UNMOUNTED, handleUnmounted);
                    canvas.addEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);
                    canvas.addEventListener(ElementEvent.BOUNDS_CHANGED, handleBoundsChanged);
                });
                renderingService.hooks.endFrame.tap(HTMLRenderingPlugin.tag, function() {
                    if (_this.$camera && renderingContext.renderReasons.has(RenderReason.CAMERA_CHANGED)) _this.$camera.style.transform = _this.joinTransformMatrix(camera.getOrthoMatrix());
                });
                renderingService.hooks.destroy.tap(HTMLRenderingPlugin.tag, function() {
                    // remove camera
                    if (_this.$camera) _this.$camera.remove();
                    canvas.removeEventListener(CanvasEvent.RESIZE, handleCanvasResize);
                    canvas.removeEventListener(ElementEvent.MOUNTED, handleMounted);
                    canvas.removeEventListener(ElementEvent.UNMOUNTED, handleUnmounted);
                    canvas.removeEventListener(ElementEvent.ATTR_MODIFIED, handleAttributeChanged);
                    canvas.removeEventListener(ElementEvent.BOUNDS_CHANGED, handleBoundsChanged);
                });
            }
        },
        {
            key: "createCamera",
            value: function createCamera(camera) {
                var _this$context$config2 = this.context.config, doc = _this$context$config2.document, width = _this$context$config2.width, height = _this$context$config2.height;
                var $canvas = this.context.contextService.getDomElement();
                var $container = $canvas.parentNode;
                if ($container) {
                    var cameraId = CANVAS_CAMERA_ID;
                    var $existedCamera = $container.querySelector("#".concat(cameraId));
                    if (!$existedCamera) {
                        // fix @see https://github.com/antvis/G/issues/1702
                        var $cameraContainer = (doc || document).createElement('div');
                        // HTML elements should not overflow with canvas @see https://github.com/antvis/G/issues/1163
                        $cameraContainer.style.overflow = 'hidden';
                        $cameraContainer.style.pointerEvents = 'none';
                        $cameraContainer.style.position = 'absolute';
                        $cameraContainer.style.left = "0px";
                        $cameraContainer.style.top = "0px";
                        $cameraContainer.style.width = "".concat(width || 0, "px");
                        $cameraContainer.style.height = "".concat(height || 0, "px");
                        var $camera = (doc || document).createElement('div');
                        $existedCamera = $camera;
                        $camera.id = cameraId;
                        // use absolute position
                        $camera.style.position = 'absolute';
                        // account for DOM element's offset @see https://github.com/antvis/G/issues/1150
                        $camera.style.left = "".concat($canvas.offsetLeft || 0, "px");
                        $camera.style.top = "".concat($canvas.offsetTop || 0, "px");
                        $camera.style.transformOrigin = 'left top';
                        $camera.style.transform = this.joinTransformMatrix(camera.getOrthoMatrix());
                        $camera.style.pointerEvents = 'none';
                        $camera.style.width = "100%";
                        $camera.style.height = "100%";
                        $cameraContainer.appendChild($camera);
                        $container.appendChild($cameraContainer);
                    }
                    return $existedCamera;
                }
                return null;
            }
        },
        {
            key: "getOrCreateEl",
            value: function getOrCreateEl(object) {
                var doc = this.context.config.document;
                var $existedElement = this.displayObjectHTMLElementMap.get(object);
                if (!$existedElement) {
                    $existedElement = (doc || document).createElement('div');
                    object.parsedStyle.$el = $existedElement;
                    this.displayObjectHTMLElementMap.set(object, $existedElement);
                    if (object.id) $existedElement.id = object.id;
                    if (object.name) $existedElement.setAttribute('name', object.name);
                    if (object.className) $existedElement.className = object.className;
                    // use absolute position
                    $existedElement.style.position = 'absolute';
                    // @see https://github.com/antvis/G/issues/1150
                    $existedElement.style['will-change'] = 'transform';
                    $existedElement.style.transform = this.joinTransformMatrix(object.getWorldTransform(), object.getOrigin());
                }
                return $existedElement;
            }
        },
        {
            key: "updateAttribute",
            value: function updateAttribute(name, object) {
                var $el = this.getOrCreateEl(object);
                switch(name){
                    case 'innerHTML':
                        var innerHTML = object.parsedStyle.innerHTML;
                        if ((0, $kVcyu.default)(innerHTML)) $el.innerHTML = innerHTML;
                        else {
                            $el.innerHTML = '';
                            $el.appendChild(innerHTML);
                        }
                        break;
                    case 'x':
                        $el.style.left = "".concat(object.parsedStyle.x, "px");
                        break;
                    case 'y':
                        $el.style.top = "".concat(object.parsedStyle.y, "px");
                        break;
                    case 'transformOrigin':
                        var transformOrigin = object.parsedStyle.transformOrigin;
                        $el.style['transform-origin'] = "".concat(transformOrigin[0].buildCSSText(null, null, ''), " ").concat(transformOrigin[1].buildCSSText(null, null, ''));
                        break;
                    case 'width':
                        var width = object.parsedStyle.width;
                        $el.style.width = (0, $jyI49.default)(width) ? "".concat(width, "px") : width.toString();
                        break;
                    case 'height':
                        var height = object.parsedStyle.height;
                        $el.style.height = (0, $jyI49.default)(height) ? "".concat(height, "px") : height.toString();
                        break;
                    case 'zIndex':
                        var zIndex = object.parsedStyle.zIndex;
                        $el.style['z-index'] = "".concat(zIndex);
                        break;
                    case 'visibility':
                        var visibility = object.parsedStyle.visibility;
                        $el.style.visibility = visibility;
                        break;
                    case 'pointerEvents':
                        var _object$parsedStyle$p = object.parsedStyle.pointerEvents, pointerEvents = _object$parsedStyle$p === void 0 ? 'auto' : _object$parsedStyle$p;
                        $el.style.pointerEvents = pointerEvents;
                        break;
                    case 'opacity':
                        var opacity = object.parsedStyle.opacity;
                        $el.style.opacity = "".concat(opacity);
                        break;
                    case 'fill':
                        var fill = object.parsedStyle.fill;
                        var color = '';
                        if (isCSSRGB(fill)) {
                            if (fill.isNone) color = 'transparent';
                            else color = object.getAttribute('fill');
                        } else if (Array.isArray(fill)) color = object.getAttribute('fill');
                        else isPattern(fill);
                        $el.style.background = color;
                        break;
                    case 'stroke':
                        var stroke = object.parsedStyle.stroke;
                        var borderColor = '';
                        if (isCSSRGB(stroke)) {
                            if (stroke.isNone) borderColor = 'transparent';
                            else borderColor = object.getAttribute('stroke');
                        } else if (Array.isArray(stroke)) borderColor = object.getAttribute('stroke');
                        else isPattern(stroke);
                        $el.style['border-color'] = borderColor;
                        $el.style['border-style'] = 'solid';
                        break;
                    case 'lineWidth':
                        var lineWidth = object.parsedStyle.lineWidth;
                        $el.style['border-width'] = "".concat(lineWidth || 0, "px");
                        break;
                    case 'lineDash':
                        $el.style['border-style'] = 'dashed';
                        break;
                    case 'filter':
                        var filter = object.style.filter;
                        $el.style.filter = filter;
                        break;
                    default:
                        if (!(0, $geZBG.default)(object.style[name]) && object.style[name] !== '') $el.style[name] = object.style[name];
                }
            }
        }
    ]);
}();
HTMLRenderingPlugin.tag = 'HTMLRendering';
var Plugin$2 = /*#__PURE__*/ function(_AbstractRendererPlug) {
    function Plugin() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Plugin);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Plugin, [].concat(args));
        _this.name = 'html-renderer';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Plugin, _AbstractRendererPlug);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Plugin, [
        {
            key: "init",
            value: function init() {
                this.addRenderingPlugin(new HTMLRenderingPlugin());
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.removeAllRenderingPlugins();
            }
        }
    ]);
}(AbstractRendererPlugin);
var index$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Plugin: Plugin$2
});
// const MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
/**
 * listen to mouse/touch/pointer events on DOM wrapper, trigger pointer events
 */ var DOMInteractionPlugin = /*#__PURE__*/ function() {
    function DOMInteractionPlugin() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DOMInteractionPlugin);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DOMInteractionPlugin, [
        {
            key: "apply",
            value: function apply(context, runtime) {
                var _this = this;
                var renderingService = context.renderingService, renderingContext = context.renderingContext, config = context.config;
                this.context = context;
                var canvas = renderingContext.root.ownerDocument.defaultView;
                // const SUPPORT_ONLY_TOUCH = canvas.supportsTouchEvents && MOBILE_REGEX.test(navigator.userAgent);
                var onPointerMove = function onPointerMove(ev) {
                    renderingService.hooks.pointerMove.call(ev);
                };
                var onPointerUp = function onPointerUp(ev) {
                    renderingService.hooks.pointerUp.call(ev);
                };
                var onPointerDown = function onPointerDown(ev) {
                    renderingService.hooks.pointerDown.call(ev);
                };
                var onPointerOver = function onPointerOver(ev) {
                    renderingService.hooks.pointerOver.call(ev);
                };
                var onPointerOut = function onPointerOut(ev) {
                    renderingService.hooks.pointerOut.call(ev);
                };
                var onPointerCancel = function onPointerCancel(ev) {
                    renderingService.hooks.pointerCancel.call(ev);
                };
                var onPointerWheel = function onPointerWheel(ev) {
                    renderingService.hooks.pointerWheel.call(ev);
                };
                var onClick = function onClick(ev) {
                    renderingService.hooks.click.call(ev);
                };
                var addPointerEventListener = function addPointerEventListener($el) {
                    runtime.globalThis.document.addEventListener('pointermove', onPointerMove, true);
                    $el.addEventListener('pointerdown', onPointerDown, true);
                    $el.addEventListener('pointerleave', onPointerOut, true);
                    $el.addEventListener('pointerover', onPointerOver, true);
                    runtime.globalThis.addEventListener('pointerup', onPointerUp, true);
                    runtime.globalThis.addEventListener('pointercancel', onPointerCancel, true);
                };
                var addTouchEventListener = function addTouchEventListener($el) {
                    $el.addEventListener('touchstart', onPointerDown, true);
                    $el.addEventListener('touchend', onPointerUp, true);
                    $el.addEventListener('touchmove', onPointerMove, true);
                    $el.addEventListener('touchcancel', onPointerCancel, true);
                };
                var addMouseEventListener = function addMouseEventListener($el) {
                    runtime.globalThis.document.addEventListener('mousemove', onPointerMove, true);
                    $el.addEventListener('mousedown', onPointerDown, true);
                    $el.addEventListener('mouseout', onPointerOut, true);
                    $el.addEventListener('mouseover', onPointerOver, true);
                    runtime.globalThis.addEventListener('mouseup', onPointerUp, true);
                };
                var removePointerEventListener = function removePointerEventListener($el) {
                    runtime.globalThis.document.removeEventListener('pointermove', onPointerMove, true);
                    $el.removeEventListener('pointerdown', onPointerDown, true);
                    $el.removeEventListener('pointerleave', onPointerOut, true);
                    $el.removeEventListener('pointerover', onPointerOver, true);
                    runtime.globalThis.removeEventListener('pointerup', onPointerUp, true);
                    runtime.globalThis.removeEventListener('pointercancel', onPointerCancel, true);
                };
                var removeTouchEventListener = function removeTouchEventListener($el) {
                    $el.removeEventListener('touchstart', onPointerDown, true);
                    $el.removeEventListener('touchend', onPointerUp, true);
                    $el.removeEventListener('touchmove', onPointerMove, true);
                    $el.removeEventListener('touchcancel', onPointerCancel, true);
                };
                var removeMouseEventListener = function removeMouseEventListener($el) {
                    runtime.globalThis.document.removeEventListener('mousemove', onPointerMove, true);
                    $el.removeEventListener('mousedown', onPointerDown, true);
                    $el.removeEventListener('mouseout', onPointerOut, true);
                    $el.removeEventListener('mouseover', onPointerOver, true);
                    runtime.globalThis.removeEventListener('mouseup', onPointerUp, true);
                };
                renderingService.hooks.init.tap(DOMInteractionPlugin.tag, function() {
                    var $el = _this.context.contextService.getDomElement();
                    // @ts-ignore
                    if (runtime.globalThis.navigator.msPointerEnabled) {
                        // @ts-ignore
                        $el.style.msContentZooming = 'none';
                        // @ts-ignore
                        $el.style.msTouchAction = 'none';
                    } else if (canvas.supportsPointerEvents) $el.style.touchAction = 'none';
                    if (canvas.supportsPointerEvents) addPointerEventListener($el);
                    else addMouseEventListener($el);
                    if (canvas.supportsTouchEvents) addTouchEventListener($el);
                    if (config.useNativeClickEvent) $el.addEventListener('click', onClick, true);
                    // use passive event listeners
                    // @see https://zhuanlan.zhihu.com/p/24555031
                    $el.addEventListener('wheel', onPointerWheel, {
                        passive: true,
                        capture: true
                    });
                });
                renderingService.hooks.destroy.tap(DOMInteractionPlugin.tag, function() {
                    var $el = _this.context.contextService.getDomElement();
                    // @ts-ignore
                    if (runtime.globalThis.navigator.msPointerEnabled) {
                        // @ts-ignore
                        $el.style.msContentZooming = '';
                        // @ts-ignore
                        $el.style.msTouchAction = '';
                    } else if (canvas.supportsPointerEvents) $el.style.touchAction = '';
                    if (canvas.supportsPointerEvents) removePointerEventListener($el);
                    else removeMouseEventListener($el);
                    if (canvas.supportsTouchEvents) removeTouchEventListener($el);
                    if (config.useNativeClickEvent) $el.removeEventListener('click', onClick, true);
                    $el.removeEventListener('wheel', onPointerWheel, true);
                });
            }
        }
    ]);
}();
DOMInteractionPlugin.tag = 'DOMInteraction';
var Plugin$1 = /*#__PURE__*/ function(_AbstractRendererPlug) {
    function Plugin() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Plugin);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Plugin, [].concat(args));
        _this.name = 'dom-interaction';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Plugin, _AbstractRendererPlug);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Plugin, [
        {
            key: "init",
            value: function init() {
                this.addRenderingPlugin(new DOMInteractionPlugin());
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.removeAllRenderingPlugins();
            }
        }
    ]);
}(AbstractRendererPlugin);
var index$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Plugin: Plugin$1
});
/**
 * listen to mouse/touch/pointer events on DOM wrapper, trigger pointer events
 */ var MobileInteractionPlugin = /*#__PURE__*/ function() {
    function MobileInteractionPlugin() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, MobileInteractionPlugin);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(MobileInteractionPlugin, [
        {
            key: "apply",
            value: function apply(context) {
                var renderingService = context.renderingService, contextService = context.contextService, config = context.config;
                // 获取小程序上下文
                var canvasEl = contextService.getDomElement();
                var onPointerDown = function onPointerDown(ev) {
                    renderingService.hooks.pointerDown.call(ev);
                };
                var onPointerUp = function onPointerUp(ev) {
                    renderingService.hooks.pointerUp.call(ev);
                };
                var onPointerMove = function onPointerMove(ev) {
                    // 触发 G 定义的标准 pointerMove 事件
                    renderingService.hooks.pointerMove.call(ev);
                };
                var onPointerOver = function onPointerOver(ev) {
                    renderingService.hooks.pointerOver.call(ev);
                };
                var onPointerOut = function onPointerOut(ev) {
                    renderingService.hooks.pointerOut.call(ev);
                };
                var onClick = function onClick(ev) {
                    renderingService.hooks.click.call(ev);
                };
                var onPointerCancel = function onPointerCancel(ev) {
                    renderingService.hooks.pointerCancel.call(ev);
                };
                renderingService.hooks.init.tap(MobileInteractionPlugin.tag, function() {
                    // 基于小程序上下文的事件监听方式，绑定事件监听，可以参考下面基于 DOM 的方式
                    canvasEl.addEventListener('touchstart', onPointerDown, true);
                    canvasEl.addEventListener('touchend', onPointerUp, true);
                    canvasEl.addEventListener('touchmove', onPointerMove, true);
                    canvasEl.addEventListener('touchcancel', onPointerCancel, true);
                    // FIXME: 这里不应该只在 canvasEl 上监听 mousemove 和 mouseup，而应该在更高层级的节点上例如 document 监听。
                    // 否则无法判断是否移出了 canvasEl
                    // canvasEl.addEventListener('mousemove', onPointerMove, true);
                    // canvasEl.addEventListener('mousedown', onPointerDown, true);
                    canvasEl.addEventListener('mouseout', onPointerOut, true);
                    canvasEl.addEventListener('mouseover', onPointerOver, true);
                    // canvasEl.addEventListener('mouseup', onPointerUp, true);
                    if (config.useNativeClickEvent) canvasEl.addEventListener('click', onClick, true);
                });
                renderingService.hooks.destroy.tap(MobileInteractionPlugin.tag, function() {
                    // 基于小程序上下文的事件监听方式，移除事件监听
                    canvasEl.removeEventListener('touchstart', onPointerDown, true);
                    canvasEl.removeEventListener('touchend', onPointerUp, true);
                    canvasEl.removeEventListener('touchmove', onPointerMove, true);
                    canvasEl.removeEventListener('touchcancel', onPointerCancel, true);
                    // canvasEl.removeEventListener('mousemove', onPointerMove, true);
                    // canvasEl.removeEventListener('mousedown', onPointerDown, true);
                    canvasEl.removeEventListener('mouseout', onPointerOut, true);
                    canvasEl.removeEventListener('mouseover', onPointerOver, true);
                    // canvasEl.removeEventListener('mouseup', onPointerUp, true);
                    if (config.useNativeClickEvent) canvasEl.removeEventListener('click', onClick, true);
                });
            }
        }
    ]);
}();
MobileInteractionPlugin.tag = 'MobileInteraction';
var Plugin = /*#__PURE__*/ function(_AbstractRendererPlug) {
    function Plugin() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Plugin);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Plugin, [].concat(args));
        _this.name = 'mobile-interaction';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Plugin, _AbstractRendererPlug);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Plugin, [
        {
            key: "init",
            value: function init() {
                this.addRenderingPlugin(new MobileInteractionPlugin());
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.removeAllRenderingPlugins();
            }
        }
    ]);
}(AbstractRendererPlugin);
var index = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Plugin: Plugin
});

});
parcelRegister("cbdLd", function(module, exports) {

var $g5Zhu = parcelRequire("g5Zhu");
function $8de12fa6a893dcd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8de12fa6a893dcd1$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8de12fa6a893dcd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $g5Zhu(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8de12fa6a893dcd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
module.exports = $8de12fa6a893dcd1$var$_objectSpread2, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fUHKi", function(module, exports) {

var $5F6pO = parcelRequire("5F6pO");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $8UrHA = parcelRequire("8UrHA");
function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $5F6pO(r) || $hAHB6(r) || $72a6v(r) || $8UrHA();
}
module.exports = $b95e04f2d4c66124$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5F6pO", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2zZPz(r);
}
module.exports = $41f5c206613f56c9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hAHB6", function(module, exports) {
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cce79e023a3a67e7$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8UrHA", function(module, exports) {
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $67c90abe6042aecd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jLNr1", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");

var $5HCVq = parcelRequire("5HCVq");

var $eN9hz = parcelRequire("eN9hz");
function $e648c0dacb12c5b2$var$_callSuper(t, o, e) {
    return o = $cGTaw(o), $eN9hz(t, $5HCVq() ? Reflect.construct(o, e || [], $cGTaw(t).constructor) : o.apply(t, e));
}
module.exports = $e648c0dacb12c5b2$var$_callSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5HCVq", function(module, exports) {
function $426f299ee58329c3$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $426f299ee58329c3$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(t);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aAhot(t, e);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3vRz3", function(module, exports) {
'use strict';
var $28edd11f6c7e9f5f$var$has = Object.prototype.hasOwnProperty, $28edd11f6c7e9f5f$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $28edd11f6c7e9f5f$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $28edd11f6c7e9f5f$var$Events().__proto__) $28edd11f6c7e9f5f$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $28edd11f6c7e9f5f$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $28edd11f6c7e9f5f$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $28edd11f6c7e9f5f$var$EE(fn, context || emitter, once), evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $28edd11f6c7e9f5f$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $28edd11f6c7e9f5f$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $28edd11f6c7e9f5f$var$EventEmitter() {
    this._events = new $28edd11f6c7e9f5f$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($28edd11f6c7e9f5f$var$has.call(events, name)) names.push($28edd11f6c7e9f5f$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $28edd11f6c7e9f5f$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $28edd11f6c7e9f5f$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $28edd11f6c7e9f5f$var$prefix ? $28edd11f6c7e9f5f$var$prefix + event : event;
        if (this._events[evt]) $28edd11f6c7e9f5f$var$clearEvent(this, evt);
    } else {
        this._events = new $28edd11f6c7e9f5f$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$28edd11f6c7e9f5f$var$EventEmitter.prototype.off = $28edd11f6c7e9f5f$var$EventEmitter.prototype.removeListener;
$28edd11f6c7e9f5f$var$EventEmitter.prototype.addListener = $28edd11f6c7e9f5f$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$28edd11f6c7e9f5f$var$EventEmitter.prefixed = $28edd11f6c7e9f5f$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$28edd11f6c7e9f5f$var$EventEmitter.EventEmitter = $28edd11f6c7e9f5f$var$EventEmitter;
module.exports = $28edd11f6c7e9f5f$var$EventEmitter;

});

parcelRegister("bDSmI", function(module, exports) {

$parcel$export(module.exports, "create", () => $879d8210211d0bfa$export$185802fd694ee1f5);
$parcel$export(module.exports, "fromMat4", () => $879d8210211d0bfa$export$b4ad467060d346fe);
$parcel$export(module.exports, "clone", () => $879d8210211d0bfa$export$9cd59f9826255e47);
$parcel$export(module.exports, "copy", () => $879d8210211d0bfa$export$784d13d8ee351f07);
$parcel$export(module.exports, "fromValues", () => $879d8210211d0bfa$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "set", () => $879d8210211d0bfa$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "identity", () => $879d8210211d0bfa$export$f0954fd7d5368655);
$parcel$export(module.exports, "transpose", () => $879d8210211d0bfa$export$9cb09a71b7d66923);
$parcel$export(module.exports, "invert", () => $879d8210211d0bfa$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "adjoint", () => $879d8210211d0bfa$export$33f3c024b4ae00a1);
$parcel$export(module.exports, "determinant", () => $879d8210211d0bfa$export$a04698f914c55ed9);
$parcel$export(module.exports, "multiply", () => $879d8210211d0bfa$export$2060d2db72cce88f);
$parcel$export(module.exports, "translate", () => $879d8210211d0bfa$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "rotate", () => $879d8210211d0bfa$export$bb628a54ab399bc9);
$parcel$export(module.exports, "scale", () => $879d8210211d0bfa$export$dcdf75081b88279d);
$parcel$export(module.exports, "fromTranslation", () => $879d8210211d0bfa$export$bc9e79e74e9fddf6);
$parcel$export(module.exports, "fromRotation", () => $879d8210211d0bfa$export$926fc125ff3c666c);
$parcel$export(module.exports, "fromScaling", () => $879d8210211d0bfa$export$832ca188ffb1955d);
$parcel$export(module.exports, "fromMat2d", () => $879d8210211d0bfa$export$68f5977575fae9bf);
$parcel$export(module.exports, "fromQuat", () => $879d8210211d0bfa$export$2ff2bbe382249af7);
$parcel$export(module.exports, "normalFromMat4", () => $879d8210211d0bfa$export$966b25ab6dc1b1f9);
$parcel$export(module.exports, "projection", () => $879d8210211d0bfa$export$b74061472fe7c07);
$parcel$export(module.exports, "str", () => $879d8210211d0bfa$export$42d51816ce590c93);
$parcel$export(module.exports, "frob", () => $879d8210211d0bfa$export$326827e8268e9cdb);
$parcel$export(module.exports, "add", () => $879d8210211d0bfa$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $879d8210211d0bfa$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiplyScalar", () => $879d8210211d0bfa$export$c697bed75648cdb7);
$parcel$export(module.exports, "multiplyScalarAndAdd", () => $879d8210211d0bfa$export$553579f63bdd7137);
$parcel$export(module.exports, "exactEquals", () => $879d8210211d0bfa$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $879d8210211d0bfa$export$e9bab7fafb253603);
$parcel$export(module.exports, "mul", () => $879d8210211d0bfa$export$6e3a27864ab166fe);
$parcel$export(module.exports, "sub", () => $879d8210211d0bfa$export$f93b5905241a7cca);

var $amnUE = parcelRequire("amnUE");
function $879d8210211d0bfa$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(9);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[5] = 0;
        out[6] = 0;
        out[7] = 0;
    }
    out[0] = 1;
    out[4] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$b4ad467060d346fe(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
}
function $879d8210211d0bfa$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$a82be99ed2a44a7d(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    var out = new $amnUE.ARRAY_TYPE(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$adaa4cf7ef1b65be(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
}
function $879d8210211d0bfa$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    return out;
}
function $879d8210211d0bfa$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b01 = a22 * a11 - a12 * a21;
    var b11 = -a22 * a10 + a12 * a20;
    var b21 = a21 * a10 - a11 * a20;
    // Calculate the determinant
    var det = a00 * b01 + a01 * b11 + a02 * b21;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
}
function $879d8210211d0bfa$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    out[0] = a11 * a22 - a12 * a21;
    out[1] = a02 * a21 - a01 * a22;
    out[2] = a01 * a12 - a02 * a11;
    out[3] = a12 * a20 - a10 * a22;
    out[4] = a00 * a22 - a02 * a20;
    out[5] = a02 * a10 - a00 * a12;
    out[6] = a10 * a21 - a11 * a20;
    out[7] = a01 * a20 - a00 * a21;
    out[8] = a00 * a11 - a01 * a10;
    return out;
}
function $879d8210211d0bfa$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
}
function $879d8210211d0bfa$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2];
    var a10 = a[3], a11 = a[4], a12 = a[5];
    var a20 = a[6], a21 = a[7], a22 = a[8];
    var b00 = b[0], b01 = b[1], b02 = b[2];
    var b10 = b[3], b11 = b[4], b12 = b[5];
    var b20 = b[6], b21 = b[7], b22 = b[8];
    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;
    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;
    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
}
function $879d8210211d0bfa$export$d73ee8ef04f5226a(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], x = v[0], y = v[1];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a10;
    out[4] = a11;
    out[5] = a12;
    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
}
function $879d8210211d0bfa$export$bb628a54ab399bc9(out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a10 = a[3], a11 = a[4], a12 = a[5], a20 = a[6], a21 = a[7], a22 = a[8], s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;
    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;
    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
}
function $879d8210211d0bfa$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1];
    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];
    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
}
function $879d8210211d0bfa$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$926fc125ff3c666c(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = -s;
    out[4] = c;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$68f5977575fae9bf(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;
    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;
    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;
    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;
    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;
    return out;
}
function $879d8210211d0bfa$export$966b25ab6dc1b1f9(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    return out;
}
function $879d8210211d0bfa$export$b74061472fe7c07(out, width, height) {
    out[0] = 2 / width;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = -2 / height;
    out[5] = 0;
    out[6] = -1;
    out[7] = 1;
    out[8] = 1;
    return out;
}
function $879d8210211d0bfa$export$42d51816ce590c93(a) {
    return "mat3(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ")";
}
function $879d8210211d0bfa$export$326827e8268e9cdb(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3] + a[4] * a[4] + a[5] * a[5] + a[6] * a[6] + a[7] * a[7] + a[8] * a[8]);
}
function $879d8210211d0bfa$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
}
function $879d8210211d0bfa$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
}
function $879d8210211d0bfa$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
}
function $879d8210211d0bfa$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    return out;
}
function $879d8210211d0bfa$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
}
function $879d8210211d0bfa$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8));
}
var $879d8210211d0bfa$export$6e3a27864ab166fe = $879d8210211d0bfa$export$2060d2db72cce88f;
var $879d8210211d0bfa$export$f93b5905241a7cca = $879d8210211d0bfa$export$4e2d2ead65e5f7e3;

});
parcelRegister("amnUE", function(module, exports) {

$parcel$export(module.exports, "EPSILON", () => $78ae820aa9ececfa$export$fd293b15f47e270);
$parcel$export(module.exports, "ARRAY_TYPE", () => $78ae820aa9ececfa$export$b67359430d3b1b2);
$parcel$export(module.exports, "RANDOM", () => $78ae820aa9ececfa$export$5ada478c8a628231);
$parcel$export(module.exports, "ANGLE_ORDER", () => $78ae820aa9ececfa$export$217057687ee20298);
$parcel$export(module.exports, "round", () => $78ae820aa9ececfa$export$2077e0241d6afd3c);
/**
 * Common utilities
 * @module glMatrix
 */ // Configuration Constants
var $78ae820aa9ececfa$export$fd293b15f47e270 = 0.000001;
var $78ae820aa9ececfa$export$b67359430d3b1b2 = typeof Float32Array !== "undefined" ? Float32Array : Array;
var $78ae820aa9ececfa$export$5ada478c8a628231 = Math.random;
var $78ae820aa9ececfa$export$217057687ee20298 = "zyx";
function $78ae820aa9ececfa$export$2077e0241d6afd3c(a) {
    if (a >= 0) return Math.round(a);
    return a % 0.5 === 0 ? Math.floor(a) : Math.round(a);
}
function $78ae820aa9ececfa$export$cb2c0eb57f5e532c(type) {
    $78ae820aa9ececfa$export$b67359430d3b1b2 = type;
}
var $78ae820aa9ececfa$var$degree = Math.PI / 180;
var $78ae820aa9ececfa$var$radian = 180 / Math.PI;
function $78ae820aa9ececfa$export$408b8ee5959eefd5(a) {
    return a * $78ae820aa9ececfa$var$degree;
}
function $78ae820aa9ececfa$export$c796d9d3e501591f(a) {
    return a * $78ae820aa9ececfa$var$radian;
}
function $78ae820aa9ececfa$export$e9bab7fafb253603(a, b) {
    var tolerance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $78ae820aa9ececfa$export$fd293b15f47e270;
    return Math.abs(a - b) <= tolerance * Math.max(1, Math.abs(a), Math.abs(b));
}

});


parcelRegister("3iqbd", function(module, exports) {

$parcel$export(module.exports, "create", () => $26675c4f95835ef1$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $26675c4f95835ef1$export$9cd59f9826255e47);
$parcel$export(module.exports, "copy", () => $26675c4f95835ef1$export$784d13d8ee351f07);
$parcel$export(module.exports, "fromValues", () => $26675c4f95835ef1$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "set", () => $26675c4f95835ef1$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "identity", () => $26675c4f95835ef1$export$f0954fd7d5368655);
$parcel$export(module.exports, "transpose", () => $26675c4f95835ef1$export$9cb09a71b7d66923);
$parcel$export(module.exports, "invert", () => $26675c4f95835ef1$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "adjoint", () => $26675c4f95835ef1$export$33f3c024b4ae00a1);
$parcel$export(module.exports, "determinant", () => $26675c4f95835ef1$export$a04698f914c55ed9);
$parcel$export(module.exports, "multiply", () => $26675c4f95835ef1$export$2060d2db72cce88f);
$parcel$export(module.exports, "translate", () => $26675c4f95835ef1$export$d73ee8ef04f5226a);
$parcel$export(module.exports, "scale", () => $26675c4f95835ef1$export$dcdf75081b88279d);
$parcel$export(module.exports, "rotate", () => $26675c4f95835ef1$export$bb628a54ab399bc9);
$parcel$export(module.exports, "rotateX", () => $26675c4f95835ef1$export$a59c8716592e09af);
$parcel$export(module.exports, "rotateY", () => $26675c4f95835ef1$export$cf71e4d4ca4d1cfd);
$parcel$export(module.exports, "rotateZ", () => $26675c4f95835ef1$export$ea6eae3365de5b9c);
$parcel$export(module.exports, "fromTranslation", () => $26675c4f95835ef1$export$bc9e79e74e9fddf6);
$parcel$export(module.exports, "fromScaling", () => $26675c4f95835ef1$export$832ca188ffb1955d);
$parcel$export(module.exports, "fromRotation", () => $26675c4f95835ef1$export$926fc125ff3c666c);
$parcel$export(module.exports, "fromXRotation", () => $26675c4f95835ef1$export$dd47cc2f828c32ef);
$parcel$export(module.exports, "fromYRotation", () => $26675c4f95835ef1$export$7dc997d67d2b7f33);
$parcel$export(module.exports, "fromZRotation", () => $26675c4f95835ef1$export$ad5ddaedc8f405df);
$parcel$export(module.exports, "fromRotationTranslation", () => $26675c4f95835ef1$export$9545ac307f2a256b);
$parcel$export(module.exports, "fromQuat2", () => $26675c4f95835ef1$export$ff497f2be31cc6a);
$parcel$export(module.exports, "getTranslation", () => $26675c4f95835ef1$export$202e99f82f7f0395);
$parcel$export(module.exports, "getScaling", () => $26675c4f95835ef1$export$71dc54d92bd04b57);
$parcel$export(module.exports, "getRotation", () => $26675c4f95835ef1$export$df3937d3b537df0a);
$parcel$export(module.exports, "decompose", () => $26675c4f95835ef1$export$4e06b4a690896b27);
$parcel$export(module.exports, "fromRotationTranslationScale", () => $26675c4f95835ef1$export$ddf9c55c9f2be172);
$parcel$export(module.exports, "fromRotationTranslationScaleOrigin", () => $26675c4f95835ef1$export$1def1f860edc4b1f);
$parcel$export(module.exports, "fromQuat", () => $26675c4f95835ef1$export$2ff2bbe382249af7);
$parcel$export(module.exports, "frustum", () => $26675c4f95835ef1$export$89b5708c387cac6c);
$parcel$export(module.exports, "perspectiveNO", () => $26675c4f95835ef1$export$4cf19729ec9a96b8);
$parcel$export(module.exports, "perspective", () => $26675c4f95835ef1$export$541149539f3a4684);
$parcel$export(module.exports, "perspectiveZO", () => $26675c4f95835ef1$export$294bba99a6af0c0c);
$parcel$export(module.exports, "perspectiveFromFieldOfView", () => $26675c4f95835ef1$export$58ae211c788e338f);
$parcel$export(module.exports, "orthoNO", () => $26675c4f95835ef1$export$c5f65ef3eb668f27);
$parcel$export(module.exports, "ortho", () => $26675c4f95835ef1$export$4f2167e613cfc87b);
$parcel$export(module.exports, "orthoZO", () => $26675c4f95835ef1$export$b1d31ea7b4d854e);
$parcel$export(module.exports, "lookAt", () => $26675c4f95835ef1$export$d924e14fd6d9aa66);
$parcel$export(module.exports, "targetTo", () => $26675c4f95835ef1$export$aa67782f4dc9e52c);
$parcel$export(module.exports, "str", () => $26675c4f95835ef1$export$42d51816ce590c93);
$parcel$export(module.exports, "frob", () => $26675c4f95835ef1$export$326827e8268e9cdb);
$parcel$export(module.exports, "add", () => $26675c4f95835ef1$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $26675c4f95835ef1$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiplyScalar", () => $26675c4f95835ef1$export$c697bed75648cdb7);
$parcel$export(module.exports, "multiplyScalarAndAdd", () => $26675c4f95835ef1$export$553579f63bdd7137);
$parcel$export(module.exports, "exactEquals", () => $26675c4f95835ef1$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $26675c4f95835ef1$export$e9bab7fafb253603);
$parcel$export(module.exports, "mul", () => $26675c4f95835ef1$export$6e3a27864ab166fe);
$parcel$export(module.exports, "sub", () => $26675c4f95835ef1$export$f93b5905241a7cca);

var $amnUE = parcelRequire("amnUE");
function $26675c4f95835ef1$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(16);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
        out[4] = 0;
        out[6] = 0;
        out[7] = 0;
        out[8] = 0;
        out[9] = 0;
        out[11] = 0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
    }
    out[0] = 1;
    out[5] = 1;
    out[10] = 1;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$a82be99ed2a44a7d(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new $amnUE.ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $26675c4f95835ef1$export$adaa4cf7ef1b65be(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
}
function $26675c4f95835ef1$export$f0954fd7d5368655(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9cb09a71b7d66923(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3];
        var a12 = a[6], a13 = a[7];
        var a23 = a[11];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$6897c284b6f9f4dc(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    // Calculate the determinant
    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
    if (!det) return null;
    det = 1.0 / det;
    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
    return out;
}
function $26675c4f95835ef1$export$33f3c024b4ae00a1(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b00 = a00 * a11 - a01 * a10;
    var b01 = a00 * a12 - a02 * a10;
    var b02 = a00 * a13 - a03 * a10;
    var b03 = a01 * a12 - a02 * a11;
    var b04 = a01 * a13 - a03 * a11;
    var b05 = a02 * a13 - a03 * a12;
    var b06 = a20 * a31 - a21 * a30;
    var b07 = a20 * a32 - a22 * a30;
    var b08 = a20 * a33 - a23 * a30;
    var b09 = a21 * a32 - a22 * a31;
    var b10 = a21 * a33 - a23 * a31;
    var b11 = a22 * a33 - a23 * a32;
    out[0] = a11 * b11 - a12 * b10 + a13 * b09;
    out[1] = a02 * b10 - a01 * b11 - a03 * b09;
    out[2] = a31 * b05 - a32 * b04 + a33 * b03;
    out[3] = a22 * b04 - a21 * b05 - a23 * b03;
    out[4] = a12 * b08 - a10 * b11 - a13 * b07;
    out[5] = a00 * b11 - a02 * b08 + a03 * b07;
    out[6] = a32 * b02 - a30 * b05 - a33 * b01;
    out[7] = a20 * b05 - a22 * b02 + a23 * b01;
    out[8] = a10 * b10 - a11 * b08 + a13 * b06;
    out[9] = a01 * b08 - a00 * b10 - a03 * b06;
    out[10] = a30 * b04 - a31 * b02 + a33 * b00;
    out[11] = a21 * b02 - a20 * b04 - a23 * b00;
    out[12] = a11 * b07 - a10 * b09 - a12 * b06;
    out[13] = a00 * b09 - a01 * b07 + a02 * b06;
    out[14] = a31 * b01 - a30 * b03 - a32 * b00;
    out[15] = a20 * b03 - a21 * b01 + a22 * b00;
    return out;
}
function $26675c4f95835ef1$export$a04698f914c55ed9(a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    var b0 = a00 * a11 - a01 * a10;
    var b1 = a00 * a12 - a02 * a10;
    var b2 = a01 * a12 - a02 * a11;
    var b3 = a20 * a31 - a21 * a30;
    var b4 = a20 * a32 - a22 * a30;
    var b5 = a21 * a32 - a22 * a31;
    var b6 = a00 * b5 - a01 * b4 + a02 * b3;
    var b7 = a10 * b5 - a11 * b4 + a12 * b3;
    var b8 = a20 * b2 - a21 * b1 + a22 * b0;
    var b9 = a30 * b2 - a31 * b1 + a32 * b0;
    // Calculate the determinant
    return a13 * b6 - a03 * b7 + a33 * b8 - a23 * b9;
}
function $26675c4f95835ef1$export$2060d2db72cce88f(out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3];
    var a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7];
    var a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11];
    var a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];
    // Cache only the current line of the second matrix
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[4];
    b1 = b[5];
    b2 = b[6];
    b3 = b[7];
    out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[8];
    b1 = b[9];
    b2 = b[10];
    b3 = b[11];
    out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    b0 = b[12];
    b1 = b[13];
    b2 = b[14];
    b3 = b[15];
    out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
    out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
    out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
    out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
    return out;
}
function $26675c4f95835ef1$export$d73ee8ef04f5226a(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0];
        a01 = a[1];
        a02 = a[2];
        a03 = a[3];
        a10 = a[4];
        a11 = a[5];
        a12 = a[6];
        a13 = a[7];
        a20 = a[8];
        a21 = a[9];
        a22 = a[10];
        a23 = a[11];
        out[0] = a00;
        out[1] = a01;
        out[2] = a02;
        out[3] = a03;
        out[4] = a10;
        out[5] = a11;
        out[6] = a12;
        out[7] = a13;
        out[8] = a20;
        out[9] = a21;
        out[10] = a22;
        out[11] = a23;
        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$dcdf75081b88279d(out, a, v) {
    var x = v[0], y = v[1], z = v[2];
    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
}
function $26675c4f95835ef1$export$bb628a54ab399bc9(out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.sqrt(x * x + y * y + z * z);
    var s, c, t;
    var a00, a01, a02, a03;
    var a10, a11, a12, a13;
    var a20, a21, a22, a23;
    var b00, b01, b02;
    var b10, b11, b12;
    var b20, b21, b22;
    if (len < $amnUE.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    // Construct the elements of the rotation matrix
    b00 = x * x * t + c;
    b01 = y * x * t + z * s;
    b02 = z * x * t - y * s;
    b10 = x * y * t - z * s;
    b11 = y * y * t + c;
    b12 = z * y * t + x * s;
    b20 = x * z * t + y * s;
    b21 = y * z * t - x * s;
    b22 = z * z * t + c;
    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
}
function $26675c4f95835ef1$export$a59c8716592e09af(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[0] = a[0];
        out[1] = a[1];
        out[2] = a[2];
        out[3] = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
}
function $26675c4f95835ef1$export$cf71e4d4ca4d1cfd(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a20 = a[8];
    var a21 = a[9];
    var a22 = a[10];
    var a23 = a[11];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged rows
        out[4] = a[4];
        out[5] = a[5];
        out[6] = a[6];
        out[7] = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
}
function $26675c4f95835ef1$export$ea6eae3365de5b9c(out, a, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    var a00 = a[0];
    var a01 = a[1];
    var a02 = a[2];
    var a03 = a[3];
    var a10 = a[4];
    var a11 = a[5];
    var a12 = a[6];
    var a13 = a[7];
    if (a !== out) {
        // If the source and destination differ, copy the unchanged last row
        out[8] = a[8];
        out[9] = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
}
function $26675c4f95835ef1$export$bc9e79e74e9fddf6(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$832ca188ffb1955d(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$926fc125ff3c666c(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2];
    var len = Math.sqrt(x * x + y * y + z * z);
    var s, c, t;
    if (len < $amnUE.EPSILON) return null;
    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;
    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;
    // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$dd47cc2f828c32ef(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$7dc997d67d2b7f33(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = 0;
    out[2] = -s;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$ad5ddaedc8f405df(out, rad) {
    var s = Math.sin(rad);
    var c = Math.cos(rad);
    // Perform axis-specific matrix multiplication
    out[0] = c;
    out[1] = s;
    out[2] = 0;
    out[3] = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$9545ac307f2a256b(out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$ff497f2be31cc6a(out, a) {
    var translation = new $amnUE.ARRAY_TYPE(3);
    var bx = -a[0], by = -a[1], bz = -a[2], bw = a[3], ax = a[4], ay = a[5], az = a[6], aw = a[7];
    var magnitude = bx * bx + by * by + bz * bz + bw * bw;
    //Only scale if it makes sense
    if (magnitude > 0) {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
    } else {
        translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
        translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
        translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
    }
    $26675c4f95835ef1$export$9545ac307f2a256b(out, a, translation);
    return out;
}
function $26675c4f95835ef1$export$202e99f82f7f0395(out, mat) {
    out[0] = mat[12];
    out[1] = mat[13];
    out[2] = mat[14];
    return out;
}
function $26675c4f95835ef1$export$71dc54d92bd04b57(out, mat) {
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
    out[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
    out[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
    return out;
}
function $26675c4f95835ef1$export$df3937d3b537df0a(out, mat) {
    var scaling = new $amnUE.ARRAY_TYPE(3);
    $26675c4f95835ef1$export$71dc54d92bd04b57(scaling, mat);
    var is1 = 1 / scaling[0];
    var is2 = 1 / scaling[1];
    var is3 = 1 / scaling[2];
    var sm11 = mat[0] * is1;
    var sm12 = mat[1] * is2;
    var sm13 = mat[2] * is3;
    var sm21 = mat[4] * is1;
    var sm22 = mat[5] * is2;
    var sm23 = mat[6] * is3;
    var sm31 = mat[8] * is1;
    var sm32 = mat[9] * is2;
    var sm33 = mat[10] * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out[3] = 0.25 * S;
        out[0] = (sm23 - sm32) / S;
        out[1] = (sm31 - sm13) / S;
        out[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out[3] = (sm23 - sm32) / S;
        out[0] = 0.25 * S;
        out[1] = (sm12 + sm21) / S;
        out[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out[3] = (sm31 - sm13) / S;
        out[0] = (sm12 + sm21) / S;
        out[1] = 0.25 * S;
        out[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out[3] = (sm12 - sm21) / S;
        out[0] = (sm31 + sm13) / S;
        out[1] = (sm23 + sm32) / S;
        out[2] = 0.25 * S;
    }
    return out;
}
function $26675c4f95835ef1$export$4e06b4a690896b27(out_r, out_t, out_s, mat) {
    out_t[0] = mat[12];
    out_t[1] = mat[13];
    out_t[2] = mat[14];
    var m11 = mat[0];
    var m12 = mat[1];
    var m13 = mat[2];
    var m21 = mat[4];
    var m22 = mat[5];
    var m23 = mat[6];
    var m31 = mat[8];
    var m32 = mat[9];
    var m33 = mat[10];
    out_s[0] = Math.sqrt(m11 * m11 + m12 * m12 + m13 * m13);
    out_s[1] = Math.sqrt(m21 * m21 + m22 * m22 + m23 * m23);
    out_s[2] = Math.sqrt(m31 * m31 + m32 * m32 + m33 * m33);
    var is1 = 1 / out_s[0];
    var is2 = 1 / out_s[1];
    var is3 = 1 / out_s[2];
    var sm11 = m11 * is1;
    var sm12 = m12 * is2;
    var sm13 = m13 * is3;
    var sm21 = m21 * is1;
    var sm22 = m22 * is2;
    var sm23 = m23 * is3;
    var sm31 = m31 * is1;
    var sm32 = m32 * is2;
    var sm33 = m33 * is3;
    var trace = sm11 + sm22 + sm33;
    var S = 0;
    if (trace > 0) {
        S = Math.sqrt(trace + 1.0) * 2;
        out_r[3] = 0.25 * S;
        out_r[0] = (sm23 - sm32) / S;
        out_r[1] = (sm31 - sm13) / S;
        out_r[2] = (sm12 - sm21) / S;
    } else if (sm11 > sm22 && sm11 > sm33) {
        S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
        out_r[3] = (sm23 - sm32) / S;
        out_r[0] = 0.25 * S;
        out_r[1] = (sm12 + sm21) / S;
        out_r[2] = (sm31 + sm13) / S;
    } else if (sm22 > sm33) {
        S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
        out_r[3] = (sm31 - sm13) / S;
        out_r[0] = (sm12 + sm21) / S;
        out_r[1] = 0.25 * S;
        out_r[2] = (sm23 + sm32) / S;
    } else {
        S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
        out_r[3] = (sm12 - sm21) / S;
        out_r[0] = (sm31 + sm13) / S;
        out_r[1] = (sm23 + sm32) / S;
        out_r[2] = 0.25 * S;
    }
    return out_r;
}
function $26675c4f95835ef1$export$ddf9c55c9f2be172(out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$1def1f860edc4b1f(out, q, v, s, o) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var xy = x * y2;
    var xz = x * z2;
    var yy = y * y2;
    var yz = y * z2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    var sx = s[0];
    var sy = s[1];
    var sz = s[2];
    var ox = o[0];
    var oy = o[1];
    var oz = o[2];
    var out0 = (1 - (yy + zz)) * sx;
    var out1 = (xy + wz) * sx;
    var out2 = (xz - wy) * sx;
    var out4 = (xy - wz) * sy;
    var out5 = (1 - (xx + zz)) * sy;
    var out6 = (yz + wx) * sy;
    var out8 = (xz + wy) * sz;
    var out9 = (yz - wx) * sz;
    var out10 = (1 - (xx + yy)) * sz;
    out[0] = out0;
    out[1] = out1;
    out[2] = out2;
    out[3] = 0;
    out[4] = out4;
    out[5] = out5;
    out[6] = out6;
    out[7] = 0;
    out[8] = out8;
    out[9] = out9;
    out[10] = out10;
    out[11] = 0;
    out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
    out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
    out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$2ff2bbe382249af7(out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3];
    var x2 = x + x;
    var y2 = y + y;
    var z2 = z + z;
    var xx = x * x2;
    var yx = y * x2;
    var yy = y * y2;
    var zx = z * x2;
    var zy = z * y2;
    var zz = z * z2;
    var wx = w * x2;
    var wy = w * y2;
    var wz = w * z2;
    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;
    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;
    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$89b5708c387cac6c(out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left);
    var tb = 1 / (top - bottom);
    var nf = 1 / (near - far);
    out[0] = near * 2 * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = near * 2 * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = far * near * 2 * nf;
    out[15] = 0;
    return out;
}
function $26675c4f95835ef1$export$4cf19729ec9a96b8(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        var nf = 1 / (near - far);
        out[10] = (far + near) * nf;
        out[14] = 2 * far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -2 * near;
    }
    return out;
}
var $26675c4f95835ef1$export$541149539f3a4684 = $26675c4f95835ef1$export$4cf19729ec9a96b8;
function $26675c4f95835ef1$export$294bba99a6af0c0c(out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[15] = 0;
    if (far != null && far !== Infinity) {
        var nf = 1 / (near - far);
        out[10] = far * nf;
        out[14] = far * near * nf;
    } else {
        out[10] = -1;
        out[14] = -near;
    }
    return out;
}
function $26675c4f95835ef1$export$58ae211c788e338f(out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
    var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
    var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
    var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
    var xScale = 2.0 / (leftTan + rightTan);
    var yScale = 2.0 / (upTan + downTan);
    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = (upTan - downTan) * yScale * 0.5;
    out[10] = far / (near - far);
    out[11] = -1;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = far * near / (near - far);
    out[15] = 0.0;
    return out;
}
function $26675c4f95835ef1$export$c5f65ef3eb668f27(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
}
var $26675c4f95835ef1$export$4f2167e613cfc87b = $26675c4f95835ef1$export$c5f65ef3eb668f27;
function $26675c4f95835ef1$export$b1d31ea7b4d854e(out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right);
    var bt = 1 / (bottom - top);
    var nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = near * nf;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$d924e14fd6d9aa66(out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
    var eyex = eye[0];
    var eyey = eye[1];
    var eyez = eye[2];
    var upx = up[0];
    var upy = up[1];
    var upz = up[2];
    var centerx = center[0];
    var centery = center[1];
    var centerz = center[2];
    if (Math.abs(eyex - centerx) < $amnUE.EPSILON && Math.abs(eyey - centery) < $amnUE.EPSILON && Math.abs(eyez - centerz) < $amnUE.EPSILON) return $26675c4f95835ef1$export$f0954fd7d5368655(out);
    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;
    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;
    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;
    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }
    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$aa67782f4dc9e52c(out, eye, target, up) {
    var eyex = eye[0], eyey = eye[1], eyez = eye[2], upx = up[0], upy = up[1], upz = up[2];
    var z0 = eyex - target[0], z1 = eyey - target[1], z2 = eyez - target[2];
    var len = z0 * z0 + z1 * z1 + z2 * z2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        z0 *= len;
        z1 *= len;
        z2 *= len;
    }
    var x0 = upy * z2 - upz * z1, x1 = upz * z0 - upx * z2, x2 = upx * z1 - upy * z0;
    len = x0 * x0 + x1 * x1 + x2 * x2;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }
    out[0] = x0;
    out[1] = x1;
    out[2] = x2;
    out[3] = 0;
    out[4] = z1 * x2 - z2 * x1;
    out[5] = z2 * x0 - z0 * x2;
    out[6] = z0 * x1 - z1 * x0;
    out[7] = 0;
    out[8] = z0;
    out[9] = z1;
    out[10] = z2;
    out[11] = 0;
    out[12] = eyex;
    out[13] = eyey;
    out[14] = eyez;
    out[15] = 1;
    return out;
}
function $26675c4f95835ef1$export$42d51816ce590c93(a) {
    return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
function $26675c4f95835ef1$export$326827e8268e9cdb(a) {
    return Math.sqrt(a[0] * a[0] + a[1] * a[1] + a[2] * a[2] + a[3] * a[3] + a[4] * a[4] + a[5] * a[5] + a[6] * a[6] + a[7] * a[7] + a[8] * a[8] + a[9] * a[9] + a[10] * a[10] + a[11] * a[11] + a[12] * a[12] + a[13] * a[13] + a[14] * a[14] + a[15] * a[15]);
}
function $26675c4f95835ef1$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
}
function $26675c4f95835ef1$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
}
function $26675c4f95835ef1$export$c697bed75648cdb7(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
}
function $26675c4f95835ef1$export$553579f63bdd7137(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    out[4] = a[4] + b[4] * scale;
    out[5] = a[5] + b[5] * scale;
    out[6] = a[6] + b[6] * scale;
    out[7] = a[7] + b[7] * scale;
    out[8] = a[8] + b[8] * scale;
    out[9] = a[9] + b[9] * scale;
    out[10] = a[10] + b[10] * scale;
    out[11] = a[11] + b[11] * scale;
    out[12] = a[12] + b[12] * scale;
    out[13] = a[13] + b[13] * scale;
    out[14] = a[14] + b[14] * scale;
    out[15] = a[15] + b[15] * scale;
    return out;
}
function $26675c4f95835ef1$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
function $26675c4f95835ef1$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7];
    var a8 = a[8], a9 = a[9], a10 = a[10], a11 = a[11];
    var a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    var b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7];
    var b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11];
    var b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
var $26675c4f95835ef1$export$6e3a27864ab166fe = $26675c4f95835ef1$export$2060d2db72cce88f;
var $26675c4f95835ef1$export$f93b5905241a7cca = $26675c4f95835ef1$export$4e2d2ead65e5f7e3;

});

parcelRegister("k1dpP", function(module, exports) {

$parcel$export(module.exports, "create", () => $e92e4eb8d35aaf31$export$185802fd694ee1f5);
$parcel$export(module.exports, "identity", () => $e92e4eb8d35aaf31$export$f0954fd7d5368655);
$parcel$export(module.exports, "setAxisAngle", () => $e92e4eb8d35aaf31$export$4286ddefc8f49512);
$parcel$export(module.exports, "getAxisAngle", () => $e92e4eb8d35aaf31$export$3f70be5e7d7dc51);
$parcel$export(module.exports, "getAngle", () => $e92e4eb8d35aaf31$export$b363da9ded343252);
$parcel$export(module.exports, "dot", () => $e92e4eb8d35aaf31$export$94132a0e348806d4);
$parcel$export(module.exports, "multiply", () => $e92e4eb8d35aaf31$export$2060d2db72cce88f);
$parcel$export(module.exports, "rotateX", () => $e92e4eb8d35aaf31$export$a59c8716592e09af);
$parcel$export(module.exports, "rotateY", () => $e92e4eb8d35aaf31$export$cf71e4d4ca4d1cfd);
$parcel$export(module.exports, "rotateZ", () => $e92e4eb8d35aaf31$export$ea6eae3365de5b9c);
$parcel$export(module.exports, "calculateW", () => $e92e4eb8d35aaf31$export$fb72b72e8d764d4e);
$parcel$export(module.exports, "exp", () => $e92e4eb8d35aaf31$export$b310ec824aaee37f);
$parcel$export(module.exports, "ln", () => $e92e4eb8d35aaf31$export$876cb1b29620556f);
$parcel$export(module.exports, "pow", () => $e92e4eb8d35aaf31$export$9c297f60e22e3389);
$parcel$export(module.exports, "scale", () => $e92e4eb8d35aaf31$export$dcdf75081b88279d);
$parcel$export(module.exports, "slerp", () => $e92e4eb8d35aaf31$export$1544d9bc2995de08);
$parcel$export(module.exports, "random", () => $e92e4eb8d35aaf31$export$4385e60b38654f68);
$parcel$export(module.exports, "invert", () => $e92e4eb8d35aaf31$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "conjugate", () => $e92e4eb8d35aaf31$export$7679f47e72c62560);
$parcel$export(module.exports, "fromMat3", () => $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b);
$parcel$export(module.exports, "fromEuler", () => $e92e4eb8d35aaf31$export$7a404a587ea85af);
$parcel$export(module.exports, "str", () => $e92e4eb8d35aaf31$export$42d51816ce590c93);
$parcel$export(module.exports, "clone", () => $e92e4eb8d35aaf31$export$9cd59f9826255e47);
$parcel$export(module.exports, "fromValues", () => $e92e4eb8d35aaf31$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $e92e4eb8d35aaf31$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $e92e4eb8d35aaf31$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $e92e4eb8d35aaf31$export$e16d8520af44a096);
$parcel$export(module.exports, "mul", () => $e92e4eb8d35aaf31$export$6e3a27864ab166fe);
$parcel$export(module.exports, "lerp", () => $e92e4eb8d35aaf31$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "length", () => $e92e4eb8d35aaf31$export$f24224f1c91d8156);
$parcel$export(module.exports, "len", () => $e92e4eb8d35aaf31$export$fc1400facf92c78);
$parcel$export(module.exports, "squaredLength", () => $e92e4eb8d35aaf31$export$ab44e1323ffc8376);
$parcel$export(module.exports, "sqrLen", () => $e92e4eb8d35aaf31$export$99d8dd3f32a3435);
$parcel$export(module.exports, "normalize", () => $e92e4eb8d35aaf31$export$a3295358bff77e);
$parcel$export(module.exports, "exactEquals", () => $e92e4eb8d35aaf31$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $e92e4eb8d35aaf31$export$e9bab7fafb253603);
$parcel$export(module.exports, "rotationTo", () => $e92e4eb8d35aaf31$export$72d66f5842c00904);
$parcel$export(module.exports, "sqlerp", () => $e92e4eb8d35aaf31$export$699b0866ca50f6cb);
$parcel$export(module.exports, "setAxes", () => $e92e4eb8d35aaf31$export$937ca0a544b2d712);

var $amnUE = parcelRequire("amnUE");

var $bDSmI = parcelRequire("bDSmI");

var $eIStk = parcelRequire("eIStk");

var $jxhwV = parcelRequire("jxhwV");
function $e92e4eb8d35aaf31$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(4);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    out[3] = 1;
    return out;
}
function $e92e4eb8d35aaf31$export$f0954fd7d5368655(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
}
function $e92e4eb8d35aaf31$export$4286ddefc8f49512(out, axis, rad) {
    rad = rad * 0.5;
    var s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
}
function $e92e4eb8d35aaf31$export$3f70be5e7d7dc51(out_axis, q) {
    var rad = Math.acos(q[3]) * 2.0;
    var s = Math.sin(rad / 2.0);
    if (s > $amnUE.EPSILON) {
        out_axis[0] = q[0] / s;
        out_axis[1] = q[1] / s;
        out_axis[2] = q[2] / s;
    } else {
        // If s is zero, return any axis (no rotation - axis does not matter)
        out_axis[0] = 1;
        out_axis[1] = 0;
        out_axis[2] = 0;
    }
    return rad;
}
function $e92e4eb8d35aaf31$export$b363da9ded343252(a, b) {
    var dotproduct = $e92e4eb8d35aaf31$export$94132a0e348806d4(a, b);
    return Math.acos(2 * dotproduct * dotproduct - 1);
}
function $e92e4eb8d35aaf31$export$2060d2db72cce88f(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
}
function $e92e4eb8d35aaf31$export$a59c8716592e09af(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
}
function $e92e4eb8d35aaf31$export$cf71e4d4ca4d1cfd(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var by = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
}
function $e92e4eb8d35aaf31$export$ea6eae3365de5b9c(out, a, rad) {
    rad *= 0.5;
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bz = Math.sin(rad), bw = Math.cos(rad);
    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
}
function $e92e4eb8d35aaf31$export$fb72b72e8d764d4e(out, a) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
}
function $e92e4eb8d35aaf31$export$b310ec824aaee37f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var et = Math.exp(w);
    var s = r > 0 ? et * Math.sin(r) / r : 0;
    out[0] = x * s;
    out[1] = y * s;
    out[2] = z * s;
    out[3] = et * Math.cos(r);
    return out;
}
function $e92e4eb8d35aaf31$export$876cb1b29620556f(out, a) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    var r = Math.sqrt(x * x + y * y + z * z);
    var t = r > 0 ? Math.atan2(r, w) / r : 0;
    out[0] = x * t;
    out[1] = y * t;
    out[2] = z * t;
    out[3] = 0.5 * Math.log(x * x + y * y + z * z + w * w);
    return out;
}
function $e92e4eb8d35aaf31$export$9c297f60e22e3389(out, a, b) {
    $e92e4eb8d35aaf31$export$876cb1b29620556f(out, a);
    $e92e4eb8d35aaf31$export$dcdf75081b88279d(out, out, b);
    $e92e4eb8d35aaf31$export$b310ec824aaee37f(out, out);
    return out;
}
function $e92e4eb8d35aaf31$export$1544d9bc2995de08(out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations
    var ax = a[0], ay = a[1], az = a[2], aw = a[3];
    var bx = b[0], by = b[1], bz = b[2], bw = b[3];
    var omega, cosom, sinom, scale0, scale1;
    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    // adjust signs (if necessary)
    if (cosom < 0.0) {
        cosom = -cosom;
        bx = -bx;
        by = -by;
        bz = -bz;
        bw = -bw;
    }
    // calculate coefficients
    if (1.0 - cosom > $amnUE.EPSILON) {
        // standard case (slerp)
        omega = Math.acos(cosom);
        sinom = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {
        // "from" and "to" quaternions are very close
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    }
    // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
}
function $e92e4eb8d35aaf31$export$4385e60b38654f68(out) {
    // Implementation of http://planning.cs.uiuc.edu/node198.html
    // TODO: Calling random 3 times is probably not the fastest solution
    var u1 = $amnUE.RANDOM();
    var u2 = $amnUE.RANDOM();
    var u3 = $amnUE.RANDOM();
    var sqrt1MinusU1 = Math.sqrt(1 - u1);
    var sqrtU1 = Math.sqrt(u1);
    out[0] = sqrt1MinusU1 * Math.sin(2.0 * Math.PI * u2);
    out[1] = sqrt1MinusU1 * Math.cos(2.0 * Math.PI * u2);
    out[2] = sqrtU1 * Math.sin(2.0 * Math.PI * u3);
    out[3] = sqrtU1 * Math.cos(2.0 * Math.PI * u3);
    return out;
}
function $e92e4eb8d35aaf31$export$6897c284b6f9f4dc(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var dot = a0 * a0 + a1 * a1 + a2 * a2 + a3 * a3;
    var invDot = dot ? 1.0 / dot : 0;
    // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0
    out[0] = -a0 * invDot;
    out[1] = -a1 * invDot;
    out[2] = -a2 * invDot;
    out[3] = a3 * invDot;
    return out;
}
function $e92e4eb8d35aaf31$export$7679f47e72c62560(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
}
function $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    var fTrace = m[0] + m[4] + m[8];
    var fRoot;
    if (fTrace > 0.0) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0); // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot; // 1/(4w)
        out[0] = (m[5] - m[7]) * fRoot;
        out[1] = (m[6] - m[2]) * fRoot;
        out[2] = (m[1] - m[3]) * fRoot;
    } else {
        // |w| <= 1/2
        var i = 0;
        if (m[4] > m[0]) i = 1;
        if (m[8] > m[i * 3 + i]) i = 2;
        var j = (i + 1) % 3;
        var k = (i + 2) % 3;
        fRoot = Math.sqrt(m[i * 3 + i] - m[j * 3 + j] - m[k * 3 + k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j * 3 + k] - m[k * 3 + j]) * fRoot;
        out[j] = (m[j * 3 + i] + m[i * 3 + j]) * fRoot;
        out[k] = (m[k * 3 + i] + m[i * 3 + k]) * fRoot;
    }
    return out;
}
function $e92e4eb8d35aaf31$export$7a404a587ea85af(out, x, y, z) {
    var order = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $amnUE.ANGLE_ORDER;
    var halfToRad = Math.PI / 360;
    x *= halfToRad;
    z *= halfToRad;
    y *= halfToRad;
    var sx = Math.sin(x);
    var cx = Math.cos(x);
    var sy = Math.sin(y);
    var cy = Math.cos(y);
    var sz = Math.sin(z);
    var cz = Math.cos(z);
    switch(order){
        case "xyz":
            out[0] = sx * cy * cz + cx * sy * sz;
            out[1] = cx * sy * cz - sx * cy * sz;
            out[2] = cx * cy * sz + sx * sy * cz;
            out[3] = cx * cy * cz - sx * sy * sz;
            break;
        case "xzy":
            out[0] = sx * cy * cz - cx * sy * sz;
            out[1] = cx * sy * cz - sx * cy * sz;
            out[2] = cx * cy * sz + sx * sy * cz;
            out[3] = cx * cy * cz + sx * sy * sz;
            break;
        case "yxz":
            out[0] = sx * cy * cz + cx * sy * sz;
            out[1] = cx * sy * cz - sx * cy * sz;
            out[2] = cx * cy * sz - sx * sy * cz;
            out[3] = cx * cy * cz + sx * sy * sz;
            break;
        case "yzx":
            out[0] = sx * cy * cz + cx * sy * sz;
            out[1] = cx * sy * cz + sx * cy * sz;
            out[2] = cx * cy * sz - sx * sy * cz;
            out[3] = cx * cy * cz - sx * sy * sz;
            break;
        case "zxy":
            out[0] = sx * cy * cz - cx * sy * sz;
            out[1] = cx * sy * cz + sx * cy * sz;
            out[2] = cx * cy * sz + sx * sy * cz;
            out[3] = cx * cy * cz - sx * sy * sz;
            break;
        case "zyx":
            out[0] = sx * cy * cz - cx * sy * sz;
            out[1] = cx * sy * cz + sx * cy * sz;
            out[2] = cx * cy * sz - sx * sy * cz;
            out[3] = cx * cy * cz + sx * sy * sz;
            break;
        default:
            throw new Error('Unknown angle order ' + order);
    }
    return out;
}
function $e92e4eb8d35aaf31$export$42d51816ce590c93(a) {
    return "quat(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
var $e92e4eb8d35aaf31$export$9cd59f9826255e47 = $jxhwV.clone;
var $e92e4eb8d35aaf31$export$a82be99ed2a44a7d = $jxhwV.fromValues;
var $e92e4eb8d35aaf31$export$784d13d8ee351f07 = $jxhwV.copy;
var $e92e4eb8d35aaf31$export$adaa4cf7ef1b65be = $jxhwV.set;
var $e92e4eb8d35aaf31$export$e16d8520af44a096 = $jxhwV.add;
var $e92e4eb8d35aaf31$export$6e3a27864ab166fe = $e92e4eb8d35aaf31$export$2060d2db72cce88f;
var $e92e4eb8d35aaf31$export$dcdf75081b88279d = $jxhwV.scale;
var $e92e4eb8d35aaf31$export$94132a0e348806d4 = $jxhwV.dot;
var $e92e4eb8d35aaf31$export$3a89f8d6f6bf6c9f = $jxhwV.lerp;
var $e92e4eb8d35aaf31$export$f24224f1c91d8156 = $jxhwV.length;
var $e92e4eb8d35aaf31$export$fc1400facf92c78 = $e92e4eb8d35aaf31$export$f24224f1c91d8156;
var $e92e4eb8d35aaf31$export$ab44e1323ffc8376 = $jxhwV.squaredLength;
var $e92e4eb8d35aaf31$export$99d8dd3f32a3435 = $e92e4eb8d35aaf31$export$ab44e1323ffc8376;
var $e92e4eb8d35aaf31$export$a3295358bff77e = $jxhwV.normalize;
var $e92e4eb8d35aaf31$export$f2599a5cf1109d8 = $jxhwV.exactEquals;
function $e92e4eb8d35aaf31$export$e9bab7fafb253603(a, b) {
    return Math.abs($jxhwV.dot(a, b)) >= 1 - $amnUE.EPSILON;
}
var $e92e4eb8d35aaf31$export$72d66f5842c00904 = function() {
    var tmpvec3 = $eIStk.create();
    var xUnitVec3 = $eIStk.fromValues(1, 0, 0);
    var yUnitVec3 = $eIStk.fromValues(0, 1, 0);
    return function(out, a, b) {
        var dot = $eIStk.dot(a, b);
        if (dot < -0.999999) {
            $eIStk.cross(tmpvec3, xUnitVec3, a);
            if ($eIStk.len(tmpvec3) < 0.000001) $eIStk.cross(tmpvec3, yUnitVec3, a);
            $eIStk.normalize(tmpvec3, tmpvec3);
            $e92e4eb8d35aaf31$export$4286ddefc8f49512(out, tmpvec3, Math.PI);
            return out;
        } else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        } else {
            $eIStk.cross(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return $e92e4eb8d35aaf31$export$a3295358bff77e(out, out);
        }
    };
}();
var $e92e4eb8d35aaf31$export$699b0866ca50f6cb = function() {
    var temp1 = $e92e4eb8d35aaf31$export$185802fd694ee1f5();
    var temp2 = $e92e4eb8d35aaf31$export$185802fd694ee1f5();
    return function(out, a, b, c, d, t) {
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(temp1, a, d, t);
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(temp2, b, c, t);
        $e92e4eb8d35aaf31$export$1544d9bc2995de08(out, temp1, temp2, 2 * t * (1 - t));
        return out;
    };
}();
var $e92e4eb8d35aaf31$export$937ca0a544b2d712 = function() {
    var matr = $bDSmI.create();
    return function(out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];
        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];
        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];
        return $e92e4eb8d35aaf31$export$a3295358bff77e(out, $e92e4eb8d35aaf31$export$272a1eb8e5a4b55b(out, matr));
    };
}();

});
parcelRegister("eIStk", function(module, exports) {

$parcel$export(module.exports, "create", () => $ab7f6dc0910e1ef7$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $ab7f6dc0910e1ef7$export$9cd59f9826255e47);
$parcel$export(module.exports, "length", () => $ab7f6dc0910e1ef7$export$f24224f1c91d8156);
$parcel$export(module.exports, "fromValues", () => $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $ab7f6dc0910e1ef7$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $ab7f6dc0910e1ef7$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $ab7f6dc0910e1ef7$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $ab7f6dc0910e1ef7$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $ab7f6dc0910e1ef7$export$cd007d971a5a2143);
$parcel$export(module.exports, "ceil", () => $ab7f6dc0910e1ef7$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "floor", () => $ab7f6dc0910e1ef7$export$a3fe094919f356fd);
$parcel$export(module.exports, "min", () => $ab7f6dc0910e1ef7$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $ab7f6dc0910e1ef7$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $ab7f6dc0910e1ef7$export$2077e0241d6afd3c);
$parcel$export(module.exports, "scale", () => $ab7f6dc0910e1ef7$export$dcdf75081b88279d);
$parcel$export(module.exports, "scaleAndAdd", () => $ab7f6dc0910e1ef7$export$19cedf1da84ba854);
$parcel$export(module.exports, "distance", () => $ab7f6dc0910e1ef7$export$9f17032d917177de);
$parcel$export(module.exports, "squaredDistance", () => $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538);
$parcel$export(module.exports, "squaredLength", () => $ab7f6dc0910e1ef7$export$ab44e1323ffc8376);
$parcel$export(module.exports, "negate", () => $ab7f6dc0910e1ef7$export$aef51622e549b8b0);
$parcel$export(module.exports, "inverse", () => $ab7f6dc0910e1ef7$export$70ae2c07e401031b);
$parcel$export(module.exports, "normalize", () => $ab7f6dc0910e1ef7$export$a3295358bff77e);
$parcel$export(module.exports, "dot", () => $ab7f6dc0910e1ef7$export$94132a0e348806d4);
$parcel$export(module.exports, "cross", () => $ab7f6dc0910e1ef7$export$bb646b20bb93d339);
$parcel$export(module.exports, "lerp", () => $ab7f6dc0910e1ef7$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "slerp", () => $ab7f6dc0910e1ef7$export$1544d9bc2995de08);
$parcel$export(module.exports, "hermite", () => $ab7f6dc0910e1ef7$export$ae8865616f30561c);
$parcel$export(module.exports, "bezier", () => $ab7f6dc0910e1ef7$export$b9c5f84610baddaf);
$parcel$export(module.exports, "random", () => $ab7f6dc0910e1ef7$export$4385e60b38654f68);
$parcel$export(module.exports, "transformMat4", () => $ab7f6dc0910e1ef7$export$5ffbd13800309d59);
$parcel$export(module.exports, "transformMat3", () => $ab7f6dc0910e1ef7$export$f0bfa0a0024626ee);
$parcel$export(module.exports, "transformQuat", () => $ab7f6dc0910e1ef7$export$c32adef9e939ce85);
$parcel$export(module.exports, "rotateX", () => $ab7f6dc0910e1ef7$export$a59c8716592e09af);
$parcel$export(module.exports, "rotateY", () => $ab7f6dc0910e1ef7$export$cf71e4d4ca4d1cfd);
$parcel$export(module.exports, "rotateZ", () => $ab7f6dc0910e1ef7$export$ea6eae3365de5b9c);
$parcel$export(module.exports, "angle", () => $ab7f6dc0910e1ef7$export$944b09d2ad10b378);
$parcel$export(module.exports, "zero", () => $ab7f6dc0910e1ef7$export$7f9972325ebfd559);
$parcel$export(module.exports, "str", () => $ab7f6dc0910e1ef7$export$42d51816ce590c93);
$parcel$export(module.exports, "exactEquals", () => $ab7f6dc0910e1ef7$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $ab7f6dc0910e1ef7$export$e9bab7fafb253603);
$parcel$export(module.exports, "sub", () => $ab7f6dc0910e1ef7$export$f93b5905241a7cca);
$parcel$export(module.exports, "mul", () => $ab7f6dc0910e1ef7$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $ab7f6dc0910e1ef7$export$159d9494db57879b);
$parcel$export(module.exports, "dist", () => $ab7f6dc0910e1ef7$export$6c4a311cc157c764);
$parcel$export(module.exports, "sqrDist", () => $ab7f6dc0910e1ef7$export$2422cd6c492a8b3a);
$parcel$export(module.exports, "len", () => $ab7f6dc0910e1ef7$export$fc1400facf92c78);
$parcel$export(module.exports, "sqrLen", () => $ab7f6dc0910e1ef7$export$99d8dd3f32a3435);
$parcel$export(module.exports, "forEach", () => $ab7f6dc0910e1ef7$export$4b80e395e36b5a56);

var $amnUE = parcelRequire("amnUE");
function $ab7f6dc0910e1ef7$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(3);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
    }
    return out;
}
function $ab7f6dc0910e1ef7$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $ab7f6dc0910e1ef7$export$a82be99ed2a44a7d(x, y, z) {
    var out = new $amnUE.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $ab7f6dc0910e1ef7$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$adaa4cf7ef1b65be(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
}
function $ab7f6dc0910e1ef7$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$2077e0241d6afd3c(out, a) {
    out[0] = $amnUE.round(a[0]);
    out[1] = $amnUE.round(a[1]);
    out[2] = $amnUE.round(a[2]);
    return out;
}
function $ab7f6dc0910e1ef7$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
}
function $ab7f6dc0910e1ef7$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    return out;
}
function $ab7f6dc0910e1ef7$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return Math.sqrt(x * x + y * y + z * z);
}
function $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    return x * x + y * y + z * z;
}
function $ab7f6dc0910e1ef7$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    return x * x + y * y + z * z;
}
function $ab7f6dc0910e1ef7$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var len = x * x + y * y + z * z;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    out[2] = a[2] * len;
    return out;
}
function $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
function $ab7f6dc0910e1ef7$export$bb646b20bb93d339(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2];
    var bx = b[0], by = b[1], bz = b[2];
    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
}
function $ab7f6dc0910e1ef7$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
}
function $ab7f6dc0910e1ef7$export$1544d9bc2995de08(out, a, b, t) {
    var angle = Math.acos(Math.min(Math.max($ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b), -1), 1));
    var sinTotal = Math.sin(angle);
    var ratioA = Math.sin((1 - t) * angle) / sinTotal;
    var ratioB = Math.sin(t * angle) / sinTotal;
    out[0] = ratioA * a[0] + ratioB * b[0];
    out[1] = ratioA * a[1] + ratioB * b[1];
    out[2] = ratioA * a[2] + ratioB * b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$ae8865616f30561c(out, a, b, c, d, t) {
    var factorTimes2 = t * t;
    var factor1 = factorTimes2 * (2 * t - 3) + 1;
    var factor2 = factorTimes2 * (t - 2) + t;
    var factor3 = factorTimes2 * (t - 1);
    var factor4 = factorTimes2 * (3 - 2 * t);
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $ab7f6dc0910e1ef7$export$b9c5f84610baddaf(out, a, b, c, d, t) {
    var inverseFactor = 1 - t;
    var inverseFactorTimesTwo = inverseFactor * inverseFactor;
    var factorTimes2 = t * t;
    var factor1 = inverseFactorTimesTwo * inverseFactor;
    var factor2 = 3 * t * inverseFactorTimesTwo;
    var factor3 = 3 * factorTimes2 * inverseFactor;
    var factor4 = factorTimes2 * t;
    out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
    out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
    out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
    return out;
}
function $ab7f6dc0910e1ef7$export$4385e60b38654f68(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    var r = $amnUE.RANDOM() * 2.0 * Math.PI;
    var z = $amnUE.RANDOM() * 2.0 - 1.0;
    var zScale = Math.sqrt(1.0 - z * z) * scale;
    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
}
function $ab7f6dc0910e1ef7$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    var w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
}
function $ab7f6dc0910e1ef7$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
}
function $ab7f6dc0910e1ef7$export$c32adef9e939ce85(out, a, q) {
    // Fast Vector Rotation using Quaternions by Robert Eisele
    // https://raw.org/proof/vector-rotation-using-quaternions/
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var vx = a[0], vy = a[1], vz = a[2];
    // t = q x v
    var tx = qy * vz - qz * vy;
    var ty = qz * vx - qx * vz;
    var tz = qx * vy - qy * vx;
    // t = 2t
    tx = tx + tx;
    ty = ty + ty;
    tz = tz + tz;
    // v + w t + q x t
    out[0] = vx + qw * tx + qy * tz - qz * ty;
    out[1] = vy + qw * ty + qz * tx - qx * tz;
    out[2] = vz + qw * tz + qx * ty - qy * tx;
    return out;
}
function $ab7f6dc0910e1ef7$export$a59c8716592e09af(out, a, b, rad) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0];
    r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
    r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$cf71e4d4ca4d1cfd(out, a, b, rad) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
    r[1] = p[1];
    r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad);
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$ea6eae3365de5b9c(out, a, b, rad) {
    var p = [], r = [];
    //Translate point to the origin
    p[0] = a[0] - b[0];
    p[1] = a[1] - b[1];
    p[2] = a[2] - b[2];
    //perform rotation
    r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
    r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
    r[2] = p[2];
    //translate to correct position
    out[0] = r[0] + b[0];
    out[1] = r[1] + b[1];
    out[2] = r[2] + b[2];
    return out;
}
function $ab7f6dc0910e1ef7$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], az = a[2], bx = b[0], by = b[1], bz = b[2], mag = Math.sqrt((ax * ax + ay * ay + az * az) * (bx * bx + by * by + bz * bz)), cosine = mag && $ab7f6dc0910e1ef7$export$94132a0e348806d4(a, b) / mag;
    return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
function $ab7f6dc0910e1ef7$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    return out;
}
function $ab7f6dc0910e1ef7$export$42d51816ce590c93(a) {
    return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
function $ab7f6dc0910e1ef7$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
function $ab7f6dc0910e1ef7$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
var $ab7f6dc0910e1ef7$export$f93b5905241a7cca = $ab7f6dc0910e1ef7$export$4e2d2ead65e5f7e3;
var $ab7f6dc0910e1ef7$export$6e3a27864ab166fe = $ab7f6dc0910e1ef7$export$2060d2db72cce88f;
var $ab7f6dc0910e1ef7$export$159d9494db57879b = $ab7f6dc0910e1ef7$export$cd007d971a5a2143;
var $ab7f6dc0910e1ef7$export$6c4a311cc157c764 = $ab7f6dc0910e1ef7$export$9f17032d917177de;
var $ab7f6dc0910e1ef7$export$2422cd6c492a8b3a = $ab7f6dc0910e1ef7$export$88e6ebb4fe54f538;
var $ab7f6dc0910e1ef7$export$fc1400facf92c78 = $ab7f6dc0910e1ef7$export$f24224f1c91d8156;
var $ab7f6dc0910e1ef7$export$99d8dd3f32a3435 = $ab7f6dc0910e1ef7$export$ab44e1323ffc8376;
var $ab7f6dc0910e1ef7$export$4b80e395e36b5a56 = function() {
    var vec = $ab7f6dc0910e1ef7$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 3;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
        }
        return a;
    };
}();

});

parcelRegister("jxhwV", function(module, exports) {

$parcel$export(module.exports, "create", () => $e38eb280d3b76273$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $e38eb280d3b76273$export$9cd59f9826255e47);
$parcel$export(module.exports, "fromValues", () => $e38eb280d3b76273$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $e38eb280d3b76273$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $e38eb280d3b76273$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $e38eb280d3b76273$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $e38eb280d3b76273$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $e38eb280d3b76273$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $e38eb280d3b76273$export$cd007d971a5a2143);
$parcel$export(module.exports, "ceil", () => $e38eb280d3b76273$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "floor", () => $e38eb280d3b76273$export$a3fe094919f356fd);
$parcel$export(module.exports, "min", () => $e38eb280d3b76273$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $e38eb280d3b76273$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $e38eb280d3b76273$export$2077e0241d6afd3c);
$parcel$export(module.exports, "scale", () => $e38eb280d3b76273$export$dcdf75081b88279d);
$parcel$export(module.exports, "scaleAndAdd", () => $e38eb280d3b76273$export$19cedf1da84ba854);
$parcel$export(module.exports, "distance", () => $e38eb280d3b76273$export$9f17032d917177de);
$parcel$export(module.exports, "squaredDistance", () => $e38eb280d3b76273$export$88e6ebb4fe54f538);
$parcel$export(module.exports, "length", () => $e38eb280d3b76273$export$f24224f1c91d8156);
$parcel$export(module.exports, "squaredLength", () => $e38eb280d3b76273$export$ab44e1323ffc8376);
$parcel$export(module.exports, "negate", () => $e38eb280d3b76273$export$aef51622e549b8b0);
$parcel$export(module.exports, "inverse", () => $e38eb280d3b76273$export$70ae2c07e401031b);
$parcel$export(module.exports, "normalize", () => $e38eb280d3b76273$export$a3295358bff77e);
$parcel$export(module.exports, "dot", () => $e38eb280d3b76273$export$94132a0e348806d4);
$parcel$export(module.exports, "cross", () => $e38eb280d3b76273$export$bb646b20bb93d339);
$parcel$export(module.exports, "lerp", () => $e38eb280d3b76273$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "random", () => $e38eb280d3b76273$export$4385e60b38654f68);
$parcel$export(module.exports, "transformMat4", () => $e38eb280d3b76273$export$5ffbd13800309d59);
$parcel$export(module.exports, "transformQuat", () => $e38eb280d3b76273$export$c32adef9e939ce85);
$parcel$export(module.exports, "zero", () => $e38eb280d3b76273$export$7f9972325ebfd559);
$parcel$export(module.exports, "str", () => $e38eb280d3b76273$export$42d51816ce590c93);
$parcel$export(module.exports, "exactEquals", () => $e38eb280d3b76273$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $e38eb280d3b76273$export$e9bab7fafb253603);
$parcel$export(module.exports, "sub", () => $e38eb280d3b76273$export$f93b5905241a7cca);
$parcel$export(module.exports, "mul", () => $e38eb280d3b76273$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $e38eb280d3b76273$export$159d9494db57879b);
$parcel$export(module.exports, "dist", () => $e38eb280d3b76273$export$6c4a311cc157c764);
$parcel$export(module.exports, "sqrDist", () => $e38eb280d3b76273$export$2422cd6c492a8b3a);
$parcel$export(module.exports, "len", () => $e38eb280d3b76273$export$fc1400facf92c78);
$parcel$export(module.exports, "sqrLen", () => $e38eb280d3b76273$export$99d8dd3f32a3435);
$parcel$export(module.exports, "forEach", () => $e38eb280d3b76273$export$4b80e395e36b5a56);

var $amnUE = parcelRequire("amnUE");
function $e38eb280d3b76273$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(4);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
        out[2] = 0;
        out[3] = 0;
    }
    return out;
}
function $e38eb280d3b76273$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$a82be99ed2a44a7d(x, y, z, w) {
    var out = new $amnUE.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e38eb280d3b76273$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$adaa4cf7ef1b65be(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
}
function $e38eb280d3b76273$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
}
function $e38eb280d3b76273$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
}
function $e38eb280d3b76273$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
}
function $e38eb280d3b76273$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
}
function $e38eb280d3b76273$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
}
function $e38eb280d3b76273$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
}
function $e38eb280d3b76273$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
}
function $e38eb280d3b76273$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
}
function $e38eb280d3b76273$export$2077e0241d6afd3c(out, a) {
    out[0] = $amnUE.round(a[0]);
    out[1] = $amnUE.round(a[1]);
    out[2] = $amnUE.round(a[2]);
    out[3] = $amnUE.round(a[3]);
    return out;
}
function $e38eb280d3b76273$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
}
function $e38eb280d3b76273$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    out[2] = a[2] + b[2] * scale;
    out[3] = a[3] + b[3] * scale;
    return out;
}
function $e38eb280d3b76273$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function $e38eb280d3b76273$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0];
    var y = b[1] - a[1];
    var z = b[2] - a[2];
    var w = b[3] - a[3];
    return x * x + y * y + z * z + w * w;
}
function $e38eb280d3b76273$export$f24224f1c91d8156(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return Math.sqrt(x * x + y * y + z * z + w * w);
}
function $e38eb280d3b76273$export$ab44e1323ffc8376(a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    return x * x + y * y + z * z + w * w;
}
function $e38eb280d3b76273$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
}
function $e38eb280d3b76273$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    out[2] = 1.0 / a[2];
    out[3] = 1.0 / a[3];
    return out;
}
function $e38eb280d3b76273$export$a3295358bff77e(out, a) {
    var x = a[0];
    var y = a[1];
    var z = a[2];
    var w = a[3];
    var len = x * x + y * y + z * z + w * w;
    if (len > 0) len = 1 / Math.sqrt(len);
    out[0] = x * len;
    out[1] = y * len;
    out[2] = z * len;
    out[3] = w * len;
    return out;
}
function $e38eb280d3b76273$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
}
function $e38eb280d3b76273$export$bb646b20bb93d339(out, u, v, w) {
    var A = v[0] * w[1] - v[1] * w[0], B = v[0] * w[2] - v[2] * w[0], C = v[0] * w[3] - v[3] * w[0], D = v[1] * w[2] - v[2] * w[1], E = v[1] * w[3] - v[3] * w[1], F = v[2] * w[3] - v[3] * w[2];
    var G = u[0];
    var H = u[1];
    var I = u[2];
    var J = u[3];
    out[0] = H * F - I * E + J * D;
    out[1] = -(G * F) + I * C - J * B;
    out[2] = G * E - H * C + J * A;
    out[3] = -(G * D) + H * B - I * A;
    return out;
}
function $e38eb280d3b76273$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
}
function $e38eb280d3b76273$export$4385e60b38654f68(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    // Marsaglia, George. Choosing a Point from the Surface of a
    // Sphere. Ann. Math. Statist. 43 (1972), no. 2, 645--646.
    // http://projecteuclid.org/euclid.aoms/1177692644;
    var v1, v2, v3, v4;
    var s1, s2;
    var rand;
    rand = $amnUE.RANDOM();
    v1 = rand * 2 - 1;
    v2 = (4 * $amnUE.RANDOM() - 2) * Math.sqrt(rand * -rand + rand);
    s1 = v1 * v1 + v2 * v2;
    rand = $amnUE.RANDOM();
    v3 = rand * 2 - 1;
    v4 = (4 * $amnUE.RANDOM() - 2) * Math.sqrt(rand * -rand + rand);
    s2 = v3 * v3 + v4 * v4;
    var d = Math.sqrt((1 - s1) / s2);
    out[0] = scale * v1;
    out[1] = scale * v2;
    out[2] = scale * v3 * d;
    out[3] = scale * v4 * d;
    return out;
}
function $e38eb280d3b76273$export$5ffbd13800309d59(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
}
function $e38eb280d3b76273$export$c32adef9e939ce85(out, a, q) {
    // Fast Vector Rotation using Quaternions by Robert Eisele
    // https://raw.org/proof/vector-rotation-using-quaternions/
    var qx = q[0], qy = q[1], qz = q[2], qw = q[3];
    var vx = a[0], vy = a[1], vz = a[2];
    // t = q x v
    var tx = qy * vz - qz * vy;
    var ty = qz * vx - qx * vz;
    var tz = qx * vy - qy * vx;
    // t = 2t
    tx = tx + tx;
    ty = ty + ty;
    tz = tz + tz;
    // v + w t + q x t
    out[0] = vx + qw * tx + qy * tz - qz * ty;
    out[1] = vy + qw * ty + qz * tx - qx * tz;
    out[2] = vz + qw * tz + qx * ty - qy * tx;
    out[3] = a[3];
    return out;
}
function $e38eb280d3b76273$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    return out;
}
function $e38eb280d3b76273$export$42d51816ce590c93(a) {
    return "vec4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ")";
}
function $e38eb280d3b76273$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
}
function $e38eb280d3b76273$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3));
}
var $e38eb280d3b76273$export$f93b5905241a7cca = $e38eb280d3b76273$export$4e2d2ead65e5f7e3;
var $e38eb280d3b76273$export$6e3a27864ab166fe = $e38eb280d3b76273$export$2060d2db72cce88f;
var $e38eb280d3b76273$export$159d9494db57879b = $e38eb280d3b76273$export$cd007d971a5a2143;
var $e38eb280d3b76273$export$6c4a311cc157c764 = $e38eb280d3b76273$export$9f17032d917177de;
var $e38eb280d3b76273$export$2422cd6c492a8b3a = $e38eb280d3b76273$export$88e6ebb4fe54f538;
var $e38eb280d3b76273$export$fc1400facf92c78 = $e38eb280d3b76273$export$f24224f1c91d8156;
var $e38eb280d3b76273$export$99d8dd3f32a3435 = $e38eb280d3b76273$export$ab44e1323ffc8376;
var $e38eb280d3b76273$export$4b80e395e36b5a56 = function() {
    var vec = $e38eb280d3b76273$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 4;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            vec[2] = a[i + 2];
            vec[3] = a[i + 3];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
            a[i + 2] = vec[2];
            a[i + 3] = vec[3];
        }
        return a;
    };
}();

});


parcelRegister("6BoVD", function(module, exports) {

$parcel$export(module.exports, "create", () => $4ce98914b6676340$export$185802fd694ee1f5);
$parcel$export(module.exports, "clone", () => $4ce98914b6676340$export$9cd59f9826255e47);
$parcel$export(module.exports, "fromValues", () => $4ce98914b6676340$export$a82be99ed2a44a7d);
$parcel$export(module.exports, "copy", () => $4ce98914b6676340$export$784d13d8ee351f07);
$parcel$export(module.exports, "set", () => $4ce98914b6676340$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "add", () => $4ce98914b6676340$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $4ce98914b6676340$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $4ce98914b6676340$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $4ce98914b6676340$export$cd007d971a5a2143);
$parcel$export(module.exports, "ceil", () => $4ce98914b6676340$export$803ce6b71a0a94b2);
$parcel$export(module.exports, "floor", () => $4ce98914b6676340$export$a3fe094919f356fd);
$parcel$export(module.exports, "min", () => $4ce98914b6676340$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $4ce98914b6676340$export$8960430cfd85939f);
$parcel$export(module.exports, "round", () => $4ce98914b6676340$export$2077e0241d6afd3c);
$parcel$export(module.exports, "scale", () => $4ce98914b6676340$export$dcdf75081b88279d);
$parcel$export(module.exports, "scaleAndAdd", () => $4ce98914b6676340$export$19cedf1da84ba854);
$parcel$export(module.exports, "distance", () => $4ce98914b6676340$export$9f17032d917177de);
$parcel$export(module.exports, "squaredDistance", () => $4ce98914b6676340$export$88e6ebb4fe54f538);
$parcel$export(module.exports, "length", () => $4ce98914b6676340$export$f24224f1c91d8156);
$parcel$export(module.exports, "squaredLength", () => $4ce98914b6676340$export$ab44e1323ffc8376);
$parcel$export(module.exports, "negate", () => $4ce98914b6676340$export$aef51622e549b8b0);
$parcel$export(module.exports, "inverse", () => $4ce98914b6676340$export$70ae2c07e401031b);
$parcel$export(module.exports, "normalize", () => $4ce98914b6676340$export$a3295358bff77e);
$parcel$export(module.exports, "dot", () => $4ce98914b6676340$export$94132a0e348806d4);
$parcel$export(module.exports, "cross", () => $4ce98914b6676340$export$bb646b20bb93d339);
$parcel$export(module.exports, "lerp", () => $4ce98914b6676340$export$3a89f8d6f6bf6c9f);
$parcel$export(module.exports, "random", () => $4ce98914b6676340$export$4385e60b38654f68);
$parcel$export(module.exports, "transformMat2", () => $4ce98914b6676340$export$b732428d73874bfc);
$parcel$export(module.exports, "transformMat2d", () => $4ce98914b6676340$export$3e55bc4b3707dfd3);
$parcel$export(module.exports, "transformMat3", () => $4ce98914b6676340$export$f0bfa0a0024626ee);
$parcel$export(module.exports, "transformMat4", () => $4ce98914b6676340$export$5ffbd13800309d59);
$parcel$export(module.exports, "rotate", () => $4ce98914b6676340$export$bb628a54ab399bc9);
$parcel$export(module.exports, "angle", () => $4ce98914b6676340$export$944b09d2ad10b378);
$parcel$export(module.exports, "signedAngle", () => $4ce98914b6676340$export$2c039ab0034c6824);
$parcel$export(module.exports, "zero", () => $4ce98914b6676340$export$7f9972325ebfd559);
$parcel$export(module.exports, "str", () => $4ce98914b6676340$export$42d51816ce590c93);
$parcel$export(module.exports, "exactEquals", () => $4ce98914b6676340$export$f2599a5cf1109d8);
$parcel$export(module.exports, "equals", () => $4ce98914b6676340$export$e9bab7fafb253603);
$parcel$export(module.exports, "len", () => $4ce98914b6676340$export$fc1400facf92c78);
$parcel$export(module.exports, "sub", () => $4ce98914b6676340$export$f93b5905241a7cca);
$parcel$export(module.exports, "mul", () => $4ce98914b6676340$export$6e3a27864ab166fe);
$parcel$export(module.exports, "div", () => $4ce98914b6676340$export$159d9494db57879b);
$parcel$export(module.exports, "dist", () => $4ce98914b6676340$export$6c4a311cc157c764);
$parcel$export(module.exports, "sqrDist", () => $4ce98914b6676340$export$2422cd6c492a8b3a);
$parcel$export(module.exports, "sqrLen", () => $4ce98914b6676340$export$99d8dd3f32a3435);
$parcel$export(module.exports, "forEach", () => $4ce98914b6676340$export$4b80e395e36b5a56);

var $amnUE = parcelRequire("amnUE");
function $4ce98914b6676340$export$185802fd694ee1f5() {
    var out = new $amnUE.ARRAY_TYPE(2);
    if ($amnUE.ARRAY_TYPE != Float32Array) {
        out[0] = 0;
        out[1] = 0;
    }
    return out;
}
function $4ce98914b6676340$export$9cd59f9826255e47(a) {
    var out = new $amnUE.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$a82be99ed2a44a7d(x, y) {
    var out = new $amnUE.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$784d13d8ee351f07(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
}
function $4ce98914b6676340$export$adaa4cf7ef1b65be(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
}
function $4ce98914b6676340$export$e16d8520af44a096(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
}
function $4ce98914b6676340$export$4e2d2ead65e5f7e3(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
}
function $4ce98914b6676340$export$2060d2db72cce88f(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
}
function $4ce98914b6676340$export$cd007d971a5a2143(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
}
function $4ce98914b6676340$export$803ce6b71a0a94b2(out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
}
function $4ce98914b6676340$export$a3fe094919f356fd(out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
}
function $4ce98914b6676340$export$96ec731ed4dcb222(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$8960430cfd85939f(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
}
function $4ce98914b6676340$export$2077e0241d6afd3c(out, a) {
    out[0] = $amnUE.round(a[0]);
    out[1] = $amnUE.round(a[1]);
    return out;
}
function $4ce98914b6676340$export$dcdf75081b88279d(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
}
function $4ce98914b6676340$export$19cedf1da84ba854(out, a, b, scale) {
    out[0] = a[0] + b[0] * scale;
    out[1] = a[1] + b[1] * scale;
    return out;
}
function $4ce98914b6676340$export$9f17032d917177de(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return Math.sqrt(x * x + y * y);
}
function $4ce98914b6676340$export$88e6ebb4fe54f538(a, b) {
    var x = b[0] - a[0], y = b[1] - a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$f24224f1c91d8156(a) {
    var x = a[0], y = a[1];
    return Math.sqrt(x * x + y * y);
}
function $4ce98914b6676340$export$ab44e1323ffc8376(a) {
    var x = a[0], y = a[1];
    return x * x + y * y;
}
function $4ce98914b6676340$export$aef51622e549b8b0(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
}
function $4ce98914b6676340$export$70ae2c07e401031b(out, a) {
    out[0] = 1.0 / a[0];
    out[1] = 1.0 / a[1];
    return out;
}
function $4ce98914b6676340$export$a3295358bff77e(out, a) {
    var x = a[0], y = a[1];
    var len = x * x + y * y;
    if (len > 0) //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
    out[0] = a[0] * len;
    out[1] = a[1] * len;
    return out;
}
function $4ce98914b6676340$export$94132a0e348806d4(a, b) {
    return a[0] * b[0] + a[1] * b[1];
}
function $4ce98914b6676340$export$bb646b20bb93d339(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
}
function $4ce98914b6676340$export$3a89f8d6f6bf6c9f(out, a, b, t) {
    var ax = a[0], ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
}
function $4ce98914b6676340$export$4385e60b38654f68(out, scale) {
    scale = scale === undefined ? 1.0 : scale;
    var r = $amnUE.RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
}
function $4ce98914b6676340$export$b732428d73874bfc(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
}
function $4ce98914b6676340$export$3e55bc4b3707dfd3(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
}
function $4ce98914b6676340$export$f0bfa0a0024626ee(out, a, m) {
    var x = a[0], y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
}
function $4ce98914b6676340$export$5ffbd13800309d59(out, a, m) {
    var x = a[0];
    var y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
}
function $4ce98914b6676340$export$bb628a54ab399bc9(out, a, b, rad) {
    //Translate point to the origin
    var p0 = a[0] - b[0], p1 = a[1] - b[1], sinC = Math.sin(rad), cosC = Math.cos(rad);
    //perform rotation and translate to correct position
    out[0] = p0 * cosC - p1 * sinC + b[0];
    out[1] = p0 * sinC + p1 * cosC + b[1];
    return out;
}
function $4ce98914b6676340$export$944b09d2ad10b378(a, b) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1];
    return Math.abs(Math.atan2(ay * bx - ax * by, ax * bx + ay * by));
}
function $4ce98914b6676340$export$2c039ab0034c6824(a, b) {
    var ax = a[0], ay = a[1], bx = b[0], by = b[1];
    return Math.atan2(ax * by - ay * bx, ax * bx + ay * by);
}
function $4ce98914b6676340$export$7f9972325ebfd559(out) {
    out[0] = 0.0;
    out[1] = 0.0;
    return out;
}
function $4ce98914b6676340$export$42d51816ce590c93(a) {
    return "vec2(" + a[0] + ", " + a[1] + ")";
}
function $4ce98914b6676340$export$f2599a5cf1109d8(a, b) {
    return a[0] === b[0] && a[1] === b[1];
}
function $4ce98914b6676340$export$e9bab7fafb253603(a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return Math.abs(a0 - b0) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= $amnUE.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1));
}
var $4ce98914b6676340$export$fc1400facf92c78 = $4ce98914b6676340$export$f24224f1c91d8156;
var $4ce98914b6676340$export$f93b5905241a7cca = $4ce98914b6676340$export$4e2d2ead65e5f7e3;
var $4ce98914b6676340$export$6e3a27864ab166fe = $4ce98914b6676340$export$2060d2db72cce88f;
var $4ce98914b6676340$export$159d9494db57879b = $4ce98914b6676340$export$cd007d971a5a2143;
var $4ce98914b6676340$export$6c4a311cc157c764 = $4ce98914b6676340$export$9f17032d917177de;
var $4ce98914b6676340$export$2422cd6c492a8b3a = $4ce98914b6676340$export$88e6ebb4fe54f538;
var $4ce98914b6676340$export$99d8dd3f32a3435 = $4ce98914b6676340$export$ab44e1323ffc8376;
var $4ce98914b6676340$export$4b80e395e36b5a56 = function() {
    var vec = $4ce98914b6676340$export$185802fd694ee1f5();
    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if (!stride) stride = 2;
        if (!offset) offset = 0;
        if (count) l = Math.min(count * stride + offset, a.length);
        else l = a.length;
        for(i = offset; i < l; i += stride){
            vec[0] = a[i];
            vec[1] = a[i + 1];
            fn(vec, vec, arg);
            a[i] = vec[0];
            a[i + 1] = vec[1];
        }
        return a;
    };
}();

});

parcelRegister("bnGdl", function(module, exports) {
function $84929694f9ad646d$var$_readOnlyError(r) {
    throw new TypeError('"' + r + '" is read-only');
}
module.exports = $84929694f9ad646d$var$_readOnlyError, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8hhuV", function(module, exports) {

$parcel$export(module.exports, "default", () => $606d7bf4931d4604$export$2e2bcd8739ae039);
var $606d7bf4931d4604$var$clamp = function(a, min, max) {
    if (a < min) return min;
    else if (a > max) return max;
    return a;
};
var $606d7bf4931d4604$export$2e2bcd8739ae039 = $606d7bf4931d4604$var$clamp;

});

parcelRegister("lIA8Y", function(module, exports) {

$parcel$export(module.exports, "clonePath", () => $fcf9be71277d2974$export$18711d956bf1c3eb);
function $fcf9be71277d2974$export$18711d956bf1c3eb(path) {
    return path.map(function(x) {
        return Array.isArray(x) ? [].concat(x) : x;
    });
}

});

parcelRegister("aoFex", function(module, exports) {

$parcel$export(module.exports, "distanceSquareRoot", () => $791c21612438fd99$export$56722444be4afaff);
function $791c21612438fd99$export$56722444be4afaff(a, b) {
    return Math.sqrt((a[0] - b[0]) * (a[0] - b[0]) + (a[1] - b[1]) * (a[1] - b[1]));
}

});

parcelRegister("gAC5x", function(module, exports) {

$parcel$export(module.exports, "equalizeSegments", () => $c13d8db17c7af24c$export$61c376ab912a104b);

var $8bNtF = parcelRequire("8bNtF");

var $kJUxO = parcelRequire("kJUxO");
var $c13d8db17c7af24c$var$MAX_RECURSION_DEPTH = 50;
function $c13d8db17c7af24c$var$splitCubic(pts, t) {
    if (t === void 0) t = 0.5;
    var p0 = pts.slice(0, 2);
    var p1 = pts.slice(2, 4);
    var p2 = pts.slice(4, 6);
    var p3 = pts.slice(6, 8);
    var p4 = (0, $8bNtF.midPoint)(p0, p1, t);
    var p5 = (0, $8bNtF.midPoint)(p1, p2, t);
    var p6 = (0, $8bNtF.midPoint)(p2, p3, t);
    var p7 = (0, $8bNtF.midPoint)(p4, p5, t);
    var p8 = (0, $8bNtF.midPoint)(p5, p6, t);
    var p9 = (0, $8bNtF.midPoint)(p7, p8, t);
    return [
        // @ts-ignore
        [
            'C'
        ].concat(p4, p7, p9),
        // @ts-ignore
        [
            'C'
        ].concat(p8, p6, p3)
    ];
}
function $c13d8db17c7af24c$var$getCurveArray(segments) {
    return segments.map(function(segment, i, pathArray) {
        // @ts-ignore
        var segmentData = i && pathArray[i - 1].slice(-2).concat(segment.slice(1));
        // @ts-ignore
        var curveLength = i ? (0, $kJUxO.segmentCubicFactory)(segmentData[0], segmentData[1], segmentData[2], segmentData[3], segmentData[4], segmentData[5], segmentData[6], segmentData[7], segmentData[8], {
            bbox: false
        }).length : 0;
        var subsegs;
        if (i) // must be [segment,segment]
        subsegs = curveLength ? $c13d8db17c7af24c$var$splitCubic(segmentData) : [
            segment,
            segment
        ];
        else subsegs = [
            segment
        ];
        return {
            s: segment,
            ss: subsegs,
            l: curveLength
        };
    });
}
function $c13d8db17c7af24c$export$61c376ab912a104b(path1, path2, TL, depth) {
    if (depth === void 0) depth = 0;
    if (depth > $c13d8db17c7af24c$var$MAX_RECURSION_DEPTH) {
        console.warn('Maximum recursion depth reached in equalizeSegments');
        return [
            path1,
            path2
        ];
    }
    var c1 = $c13d8db17c7af24c$var$getCurveArray(path1);
    var c2 = $c13d8db17c7af24c$var$getCurveArray(path2);
    var L1 = c1.length;
    var L2 = c2.length;
    var l1 = c1.filter(function(x) {
        return x.l;
    }).length;
    var l2 = c2.filter(function(x) {
        return x.l;
    }).length;
    var m1 = c1.filter(function(x) {
        return x.l;
    }).reduce(function(a, _a) {
        var l = _a.l;
        return a + l;
    }, 0) / l1 || 0;
    var m2 = c2.filter(function(x) {
        return x.l;
    }).reduce(function(a, _a) {
        var l = _a.l;
        return a + l;
    }, 0) / l2 || 0;
    var tl = TL || Math.max(L1, L2);
    var mm = [
        m1,
        m2
    ];
    var dif = [
        tl - L1,
        tl - L2
    ];
    var canSplit = 0;
    var result = [
        c1,
        c2
    ].map(function(x, i) {
        // @ts-ignore
        return x.l === tl ? x.map(function(y) {
            return y.s;
        }) : x.map(function(y, j) {
            canSplit = j && dif[i] && y.l >= mm[i];
            dif[i] -= canSplit ? 1 : 0;
            return canSplit ? y.ss : [
                y.s
            ];
        }).flat();
    });
    return result[0].length === result[1].length ? result : $c13d8db17c7af24c$export$61c376ab912a104b(result[0], result[1], tl, depth + 1);
}

});
parcelRegister("8bNtF", function(module, exports) {

$parcel$export(module.exports, "midPoint", () => $5f65bafc8b757175$export$58ee41e7a61980d3);
function $5f65bafc8b757175$export$58ee41e7a61980d3(a, b, t) {
    var ax = a[0];
    var ay = a[1];
    var bx = b[0];
    var by = b[1];
    return [
        ax + (bx - ax) * t,
        ay + (by - ay) * t
    ];
}

});

parcelRegister("kJUxO", function(module, exports) {

$parcel$export(module.exports, "segmentCubicFactory", () => $f193df27fca7f061$export$558a0541a45929b4);

var $aoFex = parcelRequire("aoFex");
/**
 * Returns a {x,y} point at a given length, the total length and
 * the minimum and maximum {x,y} coordinates of a C (cubic-bezier) segment.
 */ function $f193df27fca7f061$var$getPointAtCubicSegmentLength(x1, y1, c1x, c1y, c2x, c2y, x2, y2, t) {
    var t1 = 1 - t;
    return {
        x: Math.pow(t1, 3) * x1 + 3 * Math.pow(t1, 2) * t * c1x + 3 * t1 * Math.pow(t, 2) * c2x + Math.pow(t, 3) * x2,
        y: Math.pow(t1, 3) * y1 + 3 * Math.pow(t1, 2) * t * c1y + 3 * t1 * Math.pow(t, 2) * c2y + Math.pow(t, 3) * y2
    };
}
function $f193df27fca7f061$export$558a0541a45929b4(x1, y1, c1x, c1y, c2x, c2y, x2, y2, distance, options) {
    var _a;
    var _b = options.bbox, bbox = _b === void 0 ? true : _b, _c = options.length, length = _c === void 0 ? true : _c, _d = options.sampleSize, sampleSize = _d === void 0 ? 10 : _d;
    var distanceIsNumber = typeof distance === 'number';
    var x = x1;
    var y = y1;
    var LENGTH = 0;
    var prev = [
        x,
        y,
        LENGTH
    ];
    var cur = [
        x,
        y
    ];
    var t = 0;
    var POINT = {
        x: 0,
        y: 0
    };
    var POINTS = [
        {
            x: x,
            y: y
        }
    ];
    if (distanceIsNumber && distance <= 0) POINT = {
        x: x,
        y: y
    };
    // bad perf when size = 300
    for(var j = 0; j <= sampleSize; j += 1){
        t = j / sampleSize;
        _a = $f193df27fca7f061$var$getPointAtCubicSegmentLength(x1, y1, c1x, c1y, c2x, c2y, x2, y2, t), x = _a.x, y = _a.y;
        if (bbox) POINTS.push({
            x: x,
            y: y
        });
        if (length) LENGTH += (0, $aoFex.distanceSquareRoot)(cur, [
            x,
            y
        ]);
        cur = [
            x,
            y
        ];
        if (distanceIsNumber && LENGTH >= distance && distance > prev[2]) {
            var dv = (LENGTH - distance) / (LENGTH - prev[2]);
            POINT = {
                x: cur[0] * (1 - dv) + prev[0] * dv,
                y: cur[1] * (1 - dv) + prev[1] * dv
            };
        }
        prev = [
            x,
            y,
            LENGTH
        ];
    }
    if (distanceIsNumber && distance >= LENGTH) POINT = {
        x: x2,
        y: y2
    };
    return {
        length: LENGTH,
        point: POINT,
        min: {
            x: Math.min.apply(null, POINTS.map(function(n) {
                return n.x;
            })),
            y: Math.min.apply(null, POINTS.map(function(n) {
                return n.y;
            }))
        },
        max: {
            x: Math.max.apply(null, POINTS.map(function(n) {
                return n.x;
            })),
            y: Math.max.apply(null, POINTS.map(function(n) {
                return n.y;
            }))
        }
    };
}

});


parcelRegister("bqypU", function(module, exports) {

$parcel$export(module.exports, "getDrawDirection", () => $851cd1e7bc9cc49d$export$14e20ed9bb18e016);

var $dgeSM = parcelRequire("dgeSM");
function $851cd1e7bc9cc49d$export$14e20ed9bb18e016(pathArray) {
    return (0, $dgeSM.getPathArea)(pathArray) >= 0;
}

});
parcelRegister("dgeSM", function(module, exports) {

$parcel$export(module.exports, "getPathArea", () => $9a78505c7267dea6$export$7681076470533cd9);

var $7Tbfw = parcelRequire("7Tbfw");
/**
 * Returns the area of a single cubic-bezier segment.
 *
 * http://objectmix.com/graphics/133553-area-closed-bezier-curve.html
 */ function $9a78505c7267dea6$var$getCubicSegArea(x1, y1, c1x, c1y, c2x, c2y, x2, y2) {
    // https://stackoverflow.com/a/15845996
    return 3 * ((y2 - y1) * (c1x + c2x) - (x2 - x1) * (c1y + c2y) + c1y * (x1 - c2x) - c1x * (y1 - c2y) + y2 * (c2x + x1 / 3) - x2 * (c2y + y1 / 3)) / 20;
}
function $9a78505c7267dea6$export$7681076470533cd9(path) {
    var x = 0;
    var y = 0;
    var len = 0;
    return (0, $7Tbfw.path2Curve)(path).map(function(seg) {
        var _a;
        switch(seg[0]){
            case 'M':
                x = seg[1], y = seg[2];
                return 0;
            default:
                // @ts-ignore
                var _b = seg.slice(1), c1x = _b[0], c1y = _b[1], c2x = _b[2], c2y = _b[3], x2 = _b[4], y2 = _b[5];
                len = $9a78505c7267dea6$var$getCubicSegArea(x, y, c1x, c1y, c2x, c2y, x2, y2);
                _a = seg.slice(-2), x = _a[0], y = _a[1];
                return len;
        }
    }).reduce(function(a, b) {
        return a + b;
    }, 0);
} // export function getPathArea(pathArray: AbsoluteArray) {
 //   let x = 0;
 //   let y = 0;
 //   let mx = 0;
 //   let my = 0;
 //   let len = 0;
 //   return pathArray
 //     .map((seg) => {
 //       switch (seg[0]) {
 //         case 'M':
 //         case 'Z':
 //           mx = seg[0] === 'M' ? seg[1] : mx;
 //           my = seg[0] === 'M' ? seg[2] : my;
 //           x = mx;
 //           y = my;
 //           return 0;
 //         default:
 //           // @ts-ignore
 //           len = getCubicSegArea.apply(0, [x, y].concat(seg.slice(1)));
 //           [x, y] = seg.slice(-2) as [number, number];
 //           return len;
 //       }
 //     })
 //     .reduce((a, b) => a + b, 0);
 // }

});
parcelRegister("7Tbfw", function(module, exports) {

$parcel$export(module.exports, "path2Curve", () => $5be6655912dc0a24$export$a44d33e86876c303);

var $7WQrb = parcelRequire("7WQrb");

var $98aG8 = parcelRequire("98aG8");

var $6XFDb = parcelRequire("6XFDb");

var $dnxxK = parcelRequire("dnxxK");

var $fRiqm = parcelRequire("fRiqm");

var $ioCSG = parcelRequire("ioCSG");
function $5be6655912dc0a24$export$a44d33e86876c303(pathInput, needZCommandIndexes) {
    if (needZCommandIndexes === void 0) needZCommandIndexes = false;
    if ((0, $fRiqm.isCurveArray)(pathInput)) {
        var cloned = [].concat(pathInput);
        if (needZCommandIndexes) return [
            cloned,
            []
        ];
        else return cloned;
    }
    // fixPath will remove 'Z' command
    // const path = fixPath(normalizePath(pathInput));
    var path = (0, $dnxxK.normalizePath)(pathInput);
    var params = (0, $7WQrb.__assign)({}, (0, $98aG8.paramsParser));
    var allPathCommands = [];
    var pathCommand = '';
    var ii = path.length;
    var segment;
    var seglen;
    var zCommandIndexes = [];
    for(var i = 0; i < ii; i += 1){
        if (path[i]) pathCommand = path[i][0];
        allPathCommands[i] = pathCommand;
        var curveSegment = (0, $ioCSG.segmentToCubic)(path[i], params);
        path[i] = curveSegment;
        (0, $6XFDb.fixArc)(path, allPathCommands, i);
        ii = path.length; // solves curveArrays ending in Z
        // keep Z command account for lineJoin
        // @see https://github.com/antvis/util/issues/68
        if (pathCommand === 'Z') zCommandIndexes.push(i);
        segment = path[i];
        seglen = segment.length;
        params.x1 = +segment[seglen - 2];
        params.y1 = +segment[seglen - 1];
        params.x2 = +segment[seglen - 4] || params.x1;
        params.y2 = +segment[seglen - 3] || params.y1;
    }
    // validate
    if (needZCommandIndexes) return [
        path,
        zCommandIndexes
    ];
    else return path;
}

});
parcelRegister("7WQrb", function(module, exports) {

$parcel$export(module.exports, "__extends", () => $5c96a02c592fcff1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $5c96a02c592fcff1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $5c96a02c592fcff1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $5c96a02c592fcff1$export$1050f835b63b671e);
$parcel$export(module.exports, "__values", () => $5c96a02c592fcff1$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $5c96a02c592fcff1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArrays", () => $5c96a02c592fcff1$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $5c96a02c592fcff1$export$1216008129fb82ed);
$parcel$export(module.exports, "__classPrivateFieldGet", () => $5c96a02c592fcff1$export$d5dcaf168c640c35);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};

});

parcelRegister("98aG8", function(module, exports) {

$parcel$export(module.exports, "paramsParser", () => $6a5d24f1a1a33f09$export$b197644df460f8b1);
var $6a5d24f1a1a33f09$export$b197644df460f8b1 = {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    x: 0,
    y: 0,
    qx: null,
    qy: null
};

});

parcelRegister("6XFDb", function(module, exports) {

$parcel$export(module.exports, "fixArc", () => $51188bd5cbba4f11$export$f31e0719c298a9a6);
function $51188bd5cbba4f11$export$f31e0719c298a9a6(pathArray, allPathCommands, i) {
    if (pathArray[i].length > 7) {
        pathArray[i].shift();
        var pi = pathArray[i];
        // const ni = i + 1;
        var ni = i;
        while(pi.length){
            // if created multiple C:s, their original seg is saved
            allPathCommands[i] = 'A';
            // @ts-ignore
            pathArray.splice(ni += 1, 0, [
                'C'
            ].concat(pi.splice(0, 6)));
        }
        pathArray.splice(i, 1);
    }
}

});

parcelRegister("dnxxK", function(module, exports) {

$parcel$export(module.exports, "normalizePath", () => $9bd7715916e98e56$export$6af368f973c74c5);

var $7WQrb = parcelRequire("7WQrb");

var $6M9GU = parcelRequire("6M9GU");

var $98aG8 = parcelRequire("98aG8");

var $b7Q1z = parcelRequire("b7Q1z");

var $bwWpb = parcelRequire("bwWpb");
function $9bd7715916e98e56$export$6af368f973c74c5(pathInput) {
    if ((0, $6M9GU.isNormalizedArray)(pathInput)) return [].concat(pathInput);
    var path = (0, $b7Q1z.path2Absolute)(pathInput);
    var params = (0, $7WQrb.__assign)({}, (0, $98aG8.paramsParser));
    for(var i = 0; i < path.length; i += 1){
        // Save current path command
        path[i] = (0, $bwWpb.normalizeSegment)(path[i], params);
        var segment = path[i];
        var seglen = segment.length;
        params.x1 = +segment[seglen - 2];
        params.y1 = +segment[seglen - 1];
        params.x2 = +segment[seglen - 4] || params.x1;
        params.y2 = +segment[seglen - 3] || params.y1;
    }
    return path;
}

});
parcelRegister("6M9GU", function(module, exports) {

$parcel$export(module.exports, "isNormalizedArray", () => $4eeebe383495da15$export$3cb783b2fba7a1c3);

var $3n9Zo = parcelRequire("3n9Zo");
function $4eeebe383495da15$export$3cb783b2fba7a1c3(path) {
    return (0, $3n9Zo.isAbsoluteArray)(path) && path.every(function(_a) {
        var pc = _a[0];
        return 'ACLMQZ'.includes(pc);
    });
}

});
parcelRegister("3n9Zo", function(module, exports) {

$parcel$export(module.exports, "isAbsoluteArray", () => $274b44c017b684c7$export$e7bc78d1ea877c1);

var $hU5u6 = parcelRequire("hU5u6");
function $274b44c017b684c7$export$e7bc78d1ea877c1(path) {
    return (0, $hU5u6.isPathArray)(path) && // @ts-ignore -- `isPathArray` also checks if it's `Array`
    path.every(function(_a) {
        var x = _a[0];
        return x === x.toUpperCase();
    });
}

});
parcelRegister("hU5u6", function(module, exports) {

$parcel$export(module.exports, "isPathArray", () => $d08bebbb4ba695c3$export$ce72c156cd6a99f9);

var $abSfe = parcelRequire("abSfe");
function $d08bebbb4ba695c3$export$ce72c156cd6a99f9(path) {
    return Array.isArray(path) && path.every(function(seg) {
        var lk = seg[0].toLowerCase();
        return (0, $abSfe.paramsCount)[lk] === seg.length - 1 && 'achlmqstvz'.includes(lk);
    });
}

});
parcelRegister("abSfe", function(module, exports) {

$parcel$export(module.exports, "paramsCount", () => $76b50252fea00915$export$b7a4b31d242f9465);
var $76b50252fea00915$export$b7a4b31d242f9465 = {
    a: 7,
    c: 6,
    h: 1,
    l: 2,
    m: 2,
    r: 4,
    q: 4,
    s: 4,
    t: 2,
    v: 1,
    z: 0
};

});




parcelRegister("b7Q1z", function(module, exports) {

$parcel$export(module.exports, "path2Absolute", () => $02171badef670d9f$export$77685c95539b1b96);

var $3n9Zo = parcelRequire("3n9Zo");

var $bvBSG = parcelRequire("bvBSG");
function $02171badef670d9f$export$77685c95539b1b96(pathInput) {
    if ((0, $3n9Zo.isAbsoluteArray)(pathInput)) return [].concat(pathInput);
    var path = (0, $bvBSG.parsePathString)(pathInput);
    // if (!path || !path.length) {
    //   return [['M', 0, 0]];
    // }
    var x = 0;
    var y = 0;
    var mx = 0;
    var my = 0;
    // @ts-ignore
    return path.map(function(segment) {
        var values = segment.slice(1).map(Number);
        var pathCommand = segment[0];
        var absCommand = pathCommand.toUpperCase();
        if (pathCommand === 'M') {
            x = values[0], y = values[1];
            mx = x;
            my = y;
            return [
                'M',
                x,
                y
            ];
        }
        var absoluteSegment;
        if (pathCommand !== absCommand) switch(absCommand){
            case 'A':
                absoluteSegment = [
                    absCommand,
                    values[0],
                    values[1],
                    values[2],
                    values[3],
                    values[4],
                    values[5] + x,
                    values[6] + y
                ];
                break;
            case 'V':
                absoluteSegment = [
                    absCommand,
                    values[0] + y
                ];
                break;
            case 'H':
                absoluteSegment = [
                    absCommand,
                    values[0] + x
                ];
                break;
            default:
                // use brakets for `eslint: no-case-declaration`
                // https://stackoverflow.com/a/50753272/803358
                var absValues = values.map(function(n, j) {
                    return n + (j % 2 ? y : x);
                });
                // for n, l, c, s, q, t
                // @ts-ignore
                absoluteSegment = [
                    absCommand
                ].concat(absValues);
        }
        else // @ts-ignore
        absoluteSegment = [
            absCommand
        ].concat(values);
        var segLength = absoluteSegment.length;
        switch(absCommand){
            case 'Z':
                x = mx;
                y = my;
                break;
            case 'H':
                x = absoluteSegment[1];
                break;
            case 'V':
                y = absoluteSegment[1];
                break;
            default:
                x = absoluteSegment[segLength - 2];
                y = absoluteSegment[segLength - 1];
                if (absCommand === 'M') {
                    mx = x;
                    my = y;
                }
        }
        return absoluteSegment;
    });
}

});
parcelRegister("bvBSG", function(module, exports) {

$parcel$export(module.exports, "parsePathString", () => $860ff953f8e7b8e1$export$48bd7795c8106392);

var $hU5u6 = parcelRequire("hU5u6");

var $jfdFp = parcelRequire("jfdFp");

var $hn6XV = parcelRequire("hn6XV");

var $hHA8n = parcelRequire("hHA8n");
function $860ff953f8e7b8e1$export$48bd7795c8106392(pathInput) {
    if ((0, $hU5u6.isPathArray)(pathInput)) return [].concat(pathInput);
    var path = new (0, $hHA8n.PathParser)(pathInput);
    (0, $hn6XV.skipSpaces)(path);
    while(path.index < path.max && !path.err.length)(0, $jfdFp.scanSegment)(path);
    return path.err ? path.err : path.segments;
}

});
parcelRegister("jfdFp", function(module, exports) {

$parcel$export(module.exports, "scanSegment", () => $e02a04fa81fbf042$export$63a1b06c620672f8);

var $lIhmn = parcelRequire("lIhmn");

var $abSfe = parcelRequire("abSfe");

var $8npYx = parcelRequire("8npYx");

var $joolH = parcelRequire("joolH");

var $hn6XV = parcelRequire("hn6XV");

var $9V4v4 = parcelRequire("9V4v4");

var $4282W = parcelRequire("4282W");

var $inyiT = parcelRequire("inyiT");
function $e02a04fa81fbf042$export$63a1b06c620672f8(path) {
    var max = path.max, pathValue = path.pathValue, index = path.index;
    var cmdCode = pathValue.charCodeAt(index);
    var reqParams = (0, $abSfe.paramsCount)[pathValue[index].toLowerCase()];
    path.segmentStart = index;
    if (!(0, $9V4v4.isPathCommand)(cmdCode)) {
        path.err = "[path-util]: Invalid path value \"".concat(pathValue[index], "\" is not a path command");
        return;
    }
    path.index += 1;
    (0, $hn6XV.skipSpaces)(path);
    path.data = [];
    if (!reqParams) {
        // Z
        (0, $lIhmn.finalizeSegment)(path);
        return;
    }
    for(;;){
        for(var i = reqParams; i > 0; i -= 1){
            if ((0, $inyiT.isArcCommand)(cmdCode) && (i === 3 || i === 4)) (0, $8npYx.scanFlag)(path);
            else (0, $joolH.scanParam)(path);
            if (path.err.length) return;
            path.data.push(path.param);
            (0, $hn6XV.skipSpaces)(path);
            // after ',' param is mandatory
            if (path.index < max && pathValue.charCodeAt(path.index) === 0x2c /* , */ ) {
                path.index += 1;
                (0, $hn6XV.skipSpaces)(path);
            }
        }
        if (path.index >= path.max) break;
        // Stop on next segment
        if (!(0, $4282W.isDigitStart)(pathValue.charCodeAt(path.index))) break;
    }
    (0, $lIhmn.finalizeSegment)(path);
}

});
parcelRegister("lIhmn", function(module, exports) {

$parcel$export(module.exports, "finalizeSegment", () => $fceb2c5d86e28cbb$export$4ca0e665cf9f0cd4);

var $abSfe = parcelRequire("abSfe");
function $fceb2c5d86e28cbb$export$4ca0e665cf9f0cd4(path) {
    var pathCommand = path.pathValue[path.segmentStart];
    var LK = pathCommand.toLowerCase();
    var data = path.data;
    while(data.length >= (0, $abSfe.paramsCount)[LK]){
        // overloaded `moveTo`
        // https://github.com/rveciana/svg-path-properties/blob/master/src/parse.ts
        if (LK === 'm' && data.length > 2) {
            // @ts-ignore
            path.segments.push([
                pathCommand
            ].concat(data.splice(0, 2)));
            LK = 'l';
            pathCommand = pathCommand === 'm' ? 'l' : 'L';
        } else // @ts-ignore
        path.segments.push([
            pathCommand
        ].concat(data.splice(0, (0, $abSfe.paramsCount)[LK])));
        if (!(0, $abSfe.paramsCount)[LK]) break;
    }
}

});

parcelRegister("8npYx", function(module, exports) {

$parcel$export(module.exports, "scanFlag", () => $61949ede14a4eb22$export$428539e89abeedc9);
/**
 * Validates an A (arc-to) specific path command value.
 * Usually a `large-arc-flag` or `sweep-flag`.
 */ function $61949ede14a4eb22$export$428539e89abeedc9(path) {
    var index = path.index, pathValue = path.pathValue;
    var code = pathValue.charCodeAt(index);
    if (code === 0x30 /* 0 */ ) {
        path.param = 0;
        path.index += 1;
        return;
    }
    if (code === 0x31 /* 1 */ ) {
        path.param = 1;
        path.index += 1;
        return;
    }
    path.err = "[path-util]: invalid Arc flag \"".concat(pathValue[index], "\", expecting 0 or 1 at index ").concat(index);
}

});

parcelRegister("joolH", function(module, exports) {

$parcel$export(module.exports, "scanParam", () => $e1e3256ddbe206e3$export$2f8ec86071c1ac2d);

var $4282W = parcelRequire("4282W");
function $e1e3256ddbe206e3$export$2f8ec86071c1ac2d(path) {
    var max = path.max, pathValue = path.pathValue, start = path.index;
    var index = start;
    var zeroFirst = false;
    var hasCeiling = false;
    var hasDecimal = false;
    var hasDot = false;
    var ch;
    if (index >= max) {
        // path.err = 'SvgPath: missed param (at pos ' + index + ')';
        path.err = "[path-util]: Invalid path value at index ".concat(index, ", \"pathValue\" is missing param");
        return;
    }
    ch = pathValue.charCodeAt(index);
    if (ch === 0x2b /* + */  || ch === 0x2d /* - */ ) {
        index += 1;
        // ch = (index < max) ? pathValue.charCodeAt(index) : 0;
        ch = pathValue.charCodeAt(index);
    }
    // This logic is shamelessly borrowed from Esprima
    // https://github.com/ariya/esprimas
    if (!(0, $4282W.isDigit)(ch) && ch !== 0x2e /* . */ ) {
        // path.err = 'SvgPath: param should start with 0..9 or `.` (at pos ' + index + ')';
        path.err = "[path-util]: Invalid path value at index ".concat(index, ", \"").concat(pathValue[index], "\" is not a number");
        return;
    }
    if (ch !== 0x2e /* . */ ) {
        zeroFirst = ch === 0x30 /* 0 */ ;
        index += 1;
        ch = pathValue.charCodeAt(index);
        if (zeroFirst && index < max) // decimal number starts with '0' such as '09' is illegal.
        {
            if (ch && (0, $4282W.isDigit)(ch)) {
                // path.err = 'SvgPath: numbers started with `0` such as `09`
                // are illegal (at pos ' + start + ')';
                path.err = "[path-util]: Invalid path value at index ".concat(start, ", \"").concat(pathValue[start], "\" illegal number");
                return;
            }
        }
        while(index < max && (0, $4282W.isDigit)(pathValue.charCodeAt(index))){
            index += 1;
            hasCeiling = true;
        }
        ch = pathValue.charCodeAt(index);
    }
    if (ch === 0x2e /* . */ ) {
        hasDot = true;
        index += 1;
        while((0, $4282W.isDigit)(pathValue.charCodeAt(index))){
            index += 1;
            hasDecimal = true;
        }
        ch = pathValue.charCodeAt(index);
    }
    if (ch === 0x65 /* e */  || ch === 0x45 /* E */ ) {
        if (hasDot && !hasCeiling && !hasDecimal) {
            path.err = "[path-util]: Invalid path value at index ".concat(index, ", \"").concat(pathValue[index], "\" invalid float exponent");
            return;
        }
        index += 1;
        ch = pathValue.charCodeAt(index);
        if (ch === 0x2b /* + */  || ch === 0x2d /* - */ ) index += 1;
        if (index < max && (0, $4282W.isDigit)(pathValue.charCodeAt(index))) while(index < max && (0, $4282W.isDigit)(pathValue.charCodeAt(index)))index += 1;
        else {
            path.err = "[path-util]: Invalid path value at index ".concat(index, ", \"").concat(pathValue[index], "\" invalid integer exponent");
            return;
        }
    }
    path.index = index;
    path.param = +path.pathValue.slice(start, index);
}

});
parcelRegister("4282W", function(module, exports) {

$parcel$export(module.exports, "isDigitStart", () => $2efd9731af5ea909$export$9acba3509112782a);
$parcel$export(module.exports, "isDigit", () => $2efd9731af5ea909$export$727d9dbc4fbb948f);
/**
 * Checks if the character is or belongs to a number.
 * [0-9]|+|-|.
 */ function $2efd9731af5ea909$export$9acba3509112782a(code) {
    return code >= 48 && code <= 57 || code === 0x2b /* + */  || code === 0x2d /* - */  || code === 0x2e; /* . */ 
}
function $2efd9731af5ea909$export$727d9dbc4fbb948f(code) {
    return code >= 48 && code <= 57; // 0..9
}

});


parcelRegister("hn6XV", function(module, exports) {

$parcel$export(module.exports, "skipSpaces", () => $ca59fce16c1f582b$export$c85b81cf4e701929);

var $aeUrB = parcelRequire("aeUrB");
function $ca59fce16c1f582b$export$c85b81cf4e701929(path) {
    var pathValue = path.pathValue, max = path.max;
    while(path.index < max && (0, $aeUrB.isSpace)(pathValue.charCodeAt(path.index)))path.index += 1;
}

});
parcelRegister("aeUrB", function(module, exports) {

$parcel$export(module.exports, "isSpace", () => $7746fed0595f9369$export$1d5ccafae59b4926);
/**
 * Checks if the character is a space.
 */ function $7746fed0595f9369$export$1d5ccafae59b4926(ch) {
    var specialSpaces = [
        0x1680,
        0x180e,
        0x2000,
        0x2001,
        0x2002,
        0x2003,
        0x2004,
        0x2005,
        0x2006,
        0x2007,
        0x2008,
        0x2009,
        0x200a,
        0x202f,
        0x205f,
        0x3000,
        0xfeff
    ];
    /* istanbul ignore next */ return ch === 0x0a || ch === 0x0d || ch === 0x2028 || ch === 0x2029 || // Line terminators
    // White spaces
    ch === 0x20 || ch === 0x09 || ch === 0x0b || ch === 0x0c || ch === 0xa0 || ch >= 0x1680 && specialSpaces.includes(ch);
}

});


parcelRegister("9V4v4", function(module, exports) {

$parcel$export(module.exports, "isPathCommand", () => $738ced8ed63ebff5$export$ed8165debcda0cf4);
/**
 * Checks if the character is a path command.
 */ function $738ced8ed63ebff5$export$ed8165debcda0cf4(code) {
    // eslint-disable-next-line no-bitwise -- Impossible to satisfy
    switch(code | 0x20){
        case 0x6d /* m */ :
        case 0x7a /* z */ :
        case 0x6c /* l */ :
        case 0x68 /* h */ :
        case 0x76 /* v */ :
        case 0x63 /* c */ :
        case 0x73 /* s */ :
        case 0x71 /* q */ :
        case 0x74 /* t */ :
        case 0x61 /* a */ :
            // case 0x72/* r */:
            return true;
        default:
            return false;
    }
}

});

parcelRegister("inyiT", function(module, exports) {

$parcel$export(module.exports, "isArcCommand", () => $d614fbfdca6823f9$export$e0ec2c3fbb0947c6);
/**
 * Checks if the character is an A (arc-to) path command.
 */ function $d614fbfdca6823f9$export$e0ec2c3fbb0947c6(code) {
    return (code | 0x20) === 0x61;
}

});


parcelRegister("hHA8n", function(module, exports) {

$parcel$export(module.exports, "PathParser", () => $ce327b4f3f47f60d$export$2c011581dc2d802);
/**
 * The `PathParser` is used by the `parsePathString` static method
 * to generate a `pathArray`.
 */ var $ce327b4f3f47f60d$export$2c011581dc2d802 = /** @class */ function() {
    function PathParser(pathString) {
        this.pathValue = pathString;
        // @ts-ignore
        this.segments = [];
        this.max = pathString.length;
        this.index = 0;
        this.param = 0.0;
        this.segmentStart = 0;
        this.data = [];
        this.err = '';
    }
    return PathParser;
}();

});



parcelRegister("bwWpb", function(module, exports) {

$parcel$export(module.exports, "normalizeSegment", () => $864ffceb380a1c94$export$1c374b8be04af4a0);
/**
 * Normalizes a single segment of a `PathArray` object.
 * eg. H/V -> L, T -> Q
 */ function $864ffceb380a1c94$export$1c374b8be04af4a0(segment, params) {
    var pathCommand = segment[0];
    var px1 = params.x1, py1 = params.y1, px2 = params.x2, py2 = params.y2;
    var values = segment.slice(1).map(Number);
    var result = segment;
    if (!'TQ'.includes(pathCommand)) {
        // optional but good to be cautious
        params.qx = null;
        params.qy = null;
    }
    if (pathCommand === 'H') result = [
        'L',
        segment[1],
        py1
    ];
    else if (pathCommand === 'V') result = [
        'L',
        px1,
        segment[1]
    ];
    else if (pathCommand === 'S') {
        var x1 = px1 * 2 - px2;
        var y1 = py1 * 2 - py2;
        params.x1 = x1;
        params.y1 = y1;
        result = [
            'C',
            x1,
            y1
        ].concat(values);
    } else if (pathCommand === 'T') {
        var qx = px1 * 2 - params.qx;
        var qy = py1 * 2 - params.qy;
        params.qx = qx;
        params.qy = qy;
        result = [
            'Q',
            qx,
            qy
        ].concat(values);
    } else if (pathCommand === 'Q') {
        var nqx = values[0], nqy = values[1];
        params.qx = nqx;
        params.qy = nqy;
    }
    return result;
}

});


parcelRegister("fRiqm", function(module, exports) {

$parcel$export(module.exports, "isCurveArray", () => $b8ba18ee6d305769$export$a16fe3044aaa3daa);

var $6M9GU = parcelRequire("6M9GU");
function $b8ba18ee6d305769$export$a16fe3044aaa3daa(path) {
    return (0, $6M9GU.isNormalizedArray)(path) && path.every(function(_a) {
        var pc = _a[0];
        return 'MC'.includes(pc);
    });
}

});

parcelRegister("ioCSG", function(module, exports) {

$parcel$export(module.exports, "segmentToCubic", () => $d648a0d26b21d645$export$62fd4a9ffd749d82);

var $2PAX5 = parcelRequire("2PAX5");

var $k0gaE = parcelRequire("k0gaE");

var $cF3VT = parcelRequire("cF3VT");
function $d648a0d26b21d645$export$62fd4a9ffd749d82(segment, params) {
    var pathCommand = segment[0];
    var values = segment.slice(1).map(Number);
    var x = values[0], y = values[1];
    var args;
    var px1 = params.x1, py1 = params.y1, px = params.x, py = params.y;
    if (!'TQ'.includes(pathCommand)) {
        params.qx = null;
        params.qy = null;
    }
    switch(pathCommand){
        case 'M':
            params.x = x;
            params.y = y;
            return segment;
        case 'A':
            args = [
                px1,
                py1
            ].concat(values);
            // @ts-ignore
            return [
                'C'
            ].concat((0, $2PAX5.arcToCubic)(args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7], args[8], args[9]));
        case 'Q':
            params.qx = x;
            params.qy = y;
            args = [
                px1,
                py1
            ].concat(values);
            // @ts-ignore
            return [
                'C'
            ].concat((0, $k0gaE.quadToCubic)(args[0], args[1], args[2], args[3], args[4], args[5]));
        case 'L':
            // @ts-ignore
            return [
                'C'
            ].concat((0, $cF3VT.lineToCubic)(px1, py1, x, y));
        case 'Z':
            // prevent NaN from divide 0
            if (px1 === px && py1 === py) return [
                'C',
                px1,
                py1,
                px,
                py,
                px,
                py
            ];
            // @ts-ignore
            return [
                'C'
            ].concat((0, $cF3VT.lineToCubic)(px1, py1, px, py));
        default:
    }
    return segment;
}

});
parcelRegister("2PAX5", function(module, exports) {

$parcel$export(module.exports, "arcToCubic", () => $20fd021c4c22a0e6$export$95078ea75520a08f);

var $5V8ou = parcelRequire("5V8ou");
function $20fd021c4c22a0e6$export$95078ea75520a08f(X1, Y1, RX, RY, angle, LAF, SF, X2, Y2, recursive) {
    var x1 = X1;
    var y1 = Y1;
    var rx = RX;
    var ry = RY;
    var x2 = X2;
    var y2 = Y2;
    // for more information of where this Math came from visit:
    // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
    var d120 = Math.PI * 120 / 180;
    var rad = Math.PI / 180 * (+angle || 0);
    /** @type {number[]} */ var res = [];
    var xy;
    var f1;
    var f2;
    var cx;
    var cy;
    if (!recursive) {
        xy = (0, $5V8ou.rotateVector)(x1, y1, -rad);
        x1 = xy.x;
        y1 = xy.y;
        xy = (0, $5V8ou.rotateVector)(x2, y2, -rad);
        x2 = xy.x;
        y2 = xy.y;
        var x = (x1 - x2) / 2;
        var y = (y1 - y2) / 2;
        var h = x * x / (rx * rx) + y * y / (ry * ry);
        if (h > 1) {
            h = Math.sqrt(h);
            rx *= h;
            ry *= h;
        }
        var rx2 = rx * rx;
        var ry2 = ry * ry;
        var k = (LAF === SF ? -1 : 1) * Math.sqrt(Math.abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x)));
        cx = k * rx * y / ry + (x1 + x2) / 2;
        cy = k * -ry * x / rx + (y1 + y2) / 2;
        // eslint-disable-next-line no-bitwise -- Impossible to satisfy no-bitwise
        f1 = Math.asin(((y1 - cy) / ry * Math.pow(10, 9) >> 0) / Math.pow(10, 9));
        // eslint-disable-next-line no-bitwise -- Impossible to satisfy no-bitwise
        f2 = Math.asin(((y2 - cy) / ry * Math.pow(10, 9) >> 0) / Math.pow(10, 9));
        f1 = x1 < cx ? Math.PI - f1 : f1;
        f2 = x2 < cx ? Math.PI - f2 : f2;
        if (f1 < 0) f1 = Math.PI * 2 + f1;
        if (f2 < 0) f2 = Math.PI * 2 + f2;
        if (SF && f1 > f2) f1 -= Math.PI * 2;
        if (!SF && f2 > f1) f2 -= Math.PI * 2;
    } else f1 = recursive[0], f2 = recursive[1], cx = recursive[2], cy = recursive[3];
    var df = f2 - f1;
    if (Math.abs(df) > d120) {
        var f2old = f2;
        var x2old = x2;
        var y2old = y2;
        f2 = f1 + d120 * (SF && f2 > f1 ? 1 : -1);
        x2 = cx + rx * Math.cos(f2);
        y2 = cy + ry * Math.sin(f2);
        res = $20fd021c4c22a0e6$export$95078ea75520a08f(x2, y2, rx, ry, angle, 0, SF, x2old, y2old, [
            f2,
            f2old,
            cx,
            cy
        ]);
    }
    df = f2 - f1;
    var c1 = Math.cos(f1);
    var s1 = Math.sin(f1);
    var c2 = Math.cos(f2);
    var s2 = Math.sin(f2);
    var t = Math.tan(df / 4);
    var hx = 4 / 3 * rx * t;
    var hy = 4 / 3 * ry * t;
    var m1 = [
        x1,
        y1
    ];
    var m2 = [
        x1 + hx * s1,
        y1 - hy * c1
    ];
    var m3 = [
        x2 + hx * s2,
        y2 - hy * c2
    ];
    var m4 = [
        x2,
        y2
    ];
    m2[0] = 2 * m1[0] - m2[0];
    m2[1] = 2 * m1[1] - m2[1];
    if (recursive) return m2.concat(m3, m4, res);
    res = m2.concat(m3, m4, res);
    // res = [...m2, ...m3, ...m4, ...res];
    var newres = [];
    for(var i = 0, ii = res.length; i < ii; i += 1)newres[i] = i % 2 ? (0, $5V8ou.rotateVector)(res[i - 1], res[i], rad).y : (0, $5V8ou.rotateVector)(res[i], res[i + 1], rad).x;
    return newres;
} // const TAU = Math.PI * 2;
 // const mapToEllipse = (
 //   { x, y }: { x: number; y: number },
 //   rx: number,
 //   ry: number,
 //   cosphi: number,
 //   sinphi: number,
 //   centerx: number,
 //   centery: number,
 // ) => {
 //   x *= rx;
 //   y *= ry;
 //   const xp = cosphi * x - sinphi * y;
 //   const yp = sinphi * x + cosphi * y;
 //   return {
 //     x: xp + centerx,
 //     y: yp + centery,
 //   };
 // };
 // const approxUnitArc = (ang1: number, ang2: number) => {
 //   // If 90 degree circular arc, use a constant
 //   // as derived from http://spencermortensen.com/articles/bezier-circle
 //   const a =
 //     ang2 === 1.5707963267948966
 //       ? 0.551915024494
 //       : ang2 === -1.5707963267948966
 //       ? -0.551915024494
 //       : (4 / 3) * Math.tan(ang2 / 4);
 //   const x1 = Math.cos(ang1);
 //   const y1 = Math.sin(ang1);
 //   const x2 = Math.cos(ang1 + ang2);
 //   const y2 = Math.sin(ang1 + ang2);
 //   return [
 //     {
 //       x: x1 - y1 * a,
 //       y: y1 + x1 * a,
 //     },
 //     {
 //       x: x2 + y2 * a,
 //       y: y2 - x2 * a,
 //     },
 //     {
 //       x: x2,
 //       y: y2,
 //     },
 //   ];
 // };
 // const vectorAngle = (ux: number, uy: number, vx: number, vy: number) => {
 //   const sign = ux * vy - uy * vx < 0 ? -1 : 1;
 //   let dot = ux * vx + uy * vy;
 //   if (dot > 1) {
 //     dot = 1;
 //   }
 //   if (dot < -1) {
 //     dot = -1;
 //   }
 //   return sign * Math.acos(dot);
 // };
 // const getArcCenter = (
 //   px: any,
 //   py: any,
 //   cx: any,
 //   cy: any,
 //   rx: number,
 //   ry: number,
 //   largeArcFlag: number,
 //   sweepFlag: number,
 //   sinphi: number,
 //   cosphi: number,
 //   pxp: number,
 //   pyp: number,
 // ) => {
 //   const rxsq = Math.pow(rx, 2);
 //   const rysq = Math.pow(ry, 2);
 //   const pxpsq = Math.pow(pxp, 2);
 //   const pypsq = Math.pow(pyp, 2);
 //   let radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;
 //   if (radicant < 0) {
 //     radicant = 0;
 //   }
 //   radicant /= rxsq * pypsq + rysq * pxpsq;
 //   radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
 //   const centerxp = ((radicant * rx) / ry) * pyp;
 //   const centeryp = ((radicant * -ry) / rx) * pxp;
 //   const centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
 //   const centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;
 //   const vx1 = (pxp - centerxp) / rx;
 //   const vy1 = (pyp - centeryp) / ry;
 //   const vx2 = (-pxp - centerxp) / rx;
 //   const vy2 = (-pyp - centeryp) / ry;
 //   const ang1 = vectorAngle(1, 0, vx1, vy1);
 //   let ang2 = vectorAngle(vx1, vy1, vx2, vy2);
 //   if (sweepFlag === 0 && ang2 > 0) {
 //     ang2 -= TAU;
 //   }
 //   if (sweepFlag === 1 && ang2 < 0) {
 //     ang2 += TAU;
 //   }
 //   return [centerx, centery, ang1, ang2];
 // };
 // const arcToBezier = ({ px, py, cx, cy, rx, ry, xAxisRotation = 0, largeArcFlag = 0, sweepFlag = 0 }) => {
 //   const curves = [];
 //   if (rx === 0 || ry === 0) {
 //     return [{ x1: 0, y1: 0, x2: 0, y2: 0, x: cx, y: cy }];
 //   }
 //   const sinphi = Math.sin((xAxisRotation * TAU) / 360);
 //   const cosphi = Math.cos((xAxisRotation * TAU) / 360);
 //   const pxp = (cosphi * (px - cx)) / 2 + (sinphi * (py - cy)) / 2;
 //   const pyp = (-sinphi * (px - cx)) / 2 + (cosphi * (py - cy)) / 2;
 //   if (pxp === 0 && pyp === 0) {
 //     return [{ x1: 0, y1: 0, x2: 0, y2: 0, x: cx, y: cy }];
 //   }
 //   rx = Math.abs(rx);
 //   ry = Math.abs(ry);
 //   const lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
 //   if (lambda > 1) {
 //     rx *= Math.sqrt(lambda);
 //     ry *= Math.sqrt(lambda);
 //   }
 //   let [centerx, centery, ang1, ang2] = getArcCenter(
 //     px,
 //     py,
 //     cx,
 //     cy,
 //     rx,
 //     ry,
 //     largeArcFlag,
 //     sweepFlag,
 //     sinphi,
 //     cosphi,
 //     pxp,
 //     pyp,
 //   );
 //   // If 'ang2' == 90.0000000001, then `ratio` will evaluate to
 //   // 1.0000000001. This causes `segments` to be greater than one, which is an
 //   // unecessary split, and adds extra points to the bezier curve. To alleviate
 //   // this issue, we round to 1.0 when the ratio is close to 1.0.
 //   let ratio = Math.abs(ang2) / (TAU / 4);
 //   if (Math.abs(1.0 - ratio) < 0.0000001) {
 //     ratio = 1.0;
 //   }
 //   const segments = Math.max(Math.ceil(ratio), 1);
 //   ang2 /= segments;
 //   for (let i = 0; i < segments; i++) {
 //     curves.push(approxUnitArc(ang1, ang2));
 //     ang1 += ang2;
 //   }
 //   return curves.map((curve) => {
 //     const { x: x1, y: y1 } = mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery);
 //     const { x: x2, y: y2 } = mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery);
 //     const { x, y } = mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery);
 //     return { x1, y1, x2, y2, x, y };
 //   });
 // };
 // export function arcToCubic(
 //   x1: number,
 //   y1: number,
 //   rx: number,
 //   ry: number,
 //   angle: number,
 //   LAF: number,
 //   SF: number,
 //   x2: number,
 //   y2: number,
 // ) {
 //   const curves = arcToBezier({
 //     px: x1,
 //     py: y1,
 //     cx: x2,
 //     cy: y2,
 //     rx,
 //     ry,
 //     xAxisRotation: angle,
 //     largeArcFlag: LAF,
 //     sweepFlag: SF,
 //   });
 //   return curves.reduce((prev, cur) => {
 //     const { x1, y1, x2, y2, x, y } = cur;
 //     prev.push(x1, y1, x2, y2, x, y);
 //     return prev;
 //   }, [] as number[]);
 // }

});
parcelRegister("5V8ou", function(module, exports) {

$parcel$export(module.exports, "rotateVector", () => $44f8c9782149526c$export$3be2733b34fb8ad5);
function $44f8c9782149526c$export$3be2733b34fb8ad5(x, y, rad) {
    var X = x * Math.cos(rad) - y * Math.sin(rad);
    var Y = x * Math.sin(rad) + y * Math.cos(rad);
    return {
        x: X,
        y: Y
    };
}

});


parcelRegister("k0gaE", function(module, exports) {

$parcel$export(module.exports, "quadToCubic", () => $e90059eaefe968cf$export$63444dc525f93c8b);
function $e90059eaefe968cf$export$63444dc525f93c8b(x1, y1, qx, qy, x2, y2) {
    var r13 = 1 / 3;
    var r23 = 2 / 3;
    return [
        r13 * x1 + r23 * qx,
        r13 * y1 + r23 * qy,
        r13 * x2 + r23 * qx,
        r13 * y2 + r23 * qy,
        x2,
        y2
    ];
}

});

parcelRegister("cF3VT", function(module, exports) {

$parcel$export(module.exports, "lineToCubic", () => $937c5d5a97b5f580$export$2f006696008e2f9b);

var $7WQrb = parcelRequire("7WQrb");

var $8bNtF = parcelRequire("8bNtF");
var $937c5d5a97b5f580$export$2f006696008e2f9b = function(x1, y1, x2, y2) {
    var t = 0.5;
    var mid = (0, $8bNtF.midPoint)([
        x1,
        y1
    ], [
        x2,
        y2
    ], t);
    return (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], mid, true), [
        x2,
        y2,
        x2,
        y2
    ], false);
};

});





parcelRegister("3O2w1", function(module, exports) {

$parcel$export(module.exports, "getPointAtLength", () => $2c57fe1f4fe57647$export$3dee11a6e49c87e3);

var $7WQrb = parcelRequire("7WQrb");

var $awHWi = parcelRequire("awHWi");
function $2c57fe1f4fe57647$export$3dee11a6e49c87e3(pathInput, distance, options) {
    return (0, $awHWi.pathLengthFactory)(pathInput, distance, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
        bbox: false,
        length: true
    })).point;
}

});
parcelRegister("awHWi", function(module, exports) {

$parcel$export(module.exports, "pathLengthFactory", () => $7a9ef9f70c2e8ffa$export$4b809a44f2994b3a);

var $dnxxK = parcelRequire("dnxxK");

var $4mTD6 = parcelRequire("4mTD6");

var $crxLD = parcelRequire("crxLD");

var $kJUxO = parcelRequire("kJUxO");

var $kDGGX = parcelRequire("kDGGX");
function $7a9ef9f70c2e8ffa$export$4b809a44f2994b3a(pathInput, distance, options) {
    var _a, _b, _c, _d, _e, _f;
    var path = (0, $dnxxK.normalizePath)(pathInput);
    var distanceIsNumber = typeof distance === 'number';
    var isM;
    var data = [];
    var pathCommand;
    var x = 0;
    var y = 0;
    var mx = 0;
    var my = 0;
    var seg;
    var MIN = [];
    var MAX = [];
    var length = 0;
    var min = {
        x: 0,
        y: 0
    };
    var max = min;
    var point = min;
    var POINT = min;
    var LENGTH = 0;
    for(var i = 0, ll = path.length; i < ll; i += 1){
        seg = path[i];
        pathCommand = seg[0];
        isM = pathCommand === 'M';
        data = !isM ? [
            x,
            y
        ].concat(seg.slice(1)) : data;
        // this segment is always ZERO
        /* istanbul ignore else */ if (isM) {
            // remember mx, my for Z
            mx = seg[1], my = seg[2];
            min = {
                x: mx,
                y: my
            };
            max = min;
            length = 0;
            if (distanceIsNumber && distance < 0.001) POINT = min;
        } else if (pathCommand === 'L') _a = (0, $4mTD6.segmentLineFactory)(data[0], data[1], data[2], data[3], (distance || 0) - LENGTH), length = _a.length, min = _a.min, max = _a.max, point = _a.point;
        else if (pathCommand === 'A') _b = (0, $crxLD.segmentArcFactory)(data[0], data[1], data[2], data[3], data[4], data[5], data[6], data[7], data[8], (distance || 0) - LENGTH, options || {}), length = _b.length, min = _b.min, max = _b.max, point = _b.point;
        else if (pathCommand === 'C') _c = (0, $kJUxO.segmentCubicFactory)(data[0], data[1], data[2], data[3], data[4], data[5], data[6], data[7], (distance || 0) - LENGTH, options || {}), length = _c.length, min = _c.min, max = _c.max, point = _c.point;
        else if (pathCommand === 'Q') _d = (0, $kDGGX.segmentQuadFactory)(data[0], data[1], data[2], data[3], data[4], data[5], (distance || 0) - LENGTH, options || {}), length = _d.length, min = _d.min, max = _d.max, point = _d.point;
        else if (pathCommand === 'Z') {
            data = [
                x,
                y,
                mx,
                my
            ];
            _e = (0, $4mTD6.segmentLineFactory)(data[0], data[1], data[2], data[3], (distance || 0) - LENGTH), length = _e.length, min = _e.min, max = _e.max, point = _e.point;
        }
        if (distanceIsNumber && LENGTH < distance && LENGTH + length >= distance) POINT = point;
        MAX.push(max);
        MIN.push(min);
        LENGTH += length;
        _f = pathCommand !== 'Z' ? seg.slice(-2) : [
            mx,
            my
        ], x = _f[0], y = _f[1];
    }
    // native `getPointAtLength` behavior when the given distance
    // is higher than total length
    if (distanceIsNumber && distance >= LENGTH) POINT = {
        x: x,
        y: y
    };
    return {
        length: LENGTH,
        point: POINT,
        min: {
            x: Math.min.apply(null, MIN.map(function(n) {
                return n.x;
            })),
            y: Math.min.apply(null, MIN.map(function(n) {
                return n.y;
            }))
        },
        max: {
            x: Math.max.apply(null, MAX.map(function(n) {
                return n.x;
            })),
            y: Math.max.apply(null, MAX.map(function(n) {
                return n.y;
            }))
        }
    };
}

});
parcelRegister("4mTD6", function(module, exports) {

$parcel$export(module.exports, "segmentLineFactory", () => $32e45e61dca69c4b$export$169af231b6dbe124);

var $8bNtF = parcelRequire("8bNtF");

var $aoFex = parcelRequire("aoFex");
function $32e45e61dca69c4b$export$169af231b6dbe124(x1, y1, x2, y2, distance) {
    var length = (0, $aoFex.distanceSquareRoot)([
        x1,
        y1
    ], [
        x2,
        y2
    ]);
    var point = {
        x: 0,
        y: 0
    };
    if (typeof distance === 'number') {
        if (distance <= 0) point = {
            x: x1,
            y: y1
        };
        else if (distance >= length) point = {
            x: x2,
            y: y2
        };
        else {
            var _a = (0, $8bNtF.midPoint)([
                x1,
                y1
            ], [
                x2,
                y2
            ], distance / length), x = _a[0], y = _a[1];
            point = {
                x: x,
                y: y
            };
        }
    }
    return {
        length: length,
        point: point,
        min: {
            x: Math.min(x1, x2),
            y: Math.min(y1, y2)
        },
        max: {
            x: Math.max(x1, x2),
            y: Math.max(y1, y2)
        }
    };
}

});

parcelRegister("crxLD", function(module, exports) {

$parcel$export(module.exports, "segmentArcFactory", () => $90f2331e0ef54652$export$d7fd6ef189f99031);

var $4mTD6 = parcelRequire("4mTD6");

var $aoFex = parcelRequire("aoFex");
function $90f2331e0ef54652$var$angleBetween(v0, v1) {
    var v0x = v0.x, v0y = v0.y;
    var v1x = v1.x, v1y = v1.y;
    var p = v0x * v1x + v0y * v1y;
    var n = Math.sqrt((Math.pow(v0x, 2) + Math.pow(v0y, 2)) * (Math.pow(v1x, 2) + Math.pow(v1y, 2)));
    var sign = v0x * v1y - v0y * v1x < 0 ? -1 : 1;
    var angle = sign * Math.acos(p / n);
    return angle;
}
/**
 * Returns a {x,y} point at a given length, the total length and
 * the minimum and maximum {x,y} coordinates of a C (cubic-bezier) segment.
 * @see https://github.com/MadLittleMods/svg-curve-lib/blob/master/src/js/svg-curve-lib.js
 */ function $90f2331e0ef54652$var$getPointAtArcSegmentLength(x1, y1, RX, RY, angle, LAF, SF, x, y, t) {
    var abs = Math.abs, sin = Math.sin, cos = Math.cos, sqrt = Math.sqrt, PI = Math.PI;
    var rx = abs(RX);
    var ry = abs(RY);
    var xRot = (angle % 360 + 360) % 360;
    var xRotRad = xRot * (PI / 180);
    if (x1 === x && y1 === y) return {
        x: x1,
        y: y1
    };
    if (rx === 0 || ry === 0) return (0, $4mTD6.segmentLineFactory)(x1, y1, x, y, t).point;
    var dx = (x1 - x) / 2;
    var dy = (y1 - y) / 2;
    var transformedPoint = {
        x: cos(xRotRad) * dx + sin(xRotRad) * dy,
        y: -sin(xRotRad) * dx + cos(xRotRad) * dy
    };
    var radiiCheck = Math.pow(transformedPoint.x, 2) / Math.pow(rx, 2) + Math.pow(transformedPoint.y, 2) / Math.pow(ry, 2);
    if (radiiCheck > 1) {
        rx *= sqrt(radiiCheck);
        ry *= sqrt(radiiCheck);
    }
    var cSquareNumerator = Math.pow(rx, 2) * Math.pow(ry, 2) - Math.pow(rx, 2) * Math.pow(transformedPoint.y, 2) - Math.pow(ry, 2) * Math.pow(transformedPoint.x, 2);
    var cSquareRootDenom = Math.pow(rx, 2) * Math.pow(transformedPoint.y, 2) + Math.pow(ry, 2) * Math.pow(transformedPoint.x, 2);
    var cRadicand = cSquareNumerator / cSquareRootDenom;
    cRadicand = cRadicand < 0 ? 0 : cRadicand;
    var cCoef = (LAF !== SF ? 1 : -1) * sqrt(cRadicand);
    var transformedCenter = {
        x: cCoef * (rx * transformedPoint.y / ry),
        y: cCoef * (-(ry * transformedPoint.x) / rx)
    };
    var center = {
        x: cos(xRotRad) * transformedCenter.x - sin(xRotRad) * transformedCenter.y + (x1 + x) / 2,
        y: sin(xRotRad) * transformedCenter.x + cos(xRotRad) * transformedCenter.y + (y1 + y) / 2
    };
    var startVector = {
        x: (transformedPoint.x - transformedCenter.x) / rx,
        y: (transformedPoint.y - transformedCenter.y) / ry
    };
    var startAngle = $90f2331e0ef54652$var$angleBetween({
        x: 1,
        y: 0
    }, startVector);
    var endVector = {
        x: (-transformedPoint.x - transformedCenter.x) / rx,
        y: (-transformedPoint.y - transformedCenter.y) / ry
    };
    var sweepAngle = $90f2331e0ef54652$var$angleBetween(startVector, endVector);
    if (!SF && sweepAngle > 0) sweepAngle -= 2 * PI;
    else if (SF && sweepAngle < 0) sweepAngle += 2 * PI;
    sweepAngle %= 2 * PI;
    var alpha = startAngle + sweepAngle * t;
    var ellipseComponentX = rx * cos(alpha);
    var ellipseComponentY = ry * sin(alpha);
    var point = {
        x: cos(xRotRad) * ellipseComponentX - sin(xRotRad) * ellipseComponentY + center.x,
        y: sin(xRotRad) * ellipseComponentX + cos(xRotRad) * ellipseComponentY + center.y
    };
    // to be used later
    // point.ellipticalArcStartAngle = startAngle;
    // point.ellipticalArcEndAngle = startAngle + sweepAngle;
    // point.ellipticalArcAngle = alpha;
    // point.ellipticalArcCenter = center;
    // point.resultantRx = rx;
    // point.resultantRy = ry;
    return point;
}
function $90f2331e0ef54652$export$d7fd6ef189f99031(X1, Y1, RX, RY, angle, LAF, SF, X2, Y2, distance, options) {
    var _a;
    var _b = options.bbox, bbox = _b === void 0 ? true : _b, _c = options.length, length = _c === void 0 ? true : _c, _d = options.sampleSize, sampleSize = _d === void 0 ? 30 : _d;
    var distanceIsNumber = typeof distance === 'number';
    var x = X1;
    var y = Y1;
    var LENGTH = 0;
    var prev = [
        x,
        y,
        LENGTH
    ];
    var cur = [
        x,
        y
    ];
    var t = 0;
    var POINT = {
        x: 0,
        y: 0
    };
    var POINTS = [
        {
            x: x,
            y: y
        }
    ];
    if (distanceIsNumber && distance <= 0) POINT = {
        x: x,
        y: y
    };
    // bad perf when size > 100
    for(var j = 0; j <= sampleSize; j += 1){
        t = j / sampleSize;
        _a = $90f2331e0ef54652$var$getPointAtArcSegmentLength(X1, Y1, RX, RY, angle, LAF, SF, X2, Y2, t), x = _a.x, y = _a.y;
        if (bbox) POINTS.push({
            x: x,
            y: y
        });
        if (length) LENGTH += (0, $aoFex.distanceSquareRoot)(cur, [
            x,
            y
        ]);
        cur = [
            x,
            y
        ];
        if (distanceIsNumber && LENGTH >= distance && distance > prev[2]) {
            var dv = (LENGTH - distance) / (LENGTH - prev[2]);
            POINT = {
                x: cur[0] * (1 - dv) + prev[0] * dv,
                y: cur[1] * (1 - dv) + prev[1] * dv
            };
        }
        prev = [
            x,
            y,
            LENGTH
        ];
    }
    if (distanceIsNumber && distance >= LENGTH) POINT = {
        x: X2,
        y: Y2
    };
    return {
        length: LENGTH,
        point: POINT,
        min: {
            x: Math.min.apply(null, POINTS.map(function(n) {
                return n.x;
            })),
            y: Math.min.apply(null, POINTS.map(function(n) {
                return n.y;
            }))
        },
        max: {
            x: Math.max.apply(null, POINTS.map(function(n) {
                return n.x;
            })),
            y: Math.max.apply(null, POINTS.map(function(n) {
                return n.y;
            }))
        }
    };
}

});

parcelRegister("kDGGX", function(module, exports) {

$parcel$export(module.exports, "segmentQuadFactory", () => $f06890dc88a6d0b2$export$dfaad3bedad68aa7);

var $aoFex = parcelRequire("aoFex");
/**
 * Returns the {x,y} coordinates of a point at a
 * given length of a quadratic-bezier segment.
 *
 * @see https://github.com/substack/point-at-length
 */ function $f06890dc88a6d0b2$var$getPointAtQuadSegmentLength(x1, y1, cx, cy, x2, y2, t) {
    var t1 = 1 - t;
    return {
        x: Math.pow(t1, 2) * x1 + 2 * t1 * t * cx + Math.pow(t, 2) * x2,
        y: Math.pow(t1, 2) * y1 + 2 * t1 * t * cy + Math.pow(t, 2) * y2
    };
}
function $f06890dc88a6d0b2$export$dfaad3bedad68aa7(x1, y1, qx, qy, x2, y2, distance, options) {
    var _a;
    var _b = options.bbox, bbox = _b === void 0 ? true : _b, _c = options.length, length = _c === void 0 ? true : _c, _d = options.sampleSize, sampleSize = _d === void 0 ? 10 : _d;
    var distanceIsNumber = typeof distance === 'number';
    var x = x1;
    var y = y1;
    var LENGTH = 0;
    var prev = [
        x,
        y,
        LENGTH
    ];
    var cur = [
        x,
        y
    ];
    var t = 0;
    var POINT = {
        x: 0,
        y: 0
    };
    var POINTS = [
        {
            x: x,
            y: y
        }
    ];
    if (distanceIsNumber && distance <= 0) POINT = {
        x: x,
        y: y
    };
    for(var j = 0; j <= sampleSize; j += 1){
        t = j / sampleSize;
        _a = $f06890dc88a6d0b2$var$getPointAtQuadSegmentLength(x1, y1, qx, qy, x2, y2, t), x = _a.x, y = _a.y;
        if (bbox) POINTS.push({
            x: x,
            y: y
        });
        if (length) LENGTH += (0, $aoFex.distanceSquareRoot)(cur, [
            x,
            y
        ]);
        cur = [
            x,
            y
        ];
        if (distanceIsNumber && LENGTH >= distance && distance > prev[2]) {
            var dv = (LENGTH - distance) / (LENGTH - prev[2]);
            POINT = {
                x: cur[0] * (1 - dv) + prev[0] * dv,
                y: cur[1] * (1 - dv) + prev[1] * dv
            };
        }
        prev = [
            x,
            y,
            LENGTH
        ];
    }
    /* istanbul ignore else */ if (distanceIsNumber && distance >= LENGTH) POINT = {
        x: x2,
        y: y2
    };
    return {
        length: LENGTH,
        point: POINT,
        min: {
            x: Math.min.apply(null, POINTS.map(function(n) {
                return n.x;
            })),
            y: Math.min.apply(null, POINTS.map(function(n) {
                return n.y;
            }))
        },
        max: {
            x: Math.max.apply(null, POINTS.map(function(n) {
                return n.x;
            })),
            y: Math.max.apply(null, POINTS.map(function(n) {
                return n.y;
            }))
        }
    };
}

});



parcelRegister("ctnG0", function(module, exports) {

$parcel$export(module.exports, "getRotatedCurve", () => $914a8f283ac8be73$export$d6fb738bb17c2358);

var $aoFex = parcelRequire("aoFex");
function $914a8f283ac8be73$var$getRotations(a) {
    var segCount = a.length;
    var pointCount = segCount - 1;
    return a.map(function(f, idx) {
        return a.map(function(p, i) {
            var oldSegIdx = idx + i;
            var seg;
            if (i === 0 || a[oldSegIdx] && a[oldSegIdx][0] === 'M') {
                seg = a[oldSegIdx];
                return [
                    'M'
                ].concat(seg.slice(-2));
            }
            if (oldSegIdx >= segCount) oldSegIdx -= pointCount;
            return a[oldSegIdx];
        });
    });
}
function $914a8f283ac8be73$export$d6fb738bb17c2358(a, b) {
    var segCount = a.length - 1;
    var lineLengths = [];
    var computedIndex = 0;
    var sumLensSqrd = 0;
    var rotations = $914a8f283ac8be73$var$getRotations(a);
    rotations.forEach(function(r, i) {
        a.slice(1).forEach(function(s, j) {
            // @ts-ignore
            sumLensSqrd += (0, $aoFex.distanceSquareRoot)(a[(i + j) % segCount].slice(-2), b[j % segCount].slice(-2));
        });
        lineLengths[i] = sumLensSqrd;
        sumLensSqrd = 0;
    });
    computedIndex = lineLengths.indexOf(Math.min.apply(null, lineLengths));
    return rotations[computedIndex];
}

});

parcelRegister("iJzUi", function(module, exports) {

$parcel$export(module.exports, "getTotalLength", () => $da38485e7eacdff6$export$e8c8db6c43aad120);

var $7WQrb = parcelRequire("7WQrb");

var $awHWi = parcelRequire("awHWi");
function $da38485e7eacdff6$export$e8c8db6c43aad120(pathInput, options) {
    return (0, $awHWi.pathLengthFactory)(pathInput, undefined, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, options), {
        bbox: false,
        length: true
    })).length;
}

});

parcelRegister("1uF5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $116875e5184fe5c7$export$2e2bcd8739ae039);
/**
 * 判断值是否为数组
 * @return 是否为数组
 */ function $116875e5184fe5c7$export$2e2bcd8739ae039(value) {
    return Array.isArray(value);
}

});

parcelRegister("2LrCM", function(module, exports) {

$parcel$export(module.exports, "default", () => $20356636a62515d2$export$2e2bcd8739ae039);
/**
 * 是否是布尔类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */ 
var $9E5Oj = parcelRequire("9E5Oj");
var $20356636a62515d2$var$isBoolean = function(value) {
    return (0, $9E5Oj.default)(value, 'Boolean');
};
var $20356636a62515d2$export$2e2bcd8739ae039 = $20356636a62515d2$var$isBoolean;

});
parcelRegister("9E5Oj", function(module, exports) {

$parcel$export(module.exports, "default", () => $705c5b582ae8b0e5$export$2e2bcd8739ae039);
var $705c5b582ae8b0e5$var$toString = {}.toString;
var $705c5b582ae8b0e5$var$isType = function(value, type) {
    return $705c5b582ae8b0e5$var$toString.call(value) === '[object ' + type + ']';
};
var $705c5b582ae8b0e5$export$2e2bcd8739ae039 = $705c5b582ae8b0e5$var$isType;

});


parcelRegister("ky7aH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef5c8bbf6c2adf92$export$2e2bcd8739ae039);
/**
 * 判断值是否为函数
 * @return 是否为函数
 */ function $ef5c8bbf6c2adf92$export$2e2bcd8739ae039(value) {
    return typeof value === 'function';
}

});

parcelRegister("geZBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd2dbdf96fbb53dc$export$2e2bcd8739ae039);
/**
 * 判断值是否为 null 或 undefined
 * @return 是否为 null 或 undefined
 */ function $bd2dbdf96fbb53dc$export$2e2bcd8739ae039(value) {
    return value === null || value === undefined;
}

});

parcelRegister("jyI49", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3d35fe57cdd7ee8$export$2e2bcd8739ae039);
/**
 * 判断值是否为数字
 * @return 是否为数字
 */ function $e3d35fe57cdd7ee8$export$2e2bcd8739ae039(value) {
    return typeof value === 'number';
}

});

parcelRegister("dFv1j", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f372aa50bf12c0c$export$2e2bcd8739ae039);
var $9f372aa50bf12c0c$var$PRECISION = 0.00001; // numbers less than this is considered as 0
function $9f372aa50bf12c0c$export$2e2bcd8739ae039(a, b, precision) {
    if (precision === void 0) precision = $9f372aa50bf12c0c$var$PRECISION;
    return a === b || Math.abs(a - b) < precision;
}

});

parcelRegister("6JKSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7b4e14d2875f9c$export$2e2bcd8739ae039);
var $4e7b4e14d2875f9c$export$2e2bcd8739ae039 = function(value) {
    /**
     * isObject({}) => true
     * isObject([1, 2, 3]) => true
     * isObject(Function) => true
     * isObject(null) => false
     */ var type = typeof value;
    return value !== null && type === 'object' || type === 'function';
};

});

parcelRegister("kVcyu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3b2debbe3661a52$export$2e2bcd8739ae039);
/**
 * 判断值是否为字符串
 * @return 是否为字符串
 */ function $f3b2debbe3661a52$export$2e2bcd8739ae039(value) {
    return typeof value === 'string';
}

});

parcelRegister("aFcWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c37c6eb51b1c104$export$2e2bcd8739ae039);
var $7c37c6eb51b1c104$var$isUndefined = function(value) {
    return value === undefined;
};
var $7c37c6eb51b1c104$export$2e2bcd8739ae039 = $7c37c6eb51b1c104$var$isUndefined;

});

parcelRegister("bFgqX", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e0456e0846ef9c$export$2e2bcd8739ae039);
/**
 * 计算数组的最大值
 * @param arr 数组
 * @return 最大值
 */ function $87e0456e0846ef9c$export$2e2bcd8739ae039(arr) {
    if (!Array.isArray(arr)) return -Infinity;
    var length = arr.length;
    if (!length) return -Infinity;
    var max = arr[0];
    for(var i = 1; i < length; i++)max = Math.max(max, arr[i]);
    return max;
}

});

parcelRegister("04Wz9", function(module, exports) {

$parcel$export(module.exports, "default", () => $00edcdd35a213451$export$2e2bcd8739ae039);

var $1uF5a = parcelRequire("1uF5a");
var /**
 * @param {Array} arr The array to iterate over.
 * @return {*} Returns the minimum value.
 * @example
 *
 * min([1, 2]);
 * // => 1
 *
 * min([]);
 * // => undefined
 *
 * const data = new Array(1250010).fill(1).map((d,idx) => idx);
 *
 * min(data);
 * // => 1250010
 * // Math.min(...data) will encounter "Maximum call stack size exceeded" error
 */ $00edcdd35a213451$export$2e2bcd8739ae039 = function(arr) {
    if (!(0, $1uF5a.default)(arr)) return undefined;
    return arr.reduce(function(prev, curr) {
        return Math.min(prev, curr);
    }, arr[0]);
};

});

parcelRegister("fo9PZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b340ba6cabef24fa$export$2e2bcd8739ae039);
var $b340ba6cabef24fa$var$mod = function(n, m) {
    return (n % m + m) % m;
};
var $b340ba6cabef24fa$export$2e2bcd8739ae039 = $b340ba6cabef24fa$var$mod;

});

parcelRegister("6kBPW", function(module, exports) {

$parcel$export(module.exports, "reverseCurve", () => $49c1f5effb5db96b$export$a82144fef261eb16);
// reverse CURVE based pathArray segments only
function $49c1f5effb5db96b$export$a82144fef261eb16(pathArray) {
    var rotatedCurve = pathArray.slice(1).map(function(x, i, curveOnly) {
        // @ts-ignore
        return !i ? pathArray[0].slice(1).concat(x.slice(1)) : curveOnly[i - 1].slice(-2).concat(x.slice(1));
    })// @ts-ignore
    .map(function(x) {
        return x.map(function(y, i) {
            return x[x.length - i - 2 * (1 - i % 2)];
        });
    }).reverse();
    return [
        [
            'M'
        ].concat(rotatedCurve[0].slice(0, 2))
    ].concat(rotatedCurve.map(function(x) {
        return [
            'C'
        ].concat(x.slice(2));
    }));
}

});

parcelRegister("dPop6", function(module, exports) {

var $dpL0o = parcelRequire("dpL0o");

var $cGTaw = parcelRequire("cGTaw");
function $a112f7e1ef456a01$var$_superPropGet(t, o, e, r) {
    var p = $dpL0o($cGTaw(1 & r ? t.prototype : t), o, e);
    return 2 & r && "function" == typeof p ? function(t) {
        return p.apply(e, t);
    } : p;
}
module.exports = $a112f7e1ef456a01$var$_superPropGet, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("dpL0o", function(module, exports) {

var $fkEbL = parcelRequire("fkEbL");
function $9c4212772a6002f0$var$_get() {
    return module.exports = $9c4212772a6002f0$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $fkEbL(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $9c4212772a6002f0$var$_get.apply(null, arguments);
}
module.exports = $9c4212772a6002f0$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("fkEbL", function(module, exports) {

var $cGTaw = parcelRequire("cGTaw");
function $b297e5ebd9b2c4c7$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $cGTaw(t)););
    return t;
}
module.exports = $b297e5ebd9b2c4c7$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("11s8J", function(module, exports) {

$parcel$export(module.exports, "distance", () => $0bebb668bd6235eb$export$9f17032d917177de);
$parcel$export(module.exports, "arcBox", () => $0bebb668bd6235eb$export$e280bfbaa218982c);
$parcel$export(module.exports, "lineLength", () => $0bebb668bd6235eb$export$28022775658f8740);
$parcel$export(module.exports, "linePointAt", () => $0bebb668bd6235eb$export$bbefe09b584041c9);
$parcel$export(module.exports, "linePointToLine", () => $0bebb668bd6235eb$export$bbc2bacd0166a74d);
$parcel$export(module.exports, "cubicBox", () => $0bebb668bd6235eb$export$1f289d6af49e5576);
$parcel$export(module.exports, "cubicPointDistance", () => $0bebb668bd6235eb$export$153f9514148a3245);
$parcel$export(module.exports, "polylineLength", () => $0bebb668bd6235eb$export$fed333e70a817508);
$parcel$export(module.exports, "quadBox", () => $0bebb668bd6235eb$export$17067c8fce023cab);
$parcel$export(module.exports, "quadPointDistance", () => $0bebb668bd6235eb$export$b9a942359c6a151a);
/*!
 * @antv/g-math
 * @description Geometry util
 * @version 3.1.0
 * @date 12/22/2025, 3:02:36 AM
 * @author AntVis
 * @docs https://g.antv.antgroup.com/
 */ 
var $02Ztr = parcelRequire("02Ztr");

var $fUHKi = parcelRequire("fUHKi");

var $dFv1j = parcelRequire("dFv1j");

var $6BoVD = parcelRequire("6BoVD");
function $0bebb668bd6235eb$export$9f17032d917177de(x1, y1, x2, y2) {
    var dx = x1 - x2;
    var dy = y1 - y2;
    return Math.sqrt(dx * dx + dy * dy);
}
function $0bebb668bd6235eb$var$getBBoxByArray(xArr, yArr) {
    var minX = Math.min.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(xArr));
    var minY = Math.min.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(yArr));
    var maxX = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(xArr));
    var maxY = Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(yArr));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $0bebb668bd6235eb$var$piMod(angle) {
    return (angle + Math.PI * 2) % (Math.PI * 2);
}
function $0bebb668bd6235eb$var$copysign(v1, v2) {
    var absv = Math.abs(v1);
    return v2 > 0 ? absv : absv * -1;
}
function $0bebb668bd6235eb$var$nearestPoint$4(x, y, rx, ry, x0, y0) {
    var a = rx;
    var b = ry;
    // 假如椭圆半径为0则返回圆心
    if (a === 0 || b === 0) return {
        x: x,
        y: y
    };
    // 转换成 0， 0 为中心的椭圆计算
    var relativeX = x0 - x;
    var relativeY = y0 - y;
    var px = Math.abs(relativeX);
    var py = Math.abs(relativeY);
    var squareA = a * a;
    var squareB = b * b;
    // const angle0 = Math.atan2(relativeY, relativeX);
    var t = Math.PI / 4;
    var nearestX = 0; // 椭圆上的任一点
    var nearestY = 0;
    // 迭代 4 次
    for(var i = 0; i < 4; i++){
        nearestX = a * Math.cos(t);
        nearestY = b * Math.sin(t);
        var ex = (squareA - squareB) * Math.pow(Math.cos(t), 3) / a;
        var ey = (squareB - squareA) * Math.pow(Math.sin(t), 3) / b;
        var rx1 = nearestX - ex;
        var ry1 = nearestY - ey;
        var qx = px - ex;
        var qy = py - ey;
        var r = Math.hypot(ry1, rx1);
        var q = Math.hypot(qy, qx);
        var delta_c = r * Math.asin((rx1 * qy - ry1 * qx) / (r * q));
        var delta_t = delta_c / Math.sqrt(squareA + squareB - nearestX * nearestX - nearestY * nearestY);
        t += delta_t;
        t = Math.min(Math.PI / 2, Math.max(0, t));
    }
    return {
        x: x + $0bebb668bd6235eb$var$copysign(nearestX, relativeX),
        y: y + $0bebb668bd6235eb$var$copysign(nearestY, relativeY)
    };
}
// 偏导数 x
function $0bebb668bd6235eb$var$derivativeXAt(cx, cy, rx, ry, xRotation, startAngle, endAngle, angle) {
    return -1 * rx * Math.cos(xRotation) * Math.sin(angle) - ry * Math.sin(xRotation) * Math.cos(angle);
}
// 偏导数 y
function $0bebb668bd6235eb$var$derivativeYAt(cx, cy, rx, ry, xRotation, startAngle, endAngle, angle) {
    return -1 * rx * Math.sin(xRotation) * Math.sin(angle) + ry * Math.cos(xRotation) * Math.cos(angle);
}
// x 的极值
function $0bebb668bd6235eb$var$xExtrema(rx, ry, xRotation) {
    return Math.atan(-ry / rx * Math.tan(xRotation));
}
// y 的极值
function $0bebb668bd6235eb$var$yExtrema(rx, ry, xRotation) {
    return Math.atan(ry / (rx * Math.tan(xRotation)));
}
// 根据角度求 x 坐标
function $0bebb668bd6235eb$var$xAt(cx, cy, rx, ry, xRotation, angle) {
    return rx * Math.cos(xRotation) * Math.cos(angle) - ry * Math.sin(xRotation) * Math.sin(angle) + cx;
}
// 根据角度求 y 坐标
function $0bebb668bd6235eb$var$yAt(cx, cy, rx, ry, xRotation, angle) {
    return rx * Math.sin(xRotation) * Math.cos(angle) + ry * Math.cos(xRotation) * Math.sin(angle) + cy;
}
// 获取点在椭圆上的角度
function $0bebb668bd6235eb$var$getAngle(rx, ry, x0, y0) {
    var angle = Math.atan2(y0 * rx, x0 * ry);
    // 转换到 0 - 2PI 内
    return (angle + Math.PI * 2) % (Math.PI * 2);
}
// 根据角度获取，x,y
function $0bebb668bd6235eb$var$getPoint(rx, ry, angle) {
    return {
        x: rx * Math.cos(angle),
        y: ry * Math.sin(angle)
    };
}
// 旋转
function $0bebb668bd6235eb$var$rotate(x, y, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    return [
        x * cos - y * sin,
        x * sin + y * cos
    ];
}
function $0bebb668bd6235eb$export$e280bfbaa218982c(cx, cy, rx, ry, xRotation, startAngle, endAngle) {
    var xDim = $0bebb668bd6235eb$var$xExtrema(rx, ry, xRotation);
    var minX = Infinity;
    var maxX = -Infinity;
    var xs = [
        startAngle,
        endAngle
    ];
    for(var i = -Math.PI * 2; i <= Math.PI * 2; i += Math.PI){
        var xAngle = xDim + i;
        if (startAngle < endAngle) {
            if (startAngle < xAngle && xAngle < endAngle) xs.push(xAngle);
        } else if (endAngle < xAngle && xAngle < startAngle) xs.push(xAngle);
    }
    for(var _i = 0; _i < xs.length; _i++){
        var x = $0bebb668bd6235eb$var$xAt(cx, cy, rx, ry, xRotation, xs[_i]);
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
    }
    var yDim = $0bebb668bd6235eb$var$yExtrema(rx, ry, xRotation);
    var minY = Infinity;
    var maxY = -Infinity;
    var ys = [
        startAngle,
        endAngle
    ];
    for(var _i2 = -Math.PI * 2; _i2 <= Math.PI * 2; _i2 += Math.PI){
        var yAngle = yDim + _i2;
        if (startAngle < endAngle) {
            if (startAngle < yAngle && yAngle < endAngle) ys.push(yAngle);
        } else if (endAngle < yAngle && yAngle < startAngle) ys.push(yAngle);
    }
    for(var _i3 = 0; _i3 < ys.length; _i3++){
        var y = $0bebb668bd6235eb$var$yAt(cx, cy, rx, ry, xRotation, ys[_i3]);
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
    }
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $0bebb668bd6235eb$export$c4c935897b244399(cx, cy, rx, ry, xRotation, startAngle, endAngle, x0, y0) {
    // 将最近距离问题转换成到椭圆中心 0,0 没有旋转的椭圆问题
    var relativeVector = $0bebb668bd6235eb$var$rotate(x0 - cx, y0 - cy, -xRotation);
    var _relativeVector = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(relativeVector, 2), x1 = _relativeVector[0], y1 = _relativeVector[1];
    // 计算点到椭圆的最近的点
    var relativePoint = $0bebb668bd6235eb$var$nearestPoint$4(0, 0, rx, ry, x1, y1);
    // 获取点在椭圆上的角度
    var angle = $0bebb668bd6235eb$var$getAngle(rx, ry, relativePoint.x, relativePoint.y);
    // 点没有在圆弧上
    if (angle < startAngle) // 小于起始圆弧
    relativePoint = $0bebb668bd6235eb$var$getPoint(rx, ry, startAngle);
    else if (angle > endAngle) // 大于结束圆弧
    relativePoint = $0bebb668bd6235eb$var$getPoint(rx, ry, endAngle);
    // 旋转到 xRotation 的角度
    var vector = $0bebb668bd6235eb$var$rotate(relativePoint.x, relativePoint.y, xRotation);
    return {
        x: vector[0] + cx,
        y: vector[1] + cy
    };
}
function $0bebb668bd6235eb$export$c0a7f1bd17aec1eb(cx, cy, rx, ry, xRotation, startAngle, endAngle, t) {
    var angle = (endAngle - startAngle) * t + startAngle;
    var dx = $0bebb668bd6235eb$var$derivativeXAt(cx, cy, rx, ry, xRotation, startAngle, endAngle, angle);
    var dy = $0bebb668bd6235eb$var$derivativeYAt(cx, cy, rx, ry, xRotation, startAngle, endAngle, angle);
    return $0bebb668bd6235eb$var$piMod(Math.atan2(dy, dx));
}
var $0bebb668bd6235eb$var$EPSILON = 0.0001;
/**
 * 使用牛顿切割法求最近的点
 * @param {number[]} xArr      点的 x 数组
 * @param {number[]} yArr      点的 y 数组
 * @param {number}   x         指定的点 x
 * @param {number}   y         指定的点 y
 * @param {Function} tCallback 差值函数
 */ function $0bebb668bd6235eb$var$nearestPoint$2(xArr, yArr, x, y, tCallback, length) {
    var t = -1;
    var d = Infinity;
    var v0 = [
        x,
        y
    ];
    var segNum = 20;
    if (length && length > 200) segNum = length / 10;
    var increaseRate = 1 / segNum;
    var interval = increaseRate / 10;
    for(var i = 0; i <= segNum; i++){
        var _t = i * increaseRate;
        var v1 = [
            tCallback.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(xArr.concat([
                _t
            ]))),
            tCallback.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(yArr.concat([
                _t
            ])))
        ];
        var d1 = $0bebb668bd6235eb$export$9f17032d917177de(v0[0], v0[1], v1[0], v1[1]);
        if (d1 < d) {
            t = _t;
            d = d1;
        }
    }
    // 提前终止
    if (t === 0) return {
        x: xArr[0],
        y: yArr[0]
    };
    if (t === 1) {
        var count = xArr.length;
        return {
            x: xArr[count - 1],
            y: yArr[count - 1]
        };
    }
    d = Infinity;
    for(var _i = 0; _i < 32; _i++){
        if (interval < $0bebb668bd6235eb$var$EPSILON) break;
        var prev = t - interval;
        var next = t + interval;
        var _v = [
            tCallback.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(xArr.concat([
                prev
            ]))),
            tCallback.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(yArr.concat([
                prev
            ])))
        ];
        var _d = $0bebb668bd6235eb$export$9f17032d917177de(v0[0], v0[1], _v[0], _v[1]);
        if (prev >= 0 && _d < d) {
            t = prev;
            d = _d;
        } else {
            var v2 = [
                tCallback.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(xArr.concat([
                    next
                ]))),
                tCallback.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(yArr.concat([
                    next
                ])))
            ];
            var d2 = $0bebb668bd6235eb$export$9f17032d917177de(v0[0], v0[1], v2[0], v2[1]);
            if (next <= 1 && d2 < d) {
                t = next;
                d = d2;
            } else interval *= 0.5;
        }
    }
    return {
        x: tCallback.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(xArr.concat([
            t
        ]))),
        y: tCallback.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(yArr.concat([
            t
        ])))
    };
}
// 近似求解 https://community.khronos.org/t/3d-cubic-bezier-segment-length/62363/2
function $0bebb668bd6235eb$var$snapLength(xArr, yArr) {
    var totalLength = 0;
    var count = xArr.length;
    for(var i = 0; i < count; i++){
        var x = xArr[i];
        var y = yArr[i];
        var nextX = xArr[(i + 1) % count];
        var nextY = yArr[(i + 1) % count];
        totalLength += $0bebb668bd6235eb$export$9f17032d917177de(x, y, nextX, nextY);
    }
    return totalLength / 2;
}
function $0bebb668bd6235eb$export$2fbc65213714cb16(x1, y1, x2, y2) {
    return $0bebb668bd6235eb$var$getBBoxByArray([
        x1,
        x2
    ], [
        y1,
        y2
    ]);
}
function $0bebb668bd6235eb$export$28022775658f8740(x1, y1, x2, y2) {
    return $0bebb668bd6235eb$export$9f17032d917177de(x1, y1, x2, y2);
}
function $0bebb668bd6235eb$export$bbefe09b584041c9(x1, y1, x2, y2, t) {
    return {
        x: (1 - t) * x1 + t * x2,
        y: (1 - t) * y1 + t * y2
    };
}
function $0bebb668bd6235eb$export$e5f20cbaf608a0b8(x1, y1, x2, y2, x, y) {
    // 投影距离 x1, y1 的向量，假设 p, p1, p2 三个点，投影点为 a
    // p1a = p1p.p1p2/|p1p2| * (p1p 的单位向量)
    var cross = (x2 - x1) * (x - x1) + (y2 - y1) * (y - y1);
    if (cross < 0) return $0bebb668bd6235eb$export$9f17032d917177de(x1, y1, x, y);
    var lengthSquare = (x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1);
    if (cross > lengthSquare) return $0bebb668bd6235eb$export$9f17032d917177de(x2, y2, x, y);
    return $0bebb668bd6235eb$export$bbc2bacd0166a74d(x1, y1, x2, y2, x, y);
}
function $0bebb668bd6235eb$export$bbc2bacd0166a74d(x1, y1, x2, y2, x, y) {
    var d = [
        x2 - x1,
        y2 - y1
    ];
    // 如果端点相等，则判定点到点的距离
    if ((0, $6BoVD).exactEquals(d, [
        0,
        0
    ])) return Math.sqrt((x - x1) * (x - x1) + (y - y1) * (y - y1));
    var u = [
        -d[1],
        d[0]
    ];
    (0, $6BoVD).normalize(u, u);
    var a = [
        x - x1,
        y - y1
    ];
    return Math.abs((0, $6BoVD).dot(a, u));
}
function $0bebb668bd6235eb$export$5be2a5256ba3afe7(x1, y1, x2, y2) {
    return Math.atan2(y2 - y1, x2 - x1);
}
function $0bebb668bd6235eb$var$cubicAt(p0, p1, p2, p3, t) {
    var onet = 1 - t; // t * t * t 的性能大概是 Math.pow(t, 3) 的三倍
    return onet * onet * onet * p0 + 3 * p1 * t * onet * onet + 3 * p2 * t * t * onet + p3 * t * t * t;
}
function $0bebb668bd6235eb$var$derivativeAt(p0, p1, p2, p3, t) {
    var onet = 1 - t;
    return 3 * (onet * onet * (p1 - p0) + 2 * onet * t * (p2 - p1) + t * t * (p3 - p2));
}
function $0bebb668bd6235eb$var$extrema$1(p0, p1, p2, p3) {
    var a = -3 * p0 + 9 * p1 - 9 * p2 + 3 * p3;
    var b = 6 * p0 - 12 * p1 + 6 * p2;
    var c = 3 * p1 - 3 * p0;
    var extremas = [];
    var t1;
    var t2;
    var discSqrt;
    if ((0, $dFv1j.default)(a, 0)) {
        if (!(0, $dFv1j.default)(b, 0)) {
            t1 = -c / b;
            if (t1 >= 0 && t1 <= 1) extremas.push(t1);
        }
    } else {
        var disc = b * b - 4 * a * c;
        if ((0, $dFv1j.default)(disc, 0)) extremas.push(-b / (2 * a));
        else if (disc > 0) {
            discSqrt = Math.sqrt(disc);
            t1 = (-b + discSqrt) / (2 * a);
            t2 = (-b - discSqrt) / (2 * a);
            if (t1 >= 0 && t1 <= 1) extremas.push(t1);
            if (t2 >= 0 && t2 <= 1) extremas.push(t2);
        }
    }
    return extremas;
}
// 分割贝塞尔曲线
function $0bebb668bd6235eb$var$divideCubic(x1, y1, x2, y2, x3, y3, x4, y4, t) {
    // 划分点
    var xt = $0bebb668bd6235eb$var$cubicAt(x1, x2, x3, x4, t);
    var yt = $0bebb668bd6235eb$var$cubicAt(y1, y2, y3, y4, t);
    // 计算两点之间的差值点
    var c1 = $0bebb668bd6235eb$export$bbefe09b584041c9(x1, y1, x2, y2, t);
    var c2 = $0bebb668bd6235eb$export$bbefe09b584041c9(x2, y2, x3, y3, t);
    var c3 = $0bebb668bd6235eb$export$bbefe09b584041c9(x3, y3, x4, y4, t);
    var c12 = $0bebb668bd6235eb$export$bbefe09b584041c9(c1.x, c1.y, c2.x, c2.y, t);
    var c23 = $0bebb668bd6235eb$export$bbefe09b584041c9(c2.x, c2.y, c3.x, c3.y, t);
    return [
        [
            x1,
            y1,
            c1.x,
            c1.y,
            c12.x,
            c12.y,
            xt,
            yt
        ],
        [
            xt,
            yt,
            c23.x,
            c23.y,
            c3.x,
            c3.y,
            x4,
            y4
        ]
    ];
}
// 使用迭代法取贝塞尔曲线的长度，二阶和三阶分开写，更清晰和便于调试
function $0bebb668bd6235eb$var$cubicLength(x1, y1, x2, y2, x3, y3, x4, y4, iterationCount) {
    if (iterationCount === 0) return $0bebb668bd6235eb$var$snapLength([
        x1,
        x2,
        x3,
        x4
    ], [
        y1,
        y2,
        y3,
        y4
    ]);
    var cubics = $0bebb668bd6235eb$var$divideCubic(x1, y1, x2, y2, x3, y3, x4, y4, 0.5);
    var left = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(cubics[0]), [
        iterationCount - 1
    ]);
    var right = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(cubics[1]), [
        iterationCount - 1
    ]);
    return $0bebb668bd6235eb$var$cubicLength.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(left)) + $0bebb668bd6235eb$var$cubicLength.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(right));
}
function $0bebb668bd6235eb$export$1f289d6af49e5576(x1, y1, x2, y2, x3, y3, x4, y4) {
    var xArr = [
        x1,
        x4
    ];
    var yArr = [
        y1,
        y4
    ];
    var xExtrema = $0bebb668bd6235eb$var$extrema$1(x1, x2, x3, x4);
    var yExtrema = $0bebb668bd6235eb$var$extrema$1(y1, y2, y3, y4);
    for(var i = 0; i < xExtrema.length; i++)xArr.push($0bebb668bd6235eb$var$cubicAt(x1, x2, x3, x4, xExtrema[i]));
    for(var _i = 0; _i < yExtrema.length; _i++)yArr.push($0bebb668bd6235eb$var$cubicAt(y1, y2, y3, y4, yExtrema[_i]));
    return $0bebb668bd6235eb$var$getBBoxByArray(xArr, yArr);
}
function $0bebb668bd6235eb$export$af1875d576f60d7c(x1, y1, x2, y2, x3, y3, x4, y4) {
    // 迭代三次，划分成 8 段求长度
    return $0bebb668bd6235eb$var$cubicLength(x1, y1, x2, y2, x3, y3, x4, y4, 3);
}
function $0bebb668bd6235eb$export$7355bce41799c59b(x1, y1, x2, y2, x3, y3, x4, y4, x0, y0, length) {
    return $0bebb668bd6235eb$var$nearestPoint$2([
        x1,
        x2,
        x3,
        x4
    ], [
        y1,
        y2,
        y3,
        y4
    ], x0, y0, $0bebb668bd6235eb$var$cubicAt, length);
}
function $0bebb668bd6235eb$export$153f9514148a3245(x1, y1, x2, y2, x3, y3, x4, y4, x0, y0, length) {
    var point = $0bebb668bd6235eb$export$7355bce41799c59b(x1, y1, x2, y2, x3, y3, x4, y4, x0, y0, length);
    return $0bebb668bd6235eb$export$9f17032d917177de(point.x, point.y, x0, y0);
}
function $0bebb668bd6235eb$export$213a8694eaf0573e(x1, y1, x2, y2, x3, y3, x4, y4, t) {
    return {
        x: $0bebb668bd6235eb$var$cubicAt(x1, x2, x3, x4, t),
        y: $0bebb668bd6235eb$var$cubicAt(y1, y2, y3, y4, t)
    };
}
function $0bebb668bd6235eb$export$ef9ef6f43c40777f(x1, y1, x2, y2, x3, y3, x4, y4, t) {
    var dx = $0bebb668bd6235eb$var$derivativeAt(x1, x2, x3, x4, t);
    var dy = $0bebb668bd6235eb$var$derivativeAt(y1, y2, y3, y4, t);
    return $0bebb668bd6235eb$var$piMod(Math.atan2(dy, dx));
}
function $0bebb668bd6235eb$var$analyzePoints(points) {
    // 计算每段的长度和总的长度
    var totalLength = 0;
    var segments = [];
    for(var i = 0; i < points.length - 1; i++){
        var from = points[i];
        var to = points[i + 1];
        var length = $0bebb668bd6235eb$export$9f17032d917177de(from[0], from[1], to[0], to[1]);
        var seg = {
            from: from,
            to: to,
            length: length
        };
        segments.push(seg);
        totalLength += length;
    }
    return {
        segments: segments,
        totalLength: totalLength
    };
}
function $0bebb668bd6235eb$var$lengthOfSegment(points) {
    if (points.length < 2) return 0;
    var totalLength = 0;
    for(var i = 0; i < points.length - 1; i++){
        var from = points[i];
        var to = points[i + 1];
        totalLength += $0bebb668bd6235eb$export$9f17032d917177de(from[0], from[1], to[0], to[1]);
    }
    return totalLength;
}
/**
 * 按照比例在数据片段中获取点
 * @param {array} points 点的集合
 * @param {number} t 百分比 0-1
 * @return {object} 点的坐标
 */ function $0bebb668bd6235eb$var$pointAtSegments(points, t) {
    // 边界判断
    if (t > 1 || t < 0 || points.length < 2) return null;
    var _analyzePoints = $0bebb668bd6235eb$var$analyzePoints(points), segments = _analyzePoints.segments, totalLength = _analyzePoints.totalLength;
    // 多个点有可能重合
    if (totalLength === 0) return {
        x: points[0][0],
        y: points[0][1]
    };
    // 计算比例
    var startRatio = 0;
    var point = null;
    for(var i = 0; i < segments.length; i++){
        var seg = segments[i];
        var from = seg.from, to = seg.to;
        var currentRatio = seg.length / totalLength;
        if (t >= startRatio && t <= startRatio + currentRatio) {
            var localRatio = (t - startRatio) / currentRatio;
            point = $0bebb668bd6235eb$export$bbefe09b584041c9(from[0], from[1], to[0], to[1], localRatio);
            break;
        }
        startRatio += currentRatio;
    }
    return point;
}
/**
 * 按照比例在数据片段中获取切线的角度
 * @param {array} points 点的集合
 * @param {number} t 百分比 0-1
 */ function $0bebb668bd6235eb$var$angleAtSegments(points, t) {
    // 边界判断
    if (t > 1 || t < 0 || points.length < 2) return 0;
    var _analyzePoints2 = $0bebb668bd6235eb$var$analyzePoints(points), segments = _analyzePoints2.segments, totalLength = _analyzePoints2.totalLength;
    // 计算比例
    var startRatio = 0;
    var angle = 0;
    for(var i = 0; i < segments.length; i++){
        var seg = segments[i];
        var from = seg.from, to = seg.to;
        var currentRatio = seg.length / totalLength;
        if (t >= startRatio && t <= startRatio + currentRatio) {
            angle = Math.atan2(to[1] - from[1], to[0] - from[0]);
            break;
        }
        startRatio += currentRatio;
    }
    return angle;
}
function $0bebb668bd6235eb$var$distanceAtSegment(points, x, y) {
    var minDistance = Infinity;
    for(var i = 0; i < points.length - 1; i++){
        var point = points[i];
        var nextPoint = points[i + 1];
        var _distance = $0bebb668bd6235eb$export$e5f20cbaf608a0b8(point[0], point[1], nextPoint[0], nextPoint[1], x, y);
        if (_distance < minDistance) minDistance = _distance;
    }
    return minDistance;
}
function $0bebb668bd6235eb$export$fbb45354a3ac0213(points) {
    var xArr = [];
    var yArr = [];
    for(var i = 0; i < points.length; i++){
        var point = points[i];
        xArr.push(point[0]);
        yArr.push(point[1]);
    }
    return $0bebb668bd6235eb$var$getBBoxByArray(xArr, yArr);
}
function $0bebb668bd6235eb$export$fed333e70a817508(points) {
    return $0bebb668bd6235eb$var$lengthOfSegment(points);
}
function $0bebb668bd6235eb$export$58e991ba1860a731(points, t) {
    return $0bebb668bd6235eb$var$pointAtSegments(points, t);
}
function $0bebb668bd6235eb$export$a0186ea3c71876b0(points, x, y) {
    return $0bebb668bd6235eb$var$distanceAtSegment(points, x, y);
}
function $0bebb668bd6235eb$export$5796c0b2cecb7828(points, t) {
    return $0bebb668bd6235eb$var$angleAtSegments(points, t);
}
function $0bebb668bd6235eb$var$getAllPoints(points) {
    var tmp = points.slice(0);
    if (points.length) tmp.push(points[0]);
    return tmp;
}
function $0bebb668bd6235eb$export$d762bd8a9690a11e(points) {
    return $0bebb668bd6235eb$export$fbb45354a3ac0213(points);
}
function $0bebb668bd6235eb$export$9236f1a6c551ea06(points) {
    return $0bebb668bd6235eb$var$lengthOfSegment($0bebb668bd6235eb$var$getAllPoints(points));
}
function $0bebb668bd6235eb$export$50df11d5bd2f1bf(points, t) {
    return $0bebb668bd6235eb$var$pointAtSegments($0bebb668bd6235eb$var$getAllPoints(points), t);
}
function $0bebb668bd6235eb$export$376ccd30cce7bf54(points, x, y) {
    return $0bebb668bd6235eb$var$distanceAtSegment($0bebb668bd6235eb$var$getAllPoints(points), x, y);
}
function $0bebb668bd6235eb$export$adf39642d892a061(points, t) {
    return $0bebb668bd6235eb$var$angleAtSegments($0bebb668bd6235eb$var$getAllPoints(points), t);
}
// 差值公式
function $0bebb668bd6235eb$var$quadraticAt(p0, p1, p2, t) {
    var onet = 1 - t;
    return onet * onet * p0 + 2 * t * onet * p1 + t * t * p2;
}
// 求极值
function $0bebb668bd6235eb$var$extrema(p0, p1, p2) {
    var a = p0 + p2 - 2 * p1;
    if ((0, $dFv1j.default)(a, 0)) return [
        0.5
    ];
    var rst = (p0 - p1) / a;
    if (rst <= 1 && rst >= 0) return [
        rst
    ];
    return [];
}
// 分割贝塞尔曲线
function $0bebb668bd6235eb$var$divideQuadratic(x1, y1, x2, y2, x3, y3, t) {
    // 划分点
    var xt = $0bebb668bd6235eb$var$quadraticAt(x1, x2, x3, t);
    var yt = $0bebb668bd6235eb$var$quadraticAt(y1, y2, y3, t);
    // 分割的第一条曲线的控制点
    var controlPoint1 = $0bebb668bd6235eb$export$bbefe09b584041c9(x1, y1, x2, y2, t);
    // 分割的第二条曲线的控制点
    var controlPoint2 = $0bebb668bd6235eb$export$bbefe09b584041c9(x2, y2, x3, y3, t);
    return [
        [
            x1,
            y1,
            controlPoint1.x,
            controlPoint1.y,
            xt,
            yt
        ],
        [
            xt,
            yt,
            controlPoint2.x,
            controlPoint2.y,
            x3,
            y3
        ]
    ];
}
// 使用迭代法取贝塞尔曲线的长度
function $0bebb668bd6235eb$var$quadraticLength(x1, y1, x2, y2, x3, y3, iterationCount) {
    if (iterationCount === 0) return ($0bebb668bd6235eb$export$9f17032d917177de(x1, y1, x2, y2) + $0bebb668bd6235eb$export$9f17032d917177de(x2, y2, x3, y3) + $0bebb668bd6235eb$export$9f17032d917177de(x1, y1, x3, y3)) / 2;
    var quadratics = $0bebb668bd6235eb$var$divideQuadratic(x1, y1, x2, y2, x3, y3, 0.5);
    var left = quadratics[0];
    var right = quadratics[1];
    left.push(iterationCount - 1);
    right.push(iterationCount - 1);
    return $0bebb668bd6235eb$var$quadraticLength.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(left)) + $0bebb668bd6235eb$var$quadraticLength.apply(void 0, (0, (/*@__PURE__*/$parcel$interopDefault($fUHKi)))(right));
}
function $0bebb668bd6235eb$export$17067c8fce023cab(x1, y1, x2, y2, x3, y3) {
    var xExtrema = $0bebb668bd6235eb$var$extrema(x1, x2, x3)[0];
    var yExtrema = $0bebb668bd6235eb$var$extrema(y1, y2, y3)[0];
    // 控制点不加入 box 的计算
    var xArr = [
        x1,
        x3
    ];
    var yArr = [
        y1,
        y3
    ];
    if (xExtrema !== undefined) xArr.push($0bebb668bd6235eb$var$quadraticAt(x1, x2, x3, xExtrema));
    if (yExtrema !== undefined) yArr.push($0bebb668bd6235eb$var$quadraticAt(y1, y2, y3, yExtrema));
    return $0bebb668bd6235eb$var$getBBoxByArray(xArr, yArr);
}
function $0bebb668bd6235eb$export$680e04938e5e385b(x1, y1, x2, y2, x3, y3) {
    return $0bebb668bd6235eb$var$quadraticLength(x1, y1, x2, y2, x3, y3, 3);
}
function $0bebb668bd6235eb$export$c4f1ef577eb57075(x1, y1, x2, y2, x3, y3, x0, y0) {
    return $0bebb668bd6235eb$var$nearestPoint$2([
        x1,
        x2,
        x3
    ], [
        y1,
        y2,
        y3
    ], x0, y0, $0bebb668bd6235eb$var$quadraticAt);
}
function $0bebb668bd6235eb$export$b9a942359c6a151a(x1, y1, x2, y2, x3, y3, x0, y0) {
    var point = $0bebb668bd6235eb$export$c4f1ef577eb57075(x1, y1, x2, y2, x3, y3, x0, y0);
    return $0bebb668bd6235eb$export$9f17032d917177de(point.x, point.y, x0, y0);
}

});

parcelRegister("8HV7i", function(module, exports) {

var $g3LWB = parcelRequire("g3LWB");

var $dxaB1 = parcelRequire("dxaB1");

var $clik2 = parcelRequire("clik2");

var $ffJvR = parcelRequire("ffJvR");

var $akdiQ = parcelRequire("akdiQ");

var $jqdgk = parcelRequire("jqdgk");

var $fj05i = parcelRequire("fj05i");
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict";
    var r = $dxaB1(), e = r.m($656ea513998a70a9$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $fj05i(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $g3LWB(r, e);
            },
            AsyncIterator: $akdiQ,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $ffJvR : $clik2)(a(r), e, t, o, u);
            },
            keys: $jqdgk,
            values: $fj05i
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g3LWB", function(module, exports) {
function $bb121de08fcbfcd5$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $bb121de08fcbfcd5$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dxaB1", function(module, exports) {

var $bvtjp = parcelRequire("bvtjp");
function $9da69396b6a55ef6$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $bvtjp(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($bvtjp(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $bvtjp(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $bvtjp(u, "constructor", GeneratorFunctionPrototype), $bvtjp(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $bvtjp(GeneratorFunctionPrototype, o, "GeneratorFunction"), $bvtjp(u), $bvtjp(u, o, "Generator"), $bvtjp(u, n, function() {
        return this;
    }), $bvtjp(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $9da69396b6a55ef6$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $9da69396b6a55ef6$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bvtjp", function(module, exports) {
function $860953b56aa6b685$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $860953b56aa6b685$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $860953b56aa6b685$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $860953b56aa6b685$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $860953b56aa6b685$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("clik2", function(module, exports) {

var $ffJvR = parcelRequire("ffJvR");
function $8fc5a89a7b8dab85$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $ffJvR(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $8fc5a89a7b8dab85$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ffJvR", function(module, exports) {

var $dxaB1 = parcelRequire("dxaB1");

var $akdiQ = parcelRequire("akdiQ");
function $b1ab8fa4d5e48c1f$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $akdiQ($dxaB1().w(r, e, t, o), n || Promise);
}
module.exports = $b1ab8fa4d5e48c1f$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("akdiQ", function(module, exports) {

var $g3LWB = parcelRequire("g3LWB");

var $bvtjp = parcelRequire("bvtjp");
function $78461755ff54e6c7$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $g3LWB ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($bvtjp($78461755ff54e6c7$var$AsyncIterator.prototype), $bvtjp($78461755ff54e6c7$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $bvtjp(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $78461755ff54e6c7$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("jqdgk", function(module, exports) {
function $e23abba3e573ae7a$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $e23abba3e573ae7a$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fj05i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b248b2228601290d$var$_typeof = $41YNz.default;
function $b248b2228601290d$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($b248b2228601290d$var$_typeof(e) + " is not iterable");
}
module.exports = $b248b2228601290d$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fOd0O", function(module, exports) {
function $b8259e79f5c77a6f$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $b8259e79f5c77a6f$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $b8259e79f5c77a6f$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $b8259e79f5c77a6f$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8QL5z", function(module, exports) {

var $72a6v = parcelRequire("72a6v");
function $6717b4f17c8c4903$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $72a6v(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}
module.exports = $6717b4f17c8c4903$var$_createForOfIteratorHelper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("7JB23", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = 'AAAAAAAAAAAAEA4AGBkAAFAaAAACAAAAAAAIABAAGAAwADgACAAQAAgAEAAIABAACAAQAAgAEAAIABAACAAQAAgAEAAIABAAQABIAEQATAAIABAACAAQAAgAEAAIABAAVABcAAgAEAAIABAACAAQAGAAaABwAHgAgACIAI4AlgAIABAAmwCjAKgAsAC2AL4AvQDFAMoA0gBPAVYBWgEIAAgACACMANoAYgFkAWwBdAF8AX0BhQGNAZUBlgGeAaMBlQGWAasBswF8AbsBwwF0AcsBYwHTAQgA2wG/AOMBdAF8AekB8QF0AfkB+wHiAHQBfAEIAAMC5gQIAAsCEgIIAAgAFgIeAggAIgIpAggAMQI5AkACygEIAAgASAJQAlgCYAIIAAgACAAKBQoFCgUTBRMFGQUrBSsFCAAIAAgACAAIAAgACAAIAAgACABdAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABoAmgCrwGvAQgAbgJ2AggAHgEIAAgACADnAXsCCAAIAAgAgwIIAAgACAAIAAgACACKAggAkQKZAggAPADJAAgAoQKkAqwCsgK6AsICCADJAggA0AIIAAgACAAIANYC3gIIAAgACAAIAAgACABAAOYCCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAkASoB+QIEAAgACAA8AEMCCABCBQgACABJBVAFCAAIAAgACAAIAAgACAAIAAgACABTBVoFCAAIAFoFCABfBWUFCAAIAAgACAAIAAgAbQUIAAgACAAIAAgACABzBXsFfQWFBYoFigWKBZEFigWKBYoFmAWfBaYFrgWxBbkFCAAIAAgACAAIAAgACAAIAAgACAAIAMEFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAMgFCADQBQgACAAIAAgACAAIAAgACAAIAAgACAAIAO4CCAAIAAgAiQAIAAgACABAAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAD0AggACAD8AggACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIANYFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAMDvwAIAAgAJAIIAAgACAAIAAgACAAIAAgACwMTAwgACAB9BOsEGwMjAwgAKwMyAwsFYgE3A/MEPwMIAEUDTQNRAwgAWQOsAGEDCAAIAAgACAAIAAgACABpAzQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFIQUoBSwFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABtAwgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABMAEwACAAIAAgACAAIABgACAAIAAgACAC/AAgACAAyAQgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACAAIAAwAAgACAAIAAgACAAIAAgACAAIAAAARABIAAgACAAIABQASAAIAAgAIABwAEAAjgCIABsAqAC2AL0AigDQAtwC+IJIQqVAZUBWQqVAZUBlQGVAZUBlQGrC5UBlQGVAZUBlQGVAZUBlQGVAXsKlQGVAbAK6wsrDGUMpQzlDJUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAfAKAAuZA64AtwCJALoC6ADwAAgAuACgA/oEpgO6AqsD+AAIAAgAswMIAAgACAAIAIkAuwP5AfsBwwPLAwgACAAIAAgACADRA9kDCAAIAOED6QMIAAgACAAIAAgACADuA/YDCAAIAP4DyQAIAAgABgQIAAgAXQAOBAgACAAIAAgACAAIABMECAAIAAgACAAIAAgACAD8AAQBCAAIAAgAGgQiBCoECAExBAgAEAEIAAgACAAIAAgACAAIAAgACAAIAAgACAA4BAgACABABEYECAAIAAgATAQYAQgAVAQIAAgACAAIAAgACAAIAAgACAAIAFoECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAOQEIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAB+BAcACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAEABhgSMBAgACAAIAAgAlAQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAwAEAAQABAADAAMAAwADAAQABAAEAAQABAAEAAQABHATAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAdQMIAAgACAAIAAgACAAIAMkACAAIAAgAfQMIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACFA4kDCAAIAAgACAAIAOcBCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAIcDCAAIAAgACAAIAAgACAAIAAgACAAIAJEDCAAIAAgACADFAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABgBAgAZgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAbAQCBXIECAAIAHkECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABAAJwEQACjBKoEsgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAC6BMIECAAIAAgACAAIAAgACABmBAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAxwQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAGYECAAIAAgAzgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBd0FXwUIAOIF6gXxBYoF3gT5BQAGCAaKBYoFigWKBYoFigWKBYoFigWKBYoFigXWBIoFigWKBYoFigWKBYoFigWKBYsFEAaKBYoFigWKBYoFigWKBRQGCACKBYoFigWKBQgACAAIANEECAAIABgGigUgBggAJgYIAC4GMwaKBYoF0wQ3Bj4GigWKBYoFigWKBYoFigWKBYoFigWKBYoFigUIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWLBf///////wQABAAEAAQABAAEAAQABAAEAAQAAwAEAAQAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAQADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUAAAAFAAUAAAAFAAUAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAQAAAAUABQAFAAUABQAFAAAAAAAFAAUAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAFAAUAAQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAAABwAHAAcAAAAHAAcABwAFAAEAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAcABwAFAAUAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAAAQABAAAAAAAAAAAAAAAFAAUABQAFAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAHAAcAAAAHAAcAAAAAAAUABQAHAAUAAQAHAAEABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwABAAUABQAFAAUAAAAAAAAAAAAAAAEAAQABAAEAAQABAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABQANAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAABQAHAAUABQAFAAAAAAAAAAcABQAFAAUABQAFAAQABAAEAAQABAAEAAQABAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUAAAAFAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAUAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAcABwAFAAcABwAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUABwAHAAUABQAFAAUAAAAAAAcABwAAAAAABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAAAAAAAAAAABQAFAAAAAAAFAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAFAAUABQAFAAUAAAAFAAUABwAAAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABwAFAAUABQAFAAAAAAAHAAcAAAAAAAcABwAFAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAAAAAAAAAHAAcABwAAAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAUABQAFAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAHAAcABQAHAAcAAAAFAAcABwAAAAcABwAFAAUAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAFAAcABwAFAAUABQAAAAUAAAAHAAcABwAHAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAHAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUAAAAFAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAUAAAAFAAUAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABwAFAAUABQAFAAUABQAAAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABQAFAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAFAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAHAAUABQAFAAUABQAFAAUABwAHAAcABwAHAAcABwAHAAUABwAHAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABwAHAAcABwAFAAUABwAHAAcAAAAAAAAAAAAHAAcABQAHAAcABwAHAAcABwAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAUABQAFAAUABQAFAAUAAAAFAAAABQAAAAAABQAFAAUABQAFAAUABQAFAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAUABQAFAAUABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABwAFAAcABwAHAAcABwAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAUABQAFAAUABwAHAAUABQAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABQAFAAcABwAHAAUABwAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAcABQAFAAUABQAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAAAAAABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAAAAAAAAAFAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAUABQAHAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAFAAUABQAFAAcABwAFAAUABwAHAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAcABwAFAAUABwAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABQAAAAAABQAFAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAcABwAAAAAAAAAAAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAcABwAFAAcABwAAAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAFAAUABQAAAAUABQAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABwAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAHAAcABQAHAAUABQAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAAABwAHAAAAAAAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAFAAUABwAFAAcABwAFAAcABQAFAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAAAAAABwAHAAcABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAFAAcABwAFAAUABQAFAAUABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAUABQAFAAcABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABQAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAAAAAAFAAUABwAHAAcABwAFAAAAAAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAHAAUABQAFAAUABQAFAAUABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAABQAAAAUABQAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAHAAcAAAAFAAUAAAAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABQAFAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAABQAFAAUABQAFAAUABQAAAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAFAAUABQAFAAUADgAOAA4ADgAOAA4ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAMAAwADAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAAAAAAAAAAAAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAAAAAAAAAAAAsADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwACwAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAADgAOAA4AAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAAAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4AAAAOAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAAAAAAAAAAAA4AAAAOAAAAAAAAAAAADgAOAA4AAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAA=';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});


parcelRegister("am5xm", function(module, exports) {

$parcel$export(module.exports, "Fade", () => $78a040faa9acd59e$export$c983850c6c9d8b0e);
$parcel$export(module.exports, "Translate", () => $78a040faa9acd59e$export$9db2ba50894db2b9);
$parcel$export(module.exports, "NodeCollapse", () => $78a040faa9acd59e$export$ffc1ce8530100d99);
$parcel$export(module.exports, "NodeExpand", () => $78a040faa9acd59e$export$fa3c91a0695ac9f3);
$parcel$export(module.exports, "PathIn", () => $78a040faa9acd59e$export$dc3da5247a614047);
$parcel$export(module.exports, "PathOut", () => $78a040faa9acd59e$export$487803c351d2c4e5);
$parcel$export(module.exports, "ComboCollapse", () => $78a040faa9acd59e$export$109f3588ca92e373);
$parcel$export(module.exports, "ComboExpand", () => $78a040faa9acd59e$export$ef0a802248c8c7cb);
/**
 * <zh/> 内置的动画元素。
 * <en/> Built-in animations.
 */ 
var $lbDhQ = parcelRequire("lbDhQ");
const $78a040faa9acd59e$export$c983850c6c9d8b0e = [
    {
        fields: [
            'opacity'
        ]
    }
];
const $78a040faa9acd59e$export$9db2ba50894db2b9 = [
    {
        fields: [
            'x',
            'y'
        ]
    }
];
const $78a040faa9acd59e$export$ffc1ce8530100d99 = [
    {
        fields: [
            'x',
            'y'
        ]
    }
];
const $78a040faa9acd59e$export$fa3c91a0695ac9f3 = $78a040faa9acd59e$export$ffc1ce8530100d99;
const $78a040faa9acd59e$export$dc3da5247a614047 = [
    {
        fields: [
            'sourceNode',
            'targetNode'
        ]
    }
];
const $78a040faa9acd59e$export$487803c351d2c4e5 = $78a040faa9acd59e$export$dc3da5247a614047;
const $78a040faa9acd59e$export$109f3588ca92e373 = [
    {
        fields: [
            'childrenNode',
            'x',
            'y'
        ]
    }
];
const $78a040faa9acd59e$export$ef0a802248c8c7cb = $78a040faa9acd59e$export$109f3588ca92e373;
const $78a040faa9acd59e$export$9cb013c38e4c77ae = [
    {
        fields: [
            'childrenNode',
            'x',
            'y'
        ]
    }
];

});
parcelRegister("lbDhQ", function(module, exports) {

$parcel$export(module.exports, "executor", () => $f6c9199d5917d93f$export$ab520ac5903e3420);

var $10sB9 = parcelRequire("10sB9");

var $dtz9V = parcelRequire("dtz9V");

var $aPhuQ = parcelRequire("aPhuQ");
var $f6c9199d5917d93f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $f6c9199d5917d93f$export$ab520ac5903e3420 = (element, keyframes, options)=>{
    if (!options.length) return null;
    const [originalStyle, modifiedStyle] = keyframes;
    /**
     * <zh/> 获取图形关键帧样式
     *
     * <en/> Get the keyframe style of the shape
     * @param shapeID - <zh/> 图形 ID | <en/> shape ID
     * @returns <zh/> 图形关键帧样式 | <en/> keyframe style of the shape
     */ const getKeyframeStyle = (shapeID)=>{
        var _a;
        if (shapeID) {
            const shape = element.getShape(shapeID);
            if (!shape) return null;
            const name = `get${(0, $10sB9.default)(shapeID)}Style`;
            const styler = ((_a = element === null || element === void 0 ? void 0 : element[name]) === null || _a === void 0 ? void 0 : _a.bind(element)) || ((attrs)=>attrs);
            const fromStyle = (styler === null || styler === void 0 ? void 0 : styler(originalStyle)) || {};
            const toStyle = (styler === null || styler === void 0 ? void 0 : styler(modifiedStyle)) || {};
            return {
                shape: shape,
                fromStyle: fromStyle,
                toStyle: toStyle
            };
        } else {
            const shape = element;
            return {
                shape: shape,
                fromStyle: originalStyle,
                toStyle: modifiedStyle
            };
        }
    };
    let mainResult;
    const subResults = options.map((_a)=>{
        var { fields: fields, shape: shapeID, states: enabledStates } = _a, effectTiming = $f6c9199d5917d93f$var$__rest(_a, [
            "fields",
            "shape",
            "states"
        ]);
        const keyframeStyle = getKeyframeStyle(shapeID);
        if (!keyframeStyle) return null;
        const { shape: shape, fromStyle: fromStyle, toStyle: toStyle } = keyframeStyle;
        const keyframes = [
            {},
            {}
        ];
        fields.forEach((attr)=>{
            var _a, _b;
            Object.assign(keyframes[0], {
                [attr]: (_a = fromStyle[attr]) !== null && _a !== void 0 ? _a : (0, $dtz9V.inferDefaultValue)(attr)
            });
            Object.assign(keyframes[1], {
                [attr]: (_b = toStyle[attr]) !== null && _b !== void 0 ? _b : (0, $dtz9V.inferDefaultValue)(attr)
            });
        });
        // x/y -> translate
        if (keyframes.some((keyframe)=>Object.keys(keyframe).some((attr)=>[
                    'x',
                    'y',
                    'z'
                ].includes(attr)))) {
            const { x: x = 0, y: y = 0, z: z, transform: transform = '' } = shape.attributes || {};
            keyframes.forEach((keyframe)=>{
                var _a, _b, _c;
                // @ts-expect-error ignore type error
                keyframe.transform = (0, $aPhuQ.replaceTranslateInTransform)((_a = keyframe.x) !== null && _a !== void 0 ? _a : x, (_b = keyframe.y) !== null && _b !== void 0 ? _b : y, (_c = keyframe.z) !== null && _c !== void 0 ? _c : z, transform);
            });
        }
        const result = shape.animate((0, $dtz9V.preprocessKeyframes)(keyframes), effectTiming);
        if (shapeID === undefined) mainResult = result;
        return result;
    }).filter(Boolean);
    const result = mainResult || (subResults === null || subResults === void 0 ? void 0 : subResults[0]);
    if (!result) return null;
    return (0, $dtz9V.createAnimationsProxy)(result, subResults.filter((result)=>result !== result));
};

});
parcelRegister("10sB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bbbf9841b58a8bf$export$2e2bcd8739ae039);

var $dcr8Y = parcelRequire("dcr8Y");
var $0bbbf9841b58a8bf$var$upperFirst = function(value) {
    var str = (0, $dcr8Y.default)(value);
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var $0bbbf9841b58a8bf$export$2e2bcd8739ae039 = $0bbbf9841b58a8bf$var$upperFirst;

});
parcelRegister("dcr8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $99c1738b54eb163c$export$2e2bcd8739ae039);

var $geZBG = parcelRequire("geZBG");
var $99c1738b54eb163c$export$2e2bcd8739ae039 = function(value) {
    if ((0, $geZBG.default)(value)) return '';
    return value.toString();
};

});


parcelRegister("dtz9V", function(module, exports) {

$parcel$export(module.exports, "createAnimationsProxy", () => $9cf941a58f671779$export$3164278fbe419043);
$parcel$export(module.exports, "preprocessKeyframes", () => $9cf941a58f671779$export$818a82b7595e914e);
$parcel$export(module.exports, "inferDefaultValue", () => $9cf941a58f671779$export$68b8dbef00c7d285);
$parcel$export(module.exports, "getAnimationOptions", () => $9cf941a58f671779$export$c03d5bc10be38e5);
$parcel$export(module.exports, "getElementAnimationOptions", () => $9cf941a58f671779$export$79f33998a016b0a);

var $4ETMA = parcelRequire("4ETMA");
var $geZBG = parcelRequire("geZBG");
var $6JKSc = parcelRequire("6JKSc");
parcelRequire("ahJ7k");
var $g66KS = parcelRequire("g66KS");
var $jRLln = parcelRequire("jRLln");

var $hW6vf = parcelRequire("hW6vf");

var $aBpmX = parcelRequire("aBpmX");

var $3SjwL = parcelRequire("3SjwL");
function $9cf941a58f671779$export$3164278fbe419043(args1, args2) {
    if (Array.isArray(args1) && args1.length === 0) return null;
    const sourceAnimation = Array.isArray(args1) ? args1[0] : args1;
    const targetAnimations = Array.isArray(args1) ? args1.slice(1) : args2 || [];
    return new Proxy(sourceAnimation, {
        get (target, propKey) {
            if (typeof target[propKey] === 'function' && ![
                'onframe',
                'onfinish'
            ].includes(propKey)) return (...args)=>{
                target[propKey](...args);
                targetAnimations.forEach((animation)=>{
                    var _a;
                    return (_a = animation[propKey]) === null || _a === void 0 ? void 0 : _a.call(animation, ...args);
                });
            };
            if (propKey === 'finished') return Promise.all([
                sourceAnimation.finished,
                ...targetAnimations.map((animation)=>animation.finished)
            ]);
            return Reflect.get(target, propKey);
        },
        set (target, propKey, value) {
            // onframe 和 onfinish 特殊处理，不用同步到所有动画实例上
            // onframe and onfinish are specially processed and do not need to be synchronized to all animation instances
            if (![
                'onframe',
                'onfinish'
            ].includes(propKey)) targetAnimations.forEach((animation)=>{
                animation[propKey] = value;
            });
            return Reflect.set(target, propKey, value);
        }
    });
}
function $9cf941a58f671779$export$818a82b7595e914e(keyframes) {
    // 转化为 PropertyIndexedKeyframes 格式方便后续处理
    // convert to PropertyIndexedKeyframes format for subsequent processing
    const propertyIndexedKeyframes = keyframes.reduce((acc, kf)=>{
        Object.entries(kf).forEach(([key, value])=>{
            if (acc[key] === undefined) acc[key] = [
                value
            ];
            else acc[key].push(value);
        });
        return acc;
    }, {});
    // 过滤掉无用动画的属性（属性值为 undefined、或者值完全一致）
    // filter out useless animation properties (property value is undefined, or value is exactly the same)
    Object.entries(propertyIndexedKeyframes).forEach(([key, values])=>{
        if (// 属性值必须在每一帧都存在 / property value must exist in every frame
        values.length !== keyframes.length || // 属性值不能为空 / property value cannot be empty
        values.some((value)=>(0, $geZBG.default)(value)) || // 属性值必须不完全一致 / property value must not be exactly the same
        // 属性值可以是保留属性 / property value can be the reserved property
        values.every((value)=>![
                'sourceNode',
                'targetNode',
                'childrenNode'
            ].includes(key) && (0, $4ETMA.default)(value, values[0]))) delete propertyIndexedKeyframes[key];
    });
    // 将 PropertyIndexedKeyframes 转化为 Keyframe 格式
    // convert PropertyIndexedKeyframes to Keyframe format
    const output = Object.entries(propertyIndexedKeyframes).reduce((acc, [key, values])=>{
        values.forEach((value, index)=>{
            if (!acc[index]) acc[index] = {
                [key]: value
            };
            else acc[index][key] = value;
        });
        return acc;
    }, []);
    // 如果处理后所有的属性都被过滤掉，则添加一个没有实际作用的属性用于触发动画
    // If all properties are filtered out after processing, add a property that has no actual effect to trigger the animation
    if (keyframes.length !== 0 && output.length === 0) output.push(...[
        {
            _: 0
        },
        {
            _: 0
        }
    ]);
    return output;
}
function $9cf941a58f671779$export$68b8dbef00c7d285(name) {
    switch(name){
        case 'opacity':
            return 1;
        case 'x':
        case 'y':
        case 'z':
        case 'zIndex':
            return 0;
        case 'visibility':
            return 'visible';
        case 'collapsed':
            return false;
        case 'states':
            return [];
        default:
            return undefined;
    }
}
function $9cf941a58f671779$export$c03d5bc10be38e5(options, localAnimation) {
    const { animation: animation } = options;
    if (animation === false || localAnimation === false) return false;
    const effectTiming = Object.assign({}, (0, $g66KS.DEFAULT_ANIMATION_OPTIONS));
    if ((0, $6JKSc.default)(animation)) Object.assign(effectTiming, animation);
    if ((0, $6JKSc.default)(localAnimation)) Object.assign(effectTiming, localAnimation);
    return effectTiming;
}
/**
 * <zh/> 获取动画配置
 *
 * <en/> Get animation configuration
 * @param options - <zh/> 动画配置项 | <en/> animation configuration
 * @returns <zh/> 动画配置 | <en/> animation configuration
 */ function $9cf941a58f671779$var$animationOf(options) {
    if (typeof options === 'string') {
        const animation = (0, $hW6vf.getExtension)((0, $jRLln.ExtensionCategory).ANIMATION, options);
        if (animation) return animation;
        (0, $aBpmX.print).warn(`The animation of ${options} is not registered.`);
        return [];
    }
    return options;
}
function $9cf941a58f671779$export$79f33998a016b0a(options, elementType, stage, localAnimation) {
    var _a, _b;
    const { animation: globalAnimation } = options;
    if (globalAnimation === false || localAnimation === false) return [];
    const userElementAnimation = (_a = options === null || options === void 0 ? void 0 : options[elementType]) === null || _a === void 0 ? void 0 : _a.animation;
    if (userElementAnimation === false) return [];
    const useElementStageAnimation = userElementAnimation === null || userElementAnimation === void 0 ? void 0 : userElementAnimation[stage];
    if (useElementStageAnimation === false) return [];
    // 优先级：用户局部动画配置 > 用户动画配置 > 全局动画配置 > 主题动画配置 > 默认动画配置
    // Priority: user local animation configuration > user animation configuration > global animation configuration > theme animation configuration > default animation configuration
    const themeElementAnimation = (_b = (0, $3SjwL.themeOf)(options)[elementType]) === null || _b === void 0 ? void 0 : _b.animation;
    const combine = (_ = [])=>$9cf941a58f671779$var$animationOf(_).map((animation)=>Object.assign(Object.assign(Object.assign(Object.assign({}, (0, $g66KS.DEFAULT_ELEMENTS_ANIMATION_OPTIONS)), (0, $6JKSc.default)(globalAnimation) && globalAnimation), animation), (0, $6JKSc.default)(localAnimation) && localAnimation));
    if (useElementStageAnimation) return combine(useElementStageAnimation);
    if (!themeElementAnimation) return [];
    // 此时取决于主题动画配置
    // At this time, it depends on the theme animation configuration
    const themeElementStageAnimation = themeElementAnimation[stage];
    if (themeElementStageAnimation === false) return [];
    return combine(themeElementStageAnimation);
}

});
parcelRegister("4ETMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $36462b1dc03b4a80$export$2e2bcd8739ae039);

var $bDfiK = parcelRequire("bDfiK");

var $dDtYS = parcelRequire("dDtYS");

var $kVcyu = parcelRequire("kVcyu");
var $36462b1dc03b4a80$var$isEqual = function(value, other) {
    if (value === other) return true;
    if (!value || !other) return false;
    if ((0, $kVcyu.default)(value) || (0, $kVcyu.default)(other)) return false;
    if ((0, $dDtYS.default)(value) || (0, $dDtYS.default)(other)) {
        if (value.length !== other.length) return false;
        var rst = true;
        for(var i = 0; i < value.length; i++){
            rst = $36462b1dc03b4a80$var$isEqual(value[i], other[i]);
            if (!rst) break;
        }
        return rst;
    }
    if ((0, $bDfiK.default)(value) || (0, $bDfiK.default)(other)) {
        var valueKeys = Object.keys(value);
        var otherKeys = Object.keys(other);
        if (valueKeys.length !== otherKeys.length) return false;
        var rst = true;
        for(var i = 0; i < valueKeys.length; i++){
            rst = $36462b1dc03b4a80$var$isEqual(value[valueKeys[i]], other[valueKeys[i]]);
            if (!rst) break;
        }
        return rst;
    }
    return false;
};
var $36462b1dc03b4a80$export$2e2bcd8739ae039 = $36462b1dc03b4a80$var$isEqual;

});
parcelRegister("bDfiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $877f34c84a84698b$export$2e2bcd8739ae039);
var $877f34c84a84698b$var$isObjectLike = function(value) {
    /**
     * isObjectLike({}) => true
     * isObjectLike([1, 2, 3]) => true
     * isObjectLike(Function) => false
     * isObjectLike(null) => false
     */ return typeof value === 'object' && value !== null;
};
var $877f34c84a84698b$export$2e2bcd8739ae039 = $877f34c84a84698b$var$isObjectLike;

});

parcelRegister("dDtYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ed62c746bf901fd$export$2e2bcd8739ae039);
var $9ed62c746bf901fd$var$isArrayLike = function(value) {
    /**
     * isArrayLike([1, 2, 3]) => true
     * isArrayLike(document.body.children) => true
     * isArrayLike('abc') => true
     * isArrayLike(Function) => false
     */ return value !== null && typeof value !== 'function' && isFinite(value.length);
};
var $9ed62c746bf901fd$export$2e2bcd8739ae039 = $9ed62c746bf901fd$var$isArrayLike;

});


parcelRegister("ahJ7k", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ANIMATION_OPTIONS", () => (parcelRequire("g66KS")).DEFAULT_ANIMATION_OPTIONS);
$parcel$export(module.exports, "DEFAULT_ELEMENTS_ANIMATION_OPTIONS", () => (parcelRequire("g66KS")).DEFAULT_ELEMENTS_ANIMATION_OPTIONS);
$parcel$export(module.exports, "ChangeType", () => (parcelRequire("cFz2C")).ChangeType);
$parcel$export(module.exports, "AnimationType", () => (parcelRequire("cFuSs")).AnimationType);
$parcel$export(module.exports, "CanvasEvent", () => (parcelRequire("1igYm")).CanvasEvent);
$parcel$export(module.exports, "ComboEvent", () => (parcelRequire("jjMBX")).ComboEvent);
$parcel$export(module.exports, "CommonEvent", () => (parcelRequire("9Iel2")).CommonEvent);
$parcel$export(module.exports, "ContainerEvent", () => (parcelRequire("je0UY")).ContainerEvent);
$parcel$export(module.exports, "EdgeEvent", () => (parcelRequire("5vtWi")).EdgeEvent);
$parcel$export(module.exports, "GraphEvent", () => (parcelRequire("4EzN9")).GraphEvent);
$parcel$export(module.exports, "NodeEvent", () => (parcelRequire("eO2am")).NodeEvent);
$parcel$export(module.exports, "COMBO_KEY", () => (parcelRequire("lDPR9")).COMBO_KEY);
$parcel$export(module.exports, "TREE_KEY", () => (parcelRequire("lDPR9")).TREE_KEY);
$parcel$export(module.exports, "ExtensionCategory", () => (parcelRequire("jRLln")).ExtensionCategory);
parcelRequire("g66KS");
parcelRequire("cFz2C");
parcelRequire("hzibK");
parcelRequire("lDPR9");
parcelRequire("jRLln");

});
parcelRegister("g66KS", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ANIMATION_OPTIONS", () => $bb8272521347f958$export$999a2a2cf78cf234);
$parcel$export(module.exports, "DEFAULT_ELEMENTS_ANIMATION_OPTIONS", () => $bb8272521347f958$export$af74a7fb624601b);
const $bb8272521347f958$export$999a2a2cf78cf234 = {
    duration: 500
};
const $bb8272521347f958$export$af74a7fb624601b = {
    duration: 1000,
    easing: 'cubic-bezier(0.250, 0.460, 0.450, 0.940)',
    iterations: 1,
    fill: 'both'
};

});

parcelRegister("cFz2C", function(module, exports) {

$parcel$export(module.exports, "ChangeType", () => $93947ed7075f2d18$export$9139feb552a78922);
const $93947ed7075f2d18$export$6f3d2ed036691e4e = {
    /**
     * <zh/> 数据变更
     *
     * <en/> Data changes
     */ CHANGE: 'change'
};
var $93947ed7075f2d18$export$9139feb552a78922;
(function(ChangeType) {
    /**
     * <zh/> 节点添加
     *
     * <en/> Node added
     */ ChangeType["NodeAdded"] = "NodeAdded";
    /**
     * <zh/> 节点更新
     *
     * <en/> Node updated
     */ ChangeType["NodeUpdated"] = "NodeUpdated";
    /**
     * <zh/> 节点删除
     *
     * <en/> Node removed
     */ ChangeType["NodeRemoved"] = "NodeRemoved";
    /**
     * <zh/> 边添加
     *
     * <en/> Edge added
     */ ChangeType["EdgeAdded"] = "EdgeAdded";
    /**
     * <zh/> 边更新
     *
     * <en/> Edge updated
     */ ChangeType["EdgeUpdated"] = "EdgeUpdated";
    /**
     * <zh/> 边删除
     *
     * <en/> Edge removed
     */ ChangeType["EdgeRemoved"] = "EdgeRemoved";
    /**
     * <zh/> Combo添加
     *
     * <en/> Combo added
     */ ChangeType["ComboAdded"] = "ComboAdded";
    /**
     * <zh/> Combo更新
     *
     * <en/> Combo updated
     */ ChangeType["ComboUpdated"] = "ComboUpdated";
    /**
     * <zh/> Combo删除
     *
     * <en/> Combo removed
     */ ChangeType["ComboRemoved"] = "ComboRemoved";
})($93947ed7075f2d18$export$9139feb552a78922 || ($93947ed7075f2d18$export$9139feb552a78922 = {}));

});

parcelRegister("hzibK", function(module, exports) {

$parcel$export(module.exports, "AnimationType", () => (parcelRequire("cFuSs")).AnimationType);
$parcel$export(module.exports, "CanvasEvent", () => (parcelRequire("1igYm")).CanvasEvent);
$parcel$export(module.exports, "ComboEvent", () => (parcelRequire("jjMBX")).ComboEvent);
$parcel$export(module.exports, "CommonEvent", () => (parcelRequire("9Iel2")).CommonEvent);
$parcel$export(module.exports, "ContainerEvent", () => (parcelRequire("je0UY")).ContainerEvent);
$parcel$export(module.exports, "EdgeEvent", () => (parcelRequire("5vtWi")).EdgeEvent);
$parcel$export(module.exports, "GraphEvent", () => (parcelRequire("4EzN9")).GraphEvent);
$parcel$export(module.exports, "NodeEvent", () => (parcelRequire("eO2am")).NodeEvent);

var $cFuSs = parcelRequire("cFuSs");

var $1igYm = parcelRequire("1igYm");

var $jjMBX = parcelRequire("jjMBX");

var $9Iel2 = parcelRequire("9Iel2");

var $je0UY = parcelRequire("je0UY");

var $5vtWi = parcelRequire("5vtWi");

var $4EzN9 = parcelRequire("4EzN9");

var $5TVj3 = parcelRequire("5TVj3");

var $eO2am = parcelRequire("eO2am");

});
parcelRegister("cFuSs", function(module, exports) {

$parcel$export(module.exports, "AnimationType", () => $939143f25c03b434$export$2deb71ebd3734d23);
var $939143f25c03b434$export$2deb71ebd3734d23;
(function(AnimationType) {
    AnimationType["DRAW"] = "draw";
    AnimationType["COLLAPSE"] = "collapse";
    AnimationType["EXPAND"] = "expand";
    AnimationType["TRANSFORM"] = "transform";
})($939143f25c03b434$export$2deb71ebd3734d23 || ($939143f25c03b434$export$2deb71ebd3734d23 = {}));

});

parcelRegister("1igYm", function(module, exports) {

$parcel$export(module.exports, "CanvasEvent", () => $0f14a342d64c3d0e$export$70e68a7b98db5684);
/**
 * <zh/> 画布事件
 *
 * <en/> Canvas event
 */ var $0f14a342d64c3d0e$export$70e68a7b98db5684;
(function(CanvasEvent) {
    /**
     * <zh/> 点击时触发
     *
     * <en/> Triggered when click
     */ CanvasEvent["CLICK"] = "canvas:click";
    /**
     * <zh/> 双击时触发
     *
     * <en/> Triggered when double click
     */ CanvasEvent["DBLCLICK"] = "canvas:dblclick";
    /**
     * <zh/> 指针移入时触发
     *
     * <en/> Triggered when the pointer enters
     */ CanvasEvent["POINTER_OVER"] = "canvas:pointerover";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ CanvasEvent["POINTER_LEAVE"] = "canvas:pointerleave";
    /**
     * <zh/> 指针移入时或移入子元素时触发（不会冒泡）
     *
     * <en/> Triggered when the pointer enters or enters a child element (does not bubble)
     */ CanvasEvent["POINTER_ENTER"] = "canvas:pointerenter";
    /**
     * <zh/> 指针移动时触发
     *
     * <en/> Triggered when the pointer moves
     */ CanvasEvent["POINTER_MOVE"] = "canvas:pointermove";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ CanvasEvent["POINTER_OUT"] = "canvas:pointerout";
    /**
     * <zh/> 指针按下时触发
     *
     * <en/> Triggered when the pointer is pressed
     */ CanvasEvent["POINTER_DOWN"] = "canvas:pointerdown";
    /**
     * <zh/> 指针抬起时触发
     *
     * <en/> Triggered when the pointer is lifted
     */ CanvasEvent["POINTER_UP"] = "canvas:pointerup";
    /**
     * <zh/> 打开上下文菜单时触发
     *
     * <en/> Triggered when the context menu is opened
     */ CanvasEvent["CONTEXT_MENU"] = "canvas:contextmenu";
    /**
     * <zh/> 开始拖拽时触发
     *
     * <en/> Triggered when dragging starts
     */ CanvasEvent["DRAG_START"] = "canvas:dragstart";
    /**
     * <zh/> 拖拽过程中触发
     *
     * <en/> Triggered when dragging
     */ CanvasEvent["DRAG"] = "canvas:drag";
    /**
     * <zh/> 拖拽结束时触发
     *
     * <en/> Triggered when dragging ends
     */ CanvasEvent["DRAG_END"] = "canvas:dragend";
    /**
     * <zh/> 拖拽进入时触发
     *
     * <en/> Triggered when dragging enters
     */ CanvasEvent["DRAG_ENTER"] = "canvas:dragenter";
    /**
     * <zh/> 拖拽经过时触发
     *
     * <en/> Triggered when dragging passes
     */ CanvasEvent["DRAG_OVER"] = "canvas:dragover";
    /**
     * <zh/> 拖拽离开时触发
     *
     * <en/> Triggered when dragging leaves
     */ CanvasEvent["DRAG_LEAVE"] = "canvas:dragleave";
    /**
     * <zh/> 拖拽放下时触发
     *
     * <en/> Triggered when dragging is dropped
     */ CanvasEvent["DROP"] = "canvas:drop";
    /**
     * <zh/> 滚动时触发
     *
     * <en/> Triggered when scrolling
     */ CanvasEvent["WHEEL"] = "canvas:wheel";
})($0f14a342d64c3d0e$export$70e68a7b98db5684 || ($0f14a342d64c3d0e$export$70e68a7b98db5684 = {}));

});

parcelRegister("jjMBX", function(module, exports) {

$parcel$export(module.exports, "ComboEvent", () => $e1057fd7767cf7c3$export$91c762e0ac9db1a4);
/**
 * <zh/> 组合事件
 *
 * <en/> Combo event
 */ var $e1057fd7767cf7c3$export$91c762e0ac9db1a4;
(function(ComboEvent) {
    /**
     * <zh/> 点击时触发
     *
     * <en/> Triggered when click
     */ ComboEvent["CLICK"] = "combo:click";
    /**
     * <zh/> 双击时触发
     *
     * <en/> Triggered when double click
     */ ComboEvent["DBLCLICK"] = "combo:dblclick";
    /**
     * <zh/> 指针移入时触发
     *
     * <en/> Triggered when the pointer enters
     */ ComboEvent["POINTER_OVER"] = "combo:pointerover";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ ComboEvent["POINTER_LEAVE"] = "combo:pointerleave";
    /**
     * <zh/> 指针移入时或移入子元素时触发（不会冒泡）
     *
     * <en/> Triggered when the pointer enters or enters a child element (does not bubble)
     */ ComboEvent["POINTER_ENTER"] = "combo:pointerenter";
    /**
     * <zh/> 指针移动时触发
     *
     * <en/> Triggered when the pointer moves
     */ ComboEvent["POINTER_MOVE"] = "combo:pointermove";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ ComboEvent["POINTER_OUT"] = "combo:pointerout";
    /**
     * <zh/> 指针按下时触发
     *
     * <en/> Triggered when the pointer is pressed
     */ ComboEvent["POINTER_DOWN"] = "combo:pointerdown";
    /**
     * <zh/> 指针抬起时触发
     *
     * <en/> Triggered when the pointer is lifted
     */ ComboEvent["POINTER_UP"] = "combo:pointerup";
    /**
     * <zh/> 打开上下文菜单时触发
     *
     * <en/> Triggered when the context menu is opened
     */ ComboEvent["CONTEXT_MENU"] = "combo:contextmenu";
    /**
     * <zh/> 开始拖拽时触发
     *
     * <en/> Triggered when dragging starts
     */ ComboEvent["DRAG_START"] = "combo:dragstart";
    /**
     * <zh/> 拖拽过程中触发
     *
     * <en/> Triggered when dragging
     */ ComboEvent["DRAG"] = "combo:drag";
    /**
     * <zh/> 拖拽结束时触发
     *
     * <en/> Triggered when dragging ends
     */ ComboEvent["DRAG_END"] = "combo:dragend";
    /**
     * <zh/> 拖拽进入时触发
     *
     * <en/> Triggered when dragging enters
     */ ComboEvent["DRAG_ENTER"] = "combo:dragenter";
    /**
     * <zh/> 拖拽经过时触发
     *
     * <en/> Triggered when dragging passes
     */ ComboEvent["DRAG_OVER"] = "combo:dragover";
    /**
     * <zh/> 拖拽离开时触发
     *
     * <en/> Triggered when dragging leaves
     */ ComboEvent["DRAG_LEAVE"] = "combo:dragleave";
    /**
     * <zh/> 拖拽放下时触发
     *
     * <en/> Triggered when dragging is dropped
     */ ComboEvent["DROP"] = "combo:drop";
})($e1057fd7767cf7c3$export$91c762e0ac9db1a4 || ($e1057fd7767cf7c3$export$91c762e0ac9db1a4 = {}));

});

parcelRegister("9Iel2", function(module, exports) {

$parcel$export(module.exports, "CommonEvent", () => $7123586c84b97532$export$8a0a711b962782a4);
var $7123586c84b97532$export$8a0a711b962782a4;
(function(CommonEvent) {
    /**
     * <zh/> 点击时触发
     *
     * <en/> Triggered when click
     */ CommonEvent["CLICK"] = "click";
    /**
     * <zh/> 双击时触发
     *
     * <en/> Triggered when double click
     */ CommonEvent["DBLCLICK"] = "dblclick";
    /**
     * <zh/> 指针移入时触发
     *
     * <en/> Triggered when the pointer enters
     */ CommonEvent["POINTER_OVER"] = "pointerover";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ CommonEvent["POINTER_LEAVE"] = "pointerleave";
    /**
     * <zh/> 指针移入时或移入子元素时触发（不会冒泡）
     *
     * <en/> Triggered when the pointer enters or enters a child element (does not bubble)
     */ CommonEvent["POINTER_ENTER"] = "pointerenter";
    /**
     * <zh/> 指针移动时触发
     *
     * <en/> Triggered when the pointer moves
     */ CommonEvent["POINTER_MOVE"] = "pointermove";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ CommonEvent["POINTER_OUT"] = "pointerout";
    /**
     * <zh/> 指针按下时触发
     *
     * <en/> Triggered when the pointer is pressed
     */ CommonEvent["POINTER_DOWN"] = "pointerdown";
    /**
     * <zh/> 指针抬起时触发
     *
     * <en/> Triggered when the pointer is lifted
     */ CommonEvent["POINTER_UP"] = "pointerup";
    /**
     * <zh/> 打开上下文菜单时触发
     *
     * <en/> Triggered when the context menu is opened
     */ CommonEvent["CONTEXT_MENU"] = "contextmenu";
    /**
     * <zh/> 开始拖拽时触发
     *
     * <en/> Triggered when dragging starts
     */ CommonEvent["DRAG_START"] = "dragstart";
    /**
     * <zh/> 拖拽过程中触发
     *
     * <en/> Triggered when dragging
     */ CommonEvent["DRAG"] = "drag";
    /**
     * <zh/> 拖拽结束时触发
     *
     * <en/> Triggered when dragging ends
     */ CommonEvent["DRAG_END"] = "dragend";
    /**
     * <zh/> 拖拽进入时触发
     *
     * <en/> Triggered when dragging enters
     */ CommonEvent["DRAG_ENTER"] = "dragenter";
    /**
     * <zh/> 拖拽经过时触发
     *
     * <en/> Triggered when dragging passes
     */ CommonEvent["DRAG_OVER"] = "dragover";
    /**
     * <zh/> 拖拽离开时触发
     *
     * <en/> Triggered when dragging leaves
     */ CommonEvent["DRAG_LEAVE"] = "dragleave";
    /**
     * <zh/> 拖拽放下时触发
     *
     * <en/> Triggered when dragging is dropped
     */ CommonEvent["DROP"] = "drop";
    /**
     * <zh/> 按下键盘时触发
     *
     * <en/> Triggered when the keyboard is pressed
     */ CommonEvent["KEY_DOWN"] = "keydown";
    /**
     * <zh/> 抬起键盘时触发
     *
     * <en/> Triggered when the keyboard is lifted
     */ CommonEvent["KEY_UP"] = "keyup";
    /**
     * <zh/> 滚动时触发
     *
     * <en/> Triggered when scrolling
     */ CommonEvent["WHEEL"] = "wheel";
    /**
     * <zh/> 双指捏拢或张开时触发
     *
     * <en/> Triggered when pinch in and pinch out
     */ CommonEvent["PINCH"] = "pinch";
})($7123586c84b97532$export$8a0a711b962782a4 || ($7123586c84b97532$export$8a0a711b962782a4 = {}));

});

parcelRegister("je0UY", function(module, exports) {

$parcel$export(module.exports, "ContainerEvent", () => $dff0096934d91dcc$export$76478df2584d4a9a);
var $dff0096934d91dcc$export$76478df2584d4a9a;
(function(ContainerEvent) {
    /**
     * <zh/> 按下键盘时触发
     *
     * <en/> Triggered when the keyboard is pressed
     */ ContainerEvent["KEY_DOWN"] = "keydown";
    /**
     * <zh/> 抬起键盘时触发
     *
     * <en/> Triggered when the keyboard is lifted
     */ ContainerEvent["KEY_UP"] = "keyup";
})($dff0096934d91dcc$export$76478df2584d4a9a || ($dff0096934d91dcc$export$76478df2584d4a9a = {}));

});

parcelRegister("5vtWi", function(module, exports) {

$parcel$export(module.exports, "EdgeEvent", () => $4027124c13745eda$export$4ee39d47cbc2701);
/**
 * <zh/> 边事件
 *
 * <en/> Edge event
 */ var $4027124c13745eda$export$4ee39d47cbc2701;
(function(EdgeEvent) {
    /**
     * <zh/> 点击时触发
     *
     * <en/> Triggered when click
     */ EdgeEvent["CLICK"] = "edge:click";
    /**
     * <zh/> 双击时触发
     *
     * <en/> Triggered when double click
     */ EdgeEvent["DBLCLICK"] = "edge:dblclick";
    /**
     * <zh/> 指针移入时触发
     *
     * <en/> Triggered when the pointer enters
     */ EdgeEvent["POINTER_OVER"] = "edge:pointerover";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ EdgeEvent["POINTER_LEAVE"] = "edge:pointerleave";
    /**
     * <zh/> 指针移入时或移入子元素时触发（不会冒泡）
     *
     * <en/> Triggered when the pointer enters or enters a child element (does not bubble)
     */ EdgeEvent["POINTER_ENTER"] = "edge:pointerenter";
    /**
     * <zh/> 指针移动时触发
     *
     * <en/> Triggered when the pointer moves
     */ EdgeEvent["POINTER_MOVE"] = "edge:pointermove";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ EdgeEvent["POINTER_OUT"] = "edge:pointerout";
    /**
     * <zh/> 指针按下时触发
     *
     * <en/> Triggered when the pointer is pressed
     */ EdgeEvent["POINTER_DOWN"] = "edge:pointerdown";
    /**
     * <zh/> 指针抬起时触发
     *
     * <en/> Triggered when the pointer is lifted
     */ EdgeEvent["POINTER_UP"] = "edge:pointerup";
    /**
     * <zh/> 打开上下文菜单时触发
     *
     * <en/> Triggered when the context menu is opened
     */ EdgeEvent["CONTEXT_MENU"] = "edge:contextmenu";
    /**
     * <zh/> 拖拽进入时触发
     *
     * <en/> Triggered when dragging enters
     */ EdgeEvent["DRAG_ENTER"] = "edge:dragenter";
    /**
     * <zh/> 拖拽经过时触发
     *
     * <en/> Triggered when dragging passes
     */ EdgeEvent["DRAG_OVER"] = "edge:dragover";
    /**
     * <zh/> 拖拽离开时触发
     *
     * <en/> Triggered when dragging leaves
     */ EdgeEvent["DRAG_LEAVE"] = "edge:dragleave";
    /**
     * <zh/> 拖拽放下时触发
     *
     * <en/> Triggered when dragging is dropped
     */ EdgeEvent["DROP"] = "edge:drop";
})($4027124c13745eda$export$4ee39d47cbc2701 || ($4027124c13745eda$export$4ee39d47cbc2701 = {}));

});

parcelRegister("4EzN9", function(module, exports) {

$parcel$export(module.exports, "GraphEvent", () => $3636a95c4b5d61ef$export$976c31dcf8601566);
var $3636a95c4b5d61ef$export$976c31dcf8601566;
(function(GraphEvent) {
    /**
     * <zh/> 画布初始化之前
     *
     * <en/> Before the canvas is initialized
     */ GraphEvent["BEFORE_CANVAS_INIT"] = "beforecanvasinit";
    /**
     * <zh/> 画布初始化之后
     *
     * <en/> After the canvas is initialized
     */ GraphEvent["AFTER_CANVAS_INIT"] = "aftercanvasinit";
    /**
     * <zh/> 视口尺寸变更之前
     *
     * <en/> Before the viewport size changes
     */ GraphEvent["BEFORE_SIZE_CHANGE"] = "beforesizechange";
    /**
     * <zh/> 视口尺寸变更之后
     *
     * <en/> After the viewport size changes
     */ GraphEvent["AFTER_SIZE_CHANGE"] = "aftersizechange";
    /**
     * <zh/> 元素创建之前
     *
     * <en/> Before creating element
     */ GraphEvent["BEFORE_ELEMENT_CREATE"] = "beforeelementcreate";
    /**
     * <zh/> 元素创建之后
     *
     * <en/> After creating element
     */ GraphEvent["AFTER_ELEMENT_CREATE"] = "afterelementcreate";
    /**
     * <zh/> 元素更新之前
     *
     * <en/> Before updating element
     */ GraphEvent["BEFORE_ELEMENT_UPDATE"] = "beforeelementupdate";
    /**
     * <zh/> 元素更新之后
     *
     * <en/> After updating element
     */ GraphEvent["AFTER_ELEMENT_UPDATE"] = "afterelementupdate";
    /**
     * <zh/> 元素销毁之前
     *
     * <en/> Before destroying element
     */ GraphEvent["BEFORE_ELEMENT_DESTROY"] = "beforeelementdestroy";
    /**
     * <zh/> 元素销毁之后
     *
     * <en/> After destroying element
     */ GraphEvent["AFTER_ELEMENT_DESTROY"] = "afterelementdestroy";
    /**
     * <zh/> 元素平移之前
     *
     * <en/> Before element translation
     */ GraphEvent["BEFORE_ELEMENT_TRANSLATE"] = "beforeelementtranslate";
    /**
     * <zh/> 元素平移之后
     *
     * <en/> After element translation
     */ GraphEvent["AFTER_ELEMENT_TRANSLATE"] = "afterelementtranslate";
    /**
     * <zh/> 绘制开始之前
     *
     * <en/> Before drawing
     */ GraphEvent["BEFORE_DRAW"] = "beforedraw";
    /**
     * <zh/> 绘制结束之后
     *
     * <en/> After drawing
     */ GraphEvent["AFTER_DRAW"] = "afterdraw";
    /**
     * <zh/> 渲染开始之前
     *
     * <en/> Before rendering
     */ GraphEvent["BEFORE_RENDER"] = "beforerender";
    /**
     * <zh/> 渲染完成之后
     *
     * <en/> After rendering
     */ GraphEvent["AFTER_RENDER"] = "afterrender";
    /**
     * <zh/> 动画开始之前
     *
     * <en/> Before animation
     */ GraphEvent["BEFORE_ANIMATE"] = "beforeanimate";
    /**
     * <zh/> 动画结束之后
     *
     * <en/> After animation
     */ GraphEvent["AFTER_ANIMATE"] = "afteranimate";
    /**
     * <zh/> 布局开始之前
     *
     * <en/> Before layout
     */ GraphEvent["BEFORE_LAYOUT"] = "beforelayout";
    /**
     * <zh/> 布局结束之后
     *
     * <en/> After layout
     */ GraphEvent["AFTER_LAYOUT"] = "afterlayout";
    /**
     * <zh/> 布局过程之前，用于流水线布局过程获取当前执行的布局
     *
     * <en/> Before the layout process, used to get the current layout being executed in the pipeline layout process
     */ GraphEvent["BEFORE_STAGE_LAYOUT"] = "beforestagelayout";
    /**
     * <zh/> 布局过程之后，用于流水线布局过程获取当前执行的布局
     *
     * <en/> After the layout process, used to get the current layout being executed in the pipeline layout process
     */ GraphEvent["AFTER_STAGE_LAYOUT"] = "afterstagelayout";
    /**
     * <zh/> 可视区域变化之前
     *
     * <en/> Before the visible area changes
     */ GraphEvent["BEFORE_TRANSFORM"] = "beforetransform";
    /**
     * <zh/> 可视区域变化之后
     *
     * <en/> After the visible area changes
     */ GraphEvent["AFTER_TRANSFORM"] = "aftertransform";
    /**
     * <zh/> 批处理开始
     *
     * <en/> Batch processing starts
     */ GraphEvent["BATCH_START"] = "batchstart";
    /**
     * <zh/> 批处理结束
     *
     * <en/> Batch processing ends
     */ GraphEvent["BATCH_END"] = "batchend";
    /**
     * <zh/> 销毁开始之前
     *
     * <en/> Before destruction
     */ GraphEvent["BEFORE_DESTROY"] = "beforedestroy";
    /**
     * <zh/> 销毁结束之后
     *
     * <en/> After destruction
     */ GraphEvent["AFTER_DESTROY"] = "afterdestroy";
    /**
     * <zh/> 渲染器变更之前
     *
     * <en/> Before the renderer changes
     */ GraphEvent["BEFORE_RENDERER_CHANGE"] = "beforerendererchange";
    /**
     * <zh/> 渲染器变更之后
     *
     * <en/> After the renderer changes
     */ GraphEvent["AFTER_RENDERER_CHANGE"] = "afterrendererchange";
})($3636a95c4b5d61ef$export$976c31dcf8601566 || ($3636a95c4b5d61ef$export$976c31dcf8601566 = {}));

});

parcelRegister("5TVj3", function(module, exports) {

$parcel$export(module.exports, "HistoryEvent", () => $44be8aa3bc94058f$export$2100c56db33d1c27);
var $44be8aa3bc94058f$export$2100c56db33d1c27;
(function(HistoryEvent) {
    /**
     * <zh/> 当命令被撤销时
     *
     * <en/> When the command is undone
     */ HistoryEvent["UNDO"] = "undo";
    /**
     * <zh/> 当命令被重做时
     *
     * <en/> When the command is redone
     */ HistoryEvent["REDO"] = "redo";
    /**
     * <zh/> 当命令被取消时
     *
     * <en/> When the command is canceled
     */ HistoryEvent["CANCEL"] = "cancel";
    /**
     *  <zh/> 当命令被添加到队列时
     *
     *  <en/> When the command is added
     */ HistoryEvent["ADD"] = "add";
    /**
     * <zh/> 当历史队列被清空时
     *
     *  <en/> When the command queue is cleared
     */ HistoryEvent["CLEAR"] = "clear";
    /**
     * <zh/> 当历史队列发生变化时
     *
     * <en/> When the command queue changes
     */ HistoryEvent["CHANGE"] = "change";
})($44be8aa3bc94058f$export$2100c56db33d1c27 || ($44be8aa3bc94058f$export$2100c56db33d1c27 = {}));

});

parcelRegister("eO2am", function(module, exports) {

$parcel$export(module.exports, "NodeEvent", () => $ac776a52c78452c0$export$18562867409649d3);
/**
 * <zh/> 节点事件
 *
 * <en/> Node event
 */ var $ac776a52c78452c0$export$18562867409649d3;
(function(NodeEvent) {
    /**
     * <zh/> 点击时触发
     *
     * <en/> Triggered when click
     */ NodeEvent["CLICK"] = "node:click";
    /**
     * <zh/> 双击时触发
     *
     * <en/> Triggered when double click
     */ NodeEvent["DBLCLICK"] = "node:dblclick";
    /**
     * <zh/> 指针移入时触发
     *
     * <en/> Triggered when the pointer enters
     */ NodeEvent["POINTER_OVER"] = "node:pointerover";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ NodeEvent["POINTER_LEAVE"] = "node:pointerleave";
    /**
     * <zh/> 指针移入时或移入子元素时触发（不会冒泡）
     *
     * <en/> Triggered when the pointer enters or enters a child element (does not bubble)
     */ NodeEvent["POINTER_ENTER"] = "node:pointerenter";
    /**
     * <zh/> 指针移动时触发
     *
     * <en/> Triggered when the pointer moves
     */ NodeEvent["POINTER_MOVE"] = "node:pointermove";
    /**
     * <zh/> 指针移出时触发
     *
     * <en/> Triggered when the pointer leaves
     */ NodeEvent["POINTER_OUT"] = "node:pointerout";
    /**
     * <zh/> 指针按下时触发
     *
     * <en/> Triggered when the pointer is pressed
     */ NodeEvent["POINTER_DOWN"] = "node:pointerdown";
    /**
     * <zh/> 指针抬起时触发
     *
     * <en/> Triggered when the pointer is lifted
     */ NodeEvent["POINTER_UP"] = "node:pointerup";
    /**
     * <zh/> 打开上下文菜单时触发
     *
     * <en/> Triggered when the context menu is opened
     */ NodeEvent["CONTEXT_MENU"] = "node:contextmenu";
    /**
     * <zh/> 开始拖拽时触发
     *
     * <en/> Triggered when dragging starts
     */ NodeEvent["DRAG_START"] = "node:dragstart";
    /**
     * <zh/> 拖拽过程中触发
     *
     * <en/> Triggered when dragging
     */ NodeEvent["DRAG"] = "node:drag";
    /**
     * <zh/> 拖拽结束时触发
     *
     * <en/> Triggered when dragging ends
     */ NodeEvent["DRAG_END"] = "node:dragend";
    /**
     * <zh/> 拖拽进入时触发
     *
     * <en/> Triggered when dragging enters
     */ NodeEvent["DRAG_ENTER"] = "node:dragenter";
    /**
     * <zh/> 拖拽经过时触发
     *
     * <en/> Triggered when dragging passes
     */ NodeEvent["DRAG_OVER"] = "node:dragover";
    /**
     * <zh/> 拖拽离开时触发
     *
     * <en/> Triggered when dragging leaves
     */ NodeEvent["DRAG_LEAVE"] = "node:dragleave";
    /**
     * <zh/> 拖拽放下时触发
     *
     * <en/> Triggered when dragging is dropped
     */ NodeEvent["DROP"] = "node:drop";
})($ac776a52c78452c0$export$18562867409649d3 || ($ac776a52c78452c0$export$18562867409649d3 = {}));

});


parcelRegister("lDPR9", function(module, exports) {

$parcel$export(module.exports, "COMBO_KEY", () => $fc157711ee2a2a23$export$d55510fba35820e0);
$parcel$export(module.exports, "TREE_KEY", () => $fc157711ee2a2a23$export$ab7ca16585b31908);
const $fc157711ee2a2a23$export$d55510fba35820e0 = 'combo';
const $fc157711ee2a2a23$export$ab7ca16585b31908 = 'tree';

});

parcelRegister("jRLln", function(module, exports) {

$parcel$export(module.exports, "ExtensionCategory", () => $e767b10a9e6b4524$export$7661e78edb2d90ae);
var $e767b10a9e6b4524$export$7661e78edb2d90ae;
(function(ExtensionCategory) {
    /**
     * <zh/> 节点元素
     *
     * <en/> Node element
     */ ExtensionCategory["NODE"] = "node";
    /**
     * <zh/> 边元素
     *
     * <en/> Edge element
     */ ExtensionCategory["EDGE"] = "edge";
    /**
     * <zh/> 组合元素
     *
     * <en/> Combination element
     */ ExtensionCategory["COMBO"] = "combo";
    /**
     * <zh/> 主题
     *
     * <en/> Theme
     */ ExtensionCategory["THEME"] = "theme";
    /**
     * <zh/> 色板
     *
     * <en/> Palette
     */ ExtensionCategory["PALETTE"] = "palette";
    /**
     * <zh/> 布局
     *
     * <en/> Layout
     */ ExtensionCategory["LAYOUT"] = "layout";
    /**
     * <zh/> 交互
     *
     * <en/> Behavior
     */ ExtensionCategory["BEHAVIOR"] = "behavior";
    /**
     * <zh/> 插件
     *
     * <en/> Plugin
     */ ExtensionCategory["PLUGIN"] = "plugin";
    /**
     * <zh/> 动画
     *
     * <en/> Animation
     */ ExtensionCategory["ANIMATION"] = "animation";
    /**
     * <zh/> 数据转换
     *
     * <en/> Data transform
     */ ExtensionCategory["TRANSFORM"] = "transform";
    /**
     * <zh/> 图形
     *
     * <en/> Shape
     */ ExtensionCategory["SHAPE"] = "shape";
})($e767b10a9e6b4524$export$7661e78edb2d90ae || ($e767b10a9e6b4524$export$7661e78edb2d90ae = {}));

});


parcelRegister("hW6vf", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d0ece5cff0a5b83e$export$78d71f9ed5534abe);

var $e3xJb = parcelRequire("e3xJb");
function $d0ece5cff0a5b83e$export$78d71f9ed5534abe(category, type) {
    var _a;
    const extension = (_a = (0, $e3xJb.EXTENSION_REGISTRY)[category]) === null || _a === void 0 ? void 0 : _a[type];
    if (extension) return extension;
    return undefined;
}
function $d0ece5cff0a5b83e$export$7c6ea4184129ef74(category) {
    return (0, $e3xJb.EXTENSION_REGISTRY)[category];
}

});
parcelRegister("e3xJb", function(module, exports) {

$parcel$export(module.exports, "EXTENSION_REGISTRY", () => $a3bb8228674a1970$export$d4ef7ef6391b89e);
/**
 * <zh/> 扩展注册表
 *
 * <en/> Extension registry
 */ const $a3bb8228674a1970$export$d4ef7ef6391b89e = {
    animation: {},
    behavior: {},
    combo: {},
    edge: {},
    layout: {},
    node: {},
    palette: {},
    theme: {},
    plugin: {},
    transform: {},
    shape: {}
};

});


parcelRegister("aBpmX", function(module, exports) {

$parcel$export(module.exports, "format", () => $7b8109e9acd348a2$export$d9468344d3651243);
$parcel$export(module.exports, "print", () => $7b8109e9acd348a2$export$c2d084dc44961371);
/* global console */ /* eslint no-console: "off" */ 
var $j2xPB = parcelRequire("j2xPB");
const $7b8109e9acd348a2$var$BRAND = 'G6';
function $7b8109e9acd348a2$export$d9468344d3651243(message) {
    return `[${$7b8109e9acd348a2$var$BRAND} v${0, $j2xPB.version}] ${message}`;
}
const $7b8109e9acd348a2$export$c2d084dc44961371 = {
    mute: false,
    debug: (message)=>{
        !$7b8109e9acd348a2$export$c2d084dc44961371.mute && console.debug($7b8109e9acd348a2$export$d9468344d3651243(message));
    },
    info: (message)=>{
        !$7b8109e9acd348a2$export$c2d084dc44961371.mute && console.info($7b8109e9acd348a2$export$d9468344d3651243(message));
    },
    warn: (message)=>{
        !$7b8109e9acd348a2$export$c2d084dc44961371.mute && console.warn($7b8109e9acd348a2$export$d9468344d3651243(message));
    },
    error: (message)=>{
        !$7b8109e9acd348a2$export$c2d084dc44961371.mute && console.error($7b8109e9acd348a2$export$d9468344d3651243(message));
    }
};

});
parcelRegister("j2xPB", function(module, exports) {

$parcel$export(module.exports, "version", () => $ddc8726885669d9a$export$83d89fbfd8236492);
const $ddc8726885669d9a$export$83d89fbfd8236492 = '5.0.51';

});


parcelRegister("3SjwL", function(module, exports) {

$parcel$export(module.exports, "themeOf", () => $2d258ff6b6c0830f$export$bfd873fef8b66623);
parcelRequire("ahJ7k");
var $jRLln = parcelRequire("jRLln");

var $hW6vf = parcelRequire("hW6vf");

var $aBpmX = parcelRequire("aBpmX");
function $2d258ff6b6c0830f$export$bfd873fef8b66623(options) {
    const { theme: theme } = options;
    if (!theme) return {};
    const themeOptions = (0, $hW6vf.getExtension)((0, $jRLln.ExtensionCategory).THEME, theme);
    if (themeOptions) return themeOptions;
    (0, $aBpmX.print).warn(`The theme of ${theme} is not registered.`);
    return {};
}

});


parcelRegister("aPhuQ", function(module, exports) {

$parcel$export(module.exports, "replaceTranslateInTransform", () => $7e1c3d42aa97d05c$export$885ba1abfbffab5d);

var $jyI49 = parcelRequire("jyI49");
function $7e1c3d42aa97d05c$export$885ba1abfbffab5d(x, y, z, transform = []) {
    if (!transform && x === 0 && y === 0 && z === 0) return null;
    if (Array.isArray(transform)) {
        let translateIndex = -1;
        const newTransform = [];
        for(let i = 0; i < transform.length; i++){
            const t = transform[i];
            if (t[0] === 'translate') {
                if (t[1] === x && t[2] === y) return null;
                translateIndex = i;
                newTransform.push([
                    'translate',
                    x,
                    y
                ]);
            } else if (t[0] === 'translate3d') {
                if (t[1] === x && t[2] === y && t[3] === z) return null;
                translateIndex = i;
                newTransform.push([
                    'translate3d',
                    x,
                    y,
                    z !== null && z !== void 0 ? z : 0
                ]);
            } else newTransform.push(t);
        }
        if (translateIndex === -1) newTransform.splice(0, 0, (0, $jyI49.default)(z) ? [
            'translate3d',
            x,
            y,
            z !== null && z !== void 0 ? z : 0
        ] : [
            'translate',
            x,
            y
        ]);
        if (newTransform.length === 0) return null;
        return newTransform;
    }
    const removedTranslate = transform ? transform.replace(/translate(3d)?\([^)]*\)/g, '') : '';
    if (z === 0) return `translate(${x}, ${y})${removedTranslate}`;
    else return `translate3d(${x}, ${y}, ${z})${removedTranslate}`;
}

});



parcelRegister("kVOIy", function(module, exports) {

$parcel$export(module.exports, "AutoAdaptLabel", () => (parcelRequire("cAn0T")).AutoAdaptLabel);
$parcel$export(module.exports, "BrushSelect", () => (parcelRequire("8FmDy")).BrushSelect);
$parcel$export(module.exports, "ClickSelect", () => (parcelRequire("hgdlM")).ClickSelect);
$parcel$export(module.exports, "CollapseExpand", () => (parcelRequire("0y4XY")).CollapseExpand);
$parcel$export(module.exports, "CreateEdge", () => (parcelRequire("h3bBs")).CreateEdge);
$parcel$export(module.exports, "DragCanvas", () => (parcelRequire("1hotb")).DragCanvas);
$parcel$export(module.exports, "DragElement", () => (parcelRequire("hDdHF")).DragElement);
$parcel$export(module.exports, "DragElementForce", () => (parcelRequire("g3gkU")).DragElementForce);
$parcel$export(module.exports, "FixElementSize", () => (parcelRequire("apMdk")).FixElementSize);
$parcel$export(module.exports, "FocusElement", () => (parcelRequire("hDdip")).FocusElement);
$parcel$export(module.exports, "HoverActivate", () => (parcelRequire("5DaKb")).HoverActivate);
$parcel$export(module.exports, "LassoSelect", () => (parcelRequire("8yr5d")).LassoSelect);
$parcel$export(module.exports, "OptimizeViewportTransform", () => (parcelRequire("bC6xM")).OptimizeViewportTransform);
$parcel$export(module.exports, "ScrollCanvas", () => (parcelRequire("62Rza")).ScrollCanvas);
$parcel$export(module.exports, "ZoomCanvas", () => (parcelRequire("02HiP")).ZoomCanvas);

var $cAn0T = parcelRequire("cAn0T");

var $hQIOr = parcelRequire("hQIOr");

var $8FmDy = parcelRequire("8FmDy");

var $hgdlM = parcelRequire("hgdlM");

var $0y4XY = parcelRequire("0y4XY");

var $h3bBs = parcelRequire("h3bBs");

var $1hotb = parcelRequire("1hotb");

var $hDdHF = parcelRequire("hDdHF");

var $g3gkU = parcelRequire("g3gkU");

var $apMdk = parcelRequire("apMdk");

var $hDdip = parcelRequire("hDdip");

var $5DaKb = parcelRequire("5DaKb");

var $8yr5d = parcelRequire("8yr5d");

var $bC6xM = parcelRequire("bC6xM");

var $62Rza = parcelRequire("62Rza");

var $02HiP = parcelRequire("02HiP");

});
parcelRegister("cAn0T", function(module, exports) {

$parcel$export(module.exports, "AutoAdaptLabel", () => $929ab2ce5c52657d$export$3a880cd3b08bf2bf);

var $gYaPK = parcelRequire("gYaPK");
var $ky7aH = parcelRequire("ky7aH");
var $12lyH = parcelRequire("12lyH");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $6BVcW = parcelRequire("6BVcW");

var $eASF9 = parcelRequire("eASF9");

var $6SQtU = parcelRequire("6SQtU");

var $kzdag = parcelRequire("kzdag");

var $hQIOr = parcelRequire("hQIOr");
class $929ab2ce5c52657d$export$3a880cd3b08bf2bf extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $929ab2ce5c52657d$export$3a880cd3b08bf2bf.defaultOptions, options));
        /**
         * <zh/> 检查当前包围盒是否有足够的空间进行展示；如果与已经展示的包围盒有重叠，则不会展示
         *
         * <en/> Check whether the current bounding box has enough space to display; if it overlaps with the displayed bounding box, it will not be displayed
         * @param bbox - bbox
         * @param bboxes - occupied bboxes which are already shown
         * @returns whether the bbox is overlapping with the bboxes or outside the viewpointBounds
         */ this.isOverlapping = (bbox, bboxes)=>{
            return bboxes.some((b)=>bbox.intersects(b));
        };
        this.occupiedBounds = [];
        this.detectLabelCollision = (elements)=>{
            const viewport = this.context.viewport;
            const res = {
                show: [],
                hide: []
            };
            this.occupiedBounds = [];
            elements.forEach((element)=>{
                const labelBounds = element.getShape('label').getRenderBounds();
                if (viewport.isInViewport(labelBounds, true) && !this.isOverlapping(labelBounds, this.occupiedBounds)) {
                    res.show.push(element);
                    this.occupiedBounds.push((0, $6BVcW.getExpandedBBox)(labelBounds, this.options.padding));
                } else res.hide.push(element);
            });
            return res;
        };
        this.hideLabelIfExceedViewport = (prevElementsInView, currentElementsInView)=>{
            const { exit: exit } = (0, $6SQtU.arrayDiff)(prevElementsInView, currentElementsInView, (d)=>d.id);
            exit === null || exit === void 0 || exit.forEach(this.hideLabel);
        };
        this.nodeCentralities = new Map();
        this.sortNodesByCentrality = (nodes, centrality)=>{
            const { model: model } = this.context;
            const graphData = model.getData();
            const getRelatedEdgesData = model.getRelatedEdgesData.bind(model);
            const nodesWithCentrality = nodes.map((node)=>{
                if (!this.nodeCentralities.has(node.id)) this.nodeCentralities = (0, $eASF9.getNodeCentralities)(graphData, getRelatedEdgesData, centrality);
                return {
                    node: node,
                    centrality: this.nodeCentralities.get(node.id)
                };
            });
            return nodesWithCentrality.sort((a, b)=>b.centrality - a.centrality).map((item)=>item.node);
        };
        this.sortLabelElementsInView = (labelElements)=>{
            const { sort: sort, sortNode: sortNode, sortCombo: sortCombo, sortEdge: sortEdge } = this.options;
            const { model: model } = this.context;
            if ((0, $ky7aH.default)(sort)) return labelElements.sort((a, b)=>sort(model.getElementDataById(a.id), model.getElementDataById(b.id)));
            const { node: nodes = [], edge: edges = [], combo: combos = [] } = (0, $gYaPK.default)(labelElements, (el)=>el.type);
            const sortedCombos = (0, $ky7aH.default)(sortCombo) ? combos.sort((a, b)=>sortCombo(...model.getComboData([
                    a.id,
                    b.id
                ]))) : combos;
            const sortedNodes = (0, $ky7aH.default)(sortNode) ? nodes.sort((a, b)=>sortNode(...model.getNodeData([
                    a.id,
                    b.id
                ]))) : this.sortNodesByCentrality(nodes, sortNode);
            const sortedEdges = (0, $ky7aH.default)(sortEdge) ? edges.sort((a, b)=>sortEdge(...model.getEdgeData([
                    a.id,
                    b.id
                ]))) : edges;
            return [
                ...sortedCombos,
                ...sortedNodes,
                ...sortedEdges
            ];
        };
        this.labelElementsInView = [];
        this.isFirstRender = true;
        this.onToggleVisibility = (event)=>{
            var _a;
            // @ts-expect-error missing type
            if (((_a = event.data) === null || _a === void 0 ? void 0 : _a.stage) === 'zIndex') return;
            if (!this.validate(event)) {
                if (this.hiddenElements.size > 0) {
                    this.hiddenElements.forEach(this.showLabel);
                    this.hiddenElements.clear();
                }
                return;
            }
            const labelElementsInView = this.isFirstRender ? this.getLabelElements() : this.getLabelElementsInView();
            this.hideLabelIfExceedViewport(this.labelElementsInView, labelElementsInView);
            this.labelElementsInView = labelElementsInView;
            // 根据元素的重要性从高到低排序，重要性越高的元素其标签显示优先级越高；通常 combo > node > edge
            // Sort elements by their importance in descending order; elements with higher importance have higher label display priority; usually combo > node > edge
            const sortedElements = this.sortLabelElementsInView(this.labelElementsInView);
            const { show: show, hide: hide } = this.detectLabelCollision(sortedElements);
            for(let i = show.length - 1; i >= 0; i--)this.showLabel(show[i]);
            hide.forEach(this.hideLabel);
        };
        this.hiddenElements = new Map();
        this.hideLabel = (element)=>{
            const label = element.getShape('label');
            if (label) (0, $kzdag.setVisibility)(label, 'hidden');
            this.hiddenElements.set(element.id, element);
        };
        this.showLabel = (element)=>{
            const label = element.getShape('label');
            if (label) (0, $kzdag.setVisibility)(label, 'visible');
            element.toFront();
            this.hiddenElements.delete(element.id);
        };
        this.onTransform = (0, $12lyH.default)(this.onToggleVisibility, this.options.throttle, {
            leading: true
        });
        this.enableToggle = true;
        this.toggle = (event)=>{
            if (!this.enableToggle) return;
            this.onToggleVisibility(event);
        };
        this.onBeforeRender = ()=>{
            this.enableToggle = false;
        };
        this.onAfterRender = (event)=>{
            this.onToggleVisibility(event);
            this.enableToggle = true;
        };
        this.bindEvents();
    }
    update(options) {
        this.unbindEvents();
        super.update(options);
        this.bindEvents();
        this.onToggleVisibility({});
    }
    getLabelElements() {
        // @ts-expect-error access private property
        const { elementMap: elementMap } = this.context.element;
        const elements = [];
        for(const key in elementMap){
            const element = elementMap[key];
            if (element.isVisible() && element.getShape('label')) elements.push(element);
        }
        return elements;
    }
    getLabelElementsInView() {
        const viewport = this.context.viewport;
        return this.getLabelElements().filter((node)=>viewport.isInViewport(node.getShape('key').getRenderBounds()));
    }
    bindEvents() {
        const { graph: graph } = this.context;
        graph.on((0, $4EzN9.GraphEvent).BEFORE_RENDER, this.onBeforeRender);
        graph.on((0, $4EzN9.GraphEvent).AFTER_RENDER, this.onAfterRender);
        graph.on((0, $4EzN9.GraphEvent).AFTER_DRAW, this.toggle);
        graph.on((0, $4EzN9.GraphEvent).AFTER_LAYOUT, this.toggle);
        graph.on((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.onTransform);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        graph.off((0, $4EzN9.GraphEvent).BEFORE_RENDER, this.onBeforeRender);
        graph.off((0, $4EzN9.GraphEvent).AFTER_RENDER, this.onAfterRender);
        graph.off((0, $4EzN9.GraphEvent).AFTER_DRAW, this.toggle);
        graph.off((0, $4EzN9.GraphEvent).AFTER_LAYOUT, this.toggle);
        graph.off((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.onTransform);
    }
    validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
$929ab2ce5c52657d$export$3a880cd3b08bf2bf.defaultOptions = {
    enable: true,
    throttle: 100,
    padding: 0,
    sortNode: {
        type: 'degree'
    }
};

});
parcelRegister("gYaPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5aaa7445f7ac583$export$2e2bcd8739ae039);

var $1uF5a = parcelRequire("1uF5a");

var $ky7aH = parcelRequire("ky7aH");
var $c5aaa7445f7ac583$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c5aaa7445f7ac583$var$groupBy(data, condition) {
    if (!condition || !(0, $1uF5a.default)(data)) return {};
    var result = {};
    // 兼容方法和 字符串的写法
    var predicate = (0, $ky7aH.default)(condition) ? condition : function(item) {
        return item[condition];
    };
    var key;
    for(var i = 0; i < data.length; i++){
        var item = data[i];
        key = predicate(item);
        if ($c5aaa7445f7ac583$var$hasOwnProperty.call(result, key)) result[key].push(item);
        else result[key] = [
            item
        ];
    }
    return result;
}
var $c5aaa7445f7ac583$export$2e2bcd8739ae039 = $c5aaa7445f7ac583$var$groupBy;

});

parcelRegister("12lyH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c16b3748f8173f0$export$2e2bcd8739ae039);
var $0c16b3748f8173f0$export$2e2bcd8739ae039 = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
};

});

parcelRegister("6BVcW", function(module, exports) {

$parcel$export(module.exports, "getBBoxWidth", () => $4d0293085caa847e$export$d48506e5c23fa400);
$parcel$export(module.exports, "getBBoxHeight", () => $4d0293085caa847e$export$a20939d85d370f45);
$parcel$export(module.exports, "getBBoxSize", () => $4d0293085caa847e$export$c4987fce87d1da81);
$parcel$export(module.exports, "getNodeBBox", () => $4d0293085caa847e$export$8bfb4bef09d9faee);
$parcel$export(module.exports, "getPointBBox", () => $4d0293085caa847e$export$4af30dc50b4cc3ac);
$parcel$export(module.exports, "getExpandedBBox", () => $4d0293085caa847e$export$eb62df41a0b1c31e);
$parcel$export(module.exports, "getCombinedBBox", () => $4d0293085caa847e$export$88981988341798af);
$parcel$export(module.exports, "isBBoxInside", () => $4d0293085caa847e$export$83ad7016b1286882);
$parcel$export(module.exports, "isPointInBBox", () => $4d0293085caa847e$export$a0217f79c18ee512);
$parcel$export(module.exports, "isPointOnBBoxBoundary", () => $4d0293085caa847e$export$cbade8500b7a18f);
$parcel$export(module.exports, "isPointOutsideBBox", () => $4d0293085caa847e$export$5325fb19984c8863);
$parcel$export(module.exports, "isPointBBoxCenter", () => $4d0293085caa847e$export$2c5b1cdd7dee81e8);
$parcel$export(module.exports, "getNearestBoundarySide", () => $4d0293085caa847e$export$a03746eb4b0d146f);
$parcel$export(module.exports, "getNearestBoundaryPoint", () => $4d0293085caa847e$export$5980ef0d626e83cc);
$parcel$export(module.exports, "getTriangleCenter", () => $4d0293085caa847e$export$1974cc5bdb2842dd);
$parcel$export(module.exports, "getIncircleRadius", () => $4d0293085caa847e$export$6995f4f6a74034b2);
$parcel$export(module.exports, "getBBoxSegments", () => $4d0293085caa847e$export$23bf168b6be7633c);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $iGRaJ = parcelRequire("iGRaJ");

var $lEe0S = parcelRequire("lEe0S");

var $2Rqcx = parcelRequire("2Rqcx");

var $1uR12 = parcelRequire("1uR12");
function $4d0293085caa847e$export$d48506e5c23fa400(bbox) {
    return bbox.max[0] - bbox.min[0];
}
function $4d0293085caa847e$export$a20939d85d370f45(bbox) {
    return bbox.max[1] - bbox.min[1];
}
function $4d0293085caa847e$export$c4987fce87d1da81(bbox) {
    return [
        $4d0293085caa847e$export$d48506e5c23fa400(bbox),
        $4d0293085caa847e$export$a20939d85d370f45(bbox)
    ];
}
function $4d0293085caa847e$export$8bfb4bef09d9faee(node, padding) {
    const bbox = (0, $lEe0S.isPoint)(node) ? $4d0293085caa847e$export$4af30dc50b4cc3ac(node) : node.getShape('key').getBounds();
    return padding ? $4d0293085caa847e$export$eb62df41a0b1c31e(bbox, padding) : bbox;
}
function $4d0293085caa847e$export$4af30dc50b4cc3ac(point) {
    const [x, y, z = 0] = point;
    const bbox = new (0, $2eDEB.AABB)();
    bbox.setMinMax([
        x,
        y,
        z
    ], [
        x,
        y,
        z
    ]);
    return bbox;
}
function $4d0293085caa847e$export$eb62df41a0b1c31e(bbox, padding) {
    const [top, right, bottom, left] = (0, $1uR12.parsePadding)(padding);
    const [minX, minY, minZ] = bbox.min;
    const [maxX, maxY, maxZ] = bbox.max;
    const eBbox = new (0, $2eDEB.AABB)();
    eBbox.setMinMax([
        minX - left,
        minY - top,
        minZ
    ], [
        maxX + right,
        maxY + bottom,
        maxZ
    ]);
    return eBbox;
}
function $4d0293085caa847e$export$88981988341798af(bboxes) {
    if (bboxes.length === 0) return new (0, $2eDEB.AABB)();
    if (bboxes.length === 1) return bboxes[0];
    const bbox = new (0, $2eDEB.AABB)();
    bbox.setMinMax(bboxes[0].min, bboxes[0].max);
    for(let i = 1; i < bboxes.length; i++){
        const b2 = bboxes[i];
        bbox.setMinMax([
            Math.min(bbox.min[0], b2.min[0]),
            Math.min(bbox.min[1], b2.min[1]),
            Math.min(bbox.min[2], b2.min[2])
        ], [
            Math.max(bbox.max[0], b2.max[0]),
            Math.max(bbox.max[1], b2.max[1]),
            Math.max(bbox.max[2], b2.max[2])
        ]);
    }
    return bbox;
}
function $4d0293085caa847e$export$83ad7016b1286882(bbox1, bbox2) {
    const [minX1, minY1] = bbox1.min;
    const [maxX1, maxY1] = bbox1.max;
    const [minX2, minY2] = bbox2.min;
    const [maxX2, maxY2] = bbox2.max;
    return minX1 >= minX2 && maxX1 <= maxX2 && minY1 >= minY2 && maxY1 <= maxY2;
}
function $4d0293085caa847e$export$a0217f79c18ee512(point, bbox) {
    return (0, $2Rqcx.isBetween)(point[0], bbox.min[0], bbox.max[0]) && (0, $2Rqcx.isBetween)(point[1], bbox.min[1], bbox.max[1]);
}
function $4d0293085caa847e$export$cbade8500b7a18f(point, bbox, extended = false) {
    const { min: [minX, minY], max: [maxX, maxY] } = bbox;
    const onTopOrBottomLine = (point[1] === minY || point[1] === maxY) && (extended || (0, $2Rqcx.isBetween)(point[0], minX, maxX));
    const onLeftOrRightLine = (point[0] === minX || point[0] === maxX) && (extended || (0, $2Rqcx.isBetween)(point[1], minY, maxY));
    return onTopOrBottomLine || onLeftOrRightLine;
}
function $4d0293085caa847e$export$5325fb19984c8863(point, bbox) {
    return !$4d0293085caa847e$export$a0217f79c18ee512(point, bbox);
}
function $4d0293085caa847e$export$2c5b1cdd7dee81e8(point, bbox) {
    const { center: center } = bbox;
    return point[0] === center[0] && point[1] === center[1];
}
function $4d0293085caa847e$export$a03746eb4b0d146f(p, bbox) {
    const [x, y] = p;
    const [minX, minY] = bbox.min;
    const [maxX, maxY] = bbox.max;
    const left = x - minX;
    const right = maxX - x;
    const top = y - minY;
    const bottom = maxY - y;
    const min = Math.min(left, right, top, bottom);
    return min === left ? 'left' : min === right ? 'right' : min === top ? 'top' : min === bottom ? 'bottom' : 'left';
}
function $4d0293085caa847e$export$5980ef0d626e83cc(p, bbox) {
    const ref = (0, $iGRaJ.default)(p);
    if ($4d0293085caa847e$export$a0217f79c18ee512(p, bbox)) {
        const side = $4d0293085caa847e$export$a03746eb4b0d146f(p, bbox);
        switch(side){
            case 'left':
                ref[0] = bbox.min[0];
                break;
            case 'right':
                ref[0] = bbox.max[0];
                break;
            case 'top':
                ref[1] = bbox.min[1];
                break;
            case 'bottom':
                ref[1] = bbox.max[1];
                break;
        }
    } else {
        const [x, y] = p;
        const [minX, minY] = bbox.min;
        const [maxX, maxY] = bbox.max;
        ref[0] = (0, $2Rqcx.isBetween)(x, minX, maxX) ? x : x < minX ? minX : maxX;
        ref[1] = (0, $2Rqcx.isBetween)(y, minY, maxY) ? y : y < minY ? minY : maxY;
    }
    return ref;
}
function $4d0293085caa847e$export$1974cc5bdb2842dd(bbox, direction) {
    // todo 算法只对矩形有效
    const { center: center } = bbox;
    const [width, height] = $4d0293085caa847e$export$c4987fce87d1da81(bbox);
    const x = direction === 'up' || direction === 'down' ? center[0] : direction === 'right' ? center[0] - width / 6 : center[0] + width / 6;
    const y = direction === 'left' || direction === 'right' ? center[1] : direction === 'down' ? center[1] - height / 6 : center[1] + height / 6;
    return [
        x,
        y
    ];
}
function $4d0293085caa847e$export$6995f4f6a74034b2(bbox, direction) {
    let [w, h] = $4d0293085caa847e$export$c4987fce87d1da81(bbox);
    [w, h] = direction === 'up' || direction === 'down' ? [
        w,
        h
    ] : [
        h,
        w
    ];
    // 三角形的内切圆半径
    return (Math.pow(h, 2) - Math.pow(Math.sqrt(Math.pow(w / 2, 2) + Math.pow(h, 2)) - w / 2, 2)) / (2 * h);
}
function $4d0293085caa847e$export$23bf168b6be7633c(bbox) {
    const { min: [minX, minY], max: [maxX, maxY] } = bbox;
    const topLeftCorner = [
        minX,
        maxY
    ];
    const topRightCorner = [
        maxX,
        maxY
    ];
    const bottomRightCorner = [
        maxX,
        minY
    ];
    const bottomLeftCorner = [
        minX,
        minY
    ];
    const top = [
        topLeftCorner,
        topRightCorner
    ];
    const right = [
        topRightCorner,
        bottomRightCorner
    ];
    const bottom = [
        bottomRightCorner,
        bottomLeftCorner
    ];
    const left = [
        bottomLeftCorner,
        topLeftCorner
    ];
    return [
        top,
        right,
        bottom,
        left
    ];
}

});
parcelRegister("iGRaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9b5651fe42b152f$export$2e2bcd8739ae039);

var $1uF5a = parcelRequire("1uF5a");
var $d9b5651fe42b152f$var$clone = function(obj) {
    if (typeof obj !== 'object' || obj === null) return obj;
    var rst;
    if ((0, $1uF5a.default)(obj)) {
        rst = [];
        for(var i = 0, l = obj.length; i < l; i++)if (typeof obj[i] === 'object' && obj[i] != null) rst[i] = $d9b5651fe42b152f$var$clone(obj[i]);
        else rst[i] = obj[i];
    } else {
        rst = {};
        for(var k in obj)if (typeof obj[k] === 'object' && obj[k] != null) rst[k] = $d9b5651fe42b152f$var$clone(obj[k]);
        else rst[k] = obj[k];
    }
    return rst;
};
var $d9b5651fe42b152f$export$2e2bcd8739ae039 = $d9b5651fe42b152f$var$clone;

});

parcelRegister("lEe0S", function(module, exports) {

$parcel$export(module.exports, "isEdgeData", () => $fc28341981794b74$export$683886479b00ec9e);
$parcel$export(module.exports, "isVector2", () => $fc28341981794b74$export$ac9877f61706ddbc);
$parcel$export(module.exports, "isPoint", () => $fc28341981794b74$export$aff838a5553f2a92);
/**
 * <zh/> 判断是否为边数据
 *
 * <en/> judge whether the data is edge data
 * @param data - <zh/> 元素数据 | <en/> element data
 * @returns - <zh/> 是否为边数据 | <en/> whether the data is edge data
 */ function $fc28341981794b74$export$683886479b00ec9e(data) {
    if ('source' in data && 'target' in data) return true;
    return false;
}
function $fc28341981794b74$export$ac9877f61706ddbc(vector) {
    return vector.length === 2;
}
function $fc28341981794b74$export$70837c2d285b5b28(vector) {
    return vector.length === 3;
}
function $fc28341981794b74$export$aff838a5553f2a92(p) {
    if (p instanceof Float32Array) return true;
    if (Array.isArray(p) && (p.length === 2 || p.length === 3)) return p.every((elem)=>typeof elem === 'number');
    return false;
}

});

parcelRegister("2Rqcx", function(module, exports) {

$parcel$export(module.exports, "isBetween", () => $2154db00a7ad6e1d$export$a4d69fb5f2026c35);
/**
 * <zh/> 判断值是否在区间内
 *
 * <en/> Judge whether the value is in the interval
 * @param value - <zh/> 值 | <en/> value
 * @param min - <zh/> 最小值 | <en/> minimum value
 * @param max - <zh/> 最大值 | <en/> maximum value
 * @returns <zh/> 是否在区间内 | <en/> whether in the interval
 */ function $2154db00a7ad6e1d$export$a4d69fb5f2026c35(value, min, max) {
    return value >= min && value <= max;
}

});

parcelRegister("1uR12", function(module, exports) {

$parcel$export(module.exports, "parsePadding", () => $1171b798fe859ac8$export$4bc3c325941e6f67);
$parcel$export(module.exports, "getVerticalPadding", () => $1171b798fe859ac8$export$f4e78575dab7e370);
/**
 * <zh/> 解析 padding
 *
 * <en/> parse padding
 * @param padding - <zh/> padding | <en/> padding
 * @returns <zh/> 标准 padding | <en/> standard padding
 */ function $1171b798fe859ac8$export$4bc3c325941e6f67(padding = 0) {
    if (Array.isArray(padding)) {
        const [top = 0, right = top, bottom = top, left = right] = padding;
        return [
            top,
            right,
            bottom,
            left
        ];
    }
    return [
        padding,
        padding,
        padding,
        padding
    ];
}
function $1171b798fe859ac8$export$f4e78575dab7e370(padding = 0) {
    const parsedPadding = $1171b798fe859ac8$export$4bc3c325941e6f67(padding);
    return parsedPadding[0] + parsedPadding[2];
}
function $1171b798fe859ac8$export$78a4f7e3e091a7d5(padding = 0) {
    const parsedPadding = $1171b798fe859ac8$export$4bc3c325941e6f67(padding);
    return parsedPadding[1] + parsedPadding[3];
}

});


parcelRegister("eASF9", function(module, exports) {

$parcel$export(module.exports, "getNodeCentralities", () => $a9fed459af8a0145$export$9015489356192cd4);
parcelRequire("dfdyY");
var $9YFSY = parcelRequire("9YFSY");
var $avAF8 = parcelRequire("avAF8");

var $brtTw = parcelRequire("brtTw");
const $a9fed459af8a0145$export$9015489356192cd4 = (graphData, getRelatedEdgesData, centrality)=>{
    var _a;
    switch(centrality.type){
        case 'degree':
            {
                const centralityResult = new Map();
                (_a = graphData.nodes) === null || _a === void 0 || _a.forEach((node)=>{
                    const degree = getRelatedEdgesData((0, $brtTw.idOf)(node), centrality.direction).length;
                    centralityResult.set((0, $brtTw.idOf)(node), degree);
                });
                return centralityResult;
            }
        case 'betweenness':
            return $a9fed459af8a0145$export$df22a6b0582e9935(graphData, centrality.directed, centrality.weightPropertyName);
        case 'closeness':
            return $a9fed459af8a0145$export$87c1449aea2cb53f(graphData, centrality.directed, centrality.weightPropertyName);
        case 'eigenvector':
            return $a9fed459af8a0145$export$bead2d4f90e069e1(graphData, centrality.directed);
        case 'pagerank':
            return $a9fed459af8a0145$export$66d51b49c768a532(graphData, centrality.epsilon, centrality.linkProb);
        default:
            return $a9fed459af8a0145$export$ae5cb025408cbf66(graphData);
    }
};
const $a9fed459af8a0145$export$ae5cb025408cbf66 = (graphData)=>{
    var _a;
    const centralityResult = new Map();
    (_a = graphData.nodes) === null || _a === void 0 || _a.forEach((node)=>{
        centralityResult.set((0, $brtTw.idOf)(node), 0);
    });
    return centralityResult;
};
const $a9fed459af8a0145$export$df22a6b0582e9935 = (graphData, directed, weightPropertyName)=>{
    const centralityResult = $a9fed459af8a0145$export$ae5cb025408cbf66(graphData);
    const { nodes: nodes = [] } = graphData;
    nodes.forEach((source)=>{
        nodes.forEach((target)=>{
            if (source !== target) {
                const { allPath: allPath } = (0, $9YFSY.findShortestPath)(graphData, (0, $brtTw.idOf)(source), (0, $brtTw.idOf)(target), directed, weightPropertyName);
                const pathCount = allPath.length;
                allPath.flat().forEach((nodeId)=>{
                    if (nodeId !== (0, $brtTw.idOf)(source) && nodeId !== (0, $brtTw.idOf)(target)) centralityResult.set(nodeId, centralityResult.get(nodeId) + 1 / pathCount);
                });
            }
        });
    });
    return centralityResult;
};
const $a9fed459af8a0145$export$87c1449aea2cb53f = (graphData, directed, weightPropertyName)=>{
    const centralityResult = new Map();
    const { nodes: nodes = [] } = graphData;
    nodes.forEach((source)=>{
        const totalLength = nodes.reduce((acc, target)=>{
            if (source !== target) {
                const { length: length } = (0, $9YFSY.findShortestPath)(graphData, (0, $brtTw.idOf)(source), (0, $brtTw.idOf)(target), directed, weightPropertyName);
                acc += length;
            }
            return acc;
        }, 0);
        centralityResult.set((0, $brtTw.idOf)(source), 1 / totalLength);
    });
    return centralityResult;
};
const $a9fed459af8a0145$export$66d51b49c768a532 = (graphData, epsilon, linkProb)=>{
    var _a;
    const centralityResult = new Map();
    const data = (0, $avAF8.default)(graphData, epsilon, linkProb);
    (_a = graphData.nodes) === null || _a === void 0 || _a.forEach((node)=>{
        centralityResult.set((0, $brtTw.idOf)(node), data[(0, $brtTw.idOf)(node)]);
    });
    return centralityResult;
};
const $a9fed459af8a0145$export$bead2d4f90e069e1 = (graphData, directed)=>{
    const { nodes: nodes = [] } = graphData;
    const adjacencyMatrix = $a9fed459af8a0145$export$d86fb54417f60e2f(graphData, directed);
    const eigenvector = $a9fed459af8a0145$var$powerIteration(adjacencyMatrix, nodes.length);
    const centralityResult = new Map();
    nodes.forEach((node, index)=>{
        centralityResult.set((0, $brtTw.idOf)(node), eigenvector[index]);
    });
    return centralityResult;
};
const $a9fed459af8a0145$export$d86fb54417f60e2f = (graphData, directed)=>{
    const { nodes: nodes = [], edges: edges = [] } = graphData;
    const matrix = Array(nodes.length).fill(null).map(()=>Array(nodes.length).fill(0));
    edges.forEach(({ source: source, target: target })=>{
        const uIndex = nodes.findIndex((node)=>(0, $brtTw.idOf)(node) === source);
        const vIndex = nodes.findIndex((node)=>(0, $brtTw.idOf)(node) === target);
        if (directed) matrix[uIndex][vIndex] = 1;
        else {
            matrix[uIndex][vIndex] = 1;
            matrix[vIndex][uIndex] = 1;
        }
    });
    return matrix;
};
/**
 * <zh/> 使用幂迭代法计算主特征向量
 *
 * <en/> Calculate the principal eigenvector using the power iteration method
 * @see https://en.wikipedia.org/wiki/Eigenvalues_and_eigenvectors
 * @param matrix - <zh/> 邻接矩阵 | <en/> The adjacency matrix
 * @param numNodes - <zh/> 节点数量 | <en/> The number of nodes
 * @param maxIterations - <zh/> 最大迭代次数 | <en/> The maximum number of iterations
 * @param tolerance - <zh/> 收敛容差 | <en/> The convergence tolerance
 * @returns <zh/> 主特征向量 | <en/> The principal eigenvector
 */ const $a9fed459af8a0145$var$powerIteration = (matrix, numNodes, maxIterations = 100, tolerance = 1e-6)=>{
    let eigenvector = Array(numNodes).fill(1);
    let diff = Infinity;
    for(let iter = 0; iter < maxIterations && diff > tolerance; iter++){
        const newEigenvector = Array(numNodes).fill(0);
        for(let i = 0; i < numNodes; i++)for(let j = 0; j < numNodes; j++)newEigenvector[i] += matrix[i][j] * eigenvector[j];
        const norm = Math.sqrt(newEigenvector.reduce((sum, val)=>sum + val * val, 0));
        for(let i = 0; i < numNodes; i++)newEigenvector[i] /= norm;
        diff = Math.sqrt(newEigenvector.reduce((sum, val, index)=>sum + (val - eigenvector[index]) * val, 0));
        eigenvector = newEigenvector;
    }
    return eigenvector;
};

});
parcelRegister("dfdyY", function(module, exports) {

$parcel$export(module.exports, "findShortestPath", () => (parcelRequire("9YFSY")).findShortestPath);
$parcel$export(module.exports, "pageRank", () => (parcelRequire("avAF8")).default);

var $eltf2 = parcelRequire("eltf2");

var $9M6tF = parcelRequire("9M6tF");

var $GO5iS = parcelRequire("GO5iS");

var $gGbI9 = parcelRequire("gGbI9");

var $apRpn = parcelRequire("apRpn");

var $3AUeI = parcelRequire("3AUeI");

var $7mzeL = parcelRequire("7mzeL");

var $9YFSY = parcelRequire("9YFSY");

var $cpOcc = parcelRequire("cpOcc");

var $2knMu = parcelRequire("2knMu");

var $iEgNa = parcelRequire("iEgNa");

var $iYdqr = parcelRequire("iYdqr");

var $iXKbO = parcelRequire("iXKbO");

var $edbWE = parcelRequire("edbWE");

var $b90Kv = parcelRequire("b90Kv");

var $f2j9J = parcelRequire("f2j9J");

var $g4d4j = parcelRequire("g4d4j");

var $avAF8 = parcelRequire("avAF8");

var $8PJb7 = parcelRequire("8PJb7");

var $hmOkR = parcelRequire("hmOkR");

var $lFtOT = parcelRequire("lFtOT");
var $9a47327180815355$export$5a6442b417da421b = (0, $apRpn.default);
var $9a47327180815355$export$2e2bcd8739ae039 = {
    getAdjMatrix: (0, $eltf2.default),
    breadthFirstSearch: (0, $9M6tF.default),
    connectedComponent: (0, $GO5iS.default),
    getDegree: (0, $gGbI9.default),
    getInDegree: (0, $gGbI9.getInDegree),
    getOutDegree: (0, $gGbI9.getOutDegree),
    detectCycle: (0, $apRpn.default),
    detectDirectedCycle: $9a47327180815355$export$5a6442b417da421b,
    detectAllCycles: (0, $apRpn.detectAllCycles),
    detectAllDirectedCycle: (0, $apRpn.detectAllDirectedCycle),
    detectAllUndirectedCycle: (0, $apRpn.detectAllUndirectedCycle),
    depthFirstSearch: (0, $3AUeI.default),
    dijkstra: (0, $7mzeL.default),
    findAllPath: (0, $9YFSY.findAllPath),
    findShortestPath: (0, $9YFSY.findShortestPath),
    floydWarshall: (0, $cpOcc.default),
    labelPropagation: (0, $2knMu.default),
    louvain: (0, $iEgNa.default),
    iLouvain: (0, $iYdqr.default),
    kCore: (0, $iXKbO.default),
    kMeans: (0, $edbWE.default),
    cosineSimilarity: (0, $b90Kv.default),
    nodesCosineSimilarity: (0, $f2j9J.default),
    minimumSpanningTree: (0, $g4d4j.default),
    pageRank: (0, $avAF8.default),
    getNeighbors: (0, $lFtOT.getNeighbors),
    Stack: (0, $hmOkR.default),
    GADDI: (0, $8PJb7.default)
};

});
parcelRegister("eltf2", function(module, exports) {

$parcel$export(module.exports, "default", () => $a719b5a36c5f22b4$export$2e2bcd8739ae039);
var $a719b5a36c5f22b4$var$adjMatrix = function adjMatrix(graphData, directed) {
    var nodes = graphData.nodes, edges = graphData.edges;
    var matrix = [];
    // map node with index in data.nodes
    var nodeMap = {};
    if (!nodes) throw new Error("invalid nodes data!");
    if (nodes) nodes.forEach(function(node, i) {
        nodeMap[node.id] = i;
        var row = [];
        matrix.push(row);
    });
    if (edges) edges.forEach(function(edge) {
        var source = edge.source, target = edge.target;
        var sIndex = nodeMap[source];
        var tIndex = nodeMap[target];
        if (!sIndex && sIndex !== 0 || !tIndex && tIndex !== 0) return;
        matrix[sIndex][tIndex] = 1;
        if (!directed) matrix[tIndex][sIndex] = 1;
    });
    return matrix;
};
var $a719b5a36c5f22b4$export$2e2bcd8739ae039 = $a719b5a36c5f22b4$var$adjMatrix;

});

parcelRegister("9M6tF", function(module, exports) {

$parcel$export(module.exports, "default", () => $71dd9f10125b6049$export$2e2bcd8739ae039);

var $bEiaw = parcelRequire("bEiaw");

var $lFtOT = parcelRequire("lFtOT");
/**
 *
 * @param callbacks
 * allowTraversal: 确定 BFS 是否从顶点沿着边遍历到其邻居，默认情况下，同一个节点只能遍历一次
 * enterNode: 当 BFS 访问某个节点时调用
 * leaveNode: 当 BFS 访问访问结束某个节点时调用
 */ function $71dd9f10125b6049$var$initCallbacks(callbacks) {
    if (callbacks === void 0) callbacks = {};
    var initiatedCallback = callbacks;
    var stubCallback = function stubCallback() {};
    var allowTraversalCallback = function() {
        var seen = {};
        return function(_a) {
            var next = _a.next;
            var id = next;
            if (!seen[id]) {
                seen[id] = true;
                return true;
            }
            return false;
        };
    }();
    initiatedCallback.allowTraversal = callbacks.allowTraversal || allowTraversalCallback;
    initiatedCallback.enter = callbacks.enter || stubCallback;
    initiatedCallback.leave = callbacks.leave || stubCallback;
    return initiatedCallback;
}
/**
 * 广度优先遍历图
 * @param graph Graph 图实例
 * @param startNode 开始遍历的节点
 * @param originalCallbacks 回调
 */ var $71dd9f10125b6049$var$breadthFirstSearch = function breadthFirstSearch(graphData, startNodeId, originalCallbacks, directed) {
    if (directed === void 0) directed = true;
    var callbacks = $71dd9f10125b6049$var$initCallbacks(originalCallbacks);
    var nodeQueue = new (0, $bEiaw.default)();
    var _a = graphData.edges, edges = _a === void 0 ? [] : _a;
    // 初始化队列元素
    nodeQueue.enqueue(startNodeId);
    var previousNode = '';
    var _loop_1 = function _loop_1() {
        var currentNode = nodeQueue.dequeue();
        callbacks.enter({
            current: currentNode,
            previous: previousNode
        });
        // 将所有邻居添加到队列中以便遍历
        (0, $lFtOT.getNeighbors)(currentNode, edges, directed ? 'target' : undefined).forEach(function(nextNode) {
            if (callbacks.allowTraversal({
                previous: previousNode,
                current: currentNode,
                next: nextNode
            })) nodeQueue.enqueue(nextNode);
        });
        callbacks.leave({
            current: currentNode,
            previous: previousNode
        });
        // 下一次循环之前存储当前顶点
        previousNode = currentNode;
    };
    // 遍历队列中的所有顶点
    while(!nodeQueue.isEmpty())_loop_1();
};
var $71dd9f10125b6049$export$2e2bcd8739ae039 = $71dd9f10125b6049$var$breadthFirstSearch;

});
parcelRegister("bEiaw", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b1860fd6c98bf7$export$2e2bcd8739ae039);

var $9PxNf = parcelRequire("9PxNf");
var $87b1860fd6c98bf7$var$Queue = /** @class */ function() {
    function Queue() {
        this.linkedList = new (0, $9PxNf.default)();
    }
    /**
   * 队列是否为空
   */ Queue.prototype.isEmpty = function() {
        return !this.linkedList.head;
    };
    /**
   * 读取队列头部的元素， 不删除队列中的元素
   */ Queue.prototype.peek = function() {
        if (!this.linkedList.head) return null;
        return this.linkedList.head.value;
    };
    /**
   * 在队列的尾部新增一个元素
   * @param value
   */ Queue.prototype.enqueue = function(value) {
        this.linkedList.append(value);
    };
    /**
   * 删除队列中的头部元素，如果队列为空，则返回 null
   */ Queue.prototype.dequeue = function() {
        var removeHead = this.linkedList.deleteHead();
        return removeHead ? removeHead.value : null;
    };
    Queue.prototype.toString = function(callback) {
        return this.linkedList.toString(callback);
    };
    return Queue;
}();
var $87b1860fd6c98bf7$export$2e2bcd8739ae039 = $87b1860fd6c98bf7$var$Queue;

});
parcelRegister("9PxNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $72831719d23f6b94$export$2e2bcd8739ae039);
var $72831719d23f6b94$var$defaultComparator = function defaultComparator(a, b) {
    if (a === b) return true;
    return false;
};
/**
 * 链表中单个元素节点
 */ var $72831719d23f6b94$export$5d46cdc45c10b806 = /** @class */ function() {
    function LinkedListNode(value, next) {
        if (next === void 0) next = null;
        this.value = value;
        this.next = next;
    }
    LinkedListNode.prototype.toString = function(callback) {
        return callback ? callback(this.value) : "".concat(this.value);
    };
    return LinkedListNode;
}();
var $72831719d23f6b94$var$LinkedList = /** @class */ function() {
    function LinkedList(comparator) {
        if (comparator === void 0) comparator = $72831719d23f6b94$var$defaultComparator;
        this.head = null;
        this.tail = null;
        this.compare = comparator;
    }
    /**
   * 将指定元素添加到链表头部
   * @param value
   */ LinkedList.prototype.prepend = function(value) {
        // 在头部添加一个节点
        var newNode = new $72831719d23f6b94$export$5d46cdc45c10b806(value, this.head);
        this.head = newNode;
        if (!this.tail) this.tail = newNode;
        return this;
    };
    /**
   * 将指定元素添加到链表中
   * @param value
   */ LinkedList.prototype.append = function(value) {
        var newNode = new $72831719d23f6b94$export$5d46cdc45c10b806(value);
        // 如果不存在头节点，则将创建的新节点作为头节点
        if (!this.head) {
            this.head = newNode;
            this.tail = newNode;
            return this;
        }
        // 将新节点附加到链表末尾
        this.tail.next = newNode;
        this.tail = newNode;
        return this;
    };
    /**
   * 删除指定元素
   * @param value 要删除的元素
   */ LinkedList.prototype.delete = function(value) {
        if (!this.head) return null;
        var deleteNode = null;
        // 如果删除的是头部元素，则将next作为头元素
        while(this.head && this.compare(this.head.value, value)){
            deleteNode = this.head;
            this.head = this.head.next;
        }
        var currentNode = this.head;
        if (currentNode !== null) {
            // 如果删除了节点以后，将next节点前移
            while(currentNode.next)if (this.compare(currentNode.next.value, value)) {
                deleteNode = currentNode.next;
                currentNode.next = currentNode.next.next;
            } else currentNode = currentNode.next;
        }
        // 检查尾部节点是否被删除
        if (this.compare(this.tail.value, value)) this.tail = currentNode;
        return deleteNode;
    };
    /**
   * 查找指定的元素
   * @param param0
   */ LinkedList.prototype.find = function(_a) {
        var _b = _a.value, value = _b === void 0 ? undefined : _b, _c = _a.callback, callback = _c === void 0 ? undefined : _c;
        if (!this.head) return null;
        var currentNode = this.head;
        while(currentNode){
            // 如果指定了 callback，则按指定的 callback 查找
            if (callback && callback(currentNode.value)) return currentNode;
            // 如果指定了 value，则按 value 查找
            if (value !== undefined && this.compare(currentNode.value, value)) return currentNode;
            currentNode = currentNode.next;
        }
        return null;
    };
    /**
   * 删除尾部节点
   */ LinkedList.prototype.deleteTail = function() {
        var deletedTail = this.tail;
        if (this.head === this.tail) {
            // 链表中只有一个元素
            this.head = null;
            this.tail = null;
            return deletedTail;
        }
        var currentNode = this.head;
        while(currentNode.next)if (!currentNode.next.next) currentNode.next = null;
        else currentNode = currentNode.next;
        this.tail = currentNode;
        return deletedTail;
    };
    /**
   * 删除头部节点
   */ LinkedList.prototype.deleteHead = function() {
        if (!this.head) return null;
        var deletedHead = this.head;
        if (this.head.next) this.head = this.head.next;
        else {
            this.head = null;
            this.tail = null;
        }
        return deletedHead;
    };
    /**
   * 将一组元素转成链表中的节点
   * @param values 链表中的元素
   */ LinkedList.prototype.fromArray = function(values) {
        var _this = this;
        values.forEach(function(value) {
            return _this.append(value);
        });
        return this;
    };
    /**
   * 将链表中的节点转成数组元素
   */ LinkedList.prototype.toArray = function() {
        var nodes = [];
        var currentNode = this.head;
        while(currentNode){
            nodes.push(currentNode);
            currentNode = currentNode.next;
        }
        return nodes;
    };
    /**
   * 反转链表中的元素节点
   */ LinkedList.prototype.reverse = function() {
        var currentNode = this.head;
        var prevNode = null;
        var nextNode = null;
        while(currentNode){
            // 存储下一个元素节点
            nextNode = currentNode.next;
            // 更改当前节点的下一个节点，以便将它连接到上一个节点上
            currentNode.next = prevNode;
            // 将 prevNode 和 currentNode 向前移动一步
            prevNode = currentNode;
            currentNode = nextNode;
        }
        this.tail = this.head;
        this.head = prevNode;
    };
    LinkedList.prototype.toString = function(callback) {
        if (callback === void 0) callback = undefined;
        return this.toArray().map(function(node) {
            return node.toString(callback);
        }).toString();
    };
    return LinkedList;
}();
var $72831719d23f6b94$export$2e2bcd8739ae039 = $72831719d23f6b94$var$LinkedList;

});


parcelRegister("lFtOT", function(module, exports) {

$parcel$export(module.exports, "getNeighbors", () => $fc648eed028a7ea1$export$d267720df364abeb);
$parcel$export(module.exports, "getOutEdgesNodeId", () => $fc648eed028a7ea1$export$13019d490567b5b5);
$parcel$export(module.exports, "getEdgesByNodeId", () => $fc648eed028a7ea1$export$57dc21f121ffbbcc);
$parcel$export(module.exports, "uniqueId", () => $fc648eed028a7ea1$export$8b15d37bc3f197d4);
/**
 * 获取指定节点的所有邻居
 * @param nodeId 节点 ID
 * @param edges 图中的所有边数据
 * @param type 邻居类型
 */ var $fc648eed028a7ea1$export$d267720df364abeb = function getNeighbors(nodeId, edges, type) {
    if (edges === void 0) edges = [];
    var currentEdges = edges.filter(function(edge) {
        return edge.source === nodeId || edge.target === nodeId;
    });
    if (type === 'target') {
        // 当前节点为 source，它所指向的目标节点
        var neighhborsConverter_1 = function neighhborsConverter_1(edge) {
            return edge.source === nodeId;
        };
        return currentEdges.filter(neighhborsConverter_1).map(function(edge) {
            return edge.target;
        });
    }
    if (type === 'source') {
        // 当前节点为 target，它所指向的源节点
        var neighhborsConverter_2 = function neighhborsConverter_2(edge) {
            return edge.target === nodeId;
        };
        return currentEdges.filter(neighhborsConverter_2).map(function(edge) {
            return edge.source;
        });
    }
    // 若未指定 type ，则返回所有邻居
    var neighhborsConverter = function neighhborsConverter(edge) {
        return edge.source === nodeId ? edge.target : edge.source;
    };
    return currentEdges.map(neighhborsConverter);
};
var $fc648eed028a7ea1$export$13019d490567b5b5 = function getOutEdgesNodeId(nodeId, edges) {
    return edges.filter(function(edge) {
        return edge.source === nodeId;
    });
};
var $fc648eed028a7ea1$export$57dc21f121ffbbcc = function getEdgesByNodeId(nodeId, edges) {
    return edges.filter(function(edge) {
        return edge.source === nodeId || edge.target === nodeId;
    });
};
var $fc648eed028a7ea1$export$8b15d37bc3f197d4 = function uniqueId(index) {
    if (index === void 0) index = 0;
    var random1 = "".concat(Math.random()).split('.')[1].substr(0, 5);
    var random2 = "".concat(Math.random()).split('.')[1].substr(0, 5);
    return "".concat(index, "-").concat(random1).concat(random2);
};

});


parcelRegister("GO5iS", function(module, exports) {

$parcel$export(module.exports, "detectStrongConnectComponents", () => $080ac61ad3cb027e$export$75922f99dd18221);
$parcel$export(module.exports, "default", () => $080ac61ad3cb027e$export$2e2bcd8739ae039);

var $lFtOT = parcelRequire("lFtOT");
var $080ac61ad3cb027e$export$33a910587fba470d = function detectConnectedComponents(graphData) {
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a, _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    var allComponents = [];
    var visited = {};
    var nodeStack = [];
    var getComponent = function getComponent(node) {
        nodeStack.push(node);
        visited[node.id] = true;
        var neighbors = (0, $lFtOT.getNeighbors)(node.id, edges);
        var _loop_1 = function _loop_1(i) {
            var neighbor = neighbors[i];
            if (!visited[neighbor]) {
                var targetNode = nodes.filter(function(node) {
                    return node.id === neighbor;
                });
                if (targetNode.length > 0) getComponent(targetNode[0]);
            }
        };
        for(var i = 0; i < neighbors.length; ++i)_loop_1(i);
    };
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (!visited[node.id]) {
            // 对于无向图进行dfs遍历，每一次调用后都得到一个连通分量
            getComponent(node);
            var component = [];
            while(nodeStack.length > 0)component.push(nodeStack.pop());
            allComponents.push(component);
        }
    }
    return allComponents;
};
var $080ac61ad3cb027e$export$75922f99dd18221 = function detectStrongConnectComponents(graphData) {
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a, _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    var nodeStack = [];
    var inStack = {}; // 辅助判断是否已经在stack中，减少查找开销
    var indices = {};
    var lowLink = {};
    var allComponents = [];
    var index = 0;
    var getComponent = function getComponent(node) {
        // Set the depth index for v to the smallest unused index
        indices[node.id] = index;
        lowLink[node.id] = index;
        index += 1;
        nodeStack.push(node);
        inStack[node.id] = true;
        // 考虑每个邻接点
        var neighbors = (0, $lFtOT.getNeighbors)(node.id, edges, 'target').filter(function(n) {
            return nodes.map(function(node) {
                return node.id;
            }).indexOf(n) > -1;
        });
        var _loop_2 = function _loop_2(i) {
            var targetNodeID = neighbors[i];
            if (!indices[targetNodeID] && indices[targetNodeID] !== 0) {
                var targetNode = nodes.filter(function(node) {
                    return node.id === targetNodeID;
                });
                if (targetNode.length > 0) getComponent(targetNode[0]);
                // tree edge
                lowLink[node.id] = Math.min(lowLink[node.id], lowLink[targetNodeID]);
            } else if (inStack[targetNodeID]) // back edge, target node is in the current SCC
            lowLink[node.id] = Math.min(lowLink[node.id], indices[targetNodeID]);
        };
        for(var i = 0; i < neighbors.length; i++)_loop_2(i);
        // If node is a root node, generate an SCC
        if (lowLink[node.id] === indices[node.id]) {
            var component = [];
            while(nodeStack.length > 0){
                var tmpNode = nodeStack.pop();
                inStack[tmpNode.id] = false;
                component.push(tmpNode);
                if (tmpNode === node) break;
            }
            if (component.length > 0) allComponents.push(component);
        }
    };
    for(var _i = 0, nodes_1 = nodes; _i < nodes_1.length; _i++){
        var node = nodes_1[_i];
        if (!indices[node.id] && indices[node.id] !== 0) getComponent(node);
    }
    return allComponents;
};
function $080ac61ad3cb027e$export$2e2bcd8739ae039(graphData, directed) {
    if (directed) return $080ac61ad3cb027e$export$75922f99dd18221(graphData);
    return $080ac61ad3cb027e$export$33a910587fba470d(graphData);
}

});

parcelRegister("gGbI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c249a72b9bef465e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getInDegree", () => $c249a72b9bef465e$export$5335f358bcbc42b6);
$parcel$export(module.exports, "getOutDegree", () => $c249a72b9bef465e$export$9a4bd1064db5ddfd);
var $c249a72b9bef465e$var$degree = function degree(graphData) {
    var degrees = {};
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a, _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    nodes.forEach(function(node) {
        degrees[node.id] = {
            degree: 0,
            inDegree: 0,
            outDegree: 0
        };
    });
    edges.forEach(function(edge) {
        degrees[edge.source].degree++;
        degrees[edge.source].outDegree++;
        degrees[edge.target].degree++;
        degrees[edge.target].inDegree++;
    });
    return degrees;
};
var $c249a72b9bef465e$export$2e2bcd8739ae039 = $c249a72b9bef465e$var$degree;
var $c249a72b9bef465e$export$5335f358bcbc42b6 = function getInDegree(graphData, nodeId) {
    var nodeDegree = $c249a72b9bef465e$var$degree(graphData);
    if (nodeDegree[nodeId]) return $c249a72b9bef465e$var$degree(graphData)[nodeId].inDegree;
    return 0;
};
var $c249a72b9bef465e$export$9a4bd1064db5ddfd = function getOutDegree(graphData, nodeId) {
    var nodeDegree = $c249a72b9bef465e$var$degree(graphData);
    if (nodeDegree[nodeId]) return $c249a72b9bef465e$var$degree(graphData)[nodeId].outDegree;
    return 0;
};

});

parcelRegister("apRpn", function(module, exports) {

$parcel$export(module.exports, "detectAllUndirectedCycle", () => $7955aaf0ee3f506d$export$6097138e0093e096);
$parcel$export(module.exports, "detectAllDirectedCycle", () => $7955aaf0ee3f506d$export$b20feba7594282d);
$parcel$export(module.exports, "detectAllCycles", () => $7955aaf0ee3f506d$export$290d97467d018886);
$parcel$export(module.exports, "default", () => $7955aaf0ee3f506d$export$2e2bcd8739ae039);

var $3AUeI = parcelRequire("3AUeI");

var $GO5iS = parcelRequire("GO5iS");

var $lFtOT = parcelRequire("lFtOT");
var $7955aaf0ee3f506d$var$detectDirectedCycle = function detectDirectedCycle(graphData) {
    var cycle = null;
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a;
    var dfsParentMap = {};
    // 所有没有被访问的节点集合
    var unvisitedSet = {};
    // 正在被访问的节点集合
    var visitingSet = {};
    // 所有已经被访问过的节点集合
    var visitedSet = {};
    // 初始化 unvisitedSet
    nodes.forEach(function(node) {
        unvisitedSet[node.id] = node;
    });
    var callbacks = {
        enter: function enter(_a) {
            var currentNode = _a.current, previousNode = _a.previous;
            if (visitingSet[currentNode]) {
                // 如果当前节点正在访问中，则说明检测到环路了
                cycle = {};
                var currentCycleNode = currentNode;
                var previousCycleNode = previousNode;
                while(previousCycleNode !== currentNode){
                    cycle[currentCycleNode] = previousCycleNode;
                    currentCycleNode = previousCycleNode;
                    previousCycleNode = dfsParentMap[previousCycleNode];
                }
                cycle[currentCycleNode] = previousCycleNode;
            } else {
                // 如果不存在正在访问集合中，则将其放入正在访问集合，并从未访问集合中删除
                visitingSet[currentNode] = currentNode;
                delete unvisitedSet[currentNode];
                // 更新 DSF parents 列表
                dfsParentMap[currentNode] = previousNode;
            }
        },
        leave: function leave(_a) {
            var currentNode = _a.current;
            // 如果所有的节点的子节点都已经访问过了，则从正在访问集合中删除掉，并将其移入到已访问集合中，
            // 同时也意味着当前节点的所有邻居节点都被访问过了
            visitedSet[currentNode] = currentNode;
            delete visitingSet[currentNode];
        },
        allowTraversal: function allowTraversal(_a) {
            var nextNode = _a.next;
            // 如果检测到环路则需要终止所有进一步的遍历，否则会导致无限循环遍历
            if (cycle) return false;
            // 仅允许遍历没有访问的节点，visitedSet 中的都已经访问过了
            return !visitedSet[nextNode];
        }
    };
    // 开始遍历节点
    while(Object.keys(unvisitedSet).length){
        // 从第一个节点开始进行 DFS 遍历
        var firsetUnVisitedKey = Object.keys(unvisitedSet)[0];
        (0, $3AUeI.default)(graphData, firsetUnVisitedKey, callbacks);
    }
    return cycle;
};
var $7955aaf0ee3f506d$export$6097138e0093e096 = function detectAllUndirectedCycle(graphData, nodeIds, include) {
    var _a, _b;
    if (include === void 0) include = true;
    var allCycles = [];
    var components = (0, $GO5iS.default)(graphData, false);
    // loop through all connected components
    for(var _i = 0, components_1 = components; _i < components_1.length; _i++){
        var component = components_1[_i];
        if (!component.length) continue;
        var root = component[0];
        var rootId = root.id;
        var stack = [
            root
        ];
        var parent_1 = (_a = {}, _a[rootId] = root, _a);
        var used = (_b = {}, _b[rootId] = new Set(), _b);
        // walk a spanning tree to find cycles
        while(stack.length > 0){
            var curNode = stack.pop();
            var curNodeId = curNode.id;
            var neighbors = (0, $lFtOT.getNeighbors)(curNodeId, graphData.edges);
            var _loop_1 = function _loop_1(i) {
                var _c;
                var neighborId = neighbors[i];
                var neighbor = graphData.nodes.find(function(node) {
                    return node.id === neighborId;
                });
                // const neighborId = neighbor.get('id');
                if (neighborId === curNodeId) // 自环
                allCycles.push((_c = {}, _c[neighborId] = curNode, _c));
                else if (!(neighborId in used)) {
                    // visit a new node
                    parent_1[neighborId] = curNode;
                    stack.push(neighbor);
                    used[neighborId] = new Set([
                        curNode
                    ]);
                } else if (!used[curNodeId].has(neighbor)) {
                    // a cycle found
                    var cycleValid = true;
                    var cyclePath = [
                        neighbor,
                        curNode
                    ];
                    var p = parent_1[curNodeId];
                    while(used[neighborId].size && !used[neighborId].has(p)){
                        cyclePath.push(p);
                        if (p === parent_1[p.id]) break;
                        else p = parent_1[p.id];
                    }
                    cyclePath.push(p);
                    if (nodeIds && include) {
                        // 如果有指定包含的节点
                        cycleValid = false;
                        if (cyclePath.findIndex(function(node) {
                            return nodeIds.indexOf(node.id) > -1;
                        }) > -1) cycleValid = true;
                    } else if (nodeIds && !include) // 如果有指定不包含的节点
                    {
                        if (cyclePath.findIndex(function(node) {
                            return nodeIds.indexOf(node.id) > -1;
                        }) > -1) cycleValid = false;
                    }
                    // 把 node list 形式转换为 cycle 的格式
                    if (cycleValid) {
                        var cycle = {};
                        for(var index = 1; index < cyclePath.length; index += 1)cycle[cyclePath[index - 1].id] = cyclePath[index];
                        if (cyclePath.length) cycle[cyclePath[cyclePath.length - 1].id] = cyclePath[0];
                        allCycles.push(cycle);
                    }
                    used[neighborId].add(curNode);
                }
            };
            for(var i = 0; i < neighbors.length; i += 1)_loop_1(i);
        }
    }
    return allCycles;
};
var $7955aaf0ee3f506d$export$b20feba7594282d = function detectAllDirectedCycle(graphData, nodeIds, include) {
    if (include === void 0) include = true;
    var path = []; // stack of nodes in current path
    var blocked = new Set();
    var B = []; // remember portions of the graph that yield no elementary circuit
    var allCycles = [];
    var idx2Node = {};
    var node2Idx = {};
    // 辅助函数： unblock all blocked nodes
    var unblock = function unblock(thisNode) {
        var stack = [
            thisNode
        ];
        while(stack.length > 0){
            var node = stack.pop();
            if (blocked.has(node)) {
                blocked.delete(node);
                B[node.id].forEach(function(n) {
                    stack.push(n);
                });
                B[node.id].clear();
            }
        }
    };
    var circuit = function circuit(node, start, adjList) {
        var closed = false; // whether a path is closed
        if (nodeIds && include === false && nodeIds.indexOf(node.id) > -1) return closed;
        path.push(node);
        blocked.add(node);
        var neighbors = adjList[node.id];
        for(var i = 0; i < neighbors.length; i += 1){
            var neighbor = idx2Node[neighbors[i]];
            if (neighbor === start) {
                var cycle = {};
                for(var index = 1; index < path.length; index += 1)cycle[path[index - 1].id] = path[index];
                if (path.length) cycle[path[path.length - 1].id] = path[0];
                allCycles.push(cycle);
                closed = true;
            } else if (!blocked.has(neighbor)) {
                if (circuit(neighbor, start, adjList)) closed = true;
            }
        }
        if (closed) unblock(node);
        else for(var i = 0; i < neighbors.length; i += 1){
            var neighbor = idx2Node[neighbors[i]];
            if (!B[neighbor.id].has(node)) B[neighbor.id].add(node);
        }
        path.pop();
        return closed;
    };
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a;
    // Johnson's algorithm 要求给节点赋顺序，先按节点在数组中的顺序
    for(var i = 0; i < nodes.length; i += 1){
        var node = nodes[i];
        var nodeId = node.id;
        node2Idx[nodeId] = i;
        idx2Node[i] = node;
    }
    // 如果有指定包含的节点，则把指定节点排序在前，以便提早结束搜索
    if (nodeIds && include) {
        var _loop_2 = function _loop_2(i) {
            var nodeId = nodeIds[i];
            node2Idx[nodes[i].id] = node2Idx[nodeId];
            node2Idx[nodeId] = 0;
            idx2Node[0] = nodes.find(function(node) {
                return node.id === nodeId;
            });
            idx2Node[node2Idx[nodes[i].id]] = nodes[i];
        };
        for(var i = 0; i < nodeIds.length; i++)_loop_2(i);
    }
    // 返回 节点顺序 >= nodeOrder 的强连通分量的adjList
    var getMinComponentAdj = function getMinComponentAdj(components) {
        var _a;
        var minCompIdx;
        var minIdx = Infinity;
        // Find least component and the lowest node
        for(var i = 0; i < components.length; i += 1){
            var comp = components[i];
            for(var j = 0; j < comp.length; j++){
                var nodeIdx_1 = node2Idx[comp[j].id];
                if (nodeIdx_1 < minIdx) {
                    minIdx = nodeIdx_1;
                    minCompIdx = i;
                }
            }
        }
        var component = components[minCompIdx];
        var adjList = [];
        for(var i = 0; i < component.length; i += 1){
            var node = component[i];
            adjList[node.id] = [];
            for(var _i = 0, _b = (0, $lFtOT.getNeighbors)(node.id, graphData.edges, 'target').filter(function(n) {
                return component.map(function(c) {
                    return c.id;
                }).indexOf(n) > -1;
            }); _i < _b.length; _i++){
                var neighbor = _b[_i];
                // 对自环情况 (点连向自身) 特殊处理：记录自环，但不加入adjList
                if (neighbor === node.id && !(include === false && nodeIds.indexOf(node.id) > -1)) allCycles.push((_a = {}, _a[node.id] = node, _a));
                else adjList[node.id].push(node2Idx[neighbor]);
            }
        }
        return {
            component: component,
            adjList: adjList,
            minIdx: minIdx
        };
    };
    var nodeIdx = 0;
    while(nodeIdx < nodes.length){
        var subgraphNodes = nodes.filter(function(n) {
            return node2Idx[n.id] >= nodeIdx;
        });
        var sccs = (0, $GO5iS.detectStrongConnectComponents)({
            nodes: subgraphNodes,
            edges: graphData.edges
        }).filter(function(component) {
            return component.length > 1;
        });
        if (sccs.length === 0) break;
        var scc = getMinComponentAdj(sccs);
        var minIdx = scc.minIdx, adjList = scc.adjList, component = scc.component;
        if (component.length > 1) {
            component.forEach(function(node) {
                B[node.id] = new Set();
            });
            var startNode = idx2Node[minIdx];
            // startNode 不在指定要包含的节点中，提前结束搜索
            if (nodeIds && include && nodeIds.indexOf(startNode.id) === -1) return allCycles;
            circuit(startNode, startNode, adjList);
            nodeIdx = minIdx + 1;
        } else break;
    }
    return allCycles;
};
var $7955aaf0ee3f506d$export$290d97467d018886 = function detectAllCycles(graphData, directed, nodeIds, include) {
    if (include === void 0) include = true;
    if (directed) return $7955aaf0ee3f506d$export$b20feba7594282d(graphData, nodeIds, include);
    return $7955aaf0ee3f506d$export$6097138e0093e096(graphData, nodeIds, include);
};
var $7955aaf0ee3f506d$export$2e2bcd8739ae039 = $7955aaf0ee3f506d$var$detectDirectedCycle;

});
parcelRegister("3AUeI", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e05b3d25f079eb$export$2e2bcd8739ae039);

var $lFtOT = parcelRequire("lFtOT");
function $29e05b3d25f079eb$var$initCallbacks(callbacks) {
    if (callbacks === void 0) callbacks = {};
    var initiatedCallback = callbacks;
    var stubCallback = function stubCallback() {};
    var allowTraversalCallback = function() {
        var seen = {};
        return function(_a) {
            var next = _a.next;
            if (!seen[next]) {
                seen[next] = true;
                return true;
            }
            return false;
        };
    }();
    initiatedCallback.allowTraversal = callbacks.allowTraversal || allowTraversalCallback;
    initiatedCallback.enter = callbacks.enter || stubCallback;
    initiatedCallback.leave = callbacks.leave || stubCallback;
    return initiatedCallback;
}
/**
 * @param {Graph} graph
 * @param {GraphNode} currentNode
 * @param {GraphNode} previousNode
 * @param {Callbacks} callbacks
 */ function $29e05b3d25f079eb$var$depthFirstSearchRecursive(graphData, currentNode, previousNode, callbacks, directed) {
    if (directed === void 0) directed = true;
    callbacks.enter({
        current: currentNode,
        previous: previousNode
    });
    var _a = graphData.edges, edges = _a === void 0 ? [] : _a;
    (0, $lFtOT.getNeighbors)(currentNode, edges, directed ? 'target' : undefined).forEach(function(nextNode) {
        if (callbacks.allowTraversal({
            previous: previousNode,
            current: currentNode,
            next: nextNode
        })) $29e05b3d25f079eb$var$depthFirstSearchRecursive(graphData, nextNode, currentNode, callbacks, directed);
    });
    callbacks.leave({
        current: currentNode,
        previous: previousNode
    });
}
function $29e05b3d25f079eb$export$2e2bcd8739ae039(graphData, startNodeId, callbacks, directed) {
    if (directed === void 0) directed = true;
    $29e05b3d25f079eb$var$depthFirstSearchRecursive(graphData, startNodeId, '', $29e05b3d25f079eb$var$initCallbacks(callbacks), directed);
}

});


parcelRegister("7mzeL", function(module, exports) {

$parcel$export(module.exports, "default", () => $55c5ebd54f02c428$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("9PG0c");
var $6AW7D = parcelRequire("6AW7D");

var $lFtOT = parcelRequire("lFtOT");
var $55c5ebd54f02c428$var$minVertex = function minVertex(D, nodes, marks) {
    // 找出最小的点
    var minDis = Infinity;
    var minNode;
    for(var i = 0; i < nodes.length; i++){
        var nodeId = nodes[i].id;
        if (!marks[nodeId] && D[nodeId] <= minDis) {
            minDis = D[nodeId];
            minNode = nodes[i];
        }
    }
    return minNode;
};
var $55c5ebd54f02c428$var$dijkstra = function dijkstra(graphData, source, directed, weightPropertyName) {
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a, _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    var nodeIds = [];
    var marks = {};
    var D = {};
    var prevs = {}; // key: 顶点, value: 顶点的前驱点数组（可能有多条等长的最短路径）
    nodes.forEach(function(node, i) {
        var id = node.id;
        nodeIds.push(id);
        D[id] = Infinity;
        if (id === source) D[id] = 0;
    });
    var nodeNum = nodes.length;
    var _loop_1 = function _loop_1(i) {
        // Process the vertices
        var minNode = $55c5ebd54f02c428$var$minVertex(D, nodes, marks);
        var minNodeId = minNode.id;
        marks[minNodeId] = true;
        if (D[minNodeId] === Infinity) return "continue"; // Unreachable vertices cannot be the intermediate point
        var relatedEdges = [];
        if (directed) relatedEdges = (0, $lFtOT.getOutEdgesNodeId)(minNodeId, edges);
        else relatedEdges = (0, $lFtOT.getEdgesByNodeId)(minNodeId, edges);
        relatedEdges.forEach(function(edge) {
            var edgeTarget = edge.target;
            var edgeSource = edge.source;
            var w = edgeTarget === minNodeId ? edgeSource : edgeTarget;
            var weight = weightPropertyName && edge[weightPropertyName] ? edge[weightPropertyName] : 1;
            if (D[w] > D[minNode.id] + weight) {
                D[w] = D[minNode.id] + weight;
                prevs[w] = [
                    minNode.id
                ];
            } else if (D[w] === D[minNode.id] + weight) prevs[w].push(minNode.id);
        });
    };
    for(var i = 0; i < nodeNum; i++)_loop_1(i);
    prevs[source] = [
        source
    ];
    // 每个节点存可能存在多条最短路径
    var paths = {};
    for(var target in D)if (D[target] !== Infinity) $55c5ebd54f02c428$var$findAllPaths(source, target, prevs, paths);
    // 兼容之前单路径
    var path = {};
    for(var target in paths)path[target] = paths[target][0];
    return {
        length: D,
        path: path,
        allPath: paths
    };
};
var $55c5ebd54f02c428$export$2e2bcd8739ae039 = $55c5ebd54f02c428$var$dijkstra;
function $55c5ebd54f02c428$var$findAllPaths(source, target, prevs, foundPaths) {
    if (source === target) return [
        source
    ];
    if (foundPaths[target]) return foundPaths[target];
    var paths = [];
    for(var _i = 0, _a = prevs[target]; _i < _a.length; _i++){
        var prev = _a[_i];
        var prevPaths = $55c5ebd54f02c428$var$findAllPaths(source, prev, prevs, foundPaths);
        if (!prevPaths) return;
        for(var _b = 0, prevPaths_1 = prevPaths; _b < prevPaths_1.length; _b++){
            var prePath = prevPaths_1[_b];
            if ((0, $6AW7D.default)(prePath)) paths.push((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], prePath, true), [
                target
            ], false));
            else paths.push([
                prePath,
                target
            ]);
        }
    }
    foundPaths[target] = paths;
    return foundPaths[target];
}

});
parcelRegister("9PG0c", function(module, exports) {

$parcel$export(module.exports, "uniq", () => (parcelRequire("joF99")).default);
$parcel$export(module.exports, "isArray", () => (parcelRequire("6AW7D")).default);
$parcel$export(module.exports, "clone", () => (parcelRequire("glsCo")).default);
$parcel$export(module.exports, "isEqual", () => (parcelRequire("950hz")).default);
// array

var $kg42L = parcelRequire("kg42L");

var $gDv58 = parcelRequire("gDv58");

var $kf7SE = parcelRequire("kf7SE");

var $6mxnJ = parcelRequire("6mxnJ");

var $iCw9o = parcelRequire("iCw9o");

var $9XEVT = parcelRequire("9XEVT");

var $6ZbJQ = parcelRequire("6ZbJQ");

var $1vJQN = parcelRequire("1vJQN");

var $iM0nB = parcelRequire("iM0nB");

var $iw7pQ = parcelRequire("iw7pQ");

var $lJerm = parcelRequire("lJerm");

var $2NAVm = parcelRequire("2NAVm");

var $2dSZs = parcelRequire("2dSZs");

var $27Xcg = parcelRequire("27Xcg");

var $joF99 = parcelRequire("joF99");

var $5ERcR = parcelRequire("5ERcR");

var $e41rm = parcelRequire("e41rm");

var $6dLVr = parcelRequire("6dLVr");

var $6qJyH = parcelRequire("6qJyH");

var $6tCaZ = parcelRequire("6tCaZ");

var $lNEZp = parcelRequire("lNEZp");

var $bJRwr = parcelRequire("bJRwr");

var $80kOr = parcelRequire("80kOr");

var $9CxL4 = parcelRequire("9CxL4");

var $2gCl3 = parcelRequire("2gCl3");

var $dVWs5 = parcelRequire("dVWs5");

var $jzFiR = parcelRequire("jzFiR");

var $1csIr = parcelRequire("1csIr");

var $6K38v = parcelRequire("6K38v");

var $2uPTj = parcelRequire("2uPTj");

var $j7Zw1 = parcelRequire("j7Zw1");

var $cN6lF = parcelRequire("cN6lF");

var $lDEwq = parcelRequire("lDEwq");

var $avKEZ = parcelRequire("avKEZ");

var $6fjDQ = parcelRequire("6fjDQ");

var $6Nrz2 = parcelRequire("6Nrz2");

var $3gcQx = parcelRequire("3gcQx");

var $gV2ND = parcelRequire("gV2ND");

var $lcTyG = parcelRequire("lcTyG");

var $e7vqY = parcelRequire("e7vqY");

var $7IIpG = parcelRequire("7IIpG");

var $3vI9l = parcelRequire("3vI9l");

var $1q9NJ = parcelRequire("1q9NJ");

var $4B9Bv = parcelRequire("4B9Bv");

var $kNUye = parcelRequire("kNUye");

var $cYhPO = parcelRequire("cYhPO");

var $fcCKh = parcelRequire("fcCKh");

var $5RwDt = parcelRequire("5RwDt");

var $8AtwK = parcelRequire("8AtwK");

var $jsfXd = parcelRequire("jsfXd");

var $9b509 = parcelRequire("9b509");

var $fwOLA = parcelRequire("fwOLA");

var $iGXqG = parcelRequire("iGXqG");

var $eCWeh = parcelRequire("eCWeh");

var $eCn6a = parcelRequire("eCn6a");

var $FpM3Q = parcelRequire("FpM3Q");

var $6PXV1 = parcelRequire("6PXV1");

var $dOASN = parcelRequire("dOASN");

var $kdJVf = parcelRequire("kdJVf");

var $gpLeP = parcelRequire("gpLeP");

var $celsA = parcelRequire("celsA");

var $6AW7D = parcelRequire("6AW7D");

var $6cclF = parcelRequire("6cclF");

var $Nny3m = parcelRequire("Nny3m");

var $hfO0E = parcelRequire("hfO0E");

var $i2KdO = parcelRequire("i2KdO");

var $hOSFC = parcelRequire("hOSFC");

var $oJw8u = parcelRequire("oJw8u");

var $jIDW5 = parcelRequire("jIDW5");

var $hdErz = parcelRequire("hdErz");

var $6aSlm = parcelRequire("6aSlm");

var $lpEUi = parcelRequire("lpEUi");

var $5D4TN = parcelRequire("5D4TN");

var $7HG7Y = parcelRequire("7HG7Y");

var $7wRhs = parcelRequire("7wRhs");

var $ic1YK = parcelRequire("ic1YK");

var $kUSxU = parcelRequire("kUSxU");

var $9zNEc = parcelRequire("9zNEc");

var $3eHQ8 = parcelRequire("3eHQ8");

var $a96cp = parcelRequire("a96cp");

var $glACs = parcelRequire("glACs");

var $4eENJ = parcelRequire("4eENJ");

var $71j8U = parcelRequire("71j8U");

var $glsCo = parcelRequire("glsCo");

var $4Igwi = parcelRequire("4Igwi");

var $5u2qv = parcelRequire("5u2qv");

var $kGcJF = parcelRequire("kGcJF");

var $xl7tx = parcelRequire("xl7tx");

var $62I9o = parcelRequire("62I9o");

var $3Od90 = parcelRequire("3Od90");

var $hcp8H = parcelRequire("hcp8H");

var $950hz = parcelRequire("950hz");

var $CXf3B = parcelRequire("CXf3B");

var $8ubjB = parcelRequire("8ubjB");

var $iu94x = parcelRequire("iu94x");

var $dIthL = parcelRequire("dIthL");

var $9DjEH = parcelRequire("9DjEH");

var $iEcRk = parcelRequire("iEcRk");

var $c2G6o = parcelRequire("c2G6o");

var $l2Mfg = parcelRequire("l2Mfg");

var $KQctm = parcelRequire("KQctm");

var $7KRXX = parcelRequire("7KRXX");

var $cSzQA = parcelRequire("cSzQA");

var $h2Q84 = parcelRequire("h2Q84");

var $3jqxH = parcelRequire("3jqxH");

var $8Yobk = parcelRequire("8Yobk");

var $60MOC = parcelRequire("60MOC");

var $72Zfb = parcelRequire("72Zfb");

var $gFIIC = parcelRequire("gFIIC");

var $lN3iX = parcelRequire("lN3iX");

});
parcelRegister("kg42L", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebf8703dcf88af9d$export$2e2bcd8739ae039);

var $6cclF = parcelRequire("6cclF");
var $ebf8703dcf88af9d$var$contains = function(arr, value) {
    if (!(0, $6cclF.default)(arr)) return false;
    return arr.indexOf(value) > -1;
};
var $ebf8703dcf88af9d$export$2e2bcd8739ae039 = $ebf8703dcf88af9d$var$contains;

});
parcelRegister("6cclF", function(module, exports) {

$parcel$export(module.exports, "default", () => $482d7132e96e5e4c$export$2e2bcd8739ae039);
var $482d7132e96e5e4c$var$isArrayLike = function(value) {
    /**
     * isArrayLike([1, 2, 3]) => true
     * isArrayLike(document.body.children) => true
     * isArrayLike('abc') => true
     * isArrayLike(Function) => false
     */ return value !== null && typeof value !== 'function' && isFinite(value.length);
};
var $482d7132e96e5e4c$export$2e2bcd8739ae039 = $482d7132e96e5e4c$var$isArrayLike;

});


parcelRegister("gDv58", function(module, exports) {

var $lNEZp = parcelRequire("lNEZp");

var $kg42L = parcelRequire("kg42L");
/**
 * Flattens `array` a single level deep.
 *
 * @param {Array} arr The array to inspect.
 * @param {Array} values The values to exclude.
 * @return {Array} Returns the new array of filtered values.
 * @example
 * difference([2, 1], [2, 3]);  // => [1]
 */ var $c1c86610c3017895$var$difference = function(arr, values) {
    if (values === void 0) values = [];
    return (0, $lNEZp.default)(arr, function(value) {
        return !(0, $kg42L.default)(values, value);
    });
};
var $c1c86610c3017895$export$2e2bcd8739ae039 = $c1c86610c3017895$var$difference;

});
parcelRegister("lNEZp", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdedf83e5f72d924$export$2e2bcd8739ae039);

var $6cclF = parcelRequire("6cclF");
var $fdedf83e5f72d924$var$filter = function(arr, func) {
    if (!(0, $6cclF.default)(arr)) return arr;
    var result = [];
    for(var index = 0; index < arr.length; index++){
        var value = arr[index];
        if (func(value, index)) result.push(value);
    }
    return result;
};
var $fdedf83e5f72d924$export$2e2bcd8739ae039 = $fdedf83e5f72d924$var$filter;

});


parcelRegister("kf7SE", function(module, exports) {

var $hOSFC = parcelRequire("hOSFC");

var $iGXqG = parcelRequire("iGXqG");

var $6AW7D = parcelRequire("6AW7D");

var $7HG7Y = parcelRequire("7HG7Y");
function $ebcb523eb4882633$var$find(arr, predicate) {
    if (!(0, $6AW7D.default)(arr)) return null;
    var _predicate;
    if ((0, $hOSFC.default)(predicate)) _predicate = predicate;
    if ((0, $7HG7Y.default)(predicate)) _predicate = function(a) {
        return (0, $iGXqG.default)(a, predicate);
    };
    if (_predicate) for(var i = 0; i < arr.length; i += 1){
        if (_predicate(arr[i])) return arr[i];
    }
    return null;
}
var $ebcb523eb4882633$export$2e2bcd8739ae039 = $ebcb523eb4882633$var$find;

});
parcelRegister("hOSFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf91838803106fbb$export$2e2bcd8739ae039);
/**
 * 是否为函数
 * @param  {*} fn 对象
 * @return {Boolean}  是否函数
 */ 
var $9zNEc = parcelRequire("9zNEc");
var $cf91838803106fbb$export$2e2bcd8739ae039 = function(value) {
    return (0, $9zNEc.default)(value, 'Function');
};

});
parcelRegister("9zNEc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8de4e0722b18a0$export$2e2bcd8739ae039);
var $6f8de4e0722b18a0$var$toString = {}.toString;
var $6f8de4e0722b18a0$var$isType = function(value, type) {
    return $6f8de4e0722b18a0$var$toString.call(value) === '[object ' + type + ']';
};
var $6f8de4e0722b18a0$export$2e2bcd8739ae039 = $6f8de4e0722b18a0$var$isType;

});


parcelRegister("iGXqG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9ba3fae5a6811ea$export$2e2bcd8739ae039);

var $jIDW5 = parcelRequire("jIDW5");

var $fwOLA = parcelRequire("fwOLA");
function $d9ba3fae5a6811ea$var$isMatch(obj, attrs) {
    var _keys = (0, $fwOLA.default)(attrs);
    var length = _keys.length;
    if ((0, $jIDW5.default)(obj)) return !length;
    for(var i = 0; i < length; i += 1){
        var key = _keys[i];
        if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
}
var $d9ba3fae5a6811ea$export$2e2bcd8739ae039 = $d9ba3fae5a6811ea$var$isMatch;

});
parcelRegister("jIDW5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5b11ad4c0e45ca3$export$2e2bcd8739ae039);
// isFinite,
var $e5b11ad4c0e45ca3$var$isNil = function(value) {
    /**
     * isNil(null) => true
     * isNil() => true
     */ return value === null || value === undefined;
};
var $e5b11ad4c0e45ca3$export$2e2bcd8739ae039 = $e5b11ad4c0e45ca3$var$isNil;

});

parcelRegister("fwOLA", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4e139571cacde9e$export$2e2bcd8739ae039);

var $xl7tx = parcelRequire("xl7tx");

var $hOSFC = parcelRequire("hOSFC");
var $b4e139571cacde9e$var$keys = Object.keys ? function(obj) {
    return Object.keys(obj);
} : function(obj) {
    var result = [];
    (0, $xl7tx.default)(obj, function(value, key) {
        if (!((0, $hOSFC.default)(obj) && key === 'prototype')) result.push(key);
    });
    return result;
};
var $b4e139571cacde9e$export$2e2bcd8739ae039 = $b4e139571cacde9e$var$keys;

});
parcelRegister("xl7tx", function(module, exports) {

$parcel$export(module.exports, "default", () => $06437716b57ac4d0$export$2e2bcd8739ae039);

var $6AW7D = parcelRequire("6AW7D");

var $lpEUi = parcelRequire("lpEUi");
function $06437716b57ac4d0$var$each(elements, func) {
    if (!elements) return;
    var rst;
    if ((0, $6AW7D.default)(elements)) for(var i = 0, len = elements.length; i < len; i++){
        rst = func(elements[i], i);
        if (rst === false) break;
    }
    else if ((0, $lpEUi.default)(elements)) {
        for(var k in elements)if (elements.hasOwnProperty(k)) {
            rst = func(elements[k], k);
            if (rst === false) break;
        }
    }
}
var $06437716b57ac4d0$export$2e2bcd8739ae039 = $06437716b57ac4d0$var$each;

});
parcelRegister("6AW7D", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cd330bba94c5bd9$export$2e2bcd8739ae039);

var $9zNEc = parcelRequire("9zNEc");
var $4cd330bba94c5bd9$export$2e2bcd8739ae039 = function(value) {
    return Array.isArray ? Array.isArray(value) : (0, $9zNEc.default)(value, 'Array');
};

});

parcelRegister("lpEUi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f96baa0bc50d609b$export$2e2bcd8739ae039);
var $f96baa0bc50d609b$export$2e2bcd8739ae039 = function(value) {
    /**
     * isObject({}) => true
     * isObject([1, 2, 3]) => true
     * isObject(Function) => true
     * isObject(null) => false
     */ var type = typeof value;
    return value !== null && type === 'object' || type === 'function';
};

});




parcelRegister("7HG7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $59bd3a326036bfb6$export$2e2bcd8739ae039);

var $5D4TN = parcelRequire("5D4TN");

var $9zNEc = parcelRequire("9zNEc");
var $59bd3a326036bfb6$var$isPlainObject = function(value) {
    /**
     * isObjectLike(new Foo) => false
     * isObjectLike([1, 2, 3]) => false
     * isObjectLike({ x: 0, y: 0 }) => true
     * isObjectLike(Object.create(null)) => true
     */ if (!(0, $5D4TN.default)(value) || !(0, $9zNEc.default)(value, 'Object')) return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
};
var $59bd3a326036bfb6$export$2e2bcd8739ae039 = $59bd3a326036bfb6$var$isPlainObject;

});
parcelRegister("5D4TN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4194651e040fad8e$export$2e2bcd8739ae039);
var $4194651e040fad8e$var$isObjectLike = function(value) {
    /**
     * isObjectLike({}) => true
     * isObjectLike([1, 2, 3]) => true
     * isObjectLike(Function) => false
     * isObjectLike(null) => false
     */ return typeof value === 'object' && value !== null;
};
var $4194651e040fad8e$export$2e2bcd8739ae039 = $4194651e040fad8e$var$isObjectLike;

});



parcelRegister("6mxnJ", function(module, exports) {
function $4a1eb1116286c5f6$var$findIndex(arr, predicate, fromIndex) {
    if (fromIndex === void 0) fromIndex = 0;
    for(var i = fromIndex; i < arr.length; i++){
        if (predicate(arr[i], i)) // 找到终止循环
        return i;
    }
    return -1;
}
var $4a1eb1116286c5f6$export$2e2bcd8739ae039 = $4a1eb1116286c5f6$var$findIndex;

});

parcelRegister("iCw9o", function(module, exports) {

var $jIDW5 = parcelRequire("jIDW5");

var $6AW7D = parcelRequire("6AW7D");
var $d8e4b700aa2edb3b$var$firstValue = function(data, name) {
    var rst = null;
    for(var i = 0; i < data.length; i++){
        var obj = data[i];
        var value = obj[name];
        if (!(0, $jIDW5.default)(value)) {
            if ((0, $6AW7D.default)(value)) rst = value[0]; // todo 这里是否应该使用递归，调用 firstValue @绝云
            else rst = value;
            break;
        }
    }
    return rst;
};
var $d8e4b700aa2edb3b$export$2e2bcd8739ae039 = $d8e4b700aa2edb3b$var$firstValue;

});

parcelRegister("9XEVT", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");
/**
 * Flattens `array` a single level deep.
 *
 * @param {Array} arr The array to flatten.
 * @return {Array} Returns the new flattened array.
 * @example
 *
 * flatten([1, [2, [3, [4]], 5]]);  // => [1, 2, [3, [4]], 5]
 */ var $74096020fd16a16b$var$flatten = function(arr) {
    if (!(0, $6AW7D.default)(arr)) return [];
    var rst = [];
    for(var i = 0; i < arr.length; i++)rst = rst.concat(arr[i]);
    return rst;
};
var $74096020fd16a16b$export$2e2bcd8739ae039 = $74096020fd16a16b$var$flatten;

});

parcelRegister("6ZbJQ", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");
/**
 * Flattens `array` a single level deep.
 *
 * @param {Array} arr The array to flatten.
 * @param {Array} result The array to return.
 * @return {Array} Returns the new flattened array.
 * @example
 *
 * flattenDeep([1, [2, [3, [4]], 5]]);  // => [1, 2, 3, 4, 5]
 */ var $51618b91a0c3eddf$var$flattenDeep = function(arr, result) {
    if (result === void 0) result = [];
    if (!(0, $6AW7D.default)(arr)) result.push(arr);
    else for(var i = 0; i < arr.length; i += 1)$51618b91a0c3eddf$var$flattenDeep(arr[i], result);
    return result;
};
var $51618b91a0c3eddf$export$2e2bcd8739ae039 = $51618b91a0c3eddf$var$flattenDeep;

});

parcelRegister("1vJQN", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");

var $e7vqY = parcelRequire("e7vqY");

var $3vI9l = parcelRequire("3vI9l");
var $119c40a8f00554e0$var$getRange = function(values) {
    // 存在 NaN 时，min,max 判定会出问题
    var filterValues = values.filter(function(v) {
        return !isNaN(v);
    });
    if (!filterValues.length) // 如果没有数值则直接返回0
    return {
        min: 0,
        max: 0
    };
    if ((0, $6AW7D.default)(values[0])) {
        var tmp = [];
        for(var i = 0; i < values.length; i++)tmp = tmp.concat(values[i]);
        filterValues = tmp;
    }
    var max = (0, $e7vqY.default)(filterValues);
    var min = (0, $3vI9l.default)(filterValues);
    return {
        min: min,
        max: max
    };
};
var $119c40a8f00554e0$export$2e2bcd8739ae039 = $119c40a8f00554e0$var$getRange;

});
parcelRegister("e7vqY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a47a1a4753db32c0$export$2e2bcd8739ae039);

var $6AW7D = parcelRequire("6AW7D");
var /**
 * @param {Array} arr The array to iterate over.
 * @return {*} Returns the maximum value.
 * @example
 *
 * max([1, 2]);
 * // => 2
 *
 * max([]);
 * // => undefined
 *
 * const data = new Array(1250010).fill(1).map((d,idx) => idx);
 *
 * max(data);
 * // => 1250010
 * // Math.max(...data) will encounter "Maximum call stack size exceeded" error
 */ $a47a1a4753db32c0$export$2e2bcd8739ae039 = function(arr) {
    if (!(0, $6AW7D.default)(arr)) return undefined;
    return arr.reduce(function(prev, curr) {
        return Math.max(prev, curr);
    }, arr[0]);
};

});

parcelRegister("3vI9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e68395c9587fdd$export$2e2bcd8739ae039);

var $6AW7D = parcelRequire("6AW7D");
var /**
 * @param {Array} arr The array to iterate over.
 * @return {*} Returns the minimum value.
 * @example
 *
 * min([1, 2]);
 * // => 1
 *
 * min([]);
 * // => undefined
 *
 * const data = new Array(1250010).fill(1).map((d,idx) => idx);
 *
 * min(data);
 * // => 1250010
 * // Math.min(...data) will encounter "Maximum call stack size exceeded" error
 */ $28e68395c9587fdd$export$2e2bcd8739ae039 = function(arr) {
    if (!(0, $6AW7D.default)(arr)) return undefined;
    return arr.reduce(function(prev, curr) {
        return Math.min(prev, curr);
    }, arr[0]);
};

});


parcelRegister("iM0nB", function(module, exports) {
var $daad011b4c55b66b$var$arrPrototype = Array.prototype;
var $daad011b4c55b66b$var$splice = $daad011b4c55b66b$var$arrPrototype.splice;
var $daad011b4c55b66b$var$indexOf = $daad011b4c55b66b$var$arrPrototype.indexOf;
var $daad011b4c55b66b$var$pull = function(arr) {
    var values = [];
    for(var _i = 1; _i < arguments.length; _i++)values[_i - 1] = arguments[_i];
    for(var i = 0; i < values.length; i++){
        var value = values[i];
        var fromIndex = -1;
        while((fromIndex = $daad011b4c55b66b$var$indexOf.call(arr, value)) > -1)$daad011b4c55b66b$var$splice.call(arr, fromIndex, 1);
    }
    return arr;
};
var $daad011b4c55b66b$export$2e2bcd8739ae039 = $daad011b4c55b66b$var$pull;

});

parcelRegister("iw7pQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $037a98a451aa577b$export$2e2bcd8739ae039);

var $6cclF = parcelRequire("6cclF");
var $037a98a451aa577b$var$splice = Array.prototype.splice;
var $037a98a451aa577b$var$pullAt = function pullAt(arr, indexes) {
    if (!(0, $6cclF.default)(arr)) return [];
    var length = arr ? indexes.length : 0;
    var last = length - 1;
    while(length--){
        var previous = void 0;
        var index = indexes[length];
        if (length === last || index !== previous) {
            previous = index;
            $037a98a451aa577b$var$splice.call(arr, index, 1);
        }
    }
    return arr;
};
var $037a98a451aa577b$export$2e2bcd8739ae039 = $037a98a451aa577b$var$pullAt;

});

parcelRegister("lJerm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd190083114e73a2$export$2e2bcd8739ae039);

var $xl7tx = parcelRequire("xl7tx");

var $6AW7D = parcelRequire("6AW7D");

var $7HG7Y = parcelRequire("7HG7Y");
var $fd190083114e73a2$var$reduce = function(arr, fn, init) {
    if (!(0, $6AW7D.default)(arr) && !(0, $7HG7Y.default)(arr)) return arr;
    var result = init;
    (0, $xl7tx.default)(arr, function(data, i) {
        result = fn(result, data, i);
    });
    return result;
};
var $fd190083114e73a2$export$2e2bcd8739ae039 = $fd190083114e73a2$var$reduce;

});

parcelRegister("2NAVm", function(module, exports) {

var $6cclF = parcelRequire("6cclF");

var $iw7pQ = parcelRequire("iw7pQ");
var $209cccb921021ecd$var$remove = function(arr, predicate) {
    /**
     * const arr = [1, 2, 3, 4]
     * const evens = remove(arr, n => n % 2 == 0)
     * console.log(arr) // => [1, 3]
     * console.log(evens) // => [2, 4]
     */ var result = [];
    if (!(0, $6cclF.default)(arr)) return result;
    var i = -1;
    var indexes = [];
    var length = arr.length;
    while(++i < length){
        var value = arr[i];
        if (predicate(value, i, arr)) {
            result.push(value);
            indexes.push(i);
        }
    }
    (0, $iw7pQ.default)(arr, indexes);
    return result;
};
var $209cccb921021ecd$export$2e2bcd8739ae039 = $209cccb921021ecd$var$remove;

});

parcelRegister("2dSZs", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");

var $kUSxU = parcelRequire("kUSxU");

var $hOSFC = parcelRequire("hOSFC");
function $19e773924ae9c1f1$var$sortBy(arr, key) {
    var comparer;
    if ((0, $hOSFC.default)(key)) comparer = function(a, b) {
        return key(a) - key(b);
    };
    else {
        var keys_1 = [];
        if ((0, $kUSxU.default)(key)) keys_1.push(key);
        else if ((0, $6AW7D.default)(key)) keys_1 = key;
        comparer = function(a, b) {
            for(var i = 0; i < keys_1.length; i += 1){
                var prop = keys_1[i];
                if (a[prop] > b[prop]) return 1;
                if (a[prop] < b[prop]) return -1;
            }
            return 0;
        };
    }
    arr.sort(comparer);
    return arr;
}
var $19e773924ae9c1f1$export$2e2bcd8739ae039 = $19e773924ae9c1f1$var$sortBy;

});
parcelRegister("kUSxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3a3594e1771f939$export$2e2bcd8739ae039);

var $9zNEc = parcelRequire("9zNEc");
var $f3a3594e1771f939$export$2e2bcd8739ae039 = function(str) {
    return (0, $9zNEc.default)(str, 'String');
};

});


parcelRegister("27Xcg", function(module, exports) {

var $joF99 = parcelRequire("joF99");
var $18ca2774d072f08c$var$union = function() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return (0, $joF99.default)([].concat.apply([], sources));
};
var $18ca2774d072f08c$export$2e2bcd8739ae039 = $18ca2774d072f08c$var$union;

});
parcelRegister("joF99", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f02d0f09336e92$export$2e2bcd8739ae039);
function $e1f02d0f09336e92$export$2e2bcd8739ae039(arr, cache) {
    if (cache === void 0) cache = new Map();
    var r = [];
    if (Array.isArray(arr)) for(var i = 0, len = arr.length; i < len; i++){
        var item = arr[i];
        // 加一个 cache，提升性能
        if (!cache.has(item)) {
            r.push(item);
            cache.set(item, true);
        }
    }
    return r;
}

});


parcelRegister("5ERcR", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");

var $jIDW5 = parcelRequire("jIDW5");
var $41e9f5dd32a88d65$export$2e2bcd8739ae039 = function(data, name) {
    var rst = [];
    var tmpMap = {};
    for(var i = 0; i < data.length; i++){
        var obj = data[i];
        var value = obj[name];
        if (!(0, $jIDW5.default)(value)) {
            // flatten
            if (!(0, $6AW7D.default)(value)) value = [
                value
            ];
            for(var j = 0; j < value.length; j++){
                var val = value[j];
                // unique
                if (!tmpMap[val]) {
                    rst.push(val);
                    tmpMap[val] = true;
                }
            }
        }
    }
    return rst;
};

});

parcelRegister("e41rm", function(module, exports) {

var $6cclF = parcelRequire("6cclF");
function $a3d28e6e9be58c65$export$2e2bcd8739ae039(o) {
    if ((0, $6cclF.default)(o)) return o[0];
    return undefined;
}

});

parcelRegister("6dLVr", function(module, exports) {

var $6cclF = parcelRequire("6cclF");
function $487921f3b5c01dd0$export$2e2bcd8739ae039(o) {
    if ((0, $6cclF.default)(o)) {
        var arr = o;
        return arr[arr.length - 1];
    }
    return undefined;
}

});

parcelRegister("6qJyH", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");

var $kUSxU = parcelRequire("kUSxU");
function $4ae882c4e5906f71$var$startsWith(arr, e) {
    return (0, $6AW7D.default)(arr) || (0, $kUSxU.default)(arr) ? arr[0] === e : false;
}
var $4ae882c4e5906f71$export$2e2bcd8739ae039 = $4ae882c4e5906f71$var$startsWith;

});

parcelRegister("6tCaZ", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");

var $kUSxU = parcelRequire("kUSxU");
function $4b73108aaa8e74ff$var$endsWith(arr, e) {
    return (0, $6AW7D.default)(arr) || (0, $kUSxU.default)(arr) ? arr[arr.length - 1] === e : false;
}
var $4b73108aaa8e74ff$export$2e2bcd8739ae039 = $4b73108aaa8e74ff$var$endsWith;

});

parcelRegister("bJRwr", function(module, exports) {
/**
 * 只要有一个不满足条件就返回 false
 * @param arr
 * @param func
 */ var $88bd6a15fbb00e43$var$every = function(arr, func) {
    for(var i = 0; i < arr.length; i++){
        if (!func(arr[i], i)) return false;
    }
    return true;
};
var $88bd6a15fbb00e43$export$2e2bcd8739ae039 = $88bd6a15fbb00e43$var$every;

});

parcelRegister("80kOr", function(module, exports) {
/**
 * 只要有一个满足条件就返回 true
 * @param arr
 * @param func
 */ var $5d3e77c2230794b1$var$some = function(arr, func) {
    for(var i = 0; i < arr.length; i++){
        if (func(arr[i], i)) return true;
    }
    return false;
};
var $5d3e77c2230794b1$export$2e2bcd8739ae039 = $5d3e77c2230794b1$var$some;

});

parcelRegister("9CxL4", function(module, exports) {

var $dVWs5 = parcelRequire("dVWs5");
var $7011d95569a6419c$export$2e2bcd8739ae039 = function(data, condition) {
    if (!condition) // 没有条件，则自身改成数组
    return [
        data
    ];
    var groups = (0, $dVWs5.default)(data, condition);
    var array = [];
    for(var i in groups)array.push(groups[i]);
    return array;
};

});
parcelRegister("dVWs5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a24df09c37c43254$export$2e2bcd8739ae039);

var $6AW7D = parcelRequire("6AW7D");

var $hOSFC = parcelRequire("hOSFC");

var $2gCl3 = parcelRequire("2gCl3");
function $a24df09c37c43254$export$2e2bcd8739ae039(data, condition) {
    if (!condition) return {
        0: data
    };
    if (!(0, $hOSFC.default)(condition)) {
        // 如果是字符串，则按照 a*b 风格成数组
        var paramscondition_1 = (0, $6AW7D.default)(condition) ? condition : condition.replace(/\s+/g, '').split('*');
        condition = function(row) {
            var unique = '_'; // 避免出现数字作为Key的情况，会进行按照数字的排序
            // 根据字段列表的值，拼接成 key
            for(var i = 0, l = paramscondition_1.length; i < l; i++)unique += row[paramscondition_1[i]] && row[paramscondition_1[i]].toString();
            return unique;
        };
    }
    return (0, $2gCl3.default)(data, condition);
}

});
parcelRegister("2gCl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a6ad0a2fc70e14b$export$2e2bcd8739ae039);

var $6AW7D = parcelRequire("6AW7D");

var $hOSFC = parcelRequire("hOSFC");
var $1a6ad0a2fc70e14b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $1a6ad0a2fc70e14b$var$groupBy(data, condition) {
    if (!condition || !(0, $6AW7D.default)(data)) return {};
    var result = {};
    // 兼容方法和 字符串的写法
    var predicate = (0, $hOSFC.default)(condition) ? condition : function(item) {
        return item[condition];
    };
    var key;
    for(var i = 0; i < data.length; i++){
        var item = data[i];
        key = predicate(item);
        if ($1a6ad0a2fc70e14b$var$hasOwnProperty.call(result, key)) result[key].push(item);
        else result[key] = [
            item
        ];
    }
    return result;
}
var $1a6ad0a2fc70e14b$export$2e2bcd8739ae039 = $1a6ad0a2fc70e14b$var$groupBy;

});



parcelRegister("jzFiR", function(module, exports) {
/**
 * 获取封装的事件
 * @protected
 * @param  {Object} obj   对象
 * @param  {String} action 事件名称
 * @return {Function}        返回事件处理函数
 */ function $e40153284c8a1de2$var$getWrapBehavior(obj, action) {
    return obj['_wrap_' + action];
}
var $e40153284c8a1de2$export$2e2bcd8739ae039 = $e40153284c8a1de2$var$getWrapBehavior;

});

parcelRegister("1csIr", function(module, exports) {
/**
 * 封装事件，便于使用上下文this,和便于解除事件时使用
 * @protected
 * @param  {Object} obj   对象
 * @param  {String} action 事件名称
 * @return {Function}        返回事件处理函数
 */ function $0dfd2fc7ca234ee5$var$wrapBehavior(obj, action) {
    if (obj['_wrap_' + action]) return obj['_wrap_' + action];
    var method = function(e) {
        obj[action](e);
    };
    obj['_wrap_' + action] = method;
    return method;
}
var $0dfd2fc7ca234ee5$export$2e2bcd8739ae039 = $0dfd2fc7ca234ee5$var$wrapBehavior;

});

parcelRegister("6K38v", function(module, exports) {
var $4e8978b97ccfae9f$var$numColorCache = {};
function $4e8978b97ccfae9f$var$numberToColor(num) {
    // 增加缓存
    var color = $4e8978b97ccfae9f$var$numColorCache[num];
    if (!color) {
        var str = num.toString(16);
        for(var i = str.length; i < 6; i++)str = '0' + str;
        color = '#' + str;
        $4e8978b97ccfae9f$var$numColorCache[num] = color;
    }
    return color;
}
var $4e8978b97ccfae9f$export$2e2bcd8739ae039 = $4e8978b97ccfae9f$var$numberToColor;

});

parcelRegister("2uPTj", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");
function $1d16a299308bf4d7$var$parseRadius(radius) {
    var r1 = 0, r2 = 0, r3 = 0, r4 = 0;
    if ((0, $6AW7D.default)(radius)) {
        if (radius.length === 1) r1 = r2 = r3 = r4 = radius[0];
        else if (radius.length === 2) {
            r1 = r3 = radius[0];
            r2 = r4 = radius[1];
        } else if (radius.length === 3) {
            r1 = radius[0];
            r2 = r4 = radius[1];
            r3 = radius[2];
        } else {
            r1 = radius[0];
            r2 = radius[1];
            r3 = radius[2];
            r4 = radius[3];
        }
    } else r1 = r2 = r3 = r4 = radius;
    return {
        r1: r1,
        r2: r2,
        r3: r3,
        r4: r4
    };
}
var $1d16a299308bf4d7$export$2e2bcd8739ae039 = $1d16a299308bf4d7$var$parseRadius;

});

parcelRegister("j7Zw1", function(module, exports) {
var $dece637bbfc7265f$var$clamp = function(a, min, max) {
    if (a < min) return min;
    else if (a > max) return max;
    return a;
};
var $dece637bbfc7265f$export$2e2bcd8739ae039 = $dece637bbfc7265f$var$clamp;

});

parcelRegister("cN6lF", function(module, exports) {
var $94fefc4f62f3e00c$var$fixedBase = function(v, base) {
    var str = base.toString();
    var index = str.indexOf('.');
    if (index === -1) return Math.round(v);
    var length = str.substr(index + 1).length;
    if (length > 20) length = 20;
    return parseFloat(v.toFixed(length));
};
var $94fefc4f62f3e00c$export$2e2bcd8739ae039 = $94fefc4f62f3e00c$var$fixedBase;

});

parcelRegister("lDEwq", function(module, exports) {

var $6aSlm = parcelRequire("6aSlm");
var $fc0cac4abebc0dd1$var$isDecimal = function(num) {
    return (0, $6aSlm.default)(num) && num % 1 !== 0;
};
var $fc0cac4abebc0dd1$export$2e2bcd8739ae039 = $fc0cac4abebc0dd1$var$isDecimal;

});
parcelRegister("6aSlm", function(module, exports) {

$parcel$export(module.exports, "default", () => $47edd4c45a579e0e$export$2e2bcd8739ae039);
/**
 * 判断是否数字
 * @return {Boolean} 是否数字
 */ 
var $9zNEc = parcelRequire("9zNEc");
var $47edd4c45a579e0e$var$isNumber = function(value) {
    return (0, $9zNEc.default)(value, 'Number');
};
var $47edd4c45a579e0e$export$2e2bcd8739ae039 = $47edd4c45a579e0e$var$isNumber;

});


parcelRegister("avKEZ", function(module, exports) {

var $6aSlm = parcelRequire("6aSlm");
var $7a70fe60910786dc$var$isEven = function(num) {
    return (0, $6aSlm.default)(num) && num % 2 === 0;
};
var $7a70fe60910786dc$export$2e2bcd8739ae039 = $7a70fe60910786dc$var$isEven;

});

parcelRegister("6fjDQ", function(module, exports) {

var $6aSlm = parcelRequire("6aSlm");
var $48c36139acb6ba73$var$isInteger = Number.isInteger ? Number.isInteger : function(num) {
    return (0, $6aSlm.default)(num) && num % 1 === 0;
};
var $48c36139acb6ba73$export$2e2bcd8739ae039 = $48c36139acb6ba73$var$isInteger;

});

parcelRegister("6Nrz2", function(module, exports) {

var $6aSlm = parcelRequire("6aSlm");
var $4f2cb3585b7f90e8$var$isNegative = function(num) {
    return (0, $6aSlm.default)(num) && num < 0;
};
var $4f2cb3585b7f90e8$export$2e2bcd8739ae039 = $4f2cb3585b7f90e8$var$isNegative;

});

parcelRegister("3gcQx", function(module, exports) {
var $25fcd4bb7fa507fa$var$PRECISION = 0.00001; // numbers less than this is considered as 0
function $25fcd4bb7fa507fa$export$2e2bcd8739ae039(a, b, precision) {
    if (precision === void 0) precision = $25fcd4bb7fa507fa$var$PRECISION;
    return Math.abs(a - b) < precision;
}

});

parcelRegister("gV2ND", function(module, exports) {

var $6aSlm = parcelRequire("6aSlm");
var $c514242502b2c86e$var$isOdd = function(num) {
    return (0, $6aSlm.default)(num) && num % 2 !== 0;
};
var $c514242502b2c86e$export$2e2bcd8739ae039 = $c514242502b2c86e$var$isOdd;

});

parcelRegister("lcTyG", function(module, exports) {

var $6aSlm = parcelRequire("6aSlm");
var $f705d0b2226b4fa5$var$isPositive = function(num) {
    return (0, $6aSlm.default)(num) && num > 0;
};
var $f705d0b2226b4fa5$export$2e2bcd8739ae039 = $f705d0b2226b4fa5$var$isPositive;

});

parcelRegister("7IIpG", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");

var $hOSFC = parcelRequire("hOSFC");
var /**
 * @param {Array} arr The array to iterate over.
 * @param {Function} [fn] The iteratee invoked per element.
 * @return {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ $59ef1807b9853cd5$export$2e2bcd8739ae039 = function(arr, fn) {
    if (!(0, $6AW7D.default)(arr)) return undefined;
    var maxItem;
    var max = -Infinity;
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        var v = (0, $hOSFC.default)(fn) ? fn(item) : item[fn];
        if (v > max) {
            maxItem = item;
            max = v;
        }
    }
    return maxItem;
};

});

parcelRegister("1q9NJ", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");

var $hOSFC = parcelRequire("hOSFC");
var /**
 * @param {Array} arr The array to iterate over.
 * @param {Function} [fn] The iteratee invoked per element.
 * @return {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * minBy(objects, 'n');
 * // => { 'n': 1 }
 */ $108fd27382f53525$export$2e2bcd8739ae039 = function(arr, fn) {
    if (!(0, $6AW7D.default)(arr)) return undefined;
    var minItem;
    var min = Infinity;
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        var v = (0, $hOSFC.default)(fn) ? fn(item) : item[fn];
        if (v < min) {
            minItem = item;
            min = v;
        }
    }
    return minItem;
};

});

parcelRegister("4B9Bv", function(module, exports) {
var $3592114a3df09661$var$mod = function(n, m) {
    return (n % m + m) % m;
};
var $3592114a3df09661$export$2e2bcd8739ae039 = $3592114a3df09661$var$mod;

});

parcelRegister("kNUye", function(module, exports) {
var $f25440209c6d153d$var$DEGREE = 180 / Math.PI;
var $f25440209c6d153d$var$toDegree = function(radian) {
    return $f25440209c6d153d$var$DEGREE * radian;
};
var $f25440209c6d153d$export$2e2bcd8739ae039 = $f25440209c6d153d$var$toDegree;

});

parcelRegister("cYhPO", function(module, exports) {
var $9718ec3d3aa7d39f$export$2e2bcd8739ae039 = parseInt;

});

parcelRegister("fcCKh", function(module, exports) {
var $b116080a4f7e3c74$var$RADIAN = Math.PI / 180;
var $b116080a4f7e3c74$var$toRadian = function(degree) {
    return $b116080a4f7e3c74$var$RADIAN * degree;
};
var $b116080a4f7e3c74$export$2e2bcd8739ae039 = $b116080a4f7e3c74$var$toRadian;

});

parcelRegister("5RwDt", function(module, exports) {

var $xl7tx = parcelRequire("xl7tx");
var $444b37c2bd44c482$export$2e2bcd8739ae039 = (0, $xl7tx.default);

});

parcelRegister("8AtwK", function(module, exports) {

$parcel$export(module.exports, "default", () => $640896fd134a80df$export$2e2bcd8739ae039);
var $640896fd134a80df$export$2e2bcd8739ae039 = function(obj, key) {
    return obj.hasOwnProperty(key);
};

});

parcelRegister("jsfXd", function(module, exports) {

var $8AtwK = parcelRequire("8AtwK");
var $e29d0200db53bfb4$export$2e2bcd8739ae039 = (0, $8AtwK.default);

});

parcelRegister("9b509", function(module, exports) {

var $kg42L = parcelRequire("kg42L");

var $eCWeh = parcelRequire("eCWeh");
var $6ae9054e27fdf13a$export$2e2bcd8739ae039 = function(obj, value) {
    return (0, $kg42L.default)((0, $eCWeh.default)(obj), value);
};

});
parcelRegister("eCWeh", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa61c871d6c59ea7$export$2e2bcd8739ae039);

var $xl7tx = parcelRequire("xl7tx");

var $hOSFC = parcelRequire("hOSFC");
// @ts-ignore
var $aa61c871d6c59ea7$var$values = Object.values ? function(obj) {
    return Object.values(obj);
} : function(obj) {
    var result = [];
    (0, $xl7tx.default)(obj, function(value, key) {
        if (!((0, $hOSFC.default)(obj) && key === 'prototype')) result.push(value);
    });
    return result;
};
var $aa61c871d6c59ea7$export$2e2bcd8739ae039 = $aa61c871d6c59ea7$var$values;

});


parcelRegister("eCn6a", function(module, exports) {

var $cSzQA = parcelRequire("cSzQA");
var $aa468827f1dbb8aa$var$lowerCase = function(str) {
    return (0, $cSzQA.default)(str).toLowerCase();
};
var $aa468827f1dbb8aa$export$2e2bcd8739ae039 = $aa468827f1dbb8aa$var$lowerCase;

});
parcelRegister("cSzQA", function(module, exports) {

$parcel$export(module.exports, "default", () => $960655aa1cc2e896$export$2e2bcd8739ae039);

var $jIDW5 = parcelRequire("jIDW5");
var $960655aa1cc2e896$export$2e2bcd8739ae039 = function(value) {
    if ((0, $jIDW5.default)(value)) return '';
    return value.toString();
};

});


parcelRegister("FpM3Q", function(module, exports) {

var $cSzQA = parcelRequire("cSzQA");
var $07c7d2aa20cf1083$var$lowerFirst = function(value) {
    var str = (0, $cSzQA.default)(value);
    return str.charAt(0).toLowerCase() + str.substring(1);
};
var $07c7d2aa20cf1083$export$2e2bcd8739ae039 = $07c7d2aa20cf1083$var$lowerFirst;

});

parcelRegister("6PXV1", function(module, exports) {
function $4fa5fc1fbbda684f$var$substitute(str, o) {
    if (!str || !o) return str;
    return str.replace(/\\?\{([^{}]+)\}/g, function(match, name) {
        if (match.charAt(0) === '\\') return match.slice(1);
        return o[name] === undefined ? '' : o[name];
    });
}
var $4fa5fc1fbbda684f$export$2e2bcd8739ae039 = $4fa5fc1fbbda684f$var$substitute;

});

parcelRegister("dOASN", function(module, exports) {

var $cSzQA = parcelRequire("cSzQA");
var $a0ec8e07cdbbc022$var$upperCase = function(str) {
    return (0, $cSzQA.default)(str).toUpperCase();
};
var $a0ec8e07cdbbc022$export$2e2bcd8739ae039 = $a0ec8e07cdbbc022$var$upperCase;

});

parcelRegister("kdJVf", function(module, exports) {

var $cSzQA = parcelRequire("cSzQA");
var $eb88a4be48743eee$var$upperFirst = function(value) {
    var str = (0, $cSzQA.default)(value);
    return str.charAt(0).toUpperCase() + str.substring(1);
};
var $eb88a4be48743eee$export$2e2bcd8739ae039 = $eb88a4be48743eee$var$upperFirst;

});

parcelRegister("gpLeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf339fa975e921a3$export$2e2bcd8739ae039);
var $bf339fa975e921a3$var$toString = {}.toString;
var $bf339fa975e921a3$var$getType = function(value) {
    return $bf339fa975e921a3$var$toString.call(value).replace(/^\[object /, '').replace(/]$/, '');
};
var $bf339fa975e921a3$export$2e2bcd8739ae039 = $bf339fa975e921a3$var$getType;

});

parcelRegister("celsA", function(module, exports) {
/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */ 
var $9zNEc = parcelRequire("9zNEc");
var $8e77705d35deefd3$var$isArguments = function(value) {
    return (0, $9zNEc.default)(value, 'Arguments');
};
var $8e77705d35deefd3$export$2e2bcd8739ae039 = $8e77705d35deefd3$var$isArguments;

});

parcelRegister("Nny3m", function(module, exports) {
/**
 * 是否是布尔类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */ 
var $9zNEc = parcelRequire("9zNEc");
var $0946d7e89f343f86$var$isBoolean = function(value) {
    return (0, $9zNEc.default)(value, 'Boolean');
};
var $0946d7e89f343f86$export$2e2bcd8739ae039 = $0946d7e89f343f86$var$isBoolean;

});

parcelRegister("hfO0E", function(module, exports) {

var $9zNEc = parcelRequire("9zNEc");
var $c8faa1386b47a7ea$var$isDate = function(value) {
    return (0, $9zNEc.default)(value, 'Date');
};
var $c8faa1386b47a7ea$export$2e2bcd8739ae039 = $c8faa1386b47a7ea$var$isDate;

});

parcelRegister("i2KdO", function(module, exports) {
/**
 * 是否是参数类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */ 
var $9zNEc = parcelRequire("9zNEc");
var $d22c4493939a5c06$var$isError = function(value) {
    return (0, $9zNEc.default)(value, 'Error');
};
var $d22c4493939a5c06$export$2e2bcd8739ae039 = $d22c4493939a5c06$var$isError;

});

parcelRegister("oJw8u", function(module, exports) {
/**
 * 判断是否为有限数
 * @return {Boolean}
 */ 
var $6aSlm = parcelRequire("6aSlm");
function $04a58ccc2f115bfd$export$2e2bcd8739ae039(value) {
    return (0, $6aSlm.default)(value) && isFinite(value);
}

});

parcelRegister("hdErz", function(module, exports) {
var $c89305d6053a1ad8$var$isNull = function(value) {
    return value === null;
};
var $c89305d6053a1ad8$export$2e2bcd8739ae039 = $c89305d6053a1ad8$var$isNull;

});

parcelRegister("7wRhs", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b4d9f7e21c5df8$export$2e2bcd8739ae039);
var $57b4d9f7e21c5df8$var$objectProto = Object.prototype;
var $57b4d9f7e21c5df8$var$isPrototype = function(value) {
    var Ctor = value && value.constructor;
    var proto = typeof Ctor === 'function' && Ctor.prototype || $57b4d9f7e21c5df8$var$objectProto;
    return value === proto;
};
var $57b4d9f7e21c5df8$export$2e2bcd8739ae039 = $57b4d9f7e21c5df8$var$isPrototype;

});

parcelRegister("ic1YK", function(module, exports) {

var $9zNEc = parcelRequire("9zNEc");
var $d3eae1ecf46dcb0d$var$isRegExp = function(str) {
    return (0, $9zNEc.default)(str, 'RegExp');
};
var $d3eae1ecf46dcb0d$export$2e2bcd8739ae039 = $d3eae1ecf46dcb0d$var$isRegExp;

});

parcelRegister("3eHQ8", function(module, exports) {
var $25b4af99db1800b7$var$isUndefined = function(value) {
    return value === undefined;
};
var $25b4af99db1800b7$export$2e2bcd8739ae039 = $25b4af99db1800b7$var$isUndefined;

});

parcelRegister("a96cp", function(module, exports) {
/**
 * 判断是否HTML元素
 * @return {Boolean} 是否HTML元素
 */ var $762f8daac7e1dd90$var$isElement = function(o) {
    return o instanceof Element || o instanceof HTMLDocument;
};
var $762f8daac7e1dd90$export$2e2bcd8739ae039 = $762f8daac7e1dd90$var$isElement;

});

parcelRegister("glACs", function(module, exports) {
function $be6b0352f998966d$export$2e2bcd8739ae039(fn) {
    var method = window.requestAnimationFrame || window.webkitRequestAnimationFrame || // @ts-ignore
    window.mozRequestAnimationFrame || // @ts-ignore
    window.msRequestAnimationFrame || function(f) {
        return setTimeout(f, 16);
    };
    return method(fn);
}

});

parcelRegister("4eENJ", function(module, exports) {
function $31581e807aadecf1$export$2e2bcd8739ae039(handler) {
    var method = window.cancelAnimationFrame || window.webkitCancelAnimationFrame || // @ts-ignore
    window.mozCancelAnimationFrame || // @ts-ignore
    window.msCancelAnimationFrame || clearTimeout;
    method(handler);
}

});

parcelRegister("71j8U", function(module, exports) {

var $dIthL = parcelRequire("dIthL");

var $hOSFC = parcelRequire("hOSFC");
var $51c779bebb81ee56$var$augment = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var c = args[0];
    for(var i = 1; i < args.length; i++){
        var obj = args[i];
        if ((0, $hOSFC.default)(obj)) obj = obj.prototype;
        (0, $dIthL.default)(c.prototype, obj);
    }
};
var $51c779bebb81ee56$export$2e2bcd8739ae039 = $51c779bebb81ee56$var$augment;

});
parcelRegister("dIthL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fc619e8859d469f$export$2e2bcd8739ae039);
// FIXME: Mutable param should be forbidden in static lang.
function $9fc619e8859d469f$var$_mix(dist, obj) {
    for(var key in obj)if (obj.hasOwnProperty(key) && key !== 'constructor' && obj[key] !== undefined) dist[key] = obj[key];
}
function $9fc619e8859d469f$export$2e2bcd8739ae039(dist, src1, src2, src3) {
    if (src1) $9fc619e8859d469f$var$_mix(dist, src1);
    if (src2) $9fc619e8859d469f$var$_mix(dist, src2);
    if (src3) $9fc619e8859d469f$var$_mix(dist, src3);
    return dist;
}

});


parcelRegister("glsCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $be64ce7bc759c7a0$export$2e2bcd8739ae039);

var $6AW7D = parcelRequire("6AW7D");
var $be64ce7bc759c7a0$var$clone = function(obj) {
    if (typeof obj !== 'object' || obj === null) return obj;
    var rst;
    if ((0, $6AW7D.default)(obj)) {
        rst = [];
        for(var i = 0, l = obj.length; i < l; i++)if (typeof obj[i] === 'object' && obj[i] != null) rst[i] = $be64ce7bc759c7a0$var$clone(obj[i]);
        else rst[i] = obj[i];
    } else {
        rst = {};
        for(var k in obj)if (typeof obj[k] === 'object' && obj[k] != null) rst[k] = $be64ce7bc759c7a0$var$clone(obj[k]);
        else rst[k] = obj[k];
    }
    return rst;
};
var $be64ce7bc759c7a0$export$2e2bcd8739ae039 = $be64ce7bc759c7a0$var$clone;

});

parcelRegister("4Igwi", function(module, exports) {
function $36e816002b2f2b88$var$debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
var $36e816002b2f2b88$export$2e2bcd8739ae039 = $36e816002b2f2b88$var$debounce;

});

parcelRegister("5u2qv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe1a2eead3a794f$export$2e2bcd8739ae039);

var $hOSFC = parcelRequire("hOSFC");
var /**
 * _.memoize(calColor);
 * _.memoize(calColor, (...args) => args[0]);
 * @param f
 * @param resolver
 */ $3fe1a2eead3a794f$export$2e2bcd8739ae039 = function(f, resolver) {
    if (!(0, $hOSFC.default)(f)) throw new TypeError('Expected a function');
    var memoized = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // 使用方法构造 key，如果不存在 resolver，则直接取第一个参数作为 key
        var key = resolver ? resolver.apply(this, args) : args[0];
        var cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = f.apply(this, args);
        // 缓存起来
        cache.set(key, result);
        return result;
    };
    memoized.cache = new Map();
    return memoized;
};

});

parcelRegister("kGcJF", function(module, exports) {

var $6AW7D = parcelRequire("6AW7D");

var $7HG7Y = parcelRequire("7HG7Y");
var $f0e19bea187ee494$var$MAX_MIX_LEVEL = 5;
function $f0e19bea187ee494$var$_deepMix(dist, src, level, maxLevel) {
    level = level || 0;
    maxLevel = maxLevel || $f0e19bea187ee494$var$MAX_MIX_LEVEL;
    for(var key in src)if (src.hasOwnProperty(key)) {
        var value = src[key];
        if (value !== null && (0, $7HG7Y.default)(value)) {
            if (!(0, $7HG7Y.default)(dist[key])) dist[key] = {};
            if (level < maxLevel) $f0e19bea187ee494$var$_deepMix(dist[key], value, level + 1, maxLevel);
            else dist[key] = src[key];
        } else if ((0, $6AW7D.default)(value)) {
            dist[key] = [];
            dist[key] = dist[key].concat(value);
        } else if (value !== undefined) dist[key] = value;
    }
}
// todo 重写
var $f0e19bea187ee494$var$deepMix = function(rst) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    for(var i = 0; i < args.length; i += 1)$f0e19bea187ee494$var$_deepMix(rst, args[i]);
    return rst;
};
var $f0e19bea187ee494$export$2e2bcd8739ae039 = $f0e19bea187ee494$var$deepMix;

});

parcelRegister("62I9o", function(module, exports) {

var $dIthL = parcelRequire("dIthL");

var $hOSFC = parcelRequire("hOSFC");
var $46652d5967c91250$var$extend = function(subclass, superclass, overrides, staticOverrides) {
    // 如果只提供父类构造函数，则自动生成子类构造函数
    if (!(0, $hOSFC.default)(superclass)) {
        overrides = superclass;
        superclass = subclass;
        subclass = function() {};
    }
    var create = Object.create ? function(proto, c) {
        return Object.create(proto, {
            constructor: {
                value: c
            }
        });
    } : function(proto, c) {
        function Tmp() {}
        Tmp.prototype = proto;
        var o = new Tmp();
        o.constructor = c;
        return o;
    };
    var superObj = create(superclass.prototype, subclass); // new superclass(),//实例化父类作为子类的prototype
    subclass.prototype = (0, $dIthL.default)(superObj, subclass.prototype); // 指定子类的prototype
    subclass.superclass = create(superclass.prototype, superclass);
    (0, $dIthL.default)(superObj, overrides);
    (0, $dIthL.default)(subclass, staticOverrides);
    return subclass;
};
var $46652d5967c91250$export$2e2bcd8739ae039 = $46652d5967c91250$var$extend;

});

parcelRegister("3Od90", function(module, exports) {

var $6cclF = parcelRequire("6cclF");
var $2c603cc8affec77b$var$indexOf = function(arr, obj) {
    if (!(0, $6cclF.default)(arr)) return -1;
    var m = Array.prototype.indexOf;
    if (m) return m.call(arr, obj);
    var index = -1;
    for(var i = 0; i < arr.length; i++)if (arr[i] === obj) {
        index = i;
        break;
    }
    return index;
};
var $2c603cc8affec77b$export$2e2bcd8739ae039 = $2c603cc8affec77b$var$indexOf;

});

parcelRegister("hcp8H", function(module, exports) {

var $jIDW5 = parcelRequire("jIDW5");

var $6cclF = parcelRequire("6cclF");

var $gpLeP = parcelRequire("gpLeP");

var $7wRhs = parcelRequire("7wRhs");
var $c8570ed1357e706e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $c8570ed1357e706e$var$isEmpty(value) {
    /**
     * isEmpty(null) => true
     * isEmpty() => true
     * isEmpty(true) => true
     * isEmpty(1) => true
     * isEmpty([1, 2, 3]) => false
     * isEmpty('abc') => false
     * isEmpty({ a: 1 }) => false
     */ if ((0, $jIDW5.default)(value)) return true;
    if ((0, $6cclF.default)(value)) return !value.length;
    var type = (0, $gpLeP.default)(value);
    if (type === 'Map' || type === 'Set') return !value.size;
    if ((0, $7wRhs.default)(value)) return !Object.keys(value).length;
    for(var key in value){
        if ($c8570ed1357e706e$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $c8570ed1357e706e$export$2e2bcd8739ae039 = $c8570ed1357e706e$var$isEmpty;

});

parcelRegister("950hz", function(module, exports) {

$parcel$export(module.exports, "default", () => $69c4ccc9883d28cd$export$2e2bcd8739ae039);

var $5D4TN = parcelRequire("5D4TN");

var $6cclF = parcelRequire("6cclF");

var $kUSxU = parcelRequire("kUSxU");
var $69c4ccc9883d28cd$var$isEqual = function(value, other) {
    if (value === other) return true;
    if (!value || !other) return false;
    if ((0, $kUSxU.default)(value) || (0, $kUSxU.default)(other)) return false;
    if ((0, $6cclF.default)(value) || (0, $6cclF.default)(other)) {
        if (value.length !== other.length) return false;
        var rst = true;
        for(var i = 0; i < value.length; i++){
            rst = $69c4ccc9883d28cd$var$isEqual(value[i], other[i]);
            if (!rst) break;
        }
        return rst;
    }
    if ((0, $5D4TN.default)(value) || (0, $5D4TN.default)(other)) {
        var valueKeys = Object.keys(value);
        var otherKeys = Object.keys(other);
        if (valueKeys.length !== otherKeys.length) return false;
        var rst = true;
        for(var i = 0; i < valueKeys.length; i++){
            rst = $69c4ccc9883d28cd$var$isEqual(value[valueKeys[i]], other[valueKeys[i]]);
            if (!rst) break;
        }
        return rst;
    }
    return false;
};
var $69c4ccc9883d28cd$export$2e2bcd8739ae039 = $69c4ccc9883d28cd$var$isEqual;

});

parcelRegister("CXf3B", function(module, exports) {

var $hOSFC = parcelRequire("hOSFC");

var $950hz = parcelRequire("950hz");
var /**
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [fn] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * isEqualWith(array, other, customizer);  // => true
 */ $075180ec42bc2c45$export$2e2bcd8739ae039 = function(value, other, fn) {
    if (!(0, $hOSFC.default)(fn)) return (0, $950hz.default)(value, other);
    return !!fn(value, other);
};

});

parcelRegister("8ubjB", function(module, exports) {

var $6cclF = parcelRequire("6cclF");
var $62d9e70b640109f6$var$map = function(arr, func) {
    if (!(0, $6cclF.default)(arr)) // @ts-ignore
    return arr;
    var result = [];
    for(var index = 0; index < arr.length; index++){
        var value = arr[index];
        result.push(func(value, index));
    }
    return result;
};
var $62d9e70b640109f6$export$2e2bcd8739ae039 = $62d9e70b640109f6$var$map;

});

parcelRegister("iu94x", function(module, exports) {

var $jIDW5 = parcelRequire("jIDW5");

var $lpEUi = parcelRequire("lpEUi");
var $d75210e0c17e8c3d$var$identity = function(v) {
    return v;
};
var $d75210e0c17e8c3d$export$2e2bcd8739ae039 = function(object, func) {
    if (func === void 0) func = $d75210e0c17e8c3d$var$identity;
    var r = {};
    if ((0, $lpEUi.default)(object) && !(0, $jIDW5.default)(object)) Object.keys(object).forEach(function(key) {
        // @ts-ignore
        r[key] = func(object[key], key);
    });
    return r;
};

});

parcelRegister("9DjEH", function(module, exports) {

var $kUSxU = parcelRequire("kUSxU");
var /**
 * https://github.com/developit/dlv/blob/master/index.js
 * @param obj
 * @param key
 * @param defaultValue
 */ $703700c082006758$export$2e2bcd8739ae039 = function(obj, key, defaultValue) {
    var p = 0;
    var keyArr = (0, $kUSxU.default)(key) ? key.split('.') : key;
    while(obj && p < keyArr.length)obj = obj[keyArr[p++]];
    return obj === undefined || p < keyArr.length ? defaultValue : obj;
};

});

parcelRegister("iEcRk", function(module, exports) {

var $lpEUi = parcelRequire("lpEUi");

var $kUSxU = parcelRequire("kUSxU");

var $6aSlm = parcelRequire("6aSlm");
var /**
 * https://github.com/developit/dlv/blob/master/index.js
 * @param obj
 * @param path
 * @param value
 */ $d935effc986917af$export$2e2bcd8739ae039 = function(obj, path, value) {
    var o = obj;
    var keyArr = (0, $kUSxU.default)(path) ? path.split('.') : path;
    keyArr.forEach(function(key, idx) {
        // 不是最后一个
        if (idx < keyArr.length - 1) {
            if (!(0, $lpEUi.default)(o[key])) o[key] = (0, $6aSlm.default)(keyArr[idx + 1]) ? [] : {};
            o = o[key];
        } else o[key] = value;
    });
    return obj;
};

});

parcelRegister("c2G6o", function(module, exports) {

var $xl7tx = parcelRequire("xl7tx");

var $7HG7Y = parcelRequire("7HG7Y");
var $8c46548ed6a9c04d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $8c46548ed6a9c04d$export$2e2bcd8739ae039 = function(object, keys) {
    if (object === null || !(0, $7HG7Y.default)(object)) return {};
    var result = {};
    (0, $xl7tx.default)(keys, function(key) {
        if ($8c46548ed6a9c04d$var$hasOwnProperty.call(object, key)) result[key] = object[key];
    });
    return result;
};

});

parcelRegister("l2Mfg", function(module, exports) {

var $lJerm = parcelRequire("lJerm");
var $f51f356492744817$export$2e2bcd8739ae039 = function(obj, keys) {
    return (0, $lJerm.default)(obj, function(r, curr, key) {
        if (!keys.includes(key)) r[key] = curr;
        return r;
    }, {});
};

});

parcelRegister("KQctm", function(module, exports) {
var $08ccc9dbeaeede7e$export$2e2bcd8739ae039 = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function() {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
};

});

parcelRegister("7KRXX", function(module, exports) {

var $6cclF = parcelRequire("6cclF");
var $5a56b0cc968e6272$export$2e2bcd8739ae039 = function(value) {
    return (0, $6cclF.default)(value) ? Array.prototype.slice.call(value) : [];
};

});

parcelRegister("h2Q84", function(module, exports) {
var $c68b0f54a2da5799$var$map = {};
var $c68b0f54a2da5799$export$2e2bcd8739ae039 = function(prefix) {
    prefix = prefix || 'g';
    if (!$c68b0f54a2da5799$var$map[prefix]) $c68b0f54a2da5799$var$map[prefix] = 1;
    else $c68b0f54a2da5799$var$map[prefix] += 1;
    return prefix + $c68b0f54a2da5799$var$map[prefix];
};

});

parcelRegister("3jqxH", function(module, exports) {
var $2697bc3d86665644$export$2e2bcd8739ae039 = function() {};

});

parcelRegister("8Yobk", function(module, exports) {
var $6886af49fdd0f24c$export$2e2bcd8739ae039 = function(v) {
    return v;
};

});

parcelRegister("60MOC", function(module, exports) {

var $jIDW5 = parcelRequire("jIDW5");

var $6cclF = parcelRequire("6cclF");
function $46089be5d17e9aff$export$2e2bcd8739ae039(o) {
    if ((0, $jIDW5.default)(o)) return 0;
    if ((0, $6cclF.default)(o)) return o.length;
    return Object.keys(o).length;
}

});

parcelRegister("72Zfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $52183a1216da1c17$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $eCWeh = parcelRequire("eCWeh");

var $5u2qv = parcelRequire("5u2qv");

var $kUSxU = parcelRequire("kUSxU");
var $52183a1216da1c17$var$ctx;
var /**
 * 计算文本的宽度
 */ $52183a1216da1c17$export$2e2bcd8739ae039 = (0, $5u2qv.default)(function(text, font) {
    if (font === void 0) font = {};
    var fontSize = font.fontSize, fontFamily = font.fontFamily, fontWeight = font.fontWeight, fontStyle = font.fontStyle, fontVariant = font.fontVariant;
    if (!$52183a1216da1c17$var$ctx) $52183a1216da1c17$var$ctx = document.createElement('canvas').getContext('2d');
    $52183a1216da1c17$var$ctx.font = [
        fontStyle,
        fontVariant,
        fontWeight,
        fontSize + "px",
        fontFamily
    ].join(' ');
    return $52183a1216da1c17$var$ctx.measureText((0, $kUSxU.default)(text) ? text : '').width;
}, function(text, font) {
    if (font === void 0) font = {};
    return (0, $7WQrb.__spreadArrays)([
        text
    ], (0, $eCWeh.default)(font)).join('');
});

});

parcelRegister("gFIIC", function(module, exports) {

var $kUSxU = parcelRequire("kUSxU");

var $cSzQA = parcelRequire("cSzQA");

var $72Zfb = parcelRequire("72Zfb");
var /**
 * 获取文本的 ... 文本。
 * 算法（减少每次 measureText 的长度，measureText 的性能跟字符串时间相关）：
 * 1. 先通过 STEP 逐步计算，找到最后一个小于 maxWidth 的字符串
 * 2. 然后对最后这个字符串二分计算
 * @param text 需要计算的文本, 由于历史原因 除了支持string，还支持空值,number和数组等
 * @param maxWidth 最大宽度
 * @param font 字体
 * @param str 要替换的文本
 */ $c23329d8f2aa64d4$export$2e2bcd8739ae039 = function(text, maxWidth, font, str) {
    if (str === void 0) str = '...';
    var STEP = 16; // 每次 16，调参工程师
    var PLACEHOLDER_WIDTH = (0, $72Zfb.default)(str, font);
    var leftText = !(0, $kUSxU.default)(text) ? (0, $cSzQA.default)(text) : text;
    var leftWidth = maxWidth;
    var r = []; // 最终的分段字符串
    var currentText;
    var currentWidth;
    if ((0, $72Zfb.default)(text, font) <= maxWidth) return text;
    // 首先通过 step 计算，找出最大的未超出长度的
    // eslint-disable-next-line no-constant-condition
    while(true){
        // 更新字符串
        currentText = leftText.substr(0, STEP);
        // 计算宽度
        currentWidth = (0, $72Zfb.default)(currentText, font);
        // 超出剩余宽度，则停止
        if (currentWidth + PLACEHOLDER_WIDTH > leftWidth) {
            if (currentWidth > leftWidth) break;
        }
        r.push(currentText);
        // 没有超出，则计算剩余宽度
        leftWidth -= currentWidth;
        leftText = leftText.substr(STEP);
        // 字符串整体没有超出
        if (!leftText) return r.join('');
    }
    // 最下的最后一个 STEP，使用 1 递增（用二分效果更高）
    // eslint-disable-next-line no-constant-condition
    while(true){
        // 更新字符串
        currentText = leftText.substr(0, 1);
        // 计算宽度
        currentWidth = (0, $72Zfb.default)(currentText, font);
        // 超出剩余宽度，则停止
        if (currentWidth + PLACEHOLDER_WIDTH > leftWidth) break;
        r.push(currentText);
        // 没有超出，则计算剩余宽度
        leftWidth -= currentWidth;
        leftText = leftText.substr(1);
        if (!leftText) return r.join('');
    }
    return "" + r.join('') + str;
};

});

parcelRegister("lN3iX", function(module, exports) {
/**
 * k-v 存储
 */ var $fdd0bcd0619b1e64$var$default_1 = /** @class */ function() {
    function default_1() {
        this.map = {};
    }
    default_1.prototype.has = function(key) {
        return this.map[key] !== undefined;
    };
    default_1.prototype.get = function(key, def) {
        var v = this.map[key];
        return v === undefined ? def : v;
    };
    default_1.prototype.set = function(key, value) {
        this.map[key] = value;
    };
    default_1.prototype.clear = function() {
        this.map = {};
    };
    default_1.prototype.delete = function(key) {
        delete this.map[key];
    };
    default_1.prototype.size = function() {
        return Object.keys(this.map).length;
    };
    return default_1;
}();
var $fdd0bcd0619b1e64$export$2e2bcd8739ae039 = $fdd0bcd0619b1e64$var$default_1;

});



parcelRegister("9YFSY", function(module, exports) {

$parcel$export(module.exports, "findShortestPath", () => $743a354569bbc631$export$4c6501b067ba8dbe);
$parcel$export(module.exports, "findAllPath", () => $743a354569bbc631$export$f616f3b65f3eaa2b);

var $7mzeL = parcelRequire("7mzeL");

var $lFtOT = parcelRequire("lFtOT");
var $743a354569bbc631$export$4c6501b067ba8dbe = function findShortestPath(graphData, start, end, directed, weightPropertyName) {
    var _a = (0, $7mzeL.default)(graphData, start, directed, weightPropertyName), length = _a.length, path = _a.path, allPath = _a.allPath;
    return {
        length: length[end],
        path: path[end],
        allPath: allPath[end]
    };
};
var $743a354569bbc631$export$f616f3b65f3eaa2b = function findAllPath(graphData, start, end, directed) {
    var _a;
    if (start === end) return [
        [
            start
        ]
    ];
    var _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    var visited = [
        start
    ];
    var isVisited = (_a = {}, _a[start] = true, _a);
    var stack = []; // 辅助栈，用于存储访问过的节点的邻居节点
    var allPath = [];
    var neighbors = directed ? (0, $lFtOT.getNeighbors)(start, edges, 'target') : (0, $lFtOT.getNeighbors)(start, edges);
    stack.push(neighbors);
    while(visited.length > 0 && stack.length > 0){
        var children = stack[stack.length - 1];
        if (children.length) {
            var child = children.shift();
            if (child) {
                visited.push(child);
                isVisited[child] = true;
                neighbors = directed ? (0, $lFtOT.getNeighbors)(child, edges, 'target') : (0, $lFtOT.getNeighbors)(child, edges);
                stack.push(neighbors.filter(function(neighbor) {
                    return !isVisited[neighbor];
                }));
            }
        } else {
            var node = visited.pop();
            isVisited[node] = false;
            stack.pop();
            continue;
        }
        if (visited[visited.length - 1] === end) {
            var path = visited.map(function(node) {
                return node;
            });
            allPath.push(path);
            var node = visited.pop();
            isVisited[node] = false;
            stack.pop();
        }
    }
    return allPath;
};

});

parcelRegister("cpOcc", function(module, exports) {

$parcel$export(module.exports, "default", () => $909ec1ab8102b305$export$2e2bcd8739ae039);

var $eltf2 = parcelRequire("eltf2");
var $909ec1ab8102b305$var$floydWarshall = function floydWarshall(graphData, directed) {
    var adjacentMatrix = (0, $eltf2.default)(graphData, directed);
    var dist = [];
    var size = adjacentMatrix.length;
    for(var i = 0; i < size; i += 1){
        dist[i] = [];
        for(var j = 0; j < size; j += 1){
            if (i === j) dist[i][j] = 0;
            else if (adjacentMatrix[i][j] === 0 || !adjacentMatrix[i][j]) dist[i][j] = Infinity;
            else dist[i][j] = adjacentMatrix[i][j];
        }
    }
    // floyd
    for(var k = 0; k < size; k += 1)for(var i = 0; i < size; i += 1){
        for(var j = 0; j < size; j += 1)if (dist[i][j] > dist[i][k] + dist[k][j]) dist[i][j] = dist[i][k] + dist[k][j];
    }
    return dist;
};
var $909ec1ab8102b305$export$2e2bcd8739ae039 = $909ec1ab8102b305$var$floydWarshall;

});

parcelRegister("2knMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b1fe57ae9ae25c3$export$2e2bcd8739ae039);

var $eltf2 = parcelRequire("eltf2");

var $lFtOT = parcelRequire("lFtOT");
/**
 * 标签传播算法
 * @param graphData 图数据
 * @param directed 是否有向图，默认为 false
 * @param weightPropertyName 权重的属性字段
 * @param maxIteration 最大迭代次数
 */ var $1b1fe57ae9ae25c3$var$labelPropagation = function labelPropagation(graphData, directed, weightPropertyName, maxIteration) {
    if (directed === void 0) directed = false;
    if (weightPropertyName === void 0) weightPropertyName = 'weight';
    if (maxIteration === void 0) maxIteration = 1000;
    // the origin data
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a, _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    var clusters = {};
    var nodeMap = {};
    // init the clusters and nodeMap
    nodes.forEach(function(node, i) {
        var cid = (0, $lFtOT.uniqueId)();
        node.clusterId = cid;
        clusters[cid] = {
            id: cid,
            nodes: [
                node
            ]
        };
        nodeMap[node.id] = {
            node: node,
            idx: i
        };
    });
    // the adjacent matrix of calNodes inside clusters
    var adjMatrix = (0, $eltf2.default)(graphData, directed);
    // the sum of each row in adjacent matrix
    var ks = [];
    /**
   * neighbor nodes (id for key and weight for value) for each node
   * neighbors = {
   *  id(node_id): { id(neighbor_1_id): weight(weight of the edge), id(neighbor_2_id): weight(weight of the edge), ... },
   *  ...
   * }
   */ var neighbors = {};
    adjMatrix.forEach(function(row, i) {
        var k = 0;
        var iid = nodes[i].id;
        neighbors[iid] = {};
        row.forEach(function(entry, j) {
            if (!entry) return;
            k += entry;
            var jid = nodes[j].id;
            neighbors[iid][jid] = entry;
        });
        ks.push(k);
    });
    var iter = 0;
    var _loop_1 = function _loop_1() {
        var changed = false;
        nodes.forEach(function(node) {
            var neighborClusters = {};
            Object.keys(neighbors[node.id]).forEach(function(neighborId) {
                var neighborWeight = neighbors[node.id][neighborId];
                var neighborNode = nodeMap[neighborId].node;
                var neighborClusterId = neighborNode.clusterId;
                if (!neighborClusters[neighborClusterId]) neighborClusters[neighborClusterId] = 0;
                neighborClusters[neighborClusterId] += neighborWeight;
            });
            // find the cluster with max weight
            var maxWeight = -Infinity;
            var bestClusterIds = [];
            Object.keys(neighborClusters).forEach(function(clusterId) {
                if (maxWeight < neighborClusters[clusterId]) {
                    maxWeight = neighborClusters[clusterId];
                    bestClusterIds = [
                        clusterId
                    ];
                } else if (maxWeight === neighborClusters[clusterId]) bestClusterIds.push(clusterId);
            });
            if (bestClusterIds.length === 1 && bestClusterIds[0] === node.clusterId) return;
            var selfClusterIdx = bestClusterIds.indexOf(node.clusterId);
            if (selfClusterIdx >= 0) bestClusterIds.splice(selfClusterIdx, 1);
            if (bestClusterIds && bestClusterIds.length) {
                changed = true;
                // remove from origin cluster
                var selfCluster = clusters[node.clusterId];
                var nodeInSelfClusterIdx = selfCluster.nodes.indexOf(node);
                selfCluster.nodes.splice(nodeInSelfClusterIdx, 1);
                // move the node to the best cluster
                var randomIdx = Math.floor(Math.random() * bestClusterIds.length);
                var bestCluster = clusters[bestClusterIds[randomIdx]];
                bestCluster.nodes.push(node);
                node.clusterId = bestCluster.id;
            }
        });
        if (!changed) return "break";
        iter++;
    };
    while(iter < maxIteration){
        var state_1 = _loop_1();
        if (state_1 === "break") break;
    }
    // delete the empty clusters
    Object.keys(clusters).forEach(function(clusterId) {
        var cluster = clusters[clusterId];
        if (!cluster.nodes || !cluster.nodes.length) delete clusters[clusterId];
    });
    // get the cluster edges
    var clusterEdges = [];
    var clusterEdgeMap = {};
    edges.forEach(function(edge) {
        var source = edge.source, target = edge.target;
        var weight = edge[weightPropertyName] || 1;
        var sourceClusterId = nodeMap[source].node.clusterId;
        var targetClusterId = nodeMap[target].node.clusterId;
        var newEdgeId = "".concat(sourceClusterId, "---").concat(targetClusterId);
        if (clusterEdgeMap[newEdgeId]) {
            clusterEdgeMap[newEdgeId].weight += weight;
            clusterEdgeMap[newEdgeId].count++;
        } else {
            var newEdge = {
                source: sourceClusterId,
                target: targetClusterId,
                weight: weight,
                count: 1
            };
            clusterEdgeMap[newEdgeId] = newEdge;
            clusterEdges.push(newEdge);
        }
    });
    var clustersArray = [];
    Object.keys(clusters).forEach(function(clusterId) {
        clustersArray.push(clusters[clusterId]);
    });
    return {
        clusters: clustersArray,
        clusterEdges: clusterEdges
    };
};
var $1b1fe57ae9ae25c3$export$2e2bcd8739ae039 = $1b1fe57ae9ae25c3$var$labelPropagation;

});

parcelRegister("iEgNa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d938fcf157dbda7f$export$2e2bcd8739ae039);
parcelRequire("9PG0c");
var $glsCo = parcelRequire("glsCo");

var $eltf2 = parcelRequire("eltf2");

var $g3TBs = parcelRequire("g3TBs");

var $kPzpY = parcelRequire("kPzpY");

var $gCD0n = parcelRequire("gCD0n");
var $d938fcf157dbda7f$var$getModularity = function getModularity(nodes, adjMatrix, ks, m) {
    var length = adjMatrix.length;
    var param = 2 * m;
    var modularity = 0;
    for(var i = 0; i < length; i++){
        var clusteri = nodes[i].clusterId;
        for(var j = 0; j < length; j++){
            var clusterj = nodes[j].clusterId;
            if (clusteri !== clusterj) continue;
            var entry = adjMatrix[i][j] || 0;
            var ki = ks[i] || 0;
            var kj = ks[j] || 0;
            modularity += entry - ki * kj / param;
        }
    }
    modularity *= 1 / param;
    return modularity;
};
// 模块惯性度，衡量属性相似度
var $d938fcf157dbda7f$var$getInertialModularity = function getInertialModularity(nodes, allPropertiesWeight) {
    if (nodes === void 0) nodes = [];
    var length = nodes.length;
    var totalProperties = new (0, $g3TBs.default)([]);
    for(var i = 0; i < length; i++)totalProperties = totalProperties.add(new (0, $g3TBs.default)(allPropertiesWeight[i]));
    // 均值向量
    var avgProperties = totalProperties.avg(length);
    avgProperties.normalize();
    // 节点集合的方差: 节点v与均值向量的平方欧式距离之和
    var variance = 0;
    for(var i = 0; i < length; i++){
        var propertiesi = new (0, $g3TBs.default)(allPropertiesWeight[i]);
        var squareEuclideanDistance = propertiesi.squareEuclideanDistance(avgProperties);
        variance += squareEuclideanDistance;
    }
    // 任意两点间的欧式平方距离
    var squareEuclideanDistanceInfo = [];
    nodes.forEach(function() {
        squareEuclideanDistanceInfo.push([]);
    });
    for(var i = 0; i < length; i++){
        var propertiesi = new (0, $g3TBs.default)(allPropertiesWeight[i]);
        nodes[i]['clusterInertial'] = 0;
        for(var j = 0; j < length; j++){
            if (i === j) {
                squareEuclideanDistanceInfo[i][j] = 0;
                continue;
            }
            var propertiesj = new (0, $g3TBs.default)(allPropertiesWeight[j]);
            squareEuclideanDistanceInfo[i][j] = propertiesi.squareEuclideanDistance(propertiesj);
            nodes[i]['clusterInertial'] += squareEuclideanDistanceInfo[i][j];
        }
    }
    // 计算模块惯性度
    var inertialModularity = 0;
    var param = 2 * length * variance;
    for(var i = 0; i < length; i++){
        var clusteri = nodes[i].clusterId;
        for(var j = 0; j < length; j++){
            var clusterj = nodes[j].clusterId;
            if (i === j || clusteri !== clusterj) continue;
            var inertial = nodes[i].clusterInertial * nodes[j].clusterInertial / Math.pow(param, 2) - squareEuclideanDistanceInfo[i][j] / param;
            inertialModularity += inertial;
        }
    }
    return Number(inertialModularity.toFixed(4));
};
/**
 * 社区发现 louvain 算法
 * @param graphData 图数据
 * @param directed 是否有向图，默认为 false
 * @param weightPropertyName 权重的属性字段
 * @param threshold 差值阈值
 * @param inertialModularity 是否使用惯性模块度（即节点属性相似性）
 * @param propertyKey 属性的字段名
 * @param involvedKeys 参与计算的key集合
 * @param uninvolvedKeys 不参与计算的key集合
 * @param inertialWeight 惯性模块度权重
 */ var $d938fcf157dbda7f$var$louvain = function louvain(graphData, directed, weightPropertyName, threshold, inertialModularity, propertyKey, involvedKeys, uninvolvedKeys, inertialWeight) {
    if (directed === void 0) directed = false;
    if (weightPropertyName === void 0) weightPropertyName = 'weight';
    if (threshold === void 0) threshold = 0.0001;
    if (inertialModularity === void 0) inertialModularity = false;
    if (propertyKey === void 0) propertyKey = undefined;
    if (involvedKeys === void 0) involvedKeys = [];
    if (uninvolvedKeys === void 0) uninvolvedKeys = [
        'id'
    ];
    if (inertialWeight === void 0) inertialWeight = 1;
    // the origin data
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a, _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    var allPropertiesWeight = [];
    if (inertialModularity) {
        nodes.forEach(function(node, index) {
            node.properties = node.properties || {};
            node.originIndex = index;
        });
        var nodeTypeInfo_1 = [];
        if (nodes.every(function(node) {
            return node.hasOwnProperty('nodeType');
        })) {
            nodeTypeInfo_1 = Array.from(new Set(nodes.map(function(node) {
                return node.nodeType;
            })));
            nodes.forEach(function(node) {
                node.properties.nodeType = nodeTypeInfo_1.findIndex(function(nodeType) {
                    return nodeType === node.nodeType;
                });
            });
        }
        // 所有节点属性集合
        var properties = (0, $kPzpY.getAllProperties)(nodes, propertyKey);
        // 所有节点属性one-hot特征向量集合
        allPropertiesWeight = (0, $gCD0n.oneHot)(properties, involvedKeys, uninvolvedKeys);
    }
    var uniqueId = 1;
    var clusters = {};
    var nodeMap = {};
    // init the clusters and nodeMap
    nodes.forEach(function(node, i) {
        var cid = String(uniqueId++);
        node.clusterId = cid;
        clusters[cid] = {
            id: cid,
            nodes: [
                node
            ]
        };
        nodeMap[node.id] = {
            node: node,
            idx: i
        };
    });
    // the adjacent matrix of calNodes inside clusters
    var adjMatrix = (0, $eltf2.default)(graphData, directed);
    // the sum of each row in adjacent matrix
    var ks = [];
    /**
   * neighbor nodes (id for key and weight for value) for each node
   * neighbors = {
   *  id(node_id): { id(neighbor_1_id): weight(weight of the edge), id(neighbor_2_id): weight(weight of the edge), ... },
   *  ...
   * }
   */ var neighbors = {};
    // the sum of the weights of all edges in the graph
    var m = 0;
    adjMatrix.forEach(function(row, i) {
        var k = 0;
        var iid = nodes[i].id;
        neighbors[iid] = {};
        row.forEach(function(entry, j) {
            if (!entry) return;
            k += entry;
            var jid = nodes[j].id;
            neighbors[iid][jid] = entry;
            m += entry;
        });
        ks.push(k);
    });
    m /= 2;
    var totalModularity = Infinity;
    var previousModularity = Infinity;
    var iter = 0;
    var finalNodes = [];
    var finalClusters = {};
    while(true){
        if (inertialModularity && nodes.every(function(node) {
            return node.hasOwnProperty('properties');
        })) totalModularity = $d938fcf157dbda7f$var$getModularity(nodes, adjMatrix, ks, m) + $d938fcf157dbda7f$var$getInertialModularity(nodes, allPropertiesWeight) * inertialWeight;
        else totalModularity = $d938fcf157dbda7f$var$getModularity(nodes, adjMatrix, ks, m);
        // 第一次迭代previousModularity直接赋值
        if (iter === 0) {
            previousModularity = totalModularity;
            finalNodes = nodes;
            finalClusters = clusters;
        }
        var increaseWithinThreshold = totalModularity > 0 && totalModularity > previousModularity && totalModularity - previousModularity < threshold;
        // 总模块度增加才更新最优解
        if (totalModularity > previousModularity) {
            finalNodes = nodes.map(function(node) {
                return {
                    node: node,
                    clusterId: node.clusterId
                };
            });
            finalClusters = (0, $glsCo.default)(clusters);
            previousModularity = totalModularity;
        }
        // whether to terminate the iterations
        if (increaseWithinThreshold || iter > 100) break;
        iter++;
        // pre compute some values for current clusters
        Object.keys(clusters).forEach(function(clusterId) {
            // sum of weights of edges to nodes in cluster
            var sumTot = 0;
            edges.forEach(function(edge) {
                var source = edge.source, target = edge.target;
                var sourceClusterId = nodeMap[source].node.clusterId;
                var targetClusterId = nodeMap[target].node.clusterId;
                if (sourceClusterId === clusterId && targetClusterId !== clusterId || targetClusterId === clusterId && sourceClusterId !== clusterId) sumTot = sumTot + (edge[weightPropertyName] || 1);
            });
            clusters[clusterId].sumTot = sumTot;
        });
        // move the nodes to increase the delta modularity
        nodes.forEach(function(node, i) {
            var selfCluster = clusters[node.clusterId];
            var bestIncrease = 0;
            var bestCluster;
            var commonParam = ks[i] / (2 * m);
            // sum of weights of edges from node to nodes in cluster
            var kiin = 0;
            var selfClusterNodes = selfCluster.nodes;
            selfClusterNodes.forEach(function(scNode) {
                var scNodeIdx = nodeMap[scNode.id].idx;
                kiin += adjMatrix[i][scNodeIdx] || 0;
            });
            // the modurarity for **removing** the node i from the origin cluster of node i
            var removeModurarity = kiin - selfCluster.sumTot * commonParam;
            // nodes for **removing** node i into this neighbor cluster
            var selfClusterNodesAfterRemove = selfClusterNodes.filter(function(scNode) {
                return scNode.id !== node.id;
            });
            var propertiesWeightRemove = [];
            selfClusterNodesAfterRemove.forEach(function(nodeRemove, index) {
                propertiesWeightRemove[index] = allPropertiesWeight[nodeRemove.originIndex];
            });
            // the inertialModularity for **removing** the node i from the origin cluster of node i
            var removeInertialModularity = $d938fcf157dbda7f$var$getInertialModularity(selfClusterNodesAfterRemove, allPropertiesWeight) * inertialWeight;
            // the neightbors of the node
            var nodeNeighborIds = neighbors[node.id];
            Object.keys(nodeNeighborIds).forEach(function(neighborNodeId) {
                var neighborNode = nodeMap[neighborNodeId].node;
                var neighborClusterId = neighborNode.clusterId;
                // if the node and the neighbor of node are in the same cluster, reutrn
                if (neighborClusterId === node.clusterId) return;
                var neighborCluster = clusters[neighborClusterId];
                var clusterNodes = neighborCluster.nodes;
                // if the cluster is empty, remove the cluster and return
                if (!clusterNodes || !clusterNodes.length) return;
                // sum of weights of edges from node to nodes in cluster
                var neighborClusterKiin = 0;
                clusterNodes.forEach(function(cNode) {
                    var cNodeIdx = nodeMap[cNode.id].idx;
                    neighborClusterKiin += adjMatrix[i][cNodeIdx] || 0;
                });
                // the modurarity for **adding** node i into this neighbor cluster
                var addModurarity = neighborClusterKiin - neighborCluster.sumTot * commonParam;
                // nodes for **adding** node i into this neighbor cluster
                var clusterNodesAfterAdd = clusterNodes.concat([
                    node
                ]);
                var propertiesWeightAdd = [];
                clusterNodesAfterAdd.forEach(function(nodeAdd, index) {
                    propertiesWeightAdd[index] = allPropertiesWeight[nodeAdd.originIndex];
                });
                // the inertialModularity for **adding** node i into this neighbor cluster
                var addInertialModularity = $d938fcf157dbda7f$var$getInertialModularity(clusterNodesAfterAdd, allPropertiesWeight) * inertialWeight;
                // the increase modurarity is the difference between addModurarity and removeModurarity
                var increase = addModurarity - removeModurarity;
                if (inertialModularity) increase = addModurarity + addInertialModularity - (removeModurarity + removeInertialModularity);
                // find the best cluster to move node i into
                if (increase > bestIncrease) {
                    bestIncrease = increase;
                    bestCluster = neighborCluster;
                }
            });
            // if found a best cluster to move into
            if (bestIncrease > 0) {
                bestCluster.nodes.push(node);
                var previousClusterId_1 = node.clusterId;
                node.clusterId = bestCluster.id;
                // move the node to the best cluster
                var nodeInSelfClusterIdx = selfCluster.nodes.indexOf(node);
                // remove from origin cluster
                selfCluster.nodes.splice(nodeInSelfClusterIdx, 1);
                // update sumTot for clusters
                // sum of weights of edges to nodes in cluster
                var neighborClusterSumTot_1 = 0;
                var selfClusterSumTot_1 = 0;
                edges.forEach(function(edge) {
                    var source = edge.source, target = edge.target;
                    var sourceClusterId = nodeMap[source].node.clusterId;
                    var targetClusterId = nodeMap[target].node.clusterId;
                    if (sourceClusterId === bestCluster.id && targetClusterId !== bestCluster.id || targetClusterId === bestCluster.id && sourceClusterId !== bestCluster.id) neighborClusterSumTot_1 = neighborClusterSumTot_1 + (edge[weightPropertyName] || 1);
                    if (sourceClusterId === previousClusterId_1 && targetClusterId !== previousClusterId_1 || targetClusterId === previousClusterId_1 && sourceClusterId !== previousClusterId_1) selfClusterSumTot_1 = selfClusterSumTot_1 + (edge[weightPropertyName] || 1);
                });
                // the nodes of the clusters to move into and remove are changed, update their sumTot
                bestCluster.sumTot = neighborClusterSumTot_1;
                selfCluster.sumTot = selfClusterSumTot_1;
            }
        });
    }
    // delete the empty clusters, assign increasing clusterId
    var newClusterIdMap = {};
    var clusterIdx = 0;
    Object.keys(finalClusters).forEach(function(clusterId) {
        var cluster = finalClusters[clusterId];
        if (!cluster.nodes || !cluster.nodes.length) {
            delete finalClusters[clusterId];
            return;
        }
        var newId = String(clusterIdx + 1);
        if (newId === clusterId) return;
        cluster.id = newId;
        cluster.nodes = cluster.nodes.map(function(item) {
            return {
                id: item.id,
                clusterId: newId
            };
        });
        finalClusters[newId] = cluster;
        newClusterIdMap[clusterId] = newId;
        delete finalClusters[clusterId];
        clusterIdx++;
    });
    // restore node clusterId
    finalNodes.forEach(function(nodeInfo) {
        var node = nodeInfo.node, clusterId = nodeInfo.clusterId;
        if (!node) return;
        node.clusterId = clusterId;
        if (node.clusterId && newClusterIdMap[node.clusterId]) node.clusterId = newClusterIdMap[node.clusterId];
    });
    // get the cluster edges
    var clusterEdges = [];
    var clusterEdgeMap = {};
    edges.forEach(function(edge) {
        var source = edge.source, target = edge.target;
        var weight = edge[weightPropertyName] || 1;
        var sourceClusterId = nodeMap[source].node.clusterId;
        var targetClusterId = nodeMap[target].node.clusterId;
        if (!sourceClusterId || !targetClusterId) return;
        var newEdgeId = "".concat(sourceClusterId, "---").concat(targetClusterId);
        if (clusterEdgeMap[newEdgeId]) {
            clusterEdgeMap[newEdgeId].weight += weight;
            clusterEdgeMap[newEdgeId].count++;
        } else {
            var newEdge = {
                source: sourceClusterId,
                target: targetClusterId,
                weight: weight,
                count: 1
            };
            clusterEdgeMap[newEdgeId] = newEdge;
            clusterEdges.push(newEdge);
        }
    });
    var clustersArray = [];
    Object.keys(finalClusters).forEach(function(clusterId) {
        clustersArray.push(finalClusters[clusterId]);
    });
    return {
        clusters: clustersArray,
        clusterEdges: clusterEdges
    };
};
var $d938fcf157dbda7f$export$2e2bcd8739ae039 = $d938fcf157dbda7f$var$louvain;

});
parcelRegister("g3TBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb180eca9209dc0c$export$2e2bcd8739ae039);
/**
 * 向量运算
 */ parcelRequire("9PG0c");
var $glsCo = parcelRequire("glsCo");
var $bb180eca9209dc0c$var$Vector = /** @class */ function() {
    function Vector(arr) {
        this.arr = arr;
    }
    Vector.prototype.getArr = function() {
        return this.arr || [];
    };
    Vector.prototype.add = function(otherVector) {
        var _a;
        var otherArr = otherVector.arr;
        if (!((_a = this.arr) === null || _a === void 0 ? void 0 : _a.length)) return new Vector(otherArr);
        if (!(otherArr === null || otherArr === void 0 ? void 0 : otherArr.length)) return new Vector(this.arr);
        if (this.arr.length === otherArr.length) {
            var res = [];
            for(var index in this.arr)res[index] = this.arr[index] + otherArr[index];
            return new Vector(res);
        }
    };
    Vector.prototype.subtract = function(otherVector) {
        var _a;
        var otherArr = otherVector.arr;
        if (!((_a = this.arr) === null || _a === void 0 ? void 0 : _a.length)) return new Vector(otherArr);
        if (!(otherArr === null || otherArr === void 0 ? void 0 : otherArr.length)) return new Vector(this.arr);
        if (this.arr.length === otherArr.length) {
            var res = [];
            for(var index in this.arr)res[index] = this.arr[index] - otherArr[index];
            return new Vector(res);
        }
    };
    Vector.prototype.avg = function(length) {
        var res = [];
        if (length !== 0) for(var index in this.arr)res[index] = this.arr[index] / length;
        return new Vector(res);
    };
    Vector.prototype.negate = function() {
        var res = [];
        for(var index in this.arr)res[index] = -this.arr[index];
        return new Vector(res);
    };
    // 平方欧式距离
    Vector.prototype.squareEuclideanDistance = function(otherVector) {
        var _a;
        var otherArr = otherVector.arr;
        if (!((_a = this.arr) === null || _a === void 0 ? void 0 : _a.length) || !(otherArr === null || otherArr === void 0 ? void 0 : otherArr.length)) return 0;
        if (this.arr.length === otherArr.length) {
            var res = 0;
            for(var index in this.arr)res += Math.pow(this.arr[index] - otherVector.arr[index], 2);
            return res;
        }
    };
    // 欧式距离
    Vector.prototype.euclideanDistance = function(otherVector) {
        var _a;
        var otherArr = otherVector.arr;
        if (!((_a = this.arr) === null || _a === void 0 ? void 0 : _a.length) || !(otherArr === null || otherArr === void 0 ? void 0 : otherArr.length)) return 0;
        if (this.arr.length === otherArr.length) {
            var res = 0;
            for(var index in this.arr)res += Math.pow(this.arr[index] - otherVector.arr[index], 2);
            return Math.sqrt(res);
        } else console.error('The two vectors are unequal in length.');
    };
    // 归一化处理
    Vector.prototype.normalize = function() {
        var res = [];
        var cloneArr = (0, $glsCo.default)(this.arr);
        cloneArr.sort(function(a, b) {
            return a - b;
        });
        var max = cloneArr[cloneArr.length - 1];
        var min = cloneArr[0];
        for(var index in this.arr)res[index] = (this.arr[index] - min) / (max - min);
        return new Vector(res);
    };
    // 2范数 or 模长
    Vector.prototype.norm2 = function() {
        var _a;
        if (!((_a = this.arr) === null || _a === void 0 ? void 0 : _a.length)) return 0;
        var res = 0;
        for(var index in this.arr)res += Math.pow(this.arr[index], 2);
        return Math.sqrt(res);
    };
    // 两个向量的点积
    Vector.prototype.dot = function(otherVector) {
        var _a;
        var otherArr = otherVector.arr;
        if (!((_a = this.arr) === null || _a === void 0 ? void 0 : _a.length) || !(otherArr === null || otherArr === void 0 ? void 0 : otherArr.length)) return 0;
        if (this.arr.length === otherArr.length) {
            var res = 0;
            for(var index in this.arr)res += this.arr[index] * otherVector.arr[index];
            return res;
        } else console.error('The two vectors are unequal in length.');
    };
    // 两个向量比较
    Vector.prototype.equal = function(otherVector) {
        var _a;
        var otherArr = otherVector.arr;
        if (((_a = this.arr) === null || _a === void 0 ? void 0 : _a.length) !== (otherArr === null || otherArr === void 0 ? void 0 : otherArr.length)) return false;
        for(var index in this.arr){
            if (this.arr[index] !== otherArr[index]) return false;
        }
        return true;
    };
    return Vector;
}();
var $bb180eca9209dc0c$export$2e2bcd8739ae039 = $bb180eca9209dc0c$var$Vector;

});

parcelRegister("kPzpY", function(module, exports) {

$parcel$export(module.exports, "getAllProperties", () => $f2a40b5116d015d7$export$c6d4483417794dda);

var $c48vZ = parcelRequire("c48vZ");
var $f2a40b5116d015d7$export$8d168e6755300eb2 = function getAllSortProperties(nodes, n) {
    if (nodes === void 0) nodes = [];
    if (n === void 0) n = 100;
    var propertyKeyInfo = {};
    nodes.forEach(function(node) {
        if (!node.properties) return;
        Object.keys(node.properties).forEach(function(propertyKey) {
            // 目前过滤只保留可以转成数值型的或日期型的, todo: 统一转成one-hot特征向量或者embedding
            if (propertyKey === 'id' || !"".concat(node.properties[propertyKey]).match((0, $c48vZ.secondReg)) && !"".concat(node.properties[propertyKey]).match((0, $c48vZ.dateReg)) && isNaN(Number(node.properties[propertyKey]))) {
                if (propertyKeyInfo.hasOwnProperty(propertyKey)) delete propertyKeyInfo[propertyKey];
                return;
            }
            if (propertyKeyInfo.hasOwnProperty(propertyKey)) propertyKeyInfo[propertyKey] += 1;
            else propertyKeyInfo[propertyKey] = 1;
        });
    });
    // 取top50的属性
    var sortKeys = Object.keys(propertyKeyInfo).sort(function(a, b) {
        return propertyKeyInfo[b] - propertyKeyInfo[a];
    });
    return sortKeys.length < n ? sortKeys : sortKeys.slice(0, n);
};
var $f2a40b5116d015d7$var$processProperty = function processProperty(properties, propertyKeys) {
    return propertyKeys.map(function(key) {
        if (properties.hasOwnProperty(key)) // // 可以转成数值的直接转成数值
        // if (!isNaN(Number(properties[key]))) {
        //   return Number(properties[key]);
        // }
        // // 时间型的转成时间戳
        // if (properties[key].match(secondReg) || properties[key].match(dateReg)) {
        //   // @ts-ignore
        //   return Number(Date.parse(new Date(properties[key]))) / 1000;
        // }
        return properties[key];
        return 0;
    });
};
var $f2a40b5116d015d7$export$c679cff89c2d8a2b = function getPropertyWeight(nodes) {
    var propertyKeys = $f2a40b5116d015d7$export$8d168e6755300eb2(nodes);
    var allPropertiesWeight = [];
    for(var i = 0; i < nodes.length; i++)allPropertiesWeight[i] = $f2a40b5116d015d7$var$processProperty(nodes[i].properties, propertyKeys);
    return allPropertiesWeight;
};
var $f2a40b5116d015d7$export$c6d4483417794dda = function getAllProperties(nodes, key) {
    if (key === void 0) key = undefined;
    var allProperties = [];
    nodes.forEach(function(node) {
        if (key === undefined) allProperties.push(node);
        if (node[key] !== undefined) allProperties.push(node[key]);
    });
    return allProperties;
};
var $f2a40b5116d015d7$export$2e2bcd8739ae039 = {
    getAllSortProperties: $f2a40b5116d015d7$export$8d168e6755300eb2,
    getPropertyWeight: $f2a40b5116d015d7$export$c679cff89c2d8a2b,
    getAllProperties: $f2a40b5116d015d7$export$c6d4483417794dda
};

});
parcelRegister("c48vZ", function(module, exports) {

$parcel$export(module.exports, "secondReg", () => $8c8c76a703c7267d$export$a5a8f78c3e2fa72e);
$parcel$export(module.exports, "dateReg", () => $8c8c76a703c7267d$export$aa874457e5d6e0e3);
var $8c8c76a703c7267d$export$a5a8f78c3e2fa72e = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/;
var $8c8c76a703c7267d$export$aa874457e5d6e0e3 = /^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;

});


parcelRegister("gCD0n", function(module, exports) {

$parcel$export(module.exports, "oneHot", () => $c19e738e30a5e936$export$341b5490a776d041);
$parcel$export(module.exports, "getDistance", () => $c19e738e30a5e936$export$79376507b09a66f);
parcelRequire("9PG0c");
var $joF99 = parcelRequire("joF99");

var $9j3nj = parcelRequire("9j3nj");

var $g3TBs = parcelRequire("g3TBs");
var $c19e738e30a5e936$export$67952ae4f86fe73 = function getAllKeyValueMap(dataList, involvedKeys, uninvolvedKeys) {
    var keys = [];
    // 指定了参与计算的keys时，使用指定的keys
    if (involvedKeys === null || involvedKeys === void 0 ? void 0 : involvedKeys.length) keys = involvedKeys;
    else {
        // 未指定抽取的keys时，提取数据中所有的key
        dataList.forEach(function(data) {
            keys = keys.concat(Object.keys(data));
        });
        keys = (0, $joF99.default)(keys);
    }
    // 获取所有值非空的key的value数组
    var allKeyValueMap = {};
    keys.forEach(function(key) {
        var value = [];
        dataList.forEach(function(data) {
            if (data[key] !== undefined && data[key] !== '') value.push(data[key]);
        });
        if (value.length && !(uninvolvedKeys === null || uninvolvedKeys === void 0 ? void 0 : uninvolvedKeys.includes(key))) allKeyValueMap[key] = (0, $joF99.default)(value);
    });
    return allKeyValueMap;
};
var $c19e738e30a5e936$export$341b5490a776d041 = function oneHot(dataList, involvedKeys, uninvolvedKeys) {
    // 获取数据中所有的属性/特征及其对应的值
    var allKeyValueMap = $c19e738e30a5e936$export$67952ae4f86fe73(dataList, involvedKeys, uninvolvedKeys);
    var oneHotCode = [];
    if (!Object.keys(allKeyValueMap).length) return oneHotCode;
    // 获取所有的属性/特征值
    var allValue = Object.values(allKeyValueMap);
    // 是否所有属性/特征的值都是数值型
    var isAllNumber = allValue.every(function(value) {
        return value.every(function(item) {
            return typeof item === 'number';
        });
    });
    // 对数据进行one-hot编码
    dataList.forEach(function(data, index) {
        var code = [];
        Object.keys(allKeyValueMap).forEach(function(key) {
            var keyValue = data[key];
            var allKeyValue = allKeyValueMap[key];
            var valueIndex = allKeyValue.findIndex(function(value) {
                return keyValue === value;
            });
            var subCode = [];
            // 如果属性/特征所有的值都能转成数值型，不满足分箱，则直接用值（todo: 为了收敛更快，需做归一化处理）
            if (isAllNumber) subCode.push(keyValue);
            else {
                // 进行one-hot编码
                for(var i = 0; i < allKeyValue.length; i++)if (i === valueIndex) subCode.push(1);
                else subCode.push(0);
            }
            code = code.concat(subCode);
        });
        oneHotCode[index] = code;
    });
    return oneHotCode;
};
var $c19e738e30a5e936$export$79376507b09a66f = function getDistance(item, otherItem, distanceType, graphData) {
    if (distanceType === void 0) distanceType = (0, $9j3nj.DistanceType).EuclideanDistance;
    var distance = 0;
    switch(distanceType){
        case (0, $9j3nj.DistanceType).EuclideanDistance:
            distance = new (0, $g3TBs.default)(item).euclideanDistance(new (0, $g3TBs.default)(otherItem));
            break;
        default:
            break;
    }
    return distance;
};
var $c19e738e30a5e936$export$2e2bcd8739ae039 = {
    getAllKeyValueMap: $c19e738e30a5e936$export$67952ae4f86fe73,
    oneHot: $c19e738e30a5e936$export$341b5490a776d041,
    getDistance: $c19e738e30a5e936$export$79376507b09a66f
};

});
parcelRegister("9j3nj", function(module, exports) {

$parcel$export(module.exports, "DistanceType", () => $6c68819d9cbd8166$export$c9ec6925f65d2609);
var $6c68819d9cbd8166$export$c9ec6925f65d2609;
(function(DistanceType) {
    DistanceType["EuclideanDistance"] = "euclideanDistance";
})($6c68819d9cbd8166$export$c9ec6925f65d2609 || ($6c68819d9cbd8166$export$c9ec6925f65d2609 = {}));

});



parcelRegister("iYdqr", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcf83e9dde46e050$export$2e2bcd8739ae039);

var $iEgNa = parcelRequire("iEgNa");
/**
 * 社区发现 i-louvain 算法：模块度 + 惯性模块度（即节点属性相似性）
 * @param graphData 图数据
 * @param directed 是否有向图，默认为 false
 * @param weightPropertyName 权重的属性字段
 * @param threshold 差值阈值
 * @param propertyKey 属性的字段名
 * @param involvedKeys 参与计算的key集合
 * @param uninvolvedKeys 不参与计算的key集合
 * @param inertialWeight 惯性模块度权重
 */ var $dcf83e9dde46e050$var$iLouvain = function iLouvain(graphData, directed, weightPropertyName, threshold, propertyKey, involvedKeys, uninvolvedKeys, inertialWeight) {
    if (directed === void 0) directed = false;
    if (weightPropertyName === void 0) weightPropertyName = 'weight';
    if (threshold === void 0) threshold = 0.0001;
    if (propertyKey === void 0) propertyKey = undefined;
    if (involvedKeys === void 0) involvedKeys = [];
    if (uninvolvedKeys === void 0) uninvolvedKeys = [
        'id'
    ];
    if (inertialWeight === void 0) inertialWeight = 1;
    return (0, $iEgNa.default)(graphData, directed, weightPropertyName, threshold, true, propertyKey, involvedKeys, uninvolvedKeys, inertialWeight);
};
var $dcf83e9dde46e050$export$2e2bcd8739ae039 = $dcf83e9dde46e050$var$iLouvain;

});

parcelRegister("iXKbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $dce190f1bb5734d5$export$2e2bcd8739ae039);
parcelRequire("9PG0c");
var $glsCo = parcelRequire("glsCo");

var $gGbI9 = parcelRequire("gGbI9");
/**
 *  k-core算法 找出符合指定核心度的紧密关联的子图结构
 * @param graphData 图数据
 * @param k 核心度数
 */ var $dce190f1bb5734d5$var$kCore = function kCore(graphData, k) {
    var _a;
    if (k === void 0) k = 1;
    var data = (0, $glsCo.default)(graphData);
    var _b = data.nodes, nodes = _b === void 0 ? [] : _b;
    var _c = data.edges, edges = _c === void 0 ? [] : _c;
    var _loop_1 = function _loop_1() {
        // 获取图中节点的度数
        var degrees = (0, $gGbI9.default)({
            nodes: nodes,
            edges: edges
        });
        var nodeIds = Object.keys(degrees);
        // 按照度数进行排序
        nodeIds.sort(function(a, b) {
            var _a, _b;
            return ((_a = degrees[a]) === null || _a === void 0 ? void 0 : _a.degree) - ((_b = degrees[b]) === null || _b === void 0 ? void 0 : _b.degree);
        });
        var minIndexId = nodeIds[0];
        if (!nodes.length || ((_a = degrees[minIndexId]) === null || _a === void 0 ? void 0 : _a.degree) >= k) return "break";
        var originIndex = nodes.findIndex(function(node) {
            return node.id === minIndexId;
        });
        // 移除度数小于k的节点
        nodes.splice(originIndex, 1);
        // 移除度数小于k的节点相关的边
        edges = edges.filter(function(edge) {
            return !(edge.source === minIndexId || edge.target === minIndexId);
        });
    };
    while(true){
        var state_1 = _loop_1();
        if (state_1 === "break") break;
    }
    return {
        nodes: nodes,
        edges: edges
    };
};
var $dce190f1bb5734d5$export$2e2bcd8739ae039 = $dce190f1bb5734d5$var$kCore;

});

parcelRegister("edbWE", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58b8b9f3c76ed22$export$2e2bcd8739ae039);
parcelRequire("9PG0c");
var $950hz = parcelRequire("950hz");
var $joF99 = parcelRequire("joF99");

var $kPzpY = parcelRequire("kPzpY");

var $gCD0n = parcelRequire("gCD0n");

var $g3TBs = parcelRequire("g3TBs");

var $9j3nj = parcelRequire("9j3nj");
// 获取质心
var $a58b8b9f3c76ed22$var$getCentroid = function getCentroid(distanceType, allPropertiesWeight, index) {
    var centroid = [];
    switch(distanceType){
        case (0, $9j3nj.DistanceType).EuclideanDistance:
            centroid = allPropertiesWeight[index];
            break;
        default:
            centroid = [];
            break;
    }
    return centroid;
};
/**
 *  k-means算法 根据节点之间的距离将节点聚类为K个簇
 * @param data 图数据
 * @param k 质心（聚类中心）个数
 * @param propertyKey 属性的字段名
 * @param involvedKeys 参与计算的key集合
 * @param uninvolvedKeys 不参与计算的key集合
 * @param distanceType 距离类型 默认节点属性的欧式距离
 */ var $a58b8b9f3c76ed22$var$kMeans = function kMeans(data, k, propertyKey, involvedKeys, uninvolvedKeys, distanceType) {
    if (k === void 0) k = 3;
    if (propertyKey === void 0) propertyKey = undefined;
    if (involvedKeys === void 0) involvedKeys = [];
    if (uninvolvedKeys === void 0) uninvolvedKeys = [
        'id'
    ];
    if (distanceType === void 0) distanceType = (0, $9j3nj.DistanceType).EuclideanDistance;
    var _a = data.nodes, nodes = _a === void 0 ? [] : _a, _b = data.edges, edges = _b === void 0 ? [] : _b;
    var defaultClusterInfo = {
        clusters: [
            {
                id: "0",
                nodes: nodes
            }
        ],
        clusterEdges: []
    };
    // 距离类型为欧式距离且没有属性时，直接return
    if (distanceType === (0, $9j3nj.DistanceType).EuclideanDistance && !nodes.every(function(node) {
        return node.hasOwnProperty(propertyKey);
    })) return defaultClusterInfo;
    // 所有节点属性集合
    var properties = [];
    // 所有节点属性one-hot特征向量集合
    var allPropertiesWeight = [];
    if (distanceType === (0, $9j3nj.DistanceType).EuclideanDistance) {
        properties = (0, $kPzpY.getAllProperties)(nodes, propertyKey);
        allPropertiesWeight = (0, $gCD0n.oneHot)(properties, involvedKeys, uninvolvedKeys);
    }
    if (!allPropertiesWeight.length) return defaultClusterInfo;
    var allPropertiesWeightUniq = (0, $joF99.default)(allPropertiesWeight.map(function(item) {
        return item.join('');
    }));
    // 当输入节点数量或者属性集合的长度小于k时，k调整为其中最小的值
    var finalK = Math.min(k, nodes.length, allPropertiesWeightUniq.length);
    // 记录节点的原始index，与allPropertiesWeight对应
    for(var i = 0; i < nodes.length; i++)nodes[i].originIndex = i;
    // 初始化质心（聚类中心）
    var centroids = [];
    var centroidIndexList = [];
    var clusters = [];
    for(var i = 0; i < finalK; i++)if (i === 0) {
        // 随机选取质心（聚类中心）
        var randomIndex = Math.floor(Math.random() * nodes.length);
        switch(distanceType){
            case (0, $9j3nj.DistanceType).EuclideanDistance:
                centroids[i] = allPropertiesWeight[randomIndex];
                break;
            default:
                centroids[i] = [];
                break;
        }
        centroidIndexList.push(randomIndex);
        clusters[i] = [
            nodes[randomIndex]
        ];
        nodes[randomIndex].clusterId = String(i);
    } else {
        var maxDistance = -Infinity;
        var maxDistanceNodeIndex = 0;
        var _loop_1 = function _loop_1(m) {
            if (!centroidIndexList.includes(m)) {
                var totalDistance = 0;
                for(var j = 0; j < centroids.length; j++){
                    // 求节点到质心的距离（默认节点属性的欧式距离）
                    var distance = 0;
                    switch(distanceType){
                        case (0, $9j3nj.DistanceType).EuclideanDistance:
                            distance = (0, $gCD0n.getDistance)(allPropertiesWeight[nodes[m].originIndex], centroids[j], distanceType);
                            break;
                        default:
                            break;
                    }
                    totalDistance += distance;
                }
                // 节点到各质心的平均距离（默认欧式距离）
                var avgDistance = totalDistance / centroids.length;
                // 记录到已有质心最远的的距离和节点索引
                if (avgDistance > maxDistance && !centroids.find(function(centroid) {
                    return (0, $950hz.default)(centroid, $a58b8b9f3c76ed22$var$getCentroid(distanceType, allPropertiesWeight, nodes[m].originIndex));
                })) {
                    maxDistance = avgDistance;
                    maxDistanceNodeIndex = m;
                }
            }
        };
        // 选取与已有质心平均距离最远的点做为新的质心
        for(var m = 0; m < nodes.length; m++)_loop_1(m);
        centroids[i] = $a58b8b9f3c76ed22$var$getCentroid(distanceType, allPropertiesWeight, maxDistanceNodeIndex);
        centroidIndexList.push(maxDistanceNodeIndex);
        clusters[i] = [
            nodes[maxDistanceNodeIndex]
        ];
        nodes[maxDistanceNodeIndex].clusterId = String(i);
    }
    var iterations = 0;
    while(true){
        for(var i = 0; i < nodes.length; i++){
            var minDistanceIndex = 0;
            var minDistance = Infinity;
            if (!(iterations === 0 && centroidIndexList.includes(i))) {
                for(var j = 0; j < centroids.length; j++){
                    // 求节点到质心的距离（默认节点属性的欧式距离）
                    var distance = 0;
                    switch(distanceType){
                        case (0, $9j3nj.DistanceType).EuclideanDistance:
                            distance = (0, $gCD0n.getDistance)(allPropertiesWeight[i], centroids[j], distanceType);
                            break;
                        default:
                            break;
                    }
                    // 记录节点最近的质心的索引
                    if (distance < minDistance) {
                        minDistance = distance;
                        minDistanceIndex = j;
                    }
                }
                // 从原来的类别删除节点
                if (nodes[i].clusterId !== undefined) {
                    for(var n = clusters[Number(nodes[i].clusterId)].length - 1; n >= 0; n--)if (clusters[Number(nodes[i].clusterId)][n].id === nodes[i].id) clusters[Number(nodes[i].clusterId)].splice(n, 1);
                }
                // 将节点划分到距离最小的质心（聚类中心）所对应的类中
                nodes[i].clusterId = String(minDistanceIndex);
                clusters[minDistanceIndex].push(nodes[i]);
            }
        }
        // 是否存在质心（聚类中心）移动
        var centroidsEqualAvg = false;
        for(var i = 0; i < clusters.length; i++){
            var clusterNodes = clusters[i];
            var totalVector = new (0, $g3TBs.default)([]);
            for(var j = 0; j < clusterNodes.length; j++)totalVector = totalVector.add(new (0, $g3TBs.default)(allPropertiesWeight[clusterNodes[j].originIndex]));
            // 计算每个类别的均值向量
            var avgVector = totalVector.avg(clusterNodes.length);
            // 如果均值向量不等于质心向量
            if (!avgVector.equal(new (0, $g3TBs.default)(centroids[i]))) {
                centroidsEqualAvg = true;
                // 移动/更新每个类别的质心（聚类中心）到该均值向量
                centroids[i] = avgVector.getArr();
            }
        }
        iterations++;
        // 如果每个节点都归属了类别，且不存在质心（聚类中心）移动或者迭代次数超过1000，则停止
        if (nodes.every(function(node) {
            return node.clusterId !== undefined;
        }) && centroidsEqualAvg || iterations >= 1000) break;
    }
    // get the cluster edges
    var clusterEdges = [];
    var clusterEdgeMap = {};
    edges.forEach(function(edge) {
        var _a, _b;
        var source = edge.source, target = edge.target;
        var sourceClusterId = (_a = nodes.find(function(node) {
            return node.id === source;
        })) === null || _a === void 0 ? void 0 : _a.clusterId;
        var targetClusterId = (_b = nodes.find(function(node) {
            return node.id === target;
        })) === null || _b === void 0 ? void 0 : _b.clusterId;
        var newEdgeId = "".concat(sourceClusterId, "---").concat(targetClusterId);
        if (clusterEdgeMap[newEdgeId]) clusterEdgeMap[newEdgeId].count++;
        else {
            var newEdge = {
                source: sourceClusterId,
                target: targetClusterId,
                count: 1
            };
            clusterEdgeMap[newEdgeId] = newEdge;
            clusterEdges.push(newEdge);
        }
    });
    return {
        clusters: clusters,
        clusterEdges: clusterEdges
    };
};
var $a58b8b9f3c76ed22$export$2e2bcd8739ae039 = $a58b8b9f3c76ed22$var$kMeans;

});

parcelRegister("b90Kv", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d11dbe682a8e4a$export$2e2bcd8739ae039);

var $g3TBs = parcelRequire("g3TBs");
/**
 * cosine-similarity算法 计算余弦相似度
 * @param item 元素
 * @param targetItem 目标元素
 */ var $81d11dbe682a8e4a$var$cosineSimilarity = function cosineSimilarity(item, targetItem) {
    // 目标元素向量
    var targetItemVector = new (0, $g3TBs.default)(targetItem);
    // 目标元素向量的模长
    var targetNodeNorm2 = targetItemVector.norm2();
    // 元素向量
    var itemVector = new (0, $g3TBs.default)(item);
    // 元素向量的模长
    var itemNorm2 = itemVector.norm2();
    // 计算元素向量和目标元素向量的点积
    var dot = targetItemVector.dot(itemVector);
    var norm2Product = targetNodeNorm2 * itemNorm2;
    // 计算元素向量和目标元素向量的余弦相似度
    var cosineSimilarity = norm2Product ? dot / norm2Product : 0;
    return cosineSimilarity;
};
var $81d11dbe682a8e4a$export$2e2bcd8739ae039 = $81d11dbe682a8e4a$var$cosineSimilarity;

});

parcelRegister("f2j9J", function(module, exports) {

$parcel$export(module.exports, "default", () => $af25e6e5528babd2$export$2e2bcd8739ae039);
parcelRequire("9PG0c");
var $glsCo = parcelRequire("glsCo");

var $kPzpY = parcelRequire("kPzpY");

var $gCD0n = parcelRequire("gCD0n");

var $b90Kv = parcelRequire("b90Kv");
/**
 *  nodes-cosine-similarity算法 基于节点属性计算余弦相似度(基于种子节点寻找相似节点)
 * @param nodes 图节点数据
 * @param seedNode 种子节点
 * @param propertyKey 属性的字段名
 * @param involvedKeys 参与计算的key集合
 * @param uninvolvedKeys 不参与计算的key集合
 */ var $af25e6e5528babd2$var$nodesCosineSimilarity = function nodesCosineSimilarity(nodes, seedNode, propertyKey, involvedKeys, uninvolvedKeys) {
    if (nodes === void 0) nodes = [];
    if (propertyKey === void 0) propertyKey = undefined;
    if (involvedKeys === void 0) involvedKeys = [];
    if (uninvolvedKeys === void 0) uninvolvedKeys = [];
    var similarNodes = (0, $glsCo.default)(nodes.filter(function(node) {
        return node.id !== seedNode.id;
    }));
    var seedNodeIndex = nodes.findIndex(function(node) {
        return node.id === seedNode.id;
    });
    // 所有节点属性集合
    var properties = (0, $kPzpY.getAllProperties)(nodes, propertyKey);
    // 所有节点属性one-hot特征向量集合
    var allPropertiesWeight = (0, $gCD0n.oneHot)(properties, involvedKeys, uninvolvedKeys);
    // 种子节点属性
    var seedNodeProperties = allPropertiesWeight[seedNodeIndex];
    var allCosineSimilarity = [];
    similarNodes.forEach(function(node, index) {
        if (node.id !== seedNode.id) {
            // 节点属性
            var nodeProperties = allPropertiesWeight[index];
            // 计算节点向量和种子节点向量的余弦相似度
            var cosineSimilarityValue = (0, $b90Kv.default)(nodeProperties, seedNodeProperties);
            allCosineSimilarity.push(cosineSimilarityValue);
            node.cosineSimilarity = cosineSimilarityValue;
        }
    });
    // 将返回的节点按照余弦相似度大小排序
    similarNodes.sort(function(a, b) {
        return b.cosineSimilarity - a.cosineSimilarity;
    });
    return {
        allCosineSimilarity: allCosineSimilarity,
        similarNodes: similarNodes
    };
};
var $af25e6e5528babd2$export$2e2bcd8739ae039 = $af25e6e5528babd2$var$nodesCosineSimilarity;

});

parcelRegister("g4d4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb2728380eb1d4ff$export$2e2bcd8739ae039);

var $6RkIX = parcelRequire("6RkIX");

var $33g0U = parcelRequire("33g0U");

var $lFtOT = parcelRequire("lFtOT");
/**
 * Prim algorithm，use priority queue，复杂度 O(E+V*logV), V: 节点数量，E: 边的数量
 * refer: https://en.wikipedia.org/wiki/Prim%27s_algorithm
 * @param graph
 * @param weight 指定用于作为边权重的属性，若不指定，则认为所有边权重一致
 */ var $bb2728380eb1d4ff$var$primMST = function primMST(graphData, weight) {
    var selectedEdges = [];
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a, _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    if (nodes.length === 0) return selectedEdges;
    // 从nodes[0]开始
    var currNode = nodes[0];
    var visited = new Set();
    visited.add(currNode);
    // 用二叉堆维护距已加入节点的其他节点的边的权值
    var compareWeight = function compareWeight(a, b) {
        if (weight) return a.weight - b.weight;
        return 0;
    };
    var edgeQueue = new (0, $33g0U.default)(compareWeight);
    (0, $lFtOT.getEdgesByNodeId)(currNode.id, edges).forEach(function(edge) {
        edgeQueue.insert(edge);
    });
    while(!edgeQueue.isEmpty()){
        // 选取与已加入的结点之间边权最小的结点
        var currEdge = edgeQueue.delMin();
        var source = currEdge.source;
        var target = currEdge.target;
        if (visited.has(source) && visited.has(target)) continue;
        selectedEdges.push(currEdge);
        if (!visited.has(source)) {
            visited.add(source);
            (0, $lFtOT.getEdgesByNodeId)(source, edges).forEach(function(edge) {
                edgeQueue.insert(edge);
            });
        }
        if (!visited.has(target)) {
            visited.add(target);
            (0, $lFtOT.getEdgesByNodeId)(target, edges).forEach(function(edge) {
                edgeQueue.insert(edge);
            });
        }
    }
    return selectedEdges;
};
/**
 * Kruskal algorithm，复杂度 O(E*logE), E: 边的数量
 * refer: https://en.wikipedia.org/wiki/Kruskal%27s_algorithm
 * @param graph
 * @param weight 指定用于作为边权重的属性，若不指定，则认为所有边权重一致
 * @return IEdge[] 返回构成MST的边的数组
 */ var $bb2728380eb1d4ff$var$kruskalMST = function kruskalMST(graphData, weight) {
    var selectedEdges = [];
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a, _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    if (nodes.length === 0) return selectedEdges;
    // 若指定weight，则将所有的边按权值从小到大排序
    var weightEdges = edges.map(function(edge) {
        return edge;
    });
    if (weight) weightEdges.sort(function(a, b) {
        return a.weight - b.weight;
    });
    var disjointSet = new (0, $6RkIX.default)(nodes.map(function(n) {
        return n.id;
    }));
    // 从权值最小的边开始，如果这条边连接的两个节点于图G中不在同一个连通分量中，则添加这条边
    // 直到遍历完所有点或边
    while(weightEdges.length > 0){
        var curEdge = weightEdges.shift();
        var source = curEdge.source;
        var target = curEdge.target;
        if (!disjointSet.connected(source, target)) {
            selectedEdges.push(curEdge);
            disjointSet.union(source, target);
        }
    }
    return selectedEdges;
};
/**
 * 最小生成树
 * refer: https://en.wikipedia.org/wiki/Kruskal%27s_algorithm
 * @param graph
 * @param weight 指定用于作为边权重的属性，若不指定，则认为所有边权重一致
 * @param algo 'prim' | 'kruskal' 算法类型
 * @return EdgeConfig[] 返回构成MST的边的数组
 */ var $bb2728380eb1d4ff$var$minimumSpanningTree = function minimumSpanningTree(graphData, weight, algo) {
    var algos = {
        prim: $bb2728380eb1d4ff$var$primMST,
        kruskal: $bb2728380eb1d4ff$var$kruskalMST
    };
    if (!algo) return $bb2728380eb1d4ff$var$kruskalMST(graphData, weight);
    return algos[algo](graphData, weight);
};
var $bb2728380eb1d4ff$export$2e2bcd8739ae039 = $bb2728380eb1d4ff$var$minimumSpanningTree;

});
parcelRegister("6RkIX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fe7c4b41089f215$export$2e2bcd8739ae039);
/**
 * 并查集 Disjoint set to support quick union
 */ var $4fe7c4b41089f215$var$UnionFind = /** @class */ function() {
    function UnionFind(items) {
        this.count = items.length;
        this.parent = {};
        for(var _i = 0, items_1 = items; _i < items_1.length; _i++){
            var i = items_1[_i];
            this.parent[i] = i;
        }
    }
    // find the root of the item
    UnionFind.prototype.find = function(item) {
        while(this.parent[item] !== item)item = this.parent[item];
        return item;
    };
    UnionFind.prototype.union = function(a, b) {
        var rootA = this.find(a);
        var rootB = this.find(b);
        if (rootA === rootB) return;
        // make the element with smaller root the parent
        if (rootA < rootB) {
            if (this.parent[b] !== b) this.union(this.parent[b], a);
            this.parent[b] = this.parent[a];
        } else {
            if (this.parent[a] !== a) this.union(this.parent[a], b);
            this.parent[a] = this.parent[b];
        }
    };
    // whether a and b are connected, i.e. a and b have the same root
    UnionFind.prototype.connected = function(a, b) {
        return this.find(a) === this.find(b);
    };
    return UnionFind;
}();
var $4fe7c4b41089f215$export$2e2bcd8739ae039 = $4fe7c4b41089f215$var$UnionFind;

});

parcelRegister("33g0U", function(module, exports) {

$parcel$export(module.exports, "default", () => $238e12e8bb0a120e$export$2e2bcd8739ae039);
var $238e12e8bb0a120e$var$defaultCompare = function defaultCompare(a, b) {
    return a - b;
};
var $238e12e8bb0a120e$var$MinBinaryHeap = /** @class */ function() {
    function MinBinaryHeap(compareFn) {
        if (compareFn === void 0) compareFn = $238e12e8bb0a120e$var$defaultCompare;
        this.compareFn = compareFn;
        this.list = [];
    }
    MinBinaryHeap.prototype.getLeft = function(index) {
        return 2 * index + 1;
    };
    MinBinaryHeap.prototype.getRight = function(index) {
        return 2 * index + 2;
    };
    MinBinaryHeap.prototype.getParent = function(index) {
        if (index === 0) return null;
        return Math.floor((index - 1) / 2);
    };
    MinBinaryHeap.prototype.isEmpty = function() {
        return this.list.length <= 0;
    };
    MinBinaryHeap.prototype.top = function() {
        return this.isEmpty() ? undefined : this.list[0];
    };
    MinBinaryHeap.prototype.delMin = function() {
        var top = this.top();
        var bottom = this.list.pop();
        if (this.list.length > 0) {
            this.list[0] = bottom;
            this.moveDown(0);
        }
        return top;
    };
    MinBinaryHeap.prototype.insert = function(value) {
        if (value !== null) {
            this.list.push(value);
            var index = this.list.length - 1;
            this.moveUp(index);
            return true;
        }
        return false;
    };
    MinBinaryHeap.prototype.moveUp = function(index) {
        var parent = this.getParent(index);
        while(index && index > 0 && this.compareFn(this.list[parent], this.list[index]) > 0){
            // swap
            var tmp = this.list[parent];
            this.list[parent] = this.list[index];
            this.list[index] = tmp;
            // [this.list[index], this.list[parent]] = [this.list[parent], this.list[index]]
            index = parent;
            parent = this.getParent(index);
        }
    };
    MinBinaryHeap.prototype.moveDown = function(index) {
        var _a;
        var element = index;
        var left = this.getLeft(index);
        var right = this.getRight(index);
        var size = this.list.length;
        if (left !== null && left < size && this.compareFn(this.list[element], this.list[left]) > 0) element = left;
        else if (right !== null && right < size && this.compareFn(this.list[element], this.list[right]) > 0) element = right;
        if (index !== element) {
            _a = [
                this.list[element],
                this.list[index]
            ], this.list[index] = _a[0], this.list[element] = _a[1];
            this.moveDown(element);
        }
    };
    return MinBinaryHeap;
}();
var $238e12e8bb0a120e$export$2e2bcd8739ae039 = $238e12e8bb0a120e$var$MinBinaryHeap;

});


parcelRegister("avAF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a693d099e06bbd8$export$2e2bcd8739ae039);

var $gGbI9 = parcelRequire("gGbI9");

var $lFtOT = parcelRequire("lFtOT");
/**
 * PageRank https://en.wikipedia.org/wiki/PageRank
 * refer: https://github.com/anvaka/ngraph.pagerank
 * @param graph
 * @param epsilon 判断是否收敛的精度值，默认 0.000001
 * @param linkProb 阻尼系数（dumping factor），指任意时刻，用户访问到某节点后继续访问该节点链接的下一个节点的概率，经验值 0.85
 */ var $7a693d099e06bbd8$var$pageRank = function pageRank(graphData, epsilon, linkProb) {
    if (typeof epsilon !== 'number') epsilon = 0.000001;
    if (typeof linkProb !== 'number') linkProb = 0.85;
    var distance = 1;
    var leakedRank = 0;
    var maxIterations = 1000;
    var _a = graphData.nodes, nodes = _a === void 0 ? [] : _a, _b = graphData.edges, edges = _b === void 0 ? [] : _b;
    var nodesCount = nodes.length;
    var currentRank;
    var curRanks = {};
    var prevRanks = {};
    // Initialize pageranks 初始化
    for(var j = 0; j < nodesCount; ++j){
        var node = nodes[j];
        var nodeId = node.id;
        curRanks[nodeId] = 1 / nodesCount;
        prevRanks[nodeId] = 1 / nodesCount;
    }
    var nodeDegree = (0, $gGbI9.default)(graphData);
    while(maxIterations > 0 && distance > epsilon){
        leakedRank = 0;
        for(var j = 0; j < nodesCount; ++j){
            var node = nodes[j];
            var nodeId = node.id;
            currentRank = 0;
            if (nodeDegree[node.id].inDegree === 0) curRanks[nodeId] = 0;
            else {
                var neighbors = (0, $lFtOT.getNeighbors)(nodeId, edges, 'source');
                for(var i = 0; i < neighbors.length; ++i){
                    var neighbor = neighbors[i];
                    var outDegree = nodeDegree[neighbor].outDegree;
                    if (outDegree > 0) currentRank += prevRanks[neighbor] / outDegree;
                }
                curRanks[nodeId] = linkProb * currentRank;
                leakedRank += curRanks[nodeId];
            }
        }
        leakedRank = (1 - leakedRank) / nodesCount;
        distance = 0;
        for(var j = 0; j < nodesCount; ++j){
            var node = nodes[j];
            var nodeId = node.id;
            currentRank = curRanks[nodeId] + leakedRank;
            distance += Math.abs(currentRank - prevRanks[nodeId]);
            prevRanks[nodeId] = currentRank;
        }
        maxIterations -= 1;
    }
    return prevRanks;
};
var $7a693d099e06bbd8$export$2e2bcd8739ae039 = $7a693d099e06bbd8$var$pageRank;

});

parcelRegister("8PJb7", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e6219dfa30476d$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $cpOcc = parcelRequire("cpOcc");

var $2jvve = parcelRequire("2jvve");

var $7mzeL = parcelRequire("7mzeL");

var $lFtOT = parcelRequire("lFtOT");
/**
 * 为 graphData 中每个节点生成邻居单元数组
 * @param graphData
 * @param spm
 * @param nodeLabelProp
 * @param k k-近邻
 */ var $66e6219dfa30476d$var$findKNeighborUnits = function findKNeighborUnits(graphData, spm, nodeLabelProp, k) {
    if (nodeLabelProp === void 0) nodeLabelProp = 'cluster';
    if (k === void 0) k = 2;
    var units = [];
    var nodes = graphData.nodes;
    spm.forEach(function(row, i) {
        units.push($66e6219dfa30476d$var$findKNeighborUnit(nodes, row, i, nodeLabelProp, k));
    });
    return units;
};
var $66e6219dfa30476d$var$findKNeighborUnit = function findKNeighborUnit(nodes, row, i, nodeLabelProp, k) {
    var unitNodeIdxs = [
        i
    ];
    var neighbors = [];
    var labelCountMap = {};
    row.forEach(function(v, j) {
        if (v <= k && i !== j) {
            unitNodeIdxs.push(j);
            neighbors.push(nodes[j]);
            var label = nodes[j][nodeLabelProp];
            if (!labelCountMap[label]) labelCountMap[label] = {
                count: 1,
                dists: [
                    v
                ]
            };
            else {
                labelCountMap[label].count++;
                labelCountMap[label].dists.push(v);
            }
        }
    });
    // 将 labelCountMap 中的 dists 按照从小到大排序，方便后面使用
    Object.keys(labelCountMap).forEach(function(label) {
        labelCountMap[label].dists = labelCountMap[label].dists.sort(function(a, b) {
            return a - b;
        });
    });
    return {
        nodeIdx: i,
        nodeId: nodes[i].id,
        nodeIdxs: unitNodeIdxs,
        neighbors: neighbors,
        neighborNum: unitNodeIdxs.length - 1,
        nodeLabelCountMap: labelCountMap
    };
};
/**
 * 随机寻找点对，满足距离小于 k
 * @param k 参数 k，表示 k-近邻
 * @param nodeNum 参数 length
 * @param maxNodePairNum 寻找点对的数量不超过 maxNodePairNum
 * @param spm 最短路径矩阵
 */ var $66e6219dfa30476d$var$findNodePairsRandomly = function findNodePairsRandomly(k, nodeNum, maxNodePairNum, kNeighborUnits, spm) {
    // 每个节点需要随机找出的点对数
    var nodePairNumEachNode = Math.ceil(maxNodePairNum / nodeNum);
    var nodePairMap = {};
    var foundNodePairCount = 0;
    // 遍历节点，为每个节点随机找出 nodePairNumEachNode 个点对，满足距离小于 k。找到的点对数量超过 maxNodePairNum 或所有节点遍历结束时终止
    kNeighborUnits.forEach(function(unit, i) {
        // 若未达到 nodePairNumEachNode，或循环次数小于最大循环次数(2 * nodeNum)，继续循环
        var nodePairForICount = 0;
        var outerLoopCount = 0;
        var neighbors = unit.nodeIdxs; // the first one is the center node
        var neighborNum = unit.neighborNum - 1;
        while(nodePairForICount < nodePairNumEachNode){
            // 另一端节点在节点数组中的的 index
            var oidx = neighbors[1 + Math.floor(Math.random() * neighborNum)];
            var innerLoopCount = 0;
            // 若随机得到的另一端 idx 不符合条件，则继续 random。条件是不是同一个节点、这个点对没有被记录过、距离小于 k
            while(nodePairMap["".concat(i, "-").concat(oidx)] || nodePairMap["".concat(oidx, "-").concat(i)]){
                oidx = Math.floor(Math.random() * nodeNum);
                innerLoopCount++;
                if (innerLoopCount > 2 * nodeNum) break; // 循环次数大于最大循环次数(2 * nodeNum)跳出循环，避免死循环
            }
            if (innerLoopCount < 2 * nodeNum) {
                // 未达到最大循环次数，说明找到了合适的另一端
                nodePairMap["".concat(i, "-").concat(oidx)] = {
                    start: i,
                    end: oidx,
                    distance: spm[i][oidx]
                };
                nodePairForICount++;
                foundNodePairCount++;
                // 如果当前找到的点对数量达到了上限，返回结果
                if (foundNodePairCount >= maxNodePairNum) return nodePairMap;
            }
            outerLoopCount++;
            if (outerLoopCount > 2 * nodeNum) break; // 循环次数大于最大循环次数(2 * nodeNum)跳出循环，避免死循环
        }
        // 这个节点没有找到足够 nodePairNumEachNode 的点对。更新 nodePairNumEachNode，让后续节点找更多的点对
        if (nodePairForICount < nodePairNumEachNode) {
            var gap = nodePairNumEachNode - nodePairForICount;
            nodePairNumEachNode = (nodePairNumEachNode + gap) / (nodeNum - i - 1);
        }
    });
    return nodePairMap;
};
/**
 * 计算所有 nodePairMap 中节点对的相交邻居诱导子图
 * @param nodePairMap 节点对 map，key 为 node1.id-node2.id，value 为 { startNodeIdx, endNodeIdx, distance }
 * @param neighborUnits 每个节点的邻居元数组
 * @param graphData 原图数据
 * @param edgeMap 边的 map，方便检索
 * @param cachedInducedGraphMap 缓存的结果，下次进入该函数将继续更新该缓存，若 key 在缓存中存在则不需要重复计算
 */ var $66e6219dfa30476d$var$getIntersectNeighborInducedGraph = function getIntersectNeighborInducedGraph(nodePairMap, neighborUnits, graphData, cachedInducedGraphMap) {
    var nodes = graphData.nodes;
    if (!cachedInducedGraphMap) cachedInducedGraphMap = {};
    Object.keys(nodePairMap).forEach(function(key) {
        var _a, _b;
        if (cachedInducedGraphMap && cachedInducedGraphMap[key]) return;
        cachedInducedGraphMap[key] = {
            nodes: [],
            edges: []
        };
        var pair = nodePairMap[key];
        var startUnitNodeIds = (_a = neighborUnits[pair.start]) === null || _a === void 0 ? void 0 : _a.nodeIdxs;
        var endUnitNodeIds = (_b = neighborUnits[pair.end]) === null || _b === void 0 ? void 0 : _b.nodeIdxs;
        if (!startUnitNodeIds || !endUnitNodeIds) return; // 不存在邻元，返回空图
        var endSet = new Set(endUnitNodeIds);
        var intersect = startUnitNodeIds.filter(function(x) {
            return endSet.has(x);
        }); // 可能会爆栈（在 1580 + 6 nodes full-connected 时出现）
        if (!intersect || !intersect.length) return; // 没有交集，返回空图
        var intersectIdMap = {};
        var intersectLength = intersect.length;
        for(var i = 0; i < intersectLength; i++){
            var node = nodes[intersect[i]];
            cachedInducedGraphMap[key].nodes.push(node); // 将交集中的点加入诱导子图
            intersectIdMap[node.id] = true;
        }
        // 遍历所有边数据，如果边的两端都在交集中，将该边加入诱导子图
        graphData.edges.forEach(function(edge) {
            if (intersectIdMap[edge.source] && intersectIdMap[edge.target]) cachedInducedGraphMap[key].edges.push(edge);
        });
    });
    return cachedInducedGraphMap;
};
/**
 * 计算 strcutre 在 graph 上的匹配数量
 * @param graph 图数据
 * @param structure 目前支持只有两个节点一条边的最简单结构
 * @param nodeLabelProp 节点类型字段名
 * @param edgeLabelProp 边类型字段名
 */ var $66e6219dfa30476d$var$getMatchedCount = function getMatchedCount(graph, structure, nodeLabelProp, edgeLabelProp) {
    var _a, _b;
    var nodeMap = {};
    graph.nodes.forEach(function(node) {
        nodeMap[node.id] = node;
    });
    var count = 0;
    if (!((_a = structure === null || structure === void 0 ? void 0 : structure.edges) === null || _a === void 0 ? void 0 : _a.length) || ((_b = structure === null || structure === void 0 ? void 0 : structure.nodes) === null || _b === void 0 ? void 0 : _b.length) < 2) return 0;
    graph.edges.forEach(function(e) {
        var sourceLabel = nodeMap[e.source][nodeLabelProp];
        var targetLabel = nodeMap[e.target][nodeLabelProp];
        var strNodeLabel1 = structure === null || structure === void 0 ? void 0 : structure.nodes[0][nodeLabelProp];
        var strNodeLabel2 = structure === null || structure === void 0 ? void 0 : structure.nodes[1][nodeLabelProp];
        var strEdgeLabel = structure === null || structure === void 0 ? void 0 : structure.edges[0][edgeLabelProp];
        if (e[edgeLabelProp] !== strEdgeLabel) return;
        if (sourceLabel === strNodeLabel1 && targetLabel === strNodeLabel2 || sourceLabel === strNodeLabel2 && targetLabel === strNodeLabel1) count++;
    });
    return count;
};
/**
 * structures 中寻找最具有代表性的一个。这个结构是使得 matchedCountMap 的分组方式类内间距最小，类间间距最大
 * @param matchedCountMap 每个 structure 分类后的各图匹配数量，格式 { [strcture.idx]: { [interInducedGraphKey]: count } }
 * @param structureNum strcuture 个数，与 matchedCountMap.length 对应
 * @param structures
 */ var $66e6219dfa30476d$var$findRepresentStructure = function findRepresentStructure(matchedCountMap, structureNum, structures) {
    var maxOffset = Infinity, representClusterType = 0;
    var _loop_1 = function _loop_1(i) {
        // 一种分组的 map，key 是 intGraph 的 key，value 是 structures[i] 的匹配个数
        var countMapI = matchedCountMap[i];
        // 按照 value 为该组排序，生成 keys 的数组：
        var sortedGraphKeys = Object.keys(countMapI).sort(function(a, b) {
            return countMapI[a] - countMapI[b];
        });
        // 共 100 个 graphKeys，将 graphKeys 按顺序分为 groupNum 组
        var groupNum = 10;
        var clusters = []; // 总共有 groupNum 个项
        sortedGraphKeys.forEach(function(key, j) {
            if (!clusters[j % groupNum]) clusters[j % groupNum] = {
                graphs: [],
                totalCount: 0,
                aveCount: 0
            };
            clusters[j % groupNum].graphs.push(key);
            clusters[j % groupNum].totalCount += countMapI[key];
        });
        // 计算 cluster 与 cluster 之间的距离 innerDist，每个 cluster 内部的距离 intraDist
        var aveIntraDist = 0; // 该类的类内平均值
        var aveCounts = []; // 类内平均匹配数量，将用于计算类间距离
        clusters.forEach(function(graphsInCluster) {
            // 类内均值
            var aveCount = graphsInCluster.totalCount / graphsInCluster.graphs.length;
            graphsInCluster.aveCount = aveCount;
            aveCounts.push(aveCount);
            // 对于每类，计算类内间距平均值
            var aveIntraPerCluster = 0;
            var graphsNum = graphsInCluster.length;
            graphsInCluster.graphs.forEach(function(graphKey1, j) {
                var graph1Count = countMapI[graphKey1];
                graphsInCluster.graphs.forEach(function(graphKey2, k) {
                    if (j === k) return;
                    aveIntraPerCluster += Math.abs(graph1Count - countMapI[graphKey2]);
                });
            });
            aveIntraPerCluster /= graphsNum * (graphsNum - 1) / 2;
            aveIntraDist += aveIntraPerCluster;
        });
        aveIntraDist /= clusters.length;
        // 用类内均值计算类间距
        var aveInterDist = 0; // 类间间距平均值
        aveCounts.forEach(function(aveCount1, j) {
            aveCounts.forEach(function(aveCount2, k) {
                if (j === k) return;
                aveInterDist += Math.abs(aveCount1 - aveCount2);
            });
            aveInterDist /= aveCounts.length * (aveCounts.length - 1) / 2;
        });
        // 寻找 (类间间距均值-类内间距均值) 最大的一种分组方式（对应的 structure 就是最终要找的唯一 DS(G)）
        var offset = aveInterDist - aveIntraDist;
        if (maxOffset < offset) {
            maxOffset = offset;
            representClusterType = i;
        }
    };
    for(var i = 0; i < structureNum; i++)_loop_1(i);
    return {
        structure: structures[representClusterType],
        structureCountMap: matchedCountMap[representClusterType]
    };
};
var $66e6219dfa30476d$var$getNodeMaps = function getNodeMaps(nodes, nodeLabelProp) {
    var nodeMap = {}, nodeLabelMap = {};
    nodes.forEach(function(node, i) {
        nodeMap[node.id] = {
            idx: i,
            node: node,
            degree: 0,
            inDegree: 0,
            outDegree: 0
        };
        var label = node[nodeLabelProp];
        if (!nodeLabelMap[label]) nodeLabelMap[label] = [];
        nodeLabelMap[label].push(node);
    });
    return {
        nodeMap: nodeMap,
        nodeLabelMap: nodeLabelMap
    };
};
var $66e6219dfa30476d$var$getEdgeMaps = function getEdgeMaps(edges, edgeLabelProp, nodeMap) {
    var edgeMap = {}, edgeLabelMap = {};
    edges.forEach(function(edge, i) {
        edgeMap["".concat((0, $lFtOT.uniqueId))] = {
            idx: i,
            edge: edge
        };
        var label = edge[edgeLabelProp];
        if (!edgeLabelMap[label]) edgeLabelMap[label] = [];
        edgeLabelMap[label].push(edge);
        var sourceNode = nodeMap[edge.source];
        if (sourceNode) {
            sourceNode.degree++;
            sourceNode.outDegree++;
        }
        var targetNode = nodeMap[edge.target];
        if (targetNode) {
            targetNode.degree++;
            targetNode.inDegree++;
        }
    });
    return {
        edgeMap: edgeMap,
        edgeLabelMap: edgeLabelMap
    };
};
/**
 * 输出最短路径的 map，key 为 sourceNode.id-targetNode.id，value 为这两个节点的最短路径长度
 * @param nodes
 * @param spm
 * @param directed
 */ var $66e6219dfa30476d$var$getSpmMap = function getSpmMap(nodes, spm, directed) {
    var length = spm.length;
    var map = {};
    spm.forEach(function(row, i) {
        var start = directed ? 0 : i + 1;
        var iId = nodes[i].id;
        for(var j = start; j < length; j++){
            if (i === j) continue;
            var jId = nodes[j].id;
            var dist = row[j];
            map["".concat(iId, "-").concat(jId)] = dist;
            if (!directed) map["".concat(jId, "-").concat(iId)] = dist;
        }
    });
    return map;
};
/**
 * 计算一对节点（node1，node2）的 NDS 距离
 * @param graph 原图数据
 * @param node1
 * @param node2
 */ var $66e6219dfa30476d$var$getNDSDist = function getNDSDist(graph, node1, node2, nodeMap, spDist, kNeighborUnits, structure, nodeLabelProp, edgeLabelProp, cachedNDSMap, cachedInterInducedGraph) {
    var _a;
    var key = "".concat(node1.id, "-").concat(node2.id);
    if (cachedNDSMap && cachedNDSMap[key]) return cachedNDSMap[key];
    var interInducedGraph = cachedInterInducedGraph ? cachedInterInducedGraph[key] : undefined;
    // 若没有缓存相交邻居诱导子图，计算
    if (!interInducedGraph) {
        var pairMap = (_a = {}, _a[key] = {
            start: nodeMap[node1.id].idx,
            end: nodeMap[node2.id].idx,
            distance: spDist
        }, _a);
        cachedInterInducedGraph = $66e6219dfa30476d$var$getIntersectNeighborInducedGraph(pairMap, kNeighborUnits, graph, cachedInterInducedGraph);
        interInducedGraph = cachedInterInducedGraph[key];
    }
    return $66e6219dfa30476d$var$getMatchedCount(interInducedGraph, structure, nodeLabelProp, edgeLabelProp);
};
/**
 * 计算 pattern 上绩点的度数并存储到 minPatternNodeLabelDegreeMap
 */ var $66e6219dfa30476d$var$stashPatternNodeLabelDegreeMap = function stashPatternNodeLabelDegreeMap(minPatternNodeLabelDegreeMap, neighborLabel, patternNodeMap, patternNodeLabelMap) {
    var _a, _b, _c;
    var minPatternNodeLabelDegree = (_a = minPatternNodeLabelDegreeMap[neighborLabel]) === null || _a === void 0 ? void 0 : _a.degree;
    var minPatternNodeLabelInDegree = (_b = minPatternNodeLabelDegreeMap[neighborLabel]) === null || _b === void 0 ? void 0 : _b.inDegree;
    var minPatternNodeLabelOutDegree = (_c = minPatternNodeLabelDegreeMap[neighborLabel]) === null || _c === void 0 ? void 0 : _c.outDegree;
    if (minPatternNodeLabelDegreeMap[neighborLabel] === undefined) {
        minPatternNodeLabelDegree = Infinity;
        minPatternNodeLabelInDegree = Infinity;
        minPatternNodeLabelOutDegree = Infinity;
        patternNodeLabelMap[neighborLabel].forEach(function(patternNodeWithLabel) {
            var patternNodeDegree = patternNodeMap[patternNodeWithLabel.id].degree;
            if (minPatternNodeLabelDegree > patternNodeDegree) minPatternNodeLabelDegree = patternNodeDegree;
            var patternNodeInDegree = patternNodeMap[patternNodeWithLabel.id].inDegree;
            if (minPatternNodeLabelInDegree > patternNodeInDegree) minPatternNodeLabelInDegree = patternNodeInDegree;
            var patternNodeOutDegree = patternNodeMap[patternNodeWithLabel.id].outDegree;
            if (minPatternNodeLabelOutDegree > patternNodeOutDegree) minPatternNodeLabelOutDegree = patternNodeOutDegree;
        });
        minPatternNodeLabelDegreeMap[neighborLabel] = {
            degree: minPatternNodeLabelDegree,
            inDegree: minPatternNodeLabelInDegree,
            outDegree: minPatternNodeLabelOutDegree
        };
    }
    return {
        minPatternNodeLabelDegree: minPatternNodeLabelDegree,
        minPatternNodeLabelInDegree: minPatternNodeLabelInDegree,
        minPatternNodeLabelOutDegree: minPatternNodeLabelOutDegree
    };
};
/**
 * GADDI 模式匹配
 * @param graphData 原图数据
 * @param pattern 搜索图（需要在原图上搜索的模式）数据
 * @param directed 是否计算有向图，默认 false
 * @param k 参数 k，表示 k-近邻
 * @param length 参数 length
 * @param nodeLabelProp 节点数据中代表节点标签（分类信息）的属性名。默认为 cluster
 * @param edgeLabelProp 边数据中代表边标签（分类信息）的属性名。默认为 cluster
 */ var $66e6219dfa30476d$var$GADDI = function GADDI(graphData, pattern, directed, k, length, nodeLabelProp, edgeLabelProp) {
    var _a;
    if (directed === void 0) directed = false;
    if (nodeLabelProp === void 0) nodeLabelProp = 'cluster';
    if (edgeLabelProp === void 0) edgeLabelProp = 'cluster';
    if (!graphData || !graphData.nodes) return;
    // 分为三步：
    // 0. 预计算：节点/边数，邻接矩阵、最短路径矩阵
    // 1. 处理原图 graphData。再分为 1~5 小步
    // 2. 匹配
    // console.log("----- stage-pre: preprocessing -------");
    // -------- 第零步，预计算：节点/边数，邻接矩阵、最短路径矩阵-------
    var nodeNum = graphData.nodes.length;
    if (!nodeNum) return;
    // console.log("----- stage-pre.1: calc shortest path matrix for graph -------");
    var spm = (0, $cpOcc.default)(graphData, directed);
    // console.log(
    //   "----- stage-pre.2: calc shortest path matrix for pattern -------"
    // );
    var patternSpm = (0, $cpOcc.default)(pattern, directed);
    // console.log(
    //   "----- stage-pre.3: calc shortest path matrix map for graph -------"
    // );
    var spmMap = $66e6219dfa30476d$var$getSpmMap(graphData.nodes, spm, directed);
    // console.log(
    //   "----- stage-pre.4: calc shortest path matrix map for pattern -------"
    // );
    var patternSpmMap = $66e6219dfa30476d$var$getSpmMap(pattern.nodes, patternSpm, directed);
    // console.log("----- stage-pre.5: establish maps -------");
    // 节点的 map，以 id 为 id 映射，方便后续快速检索
    var _b = $66e6219dfa30476d$var$getNodeMaps(graphData.nodes, nodeLabelProp), nodeMap = _b.nodeMap, nodeLabelMap = _b.nodeLabelMap;
    var _c = $66e6219dfa30476d$var$getNodeMaps(pattern.nodes, nodeLabelProp), patternNodeMap = _c.nodeMap, patternNodeLabelMap = _c.nodeLabelMap;
    // 计算节点度数
    $66e6219dfa30476d$var$getEdgeMaps(graphData.edges, edgeLabelProp, nodeMap);
    var patternEdgeLabelMap = $66e6219dfa30476d$var$getEdgeMaps(pattern.edges, edgeLabelProp, patternNodeMap).edgeLabelMap;
    // 若未指定 length，自动计算 pattern 半径（最短路径最大值）
    var patternSpmSpread = [];
    patternSpm === null || patternSpm === void 0 || patternSpm.forEach(function(row) {
        patternSpmSpread = patternSpmSpread.concat(row);
    });
    if (!length) length = Math.max.apply(Math, (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], patternSpmSpread, false), [
        2
    ], false));
    if (!k) k = length;
    // console.log("params", directed, length, k);
    // console.log("----- stage-pre.6: calc k neighbor units -------");
    // 计算每个节点的 k 邻元集合
    var kNeighborUnits = $66e6219dfa30476d$var$findKNeighborUnits(graphData, spm, nodeLabelProp, k);
    var patternKNeighborUnits = $66e6219dfa30476d$var$findKNeighborUnits(pattern, patternSpm, nodeLabelProp, k);
    // console.log(
    //   "----- stage0: going to processing graph and find intersect neighbor induced graphs -------"
    // );
    // console.log("----- stage0.1: going to select random node pairs -------");
    // -------- 第一步，处理原图 graphData-------
    // 1.1. 随机选择最多 100 个点对，满足距离小于 Length 和 k
    // 当 graphData 少于 20 个节点，则不能找出 100 个点对，只找出不多于 n(n-1)/2 个点对
    var maxNodePairNum = Math.min(100, nodeNum * (nodeNum - 1) / 2);
    var nodePairsMap = $66e6219dfa30476d$var$findNodePairsRandomly(k, nodeNum, maxNodePairNum, kNeighborUnits, spm);
    // console.log(
    //   "----- stage0.2: going to calculate intersect neighbor induced graphs -------"
    // );
    // 1.2. 生成上面节点对的相应相交邻居诱导子图。格式为 {'beginNodeIdx-endNodeIdx': {nodes: [], edges: []}}
    var intGMap = $66e6219dfa30476d$var$getIntersectNeighborInducedGraph(nodePairsMap, kNeighborUnits, graphData);
    // 1.3. 使用 gSpan 算法（frequent graph mining）计算 ISIntG 的前 10 个频率最高的子结构（3-4条边）
    var top = 10, minSupport = 1, minNodeNum = 1, maxNodeNum = 4;
    var params = {
        graphs: intGMap,
        nodeLabelProp: nodeLabelProp,
        edgeLabelProp: edgeLabelProp,
        minSupport: minSupport,
        minNodeNum: minNodeNum,
        maxNodeNum: maxNodeNum,
        directed: directed
    };
    // console.log(
    //   "----- stage1: (gSpan) going to find frequent structure dsG -------"
    // );
    // console.log("----- stage1.1: going to run gSpan -------");
    // 暂时假设生成的 sub structure 都只有一条边
    var freStructures = (0, $2jvve.default)(params).slice(0, top);
    // structureNum 可能小于 top
    var structureNum = freStructures.length;
    // 1.4. 计算上述 10 个子结构在 intGMap 中每个诱导子图的匹配个数
    var matchedCountMap = [];
    freStructures.forEach(function(structure, i) {
        matchedCountMap[i] = {};
        Object.keys(intGMap).forEach(function(key) {
            var graph = intGMap[key];
            var subStructureCount = $66e6219dfa30476d$var$getMatchedCount(graph, structure, nodeLabelProp, edgeLabelProp);
            matchedCountMap[i][key] = subStructureCount;
        });
    });
    // console.log(
    //   "----- stage1.1: going to find the most represent strucutre -------"
    // );
    // 1.5. 对于每个子结构，根据匹配个数为 intGMap 中的诱导子图分组，生成 structureNum 种分组
    // 计算每种分组的类间距和类内间距，找到类间距最大、类内间距最小的一种分组，这种分组对应的子结构被选为唯一代表性子结构 DS(G)
    var _d = $66e6219dfa30476d$var$findRepresentStructure(matchedCountMap, structureNum, freStructures), dsG = _d.structure, ndsDist = _d.structureCountMap;
    // -------- 第二步，匹配-------
    // 2.1 找到从 Q 中的一个节点作为起始节点，寻找 G 中的匹配。这个其实节点的标签可以在 G 中找到最多的节点
    var beginPNode = pattern.nodes[0], candidates = [], label = (_a = pattern.nodes[0]) === null || _a === void 0 ? void 0 : _a[nodeLabelProp], maxNodeNumWithSameLabel = -Infinity;
    pattern.nodes.forEach(function(node) {
        var pLabel = node[nodeLabelProp];
        var nodesWithSameLabel = nodeLabelMap[pLabel];
        if ((nodesWithSameLabel === null || nodesWithSameLabel === void 0 ? void 0 : nodesWithSameLabel.length) > maxNodeNumWithSameLabel) {
            maxNodeNumWithSameLabel = nodesWithSameLabel.length;
            candidates = nodesWithSameLabel;
            label = pLabel;
            beginPNode = node;
        }
    });
    // console.log("----- stage2: going to find candidates -------");
    // 全局缓存，避免重复计算
    var minPatternNodeLabelDegreeMap = {}; // key 是 label，value 是该 label 节点的最小度数
    var patternIntGraphMap = {}, patternNDSDist = {}, // key 为 node.id-node.id
    patternNDSDistMap = {}; // key 为 node.id-label2，value nds距离值数组（按从大到小排序，无需关心具体对应哪个 node2）
    // 2.2.2 对于 Q 中的另一个标签的 k 个节点，计算它们到 node 的最短路径以及 NDS 距离
    var patternSpDist = {};
    var patternSpDistBack = {};
    Object.keys(patternNodeLabelMap).forEach(function(label2, j) {
        patternSpDist[label2] = [];
        if (directed) patternSpDistBack[label2] = [];
        var maxDist = -Infinity;
        var patternNodesWithLabel2 = patternNodeLabelMap[label2];
        var patternNodePairMap = {};
        patternNodesWithLabel2.forEach(function(nodeWithLabel2) {
            var dist = patternSpmMap["".concat(beginPNode.id, "-").concat(nodeWithLabel2.id)];
            dist && patternSpDist[label2].push(dist);
            if (maxDist < dist) maxDist = dist;
            patternNodePairMap["".concat(beginPNode.id, "-").concat(nodeWithLabel2.id)] = {
                start: 0,
                end: patternNodeMap[nodeWithLabel2.id].idx,
                distance: dist
            };
            if (directed) {
                var distBack = patternSpmMap["".concat(nodeWithLabel2.id, "-").concat(beginPNode.id)];
                distBack && patternSpDistBack[label2].push(distBack);
            }
        });
        // spDist[label2] 按照从小到大排序
        patternSpDist[label2] = patternSpDist[label2].sort(function(a, b) {
            return a - b;
        });
        if (directed) patternSpDistBack[label2] = patternSpDistBack[label2].sort(function(a, b) {
            return a - b;
        });
        // 计算 Q 中所有 label2 节点到 beginPNode 的 NDS 距离
        // 所有 label2 节点到 beginPNode 的邻居相交诱导子图：
        // key: node1.id-node2.id
        patternIntGraphMap = $66e6219dfa30476d$var$getIntersectNeighborInducedGraph(patternNodePairMap, patternKNeighborUnits, pattern, patternIntGraphMap);
        // pattern 中 beginNode 到当前 label2 节点 的 NDS 距离（数组，无需关心具体对应到哪个节点）
        var currentPatternNDSDistArray = [];
        Object.keys(patternNodePairMap).forEach(function(key) {
            if (patternNDSDist[key]) {
                currentPatternNDSDistArray.push(patternNDSDist[key]);
                return; // 缓存过则不需要再次计算
            }
            var patternIntGraph = patternIntGraphMap[key];
            patternNDSDist[key] = $66e6219dfa30476d$var$getMatchedCount(patternIntGraph, dsG, nodeLabelProp, edgeLabelProp);
            currentPatternNDSDistArray.push(patternNDSDist[key]);
        });
        // 根据值为 currentPatternNDSDist 从大到小排序
        currentPatternNDSDistArray = currentPatternNDSDistArray.sort(function(a, b) {
            return b - a;
        });
        patternNDSDistMap["".concat(beginPNode.id, "-").concat(label2)] = currentPatternNDSDistArray;
        if (label2 === label) return;
        var candidatesNum = (candidates === null || candidates === void 0 ? void 0 : candidates.length) || 0;
        var _loop_4 = function _loop_4(m) {
            var cNode = candidates[m];
            // prune1：若 candidates 中节点 cNode 的 kNeighborUnits 中标签为 label2 的节点个数少于 pattern 中 label2 个数，删去它
            var graphNeighborUnit = kNeighborUnits[nodeMap[cNode.id].idx];
            var graphNeighborUnitCountMap = graphNeighborUnit.nodeLabelCountMap[label2];
            var patternLabel2Num = patternNodeLabelMap[label2].length;
            if (!graphNeighborUnitCountMap || graphNeighborUnitCountMap.count < patternLabel2Num) {
                candidates.splice(m, 1);
                return "continue";
            }
            // prune2：若 candidates 中节点 cNode 到 kNeighborUnits 中标签为 label2 的节点最短路径大于 patternSpDist[label2]，删去它
            // (prune2 规则即：candidate 相关的最短路径的最大 spDist[label2].length 个，按照大小顺序依次和 patternSpDist[label2] 中的值比较，只要遇到一个是 G > Q 的，就删去这个 candidate)
            var prune2Invalid = false;
            for(var n = 0; n < patternLabel2Num; n++)if (graphNeighborUnitCountMap.dists[n] > patternSpDist[label2][n]) {
                prune2Invalid = true;
                break;
            }
            if (prune2Invalid) {
                candidates.splice(m, 1);
                return "continue";
            }
            // prune3：若 candidates 中节点 cNode 到 kNeighborUnits 中标签为 label2 的节点 NDS 距离小于 patternNDSDist[beginNode.id-label2]，删去它
            // TODO：prune3，currentPatternNDSDistArray 与 currentNDSDist 的比较
            // 计算 G 中所有 label2 节点到 cNode 的 NDS 距离
            // 所有 label2 节点到 cNode 的邻居相交诱导子图：
            var cNodePairMap = {};
            graphNeighborUnit.neighbors.forEach(function(neighborNode) {
                var dist = spmMap["".concat(cNode.id, "-").concat(neighborNode.id)];
                cNodePairMap["".concat(cNode.id, "-").concat(neighborNode.id)] = {
                    start: nodeMap[cNode.id].idx,
                    end: nodeMap[neighborNode.id].idx,
                    distance: dist
                };
            });
            // 更新 intGMap
            intGMap = $66e6219dfa30476d$var$getIntersectNeighborInducedGraph(cNodePairMap, kNeighborUnits, graphData, intGMap);
            // candidate 到它周围 label2 节点的 NDS 距离, key 是 node.id-node.id
            var currentNDSDistArray = [];
            Object.keys(cNodePairMap).forEach(function(key) {
                if (ndsDist[key]) {
                    currentNDSDistArray.push(ndsDist[key]);
                    return; // 缓存过则不需要再次计算
                }
                var intGraph = intGMap[key];
                ndsDist[key] = $66e6219dfa30476d$var$getMatchedCount(intGraph, dsG, nodeLabelProp, edgeLabelProp);
                currentNDSDistArray.push(ndsDist[key]);
            });
            // 根据值为 currentNDSDistArray 从大到小排序
            currentNDSDistArray = currentNDSDistArray.sort(function(a, b) {
                return b - a;
            });
            var prune3Invalid = false;
            for(var n = 0; n < patternLabel2Num; n++)if (currentNDSDistArray[n] < currentPatternNDSDistArray[n]) {
                prune3Invalid = true;
                break;
            }
            if (prune3Invalid) {
                candidates.splice(m, 1);
                return "continue";
            }
        };
        for(var m = candidatesNum - 1; m >= 0; m--)_loop_4(m);
    });
    var candidateGraphs = [];
    // console.log(
    //   "----- stage3: going to splice neighbors for each candidate graph -------"
    // );
    // candidates 经过筛选后，以每个 candidate 为中心，生成 Length-neighbor 的邻居诱导子图
    // 并在诱导子图中去除不可能在 Q 上找到匹配的点：在 Q 上不存在的 label，其他 label 到 candidate 的最大最短距离符合 Q、NDS 距离符合 Q
    candidates === null || candidates === void 0 || candidates.forEach(function(candidate) {
        var nodeIdx = nodeMap[candidate.id].idx;
        var lengthNeighborUnit = $66e6219dfa30476d$var$findKNeighborUnit(graphData.nodes, spm[nodeIdx], nodeIdx, nodeLabelProp, length);
        var neighborNodes = lengthNeighborUnit.neighbors;
        // 删除不可能找到匹配的邻居点
        var neighborNum = neighborNodes.length;
        var unmatched = false;
        for(var i = neighborNum - 1; i >= 0; i--){
            // 如果通过裁剪，符合条件的节点数量已过少，说明不能匹配这个 candidate 相关的图
            if (neighborNodes.length + 1 < pattern.nodes.length) {
                unmatched = true;
                return;
            }
            var neighborNode = neighborNodes[i];
            var neighborLabel = neighborNode[nodeLabelProp];
            // prune1: 若该邻居点的 label 不存在于 pattern 中，移除这个点
            if (!patternNodeLabelMap[neighborLabel] || !patternNodeLabelMap[neighborLabel].length) {
                neighborNodes.splice(i, 1);
                continue;
            }
            // prune2: 若该邻居点到 candidate 的最短路径比和它有相同 label 的节点到 beginPNode 的最大最短路径长度长，移除这个点
            // prune2.1: 如果没有这个标签到 beginPNode 的距离记录，说明 pattern 上（可能 beginPNode 是这个 label）没有其他这个 label 的节点
            if (!patternSpDist[neighborLabel] || !patternSpDist[neighborLabel].length) {
                neighborNodes.splice(i, 1);
                continue;
            }
            var key = "".concat(candidate.id, "-").concat(neighborNode.id);
            // prune2.2
            var distToCandidate = spmMap[key];
            var idx = patternSpDist[neighborLabel].length - 1;
            var maxDistWithLabelInPattern = patternSpDist[neighborLabel][idx]; // patternSpDist[neighborLabel] 已经按照从小到大排序
            if (distToCandidate > maxDistWithLabelInPattern) {
                neighborNodes.splice(i, 1);
                continue;
            }
            if (directed) {
                var keyBack = "".concat(neighborNode.id, "-").concat(candidate.id);
                var distFromCandidate = spmMap[keyBack];
                idx = patternSpDistBack[neighborLabel].length - 1;
                var maxBackDistWithLabelInPattern = patternSpDistBack[neighborLabel][idx];
                if (distFromCandidate > maxBackDistWithLabelInPattern) {
                    neighborNodes.splice(i, 1);
                    continue;
                }
            }
            // prune3: 若该邻居点到 candidate 的 NDS 距离比和它有相同 label 的节点到 beginPNode 的最小 NDS 距离小，移除这个点
            var ndsToCandidate = ndsDist[key] ? ndsDist[key] : $66e6219dfa30476d$var$getNDSDist(graphData, candidate, neighborNode, nodeMap, distToCandidate, kNeighborUnits, dsG, nodeLabelProp, edgeLabelProp, ndsDist, intGMap);
            var patternKey = "".concat(beginPNode.id, "-").concat(neighborLabel);
            var minNdsWithLabelInPattern = patternNDSDistMap[patternKey][patternNDSDistMap[patternKey].length - 1]; // patternNDSDist[key] 一定存在
            if (ndsToCandidate < minNdsWithLabelInPattern) {
                neighborNodes.splice(i, 1);
                continue;
            }
            // prune4: 若该邻居点的度数小于 pattern 同 label 节点最小度数，删去该点
            var _a = $66e6219dfa30476d$var$stashPatternNodeLabelDegreeMap(minPatternNodeLabelDegreeMap, neighborLabel, patternNodeMap, patternNodeLabelMap), minPatternNodeLabelDegree = _a.minPatternNodeLabelDegree, minPatternNodeLabelInDegree = _a.minPatternNodeLabelInDegree, minPatternNodeLabelOutDegree = _a.minPatternNodeLabelOutDegree;
            if (nodeMap[neighborNode.id].degree < minPatternNodeLabelDegree) {
                neighborNodes.splice(i, 1);
                continue;
            }
        }
        // 节点在个数上符合匹配（不少于 pattern 的节点个数），现在筛选相关边
        if (!unmatched) candidateGraphs.push({
            nodes: [
                candidate
            ].concat(neighborNodes)
        });
    });
    // console.log(
    //   "----- stage4: going to splice edges and neighbors for each candidate graph -------"
    // );
    var undirectedLengthsToBeginPNode = (0, $7mzeL.default)(pattern, beginPNode.id, false).length;
    var undirectedLengthsToBeginPNodeLabelMap = {};
    if (directed) {
        Object.keys(undirectedLengthsToBeginPNode).forEach(function(nodeId) {
            var nodeLabel = patternNodeMap[nodeId].node[nodeLabelProp];
            if (!undirectedLengthsToBeginPNodeLabelMap[nodeLabel]) undirectedLengthsToBeginPNodeLabelMap[nodeLabel] = [
                undirectedLengthsToBeginPNode[nodeId]
            ];
            else undirectedLengthsToBeginPNodeLabelMap[nodeLabel].push(undirectedLengthsToBeginPNode[nodeId]);
        });
        Object.keys(undirectedLengthsToBeginPNodeLabelMap).forEach(function(pLabel) {
            undirectedLengthsToBeginPNodeLabelMap[pLabel].sort(function(a, b) {
                return a - b;
            });
        });
    } else undirectedLengthsToBeginPNodeLabelMap = patternSpDist;
    // 现在 candidateGraphs 里面只有节点，进行边的筛选
    var candidateGraphNum = candidateGraphs.length;
    var _loop_2 = function _loop_2(i) {
        var candidateGraph = candidateGraphs[i];
        var candidate = candidateGraph.nodes[0];
        var candidateNodeLabelCountMap = {};
        var candidateNodeMap = {};
        candidateGraph.nodes.forEach(function(node, q) {
            candidateNodeMap[node.id] = {
                idx: q,
                node: node,
                degree: 0,
                inDegree: 0,
                outDegree: 0
            };
            var cNodeLabel = node[nodeLabelProp];
            if (!candidateNodeLabelCountMap[cNodeLabel]) candidateNodeLabelCountMap[cNodeLabel] = 1;
            else candidateNodeLabelCountMap[cNodeLabel]++;
        });
        // 根据 candidate 和 neighborNodes 中的节点生成 G 的诱导子图
        // 即，将 graphData 上两端都在 candidateGraph.nodes 中的边放入 candidateEdges
        var candidateEdges = [];
        var edgeLabelCountMap = {};
        graphData.edges.forEach(function(edge) {
            if (candidateNodeMap[edge.source] && candidateNodeMap[edge.target]) {
                candidateEdges.push(edge);
                if (!edgeLabelCountMap[edge[edgeLabelProp]]) edgeLabelCountMap[edge[edgeLabelProp]] = 1;
                else edgeLabelCountMap[edge[edgeLabelProp]]++;
                candidateNodeMap[edge.source].degree++;
                candidateNodeMap[edge.target].degree++;
                candidateNodeMap[edge.source].outDegree++;
                candidateNodeMap[edge.target].inDegree++;
            }
        });
        // prune：若有一个 edgeLabel 在 candidateGraph 上的个数少于 pattern，去除该图
        var pattenrEdgeLabelNum = Object.keys(patternEdgeLabelMap).length;
        var prunedByEdgeLabel = false;
        for(var e = 0; e < pattenrEdgeLabelNum; e++){
            var label_1 = Object.keys(patternEdgeLabelMap)[e];
            if (!edgeLabelCountMap[label_1] || edgeLabelCountMap[label_1] < patternEdgeLabelMap[label_1].length) {
                prunedByEdgeLabel = true;
                break;
            }
        }
        if (prunedByEdgeLabel) {
            candidateGraphs.splice(i, 1);
            return "continue";
        }
        // 遍历 candidateEdges，进行边的筛选
        var candidateEdgeNum = candidateEdges.length;
        // prune：若边数过少，去除该图
        if (candidateEdgeNum < pattern.edges.length) {
            candidateGraphs.splice(i, 1);
            return "break";
        }
        var candidateGraphInvalid = false;
        var _loop_5 = function _loop_5(e) {
            var edge = candidateEdges[e];
            var edgeLabel = edge[edgeLabelProp];
            var patternEdgesWithLabel = patternEdgeLabelMap[edgeLabel];
            // prune 1: 若边的 label 不存在于 pattern 边 label 中，去除该边
            if (!patternEdgesWithLabel || !patternEdgesWithLabel.length) {
                edgeLabelCountMap[edgeLabel]--;
                // 若这个 label 的 count 减少之后，该 label 的边数不足，去除该图
                if (patternEdgesWithLabel && edgeLabelCountMap[edgeLabel] < patternEdgesWithLabel.length) {
                    candidateGraphInvalid = true;
                    return "break";
                }
                candidateEdges.splice(e, 1);
                candidateNodeMap[edge.source].degree--;
                candidateNodeMap[edge.target].degree--;
                candidateNodeMap[edge.source].outDegree--;
                candidateNodeMap[edge.target].inDegree--;
                return "continue";
            }
            // prune 2: 若边的 label +两端 label 的三元组关系不能在 pattern 中找到，去除该边
            var sourceLabel = candidateNodeMap[edge.source].node[nodeLabelProp];
            var targetLabel = candidateNodeMap[edge.target].node[nodeLabelProp];
            var edgeMatched = false;
            patternEdgesWithLabel.forEach(function(patternEdge) {
                var patternSource = patternNodeMap[patternEdge.source].node;
                var patternTarget = patternNodeMap[patternEdge.target].node;
                if (patternSource[nodeLabelProp] === sourceLabel && patternTarget[nodeLabelProp] === targetLabel) edgeMatched = true;
                if (!directed && patternSource[nodeLabelProp] === targetLabel && patternTarget[nodeLabelProp] === sourceLabel) edgeMatched = true;
            });
            if (!edgeMatched) {
                edgeLabelCountMap[edgeLabel]--;
                // 若这个 label 的 count 减少之后，该 label 的边数不足，去除该图
                if (patternEdgesWithLabel && edgeLabelCountMap[edgeLabel] < patternEdgesWithLabel.length) {
                    candidateGraphInvalid = true;
                    return "break";
                }
                candidateEdges.splice(e, 1);
                candidateNodeMap[edge.source].degree--;
                candidateNodeMap[edge.target].degree--;
                candidateNodeMap[edge.source].outDegree--;
                candidateNodeMap[edge.target].inDegree--;
                return "continue";
            }
        };
        for(var e = candidateEdgeNum - 1; e >= 0; e--){
            var state_2 = _loop_5(e);
            if (state_2 === "break") break;
        }
        // prune2: 删除边的过程中，发现边数过少/边 label 数过少时，去除该图
        if (candidateGraphInvalid) {
            candidateGraphs.splice(i, 1);
            return "continue";
        }
        candidateGraph.edges = candidateEdges;
        var lengthsToCandidate = (0, $7mzeL.default)(candidateGraph, candidateGraph.nodes[0].id, false).length;
        Object.keys(lengthsToCandidate).reverse().forEach(function(targetId) {
            if (targetId === candidateGraph.nodes[0].id || candidateGraphInvalid) return;
            // prune4: 通过上述裁剪，可能导致该邻居子图变为不连通。裁剪掉目前在这个邻居子图中和 candidate（第一个节点）不连通的节点
            if (lengthsToCandidate[targetId] === Infinity) {
                var targetNodeLabel = candidateNodeMap[targetId].node[nodeLabelProp];
                candidateNodeLabelCountMap[targetNodeLabel]--;
                if (candidateNodeLabelCountMap[targetNodeLabel] < patternNodeLabelMap[targetNodeLabel].length) {
                    candidateGraphInvalid = true;
                    return;
                }
                var idx = candidateGraph.nodes.indexOf(candidateNodeMap[targetId].node);
                candidateGraph.nodes.splice(idx, 1);
                candidateNodeMap[targetId] = undefined;
                return;
            }
            // prune5: 经过边裁剪后，可能又出现了最短路径过长的节点 （比 pattern 中同 label 的节点到 beginNode 最大最短距离远），删去这些节点
            var nLabel = nodeMap[targetId].node[nodeLabelProp];
            if (!undirectedLengthsToBeginPNodeLabelMap[nLabel] || !undirectedLengthsToBeginPNodeLabelMap[nLabel].length || lengthsToCandidate[targetId] > undirectedLengthsToBeginPNodeLabelMap[nLabel][undirectedLengthsToBeginPNodeLabelMap[nLabel].length - 1]) {
                var targetNodeLabel = candidateNodeMap[targetId].node[nodeLabelProp];
                candidateNodeLabelCountMap[targetNodeLabel]--;
                if (candidateNodeLabelCountMap[targetNodeLabel] < patternNodeLabelMap[targetNodeLabel].length) {
                    candidateGraphInvalid = true;
                    return;
                }
                var idx = candidateGraph.nodes.indexOf(candidateNodeMap[targetId].node);
                candidateGraph.nodes.splice(idx, 1);
                candidateNodeMap[targetId] = undefined;
            }
        });
        if (candidateGraphInvalid) {
            candidateGraphs.splice(i, 1);
            return "continue";
        }
        var degreeChanged = true;
        var loopCount = 0;
        while(degreeChanged && !candidateGraphInvalid){
            degreeChanged = false;
            // candidate 度数不足，删去该图
            var condition = directed ? candidateNodeMap[candidate.id].degree < patternNodeMap[beginPNode.id].degree || candidateNodeMap[candidate.id].inDegree < patternNodeMap[beginPNode.id].inDegree || candidateNodeMap[candidate.id].outDegree < patternNodeMap[beginPNode.id].outDegree : candidateNodeMap[candidate.id].degree < patternNodeMap[beginPNode.id].degree;
            if (condition) {
                candidateGraphInvalid = true;
                break;
            }
            // candidate label 个数不足，删去该图
            if (candidateNodeLabelCountMap[candidate[nodeLabelProp]] < patternNodeLabelMap[candidate[nodeLabelProp]].length) {
                candidateGraphInvalid = true;
                break;
            }
            // prune6：去除度数过小的节点
            var currentCandidateNodeNum = candidateGraph.nodes.length;
            for(var o = currentCandidateNodeNum - 1; o >= 0; o--){
                var cgNode = candidateGraph.nodes[o];
                var nodeDegree = candidateNodeMap[cgNode.id].degree;
                var nodeInDegree = candidateNodeMap[cgNode.id].inDegree;
                var nodeOutDegree = candidateNodeMap[cgNode.id].outDegree;
                var cNodeLabel = cgNode[nodeLabelProp];
                var _e = $66e6219dfa30476d$var$stashPatternNodeLabelDegreeMap(minPatternNodeLabelDegreeMap, cNodeLabel, patternNodeMap, patternNodeLabelMap), minPatternNodeLabelDegree = _e.minPatternNodeLabelDegree, minPatternNodeLabelInDegree = _e.minPatternNodeLabelInDegree, minPatternNodeLabelOutDegree = _e.minPatternNodeLabelOutDegree;
                var deleteCondition = directed ? nodeDegree < minPatternNodeLabelDegree || nodeInDegree < minPatternNodeLabelInDegree || nodeOutDegree < minPatternNodeLabelOutDegree : nodeDegree < minPatternNodeLabelDegree;
                if (deleteCondition) {
                    candidateNodeLabelCountMap[cgNode[nodeLabelProp]]--;
                    // 节点 label 个数不足
                    if (candidateNodeLabelCountMap[cgNode[nodeLabelProp]] < patternNodeLabelMap[cgNode[nodeLabelProp]].length) {
                        candidateGraphInvalid = true;
                        break;
                    }
                    candidateGraph.nodes.splice(o, 1);
                    candidateNodeMap[cgNode.id] = undefined;
                    degreeChanged = true;
                }
            }
            if (candidateGraphInvalid || !degreeChanged && loopCount !== 0) break;
            // 经过 prune5 节点裁剪，删去端点已经不在 candidateGraph 中的边
            candidateEdgeNum = candidateEdges.length;
            for(var y = candidateEdgeNum - 1; y >= 0; y--){
                var cedge = candidateEdges[y];
                if (!candidateNodeMap[cedge.source] || !candidateNodeMap[cedge.target]) {
                    candidateEdges.splice(y, 1);
                    var edgeLabel = cedge[edgeLabelProp];
                    edgeLabelCountMap[edgeLabel]--;
                    if (candidateNodeMap[cedge.source]) {
                        candidateNodeMap[cedge.source].degree--;
                        candidateNodeMap[cedge.source].outDegree--;
                    }
                    if (candidateNodeMap[cedge.target]) {
                        candidateNodeMap[cedge.target].degree--;
                        candidateNodeMap[cedge.target].inDegree--;
                    }
                    // 边 label 数量不足
                    if (patternEdgeLabelMap[edgeLabel] && edgeLabelCountMap[edgeLabel] < patternEdgeLabelMap[edgeLabel].length) {
                        candidateGraphInvalid = true;
                        break;
                    }
                    degreeChanged = true;
                }
            }
            loopCount++;
        }
        if (candidateGraphInvalid) {
            candidateGraphs.splice(i, 1);
            return "continue";
        }
        // prune: 若节点/边数过少，节点/边 label 过少，去掉这个图
        if (candidateGraphInvalid || candidateGraph.nodes.length < pattern.nodes.length || candidateEdges.length < pattern.edges.length) {
            candidateGraphs.splice(i, 1);
            return "continue";
        }
    };
    for(var i = candidateGraphNum - 1; i >= 0; i--){
        var state_1 = _loop_2(i);
        if (state_1 === "break") break;
    }
    // 此时已经生成的多个 candidateGraphs，可能有重复
    // console.log(
    //   "----- stage5: going to splice dulplicated candidate graphs -------"
    // );
    // 删去 candidateGraphs 中一模一样的子图，通过边的 node-node-edgeLabel 作为 key，这类边个数作为 value，进行匹配
    var currentLength = candidateGraphs.length;
    var _loop_3 = function _loop_3(i) {
        var cg1 = candidateGraphs[i];
        var cg1EdgeMap = {}; // [node1.id-node2.id-edge.label]: count
        cg1.edges.forEach(function(edge) {
            var key = "".concat(edge.source, "-").concat(edge.target, "-").concat(edge.label);
            if (!cg1EdgeMap[key]) cg1EdgeMap[key] = 1;
            else cg1EdgeMap[key]++;
        });
        var _loop_6 = function _loop_6(j) {
            var cg2 = candidateGraphs[j];
            var cg2EdgeMap = {}; // [node1.id-node2.id-edge.label]: count
            cg2.edges.forEach(function(edge) {
                var key = "".concat(edge.source, "-").concat(edge.target, "-").concat(edge.label);
                if (!cg2EdgeMap[key]) cg2EdgeMap[key] = 1;
                else cg2EdgeMap[key]++;
            });
            var same = true;
            if (Object.keys(cg2EdgeMap).length !== Object.keys(cg1EdgeMap).length) same = false;
            else Object.keys(cg1EdgeMap).forEach(function(key) {
                if (cg2EdgeMap[key] !== cg1EdgeMap[key]) same = false;
            });
            if (same) candidateGraphs.splice(j, 1);
        };
        for(var j = currentLength - 1; j > i; j--)_loop_6(j);
        currentLength = candidateGraphs.length;
    };
    for(var i = 0; i <= currentLength - 1; i++)_loop_3(i);
    return candidateGraphs;
};
var $66e6219dfa30476d$export$2e2bcd8739ae039 = $66e6219dfa30476d$var$GADDI;

});
parcelRegister("2jvve", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af5cae36b978762$export$2e2bcd8739ae039);
parcelRequire("9PG0c");
var $glsCo = parcelRequire("glsCo");

var $apeLQ = parcelRequire("apeLQ");
var $1af5cae36b978762$var$DFSedge = /** @class */ function() {
    function DFSedge(fromNode, toNode, fromNodeLabel, edgeLabel, toNodeLabel) {
        this.fromNode = fromNode;
        this.toNode = toNode;
        this.nodeEdgeNodeLabel = {
            nodeLabel1: fromNodeLabel || (0, $apeLQ.VACANT_NODE_LABEL),
            edgeLabel: edgeLabel || (0, $apeLQ.VACANT_EDGE_LABEL),
            nodeLabel2: toNodeLabel || (0, $apeLQ.VACANT_NODE_LABEL)
        };
    }
    DFSedge.prototype.equalTo = function(other) {
        return this.fromNode === other.formNode && this.toNode === other.toNode && this.nodeEdgeNodeLabel === other.nodeEdgeNodeLabel;
    };
    DFSedge.prototype.notEqualTo = function(other) {
        return !this.equalTo(other);
    };
    return DFSedge;
}();
// DFScode 是 DESedge 的数组
var $1af5cae36b978762$var$DFScode = /** @class */ function() {
    function DFScode() {
        this.rmpath = [];
        this.dfsEdgeList = [];
    }
    DFScode.prototype.equalTo = function(other) {
        var aLength = this.dfsEdgeList.length;
        var bLength = other.length;
        if (aLength !== bLength) return false;
        for(var i = 0; i < aLength; i++){
            if (this.dfsEdgeList[i] !== other[i]) return false;
        }
        return true;
    };
    DFScode.prototype.notEqualTo = function(other) {
        return !this.equalTo(other);
    };
    /** 增加一条 edge 到 DFScode */ DFScode.prototype.pushBack = function(fromNode, toNode, fromNodeLabel, edgeLabel, toNodeLabel) {
        this.dfsEdgeList.push(new $1af5cae36b978762$var$DFSedge(fromNode, toNode, fromNodeLabel, edgeLabel, toNodeLabel));
        return this.dfsEdgeList;
    };
    /** 根据 dfs 构建图 */ DFScode.prototype.toGraph = function(graphId, directed) {
        if (graphId === void 0) graphId = (0, $apeLQ.VACANT_GRAPH_ID);
        if (directed === void 0) directed = false;
        var graph = new (0, $apeLQ.Graph)(graphId, true, directed);
        this.dfsEdgeList.forEach(function(dfsEdge) {
            var fromNodeId = dfsEdge.fromNode;
            var toNodeId = dfsEdge.toNode;
            var _a = dfsEdge.nodeEdgeNodeLabel, nodeLabel1 = _a.nodeLabel1, edgeLabel = _a.edgeLabel, nodeLabel2 = _a.nodeLabel2;
            if (nodeLabel1 !== (0, $apeLQ.VACANT_NODE_LABEL)) graph.addNode(fromNodeId, nodeLabel1);
            if (nodeLabel2 !== (0, $apeLQ.VACANT_NODE_LABEL)) graph.addNode(toNodeId, nodeLabel2);
            if (nodeLabel1 !== (0, $apeLQ.VACANT_NODE_LABEL) && nodeLabel2 !== nodeLabel1) graph.addEdge(undefined, fromNodeId, toNodeId, edgeLabel);
        });
        return graph;
    };
    // 建立 rightmost path
    DFScode.prototype.buildRmpath = function() {
        this.rmpath = [];
        var oldFrom = undefined;
        var selfLength = this.dfsEdgeList.length;
        for(var i = selfLength - 1; i >= 0; i--){
            var dfsEdge = this.dfsEdgeList[i];
            var fromNodeIdx = dfsEdge.fromNode;
            var toNodeIdx = dfsEdge.toNode;
            if (fromNodeIdx < toNodeIdx && (oldFrom === undefined || toNodeIdx === oldFrom)) {
                this.rmpath.push(i);
                oldFrom = fromNodeIdx;
            }
        }
        return this.rmpath;
    };
    DFScode.prototype.getNodeNum = function() {
        var nodeMap = {};
        this.dfsEdgeList.forEach(function(dfsEdge) {
            if (!nodeMap[dfsEdge.fromNode]) nodeMap[dfsEdge.fromNode] = true;
            if (!nodeMap[dfsEdge.toNode]) nodeMap[dfsEdge.toNode] = true;
        });
        return Object.keys(nodeMap).length;
    };
    return DFScode;
}();
var $1af5cae36b978762$var$History = /** @class */ function() {
    function History(pdfs) {
        this.his = {};
        this.nodesUsed = {};
        this.edgesUsed = {};
        this.edges = [];
        if (!pdfs) return;
        while(pdfs){
            var e = pdfs.edge;
            this.edges.push(e);
            this.nodesUsed[e.from] = 1;
            this.nodesUsed[e.to] = 1;
            this.edgesUsed[e.id] = 1;
            pdfs = pdfs.preNode;
        }
        // 倒序
        this.edges = this.edges.reverse();
    }
    History.prototype.hasNode = function(node) {
        return this.nodesUsed[node.id] === 1;
    };
    History.prototype.hasEdge = function(edge) {
        return this.edgesUsed[edge.id] === 1;
    };
    return History;
}();
var $1af5cae36b978762$var$GSpan = /** @class */ function() {
    function GSpan(_a) {
        var graphs = _a.graphs, _b = _a.minSupport, minSupport = _b === void 0 ? 2 : _b, _c = _a.minNodeNum, minNodeNum = _c === void 0 ? 1 : _c, _d = _a.maxNodeNum, maxNodeNum = _d === void 0 ? 4 : _d, _e = _a.top, top = _e === void 0 ? 10 : _e, _f = _a.directed, directed = _f === void 0 ? false : _f, _g = _a.verbose, verbose = _g === void 0 ? false : _g;
        // -------- 第零步，初始化-------
        this.graphs = graphs;
        this.dfsCode = new $1af5cae36b978762$var$DFScode();
        this.support = 0;
        this.frequentSize1Subgraphs = [];
        this.frequentSubgraphs = [];
        this.minSupport = minSupport;
        this.top = top;
        this.directed = directed;
        this.counter = 0;
        // TODO? timestamp = {}
        this.maxNodeNum = maxNodeNum;
        this.minNodeNum = minNodeNum;
        this.verbose = verbose;
        if (this.maxNodeNum < this.minNodeNum) this.maxNodeNum = this.minNodeNum;
        this.reportDF = []; // matrix
    }
    // Line 352
    GSpan.prototype.findForwardRootEdges = function(graph, fromNode) {
        var _this = this;
        var result = [];
        var nodeMap = graph.nodeMap;
        fromNode.edges.forEach(function(edge) {
            if (_this.directed || fromNode.label <= nodeMap[edge.to].label) result.push(edge);
        });
        return result;
    };
    GSpan.prototype.findBackwardEdge = function(graph, edge1, edge2, history) {
        if (!this.directed && edge1 === edge2) return null;
        var nodeMap = graph.nodeMap;
        var edge2To = nodeMap[edge2.to];
        var edge2ToEdges = edge2To.edges;
        var edgeLength = edge2ToEdges.length;
        for(var i = 0; i < edgeLength; i++){
            var edge = edge2ToEdges[i];
            if (history.hasEdge(edge) || edge.to !== edge1.from) continue;
            if (!this.directed) {
                if (edge1.label < edge.label || edge1.label === edge.label && nodeMap[edge1.to].label <= nodeMap[edge2.to].label) return edge;
            } else {
                if (nodeMap[edge1.from].label < nodeMap[edge2.to].label || nodeMap[edge1.from].label === nodeMap[edge2.to].label && edge1.label <= edge.label) return edge;
            }
        }
        return null;
    };
    GSpan.prototype.findForwardPureEdges = function(graph, rightmostEdge, minNodeLabel, history) {
        var result = [];
        var rightmostEdgeToId = rightmostEdge.to;
        var edges = graph.nodeMap[rightmostEdgeToId].edges;
        var edgeLength = edges.length;
        for(var i = 0; i < edgeLength; i++){
            var edge = edges[i];
            var toNode = graph.nodeMap[edge.to];
            if (minNodeLabel <= toNode.label && !history.hasNode(toNode)) result.push(edge);
        }
        return result;
    };
    GSpan.prototype.findForwardRmpathEdges = function(graph, rightmostEdge, minNodeLabel, history) {
        var result = [];
        var nodeMap = graph.nodeMap;
        var toNodeLabel = nodeMap[rightmostEdge.to].label;
        var fromNode = nodeMap[rightmostEdge.from];
        var edges = fromNode.edges;
        var edgeLength = edges.length;
        for(var i = 0; i < edgeLength; i++){
            var edge = edges[i];
            var newToNodeLabel = nodeMap[edge.to].label;
            if (rightmostEdge.to === edge.to || minNodeLabel > newToNodeLabel || history.hasNode(nodeMap[edge.to])) continue;
            if (rightmostEdge.label < edge.label || rightmostEdge.label === edge.label && toNodeLabel <= newToNodeLabel) result.push(edge);
        }
        return result;
    };
    GSpan.prototype.getSupport = function(projected) {
        var graphMap = {};
        projected.forEach(function(pro) {
            if (!graphMap[pro.graphId]) graphMap[pro.graphId] = true;
        });
        return Object.keys(graphMap).length;
    };
    GSpan.prototype.findMinLabel = function(obj) {
        var minLabel = undefined;
        Object.keys(obj).forEach(function(nodeEdgeNodeLabel) {
            var _a = obj[nodeEdgeNodeLabel], nodeLabel1 = _a.nodeLabel1, edgeLabel = _a.edgeLabel, nodeLabel2 = _a.nodeLabel2;
            if (!minLabel) {
                minLabel = {
                    nodeLabel1: nodeLabel1,
                    edgeLabel: edgeLabel,
                    nodeLabel2: nodeLabel2
                };
                return;
            }
            if (nodeLabel1 < minLabel.nodeLabel1 || nodeLabel1 === minLabel.nodeLabel1 && edgeLabel < minLabel.edgeLabel || nodeLabel1 === minLabel.nodeLabel1 && edgeLabel === minLabel.edgeLabel && nodeLabel2 < minLabel.nodeLabel2) minLabel = {
                nodeLabel1: nodeLabel1,
                edgeLabel: edgeLabel,
                nodeLabel2: nodeLabel2
            };
        });
        return minLabel;
    };
    GSpan.prototype.isMin = function() {
        var _this = this;
        var dfsCode = this.dfsCode;
        if (this.verbose) console.log("isMin checking", dfsCode);
        if (dfsCode.dfsEdgeList.length === 1) return true;
        var directed = this.directed;
        var graph = dfsCode.toGraph((0, $apeLQ.VACANT_GRAPH_ID), directed);
        var nodeMap = graph.nodeMap;
        var dfsCodeMin = new $1af5cae36b978762$var$DFScode();
        var root = {};
        graph.nodes.forEach(function(node) {
            var forwardEdges = _this.findForwardRootEdges(graph, node);
            forwardEdges.forEach(function(edge) {
                var otherNode = nodeMap[edge.to];
                var nodeEdgeNodeLabel = "".concat(node.label, "-").concat(edge.label, "-").concat(otherNode.label);
                if (!root[nodeEdgeNodeLabel]) root[nodeEdgeNodeLabel] = {
                    projected: [],
                    nodeLabel1: node.label,
                    edgeLabel: edge.label,
                    nodeLabel2: otherNode.label
                };
                var pdfs = {
                    graphId: graph.id,
                    edge: edge,
                    preNode: null
                };
                root[nodeEdgeNodeLabel].projected.push(pdfs);
            });
        });
        // 比较 root 中每一项的 nodeEdgeNodeLabel 大小，按照 nodeLabel1、edgeLabe、nodeLabel2 的顺序比较
        var minLabel = this.findMinLabel(root); // line 419
        if (!minLabel) return;
        dfsCodeMin.dfsEdgeList.push(new $1af5cae36b978762$var$DFSedge(0, 1, minLabel.nodeLabel1, minLabel.edgeLabel, minLabel.nodeLabel2));
        // line 423
        var projectIsMin = function projectIsMin(projected) {
            // right most path
            var rmpath = dfsCodeMin.buildRmpath();
            var minNodeLabel = dfsCodeMin.dfsEdgeList[0].nodeEdgeNodeLabel.nodeLabel1;
            var maxToC = dfsCodeMin.dfsEdgeList[rmpath[0]].toNode; // node id
            var backwardRoot = {};
            var flag = false, newTo = 0;
            var end = directed ? -1 : 0; // 遍历到 1 还是到 0
            var _loop_1 = function _loop_1(i) {
                if (flag) return "break";
                // line 435
                projected.forEach(function(p) {
                    var history = new $1af5cae36b978762$var$History(p);
                    var backwardEdge = _this.findBackwardEdge(graph, history.edges[rmpath[i]], history.edges[rmpath[0]], history);
                    if (backwardEdge) {
                        // Line 441
                        if (!backwardRoot[backwardEdge.label]) backwardRoot[backwardEdge.label] = {
                            projected: [],
                            edgeLabel: backwardEdge.label
                        };
                        backwardRoot[backwardEdge.label].projected.push({
                            graphId: graph.id,
                            edge: backwardRoot,
                            preNode: p
                        });
                        newTo = dfsCodeMin.dfsEdgeList[rmpath[i]].fromNode;
                        flag = true;
                    }
                });
            };
            for(var i = rmpath.length - 1; i > end; i--){
                var state_1 = _loop_1(i);
                if (state_1 === "break") break;
            }
            if (flag) {
                var minBackwardEdgeLabel = _this.findMinLabel(backwardRoot);
                dfsCodeMin.dfsEdgeList.push(new $1af5cae36b978762$var$DFSedge(maxToC, newTo, (0, $apeLQ.VACANT_NODE_LABEL), minBackwardEdgeLabel.edgeLabel, (0, $apeLQ.VACANT_NODE_LABEL)));
                var idx_1 = dfsCodeMin.dfsEdgeList.length - 1;
                if (_this.dfsCode.dfsEdgeList[idx_1] !== dfsCodeMin.dfsEdgeList[idx_1]) return false;
                return projectIsMin(backwardRoot[minBackwardEdgeLabel.edgeLabel].projected);
            }
            var forwardRoot = {};
            flag = false;
            var newFrom = 0;
            projected.forEach(function(p) {
                var history = new $1af5cae36b978762$var$History(p);
                var forwardPureEdges = _this.findForwardPureEdges(graph, history.edges[rmpath[0]], minNodeLabel, history);
                if (forwardPureEdges.length > 0) {
                    flag = true;
                    newFrom = maxToC;
                    forwardPureEdges.forEach(function(edge) {
                        var key = "".concat(edge.label, "-").concat(nodeMap[edge.to].label);
                        if (!forwardRoot[key]) forwardRoot[key] = {
                            projected: [],
                            edgeLabel: edge.label,
                            nodeLabel2: nodeMap[edge.to].label
                        };
                        forwardRoot[key].projected.push({
                            graphId: graph.id,
                            edge: edge,
                            preNode: p
                        });
                    });
                }
            });
            var pathLength = rmpath.length;
            var _loop_2 = function _loop_2(i) {
                if (flag) return "break";
                var value = rmpath[i];
                projected.forEach(function(p) {
                    var history = new $1af5cae36b978762$var$History(p);
                    var forwardRmpathEdges = _this.findForwardRmpathEdges(graph, history.edges[value], minNodeLabel, history);
                    if (forwardRmpathEdges.length > 0) {
                        flag = true;
                        newFrom = dfsCodeMin.dfsEdgeList[value].fromNode;
                        forwardRmpathEdges.forEach(function(edge) {
                            var key = "".concat(edge.label, "-").concat(nodeMap[edge.to].label);
                            if (!forwardRoot[key]) forwardRoot[key] = {
                                projected: [],
                                edgeLabel: edge.label,
                                nodeLabel2: nodeMap[edge.to].label
                            };
                            forwardRoot[key].projected.push({
                                graphId: graph.id,
                                edge: edge,
                                preNode: p
                            });
                        });
                    }
                });
            };
            for(var i = 0; i < pathLength; i++){
                var state_2 = _loop_2(i);
                if (state_2 === "break") break;
            }
            if (!flag) return true;
            var forwardMinEdgeNodeLabel = _this.findMinLabel(forwardRoot);
            dfsCodeMin.dfsEdgeList.push(new $1af5cae36b978762$var$DFSedge(newFrom, maxToC + 1, (0, $apeLQ.VACANT_NODE_LABEL), forwardMinEdgeNodeLabel.edgeLabel, forwardMinEdgeNodeLabel.nodeLabel2));
            var idx = dfsCodeMin.dfsEdgeList.length - 1;
            if (dfsCode.dfsEdgeList[idx] !== dfsCodeMin.dfsEdgeList[idx]) return false;
            return projectIsMin(forwardRoot["".concat(forwardMinEdgeNodeLabel.edgeLabel, "-").concat(forwardMinEdgeNodeLabel.nodeLabel2)].projected);
        };
        var key = "".concat(minLabel.nodeLabel1, "-").concat(minLabel.edgeLabel, "-").concat(minLabel.nodeLabel2);
        return projectIsMin(root[key].projected);
    };
    GSpan.prototype.report = function() {
        if (this.dfsCode.getNodeNum() < this.minNodeNum) return;
        this.counter++;
        var graph = this.dfsCode.toGraph(this.counter, this.directed);
        this.frequentSubgraphs.push((0, $glsCo.default)(graph));
    };
    GSpan.prototype.subGraphMining = function(projected) {
        var _this = this;
        var support = this.getSupport(projected);
        if (support < this.minSupport) return;
        if (!this.isMin()) return;
        this.report();
        var nodeNum = this.dfsCode.getNodeNum();
        var rmpath = this.dfsCode.buildRmpath();
        var maxToC = this.dfsCode.dfsEdgeList[rmpath[0]].toNode;
        var minNodeLabel = this.dfsCode.dfsEdgeList[0].nodeEdgeNodeLabel.nodeLabel1;
        var forwardRoot = {};
        var backwardRoot = {};
        projected.forEach(function(p) {
            var graph = _this.graphs[p.graphId];
            var nodeMap = graph.nodeMap;
            var history = new $1af5cae36b978762$var$History(p);
            // backward Line 526
            for(var i = rmpath.length - 1; i >= 0; i--){
                var backwardEdge = _this.findBackwardEdge(graph, history.edges[rmpath[i]], history.edges[rmpath[0]], history);
                if (backwardEdge) {
                    var key = "".concat(_this.dfsCode.dfsEdgeList[rmpath[i]].fromNode, "-").concat(backwardEdge.label);
                    if (!backwardRoot[key]) backwardRoot[key] = {
                        projected: [],
                        toNodeId: _this.dfsCode.dfsEdgeList[rmpath[i]].fromNode,
                        edgeLabel: backwardEdge.label
                    };
                    backwardRoot[key].projected.push({
                        graphId: p.graphId,
                        edge: backwardEdge,
                        preNode: p
                    });
                }
            }
            // pure forward
            if (nodeNum >= _this.maxNodeNum) return;
            var forwardPureEdges = _this.findForwardPureEdges(graph, history.edges[rmpath[0]], minNodeLabel, history);
            forwardPureEdges.forEach(function(edge) {
                var key = "".concat(maxToC, "-").concat(edge.label, "-").concat(nodeMap[edge.to].label);
                if (!forwardRoot[key]) forwardRoot[key] = {
                    projected: [],
                    fromNodeId: maxToC,
                    edgeLabel: edge.label,
                    nodeLabel2: nodeMap[edge.to].label
                };
                forwardRoot[key].projected.push({
                    graphId: p.graphId,
                    edge: edge,
                    preNode: p
                });
            });
            var _loop_3 = function _loop_3(i) {
                var forwardRmpathEdges = _this.findForwardRmpathEdges(graph, history.edges[rmpath[i]], minNodeLabel, history);
                forwardRmpathEdges.forEach(function(edge) {
                    var key = "".concat(_this.dfsCode.dfsEdgeList[rmpath[i]].fromNode, "-").concat(edge.label, "-").concat(nodeMap[edge.to].label);
                    if (!forwardRoot[key]) forwardRoot[key] = {
                        projected: [],
                        fromNodeId: _this.dfsCode.dfsEdgeList[rmpath[i]].fromNode,
                        edgeLabel: edge.label,
                        nodeLabel2: nodeMap[edge.to].label
                    };
                    forwardRoot[key].projected.push({
                        graphId: p.graphId,
                        edge: edge,
                        preNode: p
                    });
                });
            };
            // rmpath forward
            for(var i = 0; i < rmpath.length; i++)_loop_3(i);
        });
        // backward
        Object.keys(backwardRoot).forEach(function(key) {
            var _a = backwardRoot[key], toNodeId = _a.toNodeId, edgeLabel = _a.edgeLabel;
            _this.dfsCode.dfsEdgeList.push(new $1af5cae36b978762$var$DFSedge(maxToC, toNodeId, "-1", edgeLabel, "-1"));
            _this.subGraphMining(backwardRoot[key].projected);
            _this.dfsCode.dfsEdgeList.pop();
        });
        // forward
        Object.keys(forwardRoot).forEach(function(key) {
            var _a = forwardRoot[key], fromNodeId = _a.fromNodeId, edgeLabel = _a.edgeLabel, nodeLabel2 = _a.nodeLabel2;
            _this.dfsCode.dfsEdgeList.push(new $1af5cae36b978762$var$DFSedge(fromNodeId, maxToC + 1, (0, $apeLQ.VACANT_NODE_LABEL), edgeLabel, nodeLabel2));
            _this.subGraphMining(forwardRoot[key].projected);
            _this.dfsCode.dfsEdgeList.pop();
        });
    };
    GSpan.prototype.generate1EdgeFrequentSubGraphs = function() {
        var graphs = this.graphs;
        var directed = this.directed;
        var minSupport = this.minSupport;
        var frequentSize1Subgraphs = this.frequentSize1Subgraphs;
        var nodeLabelCounter = {}, nodeEdgeNodeCounter = {};
        // 保存各个图和各自节点的关系 map，key 格式为 graphKey-node类型
        var nodeLableCounted = {};
        // 保存各个图和各自边的关系 map，key 格式为 graphKey-fromNode类型-edge类型-toNode类型
        var nodeEdgeNodeLabelCounted = {};
        Object.keys(graphs).forEach(function(key) {
            // Line 271
            var graph = graphs[key];
            var nodeMap = graph.nodeMap;
            // 遍历节点，记录对应图 与 每个节点的 label 到 nodeLableCounted
            graph.nodes.forEach(function(node, i) {
                // Line 272
                var nodeLabel = node.label;
                var graphNodeKey = "".concat(key, "-").concat(nodeLabel);
                if (!nodeLableCounted[graphNodeKey]) {
                    var counter = nodeLabelCounter[nodeLabel] || 0;
                    counter++;
                    nodeLabelCounter[nodeLabel] = counter;
                }
                nodeLableCounted[graphNodeKey] = {
                    graphKey: key,
                    label: nodeLabel
                };
                // 遍历该节点的所有边，记录各个图和各自边的关系到 nodeEdgeNodeLabelCounted. Line 276
                node.edges.forEach(function(edge) {
                    var nodeLabel1 = nodeLabel;
                    var nodeLabel2 = nodeMap[edge.to].label;
                    if (!directed && nodeLabel1 > nodeLabel2) {
                        var tmp = nodeLabel2;
                        nodeLabel2 = nodeLabel1;
                        nodeLabel1 = tmp;
                    }
                    var edgeLabel = edge.label;
                    var graphNodeEdgeNodeKey = "".concat(key, "-").concat(nodeLabel1, "-").concat(edgeLabel, "-").concat(nodeLabel2);
                    var nodeEdgeNodeKey = "".concat(nodeLabel1, "-").concat(edgeLabel, "-").concat(nodeLabel2);
                    if (!nodeEdgeNodeCounter[nodeEdgeNodeKey]) {
                        var counter = nodeEdgeNodeCounter[nodeEdgeNodeKey] || 0;
                        counter++;
                        nodeEdgeNodeCounter[nodeEdgeNodeKey] = counter; // Line281
                    }
                    nodeEdgeNodeLabelCounted[graphNodeEdgeNodeKey] = {
                        graphId: key,
                        nodeLabel1: nodeLabel1,
                        edgeLabel: edgeLabel,
                        nodeLabel2: nodeLabel2
                    };
                });
            });
        });
        // 计算频繁的节点
        Object.keys(nodeLabelCounter).forEach(function(label) {
            var count = nodeLabelCounter[label];
            if (count < minSupport) return;
            var g = {
                nodes: [],
                edges: []
            };
            g.nodes.push({
                id: "0",
                label: label
            });
            frequentSize1Subgraphs.push(g);
        // if (minNodeNum <= 1) reportSize1 TODO
        });
        return frequentSize1Subgraphs;
    };
    GSpan.prototype.run = function() {
        var _this = this;
        // -------- 第一步, _generate_1edge_frequent_subgraphs：频繁的单个节点-------
        this.frequentSize1Subgraphs = this.generate1EdgeFrequentSubGraphs();
        if (this.maxNodeNum < 2) return;
        var graphs = this.graphs;
        var directed = this.directed;
        // PDFS 数组的 map Line 304
        var root = {};
        Object.keys(graphs).forEach(function(graphId) {
            var graph = graphs[graphId];
            var nodeMap = graph.nodeMap;
            // Line 306
            graph.nodes.forEach(function(node) {
                var forwardRootEdges = _this.findForwardRootEdges(graph, node);
                // Line 308
                forwardRootEdges.forEach(function(edge) {
                    var toNode = nodeMap[edge.to];
                    var nodeEdgeNodeLabel = "".concat(node.label, "-").concat(edge.label, "-").concat(toNode.label);
                    if (!root[nodeEdgeNodeLabel]) root[nodeEdgeNodeLabel] = {
                        projected: [],
                        nodeLabel1: node.label,
                        edgeLabel: edge.label,
                        nodeLabel2: toNode.label
                    };
                    var pdfs = {
                        graphId: graphId,
                        edge: edge,
                        preNode: null
                    };
                    root[nodeEdgeNodeLabel].projected.push(pdfs);
                });
            });
        });
        // Line 313
        Object.keys(root).forEach(function(nodeEdgeNodeLabel) {
            var _a = root[nodeEdgeNodeLabel], projected = _a.projected, nodeLabel1 = _a.nodeLabel1, edgeLabel = _a.edgeLabel, nodeLabel2 = _a.nodeLabel2;
            _this.dfsCode.dfsEdgeList.push(new $1af5cae36b978762$var$DFSedge(0, 1, nodeLabel1, edgeLabel, nodeLabel2));
            _this.subGraphMining(projected);
            _this.dfsCode.dfsEdgeList.pop();
        });
    };
    return GSpan;
}();
var $1af5cae36b978762$var$formatGraphs = function formatGraphs(graphs, directed, nodeLabelProp, edgeLabelProp) {
    var result = {};
    Object.keys(graphs).forEach(function(key, i) {
        var graph = graphs[key];
        var fGraph = new (0, $apeLQ.Graph)(i, true, directed);
        var nodeIdxMap = {};
        graph.nodes.forEach(function(node, j) {
            fGraph.addNode(j, node[nodeLabelProp]);
            nodeIdxMap[node.id] = j;
        });
        graph.edges.forEach(function(edge, k) {
            var sourceIdx = nodeIdxMap[edge.source];
            var targetIdx = nodeIdxMap[edge.target];
            fGraph.addEdge(-1, sourceIdx, targetIdx, edge[edgeLabelProp]);
        });
        if (fGraph && fGraph.getNodeNum()) result[fGraph.id] = fGraph;
    });
    return result;
};
var $1af5cae36b978762$var$toGraphDatas = function toGraphDatas(graphs, nodeLabelProp, edgeLabelProp) {
    var result = [];
    graphs.forEach(function(graph) {
        var graphData = {
            nodes: [],
            edges: []
        };
        graph.nodes.forEach(function(node) {
            var _a;
            graphData.nodes.push((_a = {
                id: "".concat(node.id)
            }, _a[nodeLabelProp] = node.label, _a));
        });
        graph.edges.forEach(function(edge) {
            var _a;
            graphData.edges.push((_a = {
                source: "".concat(edge.from),
                target: "".concat(edge.to)
            }, _a[edgeLabelProp] = edge.label, _a));
        });
        result.push(graphData);
    });
    return result;
};
var $1af5cae36b978762$var$DEFAULT_LABEL_NAME = "cluster";
/**
 * gSpan 频繁子图计算算法（frequent graph mining）
 * @param params 参数
 */ var $1af5cae36b978762$var$gSpan = function gSpan(params) {
    // ------- 将图数据 GraphData 的 map 转换为格式 -------
    var graphs = params.graphs, _a = params.directed, directed = _a === void 0 ? false : _a, _b = params.nodeLabelProp, nodeLabelProp = _b === void 0 ? $1af5cae36b978762$var$DEFAULT_LABEL_NAME : _b, _c = params.edgeLabelProp, edgeLabelProp = _c === void 0 ? $1af5cae36b978762$var$DEFAULT_LABEL_NAME : _c;
    var formattedGraphs = $1af5cae36b978762$var$formatGraphs(graphs, directed, nodeLabelProp, edgeLabelProp);
    var minSupport = params.minSupport, maxNodeNum = params.maxNodeNum, minNodeNum = params.minNodeNum, verbose = params.verbose, top = params.top;
    // ------- 初始化与执行算法 -------
    var algoParams = {
        graphs: formattedGraphs,
        minSupport: minSupport,
        maxNodeNum: maxNodeNum,
        minNodeNum: minNodeNum,
        top: top,
        verbose: verbose,
        directed: directed
    };
    var calculator = new $1af5cae36b978762$var$GSpan(algoParams);
    calculator.run();
    var result = $1af5cae36b978762$var$toGraphDatas(calculator.frequentSubgraphs, nodeLabelProp, edgeLabelProp);
    return result;
};
var $1af5cae36b978762$export$2e2bcd8739ae039 = $1af5cae36b978762$var$gSpan;

});
parcelRegister("apeLQ", function(module, exports) {

$parcel$export(module.exports, "VACANT_EDGE_LABEL", () => $7937b255f8d3c536$export$4a610b1bc14d17d1);
$parcel$export(module.exports, "VACANT_NODE_LABEL", () => $7937b255f8d3c536$export$84e43d20bad39660);
$parcel$export(module.exports, "VACANT_GRAPH_ID", () => $7937b255f8d3c536$export$a6b515b879b503a8);
$parcel$export(module.exports, "Graph", () => $7937b255f8d3c536$export$614db49f3febe941);
var $7937b255f8d3c536$export$434fd9e9797a8ace = -1;
var $7937b255f8d3c536$export$892541c3e9183d61 = -1;
var $7937b255f8d3c536$export$4a610b1bc14d17d1 = "-1";
var $7937b255f8d3c536$export$84e43d20bad39660 = "-1";
var $7937b255f8d3c536$export$a6b515b879b503a8 = -1;
var $7937b255f8d3c536$export$bbf880f4cb843db = "-1";
var $7937b255f8d3c536$export$b9d9805c9b77a56d = /** @class */ function() {
    function Edge(id, from, to, label) {
        if (id === void 0) id = $7937b255f8d3c536$export$434fd9e9797a8ace;
        if (from === void 0) from = $7937b255f8d3c536$export$892541c3e9183d61;
        if (to === void 0) to = $7937b255f8d3c536$export$892541c3e9183d61;
        if (label === void 0) label = $7937b255f8d3c536$export$4a610b1bc14d17d1;
        this.id = id;
        this.from = from;
        this.to = to;
        this.label = label;
    }
    return Edge;
}();
var $7937b255f8d3c536$export$85c928794f8d04d4 = /** @class */ function() {
    function Node(id, label) {
        if (id === void 0) id = $7937b255f8d3c536$export$892541c3e9183d61;
        if (label === void 0) label = $7937b255f8d3c536$export$84e43d20bad39660;
        this.id = id;
        this.label = label;
        this.edges = [];
        this.edgeMap = {};
    }
    Node.prototype.addEdge = function(edge) {
        this.edges.push(edge);
        this.edgeMap[edge.id] = edge;
    };
    return Node;
}();
var $7937b255f8d3c536$export$614db49f3febe941 = /** @class */ function() {
    function Graph(id, edgeIdAutoIncrease, directed) {
        if (id === void 0) id = $7937b255f8d3c536$export$892541c3e9183d61;
        if (edgeIdAutoIncrease === void 0) edgeIdAutoIncrease = true;
        if (directed === void 0) directed = false;
        this.id = id;
        this.edgeIdAutoIncrease = edgeIdAutoIncrease;
        this.edges = [];
        this.nodes = [];
        this.nodeMap = {};
        this.edgeMap = {};
        this.nodeLabelMap = {};
        this.edgeLabelMap = {};
        this.counter = 0;
        this.directed = directed;
    }
    Graph.prototype.getNodeNum = function() {
        return this.nodes.length;
    };
    Graph.prototype.addNode = function(id, label) {
        if (this.nodeMap[id]) return;
        var node = new $7937b255f8d3c536$export$85c928794f8d04d4(id, label);
        this.nodes.push(node);
        this.nodeMap[id] = node;
        if (!this.nodeLabelMap[label]) this.nodeLabelMap[label] = [];
        this.nodeLabelMap[label].push(id);
    };
    Graph.prototype.addEdge = function(id, from, to, label) {
        if (this.edgeIdAutoIncrease || id === undefined) id = this.counter++;
        if (this.nodeMap[from] && this.nodeMap[to] && this.nodeMap[to].edgeMap[id]) return;
        var edge = new $7937b255f8d3c536$export$b9d9805c9b77a56d(id, from, to, label);
        this.edges.push(edge);
        this.edgeMap[id] = edge;
        this.nodeMap[from].addEdge(edge);
        if (!this.edgeLabelMap[label]) this.edgeLabelMap[label] = [];
        this.edgeLabelMap[label].push(edge);
        if (!this.directed) {
            var rEdge = new $7937b255f8d3c536$export$b9d9805c9b77a56d(id, to, from, label);
            this.nodeMap[to].addEdge(rEdge);
            this.edgeLabelMap[label].push(rEdge);
        }
    };
    return Graph;
}();

});



parcelRegister("hmOkR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca4b8955bf04c964$export$2e2bcd8739ae039);

var $9PxNf = parcelRequire("9PxNf");
var $ca4b8955bf04c964$var$Stack = /** @class */ function() {
    function Stack(maxStep) {
        if (maxStep === void 0) maxStep = 10;
        this.linkedList = new (0, $9PxNf.default)();
        this.maxStep = maxStep;
    }
    Object.defineProperty(Stack.prototype, "length", {
        get: function get() {
            return this.linkedList.toArray().length;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * 判断栈是否为空，如果链表中没有头部元素，则栈为空
   */ Stack.prototype.isEmpty = function() {
        return !this.linkedList.head;
    };
    /**
   * 是否到定义的栈的最大长度，如果达到最大长度后，不再允许入栈
   */ Stack.prototype.isMaxStack = function() {
        return this.toArray().length >= this.maxStep;
    };
    /**
   * 访问顶端元素
   */ Stack.prototype.peek = function() {
        if (this.isEmpty()) return null;
        // 返回头部元素，不删除元素
        return this.linkedList.head.value;
    };
    Stack.prototype.push = function(value) {
        this.linkedList.prepend(value);
        if (this.length > this.maxStep) this.linkedList.deleteTail();
    };
    Stack.prototype.pop = function() {
        var removeHead = this.linkedList.deleteHead();
        return removeHead ? removeHead.value : null;
    };
    Stack.prototype.toArray = function() {
        return this.linkedList.toArray().map(function(node) {
            return node.value;
        });
    };
    Stack.prototype.clear = function() {
        while(!this.isEmpty())this.pop();
    };
    return Stack;
}();
var $ca4b8955bf04c964$export$2e2bcd8739ae039 = $ca4b8955bf04c964$var$Stack;

});


parcelRegister("brtTw", function(module, exports) {

$parcel$export(module.exports, "idOf", () => $854967c4ed2a1777$export$38d46f59469091c9);
$parcel$export(module.exports, "parentIdOf", () => $854967c4ed2a1777$export$735754a18ef7f409);
$parcel$export(module.exports, "idsOf", () => $854967c4ed2a1777$export$2127a3f4e9c6ae3a);

var $aBpmX = parcelRequire("aBpmX");
function $854967c4ed2a1777$export$38d46f59469091c9(data) {
    if (data.id !== undefined) return data.id;
    if (data.source !== undefined && data.target !== undefined) return `${data.source}-${data.target}`;
    throw new Error((0, $aBpmX.format)('The datum does not have available id.'));
}
function $854967c4ed2a1777$export$735754a18ef7f409(data) {
    return data.combo;
}
function $854967c4ed2a1777$export$2127a3f4e9c6ae3a(data, flat) {
    const ids = {
        nodes: (data.nodes || []).map($854967c4ed2a1777$export$38d46f59469091c9),
        edges: (data.edges || []).map($854967c4ed2a1777$export$38d46f59469091c9),
        combos: (data.combos || []).map($854967c4ed2a1777$export$38d46f59469091c9)
    };
    return flat ? Object.values(ids).flat() : ids;
}

});


parcelRegister("6SQtU", function(module, exports) {

$parcel$export(module.exports, "arrayDiff", () => $50307eeb3168bd48$export$c60e0e71ff2ff066);

var $4ETMA = parcelRequire("4ETMA");
function $50307eeb3168bd48$export$c60e0e71ff2ff066(original, modified, key, comparator = (0, $4ETMA.default)) {
    const originalMap = new Map(original.map((d)=>[
            key(d),
            d
        ]));
    const modifiedMap = new Map(modified.map((d)=>[
            key(d),
            d
        ]));
    const originalSet = new Set(originalMap.keys());
    const modifiedSet = new Set(modifiedMap.keys());
    const enter = [];
    const update = [];
    const exit = [];
    const keep = [];
    modifiedSet.forEach((key)=>{
        if (originalSet.has(key)) {
            if (!comparator(originalMap.get(key), modifiedMap.get(key))) update.push(modifiedMap.get(key));
            else keep.push(modifiedMap.get(key));
        } else enter.push(modifiedMap.get(key));
    });
    originalSet.forEach((key)=>{
        if (!modifiedSet.has(key)) exit.push(originalMap.get(key));
    });
    return {
        enter: enter,
        exit: exit,
        keep: keep,
        update: update
    };
}

});

parcelRegister("kzdag", function(module, exports) {

$parcel$export(module.exports, "setVisibility", () => $ef9149b77f8d4bda$export$2c64211ecf98e50d);
/**
 * <zh/> 设置图形实例的可见性
 *
 * <en/> Set the visibility of the shape instance
 * @param shape - <zh/> 图形实例 | <en/> shape instance
 * @param value - <zh/> 可见性 | <en/> visibility
 * @param filter - <zh/> 筛选出需要设置可见性的图形 | <en/> Filter out the shapes that need to set visibility
 * @remarks
 * <zh/> 在设置 enableCSSParsing 为 false 的情况下，复合图形无法继承父属性，因此需要对所有子图形应用相同的可见性
 *
 * <en/> After setting enableCSSParsing to false, the compound shape cannot inherit the parent attribute, so the same visibility needs to be applied to all child shapes
 */ function $ef9149b77f8d4bda$export$2c64211ecf98e50d(shape, value, filter) {
    const callback = (node)=>{
        if (filter && !filter(node)) return;
        node.style.visibility = value;
    };
    shape.forEach((node)=>{
        callback(node);
    });
}

});

parcelRegister("hQIOr", function(module, exports) {

$parcel$export(module.exports, "BaseBehavior", () => $cfea0dd1e99ac19d$export$154b7470337d8b41);

var $dhEO8 = parcelRequire("dhEO8");
class $cfea0dd1e99ac19d$export$154b7470337d8b41 extends (0, $dhEO8.BaseExtension) {
}

});
parcelRegister("dhEO8", function(module, exports) {

$parcel$export(module.exports, "ExtensionController", () => $9abc846e8d40ee2f$export$3041632b1aaf3d5e);
$parcel$export(module.exports, "BaseExtension", () => $9abc846e8d40ee2f$export$894d61b4463c68e0);

var $6SQtU = parcelRequire("6SQtU");

var $3VIah = parcelRequire("3VIah");

var $aBpmX = parcelRequire("aBpmX");

var $hW6vf = parcelRequire("hW6vf");
class $9abc846e8d40ee2f$export$3041632b1aaf3d5e {
    constructor(context){
        this.extensions = [];
        this.extensionMap = {};
        this.context = context;
    }
    setExtensions(extensions) {
        const stdExtensions = (0, $3VIah.parseExtensions)(this.context.graph, this.category, extensions);
        const { enter: enter, update: update, exit: exit, keep: keep } = (0, $6SQtU.arrayDiff)(this.extensions, stdExtensions, (extension)=>extension.key);
        this.createExtensions(enter);
        this.updateExtensions([
            ...update,
            ...keep
        ]);
        this.destroyExtensions(exit);
        this.extensions = stdExtensions;
    }
    createExtension(extension) {
        const { category: category } = this;
        const { key: key, type: type } = extension;
        const Ctor = (0, $hW6vf.getExtension)(category, type);
        if (!Ctor) return (0, $aBpmX.print).warn(`The extension ${type} of ${category} is not registered.`);
        const instance = new Ctor(this.context, extension);
        instance.initialized = true;
        this.extensionMap[key] = instance;
    }
    createExtensions(extensions) {
        extensions.forEach((extension)=>this.createExtension(extension));
    }
    updateExtension(extension) {
        const { key: key } = extension;
        const instance = this.extensionMap[key];
        if (instance) instance.update(extension);
    }
    updateExtensions(extensions) {
        extensions.forEach((extension)=>this.updateExtension(extension));
    }
    destroyExtension(key) {
        const instance = this.extensionMap[key];
        if (!instance) return;
        if (instance.initialized && !instance.destroyed) instance.destroy();
        delete this.extensionMap[key];
    }
    destroyExtensions(extensions) {
        extensions.forEach(({ key: key })=>this.destroyExtension(key));
    }
    destroy() {
        this.destroyExtensions(this.extensions);
        // @ts-expect-error force delete
        this.context = {};
        this.extensions = [];
        this.extensionMap = {};
    }
}
class $9abc846e8d40ee2f$export$894d61b4463c68e0 {
    constructor(context, options){
        this.events = [];
        this.initialized = false;
        this.destroyed = false;
        this.context = context;
        this.options = options;
    }
    update(options) {
        this.options = Object.assign(this.options, options);
    }
    destroy() {
        // @ts-expect-error force delete
        this.context = {};
        // @ts-expect-error force delete
        this.options = {};
        this.destroyed = true;
    }
}

});
parcelRegister("3VIah", function(module, exports) {

$parcel$export(module.exports, "parseExtensions", () => $2dc8f42b51f7999c$export$c81a17884ecd61bc);
/**
 * <zh/> 将模块配置项转换为标准模块格式
 *
 * <en/> Convert extension options to standard format
 * @param graph - <zh/> 图实例 <en/> graph instance
 * @param category - <zh/> 模块类型 <en/> extension type
 * @param extensions - <zh/> 模块配置项 <en/> extension options
 * @returns <zh/> 标准模块配置项 <en/> Standard extension options
 */ function $2dc8f42b51f7999c$export$c81a17884ecd61bc(graph, category, extensions) {
    const counter = {};
    const getKey = (type)=>{
        if (!(type in counter)) counter[type] = 0;
        return `${category}-${type}-${counter[type]++}`;
    };
    return extensions.map((extension)=>{
        if (typeof extension === 'string') return {
            type: extension,
            key: getKey(extension)
        };
        if (typeof extension === 'function') return extension.call(graph);
        if (extension.key) return extension;
        return Object.assign(Object.assign({}, extension), {
            key: getKey(extension.type)
        });
    });
}

});




parcelRegister("8FmDy", function(module, exports) {

$parcel$export(module.exports, "BrushSelect", () => $01a0d585403d13c6$export$4cfe149a081cb3be);
$parcel$export(module.exports, "getCursorPoint", () => $01a0d585403d13c6$export$f373920ca62fc903);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $iE4so = parcelRequire("iE4so");
var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $1igYm = parcelRequire("1igYm");
var $9Iel2 = parcelRequire("9Iel2");

var $brtTw = parcelRequire("brtTw");

var $dnXls = parcelRequire("dnXls");

var $lXl1S = parcelRequire("lXl1S");

var $hQIOr = parcelRequire("hQIOr");
class $01a0d585403d13c6$export$4cfe149a081cb3be extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, (0, $iE4so.default)({}, $01a0d585403d13c6$export$4cfe149a081cb3be.defaultOptions, options));
        this.shortcut = new (0, $lXl1S.Shortcut)(context.graph);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.clearStates = this.clearStates.bind(this);
        this.bindEvents();
    }
    /**
     * Triggered when the pointer is pressed
     * @param event - Pointer event
     * @internal
     */ onPointerDown(event) {
        if (!this.validate(event) || !this.isKeydown() || this.startPoint) return;
        const { canvas: canvas, graph: graph } = this.context;
        const style = Object.assign({}, this.options.style);
        // 根据缩放比例调整 lineWidth
        // Adjust lineWidth according to the zoom ratio
        if (this.options.style.lineWidth) style.lineWidth = +this.options.style.lineWidth / graph.getZoom();
        this.rectShape = new (0, $2eDEB.Rect)({
            id: 'g6-brush-select',
            style: style
        });
        canvas.appendChild(this.rectShape);
        this.startPoint = [
            event.canvas.x,
            event.canvas.y
        ];
    }
    /**
     * Triggered when the pointer is moved
     * @param event - Pointer event
     * @internal
     */ onPointerMove(event) {
        var _a;
        if (!this.startPoint) return;
        const { immediately: immediately, mode: mode } = this.options;
        this.endPoint = $01a0d585403d13c6$export$f373920ca62fc903(event, this.context.graph);
        (_a = this.rectShape) === null || _a === void 0 || _a.attr({
            x: Math.min(this.endPoint[0], this.startPoint[0]),
            y: Math.min(this.endPoint[1], this.startPoint[1]),
            width: Math.abs(this.endPoint[0] - this.startPoint[0]),
            height: Math.abs(this.endPoint[1] - this.startPoint[1])
        });
        if (immediately && mode === 'default') this.updateElementsStates((0, $dnXls.getBoundingPoints)(this.startPoint, this.endPoint));
    }
    /**
     * Triggered when the pointer is released
     * @param event - Pointer event
     * @internal
     */ onPointerUp(event) {
        if (!this.startPoint) return;
        if (!this.endPoint) {
            this.clearBrush();
            return;
        }
        this.endPoint = $01a0d585403d13c6$export$f373920ca62fc903(event, this.context.graph);
        this.updateElementsStates((0, $dnXls.getBoundingPoints)(this.startPoint, this.endPoint));
        this.clearBrush();
    }
    /**
     * <zh/> 清除状态
     *
     * <en/> Clear state
     * @internal
     */ clearStates() {
        if (this.endPoint) return;
        this.clearElementsStates();
    }
    /**
     * <zh/> 清除画布上所有元素的状态
     *
     * <en/> Clear the state of all elements on the canvas
     * @internal
     */ clearElementsStates() {
        const { graph: graph } = this.context;
        const states = Object.values(graph.getData()).reduce((acc, data)=>{
            return Object.assign({}, acc, data.reduce((acc, datum)=>{
                var _a;
                const restStates = (_a = datum.states || []) === null || _a === void 0 ? void 0 : _a.filter((state)=>state !== this.options.state);
                acc[(0, $brtTw.idOf)(datum)] = restStates;
                return acc;
            }, {}));
        }, {});
        graph.setElementState(states, this.options.animation);
    }
    /**
     * <zh/> 更新选中的元素状态
     *
     * <en/> Update the state of the selected elements
     * @param points - <zh/> 框选区域的顶点 | <en/> The vertex of the selection area
     * @internal
     */ updateElementsStates(points) {
        const { graph: graph } = this.context;
        const { enableElements: enableElements, state: state, mode: mode, onSelect: onSelect } = this.options;
        const selectedIds = this.selector(graph, points, enableElements);
        const states = {};
        switch(mode){
            case 'union':
                selectedIds.forEach((id)=>{
                    states[id] = [
                        ...graph.getElementState(id),
                        state
                    ];
                });
                break;
            case 'diff':
                selectedIds.forEach((id)=>{
                    const prevStates = graph.getElementState(id);
                    states[id] = prevStates.includes(state) ? prevStates.filter((s)=>s !== state) : [
                        ...prevStates,
                        state
                    ];
                });
                break;
            case 'intersect':
                selectedIds.forEach((id)=>{
                    const prevStates = graph.getElementState(id);
                    states[id] = prevStates.includes(state) ? [
                        state
                    ] : [];
                });
                break;
            case 'default':
            default:
                selectedIds.forEach((id)=>{
                    states[id] = [
                        state
                    ];
                });
                break;
        }
        if ((0, $ky7aH.default)(onSelect)) onSelect(states);
        graph.setElementState(states, this.options.animation);
    }
    /**
     * <zh/> 查找画布上在指定区域内显示的元素。当节点的包围盒中心在矩形内时，节点被选中；当边的两端节点在矩形内时，边被选中；当 combo 的包围盒中心在矩形内时，combo 被选中。
     *
     * <en/> Find the elements displayed in the specified area on the canvas. A node is selected if the center of its bbox is inside the rect; An edge is selected if both end nodes are inside the rect ;A combo is selected if the center of its bbox is inside the rect.
     * @param graph - <zh/> 图实例 | <en/> Graph instance
     * @param points - <zh/> 框选区域的顶点 | <en/> The vertex of the selection area
     * @param itemTypes - <zh/> 元素类型 | <en/> Element type
     * @returns <zh/> 选中的元素 ID 数组 | <en/> Selected element ID array
     * @internal
     */ selector(graph, points, itemTypes) {
        if (!itemTypes || itemTypes.length === 0) return [];
        const elements = [];
        const graphData = graph.getData();
        itemTypes.forEach((itemType)=>{
            graphData[`${itemType}s`].forEach((datum)=>{
                const id = (0, $brtTw.idOf)(datum);
                if (graph.getElementVisibility(id) !== 'hidden' && (0, $dnXls.isPointInPolygon)(graph.getElementPosition(id), points)) elements.push(id);
            });
        });
        // 如果边的两端节点都在框选范围内，则边也被选中 | If source node and target node are within the selection range, that edge is also selected
        if (itemTypes.includes('edge')) {
            const edges = graphData.edges;
            edges === null || edges === void 0 || edges.forEach((edge)=>{
                const { source: source, target: target } = edge;
                if (elements.includes(source) && elements.includes(target)) elements.push((0, $brtTw.idOf)(edge));
            });
        }
        return elements;
    }
    clearBrush() {
        var _a;
        (_a = this.rectShape) === null || _a === void 0 || _a.remove();
        this.rectShape = undefined;
        this.startPoint = undefined;
        this.endPoint = undefined;
    }
    /**
     * <zh/> 当前按键是否和 trigger 配置一致
     *
     * <en/> Is the current key consistent with the trigger configuration
     * @returns <zh/> 是否一致 | <en/> Is consistent
     * @internal
     */ isKeydown() {
        const { trigger: trigger } = this.options;
        const keys = Array.isArray(trigger) ? trigger : [
            trigger
        ];
        return this.shortcut.match(keys.filter((key)=>key !== 'drag'));
    }
    /**
     * <zh/> 验证是否启用框选
     *
     * <en/> Verify whether brush select is enabled
     * @param event - <zh/> 事件 | <en/> Event
     * @returns <zh/> 是否启用 | <en/> Whether to enable
     * @internal
     */ validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    bindEvents() {
        const { graph: graph } = this.context;
        graph.on((0, $9Iel2.CommonEvent).POINTER_DOWN, this.onPointerDown);
        graph.on((0, $9Iel2.CommonEvent).POINTER_MOVE, this.onPointerMove);
        graph.on((0, $9Iel2.CommonEvent).POINTER_UP, this.onPointerUp);
        graph.on((0, $1igYm.CanvasEvent).CLICK, this.clearStates);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        graph.off((0, $9Iel2.CommonEvent).POINTER_DOWN, this.onPointerDown);
        graph.off((0, $9Iel2.CommonEvent).POINTER_MOVE, this.onPointerMove);
        graph.off((0, $9Iel2.CommonEvent).POINTER_UP, this.onPointerUp);
        graph.off((0, $1igYm.CanvasEvent).CLICK, this.clearStates);
    }
    /**
     * <zh/> 更新配置项
     *
     * <en/> Update configuration
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */ update(options) {
        this.unbindEvents();
        this.options = (0, $iE4so.default)(this.options, options);
        this.bindEvents();
    }
    /**
     * <zh/> 销毁
     *
     * <en/> Destroy
     * @internal
     */ destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
$01a0d585403d13c6$export$4cfe149a081cb3be.defaultOptions = {
    animation: false,
    enable: true,
    enableElements: [
        'node',
        'combo',
        'edge'
    ],
    immediately: false,
    mode: 'default',
    state: 'selected',
    trigger: [
        'shift'
    ],
    style: {
        width: 0,
        height: 0,
        lineWidth: 1,
        fill: '#1677FF',
        stroke: '#1677FF',
        fillOpacity: 0.1,
        zIndex: 2,
        pointerEvents: 'none'
    }
};
const $01a0d585403d13c6$export$f373920ca62fc903 = (event, graph)=>{
    // Fixed #7182: 判断 html 类型节点，并把 html 节点的浏览器坐标转换为 canvas 坐标。
    // 没有直接判断的方式，nativeEvent.target 非 canvas 则表示 html 节点触发的。
    // Fixed #7182: Handles brush selection on HTML nodes by converting client coordinates to canvas coordinates.
    // An HTML node is identified if the event's targetType is 'node' but the nativeEvent.target is not the canvas element.
    if ((event.targetType === 'node' || event.targetType === 'combo') && !(event.nativeEvent.target instanceof HTMLCanvasElement)) {
        const [x, y] = graph.getCanvasByClient([
            event.client.x,
            event.client.y
        ]);
        return [
            x,
            y
        ];
    }
    return [
        event.canvas.x,
        event.canvas.y
    ];
};

});
parcelRegister("iE4so", function(module, exports) {

$parcel$export(module.exports, "default", () => $d92f6b78861ec90c$export$2e2bcd8739ae039);

var $1uF5a = parcelRequire("1uF5a");

var $1RAzq = parcelRequire("1RAzq");
var $d92f6b78861ec90c$var$MAX_MIX_LEVEL = 5;
function $d92f6b78861ec90c$var$hasOwn(object, property) {
    if (Object.hasOwn) return Object.hasOwn(object, property);
    if (object == null) throw new TypeError('Cannot convert undefined or null to object');
    return Object.prototype.hasOwnProperty.call(Object(object), property);
}
function $d92f6b78861ec90c$var$_deepMix(dist, src, level, maxLevel) {
    level = level || 0;
    maxLevel = maxLevel || $d92f6b78861ec90c$var$MAX_MIX_LEVEL;
    for(var key in src)if ($d92f6b78861ec90c$var$hasOwn(src, key)) {
        var value = src[key];
        if (value !== null && (0, $1RAzq.default)(value)) {
            if (!(0, $1RAzq.default)(dist[key])) dist[key] = {};
            if (level < maxLevel) $d92f6b78861ec90c$var$_deepMix(dist[key], value, level + 1, maxLevel);
            else dist[key] = src[key];
        } else if ((0, $1uF5a.default)(value)) {
            dist[key] = [];
            dist[key] = dist[key].concat(value);
        } else if (value !== undefined) dist[key] = value;
    }
}
// todo 重写
var $d92f6b78861ec90c$var$deepMix = function(rst) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    for(var i = 0; i < args.length; i += 1)$d92f6b78861ec90c$var$_deepMix(rst, args[i]);
    return rst;
};
var $d92f6b78861ec90c$export$2e2bcd8739ae039 = $d92f6b78861ec90c$var$deepMix;

});
parcelRegister("1RAzq", function(module, exports) {

$parcel$export(module.exports, "default", () => $15b71bc9525cbab4$export$2e2bcd8739ae039);

var $bDfiK = parcelRequire("bDfiK");

var $9E5Oj = parcelRequire("9E5Oj");
var $15b71bc9525cbab4$var$isPlainObject = function(value) {
    /**
     * isObjectLike(new Foo) => false
     * isObjectLike([1, 2, 3]) => false
     * isObjectLike({ x: 0, y: 0 }) => true
     * isObjectLike(Object.create(null)) => true
     */ if (!(0, $bDfiK.default)(value) || !(0, $9E5Oj.default)(value, 'Object')) return false;
    if (Object.getPrototypeOf(value) === null) return true;
    var proto = value;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(value) === proto;
};
var $15b71bc9525cbab4$export$2e2bcd8739ae039 = $15b71bc9525cbab4$var$isPlainObject;

});


parcelRegister("dnXls", function(module, exports) {

$parcel$export(module.exports, "parsePoint", () => $9beb750eb6405cac$export$792dbf01c6c4c784);
$parcel$export(module.exports, "toPointObject", () => $9beb750eb6405cac$export$9f069b9e50027ae9);
$parcel$export(module.exports, "round", () => $9beb750eb6405cac$export$2077e0241d6afd3c);
$parcel$export(module.exports, "moveTo", () => $9beb750eb6405cac$export$75f1ccd6dc32e80a);
$parcel$export(module.exports, "isHorizontal", () => $9beb750eb6405cac$export$2a62b49acb270576);
$parcel$export(module.exports, "isOrthogonal", () => $9beb750eb6405cac$export$fc3de5308c1cd4e);
$parcel$export(module.exports, "isCollinear", () => $9beb750eb6405cac$export$532e0853644f2f8e);
$parcel$export(module.exports, "getPolygonIntersectPoint", () => $9beb750eb6405cac$export$cfa1dae3a7181c4b);
$parcel$export(module.exports, "isPointInPolygon", () => $9beb750eb6405cac$export$f1c31811357415ac);
$parcel$export(module.exports, "getRectIntersectPoint", () => $9beb750eb6405cac$export$9b21b7ac882fb0b5);
$parcel$export(module.exports, "getEllipseIntersectPoint", () => $9beb750eb6405cac$export$90c27b2db1216b91);
$parcel$export(module.exports, "findNearestPoints", () => $9beb750eb6405cac$export$d33c4679a94e9ce);
$parcel$export(module.exports, "findNearestLine", () => $9beb750eb6405cac$export$2c0c52ad2dbe0a47);
$parcel$export(module.exports, "findNearestPointOnLine", () => $9beb750eb6405cac$export$1382d46f78a999d3);
$parcel$export(module.exports, "sortByClockwise", () => $9beb750eb6405cac$export$6dcf26a04d94b36);
$parcel$export(module.exports, "getBoundingPoints", () => $9beb750eb6405cac$export$3c24cb285e78c656);

var $4ETMA = parcelRequire("4ETMA");

var $6BVcW = parcelRequire("6BVcW");

var $6A02h = parcelRequire("6A02h");

var $46bcR = parcelRequire("46bcR");

var $dOidW = parcelRequire("dOidW");
function $9beb750eb6405cac$export$792dbf01c6c4c784(point) {
    var _a;
    return [
        point.x,
        point.y,
        (_a = point.z) !== null && _a !== void 0 ? _a : 0
    ];
}
function $9beb750eb6405cac$export$9f069b9e50027ae9(point) {
    var _a;
    return {
        x: point[0],
        y: point[1],
        z: (_a = point[2]) !== null && _a !== void 0 ? _a : 0
    };
}
function $9beb750eb6405cac$export$756ad077f724ca02(points) {
    return points.sort((a, b)=>a[0] - b[0] || a[1] - b[1]);
}
function $9beb750eb6405cac$export$6b75200e58bc97d0(points) {
    const set = new Set();
    return points.filter((p)=>{
        const key = p.join(',');
        if (set.has(key)) return false;
        set.add(key);
        return true;
    });
}
function $9beb750eb6405cac$export$2077e0241d6afd3c(point, digits = 0) {
    return point.map((p)=>parseFloat(p.toFixed(digits)));
}
function $9beb750eb6405cac$export$75f1ccd6dc32e80a(p, ref, distance, reverse = false) {
    if ((0, $4ETMA.default)(p, ref)) return p;
    const direction = reverse ? (0, $dOidW.subtract)(p, ref) : (0, $dOidW.subtract)(ref, p);
    const normalizedDirection = (0, $dOidW.normalize)(direction);
    const moveVector = [
        normalizedDirection[0] * distance,
        normalizedDirection[1] * distance
    ];
    return (0, $dOidW.add)((0, $dOidW.toVector2)(p), moveVector);
}
function $9beb750eb6405cac$export$2a62b49acb270576(p1, p2) {
    return p1[1] === p2[1];
}
function $9beb750eb6405cac$export$42c0085b96d0f4c4(p1, p2) {
    return p1[0] === p2[0];
}
function $9beb750eb6405cac$export$fc3de5308c1cd4e(p1, p2) {
    return $9beb750eb6405cac$export$2a62b49acb270576(p1, p2) || $9beb750eb6405cac$export$42c0085b96d0f4c4(p1, p2);
}
function $9beb750eb6405cac$export$532e0853644f2f8e(p1, p2, p3) {
    return (0, $6A02h.isLinesParallel)([
        p1,
        p2
    ], [
        p2,
        p3
    ]);
}
function $9beb750eb6405cac$export$f9cda2a52d194850(p, center) {
    return [
        2 * center[0] - p[0],
        2 * center[1] - p[1]
    ];
}
function $9beb750eb6405cac$export$cfa1dae3a7181c4b(p, center, points, isRelativePos = true, useExtendedLine = false) {
    for(let i = 0; i < points.length; i++){
        let start = points[i];
        let end = points[(i + 1) % points.length];
        if (isRelativePos) {
            start = (0, $dOidW.add)(center, start);
            end = (0, $dOidW.add)(center, end);
        }
        const refP = useExtendedLine ? $9beb750eb6405cac$export$f9cda2a52d194850(p, center) : p;
        const intersect = (0, $6A02h.getLinesIntersection)([
            center,
            refP
        ], [
            start,
            end
        ]);
        if (intersect) return {
            point: intersect,
            line: [
                start,
                end
            ]
        };
    }
    return {
        point: center,
        line: undefined
    };
}
function $9beb750eb6405cac$export$f1c31811357415ac(point, points, start, end) {
    const x = point[0];
    const y = point[1];
    let inside = false;
    if (start === undefined) start = 0;
    if (end === undefined) end = points.length;
    const len = end - start;
    for(let i = 0, j = len - 1; i < len; j = i++){
        const xi = points[i + start][0];
        const yi = points[i + start][1];
        const xj = points[j + start][0];
        const yj = points[j + start][1];
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $9beb750eb6405cac$export$9b21b7ac882fb0b5(p, bbox, useExtendedLine = false) {
    const center = (0, $46bcR.getXYByPlacement)(bbox, 'center');
    const corners = [
        (0, $46bcR.getXYByPlacement)(bbox, 'left-top'),
        (0, $46bcR.getXYByPlacement)(bbox, 'right-top'),
        (0, $46bcR.getXYByPlacement)(bbox, 'right-bottom'),
        (0, $46bcR.getXYByPlacement)(bbox, 'left-bottom')
    ];
    return $9beb750eb6405cac$export$cfa1dae3a7181c4b(p, center, corners, false, useExtendedLine).point;
}
function $9beb750eb6405cac$export$90c27b2db1216b91(p, bbox, useExtendedLine = false) {
    const center = bbox.center;
    const refP = useExtendedLine ? $9beb750eb6405cac$export$f9cda2a52d194850(p, center) : p;
    const vec = (0, $dOidW.subtract)(refP, bbox.center);
    const angle = Math.atan2(vec[1], vec[0]);
    if (isNaN(angle)) return center;
    const rx = (0, $6BVcW.getBBoxWidth)(bbox) / 2;
    const ry = (0, $6BVcW.getBBoxHeight)(bbox) / 2;
    const intersectX = center[0] + rx * Math.cos(angle);
    const intersectY = center[1] + ry * Math.sin(angle);
    return [
        intersectX,
        intersectY
    ];
}
function $9beb750eb6405cac$export$d33c4679a94e9ce(group1, group2) {
    let minDistance = Infinity;
    let nearestPoints = [
        group1[0],
        group2[0]
    ];
    group1.forEach((p1)=>{
        group2.forEach((p2)=>{
            const dist = (0, $dOidW.distance)(p1, p2);
            if (dist < minDistance) {
                minDistance = dist;
                nearestPoints = [
                    p1,
                    p2
                ];
            }
        });
    });
    return nearestPoints;
}
function $9beb750eb6405cac$export$2c0c52ad2dbe0a47(point, lines) {
    let minDistance = Infinity;
    let nearestLine = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    lines.forEach((line)=>{
        const distance = $9beb750eb6405cac$export$3bc502c97b7a5c4f(point, line);
        if (distance < minDistance) {
            minDistance = distance;
            nearestLine = line;
        }
    });
    return nearestLine;
}
function $9beb750eb6405cac$export$3bc502c97b7a5c4f(point, line) {
    const nearestPoint = $9beb750eb6405cac$export$1382d46f78a999d3(point, line);
    return (0, $dOidW.distance)(point, nearestPoint);
}
function $9beb750eb6405cac$export$1382d46f78a999d3(point, line) {
    const [x1, y1] = line[0];
    const [x2, y2] = line[1];
    const [x3, y3] = point;
    const px = x2 - x1;
    const py = y2 - y1;
    // 若线段实际上是一个点 | If the line segment is actually a point
    if (px === 0 && py === 0) return [
        x1,
        y1
    ];
    let u = ((x3 - x1) * px + (y3 - y1) * py) / (px * px + py * py);
    if (u > 1) u = 1;
    else if (u < 0) u = 0;
    const x = x1 + u * px;
    const y = y1 + u * py;
    return [
        x,
        y
    ];
}
function $9beb750eb6405cac$export$cafcc6d33cfa0d85(points) {
    const totalPosition = points.reduce((acc, p)=>(0, $dOidW.add)(acc, p), [
        0,
        0
    ]);
    return (0, $dOidW.divide)(totalPosition, points.length);
}
function $9beb750eb6405cac$export$6dcf26a04d94b36(points, clockwise = true) {
    const center = $9beb750eb6405cac$export$cafcc6d33cfa0d85(points);
    return points.sort(([x1, y1], [x2, y2])=>{
        const angle1 = Math.atan2(y1 - center[1], x1 - center[0]);
        const angle2 = Math.atan2(y2 - center[1], x2 - center[0]);
        return clockwise ? angle2 - angle1 : angle1 - angle2;
    });
}
function $9beb750eb6405cac$export$3c24cb285e78c656(start, end) {
    return [
        start,
        [
            start[0],
            end[1]
        ],
        end,
        [
            end[0],
            start[1]
        ]
    ];
}

});
parcelRegister("6A02h", function(module, exports) {

$parcel$export(module.exports, "isLinesParallel", () => $4ca621f3b3b9660a$export$f35a40f25cd47ee1);
$parcel$export(module.exports, "getLinesIntersection", () => $4ca621f3b3b9660a$export$ed6d29fbb19b6991);

var $2Rqcx = parcelRequire("2Rqcx");

var $dOidW = parcelRequire("dOidW");
function $4ca621f3b3b9660a$export$f35a40f25cd47ee1(l1, l2) {
    const [p1, p2] = l1;
    const [p3, p4] = l2;
    const v1 = (0, $dOidW.subtract)(p1, p2);
    const v2 = (0, $dOidW.subtract)(p3, p4);
    return (0, $dOidW.cross)(v1, v2).every((v)=>v === 0);
}
function $4ca621f3b3b9660a$export$ed6d29fbb19b6991(l1, l2, extended = false) {
    if ($4ca621f3b3b9660a$export$f35a40f25cd47ee1(l1, l2)) return undefined;
    const [p1, p2] = l1;
    const [p3, p4] = l2;
    const t = ((p1[0] - p3[0]) * (p3[1] - p4[1]) - (p1[1] - p3[1]) * (p3[0] - p4[0])) / ((p1[0] - p2[0]) * (p3[1] - p4[1]) - (p1[1] - p2[1]) * (p3[0] - p4[0]));
    const u = p4[0] - p3[0] ? (p1[0] - p3[0] + t * (p2[0] - p1[0])) / (p4[0] - p3[0]) : (p1[1] - p3[1] + t * (p2[1] - p1[1])) / (p4[1] - p3[1]);
    if (!extended && (!(0, $2Rqcx.isBetween)(t, 0, 1) || !(0, $2Rqcx.isBetween)(u, 0, 1))) return undefined;
    return [
        p1[0] + t * (p2[0] - p1[0]),
        p1[1] + t * (p2[1] - p1[1])
    ];
}

});
parcelRegister("dOidW", function(module, exports) {

$parcel$export(module.exports, "add", () => $a0de14c4f9f35791$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $a0de14c4f9f35791$export$4e2d2ead65e5f7e3);
$parcel$export(module.exports, "multiply", () => $a0de14c4f9f35791$export$2060d2db72cce88f);
$parcel$export(module.exports, "divide", () => $a0de14c4f9f35791$export$cd007d971a5a2143);
$parcel$export(module.exports, "dot", () => $a0de14c4f9f35791$export$94132a0e348806d4);
$parcel$export(module.exports, "cross", () => $a0de14c4f9f35791$export$bb646b20bb93d339);
$parcel$export(module.exports, "toVector3", () => $a0de14c4f9f35791$export$bee7d48fc0ecc4ba);
$parcel$export(module.exports, "scale", () => $a0de14c4f9f35791$export$dcdf75081b88279d);
$parcel$export(module.exports, "distance", () => $a0de14c4f9f35791$export$9f17032d917177de);
$parcel$export(module.exports, "manhattanDistance", () => $a0de14c4f9f35791$export$979519cf209c6e80);
$parcel$export(module.exports, "normalize", () => $a0de14c4f9f35791$export$a3295358bff77e);
$parcel$export(module.exports, "angle", () => $a0de14c4f9f35791$export$944b09d2ad10b378);
$parcel$export(module.exports, "perpendicular", () => $a0de14c4f9f35791$export$925f0837913477e8);
$parcel$export(module.exports, "mod", () => $a0de14c4f9f35791$export$842a2cf37af977e1);
$parcel$export(module.exports, "toVector2", () => $a0de14c4f9f35791$export$200b7785f24bd7c0);
$parcel$export(module.exports, "rad", () => $a0de14c4f9f35791$export$29e4e862bebba87f);
$parcel$export(module.exports, "rotate", () => $a0de14c4f9f35791$export$bb628a54ab399bc9);

var $lEe0S = parcelRequire("lEe0S");
const $a0de14c4f9f35791$var$VECTOR_ZERO = [
    0,
    0,
    0
];
function $a0de14c4f9f35791$export$e16d8520af44a096(a, b) {
    return a.map((v, i)=>v + b[i]);
}
function $a0de14c4f9f35791$export$4e2d2ead65e5f7e3(a, b) {
    return a.map((v, i)=>v - b[i]);
}
function $a0de14c4f9f35791$export$2060d2db72cce88f(a, b) {
    if (typeof b === 'number') return a.map((v)=>v * b);
    return a.map((v, i)=>v * b[i]);
}
function $a0de14c4f9f35791$export$cd007d971a5a2143(a, b) {
    if (typeof b === 'number') return a.map((v)=>v / b);
    return a.map((v, i)=>v / b[i]);
}
function $a0de14c4f9f35791$export$94132a0e348806d4(a, b) {
    return a.reduce((sum, v, i)=>sum + v * b[i], 0);
}
function $a0de14c4f9f35791$export$bb646b20bb93d339(a, b) {
    const a2 = $a0de14c4f9f35791$export$bee7d48fc0ecc4ba(a);
    const b2 = $a0de14c4f9f35791$export$bee7d48fc0ecc4ba(b);
    return [
        a2[1] * b2[2] - a2[2] * b2[1],
        a2[2] * b2[0] - a2[0] * b2[2],
        a2[0] * b2[1] - a2[1] * b2[0]
    ];
}
function $a0de14c4f9f35791$export$dcdf75081b88279d(a, s) {
    return a.map((v)=>v * s);
}
function $a0de14c4f9f35791$export$9f17032d917177de(a, b) {
    return Math.sqrt(a.reduce((sum, v, i)=>sum + Math.pow(v - b[i] || 0, 2), 0));
}
function $a0de14c4f9f35791$export$979519cf209c6e80(a, b) {
    return a.reduce((sum, v, i)=>sum + Math.abs(v - b[i]), 0);
}
function $a0de14c4f9f35791$export$a3295358bff77e(a) {
    const length = a.reduce((sum, v)=>sum + Math.pow(v, 2), 0);
    return a.map((v)=>v / Math.sqrt(length));
}
function $a0de14c4f9f35791$export$944b09d2ad10b378(a, b, clockwise = false) {
    const determinant = a[0] * b[1] - a[1] * b[0];
    let angle1 = Math.acos($a0de14c4f9f35791$export$2060d2db72cce88f(a, b).reduce((sum, v)=>sum + v, 0) / ($a0de14c4f9f35791$export$9f17032d917177de(a, $a0de14c4f9f35791$var$VECTOR_ZERO) * $a0de14c4f9f35791$export$9f17032d917177de(b, $a0de14c4f9f35791$var$VECTOR_ZERO)));
    // If clockwise is true and determinant is negative, adjust the angle
    if (clockwise && determinant < 0) angle1 = 2 * Math.PI - angle1;
    return angle1;
}
function $a0de14c4f9f35791$export$f2599a5cf1109d8(a, b) {
    return a.every((v, i)=>v === b[i]);
}
function $a0de14c4f9f35791$export$925f0837913477e8(a, clockwise = true) {
    return clockwise ? [
        -a[1],
        a[0]
    ] : [
        a[1],
        -a[0]
    ];
}
function $a0de14c4f9f35791$export$842a2cf37af977e1(a, b) {
    return a.map((v)=>v % b);
}
function $a0de14c4f9f35791$export$200b7785f24bd7c0(a) {
    return [
        a[0],
        a[1]
    ];
}
function $a0de14c4f9f35791$export$bee7d48fc0ecc4ba(a) {
    return (0, $lEe0S.isVector2)(a) ? [
        a[0],
        a[1],
        0
    ] : a;
}
function $a0de14c4f9f35791$export$29e4e862bebba87f(a) {
    const [x, y] = a;
    if (!x && !y) return 0;
    return Math.atan2(y, x);
}
function $a0de14c4f9f35791$export$bb628a54ab399bc9(a, angle) {
    const [dx, dy] = a;
    if (angle % 360 === 0) return [
        dx,
        dy
    ];
    const rad = angle * Math.PI / 180;
    const cos = Math.cos(rad);
    const sin = Math.sin(rad);
    return [
        dx * cos - dy * sin,
        dx * sin + dy * cos
    ];
}

});


parcelRegister("46bcR", function(module, exports) {

$parcel$export(module.exports, "positionOf", () => $2fc06a599875323b$export$e236a8e10ac348c3);
$parcel$export(module.exports, "hasPosition", () => $2fc06a599875323b$export$d00fedf23ce8ff1);
$parcel$export(module.exports, "getXYByPlacement", () => $2fc06a599875323b$export$c291894814e0c502);

var $434wt = parcelRequire("434wt");

var $jtAhq = parcelRequire("jtAhq");
function $2fc06a599875323b$export$e236a8e10ac348c3(datum) {
    const { x: x = 0, y: y = 0, z: z = 0 } = datum.style || {};
    return [
        +x,
        +y,
        +z
    ];
}
function $2fc06a599875323b$export$d00fedf23ce8ff1(datum) {
    const { x: x, y: y, z: z } = datum.style || {};
    return x !== undefined || y !== undefined || z !== undefined;
}
function $2fc06a599875323b$export$46ce5814d9a93985(bbox, placement) {
    const [x, y] = placement;
    const { min: min, max: max } = bbox;
    return [
        min[0] + x * (max[0] - min[0]),
        min[1] + y * (max[1] - min[1])
    ];
}
function $2fc06a599875323b$export$c291894814e0c502(bbox, placement = 'center') {
    const relativePlacement = (0, $jtAhq.parsePlacement)(placement);
    return $2fc06a599875323b$export$46ce5814d9a93985(bbox, relativePlacement);
}
function $2fc06a599875323b$export$26157df41aafdc88(bbox, anchor) {
    const parsedAnchor = (0, $434wt.parseAnchor)(anchor);
    return $2fc06a599875323b$export$46ce5814d9a93985(bbox, parsedAnchor);
}
const $2fc06a599875323b$export$36764b274aa8fb5f = (points)=>{
    const [p1, p2] = points;
    return {
        left: Math.min(p1[0], p2[0]),
        right: Math.max(p1[0], p2[0]),
        top: Math.min(p1[1], p2[1]),
        bottom: Math.max(p1[1], p2[1])
    };
};

});
parcelRegister("434wt", function(module, exports) {

$parcel$export(module.exports, "parseAnchor", () => $2f2af35ea0b2c46a$export$49d416a6d8a07bbb);

var $2Rqcx = parcelRequire("2Rqcx");
function $2f2af35ea0b2c46a$export$49d416a6d8a07bbb(anchor) {
    const parsedAnchor = typeof anchor === 'string' ? anchor.split(' ').map((v)=>parseFloat(v)) : anchor.slice(0, 2);
    if (!(0, $2Rqcx.isBetween)(parsedAnchor[0], 0, 1) || !(0, $2Rqcx.isBetween)(parsedAnchor[1], 0, 1)) return [
        0.5,
        0.5
    ];
    return parsedAnchor;
}

});

parcelRegister("jtAhq", function(module, exports) {

$parcel$export(module.exports, "parsePlacement", () => $e2dcde374d8beafa$export$8a2a3c01f4be5f01);

var $2Rqcx = parcelRequire("2Rqcx");
function $e2dcde374d8beafa$export$8a2a3c01f4be5f01(placement) {
    if (Array.isArray(placement)) return (0, $2Rqcx.isBetween)(placement[0], 0, 1) && (0, $2Rqcx.isBetween)(placement[1], 0, 1) ? placement : [
        0.5,
        0.5
    ];
    const direction = placement.split('-');
    const x = direction.includes('left') ? 0 : direction.includes('right') ? 1 : 0.5;
    const y = direction.includes('top') ? 0 : direction.includes('bottom') ? 1 : 0.5;
    return [
        x,
        y
    ];
}

});



parcelRegister("lXl1S", function(module, exports) {

$parcel$export(module.exports, "Shortcut", () => $ffbf6ba1f7069179$export$59451aa6b6270879);

var $4ETMA = parcelRequire("4ETMA");
var $kVcyu = parcelRequire("kVcyu");
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");

var $j5Xqx = parcelRequire("j5Xqx");
const $ffbf6ba1f7069179$var$lowerCaseKeys = (keys)=>keys.map((key)=>(0, $kVcyu.default)(key) ? key.toLocaleLowerCase() : key);
class $ffbf6ba1f7069179$export$59451aa6b6270879 {
    constructor(emitter){
        this.map = new Map();
        this.boundHandlePinch = ()=>{};
        this.recordKey = new Set();
        this.onKeyDown = (event)=>{
            if (!(event === null || event === void 0 ? void 0 : event.key)) return;
            this.recordKey.add(event.key);
            this.trigger(event);
        };
        this.onKeyUp = (event)=>{
            if (!(event === null || event === void 0 ? void 0 : event.key)) return;
            this.recordKey.delete(event.key);
        };
        this.onWheel = (event)=>{
            this.triggerExtendKey((0, $9Iel2.CommonEvent).WHEEL, event);
        };
        this.onDrag = (event)=>{
            this.triggerExtendKey((0, $9Iel2.CommonEvent).DRAG, event);
        };
        this.handlePinch = (event, options)=>{
            this.triggerExtendKey((0, $9Iel2.CommonEvent).PINCH, Object.assign(Object.assign({}, event), options));
        };
        this.onFocus = ()=>{
            this.recordKey.clear();
        };
        this.emitter = emitter;
        this.bindEvents();
    }
    bind(key, handler) {
        if (key.length === 0) return;
        if (key.includes((0, $9Iel2.CommonEvent).PINCH) && !this.pinchHandler) {
            this.boundHandlePinch = this.handlePinch.bind(this);
            this.pinchHandler = new (0, $j5Xqx.PinchHandler)(this.emitter, 'pinchmove', this.boundHandlePinch);
        }
        this.map.set(key, handler);
    }
    unbind(key, handler) {
        this.map.forEach((h, k)=>{
            if ((0, $4ETMA.default)(k, key)) {
                if (!handler || handler === h) this.map.delete(k);
            }
        });
    }
    unbindAll() {
        this.map.clear();
    }
    match(key) {
        // 排序
        const recordKeyList = $ffbf6ba1f7069179$var$lowerCaseKeys(Array.from(this.recordKey)).sort();
        const keyList = $ffbf6ba1f7069179$var$lowerCaseKeys(key).sort();
        return (0, $4ETMA.default)(recordKeyList, keyList);
    }
    bindEvents() {
        var _a;
        const { emitter: emitter } = this;
        emitter.on((0, $9Iel2.CommonEvent).KEY_DOWN, this.onKeyDown);
        emitter.on((0, $9Iel2.CommonEvent).KEY_UP, this.onKeyUp);
        emitter.on((0, $9Iel2.CommonEvent).WHEEL, this.onWheel);
        emitter.on((0, $9Iel2.CommonEvent).DRAG, this.onDrag);
        // 窗口重新获得焦点后清空按键，避免按键状态异常
        // Clear the keys when the window regains focus to avoid abnormal key states
        (_a = globalThis.addEventListener) === null || _a === void 0 || _a.call(globalThis, 'focus', this.onFocus);
    }
    trigger(event) {
        this.map.forEach((handler, key)=>{
            if (this.match(key)) handler(event);
        });
    }
    /**
     * <zh/> 扩展 wheel, drag 操作
     *
     * <en/> Extend wheel, drag operations
     * @param eventType - event name
     * @param event - event
     */ triggerExtendKey(eventType, event) {
        this.map.forEach((handler, key)=>{
            if (key.includes(eventType)) {
                if ((0, $4ETMA.default)(Array.from(this.recordKey), key.filter((k)=>k !== eventType))) handler(event);
            }
        });
    }
    destroy() {
        var _a, _b;
        this.unbindAll();
        this.emitter.off((0, $9Iel2.CommonEvent).KEY_DOWN, this.onKeyDown);
        this.emitter.off((0, $9Iel2.CommonEvent).KEY_UP, this.onKeyUp);
        this.emitter.off((0, $9Iel2.CommonEvent).WHEEL, this.onWheel);
        this.emitter.off((0, $9Iel2.CommonEvent).DRAG, this.onDrag);
        (_a = this.pinchHandler) === null || _a === void 0 || _a.off('pinchmove', this.boundHandlePinch);
        (_b = globalThis.removeEventListener) === null || _b === void 0 || _b.call(globalThis, 'focus', this.onFocus);
    }
}

});
parcelRegister("j5Xqx", function(module, exports) {

$parcel$export(module.exports, "PinchHandler", () => $de6c94e9e055dfc0$export$f145633f8210444);
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");
class $de6c94e9e055dfc0$export$f145633f8210444 {
    constructor(emitter, phase, callback){
        this.phase = phase;
        /**
         * <zh/> 当前跟踪的触摸点集合
         *
         * <en/> Currently tracked touch points collection
         */ this.pointerByTouch = [];
        /**
         * <zh/> 初始两点间距离
         *
         * <en/> Initial distance between two points
         */ this.initialDistance = null;
        this.emitter = emitter;
        if ($de6c94e9e055dfc0$export$f145633f8210444.instance) {
            $de6c94e9e055dfc0$export$f145633f8210444.callbacks[this.phase].push(callback);
            return $de6c94e9e055dfc0$export$f145633f8210444.instance;
        }
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.bindEvents();
        $de6c94e9e055dfc0$export$f145633f8210444.instance = this;
        $de6c94e9e055dfc0$export$f145633f8210444.callbacks[this.phase].push(callback);
    }
    bindEvents() {
        const { emitter: emitter } = this;
        emitter.on((0, $9Iel2.CommonEvent).POINTER_DOWN, this.onPointerDown);
        emitter.on((0, $9Iel2.CommonEvent).POINTER_MOVE, this.onPointerMove);
        emitter.on((0, $9Iel2.CommonEvent).POINTER_UP, this.onPointerUp);
    }
    /**
     * <zh/> 更新指定指针的位置
     *
     * <en/> Update position of specified pointer
     * @param pointerId - <zh/> 指针唯一标识符 | <en/> Pointer unique identifier<sup>1</sup>
     * @param x - <zh/> 新的X坐标 | <en/> New X coordinate
     * @param y - <zh/> 新的Y坐标 | <en/> New Y coordinate
     */ updatePointerPosition(pointerId, x, y) {
        const index = this.pointerByTouch.findIndex((p)=>p.pointerId === pointerId);
        if (index >= 0) this.pointerByTouch[index] = {
            x: x,
            y: y,
            pointerId: pointerId
        };
    }
    /**
     * <zh/> 处理指针按下事件
     *
     * <en/> Handle pointer down event
     * @param event - <zh/> 指针事件对象 | <en/> Pointer event object
     * @remarks
     * <zh/> 当检测到两个触摸点时记录初始距离
     *
     * <en/> Record initial distance when detecting two touch points
     */ onPointerDown(event) {
        const { x: x, y: y } = event.client || {};
        if (x === undefined || y === undefined) return;
        this.pointerByTouch.push({
            x: x,
            y: y,
            pointerId: event.pointerId
        });
        if (event.pointerType === 'touch' && this.pointerByTouch.length === 2) {
            $de6c94e9e055dfc0$export$f145633f8210444.isPinching = true;
            const dx = this.pointerByTouch[0].x - this.pointerByTouch[1].x;
            const dy = this.pointerByTouch[0].y - this.pointerByTouch[1].y;
            this.initialDistance = Math.sqrt(dx * dx + dy * dy);
            $de6c94e9e055dfc0$export$f145633f8210444.callbacks.pinchstart.forEach((cb)=>cb(event, {
                    scale: 0
                }));
        }
    }
    /**
     * <zh/> 处理指针移动事件
     *
     * <en/> Handle pointer move event
     * @param event - <zh/> 指针事件对象 | <en/> Pointer event object
     * @remarks
     * <zh/> 当存在两个有效触摸点时计算缩放比例
     *
     * <en/> Calculate zoom ratio when two valid touch points exist
     */ onPointerMove(event) {
        if (this.pointerByTouch.length !== 2 || this.initialDistance === null) return;
        const { x: x, y: y } = event.client || {};
        if (x === undefined || y === undefined) return;
        this.updatePointerPosition(event.pointerId, x, y);
        const dx = this.pointerByTouch[0].x - this.pointerByTouch[1].x;
        const dy = this.pointerByTouch[0].y - this.pointerByTouch[1].y;
        const currentDistance = Math.sqrt(dx * dx + dy * dy);
        const ratio = currentDistance / this.initialDistance;
        $de6c94e9e055dfc0$export$f145633f8210444.callbacks.pinchmove.forEach((cb)=>cb(event, {
                scale: (ratio - 1) * 5
            }));
    }
    /**
     * <zh/> 处理指针抬起事件
     *
     * <en/> Handle pointer up event
     * @param event
     * @remarks
     * <zh/> 重置触摸状态和初始距离
     *
     * <en/> Reset touch state and initial distance
     */ onPointerUp(event) {
        var _a;
        $de6c94e9e055dfc0$export$f145633f8210444.callbacks.pinchend.forEach((cb)=>cb(event, {
                scale: 0
            }));
        $de6c94e9e055dfc0$export$f145633f8210444.isPinching = false;
        this.initialDistance = null;
        this.pointerByTouch = [];
        (_a = $de6c94e9e055dfc0$export$f145633f8210444.instance) === null || _a === void 0 || _a.tryDestroy();
    }
    /**
     * <zh/> 销毁捏合手势相关监听
     *
     * <en/> Destroy pinch gesture listeners
     * @remarks
     * <zh/> 移除指针按下、移动、抬起事件的监听
     *
     * <en/> Remove listeners for pointer down, move, and up events
     */ destroy() {
        this.emitter.off((0, $9Iel2.CommonEvent).POINTER_DOWN, this.onPointerDown);
        this.emitter.off((0, $9Iel2.CommonEvent).POINTER_MOVE, this.onPointerMove);
        this.emitter.off((0, $9Iel2.CommonEvent).POINTER_UP, this.onPointerUp);
        $de6c94e9e055dfc0$export$f145633f8210444.instance = null;
    }
    /**
     * <zh/> 解绑指定阶段的手势回调
     * <en/> Unregister gesture callback for specific phase
     * @param phase - <zh/> 手势阶段：开始(pinchstart)/移动(pinchmove)/结束(pinchend) | <en/> Gesture phase: start/move/end
     * @param callback - <zh/> 要解绑的回调函数 | <en/> Callback function to unregister
     * @remarks
     * <zh/> 从指定阶段的回调列表中移除特定回调，当所有回调都解绑后自动销毁事件监听
     * <en/> Remove specific callback from the phase's callback list, auto-destroy event listeners when all callbacks are unregistered
     */ off(phase, callback) {
        const index = $de6c94e9e055dfc0$export$f145633f8210444.callbacks[phase].indexOf(callback);
        if (index > -1) $de6c94e9e055dfc0$export$f145633f8210444.callbacks[phase].splice(index, 1);
        this.tryDestroy();
    }
    /**
     * <zh/> 尝试销毁手势处理器
     * <en/> Attempt to destroy the gesture handler
     * @remarks
     * <zh/> 当所有阶段（开始/移动/结束）的回调列表都为空时，执行实际销毁操作
     * <en/> Perform actual destruction when all phase (pinchstart/pinchmove/pinchend) callback lists are empty
     * <zh/> 自动解除事件监听并重置单例实例
     * <en/> Automatically remove event listeners and reset singleton instance
     */ tryDestroy() {
        if (Object.values($de6c94e9e055dfc0$export$f145633f8210444.callbacks).every((arr)=>arr.length === 0)) this.destroy();
    }
}
/**
 * <zh/> 是否处于 Pinch 阶段
 *
 * <en/> Whether it is in the Pinch stage
 */ $de6c94e9e055dfc0$export$f145633f8210444.isPinching = false;
$de6c94e9e055dfc0$export$f145633f8210444.instance = null;
$de6c94e9e055dfc0$export$f145633f8210444.callbacks = {
    pinchstart: [],
    pinchmove: [],
    pinchend: []
};

});



parcelRegister("hgdlM", function(module, exports) {

$parcel$export(module.exports, "ClickSelect", () => $c90e4961903404fc$export$d44abbe0f8b2c0ce);

var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $1igYm = parcelRequire("1igYm");
var $9Iel2 = parcelRequire("9Iel2");

var $hXCXB = parcelRequire("hXCXB");

var $brtTw = parcelRequire("brtTw");

var $aAA2B = parcelRequire("aAA2B");

var $lXl1S = parcelRequire("lXl1S");

var $gzW5B = parcelRequire("gzW5B");

var $hQIOr = parcelRequire("hQIOr");
var $c90e4961903404fc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $c90e4961903404fc$export$d44abbe0f8b2c0ce extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $c90e4961903404fc$export$d44abbe0f8b2c0ce.defaultOptions, options));
        this.onClickSelect = (event)=>$c90e4961903404fc$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                if (!this.validate(event)) return;
                yield this.updateState(event);
                (_b = (_a = this.options).onClick) === null || _b === void 0 || _b.call(_a, event);
            });
        this.onClickCanvas = (event)=>$c90e4961903404fc$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                if (!this.validate(event)) return;
                yield this.clearState();
                (_b = (_a = this.options).onClick) === null || _b === void 0 || _b.call(_a, event);
            });
        this.shortcut = new (0, $lXl1S.Shortcut)(context.graph);
        this.bindEvents();
    }
    bindEvents() {
        const { graph: graph } = this.context;
        this.unbindEvents();
        (0, $hXCXB.ELEMENT_TYPES).forEach((type)=>{
            graph.on(`${type}:${(0, $9Iel2.CommonEvent).CLICK}`, this.onClickSelect);
        });
        graph.on((0, $1igYm.CanvasEvent).CLICK, this.onClickCanvas);
    }
    get isMultipleSelect() {
        const { multiple: multiple, trigger: trigger } = this.options;
        return multiple && this.shortcut.match(trigger);
    }
    getNeighborIds(event) {
        const { target: target, targetType: targetType } = event;
        const { graph: graph } = this.context;
        const { degree: degree } = this.options;
        return (0, $aAA2B.getElementNthDegreeIds)(graph, targetType, target.id, typeof degree === 'function' ? degree(event) : degree).filter((id)=>id !== target.id);
    }
    updateState(event) {
        return $c90e4961903404fc$var$__awaiter(this, void 0, void 0, function*() {
            const { state: selectState, unselectedState: unselectedState, neighborState: neighborState, animation: animation } = this.options;
            if (!selectState && !neighborState && !unselectedState) return;
            const { target: target } = event;
            const { graph: graph } = this.context;
            const datum = graph.getElementData(target.id);
            const type = (0, $gzW5B.statesOf)(datum).includes(selectState) ? 'unselect' : 'select';
            const states = {};
            const isMultipleSelect = this.isMultipleSelect;
            const click = [
                target.id
            ];
            const neighbor = this.getNeighborIds(event);
            if (!isMultipleSelect) {
                if (type === 'select') {
                    Object.assign(states, this.getClearStates(!!unselectedState));
                    const addState = (list, state)=>{
                        list.forEach((id)=>{
                            if (!states[id]) states[id] = graph.getElementState(id);
                            states[id].push(state);
                        });
                    };
                    addState(click, selectState);
                    addState(neighbor, neighborState);
                    if (unselectedState) Object.keys(states).forEach((id)=>{
                        if (!click.includes(id) && !neighbor.includes(id)) states[id].push(unselectedState);
                    });
                } else Object.assign(states, this.getClearStates());
            } else {
                Object.assign(states, this.getDataStates());
                if (type === 'select') {
                    const addState = (list, state)=>{
                        list.forEach((id)=>{
                            const dataStatesSet = new Set(graph.getElementState(id));
                            dataStatesSet.add(state);
                            dataStatesSet.delete(unselectedState);
                            states[id] = Array.from(dataStatesSet);
                        });
                    };
                    addState(click, selectState);
                    addState(neighbor, neighborState);
                    if (unselectedState) Object.keys(states).forEach((id)=>{
                        const _states = states[id];
                        if (!_states.includes(selectState) && !_states.includes(neighborState) && !_states.includes(unselectedState)) states[id].push(unselectedState);
                    });
                } else {
                    const targetState = states[target.id];
                    states[target.id] = targetState.filter((s)=>s !== selectState && s !== neighborState);
                    if (!targetState.includes(unselectedState)) states[target.id].push(unselectedState);
                    neighbor.forEach((id)=>{
                        states[id] = states[id].filter((s)=>s !== neighborState);
                        if (!states[id].includes(selectState)) states[id].push(unselectedState);
                    });
                }
            }
            yield graph.setElementState(states, animation);
        });
    }
    getDataStates() {
        const { graph: graph } = this.context;
        const { nodes: nodes, edges: edges, combos: combos } = graph.getData();
        const states = {};
        [
            ...nodes,
            ...edges,
            ...combos
        ].forEach((data)=>{
            states[(0, $brtTw.idOf)(data)] = (0, $gzW5B.statesOf)(data);
        });
        return states;
    }
    /**
     * <zh/> 获取需要清除的状态
     *
     * <en/> Get the states that need to be cleared
     * @param complete - <zh/> 是否返回所有状态 | <en/> Whether to return all states
     * @returns - <zh/> 需要清除的状态 | <en/> States that need to be cleared
     */ getClearStates(complete = false) {
        const { graph: graph } = this.context;
        const { state: state, unselectedState: unselectedState, neighborState: neighborState } = this.options;
        const statesToClear = new Set([
            state,
            unselectedState,
            neighborState
        ]);
        const { nodes: nodes, edges: edges, combos: combos } = graph.getData();
        const states = {};
        [
            ...nodes,
            ...edges,
            ...combos
        ].forEach((data)=>{
            const datumStates = (0, $gzW5B.statesOf)(data);
            const newStates = datumStates.filter((s)=>!statesToClear.has(s));
            if (complete) states[(0, $brtTw.idOf)(data)] = newStates;
            else if (newStates.length !== datumStates.length) states[(0, $brtTw.idOf)(data)] = newStates;
        });
        return states;
    }
    clearState() {
        return $c90e4961903404fc$var$__awaiter(this, void 0, void 0, function*() {
            const { graph: graph } = this.context;
            yield graph.setElementState(this.getClearStates(), this.options.animation);
        });
    }
    validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        (0, $hXCXB.ELEMENT_TYPES).forEach((type)=>{
            graph.off(`${type}:${(0, $9Iel2.CommonEvent).CLICK}`, this.onClickSelect);
        });
        graph.off((0, $1igYm.CanvasEvent).CLICK, this.onClickCanvas);
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
$c90e4961903404fc$export$d44abbe0f8b2c0ce.defaultOptions = {
    animation: true,
    enable: true,
    multiple: false,
    trigger: [
        'shift'
    ],
    state: 'selected',
    neighborState: 'selected',
    unselectedState: undefined,
    degree: 0
};

});
parcelRegister("hXCXB", function(module, exports) {

$parcel$export(module.exports, "ICON_SIZE_RATIO", () => $d1362b0c62240a7c$export$acddcd32796b15f);
$parcel$export(module.exports, "ELEMENT_TYPES", () => $d1362b0c62240a7c$export$e3cd54fb0588f7ea);
/**
 * <zh/> 根据不同的 node，自动计算 icon 的大小之后，乘以一下缩放系数，防止贴的太紧密
 *
 * <en/> According to the different nodes, the size of the icon is automatically calculated, and then multiplied by the following scaling factor to prevent it from being too close
 */ const $d1362b0c62240a7c$export$acddcd32796b15f = 0.8;
const $d1362b0c62240a7c$export$e3cd54fb0588f7ea = [
    'node',
    'edge',
    'combo'
];

});

parcelRegister("aAA2B", function(module, exports) {

$parcel$export(module.exports, "getElementNthDegreeIds", () => $7b59392b16ee66fa$export$8ab8f637bf29419b);

var $brtTw = parcelRequire("brtTw");

var $dTE8j = parcelRequire("dTE8j");
function $7b59392b16ee66fa$export$8ab8f637bf29419b(graph, elementType, elementId, degree, direction = 'both') {
    if (elementType === 'combo' || elementType === 'node') return $7b59392b16ee66fa$export$2d77f2cb22fe390c(graph, elementId, degree, direction);
    const edgeData = graph.getEdgeData(elementId);
    if (!edgeData) return [];
    const sourceRelations = $7b59392b16ee66fa$export$2d77f2cb22fe390c(graph, edgeData.source, degree - 1, direction);
    const targetRelations = $7b59392b16ee66fa$export$2d77f2cb22fe390c(graph, edgeData.target, degree - 1, direction);
    return Array.from(new Set([
        ...sourceRelations,
        ...targetRelations,
        elementId
    ]));
}
function $7b59392b16ee66fa$export$2d77f2cb22fe390c(graph, startNodeId, degree, direction = 'both') {
    const visitedNodes = new Set();
    const visitedEdges = new Set();
    const relations = new Set();
    (0, $dTE8j.bfs)(startNodeId, (nodeId, depth)=>{
        if (depth > degree) return;
        relations.add(nodeId);
        graph.getRelatedEdgesData(nodeId, direction).forEach((edge)=>{
            const edgeId = (0, $brtTw.idOf)(edge);
            if (!visitedEdges.has(edgeId) && depth < degree) {
                relations.add(edgeId);
                visitedEdges.add(edgeId);
            }
        });
    }, (nodeId)=>{
        return graph.getRelatedEdgesData(nodeId, direction).map((edge)=>edge.source === nodeId ? edge.target : edge.source).filter((neighborNodeId)=>{
            if (!visitedNodes.has(neighborNodeId)) {
                visitedNodes.add(neighborNodeId);
                return true;
            }
            return false;
        });
    });
    return Array.from(relations);
}

});
parcelRegister("dTE8j", function(module, exports) {

$parcel$export(module.exports, "dfs", () => $a1df8afdc65a0132$export$51b654aff22fc5a6);
$parcel$export(module.exports, "bfs", () => $a1df8afdc65a0132$export$c9e5a085bf83f8b);
/**
 * <zh/> 执行深度优先遍历
 *
 * <en/> perform depth first traversal
 * @param node - <zh/> 起始节点 | <en/> start node
 * @param visitor - <zh/> 访问节点函数 | <en/> visitor function
 * @param navigator - <zh/> 获取子节点函数 | <en/> get children function
 * @param mode - <zh/> 访问模式，BT: 自底向上访问，TB: 自顶向下访问 | <en/> traverse mode, BT: bottom to top, TB: top to bottom
 * @param depth - <zh/> 当前深度 | <en/> current depth
 */ function $a1df8afdc65a0132$export$51b654aff22fc5a6(node, visitor, navigator, mode, depth = 0) {
    if (mode === 'TB') visitor(node, depth);
    const children = navigator(node);
    if (children) for (const child of children)$a1df8afdc65a0132$export$51b654aff22fc5a6(child, visitor, navigator, mode, depth + 1);
    if (mode === 'BT') visitor(node, depth);
}
function $a1df8afdc65a0132$export$c9e5a085bf83f8b(node, visitor, navigator) {
    const queue = [
        [
            node,
            0
        ]
    ];
    while(queue.length){
        const [current, depth] = queue.shift();
        visitor(current, depth);
        const children = navigator(current);
        if (children) for (const child of children)queue.push([
            child,
            depth + 1
        ]);
    }
}

});


parcelRegister("gzW5B", function(module, exports) {

$parcel$export(module.exports, "statesOf", () => $c11cf991628d856d$export$d04278c2624301db);
/**
 * <zh/> 获取元素的状态
 *
 * <en/> Get the state of the element
 * @param datum - <zh/> 元素数据 <en/> Element data
 * @returns <zh/> 状态列表 <en/> State list
 */ function $c11cf991628d856d$export$d04278c2624301db(datum) {
    return datum.states || [];
}

});


parcelRegister("0y4XY", function(module, exports) {

$parcel$export(module.exports, "CollapseExpand", () => $001a6f99f8787091$export$46b720b010b80023);

var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");

var $VNNBO = parcelRequire("VNNBO");

var $hn4z6 = parcelRequire("hn4z6");

var $hQIOr = parcelRequire("hQIOr");
var $001a6f99f8787091$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $001a6f99f8787091$export$46b720b010b80023 extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $001a6f99f8787091$export$46b720b010b80023.defaultOptions, options));
        this.onCollapseExpand = (event)=>$001a6f99f8787091$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.validate(event)) return;
                const { target: target } = event;
                if (!(0, $hn4z6.isElement)(target)) return;
                const id = target.id;
                const { model: model, graph: graph } = this.context;
                const data = model.getElementDataById(id);
                if (!data) return false;
                const { onCollapse: onCollapse, onExpand: onExpand, animation: animation, align: align } = this.options;
                if ((0, $VNNBO.isCollapsed)(data)) {
                    yield graph.expandElement(id, {
                        animation: animation,
                        align: align
                    });
                    onExpand === null || onExpand === void 0 || onExpand(id);
                } else {
                    yield graph.collapseElement(id, {
                        animation: animation,
                        align: align
                    });
                    onCollapse === null || onCollapse === void 0 || onCollapse(id);
                }
            });
        this.bindEvents();
    }
    update(options) {
        this.unbindEvents();
        super.update(options);
        this.bindEvents();
    }
    bindEvents() {
        const { graph: graph } = this.context;
        const { trigger: trigger } = this.options;
        graph.on(`node:${trigger}`, this.onCollapseExpand);
        graph.on(`combo:${trigger}`, this.onCollapseExpand);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        const { trigger: trigger } = this.options;
        graph.off(`node:${trigger}`, this.onCollapseExpand);
        graph.off(`combo:${trigger}`, this.onCollapseExpand);
    }
    validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
$001a6f99f8787091$export$46b720b010b80023.defaultOptions = {
    enable: true,
    animation: true,
    trigger: (0, $9Iel2.CommonEvent).DBLCLICK,
    align: true
};

});
parcelRegister("VNNBO", function(module, exports) {

$parcel$export(module.exports, "isCollapsed", () => $0adbf40eda22a156$export$9c903d35b97d0190);
/**
 * <zh/> 判断节点/组合是否收起
 *
 * <en/> Determine whether the node/combo is collapsed
 * @param nodeLike - <zh/>节点/组合数据 | <en/>Node/Combo data
 * @returns <zh/>是否收起 | <en/>Whether it is collapsed
 */ function $0adbf40eda22a156$export$9c903d35b97d0190(nodeLike) {
    var _a;
    return !!((_a = nodeLike.style) === null || _a === void 0 ? void 0 : _a.collapsed);
}

});

parcelRegister("hn4z6", function(module, exports) {

$parcel$export(module.exports, "isNode", () => $ca58202f1581d432$export$8ee0fc9ee280b4ee);
$parcel$export(module.exports, "isEdge", () => $ca58202f1581d432$export$cac3980734d91fbe);
$parcel$export(module.exports, "isCombo", () => $ca58202f1581d432$export$ede79ab74d099391);
$parcel$export(module.exports, "isElement", () => $ca58202f1581d432$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isSameNode", () => $ca58202f1581d432$export$8cdf83cd3204bbcd);
$parcel$export(module.exports, "getPortXYByPlacement", () => $ca58202f1581d432$export$e6bb5609742b48ad);
$parcel$export(module.exports, "getAllPorts", () => $ca58202f1581d432$export$217d40770cec386d);
$parcel$export(module.exports, "isSimplePort", () => $ca58202f1581d432$export$6932d8693c2e55df);
$parcel$export(module.exports, "getPortPosition", () => $ca58202f1581d432$export$f006e34fa35e5c56);
$parcel$export(module.exports, "findPorts", () => $ca58202f1581d432$export$fa43bed9702e2b03);
$parcel$export(module.exports, "getConnectionPoint", () => $ca58202f1581d432$export$ed539f199a97c7c4);
$parcel$export(module.exports, "getNodeConnectionPoint", () => $ca58202f1581d432$export$9891ba4b1faa06d3);
$parcel$export(module.exports, "getPortConnectionPoint", () => $ca58202f1581d432$export$ee9894274f41fac6);
$parcel$export(module.exports, "getTextStyleByPlacement", () => $ca58202f1581d432$export$a46d89b5dc4a4a4b);
$parcel$export(module.exports, "getStarPoints", () => $ca58202f1581d432$export$180a2055f9d6539c);
$parcel$export(module.exports, "getStarPorts", () => $ca58202f1581d432$export$6856bb1abb7f4ff);
$parcel$export(module.exports, "getTrianglePoints", () => $ca58202f1581d432$export$d95c9ca32019fe2f);
$parcel$export(module.exports, "getTrianglePorts", () => $ca58202f1581d432$export$c128e8322366237);
$parcel$export(module.exports, "getDiamondPoints", () => $ca58202f1581d432$export$9ce830f3516102a2);
$parcel$export(module.exports, "isVisible", () => $ca58202f1581d432$export$795910f5f15a9633);
$parcel$export(module.exports, "setAttributes", () => $ca58202f1581d432$export$74da2cba014bdc09);
$parcel$export(module.exports, "updateStyle", () => $ca58202f1581d432$export$74d9c88a79235eef);
$parcel$export(module.exports, "getHexagonPoints", () => $ca58202f1581d432$export$dc05ac4d5f7de039);
$parcel$export(module.exports, "markToBeDestroyed", () => $ca58202f1581d432$export$2f58a02d2f5b6347);
$parcel$export(module.exports, "isToBeDestroyed", () => $ca58202f1581d432$export$a34712f2dd41f093);

var $6XARU = parcelRequire("6XARU");
var $jyI49 = parcelRequire("jyI49");
var $kVcyu = parcelRequire("kVcyu");
var $5vprq = parcelRequire("5vprq");
parcelRequire("2zk86");
var $jK4lK = parcelRequire("jK4lK");
var $clFkI = parcelRequire("clFkI");
var $63haX = parcelRequire("63haX");

var $6BVcW = parcelRequire("6BVcW");

var $lEe0S = parcelRequire("lEe0S");

var $dnXls = parcelRequire("dnXls");

var $46bcR = parcelRequire("46bcR");
var $ca58202f1581d432$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $ca58202f1581d432$export$8ee0fc9ee280b4ee(shape) {
    return shape instanceof (0, $63haX.BaseNode) && shape.type === 'node';
}
function $ca58202f1581d432$export$cac3980734d91fbe(shape) {
    return shape instanceof (0, $clFkI.BaseEdge);
}
function $ca58202f1581d432$export$ede79ab74d099391(shape) {
    return shape instanceof (0, $jK4lK.BaseCombo);
}
function $ca58202f1581d432$export$45a5e7f76e0caa8d(shape) {
    return $ca58202f1581d432$export$8ee0fc9ee280b4ee(shape) || $ca58202f1581d432$export$cac3980734d91fbe(shape) || $ca58202f1581d432$export$ede79ab74d099391(shape);
}
function $ca58202f1581d432$export$8cdf83cd3204bbcd(node1, node2) {
    if (!node1 || !node2) return false;
    return node1 === node2;
}
const $ca58202f1581d432$var$PORT_MAP = {
    top: [
        0.5,
        0
    ],
    right: [
        1,
        0.5
    ],
    bottom: [
        0.5,
        1
    ],
    left: [
        0,
        0.5
    ],
    'left-top': [
        0,
        0
    ],
    'top-left': [
        0,
        0
    ],
    'left-bottom': [
        0,
        1
    ],
    'bottom-left': [
        0,
        1
    ],
    'right-top': [
        1,
        0
    ],
    'top-right': [
        1,
        0
    ],
    'right-bottom': [
        1,
        1
    ],
    'bottom-right': [
        1,
        1
    ],
    default: [
        0.5,
        0.5
    ]
};
function $ca58202f1581d432$export$e6bb5609742b48ad(bbox, placement, portMap = $ca58202f1581d432$var$PORT_MAP, isRelative = true) {
    const DEFAULT = [
        0.5,
        0.5
    ];
    const p = (0, $kVcyu.default)(placement) ? (0, $6XARU.default)(portMap, placement.toLocaleLowerCase(), DEFAULT) : placement;
    if (!isRelative && (0, $kVcyu.default)(placement)) return p;
    const [x, y] = p || DEFAULT;
    return [
        bbox.min[0] + (0, $6BVcW.getBBoxWidth)(bbox) * x,
        bbox.min[1] + (0, $6BVcW.getBBoxHeight)(bbox) * y
    ];
}
function $ca58202f1581d432$export$217d40770cec386d(node) {
    if (!node) return {};
    // 1. 需要绘制的连接桩 | Get the ports that need to be drawn
    const ports = node.getPorts();
    // 2. 不需要额外绘制的连接桩 | Get the ports that do not need to be drawn
    const portsStyle = node.attributes.ports || [];
    portsStyle.forEach((portStyle, i)=>{
        var _a;
        const { key: key, placement: placement } = portStyle;
        if ($ca58202f1581d432$export$6932d8693c2e55df(portStyle)) ports[_a = key || i] || (ports[_a] = (0, $46bcR.getXYByPlacement)(node.getShape('key').getBounds(), placement));
    });
    return ports;
}
function $ca58202f1581d432$export$6932d8693c2e55df(portStyle) {
    const { r: r } = portStyle;
    return !r || Number(r) === 0;
}
function $ca58202f1581d432$export$f006e34fa35e5c56(port) {
    return (0, $lEe0S.isPoint)(port) ? port : port.getPosition();
}
function $ca58202f1581d432$export$fa43bed9702e2b03(sourceNode, targetNode, sourcePortKey, targetPortKey) {
    const sourcePort = $ca58202f1581d432$export$93f100df314912d6(sourceNode, targetNode, sourcePortKey, targetPortKey);
    const targetPort = $ca58202f1581d432$export$93f100df314912d6(targetNode, sourceNode, targetPortKey, sourcePortKey);
    return [
        sourcePort,
        targetPort
    ];
}
function $ca58202f1581d432$export$93f100df314912d6(node, oppositeNode, portKey, oppositePortKey) {
    const portsMap = $ca58202f1581d432$export$217d40770cec386d(node);
    if (portKey) return portsMap[portKey];
    const ports = Object.values(portsMap);
    if (ports.length === 0) return undefined;
    const positions = ports.map((port)=>$ca58202f1581d432$export$f006e34fa35e5c56(port));
    const oppositePositions = $ca58202f1581d432$var$findConnectionPoints(oppositeNode, oppositePortKey);
    const [nearestPosition] = (0, $dnXls.findNearestPoints)(positions, oppositePositions);
    return ports.find((port)=>$ca58202f1581d432$export$f006e34fa35e5c56(port) === nearestPosition);
}
/**
 * <zh/> 寻找节点上所有可能的连接点
 *
 * <en/> Find all possible connection points on the node
 * @remarks
 * 1. If `portKey` is specified, return the position of the port.
 * 2. If `portKey` is not specified, return positions of all ports.
 * 3. If the node has no ports, return the center of the node.
 * @param node - <zh/> 节点 | <en/> Node
 * @param portKey - <zh/> 连接桩的键值（key），如不指定则返回所有 | <en/> Port Key, return all if not specified
 * @returns <zh/> 连接点 | <en/> Connection Point
 */ function $ca58202f1581d432$var$findConnectionPoints(node, portKey) {
    const allPortsMap = $ca58202f1581d432$export$217d40770cec386d(node);
    if (portKey) return [
        $ca58202f1581d432$export$f006e34fa35e5c56(allPortsMap[portKey])
    ];
    const oppositePorts = Object.values(allPortsMap);
    return oppositePorts.length > 0 ? oppositePorts.map((port)=>$ca58202f1581d432$export$f006e34fa35e5c56(port)) : [
        node.getCenter()
    ];
}
function $ca58202f1581d432$export$ed539f199a97c7c4(node, opposite) {
    return $ca58202f1581d432$export$ede79ab74d099391(node) || $ca58202f1581d432$export$8ee0fc9ee280b4ee(node) ? $ca58202f1581d432$export$9891ba4b1faa06d3(node, opposite) : $ca58202f1581d432$export$ee9894274f41fac6(node, opposite);
}
function $ca58202f1581d432$export$ee9894274f41fac6(port, opposite) {
    if (!port || !opposite) return [
        0,
        0,
        0
    ];
    if ((0, $lEe0S.isPoint)(port)) return port;
    // 1. linkToCenter 为 true，则返回连接桩的中心 | If linkToCenter is true, return the center of the port
    if (port.attributes.linkToCenter) return port.getPosition();
    // 2. 推导对端的具体点：如果是连接桩或节点，则返回它的中心；如果是具体点，则直接返回
    // 2. Get a specific opposite point: if it is a port or a node, return its center; if it is a specific point, return directly
    const oppositePosition = (0, $lEe0S.isPoint)(opposite) ? opposite : $ca58202f1581d432$export$8ee0fc9ee280b4ee(opposite) ? opposite.getCenter() : opposite.getPosition();
    // 3. 返回连接桩边界上的交点 | Return the intersection point on the port boundary
    return (0, $dnXls.getEllipseIntersectPoint)(oppositePosition, port.getBounds());
}
function $ca58202f1581d432$export$9891ba4b1faa06d3(nodeLike, opposite) {
    if (!nodeLike || !opposite) return [
        0,
        0,
        0
    ];
    const oppositePosition = (0, $lEe0S.isPoint)(opposite) ? opposite : $ca58202f1581d432$export$8ee0fc9ee280b4ee(opposite) ? opposite.getCenter() : opposite.getPosition();
    return nodeLike.getIntersectPoint(oppositePosition) || nodeLike.getCenter();
}
function $ca58202f1581d432$export$a46d89b5dc4a4a4b(bbox, placement = 'bottom', offsetX = 0, offsetY = 0, isReverseBaseline = false) {
    const direction = placement.split('-');
    const [x, y] = (0, $46bcR.getXYByPlacement)(bbox, placement);
    const [top, bottom] = isReverseBaseline ? [
        'bottom',
        'top'
    ] : [
        'top',
        'bottom'
    ];
    const textBaseline = direction.includes('top') ? bottom : direction.includes('bottom') ? top : 'middle';
    const textAlign = direction.includes('left') ? 'right' : direction.includes('right') ? 'left' : 'center';
    return {
        transform: [
            [
                'translate',
                x + offsetX,
                y + offsetY
            ]
        ],
        textBaseline: textBaseline,
        textAlign: textAlign
    };
}
function $ca58202f1581d432$export$180a2055f9d6539c(outerR, innerR) {
    return [
        [
            0,
            -outerR
        ],
        [
            innerR * Math.cos(3 * Math.PI / 10),
            -innerR * Math.sin(3 * Math.PI / 10)
        ],
        [
            outerR * Math.cos(Math.PI / 10),
            -outerR * Math.sin(Math.PI / 10)
        ],
        [
            innerR * Math.cos(Math.PI / 10),
            innerR * Math.sin(Math.PI / 10)
        ],
        [
            outerR * Math.cos(3 * Math.PI / 10),
            outerR * Math.sin(3 * Math.PI / 10)
        ],
        [
            0,
            innerR
        ],
        [
            -outerR * Math.cos(3 * Math.PI / 10),
            outerR * Math.sin(3 * Math.PI / 10)
        ],
        [
            -innerR * Math.cos(Math.PI / 10),
            innerR * Math.sin(Math.PI / 10)
        ],
        [
            -outerR * Math.cos(Math.PI / 10),
            -outerR * Math.sin(Math.PI / 10)
        ],
        [
            -innerR * Math.cos(3 * Math.PI / 10),
            -innerR * Math.sin(3 * Math.PI / 10)
        ]
    ];
}
function $ca58202f1581d432$export$6856bb1abb7f4ff(outerR, innerR) {
    const r = {};
    r['top'] = [
        0,
        -outerR
    ];
    r['left'] = [
        -outerR * Math.cos(Math.PI / 10),
        -outerR * Math.sin(Math.PI / 10)
    ];
    r['left-bottom'] = [
        -outerR * Math.cos(3 * Math.PI / 10),
        outerR * Math.sin(3 * Math.PI / 10)
    ];
    r['bottom'] = [
        0,
        innerR
    ];
    r['right-bottom'] = [
        outerR * Math.cos(3 * Math.PI / 10),
        outerR * Math.sin(3 * Math.PI / 10)
    ];
    r['right'] = r['default'] = [
        outerR * Math.cos(Math.PI / 10),
        -outerR * Math.sin(Math.PI / 10)
    ];
    return r;
}
function $ca58202f1581d432$export$d95c9ca32019fe2f(width, height, direction) {
    const halfHeight = height / 2;
    const halfWidth = width / 2;
    const MAP = {
        up: [
            [
                -halfWidth,
                halfHeight
            ],
            [
                halfWidth,
                halfHeight
            ],
            [
                0,
                -halfHeight
            ]
        ],
        left: [
            [
                -halfWidth,
                0
            ],
            [
                halfWidth,
                halfHeight
            ],
            [
                halfWidth,
                -halfHeight
            ]
        ],
        right: [
            [
                -halfWidth,
                halfHeight
            ],
            [
                -halfWidth,
                -halfHeight
            ],
            [
                halfWidth,
                0
            ]
        ],
        down: [
            [
                -halfWidth,
                -halfHeight
            ],
            [
                halfWidth,
                -halfHeight
            ],
            [
                0,
                halfHeight
            ]
        ]
    };
    return MAP[direction] || MAP['up'];
}
function $ca58202f1581d432$export$c128e8322366237(width, height, direction) {
    const halfHeight = height / 2;
    const halfWidth = width / 2;
    const ports = {};
    if (direction === 'down') {
        ports['bottom'] = ports['default'] = [
            0,
            halfHeight
        ];
        ports['right'] = [
            halfWidth,
            -halfHeight
        ];
        ports['left'] = [
            -halfWidth,
            -halfHeight
        ];
    } else if (direction === 'left') {
        ports['top'] = [
            halfWidth,
            -halfHeight
        ];
        ports['bottom'] = [
            halfWidth,
            halfHeight
        ];
        ports['left'] = ports['default'] = [
            -halfWidth,
            0
        ];
    } else if (direction === 'right') {
        ports['top'] = [
            -halfWidth,
            -halfHeight
        ];
        ports['bottom'] = [
            -halfWidth,
            halfHeight
        ];
        ports['right'] = ports['default'] = [
            halfWidth,
            0
        ];
    } else {
        //up
        ports['left'] = [
            -halfWidth,
            halfHeight
        ];
        ports['top'] = ports['default'] = [
            0,
            -halfHeight
        ];
        ports['right'] = [
            halfWidth,
            halfHeight
        ];
    }
    return ports;
}
function $ca58202f1581d432$export$3c24cb285e78c656(width, height) {
    return [
        [
            width / 2,
            -height / 2
        ],
        [
            width / 2,
            height / 2
        ],
        [
            -width / 2,
            height / 2
        ],
        [
            -width / 2,
            -height / 2
        ]
    ];
}
function $ca58202f1581d432$export$9ce830f3516102a2(width, height) {
    return [
        [
            0,
            -height / 2
        ],
        [
            width / 2,
            0
        ],
        [
            0,
            height / 2
        ],
        [
            -width / 2,
            0
        ]
    ];
}
function $ca58202f1581d432$export$795910f5f15a9633(element) {
    return (0, $6XARU.default)(element, [
        'style',
        'visibility'
    ]) !== 'hidden';
}
function $ca58202f1581d432$export$74da2cba014bdc09(element, style) {
    const { zIndex: zIndex, transform: transform, transformOrigin: transformOrigin, visibility: visibility, cursor: cursor, clipPath: clipPath, component: component } = style, rest = $ca58202f1581d432$var$__rest(style, [
        "zIndex",
        "transform",
        "transformOrigin",
        "visibility",
        "cursor",
        "clipPath",
        "component"
    ]);
    Object.assign(element.attributes, rest);
    if (transform) element.setAttribute('transform', transform);
    if ((0, $jyI49.default)(zIndex)) element.setAttribute('zIndex', zIndex);
    if (transformOrigin) element.setAttribute('transformOrigin', transformOrigin);
    if (visibility) element.setAttribute('visibility', visibility);
    if (cursor) element.setAttribute('cursor', cursor);
    if (clipPath) element.setAttribute('clipPath', clipPath);
    if (component) element.setAttribute('component', component);
}
function $ca58202f1581d432$export$74d9c88a79235eef(shape, style) {
    if ('update' in shape) shape.update(style);
    else shape.attr(style);
}
function $ca58202f1581d432$export$dc05ac4d5f7de039(outerR) {
    return [
        [
            0,
            outerR
        ],
        [
            outerR * Math.sqrt(3) / 2,
            outerR / 2
        ],
        [
            outerR * Math.sqrt(3) / 2,
            -outerR / 2
        ],
        [
            0,
            -outerR
        ],
        [
            -outerR * Math.sqrt(3) / 2,
            -outerR / 2
        ],
        [
            -outerR * Math.sqrt(3) / 2,
            outerR / 2
        ]
    ];
}
function $ca58202f1581d432$export$2f58a02d2f5b6347(element) {
    (0, $5vprq.default)(element, '__to_be_destroyed__', true);
}
function $ca58202f1581d432$export$a34712f2dd41f093(element) {
    return (0, $6XARU.default)(element, '__to_be_destroyed__', false);
}

});
parcelRegister("6XARU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5114da107a83acbc$export$2e2bcd8739ae039);

var $kVcyu = parcelRequire("kVcyu");
var /**
 * https://github.com/developit/dlv/blob/master/index.js
 * @param obj
 * @param key
 * @param defaultValue
 */ $5114da107a83acbc$export$2e2bcd8739ae039 = function(obj, key, defaultValue) {
    var p = 0;
    var keyArr = (0, $kVcyu.default)(key) ? key.split('.') : key;
    while(obj && p < keyArr.length)obj = obj[keyArr[p++]];
    return obj === undefined || p < keyArr.length ? defaultValue : obj;
};

});

parcelRegister("5vprq", function(module, exports) {

$parcel$export(module.exports, "default", () => $402395220af8c8fb$export$2e2bcd8739ae039);

var $6JKSc = parcelRequire("6JKSc");

var $kVcyu = parcelRequire("kVcyu");

var $jyI49 = parcelRequire("jyI49");
var /**
 * https://github.com/developit/dlv/blob/master/index.js
 * @param obj
 * @param path
 * @param value
 */ $402395220af8c8fb$export$2e2bcd8739ae039 = function(obj, path, value) {
    var o = obj;
    var keyArr = (0, $kVcyu.default)(path) ? path.split('.') : path;
    keyArr.forEach(function(key, idx) {
        // 不是最后一个
        if (idx < keyArr.length - 1) {
            if (!(0, $6JKSc.default)(o[key])) o[key] = (0, $jyI49.default)(keyArr[idx + 1]) ? [] : {};
            o = o[key];
        } else o[key] = value;
    });
    return obj;
};

});

parcelRegister("2zk86", function(module, exports) {
$parcel$export(module.exports, "BaseCombo", () => (parcelRequire("jK4lK")).BaseCombo);
$parcel$export(module.exports, "CircleCombo", () => (parcelRequire("f2zuq")).CircleCombo);
$parcel$export(module.exports, "RectCombo", () => (parcelRequire("4zzq7")).RectCombo);
$parcel$export(module.exports, "BaseEdge", () => (parcelRequire("clFkI")).BaseEdge);
$parcel$export(module.exports, "Cubic", () => (parcelRequire("4tI2g")).Cubic);
$parcel$export(module.exports, "CubicHorizontal", () => (parcelRequire("hjONv")).CubicHorizontal);
$parcel$export(module.exports, "CubicRadial", () => (parcelRequire("bs4me")).CubicRadial);
$parcel$export(module.exports, "CubicVertical", () => (parcelRequire("ln2PG")).CubicVertical);
$parcel$export(module.exports, "Line", () => (parcelRequire("95A9Q")).Line);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("5felS")).Polyline);
$parcel$export(module.exports, "Quadratic", () => (parcelRequire("Fb2Dh")).Quadratic);
$parcel$export(module.exports, "BaseNode", () => (parcelRequire("63haX")).BaseNode);
$parcel$export(module.exports, "Circle", () => (parcelRequire("dbxRO")).Circle);
$parcel$export(module.exports, "Diamond", () => (parcelRequire("8nW3T")).Diamond);
$parcel$export(module.exports, "Donut", () => (parcelRequire("483tH")).Donut);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("hoxMw")).Ellipse);
$parcel$export(module.exports, "Hexagon", () => (parcelRequire("R3ntv")).Hexagon);
$parcel$export(module.exports, "HTML", () => (parcelRequire("bHEt9")).HTML);
$parcel$export(module.exports, "Image", () => (parcelRequire("gF4ts")).Image);
$parcel$export(module.exports, "Rect", () => (parcelRequire("3VmXJ")).Rect);
$parcel$export(module.exports, "Star", () => (parcelRequire("d1sdh")).Star);
$parcel$export(module.exports, "Triangle", () => (parcelRequire("dIvRz")).Triangle);
parcelRequire("jC8VT");
parcelRequire("l6dDw");
parcelRequire("kcFIc");

});
parcelRegister("jC8VT", function(module, exports) {

$parcel$export(module.exports, "BaseCombo", () => (parcelRequire("jK4lK")).BaseCombo);
$parcel$export(module.exports, "CircleCombo", () => (parcelRequire("f2zuq")).CircleCombo);
$parcel$export(module.exports, "RectCombo", () => (parcelRequire("4zzq7")).RectCombo);

var $jK4lK = parcelRequire("jK4lK");

var $f2zuq = parcelRequire("f2zuq");

var $4zzq7 = parcelRequire("4zzq7");

});
parcelRegister("jK4lK", function(module, exports) {

$parcel$export(module.exports, "BaseCombo", () => $e5f5affdfaa0f778$export$cd04a644e6f2c9df);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $ky7aH = parcelRequire("ky7aH");

var $6BVcW = parcelRequire("6BVcW");

var $brtTw = parcelRequire("brtTw");

var $1uR12 = parcelRequire("1uR12");

var $46bcR = parcelRequire("46bcR");

var $icwVF = parcelRequire("icwVF");

var $e6Msm = parcelRequire("e6Msm");

var $j4n8g = parcelRequire("j4n8g");

var $dOidW = parcelRequire("dOidW");
parcelRequire("kcFIc");
var $63haX = parcelRequire("63haX");
parcelRequire("hIZ0D");
var $1TY6s = parcelRequire("1TY6s");

var $hy6NM = parcelRequire("hy6NM");
var $e5f5affdfaa0f778$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $e5f5affdfaa0f778$export$cd04a644e6f2c9df extends (0, $63haX.BaseNode) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $e5f5affdfaa0f778$export$cd04a644e6f2c9df.defaultStyleProps
        }, options));
        this.type = 'combo';
        this.updateComboPosition(this.parsedAttributes);
    }
    getKeySize(attributes) {
        const { collapsed: collapsed, childrenNode: childrenNode = [] } = attributes;
        if (childrenNode.length === 0) return this.getEmptyKeySize(attributes);
        return collapsed ? this.getCollapsedKeySize(attributes) : this.getExpandedKeySize(attributes);
    }
    getEmptyKeySize(attributes) {
        const { padding: padding, collapsedSize: collapsedSize } = attributes;
        const [top, right, bottom, left] = (0, $1uR12.parsePadding)(padding);
        return (0, $dOidW.add)((0, $e6Msm.parseSize)(collapsedSize), [
            left + right,
            top + bottom,
            0
        ]);
    }
    getCollapsedKeySize(attributes) {
        return (0, $e6Msm.parseSize)(attributes.collapsedSize);
    }
    getExpandedKeySize(attributes) {
        const contentBBox = this.getContentBBox(attributes);
        return [
            (0, $6BVcW.getBBoxWidth)(contentBBox),
            (0, $6BVcW.getBBoxHeight)(contentBBox),
            0
        ];
    }
    getContentBBox(attributes) {
        const { childrenNode: childrenNode = [], padding: padding } = attributes;
        const children = childrenNode.map((id)=>this.context.element.getElement(id)).filter(Boolean);
        if (children.length === 0) {
            const bbox = new (0, $2eDEB.AABB)();
            const { x: x = 0, y: y = 0, size: size } = attributes;
            const [width, height] = (0, $e6Msm.parseSize)(size);
            bbox.setMinMax([
                x - width / 2,
                y - height / 2,
                0
            ], [
                x + width / 2,
                y + height / 2,
                0
            ]);
            return bbox;
        }
        const childrenBBox = (0, $6BVcW.getCombinedBBox)(children.map((child)=>child.getBounds()));
        if (!padding) return childrenBBox;
        return (0, $6BVcW.getExpandedBBox)(childrenBBox, padding);
    }
    drawCollapsedMarkerShape(attributes, container) {
        const style = this.getCollapsedMarkerStyle(attributes);
        this.upsert('collapsed-marker', (0, $1TY6s.Icon), style, container);
        (0, $hy6NM.connectImage)(this);
    }
    getCollapsedMarkerStyle(attributes) {
        if (!attributes.collapsed || !attributes.collapsedMarker) return false;
        const _a = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'collapsedMarker'), { type: type } = _a, collapsedMarkerStyle = $e5f5affdfaa0f778$var$__rest(_a, [
            "type"
        ]);
        const keyShape = this.getShape('key');
        const [x, y] = (0, $46bcR.getXYByPlacement)(keyShape.getLocalBounds(), 'center');
        const style = Object.assign(Object.assign({}, collapsedMarkerStyle), {
            x: x,
            y: y
        });
        if (type) {
            const text = this.getCollapsedMarkerText(type, attributes);
            Object.assign(style, {
                text: text
            });
        }
        return style;
    }
    getCollapsedMarkerText(type, attributes) {
        const { childrenData: childrenData = [] } = attributes;
        const { model: model } = this.context;
        if (type === 'descendant-count') return model.getDescendantsData(this.id).length.toString();
        if (type === 'child-count') return childrenData.length.toString();
        if (type === 'node-count') return model.getDescendantsData(this.id).filter((datum)=>model.getElementType((0, $brtTw.idOf)(datum)) === 'node').length.toString();
        if ((0, $ky7aH.default)(type)) return type(childrenData);
        return '';
    }
    getComboPosition(attributes) {
        const { x: x = 0, y: y = 0, collapsed: collapsed, childrenData: childrenData = [] } = attributes;
        if (childrenData.length === 0) return [
            +x,
            +y,
            0
        ];
        if (collapsed) {
            const { model: model } = this.context;
            const descendants = model.getDescendantsData(this.id).filter((datum)=>!model.isCombo((0, $brtTw.idOf)(datum)));
            if (descendants.length > 0 && descendants.some((0, $46bcR.hasPosition))) {
                // combo 被收起，返回平均中心位置 / combo is collapsed, return the average center position
                const totalPosition = descendants.reduce((acc, datum)=>(0, $dOidW.add)(acc, (0, $46bcR.positionOf)(datum)), [
                    0,
                    0,
                    0
                ]);
                return (0, $dOidW.divide)(totalPosition, descendants.length);
            }
            // empty combo
            return [
                +x,
                +y,
                0
            ];
        }
        return this.getContentBBox(attributes).center;
    }
    getComboStyle(attributes) {
        const [x, y] = this.getComboPosition(attributes);
        // x/y will be used to calculate position later.
        return {
            x: x,
            y: y,
            transform: [
                [
                    'translate',
                    x,
                    y
                ]
            ]
        };
    }
    updateComboPosition(attributes) {
        const comboStyle = this.getComboStyle(attributes);
        Object.assign(this.style, comboStyle);
        // Sync combo position to model
        const { x: x, y: y } = comboStyle;
        this.context.model.syncNodeLikeDatum({
            id: this.id,
            style: {
                x: x,
                y: y
            }
        });
        (0, $hy6NM.dispatchPositionChange)(this);
    }
    render(attributes, container = this) {
        super.render(attributes, container);
        // collapsed marker
        this.drawCollapsedMarkerShape(attributes, container);
    }
    update(attr = {}) {
        super.update(attr);
        this.updateComboPosition(this.parsedAttributes);
    }
    onframe() {
        super.onframe();
        // 收起状态下，通过动画来更新位置
        // Update position through animation in collapsed state
        if (!this.attributes.collapsed) this.updateComboPosition(this.parsedAttributes);
        this.drawKeyShape(this.parsedAttributes, this);
    }
    animate(keyframes, options) {
        const animation = super.animate(this.attributes.collapsed ? keyframes : // If the current combo is in the expanded state, the animation is not affected by x, y, z, transform, and the position is determined only by the child elements
        keyframes.map((_a)=>{
            var { x: x, y: y, z: z, transform: transform } = _a, keyframe = $e5f5affdfaa0f778$var$__rest(_a, [
                "x",
                "y",
                "z",
                "transform"
            ]);
            return keyframe;
        }), options);
        if (!animation) return animation;
        return new Proxy(animation, {
            set: (target, propKey, value)=>{
                if (propKey === 'currentTime') Promise.resolve().then(()=>this.onframe());
                return Reflect.set(target, propKey, value);
            }
        });
    }
}
$e5f5affdfaa0f778$export$cd04a644e6f2c9df.defaultStyleProps = {
    childrenNode: [],
    droppable: true,
    draggable: true,
    collapsed: false,
    collapsedSize: 32,
    collapsedMarker: true,
    collapsedMarkerZIndex: 1,
    collapsedMarkerFontSize: 12,
    collapsedMarkerTextAlign: 'center',
    collapsedMarkerTextBaseline: 'middle',
    collapsedMarkerType: 'child-count'
};

});
parcelRegister("icwVF", function(module, exports) {

$parcel$export(module.exports, "startsWith", () => $d402e40ad902ee05$export$68326237475e9a7d);
$parcel$export(module.exports, "subStyleProps", () => $d402e40ad902ee05$export$f38e4d4b23aef199);
$parcel$export(module.exports, "subObject", () => $d402e40ad902ee05$export$91d48959f215c266);
$parcel$export(module.exports, "omitStyleProps", () => $d402e40ad902ee05$export$2337bcb2df76985b);

var $9Ls6J = parcelRequire("9Ls6J");
var $10sB9 = parcelRequire("10sB9");
function $d402e40ad902ee05$export$68326237475e9a7d(str, prefix) {
    if (!str.startsWith(prefix)) return false;
    const nextChart = str[prefix.length];
    return nextChart >= 'A' && nextChart <= 'Z';
}
function $d402e40ad902ee05$export$9748efee331ec573(str, prefix) {
    return `${prefix}${(0, $10sB9.default)(str)}`;
}
function $d402e40ad902ee05$export$f2888183a34644d4(string, prefix, lowercaseFirstLetter = true) {
    if (!prefix) return string;
    if (!$d402e40ad902ee05$export$68326237475e9a7d(string, prefix)) return string;
    const str = string.slice(prefix.length);
    return lowercaseFirstLetter ? (0, $9Ls6J.default)(str) : str;
}
function $d402e40ad902ee05$export$f38e4d4b23aef199(style, prefix) {
    const subStyle = Object.entries(style).reduce((acc, [key, value])=>{
        if (key === 'className' || key === 'class') return acc;
        if ($d402e40ad902ee05$export$68326237475e9a7d(key, prefix)) Object.assign(acc, {
            [$d402e40ad902ee05$export$f2888183a34644d4(key, prefix)]: value
        });
        return acc;
    }, {});
    // 向下传递透明度，但避免覆盖子样式中的透明度属性
    // Pass down opacity, but avoid overwriting the opacity property in the sub-style
    if ('opacity' in style) {
        const subOpacityKey = $d402e40ad902ee05$export$9748efee331ec573('opacity', prefix);
        const opacity = style.opacity;
        if (subOpacityKey in style) {
            const subOpacity = style[subOpacityKey];
            Object.assign(subStyle, {
                opacity: opacity * subOpacity
            });
        } else Object.assign(subStyle, {
            opacity: opacity
        });
    }
    return subStyle;
}
function $d402e40ad902ee05$export$91d48959f215c266(obj, prefix) {
    const prefixLength = prefix.length;
    return Object.keys(obj).reduce((acc, key)=>{
        if (key.startsWith(prefix)) {
            const newKey = key.slice(prefixLength);
            acc[newKey] = obj[key];
        }
        return acc;
    }, {});
}
function $d402e40ad902ee05$export$2337bcb2df76985b(style, prefix) {
    const prefixArray = typeof prefix === 'string' ? [
        prefix
    ] : prefix;
    const omitStyle = {};
    Object.keys(style).forEach((key)=>{
        if (!prefixArray.find((p)=>key.startsWith(p))) omitStyle[key] = style[key];
    });
    return omitStyle;
}
function $d402e40ad902ee05$export$22ef8700548ec20(style, oldPrefix, newPrefix) {
    return Object.entries(style).reduce((acc, [key, value])=>{
        if ($d402e40ad902ee05$export$68326237475e9a7d(key, oldPrefix)) acc[$d402e40ad902ee05$export$9748efee331ec573($d402e40ad902ee05$export$f2888183a34644d4(key, oldPrefix, false), newPrefix)] = value;
        else acc[key] = value;
        return acc;
    }, {});
}

});
parcelRegister("9Ls6J", function(module, exports) {

$parcel$export(module.exports, "default", () => $71be4e67bdc4c85e$export$2e2bcd8739ae039);

var $dcr8Y = parcelRequire("dcr8Y");
var $71be4e67bdc4c85e$var$lowerFirst = function(value) {
    var str = (0, $dcr8Y.default)(value);
    return str.charAt(0).toLowerCase() + str.substring(1);
};
var $71be4e67bdc4c85e$export$2e2bcd8739ae039 = $71be4e67bdc4c85e$var$lowerFirst;

});


parcelRegister("e6Msm", function(module, exports) {

$parcel$export(module.exports, "parseSize", () => $a45736a3fb1f7018$export$880c59a0ae1158a1);
/**
 * <zh/> 解析尺寸配置
 *
 * <en/> Parse size configuration
 * @param size - <zh/> 尺寸配置 | <en/> size configuration
 * @returns <zh/> 标准尺寸格式 | <en/> standard size format
 */ function $a45736a3fb1f7018$export$880c59a0ae1158a1(size = 0) {
    if (typeof size === 'number') return [
        size,
        size,
        size
    ];
    const [x, y = x, z = x] = size;
    return [
        x,
        y,
        z
    ];
}

});

parcelRegister("j4n8g", function(module, exports) {

$parcel$export(module.exports, "computeElementCallbackStyle", () => $de2055a85c8f8544$export$2743a8610c5dc9e9);
$parcel$export(module.exports, "mergeOptions", () => $de2055a85c8f8544$export$235b7fc70b9fc359);
$parcel$export(module.exports, "getSubShapeStyle", () => $de2055a85c8f8544$export$7130bebd23bd4b51);
var $de2055a85c8f8544$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $de2055a85c8f8544$export$2743a8610c5dc9e9(callableStyle, context) {
    const { datum: datum, graph: graph } = context;
    if (typeof callableStyle === 'function') return callableStyle.call(graph, datum);
    return Object.fromEntries(Object.entries(callableStyle).map(([key, style])=>{
        if (typeof style === 'function') return [
            key,
            style.call(graph, datum)
        ];
        return [
            key,
            style
        ];
    }));
}
function $de2055a85c8f8544$export$235b7fc70b9fc359(defaultOptions, modifiedOptions) {
    const s1 = (defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.style) || {};
    const s2 = (modifiedOptions === null || modifiedOptions === void 0 ? void 0 : modifiedOptions.style) || {};
    for(const key in s1)if (!(key in s2)) s2[key] = s1[key];
    return Object.assign({}, defaultOptions, modifiedOptions, {
        style: s2
    });
}
function $de2055a85c8f8544$export$7130bebd23bd4b51(style) {
    const { x: x, y: y, z: z, class: cls, className: className, transform: transform, transformOrigin: transformOrigin, zIndex: zIndex, visibility: visibility } = style, rest = $de2055a85c8f8544$var$__rest(style, [
        "x",
        "y",
        "z",
        "class",
        "className",
        "transform",
        "transformOrigin",
        "zIndex",
        "visibility"
    ]);
    return rest;
}

});

parcelRegister("kcFIc", function(module, exports) {

$parcel$export(module.exports, "BaseNode", () => (parcelRequire("63haX")).BaseNode);
$parcel$export(module.exports, "Circle", () => (parcelRequire("dbxRO")).Circle);
$parcel$export(module.exports, "Diamond", () => (parcelRequire("8nW3T")).Diamond);
$parcel$export(module.exports, "Donut", () => (parcelRequire("483tH")).Donut);
$parcel$export(module.exports, "Ellipse", () => (parcelRequire("hoxMw")).Ellipse);
$parcel$export(module.exports, "Hexagon", () => (parcelRequire("R3ntv")).Hexagon);
$parcel$export(module.exports, "HTML", () => (parcelRequire("bHEt9")).HTML);
$parcel$export(module.exports, "Image", () => (parcelRequire("gF4ts")).Image);
$parcel$export(module.exports, "Rect", () => (parcelRequire("3VmXJ")).Rect);
$parcel$export(module.exports, "Star", () => (parcelRequire("d1sdh")).Star);
$parcel$export(module.exports, "Triangle", () => (parcelRequire("dIvRz")).Triangle);

var $63haX = parcelRequire("63haX");

var $dbxRO = parcelRequire("dbxRO");

var $8nW3T = parcelRequire("8nW3T");

var $483tH = parcelRequire("483tH");

var $hoxMw = parcelRequire("hoxMw");

var $R3ntv = parcelRequire("R3ntv");

var $bHEt9 = parcelRequire("bHEt9");

var $gF4ts = parcelRequire("gF4ts");

var $3VmXJ = parcelRequire("3VmXJ");

var $d1sdh = parcelRequire("d1sdh");

var $dIvRz = parcelRequire("dIvRz");

});
parcelRegister("63haX", function(module, exports) {

$parcel$export(module.exports, "BaseNode", () => $468058a1025c3949$export$410b0c854570d131);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $hn4z6 = parcelRequire("hn4z6");

var $kmGF8 = parcelRequire("kmGF8");

var $cHWaM = parcelRequire("cHWaM");

var $dnXls = parcelRequire("dnXls");

var $icwVF = parcelRequire("icwVF");

var $e6Msm = parcelRequire("e6Msm");

var $j4n8g = parcelRequire("j4n8g");

var $jwYMH = parcelRequire("jwYMH");

var $kzdag = parcelRequire("kzdag");

var $14Eyx = parcelRequire("14Eyx");
parcelRequire("hIZ0D");
var $2jk2f = parcelRequire("2jk2f");
var $1TY6s = parcelRequire("1TY6s");
var $1DkzN = parcelRequire("1DkzN");

var $hy6NM = parcelRequire("hy6NM");
var $468058a1025c3949$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $468058a1025c3949$export$410b0c854570d131 extends (0, $14Eyx.BaseElement) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $468058a1025c3949$export$410b0c854570d131.defaultStyleProps
        }, options));
        this.type = 'node';
    }
    getSize(attributes = this.attributes) {
        const { size: size } = attributes;
        return (0, $e6Msm.parseSize)(size);
    }
    getKeyStyle(attributes) {
        const style = this.getGraphicStyle(attributes);
        return Object.assign((0, $icwVF.omitStyleProps)(style, [
            'label',
            'halo',
            'icon',
            'badge',
            'port'
        ]));
    }
    getLabelStyle(attributes) {
        if (attributes.label === false || !attributes.labelText) return false;
        const _a = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'label'), { placement: placement, maxWidth: maxWidth, offsetX: offsetX, offsetY: offsetY } = _a, labelStyle = $468058a1025c3949$var$__rest(_a, [
            "placement",
            "maxWidth",
            "offsetX",
            "offsetY"
        ]);
        const keyBounds = this.getShape('key').getLocalBounds();
        return Object.assign((0, $hn4z6.getTextStyleByPlacement)(keyBounds, placement, offsetX, offsetY), {
            wordWrapWidth: (0, $jwYMH.getWordWrapWidthByBox)(keyBounds, maxWidth)
        }, labelStyle);
    }
    getHaloStyle(attributes) {
        if (attributes.halo === false) return false;
        const _a = this.getKeyStyle(attributes), { fill: fill } = _a, keyStyle = $468058a1025c3949$var$__rest(_a, [
            "fill"
        ]);
        const haloStyle = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'halo');
        return Object.assign(Object.assign(Object.assign({}, keyStyle), {
            stroke: fill
        }), haloStyle);
    }
    getIconStyle(attributes) {
        if (attributes.icon === false || !attributes.iconText && !attributes.iconSrc) return false;
        const iconStyle = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'icon');
        return Object.assign((0, $kmGF8.inferIconStyle)(attributes.size, iconStyle), iconStyle);
    }
    getBadgesStyle(attributes) {
        var _a;
        const badges = (0, $icwVF.subObject)(this.shapeMap, 'badge-');
        const badgesShapeStyle = {};
        Object.keys(badges).forEach((key)=>{
            badgesShapeStyle[key] = false;
        });
        if (attributes.badge === false || !((_a = attributes.badges) === null || _a === void 0 ? void 0 : _a.length)) return badgesShapeStyle;
        const { badges: badgeOptions = [], badgePalette: badgePalette, opacity: opacity = 1 } = attributes, restAttributes = $468058a1025c3949$var$__rest(attributes, [
            "badges",
            "badgePalette",
            "opacity"
        ]);
        const colors = (0, $cHWaM.getPaletteColors)(badgePalette);
        const badgeStyle = (0, $icwVF.subStyleProps)(this.getGraphicStyle(restAttributes), 'badge');
        badgeOptions.forEach((option, i)=>{
            badgesShapeStyle[i] = Object.assign(Object.assign({
                backgroundFill: colors ? colors[i % (colors === null || colors === void 0 ? void 0 : colors.length)] : undefined,
                opacity: opacity
            }, badgeStyle), this.getBadgeStyle(option));
        });
        return badgesShapeStyle;
    }
    getBadgeStyle(style) {
        const keyShape = this.getShape('key');
        const { placement: placement = 'top', offsetX: offsetX, offsetY: offsetY } = style, restStyle = $468058a1025c3949$var$__rest(style, [
            "placement",
            "offsetX",
            "offsetY"
        ]);
        const textStyle = (0, $hn4z6.getTextStyleByPlacement)(keyShape.getLocalBounds(), placement, offsetX, offsetY, true);
        return Object.assign(Object.assign({}, textStyle), restStyle);
    }
    getPortsStyle(attributes) {
        var _a;
        const ports = this.getPorts();
        const portsShapeStyle = {};
        Object.keys(ports).forEach((key)=>{
            portsShapeStyle[key] = false;
        });
        if (attributes.port === false || !((_a = attributes.ports) === null || _a === void 0 ? void 0 : _a.length)) return portsShapeStyle;
        const portStyle = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'port');
        const { ports: portOptions = [] } = attributes;
        portOptions.forEach((option, index)=>{
            const key = option.key || index;
            const mergedStyle = Object.assign(Object.assign({}, portStyle), option);
            if ((0, $hn4z6.isSimplePort)(mergedStyle)) portsShapeStyle[key] = false;
            else {
                const [x, y] = this.getPortXY(attributes, option);
                portsShapeStyle[key] = Object.assign({
                    transform: [
                        [
                            'translate',
                            x,
                            y
                        ]
                    ]
                }, mergedStyle);
            }
        });
        return portsShapeStyle;
    }
    getPortXY(attributes, style) {
        const { placement: placement = 'left' } = style;
        const keyShape = this.getShape('key');
        return (0, $hn4z6.getPortXYByPlacement)($468058a1025c3949$var$getBoundsInOffscreen(this.context, keyShape), placement);
    }
    /**
     * Get the ports for the node.
     * @returns Ports shape map.
     */ getPorts() {
        return (0, $icwVF.subObject)(this.shapeMap, 'port-');
    }
    /**
     * Get the center point of the node.
     * @returns The center point of the node.
     */ getCenter() {
        return this.getShape('key').getBounds().center;
    }
    /**
     * Get the point on the outer contour of the node that is the intersection with a line starting in the center the ending in the point `p`.
     * @param point - The point to intersect with the node.
     * @param useExtendedLine - Whether to use the extended line.
     * @returns The intersection point.
     */ getIntersectPoint(point, useExtendedLine = false) {
        const keyShapeBounds = this.getShape('key').getBounds();
        return (0, $dnXls.getRectIntersectPoint)(point, keyShapeBounds, useExtendedLine);
    }
    drawHaloShape(attributes, container) {
        const style = this.getHaloStyle(attributes);
        const keyShape = this.getShape('key');
        this.upsert('halo', keyShape.constructor, style, container);
    }
    drawIconShape(attributes, container) {
        const style = this.getIconStyle(attributes);
        this.upsert('icon', (0, $1TY6s.Icon), style, container);
        (0, $hy6NM.connectImage)(this);
    }
    drawBadgeShapes(attributes, container) {
        const badgesStyle = this.getBadgesStyle(attributes);
        Object.keys(badgesStyle).forEach((key)=>{
            const style = badgesStyle[key];
            this.upsert(`badge-${key}`, (0, $2jk2f.Badge), style, container);
        });
    }
    drawPortShapes(attributes, container) {
        const portsStyle = this.getPortsStyle(attributes);
        Object.keys(portsStyle).forEach((key)=>{
            const style = portsStyle[key];
            const shapeKey = `port-${key}`;
            this.upsert(shapeKey, (0, $2eDEB.Circle), style, container);
        });
    }
    drawLabelShape(attributes, container) {
        const style = this.getLabelStyle(attributes);
        this.upsert('label', (0, $1DkzN.Label), style, container);
    }
    // 用于装饰抽象方法 / Used to decorate abstract methods
    _drawKeyShape(attributes, container) {
        return this.drawKeyShape(attributes, container);
    }
    render(attributes = this.parsedAttributes, container = this) {
        // 1. key shape
        this._drawKeyShape(attributes, container);
        if (!this.getShape('key')) return;
        // 2. halo, use shape same with keyShape
        this.drawHaloShape(attributes, container);
        // 3. icon
        this.drawIconShape(attributes, container);
        // 4. badges
        this.drawBadgeShapes(attributes, container);
        // 5. label
        this.drawLabelShape(attributes, container);
        // 6. ports
        this.drawPortShapes(attributes, container);
    }
    update(attr) {
        super.update(attr);
        if (attr && ('x' in attr || 'y' in attr || 'z' in attr)) (0, $hy6NM.dispatchPositionChange)(this);
    }
    onframe() {
        this.drawBadgeShapes(this.parsedAttributes, this);
        this.drawLabelShape(this.parsedAttributes, this);
    }
}
$468058a1025c3949$export$410b0c854570d131.defaultStyleProps = {
    x: 0,
    y: 0,
    size: 32,
    droppable: true,
    draggable: true,
    port: true,
    ports: [],
    portZIndex: 2,
    portLinkToCenter: false,
    badge: true,
    badges: [],
    badgeZIndex: 3,
    halo: false,
    haloDroppable: false,
    haloLineDash: 0,
    haloLineWidth: 12,
    haloStrokeOpacity: 0.25,
    haloPointerEvents: 'none',
    haloZIndex: -1,
    icon: true,
    iconZIndex: 1,
    label: true,
    labelIsBillboard: true,
    labelMaxWidth: '200%',
    labelPlacement: 'bottom',
    labelWordWrap: false,
    labelZIndex: 0
};
/**
 * <zh/> 在离屏画布中获取图形包围盒
 *
 * <en/> Get the bounding box of the shape in the off-screen canvas
 * @param context - <zh/> 运行时上下文 <en/> Runtime context
 * @param shape - <zh/> 图形实例 <en/> Graphic instance
 * @returns <zh/> 图形包围盒 <en/> Graphic bounding box
 */ function $468058a1025c3949$var$getBoundsInOffscreen(context, shape) {
    if (!context) return shape.getLocalBounds();
    // 将主图形靠背至全局空间，避免受到父级 transform 的影响
    // 合理的操作应该是拷贝至离屏画布，但目前 G 有点问题
    // Move the main shape to the global space to avoid being affected by the parent transform
    // The reasonable operation should be moved to the off-screen canvas, but there is a problem with G at present
    const canvas = context.canvas.getLayer();
    const substitute = shape.cloneNode();
    (0, $kzdag.setVisibility)(substitute, 'hidden');
    canvas.appendChild(substitute);
    const bounds = substitute.getLocalBounds();
    substitute.destroy();
    return bounds;
}

});
parcelRegister("kmGF8", function(module, exports) {

$parcel$export(module.exports, "inferIconStyle", () => $ed36f49975591a06$export$af057c42b29b8059);

var $e6Msm = parcelRequire("e6Msm");
function $ed36f49975591a06$export$af057c42b29b8059(size, iconStyle) {
    const stdSize = (0, $e6Msm.parseSize)(size);
    let style = {};
    if (iconStyle.text && !iconStyle.fontSize) style = {
        fontSize: Math.min(...stdSize) * 0.5
    };
    if (iconStyle.src && (!iconStyle.width || !iconStyle.height)) style = {
        width: stdSize[0] * 0.5,
        height: stdSize[1] * 0.5
    };
    return style;
}

});

parcelRegister("cHWaM", function(module, exports) {

$parcel$export(module.exports, "parsePalette", () => $9406a01a76d7c400$export$58cec43fd630d555);
$parcel$export(module.exports, "assignColorByPalette", () => $9406a01a76d7c400$export$c38a1745aee10061);
$parcel$export(module.exports, "getPaletteColors", () => $9406a01a76d7c400$export$f0cd30648755c149);

var $gYaPK = parcelRequire("gYaPK");

var $hW6vf = parcelRequire("hW6vf");

var $brtTw = parcelRequire("brtTw");

var $aBpmX = parcelRequire("aBpmX");
function $9406a01a76d7c400$export$58cec43fd630d555(palette) {
    if (!palette) return undefined;
    if (// 色板名 palette name
    typeof palette === 'string' || // 插值函数 interpolate function
    typeof palette === 'function' || // 颜色数组 color array
    Array.isArray(palette)) // 默认为离散色板
    // Default to discrete palette, default group field is id
    return {
        type: 'group',
        field: (d)=>d.id,
        color: palette,
        invert: false
    };
    return palette;
}
function $9406a01a76d7c400$export$c38a1745aee10061(data, palette) {
    if (!palette) return {};
    const { type: type, color: colorPalette, field: field, invert: invert } = palette;
    const assignColor = (args)=>{
        const palette = typeof colorPalette === 'string' ? (0, $hW6vf.getExtension)('palette', colorPalette) : colorPalette;
        if (typeof palette === 'function') {
            // assign by continuous
            const result = {};
            args.forEach(([id, value])=>{
                result[id] = palette(invert ? 1 - value : value);
            });
            return result;
        } else if (Array.isArray(palette)) {
            // assign by discrete
            const colors = invert ? [
                ...palette
            ].reverse() : palette;
            const result = {};
            args.forEach(([id, index])=>{
                result[id] = colors[index % palette.length];
            });
            return result;
        }
        return {};
    };
    const parseField = (field, datum)=>{
        var _a;
        return typeof field === 'string' ? (_a = datum.data) === null || _a === void 0 ? void 0 : _a[field] : field === null || field === void 0 ? void 0 : field(datum);
    };
    if (type === 'group') {
        const groupData = (0, $gYaPK.default)(data, (datum)=>{
            if (!field) return 'default';
            const key = parseField(field, datum);
            return key ? String(key) : 'default';
        });
        const groupKeys = Object.keys(groupData);
        const assignResult = assignColor(groupKeys.map((key, index)=>[
                key,
                index
            ]));
        const result = {};
        Object.entries(groupData).forEach(([groupKey, groupData])=>{
            groupData.forEach((datum)=>{
                result[(0, $brtTw.idOf)(datum)] = assignResult[groupKey];
            });
        });
        return result;
    } else if (type === 'value') {
        const [min, max] = data.reduce(([min, max], datum)=>{
            const value = parseField(field, datum);
            if (typeof value !== 'number') throw new Error((0, $aBpmX.format)(`Palette field ${field} is not a number`));
            return [
                Math.min(min, value),
                Math.max(max, value)
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        const range = max - min;
        return assignColor(data.map((datum)=>[
                datum.id,
                (parseField(field, datum) - min) / range
            ]));
    }
}
function $9406a01a76d7c400$export$f0cd30648755c149(colorPalette) {
    const palette = typeof colorPalette === 'string' ? (0, $hW6vf.getExtension)('palette', colorPalette) : colorPalette;
    if (typeof palette === 'function') return undefined;
    return palette;
}

});

parcelRegister("jwYMH", function(module, exports) {

$parcel$export(module.exports, "getWordWrapWidthByBox", () => $e3802807833f7788$export$6004e2d2978d9811);
$parcel$export(module.exports, "getWordWrapWidthByEnds", () => $e3802807833f7788$export$c016b00cf6b68790);

var $dOidW = parcelRequire("dOidW");
function $e3802807833f7788$export$98810766d83f165d(length, maxWidth) {
    let wordWrapWidth = 2 * length;
    if (typeof maxWidth === 'string') wordWrapWidth = length * Number(maxWidth.replace('%', '')) / 100;
    else if (typeof maxWidth === 'number') wordWrapWidth = maxWidth;
    if (isNaN(wordWrapWidth)) wordWrapWidth = 2 * length;
    return wordWrapWidth;
}
function $e3802807833f7788$export$6004e2d2978d9811(keyShapeBox, maxWidth, zoom = 1, enableBalanceShape = false) {
    const balanceZoom = enableBalanceShape ? zoom : 1;
    const keyShapeWidth = (keyShapeBox.max[0] - keyShapeBox.min[0]) * balanceZoom;
    return $e3802807833f7788$export$98810766d83f165d(keyShapeWidth, maxWidth);
}
function $e3802807833f7788$export$c016b00cf6b68790(points, maxWidth, zoom = 1) {
    const dist = (0, $dOidW.distance)(points[0], points[1]) * zoom;
    return $e3802807833f7788$export$98810766d83f165d(dist, maxWidth);
}

});

parcelRegister("14Eyx", function(module, exports) {

$parcel$export(module.exports, "BaseElement", () => $0c859fbc0f404d0e$export$a1a7283d3ef4b3a1);
parcelRequire("hIZ0D");
var $3D5nF = parcelRequire("3D5nF");
class $0c859fbc0f404d0e$export$a1a7283d3ef4b3a1 extends (0, $3D5nF.BaseShape) {
    get context() {
        // @ts-expect-error skip type-check
        return this.config.context;
    }
    get parsedAttributes() {
        return this.attributes;
    }
    /**
     * <zh/> 动画帧执行函数
     *
     * <en/> Animation frame execution function
     */ onframe() {}
    animate(keyframes, options) {
        const animation = super.animate(keyframes, options);
        if (animation) {
            animation.onframe = ()=>this.onframe();
            animation.finished.then(()=>this.onframe());
        }
        return animation;
    }
}

});
parcelRegister("hIZ0D", function(module, exports) {

$parcel$export(module.exports, "Badge", () => (parcelRequire("2jk2f")).Badge);
$parcel$export(module.exports, "BaseShape", () => (parcelRequire("3D5nF")).BaseShape);
$parcel$export(module.exports, "Contour", () => (parcelRequire("jZN6o")).Contour);
$parcel$export(module.exports, "Icon", () => (parcelRequire("1TY6s")).Icon);
$parcel$export(module.exports, "Image", () => (parcelRequire("hy6NM")).Image);
$parcel$export(module.exports, "Label", () => (parcelRequire("1DkzN")).Label);
/**
 * <zh/> 图形组件，用于构建复合元素
 *
 * <en/> Shape components, used to build composite elements
 */ 
var $2jk2f = parcelRequire("2jk2f");

var $3D5nF = parcelRequire("3D5nF");

var $jZN6o = parcelRequire("jZN6o");

var $1TY6s = parcelRequire("1TY6s");

var $hy6NM = parcelRequire("hy6NM");

var $1DkzN = parcelRequire("1DkzN");

});
parcelRegister("2jk2f", function(module, exports) {

$parcel$export(module.exports, "Badge", () => $1aece5b9354fd481$export$37acb3580601e69a);

var $j4n8g = parcelRequire("j4n8g");

var $3D5nF = parcelRequire("3D5nF");

var $1DkzN = parcelRequire("1DkzN");
class $1aece5b9354fd481$export$37acb3580601e69a extends (0, $3D5nF.BaseShape) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $1aece5b9354fd481$export$37acb3580601e69a.defaultStyleProps
        }, options));
    }
    getBadgeStyle(attributes) {
        return this.getGraphicStyle(attributes);
    }
    render(attributes = this.parsedAttributes, container = this) {
        this.upsert('label', (0, $1DkzN.Label), this.getBadgeStyle(attributes), container);
    }
    getGeometryBounds() {
        const labelShape = this.getShape('label');
        const shape = labelShape.getShape('background') || labelShape.getShape('text');
        return shape.getGeometryBounds();
    }
}
$1aece5b9354fd481$export$37acb3580601e69a.defaultStyleProps = {
    padding: [
        2,
        4,
        2,
        4
    ],
    fontSize: 10,
    wordWrap: false,
    backgroundRadius: '50%',
    backgroundOpacity: 1
};

});
parcelRegister("3D5nF", function(module, exports) {

$parcel$export(module.exports, "BaseShape", () => $2a49301ddfd66487$export$a5a11c91f9f7ea53);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $hllqz = parcelRequire("hllqz");
var $ky7aH = parcelRequire("ky7aH");
var $10sB9 = parcelRequire("10sB9");
parcelRequire("ahJ7k");
var $jRLln = parcelRequire("jRLln");

var $dtz9V = parcelRequire("dtz9V");

var $hn4z6 = parcelRequire("hn4z6");

var $icwVF = parcelRequire("icwVF");

var $aBpmX = parcelRequire("aBpmX");

var $j4n8g = parcelRequire("j4n8g");

var $aPhuQ = parcelRequire("aPhuQ");

var $kzdag = parcelRequire("kzdag");

var $hW6vf = parcelRequire("hW6vf");
class $2a49301ddfd66487$export$a5a11c91f9f7ea53 extends (0, $2eDEB.CustomElement) {
    constructor(options){
        $2a49301ddfd66487$var$applyTransform(options.style);
        super(options);
        /**
         * <zh/> 图形实例映射表
         *
         * <en/> shape instance map
         * @internal
         */ this.shapeMap = {};
        /**
         * <zh/> 动画实例映射表
         *
         * <en/> animation instance map
         * @internal
         */ this.animateMap = {};
        this.render(this.attributes, this);
        this.setVisibility();
        this.bindEvents();
    }
    /**
     * <zh/> 解析后的属性
     *
     * <en/> parsed attributes
     * @returns <zh/> 解析后的属性 | <en/> parsed attributes
     * @internal
     */ get parsedAttributes() {
        return this.attributes;
    }
    /**
     * <zh/> 创建、更新或删除图形
     *
     * <en/> create, update or remove shape
     * @param className - <zh/> 图形名称 | <en/> shape name
     * @param Ctor - <zh/> 图形类型 | <en/> shape type
     * @param style - <zh/> 图形样式。若要删除图形，传入 false | <en/> shape style. Pass false to remove the shape
     * @param container - <zh/> 容器 | <en/> container
     * @param hooks - <zh/> 钩子函数 | <en/> hooks
     * @returns <zh/> 图形实例 | <en/> shape instance
     */ upsert(className, Ctor, style, container, hooks) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const target = this.shapeMap[className];
        // remove
        // 如果 style 为 false，则删除图形 / remove shape if style is false
        if (style === false) {
            if (target) {
                (_a = hooks === null || hooks === void 0 ? void 0 : hooks.beforeDestroy) === null || _a === void 0 || _a.call(hooks, target);
                container.removeChild(target);
                delete this.shapeMap[className];
                (_b = hooks === null || hooks === void 0 ? void 0 : hooks.afterDestroy) === null || _b === void 0 || _b.call(hooks, target);
            }
            return;
        }
        const _Ctor = typeof Ctor === 'string' ? (0, $hW6vf.getExtension)((0, $jRLln.ExtensionCategory).SHAPE, Ctor) : Ctor;
        if (!_Ctor) throw new Error((0, $aBpmX.format)(`Shape ${Ctor} not found`));
        // create
        if (!target || target.destroyed || !(target instanceof _Ctor)) {
            if (target) {
                (_c = hooks === null || hooks === void 0 ? void 0 : hooks.beforeDestroy) === null || _c === void 0 || _c.call(hooks, target);
                target === null || target === void 0 || target.destroy();
                (_d = hooks === null || hooks === void 0 ? void 0 : hooks.afterDestroy) === null || _d === void 0 || _d.call(hooks, target);
            }
            (_e = hooks === null || hooks === void 0 ? void 0 : hooks.beforeCreate) === null || _e === void 0 || _e.call(hooks);
            const instance = new _Ctor({
                className: className,
                style: style
            });
            container.appendChild(instance);
            this.shapeMap[className] = instance;
            (_f = hooks === null || hooks === void 0 ? void 0 : hooks.afterCreate) === null || _f === void 0 || _f.call(hooks, instance);
            return instance;
        }
        // update
        (_g = hooks === null || hooks === void 0 ? void 0 : hooks.beforeUpdate) === null || _g === void 0 || _g.call(hooks, target);
        (0, $hn4z6.updateStyle)(target, style);
        (_h = hooks === null || hooks === void 0 ? void 0 : hooks.afterUpdate) === null || _h === void 0 || _h.call(hooks, target);
        return target;
    }
    update(attr = {}) {
        const attributes = Object.assign({}, this.attributes, attr);
        $2a49301ddfd66487$var$applyTransform(attributes);
        (0, $hn4z6.setAttributes)(this, attributes);
        this.render(attributes, this);
        this.setVisibility();
    }
    bindEvents() {}
    /**
     * <zh/> 从给定的属性对象中提取图形样式属性。删除特定的属性，如位置、变换和类名
     *
     * <en/> Extracts the shape styles from a given attribute object.
     * Removes specific styles like position, transformation, and class name.
     * @param style - <zh/> 属性对象 | <en/> attribute object
     * @returns <zh/> 仅包含样式属性的对象 | <en/> An object containing only the style properties.
     */ getGraphicStyle(style) {
        return (0, $j4n8g.getSubShapeStyle)(style);
    }
    /**
     * Get the prefix pairs for composite shapes used to handle animation
     * @returns tuples array where each tuple contains a key corresponding to a method `get${key}Style` and its shape prefix
     * @internal
     */ get compositeShapes() {
        return [
            [
                'badges',
                'badge-'
            ],
            [
                'ports',
                'port-'
            ]
        ];
    }
    animate(keyframes, options) {
        if (keyframes.length === 0) return null;
        const animationMap = [];
        // 如果 keyframes 中存在 x/y/z ，替换为 transform
        // if x/y/z exists in keyframes, replace them with transform
        if (keyframes[0].x !== undefined || keyframes[0].y !== undefined || keyframes[0].z !== undefined) {
            const { x: _x = 0, y: _y = 0, z: _z = 0 } = this.attributes;
            keyframes.forEach((keyframe)=>{
                const { x: x = _x, y: y = _y, z: z = _z } = keyframe;
                Object.assign(keyframe, {
                    transform: z ? [
                        [
                            'translate3d',
                            x,
                            y,
                            z
                        ]
                    ] : [
                        [
                            'translate',
                            x,
                            y
                        ]
                    ]
                });
            });
        }
        const result = super.animate(keyframes, options);
        if (result) {
            $2a49301ddfd66487$var$releaseAnimation(this, result);
            animationMap.push(result);
        }
        if (Array.isArray(keyframes) && keyframes.length > 0) {
            // 如果 keyframes 中仅存在 skippedAttrs 中的属性，则仅更新父元素属性（跳过子图形）
            // if only skippedAttrs exist in keyframes, only update parent element attributes (skip child shapes)
            const skippedAttrs = [
                'transform',
                'transformOrigin',
                'x',
                'y',
                'z',
                'zIndex'
            ];
            if (Object.keys(keyframes[0]).some((attr)=>!skippedAttrs.includes(attr))) {
                Object.entries(this.shapeMap).forEach(([key, shape])=>{
                    // 如果存在方法名为 `get${key}Style` 的方法，则使用该方法获取样式，并自动为该图形实例创建动画
                    // if there is a method named `get${key}Style`, use this method to get style and automatically create animation for the shape instance
                    const methodName = `get${(0, $10sB9.default)(key)}Style`;
                    const method = this[methodName];
                    if ((0, $ky7aH.default)(method)) {
                        const subKeyframes = keyframes.map((style)=>method.call(this, Object.assign(Object.assign({}, this.attributes), style)));
                        const result = shape.animate((0, $dtz9V.preprocessKeyframes)(subKeyframes), options);
                        if (result) {
                            $2a49301ddfd66487$var$releaseAnimation(shape, result);
                            animationMap.push(result);
                        }
                    }
                });
                const handleCompositeShapeAnimation = (shapeSet, name)=>{
                    if (!(0, $hllqz.default)(shapeSet)) {
                        const methodName = `get${(0, $10sB9.default)(name)}Style`;
                        const method = this[methodName];
                        if ((0, $ky7aH.default)(method)) {
                            const itemsKeyframes = keyframes.map((style)=>method.call(this, Object.assign(Object.assign({}, this.attributes), style)));
                            Object.entries(itemsKeyframes[0]).map(([key])=>{
                                const subKeyframes = itemsKeyframes.map((styles)=>styles[key]);
                                const shape = shapeSet[key];
                                if (shape) {
                                    const result = shape.animate((0, $dtz9V.preprocessKeyframes)(subKeyframes), options);
                                    if (result) {
                                        $2a49301ddfd66487$var$releaseAnimation(shape, result);
                                        animationMap.push(result);
                                    }
                                }
                            });
                        }
                    }
                };
                this.compositeShapes.forEach(([key, prefix])=>{
                    const shapeSet = (0, $icwVF.subObject)(this.shapeMap, prefix);
                    handleCompositeShapeAnimation(shapeSet, key);
                });
            }
        }
        return (0, $dtz9V.createAnimationsProxy)(animationMap);
    }
    getShape(name) {
        return this.shapeMap[name];
    }
    setVisibility() {
        const { visibility: visibility } = this.attributes;
        (0, $kzdag.setVisibility)(this, visibility);
    }
    destroy() {
        this.shapeMap = {};
        this.animateMap = {};
        super.destroy();
    }
}
/**
 * <zh/> 释放动画
 *
 * <en/> Release animation
 * @param target - <zh/> 目标对象 | <en/> target object
 * @param animation - <zh/> 动画实例 | <en/> animation instance
 * @description see: https://github.com/antvis/G/issues/1731
 */ function $2a49301ddfd66487$var$releaseAnimation(target, animation) {
    animation === null || animation === void 0 || animation.finished.then(()=>{
        // @ts-expect-error private property
        const index = target.activeAnimations.findIndex((_)=>_ === animation);
        // @ts-expect-error private property
        if (index > -1) target.activeAnimations.splice(index, 1);
    });
}
/**
 * <zh/> 应用 transform
 *
 * <en/> Apply transform
 * @param style - <zh/> 样式 | <en/> style
 * @returns <zh/> 样式 | <en/> style
 */ function $2a49301ddfd66487$var$applyTransform(style) {
    if (!style) return {};
    if ('x' in style || 'y' in style || 'z' in style) {
        const { x: x = 0, y: y = 0, z: z, transform: transform } = style;
        const newTransform = (0, $aPhuQ.replaceTranslateInTransform)(x, y, z, transform);
        if (newTransform) style.transform = newTransform;
    }
    return style;
}

});
parcelRegister("hllqz", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca0504ea131c615f$export$2e2bcd8739ae039);

var $geZBG = parcelRequire("geZBG");

var $dDtYS = parcelRequire("dDtYS");

var $4X5Jp = parcelRequire("4X5Jp");

var $b5Ynz = parcelRequire("b5Ynz");
var $ca0504ea131c615f$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $ca0504ea131c615f$var$isEmpty(value) {
    /**
     * isEmpty(null) => true
     * isEmpty() => true
     * isEmpty(true) => true
     * isEmpty(1) => true
     * isEmpty([1, 2, 3]) => false
     * isEmpty('abc') => false
     * isEmpty({ a: 1 }) => false
     */ if ((0, $geZBG.default)(value)) return true;
    if ((0, $dDtYS.default)(value)) return !value.length;
    var type = (0, $4X5Jp.default)(value);
    if (type === 'Map' || type === 'Set') return !value.size;
    if ((0, $b5Ynz.default)(value)) return !Object.keys(value).length;
    for(var key in value){
        if ($ca0504ea131c615f$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $ca0504ea131c615f$export$2e2bcd8739ae039 = $ca0504ea131c615f$var$isEmpty;

});
parcelRegister("4X5Jp", function(module, exports) {

$parcel$export(module.exports, "default", () => $39b11e3fa2648196$export$2e2bcd8739ae039);
var $39b11e3fa2648196$var$toString = {}.toString;
var $39b11e3fa2648196$var$getType = function(value) {
    return $39b11e3fa2648196$var$toString.call(value).replace(/^\[object /, '').replace(/]$/, '');
};
var $39b11e3fa2648196$export$2e2bcd8739ae039 = $39b11e3fa2648196$var$getType;

});

parcelRegister("b5Ynz", function(module, exports) {

$parcel$export(module.exports, "default", () => $813eff61acc9d1dc$export$2e2bcd8739ae039);
var $813eff61acc9d1dc$var$objectProto = Object.prototype;
var $813eff61acc9d1dc$var$isPrototype = function(value) {
    var Ctor = value && value.constructor;
    var proto = typeof Ctor === 'function' && Ctor.prototype || $813eff61acc9d1dc$var$objectProto;
    return value === proto;
};
var $813eff61acc9d1dc$export$2e2bcd8739ae039 = $813eff61acc9d1dc$var$isPrototype;

});



parcelRegister("1DkzN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $13096504eb317f39$export$b04be29aa201d4f5);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $1uR12 = parcelRequire("1uR12");

var $icwVF = parcelRequire("icwVF");

var $j4n8g = parcelRequire("j4n8g");

var $3D5nF = parcelRequire("3D5nF");
var $13096504eb317f39$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $13096504eb317f39$export$b04be29aa201d4f5 extends (0, $3D5nF.BaseShape) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $13096504eb317f39$export$b04be29aa201d4f5.defaultStyleProps
        }, options));
    }
    isTextStyle(key) {
        return (0, $icwVF.startsWith)(key, 'label');
    }
    isBackgroundStyle(key) {
        return (0, $icwVF.startsWith)(key, 'background');
    }
    getTextStyle(attributes) {
        const _a = this.getGraphicStyle(attributes), { padding: padding } = _a, style = $13096504eb317f39$var$__rest(_a, [
            "padding"
        ]);
        return (0, $icwVF.omitStyleProps)(style, 'background');
    }
    getBackgroundStyle(attributes) {
        if (attributes.background === false) return false;
        const style = this.getGraphicStyle(attributes);
        const { wordWrap: wordWrap, wordWrapWidth: wordWrapWidth, padding: padding } = style;
        const backgroundStyle = (0, $icwVF.subStyleProps)(style, 'background');
        const { min: [minX, minY], center: [centerX, centerY], halfExtents: [halfWidth, halfHeight] } = this.shapeMap.text.getGeometryBounds();
        const [top, right, bottom, left] = (0, $1uR12.parsePadding)(padding);
        const totalWidth = halfWidth * 2 + left + right;
        const { width: width, height: height } = backgroundStyle;
        if (width && height) Object.assign(backgroundStyle, {
            x: centerX - Number(width) / 2,
            y: centerY - Number(height) / 2
        });
        else Object.assign(backgroundStyle, {
            x: minX - left,
            y: minY - top,
            width: wordWrap ? Math.min(totalWidth, wordWrapWidth + left + right) : totalWidth,
            height: halfHeight * 2 + top + bottom
        });
        // parse percentage radius
        const { radius: radius } = backgroundStyle;
        // if radius look like '10%', convert it to number
        if (typeof radius === 'string' && radius.endsWith('%')) {
            const percentage = Number(radius.replace('%', '')) / 100;
            backgroundStyle.radius = Math.min(+backgroundStyle.width, +backgroundStyle.height) * percentage;
        }
        return backgroundStyle;
    }
    render(attributes = this.parsedAttributes, container = this) {
        this.upsert('text', (0, $2eDEB.Text), this.getTextStyle(attributes), container);
        this.upsert('background', (0, $2eDEB.Rect), this.getBackgroundStyle(attributes), container);
    }
    getGeometryBounds() {
        const shape = this.getShape('background') || this.getShape('text');
        return shape.getGeometryBounds();
    }
}
$13096504eb317f39$export$b04be29aa201d4f5.defaultStyleProps = {
    padding: 0,
    fontSize: 12,
    fontFamily: 'system-ui, sans-serif',
    wordWrap: true,
    maxLines: 1,
    wordWrapWidth: 128,
    textOverflow: '...',
    textBaseline: 'middle',
    backgroundOpacity: 0.75,
    backgroundZIndex: -1,
    backgroundLineWidth: 0
};

});


parcelRegister("jZN6o", function(module, exports) {

$parcel$export(module.exports, "Contour", () => $e8e9cd75c82f8238$export$458a02e943eb446f);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $VZ520 = parcelRequire("VZ520");

var $icwVF = parcelRequire("icwVF");

var $j4n8g = parcelRequire("j4n8g");

var $jwYMH = parcelRequire("jwYMH");

var $3D5nF = parcelRequire("3D5nF");

var $1DkzN = parcelRequire("1DkzN");
var $e8e9cd75c82f8238$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $e8e9cd75c82f8238$export$458a02e943eb446f extends (0, $3D5nF.BaseShape) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $e8e9cd75c82f8238$export$458a02e943eb446f.defaultStyleProps
        }, options));
    }
    getLabelStyle(attributes) {
        if (!attributes.label || !attributes.d || attributes.d.length === 0) return false;
        const _a = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'label'), { maxWidth: maxWidth, offsetX: offsetX, offsetY: offsetY, autoRotate: autoRotate, placement: placement, closeToPath: closeToPath } = _a, labelStyle = $e8e9cd75c82f8238$var$__rest(_a, [
            "maxWidth",
            "offsetX",
            "offsetY",
            "autoRotate",
            "placement",
            "closeToPath"
        ]);
        const key = this.shapeMap.key;
        const keyBounds = key === null || key === void 0 ? void 0 : key.getRenderBounds();
        return Object.assign((0, $VZ520.getPolygonTextStyleByPlacement)(keyBounds, placement, offsetX, offsetY, closeToPath, attributes.d, autoRotate), {
            wordWrapWidth: (0, $jwYMH.getWordWrapWidthByBox)(keyBounds, maxWidth)
        }, labelStyle);
    }
    getKeyStyle(attributes) {
        return this.getGraphicStyle(attributes);
    }
    render(attributes, container) {
        this.upsert('key', (0, $2eDEB.Path), this.getKeyStyle(attributes), container);
        this.upsert('label', (0, $1DkzN.Label), this.getLabelStyle(attributes), container);
    }
}
$e8e9cd75c82f8238$export$458a02e943eb446f.defaultStyleProps = {
    label: true,
    labelPlacement: 'bottom',
    labelCloseToPath: true,
    labelAutoRotate: true,
    labelOffsetX: 0,
    labelOffsetY: 0
};

});
parcelRegister("VZ520", function(module, exports) {

$parcel$export(module.exports, "getPolygonTextStyleByPlacement", () => $0ae4b43b2f7d76a6$export$8c7f0225db77cb4e);

var $4ETMA = parcelRequire("4ETMA");

var $oZkEc = parcelRequire("oZkEc");

var $dnXls = parcelRequire("dnXls");

var $46bcR = parcelRequire("46bcR");
function $0ae4b43b2f7d76a6$export$8c7f0225db77cb4e(bounds, placement, offsetX, offsetY, closeToContour, path, autoRotate) {
    const [x, y] = (0, $46bcR.getXYByPlacement)(bounds, placement);
    const style = {
        textAlign: placement === 'left' ? 'right' : placement === 'right' ? 'left' : 'center',
        textBaseline: placement === 'top' ? 'bottom' : placement === 'bottom' ? 'top' : 'middle',
        transform: [
            [
                'translate',
                x + offsetX,
                y + offsetY
            ]
        ]
    };
    if (placement === 'center' || !closeToContour) return style;
    const points = (0, $oZkEc.pathToPoints)(path);
    if (!points || points.length <= 3) return style;
    const lines = points.map((point, index)=>{
        const p1 = point;
        const p2 = points[(index + 1) % points.length];
        if ((0, $4ETMA.default)(p1, p2)) return null;
        return [
            p1,
            p2
        ];
    }).filter(Boolean);
    const line = (0, $dnXls.findNearestLine)([
        x,
        y
    ], lines);
    const intersection = (0, $dnXls.findNearestPointOnLine)([
        x,
        y
    ], line);
    if (intersection && line) {
        style.transform = [
            [
                'translate',
                intersection[0] + offsetX,
                intersection[1] + offsetY
            ]
        ];
        if (autoRotate) {
            const angle = Math.atan((line[0][1] - line[1][1]) / (line[0][0] - line[1][0]));
            style.transform.push([
                'rotate',
                angle / Math.PI * 180
            ]);
            style.textAlign = 'center';
            if (placement === 'right' || placement === 'left') {
                if (angle > 0) style.textBaseline = placement === 'right' ? 'bottom' : 'top';
                else style.textBaseline = placement === 'right' ? 'top' : 'bottom';
            }
        }
    }
    return style;
}

});
parcelRegister("oZkEc", function(module, exports) {

$parcel$export(module.exports, "pointsToPath", () => $04b1d1449b50b16c$export$bc863495a5f10ca1);
$parcel$export(module.exports, "pathToPoints", () => $04b1d1449b50b16c$export$9aaeaa7ba96a2fd5);
$parcel$export(module.exports, "getClosedSpline", () => $04b1d1449b50b16c$export$9ace2948a1767297);
/**
 * <zh/> points 转化为 path 路径
 *
 * <en/> points transform path.
 * @param points Point[]
 * @param isClose boolean
 * @returns path string[][]
 */ function $04b1d1449b50b16c$export$bc863495a5f10ca1(points, isClose = true) {
    const path = [];
    points.forEach((point, index)=>{
        path.push([
            index === 0 ? 'M' : 'L',
            ...point
        ]);
    });
    if (isClose) path.push([
        'Z'
    ]);
    return path;
}
const $04b1d1449b50b16c$var$PATH_COMMANDS = {
    M: [
        'x',
        'y'
    ],
    m: [
        'dx',
        'dy'
    ],
    H: [
        'x'
    ],
    h: [
        'dx'
    ],
    V: [
        'y'
    ],
    v: [
        'dy'
    ],
    L: [
        'x',
        'y'
    ],
    l: [
        'dx',
        'dy'
    ],
    Z: [],
    z: [],
    C: [
        'x1',
        'y1',
        'x2',
        'y2',
        'x',
        'y'
    ],
    c: [
        'dx1',
        'dy1',
        'dx2',
        'dy2',
        'dx',
        'dy'
    ],
    S: [
        'x2',
        'y2',
        'x',
        'y'
    ],
    s: [
        'dx2',
        'dy2',
        'dx',
        'dy'
    ],
    Q: [
        'x1',
        'y1',
        'x',
        'y'
    ],
    q: [
        'dx1',
        'dy1',
        'dx',
        'dy'
    ],
    T: [
        'x',
        'y'
    ],
    t: [
        'dx',
        'dy'
    ],
    A: [
        'rx',
        'ry',
        'rotation',
        'large-arc',
        'sweep',
        'x',
        'y'
    ],
    a: [
        'rx',
        'ry',
        'rotation',
        'large-arc',
        'sweep',
        'dx',
        'dy'
    ]
};
function $04b1d1449b50b16c$export$8ccf933b0513f8d0(path) {
    const items = path.replace(/[\n\r]/g, '').replace(/-/g, ' -').replace(/(\d*\.)(\d+)(?=\.)/g, '$1$2 ').trim().split(/\s*,|\s+/);
    const segments = [];
    let currentCommand = '';
    let currentElement = {};
    while(items.length > 0){
        let it = items.shift();
        if (it in $04b1d1449b50b16c$var$PATH_COMMANDS) currentCommand = it;
        else items.unshift(it);
        currentElement = {
            type: currentCommand
        };
        $04b1d1449b50b16c$var$PATH_COMMANDS[currentCommand].forEach((prop)=>{
            it = items.shift(); // TODO sanity check
            currentElement[prop] = it;
        });
        if (currentCommand === 'M') currentCommand = 'L';
        else if (currentCommand === 'm') currentCommand = 'l';
        const [type, ...values] = Object.values(currentElement);
        segments.push([
            type,
            ...values.map(Number)
        ]);
    }
    return segments;
}
function $04b1d1449b50b16c$export$9aaeaa7ba96a2fd5(path) {
    const points = [];
    const segments = typeof path === 'string' ? $04b1d1449b50b16c$export$8ccf933b0513f8d0(path) : path;
    segments.forEach((seg)=>{
        const command = seg[0];
        if (command === 'Z') {
            points.push(points[0]);
            return;
        }
        if (command !== 'A') for(let i = 1; i < seg.length; i = i + 2)points.push([
            seg[i],
            seg[i + 1],
            0
        ]);
        else {
            const length = seg.length;
            points.push([
                seg[length - 2],
                seg[length - 1],
                0
            ]);
        }
    });
    return points;
}
const $04b1d1449b50b16c$export$9ace2948a1767297 = (points)=>{
    if (points.length < 2) return [
        [
            'M',
            0,
            0
        ],
        [
            'L',
            0,
            0
        ]
    ];
    const first = points[0];
    const second = points[1];
    const last = points[points.length - 1];
    const lastSecond = points[points.length - 2];
    points.unshift(lastSecond, last);
    points.push(first, second);
    const closedPath = [
        [
            'M',
            last[0],
            last[1]
        ]
    ];
    for(let i = 1; i < points.length - 2; i += 1){
        const [x0, y0] = points[i - 1];
        const [x1, y1] = points[i];
        const [x2, y2] = points[i + 1];
        const [x3, y3] = i !== points.length - 2 ? points[i + 2] : [
            x2,
            y2
        ];
        const cp1x = x1 + (x2 - x0) / 6;
        const cp1y = y1 + (y2 - y0) / 6;
        const cp2x = x2 - (x3 - x1) / 6;
        const cp2y = y2 - (y3 - y1) / 6;
        closedPath.push([
            'C',
            cp1x,
            cp1y,
            cp2x,
            cp2y,
            x2,
            y2
        ]);
    }
    return closedPath;
};

});



parcelRegister("1TY6s", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $16298cb92f562710$export$f04a61298a47a40f);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $3D5nF = parcelRequire("3D5nF");

var $hy6NM = parcelRequire("hy6NM");
class $16298cb92f562710$export$f04a61298a47a40f extends (0, $3D5nF.BaseShape) {
    constructor(options){
        super(options);
    }
    isImage() {
        const { src: src } = this.attributes;
        return !!src;
    }
    getIconStyle(attributes = this.attributes) {
        const { width: width = 0, height: height = 0 } = attributes;
        const style = this.getGraphicStyle(attributes);
        if (this.isImage()) return Object.assign({
            x: -width / 2,
            y: -height / 2
        }, style);
        return Object.assign({
            textBaseline: 'middle',
            textAlign: 'center'
        }, style);
    }
    render(attributes = this.attributes, container = this) {
        this.upsert('icon', this.isImage() ? (0, $hy6NM.Image) : (0, $2eDEB.Text), this.getIconStyle(attributes), container);
    }
}

});
parcelRegister("hy6NM", function(module, exports) {

$parcel$export(module.exports, "Image", () => $cc6ae35c1c6fa190$export$3e431a229df88919);
$parcel$export(module.exports, "connectImage", () => $cc6ae35c1c6fa190$export$73a4ccf5d89f71f);
$parcel$export(module.exports, "dispatchPositionChange", () => $cc6ae35c1c6fa190$export$4ace4f5e8c4edf1);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $bVjEM = parcelRequire("bVjEM");
class $cc6ae35c1c6fa190$export$3e431a229df88919 extends (0, $2eDEB.Image) {
    constructor(options){
        super(options);
        this.onMounted = ()=>{
            this.handleRadius();
        };
        this.onAttrModified = ()=>{
            this.handleRadius();
        };
        $cc6ae35c1c6fa190$var$current = this;
        this.isMutationObserved = true;
        this.addEventListener((0, $2eDEB.ElementEvent).MOUNTED, this.onMounted);
        this.addEventListener((0, $2eDEB.ElementEvent).ATTR_MODIFIED, this.onAttrModified);
    }
    handleRadius() {
        const { radius: radius, clipPath: clipPath, width: width = 0, height: height = 0 } = this.attributes;
        if (radius && width && height) {
            const [x, y] = this.getBounds().min;
            const clipPathStyle = {
                x: x,
                y: y,
                radius: radius,
                width: width,
                height: height
            };
            if (clipPath) Object.assign(this.parsedStyle.clipPath.style, clipPathStyle);
            else {
                const rect = new (0, $2eDEB.Rect)({
                    style: clipPathStyle
                });
                this.style.clipPath = rect;
            }
        } else if (clipPath) this.style.clipPath = null;
    }
}
const $cc6ae35c1c6fa190$var$ImagesWeakMap = new WeakMap();
let $cc6ae35c1c6fa190$var$current = null;
const $cc6ae35c1c6fa190$export$73a4ccf5d89f71f = (target)=>{
    if ($cc6ae35c1c6fa190$var$current && (0, $bVjEM.getAncestorShapes)($cc6ae35c1c6fa190$var$current).includes(target)) {
        const images = $cc6ae35c1c6fa190$var$ImagesWeakMap.get(target);
        if (images) {
            if (!images.includes($cc6ae35c1c6fa190$var$current)) images.push($cc6ae35c1c6fa190$var$current);
        } else $cc6ae35c1c6fa190$var$ImagesWeakMap.set(target, [
            $cc6ae35c1c6fa190$var$current
        ]);
    }
};
const $cc6ae35c1c6fa190$export$4ace4f5e8c4edf1 = (target)=>{
    const image = $cc6ae35c1c6fa190$var$ImagesWeakMap.get(target);
    if (image) image.forEach((i)=>i.handleRadius());
};

});
parcelRegister("bVjEM", function(module, exports) {

$parcel$export(module.exports, "getDescendantShapes", () => $8ae443fa6897a712$export$7777228547f1a2ff);
$parcel$export(module.exports, "getAncestorShapes", () => $8ae443fa6897a712$export$c9319af89fa66025);
/**
 * <zh/> 获取图形的所有子元素
 *
 * <en/> Get all the child elements of the shape
 * @param shape - <zh/> 图形元素 | <en/> shape
 * @returns <zh/> 子元素数组 | <en/> child elements array
 */ function $8ae443fa6897a712$export$7777228547f1a2ff(shape) {
    const succeeds = [];
    // 遍历所有子元素，并将子元素的子元素加入到数组中
    const traverse = (shape)=>{
        if (shape === null || shape === void 0 ? void 0 : shape.children.length) shape.children.forEach((child)=>{
            succeeds.push(child);
            traverse(child);
        });
    };
    traverse(shape);
    return succeeds;
}
function $8ae443fa6897a712$export$c9319af89fa66025(shape) {
    const ancestors = [];
    let currentNode = shape.parentNode;
    while(currentNode){
        ancestors.push(currentNode);
        currentNode = currentNode.parentNode;
    }
    return ancestors;
}

});






parcelRegister("dbxRO", function(module, exports) {

$parcel$export(module.exports, "Circle", () => $999692b9f9e5658d$export$c89a927ffc67e6fa);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $hXCXB = parcelRequire("hXCXB");

var $dnXls = parcelRequire("dnXls");

var $j4n8g = parcelRequire("j4n8g");

var $63haX = parcelRequire("63haX");
class $999692b9f9e5658d$export$c89a927ffc67e6fa extends (0, $63haX.BaseNode) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $999692b9f9e5658d$export$c89a927ffc67e6fa.defaultStyleProps
        }, options));
    }
    drawKeyShape(attributes, container) {
        return this.upsert('key', (0, $2eDEB.Circle), this.getKeyStyle(attributes), container);
    }
    getKeyStyle(attributes) {
        const keyStyle = super.getKeyStyle(attributes);
        return Object.assign(Object.assign({}, keyStyle), {
            r: Math.min(...this.getSize(attributes)) / 2
        });
    }
    getIconStyle(attributes) {
        const style = super.getIconStyle(attributes);
        const { r: r } = this.getShape('key').attributes;
        const size = r * 2 * (0, $hXCXB.ICON_SIZE_RATIO);
        return style ? Object.assign({
            width: size,
            height: size
        }, style) : false;
    }
    getIntersectPoint(point, useExtendedLine = false) {
        const keyShapeBounds = this.getShape('key').getBounds();
        return (0, $dnXls.getEllipseIntersectPoint)(point, keyShapeBounds, useExtendedLine);
    }
}
$999692b9f9e5658d$export$c89a927ffc67e6fa.defaultStyleProps = {
    size: 32
};

});

parcelRegister("8nW3T", function(module, exports) {

$parcel$export(module.exports, "Diamond", () => $61ad8290db083f3e$export$8c2a6f376d2e35fc);

var $hn4z6 = parcelRequire("hn4z6");

var $jv6O2 = parcelRequire("jv6O2");
class $61ad8290db083f3e$export$8c2a6f376d2e35fc extends (0, $jv6O2.Polygon) {
    constructor(options){
        super(options);
    }
    getPoints(attributes) {
        const [width, height] = this.getSize(attributes);
        return (0, $hn4z6.getDiamondPoints)(width, height);
    }
}

});
parcelRegister("jv6O2", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $e326311ec79abfc8$export$7d31b617c820d435);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $dnXls = parcelRequire("dnXls");

var $63haX = parcelRequire("63haX");
class $e326311ec79abfc8$export$7d31b617c820d435 extends (0, $63haX.BaseNode) {
    constructor(options){
        super(options);
    }
    get parsedAttributes() {
        return this.attributes;
    }
    drawKeyShape(attributes, container) {
        return this.upsert('key', (0, $2eDEB.Polygon), this.getKeyStyle(attributes), container);
    }
    getKeyStyle(attributes) {
        const keyStyle = super.getKeyStyle(attributes);
        return Object.assign(Object.assign({}, keyStyle), {
            points: this.getPoints(attributes)
        });
    }
    getIntersectPoint(point, useExtendedLine = false) {
        var _a, _b;
        const { points: points } = this.getShape('key').attributes;
        const center = [
            +(((_a = this.attributes) === null || _a === void 0 ? void 0 : _a.x) || 0),
            +(((_b = this.attributes) === null || _b === void 0 ? void 0 : _b.y) || 0)
        ];
        return (0, $dnXls.getPolygonIntersectPoint)(point, center, points, true, useExtendedLine).point;
    }
}

});


parcelRegister("483tH", function(module, exports) {

$parcel$export(module.exports, "Donut", () => $301a9b7687b9327e$export$b8fe54a0788b746d);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $jyI49 = parcelRequire("jyI49");
var $kVcyu = parcelRequire("kVcyu");

var $cHWaM = parcelRequire("cHWaM");

var $icwVF = parcelRequire("icwVF");

var $e6Msm = parcelRequire("e6Msm");

var $j4n8g = parcelRequire("j4n8g");

var $dbxRO = parcelRequire("dbxRO");
var $301a9b7687b9327e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $301a9b7687b9327e$export$b8fe54a0788b746d extends (0, $dbxRO.Circle) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $301a9b7687b9327e$export$b8fe54a0788b746d.defaultStyleProps
        }, options));
    }
    parseOuterR() {
        const { size: size } = this.parsedAttributes;
        return Math.min(...(0, $e6Msm.parseSize)(size)) / 2;
    }
    parseInnerR() {
        const { innerR: innerR } = this.parsedAttributes;
        return (0, $kVcyu.default)(innerR) ? parseInt(innerR) / 100 * this.parseOuterR() : innerR;
    }
    drawDonutShape(attributes, container) {
        const { donuts: donuts } = attributes;
        if (!(donuts === null || donuts === void 0 ? void 0 : donuts.length)) return;
        const parsedDonuts = donuts.map((round)=>(0, $jyI49.default)(round) ? {
                value: round
            } : round);
        const style = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'donut');
        const colors = (0, $cHWaM.getPaletteColors)(attributes.donutPalette);
        if (!colors) return;
        const sum = parsedDonuts.reduce((acc, cur)=>{
            var _a;
            return acc + ((_a = cur.value) !== null && _a !== void 0 ? _a : 0);
        }, 0);
        const outerR = this.parseOuterR();
        const innerR = this.parseInnerR();
        let start = 0;
        parsedDonuts.forEach((round, index)=>{
            const { value: value = 0, color: color = colors[index % colors.length] } = round, roundStyle = $301a9b7687b9327e$var$__rest(round, [
                "value",
                "color"
            ]);
            const angle = (sum === 0 ? 1 / parsedDonuts.length : value / sum) * 360;
            this.upsert(`round${index}`, (0, $2eDEB.Path), Object.assign(Object.assign(Object.assign({}, style), {
                d: $301a9b7687b9327e$var$arc(outerR, innerR, start, start + angle),
                fill: color
            }), roundStyle), container);
            start += angle;
        });
    }
    render(attributes, container = this) {
        super.render(attributes, container);
        this.drawDonutShape(attributes, container);
    }
}
$301a9b7687b9327e$export$b8fe54a0788b746d.defaultStyleProps = {
    innerR: '50%',
    donuts: [],
    donutPalette: 'tableau'
};
const $301a9b7687b9327e$var$point = (x, y, r, angel)=>[
        x + Math.sin(angel) * r,
        y - Math.cos(angel) * r
    ];
const $301a9b7687b9327e$var$full = (x, y, R, r)=>{
    if (r <= 0 || R <= r) return [
        [
            'M',
            x - R,
            y
        ],
        [
            'A',
            R,
            R,
            0,
            1,
            1,
            x + R,
            y
        ],
        [
            'A',
            R,
            R,
            0,
            1,
            1,
            x - R,
            y
        ],
        [
            'Z'
        ]
    ];
    return [
        [
            'M',
            x - R,
            y
        ],
        [
            'A',
            R,
            R,
            0,
            1,
            1,
            x + R,
            y
        ],
        [
            'A',
            R,
            R,
            0,
            1,
            1,
            x - R,
            y
        ],
        [
            'Z'
        ],
        [
            'M',
            x + r,
            y
        ],
        [
            'A',
            r,
            r,
            0,
            1,
            0,
            x - r,
            y
        ],
        [
            'A',
            r,
            r,
            0,
            1,
            0,
            x + r,
            y
        ],
        [
            'Z'
        ]
    ];
};
const $301a9b7687b9327e$var$part = (x, y, R, r, start, end)=>{
    const [s, e] = [
        start / 360 * 2 * Math.PI,
        end / 360 * 2 * Math.PI
    ];
    const P = [
        $301a9b7687b9327e$var$point(x, y, r, s),
        $301a9b7687b9327e$var$point(x, y, R, s),
        $301a9b7687b9327e$var$point(x, y, R, e),
        $301a9b7687b9327e$var$point(x, y, r, e)
    ];
    const flag = e - s > Math.PI ? 1 : 0;
    return [
        [
            'M',
            P[0][0],
            P[0][1]
        ],
        [
            'L',
            P[1][0],
            P[1][1]
        ],
        [
            'A',
            R,
            R,
            0,
            flag,
            1,
            P[2][0],
            P[2][1]
        ],
        [
            'L',
            P[3][0],
            P[3][1]
        ],
        [
            'A',
            r,
            r,
            0,
            flag,
            0,
            P[0][0],
            P[0][1]
        ],
        [
            'Z'
        ]
    ];
};
const $301a9b7687b9327e$var$arc = (R = 0, r = 0, start, end)=>{
    const [x, y] = [
        0,
        0
    ];
    if (Math.abs(start - end) % 360 < 0.000001) return $301a9b7687b9327e$var$full(x, y, R, r);
    return $301a9b7687b9327e$var$part(x, y, R, r, start, end);
};

});

parcelRegister("hoxMw", function(module, exports) {

$parcel$export(module.exports, "Ellipse", () => $ca9ee1e3776d7534$export$80b0269ab108fa11);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $hXCXB = parcelRequire("hXCXB");

var $dnXls = parcelRequire("dnXls");

var $j4n8g = parcelRequire("j4n8g");

var $63haX = parcelRequire("63haX");
class $ca9ee1e3776d7534$export$80b0269ab108fa11 extends (0, $63haX.BaseNode) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $ca9ee1e3776d7534$export$80b0269ab108fa11.defaultStyleProps
        }, options));
    }
    drawKeyShape(attributes, container) {
        return this.upsert('key', (0, $2eDEB.Ellipse), this.getKeyStyle(attributes), container);
    }
    getKeyStyle(attributes) {
        const keyStyle = super.getKeyStyle(attributes);
        const [majorAxis, minorAxis] = this.getSize(attributes);
        return Object.assign(Object.assign({}, keyStyle), {
            rx: majorAxis / 2,
            ry: minorAxis / 2
        });
    }
    getIconStyle(attributes) {
        const style = super.getIconStyle(attributes);
        const { rx: rx, ry: ry } = this.getShape('key').attributes;
        const size = Math.min(+rx, +ry) * 2 * (0, $hXCXB.ICON_SIZE_RATIO);
        return style ? Object.assign({
            width: size,
            height: size
        }, style) : false;
    }
    getIntersectPoint(point, useExtendedLine = false) {
        const keyShapeBounds = this.getShape('key').getBounds();
        return (0, $dnXls.getEllipseIntersectPoint)(point, keyShapeBounds, useExtendedLine);
    }
}
$ca9ee1e3776d7534$export$80b0269ab108fa11.defaultStyleProps = {
    size: [
        45,
        35
    ]
};

});

parcelRegister("R3ntv", function(module, exports) {

$parcel$export(module.exports, "Hexagon", () => $09f792141d3fd897$export$b21e29e5a902cabf);

var $hXCXB = parcelRequire("hXCXB");

var $hn4z6 = parcelRequire("hn4z6");

var $jv6O2 = parcelRequire("jv6O2");
class $09f792141d3fd897$export$b21e29e5a902cabf extends (0, $jv6O2.Polygon) {
    constructor(options){
        super(options);
    }
    getOuterR(attributes) {
        return attributes.outerR || Math.min(...this.getSize(attributes)) / 2;
    }
    getPoints(attributes) {
        return (0, $hn4z6.getHexagonPoints)(this.getOuterR(attributes));
    }
    getIconStyle(attributes) {
        const style = super.getIconStyle(attributes);
        const size = this.getOuterR(attributes) * (0, $hXCXB.ICON_SIZE_RATIO);
        return style ? Object.assign({
            width: size,
            height: size
        }, style) : false;
    }
}

});

parcelRegister("bHEt9", function(module, exports) {

$parcel$export(module.exports, "HTML", () => $88531a361de08604$export$9dcd2b1ca4768128);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $ci3lc = parcelRequire("ci3lc");

var $geZBG = parcelRequire("geZBG");
var $aFcWQ = parcelRequire("aFcWQ");
var $cyCCc = parcelRequire("cyCCc");
var $5vprq = parcelRequire("5vprq");
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");

var $63haX = parcelRequire("63haX");
var $88531a361de08604$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $88531a361de08604$export$9dcd2b1ca4768128 extends (0, $63haX.BaseNode) {
    constructor(options){
        super(Object.assign(Object.assign({}, options), {
            style: Object.assign({}, $88531a361de08604$export$9dcd2b1ca4768128.defaultStyleProps, options.style)
        }));
        this.rootPointerEvent = new (0, $2eDEB.FederatedPointerEvent)(null);
        this.forwardEvents = (nativeEvent)=>{
            const canvas = this.context.canvas;
            const iCanvas = canvas.context.renderingContext.root.ownerDocument.defaultView;
            const normalizedEvents = this.normalizeToPointerEvent(nativeEvent, iCanvas);
            normalizedEvents.forEach((normalizedEvent)=>{
                const event = this.bootstrapEvent(this.rootPointerEvent, normalizedEvent, iCanvas, nativeEvent);
                // 当点击到 html 元素时，避免触发 pointerupoutside 事件
                // When clicking on the html element, avoid triggering the pointerupoutside event
                (0, $5vprq.default)(canvas.context.eventService, 'mappingTable.pointerupoutside', []);
                canvas.context.eventService.mapEvent(event);
            });
        };
    }
    get eventService() {
        return this.context.canvas.context.eventService;
    }
    get events() {
        return [
            (0, $9Iel2.CommonEvent).CLICK,
            (0, $9Iel2.CommonEvent).POINTER_DOWN,
            (0, $9Iel2.CommonEvent).POINTER_MOVE,
            (0, $9Iel2.CommonEvent).POINTER_UP,
            (0, $9Iel2.CommonEvent).POINTER_OVER,
            (0, $9Iel2.CommonEvent).POINTER_LEAVE
        ];
    }
    getDomElement() {
        return this.getShape('key').getDomElement();
    }
    /**
     * @override
     */ render(attributes = this.parsedAttributes, container = this) {
        this.drawKeyShape(attributes, container);
        this.drawPortShapes(attributes, container);
    }
    getKeyStyle(attributes) {
        const _a = (0, $cyCCc.default)(attributes, [
            'dx',
            'dy',
            'innerHTML',
            'pointerEvents',
            'cursor'
        ]), { dx: dx = 0, dy: dy = 0 } = _a, style = $88531a361de08604$var$__rest(_a, [
            "dx",
            "dy"
        ]);
        const [width, height] = this.getSize(attributes);
        return Object.assign(Object.assign({
            x: dx,
            y: dy
        }, style), {
            width: width,
            height: height
        });
    }
    drawKeyShape(attributes, container) {
        const style = this.getKeyStyle(attributes);
        const { x: x, y: y, width: width = 0, height: height = 0 } = style;
        const bounds = this.upsert('key-container', (0, $2eDEB.Rect), {
            x: x,
            y: y,
            width: width,
            height: height,
            opacity: 0
        }, container);
        return this.upsert('key', (0, $2eDEB.HTML), style, bounds);
    }
    connectedCallback() {
        // only enable in canvas renderer
        const renderer = this.context.canvas.getRenderer('main');
        const isCanvasRenderer = renderer instanceof (0, $ci3lc.Renderer);
        if (!isCanvasRenderer) return;
        const element = this.getDomElement();
        this.events.forEach((eventName)=>{
            // @ts-expect-error assert event is PointerEvent
            element.addEventListener(eventName, this.forwardEvents);
        });
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'zIndex' && oldValue !== newValue) this.getDomElement().style.zIndex = newValue;
    }
    destroy() {
        const element = this.getDomElement();
        this.events.forEach((eventName)=>{
            // @ts-expect-error assert event is PointerEvent
            element.removeEventListener(eventName, this.forwardEvents);
        });
        super.destroy();
    }
    normalizeToPointerEvent(event, canvas) {
        const normalizedEvents = [];
        if (canvas.isTouchEvent(event)) for(let i = 0; i < event.changedTouches.length; i++){
            const touch = event.changedTouches[i];
            // use changedTouches instead of touches since touchend has no touches
            // @see https://stackoverflow.com/a/10079076
            if ((0, $aFcWQ.default)(touch.button)) touch.button = 0;
            if ((0, $aFcWQ.default)(touch.buttons)) touch.buttons = 1;
            if ((0, $aFcWQ.default)(touch.isPrimary)) touch.isPrimary = event.touches.length === 1 && event.type === 'touchstart';
            if ((0, $aFcWQ.default)(touch.width)) touch.width = touch.radiusX || 1;
            if ((0, $aFcWQ.default)(touch.height)) touch.height = touch.radiusY || 1;
            if ((0, $aFcWQ.default)(touch.tiltX)) touch.tiltX = 0;
            if ((0, $aFcWQ.default)(touch.tiltY)) touch.tiltY = 0;
            if ((0, $aFcWQ.default)(touch.pointerType)) touch.pointerType = 'touch';
            // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Touch/identifier
            if ((0, $aFcWQ.default)(touch.pointerId)) touch.pointerId = touch.identifier || 0;
            if ((0, $aFcWQ.default)(touch.pressure)) touch.pressure = touch.force || 0.5;
            if ((0, $aFcWQ.default)(touch.twist)) touch.twist = 0;
            if ((0, $aFcWQ.default)(touch.tangentialPressure)) touch.tangentialPressure = 0;
            touch.isNormalized = true;
            touch.type = event.type;
            normalizedEvents.push(touch);
        }
        else if (canvas.isMouseEvent(event)) {
            const tempEvent = event;
            if ((0, $aFcWQ.default)(tempEvent.isPrimary)) tempEvent.isPrimary = true;
            if ((0, $aFcWQ.default)(tempEvent.width)) tempEvent.width = 1;
            if ((0, $aFcWQ.default)(tempEvent.height)) tempEvent.height = 1;
            if ((0, $aFcWQ.default)(tempEvent.tiltX)) tempEvent.tiltX = 0;
            if ((0, $aFcWQ.default)(tempEvent.tiltY)) tempEvent.tiltY = 0;
            if ((0, $aFcWQ.default)(tempEvent.pointerType)) tempEvent.pointerType = 'mouse';
            if ((0, $aFcWQ.default)(tempEvent.pointerId)) tempEvent.pointerId = 1;
            if ((0, $aFcWQ.default)(tempEvent.pressure)) tempEvent.pressure = 0.5;
            if ((0, $aFcWQ.default)(tempEvent.twist)) tempEvent.twist = 0;
            if ((0, $aFcWQ.default)(tempEvent.tangentialPressure)) tempEvent.tangentialPressure = 0;
            tempEvent.isNormalized = true;
            normalizedEvents.push(tempEvent);
        } else normalizedEvents.push(event);
        return normalizedEvents;
    }
    transferMouseData(event, nativeEvent) {
        event.isTrusted = nativeEvent.isTrusted;
        event.srcElement = nativeEvent.srcElement;
        event.timeStamp = performance.now();
        event.type = nativeEvent.type;
        event.altKey = nativeEvent.altKey;
        event.metaKey = nativeEvent.metaKey;
        event.shiftKey = nativeEvent.shiftKey;
        event.ctrlKey = nativeEvent.ctrlKey;
        event.button = nativeEvent.button;
        event.buttons = nativeEvent.buttons;
        event.client.x = nativeEvent.clientX;
        event.client.y = nativeEvent.clientY;
        event.movement.x = nativeEvent.movementX;
        event.movement.y = nativeEvent.movementY;
        event.page.x = nativeEvent.pageX;
        event.page.y = nativeEvent.pageY;
        event.screen.x = nativeEvent.screenX;
        event.screen.y = nativeEvent.screenY;
        event.relatedTarget = null;
    }
    bootstrapEvent(event, normalizedEvent, view, nativeEvent) {
        event.view = view;
        // @ts-ignore
        event.originalEvent = null;
        event.nativeEvent = nativeEvent;
        event.pointerId = normalizedEvent.pointerId;
        event.width = normalizedEvent.width;
        event.height = normalizedEvent.height;
        event.isPrimary = normalizedEvent.isPrimary;
        event.pointerType = normalizedEvent.pointerType;
        event.pressure = normalizedEvent.pressure;
        event.tangentialPressure = normalizedEvent.tangentialPressure;
        event.tiltX = normalizedEvent.tiltX;
        event.tiltY = normalizedEvent.tiltY;
        event.twist = normalizedEvent.twist;
        this.transferMouseData(event, normalizedEvent);
        const { x: x, y: y } = this.getViewportXY(normalizedEvent);
        event.viewport.x = x;
        event.viewport.y = y;
        const [canvasX, canvasY] = this.context.canvas.getCanvasByViewport([
            x,
            y
        ]);
        event.canvas.x = canvasX;
        event.canvas.y = canvasY;
        event.global.copyFrom(event.canvas);
        event.offset.copyFrom(event.canvas);
        event.isTrusted = nativeEvent.isTrusted;
        if (event.type === 'pointerleave') event.type = 'pointerout';
        return event;
    }
    getViewportXY(nativeEvent) {
        let x;
        let y;
        const { offsetX: offsetX, offsetY: offsetY, clientX: clientX, clientY: clientY } = nativeEvent;
        if (!(0, $geZBG.default)(offsetX) && !(0, $geZBG.default)(offsetY)) {
            x = offsetX;
            y = offsetY;
        } else {
            const point = this.eventService.client2Viewport({
                x: clientX,
                y: clientY
            });
            x = point.x;
            y = point.y;
        }
        return {
            x: x,
            y: y
        };
    }
    onframe() {
        super.onframe();
        // sync opacity
        const { opacity: opacity } = this.attributes;
        this.getDomElement().style.opacity = `${opacity}`;
    }
}
$88531a361de08604$export$9dcd2b1ca4768128.defaultStyleProps = {
    size: [
        160,
        80
    ],
    halo: false,
    icon: false,
    label: false,
    pointerEvents: 'auto'
};

});
parcelRegister("ci3lc", function(module, exports) {

$parcel$export(module.exports, "Renderer", () => $8f29c1ed1c035a85$export$88530751e3977073);
/*!
 * @antv/g-canvas
 * @description A renderer implemented by Canvas 2D API
 * @version 2.2.0
 * @date 12/24/2025, 11:55:53 AM
 * @author AntVis
 * @docs https://g.antv.antgroup.com/
 */ 
var $lR7jo = parcelRequire("lR7jo");

var $fu0YK = parcelRequire("fu0YK");

var $jLNr1 = parcelRequire("jLNr1");

var $f8wIT = parcelRequire("f8wIT");

var $2eDEB = parcelRequire("2eDEB");

var $g5Zhu = parcelRequire("g5Zhu");

var $cbdLd = parcelRequire("cbdLd");

var $02Ztr = parcelRequire("02Ztr");

var $i2oVb = parcelRequire("i2oVb");

var $khiUY = parcelRequire("khiUY");

var $3iqbd = parcelRequire("3iqbd");
var $eIStk = parcelRequire("eIStk");

var $2PAX5 = parcelRequire("2PAX5");
var $8hhuV = parcelRequire("8hhuV");
var $geZBG = parcelRequire("geZBG");
var $kVcyu = parcelRequire("kVcyu");

var $8QL5z = parcelRequire("8QL5z");

var $8HV7i = parcelRequire("8HV7i");

var $fOd0O = parcelRequire("fOd0O");

var $11s8J = parcelRequire("11s8J");
var $8f29c1ed1c035a85$var$_renderState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($khiUY)))("renderState");
/**
 * support 2 modes in rendering:
 * * immediate
 * * delayed: render at the end of frame with dirty-rectangle
 */ var $8f29c1ed1c035a85$var$CanvasRendererPlugin = /*#__PURE__*/ function() {
    function CanvasRendererPlugin(canvasRendererPluginOptions // private styleRendererFactory: Record<Shape, StyleRenderer>,
    ) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CanvasRendererPlugin);
        this.renderQueue = [];
        Object.defineProperty(this, $8f29c1ed1c035a85$var$_renderState, {
            writable: true,
            value: {
                restoreStack: [],
                prevObject: null,
                currentContext: new Map()
            }
        });
        this.clearFullScreenLastFrame = false;
        this.clearFullScreen = false;
        /**
     * view projection matrix
     */ this.vpMatrix = (0, $3iqbd).create();
        this.dprMatrix = (0, $3iqbd).create();
        this.tmpMat4 = (0, $3iqbd).create();
        this.vec3a = (0, $eIStk).create();
        this.vec3b = (0, $eIStk).create();
        this.vec3c = (0, $eIStk).create();
        this.vec3d = (0, $eIStk).create();
        this.canvasRendererPluginOptions = canvasRendererPluginOptions;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CanvasRendererPlugin, [
        {
            key: "apply",
            value: function apply(context, runtime) {
                var _this = this;
                this.context = context;
                var _this$context = this.context, config = _this$context.config, camera = _this$context.camera, renderingService = _this$context.renderingService, renderingContext = _this$context.renderingContext, pathGeneratorFactory = _this$context.pathGeneratorFactory;
                var enableRenderingOptimization = config.renderer.getConfig().enableRenderingOptimization;
                config.renderer.getConfig().enableDirtyCheck = false;
                config.renderer.getConfig().enableDirtyRectangleRendering = false;
                this.pathGeneratorFactory = pathGeneratorFactory;
                var contextService = context.contextService;
                var canvas = renderingContext.root.ownerDocument.defaultView;
                renderingService.hooks.init.tap(CanvasRendererPlugin.tag, function() {
                    // clear fullscreen
                    var dpr = contextService.getDPR();
                    var width = config.width, height = config.height;
                    var context = contextService.getContext();
                    _this.clearRect(context, 0, 0, width * dpr, height * dpr, config.background);
                });
                renderingService.hooks.destroy.tap(CanvasRendererPlugin.tag, function() {
                    _this.renderQueue = [];
                    (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(_this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState] = {
                        restoreStack: [],
                        prevObject: null,
                        currentContext: null
                    };
                });
                var beforeDraw = function beforeDraw() {
                    var _canvas$context$rende;
                    var context = contextService.getContext();
                    var dpr = contextService.getDPR();
                    var width = config.width, height = config.height;
                    var _this$canvasRendererP = _this.canvasRendererPluginOptions, dirtyObjectNumThreshold = _this$canvasRendererP.dirtyObjectNumThreshold, dirtyObjectRatioThreshold = _this$canvasRendererP.dirtyObjectRatioThreshold;
                    // some heuristic conditions such as 80% object changed
                    var _renderingService$get = renderingService.getStats(), total = _renderingService$get.total, rendered = _renderingService$get.rendered;
                    var ratio = rendered / total;
                    _this.clearFullScreen = _this.clearFullScreenLastFrame || // @ts-ignore
                    !((_canvas$context$rende = canvas.context.renderingPlugins[1]) !== null && _canvas$context$rende !== void 0 && _canvas$context$rende.isFirstTimeRenderingFinished) || renderingService.disableDirtyRectangleRendering() || rendered > dirtyObjectNumThreshold && ratio > dirtyObjectRatioThreshold;
                    if (!context) return;
                    if (typeof context.resetTransform === 'function') context.resetTransform();
                    else context.setTransform(1, 0, 0, 1, 0, 0);
                    if (_this.clearFullScreen) _this.clearRect(context, 0, 0, width * dpr, height * dpr, config.background);
                };
                /**
       * render objects by z-index
       *
       * - The level of the child node will be affected by the level of the parent node
       */ var renderByZIndex = function renderByZIndex(object, context) {
                    var stack = [
                        object
                    ];
                    while(stack.length > 0){
                        var _currentObject$sortab;
                        var currentObject = stack.pop();
                        if (currentObject.isVisible() && !currentObject.isCulled()) {
                            if (enableRenderingOptimization) _this.renderDisplayObjectOptimized(currentObject, context, _this.context, (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(_this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState], runtime);
                            else _this.renderDisplayObject(currentObject, context, _this.context, (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(_this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState], runtime);
                        }
                        var objects = ((_currentObject$sortab = currentObject.sortable) === null || _currentObject$sortab === void 0 || (_currentObject$sortab = _currentObject$sortab.sorted) === null || _currentObject$sortab === void 0 ? void 0 : _currentObject$sortab.length) > 0 ? currentObject.sortable.sorted : currentObject.childNodes;
                        // should account for z-index
                        for(var i = objects.length - 1; i >= 0; i--)stack.push(objects[i]);
                    }
                };
                // render at the end of frame
                renderingService.hooks.endFrame.tap(CanvasRendererPlugin.tag, function() {
                    beforeDraw();
                    // Skip rendering.
                    if (renderingContext.root.childNodes.length === 0) {
                        _this.clearFullScreenLastFrame = true;
                        return;
                    }
                    enableRenderingOptimization = config.renderer.getConfig().enableRenderingOptimization;
                    // init
                    (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(_this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState] = {
                        restoreStack: [],
                        prevObject: null,
                        currentContext: (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(_this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState].currentContext
                    };
                    (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(_this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState].currentContext.clear();
                    _this.clearFullScreenLastFrame = false;
                    var context = contextService.getContext();
                    // clear & clip dirty rectangle
                    var dpr = contextService.getDPR();
                    (0, $3iqbd).fromScaling(_this.dprMatrix, [
                        dpr,
                        dpr,
                        1
                    ]);
                    (0, $3iqbd).multiply(_this.vpMatrix, _this.dprMatrix, camera.getOrthoMatrix());
                    if (_this.clearFullScreen) {
                        // console.time('renderByZIndex');
                        if (enableRenderingOptimization) {
                            context.save();
                            renderByZIndex(renderingContext.root, context);
                            context.restore();
                        } else renderByZIndex(renderingContext.root, context);
                    } else {
                        // console.log('canvas renderer next...', this.renderQueue);
                        // merge removed AABB
                        var dirtyRenderBounds = _this.safeMergeAABB(_this.mergeDirtyAABBs(_this.renderQueue));
                        if ((0, $2eDEB.AABB).isEmpty(dirtyRenderBounds)) {
                            _this.renderQueue = [];
                            return;
                        }
                        var dirtyRect = _this.convertAABB2Rect(dirtyRenderBounds);
                        var x = dirtyRect.x, y = dirtyRect.y, width = dirtyRect.width, height = dirtyRect.height;
                        var tl = (0, $eIStk).transformMat4(_this.vec3a, [
                            x,
                            y,
                            0
                        ], _this.vpMatrix);
                        var tr = (0, $eIStk).transformMat4(_this.vec3b, [
                            x + width,
                            y,
                            0
                        ], _this.vpMatrix);
                        var bl = (0, $eIStk).transformMat4(_this.vec3c, [
                            x,
                            y + height,
                            0
                        ], _this.vpMatrix);
                        var br = (0, $eIStk).transformMat4(_this.vec3d, [
                            x + width,
                            y + height,
                            0
                        ], _this.vpMatrix);
                        var minx = Math.min(tl[0], tr[0], br[0], bl[0]);
                        var miny = Math.min(tl[1], tr[1], br[1], bl[1]);
                        var maxx = Math.max(tl[0], tr[0], br[0], bl[0]);
                        var maxy = Math.max(tl[1], tr[1], br[1], bl[1]);
                        var ix = Math.floor(minx);
                        var iy = Math.floor(miny);
                        var iwidth = Math.ceil(maxx - minx);
                        var iheight = Math.ceil(maxy - miny);
                        context.save();
                        _this.clearRect(context, ix, iy, iwidth, iheight, config.background);
                        context.beginPath();
                        context.rect(ix, iy, iwidth, iheight);
                        context.clip();
                        // @see https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Transformations
                        context.setTransform(_this.vpMatrix[0], _this.vpMatrix[1], _this.vpMatrix[4], _this.vpMatrix[5], _this.vpMatrix[12], _this.vpMatrix[13]);
                        // draw dirty rectangle
                        var _config$renderer$getC = config.renderer.getConfig(), enableDirtyRectangleRenderingDebug = _config$renderer$getC.enableDirtyRectangleRenderingDebug;
                        if (enableDirtyRectangleRenderingDebug) canvas.dispatchEvent(new (0, $2eDEB.CustomEvent)((0, $2eDEB.CanvasEvent).DIRTY_RECTANGLE, {
                            dirtyRect: {
                                x: ix,
                                y: iy,
                                width: iwidth,
                                height: iheight
                            }
                        }));
                        // search objects intersect with dirty rectangle
                        var _dirtyRenderBounds$ge = dirtyRenderBounds.getMin(), _dirtyRenderBounds$ge2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_dirtyRenderBounds$ge, 2), minX = _dirtyRenderBounds$ge2[0], minY = _dirtyRenderBounds$ge2[1];
                        var _dirtyRenderBounds$ge3 = dirtyRenderBounds.getMax(), _dirtyRenderBounds$ge4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_dirtyRenderBounds$ge3, 2), maxX = _dirtyRenderBounds$ge4[0], maxY = _dirtyRenderBounds$ge4[1];
                        var dirtyObjects = renderingContext.root.ownerDocument.elementsFromBBox(minX, minY, maxX, maxY);
                        // do rendering
                        dirtyObjects// sort by z-index
                        .sort(function(a, b) {
                            return a.sortable.renderOrder - b.sortable.renderOrder;
                        }).forEach(function(object) {
                            // culled object should not be rendered
                            if (object && object.isVisible() && !object.isCulled()) _this.renderDisplayObject(object, context, _this.context, (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(_this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState], runtime);
                        });
                        context.restore();
                        // save dirty AABBs in last frame
                        _this.renderQueue.forEach(function(object) {
                            _this.saveDirtyAABB(object);
                        });
                        // clear queue
                        _this.renderQueue = [];
                    }
                    // pop restore stack, eg. root -> parent -> child
                    (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(_this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState].restoreStack.forEach(function() {
                        context.restore();
                    });
                    // clear restore stack
                    (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(_this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState].restoreStack = [];
                });
                renderingService.hooks.render.tap(CanvasRendererPlugin.tag, function(object) {
                    if (!_this.clearFullScreen) // render at the end of frame
                    _this.renderQueue.push(object);
                });
            }
        },
        {
            key: "clearRect",
            value: function clearRect(context, x, y, width, height, background) {
                // clearRect is faster than fillRect @see https://stackoverflow.com/a/30830253
                context.clearRect(x, y, width, height);
                if (background) {
                    context.fillStyle = background;
                    context.fillRect(x, y, width, height);
                }
            }
        },
        {
            key: "renderDisplayObjectOptimized",
            value: function renderDisplayObjectOptimized(object, context, canvasContext, renderState, runtime) {
                var nodeName = object.nodeName;
                var updateTransform = false;
                var clipDraw = false;
                // @ts-ignore
                var styleRenderer = this.context.styleRendererFactory[nodeName];
                var generatePath = this.pathGeneratorFactory[nodeName];
                // clip path
                var clipPath = object.parsedStyle.clipPath;
                if (clipPath) {
                    updateTransform = !renderState.prevObject || !(0, $3iqbd).exactEquals(clipPath.getWorldTransform(), renderState.prevObject.getWorldTransform());
                    if (updateTransform) {
                        this.applyWorldTransform(context, clipPath);
                        renderState.prevObject = null;
                    }
                    // generate path in local space
                    var _generatePath = this.pathGeneratorFactory[clipPath.nodeName];
                    if (_generatePath) {
                        context.save();
                        clipDraw = true;
                        context.beginPath();
                        _generatePath(context, clipPath.parsedStyle);
                        context.closePath();
                        context.clip();
                    }
                }
                // fill & stroke
                if (styleRenderer) {
                    updateTransform = !renderState.prevObject || !(0, $3iqbd).exactEquals(object.getWorldTransform(), renderState.prevObject.getWorldTransform());
                    if (updateTransform) this.applyWorldTransform(context, object);
                    var forceUpdateStyle = !renderState.prevObject;
                    if (!forceUpdateStyle) {
                        var prevNodeName = renderState.prevObject.nodeName;
                        if (nodeName === (0, $2eDEB.Shape).TEXT) forceUpdateStyle = prevNodeName !== (0, $2eDEB.Shape).TEXT;
                        else if (nodeName === (0, $2eDEB.Shape).IMAGE) forceUpdateStyle = prevNodeName !== (0, $2eDEB.Shape).IMAGE;
                        else forceUpdateStyle = prevNodeName === (0, $2eDEB.Shape).TEXT || prevNodeName === (0, $2eDEB.Shape).IMAGE;
                    }
                    styleRenderer.applyStyleToContext(context, object, forceUpdateStyle, renderState);
                    renderState.prevObject = object;
                }
                if (generatePath) {
                    context.beginPath();
                    generatePath(context, object.parsedStyle);
                    if (nodeName !== (0, $2eDEB.Shape).LINE && nodeName !== (0, $2eDEB.Shape).PATH && nodeName !== (0, $2eDEB.Shape).POLYLINE) context.closePath();
                }
                // fill & stroke
                if (styleRenderer) styleRenderer.drawToContext(context, object, (0, (/*@__PURE__*/$parcel$interopDefault($i2oVb)))(this, $8f29c1ed1c035a85$var$_renderState)[$8f29c1ed1c035a85$var$_renderState], this, runtime);
                if (clipDraw) context.restore();
                // finish rendering, clear dirty flag
                object.dirty(false);
            }
        },
        {
            key: "renderDisplayObject",
            value: function renderDisplayObject(object, context, canvasContext, renderState, runtime) {
                var nodeName = object.nodeName;
                // restore to its ancestor
                var parent = renderState.restoreStack[renderState.restoreStack.length - 1];
                if (parent && !(object.compareDocumentPosition(parent) & (0, $2eDEB.Node).DOCUMENT_POSITION_CONTAINS)) {
                    context.restore();
                    renderState.restoreStack.pop();
                }
                // @ts-ignore
                var styleRenderer = this.context.styleRendererFactory[nodeName];
                var generatePath = this.pathGeneratorFactory[nodeName];
                // clip path
                var clipPath = object.parsedStyle.clipPath;
                if (clipPath) {
                    this.applyWorldTransform(context, clipPath);
                    // generate path in local space
                    var _generatePath2 = this.pathGeneratorFactory[clipPath.nodeName];
                    if (_generatePath2) {
                        context.save();
                        // save clip
                        renderState.restoreStack.push(object);
                        context.beginPath();
                        _generatePath2(context, clipPath.parsedStyle);
                        context.closePath();
                        context.clip();
                    }
                }
                // fill & stroke
                if (styleRenderer) {
                    this.applyWorldTransform(context, object);
                    context.save();
                    // apply attributes to context
                    this.applyAttributesToContext(context, object);
                }
                if (generatePath) {
                    context.beginPath();
                    generatePath(context, object.parsedStyle);
                    if (nodeName !== (0, $2eDEB.Shape).LINE && nodeName !== (0, $2eDEB.Shape).PATH && nodeName !== (0, $2eDEB.Shape).POLYLINE) context.closePath();
                }
                // fill & stroke
                if (styleRenderer) {
                    styleRenderer.render(context, object.parsedStyle, object, canvasContext, this, runtime);
                    // restore applied attributes, eg. shadowBlur shadowColor...
                    context.restore();
                }
                // finish rendering, clear dirty flag
                object.dirty(false);
            }
        },
        {
            key: "applyAttributesToContext",
            value: function applyAttributesToContext(context, object) {
                var _ref = object.parsedStyle, stroke = _ref.stroke, fill = _ref.fill, opacity = _ref.opacity, lineDash = _ref.lineDash, lineDashOffset = _ref.lineDashOffset;
                // @see https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/setLineDash
                if (lineDash) context.setLineDash(lineDash);
                // @see https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/lineDashOffset
                if (!(0, $geZBG.default)(lineDashOffset)) context.lineDashOffset = lineDashOffset;
                if (!(0, $geZBG.default)(opacity)) context.globalAlpha *= opacity;
                if (!(0, $geZBG.default)(stroke) && !Array.isArray(stroke) && !stroke.isNone) context.strokeStyle = object.attributes.stroke;
                if (!(0, $geZBG.default)(fill) && !Array.isArray(fill) && !fill.isNone) context.fillStyle = object.attributes.fill;
            }
        },
        {
            key: "convertAABB2Rect",
            value: function convertAABB2Rect(aabb) {
                var min = aabb.getMin();
                var max = aabb.getMax();
                // expand the rectangle a bit to avoid artifacts
                // @see https://www.yuque.com/antv/ou292n/bi8nix#ExvCu
                var minX = Math.floor(min[0]);
                var minY = Math.floor(min[1]);
                var maxX = Math.ceil(max[0]);
                var maxY = Math.ceil(max[1]);
                var width = maxX - minX;
                var height = maxY - minY;
                return {
                    x: minX,
                    y: minY,
                    width: width,
                    height: height
                };
            }
        },
        {
            key: "mergeDirtyAABBs",
            value: function mergeDirtyAABBs(dirtyObjects) {
                // merge into a big AABB
                // TODO: skip descendant if ancestor is caculated, but compareNodePosition is really slow
                var aabb = new (0, $2eDEB.AABB)();
                dirtyObjects.forEach(function(object) {
                    var renderBounds = object.getRenderBounds();
                    aabb.add(renderBounds);
                    var dirtyRenderBounds = object.renderable.dirtyRenderBounds;
                    if (dirtyRenderBounds) aabb.add(dirtyRenderBounds);
                });
                return aabb;
            }
        },
        {
            key: "saveDirtyAABB",
            value: function saveDirtyAABB(object) {
                var renderable = object.renderable;
                if (!renderable.dirtyRenderBounds) renderable.dirtyRenderBounds = new (0, $2eDEB.AABB)();
                var renderBounds = object.getRenderBounds();
                if (renderBounds) // save last dirty aabb
                renderable.dirtyRenderBounds.update(renderBounds.center, renderBounds.halfExtents);
            }
        },
        {
            key: "applyWorldTransform",
            value: function applyWorldTransform(context, object, matrix) {
                // apply clip shape's RTS
                if (matrix) {
                    (0, $3iqbd).copy(this.tmpMat4, object.getLocalTransform());
                    (0, $3iqbd).multiply(this.tmpMat4, matrix, this.tmpMat4);
                    (0, $3iqbd).multiply(this.tmpMat4, this.vpMatrix, this.tmpMat4);
                } else {
                    // apply RTS transformation in world space
                    (0, $3iqbd).copy(this.tmpMat4, object.getWorldTransform());
                    (0, $3iqbd).multiply(this.tmpMat4, this.vpMatrix, this.tmpMat4);
                }
                // @see https://developer.mozilla.org/en-US/docs/Web/API/Canvas_API/Tutorial/Transformations
                context.setTransform(this.tmpMat4[0], this.tmpMat4[1], this.tmpMat4[4], this.tmpMat4[5], this.tmpMat4[12], this.tmpMat4[13]);
            }
        },
        {
            key: "safeMergeAABB",
            value: function safeMergeAABB() {
                var merged = new (0, $2eDEB.AABB)();
                for(var _len = arguments.length, aabbs = new Array(_len), _key = 0; _key < _len; _key++)aabbs[_key] = arguments[_key];
                aabbs.forEach(function(aabb) {
                    merged.add(aabb);
                });
                return merged;
            }
        }
    ]);
}();
$8f29c1ed1c035a85$var$CanvasRendererPlugin.tag = 'CanvasRenderer';
function $8f29c1ed1c035a85$var$getPattern(pattern, object, context, canvasContext, plugin, runtime, imagePool) {
    var $offscreenCanvas;
    var dpr;
    if (pattern.image.nodeName === 'rect') {
        var _parsedStyle = pattern.image.parsedStyle, width = _parsedStyle.width, height = _parsedStyle.height;
        dpr = canvasContext.contextService.getDPR();
        var offscreenCanvas = canvasContext.config.offscreenCanvas;
        $offscreenCanvas = runtime.offscreenCanvasCreator.getOrCreateCanvas(offscreenCanvas);
        $offscreenCanvas.width = width * dpr;
        $offscreenCanvas.height = height * dpr;
        var offscreenCanvasContext = runtime.offscreenCanvasCreator.getOrCreateContext(offscreenCanvas);
        var renderState = {
            restoreStack: [],
            prevObject: null,
            currentContext: new Map()
        };
        // offscreenCanvasContext.scale(1 / dpr, 1 / dpr);
        pattern.image.forEach(function(object) {
            plugin.renderDisplayObject(object, offscreenCanvasContext, canvasContext, renderState, runtime);
        });
        renderState.restoreStack.forEach(function() {
            offscreenCanvasContext.restore();
        });
    }
    var canvasPattern = imagePool.getOrCreatePatternSync(object, pattern, context, $offscreenCanvas, dpr, object.getGeometryBounds().min, function() {
        // set dirty rectangle flag
        object.dirty();
        canvasContext.renderingService.dirty();
    });
    return canvasPattern;
}
function $8f29c1ed1c035a85$var$getColor(parsedColor, object, context, imagePool) {
    var color;
    if (parsedColor.type === (0, $2eDEB.GradientType).LinearGradient || parsedColor.type === (0, $2eDEB.GradientType).RadialGradient) {
        var bounds = object.getGeometryBounds();
        var width = bounds && bounds.halfExtents[0] * 2 || 1;
        var height = bounds && bounds.halfExtents[1] * 2 || 1;
        var min = bounds && bounds.min || [
            0,
            0
        ];
        color = imagePool.getOrCreateGradient((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
            type: parsedColor.type
        }, parsedColor.value), {}, {
            min: min,
            width: width,
            height: height
        }), context);
    }
    return color;
}
var $8f29c1ed1c035a85$var$SHADOW_NUMBER_STYLE = [
    'shadowBlur',
    'shadowOffsetX',
    'shadowOffsetY'
];
var $8f29c1ed1c035a85$var$STROKE_STYLE = [
    'lineCap',
    'lineJoin',
    'miterLimit'
];
var $8f29c1ed1c035a85$var$DEFAULT_STYLE = {
    // common
    globalAlpha: 1,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    shadowColor: '#000',
    filter: 'none',
    globalCompositeOperation: 'source-over',
    // stroke/fill
    strokeStyle: '#000',
    strokeOpacity: 1,
    lineWidth: 1,
    lineDash: [],
    lineDashOffset: 0,
    lineCap: 'butt',
    lineJoin: 'miter',
    miterLimit: 10,
    fillStyle: '#000',
    fillOpacity: 1
};
var $8f29c1ed1c035a85$var$defaultParsedStyle = {};
/**
 * Updating the canvas context is an expensive operation. The state of the context is cached and the actual update operation is performed only when the cache is not hit.
 *
 * In any case, the previous value is returned, which is convenient for temporarily updating the context and restoring it later.
 */ function $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, key, value, cache) {
    var prevValue = cache.has(key) ? cache.get(key) : $8f29c1ed1c035a85$var$DEFAULT_STYLE[key];
    if (prevValue !== value) {
        // console.log('not hit cache', key, value, prevValue, cache);
        if (key === 'lineDash') context.setLineDash(value);
        else // @ts-ignore
        context[key] = value;
        cache.set(key, value);
    }
    return prevValue;
}
var $8f29c1ed1c035a85$var$OptimizedDefaultRenderer = /*#__PURE__*/ function() {
    function OptimizedDefaultRenderer(imagePool) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, OptimizedDefaultRenderer);
        this.imagePool = imagePool;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(OptimizedDefaultRenderer, [
        {
            key: "applyAttributesToContext",
            value: function applyAttributesToContext(context, object) {}
        },
        {
            key: "render",
            value: function render(context, parsedStyle, object, canvasContext, plugin, runtime) {}
        },
        {
            key: "applyCommonStyleToContext",
            value: function applyCommonStyleToContext(context, object, forceUpdate, renderState) {
                // const dpr = object.ownerDocument.defaultView.getContextService().getDPR();
                var prevStyle = forceUpdate ? $8f29c1ed1c035a85$var$defaultParsedStyle : renderState.prevObject.parsedStyle;
                var style = object.parsedStyle;
                if (forceUpdate || style.opacity !== prevStyle.opacity) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'globalAlpha', !(0, $geZBG.default)(style.opacity) ? style.opacity : $8f29c1ed1c035a85$var$DEFAULT_STYLE.globalAlpha, renderState.currentContext);
                // TODO blend prop
                // @ts-ignore
                if (forceUpdate || style.blend !== prevStyle.blend) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'globalCompositeOperation', // @ts-ignore
                !(0, $geZBG.default)(style.blend) ? // @ts-ignore
                style.blend : $8f29c1ed1c035a85$var$DEFAULT_STYLE.globalCompositeOperation, renderState.currentContext);
            }
        },
        {
            key: "applyStrokeFillStyleToContext",
            value: function applyStrokeFillStyleToContext(context, object, forceUpdate, renderState) {
                var prevStyle = forceUpdate ? $8f29c1ed1c035a85$var$defaultParsedStyle : renderState.prevObject.parsedStyle;
                var style = object.parsedStyle;
                var _style$lineWidth = style.lineWidth, lineWidth = _style$lineWidth === void 0 ? $8f29c1ed1c035a85$var$DEFAULT_STYLE.lineWidth : _style$lineWidth;
                var hasFill = style.fill && !style.fill.isNone;
                var hasStroke = style.stroke && !style.stroke.isNone && lineWidth > 0;
                if (hasStroke) {
                    if (forceUpdate || object.attributes.stroke !== renderState.prevObject.attributes.stroke) {
                        var value = !(0, $geZBG.default)(style.stroke) && !Array.isArray(style.stroke) && !style.stroke.isNone ? object.attributes.stroke : $8f29c1ed1c035a85$var$DEFAULT_STYLE.strokeStyle;
                        $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'strokeStyle', value, renderState.currentContext);
                    }
                    if (forceUpdate || style.lineWidth !== prevStyle.lineWidth) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'lineWidth', !(0, $geZBG.default)(style.lineWidth) ? style.lineWidth : $8f29c1ed1c035a85$var$DEFAULT_STYLE.lineWidth, renderState.currentContext);
                    if (forceUpdate || style.lineDash !== prevStyle.lineDash) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'lineDash', style.lineDash || $8f29c1ed1c035a85$var$DEFAULT_STYLE.lineDash, renderState.currentContext);
                    if (forceUpdate || style.lineDashOffset !== prevStyle.lineDashOffset) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'lineDashOffset', !(0, $geZBG.default)(style.lineDashOffset) ? style.lineDashOffset : $8f29c1ed1c035a85$var$DEFAULT_STYLE.lineDashOffset, renderState.currentContext);
                    for(var i = 0; i < $8f29c1ed1c035a85$var$STROKE_STYLE.length; i++){
                        var styleName = $8f29c1ed1c035a85$var$STROKE_STYLE[i];
                        if (forceUpdate || style[styleName] !== prevStyle[styleName]) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, styleName, !(0, $geZBG.default)(style[styleName]) ? style[styleName] : $8f29c1ed1c035a85$var$DEFAULT_STYLE[styleName], renderState.currentContext);
                    }
                }
                if (hasFill && (forceUpdate || object.attributes.fill !== renderState.prevObject.attributes.fill)) {
                    var _value = !(0, $geZBG.default)(style.fill) && !Array.isArray(style.fill) && !style.fill.isNone ? object.attributes.fill : $8f29c1ed1c035a85$var$DEFAULT_STYLE.fillStyle;
                    $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'fillStyle', _value, renderState.currentContext);
                }
            }
        },
        {
            key: "applyStyleToContext",
            value: function applyStyleToContext(context, object, forceUpdate, renderState) {
                var nodeName = object.nodeName;
                this.applyCommonStyleToContext(context, object, forceUpdate, renderState);
                if (nodeName === (0, $2eDEB.Shape).IMAGE) ;
                else this.applyStrokeFillStyleToContext(context, object, forceUpdate, renderState);
            }
        },
        {
            key: "applyShadowAndFilterStyleToContext",
            value: function applyShadowAndFilterStyleToContext(context, object, hasShadow, renderState) {
                var style = object.parsedStyle;
                if (hasShadow) {
                    $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'shadowColor', style.shadowColor.toString(), renderState.currentContext);
                    for(var i = 0; i < $8f29c1ed1c035a85$var$SHADOW_NUMBER_STYLE.length; i++){
                        var styleName = $8f29c1ed1c035a85$var$SHADOW_NUMBER_STYLE[i];
                        $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, styleName, style[styleName] || $8f29c1ed1c035a85$var$DEFAULT_STYLE[styleName], renderState.currentContext);
                    }
                }
                if (style.filter && style.filter.length) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'filter', // use raw filter string
                object.attributes.filter, renderState.currentContext);
            }
        },
        {
            key: "clearShadowAndFilterStyleForContext",
            value: function clearShadowAndFilterStyleForContext(context, hasShadow, hasFilter, renderState) {
                var onlyClearShadowFilter = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                if (hasShadow) {
                    $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'shadowColor', $8f29c1ed1c035a85$var$DEFAULT_STYLE.shadowColor, renderState.currentContext);
                    for(var i = 0; i < $8f29c1ed1c035a85$var$SHADOW_NUMBER_STYLE.length; i++){
                        var styleName = $8f29c1ed1c035a85$var$SHADOW_NUMBER_STYLE[i];
                        $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, styleName, $8f29c1ed1c035a85$var$DEFAULT_STYLE[styleName], renderState.currentContext);
                    }
                }
                if (hasFilter) {
                    if (hasShadow && onlyClearShadowFilter) {
                        // save drop-shadow filter
                        var oldFilter = context.filter;
                        if (!(0, $geZBG.default)(oldFilter) && oldFilter.indexOf('drop-shadow') > -1) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'filter', oldFilter.replace(/drop-shadow\([^)]*\)/, '').trim() || $8f29c1ed1c035a85$var$DEFAULT_STYLE.filter, renderState.currentContext);
                    } else $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'filter', $8f29c1ed1c035a85$var$DEFAULT_STYLE.filter, renderState.currentContext);
                }
            }
        },
        {
            key: "fillToContext",
            value: function fillToContext(context, object, renderState, plugin, runtime) {
                var _this = this;
                var _object$parsedStyle = object.parsedStyle, fill = _object$parsedStyle.fill, fillRule = _object$parsedStyle.fillRule;
                var resetStyle = null;
                if (Array.isArray(fill) && fill.length > 0) fill.forEach(function(gradient) {
                    var prevStyle = $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'fillStyle', $8f29c1ed1c035a85$var$getColor(gradient, object, context, _this.imagePool), renderState.currentContext);
                    resetStyle = resetStyle !== null && resetStyle !== void 0 ? resetStyle : prevStyle;
                    if (fillRule) context.fill(fillRule);
                    else context.fill();
                });
                else {
                    if ((0, $2eDEB.isPattern)(fill)) {
                        var pattern = $8f29c1ed1c035a85$var$getPattern(fill, object, context, object.ownerDocument.defaultView.context, plugin, runtime, this.imagePool);
                        if (pattern) {
                            context.fillStyle = pattern;
                            resetStyle = true;
                        }
                    }
                    if (fillRule) context.fill(fillRule);
                    else context.fill();
                }
                if (resetStyle !== null) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'fillStyle', resetStyle, renderState.currentContext);
            }
        },
        {
            key: "strokeToContext",
            value: function strokeToContext(context, object, renderState, plugin, runtime) {
                var _this2 = this;
                var stroke = object.parsedStyle.stroke;
                var resetStyle = null;
                if (Array.isArray(stroke) && stroke.length > 0) stroke.forEach(function(gradient) {
                    var prevStyle = $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'strokeStyle', $8f29c1ed1c035a85$var$getColor(gradient, object, context, _this2.imagePool), renderState.currentContext);
                    resetStyle = resetStyle !== null && resetStyle !== void 0 ? resetStyle : prevStyle;
                    context.stroke();
                });
                else {
                    if ((0, $2eDEB.isPattern)(stroke)) {
                        var pattern = $8f29c1ed1c035a85$var$getPattern(stroke, object, context, object.ownerDocument.defaultView.context, plugin, runtime, this.imagePool);
                        if (pattern) {
                            var prevStyle = $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'strokeStyle', pattern, renderState.currentContext);
                            resetStyle = resetStyle !== null && resetStyle !== void 0 ? resetStyle : prevStyle;
                        }
                    }
                    context.stroke();
                }
                if (resetStyle !== null) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'strokeStyle', resetStyle, renderState.currentContext);
            }
        },
        {
            key: "drawToContext",
            value: function drawToContext(context, object, renderState, plugin, runtime) {
                var _style$fill;
                var nodeName = object.nodeName;
                var style = object.parsedStyle;
                var _style$opacity = style.opacity, opacity = _style$opacity === void 0 ? $8f29c1ed1c035a85$var$DEFAULT_STYLE.globalAlpha : _style$opacity, _style$fillOpacity = style.fillOpacity, fillOpacity = _style$fillOpacity === void 0 ? $8f29c1ed1c035a85$var$DEFAULT_STYLE.fillOpacity : _style$fillOpacity, _style$strokeOpacity = style.strokeOpacity, strokeOpacity = _style$strokeOpacity === void 0 ? $8f29c1ed1c035a85$var$DEFAULT_STYLE.strokeOpacity : _style$strokeOpacity, _style$lineWidth2 = style.lineWidth, lineWidth = _style$lineWidth2 === void 0 ? $8f29c1ed1c035a85$var$DEFAULT_STYLE.lineWidth : _style$lineWidth2;
                var hasFill = style.fill && !style.fill.isNone;
                var hasStroke = style.stroke && !style.stroke.isNone && lineWidth > 0;
                if (!hasFill && !hasStroke) return;
                var hasShadow = !(0, $geZBG.default)(style.shadowColor) && style.shadowBlur > 0;
                var isInnerShadow = style.shadowType === 'inner';
                var isFillTransparent = ((_style$fill = style.fill) === null || _style$fill === void 0 ? void 0 : _style$fill.alpha) === 0;
                var hasFilter = !!(style.filter && style.filter.length);
                // Shadows can only be applied to fill() or stroke(), the default is fill()
                var shouldDrawShadowWithStroke = hasShadow && hasStroke && (nodeName === (0, $2eDEB.Shape).PATH || nodeName === (0, $2eDEB.Shape).LINE || nodeName === (0, $2eDEB.Shape).POLYLINE || isFillTransparent || isInnerShadow);
                // TODO https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/paint-order
                var originGlobalAlpha = null;
                if (hasFill) {
                    if (!shouldDrawShadowWithStroke) this.applyShadowAndFilterStyleToContext(context, object, hasShadow, renderState);
                    var updateOpacity = opacity * fillOpacity;
                    originGlobalAlpha = $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'globalAlpha', updateOpacity, renderState.currentContext);
                    this.fillToContext(context, object, renderState, plugin, runtime);
                    if (!shouldDrawShadowWithStroke) this.clearShadowAndFilterStyleForContext(context, hasShadow, hasFilter, renderState);
                }
                if (hasStroke) {
                    var clearShadowAndFilter = false;
                    var _updateOpacity = opacity * strokeOpacity;
                    var prevOpacity = $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'globalAlpha', _updateOpacity, renderState.currentContext);
                    originGlobalAlpha = hasFill ? originGlobalAlpha : prevOpacity;
                    if (shouldDrawShadowWithStroke) {
                        this.applyShadowAndFilterStyleToContext(context, object, hasShadow, renderState);
                        clearShadowAndFilter = true;
                        if (isInnerShadow) {
                            var originBlend = context.globalCompositeOperation;
                            context.globalCompositeOperation = 'source-atop';
                            this.strokeToContext(context, object, renderState, plugin, runtime);
                            context.globalCompositeOperation = originBlend;
                            this.clearShadowAndFilterStyleForContext(context, hasShadow, hasFilter, renderState, true);
                        }
                    }
                    this.strokeToContext(context, object, renderState, plugin, runtime);
                    if (clearShadowAndFilter) this.clearShadowAndFilterStyleForContext(context, hasShadow, hasFilter, renderState);
                }
                // clear
                if (originGlobalAlpha !== null) $8f29c1ed1c035a85$var$updateContextIfNotHitCache(context, 'globalAlpha', originGlobalAlpha, renderState.currentContext);
            }
        }
    ]);
}();
var $8f29c1ed1c035a85$var$DefaultRenderer = /*#__PURE__*/ function(_OptimizedDefaultRend) {
    function DefaultRenderer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DefaultRenderer);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, DefaultRenderer, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(DefaultRenderer, _OptimizedDefaultRend);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DefaultRenderer, [
        {
            key: "render",
            value: function render(context, parsedStyle, object, canvasContext, plugin, runtime) {
                var fill = parsedStyle.fill, fillRule = parsedStyle.fillRule, _parsedStyle$opacity = parsedStyle.opacity, opacity = _parsedStyle$opacity === void 0 ? 1 : _parsedStyle$opacity, _parsedStyle$fillOpac = parsedStyle.fillOpacity, fillOpacity = _parsedStyle$fillOpac === void 0 ? 1 : _parsedStyle$fillOpac, stroke = parsedStyle.stroke, _parsedStyle$strokeOp = parsedStyle.strokeOpacity, strokeOpacity = _parsedStyle$strokeOp === void 0 ? 1 : _parsedStyle$strokeOp, _parsedStyle$lineWidt = parsedStyle.lineWidth, lineWidth = _parsedStyle$lineWidt === void 0 ? 1 : _parsedStyle$lineWidt, lineCap = parsedStyle.lineCap, lineJoin = parsedStyle.lineJoin, shadowType = parsedStyle.shadowType, shadowColor = parsedStyle.shadowColor, shadowBlur = parsedStyle.shadowBlur, filter = parsedStyle.filter, miterLimit = parsedStyle.miterLimit;
                var hasFill = fill && !fill.isNone;
                var hasStroke = stroke && !stroke.isNone && lineWidth > 0;
                var isFillTransparent = (fill === null || fill === void 0 ? void 0 : fill.alpha) === 0;
                var hasFilter = !!(filter && filter.length);
                var hasShadow = !(0, $geZBG.default)(shadowColor) && shadowBlur > 0;
                var nodeName = object.nodeName;
                var isInnerShadow = shadowType === 'inner';
                var shouldDrawShadowWithStroke = hasStroke && hasShadow && (nodeName === (0, $2eDEB.Shape).PATH || nodeName === (0, $2eDEB.Shape).LINE || nodeName === (0, $2eDEB.Shape).POLYLINE || isFillTransparent || isInnerShadow);
                if (hasFill) {
                    context.globalAlpha = opacity * fillOpacity;
                    if (!shouldDrawShadowWithStroke) $8f29c1ed1c035a85$var$setShadowAndFilter(object, context, hasShadow);
                    $8f29c1ed1c035a85$var$applyFill(context, object, fill, fillRule, canvasContext, plugin, runtime, this.imagePool);
                    if (!shouldDrawShadowWithStroke) this.clearShadowAndFilter(context, hasFilter, hasShadow);
                }
                if (hasStroke) {
                    context.globalAlpha = opacity * strokeOpacity;
                    context.lineWidth = lineWidth;
                    if (!(0, $geZBG.default)(miterLimit)) context.miterLimit = miterLimit;
                    if (!(0, $geZBG.default)(lineCap)) context.lineCap = lineCap;
                    if (!(0, $geZBG.default)(lineJoin)) context.lineJoin = lineJoin;
                    if (shouldDrawShadowWithStroke) {
                        if (isInnerShadow) context.globalCompositeOperation = 'source-atop';
                        $8f29c1ed1c035a85$var$setShadowAndFilter(object, context, true);
                        if (isInnerShadow) {
                            $8f29c1ed1c035a85$var$applyStroke(context, object, stroke, canvasContext, plugin, runtime, this.imagePool);
                            context.globalCompositeOperation = $8f29c1ed1c035a85$var$DEFAULT_STYLE.globalCompositeOperation;
                            this.clearShadowAndFilter(context, hasFilter, true);
                        }
                    }
                    $8f29c1ed1c035a85$var$applyStroke(context, object, stroke, canvasContext, plugin, runtime, this.imagePool);
                }
            }
        },
        {
            key: "clearShadowAndFilter",
            value: function clearShadowAndFilter(context, hasFilter, hasShadow) {
                if (hasShadow) {
                    context.shadowColor = 'transparent';
                    context.shadowBlur = 0;
                }
                if (hasFilter) {
                    // save drop-shadow filter
                    var oldFilter = context.filter;
                    if (!(0, $geZBG.default)(oldFilter) && oldFilter.indexOf('drop-shadow') > -1) context.filter = oldFilter.replace(/drop-shadow\([^)]*\)/, '').trim() || 'none';
                }
            }
        }
    ]);
}($8f29c1ed1c035a85$var$OptimizedDefaultRenderer);
/**
 * apply before fill and stroke but only once
 */ function $8f29c1ed1c035a85$var$setShadowAndFilter(object, context, hasShadow) {
    var _object$parsedStyle = object.parsedStyle, filter = _object$parsedStyle.filter, shadowColor = _object$parsedStyle.shadowColor, shadowBlur = _object$parsedStyle.shadowBlur, shadowOffsetX = _object$parsedStyle.shadowOffsetX, shadowOffsetY = _object$parsedStyle.shadowOffsetY;
    if (filter && filter.length) // use raw filter string
    context.filter = object.style.filter;
    if (hasShadow) {
        context.shadowColor = shadowColor.toString();
        context.shadowBlur = shadowBlur || 0;
        context.shadowOffsetX = shadowOffsetX || 0;
        context.shadowOffsetY = shadowOffsetY || 0;
    }
}
function $8f29c1ed1c035a85$var$applyFill(context, object, fill, fillRule, canvasContext, plugin, runtime, imagePool) {
    var skipFill = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;
    if (Array.isArray(fill)) fill.forEach(function(gradient) {
        context.fillStyle = $8f29c1ed1c035a85$var$getColor(gradient, object, context, imagePool);
        if (!skipFill) fillRule ? context.fill(fillRule) : context.fill();
    });
    else {
        if ((0, $2eDEB.isPattern)(fill)) context.fillStyle = $8f29c1ed1c035a85$var$getPattern(fill, object, context, canvasContext, plugin, runtime, imagePool);
        if (!skipFill) fillRule ? context.fill(fillRule) : context.fill();
    }
}
function $8f29c1ed1c035a85$var$applyStroke(context, object, stroke, canvasContext, plugin, runtime, imagePool) {
    var skipStroke = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
    if (Array.isArray(stroke)) stroke.forEach(function(gradient) {
        context.strokeStyle = $8f29c1ed1c035a85$var$getColor(gradient, object, context, imagePool);
        if (!skipStroke) context.stroke();
    });
    else {
        if ((0, $2eDEB.isPattern)(stroke)) context.strokeStyle = $8f29c1ed1c035a85$var$getPattern(stroke, object, context, canvasContext, plugin, runtime, imagePool);
        if (!skipStroke) context.stroke();
    }
}
function $8f29c1ed1c035a85$var$calculateOverlapRect(rect1, rect2) {
    var _rect = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(rect1, 4), x1 = _rect[0], y1 = _rect[1], w1 = _rect[2], h1 = _rect[3];
    var _rect2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(rect2, 4), x2 = _rect2[0], y2 = _rect2[1], w2 = _rect2[2], h2 = _rect2[3];
    // 计算重叠区域的左上角和右下角
    var overlapLeft = Math.max(x1, x2);
    var overlapTop = Math.max(y1, y2);
    var overlapRight = Math.min(x1 + w1, x2 + w2);
    var overlapBottom = Math.min(y1 + h1, y2 + h2);
    if (overlapRight <= overlapLeft || overlapBottom <= overlapTop) return null;
    return [
        overlapLeft,
        overlapTop,
        overlapRight - overlapLeft,
        overlapBottom - overlapTop
    ];
}
function $8f29c1ed1c035a85$var$transformRect(rect, matrix) {
    var tl = (0, $eIStk).transformMat4((0, $eIStk).create(), [
        rect[0],
        rect[1],
        0
    ], matrix);
    var tr = (0, $eIStk).transformMat4((0, $eIStk).create(), [
        rect[0] + rect[2],
        rect[1],
        0
    ], matrix);
    var bl = (0, $eIStk).transformMat4((0, $eIStk).create(), [
        rect[0],
        rect[1] + rect[3],
        0
    ], matrix);
    var br = (0, $eIStk).transformMat4((0, $eIStk).create(), [
        rect[0] + rect[2],
        rect[1] + rect[3],
        0
    ], matrix);
    return [
        Math.min(tl[0], tr[0], bl[0], br[0]),
        Math.min(tl[1], tr[1], bl[1], br[1]),
        Math.max(tl[0], tr[0], bl[0], br[0]) - Math.min(tl[0], tr[0], bl[0], br[0]),
        Math.max(tl[1], tr[1], bl[1], br[1]) - Math.min(tl[1], tr[1], bl[1], br[1])
    ];
}
var $8f29c1ed1c035a85$var$ImageRenderer = /*#__PURE__*/ function(_DefaultRenderer) {
    function ImageRenderer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ImageRenderer);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, ImageRenderer, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ImageRenderer, _DefaultRenderer);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ImageRenderer, [
        {
            key: "renderDownSampled",
            value: function renderDownSampled(context, parsedStyle, object, data) {
                var src = data.src, imageCache = data.imageCache;
                if (!imageCache.downSampled) {
                    this.imagePool.createDownSampledImage(src, object).then(function() {
                        // be removed from dom tree
                        if (!object.ownerDocument) return;
                        // rerender
                        object.dirty();
                        object.ownerDocument.defaultView.context.renderingService.dirty();
                    })["catch"](function(reason) {
                        console.error(reason);
                    });
                    return;
                }
                context.drawImage(imageCache.downSampled, Math.floor(data.drawRect[0]), Math.floor(data.drawRect[1]), Math.ceil(data.drawRect[2]), Math.ceil(data.drawRect[3]));
            }
        },
        {
            key: "renderTile",
            value: function renderTile(context, parsedStyle, object, data) {
                var src = data.src, imageCache = data.imageCache, imageRect = data.imageRect, drawRect = data.drawRect;
                var originalSize = imageCache.size;
                var _context$getTransform = context.getTransform(), a = _context$getTransform.a, b = _context$getTransform.b, c = _context$getTransform.c, d = _context$getTransform.d, e = _context$getTransform.e, f = _context$getTransform.f;
                context.resetTransform();
                if (!(imageCache !== null && imageCache !== void 0 && imageCache.gridSize)) {
                    this.imagePool.createImageTiles(src, [], function() {
                        // be removed from dom tree
                        if (!object.ownerDocument) return;
                        // rerender
                        object.dirty();
                        object.ownerDocument.defaultView.context.renderingService.dirty();
                    }, object)["catch"](function(reason) {
                        console.error(reason);
                    });
                    return;
                }
                var scaleToOrigin = [
                    originalSize[0] / imageRect[2],
                    originalSize[1] / imageRect[3]
                ];
                var scaledTileSize = [
                    imageCache.tileSize[0] / scaleToOrigin[0],
                    imageCache.tileSize[1] / scaleToOrigin[1]
                ];
                var _ref = [
                    Math.floor((drawRect[0] - imageRect[0]) / scaledTileSize[0]),
                    Math.ceil((drawRect[0] + drawRect[2] - imageRect[0]) / scaledTileSize[0])
                ], startTileX = _ref[0], endTileX = _ref[1];
                var _ref2 = [
                    Math.floor((drawRect[1] - imageRect[1]) / scaledTileSize[1]),
                    Math.ceil((drawRect[1] + drawRect[3] - imageRect[1]) / scaledTileSize[1])
                ], startTileY = _ref2[0], endTileY = _ref2[1];
                for(var tileY = startTileY; tileY <= endTileY; tileY++)for(var tileX = startTileX; tileX <= endTileX; tileX++){
                    var item = imageCache.tiles[tileY][tileX];
                    if (item) {
                        var tileRect = [
                            Math.floor(imageRect[0] + item.tileX * scaledTileSize[0]),
                            Math.floor(imageRect[1] + item.tileY * scaledTileSize[1]),
                            Math.ceil(scaledTileSize[0]),
                            Math.ceil(scaledTileSize[1])
                        ];
                        context.drawImage(item.data, tileRect[0], tileRect[1], tileRect[2], tileRect[3]);
                    }
                }
                context.setTransform(a, b, c, d, e, f);
            }
        },
        {
            key: "render",
            value: function render(context, parsedStyle, object) {
                var _parsedStyle$x = parsedStyle.x, x = _parsedStyle$x === void 0 ? 0 : _parsedStyle$x, _parsedStyle$y = parsedStyle.y, y = _parsedStyle$y === void 0 ? 0 : _parsedStyle$y, width = parsedStyle.width, height = parsedStyle.height, src = parsedStyle.src, shadowColor = parsedStyle.shadowColor, shadowBlur = parsedStyle.shadowBlur;
                var imageCache = this.imagePool.getImageSync(src, object);
                var image = imageCache === null || imageCache === void 0 ? void 0 : imageCache.img;
                var iw = width;
                var ih = height;
                if (!image) return;
                iw || (iw = image.width);
                ih || (ih = image.height);
                var hasShadow = !(0, $geZBG.default)(shadowColor) && shadowBlur > 0;
                $8f29c1ed1c035a85$var$setShadowAndFilter(object, context, hasShadow);
                // node-canvas will throw the following err:
                // Error: Image given has not completed loading
                try {
                    var _object$ownerDocument = object.ownerDocument.defaultView.getContextService().getDomElement(), viewWidth = _object$ownerDocument.width, viewHeight = _object$ownerDocument.height;
                    var currentTransform = context.getTransform();
                    var a = currentTransform.a, b = currentTransform.b, c = currentTransform.c, d = currentTransform.d, e = currentTransform.e, f = currentTransform.f;
                    // 构建 mat4 矩阵
                    // prettier-ignore
                    var transformMatrix = (0, $3iqbd).fromValues(a, c, 0, 0, b, d, 0, 0, 0, 0, 1, 0, e, f, 0, 1);
                    var imageRect = $8f29c1ed1c035a85$var$transformRect([
                        x,
                        y,
                        iw,
                        ih
                    ], transformMatrix);
                    var drawRect = $8f29c1ed1c035a85$var$calculateOverlapRect([
                        0,
                        0,
                        viewWidth,
                        viewHeight
                    ], imageRect);
                    if (!drawRect) return;
                    if (!object.ownerDocument.defaultView.getConfig().enableLargeImageOptimization) {
                        ImageRenderer.renderFull(context, parsedStyle, object, {
                            image: image,
                            drawRect: [
                                x,
                                y,
                                iw,
                                ih
                            ]
                        });
                        return;
                    }
                    var sizeOfOrigin = imageRect[2] / imageCache.size[0];
                    if (sizeOfOrigin < (imageCache.downSamplingRate || 0.5)) {
                        this.renderDownSampled(context, parsedStyle, object, {
                            src: src,
                            imageCache: imageCache,
                            drawRect: [
                                x,
                                y,
                                iw,
                                ih
                            ]
                        });
                        return;
                    }
                    if (!ImagePool.isSupportTile) {
                        ImageRenderer.renderFull(context, parsedStyle, object, {
                            image: image,
                            drawRect: [
                                x,
                                y,
                                iw,
                                ih
                            ]
                        });
                        return;
                    }
                    this.renderTile(context, parsedStyle, object, {
                        src: src,
                        imageCache: imageCache,
                        imageRect: imageRect,
                        drawRect: drawRect
                    });
                } catch (_unused) {
                // expected error
                }
            }
        },
        {
            key: "drawToContext",
            value: function drawToContext(context, object, renderState, plugin, runtime) {
                this.render(context, object.parsedStyle, object);
            }
        }
    ], [
        {
            key: "renderFull",
            value: function renderFull(context, parsedStyle, object, data) {
                context.drawImage(data.image, Math.floor(data.drawRect[0]), Math.floor(data.drawRect[1]), Math.ceil(data.drawRect[2]), Math.ceil(data.drawRect[3]));
            }
        }
    ]);
}($8f29c1ed1c035a85$var$DefaultRenderer);
var $8f29c1ed1c035a85$var$TextRenderer = /*#__PURE__*/ function(_DefaultRenderer) {
    function TextRenderer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, TextRenderer);
        return (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, TextRenderer, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(TextRenderer, _DefaultRenderer);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(TextRenderer, [
        {
            key: "render",
            value: function render(context, parsedStyle, object, canvasContext, plugin, runtime) {
                // Trigger text geometry calculation.
                object.getBounds();
                var _parsedStyle$lineWidt = parsedStyle.lineWidth, lineWidth = _parsedStyle$lineWidt === void 0 ? 1 : _parsedStyle$lineWidt, _parsedStyle$textAlig = parsedStyle.textAlign, textAlign = _parsedStyle$textAlig === void 0 ? 'start' : _parsedStyle$textAlig, _parsedStyle$textBase = parsedStyle.textBaseline, textBaseline = _parsedStyle$textBase === void 0 ? 'alphabetic' : _parsedStyle$textBase, _parsedStyle$lineJoin = parsedStyle.lineJoin, lineJoin = _parsedStyle$lineJoin === void 0 ? 'miter' : _parsedStyle$lineJoin, _parsedStyle$miterLim = parsedStyle.miterLimit, miterLimit = _parsedStyle$miterLim === void 0 ? 10 : _parsedStyle$miterLim, _parsedStyle$letterSp = parsedStyle.letterSpacing, letterSpacing = _parsedStyle$letterSp === void 0 ? 0 : _parsedStyle$letterSp, stroke = parsedStyle.stroke, fill = parsedStyle.fill, fillRule = parsedStyle.fillRule, _parsedStyle$fillOpac = parsedStyle.fillOpacity, fillOpacity = _parsedStyle$fillOpac === void 0 ? 1 : _parsedStyle$fillOpac, _parsedStyle$strokeOp = parsedStyle.strokeOpacity, strokeOpacity = _parsedStyle$strokeOp === void 0 ? 1 : _parsedStyle$strokeOp, _parsedStyle$opacity = parsedStyle.opacity, opacity = _parsedStyle$opacity === void 0 ? 1 : _parsedStyle$opacity, metrics = parsedStyle.metrics, _parsedStyle$x = parsedStyle.x, x = _parsedStyle$x === void 0 ? 0 : _parsedStyle$x, _parsedStyle$y = parsedStyle.y, y = _parsedStyle$y === void 0 ? 0 : _parsedStyle$y, dx = parsedStyle.dx, dy = parsedStyle.dy, shadowColor = parsedStyle.shadowColor, shadowBlur = parsedStyle.shadowBlur, textDecorationLine = parsedStyle.textDecorationLine;
                var font = metrics.font, lines = metrics.lines, height = metrics.height, lineHeight = metrics.lineHeight, lineMetrics = metrics.lineMetrics;
                context.font = font;
                context.lineWidth = lineWidth;
                context.textAlign = textAlign === 'middle' ? 'center' : textAlign;
                var formattedTextBaseline = textBaseline;
                if (formattedTextBaseline === 'alphabetic') formattedTextBaseline = 'bottom';
                context.lineJoin = lineJoin;
                if (!(0, $geZBG.default)(miterLimit)) context.miterLimit = miterLimit;
                var linePositionY = y;
                // handle vertical text baseline
                if (textBaseline === 'middle') linePositionY += -height / 2 - lineHeight / 2;
                else if (textBaseline === 'bottom' || textBaseline === 'alphabetic' || textBaseline === 'ideographic') linePositionY += -height;
                else if (textBaseline === 'top' || textBaseline === 'hanging') linePositionY += -lineHeight;
                // account for dx & dy
                var offsetX = x + (dx || 0);
                linePositionY += dy || 0;
                if (lines.length === 1) {
                    if (formattedTextBaseline === 'bottom') {
                        formattedTextBaseline = 'middle';
                        linePositionY -= 0.5 * height;
                    } else if (formattedTextBaseline === 'top') {
                        formattedTextBaseline = 'middle';
                        linePositionY += 0.5 * height;
                    }
                }
                context.textBaseline = formattedTextBaseline;
                var hasShadow = !(0, $geZBG.default)(shadowColor) && shadowBlur > 0;
                $8f29c1ed1c035a85$var$setShadowAndFilter(object, context, hasShadow);
                // draw lines line by line
                for(var i = 0; i < lines.length; i++){
                    var linePositionX = lineWidth / 2 + offsetX;
                    linePositionY += lineHeight;
                    // no need to re-position X, cause we already set text align
                    // @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/textAlign
                    if (!(0, $geZBG.default)(stroke) && !stroke.isNone && lineWidth) this.drawLetterSpacing(context, object, lines[i], lineMetrics[i], textAlign, linePositionX, linePositionY, letterSpacing, fill, fillRule, fillOpacity, stroke, strokeOpacity, opacity, true, canvasContext, plugin, runtime);
                    if (!(0, $geZBG.default)(fill)) this.drawLetterSpacing(context, object, lines[i], lineMetrics[i], textAlign, linePositionX, linePositionY, letterSpacing, fill, fillRule, fillOpacity, stroke, strokeOpacity, opacity, false, canvasContext, plugin, runtime);
                }
                // Draw text decoration lines
                if (textDecorationLine && textDecorationLine !== 'none') this.drawTextDecorations(context, parsedStyle, object, lines, lineHeight, offsetX, y + (dy || 0), canvasContext, plugin, runtime);
            }
        },
        {
            key: "drawLetterSpacing",
            value: function drawLetterSpacing(context, object, text, lineMetrics, textAlign, x, y, letterSpacing, fill, fillRule, fillOpacity, stroke, strokeOpacity, opacity, isStroke, canvasContext, plugin, runtime) {
                // letterSpacing of 0 means normal, render all texts directly
                if (letterSpacing === 0) {
                    if (isStroke) this.strokeText(context, object, text, x, y, stroke, strokeOpacity, canvasContext, plugin, runtime);
                    else this.fillText(context, object, text, x, y, fill, fillRule, fillOpacity, opacity, canvasContext, plugin, runtime);
                    return;
                }
                // draw text using left align
                var currentTextAlign = context.textAlign;
                context.textAlign = 'left';
                var currentPosition = x;
                if (textAlign === 'center' || textAlign === 'middle') currentPosition = x - lineMetrics.width / 2;
                else if (textAlign === 'right' || textAlign === 'end') currentPosition = x - lineMetrics.width;
                var stringArray = Array.from(text);
                var previousWidth = context.measureText(text).width;
                var currentWidth = 0;
                for(var i = 0; i < stringArray.length; ++i){
                    var currentChar = stringArray[i];
                    if (isStroke) this.strokeText(context, object, currentChar, currentPosition, y, stroke, strokeOpacity, canvasContext, plugin, runtime);
                    else this.fillText(context, object, currentChar, currentPosition, y, fill, fillRule, fillOpacity, opacity, canvasContext, plugin, runtime);
                    currentWidth = context.measureText(text.substring(i + 1)).width;
                    currentPosition += previousWidth - currentWidth + letterSpacing;
                    previousWidth = currentWidth;
                }
                context.textAlign = currentTextAlign;
            }
        },
        {
            key: "fillText",
            value: function fillText(context, object, text, x, y, fill, fillRule, fillOpacity, opacity, canvasContext, plugin, runtime) {
                $8f29c1ed1c035a85$var$applyFill(context, object, fill, fillRule, canvasContext, plugin, runtime, this.imagePool, true);
                var currentGlobalAlpha;
                var applyOpacity = !(0, $geZBG.default)(fillOpacity) && fillOpacity !== 1;
                if (applyOpacity) {
                    currentGlobalAlpha = context.globalAlpha;
                    context.globalAlpha = fillOpacity * opacity;
                }
                context.fillText(text, x, y);
                if (applyOpacity) context.globalAlpha = currentGlobalAlpha;
            }
        },
        {
            key: "strokeText",
            value: function strokeText(context, object, text, x, y, stroke, strokeOpacity, canvasContext, plugin, runtime) {
                $8f29c1ed1c035a85$var$applyStroke(context, object, stroke, canvasContext, plugin, runtime, this.imagePool, true);
                var currentGlobalAlpha;
                var applyOpacity = !(0, $geZBG.default)(strokeOpacity) && strokeOpacity !== 1;
                if (applyOpacity) {
                    currentGlobalAlpha = context.globalAlpha;
                    context.globalAlpha = strokeOpacity;
                }
                context.strokeText(text, x, y);
                if (applyOpacity) context.globalAlpha = currentGlobalAlpha;
            }
        },
        {
            key: "drawTextDecorations",
            value: function drawTextDecorations(context, parsedStyle, object, lines, lineHeight, offsetX, baseY, canvasContext, plugin, runtime) {
                var textDecorationLine = parsedStyle.textDecorationLine, textDecorationColor = parsedStyle.textDecorationColor, textDecorationStyle = parsedStyle.textDecorationStyle, _parsedStyle$textDeco = parsedStyle.textDecorationThickness, textDecorationThickness = _parsedStyle$textDeco === void 0 ? 1 : _parsedStyle$textDeco, _parsedStyle$textAlig2 = parsedStyle.textAlign, textAlign = _parsedStyle$textAlig2 === void 0 ? 'start' : _parsedStyle$textAlig2, _parsedStyle$lineWidt2 = parsedStyle.lineWidth, lineWidth = _parsedStyle$lineWidt2 === void 0 ? 1 : _parsedStyle$lineWidt2, metrics = parsedStyle.metrics;
                if (!textDecorationLine || textDecorationLine === 'none') return;
                var lineMetrics = metrics.lineMetrics;
                var decorations = textDecorationLine.split(' ');
                // Set decoration style
                context.lineWidth = textDecorationThickness;
                if (textDecorationColor) context.strokeStyle = "rgba(".concat(textDecorationColor.r, ", ").concat(textDecorationColor.g, ", ").concat(textDecorationColor.b, ", ").concat(textDecorationColor.alpha, ")");
                // Set line style based on textDecorationStyle
                switch(textDecorationStyle){
                    case 'dashed':
                        context.setLineDash([
                            5,
                            5
                        ]);
                        break;
                    case 'dotted':
                        context.setLineDash([
                            2,
                            2
                        ]);
                        break;
                    case 'wavy':
                        // For wavy, we'll use a simple approximation with bezier curves
                        // A full implementation would be more complex
                        context.setLineDash([]);
                        break;
                    default:
                        context.setLineDash([]);
                        break;
                }
                var linePositionY = baseY;
                // Adjust for text baseline
                var _parsedStyle$textBase2 = parsedStyle.textBaseline, textBaseline = _parsedStyle$textBase2 === void 0 ? 'alphabetic' : _parsedStyle$textBase2;
                if (textBaseline === 'middle') linePositionY += -metrics.height / 2 - lineHeight / 2;
                else if (textBaseline === 'bottom' || textBaseline === 'alphabetic' || textBaseline === 'ideographic') linePositionY += -metrics.height;
                else if (textBaseline === 'top' || textBaseline === 'hanging') linePositionY += -lineHeight;
                // Draw each decoration for each line
                for(var i = 0; i < lines.length; i++){
                    linePositionY += lineHeight;
                    var lineMetric = lineMetrics[i];
                    if (!lineMetric) continue;
                    var lineWidthOffset = lineWidth / 2;
                    var startX = offsetX;
                    var endX = offsetX + lineMetric.width;
                    // Adjust for text alignment
                    if (textAlign === 'center' || textAlign === 'middle') {
                        startX = offsetX - lineMetric.width / 2;
                        endX = offsetX + lineMetric.width / 2;
                    } else if (textAlign === 'right' || textAlign === 'end') {
                        startX = offsetX - lineMetric.width;
                        endX = offsetX;
                    }
                    // Add lineWidth offset
                    startX += lineWidthOffset;
                    endX += lineWidthOffset;
                    // Draw each type of decoration
                    var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(decorations), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var decoration = _step.value;
                            var decorationY = linePositionY;
                            switch(decoration){
                                case 'underline':
                                    decorationY += 2; // Small offset below baseline
                                    break;
                                case 'overline':
                                    decorationY -= lineHeight - 2; // Small offset above line
                                    break;
                                case 'line-through':
                                    decorationY -= lineHeight / 2; // Middle of line
                                    break;
                                default:
                                    continue;
                            }
                            if (textDecorationStyle === 'wavy') this.drawWavyLine(context, startX, endX, decorationY);
                            else {
                                context.beginPath();
                                context.moveTo(startX, decorationY);
                                context.lineTo(endX, decorationY);
                                context.stroke();
                            }
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
                // Reset line dash
                context.setLineDash([]);
            }
        },
        {
            key: "drawWavyLine",
            value: function drawWavyLine(context, startX, endX, y) {
                var amplitude = 2; // Height of the wave
                var wavelength = 10; // Length of one wave cycle
                var numWaves = Math.floor((endX - startX) / wavelength);
                context.beginPath();
                context.moveTo(startX, y);
                for(var i = 0; i < numWaves; i++){
                    var x1 = startX + i * wavelength + wavelength / 4;
                    var y1 = y + amplitude;
                    var x2 = startX + i * wavelength + wavelength / 2;
                    var y2 = y;
                    context.quadraticCurveTo(x1, y1, x2, y2);
                    var x3 = startX + i * wavelength + wavelength * 3 / 4;
                    var y3 = y - amplitude;
                    var x4 = startX + (i + 1) * wavelength;
                    var y4 = y;
                    context.quadraticCurveTo(x3, y3, x4, y4);
                }
                context.stroke();
            }
        },
        {
            key: "drawToContext",
            value: function drawToContext(context, object, renderState, plugin, runtime) {
                this.render(context, object.parsedStyle, object, object.ownerDocument.defaultView.context, plugin, runtime);
            }
        }
    ]);
}($8f29c1ed1c035a85$var$DefaultRenderer);
var $8f29c1ed1c035a85$var$Plugin$2 = /*#__PURE__*/ function(_AbstractRendererPlug) {
    function Plugin() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Plugin);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Plugin);
        _this.name = 'canvas-renderer';
        _this.options = options;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Plugin, _AbstractRendererPlug);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Plugin, [
        {
            key: "init",
            value: function init() {
                var _defaultStyleRenderer;
                var canvasRendererPluginOptions = (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                    dirtyObjectNumThreshold: 500,
                    dirtyObjectRatioThreshold: 0.8
                }, this.options);
                // @ts-ignore
                var imagePool = this.context.imagePool;
                var defaultRenderer = new $8f29c1ed1c035a85$var$DefaultRenderer(imagePool);
                var defaultStyleRendererFactory = (_defaultStyleRenderer = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_defaultStyleRenderer, (0, $2eDEB.Shape).CIRCLE, defaultRenderer), (0, $2eDEB.Shape).ELLIPSE, defaultRenderer), (0, $2eDEB.Shape).RECT, defaultRenderer), (0, $2eDEB.Shape).IMAGE, new $8f29c1ed1c035a85$var$ImageRenderer(imagePool)), (0, $2eDEB.Shape).TEXT, new $8f29c1ed1c035a85$var$TextRenderer(imagePool)), (0, $2eDEB.Shape).LINE, defaultRenderer), (0, $2eDEB.Shape).POLYLINE, defaultRenderer), (0, $2eDEB.Shape).POLYGON, defaultRenderer), (0, $2eDEB.Shape).PATH, defaultRenderer), (0, $2eDEB.Shape).GROUP, undefined), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_defaultStyleRenderer, (0, $2eDEB.Shape).HTML, undefined), (0, $2eDEB.Shape).MESH, undefined), (0, $2eDEB.Shape).FRAGMENT, undefined));
                this.context.defaultStyleRendererFactory = defaultStyleRendererFactory;
                this.context.styleRendererFactory = defaultStyleRendererFactory;
                this.addRenderingPlugin(new $8f29c1ed1c035a85$var$CanvasRendererPlugin(canvasRendererPluginOptions));
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.removeAllRenderingPlugins();
                delete this.context.defaultStyleRendererFactory;
                delete this.context.styleRendererFactory;
            }
        }
    ]);
}((0, $2eDEB.AbstractRendererPlugin));
var $8f29c1ed1c035a85$export$7adc20298958481a = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    CircleRenderer: $8f29c1ed1c035a85$var$DefaultRenderer,
    DefaultRenderer: $8f29c1ed1c035a85$var$DefaultRenderer,
    EllipseRenderer: $8f29c1ed1c035a85$var$DefaultRenderer,
    ImageRenderer: $8f29c1ed1c035a85$var$ImageRenderer,
    LineRenderer: $8f29c1ed1c035a85$var$DefaultRenderer,
    PathRenderer: $8f29c1ed1c035a85$var$DefaultRenderer,
    Plugin: $8f29c1ed1c035a85$var$Plugin$2,
    PolygonRenderer: $8f29c1ed1c035a85$var$DefaultRenderer,
    PolylineRenderer: $8f29c1ed1c035a85$var$DefaultRenderer,
    RectRenderer: $8f29c1ed1c035a85$var$DefaultRenderer,
    TextRenderer: $8f29c1ed1c035a85$var$TextRenderer
});
var $8f29c1ed1c035a85$var$tmpVec3a = (0, $eIStk).create();
var $8f29c1ed1c035a85$var$tmpVec3b = (0, $eIStk).create();
var $8f29c1ed1c035a85$var$tmpVec3c = (0, $eIStk).create();
var $8f29c1ed1c035a85$var$tmpMat4 = (0, $3iqbd).create();
/**
 * pick shape(s) with Mouse/Touch event
 *
 * 1. find AABB with r-tree
 * 2. do math calculation with geometry in an accurate way
 */ var $8f29c1ed1c035a85$var$CanvasPickerPlugin = /*#__PURE__*/ function() {
    function CanvasPickerPlugin() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, CanvasPickerPlugin);
        this.isHit = function(displayObject, position, worldTransform, isClipPath) {
            // use picker for current shape's type
            var pick = _this.context.pointInPathPickerFactory[displayObject.nodeName];
            if (pick) {
                // invert with world matrix
                var invertWorldMat = (0, $3iqbd).invert($8f29c1ed1c035a85$var$tmpMat4, worldTransform);
                // transform client position to local space, do picking in local space
                var localPosition = (0, $eIStk).transformMat4($8f29c1ed1c035a85$var$tmpVec3b, (0, $eIStk).set($8f29c1ed1c035a85$var$tmpVec3c, position[0], position[1], 0), invertWorldMat);
                if (pick(displayObject, new (0, $2eDEB.Point)(localPosition[0], localPosition[1]), isClipPath, _this.isPointInPath, _this.context, _this.runtime)) return true;
            }
            return false;
        };
        /**
     * use native picking method
     * @see https://developer.mozilla.org/zh-CN/docs/Web/API/CanvasRenderingContext2D/isPointInPath
     */ this.isPointInPath = function(displayObject, position) {
            var context = _this.runtime.offscreenCanvasCreator.getOrCreateContext(_this.context.config.offscreenCanvas);
            var generatePath = _this.context.pathGeneratorFactory[displayObject.nodeName];
            if (generatePath) {
                context.beginPath();
                generatePath(context, displayObject.parsedStyle);
                context.closePath();
            }
            return context.isPointInPath(position.x, position.y);
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(CanvasPickerPlugin, [
        {
            key: "apply",
            value: function apply(context, runtime) {
                var _renderingContext$roo, _this2 = this;
                var renderingService = context.renderingService, renderingContext = context.renderingContext;
                this.context = context;
                this.runtime = runtime;
                var document1 = (_renderingContext$roo = renderingContext.root) === null || _renderingContext$roo === void 0 ? void 0 : _renderingContext$roo.ownerDocument;
                renderingService.hooks.pick.tapPromise(CanvasPickerPlugin.tag, /*#__PURE__*/ function() {
                    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee(result) {
                        return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    return _context.abrupt("return", _this2.pick(document1, result));
                                case 1:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    return function(_x) {
                        return _ref.apply(this, arguments);
                    };
                }());
                renderingService.hooks.pickSync.tap(CanvasPickerPlugin.tag, function(result) {
                    return _this2.pick(document1, result);
                });
            }
        },
        {
            key: "pick",
            value: function pick(document1, result) {
                var topmost = result.topmost, _result$position = result.position, x = _result$position.x, y = _result$position.y;
                // position in world space
                var position = (0, $eIStk).set($8f29c1ed1c035a85$var$tmpVec3a, x, y, 0);
                // query by AABB
                var hitTestList = document1.elementsFromBBox(position[0], position[1], position[0], position[1]);
                // test with clip path & origin shape
                // @see https://github.com/antvis/g/issues/1064
                var pickedDisplayObjects = [];
                var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($8QL5z)))(hitTestList), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _displayObject = _step.value;
                        var worldTransform = _displayObject.getWorldTransform();
                        var isHitOriginShape = this.isHit(_displayObject, position, worldTransform, false);
                        if (isHitOriginShape) {
                            // should look up in the ancestor node
                            var clipped = (0, $2eDEB.findClosestClipPathTarget)(_displayObject);
                            if (clipped) {
                                var clipPath = clipped.parsedStyle.clipPath;
                                var isHitClipPath = this.isHit(clipPath, position, clipPath.getWorldTransform(), true);
                                if (isHitClipPath) {
                                    if (topmost) {
                                        result.picked = [
                                            _displayObject
                                        ];
                                        return result;
                                    }
                                    pickedDisplayObjects.push(_displayObject);
                                }
                            } else {
                                if (topmost) {
                                    result.picked = [
                                        _displayObject
                                    ];
                                    return result;
                                }
                                pickedDisplayObjects.push(_displayObject);
                            }
                        }
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
                result.picked = pickedDisplayObjects;
                return result;
            }
        }
    ]);
}();
$8f29c1ed1c035a85$var$CanvasPickerPlugin.tag = 'CanvasPicker';
function $8f29c1ed1c035a85$var$isPointInPath$8(displayObject, position, isClipPath) {
    var _ref = displayObject.parsedStyle, _ref$cx = _ref.cx, cx = _ref$cx === void 0 ? 0 : _ref$cx, _ref$cy = _ref.cy, cy = _ref$cy === void 0 ? 0 : _ref$cy, r = _ref.r, fill = _ref.fill, stroke = _ref.stroke, _ref$lineWidth = _ref.lineWidth, lineWidth = _ref$lineWidth === void 0 ? 1 : _ref$lineWidth, _ref$increasedLineWid = _ref.increasedLineWidthForHitTesting, increasedLineWidthForHitTesting = _ref$increasedLineWid === void 0 ? 0 : _ref$increasedLineWid, _ref$pointerEvents = _ref.pointerEvents, pointerEvents = _ref$pointerEvents === void 0 ? 'auto' : _ref$pointerEvents;
    var halfLineWidth = (lineWidth + increasedLineWidthForHitTesting) / 2;
    var absDistance = (0, $11s8J.distance)(cx, cy, position.x, position.y);
    var _isFillOrStrokeAffect = (0, $2eDEB.isFillOrStrokeAffected)(pointerEvents, fill, stroke), _isFillOrStrokeAffect2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_isFillOrStrokeAffect, 2), hasFill = _isFillOrStrokeAffect2[0], hasStroke = _isFillOrStrokeAffect2[1];
    if (hasFill && hasStroke || isClipPath) return absDistance <= r + halfLineWidth;
    if (hasFill) return absDistance <= r;
    if (hasStroke) return absDistance >= r - halfLineWidth && absDistance <= r + halfLineWidth;
    return false;
}
function $8f29c1ed1c035a85$var$ellipseDistance(squareX, squareY, rx, ry) {
    return squareX / (rx * rx) + squareY / (ry * ry);
}
function $8f29c1ed1c035a85$var$isPointInPath$7(displayObject, position, isClipPath) {
    var _ref = displayObject.parsedStyle, _ref$cx = _ref.cx, cx = _ref$cx === void 0 ? 0 : _ref$cx, _ref$cy = _ref.cy, cy = _ref$cy === void 0 ? 0 : _ref$cy, rx = _ref.rx, ry = _ref.ry, fill = _ref.fill, stroke = _ref.stroke, _ref$lineWidth = _ref.lineWidth, lineWidth = _ref$lineWidth === void 0 ? 1 : _ref$lineWidth, _ref$increasedLineWid = _ref.increasedLineWidthForHitTesting, increasedLineWidthForHitTesting = _ref$increasedLineWid === void 0 ? 0 : _ref$increasedLineWid, _ref$pointerEvents = _ref.pointerEvents, pointerEvents = _ref$pointerEvents === void 0 ? 'auto' : _ref$pointerEvents;
    var x = position.x, y = position.y;
    var _isFillOrStrokeAffect = (0, $2eDEB.isFillOrStrokeAffected)(pointerEvents, fill, stroke), _isFillOrStrokeAffect2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_isFillOrStrokeAffect, 2), hasFill = _isFillOrStrokeAffect2[0], hasStroke = _isFillOrStrokeAffect2[1];
    var halfLineWith = (lineWidth + increasedLineWidthForHitTesting) / 2;
    var squareX = (x - cx) * (x - cx);
    var squareY = (y - cy) * (y - cy);
    // 使用椭圆的公式： x*x/rx*rx + y*y/ry*ry = 1;
    if (hasFill && hasStroke || isClipPath) return $8f29c1ed1c035a85$var$ellipseDistance(squareX, squareY, rx + halfLineWith, ry + halfLineWith) <= 1;
    if (hasFill) return $8f29c1ed1c035a85$var$ellipseDistance(squareX, squareY, rx, ry) <= 1;
    if (hasStroke) return $8f29c1ed1c035a85$var$ellipseDistance(squareX, squareY, rx - halfLineWith, ry - halfLineWith) >= 1 && $8f29c1ed1c035a85$var$ellipseDistance(squareX, squareY, rx + halfLineWith, ry + halfLineWith) <= 1;
    return false;
}
function $8f29c1ed1c035a85$var$inBox(minX, minY, width, height, x, y) {
    return x >= minX && x <= minX + width && y >= minY && y <= minY + height;
}
function $8f29c1ed1c035a85$var$inRect(minX, minY, width, height, lineWidth, x, y) {
    var halfWidth = lineWidth / 2;
    // 将四个边看做矩形来检测，比边的检测算法要快
    return $8f29c1ed1c035a85$var$inBox(minX - halfWidth, minY - halfWidth, width, lineWidth, x, y) || // 上边
    $8f29c1ed1c035a85$var$inBox(minX + width - halfWidth, minY - halfWidth, lineWidth, height, x, y) || // 右边
    $8f29c1ed1c035a85$var$inBox(minX + halfWidth, minY + height - halfWidth, width, lineWidth, x, y) || // 下边
    $8f29c1ed1c035a85$var$inBox(minX - halfWidth, minY + halfWidth, lineWidth, height, x, y); // 左边
}
function $8f29c1ed1c035a85$var$inArc(cx, cy, r, startAngle, endAngle, lineWidth, x, y) {
    var angle = (Math.atan2(y - cy, x - cx) + Math.PI * 2) % (Math.PI * 2); // 转换到 0 - 2 * Math.PI 之间
    // if (angle < startAngle || angle > endAngle) {
    //   return false;
    // }
    var point = {
        x: cx + r * Math.cos(angle),
        y: cy + r * Math.sin(angle)
    };
    return (0, $11s8J.distance)(point.x, point.y, x, y) <= lineWidth / 2;
}
function $8f29c1ed1c035a85$var$inLine(x1, y1, x2, y2, lineWidth, x, y) {
    var minX = Math.min(x1, x2);
    var maxX = Math.max(x1, x2);
    var minY = Math.min(y1, y2);
    var maxY = Math.max(y1, y2);
    var halfWidth = lineWidth / 2;
    // 因为目前的方案是计算点到直线的距离，而有可能会在延长线上，所以要先判断是否在包围盒内
    // 这种方案会在水平或者竖直的情况下载线的延长线上有半 lineWidth 的误差
    if (!(x >= minX - halfWidth && x <= maxX + halfWidth && y >= minY - halfWidth && y <= maxY + halfWidth)) return false;
    // 因为已经计算了包围盒，所以仅需要计算到直线的距离即可，可以显著提升性能
    return (0, $11s8J.linePointToLine)(x1, y1, x2, y2, x, y) <= lineWidth / 2;
}
function $8f29c1ed1c035a85$var$inPolyline(points, lineWidth, x, y, isClose) {
    var count = points.length;
    if (count < 2) return false;
    for(var i = 0; i < count - 1; i++){
        var x1 = points[i][0];
        var y1 = points[i][1];
        var x2 = points[i + 1][0];
        var y2 = points[i + 1][1];
        if ($8f29c1ed1c035a85$var$inLine(x1, y1, x2, y2, lineWidth, x, y)) return true;
    }
    // 如果封闭，则计算起始点和结束点的边
    if (isClose) {
        var first = points[0];
        var last = points[count - 1];
        if ($8f29c1ed1c035a85$var$inLine(first[0], first[1], last[0], last[1], lineWidth, x, y)) return true;
    }
    return false;
}
// 多边形的射线检测，参考：https://blog.csdn.net/WilliamSun0122/article/details/77994526
var $8f29c1ed1c035a85$var$tolerance = 1e-6;
// 三态函数，判断两个double在eps精度下的大小关系
function $8f29c1ed1c035a85$var$dcmp(x) {
    if (Math.abs(x) < $8f29c1ed1c035a85$var$tolerance) return 0;
    return x < 0 ? -1 : 1;
}
// 判断点Q是否在p1和p2的线段上
function $8f29c1ed1c035a85$var$onSegment(p1, p2, q) {
    if ((q[0] - p1[0]) * (p2[1] - p1[1]) === (p2[0] - p1[0]) * (q[1] - p1[1]) && Math.min(p1[0], p2[0]) <= q[0] && q[0] <= Math.max(p1[0], p2[0]) && Math.min(p1[1], p2[1]) <= q[1] && q[1] <= Math.max(p1[1], p2[1])) return true;
    return false;
}
// 判断点P在多边形内-射线法
function $8f29c1ed1c035a85$var$inPolygon(points, x, y) {
    var isHit = false;
    var n = points.length;
    if (n <= 2) // svg 中点小于 3 个时，不显示，也无法被拾取
    return false;
    for(var i = 0; i < n; i++){
        var p1 = points[i];
        var p2 = points[(i + 1) % n];
        if ($8f29c1ed1c035a85$var$onSegment(p1, p2, [
            x,
            y
        ])) // 点在多边形一条边上
        return true;
        // 前一个判断min(p1[1],p2[1])<P.y<=max(p1[1],p2[1])
        // 后一个判断被测点 在 射线与边交点 的左边
        if ($8f29c1ed1c035a85$var$dcmp(p1[1] - y) > 0 !== $8f29c1ed1c035a85$var$dcmp(p2[1] - y) > 0 && $8f29c1ed1c035a85$var$dcmp(x - (y - p1[1]) * (p1[0] - p2[0]) / (p1[1] - p2[1]) - p1[0]) < 0) isHit = !isHit;
    }
    return isHit;
}
function $8f29c1ed1c035a85$var$inPolygons(polygons, x, y) {
    var isHit = false;
    for(var i = 0; i < polygons.length; i++){
        var points = polygons[i];
        isHit = $8f29c1ed1c035a85$var$inPolygon(points, x, y);
        if (isHit) break;
    }
    return isHit;
}
function $8f29c1ed1c035a85$var$isPointInPath$6(displayObject, position, isClipPath) {
    var _ref = displayObject.parsedStyle, x1 = _ref.x1, y1 = _ref.y1, x2 = _ref.x2, y2 = _ref.y2, _ref$lineWidth = _ref.lineWidth, lineWidth = _ref$lineWidth === void 0 ? 1 : _ref$lineWidth, _ref$increasedLineWid = _ref.increasedLineWidthForHitTesting, increasedLineWidthForHitTesting = _ref$increasedLineWid === void 0 ? 0 : _ref$increasedLineWid, _ref$pointerEvents = _ref.pointerEvents, pointerEvents = _ref$pointerEvents === void 0 ? 'auto' : _ref$pointerEvents, fill = _ref.fill, stroke = _ref.stroke;
    var _isFillOrStrokeAffect = (0, $2eDEB.isFillOrStrokeAffected)(pointerEvents, fill, stroke), _isFillOrStrokeAffect2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_isFillOrStrokeAffect, 2), hasStroke = _isFillOrStrokeAffect2[1];
    if (!hasStroke && !isClipPath || !lineWidth) return false;
    return $8f29c1ed1c035a85$var$inLine(x1, y1, x2, y2, lineWidth + increasedLineWidthForHitTesting, position.x, position.y);
}
// TODO: replace it with method in @antv/util
function $8f29c1ed1c035a85$var$isPointInStroke(segments, lineWidth, px, py, length) {
    var isHit = false;
    var halfWidth = lineWidth / 2;
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        var currentPoint = segment.currentPoint, params = segment.params, prePoint = segment.prePoint, box = segment.box;
        // 如果在前面已经生成过包围盒，直接按照包围盒计算
        if (box && !$8f29c1ed1c035a85$var$inBox(box.x - halfWidth, box.y - halfWidth, box.width + lineWidth, box.height + lineWidth, px, py)) continue;
        switch(segment.command){
            // L 和 Z 都是直线， M 不进行拾取
            case 'L':
            case 'Z':
                isHit = $8f29c1ed1c035a85$var$inLine(prePoint[0], prePoint[1], currentPoint[0], currentPoint[1], lineWidth, px, py);
                if (isHit) return true;
                break;
            case 'Q':
                var qDistance = (0, $11s8J.quadPointDistance)(prePoint[0], prePoint[1], params[1], params[2], params[3], params[4], px, py);
                isHit = qDistance <= lineWidth / 2;
                if (isHit) return true;
                break;
            case 'C':
                var cDistance = (0, $11s8J.cubicPointDistance)(prePoint[0], // 上一段结束位置, 即 C 的起始点
                prePoint[1], params[1], // 'C' 的参数，1、2 为第一个控制点，3、4 为第二个控制点，5、6 为结束点
                params[2], params[3], params[4], params[5], params[6], px, py, length);
                isHit = cDistance <= lineWidth / 2;
                if (isHit) return true;
                break;
            case 'A':
                // cache conversion result
                if (!segment.cubicParams) segment.cubicParams = (0, $2PAX5.arcToCubic)(prePoint[0], prePoint[1], params[1], params[2], params[3], params[4], params[5], params[6], params[7], undefined);
                var args = segment.cubicParams;
                // fixArc
                var prePointInCubic = prePoint;
                for(var _i = 0; _i < args.length; _i += 6){
                    var _cDistance = (0, $11s8J.cubicPointDistance)(prePointInCubic[0], // 上一段结束位置, 即 C 的起始点
                    prePointInCubic[1], args[_i], args[_i + 1], args[_i + 2], args[_i + 3], args[_i + 4], args[_i + 5], px, py, length);
                    prePointInCubic = [
                        args[_i + 4],
                        args[_i + 5]
                    ];
                    isHit = _cDistance <= lineWidth / 2;
                    if (isHit) return true;
                }
                break;
        }
    }
    return isHit;
}
function $8f29c1ed1c035a85$var$isPointInPath$5(displayObject, position, isClipPath, isPointInPath, renderingPluginContext, runtime) {
    var _ref = displayObject.parsedStyle, _ref$lineWidth = _ref.lineWidth, lineWidth = _ref$lineWidth === void 0 ? 1 : _ref$lineWidth, _ref$increasedLineWid = _ref.increasedLineWidthForHitTesting, increasedLineWidthForHitTesting = _ref$increasedLineWid === void 0 ? 0 : _ref$increasedLineWid, stroke = _ref.stroke, fill = _ref.fill, d = _ref.d, _ref$pointerEvents = _ref.pointerEvents, pointerEvents = _ref$pointerEvents === void 0 ? 'auto' : _ref$pointerEvents;
    var segments = d.segments, hasArc = d.hasArc, polylines = d.polylines, polygons = d.polygons;
    var _isFillOrStrokeAffect = (0, $2eDEB.isFillOrStrokeAffected)(pointerEvents, // Only a closed path can be filled.
    (polygons === null || polygons === void 0 ? void 0 : polygons.length) && fill, stroke), _isFillOrStrokeAffect2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_isFillOrStrokeAffect, 2), hasFill = _isFillOrStrokeAffect2[0], hasStroke = _isFillOrStrokeAffect2[1];
    var totalLength = (0, $2eDEB.getOrCalculatePathTotalLength)(displayObject);
    var isHit = false;
    if (hasFill || isClipPath) {
        if (hasArc) // 存在曲线时，暂时使用 canvas 的 api 计算，后续可以进行多边形切割
        isHit = isPointInPath(displayObject, position);
        else // 提取出来的多边形包含闭合的和非闭合的，在这里统一按照多边形处理
        isHit = $8f29c1ed1c035a85$var$inPolygons(polygons, position.x, position.y) || $8f29c1ed1c035a85$var$inPolygons(polylines, position.x, position.y);
        return isHit;
    }
    if (hasStroke || isClipPath) isHit = $8f29c1ed1c035a85$var$isPointInStroke(segments, lineWidth + increasedLineWidthForHitTesting, position.x, position.y, totalLength);
    return isHit;
}
function $8f29c1ed1c035a85$var$isPointInPath$4(displayObject, position, isClipPath) {
    var _ref = displayObject.parsedStyle, stroke = _ref.stroke, fill = _ref.fill, _ref$lineWidth = _ref.lineWidth, lineWidth = _ref$lineWidth === void 0 ? 1 : _ref$lineWidth, _ref$increasedLineWid = _ref.increasedLineWidthForHitTesting, increasedLineWidthForHitTesting = _ref$increasedLineWid === void 0 ? 0 : _ref$increasedLineWid, points = _ref.points, _ref$pointerEvents = _ref.pointerEvents, pointerEvents = _ref$pointerEvents === void 0 ? 'auto' : _ref$pointerEvents;
    var _isFillOrStrokeAffect = (0, $2eDEB.isFillOrStrokeAffected)(pointerEvents, fill, stroke), _isFillOrStrokeAffect2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_isFillOrStrokeAffect, 2), hasFill = _isFillOrStrokeAffect2[0], hasStroke = _isFillOrStrokeAffect2[1];
    var isHit = false;
    if (hasStroke || isClipPath) isHit = $8f29c1ed1c035a85$var$inPolyline(points.points, lineWidth + increasedLineWidthForHitTesting, position.x, position.y, true);
    if (!isHit && (hasFill || isClipPath)) isHit = $8f29c1ed1c035a85$var$inPolygon(points.points, position.x, position.y);
    return isHit;
}
function $8f29c1ed1c035a85$var$isPointInPath$3(displayObject, position, isClipPath) {
    var _ref = displayObject.parsedStyle, _ref$lineWidth = _ref.lineWidth, lineWidth = _ref$lineWidth === void 0 ? 1 : _ref$lineWidth, _ref$increasedLineWid = _ref.increasedLineWidthForHitTesting, increasedLineWidthForHitTesting = _ref$increasedLineWid === void 0 ? 0 : _ref$increasedLineWid, points = _ref.points, _ref$pointerEvents = _ref.pointerEvents, pointerEvents = _ref$pointerEvents === void 0 ? 'auto' : _ref$pointerEvents, fill = _ref.fill, stroke = _ref.stroke;
    var _isFillOrStrokeAffect = (0, $2eDEB.isFillOrStrokeAffected)(pointerEvents, fill, stroke), _isFillOrStrokeAffect2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_isFillOrStrokeAffect, 2), hasStroke = _isFillOrStrokeAffect2[1];
    if (!hasStroke && !isClipPath || !lineWidth) return false;
    return $8f29c1ed1c035a85$var$inPolyline(points.points, lineWidth + increasedLineWidthForHitTesting, position.x, position.y, false);
}
function $8f29c1ed1c035a85$var$isPointInPath$2(displayObject, position, isClipPath, isPointInPath, runtime) {
    var _ref = displayObject.parsedStyle, radius = _ref.radius, fill = _ref.fill, stroke = _ref.stroke, _ref$lineWidth = _ref.lineWidth, lineWidth = _ref$lineWidth === void 0 ? 1 : _ref$lineWidth, _ref$increasedLineWid = _ref.increasedLineWidthForHitTesting, increasedLineWidthForHitTesting = _ref$increasedLineWid === void 0 ? 0 : _ref$increasedLineWid, _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, width = _ref.width, height = _ref.height, _ref$pointerEvents = _ref.pointerEvents, pointerEvents = _ref$pointerEvents === void 0 ? 'auto' : _ref$pointerEvents;
    var _isFillOrStrokeAffect = (0, $2eDEB.isFillOrStrokeAffected)(pointerEvents, fill, stroke), _isFillOrStrokeAffect2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_isFillOrStrokeAffect, 2), hasFill = _isFillOrStrokeAffect2[0], hasStroke = _isFillOrStrokeAffect2[1];
    var hasRadius = radius && radius.some(function(r) {
        return r !== 0;
    });
    var lineWidthForHitTesting = lineWidth + increasedLineWidthForHitTesting;
    // 无圆角时的策略
    if (!hasRadius) {
        var halfWidth = lineWidthForHitTesting / 2;
        // 同时填充和带有边框
        if (hasFill && hasStroke || isClipPath) return $8f29c1ed1c035a85$var$inBox(x - halfWidth, y - halfWidth, width + halfWidth, height + halfWidth, position.x, position.y);
        // 仅填充
        if (hasFill) return $8f29c1ed1c035a85$var$inBox(x, y, width, height, position.x, position.y);
        if (hasStroke) return $8f29c1ed1c035a85$var$inRect(x, y, width, height, lineWidthForHitTesting, position.x, position.y);
    } else {
        var isHit = false;
        if (hasStroke || isClipPath) isHit = $8f29c1ed1c035a85$var$inRectWithRadius(x, y, width, height, radius.map(function(r) {
            return (0, $8hhuV.default)(r, 0, Math.min(Math.abs(width) / 2, Math.abs(height) / 2));
        }), lineWidthForHitTesting, position.x, position.y);
        // 仅填充时带有圆角的矩形直接通过图形拾取
        // 以后可以改成纯数学的近似拾取，将圆弧切割成多边形
        if (!isHit && (hasFill || isClipPath)) isHit = isPointInPath(displayObject, position);
        return isHit;
    }
    return false;
}
function $8f29c1ed1c035a85$var$inRectWithRadius(minX, minY, width, height, radiusArray, lineWidth, x, y) {
    var _radiusArray = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(radiusArray, 4), tlr = _radiusArray[0], trr = _radiusArray[1], brr = _radiusArray[2], blr = _radiusArray[3];
    return $8f29c1ed1c035a85$var$inLine(minX + tlr, minY, minX + width - trr, minY, lineWidth, x, y) || $8f29c1ed1c035a85$var$inLine(minX + width, minY + trr, minX + width, minY + height - brr, lineWidth, x, y) || $8f29c1ed1c035a85$var$inLine(minX + width - brr, minY + height, minX + blr, minY + height, lineWidth, x, y) || $8f29c1ed1c035a85$var$inLine(minX, minY + height - blr, minX, minY + tlr, lineWidth, x, y) || $8f29c1ed1c035a85$var$inArc(minX + width - trr, minY + trr, trr, 1.5 * Math.PI, 2 * Math.PI, lineWidth, x, y) || $8f29c1ed1c035a85$var$inArc(minX + width - brr, minY + height - brr, brr, 0, 0.5 * Math.PI, lineWidth, x, y) || $8f29c1ed1c035a85$var$inArc(minX + blr, minY + height - blr, blr, 0.5 * Math.PI, Math.PI, lineWidth, x, y) || $8f29c1ed1c035a85$var$inArc(minX + tlr, minY + tlr, tlr, Math.PI, 1.5 * Math.PI, lineWidth, x, y);
}
function $8f29c1ed1c035a85$var$isPointInPath$1(displayObject, position, isClipPath, isPointInPath, renderingPluginContext, runtime) {
    var _ref = displayObject.parsedStyle, _ref$pointerEvents = _ref.pointerEvents, pointerEvents = _ref$pointerEvents === void 0 ? 'auto' : _ref$pointerEvents, _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, width = _ref.width, height = _ref.height;
    if (pointerEvents === 'non-transparent-pixel') {
        var offscreenCanvas = renderingPluginContext.config.offscreenCanvas;
        var canvas = runtime.offscreenCanvasCreator.getOrCreateCanvas(offscreenCanvas);
        var context = runtime.offscreenCanvasCreator.getOrCreateContext(offscreenCanvas, {
            willReadFrequently: true
        });
        canvas.width = width;
        canvas.height = height;
        renderingPluginContext.defaultStyleRendererFactory[(0, $2eDEB.Shape).IMAGE].render(context, (0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({}, displayObject.parsedStyle), {}, {
            x: 0,
            y: 0
        }), displayObject, undefined, undefined, undefined);
        var imagedata = context.getImageData(position.x - x, position.y - y, 1, 1).data;
        return imagedata.every(function(component) {
            return component !== 0;
        });
    }
    return true;
}
function $8f29c1ed1c035a85$var$isPointInPath(displayObject, position, isClipPath, isPointInPath) {
    var bounds = displayObject.getGeometryBounds();
    // @see https://stackoverflow.com/questions/28706989/how-do-i-check-if-a-mouse-click-is-inside-a-rotated-text-on-the-html5-canvas-in
    return position.x >= bounds.min[0] && position.y >= bounds.min[1] && position.x <= bounds.max[0] && position.y <= bounds.max[1];
}
var $8f29c1ed1c035a85$var$Plugin$1 = /*#__PURE__*/ function(_AbstractRendererPlug) {
    function Plugin() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Plugin);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Plugin, [].concat(args));
        _this.name = 'canvas-picker';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Plugin, _AbstractRendererPlug);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Plugin, [
        {
            key: "init",
            value: function init() {
                var _pointInPathPickerFac;
                var pointInPathPickerFactory = (_pointInPathPickerFac = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_pointInPathPickerFac, (0, $2eDEB.Shape).CIRCLE, $8f29c1ed1c035a85$var$isPointInPath$8), (0, $2eDEB.Shape).ELLIPSE, $8f29c1ed1c035a85$var$isPointInPath$7), (0, $2eDEB.Shape).RECT, $8f29c1ed1c035a85$var$isPointInPath$2), (0, $2eDEB.Shape).LINE, $8f29c1ed1c035a85$var$isPointInPath$6), (0, $2eDEB.Shape).POLYLINE, $8f29c1ed1c035a85$var$isPointInPath$3), (0, $2eDEB.Shape).POLYGON, $8f29c1ed1c035a85$var$isPointInPath$4), (0, $2eDEB.Shape).PATH, $8f29c1ed1c035a85$var$isPointInPath$5), (0, $2eDEB.Shape).TEXT, $8f29c1ed1c035a85$var$isPointInPath), (0, $2eDEB.Shape).GROUP, null), (0, $2eDEB.Shape).IMAGE, $8f29c1ed1c035a85$var$isPointInPath$1), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_pointInPathPickerFac, (0, $2eDEB.Shape).HTML, null), (0, $2eDEB.Shape).MESH, null));
                // @ts-ignore
                this.context.pointInPathPickerFactory = pointInPathPickerFactory;
                this.addRenderingPlugin(new $8f29c1ed1c035a85$var$CanvasPickerPlugin());
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                // @ts-ignore
                delete this.context.pointInPathPickerFactory;
                this.removeAllRenderingPlugins();
            }
        }
    ]);
}((0, $2eDEB.AbstractRendererPlugin));
var $8f29c1ed1c035a85$export$95e2da5f45c14ac7 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Plugin: $8f29c1ed1c035a85$var$Plugin$1
});
function $8f29c1ed1c035a85$var$generatePath$6(context, parsedStyle) {
    var _parsedStyle$cx = parsedStyle.cx, cx = _parsedStyle$cx === void 0 ? 0 : _parsedStyle$cx, _parsedStyle$cy = parsedStyle.cy, cy = _parsedStyle$cy === void 0 ? 0 : _parsedStyle$cy, r = parsedStyle.r;
    context.arc(cx, cy, r, 0, Math.PI * 2, false);
}
function $8f29c1ed1c035a85$var$generatePath$5(context, parsedStyle) {
    var _parsedStyle$cx = parsedStyle.cx, cx = _parsedStyle$cx === void 0 ? 0 : _parsedStyle$cx, _parsedStyle$cy = parsedStyle.cy, cy = _parsedStyle$cy === void 0 ? 0 : _parsedStyle$cy, rx = parsedStyle.rx, ry = parsedStyle.ry;
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/ellipse
    if (context.ellipse) context.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2, false);
    else {
        // 如果不支持，则使用圆来绘制，进行变形
        var r = rx > ry ? rx : ry;
        var scaleX = rx > ry ? 1 : rx / ry;
        var scaleY = rx > ry ? ry / rx : 1;
        context.save();
        context.scale(scaleX, scaleY);
        context.arc(cx, cy, r, 0, Math.PI * 2);
    }
}
function $8f29c1ed1c035a85$var$generatePath$4(context, parsedStyle) {
    var x1 = parsedStyle.x1, y1 = parsedStyle.y1, x2 = parsedStyle.x2, y2 = parsedStyle.y2, markerStart = parsedStyle.markerStart, markerEnd = parsedStyle.markerEnd, markerStartOffset = parsedStyle.markerStartOffset, markerEndOffset = parsedStyle.markerEndOffset;
    var startOffsetX = 0;
    var startOffsetY = 0;
    var endOffsetX = 0;
    var endOffsetY = 0;
    var rad = 0;
    var x;
    var y;
    if (markerStart && (0, $2eDEB.isDisplayObject)(markerStart) && markerStartOffset) {
        x = x2 - x1;
        y = y2 - y1;
        rad = Math.atan2(y, x);
        startOffsetX = Math.cos(rad) * (markerStartOffset || 0);
        startOffsetY = Math.sin(rad) * (markerStartOffset || 0);
    }
    if (markerEnd && (0, $2eDEB.isDisplayObject)(markerEnd) && markerEndOffset) {
        x = x1 - x2;
        y = y1 - y2;
        rad = Math.atan2(y, x);
        endOffsetX = Math.cos(rad) * (markerEndOffset || 0);
        endOffsetY = Math.sin(rad) * (markerEndOffset || 0);
    }
    context.moveTo(x1 + startOffsetX, y1 + startOffsetY);
    context.lineTo(x2 + endOffsetX, y2 + endOffsetY);
}
function $8f29c1ed1c035a85$var$generatePath$3(context, parsedStyle) {
    var markerStart = parsedStyle.markerStart, markerEnd = parsedStyle.markerEnd, markerStartOffset = parsedStyle.markerStartOffset, markerEndOffset = parsedStyle.markerEndOffset;
    var _parsedStyle$d = parsedStyle.d, absolutePath = _parsedStyle$d.absolutePath, segments = _parsedStyle$d.segments;
    var startOffsetX = 0;
    var startOffsetY = 0;
    var endOffsetX = 0;
    var endOffsetY = 0;
    var rad = 0;
    var x;
    var y;
    if (markerStart && (0, $2eDEB.isDisplayObject)(markerStart) && markerStartOffset) {
        var _getStartTangent = markerStart.parentNode.getStartTangent(), _getStartTangent2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_getStartTangent, 2), p1 = _getStartTangent2[0], p2 = _getStartTangent2[1];
        x = p1[0] - p2[0];
        y = p1[1] - p2[1];
        rad = Math.atan2(y, x);
        startOffsetX = Math.cos(rad) * (markerStartOffset || 0);
        startOffsetY = Math.sin(rad) * (markerStartOffset || 0);
    }
    if (markerEnd && (0, $2eDEB.isDisplayObject)(markerEnd) && markerEndOffset) {
        var _getEndTangent = markerEnd.parentNode.getEndTangent(), _getEndTangent2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_getEndTangent, 2), _p = _getEndTangent2[0], _p2 = _getEndTangent2[1];
        x = _p[0] - _p2[0];
        y = _p[1] - _p2[1];
        rad = Math.atan2(y, x);
        endOffsetX = Math.cos(rad) * (markerEndOffset || 0);
        endOffsetY = Math.sin(rad) * (markerEndOffset || 0);
    }
    for(var i = 0; i < absolutePath.length; i++){
        var params = absolutePath[i];
        var command = params[0];
        var nextSegment = absolutePath[i + 1];
        var useStartOffset = i === 0 && (startOffsetX !== 0 || startOffsetY !== 0);
        var useEndOffset = (i === absolutePath.length - 1 || nextSegment && (nextSegment[0] === 'M' || nextSegment[0] === 'Z')) && endOffsetX !== 0 && endOffsetY !== 0;
        var _ref = useStartOffset ? [
            startOffsetX,
            startOffsetY
        ] : [
            0,
            0
        ], _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref, 2), startOffsetXTemp = _ref2[0], startOffsetYTemp = _ref2[1];
        var _ref3 = useEndOffset ? [
            endOffsetX,
            endOffsetY
        ] : [
            0,
            0
        ], _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_ref3, 2), endOffsetXTemp = _ref4[0], endOffsetYTemp = _ref4[1];
        switch(command){
            case 'M':
                // Use start marker offset
                context.moveTo(params[1] + startOffsetXTemp, params[2] + startOffsetYTemp);
                break;
            case 'L':
                context.lineTo(params[1] + endOffsetXTemp, params[2] + endOffsetYTemp);
                break;
            case 'Q':
                context.quadraticCurveTo(params[1], params[2], params[3] + endOffsetXTemp, params[4] + endOffsetYTemp);
                break;
            case 'C':
                context.bezierCurveTo(params[1], params[2], params[3], params[4], params[5] + endOffsetXTemp, params[6] + endOffsetYTemp);
                break;
            case 'A':
                // FIXME startOffset / endOffset
                var arcParams = segments[i].arcParams;
                var cx = arcParams.cx, cy = arcParams.cy, rx = arcParams.rx, ry = arcParams.ry, startAngle = arcParams.startAngle, endAngle = arcParams.endAngle, xRotation = arcParams.xRotation, sweepFlag = arcParams.sweepFlag;
                // @see https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/ellipse
                if (context.ellipse) context.ellipse(cx, cy, rx, ry, xRotation, startAngle, endAngle, !!(1 - sweepFlag));
                else {
                    // @see https://stackoverflow.com/a/47494351
                    var r = rx > ry ? rx : ry;
                    var scaleX = rx > ry ? 1 : rx / ry;
                    var scaleY = rx > ry ? ry / rx : 1;
                    context.translate(cx, cy);
                    context.rotate(xRotation);
                    context.scale(scaleX, scaleY);
                    context.arc(0, 0, r, startAngle, endAngle, !!(1 - sweepFlag));
                    context.scale(1 / scaleX, 1 / scaleY);
                    context.rotate(-xRotation);
                    context.translate(-cx, -cy);
                }
                if (useEndOffset) context.lineTo(params[6] + endOffsetX, params[7] + endOffsetY);
                break;
            case 'Z':
                context.closePath();
                break;
        }
    }
}
function $8f29c1ed1c035a85$var$generatePath$2(context, parsedStyle) {
    var markerStart = parsedStyle.markerStart, markerEnd = parsedStyle.markerEnd, markerStartOffset = parsedStyle.markerStartOffset, markerEndOffset = parsedStyle.markerEndOffset;
    var points = parsedStyle.points.points;
    var length = points.length;
    var x1 = points[0][0];
    var y1 = points[0][1];
    var x2 = points[length - 1][0];
    var y2 = points[length - 1][1];
    var startOffsetX = 0;
    var startOffsetY = 0;
    var endOffsetX = 0;
    var endOffsetY = 0;
    var rad = 0;
    var x;
    var y;
    if (markerStart && (0, $2eDEB.isDisplayObject)(markerStart) && markerStartOffset) {
        x = points[1][0] - points[0][0];
        y = points[1][1] - points[0][1];
        rad = Math.atan2(y, x);
        startOffsetX = Math.cos(rad) * (markerStartOffset || 0);
        startOffsetY = Math.sin(rad) * (markerStartOffset || 0);
    }
    if (markerEnd && (0, $2eDEB.isDisplayObject)(markerEnd) && markerEndOffset) {
        x = points[length - 1][0] - points[0][0];
        y = points[length - 1][1] - points[0][1];
        rad = Math.atan2(y, x);
        endOffsetX = Math.cos(rad) * (markerEndOffset || 0);
        endOffsetY = Math.sin(rad) * (markerEndOffset || 0);
    }
    context.moveTo(x1 + (startOffsetX || endOffsetX), y1 + (startOffsetY || endOffsetY));
    for(var i = 1; i < length - 1; i++){
        var point = points[i];
        context.lineTo(point[0], point[1]);
    }
    context.lineTo(x2, y2);
}
function $8f29c1ed1c035a85$var$generatePath$1(context, parsedStyle) {
    var markerStart = parsedStyle.markerStart, markerEnd = parsedStyle.markerEnd, markerStartOffset = parsedStyle.markerStartOffset, markerEndOffset = parsedStyle.markerEndOffset;
    var points = parsedStyle.points.points;
    var length = points.length;
    var x1 = points[0][0];
    var y1 = points[0][1];
    var x2 = points[length - 1][0];
    var y2 = points[length - 1][1];
    var startOffsetX = 0;
    var startOffsetY = 0;
    var endOffsetX = 0;
    var endOffsetY = 0;
    var rad = 0;
    var x;
    var y;
    if (markerStart && (0, $2eDEB.isDisplayObject)(markerStart) && markerStartOffset) {
        x = points[1][0] - points[0][0];
        y = points[1][1] - points[0][1];
        rad = Math.atan2(y, x);
        startOffsetX = Math.cos(rad) * (markerStartOffset || 0);
        startOffsetY = Math.sin(rad) * (markerStartOffset || 0);
    }
    if (markerEnd && (0, $2eDEB.isDisplayObject)(markerEnd) && markerEndOffset) {
        x = points[length - 2][0] - points[length - 1][0];
        y = points[length - 2][1] - points[length - 1][1];
        rad = Math.atan2(y, x);
        endOffsetX = Math.cos(rad) * (markerEndOffset || 0);
        endOffsetY = Math.sin(rad) * (markerEndOffset || 0);
    }
    context.moveTo(x1 + startOffsetX, y1 + startOffsetY);
    for(var i = 1; i < length - 1; i++){
        var point = points[i];
        context.lineTo(point[0], point[1]);
    }
    context.lineTo(x2 + endOffsetX, y2 + endOffsetY);
}
function $8f29c1ed1c035a85$var$generatePath(context, parsedStyle) {
    var _parsedStyle$x = parsedStyle.x, x = _parsedStyle$x === void 0 ? 0 : _parsedStyle$x, _parsedStyle$y = parsedStyle.y, y = _parsedStyle$y === void 0 ? 0 : _parsedStyle$y, radius = parsedStyle.radius, width = parsedStyle.width, height = parsedStyle.height;
    var w = width;
    var h = height;
    var hasRadius = radius && radius.some(function(r) {
        return r !== 0;
    });
    if (!hasRadius) // Canvas support negative width/height of rect
    context.rect(x, y, w, h);
    else {
        var signX = width > 0 ? 1 : -1;
        var signY = height > 0 ? 1 : -1;
        var sweepFlag = signX + signY === 0;
        var _radius$map = radius.map(function(r) {
            return (0, $8hhuV.default)(r, 0, Math.min(Math.abs(w) / 2, Math.abs(h) / 2));
        }), _radius$map2 = (0, (/*@__PURE__*/$parcel$interopDefault($02Ztr)))(_radius$map, 4), tlr = _radius$map2[0], trr = _radius$map2[1], brr = _radius$map2[2], blr = _radius$map2[3];
        context.moveTo(signX * tlr + x, y);
        context.lineTo(w - signX * trr + x, y);
        if (trr !== 0) context.arc(w - signX * trr + x, signY * trr + y, trr, -signY * Math.PI / 2, signX > 0 ? 0 : Math.PI, sweepFlag);
        context.lineTo(w + x, h - signY * brr + y);
        if (brr !== 0) context.arc(w - signX * brr + x, h - signY * brr + y, brr, signX > 0 ? 0 : Math.PI, signY > 0 ? Math.PI / 2 : 1.5 * Math.PI, sweepFlag);
        context.lineTo(signX * blr + x, h + y);
        if (blr !== 0) context.arc(signX * blr + x, h - signY * blr + y, blr, signY > 0 ? Math.PI / 2 : -Math.PI / 2, signX > 0 ? Math.PI : 0, sweepFlag);
        context.lineTo(x, signY * tlr + y);
        if (tlr !== 0) context.arc(signX * tlr + x, signY * tlr + y, tlr, signX > 0 ? Math.PI : 0, signY > 0 ? Math.PI * 1.5 : Math.PI / 2, sweepFlag);
    }
}
var $8f29c1ed1c035a85$var$Plugin = /*#__PURE__*/ function(_AbstractRendererPlug) {
    function Plugin() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Plugin);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Plugin, [].concat(args));
        _this.name = 'canvas-path-generator';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Plugin, _AbstractRendererPlug);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Plugin, [
        {
            key: "init",
            value: function init() {
                var _pathGeneratorFactory;
                var pathGeneratorFactory = (_pathGeneratorFactory = {}, (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_pathGeneratorFactory, (0, $2eDEB.Shape).CIRCLE, $8f29c1ed1c035a85$var$generatePath$6), (0, $2eDEB.Shape).ELLIPSE, $8f29c1ed1c035a85$var$generatePath$5), (0, $2eDEB.Shape).RECT, $8f29c1ed1c035a85$var$generatePath), (0, $2eDEB.Shape).LINE, $8f29c1ed1c035a85$var$generatePath$4), (0, $2eDEB.Shape).POLYLINE, $8f29c1ed1c035a85$var$generatePath$1), (0, $2eDEB.Shape).POLYGON, $8f29c1ed1c035a85$var$generatePath$2), (0, $2eDEB.Shape).PATH, $8f29c1ed1c035a85$var$generatePath$3), (0, $2eDEB.Shape).TEXT, undefined), (0, $2eDEB.Shape).GROUP, undefined), (0, $2eDEB.Shape).IMAGE, undefined), (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))(_pathGeneratorFactory, (0, $2eDEB.Shape).HTML, undefined), (0, $2eDEB.Shape).MESH, undefined), (0, $2eDEB.Shape).FRAGMENT, undefined));
                // @ts-ignore
                this.context.pathGeneratorFactory = pathGeneratorFactory;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                // @ts-ignore
                delete this.context.pathGeneratorFactory;
            }
        }
    ]);
}((0, $2eDEB.AbstractRendererPlugin));
var $8f29c1ed1c035a85$export$c2abd4e5b35f46a7 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Plugin: $8f29c1ed1c035a85$var$Plugin
});
var $8f29c1ed1c035a85$var$Canvas2DContextService = /*#__PURE__*/ function() {
    function Canvas2DContextService(context) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Canvas2DContextService);
        this.renderingContext = context.renderingContext;
        this.canvasConfig = context.config;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Canvas2DContextService, [
        {
            key: "init",
            value: function init() {
                var _this$canvasConfig = this.canvasConfig, container = _this$canvasConfig.container, canvas = _this$canvasConfig.canvas;
                if (canvas) {
                    this.$canvas = canvas;
                    if (container && canvas.parentElement !== container) container.appendChild(canvas);
                    this.$container = canvas.parentElement;
                    this.canvasConfig.container = this.$container;
                } else if (container) {
                    // create container
                    this.$container = (0, $kVcyu.default)(container) ? document.getElementById(container) : container;
                    if (this.$container) {
                        // create canvas
                        var $canvas = document.createElement('canvas');
                        this.$container.appendChild($canvas);
                        if (!this.$container.style.position) this.$container.style.position = 'relative';
                        this.$canvas = $canvas;
                    }
                }
                this.context = this.$canvas.getContext('2d');
                this.resize(this.canvasConfig.width, this.canvasConfig.height);
            }
        },
        {
            key: "getContext",
            value: function getContext() {
                return this.context;
            }
        },
        {
            key: "getDomElement",
            value: function getDomElement() {
                return this.$canvas;
            }
        },
        {
            key: "getDPR",
            value: function getDPR() {
                return this.dpr;
            }
        },
        {
            key: "getBoundingClientRect",
            value: function getBoundingClientRect() {
                if (this.$canvas.getBoundingClientRect) return this.$canvas.getBoundingClientRect();
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                // @ts-ignore
                if (this.$container && this.$canvas && this.$canvas.parentNode) // destroy context
                // @ts-ignore
                this.$container.removeChild(this.$canvas);
            }
        },
        {
            key: "resize",
            value: function resize(width, height) {
                var dpr = this.canvasConfig.devicePixelRatio;
                this.dpr = dpr;
                if (this.$canvas) {
                    // set canvas width & height
                    this.$canvas.width = this.dpr * width;
                    this.$canvas.height = this.dpr * height;
                    // set CSS style width & height
                    (0, $2eDEB.setDOMSize)(this.$canvas, width, height);
                // const dpr = this.getDPR();
                // scale all drawing operations by the dpr
                // @see https://www.html5rocks.com/en/tutorials/canvas/hidpi/
                // this.context.scale(dpr, dpr);
                }
                this.renderingContext.renderReasons.add((0, $2eDEB.RenderReason).CAMERA_CHANGED);
            }
        },
        {
            key: "applyCursorStyle",
            value: function applyCursorStyle(cursor) {
                if (this.$container && this.$container.style) this.$container.style.cursor = cursor;
            }
        },
        {
            key: "toDataURL",
            value: function() {
                var _toDataURL = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee() {
                    var options, type, encoderOptions, _args = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                                type = options.type, encoderOptions = options.encoderOptions;
                                return _context.abrupt("return", this.context.canvas.toDataURL(type, encoderOptions));
                            case 1:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function toDataURL() {
                    return _toDataURL.apply(this, arguments);
                }
                return toDataURL;
            }()
        }
    ]);
}();
var $8f29c1ed1c035a85$var$ContextRegisterPlugin = /*#__PURE__*/ function(_AbstractRendererPlug) {
    function ContextRegisterPlugin() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, ContextRegisterPlugin);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, ContextRegisterPlugin, [].concat(args));
        _this.name = 'canvas-context-register';
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(ContextRegisterPlugin, _AbstractRendererPlug);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(ContextRegisterPlugin, [
        {
            key: "init",
            value: function init() {
                this.context.ContextService = $8f29c1ed1c035a85$var$Canvas2DContextService;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                delete this.context.ContextService;
            }
        }
    ]);
}((0, $2eDEB.AbstractRendererPlugin));
var $8f29c1ed1c035a85$export$88530751e3977073 = /*#__PURE__*/ function(_AbstractRenderer) {
    function Renderer(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Renderer);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Renderer, [
            config
        ]);
        // register Canvas2DContext
        _this.registerPlugin(new $8f29c1ed1c035a85$var$ContextRegisterPlugin());
        _this.registerPlugin(new (0, $2eDEB.ImageLoader).Plugin());
        _this.registerPlugin(new $8f29c1ed1c035a85$var$Plugin());
        // enable rendering with Canvas2D API
        _this.registerPlugin(new $8f29c1ed1c035a85$var$Plugin$2());
        _this.registerPlugin(new (0, $2eDEB.DomInteraction).Plugin());
        // enable picking with Canvas2D API
        _this.registerPlugin(new $8f29c1ed1c035a85$var$Plugin$1());
        // render HTML component
        _this.registerPlugin(new (0, $2eDEB.HTMLRenderer).Plugin());
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Renderer, _AbstractRenderer);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Renderer);
}((0, $2eDEB.AbstractRenderer));

});
parcelRegister("i2oVb", function(module, exports) {
function $d21bbebee4d2f046$var$_classPrivateFieldBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
module.exports = $d21bbebee4d2f046$var$_classPrivateFieldBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("khiUY", function(module, exports) {
var $ec3411dd85e57308$var$id = 0;
function $ec3411dd85e57308$var$_classPrivateFieldKey(e) {
    return "__private_" + $ec3411dd85e57308$var$id++ + "_" + e;
}
module.exports = $ec3411dd85e57308$var$_classPrivateFieldKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cyCCc", function(module, exports) {

$parcel$export(module.exports, "default", () => $92469d2572ce1e44$export$2e2bcd8739ae039);

var $dZz8z = parcelRequire("dZz8z");

var $1RAzq = parcelRequire("1RAzq");
var $92469d2572ce1e44$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $92469d2572ce1e44$export$2e2bcd8739ae039 = function(object, keys) {
    if (object === null || !(0, $1RAzq.default)(object)) return {};
    var result = {};
    (0, $dZz8z.default)(keys, function(key) {
        if ($92469d2572ce1e44$var$hasOwnProperty.call(object, key)) result[key] = object[key];
    });
    return result;
};

});
parcelRegister("dZz8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $a2fc3a66183e8c76$export$2e2bcd8739ae039);

var $1uF5a = parcelRequire("1uF5a");

var $6JKSc = parcelRequire("6JKSc");
function $a2fc3a66183e8c76$var$each(elements, func) {
    if (!elements) return;
    var rst;
    if ((0, $1uF5a.default)(elements)) for(var i = 0, len = elements.length; i < len; i++){
        rst = func(elements[i], i);
        if (rst === false) break;
    }
    else if ((0, $6JKSc.default)(elements)) {
        for(var k in elements)if (elements.hasOwnProperty(k)) {
            rst = func(elements[k], k);
            if (rst === false) break;
        }
    }
}
var $a2fc3a66183e8c76$export$2e2bcd8739ae039 = $a2fc3a66183e8c76$var$each;

});



parcelRegister("gF4ts", function(module, exports) {

$parcel$export(module.exports, "Image", () => $c213f2277ceb7451$export$3e431a229df88919);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $hXCXB = parcelRequire("hXCXB");

var $icwVF = parcelRequire("icwVF");

var $j4n8g = parcelRequire("j4n8g");

var $dOidW = parcelRequire("dOidW");
parcelRequire("hIZ0D");
var $hy6NM = parcelRequire("hy6NM");

var $hy6NM = parcelRequire("hy6NM");

var $63haX = parcelRequire("63haX");
var $c213f2277ceb7451$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $c213f2277ceb7451$export$3e431a229df88919 extends (0, $63haX.BaseNode) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $c213f2277ceb7451$export$3e431a229df88919.defaultStyleProps
        }, options));
    }
    getKeyStyle(attributes) {
        const [width, height] = this.getSize(attributes);
        const _a = super.getKeyStyle(attributes), { fillOpacity: fillOpacity, opacity: opacity = fillOpacity } = _a, keyStyle = $c213f2277ceb7451$var$__rest(_a, [
            "fillOpacity",
            "opacity"
        ]);
        return Object.assign(Object.assign({
            opacity: opacity
        }, keyStyle), {
            width: width,
            height: height,
            x: -width / 2,
            y: -height / 2
        });
    }
    getBounds() {
        return this.getShape('key').getBounds();
    }
    getHaloStyle(attributes) {
        if (attributes.halo === false) return false;
        const _a = this.getShape('key').attributes, { fill: keyStyleFill, stroke: keyStyleStroke } = _a, keyStyle = $c213f2277ceb7451$var$__rest(_a, [
            "fill",
            "stroke"
        ]);
        const haloStyle = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'halo');
        const haloLineWidth = Number(haloStyle.lineWidth);
        const [width, height] = (0, $dOidW.add)(this.getSize(attributes), [
            haloLineWidth,
            haloLineWidth
        ]);
        const { lineWidth: lineWidth } = haloStyle;
        const recalculate = {
            fill: 'transparent',
            lineWidth: lineWidth / 2,
            width: width - lineWidth / 2,
            height: height - lineWidth / 2,
            x: -(width - lineWidth / 2) / 2,
            y: -(height - lineWidth / 2) / 2
        };
        return Object.assign(Object.assign({}, haloStyle), recalculate);
    }
    getIconStyle(attributes) {
        const style = super.getIconStyle(attributes);
        const [width, height] = this.getSize(attributes);
        return style ? Object.assign({
            width: width * (0, $hXCXB.ICON_SIZE_RATIO),
            height: height * (0, $hXCXB.ICON_SIZE_RATIO)
        }, style) : false;
    }
    drawKeyShape(attributes, container) {
        const image = this.upsert('key', (0, $hy6NM.Image), this.getKeyStyle(attributes), container);
        (0, $hy6NM.connectImage)(this);
        return image;
    }
    drawHaloShape(attributes, container) {
        this.upsert('halo', (0, $2eDEB.Rect), this.getHaloStyle(attributes), container);
    }
    update(attr) {
        super.update(attr);
        if (attr && ('x' in attr || 'y' in attr || 'z' in attr)) (0, $hy6NM.dispatchPositionChange)(this);
    }
}
$c213f2277ceb7451$export$3e431a229df88919.defaultStyleProps = {
    size: 32
};

});

parcelRegister("3VmXJ", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $2db881d4114e81f8$export$c79fc6492f3af13d);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $hXCXB = parcelRequire("hXCXB");

var $63haX = parcelRequire("63haX");
class $2db881d4114e81f8$export$c79fc6492f3af13d extends (0, $63haX.BaseNode) {
    constructor(options){
        super(options);
    }
    getKeyStyle(attributes) {
        const [width, height] = this.getSize(attributes);
        return Object.assign(Object.assign({}, super.getKeyStyle(attributes)), {
            width: width,
            height: height,
            x: -width / 2,
            y: -height / 2
        });
    }
    getIconStyle(attributes) {
        const style = super.getIconStyle(attributes);
        const { width: width, height: height } = this.getShape('key').attributes;
        return style ? Object.assign({
            width: width * (0, $hXCXB.ICON_SIZE_RATIO),
            height: height * (0, $hXCXB.ICON_SIZE_RATIO)
        }, style) : false;
    }
    drawKeyShape(attributes, container) {
        return this.upsert('key', (0, $2eDEB.Rect), this.getKeyStyle(attributes), container);
    }
}

});

parcelRegister("d1sdh", function(module, exports) {

$parcel$export(module.exports, "Star", () => $97b140eef4b959a7$export$1644ba17714857f1);

var $hXCXB = parcelRequire("hXCXB");

var $hn4z6 = parcelRequire("hn4z6");

var $jv6O2 = parcelRequire("jv6O2");
class $97b140eef4b959a7$export$1644ba17714857f1 extends (0, $jv6O2.Polygon) {
    constructor(options){
        super(options);
    }
    getInnerR(attributes) {
        return attributes.innerR || this.getOuterR(attributes) * 3 / 8;
    }
    getOuterR(attributes) {
        return Math.min(...this.getSize(attributes)) / 2;
    }
    getPoints(attributes) {
        return (0, $hn4z6.getStarPoints)(this.getOuterR(attributes), this.getInnerR(attributes));
    }
    getIconStyle(attributes) {
        const style = super.getIconStyle(attributes);
        const size = this.getInnerR(attributes) * 2 * (0, $hXCXB.ICON_SIZE_RATIO);
        return style ? Object.assign({
            width: size,
            height: size
        }, style) : false;
    }
    getPortXY(attributes, style) {
        const { placement: placement = 'top' } = style;
        const bbox = this.getShape('key').getLocalBounds();
        const ports = (0, $hn4z6.getStarPorts)(this.getOuterR(attributes), this.getInnerR(attributes));
        return (0, $hn4z6.getPortXYByPlacement)(bbox, placement, ports, false);
    }
}

});

parcelRegister("dIvRz", function(module, exports) {

$parcel$export(module.exports, "Triangle", () => $9fc819c787885670$export$5a465592bfe74b48);

var $hllqz = parcelRequire("hllqz");

var $hXCXB = parcelRequire("hXCXB");

var $6BVcW = parcelRequire("6BVcW");

var $hn4z6 = parcelRequire("hn4z6");

var $icwVF = parcelRequire("icwVF");

var $j4n8g = parcelRequire("j4n8g");

var $jv6O2 = parcelRequire("jv6O2");
class $9fc819c787885670$export$5a465592bfe74b48 extends (0, $jv6O2.Polygon) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $9fc819c787885670$export$5a465592bfe74b48.defaultStyleProps
        }, options));
    }
    getPoints(attributes) {
        const { direction: direction } = attributes;
        const [width, height] = this.getSize(attributes);
        return (0, $hn4z6.getTrianglePoints)(width, height, direction);
    }
    getPortXY(attributes, style) {
        const { direction: direction } = attributes;
        const { placement: placement = 'top' } = style;
        const bbox = this.getShape('key').getLocalBounds();
        const [width, height] = this.getSize(attributes);
        const ports = (0, $hn4z6.getTrianglePorts)(width, height, direction);
        return (0, $hn4z6.getPortXYByPlacement)(bbox, placement, ports, false);
    }
    // icon 处于内切三角形的重心
    // icon is at the centroid of the triangle
    getIconStyle(attributes) {
        const { icon: icon, iconText: iconText, iconSrc: iconSrc, direction: direction } = attributes;
        if (icon === false || (0, $hllqz.default)(iconText || iconSrc)) return false;
        const iconStyle = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'icon');
        const bbox = this.getShape('key').getLocalBounds();
        const [x, y] = (0, $6BVcW.getTriangleCenter)(bbox, direction);
        const size = (0, $6BVcW.getIncircleRadius)(bbox, direction) * 2 * (0, $hXCXB.ICON_SIZE_RATIO);
        return Object.assign({
            x: x,
            y: y,
            width: size,
            height: size
        }, iconStyle);
    }
}
$9fc819c787885670$export$5a465592bfe74b48.defaultStyleProps = {
    size: 40,
    direction: 'up'
};

});



parcelRegister("f2zuq", function(module, exports) {

$parcel$export(module.exports, "CircleCombo", () => $af3292769fdacda2$export$816ecb609cdd707f);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $6BVcW = parcelRequire("6BVcW");

var $dnXls = parcelRequire("dnXls");

var $icwVF = parcelRequire("icwVF");

var $e6Msm = parcelRequire("e6Msm");

var $jK4lK = parcelRequire("jK4lK");
class $af3292769fdacda2$export$816ecb609cdd707f extends (0, $jK4lK.BaseCombo) {
    constructor(options){
        super(options);
    }
    drawKeyShape(attributes, container) {
        return this.upsert('key', (0, $2eDEB.Circle), this.getKeyStyle(attributes), container);
    }
    getKeyStyle(attributes) {
        const { collapsed: collapsed } = attributes;
        const keyStyle = super.getKeyStyle(attributes);
        const [width] = this.getKeySize(attributes);
        return Object.assign(Object.assign(Object.assign({}, keyStyle), collapsed && (0, $icwVF.subStyleProps)(keyStyle, 'collapsed')), {
            r: width / 2
        });
    }
    getCollapsedKeySize(attributes) {
        const [collapsedWidth, collapsedHeight] = (0, $e6Msm.parseSize)(attributes.collapsedSize);
        const collapsedR = Math.max(collapsedWidth, collapsedHeight) / 2;
        return [
            collapsedR * 2,
            collapsedR * 2,
            0
        ];
    }
    getExpandedKeySize(attributes) {
        const contentBBox = this.getContentBBox(attributes);
        const [width, height] = (0, $6BVcW.getBBoxSize)(contentBBox);
        const expandedR = Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)) / 2;
        return [
            expandedR * 2,
            expandedR * 2,
            0
        ];
    }
    getIntersectPoint(point, useExtendedLine = false) {
        const keyShapeBounds = this.getShape('key').getBounds();
        return (0, $dnXls.getEllipseIntersectPoint)(point, keyShapeBounds, useExtendedLine);
    }
}

});

parcelRegister("4zzq7", function(module, exports) {

$parcel$export(module.exports, "RectCombo", () => $3545e80366c51d77$export$a1de11ce8b712e84);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $icwVF = parcelRequire("icwVF");

var $jK4lK = parcelRequire("jK4lK");
class $3545e80366c51d77$export$a1de11ce8b712e84 extends (0, $jK4lK.BaseCombo) {
    constructor(options){
        super(options);
    }
    drawKeyShape(attributes, container) {
        return this.upsert('key', (0, $2eDEB.Rect), this.getKeyStyle(attributes), container);
    }
    getKeyStyle(attributes) {
        const keyStyle = super.getKeyStyle(attributes);
        const [width, height] = this.getKeySize(attributes);
        return Object.assign(Object.assign(Object.assign({}, keyStyle), attributes.collapsed && (0, $icwVF.subStyleProps)(keyStyle, 'collapsed')), {
            width: width,
            height: height,
            x: -width / 2,
            y: -height / 2
        });
    }
}

});


parcelRegister("l6dDw", function(module, exports) {

$parcel$export(module.exports, "BaseEdge", () => (parcelRequire("clFkI")).BaseEdge);
$parcel$export(module.exports, "Cubic", () => (parcelRequire("4tI2g")).Cubic);
$parcel$export(module.exports, "CubicHorizontal", () => (parcelRequire("hjONv")).CubicHorizontal);
$parcel$export(module.exports, "CubicRadial", () => (parcelRequire("bs4me")).CubicRadial);
$parcel$export(module.exports, "CubicVertical", () => (parcelRequire("ln2PG")).CubicVertical);
$parcel$export(module.exports, "Line", () => (parcelRequire("95A9Q")).Line);
$parcel$export(module.exports, "Polyline", () => (parcelRequire("5felS")).Polyline);
$parcel$export(module.exports, "Quadratic", () => (parcelRequire("Fb2Dh")).Quadratic);

var $clFkI = parcelRequire("clFkI");

var $4tI2g = parcelRequire("4tI2g");

var $hjONv = parcelRequire("hjONv");

var $bs4me = parcelRequire("bs4me");

var $ln2PG = parcelRequire("ln2PG");

var $95A9Q = parcelRequire("95A9Q");

var $5felS = parcelRequire("5felS");

var $Fb2Dh = parcelRequire("Fb2Dh");

});
parcelRegister("clFkI", function(module, exports) {

$parcel$export(module.exports, "BaseEdge", () => $8fd782189a6e4844$export$b746b7c1be3cefa0);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $ky7aH = parcelRequire("ky7aH");
var $cyCCc = parcelRequire("cyCCc");

var $6BVcW = parcelRequire("6BVcW");

var $25dP3 = parcelRequire("25dP3");

var $hn4z6 = parcelRequire("hn4z6");

var $icwVF = parcelRequire("icwVF");

var $e6Msm = parcelRequire("e6Msm");

var $j4n8g = parcelRequire("j4n8g");

var $dkVLZ = parcelRequire("dkVLZ");

var $jwYMH = parcelRequire("jwYMH");

var $14Eyx = parcelRequire("14Eyx");
parcelRequire("hIZ0D");
var $2jk2f = parcelRequire("2jk2f");
var $1DkzN = parcelRequire("1DkzN");
var $8fd782189a6e4844$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $8fd782189a6e4844$export$b746b7c1be3cefa0 extends (0, $14Eyx.BaseElement) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $8fd782189a6e4844$export$b746b7c1be3cefa0.defaultStyleProps
        }, options));
        this.type = 'edge';
    }
    get sourceNode() {
        const { sourceNode: source } = this.parsedAttributes;
        return this.context.element.getElement(source);
    }
    get targetNode() {
        const { targetNode: target } = this.parsedAttributes;
        return this.context.element.getElement(target);
    }
    getKeyStyle(attributes) {
        const _a = this.getGraphicStyle(attributes), { loop: loop } = _a, style = $8fd782189a6e4844$var$__rest(_a, [
            "loop"
        ]);
        const { sourceNode: sourceNode, targetNode: targetNode } = this;
        const d = loop && (0, $hn4z6.isSameNode)(sourceNode, targetNode) ? this.getLoopPath(attributes) : this.getKeyPath(attributes);
        const keyStyle = {
            d: d
        };
        (0, $2eDEB.Path).PARSED_STYLE_LIST.forEach((key)=>{
            // @ts-expect-error skip type error
            if (key in style) keyStyle[key] = style[key];
        });
        return keyStyle;
    }
    getLoopPath(attributes) {
        const { sourcePort: sourcePort, targetPort: targetPort } = attributes;
        const node = this.sourceNode;
        const bbox = (0, $6BVcW.getNodeBBox)(node);
        const defaultDist = Math.max((0, $6BVcW.getBBoxWidth)(bbox), (0, $6BVcW.getBBoxHeight)(bbox));
        const { placement: placement, clockwise: clockwise, dist: dist = defaultDist } = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'loop');
        return (0, $25dP3.getCubicLoopPath)(node, placement, clockwise, dist, sourcePort, targetPort);
    }
    getEndpoints(attributes, optimize = true, controlPoints = []) {
        const { sourcePort: sourcePortKey, targetPort: targetPortKey } = attributes;
        const { sourceNode: sourceNode, targetNode: targetNode } = this;
        const [sourcePort, targetPort] = (0, $hn4z6.findPorts)(sourceNode, targetNode, sourcePortKey, targetPortKey);
        if (!optimize) {
            const sourcePoint = sourcePort ? (0, $hn4z6.getPortPosition)(sourcePort) : sourceNode.getCenter();
            const targetPoint = targetPort ? (0, $hn4z6.getPortPosition)(targetPort) : targetNode.getCenter();
            return [
                sourcePoint,
                targetPoint
            ];
        }
        const _controlPoints = typeof controlPoints === 'function' ? controlPoints() : controlPoints;
        const sourcePoint = (0, $hn4z6.getConnectionPoint)(sourcePort || sourceNode, _controlPoints[0] || targetPort || targetNode);
        const targetPoint = (0, $hn4z6.getConnectionPoint)(targetPort || targetNode, _controlPoints[_controlPoints.length - 1] || sourcePort || sourceNode);
        return [
            sourcePoint,
            targetPoint
        ];
    }
    getHaloStyle(attributes) {
        if (attributes.halo === false) return false;
        const keyStyle = this.getKeyStyle(attributes);
        const haloStyle = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'halo');
        return Object.assign(Object.assign({}, keyStyle), haloStyle);
    }
    getLabelStyle(attributes) {
        if (attributes.label === false || !attributes.labelText) return false;
        const labelStyle = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'label');
        const { placement: placement, offsetX: offsetX, offsetY: offsetY, autoRotate: autoRotate, maxWidth: maxWidth } = labelStyle, restStyle = $8fd782189a6e4844$var$__rest(labelStyle, [
            "placement",
            "offsetX",
            "offsetY",
            "autoRotate",
            "maxWidth"
        ]);
        const labelPositionStyle = (0, $25dP3.getLabelPositionStyle)(this.shapeMap.key, placement, autoRotate, offsetX, offsetY);
        const bbox = this.shapeMap.key.getLocalBounds();
        const wordWrapWidth = (0, $jwYMH.getWordWrapWidthByEnds)([
            bbox.min,
            bbox.max
        ], maxWidth);
        return Object.assign({
            wordWrapWidth: wordWrapWidth
        }, labelPositionStyle, restStyle);
    }
    getBadgeStyle(attributes) {
        if (attributes.badge === false || !attributes.badgeText) return false;
        const _a = (0, $icwVF.subStyleProps)(attributes, 'badge'), { offsetX: offsetX, offsetY: offsetY, placement: placement } = _a, badgeStyle = $8fd782189a6e4844$var$__rest(_a, [
            "offsetX",
            "offsetY",
            "placement"
        ]);
        return Object.assign(badgeStyle, (0, $25dP3.getBadgePositionStyle)(this.shapeMap, placement, attributes.labelPlacement, offsetX, offsetY));
    }
    drawArrow(attributes, type) {
        var _a;
        const isStart = type === 'start';
        const arrowType = type === 'start' ? 'startArrow' : 'endArrow';
        const enable = attributes[arrowType];
        const keyShape = this.shapeMap.key;
        if (enable) {
            const arrowStyle = this.getArrowStyle(attributes, isStart);
            const [marker, markerOffset, arrowOffset] = isStart ? [
                'markerStart',
                'markerStartOffset',
                'startArrowOffset'
            ] : [
                'markerEnd',
                'markerEndOffset',
                'endArrowOffset'
            ];
            const arrow = keyShape.parsedStyle[marker];
            // update
            if (arrow) arrow.attr(arrowStyle);
            else {
                const Ctor = arrowStyle.src ? (0, $2eDEB.Image) : (0, $2eDEB.Path);
                const arrowShape = new Ctor({
                    style: arrowStyle
                });
                keyShape.style[marker] = arrowShape;
            }
            keyShape.style[markerOffset] = attributes[arrowOffset] || arrowStyle.width / 2 + +arrowStyle.lineWidth;
        } else {
            // destroy
            const marker = isStart ? 'markerStart' : 'markerEnd';
            (_a = keyShape.style[marker]) === null || _a === void 0 || _a.destroy();
            keyShape.style[marker] = null;
        }
    }
    getArrowStyle(attributes, isStart) {
        const keyStyle = this.getShape('key').attributes;
        const arrowType = isStart ? 'startArrow' : 'endArrow';
        const _a = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), arrowType), { size: size, type: type } = _a, arrowStyle = $8fd782189a6e4844$var$__rest(_a, [
            "size",
            "type"
        ]);
        const [width, height] = (0, $e6Msm.parseSize)((0, $25dP3.getArrowSize)(keyStyle.lineWidth, size));
        const arrowFn = (0, $ky7aH.default)(type) ? type : $dkVLZ[type] || $dkVLZ.triangle;
        const d = arrowFn(width, height);
        return Object.assign((0, $cyCCc.default)(keyStyle, [
            'stroke',
            'strokeOpacity',
            'fillOpacity'
        ]), {
            width: width,
            height: height
        }, Object.assign({}, d && {
            d: d,
            fill: type === 'simple' ? '' : keyStyle.stroke
        }), arrowStyle);
    }
    drawLabelShape(attributes, container) {
        const style = this.getLabelStyle(attributes);
        this.upsert('label', (0, $1DkzN.Label), style, container);
    }
    drawHaloShape(attributes, container) {
        const style = this.getHaloStyle(attributes);
        this.upsert('halo', (0, $2eDEB.Path), style, container);
    }
    drawBadgeShape(attributes, container) {
        const style = this.getBadgeStyle(attributes);
        this.upsert('badge', (0, $2jk2f.Badge), style, container);
    }
    drawSourceArrow(attributes) {
        this.drawArrow(attributes, 'start');
    }
    drawTargetArrow(attributes) {
        this.drawArrow(attributes, 'end');
    }
    drawKeyShape(attributes, container) {
        const style = this.getKeyStyle(attributes);
        return this.upsert('key', (0, $2eDEB.Path), style, container);
    }
    render(attributes = this.parsedAttributes, container = this) {
        // 1. key shape
        this.drawKeyShape(attributes, container);
        if (!this.getShape('key')) return;
        // 2. arrows
        this.drawSourceArrow(attributes);
        this.drawTargetArrow(attributes);
        // 3. label
        this.drawLabelShape(attributes, container);
        // 4. halo
        this.drawHaloShape(attributes, container);
        // 5. badges
        this.drawBadgeShape(attributes, container);
    }
    onframe() {
        this.drawKeyShape(this.parsedAttributes, this);
        this.drawSourceArrow(this.parsedAttributes);
        this.drawTargetArrow(this.parsedAttributes);
        this.drawHaloShape(this.parsedAttributes, this);
        this.drawLabelShape(this.parsedAttributes, this);
        this.drawBadgeShape(this.parsedAttributes, this);
    }
    animate(keyframes, options) {
        const animation = super.animate(keyframes, options);
        if (!animation) return animation;
        // 设置 currentTime 时触发更新
        // Trigger update when setting currentTime
        return new Proxy(animation, {
            set: (target, propKey, value)=>{
                // 需要推迟 onframe 调用时机，等待节点位置更新完成
                // Need to delay the timing of the onframe call, wait for the node position update to complete
                if (propKey === 'currentTime') Promise.resolve().then(()=>this.onframe());
                return Reflect.set(target, propKey, value);
            }
        });
    }
}
$8fd782189a6e4844$export$b746b7c1be3cefa0.defaultStyleProps = {
    badge: true,
    badgeOffsetX: 0,
    badgeOffsetY: 0,
    badgePlacement: 'suffix',
    isBillboard: true,
    label: true,
    labelAutoRotate: true,
    labelIsBillboard: true,
    labelMaxWidth: '80%',
    labelOffsetX: 4,
    labelOffsetY: 0,
    labelPlacement: 'center',
    labelTextBaseline: 'middle',
    labelWordWrap: false,
    halo: false,
    haloDroppable: false,
    haloLineDash: 0,
    haloLineWidth: 12,
    haloPointerEvents: 'none',
    haloStrokeOpacity: 0.25,
    haloZIndex: -1,
    loop: true,
    startArrow: false,
    startArrowLineDash: 0,
    startArrowLineJoin: 'round',
    startArrowLineWidth: 1,
    startArrowTransformOrigin: 'center',
    startArrowType: 'vee',
    endArrow: false,
    endArrowLineDash: 0,
    endArrowLineJoin: 'round',
    endArrowLineWidth: 1,
    endArrowTransformOrigin: 'center',
    endArrowType: 'vee',
    loopPlacement: 'top',
    loopClockwise: true
};

});
parcelRegister("25dP3", function(module, exports) {

$parcel$export(module.exports, "getLabelPositionStyle", () => $1846c545f8cd6317$export$3a30fb49b65eb58c);
$parcel$export(module.exports, "getBadgePositionStyle", () => $1846c545f8cd6317$export$fe655ce66234c268);
$parcel$export(module.exports, "getCurveControlPoint", () => $1846c545f8cd6317$export$f6e8c1fb5cf1c391);
$parcel$export(module.exports, "parseCurveOffset", () => $1846c545f8cd6317$export$92619288b17044ec);
$parcel$export(module.exports, "parseCurvePosition", () => $1846c545f8cd6317$export$e6e997b2104facd8);
$parcel$export(module.exports, "getQuadraticPath", () => $1846c545f8cd6317$export$8ad62f87f6104bf4);
$parcel$export(module.exports, "getCubicPath", () => $1846c545f8cd6317$export$1d176f9cfffc146f);
$parcel$export(module.exports, "getPolylinePath", () => $1846c545f8cd6317$export$595c484e7288d398);
$parcel$export(module.exports, "getCubicLoopPath", () => $1846c545f8cd6317$export$c82f9b63cddd3b4f);
$parcel$export(module.exports, "getPolylineLoopPath", () => $1846c545f8cd6317$export$f7f28b6918fbd1b1);
$parcel$export(module.exports, "getSubgraphRelatedEdges", () => $1846c545f8cd6317$export$2619d50aa6a031a3);
$parcel$export(module.exports, "findActualConnectNodeData", () => $1846c545f8cd6317$export$e77ee0cb84a90f4c);
$parcel$export(module.exports, "getArrowSize", () => $1846c545f8cd6317$export$5073496d9f85dd2c);

var $4ETMA = parcelRequire("4ETMA");
var $jyI49 = parcelRequire("jyI49");

var $6BVcW = parcelRequire("6BVcW");

var $VNNBO = parcelRequire("VNNBO");

var $hn4z6 = parcelRequire("hn4z6");

var $brtTw = parcelRequire("brtTw");

var $dnXls = parcelRequire("dnXls");

var $3AHBz = parcelRequire("3AHBz");

var $dOidW = parcelRequire("dOidW");
function $1846c545f8cd6317$export$3a30fb49b65eb58c(key, placement, autoRotate, offsetX, offsetY) {
    const START_RATIO = 0;
    const MIDDLE_RATIO = 0.5;
    const END_RATIO = 0.99;
    let ratio = typeof placement === 'number' ? placement : MIDDLE_RATIO;
    if (placement === 'start') ratio = START_RATIO;
    if (placement === 'end') ratio = END_RATIO;
    const point = (0, $dnXls.parsePoint)(key.getPoint(ratio));
    const pointOffset = (0, $dnXls.parsePoint)(key.getPoint(ratio + 0.01));
    let textAlign = placement === 'start' ? 'left' : placement === 'end' ? 'right' : 'center';
    if ((0, $dnXls.isHorizontal)(point, pointOffset) || !autoRotate) {
        const [x, y] = $1846c545f8cd6317$var$getXYByPlacement(key, ratio, offsetX, offsetY);
        return {
            transform: [
                [
                    'translate',
                    x,
                    y
                ]
            ],
            textAlign: textAlign
        };
    }
    let angle = Math.atan2(pointOffset[1] - point[1], pointOffset[0] - point[0]);
    const isRevert = pointOffset[0] < point[0];
    if (isRevert) {
        textAlign = textAlign === 'center' ? textAlign : textAlign === 'left' ? 'right' : 'left';
        offsetX *= -1;
        angle += Math.PI;
    }
    const [x, y] = $1846c545f8cd6317$var$getXYByPlacement(key, ratio, offsetX, offsetY, angle);
    const transform = [
        [
            'translate',
            x,
            y
        ],
        [
            'rotate',
            angle / Math.PI * 180
        ]
    ];
    return {
        textAlign: textAlign,
        transform: transform
    };
}
function $1846c545f8cd6317$export$fe655ce66234c268(shapeMap, placement, labelPlacement, offsetX, offsetY) {
    var _a, _b;
    const badgeWidth = ((_a = shapeMap.badge) === null || _a === void 0 ? void 0 : _a.getGeometryBounds().halfExtents[0]) * 2 || 0;
    const labelWidth = ((_b = shapeMap.label) === null || _b === void 0 ? void 0 : _b.getGeometryBounds().halfExtents[0]) * 2 || 0;
    return $1846c545f8cd6317$export$3a30fb49b65eb58c(shapeMap.key, labelPlacement, true, (labelWidth ? (labelWidth / 2 + badgeWidth / 2) * (placement === 'suffix' ? 1 : -1) : 0) + offsetX, offsetY);
}
/**
 * <zh/> 获取给定边上的指定位置的坐标
 *
 * <en/> Get the coordinates at the specified position on the given edge
 * @param key - <zh/> 边实例 | <en/> Edge instance
 * @param ratio - <zh/> 位置比率 | <en/> Position ratio
 * @param offsetX - <zh/> 水平偏移量 | <en/> Horizontal offset
 * @param offsetY - <zh/> 垂直偏移量 | <en/> Vertical offset
 * @param angle - <zh/> 旋转角度 | <en/> Rotation angle
 * @returns <zh/> 坐标 | <en/> Coordinates
 */ function $1846c545f8cd6317$var$getXYByPlacement(key, ratio, offsetX, offsetY, angle) {
    const [pointX, pointY] = (0, $dnXls.parsePoint)(key.getPoint(ratio));
    let actualOffsetX = offsetX;
    let actualOffsetY = offsetY;
    if (angle) {
        actualOffsetX = offsetX * Math.cos(angle) - offsetY * Math.sin(angle);
        actualOffsetY = offsetX * Math.sin(angle) + offsetY * Math.cos(angle);
    }
    return [
        pointX + actualOffsetX,
        pointY + actualOffsetY
    ];
}
function $1846c545f8cd6317$export$f6e8c1fb5cf1c391(sourcePoint, targetPoint, curvePosition, curveOffset) {
    if ((0, $4ETMA.default)(sourcePoint, targetPoint)) return sourcePoint;
    const lineVector = (0, $dOidW.subtract)(targetPoint, sourcePoint);
    const controlPoint = [
        sourcePoint[0] + curvePosition * lineVector[0],
        sourcePoint[1] + curvePosition * lineVector[1]
    ];
    const perpVector = (0, $dOidW.normalize)((0, $dOidW.perpendicular)(lineVector, false));
    controlPoint[0] += curveOffset * perpVector[0];
    controlPoint[1] += curveOffset * perpVector[1];
    return controlPoint;
}
function $1846c545f8cd6317$export$92619288b17044ec(curveOffset) {
    if ((0, $jyI49.default)(curveOffset)) return [
        curveOffset,
        -curveOffset
    ];
    return curveOffset;
}
function $1846c545f8cd6317$export$e6e997b2104facd8(curvePosition) {
    if ((0, $jyI49.default)(curvePosition)) return [
        curvePosition,
        1 - curvePosition
    ];
    return curvePosition;
}
function $1846c545f8cd6317$export$8ad62f87f6104bf4(sourcePoint, targetPoint, controlPoint) {
    return [
        [
            'M',
            sourcePoint[0],
            sourcePoint[1]
        ],
        [
            'Q',
            controlPoint[0],
            controlPoint[1],
            targetPoint[0],
            targetPoint[1]
        ]
    ];
}
function $1846c545f8cd6317$export$1d176f9cfffc146f(sourcePoint, targetPoint, controlPoints) {
    return [
        [
            'M',
            sourcePoint[0],
            sourcePoint[1]
        ],
        [
            'C',
            controlPoints[0][0],
            controlPoints[0][1],
            controlPoints[1][0],
            controlPoints[1][1],
            targetPoint[0],
            targetPoint[1]
        ]
    ];
}
function $1846c545f8cd6317$export$595c484e7288d398(points, radius = 0, z = false) {
    const targetIndex = points.length - 1;
    const sourcePoint = points[0];
    const targetPoint = points[targetIndex];
    const controlPoints = points.slice(1, targetIndex);
    const pathArray = [
        [
            'M',
            sourcePoint[0],
            sourcePoint[1]
        ]
    ];
    controlPoints.forEach((midPoint, i)=>{
        const prevPoint = controlPoints[i - 1] || sourcePoint;
        const nextPoint = controlPoints[i + 1] || targetPoint;
        if (!(0, $dnXls.isCollinear)(prevPoint, midPoint, nextPoint) && radius) {
            const [ps, pt] = $1846c545f8cd6317$export$8abef314883e9117(prevPoint, midPoint, nextPoint, radius);
            pathArray.push([
                'L',
                ps[0],
                ps[1]
            ], [
                'Q',
                midPoint[0],
                midPoint[1],
                pt[0],
                pt[1]
            ], [
                'L',
                pt[0],
                pt[1]
            ]);
        } else pathArray.push([
            'L',
            midPoint[0],
            midPoint[1]
        ]);
    });
    pathArray.push([
        'L',
        targetPoint[0],
        targetPoint[1]
    ]);
    if (z) pathArray.push([
        'Z'
    ]);
    return pathArray;
}
function $1846c545f8cd6317$export$8abef314883e9117(prevPoint, midPoint, nextPoint, radius) {
    const d0 = (0, $dOidW.manhattanDistance)(prevPoint, midPoint);
    const d1 = (0, $dOidW.manhattanDistance)(nextPoint, midPoint);
    // 取给定的半径和最小半径之间的较小值 | use the smaller value between the given radius and the minimum radius
    const r = Math.min(radius, Math.min(d0, d1) / 2);
    const ps = [
        midPoint[0] - r / d0 * (midPoint[0] - prevPoint[0]),
        midPoint[1] - r / d0 * (midPoint[1] - prevPoint[1])
    ];
    const pt = [
        midPoint[0] - r / d1 * (midPoint[0] - nextPoint[0]),
        midPoint[1] - r / d1 * (midPoint[1] - nextPoint[1])
    ];
    return [
        ps,
        pt
    ];
}
const $1846c545f8cd6317$export$79ad8f3b2ee3923 = (bbox)=>{
    const halfPI = Math.PI / 2;
    const halfHeight = (0, $6BVcW.getBBoxHeight)(bbox) / 2;
    const halfWidth = (0, $6BVcW.getBBoxWidth)(bbox) / 2;
    const angleWithX = Math.atan2(halfHeight, halfWidth) / 2;
    const angleWithY = Math.atan2(halfWidth, halfHeight) / 2;
    return {
        top: [
            -halfPI - angleWithY,
            -halfPI + angleWithY
        ],
        'top-right': [
            -halfPI + angleWithY,
            -angleWithX
        ],
        'right-top': [
            -halfPI + angleWithY,
            -angleWithX
        ],
        right: [
            -angleWithX,
            angleWithX
        ],
        'bottom-right': [
            angleWithX,
            halfPI - angleWithY
        ],
        'right-bottom': [
            angleWithX,
            halfPI - angleWithY
        ],
        bottom: [
            halfPI - angleWithY,
            halfPI + angleWithY
        ],
        'bottom-left': [
            halfPI + angleWithY,
            Math.PI - angleWithX
        ],
        'left-bottom': [
            halfPI + angleWithY,
            Math.PI - angleWithX
        ],
        left: [
            Math.PI - angleWithX,
            Math.PI + angleWithX
        ],
        'top-left': [
            Math.PI + angleWithX,
            -halfPI - angleWithY
        ],
        'left-top': [
            Math.PI + angleWithX,
            -halfPI - angleWithY
        ]
    };
};
function $1846c545f8cd6317$export$d16bfad9bea0d28(node, placement, clockwise, sourcePort, targetPort) {
    const bbox = (0, $6BVcW.getNodeBBox)(node);
    const center = node.getCenter();
    let sourcePoint = sourcePort && (0, $hn4z6.getPortPosition)(sourcePort);
    let targetPoint = targetPort && (0, $hn4z6.getPortPosition)(targetPort);
    if (!sourcePoint || !targetPoint) {
        const radians = $1846c545f8cd6317$export$79ad8f3b2ee3923(bbox);
        const angle1 = radians[placement][0];
        const angle2 = radians[placement][1];
        const [width, height] = (0, $6BVcW.getBBoxSize)(bbox);
        const r = Math.max(width, height);
        const point1 = (0, $dOidW.add)(center, [
            r * Math.cos(angle1),
            r * Math.sin(angle1),
            0
        ]);
        const point2 = (0, $dOidW.add)(center, [
            r * Math.cos(angle2),
            r * Math.sin(angle2),
            0
        ]);
        sourcePoint = (0, $hn4z6.getNodeConnectionPoint)(node, point1);
        targetPoint = (0, $hn4z6.getNodeConnectionPoint)(node, point2);
        if (!clockwise) [sourcePoint, targetPoint] = [
            targetPoint,
            sourcePoint
        ];
    }
    return [
        sourcePoint,
        targetPoint
    ];
}
function $1846c545f8cd6317$export$c82f9b63cddd3b4f(node, placement, clockwise, dist, sourcePortKey, targetPortKey) {
    const sourcePort = node.getPorts()[sourcePortKey || targetPortKey];
    const targetPort = node.getPorts()[targetPortKey || sourcePortKey];
    // 1. 获取起点和终点 | Get the start and end points
    let [sourcePoint, targetPoint] = $1846c545f8cd6317$export$d16bfad9bea0d28(node, placement, clockwise, sourcePort, targetPort);
    // 2. 获取控制点 | Get the control points
    const controlPoints = $1846c545f8cd6317$export$bfeaec8c5f158364(node, sourcePoint, targetPoint, dist);
    // 3. 如果定义了连接桩，调整端点以与连接桩边界相交 | If the port is defined, adjust the endpoint to intersect with the port boundary
    if (sourcePort) sourcePoint = (0, $hn4z6.getPortConnectionPoint)(sourcePort, controlPoints[0]);
    if (targetPort) targetPoint = (0, $hn4z6.getPortConnectionPoint)(targetPort, controlPoints.at(-1));
    return $1846c545f8cd6317$export$1d176f9cfffc146f(sourcePoint, targetPoint, controlPoints);
}
function $1846c545f8cd6317$export$bfeaec8c5f158364(node, sourcePoint, targetPoint, dist) {
    const center = node.getCenter();
    if ((0, $4ETMA.default)(sourcePoint, targetPoint)) {
        const direction = (0, $dOidW.subtract)(sourcePoint, center);
        const adjustment = [
            dist * Math.sign(direction[0]) || dist / 2,
            dist * Math.sign(direction[1]) || -dist / 2,
            0
        ];
        return [
            (0, $dOidW.add)(sourcePoint, adjustment),
            (0, $dOidW.add)(targetPoint, (0, $dOidW.multiply)(adjustment, [
                1,
                -1,
                1
            ]))
        ];
    }
    return [
        (0, $dnXls.moveTo)(center, sourcePoint, (0, $dOidW.distance)(center, sourcePoint) + dist),
        (0, $dnXls.moveTo)(center, targetPoint, (0, $dOidW.distance)(center, targetPoint) + dist)
    ];
}
function $1846c545f8cd6317$export$f7f28b6918fbd1b1(node, radius, placement, clockwise, dist, sourcePortKey, targetPortKey) {
    const allPortsMap = (0, $hn4z6.getAllPorts)(node);
    const sourcePort = allPortsMap[sourcePortKey || targetPortKey];
    const targetPort = allPortsMap[targetPortKey || sourcePortKey];
    // 1. 获取起点和终点 | Get the start and end points
    let [sourcePoint, targetPoint] = $1846c545f8cd6317$export$d16bfad9bea0d28(node, placement, clockwise, sourcePort, targetPort);
    // 2. 获取控制点 | Get the control points
    const controlPoints = $1846c545f8cd6317$export$f0b02a47621cfb02(node, sourcePoint, targetPoint, dist);
    // 3. 如果定义了连接桩，调整端点以与连接桩边界相交 | If the port is defined, adjust the endpoint to intersect with the port boundary
    if (sourcePort) sourcePoint = (0, $hn4z6.getPortConnectionPoint)(sourcePort, controlPoints[0]);
    if (targetPort) targetPoint = (0, $hn4z6.getPortConnectionPoint)(targetPort, controlPoints.at(-1));
    return $1846c545f8cd6317$export$595c484e7288d398([
        sourcePoint,
        ...controlPoints,
        targetPoint
    ], radius);
}
function $1846c545f8cd6317$export$f0b02a47621cfb02(node, sourcePoint, targetPoint, dist) {
    const controlPoints = [];
    const bbox = (0, $6BVcW.getNodeBBox)(node);
    // 1. 起点和终点相同 | The start and end points are the same
    if ((0, $4ETMA.default)(sourcePoint, targetPoint)) {
        const side = (0, $6BVcW.getNearestBoundarySide)(sourcePoint, bbox);
        switch(side){
            case 'left':
                controlPoints.push([
                    sourcePoint[0] - dist,
                    sourcePoint[1]
                ]);
                controlPoints.push([
                    sourcePoint[0] - dist,
                    sourcePoint[1] + dist
                ]);
                controlPoints.push([
                    sourcePoint[0],
                    sourcePoint[1] + dist
                ]);
                break;
            case 'right':
                controlPoints.push([
                    sourcePoint[0] + dist,
                    sourcePoint[1]
                ]);
                controlPoints.push([
                    sourcePoint[0] + dist,
                    sourcePoint[1] + dist
                ]);
                controlPoints.push([
                    sourcePoint[0],
                    sourcePoint[1] + dist
                ]);
                break;
            case 'top':
                controlPoints.push([
                    sourcePoint[0],
                    sourcePoint[1] - dist
                ]);
                controlPoints.push([
                    sourcePoint[0] + dist,
                    sourcePoint[1] - dist
                ]);
                controlPoints.push([
                    sourcePoint[0] + dist,
                    sourcePoint[1]
                ]);
                break;
            case 'bottom':
                controlPoints.push([
                    sourcePoint[0],
                    sourcePoint[1] + dist
                ]);
                controlPoints.push([
                    sourcePoint[0] + dist,
                    sourcePoint[1] + dist
                ]);
                controlPoints.push([
                    sourcePoint[0] + dist,
                    sourcePoint[1]
                ]);
                break;
        }
    } else {
        const sourceSide = (0, $6BVcW.getNearestBoundarySide)(sourcePoint, bbox);
        const targetSide = (0, $6BVcW.getNearestBoundarySide)(targetPoint, bbox);
        // 2. 起点与终点同边 | The start and end points are on the same side
        if (sourceSide === targetSide) {
            const side = sourceSide;
            let x, y;
            switch(side){
                case 'left':
                    x = Math.min(sourcePoint[0], targetPoint[0]) - dist;
                    controlPoints.push([
                        x,
                        sourcePoint[1]
                    ]);
                    controlPoints.push([
                        x,
                        targetPoint[1]
                    ]);
                    break;
                case 'right':
                    x = Math.max(sourcePoint[0], targetPoint[0]) + dist;
                    controlPoints.push([
                        x,
                        sourcePoint[1]
                    ]);
                    controlPoints.push([
                        x,
                        targetPoint[1]
                    ]);
                    break;
                case 'top':
                    y = Math.min(sourcePoint[1], targetPoint[1]) - dist;
                    controlPoints.push([
                        sourcePoint[0],
                        y
                    ]);
                    controlPoints.push([
                        targetPoint[0],
                        y
                    ]);
                    break;
                case 'bottom':
                    y = Math.max(sourcePoint[1], targetPoint[1]) + dist;
                    controlPoints.push([
                        sourcePoint[0],
                        y
                    ]);
                    controlPoints.push([
                        targetPoint[0],
                        y
                    ]);
                    break;
            }
        } else {
            // 3. 起点与终点不同边 | The start and end points are on different sides
            const getPointOffSide = (side, point)=>{
                return ({
                    left: [
                        point[0] - dist,
                        point[1]
                    ],
                    right: [
                        point[0] + dist,
                        point[1]
                    ],
                    top: [
                        point[0],
                        point[1] - dist
                    ],
                    bottom: [
                        point[0],
                        point[1] + dist
                    ]
                })[side];
            };
            const p1 = getPointOffSide(sourceSide, sourcePoint);
            const p2 = getPointOffSide(targetSide, targetPoint);
            const p3 = (0, $3AHBz.freeJoin)(p1, p2, bbox);
            controlPoints.push(p1, p3, p2);
        }
    }
    return controlPoints;
}
function $1846c545f8cd6317$export$2619d50aa6a031a3(ids, getRelatedEdges) {
    const edges = new Set();
    const internal = new Set();
    const external = new Set();
    ids.forEach((id)=>{
        const relatedEdges = getRelatedEdges(id);
        relatedEdges.forEach((edge)=>{
            edges.add(edge);
            if (ids.includes(edge.source) && ids.includes(edge.target)) internal.add(edge);
            else external.add(edge);
        });
    });
    return {
        edges: Array.from(edges),
        internal: Array.from(internal),
        external: Array.from(external)
    };
}
function $1846c545f8cd6317$export$e77ee0cb84a90f4c(node, getParentData) {
    const path = [];
    let current = node;
    while(current){
        path.push(current);
        const parent = getParentData((0, $brtTw.idOf)(current));
        if (parent) current = parent;
        else break;
    }
    if (path.some((n)=>{
        var _a;
        return (_a = n.style) === null || _a === void 0 ? void 0 : _a.collapsed;
    })) {
        const index = path.reverse().findIndex((0, $VNNBO.isCollapsed));
        return path[index] || path.at(-1);
    }
    return node;
}
function $1846c545f8cd6317$export$5073496d9f85dd2c(lineWidth, size) {
    if (size) return size;
    if (lineWidth < 4) return 10;
    if (lineWidth === 4) return 12;
    return lineWidth * 2.5;
}

});
parcelRegister("3AHBz", function(module, exports) {

$parcel$export(module.exports, "orth", () => $29d68eef82b6c3da$export$5a6f919b42c1dd75);
$parcel$export(module.exports, "freeJoin", () => $29d68eef82b6c3da$export$cdf89bc249a51a5);

var $eA7Uf = parcelRequire("eA7Uf");
var $4ETMA = parcelRequire("4ETMA");

var $6BVcW = parcelRequire("6BVcW");

var $dnXls = parcelRequire("dnXls");

var $dOidW = parcelRequire("dOidW");
const $29d68eef82b6c3da$var$defaultOptions = {
    padding: 10
};
function $29d68eef82b6c3da$export$5a6f919b42c1dd75(sourcePoint, targetPoint, sourceNode, targetNode, controlPoints, options) {
    const { padding: padding } = Object.assign($29d68eef82b6c3da$var$defaultOptions, options);
    const sourceBBox = (0, $6BVcW.getNodeBBox)(sourceNode, padding);
    const targetBBox = (0, $6BVcW.getNodeBBox)(targetNode, padding);
    const points = [
        sourcePoint,
        ...controlPoints,
        targetPoint
    ];
    // direction of previous route segment
    let direction = null;
    const result = [];
    for(let fromIdx = 0, len = points.length; fromIdx < len - 1; fromIdx++){
        const toIdx = fromIdx + 1;
        const from = points[fromIdx];
        const to = points[toIdx];
        const isOrth = (0, $dnXls.isOrthogonal)(from, to);
        let route = null;
        if (fromIdx === 0) {
            if (toIdx === len - 1) {
                // source -> target
                if (sourceBBox.intersects(targetBBox)) route = $29d68eef82b6c3da$export$ed6cfa7b8aee6043(from, to, sourceBBox, targetBBox);
                else if (!(0, $6BVcW.isPointBBoxCenter)(from, sourceBBox) && !(0, $6BVcW.isPointBBoxCenter)(to, targetBBox)) {
                    const fromWithPadding = (0, $6BVcW.getNearestBoundaryPoint)(from, sourceBBox);
                    const toWithPadding = (0, $6BVcW.getNearestBoundaryPoint)(to, targetBBox);
                    route = $29d68eef82b6c3da$export$9dccd3ac5fcbc1c5(fromWithPadding, toWithPadding, $29d68eef82b6c3da$export$fcce7887255d1c69(fromWithPadding, toWithPadding));
                    route.points.unshift(fromWithPadding);
                    route.points.push(toWithPadding);
                } else if (!isOrth) route = $29d68eef82b6c3da$export$9d71392f9b0e0e70(from, to, sourceBBox, targetBBox);
            } else {
                // source -> point
                if ((0, $6BVcW.isPointInBBox)(to, sourceBBox)) route = $29d68eef82b6c3da$export$ed6cfa7b8aee6043(from, to, sourceBBox, (0, $6BVcW.getNodeBBox)(to, padding), direction);
                else if (!isOrth) route = $29d68eef82b6c3da$export$30d514de96d561fc(from, to, sourceBBox);
            }
        } else if (toIdx === len - 1) {
            // point -> target
            if ((0, $6BVcW.isPointInBBox)(from, targetBBox)) route = $29d68eef82b6c3da$export$ed6cfa7b8aee6043(from, to, (0, $6BVcW.getNodeBBox)(from, padding), targetBBox, direction);
            else if (!isOrth) route = $29d68eef82b6c3da$export$6cab785bceff29e0(from, to, targetBBox, direction);
        } else if (!isOrth) // point -> point
        route = $29d68eef82b6c3da$export$9dccd3ac5fcbc1c5(from, to, direction);
        // set direction for next iteration
        if (route) {
            result.push(...route.points);
            direction = route.direction;
        } else // orthogonal route and not looped
        direction = $29d68eef82b6c3da$export$fcce7887255d1c69(from, to);
        if (toIdx < len - 1) result.push(to);
    }
    return result.map((0, $dOidW.toVector2));
}
/**
 * Direction to opposites direction map
 */ const $29d68eef82b6c3da$var$opposites = {
    N: 'S',
    S: 'N',
    W: 'E',
    E: 'W'
};
/**
 * Direction to radians map
 */ const $29d68eef82b6c3da$var$radians = {
    N: -Math.PI / 2,
    S: Math.PI / 2,
    E: 0,
    W: Math.PI
};
function $29d68eef82b6c3da$export$fcce7887255d1c69(from, to) {
    const [fx, fy] = from;
    const [tx, ty] = to;
    if (fx === tx) return fy > ty ? 'N' : 'S';
    if (fy === ty) return fx > tx ? 'W' : 'E';
    return null;
}
function $29d68eef82b6c3da$export$c4987fce87d1da81(bbox, direction) {
    return direction === 'N' || direction === 'S' ? (0, $6BVcW.getBBoxHeight)(bbox) : (0, $6BVcW.getBBoxWidth)(bbox);
}
function $29d68eef82b6c3da$export$9dccd3ac5fcbc1c5(from, to, direction) {
    const p1 = [
        from[0],
        to[1]
    ];
    const p2 = [
        to[0],
        from[1]
    ];
    const d1 = $29d68eef82b6c3da$export$fcce7887255d1c69(from, p1);
    const d2 = $29d68eef82b6c3da$export$fcce7887255d1c69(from, p2);
    const opposite = direction ? $29d68eef82b6c3da$var$opposites[direction] : null;
    const p = d1 === direction || d1 !== opposite && d2 !== direction ? p1 : p2;
    return {
        points: [
            p
        ],
        direction: $29d68eef82b6c3da$export$fcce7887255d1c69(p, to)
    };
}
function $29d68eef82b6c3da$export$30d514de96d561fc(from, to, fromBBox) {
    if ((0, $6BVcW.isPointBBoxCenter)(from, fromBBox)) {
        const p = $29d68eef82b6c3da$export$cdf89bc249a51a5(from, to, fromBBox);
        return {
            points: [
                p
            ],
            direction: $29d68eef82b6c3da$export$fcce7887255d1c69(p, to)
        };
    } else {
        const fromWithPadding = (0, $6BVcW.getNearestBoundaryPoint)(from, fromBBox);
        const isHorizontal = [
            'left',
            'right'
        ].includes((0, $6BVcW.getNearestBoundarySide)(from, fromBBox));
        const p = isHorizontal ? [
            to[0],
            fromWithPadding[1]
        ] : [
            fromWithPadding[0],
            to[1]
        ];
        return {
            points: [
                p
            ],
            direction: $29d68eef82b6c3da$export$fcce7887255d1c69(p, to)
        };
    }
}
function $29d68eef82b6c3da$export$6cab785bceff29e0(from, to, toBBox, direction) {
    const toWithPadding = (0, $6BVcW.isPointBBoxCenter)(to, toBBox) ? to : (0, $6BVcW.getNearestBoundaryPoint)(to, toBBox);
    const points = [
        [
            toWithPadding[0],
            from[1]
        ],
        [
            from[0],
            toWithPadding[1]
        ]
    ];
    const freePoints = points.filter((p)=>(0, $6BVcW.isPointOutsideBBox)(p, toBBox) && !(0, $6BVcW.isPointOnBBoxBoundary)(p, toBBox, true));
    const freeDirectionPoints = freePoints.filter((p)=>$29d68eef82b6c3da$export$fcce7887255d1c69(p, from) !== direction);
    if (freeDirectionPoints.length > 0) {
        // Pick a point which bears the same direction as the previous segment.
        const p = freeDirectionPoints.find((p)=>$29d68eef82b6c3da$export$fcce7887255d1c69(from, p) === direction) || freeDirectionPoints[0];
        return {
            points: [
                p
            ],
            direction: $29d68eef82b6c3da$export$fcce7887255d1c69(p, to)
        };
    } else {
        // Here we found only points which are either contained in the element or they would create
        // a link segment going in opposites direction from the previous one.
        // We take the point inside element and move it outside the element in the direction the
        // route is going. Now we can join this point with the current end (using freeJoin).
        const p = (0, $eA7Uf.default)(points, freePoints)[0];
        const p2 = (0, $dnXls.moveTo)(to, p, $29d68eef82b6c3da$export$c4987fce87d1da81(toBBox, direction) / 2);
        const p1 = $29d68eef82b6c3da$export$cdf89bc249a51a5(p2, from, toBBox);
        return {
            points: [
                p1,
                p2
            ],
            direction: $29d68eef82b6c3da$export$fcce7887255d1c69(p2, to)
        };
    }
}
function $29d68eef82b6c3da$export$9d71392f9b0e0e70(from, to, fromBBox, toBBox) {
    let route = $29d68eef82b6c3da$export$30d514de96d561fc(from, to, fromBBox);
    const p1 = (0, $dOidW.toVector3)(route.points[0]);
    if ((0, $6BVcW.isPointInBBox)(p1, toBBox)) {
        route = $29d68eef82b6c3da$export$30d514de96d561fc(to, from, toBBox);
        const p2 = (0, $dOidW.toVector3)(route.points[0]);
        if ((0, $6BVcW.isPointInBBox)(p2, fromBBox)) {
            const fromBorder = (0, $dnXls.moveTo)(from, p1, $29d68eef82b6c3da$export$c4987fce87d1da81(fromBBox, $29d68eef82b6c3da$export$fcce7887255d1c69(from, p1)) / 2);
            const toBorder = (0, $dnXls.moveTo)(to, p2, $29d68eef82b6c3da$export$c4987fce87d1da81(toBBox, $29d68eef82b6c3da$export$fcce7887255d1c69(to, p2)) / 2);
            const midPoint = [
                (fromBorder[0] + toBorder[0]) / 2,
                (fromBorder[1] + toBorder[1]) / 2
            ];
            const startRoute = $29d68eef82b6c3da$export$30d514de96d561fc(from, midPoint, fromBBox);
            const endRoute = $29d68eef82b6c3da$export$6cab785bceff29e0(midPoint, to, toBBox, startRoute.direction);
            route.points = [
                startRoute.points[0],
                endRoute.points[0]
            ];
            route.direction = endRoute.direction;
        }
    }
    return route;
}
function $29d68eef82b6c3da$export$ed6cfa7b8aee6043(from, to, fromBBox, toBBox, direction) {
    const DEFAULT_OFFSET = 0.01;
    const boundary = (0, $6BVcW.getCombinedBBox)([
        fromBBox,
        toBBox
    ]);
    const reversed = (0, $dOidW.distance)(to, boundary.center) > (0, $dOidW.distance)(from, boundary.center);
    const [start, end] = reversed ? [
        to,
        from
    ] : [
        from,
        to
    ];
    const halfPerimeter = (0, $6BVcW.getBBoxHeight)(boundary) + (0, $6BVcW.getBBoxWidth)(boundary);
    let p1;
    if (direction) {
        const ref = [
            start[0] + halfPerimeter * Math.cos($29d68eef82b6c3da$var$radians[direction]),
            start[1] + halfPerimeter * Math.sin($29d68eef82b6c3da$var$radians[direction])
        ];
        // `getNearestBoundaryPoint` returns a point on the boundary, so we need to move it a bit to ensure it's outside the element and then get the correct `p2` via `freeJoin`.
        p1 = (0, $dnXls.moveTo)((0, $6BVcW.getNearestBoundaryPoint)(ref, boundary), ref, DEFAULT_OFFSET);
    } else p1 = (0, $dnXls.moveTo)((0, $6BVcW.getNearestBoundaryPoint)(start, boundary), start, -DEFAULT_OFFSET);
    let p2 = $29d68eef82b6c3da$export$cdf89bc249a51a5(p1, end, boundary);
    let points = [
        (0, $dnXls.round)(p1, 2),
        (0, $dnXls.round)(p2, 2)
    ];
    if ((0, $4ETMA.default)((0, $dnXls.round)(p1), (0, $dnXls.round)(p2))) {
        const rad = (0, $dOidW.angle)((0, $dOidW.subtract)(p1, start), [
            1,
            0,
            0
        ]) + Math.PI / 2;
        p2 = [
            end[0] + halfPerimeter * Math.cos(rad),
            end[1] + halfPerimeter * Math.sin(rad),
            0
        ];
        p2 = (0, $dnXls.round)((0, $dnXls.moveTo)((0, $6BVcW.getNearestBoundaryPoint)(p2, boundary), end, -DEFAULT_OFFSET), 2);
        const p3 = $29d68eef82b6c3da$export$cdf89bc249a51a5(p1, p2, boundary);
        points = [
            p1,
            p3,
            p2
        ];
    }
    return {
        points: reversed ? points.reverse() : points,
        direction: reversed ? $29d68eef82b6c3da$export$fcce7887255d1c69(p1, to) : $29d68eef82b6c3da$export$fcce7887255d1c69(p2, to)
    };
}
function $29d68eef82b6c3da$export$cdf89bc249a51a5(p1, p2, bbox) {
    let p = [
        p1[0],
        p2[1]
    ];
    if ((0, $6BVcW.isPointInBBox)(p, bbox)) p = [
        p2[0],
        p1[1]
    ];
    return p;
}

});
parcelRegister("eA7Uf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9da8f82773a6710$export$2e2bcd8739ae039);

var $fVnY2 = parcelRequire("fVnY2");

var $6PT1J = parcelRequire("6PT1J");
/**
 * Flattens `array` a single level deep.
 *
 * @param {Array} arr The array to inspect.
 * @param {Array} values The values to exclude.
 * @return {Array} Returns the new array of filtered values.
 * @example
 * difference([2, 1], [2, 3]);  // => [1]
 */ var $a9da8f82773a6710$var$difference = function(arr, values) {
    if (values === void 0) values = [];
    return (0, $fVnY2.default)(arr, function(value) {
        return !(0, $6PT1J.default)(values, value);
    });
};
var $a9da8f82773a6710$export$2e2bcd8739ae039 = $a9da8f82773a6710$var$difference;

});
parcelRegister("fVnY2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b97ec54a0e442417$export$2e2bcd8739ae039);

var $dDtYS = parcelRequire("dDtYS");
var $b97ec54a0e442417$var$filter = function(arr, func) {
    if (!(0, $dDtYS.default)(arr)) return arr;
    var result = [];
    for(var index = 0; index < arr.length; index++){
        var value = arr[index];
        if (func(value, index)) result.push(value);
    }
    return result;
};
var $b97ec54a0e442417$export$2e2bcd8739ae039 = $b97ec54a0e442417$var$filter;

});

parcelRegister("6PT1J", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa230b8573005a3$export$2e2bcd8739ae039);

var $dDtYS = parcelRequire("dDtYS");
var $4fa230b8573005a3$var$contains = function(arr, value) {
    if (!(0, $dDtYS.default)(arr)) return false;
    return arr.indexOf(value) > -1;
};
var $4fa230b8573005a3$export$2e2bcd8739ae039 = $4fa230b8573005a3$var$contains;

});




parcelRegister("dkVLZ", function(module, exports) {

$parcel$export(module.exports, "circle", () => $9b59f526327acebf$export$e1d786d2f707b414);
$parcel$export(module.exports, "triangle", () => $9b59f526327acebf$export$9eed783d03e0135c);
$parcel$export(module.exports, "diamond", () => $9b59f526327acebf$export$bc2a8782c99449da);
$parcel$export(module.exports, "vee", () => $9b59f526327acebf$export$aca759d3d449da63);
$parcel$export(module.exports, "rect", () => $9b59f526327acebf$export$4b409e53cf4df6e6);
$parcel$export(module.exports, "triangleRect", () => $9b59f526327acebf$export$af176bae4c646cee);
$parcel$export(module.exports, "simple", () => $9b59f526327acebf$export$52257e56c24a8923);
/**
 * ○
 */ const $9b59f526327acebf$export$e1d786d2f707b414 = (width, height)=>{
    const r = Math.max(width, height) / 2;
    return [
        [
            'M',
            -width / 2,
            0
        ],
        [
            'A',
            r,
            r,
            0,
            1,
            0,
            2 * r - width / 2,
            0
        ],
        [
            'A',
            r,
            r,
            0,
            1,
            0,
            -width / 2,
            0
        ],
        [
            'Z'
        ]
    ];
};
const $9b59f526327acebf$export$9eed783d03e0135c = (width, height)=>{
    return [
        [
            'M',
            -width / 2,
            0
        ],
        [
            'L',
            width / 2,
            -height / 2
        ],
        [
            'L',
            width / 2,
            height / 2
        ],
        [
            'Z'
        ]
    ];
};
const $9b59f526327acebf$export$bc2a8782c99449da = (width, height)=>{
    return [
        [
            'M',
            -width / 2,
            0
        ],
        [
            'L',
            0,
            -height / 2
        ],
        [
            'L',
            width / 2,
            0
        ],
        [
            'L',
            0,
            height / 2
        ],
        [
            'Z'
        ]
    ];
};
const $9b59f526327acebf$export$aca759d3d449da63 = (width, height)=>{
    return [
        [
            'M',
            -width / 2,
            0
        ],
        [
            'L',
            width / 2,
            -height / 2
        ],
        [
            'L',
            4 * width / 5 - width / 2,
            0
        ],
        [
            'L',
            width / 2,
            height / 2
        ],
        [
            'Z'
        ]
    ];
};
const $9b59f526327acebf$export$4b409e53cf4df6e6 = (width, height)=>{
    return [
        [
            'M',
            -width / 2,
            -height / 2
        ],
        [
            'L',
            width / 2,
            -height / 2
        ],
        [
            'L',
            width / 2,
            height / 2
        ],
        [
            'L',
            -width / 2,
            height / 2
        ],
        [
            'Z'
        ]
    ];
};
const $9b59f526327acebf$export$af176bae4c646cee = (width, height)=>{
    const tWidth = width / 2;
    const rWidth = width / 7;
    const rBeginX = width - rWidth;
    return [
        [
            'M',
            -tWidth,
            0
        ],
        [
            'L',
            0,
            -height / 2
        ],
        [
            'L',
            0,
            height / 2
        ],
        [
            'Z'
        ],
        [
            'M',
            rBeginX - tWidth,
            -height / 2
        ],
        [
            'L',
            rBeginX + rWidth - tWidth,
            -height / 2
        ],
        [
            'L',
            rBeginX + rWidth - tWidth,
            height / 2
        ],
        [
            'L',
            rBeginX - tWidth,
            height / 2
        ],
        [
            'Z'
        ]
    ];
};
const $9b59f526327acebf$export$52257e56c24a8923 = (width, height)=>{
    return [
        [
            'M',
            width / 2,
            -height / 2
        ],
        [
            'L',
            -width / 2,
            0
        ],
        [
            'L',
            width / 2,
            0
        ],
        [
            'L',
            -width / 2,
            0
        ],
        [
            'L',
            width / 2,
            height / 2
        ]
    ];
};

});


parcelRegister("4tI2g", function(module, exports) {

$parcel$export(module.exports, "Cubic", () => $342c0761f313481b$export$755261d5a1567778);

var $25dP3 = parcelRequire("25dP3");

var $j4n8g = parcelRequire("j4n8g");

var $clFkI = parcelRequire("clFkI");
class $342c0761f313481b$export$755261d5a1567778 extends (0, $clFkI.BaseEdge) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $342c0761f313481b$export$755261d5a1567778.defaultStyleProps
        }, options));
    }
    /**
     * @inheritdoc
     */ getKeyPath(attributes) {
        const [sourcePoint, targetPoint] = this.getEndpoints(attributes);
        const { controlPoints: controlPoints, curvePosition: curvePosition, curveOffset: curveOffset } = attributes;
        const actualControlPoints = this.getControlPoints(sourcePoint, targetPoint, (0, $25dP3.parseCurvePosition)(curvePosition), (0, $25dP3.parseCurveOffset)(curveOffset), controlPoints);
        return (0, $25dP3.getCubicPath)(sourcePoint, targetPoint, actualControlPoints);
    }
    getControlPoints(sourcePoint, targetPoint, curvePosition, curveOffset, controlPoints) {
        return (controlPoints === null || controlPoints === void 0 ? void 0 : controlPoints.length) === 2 ? controlPoints : [
            (0, $25dP3.getCurveControlPoint)(sourcePoint, targetPoint, curvePosition[0], curveOffset[0]),
            (0, $25dP3.getCurveControlPoint)(sourcePoint, targetPoint, curvePosition[1], curveOffset[1])
        ];
    }
}
$342c0761f313481b$export$755261d5a1567778.defaultStyleProps = {
    curvePosition: 0.5,
    curveOffset: 20
};

});

parcelRegister("hjONv", function(module, exports) {

$parcel$export(module.exports, "CubicHorizontal", () => $c9bb9d51bba173a6$export$744b2430e73fc850);

var $j4n8g = parcelRequire("j4n8g");

var $4tI2g = parcelRequire("4tI2g");
class $c9bb9d51bba173a6$export$744b2430e73fc850 extends (0, $4tI2g.Cubic) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $c9bb9d51bba173a6$export$744b2430e73fc850.defaultStyleProps
        }, options));
    }
    getControlPoints(sourcePoint, targetPoint, curvePosition, curveOffset) {
        const xDist = targetPoint[0] - sourcePoint[0];
        return [
            [
                sourcePoint[0] + xDist * curvePosition[0] + curveOffset[0],
                sourcePoint[1]
            ],
            [
                targetPoint[0] - xDist * curvePosition[1] + curveOffset[1],
                targetPoint[1]
            ]
        ];
    }
}
$c9bb9d51bba173a6$export$744b2430e73fc850.defaultStyleProps = {
    curvePosition: [
        0.5,
        0.5
    ],
    curveOffset: [
        0,
        0
    ]
};

});

parcelRegister("bs4me", function(module, exports) {

$parcel$export(module.exports, "CubicRadial", () => $8565b08f2ca3377e$export$8992b57e8a94d77e);

var $46bcR = parcelRequire("46bcR");

var $j4n8g = parcelRequire("j4n8g");

var $dOidW = parcelRequire("dOidW");

var $4tI2g = parcelRequire("4tI2g");
class $8565b08f2ca3377e$export$8992b57e8a94d77e extends (0, $4tI2g.Cubic) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $8565b08f2ca3377e$export$8992b57e8a94d77e.defaultStyleProps
        }, options));
    }
    get ref() {
        return this.context.model.getRootsData()[0];
    }
    getEndpoints(attributes) {
        if (this.sourceNode.id === this.ref.id) return super.getEndpoints(attributes);
        const refPoint = (0, $46bcR.positionOf)(this.ref);
        const sourcePoint = this.sourceNode.getIntersectPoint(refPoint, true);
        const targetPoint = this.targetNode.getIntersectPoint(refPoint);
        return [
            sourcePoint,
            targetPoint
        ];
    }
    toRadialCoordinate(p) {
        const refPoint = (0, $46bcR.positionOf)(this.ref);
        const r = (0, $dOidW.distance)(p, refPoint);
        const radian = (0, $dOidW.rad)((0, $dOidW.subtract)(p, refPoint));
        return [
            r,
            radian
        ];
    }
    getControlPoints(sourcePoint, targetPoint, curvePosition, curveOffset) {
        const [r1, rad1] = this.toRadialCoordinate(sourcePoint);
        const [r2] = this.toRadialCoordinate(targetPoint);
        const rDist = r2 - r1;
        return [
            [
                sourcePoint[0] + (rDist * curvePosition[0] + curveOffset[0]) * Math.cos(rad1),
                sourcePoint[1] + (rDist * curvePosition[0] + curveOffset[0]) * Math.sin(rad1)
            ],
            [
                targetPoint[0] - (rDist * curvePosition[1] - curveOffset[0]) * Math.cos(rad1),
                targetPoint[1] - (rDist * curvePosition[1] - curveOffset[0]) * Math.sin(rad1)
            ]
        ];
    }
}
$8565b08f2ca3377e$export$8992b57e8a94d77e.defaultStyleProps = {
    curvePosition: 0.5,
    curveOffset: 20
};

});

parcelRegister("ln2PG", function(module, exports) {

$parcel$export(module.exports, "CubicVertical", () => $f8edf16e1f8e8a9a$export$6a6d81877ac9a208);

var $j4n8g = parcelRequire("j4n8g");

var $4tI2g = parcelRequire("4tI2g");
class $f8edf16e1f8e8a9a$export$6a6d81877ac9a208 extends (0, $4tI2g.Cubic) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $f8edf16e1f8e8a9a$export$6a6d81877ac9a208.defaultStyleProps
        }, options));
    }
    getControlPoints(sourcePoint, targetPoint, curvePosition, curveOffset) {
        const yDist = targetPoint[1] - sourcePoint[1];
        return [
            [
                sourcePoint[0],
                sourcePoint[1] + yDist * curvePosition[0] + curveOffset[0]
            ],
            [
                targetPoint[0],
                targetPoint[1] - yDist * curvePosition[1] + curveOffset[1]
            ]
        ];
    }
}
$f8edf16e1f8e8a9a$export$6a6d81877ac9a208.defaultStyleProps = {
    curvePosition: [
        0.5,
        0.5
    ],
    curveOffset: [
        0,
        0
    ]
};

});

parcelRegister("95A9Q", function(module, exports) {

$parcel$export(module.exports, "Line", () => $69e0a0d847ac2cc7$export$17d680238e50603e);

var $j4n8g = parcelRequire("j4n8g");

var $clFkI = parcelRequire("clFkI");
class $69e0a0d847ac2cc7$export$17d680238e50603e extends (0, $clFkI.BaseEdge) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $69e0a0d847ac2cc7$export$17d680238e50603e.defaultStyleProps
        }, options));
    }
    getKeyPath(attributes) {
        const [sourcePoint, targetPoint] = this.getEndpoints(attributes);
        return [
            [
                'M',
                sourcePoint[0],
                sourcePoint[1]
            ],
            [
                'L',
                targetPoint[0],
                targetPoint[1]
            ]
        ];
    }
}
$69e0a0d847ac2cc7$export$17d680238e50603e.defaultStyleProps = {};

});

parcelRegister("5felS", function(module, exports) {

$parcel$export(module.exports, "Polyline", () => $3d197c72eb12113f$export$79f3ee03e63e7073);

var $6BVcW = parcelRequire("6BVcW");

var $25dP3 = parcelRequire("25dP3");

var $icwVF = parcelRequire("icwVF");

var $3AHBz = parcelRequire("3AHBz");

var $kV20T = parcelRequire("kV20T");

var $j4n8g = parcelRequire("j4n8g");

var $clFkI = parcelRequire("clFkI");
class $3d197c72eb12113f$export$79f3ee03e63e7073 extends (0, $clFkI.BaseEdge) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $3d197c72eb12113f$export$79f3ee03e63e7073.defaultStyleProps
        }, options));
    }
    getControlPoints(attributes) {
        const { router: router } = attributes;
        const { sourceNode: sourceNode, targetNode: targetNode } = this;
        const [sourcePoint, targetPoint] = this.getEndpoints(attributes, false);
        let controlPoints = [];
        if (!router) controlPoints = attributes.controlPoints;
        else {
            if (router.type === 'shortest-path') {
                const nodes = this.context.element.getNodes();
                controlPoints = (0, $kV20T.aStarSearch)(sourceNode, targetNode, nodes, router);
                if (!controlPoints.length) controlPoints = (0, $3AHBz.orth)(sourcePoint, targetPoint, sourceNode, targetNode, attributes.controlPoints, {
                    padding: router.offset
                });
            } else if (router.type === 'orth') controlPoints = (0, $3AHBz.orth)(sourcePoint, targetPoint, sourceNode, targetNode, attributes.controlPoints, router);
        }
        return controlPoints;
    }
    getPoints(attributes) {
        const controlPoints = this.getControlPoints(attributes);
        const [newSourcePoint, newTargetPoint] = this.getEndpoints(attributes, true, controlPoints);
        return [
            newSourcePoint,
            ...controlPoints,
            newTargetPoint
        ];
    }
    getKeyPath(attributes) {
        const points = this.getPoints(attributes);
        return (0, $25dP3.getPolylinePath)(points, attributes.radius);
    }
    getLoopPath(attributes) {
        const { sourcePort: sourcePortKey, targetPort: targetPortKey, radius: radius } = attributes;
        const node = this.sourceNode;
        const bbox = (0, $6BVcW.getNodeBBox)(node);
        // 默认转折点距离为 bbox 的最大宽高的 1/4
        // Default distance of the turning point is 1/4 of the maximum width and height of the bbox
        const defaultDist = Math.max((0, $6BVcW.getBBoxWidth)(bbox), (0, $6BVcW.getBBoxHeight)(bbox)) / 4;
        const { placement: placement, clockwise: clockwise, dist: dist = defaultDist } = (0, $icwVF.subStyleProps)(this.getGraphicStyle(attributes), 'loop');
        return (0, $25dP3.getPolylineLoopPath)(node, radius, placement, clockwise, dist, sourcePortKey, targetPortKey);
    }
}
$3d197c72eb12113f$export$79f3ee03e63e7073.defaultStyleProps = {
    radius: 0,
    controlPoints: [],
    router: false
};

});
parcelRegister("kV20T", function(module, exports) {

$parcel$export(module.exports, "aStarSearch", () => $f3aab1562094a901$export$336da06bb173b8e5);

var $jyI49 = parcelRequire("jyI49");

var $6BVcW = parcelRequire("6BVcW");

var $6A02h = parcelRequire("6A02h");

var $dOidW = parcelRequire("dOidW");
const $f3aab1562094a901$var$defaultCfg = {
    enableObstacleAvoidance: false,
    offset: 10,
    maxAllowedDirectionChange: Math.PI / 2,
    maximumLoops: 3000,
    gridSize: 5,
    startDirections: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    endDirections: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    directionMap: {
        right: {
            stepX: 1,
            stepY: 0
        },
        left: {
            stepX: -1,
            stepY: 0
        },
        bottom: {
            stepX: 0,
            stepY: 1
        },
        top: {
            stepX: 0,
            stepY: -1
        }
    },
    penalties: {
        0: 0,
        90: 0
    },
    distFunc: (0, $dOidW.manhattanDistance)
};
const $f3aab1562094a901$var$keyOf = (point)=>`${Math.round(point[0])}|||${Math.round(point[1])}`;
/**
 * <zh/> 将坐标对齐到网格
 *
 * <en/> Align to the grid
 * @param p - <zh/> 坐标 | <en/> point
 * @param gridSize - <zh/> 网格大小 | <en/> grid size
 * @returns <zh/> 对齐后的坐标 | <en/> aligned point
 */ function $f3aab1562094a901$var$alignToGrid(p, gridSize) {
    const align = (value)=>Math.round(value / gridSize);
    if ((0, $jyI49.default)(p)) return align(p);
    return p.map(align);
}
/**
 * <zh/> 获取两个角度的变化方向，并确保小于 180 度
 *
 * <en/ >Get changed direction angle and make sure less than 180 degrees
 * @param angle1 - <zh/> 第一个角度 | <en/> the first angle
 * @param angle2 - <zh/> 第二个角度 | <en/> the second angle
 * @returns <zh/> 两个角度的变化方向 | <en/> changed direction angle
 */ function $f3aab1562094a901$var$getAngleDiff(angle1, angle2) {
    const directionChange = Math.abs(angle1 - angle2);
    return directionChange > Math.PI ? 2 * Math.PI - directionChange : directionChange;
}
/**
 * <zh/> 获取从 p1 指向 p2 的向量与 x 轴正方向之间的夹角，单位为弧度
 *
 * <en/> Get the angle between the vector from p1 to p2 and the positive direction of the x-axis, in radians
 * @param p1 - <zh/> 点 p1 | <en/> point p1
 * @param p2 - <zh/> 点 p2 | <en/> point p2
 * @returns <zh/> 夹角 | <en/> angle
 */ function $f3aab1562094a901$var$getDirectionAngle(p1, p2) {
    const deltaX = p2[0] - p1[0];
    const deltaY = p2[1] - p1[1];
    if (!deltaX && !deltaY) return 0;
    return Math.atan2(deltaY, deltaX);
}
/**
 * <zh/> 获取两个点之间的方向变化
 *
 * <en/> Get direction change between two points
 * @param current - <zh/> 当前点 | <en/> current point
 * @param neighbor - <zh/> 邻居点 | <en/> neighbor point
 * @param cameFrom - <zh/> 来源点 | <en/> source point
 * @param scaleStartPoint - <zh/> 缩放后的起点 | <en/> scaled start point
 * @returns <zh/> 方向变化 | <en/> direction change
 */ function $f3aab1562094a901$var$getDirectionChange(current, neighbor, cameFrom, scaleStartPoint) {
    const directionAngle = $f3aab1562094a901$var$getDirectionAngle(current, neighbor);
    const currentCameFrom = cameFrom[$f3aab1562094a901$var$keyOf(current)];
    const prev = !currentCameFrom ? scaleStartPoint : currentCameFrom;
    const prevDirectionAngle = $f3aab1562094a901$var$getDirectionAngle(prev, current);
    return $f3aab1562094a901$var$getAngleDiff(prevDirectionAngle, directionAngle);
}
/**
 * <zh/> 获取障碍物地图
 *
 * <en/> Get obstacle map
 * @param nodes - <zh/> 图上所有节点 | <en/> all nodes on the graph
 * @param options - <zh/> 路由配置 | <en/> router options
 * @returns <zh/> 障碍物地图 | <en/> obstacle map
 */ const $f3aab1562094a901$var$getObstacleMap = (nodes, options)=>{
    const { offset: offset, gridSize: gridSize } = options;
    const obstacleMap = {};
    nodes.forEach((item)=>{
        if (!item || item.destroyed || !item.isVisible()) return;
        const bbox = (0, $6BVcW.getExpandedBBox)(item.getRenderBounds(), offset);
        for(let x = $f3aab1562094a901$var$alignToGrid(bbox.min[0], gridSize); x <= $f3aab1562094a901$var$alignToGrid(bbox.max[0], gridSize); x += 1)for(let y = $f3aab1562094a901$var$alignToGrid(bbox.min[1], gridSize); y <= $f3aab1562094a901$var$alignToGrid(bbox.max[1], gridSize); y += 1)obstacleMap[`${x}|||${y}`] = true;
    });
    return obstacleMap;
};
function $f3aab1562094a901$export$1b1a7e3f7f92eaba(from, anchors, distFunc) {
    return Math.min(...anchors.map((anchor)=>distFunc(from, anchor)));
}
function $f3aab1562094a901$export$19482c0633d216f1(points, refPoint, distFunc) {
    let nearestPoint = points[0];
    let minDistance = distFunc(points[0], refPoint);
    for(let i = 0; i < points.length; i++){
        const point = points[i];
        const dis = distFunc(point, refPoint);
        if (dis < minDistance) {
            nearestPoint = point;
            minDistance = dis;
        }
    }
    return nearestPoint;
}
/**
 * Calculate the connection points on the expanded BBox
 * @param point
 * @param node
 * @param directions
 * @param options
 */ const $f3aab1562094a901$var$getBoxPoints = (point, node, directions, options)=>{
    // create-edge 生成边的过程中，endNode 为 null
    if (!node) return [
        point
    ];
    const { directionMap: directionMap, offset: offset } = options;
    const expandedBBox = (0, $6BVcW.getExpandedBBox)(node.getRenderBounds(), offset);
    const points = Object.keys(directionMap).reduce((res, directionKey)=>{
        if (directions.includes(directionKey)) {
            const direction = directionMap[directionKey];
            const [width, height] = (0, $6BVcW.getBBoxSize)(expandedBBox);
            const otherPoint = [
                point[0] + direction.stepX * width,
                point[1] + direction.stepY * height
            ];
            const segments = (0, $6BVcW.getBBoxSegments)(expandedBBox);
            for(let i = 0; i < segments.length; i++){
                const intersectP = (0, $6A02h.getLinesIntersection)([
                    point,
                    otherPoint
                ], segments[i]);
                if (intersectP && (0, $6BVcW.isPointOnBBoxBoundary)(intersectP, expandedBBox)) res.push(intersectP);
            }
        }
        return res;
    }, []);
    if (!(0, $6BVcW.isPointInBBox)(point, expandedBBox)) points.push(point);
    return points.map((point)=>$f3aab1562094a901$var$alignToGrid(point, options.gridSize));
};
const $f3aab1562094a901$var$getControlPoints = (current, cameFrom, scaleStartPoint, endPoint, startPoints, scaleEndPoint, gridSize)=>{
    const controlPoints = [];
    // append endPoint
    let pointZero = [
        scaleEndPoint[0] === endPoint[0] ? endPoint[0] : current[0] * gridSize,
        scaleEndPoint[1] === endPoint[1] ? endPoint[1] : current[1] * gridSize
    ];
    controlPoints.unshift(pointZero);
    let _current = current;
    let _currentCameFrom = cameFrom[$f3aab1562094a901$var$keyOf(_current)];
    while(_currentCameFrom){
        const prePoint = _currentCameFrom;
        const point = _current;
        const directionChange = $f3aab1562094a901$var$getDirectionChange(prePoint, point, cameFrom, scaleStartPoint);
        if (directionChange) {
            pointZero = [
                prePoint[0] === point[0] ? pointZero[0] : prePoint[0] * gridSize,
                prePoint[1] === point[1] ? pointZero[1] : prePoint[1] * gridSize
            ];
            controlPoints.unshift(pointZero);
        }
        _currentCameFrom = cameFrom[$f3aab1562094a901$var$keyOf(prePoint)];
        _current = prePoint;
    }
    // append startPoint
    const realStartPoints = startPoints.map((point)=>[
            point[0] * gridSize,
            point[1] * gridSize
        ]);
    const startPoint = $f3aab1562094a901$export$19482c0633d216f1(realStartPoints, pointZero, (0, $dOidW.manhattanDistance));
    controlPoints.unshift(startPoint);
    return controlPoints;
};
function $f3aab1562094a901$export$336da06bb173b8e5(sourceNode, targetNode, nodes, config) {
    const startPoint = (0, $dOidW.toVector2)(sourceNode.getCenter());
    const endPoint = (0, $dOidW.toVector2)(targetNode.getCenter());
    const options = Object.assign($f3aab1562094a901$var$defaultCfg, config);
    const { gridSize: gridSize } = options;
    const obstacles = options.enableObstacleAvoidance ? nodes : [
        sourceNode,
        targetNode
    ];
    const obstacleMap = $f3aab1562094a901$var$getObstacleMap(obstacles, options);
    const scaleStartPoint = $f3aab1562094a901$var$alignToGrid(startPoint, gridSize);
    const scaleEndPoint = $f3aab1562094a901$var$alignToGrid(endPoint, gridSize);
    const startPoints = $f3aab1562094a901$var$getBoxPoints(startPoint, sourceNode, options.startDirections, options);
    const endPoints = $f3aab1562094a901$var$getBoxPoints(endPoint, targetNode, options.endDirections, options);
    startPoints.forEach((point)=>delete obstacleMap[$f3aab1562094a901$var$keyOf(point)]);
    endPoints.forEach((point)=>delete obstacleMap[$f3aab1562094a901$var$keyOf(point)]);
    const openList = {};
    const closedList = {};
    const cameFrom = {};
    // The movement cost to move from the starting point to the current point on the grid.
    const gScore = {};
    // The estimated movement cost to move from the starting point to the end point after passing through the current point.
    // f = g + h
    const fScore = {};
    const sortedOpenSet = new $f3aab1562094a901$export$da06241c4eac8180();
    for(let i = 0; i < startPoints.length; i++){
        const firstStep = startPoints[i];
        const key = $f3aab1562094a901$var$keyOf(firstStep);
        openList[key] = firstStep;
        gScore[key] = 0;
        fScore[key] = $f3aab1562094a901$export$1b1a7e3f7f92eaba(firstStep, endPoints, options.distFunc);
        // Push start point to sortedOpenSet
        sortedOpenSet.add({
            id: key,
            value: fScore[key]
        });
    }
    const endPointsKeys = endPoints.map((point)=>$f3aab1562094a901$var$keyOf(point));
    let remainLoops = options.maximumLoops;
    let current;
    let curCost = Infinity;
    for (const [id, value] of Object.entries(openList))if (fScore[id] <= curCost) {
        curCost = fScore[id];
        current = value;
    }
    while(Object.keys(openList).length > 0 && remainLoops > 0){
        const minId = sortedOpenSet.minId(false);
        if (minId) current = openList[minId];
        else break;
        const key = $f3aab1562094a901$var$keyOf(current);
        // If currentNode is final, return the successful path
        if (endPointsKeys.includes(key)) return $f3aab1562094a901$var$getControlPoints(current, cameFrom, scaleStartPoint, endPoint, startPoints, scaleEndPoint, gridSize);
        // Set currentNode as closed
        delete openList[key];
        sortedOpenSet.remove(key);
        closedList[key] = true;
        // Get the neighbor points of the next step
        for (const dir of Object.values(options.directionMap)){
            const neighbor = (0, $dOidW.add)(current, [
                dir.stepX,
                dir.stepY
            ]);
            const neighborId = $f3aab1562094a901$var$keyOf(neighbor);
            if (closedList[neighborId]) continue;
            const directionChange = $f3aab1562094a901$var$getDirectionChange(current, neighbor, cameFrom, scaleStartPoint);
            if (directionChange > options.maxAllowedDirectionChange) continue;
            if (obstacleMap[neighborId]) continue; // skip if intersects
            // Add neighbor points to openList, and calculate the cost of each neighbor point
            if (!openList[neighborId]) openList[neighborId] = neighbor;
            const directionPenalties = options.penalties[directionChange];
            const neighborCost = options.distFunc(current, neighbor) + (isNaN(directionPenalties) ? gridSize : directionPenalties);
            const costFromStart = gScore[key] + neighborCost;
            const neighborGScore = gScore[neighborId];
            if (neighborGScore && costFromStart >= neighborGScore) continue;
            cameFrom[neighborId] = current;
            gScore[neighborId] = costFromStart;
            fScore[neighborId] = costFromStart + $f3aab1562094a901$export$1b1a7e3f7f92eaba(neighbor, endPoints, options.distFunc);
            sortedOpenSet.add({
                id: neighborId,
                value: fScore[neighborId]
            });
        }
        remainLoops -= 1;
    }
    return [];
}
class $f3aab1562094a901$export$da06241c4eac8180 {
    constructor(){
        this.arr = [];
        this.map = {};
        this.arr = [];
        this.map = {};
    }
    _innerAdd(item, length) {
        let low = 0, high = length - 1;
        while(high - low > 1){
            const mid = Math.floor((low + high) / 2);
            if (this.arr[mid].value > item.value) high = mid;
            else if (this.arr[mid].value < item.value) low = mid;
            else {
                this.arr.splice(mid, 0, item);
                this.map[item.id] = true;
                return;
            }
        }
        this.arr.splice(high, 0, item);
        this.map[item.id] = true;
    }
    /**
     * <zh/> 将新项添加到适当的索引位置
     *
     * <en/> Add the new item to the appropriate index
     * @param item - <zh/> 新项 | <en/> new item
     */ add(item) {
        // 已经存在，先移除
        // If exists, remove it
        delete this.map[item.id];
        const length = this.arr.length;
        // 如果为空或者最后一个元素小于当前元素，直接添加到最后
        // If empty or the last element is less than the current element, add to the end
        if (!length || this.arr[length - 1].value < item.value) {
            this.arr.push(item);
            this.map[item.id] = true;
            return;
        }
        // 按照升序排列，找到合适的位置插入
        // Find the appropriate position to insert in ascending order
        this._innerAdd(item, length);
    }
    remove(id) {
        if (!this.map[id]) return;
        delete this.map[id];
    }
    _clearAndGetMinId() {
        let res;
        for(let i = this.arr.length - 1; i >= 0; i--)if (this.map[this.arr[i].id]) res = this.arr[i].id;
        else this.arr.splice(i, 1);
        return res;
    }
    _findFirstId() {
        while(this.arr.length){
            const first = this.arr.shift();
            if (this.map[first.id]) return first.id;
        }
    }
    minId(clear) {
        if (clear) return this._clearAndGetMinId();
        else return this._findFirstId();
    }
}

});


parcelRegister("Fb2Dh", function(module, exports) {

$parcel$export(module.exports, "Quadratic", () => $07bc650df2fbcbde$export$9a033a05ecac1137);

var $25dP3 = parcelRequire("25dP3");

var $j4n8g = parcelRequire("j4n8g");

var $clFkI = parcelRequire("clFkI");
class $07bc650df2fbcbde$export$9a033a05ecac1137 extends (0, $clFkI.BaseEdge) {
    constructor(options){
        super((0, $j4n8g.mergeOptions)({
            style: $07bc650df2fbcbde$export$9a033a05ecac1137.defaultStyleProps
        }, options));
    }
    getKeyPath(attributes) {
        const { curvePosition: curvePosition, curveOffset: curveOffset } = attributes;
        const [sourcePoint, targetPoint] = this.getEndpoints(attributes);
        const controlPoint = attributes.controlPoint || (0, $25dP3.getCurveControlPoint)(sourcePoint, targetPoint, curvePosition, curveOffset);
        return (0, $25dP3.getQuadraticPath)(sourcePoint, targetPoint, controlPoint);
    }
}
$07bc650df2fbcbde$export$9a033a05ecac1137.defaultStyleProps = {
    curvePosition: 0.5,
    curveOffset: 30
};

});





parcelRegister("h3bBs", function(module, exports) {

$parcel$export(module.exports, "CreateEdge", () => $c69bb7a102506607$export$e78e2bf103427cc0);

var $ky7aH = parcelRequire("ky7aH");
var $beZmT = parcelRequire("beZmT");
parcelRequire("ahJ7k");
var $1igYm = parcelRequire("1igYm");
var $jjMBX = parcelRequire("jjMBX");
var $9Iel2 = parcelRequire("9Iel2");
var $5vtWi = parcelRequire("5vtWi");
var $eO2am = parcelRequire("eO2am");

var $b8Sbq = parcelRequire("b8Sbq");

var $hQIOr = parcelRequire("hQIOr");
var $c69bb7a102506607$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $c69bb7a102506607$var$ASSIST_EDGE_ID = 'g6-create-edge-assist-edge-id';
const $c69bb7a102506607$var$ASSIST_NODE_ID = 'g6-create-edge-assist-node-id';
class $c69bb7a102506607$export$e78e2bf103427cc0 extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $c69bb7a102506607$export$e78e2bf103427cc0.defaultOptions, options));
        this.drop = (event)=>$c69bb7a102506607$var$__awaiter(this, void 0, void 0, function*() {
                const { targetType: targetType } = event;
                if ([
                    'combo',
                    'node'
                ].includes(targetType) && this.source) yield this.handleCreateEdge(event);
                else yield this.cancelEdge();
            });
        this.handleCreateEdge = (event)=>$c69bb7a102506607$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b, _c;
                if (!this.validate(event)) return;
                const { graph: graph, canvas: canvas, batch: batch, element: element } = this.context;
                const { style: style } = this.options;
                if (this.source) {
                    this.createEdge(event);
                    yield this.cancelEdge();
                    return;
                }
                batch.startBatch();
                canvas.setCursor('crosshair');
                this.source = this.getSelectedNodeIDs([
                    event.target.id
                ])[0];
                const sourceNode = graph.getElementData(this.source);
                graph.addNodeData([
                    {
                        id: $c69bb7a102506607$var$ASSIST_NODE_ID,
                        type: 'circle',
                        [(0, $b8Sbq.OVERRIDE_KEY)]: false,
                        style: {
                            size: 1,
                            visibility: 'hidden',
                            ports: [
                                {
                                    key: 'port-1',
                                    placement: [
                                        0.5,
                                        0.5
                                    ]
                                }
                            ],
                            x: (_a = sourceNode.style) === null || _a === void 0 ? void 0 : _a.x,
                            y: (_b = sourceNode.style) === null || _b === void 0 ? void 0 : _b.y
                        }
                    }
                ]);
                graph.addEdgeData([
                    {
                        id: $c69bb7a102506607$var$ASSIST_EDGE_ID,
                        source: this.source,
                        target: $c69bb7a102506607$var$ASSIST_NODE_ID,
                        style: Object.assign({
                            pointerEvents: 'none'
                        }, style)
                    }
                ]);
                yield (_c = element.draw({
                    animation: false
                })) === null || _c === void 0 ? void 0 : _c.finished;
            });
        this.updateAssistEdge = (event)=>$c69bb7a102506607$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                if (!this.source) return;
                const { model: model, element: element } = this.context;
                model.translateNodeTo($c69bb7a102506607$var$ASSIST_NODE_ID, [
                    event.client.x,
                    event.client.y
                ]);
                yield (_a = element.draw({
                    animation: false,
                    silence: true
                })) === null || _a === void 0 ? void 0 : _a.finished;
            });
        this.createEdge = (event)=>{
            var _a, _b;
            const { graph: graph } = this.context;
            const { style: style, onFinish: onFinish, onCreate: onCreate } = this.options;
            const targetId = (_a = event.target) === null || _a === void 0 ? void 0 : _a.id;
            if (targetId === undefined || this.source === undefined) return;
            const target = (_b = this.getSelectedNodeIDs([
                event.target.id
            ])) === null || _b === void 0 ? void 0 : _b[0];
            const id = `${this.source}-${target}-${(0, $beZmT.default)()}`;
            const edgeData = onCreate({
                id: id,
                source: this.source,
                target: target,
                style: style
            });
            if (edgeData) {
                graph.addEdgeData([
                    edgeData
                ]);
                onFinish(edgeData);
            }
        };
        this.cancelEdge = ()=>$c69bb7a102506607$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                if (!this.source) return;
                const { graph: graph, element: element, batch: batch } = this.context;
                graph.removeNodeData([
                    $c69bb7a102506607$var$ASSIST_NODE_ID
                ]);
                this.source = undefined;
                yield (_a = element.draw({
                    animation: false
                })) === null || _a === void 0 ? void 0 : _a.finished;
                batch.endBatch();
            });
        this.bindEvents();
    }
    /**
     * Update options
     * @param options - The options to update
     * @internal
     */ update(options) {
        super.update(options);
        this.bindEvents();
    }
    bindEvents() {
        const { graph: graph } = this.context;
        const { trigger: trigger } = this.options;
        this.unbindEvents();
        if (trigger === 'click') {
            graph.on((0, $eO2am.NodeEvent).CLICK, this.handleCreateEdge);
            graph.on((0, $jjMBX.ComboEvent).CLICK, this.handleCreateEdge);
            graph.on((0, $1igYm.CanvasEvent).CLICK, this.cancelEdge);
            graph.on((0, $5vtWi.EdgeEvent).CLICK, this.cancelEdge);
        } else {
            graph.on((0, $eO2am.NodeEvent).DRAG_START, this.handleCreateEdge);
            graph.on((0, $jjMBX.ComboEvent).DRAG_START, this.handleCreateEdge);
            graph.on((0, $9Iel2.CommonEvent).POINTER_UP, this.drop);
        }
        graph.on((0, $9Iel2.CommonEvent).POINTER_MOVE, this.updateAssistEdge);
    }
    getSelectedNodeIDs(currTarget) {
        return Array.from(new Set(this.context.graph.getElementDataByState('node', this.options.state).map((node)=>node.id).concat(currTarget)));
    }
    validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        graph.off((0, $eO2am.NodeEvent).CLICK, this.handleCreateEdge);
        graph.off((0, $jjMBX.ComboEvent).CLICK, this.handleCreateEdge);
        graph.off((0, $1igYm.CanvasEvent).CLICK, this.cancelEdge);
        graph.off((0, $5vtWi.EdgeEvent).CLICK, this.cancelEdge);
        graph.off((0, $eO2am.NodeEvent).DRAG_START, this.handleCreateEdge);
        graph.off((0, $jjMBX.ComboEvent).DRAG_START, this.handleCreateEdge);
        graph.off((0, $9Iel2.CommonEvent).POINTER_UP, this.drop);
        graph.off((0, $9Iel2.CommonEvent).POINTER_MOVE, this.updateAssistEdge);
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
$c69bb7a102506607$export$e78e2bf103427cc0.defaultOptions = {
    animation: true,
    enable: true,
    style: {},
    trigger: 'drag',
    onCreate: (data)=>data,
    onFinish: ()=>{}
};

});
parcelRegister("beZmT", function(module, exports) {

$parcel$export(module.exports, "default", () => $82f09af8fe4c0e9b$export$2e2bcd8739ae039);
var $82f09af8fe4c0e9b$var$map = {};
var $82f09af8fe4c0e9b$export$2e2bcd8739ae039 = function(prefix) {
    prefix = prefix || 'g';
    if (!$82f09af8fe4c0e9b$var$map[prefix]) $82f09af8fe4c0e9b$var$map[prefix] = 1;
    else $82f09af8fe4c0e9b$var$map[prefix] += 1;
    return prefix + $82f09af8fe4c0e9b$var$map[prefix];
};

});

parcelRegister("b8Sbq", function(module, exports) {

$parcel$export(module.exports, "mergeElementsData", () => $81ca78be3fd9d533$export$11643f83153490f8);
$parcel$export(module.exports, "cloneElementData", () => $81ca78be3fd9d533$export$f2bbbd077044c898);
$parcel$export(module.exports, "isElementDataEqual", () => $81ca78be3fd9d533$export$221be5f16842c206);
$parcel$export(module.exports, "OVERRIDE_KEY", () => $81ca78be3fd9d533$export$a7b057e0cd28292b);
$parcel$export(module.exports, "isOverridable", () => $81ca78be3fd9d533$export$4a7257654b13c3e1);

var $6XARU = parcelRequire("6XARU");
var $81ca78be3fd9d533$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $81ca78be3fd9d533$export$11643f83153490f8(original, modified) {
    const { data: originalData, style: originalStyle } = original, originalAttrs = $81ca78be3fd9d533$var$__rest(original, [
        "data",
        "style"
    ]);
    const { data: modifiedData, style: modifiedStyle } = modified, modifiedAttrs = $81ca78be3fd9d533$var$__rest(modified, [
        "data",
        "style"
    ]);
    const result = Object.assign(Object.assign({}, originalAttrs), modifiedAttrs);
    if (originalData || modifiedData) Object.assign(result, {
        data: Object.assign(Object.assign({}, originalData), modifiedData)
    });
    if (originalStyle || modifiedStyle) Object.assign(result, {
        style: Object.assign(Object.assign({}, originalStyle), modifiedStyle)
    });
    return result;
}
function $81ca78be3fd9d533$export$f2bbbd077044c898(data) {
    const { data: customData, style: style } = data, restAttrs = $81ca78be3fd9d533$var$__rest(data, [
        "data",
        "style"
    ]);
    const clonedData = restAttrs;
    if (customData) clonedData.data = Object.assign({}, customData);
    if (style) clonedData.style = Object.assign({}, style);
    return clonedData;
}
function $81ca78be3fd9d533$export$ea55f474a468804e(data) {
    return !(0, $6XARU.default)(data, [
        'nodes',
        'length'
    ]) && !(0, $6XARU.default)(data, [
        'edges',
        'length'
    ]) && !(0, $6XARU.default)(data, [
        'combos',
        'length'
    ]);
}
function $81ca78be3fd9d533$export$221be5f16842c206(original = {}, modified = {}) {
    const { states: originalStates = [], data: originalData = {}, style: originalStyle = {}, children: originalChildren = [] } = original, originalAttrs = $81ca78be3fd9d533$var$__rest(original, [
        "states",
        "data",
        "style",
        "children"
    ]);
    const { states: modifiedStates = [], data: modifiedData = {}, style: modifiedStyle = {}, children: modifiedChildren = [] } = modified, modifiedAttrs = $81ca78be3fd9d533$var$__rest(modified, [
        "states",
        "data",
        "style",
        "children"
    ]);
    const isArrayEqual = (arr1, arr2)=>{
        if (arr1.length !== arr2.length) return false;
        return arr1.every((item, index)=>item === arr2[index]);
    };
    const isObjectEqual = (obj1, obj2)=>{
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length) return false;
        return keys1.every((key)=>obj1[key] === obj2[key]);
    };
    if (!isObjectEqual(originalAttrs, modifiedAttrs)) return false;
    if (!isArrayEqual(originalChildren, modifiedChildren)) return false;
    if (!isArrayEqual(originalStates, modifiedStates)) return false;
    if (!isObjectEqual(originalData, modifiedData)) return false;
    if (!isObjectEqual(originalStyle, modifiedStyle)) return false;
    return true;
}
const $81ca78be3fd9d533$export$a7b057e0cd28292b = '__internal_override__';
function $81ca78be3fd9d533$export$4a7257654b13c3e1(datum) {
    return datum[$81ca78be3fd9d533$export$a7b057e0cd28292b] !== false;
}

});


parcelRegister("1hotb", function(module, exports) {

$parcel$export(module.exports, "DragCanvas", () => $0eea5c27ada808f2$export$dee4bee6fd54839f);

var $2ZmO4 = parcelRequire("2ZmO4");
var $6JKSc = parcelRequire("6JKSc");
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");

var $6BVcW = parcelRequire("6BVcW");

var $1uR12 = parcelRequire("1uR12");

var $j5Xqx = parcelRequire("j5Xqx");

var $lXl1S = parcelRequire("lXl1S");

var $dOidW = parcelRequire("dOidW");

var $hQIOr = parcelRequire("hQIOr");
var $0eea5c27ada808f2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $0eea5c27ada808f2$export$dee4bee6fd54839f extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $0eea5c27ada808f2$export$dee4bee6fd54839f.defaultOptions, options));
        this.isDragging = false;
        this.onDragStart = (event)=>{
            if (!this.validate(event)) return;
            this.isDragging = true;
            this.context.canvas.setCursor('grabbing');
        };
        this.onDrag = (event)=>{
            var _a, _b, _c, _d;
            if (!this.isDragging || (0, $j5Xqx.PinchHandler).isPinching) return;
            const x = (_b = (_a = event.movement) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : event.dx;
            const y = (_d = (_c = event.movement) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : event.dy;
            if ((x | y) !== 0) this.translate([
                x,
                y
            ], false);
        };
        this.onDragEnd = ()=>{
            var _a, _b;
            this.isDragging = false;
            this.context.canvas.setCursor(this.defaultCursor);
            (_b = (_a = this.options).onFinish) === null || _b === void 0 || _b.call(_a);
        };
        this.invokeOnFinish = (0, $2ZmO4.default)(()=>{
            var _a, _b;
            (_b = (_a = this.options).onFinish) === null || _b === void 0 || _b.call(_a);
        }, 300);
        this.shortcut = new (0, $lXl1S.Shortcut)(context.graph);
        this.bindEvents();
        this.defaultCursor = this.context.canvas.getConfig().cursor || 'default';
    }
    /**
     * <zh/> 更新配置
     *
     * <en/> Update options
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */ update(options) {
        this.unbindEvents();
        super.update(options);
        this.bindEvents();
    }
    bindEvents() {
        const { trigger: trigger } = this.options;
        if ((0, $6JKSc.default)(trigger)) {
            const { up: up = [], down: down = [], left: left = [], right: right = [] } = trigger;
            this.shortcut.bind(up, (event)=>this.onTranslate([
                    0,
                    1
                ], event));
            this.shortcut.bind(down, (event)=>this.onTranslate([
                    0,
                    -1
                ], event));
            this.shortcut.bind(left, (event)=>this.onTranslate([
                    1,
                    0
                ], event));
            this.shortcut.bind(right, (event)=>this.onTranslate([
                    -1,
                    0
                ], event));
        } else {
            const { graph: graph } = this.context;
            graph.on((0, $9Iel2.CommonEvent).DRAG_START, this.onDragStart);
            graph.on((0, $9Iel2.CommonEvent).DRAG, this.onDrag);
            graph.on((0, $9Iel2.CommonEvent).DRAG_END, this.onDragEnd);
        }
    }
    onTranslate(value, event) {
        return $0eea5c27ada808f2$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.validate(event)) return;
            const { sensitivity: sensitivity } = this.options;
            const delta = sensitivity * -1;
            yield this.translate((0, $dOidW.multiply)(value, delta), this.options.animation);
            this.invokeOnFinish();
        });
    }
    /**
     * <zh/> 平移画布
     *
     * <en/> Translate canvas
     * @param offset - <zh/> 平移距离 | <en/> Translation distance
     * @param animation - <zh/> 动画配置 | <en/> Animation configuration
     * @internal
     */ translate(offset, animation) {
        return $0eea5c27ada808f2$var$__awaiter(this, void 0, void 0, function*() {
            offset = this.clampByDirection(offset);
            offset = this.clampByRange(offset);
            offset = this.clampByRotation(offset);
            yield this.context.graph.translateBy(offset, animation);
        });
    }
    clampByRotation([dx, dy]) {
        const rotation = this.context.graph.getRotation();
        return (0, $dOidW.rotate)([
            dx,
            dy
        ], rotation);
    }
    clampByDirection([dx, dy]) {
        const { direction: direction } = this.options;
        if (direction === 'x') dy = 0;
        else if (direction === 'y') dx = 0;
        return [
            dx,
            dy
        ];
    }
    clampByRange([dx, dy]) {
        const { viewport: viewport, canvas: canvas } = this.context;
        const [canvasWidth, canvasHeight] = canvas.getSize();
        const [top, right, bottom, left] = (0, $1uR12.parsePadding)(this.options.range);
        const range = [
            canvasHeight * top,
            canvasWidth * right,
            canvasHeight * bottom,
            canvasWidth * left
        ];
        const draggableArea = (0, $6BVcW.getExpandedBBox)((0, $6BVcW.getPointBBox)(viewport.getCanvasCenter()), range);
        const nextViewportCenter = (0, $dOidW.subtract)(viewport.getViewportCenter(), [
            dx,
            dy,
            0
        ]);
        if (!(0, $6BVcW.isPointInBBox)(nextViewportCenter, draggableArea)) {
            const { min: [minX, minY], max: [maxX, maxY] } = draggableArea;
            if (nextViewportCenter[0] < minX && dx > 0 || nextViewportCenter[0] > maxX && dx < 0) dx = 0;
            if (nextViewportCenter[1] < minY && dy > 0 || nextViewportCenter[1] > maxY && dy < 0) dy = 0;
        }
        return [
            dx,
            dy
        ];
    }
    validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if (typeof enable === 'function') return enable(event);
        return !!enable;
    }
    unbindEvents() {
        this.shortcut.unbindAll();
        const { graph: graph } = this.context;
        graph.off((0, $9Iel2.CommonEvent).DRAG_START, this.onDragStart);
        graph.off((0, $9Iel2.CommonEvent).DRAG, this.onDrag);
        graph.off((0, $9Iel2.CommonEvent).DRAG_END, this.onDragEnd);
    }
    destroy() {
        this.shortcut.destroy();
        this.unbindEvents();
        this.context.canvas.setCursor(this.defaultCursor);
        super.destroy();
    }
}
$0eea5c27ada808f2$export$dee4bee6fd54839f.defaultOptions = {
    enable: (event)=>{
        if ('targetType' in event) return event.targetType === 'canvas';
        return true;
    },
    sensitivity: 10,
    direction: 'both',
    range: Infinity
};

});
parcelRegister("2ZmO4", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d2f82aee427992$export$2e2bcd8739ae039);
function $22d2f82aee427992$var$debounce(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}
var $22d2f82aee427992$export$2e2bcd8739ae039 = $22d2f82aee427992$var$debounce;

});


parcelRegister("hDdHF", function(module, exports) {

$parcel$export(module.exports, "DragElement", () => $cd60b565fbc67af4$export$64e6d832eadee3e5);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $1igYm = parcelRequire("1igYm");
var $lDPR9 = parcelRequire("lDPR9");
var $jjMBX = parcelRequire("jjMBX");
var $9Iel2 = parcelRequire("9Iel2");

var $6BVcW = parcelRequire("6BVcW");

var $hn4z6 = parcelRequire("hn4z6");

var $brtTw = parcelRequire("brtTw");

var $icwVF = parcelRequire("icwVF");

var $lXl1S = parcelRequire("lXl1S");

var $dOidW = parcelRequire("dOidW");

var $hQIOr = parcelRequire("hQIOr");
var $cd60b565fbc67af4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $cd60b565fbc67af4$export$64e6d832eadee3e5 extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $cd60b565fbc67af4$export$64e6d832eadee3e5.defaultOptions, options));
        this.enable = false;
        this.enableElements = [
            'node',
            'combo'
        ];
        this.target = [];
        this.shadowOrigin = [
            0,
            0
        ];
        this.hiddenEdges = [];
        this.isDragging = false;
        /**
         * <zh/> 拖拽放下的回调
         *
         * <en/> Callback when dragging is released
         * @param event - <zh/> 拖拽事件对象 | <en/> drag event object
         */ this.onDrop = (event)=>$cd60b565fbc67af4$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                if (this.options.dropEffect !== 'link') return;
                const { model: model, element: element } = this.context;
                const modifiedParentId = event.target.id;
                this.target.forEach((id)=>{
                    const originalParent = model.getParentData(id, (0, $lDPR9.COMBO_KEY));
                    // 如果是在原父 combo 内部拖拽，需要刷新 combo 数据
                    // If it is a drag and drop within the original parent combo, you need to refresh the combo data
                    if (originalParent && (0, $brtTw.idOf)(originalParent) === modifiedParentId) model.refreshComboData(modifiedParentId);
                    model.setParent(id, modifiedParentId, (0, $lDPR9.COMBO_KEY));
                });
                yield (_a = element === null || element === void 0 ? void 0 : element.draw({
                    animation: true
                })) === null || _a === void 0 ? void 0 : _a.finished;
            });
        this.setCursor = (event)=>{
            if (this.isDragging) return;
            const { type: type } = event;
            const { canvas: canvas } = this.context;
            const { cursor: cursor } = this.options;
            if (type === (0, $9Iel2.CommonEvent).POINTER_ENTER) canvas.setCursor((cursor === null || cursor === void 0 ? void 0 : cursor.grab) || 'grab');
            else canvas.setCursor((cursor === null || cursor === void 0 ? void 0 : cursor.default) || 'default');
        };
        this.shortcut = new (0, $lXl1S.Shortcut)(context.graph);
        this.onDragStart = this.onDragStart.bind(this);
        this.onDrag = this.onDrag.bind(this);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.onDrop = this.onDrop.bind(this);
        this.bindEvents();
    }
    /**
     * <zh/> 更新元素拖拽配置
     *
     * <en/> Update the element dragging configuration
     * @param options - <zh/> 配置项 | <en/> options
     * @internal
     */ update(options) {
        this.unbindEvents();
        super.update(options);
        this.bindEvents();
    }
    bindEvents() {
        const { graph: graph, canvas: canvas } = this.context;
        // @ts-expect-error internal property
        const $canvas = canvas.getLayer().getContextService().$canvas;
        if ($canvas) {
            $canvas.addEventListener('blur', this.onDragEnd);
            $canvas.addEventListener('contextmenu', this.onDragEnd);
        }
        this.enableElements.forEach((type)=>{
            graph.on(`${type}:${(0, $9Iel2.CommonEvent).DRAG_START}`, this.onDragStart);
            graph.on(`${type}:${(0, $9Iel2.CommonEvent).DRAG}`, this.onDrag);
            graph.on(`${type}:${(0, $9Iel2.CommonEvent).DRAG_END}`, this.onDragEnd);
            graph.on(`${type}:${(0, $9Iel2.CommonEvent).POINTER_ENTER}`, this.setCursor);
            graph.on(`${type}:${(0, $9Iel2.CommonEvent).POINTER_LEAVE}`, this.setCursor);
        });
        if ([
            'link'
        ].includes(this.options.dropEffect)) {
            graph.on((0, $jjMBX.ComboEvent).DROP, this.onDrop);
            graph.on((0, $1igYm.CanvasEvent).DROP, this.onDrop);
        }
    }
    /**
     * <zh/> 获取当前选中的节点 id 集合
     *
     * <en/> Get the id collection of the currently selected node
     * @param currTarget - <zh/> 当前拖拽目标元素 id 集合 | <en/> The id collection of the current drag target element
     * @returns <zh/> 当前选中的节点 id 集合 | <en/> The id collection of the currently selected node
     * @internal
     */ getSelectedNodeIDs(currTarget) {
        return Array.from(new Set(this.context.graph.getElementDataByState('node', this.options.state).map((node)=>node.id).concat(currTarget)));
    }
    /**
     * Get the delta of the drag
     * @param event - drag event object
     * @returns delta
     * @internal
     */ getDelta(event) {
        const zoom = this.context.graph.getZoom();
        return (0, $dOidW.divide)([
            event.dx,
            event.dy
        ], zoom);
    }
    /**
     * <zh/> 拖拽开始时的回调
     *
     * <en/> Callback when dragging starts
     * @param event - <zh/> 拖拽事件对象 | <en/> drag event object
     * @internal
     */ onDragStart(event) {
        var _a;
        this.enable = this.validate(event);
        if (!this.enable) return;
        const { batch: batch, canvas: canvas, graph: graph } = this.context;
        canvas.setCursor(((_a = this.options.cursor) === null || _a === void 0 ? void 0 : _a.grabbing) || 'grabbing');
        this.isDragging = true;
        batch.startBatch();
        // 如果当前节点是选中状态，则查询出画布中所有选中的节点，否则只拖拽当前节点
        // If the current node is selected, query all selected nodes in the canvas, otherwise only drag the current node
        const id = event.target.id;
        const states = graph.getElementState(id);
        if (states.includes(this.options.state)) this.target = this.getSelectedNodeIDs([
            id
        ]);
        else this.target = [
            id
        ];
        this.hideEdge();
        this.context.graph.frontElement(this.target);
        if (this.options.shadow) this.createShadow(this.target);
    }
    /**
     * <zh/> 拖拽过程中的回调
     *
     * <en/> Callback when dragging
     * @param event - <zh/> 拖拽事件对象 | <en/> drag event object
     * @internal
     */ onDrag(event) {
        if (!this.enable) return;
        const delta = this.getDelta(event);
        if (this.options.shadow) this.moveShadow(delta);
        else this.moveElement(this.target, delta);
    }
    /**
     * <zh/> 元素拖拽结束的回调
     *
     * <en/> Callback when dragging ends
     * @internal
     */ onDragEnd() {
        var _a, _b, _c;
        if (!this.enable) return; // It can be called multiple times
        this.enable = false;
        if (this.options.shadow) {
            if (!this.shadow) return;
            this.shadow.style.visibility = 'hidden';
            const { x: x = 0, y: y = 0 } = this.shadow.attributes;
            const [dx, dy] = (0, $dOidW.subtract)([
                +x,
                +y
            ], this.shadowOrigin);
            this.moveElement(this.target, [
                dx,
                dy
            ]);
        }
        this.showEdges();
        (_b = (_a = this.options).onFinish) === null || _b === void 0 || _b.call(_a, this.target);
        const { batch: batch, canvas: canvas } = this.context;
        batch.endBatch();
        canvas.setCursor(((_c = this.options.cursor) === null || _c === void 0 ? void 0 : _c.grab) || 'grab');
        this.isDragging = false;
        this.target = [];
    }
    /**
     * <zh/> 当前按键是否和 trigger 配置一致
     *
     * <en/> Is the current key consistent with the trigger configuration
     * @returns <zh/> 是否一致 | <en/> Is consistent
     * @internal
     */ isKeydown() {
        const { trigger: trigger } = this.options;
        if (!(trigger === null || trigger === void 0 ? void 0 : trigger.length)) return true;
        return this.shortcut.match(trigger);
    }
    /**
     * <zh/> 验证元素是否允许拖拽
     *
     * <en/> Verify if the element is allowed to be dragged
     * @param event - <zh/> 拖拽事件对象 | <en/> drag event object
     * @returns <zh/> 是否允许拖拽 | <en/> Whether to allow dragging
     * @internal
     */ validate(event) {
        if (this.destroyed || (0, $hn4z6.isToBeDestroyed)(event.target) || // @ts-expect-error private property
        // 避免动画冲突，在combo/node折叠展开过程中不触发
        this.context.graph.isCollapsingExpanding || !this.isKeydown()) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    clampByRotation([dx, dy]) {
        const rotation = this.context.graph.getRotation();
        return (0, $dOidW.rotate)([
            dx,
            dy
        ], rotation);
    }
    /**
     * <zh/> 移动元素
     *
     * <en/> Move the element
     * @param ids - <zh/> 元素 id 集合 | <en/> element id collection
     * @param offset <zh/> 偏移量 | <en/> offset
     * @internal
     */ moveElement(ids, offset) {
        return $cd60b565fbc67af4$var$__awaiter(this, void 0, void 0, function*() {
            const { graph: graph, model: model } = this.context;
            const { dropEffect: dropEffect } = this.options;
            if (dropEffect === 'move') ids.forEach((id)=>model.refreshComboData(id));
            graph.translateElementBy(Object.fromEntries(ids.map((id)=>[
                    id,
                    this.clampByRotation(offset)
                ])), false);
        });
    }
    moveShadow(offset) {
        if (!this.shadow) return;
        const { x: x = 0, y: y = 0 } = this.shadow.attributes;
        const [dx, dy] = offset;
        this.shadow.attr({
            x: +x + dx,
            y: +y + dy
        });
    }
    createShadow(target) {
        const shadowStyle = (0, $icwVF.subStyleProps)(this.options, 'shadow');
        const bbox = (0, $6BVcW.getCombinedBBox)(target.map((id)=>this.context.element.getElement(id).getBounds()));
        const [x, y] = bbox.min;
        this.shadowOrigin = [
            x,
            y
        ];
        const [width, height] = (0, $6BVcW.getBBoxSize)(bbox);
        const positionStyle = {
            width: width,
            height: height,
            x: x,
            y: y
        };
        if (this.shadow) this.shadow.attr(Object.assign(Object.assign(Object.assign({}, shadowStyle), positionStyle), {
            visibility: 'visible'
        }));
        else {
            this.shadow = new (0, $2eDEB.Rect)({
                style: Object.assign(Object.assign(Object.assign({
                    // @ts-ignore $layer is not in the type definition
                    $layer: 'transient'
                }, shadowStyle), positionStyle), {
                    pointerEvents: 'none'
                })
            });
            this.context.canvas.appendChild(this.shadow);
        }
    }
    showEdges() {
        if (this.options.shadow || this.hiddenEdges.length === 0) return;
        this.context.graph.showElement(this.hiddenEdges);
        this.hiddenEdges = [];
    }
    /**
     * Hide the edge
     * @internal
     */ hideEdge() {
        const { hideEdge: hideEdge, shadow: shadow } = this.options;
        if (hideEdge === 'none' || shadow) return;
        const { graph: graph } = this.context;
        if (hideEdge === 'all') this.hiddenEdges = graph.getEdgeData().map((0, $brtTw.idOf));
        else this.hiddenEdges = Array.from(new Set(this.target.map((id)=>graph.getRelatedEdgesData(id, hideEdge).map((0, $brtTw.idOf))).flat()));
        graph.hideElement(this.hiddenEdges);
    }
    unbindEvents() {
        const { graph: graph, canvas: canvas } = this.context;
        // @ts-expect-error internal property
        const $canvas = canvas.getLayer().getContextService().$canvas;
        if ($canvas) {
            $canvas.removeEventListener('blur', this.onDragEnd);
            $canvas.removeEventListener('contextmenu', this.onDragEnd);
        }
        this.enableElements.forEach((type)=>{
            graph.off(`${type}:${(0, $9Iel2.CommonEvent).DRAG_START}`, this.onDragStart);
            graph.off(`${type}:${(0, $9Iel2.CommonEvent).DRAG}`, this.onDrag);
            graph.off(`${type}:${(0, $9Iel2.CommonEvent).DRAG_END}`, this.onDragEnd);
            graph.off(`${type}:${(0, $9Iel2.CommonEvent).POINTER_ENTER}`, this.setCursor);
            graph.off(`${type}:${(0, $9Iel2.CommonEvent).POINTER_LEAVE}`, this.setCursor);
        });
        graph.off(`combo:${(0, $9Iel2.CommonEvent).DROP}`, this.onDrop);
        graph.off(`canvas:${(0, $9Iel2.CommonEvent).DROP}`, this.onDrop);
    }
    destroy() {
        var _a;
        this.unbindEvents();
        (_a = this.shadow) === null || _a === void 0 || _a.destroy();
        super.destroy();
    }
}
$cd60b565fbc67af4$export$64e6d832eadee3e5.defaultOptions = {
    animation: true,
    enable: (event)=>[
            'node',
            'combo'
        ].includes(event.targetType),
    trigger: [],
    dropEffect: 'move',
    state: 'selected',
    hideEdge: 'none',
    shadow: false,
    shadowZIndex: 100,
    shadowFill: '#F3F9FF',
    shadowFillOpacity: 0.5,
    shadowStroke: '#1890FF',
    shadowStrokeOpacity: 0.9,
    shadowLineDash: [
        5,
        5
    ],
    cursor: {
        default: 'default',
        grab: 'grab',
        grabbing: 'grabbing'
    }
};

});

parcelRegister("g3gkU", function(module, exports) {

$parcel$export(module.exports, "DragElementForce", () => $baf999321fd6a7d5$export$3faac5b3c2111440);

var $brtTw = parcelRequire("brtTw");

var $fYedv = parcelRequire("fYedv");

var $aBpmX = parcelRequire("aBpmX");

var $dOidW = parcelRequire("dOidW");

var $hDdHF = parcelRequire("hDdHF");
var $baf999321fd6a7d5$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $baf999321fd6a7d5$export$3faac5b3c2111440 extends (0, $hDdHF.DragElement) {
    get forceLayoutInstance() {
        return this.context.layout.getLayoutInstance().find((layout)=>[
                'd3-force',
                'd3-force-3d'
            ].includes(layout === null || layout === void 0 ? void 0 : layout.id));
    }
    /**
     * Whether the behavior is enabled
     * @param event - The event object
     * @returns Is the behavior enabled
     * @internal
     */ validate(event) {
        if (!this.context.layout) return false;
        // 未使用力导布局 / The force layout is not used
        if (!this.forceLayoutInstance) {
            (0, $aBpmX.print).warn('DragElementForce only works with d3-force or d3-force-3d layout');
            return false;
        }
        return super.validate(event);
    }
    /**
     * Move selected elements by offset
     * @param ids - The selected element IDs
     * @param offset - The offset to move
     * @internal
     */ moveElement(ids, offset) {
        return $baf999321fd6a7d5$var$__awaiter(this, void 0, void 0, function*() {
            const layout = this.forceLayoutInstance;
            this.context.graph.getNodeData(ids).forEach((element, index)=>{
                const { x: x = 0, y: y = 0 } = element.style || {};
                if (layout) (0, $fYedv.invokeLayoutMethod)(layout, 'setFixedPosition', ids[index], [
                    ...(0, $dOidW.add)([
                        +x,
                        +y
                    ], this.clampByRotation(offset))
                ]);
            });
        });
    }
    /**
     * Triggered when the drag starts
     * @param event - The event object
     * @internal
     */ onDragStart(event) {
        this.enable = this.validate(event);
        if (!this.enable) return;
        this.target = this.getSelectedNodeIDs([
            event.target.id
        ]);
        this.hideEdge();
        this.context.graph.frontElement(this.target);
        const layout = this.forceLayoutInstance;
        if (layout) (0, $fYedv.getLayoutProperty)(layout, 'simulation').alphaTarget(0.3).restart();
        this.context.graph.getNodeData(this.target).forEach((element)=>{
            const { x: x = 0, y: y = 0 } = element.style || {};
            if (layout) (0, $fYedv.invokeLayoutMethod)(layout, 'setFixedPosition', (0, $brtTw.idOf)(element), [
                +x,
                +y
            ]);
        });
    }
    /**
     * Triggered when dragging
     * @param event - The event object
     * @internal
     */ onDrag(event) {
        if (!this.enable) return;
        const delta = this.getDelta(event);
        this.moveElement(this.target, delta);
    }
    /**
     * Triggered when the drag ends
     * @internal
     */ onDragEnd() {
        const layout = this.forceLayoutInstance;
        if (layout) (0, $fYedv.getLayoutProperty)(layout, 'simulation').alphaTarget(0);
        if (this.options.fixed) return;
        this.context.graph.getNodeData(this.target).forEach((element)=>{
            if (layout) (0, $fYedv.invokeLayoutMethod)(layout, 'setFixedPosition', (0, $brtTw.idOf)(element), [
                null,
                null,
                null
            ]);
        });
    }
}

});
parcelRegister("fYedv", function(module, exports) {

$parcel$export(module.exports, "isTreeLayout", () => $ba077cc955df8726$export$ec6d94033153a14a);
$parcel$export(module.exports, "isPreLayout", () => $ba077cc955df8726$export$eba60a459b3a7377);
$parcel$export(module.exports, "layoutMapping2GraphData", () => $ba077cc955df8726$export$927fde7be93d9a49);
$parcel$export(module.exports, "layoutAdapter", () => $ba077cc955df8726$export$1e569385ee575d7c);
$parcel$export(module.exports, "invokeLayoutMethod", () => $ba077cc955df8726$export$92b1ee04438d1b55);
$parcel$export(module.exports, "getLayoutProperty", () => $ba077cc955df8726$export$6719a9f73df18749);

var $fc2XC = parcelRequire("fc2XC");

var $iE4so = parcelRequire("iE4so");
var $jyI49 = parcelRequire("jyI49");
parcelRequire("ahJ7k");
var $lDPR9 = parcelRequire("lDPR9");

var $ht4Ur = parcelRequire("ht4Ur");

var $brtTw = parcelRequire("brtTw");

var $dnXls = parcelRequire("dnXls");
var $ba077cc955df8726$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ba077cc955df8726$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $ba077cc955df8726$export$fd133d193aaf2389(options) {
    const { type: type } = options;
    if ([
        'comboCombined',
        'comboForce'
    ].includes(type)) return true;
    if (type === 'antv-dagre' && options.sortByCombo) return true;
    return false;
}
function $ba077cc955df8726$export$ec6d94033153a14a(options) {
    const { type: type } = options;
    return [
        'compact-box',
        'mindmap',
        'dendrogram',
        'indented'
    ].includes(type);
}
function $ba077cc955df8726$export$efe1eb554269eec9(data) {
    return (0, $jyI49.default)(data.x) && (0, $jyI49.default)(data.y);
}
function $ba077cc955df8726$export$eba60a459b3a7377(options) {
    return !Array.isArray(options) && (options === null || options === void 0 ? void 0 : options.preLayout);
}
function $ba077cc955df8726$export$927fde7be93d9a49(layoutMapping) {
    const { nodes: nodes, edges: edges } = layoutMapping;
    const data = {
        nodes: [],
        edges: [],
        combos: []
    };
    nodes.forEach((nodeLike)=>{
        const target = nodeLike.data._isCombo ? data.combos : data.nodes;
        const { x: x, y: y, z: z = 0 } = nodeLike.data;
        target === null || target === void 0 || target.push({
            id: nodeLike.id,
            style: {
                x: x,
                y: y,
                z: z
            }
        });
    });
    edges.forEach((edge)=>{
        const { id: id, source: source, target: target, data: { points: points = [], controlPoints: controlPoints = points.slice(1, points.length - 1) } } = edge;
        data.edges.push({
            id: id,
            source: source,
            target: target,
            style: Object.assign({}, (controlPoints === null || controlPoints === void 0 ? void 0 : controlPoints.length) ? {
                controlPoints: controlPoints.map((0, $dnXls.parsePoint))
            } : {})
        });
    });
    return data;
}
function $ba077cc955df8726$export$1e569385ee575d7c(Ctor, context) {
    class AdaptLayout extends (0, $ht4Ur.BaseLayout) {
        constructor(context, options){
            super(context, options);
            this.instance = new Ctor({});
            this.id = this.instance.id;
            if ('stop' in this.instance && 'tick' in this.instance) {
                const instance = this.instance;
                this.stop = instance.stop.bind(instance);
                this.tick = (iterations)=>{
                    const tickResult = instance.tick(iterations);
                    return $ba077cc955df8726$export$927fde7be93d9a49(tickResult);
                };
            }
        }
        execute(model, options) {
            return $ba077cc955df8726$var$__awaiter(this, void 0, void 0, function*() {
                return $ba077cc955df8726$export$927fde7be93d9a49((yield this.instance.execute(this.graphData2LayoutModel(model), this.transformOptions((0, $iE4so.default)({}, this.options, options)))));
            });
        }
        transformOptions(options) {
            if (!('onTick' in options)) return options;
            const onTick = options.onTick;
            options.onTick = (data)=>onTick($ba077cc955df8726$export$927fde7be93d9a49(data));
            return options;
        }
        graphData2LayoutModel(data) {
            const { nodes: nodes = [], edges: edges = [], combos: combos = [] } = data;
            const nodesToLayout = nodes.map((datum)=>{
                const id = (0, $brtTw.idOf)(datum);
                const { data: data, style: style, combo: combo } = datum, rest = $ba077cc955df8726$var$__rest(datum, [
                    "data",
                    "style",
                    "combo"
                ]);
                const result = {
                    id: id,
                    data: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, data), {
                        data: data
                    }), combo ? {
                        parentId: combo
                    } : {}), {
                        style: style
                    }), rest)
                };
                // 一些布局会从 data 中读取位置信息
                if (style === null || style === void 0 ? void 0 : style.x) Object.assign(result.data, {
                    x: style.x
                });
                if (style === null || style === void 0 ? void 0 : style.y) Object.assign(result.data, {
                    y: style.y
                });
                if (style === null || style === void 0 ? void 0 : style.z) Object.assign(result.data, {
                    z: style.z
                });
                return result;
            });
            const nodesIdMap = new Map(nodesToLayout.map((node)=>[
                    node.id,
                    node
                ]));
            const edgesToLayout = edges.filter((edge)=>{
                const { source: source, target: target } = edge;
                return nodesIdMap.has(source) && nodesIdMap.has(target);
            }).map((edge)=>{
                const { source: source, target: target, data: data, style: style } = edge;
                return {
                    id: (0, $brtTw.idOf)(edge),
                    source: source,
                    target: target,
                    data: Object.assign({}, data),
                    style: Object.assign({}, style)
                };
            });
            const combosToLayout = combos.map((combo)=>{
                return {
                    id: (0, $brtTw.idOf)(combo),
                    data: Object.assign({
                        _isCombo: true
                    }, combo.data),
                    style: Object.assign({}, combo.style)
                };
            });
            const layoutModel = new (0, $fc2XC.Graph)({
                nodes: [
                    ...nodesToLayout,
                    ...combosToLayout
                ],
                edges: edgesToLayout
            });
            if (context.model.model.hasTreeStructure((0, $lDPR9.COMBO_KEY))) {
                layoutModel.attachTreeStructure((0, $lDPR9.COMBO_KEY));
                // 同步层级关系 / Synchronize hierarchical relationships
                nodesToLayout.forEach((node)=>{
                    const parent = context.model.model.getParent(node.id, (0, $lDPR9.COMBO_KEY));
                    if (parent && layoutModel.hasNode(parent.id)) layoutModel.setParent(node.id, parent.id, (0, $lDPR9.COMBO_KEY));
                });
            }
            return layoutModel;
        }
    }
    return AdaptLayout;
}
function $ba077cc955df8726$export$92b1ee04438d1b55(layout, method, ...args) {
    if (method in layout) return layout[method](...args);
    // invoke AdaptLayout method
    if ('instance' in layout) {
        const instance = layout.instance;
        if (method in instance) return instance[method](...args);
    }
    return null;
}
function $ba077cc955df8726$export$6719a9f73df18749(layout, name) {
    if (name in layout) return layout[name];
    if ('instance' in layout) {
        const instance = layout.instance;
        if (name in instance) return instance[name];
    }
    return null;
}

});
parcelRegister("fc2XC", function(module, exports) {

$parcel$export(module.exports, "Graph", () => $b0fa45e53e1e94ef$export$614db49f3febe941);

var $7VXo7 = parcelRequire("7VXo7");

var $iGAUM = parcelRequire("iGAUM");

var $7HjkA = parcelRequire("7HjkA");
class $b0fa45e53e1e94ef$export$614db49f3febe941 extends (0, $7VXo7.default) {
    nodeMap = new Map();
    edgeMap = new Map();
    inEdgesMap = new Map();
    outEdgesMap = new Map();
    bothEdgesMap = new Map();
    treeIndices = new Map();
    changes = [];
    batchCount = 0;
    /**
     * This function is called with a {@link GraphChangedEvent} each time a graph change happened.
     *
     * `event.changes` contains all the graph changes in order since last `onChanged`.
     */ onChanged = ()=>{
    // Do nothing.
    };
    /**
     * Create a new Graph instance.
     * @param options - The options to initialize a graph. See {@link GraphOptions}.
     *
     * ```ts
     * const graph = new Graph({
     *   // Optional, initial nodes.
     *   nodes: [
     *     // Each node has a unique ID.
     *     { id: 'A', foo: 1 },
     *     { id: 'B', foo: 1 },
     *   ],
     *   // Optional, initial edges.
     *   edges: [
     *     { id: 'C', source: 'B', target: 'B', weight: 1 },
     *   ],
     *   // Optional, called with a GraphChangedEvent.
     *   onChanged: (event) => {
     *     console.log(event);
     *   }
     * });
     * ```
     */ constructor(options){
        super();
        if (!options) return;
        if (options.nodes) this.addNodes(options.nodes);
        if (options.edges) this.addEdges(options.edges);
        if (options.tree) this.addTree(options.tree);
        if (options.onChanged) this.onChanged = options.onChanged;
    }
    /**
     * Batch several graph changes into one.
     *
     * Make several changes, but dispatch only one ChangedEvent at the end of batch:
     * ```ts
     * graph.batch(() => {
     *   graph.addNodes([]);
     *   graph.addEdges([]);
     * });
     * ```
     *
     * Batches can be nested. Only the outermost batch will dispatch a ChangedEvent:
     * ```ts
     * graph.batch(() => {
     *   graph.addNodes([]);
     *   graph.batch(() => {
     *     graph.addEdges([]);
     *   });
     * });
     * ```
     */ batch = (fn)=>{
        this.batchCount += 1;
        fn();
        this.batchCount -= 1;
        if (!this.batchCount) this.commit();
    };
    /**
     * Reset changes and dispatch a ChangedEvent.
     */ commit() {
        const changes = this.changes;
        this.changes = [];
        const event = {
            graph: this,
            changes: changes
        };
        this.emit('changed', event);
        this.onChanged(event);
    }
    /**
     * Reduce the number of ordered graph changes by dropping or merging unnecessary changes.
     *
     * For example, if we update a node and remove it in a batch:
     *
     * ```ts
     * graph.batch(() => {
     *   graph.updateNodeData('A', 'foo', 2);
     *   graph.removeNode('A');
     * });
     * ```
     *
     * We get 2 atomic graph changes like
     *
     * ```ts
     * [
     *   { type: 'NodeDataUpdated', id: 'A', propertyName: 'foo', oldValue: 1, newValue: 2 },
     *   { type: 'NodeRemoved', value: { id: 'A', data: { foo: 2 } },
     * ]
     * ```
     *
     * Since node 'A' has been removed, we actually have no need to handle with NodeDataUpdated change.
     *
     * `reduceChanges()` here helps us remove such changes.
     */ reduceChanges(changes) {
        let mergedChanges = [];
        changes.forEach((change)=>{
            switch(change.type){
                case 'NodeRemoved':
                    {
                        // NodeAdded: A added.
                        // NodeDataUpdated: A changed.
                        // TreeStructureChanged: A's parent changed.
                        // NodeRemoved: A removed. 👈🏻 Since A was removed, above three changes may be ignored.
                        let isNewlyAdded = false;
                        mergedChanges = mergedChanges.filter((pastChange)=>{
                            if (pastChange.type === 'NodeAdded') {
                                const sameId = pastChange.value.id === change.value.id;
                                if (sameId) isNewlyAdded = true;
                                return !sameId;
                            } else if (pastChange.type === 'NodeDataUpdated') return pastChange.id !== change.value.id;
                            else if (pastChange.type === 'TreeStructureChanged') return pastChange.nodeId !== change.value.id;
                            return true;
                        });
                        if (!isNewlyAdded) mergedChanges.push(change);
                        break;
                    }
                case 'EdgeRemoved':
                    {
                        // EdgeAdded: A added.
                        // EdgeDataUpdated: A changed.
                        // EdgeDataUpdated: A's source/target changed.
                        // EdgeRemoved: A removed. 👈🏻 Since A was removed, above three changes may be ignored.
                        let isNewlyAdded = false;
                        mergedChanges = mergedChanges.filter((pastChange)=>{
                            if (pastChange.type === 'EdgeAdded') {
                                const sameId = pastChange.value.id === change.value.id;
                                if (sameId) isNewlyAdded = true;
                                return !sameId;
                            } else if (pastChange.type === 'EdgeDataUpdated' || pastChange.type === 'EdgeUpdated') return pastChange.id !== change.value.id;
                            return true;
                        });
                        if (!isNewlyAdded) mergedChanges.push(change);
                        break;
                    }
                case 'NodeDataUpdated':
                case 'EdgeDataUpdated':
                case 'EdgeUpdated':
                    {
                        // NodeDataUpdated: { id: A, propertyName: 'foo', oldValue: 1, newValue: 2 }.
                        // NodeDataUpdated: { id: A, propertyName: 'foo', oldValue: 2, newValue: 3 }.
                        // 👆 Could be merged as { id: A, propertyName: 'foo', oldValue: 1, newValue: 3 }.
                        const index = mergedChanges.findIndex((pastChange)=>{
                            return pastChange.type === change.type && pastChange.id === change.id && (change.propertyName === undefined || pastChange.propertyName === change.propertyName);
                        });
                        const existingChange = mergedChanges[index];
                        if (existingChange) {
                            if (change.propertyName !== undefined) // The incoming change is of the same property of existing change.
                            existingChange.newValue = change.newValue;
                            else {
                                // The incoming change is a whole data override.
                                mergedChanges.splice(index, 1);
                                mergedChanges.push(change);
                            }
                        } else mergedChanges.push(change);
                        break;
                    }
                case 'TreeStructureDetached':
                    // TreeStructureAttached
                    // TreeStructureChanged
                    // TreeStructureDetached 👈🏻 Since the tree struct was detached, above 2 changes may be ignored.
                    mergedChanges = mergedChanges.filter((pastChange)=>{
                        if (pastChange.type === 'TreeStructureAttached') return pastChange.treeKey !== change.treeKey;
                        else if (pastChange.type === 'TreeStructureChanged') return pastChange.treeKey !== change.treeKey;
                        return true;
                    });
                    mergedChanges.push(change);
                    break;
                case 'TreeStructureChanged':
                    {
                        const existingChange = mergedChanges.find((pastChange)=>{
                            return pastChange.type === 'TreeStructureChanged' && pastChange.treeKey === change.treeKey && pastChange.nodeId === change.nodeId;
                        });
                        if (existingChange) existingChange.newParentId = change.newParentId;
                        else mergedChanges.push(change);
                        break;
                    }
                default:
                    mergedChanges.push(change);
                    break;
            }
        });
        return mergedChanges;
    }
    // ================= Node =================
    checkNodeExistence(id) {
        this.getNode(id);
    }
    /**
     * Check if a node exists in the graph.
     * @group NodeMethods
     */ hasNode(id) {
        return this.nodeMap.has(id);
    }
    /**
     * Tell if two nodes are neighbors.
     * @group NodeMethods
     */ areNeighbors(firstNodeId, secondNodeId) {
        return this.getNeighbors(secondNodeId).some((neighbor)=>neighbor.id === firstNodeId);
    }
    /**
     * Get the node data with given ID.
     * @group NodeMethods
     */ getNode(id) {
        const node = this.nodeMap.get(id);
        if (!node) throw new Error('Node not found for id: ' + id);
        return node;
    }
    /**
     * Given a node ID, find all edges of the node.
     * @param id - ID of the node
     * @param direction - Edge direction, defaults to 'both'.
     * @group NodeMethods
     */ getRelatedEdges(id, direction) {
        this.checkNodeExistence(id);
        if (direction === 'in') {
            const inEdges = this.inEdgesMap.get(id);
            return Array.from(inEdges);
        } else if (direction === 'out') {
            const outEdges = this.outEdgesMap.get(id);
            return Array.from(outEdges);
        } else {
            const bothEdges = this.bothEdgesMap.get(id);
            return Array.from(bothEdges);
        }
    }
    /**
     * Get the degree of the given node.
     * @group NodeMethods
     */ getDegree(id, direction) {
        return this.getRelatedEdges(id, direction).length;
    }
    /**
     * Get all successors of the given node.
     */ getSuccessors(id) {
        const outEdges = this.getRelatedEdges(id, 'out');
        const targets = outEdges.map((edge)=>this.getNode(edge.target));
        return Array.from(new Set(targets));
    }
    /**
     * Get all predecessors of the given node.
     */ getPredecessors(id) {
        const inEdges = this.getRelatedEdges(id, 'in');
        const sources = inEdges.map((edge)=>this.getNode(edge.source));
        return Array.from(new Set(sources));
    }
    /**
     * Given a node ID, find its neighbors.
     * @param id - ID of the node
     * @group NodeMethods
     */ getNeighbors(id) {
        const predecessors = this.getPredecessors(id);
        const successors = this.getSuccessors(id);
        return Array.from(new Set([
            ...predecessors,
            ...successors
        ]));
    }
    doAddNode(node) {
        if (this.hasNode(node.id)) throw new Error('Node already exists: ' + node.id);
        this.nodeMap.set(node.id, node);
        this.inEdgesMap.set(node.id, new Set());
        this.outEdgesMap.set(node.id, new Set());
        this.bothEdgesMap.set(node.id, new Set());
        this.treeIndices.forEach((tree)=>{
            tree.childrenMap.set(node.id, new Set());
        });
        this.changes.push({
            type: 'NodeAdded',
            value: node
        });
    }
    /**
     * Add all nodes of the given array, or iterable, into the graph.
     * @group NodeMethods
     */ addNodes(nodes) {
        this.batch(()=>{
            for (const node of nodes)this.doAddNode(node);
        });
    }
    /**
     * Add a single node into the graph.
     * @group NodeMethods
     */ addNode(node) {
        this.addNodes([
            node
        ]);
    }
    doRemoveNode(id) {
        const node = this.getNode(id);
        const bothEdges = this.bothEdgesMap.get(id);
        bothEdges?.forEach((edge)=>this.doRemoveEdge(edge.id));
        this.nodeMap.delete(id);
        this.treeIndices.forEach((tree)=>{
            tree.childrenMap.get(id)?.forEach((child)=>{
                tree.parentMap.delete(child.id);
            });
            const parent = tree.parentMap.get(id);
            if (parent) tree.childrenMap.get(parent.id)?.delete(node);
            tree.parentMap.delete(id);
            tree.childrenMap.delete(id);
        });
        this.bothEdgesMap.delete(id);
        this.inEdgesMap.delete(id);
        this.outEdgesMap.delete(id);
        this.changes.push({
            type: 'NodeRemoved',
            value: node
        });
    }
    /**
     * Remove nodes and their attached edges from the graph.
     * @group NodeMethods
     */ removeNodes(idList) {
        this.batch(()=>{
            idList.forEach((id)=>this.doRemoveNode(id));
        });
    }
    /**
     * Remove a single node and its attached edges from the graph.
     * @group NodeMethods
     */ removeNode(id) {
        this.removeNodes([
            id
        ]);
    }
    updateNodeDataProperty(id, propertyName, value) {
        const node = this.getNode(id);
        this.batch(()=>{
            const oldValue = node.data[propertyName];
            const newValue = value;
            node.data[propertyName] = newValue;
            this.changes.push({
                type: 'NodeDataUpdated',
                id: id,
                propertyName: propertyName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
    }
    /**
     * Like Object.assign, merge all properties of `path` to the node data.
     * @param id Node ID.
     * @param patch A data object to merge.
     */ mergeNodeData(id, patch) {
        this.batch(()=>{
            Object.entries(patch).forEach(([propertyName, value])=>{
                this.updateNodeDataProperty(id, propertyName, value);
            });
        });
    }
    updateNodeData(...args) {
        const id = args[0];
        const node = this.getNode(id);
        if (typeof args[1] === 'string') {
            // id, propertyName, value
            this.updateNodeDataProperty(id, args[1], args[2]);
            return;
        }
        let data;
        if (typeof args[1] === 'function') {
            // id, update
            const update = args[1];
            data = update(node.data);
        } else if (typeof args[1] === 'object') // id, data
        data = args[1];
        this.batch(()=>{
            const oldValue = node.data;
            const newValue = data;
            node.data = data;
            this.changes.push({
                type: 'NodeDataUpdated',
                id: id,
                oldValue: oldValue,
                newValue: newValue
            });
        });
    }
    // ================= Edge =================
    checkEdgeExistence(id) {
        if (!this.hasEdge(id)) throw new Error('Edge not found for id: ' + id);
    }
    /**
     * Check if an edge exists in the graph.
     * @group NodeMethods
     */ hasEdge(id) {
        return this.edgeMap.has(id);
    }
    /**
     * Get the edge data with given ID.
     * @group EdgeMethods
     */ getEdge(id) {
        this.checkEdgeExistence(id);
        return this.edgeMap.get(id);
    }
    /**
     * Get the edge, the source node, and the target node by an edge ID.
     * @group EdgeMethods
     */ getEdgeDetail(id) {
        const edge = this.getEdge(id);
        return {
            edge: edge,
            source: this.getNode(edge.source),
            target: this.getNode(edge.target)
        };
    }
    doAddEdge(edge) {
        if (this.hasEdge(edge.id)) throw new Error('Edge already exists: ' + edge.id);
        this.checkNodeExistence(edge.source);
        this.checkNodeExistence(edge.target);
        this.edgeMap.set(edge.id, edge);
        const inEdges = this.inEdgesMap.get(edge.target);
        const outEdges = this.outEdgesMap.get(edge.source);
        const bothEdgesOfSource = this.bothEdgesMap.get(edge.source);
        const bothEdgesOfTarget = this.bothEdgesMap.get(edge.target);
        inEdges.add(edge);
        outEdges.add(edge);
        bothEdgesOfSource.add(edge);
        bothEdgesOfTarget.add(edge);
        this.changes.push({
            type: 'EdgeAdded',
            value: edge
        });
    }
    /**
     * Add all edges of the given iterable(an array, a set, etc.) into the graph.
     * @group EdgeMethods
     */ addEdges(edges) {
        this.batch(()=>{
            for (const edge of edges)this.doAddEdge(edge);
        });
    }
    /**
     * Add a single edge pointing from `source` to `target` into the graph.
     *
     * ```ts
     * graph.addNode({ id: 'NodeA' });
     * graph.addNode({ id: 'NodeB' });
     * graph.addEdge({ id: 'EdgeA', source: 'NodeA', target: 'NodeB' });
     * ```
     *
     * If `source` or `target` were not found in the current graph, it throws an Error.
     * @group EdgeMethods
     */ addEdge(edge) {
        this.addEdges([
            edge
        ]);
    }
    doRemoveEdge(id) {
        const edge = this.getEdge(id);
        const outEdges = this.outEdgesMap.get(edge.source);
        const inEdges = this.inEdgesMap.get(edge.target);
        const bothEdgesOfSource = this.bothEdgesMap.get(edge.source);
        const bothEdgesOfTarget = this.bothEdgesMap.get(edge.target);
        outEdges.delete(edge);
        inEdges.delete(edge);
        bothEdgesOfSource.delete(edge);
        bothEdgesOfTarget.delete(edge);
        this.edgeMap.delete(id);
        this.changes.push({
            type: 'EdgeRemoved',
            value: edge
        });
    }
    /**
     * Remove edges whose id was included in the given id list.
     * @group EdgeMethods
     */ removeEdges(idList) {
        this.batch(()=>{
            idList.forEach((id)=>this.doRemoveEdge(id));
        });
    }
    /**
     * Remove a single edge of the given id.
     * @group EdgeMethods
     */ removeEdge(id) {
        this.removeEdges([
            id
        ]);
    }
    /**
     * Change the source of an edge. The source must be found in current graph.
     * @group EdgeMethods
     */ updateEdgeSource(id, source) {
        const edge = this.getEdge(id);
        this.checkNodeExistence(source);
        const oldSource = edge.source;
        const newSource = source;
        this.outEdgesMap.get(oldSource).delete(edge);
        this.bothEdgesMap.get(oldSource).delete(edge);
        this.outEdgesMap.get(newSource).add(edge);
        this.bothEdgesMap.get(newSource).add(edge);
        edge.source = source;
        this.batch(()=>{
            this.changes.push({
                type: 'EdgeUpdated',
                id: id,
                propertyName: 'source',
                oldValue: oldSource,
                newValue: newSource
            });
        });
    }
    /**
     * Change the target of an edge. The target must be found in current graph.
     * @group EdgeMethods
     */ updateEdgeTarget(id, target) {
        const edge = this.getEdge(id);
        this.checkNodeExistence(target);
        const oldTarget = edge.target;
        const newTarget = target;
        this.inEdgesMap.get(oldTarget).delete(edge);
        this.bothEdgesMap.get(oldTarget).delete(edge);
        this.inEdgesMap.get(newTarget).add(edge);
        this.bothEdgesMap.get(newTarget).add(edge);
        edge.target = target;
        this.batch(()=>{
            this.changes.push({
                type: 'EdgeUpdated',
                id: id,
                propertyName: 'target',
                oldValue: oldTarget,
                newValue: newTarget
            });
        });
    }
    updateEdgeDataProperty(id, propertyName, value) {
        const edge = this.getEdge(id);
        this.batch(()=>{
            const oldValue = edge.data[propertyName];
            const newValue = value;
            edge.data[propertyName] = newValue;
            this.changes.push({
                type: 'EdgeDataUpdated',
                id: id,
                propertyName: propertyName,
                oldValue: oldValue,
                newValue: newValue
            });
        });
    }
    updateEdgeData(...args) {
        const id = args[0];
        const edge = this.getEdge(id);
        if (typeof args[1] === 'string') {
            // id, propertyName, value
            this.updateEdgeDataProperty(id, args[1], args[2]);
            return;
        }
        let data;
        if (typeof args[1] === 'function') {
            // id, update
            const update = args[1];
            data = update(edge.data);
        } else if (typeof args[1] === 'object') // id, data
        data = args[1];
        this.batch(()=>{
            const oldValue = edge.data;
            const newValue = data;
            edge.data = data;
            this.changes.push({
                type: 'EdgeDataUpdated',
                id: id,
                oldValue: oldValue,
                newValue: newValue
            });
        });
    }
    /**
     * @group EdgeMethods
     */ mergeEdgeData(id, patch) {
        this.batch(()=>{
            Object.entries(patch).forEach(([propertyName, value])=>{
                this.updateEdgeDataProperty(id, propertyName, value);
            });
        });
    }
    // ================= Tree =================
    checkTreeExistence(treeKey) {
        if (!this.hasTreeStructure(treeKey)) throw new Error('Tree structure not found for treeKey: ' + treeKey);
    }
    hasTreeStructure(treeKey) {
        return this.treeIndices.has(treeKey);
    }
    /**
     * Attach a new tree structure representing the hierarchy of all nodes in the graph.
     * @param treeKey A unique key of the tree structure. You can attach multiple tree structures with different keys.
     *
     * ```ts
     * const graph = new Graph({
     *   nodes: [{ id: 1 }, { id: 2 }, { id: 3 }],
     * });
     * graph.attachTreeStructure('Inheritance');
     * graph.setParent(2, 1, 'Inheritance');
     * graph.setParent(3, 1, 'Inheritance');
     * graph.getRoots('Inheritance'); // [1]
     * graph.getChildren(1, 'Inheritance'); // [2,3]
     * ```
     * @group TreeMethods
     */ attachTreeStructure(treeKey) {
        if (this.treeIndices.has(treeKey)) // Already attached.
        return;
        this.treeIndices.set(treeKey, {
            parentMap: new Map(),
            childrenMap: new Map()
        });
        this.batch(()=>{
            this.changes.push({
                type: 'TreeStructureAttached',
                treeKey: treeKey
            });
        });
    }
    /**
     * Detach the tree structure of the given tree key from the graph.
     *
     * ```ts
     * graph.detachTreeStructure('Inheritance');
     * graph.getRoots('Inheritance'); // Error!
     * ```
     * @group TreeMethods
     */ detachTreeStructure(treeKey) {
        this.checkTreeExistence(treeKey);
        this.treeIndices.delete(treeKey);
        this.batch(()=>{
            this.changes.push({
                type: 'TreeStructureDetached',
                treeKey: treeKey
            });
        });
    }
    /**
     * Traverse the given tree data, add each node into the graph, then attach the tree structure.
     *
     * ```ts
     * graph.addTree({
     *   id: 1,
     *   children: [
     *     { id: 2 },
     *     { id: 3 },
     *   ],
     * }, 'Inheritance');
     * graph.getRoots('Inheritance'); // [1]
     * graph.getChildren(1, 'Inheritance'); // [2, 3]
     * graph.getAllNodes(); // [1, 2, 3]
     * graph.getAllEdges(); // []
     * ```
     * @group TreeMethods
     */ addTree(tree, treeKey) {
        this.batch(()=>{
            this.attachTreeStructure(treeKey);
            // Add Nodes
            const nodes = [];
            const stack = Array.isArray(tree) ? tree : [
                tree
            ];
            while(stack.length){
                const node = stack.shift();
                nodes.push(node);
                if (node.children) stack.push(...node.children);
            }
            this.addNodes(nodes);
            // Set parent for each child node.
            nodes.forEach((parent)=>{
                parent.children?.forEach((child)=>{
                    this.setParent(child.id, parent.id, treeKey);
                });
            });
        });
    }
    /**
     * Get the root nodes of an attached tree structure.
     *
     * Consider a graph with the following tree structure attached:
     * ```
     * Tree structure:
     *    O     3
     *   / \    |
     *  1   2   4
     * ```
     * `graph.getRoots()` takes all nodes without a parent, therefore [0, 3] was returned.
     *
     * Newly added nodes are also unparented. So they are counted as roots.
     * ```ts
     * graph.addNode({ id: 5 });
     * graph.getRoots(); // [0, 3, 5]
     * ```
     *
     * Here is how the tree structure looks like:
     * ```
     * Tree structure:
     *    O     3  5
     *   / \    |
     *  1   2   4
     * ```
     *
     * By setting a parent, a root node no more be a root.
     * ```ts
     * graph.setParent(5, 2);
     * graph.getRoots(); // [0, 3]
     * ```
     *
     * The tree structure now becomes:
     * ```
     * Tree structure:
     *    O     3
     *   / \    |
     *  1   2   4
     *      |
     *      5
     * ```
     *
     * Removing a node forces its children to be unparented, or roots.
     * ```ts
     * graph.removeNode(0);
     * graph.getRoots(); // [1, 2, 3]
     * ```
     *
     * You might draw the the structure as follow:
     * ```
     * Tree structure:
     *  1   2  3
     *      |  |
     *      5  4
     * ```
     * @group TreeMethods
     */ getRoots(treeKey) {
        this.checkTreeExistence(treeKey);
        return this.getAllNodes().filter((node)=>!this.getParent(node.id, treeKey));
    }
    /**
     * Given a node ID and an optional tree key, get the children of the node in the specified tree structure.
     * @group TreeMethods
     */ getChildren(id, treeKey) {
        this.checkNodeExistence(id);
        this.checkTreeExistence(treeKey);
        const tree = this.treeIndices.get(treeKey);
        const children = tree.childrenMap.get(id);
        return Array.from(children || []);
    }
    /**
     * Given a node ID and an optional tree key, get the parent of the node in the specified tree structure.
     * If the given node is one of the tree roots, this returns null.
     * @group TreeMethods
     */ getParent(id, treeKey) {
        this.checkNodeExistence(id);
        this.checkTreeExistence(treeKey);
        const tree = this.treeIndices.get(treeKey);
        return tree.parentMap.get(id) || null;
    }
    /**
     * Returns an array of all the ancestor nodes, staring from the parent to the root.
     */ getAncestors(id, treeKey) {
        const ancestors = [];
        let current = this.getNode(id);
        let parent;
        // eslint-disable-next-line no-cond-assign
        while(parent = this.getParent(current.id, treeKey)){
            ancestors.push(parent);
            current = parent;
        }
        return ancestors;
    }
    /**
     * Set node parent. If this operation causes a circle, it fails with an error.
     * @param id - ID of the child node.
     * @param parent - ID of the parent node. If it is undefined or null, means unset parent for node with id.
     * @param treeKey - Which tree structure the relation is applied to.
     * @group TreeMethods
     */ setParent(id, parent, treeKey) {
        this.checkTreeExistence(treeKey);
        const tree = this.treeIndices.get(treeKey);
        if (!tree) return;
        const node = this.getNode(id);
        const oldParent = tree.parentMap.get(id);
        // Same parent id as old one, skip
        if (oldParent?.id === parent) return;
        // New parent is undefined or null, unset parent for the node
        if (parent === undefined || parent === null) {
            if (oldParent) tree.childrenMap.get(oldParent.id)?.delete(node);
            tree.parentMap.delete(id);
            return;
        }
        const newParent = this.getNode(parent);
        // Set parent
        tree.parentMap.set(id, newParent);
        // Set children
        if (oldParent) tree.childrenMap.get(oldParent.id)?.delete(node);
        let children = tree.childrenMap.get(newParent.id);
        if (!children) {
            children = new Set();
            tree.childrenMap.set(newParent.id, children);
        }
        children.add(node);
        this.batch(()=>{
            this.changes.push({
                type: 'TreeStructureChanged',
                treeKey: treeKey,
                nodeId: id,
                oldParentId: oldParent?.id,
                newParentId: newParent.id
            });
        });
    }
    dfsTree(id, fn, treeKey) {
        const navigator = (nodeId)=>this.getChildren(nodeId, treeKey);
        return (0, $7HjkA.doDFS)(this.getNode(id), new Set(), fn, navigator);
    }
    bfsTree(id, fn, treeKey) {
        const navigator = (nodeId)=>this.getChildren(nodeId, treeKey);
        return (0, $7HjkA.doBFS)([
            this.getNode(id)
        ], new Set(), fn, navigator);
    }
    // ================= Graph =================
    /**
     * Get all nodes in the graph as an array.
     */ getAllNodes() {
        return Array.from(this.nodeMap.values());
    }
    /**
     * Get all edges in the graph as an array.
     */ getAllEdges() {
        return Array.from(this.edgeMap.values());
    }
    bfs(id, fn, direction = 'out') {
        const navigator = {
            in: this.getPredecessors.bind(this),
            out: this.getSuccessors.bind(this),
            both: this.getNeighbors.bind(this)
        }[direction];
        return (0, $7HjkA.doBFS)([
            this.getNode(id)
        ], new Set(), fn, navigator);
    }
    dfs(id, fn, direction = 'out') {
        const navigator = {
            in: this.getPredecessors.bind(this),
            out: this.getSuccessors.bind(this),
            both: this.getNeighbors.bind(this)
        }[direction];
        return (0, $7HjkA.doDFS)(this.getNode(id), new Set(), fn, navigator);
    }
    clone() {
        // Make a shallow copy of nodes and edges.
        const newNodes = this.getAllNodes().map((oldNode)=>{
            return {
                ...oldNode,
                data: {
                    ...oldNode.data
                }
            };
        });
        const newEdges = this.getAllEdges().map((oldEdge)=>{
            return {
                ...oldEdge,
                data: {
                    ...oldEdge.data
                }
            };
        });
        // Create a new graph with shallow copied nodes and edges.
        const newGraph = new $b0fa45e53e1e94ef$export$614db49f3febe941({
            nodes: newNodes,
            edges: newEdges
        });
        // Add tree indices.
        this.treeIndices.forEach(({ parentMap: oldParentMap, childrenMap: oldChildrenMap }, treeKey)=>{
            const parentMap = new Map();
            oldParentMap.forEach((parent, key)=>{
                parentMap.set(key, newGraph.getNode(parent.id));
            });
            const childrenMap = new Map();
            oldChildrenMap.forEach((children, key)=>{
                childrenMap.set(key, new Set(Array.from(children).map((n)=>newGraph.getNode(n.id))));
            });
            newGraph.treeIndices.set(treeKey, {
                parentMap: parentMap,
                childrenMap: childrenMap
            });
        });
        return newGraph;
    }
    toJSON() {
        return JSON.stringify({
            nodes: this.getAllNodes(),
            edges: this.getAllEdges()
        });
    }
    createView(options) {
        return new (0, $iGAUM.GraphView)({
            graph: this,
            ...options
        });
    }
}

});
parcelRegister("7VXo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c6bec85cc7c756a$export$2e2bcd8739ae039);
var $5c6bec85cc7c756a$var$WILDCARD = '*';
/* event-emitter */ var $5c6bec85cc7c756a$var$EventEmitter = /** @class */ function() {
    function EventEmitter() {
        this._events = {};
    }
    /**
     * 监听一个事件
     * @param evt
     * @param callback
     * @param once
     */ EventEmitter.prototype.on = function(evt, callback, once) {
        if (!this._events[evt]) this._events[evt] = [];
        this._events[evt].push({
            callback: callback,
            once: !!once
        });
        return this;
    };
    /**
     * 监听一个事件一次
     * @param evt
     * @param callback
     */ EventEmitter.prototype.once = function(evt, callback) {
        return this.on(evt, callback, true);
    };
    /**
     * 触发一个事件
     * @param evt
     * @param args
     */ EventEmitter.prototype.emit = function(evt) {
        var _this = this;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var events = this._events[evt] || [];
        var wildcardEvents = this._events[$5c6bec85cc7c756a$var$WILDCARD] || [];
        // 实际的处理 emit 方法
        var doEmit = function(es) {
            var length = es.length;
            for(var i = 0; i < length; i++){
                if (!es[i]) continue;
                var _a = es[i], callback = _a.callback, once = _a.once;
                if (once) {
                    es.splice(i, 1);
                    if (es.length === 0) delete _this._events[evt];
                    length--;
                    i--;
                }
                callback.apply(_this, args);
            }
        };
        doEmit(events);
        doEmit(wildcardEvents);
    };
    /**
     * 取消监听一个事件，或者一个channel
     * @param evt
     * @param callback
     */ EventEmitter.prototype.off = function(evt, callback) {
        if (!evt) // evt 为空全部清除
        this._events = {};
        else if (!callback) // evt 存在，callback 为空，清除事件所有方法
        delete this._events[evt];
        else {
            // evt 存在，callback 存在，清除匹配的
            var events = this._events[evt] || [];
            var length_1 = events.length;
            for(var i = 0; i < length_1; i++)if (events[i].callback === callback) {
                events.splice(i, 1);
                length_1--;
                i--;
            }
            if (events.length === 0) delete this._events[evt];
        }
        return this;
    };
    /* 当前所有的事件 */ EventEmitter.prototype.getEvents = function() {
        return this._events;
    };
    return EventEmitter;
}();
var $5c6bec85cc7c756a$export$2e2bcd8739ae039 = $5c6bec85cc7c756a$var$EventEmitter;

});

parcelRegister("iGAUM", function(module, exports) {

$parcel$export(module.exports, "GraphView", () => $d9a8c8bc484ffa14$export$6a7fe3ef90e8d566);

var $7HjkA = parcelRequire("7HjkA");
const $d9a8c8bc484ffa14$var$defaultFilter = ()=>true;
class $d9a8c8bc484ffa14$export$6a7fe3ef90e8d566 {
    graph;
    nodeFilter;
    edgeFilter;
    // caches
    cacheEnabled;
    inEdgesMap = new Map();
    outEdgesMap = new Map();
    bothEdgesMap = new Map();
    allNodesMap = new Map();
    allEdgesMap = new Map();
    constructor(options){
        this.graph = options.graph;
        const nodeFilter = options.nodeFilter || $d9a8c8bc484ffa14$var$defaultFilter;
        const edgeFilter = options.edgeFilter || $d9a8c8bc484ffa14$var$defaultFilter;
        this.nodeFilter = nodeFilter;
        this.edgeFilter = (edge)=>{
            const { source: source, target: target } = this.graph.getEdgeDetail(edge.id);
            if (!nodeFilter(source) || !nodeFilter(target)) return false;
            return edgeFilter(edge, source, target);
        };
        if (options.cache === 'auto') {
            this.cacheEnabled = true;
            this.startAutoCache();
        } else if (options.cache === 'manual') this.cacheEnabled = true;
        else this.cacheEnabled = false;
    }
    /**
     * Clear all cache data. Therefore `getAllNodes()` will return `[]`.
     * If you want to disable caching, use `graphView.cacheEnabled = false` instead.
     */ clearCache = ()=>{
        this.inEdgesMap.clear();
        this.outEdgesMap.clear();
        this.bothEdgesMap.clear();
        this.allNodesMap.clear();
        this.allEdgesMap.clear();
    };
    /**
     * Fully refresh all cache data to the current graph state.
     */ refreshCache = ()=>{
        this.clearCache();
        this.updateCache(this.graph.getAllNodes().map((node)=>node.id));
    };
    /**
     * Instead of a fully refreshment, this method partially update the cache data by specifying
     * involved(added, removed, updated) nodes. It's more efficient when handling small changes
     * on a large graph.
     */ updateCache = (involvedNodeIds)=>{
        const involvedEdgeIds = new Set();
        involvedNodeIds.forEach((id)=>{
            // Collect all involved old edges.
            const oldEdgesSet = this.bothEdgesMap.get(id);
            if (oldEdgesSet) oldEdgesSet.forEach((edge)=>involvedEdgeIds.add(edge.id));
            if (!this.hasNode(id)) {
                // When an involved node becomes unvisitable:
                // 1. Delete its related edges cache.
                this.inEdgesMap.delete(id);
                this.outEdgesMap.delete(id);
                this.bothEdgesMap.delete(id);
                // 2. Delete it from the allNodesMap.
                this.allNodesMap.delete(id);
            } else {
                // When an involved node becomes or stays visitable:
                // 1. Collect its new edges.
                const inEdges = this.graph.getRelatedEdges(id, 'in').filter(this.edgeFilter);
                const outEdges = this.graph.getRelatedEdges(id, 'out').filter(this.edgeFilter);
                const bothEdges = Array.from(new Set([
                    ...inEdges,
                    ...outEdges
                ]));
                bothEdges.forEach((edge)=>involvedEdgeIds.add(edge.id));
                // 2. Update its related edges cache.
                this.inEdgesMap.set(id, inEdges);
                this.outEdgesMap.set(id, outEdges);
                this.bothEdgesMap.set(id, bothEdges);
                // 3. Add to allNodesMap.
                this.allNodesMap.set(id, this.graph.getNode(id));
            }
        });
        // Update allEdgesMap.
        involvedEdgeIds.forEach((id)=>{
            if (this.hasEdge(id)) this.allEdgesMap.set(id, this.graph.getEdge(id));
            else this.allEdgesMap.delete(id);
        });
    };
    startAutoCache() {
        this.refreshCache();
        this.graph.on('changed', this.handleGraphChanged);
    }
    stopAutoCache() {
        this.graph.off('changed', this.handleGraphChanged);
    }
    handleGraphChanged = (event)=>{
        // Collect all involved nodes.
        const involvedNodeIds = new Set();
        event.changes.forEach((change)=>{
            switch(change.type){
                case 'NodeAdded':
                    involvedNodeIds.add(change.value.id);
                    break;
                case 'NodeDataUpdated':
                    involvedNodeIds.add(change.id);
                    break;
                case 'EdgeAdded':
                    involvedNodeIds.add(change.value.source);
                    involvedNodeIds.add(change.value.target);
                    break;
                case 'EdgeUpdated':
                    if (change.propertyName === 'source' || change.propertyName === 'target') {
                        involvedNodeIds.add(change.oldValue);
                        involvedNodeIds.add(change.newValue);
                    }
                    break;
                case 'EdgeDataUpdated':
                    if (event.graph.hasEdge(change.id)) {
                        const edge = event.graph.getEdge(change.id);
                        involvedNodeIds.add(edge.source);
                        involvedNodeIds.add(edge.target);
                    }
                    break;
                case 'EdgeRemoved':
                    involvedNodeIds.add(change.value.source);
                    involvedNodeIds.add(change.value.target);
                    break;
                case 'NodeRemoved':
                    involvedNodeIds.add(change.value.id);
                    break;
                default:
                    break;
            }
        });
        // Update their caches.
        this.updateCache(involvedNodeIds);
    };
    // ================= Node =================
    checkNodeExistence(id) {
        this.getNode(id);
    }
    hasNode(id) {
        if (!this.graph.hasNode(id)) return false;
        const node = this.graph.getNode(id);
        return this.nodeFilter(node);
    }
    areNeighbors(firstNodeId, secondNodeId) {
        this.checkNodeExistence(firstNodeId);
        return this.getNeighbors(secondNodeId).some((neighbor)=>neighbor.id === firstNodeId);
    }
    getNode(id) {
        const node = this.graph.getNode(id);
        if (!this.nodeFilter(node)) throw new Error('Node not found for id: ' + id);
        return node;
    }
    getRelatedEdges(id, direction) {
        this.checkNodeExistence(id);
        if (this.cacheEnabled) {
            if (direction === 'in') return this.inEdgesMap.get(id);
            else if (direction === 'out') return this.outEdgesMap.get(id);
            else return this.bothEdgesMap.get(id);
        }
        const edges = this.graph.getRelatedEdges(id, direction);
        return edges.filter(this.edgeFilter);
    }
    getDegree(id, direction) {
        return this.getRelatedEdges(id, direction).length;
    }
    getSuccessors(id) {
        const outEdges = this.getRelatedEdges(id, 'out');
        const targets = outEdges.map((edge)=>this.getNode(edge.target));
        return Array.from(new Set(targets));
    }
    getPredecessors(id) {
        const inEdges = this.getRelatedEdges(id, 'in');
        const sources = inEdges.map((edge)=>this.getNode(edge.source));
        return Array.from(new Set(sources));
    }
    getNeighbors(id) {
        const predecessors = this.getPredecessors(id);
        const successors = this.getSuccessors(id);
        return Array.from(new Set([
            ...predecessors,
            ...successors
        ]));
    }
    // ================= Edge =================
    hasEdge(id) {
        if (!this.graph.hasEdge(id)) return false;
        const edge = this.graph.getEdge(id);
        return this.edgeFilter(edge);
    }
    getEdge(id) {
        const edge = this.graph.getEdge(id);
        if (!this.edgeFilter(edge)) throw new Error('Edge not found for id: ' + id);
        return edge;
    }
    getEdgeDetail(id) {
        const edge = this.getEdge(id);
        return {
            edge: edge,
            source: this.getNode(edge.source),
            target: this.getNode(edge.target)
        };
    }
    // ================= Tree =================
    hasTreeStructure(treeKey) {
        return this.graph.hasTreeStructure(treeKey);
    }
    getRoots(treeKey) {
        return this.graph.getRoots(treeKey).filter(this.nodeFilter);
    }
    getChildren(id, treeKey) {
        this.checkNodeExistence(id);
        return this.graph.getChildren(id, treeKey).filter(this.nodeFilter);
    }
    getParent(id, treeKey) {
        this.checkNodeExistence(id);
        const parent = this.graph.getParent(id, treeKey);
        if (!parent || !this.nodeFilter(parent)) return null;
        return parent;
    }
    // ================= Graph =================
    getAllNodes() {
        if (this.cacheEnabled) return Array.from(this.allNodesMap.values());
        return this.graph.getAllNodes().filter(this.nodeFilter);
    }
    getAllEdges() {
        if (this.cacheEnabled) return Array.from(this.allEdgesMap.values());
        return this.graph.getAllEdges().filter(this.edgeFilter);
    }
    bfs(id, fn, direction = 'out') {
        const navigator = {
            in: this.getPredecessors.bind(this),
            out: this.getSuccessors.bind(this),
            both: this.getNeighbors.bind(this)
        }[direction];
        (0, $7HjkA.doBFS)([
            this.getNode(id)
        ], new Set(), fn, navigator);
    }
    dfs(id, fn, direction = 'out') {
        const navigator = {
            in: this.getPredecessors.bind(this),
            out: this.getSuccessors.bind(this),
            both: this.getNeighbors.bind(this)
        }[direction];
        (0, $7HjkA.doDFS)(this.getNode(id), new Set(), fn, navigator);
    }
}

});
parcelRegister("7HjkA", function(module, exports) {

$parcel$export(module.exports, "doBFS", () => $59ab8b50db6ed8db$export$35f2fded3a66c010);
$parcel$export(module.exports, "doDFS", () => $59ab8b50db6ed8db$export$c02af4b0c096197c);
function $59ab8b50db6ed8db$export$35f2fded3a66c010(queue, visited, fn, navigator) {
    while(queue.length){
        const node = queue.shift();
        const abort = fn(node);
        if (abort) return true;
        visited.add(node.id);
        navigator(node.id).forEach((n)=>{
            if (!visited.has(n.id)) {
                visited.add(n.id);
                queue.push(n);
            }
        });
    }
    return false;
}
function $59ab8b50db6ed8db$export$c02af4b0c096197c(node, visited, fn, navigator) {
    const abort = fn(node);
    if (abort) return true;
    visited.add(node.id);
    for (const n of navigator(node.id))if (!visited.has(n.id)) {
        if ($59ab8b50db6ed8db$export$c02af4b0c096197c(n, visited, fn, navigator)) return true;
    }
    return false;
}

});



parcelRegister("ht4Ur", function(module, exports) {

$parcel$export(module.exports, "BaseLayout", () => $cb78f3fbf0b554be$export$64943d2e59d72a29);
/**
 * <zh/> 布局的基类
 *
 * <en/> Base class for layout
 */ class $cb78f3fbf0b554be$export$64943d2e59d72a29 {
    constructor(context, options){
        this.context = context;
        this.options = options || {};
    }
}

});



parcelRegister("apMdk", function(module, exports) {

$parcel$export(module.exports, "FixElementSize", () => $7951a378af88fe9b$export$86622a1b22ddb479);

var $hllqz = parcelRequire("hllqz");
var $ky7aH = parcelRequire("ky7aH");
var $jyI49 = parcelRequire("jyI49");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $brtTw = parcelRequire("brtTw");

var $bVjEM = parcelRequire("bVjEM");

var $hQIOr = parcelRequire("hQIOr");
var $7951a378af88fe9b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $7951a378af88fe9b$export$86622a1b22ddb479 extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $7951a378af88fe9b$export$86622a1b22ddb479.defaultOptions, options));
        this.isZoomEvent = (event)=>Boolean(event.data && 'scale' in event.data);
        this.relatedEdgeToUpdate = new Set();
        this.zoom = this.context.graph.getZoom();
        this.fixElementSize = (event)=>$7951a378af88fe9b$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.validate(event)) return;
                const { graph: graph } = this.context;
                const { state: state, nodeFilter: nodeFilter, edgeFilter: edgeFilter, comboFilter: comboFilter } = this.options;
                const nodeData = (state ? graph.getElementDataByState('node', state) : graph.getNodeData()).filter(nodeFilter);
                const edgeData = (state ? graph.getElementDataByState('edge', state) : graph.getEdgeData()).filter(edgeFilter);
                const comboData = (state ? graph.getElementDataByState('combo', state) : graph.getComboData()).filter(comboFilter);
                // 设置阈值防止过大或过小时抖动 | Set the threshold to prevent jitter when too large or too small
                const currentScale = this.isZoomEvent(event) ? this.zoom = Math.max(0.01, Math.min(event.data.scale, 10)) : this.zoom;
                const nodeLikeData = [
                    ...nodeData,
                    ...comboData
                ];
                if (nodeLikeData.length > 0) nodeLikeData.forEach((datum)=>this.fixNodeLike(datum, currentScale));
                this.updateRelatedEdges();
                if (edgeData.length > 0) edgeData.forEach((datum)=>this.fixEdge(datum, currentScale));
            });
        this.cachedStyles = new Map();
        this.getOriginalFieldValue = (id, shape, field)=>{
            var _a;
            const shapesStyle = this.cachedStyles.get(id) || [];
            const shapeStyle = ((_a = shapesStyle.find((style)=>style.shape === shape)) === null || _a === void 0 ? void 0 : _a.style) || {};
            if (!(field in shapeStyle)) {
                shapeStyle[field] = shape.attributes[field];
                this.cachedStyles.set(id, [
                    ...shapesStyle.filter((style)=>style.shape !== shape),
                    {
                        shape: shape,
                        style: shapeStyle
                    }
                ]);
            }
            return shapeStyle[field];
        };
        this.scaleEntireElement = (id, el, currentScale)=>{
            el.setLocalScale(1 / currentScale);
            const shapesStyle = this.cachedStyles.get(id) || [];
            shapesStyle.push({
                shape: el
            });
            this.cachedStyles.set(id, shapesStyle);
        };
        this.scaleSpecificShapes = (el, currentScale, config)=>{
            const descendantShapes = (0, $bVjEM.getDescendantShapes)(el);
            const configs = Array.isArray(config) ? config : [
                config
            ];
            configs.forEach((config)=>{
                const { shape: shapeFilter, fields: fields } = config;
                const shape = typeof shapeFilter === 'function' ? shapeFilter(descendantShapes) : el.getShape(shapeFilter);
                if (!shape) return;
                if (!fields) {
                    this.scaleEntireElement(el.id, shape, currentScale);
                    return;
                }
                fields.forEach((field)=>{
                    const oriFieldValue = this.getOriginalFieldValue(el.id, shape, field);
                    if (!(0, $jyI49.default)(oriFieldValue)) return;
                    shape.style[field] = oriFieldValue / currentScale;
                });
            });
        };
        this.skipIfExceedViewport = (el)=>{
            const { viewport: viewport } = this.context;
            return !(viewport === null || viewport === void 0 ? void 0 : viewport.isInViewport(el.getRenderBounds(), false, 30));
        };
        this.fixNodeLike = (datum, currentScale)=>{
            const id = (0, $brtTw.idOf)(datum);
            const { element: element, model: model } = this.context;
            const el = element.getElement(id);
            if (!el || this.skipIfExceedViewport(el)) return;
            const edges = model.getRelatedEdgesData(id);
            edges.forEach((edge)=>this.relatedEdgeToUpdate.add((0, $brtTw.idOf)(edge)));
            const config = this.options[el.type];
            if (!config) {
                this.scaleEntireElement(id, el, currentScale);
                return;
            }
            this.scaleSpecificShapes(el, currentScale, config);
        };
        this.fixEdge = (datum, currentScale)=>{
            const id = (0, $brtTw.idOf)(datum);
            const el = this.context.element.getElement(id);
            if (!el || this.skipIfExceedViewport(el)) return;
            const config = this.options.edge;
            if (!config) {
                el.style.transformOrigin = 'center';
                this.scaleEntireElement(id, el, currentScale);
                return;
            }
            this.scaleSpecificShapes(el, currentScale, config);
        };
        this.updateRelatedEdges = ()=>{
            const { element: element } = this.context;
            if (this.relatedEdgeToUpdate.size > 0) this.relatedEdgeToUpdate.forEach((id)=>{
                const edge = element.getElement(id);
                edge === null || edge === void 0 || edge.update({});
            });
            this.relatedEdgeToUpdate.clear();
        };
        this.resetTransform = (event)=>$7951a378af88fe9b$var$__awaiter(this, void 0, void 0, function*() {
                var _a;
                // 首屏渲染时跳过 | Skip when rendering the first screen
                if ((_a = event.data) === null || _a === void 0 ? void 0 : _a.firstRender) return;
                if (this.options.reset) this.restoreCachedStyles();
                else this.fixElementSize({
                    data: {
                        scale: this.zoom
                    }
                });
            });
        this.bindEvents();
    }
    restoreCachedStyles() {
        if (this.cachedStyles.size > 0) {
            this.cachedStyles.forEach((shapesStyle)=>{
                shapesStyle.forEach(({ shape: shape, style: style })=>{
                    if ((0, $hllqz.default)(style)) shape.setLocalScale(1);
                    else {
                        if (this.options.state) return;
                        Object.entries(style).forEach(([field, value])=>shape.style[field] = value);
                    }
                });
            });
            const { graph: graph, element: element } = this.context;
            const nodeIds = Object.keys(Object.fromEntries(this.cachedStyles)).filter((id)=>id && graph.getElementType(id) === 'node');
            if (nodeIds.length > 0) {
                const edgeIds = new Set();
                nodeIds.forEach((id)=>{
                    graph.getRelatedEdgesData(id).forEach((edge)=>edgeIds.add((0, $brtTw.idOf)(edge)));
                });
                edgeIds.forEach((id)=>{
                    const edge = element === null || element === void 0 ? void 0 : element.getElement(id);
                    edge === null || edge === void 0 || edge.update({});
                });
            }
        }
    // this.cachedStyles.clear();
    }
    bindEvents() {
        const { graph: graph } = this.context;
        graph.on((0, $4EzN9.GraphEvent).AFTER_DRAW, this.resetTransform);
        graph.on((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.fixElementSize);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        graph.off((0, $4EzN9.GraphEvent).AFTER_DRAW, this.resetTransform);
        graph.off((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.fixElementSize);
    }
    validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
$7951a378af88fe9b$export$86622a1b22ddb479.defaultOptions = {
    enable: (event)=>event.data.scale < 1,
    nodeFilter: ()=>true,
    edgeFilter: ()=>true,
    comboFilter: ()=>true,
    edge: [
        {
            shape: 'key',
            fields: [
                'lineWidth'
            ]
        },
        {
            shape: 'halo',
            fields: [
                'lineWidth'
            ]
        },
        {
            shape: 'label'
        }
    ],
    reset: false
};

});

parcelRegister("hDdip", function(module, exports) {

$parcel$export(module.exports, "FocusElement", () => $cd60647d3d90b5f3$export$7a3a9a146a507fa7);

var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");

var $hXCXB = parcelRequire("hXCXB");

var $lXl1S = parcelRequire("lXl1S");

var $hQIOr = parcelRequire("hQIOr");
var $cd60647d3d90b5f3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $cd60647d3d90b5f3$export$7a3a9a146a507fa7 extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $cd60647d3d90b5f3$export$7a3a9a146a507fa7.defaultOptions, options));
        this.focus = (event)=>$cd60647d3d90b5f3$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.validate(event)) return;
                const { graph: graph } = this.context;
                yield graph.focusElement(event.target.id, this.options.animation);
            });
        this.shortcut = new (0, $lXl1S.Shortcut)(context.graph);
        this.bindEvents();
    }
    bindEvents() {
        const { graph: graph } = this.context;
        this.unbindEvents();
        (0, $hXCXB.ELEMENT_TYPES).forEach((type)=>{
            graph.on(`${type}:${(0, $9Iel2.CommonEvent).CLICK}`, this.focus);
        });
    }
    validate(event) {
        if (this.destroyed || !this.isKeydown()) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    /**
     * <zh/> 当前按键是否和 trigger 配置一致
     *
     * <en/> Is the current key consistent with the trigger configuration
     * @returns <zh/> 是否一致 | <en/> Is consistent
     * @internal
     */ isKeydown() {
        const { trigger: trigger } = this.options;
        if (!(trigger === null || trigger === void 0 ? void 0 : trigger.length)) return true;
        return this.shortcut.match(trigger);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        (0, $hXCXB.ELEMENT_TYPES).forEach((type)=>{
            graph.off(`${type}:${(0, $9Iel2.CommonEvent).CLICK}`, this.focus);
        });
    }
    destroy() {
        this.unbindEvents();
        this.shortcut.destroy();
        super.destroy();
    }
}
$cd60647d3d90b5f3$export$7a3a9a146a507fa7.defaultOptions = {
    animation: {
        easing: 'ease-in',
        duration: 500
    },
    enable: true,
    trigger: []
};

});

parcelRegister("5DaKb", function(module, exports) {

$parcel$export(module.exports, "HoverActivate", () => $4198edc6c44bab52$export$cca3922b095f8458);

var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");

var $hXCXB = parcelRequire("hXCXB");

var $hn4z6 = parcelRequire("hn4z6");

var $brtTw = parcelRequire("brtTw");

var $aAA2B = parcelRequire("aAA2B");

var $hQIOr = parcelRequire("hQIOr");
class $4198edc6c44bab52$export$cca3922b095f8458 extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $4198edc6c44bab52$export$cca3922b095f8458.defaultOptions, options));
        this.isFrozen = false;
        this.toggleFrozen = (e)=>{
            this.isFrozen = e.type === 'dragstart';
        };
        this.hoverElement = (event)=>{
            if (!this.validate(event)) return;
            const isEnter = event.type === (0, $9Iel2.CommonEvent).POINTER_ENTER;
            this.updateElementsState(event, isEnter);
            const { onHover: onHover, onHoverEnd: onHoverEnd } = this.options;
            if (isEnter) onHover === null || onHover === void 0 || onHover(event);
            else onHoverEnd === null || onHoverEnd === void 0 || onHoverEnd(event);
        };
        this.updateElementsState = (event, add)=>{
            if (!this.options.state && !this.options.inactiveState) return;
            const { graph: graph } = this.context;
            const { state: state, animation: animation, inactiveState: inactiveState } = this.options;
            const activeIds = this.getActiveIds(event);
            const states = {};
            if (state) Object.assign(states, this.getElementsState(activeIds, state, add));
            if (inactiveState) {
                const inactiveIds = (0, $brtTw.idsOf)(graph.getData(), true).filter((id)=>!activeIds.includes(id));
                Object.assign(states, this.getElementsState(inactiveIds, inactiveState, add));
            }
            graph.setElementState(states, animation);
        };
        this.getElementsState = (ids, state, add)=>{
            const { graph: graph } = this.context;
            const states = {};
            ids.forEach((id)=>{
                const currentState = graph.getElementState(id);
                if (add) states[id] = currentState.includes(state) ? currentState : [
                    ...currentState,
                    state
                ];
                else states[id] = currentState.filter((s)=>s !== state);
            });
            return states;
        };
        this.bindEvents();
    }
    bindEvents() {
        const { graph: graph } = this.context;
        this.unbindEvents();
        (0, $hXCXB.ELEMENT_TYPES).forEach((type)=>{
            graph.on(`${type}:${(0, $9Iel2.CommonEvent).POINTER_ENTER}`, this.hoverElement);
            graph.on(`${type}:${(0, $9Iel2.CommonEvent).POINTER_LEAVE}`, this.hoverElement);
        });
        const canvas = this.context.canvas.document;
        canvas.addEventListener(`${(0, $9Iel2.CommonEvent).DRAG_START}`, this.toggleFrozen);
        canvas.addEventListener(`${(0, $9Iel2.CommonEvent).DRAG_END}`, this.toggleFrozen);
    }
    getActiveIds(event) {
        const { graph: graph } = this.context;
        const { degree: degree, direction: direction } = this.options;
        const elementId = event.target.id;
        return degree ? (0, $aAA2B.getElementNthDegreeIds)(graph, event.targetType, elementId, typeof degree === 'function' ? degree(event) : degree, direction) : [
            elementId
        ];
    }
    validate(event) {
        if (this.destroyed || this.isFrozen || (0, $hn4z6.isToBeDestroyed)(event.target) || // @ts-expect-error private property
        // 避免动画冲突，在combo/node折叠展开过程中不触发
        this.context.graph.isCollapsingExpanding) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        (0, $hXCXB.ELEMENT_TYPES).forEach((type)=>{
            graph.off(`${type}:${(0, $9Iel2.CommonEvent).POINTER_ENTER}`, this.hoverElement);
            graph.off(`${type}:${(0, $9Iel2.CommonEvent).POINTER_LEAVE}`, this.hoverElement);
        });
        const canvas = this.context.canvas.document;
        canvas.removeEventListener(`${(0, $9Iel2.CommonEvent).DRAG_START}`, this.toggleFrozen);
        canvas.removeEventListener(`${(0, $9Iel2.CommonEvent).DRAG_END}`, this.toggleFrozen);
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
$4198edc6c44bab52$export$cca3922b095f8458.defaultOptions = {
    animation: false,
    enable: true,
    degree: 0,
    direction: 'both',
    state: 'active',
    inactiveState: undefined
};

});

parcelRegister("8yr5d", function(module, exports) {

$parcel$export(module.exports, "LassoSelect", () => $63a681d8708f9ba2$export$639beca75c32a67d);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $oZkEc = parcelRequire("oZkEc");

var $8FmDy = parcelRequire("8FmDy");
class $63a681d8708f9ba2$export$639beca75c32a67d extends (0, $8FmDy.BrushSelect) {
    /**
     * Triggered when the mouse is pressed
     * @param event - mouse event
     * @internal
     */ onPointerDown(event) {
        if (!super.validate(event) || !super.isKeydown() || this.points) return;
        const { canvas: canvas, graph: graph } = this.context;
        this.pathShape = new (0, $2eDEB.Path)({
            id: 'g6-lasso-select',
            style: this.options.style
        });
        canvas.appendChild(this.pathShape);
        this.points = [
            (0, $8FmDy.getCursorPoint)(event, graph)
        ];
    }
    /**
     * Triggered when the mouse is moved
     * @param event - mouse event
     * @internal
     */ onPointerMove(event) {
        var _a;
        if (!this.points) return;
        const { immediately: immediately, mode: mode } = this.options;
        this.points.push((0, $8FmDy.getCursorPoint)(event, this.context.graph));
        (_a = this.pathShape) === null || _a === void 0 || _a.setAttribute('d', (0, $oZkEc.pointsToPath)(this.points));
        if (immediately && mode === 'default' && this.points.length > 2) super.updateElementsStates(this.points);
    }
    /**
     * Triggered when the mouse is released
     * @internal
     */ onPointerUp() {
        if (!this.points) return;
        if (this.points.length < 2) {
            this.clearLasso();
            return;
        }
        super.updateElementsStates(this.points);
        this.clearLasso();
    }
    clearLasso() {
        var _a;
        (_a = this.pathShape) === null || _a === void 0 || _a.remove();
        this.pathShape = undefined;
        this.points = undefined;
    }
}

});

parcelRegister("bC6xM", function(module, exports) {

$parcel$export(module.exports, "OptimizeViewportTransform", () => $874851c7dddc243d$export$549811f1fbc37692);

var $2ZmO4 = parcelRequire("2ZmO4");
var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $kzdag = parcelRequire("kzdag");

var $hQIOr = parcelRequire("hQIOr");
class $874851c7dddc243d$export$549811f1fbc37692 extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $874851c7dddc243d$export$549811f1fbc37692.defaultOptions, options));
        this.hiddenShapes = [];
        this.isVisible = true;
        this.setElementsVisibility = (elements, visibility, filter)=>{
            elements.filter(Boolean).forEach((element)=>{
                if (visibility === 'hidden' && !element.isVisible()) this.hiddenShapes.push(element);
                else if (visibility === 'visible' && this.hiddenShapes.includes(element)) this.hiddenShapes.splice(this.hiddenShapes.indexOf(element), 1);
                else (0, $kzdag.setVisibility)(element, visibility, filter);
            });
        };
        this.filterShapes = (type, filter)=>{
            if ((0, $ky7aH.default)(filter)) return (shape)=>!filter(type, shape);
            const includesClassnames = filter === null || filter === void 0 ? void 0 : filter[type];
            return (shape)=>{
                if (!shape.className) return true;
                return !(includesClassnames === null || includesClassnames === void 0 ? void 0 : includesClassnames.includes(shape.className));
            };
        };
        this.hideShapes = (event)=>{
            if (!this.validate(event) || !this.isVisible) return;
            const { element: element } = this.context;
            const { shapes: shapes = {} } = this.options;
            this.setElementsVisibility(element.getNodes(), 'hidden', this.filterShapes('node', shapes));
            this.setElementsVisibility(element.getEdges(), 'hidden', this.filterShapes('edge', shapes));
            this.setElementsVisibility(element.getCombos(), 'hidden', this.filterShapes('combo', shapes));
            this.isVisible = false;
        };
        this.showShapes = (0, $2ZmO4.default)((event)=>{
            if (!this.validate(event) || this.isVisible) return;
            const { element: element } = this.context;
            this.setElementsVisibility(element.getNodes(), 'visible');
            this.setElementsVisibility(element.getEdges(), 'visible');
            this.setElementsVisibility(element.getCombos(), 'visible');
            this.isVisible = true;
        }, this.options.debounce);
        this.bindEvents();
    }
    bindEvents() {
        const { graph: graph } = this.context;
        graph.on((0, $4EzN9.GraphEvent).BEFORE_TRANSFORM, this.hideShapes);
        graph.on((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.showShapes);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        graph.off((0, $4EzN9.GraphEvent).BEFORE_TRANSFORM, this.hideShapes);
        graph.off((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.showShapes);
    }
    validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    update(options) {
        this.unbindEvents();
        super.update(options);
        this.bindEvents();
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
$874851c7dddc243d$export$549811f1fbc37692.defaultOptions = {
    enable: true,
    debounce: 200,
    shapes: (type)=>type === 'node'
};

});

parcelRegister("62Rza", function(module, exports) {

$parcel$export(module.exports, "ScrollCanvas", () => $466c7b1912f53a6a$export$e5b43a5d45bc95c6);

var $ky7aH = parcelRequire("ky7aH");
var $6JKSc = parcelRequire("6JKSc");
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");

var $6BVcW = parcelRequire("6BVcW");

var $1uR12 = parcelRequire("1uR12");

var $lXl1S = parcelRequire("lXl1S");

var $dOidW = parcelRequire("dOidW");

var $hQIOr = parcelRequire("hQIOr");
var $466c7b1912f53a6a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $466c7b1912f53a6a$export$e5b43a5d45bc95c6 extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $466c7b1912f53a6a$export$e5b43a5d45bc95c6.defaultOptions, options));
        this.onWheel = (event)=>$466c7b1912f53a6a$var$__awaiter(this, void 0, void 0, function*() {
                if (this.options.preventDefault) event.preventDefault();
                const diffX = event.deltaX;
                const diffY = event.deltaY;
                yield this.scroll([
                    -diffX,
                    -diffY
                ], event);
            });
        this.shortcut = new (0, $lXl1S.Shortcut)(context.graph);
        this.bindEvents();
    }
    /**
     * <zh/> 更新配置
     *
     * <en/> Update options
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */ update(options) {
        super.update(options);
        this.bindEvents();
    }
    bindEvents() {
        var _a, _b;
        const { trigger: trigger } = this.options;
        this.shortcut.unbindAll();
        if ((0, $6JKSc.default)(trigger)) {
            (_a = this.graphDom) === null || _a === void 0 || _a.removeEventListener((0, $9Iel2.CommonEvent).WHEEL, this.onWheel);
            const { up: up = [], down: down = [], left: left = [], right: right = [] } = trigger;
            this.shortcut.bind(up, (event)=>this.scroll([
                    0,
                    -10
                ], event));
            this.shortcut.bind(down, (event)=>this.scroll([
                    0,
                    10
                ], event));
            this.shortcut.bind(left, (event)=>this.scroll([
                    -10,
                    0
                ], event));
            this.shortcut.bind(right, (event)=>this.scroll([
                    10,
                    0
                ], event));
        } else /**
             * 这里必需在原生canvas上绑定wheel事件，参考：
             * https://g.antv.antgroup.com/api/event/faq#%E5%9C%A8-chrome-%E4%B8%AD%E7%A6%81%E6%AD%A2%E9%A1%B5%E9%9D%A2%E9%BB%98%E8%AE%A4%E6%BB%9A%E5%8A%A8%E8%A1%8C%E4%B8%BA
             */ (_b = this.graphDom) === null || _b === void 0 || _b.addEventListener((0, $9Iel2.CommonEvent).WHEEL, this.onWheel, {
            passive: false
        });
    }
    get graphDom() {
        return this.context.graph.getCanvas().getContextService().getDomElement();
    }
    formatDisplacement(d) {
        const { sensitivity: sensitivity } = this.options;
        d = (0, $dOidW.multiply)(d, sensitivity);
        d = this.clampByDirection(d);
        d = this.clampByRange(d);
        return d;
    }
    clampByDirection([dx, dy]) {
        const { direction: direction } = this.options;
        if (direction === 'x') dy = 0;
        else if (direction === 'y') dx = 0;
        return [
            dx,
            dy
        ];
    }
    clampByRange([dx, dy]) {
        const { viewport: viewport, canvas: canvas } = this.context;
        const [canvasWidth, canvasHeight] = canvas.getSize();
        const [top, right, bottom, left] = (0, $1uR12.parsePadding)(this.options.range);
        const range = [
            canvasHeight * top,
            canvasWidth * right,
            canvasHeight * bottom,
            canvasWidth * left
        ];
        const scrollableArea = (0, $6BVcW.getExpandedBBox)((0, $6BVcW.getPointBBox)(viewport.getCanvasCenter()), range);
        const nextViewportCenter = (0, $dOidW.subtract)(viewport.getViewportCenter(), [
            dx,
            dy,
            0
        ]);
        if (!(0, $6BVcW.isPointInBBox)(nextViewportCenter, scrollableArea)) {
            const { min: [minX, minY], max: [maxX, maxY] } = scrollableArea;
            if (nextViewportCenter[0] < minX && dx > 0 || nextViewportCenter[0] > maxX && dx < 0) dx = 0;
            if (nextViewportCenter[1] < minY && dy > 0 || nextViewportCenter[1] > maxY && dy < 0) dy = 0;
        }
        return [
            dx,
            dy
        ];
    }
    scroll(value, event) {
        return $466c7b1912f53a6a$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.validate(event)) return;
            const { onFinish: onFinish } = this.options;
            const graph = this.context.graph;
            const formattedValue = this.formatDisplacement(value);
            yield graph.translateBy(formattedValue, false);
            onFinish === null || onFinish === void 0 || onFinish();
        });
    }
    validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    /**
     * <zh/> 销毁画布滚动
     *
     * <en/> Destroy the canvas scrolling
     */ destroy() {
        var _a;
        this.shortcut.destroy();
        (_a = this.graphDom) === null || _a === void 0 || _a.removeEventListener((0, $9Iel2.CommonEvent).WHEEL, this.onWheel);
        super.destroy();
    }
}
$466c7b1912f53a6a$export$e5b43a5d45bc95c6.defaultOptions = {
    enable: true,
    sensitivity: 1,
    preventDefault: true,
    range: Infinity
};

});

parcelRegister("02HiP", function(module, exports) {

$parcel$export(module.exports, "ZoomCanvas", () => $0081c7068f5d20f8$export$9a0c831e2a32cced);

var $8hhuV = parcelRequire("8hhuV");
var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");

var $dnXls = parcelRequire("dnXls");

var $lXl1S = parcelRequire("lXl1S");

var $hQIOr = parcelRequire("hQIOr");
var $0081c7068f5d20f8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $0081c7068f5d20f8$export$9a0c831e2a32cced extends (0, $hQIOr.BaseBehavior) {
    constructor(context, options){
        super(context, Object.assign({}, $0081c7068f5d20f8$export$9a0c831e2a32cced.defaultOptions, options));
        /**
         * <zh/> 缩放画布
         *
         * <en/> Zoom canvas
         * @param value - <zh/> 缩放值， > 0 放大， < 0 缩小 | <en/> Zoom value, > 0 zoom in, < 0 zoom out
         * @param event - <zh/> 事件对象 | <en/> Event object
         * @param animation - <zh/> 缩放动画配置 | <en/> Zoom animation configuration
         */ this.zoom = (value, event, animation)=>$0081c7068f5d20f8$var$__awaiter(this, void 0, void 0, function*() {
                if (!this.validate(event)) return;
                const { graph: graph } = this.context;
                let origin = this.options.origin;
                if (!origin && 'viewport' in event) origin = (0, $dnXls.parsePoint)(event.viewport);
                const { sensitivity: sensitivity, onFinish: onFinish } = this.options;
                const ratio = 1 + (0, $8hhuV.default)(value, -50, 50) * sensitivity / 100;
                const zoom = graph.getZoom();
                yield graph.zoomTo(zoom * ratio, animation, origin);
                onFinish === null || onFinish === void 0 || onFinish();
            });
        this.onReset = ()=>$0081c7068f5d20f8$var$__awaiter(this, void 0, void 0, function*() {
                yield this.context.graph.zoomTo(1, this.options.animation);
            });
        this.preventDefault = (event)=>{
            if (this.options.preventDefault) event.preventDefault();
        };
        this.shortcut = new (0, $lXl1S.Shortcut)(context.graph);
        this.bindEvents();
    }
    /**
     * <zh/> 更新配置
     *
     * <en/> Update options
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */ update(options) {
        super.update(options);
        this.bindEvents();
    }
    bindEvents() {
        const { trigger: trigger } = this.options;
        this.shortcut.unbindAll();
        if (Array.isArray(trigger)) {
            if (trigger.includes((0, $9Iel2.CommonEvent).PINCH)) this.shortcut.bind([
                (0, $9Iel2.CommonEvent).PINCH
            ], (event)=>{
                this.zoom(event.scale, event, false);
            });
            else {
                const container = this.context.canvas.getContainer();
                container === null || container === void 0 || container.addEventListener((0, $9Iel2.CommonEvent).WHEEL, this.preventDefault);
                this.shortcut.bind([
                    ...trigger,
                    (0, $9Iel2.CommonEvent).WHEEL
                ], (event)=>{
                    const { deltaX: deltaX, deltaY: deltaY } = event;
                    this.zoom(-(deltaY !== null && deltaY !== void 0 ? deltaY : deltaX), event, false);
                });
            }
        }
        if (typeof trigger === 'object') {
            const { zoomIn: zoomIn = [], zoomOut: zoomOut = [], reset: reset = [] } = trigger;
            this.shortcut.bind(zoomIn, (event)=>this.zoom(10, event, this.options.animation));
            this.shortcut.bind(zoomOut, (event)=>this.zoom(-10, event, this.options.animation));
            this.shortcut.bind(reset, this.onReset);
        }
    }
    /**
     * <zh/> 验证是否可以缩放
     *
     * <en/> Verify whether it can be zoomed
     * @param event - <zh/> 事件对象 | <en/> Event object
     * @returns <zh/> 是否可以缩放 | <en/> Whether it can be zoomed
     * @internal
     */ validate(event) {
        if (this.destroyed) return false;
        const { enable: enable } = this.options;
        if ((0, $ky7aH.default)(enable)) return enable(event);
        return !!enable;
    }
    /**
     * <zh/> 销毁缩放画布
     *
     * <en/> Destroy zoom canvas
     */ destroy() {
        var _a;
        this.shortcut.destroy();
        (_a = this.context.canvas.getContainer()) === null || _a === void 0 || _a.removeEventListener((0, $9Iel2.CommonEvent).WHEEL, this.preventDefault);
        super.destroy();
    }
}
$0081c7068f5d20f8$export$9a0c831e2a32cced.defaultOptions = {
    animation: {
        duration: 200
    },
    enable: true,
    sensitivity: 1,
    trigger: [],
    preventDefault: true
};

});


parcelRegister("2oT5h", function(module, exports) {

$parcel$export(module.exports, "compactBox", () => (parcelRequire("hFThh")).compactBox);
$parcel$export(module.exports, "dendrogram", () => (parcelRequire("hFThh")).dendrogram);
$parcel$export(module.exports, "indented", () => (parcelRequire("hFThh")).indented);
$parcel$export(module.exports, "mindmap", () => (parcelRequire("hFThh")).mindmap);
$parcel$export(module.exports, "AntVDagreLayout", () => (parcelRequire("3MWMO")).AntVDagreLayout);
$parcel$export(module.exports, "CircularLayout", () => (parcelRequire("1IlsW")).CircularLayout);
$parcel$export(module.exports, "ComboCombinedLayout", () => (parcelRequire("5n8Ib")).ComboCombinedLayout);
$parcel$export(module.exports, "ConcentricLayout", () => (parcelRequire("kd0OI")).ConcentricLayout);
$parcel$export(module.exports, "D3ForceLayout", () => (parcelRequire("hhpea")).D3ForceLayout);
$parcel$export(module.exports, "DagreLayout", () => (parcelRequire("iMTgF")).DagreLayout);
$parcel$export(module.exports, "ForceAtlas2Layout", () => (parcelRequire("eyWFr")).ForceAtlas2Layout);
$parcel$export(module.exports, "ForceLayout", () => (parcelRequire("irTWF")).ForceLayout);
$parcel$export(module.exports, "FruchtermanLayout", () => (parcelRequire("eifoa")).FruchtermanLayout);
$parcel$export(module.exports, "GridLayout", () => (parcelRequire("e7HzC")).GridLayout);
$parcel$export(module.exports, "MDSLayout", () => (parcelRequire("k9H1V")).MDSLayout);
$parcel$export(module.exports, "RadialLayout", () => (parcelRequire("1aclp")).RadialLayout);
$parcel$export(module.exports, "RandomLayout", () => (parcelRequire("4JXd9")).RandomLayout);
$parcel$export(module.exports, "BaseLayout", () => (parcelRequire("ht4Ur")).BaseLayout);
$parcel$export(module.exports, "FishboneLayout", () => (parcelRequire("7C1fc")).FishboneLayout);
$parcel$export(module.exports, "SnakeLayout", () => (parcelRequire("2D9MF")).SnakeLayout);

var $hFThh = parcelRequire("hFThh");

var $3MWMO = parcelRequire("3MWMO");
var $1IlsW = parcelRequire("1IlsW");
var $5n8Ib = parcelRequire("5n8Ib");
var $kd0OI = parcelRequire("kd0OI");
var $hhpea = parcelRequire("hhpea");
var $iMTgF = parcelRequire("iMTgF");
var $eyWFr = parcelRequire("eyWFr");
var $irTWF = parcelRequire("irTWF");
var $eifoa = parcelRequire("eifoa");
var $e7HzC = parcelRequire("e7HzC");
var $k9H1V = parcelRequire("k9H1V");
var $1aclp = parcelRequire("1aclp");
var $4JXd9 = parcelRequire("4JXd9");

var $ht4Ur = parcelRequire("ht4Ur");

var $7C1fc = parcelRequire("7C1fc");

var $2D9MF = parcelRequire("2D9MF");

});
parcelRegister("hFThh", function(module, exports) {

$parcel$export(module.exports, "compactBox", () => $cde12507e35bb579$export$5b210cf3c2a0bd76);
$parcel$export(module.exports, "dendrogram", () => $cde12507e35bb579$export$98953bb81c486df2);
$parcel$export(module.exports, "indented", () => $cde12507e35bb579$export$24152c33b3d314cb);
$parcel$export(module.exports, "mindmap", () => $cde12507e35bb579$export$b7627032b15a6271);
function $cde12507e35bb579$var$t(t1, e, i, n = "height") {
    const h = t1[n], r = e[n];
    return "center" === i ? (h + r) / 2 : t1.height;
}
const $cde12507e35bb579$var$e = Object.assign, $cde12507e35bb579$var$i = {
    getId: (t)=>t.id || t.name,
    getPreH: (t)=>t.preH || 0,
    getPreV: (t)=>t.preV || 0,
    getHGap: (t)=>t.hgap || 18,
    getVGap: (t)=>t.vgap || 18,
    getChildren: (t)=>t.children,
    getHeight: (t)=>t.height || 36,
    getWidth (t) {
        const e = t.label || " ";
        return t.width || 18 * e.split("").length;
    }
};
class $cde12507e35bb579$var$n {
    constructor(t, e){
        if (this.x = 0, this.y = 0, this.depth = 0, this.children = [], this.hgap = 0, this.vgap = 0, t instanceof $cde12507e35bb579$var$n || "x" in t && "y" in t && "children" in t) {
            const e = t;
            return this.data = e.data, this.id = e.id, this.x = e.x, this.y = e.y, this.width = e.width, this.height = e.height, this.depth = e.depth, this.children = e.children, this.parent = e.parent, this.hgap = e.hgap, this.vgap = e.vgap, this.preH = e.preH, void (this.preV = e.preV);
        }
        this.data = t;
        const i = e.getHGap(t), h = e.getVGap(t);
        this.preH = e.getPreH(t), this.preV = e.getPreV(t), this.width = e.getWidth(t), this.height = e.getHeight(t), this.width += this.preH, this.height += this.preV, this.id = e.getId(t), this.addGap(i, h);
    }
    isRoot() {
        return 0 === this.depth;
    }
    isLeaf() {
        return 0 === this.children.length;
    }
    addGap(t, e) {
        this.hgap += t, this.vgap += e, this.width += 2 * t, this.height += 2 * e;
    }
    eachNode(t) {
        let e, i = [
            this
        ];
        for(; e = i.shift();)t(e), i = e.children.concat(i);
    }
    DFTraverse(t) {
        this.eachNode(t);
    }
    BFTraverse(t) {
        let e, i = [
            this
        ];
        for(; e = i.shift();)t(e), i = i.concat(e.children);
    }
    getBoundingBox() {
        const t = {
            left: Number.MAX_VALUE,
            top: Number.MAX_VALUE,
            width: 0,
            height: 0
        };
        return this.eachNode((e)=>{
            t.left = Math.min(t.left, e.x), t.top = Math.min(t.top, e.y), t.width = Math.max(t.width, e.x + e.width), t.height = Math.max(t.height, e.y + e.height);
        }), t;
    }
    translate(t = 0, e = 0) {
        this.eachNode((i)=>{
            i.x += t, i.y += e, i.x += i.preH, i.y += i.preV;
        });
    }
    right2left() {
        const t = this.getBoundingBox();
        this.eachNode((e)=>{
            e.x = e.x - 2 * (e.x - t.left) - e.width;
        }), this.translate(t.width, 0);
    }
    bottom2top() {
        const t = this.getBoundingBox();
        this.eachNode((e)=>{
            e.y = e.y - 2 * (e.y - t.top) - e.height;
        }), this.translate(0, t.height);
    }
}
function $cde12507e35bb579$var$h(t, h1 = {}, r) {
    h1 = $cde12507e35bb579$var$e({}, $cde12507e35bb579$var$i, h1);
    const o = new $cde12507e35bb579$var$n(t, h1), s = [
        o
    ];
    let c;
    if (!r && !t.collapsed) {
        for(; c = s.shift();)if (!c.data.collapsed) {
            const t = h1.getChildren(c.data), e = t ? t.length : 0;
            if (c.children = new Array(e), t && e) for(let i = 0; i < e; i++){
                const e = new $cde12507e35bb579$var$n(t[i], h1);
                c.children[i] = e, s.push(e), e.parent = c, e.depth = c.depth + 1;
            }
        }
    }
    return o;
}
class $cde12507e35bb579$var$r {
    constructor(t, e = {}){
        this.options = e, this.rootNode = $cde12507e35bb579$var$h(t, e);
    }
    execute() {
        throw new Error("please override this method");
    }
}
let $cde12507e35bb579$var$o = class t {
    constructor(t = 0, e = 0, i = 0, n = []){
        this.x = 0, this.prelim = 0, this.mod = 0, this.shift = 0, this.change = 0, this.tl = null, this.tr = null, this.el = null, this.er = null, this.msel = 0, this.mser = 0, this.w = t || 0, this.h = e || 0, this.y = i || 0, this.c = n || [], this.cs = n.length;
    }
    static fromNode(e, i) {
        if (!e) return null;
        const n = [];
        return e.children.forEach((e)=>{
            const h = t.fromNode(e, i);
            h && n.push(h);
        }), i ? new t(e.height, e.width, e.x, n) : new t(e.width, e.height, e.y, n);
    }
};
function $cde12507e35bb579$var$s(t, e, i) {
    i ? t.y += e : t.x += e, t.children.forEach((t)=>{
        $cde12507e35bb579$var$s(t, e, i);
    });
}
function $cde12507e35bb579$var$c(t, e) {
    let i = e ? t.y : t.x;
    return t.children.forEach((t)=>{
        i = Math.min($cde12507e35bb579$var$c(t, e), i);
    }), i;
}
function $cde12507e35bb579$var$l(t, e) {
    $cde12507e35bb579$var$s(t, -$cde12507e35bb579$var$c(t, e), e);
}
function $cde12507e35bb579$var$a(t, e, i) {
    i ? e.y = t.x : e.x = t.x, t.c.forEach((t, n)=>{
        $cde12507e35bb579$var$a(t, e.children[n], i);
    });
}
function $cde12507e35bb579$var$d(t, e, i = 0) {
    e ? (t.x = i, i += t.width) : (t.y = i, i += t.height), t.children.forEach((t)=>{
        $cde12507e35bb579$var$d(t, e, i);
    });
}
function $cde12507e35bb579$var$f(t, e = {}) {
    const i = e.isHorizontal;
    function n(t) {
        0 === t.cs ? (t.el = t, t.er = t, t.msel = t.mser = 0) : (t.el = t.c[0].el, t.msel = t.c[0].msel, t.er = t.c[t.cs - 1].er, t.mser = t.c[t.cs - 1].mser);
    }
    function h(t, e, i) {
        let n = t.c[e - 1], h = n.mod, o = t.c[e], l = o.mod;
        for(; null !== n && null !== o;){
            i && f1(n) > i.low && (i = i.nxt);
            const a = h + n.prelim + n.w - (l + o.prelim);
            a > 0 && (l += a, i && r(t, e, i.index, a));
            const d = f1(n), g = f1(o);
            d <= g && (n = c(n), null !== n && (h += n.mod)), d >= g && (o = s(o), null !== o && (l += o.mod));
        }
        !n && o ? function(t, e, i, n) {
            const h = t.c[0].el;
            h.tl = i;
            const r = n - i.mod - t.c[0].msel;
            h.mod += r, h.prelim -= r, t.c[0].el = t.c[e].el, t.c[0].msel = t.c[e].msel;
        }(t, e, o, l) : n && !o && function(t, e, i, n) {
            const h = t.c[e].er;
            h.tr = i;
            const r = n - i.mod - t.c[e].mser;
            h.mod += r, h.prelim -= r, t.c[e].er = t.c[e - 1].er, t.c[e].mser = t.c[e - 1].mser;
        }(t, e, n, h);
    }
    function r(t, e, i, n) {
        t.c[e].mod += n, t.c[e].msel += n, t.c[e].mser += n, function(t, e, i, n) {
            if (i !== e - 1) {
                const h = e - i;
                t.c[i + 1].shift += n / h, t.c[e].shift -= n / h, t.c[e].change -= n - n / h;
            }
        }(t, e, i, n);
    }
    function s(t) {
        return 0 === t.cs ? t.tl : t.c[0];
    }
    function c(t) {
        return 0 === t.cs ? t.tr : t.c[t.cs - 1];
    }
    function f1(t) {
        return t.y + t.h;
    }
    function g(t, e, i) {
        for(; null !== i && t >= i.low;)i = i.nxt;
        return {
            low: t,
            index: e,
            nxt: i
        };
    }
    $cde12507e35bb579$var$d(t, i);
    const u = $cde12507e35bb579$var$o.fromNode(t, i);
    return u && (!function t(e) {
        if (0 === e.cs) return void n(e);
        t(e.c[0]);
        let i = g(f1(e.c[0].el), 0, null);
        for(let n = 1; n < e.cs; ++n){
            t(e.c[n]);
            const r = f1(e.c[n].er);
            h(e, n, i), i = g(r, n, i);
        }
        !function(t) {
            t.prelim = (t.c[0].prelim + t.c[0].mod + t.c[t.cs - 1].mod + t.c[t.cs - 1].prelim + t.c[t.cs - 1].w) / 2 - t.w / 2;
        }(e), n(e);
    }(u), function t(e, i) {
        i += e.mod, e.x = e.prelim + i, function(t) {
            let e = 0, i = 0;
            for(let n = 0; n < t.cs; n++)e += t.c[n].shift, i += e + t.c[n].change, t.c[n].mod += i;
        }(e);
        for(let n = 0; n < e.cs; n++)t(e.c[n], i);
    }(u, 0), $cde12507e35bb579$var$a(u, t, i), $cde12507e35bb579$var$l(t, i)), t;
}
function $cde12507e35bb579$var$g(t, e) {
    const i = $cde12507e35bb579$var$h(t.data, e, !0), n = $cde12507e35bb579$var$h(t.data, e, !0), r = t.children.length, o = Math.round(r / 2), s = e.getSide || function(t, e) {
        return e < o ? "right" : "left";
    };
    for(let h = 0; h < r; h++){
        const e = t.children[h];
        "right" === s(e, h) ? n.children.push(e) : i.children.push(e);
    }
    return i.eachNode((t)=>{
        t.isRoot() || (t.side = "left");
    }), n.eachNode((t)=>{
        t.isRoot() || (t.side = "right");
    }), {
        left: i,
        right: n
    };
}
const $cde12507e35bb579$var$u = [
    "LR",
    "RL",
    "TB",
    "BT",
    "H",
    "V"
], $cde12507e35bb579$var$p = [
    "LR",
    "RL",
    "H"
], $cde12507e35bb579$var$x = $cde12507e35bb579$var$u[0];
function $cde12507e35bb579$var$y(t, e, i) {
    const n = e.direction || $cde12507e35bb579$var$x;
    if (e.isHorizontal = ((t)=>$cde12507e35bb579$var$p.indexOf(t) > -1)(n), n && -1 === $cde12507e35bb579$var$u.indexOf(n)) throw new TypeError(`Invalid direction: ${n}`);
    if (n === $cde12507e35bb579$var$u[0]) i(t, e);
    else if (n === $cde12507e35bb579$var$u[1]) i(t, e), t.right2left();
    else if (n === $cde12507e35bb579$var$u[2]) i(t, e);
    else if (n === $cde12507e35bb579$var$u[3]) i(t, e), t.bottom2top();
    else if (n === $cde12507e35bb579$var$u[4] || n === $cde12507e35bb579$var$u[5]) {
        const { left: n, right: h } = $cde12507e35bb579$var$g(t, e);
        i(n, e), i(h, e), e.isHorizontal ? n.right2left() : n.bottom2top(), h.translate(n.x - h.x, n.y - h.y), t.x = n.x, t.y = h.y;
        const r = t.getBoundingBox();
        e.isHorizontal ? r.top < 0 && t.translate(0, -r.top) : r.left < 0 && t.translate(-r.left, 0);
    }
    let h = e.fixedRoot;
    return void 0 === h && (h = !0), h && t.translate(-(t.x + t.width / 2 + t.hgap), -(t.y + t.height / 2 + t.vgap)), function(t, e) {
        if (e.radial) {
            const [i, n] = e.isHorizontal ? [
                "x",
                "y"
            ] : [
                "y",
                "x"
            ], h = {
                x: 1 / 0,
                y: 1 / 0
            }, r = {
                x: -1 / 0,
                y: -1 / 0
            };
            let o = 0;
            t.DFTraverse((t)=>{
                o++;
                const { x: e, y: i } = t;
                h.x = Math.min(h.x, e), h.y = Math.min(h.y, i), r.x = Math.max(r.x, e), r.y = Math.max(r.y, i);
            });
            const s = r[n] - h[n];
            if (0 === s) return;
            const c = 2 * Math.PI / o;
            t.DFTraverse((e)=>{
                const r = e[n], o = h[n], l = e[i], a = t[i], d = (r - o) / s * (2 * Math.PI - c) + c, f = l - a;
                e.x = Math.cos(d) * f, e.y = Math.sin(d) * f;
            });
        }
    }(t, e), t;
}
class $cde12507e35bb579$var$m extends $cde12507e35bb579$var$r {
    execute() {
        return $cde12507e35bb579$var$y(this.rootNode, this.options, $cde12507e35bb579$var$f);
    }
}
const $cde12507e35bb579$var$w = {};
function $cde12507e35bb579$export$5b210cf3c2a0bd76(t, i) {
    const n = $cde12507e35bb579$var$e({}, $cde12507e35bb579$var$w, i);
    return new $cde12507e35bb579$var$m(t, n).execute();
}
class $cde12507e35bb579$var$N {
    constructor(t = 0, e = []){
        this.x = 0, this.y = 0, this.leftChild = null, this.rightChild = null, this.isLeaf = !1, this.height = t, this.children = e;
    }
}
const $cde12507e35bb579$var$v = {
    isHorizontal: !0,
    nodeSep: 20,
    nodeSize: 20,
    rankSep: 200,
    subTreeSep: 10
};
function $cde12507e35bb579$var$M(t, e, i) {
    i ? (e.x = t.x, e.y = t.y) : (e.x = t.y, e.y = t.x), t.children.forEach((t, n)=>{
        $cde12507e35bb579$var$M(t, e.children[n], i);
    });
}
function $cde12507e35bb579$var$E(t, i = {}) {
    const n = $cde12507e35bb579$var$e({}, $cde12507e35bb579$var$v, i);
    let h = 0;
    let r = null;
    const o = function t(e) {
        e.width = 0, e.depth && e.depth > h && (h = e.depth);
        const i = e.children, n = i.length, r = new $cde12507e35bb579$var$N(0, []);
        return i.forEach((e, i)=>{
            const h = t(e);
            r.children.push(h), 0 === i && (r.leftChild = h), i === n - 1 && (r.rightChild = h);
        }), r.originNode = e, r.isLeaf = e.isLeaf(), r;
    }(t);
    return function t(e) {
        if (e.isLeaf || 0 === e.children.length) e.drawingDepth = h;
        else {
            const i = e.children.map((e)=>t(e)), n = Math.min(...i);
            e.drawingDepth = n - 1;
        }
        return e.drawingDepth;
    }(o), function t(e) {
        e.x = e.drawingDepth * n.rankSep, e.isLeaf ? (e.y = 0, r && (e.y = r.y + r.height + n.nodeSep, e.originNode.parent !== r.originNode.parent && (e.y += n.subTreeSep)), r = e) : (e.children.forEach((e)=>{
            t(e);
        }), e.y = (e.leftChild.y + e.rightChild.y) / 2);
    }(o), $cde12507e35bb579$var$M(o, t, n.isHorizontal), t;
}
class $cde12507e35bb579$var$B extends $cde12507e35bb579$var$r {
    execute() {
        return this.rootNode.width = 0, $cde12507e35bb579$var$y(this.rootNode, this.options, $cde12507e35bb579$var$E);
    }
}
const $cde12507e35bb579$var$T = {};
function $cde12507e35bb579$export$98953bb81c486df2(t, i) {
    const n = $cde12507e35bb579$var$e({}, $cde12507e35bb579$var$T, i);
    return new $cde12507e35bb579$var$B(t, n).execute();
}
function $cde12507e35bb579$var$b(e, i, n, h) {
    let r = null;
    e.eachNode((e)=>{
        !function(e, i, n, h, r) {
            const o = ("function" == typeof n ? n(e) : n) * e.depth;
            if (!h) try {
                if (e.parent && e.id === e.parent.children[0].id) return e.x += o, void (e.y = i ? i.y : 0);
            } catch  {}
            if (e.x += o, i) {
                if (e.y = i.y + $cde12507e35bb579$var$t(i, e, r), i.parent && e.parent && e.parent.id !== i.parent.id) {
                    const n = i.parent, h = n.y + $cde12507e35bb579$var$t(n, e, r);
                    e.y = h > e.y ? h : e.y;
                }
            } else e.y = 0;
        }(e, r, i, n, h), r = e;
    });
}
const $cde12507e35bb579$var$L = [
    "LR",
    "RL",
    "H"
], $cde12507e35bb579$var$V = $cde12507e35bb579$var$L[0];
class $cde12507e35bb579$var$R extends $cde12507e35bb579$var$r {
    execute() {
        const t = this.options, e = this.rootNode;
        t.isHorizontal = !0;
        const { indent: i = 20, dropCap: n = !0, direction: h = $cde12507e35bb579$var$V, align: r } = t;
        if (h && -1 === $cde12507e35bb579$var$L.indexOf(h)) throw new TypeError(`Invalid direction: ${h}`);
        if (h === $cde12507e35bb579$var$L[0]) $cde12507e35bb579$var$b(e, i, n, r);
        else if (h === $cde12507e35bb579$var$L[1]) $cde12507e35bb579$var$b(e, i, n, r), e.right2left();
        else if (h === $cde12507e35bb579$var$L[2]) {
            const { left: h, right: o } = $cde12507e35bb579$var$g(e, t);
            $cde12507e35bb579$var$b(h, i, n, r), h.right2left(), $cde12507e35bb579$var$b(o, i, n, r);
            const s = h.getBoundingBox();
            o.translate(s.width, 0), e.x = o.x - e.width / 2;
        }
        return e;
    }
}
const $cde12507e35bb579$var$z = {};
function $cde12507e35bb579$export$24152c33b3d314cb(t, i) {
    const n = $cde12507e35bb579$var$e({}, $cde12507e35bb579$var$z, i);
    return new $cde12507e35bb579$var$R(t, n).execute();
}
function $cde12507e35bb579$var$D(t, e) {
    let i = 0;
    return t.children.length ? t.children.forEach((t)=>{
        i += $cde12507e35bb579$var$D(t, e);
    }) : i = t.height, t._subTreeSep = e.getSubTreeSep(t.data), t.totalHeight = Math.max(t.height, i) + 2 * t._subTreeSep, t.totalHeight;
}
function $cde12507e35bb579$var$Y(t) {
    const e = t.children, i = e.length;
    if (i) {
        e.forEach((t)=>{
            $cde12507e35bb579$var$Y(t);
        });
        const n = e[0], h = e[i - 1], r = h.y - n.y + h.height;
        let o = 0;
        if (e.forEach((t)=>{
            o += t.totalHeight;
        }), r > t.height) t.y = n.y + r / 2 - t.height / 2;
        else if (1 !== e.length || t.height > o) {
            const i = t.y + (t.height - r) / 2 - n.y;
            e.forEach((t)=>{
                t.translate(0, i);
            });
        } else t.y = (n.y + n.height / 2 + h.y + h.height / 2) / 2 - t.height / 2;
    }
}
const $cde12507e35bb579$var$G = {
    getSubTreeSep: ()=>0
};
function $cde12507e35bb579$var$I(t, i = {}) {
    return i = $cde12507e35bb579$var$e({}, $cde12507e35bb579$var$G, i), t.parent = {
        x: 0,
        width: 0,
        height: 0,
        y: 0
    }, t.BFTraverse((t)=>{
        t.x = t.parent.x + t.parent.width;
    }), t.parent = void 0, $cde12507e35bb579$var$D(t, i), t.startY = 0, t.y = t.totalHeight / 2 - t.height / 2, t.eachNode((t)=>{
        const e = t.children, i = e.length;
        if (i) {
            const n = e[0];
            if (n.startY = t.startY + t._subTreeSep, 1 === i) n.y = t.y + t.height / 2 - n.height / 2;
            else {
                n.y = n.startY + n.totalHeight / 2 - n.height / 2;
                for(let t = 1; t < i; t++){
                    const i = e[t];
                    i.startY = e[t - 1].startY + e[t - 1].totalHeight, i.y = i.startY + i.totalHeight / 2 - i.height / 2;
                }
            }
        }
    }), $cde12507e35bb579$var$Y(t), t;
}
class $cde12507e35bb579$var$P extends $cde12507e35bb579$var$r {
    execute() {
        return $cde12507e35bb579$var$y(this.rootNode, this.options, $cde12507e35bb579$var$I);
    }
}
const $cde12507e35bb579$var$A = {};
function $cde12507e35bb579$export$b7627032b15a6271(t, i) {
    const n = $cde12507e35bb579$var$e({}, $cde12507e35bb579$var$A, i);
    return new $cde12507e35bb579$var$P(t, n).execute();
}
const $cde12507e35bb579$export$2e2bcd8739ae039 = {
    compactBox: $cde12507e35bb579$export$5b210cf3c2a0bd76,
    dendrogram: $cde12507e35bb579$export$98953bb81c486df2,
    indented: $cde12507e35bb579$export$24152c33b3d314cb,
    mindmap: $cde12507e35bb579$export$b7627032b15a6271
}, $cde12507e35bb579$export$83d89fbfd8236492 = "0.7.0";

});

parcelRegister("3MWMO", function(module, exports) {

$parcel$export(module.exports, "AntVDagreLayout", () => $2c23748afa4b6c5f$export$37faa137668b7035);

var $7WQrb = parcelRequire("7WQrb");

var $fc2XC = parcelRequire("fc2XC");

var $jyI49 = parcelRequire("jyI49");

var $kxEhx = parcelRequire("kxEhx");

var $9nuNf = parcelRequire("9nuNf");
var $9RkJR = parcelRequire("9RkJR");

var $lKWgx = parcelRequire("lKWgx");
const $2c23748afa4b6c5f$var$DEFAULTS_LAYOUT_OPTIONS = {
    rankdir: 'TB',
    nodesep: 50,
    ranksep: 50,
    edgeLabelSpace: true,
    ranker: 'tight-tree',
    controlPoints: false,
    radial: false,
    focusNode: null
};
class $2c23748afa4b6c5f$export$37faa137668b7035 {
    constructor(options = {}){
        this.options = options;
        this.id = 'antv-dagre';
        this.options = Object.assign(Object.assign({}, $2c23748afa4b6c5f$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericDagreLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericDagreLayout(true, graph, options);
        });
    }
    genericDagreLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const mergedOptions = Object.assign(Object.assign({}, this.options), options);
            const { nodeSize: nodeSize, align: align, rankdir: rankdir = 'TB', ranksep: ranksep, nodesep: nodesep, ranksepFunc: ranksepFunc, nodesepFunc: nodesepFunc, edgeLabelSpace: edgeLabelSpace, ranker: ranker, nodeOrder: nodeOrder, begin: begin, controlPoints: controlPoints, radial: radial, sortByCombo: sortByCombo, preset: // focusNode,
            preset } = mergedOptions;
            const g = new (0, $fc2XC.Graph)({
                tree: []
            });
            const ranksepfunc = (0, $9RkJR.formatNumberFn)(ranksep || 50, ranksepFunc);
            const nodesepfunc = (0, $9RkJR.formatNumberFn)(nodesep || 50, nodesepFunc);
            let horisep = nodesepfunc;
            let vertisep = ranksepfunc;
            if (rankdir === 'LR' || rankdir === 'RL') {
                horisep = ranksepfunc;
                vertisep = nodesepfunc;
            }
            const nodeSizeFunc = (0, $9RkJR.formatSizeFn)(10, nodeSize, false);
            // copy graph to g
            const nodes = graph.getAllNodes();
            const edges = graph.getAllEdges();
            nodes.forEach((node)=>{
                const size = (0, $lKWgx.parseSize)(nodeSizeFunc(node));
                const verti = vertisep(node);
                const hori = horisep(node);
                const width = size[0] + 2 * hori;
                const height = size[1] + 2 * verti;
                const layer = node.data.layer;
                if ((0, $jyI49.default)(layer)) // 如果有layer属性，加入到node的label中
                g.addNode({
                    id: node.id,
                    data: {
                        width: width,
                        height: height,
                        layer: layer
                    }
                });
                else g.addNode({
                    id: node.id,
                    data: {
                        width: width,
                        height: height
                    }
                });
            });
            if (sortByCombo) {
                g.attachTreeStructure('combo');
                nodes.forEach((node)=>{
                    const { parentId: parentId } = node.data;
                    if (parentId === undefined) return;
                    if (g.hasNode(parentId)) g.setParent(node.id, parentId, 'combo');
                });
            }
            edges.forEach((edge)=>{
                // dagrejs Wiki https://github.com/dagrejs/dagre/wiki#configuring-the-layout
                g.addEdge({
                    id: edge.id,
                    source: edge.source,
                    target: edge.target,
                    data: {
                        weight: edge.data.weight || 1
                    }
                });
            });
            let prevGraph = undefined;
            if (preset === null || preset === void 0 ? void 0 : preset.length) prevGraph = new (0, $fc2XC.Graph)({
                nodes: preset
            });
            (0, $kxEhx.layout)(g, {
                prevGraph: prevGraph,
                edgeLabelSpace: edgeLabelSpace,
                keepNodeOrder: !!nodeOrder,
                nodeOrder: nodeOrder || [],
                acyclicer: 'greedy',
                ranker: ranker,
                rankdir: rankdir,
                nodesep: nodesep,
                align: align
            });
            const layoutTopLeft = [
                0,
                0
            ];
            if (begin) {
                let minX = Infinity;
                let minY = Infinity;
                g.getAllNodes().forEach((node)=>{
                    if (minX > node.data.x) minX = node.data.x;
                    if (minY > node.data.y) minY = node.data.y;
                });
                g.getAllEdges().forEach((edge)=>{
                    var _a;
                    (_a = edge.data.points) === null || _a === void 0 || _a.forEach((point)=>{
                        if (minX > point.x) minX = point.x;
                        if (minY > point.y) minY = point.y;
                    });
                });
                layoutTopLeft[0] = begin[0] - minX;
                layoutTopLeft[1] = begin[1] - minY;
            }
            const isHorizontal = rankdir === 'LR' || rankdir === 'RL';
            if (radial) ;
            else {
                const layerCoords = new Set();
                const isInvert = rankdir === 'BT' || rankdir === 'RL';
                const layerCoordSort = isInvert ? (a, b)=>b - a : (a, b)=>a - b;
                g.getAllNodes().forEach((node)=>{
                    // let ndata: any = this.nodeMap[node];
                    // if (!ndata) {
                    //   ndata = combos?.find((it) => it.id === node);
                    // }
                    // if (!ndata) return;
                    // ndata.x = node.data.x! + dBegin[0];
                    // ndata.y = node.data.y! + dBegin[1];
                    // //  pass layer order to data for increment layout use
                    // ndata._order = node.data._order;
                    // layerCoords.add(isHorizontal ? ndata.x : ndata.y);
                    node.data.x = node.data.x + layoutTopLeft[0];
                    node.data.y = node.data.y + layoutTopLeft[1];
                    layerCoords.add(isHorizontal ? node.data.x : node.data.y);
                });
                const layerCoordsArr = Array.from(layerCoords).sort(layerCoordSort);
                // pre-define the isHorizontal related functions to avoid redundant calc in interations
                const isDifferentLayer = isHorizontal ? (point1, point2)=>point1.x !== point2.x : (point1, point2)=>point1.y !== point2.y;
                const filterControlPointsOutOfBoundary = isHorizontal ? (ps, point1, point2)=>{
                    const max = Math.max(point1.y, point2.y);
                    const min = Math.min(point1.y, point2.y);
                    return ps.filter((point)=>point.y <= max && point.y >= min);
                } : (ps, point1, point2)=>{
                    const max = Math.max(point1.x, point2.x);
                    const min = Math.min(point1.x, point2.x);
                    return ps.filter((point)=>point.x <= max && point.x >= min);
                };
                g.getAllEdges().forEach((edge, i)=>{
                    var _a;
                    // const i = edges.findIndex((it) => {
                    //   return it.source === edge.source && it.target === edge.target;
                    // });
                    // if (i <= -1) return;
                    if (edgeLabelSpace && controlPoints && edge.data.type !== 'loop') edge.data.controlPoints = $2c23748afa4b6c5f$var$getControlPoints((_a = edge.data.points) === null || _a === void 0 ? void 0 : _a.map(({ x: x, y: y })=>({
                            x: x + layoutTopLeft[0],
                            y: y + layoutTopLeft[1]
                        })), g.getNode(edge.source), g.getNode(edge.target), layerCoordsArr, isHorizontal, isDifferentLayer, filterControlPointsOutOfBoundary);
                });
            }
            // calculated nodes as temporary result
            let layoutNodes = [];
            // layout according to the original order in the data.nodes
            layoutNodes = g.getAllNodes().map((node)=>(0, $9nuNf.cloneFormatData)(node));
            const layoutEdges = g.getAllEdges();
            if (assign) {
                layoutNodes.forEach((node)=>{
                    graph.mergeNodeData(node.id, {
                        x: node.data.x,
                        y: node.data.y
                    });
                });
                layoutEdges.forEach((edge)=>{
                    graph.mergeEdgeData(edge.id, {
                        controlPoints: edge.data.controlPoints
                    });
                });
            }
            const result = {
                nodes: layoutNodes,
                edges: layoutEdges
            };
            return result;
        });
    }
}
/**
 * Format controlPoints to avoid polylines crossing nodes
 * @param points
 * @param sourceNode
 * @param targetNode
 * @param layerCoordsArr
 * @param isHorizontal
 * @returns
 */ const $2c23748afa4b6c5f$var$getControlPoints = (points, sourceNode, targetNode, layerCoordsArr, isHorizontal, isDifferentLayer, filterControlPointsOutOfBoundary)=>{
    let controlPoints = (points === null || points === void 0 ? void 0 : points.slice(1, points.length - 1)) || []; // 去掉头尾
    // 酌情增加控制点，使折线不穿过跨层的节点
    if (sourceNode && targetNode) {
        let { x: sourceX, y: sourceY } = sourceNode.data;
        let { x: targetX, y: targetY } = targetNode.data;
        if (isHorizontal) {
            sourceX = sourceNode.data.y;
            sourceY = sourceNode.data.x;
            targetX = targetNode.data.y;
            targetY = targetNode.data.x;
        }
        // 为跨层级的边增加第一个控制点。忽略垂直的/横向的边。
        // 新控制点 = {
        //   x: 终点x,
        //   y: (起点y + 下一层y) / 2,   #下一层y可能不等于终点y
        // }
        if (targetY !== sourceY && sourceX !== targetX) {
            const sourceLayer = layerCoordsArr.indexOf(sourceY);
            const sourceNextLayerCoord = layerCoordsArr[sourceLayer + 1];
            if (sourceNextLayerCoord) {
                const firstControlPoint = controlPoints[0];
                const insertStartControlPoint = isHorizontal ? {
                    x: (sourceY + sourceNextLayerCoord) / 2,
                    y: (firstControlPoint === null || firstControlPoint === void 0 ? void 0 : firstControlPoint.y) || targetX
                } : {
                    x: (firstControlPoint === null || firstControlPoint === void 0 ? void 0 : firstControlPoint.x) || targetX,
                    y: (sourceY + sourceNextLayerCoord) / 2
                };
                // 当新增的控制点不存在（!=当前第一个控制点）时添加
                if (!firstControlPoint || isDifferentLayer(firstControlPoint, insertStartControlPoint)) controlPoints.unshift(insertStartControlPoint);
            }
            const targetLayer = layerCoordsArr.indexOf(targetY);
            const layerDiff = Math.abs(targetLayer - sourceLayer);
            if (layerDiff === 1) {
                controlPoints = filterControlPointsOutOfBoundary(controlPoints, sourceNode.data, targetNode.data);
                // one controlPoint at least
                if (!controlPoints.length) controlPoints.push(isHorizontal ? {
                    x: (sourceY + targetY) / 2,
                    y: sourceX
                } : {
                    x: sourceX,
                    y: (sourceY + targetY) / 2
                });
            } else if (layerDiff > 1) {
                const targetLastLayerCoord = layerCoordsArr[targetLayer - 1];
                if (targetLastLayerCoord) {
                    const lastControlPoints = controlPoints[controlPoints.length - 1];
                    const insertEndControlPoint = isHorizontal ? {
                        x: (targetY + targetLastLayerCoord) / 2,
                        y: (lastControlPoints === null || lastControlPoints === void 0 ? void 0 : lastControlPoints.y) || targetX
                    } : {
                        x: (lastControlPoints === null || lastControlPoints === void 0 ? void 0 : lastControlPoints.x) || sourceX,
                        y: (targetY + targetLastLayerCoord) / 2
                    };
                    // 当新增的控制点不存在（!=当前最后一个控制点）时添加
                    if (!lastControlPoints || isDifferentLayer(lastControlPoints, insertEndControlPoint)) controlPoints.push(insertEndControlPoint);
                }
            }
        }
    }
    return controlPoints;
};

});
parcelRegister("kxEhx", function(module, exports) {

$parcel$export(module.exports, "layout", () => $ef4622e02fe04490$export$b3219800bda33a1f);

var $fc2XC = parcelRequire("fc2XC");

var $geZBG = parcelRequire("geZBG");

var $fNUaF = parcelRequire("fNUaF");

var $caG8q = parcelRequire("caG8q");

var $hxfhS = parcelRequire("hxfhS");

var $47fN7 = parcelRequire("47fN7");

var $6y9Lh = parcelRequire("6y9Lh");

var $1R4Sz = parcelRequire("1R4Sz");

var $cnHil = parcelRequire("cnHil");

var $FuDjN = parcelRequire("FuDjN");

var $eUqJB = parcelRequire("eUqJB");

var $7WQT7 = parcelRequire("7WQT7");

var $c1yiZ = parcelRequire("c1yiZ");
const $ef4622e02fe04490$export$b3219800bda33a1f = (g, options)=>{
    const { edgeLabelSpace: edgeLabelSpace, keepNodeOrder: keepNodeOrder, prevGraph: prevGraph, rankdir: rankdir, ranksep: ranksep } = options;
    // 如果在原图基础上修改，继承原图的order结果
    if (!keepNodeOrder && prevGraph) $ef4622e02fe04490$var$inheritOrder(g, prevGraph);
    const layoutGraph = $ef4622e02fe04490$var$buildLayoutGraph(g);
    // 控制是否为边的label留位置（这会影响是否在边中间添加dummy node）
    if (!!edgeLabelSpace) options.ranksep = $ef4622e02fe04490$var$makeSpaceForEdgeLabels(layoutGraph, {
        rankdir: rankdir,
        ranksep: ranksep
    });
    let dimension;
    // TODO: 暂时处理层级设置不正确时的异常报错，提示设置正确的层级
    try {
        dimension = $ef4622e02fe04490$var$runLayout(layoutGraph, options);
    } catch (e) {
        if (e.message === 'Not possible to find intersection inside of the rectangle') {
            console.error("The following error may be caused by improper layer setting, please make sure your manual layer setting does not violate the graph's structure:\n", e);
            return;
        }
        throw e;
    }
    $ef4622e02fe04490$var$updateInputGraph(g, layoutGraph);
    return dimension;
};
const $ef4622e02fe04490$var$runLayout = (g, options)=>{
    const { acyclicer: acyclicer, ranker: ranker, rankdir: rankdir = 'tb', nodeOrder: nodeOrder, keepNodeOrder: keepNodeOrder, align: align, nodesep: nodesep = 50, edgesep: edgesep = 20, ranksep: ranksep = 50 } = options;
    $ef4622e02fe04490$var$removeSelfEdges(g);
    (0, $fNUaF.run)(g, acyclicer);
    const { nestingRoot: nestingRoot, nodeRankFactor: nodeRankFactor } = (0, $47fN7.run)(g);
    (0, $7WQT7.rank)((0, $c1yiZ.asNonCompoundGraph)(g), ranker);
    $ef4622e02fe04490$var$injectEdgeLabelProxies(g);
    (0, $c1yiZ.removeEmptyRanks)(g, nodeRankFactor);
    (0, $47fN7.cleanup)(g, nestingRoot);
    (0, $c1yiZ.normalizeRanks)(g);
    $ef4622e02fe04490$var$assignRankMinMax(g);
    $ef4622e02fe04490$var$removeEdgeLabelProxies(g);
    const dummyChains = [];
    (0, $6y9Lh.run)(g, dummyChains);
    (0, $FuDjN.parentDummyChains)(g, dummyChains);
    (0, $caG8q.addBorderSegments)(g);
    if (keepNodeOrder) (0, $cnHil.initDataOrder)(g, nodeOrder);
    (0, $1R4Sz.order)(g, keepNodeOrder);
    $ef4622e02fe04490$var$insertSelfEdges(g);
    (0, $hxfhS.adjust)(g, rankdir);
    (0, $eUqJB.position)(g, {
        align: align,
        nodesep: nodesep,
        edgesep: edgesep,
        ranksep: ranksep
    });
    $ef4622e02fe04490$var$positionSelfEdges(g);
    $ef4622e02fe04490$var$removeBorderNodes(g);
    (0, $6y9Lh.undo)(g, dummyChains);
    $ef4622e02fe04490$var$fixupEdgeLabelCoords(g);
    (0, $hxfhS.undo)(g, rankdir);
    const { width: width, height: height } = $ef4622e02fe04490$var$translateGraph(g);
    $ef4622e02fe04490$var$assignNodeIntersects(g);
    $ef4622e02fe04490$var$reversePointsForReversedEdges(g);
    (0, $fNUaF.undo)(g);
    return {
        width: width,
        height: height
    };
};
/**
 * 继承上一个布局中的order，防止翻转
 * TODO: 暂时没有考虑涉及层级变动的布局，只保证原来布局层级和相对顺序不变
 */ const $ef4622e02fe04490$var$inheritOrder = (currG, prevG)=>{
    currG.getAllNodes().forEach((n)=>{
        const node = currG.getNode(n.id);
        if (prevG.hasNode(n.id)) {
            const prevNode = prevG.getNode(n.id);
            node.data.fixorder = prevNode.data._order;
            delete prevNode.data._order;
        } else delete node.data.fixorder;
    });
};
/*
 * Copies final layout information from the layout graph back to the input
 * graph. This process only copies whitelisted attributes from the layout graph
 * to the input graph, so it serves as a good place to determine what
 * attributes can influence layout.
 */ const $ef4622e02fe04490$var$updateInputGraph = (inputGraph, layoutGraph)=>{
    inputGraph.getAllNodes().forEach((v)=>{
        var _a;
        const inputLabel = inputGraph.getNode(v.id);
        if (inputLabel) {
            const layoutLabel = layoutGraph.getNode(v.id);
            inputLabel.data.x = layoutLabel.data.x;
            inputLabel.data.y = layoutLabel.data.y;
            inputLabel.data._order = layoutLabel.data.order;
            inputLabel.data._rank = layoutLabel.data.rank;
            if ((_a = layoutGraph.getChildren(v.id)) === null || _a === void 0 ? void 0 : _a.length) {
                inputLabel.data.width = layoutLabel.data.width;
                inputLabel.data.height = layoutLabel.data.height;
            }
        }
    });
    inputGraph.getAllEdges().forEach((e)=>{
        const inputLabel = inputGraph.getEdge(e.id);
        const layoutLabel = layoutGraph.getEdge(e.id);
        inputLabel.data.points = layoutLabel ? layoutLabel.data.points : [];
        if (layoutLabel && layoutLabel.data.hasOwnProperty('x')) {
            inputLabel.data.x = layoutLabel.data.x;
            inputLabel.data.y = layoutLabel.data.y;
        }
    });
// inputGraph.graph().width = layoutGraph.graph().width;
// inputGraph.graph().height = layoutGraph.graph().height;
};
const $ef4622e02fe04490$var$nodeNumAttrs = [
    'width',
    'height',
    'layer',
    'fixorder'
]; // 需要传入layer, fixOrder作为参数参考
const $ef4622e02fe04490$var$nodeDefaults = {
    width: 0,
    height: 0
};
const $ef4622e02fe04490$var$edgeNumAttrs = [
    'minlen',
    'weight',
    'width',
    'height',
    'labeloffset'
];
const $ef4622e02fe04490$var$edgeDefaults = {
    minlen: 1,
    weight: 1,
    width: 0,
    height: 0,
    labeloffset: 10,
    labelpos: 'r'
};
const $ef4622e02fe04490$var$edgeAttrs = [
    'labelpos'
];
/*
 * Constructs a new graph from the input graph, which can be used for layout.
 * This process copies only whitelisted attributes from the input graph to the
 * layout graph. Thus this function serves as a good place to determine what
 * attributes can influence layout.
 */ const $ef4622e02fe04490$var$buildLayoutGraph = (inputGraph)=>{
    const g = new (0, $fc2XC.Graph)({
        tree: []
    });
    inputGraph.getAllNodes().forEach((v)=>{
        const node = $ef4622e02fe04490$var$canonicalize(inputGraph.getNode(v.id).data);
        const defaultNode = Object.assign(Object.assign({}, $ef4622e02fe04490$var$nodeDefaults), node);
        const defaultAttrs = $ef4622e02fe04490$var$selectNumberAttrs(defaultNode, $ef4622e02fe04490$var$nodeNumAttrs);
        if (!g.hasNode(v.id)) g.addNode({
            id: v.id,
            data: Object.assign({}, defaultAttrs)
        });
        const parent = inputGraph.hasTreeStructure('combo') ? inputGraph.getParent(v.id, 'combo') : inputGraph.getParent(v.id);
        if (!(0, $geZBG.default)(parent)) {
            if (!g.hasNode(parent.id)) g.addNode(Object.assign({}, parent));
            g.setParent(v.id, parent.id);
        }
    });
    inputGraph.getAllEdges().forEach((e)=>{
        const edge = $ef4622e02fe04490$var$canonicalize(inputGraph.getEdge(e.id).data);
        const pickedProperties = {};
        $ef4622e02fe04490$var$edgeAttrs === null || $ef4622e02fe04490$var$edgeAttrs === void 0 || $ef4622e02fe04490$var$edgeAttrs.forEach((key)=>{
            if (edge[key] !== undefined) pickedProperties[key] = edge[key];
        });
        g.addEdge({
            id: e.id,
            source: e.source,
            target: e.target,
            data: Object.assign({}, $ef4622e02fe04490$var$edgeDefaults, $ef4622e02fe04490$var$selectNumberAttrs(edge, $ef4622e02fe04490$var$edgeNumAttrs), pickedProperties)
        });
    });
    return g;
};
/*
 * This idea comes from the Gansner paper: to account for edge labels in our
 * layout we split each rank in half by doubling minlen and halving ranksep.
 * Then we can place labels at these mid-points between nodes.
 *
 * We also add some minimal padding to the width to push the label for the edge
 * away from the edge itself a bit.
 */ const $ef4622e02fe04490$var$makeSpaceForEdgeLabels = (g, options)=>{
    const { ranksep: ranksep = 0, rankdir: rankdir } = options;
    g.getAllNodes().forEach((node)=>{
        if (!isNaN(node.data.layer)) {
            if (!node.data.layer) node.data.layer = 0;
        }
    });
    g.getAllEdges().forEach((edge)=>{
        var _a;
        edge.data.minlen *= 2;
        if (((_a = edge.data.labelpos) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== 'c') {
            if (rankdir === 'TB' || rankdir === 'BT') edge.data.width += edge.data.labeloffset;
            else edge.data.height += edge.data.labeloffset;
        }
    });
    return ranksep / 2;
};
/*
 * Creates temporary dummy nodes that capture the rank in which each edge's
 * label is going to, if it has one of non-zero width and height. We do this
 * so that we can safely remove empty ranks while preserving balance for the
 * label's position.
 */ const $ef4622e02fe04490$var$injectEdgeLabelProxies = (g)=>{
    g.getAllEdges().forEach((e)=>{
        if (e.data.width && e.data.height) {
            const v = g.getNode(e.source);
            const w = g.getNode(e.target);
            const label = {
                e: e,
                rank: (w.data.rank - v.data.rank) / 2 + v.data.rank
            };
            (0, $c1yiZ.addDummyNode)(g, 'edge-proxy', label, '_ep');
        }
    });
};
const $ef4622e02fe04490$var$assignRankMinMax = (g)=>{
    let maxRank = 0;
    g.getAllNodes().forEach((node)=>{
        var _a, _b;
        if (node.data.borderTop) {
            node.data.minRank = (_a = g.getNode(node.data.borderTop)) === null || _a === void 0 ? void 0 : _a.data.rank;
            node.data.maxRank = (_b = g.getNode(node.data.borderBottom)) === null || _b === void 0 ? void 0 : _b.data.rank;
            maxRank = Math.max(maxRank, node.data.maxRank || -Infinity);
        }
    });
    return maxRank;
};
const $ef4622e02fe04490$var$removeEdgeLabelProxies = (g)=>{
    g.getAllNodes().forEach((node)=>{
        if (node.data.dummy === 'edge-proxy') {
            g.getEdge(node.data.e.id).data.labelRank = node.data.rank;
            g.removeNode(node.id);
        }
    });
};
const $ef4622e02fe04490$var$translateGraph = (g, options)=>{
    let minX;
    let maxX = 0;
    let minY;
    let maxY = 0;
    const { marginx: marginX = 0, marginy: marginY = 0 } = options || {};
    const getExtremes = (attrs)=>{
        if (!attrs.data) return;
        const x = attrs.data.x;
        const y = attrs.data.y;
        const w = attrs.data.width;
        const h = attrs.data.height;
        if (!isNaN(x) && !isNaN(w)) {
            if (minX === undefined) minX = x - w / 2;
            minX = Math.min(minX, x - w / 2);
            maxX = Math.max(maxX, x + w / 2);
        }
        if (!isNaN(y) && !isNaN(h)) {
            if (minY === undefined) minY = y - h / 2;
            minY = Math.min(minY, y - h / 2);
            maxY = Math.max(maxY, y + h / 2);
        }
    };
    g.getAllNodes().forEach((v)=>{
        getExtremes(v);
    });
    g.getAllEdges().forEach((e)=>{
        if (e === null || e === void 0 ? void 0 : e.data.hasOwnProperty('x')) getExtremes(e);
    });
    minX -= marginX;
    minY -= marginY;
    g.getAllNodes().forEach((node)=>{
        node.data.x -= minX;
        node.data.y -= minY;
    });
    g.getAllEdges().forEach((edge)=>{
        var _a;
        (_a = edge.data.points) === null || _a === void 0 || _a.forEach((p)=>{
            p.x -= minX;
            p.y -= minY;
        });
        if (edge.data.hasOwnProperty('x')) edge.data.x -= minX;
        if (edge.data.hasOwnProperty('y')) edge.data.y -= minY;
    });
    return {
        width: maxX - minX + marginX,
        height: maxY - minY + marginY
    };
};
const $ef4622e02fe04490$var$assignNodeIntersects = (g)=>{
    g.getAllEdges().forEach((e)=>{
        const nodeV = g.getNode(e.source);
        const nodeW = g.getNode(e.target);
        let p1;
        let p2;
        if (!e.data.points) {
            e.data.points = [];
            p1 = {
                x: nodeW.data.x,
                y: nodeW.data.y
            };
            p2 = {
                x: nodeV.data.x,
                y: nodeV.data.y
            };
        } else {
            p1 = e.data.points[0];
            p2 = e.data.points[e.data.points.length - 1];
        }
        e.data.points.unshift((0, $c1yiZ.intersectRect)(nodeV.data, p1));
        e.data.points.push((0, $c1yiZ.intersectRect)(nodeW.data, p2));
    });
};
const $ef4622e02fe04490$var$fixupEdgeLabelCoords = (g)=>{
    g.getAllEdges().forEach((edge)=>{
        if (edge.data.hasOwnProperty('x')) {
            if (edge.data.labelpos === 'l' || edge.data.labelpos === 'r') edge.data.width -= edge.data.labeloffset;
            switch(edge.data.labelpos){
                case 'l':
                    edge.data.x -= edge.data.width / 2 + edge.data.labeloffset;
                    break;
                case 'r':
                    edge.data.x += edge.data.width / 2 + edge.data.labeloffset;
                    break;
            }
        }
    });
};
const $ef4622e02fe04490$var$reversePointsForReversedEdges = (g)=>{
    g.getAllEdges().forEach((edge)=>{
        var _a;
        if (edge.data.reversed) (_a = edge.data.points) === null || _a === void 0 || _a.reverse();
    });
};
const $ef4622e02fe04490$var$removeBorderNodes = (g)=>{
    g.getAllNodes().forEach((v)=>{
        var _a, _b, _c;
        if ((_a = g.getChildren(v.id)) === null || _a === void 0 ? void 0 : _a.length) {
            const node = g.getNode(v.id);
            const t = g.getNode(node.data.borderTop);
            const b = g.getNode(node.data.borderBottom);
            const l = g.getNode(node.data.borderLeft[((_b = node.data.borderLeft) === null || _b === void 0 ? void 0 : _b.length) - 1]);
            const r = g.getNode(node.data.borderRight[((_c = node.data.borderRight) === null || _c === void 0 ? void 0 : _c.length) - 1]);
            node.data.width = Math.abs((r === null || r === void 0 ? void 0 : r.data.x) - (l === null || l === void 0 ? void 0 : l.data.x)) || 10;
            node.data.height = Math.abs((b === null || b === void 0 ? void 0 : b.data.y) - (t === null || t === void 0 ? void 0 : t.data.y)) || 10;
            node.data.x = ((l === null || l === void 0 ? void 0 : l.data.x) || 0) + node.data.width / 2;
            node.data.y = ((t === null || t === void 0 ? void 0 : t.data.y) || 0) + node.data.height / 2;
        }
    });
    g.getAllNodes().forEach((n)=>{
        if (n.data.dummy === 'border') g.removeNode(n.id);
    });
};
const $ef4622e02fe04490$var$removeSelfEdges = (g)=>{
    g.getAllEdges().forEach((e)=>{
        if (e.source === e.target) {
            const node = g.getNode(e.source);
            if (!node.data.selfEdges) node.data.selfEdges = [];
            node.data.selfEdges.push(e);
            g.removeEdge(e.id);
        }
    });
};
const $ef4622e02fe04490$var$insertSelfEdges = (g)=>{
    const layers = (0, $c1yiZ.buildLayerMatrix)(g);
    layers === null || layers === void 0 || layers.forEach((layer)=>{
        let orderShift = 0;
        layer === null || layer === void 0 || layer.forEach((v, i)=>{
            var _a;
            const node = g.getNode(v);
            node.data.order = i + orderShift;
            (_a = node.data.selfEdges) === null || _a === void 0 || _a.forEach((selfEdge)=>{
                (0, $c1yiZ.addDummyNode)(g, 'selfedge', {
                    width: selfEdge.data.width,
                    height: selfEdge.data.height,
                    rank: node.data.rank,
                    order: i + ++orderShift,
                    e: selfEdge
                }, '_se');
            });
            delete node.data.selfEdges;
        });
    });
};
const $ef4622e02fe04490$var$positionSelfEdges = (g)=>{
    g.getAllNodes().forEach((v)=>{
        const node = g.getNode(v.id);
        if (node.data.dummy === 'selfedge') {
            const selfNode = g.getNode(node.data.e.source);
            const x = selfNode.data.x + selfNode.data.width / 2;
            const y = selfNode.data.y;
            const dx = node.data.x - x;
            const dy = selfNode.data.height / 2;
            if (g.hasEdge(node.data.e.id)) g.updateEdgeData(node.data.e.id, node.data.e.data);
            else g.addEdge({
                id: node.data.e.id,
                source: node.data.e.source,
                target: node.data.e.target,
                data: node.data.e.data
            });
            g.removeNode(v.id);
            node.data.e.data.points = [
                {
                    x: x + 2 * dx / 3,
                    y: y - dy
                },
                {
                    x: x + 5 * dx / 6,
                    y: y - dy
                },
                {
                    y: y,
                    x: x + dx
                },
                {
                    x: x + 5 * dx / 6,
                    y: y + dy
                },
                {
                    x: x + 2 * dx / 3,
                    y: y + dy
                }
            ];
            node.data.e.data.x = node.data.x;
            node.data.e.data.y = node.data.y;
        }
    });
};
const $ef4622e02fe04490$var$selectNumberAttrs = (obj, attrs)=>{
    const pickedProperties = {};
    attrs === null || attrs === void 0 || attrs.forEach((key)=>{
        if (obj[key] === undefined) return;
        pickedProperties[key] = +obj[key];
    });
    return pickedProperties;
};
const $ef4622e02fe04490$var$canonicalize = (attrs = {})=>{
    const newAttrs = {};
    Object.keys(attrs).forEach((k)=>{
        newAttrs[k.toLowerCase()] = attrs[k];
    });
    return newAttrs;
};

});
parcelRegister("fNUaF", function(module, exports) {

$parcel$export(module.exports, "run", () => $b8170105b7466c57$export$889ea624f2cb2c57);
$parcel$export(module.exports, "undo", () => $b8170105b7466c57$export$21f930c44940fd98);

var $hM3nj = parcelRequire("hM3nj");
const $b8170105b7466c57$export$889ea624f2cb2c57 = (g, acyclicer)=>{
    const weightFn = (g)=>{
        return (e)=>e.data.weight || 1;
    };
    const fas = acyclicer === 'greedy' ? (0, $hM3nj.greedyFAS)(g, weightFn(g)) : $b8170105b7466c57$var$dfsFAS(g);
    fas === null || fas === void 0 || fas.forEach((e)=>{
        const label = e.data;
        g.removeEdge(e.id);
        label.forwardName = e.data.name;
        label.reversed = true;
        g.addEdge({
            id: e.id,
            source: e.target,
            target: e.source,
            data: Object.assign({}, label)
        });
    });
};
const $b8170105b7466c57$var$dfsFAS = (g)=>{
    const fas = [];
    const stack = {};
    const visited = {};
    const dfs = (v)=>{
        if (visited[v]) return;
        visited[v] = true;
        stack[v] = true;
        g.getRelatedEdges(v, 'out').forEach((e)=>{
            if (stack[e.target]) fas.push(e);
            else dfs(e.target);
        });
        delete stack[v];
    };
    g.getAllNodes().forEach((n)=>dfs(n.id));
    return fas;
};
const $b8170105b7466c57$export$21f930c44940fd98 = (g)=>{
    g.getAllEdges().forEach((e)=>{
        const label = e.data;
        if (label.reversed) {
            g.removeEdge(e.id);
            const forwardName = label.forwardName;
            delete label.reversed;
            delete label.forwardName;
            g.addEdge({
                id: e.id,
                source: e.target,
                target: e.source,
                data: Object.assign(Object.assign({}, label), {
                    forwardName: forwardName
                })
            });
        }
    });
};

});
parcelRegister("hM3nj", function(module, exports) {

$parcel$export(module.exports, "greedyFAS", () => $cf09898c6dc74a4f$export$b96a088aeac42554);
/*
 * A greedy heuristic for finding a feedback arc set for a graph. A feedback
 * arc set is a set of edges that can be removed to make a graph acyclic.
 * The algorithm comes from: P. Eades, X. Lin, and W. F. Smyth, "A fast and
 * effective heuristic for the feedback arc set problem." This implementation
 * adjusts that from the paper to allow for weighted edges.
 *
 * @see https://github.com/dagrejs/dagre/blob/master/lib/greedy-fas.js
 */ 
var $fc2XC = parcelRequire("fc2XC");

var $etBhl = parcelRequire("etBhl");
class $cf09898c6dc74a4f$var$List extends (0, $etBhl.default) {
}
const $cf09898c6dc74a4f$var$DEFAULT_WEIGHT_FN = ()=>1;
const $cf09898c6dc74a4f$export$b96a088aeac42554 = (g, weightFn)=>{
    var _a;
    if (g.getAllNodes().length <= 1) return [];
    const state = $cf09898c6dc74a4f$var$buildState(g, weightFn || $cf09898c6dc74a4f$var$DEFAULT_WEIGHT_FN);
    const results = $cf09898c6dc74a4f$var$doGreedyFAS(state.graph, state.buckets, state.zeroIdx);
    return (_a = results.map((e)=>g.getRelatedEdges(e.v, 'out').filter(({ target: target })=>target === e.w))) === null || _a === void 0 ? void 0 : _a.flat();
};
const $cf09898c6dc74a4f$var$doGreedyFAS = (g, buckets, zeroIdx)=>{
    let results = [];
    const sources = buckets[buckets.length - 1];
    const sinks = buckets[0];
    let entry;
    while(g.getAllNodes().length){
        while(entry = sinks.dequeue())$cf09898c6dc74a4f$var$removeNode(g, buckets, zeroIdx, entry);
        while(entry = sources.dequeue())$cf09898c6dc74a4f$var$removeNode(g, buckets, zeroIdx, entry);
        if (g.getAllNodes().length) for(let i = buckets.length - 2; i > 0; --i){
            entry = buckets[i].dequeue();
            if (entry) {
                results = results.concat($cf09898c6dc74a4f$var$removeNode(g, buckets, zeroIdx, entry, true));
                break;
            }
        }
    }
    return results;
};
const $cf09898c6dc74a4f$var$removeNode = (g, buckets, zeroIdx, entry, collectPredecessors)=>{
    var _a, _b;
    const results = [];
    if (g.hasNode(entry.v)) {
        (_a = g.getRelatedEdges(entry.v, 'in')) === null || _a === void 0 || _a.forEach((edge)=>{
            const weight = edge.data.weight;
            const uEntry = g.getNode(edge.source);
            if (collectPredecessors) // this result not really care about in or out
            results.push({
                v: edge.source,
                w: edge.target,
                in: 0,
                out: 0
            });
            if (uEntry.data.out === undefined) uEntry.data.out = 0;
            // @ts-ignore
            uEntry.data.out -= weight;
            $cf09898c6dc74a4f$var$assignBucket(buckets, zeroIdx, Object.assign({
                v: uEntry.id
            }, uEntry.data));
        });
        (_b = g.getRelatedEdges(entry.v, 'out')) === null || _b === void 0 || _b.forEach((edge)=>{
            const weight = edge.data.weight;
            const w = edge.target;
            const wEntry = g.getNode(w);
            if (wEntry.data.in === undefined) wEntry.data.in = 0;
            // @ts-ignore
            wEntry.data.in -= weight;
            $cf09898c6dc74a4f$var$assignBucket(buckets, zeroIdx, Object.assign({
                v: wEntry.id
            }, wEntry.data));
        });
        g.removeNode(entry.v);
    }
    return collectPredecessors ? results : undefined;
};
const $cf09898c6dc74a4f$var$buildState = (g, weightFn)=>{
    const fasGraph = new (0, $fc2XC.Graph)();
    let maxIn = 0;
    let maxOut = 0;
    g.getAllNodes().forEach((v)=>{
        fasGraph.addNode({
            id: v.id,
            data: {
                v: v.id,
                in: 0,
                out: 0
            }
        });
    });
    // Aggregate weights on nodes, but also sum the weights across multi-edges
    // into a single edge for the fasGraph.
    g.getAllEdges().forEach((e)=>{
        const edge = fasGraph.getRelatedEdges(e.source, 'out').find((edge)=>edge.target === e.target);
        const weight = (weightFn === null || weightFn === void 0 ? void 0 : weightFn(e)) || 1;
        if (!edge) fasGraph.addEdge({
            id: e.id,
            source: e.source,
            target: e.target,
            data: {
                weight: weight
            }
        });
        else fasGraph.updateEdgeData(edge === null || edge === void 0 ? void 0 : edge.id, Object.assign(Object.assign({}, edge.data), {
            weight: edge.data.weight + weight
        }));
        // @ts-ignore
        maxOut = Math.max(maxOut, fasGraph.getNode(e.source).data.out += weight);
        // @ts-ignore
        maxIn = Math.max(maxIn, fasGraph.getNode(e.target).data.in += weight);
    });
    const buckets = [];
    const rangeMax = maxOut + maxIn + 3;
    for(let i = 0; i < rangeMax; i++)buckets.push(new $cf09898c6dc74a4f$var$List());
    const zeroIdx = maxIn + 1;
    fasGraph.getAllNodes().forEach((v)=>{
        $cf09898c6dc74a4f$var$assignBucket(buckets, zeroIdx, Object.assign({
            v: v.id
        }, fasGraph.getNode(v.id).data));
    });
    return {
        buckets: buckets,
        zeroIdx: zeroIdx,
        graph: fasGraph
    };
};
const $cf09898c6dc74a4f$var$assignBucket = (buckets, zeroIdx, entry)=>{
    if (!entry.out) buckets[0].enqueue(entry);
    else if (!entry['in']) buckets[buckets.length - 1].enqueue(entry);
    else buckets[entry.out - entry['in'] + zeroIdx].enqueue(entry);
};

});
parcelRegister("etBhl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8a0b0e1bab6ac16$export$2e2bcd8739ae039);
const $a8a0b0e1bab6ac16$var$filterOutLinks = (k, v)=>{
    if (k !== 'next' && k !== 'prev') return v;
};
const $a8a0b0e1bab6ac16$var$unlink = (entry)=>{
    entry.prev.next = entry.next;
    entry.next.prev = entry.prev;
    delete entry.next;
    delete entry.prev;
};
class $a8a0b0e1bab6ac16$export$2e2bcd8739ae039 {
    constructor(){
        const shortcut = {};
        shortcut.prev = shortcut;
        shortcut.next = shortcut.prev;
        this.shortcut = shortcut;
    }
    dequeue() {
        const shortcut = this.shortcut;
        const entry = shortcut.prev;
        if (entry && entry !== shortcut) {
            $a8a0b0e1bab6ac16$var$unlink(entry);
            return entry;
        }
    }
    enqueue(entry) {
        const shortcut = this.shortcut;
        if (entry.prev && entry.next) $a8a0b0e1bab6ac16$var$unlink(entry);
        entry.next = shortcut.next;
        shortcut.next.prev = entry;
        shortcut.next = entry;
        entry.prev = shortcut;
    }
    toString() {
        const strs = [];
        const sentinel = this.shortcut;
        let curr = sentinel.prev;
        while(curr !== sentinel){
            strs.push(JSON.stringify(curr, $a8a0b0e1bab6ac16$var$filterOutLinks));
            curr = curr === null || curr === void 0 ? void 0 : curr.prev;
        }
        return `[${strs.join(', ')}]`;
    }
}

});



parcelRegister("caG8q", function(module, exports) {

$parcel$export(module.exports, "addBorderSegments", () => $8dc71a4fd3f9f2b8$export$9a52541ba49edb51);

var $c1yiZ = parcelRequire("c1yiZ");
const $8dc71a4fd3f9f2b8$export$9a52541ba49edb51 = (g)=>{
    const dfs = (v)=>{
        const children = g.getChildren(v);
        const node = g.getNode(v);
        if (children === null || children === void 0 ? void 0 : children.length) children.forEach((child)=>dfs(child.id));
        if (node.data.hasOwnProperty('minRank')) {
            node.data.borderLeft = [];
            node.data.borderRight = [];
            for(let rank = node.data.minRank, maxRank = node.data.maxRank + 1; rank < maxRank; rank += 1){
                $8dc71a4fd3f9f2b8$var$addBorderNode(g, 'borderLeft', '_bl', v, node, rank);
                $8dc71a4fd3f9f2b8$var$addBorderNode(g, 'borderRight', '_br', v, node, rank);
            }
        }
    };
    g.getRoots().forEach((child)=>dfs(child.id));
};
const $8dc71a4fd3f9f2b8$var$addBorderNode = (g, prop, prefix, sg, sgNode, rank)=>{
    const label = {
        rank: rank,
        borderType: prop,
        width: 0,
        height: 0
    };
    // @ts-ignore
    const prev = sgNode.data[prop][rank - 1];
    const curr = (0, $c1yiZ.addDummyNode)(g, 'border', label, prefix);
    // @ts-ignore
    sgNode.data[prop][rank] = curr;
    g.setParent(curr, sg);
    if (prev) g.addEdge({
        id: `e${Math.random()}`,
        source: prev,
        target: curr,
        data: {
            weight: 1
        }
    });
};

});
parcelRegister("c1yiZ", function(module, exports) {

$parcel$export(module.exports, "addDummyNode", () => $8c10305dba6e08b2$export$ecf34c2268abf7a0);
$parcel$export(module.exports, "simplify", () => $8c10305dba6e08b2$export$798b53621063651);
$parcel$export(module.exports, "asNonCompoundGraph", () => $8c10305dba6e08b2$export$556dc3686e4a2bd5);
$parcel$export(module.exports, "zipObject", () => $8c10305dba6e08b2$export$918056458ccab0);
$parcel$export(module.exports, "intersectRect", () => $8c10305dba6e08b2$export$4a227323f5de0b79);
$parcel$export(module.exports, "buildLayerMatrix", () => $8c10305dba6e08b2$export$aca89c9d4c6bb8ae);
$parcel$export(module.exports, "maxRank", () => $8c10305dba6e08b2$export$978bfc7f0ad7d28e);
$parcel$export(module.exports, "normalizeRanks", () => $8c10305dba6e08b2$export$5747adf39cbd8007);
$parcel$export(module.exports, "removeEmptyRanks", () => $8c10305dba6e08b2$export$45a0c732a9a44b01);
$parcel$export(module.exports, "addBorderNode", () => $8c10305dba6e08b2$export$6589834e22e3d497);
$parcel$export(module.exports, "partition", () => $8c10305dba6e08b2$export$b29f828819edca8d);
$parcel$export(module.exports, "minBy", () => $8c10305dba6e08b2$export$8c826aa0fa59ac68);
$parcel$export(module.exports, "dfs", () => $8c10305dba6e08b2$export$51b654aff22fc5a6);

var $fc2XC = parcelRequire("fc2XC");

var $jyI49 = parcelRequire("jyI49");
const $8c10305dba6e08b2$var$safeSort = (valueA, valueB)=>{
    return Number(valueA) - Number(valueB);
};
const $8c10305dba6e08b2$export$ecf34c2268abf7a0 = (g, type, data, name)=>{
    let v;
    do v = `${name}${Math.random()}`;
    while (g.hasNode(v));
    data.dummy = type;
    g.addNode({
        id: v,
        data: data
    });
    return v;
};
const $8c10305dba6e08b2$export$798b53621063651 = (g)=>{
    const simplified = new (0, $fc2XC.Graph)();
    g.getAllNodes().forEach((v)=>{
        simplified.addNode(Object.assign({}, v));
    });
    g.getAllEdges().forEach((e)=>{
        const edge = simplified.getRelatedEdges(e.source, 'out').find((edge)=>edge.target === e.target);
        if (!edge) simplified.addEdge({
            id: e.id,
            source: e.source,
            target: e.target,
            data: {
                weight: e.data.weight || 0,
                minlen: e.data.minlen || 1
            }
        });
        else simplified.updateEdgeData(edge === null || edge === void 0 ? void 0 : edge.id, Object.assign(Object.assign({}, edge.data), {
            weight: edge.data.weight + e.data.weight || 0,
            minlen: Math.max(edge.data.minlen, e.data.minlen || 1)
        }));
    });
    return simplified;
};
const $8c10305dba6e08b2$export$556dc3686e4a2bd5 = (g)=>{
    const simplified = new (0, $fc2XC.Graph)();
    g.getAllNodes().forEach((node)=>{
        if (!g.getChildren(node.id).length) simplified.addNode(Object.assign({}, node));
    });
    g.getAllEdges().forEach((edge)=>{
        simplified.addEdge(edge);
    });
    return simplified;
};
const $8c10305dba6e08b2$export$918056458ccab0 = (keys, values)=>{
    return keys === null || keys === void 0 ? void 0 : keys.reduce((obj, key, i)=>{
        obj[key] = values[i];
        return obj;
    }, {});
};
const $8c10305dba6e08b2$export$c5a5d928abe0f9b5 = (g)=>{
    const weightsMap = {};
    g.getAllNodes().forEach((node)=>{
        const sucs = {};
        g.getRelatedEdges(node.id, 'out').forEach((e)=>{
            sucs[e.target] = (sucs[e.target] || 0) + (e.data.weight || 0);
        });
        weightsMap[node.id] = sucs;
    });
    return weightsMap;
};
const $8c10305dba6e08b2$export$26130937b5f6ca22 = (g)=>{
    const nodes = g.getAllNodes();
    const weightMap = nodes.map((v)=>{
        const preds = {};
        g.getRelatedEdges(v.id, 'in').forEach((e)=>{
            preds[e.source] = (preds[e.source] || 0) + e.data.weight;
        });
        return preds;
    });
    return $8c10305dba6e08b2$export$918056458ccab0(nodes.map((n)=>n.id), weightMap);
};
const $8c10305dba6e08b2$export$4a227323f5de0b79 = (rect, point)=>{
    const x = Number(rect.x);
    const y = Number(rect.y);
    // Rectangle intersection algorithm from:
    // http://math.stackexchange.com/questions/108113/find-edge-between-two-boxes
    const dx = Number(point.x) - x;
    const dy = Number(point.y) - y;
    let w = Number(rect.width) / 2;
    let h = Number(rect.height) / 2;
    if (!dx && !dy) // completely overlapped directly, then return points its self
    return {
        x: 0,
        y: 0
    };
    let sx;
    let sy;
    if (Math.abs(dy) * w > Math.abs(dx) * h) {
        // Intersection is top or bottom of rect.
        if (dy < 0) h = -h;
        sx = h * dx / dy;
        sy = h;
    } else {
        // Intersection is left or right of rect.
        if (dx < 0) w = -w;
        sx = w;
        sy = w * dy / dx;
    }
    return {
        x: x + sx,
        y: y + sy
    };
};
const $8c10305dba6e08b2$export$aca89c9d4c6bb8ae = (g)=>{
    const layeringNodes = [];
    const rankMax = $8c10305dba6e08b2$export$978bfc7f0ad7d28e(g) + 1;
    for(let i = 0; i < rankMax; i++)layeringNodes.push([]);
    // const layering = _.map(_.range(maxRank(g) + 1), function() { return []; });
    g.getAllNodes().forEach((node)=>{
        const rank = node.data.rank;
        if (rank !== undefined && layeringNodes[rank]) layeringNodes[rank].push(node.id);
    });
    for(let i = 0; i < rankMax; i++)layeringNodes[i] = layeringNodes[i].sort((va, vb)=>$8c10305dba6e08b2$var$safeSort(g.getNode(va).data.order, g.getNode(vb).data.order));
    return layeringNodes;
};
const $8c10305dba6e08b2$export$5747adf39cbd8007 = (g)=>{
    const nodeRanks = g.getAllNodes().filter((v)=>v.data.rank !== undefined).map((v)=>v.data.rank);
    const min = Math.min(...nodeRanks);
    g.getAllNodes().forEach((v)=>{
        if (v.data.hasOwnProperty('rank') && min !== Infinity) v.data.rank -= min;
    });
};
const $8c10305dba6e08b2$export$45a0c732a9a44b01 = (g, nodeRankFactor = 0)=>{
    // Ranks may not start at 0, so we need to offset them
    const nodes = g.getAllNodes();
    const nodeRanks = nodes.filter((v)=>v.data.rank !== undefined).map((v)=>v.data.rank);
    const offset = Math.min(...nodeRanks);
    const layers = [];
    nodes.forEach((v)=>{
        const rank = (v.data.rank || 0) - offset;
        if (!layers[rank]) layers[rank] = [];
        layers[rank].push(v.id);
    });
    let delta = 0;
    for(let i = 0; i < layers.length; i++){
        const vs = layers[i];
        if (vs === undefined) {
            if (i % nodeRankFactor !== 0) delta -= 1;
        } else if (delta) vs === null || vs === void 0 || vs.forEach((v)=>{
            const node = g.getNode(v);
            if (node) {
                node.data.rank = node.data.rank || 0;
                node.data.rank += delta;
            }
        });
    }
};
const $8c10305dba6e08b2$export$6589834e22e3d497 = (g, prefix, rank, order)=>{
    const node = {
        width: 0,
        height: 0
    };
    if ((0, $jyI49.default)(rank) && (0, $jyI49.default)(order)) {
        node.rank = rank;
        node.order = order;
    }
    return $8c10305dba6e08b2$export$ecf34c2268abf7a0(g, 'border', node, prefix);
};
const $8c10305dba6e08b2$export$978bfc7f0ad7d28e = (g)=>{
    let maxRank;
    g.getAllNodes().forEach((v)=>{
        const rank = v.data.rank;
        if (rank !== undefined) {
            if (maxRank === undefined || rank > maxRank) maxRank = rank;
        }
    });
    if (!maxRank) maxRank = 0;
    return maxRank;
};
const $8c10305dba6e08b2$export$b29f828819edca8d = (collection, fn)=>{
    const result = {
        lhs: [],
        rhs: []
    };
    collection === null || collection === void 0 || collection.forEach((value)=>{
        if (fn(value)) result.lhs.push(value);
        else result.rhs.push(value);
    });
    return result;
};
const $8c10305dba6e08b2$export$8c826aa0fa59ac68 = (array, func)=>{
    return array.reduce((a, b)=>{
        const valA = func(a);
        const valB = func(b);
        return valA > valB ? b : a;
    });
};
const $8c10305dba6e08b2$var$doDFS = (graph, node, postorder, visited, navigator, result)=>{
    if (!visited.includes(node.id)) {
        visited.push(node.id);
        if (!postorder) result.push(node.id);
        navigator(node.id).forEach((n)=>$8c10305dba6e08b2$var$doDFS(graph, n, postorder, visited, navigator, result));
        if (postorder) result.push(node.id);
    }
};
const $8c10305dba6e08b2$export$51b654aff22fc5a6 = (graph, node, order, isDirected)=>{
    const nodes = Array.isArray(node) ? node : [
        node
    ];
    const navigator = (n)=>isDirected ? graph.getSuccessors(n) : graph.getNeighbors(n);
    const results = [];
    const visited = [];
    nodes.forEach((node)=>{
        if (!graph.hasNode(node.id)) throw new Error(`Graph does not have node: ${node}`);
        else $8c10305dba6e08b2$var$doDFS(graph, node, order === 'post', visited, navigator, results);
    });
    return results;
};

});


parcelRegister("hxfhS", function(module, exports) {

$parcel$export(module.exports, "adjust", () => $cc4160815348822c$export$2c0e788bcc82013);
$parcel$export(module.exports, "undo", () => $cc4160815348822c$export$21f930c44940fd98);
const $cc4160815348822c$export$2c0e788bcc82013 = (g, rankdir)=>{
    const rd = rankdir.toLowerCase();
    if (rd === 'lr' || rd === 'rl') $cc4160815348822c$var$swapWidthHeight(g);
};
const $cc4160815348822c$export$21f930c44940fd98 = (g, rankdir)=>{
    const rd = rankdir.toLowerCase();
    if (rd === 'bt' || rd === 'rl') $cc4160815348822c$var$reverseY(g);
    if (rd === 'lr' || rd === 'rl') {
        $cc4160815348822c$var$swapXY(g);
        $cc4160815348822c$var$swapWidthHeight(g);
    }
};
const $cc4160815348822c$var$swapWidthHeight = (g)=>{
    g.getAllNodes().forEach((v)=>{
        $cc4160815348822c$var$swapWidthHeightOne(v);
    });
    g.getAllEdges().forEach((e)=>{
        $cc4160815348822c$var$swapWidthHeightOne(e);
    });
};
const $cc4160815348822c$var$swapWidthHeightOne = (node)=>{
    const w = node.data.width;
    node.data.width = node.data.height;
    node.data.height = w;
};
const $cc4160815348822c$var$reverseY = (g)=>{
    g.getAllNodes().forEach((v)=>{
        $cc4160815348822c$var$reverseYOne(v.data);
    });
    g.getAllEdges().forEach((edge)=>{
        var _a;
        (_a = edge.data.points) === null || _a === void 0 || _a.forEach((point)=>$cc4160815348822c$var$reverseYOne(point));
        if (edge.data.hasOwnProperty('y')) $cc4160815348822c$var$reverseYOne(edge.data);
    });
};
const $cc4160815348822c$var$reverseYOne = (node)=>{
    if (node === null || node === void 0 ? void 0 : node.y) node.y = -node.y;
};
const $cc4160815348822c$var$swapXY = (g)=>{
    g.getAllNodes().forEach((v)=>{
        $cc4160815348822c$var$swapXYOne(v.data);
    });
    g.getAllEdges().forEach((edge)=>{
        var _a;
        (_a = edge.data.points) === null || _a === void 0 || _a.forEach((point)=>$cc4160815348822c$var$swapXYOne(point));
        if (edge.data.hasOwnProperty('x')) $cc4160815348822c$var$swapXYOne(edge.data);
    });
};
const $cc4160815348822c$var$swapXYOne = (node)=>{
    const x = node.x;
    node.x = node.y;
    node.y = x;
};

});

parcelRegister("47fN7", function(module, exports) {

$parcel$export(module.exports, "run", () => $2ff410a8e0ea6187$export$889ea624f2cb2c57);
$parcel$export(module.exports, "cleanup", () => $2ff410a8e0ea6187$export$de863c629cb9919d);

var $c1yiZ = parcelRequire("c1yiZ");
/*
 * A nesting graph creates dummy nodes for the tops and bottoms of subgraphs,
 * adds appropriate edges to ensure that all cluster nodes are placed between
 * these boundries, and ensures that the graph is connected.
 *
 * In addition we ensure, through the use of the minlen property, that nodes
 * and subgraph border nodes to not end up on the same rank.
 *
 * Preconditions:
 *
 *    1. Input graph is a DAG
 *    2. Nodes in the input graph has a minlen attribute
 *
 * Postconditions:
 *
 *    1. Input graph is connected.
 *    2. Dummy nodes are added for the tops and bottoms of subgraphs.
 *    3. The minlen attribute for nodes is adjusted to ensure nodes do not
 *       get placed on the same rank as subgraph border nodes.
 *
 * The nesting graph idea comes from Sander, "Layout of Compound Directed
 * Graphs."
 */ const $2ff410a8e0ea6187$export$889ea624f2cb2c57 = (g)=>{
    const root = (0, $c1yiZ.addDummyNode)(g, 'root', {}, '_root');
    const depths = $2ff410a8e0ea6187$var$treeDepths(g);
    let maxDepth = Math.max(...Object.values(depths));
    if (Math.abs(maxDepth) === Infinity) maxDepth = 1;
    const height = maxDepth - 1; // Note: depths is an Object not an array
    const nodeSep = 2 * height + 1;
    // g.graph().nestingRoot = root;
    // Multiply minlen by nodeSep to align nodes on non-border ranks.
    g.getAllEdges().forEach((e)=>{
        e.data.minlen *= nodeSep;
    });
    // Calculate a weight that is sufficient to keep subgraphs vertically compact
    const weight = $2ff410a8e0ea6187$var$sumWeights(g) + 1;
    // Create border nodes and link them up
    // g.children()?.forEach((child) => {
    //   dfs(g, root, nodeSep, weight, height, depths, child);
    // });
    g.getRoots().forEach((child)=>{
        $2ff410a8e0ea6187$var$dfs(g, root, nodeSep, weight, height, depths, child.id);
    });
    // Save the multiplier for node layers for later removal of empty border
    // layers.
    // g.graph().nodeRankFactor = nodeSep;
    return {
        nestingRoot: root,
        nodeRankFactor: nodeSep
    };
};
const $2ff410a8e0ea6187$var$dfs = (g, root, nodeSep, weight, height, depths, v)=>{
    const children = g.getChildren(v);
    if (!(children === null || children === void 0 ? void 0 : children.length)) {
        if (v !== root) // g.setEdge(root, v, { weight: 0, minlen: nodeSep });
        g.addEdge({
            id: `e${Math.random()}`,
            source: root,
            target: v,
            data: {
                weight: 0,
                minlen: nodeSep
            }
        });
        return;
    }
    const top = (0, $c1yiZ.addBorderNode)(g, '_bt');
    const bottom = (0, $c1yiZ.addBorderNode)(g, '_bb');
    const label = g.getNode(v);
    g.setParent(top, v);
    label.data.borderTop = top;
    g.setParent(bottom, v);
    label.data.borderBottom = bottom;
    children === null || children === void 0 || children.forEach((childNode)=>{
        $2ff410a8e0ea6187$var$dfs(g, root, nodeSep, weight, height, depths, childNode.id);
        const childTop = childNode.data.borderTop ? childNode.data.borderTop : childNode.id;
        const childBottom = childNode.data.borderBottom ? childNode.data.borderBottom : childNode.id;
        const thisWeight = childNode.data.borderTop ? weight : 2 * weight;
        const minlen = childTop !== childBottom ? 1 : height - depths[v] + 1;
        g.addEdge({
            id: `e${Math.random()}`,
            source: top,
            target: childTop,
            data: {
                minlen: minlen,
                weight: thisWeight,
                nestingEdge: true
            }
        });
        g.addEdge({
            id: `e${Math.random()}`,
            source: childBottom,
            target: bottom,
            data: {
                minlen: minlen,
                weight: thisWeight,
                nestingEdge: true
            }
        });
    });
    if (!g.getParent(v)) g.addEdge({
        id: `e${Math.random()}`,
        source: root,
        target: top,
        data: {
            weight: 0,
            minlen: height + depths[v]
        }
    });
};
const $2ff410a8e0ea6187$var$treeDepths = (g)=>{
    const depths = {};
    const dfs = (v, depth)=>{
        const children = g.getChildren(v);
        children === null || children === void 0 || children.forEach((child)=>dfs(child.id, depth + 1));
        depths[v] = depth;
    };
    // g.children()?.forEach((v) => dfs(v, 1));
    g.getRoots().forEach((v)=>dfs(v.id, 1));
    return depths;
};
const $2ff410a8e0ea6187$var$sumWeights = (g)=>{
    let result = 0;
    g.getAllEdges().forEach((e)=>{
        result += e.data.weight;
    });
    return result;
};
const $2ff410a8e0ea6187$export$de863c629cb9919d = (g, nestingRoot)=>{
    // const graphLabel = g.graph();
    // graphLabel.nestingRoot && g.removeNode(graphLabel.nestingRoot);
    // delete graphLabel.nestingRoot;
    if (nestingRoot) g.removeNode(nestingRoot);
    g.getAllEdges().forEach((e)=>{
        if (e.data.nestingEdge) g.removeEdge(e.id);
    });
};

});

parcelRegister("6y9Lh", function(module, exports) {

$parcel$export(module.exports, "run", () => $4c4d7d7d463f5a53$export$889ea624f2cb2c57);
$parcel$export(module.exports, "undo", () => $4c4d7d7d463f5a53$export$21f930c44940fd98);

var $c1yiZ = parcelRequire("c1yiZ");
/*
 * Breaks any long edges in the graph into short segments that span 1 layer
 * each. This operation is undoable with the denormalize function.
 *
 * Pre-conditions:
 *
 *    1. The input graph is a DAG.
 *    2. Each node in the graph has a "rank" property.
 *
 * Post-condition:
 *
 *    1. All edges in the graph have a length of 1.
 *    2. Dummy nodes are added where edges have been split into segments.
 *    3. The graph is augmented with a "dummyChains" attribute which contains
 *       the first dummy in each chain of dummy nodes produced.
 */ const $4c4d7d7d463f5a53$var$DUMMY_NODE_EDGE = 'edge';
const $4c4d7d7d463f5a53$var$DUMMY_NODE_EDGE_LABEL = 'edge-label';
const $4c4d7d7d463f5a53$export$889ea624f2cb2c57 = (g, dummyChains)=>{
    g.getAllEdges().forEach((edge)=>$4c4d7d7d463f5a53$var$normalizeEdge(g, edge, dummyChains));
};
const $4c4d7d7d463f5a53$var$normalizeEdge = (g, e, dummyChains)=>{
    let v = e.source;
    let vRank = g.getNode(v).data.rank;
    const w = e.target;
    const wRank = g.getNode(w).data.rank;
    const labelRank = e.data.labelRank;
    if (wRank === vRank + 1) return;
    g.removeEdge(e.id);
    let dummy;
    let nodeData;
    let i;
    for(i = 0, ++vRank; vRank < wRank; ++i, ++vRank){
        e.data.points = [];
        nodeData = {
            originalEdge: e,
            width: 0,
            height: 0,
            rank: vRank
        };
        dummy = (0, $c1yiZ.addDummyNode)(g, $4c4d7d7d463f5a53$var$DUMMY_NODE_EDGE, nodeData, '_d');
        if (vRank === labelRank) {
            nodeData.width = e.data.width;
            nodeData.height = e.data.height;
            nodeData.dummy = $4c4d7d7d463f5a53$var$DUMMY_NODE_EDGE_LABEL;
            nodeData.labelpos = e.data.labelpos;
        }
        g.addEdge({
            id: `e${Math.random()}`,
            source: v,
            target: dummy,
            data: {
                weight: e.data.weight
            }
        });
        if (i === 0) dummyChains.push(dummy);
        v = dummy;
    }
    g.addEdge({
        id: `e${Math.random()}`,
        source: v,
        target: w,
        data: {
            weight: e.data.weight
        }
    });
};
const $4c4d7d7d463f5a53$export$21f930c44940fd98 = (g, dummyChains)=>{
    dummyChains.forEach((v)=>{
        let node = g.getNode(v);
        const { data: data } = node;
        const originalEdge = data.originalEdge;
        let w;
        // Restore original edge.
        if (originalEdge) g.addEdge(originalEdge);
        let currentV = v;
        while(node.data.dummy){
            w = g.getSuccessors(currentV)[0];
            g.removeNode(currentV);
            originalEdge.data.points.push({
                x: node.data.x,
                y: node.data.y
            });
            if (node.data.dummy === $4c4d7d7d463f5a53$var$DUMMY_NODE_EDGE_LABEL) {
                originalEdge.data.x = node.data.x;
                originalEdge.data.y = node.data.y;
                originalEdge.data.width = node.data.width;
                originalEdge.data.height = node.data.height;
            }
            currentV = w.id;
            node = g.getNode(currentV);
        }
    });
};

});

parcelRegister("1R4Sz", function(module, exports) {

$parcel$export(module.exports, "order", () => $159e868f39149705$export$aaaeab0fac9a3ccb);

var $fc2XC = parcelRequire("fc2XC");

var $iGRaJ = parcelRequire("iGRaJ");

var $c1yiZ = parcelRequire("c1yiZ");

var $9DccN = parcelRequire("9DccN");

var $31HLr = parcelRequire("31HLr");

var $1qyNA = parcelRequire("1qyNA");

var $bpLYK = parcelRequire("bpLYK");

var $7zGdq = parcelRequire("7zGdq");
const $159e868f39149705$export$aaaeab0fac9a3ccb = (g, keepNodeOrder)=>{
    const mxRank = (0, $c1yiZ.maxRank)(g);
    const range1 = [];
    const range2 = [];
    for(let i = 1; i < mxRank + 1; i++)range1.push(i);
    for(let i = mxRank - 1; i > -1; i--)range2.push(i);
    const downLayerGraphs = $159e868f39149705$var$buildLayerGraphs(g, range1, 'in');
    const upLayerGraphs = $159e868f39149705$var$buildLayerGraphs(g, range2, 'out');
    let layering = (0, $bpLYK.initOrder)(g);
    $159e868f39149705$var$assignOrder(g, layering);
    let bestCC = Number.POSITIVE_INFINITY;
    let best;
    for(let i = 0, lastBest = 0; lastBest < 4; ++i, ++lastBest){
        $159e868f39149705$var$sweepLayerGraphs(i % 2 ? downLayerGraphs : upLayerGraphs, i % 4 >= 2, false, keepNodeOrder);
        layering = (0, $c1yiZ.buildLayerMatrix)(g);
        const cc = (0, $1qyNA.crossCount)(g, layering);
        if (cc < bestCC) {
            lastBest = 0;
            best = (0, $iGRaJ.default)(layering);
            bestCC = cc;
        }
    }
    // consider use previous result, maybe somewhat reduendant
    layering = (0, $bpLYK.initOrder)(g);
    $159e868f39149705$var$assignOrder(g, layering);
    for(let i = 0, lastBest = 0; lastBest < 4; ++i, ++lastBest){
        $159e868f39149705$var$sweepLayerGraphs(i % 2 ? downLayerGraphs : upLayerGraphs, i % 4 >= 2, true, keepNodeOrder);
        layering = (0, $c1yiZ.buildLayerMatrix)(g);
        const cc = (0, $1qyNA.crossCount)(g, layering);
        if (cc < bestCC) {
            lastBest = 0;
            best = (0, $iGRaJ.default)(layering);
            bestCC = cc;
        }
    }
    $159e868f39149705$var$assignOrder(g, best);
};
const $159e868f39149705$var$buildLayerGraphs = (g, ranks, direction)=>{
    return ranks.map((rank)=>{
        return (0, $31HLr.buildLayerGraph)(g, rank, direction);
    });
};
const $159e868f39149705$var$sweepLayerGraphs = (layerGraphs, biasRight, usePrev, keepNodeOrder)=>{
    const cg = new (0, $fc2XC.Graph)();
    layerGraphs === null || layerGraphs === void 0 || layerGraphs.forEach((lg)=>{
        var _a;
        // const root = lg.graph().root as string;
        const root = lg.getRoots()[0].id;
        const sorted = (0, $7zGdq.sortSubgraph)(lg, root, cg, biasRight, usePrev, keepNodeOrder);
        for(let i = 0; i < ((_a = sorted.vs) === null || _a === void 0 ? void 0 : _a.length) || 0; i++){
            const lnode = lg.getNode(sorted.vs[i]);
            if (lnode) lnode.data.order = i;
        }
        (0, $9DccN.addSubgraphConstraints)(lg, cg, sorted.vs);
    });
};
const $159e868f39149705$var$assignOrder = (g, layering)=>{
    layering === null || layering === void 0 || layering.forEach((layer)=>{
        layer === null || layer === void 0 || layer.forEach((v, i)=>{
            g.getNode(v).data.order = i;
        });
    });
};

});
parcelRegister("9DccN", function(module, exports) {

$parcel$export(module.exports, "addSubgraphConstraints", () => $70313955c4f93481$export$def0b5ae5036962c);
const $70313955c4f93481$export$def0b5ae5036962c = (g, cg, vs)=>{
    const prev = {};
    let rootPrev;
    vs === null || vs === void 0 || vs.forEach((v)=>{
        let child = g.getParent(v);
        let parent;
        let prevChild;
        while(child){
            parent = g.getParent(child.id);
            if (parent) {
                prevChild = prev[parent.id];
                prev[parent.id] = child.id;
            } else {
                prevChild = rootPrev;
                rootPrev = child.id;
            }
            if (prevChild && prevChild !== child.id) {
                if (!cg.hasNode(prevChild)) cg.addNode({
                    id: prevChild,
                    data: {}
                });
                if (!cg.hasNode(child.id)) cg.addNode({
                    id: child.id,
                    data: {}
                });
                if (!cg.hasEdge(`e${prevChild}-${child.id}`)) cg.addEdge({
                    id: `e${prevChild}-${child.id}`,
                    source: prevChild,
                    target: child.id,
                    data: {}
                });
                return;
            }
            child = parent;
        }
    });
};

});

parcelRegister("31HLr", function(module, exports) {

$parcel$export(module.exports, "buildLayerGraph", () => $234369c1e753ac56$export$eeb2d75ed1ad428);

var $fc2XC = parcelRequire("fc2XC");
const $234369c1e753ac56$export$eeb2d75ed1ad428 = (g, rank, direction)=>{
    const root = $234369c1e753ac56$var$createRootNode(g);
    const result = new (0, $fc2XC.Graph)({
        tree: [
            {
                id: root,
                children: [],
                data: {}
            }
        ]
    });
    g.getAllNodes().forEach((v)=>{
        const parent = g.getParent(v.id);
        if (v.data.rank === rank || v.data.minRank <= rank && rank <= v.data.maxRank) {
            if (!result.hasNode(v.id)) result.addNode(Object.assign({}, v));
            if ((parent === null || parent === void 0 ? void 0 : parent.id) && !result.hasNode(parent === null || parent === void 0 ? void 0 : parent.id)) result.addNode(Object.assign({}, parent));
            result.setParent(v.id, (parent === null || parent === void 0 ? void 0 : parent.id) || root);
            // This assumes we have only short edges!
            g.getRelatedEdges(v.id, direction).forEach((e)=>{
                const u = e.source === v.id ? e.target : e.source;
                if (!result.hasNode(u)) result.addNode(Object.assign({}, g.getNode(u)));
                const edge = result.getRelatedEdges(u, 'out').find(({ target: target })=>target === v.id);
                const weight = edge !== undefined ? edge.data.weight : 0;
                if (!edge) result.addEdge({
                    id: e.id,
                    source: u,
                    target: v.id,
                    data: {
                        weight: e.data.weight + weight
                    }
                });
                else result.updateEdgeData(edge.id, Object.assign(Object.assign({}, edge.data), {
                    weight: e.data.weight + weight
                }));
            });
            // console.log(v);
            if (v.data.hasOwnProperty('minRank')) result.updateNodeData(v.id, Object.assign(Object.assign({}, v.data), {
                borderLeft: v.data.borderLeft[rank],
                borderRight: v.data.borderRight[rank]
            }));
        }
    });
    return result;
};
const $234369c1e753ac56$var$createRootNode = (g)=>{
    let v;
    while(g.hasNode(v = `_root${Math.random()}`));
    return v;
};

});

parcelRegister("1qyNA", function(module, exports) {

$parcel$export(module.exports, "crossCount", () => $10a33671e50f014a$export$4487b4ec3754a783);
/*
 * A function that takes a layering (an array of layers, each with an array of
 * ordererd nodes) and a graph and returns a weighted crossing count.
 *
 * Pre-conditions:
 *
 *    1. Input graph must be simple (not a multigraph), directed, and include
 *       only simple edges.
 *    2. Edges in the input graph must have assigned weights.
 *
 * Post-conditions:
 *
 *    1. The graph and layering matrix are left unchanged.
 *
 * This algorithm is derived from Barth, et al., "Bilayer Cross Counting."
 */ 
var $c1yiZ = parcelRequire("c1yiZ");
const $10a33671e50f014a$var$twoLayerCrossCount = (g, northLayer, southLayer)=>{
    // Sort all of the edges between the north and south layers by their position
    // in the north layer and then the south. Map these edges to the position of
    // their head in the south layer.
    const southPos = (0, $c1yiZ.zipObject)(southLayer, southLayer.map((v, i)=>i));
    const unflat = northLayer.map((v)=>{
        const unsort = g.getRelatedEdges(v, 'out').map((e)=>{
            return {
                pos: southPos[e.target] || 0,
                weight: e.data.weight
            };
        });
        return unsort === null || unsort === void 0 ? void 0 : unsort.sort((a, b)=>a.pos - b.pos);
    });
    const southEntries = unflat.flat().filter((entry)=>entry !== undefined);
    // Build the accumulator tree
    let firstIndex = 1;
    while(firstIndex < southLayer.length)firstIndex <<= 1;
    const treeSize = 2 * firstIndex - 1;
    firstIndex -= 1;
    const tree = Array(treeSize).fill(0, 0, treeSize);
    // Calculate the weighted crossings
    let cc = 0;
    southEntries === null || southEntries === void 0 || southEntries.forEach((entry)=>{
        if (entry) {
            let index = entry.pos + firstIndex;
            tree[index] += entry.weight;
            let weightSum = 0;
            while(index > 0){
                if (index % 2) weightSum += tree[index + 1];
                index = index - 1 >> 1;
                tree[index] += entry.weight;
            }
            cc += entry.weight * weightSum;
        }
    });
    return cc;
};
const $10a33671e50f014a$export$4487b4ec3754a783 = (g, layering)=>{
    let cc = 0;
    for(let i = 1; i < (layering === null || layering === void 0 ? void 0 : layering.length); i += 1)cc += $10a33671e50f014a$var$twoLayerCrossCount(g, layering[i - 1], layering[i]);
    return cc;
};

});

parcelRegister("bpLYK", function(module, exports) {

$parcel$export(module.exports, "initOrder", () => $84f73f1d5ed364f3$export$a68885affb54ae0d);
/*
 * Assigns an initial order value for each node by performing a DFS search
 * starting from nodes in the first rank. Nodes are assigned an order in their
 * rank as they are first visited.
 *
 * This approach comes from Gansner, et al., "A Technique for Drawing Directed
 * Graphs."
 *
 * Returns a layering matrix with an array per layer and each layer sorted by
 * the order of its nodes.
 */ const $84f73f1d5ed364f3$export$a68885affb54ae0d = (g)=>{
    const visited = {};
    // const simpleNodes = g.getAllNodes().filter((v) => {
    //   return !g.getChildren(v.id)?.length;
    // });
    const simpleNodes = g.getAllNodes();
    const nodeRanks = simpleNodes.map((v)=>{
        var _a;
        return (_a = v.data.rank) !== null && _a !== void 0 ? _a : -Infinity;
    });
    const maxRank = Math.max(...nodeRanks);
    const layers = [];
    for(let i = 0; i < maxRank + 1; i++)layers.push([]);
    const orderedVs = simpleNodes.sort((a, b)=>g.getNode(a.id).data.rank - g.getNode(b.id).data.rank);
    // const orderedVs = _.sortBy(simpleNodes, function(v) { return g.node(v)!.rank; });
    // 有fixOrder的，直接排序好放进去
    const beforeSort = orderedVs.filter((n)=>{
        return g.getNode(n.id).data.fixorder !== undefined;
    });
    const fixOrderNodes = beforeSort.sort((a, b)=>g.getNode(a.id).data.fixorder - g.getNode(b.id).data.fixorder);
    fixOrderNodes === null || fixOrderNodes === void 0 || fixOrderNodes.forEach((n)=>{
        if (!isNaN(g.getNode(n.id).data.rank)) layers[g.getNode(n.id).data.rank].push(n.id);
        visited[n.id] = true;
    });
    orderedVs === null || orderedVs === void 0 || orderedVs.forEach((n)=>g.dfsTree(n.id, (node)=>{
            if (visited.hasOwnProperty(node.id)) return true;
            visited[node.id] = true;
            if (!isNaN(node.data.rank)) layers[node.data.rank].push(node.id);
        }));
    return layers;
};

});

parcelRegister("7zGdq", function(module, exports) {

$parcel$export(module.exports, "sortSubgraph", () => $583c8c65d9224479$export$734a84c77ae2f1e);

var $hTn8d = parcelRequire("hTn8d");

var $9pIph = parcelRequire("9pIph");

var $3xuzb = parcelRequire("3xuzb");
const $583c8c65d9224479$export$734a84c77ae2f1e = (g, v, cg, biasRight, usePrev, keepNodeOrder)=>{
    var _a, _b, _c, _d;
    let movable = g.getChildren(v).map((n)=>n.id);
    // fixorder的点不参与排序（这个方案不合适，只排了新增节点，和原来的分离）
    const node = g.getNode(v);
    const bl = node ? node.data.borderLeft : undefined;
    const br = node ? node.data.borderRight : undefined;
    const subgraphs = {};
    if (bl) movable = movable === null || movable === void 0 ? void 0 : movable.filter((w)=>{
        return w !== bl && w !== br;
    });
    const barycenters = (0, $hTn8d.barycenter)(g, movable || []);
    barycenters === null || barycenters === void 0 || barycenters.forEach((entry)=>{
        var _a;
        if ((_a = g.getChildren(entry.v)) === null || _a === void 0 ? void 0 : _a.length) {
            const subgraphResult = $583c8c65d9224479$export$734a84c77ae2f1e(g, entry.v, cg, biasRight, keepNodeOrder);
            subgraphs[entry.v] = subgraphResult;
            if (subgraphResult.hasOwnProperty('barycenter')) $583c8c65d9224479$var$mergeBarycenters(entry, subgraphResult);
        }
    });
    const entries = (0, $9pIph.default)(barycenters, cg);
    $583c8c65d9224479$var$expandSubgraphs(entries, subgraphs);
    // 添加fixorder信息到entries里边
    // TODO: 不考虑复合情况，只用第一个点的fixorder信息，后续考虑更完备的实现
    (_a = entries.filter((e)=>e.vs.length > 0)) === null || _a === void 0 || _a.forEach((e)=>{
        const node = g.getNode(e.vs[0]);
        if (node) {
            e.fixorder = node.data.fixorder;
            e.order = node.data.order;
        }
    });
    const result = (0, $3xuzb.sort)(entries, biasRight, usePrev, keepNodeOrder);
    if (bl) {
        result.vs = [
            bl,
            result.vs,
            br
        ].flat();
        if ((_b = g.getPredecessors(bl)) === null || _b === void 0 ? void 0 : _b.length) {
            const blPred = g.getNode(((_c = g.getPredecessors(bl)) === null || _c === void 0 ? void 0 : _c[0].id) || '');
            const brPred = g.getNode(((_d = g.getPredecessors(br)) === null || _d === void 0 ? void 0 : _d[0].id) || '');
            if (!result.hasOwnProperty('barycenter')) {
                result.barycenter = 0;
                result.weight = 0;
            }
            result.barycenter = (result.barycenter * result.weight + blPred.data.order + brPred.data.order) / (result.weight + 2);
            result.weight += 2;
        }
    }
    return result;
};
const $583c8c65d9224479$var$expandSubgraphs = (entries, subgraphs)=>{
    entries === null || entries === void 0 || entries.forEach((entry)=>{
        var _a;
        const vss = (_a = entry.vs) === null || _a === void 0 ? void 0 : _a.map((v)=>{
            if (subgraphs[v]) return subgraphs[v].vs;
            return v;
        });
        entry.vs = vss.flat();
    });
};
const $583c8c65d9224479$var$mergeBarycenters = (target, other)=>{
    if (target.barycenter !== undefined) {
        target.barycenter = (target.barycenter * target.weight + other.barycenter * other.weight) / (target.weight + other.weight);
        target.weight += other.weight;
    } else {
        target.barycenter = other.barycenter;
        target.weight = other.weight;
    }
};

});
parcelRegister("hTn8d", function(module, exports) {

$parcel$export(module.exports, "barycenter", () => $d069842259b06720$export$d54b347d68b9b5f6);
/**
 * TODO: The median method consistently performs better than the barycenter method and has a slight theoretical advantage
 */ const $d069842259b06720$export$d54b347d68b9b5f6 = (g, movable)=>{
    return movable.map((v)=>{
        const inV = g.getRelatedEdges(v, 'in');
        if (!(inV === null || inV === void 0 ? void 0 : inV.length)) return {
            v: v
        };
        const result = {
            sum: 0,
            weight: 0
        };
        inV === null || inV === void 0 || inV.forEach((e)=>{
            const nodeU = g.getNode(e.source);
            result.sum += e.data.weight * nodeU.data.order;
            result.weight += e.data.weight;
        });
        return {
            v: v,
            barycenter: result.sum / result.weight,
            weight: result.weight
        };
    });
};

});

parcelRegister("9pIph", function(module, exports) {

$parcel$export(module.exports, "default", () => $6da8e51f20096e0b$export$2e2bcd8739ae039);
/*
 * Given a list of entries of the form {v, barycenter, weight} and a
 * constraint graph this function will resolve any conflicts between the
 * constraint graph and the barycenters for the entries. If the barycenters for
 * an entry would violate a constraint in the constraint graph then we coalesce
 * the nodes in the conflict into a new node that respects the contraint and
 * aggregates barycenter and weight information.
 *
 * This implementation is based on the description in Forster, "A Fast and
 * Simple Hueristic for Constrained Two-Level Crossing Reduction," thought it
 * differs in some specific details.
 *
 * Pre-conditions:
 *
 *    1. Each entry has the form {v, barycenter, weight}, or if the node has
 *       no barycenter, then {v}.
 *
 * Returns:
 *
 *    A new list of entries of the form {vs, i, barycenter, weight}. The list
 *    `vs` may either be a singleton or it may be an aggregation of nodes
 *    ordered such that they do not violate constraints from the constraint
 *    graph. The property `i` is the lowest original index of any of the
 *    elements in `vs`.
 */ const $6da8e51f20096e0b$var$resolveConflicts = (entries, cg)=>{
    var _a, _b, _c;
    const mappedEntries = {};
    entries === null || entries === void 0 || entries.forEach((entry, i)=>{
        mappedEntries[entry.v] = {
            i: i,
            indegree: 0,
            in: [],
            out: [],
            vs: [
                entry.v
            ]
        };
        const tmp = mappedEntries[entry.v];
        if (entry.barycenter !== undefined) {
            tmp.barycenter = entry.barycenter;
            tmp.weight = entry.weight;
        }
    });
    (_a = cg.getAllEdges()) === null || _a === void 0 || _a.forEach((e)=>{
        const entryV = mappedEntries[e.source];
        const entryW = mappedEntries[e.target];
        if (entryV !== undefined && entryW !== undefined) {
            entryW.indegree++;
            entryV.out.push(mappedEntries[e.target]);
        }
    });
    const sourceSet = (_c = (_b = Object.values(mappedEntries)).filter) === null || _c === void 0 ? void 0 : _c.call(_b, (entry)=>!entry.indegree);
    return $6da8e51f20096e0b$var$doResolveConflicts(sourceSet);
};
const $6da8e51f20096e0b$var$doResolveConflicts = (sourceSet)=>{
    var _a, _b;
    const entries = [];
    const handleIn = (vEntry)=>{
        return (uEntry)=>{
            if (uEntry.merged) return;
            if (uEntry.barycenter === undefined || vEntry.barycenter === undefined || uEntry.barycenter >= vEntry.barycenter) $6da8e51f20096e0b$var$mergeEntries(vEntry, uEntry);
        };
    };
    const handleOut = (vEntry)=>{
        return (wEntry)=>{
            wEntry['in'].push(vEntry);
            if (--wEntry.indegree === 0) sourceSet.push(wEntry);
        };
    };
    while(sourceSet === null || sourceSet === void 0 ? void 0 : sourceSet.length){
        const entry = sourceSet.pop();
        entries.push(entry);
        (_a = entry['in'].reverse()) === null || _a === void 0 || _a.forEach((e)=>handleIn(entry)(e));
        (_b = entry.out) === null || _b === void 0 || _b.forEach((e)=>handleOut(entry)(e));
    }
    const filtered = entries.filter((entry)=>!entry.merged);
    const keys = [
        'vs',
        'i',
        'barycenter',
        'weight'
    ];
    return filtered.map((entry)=>{
        const picked = {};
        keys === null || keys === void 0 || keys.forEach((key)=>{
            if (entry[key] === undefined) return;
            picked[key] = entry[key];
        });
        return picked;
    });
};
const $6da8e51f20096e0b$var$mergeEntries = (target, source)=>{
    var _a;
    let sum = 0;
    let weight = 0;
    if (target.weight) {
        sum += target.barycenter * target.weight;
        weight += target.weight;
    }
    if (source.weight) {
        sum += source.barycenter * source.weight;
        weight += source.weight;
    }
    target.vs = (_a = source.vs) === null || _a === void 0 ? void 0 : _a.concat(target.vs);
    target.barycenter = sum / weight;
    target.weight = weight;
    target.i = Math.min(source.i, target.i);
    source.merged = true;
};
var $6da8e51f20096e0b$export$2e2bcd8739ae039 = $6da8e51f20096e0b$var$resolveConflicts;

});

parcelRegister("3xuzb", function(module, exports) {

$parcel$export(module.exports, "sort", () => $293c2a0cedf8fc6d$export$97db5808d8f88186);

var $c1yiZ = parcelRequire("c1yiZ");
const $293c2a0cedf8fc6d$export$97db5808d8f88186 = (entries, biasRight, usePrev, keepNodeOrder)=>{
    const parts = (0, $c1yiZ.partition)(entries, (entry)=>{
        const hasFixOrder = entry.hasOwnProperty('fixorder') && !isNaN(entry.fixorder);
        if (keepNodeOrder) return !hasFixOrder && entry.hasOwnProperty('barycenter');
        // NOTE: 有fixorder的也可以排
        return hasFixOrder || entry.hasOwnProperty('barycenter');
    });
    const sortable = parts.lhs;
    const unsortable = parts.rhs.sort((a, b)=>-a.i - -b.i);
    const vs = [];
    let sum = 0;
    let weight = 0;
    let vsIndex = 0;
    sortable === null || sortable === void 0 || sortable.sort($293c2a0cedf8fc6d$var$compareWithBias(!!biasRight, !!usePrev));
    vsIndex = $293c2a0cedf8fc6d$var$consumeUnsortable(vs, unsortable, vsIndex);
    sortable === null || sortable === void 0 || sortable.forEach((entry)=>{
        var _a;
        vsIndex += (_a = entry.vs) === null || _a === void 0 ? void 0 : _a.length;
        vs.push(entry.vs);
        sum += entry.barycenter * entry.weight;
        weight += entry.weight;
        vsIndex = $293c2a0cedf8fc6d$var$consumeUnsortable(vs, unsortable, vsIndex);
    });
    const result = {
        vs: vs.flat()
    };
    if (weight) {
        result.barycenter = sum / weight;
        result.weight = weight;
    }
    return result;
};
const $293c2a0cedf8fc6d$var$consumeUnsortable = (vs, unsortable, index)=>{
    let iindex = index;
    let last;
    while(unsortable.length && (last = unsortable[unsortable.length - 1]).i <= iindex){
        unsortable.pop();
        vs === null || vs === void 0 || vs.push(last.vs);
        iindex++;
    }
    return iindex;
};
/**
 * 配置是否考虑使用之前的布局结果
 */ const $293c2a0cedf8fc6d$var$compareWithBias = (bias, usePrev)=>{
    return (entryV, entryW)=>{
        // 排序的时候先判断fixorder，不行再判断重心
        if (entryV.fixorder !== undefined && entryW.fixorder !== undefined) return entryV.fixorder - entryW.fixorder;
        if (entryV.barycenter < entryW.barycenter) return -1;
        if (entryV.barycenter > entryW.barycenter) return 1;
        // 重心相同，考虑之前排好的顺序
        if (usePrev && entryV.order !== undefined && entryW.order !== undefined) {
            if (entryV.order < entryW.order) return -1;
            if (entryV.order > entryW.order) return 1;
        }
        return !bias ? entryV.i - entryW.i : entryW.i - entryV.i;
    };
};

});



parcelRegister("cnHil", function(module, exports) {

$parcel$export(module.exports, "initDataOrder", () => $9039378000555b47$export$5eded36975f147bd);
/**
 * 按照数据中的结果设置fixorder
 */ const $9039378000555b47$export$5eded36975f147bd = (g, nodeOrder)=>{
    const simpleNodes = g.getAllNodes().filter((v)=>{
        var _a;
        return !((_a = g.getChildren(v.id)) === null || _a === void 0 ? void 0 : _a.length);
    });
    const ranks = simpleNodes.map((v)=>v.data.rank);
    const maxRank = Math.max(...ranks);
    const layers = [];
    for(let i = 0; i < maxRank + 1; i++)layers[i] = [];
    nodeOrder === null || nodeOrder === void 0 || nodeOrder.forEach((n)=>{
        const node = g.getNode(n);
        // 只考虑原有节点，dummy节点需要按照后续算法排出
        if (!node || node.data.dummy) return;
        if (!isNaN(node.data.rank)) {
            node.data.fixorder = layers[node.data.rank].length; // 设置fixorder为当层的顺序
            layers[node.data.rank].push(n);
        }
    });
};

});

parcelRegister("FuDjN", function(module, exports) {

$parcel$export(module.exports, "parentDummyChains", () => $07cb978efe6d96f9$export$f30289267ab03372);
// deep first search with both order low for pre, lim for post
const $07cb978efe6d96f9$var$dfsBothOrder = (g)=>{
    const result = {};
    let lim = 0;
    const dfs = (v)=>{
        const low = lim;
        g.getChildren(v).forEach((n)=>dfs(n.id));
        result[v] = {
            low: low,
            lim: lim++
        };
    };
    g.getRoots().forEach((n)=>dfs(n.id));
    return result;
};
// Find a path from v to w through the lowest common ancestor (LCA). Return the
// full path and the LCA.
const $07cb978efe6d96f9$var$findPath = (g, postorderNums, v, w)=>{
    var _a, _b;
    const vPath = [];
    const wPath = [];
    const low = Math.min(postorderNums[v].low, postorderNums[w].low);
    const lim = Math.max(postorderNums[v].lim, postorderNums[w].lim);
    let parent;
    let lca;
    // Traverse up from v to find the LCA
    parent = v;
    do {
        parent = (_a = g.getParent(parent)) === null || _a === void 0 ? void 0 : _a.id;
        vPath.push(parent);
    }while (parent && (postorderNums[parent].low > low || lim > postorderNums[parent].lim));
    lca = parent;
    // Traverse from w to LCA
    parent = w;
    while(parent && parent !== lca){
        wPath.push(parent);
        parent = (_b = g.getParent(parent)) === null || _b === void 0 ? void 0 : _b.id;
    }
    return {
        lca: lca,
        path: vPath.concat(wPath.reverse())
    };
};
const $07cb978efe6d96f9$export$f30289267ab03372 = (g, dummyChains)=>{
    const postorderNums = $07cb978efe6d96f9$var$dfsBothOrder(g);
    dummyChains.forEach((startV)=>{
        var _a, _b;
        let v = startV;
        let node = g.getNode(v);
        const originalEdge = node.data.originalEdge;
        if (!originalEdge) return;
        const pathData = $07cb978efe6d96f9$var$findPath(g, postorderNums, originalEdge.source, originalEdge.target);
        const path = pathData.path;
        const lca = pathData.lca;
        let pathIdx = 0;
        let pathV = path[pathIdx];
        let ascending = true;
        while(v !== originalEdge.target){
            node = g.getNode(v);
            if (ascending) {
                while(pathV !== lca && ((_a = g.getNode(pathV)) === null || _a === void 0 ? void 0 : _a.data.maxRank) < node.data.rank){
                    pathIdx++;
                    pathV = path[pathIdx];
                }
                if (pathV === lca) ascending = false;
            }
            if (!ascending) {
                while(pathIdx < path.length - 1 && ((_b = g.getNode(path[pathIdx + 1])) === null || _b === void 0 ? void 0 : _b.data.minRank) <= node.data.rank)pathIdx++;
                pathV = path[pathIdx];
            }
            if (g.hasNode(pathV)) g.setParent(v, pathV);
            v = g.getSuccessors(v)[0].id;
        }
    });
};

});

parcelRegister("eUqJB", function(module, exports) {

$parcel$export(module.exports, "position", () => $adab0893f0ddd6af$export$5880b8b5730aff45);

var $c1yiZ = parcelRequire("c1yiZ");

var $hIhW3 = parcelRequire("hIhW3");
const $adab0893f0ddd6af$var$positionY = (g, options)=>{
    const { ranksep: ranksep = 0 } = options || {};
    const layering = (0, $c1yiZ.buildLayerMatrix)(g);
    let prevY = 0;
    layering === null || layering === void 0 || layering.forEach((layer)=>{
        const heights = layer.map((v)=>g.getNode(v).data.height);
        const maxHeight = Math.max(...heights, 0);
        layer === null || layer === void 0 || layer.forEach((v)=>{
            g.getNode(v).data.y = prevY + maxHeight / 2;
        });
        prevY += maxHeight + ranksep;
    });
};
const $adab0893f0ddd6af$var$positionX = (g, options)=>{
    const { align: graphAlign, nodesep: nodesep = 0, edgesep: edgesep = 0 } = options || {};
    const layering = (0, $c1yiZ.buildLayerMatrix)(g);
    const conflicts = Object.assign((0, $hIhW3.findType1Conflicts)(g, layering), (0, $hIhW3.findType2Conflicts)(g, layering));
    const xss = {};
    let adjustedLayering = [];
    [
        'u',
        'd'
    ].forEach((vert)=>{
        adjustedLayering = vert === 'u' ? layering : Object.values(layering).reverse();
        [
            'l',
            'r'
        ].forEach((horiz)=>{
            if (horiz === 'r') adjustedLayering = adjustedLayering.map((inner)=>Object.values(inner).reverse());
            const neighborFn = (vert === 'u' ? g.getPredecessors : g.getSuccessors).bind(g);
            const align = (0, $hIhW3.verticalAlignment)(g, adjustedLayering, conflicts, neighborFn);
            const xs = (0, $hIhW3.horizontalCompaction)(g, adjustedLayering, align.root, align.align, nodesep, edgesep, horiz === 'r');
            if (horiz === 'r') Object.keys(xs).forEach((xsKey)=>xs[xsKey] = -xs[xsKey]);
            xss[vert + horiz] = xs;
        });
    });
    const smallestWidth = (0, $hIhW3.findSmallestWidthAlignment)(g, xss);
    smallestWidth && (0, $hIhW3.alignCoordinates)(xss, smallestWidth);
    return (0, $hIhW3.balance)(xss, graphAlign);
};
const $adab0893f0ddd6af$export$5880b8b5730aff45 = (g, options)=>{
    var _a;
    const ng = (0, $c1yiZ.asNonCompoundGraph)(g);
    $adab0893f0ddd6af$var$positionY(ng, options);
    const xs = $adab0893f0ddd6af$var$positionX(ng, options);
    (_a = Object.keys(xs)) === null || _a === void 0 || _a.forEach((key)=>{
        ng.getNode(key).data.x = xs[key];
    });
};

});
parcelRegister("hIhW3", function(module, exports) {

$parcel$export(module.exports, "findType1Conflicts", () => $ce54754d41155800$export$a2336058547dd16b);
$parcel$export(module.exports, "findType2Conflicts", () => $ce54754d41155800$export$f384d2f2a62cea4b);
$parcel$export(module.exports, "verticalAlignment", () => $ce54754d41155800$export$983b95e2e3722091);
$parcel$export(module.exports, "horizontalCompaction", () => $ce54754d41155800$export$40e1a979a22b42db);
$parcel$export(module.exports, "findSmallestWidthAlignment", () => $ce54754d41155800$export$870d8cbd39818c9);
$parcel$export(module.exports, "alignCoordinates", () => $ce54754d41155800$export$68444cc44dca9679);
$parcel$export(module.exports, "balance", () => $ce54754d41155800$export$13efda6d80c8a88);
/*
 * This module provides coordinate assignment based on Brandes and Köpf, "Fast
 * and Simple Horizontal Coordinate Assignment."
 */ 
var $fc2XC = parcelRequire("fc2XC");

var $c1yiZ = parcelRequire("c1yiZ");
const $ce54754d41155800$export$a2336058547dd16b = (g, layering)=>{
    const conflicts = {};
    const visitLayer = (prevLayer, layer)=>{
        // last visited node in the previous layer that is incident on an inner
        // segment.
        let k0 = 0;
        // Tracks the last node in this layer scanned for crossings with a type-1
        // segment.
        let scanPos = 0;
        const prevLayerLength = prevLayer.length;
        const lastNode = layer === null || layer === void 0 ? void 0 : layer[(layer === null || layer === void 0 ? void 0 : layer.length) - 1];
        layer === null || layer === void 0 || layer.forEach((v, i)=>{
            var _a;
            const w = $ce54754d41155800$export$3c5c9b7b489ac6ee(g, v);
            const k1 = w ? g.getNode(w.id).data.order : prevLayerLength;
            if (w || v === lastNode) {
                (_a = layer.slice(scanPos, i + 1)) === null || _a === void 0 || _a.forEach((scanNode)=>{
                    var _a;
                    (_a = g.getPredecessors(scanNode)) === null || _a === void 0 || _a.forEach((u)=>{
                        var _a;
                        const uLabel = g.getNode(u.id);
                        const uPos = uLabel.data.order;
                        if ((uPos < k0 || k1 < uPos) && !(uLabel.data.dummy && ((_a = g.getNode(scanNode)) === null || _a === void 0 ? void 0 : _a.data.dummy))) $ce54754d41155800$export$d6a30e6c78fac74(conflicts, u.id, scanNode);
                    });
                });
                scanPos = i + 1;
                k0 = k1;
            }
        });
        return layer;
    };
    if (layering === null || layering === void 0 ? void 0 : layering.length) layering.reduce(visitLayer);
    return conflicts;
};
const $ce54754d41155800$export$f384d2f2a62cea4b = (g, layering)=>{
    const conflicts = {};
    function scan(south, southPos, southEnd, prevNorthBorder, nextNorthBorder) {
        var _a, _b;
        let v;
        for(let i = southPos; i < southEnd; i++){
            v = south[i];
            if ((_a = g.getNode(v)) === null || _a === void 0 ? void 0 : _a.data.dummy) (_b = g.getPredecessors(v)) === null || _b === void 0 || _b.forEach((u)=>{
                const uNode = g.getNode(u.id);
                if (uNode.data.dummy && (uNode.data.order < prevNorthBorder || uNode.data.order > nextNorthBorder)) $ce54754d41155800$export$d6a30e6c78fac74(conflicts, u.id, v);
            });
        }
    }
    function getScannedKey(params) {
        // south数组可能很大，不适合做key
        return JSON.stringify(params.slice(1));
    }
    function scanIfNeeded(params, scanCache) {
        const cacheKey = getScannedKey(params);
        if (scanCache.get(cacheKey)) return;
        scan(...params);
        scanCache.set(cacheKey, true);
    }
    const visitLayer = (north, south)=>{
        let prevNorthPos = -1;
        let nextNorthPos;
        let southPos = 0;
        const scanned = new Map();
        south === null || south === void 0 || south.forEach((v, southLookahead)=>{
            var _a;
            if (((_a = g.getNode(v)) === null || _a === void 0 ? void 0 : _a.data.dummy) === 'border') {
                const predecessors = g.getPredecessors(v) || [];
                if (predecessors.length) {
                    nextNorthPos = g.getNode(predecessors[0].id).data.order;
                    scanIfNeeded([
                        south,
                        southPos,
                        southLookahead,
                        prevNorthPos,
                        nextNorthPos
                    ], scanned);
                    southPos = southLookahead;
                    prevNorthPos = nextNorthPos;
                }
            }
            scanIfNeeded([
                south,
                southPos,
                south.length,
                nextNorthPos,
                north.length
            ], scanned);
        });
        return south;
    };
    if (layering === null || layering === void 0 ? void 0 : layering.length) layering.reduce(visitLayer);
    return conflicts;
};
const $ce54754d41155800$export$3c5c9b7b489ac6ee = (g, v)=>{
    var _a, _b;
    if ((_a = g.getNode(v)) === null || _a === void 0 ? void 0 : _a.data.dummy) return (_b = g.getPredecessors(v)) === null || _b === void 0 ? void 0 : _b.find((u)=>g.getNode(u.id).data.dummy);
};
const $ce54754d41155800$export$d6a30e6c78fac74 = (conflicts, v, w)=>{
    let vv = v;
    let ww = w;
    if (vv > ww) {
        const tmp = vv;
        vv = ww;
        ww = tmp;
    }
    let conflictsV = conflicts[vv];
    if (!conflictsV) conflicts[vv] = conflictsV = {};
    conflictsV[ww] = true;
};
const $ce54754d41155800$export$76734886d09d2999 = (conflicts, v, w)=>{
    let vv = v;
    let ww = w;
    if (vv > ww) {
        const tmp = v;
        vv = ww;
        ww = tmp;
    }
    return !!conflicts[vv];
};
const $ce54754d41155800$export$983b95e2e3722091 = (g, layering, conflicts, neighborFn)=>{
    const root = {};
    const align = {};
    const pos = {};
    // We cache the position here based on the layering because the graph and
    // layering may be out of sync. The layering matrix is manipulated to
    // generate different extreme alignments.
    layering === null || layering === void 0 || layering.forEach((layer)=>{
        layer === null || layer === void 0 || layer.forEach((v, order)=>{
            root[v] = v;
            align[v] = v;
            pos[v] = order;
        });
    });
    layering === null || layering === void 0 || layering.forEach((layer)=>{
        let prevIdx = -1;
        layer === null || layer === void 0 || layer.forEach((v)=>{
            let ws = neighborFn(v).map((n)=>n.id);
            if (ws.length) {
                ws = ws.sort((a, b)=>pos[a] - pos[b]);
                const mp = (ws.length - 1) / 2;
                for(let i = Math.floor(mp), il = Math.ceil(mp); i <= il; ++i){
                    const w = ws[i];
                    if (align[v] === v && prevIdx < pos[w] && !$ce54754d41155800$export$76734886d09d2999(conflicts, v, w)) {
                        align[w] = v;
                        align[v] = root[v] = root[w];
                        prevIdx = pos[w];
                    }
                }
            }
        });
    });
    return {
        root: root,
        align: align
    };
};
const $ce54754d41155800$export$40e1a979a22b42db = (g, layering, root, align, nodesep, edgesep, reverseSep)=>{
    var _a;
    // This portion of the algorithm differs from BK due to a number of problems.
    // Instead of their algorithm we construct a new block graph and do two
    // sweeps. The first sweep places blocks with the smallest possible
    // coordinates. The second sweep removes unused space by moving blocks to the
    // greatest coordinates without violating separation.
    const xs = {};
    const blockG = $ce54754d41155800$export$1c98a49158fa9de5(g, layering, root, nodesep, edgesep, reverseSep);
    const borderType = reverseSep ? 'borderLeft' : 'borderRight';
    const iterate = (setXsFunc, nextNodesFunc)=>{
        let stack = blockG.getAllNodes();
        let elem = stack.pop();
        const visited = {};
        while(elem){
            if (visited[elem.id]) setXsFunc(elem.id);
            else {
                visited[elem.id] = true;
                stack.push(elem);
                stack = stack.concat(nextNodesFunc(elem.id));
            }
            elem = stack.pop();
        }
    };
    // First pass, assign smallest coordinates
    const pass1 = (elem)=>{
        xs[elem] = (blockG.getRelatedEdges(elem, 'in') || []).reduce((acc, e)=>{
            return Math.max(acc, (xs[e.source] || 0) + e.data.weight);
        }, 0);
    };
    // Second pass, assign greatest coordinates
    const pass2 = (elem)=>{
        const min = (blockG.getRelatedEdges(elem, 'out') || []).reduce((acc, e)=>{
            return Math.min(acc, (xs[e.target] || 0) - e.data.weight);
        }, Number.POSITIVE_INFINITY);
        const node = g.getNode(elem);
        if (min !== Number.POSITIVE_INFINITY && node.data.borderType !== borderType) xs[elem] = Math.max(xs[elem], min);
    };
    iterate(pass1, blockG.getPredecessors.bind(blockG));
    iterate(pass2, blockG.getSuccessors.bind(blockG));
    // Assign x coordinates to all nodes
    (_a = Object.values(align)) === null || _a === void 0 || _a.forEach((v)=>{
        xs[v] = xs[root[v]];
    });
    return xs;
};
const $ce54754d41155800$export$1c98a49158fa9de5 = (g, layering, root, nodesep, edgesep, reverseSep)=>{
    const blockGraph = new (0, $fc2XC.Graph)();
    const sepFn = $ce54754d41155800$export$5aee1a5bd9743d8f(nodesep, edgesep, reverseSep);
    layering === null || layering === void 0 || layering.forEach((layer)=>{
        let u;
        layer === null || layer === void 0 || layer.forEach((v)=>{
            const vRoot = root[v];
            if (!blockGraph.hasNode(vRoot)) blockGraph.addNode({
                id: vRoot,
                data: {}
            });
            if (u) {
                const uRoot = root[u];
                const edge = blockGraph.getRelatedEdges(uRoot, 'out').find((edge)=>edge.target === vRoot);
                if (!edge) blockGraph.addEdge({
                    id: `e${Math.random()}`,
                    source: uRoot,
                    target: vRoot,
                    data: {
                        weight: Math.max(sepFn(g, v, u), 0)
                    }
                });
                else blockGraph.updateEdgeData(edge.id, Object.assign(Object.assign({}, edge.data), {
                    weight: Math.max(sepFn(g, v, u), edge.data.weight || 0)
                }));
            }
            u = v;
        });
    });
    return blockGraph;
};
const $ce54754d41155800$export$870d8cbd39818c9 = (g, xss)=>{
    return (0, $c1yiZ.minBy)(Object.values(xss), (xs)=>{
        var _a;
        let max = Number.NEGATIVE_INFINITY;
        let min = Number.POSITIVE_INFINITY;
        (_a = Object.keys(xs)) === null || _a === void 0 || _a.forEach((v)=>{
            const x = xs[v];
            const halfWidth = $ce54754d41155800$export$7e3df82ee760448c(g, v) / 2;
            max = Math.max(x + halfWidth, max);
            min = Math.min(x - halfWidth, min);
        });
        return max - min;
    });
};
function $ce54754d41155800$export$68444cc44dca9679(xss, alignTo) {
    const alignToVals = Object.values(alignTo);
    const alignToMin = Math.min(...alignToVals);
    const alignToMax = Math.max(...alignToVals);
    [
        'u',
        'd'
    ].forEach((vert)=>{
        [
            'l',
            'r'
        ].forEach((horiz)=>{
            const alignment = vert + horiz;
            const xs = xss[alignment];
            let delta;
            if (xs === alignTo) return;
            const xsVals = Object.values(xs);
            delta = horiz === 'l' ? alignToMin - Math.min(...xsVals) : alignToMax - Math.max(...xsVals);
            if (delta) {
                xss[alignment] = {};
                Object.keys(xs).forEach((key)=>{
                    xss[alignment][key] = xs[key] + delta;
                });
            }
        });
    });
}
const $ce54754d41155800$export$13efda6d80c8a88 = (xss, align)=>{
    const result = {};
    Object.keys(xss.ul).forEach((key)=>{
        if (align) result[key] = xss[align.toLowerCase()][key];
        else {
            const values = Object.values(xss).map((x)=>x[key]);
            result[key] = (values[0] + values[1]) / 2; // (ur + ul) / 2
        }
    });
    return result;
};
const $ce54754d41155800$export$ec3af212ec314f01 = (g, options)=>{
    const { align: graphAlign, nodesep: nodesep = 0, edgesep: edgesep = 0 } = options || {};
    const layering = (0, $c1yiZ.buildLayerMatrix)(g);
    const conflicts = Object.assign($ce54754d41155800$export$a2336058547dd16b(g, layering), $ce54754d41155800$export$f384d2f2a62cea4b(g, layering));
    const xss = {};
    let adjustedLayering;
    [
        'u',
        'd'
    ].forEach((vert)=>{
        adjustedLayering = vert === 'u' ? layering : Object.values(layering).reverse();
        [
            'l',
            'r'
        ].forEach((horiz)=>{
            if (horiz === 'r') adjustedLayering = adjustedLayering.map((inner)=>Object.values(inner).reverse());
            const neighborFn = (vert === 'u' ? g.getPredecessors : g.getSuccessors).bind(g);
            const align = $ce54754d41155800$export$983b95e2e3722091(g, adjustedLayering, conflicts, neighborFn);
            const xs = $ce54754d41155800$export$40e1a979a22b42db(g, adjustedLayering, align.root, align.align, nodesep, edgesep, horiz === 'r');
            if (horiz === 'r') Object.keys(xs).forEach((key)=>{
                xs[key] = -xs[key];
            });
            xss[vert + horiz] = xs;
        });
    });
    const smallestWidth = $ce54754d41155800$export$870d8cbd39818c9(g, xss);
    $ce54754d41155800$export$68444cc44dca9679(xss, smallestWidth);
    return $ce54754d41155800$export$13efda6d80c8a88(xss, graphAlign);
};
const $ce54754d41155800$export$5aee1a5bd9743d8f = (nodeSep, edgeSep, reverseSep)=>{
    return (g, v, w)=>{
        const vLabel = g.getNode(v);
        const wLabel = g.getNode(w);
        let sum = 0;
        let delta = 0;
        sum += vLabel.data.width / 2;
        if (vLabel.data.hasOwnProperty('labelpos')) switch((vLabel.data.labelpos || '').toLowerCase()){
            case 'l':
                delta = -vLabel.data.width / 2;
                break;
            case 'r':
                delta = vLabel.data.width / 2;
                break;
        }
        if (delta) sum += reverseSep ? delta : -delta;
        delta = 0;
        sum += (vLabel.data.dummy ? edgeSep : nodeSep) / 2;
        sum += (wLabel.data.dummy ? edgeSep : nodeSep) / 2;
        sum += wLabel.data.width / 2;
        if (wLabel.data.labelpos) switch((wLabel.data.labelpos || '').toLowerCase()){
            case 'l':
                delta = wLabel.data.width / 2;
                break;
            case 'r':
                delta = -wLabel.data.width / 2;
                break;
        }
        if (delta) sum += reverseSep ? delta : -delta;
        delta = 0;
        return sum;
    };
};
const $ce54754d41155800$export$7e3df82ee760448c = (g, v)=>g.getNode(v).data.width || 0;

});


parcelRegister("7WQT7", function(module, exports) {

$parcel$export(module.exports, "rank", () => $5c96f9a9944401cf$export$fbc8bcd33b574fbc);

var $7DBmw = parcelRequire("7DBmw");

var $l9rBP = parcelRequire("l9rBP");

var $au360 = parcelRequire("au360");
const $5c96f9a9944401cf$export$fbc8bcd33b574fbc = (g, ranker)=>{
    switch(ranker){
        case 'network-simplex':
            $5c96f9a9944401cf$var$networkSimplexRanker(g);
            break;
        case 'tight-tree':
            $5c96f9a9944401cf$var$tightTreeRanker(g);
            break;
        case 'longest-path':
            $5c96f9a9944401cf$var$longestPathRanker(g);
            break;
        // default: networkSimplexRanker(g);
        default:
            $5c96f9a9944401cf$var$tightTreeRanker(g);
    }
};
// A fast and simple ranker, but results are far from optimal.
const $5c96f9a9944401cf$var$longestPathRanker = (0, $au360.longestPath);
const $5c96f9a9944401cf$var$tightTreeRanker = (g)=>{
    (0, $au360.longestPathWithLayer)(g);
    (0, $7DBmw.feasibleTreeWithLayer)(g);
};
const $5c96f9a9944401cf$var$networkSimplexRanker = (g)=>{
    (0, $l9rBP.networkSimplex)(g);
};

});
parcelRegister("7DBmw", function(module, exports) {

$parcel$export(module.exports, "feasibleTree", () => $58f9284a48cc477f$export$1d03f990b5f20c77);
$parcel$export(module.exports, "feasibleTreeWithLayer", () => $58f9284a48cc477f$export$1db489075cbdd4);

var $fc2XC = parcelRequire("fc2XC");

var $c1yiZ = parcelRequire("c1yiZ");

var $au360 = parcelRequire("au360");
/*
 * Constructs a spanning tree with tight edges and adjusted the input node's
 * ranks to achieve this. A tight edge is one that is has a length that matches
 * its "minlen" attribute.
 *
 * The basic structure for this function is derived from Gansner, et al., "A
 * Technique for Drawing Directed Graphs."
 *
 * Pre-conditions:
 *
 *    1. Graph must be a DAG.
 *    2. Graph must be connected.
 *    3. Graph must have at least one node.
 *    5. Graph nodes must have been previously assigned a "rank" property that
 *       respects the "minlen" property of incident edges.
 *    6. Graph edges must have a "minlen" property.
 *
 * Post-conditions:
 *
 *    - Graph nodes will have their rank adjusted to ensure that all edges are
 *      tight.
 *
 * Returns a tree (undirected graph) that is constructed using only "tight"
 * edges.
 */ const $58f9284a48cc477f$export$1d03f990b5f20c77 = (g)=>{
    const t = new (0, $fc2XC.Graph)({
        tree: []
    });
    // Choose arbitrary node from which to start our tree
    const start = g.getAllNodes()[0];
    const size = g.getAllNodes().length;
    t.addNode(start);
    let edge;
    let delta;
    while($58f9284a48cc477f$var$tightTree(t, g) < size){
        edge = $58f9284a48cc477f$var$findMinSlackEdge(t, g);
        delta = t.hasNode(edge.source) ? (0, $au360.slack)(g, edge) : -(0, $au360.slack)(g, edge);
        $58f9284a48cc477f$var$shiftRanks(t, g, delta);
    }
    return t;
};
/*
 * Finds a maximal tree of tight edges and returns the number of nodes in the
 * tree.
 */ const $58f9284a48cc477f$var$tightTree = (t, g)=>{
    const dfs = (v)=>{
        g.getRelatedEdges(v, 'both').forEach((e)=>{
            const edgeV = e.source;
            const w = v === edgeV ? e.target : edgeV;
            if (!t.hasNode(w) && !(0, $au360.slack)(g, e)) {
                t.addNode({
                    id: w,
                    data: {}
                });
                t.addEdge({
                    id: e.id,
                    source: v,
                    target: w,
                    data: {}
                });
                dfs(w);
            }
        });
    };
    t.getAllNodes().forEach((n)=>dfs(n.id));
    return t.getAllNodes().length;
};
/*
 * Constructs a spanning tree with tight edges and adjusted the input node's
 * ranks to achieve this. A tight edge is one that is has a length that matches
 * its "minlen" attribute.
 *
 * The basic structure for this function is derived from Gansner, et al., "A
 * Technique for Drawing Directed Graphs."
 *
 * Pre-conditions:
 *
 *    1. Graph must be a DAG.
 *    2. Graph must be connected.
 *    3. Graph must have at least one node.
 *    5. Graph nodes must have been previously assigned a "rank" property that
 *       respects the "minlen" property of incident edges.
 *    6. Graph edges must have a "minlen" property.
 *
 * Post-conditions:
 *
 *    - Graph nodes will have their rank adjusted to ensure that all edges are
 *      tight.
 *
 * Returns a tree (undirected graph) that is constructed using only "tight"
 * edges.
 */ const $58f9284a48cc477f$export$1db489075cbdd4 = (g)=>{
    const t = new (0, $fc2XC.Graph)({
        tree: []
    });
    // Choose arbitrary node from which to start our tree
    const start = g.getAllNodes()[0];
    const size = g.getAllNodes().length;
    t.addNode(start);
    let edge;
    let delta;
    while($58f9284a48cc477f$var$tightTreeWithLayer(t, g) < size){
        edge = $58f9284a48cc477f$var$findMinSlackEdge(t, g);
        delta = t.hasNode(edge.source) ? (0, $au360.slack)(g, edge) : -(0, $au360.slack)(g, edge);
        $58f9284a48cc477f$var$shiftRanks(t, g, delta);
    }
    return t;
};
/*
 * Finds a maximal tree of tight edges and returns the number of nodes in the
 * tree.
 */ const $58f9284a48cc477f$var$tightTreeWithLayer = (t, g)=>{
    const dfs = (v)=>{
        var _a;
        (_a = g.getRelatedEdges(v, 'both')) === null || _a === void 0 || _a.forEach((e)=>{
            const edgeV = e.source;
            const w = v === edgeV ? e.target : edgeV;
            // 对于指定layer的，直接加入tight-tree，不参与调整
            if (!t.hasNode(w) && (g.getNode(w).data.layer !== undefined || !(0, $au360.slack)(g, e))) {
                t.addNode({
                    id: w,
                    data: {}
                });
                t.addEdge({
                    id: e.id,
                    source: v,
                    target: w,
                    data: {}
                });
                dfs(w);
            }
        });
    };
    t.getAllNodes().forEach((n)=>dfs(n.id));
    return t.getAllNodes().length;
};
/*
 * Finds the edge with the smallest slack that is incident on tree and returns
 * it.
 */ const $58f9284a48cc477f$var$findMinSlackEdge = (t, g)=>{
    return (0, $c1yiZ.minBy)(g.getAllEdges(), (e)=>{
        if (t.hasNode(e.source) !== t.hasNode(e.target)) return (0, $au360.slack)(g, e);
        return Infinity;
    });
};
const $58f9284a48cc477f$var$shiftRanks = (t, g, delta)=>{
    t.getAllNodes().forEach((tn)=>{
        const v = g.getNode(tn.id);
        if (!v.data.rank) v.data.rank = 0;
        v.data.rank += delta;
    });
};

});
parcelRegister("au360", function(module, exports) {

$parcel$export(module.exports, "longestPath", () => $7a1f1b845c270b21$export$cebe150c9dd2da2e);
$parcel$export(module.exports, "longestPathWithLayer", () => $7a1f1b845c270b21$export$837d78d6ca62db5a);
$parcel$export(module.exports, "slack", () => $7a1f1b845c270b21$export$3748e8b0e9529e9c);
/*
 * Initializes ranks for the input graph using the longest path algorithm. This
 * algorithm scales well and is fast in practice, it yields rather poor
 * solutions. Nodes are pushed to the lowest layer possible, leaving the bottom
 * ranks wide and leaving edges longer than necessary. However, due to its
 * speed, this algorithm is good for getting an initial ranking that can be fed
 * into other algorithms.
 *
 * This algorithm does not normalize layers because it will be used by other
 * algorithms in most cases. If using this algorithm directly, be sure to
 * run normalize at the end.
 *
 * Pre-conditions:
 *
 *    1. Input graph is a DAG.
 *    2. Input graph node labels can be assigned properties.
 *
 * Post-conditions:
 *
 *    1. Each node will be assign an (unnormalized) "rank" property.
 */ const $7a1f1b845c270b21$export$cebe150c9dd2da2e = (g)=>{
    const visited = {};
    const dfs = (v)=>{
        var _a;
        const label = g.getNode(v);
        if (!label) return 0;
        if (visited[v]) return label.data.rank;
        visited[v] = true;
        let rank;
        (_a = g.getRelatedEdges(v, 'out')) === null || _a === void 0 || _a.forEach((e)=>{
            const wRank = dfs(e.target);
            const minLen = e.data.minlen;
            const r = wRank - minLen;
            if (r) {
                if (rank === undefined || r < rank) rank = r;
            }
        });
        if (!rank) rank = 0;
        label.data.rank = rank;
        return rank;
    };
    g.getAllNodes().filter((n)=>g.getRelatedEdges(n.id, 'in').length === 0).forEach((source)=>dfs(source.id));
};
const $7a1f1b845c270b21$export$837d78d6ca62db5a = (g)=>{
    // 用longest path，找出最深的点
    const visited = {};
    let minRank;
    const dfs = (v)=>{
        var _a;
        const label = g.getNode(v);
        if (!label) return 0;
        if (visited[v]) return label.data.rank;
        visited[v] = true;
        let rank;
        (_a = g.getRelatedEdges(v, 'out')) === null || _a === void 0 || _a.forEach((e)=>{
            const wRank = dfs(e.target);
            const minLen = e.data.minlen;
            const r = wRank - minLen;
            if (r) {
                if (rank === undefined || r < rank) rank = r;
            }
        });
        if (!rank) rank = 0;
        if (minRank === undefined || rank < minRank) minRank = rank;
        label.data.rank = rank;
        return rank;
    };
    g.getAllNodes().filter((n)=>g.getRelatedEdges(n.id, 'in').length === 0).forEach((source)=>{
        if (source) dfs(source.id);
    });
    if (minRank === undefined) minRank = 0;
    // minRank += 1; // NOTE: 最小的层级是dummy root，+1
    // forward一遍，赋值层级
    const forwardVisited = {};
    const dfsForward = (v, nextRank)=>{
        var _a;
        const label = g.getNode(v);
        const currRank = !isNaN(label.data.layer) ? label.data.layer : nextRank;
        // 没有指定，取最大值
        if (label.data.rank === undefined || label.data.rank < currRank) label.data.rank = currRank;
        if (forwardVisited[v]) return;
        forwardVisited[v] = true;
        // DFS遍历子节点
        (_a = g.getRelatedEdges(v, 'out')) === null || _a === void 0 || _a.forEach((e)=>{
            dfsForward(e.target, currRank + e.data.minlen);
        });
    };
    // 指定层级的，更新下游
    g.getAllNodes().forEach((n)=>{
        const label = n.data;
        if (!label) return;
        if (!isNaN(label.layer)) dfsForward(n.id, label.layer); // 默认的dummy root所在层的rank是-1
        else label.rank -= minRank;
    });
};
/*
 * Returns the amount of slack for the given edge. The slack is defined as the
 * difference between the length of the edge and its minimum length.
 */ const $7a1f1b845c270b21$export$3748e8b0e9529e9c = (g, e)=>{
    return g.getNode(e.target).data.rank - g.getNode(e.source).data.rank - e.data.minlen;
};

});


parcelRegister("l9rBP", function(module, exports) {

$parcel$export(module.exports, "networkSimplex", () => $f65fdadab7ec82ed$export$fb928ed1fa9faa94);

var $c1yiZ = parcelRequire("c1yiZ");

var $7DBmw = parcelRequire("7DBmw");

var $au360 = parcelRequire("au360");
const $f65fdadab7ec82ed$export$fb928ed1fa9faa94 = (og)=>{
    const g = (0, $c1yiZ.simplify)(og);
    (0, $au360.longestPath)(g);
    const t = (0, $7DBmw.feasibleTree)(g);
    $f65fdadab7ec82ed$export$cd95219fca51d6fa(t);
    $f65fdadab7ec82ed$export$124e51299b9d9c89(t, g);
    let e;
    let f;
    while(e = $f65fdadab7ec82ed$export$43036cc3e8211896(t)){
        f = $f65fdadab7ec82ed$export$7df03ef35ad8e1f8(t, g, e);
        $f65fdadab7ec82ed$export$f29e43b66b35aab7(t, g, e, f);
    }
};
const $f65fdadab7ec82ed$export$124e51299b9d9c89 = (t, g)=>{
    let vs = (0, $c1yiZ.dfs)(t, t.getAllNodes(), 'post', false);
    vs = vs.slice(0, (vs === null || vs === void 0 ? void 0 : vs.length) - 1);
    vs.forEach((v)=>{
        $f65fdadab7ec82ed$var$assignCutValue(t, g, v);
    });
};
const $f65fdadab7ec82ed$var$assignCutValue = (t, g, child)=>{
    const childLab = t.getNode(child);
    const parent = childLab.data.parent;
    // FIXME: use undirected edge?
    const edge = t.getRelatedEdges(child, 'both').find((e)=>e.target === parent || e.source === parent);
    edge.data.cutvalue = $f65fdadab7ec82ed$export$36e827898034dd48(t, g, child);
};
const $f65fdadab7ec82ed$export$36e827898034dd48 = (t, g, child)=>{
    const childLab = t.getNode(child);
    const parent = childLab.data.parent;
    // True if the child is on the tail end of the edge in the directed graph
    let childIsTail = true;
    // The graph's view of the tree edge we're inspecting
    let graphEdge = g.getRelatedEdges(child, 'out').find((e)=>e.target === parent);
    // The accumulated cut value for the edge between this node and its parent
    let cutValue = 0;
    if (!graphEdge) {
        childIsTail = false;
        graphEdge = g.getRelatedEdges(parent, 'out').find((e)=>e.target === child);
    }
    cutValue = graphEdge.data.weight;
    g.getRelatedEdges(child, 'both').forEach((e)=>{
        const isOutEdge = e.source === child;
        const other = isOutEdge ? e.target : e.source;
        if (other !== parent) {
            const pointsToHead = isOutEdge === childIsTail;
            const otherWeight = e.data.weight;
            cutValue += pointsToHead ? otherWeight : -otherWeight;
            if ($f65fdadab7ec82ed$var$isTreeEdge(t, child, other)) {
                // FIXME: use undirected edge?
                const otherCutValue = t.getRelatedEdges(child, 'both').find((e)=>e.source === other || e.target === other).data.cutvalue;
                cutValue += pointsToHead ? -otherCutValue : otherCutValue;
            }
        }
    });
    return cutValue;
};
const $f65fdadab7ec82ed$export$cd95219fca51d6fa = (tree, root = tree.getAllNodes()[0].id)=>{
    $f65fdadab7ec82ed$var$dfsAssignLowLim(tree, {}, 1, root);
};
const $f65fdadab7ec82ed$var$dfsAssignLowLim = (tree, visited, nextLim, v, parent)=>{
    var _a;
    const low = nextLim;
    let useNextLim = nextLim;
    const label = tree.getNode(v);
    visited[v] = true;
    (_a = tree.getNeighbors(v)) === null || _a === void 0 || _a.forEach((w)=>{
        if (!visited[w.id]) useNextLim = $f65fdadab7ec82ed$var$dfsAssignLowLim(tree, visited, useNextLim, w.id, v);
    });
    label.data.low = low;
    label.data.lim = useNextLim++;
    if (parent) label.data.parent = parent;
    else // TODO should be able to remove this when we incrementally update low lim
    delete label.data.parent;
    return useNextLim;
};
const $f65fdadab7ec82ed$export$43036cc3e8211896 = (tree)=>{
    return tree.getAllEdges().find((e)=>{
        return e.data.cutvalue < 0;
    });
};
const $f65fdadab7ec82ed$export$7df03ef35ad8e1f8 = (t, g, edge)=>{
    let v = edge.source;
    let w = edge.target;
    // For the rest of this function we assume that v is the tail and w is the
    // head, so if we don't have this edge in the graph we should flip it to
    // match the correct orientation.
    if (!g.getRelatedEdges(v, 'out').find((e)=>e.target === w)) {
        v = edge.target;
        w = edge.source;
    }
    const vLabel = t.getNode(v);
    const wLabel = t.getNode(w);
    let tailLabel = vLabel;
    let flip = false;
    // If the root is in the tail of the edge then we need to flip the logic that
    // checks for the head and tail nodes in the candidates function below.
    if (vLabel.data.lim > wLabel.data.lim) {
        tailLabel = wLabel;
        flip = true;
    }
    const candidates = g.getAllEdges().filter((edge)=>{
        return flip === $f65fdadab7ec82ed$var$isDescendant(t.getNode(edge.source), tailLabel) && flip !== $f65fdadab7ec82ed$var$isDescendant(t.getNode(edge.target), tailLabel);
    });
    return (0, $c1yiZ.minBy)(candidates, (edge)=>{
        return (0, $au360.slack)(g, edge);
    });
};
const $f65fdadab7ec82ed$export$f29e43b66b35aab7 = (t, g, e, f)=>{
    // FIXME: use undirected edge?
    const existed = t.getRelatedEdges(e.source, 'both').find((edge)=>edge.source === e.target || edge.target === e.target);
    if (existed) t.removeEdge(existed.id);
    t.addEdge({
        id: `e${Math.random()}`,
        source: f.source,
        target: f.target,
        data: {}
    });
    $f65fdadab7ec82ed$export$cd95219fca51d6fa(t);
    $f65fdadab7ec82ed$export$124e51299b9d9c89(t, g);
    $f65fdadab7ec82ed$var$updateRanks(t, g);
};
const $f65fdadab7ec82ed$var$updateRanks = (t, g)=>{
    const root = t.getAllNodes().find((v)=>{
        return !v.data.parent;
    });
    let vs = (0, $c1yiZ.dfs)(t, root, 'pre', false);
    vs = vs.slice(1);
    vs.forEach((v)=>{
        const parent = t.getNode(v).data.parent;
        let edge = g.getRelatedEdges(v, 'out').find((e)=>e.target === parent);
        // let edge = g.edgeFromArgs(v, parent);
        let flipped = false;
        if (!edge && g.hasNode(parent)) {
            // edge = g.edgeFromArgs(parent, v)!;
            edge = g.getRelatedEdges(parent, 'out').find((e)=>e.target === v);
            flipped = true;
        }
        g.getNode(v).data.rank = (g.hasNode(parent) && g.getNode(parent).data.rank || 0) + (flipped ? edge === null || edge === void 0 ? void 0 : edge.data.minlen : -(edge === null || edge === void 0 ? void 0 : edge.data.minlen));
    });
};
/*
 * Returns true if the edge is in the tree.
 */ const $f65fdadab7ec82ed$var$isTreeEdge = (tree, u, v)=>{
    // FIXME: use undirected edge?
    return tree.getRelatedEdges(u, 'both').find((e)=>e.source === v || e.target === v);
};
/*
 * Returns true if the specified node is descendant of the root node per the
 * assigned low and lim attributes in the tree.
 */ const $f65fdadab7ec82ed$var$isDescendant = (vLabel, rootLabel)=>{
    return rootLabel.data.low <= vLabel.data.lim && vLabel.data.lim <= rootLabel.data.lim;
};

});



parcelRegister("9nuNf", function(module, exports) {

$parcel$export(module.exports, "cloneFormatData", () => $6d3e25ed2f26e1b7$export$8630667bbca04569);

var $jyI49 = parcelRequire("jyI49");
const $6d3e25ed2f26e1b7$export$9cd59f9826255e47 = (target)=>{
    if (target === null) return target;
    if (target instanceof Date) return new Date(target.getTime());
    if (target instanceof Array) {
        const cp = [];
        target.forEach((v)=>{
            cp.push(v);
        });
        return cp.map((n)=>$6d3e25ed2f26e1b7$export$9cd59f9826255e47(n));
    }
    if (typeof target === 'object') {
        const cp = {};
        Object.keys(target).forEach((k)=>{
            cp[k] = $6d3e25ed2f26e1b7$export$9cd59f9826255e47(target[k]);
        });
        return cp;
    }
    return target;
};
const $6d3e25ed2f26e1b7$export$8630667bbca04569 = (target, initRange)=>{
    const cloned = $6d3e25ed2f26e1b7$export$9cd59f9826255e47(target);
    cloned.data = cloned.data || {};
    if (initRange) {
        if (!(0, $jyI49.default)(cloned.data.x)) cloned.data.x = Math.random() * initRange[0];
        if (!(0, $jyI49.default)(cloned.data.y)) cloned.data.y = Math.random() * initRange[1];
    }
    return cloned;
};

});

parcelRegister("9RkJR", function(module, exports) {

$parcel$export(module.exports, "formatNumberFn", () => $72d92691a4e44a47$export$54ea943624daf252);
$parcel$export(module.exports, "formatSizeFn", () => $72d92691a4e44a47$export$dbd46949b4b9980d);
$parcel$export(module.exports, "formatNodeSizeToNumber", () => $72d92691a4e44a47$export$3a7a80b0f3334abe);

var $ky7aH = parcelRequire("ky7aH");
var $jyI49 = parcelRequire("jyI49");
var $6JKSc = parcelRequire("6JKSc");

var $lKWgx = parcelRequire("lKWgx");
function $72d92691a4e44a47$export$54ea943624daf252(defaultValue, value) {
    let resultFunc;
    if ((0, $ky7aH.default)(value)) resultFunc = value;
    else if ((0, $jyI49.default)(value)) // value is number
    resultFunc = ()=>value;
    else // value is not number and function
    resultFunc = ()=>defaultValue;
    return resultFunc;
}
function $72d92691a4e44a47$export$dbd46949b4b9980d(defaultValue, value, resultIsNumber = true) {
    if (!value && value !== 0) return (d)=>{
        const { size: size } = d.data || {};
        if (size) {
            if (Array.isArray(size)) return resultIsNumber ? Math.max(...size) || defaultValue : size;
            if ((0, $6JKSc.default)(size) && size.width && size.height) return resultIsNumber ? Math.max(size.width, size.height) || defaultValue : [
                size.width,
                size.height
            ];
            return size;
        }
        return defaultValue;
    };
    if ((0, $ky7aH.default)(value)) return value;
    if ((0, $jyI49.default)(value)) return ()=>value;
    if (Array.isArray(value)) return ()=>{
        if (resultIsNumber) return Math.max(...value) || defaultValue;
        return value;
    };
    if ((0, $6JKSc.default)(value) && value.width && value.height) return ()=>{
        if (resultIsNumber) return Math.max(value.width, value.height) || defaultValue;
        return [
            value.width,
            value.height
        ];
    };
    return ()=>defaultValue;
}
const $72d92691a4e44a47$export$3a7a80b0f3334abe = (nodeSize, nodeSpacing, defaultNodeSize = 10)=>{
    let nodeSizeFunc;
    const nodeSpacingFunc = typeof nodeSpacing === 'function' ? nodeSpacing : ()=>nodeSpacing || 0;
    if (!nodeSize) nodeSizeFunc = (d)=>{
        var _a, _b, _c;
        if ((_a = d.data) === null || _a === void 0 ? void 0 : _a.bboxSize) return (_b = d.data) === null || _b === void 0 ? void 0 : _b.bboxSize;
        if ((_c = d.data) === null || _c === void 0 ? void 0 : _c.size) {
            const dataSize = d.data.size;
            if (Array.isArray(dataSize)) return dataSize;
            if ((0, $6JKSc.default)(dataSize)) return [
                dataSize.width,
                dataSize.height
            ];
            return dataSize;
        }
        return defaultNodeSize;
    };
    else if (Array.isArray(nodeSize)) nodeSizeFunc = (d)=>nodeSize;
    else if ((0, $ky7aH.default)(nodeSize)) nodeSizeFunc = nodeSize;
    else nodeSizeFunc = (d)=>nodeSize;
    const func = (d)=>{
        const nodeSize = nodeSizeFunc(d);
        const nodeSpacing = nodeSpacingFunc(d);
        return Math.max(...(0, $lKWgx.parseSize)(nodeSize)) + nodeSpacing;
    };
    return func;
};

});
parcelRegister("lKWgx", function(module, exports) {

$parcel$export(module.exports, "parseSize", () => $fd6b1738e6834536$export$880c59a0ae1158a1);

var $jyI49 = parcelRequire("jyI49");
function $fd6b1738e6834536$export$880c59a0ae1158a1(size) {
    if (!size) return [
        0,
        0,
        0
    ];
    if ((0, $jyI49.default)(size)) return [
        size,
        size,
        size
    ];
    else if (size.length === 0) return [
        0,
        0,
        0
    ];
    const [x, y = x, z = x] = size;
    return [
        x,
        y,
        z
    ];
}

});



parcelRegister("1IlsW", function(module, exports) {

$parcel$export(module.exports, "CircularLayout", () => $13fa8d2e627daa0b$export$59c1a03c0095767a);

var $7WQrb = parcelRequire("7WQrb");

var $9nuNf = parcelRequire("9nuNf");
var $9RkJR = parcelRequire("9RkJR");

var $5Rnio = parcelRequire("5Rnio");
const $13fa8d2e627daa0b$var$DEFAULTS_LAYOUT_OPTIONS = {
    radius: null,
    startRadius: null,
    endRadius: null,
    startAngle: 0,
    endAngle: 2 * Math.PI,
    clockwise: true,
    divisions: 1,
    ordering: null,
    angleRatio: 1
};
class $13fa8d2e627daa0b$export$59c1a03c0095767a {
    constructor(options = {}){
        this.options = options;
        this.id = 'circular';
        this.options = Object.assign(Object.assign({}, $13fa8d2e627daa0b$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericCircularLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericCircularLayout(true, graph, options);
        });
    }
    genericCircularLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const mergedOptions = Object.assign(Object.assign({}, this.options), options);
            const { width: width, height: height, center: center, divisions: divisions, startAngle: startAngle = 0, endAngle: endAngle = 2 * Math.PI, angleRatio: angleRatio, ordering: ordering, clockwise: clockwise, nodeSpacing: paramNodeSpacing, nodeSize: paramNodeSize } = mergedOptions;
            const nodes = graph.getAllNodes();
            const edges = graph.getAllEdges();
            // Calculate center according to `window` if not provided.
            const [calculatedWidth, calculatedHeight, calculatedCenter] = $13fa8d2e627daa0b$var$calculateCenter(width, height, center);
            const n = nodes === null || nodes === void 0 ? void 0 : nodes.length;
            if (!n || n === 1) return (0, $5Rnio.handleSingleNodeGraph)(graph, assign, calculatedCenter);
            const angleStep = (endAngle - startAngle) / n;
            let { radius: radius, startRadius: startRadius, endRadius: endRadius } = mergedOptions;
            if (paramNodeSpacing) {
                const nodeSpacing = (0, $9RkJR.formatNumberFn)(10, paramNodeSpacing);
                const nodeSize = (0, $9RkJR.formatSizeFn)(10, paramNodeSize);
                let maxNodeSize = -Infinity;
                nodes.forEach((node)=>{
                    const nSize = nodeSize(node);
                    if (maxNodeSize < nSize) maxNodeSize = nSize;
                });
                let perimeter = 0;
                nodes.forEach((node, i)=>{
                    if (i === 0) perimeter += maxNodeSize || 10;
                    else perimeter += (nodeSpacing(node) || 0) + (maxNodeSize || 10);
                });
                radius = perimeter / (2 * Math.PI);
            } else if (!radius && !startRadius && !endRadius) radius = Math.min(calculatedHeight, calculatedWidth) / 2;
            else if (!startRadius && endRadius) startRadius = endRadius;
            else if (startRadius && !endRadius) endRadius = startRadius;
            const astep = angleStep * angleRatio;
            // calculated nodes as temporary result
            let layoutNodes = [];
            if (ordering === 'topology') // layout according to the topology
            layoutNodes = $13fa8d2e627daa0b$var$topologyOrdering(graph, nodes);
            else if (ordering === 'topology-directed') // layout according to the topology
            layoutNodes = $13fa8d2e627daa0b$var$topologyOrdering(graph, nodes, true);
            else if (ordering === 'degree') // layout according to the descent order of degrees
            layoutNodes = $13fa8d2e627daa0b$var$degreeOrdering(graph, nodes);
            else // layout according to the original order in the data.nodes
            layoutNodes = nodes.map((node)=>(0, $9nuNf.cloneFormatData)(node));
            const divN = Math.ceil(n / divisions); // node number in each division
            for(let i = 0; i < n; ++i){
                let r = radius;
                if (!r && startRadius !== null && endRadius !== null) r = startRadius + i * (endRadius - startRadius) / (n - 1);
                if (!r) r = 10 + i * 100 / (n - 1);
                let angle = startAngle + i % divN * astep + 2 * Math.PI / divisions * Math.floor(i / divN);
                if (!clockwise) angle = endAngle - i % divN * astep - 2 * Math.PI / divisions * Math.floor(i / divN);
                layoutNodes[i].data.x = calculatedCenter[0] + Math.cos(angle) * r;
                layoutNodes[i].data.y = calculatedCenter[1] + Math.sin(angle) * r;
            }
            if (assign) layoutNodes.forEach((node)=>{
                graph.mergeNodeData(node.id, {
                    x: node.data.x,
                    y: node.data.y
                });
            });
            const result = {
                nodes: layoutNodes,
                edges: edges
            };
            return result;
        });
    }
}
/**
 * order the nodes acoording to the graph topology
 * @param graph
 * @param nodes
 * @param directed
 * @returns
 */ const $13fa8d2e627daa0b$var$topologyOrdering = (graph, nodes, directed = false)=>{
    const orderedCNodes = [
        (0, $9nuNf.cloneFormatData)(nodes[0])
    ];
    const pickFlags = {};
    const n = nodes.length;
    pickFlags[nodes[0].id] = true;
    // write children into cnodes
    let k = 0;
    nodes.forEach((node, i)=>{
        if (i !== 0) {
            if ((i === n - 1 || graph.getDegree(node.id, 'both') !== graph.getDegree(nodes[i + 1].id, 'both') || graph.areNeighbors(orderedCNodes[k].id, node.id)) && !pickFlags[node.id]) {
                orderedCNodes.push((0, $9nuNf.cloneFormatData)(node));
                pickFlags[node.id] = true;
                k++;
            } else {
                const children = directed ? graph.getSuccessors(orderedCNodes[k].id) : graph.getNeighbors(orderedCNodes[k].id);
                let foundChild = false;
                for(let j = 0; j < children.length; j++){
                    const child = children[j];
                    if (graph.getDegree(child.id) === graph.getDegree(node.id) && !pickFlags[child.id]) {
                        orderedCNodes.push((0, $9nuNf.cloneFormatData)(child));
                        pickFlags[child.id] = true;
                        foundChild = true;
                        break;
                    }
                }
                let ii = 0;
                while(!foundChild){
                    if (!pickFlags[nodes[ii].id]) {
                        orderedCNodes.push((0, $9nuNf.cloneFormatData)(nodes[ii]));
                        pickFlags[nodes[ii].id] = true;
                        foundChild = true;
                    }
                    ii++;
                    if (ii === n) break;
                }
            }
        }
    });
    return orderedCNodes;
};
/**
 * order the nodes according to their degree
 * @param graph
 * @param nodes
 * @returns
 */ function $13fa8d2e627daa0b$var$degreeOrdering(graph, nodes) {
    const orderedNodes = [];
    nodes.forEach((node, i)=>{
        orderedNodes.push((0, $9nuNf.cloneFormatData)(node));
    });
    orderedNodes.sort((nodeA, nodeB)=>graph.getDegree(nodeA.id, 'both') - graph.getDegree(nodeB.id, 'both'));
    return orderedNodes;
}
/**
 * format the invalide width and height, and get the center position
 * @param width
 * @param height
 * @param center
 * @returns
 */ const $13fa8d2e627daa0b$var$calculateCenter = (width, height, center)=>{
    let calculatedWidth = width;
    let calculatedHeight = height;
    let calculatedCenter = center;
    if (!calculatedWidth && typeof window !== 'undefined') calculatedWidth = window.innerWidth;
    if (!calculatedHeight && typeof window !== 'undefined') calculatedHeight = window.innerHeight;
    if (!calculatedCenter) calculatedCenter = [
        calculatedWidth / 2,
        calculatedHeight / 2
    ];
    return [
        calculatedWidth,
        calculatedHeight,
        calculatedCenter
    ];
};

});
parcelRegister("5Rnio", function(module, exports) {

$parcel$export(module.exports, "handleSingleNodeGraph", () => $4443f90aa1f6e7e7$export$3f5334baeb17ae93);
/**
 * Assign or only return the result for the graph who has no nodes or only one node.
 * @param graph original graph
 * @param assign whether assign result to original graph
 * @param center the layout center
 * @returns
 */ const $4443f90aa1f6e7e7$export$3f5334baeb17ae93 = (graph, assign, center)=>{
    const nodes = graph.getAllNodes();
    const edges = graph.getAllEdges();
    if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length)) {
        const result = {
            nodes: [],
            edges: edges
        };
        return result;
    }
    if (nodes.length === 1) {
        if (assign) graph.mergeNodeData(nodes[0].id, {
            x: center[0],
            y: center[1]
        });
        const result = {
            nodes: [
                Object.assign(Object.assign({}, nodes[0]), {
                    data: Object.assign(Object.assign({}, nodes[0].data), {
                        x: center[0],
                        y: center[1]
                    })
                })
            ],
            edges: edges
        };
        return result;
    }
};

});


parcelRegister("5n8Ib", function(module, exports) {

$parcel$export(module.exports, "ComboCombinedLayout", () => $3e95dbab0102a3a5$export$a8b67f22f5576612);

var $7WQrb = parcelRequire("7WQrb");

var $fc2XC = parcelRequire("fc2XC");

var $ky7aH = parcelRequire("ky7aH");
var $jyI49 = parcelRequire("jyI49");
var $6JKSc = parcelRequire("6JKSc");

var $kd0OI = parcelRequire("kd0OI");

var $irTWF = parcelRequire("irTWF");

var $k9H1V = parcelRequire("k9H1V");

var $g98sr = parcelRequire("g98sr");

var $8e7dj = parcelRequire("8e7dj");
var $hHwGT = parcelRequire("hHwGT");

var $5Rnio = parcelRequire("5Rnio");
const $3e95dbab0102a3a5$var$FORCE_LAYOUT_TYPE_MAP = {
    gForce: true,
    force2: true,
    d3force: true,
    fruchterman: true,
    forceAtlas2: true,
    force: true,
    'graphin-force': true
};
const $3e95dbab0102a3a5$var$DEFAULTS_LAYOUT_OPTIONS = {
    center: [
        0,
        0
    ],
    comboPadding: 10,
    treeKey: 'combo'
};
class $3e95dbab0102a3a5$export$a8b67f22f5576612 {
    constructor(options = {}){
        this.options = options;
        this.id = 'comboCombined';
        this.options = Object.assign(Object.assign({}, $3e95dbab0102a3a5$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericComboCombinedLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericComboCombinedLayout(true, graph, options);
        });
    }
    genericComboCombinedLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const mergedOptions = this.initVals(Object.assign(Object.assign({}, this.options), options));
            const { center: center, treeKey: treeKey, outerLayout: propsOuterLayout } = mergedOptions;
            const nodes = graph.getAllNodes().filter((node)=>!node.data._isCombo);
            const combos = graph.getAllNodes().filter((node)=>node.data._isCombo);
            const edges = graph.getAllEdges();
            const n = nodes === null || nodes === void 0 ? void 0 : nodes.length;
            if (!n || n === 1) return (0, $5Rnio.handleSingleNodeGraph)(graph, assign, center);
            // output nodes
            const layoutNodes = [];
            const nodeMap = new Map();
            nodes.forEach((node)=>{
                nodeMap.set(node.id, node);
            });
            const comboMap = new Map();
            combos.forEach((combo)=>{
                comboMap.set(combo.id, combo);
            });
            // each one in comboNodes is a combo contains the size and child nodes
            // comboNodes includes the node who has no parent combo
            const comboNodes = new Map();
            // the inner layouts, the result positions are stored in comboNodes and their child nodes
            const innerGraphLayoutPromises = this.getInnerGraphs(graph, treeKey, nodeMap, comboMap, edges, mergedOptions, comboNodes);
            yield Promise.all(innerGraphLayoutPromises);
            const outerNodeIds = new Map();
            const outerLayoutNodes = [];
            const nodeAncestorIdMap = new Map();
            let allHaveNoPosition = true;
            graph.getRoots(treeKey).forEach((root)=>{
                const combo = comboNodes.get(root.id);
                const cacheCombo = comboMap.get(root.id) || nodeMap.get(root.id);
                const comboLayoutNode = {
                    id: root.id,
                    data: Object.assign(Object.assign({}, root.data), {
                        x: combo.data.x || cacheCombo.data.x,
                        y: combo.data.y || cacheCombo.data.y,
                        fx: combo.data.fx || cacheCombo.data.fx,
                        fy: combo.data.fy || cacheCombo.data.fy,
                        mass: combo.data.mass || cacheCombo.data.mass,
                        size: combo.data.size
                    })
                };
                outerLayoutNodes.push(comboLayoutNode);
                outerNodeIds.set(root.id, true);
                if (!isNaN(comboLayoutNode.data.x) && comboLayoutNode.data.x !== 0 && !isNaN(comboLayoutNode.data.y) && comboLayoutNode.data.y !== 0) allHaveNoPosition = false;
                else {
                    comboLayoutNode.data.x = Math.random() * 100;
                    comboLayoutNode.data.y = Math.random() * 100;
                }
                (0, $8e7dj.graphTreeDfs)(graph, [
                    root
                ], (child)=>{
                    if (child.id !== root.id) nodeAncestorIdMap.set(child.id, root.id);
                }, 'TB', treeKey);
            });
            const outerLayoutEdges = [];
            edges.forEach((edge)=>{
                const sourceAncestorId = nodeAncestorIdMap.get(edge.source) || edge.source;
                const targetAncestorId = nodeAncestorIdMap.get(edge.target) || edge.target;
                // create an edge for outer layout if both source and target's ancestor combo is in outer layout nodes
                if (sourceAncestorId !== targetAncestorId && outerNodeIds.has(sourceAncestorId) && outerNodeIds.has(targetAncestorId)) outerLayoutEdges.push({
                    id: edge.id,
                    source: sourceAncestorId,
                    target: targetAncestorId,
                    data: {}
                });
            });
            // 若有需要最外层的 combo 或节点，则对最外层执行力导向
            let outerPositions;
            if (outerLayoutNodes === null || outerLayoutNodes === void 0 ? void 0 : outerLayoutNodes.length) {
                if (outerLayoutNodes.length === 1) {
                    outerLayoutNodes[0].data.x = center[0];
                    outerLayoutNodes[0].data.y = center[1];
                } else {
                    const outerLayoutGraph = new (0, $fc2XC.Graph)({
                        nodes: outerLayoutNodes,
                        edges: outerLayoutEdges
                    });
                    const outerLayout = propsOuterLayout || new (0, $irTWF.ForceLayout)();
                    // preset the nodes if the outerLayout is a force family layout
                    if (allHaveNoPosition && $3e95dbab0102a3a5$var$FORCE_LAYOUT_TYPE_MAP[outerLayout.id]) {
                        const outerLayoutPreset = outerLayoutNodes.length < 100 ? new (0, $k9H1V.MDSLayout)() : new (0, $kd0OI.ConcentricLayout)();
                        yield outerLayoutPreset.assign(outerLayoutGraph);
                    }
                    const options = Object.assign({
                        center: center,
                        kg: 5,
                        preventOverlap: true,
                        animate: false
                    }, outerLayout.id === 'force' ? {
                        gravity: 1,
                        factor: 4,
                        linkDistance: (edge, source, target)=>{
                            const sourceSize = Math.max(...source.data.size) || 32;
                            const targetSize = Math.max(...target.data.size) || 32;
                            return sourceSize / 2 + targetSize / 2 + 200;
                        }
                    } : {});
                    outerPositions = yield $3e95dbab0102a3a5$var$executeLayout(outerLayout, outerLayoutGraph, options);
                }
                // move the combos and their child nodes
                comboNodes.forEach((comboNode)=>{
                    var _a;
                    const outerPosition = outerPositions.nodes.find((pos)=>pos.id === comboNode.id);
                    if (outerPosition) {
                        // if it is one of the outer layout nodes, update the positions
                        const { x: x, y: y } = outerPosition.data;
                        comboNode.data.visited = true;
                        comboNode.data.x = x;
                        comboNode.data.y = y;
                        layoutNodes.push({
                            id: comboNode.id,
                            data: {
                                x: x,
                                y: y
                            }
                        });
                    }
                    // move the child nodes
                    const { x: x, y: y } = comboNode.data;
                    (_a = comboNode.data.nodes) === null || _a === void 0 || _a.forEach((node)=>{
                        layoutNodes.push({
                            id: node.id,
                            data: {
                                x: node.data.x + x,
                                y: node.data.y + y
                            }
                        });
                    });
                });
                // move the nodes from top to bottom
                comboNodes.forEach(({ data: data })=>{
                    const { x: x, y: y, visited: visited, nodes: nodes } = data;
                    nodes === null || nodes === void 0 || nodes.forEach((node)=>{
                        if (!visited) {
                            const layoutNode = layoutNodes.find((n)=>n.id === node.id);
                            layoutNode.data.x += x || 0;
                            layoutNode.data.y += y || 0;
                        }
                    });
                });
            }
            if (assign) layoutNodes.forEach((node)=>{
                graph.mergeNodeData(node.id, {
                    x: node.data.x,
                    y: node.data.y
                });
            });
            const result = {
                nodes: layoutNodes,
                edges: edges
            };
            return result;
        });
    }
    initVals(options) {
        const formattedOptions = Object.assign({}, options);
        const { nodeSize: nodeSize, spacing: spacing, comboPadding: comboPadding } = options;
        let nodeSizeFunc;
        let spacingFunc;
        // nodeSpacing to function
        if ((0, $jyI49.default)(spacing)) spacingFunc = ()=>spacing;
        else if ((0, $ky7aH.default)(spacing)) spacingFunc = spacing;
        else spacingFunc = ()=>0;
        formattedOptions.spacing = spacingFunc;
        // nodeSize to function
        if (!nodeSize) nodeSizeFunc = (d)=>{
            const spacing = spacingFunc(d);
            if (d.size) {
                if ((0, $hHwGT.isArray)(d.size)) {
                    const res = d.size[0] > d.size[1] ? d.size[0] : d.size[1];
                    return (res + spacing) / 2;
                }
                if ((0, $6JKSc.default)(d.size)) {
                    const res = d.size.width > d.size.height ? d.size.width : d.size.height;
                    return (res + spacing) / 2;
                }
                return (d.size + spacing) / 2;
            }
            return 32 + spacing / 2;
        };
        else if ((0, $ky7aH.default)(nodeSize)) nodeSizeFunc = (d)=>{
            const size = nodeSize(d);
            const spacing = spacingFunc(d);
            if ((0, $hHwGT.isArray)(d.size)) {
                const res = d.size[0] > d.size[1] ? d.size[0] : d.size[1];
                return (res + spacing) / 2;
            }
            return ((size || 32) + spacing) / 2;
        };
        else if ((0, $hHwGT.isArray)(nodeSize)) {
            const larger = nodeSize[0] > nodeSize[1] ? nodeSize[0] : nodeSize[1];
            const radius = larger / 2;
            nodeSizeFunc = (d)=>radius + spacingFunc(d) / 2;
        } else {
            // number type
            const radius = nodeSize / 2;
            nodeSizeFunc = (d)=>radius + spacingFunc(d) / 2;
        }
        formattedOptions.nodeSize = nodeSizeFunc;
        // comboPadding to function
        let comboPaddingFunc;
        if ((0, $jyI49.default)(comboPadding)) comboPaddingFunc = ()=>comboPadding;
        else if ((0, $hHwGT.isArray)(comboPadding)) comboPaddingFunc = ()=>Math.max.apply(null, comboPadding);
        else if ((0, $ky7aH.default)(comboPadding)) comboPaddingFunc = comboPadding;
        else // null type
        comboPaddingFunc = ()=>0;
        formattedOptions.comboPadding = comboPaddingFunc;
        return formattedOptions;
    }
    getInnerGraphs(graph, treeKey, nodeMap, comboMap, edges, options, comboNodes) {
        const { nodeSize: nodeSize, comboPadding: comboPadding, spacing: spacing, innerLayout: innerLayout } = options;
        const innerGraphLayout = innerLayout || new (0, $kd0OI.ConcentricLayout)({});
        const innerLayoutOptions = {
            center: [
                0,
                0
            ],
            preventOverlap: true,
            nodeSpacing: spacing
        };
        const innerLayoutPromises = [];
        const getSize = (node)=>{
            // @ts-ignore
            let padding = (comboPadding === null || comboPadding === void 0 ? void 0 : comboPadding(node)) || 10;
            if ((0, $hHwGT.isArray)(padding)) padding = Math.max(...padding);
            return {
                size: padding ? [
                    padding * 2,
                    padding * 2
                ] : [
                    30,
                    30
                ],
                padding: padding
            };
        };
        graph.getRoots(treeKey).forEach((root)=>{
            // @ts-ignore
            comboNodes.set(root.id, {
                id: root.id,
                data: {
                    nodes: [],
                    size: getSize(root).size
                }
            });
            let start = Promise.resolve();
            // Regard the child nodes in one combo as a graph, and layout them from bottom to top
            (0, $8e7dj.graphTreeDfs)(graph, [
                root
            ], (treeNode)=>{
                var _a;
                if (!treeNode.data._isCombo) return;
                const { size: nsize, padding: padding } = getSize(treeNode);
                if (!((_a = graph.getChildren(treeNode.id, treeKey)) === null || _a === void 0 ? void 0 : _a.length)) // empty combo
                comboNodes.set(treeNode.id, {
                    id: treeNode.id,
                    data: Object.assign(Object.assign({}, treeNode.data), {
                        size: nsize
                    })
                });
                else {
                    // combo not empty
                    const comboNode = comboNodes.get(treeNode.id);
                    comboNodes.set(treeNode.id, {
                        id: treeNode.id,
                        data: Object.assign({
                            nodes: []
                        }, comboNode === null || comboNode === void 0 ? void 0 : comboNode.data)
                    });
                    const innerLayoutNodeIds = new Map();
                    const innerLayoutNodes = graph.getChildren(treeNode.id, treeKey).map((child)=>{
                        if (child.data._isCombo) {
                            if (!comboNodes.has(child.id)) comboNodes.set(child.id, {
                                id: child.id,
                                data: Object.assign({}, child.data)
                            });
                            innerLayoutNodeIds.set(child.id, true);
                            return comboNodes.get(child.id);
                        }
                        const oriNode = nodeMap.get(child.id) || comboMap.get(child.id);
                        innerLayoutNodeIds.set(child.id, true);
                        return {
                            id: child.id,
                            data: Object.assign(Object.assign({}, oriNode.data), child.data)
                        };
                    });
                    const innerGraphData = {
                        nodes: innerLayoutNodes,
                        edges: edges.filter((edge)=>innerLayoutNodeIds.has(edge.source) && innerLayoutNodeIds.has(edge.target))
                    };
                    let minNodeSize = Infinity;
                    innerLayoutNodes.forEach((node)=>{
                        var _a;
                        let { size: size } = node.data;
                        if (!size) size = ((_a = comboNodes.get(node.id)) === null || _a === void 0 ? void 0 : _a.data.size) || (nodeSize === null || nodeSize === void 0 ? void 0 : nodeSize(node)) || [
                            30,
                            30
                        ];
                        if ((0, $jyI49.default)(size)) size = [
                            size,
                            size
                        ];
                        const [size0, size1] = size;
                        if (minNodeSize > size0) minNodeSize = size0;
                        if (minNodeSize > size1) minNodeSize = size1;
                        node.data.size = size;
                    });
                    // innerGraphLayout.assign(innerGraphCore, innerLayoutOptions);
                    start = start.then(()=>(0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
                            const innerGraphCore = new (0, $fc2XC.Graph)(innerGraphData);
                            yield $3e95dbab0102a3a5$var$executeLayout(innerGraphLayout, innerGraphCore, innerLayoutOptions, true);
                            const { minX: minX, minY: minY, maxX: maxX, maxY: maxY } = (0, $8e7dj.getLayoutBBox)(innerLayoutNodes);
                            // move the innerGraph to [0, 0], for later controlled by parent layout
                            const center = {
                                x: (maxX + minX) / 2,
                                y: (maxY + minY) / 2
                            };
                            innerGraphData.nodes.forEach((node)=>{
                                node.data.x -= center.x;
                                node.data.y -= center.y;
                            });
                            const size = [
                                Math.max(maxX - minX, minNodeSize) + padding * 2,
                                Math.max(maxY - minY, minNodeSize) + padding * 2
                            ];
                            comboNodes.get(treeNode.id).data.size = size;
                            comboNodes.get(treeNode.id).data.nodes = innerLayoutNodes;
                        }));
                }
                return true;
            }, 'BT', treeKey);
            innerLayoutPromises.push(start);
        });
        return innerLayoutPromises;
    }
}
function $3e95dbab0102a3a5$var$executeLayout(layout, graph, options, assign) {
    var _a;
    return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
        if ((0, $g98sr.isLayoutWithIterations)(layout)) {
            layout.execute(graph, options);
            layout.stop();
            return layout.tick((_a = options.iterations) !== null && _a !== void 0 ? _a : 300);
        }
        if (assign) return yield layout.assign(graph, options);
        return yield layout.execute(graph, options);
    });
}

});
parcelRegister("kd0OI", function(module, exports) {

$parcel$export(module.exports, "ConcentricLayout", () => $eb65a7c63d7ba6cf$export$9347783c4f7c1005);

var $7WQrb = parcelRequire("7WQrb");

var $ky7aH = parcelRequire("ky7aH");
var $jyI49 = parcelRequire("jyI49");
var $6JKSc = parcelRequire("6JKSc");
var $kVcyu = parcelRequire("kVcyu");

var $9nuNf = parcelRequire("9nuNf");
var $hHwGT = parcelRequire("hHwGT");

var $5Rnio = parcelRequire("5Rnio");

var $lKWgx = parcelRequire("lKWgx");
const $eb65a7c63d7ba6cf$var$DEFAULTS_LAYOUT_OPTIONS = {
    nodeSize: 30,
    nodeSpacing: 10,
    preventOverlap: false,
    sweep: undefined,
    equidistant: false,
    startAngle: 1.5 * Math.PI,
    clockwise: true,
    maxLevelDiff: undefined,
    sortBy: 'degree'
};
class $eb65a7c63d7ba6cf$export$9347783c4f7c1005 {
    constructor(options = {}){
        this.options = options;
        this.id = 'concentric';
        this.options = Object.assign(Object.assign({}, $eb65a7c63d7ba6cf$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericConcentricLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericConcentricLayout(true, graph, options);
        });
    }
    genericConcentricLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const mergedOptions = Object.assign(Object.assign({}, this.options), options);
            const { center: propsCenter, width: propsWidth, height: propsHeight, sortBy: propsSortBy, maxLevelDiff: propsMaxLevelDiff, sweep: propsSweep, clockwise: clockwise, equidistant: equidistant, preventOverlap: preventOverlap, startAngle: startAngle = 1.5 * Math.PI, nodeSize: nodeSize, nodeSpacing: nodeSpacing } = mergedOptions;
            const nodes = graph.getAllNodes();
            const edges = graph.getAllEdges();
            const width = !propsWidth && typeof window !== 'undefined' ? window.innerWidth : propsWidth;
            const height = !propsHeight && typeof window !== 'undefined' ? window.innerHeight : propsHeight;
            const center = !propsCenter ? [
                width / 2,
                height / 2
            ] : propsCenter;
            if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length) || nodes.length === 1) return (0, $5Rnio.handleSingleNodeGraph)(graph, assign, center);
            const layoutNodes = [];
            let maxNodeSize;
            let maxNodeSpacing = 0;
            if ((0, $hHwGT.isArray)(nodeSize)) maxNodeSize = Math.max(nodeSize[0], nodeSize[1]);
            else if ((0, $ky7aH.default)(nodeSize)) {
                maxNodeSize = -Infinity;
                nodes.forEach((node)=>{
                    const currentSize = Math.max(...(0, $lKWgx.parseSize)(nodeSize(node)));
                    if (currentSize > maxNodeSize) maxNodeSize = currentSize;
                });
            } else maxNodeSize = nodeSize;
            if ((0, $hHwGT.isArray)(nodeSpacing)) maxNodeSpacing = Math.max(nodeSpacing[0], nodeSpacing[1]);
            else if ((0, $jyI49.default)(nodeSpacing)) maxNodeSpacing = nodeSpacing;
            nodes.forEach((node)=>{
                const cnode = (0, $9nuNf.cloneFormatData)(node);
                layoutNodes.push(cnode);
                let nodeSize = maxNodeSize;
                const { data: data } = cnode;
                if ((0, $hHwGT.isArray)(data.size)) nodeSize = Math.max(data.size[0], data.size[1]);
                else if ((0, $jyI49.default)(data.size)) nodeSize = data.size;
                else if ((0, $6JKSc.default)(data.size)) nodeSize = Math.max(data.size.width, data.size.height);
                maxNodeSize = Math.max(maxNodeSize, nodeSize);
                if ((0, $ky7aH.default)(nodeSpacing)) maxNodeSpacing = Math.max(nodeSpacing(node), maxNodeSpacing);
            });
            // layout
            const nodeIdxMap = {};
            layoutNodes.forEach((node, i)=>{
                nodeIdxMap[node.id] = i;
            });
            // get the node degrees
            let sortBy = propsSortBy;
            if (!(0, $kVcyu.default)(sortBy) || layoutNodes[0].data[sortBy] === undefined) sortBy = 'degree';
            if (sortBy === 'degree') layoutNodes.sort((n1, n2)=>graph.getDegree(n2.id, 'both') - graph.getDegree(n1.id, 'both'));
            else // sort nodes by value
            layoutNodes.sort((n1, n2)=>n2.data[sortBy] - n1.data[sortBy]);
            const maxValueNode = layoutNodes[0];
            const maxLevelDiff = (propsMaxLevelDiff || (sortBy === 'degree' ? graph.getDegree(maxValueNode.id, 'both') : maxValueNode.data[sortBy])) / 4;
            // put the values into levels
            const levels = [
                {
                    nodes: []
                }
            ];
            let currentLevel = levels[0];
            layoutNodes.forEach((node)=>{
                if (currentLevel.nodes.length > 0) {
                    const diff = sortBy === 'degree' ? Math.abs(graph.getDegree(currentLevel.nodes[0].id, 'both') - graph.getDegree(node.id, 'both')) : Math.abs(currentLevel.nodes[0].data[sortBy] - node.data[sortBy]);
                    if (maxLevelDiff && diff >= maxLevelDiff) {
                        currentLevel = {
                            nodes: []
                        };
                        levels.push(currentLevel);
                    }
                }
                currentLevel.nodes.push(node);
            });
            // create positions for levels
            let minDist = maxNodeSize + maxNodeSpacing; // min dist between nodes
            if (!preventOverlap) {
                // then strictly constrain to bb
                const firstLvlHasMulti = levels.length > 0 && levels[0].nodes.length > 1;
                const maxR = Math.min(width, height) / 2 - minDist;
                const rStep = maxR / (levels.length + (firstLvlHasMulti ? 1 : 0));
                minDist = Math.min(minDist, rStep);
            }
            // find the metrics for each level
            let r = 0;
            levels.forEach((level)=>{
                const sweep = propsSweep === undefined ? 2 * Math.PI - 2 * Math.PI / level.nodes.length : propsSweep;
                level.dTheta = sweep / Math.max(1, level.nodes.length - 1);
                // calculate the radius
                if (level.nodes.length > 1 && preventOverlap) {
                    // but only if more than one node (can't overlap)
                    const dcos = Math.cos(level.dTheta) - Math.cos(0);
                    const dsin = Math.sin(level.dTheta) - Math.sin(0);
                    const rMin = Math.sqrt(minDist * minDist / (dcos * dcos + dsin * dsin)); // s.t. no nodes overlapping
                    r = Math.max(rMin, r);
                }
                level.r = r;
                r += minDist;
            });
            if (equidistant) {
                let rDeltaMax = 0;
                let rr = 0;
                for(let i = 0; i < levels.length; i++){
                    const level = levels[i];
                    const rDelta = (level.r || 0) - rr;
                    rDeltaMax = Math.max(rDeltaMax, rDelta);
                }
                rr = 0;
                levels.forEach((level, i)=>{
                    if (i === 0) rr = level.r || 0;
                    level.r = rr;
                    rr += rDeltaMax;
                });
            }
            // calculate the node positions
            levels.forEach((level)=>{
                const dTheta = level.dTheta || 0;
                const rr = level.r || 0;
                level.nodes.forEach((node, j)=>{
                    const theta = startAngle + (clockwise ? 1 : -1) * dTheta * j;
                    node.data.x = center[0] + rr * Math.cos(theta);
                    node.data.y = center[1] + rr * Math.sin(theta);
                });
            });
            if (assign) layoutNodes.forEach((node)=>graph.mergeNodeData(node.id, {
                    x: node.data.x,
                    y: node.data.y
                }));
            const result = {
                nodes: layoutNodes,
                edges: edges
            };
            return result;
        });
    }
}

});
parcelRegister("hHwGT", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $ce2fcf8f029fcc28$export$43bee75e5e14138e);
const $ce2fcf8f029fcc28$export$43bee75e5e14138e = Array.isArray;

});


parcelRegister("irTWF", function(module, exports) {

$parcel$export(module.exports, "ForceLayout", () => $d6e62526c3ef2275$export$9a500154086f6247);

var $7WQrb = parcelRequire("7WQrb");

var $fc2XC = parcelRequire("fc2XC");

var $jyI49 = parcelRequire("jyI49");

var $9RkJR = parcelRequire("9RkJR");

var $j1gOq = parcelRequire("j1gOq");
const $d6e62526c3ef2275$var$DEFAULTS_LAYOUT_OPTIONS = {
    dimensions: 2,
    maxIteration: 500,
    gravity: 10,
    factor: 1,
    edgeStrength: 50,
    nodeStrength: 1000,
    coulombDisScale: 0.005,
    damping: 0.9,
    maxSpeed: 200,
    minMovement: 0.4,
    interval: 0.02,
    linkDistance: 200,
    clusterNodeStrength: 20,
    preventOverlap: true,
    distanceThresholdMode: 'mean'
};
class $d6e62526c3ef2275$export$9a500154086f6247 {
    constructor(options = {}){
        this.options = options;
        this.id = 'force';
        /**
         * time interval for layout force animations
         */ this.timeInterval = 0;
        /**
         * compare with minMovement to end the nodes' movement
         */ this.judgingDistance = 0;
        this.running = false;
        this.options = Object.assign(Object.assign({}, $d6e62526c3ef2275$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericForceLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericForceLayout(true, graph, options);
        });
    }
    /**
     * Stop simulation immediately.
     */ stop() {
        if (this.timeInterval && typeof window !== 'undefined') window.clearInterval(this.timeInterval);
        this.running = false;
    }
    /**
     * Manually steps the simulation by the specified number of iterations.
     * @see https://github.com/d3/d3-force#simulation_tick
     */ tick(iterations = this.options.maxIteration || 1) {
        if (this.lastResult) return this.lastResult;
        for(let i = 0; (this.judgingDistance > this.lastOptions.minMovement || i < 1) && i < iterations; i++){
            this.runOneStep(this.lastCalcGraph, this.lastGraph, i, this.lastVelMap, this.lastOptions);
            this.updatePosition(this.lastGraph, this.lastCalcGraph, this.lastVelMap, this.lastOptions);
        }
        const result = {
            nodes: this.lastLayoutNodes,
            edges: this.lastLayoutEdges
        };
        if (this.lastAssign) result.nodes.forEach((node)=>this.lastGraph.mergeNodeData(node.id, {
                x: node.data.x,
                y: node.data.y,
                z: this.options.dimensions === 3 ? node.data.z : undefined
            }));
        return result;
    }
    genericForceLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const mergedOptions = Object.assign(Object.assign({}, this.options), options);
            const nodes = graph.getAllNodes();
            const edges = graph.getAllEdges();
            const formattedOptions = this.formatOptions(mergedOptions, graph);
            const { dimensions: dimensions, width: width, height: height, nodeSize: nodeSize, getMass: getMass, nodeStrength: nodeStrength, edgeStrength: edgeStrength, linkDistance: linkDistance } = formattedOptions;
            // clones the original data and attaches calculation attributes for this layout algorithm
            const layoutNodes = nodes.map((node, i)=>{
                return Object.assign(Object.assign({}, node), {
                    data: Object.assign(Object.assign({}, node.data), {
                        // ...randomDistribution(node, dimensions, 30, i),
                        x: (0, $jyI49.default)(node.data.x) ? node.data.x : Math.random() * width,
                        y: (0, $jyI49.default)(node.data.y) ? node.data.y : Math.random() * height,
                        z: (0, $jyI49.default)(node.data.z) ? node.data.z : Math.random() * Math.sqrt(width * height),
                        size: nodeSize(node) || 30,
                        mass: getMass(node),
                        nodeStrength: nodeStrength(node)
                    })
                });
            });
            const layoutEdges = edges.map((edge)=>Object.assign(Object.assign({}, edge), {
                    data: Object.assign(Object.assign({}, edge.data), {
                        edgeStrength: edgeStrength(edge),
                        linkDistance: linkDistance(edge, graph.getNode(edge.source), graph.getNode(edge.target))
                    })
                }));
            if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length)) {
                this.lastResult = {
                    nodes: [],
                    edges: edges
                };
                return {
                    nodes: [],
                    edges: edges
                };
            }
            const velMap = {};
            nodes.forEach((node, i)=>{
                velMap[node.id] = {
                    x: 0,
                    y: 0,
                    z: 0
                };
            });
            const calcGraph = new (0, $fc2XC.Graph)({
                nodes: layoutNodes,
                edges: layoutEdges
            });
            this.formatCentripetal(formattedOptions, calcGraph);
            const { maxIteration: maxIteration, minMovement: minMovement, onTick: onTick } = formattedOptions;
            // Use them later in `tick`.
            this.lastLayoutNodes = layoutNodes;
            this.lastLayoutEdges = layoutEdges;
            this.lastAssign = assign;
            this.lastGraph = graph;
            this.lastCalcGraph = calcGraph;
            this.lastOptions = formattedOptions;
            this.lastVelMap = velMap;
            if (typeof window === 'undefined') return;
            let iter = 0;
            return new Promise((resolve)=>{
                // interval for render the result after each iteration
                this.timeInterval = window.setInterval(()=>{
                    if (!nodes || !this.running) resolve({
                        nodes: $d6e62526c3ef2275$var$formatOutNodes(graph, layoutNodes),
                        edges: edges
                    });
                    this.runOneStep(calcGraph, graph, iter, velMap, formattedOptions);
                    this.updatePosition(graph, calcGraph, velMap, formattedOptions);
                    if (assign) layoutNodes.forEach((node)=>graph.mergeNodeData(node.id, {
                            x: node.data.x,
                            y: node.data.y,
                            z: dimensions === 3 ? node.data.z : undefined
                        }));
                    onTick === null || onTick === void 0 || onTick({
                        nodes: $d6e62526c3ef2275$var$formatOutNodes(graph, layoutNodes),
                        edges: edges
                    });
                    iter++;
                    if (iter >= maxIteration || this.judgingDistance < minMovement) {
                        window.clearInterval(this.timeInterval);
                        resolve({
                            nodes: $d6e62526c3ef2275$var$formatOutNodes(graph, layoutNodes),
                            edges: edges
                        });
                    }
                }, 0);
                this.running = true;
            });
        });
    }
    /**
     * Format merged layout options.
     * @param options merged layout options
     * @param graph original graph
     * @returns
     */ formatOptions(options, graph) {
        const formattedOptions = Object.assign({}, options);
        const { width: propsWidth, height: propsHeight, getMass: getMass } = options;
        // === formating width, height, and center =====
        formattedOptions.width = !propsWidth && typeof window !== 'undefined' ? window.innerWidth : propsWidth;
        formattedOptions.height = !propsHeight && typeof window !== 'undefined' ? window.innerHeight : propsHeight;
        if (!options.center) formattedOptions.center = [
            formattedOptions.width / 2,
            formattedOptions.height / 2
        ];
        // === formating node mass =====
        if (!getMass) formattedOptions.getMass = (d)=>{
            let massWeight = 1;
            if ((0, $jyI49.default)(d === null || d === void 0 ? void 0 : d.data.mass)) massWeight = d === null || d === void 0 ? void 0 : d.data.mass;
            const degree = graph.getDegree(d.id, 'both');
            return !degree || degree < 5 ? massWeight : degree * 5 * massWeight;
        };
        // === formating node size =====
        formattedOptions.nodeSize = (0, $9RkJR.formatNodeSizeToNumber)(options.nodeSize, options.nodeSpacing);
        // === formating node / edge strengths =====
        const linkDistanceFn = options.linkDistance ? (0, $9RkJR.formatNumberFn)(1, options.linkDistance) : (edge)=>{
            return 1 + formattedOptions.nodeSize(graph.getNode(edge.source)) + formattedOptions.nodeSize(graph.getNode(edge.target));
        };
        formattedOptions.linkDistance = linkDistanceFn;
        formattedOptions.nodeStrength = (0, $9RkJR.formatNumberFn)(1, options.nodeStrength);
        formattedOptions.edgeStrength = (0, $9RkJR.formatNumberFn)(1, options.edgeStrength);
        return formattedOptions;
    }
    /**
     * Format centripetalOption in the option.
     * @param options merged layout options
     * @param calcGraph calculation graph
     */ formatCentripetal(options, calcGraph) {
        const { dimensions: dimensions, centripetalOptions: centripetalOptions, center: center, clusterNodeStrength: clusterNodeStrength, leafCluster: leafCluster, clustering: clustering, nodeClusterBy: nodeClusterBy } = options;
        const calcNodes = calcGraph.getAllNodes();
        // === formating centripetalOptions =====
        const basicCentripetal = centripetalOptions || {
            leaf: 2,
            single: 2,
            others: 1,
            // eslint-disable-next-line
            center: (n)=>{
                return {
                    x: center[0],
                    y: center[1],
                    z: dimensions === 3 ? center[2] : undefined
                };
            }
        };
        if (typeof clusterNodeStrength !== 'function') options.clusterNodeStrength = (node)=>clusterNodeStrength;
        let sameTypeLeafMap;
        let clusters;
        if (leafCluster && nodeClusterBy) {
            sameTypeLeafMap = $d6e62526c3ef2275$var$getSameTypeLeafMap(calcGraph, nodeClusterBy);
            clusters = Array.from(new Set(calcNodes === null || calcNodes === void 0 ? void 0 : calcNodes.map((node)=>node.data[nodeClusterBy]))) || [];
            // @ts-ignore
            options.centripetalOptions = Object.assign(basicCentripetal, {
                single: 100,
                leaf: (node)=>{
                    // 找出与它关联的边的起点或终点出发的所有一度节点中同类型的叶子节点
                    const { siblingLeaves: siblingLeaves, sameTypeLeaves: sameTypeLeaves } = sameTypeLeafMap[node.id] || {};
                    // 如果都是同一类型或者每种类型只有1个，则施加默认向心力
                    if ((sameTypeLeaves === null || sameTypeLeaves === void 0 ? void 0 : sameTypeLeaves.length) === (siblingLeaves === null || siblingLeaves === void 0 ? void 0 : siblingLeaves.length) || (clusters === null || clusters === void 0 ? void 0 : clusters.length) === 1) return 1;
                    return options.clusterNodeStrength(node);
                },
                others: 1,
                center: (node)=>{
                    const degree = calcGraph.getDegree(node.id, 'both');
                    // 孤点默认给1个远离的中心点
                    if (!degree) return {
                        x: 100,
                        y: 100,
                        z: 0
                    };
                    let centerPos;
                    if (degree === 1) {
                        // 如果为叶子节点
                        // 找出与它关联的边的起点出发的所有一度节点中同类型的叶子节点
                        const { sameTypeLeaves: sameTypeLeaves = [] } = sameTypeLeafMap[node.id] || {};
                        if (sameTypeLeaves.length === 1) // 如果同类型的叶子节点只有1个，中心位置为undefined
                        centerPos = undefined;
                        else if (sameTypeLeaves.length > 1) // 找出同类型节点平均位置作为中心
                        centerPos = $d6e62526c3ef2275$var$getAvgNodePosition(sameTypeLeaves);
                    } else centerPos = undefined;
                    return {
                        x: centerPos === null || centerPos === void 0 ? void 0 : centerPos.x,
                        y: centerPos === null || centerPos === void 0 ? void 0 : centerPos.y,
                        z: centerPos === null || centerPos === void 0 ? void 0 : centerPos.z
                    };
                }
            });
        }
        if (clustering && nodeClusterBy) {
            if (!sameTypeLeafMap) sameTypeLeafMap = $d6e62526c3ef2275$var$getSameTypeLeafMap(calcGraph, nodeClusterBy);
            if (!clusters) clusters = Array.from(new Set(calcNodes.map((node)=>node.data[nodeClusterBy])));
            clusters = clusters.filter((item)=>item !== undefined);
            const centerInfo = {};
            clusters.forEach((cluster)=>{
                const sameTypeNodes = calcNodes.filter((node)=>node.data[nodeClusterBy] === cluster).map((node)=>calcGraph.getNode(node.id));
                // 找出同类型节点平均位置节点的距离最近的节点作为中心节点
                centerInfo[cluster] = $d6e62526c3ef2275$var$getAvgNodePosition(sameTypeNodes);
            });
            options.centripetalOptions = Object.assign(basicCentripetal, {
                single: (node)=>options.clusterNodeStrength(node),
                leaf: (node)=>options.clusterNodeStrength(node),
                others: (node)=>options.clusterNodeStrength(node),
                center: (node)=>{
                    // 找出同类型节点平均位置节点的距离最近的节点作为中心节点
                    const centerPos = centerInfo[node.data[nodeClusterBy]];
                    return {
                        x: centerPos === null || centerPos === void 0 ? void 0 : centerPos.x,
                        y: centerPos === null || centerPos === void 0 ? void 0 : centerPos.y,
                        z: centerPos === null || centerPos === void 0 ? void 0 : centerPos.z
                    };
                }
            });
        }
        const { leaf: leaf, single: single, others: others } = options.centripetalOptions || {};
        if (leaf && typeof leaf !== 'function') options.centripetalOptions.leaf = ()=>leaf;
        if (single && typeof single !== 'function') options.centripetalOptions.single = ()=>single;
        if (others && typeof others !== 'function') options.centripetalOptions.others = ()=>others;
    }
    /**
     * One iteration.
     * @param calcGraph calculation graph
     * @param graph origin graph
     * @param iter current iteration index
     * @param velMap nodes' velocity map
     * @param options formatted layout options
     * @returns
     */ runOneStep(calcGraph, graph, iter, velMap, options) {
        const accMap = {};
        const calcNodes = calcGraph.getAllNodes();
        const calcEdges = calcGraph.getAllEdges();
        if (!(calcNodes === null || calcNodes === void 0 ? void 0 : calcNodes.length)) return;
        const { monitor: monitor } = options;
        this.calRepulsive(calcGraph, accMap, options);
        if (calcEdges) this.calAttractive(calcGraph, accMap, options);
        this.calGravity(calcGraph, graph, accMap, options);
        this.updateVelocity(calcGraph, accMap, velMap, options);
        /** 如果需要监控信息，则提供给用户 */ if (monitor) {
            const energy = this.calTotalEnergy(accMap, calcNodes);
            monitor({
                energy: energy,
                nodes: graph.getAllNodes(),
                edges: graph.getAllEdges(),
                iterations: iter
            });
        }
    }
    /**
     * Calculate graph energy for monitoring convergence.
     * @param accMap acceleration map
     * @param nodes calculation nodes
     * @returns energy
     */ calTotalEnergy(accMap, nodes) {
        if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length)) return 0;
        let energy = 0.0;
        nodes.forEach((node, i)=>{
            const vx = accMap[node.id].x;
            const vy = accMap[node.id].y;
            const vz = this.options.dimensions === 3 ? accMap[node.id].z : 0;
            const speed2 = vx * vx + vy * vy + vz * vz;
            const { mass: mass = 1 } = node.data;
            energy += mass * speed2 * 0.5; // p = 1/2*(mv^2)
        });
        return energy;
    }
    /**
     * Calculate the repulsive forces according to coulombs law.
     * @param calcGraph calculation graph
     * @param accMap acceleration map
     * @param options formatted layout options
     */ calRepulsive(calcGraph, accMap, options) {
        const { dimensions: dimensions, factor: factor, coulombDisScale: coulombDisScale } = options;
        (0, $j1gOq.forceNBody)(calcGraph, factor, coulombDisScale * coulombDisScale, accMap, dimensions);
    }
    /**
     * Calculate the attractive forces according to hooks law.
     * @param calcGraph calculation graph
     * @param accMap acceleration map
     */ calAttractive(calcGraph, accMap, options) {
        const { dimensions: dimensions, nodeSize: nodeSize } = options;
        calcGraph.getAllEdges().forEach((edge, i)=>{
            const { source: source, target: target } = edge;
            const sourceNode = calcGraph.getNode(source);
            const targetNode = calcGraph.getNode(target);
            if (!sourceNode || !targetNode) return;
            let vecX = targetNode.data.x - sourceNode.data.x;
            let vecY = targetNode.data.y - sourceNode.data.y;
            let vecZ = dimensions === 3 ? targetNode.data.z - sourceNode.data.z : 0;
            if (!vecX && !vecY) {
                vecX = Math.random() * 0.01;
                vecY = Math.random() * 0.01;
                if (dimensions === 3 && !vecZ) vecZ = Math.random() * 0.01;
            }
            const vecLength = Math.sqrt(vecX * vecX + vecY * vecY + vecZ * vecZ);
            if (vecLength < nodeSize(sourceNode) + nodeSize(targetNode)) return;
            const direX = vecX / vecLength;
            const direY = vecY / vecLength;
            const direZ = vecZ / vecLength;
            const { linkDistance: linkDistance = 200, edgeStrength: edgeStrength = 200 } = edge.data || {};
            const diff = linkDistance - vecLength;
            const param = diff * edgeStrength;
            const massSource = sourceNode.data.mass || 1;
            const massTarget = targetNode.data.mass || 1;
            // 质量占比越大，对另一端影响程度越大
            const sourceMassRatio = 1 / massSource;
            const targetMassRatio = 1 / massTarget;
            const disX = direX * param;
            const disY = direY * param;
            const disZ = direZ * param;
            accMap[source].x -= disX * sourceMassRatio;
            accMap[source].y -= disY * sourceMassRatio;
            accMap[source].z -= disZ * sourceMassRatio;
            accMap[target].x += disX * targetMassRatio;
            accMap[target].y += disY * targetMassRatio;
            accMap[target].z += disZ * targetMassRatio;
        });
    }
    /**
     * Calculate the gravity forces toward center.
     * @param calcGraph calculation graph
     * @param graph origin graph
     * @param accMap acceleration map
     * @param options formatted layout options
     */ calGravity(calcGraph, graph, accMap, options) {
        const { getCenter: getCenter } = options;
        const calcNodes = calcGraph.getAllNodes();
        const nodes = graph.getAllNodes();
        const edges = graph.getAllEdges();
        const { width: width, height: height, center: center, gravity: defaultGravity, centripetalOptions: centripetalOptions } = options;
        if (!calcNodes) return;
        calcNodes.forEach((calcNode)=>{
            const { id: id, data: data } = calcNode;
            const { mass: mass, x: x, y: y, z: z } = data;
            const node = graph.getNode(id);
            let vecX = 0;
            let vecY = 0;
            let vecZ = 0;
            let gravity = defaultGravity;
            const inDegree = calcGraph.getDegree(id, 'in');
            const outDegree = calcGraph.getDegree(id, 'out');
            const degree = calcGraph.getDegree(id, 'both');
            const forceCenter = getCenter === null || getCenter === void 0 ? void 0 : getCenter(node, degree);
            if (forceCenter) {
                const [centerX, centerY, strength] = forceCenter;
                vecX = x - centerX;
                vecY = y - centerY;
                gravity = strength;
            } else {
                vecX = x - center[0];
                vecY = y - center[1];
                vecZ = z - center[2];
            }
            if (gravity) {
                accMap[id].x -= gravity * vecX / mass;
                accMap[id].y -= gravity * vecY / mass;
                accMap[id].z -= gravity * vecZ / mass;
            }
            if (centripetalOptions) {
                const { leaf: leaf, single: single, others: others, center: centriCenter } = centripetalOptions;
                const { x: centriX, y: centriY, z: centriZ, centerStrength: centerStrength } = (centriCenter === null || centriCenter === void 0 ? void 0 : centriCenter(node, nodes, edges, width, height)) || {
                    x: 0,
                    y: 0,
                    z: 0,
                    centerStrength: 0
                };
                if (!(0, $jyI49.default)(centriX) || !(0, $jyI49.default)(centriY)) return;
                const vx = (x - centriX) / mass;
                const vy = (y - centriY) / mass;
                const vz = (z - centriZ) / mass;
                if (centerStrength) {
                    accMap[id].x -= centerStrength * vx;
                    accMap[id].y -= centerStrength * vy;
                    accMap[id].z -= centerStrength * vz;
                }
                // 孤点
                if (degree === 0) {
                    const singleStrength = single(node);
                    if (!singleStrength) return;
                    accMap[id].x -= singleStrength * vx;
                    accMap[id].y -= singleStrength * vy;
                    accMap[id].z -= singleStrength * vz;
                    return;
                }
                // 没有出度或没有入度，都认为是叶子节点
                if (inDegree === 0 || outDegree === 0) {
                    const leafStrength = leaf(node, nodes, edges);
                    if (!leafStrength) return;
                    accMap[id].x -= leafStrength * vx;
                    accMap[id].y -= leafStrength * vy;
                    accMap[id].z -= leafStrength * vz;
                    return;
                }
                /** others */ const othersStrength = others(node);
                if (!othersStrength) return;
                accMap[id].x -= othersStrength * vx;
                accMap[id].y -= othersStrength * vy;
                accMap[id].z -= othersStrength * vz;
            }
        });
    }
    /**
     * Update the velocities for nodes.
     * @param calcGraph calculation graph
     * @param accMap acceleration map
     * @param velMap velocity map
     * @param options formatted layout options
     * @returns
     */ updateVelocity(calcGraph, accMap, velMap, options) {
        const { damping: damping, maxSpeed: maxSpeed, interval: interval, dimensions: dimensions } = options;
        const calcNodes = calcGraph.getAllNodes();
        if (!(calcNodes === null || calcNodes === void 0 ? void 0 : calcNodes.length)) return;
        calcNodes.forEach((calcNode)=>{
            const { id: id } = calcNode;
            let vx = (velMap[id].x + accMap[id].x * interval) * damping || 0.01;
            let vy = (velMap[id].y + accMap[id].y * interval) * damping || 0.01;
            let vz = dimensions === 3 ? (velMap[id].z + accMap[id].z * interval) * damping || 0.01 : 0.0;
            const vLength = Math.sqrt(vx * vx + vy * vy + vz * vz);
            if (vLength > maxSpeed) {
                const param2 = maxSpeed / vLength;
                vx = param2 * vx;
                vy = param2 * vy;
                vz = param2 * vz;
            }
            velMap[id] = {
                x: vx,
                y: vy,
                z: vz
            };
        });
    }
    /**
     * Update nodes' positions.
     * @param graph origin graph
     * @param calcGraph calculatition graph
     * @param velMap velocity map
     * @param options formatted layou options
     * @returns
     */ updatePosition(graph, calcGraph, velMap, options) {
        const { distanceThresholdMode: distanceThresholdMode, interval: interval, dimensions: dimensions } = options;
        const calcNodes = calcGraph.getAllNodes();
        if (!(calcNodes === null || calcNodes === void 0 ? void 0 : calcNodes.length)) {
            this.judgingDistance = 0;
            return;
        }
        let sum = 0;
        if (distanceThresholdMode === 'max') this.judgingDistance = -Infinity;
        else if (distanceThresholdMode === 'min') this.judgingDistance = Infinity;
        calcNodes.forEach((calcNode)=>{
            const { id: id } = calcNode;
            const node = graph.getNode(id);
            if ((0, $jyI49.default)(node.data.fx) && (0, $jyI49.default)(node.data.fy)) {
                calcGraph.mergeNodeData(id, {
                    x: node.data.fx,
                    y: node.data.fy,
                    z: dimensions === 3 ? node.data.fz : undefined
                });
                return;
            }
            const distX = velMap[id].x * interval;
            const distY = velMap[id].y * interval;
            const distZ = dimensions === 3 ? velMap[id].z * interval : 0.0;
            calcGraph.mergeNodeData(id, {
                x: calcNode.data.x + distX,
                y: calcNode.data.y + distY,
                z: calcNode.data.z + distZ
            });
            const distanceMagnitude = Math.sqrt(distX * distX + distY * distY + distZ * distZ);
            switch(distanceThresholdMode){
                case 'max':
                    if (this.judgingDistance < distanceMagnitude) this.judgingDistance = distanceMagnitude;
                    break;
                case 'min':
                    if (this.judgingDistance > distanceMagnitude) this.judgingDistance = distanceMagnitude;
                    break;
                default:
                    sum = sum + distanceMagnitude;
                    break;
            }
        });
        if (!distanceThresholdMode || distanceThresholdMode === 'mean') this.judgingDistance = sum / calcNodes.length;
    }
}
/**
 * Group the leaf nodes according to nodeClusterBy field.
 * @param calcGraph calculation graph
 * @param nodeClusterBy the field name in node.data to ditinguish different node clusters
 * @returns related same group leaf nodes for each leaf node
 */ const $d6e62526c3ef2275$var$getSameTypeLeafMap = (calcGraph, nodeClusterBy)=>{
    const calcNodes = calcGraph.getAllNodes();
    if (!(calcNodes === null || calcNodes === void 0 ? void 0 : calcNodes.length)) return {};
    const sameTypeLeafMap = {};
    calcNodes.forEach((node, i)=>{
        const degree = calcGraph.getDegree(node.id, 'both');
        if (degree === 1) sameTypeLeafMap[node.id] = $d6e62526c3ef2275$var$getCoreNodeAndSiblingLeaves(calcGraph, 'leaf', node, nodeClusterBy);
    });
    return sameTypeLeafMap;
};
/**
 * Find the successor or predecessor of node as coreNode, the sibling leaf nodes
 * @param calcGraph calculation graph
 * @param type ('all') filter out the not-same-cluster nodes, ('leaf') or filter out the not-leaf nodes in the same time
 * @param node the target node
 * @param nodeClusterBy the field name in node.data to ditinguish different node clusters
 * @returns coreNode, sibling leaf nodes, and grouped sibling leaf nodes
 */ const $d6e62526c3ef2275$var$getCoreNodeAndSiblingLeaves = (calcGraph, type, node, nodeClusterBy)=>{
    const inDegree = calcGraph.getDegree(node.id, 'in');
    const outDegree = calcGraph.getDegree(node.id, 'out');
    // node is not a leaf, coreNode is itself, siblingLeaves is empty
    let coreNode = node;
    let siblingLeaves = [];
    if (inDegree === 0) {
        // node is a leaf node without out edges, its related(successor) node is coreNode, siblingLeaves is the neighbors of its related node
        coreNode = calcGraph.getSuccessors(node.id)[0];
        siblingLeaves = calcGraph.getNeighbors(coreNode.id);
    } else if (outDegree === 0) {
        // node is a leaf node without in edges, its related(predecessor) node is coreNode, siblingLeaves is the neighbors of its related node
        coreNode = calcGraph.getPredecessors(node.id)[0];
        siblingLeaves = calcGraph.getNeighbors(coreNode.id);
    }
    // siblingLeaves are leaf nodes
    siblingLeaves = siblingLeaves.filter((node)=>calcGraph.getDegree(node.id, 'in') === 0 || calcGraph.getDegree(node.id, 'out') === 0);
    const sameTypeLeaves = $d6e62526c3ef2275$var$getSameTypeNodes(calcGraph, type, nodeClusterBy, node, siblingLeaves);
    return {
        coreNode: coreNode,
        siblingLeaves: siblingLeaves,
        sameTypeLeaves: sameTypeLeaves
    };
};
/**
 * Find the same type (according to nodeClusterBy field) of node in relativeNodes.
 * @param calcGraph calculation graph
 * @param type ('all') filter out the not-same-cluster nodes, ('leaf') or filter out the not-leaf nodes in the same time
 * @param nodeClusterBy the field name in node.data to ditinguish different node clusters
 * @param node the target node
 * @param relativeNodes node's related ndoes to be filtered
 * @returns related nodes that meet the filtering conditions
 */ const $d6e62526c3ef2275$var$getSameTypeNodes = (calcGraph, type, nodeClusterBy, node, relativeNodes)=>{
    const typeName = node.data[nodeClusterBy] || '';
    let sameTypeNodes = (relativeNodes === null || relativeNodes === void 0 ? void 0 : relativeNodes.filter((item)=>item.data[nodeClusterBy] === typeName)) || [];
    if (type === 'leaf') sameTypeNodes = sameTypeNodes.filter((item)=>calcGraph.getDegree(item.id, 'in') === 0 || calcGraph.getDegree(item.id, 'out') === 0);
    return sameTypeNodes;
};
/**
 * Get the average position of nodes.
 * @param nodes nodes set
 * @returns average ppsition
 */ const $d6e62526c3ef2275$var$getAvgNodePosition = (nodes)=>{
    const totalNodes = {
        x: 0,
        y: 0
    };
    nodes.forEach((node)=>{
        const { x: x, y: y } = node.data;
        totalNodes.x += x || 0;
        totalNodes.y += y || 0;
    });
    // 获取均值向量
    const length = nodes.length || 1;
    return {
        x: totalNodes.x / length,
        y: totalNodes.y / length
    };
};
/**
 * Format the output nodes from CalcNode[].
 * @param graph origin graph
 * @param layoutNodes calculation nodes
 * @returns output nodes
 */ const $d6e62526c3ef2275$var$formatOutNodes = (graph, layoutNodes)=>layoutNodes.map((calcNode)=>{
        const { id: id, data: data } = calcNode;
        const node = graph.getNode(id);
        return Object.assign(Object.assign({}, node), {
            data: Object.assign(Object.assign({}, node.data), {
                x: data.x,
                y: data.y,
                z: data.z
            })
        });
    });

});
parcelRegister("j1gOq", function(module, exports) {

$parcel$export(module.exports, "forceNBody", () => $dd8b26e5ce291e31$export$fef20e2a22d94f43);

var $d0mwP = parcelRequire("d0mwP");

var $gx2Yb = parcelRequire("gx2Yb");
const $dd8b26e5ce291e31$var$theta2 = 0.81; // Barnes-Hut approximation threshold
const $dd8b26e5ce291e31$var$epsilon = 0.1; // 为了防止出现除0的情况，加一个epsilon
function $dd8b26e5ce291e31$export$fef20e2a22d94f43(calcGraph, factor, coulombDisScale2, accMap, dimensions = 2) {
    const weightParam = factor / coulombDisScale2;
    const calcNodes = calcGraph.getAllNodes();
    const data = calcNodes.map((calcNode, i)=>{
        const { nodeStrength: nodeStrength, x: x, y: y, z: z, size: size } = calcNode.data;
        return {
            x: x,
            y: y,
            z: z,
            size: size,
            index: i,
            id: calcNode.id,
            vx: 0,
            vy: 0,
            vz: 0,
            weight: weightParam * nodeStrength
        };
    });
    const tree = (dimensions === 2 ? (0, $d0mwP.default)(data, (d)=>d.x, (d)=>d.y) : (0, $gx2Yb.default)(data, (d)=>d.x, (d)=>d.y, (d)=>d.z)).visitAfter($dd8b26e5ce291e31$var$accumulate); // init internal node
    const nodeMap = new Map();
    data.forEach((n)=>{
        nodeMap.set(n.id, n);
        // @ts-ignore
        $dd8b26e5ce291e31$var$computeForce(n, tree, dimensions);
    });
    data.map((n, i)=>{
        const { id: id, data: data } = calcNodes[i];
        const { mass: mass = 1 } = data;
        // 从 0 开始，= 初始化 + 加斥力
        accMap[id] = {
            x: n.vx / mass,
            y: n.vy / mass,
            z: n.vz / mass
        };
    });
    return accMap;
}
function $dd8b26e5ce291e31$var$accumulate(treeNode) {
    let accWeight = 0;
    let accX = 0;
    let accY = 0;
    let accZ = 0;
    let accSize = 0;
    const numChildren = treeNode.length;
    if (numChildren) {
        // internal node, accumulate 4 child quads
        for(let i = 0; i < numChildren; i++){
            const q = treeNode[i];
            if (q && q.weight) {
                accWeight += q.weight;
                accX += q.x * q.weight;
                accY += q.y * q.weight;
                accZ += q.z * q.weight;
                accSize += q.size * q.weight;
            }
        }
        treeNode.x = accX / accWeight;
        treeNode.y = accY / accWeight;
        treeNode.z = accZ / accWeight;
        treeNode.size = accSize / accWeight;
        treeNode.weight = accWeight;
    } else {
        // leaf node
        const q = treeNode;
        treeNode.x = q.data.x;
        treeNode.y = q.data.y;
        treeNode.z = q.data.z;
        treeNode.size = q.data.size;
        treeNode.weight = q.data.weight;
    }
}
const $dd8b26e5ce291e31$var$apply = (treeNode, x1, arg1, arg2, arg3, node, dimensions)=>{
    var _a;
    if (((_a = treeNode.data) === null || _a === void 0 ? void 0 : _a.id) === node.id) return;
    const x2 = [
        arg1,
        arg2,
        arg3
    ][dimensions - 1];
    const dx = node.x - treeNode.x || $dd8b26e5ce291e31$var$epsilon;
    const dy = node.y - treeNode.y || $dd8b26e5ce291e31$var$epsilon;
    const dz = node.z - treeNode.z || $dd8b26e5ce291e31$var$epsilon;
    const pos = [
        dx,
        dy,
        dz
    ];
    const width = x2 - x1;
    let len2 = 0;
    for(let i = 0; i < dimensions; i++)len2 += pos[i] * pos[i];
    const len1 = Math.sqrt(len2);
    const len3 = len1 * len2;
    // far node, apply Barnes-Hut approximation
    if (width * width * $dd8b26e5ce291e31$var$theta2 < len2) {
        const param = treeNode.weight / len3;
        node.vx += dx * param;
        node.vy += dy * param;
        node.vz += dz * param;
        return true;
    }
    // near quad, compute force directly
    if (treeNode.length) return false; // internal node, visit children
    // leaf node
    if (treeNode.data !== node) {
        const param = treeNode.data.weight / len3;
        node.vx += dx * param;
        node.vy += dy * param;
        node.vz += dz * param;
    }
};
// @ts-ignore
function $dd8b26e5ce291e31$var$computeForce(node, tree, dimensions) {
    // @ts-ignore
    tree.visit((treeNode, x1, y1, x2, y2)=>$dd8b26e5ce291e31$var$apply(treeNode, x1, y1, x2, y2, node, dimensions));
}

});
parcelRegister("d0mwP", function(module, exports) {

$parcel$export(module.exports, "default", () => $977cc0295d3f184c$export$2e2bcd8739ae039);

var $gjVyY = parcelRequire("gjVyY");

var $8h5eQ = parcelRequire("8h5eQ");

var $hQmlF = parcelRequire("hQmlF");

var $lSEe3 = parcelRequire("lSEe3");

var $fLzjZ = parcelRequire("fLzjZ");

var $dCvn0 = parcelRequire("dCvn0");

var $1audT = parcelRequire("1audT");

var $lo9rr = parcelRequire("lo9rr");

var $1ReeB = parcelRequire("1ReeB");

var $dfm4j = parcelRequire("dfm4j");

var $jepce = parcelRequire("jepce");

var $96eXQ = parcelRequire("96eXQ");
function $977cc0295d3f184c$export$2e2bcd8739ae039(nodes, x, y) {
    var tree = new $977cc0295d3f184c$var$Quadtree(x == null ? (0, $jepce.defaultX) : x, y == null ? (0, $96eXQ.defaultY) : y, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $977cc0295d3f184c$var$Quadtree(x, y, x0, y0, x1, y1) {
    this._x = x;
    this._y = y;
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    this._root = undefined;
}
function $977cc0295d3f184c$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $977cc0295d3f184c$var$treeProto = $977cc0295d3f184c$export$2e2bcd8739ae039.prototype = $977cc0295d3f184c$var$Quadtree.prototype;
$977cc0295d3f184c$var$treeProto.copy = function() {
    var copy = new $977cc0295d3f184c$var$Quadtree(this._x, this._y, this._x0, this._y0, this._x1, this._y1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $977cc0295d3f184c$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(4)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 4; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(4)
            });
            else node.target[i] = $977cc0295d3f184c$var$leaf_copy(child);
        }
    }
    return copy;
};
$977cc0295d3f184c$var$treeProto.add = (0, $gjVyY.default);
$977cc0295d3f184c$var$treeProto.addAll = (0, $gjVyY.addAll);
$977cc0295d3f184c$var$treeProto.cover = (0, $8h5eQ.default);
$977cc0295d3f184c$var$treeProto.data = (0, $hQmlF.default);
$977cc0295d3f184c$var$treeProto.extent = (0, $lSEe3.default);
$977cc0295d3f184c$var$treeProto.find = (0, $fLzjZ.default);
$977cc0295d3f184c$var$treeProto.remove = (0, $dCvn0.default);
$977cc0295d3f184c$var$treeProto.removeAll = (0, $dCvn0.removeAll);
$977cc0295d3f184c$var$treeProto.root = (0, $1audT.default);
$977cc0295d3f184c$var$treeProto.size = (0, $lo9rr.default);
$977cc0295d3f184c$var$treeProto.visit = (0, $1ReeB.default);
$977cc0295d3f184c$var$treeProto.visitAfter = (0, $dfm4j.default);
$977cc0295d3f184c$var$treeProto.x = (0, $jepce.default);
$977cc0295d3f184c$var$treeProto.y = (0, $96eXQ.default);

});
parcelRegister("gjVyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $be1b12895c7da8cf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addAll", () => $be1b12895c7da8cf$export$32ed0561867ec8a1);
function $be1b12895c7da8cf$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d);
    return $be1b12895c7da8cf$var$add(this.cover(x, y), x, y, d);
}
function $be1b12895c7da8cf$var$add(tree, x, y, d) {
    if (isNaN(x) || isNaN(y)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, x1 = tree._x1, y1 = tree._y1, xm, ym, xp, yp, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (parent = node, !(node = node[i = bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    if (x === xp && y === yp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(4) : tree._root = new Array(4);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
    }while ((i = bottom << 1 | right) === (j = (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $be1b12895c7da8cf$export$32ed0561867ec8a1(data) {
    var d, i, n = data.length, x, y, xz = new Array(n), yz = new Array(n), x0 = Infinity, y0 = Infinity, x1 = -Infinity, y1 = -Infinity;
    // Compute the points and their extent.
    for(i = 0; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0).cover(x1, y1);
    // Add the new points.
    for(i = 0; i < n; ++i)$be1b12895c7da8cf$var$add(this, xz[i], yz[i], data[i]);
    return this;
}

});

parcelRegister("8h5eQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6063f984171c8523$export$2e2bcd8739ae039);
function $6063f984171c8523$export$2e2bcd8739ae039(x, y) {
    if (isNaN(x = +x) || isNaN(y = +y)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1;
    // If the quadtree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing quadrant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
    } else {
        var z = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1){
            i = (y < y0) << 1 | x < x0;
            parent = new Array(4), parent[i] = node, node = parent, z *= 2;
            switch(i){
                case 0:
                    x1 = x0 + z, y1 = y0 + z;
                    break;
                case 1:
                    x0 = x1 - z, y1 = y0 + z;
                    break;
                case 2:
                    x1 = x0 + z, y0 = y1 - z;
                    break;
                case 3:
                    x0 = x1 - z, y0 = y1 - z;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._x1 = x1;
    this._y1 = y1;
    return this;
}

});

parcelRegister("hQmlF", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd8a0ee53f875c5$export$2e2bcd8739ae039);
function $cfd8a0ee53f875c5$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}

});

parcelRegister("lSEe3", function(module, exports) {

$parcel$export(module.exports, "default", () => $feddd81cb3a1a5cd$export$2e2bcd8739ae039);
function $feddd81cb3a1a5cd$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1]).cover(+_[1][0], +_[1][1]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0
        ],
        [
            this._x1,
            this._y1
        ]
    ];
}

});

parcelRegister("fLzjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7a6a4e6ea4402cb$export$2e2bcd8739ae039);

var $a7Sel = parcelRequire("a7Sel");
function $b7a6a4e6ea4402cb$export$2e2bcd8739ae039(x, y, radius) {
    var data, x0 = this._x0, y0 = this._y0, x1, y1, x2, y2, x3 = this._x1, y3 = this._y1, quads = [], node = this._root, q, i;
    if (node) quads.push(new (0, $a7Sel.default)(node, x0, y0, x3, y3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius;
        x3 = x + radius, y3 = y + radius;
        radius *= radius;
    }
    while(q = quads.pop()){
        // Stop searching if this quadrant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0) continue;
        // Bisect the current quadrant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2;
            quads.push(new (0, $a7Sel.default)(node[3], xm, ym, x2, y2), new (0, $a7Sel.default)(node[2], x1, ym, xm, y2), new (0, $a7Sel.default)(node[1], xm, y1, x2, ym), new (0, $a7Sel.default)(node[0], x1, y1, xm, ym));
            // Visit the closest quadrant first.
            if (i = (y >= ym) << 1 | x >= xm) {
                q = quads[quads.length - 1];
                quads[quads.length - 1] = quads[quads.length - 1 - i];
                quads[quads.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), d2 = dx * dx + dy * dy;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d;
                x3 = x + d, y3 = y + d;
                data = node.data;
            }
        }
    }
    return data;
}

});
parcelRegister("a7Sel", function(module, exports) {

$parcel$export(module.exports, "default", () => $75f49fd5af8d23e7$export$2e2bcd8739ae039);
function $75f49fd5af8d23e7$export$2e2bcd8739ae039(node, x0, y0, x1, y1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
}

});


parcelRegister("dCvn0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ea7286cd6ff459a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "removeAll", () => $9ea7286cd6ff459a$export$1cfc7aad5cb1833b);
function $9ea7286cd6ff459a$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, x1 = this._x1, y1 = this._y1, x, y, xm, ym, right, bottom, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (!(parent = node, node = node[i = bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 3] || parent[i + 2 & 3] || parent[i + 3 & 3]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3]) && node === (parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $9ea7286cd6ff459a$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

});

parcelRegister("1audT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d9e2b498bba95b5$export$2e2bcd8739ae039);
function $0d9e2b498bba95b5$export$2e2bcd8739ae039() {
    return this._root;
}

});

parcelRegister("lo9rr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92329c600392ac7$export$2e2bcd8739ae039);
function $f92329c600392ac7$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}

});

parcelRegister("1ReeB", function(module, exports) {

$parcel$export(module.exports, "default", () => $15a5c85e382805ba$export$2e2bcd8739ae039);

var $a7Sel = parcelRequire("a7Sel");
function $15a5c85e382805ba$export$2e2bcd8739ae039(callback) {
    var quads = [], q, node = this._root, child, x0, y0, x1, y1;
    if (node) quads.push(new (0, $a7Sel.default)(node, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
        if (child = node[3]) quads.push(new (0, $a7Sel.default)(child, xm, ym, x1, y1));
        if (child = node[2]) quads.push(new (0, $a7Sel.default)(child, x0, ym, xm, y1));
        if (child = node[1]) quads.push(new (0, $a7Sel.default)(child, xm, y0, x1, ym));
        if (child = node[0]) quads.push(new (0, $a7Sel.default)(child, x0, y0, xm, ym));
    }
    return this;
}

});

parcelRegister("dfm4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a4dcb6a46603c0e$export$2e2bcd8739ae039);

var $a7Sel = parcelRequire("a7Sel");
function $9a4dcb6a46603c0e$export$2e2bcd8739ae039(callback) {
    var quads = [], next = [], q;
    if (this._root) quads.push(new (0, $a7Sel.default)(this._root, this._x0, this._y0, this._x1, this._y1));
    while(q = quads.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, x1 = q.x1, y1 = q.y1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2;
            if (child = node[0]) quads.push(new (0, $a7Sel.default)(child, x0, y0, xm, ym));
            if (child = node[1]) quads.push(new (0, $a7Sel.default)(child, xm, y0, x1, ym));
            if (child = node[2]) quads.push(new (0, $a7Sel.default)(child, x0, ym, xm, y1));
            if (child = node[3]) quads.push(new (0, $a7Sel.default)(child, xm, ym, x1, y1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.x1, q.y1);
    return this;
}

});

parcelRegister("jepce", function(module, exports) {

$parcel$export(module.exports, "defaultX", () => $e002de94352e4f40$export$e6fafc98131d2a44);
$parcel$export(module.exports, "default", () => $e002de94352e4f40$export$2e2bcd8739ae039);
function $e002de94352e4f40$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $e002de94352e4f40$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}

});

parcelRegister("96eXQ", function(module, exports) {

$parcel$export(module.exports, "defaultY", () => $6a00482922687876$export$6f0a21aeb844a64c);
$parcel$export(module.exports, "default", () => $6a00482922687876$export$2e2bcd8739ae039);
function $6a00482922687876$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $6a00482922687876$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}

});


parcelRegister("gx2Yb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0920825b99e823f$export$2e2bcd8739ae039);

var $i2goS = parcelRequire("i2goS");

var $jnaUn = parcelRequire("jnaUn");

var $fc3tS = parcelRequire("fc3tS");

var $iG3jI = parcelRequire("iG3jI");

var $dgJvt = parcelRequire("dgJvt");

var $lNxLs = parcelRequire("lNxLs");

var $ipBW3 = parcelRequire("ipBW3");

var $5Cq6q = parcelRequire("5Cq6q");

var $fvvkx = parcelRequire("fvvkx");

var $fvkc8 = parcelRequire("fvkc8");

var $558DB = parcelRequire("558DB");

var $5h8HF = parcelRequire("5h8HF");

var $e5ChC = parcelRequire("e5ChC");

var $9WNH5 = parcelRequire("9WNH5");
function $c0920825b99e823f$export$2e2bcd8739ae039(nodes, x, y, z) {
    var tree = new $c0920825b99e823f$var$Octree(x == null ? (0, $5h8HF.defaultX) : x, y == null ? (0, $e5ChC.defaultY) : y, z == null ? (0, $9WNH5.defaultZ) : z, NaN, NaN, NaN, NaN, NaN, NaN);
    return nodes == null ? tree : tree.addAll(nodes);
}
function $c0920825b99e823f$var$Octree(x, y, z, x0, y0, z0, x1, y1, z1) {
    this._x = x;
    this._y = y;
    this._z = z;
    this._x0 = x0;
    this._y0 = y0;
    this._z0 = z0;
    this._x1 = x1;
    this._y1 = y1;
    this._z1 = z1;
    this._root = undefined;
}
function $c0920825b99e823f$var$leaf_copy(leaf) {
    var copy = {
        data: leaf.data
    }, next = copy;
    while(leaf = leaf.next)next = next.next = {
        data: leaf.data
    };
    return copy;
}
var $c0920825b99e823f$var$treeProto = $c0920825b99e823f$export$2e2bcd8739ae039.prototype = $c0920825b99e823f$var$Octree.prototype;
$c0920825b99e823f$var$treeProto.copy = function() {
    var copy = new $c0920825b99e823f$var$Octree(this._x, this._y, this._z, this._x0, this._y0, this._z0, this._x1, this._y1, this._z1), node = this._root, nodes, child;
    if (!node) return copy;
    if (!node.length) return copy._root = $c0920825b99e823f$var$leaf_copy(node), copy;
    nodes = [
        {
            source: node,
            target: copy._root = new Array(8)
        }
    ];
    while(node = nodes.pop()){
        for(var i = 0; i < 8; ++i)if (child = node.source[i]) {
            if (child.length) nodes.push({
                source: child,
                target: node.target[i] = new Array(8)
            });
            else node.target[i] = $c0920825b99e823f$var$leaf_copy(child);
        }
    }
    return copy;
};
$c0920825b99e823f$var$treeProto.add = (0, $i2goS.default);
$c0920825b99e823f$var$treeProto.addAll = (0, $i2goS.addAll);
$c0920825b99e823f$var$treeProto.cover = (0, $jnaUn.default);
$c0920825b99e823f$var$treeProto.data = (0, $fc3tS.default);
$c0920825b99e823f$var$treeProto.extent = (0, $iG3jI.default);
$c0920825b99e823f$var$treeProto.find = (0, $dgJvt.default);
$c0920825b99e823f$var$treeProto.findAllWithinRadius = (0, $lNxLs.findAllWithinRadius);
$c0920825b99e823f$var$treeProto.remove = (0, $ipBW3.default);
$c0920825b99e823f$var$treeProto.removeAll = (0, $ipBW3.removeAll);
$c0920825b99e823f$var$treeProto.root = (0, $5Cq6q.default);
$c0920825b99e823f$var$treeProto.size = (0, $fvvkx.default);
$c0920825b99e823f$var$treeProto.visit = (0, $fvkc8.default);
$c0920825b99e823f$var$treeProto.visitAfter = (0, $558DB.default);
$c0920825b99e823f$var$treeProto.x = (0, $5h8HF.default);
$c0920825b99e823f$var$treeProto.y = (0, $e5ChC.default);
$c0920825b99e823f$var$treeProto.z = (0, $9WNH5.default);

});
parcelRegister("i2goS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d21522a7a85a91c2$export$2e2bcd8739ae039);
$parcel$export(module.exports, "addAll", () => $d21522a7a85a91c2$export$32ed0561867ec8a1);
function $d21522a7a85a91c2$export$2e2bcd8739ae039(d) {
    const x = +this._x.call(null, d), y = +this._y.call(null, d), z = +this._z.call(null, d);
    return $d21522a7a85a91c2$var$add(this.cover(x, y, z), x, y, z, d);
}
function $d21522a7a85a91c2$var$add(tree, x, y, z, d) {
    if (isNaN(x) || isNaN(y) || isNaN(z)) return tree; // ignore invalid points
    var parent, node = tree._root, leaf = {
        data: d
    }, x0 = tree._x0, y0 = tree._y0, z0 = tree._z0, x1 = tree._x1, y1 = tree._y1, z1 = tree._z1, xm, ym, zm, xp, yp, zp, right, bottom, deep, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return tree._root = leaf, tree;
    // Find the existing leaf for the new point, or add it.
    while(node.length){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (deep = z >= (zm = (z0 + z1) / 2)) z0 = zm;
        else z1 = zm;
        if (parent = node, !(node = node[i = deep << 2 | bottom << 1 | right])) return parent[i] = leaf, tree;
    }
    // Is the new point is exactly coincident with the existing point?
    xp = +tree._x.call(null, node.data);
    yp = +tree._y.call(null, node.data);
    zp = +tree._z.call(null, node.data);
    if (x === xp && y === yp && z === zp) return leaf.next = node, parent ? parent[i] = leaf : tree._root = leaf, tree;
    // Otherwise, split the leaf node until the old and new point are separated.
    do {
        parent = parent ? parent[i] = new Array(8) : tree._root = new Array(8);
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (deep = z >= (zm = (z0 + z1) / 2)) z0 = zm;
        else z1 = zm;
    }while ((i = deep << 2 | bottom << 1 | right) === (j = (zp >= zm) << 2 | (yp >= ym) << 1 | xp >= xm));
    return parent[j] = node, parent[i] = leaf, tree;
}
function $d21522a7a85a91c2$export$32ed0561867ec8a1(data) {
    if (!Array.isArray(data)) data = Array.from(data);
    const n = data.length;
    const xz = new Float64Array(n);
    const yz = new Float64Array(n);
    const zz = new Float64Array(n);
    let x0 = Infinity, y0 = Infinity, z0 = Infinity, x1 = -Infinity, y1 = -Infinity, z1 = -Infinity;
    // Compute the points and their extent.
    for(let i = 0, d, x, y, z; i < n; ++i){
        if (isNaN(x = +this._x.call(null, d = data[i])) || isNaN(y = +this._y.call(null, d)) || isNaN(z = +this._z.call(null, d))) continue;
        xz[i] = x;
        yz[i] = y;
        zz[i] = z;
        if (x < x0) x0 = x;
        if (x > x1) x1 = x;
        if (y < y0) y0 = y;
        if (y > y1) y1 = y;
        if (z < z0) z0 = z;
        if (z > z1) z1 = z;
    }
    // If there were no (valid) points, abort.
    if (x0 > x1 || y0 > y1 || z0 > z1) return this;
    // Expand the tree to cover the new points.
    this.cover(x0, y0, z0).cover(x1, y1, z1);
    // Add the new points.
    for(let i = 0; i < n; ++i)$d21522a7a85a91c2$var$add(this, xz[i], yz[i], zz[i], data[i]);
    return this;
}

});

parcelRegister("jnaUn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a8a07399b9cf06$export$2e2bcd8739ae039);
function $e1a8a07399b9cf06$export$2e2bcd8739ae039(x, y, z) {
    if (isNaN(x = +x) || isNaN(y = +y) || isNaN(z = +z)) return this; // ignore invalid points
    var x0 = this._x0, y0 = this._y0, z0 = this._z0, x1 = this._x1, y1 = this._y1, z1 = this._z1;
    // If the octree has no extent, initialize them.
    // Integer extent are necessary so that if we later double the extent,
    // the existing octant boundaries don’t change due to floating point error!
    if (isNaN(x0)) {
        x1 = (x0 = Math.floor(x)) + 1;
        y1 = (y0 = Math.floor(y)) + 1;
        z1 = (z0 = Math.floor(z)) + 1;
    } else {
        var t = x1 - x0 || 1, node = this._root, parent, i;
        while(x0 > x || x >= x1 || y0 > y || y >= y1 || z0 > z || z >= z1){
            i = (z < z0) << 2 | (y < y0) << 1 | x < x0;
            parent = new Array(8), parent[i] = node, node = parent, t *= 2;
            switch(i){
                case 0:
                    x1 = x0 + t, y1 = y0 + t, z1 = z0 + t;
                    break;
                case 1:
                    x0 = x1 - t, y1 = y0 + t, z1 = z0 + t;
                    break;
                case 2:
                    x1 = x0 + t, y0 = y1 - t, z1 = z0 + t;
                    break;
                case 3:
                    x0 = x1 - t, y0 = y1 - t, z1 = z0 + t;
                    break;
                case 4:
                    x1 = x0 + t, y1 = y0 + t, z0 = z1 - t;
                    break;
                case 5:
                    x0 = x1 - t, y1 = y0 + t, z0 = z1 - t;
                    break;
                case 6:
                    x1 = x0 + t, y0 = y1 - t, z0 = z1 - t;
                    break;
                case 7:
                    x0 = x1 - t, y0 = y1 - t, z0 = z1 - t;
                    break;
            }
        }
        if (this._root && this._root.length) this._root = node;
    }
    this._x0 = x0;
    this._y0 = y0;
    this._z0 = z0;
    this._x1 = x1;
    this._y1 = y1;
    this._z1 = z1;
    return this;
}

});

parcelRegister("fc3tS", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0faad390127ba70$export$2e2bcd8739ae039);
function $b0faad390127ba70$export$2e2bcd8739ae039() {
    var data = [];
    this.visit(function(node) {
        if (!node.length) do data.push(node.data);
        while (node = node.next);
    });
    return data;
}

});

parcelRegister("iG3jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d98eb8f22d167a52$export$2e2bcd8739ae039);
function $d98eb8f22d167a52$export$2e2bcd8739ae039(_) {
    return arguments.length ? this.cover(+_[0][0], +_[0][1], +_[0][2]).cover(+_[1][0], +_[1][1], +_[1][2]) : isNaN(this._x0) ? undefined : [
        [
            this._x0,
            this._y0,
            this._z0
        ],
        [
            this._x1,
            this._y1,
            this._z1
        ]
    ];
}

});

parcelRegister("dgJvt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a9011ab754ae1ca$export$2e2bcd8739ae039);

var $b5np6 = parcelRequire("b5np6");
function $9a9011ab754ae1ca$export$2e2bcd8739ae039(x, y, z, radius) {
    var data, x0 = this._x0, y0 = this._y0, z0 = this._z0, x1, y1, z1, x2, y2, z2, x3 = this._x1, y3 = this._y1, z3 = this._z1, octs = [], node = this._root, q, i;
    if (node) octs.push(new (0, $b5np6.default)(node, x0, y0, z0, x3, y3, z3));
    if (radius == null) radius = Infinity;
    else {
        x0 = x - radius, y0 = y - radius, z0 = z - radius;
        x3 = x + radius, y3 = y + radius, z3 = z + radius;
        radius *= radius;
    }
    while(q = octs.pop()){
        // Stop searching if this octant can’t contain a closer node.
        if (!(node = q.node) || (x1 = q.x0) > x3 || (y1 = q.y0) > y3 || (z1 = q.z0) > z3 || (x2 = q.x1) < x0 || (y2 = q.y1) < y0 || (z2 = q.z1) < z0) continue;
        // Bisect the current octant.
        if (node.length) {
            var xm = (x1 + x2) / 2, ym = (y1 + y2) / 2, zm = (z1 + z2) / 2;
            octs.push(new (0, $b5np6.default)(node[7], xm, ym, zm, x2, y2, z2), new (0, $b5np6.default)(node[6], x1, ym, zm, xm, y2, z2), new (0, $b5np6.default)(node[5], xm, y1, zm, x2, ym, z2), new (0, $b5np6.default)(node[4], x1, y1, zm, xm, ym, z2), new (0, $b5np6.default)(node[3], xm, ym, z1, x2, y2, zm), new (0, $b5np6.default)(node[2], x1, ym, z1, xm, y2, zm), new (0, $b5np6.default)(node[1], xm, y1, z1, x2, ym, zm), new (0, $b5np6.default)(node[0], x1, y1, z1, xm, ym, zm));
            // Visit the closest octant first.
            if (i = (z >= zm) << 2 | (y >= ym) << 1 | x >= xm) {
                q = octs[octs.length - 1];
                octs[octs.length - 1] = octs[octs.length - 1 - i];
                octs[octs.length - 1 - i] = q;
            }
        } else {
            var dx = x - +this._x.call(null, node.data), dy = y - +this._y.call(null, node.data), dz = z - +this._z.call(null, node.data), d2 = dx * dx + dy * dy + dz * dz;
            if (d2 < radius) {
                var d = Math.sqrt(radius = d2);
                x0 = x - d, y0 = y - d, z0 = z - d;
                x3 = x + d, y3 = y + d, z3 = z + d;
                data = node.data;
            }
        }
    }
    return data;
}

});
parcelRegister("b5np6", function(module, exports) {

$parcel$export(module.exports, "default", () => $812250d8480ea962$export$2e2bcd8739ae039);
function $812250d8480ea962$export$2e2bcd8739ae039(node, x0, y0, z0, x1, y1, z1) {
    this.node = node;
    this.x0 = x0;
    this.y0 = y0;
    this.z0 = z0;
    this.x1 = x1;
    this.y1 = y1;
    this.z1 = z1;
}

});


parcelRegister("lNxLs", function(module, exports) {

$parcel$export(module.exports, "findAllWithinRadius", () => $fde85d7e54ba2734$export$36c76be95711f426);
const $fde85d7e54ba2734$var$distance = (x1, y1, z1, x2, y2, z2)=>Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2 + (z1 - z2) ** 2);
function $fde85d7e54ba2734$export$36c76be95711f426(x, y, z, radius) {
    const result = [];
    const xMin = x - radius;
    const yMin = y - radius;
    const zMin = z - radius;
    const xMax = x + radius;
    const yMax = y + radius;
    const zMax = z + radius;
    this.visit((node, x1, y1, z1, x2, y2, z2)=>{
        if (!node.length) do {
            const d = node.data;
            if ($fde85d7e54ba2734$var$distance(x, y, z, this._x(d), this._y(d), this._z(d)) <= radius) result.push(d);
        }while (node = node.next);
        return x1 > xMax || y1 > yMax || z1 > zMax || x2 < xMin || y2 < yMin || z2 < zMin;
    });
    return result;
}

});

parcelRegister("ipBW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $d677fcf60e454087$export$2e2bcd8739ae039);
$parcel$export(module.exports, "removeAll", () => $d677fcf60e454087$export$1cfc7aad5cb1833b);
function $d677fcf60e454087$export$2e2bcd8739ae039(d) {
    if (isNaN(x = +this._x.call(null, d)) || isNaN(y = +this._y.call(null, d)) || isNaN(z = +this._z.call(null, d))) return this; // ignore invalid points
    var parent, node = this._root, retainer, previous, next, x0 = this._x0, y0 = this._y0, z0 = this._z0, x1 = this._x1, y1 = this._y1, z1 = this._z1, x, y, z, xm, ym, zm, right, bottom, deep, i, j;
    // If the tree is empty, initialize the root as a leaf.
    if (!node) return this;
    // Find the leaf node for the point.
    // While descending, also retain the deepest parent with a non-removed sibling.
    if (node.length) while(true){
        if (right = x >= (xm = (x0 + x1) / 2)) x0 = xm;
        else x1 = xm;
        if (bottom = y >= (ym = (y0 + y1) / 2)) y0 = ym;
        else y1 = ym;
        if (deep = z >= (zm = (z0 + z1) / 2)) z0 = zm;
        else z1 = zm;
        if (!(parent = node, node = node[i = deep << 2 | bottom << 1 | right])) return this;
        if (!node.length) break;
        if (parent[i + 1 & 7] || parent[i + 2 & 7] || parent[i + 3 & 7] || parent[i + 4 & 7] || parent[i + 5 & 7] || parent[i + 6 & 7] || parent[i + 7 & 7]) retainer = parent, j = i;
    }
    // Find the point to remove.
    while(node.data !== d)if (!(previous = node, node = node.next)) return this;
    if (next = node.next) delete node.next;
    // If there are multiple coincident points, remove just the point.
    if (previous) return next ? previous.next = next : delete previous.next, this;
    // If this is the root point, remove it.
    if (!parent) return this._root = next, this;
    // Remove this leaf.
    next ? parent[i] = next : delete parent[i];
    // If the parent now contains exactly one leaf, collapse superfluous parents.
    if ((node = parent[0] || parent[1] || parent[2] || parent[3] || parent[4] || parent[5] || parent[6] || parent[7]) && node === (parent[7] || parent[6] || parent[5] || parent[4] || parent[3] || parent[2] || parent[1] || parent[0]) && !node.length) {
        if (retainer) retainer[j] = node;
        else this._root = node;
    }
    return this;
}
function $d677fcf60e454087$export$1cfc7aad5cb1833b(data) {
    for(var i = 0, n = data.length; i < n; ++i)this.remove(data[i]);
    return this;
}

});

parcelRegister("5Cq6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4174bfc6ca39974a$export$2e2bcd8739ae039);
function $4174bfc6ca39974a$export$2e2bcd8739ae039() {
    return this._root;
}

});

parcelRegister("fvvkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4a20dcf80e902c5$export$2e2bcd8739ae039);
function $b4a20dcf80e902c5$export$2e2bcd8739ae039() {
    var size = 0;
    this.visit(function(node) {
        if (!node.length) do ++size;
        while (node = node.next);
    });
    return size;
}

});

parcelRegister("fvkc8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4996a8350fe675e$export$2e2bcd8739ae039);

var $b5np6 = parcelRequire("b5np6");
function $b4996a8350fe675e$export$2e2bcd8739ae039(callback) {
    var octs = [], q, node = this._root, child, x0, y0, z0, x1, y1, z1;
    if (node) octs.push(new (0, $b5np6.default)(node, this._x0, this._y0, this._z0, this._x1, this._y1, this._z1));
    while(q = octs.pop())if (!callback(node = q.node, x0 = q.x0, y0 = q.y0, z0 = q.z0, x1 = q.x1, y1 = q.y1, z1 = q.z1) && node.length) {
        var xm = (x0 + x1) / 2, ym = (y0 + y1) / 2, zm = (z0 + z1) / 2;
        if (child = node[7]) octs.push(new (0, $b5np6.default)(child, xm, ym, zm, x1, y1, z1));
        if (child = node[6]) octs.push(new (0, $b5np6.default)(child, x0, ym, zm, xm, y1, z1));
        if (child = node[5]) octs.push(new (0, $b5np6.default)(child, xm, y0, zm, x1, ym, z1));
        if (child = node[4]) octs.push(new (0, $b5np6.default)(child, x0, y0, zm, xm, ym, z1));
        if (child = node[3]) octs.push(new (0, $b5np6.default)(child, xm, ym, z0, x1, y1, zm));
        if (child = node[2]) octs.push(new (0, $b5np6.default)(child, x0, ym, z0, xm, y1, zm));
        if (child = node[1]) octs.push(new (0, $b5np6.default)(child, xm, y0, z0, x1, ym, zm));
        if (child = node[0]) octs.push(new (0, $b5np6.default)(child, x0, y0, z0, xm, ym, zm));
    }
    return this;
}

});

parcelRegister("558DB", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b341ea4c5e83f50$export$2e2bcd8739ae039);

var $b5np6 = parcelRequire("b5np6");
function $3b341ea4c5e83f50$export$2e2bcd8739ae039(callback) {
    var octs = [], next = [], q;
    if (this._root) octs.push(new (0, $b5np6.default)(this._root, this._x0, this._y0, this._z0, this._x1, this._y1, this._z1));
    while(q = octs.pop()){
        var node = q.node;
        if (node.length) {
            var child, x0 = q.x0, y0 = q.y0, z0 = q.z0, x1 = q.x1, y1 = q.y1, z1 = q.z1, xm = (x0 + x1) / 2, ym = (y0 + y1) / 2, zm = (z0 + z1) / 2;
            if (child = node[0]) octs.push(new (0, $b5np6.default)(child, x0, y0, z0, xm, ym, zm));
            if (child = node[1]) octs.push(new (0, $b5np6.default)(child, xm, y0, z0, x1, ym, zm));
            if (child = node[2]) octs.push(new (0, $b5np6.default)(child, x0, ym, z0, xm, y1, zm));
            if (child = node[3]) octs.push(new (0, $b5np6.default)(child, xm, ym, z0, x1, y1, zm));
            if (child = node[4]) octs.push(new (0, $b5np6.default)(child, x0, y0, zm, xm, ym, z1));
            if (child = node[5]) octs.push(new (0, $b5np6.default)(child, xm, y0, zm, x1, ym, z1));
            if (child = node[6]) octs.push(new (0, $b5np6.default)(child, x0, ym, zm, xm, y1, z1));
            if (child = node[7]) octs.push(new (0, $b5np6.default)(child, xm, ym, zm, x1, y1, z1));
        }
        next.push(q);
    }
    while(q = next.pop())callback(q.node, q.x0, q.y0, q.z0, q.x1, q.y1, q.z1);
    return this;
}

});

parcelRegister("5h8HF", function(module, exports) {

$parcel$export(module.exports, "defaultX", () => $3d754a90c7056106$export$e6fafc98131d2a44);
$parcel$export(module.exports, "default", () => $3d754a90c7056106$export$2e2bcd8739ae039);
function $3d754a90c7056106$export$e6fafc98131d2a44(d) {
    return d[0];
}
function $3d754a90c7056106$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._x = _, this) : this._x;
}

});

parcelRegister("e5ChC", function(module, exports) {

$parcel$export(module.exports, "defaultY", () => $a41f3a890178338c$export$6f0a21aeb844a64c);
$parcel$export(module.exports, "default", () => $a41f3a890178338c$export$2e2bcd8739ae039);
function $a41f3a890178338c$export$6f0a21aeb844a64c(d) {
    return d[1];
}
function $a41f3a890178338c$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._y = _, this) : this._y;
}

});

parcelRegister("9WNH5", function(module, exports) {

$parcel$export(module.exports, "defaultZ", () => $73e0140023f54adb$export$f56e419c070182d8);
$parcel$export(module.exports, "default", () => $73e0140023f54adb$export$2e2bcd8739ae039);
function $73e0140023f54adb$export$f56e419c070182d8(d) {
    return d[2];
}
function $73e0140023f54adb$export$2e2bcd8739ae039(_) {
    return arguments.length ? (this._z = _, this) : this._z;
}

});




parcelRegister("k9H1V", function(module, exports) {

$parcel$export(module.exports, "MDSLayout", () => $eac606cdc24953ba$export$6b075c289f9d9aa8);

var $7WQrb = parcelRequire("7WQrb");

var $gGKJ4 = parcelRequire("gGKJ4");
var $aDK3x = parcelRequire("aDK3x");

var $9nuNf = parcelRequire("9nuNf");
var $8e7dj = parcelRequire("8e7dj");

var $5Rnio = parcelRequire("5Rnio");
const $eac606cdc24953ba$var$DEFAULTS_LAYOUT_OPTIONS = {
    center: [
        0,
        0
    ],
    linkDistance: 50
};
class $eac606cdc24953ba$export$6b075c289f9d9aa8 {
    constructor(options = {}){
        this.options = options;
        this.id = 'mds';
        this.options = Object.assign(Object.assign({}, $eac606cdc24953ba$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericMDSLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericMDSLayout(true, graph, options);
        });
    }
    genericMDSLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const mergedOptions = Object.assign(Object.assign({}, this.options), options);
            const { center: center = [
                0,
                0
            ], linkDistance: linkDistance = 50 } = mergedOptions;
            const nodes = graph.getAllNodes();
            const edges = graph.getAllEdges();
            if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length) || nodes.length === 1) return (0, $5Rnio.handleSingleNodeGraph)(graph, assign, center);
            // the graph-theoretic distance (shortest path distance) matrix
            const adjMatrix = (0, $8e7dj.getAdjMatrix)({
                nodes: nodes,
                edges: edges
            }, false);
            const distances = (0, $8e7dj.floydWarshall)(adjMatrix);
            $eac606cdc24953ba$var$handleInfinity(distances);
            // scale the ideal edge length acoording to linkDistance
            const scaledD = (0, $8e7dj.scaleMatrix)(distances, linkDistance);
            // get positions by MDS
            const positions = $eac606cdc24953ba$var$runMDS(scaledD);
            const layoutNodes = [];
            positions.forEach((p, i)=>{
                const cnode = (0, $9nuNf.cloneFormatData)(nodes[i]);
                cnode.data.x = p[0] + center[0];
                cnode.data.y = p[1] + center[1];
                layoutNodes.push(cnode);
            });
            if (assign) layoutNodes.forEach((node)=>graph.mergeNodeData(node.id, {
                    x: node.data.x,
                    y: node.data.y
                }));
            const result = {
                nodes: layoutNodes,
                edges: edges
            };
            return result;
        });
    }
}
const $eac606cdc24953ba$var$handleInfinity = (distances)=>{
    let maxDistance = -999999;
    distances.forEach((row)=>{
        row.forEach((value)=>{
            if (value === Infinity) return;
            if (maxDistance < value) maxDistance = value;
        });
    });
    distances.forEach((row, i)=>{
        row.forEach((value, j)=>{
            if (value === Infinity) distances[i][j] = maxDistance;
        });
    });
};
/**
 * mds 算法
 * @return {array} positions 计算后的节点位置数组
 */ const $eac606cdc24953ba$var$runMDS = (distances)=>{
    const dimension = 2;
    // square distances
    const M = (0, $gGKJ4.default).mul((0, $gGKJ4.default).pow(distances, 2), -0.5);
    // double centre the rows/columns
    const rowMeans = M.mean('row');
    const colMeans = M.mean('column');
    const totalMean = M.mean();
    M.add(totalMean).subRowVector(rowMeans).subColumnVector(colMeans);
    // take the SVD of the double centred matrix, and return the
    // points from it
    const ret = new (0, $aDK3x.default)(M);
    const eigenValues = (0, $gGKJ4.default).sqrt(ret.diagonalMatrix).diagonal();
    return ret.leftSingularVectors.toJSON().map((row)=>{
        return (0, $gGKJ4.default).mul([
            row
        ], [
            eigenValues
        ]).toJSON()[0].splice(0, dimension);
    });
};

});
parcelRegister("gGKJ4", function(module, exports) {

$parcel$export(module.exports, "AbstractMatrix", () => $c264d068d49d06d8$export$4b275fa73feb14fa);
$parcel$export(module.exports, "default", () => $c264d068d49d06d8$export$2e2bcd8739ae039);

var $iyj1l = parcelRequire("iyj1l");

var $iJ72H = parcelRequire("iJ72H");

var $gBIpq = parcelRequire("gBIpq");

var $1MrQ0 = parcelRequire("1MrQ0");

var $7J0w1 = parcelRequire("7J0w1");

var $cbd2a = parcelRequire("cbd2a");
class $c264d068d49d06d8$export$4b275fa73feb14fa {
    static from1DArray(newRows, newColumns, newData) {
        let length = newRows * newColumns;
        if (length !== newData.length) throw new RangeError('data length does not match given dimensions');
        let newMatrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(newRows, newColumns);
        for(let row = 0; row < newRows; row++)for(let column = 0; column < newColumns; column++)newMatrix.set(row, column, newData[row * newColumns + column]);
        return newMatrix;
    }
    static rowVector(newData) {
        let vector = new $c264d068d49d06d8$export$2e2bcd8739ae039(1, newData.length);
        for(let i = 0; i < newData.length; i++)vector.set(0, i, newData[i]);
        return vector;
    }
    static columnVector(newData) {
        let vector = new $c264d068d49d06d8$export$2e2bcd8739ae039(newData.length, 1);
        for(let i = 0; i < newData.length; i++)vector.set(i, 0, newData[i]);
        return vector;
    }
    static zeros(rows, columns) {
        return new $c264d068d49d06d8$export$2e2bcd8739ae039(rows, columns);
    }
    static ones(rows, columns) {
        return new $c264d068d49d06d8$export$2e2bcd8739ae039(rows, columns).fill(1);
    }
    static rand(rows, columns, options = {}) {
        if (typeof options !== 'object') throw new TypeError('options must be an object');
        const { random: random = Math.random } = options;
        let matrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(rows, columns);
        for(let i = 0; i < rows; i++)for(let j = 0; j < columns; j++)matrix.set(i, j, random());
        return matrix;
    }
    static randInt(rows, columns, options = {}) {
        if (typeof options !== 'object') throw new TypeError('options must be an object');
        const { min: min = 0, max: max = 1000, random: random = Math.random } = options;
        if (!Number.isInteger(min)) throw new TypeError('min must be an integer');
        if (!Number.isInteger(max)) throw new TypeError('max must be an integer');
        if (min >= max) throw new RangeError('min must be smaller than max');
        let interval = max - min;
        let matrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(rows, columns);
        for(let i = 0; i < rows; i++)for(let j = 0; j < columns; j++){
            let value = min + Math.round(random() * interval);
            matrix.set(i, j, value);
        }
        return matrix;
    }
    static eye(rows, columns, value) {
        if (columns === undefined) columns = rows;
        if (value === undefined) value = 1;
        let min = Math.min(rows, columns);
        let matrix = this.zeros(rows, columns);
        for(let i = 0; i < min; i++)matrix.set(i, i, value);
        return matrix;
    }
    static diag(data, rows, columns) {
        let l = data.length;
        if (rows === undefined) rows = l;
        if (columns === undefined) columns = rows;
        let min = Math.min(l, rows, columns);
        let matrix = this.zeros(rows, columns);
        for(let i = 0; i < min; i++)matrix.set(i, i, data[i]);
        return matrix;
    }
    static min(matrix1, matrix2) {
        matrix1 = this.checkMatrix(matrix1);
        matrix2 = this.checkMatrix(matrix2);
        let rows = matrix1.rows;
        let columns = matrix1.columns;
        let result = new $c264d068d49d06d8$export$2e2bcd8739ae039(rows, columns);
        for(let i = 0; i < rows; i++)for(let j = 0; j < columns; j++)result.set(i, j, Math.min(matrix1.get(i, j), matrix2.get(i, j)));
        return result;
    }
    static max(matrix1, matrix2) {
        matrix1 = this.checkMatrix(matrix1);
        matrix2 = this.checkMatrix(matrix2);
        let rows = matrix1.rows;
        let columns = matrix1.columns;
        let result = new this(rows, columns);
        for(let i = 0; i < rows; i++)for(let j = 0; j < columns; j++)result.set(i, j, Math.max(matrix1.get(i, j), matrix2.get(i, j)));
        return result;
    }
    static checkMatrix(value) {
        return $c264d068d49d06d8$export$4b275fa73feb14fa.isMatrix(value) ? value : new $c264d068d49d06d8$export$2e2bcd8739ae039(value);
    }
    static isMatrix(value) {
        return value != null && value.klass === 'Matrix';
    }
    get size() {
        return this.rows * this.columns;
    }
    apply(callback) {
        if (typeof callback !== 'function') throw new TypeError('callback must be a function');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)callback.call(this, i, j);
        return this;
    }
    to1DArray() {
        let array = [];
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)array.push(this.get(i, j));
        return array;
    }
    to2DArray() {
        let copy = [];
        for(let i = 0; i < this.rows; i++){
            copy.push([]);
            for(let j = 0; j < this.columns; j++)copy[i].push(this.get(i, j));
        }
        return copy;
    }
    toJSON() {
        return this.to2DArray();
    }
    isRowVector() {
        return this.rows === 1;
    }
    isColumnVector() {
        return this.columns === 1;
    }
    isVector() {
        return this.rows === 1 || this.columns === 1;
    }
    isSquare() {
        return this.rows === this.columns;
    }
    isEmpty() {
        return this.rows === 0 || this.columns === 0;
    }
    isSymmetric() {
        if (this.isSquare()) {
            for(let i = 0; i < this.rows; i++)for(let j = 0; j <= i; j++){
                if (this.get(i, j) !== this.get(j, i)) return false;
            }
            return true;
        }
        return false;
    }
    isDistance() {
        if (!this.isSymmetric()) return false;
        for(let i = 0; i < this.rows; i++){
            if (this.get(i, i) !== 0) return false;
        }
        return true;
    }
    isEchelonForm() {
        let i = 0;
        let j = 0;
        let previousColumn = -1;
        let isEchelonForm = true;
        let checked = false;
        while(i < this.rows && isEchelonForm){
            j = 0;
            checked = false;
            while(j < this.columns && checked === false){
                if (this.get(i, j) === 0) j++;
                else if (this.get(i, j) === 1 && j > previousColumn) {
                    checked = true;
                    previousColumn = j;
                } else {
                    isEchelonForm = false;
                    checked = true;
                }
            }
            i++;
        }
        return isEchelonForm;
    }
    isReducedEchelonForm() {
        let i = 0;
        let j = 0;
        let previousColumn = -1;
        let isReducedEchelonForm = true;
        let checked = false;
        while(i < this.rows && isReducedEchelonForm){
            j = 0;
            checked = false;
            while(j < this.columns && checked === false){
                if (this.get(i, j) === 0) j++;
                else if (this.get(i, j) === 1 && j > previousColumn) {
                    checked = true;
                    previousColumn = j;
                } else {
                    isReducedEchelonForm = false;
                    checked = true;
                }
            }
            for(let k = j + 1; k < this.rows; k++)if (this.get(i, k) !== 0) isReducedEchelonForm = false;
            i++;
        }
        return isReducedEchelonForm;
    }
    echelonForm() {
        let result = this.clone();
        let h = 0;
        let k = 0;
        while(h < result.rows && k < result.columns){
            let iMax = h;
            for(let i = h; i < result.rows; i++)if (result.get(i, k) > result.get(iMax, k)) iMax = i;
            if (result.get(iMax, k) === 0) k++;
            else {
                result.swapRows(h, iMax);
                let tmp = result.get(h, k);
                for(let j = k; j < result.columns; j++)result.set(h, j, result.get(h, j) / tmp);
                for(let i = h + 1; i < result.rows; i++){
                    let factor = result.get(i, k) / result.get(h, k);
                    result.set(i, k, 0);
                    for(let j = k + 1; j < result.columns; j++)result.set(i, j, result.get(i, j) - result.get(h, j) * factor);
                }
                h++;
                k++;
            }
        }
        return result;
    }
    reducedEchelonForm() {
        let result = this.echelonForm();
        let m = result.columns;
        let n = result.rows;
        let h = n - 1;
        while(h >= 0)if (result.maxRow(h) === 0) h--;
        else {
            let p = 0;
            let pivot = false;
            while(p < n && pivot === false)if (result.get(h, p) === 1) pivot = true;
            else p++;
            for(let i = 0; i < h; i++){
                let factor = result.get(i, p);
                for(let j = p; j < m; j++){
                    let tmp = result.get(i, j) - factor * result.get(h, j);
                    result.set(i, j, tmp);
                }
            }
            h--;
        }
        return result;
    }
    set() {
        throw new Error('set method is unimplemented');
    }
    get() {
        throw new Error('get method is unimplemented');
    }
    repeat(options = {}) {
        if (typeof options !== 'object') throw new TypeError('options must be an object');
        const { rows: rows = 1, columns: columns = 1 } = options;
        if (!Number.isInteger(rows) || rows <= 0) throw new TypeError('rows must be a positive integer');
        if (!Number.isInteger(columns) || columns <= 0) throw new TypeError('columns must be a positive integer');
        let matrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(this.rows * rows, this.columns * columns);
        for(let i = 0; i < rows; i++)for(let j = 0; j < columns; j++)matrix.setSubMatrix(this, this.rows * i, this.columns * j);
        return matrix;
    }
    fill(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, value);
        return this;
    }
    neg() {
        return this.mulS(-1);
    }
    getRow(index) {
        (0, $cbd2a.checkRowIndex)(this, index);
        let row = [];
        for(let i = 0; i < this.columns; i++)row.push(this.get(index, i));
        return row;
    }
    getRowVector(index) {
        return $c264d068d49d06d8$export$2e2bcd8739ae039.rowVector(this.getRow(index));
    }
    setRow(index, array) {
        (0, $cbd2a.checkRowIndex)(this, index);
        array = (0, $cbd2a.checkRowVector)(this, array);
        for(let i = 0; i < this.columns; i++)this.set(index, i, array[i]);
        return this;
    }
    swapRows(row1, row2) {
        (0, $cbd2a.checkRowIndex)(this, row1);
        (0, $cbd2a.checkRowIndex)(this, row2);
        for(let i = 0; i < this.columns; i++){
            let temp = this.get(row1, i);
            this.set(row1, i, this.get(row2, i));
            this.set(row2, i, temp);
        }
        return this;
    }
    getColumn(index) {
        (0, $cbd2a.checkColumnIndex)(this, index);
        let column = [];
        for(let i = 0; i < this.rows; i++)column.push(this.get(i, index));
        return column;
    }
    getColumnVector(index) {
        return $c264d068d49d06d8$export$2e2bcd8739ae039.columnVector(this.getColumn(index));
    }
    setColumn(index, array) {
        (0, $cbd2a.checkColumnIndex)(this, index);
        array = (0, $cbd2a.checkColumnVector)(this, array);
        for(let i = 0; i < this.rows; i++)this.set(i, index, array[i]);
        return this;
    }
    swapColumns(column1, column2) {
        (0, $cbd2a.checkColumnIndex)(this, column1);
        (0, $cbd2a.checkColumnIndex)(this, column2);
        for(let i = 0; i < this.rows; i++){
            let temp = this.get(i, column1);
            this.set(i, column1, this.get(i, column2));
            this.set(i, column2, temp);
        }
        return this;
    }
    addRowVector(vector) {
        vector = (0, $cbd2a.checkRowVector)(this, vector);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) + vector[j]);
        return this;
    }
    subRowVector(vector) {
        vector = (0, $cbd2a.checkRowVector)(this, vector);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) - vector[j]);
        return this;
    }
    mulRowVector(vector) {
        vector = (0, $cbd2a.checkRowVector)(this, vector);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) * vector[j]);
        return this;
    }
    divRowVector(vector) {
        vector = (0, $cbd2a.checkRowVector)(this, vector);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) / vector[j]);
        return this;
    }
    addColumnVector(vector) {
        vector = (0, $cbd2a.checkColumnVector)(this, vector);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) + vector[i]);
        return this;
    }
    subColumnVector(vector) {
        vector = (0, $cbd2a.checkColumnVector)(this, vector);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) - vector[i]);
        return this;
    }
    mulColumnVector(vector) {
        vector = (0, $cbd2a.checkColumnVector)(this, vector);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) * vector[i]);
        return this;
    }
    divColumnVector(vector) {
        vector = (0, $cbd2a.checkColumnVector)(this, vector);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) / vector[i]);
        return this;
    }
    mulRow(index, value) {
        (0, $cbd2a.checkRowIndex)(this, index);
        for(let i = 0; i < this.columns; i++)this.set(index, i, this.get(index, i) * value);
        return this;
    }
    mulColumn(index, value) {
        (0, $cbd2a.checkColumnIndex)(this, index);
        for(let i = 0; i < this.rows; i++)this.set(i, index, this.get(i, index) * value);
        return this;
    }
    max(by) {
        if (this.isEmpty()) return NaN;
        switch(by){
            case 'row':
                {
                    const max = new Array(this.rows).fill(Number.NEGATIVE_INFINITY);
                    for(let row = 0; row < this.rows; row++){
                        for(let column = 0; column < this.columns; column++)if (this.get(row, column) > max[row]) max[row] = this.get(row, column);
                    }
                    return max;
                }
            case 'column':
                {
                    const max = new Array(this.columns).fill(Number.NEGATIVE_INFINITY);
                    for(let row = 0; row < this.rows; row++){
                        for(let column = 0; column < this.columns; column++)if (this.get(row, column) > max[column]) max[column] = this.get(row, column);
                    }
                    return max;
                }
            case undefined:
                {
                    let max = this.get(0, 0);
                    for(let row = 0; row < this.rows; row++){
                        for(let column = 0; column < this.columns; column++)if (this.get(row, column) > max) max = this.get(row, column);
                    }
                    return max;
                }
            default:
                throw new Error(`invalid option: ${by}`);
        }
    }
    maxIndex() {
        (0, $cbd2a.checkNonEmpty)(this);
        let v = this.get(0, 0);
        let idx = [
            0,
            0
        ];
        for(let i = 0; i < this.rows; i++){
            for(let j = 0; j < this.columns; j++)if (this.get(i, j) > v) {
                v = this.get(i, j);
                idx[0] = i;
                idx[1] = j;
            }
        }
        return idx;
    }
    min(by) {
        if (this.isEmpty()) return NaN;
        switch(by){
            case 'row':
                {
                    const min = new Array(this.rows).fill(Number.POSITIVE_INFINITY);
                    for(let row = 0; row < this.rows; row++){
                        for(let column = 0; column < this.columns; column++)if (this.get(row, column) < min[row]) min[row] = this.get(row, column);
                    }
                    return min;
                }
            case 'column':
                {
                    const min = new Array(this.columns).fill(Number.POSITIVE_INFINITY);
                    for(let row = 0; row < this.rows; row++){
                        for(let column = 0; column < this.columns; column++)if (this.get(row, column) < min[column]) min[column] = this.get(row, column);
                    }
                    return min;
                }
            case undefined:
                {
                    let min = this.get(0, 0);
                    for(let row = 0; row < this.rows; row++){
                        for(let column = 0; column < this.columns; column++)if (this.get(row, column) < min) min = this.get(row, column);
                    }
                    return min;
                }
            default:
                throw new Error(`invalid option: ${by}`);
        }
    }
    minIndex() {
        (0, $cbd2a.checkNonEmpty)(this);
        let v = this.get(0, 0);
        let idx = [
            0,
            0
        ];
        for(let i = 0; i < this.rows; i++){
            for(let j = 0; j < this.columns; j++)if (this.get(i, j) < v) {
                v = this.get(i, j);
                idx[0] = i;
                idx[1] = j;
            }
        }
        return idx;
    }
    maxRow(row) {
        (0, $cbd2a.checkRowIndex)(this, row);
        if (this.isEmpty()) return NaN;
        let v = this.get(row, 0);
        for(let i = 1; i < this.columns; i++)if (this.get(row, i) > v) v = this.get(row, i);
        return v;
    }
    maxRowIndex(row) {
        (0, $cbd2a.checkRowIndex)(this, row);
        (0, $cbd2a.checkNonEmpty)(this);
        let v = this.get(row, 0);
        let idx = [
            row,
            0
        ];
        for(let i = 1; i < this.columns; i++)if (this.get(row, i) > v) {
            v = this.get(row, i);
            idx[1] = i;
        }
        return idx;
    }
    minRow(row) {
        (0, $cbd2a.checkRowIndex)(this, row);
        if (this.isEmpty()) return NaN;
        let v = this.get(row, 0);
        for(let i = 1; i < this.columns; i++)if (this.get(row, i) < v) v = this.get(row, i);
        return v;
    }
    minRowIndex(row) {
        (0, $cbd2a.checkRowIndex)(this, row);
        (0, $cbd2a.checkNonEmpty)(this);
        let v = this.get(row, 0);
        let idx = [
            row,
            0
        ];
        for(let i = 1; i < this.columns; i++)if (this.get(row, i) < v) {
            v = this.get(row, i);
            idx[1] = i;
        }
        return idx;
    }
    maxColumn(column) {
        (0, $cbd2a.checkColumnIndex)(this, column);
        if (this.isEmpty()) return NaN;
        let v = this.get(0, column);
        for(let i = 1; i < this.rows; i++)if (this.get(i, column) > v) v = this.get(i, column);
        return v;
    }
    maxColumnIndex(column) {
        (0, $cbd2a.checkColumnIndex)(this, column);
        (0, $cbd2a.checkNonEmpty)(this);
        let v = this.get(0, column);
        let idx = [
            0,
            column
        ];
        for(let i = 1; i < this.rows; i++)if (this.get(i, column) > v) {
            v = this.get(i, column);
            idx[0] = i;
        }
        return idx;
    }
    minColumn(column) {
        (0, $cbd2a.checkColumnIndex)(this, column);
        if (this.isEmpty()) return NaN;
        let v = this.get(0, column);
        for(let i = 1; i < this.rows; i++)if (this.get(i, column) < v) v = this.get(i, column);
        return v;
    }
    minColumnIndex(column) {
        (0, $cbd2a.checkColumnIndex)(this, column);
        (0, $cbd2a.checkNonEmpty)(this);
        let v = this.get(0, column);
        let idx = [
            0,
            column
        ];
        for(let i = 1; i < this.rows; i++)if (this.get(i, column) < v) {
            v = this.get(i, column);
            idx[0] = i;
        }
        return idx;
    }
    diag() {
        let min = Math.min(this.rows, this.columns);
        let diag = [];
        for(let i = 0; i < min; i++)diag.push(this.get(i, i));
        return diag;
    }
    norm(type = 'frobenius') {
        switch(type){
            case 'max':
                return this.max();
            case 'frobenius':
                return Math.sqrt(this.dot(this));
            default:
                throw new RangeError(`unknown norm type: ${type}`);
        }
    }
    cumulativeSum() {
        let sum = 0;
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++){
            sum += this.get(i, j);
            this.set(i, j, sum);
        }
        return this;
    }
    dot(vector2) {
        if ($c264d068d49d06d8$export$4b275fa73feb14fa.isMatrix(vector2)) vector2 = vector2.to1DArray();
        let vector1 = this.to1DArray();
        if (vector1.length !== vector2.length) throw new RangeError('vectors do not have the same size');
        let dot = 0;
        for(let i = 0; i < vector1.length; i++)dot += vector1[i] * vector2[i];
        return dot;
    }
    mmul(other) {
        other = $c264d068d49d06d8$export$2e2bcd8739ae039.checkMatrix(other);
        let m = this.rows;
        let n = this.columns;
        let p = other.columns;
        let result = new $c264d068d49d06d8$export$2e2bcd8739ae039(m, p);
        let Bcolj = new Float64Array(n);
        for(let j = 0; j < p; j++){
            for(let k = 0; k < n; k++)Bcolj[k] = other.get(k, j);
            for(let i = 0; i < m; i++){
                let s = 0;
                for(let k = 0; k < n; k++)s += this.get(i, k) * Bcolj[k];
                result.set(i, j, s);
            }
        }
        return result;
    }
    mpow(scalar) {
        if (!this.isSquare()) throw new RangeError('Matrix must be square');
        if (!Number.isInteger(scalar) || scalar < 0) throw new RangeError('Exponent must be a non-negative integer');
        // Russian Peasant exponentiation, i.e. exponentiation by squaring
        let result = $c264d068d49d06d8$export$2e2bcd8739ae039.eye(this.rows);
        let bb = this;
        // Note: Don't bit shift. In JS, that would truncate at 32 bits
        for(let e = scalar; e >= 1; e /= 2){
            if ((e & 1) !== 0) result = result.mmul(bb);
            bb = bb.mmul(bb);
        }
        return result;
    }
    strassen2x2(other) {
        other = $c264d068d49d06d8$export$2e2bcd8739ae039.checkMatrix(other);
        let result = new $c264d068d49d06d8$export$2e2bcd8739ae039(2, 2);
        const a11 = this.get(0, 0);
        const b11 = other.get(0, 0);
        const a12 = this.get(0, 1);
        const b12 = other.get(0, 1);
        const a21 = this.get(1, 0);
        const b21 = other.get(1, 0);
        const a22 = this.get(1, 1);
        const b22 = other.get(1, 1);
        // Compute intermediate values.
        const m1 = (a11 + a22) * (b11 + b22);
        const m2 = (a21 + a22) * b11;
        const m3 = a11 * (b12 - b22);
        const m4 = a22 * (b21 - b11);
        const m5 = (a11 + a12) * b22;
        const m6 = (a21 - a11) * (b11 + b12);
        const m7 = (a12 - a22) * (b21 + b22);
        // Combine intermediate values into the output.
        const c00 = m1 + m4 - m5 + m7;
        const c01 = m3 + m5;
        const c10 = m2 + m4;
        const c11 = m1 - m2 + m3 + m6;
        result.set(0, 0, c00);
        result.set(0, 1, c01);
        result.set(1, 0, c10);
        result.set(1, 1, c11);
        return result;
    }
    strassen3x3(other) {
        other = $c264d068d49d06d8$export$2e2bcd8739ae039.checkMatrix(other);
        let result = new $c264d068d49d06d8$export$2e2bcd8739ae039(3, 3);
        const a00 = this.get(0, 0);
        const a01 = this.get(0, 1);
        const a02 = this.get(0, 2);
        const a10 = this.get(1, 0);
        const a11 = this.get(1, 1);
        const a12 = this.get(1, 2);
        const a20 = this.get(2, 0);
        const a21 = this.get(2, 1);
        const a22 = this.get(2, 2);
        const b00 = other.get(0, 0);
        const b01 = other.get(0, 1);
        const b02 = other.get(0, 2);
        const b10 = other.get(1, 0);
        const b11 = other.get(1, 1);
        const b12 = other.get(1, 2);
        const b20 = other.get(2, 0);
        const b21 = other.get(2, 1);
        const b22 = other.get(2, 2);
        const m1 = (a00 + a01 + a02 - a10 - a11 - a21 - a22) * b11;
        const m2 = (a00 - a10) * (-b01 + b11);
        const m3 = a11 * (-b00 + b01 + b10 - b11 - b12 - b20 + b22);
        const m4 = (-a00 + a10 + a11) * (b00 - b01 + b11);
        const m5 = (a10 + a11) * (-b00 + b01);
        const m6 = a00 * b00;
        const m7 = (-a00 + a20 + a21) * (b00 - b02 + b12);
        const m8 = (-a00 + a20) * (b02 - b12);
        const m9 = (a20 + a21) * (-b00 + b02);
        const m10 = (a00 + a01 + a02 - a11 - a12 - a20 - a21) * b12;
        const m11 = a21 * (-b00 + b02 + b10 - b11 - b12 - b20 + b21);
        const m12 = (-a02 + a21 + a22) * (b11 + b20 - b21);
        const m13 = (a02 - a22) * (b11 - b21);
        const m14 = a02 * b20;
        const m15 = (a21 + a22) * (-b20 + b21);
        const m16 = (-a02 + a11 + a12) * (b12 + b20 - b22);
        const m17 = (a02 - a12) * (b12 - b22);
        const m18 = (a11 + a12) * (-b20 + b22);
        const m19 = a01 * b10;
        const m20 = a12 * b21;
        const m21 = a10 * b02;
        const m22 = a20 * b01;
        const m23 = a22 * b22;
        const c00 = m6 + m14 + m19;
        const c01 = m1 + m4 + m5 + m6 + m12 + m14 + m15;
        const c02 = m6 + m7 + m9 + m10 + m14 + m16 + m18;
        const c10 = m2 + m3 + m4 + m6 + m14 + m16 + m17;
        const c11 = m2 + m4 + m5 + m6 + m20;
        const c12 = m14 + m16 + m17 + m18 + m21;
        const c20 = m6 + m7 + m8 + m11 + m12 + m13 + m14;
        const c21 = m12 + m13 + m14 + m15 + m22;
        const c22 = m6 + m7 + m8 + m9 + m23;
        result.set(0, 0, c00);
        result.set(0, 1, c01);
        result.set(0, 2, c02);
        result.set(1, 0, c10);
        result.set(1, 1, c11);
        result.set(1, 2, c12);
        result.set(2, 0, c20);
        result.set(2, 1, c21);
        result.set(2, 2, c22);
        return result;
    }
    mmulStrassen(y) {
        y = $c264d068d49d06d8$export$2e2bcd8739ae039.checkMatrix(y);
        let x = this.clone();
        let r1 = x.rows;
        let c1 = x.columns;
        let r2 = y.rows;
        let c2 = y.columns;
        if (c1 !== r2) // eslint-disable-next-line no-console
        console.warn(`Multiplying ${r1} x ${c1} and ${r2} x ${c2} matrix: dimensions do not match.`);
        // Put a matrix into the top left of a matrix of zeros.
        // `rows` and `cols` are the dimensions of the output matrix.
        function embed(mat, rows, cols) {
            let r = mat.rows;
            let c = mat.columns;
            if (r === rows && c === cols) return mat;
            else {
                let resultat = $c264d068d49d06d8$export$4b275fa73feb14fa.zeros(rows, cols);
                resultat = resultat.setSubMatrix(mat, 0, 0);
                return resultat;
            }
        }
        // Make sure both matrices are the same size.
        // This is exclusively for simplicity:
        // this algorithm can be implemented with matrices of different sizes.
        let r = Math.max(r1, r2);
        let c = Math.max(c1, c2);
        x = embed(x, r, c);
        y = embed(y, r, c);
        // Our recursive multiplication function.
        function blockMult(a, b, rows, cols) {
            // For small matrices, resort to naive multiplication.
            if (rows <= 512 || cols <= 512) return a.mmul(b); // a is equivalent to this
            // Apply dynamic padding.
            if (rows % 2 === 1 && cols % 2 === 1) {
                a = embed(a, rows + 1, cols + 1);
                b = embed(b, rows + 1, cols + 1);
            } else if (rows % 2 === 1) {
                a = embed(a, rows + 1, cols);
                b = embed(b, rows + 1, cols);
            } else if (cols % 2 === 1) {
                a = embed(a, rows, cols + 1);
                b = embed(b, rows, cols + 1);
            }
            let halfRows = parseInt(a.rows / 2, 10);
            let halfCols = parseInt(a.columns / 2, 10);
            // Subdivide input matrices.
            let a11 = a.subMatrix(0, halfRows - 1, 0, halfCols - 1);
            let b11 = b.subMatrix(0, halfRows - 1, 0, halfCols - 1);
            let a12 = a.subMatrix(0, halfRows - 1, halfCols, a.columns - 1);
            let b12 = b.subMatrix(0, halfRows - 1, halfCols, b.columns - 1);
            let a21 = a.subMatrix(halfRows, a.rows - 1, 0, halfCols - 1);
            let b21 = b.subMatrix(halfRows, b.rows - 1, 0, halfCols - 1);
            let a22 = a.subMatrix(halfRows, a.rows - 1, halfCols, a.columns - 1);
            let b22 = b.subMatrix(halfRows, b.rows - 1, halfCols, b.columns - 1);
            // Compute intermediate values.
            let m1 = blockMult($c264d068d49d06d8$export$4b275fa73feb14fa.add(a11, a22), $c264d068d49d06d8$export$4b275fa73feb14fa.add(b11, b22), halfRows, halfCols);
            let m2 = blockMult($c264d068d49d06d8$export$4b275fa73feb14fa.add(a21, a22), b11, halfRows, halfCols);
            let m3 = blockMult(a11, $c264d068d49d06d8$export$4b275fa73feb14fa.sub(b12, b22), halfRows, halfCols);
            let m4 = blockMult(a22, $c264d068d49d06d8$export$4b275fa73feb14fa.sub(b21, b11), halfRows, halfCols);
            let m5 = blockMult($c264d068d49d06d8$export$4b275fa73feb14fa.add(a11, a12), b22, halfRows, halfCols);
            let m6 = blockMult($c264d068d49d06d8$export$4b275fa73feb14fa.sub(a21, a11), $c264d068d49d06d8$export$4b275fa73feb14fa.add(b11, b12), halfRows, halfCols);
            let m7 = blockMult($c264d068d49d06d8$export$4b275fa73feb14fa.sub(a12, a22), $c264d068d49d06d8$export$4b275fa73feb14fa.add(b21, b22), halfRows, halfCols);
            // Combine intermediate values into the output.
            let c11 = $c264d068d49d06d8$export$4b275fa73feb14fa.add(m1, m4);
            c11.sub(m5);
            c11.add(m7);
            let c12 = $c264d068d49d06d8$export$4b275fa73feb14fa.add(m3, m5);
            let c21 = $c264d068d49d06d8$export$4b275fa73feb14fa.add(m2, m4);
            let c22 = $c264d068d49d06d8$export$4b275fa73feb14fa.sub(m1, m2);
            c22.add(m3);
            c22.add(m6);
            // Crop output to the desired size (undo dynamic padding).
            let result = $c264d068d49d06d8$export$4b275fa73feb14fa.zeros(2 * c11.rows, 2 * c11.columns);
            result = result.setSubMatrix(c11, 0, 0);
            result = result.setSubMatrix(c12, c11.rows, 0);
            result = result.setSubMatrix(c21, 0, c11.columns);
            result = result.setSubMatrix(c22, c11.rows, c11.columns);
            return result.subMatrix(0, rows - 1, 0, cols - 1);
        }
        return blockMult(x, y, r, c);
    }
    scaleRows(options = {}) {
        if (typeof options !== 'object') throw new TypeError('options must be an object');
        const { min: min = 0, max: max = 1 } = options;
        if (!Number.isFinite(min)) throw new TypeError('min must be a number');
        if (!Number.isFinite(max)) throw new TypeError('max must be a number');
        if (min >= max) throw new RangeError('min must be smaller than max');
        let newMatrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(this.rows, this.columns);
        for(let i = 0; i < this.rows; i++){
            const row = this.getRow(i);
            if (row.length > 0) (0, $iJ72H.default)(row, {
                min: min,
                max: max,
                output: row
            });
            newMatrix.setRow(i, row);
        }
        return newMatrix;
    }
    scaleColumns(options = {}) {
        if (typeof options !== 'object') throw new TypeError('options must be an object');
        const { min: min = 0, max: max = 1 } = options;
        if (!Number.isFinite(min)) throw new TypeError('min must be a number');
        if (!Number.isFinite(max)) throw new TypeError('max must be a number');
        if (min >= max) throw new RangeError('min must be smaller than max');
        let newMatrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(this.rows, this.columns);
        for(let i = 0; i < this.columns; i++){
            const column = this.getColumn(i);
            if (column.length) (0, $iJ72H.default)(column, {
                min: min,
                max: max,
                output: column
            });
            newMatrix.setColumn(i, column);
        }
        return newMatrix;
    }
    flipRows() {
        const middle = Math.ceil(this.columns / 2);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < middle; j++){
            let first = this.get(i, j);
            let last = this.get(i, this.columns - 1 - j);
            this.set(i, j, last);
            this.set(i, this.columns - 1 - j, first);
        }
        return this;
    }
    flipColumns() {
        const middle = Math.ceil(this.rows / 2);
        for(let j = 0; j < this.columns; j++)for(let i = 0; i < middle; i++){
            let first = this.get(i, j);
            let last = this.get(this.rows - 1 - i, j);
            this.set(i, j, last);
            this.set(this.rows - 1 - i, j, first);
        }
        return this;
    }
    kroneckerProduct(other) {
        other = $c264d068d49d06d8$export$2e2bcd8739ae039.checkMatrix(other);
        let m = this.rows;
        let n = this.columns;
        let p = other.rows;
        let q = other.columns;
        let result = new $c264d068d49d06d8$export$2e2bcd8739ae039(m * p, n * q);
        for(let i = 0; i < m; i++)for(let j = 0; j < n; j++){
            for(let k = 0; k < p; k++)for(let l = 0; l < q; l++)result.set(p * i + k, q * j + l, this.get(i, j) * other.get(k, l));
        }
        return result;
    }
    kroneckerSum(other) {
        other = $c264d068d49d06d8$export$2e2bcd8739ae039.checkMatrix(other);
        if (!this.isSquare() || !other.isSquare()) throw new Error('Kronecker Sum needs two Square Matrices');
        let m = this.rows;
        let n = other.rows;
        let AxI = this.kroneckerProduct($c264d068d49d06d8$export$2e2bcd8739ae039.eye(n, n));
        let IxB = $c264d068d49d06d8$export$2e2bcd8739ae039.eye(m, m).kroneckerProduct(other);
        return AxI.add(IxB);
    }
    transpose() {
        let result = new $c264d068d49d06d8$export$2e2bcd8739ae039(this.columns, this.rows);
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)result.set(j, i, this.get(i, j));
        return result;
    }
    sortRows(compareFunction = $c264d068d49d06d8$var$compareNumbers) {
        for(let i = 0; i < this.rows; i++)this.setRow(i, this.getRow(i).sort(compareFunction));
        return this;
    }
    sortColumns(compareFunction = $c264d068d49d06d8$var$compareNumbers) {
        for(let i = 0; i < this.columns; i++)this.setColumn(i, this.getColumn(i).sort(compareFunction));
        return this;
    }
    subMatrix(startRow, endRow, startColumn, endColumn) {
        (0, $cbd2a.checkRange)(this, startRow, endRow, startColumn, endColumn);
        let newMatrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(endRow - startRow + 1, endColumn - startColumn + 1);
        for(let i = startRow; i <= endRow; i++)for(let j = startColumn; j <= endColumn; j++)newMatrix.set(i - startRow, j - startColumn, this.get(i, j));
        return newMatrix;
    }
    subMatrixRow(indices, startColumn, endColumn) {
        if (startColumn === undefined) startColumn = 0;
        if (endColumn === undefined) endColumn = this.columns - 1;
        if (startColumn > endColumn || startColumn < 0 || startColumn >= this.columns || endColumn < 0 || endColumn >= this.columns) throw new RangeError('Argument out of range');
        let newMatrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(indices.length, endColumn - startColumn + 1);
        for(let i = 0; i < indices.length; i++)for(let j = startColumn; j <= endColumn; j++){
            if (indices[i] < 0 || indices[i] >= this.rows) throw new RangeError(`Row index out of range: ${indices[i]}`);
            newMatrix.set(i, j - startColumn, this.get(indices[i], j));
        }
        return newMatrix;
    }
    subMatrixColumn(indices, startRow, endRow) {
        if (startRow === undefined) startRow = 0;
        if (endRow === undefined) endRow = this.rows - 1;
        if (startRow > endRow || startRow < 0 || startRow >= this.rows || endRow < 0 || endRow >= this.rows) throw new RangeError('Argument out of range');
        let newMatrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(endRow - startRow + 1, indices.length);
        for(let i = 0; i < indices.length; i++)for(let j = startRow; j <= endRow; j++){
            if (indices[i] < 0 || indices[i] >= this.columns) throw new RangeError(`Column index out of range: ${indices[i]}`);
            newMatrix.set(j - startRow, i, this.get(j, indices[i]));
        }
        return newMatrix;
    }
    setSubMatrix(matrix, startRow, startColumn) {
        matrix = $c264d068d49d06d8$export$2e2bcd8739ae039.checkMatrix(matrix);
        if (matrix.isEmpty()) return this;
        let endRow = startRow + matrix.rows - 1;
        let endColumn = startColumn + matrix.columns - 1;
        (0, $cbd2a.checkRange)(this, startRow, endRow, startColumn, endColumn);
        for(let i = 0; i < matrix.rows; i++)for(let j = 0; j < matrix.columns; j++)this.set(startRow + i, startColumn + j, matrix.get(i, j));
        return this;
    }
    selection(rowIndices, columnIndices) {
        (0, $cbd2a.checkRowIndices)(this, rowIndices);
        (0, $cbd2a.checkColumnIndices)(this, columnIndices);
        let newMatrix = new $c264d068d49d06d8$export$2e2bcd8739ae039(rowIndices.length, columnIndices.length);
        for(let i = 0; i < rowIndices.length; i++){
            let rowIndex = rowIndices[i];
            for(let j = 0; j < columnIndices.length; j++){
                let columnIndex = columnIndices[j];
                newMatrix.set(i, j, this.get(rowIndex, columnIndex));
            }
        }
        return newMatrix;
    }
    trace() {
        let min = Math.min(this.rows, this.columns);
        let trace = 0;
        for(let i = 0; i < min; i++)trace += this.get(i, i);
        return trace;
    }
    clone() {
        return this.constructor.copy(this, new $c264d068d49d06d8$export$2e2bcd8739ae039(this.rows, this.columns));
    }
    /**
   * @template {AbstractMatrix} M
   * @param {AbstractMatrix} from
   * @param {M} to
   * @return {M}
   */ static copy(from, to) {
        for (const [row, column, value] of from.entries())to.set(row, column, value);
        return to;
    }
    sum(by) {
        switch(by){
            case 'row':
                return (0, $7J0w1.sumByRow)(this);
            case 'column':
                return (0, $7J0w1.sumByColumn)(this);
            case undefined:
                return (0, $7J0w1.sumAll)(this);
            default:
                throw new Error(`invalid option: ${by}`);
        }
    }
    product(by) {
        switch(by){
            case 'row':
                return (0, $7J0w1.productByRow)(this);
            case 'column':
                return (0, $7J0w1.productByColumn)(this);
            case undefined:
                return (0, $7J0w1.productAll)(this);
            default:
                throw new Error(`invalid option: ${by}`);
        }
    }
    mean(by) {
        const sum = this.sum(by);
        switch(by){
            case 'row':
                for(let i = 0; i < this.rows; i++)sum[i] /= this.columns;
                return sum;
            case 'column':
                for(let i = 0; i < this.columns; i++)sum[i] /= this.rows;
                return sum;
            case undefined:
                return sum / this.size;
            default:
                throw new Error(`invalid option: ${by}`);
        }
    }
    variance(by, options = {}) {
        if (typeof by === 'object') {
            options = by;
            by = undefined;
        }
        if (typeof options !== 'object') throw new TypeError('options must be an object');
        const { unbiased: unbiased = true, mean: mean = this.mean(by) } = options;
        if (typeof unbiased !== 'boolean') throw new TypeError('unbiased must be a boolean');
        switch(by){
            case 'row':
                if (!(0, $iyj1l.isAnyArray)(mean)) throw new TypeError('mean must be an array');
                return (0, $7J0w1.varianceByRow)(this, unbiased, mean);
            case 'column':
                if (!(0, $iyj1l.isAnyArray)(mean)) throw new TypeError('mean must be an array');
                return (0, $7J0w1.varianceByColumn)(this, unbiased, mean);
            case undefined:
                if (typeof mean !== 'number') throw new TypeError('mean must be a number');
                return (0, $7J0w1.varianceAll)(this, unbiased, mean);
            default:
                throw new Error(`invalid option: ${by}`);
        }
    }
    standardDeviation(by, options) {
        if (typeof by === 'object') {
            options = by;
            by = undefined;
        }
        const variance = this.variance(by, options);
        if (by === undefined) return Math.sqrt(variance);
        else {
            for(let i = 0; i < variance.length; i++)variance[i] = Math.sqrt(variance[i]);
            return variance;
        }
    }
    center(by, options = {}) {
        if (typeof by === 'object') {
            options = by;
            by = undefined;
        }
        if (typeof options !== 'object') throw new TypeError('options must be an object');
        const { center: center = this.mean(by) } = options;
        switch(by){
            case 'row':
                if (!(0, $iyj1l.isAnyArray)(center)) throw new TypeError('center must be an array');
                (0, $7J0w1.centerByRow)(this, center);
                return this;
            case 'column':
                if (!(0, $iyj1l.isAnyArray)(center)) throw new TypeError('center must be an array');
                (0, $7J0w1.centerByColumn)(this, center);
                return this;
            case undefined:
                if (typeof center !== 'number') throw new TypeError('center must be a number');
                (0, $7J0w1.centerAll)(this, center);
                return this;
            default:
                throw new Error(`invalid option: ${by}`);
        }
    }
    scale(by, options = {}) {
        if (typeof by === 'object') {
            options = by;
            by = undefined;
        }
        if (typeof options !== 'object') throw new TypeError('options must be an object');
        let scale = options.scale;
        switch(by){
            case 'row':
                if (scale === undefined) scale = (0, $7J0w1.getScaleByRow)(this);
                else if (!(0, $iyj1l.isAnyArray)(scale)) throw new TypeError('scale must be an array');
                (0, $7J0w1.scaleByRow)(this, scale);
                return this;
            case 'column':
                if (scale === undefined) scale = (0, $7J0w1.getScaleByColumn)(this);
                else if (!(0, $iyj1l.isAnyArray)(scale)) throw new TypeError('scale must be an array');
                (0, $7J0w1.scaleByColumn)(this, scale);
                return this;
            case undefined:
                if (scale === undefined) scale = (0, $7J0w1.getScaleAll)(this);
                else if (typeof scale !== 'number') throw new TypeError('scale must be a number');
                (0, $7J0w1.scaleAll)(this, scale);
                return this;
            default:
                throw new Error(`invalid option: ${by}`);
        }
    }
    toString(options) {
        return (0, $gBIpq.inspectMatrixWithOptions)(this, options);
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    /**
   * iterator from left to right, from top to bottom
   * yield [row, column, value]
   * @returns {Generator<[number, number, number], void, void>}
   */ *entries() {
        for(let row = 0; row < this.rows; row++)for(let col = 0; col < this.columns; col++)yield [
            row,
            col,
            this.get(row, col)
        ];
    }
    /**
   * iterator from left to right, from top to bottom
   * yield value
   * @returns {Generator<number, void, void>}
   */ *values() {
        for(let row = 0; row < this.rows; row++)for(let col = 0; col < this.columns; col++)yield this.get(row, col);
    }
}
$c264d068d49d06d8$export$4b275fa73feb14fa.prototype.klass = 'Matrix';
if (typeof Symbol !== 'undefined') $c264d068d49d06d8$export$4b275fa73feb14fa.prototype[Symbol.for('nodejs.util.inspect.custom')] = (0, $gBIpq.inspectMatrix);
function $c264d068d49d06d8$var$compareNumbers(a, b) {
    return a - b;
}
function $c264d068d49d06d8$var$isArrayOfNumbers(array) {
    return array.every((element)=>{
        return typeof element === 'number';
    });
}
// Synonyms
$c264d068d49d06d8$export$4b275fa73feb14fa.random = $c264d068d49d06d8$export$4b275fa73feb14fa.rand;
$c264d068d49d06d8$export$4b275fa73feb14fa.randomInt = $c264d068d49d06d8$export$4b275fa73feb14fa.randInt;
$c264d068d49d06d8$export$4b275fa73feb14fa.diagonal = $c264d068d49d06d8$export$4b275fa73feb14fa.diag;
$c264d068d49d06d8$export$4b275fa73feb14fa.prototype.diagonal = $c264d068d49d06d8$export$4b275fa73feb14fa.prototype.diag;
$c264d068d49d06d8$export$4b275fa73feb14fa.identity = $c264d068d49d06d8$export$4b275fa73feb14fa.eye;
$c264d068d49d06d8$export$4b275fa73feb14fa.prototype.negate = $c264d068d49d06d8$export$4b275fa73feb14fa.prototype.neg;
$c264d068d49d06d8$export$4b275fa73feb14fa.prototype.tensorProduct = $c264d068d49d06d8$export$4b275fa73feb14fa.prototype.kroneckerProduct;
class $c264d068d49d06d8$export$2e2bcd8739ae039 extends $c264d068d49d06d8$export$4b275fa73feb14fa {
    /**
   * @type {Float64Array[]}
   */ data;
    /**
   * Init an empty matrix
   * @param {number} nRows
   * @param {number} nColumns
   */ #initData(nRows, nColumns) {
        this.data = [];
        if (Number.isInteger(nColumns) && nColumns >= 0) for(let i = 0; i < nRows; i++)this.data.push(new Float64Array(nColumns));
        else throw new TypeError('nColumns must be a positive integer');
        this.rows = nRows;
        this.columns = nColumns;
    }
    constructor(nRows, nColumns){
        super();
        if ($c264d068d49d06d8$export$2e2bcd8739ae039.isMatrix(nRows)) {
            this.#initData(nRows.rows, nRows.columns);
            $c264d068d49d06d8$export$2e2bcd8739ae039.copy(nRows, this);
        } else if (Number.isInteger(nRows) && nRows >= 0) this.#initData(nRows, nColumns);
        else if ((0, $iyj1l.isAnyArray)(nRows)) {
            // Copy the values from the 2D array
            const arrayData = nRows;
            nRows = arrayData.length;
            nColumns = nRows ? arrayData[0].length : 0;
            if (typeof nColumns !== 'number') throw new TypeError('Data must be a 2D array with at least one element');
            this.data = [];
            for(let i = 0; i < nRows; i++){
                if (arrayData[i].length !== nColumns) throw new RangeError('Inconsistent array dimensions');
                if (!$c264d068d49d06d8$var$isArrayOfNumbers(arrayData[i])) throw new TypeError('Input data contains non-numeric values');
                this.data.push(Float64Array.from(arrayData[i]));
            }
            this.rows = nRows;
            this.columns = nColumns;
        } else throw new TypeError('First argument must be a positive number or an array');
    }
    set(rowIndex, columnIndex, value) {
        this.data[rowIndex][columnIndex] = value;
        return this;
    }
    get(rowIndex, columnIndex) {
        return this.data[rowIndex][columnIndex];
    }
    removeRow(index) {
        (0, $cbd2a.checkRowIndex)(this, index);
        this.data.splice(index, 1);
        this.rows -= 1;
        return this;
    }
    addRow(index, array) {
        if (array === undefined) {
            array = index;
            index = this.rows;
        }
        (0, $cbd2a.checkRowIndex)(this, index, true);
        array = Float64Array.from((0, $cbd2a.checkRowVector)(this, array));
        this.data.splice(index, 0, array);
        this.rows += 1;
        return this;
    }
    removeColumn(index) {
        (0, $cbd2a.checkColumnIndex)(this, index);
        for(let i = 0; i < this.rows; i++){
            const newRow = new Float64Array(this.columns - 1);
            for(let j = 0; j < index; j++)newRow[j] = this.data[i][j];
            for(let j = index + 1; j < this.columns; j++)newRow[j - 1] = this.data[i][j];
            this.data[i] = newRow;
        }
        this.columns -= 1;
        return this;
    }
    addColumn(index, array) {
        if (typeof array === 'undefined') {
            array = index;
            index = this.columns;
        }
        (0, $cbd2a.checkColumnIndex)(this, index, true);
        array = (0, $cbd2a.checkColumnVector)(this, array);
        for(let i = 0; i < this.rows; i++){
            const newRow = new Float64Array(this.columns + 1);
            let j = 0;
            for(; j < index; j++)newRow[j] = this.data[i][j];
            newRow[j++] = array[i];
            for(; j < this.columns + 1; j++)newRow[j] = this.data[i][j - 1];
            this.data[i] = newRow;
        }
        this.columns += 1;
        return this;
    }
}
(0, $1MrQ0.installMathOperations)($c264d068d49d06d8$export$4b275fa73feb14fa, $c264d068d49d06d8$export$2e2bcd8739ae039);

});
parcelRegister("iyj1l", function(module, exports) {

$parcel$export(module.exports, "isAnyArray", () => $d81a281a2789a823$export$b587624c098d7880);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $d81a281a2789a823$var$toString = Object.prototype.toString;
function $d81a281a2789a823$export$b587624c098d7880(value) {
    const tag = $d81a281a2789a823$var$toString.call(value);
    return tag.endsWith('Array]') && !tag.includes('Big');
}

});

parcelRegister("iJ72H", function(module, exports) {

$parcel$export(module.exports, "default", () => $da21e47a1f7350b7$export$2e2bcd8739ae039);

var $iyj1l = parcelRequire("iyj1l");

var $3g81r = parcelRequire("3g81r");

var $046nB = parcelRequire("046nB");
function $da21e47a1f7350b7$export$2e2bcd8739ae039(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $iyj1l.isAnyArray)(input)) throw new TypeError('input must be an array');
    else if (input.length === 0) throw new TypeError('input must not be empty');
    var output;
    if (options.output !== undefined) {
        if (!(0, $iyj1l.isAnyArray)(options.output)) throw new TypeError('output option must be an array if specified');
        output = options.output;
    } else output = new Array(input.length);
    var currentMin = (0, $046nB.default)(input);
    var currentMax = (0, $3g81r.default)(input);
    if (currentMin === currentMax) throw new RangeError('minimum and maximum input values are equal. Cannot rescale a constant array');
    var _options$min = options.min, minValue = _options$min === void 0 ? options.autoMinMax ? currentMin : 0 : _options$min, _options$max = options.max, maxValue = _options$max === void 0 ? options.autoMinMax ? currentMax : 1 : _options$max;
    if (minValue >= maxValue) throw new RangeError('min option must be smaller than max option');
    var factor = (maxValue - minValue) / (currentMax - currentMin);
    for(var i = 0; i < input.length; i++)output[i] = (input[i] - currentMin) * factor + minValue;
    return output;
}

});
parcelRegister("3g81r", function(module, exports) {

$parcel$export(module.exports, "default", () => $25f916c46ee2fb6e$export$2e2bcd8739ae039);

var $iyj1l = parcelRequire("iyj1l");
function $25f916c46ee2fb6e$export$2e2bcd8739ae039(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $iyj1l.isAnyArray)(input)) throw new TypeError('input must be an array');
    if (input.length === 0) throw new TypeError('input must not be empty');
    var _options$fromIndex = options.fromIndex, fromIndex = _options$fromIndex === void 0 ? 0 : _options$fromIndex, _options$toIndex = options.toIndex, toIndex = _options$toIndex === void 0 ? input.length : _options$toIndex;
    if (fromIndex < 0 || fromIndex >= input.length || !Number.isInteger(fromIndex)) throw new Error('fromIndex must be a positive integer smaller than length');
    if (toIndex <= fromIndex || toIndex > input.length || !Number.isInteger(toIndex)) throw new Error('toIndex must be an integer greater than fromIndex and at most equal to length');
    var maxValue = input[fromIndex];
    for(var i = fromIndex + 1; i < toIndex; i++)if (input[i] > maxValue) maxValue = input[i];
    return maxValue;
}

});

parcelRegister("046nB", function(module, exports) {

$parcel$export(module.exports, "default", () => $00c552b490dda62f$export$2e2bcd8739ae039);

var $iyj1l = parcelRequire("iyj1l");
function $00c552b490dda62f$export$2e2bcd8739ae039(input) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!(0, $iyj1l.isAnyArray)(input)) throw new TypeError('input must be an array');
    if (input.length === 0) throw new TypeError('input must not be empty');
    var _options$fromIndex = options.fromIndex, fromIndex = _options$fromIndex === void 0 ? 0 : _options$fromIndex, _options$toIndex = options.toIndex, toIndex = _options$toIndex === void 0 ? input.length : _options$toIndex;
    if (fromIndex < 0 || fromIndex >= input.length || !Number.isInteger(fromIndex)) throw new Error('fromIndex must be a positive integer smaller than length');
    if (toIndex <= fromIndex || toIndex > input.length || !Number.isInteger(toIndex)) throw new Error('toIndex must be an integer greater than fromIndex and at most equal to length');
    var minValue = input[fromIndex];
    for(var i = fromIndex + 1; i < toIndex; i++)if (input[i] < minValue) minValue = input[i];
    return minValue;
}

});


parcelRegister("gBIpq", function(module, exports) {

$parcel$export(module.exports, "inspectMatrix", () => $c1728cbfd666a0b5$export$b1353423cee91caf);
$parcel$export(module.exports, "inspectMatrixWithOptions", () => $c1728cbfd666a0b5$export$66f7e3f9359f0f9e);
const $c1728cbfd666a0b5$var$indent = ' '.repeat(2);
const $c1728cbfd666a0b5$var$indentData = ' '.repeat(4);
function $c1728cbfd666a0b5$export$b1353423cee91caf() {
    return $c1728cbfd666a0b5$export$66f7e3f9359f0f9e(this);
}
function $c1728cbfd666a0b5$export$66f7e3f9359f0f9e(matrix, options = {}) {
    const { maxRows: maxRows = 15, maxColumns: maxColumns = 10, maxNumSize: maxNumSize = 8, padMinus: padMinus = 'auto' } = options;
    return `${matrix.constructor.name} {
${$c1728cbfd666a0b5$var$indent}[
${$c1728cbfd666a0b5$var$indentData}${$c1728cbfd666a0b5$var$inspectData(matrix, maxRows, maxColumns, maxNumSize, padMinus)}
${$c1728cbfd666a0b5$var$indent}]
${$c1728cbfd666a0b5$var$indent}rows: ${matrix.rows}
${$c1728cbfd666a0b5$var$indent}columns: ${matrix.columns}
}`;
}
function $c1728cbfd666a0b5$var$inspectData(matrix, maxRows, maxColumns, maxNumSize, padMinus) {
    const { rows: rows, columns: columns } = matrix;
    const maxI = Math.min(rows, maxRows);
    const maxJ = Math.min(columns, maxColumns);
    const result = [];
    if (padMinus === 'auto') {
        padMinus = false;
        loop: for(let i = 0; i < maxI; i++){
            for(let j = 0; j < maxJ; j++)if (matrix.get(i, j) < 0) {
                padMinus = true;
                break loop;
            }
        }
    }
    for(let i = 0; i < maxI; i++){
        let line = [];
        for(let j = 0; j < maxJ; j++)line.push($c1728cbfd666a0b5$var$formatNumber(matrix.get(i, j), maxNumSize, padMinus));
        result.push(`${line.join(' ')}`);
    }
    if (maxJ !== columns) result[result.length - 1] += ` ... ${columns - maxColumns} more columns`;
    if (maxI !== rows) result.push(`... ${rows - maxRows} more rows`);
    return result.join(`\n${$c1728cbfd666a0b5$var$indentData}`);
}
function $c1728cbfd666a0b5$var$formatNumber(num, maxNumSize, padMinus) {
    return (num >= 0 && padMinus ? ` ${$c1728cbfd666a0b5$var$formatNumber2(num, maxNumSize - 1)}` : $c1728cbfd666a0b5$var$formatNumber2(num, maxNumSize)).padEnd(maxNumSize);
}
function $c1728cbfd666a0b5$var$formatNumber2(num, len) {
    // small.length numbers should be as is
    let str = num.toString();
    if (str.length <= len) return str;
    // (7)'0.00123' is better then (7)'1.23e-2'
    // (8)'0.000123' is worse then (7)'1.23e-3',
    let fix = num.toFixed(len);
    if (fix.length > len) fix = num.toFixed(Math.max(0, len - (fix.length - len)));
    if (fix.length <= len && !fix.startsWith('0.000') && !fix.startsWith('-0.000')) return fix;
    // well, if it's still too long the user should've used longer numbers
    let exp = num.toExponential(len);
    if (exp.length > len) exp = num.toExponential(Math.max(0, len - (exp.length - len)));
    return exp.slice(0);
}

});

parcelRegister("1MrQ0", function(module, exports) {

$parcel$export(module.exports, "installMathOperations", () => $14bfde21dd252749$export$f9fe1a46265a1978);
function $14bfde21dd252749$export$f9fe1a46265a1978(AbstractMatrix, Matrix) {
    AbstractMatrix.prototype.add = function add(value) {
        if (typeof value === 'number') return this.addS(value);
        return this.addM(value);
    };
    AbstractMatrix.prototype.addS = function addS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) + value);
        return this;
    };
    AbstractMatrix.prototype.addM = function addM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) + matrix.get(i, j));
        return this;
    };
    AbstractMatrix.add = function add(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.add(value);
    };
    AbstractMatrix.prototype.sub = function sub(value) {
        if (typeof value === 'number') return this.subS(value);
        return this.subM(value);
    };
    AbstractMatrix.prototype.subS = function subS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) - value);
        return this;
    };
    AbstractMatrix.prototype.subM = function subM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) - matrix.get(i, j));
        return this;
    };
    AbstractMatrix.sub = function sub(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.sub(value);
    };
    AbstractMatrix.prototype.subtract = AbstractMatrix.prototype.sub;
    AbstractMatrix.prototype.subtractS = AbstractMatrix.prototype.subS;
    AbstractMatrix.prototype.subtractM = AbstractMatrix.prototype.subM;
    AbstractMatrix.subtract = AbstractMatrix.sub;
    AbstractMatrix.prototype.mul = function mul(value) {
        if (typeof value === 'number') return this.mulS(value);
        return this.mulM(value);
    };
    AbstractMatrix.prototype.mulS = function mulS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) * value);
        return this;
    };
    AbstractMatrix.prototype.mulM = function mulM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) * matrix.get(i, j));
        return this;
    };
    AbstractMatrix.mul = function mul(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.mul(value);
    };
    AbstractMatrix.prototype.multiply = AbstractMatrix.prototype.mul;
    AbstractMatrix.prototype.multiplyS = AbstractMatrix.prototype.mulS;
    AbstractMatrix.prototype.multiplyM = AbstractMatrix.prototype.mulM;
    AbstractMatrix.multiply = AbstractMatrix.mul;
    AbstractMatrix.prototype.div = function div(value) {
        if (typeof value === 'number') return this.divS(value);
        return this.divM(value);
    };
    AbstractMatrix.prototype.divS = function divS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) / value);
        return this;
    };
    AbstractMatrix.prototype.divM = function divM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) / matrix.get(i, j));
        return this;
    };
    AbstractMatrix.div = function div(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.div(value);
    };
    AbstractMatrix.prototype.divide = AbstractMatrix.prototype.div;
    AbstractMatrix.prototype.divideS = AbstractMatrix.prototype.divS;
    AbstractMatrix.prototype.divideM = AbstractMatrix.prototype.divM;
    AbstractMatrix.divide = AbstractMatrix.div;
    AbstractMatrix.prototype.mod = function mod(value) {
        if (typeof value === 'number') return this.modS(value);
        return this.modM(value);
    };
    AbstractMatrix.prototype.modS = function modS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) % value);
        return this;
    };
    AbstractMatrix.prototype.modM = function modM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) % matrix.get(i, j));
        return this;
    };
    AbstractMatrix.mod = function mod(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.mod(value);
    };
    AbstractMatrix.prototype.modulus = AbstractMatrix.prototype.mod;
    AbstractMatrix.prototype.modulusS = AbstractMatrix.prototype.modS;
    AbstractMatrix.prototype.modulusM = AbstractMatrix.prototype.modM;
    AbstractMatrix.modulus = AbstractMatrix.mod;
    AbstractMatrix.prototype.and = function and(value) {
        if (typeof value === 'number') return this.andS(value);
        return this.andM(value);
    };
    AbstractMatrix.prototype.andS = function andS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) & value);
        return this;
    };
    AbstractMatrix.prototype.andM = function andM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) & matrix.get(i, j));
        return this;
    };
    AbstractMatrix.and = function and(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.and(value);
    };
    AbstractMatrix.prototype.or = function or(value) {
        if (typeof value === 'number') return this.orS(value);
        return this.orM(value);
    };
    AbstractMatrix.prototype.orS = function orS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) | value);
        return this;
    };
    AbstractMatrix.prototype.orM = function orM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) | matrix.get(i, j));
        return this;
    };
    AbstractMatrix.or = function or(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.or(value);
    };
    AbstractMatrix.prototype.xor = function xor(value) {
        if (typeof value === 'number') return this.xorS(value);
        return this.xorM(value);
    };
    AbstractMatrix.prototype.xorS = function xorS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) ^ value);
        return this;
    };
    AbstractMatrix.prototype.xorM = function xorM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) ^ matrix.get(i, j));
        return this;
    };
    AbstractMatrix.xor = function xor(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.xor(value);
    };
    AbstractMatrix.prototype.leftShift = function leftShift(value) {
        if (typeof value === 'number') return this.leftShiftS(value);
        return this.leftShiftM(value);
    };
    AbstractMatrix.prototype.leftShiftS = function leftShiftS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) << value);
        return this;
    };
    AbstractMatrix.prototype.leftShiftM = function leftShiftM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) << matrix.get(i, j));
        return this;
    };
    AbstractMatrix.leftShift = function leftShift(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.leftShift(value);
    };
    AbstractMatrix.prototype.signPropagatingRightShift = function signPropagatingRightShift(value) {
        if (typeof value === 'number') return this.signPropagatingRightShiftS(value);
        return this.signPropagatingRightShiftM(value);
    };
    AbstractMatrix.prototype.signPropagatingRightShiftS = function signPropagatingRightShiftS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) >> value);
        return this;
    };
    AbstractMatrix.prototype.signPropagatingRightShiftM = function signPropagatingRightShiftM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) >> matrix.get(i, j));
        return this;
    };
    AbstractMatrix.signPropagatingRightShift = function signPropagatingRightShift(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.signPropagatingRightShift(value);
    };
    AbstractMatrix.prototype.rightShift = function rightShift(value) {
        if (typeof value === 'number') return this.rightShiftS(value);
        return this.rightShiftM(value);
    };
    AbstractMatrix.prototype.rightShiftS = function rightShiftS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) >>> value);
        return this;
    };
    AbstractMatrix.prototype.rightShiftM = function rightShiftM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) >>> matrix.get(i, j));
        return this;
    };
    AbstractMatrix.rightShift = function rightShift(matrix, value) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.rightShift(value);
    };
    AbstractMatrix.prototype.zeroFillRightShift = AbstractMatrix.prototype.rightShift;
    AbstractMatrix.prototype.zeroFillRightShiftS = AbstractMatrix.prototype.rightShiftS;
    AbstractMatrix.prototype.zeroFillRightShiftM = AbstractMatrix.prototype.rightShiftM;
    AbstractMatrix.zeroFillRightShift = AbstractMatrix.rightShift;
    AbstractMatrix.prototype.not = function not() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, ~this.get(i, j));
        return this;
    };
    AbstractMatrix.not = function not(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.not();
    };
    AbstractMatrix.prototype.abs = function abs() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.abs(this.get(i, j)));
        return this;
    };
    AbstractMatrix.abs = function abs(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.abs();
    };
    AbstractMatrix.prototype.acos = function acos() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.acos(this.get(i, j)));
        return this;
    };
    AbstractMatrix.acos = function acos(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.acos();
    };
    AbstractMatrix.prototype.acosh = function acosh() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.acosh(this.get(i, j)));
        return this;
    };
    AbstractMatrix.acosh = function acosh(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.acosh();
    };
    AbstractMatrix.prototype.asin = function asin() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.asin(this.get(i, j)));
        return this;
    };
    AbstractMatrix.asin = function asin(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.asin();
    };
    AbstractMatrix.prototype.asinh = function asinh() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.asinh(this.get(i, j)));
        return this;
    };
    AbstractMatrix.asinh = function asinh(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.asinh();
    };
    AbstractMatrix.prototype.atan = function atan() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.atan(this.get(i, j)));
        return this;
    };
    AbstractMatrix.atan = function atan(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.atan();
    };
    AbstractMatrix.prototype.atanh = function atanh() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.atanh(this.get(i, j)));
        return this;
    };
    AbstractMatrix.atanh = function atanh(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.atanh();
    };
    AbstractMatrix.prototype.cbrt = function cbrt() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.cbrt(this.get(i, j)));
        return this;
    };
    AbstractMatrix.cbrt = function cbrt(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.cbrt();
    };
    AbstractMatrix.prototype.ceil = function ceil() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.ceil(this.get(i, j)));
        return this;
    };
    AbstractMatrix.ceil = function ceil(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.ceil();
    };
    AbstractMatrix.prototype.clz32 = function clz32() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.clz32(this.get(i, j)));
        return this;
    };
    AbstractMatrix.clz32 = function clz32(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.clz32();
    };
    AbstractMatrix.prototype.cos = function cos() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.cos(this.get(i, j)));
        return this;
    };
    AbstractMatrix.cos = function cos(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.cos();
    };
    AbstractMatrix.prototype.cosh = function cosh() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.cosh(this.get(i, j)));
        return this;
    };
    AbstractMatrix.cosh = function cosh(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.cosh();
    };
    AbstractMatrix.prototype.exp = function exp() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.exp(this.get(i, j)));
        return this;
    };
    AbstractMatrix.exp = function exp(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.exp();
    };
    AbstractMatrix.prototype.expm1 = function expm1() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.expm1(this.get(i, j)));
        return this;
    };
    AbstractMatrix.expm1 = function expm1(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.expm1();
    };
    AbstractMatrix.prototype.floor = function floor() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.floor(this.get(i, j)));
        return this;
    };
    AbstractMatrix.floor = function floor(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.floor();
    };
    AbstractMatrix.prototype.fround = function fround() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.fround(this.get(i, j)));
        return this;
    };
    AbstractMatrix.fround = function fround(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.fround();
    };
    AbstractMatrix.prototype.log = function log() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.log(this.get(i, j)));
        return this;
    };
    AbstractMatrix.log = function log(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.log();
    };
    AbstractMatrix.prototype.log1p = function log1p() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.log1p(this.get(i, j)));
        return this;
    };
    AbstractMatrix.log1p = function log1p(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.log1p();
    };
    AbstractMatrix.prototype.log10 = function log10() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.log10(this.get(i, j)));
        return this;
    };
    AbstractMatrix.log10 = function log10(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.log10();
    };
    AbstractMatrix.prototype.log2 = function log2() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.log2(this.get(i, j)));
        return this;
    };
    AbstractMatrix.log2 = function log2(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.log2();
    };
    AbstractMatrix.prototype.round = function round() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.round(this.get(i, j)));
        return this;
    };
    AbstractMatrix.round = function round(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.round();
    };
    AbstractMatrix.prototype.sign = function sign() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.sign(this.get(i, j)));
        return this;
    };
    AbstractMatrix.sign = function sign(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.sign();
    };
    AbstractMatrix.prototype.sin = function sin() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.sin(this.get(i, j)));
        return this;
    };
    AbstractMatrix.sin = function sin(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.sin();
    };
    AbstractMatrix.prototype.sinh = function sinh() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.sinh(this.get(i, j)));
        return this;
    };
    AbstractMatrix.sinh = function sinh(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.sinh();
    };
    AbstractMatrix.prototype.sqrt = function sqrt() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.sqrt(this.get(i, j)));
        return this;
    };
    AbstractMatrix.sqrt = function sqrt(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.sqrt();
    };
    AbstractMatrix.prototype.tan = function tan() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.tan(this.get(i, j)));
        return this;
    };
    AbstractMatrix.tan = function tan(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.tan();
    };
    AbstractMatrix.prototype.tanh = function tanh() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.tanh(this.get(i, j)));
        return this;
    };
    AbstractMatrix.tanh = function tanh(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.tanh();
    };
    AbstractMatrix.prototype.trunc = function trunc() {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, Math.trunc(this.get(i, j)));
        return this;
    };
    AbstractMatrix.trunc = function trunc(matrix) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.trunc();
    };
    AbstractMatrix.pow = function pow(matrix, arg0) {
        const newMatrix = new Matrix(matrix);
        return newMatrix.pow(arg0);
    };
    AbstractMatrix.prototype.pow = function pow(value) {
        if (typeof value === 'number') return this.powS(value);
        return this.powM(value);
    };
    AbstractMatrix.prototype.powS = function powS(value) {
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) ** value);
        return this;
    };
    AbstractMatrix.prototype.powM = function powM(matrix) {
        matrix = Matrix.checkMatrix(matrix);
        if (this.rows !== matrix.rows || this.columns !== matrix.columns) throw new RangeError('Matrices dimensions must be equal');
        for(let i = 0; i < this.rows; i++)for(let j = 0; j < this.columns; j++)this.set(i, j, this.get(i, j) ** matrix.get(i, j));
        return this;
    };
}

});

parcelRegister("7J0w1", function(module, exports) {

$parcel$export(module.exports, "sumByRow", () => $59fd22b8b0a08922$export$8f455058137a1ae1);
$parcel$export(module.exports, "sumByColumn", () => $59fd22b8b0a08922$export$76d99fcf491f8353);
$parcel$export(module.exports, "sumAll", () => $59fd22b8b0a08922$export$e9666e11c29bfd93);
$parcel$export(module.exports, "productByRow", () => $59fd22b8b0a08922$export$c48f519082514e8e);
$parcel$export(module.exports, "productByColumn", () => $59fd22b8b0a08922$export$f896e61c4deaaeab);
$parcel$export(module.exports, "productAll", () => $59fd22b8b0a08922$export$dcf59fc14c9dc536);
$parcel$export(module.exports, "varianceByRow", () => $59fd22b8b0a08922$export$12e045d6bca3f52f);
$parcel$export(module.exports, "varianceByColumn", () => $59fd22b8b0a08922$export$8eaba4ad2bf7f22f);
$parcel$export(module.exports, "varianceAll", () => $59fd22b8b0a08922$export$e41d45637057ea2f);
$parcel$export(module.exports, "centerByRow", () => $59fd22b8b0a08922$export$d657ff37d9803f2c);
$parcel$export(module.exports, "centerByColumn", () => $59fd22b8b0a08922$export$a97d54bde1f37f4f);
$parcel$export(module.exports, "centerAll", () => $59fd22b8b0a08922$export$4961127515ac14d9);
$parcel$export(module.exports, "getScaleByRow", () => $59fd22b8b0a08922$export$401b5d1e21b3d95f);
$parcel$export(module.exports, "scaleByRow", () => $59fd22b8b0a08922$export$be914f666e802cef);
$parcel$export(module.exports, "getScaleByColumn", () => $59fd22b8b0a08922$export$67bf442048b342f3);
$parcel$export(module.exports, "scaleByColumn", () => $59fd22b8b0a08922$export$909f59241c977663);
$parcel$export(module.exports, "getScaleAll", () => $59fd22b8b0a08922$export$1ca6b014d842307d);
$parcel$export(module.exports, "scaleAll", () => $59fd22b8b0a08922$export$2049ee336508b8aa);

var $cbd2a = parcelRequire("cbd2a");
function $59fd22b8b0a08922$export$8f455058137a1ae1(matrix) {
    let sum = (0, $cbd2a.newArray)(matrix.rows);
    for(let i = 0; i < matrix.rows; ++i)for(let j = 0; j < matrix.columns; ++j)sum[i] += matrix.get(i, j);
    return sum;
}
function $59fd22b8b0a08922$export$76d99fcf491f8353(matrix) {
    let sum = (0, $cbd2a.newArray)(matrix.columns);
    for(let i = 0; i < matrix.rows; ++i)for(let j = 0; j < matrix.columns; ++j)sum[j] += matrix.get(i, j);
    return sum;
}
function $59fd22b8b0a08922$export$e9666e11c29bfd93(matrix) {
    let v = 0;
    for(let i = 0; i < matrix.rows; i++)for(let j = 0; j < matrix.columns; j++)v += matrix.get(i, j);
    return v;
}
function $59fd22b8b0a08922$export$c48f519082514e8e(matrix) {
    let sum = (0, $cbd2a.newArray)(matrix.rows, 1);
    for(let i = 0; i < matrix.rows; ++i)for(let j = 0; j < matrix.columns; ++j)sum[i] *= matrix.get(i, j);
    return sum;
}
function $59fd22b8b0a08922$export$f896e61c4deaaeab(matrix) {
    let sum = (0, $cbd2a.newArray)(matrix.columns, 1);
    for(let i = 0; i < matrix.rows; ++i)for(let j = 0; j < matrix.columns; ++j)sum[j] *= matrix.get(i, j);
    return sum;
}
function $59fd22b8b0a08922$export$dcf59fc14c9dc536(matrix) {
    let v = 1;
    for(let i = 0; i < matrix.rows; i++)for(let j = 0; j < matrix.columns; j++)v *= matrix.get(i, j);
    return v;
}
function $59fd22b8b0a08922$export$12e045d6bca3f52f(matrix, unbiased, mean) {
    const rows = matrix.rows;
    const cols = matrix.columns;
    const variance = [];
    for(let i = 0; i < rows; i++){
        let sum1 = 0;
        let sum2 = 0;
        let x = 0;
        for(let j = 0; j < cols; j++){
            x = matrix.get(i, j) - mean[i];
            sum1 += x;
            sum2 += x * x;
        }
        if (unbiased) variance.push((sum2 - sum1 * sum1 / cols) / (cols - 1));
        else variance.push((sum2 - sum1 * sum1 / cols) / cols);
    }
    return variance;
}
function $59fd22b8b0a08922$export$8eaba4ad2bf7f22f(matrix, unbiased, mean) {
    const rows = matrix.rows;
    const cols = matrix.columns;
    const variance = [];
    for(let j = 0; j < cols; j++){
        let sum1 = 0;
        let sum2 = 0;
        let x = 0;
        for(let i = 0; i < rows; i++){
            x = matrix.get(i, j) - mean[j];
            sum1 += x;
            sum2 += x * x;
        }
        if (unbiased) variance.push((sum2 - sum1 * sum1 / rows) / (rows - 1));
        else variance.push((sum2 - sum1 * sum1 / rows) / rows);
    }
    return variance;
}
function $59fd22b8b0a08922$export$e41d45637057ea2f(matrix, unbiased, mean) {
    const rows = matrix.rows;
    const cols = matrix.columns;
    const size = rows * cols;
    let sum1 = 0;
    let sum2 = 0;
    let x = 0;
    for(let i = 0; i < rows; i++)for(let j = 0; j < cols; j++){
        x = matrix.get(i, j) - mean;
        sum1 += x;
        sum2 += x * x;
    }
    if (unbiased) return (sum2 - sum1 * sum1 / size) / (size - 1);
    else return (sum2 - sum1 * sum1 / size) / size;
}
function $59fd22b8b0a08922$export$d657ff37d9803f2c(matrix, mean) {
    for(let i = 0; i < matrix.rows; i++)for(let j = 0; j < matrix.columns; j++)matrix.set(i, j, matrix.get(i, j) - mean[i]);
}
function $59fd22b8b0a08922$export$a97d54bde1f37f4f(matrix, mean) {
    for(let i = 0; i < matrix.rows; i++)for(let j = 0; j < matrix.columns; j++)matrix.set(i, j, matrix.get(i, j) - mean[j]);
}
function $59fd22b8b0a08922$export$4961127515ac14d9(matrix, mean) {
    for(let i = 0; i < matrix.rows; i++)for(let j = 0; j < matrix.columns; j++)matrix.set(i, j, matrix.get(i, j) - mean);
}
function $59fd22b8b0a08922$export$401b5d1e21b3d95f(matrix) {
    const scale = [];
    for(let i = 0; i < matrix.rows; i++){
        let sum = 0;
        for(let j = 0; j < matrix.columns; j++)sum += matrix.get(i, j) ** 2 / (matrix.columns - 1);
        scale.push(Math.sqrt(sum));
    }
    return scale;
}
function $59fd22b8b0a08922$export$be914f666e802cef(matrix, scale) {
    for(let i = 0; i < matrix.rows; i++)for(let j = 0; j < matrix.columns; j++)matrix.set(i, j, matrix.get(i, j) / scale[i]);
}
function $59fd22b8b0a08922$export$67bf442048b342f3(matrix) {
    const scale = [];
    for(let j = 0; j < matrix.columns; j++){
        let sum = 0;
        for(let i = 0; i < matrix.rows; i++)sum += matrix.get(i, j) ** 2 / (matrix.rows - 1);
        scale.push(Math.sqrt(sum));
    }
    return scale;
}
function $59fd22b8b0a08922$export$909f59241c977663(matrix, scale) {
    for(let i = 0; i < matrix.rows; i++)for(let j = 0; j < matrix.columns; j++)matrix.set(i, j, matrix.get(i, j) / scale[j]);
}
function $59fd22b8b0a08922$export$1ca6b014d842307d(matrix) {
    const divider = matrix.size - 1;
    let sum = 0;
    for(let j = 0; j < matrix.columns; j++)for(let i = 0; i < matrix.rows; i++)sum += matrix.get(i, j) ** 2 / divider;
    return Math.sqrt(sum);
}
function $59fd22b8b0a08922$export$2049ee336508b8aa(matrix, scale) {
    for(let i = 0; i < matrix.rows; i++)for(let j = 0; j < matrix.columns; j++)matrix.set(i, j, matrix.get(i, j) / scale);
}

});
parcelRegister("cbd2a", function(module, exports) {

$parcel$export(module.exports, "checkRowIndex", () => $8de09f6892512dfd$export$1c43f07899a70228);
$parcel$export(module.exports, "checkColumnIndex", () => $8de09f6892512dfd$export$9f3f99fd4fb91358);
$parcel$export(module.exports, "checkRowVector", () => $8de09f6892512dfd$export$af0312fee396fd93);
$parcel$export(module.exports, "checkColumnVector", () => $8de09f6892512dfd$export$d13fb0648ea9f6c7);
$parcel$export(module.exports, "checkRowIndices", () => $8de09f6892512dfd$export$f1ebfb29aa181ce9);
$parcel$export(module.exports, "checkColumnIndices", () => $8de09f6892512dfd$export$2c3e14daf01f9739);
$parcel$export(module.exports, "checkRange", () => $8de09f6892512dfd$export$da114b648d798864);
$parcel$export(module.exports, "newArray", () => $8de09f6892512dfd$export$9ffbd50e3873ea06);
$parcel$export(module.exports, "checkNonEmpty", () => $8de09f6892512dfd$export$f0dd04159b94e070);

var $iyj1l = parcelRequire("iyj1l");
function $8de09f6892512dfd$export$1c43f07899a70228(matrix, index, outer) {
    let max = outer ? matrix.rows : matrix.rows - 1;
    if (index < 0 || index > max) throw new RangeError('Row index out of range');
}
function $8de09f6892512dfd$export$9f3f99fd4fb91358(matrix, index, outer) {
    let max = outer ? matrix.columns : matrix.columns - 1;
    if (index < 0 || index > max) throw new RangeError('Column index out of range');
}
function $8de09f6892512dfd$export$af0312fee396fd93(matrix, vector) {
    if (vector.to1DArray) vector = vector.to1DArray();
    if (vector.length !== matrix.columns) throw new RangeError('vector size must be the same as the number of columns');
    return vector;
}
function $8de09f6892512dfd$export$d13fb0648ea9f6c7(matrix, vector) {
    if (vector.to1DArray) vector = vector.to1DArray();
    if (vector.length !== matrix.rows) throw new RangeError('vector size must be the same as the number of rows');
    return vector;
}
function $8de09f6892512dfd$export$f1ebfb29aa181ce9(matrix, rowIndices) {
    if (!(0, $iyj1l.isAnyArray)(rowIndices)) throw new TypeError('row indices must be an array');
    for(let i = 0; i < rowIndices.length; i++){
        if (rowIndices[i] < 0 || rowIndices[i] >= matrix.rows) throw new RangeError('row indices are out of range');
    }
}
function $8de09f6892512dfd$export$2c3e14daf01f9739(matrix, columnIndices) {
    if (!(0, $iyj1l.isAnyArray)(columnIndices)) throw new TypeError('column indices must be an array');
    for(let i = 0; i < columnIndices.length; i++){
        if (columnIndices[i] < 0 || columnIndices[i] >= matrix.columns) throw new RangeError('column indices are out of range');
    }
}
function $8de09f6892512dfd$export$da114b648d798864(matrix, startRow, endRow, startColumn, endColumn) {
    if (arguments.length !== 5) throw new RangeError('expected 4 arguments');
    $8de09f6892512dfd$var$checkNumber('startRow', startRow);
    $8de09f6892512dfd$var$checkNumber('endRow', endRow);
    $8de09f6892512dfd$var$checkNumber('startColumn', startColumn);
    $8de09f6892512dfd$var$checkNumber('endColumn', endColumn);
    if (startRow > endRow || startColumn > endColumn || startRow < 0 || startRow >= matrix.rows || endRow < 0 || endRow >= matrix.rows || startColumn < 0 || startColumn >= matrix.columns || endColumn < 0 || endColumn >= matrix.columns) throw new RangeError('Submatrix indices are out of range');
}
function $8de09f6892512dfd$export$9ffbd50e3873ea06(length, value = 0) {
    let array = [];
    for(let i = 0; i < length; i++)array.push(value);
    return array;
}
function $8de09f6892512dfd$var$checkNumber(name, value) {
    if (typeof value !== 'number') throw new TypeError(`${name} must be a number`);
}
function $8de09f6892512dfd$export$f0dd04159b94e070(matrix) {
    if (matrix.isEmpty()) throw new Error('Empty matrix has no elements to index');
}

});



parcelRegister("aDK3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf145ab19f34e36$export$2e2bcd8739ae039);

var $gGKJ4 = parcelRequire("gGKJ4");

var $jLEGE = parcelRequire("jLEGE");

var $8Enxc = parcelRequire("8Enxc");
class $7bf145ab19f34e36$export$2e2bcd8739ae039 {
    constructor(value, options = {}){
        value = (0, $jLEGE.default).checkMatrix(value);
        if (value.isEmpty()) throw new Error('Matrix must be non-empty');
        let m = value.rows;
        let n = value.columns;
        const { computeLeftSingularVectors: computeLeftSingularVectors = true, computeRightSingularVectors: computeRightSingularVectors = true, autoTranspose: autoTranspose = false } = options;
        let wantu = Boolean(computeLeftSingularVectors);
        let wantv = Boolean(computeRightSingularVectors);
        let swapped = false;
        let a;
        if (m < n) {
            if (!autoTranspose) {
                a = value.clone();
                // eslint-disable-next-line no-console
                console.warn('Computing SVD on a matrix with more columns than rows. Consider enabling autoTranspose');
            } else {
                a = value.transpose();
                m = a.rows;
                n = a.columns;
                swapped = true;
                let aux = wantu;
                wantu = wantv;
                wantv = aux;
            }
        } else a = value.clone();
        let nu = Math.min(m, n);
        let ni = Math.min(m + 1, n);
        let s = new Float64Array(ni);
        let U = new (0, $gGKJ4.default)(m, nu);
        let V = new (0, $gGKJ4.default)(n, n);
        let e = new Float64Array(n);
        let work = new Float64Array(m);
        let si = new Float64Array(ni);
        for(let i = 0; i < ni; i++)si[i] = i;
        let nct = Math.min(m - 1, n);
        let nrt = Math.max(0, Math.min(n - 2, m));
        let mrc = Math.max(nct, nrt);
        for(let k = 0; k < mrc; k++){
            if (k < nct) {
                s[k] = 0;
                for(let i = k; i < m; i++)s[k] = (0, $8Enxc.hypotenuse)(s[k], a.get(i, k));
                if (s[k] !== 0) {
                    if (a.get(k, k) < 0) s[k] = -s[k];
                    for(let i = k; i < m; i++)a.set(i, k, a.get(i, k) / s[k]);
                    a.set(k, k, a.get(k, k) + 1);
                }
                s[k] = -s[k];
            }
            for(let j = k + 1; j < n; j++){
                if (k < nct && s[k] !== 0) {
                    let t = 0;
                    for(let i = k; i < m; i++)t += a.get(i, k) * a.get(i, j);
                    t = -t / a.get(k, k);
                    for(let i = k; i < m; i++)a.set(i, j, a.get(i, j) + t * a.get(i, k));
                }
                e[j] = a.get(k, j);
            }
            if (wantu && k < nct) for(let i = k; i < m; i++)U.set(i, k, a.get(i, k));
            if (k < nrt) {
                e[k] = 0;
                for(let i = k + 1; i < n; i++)e[k] = (0, $8Enxc.hypotenuse)(e[k], e[i]);
                if (e[k] !== 0) {
                    if (e[k + 1] < 0) e[k] = 0 - e[k];
                    for(let i = k + 1; i < n; i++)e[i] /= e[k];
                    e[k + 1] += 1;
                }
                e[k] = -e[k];
                if (k + 1 < m && e[k] !== 0) {
                    for(let i = k + 1; i < m; i++)work[i] = 0;
                    for(let i = k + 1; i < m; i++)for(let j = k + 1; j < n; j++)work[i] += e[j] * a.get(i, j);
                    for(let j = k + 1; j < n; j++){
                        let t = -e[j] / e[k + 1];
                        for(let i = k + 1; i < m; i++)a.set(i, j, a.get(i, j) + t * work[i]);
                    }
                }
                if (wantv) for(let i = k + 1; i < n; i++)V.set(i, k, e[i]);
            }
        }
        let p = Math.min(n, m + 1);
        if (nct < n) s[nct] = a.get(nct, nct);
        if (m < p) s[p - 1] = 0;
        if (nrt + 1 < p) e[nrt] = a.get(nrt, p - 1);
        e[p - 1] = 0;
        if (wantu) {
            for(let j = nct; j < nu; j++){
                for(let i = 0; i < m; i++)U.set(i, j, 0);
                U.set(j, j, 1);
            }
            for(let k = nct - 1; k >= 0; k--)if (s[k] !== 0) {
                for(let j = k + 1; j < nu; j++){
                    let t = 0;
                    for(let i = k; i < m; i++)t += U.get(i, k) * U.get(i, j);
                    t = -t / U.get(k, k);
                    for(let i = k; i < m; i++)U.set(i, j, U.get(i, j) + t * U.get(i, k));
                }
                for(let i = k; i < m; i++)U.set(i, k, -U.get(i, k));
                U.set(k, k, 1 + U.get(k, k));
                for(let i = 0; i < k - 1; i++)U.set(i, k, 0);
            } else {
                for(let i = 0; i < m; i++)U.set(i, k, 0);
                U.set(k, k, 1);
            }
        }
        if (wantv) for(let k = n - 1; k >= 0; k--){
            if (k < nrt && e[k] !== 0) for(let j = k + 1; j < n; j++){
                let t = 0;
                for(let i = k + 1; i < n; i++)t += V.get(i, k) * V.get(i, j);
                t = -t / V.get(k + 1, k);
                for(let i = k + 1; i < n; i++)V.set(i, j, V.get(i, j) + t * V.get(i, k));
            }
            for(let i = 0; i < n; i++)V.set(i, k, 0);
            V.set(k, k, 1);
        }
        let pp = p - 1;
        let iter = 0;
        let eps = Number.EPSILON;
        while(p > 0){
            let k, kase;
            for(k = p - 2; k >= -1; k--){
                if (k === -1) break;
                const alpha = Number.MIN_VALUE + eps * Math.abs(s[k] + Math.abs(s[k + 1]));
                if (Math.abs(e[k]) <= alpha || Number.isNaN(e[k])) {
                    e[k] = 0;
                    break;
                }
            }
            if (k === p - 2) kase = 4;
            else {
                let ks;
                for(ks = p - 1; ks >= k; ks--){
                    if (ks === k) break;
                    let t = (ks !== p ? Math.abs(e[ks]) : 0) + (ks !== k + 1 ? Math.abs(e[ks - 1]) : 0);
                    if (Math.abs(s[ks]) <= eps * t) {
                        s[ks] = 0;
                        break;
                    }
                }
                if (ks === k) kase = 3;
                else if (ks === p - 1) kase = 1;
                else {
                    kase = 2;
                    k = ks;
                }
            }
            k++;
            switch(kase){
                case 1:
                    {
                        let f = e[p - 2];
                        e[p - 2] = 0;
                        for(let j = p - 2; j >= k; j--){
                            let t = (0, $8Enxc.hypotenuse)(s[j], f);
                            let cs = s[j] / t;
                            let sn = f / t;
                            s[j] = t;
                            if (j !== k) {
                                f = -sn * e[j - 1];
                                e[j - 1] = cs * e[j - 1];
                            }
                            if (wantv) for(let i = 0; i < n; i++){
                                t = cs * V.get(i, j) + sn * V.get(i, p - 1);
                                V.set(i, p - 1, -sn * V.get(i, j) + cs * V.get(i, p - 1));
                                V.set(i, j, t);
                            }
                        }
                        break;
                    }
                case 2:
                    {
                        let f = e[k - 1];
                        e[k - 1] = 0;
                        for(let j = k; j < p; j++){
                            let t = (0, $8Enxc.hypotenuse)(s[j], f);
                            let cs = s[j] / t;
                            let sn = f / t;
                            s[j] = t;
                            f = -sn * e[j];
                            e[j] = cs * e[j];
                            if (wantu) for(let i = 0; i < m; i++){
                                t = cs * U.get(i, j) + sn * U.get(i, k - 1);
                                U.set(i, k - 1, -sn * U.get(i, j) + cs * U.get(i, k - 1));
                                U.set(i, j, t);
                            }
                        }
                        break;
                    }
                case 3:
                    {
                        const scale = Math.max(Math.abs(s[p - 1]), Math.abs(s[p - 2]), Math.abs(e[p - 2]), Math.abs(s[k]), Math.abs(e[k]));
                        const sp = s[p - 1] / scale;
                        const spm1 = s[p - 2] / scale;
                        const epm1 = e[p - 2] / scale;
                        const sk = s[k] / scale;
                        const ek = e[k] / scale;
                        const b = ((spm1 + sp) * (spm1 - sp) + epm1 * epm1) / 2;
                        const c = sp * epm1 * (sp * epm1);
                        let shift = 0;
                        if (b !== 0 || c !== 0) {
                            if (b < 0) shift = 0 - Math.sqrt(b * b + c);
                            else shift = Math.sqrt(b * b + c);
                            shift = c / (b + shift);
                        }
                        let f = (sk + sp) * (sk - sp) + shift;
                        let g = sk * ek;
                        for(let j = k; j < p - 1; j++){
                            let t = (0, $8Enxc.hypotenuse)(f, g);
                            if (t === 0) t = Number.MIN_VALUE;
                            let cs = f / t;
                            let sn = g / t;
                            if (j !== k) e[j - 1] = t;
                            f = cs * s[j] + sn * e[j];
                            e[j] = cs * e[j] - sn * s[j];
                            g = sn * s[j + 1];
                            s[j + 1] = cs * s[j + 1];
                            if (wantv) for(let i = 0; i < n; i++){
                                t = cs * V.get(i, j) + sn * V.get(i, j + 1);
                                V.set(i, j + 1, -sn * V.get(i, j) + cs * V.get(i, j + 1));
                                V.set(i, j, t);
                            }
                            t = (0, $8Enxc.hypotenuse)(f, g);
                            if (t === 0) t = Number.MIN_VALUE;
                            cs = f / t;
                            sn = g / t;
                            s[j] = t;
                            f = cs * e[j] + sn * s[j + 1];
                            s[j + 1] = -sn * e[j] + cs * s[j + 1];
                            g = sn * e[j + 1];
                            e[j + 1] = cs * e[j + 1];
                            if (wantu && j < m - 1) for(let i = 0; i < m; i++){
                                t = cs * U.get(i, j) + sn * U.get(i, j + 1);
                                U.set(i, j + 1, -sn * U.get(i, j) + cs * U.get(i, j + 1));
                                U.set(i, j, t);
                            }
                        }
                        e[p - 2] = f;
                        iter = iter + 1;
                        break;
                    }
                case 4:
                    if (s[k] <= 0) {
                        s[k] = s[k] < 0 ? -s[k] : 0;
                        if (wantv) for(let i = 0; i <= pp; i++)V.set(i, k, -V.get(i, k));
                    }
                    while(k < pp){
                        if (s[k] >= s[k + 1]) break;
                        let t = s[k];
                        s[k] = s[k + 1];
                        s[k + 1] = t;
                        if (wantv && k < n - 1) for(let i = 0; i < n; i++){
                            t = V.get(i, k + 1);
                            V.set(i, k + 1, V.get(i, k));
                            V.set(i, k, t);
                        }
                        if (wantu && k < m - 1) for(let i = 0; i < m; i++){
                            t = U.get(i, k + 1);
                            U.set(i, k + 1, U.get(i, k));
                            U.set(i, k, t);
                        }
                        k++;
                    }
                    iter = 0;
                    p--;
                    break;
            }
        }
        if (swapped) {
            let tmp = V;
            V = U;
            U = tmp;
        }
        this.m = m;
        this.n = n;
        this.s = s;
        this.U = U;
        this.V = V;
    }
    solve(value) {
        let Y = value;
        let e = this.threshold;
        let scols = this.s.length;
        let Ls = (0, $gGKJ4.default).zeros(scols, scols);
        for(let i = 0; i < scols; i++)if (Math.abs(this.s[i]) <= e) Ls.set(i, i, 0);
        else Ls.set(i, i, 1 / this.s[i]);
        let U = this.U;
        let V = this.rightSingularVectors;
        let VL = V.mmul(Ls);
        let vrows = V.rows;
        let urows = U.rows;
        let VLU = (0, $gGKJ4.default).zeros(vrows, urows);
        for(let i = 0; i < vrows; i++)for(let j = 0; j < urows; j++){
            let sum = 0;
            for(let k = 0; k < scols; k++)sum += VL.get(i, k) * U.get(j, k);
            VLU.set(i, j, sum);
        }
        return VLU.mmul(Y);
    }
    solveForDiagonal(value) {
        return this.solve((0, $gGKJ4.default).diag(value));
    }
    inverse() {
        let V = this.V;
        let e = this.threshold;
        let vrows = V.rows;
        let vcols = V.columns;
        let X = new (0, $gGKJ4.default)(vrows, this.s.length);
        for(let i = 0; i < vrows; i++){
            for(let j = 0; j < vcols; j++)if (Math.abs(this.s[j]) > e) X.set(i, j, V.get(i, j) / this.s[j]);
        }
        let U = this.U;
        let urows = U.rows;
        let ucols = U.columns;
        let Y = new (0, $gGKJ4.default)(vrows, urows);
        for(let i = 0; i < vrows; i++)for(let j = 0; j < urows; j++){
            let sum = 0;
            for(let k = 0; k < ucols; k++)sum += X.get(i, k) * U.get(j, k);
            Y.set(i, j, sum);
        }
        return Y;
    }
    get condition() {
        return this.s[0] / this.s[Math.min(this.m, this.n) - 1];
    }
    get norm2() {
        return this.s[0];
    }
    get rank() {
        let tol = Math.max(this.m, this.n) * this.s[0] * Number.EPSILON;
        let r = 0;
        let s = this.s;
        for(let i = 0, ii = s.length; i < ii; i++)if (s[i] > tol) r++;
        return r;
    }
    get diagonal() {
        return Array.from(this.s);
    }
    get threshold() {
        return Number.EPSILON / 2 * Math.max(this.m, this.n) * this.s[0];
    }
    get leftSingularVectors() {
        return this.U;
    }
    get rightSingularVectors() {
        return this.V;
    }
    get diagonalMatrix() {
        return (0, $gGKJ4.default).diag(this.s);
    }
}

});
parcelRegister("jLEGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e641f7ac1358cb4d$export$2e2bcd8739ae039);

var $gGKJ4 = parcelRequire("gGKJ4");
class $e641f7ac1358cb4d$export$2e2bcd8739ae039 extends (0, $gGKJ4.AbstractMatrix) {
    constructor(data){
        super();
        this.data = data;
        this.rows = data.length;
        this.columns = data[0].length;
    }
    set(rowIndex, columnIndex, value) {
        this.data[rowIndex][columnIndex] = value;
        return this;
    }
    get(rowIndex, columnIndex) {
        return this.data[rowIndex][columnIndex];
    }
}

});

parcelRegister("8Enxc", function(module, exports) {

$parcel$export(module.exports, "hypotenuse", () => $64c4509f4b1277fc$export$39cf33a0d758f8b4);
function $64c4509f4b1277fc$export$39cf33a0d758f8b4(a, b) {
    let r = 0;
    if (Math.abs(a) > Math.abs(b)) {
        r = b / a;
        return Math.abs(a) * Math.sqrt(1 + r * r);
    }
    if (b !== 0) {
        r = a / b;
        return Math.abs(b) * Math.sqrt(1 + r * r);
    }
    return 0;
}

});


parcelRegister("8e7dj", function(module, exports) {

$parcel$export(module.exports, "floydWarshall", () => $5fd53a0c3903eef1$export$fbbf4bd85aaff6bd);
$parcel$export(module.exports, "getAdjMatrix", () => $5fd53a0c3903eef1$export$b7dd8b2289c43065);
$parcel$export(module.exports, "scaleMatrix", () => $5fd53a0c3903eef1$export$f89d8f511263c5b);
$parcel$export(module.exports, "getLayoutBBox", () => $5fd53a0c3903eef1$export$4d7b865a5fd254d3);
$parcel$export(module.exports, "getEuclideanDistance", () => $5fd53a0c3903eef1$export$58ff206e6557f2f0);
$parcel$export(module.exports, "graphTreeDfs", () => $5fd53a0c3903eef1$export$6c2da045c9b1be36);

var $jyI49 = parcelRequire("jyI49");

var $hHwGT = parcelRequire("hHwGT");
const $5fd53a0c3903eef1$export$fbbf4bd85aaff6bd = (adjMatrix)=>{
    // initialize
    const dist = [];
    const size = adjMatrix.length;
    for(let i = 0; i < size; i += 1){
        dist[i] = [];
        for(let j = 0; j < size; j += 1){
            if (i === j) dist[i][j] = 0;
            else if (adjMatrix[i][j] === 0 || !adjMatrix[i][j]) dist[i][j] = Infinity;
            else dist[i][j] = adjMatrix[i][j];
        }
    }
    // floyd
    for(let k = 0; k < size; k += 1)for(let i = 0; i < size; i += 1){
        for(let j = 0; j < size; j += 1)if (dist[i][j] > dist[i][k] + dist[k][j]) dist[i][j] = dist[i][k] + dist[k][j];
    }
    return dist;
};
const $5fd53a0c3903eef1$export$b7dd8b2289c43065 = (data, directed)=>{
    const { nodes: nodes, edges: edges } = data;
    const matrix = [];
    // map node with index in data.nodes
    const nodeMap = {};
    if (!nodes) throw new Error('invalid nodes data!');
    if (nodes) nodes.forEach((node, i)=>{
        nodeMap[node.id] = i;
        const row = [];
        matrix.push(row);
    });
    edges === null || edges === void 0 || edges.forEach((e)=>{
        const { source: source, target: target } = e;
        const sIndex = nodeMap[source];
        const tIndex = nodeMap[target];
        if (sIndex === undefined || tIndex === undefined) return;
        matrix[sIndex][tIndex] = 1;
        if (!directed) matrix[tIndex][sIndex] = 1;
    });
    return matrix;
};
const $5fd53a0c3903eef1$export$f89d8f511263c5b = (matrix, ratio)=>{
    const result = [];
    matrix.forEach((row)=>{
        const newRow = [];
        row.forEach((v)=>{
            newRow.push(v * ratio);
        });
        result.push(newRow);
    });
    return result;
};
const $5fd53a0c3903eef1$export$4d7b865a5fd254d3 = (nodes)=>{
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    nodes.forEach((node)=>{
        let size = node.data.size;
        if ((0, $hHwGT.isArray)(size)) {
            if (size.length === 1) size = [
                size[0],
                size[0]
            ];
        } else if ((0, $jyI49.default)(size)) size = [
            size,
            size
        ];
        else if (size === undefined || isNaN(size)) size = [
            30,
            30
        ];
        const halfSize = [
            size[0] / 2,
            size[1] / 2
        ];
        const left = node.data.x - halfSize[0];
        const right = node.data.x + halfSize[0];
        const top = node.data.y - halfSize[1];
        const bottom = node.data.y + halfSize[1];
        if (minX > left) minX = left;
        if (minY > top) minY = top;
        if (maxX < right) maxX = right;
        if (maxY < bottom) maxY = bottom;
    });
    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY
    };
};
const $5fd53a0c3903eef1$export$58ff206e6557f2f0 = (p1, p2)=>Math.sqrt((p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y));
const $5fd53a0c3903eef1$export$6c2da045c9b1be36 = (graph, nodes, fn, mode = 'TB', treeKey, stopFns = {})=>{
    if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length)) return;
    const { stopBranchFn: stopBranchFn, stopAllFn: stopAllFn } = stopFns;
    for(let i = 0; i < nodes.length; i++){
        const node = nodes[i];
        if (!graph.hasNode(node.id)) continue;
        if (stopBranchFn === null || stopBranchFn === void 0 ? void 0 : stopBranchFn(node)) continue; // Stop this branch
        if (stopAllFn === null || stopAllFn === void 0 ? void 0 : stopAllFn(node)) return; // Stop all
        if (mode === 'TB') fn(node); // Traverse from top to bottom
        $5fd53a0c3903eef1$export$6c2da045c9b1be36(graph, graph.getChildren(node.id, treeKey), fn, mode, treeKey, stopFns);
        if (mode !== 'TB') fn(node); // Traverse from bottom to top
    }
};

});


parcelRegister("g98sr", function(module, exports) {

$parcel$export(module.exports, "isLayoutWithIterations", () => $bc140c225acc800a$export$6db3e338b9f8fea2);
function $bc140c225acc800a$export$6db3e338b9f8fea2(layout) {
    return !!layout.tick && !!layout.stop;
}

});


parcelRegister("hhpea", function(module, exports) {

$parcel$export(module.exports, "D3ForceLayout", () => $c94797e116bc2b7a$export$8ff17a5dd8c72f61);

var $7WQrb = parcelRequire("7WQrb");

var $iE4so = parcelRequire("iE4so");
var $cyCCc = parcelRequire("cyCCc");

var $4lQVz = parcelRequire("4lQVz");
var $giq4g = parcelRequire("giq4g");
var $5HLGf = parcelRequire("5HLGf");
var $9dRdw = parcelRequire("9dRdw");
var $9yZF1 = parcelRequire("9yZF1");
var $lhHp2 = parcelRequire("lhHp2");
var $cQlPV = parcelRequire("cQlPV");
var $etPOH = parcelRequire("etPOH");
class $c94797e116bc2b7a$export$8ff17a5dd8c72f61 {
    constructor(options){
        this.id = 'd3-force';
        this.config = {
            inputNodeAttrs: [
                'x',
                'y',
                'vx',
                'vy',
                'fx',
                'fy'
            ],
            outputNodeAttrs: [
                'x',
                'y',
                'vx',
                'vy'
            ],
            simulationAttrs: [
                'alpha',
                'alphaMin',
                'alphaDecay',
                'alphaTarget',
                'velocityDecay',
                'randomSource'
            ]
        };
        this.forceMap = {
            link: (0, $5HLGf.default),
            manyBody: (0, $9dRdw.default),
            center: (0, $4lQVz.default),
            collide: (0, $giq4g.default),
            radial: (0, $9yZF1.default),
            x: (0, $cQlPV.default),
            y: (0, $etPOH.default)
        };
        // @ts-ignore
        this.options = {
            link: {
                id: (edge)=>edge.id
            },
            manyBody: {},
            center: {
                x: 0,
                y: 0
            }
        };
        this.context = {
            options: {},
            assign: false,
            nodes: [],
            edges: []
        };
        (0, $iE4so.default)(this.options, options);
        if (this.options.forceSimulation) this.simulation = this.options.forceSimulation;
    }
    execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericLayout(false, graph, options);
        });
    }
    assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericLayout(true, graph, options);
        });
    }
    stop() {
        this.simulation.stop();
    }
    tick(iterations) {
        this.simulation.tick(iterations);
        return this.getResult();
    }
    restart() {
        this.simulation.restart();
    }
    setFixedPosition(id, position) {
        const node = this.context.nodes.find((n)=>n.id === id);
        if (!node) return;
        position.forEach((value, index)=>{
            if (typeof value === 'number' || value === null) {
                const key = [
                    'fx',
                    'fy',
                    'fz'
                ][index];
                node[key] = value;
            }
        });
    }
    getOptions(options) {
        var _a, _b;
        const _ = (0, $iE4so.default)({}, this.options, options);
        // process nodeSize
        if (_.collide && ((_a = _.collide) === null || _a === void 0 ? void 0 : _a.radius) === undefined) {
            _.collide = _.collide || {};
            // @ts-ignore
            _.collide.radius = (_b = _.nodeSize) !== null && _b !== void 0 ? _b : 10;
        }
        // process iterations
        if (_.iterations === undefined) {
            if (_.link && _.link.iterations === undefined) _.iterations = _.link.iterations;
            if (_.collide && _.collide.iterations === undefined) _.iterations = _.collide.iterations;
        }
        // assign to context
        this.context.options = _;
        return _;
    }
    genericLayout(assign, graph, options) {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const _options = this.getOptions(options);
            const nodes = graph.getAllNodes().map(({ id: id, data: data })=>Object.assign(Object.assign({
                    id: id
                }, data), (0, $cyCCc.default)(data.data, this.config.inputNodeAttrs)));
            const edges = graph.getAllEdges().map((edge)=>Object.assign({}, edge));
            Object.assign(this.context, {
                assign: assign,
                nodes: nodes,
                edges: edges,
                graph: graph
            });
            const promise = new Promise((resolver)=>{
                this.resolver = resolver;
            });
            const simulation = this.setSimulation(_options);
            simulation.nodes(nodes);
            (_a = simulation.force('link')) === null || _a === void 0 || _a.links(edges);
            return promise;
        });
    }
    getResult() {
        const { assign: assign, nodes: nodes, edges: edges, graph: graph } = this.context;
        const nodesResult = nodes.map((node)=>({
                id: node.id,
                data: Object.assign(Object.assign({}, node.data), (0, $cyCCc.default)(node, this.config.outputNodeAttrs))
            }));
        const edgeResult = edges.map(({ id: id, source: source, target: target, data: data })=>({
                id: id,
                source: typeof source === 'object' ? source.id : source,
                target: typeof target === 'object' ? target.id : target,
                data: data
            }));
        if (assign) nodesResult.forEach((node)=>graph.mergeNodeData(node.id, node.data));
        return {
            nodes: nodesResult,
            edges: edgeResult
        };
    }
    initSimulation() {
        return (0, $lhHp2.default)();
    }
    setSimulation(options) {
        const simulation = this.simulation || this.options.forceSimulation || this.initSimulation();
        if (!this.simulation) this.simulation = simulation.on('tick', ()=>{
            var _a;
            return (_a = options.onTick) === null || _a === void 0 ? void 0 : _a.call(options, this.getResult());
        }).on('end', ()=>{
            var _a;
            return (_a = this.resolver) === null || _a === void 0 ? void 0 : _a.call(this, this.getResult());
        });
        $c94797e116bc2b7a$var$apply(simulation, this.config.simulationAttrs.map((name)=>[
                name,
                options[name]
            ]));
        Object.entries(this.forceMap).forEach(([name, Ctor])=>{
            const forceName = name;
            if (options[name]) {
                let force = simulation.force(forceName);
                if (!force) {
                    force = Ctor();
                    simulation.force(forceName, force);
                }
                $c94797e116bc2b7a$var$apply(force, Object.entries(options[forceName]));
            } else simulation.force(forceName, null);
        });
        return simulation;
    }
}
const $c94797e116bc2b7a$var$apply = (target, params)=>{
    return params.reduce((acc, [method, param])=>{
        if (!acc[method] || param === undefined) return acc;
        return acc[method].call(target, param);
    }, target);
};

});
parcelRegister("4lQVz", function(module, exports) {

$parcel$export(module.exports, "default", () => $32b22de0132cc595$export$2e2bcd8739ae039);
function $32b22de0132cc595$export$2e2bcd8739ae039(x, y) {
    var nodes, strength = 1;
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force() {
        var i, n = nodes.length, node, sx = 0, sy = 0;
        for(i = 0; i < n; ++i)node = nodes[i], sx += node.x, sy += node.y;
        for(sx = (sx / n - x) * strength, sy = (sy / n - y) * strength, i = 0; i < n; ++i)node = nodes[i], node.x -= sx, node.y -= sy;
    }
    force.initialize = function(_) {
        nodes = _;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    return force;
}

});

parcelRegister("giq4g", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd28c4fe1fd882d$export$2e2bcd8739ae039);

var $d0mwP = parcelRequire("d0mwP");

var $fcgQ0 = parcelRequire("fcgQ0");

var $3Wp9e = parcelRequire("3Wp9e");
function $bdd28c4fe1fd882d$var$x(d) {
    return d.x + d.vx;
}
function $bdd28c4fe1fd882d$var$y(d) {
    return d.y + d.vy;
}
function $bdd28c4fe1fd882d$export$2e2bcd8739ae039(radius) {
    var nodes, radii, random, strength = 1, iterations = 1;
    if (typeof radius !== "function") radius = (0, $fcgQ0.default)(radius == null ? 1 : +radius);
    function force() {
        var i, n = nodes.length, tree, node, xi, yi, ri, ri2;
        for(var k = 0; k < iterations; ++k){
            tree = (0, $d0mwP.default)(nodes, $bdd28c4fe1fd882d$var$x, $bdd28c4fe1fd882d$var$y).visitAfter(prepare);
            for(i = 0; i < n; ++i){
                node = nodes[i];
                ri = radii[node.index], ri2 = ri * ri;
                xi = node.x + node.vx;
                yi = node.y + node.vy;
                tree.visit(apply);
            }
        }
        function apply(quad, x0, y0, x1, y1) {
            var data = quad.data, rj = quad.r, r = ri + rj;
            if (data) {
                if (data.index > node.index) {
                    var x = xi - data.x - data.vx, y = yi - data.y - data.vy, l = x * x + y * y;
                    if (l < r * r) {
                        if (x === 0) x = (0, $3Wp9e.default)(random), l += x * x;
                        if (y === 0) y = (0, $3Wp9e.default)(random), l += y * y;
                        l = (r - (l = Math.sqrt(l))) / l * strength;
                        node.vx += (x *= l) * (r = (rj *= rj) / (ri2 + rj));
                        node.vy += (y *= l) * r;
                        data.vx -= x * (r = 1 - r);
                        data.vy -= y * r;
                    }
                }
                return;
            }
            return x0 > xi + r || x1 < xi - r || y0 > yi + r || y1 < yi - r;
        }
    }
    function prepare(quad) {
        if (quad.data) return quad.r = radii[quad.data.index];
        for(var i = quad.r = 0; i < 4; ++i)if (quad[i] && quad[i].r > quad.r) quad.r = quad[i].r;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        radii = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], radii[node.index] = +radius(node, i, nodes);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = +_, force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initialize(), force) : radius;
    };
    return force;
}

});
parcelRegister("fcgQ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b10509a5c523ef79$export$2e2bcd8739ae039);
function $b10509a5c523ef79$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("3Wp9e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dea4bbaea189065$export$2e2bcd8739ae039);
function $2dea4bbaea189065$export$2e2bcd8739ae039(random) {
    return (random() - 0.5) * 1e-6;
}

});


parcelRegister("5HLGf", function(module, exports) {

$parcel$export(module.exports, "default", () => $4275f440a0eccb35$export$2e2bcd8739ae039);

var $fcgQ0 = parcelRequire("fcgQ0");

var $3Wp9e = parcelRequire("3Wp9e");
function $4275f440a0eccb35$var$index(d) {
    return d.index;
}
function $4275f440a0eccb35$var$find(nodeById, nodeId) {
    var node = nodeById.get(nodeId);
    if (!node) throw new Error("node not found: " + nodeId);
    return node;
}
function $4275f440a0eccb35$export$2e2bcd8739ae039(links) {
    var id = $4275f440a0eccb35$var$index, strength = defaultStrength, strengths, distance = (0, $fcgQ0.default)(30), distances, nodes, count, bias, random, iterations = 1;
    if (links == null) links = [];
    function defaultStrength(link) {
        return 1 / Math.min(count[link.source.index], count[link.target.index]);
    }
    function force(alpha) {
        for(var k = 0, n = links.length; k < iterations; ++k)for(var i = 0, link, source, target, x, y, l, b; i < n; ++i){
            link = links[i], source = link.source, target = link.target;
            x = target.x + target.vx - source.x - source.vx || (0, $3Wp9e.default)(random);
            y = target.y + target.vy - source.y - source.vy || (0, $3Wp9e.default)(random);
            l = Math.sqrt(x * x + y * y);
            l = (l - distances[i]) / l * alpha * strengths[i];
            x *= l, y *= l;
            target.vx -= x * (b = bias[i]);
            target.vy -= y * b;
            source.vx += x * (b = 1 - b);
            source.vy += y * b;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, m = links.length, nodeById = new Map(nodes.map((d, i)=>[
                id(d, i, nodes),
                d
            ])), link;
        for(i = 0, count = new Array(n); i < m; ++i){
            link = links[i], link.index = i;
            if (typeof link.source !== "object") link.source = $4275f440a0eccb35$var$find(nodeById, link.source);
            if (typeof link.target !== "object") link.target = $4275f440a0eccb35$var$find(nodeById, link.target);
            count[link.source.index] = (count[link.source.index] || 0) + 1;
            count[link.target.index] = (count[link.target.index] || 0) + 1;
        }
        for(i = 0, bias = new Array(m); i < m; ++i)link = links[i], bias[i] = count[link.source.index] / (count[link.source.index] + count[link.target.index]);
        strengths = new Array(m), initializeStrength();
        distances = new Array(m), initializeDistance();
    }
    function initializeStrength() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)strengths[i] = +strength(links[i], i, links);
    }
    function initializeDistance() {
        if (!nodes) return;
        for(var i = 0, n = links.length; i < n; ++i)distances[i] = +distance(links[i], i, links);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.links = function(_) {
        return arguments.length ? (links = _, initialize(), force) : links;
    };
    force.id = function(_) {
        return arguments.length ? (id = _, force) : id;
    };
    force.iterations = function(_) {
        return arguments.length ? (iterations = +_, force) : iterations;
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initializeStrength(), force) : strength;
    };
    force.distance = function(_) {
        return arguments.length ? (distance = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initializeDistance(), force) : distance;
    };
    return force;
}

});

parcelRegister("9dRdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b6e9bc7f2e1a0ee$export$2e2bcd8739ae039);

var $d0mwP = parcelRequire("d0mwP");

var $fcgQ0 = parcelRequire("fcgQ0");

var $3Wp9e = parcelRequire("3Wp9e");

var $lhHp2 = parcelRequire("lhHp2");
function $6b6e9bc7f2e1a0ee$export$2e2bcd8739ae039() {
    var nodes, node, random, alpha, strength = (0, $fcgQ0.default)(-30), strengths, distanceMin2 = 1, distanceMax2 = Infinity, theta2 = 0.81;
    function force(_) {
        var i, n = nodes.length, tree = (0, $d0mwP.default)(nodes, (0, $lhHp2.x), (0, $lhHp2.y)).visitAfter(accumulate);
        for(alpha = _, i = 0; i < n; ++i)node = nodes[i], tree.visit(apply);
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length, node;
        strengths = new Array(n);
        for(i = 0; i < n; ++i)node = nodes[i], strengths[node.index] = +strength(node, i, nodes);
    }
    function accumulate(quad) {
        var strength = 0, q, c, weight = 0, x, y, i;
        // For internal nodes, accumulate forces from child quadrants.
        if (quad.length) {
            for(x = y = i = 0; i < 4; ++i)if ((q = quad[i]) && (c = Math.abs(q.value))) strength += q.value, weight += c, x += c * q.x, y += c * q.y;
            quad.x = x / weight;
            quad.y = y / weight;
        } else {
            q = quad;
            q.x = q.data.x;
            q.y = q.data.y;
            do strength += strengths[q.data.index];
            while (q = q.next);
        }
        quad.value = strength;
    }
    function apply(quad, x1, _, x2) {
        if (!quad.value) return true;
        var x = quad.x - node.x, y = quad.y - node.y, w = x2 - x1, l = x * x + y * y;
        // Apply the Barnes-Hut approximation if possible.
        // Limit forces for very close nodes; randomize direction if coincident.
        if (w * w / theta2 < l) {
            if (l < distanceMax2) {
                if (x === 0) x = (0, $3Wp9e.default)(random), l += x * x;
                if (y === 0) y = (0, $3Wp9e.default)(random), l += y * y;
                if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
                node.vx += x * quad.value * alpha / l;
                node.vy += y * quad.value * alpha / l;
            }
            return true;
        } else if (quad.length || l >= distanceMax2) return;
        // Limit forces for very close nodes; randomize direction if coincident.
        if (quad.data !== node || quad.next) {
            if (x === 0) x = (0, $3Wp9e.default)(random), l += x * x;
            if (y === 0) y = (0, $3Wp9e.default)(random), l += y * y;
            if (l < distanceMin2) l = Math.sqrt(distanceMin2 * l);
        }
        do if (quad.data !== node) {
            w = strengths[quad.data.index] * alpha / l;
            node.vx += x * w;
            node.vy += y * w;
        }
        while (quad = quad.next);
    }
    force.initialize = function(_nodes, _random) {
        nodes = _nodes;
        random = _random;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initialize(), force) : strength;
    };
    force.distanceMin = function(_) {
        return arguments.length ? (distanceMin2 = _ * _, force) : Math.sqrt(distanceMin2);
    };
    force.distanceMax = function(_) {
        return arguments.length ? (distanceMax2 = _ * _, force) : Math.sqrt(distanceMax2);
    };
    force.theta = function(_) {
        return arguments.length ? (theta2 = _ * _, force) : Math.sqrt(theta2);
    };
    return force;
}

});
parcelRegister("lhHp2", function(module, exports) {

$parcel$export(module.exports, "x", () => $f7ecda670cf68ae1$export$d141bba7fdc215a3);
$parcel$export(module.exports, "y", () => $f7ecda670cf68ae1$export$4a5767248b18ef41);
$parcel$export(module.exports, "default", () => $f7ecda670cf68ae1$export$2e2bcd8739ae039);

var $aFEgl = parcelRequire("aFEgl");

var $jSjsP = parcelRequire("jSjsP");

var $3CV51 = parcelRequire("3CV51");
function $f7ecda670cf68ae1$export$d141bba7fdc215a3(d) {
    return d.x;
}
function $f7ecda670cf68ae1$export$4a5767248b18ef41(d) {
    return d.y;
}
var $f7ecda670cf68ae1$var$initialRadius = 10, $f7ecda670cf68ae1$var$initialAngle = Math.PI * (3 - Math.sqrt(5));
function $f7ecda670cf68ae1$export$2e2bcd8739ae039(nodes) {
    var simulation, alpha = 1, alphaMin = 0.001, alphaDecay = 1 - Math.pow(alphaMin, 1 / 300), alphaTarget = 0, velocityDecay = 0.6, forces = new Map(), stepper = (0, $jSjsP.timer)(step), event = (0, $aFEgl.default)("tick", "end"), random = (0, $3CV51.default)();
    if (nodes == null) nodes = [];
    function step() {
        tick();
        event.call("tick", simulation);
        if (alpha < alphaMin) {
            stepper.stop();
            event.call("end", simulation);
        }
    }
    function tick(iterations) {
        var i, n = nodes.length, node;
        if (iterations === undefined) iterations = 1;
        for(var k = 0; k < iterations; ++k){
            alpha += (alphaTarget - alpha) * alphaDecay;
            forces.forEach(function(force) {
                force(alpha);
            });
            for(i = 0; i < n; ++i){
                node = nodes[i];
                if (node.fx == null) node.x += node.vx *= velocityDecay;
                else node.x = node.fx, node.vx = 0;
                if (node.fy == null) node.y += node.vy *= velocityDecay;
                else node.y = node.fy, node.vy = 0;
            }
        }
        return simulation;
    }
    function initializeNodes() {
        for(var i = 0, n = nodes.length, node; i < n; ++i){
            node = nodes[i], node.index = i;
            if (node.fx != null) node.x = node.fx;
            if (node.fy != null) node.y = node.fy;
            if (isNaN(node.x) || isNaN(node.y)) {
                var radius = $f7ecda670cf68ae1$var$initialRadius * Math.sqrt(0.5 + i), angle = i * $f7ecda670cf68ae1$var$initialAngle;
                node.x = radius * Math.cos(angle);
                node.y = radius * Math.sin(angle);
            }
            if (isNaN(node.vx) || isNaN(node.vy)) node.vx = node.vy = 0;
        }
    }
    function initializeForce(force) {
        if (force.initialize) force.initialize(nodes, random);
        return force;
    }
    initializeNodes();
    return simulation = {
        tick: tick,
        restart: function() {
            return stepper.restart(step), simulation;
        },
        stop: function() {
            return stepper.stop(), simulation;
        },
        nodes: function(_) {
            return arguments.length ? (nodes = _, initializeNodes(), forces.forEach(initializeForce), simulation) : nodes;
        },
        alpha: function(_) {
            return arguments.length ? (alpha = +_, simulation) : alpha;
        },
        alphaMin: function(_) {
            return arguments.length ? (alphaMin = +_, simulation) : alphaMin;
        },
        alphaDecay: function(_) {
            return arguments.length ? (alphaDecay = +_, simulation) : +alphaDecay;
        },
        alphaTarget: function(_) {
            return arguments.length ? (alphaTarget = +_, simulation) : alphaTarget;
        },
        velocityDecay: function(_) {
            return arguments.length ? (velocityDecay = 1 - _, simulation) : 1 - velocityDecay;
        },
        randomSource: function(_) {
            return arguments.length ? (random = _, forces.forEach(initializeForce), simulation) : random;
        },
        force: function(name, _) {
            return arguments.length > 1 ? (_ == null ? forces.delete(name) : forces.set(name, initializeForce(_)), simulation) : forces.get(name);
        },
        find: function(x, y, radius) {
            var i = 0, n = nodes.length, dx, dy, d2, node, closest;
            if (radius == null) radius = Infinity;
            else radius *= radius;
            for(i = 0; i < n; ++i){
                node = nodes[i];
                dx = x - node.x;
                dy = y - node.y;
                d2 = dx * dx + dy * dy;
                if (d2 < radius) closest = node, radius = d2;
            }
            return closest;
        },
        on: function(name, _) {
            return arguments.length > 1 ? (event.on(name, _), simulation) : event.on(name);
        }
    };
}

});
parcelRegister("aFEgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4cf709d1826294$export$2e2bcd8739ae039);
var $7c4cf709d1826294$var$noop = {
    value: ()=>{}
};
function $7c4cf709d1826294$var$dispatch() {
    for(var i = 0, n = arguments.length, _ = {}, t; i < n; ++i){
        if (!(t = arguments[i] + "") || t in _ || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
        _[t] = [];
    }
    return new $7c4cf709d1826294$var$Dispatch(_);
}
function $7c4cf709d1826294$var$Dispatch(_) {
    this._ = _;
}
function $7c4cf709d1826294$var$parseTypenames(typenames, types) {
    return typenames.trim().split(/^|\s+/).map(function(t) {
        var name = "", i = t.indexOf(".");
        if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
        if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
        return {
            type: t,
            name: name
        };
    });
}
$7c4cf709d1826294$var$Dispatch.prototype = $7c4cf709d1826294$var$dispatch.prototype = {
    constructor: $7c4cf709d1826294$var$Dispatch,
    on: function(typename, callback) {
        var _ = this._, T = $7c4cf709d1826294$var$parseTypenames(typename + "", _), t, i = -1, n = T.length;
        // If no callback was specified, return the callback of the given type and name.
        if (arguments.length < 2) {
            while(++i < n)if ((t = (typename = T[i]).type) && (t = $7c4cf709d1826294$var$get(_[t], typename.name))) return t;
            return;
        }
        // If a type was specified, set the callback for the given type and name.
        // Otherwise, if a null callback was specified, remove callbacks of the given name.
        if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
        while(++i < n){
            if (t = (typename = T[i]).type) _[t] = $7c4cf709d1826294$var$set(_[t], typename.name, callback);
            else if (callback == null) for(t in _)_[t] = $7c4cf709d1826294$var$set(_[t], typename.name, null);
        }
        return this;
    },
    copy: function() {
        var copy = {}, _ = this._;
        for(var t in _)copy[t] = _[t].slice();
        return new $7c4cf709d1826294$var$Dispatch(copy);
    },
    call: function(type, that) {
        if ((n = arguments.length - 2) > 0) for(var args = new Array(n), i = 0, n, t; i < n; ++i)args[i] = arguments[i + 2];
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    },
    apply: function(type, that, args) {
        if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
        for(var t = this._[type], i = 0, n = t.length; i < n; ++i)t[i].value.apply(that, args);
    }
};
function $7c4cf709d1826294$var$get(type, name) {
    for(var i = 0, n = type.length, c; i < n; ++i){
        if ((c = type[i]).name === name) return c.value;
    }
}
function $7c4cf709d1826294$var$set(type, name, callback) {
    for(var i = 0, n = type.length; i < n; ++i)if (type[i].name === name) {
        type[i] = $7c4cf709d1826294$var$noop, type = type.slice(0, i).concat(type.slice(i + 1));
        break;
    }
    if (callback != null) type.push({
        name: name,
        value: callback
    });
    return type;
}
var $7c4cf709d1826294$export$2e2bcd8739ae039 = $7c4cf709d1826294$var$dispatch;

});

parcelRegister("jSjsP", function(module, exports) {

$parcel$export(module.exports, "timer", () => $e782289d8bd71451$export$9dc4ecf953986f04);
var $e782289d8bd71451$var$frame = 0, $e782289d8bd71451$var$timeout = 0, $e782289d8bd71451$var$interval = 0, $e782289d8bd71451$var$pokeDelay = 1000, $e782289d8bd71451$var$taskHead, $e782289d8bd71451$var$taskTail, $e782289d8bd71451$var$clockLast = 0, $e782289d8bd71451$var$clockNow = 0, $e782289d8bd71451$var$clockSkew = 0, $e782289d8bd71451$var$clock = typeof performance === "object" && performance.now ? performance : Date, $e782289d8bd71451$var$setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) {
    setTimeout(f, 17);
};
function $e782289d8bd71451$export$461939dd4422153() {
    return $e782289d8bd71451$var$clockNow || ($e782289d8bd71451$var$setFrame($e782289d8bd71451$var$clearNow), $e782289d8bd71451$var$clockNow = $e782289d8bd71451$var$clock.now() + $e782289d8bd71451$var$clockSkew);
}
function $e782289d8bd71451$var$clearNow() {
    $e782289d8bd71451$var$clockNow = 0;
}
function $e782289d8bd71451$export$c57e9b2d8b9e4de() {
    this._call = this._time = this._next = null;
}
$e782289d8bd71451$export$c57e9b2d8b9e4de.prototype = $e782289d8bd71451$export$9dc4ecf953986f04.prototype = {
    constructor: $e782289d8bd71451$export$c57e9b2d8b9e4de,
    restart: function(callback, delay, time) {
        if (typeof callback !== "function") throw new TypeError("callback is not a function");
        time = (time == null ? $e782289d8bd71451$export$461939dd4422153() : +time) + (delay == null ? 0 : +delay);
        if (!this._next && $e782289d8bd71451$var$taskTail !== this) {
            if ($e782289d8bd71451$var$taskTail) $e782289d8bd71451$var$taskTail._next = this;
            else $e782289d8bd71451$var$taskHead = this;
            $e782289d8bd71451$var$taskTail = this;
        }
        this._call = callback;
        this._time = time;
        $e782289d8bd71451$var$sleep();
    },
    stop: function() {
        if (this._call) {
            this._call = null;
            this._time = Infinity;
            $e782289d8bd71451$var$sleep();
        }
    }
};
function $e782289d8bd71451$export$9dc4ecf953986f04(callback, delay, time) {
    var t = new $e782289d8bd71451$export$c57e9b2d8b9e4de;
    t.restart(callback, delay, time);
    return t;
}
function $e782289d8bd71451$export$d60154c1d7f3990e() {
    $e782289d8bd71451$export$461939dd4422153(); // Get the current time, if not already set.
    ++$e782289d8bd71451$var$frame; // Pretend we’ve set an alarm, if we haven’t already.
    var t = $e782289d8bd71451$var$taskHead, e;
    while(t){
        if ((e = $e782289d8bd71451$var$clockNow - t._time) >= 0) t._call.call(undefined, e);
        t = t._next;
    }
    --$e782289d8bd71451$var$frame;
}
function $e782289d8bd71451$var$wake() {
    $e782289d8bd71451$var$clockNow = ($e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now()) + $e782289d8bd71451$var$clockSkew;
    $e782289d8bd71451$var$frame = $e782289d8bd71451$var$timeout = 0;
    try {
        $e782289d8bd71451$export$d60154c1d7f3990e();
    } finally{
        $e782289d8bd71451$var$frame = 0;
        $e782289d8bd71451$var$nap();
        $e782289d8bd71451$var$clockNow = 0;
    }
}
function $e782289d8bd71451$var$poke() {
    var now = $e782289d8bd71451$var$clock.now(), delay = now - $e782289d8bd71451$var$clockLast;
    if (delay > $e782289d8bd71451$var$pokeDelay) $e782289d8bd71451$var$clockSkew -= delay, $e782289d8bd71451$var$clockLast = now;
}
function $e782289d8bd71451$var$nap() {
    var t0, t1 = $e782289d8bd71451$var$taskHead, t2, time = Infinity;
    while(t1)if (t1._call) {
        if (time > t1._time) time = t1._time;
        t0 = t1, t1 = t1._next;
    } else {
        t2 = t1._next, t1._next = null;
        t1 = t0 ? t0._next = t2 : $e782289d8bd71451$var$taskHead = t2;
    }
    $e782289d8bd71451$var$taskTail = t0;
    $e782289d8bd71451$var$sleep(time);
}
function $e782289d8bd71451$var$sleep(time) {
    if ($e782289d8bd71451$var$frame) return; // Soonest alarm already set, or will be.
    if ($e782289d8bd71451$var$timeout) $e782289d8bd71451$var$timeout = clearTimeout($e782289d8bd71451$var$timeout);
    var delay = time - $e782289d8bd71451$var$clockNow; // Strictly less than if we recomputed clockNow.
    if (delay > 24) {
        if (time < Infinity) $e782289d8bd71451$var$timeout = setTimeout($e782289d8bd71451$var$wake, time - $e782289d8bd71451$var$clock.now() - $e782289d8bd71451$var$clockSkew);
        if ($e782289d8bd71451$var$interval) $e782289d8bd71451$var$interval = clearInterval($e782289d8bd71451$var$interval);
    } else {
        if (!$e782289d8bd71451$var$interval) $e782289d8bd71451$var$clockLast = $e782289d8bd71451$var$clock.now(), $e782289d8bd71451$var$interval = setInterval($e782289d8bd71451$var$poke, $e782289d8bd71451$var$pokeDelay);
        $e782289d8bd71451$var$frame = 1, $e782289d8bd71451$var$setFrame($e782289d8bd71451$var$wake);
    }
}

});

parcelRegister("3CV51", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a41329dd990bdd6$export$2e2bcd8739ae039);
// https://en.wikipedia.org/wiki/Linear_congruential_generator#Parameters_in_common_use
const $2a41329dd990bdd6$var$a = 1664525;
const $2a41329dd990bdd6$var$c = 1013904223;
const $2a41329dd990bdd6$var$m = 4294967296; // 2^32
function $2a41329dd990bdd6$export$2e2bcd8739ae039() {
    let s = 1;
    return ()=>(s = ($2a41329dd990bdd6$var$a * s + $2a41329dd990bdd6$var$c) % $2a41329dd990bdd6$var$m) / $2a41329dd990bdd6$var$m;
}

});



parcelRegister("9yZF1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f671e8f12d94cfe$export$2e2bcd8739ae039);

var $fcgQ0 = parcelRequire("fcgQ0");
function $6f671e8f12d94cfe$export$2e2bcd8739ae039(radius, x, y) {
    var nodes, strength = (0, $fcgQ0.default)(0.1), strengths, radiuses;
    if (typeof radius !== "function") radius = (0, $fcgQ0.default)(+radius);
    if (x == null) x = 0;
    if (y == null) y = 0;
    function force(alpha) {
        for(var i = 0, n = nodes.length; i < n; ++i){
            var node = nodes[i], dx = node.x - x || 1e-6, dy = node.y - y || 1e-6, r = Math.sqrt(dx * dx + dy * dy), k = (radiuses[i] - r) * strengths[i] * alpha / r;
            node.vx += dx * k;
            node.vy += dy * k;
        }
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        radiuses = new Array(n);
        for(i = 0; i < n; ++i){
            radiuses[i] = +radius(nodes[i], i, nodes);
            strengths[i] = isNaN(radiuses[i]) ? 0 : +strength(nodes[i], i, nodes);
        }
    }
    force.initialize = function(_) {
        nodes = _, initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initialize(), force) : strength;
    };
    force.radius = function(_) {
        return arguments.length ? (radius = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initialize(), force) : radius;
    };
    force.x = function(_) {
        return arguments.length ? (x = +_, force) : x;
    };
    force.y = function(_) {
        return arguments.length ? (y = +_, force) : y;
    };
    return force;
}

});

parcelRegister("cQlPV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0269baf63e02b6fc$export$2e2bcd8739ae039);

var $fcgQ0 = parcelRequire("fcgQ0");
function $0269baf63e02b6fc$export$2e2bcd8739ae039(x) {
    var strength = (0, $fcgQ0.default)(0.1), nodes, strengths, xz;
    if (typeof x !== "function") x = (0, $fcgQ0.default)(x == null ? 0 : +x);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vx += (xz[i] - node.x) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        xz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(xz[i] = +x(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initialize(), force) : strength;
    };
    force.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initialize(), force) : x;
    };
    return force;
}

});

parcelRegister("etPOH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8abf7da4ed52888$export$2e2bcd8739ae039);

var $fcgQ0 = parcelRequire("fcgQ0");
function $a8abf7da4ed52888$export$2e2bcd8739ae039(y) {
    var strength = (0, $fcgQ0.default)(0.1), nodes, strengths, yz;
    if (typeof y !== "function") y = (0, $fcgQ0.default)(y == null ? 0 : +y);
    function force(alpha) {
        for(var i = 0, n = nodes.length, node; i < n; ++i)node = nodes[i], node.vy += (yz[i] - node.y) * strengths[i] * alpha;
    }
    function initialize() {
        if (!nodes) return;
        var i, n = nodes.length;
        strengths = new Array(n);
        yz = new Array(n);
        for(i = 0; i < n; ++i)strengths[i] = isNaN(yz[i] = +y(nodes[i], i, nodes)) ? 0 : +strength(nodes[i], i, nodes);
    }
    force.initialize = function(_) {
        nodes = _;
        initialize();
    };
    force.strength = function(_) {
        return arguments.length ? (strength = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initialize(), force) : strength;
    };
    force.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $fcgQ0.default)(+_), initialize(), force) : y;
    };
    return force;
}

});


parcelRegister("iMTgF", function(module, exports) {

$parcel$export(module.exports, "DagreLayout", () => $dad794b4ff10e1fe$export$248f0a26949d24d9);

var $7WQrb = parcelRequire("7WQrb");

var $ky7aH = parcelRequire("ky7aH");
var $jyI49 = parcelRequire("jyI49");

var $261Fc = parcelRequire("261Fc");

var $lKWgx = parcelRequire("lKWgx");
class $dad794b4ff10e1fe$export$248f0a26949d24d9 {
    constructor(options){
        this.id = 'dagre';
        this.options = {};
        Object.assign(this.options, $dad794b4ff10e1fe$export$248f0a26949d24d9.defaultOptions, options);
    }
    execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericDagreLayout(false, graph, Object.assign(Object.assign({}, this.options), options));
        });
    }
    assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericDagreLayout(true, graph, Object.assign(Object.assign({}, this.options), options));
        });
    }
    genericDagreLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const { nodeSize: nodeSize } = options;
            const g = new (0, $261Fc.graphlib).Graph();
            g.setGraph(options);
            g.setDefaultEdgeLabel(()=>({}));
            const nodes = graph.getAllNodes();
            const edges = graph.getAllEdges();
            if ([
                ...nodes,
                ...edges
            ].some(({ id: id })=>(0, $jyI49.default)(id))) console.error('Dagre layout only support string id, it will convert number to string.');
            graph.getAllNodes().forEach((node)=>{
                const { id: id } = node;
                const data = Object.assign({}, node.data);
                if (nodeSize !== undefined) {
                    const [width, height] = (0, $lKWgx.parseSize)((0, $ky7aH.default)(nodeSize) ? nodeSize(node) : nodeSize);
                    Object.assign(data, {
                        width: width,
                        height: height
                    });
                }
                g.setNode(id.toString(), data);
            });
            graph.getAllEdges().forEach(({ id: id, source: source, target: target })=>{
                g.setEdge(source.toString(), target.toString(), {
                    id: id
                });
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($261Fc))).layout(g);
            const mapping = {
                nodes: [],
                edges: []
            };
            g.nodes().forEach((id)=>{
                const data = g.node(id);
                mapping.nodes.push({
                    id: id,
                    data: data
                });
                if (assign) graph.mergeNodeData(id, data);
            });
            g.edges().forEach((edge)=>{
                const _a = g.edge(edge), { id: id } = _a, data = (0, $7WQrb.__rest)(_a, [
                    "id"
                ]);
                const { v: source, w: target } = edge;
                mapping.edges.push({
                    id: id,
                    source: source,
                    target: target,
                    data: data
                });
                if (assign) graph.mergeEdgeData(id, data);
            });
            return mapping;
        });
    }
}
$dad794b4ff10e1fe$export$248f0a26949d24d9.defaultOptions = {};

});
parcelRegister("261Fc", function(module, exports) {
/*
Copyright (c) 2012-2014 Chris Pettitt

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/ 





module.exports = {
    graphlib: (parcelRequire("6mwJ2")),
    layout: (parcelRequire("VZEn7")),
    debug: (parcelRequire("8XBdx")),
    util: {
        time: (parcelRequire("1kMKg")).time,
        notime: (parcelRequire("1kMKg")).notime
    },
    version: (parcelRequire("9Grre"))
};

});
parcelRegister("6mwJ2", function(module, exports) {
/* global window */ var $4a1e2ebf410e6993$var$graphlib;

try {
    $4a1e2ebf410e6993$var$graphlib = (parcelRequire("2B9Zv"));
} catch (e) {
// continue regardless of error
}
if (!$4a1e2ebf410e6993$var$graphlib) $4a1e2ebf410e6993$var$graphlib = window.graphlib;
module.exports = $4a1e2ebf410e6993$var$graphlib;

});
parcelRegister("2B9Zv", function(module, exports) {
/**
 * Copyright (c) 2014, Chris Pettitt
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of the copyright holder nor the names of its contributors
 * may be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
 * FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
 * DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
 * CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
 * OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */ 
var $5j6So = parcelRequire("5j6So");


module.exports = {
    Graph: $5j6So.Graph,
    json: (parcelRequire("cOdIh")),
    alg: (parcelRequire("jm1Oa")),
    version: $5j6So.version
};

});
parcelRegister("5j6So", function(module, exports) {
// Includes only the "core" of graphlib


module.exports = {
    Graph: (parcelRequire("4JZcb")),
    version: (parcelRequire("5LcVV"))
};

});
parcelRegister("4JZcb", function(module, exports) {
"use strict";

var $dOCPl = parcelRequire("dOCPl");
module.exports = $373ad590b7c1733e$var$Graph;
var $373ad590b7c1733e$var$DEFAULT_EDGE_NAME = "\x00";
var $373ad590b7c1733e$var$GRAPH_NODE = "\x00";
var $373ad590b7c1733e$var$EDGE_KEY_DELIM = "\x01";
// Implementation notes:
//
//  * Node id query functions should return string ids for the nodes
//  * Edge id query functions should return an "edgeObj", edge object, that is
//    composed of enough information to uniquely identify an edge: {v, w, name}.
//  * Internally we use an "edgeId", a stringified form of the edgeObj, to
//    reference edges. This is because we need a performant way to look these
//    edges up and, object properties, which have string keys, are the closest
//    we're going to get to a performant hashtable in JavaScript.
function $373ad590b7c1733e$var$Graph(opts) {
    this._isDirected = $dOCPl.has(opts, "directed") ? opts.directed : true;
    this._isMultigraph = $dOCPl.has(opts, "multigraph") ? opts.multigraph : false;
    this._isCompound = $dOCPl.has(opts, "compound") ? opts.compound : false;
    // Label for the graph itself
    this._label = undefined;
    // Defaults to be set when creating a new node
    this._defaultNodeLabelFn = $dOCPl.constant(undefined);
    // Defaults to be set when creating a new edge
    this._defaultEdgeLabelFn = $dOCPl.constant(undefined);
    // v -> label
    this._nodes = {};
    if (this._isCompound) {
        // v -> parent
        this._parent = {};
        // v -> children
        this._children = {};
        this._children[$373ad590b7c1733e$var$GRAPH_NODE] = {};
    }
    // v -> edgeObj
    this._in = {};
    // u -> v -> Number
    this._preds = {};
    // v -> edgeObj
    this._out = {};
    // v -> w -> Number
    this._sucs = {};
    // e -> edgeObj
    this._edgeObjs = {};
    // e -> label
    this._edgeLabels = {};
}
/* Number of nodes in the graph. Should only be changed by the implementation. */ $373ad590b7c1733e$var$Graph.prototype._nodeCount = 0;
/* Number of edges in the graph. Should only be changed by the implementation. */ $373ad590b7c1733e$var$Graph.prototype._edgeCount = 0;
/* === Graph functions ========= */ $373ad590b7c1733e$var$Graph.prototype.isDirected = function() {
    return this._isDirected;
};
$373ad590b7c1733e$var$Graph.prototype.isMultigraph = function() {
    return this._isMultigraph;
};
$373ad590b7c1733e$var$Graph.prototype.isCompound = function() {
    return this._isCompound;
};
$373ad590b7c1733e$var$Graph.prototype.setGraph = function(label) {
    this._label = label;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.graph = function() {
    return this._label;
};
/* === Node functions ========== */ $373ad590b7c1733e$var$Graph.prototype.setDefaultNodeLabel = function(newDefault) {
    if (!$dOCPl.isFunction(newDefault)) newDefault = $dOCPl.constant(newDefault);
    this._defaultNodeLabelFn = newDefault;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.nodeCount = function() {
    return this._nodeCount;
};
$373ad590b7c1733e$var$Graph.prototype.nodes = function() {
    return $dOCPl.keys(this._nodes);
};
$373ad590b7c1733e$var$Graph.prototype.sources = function() {
    var self = this;
    return $dOCPl.filter(this.nodes(), function(v) {
        return $dOCPl.isEmpty(self._in[v]);
    });
};
$373ad590b7c1733e$var$Graph.prototype.sinks = function() {
    var self = this;
    return $dOCPl.filter(this.nodes(), function(v) {
        return $dOCPl.isEmpty(self._out[v]);
    });
};
$373ad590b7c1733e$var$Graph.prototype.setNodes = function(vs, value) {
    var args = arguments;
    var self = this;
    $dOCPl.each(vs, function(v) {
        if (args.length > 1) self.setNode(v, value);
        else self.setNode(v);
    });
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.setNode = function(v, value) {
    if ($dOCPl.has(this._nodes, v)) {
        if (arguments.length > 1) this._nodes[v] = value;
        return this;
    }
    this._nodes[v] = arguments.length > 1 ? value : this._defaultNodeLabelFn(v);
    if (this._isCompound) {
        this._parent[v] = $373ad590b7c1733e$var$GRAPH_NODE;
        this._children[v] = {};
        this._children[$373ad590b7c1733e$var$GRAPH_NODE][v] = true;
    }
    this._in[v] = {};
    this._preds[v] = {};
    this._out[v] = {};
    this._sucs[v] = {};
    ++this._nodeCount;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.node = function(v) {
    return this._nodes[v];
};
$373ad590b7c1733e$var$Graph.prototype.hasNode = function(v) {
    return $dOCPl.has(this._nodes, v);
};
$373ad590b7c1733e$var$Graph.prototype.removeNode = function(v) {
    var self = this;
    if ($dOCPl.has(this._nodes, v)) {
        var removeEdge = function(e) {
            self.removeEdge(self._edgeObjs[e]);
        };
        delete this._nodes[v];
        if (this._isCompound) {
            this._removeFromParentsChildList(v);
            delete this._parent[v];
            $dOCPl.each(this.children(v), function(child) {
                self.setParent(child);
            });
            delete this._children[v];
        }
        $dOCPl.each($dOCPl.keys(this._in[v]), removeEdge);
        delete this._in[v];
        delete this._preds[v];
        $dOCPl.each($dOCPl.keys(this._out[v]), removeEdge);
        delete this._out[v];
        delete this._sucs[v];
        --this._nodeCount;
    }
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.setParent = function(v, parent) {
    if (!this._isCompound) throw new Error("Cannot set parent in a non-compound graph");
    if ($dOCPl.isUndefined(parent)) parent = $373ad590b7c1733e$var$GRAPH_NODE;
    else {
        // Coerce parent to string
        parent += "";
        for(var ancestor = parent; !$dOCPl.isUndefined(ancestor); ancestor = this.parent(ancestor)){
            if (ancestor === v) throw new Error("Setting " + parent + " as parent of " + v + " would create a cycle");
        }
        this.setNode(parent);
    }
    this.setNode(v);
    this._removeFromParentsChildList(v);
    this._parent[v] = parent;
    this._children[parent][v] = true;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype._removeFromParentsChildList = function(v) {
    delete this._children[this._parent[v]][v];
};
$373ad590b7c1733e$var$Graph.prototype.parent = function(v) {
    if (this._isCompound) {
        var parent = this._parent[v];
        if (parent !== $373ad590b7c1733e$var$GRAPH_NODE) return parent;
    }
};
$373ad590b7c1733e$var$Graph.prototype.children = function(v) {
    if ($dOCPl.isUndefined(v)) v = $373ad590b7c1733e$var$GRAPH_NODE;
    if (this._isCompound) {
        var children = this._children[v];
        if (children) return $dOCPl.keys(children);
    } else if (v === $373ad590b7c1733e$var$GRAPH_NODE) return this.nodes();
    else if (this.hasNode(v)) return [];
};
$373ad590b7c1733e$var$Graph.prototype.predecessors = function(v) {
    var predsV = this._preds[v];
    if (predsV) return $dOCPl.keys(predsV);
};
$373ad590b7c1733e$var$Graph.prototype.successors = function(v) {
    var sucsV = this._sucs[v];
    if (sucsV) return $dOCPl.keys(sucsV);
};
$373ad590b7c1733e$var$Graph.prototype.neighbors = function(v) {
    var preds = this.predecessors(v);
    if (preds) return $dOCPl.union(preds, this.successors(v));
};
$373ad590b7c1733e$var$Graph.prototype.isLeaf = function(v) {
    var neighbors;
    if (this.isDirected()) neighbors = this.successors(v);
    else neighbors = this.neighbors(v);
    return neighbors.length === 0;
};
$373ad590b7c1733e$var$Graph.prototype.filterNodes = function(filter) {
    var copy = new this.constructor({
        directed: this._isDirected,
        multigraph: this._isMultigraph,
        compound: this._isCompound
    });
    copy.setGraph(this.graph());
    var self = this;
    $dOCPl.each(this._nodes, function(value, v) {
        if (filter(v)) copy.setNode(v, value);
    });
    $dOCPl.each(this._edgeObjs, function(e) {
        if (copy.hasNode(e.v) && copy.hasNode(e.w)) copy.setEdge(e, self.edge(e));
    });
    var parents = {};
    function findParent(v) {
        var parent = self.parent(v);
        if (parent === undefined || copy.hasNode(parent)) {
            parents[v] = parent;
            return parent;
        } else if (parent in parents) return parents[parent];
        else return findParent(parent);
    }
    if (this._isCompound) $dOCPl.each(copy.nodes(), function(v) {
        copy.setParent(v, findParent(v));
    });
    return copy;
};
/* === Edge functions ========== */ $373ad590b7c1733e$var$Graph.prototype.setDefaultEdgeLabel = function(newDefault) {
    if (!$dOCPl.isFunction(newDefault)) newDefault = $dOCPl.constant(newDefault);
    this._defaultEdgeLabelFn = newDefault;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.edgeCount = function() {
    return this._edgeCount;
};
$373ad590b7c1733e$var$Graph.prototype.edges = function() {
    return $dOCPl.values(this._edgeObjs);
};
$373ad590b7c1733e$var$Graph.prototype.setPath = function(vs, value) {
    var self = this;
    var args = arguments;
    $dOCPl.reduce(vs, function(v, w) {
        if (args.length > 1) self.setEdge(v, w, value);
        else self.setEdge(v, w);
        return w;
    });
    return this;
};
/*
 * setEdge(v, w, [value, [name]])
 * setEdge({ v, w, [name] }, [value])
 */ $373ad590b7c1733e$var$Graph.prototype.setEdge = function() {
    var v, w, name, value;
    var valueSpecified = false;
    var arg0 = arguments[0];
    if (typeof arg0 === "object" && arg0 !== null && "v" in arg0) {
        v = arg0.v;
        w = arg0.w;
        name = arg0.name;
        if (arguments.length === 2) {
            value = arguments[1];
            valueSpecified = true;
        }
    } else {
        v = arg0;
        w = arguments[1];
        name = arguments[3];
        if (arguments.length > 2) {
            value = arguments[2];
            valueSpecified = true;
        }
    }
    v = "" + v;
    w = "" + w;
    if (!$dOCPl.isUndefined(name)) name = "" + name;
    var e = $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    if ($dOCPl.has(this._edgeLabels, e)) {
        if (valueSpecified) this._edgeLabels[e] = value;
        return this;
    }
    if (!$dOCPl.isUndefined(name) && !this._isMultigraph) throw new Error("Cannot set a named edge when isMultigraph = false");
    // It didn't exist, so we need to create it.
    // First ensure the nodes exist.
    this.setNode(v);
    this.setNode(w);
    this._edgeLabels[e] = valueSpecified ? value : this._defaultEdgeLabelFn(v, w, name);
    var edgeObj = $373ad590b7c1733e$var$edgeArgsToObj(this._isDirected, v, w, name);
    // Ensure we add undirected edges in a consistent way.
    v = edgeObj.v;
    w = edgeObj.w;
    Object.freeze(edgeObj);
    this._edgeObjs[e] = edgeObj;
    $373ad590b7c1733e$var$incrementOrInitEntry(this._preds[w], v);
    $373ad590b7c1733e$var$incrementOrInitEntry(this._sucs[v], w);
    this._in[w][e] = edgeObj;
    this._out[v][e] = edgeObj;
    this._edgeCount++;
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.edge = function(v, w, name) {
    var e = arguments.length === 1 ? $373ad590b7c1733e$var$edgeObjToId(this._isDirected, arguments[0]) : $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    return this._edgeLabels[e];
};
$373ad590b7c1733e$var$Graph.prototype.hasEdge = function(v, w, name) {
    var e = arguments.length === 1 ? $373ad590b7c1733e$var$edgeObjToId(this._isDirected, arguments[0]) : $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    return $dOCPl.has(this._edgeLabels, e);
};
$373ad590b7c1733e$var$Graph.prototype.removeEdge = function(v, w, name) {
    var e = arguments.length === 1 ? $373ad590b7c1733e$var$edgeObjToId(this._isDirected, arguments[0]) : $373ad590b7c1733e$var$edgeArgsToId(this._isDirected, v, w, name);
    var edge = this._edgeObjs[e];
    if (edge) {
        v = edge.v;
        w = edge.w;
        delete this._edgeLabels[e];
        delete this._edgeObjs[e];
        $373ad590b7c1733e$var$decrementOrRemoveEntry(this._preds[w], v);
        $373ad590b7c1733e$var$decrementOrRemoveEntry(this._sucs[v], w);
        delete this._in[w][e];
        delete this._out[v][e];
        this._edgeCount--;
    }
    return this;
};
$373ad590b7c1733e$var$Graph.prototype.inEdges = function(v, u) {
    var inV = this._in[v];
    if (inV) {
        var edges = $dOCPl.values(inV);
        if (!u) return edges;
        return $dOCPl.filter(edges, function(edge) {
            return edge.v === u;
        });
    }
};
$373ad590b7c1733e$var$Graph.prototype.outEdges = function(v, w) {
    var outV = this._out[v];
    if (outV) {
        var edges = $dOCPl.values(outV);
        if (!w) return edges;
        return $dOCPl.filter(edges, function(edge) {
            return edge.w === w;
        });
    }
};
$373ad590b7c1733e$var$Graph.prototype.nodeEdges = function(v, w) {
    var inEdges = this.inEdges(v, w);
    if (inEdges) return inEdges.concat(this.outEdges(v, w));
};
function $373ad590b7c1733e$var$incrementOrInitEntry(map, k) {
    if (map[k]) map[k]++;
    else map[k] = 1;
}
function $373ad590b7c1733e$var$decrementOrRemoveEntry(map, k) {
    if (!--map[k]) delete map[k];
}
function $373ad590b7c1733e$var$edgeArgsToId(isDirected, v_, w_, name) {
    var v = "" + v_;
    var w = "" + w_;
    if (!isDirected && v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    return v + $373ad590b7c1733e$var$EDGE_KEY_DELIM + w + $373ad590b7c1733e$var$EDGE_KEY_DELIM + ($dOCPl.isUndefined(name) ? $373ad590b7c1733e$var$DEFAULT_EDGE_NAME : name);
}
function $373ad590b7c1733e$var$edgeArgsToObj(isDirected, v_, w_, name) {
    var v = "" + v_;
    var w = "" + w_;
    if (!isDirected && v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    var edgeObj = {
        v: v,
        w: w
    };
    if (name) edgeObj.name = name;
    return edgeObj;
}
function $373ad590b7c1733e$var$edgeObjToId(isDirected, edgeObj) {
    return $373ad590b7c1733e$var$edgeArgsToId(isDirected, edgeObj.v, edgeObj.w, edgeObj.name);
}

});
parcelRegister("dOCPl", function(module, exports) {
/* global window */ var $a0ee10204aed0d3b$var$lodash;
















try {
    $a0ee10204aed0d3b$var$lodash = {
        clone: (parcelRequire("bTYY2")),
        constant: (parcelRequire("9HRmE")),
        each: (parcelRequire("5kE3T")),
        filter: (parcelRequire("jLJR7")),
        has: (parcelRequire("jplJt")),
        isArray: (parcelRequire("o8HxT")),
        isEmpty: (parcelRequire("44Pmt")),
        isFunction: (parcelRequire("01ubZ")),
        isUndefined: (parcelRequire("enrJD")),
        keys: (parcelRequire("LAMcS")),
        map: (parcelRequire("437iZ")),
        reduce: (parcelRequire("2KuAh")),
        size: (parcelRequire("2RKXE")),
        transform: (parcelRequire("bGcIb")),
        union: (parcelRequire("1c10x")),
        values: (parcelRequire("7D6Gq"))
    };
} catch (e) {
// continue regardless of error
}
if (!$a0ee10204aed0d3b$var$lodash) $a0ee10204aed0d3b$var$lodash = window._;
module.exports = $a0ee10204aed0d3b$var$lodash;

});
parcelRegister("bTYY2", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $8aa41f9fe04bb5cc$var$clone(value) {
    return $kqX4j(value, $8aa41f9fe04bb5cc$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $8aa41f9fe04bb5cc$var$clone;

});
parcelRegister("kqX4j", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $bFZGr = parcelRequire("bFZGr");

var $5i71d = parcelRequire("5i71d");

var $XXQDs = parcelRequire("XXQDs");

var $1djPb = parcelRequire("1djPb");

var $uQ1Em = parcelRequire("uQ1Em");

var $aA0pv = parcelRequire("aA0pv");

var $hIxJe = parcelRequire("hIxJe");

var $7n7lE = parcelRequire("7n7lE");

var $apVCl = parcelRequire("apVCl");

var $i0kKc = parcelRequire("i0kKc");

var $67A6V = parcelRequire("67A6V");

var $4UmGC = parcelRequire("4UmGC");

var $btuqH = parcelRequire("btuqH");

var $dFJsF = parcelRequire("dFJsF");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $eJObK = parcelRequire("eJObK");

var $lsJ54 = parcelRequire("lsJ54");

var $jZm8C = parcelRequire("jZm8C");

var $LAMcS = parcelRequire("LAMcS");

var $f4lqP = parcelRequire("f4lqP");
/** Used to compose bitmasks for cloning. */ var $ee040e257a097984$var$CLONE_DEEP_FLAG = 1, $ee040e257a097984$var$CLONE_FLAT_FLAG = 2, $ee040e257a097984$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ee040e257a097984$var$argsTag = '[object Arguments]', $ee040e257a097984$var$arrayTag = '[object Array]', $ee040e257a097984$var$boolTag = '[object Boolean]', $ee040e257a097984$var$dateTag = '[object Date]', $ee040e257a097984$var$errorTag = '[object Error]', $ee040e257a097984$var$funcTag = '[object Function]', $ee040e257a097984$var$genTag = '[object GeneratorFunction]', $ee040e257a097984$var$mapTag = '[object Map]', $ee040e257a097984$var$numberTag = '[object Number]', $ee040e257a097984$var$objectTag = '[object Object]', $ee040e257a097984$var$regexpTag = '[object RegExp]', $ee040e257a097984$var$setTag = '[object Set]', $ee040e257a097984$var$stringTag = '[object String]', $ee040e257a097984$var$symbolTag = '[object Symbol]', $ee040e257a097984$var$weakMapTag = '[object WeakMap]';
var $ee040e257a097984$var$arrayBufferTag = '[object ArrayBuffer]', $ee040e257a097984$var$dataViewTag = '[object DataView]', $ee040e257a097984$var$float32Tag = '[object Float32Array]', $ee040e257a097984$var$float64Tag = '[object Float64Array]', $ee040e257a097984$var$int8Tag = '[object Int8Array]', $ee040e257a097984$var$int16Tag = '[object Int16Array]', $ee040e257a097984$var$int32Tag = '[object Int32Array]', $ee040e257a097984$var$uint8Tag = '[object Uint8Array]', $ee040e257a097984$var$uint8ClampedTag = '[object Uint8ClampedArray]', $ee040e257a097984$var$uint16Tag = '[object Uint16Array]', $ee040e257a097984$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ee040e257a097984$var$cloneableTags = {};
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$argsTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayBufferTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dataViewTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$boolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dateTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float64Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$mapTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$numberTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$objectTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$regexpTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$setTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$stringTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$symbolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8ClampedTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint32Tag] = true;
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$errorTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$funcTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ee040e257a097984$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ee040e257a097984$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ee040e257a097984$var$CLONE_FLAT_FLAG, isFull = bitmask & $ee040e257a097984$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lsJ54(value)) return value;
    var isArr = $o8HxT(value);
    if (isArr) {
        result = $4UmGC(value);
        if (!isDeep) return $aA0pv(value, result);
    } else {
        var tag = $67A6V(value), isFunc = tag == $ee040e257a097984$var$funcTag || tag == $ee040e257a097984$var$genTag;
        if ($f504n(value)) return $uQ1Em(value, isDeep);
        if (tag == $ee040e257a097984$var$objectTag || tag == $ee040e257a097984$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $dFJsF(value);
            if (!isDeep) return isFlat ? $7n7lE(value, $1djPb(result, value)) : $hIxJe(value, $XXQDs(result, value));
        } else {
            if (!$ee040e257a097984$var$cloneableTags[tag]) return object ? value : {};
            result = $btuqH(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $g779E);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($jZm8C(value)) value.forEach(function(subValue) {
        result.add($ee040e257a097984$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eJObK(value)) value.forEach(function(subValue, key) {
        result.set(key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $i0kKc : $apVCl : isFlat ? $f4lqP : $LAMcS;
    var props = isArr ? undefined : keysFunc(value);
    $bFZGr(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5i71d(result, key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $ee040e257a097984$var$baseClone;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype['delete'] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype['delete'] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});
parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, 'Map');
module.exports = $19b02faa57603249$var$Map;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp('^' + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = '[object AsyncFunction]', $004783abbde551e4$var$funcTag = '[object Function]', $004783abbde551e4$var$genTag = '[object GeneratorFunction]', $004783abbde551e4$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});



parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype['delete'] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new $c8dKl,
        'map': new ($2cJKd || $iYOpJ),
        'string': new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype['delete'] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, 'create');
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});


parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});



parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});




parcelRegister("bFZGr", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $88035f224ff89479$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $88035f224ff89479$var$arrayEach;

});

parcelRegister("5i71d", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $6TC8i(objValue, value)) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $3da413f0b86c10df$var$assignValue;

});
parcelRegister("cWbJD", function(module, exports) {

var $4hwTc = parcelRequire("4hwTc");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && $4hwTc) $4hwTc(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = $96b401257ea00d24$var$baseAssignValue;

});
parcelRegister("4hwTc", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $6T08O(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = $31e24313ace94404$var$defineProperty;

});



parcelRegister("XXQDs", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0b43ef5c64ba7f70$var$baseAssign(object, source) {
    return object && $cYlGN(source, $LAMcS(source), object);
}
module.exports = $0b43ef5c64ba7f70$var$baseAssign;

});
parcelRegister("cYlGN", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $cWbJD = parcelRequire("cWbJD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $cWbJD(object, key, newValue);
        else $5i71d(object, key, newValue);
    }
    return object;
}
module.exports = $971be9a5edcd8d07$var$copyObject;

});

parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});

parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, 'callee') && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});
parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});

parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = '[object Arguments]', $9d076681a0e29d68$var$arrayTag = '[object Array]', $9d076681a0e29d68$var$boolTag = '[object Boolean]', $9d076681a0e29d68$var$dateTag = '[object Date]', $9d076681a0e29d68$var$errorTag = '[object Error]', $9d076681a0e29d68$var$funcTag = '[object Function]', $9d076681a0e29d68$var$mapTag = '[object Map]', $9d076681a0e29d68$var$numberTag = '[object Number]', $9d076681a0e29d68$var$objectTag = '[object Object]', $9d076681a0e29d68$var$regexpTag = '[object RegExp]', $9d076681a0e29d68$var$setTag = '[object Set]', $9d076681a0e29d68$var$stringTag = '[object String]', $9d076681a0e29d68$var$weakMapTag = '[object WeakMap]';
var $9d076681a0e29d68$var$arrayBufferTag = '[object ArrayBuffer]', $9d076681a0e29d68$var$dataViewTag = '[object DataView]', $9d076681a0e29d68$var$float32Tag = '[object Float32Array]', $9d076681a0e29d68$var$float64Tag = '[object Float64Array]', $9d076681a0e29d68$var$int8Tag = '[object Int8Array]', $9d076681a0e29d68$var$int16Tag = '[object Int16Array]', $9d076681a0e29d68$var$int32Tag = '[object Int32Array]', $9d076681a0e29d68$var$uint8Tag = '[object Uint8Array]', $9d076681a0e29d68$var$uint8ClampedTag = '[object Uint8ClampedArray]', $9d076681a0e29d68$var$uint16Tag = '[object Uint16Array]', $9d076681a0e29d68$var$uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});
parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});


parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});

parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});



parcelRegister("1djPb", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0e266213253a5976$var$baseAssignIn(object, source) {
    return object && $cYlGN(source, $f4lqP(source), object);
}
module.exports = $0e266213253a5976$var$baseAssignIn;

});
parcelRegister("f4lqP", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $4ECPT = parcelRequire("4ECPT");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $eMthh(object) ? $8C60w(object, true) : $4ECPT(object);
}
module.exports = $af87da9a76941740$var$keysIn;

});
parcelRegister("4ECPT", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $3wZFp = parcelRequire("3wZFp");

var $7w1ie = parcelRequire("7w1ie");
/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$lsJ54(object)) return $7w1ie(object);
    var isProto = $3wZFp(object), result = [];
    for(var key in object)if (!(key == 'constructor' && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $363905e043db7569$var$baseKeysIn;

});
parcelRegister("7w1ie", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $578c86548a505f7a$var$nativeKeysIn;

});




parcelRegister("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("aA0pv", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $7b3d95b0cd9dcb32$var$copyArray;

});

parcelRegister("hIxJe", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $6YcYN = parcelRequire("6YcYN");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ce60b583e6a24a63$var$copySymbols(source, object) {
    return $cYlGN(source, $6YcYN(source), object);
}
module.exports = $ce60b583e6a24a63$var$copySymbols;

});
parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});



parcelRegister("7n7lE", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $aiaLi = parcelRequire("aiaLi");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $55e06195de8b50ba$var$copySymbolsIn(source, object) {
    return $cYlGN(source, $aiaLi(source), object);
}
module.exports = $55e06195de8b50ba$var$copySymbolsIn;

});
parcelRegister("aiaLi", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $cdnOB = parcelRequire("cdnOB");

var $6YcYN = parcelRequire("6YcYN");

var $clnSu = parcelRequire("clnSu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $clnSu : function(object) {
    var result = [];
    while(object){
        $hynws(result, $6YcYN(object));
        object = $cdnOB(object);
    }
    return result;
};
module.exports = $77e3eeed2d30c6bc$var$getSymbolsIn;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});

parcelRegister("cdnOB", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $lW2Sc(Object.getPrototypeOf, Object);
module.exports = $8e492c1d7a7ea307$var$getPrototype;

});



parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});


parcelRegister("i0kKc", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $aiaLi = parcelRequire("aiaLi");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $ctgi8(object, $f4lqP, $aiaLi);
}
module.exports = $d1b85174ea17081a$var$getAllKeysIn;

});

parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = '[object Map]', $474f685f496bfe31$var$objectTag = '[object Object]', $474f685f496bfe31$var$promiseTag = '[object Promise]', $474f685f496bfe31$var$setTag = '[object Set]', $474f685f496bfe31$var$weakMapTag = '[object WeakMap]';
var $474f685f496bfe31$var$dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : '';
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, 'DataView');
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, 'Promise');
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, 'Set');
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, 'WeakMap');
module.exports = $aedce50092a1e6a6$var$WeakMap;

});


parcelRegister("4UmGC", function(module, exports) {
/** Used for built-in method references. */ var $392dfd68f4953502$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $392dfd68f4953502$var$hasOwnProperty = $392dfd68f4953502$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $392dfd68f4953502$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && $392dfd68f4953502$var$hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $392dfd68f4953502$var$initCloneArray;

});

parcelRegister("btuqH", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");

var $aKTvD = parcelRequire("aKTvD");

var $5IIrB = parcelRequire("5IIrB");

var $jxFRj = parcelRequire("jxFRj");

var $5JAGM = parcelRequire("5JAGM");
/** `Object#toString` result references. */ var $85aa01d56b12d536$var$boolTag = '[object Boolean]', $85aa01d56b12d536$var$dateTag = '[object Date]', $85aa01d56b12d536$var$mapTag = '[object Map]', $85aa01d56b12d536$var$numberTag = '[object Number]', $85aa01d56b12d536$var$regexpTag = '[object RegExp]', $85aa01d56b12d536$var$setTag = '[object Set]', $85aa01d56b12d536$var$stringTag = '[object String]', $85aa01d56b12d536$var$symbolTag = '[object Symbol]';
var $85aa01d56b12d536$var$arrayBufferTag = '[object ArrayBuffer]', $85aa01d56b12d536$var$dataViewTag = '[object DataView]', $85aa01d56b12d536$var$float32Tag = '[object Float32Array]', $85aa01d56b12d536$var$float64Tag = '[object Float64Array]', $85aa01d56b12d536$var$int8Tag = '[object Int8Array]', $85aa01d56b12d536$var$int16Tag = '[object Int16Array]', $85aa01d56b12d536$var$int32Tag = '[object Int32Array]', $85aa01d56b12d536$var$uint8Tag = '[object Uint8Array]', $85aa01d56b12d536$var$uint8ClampedTag = '[object Uint8ClampedArray]', $85aa01d56b12d536$var$uint16Tag = '[object Uint16Array]', $85aa01d56b12d536$var$uint32Tag = '[object Uint32Array]';
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $85aa01d56b12d536$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $85aa01d56b12d536$var$arrayBufferTag:
            return $jjbq1(object);
        case $85aa01d56b12d536$var$boolTag:
        case $85aa01d56b12d536$var$dateTag:
            return new Ctor(+object);
        case $85aa01d56b12d536$var$dataViewTag:
            return $aKTvD(object, isDeep);
        case $85aa01d56b12d536$var$float32Tag:
        case $85aa01d56b12d536$var$float64Tag:
        case $85aa01d56b12d536$var$int8Tag:
        case $85aa01d56b12d536$var$int16Tag:
        case $85aa01d56b12d536$var$int32Tag:
        case $85aa01d56b12d536$var$uint8Tag:
        case $85aa01d56b12d536$var$uint8ClampedTag:
        case $85aa01d56b12d536$var$uint16Tag:
        case $85aa01d56b12d536$var$uint32Tag:
            return $5JAGM(object, isDeep);
        case $85aa01d56b12d536$var$mapTag:
            return new Ctor;
        case $85aa01d56b12d536$var$numberTag:
        case $85aa01d56b12d536$var$stringTag:
            return new Ctor(object);
        case $85aa01d56b12d536$var$regexpTag:
            return $5IIrB(object);
        case $85aa01d56b12d536$var$setTag:
            return new Ctor;
        case $85aa01d56b12d536$var$symbolTag:
            return $jxFRj(object);
    }
}
module.exports = $85aa01d56b12d536$var$initCloneByTag;

});
parcelRegister("jjbq1", function(module, exports) {

var $lx3EF = parcelRequire("lx3EF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $lx3EF(result).set(new $lx3EF(arrayBuffer));
    return result;
}
module.exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});


parcelRegister("aKTvD", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7d49423a2080f7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jjbq1(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $7d49423a2080f7e8$var$cloneDataView;

});

parcelRegister("5IIrB", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $42a38980bea1ca34$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $42a38980bea1ca34$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $42a38980bea1ca34$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $42a38980bea1ca34$var$cloneRegExp;

});

parcelRegister("jxFRj", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used to convert symbols to primitives and strings. */ var $e3a191b3227aae5b$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $e3a191b3227aae5b$var$symbolValueOf = $e3a191b3227aae5b$var$symbolProto ? $e3a191b3227aae5b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e3a191b3227aae5b$var$cloneSymbol(symbol) {
    return $e3a191b3227aae5b$var$symbolValueOf ? Object($e3a191b3227aae5b$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $e3a191b3227aae5b$var$cloneSymbol;

});

parcelRegister("5JAGM", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jjbq1(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $42cd9d64f56ec214$var$cloneTypedArray;

});


parcelRegister("dFJsF", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $cdnOB = parcelRequire("cdnOB");

var $3wZFp = parcelRequire("3wZFp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == 'function' && !$3wZFp(object) ? $4XGZt($cdnOB(object)) : {};
}
module.exports = $9f425e619197b80f$var$initCloneObject;

});
parcelRegister("4XGZt", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lsJ54(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $39ce05228f203f9a$var$baseCreate;

});


parcelRegister("eJObK", function(module, exports) {

var $9ORep = parcelRequire("9ORep");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $abac330771f68232$var$nodeIsMap = $jIny1 && $jIny1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $abac330771f68232$var$isMap = $abac330771f68232$var$nodeIsMap ? $91Qdd($abac330771f68232$var$nodeIsMap) : $9ORep;
module.exports = $abac330771f68232$var$isMap;

});
parcelRegister("9ORep", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $7262133281c40437$var$mapTag = '[object Map]';
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7262133281c40437$var$baseIsMap(value) {
    return $8l89S(value) && $67A6V(value) == $7262133281c40437$var$mapTag;
}
module.exports = $7262133281c40437$var$baseIsMap;

});


parcelRegister("jZm8C", function(module, exports) {

var $eFk8g = parcelRequire("eFk8g");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $e8d4e2fa1f2b8f08$var$nodeIsSet = $jIny1 && $jIny1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e8d4e2fa1f2b8f08$var$isSet = $e8d4e2fa1f2b8f08$var$nodeIsSet ? $91Qdd($e8d4e2fa1f2b8f08$var$nodeIsSet) : $eFk8g;
module.exports = $e8d4e2fa1f2b8f08$var$isSet;

});
parcelRegister("eFk8g", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $aad482e59457493b$var$setTag = '[object Set]';
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $aad482e59457493b$var$baseIsSet(value) {
    return $8l89S(value) && $67A6V(value) == $aad482e59457493b$var$setTag;
}
module.exports = $aad482e59457493b$var$baseIsSet;

});




parcelRegister("9HRmE", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $7111863c3c692f0e$var$constant;

});

parcelRegister("5kE3T", function(module, exports) {

module.exports = (parcelRequire("iWSff"));

});
parcelRegister("iWSff", function(module, exports) {

var $bFZGr = parcelRequire("bFZGr");

var $4DjQp = parcelRequire("4DjQp");

var $4c8Zb = parcelRequire("4c8Zb");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $dcb7b8b4ed4ef64b$var$forEach(collection, iteratee) {
    var func = $o8HxT(collection) ? $bFZGr : $4DjQp;
    return func(collection, $4c8Zb(iteratee));
}
module.exports = $dcb7b8b4ed4ef64b$var$forEach;

});
parcelRegister("4DjQp", function(module, exports) {

var $4xK4A = parcelRequire("4xK4A");

var $kCOH9 = parcelRequire("kCOH9");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $kCOH9($4xK4A);
module.exports = $35fa3296f177aa01$var$baseEach;

});
parcelRegister("4xK4A", function(module, exports) {

var $dEvx9 = parcelRequire("dEvx9");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $dEvx9(object, iteratee, $LAMcS);
}
module.exports = $34edfba366a0cfa1$var$baseForOwn;

});
parcelRegister("dEvx9", function(module, exports) {

var $jTvRt = parcelRequire("jTvRt");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $jTvRt();
module.exports = $9f0778b809a8c692$var$baseFor;

});
parcelRegister("jTvRt", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $e7bbde6376f4568a$var$createBaseFor;

});



parcelRegister("kCOH9", function(module, exports) {

var $eMthh = parcelRequire("eMthh");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$eMthh(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $f03eae3721f9ace8$var$createBaseEach;

});


parcelRegister("4c8Zb", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $30df40d61e63f4ce$var$castFunction(value) {
    return typeof value == 'function' ? value : $4Nq5y;
}
module.exports = $30df40d61e63f4ce$var$castFunction;

});
parcelRegister("4Nq5y", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
module.exports = $37dff9aa04444f9c$var$identity;

});




parcelRegister("jLJR7", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $agamk = parcelRequire("agamk");

var $7MWok = parcelRequire("7MWok");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */ function $e645fa20844da7aa$var$filter(collection, predicate) {
    var func = $o8HxT(collection) ? $8H9RZ : $agamk;
    return func(collection, $7MWok(predicate, 3));
}
module.exports = $e645fa20844da7aa$var$filter;

});
parcelRegister("agamk", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");
/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $77836f185896e906$var$baseFilter(collection, predicate) {
    var result = [];
    $4DjQp(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) result.push(value);
    });
    return result;
}
module.exports = $77836f185896e906$var$baseFilter;

});

parcelRegister("7MWok", function(module, exports) {

var $jShkp = parcelRequire("jShkp");

var $in5n5 = parcelRequire("in5n5");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");

var $bAYPD = parcelRequire("bAYPD");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return $4Nq5y;
    if (typeof value == 'object') return $o8HxT(value) ? $in5n5(value[0], value[1]) : $jShkp(value);
    return $bAYPD(value);
}
module.exports = $5aba4f6d9f8304a3$var$baseIteratee;

});
parcelRegister("jShkp", function(module, exports) {

var $kgn8n = parcelRequire("kgn8n");

var $9dd8D = parcelRequire("9dd8D");

var $2IhDm = parcelRequire("2IhDm");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $9dd8D(source);
    if (matchData.length == 1 && matchData[0][2]) return $2IhDm(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $kgn8n(object, source, matchData);
    };
}
module.exports = $e780807e2b795134$var$baseMatches;

});
parcelRegister("kgn8n", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $abgWr = parcelRequire("abgWr");
/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $g779E;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $abgWr(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $ec073f38db6e7d54$var$baseIsMatch;

});
parcelRegister("abgWr", function(module, exports) {

var $7qq40 = parcelRequire("7qq40");

var $8l89S = parcelRequire("8l89S");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8l89S(value) && !$8l89S(other)) return value !== value && other !== other;
    return $7qq40(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
module.exports = $769812b29c18141e$var$baseIsEqual;

});
parcelRegister("7qq40", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $1pRE7 = parcelRequire("1pRE7");

var $g3aCZ = parcelRequire("g3aCZ");

var $eOqMj = parcelRequire("eOqMj");

var $67A6V = parcelRequire("67A6V");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $1Q21n = parcelRequire("1Q21n");
/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = '[object Arguments]', $567f2dd161ebd4f6$var$arrayTag = '[object Array]', $567f2dd161ebd4f6$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $o8HxT(object), othIsArr = $o8HxT(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $g779E);
        return objIsArr || $1Q21n(object) ? $1pRE7(object, other, bitmask, customizer, equalFunc, stack) : $g3aCZ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $g779E);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $g779E);
    return $eOqMj(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;

});
parcelRegister("1pRE7", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $eFBTL = parcelRequire("eFBTL");

var $2l8n7 = parcelRequire("2l8n7");
/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $dXA7v : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eFBTL(other, function(othValue, othIndex) {
                if (!$2l8n7(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = $1081bd3a2e361911$var$equalArrays;

});
parcelRegister("dXA7v", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");

var $j1Tfx = parcelRequire("j1Tfx");

var $8NkYQ = parcelRequire("8NkYQ");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $j1Tfx;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $8NkYQ;
module.exports = $a29ccdc0f60e279e$var$SetCache;

});
parcelRegister("j1Tfx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $dda8f7b6b589544e$var$setCacheAdd;

});

parcelRegister("8NkYQ", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $66732c92c350622c$var$setCacheHas;

});


parcelRegister("eFBTL", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $aae24ad60cc3cfcb$var$arraySome;

});

parcelRegister("2l8n7", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1b44096ad4b9e2d5$var$cacheHas;

});


parcelRegister("g3aCZ", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $lx3EF = parcelRequire("lx3EF");

var $6TC8i = parcelRequire("6TC8i");

var $1pRE7 = parcelRequire("1pRE7");

var $cwfcG = parcelRequire("cwfcG");

var $1xAji = parcelRequire("1xAji");
/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = '[object Boolean]', $baf52b9e146f3da7$var$dateTag = '[object Date]', $baf52b9e146f3da7$var$errorTag = '[object Error]', $baf52b9e146f3da7$var$mapTag = '[object Map]', $baf52b9e146f3da7$var$numberTag = '[object Number]', $baf52b9e146f3da7$var$regexpTag = '[object RegExp]', $baf52b9e146f3da7$var$setTag = '[object Set]', $baf52b9e146f3da7$var$stringTag = '[object String]', $baf52b9e146f3da7$var$symbolTag = '[object Symbol]';
var $baf52b9e146f3da7$var$arrayBufferTag = '[object ArrayBuffer]', $baf52b9e146f3da7$var$dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $lx3EF(object), new $lx3EF(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6TC8i(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $cwfcG;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1xAji);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1pRE7(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $baf52b9e146f3da7$var$equalByTag;

});
parcelRegister("cwfcG", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $91d4444cbb077e0c$var$mapToArray;

});

parcelRegister("1xAji", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $11f509f8f53d8c36$var$setToArray;

});


parcelRegister("eOqMj", function(module, exports) {

var $apVCl = parcelRequire("apVCl");
/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $apVCl(object), objLength = objProps.length, othProps = $apVCl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = $ac8a81cbae0357e8$var$equalObjects;

});




parcelRegister("9dd8D", function(module, exports) {

var $1n1hd = parcelRequire("1n1hd");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $LAMcS(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1n1hd(value)
        ];
    }
    return result;
}
module.exports = $6b4f84f6be7f825c$var$getMatchData;

});
parcelRegister("1n1hd", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$lsJ54(value);
}
module.exports = $0ff8edf4f90a7955$var$isStrictComparable;

});


parcelRegister("2IhDm", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $1f9d5e891556ddb9$var$matchesStrictComparable;

});


parcelRegister("in5n5", function(module, exports) {

var $abgWr = parcelRequire("abgWr");

var $i51gj = parcelRequire("i51gj");

var $2VBx6 = parcelRequire("2VBx6");

var $kPpic = parcelRequire("kPpic");

var $1n1hd = parcelRequire("1n1hd");

var $2IhDm = parcelRequire("2IhDm");

var $6DSvu = parcelRequire("6DSvu");
/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($kPpic(path) && $1n1hd(srcValue)) return $2IhDm($6DSvu(path), srcValue);
    return function(object) {
        var objValue = $i51gj(object, path);
        return objValue === undefined && objValue === srcValue ? $2VBx6(object, path) : $abgWr(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;

});
parcelRegister("i51gj", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $lJEX1(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $d299ac421c05c135$var$get;

});
parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});
parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});


parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});



parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + '';
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});




parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == 'string' || $9dr3u(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$4d60aa8c33155976$var$INFINITY ? '-0' : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});



parcelRegister("2VBx6", function(module, exports) {

var $ij33W = parcelRequire("ij33W");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $btvBm(object, path, $ij33W);
}
module.exports = $221e04e57e35dd04$var$hasIn;

});
parcelRegister("ij33W", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d53c6080f339a51f$var$baseHasIn;

});

parcelRegister("btvBm", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $4RK0h(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6DSvu(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
module.exports = $85aaea8f77d790ae$var$hasPath;

});



parcelRegister("bAYPD", function(module, exports) {

var $ielIK = parcelRequire("ielIK");

var $jfdoV = parcelRequire("jfdoV");

var $kPpic = parcelRequire("kPpic");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $kPpic(path) ? $ielIK($6DSvu(path)) : $jfdoV(path);
}
module.exports = $87123e72266aa58c$var$property;

});
parcelRegister("ielIK", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $d45a621b4548f6bb$var$baseProperty;

});

parcelRegister("jfdoV", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $lJEX1(object, path);
    };
}
module.exports = $e029d02f9dd10368$var$basePropertyDeep;

});




parcelRegister("jplJt", function(module, exports) {

var $5aSdf = parcelRequire("5aSdf");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */ function $e21135b6db383fe3$var$has(object, path) {
    return object != null && $btvBm(object, path, $5aSdf);
}
module.exports = $e21135b6db383fe3$var$has;

});
parcelRegister("5aSdf", function(module, exports) {
/** Used for built-in method references. */ var $3c47f0745c8ad323$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c47f0745c8ad323$var$hasOwnProperty = $3c47f0745c8ad323$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $3c47f0745c8ad323$var$baseHas(object, key) {
    return object != null && $3c47f0745c8ad323$var$hasOwnProperty.call(object, key);
}
module.exports = $3c47f0745c8ad323$var$baseHas;

});


parcelRegister("44Pmt", function(module, exports) {

var $jViFF = parcelRequire("jViFF");

var $67A6V = parcelRequire("67A6V");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $eMthh = parcelRequire("eMthh");

var $f504n = parcelRequire("f504n");

var $3wZFp = parcelRequire("3wZFp");

var $1Q21n = parcelRequire("1Q21n");
/** `Object#toString` result references. */ var $2f7f607262506341$var$mapTag = '[object Map]', $2f7f607262506341$var$setTag = '[object Set]';
/** Used for built-in method references. */ var $2f7f607262506341$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f7f607262506341$var$hasOwnProperty = $2f7f607262506341$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $2f7f607262506341$var$isEmpty(value) {
    if (value == null) return true;
    if ($eMthh(value) && ($o8HxT(value) || typeof value == 'string' || typeof value.splice == 'function' || $f504n(value) || $1Q21n(value) || $aJD6g(value))) return !value.length;
    var tag = $67A6V(value);
    if (tag == $2f7f607262506341$var$mapTag || tag == $2f7f607262506341$var$setTag) return !value.size;
    if ($3wZFp(value)) return !$jViFF(value).length;
    for(var key in value){
        if ($2f7f607262506341$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $2f7f607262506341$var$isEmpty;

});

parcelRegister("enrJD", function(module, exports) {
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $a778ba4a8bc65100$var$isUndefined(value) {
    return value === undefined;
}
module.exports = $a778ba4a8bc65100$var$isUndefined;

});

parcelRegister("437iZ", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $7MWok = parcelRequire("7MWok");

var $fDc61 = parcelRequire("fDc61");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $2f2d1bf022ac3e3d$var$map(collection, iteratee) {
    var func = $o8HxT(collection) ? $i46jW : $fDc61;
    return func(collection, $7MWok(iteratee, 3));
}
module.exports = $2f2d1bf022ac3e3d$var$map;

});
parcelRegister("fDc61", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");

var $eMthh = parcelRequire("eMthh");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $eMthh(collection) ? Array(collection.length) : [];
    $4DjQp(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $b613e194c1b157de$var$baseMap;

});


parcelRegister("2KuAh", function(module, exports) {

var $1FZZ3 = parcelRequire("1FZZ3");

var $4DjQp = parcelRequire("4DjQp");

var $7MWok = parcelRequire("7MWok");

var $aJqKN = parcelRequire("aJqKN");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $20079a03744bdfdb$var$reduce(collection, iteratee, accumulator) {
    var func = $o8HxT(collection) ? $1FZZ3 : $aJqKN, initAccum = arguments.length < 3;
    return func(collection, $7MWok(iteratee, 4), accumulator, initAccum, $4DjQp);
}
module.exports = $20079a03744bdfdb$var$reduce;

});
parcelRegister("1FZZ3", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $1389b3710f5da9e8$var$arrayReduce;

});

parcelRegister("aJqKN", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $7d02dc1e77542632$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $7d02dc1e77542632$var$baseReduce;

});


parcelRegister("2RKXE", function(module, exports) {

var $jViFF = parcelRequire("jViFF");

var $67A6V = parcelRequire("67A6V");

var $eMthh = parcelRequire("eMthh");

var $1SJGG = parcelRequire("1SJGG");

var $irc76 = parcelRequire("irc76");
/** `Object#toString` result references. */ var $2164f585c713957a$var$mapTag = '[object Map]', $2164f585c713957a$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $2164f585c713957a$var$size(collection) {
    if (collection == null) return 0;
    if ($eMthh(collection)) return $1SJGG(collection) ? $irc76(collection) : collection.length;
    var tag = $67A6V(collection);
    if (tag == $2164f585c713957a$var$mapTag || tag == $2164f585c713957a$var$setTag) return collection.size;
    return $jViFF(collection).length;
}
module.exports = $2164f585c713957a$var$size;

});
parcelRegister("1SJGG", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $o8HxT = parcelRequire("o8HxT");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $15ee4628980e0994$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $15ee4628980e0994$var$isString(value) {
    return typeof value == 'string' || !$o8HxT(value) && $8l89S(value) && $eq6CV(value) == $15ee4628980e0994$var$stringTag;
}
module.exports = $15ee4628980e0994$var$isString;

});

parcelRegister("irc76", function(module, exports) {

var $ijOWR = parcelRequire("ijOWR");

var $05hp8 = parcelRequire("05hp8");

var $etsxF = parcelRequire("etsxF");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $d6c4251e3abece1b$var$stringSize(string) {
    return $05hp8(string) ? $etsxF(string) : $ijOWR(string);
}
module.exports = $d6c4251e3abece1b$var$stringSize;

});
parcelRegister("ijOWR", function(module, exports) {

var $ielIK = parcelRequire("ielIK");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $d56185a2b451cebc$var$asciiSize = $ielIK('length');
module.exports = $d56185a2b451cebc$var$asciiSize;

});

parcelRegister("05hp8", function(module, exports) {
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = '\\ud800-\\udfff', $00fdf7eab00be2e7$var$rsComboMarksRange = '\\u0300-\\u036f', $00fdf7eab00be2e7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $00fdf7eab00be2e7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp('[' + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
module.exports = $00fdf7eab00be2e7$var$hasUnicode;

});

parcelRegister("etsxF", function(module, exports) {
/** Used to compose unicode character classes. */ var $a899e9fda8cd3735$var$rsAstralRange = '\\ud800-\\udfff', $a899e9fda8cd3735$var$rsComboMarksRange = '\\u0300-\\u036f', $a899e9fda8cd3735$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $a899e9fda8cd3735$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $a899e9fda8cd3735$var$rsComboRange = $a899e9fda8cd3735$var$rsComboMarksRange + $a899e9fda8cd3735$var$reComboHalfMarksRange + $a899e9fda8cd3735$var$rsComboSymbolsRange, $a899e9fda8cd3735$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $a899e9fda8cd3735$var$rsAstral = '[' + $a899e9fda8cd3735$var$rsAstralRange + ']', $a899e9fda8cd3735$var$rsCombo = '[' + $a899e9fda8cd3735$var$rsComboRange + ']', $a899e9fda8cd3735$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $a899e9fda8cd3735$var$rsModifier = '(?:' + $a899e9fda8cd3735$var$rsCombo + '|' + $a899e9fda8cd3735$var$rsFitz + ')', $a899e9fda8cd3735$var$rsNonAstral = '[^' + $a899e9fda8cd3735$var$rsAstralRange + ']', $a899e9fda8cd3735$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $a899e9fda8cd3735$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $a899e9fda8cd3735$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $a899e9fda8cd3735$var$reOptMod = $a899e9fda8cd3735$var$rsModifier + '?', $a899e9fda8cd3735$var$rsOptVar = '[' + $a899e9fda8cd3735$var$rsVarRange + ']?', $a899e9fda8cd3735$var$rsOptJoin = '(?:' + $a899e9fda8cd3735$var$rsZWJ + '(?:' + [
    $a899e9fda8cd3735$var$rsNonAstral,
    $a899e9fda8cd3735$var$rsRegional,
    $a899e9fda8cd3735$var$rsSurrPair
].join('|') + ')' + $a899e9fda8cd3735$var$rsOptVar + $a899e9fda8cd3735$var$reOptMod + ')*', $a899e9fda8cd3735$var$rsSeq = $a899e9fda8cd3735$var$rsOptVar + $a899e9fda8cd3735$var$reOptMod + $a899e9fda8cd3735$var$rsOptJoin, $a899e9fda8cd3735$var$rsSymbol = '(?:' + [
    $a899e9fda8cd3735$var$rsNonAstral + $a899e9fda8cd3735$var$rsCombo + '?',
    $a899e9fda8cd3735$var$rsCombo,
    $a899e9fda8cd3735$var$rsRegional,
    $a899e9fda8cd3735$var$rsSurrPair,
    $a899e9fda8cd3735$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $a899e9fda8cd3735$var$reUnicode = RegExp($a899e9fda8cd3735$var$rsFitz + '(?=' + $a899e9fda8cd3735$var$rsFitz + ')|' + $a899e9fda8cd3735$var$rsSymbol + $a899e9fda8cd3735$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $a899e9fda8cd3735$var$unicodeSize(string) {
    var result = $a899e9fda8cd3735$var$reUnicode.lastIndex = 0;
    while($a899e9fda8cd3735$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $a899e9fda8cd3735$var$unicodeSize;

});



parcelRegister("bGcIb", function(module, exports) {

var $bFZGr = parcelRequire("bFZGr");

var $4XGZt = parcelRequire("4XGZt");

var $4xK4A = parcelRequire("4xK4A");

var $7MWok = parcelRequire("7MWok");

var $cdnOB = parcelRequire("cdnOB");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $1Q21n = parcelRequire("1Q21n");
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function $880d7a3d41bd08eb$var$transform(object, iteratee, accumulator) {
    var isArr = $o8HxT(object), isArrLike = isArr || $f504n(object) || $1Q21n(object);
    iteratee = $7MWok(iteratee, 4);
    if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) accumulator = isArr ? new Ctor : [];
        else if ($lsJ54(object)) accumulator = $01ubZ(Ctor) ? $4XGZt($cdnOB(object)) : {};
        else accumulator = {};
    }
    (isArrLike ? $bFZGr : $4xK4A)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
module.exports = $880d7a3d41bd08eb$var$transform;

});

parcelRegister("1c10x", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");

var $5iyRF = parcelRequire("5iyRF");

var $5VSS6 = parcelRequire("5VSS6");

var $jGP9B = parcelRequire("jGP9B");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $0de7b1862975f367$var$union = $5iyRF(function(arrays) {
    return $5VSS6($fgBHx(arrays, 1, $jGP9B, true));
});
module.exports = $0de7b1862975f367$var$union;

});
parcelRegister("fgBHx", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $hStNq = parcelRequire("hStNq");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $hStNq);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hynws(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $b1d5985487d54dea$var$baseFlatten;

});
parcelRegister("hStNq", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $57wYk ? $57wYk.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $o8HxT(value) || $aJD6g(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
module.exports = $035bd928078475ee$var$isFlattenable;

});


parcelRegister("5iyRF", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $iGMVy($b86t6(func, start, $4Nq5y), func + '');
}
module.exports = $3db9ad8fe1351fef$var$baseRest;

});
parcelRegister("b86t6", function(module, exports) {

var $jpWht = parcelRequire("jpWht");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $jpWht(func, this, otherArgs);
    };
}
module.exports = $81a5758ee0248452$var$overRest;

});
parcelRegister("jpWht", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $e22d8f7aab4ea8e2$var$apply;

});


parcelRegister("iGMVy", function(module, exports) {

var $2yzAw = parcelRequire("2yzAw");

var $7WhTB = parcelRequire("7WhTB");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $7WhTB($2yzAw);
module.exports = $d9b21a2cad7f96c2$var$setToString;

});
parcelRegister("2yzAw", function(module, exports) {

var $9HRmE = parcelRequire("9HRmE");

var $4hwTc = parcelRequire("4hwTc");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$4hwTc ? $4Nq5y : function(func, string) {
    return $4hwTc(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $9HRmE(string),
        'writable': true
    });
};
module.exports = $1dca5cc74bf5ffaf$var$baseSetToString;

});

parcelRegister("7WhTB", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $5c7bd4e931ae22e5$var$shortOut;

});



parcelRegister("5VSS6", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $ebE2M = parcelRequire("ebE2M");

var $eSdxB = parcelRequire("eSdxB");

var $2l8n7 = parcelRequire("2l8n7");

var $5sRi0 = parcelRequire("5sRi0");

var $1xAji = parcelRequire("1xAji");
/** Used as the size to enable large array optimizations. */ var $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $451cd6fc5b077ebe$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $ebE2M, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $eSdxB;
    } else if (length >= $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $5sRi0(array);
        if (set) return $1xAji(set);
        isCommon = false;
        includes = $2l8n7;
        seen = new $dXA7v;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $451cd6fc5b077ebe$var$baseUniq;

});
parcelRegister("ebE2M", function(module, exports) {

var $7pFTU = parcelRequire("7pFTU");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $7pFTU(array, value, 0) > -1;
}
module.exports = $a541279ebb64f2c9$var$arrayIncludes;

});
parcelRegister("7pFTU", function(module, exports) {

var $eAor6 = parcelRequire("eAor6");

var $h2dHy = parcelRequire("h2dHy");

var $dU1uo = parcelRequire("dU1uo");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $dU1uo(array, value, fromIndex) : $eAor6(array, $h2dHy, fromIndex);
}
module.exports = $565b5ed18efa4b9c$var$baseIndexOf;

});
parcelRegister("eAor6", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $a9e76203bd7c412f$var$baseFindIndex;

});

parcelRegister("h2dHy", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $c66d4063f81f4687$var$baseIsNaN;

});

parcelRegister("dU1uo", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $a1f1a90cd7caaefa$var$strictIndexOf;

});



parcelRegister("eSdxB", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ad409cc63f3cbe79$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $ad409cc63f3cbe79$var$arrayIncludesWith;

});

parcelRegister("5sRi0", function(module, exports) {

var $vH4x0 = parcelRequire("vH4x0");

var $9iECD = parcelRequire("9iECD");

var $1xAji = parcelRequire("1xAji");
/** Used as references for various `Number` constants. */ var $3fa8e773494800f5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3fa8e773494800f5$var$createSet = !($vH4x0 && 1 / $1xAji(new $vH4x0([
    ,
    -0
]))[1] == $3fa8e773494800f5$var$INFINITY) ? $9iECD : function(values) {
    return new $vH4x0(values);
};
module.exports = $3fa8e773494800f5$var$createSet;

});
parcelRegister("9iECD", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
module.exports = $6c554e32feae9faa$var$noop;

});



parcelRegister("jGP9B", function(module, exports) {

var $eMthh = parcelRequire("eMthh");

var $8l89S = parcelRequire("8l89S");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e5599ea424e07f76$var$isArrayLikeObject(value) {
    return $8l89S(value) && $eMthh(value);
}
module.exports = $e5599ea424e07f76$var$isArrayLikeObject;

});


parcelRegister("7D6Gq", function(module, exports) {

var $jaYdQ = parcelRequire("jaYdQ");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $58e15c1958c92f73$var$values(object) {
    return object == null ? [] : $jaYdQ(object, $LAMcS(object));
}
module.exports = $58e15c1958c92f73$var$values;

});
parcelRegister("jaYdQ", function(module, exports) {

var $i46jW = parcelRequire("i46jW");
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $df5daa5e60cd3cbe$var$baseValues(object, props) {
    return $i46jW(props, function(key) {
        return object[key];
    });
}
module.exports = $df5daa5e60cd3cbe$var$baseValues;

});




parcelRegister("5LcVV", function(module, exports) {
module.exports = '2.1.8';

});


parcelRegister("cOdIh", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $4JZcb = parcelRequire("4JZcb");
module.exports = {
    write: $9534cab8b40cf3db$var$write,
    read: $9534cab8b40cf3db$var$read
};
function $9534cab8b40cf3db$var$write(g) {
    var json = {
        options: {
            directed: g.isDirected(),
            multigraph: g.isMultigraph(),
            compound: g.isCompound()
        },
        nodes: $9534cab8b40cf3db$var$writeNodes(g),
        edges: $9534cab8b40cf3db$var$writeEdges(g)
    };
    if (!$dOCPl.isUndefined(g.graph())) json.value = $dOCPl.clone(g.graph());
    return json;
}
function $9534cab8b40cf3db$var$writeNodes(g) {
    return $dOCPl.map(g.nodes(), function(v) {
        var nodeValue = g.node(v);
        var parent = g.parent(v);
        var node = {
            v: v
        };
        if (!$dOCPl.isUndefined(nodeValue)) node.value = nodeValue;
        if (!$dOCPl.isUndefined(parent)) node.parent = parent;
        return node;
    });
}
function $9534cab8b40cf3db$var$writeEdges(g) {
    return $dOCPl.map(g.edges(), function(e) {
        var edgeValue = g.edge(e);
        var edge = {
            v: e.v,
            w: e.w
        };
        if (!$dOCPl.isUndefined(e.name)) edge.name = e.name;
        if (!$dOCPl.isUndefined(edgeValue)) edge.value = edgeValue;
        return edge;
    });
}
function $9534cab8b40cf3db$var$read(json) {
    var g = new $4JZcb(json.options).setGraph(json.value);
    $dOCPl.each(json.nodes, function(entry) {
        g.setNode(entry.v, entry.value);
        if (entry.parent) g.setParent(entry.v, entry.parent);
    });
    $dOCPl.each(json.edges, function(entry) {
        g.setEdge({
            v: entry.v,
            w: entry.w,
            name: entry.name
        }, entry.value);
    });
    return g;
}

});

parcelRegister("jm1Oa", function(module, exports) {











module.exports = {
    components: (parcelRequire("c3Kkn")),
    dijkstra: (parcelRequire("a8y4J")),
    dijkstraAll: (parcelRequire("3uso6")),
    findCycles: (parcelRequire("6pFca")),
    floydWarshall: (parcelRequire("2yn2B")),
    isAcyclic: (parcelRequire("3hBSd")),
    postorder: (parcelRequire("dX1tj")),
    preorder: (parcelRequire("e890l")),
    prim: (parcelRequire("ifTuH")),
    tarjan: (parcelRequire("38Zd5")),
    topsort: (parcelRequire("8UkLw"))
};

});
parcelRegister("c3Kkn", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $8c79b38e8bb785e6$var$components;
function $8c79b38e8bb785e6$var$components(g) {
    var visited = {};
    var cmpts = [];
    var cmpt;
    function dfs(v) {
        if ($dOCPl.has(visited, v)) return;
        visited[v] = true;
        cmpt.push(v);
        $dOCPl.each(g.successors(v), dfs);
        $dOCPl.each(g.predecessors(v), dfs);
    }
    $dOCPl.each(g.nodes(), function(v) {
        cmpt = [];
        dfs(v);
        if (cmpt.length) cmpts.push(cmpt);
    });
    return cmpts;
}

});

parcelRegister("a8y4J", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $5ZDax = parcelRequire("5ZDax");
module.exports = $7615155e1d66a6d5$var$dijkstra;
var $7615155e1d66a6d5$var$DEFAULT_WEIGHT_FUNC = $dOCPl.constant(1);
function $7615155e1d66a6d5$var$dijkstra(g, source, weightFn, edgeFn) {
    return $7615155e1d66a6d5$var$runDijkstra(g, String(source), weightFn || $7615155e1d66a6d5$var$DEFAULT_WEIGHT_FUNC, edgeFn || function(v) {
        return g.outEdges(v);
    });
}
function $7615155e1d66a6d5$var$runDijkstra(g, source, weightFn, edgeFn) {
    var results = {};
    var pq = new $5ZDax();
    var v, vEntry;
    var updateNeighbors = function(edge) {
        var w = edge.v !== v ? edge.v : edge.w;
        var wEntry = results[w];
        var weight = weightFn(edge);
        var distance = vEntry.distance + weight;
        if (weight < 0) throw new Error("dijkstra does not allow negative edge weights. Bad edge: " + edge + " Weight: " + weight);
        if (distance < wEntry.distance) {
            wEntry.distance = distance;
            wEntry.predecessor = v;
            pq.decrease(w, distance);
        }
    };
    g.nodes().forEach(function(v) {
        var distance = v === source ? 0 : Number.POSITIVE_INFINITY;
        results[v] = {
            distance: distance
        };
        pq.add(v, distance);
    });
    while(pq.size() > 0){
        v = pq.removeMin();
        vEntry = results[v];
        if (vEntry.distance === Number.POSITIVE_INFINITY) break;
        edgeFn(v).forEach(updateNeighbors);
    }
    return results;
}

});
parcelRegister("5ZDax", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $45d10863bd1362e9$var$PriorityQueue;
/**
 * A min-priority queue data structure. This algorithm is derived from Cormen,
 * et al., "Introduction to Algorithms". The basic idea of a min-priority
 * queue is that you can efficiently (in O(1) time) get the smallest key in
 * the queue. Adding and removing elements takes O(log n) time. A key can
 * have its priority decreased in O(log n) time.
 */ function $45d10863bd1362e9$var$PriorityQueue() {
    this._arr = [];
    this._keyIndices = {};
}
/**
 * Returns the number of elements in the queue. Takes `O(1)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.size = function() {
    return this._arr.length;
};
/**
 * Returns the keys that are in the queue. Takes `O(n)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.keys = function() {
    return this._arr.map(function(x) {
        return x.key;
    });
};
/**
 * Returns `true` if **key** is in the queue and `false` if not.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.has = function(key) {
    return $dOCPl.has(this._keyIndices, key);
};
/**
 * Returns the priority for **key**. If **key** is not present in the queue
 * then this function returns `undefined`. Takes `O(1)` time.
 *
 * @param {Object} key
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.priority = function(key) {
    var index = this._keyIndices[key];
    if (index !== undefined) return this._arr[index].priority;
};
/**
 * Returns the key for the minimum element in this queue. If the queue is
 * empty this function throws an Error. Takes `O(1)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.min = function() {
    if (this.size() === 0) throw new Error("Queue underflow");
    return this._arr[0].key;
};
/**
 * Inserts a new key into the priority queue. If the key already exists in
 * the queue this function returns `false`; otherwise it will return `true`.
 * Takes `O(n)` time.
 *
 * @param {Object} key the key to add
 * @param {Number} priority the initial priority for the key
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.add = function(key, priority) {
    var keyIndices = this._keyIndices;
    key = String(key);
    if (!$dOCPl.has(keyIndices, key)) {
        var arr = this._arr;
        var index = arr.length;
        keyIndices[key] = index;
        arr.push({
            key: key,
            priority: priority
        });
        this._decrease(index);
        return true;
    }
    return false;
};
/**
 * Removes and returns the smallest key in the queue. Takes `O(log n)` time.
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.removeMin = function() {
    this._swap(0, this._arr.length - 1);
    var min = this._arr.pop();
    delete this._keyIndices[min.key];
    this._heapify(0);
    return min.key;
};
/**
 * Decreases the priority for **key** to **priority**. If the new priority is
 * greater than the previous priority, this function will throw an Error.
 *
 * @param {Object} key the key for which to raise priority
 * @param {Number} priority the new priority for the key
 */ $45d10863bd1362e9$var$PriorityQueue.prototype.decrease = function(key, priority) {
    var index = this._keyIndices[key];
    if (priority > this._arr[index].priority) throw new Error("New priority is greater than current priority. Key: " + key + " Old: " + this._arr[index].priority + " New: " + priority);
    this._arr[index].priority = priority;
    this._decrease(index);
};
$45d10863bd1362e9$var$PriorityQueue.prototype._heapify = function(i) {
    var arr = this._arr;
    var l = 2 * i;
    var r = l + 1;
    var largest = i;
    if (l < arr.length) {
        largest = arr[l].priority < arr[largest].priority ? l : largest;
        if (r < arr.length) largest = arr[r].priority < arr[largest].priority ? r : largest;
        if (largest !== i) {
            this._swap(i, largest);
            this._heapify(largest);
        }
    }
};
$45d10863bd1362e9$var$PriorityQueue.prototype._decrease = function(index) {
    var arr = this._arr;
    var priority = arr[index].priority;
    var parent;
    while(index !== 0){
        parent = index >> 1;
        if (arr[parent].priority < priority) break;
        this._swap(index, parent);
        index = parent;
    }
};
$45d10863bd1362e9$var$PriorityQueue.prototype._swap = function(i, j) {
    var arr = this._arr;
    var keyIndices = this._keyIndices;
    var origArrI = arr[i];
    var origArrJ = arr[j];
    arr[i] = origArrJ;
    arr[j] = origArrI;
    keyIndices[origArrJ.key] = i;
    keyIndices[origArrI.key] = j;
};

});


parcelRegister("3uso6", function(module, exports) {

var $a8y4J = parcelRequire("a8y4J");

var $dOCPl = parcelRequire("dOCPl");
module.exports = $28aa31ab5a3c320e$var$dijkstraAll;
function $28aa31ab5a3c320e$var$dijkstraAll(g, weightFunc, edgeFunc) {
    return $dOCPl.transform(g.nodes(), function(acc, v) {
        acc[v] = $a8y4J(g, v, weightFunc, edgeFunc);
    }, {});
}

});

parcelRegister("6pFca", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $38Zd5 = parcelRequire("38Zd5");
module.exports = $4ab50861b5d77a2b$var$findCycles;
function $4ab50861b5d77a2b$var$findCycles(g) {
    return $dOCPl.filter($38Zd5(g), function(cmpt) {
        return cmpt.length > 1 || cmpt.length === 1 && g.hasEdge(cmpt[0], cmpt[0]);
    });
}

});
parcelRegister("38Zd5", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $24a1997f93a076e1$var$tarjan;
function $24a1997f93a076e1$var$tarjan(g) {
    var index = 0;
    var stack = [];
    var visited = {}; // node id -> { onStack, lowlink, index }
    var results = [];
    function dfs(v) {
        var entry = visited[v] = {
            onStack: true,
            lowlink: index,
            index: index++
        };
        stack.push(v);
        g.successors(v).forEach(function(w) {
            if (!$dOCPl.has(visited, w)) {
                dfs(w);
                entry.lowlink = Math.min(entry.lowlink, visited[w].lowlink);
            } else if (visited[w].onStack) entry.lowlink = Math.min(entry.lowlink, visited[w].index);
        });
        if (entry.lowlink === entry.index) {
            var cmpt = [];
            var w;
            do {
                w = stack.pop();
                visited[w].onStack = false;
                cmpt.push(w);
            }while (v !== w);
            results.push(cmpt);
        }
    }
    g.nodes().forEach(function(v) {
        if (!$dOCPl.has(visited, v)) dfs(v);
    });
    return results;
}

});


parcelRegister("2yn2B", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $1dc0a13696a98e60$var$floydWarshall;
var $1dc0a13696a98e60$var$DEFAULT_WEIGHT_FUNC = $dOCPl.constant(1);
function $1dc0a13696a98e60$var$floydWarshall(g, weightFn, edgeFn) {
    return $1dc0a13696a98e60$var$runFloydWarshall(g, weightFn || $1dc0a13696a98e60$var$DEFAULT_WEIGHT_FUNC, edgeFn || function(v) {
        return g.outEdges(v);
    });
}
function $1dc0a13696a98e60$var$runFloydWarshall(g, weightFn, edgeFn) {
    var results = {};
    var nodes = g.nodes();
    nodes.forEach(function(v) {
        results[v] = {};
        results[v][v] = {
            distance: 0
        };
        nodes.forEach(function(w) {
            if (v !== w) results[v][w] = {
                distance: Number.POSITIVE_INFINITY
            };
        });
        edgeFn(v).forEach(function(edge) {
            var w = edge.v === v ? edge.w : edge.v;
            var d = weightFn(edge);
            results[v][w] = {
                distance: d,
                predecessor: v
            };
        });
    });
    nodes.forEach(function(k) {
        var rowK = results[k];
        nodes.forEach(function(i) {
            var rowI = results[i];
            nodes.forEach(function(j) {
                var ik = rowI[k];
                var kj = rowK[j];
                var ij = rowI[j];
                var altDistance = ik.distance + kj.distance;
                if (altDistance < ij.distance) {
                    ij.distance = altDistance;
                    ij.predecessor = kj.predecessor;
                }
            });
        });
    });
    return results;
}

});

parcelRegister("3hBSd", function(module, exports) {

var $8UkLw = parcelRequire("8UkLw");
module.exports = $2640567c8b029db9$var$isAcyclic;
function $2640567c8b029db9$var$isAcyclic(g) {
    try {
        $8UkLw(g);
    } catch (e) {
        if (e instanceof $8UkLw.CycleException) return false;
        throw e;
    }
    return true;
}

});
parcelRegister("8UkLw", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $67c3a94e2e06a874$var$topsort;
$67c3a94e2e06a874$var$topsort.CycleException = $67c3a94e2e06a874$var$CycleException;
function $67c3a94e2e06a874$var$topsort(g) {
    var visited = {};
    var stack = {};
    var results = [];
    function visit(node) {
        if ($dOCPl.has(stack, node)) throw new $67c3a94e2e06a874$var$CycleException();
        if (!$dOCPl.has(visited, node)) {
            stack[node] = true;
            visited[node] = true;
            $dOCPl.each(g.predecessors(node), visit);
            delete stack[node];
            results.push(node);
        }
    }
    $dOCPl.each(g.sinks(), visit);
    if ($dOCPl.size(visited) !== g.nodeCount()) throw new $67c3a94e2e06a874$var$CycleException();
    return results;
}
function $67c3a94e2e06a874$var$CycleException() {}
$67c3a94e2e06a874$var$CycleException.prototype = new Error(); // must be an instance of Error to pass testing

});


parcelRegister("dX1tj", function(module, exports) {

var $aCKt6 = parcelRequire("aCKt6");
module.exports = $a281ed51bb559346$var$postorder;
function $a281ed51bb559346$var$postorder(g, vs) {
    return $aCKt6(g, vs, "post");
}

});
parcelRegister("aCKt6", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");
module.exports = $7bc17fabfc4c38ec$var$dfs;
/*
 * A helper that preforms a pre- or post-order traversal on the input graph
 * and returns the nodes in the order they were visited. If the graph is
 * undirected then this algorithm will navigate using neighbors. If the graph
 * is directed then this algorithm will navigate using successors.
 *
 * Order must be one of "pre" or "post".
 */ function $7bc17fabfc4c38ec$var$dfs(g, vs, order) {
    if (!$dOCPl.isArray(vs)) vs = [
        vs
    ];
    var navigation = (g.isDirected() ? g.successors : g.neighbors).bind(g);
    var acc = [];
    var visited = {};
    $dOCPl.each(vs, function(v) {
        if (!g.hasNode(v)) throw new Error("Graph does not have node: " + v);
        $7bc17fabfc4c38ec$var$doDfs(g, v, order === "post", visited, navigation, acc);
    });
    return acc;
}
function $7bc17fabfc4c38ec$var$doDfs(g, v, postorder, visited, navigation, acc) {
    if (!$dOCPl.has(visited, v)) {
        visited[v] = true;
        if (!postorder) acc.push(v);
        $dOCPl.each(navigation(v), function(w) {
            $7bc17fabfc4c38ec$var$doDfs(g, w, postorder, visited, navigation, acc);
        });
        if (postorder) acc.push(v);
    }
}

});


parcelRegister("e890l", function(module, exports) {

var $aCKt6 = parcelRequire("aCKt6");
module.exports = $a498cc2fcabcfc22$var$preorder;
function $a498cc2fcabcfc22$var$preorder(g, vs) {
    return $aCKt6(g, vs, "pre");
}

});

parcelRegister("ifTuH", function(module, exports) {

var $dOCPl = parcelRequire("dOCPl");

var $4JZcb = parcelRequire("4JZcb");

var $5ZDax = parcelRequire("5ZDax");
module.exports = $d4a4acb6cacbea91$var$prim;
function $d4a4acb6cacbea91$var$prim(g, weightFunc) {
    var result = new $4JZcb();
    var parents = {};
    var pq = new $5ZDax();
    var v;
    function updateNeighbors(edge) {
        var w = edge.v === v ? edge.w : edge.v;
        var pri = pq.priority(w);
        if (pri !== undefined) {
            var edgeWeight = weightFunc(edge);
            if (edgeWeight < pri) {
                parents[w] = v;
                pq.decrease(w, edgeWeight);
            }
        }
    }
    if (g.nodeCount() === 0) return result;
    $dOCPl.each(g.nodes(), function(v) {
        pq.add(v, Number.POSITIVE_INFINITY);
        result.setNode(v);
    });
    // Start from an arbitrary node
    pq.decrease(g.nodes()[0], 0);
    var init = false;
    while(pq.size() > 0){
        v = pq.removeMin();
        if ($dOCPl.has(parents, v)) result.setEdge(v, parents[v]);
        else if (init) throw new Error("Input graph is not connected: " + g);
        else init = true;
        g.nodeEdges(v).forEach(updateNeighbors);
    }
    return result;
}

});




parcelRegister("VZEn7", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $61rsw = parcelRequire("61rsw");

var $fi6eg = parcelRequire("fi6eg");

var $hv32p = parcelRequire("hv32p");

var $1kMKg = parcelRequire("1kMKg");
var $0ae5256c4a1477f2$require$normalizeRanks = $1kMKg.normalizeRanks;

var $eBG2O = parcelRequire("eBG2O");

var $1kMKg = parcelRequire("1kMKg");
var $0ae5256c4a1477f2$require$removeEmptyRanks = $1kMKg.removeEmptyRanks;

var $YdQc0 = parcelRequire("YdQc0");

var $fSZns = parcelRequire("fSZns");

var $lWVsJ = parcelRequire("lWVsJ");

var $3dyGB = parcelRequire("3dyGB");

var $j257S = parcelRequire("j257S");

var $1kMKg = parcelRequire("1kMKg");

var $6mwJ2 = parcelRequire("6mwJ2");
var $0ae5256c4a1477f2$require$Graph = $6mwJ2.Graph;
module.exports = $0ae5256c4a1477f2$var$layout;
function $0ae5256c4a1477f2$var$layout(g, opts) {
    var time = opts && opts.debugTiming ? $1kMKg.time : $1kMKg.notime;
    time("layout", function() {
        var layoutGraph = time("  buildLayoutGraph", function() {
            return $0ae5256c4a1477f2$var$buildLayoutGraph(g);
        });
        time("  runLayout", function() {
            $0ae5256c4a1477f2$var$runLayout(layoutGraph, time);
        });
        time("  updateInputGraph", function() {
            $0ae5256c4a1477f2$var$updateInputGraph(g, layoutGraph);
        });
    });
}
function $0ae5256c4a1477f2$var$runLayout(g, time) {
    time("    makeSpaceForEdgeLabels", function() {
        $0ae5256c4a1477f2$var$makeSpaceForEdgeLabels(g);
    });
    time("    removeSelfEdges", function() {
        $0ae5256c4a1477f2$var$removeSelfEdges(g);
    });
    time("    acyclic", function() {
        $61rsw.run(g);
    });
    time("    nestingGraph.run", function() {
        $YdQc0.run(g);
    });
    time("    rank", function() {
        $hv32p($1kMKg.asNonCompoundGraph(g));
    });
    time("    injectEdgeLabelProxies", function() {
        $0ae5256c4a1477f2$var$injectEdgeLabelProxies(g);
    });
    time("    removeEmptyRanks", function() {
        $0ae5256c4a1477f2$require$removeEmptyRanks(g);
    });
    time("    nestingGraph.cleanup", function() {
        $YdQc0.cleanup(g);
    });
    time("    normalizeRanks", function() {
        $0ae5256c4a1477f2$require$normalizeRanks(g);
    });
    time("    assignRankMinMax", function() {
        $0ae5256c4a1477f2$var$assignRankMinMax(g);
    });
    time("    removeEdgeLabelProxies", function() {
        $0ae5256c4a1477f2$var$removeEdgeLabelProxies(g);
    });
    time("    normalize.run", function() {
        $fi6eg.run(g);
    });
    time("    parentDummyChains", function() {
        $eBG2O(g);
    });
    time("    addBorderSegments", function() {
        $fSZns(g);
    });
    time("    order", function() {
        $3dyGB(g);
    });
    time("    insertSelfEdges", function() {
        $0ae5256c4a1477f2$var$insertSelfEdges(g);
    });
    time("    adjustCoordinateSystem", function() {
        $lWVsJ.adjust(g);
    });
    time("    position", function() {
        $j257S(g);
    });
    time("    positionSelfEdges", function() {
        $0ae5256c4a1477f2$var$positionSelfEdges(g);
    });
    time("    removeBorderNodes", function() {
        $0ae5256c4a1477f2$var$removeBorderNodes(g);
    });
    time("    normalize.undo", function() {
        $fi6eg.undo(g);
    });
    time("    fixupEdgeLabelCoords", function() {
        $0ae5256c4a1477f2$var$fixupEdgeLabelCoords(g);
    });
    time("    undoCoordinateSystem", function() {
        $lWVsJ.undo(g);
    });
    time("    translateGraph", function() {
        $0ae5256c4a1477f2$var$translateGraph(g);
    });
    time("    assignNodeIntersects", function() {
        $0ae5256c4a1477f2$var$assignNodeIntersects(g);
    });
    time("    reversePoints", function() {
        $0ae5256c4a1477f2$var$reversePointsForReversedEdges(g);
    });
    time("    acyclic.undo", function() {
        $61rsw.undo(g);
    });
}
/*
 * Copies final layout information from the layout graph back to the input
 * graph. This process only copies whitelisted attributes from the layout graph
 * to the input graph, so it serves as a good place to determine what
 * attributes can influence layout.
 */ function $0ae5256c4a1477f2$var$updateInputGraph(inputGraph, layoutGraph) {
    $bqfL5.forEach(inputGraph.nodes(), function(v) {
        var inputLabel = inputGraph.node(v);
        var layoutLabel = layoutGraph.node(v);
        if (inputLabel) {
            inputLabel.x = layoutLabel.x;
            inputLabel.y = layoutLabel.y;
            if (layoutGraph.children(v).length) {
                inputLabel.width = layoutLabel.width;
                inputLabel.height = layoutLabel.height;
            }
        }
    });
    $bqfL5.forEach(inputGraph.edges(), function(e) {
        var inputLabel = inputGraph.edge(e);
        var layoutLabel = layoutGraph.edge(e);
        inputLabel.points = layoutLabel.points;
        if ($bqfL5.has(layoutLabel, "x")) {
            inputLabel.x = layoutLabel.x;
            inputLabel.y = layoutLabel.y;
        }
    });
    inputGraph.graph().width = layoutGraph.graph().width;
    inputGraph.graph().height = layoutGraph.graph().height;
}
var $0ae5256c4a1477f2$var$graphNumAttrs = [
    "nodesep",
    "edgesep",
    "ranksep",
    "marginx",
    "marginy"
];
var $0ae5256c4a1477f2$var$graphDefaults = {
    ranksep: 50,
    edgesep: 20,
    nodesep: 50,
    rankdir: "tb"
};
var $0ae5256c4a1477f2$var$graphAttrs = [
    "acyclicer",
    "ranker",
    "rankdir",
    "align"
];
var $0ae5256c4a1477f2$var$nodeNumAttrs = [
    "width",
    "height"
];
var $0ae5256c4a1477f2$var$nodeDefaults = {
    width: 0,
    height: 0
};
var $0ae5256c4a1477f2$var$edgeNumAttrs = [
    "minlen",
    "weight",
    "width",
    "height",
    "labeloffset"
];
var $0ae5256c4a1477f2$var$edgeDefaults = {
    minlen: 1,
    weight: 1,
    width: 0,
    height: 0,
    labeloffset: 10,
    labelpos: "r"
};
var $0ae5256c4a1477f2$var$edgeAttrs = [
    "labelpos"
];
/*
 * Constructs a new graph from the input graph, which can be used for layout.
 * This process copies only whitelisted attributes from the input graph to the
 * layout graph. Thus this function serves as a good place to determine what
 * attributes can influence layout.
 */ function $0ae5256c4a1477f2$var$buildLayoutGraph(inputGraph) {
    var g = new $0ae5256c4a1477f2$require$Graph({
        multigraph: true,
        compound: true
    });
    var graph = $0ae5256c4a1477f2$var$canonicalize(inputGraph.graph());
    g.setGraph($bqfL5.merge({}, $0ae5256c4a1477f2$var$graphDefaults, $0ae5256c4a1477f2$var$selectNumberAttrs(graph, $0ae5256c4a1477f2$var$graphNumAttrs), $bqfL5.pick(graph, $0ae5256c4a1477f2$var$graphAttrs)));
    $bqfL5.forEach(inputGraph.nodes(), function(v) {
        var node = $0ae5256c4a1477f2$var$canonicalize(inputGraph.node(v));
        g.setNode(v, $bqfL5.defaults($0ae5256c4a1477f2$var$selectNumberAttrs(node, $0ae5256c4a1477f2$var$nodeNumAttrs), $0ae5256c4a1477f2$var$nodeDefaults));
        g.setParent(v, inputGraph.parent(v));
    });
    $bqfL5.forEach(inputGraph.edges(), function(e) {
        var edge = $0ae5256c4a1477f2$var$canonicalize(inputGraph.edge(e));
        g.setEdge(e, $bqfL5.merge({}, $0ae5256c4a1477f2$var$edgeDefaults, $0ae5256c4a1477f2$var$selectNumberAttrs(edge, $0ae5256c4a1477f2$var$edgeNumAttrs), $bqfL5.pick(edge, $0ae5256c4a1477f2$var$edgeAttrs)));
    });
    return g;
}
/*
 * This idea comes from the Gansner paper: to account for edge labels in our
 * layout we split each rank in half by doubling minlen and halving ranksep.
 * Then we can place labels at these mid-points between nodes.
 *
 * We also add some minimal padding to the width to push the label for the edge
 * away from the edge itself a bit.
 */ function $0ae5256c4a1477f2$var$makeSpaceForEdgeLabels(g) {
    var graph = g.graph();
    graph.ranksep /= 2;
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        edge.minlen *= 2;
        if (edge.labelpos.toLowerCase() !== "c") {
            if (graph.rankdir === "TB" || graph.rankdir === "BT") edge.width += edge.labeloffset;
            else edge.height += edge.labeloffset;
        }
    });
}
/*
 * Creates temporary dummy nodes that capture the rank in which each edge's
 * label is going to, if it has one of non-zero width and height. We do this
 * so that we can safely remove empty ranks while preserving balance for the
 * label's position.
 */ function $0ae5256c4a1477f2$var$injectEdgeLabelProxies(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if (edge.width && edge.height) {
            var v = g.node(e.v);
            var w = g.node(e.w);
            var label = {
                rank: (w.rank - v.rank) / 2 + v.rank,
                e: e
            };
            $1kMKg.addDummyNode(g, "edge-proxy", label, "_ep");
        }
    });
}
function $0ae5256c4a1477f2$var$assignRankMinMax(g) {
    var maxRank = 0;
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if (node.borderTop) {
            node.minRank = g.node(node.borderTop).rank;
            node.maxRank = g.node(node.borderBottom).rank;
            maxRank = $bqfL5.max(maxRank, node.maxRank);
        }
    });
    g.graph().maxRank = maxRank;
}
function $0ae5256c4a1477f2$var$removeEdgeLabelProxies(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if (node.dummy === "edge-proxy") {
            g.edge(node.e).labelRank = node.rank;
            g.removeNode(v);
        }
    });
}
function $0ae5256c4a1477f2$var$translateGraph(g) {
    var minX = Number.POSITIVE_INFINITY;
    var maxX = 0;
    var minY = Number.POSITIVE_INFINITY;
    var maxY = 0;
    var graphLabel = g.graph();
    var marginX = graphLabel.marginx || 0;
    var marginY = graphLabel.marginy || 0;
    function getExtremes(attrs) {
        var x = attrs.x;
        var y = attrs.y;
        var w = attrs.width;
        var h = attrs.height;
        minX = Math.min(minX, x - w / 2);
        maxX = Math.max(maxX, x + w / 2);
        minY = Math.min(minY, y - h / 2);
        maxY = Math.max(maxY, y + h / 2);
    }
    $bqfL5.forEach(g.nodes(), function(v) {
        getExtremes(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if ($bqfL5.has(edge, "x")) getExtremes(edge);
    });
    minX -= marginX;
    minY -= marginY;
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        node.x -= minX;
        node.y -= minY;
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        $bqfL5.forEach(edge.points, function(p) {
            p.x -= minX;
            p.y -= minY;
        });
        if ($bqfL5.has(edge, "x")) edge.x -= minX;
        if ($bqfL5.has(edge, "y")) edge.y -= minY;
    });
    graphLabel.width = maxX - minX + marginX;
    graphLabel.height = maxY - minY + marginY;
}
function $0ae5256c4a1477f2$var$assignNodeIntersects(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        var nodeV = g.node(e.v);
        var nodeW = g.node(e.w);
        var p1, p2;
        if (!edge.points) {
            edge.points = [];
            p1 = nodeW;
            p2 = nodeV;
        } else {
            p1 = edge.points[0];
            p2 = edge.points[edge.points.length - 1];
        }
        edge.points.unshift($1kMKg.intersectRect(nodeV, p1));
        edge.points.push($1kMKg.intersectRect(nodeW, p2));
    });
}
function $0ae5256c4a1477f2$var$fixupEdgeLabelCoords(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if ($bqfL5.has(edge, "x")) {
            if (edge.labelpos === "l" || edge.labelpos === "r") edge.width -= edge.labeloffset;
            switch(edge.labelpos){
                case "l":
                    edge.x -= edge.width / 2 + edge.labeloffset;
                    break;
                case "r":
                    edge.x += edge.width / 2 + edge.labeloffset;
                    break;
            }
        }
    });
}
function $0ae5256c4a1477f2$var$reversePointsForReversedEdges(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if (edge.reversed) edge.points.reverse();
    });
}
function $0ae5256c4a1477f2$var$removeBorderNodes(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        if (g.children(v).length) {
            var node = g.node(v);
            var t = g.node(node.borderTop);
            var b = g.node(node.borderBottom);
            var l = g.node($bqfL5.last(node.borderLeft));
            var r = g.node($bqfL5.last(node.borderRight));
            node.width = Math.abs(r.x - l.x);
            node.height = Math.abs(b.y - t.y);
            node.x = l.x + node.width / 2;
            node.y = t.y + node.height / 2;
        }
    });
    $bqfL5.forEach(g.nodes(), function(v) {
        if (g.node(v).dummy === "border") g.removeNode(v);
    });
}
function $0ae5256c4a1477f2$var$removeSelfEdges(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        if (e.v === e.w) {
            var node = g.node(e.v);
            if (!node.selfEdges) node.selfEdges = [];
            node.selfEdges.push({
                e: e,
                label: g.edge(e)
            });
            g.removeEdge(e);
        }
    });
}
function $0ae5256c4a1477f2$var$insertSelfEdges(g) {
    var layers = $1kMKg.buildLayerMatrix(g);
    $bqfL5.forEach(layers, function(layer) {
        var orderShift = 0;
        $bqfL5.forEach(layer, function(v, i) {
            var node = g.node(v);
            node.order = i + orderShift;
            $bqfL5.forEach(node.selfEdges, function(selfEdge) {
                $1kMKg.addDummyNode(g, "selfedge", {
                    width: selfEdge.label.width,
                    height: selfEdge.label.height,
                    rank: node.rank,
                    order: i + ++orderShift,
                    e: selfEdge.e,
                    label: selfEdge.label
                }, "_se");
            });
            delete node.selfEdges;
        });
    });
}
function $0ae5256c4a1477f2$var$positionSelfEdges(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if (node.dummy === "selfedge") {
            var selfNode = g.node(node.e.v);
            var x = selfNode.x + selfNode.width / 2;
            var y = selfNode.y;
            var dx = node.x - x;
            var dy = selfNode.height / 2;
            g.setEdge(node.e, node.label);
            g.removeNode(v);
            node.label.points = [
                {
                    x: x + 2 * dx / 3,
                    y: y - dy
                },
                {
                    x: x + 5 * dx / 6,
                    y: y - dy
                },
                {
                    x: x + dx,
                    y: y
                },
                {
                    x: x + 5 * dx / 6,
                    y: y + dy
                },
                {
                    x: x + 2 * dx / 3,
                    y: y + dy
                }
            ];
            node.label.x = node.x;
            node.label.y = node.y;
        }
    });
}
function $0ae5256c4a1477f2$var$selectNumberAttrs(obj, attrs) {
    return $bqfL5.mapValues($bqfL5.pick(obj, attrs), Number);
}
function $0ae5256c4a1477f2$var$canonicalize(attrs) {
    var newAttrs = {};
    $bqfL5.forEach(attrs, function(v, k) {
        newAttrs[k.toLowerCase()] = v;
    });
    return newAttrs;
}

});
parcelRegister("bqfL5", function(module, exports) {
/* global window */ var $850e58b67514fb74$var$lodash;


























try {
    $850e58b67514fb74$var$lodash = {
        cloneDeep: (parcelRequire("iGQLm")),
        constant: (parcelRequire("9HRmE")),
        defaults: (parcelRequire("1SWLj")),
        each: (parcelRequire("5kE3T")),
        filter: (parcelRequire("jLJR7")),
        find: (parcelRequire("8I8e5")),
        flatten: (parcelRequire("20Rgr")),
        forEach: (parcelRequire("iWSff")),
        forIn: (parcelRequire("jojmF")),
        has: (parcelRequire("jplJt")),
        isUndefined: (parcelRequire("enrJD")),
        last: (parcelRequire("hkfXi")),
        map: (parcelRequire("437iZ")),
        mapValues: (parcelRequire("1Z7cU")),
        max: (parcelRequire("aK6kk")),
        merge: (parcelRequire("5W3lT")),
        min: (parcelRequire("3Ne9k")),
        minBy: (parcelRequire("5oTLF")),
        now: (parcelRequire("9nn6T")),
        pick: (parcelRequire("12eN8")),
        range: (parcelRequire("fpRwA")),
        reduce: (parcelRequire("2KuAh")),
        sortBy: (parcelRequire("47O2q")),
        uniqueId: (parcelRequire("g0ikZ")),
        values: (parcelRequire("7D6Gq")),
        zipObject: (parcelRequire("d0lTW"))
    };
} catch (e) {
// continue regardless of error
}
if (!$850e58b67514fb74$var$lodash) $850e58b67514fb74$var$lodash = window._;
module.exports = $850e58b67514fb74$var$lodash;

});
parcelRegister("iGQLm", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $d9b513d63d79678d$var$CLONE_DEEP_FLAG = 1, $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d9b513d63d79678d$var$cloneDeep(value) {
    return $kqX4j(value, $d9b513d63d79678d$var$CLONE_DEEP_FLAG | $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $d9b513d63d79678d$var$cloneDeep;

});

parcelRegister("1SWLj", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $6TC8i = parcelRequire("6TC8i");

var $b8mN0 = parcelRequire("b8mN0");

var $f4lqP = parcelRequire("f4lqP");
/** Used for built-in method references. */ var $15f86a7fdfb0f225$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $15f86a7fdfb0f225$var$hasOwnProperty = $15f86a7fdfb0f225$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $15f86a7fdfb0f225$var$defaults = $5iyRF(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $b8mN0(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $f4lqP(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $6TC8i(value, $15f86a7fdfb0f225$var$objectProto[key]) && !$15f86a7fdfb0f225$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $15f86a7fdfb0f225$var$defaults;

});
parcelRegister("b8mN0", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");

var $eMthh = parcelRequire("eMthh");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$lsJ54(object)) return false;
    var type = typeof index;
    if (type == 'number' ? $eMthh(object) && $iyUuu(index, object.length) : type == 'string' && index in object) return $6TC8i(object[index], value);
    return false;
}
module.exports = $81b21e8b41d211e8$var$isIterateeCall;

});


parcelRegister("8I8e5", function(module, exports) {

var $ePhxS = parcelRequire("ePhxS");

var $cpmrH = parcelRequire("cpmrH");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $6578d05764c8afc8$var$find = $ePhxS($cpmrH);
module.exports = $6578d05764c8afc8$var$find;

});
parcelRegister("ePhxS", function(module, exports) {

var $7MWok = parcelRequire("7MWok");

var $eMthh = parcelRequire("eMthh");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $acb3703f94fb96ce$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$eMthh(collection)) {
            var iteratee = $7MWok(predicate, 3);
            collection = $LAMcS(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $acb3703f94fb96ce$var$createFind;

});

parcelRegister("cpmrH", function(module, exports) {

var $eAor6 = parcelRequire("eAor6");

var $7MWok = parcelRequire("7MWok");

var $2MGGR = parcelRequire("2MGGR");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $90893b1abc59631b$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $90893b1abc59631b$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $2MGGR(fromIndex);
    if (index < 0) index = $90893b1abc59631b$var$nativeMax(length + index, 0);
    return $eAor6(array, $7MWok(predicate, 3), index);
}
module.exports = $90893b1abc59631b$var$findIndex;

});
parcelRegister("2MGGR", function(module, exports) {

var $9lLgO = parcelRequire("9lLgO");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $20712de2064d78dd$var$toInteger(value) {
    var result = $9lLgO(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
module.exports = $20712de2064d78dd$var$toInteger;

});
parcelRegister("9lLgO", function(module, exports) {

var $iV4PZ = parcelRequire("iV4PZ");
/** Used as references for various `Number` constants. */ var $6ceabe126a95a54e$var$INFINITY = 1 / 0, $6ceabe126a95a54e$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $6ceabe126a95a54e$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $iV4PZ(value);
    if (value === $6ceabe126a95a54e$var$INFINITY || value === -$6ceabe126a95a54e$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $6ceabe126a95a54e$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
module.exports = $6ceabe126a95a54e$var$toFinite;

});
parcelRegister("iV4PZ", function(module, exports) {

var $s0iWz = parcelRequire("s0iWz");

var $lsJ54 = parcelRequire("lsJ54");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $dc614d828223dea6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $dc614d828223dea6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $dc614d828223dea6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $dc614d828223dea6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $dc614d828223dea6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $dc614d828223dea6$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($9dr3u(value)) return $dc614d828223dea6$var$NAN;
    if ($lsJ54(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $lsJ54(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $s0iWz(value);
    var isBinary = $dc614d828223dea6$var$reIsBinary.test(value);
    return isBinary || $dc614d828223dea6$var$reIsOctal.test(value) ? $dc614d828223dea6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $dc614d828223dea6$var$reIsBadHex.test(value) ? $dc614d828223dea6$var$NAN : +value;
}
module.exports = $dc614d828223dea6$var$toNumber;

});
parcelRegister("s0iWz", function(module, exports) {

var $kzo8D = parcelRequire("kzo8D");
/** Used to match leading whitespace. */ var $0542da1d887b1c4d$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $0542da1d887b1c4d$var$baseTrim(string) {
    return string ? string.slice(0, $kzo8D(string) + 1).replace($0542da1d887b1c4d$var$reTrimStart, '') : string;
}
module.exports = $0542da1d887b1c4d$var$baseTrim;

});
parcelRegister("kzo8D", function(module, exports) {
/** Used to match a single whitespace character. */ var $ef99cce288c7323e$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $ef99cce288c7323e$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $ef99cce288c7323e$var$reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = $ef99cce288c7323e$var$trimmedEndIndex;

});







parcelRegister("20Rgr", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $1774e6065e7ade58$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, 1) : [];
}
module.exports = $1774e6065e7ade58$var$flatten;

});

parcelRegister("jojmF", function(module, exports) {

var $dEvx9 = parcelRequire("dEvx9");

var $4c8Zb = parcelRequire("4c8Zb");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Iterates over own and inherited enumerable string keyed properties of an
 * object and invokes `iteratee` for each property. The iteratee is invoked
 * with three arguments: (value, key, object). Iteratee functions may exit
 * iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forInRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forIn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
 */ function $e1df479b00a6084f$var$forIn(object, iteratee) {
    return object == null ? object : $dEvx9(object, $4c8Zb(iteratee), $f4lqP);
}
module.exports = $e1df479b00a6084f$var$forIn;

});

parcelRegister("hkfXi", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $c9d0ae50fd1d1372$var$last;

});

parcelRegister("1Z7cU", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $4xK4A = parcelRequire("4xK4A");

var $7MWok = parcelRequire("7MWok");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $17211428bc2045c4$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7MWok(iteratee, 3);
    $4xK4A(object, function(value, key, object) {
        $cWbJD(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $17211428bc2045c4$var$mapValues;

});

parcelRegister("aK6kk", function(module, exports) {

var $gv3JG = parcelRequire("gv3JG");

var $iK245 = parcelRequire("iK245");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $7d231ba5a67a42db$var$max(array) {
    return array && array.length ? $gv3JG(array, $4Nq5y, $iK245) : undefined;
}
module.exports = $7d231ba5a67a42db$var$max;

});
parcelRegister("gv3JG", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $c032706da200ef36$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$9dr3u(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $c032706da200ef36$var$baseExtremum;

});

parcelRegister("iK245", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $da4e1fe5f8bd1939$var$baseGt(value, other) {
    return value > other;
}
module.exports = $da4e1fe5f8bd1939$var$baseGt;

});


parcelRegister("5W3lT", function(module, exports) {

var $4uZ7x = parcelRequire("4uZ7x");

var $i1jm6 = parcelRequire("i1jm6");
/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $4524f833ae45779b$var$merge = $i1jm6(function(object, source, srcIndex) {
    $4uZ7x(object, source, srcIndex);
});
module.exports = $4524f833ae45779b$var$merge;

});
parcelRegister("4uZ7x", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $7RXmv = parcelRequire("7RXmv");

var $dEvx9 = parcelRequire("dEvx9");

var $cTZHA = parcelRequire("cTZHA");

var $lsJ54 = parcelRequire("lsJ54");

var $f4lqP = parcelRequire("f4lqP");

var $1ys2O = parcelRequire("1ys2O");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $34696005ed9b3f30$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $dEvx9(source, function(srcValue, key) {
        stack || (stack = new $g779E);
        if ($lsJ54(srcValue)) $cTZHA(object, source, key, srcIndex, $34696005ed9b3f30$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($1ys2O(object, key), srcValue, key + '', object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $7RXmv(object, key, newValue);
        }
    }, $f4lqP);
}
module.exports = $34696005ed9b3f30$var$baseMerge;

});
parcelRegister("7RXmv", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5bab87b519c266a0$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$6TC8i(object[key], value) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $5bab87b519c266a0$var$assignMergeValue;

});

parcelRegister("cTZHA", function(module, exports) {

var $7RXmv = parcelRequire("7RXmv");

var $uQ1Em = parcelRequire("uQ1Em");

var $5JAGM = parcelRequire("5JAGM");

var $aA0pv = parcelRequire("aA0pv");

var $dFJsF = parcelRequire("dFJsF");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $jGP9B = parcelRequire("jGP9B");

var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $xMy82 = parcelRequire("xMy82");

var $1Q21n = parcelRequire("1Q21n");

var $1ys2O = parcelRequire("1ys2O");

var $kp2OI = parcelRequire("kp2OI");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $964a7bd734d0fbad$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $1ys2O(object, key), srcValue = $1ys2O(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $7RXmv(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $o8HxT(srcValue), isBuff = !isArr && $f504n(srcValue), isTyped = !isArr && !isBuff && $1Q21n(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($o8HxT(objValue)) newValue = objValue;
            else if ($jGP9B(objValue)) newValue = $aA0pv(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $uQ1Em(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $5JAGM(srcValue, true);
            } else newValue = [];
        } else if ($xMy82(srcValue) || $aJD6g(srcValue)) {
            newValue = objValue;
            if ($aJD6g(objValue)) newValue = $kp2OI(objValue);
            else if (!$lsJ54(objValue) || $01ubZ(objValue)) newValue = $dFJsF(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
    }
    $7RXmv(object, key, newValue);
}
module.exports = $964a7bd734d0fbad$var$baseMergeDeep;

});
parcelRegister("xMy82", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $cdnOB = parcelRequire("cdnOB");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$8l89S(value) || $eq6CV(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $cdnOB(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
module.exports = $0658be17f7793a43$var$isPlainObject;

});

parcelRegister("1ys2O", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $121eb86ef7ce6b9c$var$safeGet(object, key) {
    if (key === 'constructor' && typeof object[key] === 'function') return;
    if (key == '__proto__') return;
    return object[key];
}
module.exports = $121eb86ef7ce6b9c$var$safeGet;

});

parcelRegister("kp2OI", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $eda853de6b056001$var$toPlainObject(value) {
    return $cYlGN(value, $f4lqP(value));
}
module.exports = $eda853de6b056001$var$toPlainObject;

});



parcelRegister("i1jm6", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $d1e75591f556b111$var$createAssigner(assigner) {
    return $5iyRF(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && $b8mN0(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $d1e75591f556b111$var$createAssigner;

});


parcelRegister("3Ne9k", function(module, exports) {

var $gv3JG = parcelRequire("gv3JG");

var $hGcz8 = parcelRequire("hGcz8");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $2c30ec7848ba160d$var$min(array) {
    return array && array.length ? $gv3JG(array, $4Nq5y, $hGcz8) : undefined;
}
module.exports = $2c30ec7848ba160d$var$min;

});
parcelRegister("hGcz8", function(module, exports) {
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $cdf01b2c29e1be9c$var$baseLt(value, other) {
    return value < other;
}
module.exports = $cdf01b2c29e1be9c$var$baseLt;

});


parcelRegister("5oTLF", function(module, exports) {

var $gv3JG = parcelRequire("gv3JG");

var $7MWok = parcelRequire("7MWok");

var $hGcz8 = parcelRequire("hGcz8");
/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */ function $3eea73fc544592fd$var$minBy(array, iteratee) {
    return array && array.length ? $gv3JG(array, $7MWok(iteratee, 2), $hGcz8) : undefined;
}
module.exports = $3eea73fc544592fd$var$minBy;

});

parcelRegister("9nn6T", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6d38303b9c8735ba$var$now = function() {
    return $23YZo.Date.now();
};
module.exports = $6d38303b9c8735ba$var$now;

});

parcelRegister("12eN8", function(module, exports) {

var $1AWBt = parcelRequire("1AWBt");

var $8KK0w = parcelRequire("8KK0w");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $0c11739df3ac35ad$var$pick = $8KK0w(function(object, paths) {
    return object == null ? {} : $1AWBt(object, paths);
});
module.exports = $0c11739df3ac35ad$var$pick;

});
parcelRegister("1AWBt", function(module, exports) {

var $6IXDN = parcelRequire("6IXDN");

var $2VBx6 = parcelRequire("2VBx6");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $12969ca4851cc4ab$var$basePick(object, paths) {
    return $6IXDN(object, paths, function(value, path) {
        return $2VBx6(object, path);
    });
}
module.exports = $12969ca4851cc4ab$var$basePick;

});
parcelRegister("6IXDN", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");

var $eJzCK = parcelRequire("eJzCK");

var $4RK0h = parcelRequire("4RK0h");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4e551d8e73f04819$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $lJEX1(object, path);
        if (predicate(value, path)) $eJzCK(result, $4RK0h(path, object), value);
    }
    return result;
}
module.exports = $4e551d8e73f04819$var$basePickBy;

});
parcelRegister("eJzCK", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $4RK0h = parcelRequire("4RK0h");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$lsJ54(object)) return object;
    path = $4RK0h(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $6DSvu(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lsJ54(objValue) ? objValue : $iyUuu(path[index + 1]) ? [] : {};
        }
        $5i71d(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $aba0e6d66e8d80dd$var$baseSet;

});



parcelRegister("8KK0w", function(module, exports) {

var $20Rgr = parcelRequire("20Rgr");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $65f64eb9f31faa0d$var$flatRest(func) {
    return $iGMVy($b86t6(func, undefined, $20Rgr), func + '');
}
module.exports = $65f64eb9f31faa0d$var$flatRest;

});


parcelRegister("fpRwA", function(module, exports) {

var $hDGMd = parcelRequire("hDGMd");
/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $b392b5b21038a0ce$var$range = $hDGMd();
module.exports = $b392b5b21038a0ce$var$range;

});
parcelRegister("hDGMd", function(module, exports) {

var $ia9lU = parcelRequire("ia9lU");

var $b8mN0 = parcelRequire("b8mN0");

var $9lLgO = parcelRequire("9lLgO");
/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $cd7742b81dd96fb0$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != 'number' && $b8mN0(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $9lLgO(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $9lLgO(end);
        step = step === undefined ? start < end ? 1 : -1 : $9lLgO(step);
        return $ia9lU(start, end, step, fromRight);
    };
}
module.exports = $cd7742b81dd96fb0$var$createRange;

});
parcelRegister("ia9lU", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d3906a592348eb7a$var$nativeCeil = Math.ceil, $d3906a592348eb7a$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $d3906a592348eb7a$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $d3906a592348eb7a$var$nativeMax($d3906a592348eb7a$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
module.exports = $d3906a592348eb7a$var$baseRange;

});



parcelRegister("47O2q", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");

var $jrtNg = parcelRequire("jrtNg");

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $300ea168693086c2$var$sortBy = $5iyRF(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $b8mN0(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $b8mN0(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $jrtNg(collection, $fgBHx(iteratees, 1), []);
});
module.exports = $300ea168693086c2$var$sortBy;

});
parcelRegister("jrtNg", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $lJEX1 = parcelRequire("lJEX1");

var $7MWok = parcelRequire("7MWok");

var $fDc61 = parcelRequire("fDc61");

var $9xZGY = parcelRequire("9xZGY");

var $91Qdd = parcelRequire("91Qdd");

var $fyGSR = parcelRequire("fyGSR");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $i46jW(iteratees, function(iteratee) {
        if ($o8HxT(iteratee)) return function(value) {
            return $lJEX1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $4Nq5y
    ];
    var index = -1;
    iteratees = $i46jW(iteratees, $91Qdd($7MWok));
    var result = $fDc61(collection, function(value, key, collection) {
        var criteria = $i46jW(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            'criteria': criteria,
            'index': ++index,
            'value': value
        };
    });
    return $9xZGY(result, function(object, other) {
        return $fyGSR(object, other, orders);
    });
}
module.exports = $e277a64de4eeade6$var$baseOrderBy;

});
parcelRegister("9xZGY", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $6f370ce7a904568e$var$baseSortBy;

});

parcelRegister("fyGSR", function(module, exports) {

var $1HU00 = parcelRequire("1HU00");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $1HU00(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $b53b4bd61680c3b6$var$compareMultiple;

});
parcelRegister("1HU00", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9dr3u(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9dr3u(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $13e53edf809f77b7$var$compareAscending;

});




parcelRegister("g0ikZ", function(module, exports) {

var $l6E2L = parcelRequire("l6E2L");
/** Used to generate unique IDs. */ var $ba6adedcdb459bac$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $ba6adedcdb459bac$var$uniqueId(prefix) {
    var id = ++$ba6adedcdb459bac$var$idCounter;
    return $l6E2L(prefix) + id;
}
module.exports = $ba6adedcdb459bac$var$uniqueId;

});

parcelRegister("d0lTW", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $gMJL8 = parcelRequire("gMJL8");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $977c4393d7c5d19f$var$zipObject(props, values) {
    return $gMJL8(props || [], values || [], $5i71d);
}
module.exports = $977c4393d7c5d19f$var$zipObject;

});
parcelRegister("gMJL8", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $c3849fdfd5a45efd$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $c3849fdfd5a45efd$var$baseZipObject;

});



parcelRegister("61rsw", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $7azAU = parcelRequire("7azAU");
module.exports = {
    run: $462822e0eb73a15e$var$run,
    undo: $462822e0eb73a15e$var$undo
};
function $462822e0eb73a15e$var$run(g) {
    var fas = g.graph().acyclicer === "greedy" ? $7azAU(g, weightFn(g)) : $462822e0eb73a15e$var$dfsFAS(g);
    $bqfL5.forEach(fas, function(e) {
        var label = g.edge(e);
        g.removeEdge(e);
        label.forwardName = e.name;
        label.reversed = true;
        g.setEdge(e.w, e.v, label, $bqfL5.uniqueId("rev"));
    });
    function weightFn(g) {
        return function(e) {
            return g.edge(e).weight;
        };
    }
}
function $462822e0eb73a15e$var$dfsFAS(g) {
    var fas = [];
    var stack = {};
    var visited = {};
    function dfs(v) {
        if ($bqfL5.has(visited, v)) return;
        visited[v] = true;
        stack[v] = true;
        $bqfL5.forEach(g.outEdges(v), function(e) {
            if ($bqfL5.has(stack, e.w)) fas.push(e);
            else dfs(e.w);
        });
        delete stack[v];
    }
    $bqfL5.forEach(g.nodes(), dfs);
    return fas;
}
function $462822e0eb73a15e$var$undo(g) {
    $bqfL5.forEach(g.edges(), function(e) {
        var label = g.edge(e);
        if (label.reversed) {
            g.removeEdge(e);
            var forwardName = label.forwardName;
            delete label.reversed;
            delete label.forwardName;
            g.setEdge(e.w, e.v, label, forwardName);
        }
    });
}

});
parcelRegister("7azAU", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $538513d89390fb19$require$Graph = $6mwJ2.Graph;

var $1Gvoz = parcelRequire("1Gvoz");
/*
 * A greedy heuristic for finding a feedback arc set for a graph. A feedback
 * arc set is a set of edges that can be removed to make a graph acyclic.
 * The algorithm comes from: P. Eades, X. Lin, and W. F. Smyth, "A fast and
 * effective heuristic for the feedback arc set problem." This implementation
 * adjusts that from the paper to allow for weighted edges.
 */ module.exports = $538513d89390fb19$var$greedyFAS;
var $538513d89390fb19$var$DEFAULT_WEIGHT_FN = $bqfL5.constant(1);
function $538513d89390fb19$var$greedyFAS(g, weightFn) {
    if (g.nodeCount() <= 1) return [];
    var state = $538513d89390fb19$var$buildState(g, weightFn || $538513d89390fb19$var$DEFAULT_WEIGHT_FN);
    var results = $538513d89390fb19$var$doGreedyFAS(state.graph, state.buckets, state.zeroIdx);
    // Expand multi-edges
    return $bqfL5.flatten($bqfL5.map(results, function(e) {
        return g.outEdges(e.v, e.w);
    }), true);
}
function $538513d89390fb19$var$doGreedyFAS(g, buckets, zeroIdx) {
    var results = [];
    var sources = buckets[buckets.length - 1];
    var sinks = buckets[0];
    var entry;
    while(g.nodeCount()){
        while(entry = sinks.dequeue())$538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry);
        while(entry = sources.dequeue())$538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry);
        if (g.nodeCount()) for(var i = buckets.length - 2; i > 0; --i){
            entry = buckets[i].dequeue();
            if (entry) {
                results = results.concat($538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry, true));
                break;
            }
        }
    }
    return results;
}
function $538513d89390fb19$var$removeNode(g, buckets, zeroIdx, entry, collectPredecessors) {
    var results = collectPredecessors ? [] : undefined;
    $bqfL5.forEach(g.inEdges(entry.v), function(edge) {
        var weight = g.edge(edge);
        var uEntry = g.node(edge.v);
        if (collectPredecessors) results.push({
            v: edge.v,
            w: edge.w
        });
        uEntry.out -= weight;
        $538513d89390fb19$var$assignBucket(buckets, zeroIdx, uEntry);
    });
    $bqfL5.forEach(g.outEdges(entry.v), function(edge) {
        var weight = g.edge(edge);
        var w = edge.w;
        var wEntry = g.node(w);
        wEntry["in"] -= weight;
        $538513d89390fb19$var$assignBucket(buckets, zeroIdx, wEntry);
    });
    g.removeNode(entry.v);
    return results;
}
function $538513d89390fb19$var$buildState(g, weightFn) {
    var fasGraph = new $538513d89390fb19$require$Graph();
    var maxIn = 0;
    var maxOut = 0;
    $bqfL5.forEach(g.nodes(), function(v) {
        fasGraph.setNode(v, {
            v: v,
            "in": 0,
            out: 0
        });
    });
    // Aggregate weights on nodes, but also sum the weights across multi-edges
    // into a single edge for the fasGraph.
    $bqfL5.forEach(g.edges(), function(e) {
        var prevWeight = fasGraph.edge(e.v, e.w) || 0;
        var weight = weightFn(e);
        var edgeWeight = prevWeight + weight;
        fasGraph.setEdge(e.v, e.w, edgeWeight);
        maxOut = Math.max(maxOut, fasGraph.node(e.v).out += weight);
        maxIn = Math.max(maxIn, fasGraph.node(e.w)["in"] += weight);
    });
    var buckets = $bqfL5.range(maxOut + maxIn + 3).map(function() {
        return new $1Gvoz();
    });
    var zeroIdx = maxIn + 1;
    $bqfL5.forEach(fasGraph.nodes(), function(v) {
        $538513d89390fb19$var$assignBucket(buckets, zeroIdx, fasGraph.node(v));
    });
    return {
        graph: fasGraph,
        buckets: buckets,
        zeroIdx: zeroIdx
    };
}
function $538513d89390fb19$var$assignBucket(buckets, zeroIdx, entry) {
    if (!entry.out) buckets[0].enqueue(entry);
    else if (!entry["in"]) buckets[buckets.length - 1].enqueue(entry);
    else buckets[entry.out - entry["in"] + zeroIdx].enqueue(entry);
}

});
parcelRegister("1Gvoz", function(module, exports) {
/*
 * Simple doubly linked list implementation derived from Cormen, et al.,
 * "Introduction to Algorithms".
 */ module.exports = $13a211288b92d897$var$List;
function $13a211288b92d897$var$List() {
    var sentinel = {};
    sentinel._next = sentinel._prev = sentinel;
    this._sentinel = sentinel;
}
$13a211288b92d897$var$List.prototype.dequeue = function() {
    var sentinel = this._sentinel;
    var entry = sentinel._prev;
    if (entry !== sentinel) {
        $13a211288b92d897$var$unlink(entry);
        return entry;
    }
};
$13a211288b92d897$var$List.prototype.enqueue = function(entry) {
    var sentinel = this._sentinel;
    if (entry._prev && entry._next) $13a211288b92d897$var$unlink(entry);
    entry._next = sentinel._next;
    sentinel._next._prev = entry;
    sentinel._next = entry;
    entry._prev = sentinel;
};
$13a211288b92d897$var$List.prototype.toString = function() {
    var strs = [];
    var sentinel = this._sentinel;
    var curr = sentinel._prev;
    while(curr !== sentinel){
        strs.push(JSON.stringify(curr, $13a211288b92d897$var$filterOutLinks));
        curr = curr._prev;
    }
    return "[" + strs.join(", ") + "]";
};
function $13a211288b92d897$var$unlink(entry) {
    entry._prev._next = entry._next;
    entry._next._prev = entry._prev;
    delete entry._next;
    delete entry._prev;
}
function $13a211288b92d897$var$filterOutLinks(k, v) {
    if (k !== "_next" && k !== "_prev") return v;
}

});



parcelRegister("fi6eg", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = {
    run: $b21d5e65d022816f$var$run,
    undo: $b21d5e65d022816f$var$undo
};
/*
 * Breaks any long edges in the graph into short segments that span 1 layer
 * each. This operation is undoable with the denormalize function.
 *
 * Pre-conditions:
 *
 *    1. The input graph is a DAG.
 *    2. Each node in the graph has a "rank" property.
 *
 * Post-condition:
 *
 *    1. All edges in the graph have a length of 1.
 *    2. Dummy nodes are added where edges have been split into segments.
 *    3. The graph is augmented with a "dummyChains" attribute which contains
 *       the first dummy in each chain of dummy nodes produced.
 */ function $b21d5e65d022816f$var$run(g) {
    g.graph().dummyChains = [];
    $bqfL5.forEach(g.edges(), function(edge) {
        $b21d5e65d022816f$var$normalizeEdge(g, edge);
    });
}
function $b21d5e65d022816f$var$normalizeEdge(g, e) {
    var v = e.v;
    var vRank = g.node(v).rank;
    var w = e.w;
    var wRank = g.node(w).rank;
    var name = e.name;
    var edgeLabel = g.edge(e);
    var labelRank = edgeLabel.labelRank;
    if (wRank === vRank + 1) return;
    g.removeEdge(e);
    var dummy, attrs, i;
    for(i = 0, ++vRank; vRank < wRank; ++i, ++vRank){
        edgeLabel.points = [];
        attrs = {
            width: 0,
            height: 0,
            edgeLabel: edgeLabel,
            edgeObj: e,
            rank: vRank
        };
        dummy = $1kMKg.addDummyNode(g, "edge", attrs, "_d");
        if (vRank === labelRank) {
            attrs.width = edgeLabel.width;
            attrs.height = edgeLabel.height;
            attrs.dummy = "edge-label";
            attrs.labelpos = edgeLabel.labelpos;
        }
        g.setEdge(v, dummy, {
            weight: edgeLabel.weight
        }, name);
        if (i === 0) g.graph().dummyChains.push(dummy);
        v = dummy;
    }
    g.setEdge(v, w, {
        weight: edgeLabel.weight
    }, name);
}
function $b21d5e65d022816f$var$undo(g) {
    $bqfL5.forEach(g.graph().dummyChains, function(v) {
        var node = g.node(v);
        var origLabel = node.edgeLabel;
        var w;
        g.setEdge(node.edgeObj, origLabel);
        while(node.dummy){
            w = g.successors(v)[0];
            g.removeNode(v);
            origLabel.points.push({
                x: node.x,
                y: node.y
            });
            if (node.dummy === "edge-label") {
                origLabel.x = node.x;
                origLabel.y = node.y;
                origLabel.width = node.width;
                origLabel.height = node.height;
            }
            v = w;
            node = g.node(v);
        }
    });
}

});
parcelRegister("1kMKg", function(module, exports) {
/* eslint "no-console": off */ "use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $0f8d7874fb4245ee$require$Graph = $6mwJ2.Graph;
module.exports = {
    addDummyNode: $0f8d7874fb4245ee$var$addDummyNode,
    simplify: $0f8d7874fb4245ee$var$simplify,
    asNonCompoundGraph: $0f8d7874fb4245ee$var$asNonCompoundGraph,
    successorWeights: $0f8d7874fb4245ee$var$successorWeights,
    predecessorWeights: $0f8d7874fb4245ee$var$predecessorWeights,
    intersectRect: $0f8d7874fb4245ee$var$intersectRect,
    buildLayerMatrix: $0f8d7874fb4245ee$var$buildLayerMatrix,
    normalizeRanks: $0f8d7874fb4245ee$var$normalizeRanks,
    removeEmptyRanks: $0f8d7874fb4245ee$var$removeEmptyRanks,
    addBorderNode: $0f8d7874fb4245ee$var$addBorderNode,
    maxRank: $0f8d7874fb4245ee$var$maxRank,
    partition: $0f8d7874fb4245ee$var$partition,
    time: $0f8d7874fb4245ee$var$time,
    notime: $0f8d7874fb4245ee$var$notime
};
/*
 * Adds a dummy node to the graph and return v.
 */ function $0f8d7874fb4245ee$var$addDummyNode(g, type, attrs, name) {
    var v;
    do v = $bqfL5.uniqueId(name);
    while (g.hasNode(v));
    attrs.dummy = type;
    g.setNode(v, attrs);
    return v;
}
/*
 * Returns a new graph with only simple edges. Handles aggregation of data
 * associated with multi-edges.
 */ function $0f8d7874fb4245ee$var$simplify(g) {
    var simplified = new $0f8d7874fb4245ee$require$Graph().setGraph(g.graph());
    $bqfL5.forEach(g.nodes(), function(v) {
        simplified.setNode(v, g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var simpleLabel = simplified.edge(e.v, e.w) || {
            weight: 0,
            minlen: 1
        };
        var label = g.edge(e);
        simplified.setEdge(e.v, e.w, {
            weight: simpleLabel.weight + label.weight,
            minlen: Math.max(simpleLabel.minlen, label.minlen)
        });
    });
    return simplified;
}
function $0f8d7874fb4245ee$var$asNonCompoundGraph(g) {
    var simplified = new $0f8d7874fb4245ee$require$Graph({
        multigraph: g.isMultigraph()
    }).setGraph(g.graph());
    $bqfL5.forEach(g.nodes(), function(v) {
        if (!g.children(v).length) simplified.setNode(v, g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        simplified.setEdge(e, g.edge(e));
    });
    return simplified;
}
function $0f8d7874fb4245ee$var$successorWeights(g) {
    var weightMap = $bqfL5.map(g.nodes(), function(v) {
        var sucs = {};
        $bqfL5.forEach(g.outEdges(v), function(e) {
            sucs[e.w] = (sucs[e.w] || 0) + g.edge(e).weight;
        });
        return sucs;
    });
    return $bqfL5.zipObject(g.nodes(), weightMap);
}
function $0f8d7874fb4245ee$var$predecessorWeights(g) {
    var weightMap = $bqfL5.map(g.nodes(), function(v) {
        var preds = {};
        $bqfL5.forEach(g.inEdges(v), function(e) {
            preds[e.v] = (preds[e.v] || 0) + g.edge(e).weight;
        });
        return preds;
    });
    return $bqfL5.zipObject(g.nodes(), weightMap);
}
/*
 * Finds where a line starting at point ({x, y}) would intersect a rectangle
 * ({x, y, width, height}) if it were pointing at the rectangle's center.
 */ function $0f8d7874fb4245ee$var$intersectRect(rect, point) {
    var x = rect.x;
    var y = rect.y;
    // Rectangle intersection algorithm from:
    // http://math.stackexchange.com/questions/108113/find-edge-between-two-boxes
    var dx = point.x - x;
    var dy = point.y - y;
    var w = rect.width / 2;
    var h = rect.height / 2;
    if (!dx && !dy) throw new Error("Not possible to find intersection inside of the rectangle");
    var sx, sy;
    if (Math.abs(dy) * w > Math.abs(dx) * h) {
        // Intersection is top or bottom of rect.
        if (dy < 0) h = -h;
        sx = h * dx / dy;
        sy = h;
    } else {
        // Intersection is left or right of rect.
        if (dx < 0) w = -w;
        sx = w;
        sy = w * dy / dx;
    }
    return {
        x: x + sx,
        y: y + sy
    };
}
/*
 * Given a DAG with each node assigned "rank" and "order" properties, this
 * function will produce a matrix with the ids of each node.
 */ function $0f8d7874fb4245ee$var$buildLayerMatrix(g) {
    var layering = $bqfL5.map($bqfL5.range($0f8d7874fb4245ee$var$maxRank(g) + 1), function() {
        return [];
    });
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        var rank = node.rank;
        if (!$bqfL5.isUndefined(rank)) layering[rank][node.order] = v;
    });
    return layering;
}
/*
 * Adjusts the ranks for all nodes in the graph such that all nodes v have
 * rank(v) >= 0 and at least one node w has rank(w) = 0.
 */ function $0f8d7874fb4245ee$var$normalizeRanks(g) {
    var min = $bqfL5.min($bqfL5.map(g.nodes(), function(v) {
        return g.node(v).rank;
    }));
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v);
        if ($bqfL5.has(node, "rank")) node.rank -= min;
    });
}
function $0f8d7874fb4245ee$var$removeEmptyRanks(g) {
    // Ranks may not start at 0, so we need to offset them
    var offset = $bqfL5.min($bqfL5.map(g.nodes(), function(v) {
        return g.node(v).rank;
    }));
    var layers = [];
    $bqfL5.forEach(g.nodes(), function(v) {
        var rank = g.node(v).rank - offset;
        if (!layers[rank]) layers[rank] = [];
        layers[rank].push(v);
    });
    var delta = 0;
    var nodeRankFactor = g.graph().nodeRankFactor;
    $bqfL5.forEach(layers, function(vs, i) {
        if ($bqfL5.isUndefined(vs) && i % nodeRankFactor !== 0) --delta;
        else if (delta) $bqfL5.forEach(vs, function(v) {
            g.node(v).rank += delta;
        });
    });
}
function $0f8d7874fb4245ee$var$addBorderNode(g, prefix, rank, order) {
    var node = {
        width: 0,
        height: 0
    };
    if (arguments.length >= 4) {
        node.rank = rank;
        node.order = order;
    }
    return $0f8d7874fb4245ee$var$addDummyNode(g, "border", node, prefix);
}
function $0f8d7874fb4245ee$var$maxRank(g) {
    return $bqfL5.max($bqfL5.map(g.nodes(), function(v) {
        var rank = g.node(v).rank;
        if (!$bqfL5.isUndefined(rank)) return rank;
    }));
}
/*
 * Partition a collection into two groups: `lhs` and `rhs`. If the supplied
 * function returns true for an entry it goes into `lhs`. Otherwise it goes
 * into `rhs.
 */ function $0f8d7874fb4245ee$var$partition(collection, fn) {
    var result = {
        lhs: [],
        rhs: []
    };
    $bqfL5.forEach(collection, function(value) {
        if (fn(value)) result.lhs.push(value);
        else result.rhs.push(value);
    });
    return result;
}
/*
 * Returns a new function that wraps `fn` with a timer. The wrapper logs the
 * time it takes to execute the function.
 */ function $0f8d7874fb4245ee$var$time(name, fn) {
    var start = $bqfL5.now();
    try {
        return fn();
    } finally{
        console.log(name + " time: " + ($bqfL5.now() - start) + "ms");
    }
}
function $0f8d7874fb4245ee$var$notime(name, fn) {
    return fn();
}

});


parcelRegister("hv32p", function(module, exports) {
"use strict";

var $7JZFZ = parcelRequire("7JZFZ");
var $cbd7b02ec197fd8b$var$longestPath = $7JZFZ.longestPath;

var $8eEo6 = parcelRequire("8eEo6");

var $fT8MR = parcelRequire("fT8MR");
module.exports = $cbd7b02ec197fd8b$var$rank;
/*
 * Assigns a rank to each node in the input graph that respects the "minlen"
 * constraint specified on edges between nodes.
 *
 * This basic structure is derived from Gansner, et al., "A Technique for
 * Drawing Directed Graphs."
 *
 * Pre-conditions:
 *
 *    1. Graph must be a connected DAG
 *    2. Graph nodes must be objects
 *    3. Graph edges must have "weight" and "minlen" attributes
 *
 * Post-conditions:
 *
 *    1. Graph nodes will have a "rank" attribute based on the results of the
 *       algorithm. Ranks can start at any index (including negative), we'll
 *       fix them up later.
 */ function $cbd7b02ec197fd8b$var$rank(g) {
    switch(g.graph().ranker){
        case "network-simplex":
            $cbd7b02ec197fd8b$var$networkSimplexRanker(g);
            break;
        case "tight-tree":
            $cbd7b02ec197fd8b$var$tightTreeRanker(g);
            break;
        case "longest-path":
            $cbd7b02ec197fd8b$var$longestPathRanker(g);
            break;
        default:
            $cbd7b02ec197fd8b$var$networkSimplexRanker(g);
    }
}
// A fast and simple ranker, but results are far from optimal.
var $cbd7b02ec197fd8b$var$longestPathRanker = $cbd7b02ec197fd8b$var$longestPath;
function $cbd7b02ec197fd8b$var$tightTreeRanker(g) {
    $cbd7b02ec197fd8b$var$longestPath(g);
    $8eEo6(g);
}
function $cbd7b02ec197fd8b$var$networkSimplexRanker(g) {
    $fT8MR(g);
}

});
parcelRegister("7JZFZ", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = {
    longestPath: $5a2c9402b96e1199$var$longestPath,
    slack: $5a2c9402b96e1199$var$slack
};
/*
 * Initializes ranks for the input graph using the longest path algorithm. This
 * algorithm scales well and is fast in practice, it yields rather poor
 * solutions. Nodes are pushed to the lowest layer possible, leaving the bottom
 * ranks wide and leaving edges longer than necessary. However, due to its
 * speed, this algorithm is good for getting an initial ranking that can be fed
 * into other algorithms.
 *
 * This algorithm does not normalize layers because it will be used by other
 * algorithms in most cases. If using this algorithm directly, be sure to
 * run normalize at the end.
 *
 * Pre-conditions:
 *
 *    1. Input graph is a DAG.
 *    2. Input graph node labels can be assigned properties.
 *
 * Post-conditions:
 *
 *    1. Each node will be assign an (unnormalized) "rank" property.
 */ function $5a2c9402b96e1199$var$longestPath(g) {
    var visited = {};
    function dfs(v) {
        var label = g.node(v);
        if ($bqfL5.has(visited, v)) return label.rank;
        visited[v] = true;
        var rank = $bqfL5.min($bqfL5.map(g.outEdges(v), function(e) {
            return dfs(e.w) - g.edge(e).minlen;
        }));
        if (rank === Number.POSITIVE_INFINITY || // return value of _.map([]) for Lodash 3
        rank === undefined || // return value of _.map([]) for Lodash 4
        rank === null) rank = 0;
        return label.rank = rank;
    }
    $bqfL5.forEach(g.sources(), dfs);
}
/*
 * Returns the amount of slack for the given edge. The slack is defined as the
 * difference between the length of the edge and its minimum length.
 */ function $5a2c9402b96e1199$var$slack(g, e) {
    return g.node(e.w).rank - g.node(e.v).rank - g.edge(e).minlen;
}

});

parcelRegister("8eEo6", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $5feef5b0afc29ce6$require$Graph = $6mwJ2.Graph;

var $7JZFZ = parcelRequire("7JZFZ");
var $5feef5b0afc29ce6$require$slack = $7JZFZ.slack;
module.exports = $5feef5b0afc29ce6$var$feasibleTree;
/*
 * Constructs a spanning tree with tight edges and adjusted the input node's
 * ranks to achieve this. A tight edge is one that is has a length that matches
 * its "minlen" attribute.
 *
 * The basic structure for this function is derived from Gansner, et al., "A
 * Technique for Drawing Directed Graphs."
 *
 * Pre-conditions:
 *
 *    1. Graph must be a DAG.
 *    2. Graph must be connected.
 *    3. Graph must have at least one node.
 *    5. Graph nodes must have been previously assigned a "rank" property that
 *       respects the "minlen" property of incident edges.
 *    6. Graph edges must have a "minlen" property.
 *
 * Post-conditions:
 *
 *    - Graph nodes will have their rank adjusted to ensure that all edges are
 *      tight.
 *
 * Returns a tree (undirected graph) that is constructed using only "tight"
 * edges.
 */ function $5feef5b0afc29ce6$var$feasibleTree(g) {
    var t = new $5feef5b0afc29ce6$require$Graph({
        directed: false
    });
    // Choose arbitrary node from which to start our tree
    var start = g.nodes()[0];
    var size = g.nodeCount();
    t.setNode(start, {});
    var edge, delta;
    while($5feef5b0afc29ce6$var$tightTree(t, g) < size){
        edge = $5feef5b0afc29ce6$var$findMinSlackEdge(t, g);
        delta = t.hasNode(edge.v) ? $5feef5b0afc29ce6$require$slack(g, edge) : -$5feef5b0afc29ce6$require$slack(g, edge);
        $5feef5b0afc29ce6$var$shiftRanks(t, g, delta);
    }
    return t;
}
/*
 * Finds a maximal tree of tight edges and returns the number of nodes in the
 * tree.
 */ function $5feef5b0afc29ce6$var$tightTree(t, g) {
    function dfs(v) {
        $bqfL5.forEach(g.nodeEdges(v), function(e) {
            var edgeV = e.v, w = v === edgeV ? e.w : edgeV;
            if (!t.hasNode(w) && !$5feef5b0afc29ce6$require$slack(g, e)) {
                t.setNode(w, {});
                t.setEdge(v, w, {});
                dfs(w);
            }
        });
    }
    $bqfL5.forEach(t.nodes(), dfs);
    return t.nodeCount();
}
/*
 * Finds the edge with the smallest slack that is incident on tree and returns
 * it.
 */ function $5feef5b0afc29ce6$var$findMinSlackEdge(t, g) {
    return $bqfL5.minBy(g.edges(), function(e) {
        if (t.hasNode(e.v) !== t.hasNode(e.w)) return $5feef5b0afc29ce6$require$slack(g, e);
    });
}
function $5feef5b0afc29ce6$var$shiftRanks(t, g, delta) {
    $bqfL5.forEach(t.nodes(), function(v) {
        g.node(v).rank += delta;
    });
}

});

parcelRegister("fT8MR", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $8eEo6 = parcelRequire("8eEo6");

var $7JZFZ = parcelRequire("7JZFZ");
var $b912cf006614473d$require$slack = $7JZFZ.slack;

var $7JZFZ = parcelRequire("7JZFZ");
var $b912cf006614473d$require$initRank = $7JZFZ.longestPath;

var $b912cf006614473d$var$preorder = (parcelRequire("6mwJ2")).alg.preorder;

var $b912cf006614473d$var$postorder = (parcelRequire("6mwJ2")).alg.postorder;

var $1kMKg = parcelRequire("1kMKg");
var $b912cf006614473d$require$simplify = $1kMKg.simplify;
module.exports = $b912cf006614473d$var$networkSimplex;
// Expose some internals for testing purposes
$b912cf006614473d$var$networkSimplex.initLowLimValues = $b912cf006614473d$var$initLowLimValues;
$b912cf006614473d$var$networkSimplex.initCutValues = $b912cf006614473d$var$initCutValues;
$b912cf006614473d$var$networkSimplex.calcCutValue = $b912cf006614473d$var$calcCutValue;
$b912cf006614473d$var$networkSimplex.leaveEdge = $b912cf006614473d$var$leaveEdge;
$b912cf006614473d$var$networkSimplex.enterEdge = $b912cf006614473d$var$enterEdge;
$b912cf006614473d$var$networkSimplex.exchangeEdges = $b912cf006614473d$var$exchangeEdges;
/*
 * The network simplex algorithm assigns ranks to each node in the input graph
 * and iteratively improves the ranking to reduce the length of edges.
 *
 * Preconditions:
 *
 *    1. The input graph must be a DAG.
 *    2. All nodes in the graph must have an object value.
 *    3. All edges in the graph must have "minlen" and "weight" attributes.
 *
 * Postconditions:
 *
 *    1. All nodes in the graph will have an assigned "rank" attribute that has
 *       been optimized by the network simplex algorithm. Ranks start at 0.
 *
 *
 * A rough sketch of the algorithm is as follows:
 *
 *    1. Assign initial ranks to each node. We use the longest path algorithm,
 *       which assigns ranks to the lowest position possible. In general this
 *       leads to very wide bottom ranks and unnecessarily long edges.
 *    2. Construct a feasible tight tree. A tight tree is one such that all
 *       edges in the tree have no slack (difference between length of edge
 *       and minlen for the edge). This by itself greatly improves the assigned
 *       rankings by shorting edges.
 *    3. Iteratively find edges that have negative cut values. Generally a
 *       negative cut value indicates that the edge could be removed and a new
 *       tree edge could be added to produce a more compact graph.
 *
 * Much of the algorithms here are derived from Gansner, et al., "A Technique
 * for Drawing Directed Graphs." The structure of the file roughly follows the
 * structure of the overall algorithm.
 */ function $b912cf006614473d$var$networkSimplex(g) {
    g = $b912cf006614473d$require$simplify(g);
    $b912cf006614473d$require$initRank(g);
    var t = $8eEo6(g);
    $b912cf006614473d$var$initLowLimValues(t);
    $b912cf006614473d$var$initCutValues(t, g);
    var e, f;
    while(e = $b912cf006614473d$var$leaveEdge(t)){
        f = $b912cf006614473d$var$enterEdge(t, g, e);
        $b912cf006614473d$var$exchangeEdges(t, g, e, f);
    }
}
/*
 * Initializes cut values for all edges in the tree.
 */ function $b912cf006614473d$var$initCutValues(t, g) {
    var vs = $b912cf006614473d$var$postorder(t, t.nodes());
    vs = vs.slice(0, vs.length - 1);
    $bqfL5.forEach(vs, function(v) {
        $b912cf006614473d$var$assignCutValue(t, g, v);
    });
}
function $b912cf006614473d$var$assignCutValue(t, g, child) {
    var childLab = t.node(child);
    var parent = childLab.parent;
    t.edge(child, parent).cutvalue = $b912cf006614473d$var$calcCutValue(t, g, child);
}
/*
 * Given the tight tree, its graph, and a child in the graph calculate and
 * return the cut value for the edge between the child and its parent.
 */ function $b912cf006614473d$var$calcCutValue(t, g, child) {
    var childLab = t.node(child);
    var parent = childLab.parent;
    // True if the child is on the tail end of the edge in the directed graph
    var childIsTail = true;
    // The graph's view of the tree edge we're inspecting
    var graphEdge = g.edge(child, parent);
    // The accumulated cut value for the edge between this node and its parent
    var cutValue = 0;
    if (!graphEdge) {
        childIsTail = false;
        graphEdge = g.edge(parent, child);
    }
    cutValue = graphEdge.weight;
    $bqfL5.forEach(g.nodeEdges(child), function(e) {
        var isOutEdge = e.v === child, other = isOutEdge ? e.w : e.v;
        if (other !== parent) {
            var pointsToHead = isOutEdge === childIsTail, otherWeight = g.edge(e).weight;
            cutValue += pointsToHead ? otherWeight : -otherWeight;
            if ($b912cf006614473d$var$isTreeEdge(t, child, other)) {
                var otherCutValue = t.edge(child, other).cutvalue;
                cutValue += pointsToHead ? -otherCutValue : otherCutValue;
            }
        }
    });
    return cutValue;
}
function $b912cf006614473d$var$initLowLimValues(tree, root) {
    if (arguments.length < 2) root = tree.nodes()[0];
    $b912cf006614473d$var$dfsAssignLowLim(tree, {}, 1, root);
}
function $b912cf006614473d$var$dfsAssignLowLim(tree, visited, nextLim, v, parent) {
    var low = nextLim;
    var label = tree.node(v);
    visited[v] = true;
    $bqfL5.forEach(tree.neighbors(v), function(w) {
        if (!$bqfL5.has(visited, w)) nextLim = $b912cf006614473d$var$dfsAssignLowLim(tree, visited, nextLim, w, v);
    });
    label.low = low;
    label.lim = nextLim++;
    if (parent) label.parent = parent;
    else // TODO should be able to remove this when we incrementally update low lim
    delete label.parent;
    return nextLim;
}
function $b912cf006614473d$var$leaveEdge(tree) {
    return $bqfL5.find(tree.edges(), function(e) {
        return tree.edge(e).cutvalue < 0;
    });
}
function $b912cf006614473d$var$enterEdge(t, g, edge) {
    var v = edge.v;
    var w = edge.w;
    // For the rest of this function we assume that v is the tail and w is the
    // head, so if we don't have this edge in the graph we should flip it to
    // match the correct orientation.
    if (!g.hasEdge(v, w)) {
        v = edge.w;
        w = edge.v;
    }
    var vLabel = t.node(v);
    var wLabel = t.node(w);
    var tailLabel = vLabel;
    var flip = false;
    // If the root is in the tail of the edge then we need to flip the logic that
    // checks for the head and tail nodes in the candidates function below.
    if (vLabel.lim > wLabel.lim) {
        tailLabel = wLabel;
        flip = true;
    }
    var candidates = $bqfL5.filter(g.edges(), function(edge) {
        return flip === $b912cf006614473d$var$isDescendant(t, t.node(edge.v), tailLabel) && flip !== $b912cf006614473d$var$isDescendant(t, t.node(edge.w), tailLabel);
    });
    return $bqfL5.minBy(candidates, function(edge) {
        return $b912cf006614473d$require$slack(g, edge);
    });
}
function $b912cf006614473d$var$exchangeEdges(t, g, e, f) {
    var v = e.v;
    var w = e.w;
    t.removeEdge(v, w);
    t.setEdge(f.v, f.w, {});
    $b912cf006614473d$var$initLowLimValues(t);
    $b912cf006614473d$var$initCutValues(t, g);
    $b912cf006614473d$var$updateRanks(t, g);
}
function $b912cf006614473d$var$updateRanks(t, g) {
    var root = $bqfL5.find(t.nodes(), function(v) {
        return !g.node(v).parent;
    });
    var vs = $b912cf006614473d$var$preorder(t, root);
    vs = vs.slice(1);
    $bqfL5.forEach(vs, function(v) {
        var parent = t.node(v).parent, edge = g.edge(v, parent), flipped = false;
        if (!edge) {
            edge = g.edge(parent, v);
            flipped = true;
        }
        g.node(v).rank = g.node(parent).rank + (flipped ? edge.minlen : -edge.minlen);
    });
}
/*
 * Returns true if the edge is in the tree.
 */ function $b912cf006614473d$var$isTreeEdge(tree, u, v) {
    return tree.hasEdge(u, v);
}
/*
 * Returns true if the specified node is descendant of the root node per the
 * assigned low and lim attributes in the tree.
 */ function $b912cf006614473d$var$isDescendant(tree, vLabel, rootLabel) {
    return rootLabel.low <= vLabel.lim && vLabel.lim <= rootLabel.lim;
}

});


parcelRegister("eBG2O", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $aa252286d7a30ca5$var$parentDummyChains;
function $aa252286d7a30ca5$var$parentDummyChains(g) {
    var postorderNums = $aa252286d7a30ca5$var$postorder(g);
    $bqfL5.forEach(g.graph().dummyChains, function(v) {
        var node = g.node(v);
        var edgeObj = node.edgeObj;
        var pathData = $aa252286d7a30ca5$var$findPath(g, postorderNums, edgeObj.v, edgeObj.w);
        var path = pathData.path;
        var lca = pathData.lca;
        var pathIdx = 0;
        var pathV = path[pathIdx];
        var ascending = true;
        while(v !== edgeObj.w){
            node = g.node(v);
            if (ascending) {
                while((pathV = path[pathIdx]) !== lca && g.node(pathV).maxRank < node.rank)pathIdx++;
                if (pathV === lca) ascending = false;
            }
            if (!ascending) {
                while(pathIdx < path.length - 1 && g.node(pathV = path[pathIdx + 1]).minRank <= node.rank)pathIdx++;
                pathV = path[pathIdx];
            }
            g.setParent(v, pathV);
            v = g.successors(v)[0];
        }
    });
}
// Find a path from v to w through the lowest common ancestor (LCA). Return the
// full path and the LCA.
function $aa252286d7a30ca5$var$findPath(g, postorderNums, v, w) {
    var vPath = [];
    var wPath = [];
    var low = Math.min(postorderNums[v].low, postorderNums[w].low);
    var lim = Math.max(postorderNums[v].lim, postorderNums[w].lim);
    var parent;
    var lca;
    // Traverse up from v to find the LCA
    parent = v;
    do {
        parent = g.parent(parent);
        vPath.push(parent);
    }while (parent && (postorderNums[parent].low > low || lim > postorderNums[parent].lim));
    lca = parent;
    // Traverse from w to LCA
    parent = w;
    while((parent = g.parent(parent)) !== lca)wPath.push(parent);
    return {
        path: vPath.concat(wPath.reverse()),
        lca: lca
    };
}
function $aa252286d7a30ca5$var$postorder(g) {
    var result = {};
    var lim = 0;
    function dfs(v) {
        var low = lim;
        $bqfL5.forEach(g.children(v), dfs);
        result[v] = {
            low: low,
            lim: lim++
        };
    }
    $bqfL5.forEach(g.children(), dfs);
    return result;
}

});

parcelRegister("YdQc0", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = {
    run: $0b5057358d9c05c8$var$run,
    cleanup: $0b5057358d9c05c8$var$cleanup
};
/*
 * A nesting graph creates dummy nodes for the tops and bottoms of subgraphs,
 * adds appropriate edges to ensure that all cluster nodes are placed between
 * these boundries, and ensures that the graph is connected.
 *
 * In addition we ensure, through the use of the minlen property, that nodes
 * and subgraph border nodes to not end up on the same rank.
 *
 * Preconditions:
 *
 *    1. Input graph is a DAG
 *    2. Nodes in the input graph has a minlen attribute
 *
 * Postconditions:
 *
 *    1. Input graph is connected.
 *    2. Dummy nodes are added for the tops and bottoms of subgraphs.
 *    3. The minlen attribute for nodes is adjusted to ensure nodes do not
 *       get placed on the same rank as subgraph border nodes.
 *
 * The nesting graph idea comes from Sander, "Layout of Compound Directed
 * Graphs."
 */ function $0b5057358d9c05c8$var$run(g) {
    var root = $1kMKg.addDummyNode(g, "root", {}, "_root");
    var depths = $0b5057358d9c05c8$var$treeDepths(g);
    var height = $bqfL5.max($bqfL5.values(depths)) - 1; // Note: depths is an Object not an array
    var nodeSep = 2 * height + 1;
    g.graph().nestingRoot = root;
    // Multiply minlen by nodeSep to align nodes on non-border ranks.
    $bqfL5.forEach(g.edges(), function(e) {
        g.edge(e).minlen *= nodeSep;
    });
    // Calculate a weight that is sufficient to keep subgraphs vertically compact
    var weight = $0b5057358d9c05c8$var$sumWeights(g) + 1;
    // Create border nodes and link them up
    $bqfL5.forEach(g.children(), function(child) {
        $0b5057358d9c05c8$var$dfs(g, root, nodeSep, weight, height, depths, child);
    });
    // Save the multiplier for node layers for later removal of empty border
    // layers.
    g.graph().nodeRankFactor = nodeSep;
}
function $0b5057358d9c05c8$var$dfs(g, root, nodeSep, weight, height, depths, v) {
    var children = g.children(v);
    if (!children.length) {
        if (v !== root) g.setEdge(root, v, {
            weight: 0,
            minlen: nodeSep
        });
        return;
    }
    var top = $1kMKg.addBorderNode(g, "_bt");
    var bottom = $1kMKg.addBorderNode(g, "_bb");
    var label = g.node(v);
    g.setParent(top, v);
    label.borderTop = top;
    g.setParent(bottom, v);
    label.borderBottom = bottom;
    $bqfL5.forEach(children, function(child) {
        $0b5057358d9c05c8$var$dfs(g, root, nodeSep, weight, height, depths, child);
        var childNode = g.node(child);
        var childTop = childNode.borderTop ? childNode.borderTop : child;
        var childBottom = childNode.borderBottom ? childNode.borderBottom : child;
        var thisWeight = childNode.borderTop ? weight : 2 * weight;
        var minlen = childTop !== childBottom ? 1 : height - depths[v] + 1;
        g.setEdge(top, childTop, {
            weight: thisWeight,
            minlen: minlen,
            nestingEdge: true
        });
        g.setEdge(childBottom, bottom, {
            weight: thisWeight,
            minlen: minlen,
            nestingEdge: true
        });
    });
    if (!g.parent(v)) g.setEdge(root, top, {
        weight: 0,
        minlen: height + depths[v]
    });
}
function $0b5057358d9c05c8$var$treeDepths(g) {
    var depths = {};
    function dfs(v, depth) {
        var children = g.children(v);
        if (children && children.length) $bqfL5.forEach(children, function(child) {
            dfs(child, depth + 1);
        });
        depths[v] = depth;
    }
    $bqfL5.forEach(g.children(), function(v) {
        dfs(v, 1);
    });
    return depths;
}
function $0b5057358d9c05c8$var$sumWeights(g) {
    return $bqfL5.reduce(g.edges(), function(acc, e) {
        return acc + g.edge(e).weight;
    }, 0);
}
function $0b5057358d9c05c8$var$cleanup(g) {
    var graphLabel = g.graph();
    g.removeNode(graphLabel.nestingRoot);
    delete graphLabel.nestingRoot;
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        if (edge.nestingEdge) g.removeEdge(e);
    });
}

});

parcelRegister("fSZns", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = $b90b826f4fed8d23$var$addBorderSegments;
function $b90b826f4fed8d23$var$addBorderSegments(g) {
    function dfs(v) {
        var children = g.children(v);
        var node = g.node(v);
        if (children.length) $bqfL5.forEach(children, dfs);
        if ($bqfL5.has(node, "minRank")) {
            node.borderLeft = [];
            node.borderRight = [];
            for(var rank = node.minRank, maxRank = node.maxRank + 1; rank < maxRank; ++rank){
                $b90b826f4fed8d23$var$addBorderNode(g, "borderLeft", "_bl", v, node, rank);
                $b90b826f4fed8d23$var$addBorderNode(g, "borderRight", "_br", v, node, rank);
            }
        }
    }
    $bqfL5.forEach(g.children(), dfs);
}
function $b90b826f4fed8d23$var$addBorderNode(g, prop, prefix, sg, sgNode, rank) {
    var label = {
        width: 0,
        height: 0,
        rank: rank,
        borderType: prop
    };
    var prev = sgNode[prop][rank - 1];
    var curr = $1kMKg.addDummyNode(g, "border", label, prefix);
    sgNode[prop][rank] = curr;
    g.setParent(curr, sg);
    if (prev) g.setEdge(prev, curr, {
        weight: 1
    });
}

});

parcelRegister("lWVsJ", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = {
    adjust: $ffab96934221be07$var$adjust,
    undo: $ffab96934221be07$var$undo
};
function $ffab96934221be07$var$adjust(g) {
    var rankDir = g.graph().rankdir.toLowerCase();
    if (rankDir === "lr" || rankDir === "rl") $ffab96934221be07$var$swapWidthHeight(g);
}
function $ffab96934221be07$var$undo(g) {
    var rankDir = g.graph().rankdir.toLowerCase();
    if (rankDir === "bt" || rankDir === "rl") $ffab96934221be07$var$reverseY(g);
    if (rankDir === "lr" || rankDir === "rl") {
        $ffab96934221be07$var$swapXY(g);
        $ffab96934221be07$var$swapWidthHeight(g);
    }
}
function $ffab96934221be07$var$swapWidthHeight(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        $ffab96934221be07$var$swapWidthHeightOne(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        $ffab96934221be07$var$swapWidthHeightOne(g.edge(e));
    });
}
function $ffab96934221be07$var$swapWidthHeightOne(attrs) {
    var w = attrs.width;
    attrs.width = attrs.height;
    attrs.height = w;
}
function $ffab96934221be07$var$reverseY(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        $ffab96934221be07$var$reverseYOne(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        $bqfL5.forEach(edge.points, $ffab96934221be07$var$reverseYOne);
        if ($bqfL5.has(edge, "y")) $ffab96934221be07$var$reverseYOne(edge);
    });
}
function $ffab96934221be07$var$reverseYOne(attrs) {
    attrs.y = -attrs.y;
}
function $ffab96934221be07$var$swapXY(g) {
    $bqfL5.forEach(g.nodes(), function(v) {
        $ffab96934221be07$var$swapXYOne(g.node(v));
    });
    $bqfL5.forEach(g.edges(), function(e) {
        var edge = g.edge(e);
        $bqfL5.forEach(edge.points, $ffab96934221be07$var$swapXYOne);
        if ($bqfL5.has(edge, "x")) $ffab96934221be07$var$swapXYOne(edge);
    });
}
function $ffab96934221be07$var$swapXYOne(attrs) {
    var x = attrs.x;
    attrs.x = attrs.y;
    attrs.y = x;
}

});

parcelRegister("3dyGB", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $7H72Y = parcelRequire("7H72Y");

var $lesrU = parcelRequire("lesrU");

var $3CKyT = parcelRequire("3CKyT");

var $lvOrT = parcelRequire("lvOrT");

var $7mMpT = parcelRequire("7mMpT");

var $6mwJ2 = parcelRequire("6mwJ2");
var $257d7deb0180286c$require$Graph = $6mwJ2.Graph;

var $1kMKg = parcelRequire("1kMKg");
module.exports = $257d7deb0180286c$var$order;
/*
 * Applies heuristics to minimize edge crossings in the graph and sets the best
 * order solution as an order attribute on each node.
 *
 * Pre-conditions:
 *
 *    1. Graph must be DAG
 *    2. Graph nodes must be objects with a "rank" attribute
 *    3. Graph edges must have the "weight" attribute
 *
 * Post-conditions:
 *
 *    1. Graph nodes will have an "order" attribute based on the results of the
 *       algorithm.
 */ function $257d7deb0180286c$var$order(g) {
    var maxRank = $1kMKg.maxRank(g), downLayerGraphs = $257d7deb0180286c$var$buildLayerGraphs(g, $bqfL5.range(1, maxRank + 1), "inEdges"), upLayerGraphs = $257d7deb0180286c$var$buildLayerGraphs(g, $bqfL5.range(maxRank - 1, -1, -1), "outEdges");
    var layering = $7H72Y(g);
    $257d7deb0180286c$var$assignOrder(g, layering);
    var bestCC = Number.POSITIVE_INFINITY, best;
    for(var i = 0, lastBest = 0; lastBest < 4; ++i, ++lastBest){
        $257d7deb0180286c$var$sweepLayerGraphs(i % 2 ? downLayerGraphs : upLayerGraphs, i % 4 >= 2);
        layering = $1kMKg.buildLayerMatrix(g);
        var cc = $lesrU(g, layering);
        if (cc < bestCC) {
            lastBest = 0;
            best = $bqfL5.cloneDeep(layering);
            bestCC = cc;
        }
    }
    $257d7deb0180286c$var$assignOrder(g, best);
}
function $257d7deb0180286c$var$buildLayerGraphs(g, ranks, relationship) {
    return $bqfL5.map(ranks, function(rank) {
        return $lvOrT(g, rank, relationship);
    });
}
function $257d7deb0180286c$var$sweepLayerGraphs(layerGraphs, biasRight) {
    var cg = new $257d7deb0180286c$require$Graph();
    $bqfL5.forEach(layerGraphs, function(lg) {
        var root = lg.graph().root;
        var sorted = $3CKyT(lg, root, cg, biasRight);
        $bqfL5.forEach(sorted.vs, function(v, i) {
            lg.node(v).order = i;
        });
        $7mMpT(lg, cg, sorted.vs);
    });
}
function $257d7deb0180286c$var$assignOrder(g, layering) {
    $bqfL5.forEach(layering, function(layer) {
        $bqfL5.forEach(layer, function(v, i) {
            g.node(v).order = i;
        });
    });
}

});
parcelRegister("7H72Y", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $59a203f227f1c21c$var$initOrder;
/*
 * Assigns an initial order value for each node by performing a DFS search
 * starting from nodes in the first rank. Nodes are assigned an order in their
 * rank as they are first visited.
 *
 * This approach comes from Gansner, et al., "A Technique for Drawing Directed
 * Graphs."
 *
 * Returns a layering matrix with an array per layer and each layer sorted by
 * the order of its nodes.
 */ function $59a203f227f1c21c$var$initOrder(g) {
    var visited = {};
    var simpleNodes = $bqfL5.filter(g.nodes(), function(v) {
        return !g.children(v).length;
    });
    var maxRank = $bqfL5.max($bqfL5.map(simpleNodes, function(v) {
        return g.node(v).rank;
    }));
    var layers = $bqfL5.map($bqfL5.range(maxRank + 1), function() {
        return [];
    });
    function dfs(v) {
        if ($bqfL5.has(visited, v)) return;
        visited[v] = true;
        var node = g.node(v);
        layers[node.rank].push(v);
        $bqfL5.forEach(g.successors(v), dfs);
    }
    var orderedVs = $bqfL5.sortBy(simpleNodes, function(v) {
        return g.node(v).rank;
    });
    $bqfL5.forEach(orderedVs, dfs);
    return layers;
}

});

parcelRegister("lesrU", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $f750f92bb92fe0f2$var$crossCount;
/*
 * A function that takes a layering (an array of layers, each with an array of
 * ordererd nodes) and a graph and returns a weighted crossing count.
 *
 * Pre-conditions:
 *
 *    1. Input graph must be simple (not a multigraph), directed, and include
 *       only simple edges.
 *    2. Edges in the input graph must have assigned weights.
 *
 * Post-conditions:
 *
 *    1. The graph and layering matrix are left unchanged.
 *
 * This algorithm is derived from Barth, et al., "Bilayer Cross Counting."
 */ function $f750f92bb92fe0f2$var$crossCount(g, layering) {
    var cc = 0;
    for(var i = 1; i < layering.length; ++i)cc += $f750f92bb92fe0f2$var$twoLayerCrossCount(g, layering[i - 1], layering[i]);
    return cc;
}
function $f750f92bb92fe0f2$var$twoLayerCrossCount(g, northLayer, southLayer) {
    // Sort all of the edges between the north and south layers by their position
    // in the north layer and then the south. Map these edges to the position of
    // their head in the south layer.
    var southPos = $bqfL5.zipObject(southLayer, $bqfL5.map(southLayer, function(v, i) {
        return i;
    }));
    var southEntries = $bqfL5.flatten($bqfL5.map(northLayer, function(v) {
        return $bqfL5.sortBy($bqfL5.map(g.outEdges(v), function(e) {
            return {
                pos: southPos[e.w],
                weight: g.edge(e).weight
            };
        }), "pos");
    }), true);
    // Build the accumulator tree
    var firstIndex = 1;
    while(firstIndex < southLayer.length)firstIndex <<= 1;
    var treeSize = 2 * firstIndex - 1;
    firstIndex -= 1;
    var tree = $bqfL5.map(new Array(treeSize), function() {
        return 0;
    });
    // Calculate the weighted crossings
    var cc = 0;
    $bqfL5.forEach(southEntries.forEach(function(entry) {
        var index = entry.pos + firstIndex;
        tree[index] += entry.weight;
        var weightSum = 0;
        while(index > 0){
            if (index % 2) weightSum += tree[index + 1];
            index = index - 1 >> 1;
            tree[index] += entry.weight;
        }
        cc += entry.weight * weightSum;
    }));
    return cc;
}

});

parcelRegister("3CKyT", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $6dVLr = parcelRequire("6dVLr");

var $7P6no = parcelRequire("7P6no");

var $6WEME = parcelRequire("6WEME");
module.exports = $2a3909eacdbc5484$var$sortSubgraph;
function $2a3909eacdbc5484$var$sortSubgraph(g, v, cg, biasRight) {
    var movable = g.children(v);
    var node = g.node(v);
    var bl = node ? node.borderLeft : undefined;
    var br = node ? node.borderRight : undefined;
    var subgraphs = {};
    if (bl) movable = $bqfL5.filter(movable, function(w) {
        return w !== bl && w !== br;
    });
    var barycenters = $6dVLr(g, movable);
    $bqfL5.forEach(barycenters, function(entry) {
        if (g.children(entry.v).length) {
            var subgraphResult = $2a3909eacdbc5484$var$sortSubgraph(g, entry.v, cg, biasRight);
            subgraphs[entry.v] = subgraphResult;
            if ($bqfL5.has(subgraphResult, "barycenter")) $2a3909eacdbc5484$var$mergeBarycenters(entry, subgraphResult);
        }
    });
    var entries = $7P6no(barycenters, cg);
    $2a3909eacdbc5484$var$expandSubgraphs(entries, subgraphs);
    var result = $6WEME(entries, biasRight);
    if (bl) {
        result.vs = $bqfL5.flatten([
            bl,
            result.vs,
            br
        ], true);
        if (g.predecessors(bl).length) {
            var blPred = g.node(g.predecessors(bl)[0]), brPred = g.node(g.predecessors(br)[0]);
            if (!$bqfL5.has(result, "barycenter")) {
                result.barycenter = 0;
                result.weight = 0;
            }
            result.barycenter = (result.barycenter * result.weight + blPred.order + brPred.order) / (result.weight + 2);
            result.weight += 2;
        }
    }
    return result;
}
function $2a3909eacdbc5484$var$expandSubgraphs(entries, subgraphs) {
    $bqfL5.forEach(entries, function(entry) {
        entry.vs = $bqfL5.flatten(entry.vs.map(function(v) {
            if (subgraphs[v]) return subgraphs[v].vs;
            return v;
        }), true);
    });
}
function $2a3909eacdbc5484$var$mergeBarycenters(target, other) {
    if (!$bqfL5.isUndefined(target.barycenter)) {
        target.barycenter = (target.barycenter * target.weight + other.barycenter * other.weight) / (target.weight + other.weight);
        target.weight += other.weight;
    } else {
        target.barycenter = other.barycenter;
        target.weight = other.weight;
    }
}

});
parcelRegister("6dVLr", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $4880c3b846cacbd2$var$barycenter;
function $4880c3b846cacbd2$var$barycenter(g, movable) {
    return $bqfL5.map(movable, function(v) {
        var inV = g.inEdges(v);
        if (!inV.length) return {
            v: v
        };
        else {
            var result = $bqfL5.reduce(inV, function(acc, e) {
                var edge = g.edge(e), nodeU = g.node(e.v);
                return {
                    sum: acc.sum + edge.weight * nodeU.order,
                    weight: acc.weight + edge.weight
                };
            }, {
                sum: 0,
                weight: 0
            });
            return {
                v: v,
                barycenter: result.sum / result.weight,
                weight: result.weight
            };
        }
    });
}

});

parcelRegister("7P6no", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $5b223e00506bc319$var$resolveConflicts;
/*
 * Given a list of entries of the form {v, barycenter, weight} and a
 * constraint graph this function will resolve any conflicts between the
 * constraint graph and the barycenters for the entries. If the barycenters for
 * an entry would violate a constraint in the constraint graph then we coalesce
 * the nodes in the conflict into a new node that respects the contraint and
 * aggregates barycenter and weight information.
 *
 * This implementation is based on the description in Forster, "A Fast and
 * Simple Hueristic for Constrained Two-Level Crossing Reduction," thought it
 * differs in some specific details.
 *
 * Pre-conditions:
 *
 *    1. Each entry has the form {v, barycenter, weight}, or if the node has
 *       no barycenter, then {v}.
 *
 * Returns:
 *
 *    A new list of entries of the form {vs, i, barycenter, weight}. The list
 *    `vs` may either be a singleton or it may be an aggregation of nodes
 *    ordered such that they do not violate constraints from the constraint
 *    graph. The property `i` is the lowest original index of any of the
 *    elements in `vs`.
 */ function $5b223e00506bc319$var$resolveConflicts(entries, cg) {
    var mappedEntries = {};
    $bqfL5.forEach(entries, function(entry, i) {
        var tmp = mappedEntries[entry.v] = {
            indegree: 0,
            "in": [],
            out: [],
            vs: [
                entry.v
            ],
            i: i
        };
        if (!$bqfL5.isUndefined(entry.barycenter)) {
            tmp.barycenter = entry.barycenter;
            tmp.weight = entry.weight;
        }
    });
    $bqfL5.forEach(cg.edges(), function(e) {
        var entryV = mappedEntries[e.v];
        var entryW = mappedEntries[e.w];
        if (!$bqfL5.isUndefined(entryV) && !$bqfL5.isUndefined(entryW)) {
            entryW.indegree++;
            entryV.out.push(mappedEntries[e.w]);
        }
    });
    var sourceSet = $bqfL5.filter(mappedEntries, function(entry) {
        return !entry.indegree;
    });
    return $5b223e00506bc319$var$doResolveConflicts(sourceSet);
}
function $5b223e00506bc319$var$doResolveConflicts(sourceSet) {
    var entries = [];
    function handleIn(vEntry) {
        return function(uEntry) {
            if (uEntry.merged) return;
            if ($bqfL5.isUndefined(uEntry.barycenter) || $bqfL5.isUndefined(vEntry.barycenter) || uEntry.barycenter >= vEntry.barycenter) $5b223e00506bc319$var$mergeEntries(vEntry, uEntry);
        };
    }
    function handleOut(vEntry) {
        return function(wEntry) {
            wEntry["in"].push(vEntry);
            if (--wEntry.indegree === 0) sourceSet.push(wEntry);
        };
    }
    while(sourceSet.length){
        var entry = sourceSet.pop();
        entries.push(entry);
        $bqfL5.forEach(entry["in"].reverse(), handleIn(entry));
        $bqfL5.forEach(entry.out, handleOut(entry));
    }
    return $bqfL5.map($bqfL5.filter(entries, function(entry) {
        return !entry.merged;
    }), function(entry) {
        return $bqfL5.pick(entry, [
            "vs",
            "i",
            "barycenter",
            "weight"
        ]);
    });
}
function $5b223e00506bc319$var$mergeEntries(target, source) {
    var sum = 0;
    var weight = 0;
    if (target.weight) {
        sum += target.barycenter * target.weight;
        weight += target.weight;
    }
    if (source.weight) {
        sum += source.barycenter * source.weight;
        weight += source.weight;
    }
    target.vs = source.vs.concat(target.vs);
    target.barycenter = sum / weight;
    target.weight = weight;
    target.i = Math.min(source.i, target.i);
    source.merged = true;
}

});

parcelRegister("6WEME", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");
module.exports = $50e7cbac5d0d1447$var$sort;
function $50e7cbac5d0d1447$var$sort(entries, biasRight) {
    var parts = $1kMKg.partition(entries, function(entry) {
        return $bqfL5.has(entry, "barycenter");
    });
    var sortable = parts.lhs, unsortable = $bqfL5.sortBy(parts.rhs, function(entry) {
        return -entry.i;
    }), vs = [], sum = 0, weight = 0, vsIndex = 0;
    sortable.sort($50e7cbac5d0d1447$var$compareWithBias(!!biasRight));
    vsIndex = $50e7cbac5d0d1447$var$consumeUnsortable(vs, unsortable, vsIndex);
    $bqfL5.forEach(sortable, function(entry) {
        vsIndex += entry.vs.length;
        vs.push(entry.vs);
        sum += entry.barycenter * entry.weight;
        weight += entry.weight;
        vsIndex = $50e7cbac5d0d1447$var$consumeUnsortable(vs, unsortable, vsIndex);
    });
    var result = {
        vs: $bqfL5.flatten(vs, true)
    };
    if (weight) {
        result.barycenter = sum / weight;
        result.weight = weight;
    }
    return result;
}
function $50e7cbac5d0d1447$var$consumeUnsortable(vs, unsortable, index) {
    var last;
    while(unsortable.length && (last = $bqfL5.last(unsortable)).i <= index){
        unsortable.pop();
        vs.push(last.vs);
        index++;
    }
    return index;
}
function $50e7cbac5d0d1447$var$compareWithBias(bias) {
    return function(entryV, entryW) {
        if (entryV.barycenter < entryW.barycenter) return -1;
        else if (entryV.barycenter > entryW.barycenter) return 1;
        return !bias ? entryV.i - entryW.i : entryW.i - entryV.i;
    };
}

});


parcelRegister("lvOrT", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $fa93a057a2513c66$require$Graph = $6mwJ2.Graph;
module.exports = $fa93a057a2513c66$var$buildLayerGraph;
/*
 * Constructs a graph that can be used to sort a layer of nodes. The graph will
 * contain all base and subgraph nodes from the request layer in their original
 * hierarchy and any edges that are incident on these nodes and are of the type
 * requested by the "relationship" parameter.
 *
 * Nodes from the requested rank that do not have parents are assigned a root
 * node in the output graph, which is set in the root graph attribute. This
 * makes it easy to walk the hierarchy of movable nodes during ordering.
 *
 * Pre-conditions:
 *
 *    1. Input graph is a DAG
 *    2. Base nodes in the input graph have a rank attribute
 *    3. Subgraph nodes in the input graph has minRank and maxRank attributes
 *    4. Edges have an assigned weight
 *
 * Post-conditions:
 *
 *    1. Output graph has all nodes in the movable rank with preserved
 *       hierarchy.
 *    2. Root nodes in the movable layer are made children of the node
 *       indicated by the root attribute of the graph.
 *    3. Non-movable nodes incident on movable nodes, selected by the
 *       relationship parameter, are included in the graph (without hierarchy).
 *    4. Edges incident on movable nodes, selected by the relationship
 *       parameter, are added to the output graph.
 *    5. The weights for copied edges are aggregated as need, since the output
 *       graph is not a multi-graph.
 */ function $fa93a057a2513c66$var$buildLayerGraph(g, rank, relationship) {
    var root = $fa93a057a2513c66$var$createRootNode(g), result = new $fa93a057a2513c66$require$Graph({
        compound: true
    }).setGraph({
        root: root
    }).setDefaultNodeLabel(function(v) {
        return g.node(v);
    });
    $bqfL5.forEach(g.nodes(), function(v) {
        var node = g.node(v), parent = g.parent(v);
        if (node.rank === rank || node.minRank <= rank && rank <= node.maxRank) {
            result.setNode(v);
            result.setParent(v, parent || root);
            // This assumes we have only short edges!
            $bqfL5.forEach(g[relationship](v), function(e) {
                var u = e.v === v ? e.w : e.v, edge = result.edge(u, v), weight = !$bqfL5.isUndefined(edge) ? edge.weight : 0;
                result.setEdge(u, v, {
                    weight: g.edge(e).weight + weight
                });
            });
            if ($bqfL5.has(node, "minRank")) result.setNode(v, {
                borderLeft: node.borderLeft[rank],
                borderRight: node.borderRight[rank]
            });
        }
    });
    return result;
}
function $fa93a057a2513c66$var$createRootNode(g) {
    var v;
    while(g.hasNode(v = $bqfL5.uniqueId("_root")));
    return v;
}

});

parcelRegister("7mMpT", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");
module.exports = $55d025054c74605a$var$addSubgraphConstraints;
function $55d025054c74605a$var$addSubgraphConstraints(g, cg, vs) {
    var prev = {}, rootPrev;
    $bqfL5.forEach(vs, function(v) {
        var child = g.parent(v), parent, prevChild;
        while(child){
            parent = g.parent(child);
            if (parent) {
                prevChild = prev[parent];
                prev[parent] = child;
            } else {
                prevChild = rootPrev;
                rootPrev = child;
            }
            if (prevChild && prevChild !== child) {
                cg.setEdge(prevChild, child);
                return;
            }
            child = parent;
        }
    });
/*
  function dfs(v) {
    var children = v ? g.children(v) : g.children();
    if (children.length) {
      var min = Number.POSITIVE_INFINITY,
          subgraphs = [];
      _.each(children, function(child) {
        var childMin = dfs(child);
        if (g.children(child).length) {
          subgraphs.push({ v: child, order: childMin });
        }
        min = Math.min(min, childMin);
      });
      _.reduce(_.sortBy(subgraphs, "order"), function(prev, curr) {
        cg.setEdge(prev.v, curr.v);
        return curr;
      });
      return min;
    }
    return g.node(v).order;
  }
  dfs(undefined);
  */ }

});


parcelRegister("j257S", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");

var $94mUQ = parcelRequire("94mUQ");
var $ddb22e2223075eef$require$positionX = $94mUQ.positionX;
module.exports = $ddb22e2223075eef$var$position;
function $ddb22e2223075eef$var$position(g) {
    g = $1kMKg.asNonCompoundGraph(g);
    $ddb22e2223075eef$var$positionY(g);
    $bqfL5.forEach($ddb22e2223075eef$require$positionX(g), function(x, v) {
        g.node(v).x = x;
    });
}
function $ddb22e2223075eef$var$positionY(g) {
    var layering = $1kMKg.buildLayerMatrix(g);
    var rankSep = g.graph().ranksep;
    var prevY = 0;
    $bqfL5.forEach(layering, function(layer) {
        var maxHeight = $bqfL5.max($bqfL5.map(layer, function(v) {
            return g.node(v).height;
        }));
        $bqfL5.forEach(layer, function(v) {
            g.node(v).y = prevY + maxHeight / 2;
        });
        prevY += maxHeight + rankSep;
    });
}

});
parcelRegister("94mUQ", function(module, exports) {
"use strict";

var $bqfL5 = parcelRequire("bqfL5");

var $6mwJ2 = parcelRequire("6mwJ2");
var $69a6435f926c5c17$require$Graph = $6mwJ2.Graph;

var $1kMKg = parcelRequire("1kMKg");
/*
 * This module provides coordinate assignment based on Brandes and Köpf, "Fast
 * and Simple Horizontal Coordinate Assignment."
 */ module.exports = {
    positionX: $69a6435f926c5c17$var$positionX,
    findType1Conflicts: $69a6435f926c5c17$var$findType1Conflicts,
    findType2Conflicts: $69a6435f926c5c17$var$findType2Conflicts,
    addConflict: $69a6435f926c5c17$var$addConflict,
    hasConflict: $69a6435f926c5c17$var$hasConflict,
    verticalAlignment: $69a6435f926c5c17$var$verticalAlignment,
    horizontalCompaction: $69a6435f926c5c17$var$horizontalCompaction,
    alignCoordinates: $69a6435f926c5c17$var$alignCoordinates,
    findSmallestWidthAlignment: $69a6435f926c5c17$var$findSmallestWidthAlignment,
    balance: $69a6435f926c5c17$var$balance
};
/*
 * Marks all edges in the graph with a type-1 conflict with the "type1Conflict"
 * property. A type-1 conflict is one where a non-inner segment crosses an
 * inner segment. An inner segment is an edge with both incident nodes marked
 * with the "dummy" property.
 *
 * This algorithm scans layer by layer, starting with the second, for type-1
 * conflicts between the current layer and the previous layer. For each layer
 * it scans the nodes from left to right until it reaches one that is incident
 * on an inner segment. It then scans predecessors to determine if they have
 * edges that cross that inner segment. At the end a final scan is done for all
 * nodes on the current rank to see if they cross the last visited inner
 * segment.
 *
 * This algorithm (safely) assumes that a dummy node will only be incident on a
 * single node in the layers being scanned.
 */ function $69a6435f926c5c17$var$findType1Conflicts(g, layering) {
    var conflicts = {};
    function visitLayer(prevLayer, layer) {
        var // last visited node in the previous layer that is incident on an inner
        // segment.
        k0 = 0, // Tracks the last node in this layer scanned for crossings with a type-1
        // segment.
        scanPos = 0, prevLayerLength = prevLayer.length, lastNode = $bqfL5.last(layer);
        $bqfL5.forEach(layer, function(v, i) {
            var w = $69a6435f926c5c17$var$findOtherInnerSegmentNode(g, v), k1 = w ? g.node(w).order : prevLayerLength;
            if (w || v === lastNode) {
                $bqfL5.forEach(layer.slice(scanPos, i + 1), function(scanNode) {
                    $bqfL5.forEach(g.predecessors(scanNode), function(u) {
                        var uLabel = g.node(u), uPos = uLabel.order;
                        if ((uPos < k0 || k1 < uPos) && !(uLabel.dummy && g.node(scanNode).dummy)) $69a6435f926c5c17$var$addConflict(conflicts, u, scanNode);
                    });
                });
                scanPos = i + 1;
                k0 = k1;
            }
        });
        return layer;
    }
    $bqfL5.reduce(layering, visitLayer);
    return conflicts;
}
function $69a6435f926c5c17$var$findType2Conflicts(g, layering) {
    var conflicts = {};
    function scan(south, southPos, southEnd, prevNorthBorder, nextNorthBorder) {
        var v;
        $bqfL5.forEach($bqfL5.range(southPos, southEnd), function(i) {
            v = south[i];
            if (g.node(v).dummy) $bqfL5.forEach(g.predecessors(v), function(u) {
                var uNode = g.node(u);
                if (uNode.dummy && (uNode.order < prevNorthBorder || uNode.order > nextNorthBorder)) $69a6435f926c5c17$var$addConflict(conflicts, u, v);
            });
        });
    }
    function visitLayer(north, south) {
        var prevNorthPos = -1, nextNorthPos, southPos = 0;
        $bqfL5.forEach(south, function(v, southLookahead) {
            if (g.node(v).dummy === "border") {
                var predecessors = g.predecessors(v);
                if (predecessors.length) {
                    nextNorthPos = g.node(predecessors[0]).order;
                    scan(south, southPos, southLookahead, prevNorthPos, nextNorthPos);
                    southPos = southLookahead;
                    prevNorthPos = nextNorthPos;
                }
            }
            scan(south, southPos, south.length, nextNorthPos, north.length);
        });
        return south;
    }
    $bqfL5.reduce(layering, visitLayer);
    return conflicts;
}
function $69a6435f926c5c17$var$findOtherInnerSegmentNode(g, v) {
    if (g.node(v).dummy) return $bqfL5.find(g.predecessors(v), function(u) {
        return g.node(u).dummy;
    });
}
function $69a6435f926c5c17$var$addConflict(conflicts, v, w) {
    if (v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    var conflictsV = conflicts[v];
    if (!conflictsV) conflicts[v] = conflictsV = {};
    conflictsV[w] = true;
}
function $69a6435f926c5c17$var$hasConflict(conflicts, v, w) {
    if (v > w) {
        var tmp = v;
        v = w;
        w = tmp;
    }
    return $bqfL5.has(conflicts[v], w);
}
/*
 * Try to align nodes into vertical "blocks" where possible. This algorithm
 * attempts to align a node with one of its median neighbors. If the edge
 * connecting a neighbor is a type-1 conflict then we ignore that possibility.
 * If a previous node has already formed a block with a node after the node
 * we're trying to form a block with, we also ignore that possibility - our
 * blocks would be split in that scenario.
 */ function $69a6435f926c5c17$var$verticalAlignment(g, layering, conflicts, neighborFn) {
    var root = {}, align = {}, pos = {};
    // We cache the position here based on the layering because the graph and
    // layering may be out of sync. The layering matrix is manipulated to
    // generate different extreme alignments.
    $bqfL5.forEach(layering, function(layer) {
        $bqfL5.forEach(layer, function(v, order) {
            root[v] = v;
            align[v] = v;
            pos[v] = order;
        });
    });
    $bqfL5.forEach(layering, function(layer) {
        var prevIdx = -1;
        $bqfL5.forEach(layer, function(v) {
            var ws = neighborFn(v);
            if (ws.length) {
                ws = $bqfL5.sortBy(ws, function(w) {
                    return pos[w];
                });
                var mp = (ws.length - 1) / 2;
                for(var i = Math.floor(mp), il = Math.ceil(mp); i <= il; ++i){
                    var w = ws[i];
                    if (align[v] === v && prevIdx < pos[w] && !$69a6435f926c5c17$var$hasConflict(conflicts, v, w)) {
                        align[w] = v;
                        align[v] = root[v] = root[w];
                        prevIdx = pos[w];
                    }
                }
            }
        });
    });
    return {
        root: root,
        align: align
    };
}
function $69a6435f926c5c17$var$horizontalCompaction(g, layering, root, align, reverseSep) {
    // This portion of the algorithm differs from BK due to a number of problems.
    // Instead of their algorithm we construct a new block graph and do two
    // sweeps. The first sweep places blocks with the smallest possible
    // coordinates. The second sweep removes unused space by moving blocks to the
    // greatest coordinates without violating separation.
    var xs = {}, blockG = $69a6435f926c5c17$var$buildBlockGraph(g, layering, root, reverseSep), borderType = reverseSep ? "borderLeft" : "borderRight";
    function iterate(setXsFunc, nextNodesFunc) {
        var stack = blockG.nodes();
        var elem = stack.pop();
        var visited = {};
        while(elem){
            if (visited[elem]) setXsFunc(elem);
            else {
                visited[elem] = true;
                stack.push(elem);
                stack = stack.concat(nextNodesFunc(elem));
            }
            elem = stack.pop();
        }
    }
    // First pass, assign smallest coordinates
    function pass1(elem) {
        xs[elem] = blockG.inEdges(elem).reduce(function(acc, e) {
            return Math.max(acc, xs[e.v] + blockG.edge(e));
        }, 0);
    }
    // Second pass, assign greatest coordinates
    function pass2(elem) {
        var min = blockG.outEdges(elem).reduce(function(acc, e) {
            return Math.min(acc, xs[e.w] - blockG.edge(e));
        }, Number.POSITIVE_INFINITY);
        var node = g.node(elem);
        if (min !== Number.POSITIVE_INFINITY && node.borderType !== borderType) xs[elem] = Math.max(xs[elem], min);
    }
    iterate(pass1, blockG.predecessors.bind(blockG));
    iterate(pass2, blockG.successors.bind(blockG));
    // Assign x coordinates to all nodes
    $bqfL5.forEach(align, function(v) {
        xs[v] = xs[root[v]];
    });
    return xs;
}
function $69a6435f926c5c17$var$buildBlockGraph(g, layering, root, reverseSep) {
    var blockGraph = new $69a6435f926c5c17$require$Graph(), graphLabel = g.graph(), sepFn = $69a6435f926c5c17$var$sep(graphLabel.nodesep, graphLabel.edgesep, reverseSep);
    $bqfL5.forEach(layering, function(layer) {
        var u;
        $bqfL5.forEach(layer, function(v) {
            var vRoot = root[v];
            blockGraph.setNode(vRoot);
            if (u) {
                var uRoot = root[u], prevMax = blockGraph.edge(uRoot, vRoot);
                blockGraph.setEdge(uRoot, vRoot, Math.max(sepFn(g, v, u), prevMax || 0));
            }
            u = v;
        });
    });
    return blockGraph;
}
/*
 * Returns the alignment that has the smallest width of the given alignments.
 */ function $69a6435f926c5c17$var$findSmallestWidthAlignment(g, xss) {
    return $bqfL5.minBy($bqfL5.values(xss), function(xs) {
        var max = Number.NEGATIVE_INFINITY;
        var min = Number.POSITIVE_INFINITY;
        $bqfL5.forIn(xs, function(x, v) {
            var halfWidth = $69a6435f926c5c17$var$width(g, v) / 2;
            max = Math.max(x + halfWidth, max);
            min = Math.min(x - halfWidth, min);
        });
        return max - min;
    });
}
/*
 * Align the coordinates of each of the layout alignments such that
 * left-biased alignments have their minimum coordinate at the same point as
 * the minimum coordinate of the smallest width alignment and right-biased
 * alignments have their maximum coordinate at the same point as the maximum
 * coordinate of the smallest width alignment.
 */ function $69a6435f926c5c17$var$alignCoordinates(xss, alignTo) {
    var alignToVals = $bqfL5.values(alignTo), alignToMin = $bqfL5.min(alignToVals), alignToMax = $bqfL5.max(alignToVals);
    $bqfL5.forEach([
        "u",
        "d"
    ], function(vert) {
        $bqfL5.forEach([
            "l",
            "r"
        ], function(horiz) {
            var alignment = vert + horiz, xs = xss[alignment], delta;
            if (xs === alignTo) return;
            var xsVals = $bqfL5.values(xs);
            delta = horiz === "l" ? alignToMin - $bqfL5.min(xsVals) : alignToMax - $bqfL5.max(xsVals);
            if (delta) xss[alignment] = $bqfL5.mapValues(xs, function(x) {
                return x + delta;
            });
        });
    });
}
function $69a6435f926c5c17$var$balance(xss, align) {
    return $bqfL5.mapValues(xss.ul, function(ignore, v) {
        if (align) return xss[align.toLowerCase()][v];
        else {
            var xs = $bqfL5.sortBy($bqfL5.map(xss, v));
            return (xs[1] + xs[2]) / 2;
        }
    });
}
function $69a6435f926c5c17$var$positionX(g) {
    var layering = $1kMKg.buildLayerMatrix(g);
    var conflicts = $bqfL5.merge($69a6435f926c5c17$var$findType1Conflicts(g, layering), $69a6435f926c5c17$var$findType2Conflicts(g, layering));
    var xss = {};
    var adjustedLayering;
    $bqfL5.forEach([
        "u",
        "d"
    ], function(vert) {
        adjustedLayering = vert === "u" ? layering : $bqfL5.values(layering).reverse();
        $bqfL5.forEach([
            "l",
            "r"
        ], function(horiz) {
            if (horiz === "r") adjustedLayering = $bqfL5.map(adjustedLayering, function(inner) {
                return $bqfL5.values(inner).reverse();
            });
            var neighborFn = (vert === "u" ? g.predecessors : g.successors).bind(g);
            var align = $69a6435f926c5c17$var$verticalAlignment(g, adjustedLayering, conflicts, neighborFn);
            var xs = $69a6435f926c5c17$var$horizontalCompaction(g, adjustedLayering, align.root, align.align, horiz === "r");
            if (horiz === "r") xs = $bqfL5.mapValues(xs, function(x) {
                return -x;
            });
            xss[vert + horiz] = xs;
        });
    });
    var smallestWidth = $69a6435f926c5c17$var$findSmallestWidthAlignment(g, xss);
    $69a6435f926c5c17$var$alignCoordinates(xss, smallestWidth);
    return $69a6435f926c5c17$var$balance(xss, g.graph().align);
}
function $69a6435f926c5c17$var$sep(nodeSep, edgeSep, reverseSep) {
    return function(g, v, w) {
        var vLabel = g.node(v);
        var wLabel = g.node(w);
        var sum = 0;
        var delta;
        sum += vLabel.width / 2;
        if ($bqfL5.has(vLabel, "labelpos")) switch(vLabel.labelpos.toLowerCase()){
            case "l":
                delta = -vLabel.width / 2;
                break;
            case "r":
                delta = vLabel.width / 2;
                break;
        }
        if (delta) sum += reverseSep ? delta : -delta;
        delta = 0;
        sum += (vLabel.dummy ? edgeSep : nodeSep) / 2;
        sum += (wLabel.dummy ? edgeSep : nodeSep) / 2;
        sum += wLabel.width / 2;
        if ($bqfL5.has(wLabel, "labelpos")) switch(wLabel.labelpos.toLowerCase()){
            case "l":
                delta = wLabel.width / 2;
                break;
            case "r":
                delta = -wLabel.width / 2;
                break;
        }
        if (delta) sum += reverseSep ? delta : -delta;
        delta = 0;
        return sum;
    };
}
function $69a6435f926c5c17$var$width(g, v) {
    return g.node(v).width;
}

});



parcelRegister("8XBdx", function(module, exports) {

var $bqfL5 = parcelRequire("bqfL5");

var $1kMKg = parcelRequire("1kMKg");

var $6mwJ2 = parcelRequire("6mwJ2");
var $6860b4009ab03a40$require$Graph = $6mwJ2.Graph;
module.exports = {
    debugOrdering: $6860b4009ab03a40$var$debugOrdering
};
/* istanbul ignore next */ function $6860b4009ab03a40$var$debugOrdering(g) {
    var layerMatrix = $1kMKg.buildLayerMatrix(g);
    var h = new $6860b4009ab03a40$require$Graph({
        compound: true,
        multigraph: true
    }).setGraph({});
    $bqfL5.forEach(g.nodes(), function(v) {
        h.setNode(v, {
            label: v
        });
        h.setParent(v, "layer" + g.node(v).rank);
    });
    $bqfL5.forEach(g.edges(), function(e) {
        h.setEdge(e.v, e.w, {}, e.name);
    });
    $bqfL5.forEach(layerMatrix, function(layer, i) {
        var layerV = "layer" + i;
        h.setNode(layerV, {
            rank: "same"
        });
        $bqfL5.reduce(layer, function(u, v) {
            h.setEdge(u, v, {
                style: "invis"
            });
            return v;
        });
    });
    return h;
}

});

parcelRegister("9Grre", function(module, exports) {
module.exports = "0.8.5";

});



parcelRegister("eyWFr", function(module, exports) {

$parcel$export(module.exports, "ForceAtlas2Layout", () => $a9a1bfc97b6ef6e9$export$c10edd245dbf6143);

var $7WQrb = parcelRequire("7WQrb");

var $fc2XC = parcelRequire("fc2XC");

var $jyI49 = parcelRequire("jyI49");

var $9nuNf = parcelRequire("9nuNf");
var $9RkJR = parcelRequire("9RkJR");

var $5Rnio = parcelRequire("5Rnio");

var $3KpyM = parcelRequire("3KpyM");

var $h6W7d = parcelRequire("h6W7d");

var $kYDom = parcelRequire("kYDom");
const $a9a1bfc97b6ef6e9$var$DEFAULTS_LAYOUT_OPTIONS = {
    center: [
        0,
        0
    ],
    width: 300,
    height: 300,
    kr: 5,
    kg: 1,
    mode: 'normal',
    preventOverlap: false,
    dissuadeHubs: false,
    maxIteration: 0,
    ks: 0.1,
    ksmax: 10,
    tao: 0.1
};
class $a9a1bfc97b6ef6e9$export$c10edd245dbf6143 {
    constructor(options = {}){
        this.options = options;
        this.id = 'forceAtlas2';
        this.options = Object.assign(Object.assign({}, $a9a1bfc97b6ef6e9$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericForceAtlas2Layout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericForceAtlas2Layout(true, graph, options);
        });
    }
    genericForceAtlas2Layout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const edges = graph.getAllEdges();
            const nodes = graph.getAllNodes();
            const mergedOptions = this.formatOptions(options, nodes.length);
            const { width: width, height: height, prune: prune, maxIteration: maxIteration, nodeSize: nodeSize, center: center } = mergedOptions;
            if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length) || nodes.length === 1) return (0, $5Rnio.handleSingleNodeGraph)(graph, assign, center);
            const calcNodes = nodes.map((node)=>(0, $9nuNf.cloneFormatData)(node, [
                    width,
                    height
                ]));
            const calcEdges = edges.filter((edge)=>{
                const { source: source, target: target } = edge;
                return source !== target;
            });
            const calcGraph = new (0, $fc2XC.Graph)({
                nodes: calcNodes,
                edges: calcEdges
            });
            const sizes = this.getSizes(calcGraph, nodeSize);
            this.run(calcGraph, graph, maxIteration, sizes, assign, mergedOptions);
            // if prune, place the leaves around their parents, and then re-layout for several iterations.
            if (prune) {
                for(let j = 0; j < calcEdges.length; j += 1){
                    const { source: source, target: target } = calcEdges[j];
                    const sourceDegree = calcGraph.getDegree(source);
                    const targetDegree = calcGraph.getDegree(source);
                    if (sourceDegree <= 1) {
                        const targetNode = calcGraph.getNode(target);
                        calcGraph.mergeNodeData(source, {
                            x: targetNode.data.x,
                            y: targetNode.data.y
                        });
                    } else if (targetDegree <= 1) {
                        const sourceNode = calcGraph.getNode(source);
                        calcGraph.mergeNodeData(target, {
                            x: sourceNode.data.x,
                            y: sourceNode.data.y
                        });
                    }
                }
                const postOptions = Object.assign(Object.assign({}, mergedOptions), {
                    prune: false,
                    barnesHut: false
                });
                this.run(calcGraph, graph, 100, sizes, assign, postOptions);
            }
            return {
                nodes: calcNodes,
                edges: edges
            };
        });
    }
    /**
     * Init the node positions if there is no initial positions.
     * And pre-calculate the size (max of width and height) for each node.
     * @param calcGraph graph for calculation
     * @param nodeSize node size config from layout options
     * @returns {SizeMap} node'id mapped to max of its width and height
     */ getSizes(calcGraph, nodeSize) {
        const nodes = calcGraph.getAllNodes();
        const sizes = {};
        for(let i = 0; i < nodes.length; i += 1){
            const node = nodes[i];
            sizes[node.id] = (0, $9RkJR.formatNodeSizeToNumber)(nodeSize, undefined)(node);
        }
        return sizes;
    }
    /**
     * Format the options.
     * @param options input options
     * @param nodeNum number of nodes
     * @returns formatted options
     */ formatOptions(options = {}, nodeNum) {
        const mergedOptions = Object.assign(Object.assign({}, this.options), options);
        const { center: center, width: width, height: height, barnesHut: barnesHut, prune: prune, maxIteration: maxIteration, kr: kr, kg: kg } = mergedOptions;
        mergedOptions.width = !width && typeof window !== 'undefined' ? window.innerWidth : width;
        mergedOptions.height = !height && typeof window !== 'undefined' ? window.innerHeight : height;
        mergedOptions.center = !center ? [
            mergedOptions.width / 2,
            mergedOptions.height / 2
        ] : center;
        if (barnesHut === undefined && nodeNum > 250) mergedOptions.barnesHut = true;
        if (prune === undefined && nodeNum > 100) mergedOptions.prune = true;
        if (maxIteration === 0 && !prune) {
            mergedOptions.maxIteration = 250;
            if (nodeNum <= 200 && nodeNum > 100) mergedOptions.maxIteration = 1000;
            else if (nodeNum > 200) mergedOptions.maxIteration = 1200;
        } else if (maxIteration === 0 && prune) {
            mergedOptions.maxIteration = 100;
            if (nodeNum <= 200 && nodeNum > 100) mergedOptions.maxIteration = 500;
            else if (nodeNum > 200) mergedOptions.maxIteration = 950;
        }
        if (!kr) {
            mergedOptions.kr = 50;
            if (nodeNum > 100 && nodeNum <= 500) mergedOptions.kr = 20;
            else if (nodeNum > 500) mergedOptions.kr = 1;
        }
        if (!kg) {
            mergedOptions.kg = 20;
            if (nodeNum > 100 && nodeNum <= 500) mergedOptions.kg = 10;
            else if (nodeNum > 500) mergedOptions.kg = 1;
        }
        return mergedOptions;
    }
    /**
     * Loops for fa2.
     * @param calcGraph graph for calculation
     * @param graph original graph
     * @param iteration iteration number
     * @param sizes nodes' size
     * @param options formatted layout options
     * @returns
     */ run(calcGraph, graph, iteration, sizes, assign, options) {
        const { kr: kr, barnesHut: barnesHut, onTick: onTick } = options;
        const calcNodes = calcGraph.getAllNodes();
        let sg = 0;
        let iter = iteration;
        const forces = {};
        const preForces = {};
        const bodies = {};
        for(let i = 0; i < calcNodes.length; i += 1){
            const { data: data, id: id } = calcNodes[i];
            forces[id] = [
                0,
                0
            ];
            if (barnesHut) {
                const params = {
                    id: i,
                    rx: data.x,
                    ry: data.y,
                    mass: 1,
                    g: kr,
                    degree: calcGraph.getDegree(id)
                };
                bodies[id] = new (0, $3KpyM.default)(params);
            }
        }
        while(iter > 0){
            sg = this.oneStep(calcGraph, {
                iter: iter,
                preventOverlapIters: 50,
                krPrime: 100,
                sg: sg,
                forces: forces,
                preForces: preForces,
                bodies: bodies,
                sizes: sizes
            }, options);
            iter--;
            onTick === null || onTick === void 0 || onTick({
                nodes: calcNodes,
                edges: graph.getAllEdges()
            });
        // if (assign) {
        //   calcNodes.forEach(({ id, data }) => graph.mergeNodeData(id, {
        //     x: data.x,
        //     y: data.y
        //   }))
        // }
        }
        return calcGraph;
    }
    /**
     * One step for a loop.
     * @param graph graph for calculation
     * @param params parameters for a loop
     * @param options formatted layout's input options
     * @returns
     */ oneStep(graph, params, options) {
        const { iter: iter, preventOverlapIters: preventOverlapIters, krPrime: krPrime, sg: sg, preForces: preForces, bodies: bodies, sizes: sizes } = params;
        let { forces: forces } = params;
        const { preventOverlap: preventOverlap, barnesHut: barnesHut } = options;
        const nodes = graph.getAllNodes();
        for(let i = 0; i < nodes.length; i += 1){
            const { id: id } = nodes[i];
            preForces[id] = [
                ...forces[id]
            ];
            forces[id] = [
                0,
                0
            ];
        }
        // attractive forces, existing on every actual edge
        forces = this.getAttrForces(graph, iter, preventOverlapIters, sizes, forces, options);
        // repulsive forces and Gravity, existing on every node pair
        // if preventOverlap, using the no-optimized method in the last preventOverlapIters instead.
        if (barnesHut && (preventOverlap && iter > preventOverlapIters || !preventOverlap)) forces = this.getOptRepGraForces(graph, forces, bodies, options);
        else forces = this.getRepGraForces(graph, iter, preventOverlapIters, forces, krPrime, sizes, options);
        // update the positions
        return this.updatePos(graph, forces, preForces, sg, options);
    }
    /**
     * Calculate the attract forces for nodes.
     * @param graph graph for calculation
     * @param iter current iteration index
     * @param preventOverlapIters the iteration number for preventing overlappings
     * @param sizes nodes' sizes
     * @param forces forces for nodes, which will be modified
     * @param options formatted layout's input options
     * @returns
     */ getAttrForces(graph, iter, preventOverlapIters, sizes, forces, options) {
        const { preventOverlap: preventOverlap, dissuadeHubs: dissuadeHubs, mode: mode, prune: prune } = options;
        const edges = graph.getAllEdges();
        for(let i = 0; i < edges.length; i += 1){
            const { source: source, target: target } = edges[i];
            const sourceNode = graph.getNode(source);
            const targetNode = graph.getNode(target);
            const sourceDegree = graph.getDegree(source);
            const targetDegree = graph.getDegree(target);
            if (prune && (sourceDegree <= 1 || targetDegree <= 1)) continue;
            const dir = [
                targetNode.data.x - sourceNode.data.x,
                targetNode.data.y - sourceNode.data.y
            ];
            let eucliDis = Math.hypot(dir[0], dir[1]);
            eucliDis = eucliDis < 0.0001 ? 0.0001 : eucliDis;
            dir[0] = dir[0] / eucliDis;
            dir[1] = dir[1] / eucliDis;
            if (preventOverlap && iter < preventOverlapIters) eucliDis = eucliDis - sizes[source] - sizes[target];
            let fa1 = eucliDis;
            let fa2 = fa1;
            if (mode === 'linlog') {
                fa1 = Math.log(1 + eucliDis);
                fa2 = fa1;
            }
            if (dissuadeHubs) {
                fa1 = eucliDis / sourceDegree;
                fa2 = eucliDis / targetDegree;
            }
            if (preventOverlap && iter < preventOverlapIters && eucliDis <= 0) {
                fa1 = 0;
                fa2 = 0;
            } else if (preventOverlap && iter < preventOverlapIters && eucliDis > 0) {
                fa1 = eucliDis;
                fa2 = eucliDis;
            }
            forces[source][0] += fa1 * dir[0];
            forces[target][0] -= fa2 * dir[0];
            forces[source][1] += fa1 * dir[1];
            forces[target][1] -= fa2 * dir[1];
        }
        return forces;
    }
    /**
     * Calculate the repulsive forces for nodes under barnesHut mode.
     * @param graph graph for calculatiion
     * @param forces forces for nodes, which will be modified
     * @param bodies force body map
     * @param options formatted layout's input options
     * @returns
     */ getOptRepGraForces(graph, forces, bodies, options) {
        const { kg: kg, center: center, prune: prune } = options;
        const nodes = graph.getAllNodes();
        const nodeNum = nodes.length;
        let minx = 9e10;
        let maxx = -90000000000;
        let miny = 9e10;
        let maxy = -90000000000;
        for(let i = 0; i < nodeNum; i += 1){
            const { id: id, data: data } = nodes[i];
            if (prune && graph.getDegree(id) <= 1) continue;
            bodies[id].setPos(data.x, data.y);
            if (data.x >= maxx) maxx = data.x;
            if (data.x <= minx) minx = data.x;
            if (data.y >= maxy) maxy = data.y;
            if (data.y <= miny) miny = data.y;
        }
        const width = Math.max(maxx - minx, maxy - miny);
        const quadParams = {
            xmid: (maxx + minx) / 2,
            ymid: (maxy + miny) / 2,
            length: width,
            massCenter: center,
            mass: nodeNum
        };
        const quad = new (0, $h6W7d.default)(quadParams);
        const quadTree = new (0, $kYDom.default)(quad);
        // build the tree, insert the nodes(quads) into the tree
        for(let i = 0; i < nodeNum; i += 1){
            const { id: id } = nodes[i];
            if (prune && graph.getDegree(id) <= 1) continue;
            if (bodies[id].in(quad)) quadTree.insert(bodies[id]);
        }
        // update the repulsive forces and the gravity.
        for(let i = 0; i < nodeNum; i += 1){
            const { id: id, data: data } = nodes[i];
            const degree = graph.getDegree(id);
            if (prune && degree <= 1) continue;
            bodies[id].resetForce();
            quadTree.updateForce(bodies[id]);
            forces[id][0] -= bodies[id].fx;
            forces[id][1] -= bodies[id].fy;
            // gravity
            const dir = [
                data.x - center[0],
                data.y - center[1]
            ];
            let eucliDis = Math.hypot(dir[0], dir[1]);
            eucliDis = eucliDis < 0.0001 ? 0.0001 : eucliDis;
            dir[0] = dir[0] / eucliDis;
            dir[1] = dir[1] / eucliDis;
            const fg = kg * (degree + 1); // tslint:disable-line
            forces[id][0] -= fg * dir[0];
            forces[id][1] -= fg * dir[1];
        }
        return forces;
    }
    /**
     * Calculate the repulsive forces for nodes.
     * @param graph graph for calculatiion
     * @param iter current iteration index
     * @param preventOverlapIters the iteration number for preventing overlappings
     * @param forces forces for nodes, which will be modified
     * @param krPrime larger the krPrime, larger the repulsive force
     * @param sizes nodes' sizes
     * @param options formatted layout's input options
     * @returns
     */ getRepGraForces(graph, iter, preventOverlapIters, forces, krPrime, sizes, options) {
        const { preventOverlap: preventOverlap, kr: kr, kg: kg, center: center, prune: prune } = options;
        const nodes = graph.getAllNodes();
        const nodeNum = nodes.length;
        for(let i = 0; i < nodeNum; i += 1){
            const nodei = nodes[i];
            const degreei = graph.getDegree(nodei.id);
            for(let j = i + 1; j < nodeNum; j += 1){
                const nodej = nodes[j];
                const degreej = graph.getDegree(nodej.id);
                if (prune && (degreei <= 1 || degreej <= 1)) continue;
                const dir = [
                    nodej.data.x - nodei.data.x,
                    nodej.data.y - nodei.data.y
                ];
                let eucliDis = Math.hypot(dir[0], dir[1]);
                eucliDis = eucliDis < 0.0001 ? 0.0001 : eucliDis;
                dir[0] = dir[0] / eucliDis;
                dir[1] = dir[1] / eucliDis;
                if (preventOverlap && iter < preventOverlapIters) eucliDis = eucliDis - sizes[nodei.id] - sizes[nodej.id];
                let fr = kr * (degreei + 1) * (degreej + 1) / eucliDis;
                if (preventOverlap && iter < preventOverlapIters && eucliDis < 0) fr = krPrime * (degreei + 1) * (degreej + 1);
                else if (preventOverlap && iter < preventOverlapIters && eucliDis === 0) fr = 0;
                else if (preventOverlap && iter < preventOverlapIters && eucliDis > 0) fr = kr * (degreei + 1) * (degreej + 1) / eucliDis;
                forces[nodei.id][0] -= fr * dir[0];
                forces[nodej.id][0] += fr * dir[0];
                forces[nodei.id][1] -= fr * dir[1];
                forces[nodej.id][1] += fr * dir[1];
            }
            // gravity
            const dir = [
                nodei.data.x - center[0],
                nodei.data.y - center[1]
            ];
            const eucliDis = Math.hypot(dir[0], dir[1]);
            dir[0] = dir[0] / eucliDis;
            dir[1] = dir[1] / eucliDis;
            const fg = kg * (degreei + 1); // tslint:disable-line
            forces[nodei.id][0] -= fg * dir[0];
            forces[nodei.id][1] -= fg * dir[1];
        }
        return forces;
    }
    /**
     * Update node positions.
     * @param graph graph for calculatiion
     * @param forces forces for nodes, which will be modified
     * @param preForces previous forces for nodes, which will be modified
     * @param sg constant for move distance of one step
     * @param options formatted layout's input options
     * @returns
     */ updatePos(graph, forces, preForces, sg, options) {
        const { ks: ks, tao: tao, prune: prune, ksmax: ksmax } = options;
        const nodes = graph.getAllNodes();
        const nodeNum = nodes.length;
        const swgns = [];
        const trans = [];
        // swg(G) and tra(G)
        let swgG = 0;
        let traG = 0;
        let usingSg = sg;
        for(let i = 0; i < nodeNum; i += 1){
            const { id: id } = nodes[i];
            const degree = graph.getDegree(id);
            if (prune && degree <= 1) continue;
            const minus = [
                forces[id][0] - preForces[id][0],
                forces[id][1] - preForces[id][1]
            ];
            const minusNorm = Math.hypot(minus[0], minus[1]);
            const add = [
                forces[id][0] + preForces[id][0],
                forces[id][1] + preForces[id][1]
            ];
            const addNorm = Math.hypot(add[0], add[1]);
            swgns[i] = minusNorm;
            trans[i] = addNorm / 2;
            swgG += (degree + 1) * swgns[i];
            traG += (degree + 1) * trans[i];
        }
        const preSG = usingSg;
        usingSg = tao * traG / swgG;
        if (preSG !== 0) usingSg = usingSg > 1.5 * preSG ? 1.5 * preSG : usingSg;
        // update the node positions
        for(let i = 0; i < nodeNum; i += 1){
            const { id: id, data: data } = nodes[i];
            const degree = graph.getDegree(id);
            if (prune && degree <= 1) continue;
            if ((0, $jyI49.default)(data.fx) && (0, $jyI49.default)(data.fy)) continue;
            let sn = ks * usingSg / (1 + usingSg * Math.sqrt(swgns[i]));
            let absForce = Math.hypot(forces[id][0], forces[id][1]);
            absForce = absForce < 0.0001 ? 0.0001 : absForce;
            const max = ksmax / absForce;
            sn = sn > max ? max : sn;
            const dnx = sn * forces[id][0];
            const dny = sn * forces[id][1];
            graph.mergeNodeData(id, {
                x: data.x + dnx,
                y: data.y + dny
            });
        }
        return usingSg;
    }
}

});
parcelRegister("3KpyM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ba97ea6f8da64fd$export$2e2bcd8739ae039);
// represents a body(a point mass) and its position
class $2ba97ea6f8da64fd$export$2e2bcd8739ae039 {
    constructor(params){
        /**
         * the id of this body, the same with the node id
         * @type  {number}
         */ this.id = params.id || 0;
        /**
         * the position of this body
         * @type  {number}
         */ this.rx = params.rx;
        /**
         * the position of this body
         * @type  {number}
         */ this.ry = params.ry;
        /**
         * the force acting on this body
         * @type  {number}
         */ this.fx = 0;
        /**
         * the force acting on this body
         * @type  {number}
         */ this.fy = 0;
        /**
         * the mass of this body, =1 for a node
         * @type  {number}
         */ this.mass = params.mass;
        /**
         * the degree of the node represented by this body
         * @type  {number}
         */ this.degree = params.degree;
        /**
         * the parameter for repulsive force, = kr
         * @type  {number}
         */ this.g = params.g || 0;
    }
    // returns the euclidean distance
    distanceTo(bo) {
        const dx = this.rx - bo.rx;
        const dy = this.ry - bo.ry;
        return Math.hypot(dx, dy);
    }
    setPos(x, y) {
        this.rx = x;
        this.ry = y;
    }
    // resets the forces
    resetForce() {
        this.fx = 0;
        this.fy = 0;
    }
    addForce(b) {
        const dx = b.rx - this.rx;
        const dy = b.ry - this.ry;
        let dist = Math.hypot(dx, dy);
        dist = dist < 0.0001 ? 0.0001 : dist;
        // the repulsive defined by force atlas 2
        const F = this.g * (this.degree + 1) * (b.degree + 1) / dist;
        this.fx += F * dx / dist;
        this.fy += F * dy / dist;
    }
    // if quad contains this body
    in(quad) {
        return quad.contains(this.rx, this.ry);
    }
    // returns a new body
    add(bo) {
        const nenwMass = this.mass + bo.mass;
        const x = (this.rx * this.mass + bo.rx * bo.mass) / nenwMass;
        const y = (this.ry * this.mass + bo.ry * bo.mass) / nenwMass;
        const dg = this.degree + bo.degree;
        const params = {
            rx: x,
            ry: y,
            mass: nenwMass,
            degree: dg
        };
        return new $2ba97ea6f8da64fd$export$2e2bcd8739ae039(params);
    }
}

});

parcelRegister("h6W7d", function(module, exports) {

$parcel$export(module.exports, "default", () => $c75013ba59aeb56e$export$2e2bcd8739ae039);
class $c75013ba59aeb56e$export$2e2bcd8739ae039 {
    constructor(params){
        /**
         * the center position of this quad
         * @type  {number}
         */ this.xmid = params.xmid;
        /**
         * the center position of this quad
         * @type  {number}
         */ this.ymid = params.ymid;
        /**
         * the length of this quad
         * @type  {number}
         */ this.length = params.length;
        /**
         * the mass center of this quad
         * @type  {number}
         */ this.massCenter = params.massCenter || [
            0,
            0
        ];
        /**
         * the mass of this quad
         * @type  {number}
         */ this.mass = params.mass || 1;
    }
    getLength() {
        return this.length;
    }
    contains(x, y) {
        const halfLen = this.length / 2;
        return x <= this.xmid + halfLen && x >= this.xmid - halfLen && y <= this.ymid + halfLen && y >= this.ymid - halfLen;
    }
    // northwest quadrant
    // tslint:disable-next-line
    NW() {
        const x = this.xmid - this.length / 4;
        const y = this.ymid + this.length / 4;
        const len = this.length / 2;
        const params = {
            xmid: x,
            ymid: y,
            length: len
        };
        const NW = new $c75013ba59aeb56e$export$2e2bcd8739ae039(params);
        return NW;
    }
    // northeast
    // tslint:disable-next-line
    NE() {
        const x = this.xmid + this.length / 4;
        const y = this.ymid + this.length / 4;
        const len = this.length / 2;
        const params = {
            xmid: x,
            ymid: y,
            length: len
        };
        const NE = new $c75013ba59aeb56e$export$2e2bcd8739ae039(params);
        return NE;
    }
    // southwest
    // tslint:disable-next-line
    SW() {
        const x = this.xmid - this.length / 4;
        const y = this.ymid - this.length / 4;
        const len = this.length / 2;
        const params = {
            xmid: x,
            ymid: y,
            length: len
        };
        const SW = new $c75013ba59aeb56e$export$2e2bcd8739ae039(params);
        return SW;
    }
    // southeast
    // tslint:disable-next-line
    SE() {
        const x = this.xmid + this.length / 4;
        const y = this.ymid - this.length / 4;
        const len = this.length / 2;
        const params = {
            xmid: x,
            ymid: y,
            length: len
        };
        const SE = new $c75013ba59aeb56e$export$2e2bcd8739ae039(params);
        return SE;
    }
}

});

parcelRegister("kYDom", function(module, exports) {

$parcel$export(module.exports, "default", () => $f457f7a23f96984c$export$2e2bcd8739ae039);
/**
 * @fileOverview quadTree
 * @author shiwu.wyy@antfin.com
 */ class $f457f7a23f96984c$export$2e2bcd8739ae039 {
    // each quadtree represents a quadrant and an aggregate body
    // that represents all bodies inside the quadrant
    constructor(param){
        /**
         * (aggregated) body in this quad
         * @type  {object}
         */ this.body = null;
        /**
         * tree representing the northwest quadrant
         * @type  {object}
         */ this.quad = null;
        this.NW = null;
        this.NE = null;
        this.SW = null;
        this.SE = null;
        /**
         * threshold
         * @type  {number}
         */ this.theta = 0.5;
        if (param != null) this.quad = param;
    }
    // insert a body(node) into the tree
    insert(bo) {
        // if this node does not contain a body, put the new body bo here
        if (this.body == null) {
            this.body = bo;
            return;
        }
        // internal node
        if (!this._isExternal()) {
            // update mass info
            this.body = this.body.add(bo);
            // insert body into quadrant
            this._putBody(bo);
        } else {
            // external node
            // divide this region into four children
            if (this.quad) {
                this.NW = new $f457f7a23f96984c$export$2e2bcd8739ae039(this.quad.NW());
                this.NE = new $f457f7a23f96984c$export$2e2bcd8739ae039(this.quad.NE());
                this.SW = new $f457f7a23f96984c$export$2e2bcd8739ae039(this.quad.SW());
                this.SE = new $f457f7a23f96984c$export$2e2bcd8739ae039(this.quad.SE());
            }
            // insert this body and bo
            this._putBody(this.body);
            this._putBody(bo);
            // update the mass info
            this.body = this.body.add(bo);
        }
    }
    // inserts bo into a quad
    // tslint:disable-next-line
    _putBody(bo) {
        if (!this.quad) return;
        if (bo.in(this.quad.NW()) && this.NW) this.NW.insert(bo);
        else if (bo.in(this.quad.NE()) && this.NE) this.NE.insert(bo);
        else if (bo.in(this.quad.SW()) && this.SW) this.SW.insert(bo);
        else if (bo.in(this.quad.SE()) && this.SE) this.SE.insert(bo);
    }
    // tslint:disable-next-line
    _isExternal() {
        // four children are null
        return this.NW == null && this.NE == null && this.SW == null && this.SE == null;
    }
    // update the forces
    updateForce(bo) {
        if (this.body == null || bo === this.body) return;
        // if the current node is external
        if (this._isExternal()) bo.addForce(this.body);
        else {
            const s = this.quad ? this.quad.getLength() : 0;
            const d = this.body.distanceTo(bo);
            // b is far enough
            if (s / d < this.theta) bo.addForce(this.body);
            else {
                this.NW && this.NW.updateForce(bo);
                this.NE && this.NE.updateForce(bo);
                this.SW && this.SW.updateForce(bo);
                this.SE && this.SE.updateForce(bo);
            }
        }
    }
}

});


parcelRegister("eifoa", function(module, exports) {

$parcel$export(module.exports, "FruchtermanLayout", () => $a67eaf00dd6e09e6$export$407f4cf112ef23b2);

var $7WQrb = parcelRequire("7WQrb");

var $fc2XC = parcelRequire("fc2XC");

var $jyI49 = parcelRequire("jyI49");

var $9nuNf = parcelRequire("9nuNf");
const $a67eaf00dd6e09e6$var$DEFAULTS_LAYOUT_OPTIONS = {
    maxIteration: 1000,
    gravity: 10,
    speed: 5,
    clustering: false,
    clusterGravity: 10,
    width: 300,
    height: 300,
    nodeClusterBy: 'cluster'
};
const $a67eaf00dd6e09e6$var$SPEED_DIVISOR = 800;
class $a67eaf00dd6e09e6$export$407f4cf112ef23b2 {
    constructor(options = {}){
        this.options = options;
        this.id = 'fruchterman';
        this.timeInterval = 0;
        this.running = false;
        this.options = Object.assign(Object.assign({}, $a67eaf00dd6e09e6$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericFruchtermanLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericFruchtermanLayout(true, graph, options);
        });
    }
    /**
     * Stop simulation immediately.
     */ stop() {
        if (this.timeInterval && typeof window !== 'undefined') window.clearInterval(this.timeInterval);
        this.running = false;
    }
    /**
     * Manually steps the simulation by the specified number of iterations.
     * @see https://github.com/d3/d3-force#simulation_tick
     */ tick(iterations = this.options.maxIteration || 1) {
        if (this.lastResult) return this.lastResult;
        for(let i = 0; i < iterations; i++)this.runOneStep(this.lastGraph, this.lastClusterMap, this.lastOptions);
        const result = {
            nodes: this.lastLayoutNodes,
            edges: this.lastLayoutEdges
        };
        if (this.lastAssign) result.nodes.forEach((node)=>this.lastGraph.mergeNodeData(node.id, {
                x: node.data.x,
                y: node.data.y,
                z: this.options.dimensions === 3 ? node.data.z : undefined
            }));
        return result;
    }
    genericFruchtermanLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            if (this.running) return;
            const formattedOptions = this.formatOptions(options);
            const { dimensions: dimensions, width: width, height: height, center: center, clustering: clustering, nodeClusterBy: nodeClusterBy, maxIteration: maxIteration, onTick: onTick } = formattedOptions;
            const nodes = graph.getAllNodes();
            const edges = graph.getAllEdges();
            if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length)) {
                const result = {
                    nodes: [],
                    edges: edges
                };
                this.lastResult = result;
                return result;
            }
            if (nodes.length === 1) {
                if (assign) graph.mergeNodeData(nodes[0].id, {
                    x: center[0],
                    y: center[1],
                    z: dimensions === 3 ? center[2] : undefined
                });
                const result = {
                    nodes: [
                        Object.assign(Object.assign({}, nodes[0]), {
                            data: Object.assign(Object.assign({}, nodes[0].data), {
                                x: center[0],
                                y: center[1],
                                z: dimensions === 3 ? center[2] : undefined
                            })
                        })
                    ],
                    edges: edges
                };
                this.lastResult = result;
                return result;
            }
            const layoutNodes = nodes.map((node)=>(0, $9nuNf.cloneFormatData)(node, [
                    width,
                    height
                ]));
            const calcGraph = new (0, $fc2XC.Graph)({
                nodes: layoutNodes,
                edges: edges
            });
            // clustering info
            const clusterMap = {};
            if (clustering) layoutNodes.forEach((node)=>{
                const clusterValue = node.data[nodeClusterBy];
                if (!clusterMap[clusterValue]) clusterMap[clusterValue] = {
                    name: clusterValue,
                    cx: 0,
                    cy: 0,
                    count: 0
                };
            });
            // Use them later in `tick`.
            this.lastLayoutNodes = layoutNodes;
            this.lastLayoutEdges = edges;
            this.lastAssign = assign;
            this.lastGraph = calcGraph;
            this.lastOptions = formattedOptions;
            this.lastClusterMap = clusterMap;
            if (typeof window === 'undefined') return;
            let iter = 0;
            return new Promise((resolve)=>{
                // interval for render the result after each iteration
                this.timeInterval = window.setInterval(()=>{
                    if (!this.running) {
                        resolve({
                            nodes: layoutNodes,
                            edges: edges
                        });
                        return;
                    }
                    this.runOneStep(calcGraph, clusterMap, formattedOptions);
                    if (assign) layoutNodes.forEach(({ id: id, data: data })=>graph.mergeNodeData(id, {
                            x: data.x,
                            y: data.y,
                            z: dimensions === 3 ? data.z : undefined
                        }));
                    onTick === null || onTick === void 0 || onTick({
                        nodes: layoutNodes,
                        edges: edges
                    });
                    iter++;
                    if (iter >= maxIteration) {
                        window.clearInterval(this.timeInterval);
                        resolve({
                            nodes: layoutNodes,
                            edges: edges
                        });
                    }
                }, 0);
                this.running = true;
            });
        });
    }
    formatOptions(options = {}) {
        const mergedOptions = Object.assign(Object.assign({}, this.options), options);
        const { clustering: clustering, nodeClusterBy: nodeClusterBy } = mergedOptions;
        const { center: propsCenter, width: propsWidth, height: propsHeight } = mergedOptions;
        mergedOptions.width = !propsWidth && typeof window !== 'undefined' ? window.innerWidth : propsWidth;
        mergedOptions.height = !propsHeight && typeof window !== 'undefined' ? window.innerHeight : propsHeight;
        mergedOptions.center = !propsCenter ? [
            mergedOptions.width / 2,
            mergedOptions.height / 2
        ] : propsCenter;
        mergedOptions.clustering = clustering && !!nodeClusterBy;
        return mergedOptions;
    }
    runOneStep(calcGraph, clusterMap, options) {
        const { dimensions: dimensions, height: height, width: width, gravity: gravity, center: center, speed: speed, clustering: clustering, nodeClusterBy: nodeClusterBy, clusterGravity: propsClusterGravity } = options;
        const area = height * width;
        const maxDisplace = Math.sqrt(area) / 10;
        const nodes = calcGraph.getAllNodes();
        const k2 = area / (nodes.length + 1);
        const k = Math.sqrt(k2);
        const displacements = {};
        this.applyCalculate(calcGraph, displacements, k, k2);
        // gravity for clusters
        if (clustering) {
            // reset the clustering centers
            for(const key in clusterMap){
                clusterMap[key].cx = 0;
                clusterMap[key].cy = 0;
                clusterMap[key].count = 0;
            }
            // re-compute clustering centers
            nodes.forEach((node)=>{
                const { data: data } = node; // node is one of layoutNodes, which is formatted and data field exists
                const c = clusterMap[data[nodeClusterBy]];
                if ((0, $jyI49.default)(data.x)) c.cx += data.x;
                if ((0, $jyI49.default)(data.y)) c.cy += data.y;
                c.count++;
            });
            for(const key in clusterMap){
                clusterMap[key].cx /= clusterMap[key].count;
                clusterMap[key].cy /= clusterMap[key].count;
            }
            // compute the cluster gravity forces
            const clusterGravity = propsClusterGravity || gravity;
            nodes.forEach((node, j)=>{
                const { id: id, data: data } = node;
                if (!(0, $jyI49.default)(data.x) || !(0, $jyI49.default)(data.y)) return;
                const c = clusterMap[data[nodeClusterBy]];
                const distLength = Math.sqrt((data.x - c.cx) * (data.x - c.cx) + (data.y - c.cy) * (data.y - c.cy));
                const gravityForce = k * clusterGravity;
                displacements[id].x -= gravityForce * (data.x - c.cx) / distLength;
                displacements[id].y -= gravityForce * (data.y - c.cy) / distLength;
            });
        }
        // gravity
        nodes.forEach((node, j)=>{
            const { id: id, data: data } = node;
            if (!(0, $jyI49.default)(data.x) || !(0, $jyI49.default)(data.y)) return;
            const gravityForce = 0.01 * k * gravity;
            displacements[id].x -= gravityForce * (data.x - center[0]);
            displacements[id].y -= gravityForce * (data.y - center[1]);
            if (dimensions === 3) displacements[id].z -= gravityForce * (data.z - center[2]);
        });
        // move
        nodes.forEach((node, j)=>{
            const { id: id, data: data } = node;
            if ((0, $jyI49.default)(data.fx) && (0, $jyI49.default)(data.fy)) {
                data.x = data.fx;
                data.y = data.fy;
                if (dimensions === 3) data.z = data.fz;
                return;
            }
            if (!(0, $jyI49.default)(data.x) || !(0, $jyI49.default)(data.y)) return;
            const distLength = Math.sqrt(displacements[id].x * displacements[id].x + displacements[id].y * displacements[id].y + (dimensions === 3 ? displacements[id].z * displacements[id].z : 0));
            if (distLength > 0) {
                // && !n.isFixed()
                const limitedDist = Math.min(maxDisplace * (speed / $a67eaf00dd6e09e6$var$SPEED_DIVISOR), distLength);
                calcGraph.mergeNodeData(id, {
                    x: data.x + displacements[id].x / distLength * limitedDist,
                    y: data.y + displacements[id].y / distLength * limitedDist,
                    z: dimensions === 3 ? data.z + displacements[id].z / distLength * limitedDist : undefined
                });
            }
        });
    }
    applyCalculate(calcGraph, displacements, k, k2) {
        this.calRepulsive(calcGraph, displacements, k2);
        this.calAttractive(calcGraph, displacements, k);
    }
    calRepulsive(calcGraph, displacements, k2) {
        const nodes = calcGraph.getAllNodes();
        nodes.forEach(({ data: v, id: vid }, i)=>{
            displacements[vid] = {
                x: 0,
                y: 0,
                z: 0
            };
            nodes.forEach(({ data: u, id: uid }, j)=>{
                if (i <= j || !(0, $jyI49.default)(v.x) || !(0, $jyI49.default)(u.x) || !(0, $jyI49.default)(v.y) || !(0, $jyI49.default)(u.y)) return;
                let vecX = v.x - u.x;
                let vecY = v.y - u.y;
                let vecZ = this.options.dimensions === 3 ? v.z - u.z : 0;
                let lengthSqr = vecX * vecX + vecY * vecY + vecZ * vecZ;
                if (lengthSqr === 0) {
                    lengthSqr = 1;
                    vecX = 0.01;
                    vecY = 0.01;
                    vecZ = 0.01;
                }
                const common = k2 / lengthSqr;
                const dispX = vecX * common;
                const dispY = vecY * common;
                const dispZ = vecZ * common;
                displacements[vid].x += dispX;
                displacements[vid].y += dispY;
                displacements[uid].x -= dispX;
                displacements[uid].y -= dispY;
                if (this.options.dimensions === 3) {
                    displacements[vid].z += dispZ;
                    displacements[uid].z -= dispZ;
                }
            });
        });
    }
    calAttractive(calcGraph, displacements, k) {
        const edges = calcGraph.getAllEdges();
        edges.forEach((e)=>{
            const { source: source, target: target } = e;
            if (!source || !target || source === target) return;
            const { data: u } = calcGraph.getNode(source);
            const { data: v } = calcGraph.getNode(target);
            if (!(0, $jyI49.default)(v.x) || !(0, $jyI49.default)(u.x) || !(0, $jyI49.default)(v.y) || !(0, $jyI49.default)(u.y)) return;
            const vecX = v.x - u.x;
            const vecY = v.y - u.y;
            const vecZ = this.options.dimensions === 3 ? v.z - u.z : 0;
            const common = Math.sqrt(vecX * vecX + vecY * vecY + vecZ * vecZ) / k;
            const dispX = vecX * common;
            const dispY = vecY * common;
            const dispZ = vecZ * common;
            displacements[source].x += dispX;
            displacements[source].y += dispY;
            displacements[target].x -= dispX;
            displacements[target].y -= dispY;
            if (this.options.dimensions === 3) {
                displacements[source].z += dispZ;
                displacements[target].z -= dispZ;
            }
        });
    }
}

});

parcelRegister("e7HzC", function(module, exports) {

$parcel$export(module.exports, "GridLayout", () => $a48384f082433faa$export$7d2b12578154a735);

var $7WQrb = parcelRequire("7WQrb");

var $jyI49 = parcelRequire("jyI49");
var $kVcyu = parcelRequire("kVcyu");

var $9nuNf = parcelRequire("9nuNf");
var $9RkJR = parcelRequire("9RkJR");

var $5Rnio = parcelRequire("5Rnio");

var $lKWgx = parcelRequire("lKWgx");
const $a48384f082433faa$var$DEFAULTS_LAYOUT_OPTIONS = {
    begin: [
        0,
        0
    ],
    preventOverlap: true,
    preventOverlapPadding: 10,
    condense: false,
    rows: undefined,
    cols: undefined,
    position: undefined,
    sortBy: 'degree',
    nodeSize: 30,
    width: 300,
    height: 300
};
class $a48384f082433faa$export$7d2b12578154a735 {
    constructor(options = {}){
        this.options = options;
        this.id = 'grid';
        this.options = Object.assign(Object.assign({}, $a48384f082433faa$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericGridLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericGridLayout(true, graph, options);
        });
    }
    genericGridLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const mergedOptions = Object.assign(Object.assign({}, this.options), options);
            const { begin: begin = [
                0,
                0
            ], condense: condense, preventOverlapPadding: preventOverlapPadding, preventOverlap: preventOverlap, rows: propsRows, cols: propsCols, nodeSpacing: paramNodeSpacing, nodeSize: paramNodeSize, width: propsWidth, height: propsHeight, position: position } = mergedOptions;
            let { sortBy: sortBy } = mergedOptions;
            const nodes = graph.getAllNodes();
            const edges = graph.getAllEdges();
            const n = nodes === null || nodes === void 0 ? void 0 : nodes.length;
            // Need no layout if there is no node.
            if (!n || n === 1) return (0, $5Rnio.handleSingleNodeGraph)(graph, assign, begin);
            const layoutNodes = nodes.map((node)=>(0, $9nuNf.cloneFormatData)(node));
            if (// `id` should be reserved keyword
            sortBy !== 'id' && (!(0, $kVcyu.default)(sortBy) || layoutNodes[0].data[sortBy] === undefined)) sortBy = 'degree';
            if (sortBy === 'degree') layoutNodes.sort((n1, n2)=>graph.getDegree(n2.id, 'both') - graph.getDegree(n1.id, 'both'));
            else if (sortBy === 'id') // sort nodes by ID
            layoutNodes.sort((n1, n2)=>{
                if ((0, $jyI49.default)(n2.id) && (0, $jyI49.default)(n1.id)) return n2.id - n1.id;
                return `${n1.id}`.localeCompare(`${n2.id}`);
            });
            else // sort nodes by value
            layoutNodes.sort((n1, n2)=>n2.data[sortBy] - n1.data[sortBy]);
            const width = !propsWidth && typeof window !== 'undefined' ? window.innerWidth : propsWidth;
            const height = !propsHeight && typeof window !== 'undefined' ? window.innerHeight : propsHeight;
            const cells = n;
            const rcs = {
                rows: propsRows,
                cols: propsCols
            };
            // if rows or columns were set in self, use those values
            if (propsRows != null && propsCols != null) {
                rcs.rows = propsRows;
                rcs.cols = propsCols;
            } else if (propsRows != null && propsCols == null) {
                rcs.rows = propsRows;
                rcs.cols = Math.ceil(cells / rcs.rows);
            } else if (propsRows == null && propsCols != null) {
                rcs.cols = propsCols;
                rcs.rows = Math.ceil(cells / rcs.cols);
            } else {
                // otherwise use the automatic values and adjust accordingly	      // otherwise use the automatic values and adjust accordingly
                // width/height * splits^2 = cells where splits is number of times to split width
                const splits = Math.sqrt(cells * height / width);
                rcs.rows = Math.round(splits);
                rcs.cols = Math.round(width / height * splits);
            }
            rcs.rows = Math.max(rcs.rows, 1);
            rcs.cols = Math.max(rcs.cols, 1);
            if (rcs.cols * rcs.rows > cells) {
                // otherwise use the automatic values and adjust accordingly
                // if rounding was up, see if we can reduce rows or columns
                const sm = $a48384f082433faa$var$small(rcs);
                const lg = $a48384f082433faa$var$large(rcs);
                // reducing the small side takes away the most cells, so try it first
                if ((sm - 1) * lg >= cells) $a48384f082433faa$var$small(rcs, sm - 1);
                else if ((lg - 1) * sm >= cells) $a48384f082433faa$var$large(rcs, lg - 1);
            } else // if rounding was too low, add rows or columns
            while(rcs.cols * rcs.rows < cells){
                const sm = $a48384f082433faa$var$small(rcs);
                const lg = $a48384f082433faa$var$large(rcs);
                // try to add to larger side first (adds less in multiplication)
                if ((lg + 1) * sm >= cells) $a48384f082433faa$var$large(rcs, lg + 1);
                else $a48384f082433faa$var$small(rcs, sm + 1);
            }
            let cellWidth = condense ? 0 : width / rcs.cols;
            let cellHeight = condense ? 0 : height / rcs.rows;
            if (preventOverlap || paramNodeSpacing) {
                const nodeSpacing = (0, $9RkJR.formatNumberFn)(10, paramNodeSpacing);
                const nodeSize = (0, $9RkJR.formatSizeFn)(30, paramNodeSize, false);
                layoutNodes.forEach((node)=>{
                    if (!node.data.x || !node.data.y) {
                        // for bb
                        node.data.x = 0;
                        node.data.y = 0;
                    }
                    const oNode = graph.getNode(node.id);
                    const [nodeW, nodeH] = (0, $lKWgx.parseSize)(nodeSize(oNode) || 30);
                    const p = nodeSpacing !== undefined ? nodeSpacing(node) : preventOverlapPadding;
                    const w = nodeW + p;
                    const h = nodeH + p;
                    cellWidth = Math.max(cellWidth, w);
                    cellHeight = Math.max(cellHeight, h);
                });
            }
            const cellUsed = {}; // e.g. 'c-0-2' => true
            // to keep track of current cell position
            const rc = {
                row: 0,
                col: 0
            };
            // get a cache of all the manual positions
            const id2manPos = {};
            for(let i = 0; i < layoutNodes.length; i++){
                const node = layoutNodes[i];
                let rcPos;
                if (position) // TODO: not sure the api name
                rcPos = position(graph.getNode(node.id));
                if (rcPos && (rcPos.row !== undefined || rcPos.col !== undefined)) {
                    // must have at least row or col def'd
                    const pos = {
                        row: rcPos.row,
                        col: rcPos.col
                    };
                    if (pos.col === undefined) {
                        // find unused col
                        pos.col = 0;
                        while($a48384f082433faa$var$used(cellUsed, pos))pos.col++;
                    } else if (pos.row === undefined) {
                        // find unused row
                        pos.row = 0;
                        while($a48384f082433faa$var$used(cellUsed, pos))pos.row++;
                    }
                    id2manPos[node.id] = pos;
                    $a48384f082433faa$var$use(cellUsed, pos);
                }
                $a48384f082433faa$var$getPos(node, begin, cellWidth, cellHeight, id2manPos, rcs, rc, cellUsed);
            }
            const result = {
                nodes: layoutNodes,
                edges: edges
            };
            if (assign) layoutNodes.forEach((node)=>{
                graph.mergeNodeData(node.id, {
                    x: node.data.x,
                    y: node.data.y
                });
            });
            return result;
        });
    }
}
const $a48384f082433faa$var$small = (rcs, val)=>{
    let res;
    const rows = rcs.rows || 5;
    const cols = rcs.cols || 5;
    if (val == null) res = Math.min(rows, cols);
    else {
        const min = Math.min(rows, cols);
        if (min === rcs.rows) rcs.rows = val;
        else rcs.cols = val;
    }
    return res;
};
const $a48384f082433faa$var$large = (rcs, val)=>{
    let result;
    const usedRows = rcs.rows || 5;
    const usedCols = rcs.cols || 5;
    if (val == null) result = Math.max(usedRows, usedCols);
    else {
        const max = Math.max(usedRows, usedCols);
        if (max === rcs.rows) rcs.rows = val;
        else rcs.cols = val;
    }
    return result;
};
const $a48384f082433faa$var$used = (cellUsed, rc)=>cellUsed[`c-${rc.row}-${rc.col}`] || false;
const $a48384f082433faa$var$use = (cellUsed, rc)=>cellUsed[`c-${rc.row}-${rc.col}`] = true;
const $a48384f082433faa$var$moveToNextCell = (rcs, rc)=>{
    const cols = rcs.cols || 5;
    rc.col++;
    if (rc.col >= cols) {
        rc.col = 0;
        rc.row++;
    }
};
const $a48384f082433faa$var$getPos = (node, begin, cellWidth, cellHeight, id2manPos, rcs, rc, cellUsed)=>{
    let x;
    let y;
    // see if we have a manual position set
    const rcPos = id2manPos[node.id];
    if (rcPos) {
        x = rcPos.col * cellWidth + cellWidth / 2 + begin[0];
        y = rcPos.row * cellHeight + cellHeight / 2 + begin[1];
    } else {
        // otherwise set automatically
        while($a48384f082433faa$var$used(cellUsed, rc))$a48384f082433faa$var$moveToNextCell(rcs, rc);
        x = rc.col * cellWidth + cellWidth / 2 + begin[0];
        y = rc.row * cellHeight + cellHeight / 2 + begin[1];
        $a48384f082433faa$var$use(cellUsed, rc);
        $a48384f082433faa$var$moveToNextCell(rcs, rc);
    }
    node.data.x = x;
    node.data.y = y;
};

});

parcelRegister("1aclp", function(module, exports) {

$parcel$export(module.exports, "RadialLayout", () => $0d904ced9895cada$export$e305311e38386ec3);

var $7WQrb = parcelRequire("7WQrb");

var $kVcyu = parcelRequire("kVcyu");

var $9nuNf = parcelRequire("9nuNf");
var $8e7dj = parcelRequire("8e7dj");
var $9RkJR = parcelRequire("9RkJR");

var $5Rnio = parcelRequire("5Rnio");

var $3RLoZ = parcelRequire("3RLoZ");

var $5Jmkc = parcelRequire("5Jmkc");
const $0d904ced9895cada$var$DEFAULTS_LAYOUT_OPTIONS = {
    maxIteration: 1000,
    focusNode: null,
    unitRadius: null,
    linkDistance: 50,
    preventOverlap: false,
    strictRadial: true,
    maxPreventOverlapIteration: 200,
    sortStrength: 10
};
class $0d904ced9895cada$export$e305311e38386ec3 {
    constructor(options = {}){
        this.options = options;
        this.id = 'radial';
        this.options = Object.assign(Object.assign({}, $0d904ced9895cada$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericRadialLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericRadialLayout(true, graph, options);
        });
    }
    genericRadialLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const mergedOptions = Object.assign(Object.assign({}, this.options), options);
            const { width: propsWidth, height: propsHeight, center: propsCenter, focusNode: propsFocusNode, unitRadius: propsUnitRadius, nodeSize: nodeSize, nodeSpacing: nodeSpacing, strictRadial: strictRadial, preventOverlap: preventOverlap, maxPreventOverlapIteration: maxPreventOverlapIteration, sortBy: sortBy, linkDistance: linkDistance = 50, sortStrength: sortStrength = 10, maxIteration: maxIteration = 1000 } = mergedOptions;
            const nodes = graph.getAllNodes();
            const edges = graph.getAllEdges();
            const width = !propsWidth && typeof window !== 'undefined' ? window.innerWidth : propsWidth;
            const height = !propsHeight && typeof window !== 'undefined' ? window.innerHeight : propsHeight;
            const center = !propsCenter ? [
                width / 2,
                height / 2
            ] : propsCenter;
            if (!(nodes === null || nodes === void 0 ? void 0 : nodes.length) || nodes.length === 1) return (0, $5Rnio.handleSingleNodeGraph)(graph, assign, center);
            let focusNode = nodes[0];
            if ((0, $kVcyu.default)(propsFocusNode)) {
                for(let i = 0; i < nodes.length; i++)if (nodes[i].id === propsFocusNode) {
                    focusNode = nodes[i];
                    break;
                }
            } else focusNode = propsFocusNode || nodes[0];
            // the index of the focusNode in data
            const focusIndex = $0d904ced9895cada$var$getIndexById(nodes, focusNode.id);
            // the graph-theoretic distance (shortest path distance) matrix
            const adjMatrix = (0, $8e7dj.getAdjMatrix)({
                nodes: nodes,
                edges: edges
            }, false);
            const distances = (0, $8e7dj.floydWarshall)(adjMatrix);
            const maxDistance = $0d904ced9895cada$var$maxToFocus(distances, focusIndex);
            // replace first node in unconnected component to the circle at (maxDistance + 1)
            $0d904ced9895cada$var$handleInfinity(distances, focusIndex, maxDistance + 1);
            // the shortest path distance from each node to focusNode
            const focusNodeD = distances[focusIndex];
            let semiWidth = width - center[0] > center[0] ? center[0] : width - center[0];
            let semiHeight = height - center[1] > center[1] ? center[1] : height - center[1];
            if (semiWidth === 0) semiWidth = width / 2;
            if (semiHeight === 0) semiHeight = height / 2;
            // the maxRadius of the graph
            const maxRadius = Math.min(semiWidth, semiHeight);
            const maxD = Math.max(...focusNodeD);
            // the radius for each nodes away from focusNode
            const radii = [];
            const unitRadius = !propsUnitRadius ? maxRadius / maxD : propsUnitRadius;
            focusNodeD.forEach((value, i)=>{
                radii[i] = value * unitRadius;
            });
            const idealDistances = $0d904ced9895cada$var$eIdealDisMatrix(nodes, distances, linkDistance, radii, unitRadius, sortBy, sortStrength);
            // the weight matrix, Wij = 1 / dij^(-2)
            const weights = $0d904ced9895cada$var$getWeightMatrix(idealDistances);
            // the initial positions from mds, move the graph to origin, centered at focusNode
            const mdsResult = (0, $3RLoZ.mds)(linkDistance, idealDistances, linkDistance);
            let positions = mdsResult.map(([x, y])=>({
                    x: (isNaN(x) ? Math.random() * linkDistance : x) - mdsResult[focusIndex][0],
                    y: (isNaN(y) ? Math.random() * linkDistance : y) - mdsResult[focusIndex][1]
                }));
            this.run(maxIteration, positions, weights, idealDistances, radii, focusIndex);
            let nodeSizeFunc;
            // stagger the overlapped nodes
            if (preventOverlap) {
                nodeSizeFunc = (0, $9RkJR.formatNodeSizeToNumber)(nodeSize, nodeSpacing);
                const nonoverlapForceParams = {
                    nodes: nodes,
                    nodeSizeFunc: nodeSizeFunc,
                    positions: positions,
                    radii: radii,
                    height: height,
                    width: width,
                    strictRadial: Boolean(strictRadial),
                    focusIdx: focusIndex,
                    iterations: maxPreventOverlapIteration || 200,
                    k: positions.length / 4.5
                };
                positions = (0, $5Jmkc.radialNonoverlapForce)(graph, nonoverlapForceParams);
            }
            // move the graph to center
            const layoutNodes = [];
            positions.forEach((p, i)=>{
                const cnode = (0, $9nuNf.cloneFormatData)(nodes[i]);
                cnode.data.x = p.x + center[0];
                cnode.data.y = p.y + center[1];
                layoutNodes.push(cnode);
            });
            if (assign) layoutNodes.forEach((node)=>graph.mergeNodeData(node.id, {
                    x: node.data.x,
                    y: node.data.y
                }));
            const result = {
                nodes: layoutNodes,
                edges: edges
            };
            return result;
        });
    }
    run(maxIteration, positions, weights, idealDistances, radii, focusIndex) {
        for(let i = 0; i <= maxIteration; i++){
            const param = i / maxIteration;
            this.oneIteration(param, positions, radii, idealDistances, weights, focusIndex);
        }
    }
    oneIteration(param, positions, radii, distances, weights, focusIndex) {
        const vparam = 1 - param;
        positions.forEach((v, i)=>{
            // v
            const originDis = (0, $8e7dj.getEuclideanDistance)(v, {
                x: 0,
                y: 0
            });
            const reciODis = originDis === 0 ? 0 : 1 / originDis;
            if (i === focusIndex) return;
            let xMolecule = 0;
            let yMolecule = 0;
            let denominator = 0;
            positions.forEach((u, j)=>{
                // u
                if (i === j) return;
                // the euclidean distance between v and u
                const edis = (0, $8e7dj.getEuclideanDistance)(v, u);
                const reciEdis = edis === 0 ? 0 : 1 / edis;
                const idealDis = distances[j][i];
                // same for x and y
                denominator += weights[i][j];
                // x
                xMolecule += weights[i][j] * (u.x + idealDis * (v.x - u.x) * reciEdis);
                // y
                yMolecule += weights[i][j] * (u.y + idealDis * (v.y - u.y) * reciEdis);
            });
            const reciR = radii[i] === 0 ? 0 : 1 / radii[i];
            denominator *= vparam;
            denominator += param * reciR * reciR;
            // x
            xMolecule *= vparam;
            xMolecule += param * reciR * v.x * reciODis;
            v.x = xMolecule / denominator;
            // y
            yMolecule *= vparam;
            yMolecule += param * reciR * v.y * reciODis;
            v.y = yMolecule / denominator;
        });
    }
}
const $0d904ced9895cada$var$eIdealDisMatrix = (nodes, distances, linkDistance, radii, unitRadius, sortBy, sortStrength)=>{
    if (!nodes) return [];
    const result = [];
    if (distances) {
        // cache the value of field sortBy for nodes to avoid dupliate calculation
        const sortValueCache = {};
        distances.forEach((row, i)=>{
            const newRow = [];
            row.forEach((v, j)=>{
                var _a, _b;
                if (i === j) newRow.push(0);
                else if (radii[i] === radii[j]) {
                    // i and j are on the same circle
                    if (sortBy === 'data') // sort the nodes on the same circle according to the ordering of the data
                    newRow.push(v * (Math.abs(i - j) * sortStrength) / (radii[i] / unitRadius));
                    else if (sortBy) {
                        // sort the nodes on the same circle according to the attributes
                        let iValue;
                        let jValue;
                        if (sortValueCache[nodes[i].id]) iValue = sortValueCache[nodes[i].id];
                        else {
                            const value = (sortBy === 'id' ? nodes[i].id : (_a = nodes[i].data) === null || _a === void 0 ? void 0 : _a[sortBy]) || 0;
                            if ((0, $kVcyu.default)(value)) iValue = value.charCodeAt(0);
                            else iValue = value;
                            sortValueCache[nodes[i].id] = iValue;
                        }
                        if (sortValueCache[nodes[j].id]) jValue = sortValueCache[nodes[j].id];
                        else {
                            const value = (sortBy === 'id' ? nodes[j].id : (_b = nodes[j].data) === null || _b === void 0 ? void 0 : _b[sortBy]) || 0;
                            if ((0, $kVcyu.default)(value)) jValue = value.charCodeAt(0);
                            else jValue = value;
                            sortValueCache[nodes[j].id] = jValue;
                        }
                        newRow.push(v * (Math.abs(iValue - jValue) * sortStrength) / (radii[i] / unitRadius));
                    } else newRow.push(v * linkDistance / (radii[i] / unitRadius));
                } else {
                    // i and j are on different circles
                    const link = (linkDistance + unitRadius) / 2;
                    newRow.push(v * link);
                }
            });
            result.push(newRow);
        });
    }
    return result;
};
const $0d904ced9895cada$var$getWeightMatrix = (idealDistances)=>{
    const rows = idealDistances.length;
    const cols = idealDistances[0].length;
    const result = [];
    for(let i = 0; i < rows; i++){
        const row = [];
        for(let j = 0; j < cols; j++)if (idealDistances[i][j] !== 0) row.push(1 / (idealDistances[i][j] * idealDistances[i][j]));
        else row.push(0);
        result.push(row);
    }
    return result;
};
const $0d904ced9895cada$var$getIndexById = (array, id)=>{
    let index = -1;
    array.forEach((a, i)=>{
        if (a.id === id) index = i;
    });
    return Math.max(index, 0);
};
const $0d904ced9895cada$var$handleInfinity = (matrix, focusIndex, step)=>{
    const length = matrix.length;
    // 遍历 matrix 中遍历 focus 对应行
    for(let i = 0; i < length; i++)// matrix 关注点对应行的 Inf 项
    if (matrix[focusIndex][i] === Infinity) {
        matrix[focusIndex][i] = step;
        matrix[i][focusIndex] = step;
        // 遍历 matrix 中的 i 行，i 行中非 Inf 项若在 focus 行为 Inf，则替换 focus 行的那个 Inf
        for(let j = 0; j < length; j++)if (matrix[i][j] !== Infinity && matrix[focusIndex][j] === Infinity) {
            matrix[focusIndex][j] = step + matrix[i][j];
            matrix[j][focusIndex] = step + matrix[i][j];
        }
    }
    // 处理其他行的 Inf。根据该行对应点与 focus 距离以及 Inf 项点 与 focus 距离，决定替换值
    for(let i = 0; i < length; i++){
        if (i === focusIndex) continue;
        for(let j = 0; j < length; j++)if (matrix[i][j] === Infinity) {
            let minus = Math.abs(matrix[focusIndex][i] - matrix[focusIndex][j]);
            minus = minus === 0 ? 1 : minus;
            matrix[i][j] = minus;
        }
    }
};
const $0d904ced9895cada$var$maxToFocus = (matrix, focusIndex)=>{
    let max = 0;
    for(let i = 0; i < matrix[focusIndex].length; i++){
        if (matrix[focusIndex][i] === Infinity) continue;
        max = matrix[focusIndex][i] > max ? matrix[focusIndex][i] : max;
    }
    return max;
};

});
parcelRegister("3RLoZ", function(module, exports) {

$parcel$export(module.exports, "mds", () => $2d0b176ab86dc95c$export$d708eb154746899c);

var $gGKJ4 = parcelRequire("gGKJ4");
var $aDK3x = parcelRequire("aDK3x");
const $2d0b176ab86dc95c$export$d708eb154746899c = (dimension, distances, linkDistance)=>{
    try {
        // square distances
        const M = (0, $gGKJ4.default).mul((0, $gGKJ4.default).pow(distances, 2), -0.5);
        // double centre the rows/columns
        const rowMeans = M.mean('row');
        const colMeans = M.mean('column');
        const totalMean = M.mean();
        M.add(totalMean).subRowVector(rowMeans).subColumnVector(colMeans);
        // take the SVD of the double centred matrix, and return the
        // points from it
        const ret = new (0, $aDK3x.default)(M);
        const eigenValues = (0, $gGKJ4.default).sqrt(ret.diagonalMatrix).diagonal();
        return ret.leftSingularVectors.toJSON().map((row)=>{
            return (0, $gGKJ4.default).mul([
                row
            ], [
                eigenValues
            ]).toJSON()[0].splice(0, dimension);
        });
    } catch (_a) {
        const res = [];
        for(let i = 0; i < distances.length; i++){
            const x = Math.random() * linkDistance;
            const y = Math.random() * linkDistance;
            res.push([
                x,
                y
            ]);
        }
        return res;
    }
};

});

parcelRegister("5Jmkc", function(module, exports) {

$parcel$export(module.exports, "radialNonoverlapForce", () => $42c278f277c7f780$export$53e8e49630801d47);
const $42c278f277c7f780$var$SPEED_DIVISOR = 800;
const $42c278f277c7f780$var$DEFAULTS_LAYOUT_OPTIONS = {
    iterations: 10,
    height: 10,
    width: 10,
    speed: 100,
    gravity: 10,
    k: 5
};
const $42c278f277c7f780$export$53e8e49630801d47 = (graph, options)=>{
    const mergedOptions = Object.assign(Object.assign({}, $42c278f277c7f780$var$DEFAULTS_LAYOUT_OPTIONS), options);
    const { positions: positions, iterations: iterations, width: width, k: k, speed: speed = 100, strictRadial: strictRadial, focusIdx: focusIdx, radii: radii = [], nodeSizeFunc: nodeSizeFunc } = mergedOptions;
    const nodes = graph.getAllNodes();
    const disp = [];
    const maxDisplace = width / 10;
    for(let i = 0; i < iterations; i++){
        positions.forEach((_, k)=>{
            disp[k] = {
                x: 0,
                y: 0
            };
        });
        // 给重叠的节点增加斥力
        $42c278f277c7f780$var$getRepulsion(nodes, positions, disp, k, radii, nodeSizeFunc);
        $42c278f277c7f780$var$updatePositions(positions, disp, speed, strictRadial, focusIdx, maxDisplace, width, radii);
    }
    return positions;
};
const $42c278f277c7f780$var$getRepulsion = (nodes, positions, disp, k, radii, nodeSizeFunc)=>{
    positions.forEach((v, i)=>{
        disp[i] = {
            x: 0,
            y: 0
        };
        positions.forEach((u, j)=>{
            if (i === j) return;
            // v and u are not on the same circle, return
            if (radii[i] !== radii[j]) return;
            let vecx = v.x - u.x;
            let vecy = v.y - u.y;
            let vecLength = Math.sqrt(vecx * vecx + vecy * vecy);
            if (vecLength === 0) {
                vecLength = 1;
                const sign = i > j ? 1 : -1;
                vecx = 0.01 * sign;
                vecy = 0.01 * sign;
            }
            // these two nodes overlap
            if (vecLength < nodeSizeFunc(nodes[i]) / 2 + nodeSizeFunc(nodes[j]) / 2) {
                const common = k * k / vecLength;
                disp[i].x += vecx / vecLength * common;
                disp[i].y += vecy / vecLength * common;
            }
        });
    });
};
const $42c278f277c7f780$var$updatePositions = (positions, disp, speed, strictRadial, focusIdx, maxDisplace, width, radii)=>{
    const maxDisp = maxDisplace || width / 10;
    if (strictRadial) disp.forEach((di, i)=>{
        const vx = positions[i].x - positions[focusIdx].x;
        const vy = positions[i].y - positions[focusIdx].y;
        const vLength = Math.sqrt(vx * vx + vy * vy);
        let vpx = vy / vLength;
        let vpy = -vx / vLength;
        const diLength = Math.sqrt(di.x * di.x + di.y * di.y);
        let alpha = Math.acos((vpx * di.x + vpy * di.y) / diLength);
        if (alpha > Math.PI / 2) {
            alpha -= Math.PI / 2;
            vpx *= -1;
            vpy *= -1;
        }
        const tdispLength = Math.cos(alpha) * diLength;
        di.x = vpx * tdispLength;
        di.y = vpy * tdispLength;
    });
    // move
    positions.forEach((n, i)=>{
        if (i === focusIdx) return;
        const distLength = Math.sqrt(disp[i].x * disp[i].x + disp[i].y * disp[i].y);
        if (distLength > 0 && i !== focusIdx) {
            const limitedDist = Math.min(maxDisp * (speed / $42c278f277c7f780$var$SPEED_DIVISOR), distLength);
            n.x += disp[i].x / distLength * limitedDist;
            n.y += disp[i].y / distLength * limitedDist;
            if (strictRadial) {
                let vx = n.x - positions[focusIdx].x;
                let vy = n.y - positions[focusIdx].y;
                const nfDis = Math.sqrt(vx * vx + vy * vy);
                vx = vx / nfDis * radii[i];
                vy = vy / nfDis * radii[i];
                n.x = positions[focusIdx].x + vx;
                n.y = positions[focusIdx].y + vy;
            }
        }
    });
    return positions;
};

});


parcelRegister("4JXd9", function(module, exports) {

$parcel$export(module.exports, "RandomLayout", () => $37394b786bc33bca$export$db32c96a7bc2e53e);

var $7WQrb = parcelRequire("7WQrb");
const $37394b786bc33bca$var$DEFAULTS_LAYOUT_OPTIONS = {
    center: [
        0,
        0
    ],
    width: 300,
    height: 300
};
class $37394b786bc33bca$export$db32c96a7bc2e53e {
    constructor(options = {}){
        this.options = options;
        this.id = 'random';
        this.options = Object.assign(Object.assign({}, $37394b786bc33bca$var$DEFAULTS_LAYOUT_OPTIONS), options);
    }
    /**
     * Return the positions of nodes and edges(if needed).
     */ execute(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            return this.genericRandomLayout(false, graph, options);
        });
    }
    /**
     * To directly assign the positions to the nodes.
     */ assign(graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            yield this.genericRandomLayout(true, graph, options);
        });
    }
    genericRandomLayout(assign, graph, options) {
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            const mergedOptions = Object.assign(Object.assign({}, this.options), options);
            const { center: propsCenter, width: propsWidth, height: propsHeight } = mergedOptions;
            const nodes = graph.getAllNodes();
            const layoutScale = 0.9;
            const width = !propsWidth && typeof window !== 'undefined' ? window.innerWidth : propsWidth;
            const height = !propsHeight && typeof window !== 'undefined' ? window.innerHeight : propsHeight;
            const center = !propsCenter ? [
                width / 2,
                height / 2
            ] : propsCenter;
            const layoutNodes = [];
            if (nodes) nodes.forEach((node)=>{
                layoutNodes.push({
                    id: node.id,
                    data: {
                        x: (Math.random() - 0.5) * layoutScale * width + center[0],
                        y: (Math.random() - 0.5) * layoutScale * height + center[1]
                    }
                });
            });
            if (assign) layoutNodes.forEach((node)=>graph.mergeNodeData(node.id, {
                    x: node.data.x,
                    y: node.data.y
                }));
            const result = {
                nodes: layoutNodes,
                edges: graph.getAllEdges()
            };
            return result;
        });
    }
}

});

parcelRegister("7C1fc", function(module, exports) {

$parcel$export(module.exports, "FishboneLayout", () => $58ad0c16f79df235$export$4d472c1bc45a6c9f);

var $hllqz = parcelRequire("hllqz");
var $amGwr = parcelRequire("amGwr");

var $brtTw = parcelRequire("brtTw");

var $e6Msm = parcelRequire("e6Msm");

var $ht4Ur = parcelRequire("ht4Ur");
var $58ad0c16f79df235$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $58ad0c16f79df235$export$4d472c1bc45a6c9f extends (0, $ht4Ur.BaseLayout) {
    constructor(){
        super(...arguments);
        this.id = 'fishbone';
    }
    getRoot() {
        const roots = this.context.model.getRootsData();
        if ((0, $hllqz.default)(roots) || roots.length > 2) return;
        return roots[0];
    }
    formatSize(nodeSize) {
        const nodeSizeFunc = typeof nodeSize === 'function' ? nodeSize : ()=>nodeSize;
        return (node)=>(0, $e6Msm.parseSize)(nodeSizeFunc(node));
    }
    doLayout(root, options) {
        const { hGap: hGap, getRibSep: getRibSep, vGap: vGap, nodeSize: nodeSize, height: height } = options;
        const { model: model } = this.context;
        const getSize = this.formatSize(nodeSize);
        let ribX = getSize(root)[0] + getRibSep(root);
        const getHorizontalOffset = (node, result = 0)=>{
            var _a;
            result += hGap * ((node.children || []).length + 1);
            (_a = node.children) === null || _a === void 0 || _a.forEach((childId)=>{
                var _a;
                const child = model.getNodeLikeDatum(childId);
                (_a = child.children) === null || _a === void 0 || _a.forEach((grandChildId)=>{
                    const grandChild = model.getNodeLikeDatum(grandChildId);
                    result = getHorizontalOffset(grandChild, result);
                });
            });
            return result;
        };
        const getAuxiliaryPoint = (node)=>{
            if (node.depth === 1) return ribX;
            const parent = model.getParentData(node.id, 'tree');
            if ($58ad0c16f79df235$var$isAtEvenDepth(node)) {
                const ancestor = model.getParentData(parent.id, 'tree');
                const deltaY = calculateY(node) - calculateY(ancestor);
                return getAuxiliaryPoint(parent) + deltaY * hGap / vGap;
            } else {
                const nodeIndex = (parent.children || []).indexOf(node.id);
                const followingSiblingsIncludeSelf = model.getNodeData((parent.children || []).slice(nodeIndex));
                return calculateX(parent) - followingSiblingsIncludeSelf.reduce((acc, sibling)=>acc + getHorizontalOffset(sibling), 0) - getSize(parent)[0] / 2;
            }
        };
        const calculateX = (0, $amGwr.default)((node)=>{
            if ($58ad0c16f79df235$var$isRoot(node)) return getSize(node)[0] / 2;
            const parent = model.getParentData(node.id, 'tree');
            if ($58ad0c16f79df235$var$isAtEvenDepth(node)) return getAuxiliaryPoint(node) + getHorizontalOffset(node) + getSize(node)[0] / 2;
            else {
                const deltaY = calculateY(node) - calculateY(parent);
                const ratio = hGap / vGap;
                return getAuxiliaryPoint(node) + deltaY * ratio;
            }
        }, (node)=>node.id);
        const getParentY = (nodeId)=>calculateY(model.getParentData(nodeId, 'tree'));
        const calculateY = (0, $amGwr.default)((node)=>{
            if ($58ad0c16f79df235$var$isRoot(node)) return height / 2;
            if (!$58ad0c16f79df235$var$isAtEvenDepth(node)) {
                // If the node has no children, calculate Y based on the parent
                if ((0, $hllqz.default)(node.children)) return getParentY(node.id) + vGap;
                // If the last child has no children, calculate Y based on the last child
                const lastChild = model.getNodeLikeDatum(node.children.slice(-1)[0]);
                if ((0, $hllqz.default)(lastChild.children)) return calculateY(lastChild) + vGap;
                // If the last child has children, calculate Y based on the last descendant of the last child
                const lastDescendant = model.getDescendantsData(node.id).slice(-1)[0];
                return ($58ad0c16f79df235$var$isAtEvenDepth(lastDescendant) ? getParentY(lastDescendant.id) : calculateY(lastDescendant)) + vGap;
            } else {
                // depth > 0 && isAtEvenDepth(node)
                const parent = model.getParentData(node.id, 'tree');
                const nodeIndex = parent.children.indexOf(node.id);
                // If the node is the first sibling, return Y based on parent
                if (nodeIndex === 0) return getParentY(parent.id) + vGap;
                // If the previous sibling has no children, calculate Y based on the previous sibling
                const prevSibling = model.getNodeLikeDatum(parent.children[nodeIndex - 1]);
                if ((0, $hllqz.default)(prevSibling.children)) return calculateY(prevSibling) + vGap;
                // If the previous sibling has children, calculate Y based on the last descendant of the previous sibling
                const descendants = model.getDescendantsData(prevSibling.id);
                return Math.max(...descendants.map((descendant)=>$58ad0c16f79df235$var$isAtEvenDepth(descendant) ? getParentY(descendant.id) : calculateY(descendant))) + vGap;
            }
        }, (node)=>node.id);
        let tmpRibX = 0;
        const result = {
            nodes: [],
            edges: []
        };
        const layout = (node)=>{
            var _a;
            (_a = node.children) === null || _a === void 0 || _a.forEach((childId)=>layout(model.getNodeLikeDatum(childId)));
            const y = calculateY(node);
            const x = calculateX(node);
            result.nodes.push({
                id: node.id,
                x: x,
                y: y
            });
            if ($58ad0c16f79df235$var$isRoot(node)) return;
            const edge = model.getRelatedEdgesData(node.id, 'in')[0];
            const controlPoint = [
                getAuxiliaryPoint(node),
                $58ad0c16f79df235$var$isAtEvenDepth(node) ? y : getParentY(node.id)
            ];
            result.edges.push({
                id: (0, $brtTw.idOf)(edge),
                controlPoints: [
                    controlPoint
                ],
                relatedNodeId: node.id
            });
            tmpRibX = Math.max(tmpRibX, x + getRibSep(node));
            if (node.depth === 1) ribX = tmpRibX;
        };
        layout(root);
        return result;
    }
    placeAlterative(result, root) {
        const oddIndexedRibs = (root.children || []).filter((_, index)=>index % 2 !== 0);
        if (oddIndexedRibs.length === 0) return result;
        const { model: model } = this.context;
        const rootY = result.nodes.find((node)=>node.id === root.id).y;
        const shouldFlip = (nodeId)=>{
            const ancestors = model.getAncestorsData(nodeId, 'tree');
            if ((0, $hllqz.default)(ancestors)) return false;
            const ribId = ancestors.length === 1 ? nodeId : ancestors[ancestors.length - 2].id;
            return oddIndexedRibs.includes(ribId);
        };
        result.nodes.forEach((node)=>{
            if (shouldFlip(node.id)) node.y = 2 * rootY - node.y;
        });
        result.edges.forEach((edge)=>{
            if (shouldFlip(edge.relatedNodeId)) edge.controlPoints = edge.controlPoints.map((point)=>[
                    point[0],
                    2 * rootY - point[1]
                ]);
        });
    }
    rightToLeft(result, options) {
        result.nodes.forEach((node)=>node.x = options.width - node.x);
        result.edges.forEach((edge)=>{
            edge.controlPoints = edge.controlPoints.map((point)=>[
                    options.width - point[0],
                    point[1]
                ]);
        });
        return result;
    }
    execute(data, propOptions) {
        return $58ad0c16f79df235$var$__awaiter(this, void 0, void 0, function*() {
            const options = Object.assign(Object.assign(Object.assign({}, $58ad0c16f79df235$export$4d472c1bc45a6c9f.defaultOptions), this.options), propOptions);
            const { direction: direction, nodeSize: nodeSize } = options;
            const root = this.getRoot();
            if (!root) return data;
            const getSize = this.formatSize(nodeSize);
            options.vGap || (options.vGap = Math.max(...(data.nodes || []).map((node)=>getSize(node)[1])));
            options.hGap || (options.hGap = Math.max(...(data.nodes || []).map((node)=>getSize(node)[0])));
            let result = this.doLayout(root, options);
            this.placeAlterative(result, root);
            if (direction === 'RL') result = this.rightToLeft(result, options);
            const { model: model } = this.context;
            const nodes = [];
            const edges = [];
            result.nodes.forEach((node)=>{
                const { id: id, x: x, y: y } = node;
                const nodeData = model.getNodeLikeDatum(id);
                nodes.push($58ad0c16f79df235$var$assignElementStyle(nodeData, {
                    x: x,
                    y: y
                }));
            });
            result.edges.forEach((edge)=>{
                const { id: id, controlPoints: controlPoints } = edge;
                const edgeData = model.getEdgeDatum(id);
                edges.push($58ad0c16f79df235$var$assignElementStyle(edgeData, {
                    controlPoints: controlPoints
                }));
            });
            return {
                nodes: nodes,
                edges: edges
            };
        });
    }
}
$58ad0c16f79df235$export$4d472c1bc45a6c9f.defaultOptions = {
    direction: 'RL',
    getRibSep: ()=>60
};
const $58ad0c16f79df235$var$assignElementStyle = (element, style)=>{
    return Object.assign(Object.assign({}, element), {
        style: Object.assign(Object.assign({}, element.style || {}), style)
    });
};
const $58ad0c16f79df235$var$isRoot = (node)=>node.depth === 0;
const $58ad0c16f79df235$var$isAtEvenDepth = (node)=>(node.depth || (node.depth = 0)) % 2 === 0;

});
parcelRegister("amGwr", function(module, exports) {

$parcel$export(module.exports, "default", () => $78bcf17c4acee91a$export$2e2bcd8739ae039);
function $78bcf17c4acee91a$var$flru(max) {
    var num, curr, prev;
    var limit = max || 1;
    function keep(key, value) {
        if (++num > limit) {
            prev = curr;
            reset(1);
            ++num;
        }
        curr[key] = value;
    }
    function reset(isPartial) {
        num = 0;
        curr = Object.create(null);
        isPartial || (prev = Object.create(null));
    }
    reset();
    return {
        clear: reset,
        has: function(key) {
            return curr[key] !== void 0 || prev[key] !== void 0;
        },
        get: function(key) {
            var val = curr[key];
            if (val !== void 0) return val;
            if ((val = prev[key]) !== void 0) {
                keep(key, val);
                return val;
            }
        },
        set: function(key, value) {
            if (curr[key] !== void 0) curr[key] = value;
            else keep(key, value);
        }
    };
}
var $78bcf17c4acee91a$var$CacheMap = new Map();
function $78bcf17c4acee91a$export$2e2bcd8739ae039(fn, resolver, maxSize) {
    if (maxSize === void 0) maxSize = 128;
    var memoized = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // 使用方法构造 key，如果不存在 resolver，则直接取第一个参数作为 key
        var key = resolver ? resolver.apply(this, args) : args[0];
        if (!$78bcf17c4acee91a$var$CacheMap.has(fn)) $78bcf17c4acee91a$var$CacheMap.set(fn, $78bcf17c4acee91a$var$flru(maxSize));
        var cache = $78bcf17c4acee91a$var$CacheMap.get(fn);
        if (cache.has(key)) return cache.get(key);
        var result = fn.apply(this, args);
        cache.set(key, result);
        return result;
    };
    return memoized;
}

});


parcelRegister("2D9MF", function(module, exports) {

$parcel$export(module.exports, "SnakeLayout", () => $1ea6d02b63a37554$export$62a0ec3ef00557ae);

var $1uR12 = parcelRequire("1uR12");

var $e6Msm = parcelRequire("e6Msm");

var $ht4Ur = parcelRequire("ht4Ur");
var $1ea6d02b63a37554$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $1ea6d02b63a37554$export$62a0ec3ef00557ae extends (0, $ht4Ur.BaseLayout) {
    constructor(){
        super(...arguments);
        this.id = 'snake';
    }
    formatSize(nodes, size) {
        const sizeFn = typeof size === 'function' ? size : ()=>size;
        return nodes.reduce((acc, node)=>{
            const [w, h] = (0, $e6Msm.parseSize)(sizeFn(node)) || [
                0,
                0
            ];
            return [
                Math.max(acc[0], w),
                Math.max(acc[1], h)
            ];
        }, [
            0,
            0
        ]);
    }
    /**
     * Validates the graph data to ensure it meets the requirements for linear arrangement.
     * @param data - Graph data
     * @returns false if the graph is not connected, has more than one source or sink node, or contains cycles.
     */ validate(data) {
        const { nodes: nodes = [], edges: edges = [] } = data;
        const inDegree = {};
        const outDegree = {};
        const adjList = {};
        nodes.forEach((node)=>{
            inDegree[node.id] = 0;
            outDegree[node.id] = 0;
            adjList[node.id] = [];
        });
        edges.forEach((edge)=>{
            inDegree[edge.target]++;
            outDegree[edge.source]++;
            adjList[edge.source].push(edge.target);
        });
        // 检查图是否连通
        // Check if the graph is connected
        const visited = new Set();
        const dfs = (nodeId)=>{
            if (visited.has(nodeId)) return;
            visited.add(nodeId);
            adjList[nodeId].forEach(dfs);
        };
        dfs(nodes[0].id);
        if (visited.size !== nodes.length) return false;
        // 检查是否有且仅有一个源节点和一个汇节点
        // Check if there is exactly one source node and one sink node
        const sourceNodes = nodes.filter((node)=>inDegree[node.id] === 0);
        const sinkNodes = nodes.filter((node)=>outDegree[node.id] === 0);
        if (sourceNodes.length !== 1 || sinkNodes.length !== 1) return false;
        // 检查中间节点是否只有一个前驱和一个后继
        // Check if the middle nodes have only one predecessor and one successor
        const middleNodes = nodes.filter((node)=>inDegree[node.id] === 1 && outDegree[node.id] === 1);
        if (middleNodes.length !== nodes.length - 2) return false;
        return true;
    }
    execute(model, options) {
        return $1ea6d02b63a37554$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!this.validate(model)) return model;
            const { nodeSize: propNodeSize, padding: propPadding, sortBy: sortBy, cols: cols, colGap: propColSep, rowGap: propRowSep, clockwise: clockwise, width: width, height: height } = Object.assign({}, $1ea6d02b63a37554$export$62a0ec3ef00557ae.defaultOptions, this.options, options);
            const [top, right, bottom, left] = (0, $1uR12.parsePadding)(propPadding);
            const nodeSize = this.formatSize(model.nodes || [], propNodeSize);
            const rows = Math.ceil((model.nodes || []).length / cols);
            let colSep = propColSep ? propColSep : (width - left - right - cols * nodeSize[0]) / (cols - 1);
            let rowSep = propRowSep ? propRowSep : (height - top - bottom - rows * nodeSize[1]) / (rows - 1);
            if (rowSep === Infinity || rowSep < 0) rowSep = 0;
            if (colSep === Infinity || colSep < 0) colSep = 0;
            const sortedNodes = sortBy ? (_a = model.nodes) === null || _a === void 0 ? void 0 : _a.sort(sortBy) : $1ea6d02b63a37554$var$topologicalSort(model);
            const nodes = (sortedNodes || []).map((node, index)=>{
                const rowIndex = Math.floor(index / cols);
                const colIndex = index % cols;
                const actualColIndex = clockwise ? rowIndex % 2 === 0 ? colIndex : cols - 1 - colIndex : rowIndex % 2 === 0 ? cols - 1 - colIndex : colIndex;
                const x = left + actualColIndex * (nodeSize[0] + colSep) + nodeSize[0] / 2;
                const y = top + rowIndex * (nodeSize[1] + rowSep) + nodeSize[1] / 2;
                return {
                    id: node.id,
                    style: {
                        x: x,
                        y: y
                    }
                };
            });
            return {
                nodes: nodes
            };
        });
    }
}
$1ea6d02b63a37554$export$62a0ec3ef00557ae.defaultOptions = {
    padding: 0,
    cols: 5,
    clockwise: true
};
/**
 * Topological sorting. The nodes are sorted according to the order of the paths(from the start node to the end node).
 * @param data - Graph data
 * @returns Sorted nodes
 */ function $1ea6d02b63a37554$var$topologicalSort(data) {
    const { nodes: nodes = [], edges: edges = [] } = data;
    const inDegree = {};
    const adjList = {};
    nodes.forEach((node)=>{
        inDegree[node.id] = 0;
        adjList[node.id] = [];
    });
    edges.forEach((edge)=>{
        inDegree[edge.target]++;
        adjList[edge.source].push(edge.target);
    });
    const queue = [];
    const sortedNodes = [];
    nodes.forEach((node)=>{
        if (inDegree[node.id] === 0) queue.push(node.id);
    });
    while(queue.length > 0){
        const nodeId = queue.shift();
        const node = nodes.find((n)=>n.id === nodeId);
        sortedNodes.push(node);
        adjList[nodeId].forEach((neighbor)=>{
            inDegree[neighbor]--;
            if (inDegree[neighbor] === 0) queue.push(neighbor);
        });
    }
    return sortedNodes;
}

});


parcelRegister("sm1F8", function(module, exports) {

$parcel$export(module.exports, "spectral", () => $0553b381f17a04d5$export$e0ccf6166915bd59);
$parcel$export(module.exports, "tableau", () => $0553b381f17a04d5$export$a31b405862ec3f69);
$parcel$export(module.exports, "oranges", () => $0553b381f17a04d5$export$4481b33599629aa4);
$parcel$export(module.exports, "greens", () => $0553b381f17a04d5$export$534b04b9576bcd9a);
$parcel$export(module.exports, "blues", () => $0553b381f17a04d5$export$c93688a1530e5956);
/**
 * <zh/> 内置色板
 *
 * <en/> Built-in palettes
 */ const $0553b381f17a04d5$export$e0ccf6166915bd59 = [
    'rgb(158, 1, 66)',
    'rgb(213, 62, 79)',
    'rgb(244, 109, 67)',
    'rgb(253, 174, 97)',
    'rgb(254, 224, 139)',
    'rgb(255, 255, 191)',
    'rgb(230, 245, 152)',
    'rgb(171, 221, 164)',
    'rgb(102, 194, 165)',
    'rgb(50, 136, 189)',
    'rgb(94, 79, 162)'
];
const $0553b381f17a04d5$export$a31b405862ec3f69 = [
    'rgb(78, 121, 167)',
    'rgb(242, 142, 44)',
    'rgb(225, 87, 89)',
    'rgb(118, 183, 178)',
    'rgb(89, 161, 79)',
    'rgb(237, 201, 73)',
    'rgb(175, 122, 161)',
    'rgb(255, 157, 167)',
    'rgb(156, 117, 95)',
    'rgb(186, 176, 171)'
];
const $0553b381f17a04d5$export$4481b33599629aa4 = [
    'rgb(255, 245, 235)',
    'rgb(254, 230, 206)',
    'rgb(253, 208, 162)',
    'rgb(253, 174, 107)',
    'rgb(253, 141, 60)',
    'rgb(241, 105, 19)',
    'rgb(217, 72, 1)',
    'rgb(166, 54, 3)',
    'rgb(127, 39, 4)'
];
const $0553b381f17a04d5$export$534b04b9576bcd9a = [
    'rgb(247, 252, 245)',
    'rgb(229, 245, 224)',
    'rgb(199, 233, 192)',
    'rgb(161, 217, 155)',
    'rgb(116, 196, 118)',
    'rgb(65, 171, 93)',
    'rgb(35, 139, 69)',
    'rgb(0, 109, 44)',
    'rgb(0, 68, 27)'
];
const $0553b381f17a04d5$export$c93688a1530e5956 = [
    'rgb(247, 251, 255)',
    'rgb(222, 235, 247)',
    'rgb(198, 219, 239)',
    'rgb(158, 202, 225)',
    'rgb(107, 174, 214)',
    'rgb(66, 146, 198)',
    'rgb(33, 113, 181)',
    'rgb(8, 81, 156)',
    'rgb(8, 48, 107)'
];

});

parcelRegister("i257J", function(module, exports) {

$parcel$export(module.exports, "Background", () => (parcelRequire("3uNWk")).Background);
$parcel$export(module.exports, "BubbleSets", () => (parcelRequire("isds8")).BubbleSets);
$parcel$export(module.exports, "Contextmenu", () => (parcelRequire("4XBSa")).Contextmenu);
$parcel$export(module.exports, "EdgeBundling", () => (parcelRequire("1uN78")).EdgeBundling);
$parcel$export(module.exports, "EdgeFilterLens", () => (parcelRequire("cCF4r")).EdgeFilterLens);
$parcel$export(module.exports, "Fisheye", () => (parcelRequire("5OSjO")).Fisheye);
$parcel$export(module.exports, "Fullscreen", () => (parcelRequire("bbw6O")).Fullscreen);
$parcel$export(module.exports, "GridLine", () => (parcelRequire("86w7z")).GridLine);
$parcel$export(module.exports, "History", () => (parcelRequire("cqIFg")).History);
$parcel$export(module.exports, "Hull", () => (parcelRequire("7ZR3h")).Hull);
$parcel$export(module.exports, "Legend", () => (parcelRequire("7C4rJ")).Legend);
$parcel$export(module.exports, "Minimap", () => (parcelRequire("gICz0")).Minimap);
$parcel$export(module.exports, "Snapline", () => (parcelRequire("bU3Ie")).Snapline);
$parcel$export(module.exports, "Timebar", () => (parcelRequire("7Ns1A")).Timebar);
$parcel$export(module.exports, "Title", () => (parcelRequire("ly6UE")).Title);
$parcel$export(module.exports, "Toolbar", () => (parcelRequire("4Phbm")).Toolbar);
$parcel$export(module.exports, "Tooltip", () => (parcelRequire("fha4x")).Tooltip);
$parcel$export(module.exports, "Watermark", () => (parcelRequire("7mp9z")).Watermark);

var $3uNWk = parcelRequire("3uNWk");

var $WdqOS = parcelRequire("WdqOS");

var $isds8 = parcelRequire("isds8");

var $fuTQ7 = parcelRequire("fuTQ7");

var $4XBSa = parcelRequire("4XBSa");

var $1uN78 = parcelRequire("1uN78");

var $cCF4r = parcelRequire("cCF4r");

var $5OSjO = parcelRequire("5OSjO");

var $bbw6O = parcelRequire("bbw6O");

var $86w7z = parcelRequire("86w7z");

var $cqIFg = parcelRequire("cqIFg");

var $7ZR3h = parcelRequire("7ZR3h");

var $7C4rJ = parcelRequire("7C4rJ");

var $gICz0 = parcelRequire("gICz0");

var $bU3Ie = parcelRequire("bU3Ie");

var $7Ns1A = parcelRequire("7Ns1A");

var $ly6UE = parcelRequire("ly6UE");

var $4Phbm = parcelRequire("4Phbm");

var $fha4x = parcelRequire("fha4x");

var $7mp9z = parcelRequire("7mp9z");

});
parcelRegister("3uNWk", function(module, exports) {

$parcel$export(module.exports, "Background", () => $28bae96b00333134$export$668799e4797757a8);

var $64w8j = parcelRequire("64w8j");

var $WdqOS = parcelRequire("WdqOS");

var $bEb16 = parcelRequire("bEb16");
var $28bae96b00333134$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $28bae96b00333134$export$668799e4797757a8 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $28bae96b00333134$export$668799e4797757a8.defaultOptions, options));
        this.$element = (0, $bEb16.createPluginContainer)('background');
        const $container = this.context.canvas.getContainer();
        $container.prepend(this.$element);
        this.update(options);
    }
    /**
     * <zh/> 更新背景图配置
     *
     * <en/> Update the background image configuration
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */ update(options) {
        const _super = Object.create(null, {
            update: {
                get: ()=>super.update
            }
        });
        return $28bae96b00333134$var$__awaiter(this, void 0, void 0, function*() {
            _super.update.call(this, options);
            // Set the background style.
            Object.assign(this.$element.style, (0, $64w8j.default)(this.options, [
                'key',
                'type'
            ]));
        });
    }
    /**
     * <zh/> 销毁背景图
     *
     * <en/> Destroy the background image
     * @internal
     */ destroy() {
        super.destroy();
        // Remove the background dom.
        this.$element.remove();
    }
}
$28bae96b00333134$export$668799e4797757a8.defaultOptions = {
    transition: 'background 0.5s',
    backgroundSize: 'cover',
    zIndex: '-1'
};

});
parcelRegister("64w8j", function(module, exports) {

$parcel$export(module.exports, "default", () => $46bc0ac1fb103796$export$2e2bcd8739ae039);

var $27M7y = parcelRequire("27M7y");
var $46bc0ac1fb103796$export$2e2bcd8739ae039 = function(obj, keys) {
    return (0, $27M7y.default)(obj, function(r, curr, key) {
        if (!keys.includes(key)) r[key] = curr;
        return r;
    }, {});
};

});
parcelRegister("27M7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $18c19006ac096945$export$2e2bcd8739ae039);

var $dZz8z = parcelRequire("dZz8z");

var $1uF5a = parcelRequire("1uF5a");

var $1RAzq = parcelRequire("1RAzq");
var $18c19006ac096945$var$reduce = function(arr, fn, init) {
    if (!(0, $1uF5a.default)(arr) && !(0, $1RAzq.default)(arr)) return arr;
    var result = init;
    (0, $dZz8z.default)(arr, function(data, i) {
        result = fn(result, data, i);
    });
    return result;
};
var $18c19006ac096945$export$2e2bcd8739ae039 = $18c19006ac096945$var$reduce;

});


parcelRegister("WdqOS", function(module, exports) {

$parcel$export(module.exports, "BasePlugin", () => $0aefd6200013b9b7$export$af2591e7a96958a7);

var $dhEO8 = parcelRequire("dhEO8");
class $0aefd6200013b9b7$export$af2591e7a96958a7 extends (0, $dhEO8.BaseExtension) {
}

});

parcelRegister("bEb16", function(module, exports) {

$parcel$export(module.exports, "createPluginContainer", () => $87abf9dc938de0a9$export$53a6dd7f7eb12a06);
$parcel$export(module.exports, "insertDOM", () => $87abf9dc938de0a9$export$c91098b6873026a2);
/**
 * <zh/> 创建插件容器
 *
 * <en/> Create a plugin container
 * @param type - <zh/> 插件类型 | <en/> plugin type
 * @param cover - <zh/> 容器是否覆盖整个画布 | <en/> Whether the container covers the entire canvas
 * @param style - <zh/> 额外样式 | <en/> Additional style
 * @returns <zh/> 插件容器 | <en/> plugin container
 */ function $87abf9dc938de0a9$export$53a6dd7f7eb12a06(type, cover = true, style) {
    const container = document.createElement('div');
    container.setAttribute('class', `g6-${type}`);
    Object.assign(container.style, {
        position: 'absolute',
        display: 'block'
    });
    if (cover) Object.assign(container.style, {
        position: 'unset',
        gridArea: '1 / 1 / 2 / 2',
        inset: '0px',
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        pointerEvents: 'none'
    });
    if (style) Object.assign(container.style, style);
    return container;
}
function $87abf9dc938de0a9$export$c91098b6873026a2(id, tag = 'div', style = {}, innerHTML = '', container = document.body) {
    const dom = document.getElementById(id);
    if (dom) dom.remove();
    const div = document.createElement(tag);
    div.innerHTML = innerHTML;
    div.id = id;
    Object.assign(div.style, style);
    container.appendChild(div);
    return div;
}

});


parcelRegister("isds8", function(module, exports) {

$parcel$export(module.exports, "BubbleSets", () => $d6f546f4e7ad6c1a$export$b0964bf07e78d5cb);

var $iE4so = parcelRequire("iE4so");
var $4ETMA = parcelRequire("4ETMA");
var $ky7aH = parcelRequire("ky7aH");

var $2T5TZ = parcelRequire("2T5TZ");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");
parcelRequire("hIZ0D");
var $jZN6o = parcelRequire("jZN6o");

var $6BVcW = parcelRequire("6BVcW");

var $6SQtU = parcelRequire("6SQtU");

var $brtTw = parcelRequire("brtTw");

var $oZkEc = parcelRequire("oZkEc");

var $dnXls = parcelRequire("dnXls");

var $WdqOS = parcelRequire("WdqOS");
var $d6f546f4e7ad6c1a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $d6f546f4e7ad6c1a$export$b0964bf07e78d5cb extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, (0, $iE4so.default)({}, $d6f546f4e7ad6c1a$export$b0964bf07e78d5cb.defaultOptions, options));
        this.path = null;
        this.members = new Map();
        this.avoidMembers = new Map();
        this.bubbleSetOptions = {};
        this.drawBubbleSets = ()=>{
            const { style: style, bubbleSetOptions: bubbleSetOptions } = this.parseOptions();
            if (!(0, $4ETMA.default)(this.bubbleSetOptions, bubbleSetOptions)) this.init();
            this.bubbleSetOptions = Object.assign({}, bubbleSetOptions);
            const finalStyle = Object.assign(Object.assign({}, style), {
                d: this.getPath()
            });
            if (!this.shape) {
                this.shape = new (0, $jZN6o.Contour)({
                    style: finalStyle
                });
                this.context.canvas.appendChild(this.shape);
            } else this.shape.update(finalStyle);
        };
        this.updateBubbleSetsPath = (event)=>{
            if (!this.shape) return;
            const id = (0, $brtTw.idOf)(event.data);
            if (![
                ...this.options.members,
                ...this.options.avoidMembers
            ].includes(id)) return;
            this.shape.update(Object.assign(Object.assign({}, this.parseOptions().style), {
                d: this.getPath(id)
            }));
        };
        this.getPath = (forceUpdateId)=>{
            const { graph: graph } = this.context;
            const currMembers = this.options.members;
            const prevMembers = [
                ...this.members.keys()
            ];
            const currAvoidMembers = this.options.avoidMembers;
            const prevAvoidMembers = [
                ...this.avoidMembers.keys()
            ];
            if (currMembers.length === 0 && currAvoidMembers.length === 0) {
                this.members.clear();
                this.avoidMembers.clear();
                this.path = [];
                return this.path;
            }
            if (!forceUpdateId && this.path && (0, $4ETMA.default)(currMembers, prevMembers) && (0, $4ETMA.default)(currAvoidMembers, prevAvoidMembers)) return this.path;
            const { enter: membersToEnter = [], exit: membersToExit = [] } = (0, $6SQtU.arrayDiff)(prevMembers, currMembers, (d)=>d);
            const { enter: avoidMembersToEnter = [], exit: avoidMembersToExit = [] } = (0, $6SQtU.arrayDiff)(prevAvoidMembers, currAvoidMembers, (d)=>d);
            if (forceUpdateId) {
                const isMemberNow = currMembers.includes(forceUpdateId);
                const isAvoidNow = currAvoidMembers.includes(forceUpdateId);
                if (isMemberNow) {
                    membersToExit.push(forceUpdateId);
                    membersToEnter.push(forceUpdateId);
                }
                if (isAvoidNow) {
                    avoidMembersToExit.push(forceUpdateId);
                    avoidMembersToEnter.push(forceUpdateId);
                }
            }
            const updateBubbleSets = (ids, isEntering, isMember)=>{
                ids.forEach((id)=>{
                    const members = isMember ? this.members : this.avoidMembers;
                    const pushMember = isMember ? 'pushMember' : 'pushNonMember';
                    const removeMember = isMember ? 'removeMember' : 'removeNonMember';
                    if (isEntering) {
                        let area;
                        if (graph.getElementType(id) === 'edge') {
                            [area] = $d6f546f4e7ad6c1a$var$convertToLine(graph, id);
                            this.bubbleSets.pushEdge(area);
                        } else {
                            [area] = $d6f546f4e7ad6c1a$var$convertToRectangle(graph, id);
                            this.bubbleSets[pushMember](area);
                        }
                        members.set(id, area);
                    } else {
                        const area = members.get(id);
                        if (area) {
                            if (graph.getElementType(id) === 'edge') this.bubbleSets.removeEdge(area);
                            else this.bubbleSets[removeMember](area);
                            members.delete(id);
                        }
                    }
                });
            };
            updateBubbleSets(membersToExit, false, true);
            updateBubbleSets(membersToEnter, true, true);
            updateBubbleSets(avoidMembersToExit, false, false);
            updateBubbleSets(avoidMembersToEnter, true, false);
            const pointPath = this.bubbleSets.compute();
            const cleanPath = pointPath.sample(8).simplify(0).bSplines().simplify(0);
            this.path = (0, $oZkEc.getClosedSpline)(cleanPath.points.map((0, $dnXls.parsePoint)));
            return this.path;
        };
        this.bindEvents();
        this.bubbleSets = new (0, $2T5TZ.BubbleSets)(this.options);
    }
    bindEvents() {
        this.context.graph.on((0, $4EzN9.GraphEvent).AFTER_RENDER, this.drawBubbleSets);
        this.context.graph.on((0, $4EzN9.GraphEvent).AFTER_ELEMENT_UPDATE, this.updateBubbleSetsPath);
    }
    init() {
        this.bubbleSets = new (0, $2T5TZ.BubbleSets)(this.options);
        this.members.clear();
        this.avoidMembers.clear();
        this.path = null;
    }
    parseOptions() {
        const _a = this.options, { type: type, key: key, members: members, avoidMembers: avoidMembers } = _a, rest = $d6f546f4e7ad6c1a$var$__rest(_a, [
            "type",
            "key",
            "members",
            "avoidMembers"
        ]);
        const res = Object.keys(rest).reduce((acc, key)=>{
            if (key in (0, $2T5TZ.defaultOptions)) acc.bubbleSetOptions[key] = rest[key];
            else acc.style[key] = rest[key];
            return acc;
        }, {
            style: {},
            bubbleSetOptions: {}
        });
        return Object.assign({
            type: type,
            key: key,
            members: members,
            avoidMembers: avoidMembers
        }, res);
    }
    /**
     * <zh/> 添加成员元素
     *
     * <en/> Add member elements
     * @param members - <zh/> 单个或多个 | <en/> single or multiple
     */ addMember(members) {
        const membersToAdd = Array.isArray(members) ? members : [
            members
        ];
        if (membersToAdd.some((member)=>this.options.avoidMembers.includes(member))) this.options.avoidMembers = this.options.avoidMembers.filter((id)=>!membersToAdd.includes(id));
        this.options.members = [
            ...new Set([
                ...this.options.members,
                ...membersToAdd
            ])
        ];
        this.drawBubbleSets();
    }
    /**
     * <zh/> 移除成员元素
     *
     * <en/> Remove member elements
     * @param members - <zh/> 单个或多个 | <en/> single or multiple
     */ removeMember(members) {
        const membersToRemove = Array.isArray(members) ? members : [
            members
        ];
        this.options.members = this.options.members.filter((id)=>!membersToRemove.includes(id));
        this.drawBubbleSets();
    }
    /**
     * <zh/> 更新成员元素
     *
     * <en/> Update member elements
     * @param members - <zh/> 值或者回调函数 | <en/> value or callback function
     */ updateMember(members) {
        this.options.members = (0, $ky7aH.default)(members) ? members(this.options.members) : members;
        this.drawBubbleSets();
    }
    /**
     * <zh/> 获取成员元素
     *
     * <en/> Get member elements
     * @returns <zh/> 成员元素数组 | <en/> member elements array
     */ getMember() {
        return this.options.members;
    }
    /**
     * <zh/> 添加需要避开的元素
     *
     * <en/> Add elements to avoid
     * @param avoidMembers - <zh/> 单个或多个 | <en/> single or multiple
     */ addAvoidMember(avoidMembers) {
        const avoidMembersToAdd = Array.isArray(avoidMembers) ? avoidMembers : [
            avoidMembers
        ];
        if (avoidMembersToAdd.some((avoidMember)=>this.options.members.includes(avoidMember))) this.options.members = this.options.members.filter((id)=>!avoidMembersToAdd.includes(id));
        this.options.avoidMembers = [
            ...new Set([
                ...this.options.avoidMembers,
                ...avoidMembersToAdd
            ])
        ];
        this.drawBubbleSets();
    }
    /**
     * <zh/> 移除需要避开的元素
     *
     * <en/> Remove elements to avoid
     * @param avoidMembers - <zh/> 单个或多个 | <en/> single or multiple
     */ removeAvoidMember(avoidMembers) {
        const avoidMembersToRemove = Array.isArray(avoidMembers) ? avoidMembers : [
            avoidMembers
        ];
        if (this.options.avoidMembers.some((member)=>avoidMembersToRemove.includes(member))) {
            this.options.avoidMembers = this.options.avoidMembers.filter((id)=>!avoidMembersToRemove.includes(id));
            this.drawBubbleSets();
        }
    }
    /**
     * <zh/> 更新需要避开的元素
     *
     * <en/> Update elements to avoid
     * @param avoidMembers - <zh/> 单个或多个 | <en/> single or multiple
     */ updateAvoidMember(avoidMembers) {
        this.options.avoidMembers = Array.isArray(avoidMembers) ? avoidMembers : [
            avoidMembers
        ];
        this.drawBubbleSets();
    }
    /**
     * <zh/> 获取需要避开的元素
     *
     * <en/> Get elements to avoid
     * @returns avoidMembers <zh/> 成员元素数组 | <en/> member elements array
     */ getAvoidMember() {
        return this.options.avoidMembers;
    }
    /**
     * <zh/> 销毁
     *
     * <en/> Destroy
     * @internal
     */ destroy() {
        this.context.graph.off((0, $4EzN9.GraphEvent).AFTER_RENDER, this.drawBubbleSets);
        this.context.graph.off((0, $4EzN9.GraphEvent).AFTER_ELEMENT_UPDATE, this.updateBubbleSetsPath);
        if (this.shape) {
            this.shape.destroy();
            this.shape = undefined;
        }
        super.destroy();
    }
}
$d6f546f4e7ad6c1a$export$b0964bf07e78d5cb.defaultOptions = Object.assign({
    members: [],
    avoidMembers: [],
    /** shape style */ fill: 'lightblue',
    fillOpacity: 0.2,
    stroke: 'blue',
    strokeOpacity: 0.2
}, (0, $2T5TZ.defaultOptions));
/**
 * <zh/> 将节点转换为 BubbleSetJS 支持的矩形
 *
 * <en/> Convert nodes to rectangles supported by BubbleSetJS
 * @param graph - <zh/> 图实例 | <en/> graph instance
 * @param ids - <zh/> 元素 ID 数组 | <en/> element ID array
 * @returns <zh/> 矩形数组 | <en/> rectangle array
 */ const $d6f546f4e7ad6c1a$var$convertToRectangle = (graph, ids)=>{
    const idArr = Array.isArray(ids) ? ids : [
        ids
    ];
    return idArr.map((id)=>{
        const bbox = graph.getElementRenderBounds(id);
        return new (0, $2T5TZ.Rectangle)(bbox.min[0], bbox.min[1], (0, $6BVcW.getBBoxWidth)(bbox), (0, $6BVcW.getBBoxHeight)(bbox));
    });
};
/**
 * <zh/> 将边转换为 BubbleSetJS 支持的线
 *
 * <en/> Convert edges to lines supported by BubbleSetJS
 * @param graph - <zh/> 图实例 | <en/> graph instance
 * @param ids - <zh/> 元素 ID 数组 | <en/> element ID array
 * @returns <zh/> 线数组 | <en/> line array
 */ const $d6f546f4e7ad6c1a$var$convertToLine = (graph, ids)=>{
    const idArr = Array.isArray(ids) ? ids : [
        ids
    ];
    return idArr.map((id)=>{
        const data = graph.getEdgeData(id);
        const source = graph.getElementPosition(data.source);
        const target = graph.getElementPosition(data.target);
        return (0, $2T5TZ.Line).from({
            x1: source[0],
            y1: source[1],
            x2: target[0],
            y2: target[1]
        });
    });
};

});
parcelRegister("2T5TZ", function(module, exports) {

$parcel$export(module.exports, "Line", () => $21a54bda07acbf50$export$17d680238e50603e);
$parcel$export(module.exports, "Rectangle", () => $21a54bda07acbf50$export$4617fb02663045ef);
$parcel$export(module.exports, "defaultOptions", () => $21a54bda07acbf50$export$ba43bf67f3d48107);
$parcel$export(module.exports, "BubbleSets", () => $21a54bda07acbf50$export$b0964bf07e78d5cb);
/**
 * bubblesets-js
 * https://github.com/upsetjs/bubblesets-js
 *
 * Copyright (c) 2021-2022 Samuel Gratzl <sam@sgratzl.com>
 */ function $21a54bda07acbf50$var$linePtSegDistSq(lx1, ly1, lx2, ly2, x, y) {
    const x1 = lx1;
    const y1 = ly1;
    const x2 = lx2 - x1;
    const y2 = ly2 - y1;
    let px = x - x1;
    let py = y - y1;
    let dotprod = px * x2 + py * y2;
    let projlenSq = 0;
    if (dotprod <= 0) projlenSq = 0;
    else {
        px = x2 - px;
        py = y2 - py;
        dotprod = px * x2 + py * y2;
        if (dotprod <= 0) projlenSq = 0;
        else projlenSq = dotprod * dotprod / (x2 * x2 + y2 * y2);
    }
    const lenSq = px * px + py * py - projlenSq;
    if (lenSq < 0) return 0;
    return lenSq;
}
function $21a54bda07acbf50$var$ptsDistanceSq(x1, y1, x2, y2) {
    return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
}
function $21a54bda07acbf50$var$doublePointsEqual(x1, y1, x2, y2, delta) {
    return $21a54bda07acbf50$var$ptsDistanceSq(x1, y1, x2, y2) < delta * delta;
}
function $21a54bda07acbf50$var$round(digits) {
    if (!Number.isFinite(digits)) return (v)=>v;
    if (digits === 0) return Math.round;
    const factor = Math.pow(10, digits);
    return (v)=>Math.round(v * factor) / factor;
}
function $21a54bda07acbf50$export$26fe0db1e56290ef(line) {
    const minX = Math.min(line.x1, line.x2);
    const maxX = Math.max(line.x1, line.x2);
    const minY = Math.min(line.y1, line.y2);
    const maxY = Math.max(line.y1, line.y2);
    return {
        x: minX,
        y: minY,
        x2: maxX,
        y2: maxY,
        width: maxX - minX,
        height: maxY - minY
    };
}
class $21a54bda07acbf50$export$17d680238e50603e {
    constructor(x1, y1, x2, y2){
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
    equals(that) {
        return this.x1 === that.x1 && this.y1 === that.y1 && this.x2 === that.x2 && this.y2 === that.y2;
    }
    draw(ctx) {
        ctx.moveTo(this.x1, this.y1);
        ctx.lineTo(this.x2, this.y2);
    }
    toString() {
        return `Line(from=(${this.x1},${this.y1}),to=(${this.x2},${this.y2}))`;
    }
    static from(l) {
        return new $21a54bda07acbf50$export$17d680238e50603e(l.x1, l.y1, l.x2, l.y2);
    }
    cuts(px, py) {
        if (this.y1 === this.y2) return false;
        if (py < this.y1 && py <= this.y2 || py > this.y1 && py >= this.y2) return false;
        if (px > this.x1 && px >= this.x2) return false;
        if (px < this.x1 && px <= this.x2) return true;
        const cross = this.x1 + (py - this.y1) * (this.x2 - this.x1) / (this.y2 - this.y1);
        return px <= cross;
    }
    distSquare(x, y) {
        return $21a54bda07acbf50$var$linePtSegDistSq(this.x1, this.y1, this.x2, this.y2, x, y);
    }
    ptClose(x, y, r) {
        if (this.x1 < this.x2) {
            if (x < this.x1 - r || x > this.x2 + r) return false;
        } else {
            if (x < this.x2 - r || x > this.x1 + r) return false;
        }
        if (this.y1 < this.y2) {
            if (y < this.y1 - r || y > this.y2 + r) return false;
        } else {
            if (y < this.y2 - r || y > this.y1 + r) return false;
        }
        return true;
    }
}
var $21a54bda07acbf50$var$EState;
(function(EState) {
    EState[EState["POINT"] = 1] = "POINT";
    EState[EState["PARALLEL"] = 2] = "PARALLEL";
    EState[EState["COINCIDENT"] = 3] = "COINCIDENT";
    EState[EState["NONE"] = 4] = "NONE";
})($21a54bda07acbf50$var$EState || ($21a54bda07acbf50$var$EState = {}));
class $21a54bda07acbf50$var$Intersection {
    constructor(state, x = 0, y = 0){
        this.state = state;
        this.x = x;
        this.y = y;
    }
}
function $21a54bda07acbf50$var$intersectLineLine(la, lb) {
    const uaT = (lb.x2 - lb.x1) * (la.y1 - lb.y1) - (lb.y2 - lb.y1) * (la.x1 - lb.x1);
    const ubT = (la.x2 - la.x1) * (la.y1 - lb.y1) - (la.y2 - la.y1) * (la.x1 - lb.x1);
    const uB = (lb.y2 - lb.y1) * (la.x2 - la.x1) - (lb.x2 - lb.x1) * (la.y2 - la.y1);
    if (uB) {
        const ua = uaT / uB;
        const ub = ubT / uB;
        if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) return new $21a54bda07acbf50$var$Intersection($21a54bda07acbf50$var$EState.POINT, la.x1 + ua * (la.x2 - la.x1), la.y1 + ua * (la.y2 - la.y1));
        return new $21a54bda07acbf50$var$Intersection($21a54bda07acbf50$var$EState.NONE);
    }
    return new $21a54bda07acbf50$var$Intersection(uaT === 0 || ubT === 0 ? $21a54bda07acbf50$var$EState.COINCIDENT : $21a54bda07acbf50$var$EState.PARALLEL);
}
function $21a54bda07acbf50$var$fractionAlongLineA(la, lb) {
    const uaT = (lb.x2 - lb.x1) * (la.y1 - lb.y1) - (lb.y2 - lb.y1) * (la.x1 - lb.x1);
    const ubT = (la.x2 - la.x1) * (la.y1 - lb.y1) - (la.y2 - la.y1) * (la.x1 - lb.x1);
    const uB = (lb.y2 - lb.y1) * (la.x2 - la.x1) - (lb.x2 - lb.x1) * (la.y2 - la.y1);
    if (uB) {
        const ua = uaT / uB;
        const ub = ubT / uB;
        if (0 <= ua && ua <= 1 && 0 <= ub && ub <= 1) return ua;
    }
    return Number.POSITIVE_INFINITY;
}
function $21a54bda07acbf50$var$hasFractionToLineCenter(bounds, line) {
    function testLine(xa, ya, xb, yb) {
        let testDistance = $21a54bda07acbf50$var$fractionAlongLineA(line, new $21a54bda07acbf50$export$17d680238e50603e(xa, ya, xb, yb));
        testDistance = Math.abs(testDistance - 0.5);
        if (testDistance >= 0 && testDistance <= 1) return 1;
        return 0;
    }
    let countIntersections = testLine(bounds.x, bounds.y, bounds.x2, bounds.y);
    countIntersections += testLine(bounds.x, bounds.y, bounds.x, bounds.y2);
    if (countIntersections > 1) return true;
    countIntersections += testLine(bounds.x, bounds.y2, bounds.x2, bounds.y2);
    if (countIntersections > 1) return true;
    countIntersections += testLine(bounds.x2, bounds.y, bounds.x2, bounds.y2);
    return countIntersections > 0;
}
var $21a54bda07acbf50$var$OutCode;
(function(OutCode) {
    OutCode[OutCode["LEFT"] = 0] = "LEFT";
    OutCode[OutCode["TOP"] = 1] = "TOP";
    OutCode[OutCode["RIGHT"] = 2] = "RIGHT";
    OutCode[OutCode["BOTTOM"] = 3] = "BOTTOM";
})($21a54bda07acbf50$var$OutCode || ($21a54bda07acbf50$var$OutCode = {}));
function $21a54bda07acbf50$var$outcode(bounds, px, py) {
    const out = new Set();
    if (bounds.width <= 0) {
        out.add($21a54bda07acbf50$var$OutCode.LEFT);
        out.add($21a54bda07acbf50$var$OutCode.RIGHT);
    } else if (px < bounds.x) out.add($21a54bda07acbf50$var$OutCode.LEFT);
    else if (px > bounds.x + bounds.width) out.add($21a54bda07acbf50$var$OutCode.RIGHT);
    if (bounds.height <= 0) {
        out.add($21a54bda07acbf50$var$OutCode.TOP);
        out.add($21a54bda07acbf50$var$OutCode.BOTTOM);
    } else if (py < bounds.y) out.add($21a54bda07acbf50$var$OutCode.TOP);
    else if (py > bounds.y + bounds.height) out.add($21a54bda07acbf50$var$OutCode.BOTTOM);
    return out;
}
function $21a54bda07acbf50$var$intersectsLine(bounds, line) {
    let x1 = line.x1;
    let y1 = line.y1;
    const x2 = line.x2;
    const y2 = line.y2;
    const out2 = Array.from($21a54bda07acbf50$var$outcode(bounds, x2, y2));
    if (out2.length === 0) return true;
    let out1 = $21a54bda07acbf50$var$outcode(bounds, x1, y1);
    while(out1.size !== 0){
        for (const a of out2){
            if (out1.has(a)) return false;
        }
        if (out1.has($21a54bda07acbf50$var$OutCode.RIGHT) || out1.has($21a54bda07acbf50$var$OutCode.LEFT)) {
            let x = bounds.x;
            if (out1.has($21a54bda07acbf50$var$OutCode.RIGHT)) x += bounds.width;
            y1 = y1 + (x - x1) * (y2 - y1) / (x2 - x1);
            x1 = x;
        } else {
            let y = bounds.y;
            if (out1.has($21a54bda07acbf50$var$OutCode.BOTTOM)) y += bounds.height;
            x1 = x1 + (y - y1) * (x2 - x1) / (y2 - y1);
            y1 = y;
        }
        out1 = $21a54bda07acbf50$var$outcode(bounds, x1, y1);
    }
    return true;
}
function $21a54bda07acbf50$var$fractionToLineCenter(bounds, line) {
    let minDistance = Number.POSITIVE_INFINITY;
    let countIntersections = 0;
    function testLine(xa, ya, xb, yb) {
        let testDistance = $21a54bda07acbf50$var$fractionAlongLineA(line, new $21a54bda07acbf50$export$17d680238e50603e(xa, ya, xb, yb));
        testDistance = Math.abs(testDistance - 0.5);
        if (testDistance >= 0 && testDistance <= 1) {
            countIntersections++;
            if (testDistance < minDistance) minDistance = testDistance;
        }
    }
    testLine(bounds.x, bounds.y, bounds.x2, bounds.y);
    testLine(bounds.x, bounds.y, bounds.x, bounds.y2);
    if (countIntersections > 1) return minDistance;
    testLine(bounds.x, bounds.y2, bounds.x2, bounds.y2);
    if (countIntersections > 1) return minDistance;
    testLine(bounds.x2, bounds.y, bounds.x2, bounds.y2);
    if (countIntersections === 0) return -1;
    return minDistance;
}
function $21a54bda07acbf50$var$testIntersection(line, bounds) {
    let count = 0;
    const top = $21a54bda07acbf50$var$intersectLineLine(line, new $21a54bda07acbf50$export$17d680238e50603e(bounds.x, bounds.y, bounds.x2, bounds.y));
    count += top.state === $21a54bda07acbf50$var$EState.POINT ? 1 : 0;
    const left = $21a54bda07acbf50$var$intersectLineLine(line, new $21a54bda07acbf50$export$17d680238e50603e(bounds.x, bounds.y, bounds.x, bounds.y2));
    count += left.state === $21a54bda07acbf50$var$EState.POINT ? 1 : 0;
    const bottom = $21a54bda07acbf50$var$intersectLineLine(line, new $21a54bda07acbf50$export$17d680238e50603e(bounds.x, bounds.y2, bounds.x2, bounds.y2));
    count += bottom.state === $21a54bda07acbf50$var$EState.POINT ? 1 : 0;
    const right = $21a54bda07acbf50$var$intersectLineLine(line, new $21a54bda07acbf50$export$17d680238e50603e(bounds.x2, bounds.y, bounds.x2, bounds.y2));
    count += right.state === $21a54bda07acbf50$var$EState.POINT ? 1 : 0;
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        count: count
    };
}
class $21a54bda07acbf50$export$4617fb02663045ef {
    constructor(x, y, width, height){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    get x2() {
        return this.x + this.width;
    }
    get y2() {
        return this.y + this.height;
    }
    get cx() {
        return this.x + this.width / 2;
    }
    get cy() {
        return this.y + this.height / 2;
    }
    get radius() {
        return Math.max(this.width, this.height) / 2;
    }
    static from(r) {
        return new $21a54bda07acbf50$export$4617fb02663045ef(r.x, r.y, r.width, r.height);
    }
    equals(that) {
        return this.x === that.x && this.y === that.y && this.width === that.width && this.height === that.height;
    }
    clone() {
        return new $21a54bda07acbf50$export$4617fb02663045ef(this.x, this.y, this.width, this.height);
    }
    add(that) {
        const x = Math.min(this.x, that.x);
        const y = Math.min(this.y, that.y);
        const x2 = Math.max(this.x2, that.x + that.width);
        const y2 = Math.max(this.y2, that.y + that.height);
        this.x = x;
        this.y = y;
        this.width = x2 - x;
        this.height = y2 - y;
    }
    addPoint(p) {
        const x = Math.min(this.x, p.x);
        const y = Math.min(this.y, p.y);
        const x2 = Math.max(this.x2, p.x);
        const y2 = Math.max(this.y2, p.y);
        this.x = x;
        this.y = y;
        this.width = x2 - x;
        this.height = y2 - y;
    }
    toString() {
        return `Rectangle[x=${this.x}, y=${this.y}, w=${this.width}, h=${this.height}]`;
    }
    draw(ctx) {
        ctx.rect(this.x, this.y, this.width, this.height);
    }
    containsPt(px, py) {
        return px >= this.x && px <= this.x2 && py >= this.y && py <= this.y2;
    }
    get area() {
        return this.width * this.height;
    }
    intersects(that) {
        if (this.area <= 0 || that.width <= 0 || that.height <= 0) return false;
        return that.x + that.width > this.x && that.y + that.height > this.y && that.x < this.x2 && that.y < this.y2;
    }
    distSquare(tempX, tempY) {
        if (this.containsPt(tempX, tempY)) return 0;
        const code = $21a54bda07acbf50$var$outcode(this, tempX, tempY);
        if (code.has($21a54bda07acbf50$var$OutCode.TOP)) {
            if (code.has($21a54bda07acbf50$var$OutCode.LEFT)) return $21a54bda07acbf50$var$ptsDistanceSq(tempX, tempY, this.x, this.y);
            if (code.has($21a54bda07acbf50$var$OutCode.RIGHT)) return $21a54bda07acbf50$var$ptsDistanceSq(tempX, tempY, this.x2, this.y);
            return (this.y - tempY) * (this.y - tempY);
        }
        if (code.has($21a54bda07acbf50$var$OutCode.BOTTOM)) {
            if (code.has($21a54bda07acbf50$var$OutCode.LEFT)) return $21a54bda07acbf50$var$ptsDistanceSq(tempX, tempY, this.x, this.y2);
            if (code.has($21a54bda07acbf50$var$OutCode.RIGHT)) return $21a54bda07acbf50$var$ptsDistanceSq(tempX, tempY, this.x2, this.y2);
            return (tempY - this.y2) * (tempY - this.y2);
        }
        if (code.has($21a54bda07acbf50$var$OutCode.LEFT)) return (this.x - tempX) * (this.x - tempX);
        if (code.has($21a54bda07acbf50$var$OutCode.RIGHT)) return (tempX - this.x2) * (tempX - this.x2);
        return 0;
    }
}
function $21a54bda07acbf50$export$c845df1685d3e70f(path) {
    if (path.length === 0) return null;
    const first = path[0];
    const bb = new $21a54bda07acbf50$export$4617fb02663045ef(first.x, first.y, 0, 0);
    for (const point of path)bb.addPoint(point);
    return bb;
}
class $21a54bda07acbf50$export$c89a927ffc67e6fa {
    constructor(cx, cy, radius){
        this.cx = cx;
        this.cy = cy;
        this.radius = radius;
    }
    get x() {
        return this.cx - this.radius;
    }
    get x2() {
        return this.cx + this.radius;
    }
    get width() {
        return this.radius * 2;
    }
    get y() {
        return this.cy - this.radius;
    }
    get y2() {
        return this.cy + this.radius;
    }
    get height() {
        return this.radius * 2;
    }
    static from(r) {
        return new $21a54bda07acbf50$export$c89a927ffc67e6fa(r.cx, r.cy, r.radius);
    }
    containsPt(x, y) {
        return $21a54bda07acbf50$var$ptsDistanceSq(this.cx, this.cy, x, y) < this.radius * this.radius;
    }
    distSquare(tempX, tempY) {
        const dist = $21a54bda07acbf50$var$ptsDistanceSq(this.cx, this.cy, tempX, tempY);
        if (dist < this.radius * this.radius) return 0;
        const offset = Math.sqrt(dist) - this.radius;
        return offset * offset;
    }
    draw(ctx) {
        ctx.ellipse(this.cx, this.cy, this.radius, this.radius, 0, 0, Math.PI * 2);
    }
}
class $21a54bda07acbf50$export$ea1a111407f37557 {
    constructor(pixelGroup, i = 0, j = 0, pixelX = 0, pixelY = 0, width = 10, height = 10, pixels = new Float32Array(Math.max(0, width * height)).fill(0)){
        this.pixelGroup = pixelGroup;
        this.i = i;
        this.j = j;
        this.pixelX = pixelX;
        this.pixelY = pixelY;
        this.width = width;
        this.height = height;
        this.area = pixels;
    }
    createSub(rect, pixelPos) {
        return new $21a54bda07acbf50$export$ea1a111407f37557(this.pixelGroup, rect.x, rect.y, pixelPos.x, pixelPos.y, rect.width, rect.height);
    }
    static fromPixelRegion(pixelRect, pixelGroup) {
        return new $21a54bda07acbf50$export$ea1a111407f37557(pixelGroup, 0, 0, pixelRect.x, pixelRect.y, Math.ceil(pixelRect.width / pixelGroup), Math.ceil(pixelRect.height / pixelGroup));
    }
    copy(sub, pixelPoint) {
        return new $21a54bda07acbf50$export$ea1a111407f37557(this.pixelGroup, this.scaleX(pixelPoint.x), this.scaleY(pixelPoint.y), pixelPoint.x, pixelPoint.y, sub.width, sub.height, sub.area);
    }
    boundX(pos) {
        if (pos < this.i) return this.i;
        if (pos >= this.width) return this.width - 1;
        return pos;
    }
    boundY(pos) {
        if (pos < this.j) return this.j;
        if (pos >= this.height) return this.height - 1;
        return pos;
    }
    scaleX(pixel) {
        return this.boundX(Math.floor((pixel - this.pixelX) / this.pixelGroup));
    }
    scaleY(pixel) {
        return this.boundY(Math.floor((pixel - this.pixelY) / this.pixelGroup));
    }
    scale(pixelRect) {
        const x = this.scaleX(pixelRect.x);
        const y = this.scaleY(pixelRect.y);
        const x2 = this.boundX(Math.ceil((pixelRect.x + pixelRect.width - this.pixelX) / this.pixelGroup));
        const y2 = this.boundY(Math.ceil((pixelRect.y + pixelRect.height - this.pixelY) / this.pixelGroup));
        const width = x2 - x;
        const height = y2 - y;
        return new $21a54bda07acbf50$export$4617fb02663045ef(x, y, width, height);
    }
    invertScaleX(v) {
        return Math.round(v * this.pixelGroup + this.pixelX);
    }
    invertScaleY(v) {
        return Math.round(v * this.pixelGroup + this.pixelY);
    }
    addPadding(rect, pixelPadding) {
        const padding = Math.ceil(pixelPadding / this.pixelGroup);
        const x = this.boundX(rect.x - padding);
        const y = this.boundY(rect.y - padding);
        const x2 = this.boundX(rect.x2 + padding);
        const y2 = this.boundY(rect.y2 + padding);
        const width = x2 - x;
        const height = y2 - y;
        return new $21a54bda07acbf50$export$4617fb02663045ef(x, y, width, height);
    }
    get(i, j) {
        if (i < 0 || j < 0 || i >= this.width || j >= this.height) return Number.NaN;
        return this.area[i + j * this.width];
    }
    inc(i, j, v) {
        if (i < 0 || j < 0 || i >= this.width || j >= this.height) return;
        this.area[i + j * this.width] += v;
    }
    set(i, j, v) {
        if (i < 0 || j < 0 || i >= this.width || j >= this.height) return;
        this.area[i + j * this.width] = v;
    }
    incArea(sub, factor) {
        if (sub.width <= 0 || sub.height <= 0 || factor === 0) return;
        const w = this.width;
        const aw = sub.width;
        const i1 = Math.max(0, sub.i);
        const j1 = Math.max(0, sub.j);
        const i2 = Math.min(sub.i + sub.width, w);
        const j2 = Math.min(sub.j + sub.height, this.height);
        if (j2 <= 0 || i2 <= 0 || i1 >= w || j2 >= this.height) return;
        for(let j = j1; j < j2; j++){
            const subRow = (j - sub.j) * aw;
            const row = j * w;
            for(let i = i1; i < i2; i++){
                const v = sub.area[i - sub.i + subRow];
                if (v === 0) continue;
                this.area[i + row] += factor * v;
            }
        }
    }
    fill(value) {
        this.area.fill(value);
    }
    fillArea(rect, value) {
        const offset = rect.x + rect.y * this.width;
        for(let j = 0; j < rect.height; j++){
            const pos = offset + j * this.width;
            this.area.fill(value, pos, pos + rect.width);
        }
    }
    fillHorizontalLine(i, j, width, value) {
        const offset = i + j * this.width;
        this.area.fill(value, offset, offset + width);
    }
    fillVerticalLine(i, j, height, value) {
        const offset = i + j * this.width;
        for(let k = 0; k < height; k++)this.area[offset + k * this.width] = value;
    }
    clear() {
        this.area.fill(0);
    }
    toString() {
        let r = '';
        for(let j = 0; j < this.height; j++){
            const row = j * this.width;
            for(let i = 0; i < this.width; i++){
                const v = this.area[row + i];
                r += v.toFixed(1).padStart(6);
                r += ' ';
            }
            r += '\n';
        }
        return r;
    }
    draw(ctx, offset = true) {
        if (this.width <= 0 || this.height <= 0) return;
        ctx.save();
        if (offset) ctx.translate(this.pixelX, this.pixelY);
        const min = this.area.reduce((acc, v)=>Math.min(acc, v), Number.POSITIVE_INFINITY);
        const max = this.area.reduce((acc, v)=>Math.max(acc, v), Number.NEGATIVE_INFINITY);
        const scale = (v)=>(v - min) / (max - min);
        ctx.scale(this.pixelGroup, this.pixelGroup);
        for(let i = 0; i < this.width; i++)for(let j = 0; j < this.height; j++){
            const v = this.area[i + j * this.width];
            ctx.fillStyle = `rgba(0, 0, 0, ${scale(v)})`;
            ctx.fillRect(i, j, 1, 1);
        }
        ctx.restore();
    }
    drawThreshold(ctx, threshold, offset = true) {
        if (this.width <= 0 || this.height <= 0) return;
        ctx.save();
        if (offset) ctx.translate(this.pixelX, this.pixelY);
        ctx.scale(this.pixelGroup, this.pixelGroup);
        for(let i = 0; i < this.width; i++)for(let j = 0; j < this.height; j++){
            const v = this.area[i + j * this.width];
            ctx.fillStyle = v > threshold ? 'black' : 'white';
            ctx.fillRect(i, j, 1, 1);
        }
        ctx.restore();
    }
}
function $21a54bda07acbf50$export$adf255e13b40f23f(rect, padding) {
    const map = (r)=>({
            x: r.x - padding,
            y: r.y - padding,
            width: r.width + 2 * padding,
            height: r.height + 2 * padding
        });
    if (Array.isArray(rect)) return rect.map(map);
    return map(rect);
}
function $21a54bda07acbf50$export$4a96817c3621429e(line, potentialArea, padding) {
    return $21a54bda07acbf50$export$88df63bd43ece0f0(Object.assign($21a54bda07acbf50$export$26fe0db1e56290ef(line), {
        distSquare: (x, y)=>$21a54bda07acbf50$var$linePtSegDistSq(line.x1, line.y1, line.x2, line.y2, x, y)
    }), potentialArea, padding);
}
function $21a54bda07acbf50$export$88df63bd43ece0f0(shape, potentialArea, padding) {
    const lr = $21a54bda07acbf50$export$adf255e13b40f23f(shape, padding);
    const scaled = potentialArea.scale(lr);
    const area = potentialArea.createSub(scaled, lr);
    $21a54bda07acbf50$var$sample(area, potentialArea, padding, (x, y)=>shape.distSquare(x, y));
    return area;
}
function $21a54bda07acbf50$var$sample(area, potentialArea, padding, distanceFunction) {
    const padding2 = padding * padding;
    for(let y = 0; y < area.height; y++)for(let x = 0; x < area.width; x++){
        const tempX = potentialArea.invertScaleX(area.i + x);
        const tempY = potentialArea.invertScaleY(area.j + y);
        const distanceSq = distanceFunction(tempX, tempY);
        if (distanceSq === 0) {
            area.set(x, y, padding2);
            continue;
        }
        if (distanceSq < padding2) {
            const dr = padding - Math.sqrt(distanceSq);
            area.set(x, y, dr * dr);
        }
    }
    return area;
}
function $21a54bda07acbf50$export$1f5241b260204fa9(rect, potentialArea, padding) {
    const scaled = potentialArea.scale(rect);
    const padded = potentialArea.addPadding(scaled, padding);
    const area = potentialArea.createSub(padded, {
        x: rect.x - padding,
        y: rect.y - padding
    });
    const paddingLeft = scaled.x - padded.x;
    const paddingTop = scaled.y - padded.y;
    const paddingRight = padded.x2 - scaled.x2;
    const paddingBottom = padded.y2 - scaled.y2;
    const innerWidth = padded.width - paddingLeft - paddingRight;
    const innerHeight = padded.height - paddingTop - paddingBottom;
    const padding2 = padding * padding;
    area.fillArea({
        x: paddingLeft,
        y: paddingTop,
        width: innerWidth + 1,
        height: innerHeight + 1
    }, padding2);
    const straightDistances = [
        0
    ];
    const maxPadding = Math.max(paddingTop, paddingLeft, paddingRight, paddingBottom);
    {
        const tempX = potentialArea.invertScaleX(scaled.x + scaled.width / 2);
        for(let i = 1; i < maxPadding; i++){
            const tempY = potentialArea.invertScaleY(scaled.y - i);
            const distanceSq = rect.distSquare(tempX, tempY);
            if (distanceSq < padding2) {
                const dr = padding - Math.sqrt(distanceSq);
                straightDistances.push(dr * dr);
            } else break;
        }
    }
    const cornerDistances = [];
    const maxHorizontalPadding = Math.max(paddingLeft, paddingRight);
    const maxVerticalPadding = Math.max(paddingTop, paddingRight);
    for(let i = 1; i < maxHorizontalPadding; i++){
        const tempX = potentialArea.invertScaleX(scaled.x - i);
        const row = [];
        for(let j = 1; j < maxVerticalPadding; j++){
            const tempY = potentialArea.invertScaleY(scaled.y - j);
            const distanceSq = rect.distSquare(tempX, tempY);
            if (distanceSq < padding2) {
                const dr = padding - Math.sqrt(distanceSq);
                row.push(dr * dr);
            } else row.push(0);
        }
        cornerDistances.push(row);
    }
    for(let y = 1; y < Math.min(paddingTop, straightDistances.length); y++){
        const value = straightDistances[y];
        area.fillHorizontalLine(paddingLeft, paddingTop - y, innerWidth + 1, value);
    }
    for(let y = 1; y < Math.min(paddingBottom, straightDistances.length); y++){
        const value = straightDistances[y];
        area.fillHorizontalLine(paddingLeft, paddingTop + innerHeight + y, innerWidth + 1, value);
    }
    for(let x = 1; x < Math.min(paddingLeft, straightDistances.length); x++){
        const value = straightDistances[x];
        area.fillVerticalLine(paddingLeft - x, paddingTop, innerHeight + 1, value);
    }
    for(let x = 1; x < Math.min(paddingBottom, straightDistances.length); x++){
        const value = straightDistances[x];
        area.fillVerticalLine(paddingLeft + innerWidth + x, paddingTop, innerHeight + 1, value);
    }
    for(let i = 1; i < paddingLeft; i++){
        const row = cornerDistances[i - 1];
        const ii = paddingLeft - i;
        for(let j = 1; j < paddingTop; j++)area.set(ii, paddingTop - j, row[j - 1]);
        for(let j = 1; j < paddingBottom; j++)area.set(ii, paddingTop + innerHeight + j, row[j - 1]);
    }
    for(let i = 1; i < paddingRight; i++){
        const row = cornerDistances[i - 1];
        const ii = paddingLeft + innerWidth + i;
        for(let j = 1; j < paddingTop; j++)area.set(ii, paddingTop - j, row[j - 1]);
        for(let j = 1; j < paddingBottom; j++)area.set(ii, paddingTop + innerHeight + j, row[j - 1]);
    }
    return area;
}
function $21a54bda07acbf50$export$4b409e53cf4df6e6(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
function $21a54bda07acbf50$export$e1d786d2f707b414(cx, cy, radius) {
    return {
        cx: cx,
        cy: cy,
        radius: radius
    };
}
function $21a54bda07acbf50$export$53f1d5ea8de3d7c(x1, y1, x2, y2) {
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $21a54bda07acbf50$export$105684a3041cb6f3(x, y) {
    return {
        x: x,
        y: y
    };
}
function $21a54bda07acbf50$export$adcb69fca15b3962(items, nonMembers, maxRoutingIterations, morphBuffer) {
    if (items.length === 0) return [];
    const sorted = $21a54bda07acbf50$var$sortByDistanceToCentroid(items);
    return sorted.map((d, i)=>{
        const visited = sorted.slice(0, i);
        return $21a54bda07acbf50$var$connectItem(nonMembers, d, visited, maxRoutingIterations, morphBuffer);
    }).flat();
}
function $21a54bda07acbf50$var$connectItem(nonMembers, item, visited, maxRoutingIterations, morphBuffer) {
    const itemCenter = $21a54bda07acbf50$export$105684a3041cb6f3(item.cx, item.cy);
    const closestNeighbor = $21a54bda07acbf50$var$calculateClosestNeighbor(itemCenter, visited, nonMembers);
    if (closestNeighbor == null) return [];
    const directLine = new $21a54bda07acbf50$export$17d680238e50603e(itemCenter.x, itemCenter.y, closestNeighbor.cx, closestNeighbor.cy);
    const scannedLines = $21a54bda07acbf50$var$computeRoute(directLine, nonMembers, maxRoutingIterations, morphBuffer);
    return $21a54bda07acbf50$var$mergeLines(scannedLines, nonMembers);
}
function $21a54bda07acbf50$var$computeRoute(directLine, nonMembers, maxRoutingIterations, morphBuffer) {
    const scannedLines = [];
    const linesToCheck = [];
    linesToCheck.push(directLine);
    let hasIntersection = true;
    for(let iterations = 0; iterations < maxRoutingIterations && hasIntersection; iterations++){
        hasIntersection = false;
        while(!hasIntersection && linesToCheck.length > 0){
            const line = linesToCheck.pop();
            const closestItem = $21a54bda07acbf50$var$getCenterItem(nonMembers, line);
            const intersections = closestItem ? $21a54bda07acbf50$var$testIntersection(line, closestItem) : null;
            if (!closestItem || !intersections || intersections.count !== 2) {
                if (!hasIntersection) scannedLines.push(line);
                continue;
            }
            let tempMorphBuffer = morphBuffer;
            let movePoint = $21a54bda07acbf50$var$rerouteLine(closestItem, tempMorphBuffer, intersections, true);
            let foundFirst = $21a54bda07acbf50$var$pointExists(movePoint, linesToCheck) || $21a54bda07acbf50$var$pointExists(movePoint, scannedLines);
            let pointInside = $21a54bda07acbf50$var$isPointInRectangles(movePoint, nonMembers);
            while(!foundFirst && pointInside && tempMorphBuffer >= 1){
                tempMorphBuffer /= 1.5;
                movePoint = $21a54bda07acbf50$var$rerouteLine(closestItem, tempMorphBuffer, intersections, true);
                foundFirst = $21a54bda07acbf50$var$pointExists(movePoint, linesToCheck) || $21a54bda07acbf50$var$pointExists(movePoint, scannedLines);
                pointInside = $21a54bda07acbf50$var$isPointInRectangles(movePoint, nonMembers);
            }
            if (movePoint && !foundFirst && !pointInside) {
                linesToCheck.push(new $21a54bda07acbf50$export$17d680238e50603e(line.x1, line.y1, movePoint.x, movePoint.y));
                linesToCheck.push(new $21a54bda07acbf50$export$17d680238e50603e(movePoint.x, movePoint.y, line.x2, line.y2));
                hasIntersection = true;
            }
            if (hasIntersection) continue;
            tempMorphBuffer = morphBuffer;
            movePoint = $21a54bda07acbf50$var$rerouteLine(closestItem, tempMorphBuffer, intersections, false);
            let foundSecond = $21a54bda07acbf50$var$pointExists(movePoint, linesToCheck) || $21a54bda07acbf50$var$pointExists(movePoint, scannedLines);
            pointInside = $21a54bda07acbf50$var$isPointInRectangles(movePoint, nonMembers);
            while(!foundSecond && pointInside && tempMorphBuffer >= 1){
                tempMorphBuffer /= 1.5;
                movePoint = $21a54bda07acbf50$var$rerouteLine(closestItem, tempMorphBuffer, intersections, false);
                foundSecond = $21a54bda07acbf50$var$pointExists(movePoint, linesToCheck) || $21a54bda07acbf50$var$pointExists(movePoint, scannedLines);
                pointInside = $21a54bda07acbf50$var$isPointInRectangles(movePoint, nonMembers);
            }
            if (movePoint && !foundSecond) {
                linesToCheck.push(new $21a54bda07acbf50$export$17d680238e50603e(line.x1, line.y1, movePoint.x, movePoint.y));
                linesToCheck.push(new $21a54bda07acbf50$export$17d680238e50603e(movePoint.x, movePoint.y, line.x2, line.y2));
                hasIntersection = true;
            }
            if (!hasIntersection) scannedLines.push(line);
        }
    }
    while(linesToCheck.length > 0)scannedLines.push(linesToCheck.pop());
    return scannedLines;
}
function $21a54bda07acbf50$var$mergeLines(scannedLines, nonMembers) {
    const finalRoute = [];
    while(scannedLines.length > 0){
        const line1 = scannedLines.pop();
        if (scannedLines.length === 0) {
            finalRoute.push(line1);
            break;
        }
        const line2 = scannedLines.pop();
        const mergeLine = new $21a54bda07acbf50$export$17d680238e50603e(line1.x1, line1.y1, line2.x2, line2.y2);
        const closestItem = $21a54bda07acbf50$var$getCenterItem(nonMembers, mergeLine);
        if (!closestItem) scannedLines.push(mergeLine);
        else {
            finalRoute.push(line1);
            scannedLines.push(line2);
        }
    }
    return finalRoute;
}
function $21a54bda07acbf50$var$calculateClosestNeighbor(itemCenter, visited, nonMembers) {
    let minLengthSq = Number.POSITIVE_INFINITY;
    return visited.reduce((closestNeighbor, neighborItem)=>{
        const distanceSq = $21a54bda07acbf50$var$ptsDistanceSq(itemCenter.x, itemCenter.y, neighborItem.cx, neighborItem.cy);
        if (distanceSq > minLengthSq) return closestNeighbor;
        const directLine = new $21a54bda07acbf50$export$17d680238e50603e(itemCenter.x, itemCenter.y, neighborItem.cx, neighborItem.cy);
        const numberInterferenceItems = $21a54bda07acbf50$var$itemsCuttingLine(nonMembers, directLine);
        if (distanceSq * (numberInterferenceItems + 1) * (numberInterferenceItems + 1) < minLengthSq) {
            closestNeighbor = neighborItem;
            minLengthSq = distanceSq * (numberInterferenceItems + 1) * (numberInterferenceItems + 1);
        }
        return closestNeighbor;
    }, null);
}
function $21a54bda07acbf50$var$sortByDistanceToCentroid(items) {
    if (items.length < 2) return items;
    let totalX = 0;
    let totalY = 0;
    items.forEach((item)=>{
        totalX += item.cx;
        totalY += item.cy;
    });
    totalX /= items.length;
    totalY /= items.length;
    return items.map((item)=>{
        const diffX = totalX - item.cx;
        const diffY = totalY - item.cy;
        const dist = diffX * diffX + diffY * diffY;
        return [
            item,
            dist
        ];
    }).sort((a, b)=>a[1] - b[1]).map((d)=>d[0]);
}
function $21a54bda07acbf50$var$isPointInRectangles(p, rects) {
    return rects.some((r)=>r.containsPt(p.x, p.y));
}
function $21a54bda07acbf50$var$pointExists(pointToCheck, lines) {
    return lines.some((checkEndPointsLine)=>{
        if ($21a54bda07acbf50$var$doublePointsEqual(checkEndPointsLine.x1, checkEndPointsLine.y1, pointToCheck.x, pointToCheck.y, 1e-3)) return true;
        if ($21a54bda07acbf50$var$doublePointsEqual(checkEndPointsLine.x2, checkEndPointsLine.y2, pointToCheck.x, pointToCheck.y, 1e-3)) return true;
        return false;
    });
}
function $21a54bda07acbf50$var$getCenterItem(items, testLine) {
    let minDistance = Number.POSITIVE_INFINITY;
    let closestItem = null;
    for (const item of items){
        if (!$21a54bda07acbf50$var$intersectsLine(item, testLine)) continue;
        const distance = $21a54bda07acbf50$var$fractionToLineCenter(item, testLine);
        if (distance >= 0 && distance < minDistance) {
            closestItem = item;
            minDistance = distance;
        }
    }
    return closestItem;
}
function $21a54bda07acbf50$var$itemsCuttingLine(items, testLine) {
    return items.reduce((count, item)=>{
        if ($21a54bda07acbf50$var$intersectsLine(item, testLine) && $21a54bda07acbf50$var$hasFractionToLineCenter(item, testLine)) return count + 1;
        return count;
    }, 0);
}
function $21a54bda07acbf50$var$rerouteLine(item, rerouteBuffer, intersections, wrapNormal) {
    const topIntersect = intersections.top;
    const leftIntersect = intersections.left;
    const bottomIntersect = intersections.bottom;
    const rightIntersect = intersections.right;
    if (wrapNormal) {
        if (leftIntersect.state === $21a54bda07acbf50$var$EState.POINT) {
            if (topIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
            if (bottomIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
            const totalArea = item.width * item.height;
            const topArea = item.width * ((leftIntersect.y - item.y + (rightIntersect.y - item.y)) * 0.5);
            if (topArea < totalArea * 0.5) {
                if (leftIntersect.y > rightIntersect.y) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
                return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
            }
            if (leftIntersect.y < rightIntersect.y) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
            return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
        }
        if (rightIntersect.state === $21a54bda07acbf50$var$EState.POINT) {
            if (topIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
            if (bottomIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
        }
        const totalArea = item.height * item.width;
        const leftArea = item.height * ((topIntersect.x - item.x + (rightIntersect.x - item.x)) * 0.5);
        if (leftArea < totalArea * 0.5) {
            if (topIntersect.x > bottomIntersect.x) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
            return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
        }
        if (topIntersect.x < bottomIntersect.x) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
        return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
    }
    if (leftIntersect.state === $21a54bda07acbf50$var$EState.POINT) {
        if (topIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
        if (bottomIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
        const totalArea = item.height * item.width;
        const topArea = item.width * ((leftIntersect.y - item.y + (rightIntersect.y - item.y)) * 0.5);
        if (topArea < totalArea * 0.5) {
            if (leftIntersect.y > rightIntersect.y) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
            return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
        }
        if (leftIntersect.y < rightIntersect.y) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
        return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
    }
    if (rightIntersect.state === $21a54bda07acbf50$var$EState.POINT) {
        if (topIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
        if (bottomIntersect.state === $21a54bda07acbf50$var$EState.POINT) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
    }
    const totalArea = item.height * item.width;
    const leftArea = item.height * ((topIntersect.x - item.x + (rightIntersect.x - item.x)) * 0.5);
    if (leftArea < totalArea * 0.5) {
        if (topIntersect.x > bottomIntersect.x) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y2 + rerouteBuffer);
        return $21a54bda07acbf50$export$105684a3041cb6f3(item.x2 + rerouteBuffer, item.y - rerouteBuffer);
    }
    if (topIntersect.x < bottomIntersect.x) return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y2 + rerouteBuffer);
    return $21a54bda07acbf50$export$105684a3041cb6f3(item.x - rerouteBuffer, item.y - rerouteBuffer);
}
function $21a54bda07acbf50$var$canTakeNext(path, start, end, toleranceSquared) {
    const validEnd = path.closed ? end < path.length : end < path.length - 1;
    if (!validEnd) return false;
    const s = path.get(start);
    const e = path.get(end + 1);
    for(let index = start + 1; index <= end; index++){
        const p = path.get(index);
        const len = $21a54bda07acbf50$var$linePtSegDistSq(s.x, s.y, e.x, e.y, p.x, p.y);
        if (len > toleranceSquared) return false;
    }
    return true;
}
function $21a54bda07acbf50$var$shapeSimplifier(tolerance = 0.0) {
    return (path)=>{
        if (tolerance < 0 || path.length < 3) return path;
        const points = [];
        let start = 0;
        const toleranceSquared = tolerance * tolerance;
        while(start < path.length){
            let end = start + 1;
            while($21a54bda07acbf50$var$canTakeNext(path, start, end, toleranceSquared))end++;
            points.push(path.get(start));
            start = end;
        }
        return new $21a54bda07acbf50$export$e11c86b5a124f28(points);
    };
}
function $21a54bda07acbf50$var$basicFunction(i, t) {
    switch(i){
        case -2:
            return (((-t + 3.0) * t - 3.0) * t + 1.0) / 6.0;
        case -1:
            return ((3.0 * t - 6.0) * t * t + 4.0) / 6.0;
        case 0:
            return (((-3 * t + 3.0) * t + 3.0) * t + 1.0) / 6.0;
        case 1:
            return t * t * t / 6.0;
        default:
            throw new Error('unknown error');
    }
}
function $21a54bda07acbf50$var$bSplineShapeGenerator(granularity = 6.0) {
    const ORDER = 3;
    const START_INDEX = ORDER - 1;
    const REL_END = 1;
    const REL_START = REL_END - ORDER;
    function calcPoint(path, i, t) {
        let px = 0.0;
        let py = 0.0;
        for(let j = REL_START; j <= REL_END; j++){
            const p = path.get(i + j);
            const bf = $21a54bda07acbf50$var$basicFunction(j, t);
            px += bf * p.x;
            py += bf * p.y;
        }
        return {
            x: px,
            y: py
        };
    }
    return (path)=>{
        if (path.length < 3) return path;
        const res = [];
        const closed = path.closed;
        const count = path.length + ORDER - 1 + (closed ? 0 : 2);
        res.push(calcPoint(path, START_INDEX - (closed ? 0 : 2), 0));
        for(let ix = START_INDEX - (closed ? 0 : 2); ix < count; ix++)for(let k = 1; k <= granularity; k++)res.push(calcPoint(path, ix, k / granularity));
        return new $21a54bda07acbf50$export$e11c86b5a124f28(res);
    };
}
function $21a54bda07acbf50$var$samplePath(skip = 8) {
    return (path)=>{
        let actSkip = skip;
        let size = path.length;
        if (actSkip > 1) {
            size = Math.floor(path.length / actSkip);
            while(size < 3 && actSkip > 1){
                actSkip -= 1;
                size = Math.floor(path.length / actSkip);
            }
        }
        const finalHull = [];
        for(let i = 0, j = 0; j < size; j++, i += actSkip)finalHull.push(path.get(i));
        return new $21a54bda07acbf50$export$e11c86b5a124f28(finalHull);
    };
}
class $21a54bda07acbf50$export$e11c86b5a124f28 {
    constructor(points = [], closed = true){
        this.points = points;
        this.closed = closed;
    }
    get(index) {
        const i = index;
        const l = this.points.length;
        if (index < 0) return this.closed ? this.get(index + l) : this.points[0];
        else if (index >= l) return this.closed ? this.get(index - l) : this.points[l - 1];
        return this.points[i];
    }
    get length() {
        return this.points.length;
    }
    toString(roundToDigits = Infinity) {
        const points = this.points;
        if (points.length === 0) return '';
        const rounder = typeof roundToDigits === 'function' ? roundToDigits : $21a54bda07acbf50$var$round(roundToDigits);
        let r = 'M';
        for (const p of points)r += `${rounder(p.x)},${rounder(p.y)} L`;
        r = r.slice(0, -1);
        if (this.closed) r += ' Z';
        return r;
    }
    draw(ctx) {
        const points = this.points;
        if (points.length === 0) return;
        ctx.beginPath();
        ctx.moveTo(points[0].x, points[0].y);
        for (const p of points)ctx.lineTo(p.x, p.y);
        if (this.closed) ctx.closePath();
    }
    sample(skip) {
        return $21a54bda07acbf50$var$samplePath(skip)(this);
    }
    simplify(tolerance) {
        return $21a54bda07acbf50$var$shapeSimplifier(tolerance)(this);
    }
    bSplines(granularity) {
        return $21a54bda07acbf50$var$bSplineShapeGenerator(granularity)(this);
    }
    apply(transformer) {
        return transformer(this);
    }
    containsElements(members) {
        const bb = $21a54bda07acbf50$export$c845df1685d3e70f(this.points);
        if (!bb) return false;
        return members.every((member)=>{
            return bb.containsPt(member.cx, member.cy) && this.withinArea(member.cx, member.cy);
        });
    }
    withinArea(px, py) {
        if (this.length === 0) return false;
        let crossings = 0;
        const first = this.points[0];
        const line = new $21a54bda07acbf50$export$17d680238e50603e(first.x, first.y, first.x, first.y);
        for(let i = 1; i < this.points.length; i++){
            const cur = this.points[i];
            line.x1 = line.x2;
            line.y1 = line.y2;
            line.x2 = cur.x;
            line.y2 = cur.y;
            if (line.cuts(px, py)) crossings++;
        }
        line.x1 = line.x2;
        line.y1 = line.y2;
        line.x2 = first.x;
        line.y2 = first.y;
        if (line.cuts(px, py)) crossings++;
        return crossings % 2 === 1;
    }
}
class $21a54bda07acbf50$var$PointList {
    constructor(size = 0){
        this.count = 0;
        this.arr = [];
        this.set = new Set();
        this.arr.length = size;
    }
    add(p) {
        this.set.add(`${p.x}x${p.y}`);
        this.arr[this.count++] = p;
    }
    contains(p) {
        return this.set.has(`${p.x}x${p.y}`);
    }
    isFirst(p) {
        if (this.count === 0) return false;
        const o = this.arr[0];
        return o != null && o.x === p.x && o.y === p.y;
    }
    path() {
        return new $21a54bda07acbf50$export$e11c86b5a124f28(this.arr.slice(0, this.count));
    }
    clear() {
        this.set.clear();
        this.count = 0;
    }
    get(ix) {
        return this.arr[ix];
    }
    get length() {
        return this.count;
    }
}
const $21a54bda07acbf50$var$N = 0;
const $21a54bda07acbf50$var$S = 1;
const $21a54bda07acbf50$var$E = 2;
const $21a54bda07acbf50$var$W = 3;
function $21a54bda07acbf50$var$marchingSquares(potentialArea, threshold) {
    const estLength = (Math.floor(potentialArea.width) + Math.floor(potentialArea.height)) * 2;
    const contour = new $21a54bda07acbf50$var$PointList(estLength);
    function updateDir(x, y, dir, res) {
        const v = potentialArea.get(x, y);
        if (Number.isNaN(v)) return Number.NaN;
        if (v > threshold) return dir + res;
        return dir;
    }
    function getState(x, y) {
        let dir = $21a54bda07acbf50$var$N;
        dir = updateDir(x, y, dir, 1);
        dir = updateDir(x + 1, y, dir, 2);
        dir = updateDir(x, y + 1, dir, 4);
        dir = updateDir(x + 1, y + 1, dir, 8);
        if (Number.isNaN(dir)) return -1;
        return dir;
    }
    let direction = $21a54bda07acbf50$var$S;
    function doMarch(xPos, yPos) {
        let x = xPos;
        let y = yPos;
        let xPixel = potentialArea.invertScaleX(x);
        let yPixel = potentialArea.invertScaleY(y);
        for(let i = 0; i < potentialArea.width * potentialArea.height; i++){
            const p = {
                x: xPixel,
                y: yPixel
            };
            if (contour.contains(p)) {
                if (!contour.isFirst(p)) ;
                else return true;
            } else contour.add(p);
            const state = getState(x, y);
            switch(state){
                case -1:
                    return true;
                case 0:
                case 3:
                case 2:
                case 7:
                    direction = $21a54bda07acbf50$var$E;
                    break;
                case 12:
                case 14:
                case 4:
                    direction = $21a54bda07acbf50$var$W;
                    break;
                case 6:
                    direction = direction === $21a54bda07acbf50$var$N ? $21a54bda07acbf50$var$W : $21a54bda07acbf50$var$E;
                    break;
                case 1:
                case 13:
                case 5:
                    direction = $21a54bda07acbf50$var$N;
                    break;
                case 9:
                    direction = direction === $21a54bda07acbf50$var$E ? $21a54bda07acbf50$var$N : $21a54bda07acbf50$var$S;
                    break;
                case 10:
                case 8:
                case 11:
                    direction = $21a54bda07acbf50$var$S;
                    break;
                default:
                    console.warn('Marching squares invalid state: ' + state);
                    return true;
            }
            switch(direction){
                case $21a54bda07acbf50$var$N:
                    y--;
                    yPixel -= potentialArea.pixelGroup;
                    break;
                case $21a54bda07acbf50$var$S:
                    y++;
                    yPixel += potentialArea.pixelGroup;
                    break;
                case $21a54bda07acbf50$var$W:
                    x--;
                    xPixel -= potentialArea.pixelGroup;
                    break;
                case $21a54bda07acbf50$var$E:
                    x++;
                    xPixel += potentialArea.pixelGroup;
                    break;
                default:
                    console.warn('Marching squares invalid state: ' + state);
                    return true;
            }
        }
        return true;
    }
    for(let x = 0; x < potentialArea.width; x++)for(let y = 0; y < potentialArea.height; y++){
        if (potentialArea.get(x, y) <= threshold) continue;
        const state = getState(x, y);
        if (state < 0 || state === 15) continue;
        if (doMarch(x, y)) return contour.path();
    }
    return null;
}
const $21a54bda07acbf50$export$ba43bf67f3d48107 = {
    maxRoutingIterations: 100,
    maxMarchingIterations: 20,
    pixelGroup: 4,
    edgeR0: 10,
    edgeR1: 20,
    nodeR0: 15,
    nodeR1: 50,
    morphBuffer: 10,
    threshold: 1,
    memberInfluenceFactor: 1,
    edgeInfluenceFactor: 1,
    nonMemberInfluenceFactor: -0.8,
    virtualEdges: true
};
function $21a54bda07acbf50$var$isCircle(v) {
    return v != null && typeof v.radius === 'number';
}
function $21a54bda07acbf50$var$isEqual(a, b) {
    if ($21a54bda07acbf50$var$isCircle(a) !== $21a54bda07acbf50$var$isCircle(b)) return false;
    if ($21a54bda07acbf50$var$isCircle(a)) {
        const bc = b;
        return a.cx === bc.cx && a.cy === bc.cy && a.radius === bc.radius;
    }
    const br = b;
    return a.x === br.x && a.y === br.y && a.width === br.width && a.height === br.height;
}
var $21a54bda07acbf50$var$EDirty;
(function(EDirty) {
    EDirty[EDirty["MEMBERS"] = 0] = "MEMBERS";
    EDirty[EDirty["NON_MEMBERS"] = 1] = "NON_MEMBERS";
    EDirty[EDirty["EDGES"] = 2] = "EDGES";
})($21a54bda07acbf50$var$EDirty || ($21a54bda07acbf50$var$EDirty = {}));
class $21a54bda07acbf50$export$b0964bf07e78d5cb {
    constructor(options = {}){
        this.dirty = new Set();
        this.members = [];
        this.nonMembers = [];
        this.virtualEdges = [];
        this.edges = [];
        this.activeRegion = new $21a54bda07acbf50$export$4617fb02663045ef(0, 0, 0, 0);
        this.potentialArea = new $21a54bda07acbf50$export$ea1a111407f37557(1, 0, 0, 0, 0, 0, 0);
        this.o = Object.assign({}, $21a54bda07acbf50$export$ba43bf67f3d48107, options);
    }
    pushMember(...members) {
        if (members.length === 0) return;
        this.dirty.add($21a54bda07acbf50$var$EDirty.MEMBERS);
        for (const v of members)this.members.push({
            raw: v,
            obj: $21a54bda07acbf50$var$isCircle(v) ? $21a54bda07acbf50$export$c89a927ffc67e6fa.from(v) : $21a54bda07acbf50$export$4617fb02663045ef.from(v),
            area: null
        });
    }
    removeMember(member) {
        const index = this.members.findIndex((d)=>$21a54bda07acbf50$var$isEqual(d.raw, member));
        if (index < 0) return false;
        this.members.splice(index, 1);
        this.dirty.add($21a54bda07acbf50$var$EDirty.MEMBERS);
        return true;
    }
    removeNonMember(nonMember) {
        const index = this.nonMembers.findIndex((d)=>$21a54bda07acbf50$var$isEqual(d.raw, nonMember));
        if (index < 0) return false;
        this.nonMembers.splice(index, 1);
        this.dirty.add($21a54bda07acbf50$var$EDirty.NON_MEMBERS);
        return true;
    }
    removeEdge(edge) {
        const index = this.edges.findIndex((d)=>d.obj.equals(edge));
        if (index < 0) return false;
        this.edges.splice(index, 1);
        this.dirty.add($21a54bda07acbf50$var$EDirty.NON_MEMBERS);
        return true;
    }
    pushNonMember(...nonMembers) {
        if (nonMembers.length === 0) return;
        this.dirty.add($21a54bda07acbf50$var$EDirty.NON_MEMBERS);
        for (const v of nonMembers)this.nonMembers.push({
            raw: v,
            obj: $21a54bda07acbf50$var$isCircle(v) ? $21a54bda07acbf50$export$c89a927ffc67e6fa.from(v) : $21a54bda07acbf50$export$4617fb02663045ef.from(v),
            area: null
        });
    }
    pushEdge(...edges) {
        if (edges.length === 0) return;
        this.dirty.add($21a54bda07acbf50$var$EDirty.EDGES);
        for (const v of edges)this.edges.push({
            raw: v,
            obj: $21a54bda07acbf50$export$17d680238e50603e.from(v),
            area: null
        });
    }
    update() {
        const dirtyMembers = this.dirty.has($21a54bda07acbf50$var$EDirty.MEMBERS);
        const dirtyNonMembers = this.dirty.has($21a54bda07acbf50$var$EDirty.NON_MEMBERS);
        let dirtyEdges = this.dirty.has($21a54bda07acbf50$var$EDirty.EDGES);
        this.dirty.clear();
        const memberObjs = this.members.map((d)=>d.obj);
        if (this.o.virtualEdges && (dirtyMembers || dirtyNonMembers)) {
            const nonMembersAsRects = this.nonMembers.map((d)=>d.obj);
            const virtualEdges = $21a54bda07acbf50$export$adcb69fca15b3962(memberObjs, nonMembersAsRects, this.o.maxRoutingIterations, this.o.morphBuffer);
            const old = new Map(this.virtualEdges.map((e)=>[
                    e.obj.toString(),
                    e.area
                ]));
            this.virtualEdges = virtualEdges.map((e)=>{
                var _a;
                return {
                    raw: e,
                    obj: e,
                    area: (_a = old.get(e.toString())) !== null && _a !== void 0 ? _a : null
                };
            });
            dirtyEdges = true;
        }
        let activeRegionDirty = false;
        if (dirtyMembers || dirtyEdges) {
            const edgesObj = this.virtualEdges.concat(this.edges).map((e)=>e.obj);
            const bb = $21a54bda07acbf50$export$2ee2c9fb0417d5ac(memberObjs, edgesObj);
            const padding = Math.max(this.o.edgeR1, this.o.nodeR1) + this.o.morphBuffer;
            const activeRegion = $21a54bda07acbf50$export$4617fb02663045ef.from($21a54bda07acbf50$export$adf255e13b40f23f(bb, padding));
            if (!activeRegion.equals(this.activeRegion)) {
                activeRegionDirty = true;
                this.activeRegion = activeRegion;
            }
        }
        if (activeRegionDirty) {
            const potentialWidth = Math.ceil(this.activeRegion.width / this.o.pixelGroup);
            const potentialHeight = Math.ceil(this.activeRegion.height / this.o.pixelGroup);
            if (this.activeRegion.x !== this.potentialArea.pixelX || this.activeRegion.y !== this.potentialArea.pixelY) {
                this.potentialArea = $21a54bda07acbf50$export$ea1a111407f37557.fromPixelRegion(this.activeRegion, this.o.pixelGroup);
                this.members.forEach((m)=>m.area = null);
                this.nonMembers.forEach((m)=>m.area = null);
                this.edges.forEach((m)=>m.area = null);
                this.virtualEdges.forEach((m)=>m.area = null);
            } else if (potentialWidth !== this.potentialArea.width || potentialHeight !== this.potentialArea.height) this.potentialArea = $21a54bda07acbf50$export$ea1a111407f37557.fromPixelRegion(this.activeRegion, this.o.pixelGroup);
        }
        const existing = new Map();
        const addCache = (m)=>{
            if (m.area) {
                const key = `${m.obj.width}x${m.obj.height}x${m.obj instanceof $21a54bda07acbf50$export$4617fb02663045ef ? 'R' : 'C'}`;
                existing.set(key, m.area);
            }
        };
        const createOrAddCache = (m)=>{
            if (m.area) return;
            const key = `${m.obj.width}x${m.obj.height}x${m.obj instanceof $21a54bda07acbf50$export$4617fb02663045ef ? 'R' : 'C'}`;
            if (existing.has(key)) {
                const r = existing.get(key);
                m.area = this.potentialArea.copy(r, {
                    x: m.obj.x - this.o.nodeR1,
                    y: m.obj.y - this.o.nodeR1
                });
                return;
            }
            const r = m.obj instanceof $21a54bda07acbf50$export$4617fb02663045ef ? $21a54bda07acbf50$export$1f5241b260204fa9(m.obj, this.potentialArea, this.o.nodeR1) : $21a54bda07acbf50$export$88df63bd43ece0f0(m.obj, this.potentialArea, this.o.nodeR1);
            m.area = r;
            existing.set(key, r);
        };
        this.members.forEach(addCache);
        this.nonMembers.forEach(addCache);
        this.members.forEach(createOrAddCache);
        this.nonMembers.forEach((m)=>{
            if (!this.activeRegion.intersects(m.obj)) m.area = null;
            else createOrAddCache(m);
        });
        this.edges.forEach((edge)=>{
            if (!edge.area) edge.area = $21a54bda07acbf50$export$4a96817c3621429e(edge.obj, this.potentialArea, this.o.edgeR1);
        });
        this.virtualEdges.forEach((edge)=>{
            if (!edge.area) edge.area = $21a54bda07acbf50$export$4a96817c3621429e(edge.obj, this.potentialArea, this.o.edgeR1);
        });
    }
    drawMembers(ctx) {
        for (const member of this.members)member.obj.draw(ctx);
    }
    drawNonMembers(ctx) {
        for (const member of this.nonMembers)member.obj.draw(ctx);
    }
    drawEdges(ctx) {
        for (const edge of this.edges)edge.obj.draw(ctx);
    }
    drawPotentialArea(ctx, offset = true) {
        this.potentialArea.draw(ctx, offset);
    }
    compute() {
        if (this.members.length === 0) return new $21a54bda07acbf50$export$e11c86b5a124f28([]);
        if (this.dirty.size > 0) this.update();
        const { o: o, potentialArea: potentialArea } = this;
        const members = this.members.map((m)=>m.area);
        const edges = this.virtualEdges.concat(this.edges).map((d)=>d.area);
        const nonMembers = this.nonMembers.filter((d)=>d.area != null).map((d)=>d.area);
        const memberObjs = this.members.map((m)=>m.obj);
        return $21a54bda07acbf50$export$a7b1397aa533a84f(potentialArea, members, edges, nonMembers, (p)=>p.containsElements(memberObjs), o);
    }
}
function $21a54bda07acbf50$export$a7b1397aa533a84f(potentialArea, members, edges, nonMembers, validPath, options = {}) {
    const o = Object.assign({}, $21a54bda07acbf50$export$ba43bf67f3d48107, options);
    let threshold = o.threshold;
    let memberInfluenceFactor = o.memberInfluenceFactor;
    let edgeInfluenceFactor = o.edgeInfluenceFactor;
    let nonMemberInfluenceFactor = o.nonMemberInfluenceFactor;
    const nodeInfA = (o.nodeR0 - o.nodeR1) * (o.nodeR0 - o.nodeR1);
    const edgeInfA = (o.edgeR0 - o.edgeR1) * (o.edgeR0 - o.edgeR1);
    for(let iterations = 0; iterations < o.maxMarchingIterations; iterations++){
        potentialArea.clear();
        if (memberInfluenceFactor !== 0) {
            const f = memberInfluenceFactor / nodeInfA;
            for (const item of members)potentialArea.incArea(item, f);
        }
        if (edgeInfluenceFactor !== 0) {
            const f = edgeInfluenceFactor / edgeInfA;
            for (const area of edges)potentialArea.incArea(area, f);
        }
        if (nonMemberInfluenceFactor !== 0) {
            const f = nonMemberInfluenceFactor / nodeInfA;
            for (const area of nonMembers)potentialArea.incArea(area, f);
        }
        const contour = $21a54bda07acbf50$var$marchingSquares(potentialArea, threshold);
        if (contour && validPath(contour)) return contour;
        threshold *= 0.95;
        if (iterations <= o.maxMarchingIterations * 0.5) {
            memberInfluenceFactor *= 1.2;
            edgeInfluenceFactor *= 1.2;
        } else if (nonMemberInfluenceFactor !== 0 && nonMembers.length > 0) nonMemberInfluenceFactor *= 0.8;
        else break;
    }
    return new $21a54bda07acbf50$export$e11c86b5a124f28([]);
}
function $21a54bda07acbf50$export$2ee2c9fb0417d5ac(memberItems, edgeItems) {
    if (memberItems.length === 0) return new $21a54bda07acbf50$export$4617fb02663045ef(0, 0, 0, 0);
    const activeRegion = $21a54bda07acbf50$export$4617fb02663045ef.from(memberItems[0]);
    for (const m of memberItems)activeRegion.add(m);
    for (const l of edgeItems)activeRegion.add($21a54bda07acbf50$export$26fe0db1e56290ef(l));
    return activeRegion;
}
function $21a54bda07acbf50$export$cc913e7b2de70ad9(members, nonMembers = [], edges = [], options = {}) {
    if (members.length === 0) return new $21a54bda07acbf50$export$e11c86b5a124f28([]);
    const bb = new $21a54bda07acbf50$export$b0964bf07e78d5cb(options);
    bb.pushMember(...members);
    bb.pushNonMember(...nonMembers);
    bb.pushEdge(...edges);
    return bb.compute();
}

});


parcelRegister("fuTQ7", function(module, exports) {
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $WdqOS = parcelRequire("WdqOS");
class $b484f8f7ab15c944$export$1279dab409618ab6 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, options);
        this.setOptions = (options)=>{
            const caller = {
                cameraType: 'setType',
                near: 'setNear',
                far: 'setFar',
                fov: 'setFov',
                aspect: 'setAspect',
                // 确保 projectionMode 在 near/far/fov/aspect 之后设置
                // Ensure that projectionMode is set after near/far/fov/aspect
                projectionMode: 'setProjectionMode',
                distance: 'setDistance',
                minDistance: 'setMinDistance',
                maxDistance: 'setMaxDistance',
                roll: 'setRoll',
                elevation: 'setElevation',
                azimuth: 'setAzimuth'
            };
            const valueMapper = (key, value)=>{
                switch(key){
                    case 'projectionMode':
                        return value === 'perspective' ? 1 : 0;
                    case 'cameraType':
                        return ({
                            orbiting: 0,
                            exploring: 1,
                            tracking: 2
                        })[value];
                    case 'aspect':
                        if (typeof value === 'number') return value;
                        return this.getCanvasAspect();
                    default:
                        return value;
                }
            };
            Object.entries(caller).forEach(([key, method])=>{
                const value = options[key];
                if (value !== undefined) {
                    const actualValue = valueMapper(key, value);
                    // @ts-expect-error incorrect ts type check
                    this.context.canvas.getCamera()[method](actualValue);
                }
            });
        };
        this.bindEvents();
    }
    /**
     * <zh/> 更新相机参数
     *
     * <en/> Update camera parameters
     * @param options - <zh/> 相机配置项 | <en/> Camera configuration options
     * @internal
     */ update(options) {
        this.setOptions(options);
        super.update(options);
    }
    bindEvents() {
        this.context.graph.once((0, $4EzN9.GraphEvent).BEFORE_DRAW, ()=>this.setOptions(this.options));
    }
    getCanvasAspect() {
        const [width, height] = this.context.viewport.getCanvasSize();
        return width / height;
    }
}

});

parcelRegister("4XBSa", function(module, exports) {

$parcel$export(module.exports, "Contextmenu", () => $39ca0cd51ef04434$export$fe3295253c457f20);

var $WdqOS = parcelRequire("WdqOS");

var $bEb16 = parcelRequire("bEb16");

var $bb2xy = parcelRequire("bb2xy");
var $39ca0cd51ef04434$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $39ca0cd51ef04434$export$fe3295253c457f20 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $39ca0cd51ef04434$export$fe3295253c457f20.defaultOptions, options));
        this.targetElement = null;
        this.onTriggerEvent = (event)=>{
            var _a;
            // `contextmenu` 事件默认会触发浏览器的右键菜单，需要阻止默认事件
            // `click` 事件不需要阻止默认事件
            (_a = event.preventDefault) === null || _a === void 0 || _a.call(event);
            this.show(event);
        };
        this.onMenuItemClick = (event)=>{
            const { onClick: onClick, trigger: trigger } = this.options;
            if (event.target instanceof HTMLElement) {
                if (event.target.className.includes('g6-contextmenu-li')) {
                    const value = event.target.getAttribute('value');
                    onClick === null || onClick === void 0 || onClick(value, event.target, this.targetElement);
                    this.hide();
                }
            }
            if (trigger !== 'click') this.hide();
        };
        this.initElement();
        this.update(options);
    }
    initElement() {
        this.$element = (0, $bEb16.createPluginContainer)('contextmenu', false, {
            zIndex: '99'
        });
        const { className: className } = this.options;
        if (className) this.$element.classList.add(className);
        const $container = this.context.canvas.getContainer();
        $container.appendChild(this.$element);
        (0, $bEb16.insertDOM)('g6-contextmenu-css', 'style', {}, (0, $bb2xy.CONTEXTMENU_CSS), document.head);
    }
    /**
     * <zh/> 显示上下文菜单
     *
     * <en/> Show the contextmenu
     * @param event - <zh/> 元素指针事件 | <en/> Element pointer event
     * @internal
     */ show(event) {
        return $39ca0cd51ef04434$var$__awaiter(this, void 0, void 0, function*() {
            const { enable: enable, offset: offset } = this.options;
            if (typeof enable === 'function' && !enable(event) || !enable) {
                this.hide();
                return;
            }
            const content = yield this.getDOMContent(event);
            if (content instanceof HTMLElement) {
                this.$element.innerHTML = '';
                this.$element.appendChild(content);
            } else this.$element.innerHTML = content;
            // NOTICE: 为什么事件中的 client 是相对浏览器，而不是画布容器？
            const clientRect = this.context.graph.getCanvas().getContainer().getBoundingClientRect();
            this.$element.style.left = `${event.client.x - clientRect.left + offset[0]}px`;
            this.$element.style.top = `${event.client.y - clientRect.top + offset[1]}px`;
            this.$element.style.display = 'block';
            this.targetElement = event.target;
        });
    }
    /**
     * <zh/> 隐藏上下文菜单
     *
     * <en/> Hide the contextmenu
     */ hide() {
        this.$element.style.display = 'none';
        this.targetElement = null;
    }
    /**
     * <zh/> 更新上下文菜单的配置项
     *
     * <en/> Update the contextmenu options
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */ update(options) {
        this.unbindEvents();
        super.update(options);
        this.bindEvents();
    }
    /**
     * <zh/> 销毁上下文菜单
     *
     * <en/> Destroy the contextmenu
     * @internal
     */ destroy() {
        this.unbindEvents();
        super.destroy();
        this.$element.remove();
    }
    getDOMContent(event) {
        return $39ca0cd51ef04434$var$__awaiter(this, void 0, void 0, function*() {
            const { getContent: getContent, getItems: getItems } = this.options;
            if (getItems) return (0, $bb2xy.getContentFromItems)((yield getItems(event)));
            return yield getContent(event);
        });
    }
    bindEvents() {
        const { graph: graph } = this.context;
        const { trigger: trigger } = this.options;
        graph.on(`canvas:${trigger}`, this.onTriggerEvent);
        graph.on(`node:${trigger}`, this.onTriggerEvent);
        graph.on(`edge:${trigger}`, this.onTriggerEvent);
        graph.on(`combo:${trigger}`, this.onTriggerEvent);
        document.addEventListener('click', this.onMenuItemClick);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        const { trigger: trigger } = this.options;
        graph.off(`canvas:${trigger}`, this.onTriggerEvent);
        graph.off(`node:${trigger}`, this.onTriggerEvent);
        graph.off(`edge:${trigger}`, this.onTriggerEvent);
        graph.off(`combo:${trigger}`, this.onTriggerEvent);
        document.removeEventListener('click', this.onMenuItemClick);
    }
}
$39ca0cd51ef04434$export$fe3295253c457f20.defaultOptions = {
    trigger: 'contextmenu',
    offset: [
        4,
        4
    ],
    loadingContent: '<div class="g6-contextmenu-loading">Loading...</div>',
    getContent: ()=>'It is a empty context menu.',
    enable: ()=>true
};

});
parcelRegister("bb2xy", function(module, exports) {

$parcel$export(module.exports, "getContentFromItems", () => $8232b13d73b3edfd$export$396a3f10a0550c5d);
$parcel$export(module.exports, "CONTEXTMENU_CSS", () => $8232b13d73b3edfd$export$d2745790b746f83e);
/**
 * Get the content of the right-click menu.
 * @param items - context menu items
 * @returns HTML string
 */ function $8232b13d73b3edfd$export$396a3f10a0550c5d(items) {
    return `
    <ul class="g6-contextmenu-ul">
      ${items.map((item)=>`<li  class="g6-contextmenu-li" value="${item.value}">${item.name}</li>`).join('')}
    </ul>
  `;
}
const $8232b13d73b3edfd$export$d2745790b746f83e = `
  .g6-contextmenu {
    font-size: 12px;
    background-color: rgba(255, 255, 255, 0.96);
    border-radius: 4px;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 12px 0px;
    transition: visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1) 0s, left 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s, top 0.4s cubic-bezier(0.23, 1, 0.32, 1) 0s;
  }

  .g6-contextmenu-ul {
    max-width: 256px;
    min-width: 96px;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .g6-contextmenu-li {
    padding: 8px 12px;
    cursor: pointer;
    user-select: none;
  }

  .g6-contextmenu-li:hover {
    background-color: #f5f5f5;
    cursor: pointer;
  }
`;

});


parcelRegister("1uN78", function(module, exports) {

$parcel$export(module.exports, "EdgeBundling", () => $116eb0cf47690d1a$export$b243353618eb4506);

var $hllqz = parcelRequire("hllqz");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $25dP3 = parcelRequire("25dP3");

var $brtTw = parcelRequire("brtTw");

var $46bcR = parcelRequire("46bcR");

var $dOidW = parcelRequire("dOidW");

var $WdqOS = parcelRequire("WdqOS");
class $116eb0cf47690d1a$export$b243353618eb4506 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $116eb0cf47690d1a$export$b243353618eb4506.defaultOptions, options));
        this.edgeBundles = {};
        this.edgePoints = {};
        this.onBundle = ()=>{
            const { model: model, element: element } = this.context;
            const edges = model.getEdgeData();
            this.divideEdges(this.options.divisions);
            const { cycles: cycles, iterRate: iterRate, divRate: divRate } = this.options;
            let { lambda: lambda, divisions: divisions, iterations: iterations } = this.options;
            for(let i = 0; i < cycles; i++){
                for(let j = 0; j < iterations; j++){
                    const forces = {};
                    edges.forEach((edge)=>{
                        var _a;
                        if (edge.source === edge.target) return;
                        const edgeId = (0, $brtTw.idOf)(edge);
                        forces[edgeId] = this.getEdgeForces(edge, divisions, lambda);
                        for(let p = 0; p < divisions + 1; p++){
                            (_a = this.edgePoints)[edgeId] || (_a[edgeId] = []);
                            this.edgePoints[edgeId][p] = (0, $dOidW.add)(this.edgePoints[edgeId][p], forces[edgeId][p]);
                        }
                    });
                }
                // parameters for next cycle
                lambda /= 2;
                divisions *= divRate;
                iterations *= iterRate;
                this.divideEdges(divisions);
            }
            edges.forEach((edge)=>{
                const edgeId = (0, $brtTw.idOf)(edge);
                const edgeEl = element.getElement(edgeId);
                edgeEl === null || edgeEl === void 0 || edgeEl.update({
                    d: (0, $25dP3.getPolylinePath)(this.edgePoints[edgeId])
                });
            });
        };
        this.bindEvents();
    }
    get nodeMap() {
        const nodes = this.context.model.getNodeData();
        return Object.fromEntries(nodes.map((node)=>[
                (0, $brtTw.idOf)(node),
                (0, $dOidW.toVector2)((0, $46bcR.positionOf)(node))
            ]));
    }
    divideEdges(divisions) {
        const edges = this.context.model.getEdgeData();
        edges.forEach((edge)=>{
            var _a;
            const edgeId = (0, $brtTw.idOf)(edge);
            (_a = this.edgePoints)[edgeId] || (_a[edgeId] = []);
            const source = this.nodeMap[edge.source];
            const target = this.nodeMap[edge.target];
            if (divisions === 1) {
                this.edgePoints[edgeId].push(source);
                this.edgePoints[edgeId].push((0, $dOidW.divide)((0, $dOidW.add)(source, target), 2));
                this.edgePoints[edgeId].push(target);
            } else {
                const edgeLength = this.edgePoints[edgeId].length === 0 ? (0, $dOidW.distance)(source, target) : $116eb0cf47690d1a$var$getEdgeLength(this.edgePoints[edgeId]);
                const divisionLength = edgeLength / (divisions + 1);
                let currentDivisionLength = divisionLength;
                const newEdgePoints = [
                    source
                ];
                for(let i = 1; i < this.edgePoints[edgeId].length; i++){
                    const prevEp = this.edgePoints[edgeId][i - 1];
                    const ep = this.edgePoints[edgeId][i];
                    let oriDivisionLength = (0, $dOidW.distance)(ep, prevEp);
                    while(oriDivisionLength > currentDivisionLength){
                        const ratio = currentDivisionLength / oriDivisionLength;
                        const edgePoint = (0, $dOidW.add)(prevEp, (0, $dOidW.multiply)((0, $dOidW.subtract)(ep, prevEp), ratio));
                        newEdgePoints.push(edgePoint);
                        oriDivisionLength -= currentDivisionLength;
                        currentDivisionLength = divisionLength;
                    }
                    currentDivisionLength -= oriDivisionLength;
                }
                newEdgePoints.push(target);
                this.edgePoints[edgeId] = newEdgePoints;
            }
        });
    }
    getVectorPosition(edge) {
        const source = this.nodeMap[edge.source];
        const target = this.nodeMap[edge.target];
        const [vx, vy] = (0, $dOidW.subtract)(target, source);
        const length = (0, $dOidW.distance)(source, target);
        return {
            source: source,
            target: target,
            vx: vx,
            vy: vy,
            length: length
        };
    }
    measureEdgeCompatibility(edge1, edge2) {
        const vector1 = this.getVectorPosition(edge1);
        const vector2 = this.getVectorPosition(edge2);
        const ac = $116eb0cf47690d1a$var$getAngleCompatibility(vector1, vector2);
        const sc = $116eb0cf47690d1a$var$getScaleCompatibility(vector1, vector2);
        const pc = $116eb0cf47690d1a$var$getPositionCompatibility(vector1, vector2);
        const vc = $116eb0cf47690d1a$var$getVisibilityCompatibility(vector1, vector2);
        return ac * sc * pc * vc;
    }
    getEdgeBundles() {
        const edgeBundles = {};
        const bundleThreshold = this.options.bundleThreshold;
        const edges = this.context.model.getEdgeData();
        edges.forEach((edge1, i)=>{
            edges.forEach((edge2, j)=>{
                var _a, _b;
                if (j <= i) return;
                const compatibility = this.measureEdgeCompatibility(edge1, edge2);
                if (compatibility >= bundleThreshold) {
                    edgeBundles[_a = (0, $brtTw.idOf)(edge1)] || (edgeBundles[_a] = []);
                    edgeBundles[(0, $brtTw.idOf)(edge1)].push(edge2);
                    edgeBundles[_b = (0, $brtTw.idOf)(edge2)] || (edgeBundles[_b] = []);
                    edgeBundles[(0, $brtTw.idOf)(edge2)].push(edge1);
                }
            });
        });
        return edgeBundles;
    }
    getSpringForce(divisions, kp) {
        const { pre: pre, cur: cur, next: next } = divisions;
        return (0, $dOidW.multiply)((0, $dOidW.subtract)((0, $dOidW.add)(pre, next), (0, $dOidW.multiply)(cur, 2)), kp);
    }
    getElectrostaticForce(pidx, edge) {
        if ((0, $hllqz.default)(this.edgeBundles)) this.edgeBundles = this.getEdgeBundles();
        const edgeBundle = this.edgeBundles[(0, $brtTw.idOf)(edge)];
        let resForce = [
            0,
            0
        ];
        edgeBundle === null || edgeBundle === void 0 || edgeBundle.forEach((eb)=>{
            const p1 = this.edgePoints[(0, $brtTw.idOf)(eb)][pidx];
            const p2 = this.edgePoints[(0, $brtTw.idOf)(edge)][pidx];
            const force = (0, $dOidW.subtract)(p1, p2);
            const length = (0, $dOidW.distance)(p1, p2);
            resForce = (0, $dOidW.add)(resForce, (0, $dOidW.multiply)(force, 1 / length));
        });
        return resForce;
    }
    getEdgeForces(edge, divisions, lambda) {
        const source = this.nodeMap[edge.source];
        const target = this.nodeMap[edge.target];
        const kp = this.options.K / ((0, $dOidW.distance)(source, target) * (divisions + 1));
        const edgePointForces = [
            [
                0,
                0
            ]
        ];
        const edgeId = (0, $brtTw.idOf)(edge);
        for(let i = 1; i < divisions; i++){
            const spring = this.getSpringForce({
                pre: this.edgePoints[edgeId][i - 1],
                cur: this.edgePoints[edgeId][i],
                next: this.edgePoints[edgeId][i + 1] || [
                    0,
                    0
                ]
            }, kp);
            const electrostatic = this.getElectrostaticForce(i, edge);
            edgePointForces.push((0, $dOidW.multiply)((0, $dOidW.add)(spring, electrostatic), lambda));
        }
        edgePointForces.push([
            0,
            0
        ]);
        return edgePointForces;
    }
    bindEvents() {
        const { graph: graph } = this.context;
        graph.on((0, $4EzN9.GraphEvent).AFTER_RENDER, this.onBundle);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        graph.off((0, $4EzN9.GraphEvent).AFTER_RENDER, this.onBundle);
    }
    destroy() {
        this.unbindEvents();
        super.destroy();
    }
}
$116eb0cf47690d1a$export$b243353618eb4506.defaultOptions = {
    K: 0.1,
    lambda: 0.1,
    divisions: 1,
    divRate: 2,
    cycles: 6,
    iterations: 90,
    iterRate: 2 / 3,
    bundleThreshold: 0.6
};
// The larger the angle between edges P and Q, the smaller Ca(P,Q).
// Ca(P,Q) is 0 if P and Q are orthogonal and 1 if P and Q are parallel.
const $116eb0cf47690d1a$var$getAngleCompatibility = (p, q)=>{
    return Math.abs((0, $dOidW.dot)([
        p.vx,
        p.vy
    ], [
        q.vx,
        q.vy
    ]) / (p.length * q.length));
};
// Cs(P,Q) is 1 if P and Q have equal length and approaches 0 if the ratio between the longest and the shortest edge approaches ∞.
const $116eb0cf47690d1a$var$getScaleCompatibility = (p, q)=>{
    const aLength = (p.length + q.length) / 2;
    return 2 / (aLength / Math.min(p.length, q.length) + Math.max(p.length, q.length) / aLength);
};
// Cp(P,Q) is 1 if Pm and Qm coincide and approaches 0 if ||Pm −Qm|| approaches ∞.
const $116eb0cf47690d1a$var$getPositionCompatibility = (p, q)=>{
    const aLength = (p.length + q.length) / 2;
    const pMid = (0, $dOidW.divide)((0, $dOidW.add)(p.source, p.target), 2);
    const qMid = (0, $dOidW.divide)((0, $dOidW.add)(q.source, q.target), 2);
    return aLength / (aLength + (0, $dOidW.distance)(pMid, qMid));
};
const $116eb0cf47690d1a$var$projectPointToEdge = (p, e)=>{
    if (e.source[0] === e.target[0]) return [
        e.source[0],
        p[1]
    ];
    if (e.source[1] === e.target[1]) return [
        p[0],
        e.source[1]
    ];
    const k = (e.source[1] - e.target[1]) / (e.source[0] - e.target[0]);
    const x = (k * k * e.source[0] + k * (p[1] - e.source[1]) + p[0]) / (k * k + 1);
    const y = k * (x - e.source[0]) + e.source[1];
    return [
        x,
        y
    ];
};
const $116eb0cf47690d1a$var$getEdgeVisibility = (p, q)=>{
    const is = $116eb0cf47690d1a$var$projectPointToEdge(q.source, p);
    const it = $116eb0cf47690d1a$var$projectPointToEdge(q.target, p);
    const iMid = (0, $dOidW.divide)((0, $dOidW.add)(is, it), 2);
    const pMid = (0, $dOidW.divide)((0, $dOidW.add)(p.source, p.target), 2);
    if ((0, $dOidW.distance)(is, it) === 0) return 0;
    return Math.max(0, 1 - 2 * (0, $dOidW.distance)(pMid, iMid) / (0, $dOidW.distance)(is, it));
};
const $116eb0cf47690d1a$var$getVisibilityCompatibility = (p, q)=>{
    return Math.min($116eb0cf47690d1a$var$getEdgeVisibility(p, q), $116eb0cf47690d1a$var$getEdgeVisibility(q, p));
};
/**
 * Calculate the length of a polyline
 * @param points - The points of the polyline
 * @returns The length of the polyline
 */ const $116eb0cf47690d1a$var$getEdgeLength = (points)=>{
    let length = 0;
    for(let i = 1; i < points.length; i++)length += (0, $dOidW.distance)(points[i], points[i - 1]);
    return length;
};

});

parcelRegister("cCF4r", function(module, exports) {

$parcel$export(module.exports, "EdgeFilterLens", () => $9308e467489f1689$export$c5fc19d5618e9348);
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");
parcelRequire("2zk86");
var $dbxRO = parcelRequire("dbxRO");

var $brtTw = parcelRequire("brtTw");

var $dnXls = parcelRequire("dnXls");

var $46bcR = parcelRequire("46bcR");

var $dOidW = parcelRequire("dOidW");

var $WdqOS = parcelRequire("WdqOS");
const $9308e467489f1689$var$defaultLensStyle = {
    fill: '#fff',
    fillOpacity: 1,
    lineWidth: 1,
    stroke: '#000',
    strokeOpacity: 0.8,
    zIndex: -Infinity
};
const $9308e467489f1689$var$DELTA = 0.05;
class $9308e467489f1689$export$c5fc19d5618e9348 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $9308e467489f1689$export$c5fc19d5618e9348.defaultOptions, options));
        this.shapes = new Map();
        this.r = this.options.r;
        this.onEdgeFilter = (event)=>{
            if (this.options.trigger === 'drag' && this.isLensOn) return;
            const origin = (0, $dnXls.parsePoint)(event.canvas);
            this.renderLens(origin);
            this.renderFocusElements();
        };
        this.renderLens = (origin)=>{
            const style = Object.assign({}, $9308e467489f1689$var$defaultLensStyle, this.options.style);
            if (!this.isLensOn) {
                this.lens = new (0, $dbxRO.Circle)({
                    style: style
                });
                this.canvas.appendChild(this.lens);
            }
            Object.assign(style, (0, $dnXls.toPointObject)(origin), {
                size: this.r * 2
            });
            this.lens.update(style);
        };
        this.getFilterData = ()=>{
            const { filter: filter } = this.options;
            const { model: model } = this.context;
            const data = model.getData();
            if (!filter) return data;
            const { nodes: nodes, edges: edges, combos: combos } = data;
            return {
                nodes: nodes.filter((node)=>filter((0, $brtTw.idOf)(node), 'node')),
                edges: edges.filter((edge)=>filter((0, $brtTw.idOf)(edge), 'edge')),
                combos: combos.filter((combo)=>filter((0, $brtTw.idOf)(combo), 'combo'))
            };
        };
        this.getFocusElements = (origin)=>{
            const { nodes: nodes, edges: edges } = this.getFilterData();
            const focusNodes = nodes.filter((datum)=>(0, $dOidW.distance)((0, $46bcR.positionOf)(datum), origin) < this.r);
            const focusNodeIds = focusNodes.map((node)=>(0, $brtTw.idOf)(node));
            const focusEdges = edges.filter((datum)=>{
                const { source: source, target: target } = datum;
                const isSourceFocus = focusNodeIds.includes(source);
                const isTargetFocus = focusNodeIds.includes(target);
                switch(this.options.nodeType){
                    case 'both':
                        return isSourceFocus && isTargetFocus;
                    case 'either':
                        return isSourceFocus !== isTargetFocus;
                    case 'source':
                        return isSourceFocus && !isTargetFocus;
                    case 'target':
                        return !isSourceFocus && isTargetFocus;
                    default:
                        return false;
                }
            });
            return {
                nodes: focusNodes,
                edges: focusEdges
            };
        };
        this.renderFocusElements = ()=>{
            const { element: element, graph: graph } = this.context;
            if (!this.isLensOn) return;
            const origin = this.lens.getCenter();
            const { nodes: nodes, edges: edges } = this.getFocusElements(origin);
            const ids = new Set();
            const iterate = (datum)=>{
                const id = (0, $brtTw.idOf)(datum);
                ids.add(id);
                const shape = element.getElement(id);
                if (!shape) return;
                const cloneShape = this.shapes.get(id) || shape.cloneNode();
                cloneShape.setPosition(shape.getPosition());
                cloneShape.id = shape.id;
                if (!this.shapes.has(id)) {
                    this.canvas.appendChild(cloneShape);
                    this.shapes.set(id, cloneShape);
                } else Object.entries(shape.attributes).forEach(([key, value])=>{
                    if (cloneShape.style[key] !== value) cloneShape.style[key] = value;
                });
                const elementType = graph.getElementType(id);
                const style = this.getElementStyle(elementType, datum);
                // @ts-ignore
                cloneShape.update(style);
            };
            nodes.forEach(iterate);
            edges.forEach(iterate);
            this.shapes.forEach((shape, id)=>{
                if (!ids.has(id)) {
                    shape.destroy();
                    this.shapes.delete(id);
                }
            });
        };
        this.scaleRByWheel = (event)=>{
            var _a;
            if (this.options.preventDefault) event.preventDefault();
            const { clientX: clientX, clientY: clientY, deltaX: deltaX, deltaY: deltaY } = event;
            const { graph: graph, canvas: canvas } = this.context;
            const scaleOrigin = graph.getCanvasByClient([
                clientX,
                clientY
            ]);
            const origin = (_a = this.lens) === null || _a === void 0 ? void 0 : _a.getCenter();
            if (!this.isLensOn || (0, $dOidW.distance)(scaleOrigin, origin) > this.r) return;
            const { maxR: maxR, minR: minR } = this.options;
            const ratio = deltaX + deltaY > 0 ? 1 / (1 - $9308e467489f1689$var$DELTA) : 1 - $9308e467489f1689$var$DELTA;
            const canvasR = Math.min(...canvas.getSize()) / 2;
            this.r = Math.max(minR || 0, Math.min(maxR || canvasR, this.r * ratio));
            this.renderLens(origin);
            this.renderFocusElements();
        };
        this.isLensDragging = false;
        this.onDragStart = (event)=>{
            var _a;
            const dragOrigin = (0, $dnXls.parsePoint)(event.canvas);
            const origin = (_a = this.lens) === null || _a === void 0 ? void 0 : _a.getCenter();
            if (!this.isLensOn || (0, $dOidW.distance)(dragOrigin, origin) > this.r) return;
            this.isLensDragging = true;
        };
        this.onDrag = (event)=>{
            if (!this.isLensDragging) return;
            const dragOrigin = (0, $dnXls.parsePoint)(event.canvas);
            this.renderLens(dragOrigin);
            this.renderFocusElements();
        };
        this.onDragEnd = ()=>{
            this.isLensDragging = false;
        };
        this.bindEvents();
    }
    get canvas() {
        return this.context.canvas.getLayer('transient');
    }
    get isLensOn() {
        return this.lens && !this.lens.destroyed;
    }
    getElementStyle(elementType, datum) {
        const styler = elementType === 'node' ? this.options.nodeStyle : this.options.edgeStyle;
        if (typeof styler === 'function') return styler(datum);
        return styler;
    }
    get graphDom() {
        return this.context.graph.getCanvas().getContextService().getDomElement();
    }
    bindEvents() {
        var _a;
        const { graph: graph } = this.context;
        const { trigger: trigger, scaleRBy: scaleRBy } = this.options;
        const canvas = graph.getCanvas().getLayer();
        if ([
            'click',
            'drag'
        ].includes(trigger)) canvas.addEventListener((0, $9Iel2.CommonEvent).CLICK, this.onEdgeFilter);
        if (trigger === 'pointermove') canvas.addEventListener((0, $9Iel2.CommonEvent).POINTER_MOVE, this.onEdgeFilter);
        else if (trigger === 'drag') {
            canvas.addEventListener((0, $9Iel2.CommonEvent).DRAG_START, this.onDragStart);
            canvas.addEventListener((0, $9Iel2.CommonEvent).DRAG, this.onDrag);
            canvas.addEventListener((0, $9Iel2.CommonEvent).DRAG_END, this.onDragEnd);
        }
        if (scaleRBy === 'wheel') (_a = this.graphDom) === null || _a === void 0 || _a.addEventListener((0, $9Iel2.CommonEvent).WHEEL, this.scaleRByWheel, {
            passive: false
        });
    }
    unbindEvents() {
        var _a;
        const { graph: graph } = this.context;
        const { trigger: trigger, scaleRBy: scaleRBy } = this.options;
        const canvas = graph.getCanvas().getLayer();
        if ([
            'click',
            'drag'
        ].includes(trigger)) canvas.removeEventListener((0, $9Iel2.CommonEvent).CLICK, this.onEdgeFilter);
        if (trigger === 'pointermove') canvas.removeEventListener((0, $9Iel2.CommonEvent).POINTER_MOVE, this.onEdgeFilter);
        else if (trigger === 'drag') {
            canvas.removeEventListener((0, $9Iel2.CommonEvent).DRAG_START, this.onDragStart);
            canvas.removeEventListener((0, $9Iel2.CommonEvent).DRAG, this.onDrag);
            canvas.removeEventListener((0, $9Iel2.CommonEvent).DRAG_END, this.onDragEnd);
        }
        if (scaleRBy === 'wheel') (_a = this.graphDom) === null || _a === void 0 || _a.removeEventListener((0, $9Iel2.CommonEvent).WHEEL, this.scaleRByWheel);
    }
    update(options) {
        var _a;
        this.unbindEvents();
        super.update(options);
        this.r = (_a = options.r) !== null && _a !== void 0 ? _a : this.r;
        this.bindEvents();
    }
    destroy() {
        this.unbindEvents();
        if (this.isLensOn) this.lens.destroy();
        this.shapes.forEach((shape, id)=>{
            shape.destroy();
            this.shapes.delete(id);
        });
        super.destroy();
    }
}
$9308e467489f1689$export$c5fc19d5618e9348.defaultOptions = {
    trigger: 'pointermove',
    r: 60,
    nodeType: 'both',
    filter: ()=>true,
    style: {
        lineWidth: 2
    },
    nodeStyle: {
        label: false
    },
    edgeStyle: {
        label: true
    },
    scaleRBy: 'wheel',
    preventDefault: true
};

});

parcelRegister("5OSjO", function(module, exports) {

$parcel$export(module.exports, "Fisheye", () => $43cbc1c895dee0e5$export$7e0fae892bcfed4c);

var $cyCCc = parcelRequire("cyCCc");
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");
parcelRequire("2zk86");
var $dbxRO = parcelRequire("dbxRO");

var $6SQtU = parcelRequire("6SQtU");

var $brtTw = parcelRequire("brtTw");

var $dnXls = parcelRequire("dnXls");

var $46bcR = parcelRequire("46bcR");

var $dOidW = parcelRequire("dOidW");

var $WdqOS = parcelRequire("WdqOS");
const $43cbc1c895dee0e5$var$defaultLensStyle = {
    fill: '#ccc',
    fillOpacity: 0.1,
    lineWidth: 2,
    stroke: '#000',
    strokeOpacity: 0.8,
    labelFontSize: 12
};
const $43cbc1c895dee0e5$var$R_DELTA = 0.05;
const $43cbc1c895dee0e5$var$D_DELTA = 0.1;
class $43cbc1c895dee0e5$export$7e0fae892bcfed4c extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $43cbc1c895dee0e5$export$7e0fae892bcfed4c.defaultOptions, options));
        this.r = this.options.r;
        this.d = this.options.d;
        this.onCreateFisheye = (event)=>{
            if (this.options.trigger === 'drag' && this.isLensOn) return;
            const origin = (0, $dnXls.parsePoint)(event.canvas);
            this.onMagnify(origin);
        };
        this.onMagnify = (origin)=>{
            if (origin.some(isNaN)) return;
            this.renderLens(origin);
            this.renderFocusElements();
        };
        this.renderLens = (origin)=>{
            const style = Object.assign({}, $43cbc1c895dee0e5$var$defaultLensStyle, this.options.style);
            if (!this.isLensOn) {
                this.lens = new (0, $dbxRO.Circle)({
                    style: style
                });
                this.canvas.appendChild(this.lens);
            }
            Object.assign(style, (0, $dnXls.toPointObject)(origin), {
                size: this.r * 2,
                label: this.options.showDPercent,
                labelText: this.getDPercent()
            });
            this.lens.update(style);
        };
        this.getDPercent = ()=>{
            const { minD: minD, maxD: maxD } = this.options;
            const percent = Math.round((this.d - minD) / (maxD - minD) * 100);
            return `${percent}%`;
        };
        this.prevMagnifiedStyleMap = new Map();
        this.prevOriginStyleMap = new Map();
        this.renderFocusElements = ()=>{
            if (!this.isLensOn) return;
            const { graph: graph } = this.context;
            const origin = this.lens.getCenter();
            const molecularParam = (this.d + 1) * this.r;
            const magnifiedStyleMap = new Map();
            const originStyleMap = new Map();
            const nodeData = graph.getNodeData();
            nodeData.forEach((datum)=>{
                const position = (0, $46bcR.positionOf)(datum);
                const distanceToOrigin = (0, $dOidW.distance)(position, origin);
                if (distanceToOrigin > this.r) return;
                const magnifiedDistance = molecularParam * distanceToOrigin / (this.d * distanceToOrigin + this.r);
                const [nodeX, nodeY] = position;
                const [originX, originY] = origin;
                const cos = (nodeX - originX) / distanceToOrigin;
                const sin = (nodeY - originY) / distanceToOrigin;
                const newPoint = [
                    originX + magnifiedDistance * cos,
                    originY + magnifiedDistance * sin
                ];
                const nodeId = (0, $brtTw.idOf)(datum);
                const style = this.getNodeStyle(datum);
                const originStyle = (0, $cyCCc.default)(graph.getElementRenderStyle(nodeId), Object.keys(style));
                magnifiedStyleMap.set(nodeId, Object.assign(Object.assign({}, (0, $dnXls.toPointObject)(newPoint)), style));
                originStyleMap.set(nodeId, Object.assign(Object.assign({}, (0, $dnXls.toPointObject)(position)), originStyle));
            });
            this.updateStyle(magnifiedStyleMap, originStyleMap);
        };
        this.getNodeStyle = (datum)=>{
            const { nodeStyle: nodeStyle } = this.options;
            return typeof nodeStyle === 'function' ? nodeStyle(datum) : nodeStyle;
        };
        this.updateStyle = (magnifiedStyleMap, originStyleMap)=>{
            const { graph: graph, element: element } = this.context;
            const { enter: enter, exit: exit, keep: keep } = (0, $6SQtU.arrayDiff)(Array.from(this.prevMagnifiedStyleMap.keys()), Array.from(magnifiedStyleMap.keys()), (d)=>d);
            const relatedEdges = new Set();
            const update = (nodeId, style)=>{
                const node = element.getElement(nodeId);
                node === null || node === void 0 || node.update(style);
                graph.getRelatedEdgesData(nodeId).forEach((datum)=>{
                    relatedEdges.add((0, $brtTw.idOf)(datum));
                });
            };
            [
                ...enter,
                ...keep
            ].forEach((nodeId)=>{
                update(nodeId, magnifiedStyleMap.get(nodeId));
            });
            exit.forEach((nodeId)=>{
                update(nodeId, this.prevOriginStyleMap.get(nodeId));
                this.prevOriginStyleMap.delete(nodeId);
            });
            relatedEdges.forEach((edgeId)=>{
                const edge = element.getElement(edgeId);
                edge === null || edge === void 0 || edge.update({});
            });
            this.prevMagnifiedStyleMap = magnifiedStyleMap;
            originStyleMap.forEach((style, nodeId)=>{
                if (!this.prevOriginStyleMap.has(nodeId)) this.prevOriginStyleMap.set(nodeId, style);
            });
        };
        this.isWheelValid = (event)=>{
            if (this.options.preventDefault) event.preventDefault();
            if (!this.isLensOn) return false;
            const { clientX: clientX, clientY: clientY } = event;
            const scaleOrigin = this.context.graph.getCanvasByClient([
                clientX,
                clientY
            ]);
            const origin = this.lens.getCenter();
            if ((0, $dOidW.distance)(scaleOrigin, origin) > this.r) return false;
            return true;
        };
        this.scaleR = (positive)=>{
            const { maxR: maxR, minR: minR } = this.options;
            const ratio = positive ? 1 / (1 - $43cbc1c895dee0e5$var$R_DELTA) : 1 - $43cbc1c895dee0e5$var$R_DELTA;
            const canvasR = Math.min(...this.context.canvas.getSize()) / 2;
            this.r = Math.max(minR || 0, Math.min(maxR || canvasR, this.r * ratio));
        };
        this.scaleD = (positive)=>{
            const { maxD: maxD, minD: minD } = this.options;
            const newD = positive ? this.d + $43cbc1c895dee0e5$var$D_DELTA : this.d - $43cbc1c895dee0e5$var$D_DELTA;
            this.d = Math.max(minD, Math.min(maxD, newD));
        };
        this.scaleRByWheel = (event)=>{
            if (!this.isWheelValid(event)) return;
            const { deltaX: deltaX, deltaY: deltaY } = event;
            this.scaleR(deltaX + deltaY > 0);
            const origin = this.lens.getCenter();
            this.onMagnify(origin);
        };
        this.scaleDByWheel = (event)=>{
            if (!this.isWheelValid(event)) return;
            const { deltaX: deltaX, deltaY: deltaY } = event;
            this.scaleD(deltaX + deltaY > 0);
            const origin = this.lens.getCenter();
            this.onMagnify(origin);
        };
        this.isDragValid = (event)=>{
            if (this.options.preventDefault) event.preventDefault();
            if (!this.isLensOn) return false;
            const dragOrigin = (0, $dnXls.parsePoint)(event.canvas);
            const origin = this.lens.getCenter();
            if ((0, $dOidW.distance)(dragOrigin, origin) > this.r) return false;
            return true;
        };
        this.isLensDragging = false;
        this.onDragStart = (event)=>{
            if (!this.isDragValid(event)) return;
            this.isLensDragging = true;
        };
        this.onDrag = (event)=>{
            if (!this.isLensDragging) return;
            const dragOrigin = (0, $dnXls.parsePoint)(event.canvas);
            this.onMagnify(dragOrigin);
        };
        this.onDragEnd = ()=>{
            this.isLensDragging = false;
        };
        this.scaleRByDrag = (event)=>{
            if (!this.isLensDragging) return;
            const { dx: dx, dy: dy } = event;
            this.scaleR(dx - dy > 0);
            const origin = this.lens.getCenter();
            this.onMagnify(origin);
        };
        this.scaleDByDrag = (event)=>{
            if (!this.isLensDragging) return;
            const { dx: dx, dy: dy } = event;
            this.scaleD(dx - dy > 0);
            const origin = this.lens.getCenter();
            this.onMagnify(origin);
        };
        this.bindEvents();
    }
    get canvas() {
        return this.context.canvas.getLayer('transient');
    }
    get isLensOn() {
        return this.lens && !this.lens.destroyed;
    }
    get graphDom() {
        return this.context.graph.getCanvas().getContextService().getDomElement();
    }
    bindEvents() {
        var _a;
        const { graph: graph } = this.context;
        const { trigger: trigger, scaleRBy: scaleRBy, scaleDBy: scaleDBy } = this.options;
        const canvas = graph.getCanvas().getLayer();
        if ([
            'click',
            'drag'
        ].includes(trigger)) canvas.addEventListener((0, $9Iel2.CommonEvent).CLICK, this.onCreateFisheye);
        if (trigger === 'pointermove') canvas.addEventListener((0, $9Iel2.CommonEvent).POINTER_MOVE, this.onCreateFisheye);
        if (trigger === 'drag' || scaleRBy === 'drag' || scaleDBy === 'drag') {
            canvas.addEventListener((0, $9Iel2.CommonEvent).DRAG_START, this.onDragStart);
            canvas.addEventListener((0, $9Iel2.CommonEvent).DRAG_END, this.onDragEnd);
            const dragFunc = trigger === 'drag' ? this.onDrag : scaleRBy === 'drag' ? this.scaleRByDrag : this.scaleDByDrag;
            canvas.addEventListener((0, $9Iel2.CommonEvent).DRAG, dragFunc);
        }
        if (scaleRBy === 'wheel' || scaleDBy === 'wheel') {
            const wheelFunc = scaleRBy === 'wheel' ? this.scaleRByWheel : this.scaleDByWheel;
            (_a = this.graphDom) === null || _a === void 0 || _a.addEventListener((0, $9Iel2.CommonEvent).WHEEL, wheelFunc, {
                passive: false
            });
        }
    }
    unbindEvents() {
        var _a;
        const { graph: graph } = this.context;
        const { trigger: trigger, scaleRBy: scaleRBy, scaleDBy: scaleDBy } = this.options;
        const canvas = graph.getCanvas().getLayer();
        if ([
            'click',
            'drag'
        ].includes(trigger)) canvas.removeEventListener((0, $9Iel2.CommonEvent).CLICK, this.onCreateFisheye);
        if (trigger === 'pointermove') canvas.removeEventListener((0, $9Iel2.CommonEvent).POINTER_MOVE, this.onCreateFisheye);
        if (trigger === 'drag' || scaleRBy === 'drag' || scaleDBy === 'drag') {
            canvas.removeEventListener((0, $9Iel2.CommonEvent).DRAG_START, this.onDragStart);
            canvas.removeEventListener((0, $9Iel2.CommonEvent).DRAG_END, this.onDragEnd);
            const dragFunc = trigger === 'drag' ? this.onDrag : scaleRBy === 'drag' ? this.scaleRByDrag : this.scaleDByDrag;
            canvas.removeEventListener((0, $9Iel2.CommonEvent).DRAG, dragFunc);
        }
        if (scaleRBy === 'wheel' || scaleDBy === 'wheel') {
            const wheelFunc = scaleRBy === 'wheel' ? this.scaleRByWheel : this.scaleDByWheel;
            (_a = this.graphDom) === null || _a === void 0 || _a.removeEventListener((0, $9Iel2.CommonEvent).WHEEL, wheelFunc);
        }
    }
    update(options) {
        var _a, _b;
        this.unbindEvents();
        super.update(options);
        this.r = (_a = options.r) !== null && _a !== void 0 ? _a : this.r;
        this.d = (_b = options.d) !== null && _b !== void 0 ? _b : this.d;
        this.bindEvents();
    }
    destroy() {
        var _a;
        this.unbindEvents();
        if (this.isLensOn) (_a = this.lens) === null || _a === void 0 || _a.destroy();
        this.prevMagnifiedStyleMap.clear();
        this.prevOriginStyleMap.clear();
        super.destroy();
    }
}
$43cbc1c895dee0e5$export$7e0fae892bcfed4c.defaultOptions = {
    trigger: 'pointermove',
    r: 120,
    d: 1.5,
    maxD: 5,
    minD: 0,
    showDPercent: true,
    style: {},
    nodeStyle: {
        label: true
    },
    preventDefault: true
};

});

parcelRegister("bbw6O", function(module, exports) {

$parcel$export(module.exports, "Fullscreen", () => $8249a0ec064c858a$export$159cd03be7087f39);

var $aBpmX = parcelRequire("aBpmX");

var $lXl1S = parcelRequire("lXl1S");

var $WdqOS = parcelRequire("WdqOS");
class $8249a0ec064c858a$export$159cd03be7087f39 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $8249a0ec064c858a$export$159cd03be7087f39.defaultOptions, options));
        this.$el = this.context.canvas.getContainer();
        this.graphSize = [
            0,
            0
        ];
        this.onFullscreenChange = ()=>{
            var _a, _b, _c, _d;
            const isFull = !!document.fullscreenElement;
            if (this.options.autoFit) this.setGraphSize(isFull);
            if (isFull) (_b = (_a = this.options).onEnter) === null || _b === void 0 || _b.call(_a);
            else (_d = (_c = this.options).onExit) === null || _d === void 0 || _d.call(_c);
        };
        this.shortcut = new (0, $lXl1S.Shortcut)(context.graph);
        this.bindEvents();
        this.style = document.createElement('style');
        document.head.appendChild(this.style);
        this.style.innerHTML = `
      :not(:root):fullscreen::backdrop {
        background: transparent;
      }
    `;
    }
    bindEvents() {
        this.unbindEvents();
        this.shortcut.unbindAll();
        const { request: request = [], exit: exit = [] } = this.options.trigger;
        this.shortcut.bind(request, this.request);
        this.shortcut.bind(exit, this.exit);
        const events = [
            'webkitfullscreenchange',
            'mozfullscreenchange',
            'fullscreenchange',
            'MSFullscreenChange'
        ];
        events.forEach((eventName)=>{
            document.addEventListener(eventName, this.onFullscreenChange, false);
        });
    }
    unbindEvents() {
        this.shortcut.unbindAll();
        const events = [
            'webkitfullscreenchange',
            'mozfullscreenchange',
            'fullscreenchange',
            'MSFullscreenChange'
        ];
        events.forEach((eventName)=>{
            document.removeEventListener(eventName, this.onFullscreenChange, false);
        });
    }
    setGraphSize(fullScreen = true) {
        var _a, _b;
        let width, height;
        if (fullScreen) {
            width = ((_a = globalThis.screen) === null || _a === void 0 ? void 0 : _a.width) || 0;
            height = ((_b = globalThis.screen) === null || _b === void 0 ? void 0 : _b.height) || 0;
            this.graphSize = this.context.graph.getSize();
        } else [width, height] = this.graphSize;
        this.context.graph.setSize(width, height);
        this.context.graph.render();
    }
    /**
     * <zh/> 请求全屏
     *
     * <en/> Request full screen
     */ request() {
        if (document.fullscreenElement || !$8249a0ec064c858a$var$isFullscreenEnabled()) return;
        this.$el.requestFullscreen().catch((err)=>{
            (0, $aBpmX.print).warn(`Error attempting to enable full-screen: ${err.message} (${err.name})`);
        });
    }
    /**
     * <zh/> 退出全屏
     *
     * <en/> Exit full screen
     */ exit() {
        if (!document.fullscreenElement) return;
        document.exitFullscreen();
    }
    /**
     * <zh/> 更新配置
     *
     * <en/> Update options
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */ update(options) {
        this.unbindEvents();
        super.update(options);
        this.bindEvents();
    }
    destroy() {
        this.exit();
        this.style.remove();
        super.destroy();
    }
}
$8249a0ec064c858a$export$159cd03be7087f39.defaultOptions = {
    trigger: {},
    autoFit: true
};
/**
 * <zh/> 判断是否支持全屏
 *
 * <en/> Determine whether full screen is enabled
 * @returns <zh/> 是否支持全屏 | <en/> Whether full screen is enabled
 */ function $8249a0ec064c858a$var$isFullscreenEnabled() {
    return document.fullscreenEnabled || // <zh/> 使用 Reflect 语法规避 ts 检查 | <en/> use Reflect to avoid ts checking
    Reflect.get(document, 'webkitFullscreenEnabled') || Reflect.get(document, 'mozFullscreenEnabled') || Reflect.get(document, 'msFullscreenEnabled');
}

});

parcelRegister("86w7z", function(module, exports) {

$parcel$export(module.exports, "GridLine", () => $5e67ccde04effd82$export$cb089865d3c60926);

var $2LrCM = parcelRequire("2LrCM");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $dOidW = parcelRequire("dOidW");

var $WdqOS = parcelRequire("WdqOS");

var $bEb16 = parcelRequire("bEb16");
class $5e67ccde04effd82$export$cb089865d3c60926 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $5e67ccde04effd82$export$cb089865d3c60926.defaultOptions, options));
        this.$element = (0, $bEb16.createPluginContainer)('grid-line', true);
        this.offset = [
            0,
            0
        ];
        this.currentScale = 1;
        this.followZoom = (event)=>{
            const { data: { scale: scale, origin: origin } } = event;
            if (!scale || origin === undefined && this.context.viewport === undefined) return;
            const prevScale = this.currentScale;
            this.currentScale = scale;
            const deltaScale = scale / prevScale;
            const positionOffset = (0, $dOidW.multiply)(origin || this.context.graph.getCanvasCenter(), 1 - deltaScale);
            const scaledSize = this.baseSize * scale;
            const scaledOffset = (0, $dOidW.multiply)(this.offset, deltaScale);
            const modulatedOffset = (0, $dOidW.mod)(scaledOffset, scaledSize);
            const newOffset = (0, $dOidW.add)(modulatedOffset, positionOffset);
            this.$element.style.backgroundSize = `${scaledSize}px ${scaledSize}px`;
            this.$element.style.backgroundPosition = `${newOffset[0]}px ${newOffset[1]}px`;
            this.offset = (0, $dOidW.mod)(newOffset, scaledSize);
        };
        this.followTranslate = (event)=>{
            if (!this.options.follow) return;
            const { data: { translate: translate } } = event;
            if (translate) this.updateOffset(translate);
        };
        this.onTransform = (event)=>{
            const follow = this.parseFollow(this.options.follow);
            if (follow.zoom) this.followZoom(event);
            if (follow.translate) this.followTranslate(event);
        };
        const $container = this.context.canvas.getContainer();
        $container.prepend(this.$element);
        this.baseSize = this.options.size;
        this.updateStyle();
        this.bindEvents();
    }
    /**
     * <zh/> 更新网格线配置
     *
     * <en/> Update the configuration of the grid line
     * @param options - <zh/> 配置项 | <en/> options
     * @internal
     */ update(options) {
        super.update(options);
        if (options.size !== undefined) this.baseSize = options.size;
        this.updateStyle();
    }
    bindEvents() {
        const { graph: graph } = this.context;
        graph.on((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.onTransform);
    }
    updateStyle() {
        const { stroke: stroke, lineWidth: lineWidth, border: border, borderLineWidth: borderLineWidth, borderStroke: borderStroke, borderStyle: borderStyle } = this.options;
        const scaledSize = this.baseSize * this.currentScale;
        Object.assign(this.$element.style, {
            border: border ? `${borderLineWidth}px ${borderStyle} ${borderStroke}` : 'none',
            backgroundImage: `linear-gradient(${stroke} ${lineWidth}px, transparent ${lineWidth}px), linear-gradient(90deg, ${stroke} ${lineWidth}px, transparent ${lineWidth}px)`,
            backgroundSize: `${scaledSize}px ${scaledSize}px`,
            backgroundRepeat: 'repeat'
        });
    }
    updateOffset(delta) {
        const scaledSize = this.baseSize * this.currentScale;
        this.offset = (0, $dOidW.mod)((0, $dOidW.add)(this.offset, delta), scaledSize);
        this.$element.style.backgroundPosition = `${this.offset[0]}px ${this.offset[1]}px`;
    }
    parseFollow(follow) {
        var _a, _b;
        return (0, $2LrCM.default)(follow) ? {
            translate: follow,
            zoom: follow
        } : {
            translate: (_a = follow === null || follow === void 0 ? void 0 : follow.translate) !== null && _a !== void 0 ? _a : false,
            zoom: (_b = follow === null || follow === void 0 ? void 0 : follow.zoom) !== null && _b !== void 0 ? _b : false
        };
    }
    /**
     * <zh/> 销毁网格线
     *
     * <en/> Destroy the grid line
     * @internal
     */ destroy() {
        this.context.graph.off((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.onTransform);
        this.$element.remove();
        super.destroy();
    }
}
$5e67ccde04effd82$export$cb089865d3c60926.defaultOptions = {
    border: true,
    borderLineWidth: 1,
    borderStroke: '#eee',
    borderStyle: 'solid',
    lineWidth: 1,
    size: 20,
    stroke: '#eee'
};

});

parcelRegister("cqIFg", function(module, exports) {

$parcel$export(module.exports, "History", () => $90ca8f2c72f4759a$export$84202caead5689ba);

var $7VXo7 = parcelRequire("7VXo7");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $5TVj3 = parcelRequire("5TVj3");

var $brtTw = parcelRequire("brtTw");

var $WdqOS = parcelRequire("WdqOS");

var $i1SRO = parcelRequire("i1SRO");
class $90ca8f2c72f4759a$export$84202caead5689ba extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $90ca8f2c72f4759a$export$84202caead5689ba.defaultOptions, options));
        this.batchChanges = null;
        this.batchAnimation = false;
        this.undoStack = [];
        this.redoStack = [];
        this.freezed = false;
        this.executeCommand = (cmd, revert = true)=>{
            var _a, _b, _c;
            this.freezed = true;
            (_b = (_a = this.options).executeCommand) === null || _b === void 0 || _b.call(_a, cmd);
            const values = revert ? cmd.original : cmd.current;
            this.context.graph.addData(values.add);
            this.context.graph.updateData(values.update);
            this.context.graph.removeData((0, $brtTw.idsOf)(values.remove, false));
            (_c = this.context.element) === null || _c === void 0 || _c.draw({
                silence: true,
                animation: cmd.animation
            });
            this.freezed = false;
        };
        this.addCommand = (event)=>{
            var _a;
            if (this.freezed) return;
            if (event.type === (0, $4EzN9.GraphEvent).AFTER_DRAW) {
                const { dataChanges: dataChanges = [], animation: animation = true } = event.data;
                if ((_a = this.context.batch) === null || _a === void 0 ? void 0 : _a.isBatching) {
                    if (!this.batchChanges) return;
                    this.batchChanges.push(dataChanges);
                    this.batchAnimation && (this.batchAnimation = animation);
                    return;
                }
                this.batchChanges = [
                    dataChanges
                ];
                this.batchAnimation = animation;
            }
            this.undoStackPush((0, $i1SRO.parseCommand)(this.batchChanges.flat(), this.batchAnimation, this.context));
            this.notify((0, $5TVj3.HistoryEvent).ADD, this.undoStack[this.undoStack.length - 1]);
        };
        this.initBatchCommand = (event)=>{
            const { initiate: initiate } = event.data;
            this.batchAnimation = false;
            if (initiate) this.batchChanges = [];
            else {
                const cmd = this.undoStack.pop();
                if (!cmd) this.batchChanges = null;
            }
        };
        this.emitter = new (0, $7VXo7.default)();
        const { graph: graph } = this.context;
        graph.on((0, $4EzN9.GraphEvent).AFTER_DRAW, this.addCommand);
        graph.on((0, $4EzN9.GraphEvent).BATCH_START, this.initBatchCommand);
        graph.on((0, $4EzN9.GraphEvent).BATCH_END, this.addCommand);
    }
    /**
     * <zh/> 是否可以执行撤销操作
     *
     * <en/> Whether undo can be done
     * @returns <zh/> 是否可以执行撤销操作 | <en/> Whether undo can be done
     */ canUndo() {
        return this.undoStack.length > 0;
    }
    /**
     * <zh/> 是否可以执行重做操作
     *
     * <en/> Whether redo can be done
     * @returns <zh/> 是否可以执行重做操作 | <en/> Whether redo can be done
     */ canRedo() {
        return this.redoStack.length > 0;
    }
    /**
     * <zh/> 执行撤销
     *
     * <en/> Execute undo
     * @returns <zh/> 返回当前实例 | <en/> Return the current instance
     */ undo() {
        var _a, _b, _c, _d;
        const cmd = this.undoStack.pop();
        if (cmd) {
            this.executeCommand(cmd);
            const before = (_b = (_a = this.options).beforeAddCommand) === null || _b === void 0 ? void 0 : _b.call(_a, cmd, false);
            if (before === false) return;
            this.redoStack.push(cmd);
            (_d = (_c = this.options).afterAddCommand) === null || _d === void 0 || _d.call(_c, cmd, false);
            this.notify((0, $5TVj3.HistoryEvent).UNDO, cmd);
        }
        return this;
    }
    /**
     * <zh/> 执行重做
     *
     * <en/> Execute redo
     * @returns <zh/> 返回当前实例 | <en/> Return the current instance
     */ redo() {
        const cmd = this.redoStack.pop();
        if (cmd) {
            this.executeCommand(cmd, false);
            this.undoStackPush(cmd);
            this.notify((0, $5TVj3.HistoryEvent).REDO, cmd);
        }
        return this;
    }
    /**
     * <zh/> 执行撤销且不计入历史记录
     *
     * <en/> Execute undo and do not record in history
     * @returns <zh/> 返回当前实例 | <en/> Return the current instance
     */ undoAndCancel() {
        const cmd = this.undoStack.pop();
        if (cmd) {
            this.executeCommand(cmd, false);
            this.redoStack = [];
            this.notify((0, $5TVj3.HistoryEvent).CANCEL, cmd);
        }
        return this;
    }
    undoStackPush(cmd) {
        var _a, _b, _c, _d;
        const { stackSize: stackSize } = this.options;
        if (stackSize !== 0 && this.undoStack.length >= stackSize) this.undoStack.shift();
        const before = (_b = (_a = this.options).beforeAddCommand) === null || _b === void 0 ? void 0 : _b.call(_a, cmd, true);
        if (before === false) return;
        this.undoStack.push(cmd);
        (_d = (_c = this.options).afterAddCommand) === null || _d === void 0 || _d.call(_c, cmd, true);
    }
    /**
     * <zh/> 清空历史记录
     *
     * <en/> Clear history
     */ clear() {
        this.undoStack = [];
        this.redoStack = [];
        this.batchChanges = null;
        this.batchAnimation = false;
        this.notify((0, $5TVj3.HistoryEvent).CLEAR, null);
    }
    notify(event, cmd) {
        this.emitter.emit(event, {
            cmd: cmd
        });
        this.emitter.emit((0, $5TVj3.HistoryEvent).CHANGE, {
            cmd: cmd
        });
    }
    /**
     * <zh/> 监听历史记录事件
     *
     * <en/> Listen to history events
     * @param event  - <zh/> 事件名称 | <en/> Event name
     * @param handler - <zh/> 事件处理函数 | <en/> Event handler
     */ on(event, handler) {
        this.emitter.on(event, handler);
    }
    /**
     * <zh/> 销毁
     *
     * <en/> Destroy
     * @internal
     */ destroy() {
        const { graph: graph } = this.context;
        graph.off((0, $4EzN9.GraphEvent).AFTER_DRAW, this.addCommand);
        graph.off((0, $4EzN9.GraphEvent).BATCH_START, this.initBatchCommand);
        graph.off((0, $4EzN9.GraphEvent).BATCH_END, this.addCommand);
        this.emitter.off();
        super.destroy();
        this.undoStack = [];
        this.redoStack = [];
    }
}
$90ca8f2c72f4759a$export$84202caead5689ba.defaultOptions = {
    stackSize: 0
};

});
parcelRegister("i1SRO", function(module, exports) {

$parcel$export(module.exports, "parseCommand", () => $d202e16fe262ac37$export$78bcee23e0849f6a);

var $6JKSc = parcelRequire("6JKSc");

var $dtz9V = parcelRequire("dtz9V");

var $gO13V = parcelRequire("gO13V");

var $brtTw = parcelRequire("brtTw");
function $d202e16fe262ac37$export$b836337b38fa63b6(refObject, targetObject) {
    for(const key in refObject){
        if ((0, $6JKSc.default)(refObject[key]) && !Array.isArray(refObject[key]) && refObject[key] !== null) {
            if (!targetObject[key]) targetObject[key] = {};
            $d202e16fe262ac37$export$b836337b38fa63b6(refObject[key], targetObject[key]);
        } else if (targetObject[key] === undefined) targetObject[key] = (0, $dtz9V.inferDefaultValue)(key);
    }
}
function $d202e16fe262ac37$export$78bcee23e0849f6a(changes, animation = false, context) {
    const cmd = {
        animation: animation,
        current: {
            add: {},
            update: {},
            remove: {}
        },
        original: {
            add: {},
            update: {},
            remove: {}
        }
    };
    const { add: add, update: update, remove: remove } = (0, $gO13V.groupByChangeType)((0, $gO13V.reduceDataChanges)(changes));
    [
        'nodes',
        'edges',
        'combos'
    ].forEach((category)=>{
        if (update[category]) update[category].forEach((item)=>{
            var _a, _b;
            const newValue = Object.assign({}, item.value);
            let newOriginal = Object.assign({}, item.original);
            if (context) {
                // 特殊处理：获取元素原始 color
                const itemType = context.graph.getElementType((0, $brtTw.idOf)(item.original));
                const colorKey = itemType === 'edge' ? 'stroke' : 'fill';
                const style = context.element.getElementComputedStyle(itemType, item.original);
                newOriginal = Object.assign(Object.assign({}, item.original), {
                    style: Object.assign({
                        [colorKey]: style[colorKey]
                    }, item.original.style)
                });
            }
            $d202e16fe262ac37$export$b836337b38fa63b6(newValue, newOriginal);
            (_a = cmd.current.update)[category] || (_a[category] = []);
            cmd.current.update[category].push(newValue);
            (_b = cmd.original.update)[category] || (_b[category] = []);
            cmd.original.update[category].push(newOriginal);
        });
        if (add[category]) add[category].forEach((item)=>{
            var _a, _b;
            const newValue = Object.assign({}, item.value);
            (_a = cmd.current.add)[category] || (_a[category] = []);
            cmd.current.add[category].push(newValue);
            (_b = cmd.original.remove)[category] || (_b[category] = []);
            cmd.original.remove[category].push(newValue);
        });
        if (remove[category]) remove[category].forEach((item)=>{
            var _a, _b;
            const newValue = Object.assign({}, item.value);
            (_a = cmd.current.remove)[category] || (_a[category] = []);
            cmd.current.remove[category].push(newValue);
            (_b = cmd.original.add)[category] || (_b[category] = []);
            cmd.original.add[category].push(newValue);
        });
    });
    return cmd;
}

});
parcelRegister("gO13V", function(module, exports) {

$parcel$export(module.exports, "reduceDataChanges", () => $c3c223d00c3e5b92$export$eb395986d8cfb1c6);
$parcel$export(module.exports, "groupByChangeType", () => $c3c223d00c3e5b92$export$3e3b4ff7c4a5d55b);

var $gYaPK = parcelRequire("gYaPK");

var $brtTw = parcelRequire("brtTw");
function $c3c223d00c3e5b92$export$eb395986d8cfb1c6(changes) {
    const results = {
        Added: new Map(),
        Updated: new Map(),
        Removed: new Map()
    };
    changes.forEach((change)=>{
        const { type: type, value: value } = change;
        const id = (0, $brtTw.idOf)(value);
        if (type === 'NodeAdded' || type === 'EdgeAdded' || type === 'ComboAdded') results.Added.set(id, change);
        else if (type === 'NodeUpdated' || type === 'EdgeUpdated' || type === 'ComboUpdated') {
            // 如果存在 Added，将当前操作置为 Added 操作
            // If there is an Added operation, set the current operation to Added
            if (results.Added.has(id)) results.Added.set(id, {
                type: type.replace('Updated', 'Added'),
                value: value
            });
            else if (results.Updated.has(id)) {
                const { original: original } = results.Updated.get(id);
                results.Updated.set(id, {
                    type: type,
                    value: value,
                    original: original
                });
            } else if (results.Removed.has(id)) ;
            else results.Updated.set(id, change);
        } else if (type === 'NodeRemoved' || type === 'EdgeRemoved' || type === 'ComboRemoved') {
            // 如果存在 Added 或者 Updated 的操作，删除 Removed 操作
            // If there is an Added or Updated operation, delete the Removed operation
            if (results.Added.has(id)) results.Added.delete(id);
            else if (results.Updated.has(id)) {
                results.Updated.delete(id);
                results.Removed.set(id, change);
            } else results.Removed.set(id, change);
        }
    });
    // 顺序并不重要
    // The order is not important
    return [
        ...Array.from(results.Added.values()),
        ...Array.from(results.Updated.values()),
        ...Array.from(results.Removed.values())
    ];
}
function $c3c223d00c3e5b92$export$3e3b4ff7c4a5d55b(changes) {
    const { NodeAdded: NodeAdded = [], NodeUpdated: NodeUpdated = [], NodeRemoved: NodeRemoved = [], EdgeAdded: EdgeAdded = [], EdgeUpdated: EdgeUpdated = [], EdgeRemoved: EdgeRemoved = [], ComboAdded: ComboAdded = [], ComboUpdated: ComboUpdated = [], ComboRemoved: ComboRemoved = [] } = (0, $gYaPK.default)(changes, (change)=>change.type);
    return {
        add: {
            nodes: NodeAdded,
            edges: EdgeAdded,
            combos: ComboAdded
        },
        update: {
            nodes: NodeUpdated,
            edges: EdgeUpdated,
            combos: ComboUpdated
        },
        remove: {
            nodes: NodeRemoved,
            edges: EdgeRemoved,
            combos: ComboRemoved
        }
    };
}

});



parcelRegister("7ZR3h", function(module, exports) {

$parcel$export(module.exports, "Hull", () => $5d2761ec342cf915$export$c4813cc5e4374a49);

var $4ETMA = parcelRequire("4ETMA");
var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");
parcelRequire("hIZ0D");
var $jZN6o = parcelRequire("jZN6o");

var $brtTw = parcelRequire("brtTw");

var $46bcR = parcelRequire("46bcR");

var $WdqOS = parcelRequire("WdqOS");

var $kmpaf = parcelRequire("kmpaf");

var $hh3kD = parcelRequire("hh3kD");
var $5d2761ec342cf915$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $5d2761ec342cf915$export$c4813cc5e4374a49 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $5d2761ec342cf915$export$c4813cc5e4374a49.defaultOptions, options));
        /**
         * <zh/> 在 Hull 上的元素
         *
         * <en/> Element Ids on Hull
         */ this.hullMemberIds = [];
        this.drawHull = ()=>{
            if (!this.shape) {
                this.shape = new (0, $jZN6o.Contour)({
                    style: this.getHullStyle()
                });
                this.context.canvas.appendChild(this.shape);
            } else {
                const forceUpdate = !(0, $4ETMA.default)(this.optionsCache, this.options);
                this.shape.update(this.getHullStyle(forceUpdate));
            }
            this.optionsCache = Object.assign({}, this.options);
        };
        this.updateHullPath = (event)=>{
            if (!this.shape) return;
            if (!this.options.members.includes((0, $brtTw.idOf)(event.data))) return;
            this.shape.update({
                d: this.getHullPath(true)
            });
        };
        this.getHullPath = (forceUpdate = false)=>{
            const { graph: graph } = this.context;
            const members = this.getMember();
            if (members.length === 0) return '';
            const data = members.map((id)=>graph.getNodeData(id));
            const vertices = (0, $kmpaf.hull)(data.map((0, $46bcR.positionOf)), this.options.concavity).slice(1).reverse();
            const hullMemberIds = vertices.flatMap((point)=>data.filter((m)=>(0, $4ETMA.default)((0, $46bcR.positionOf)(m), point)).map((0, $brtTw.idOf)));
            if ((0, $4ETMA.default)(hullMemberIds, this.hullMemberIds) && !forceUpdate) return this.path;
            this.hullMemberIds = hullMemberIds;
            this.path = (0, $hh3kD.computeHullPath)(vertices, this.getPadding(), this.options.corner);
            return this.path;
        };
        this.bindEvents();
    }
    bindEvents() {
        this.context.graph.on((0, $4EzN9.GraphEvent).AFTER_RENDER, this.drawHull);
        this.context.graph.on((0, $4EzN9.GraphEvent).AFTER_ELEMENT_UPDATE, this.updateHullPath);
    }
    unbindEvents() {
        this.context.graph.off((0, $4EzN9.GraphEvent).AFTER_RENDER, this.drawHull);
        this.context.graph.off((0, $4EzN9.GraphEvent).AFTER_ELEMENT_UPDATE, this.updateHullPath);
    }
    getHullStyle(forceUpdate) {
        const _a = this.options, { members: members, padding: padding, corner: corner } = _a, style = $5d2761ec342cf915$var$__rest(_a, [
            "members",
            "padding",
            "corner"
        ]);
        return Object.assign(Object.assign({}, style), {
            d: this.getHullPath(forceUpdate)
        });
    }
    getPadding() {
        const { graph: graph } = this.context;
        const memberPadding = this.hullMemberIds.reduce((acc, id)=>{
            const { halfExtents: halfExtents } = graph.getElementRenderBounds(id);
            const size = Math.max(halfExtents[0], halfExtents[1]);
            return Math.max(acc, size);
        }, 0);
        return memberPadding + this.options.padding;
    }
    /**
     * <zh/> 添加 Hull 成员
     *
     * <en/> Add Hull member
     * @param members - <zh/> 元素 Ids | <en/> Element Ids
     */ addMember(members) {
        const membersToAdd = Array.isArray(members) ? members : [
            members
        ];
        this.options.members = [
            ...new Set([
                ...this.options.members,
                ...membersToAdd
            ])
        ];
        this.shape.update({
            d: this.getHullPath()
        });
    }
    /**
     * <zh/> 移除 Hull 成员
     *
     * <en/> Remove Hull member
     * @param members - <zh/> 元素 Ids | <en/> Element Ids
     */ removeMember(members) {
        const membersToRemove = Array.isArray(members) ? members : [
            members
        ];
        this.options.members = this.options.members.filter((id)=>!membersToRemove.includes(id));
        if (membersToRemove.some((id)=>this.hullMemberIds.includes(id))) this.shape.update({
            d: this.getHullPath()
        });
    }
    /**
     * <zh/> 更新 Hull 成员
     *
     * <en/> Update Hull member
     * @param members - <zh/> 元素 Ids | <en/> Element Ids
     */ updateMember(members) {
        this.options.members = (0, $ky7aH.default)(members) ? members(this.options.members) : members;
        this.shape.update(this.getHullStyle(true));
    }
    /**
     * <zh/> 获取 Hull 成员
     *
     * <en/> Get Hull member
     * @returns <zh/> 元素 Ids | <en/> Element Ids
     */ getMember() {
        return this.options.members;
    }
    /**
     * <zh/> 销毁 Hull
     *
     * <en/> Destroy Hull
     * @internal
     */ destroy() {
        this.unbindEvents();
        this.shape.destroy();
        this.hullMemberIds = [];
        super.destroy();
    }
}
$5d2761ec342cf915$export$c4813cc5e4374a49.defaultOptions = {
    members: [],
    padding: 10,
    corner: 'rounded',
    concavity: Infinity,
    /** hull style */ fill: 'lightblue',
    fillOpacity: 0.2,
    labelOpacity: 1,
    stroke: 'blue',
    strokeOpacity: 0.2
};

});
parcelRegister("kmpaf", function(module, exports) {

$parcel$export(module.exports, "hull", () => $ed2961d8e15f7098$export$b786f4033a68f961);

var $fUtfN = parcelRequire("fUtfN");

var $6aLlr = parcelRequire("6aLlr");

var $59QQk = parcelRequire("59QQk");

var $goGRf = parcelRequire("goGRf");
function $ed2961d8e15f7098$var$_filterDuplicates(pointset) {
    const unique = [
        pointset[0]
    ];
    let lastPoint = pointset[0];
    for(let i = 1; i < pointset.length; i++){
        const currentPoint = pointset[i];
        if (lastPoint[0] !== currentPoint[0] || lastPoint[1] !== currentPoint[1]) unique.push(currentPoint);
        lastPoint = currentPoint;
    }
    return unique;
}
function $ed2961d8e15f7098$var$_sortByX(pointset) {
    return pointset.sort(function(a, b) {
        return a[0] - b[0] || a[1] - b[1];
    });
}
function $ed2961d8e15f7098$var$_sqLength(a, b) {
    return Math.pow(b[0] - a[0], 2) + Math.pow(b[1] - a[1], 2);
}
function $ed2961d8e15f7098$var$_cos(o, a, b) {
    const aShifted = [
        a[0] - o[0],
        a[1] - o[1]
    ], bShifted = [
        b[0] - o[0],
        b[1] - o[1]
    ], sqALen = $ed2961d8e15f7098$var$_sqLength(o, a), sqBLen = $ed2961d8e15f7098$var$_sqLength(o, b), dot = aShifted[0] * bShifted[0] + aShifted[1] * bShifted[1];
    return dot / Math.sqrt(sqALen * sqBLen);
}
function $ed2961d8e15f7098$var$_intersect(segment, pointset) {
    for(let i = 0; i < pointset.length - 1; i++){
        const seg = [
            pointset[i],
            pointset[i + 1]
        ];
        if (segment[0][0] === seg[0][0] && segment[0][1] === seg[0][1] || segment[0][0] === seg[1][0] && segment[0][1] === seg[1][1]) continue;
        if ((0, $goGRf.segmentsIntersect)(segment[0], segment[1], seg[0], seg[1])) return true;
    }
    return false;
}
function $ed2961d8e15f7098$var$_occupiedArea(pointset) {
    let minX = Infinity;
    let minY = Infinity;
    let maxX = -Infinity;
    let maxY = -Infinity;
    for(let i = pointset.length - 1; i >= 0; i--){
        if (pointset[i][0] < minX) minX = pointset[i][0];
        if (pointset[i][1] < minY) minY = pointset[i][1];
        if (pointset[i][0] > maxX) maxX = pointset[i][0];
        if (pointset[i][1] > maxY) maxY = pointset[i][1];
    }
    return [
        maxX - minX,
        maxY - minY
    ];
}
function $ed2961d8e15f7098$var$_bBoxAround(edge) {
    return [
        Math.min(edge[0][0], edge[1][0]),
        Math.min(edge[0][1], edge[1][1]),
        Math.max(edge[0][0], edge[1][0]),
        Math.max(edge[0][1], edge[1][1])
    ];
}
function $ed2961d8e15f7098$var$_midPoint(edge, innerPoints, convex) {
    let point = null, angle1Cos = $ed2961d8e15f7098$var$MAX_CONCAVE_ANGLE_COS, angle2Cos = $ed2961d8e15f7098$var$MAX_CONCAVE_ANGLE_COS, a1Cos, a2Cos;
    for(let i = 0; i < innerPoints.length; i++){
        a1Cos = $ed2961d8e15f7098$var$_cos(edge[0], edge[1], innerPoints[i]);
        a2Cos = $ed2961d8e15f7098$var$_cos(edge[1], edge[0], innerPoints[i]);
        if (a1Cos > angle1Cos && a2Cos > angle2Cos && !$ed2961d8e15f7098$var$_intersect([
            edge[0],
            innerPoints[i]
        ], convex) && !$ed2961d8e15f7098$var$_intersect([
            edge[1],
            innerPoints[i]
        ], convex)) {
            angle1Cos = a1Cos;
            angle2Cos = a2Cos;
            point = innerPoints[i];
        }
    }
    return point;
}
function $ed2961d8e15f7098$var$_concave(convex, maxSqEdgeLen, maxSearchArea, grid, edgeSkipList) {
    let midPointInserted = false;
    for(let i = 0; i < convex.length - 1; i++){
        const edge = [
            convex[i],
            convex[i + 1]
        ];
        // generate a key in the format X0,Y0,X1,Y1
        const keyInSkipList = edge[0][0] + ',' + edge[0][1] + ',' + edge[1][0] + ',' + edge[1][1];
        if ($ed2961d8e15f7098$var$_sqLength(edge[0], edge[1]) < maxSqEdgeLen || edgeSkipList.has(keyInSkipList)) continue;
        let scaleFactor = 0;
        let bBoxAround = $ed2961d8e15f7098$var$_bBoxAround(edge);
        let bBoxWidth;
        let bBoxHeight;
        let midPoint;
        do {
            bBoxAround = grid.extendBbox(bBoxAround, scaleFactor);
            bBoxWidth = bBoxAround[2] - bBoxAround[0];
            bBoxHeight = bBoxAround[3] - bBoxAround[1];
            midPoint = $ed2961d8e15f7098$var$_midPoint(edge, grid.rangePoints(bBoxAround), convex);
            scaleFactor++;
        }while (midPoint === null && (maxSearchArea[0] > bBoxWidth || maxSearchArea[1] > bBoxHeight));
        if (bBoxWidth >= maxSearchArea[0] && bBoxHeight >= maxSearchArea[1]) edgeSkipList.add(keyInSkipList);
        if (midPoint !== null) {
            convex.splice(i + 1, 0, midPoint);
            grid.removePoint(midPoint);
            midPointInserted = true;
        }
    }
    if (midPointInserted) return $ed2961d8e15f7098$var$_concave(convex, maxSqEdgeLen, maxSearchArea, grid, edgeSkipList);
    return convex;
}
function $ed2961d8e15f7098$export$b786f4033a68f961(pointset, concavity, format) {
    const maxEdgeLen = concavity || 20;
    const points = $ed2961d8e15f7098$var$_filterDuplicates($ed2961d8e15f7098$var$_sortByX((0, $fUtfN.formatUtil).toXy(pointset, format)));
    if (points.length < 4) {
        const concave = points.concat([
            points[0]
        ]);
        return format ? (0, $fUtfN.formatUtil).fromXy(concave, format) : concave;
    }
    const occupiedArea = $ed2961d8e15f7098$var$_occupiedArea(points);
    const maxSearchArea = [
        occupiedArea[0] * $ed2961d8e15f7098$var$MAX_SEARCH_BBOX_SIZE_PERCENT,
        occupiedArea[1] * $ed2961d8e15f7098$var$MAX_SEARCH_BBOX_SIZE_PERCENT
    ];
    const convex = (0, $59QQk.monotoneConvexHull2D)(points).reverse().map((idx)=>points[idx]); // ccw -> cw, indices -> points
    convex.push(convex[0]);
    const innerPoints = points.filter(function(pt) {
        return convex.indexOf(pt) < 0;
    });
    const cellSize = Math.ceil(1 / (points.length / (occupiedArea[0] * occupiedArea[1])));
    const concave = $ed2961d8e15f7098$var$_concave(convex, Math.pow(maxEdgeLen, 2), maxSearchArea, (0, $6aLlr.grid)(innerPoints, cellSize), new Set());
    return format ? (0, $fUtfN.formatUtil).fromXy(concave, format) : concave;
}
const $ed2961d8e15f7098$var$MAX_CONCAVE_ANGLE_COS = Math.cos(90 / (180 / Math.PI)); // angle = 90 deg
const $ed2961d8e15f7098$var$MAX_SEARCH_BBOX_SIZE_PERCENT = 0.6;

});
parcelRegister("fUtfN", function(module, exports) {

$parcel$export(module.exports, "formatUtil", () => $b952c72a05964df3$export$29d1aa4fdfab8395);
const $b952c72a05964df3$export$29d1aa4fdfab8395 = {
    toXy (pointset, format) {
        if (!format) return [
            ...pointset
        ];
        const xProperty = format[0].slice(1);
        const yProperty = format[1].slice(1);
        return pointset.map((pt)=>[
                pt[xProperty],
                pt[yProperty]
            ]);
    },
    fromXy (coordinates, format) {
        if (!format) return [
            ...coordinates
        ];
        const xProperty = format[0].slice(1);
        const yProperty = format[1].slice(1);
        return coordinates.map(([x, y])=>({
                [xProperty]: x,
                [yProperty]: y
            }));
    }
};

});

parcelRegister("6aLlr", function(module, exports) {

$parcel$export(module.exports, "grid", () => $47e866ee76ce89cc$export$85fc379452d91af0);
class $47e866ee76ce89cc$export$ef2184bd89960b14 {
    constructor(points, cellSize){
        this._cells = [];
        this._cellSize = cellSize;
        this._reverseCellSize = 1 / cellSize;
        for (const point of points){
            const x = this.coordToCellNum(point[0]);
            const y = this.coordToCellNum(point[1]);
            if (!this._cells[x]) this._cells[x] = [];
            if (!this._cells[x][y]) this._cells[x][y] = [];
            this._cells[x][y].push(point);
        }
    }
    cellPoints(x, y) {
        var _a;
        return ((_a = this._cells[x]) === null || _a === void 0 ? void 0 : _a[y]) || [];
    }
    rangePoints(bbox) {
        const tlCellX = this.coordToCellNum(bbox[0]);
        const tlCellY = this.coordToCellNum(bbox[1]);
        const brCellX = this.coordToCellNum(bbox[2]);
        const brCellY = this.coordToCellNum(bbox[3]);
        const points = [];
        for(let x = tlCellX; x <= brCellX; x++)for(let y = tlCellY; y <= brCellY; y++){
            const cell = this.cellPoints(x, y);
            for (const point of cell)points.push(point);
        }
        return points;
    }
    removePoint(point) {
        const cellX = this.coordToCellNum(point[0]);
        const cellY = this.coordToCellNum(point[1]);
        const cell = this._cells[cellX][cellY];
        const index = cell.findIndex(([px, py])=>px === point[0] && py === point[1]);
        if (index > -1) cell.splice(index, 1);
        return cell;
    }
    trunc(val) {
        return Math.trunc(val);
    }
    coordToCellNum(x) {
        return this.trunc(x * this._reverseCellSize);
    }
    extendBbox(bbox, scaleFactor) {
        return [
            bbox[0] - scaleFactor * this._cellSize,
            bbox[1] - scaleFactor * this._cellSize,
            bbox[2] + scaleFactor * this._cellSize,
            bbox[3] + scaleFactor * this._cellSize
        ];
    }
}
function $47e866ee76ce89cc$export$85fc379452d91af0(points, cellSize) {
    return new $47e866ee76ce89cc$export$ef2184bd89960b14(points, cellSize);
}

});

parcelRegister("59QQk", function(module, exports) {

$parcel$export(module.exports, "monotoneConvexHull2D", () => $3c16c886da74dbc7$export$c23ffdcfc50a7fa1);

var $e0m3I = parcelRequire("e0m3I");
'use strict';
const $3c16c886da74dbc7$var$orient = (0, $e0m3I.default)[3];
function $3c16c886da74dbc7$export$c23ffdcfc50a7fa1(points) {
    const n = points.length;
    // Handle special cases when the input contains fewer than 3 points
    if (n < 3) {
        const result = new Array(n);
        for(let i = 0; i < n; ++i)result[i] = i;
        // Special case for exactly 2 identical points
        if (n === 2 && points[0][0] === points[1][0] && points[0][1] === points[1][1]) return [
            0
        ];
        return result;
    }
    // Sort point indices along the x-axis (breaking ties with y-axis)
    const sorted = new Array(n);
    for(let i = 0; i < n; ++i)sorted[i] = i;
    sorted.sort((a, b)=>{
        const d = points[a][0] - points[b][0];
        if (d) return d;
        return points[a][1] - points[b][1];
    });
    // Construct the upper and lower hulls
    const lower = [
        sorted[0],
        sorted[1]
    ];
    const upper = [
        sorted[0],
        sorted[1]
    ];
    for(let i = 2; i < n; ++i){
        const idx = sorted[i];
        const p = points[idx];
        // Insert into the lower hull
        let m = lower.length;
        while(m > 1 && $3c16c886da74dbc7$var$orient(points[lower[m - 2]], points[lower[m - 1]], p) <= 0){
            m -= 1;
            lower.pop();
        }
        lower.push(idx);
        // Insert into the upper hull
        m = upper.length;
        while(m > 1 && $3c16c886da74dbc7$var$orient(points[upper[m - 2]], points[upper[m - 1]], p) >= 0){
            m -= 1;
            upper.pop();
        }
        upper.push(idx);
    }
    // Merge the lower and upper hulls into the final result
    const result = new Array(upper.length + lower.length - 2);
    let ptr = 0;
    for(let i = 0, nl = lower.length; i < nl; ++i)result[ptr++] = lower[i];
    for(let j = upper.length - 2; j > 0; --j)result[ptr++] = upper[j];
    // Return the final convex hull
    return result;
}

});
parcelRegister("e0m3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3222d38c0880b45$export$2e2bcd8739ae039);

var $eCj7p = parcelRequire("eCj7p");

var $2jINs = parcelRequire("2jINs");

var $lpS3v = parcelRequire("lpS3v");

var $8tJJe = parcelRequire("8tJJe");
'use strict';
const $a3222d38c0880b45$var$NUM_EXPAND = 5;
const $a3222d38c0880b45$var$EPSILON = 1.1102230246251565e-16;
const $a3222d38c0880b45$var$ERR_BOUND_3 = (3.0 + 16.0 * $a3222d38c0880b45$var$EPSILON) * $a3222d38c0880b45$var$EPSILON;
const $a3222d38c0880b45$var$ERR_BOUND_4 = (7.0 + 56.0 * $a3222d38c0880b45$var$EPSILON) * $a3222d38c0880b45$var$EPSILON;
function $a3222d38c0880b45$var$orientation_3(sum, prod, scale, sub) {
    return function orientation3Exact(m0, m1, m2) {
        const p = sum(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])));
        const n = sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0]));
        const d = sub(p, n);
        return d[d.length - 1];
    };
}
function $a3222d38c0880b45$var$orientation_4(sum, prod, scale, sub) {
    return function orientation4Exact(m0, m1, m2, m3) {
        const p = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))));
        const n = sum(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))));
        const d = sub(p, n);
        return d[d.length - 1];
    };
}
function $a3222d38c0880b45$var$orientation_5(sum, prod, scale, sub) {
    return function orientation5Exact(m0, m1, m2, m3, m4) {
        const p = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m1[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), -m2[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m3[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), -m4[3]), sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m3[2]), scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m1[3])))), sum(sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m3[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), -m4[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m3[2]))), m0[3]))), sum(scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m1[3]), sum(scale(sum(scale(sum(prod(m1[1], m3[0]), prod(-m3[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m3[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m3[3])))));
        const n = sum(sum(sum(scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m2[2]), sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), -m3[2]), scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m3[1], m4[0]), prod(-m4[1], m3[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m3[2]), scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), m4[2]))), -m2[3])), sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), m3[3]), scale(sum(scale(sum(prod(m2[1], m3[0]), prod(-m3[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m3[0]), prod(-m3[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m3[2]))), -m4[3]))), sum(sum(scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m1[2]), sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), -m2[2]), scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m4[2]))), m0[3]), scale(sum(scale(sum(prod(m2[1], m4[0]), prod(-m4[1], m2[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m2[2]), scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), m4[2]))), -m1[3])), sum(scale(sum(scale(sum(prod(m1[1], m4[0]), prod(-m4[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m4[0]), prod(-m4[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m4[2]))), m2[3]), scale(sum(scale(sum(prod(m1[1], m2[0]), prod(-m2[1], m1[0])), m0[2]), sum(scale(sum(prod(m0[1], m2[0]), prod(-m2[1], m0[0])), -m1[2]), scale(sum(prod(m0[1], m1[0]), prod(-m1[1], m0[0])), m2[2]))), -m4[3]))));
        const d = sub(p, n);
        return d[d.length - 1];
    };
}
function $a3222d38c0880b45$var$orientation(n) {
    const fn = n === 3 ? $a3222d38c0880b45$var$orientation_3 : n === 4 ? $a3222d38c0880b45$var$orientation_4 : $a3222d38c0880b45$var$orientation_5;
    return fn((0, $lpS3v.linearExpansionSum), (0, $8tJJe.twoProduct), (0, $eCj7p.scaleLinearExpansion), (0, $2jINs.robustSubtract));
}
const $a3222d38c0880b45$var$orientation3Exact = $a3222d38c0880b45$var$orientation(3);
const $a3222d38c0880b45$var$orientation4Exact = $a3222d38c0880b45$var$orientation(4);
const $a3222d38c0880b45$var$CACHED = [
    function orientation0() {
        return 0;
    },
    function orientation1() {
        return 0;
    },
    function orientation2(a, b) {
        return b[0] - a[0];
    },
    function orientation3(a, b, c) {
        const l = (a[1] - c[1]) * (b[0] - c[0]);
        const r = (a[0] - c[0]) * (b[1] - c[1]);
        const det = l - r;
        let s;
        if (l > 0) {
            if (r <= 0) return det;
            else s = l + r;
        } else if (l < 0) {
            if (r >= 0) return det;
            else s = -(l + r);
        } else return det;
        const tol = $a3222d38c0880b45$var$ERR_BOUND_3 * s;
        if (det >= tol || det <= -tol) return det;
        return $a3222d38c0880b45$var$orientation3Exact(a, b, c);
    },
    function orientation4(a, b, c, d) {
        const adx = a[0] - d[0];
        const bdx = b[0] - d[0];
        const cdx = c[0] - d[0];
        const ady = a[1] - d[1];
        const bdy = b[1] - d[1];
        const cdy = c[1] - d[1];
        const adz = a[2] - d[2];
        const bdz = b[2] - d[2];
        const cdz = c[2] - d[2];
        const bdx_cdy = bdx * cdy;
        const cdx_bdy = cdx * bdy;
        const cdx_ady = cdx * ady;
        const adx_cdy = adx * cdy;
        const adx_bdy = adx * bdy;
        const bdx_ady = bdx * ady;
        const det = adz * (bdx_cdy - cdx_bdy) + bdz * (cdx_ady - adx_cdy) + cdz * (adx_bdy - bdx_ady);
        const permanent = (Math.abs(bdx_cdy) + Math.abs(cdx_bdy)) * Math.abs(adz) + (Math.abs(cdx_ady) + Math.abs(adx_cdy)) * Math.abs(bdz) + (Math.abs(adx_bdy) + Math.abs(bdx_ady)) * Math.abs(cdz);
        const tol = $a3222d38c0880b45$var$ERR_BOUND_4 * permanent;
        if (det > tol || -det > tol) return det;
        return $a3222d38c0880b45$var$orientation4Exact(a, b, c, d);
    }
];
function $a3222d38c0880b45$var$slowOrient(args) {
    let proc = $a3222d38c0880b45$var$CACHED[args.length];
    if (!proc) proc = $a3222d38c0880b45$var$CACHED[args.length] = $a3222d38c0880b45$var$orientation(args.length);
    return proc.apply(undefined, ...args);
}
function $a3222d38c0880b45$var$proc(slow, o0, o1, o2, o3, o4, o5) {
    return function getOrientation(...args) {
        switch(args.length){
            case 0:
            case 1:
                return 0;
            case 2:
                return o2(args[0], args[1]);
            case 3:
                return o3(args[0], args[1], args[2]);
            case 4:
                return o4(args[0], args[1], args[2], args[3]);
            case 5:
                return o5(args[0], args[1], args[2], args[3], args[4]);
        }
        return slow(args);
    };
}
function $a3222d38c0880b45$var$generateOrientationProc() {
    while($a3222d38c0880b45$var$CACHED.length <= $a3222d38c0880b45$var$NUM_EXPAND)$a3222d38c0880b45$var$CACHED.push($a3222d38c0880b45$var$orientation($a3222d38c0880b45$var$CACHED.length));
    // @ts-ignore
    const orientationProc = $a3222d38c0880b45$var$proc(undefined, $a3222d38c0880b45$var$slowOrient, ...$a3222d38c0880b45$var$CACHED);
    for(let i = 0; i <= $a3222d38c0880b45$var$NUM_EXPAND; ++i)// @ts-ignore
    orientationProc[i] = $a3222d38c0880b45$var$CACHED[i];
    return orientationProc;
}
var $a3222d38c0880b45$export$2e2bcd8739ae039 = $a3222d38c0880b45$var$generateOrientationProc();

});
parcelRegister("eCj7p", function(module, exports) {

$parcel$export(module.exports, "scaleLinearExpansion", () => $aa4371d543745a20$export$7a15213383337574);

var $8tJJe = parcelRequire("8tJJe");

var $guUVd = parcelRequire("guUVd");
'use strict';
function $aa4371d543745a20$export$7a15213383337574(e, scale) {
    const n = e.length;
    if (n === 1) {
        const ts = (0, $8tJJe.twoProduct)(e[0], scale);
        if (ts[0]) return ts;
        return [
            ts[1]
        ];
    }
    const g = new Array(2 * n);
    const q = [
        0.1,
        0.1
    ];
    const t = [
        0.1,
        0.1
    ];
    let count = 0;
    (0, $8tJJe.twoProduct)(e[0], scale, q);
    if (q[0]) g[count++] = q[0];
    for(let i = 1; i < n; ++i){
        (0, $8tJJe.twoProduct)(e[i], scale, t);
        const pq = q[1];
        (0, $guUVd.fastTwoSum)(pq, t[0], q);
        if (q[0]) g[count++] = q[0];
        const a = t[1];
        const b = q[1];
        const x = a + b;
        const bv = x - a;
        const y = b - bv;
        q[1] = x;
        if (y) g[count++] = y;
    }
    if (q[1]) g[count++] = q[1];
    if (count === 0) g[count++] = 0.0;
    g.length = count;
    return g;
}

});
parcelRegister("8tJJe", function(module, exports) {

$parcel$export(module.exports, "twoProduct", () => $62c480e64c86a45b$export$e12f8fbd7b33ced7);
'use strict';
const $62c480e64c86a45b$var$SPLITTER = +(Math.pow(2, 27) + 1.0);
function $62c480e64c86a45b$export$e12f8fbd7b33ced7(a, b, result) {
    const x = a * b;
    const c = $62c480e64c86a45b$var$SPLITTER * a;
    const a_big = c - a;
    const ahi = c - a_big;
    const alo = a - ahi;
    const d = $62c480e64c86a45b$var$SPLITTER * b;
    const b_big = d - b;
    const bhi = d - b_big;
    const blo = b - bhi;
    const err1 = x - ahi * bhi;
    const err2 = err1 - alo * bhi;
    const err3 = err2 - ahi * blo;
    const y = alo * blo - err3;
    if (result) {
        result[0] = y;
        result[1] = x;
        return result;
    }
    return [
        y,
        x
    ];
}

});

parcelRegister("guUVd", function(module, exports) {

$parcel$export(module.exports, "fastTwoSum", () => $c02b9a2d78fe5fbd$export$470861248df637de);
'use strict';
function $c02b9a2d78fe5fbd$export$470861248df637de(a, b, result) {
    const x = a + b;
    const bv = x - a;
    const av = x - bv;
    const br = b - bv;
    const ar = a - av;
    if (result) {
        result[0] = ar + br;
        result[1] = x;
        return result;
    }
    return [
        ar + br,
        x
    ];
}

});


parcelRegister("2jINs", function(module, exports) {

$parcel$export(module.exports, "robustSubtract", () => $1b001acc1452ae7c$export$c6fcad9a460dfb75);
'use strict';
function $1b001acc1452ae7c$var$scalarScalar(a, b) {
    const x = a + b;
    const bv = x - a;
    const av = x - bv;
    const br = b - bv;
    const ar = a - av;
    const y = ar + br;
    if (y) return [
        y,
        x
    ];
    return [
        x
    ];
}
function $1b001acc1452ae7c$export$c6fcad9a460dfb75(e, f) {
    const ne = e.length | 0;
    const nf = f.length | 0;
    // Base case: scalar subtraction
    if (ne === 1 && nf === 1) return $1b001acc1452ae7c$var$scalarScalar(e[0], -f[0]);
    const n = ne + nf;
    const g = new Array(n);
    let count = 0;
    let ep_tr = 0;
    let fp_tr = 0;
    const abs = Math.abs;
    let ei = e[ep_tr];
    let ea = abs(ei);
    let fi = -f[fp_tr];
    let fa = abs(fi);
    let a, b;
    // Initial comparison to determine `a` and `b`
    if (ea < fa) {
        b = ei;
        ep_tr += 1;
        if (ep_tr < ne) {
            ei = e[ep_tr];
            ea = abs(ei);
        }
    } else {
        b = fi;
        fp_tr += 1;
        if (fp_tr < nf) {
            fi = -f[fp_tr];
            fa = abs(fi);
        }
    }
    if (ep_tr < ne && ea < fa || fp_tr >= nf) {
        a = ei;
        ep_tr += 1;
        if (ep_tr < ne) {
            ei = e[ep_tr];
            ea = abs(ei);
        }
    } else {
        a = fi;
        fp_tr += 1;
        if (fp_tr < nf) {
            fi = -f[fp_tr];
            fa = abs(fi);
        }
    }
    let x = a + b;
    let bv = x - a;
    let y = b - bv;
    let q0 = y;
    let q1 = x;
    let _x, _bv, _av, _br, _ar;
    // Main loop for combining expansions
    while(ep_tr < ne && fp_tr < nf){
        if (ea < fa) {
            a = ei;
            ep_tr += 1;
            if (ep_tr < ne) {
                ei = e[ep_tr];
                ea = abs(ei);
            }
        } else {
            a = fi;
            fp_tr += 1;
            if (fp_tr < nf) {
                fi = -f[fp_tr];
                fa = abs(fi);
            }
        }
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
    }
    // Handle remaining elements in `e`
    while(ep_tr < ne){
        a = ei;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        ep_tr += 1;
        if (ep_tr < ne) ei = e[ep_tr];
    }
    // Handle remaining elements in `f`
    while(fp_tr < nf){
        a = fi;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        fp_tr += 1;
        if (fp_tr < nf) fi = -f[fp_tr];
    }
    // Finalize the result
    if (q0) g[count++] = q0;
    if (q1) g[count++] = q1;
    if (!count) g[count++] = 0.0;
    g.length = count;
    return g;
}

});

parcelRegister("lpS3v", function(module, exports) {

$parcel$export(module.exports, "linearExpansionSum", () => $f975dd160a84e115$export$59b87a074415d531);
'use strict';
function $f975dd160a84e115$var$scalarScalar(a, b) {
    const x = a + b;
    const bv = x - a;
    const av = x - bv;
    const br = b - bv;
    const ar = a - av;
    const y = ar + br;
    if (y) return [
        y,
        x
    ];
    return [
        x
    ];
}
function $f975dd160a84e115$export$59b87a074415d531(e, f) {
    const ne = e.length | 0;
    const nf = f.length | 0;
    if (ne === 1 && nf === 1) return $f975dd160a84e115$var$scalarScalar(e[0], f[0]);
    const n = ne + nf;
    const g = new Array(n);
    let count = 0;
    let ep_tr = 0;
    let fp_tr = 0;
    const abs = Math.abs;
    let ei = e[ep_tr];
    let ea = abs(ei);
    let fi = f[fp_tr];
    let fa = abs(fi);
    let a, b;
    if (ea < fa) {
        b = ei;
        ep_tr += 1;
        if (ep_tr < ne) {
            ei = e[ep_tr];
            ea = abs(ei);
        }
    } else {
        b = fi;
        fp_tr += 1;
        if (fp_tr < nf) {
            fi = f[fp_tr];
            fa = abs(fi);
        }
    }
    if (ep_tr < ne && ea < fa || fp_tr >= nf) {
        a = ei;
        ep_tr += 1;
        if (ep_tr < ne) {
            ei = e[ep_tr];
            ea = abs(ei);
        }
    } else {
        a = fi;
        fp_tr += 1;
        if (fp_tr < nf) {
            fi = f[fp_tr];
            fa = abs(fi);
        }
    }
    let x = a + b;
    let bv = x - a;
    let y = b - bv;
    let q0 = y;
    let q1 = x;
    let _x, _bv, _av, _br, _ar;
    while(ep_tr < ne && fp_tr < nf){
        if (ea < fa) {
            a = ei;
            ep_tr += 1;
            if (ep_tr < ne) {
                ei = e[ep_tr];
                ea = abs(ei);
            }
        } else {
            a = fi;
            fp_tr += 1;
            if (fp_tr < nf) {
                fi = f[fp_tr];
                fa = abs(fi);
            }
        }
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
    }
    while(ep_tr < ne){
        a = ei;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        ep_tr += 1;
        if (ep_tr < ne) ei = e[ep_tr];
    }
    while(fp_tr < nf){
        a = fi;
        b = q0;
        x = a + b;
        bv = x - a;
        y = b - bv;
        if (y) g[count++] = y;
        _x = q1 + x;
        _bv = _x - q1;
        _av = _x - _bv;
        _br = x - _bv;
        _ar = q1 - _av;
        q0 = _ar + _br;
        q1 = _x;
        fp_tr += 1;
        if (fp_tr < nf) fi = f[fp_tr];
    }
    if (q0) g[count++] = q0;
    if (q1) g[count++] = q1;
    if (!count) g[count++] = 0.0;
    g.length = count;
    return g;
}

});



parcelRegister("goGRf", function(module, exports) {

$parcel$export(module.exports, "segmentsIntersect", () => $bf0021eb40dfdfad$export$668c0a2094d6348f);

var $e0m3I = parcelRequire("e0m3I");
function $bf0021eb40dfdfad$var$checkCollinear(a0, a1, b0, b1) {
    for(let d = 0; d < 2; ++d){
        const x0 = a0[d];
        const y0 = a1[d];
        const [l0, h0] = [
            Math.min(x0, y0),
            Math.max(x0, y0)
        ];
        const x1 = b0[d];
        const y1 = b1[d];
        const [l1, h1] = [
            Math.min(x1, y1),
            Math.max(x1, y1)
        ];
        if (h1 < l0 || h0 < l1) return false;
    }
    return true;
}
function $bf0021eb40dfdfad$export$668c0a2094d6348f(a0, a1, b0, b1) {
    const x0 = (0, $e0m3I.default)(a0, b0, b1);
    const y0 = (0, $e0m3I.default)(a1, b0, b1);
    if (x0 > 0 && y0 > 0 || x0 < 0 && y0 < 0) return false;
    const x1 = (0, $e0m3I.default)(b0, a0, a1);
    const y1 = (0, $e0m3I.default)(b1, a0, a1);
    if (x1 > 0 && y1 > 0 || x1 < 0 && y1 < 0) return false;
    if (x0 === 0 && y0 === 0 && x1 === 0 && y1 === 0) return $bf0021eb40dfdfad$var$checkCollinear(a0, a1, b0, b1);
    return true;
}

});


parcelRegister("hh3kD", function(module, exports) {

$parcel$export(module.exports, "computeHullPath", () => $c9369bdad1137110$export$a36283c645b2f121);

var $6A02h = parcelRequire("6A02h");

var $oZkEc = parcelRequire("oZkEc");

var $dnXls = parcelRequire("dnXls");

var $dOidW = parcelRequire("dOidW");
function $c9369bdad1137110$export$a36283c645b2f121(points, padding, corner) {
    if (points.length === 1) return $c9369bdad1137110$var$genSinglePointHullPath(points[0], padding, corner);
    if (points.length === 2) return $c9369bdad1137110$var$genTwoPointsHullPath(points, padding, corner);
    if (points.length === 3) {
        const [p1, p2, p3] = (0, $dnXls.sortByClockwise)(points);
        if ((0, $dnXls.isCollinear)(p1, p2, p3)) return $c9369bdad1137110$var$genTwoPointsHullPath([
            p1,
            p3
        ], padding, corner);
    }
    switch(corner){
        case 'smooth':
            return $c9369bdad1137110$var$genMultiPointsSmoothHull(points, padding);
        case 'sharp':
            return $c9369bdad1137110$var$genMultiPointsSharpHull(points, padding);
        case 'rounded':
        default:
            return $c9369bdad1137110$var$genMultiPointsRoundedHull(points, padding);
    }
}
/**
 * <zh/> 生成单点 Hull 路径
 *
 * <en/> Generate Hull Path for a single point
 * @param point - <zh/> 单点 | <en/> Single point
 * @param padding - <zh/> 内边距 | <en/> Padding
 * @param corner - <zh/> 拐角类型 | <en/> Corner type
 * @returns <zh/> 单点 Hull 路径 | <en/> Single point Hull Path
 */ const $c9369bdad1137110$var$genSinglePointHullPath = (point, padding, corner)=>{
    if (corner === 'sharp') return [
        [
            'M',
            point[0] - padding,
            point[1] - padding
        ],
        [
            'L',
            point[0] + padding,
            point[1] - padding
        ],
        [
            'L',
            point[0] + padding,
            point[1] + padding
        ],
        [
            'L',
            point[0] - padding,
            point[1] + padding
        ],
        [
            'Z'
        ]
    ];
    const arcData = [
        padding,
        padding,
        0,
        0,
        0
    ];
    return [
        [
            'M',
            point[0],
            point[1] - padding
        ],
        [
            'A',
            ...arcData,
            point[0],
            point[1] + padding
        ],
        [
            'A',
            ...arcData,
            point[0],
            point[1] - padding
        ]
    ];
};
/**
 * <zh/> 生成两点 Hull 路径
 *
 * <en/> Generate Hull Path for two points
 * @param points - <zh/> 两点 | <en/> Two points
 * @param padding - <zh/> 内边距 | <en/> Padding
 * @param corner - <zh/> 拐角类型 | <en/> Corner type
 * @returns <zh/> 两点 Hull 路径 | <en/> Two points Hull Path
 */ const $c9369bdad1137110$var$genTwoPointsHullPath = (points, padding, corner)=>{
    const arcData = [
        padding,
        padding,
        0,
        0,
        0
    ];
    const point1 = corner === 'sharp' ? (0, $dOidW.add)(points[0], (0, $dOidW.scale)((0, $dOidW.normalize)((0, $dOidW.subtract)(points[0], points[1])), padding)) : points[0];
    const point2 = corner === 'sharp' ? (0, $dOidW.add)(points[1], (0, $dOidW.scale)((0, $dOidW.normalize)((0, $dOidW.subtract)(points[1], points[0])), padding)) : points[1];
    const offsetVector = (0, $dOidW.scale)((0, $dOidW.normalize)((0, $dOidW.perpendicular)((0, $dOidW.subtract)(point1, point2), false)), padding);
    const invOffsetVector = (0, $dOidW.scale)(offsetVector, -1);
    const prev = (0, $dOidW.add)(point1, offsetVector);
    const current = (0, $dOidW.add)(point2, offsetVector);
    const p2 = (0, $dOidW.add)(point2, invOffsetVector);
    const p3 = (0, $dOidW.add)(point1, invOffsetVector);
    if (corner === 'sharp') return [
        [
            'M',
            prev[0],
            prev[1]
        ],
        [
            'L',
            current[0],
            current[1]
        ],
        [
            'L',
            p2[0],
            p2[1]
        ],
        [
            'L',
            p3[0],
            p3[1]
        ],
        [
            'Z'
        ]
    ];
    return [
        [
            'M',
            prev[0],
            prev[1]
        ],
        [
            'L',
            current[0],
            current[1]
        ],
        [
            'A',
            ...arcData,
            p2[0],
            p2[1]
        ],
        [
            'L',
            p3[0],
            p3[1]
        ],
        [
            'A',
            ...arcData,
            prev[0],
            prev[1]
        ]
    ];
};
/**
 * <zh/> 生成多点 Hull 路径且拐角为圆角
 *
 * <en/> Generate Hull Path for multiple points with rounded corners
 * @param points - <zh/> 形成 Hull 的点集 | <en/> Points that form the Hull
 * @param padding - <zh/> 内边距 | <en/> Padding
 * @returns <zh/> 圆角外壳路径 | <en/> Rounded hull path
 */ const $c9369bdad1137110$var$genMultiPointsRoundedHull = (points, padding)=>{
    const segments = (0, $dnXls.sortByClockwise)(points).map((current, i)=>{
        const prev2Index = (i - 2 + points.length) % points.length;
        const prevIndex = (i - 1 + points.length) % points.length;
        const nextIndex = (i + 1) % points.length;
        const prev2 = points[prev2Index];
        const prev = points[prevIndex];
        const next = points[nextIndex];
        const v0 = (0, $dOidW.subtract)(prev2, prev);
        const v1 = (0, $dOidW.subtract)(prev, current);
        const v2 = (0, $dOidW.subtract)(current, next);
        // 判断是否为凹角 ｜ Determine if it is a concave angle
        const isConcave = (v1, v2)=>{
            return (0, $dOidW.angle)(v1, v2, true) < Math.PI;
        };
        const concavePrev = isConcave(v0, v1);
        const concaveNext = isConcave(v1, v2);
        const offsetVector = (v)=>(0, $dOidW.scale)((0, $dOidW.normalize)((0, $dOidW.perpendicular)(v, false)), padding);
        const offset = offsetVector(v1);
        return [
            {
                p: (0, $dOidW.toVector2)(concavePrev ? (0, $dOidW.add)(prev, offsetVector(v0)) : (0, $dOidW.add)(prev, offset)),
                concave: concavePrev && prev
            },
            {
                p: (0, $dOidW.toVector2)(concaveNext ? (0, $dOidW.add)(current, offsetVector(v2)) : (0, $dOidW.add)(current, offset)),
                concave: concaveNext && current
            }
        ];
    });
    const arcData = [
        padding,
        padding,
        0,
        0,
        0
    ];
    const startIndex = segments.findIndex((segment, i)=>!segments[(i - 1 + segments.length) % segments.length][0].concave && !segments[(i - 1 + segments.length) % segments.length][1].concave && !segment[0].concave && !segment[0].concave && !segment[1].concave);
    const sortedSegments = segments.slice(startIndex).concat(segments.slice(0, startIndex));
    let concavePoints = [];
    return sortedSegments.flatMap((segment, i)=>{
        const pathFragment = [];
        const lastSegment = sortedSegments[segments.length - 1];
        if (i === 0) pathFragment.push([
            'M',
            ...lastSegment[1].p
        ]);
        if (!segment[0].concave) pathFragment.push([
            'A',
            ...arcData,
            ...segment[0].p
        ]);
        else concavePoints.push(segment[0].p, segment[1].p);
        if (!segment[1].concave) pathFragment.push([
            'L',
            ...segment[1].p
        ]);
        else concavePoints.unshift(segment[1].p);
        if (concavePoints.length === 3) {
            pathFragment.pop();
            pathFragment.push([
                'C',
                ...concavePoints.flat()
            ]);
            concavePoints = [];
        }
        return pathFragment;
    });
};
/**
 * <zh/> 生成多点 Hull 路径且拐角为平滑
 *
 * <en/> Generate Hull Path for multiple points with smooth corners
 * @param points - <zh/> 形成 Hull 的点集 | <en/> Points that form the Hull
 * @param padding - <zh/> 内边距 | <en/> Padding
 * @returns <zh/> 平滑外壳路径 | <en/> Smooth hull path
 */ const $c9369bdad1137110$var$genMultiPointsSmoothHull = (points, padding)=>{
    const hullPoints = (0, $dnXls.sortByClockwise)(points).map((p, i)=>{
        const pNext = points[(i + 1) % points.length];
        return {
            p: p,
            v: (0, $dOidW.normalize)((0, $dOidW.subtract)(pNext, p))
        };
    });
    // Compute the expanded hull points, and the nearest prior control point for each.
    hullPoints.forEach((hp, i)=>{
        const priorIndex = i > 0 ? i - 1 : points.length - 1;
        const prevV = hullPoints[priorIndex].v;
        const extensionVec = (0, $dOidW.normalize)((0, $dOidW.add)(prevV, (0, $dOidW.scale)(hp.v, (0, $dOidW.angle)(prevV, hp.v, true) < Math.PI ? 1 : -1)));
        hp.p = (0, $dOidW.add)(hp.p, (0, $dOidW.scale)(extensionVec, padding));
    });
    return (0, $oZkEc.getClosedSpline)(hullPoints.map((obj)=>obj.p));
};
/**
 * <zh/> 生成多点 Hull 路径且拐角为尖锐
 *
 * <en/> Generate Hull Path for multiple points with sharp corners
 * @param points - <zh/> 形成 Hull 的点集 | <en/> Points that form the Hull
 * @param padding - <zh/> 内边距 | <en/> Padding
 * @returns <zh/> 锐角外壳路径 | <en/> Sharp hull path
 */ const $c9369bdad1137110$var$genMultiPointsSharpHull = (points, padding)=>{
    const segments = points.map((current, i)=>{
        const prev = points[i === 0 ? points.length - 1 : i - 1];
        const offset = (0, $dOidW.toVector3)((0, $dOidW.scale)((0, $dOidW.normalize)((0, $dOidW.perpendicular)((0, $dOidW.subtract)(prev, current), false)), padding));
        return [
            (0, $dOidW.add)(prev, offset),
            (0, $dOidW.add)(current, offset)
        ];
    });
    const arr = segments.flat();
    const vertices = arr.map((_, i)=>{
        if (i % 2 === 0) return null;
        const l1 = [
            arr[(i - 1) % arr.length],
            arr[i % arr.length]
        ];
        const l2 = [
            arr[(i + 1) % arr.length],
            arr[(i + 2) % arr.length]
        ];
        return (0, $6A02h.getLinesIntersection)(l1, l2, true);
    }).filter(Boolean);
    return vertices.map((point, i)=>[
            i === 0 ? 'M' : 'L',
            point[0],
            point[1]
        ]).concat([
        [
            'Z'
        ]
    ]);
};

});


parcelRegister("7C4rJ", function(module, exports) {

$parcel$export(module.exports, "Legend", () => $58af87f4b2d76b0e$export$ed247974535929c7);

var $l4nKx = parcelRequire("l4nKx");

var $6XARU = parcelRequire("6XARU");
var $ky7aH = parcelRequire("ky7aH");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $WdqOS = parcelRequire("WdqOS");

var $5Pn1Q = parcelRequire("5Pn1Q");
var $58af87f4b2d76b0e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $58af87f4b2d76b0e$export$ed247974535929c7 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $58af87f4b2d76b0e$export$ed247974535929c7.defaultOptions, options));
        this.typePrefix = '__data__';
        this.draw = false;
        this.fieldMap = {
            node: new Map(),
            edge: new Map(),
            combo: new Map()
        };
        this.selectedItems = [];
        this.bindEvents = ()=>{
            const { graph: graph } = this.context;
            graph.on((0, $4EzN9.GraphEvent).AFTER_DRAW, this.createElement);
        };
        this.changeState = (el, state)=>{
            const { graph: graph } = this.context;
            const { typePrefix: typePrefix } = this;
            const composeId = (0, $6XARU.default)(el, [
                typePrefix,
                'id'
            ]);
            const category = (0, $6XARU.default)(el, [
                typePrefix,
                'style',
                'labelText'
            ]);
            const [type] = composeId.split('__');
            const ids = this.fieldMap[type].get(category) || [];
            graph.setElementState(Object.fromEntries(ids === null || ids === void 0 ? void 0 : ids.map((id)=>[
                    id,
                    state
                ])));
        };
        /**
         * <zh/> 图例元素点击事件
         *
         * <en/> Legend element click event
         * @param event - <zh/> 点击的元素 | <en/> The element that is clicked
         */ this.click = (event)=>{
            if (this.options.trigger === 'hover') return;
            const composeId = (0, $6XARU.default)(event, [
                this.typePrefix,
                'id'
            ]);
            if (!this.selectedItems.includes(composeId)) {
                this.selectedItems.push(composeId);
                this.changeState(event, 'selected');
            } else {
                this.selectedItems = this.selectedItems.filter((item)=>item !== composeId);
                this.changeState(event, []);
            }
        };
        /**
         * <zh/> 图例元素移出事件
         *
         * <en/> Legend element mouseleave event
         * @param event - <zh/> 移出的元素 | <en/> The element that is moved out
         */ this.mouseleave = (event)=>{
            if (this.options.trigger === 'click') return;
            this.selectedItems = [];
            this.changeState(event, []);
        };
        /**
         * <zh/> 图例元素移入事件
         *
         * <en/> Legend element mouseenter event
         * @param event - <zh/> 移入的元素 | <en/> The element that is moved in
         */ this.mouseenter = (event)=>{
            if (this.options.trigger === 'click') return;
            const composeId = (0, $6XARU.default)(event, [
                this.typePrefix,
                'id'
            ]);
            if (!this.selectedItems.includes(composeId)) {
                this.selectedItems.push(composeId);
                this.changeState(event, 'active');
            } else this.selectedItems = this.selectedItems.filter((item)=>item !== composeId);
        };
        this.setFieldMap = (field, id, type)=>{
            if (!field) return;
            const map = this.fieldMap[type];
            if (!map) return;
            if (!map.has(field)) map.set(field, [
                id
            ]);
            else {
                const ids = map.get(field);
                if (ids) {
                    ids.push(id);
                    map.set(field, ids);
                }
            }
        };
        this.getEvents = ()=>{
            return {
                mouseenter: this.mouseenter,
                mouseleave: this.mouseleave,
                click: this.click
            };
        };
        this.getMarkerData = (field, elementType)=>{
            if (!field) return [];
            const { model: model, element: element } = this.context;
            const { nodes: nodes, edges: edges, combos: combos } = model.getData();
            const items = {};
            const getField = (item)=>{
                if ((0, $ky7aH.default)(field)) return field(item);
                return field;
            };
            const defaultType = {
                node: 'circle',
                edge: 'line',
                combo: 'rect'
            };
            // 用于将 G6 element 转换为 components 支持的类型
            // Used to convert G6 element to types supported by components
            const markerMapping = {
                circle: 'circle',
                ellipse: 'circle',
                image: 'bowtie',
                rect: 'square',
                star: 'cross',
                triangle: 'triangle',
                diamond: 'diamond',
                cubic: 'dot',
                line: 'hyphen',
                polyline: 'hyphen',
                quadratic: 'hv',
                'cubic-horizontal': 'hyphen',
                'cubic-vertical': 'line'
            };
            const getElementStyle = (type, datum)=>{
                const style = element === null || element === void 0 ? void 0 : element.getElementComputedStyle(type, datum);
                return style;
            };
            const getElementModel = (data, type)=>{
                data.forEach((item)=>{
                    const { id: id } = item;
                    const value = (0, $6XARU.default)(item, [
                        'data',
                        getField(item)
                    ]);
                    const marker = (element === null || element === void 0 ? void 0 : element.getElementType(type, item)) || 'circle';
                    const style = getElementStyle(type, item);
                    const color = (type === 'edge' ? style === null || style === void 0 ? void 0 : style.stroke : style === null || style === void 0 ? void 0 : style.fill) || '#1783ff';
                    if (id && value && value.replace(/\s+/g, '')) {
                        this.setFieldMap(value, id, type);
                        if (!items[value]) items[value] = {
                            id: `${type}__${id}`,
                            label: value,
                            marker: markerMapping[marker] || defaultType[type],
                            elementType: type,
                            lineWidth: 1,
                            stroke: color,
                            fill: color
                        };
                    }
                });
            };
            switch(elementType){
                case 'node':
                    getElementModel(nodes, 'node');
                    break;
                case 'edge':
                    getElementModel(edges, 'edge');
                    break;
                case 'combo':
                    getElementModel(combos, 'combo');
                    break;
                default:
                    return [];
            }
            return Object.values(items);
        };
        this.createElement = ()=>{
            if (this.draw) {
                this.updateElement();
                return;
            }
            const _a = this.options, { width: width, height: height, nodeField: nodeField, edgeField: edgeField, comboField: comboField, trigger: trigger, position: position, container: container, containerStyle: containerStyle, className: className } = _a, rest = $58af87f4b2d76b0e$var$__rest(_a, [
                "width",
                "height",
                "nodeField",
                "edgeField",
                "comboField",
                "trigger",
                "position",
                "container",
                "containerStyle",
                "className"
            ]);
            const nodeItems = this.getMarkerData(nodeField, 'node');
            const edgeItems = this.getMarkerData(edgeField, 'edge');
            const comboItems = this.getMarkerData(comboField, 'combo');
            const items = [
                ...nodeItems,
                ...comboItems,
                ...edgeItems
            ];
            const categoryStyle = Object.assign({
                width: width,
                height: height,
                data: items,
                itemMarkerLineWidth: ({ lineWidth: lineWidth })=>lineWidth,
                itemMarker: ({ marker: marker })=>marker,
                itemMarkerStroke: ({ stroke: stroke })=>stroke,
                itemMarkerFill: ({ fill: fill })=>fill,
                gridCol: nodeItems.length
            }, rest, this.getEvents());
            const category = new (0, $l4nKx.Category)({
                className: 'legend',
                style: categoryStyle
            });
            this.category = category;
            const canvas = this.upsertCanvas();
            canvas.appendChild(category);
            this.draw = true;
        };
        this.bindEvents();
    }
    /**
     * <zh/> 更新图例配置
     *
     * <en/> Update the legend configuration
     * @param options - <zh/> 图例配置项 | <en/> Legend options
     * @internal
     */ update(options) {
        super.update(options);
        this.clear();
        this.createElement();
    }
    clear() {
        var _a, _b;
        (_a = this.canvas) === null || _a === void 0 || _a.destroy();
        (_b = this.container) === null || _b === void 0 || _b.remove();
        this.canvas = undefined;
        this.container = undefined;
        this.draw = false;
    }
    /**
     * <zh/> 刷新图例元素状态
     *
     * <en/> Refresh the status of the legend element
     */ updateElement() {
        if (!this.category) return;
        this.category.update({
            itemMarkerOpacity: ({ id: id })=>{
                if (!this.selectedItems.length || this.selectedItems.includes(id)) return 1;
                return 0.5;
            },
            itemLabelOpacity: ({ id: id })=>{
                if (!this.selectedItems.length || this.selectedItems.includes(id)) return 1;
                return 0.5;
            }
        });
    }
    upsertCanvas() {
        if (this.canvas) return this.canvas;
        const graphCanvas = this.context.canvas;
        const [canvasWidth, canvasHeight] = graphCanvas.getSize();
        const { width: width = canvasWidth, height: height = canvasHeight, position: position, container: container, containerStyle: containerStyle, className: className } = this.options;
        const [$container, canvas] = (0, $5Pn1Q.createPluginCanvas)({
            width: width,
            height: height,
            graphCanvas: graphCanvas,
            container: container,
            containerStyle: containerStyle,
            placement: position,
            className: 'legend'
        });
        this.container = $container;
        if (className) $container.classList.add(className);
        this.canvas = canvas;
        return this.canvas;
    }
    /**
     * <zh/>销毁图例
     *
     * <en/> Destroy the legend
     * @internal
     */ destroy() {
        this.clear();
        this.context.graph.off((0, $4EzN9.GraphEvent).AFTER_DRAW, this.createElement);
        super.destroy();
    }
}
$58af87f4b2d76b0e$export$ed247974535929c7.defaultOptions = {
    position: 'bottom',
    trigger: 'hover',
    orientation: 'horizontal',
    layout: 'flex',
    itemSpacing: 4,
    rowPadding: 10,
    colPadding: 10,
    itemMarkerSize: 16,
    itemLabelFontSize: 16,
    width: 240,
    height: 160
};

});
parcelRegister("l4nKx", function(module, exports) {

$parcel$export(module.exports, "Category", () => $f56c64de0a5651ab$export$3a8840c5b2ecf003);

var $7WQrb = parcelRequire("7WQrb");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $7agTx = parcelRequire("7agTx");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $2IgUM = parcelRequire("2IgUM");

var $caSBp = parcelRequire("caSBp");

var $ieO5k = parcelRequire("ieO5k");
var $f56c64de0a5651ab$var$HtmlLegend = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(HtmlLegend, _super);
    function HtmlLegend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HtmlLegend.prototype.update = function(options) {
        this.attr(options);
    };
    return HtmlLegend;
}((0, $2eDEB.HTML));
var $f56c64de0a5651ab$export$3a8840c5b2ecf003 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Category, _super);
    function Category(options) {
        return _super.call(this, options, (0, $ieO5k.CATEGORY_DEFAULT_OPTIONS)) || this;
    }
    Category.prototype.renderTitle = function(container, width, height) {
        var _a = this.attributes, showTitle = _a.showTitle, titleText = _a.titleText, classNamePrefix = _a.classNamePrefix;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'title');
        var _b = (0, $7WQrb.__read)((0, $8UxPj.splitStyle)(style), 2), titleStyle = _b[0], groupStyle = _b[1];
        this.titleGroup = container.maybeAppendByClassName((0, $ieO5k.CLASS_NAMES).titleGroup, 'g').styles(groupStyle);
        var finalTitleStyle = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
            width: width,
            height: height
        }, titleStyle), {
            text: showTitle ? titleText : '',
            classNamePrefix: classNamePrefix
        });
        this.title = this.titleGroup.maybeAppendByClassName((0, $ieO5k.CLASS_NAMES).title, function() {
            return new (0, $2IgUM.Title)({
                style: finalTitleStyle
            });
        }).update(finalTitleStyle);
    };
    Category.prototype.renderCustom = function(container) {
        var data = this.attributes.data;
        var style = {
            innerHTML: this.attributes.render(data),
            pointerEvents: 'auto'
        };
        container.maybeAppendByClassName((0, $ieO5k.CLASS_NAMES).html, function() {
            return new $f56c64de0a5651ab$var$HtmlLegend({
                className: (0, $ieO5k.CLASS_NAMES).html.name,
                style: style
            });
        }).update(style);
    };
    Category.prototype.renderItems = function(container, bbox) {
        var x = bbox.x, y = bbox.y, width = bbox.width, height = bbox.height;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'title', true);
        var _a = (0, $7WQrb.__read)((0, $8UxPj.splitStyle)(style), 2), partialItemStyle = _a[0], groupStyle = _a[1];
        // overwrite width and height to available space
        // overwrite x and y to 0
        var itemStyle = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, partialItemStyle), {
            width: width,
            height: height,
            x: 0,
            y: 0
        });
        this.itemsGroup = container.maybeAppendByClassName((0, $ieO5k.CLASS_NAMES).itemsGroup, 'g').styles((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, groupStyle), {
            transform: "translate(".concat(x, ", ").concat(y, ")")
        }));
        var that = this;
        this.itemsGroup.selectAll((0, $ieO5k.CLASS_NAMES).items.class).data([
            'items'
        ]).join(function(enter) {
            return enter.append(function() {
                return new (0, $caSBp.CategoryItems)({
                    style: itemStyle
                });
            }).attr('className', (0, $ieO5k.CLASS_NAMES).items.name).each(function() {
                that.items = (0, $bCy7Q.select)(this);
            });
        }, function(update) {
            return update.update(itemStyle);
        }, function(exit) {
            return exit.remove();
        });
    };
    Category.prototype.adjustLayout = function() {
        var showTitle = this.attributes.showTitle;
        if (showTitle) {
            var _a = this.title.node().getAvailableSpace(), x = _a.x, y = _a.y;
            this.itemsGroup.node().style.transform = "translate(".concat(x, ", ").concat(y, ")");
        }
    };
    Object.defineProperty(Category.prototype, "availableSpace", {
        get: function() {
            var _a = this.attributes, showTitle = _a.showTitle, width = _a.width, height = _a.height;
            if (!showTitle) return new (0, $7agTx.BBox)(0, 0, width, height);
            return this.title.node().getAvailableSpace();
        },
        enumerable: false,
        configurable: true
    });
    Category.prototype.getBBox = function() {
        var _a, _b;
        var title = (_a = this.title) === null || _a === void 0 ? void 0 : _a.node();
        var items = (_b = this.items) === null || _b === void 0 ? void 0 : _b.node();
        if (!title || !items) return _super.prototype.getBBox.call(this);
        return (0, $2IgUM.getBBox)(title, items);
    };
    Category.prototype.render = function(attributes, container) {
        var _a = this.attributes, width = _a.width, height = _a.height, _b = _a.x, x = _b === void 0 ? 0 : _b, _c = _a.y, y = _c === void 0 ? 0 : _c, classNamePrefix = _a.classNamePrefix, render = _a.render;
        var ctn = (0, $bCy7Q.select)(container);
        // Set root container className
        var baseClassName = container.className || 'legend-category';
        if (classNamePrefix) container.attr('className', "".concat(baseClassName, " ").concat(classNamePrefix, "legend"));
        else if (!container.className) container.attr('className', 'legend-category');
        container.style.transform = "translate(".concat(x, ", ").concat(y, ")");
        if (render) this.renderCustom(ctn);
        else {
            this.renderTitle(ctn, width, height);
            this.renderItems(ctn, this.availableSpace);
            this.adjustLayout();
        }
    };
    return Category;
}((0, $e7n3C.Component));

});
parcelRegister("e7n3C", function(module, exports) {

$parcel$export(module.exports, "Component", () => $a4739ad6ee7e5ea3$export$16fa2f45be04daa8);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $1qXAC = parcelRequire("1qXAC");
var $6LvUc = parcelRequire("6LvUc");
var $2gch2 = parcelRequire("2gch2");
function $a4739ad6ee7e5ea3$var$applyVisibility() {
    (0, $2gch2.visibility)(this, this.attributes.visibility !== 'hidden');
}
var $a4739ad6ee7e5ea3$export$16fa2f45be04daa8 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Component, _super);
    function Component(options, defaultStyleProps) {
        if (defaultStyleProps === void 0) defaultStyleProps = {};
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, {
            style: defaultStyleProps
        }, options)) || this;
        _this.initialized = false;
        _this._defaultOptions = defaultStyleProps;
        return _this;
    }
    Object.defineProperty(Component.prototype, "offscreenGroup", {
        get: function() {
            if (!this._offscreen) this._offscreen = (0, $1qXAC.createOffscreenGroup)(this);
            return this._offscreen;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Component.prototype, "defaultOptions", {
        get: function() {
            return this._defaultOptions;
        },
        enumerable: false,
        configurable: true
    });
    Component.prototype.connectedCallback = function() {
        this.render(this.attributes, this);
        this.bindEvents(this.attributes, this);
        this.initialized = true;
    };
    Component.prototype.disconnectedCallback = function() {
        var _a;
        (_a = this._offscreen) === null || _a === void 0 || _a.destroy();
    };
    Component.prototype.attributeChangedCallback = function(name) {
        if (name === 'visibility') $a4739ad6ee7e5ea3$var$applyVisibility.call(this);
    };
    Component.prototype.update = function(attr, animate) {
        var _a;
        this.attr((0, $6LvUc.deepAssign)({}, this.attributes, attr || {}));
        return (_a = this.render) === null || _a === void 0 ? void 0 : _a.call(this, this.attributes, this, animate);
    };
    Component.prototype.clear = function() {
        this.removeChildren();
    };
    Component.prototype.bindEvents = function(attributes, container) {};
    Component.prototype.getSubShapeStyle = function(attributes) {
        var x = attributes.x, y = attributes.y, transform = attributes.transform, transformOrigin = attributes.transformOrigin, _class = attributes.class, className = attributes.className, zIndex = attributes.zIndex, style = (0, $7WQrb.__rest)(attributes, [
            "x",
            "y",
            "transform",
            "transformOrigin",
            "class",
            "className",
            "zIndex"
        ]);
        return style;
    };
    return Component;
}((0, $2eDEB.CustomElement));

});
parcelRegister("1qXAC", function(module, exports) {

$parcel$export(module.exports, "createOffscreenGroup", () => $10b67164ba75e102$export$52b4e620b5db45b4);
$parcel$export(module.exports, "isInOffscreenGroup", () => $10b67164ba75e102$export$f40737efe6bfe48e);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $2gch2 = parcelRequire("2gch2");
var $10b67164ba75e102$var$OffscreenGroup = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(OffscreenGroup, _super);
    function OffscreenGroup() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(args), false)) || this;
        _this.isMutationObserved = true;
        _this.addEventListener((0, $2eDEB.ElementEvent).INSERTED, function() {
            (0, $2gch2.hide)(_this);
        });
        return _this;
    }
    return OffscreenGroup;
}((0, $2eDEB.Group));
function $10b67164ba75e102$export$52b4e620b5db45b4(container) {
    var group = container.appendChild(new $10b67164ba75e102$var$OffscreenGroup({
        class: 'offscreen'
    }));
    (0, $2gch2.hide)(group);
    return group;
}
function $10b67164ba75e102$export$f40737efe6bfe48e(group) {
    var ancestor = group;
    while(ancestor){
        if (ancestor.className === 'offscreen') return true;
        ancestor = ancestor.parent;
    }
    return false;
}

});
parcelRegister("2gch2", function(module, exports) {

$parcel$export(module.exports, "show", () => $1a5698b996787dcd$export$57bf213be019eeb0);
$parcel$export(module.exports, "visibility", () => $1a5698b996787dcd$export$91fa9ac3f4021ce4);
$parcel$export(module.exports, "hide", () => $1a5698b996787dcd$export$fe8985bb6374093c);

var $lI6dc = parcelRequire("lI6dc");
function $1a5698b996787dcd$export$57bf213be019eeb0(element) {
    $1a5698b996787dcd$export$91fa9ac3f4021ce4(element, true);
}
function $1a5698b996787dcd$export$fe8985bb6374093c(element) {
    $1a5698b996787dcd$export$91fa9ac3f4021ce4(element, false);
}
function $1a5698b996787dcd$export$91fa9ac3f4021ce4(element, visible) {
    var value = visible ? 'visible' : 'hidden';
    (0, $lI6dc.traverse)(element, function(node) {
        node.attr('visibility', value);
    });
}

});
parcelRegister("lI6dc", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $fce28691c4b404f5$export$df3f009e3d155b20);
function $fce28691c4b404f5$export$df3f009e3d155b20(element, callback) {
    callback(element);
    if (element.children) element.children.forEach(function(child) {
        if (child) $fce28691c4b404f5$export$df3f009e3d155b20(child, callback);
    });
}

});



parcelRegister("6LvUc", function(module, exports) {

$parcel$export(module.exports, "deepAssign", () => $4ecfe1a270f1cd26$export$1148cb79ceecd5fa);

var $7WQrb = parcelRequire("7WQrb");

var $1uF5a = parcelRequire("1uF5a");
var $1RAzq = parcelRequire("1RAzq");
var $4ecfe1a270f1cd26$var$MAX_MIX_LEVEL = 5;
var $4ecfe1a270f1cd26$var$deep = function(dist, src, level, maxLevel) {
    if (level === void 0) level = 0;
    if (maxLevel === void 0) maxLevel = $4ecfe1a270f1cd26$var$MAX_MIX_LEVEL;
    Object.entries(src).forEach(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], value = _b[1];
        var res = dist;
        if (Object.prototype.hasOwnProperty.call(src, key)) {
            if (!value) // null 、 undefined 等情况直接赋值
            res[key] = value;
            else if ((0, $1RAzq.default)(value)) {
                if (!(0, $1RAzq.default)(dist[key])) res[key] = {};
                if (level < maxLevel) $4ecfe1a270f1cd26$var$deep(dist[key], value, level + 1, maxLevel);
                else // 层级过深直接赋值，性能问题
                res[key] = src[key];
            } else if ((0, $1uF5a.default)(value)) {
                res[key] = [];
                res[key] = res[key].concat(value);
            } else res[key] = value;
        }
    });
};
var $4ecfe1a270f1cd26$export$1148cb79ceecd5fa = function(rst) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    for(var i = 0; i < args.length; i += 1)$4ecfe1a270f1cd26$var$deep(rst, args[i]);
    return rst;
};

});


parcelRegister("7agTx", function(module, exports) {

$parcel$export(module.exports, "BBox", () => $5376928c8673067b$export$bd64c5827f1eba0c);

var $7WQrb = parcelRequire("7WQrb");
var $5376928c8673067b$export$bd64c5827f1eba0c = /** @class */ function() {
    function BBox(x, y, width, height) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        if (width === void 0) width = 0;
        if (height === void 0) height = 0;
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    Object.defineProperty(BBox.prototype, "bottom", {
        get: function() {
            return this.y + this.height;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BBox.prototype, "left", {
        get: function() {
            return this.x;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BBox.prototype, "right", {
        get: function() {
            return this.x + this.width;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BBox.prototype, "top", {
        get: function() {
            return this.y;
        },
        enumerable: false,
        configurable: true
    });
    BBox.fromRect = function(other) {
        return new BBox(other.x, other.y, other.width, other.height);
    };
    BBox.prototype.toJSON = function() {
        return {
            x: this.x,
            y: this.y,
            width: this.width,
            height: this.height,
            top: this.top,
            right: this.right,
            bottom: this.bottom,
            left: this.left
        };
    };
    /**
     * 点是否在 bbox 中
     * @param p
     */ BBox.prototype.isPointIn = function(x, y) {
        return x >= this.left && x <= this.right && y >= this.top && y <= this.bottom;
    };
    return BBox;
}();
function $5376928c8673067b$export$3478bc6d029410d5(element) {
    var _a = element.getRenderBounds(), _b = (0, $7WQrb.__read)(_a.min, 2), minX = _b[0], minY = _b[1], _c = (0, $7WQrb.__read)(_a.max, 2), maxX = _c[0], maxY = _c[1];
    var width = maxX - minX;
    var height = maxY - minY;
    return new $5376928c8673067b$export$bd64c5827f1eba0c(minX, minY, width, height);
}

});

parcelRegister("bCy7Q", function(module, exports) {

$parcel$export(module.exports, "select", () => $875db6effa85e2eb$export$2e6c959c16ff56b8);
$parcel$export(module.exports, "maybeAppend", () => $875db6effa85e2eb$export$96036e1b1324c263);

var $7WQrb = parcelRequire("7WQrb");

var $gVoA7 = parcelRequire("gVoA7");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");
var $eNeqF = parcelRequire("eNeqF");

var $01ZX5 = parcelRequire("01ZX5");
function $875db6effa85e2eb$var$error(msg) {
    throw new Error(msg);
}
/**
 * A simple implementation of d3-selection for @antv/g.
 * It has the core features of d3-selection and extended ability.
 * Every methods of selection returns new selection if elements
 * are mutated(e.g. append, remove), otherwise return the selection itself(e.g. attr, style).
 * @see https://github.com/d3/d3-selection
 * @see https://github.com/antvis/g
 * @todo Nested selections.
 * @todo More useful functor.
 */ var $875db6effa85e2eb$export$52baac22726c72bf = /** @class */ function() {
    function Selection(elements, data, parent, document, selections, transitions, updateElements) {
        if (elements === void 0) elements = null;
        if (data === void 0) data = null;
        if (parent === void 0) parent = null;
        if (document === void 0) document = null;
        if (selections === void 0) selections = [
            null,
            null,
            null,
            null,
            null
        ];
        if (transitions === void 0) transitions = [];
        if (updateElements === void 0) updateElements = [];
        _Selection_instances.add(this);
        this._elements = Array.from(elements);
        this._data = data;
        this._parent = parent;
        this._document = document;
        this._enter = selections[0];
        this._update = selections[1];
        this._exit = selections[2];
        this._merge = selections[3];
        this._split = selections[4];
        this._transitions = transitions;
        this._facetElements = updateElements;
    }
    Selection.prototype.selectAll = function(selector) {
        var elements = typeof selector === 'string' ? this._parent.querySelectorAll(selector) : selector;
        return new _a(elements, null, this._elements[0], this._document);
    };
    Selection.prototype.selectFacetAll = function(selector) {
        var elements = typeof selector === 'string' ? this._parent.querySelectorAll(selector) : selector;
        return new _a(this._elements, null, this._parent, this._document, undefined, undefined, elements);
    };
    /**
     * @todo Replace with querySelector which has bug now.
     */ Selection.prototype.select = function(selector) {
        var element = typeof selector === 'string' ? this._parent.querySelectorAll(selector)[0] || null : selector;
        return new _a([
            element
        ], null, element, this._document);
    };
    Selection.prototype.append = function(node) {
        var _this = this;
        var callback = typeof node === 'function' ? node : function() {
            return _this.createElement(node);
        };
        var elements = [];
        if (this._data !== null) {
            // For empty selection, append new element to parent.
            // Each element is bind with datum.
            for(var i = 0; i < this._data.length; i++){
                var d = this._data[i];
                var _b = (0, $7WQrb.__read)(Array.isArray(d) ? d : [
                    d,
                    null
                ], 2), datum = _b[0], from = _b[1];
                var newElement = callback(datum, i);
                newElement.__data__ = datum;
                if (from !== null) newElement.__fromElements__ = from;
                this._parent.appendChild(newElement);
                elements.push(newElement);
            }
            return new _a(elements, null, this._parent, this._document);
        }
        // For non-empty selection, append new element to
        // selected element and return new selection.
        for(var i = 0; i < this._elements.length; i++){
            var element = this._elements[i];
            var datum = element.__data__;
            var newElement = callback(datum, i);
            element.appendChild(newElement);
            elements.push(newElement);
        }
        return new _a(elements, null, elements[0], this._document);
    };
    Selection.prototype.maybeAppend = function(id, node) {
        var element = (0, $7WQrb.__classPrivateFieldGet)(this, _Selection_instances, "m", _Selection_maybeAppend).call(this, id[0] === '#' ? id : "#".concat(id), node);
        element.attr('id', id);
        return element;
    };
    Selection.prototype.maybeAppendByClassName = function(className, node) {
        var cls = className.toString();
        var element = (0, $7WQrb.__classPrivateFieldGet)(this, _Selection_instances, "m", _Selection_maybeAppend).call(this, cls[0] === '.' ? cls : ".".concat(cls), node);
        element.attr('className', cls);
        return element;
    };
    Selection.prototype.maybeAppendByName = function(name, node) {
        var element = (0, $7WQrb.__classPrivateFieldGet)(this, _Selection_instances, "m", _Selection_maybeAppend).call(this, "[name=\"".concat(name, "\"]"), node);
        element.attr('name', name);
        return element;
    };
    /**
     * Bind data to elements, and produce three selection:
     * Enter: Selection with empty elements and data to be bind to elements.
     * Update: Selection with elements to be updated.
     * Exit: Selection with elements to be removed.
     */ Selection.prototype.data = function(data, id, groupId) {
        var e_1, _b;
        if (id === void 0) id = function(d) {
            return d;
        };
        if (groupId === void 0) groupId = function() {
            return null;
        };
        // An Array of new data.
        var enter = [];
        // An Array of elements to be updated.
        var update = [];
        // A Set of elements to be removed.
        var exit = new Set(this._elements);
        // An Array of data to be merged into one element.
        var merge = [];
        // A Set of elements to be split into multiple datum.
        var split = new Set();
        // A Map from key to each element.
        var keyElement = new Map(this._elements.map(function(d, i) {
            return [
                id(d.__data__, i),
                d
            ];
        }));
        // A Map from key to exist element. The Update Selection
        // can get element from this map, this is for diff among
        // facets.
        var keyUpdateElement = new Map(this._facetElements.map(function(d, i) {
            return [
                id(d.__data__, i),
                d
            ];
        }));
        // A Map from groupKey to a group of elements.
        var groupKeyElements = (0, $01ZX5.group)(this._elements, function(d) {
            return groupId(d.__data__);
        });
        // Diff data with selection(elements with data).
        // !!! Note
        // The switch is strictly ordered, not not change the order of them.
        for(var i = 0; i < data.length; i++){
            var datum = data[i];
            var key = id(datum, i);
            var groupKey = groupId(datum, i);
            // Append element to update selection if incoming data has
            // exactly the same key with elements.
            if (keyElement.has(key)) {
                var element = keyElement.get(key);
                element.__data__ = datum;
                element.__facet__ = false;
                update.push(element);
                exit.delete(element);
                keyElement.delete(key);
            // Append element to update selection if incoming data has
            // exactly the same key with updateElements.
            } else if (keyUpdateElement.has(key)) {
                var element = keyUpdateElement.get(key);
                element.__data__ = datum;
                // Flag this element should update its parentNode.
                element.__facet__ = true;
                update.push(element);
                keyUpdateElement.delete(key);
            // Append datum to merge selection if existed elements has
            // its key as groupKey.
            } else if (groupKeyElements.has(key)) {
                var group_2 = groupKeyElements.get(key);
                merge.push([
                    datum,
                    group_2
                ]);
                try {
                    for(var group_1 = (e_1 = void 0, (0, $7WQrb.__values)(group_2)), group_1_1 = group_1.next(); !group_1_1.done; group_1_1 = group_1.next()){
                        var element = group_1_1.value;
                        exit.delete(element);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (group_1_1 && !group_1_1.done && (_b = group_1.return)) _b.call(group_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                groupKeyElements.delete(key);
            // Append element to split selection if incoming data has
            // groupKey as its key, and bind to datum for it.
            } else if (keyElement.has(groupKey)) {
                var element = keyElement.get(groupKey);
                if (element.__toData__) element.__toData__.push(datum);
                else element.__toData__ = [
                    datum
                ];
                split.add(element);
                exit.delete(element);
            } else enter.push(datum);
        }
        // Create new selection with enter, update and exit.
        var S = [
            new _a([], enter, this._parent, this._document),
            new _a(update, null, this._parent, this._document),
            new _a(exit, null, this._parent, this._document),
            new _a([], merge, this._parent, this._document),
            new _a(split, null, this._parent, this._document)
        ];
        return new _a(this._elements, null, this._parent, this._document, S);
    };
    Selection.prototype.merge = function(other) {
        var elements = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(this._elements), false), (0, $7WQrb.__read)(other._elements), false);
        var transitions = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(this._transitions), false), (0, $7WQrb.__read)(other._transitions), false);
        return new _a(elements, null, this._parent, this._document, undefined, transitions);
    };
    Selection.prototype.createElement = function(type) {
        if (this._document) return this._document.createElement(type, {});
        var Ctor = _a.registry[type];
        if (Ctor) return new Ctor();
        return $875db6effa85e2eb$var$error("Unknown node type: ".concat(type));
    };
    /**
     * Apply callback for each selection(enter, update, exit)
     * and merge them into one selection.
     */ Selection.prototype.join = function(enter, update, exit, merge, split) {
        if (enter === void 0) enter = function(d) {
            return d;
        };
        if (update === void 0) update = function(d) {
            return d;
        };
        if (exit === void 0) exit = function(d) {
            return d.remove();
        };
        if (merge === void 0) merge = function(d) {
            return d;
        };
        if (split === void 0) split = function(d) {
            return d.remove();
        };
        var newEnter = enter(this._enter);
        var newUpdate = update(this._update);
        var newExit = exit(this._exit);
        var newMerge = merge(this._merge);
        var newSplit = split(this._split);
        return newUpdate.merge(newEnter).merge(newExit).merge(newMerge).merge(newSplit);
    };
    Selection.prototype.remove = function() {
        var _loop_1 = function(i) {
            var element = this_1._elements[i];
            var transition = this_1._transitions[i];
            if (transition) transition.then(function() {
                return element.remove();
            });
            else element.remove();
        };
        var this_1 = this;
        // Remove node immediately if there is no transition,
        // otherwise wait until transition finished.
        for(var i = 0; i < this._elements.length; i++)_loop_1(i);
        return new _a([], null, this._parent, this._document, undefined, this._transitions);
    };
    Selection.prototype.each = function(callback) {
        for(var i = 0; i < this._elements.length; i++){
            var element = this._elements[i];
            var datum = element.__data__;
            callback.call(element, datum, i);
        }
        return this;
    };
    Selection.prototype.attr = function(key, value) {
        var callback = typeof value !== 'function' ? function() {
            return value;
        } : value;
        return this.each(function(d, i) {
            if (value !== undefined) this[key] = callback.call(this, d, i);
        });
    };
    Selection.prototype.style = function(key, value, callable) {
        if (callable === void 0) callable = true;
        var callback = typeof value !== 'function' || !callable ? function() {
            return value;
        } : value;
        return this.each(function(d, i) {
            if (value !== undefined) this.style[key] = callback.call(this, d, i);
        });
    };
    Selection.prototype.styles = function(style, callable) {
        if (style === void 0) style = {};
        if (callable === void 0) callable = true;
        return this.each(function(d, i) {
            var _this = this;
            Object.entries(style).forEach(function(_b) {
                var _c = (0, $7WQrb.__read)(_b, 2), key = _c[0], value = _c[1];
                var callback = typeof value !== 'function' || !callable ? function() {
                    return value;
                } : value;
                if (value !== undefined) _this.attr(key, callback.call(_this, d, i));
            });
        });
    };
    Selection.prototype.update = function(option, callable) {
        if (callable === void 0) callable = true;
        var callback = typeof option !== 'function' || !callable ? function() {
            return option;
        } : option;
        return this.each(function(d, i) {
            if (option && this.update) this.update(callback.call(this, d, i));
        });
    };
    /** if current stage is maybeAppend, skip update stage */ Selection.prototype.maybeUpdate = function(option, callable) {
        if (callable === void 0) callable = true;
        var callback = typeof option !== 'function' || !callable ? function() {
            return option;
        } : option;
        return this.each(function(d, i) {
            if (option && this.update) this.update(callback.call(this, d, i));
        });
    };
    Selection.prototype.transition = function(callback) {
        var T = this._transitions;
        var newTransitions = new Array(this._elements.length);
        this.each(function(d, i) {
            newTransitions[i] = callback.call(this, d, i);
        });
        this._transitions = (0, $gVoA7.default)(newTransitions);
        return this;
    };
    Selection.prototype.on = function(event, handler) {
        this.each(function() {
            this.addEventListener(event, handler);
        });
        return this;
    };
    Selection.prototype.call = function(callback) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        callback.call.apply(callback, (0, $7WQrb.__spreadArray)([
            this._parent,
            this
        ], (0, $7WQrb.__read)(args), false));
        return this;
    };
    Selection.prototype.node = function() {
        return this._elements[0];
    };
    Selection.prototype.nodes = function() {
        return this._elements;
    };
    Selection.prototype.transitions = function() {
        return this._transitions.filter(function(t) {
            return !!t;
        });
    };
    Selection.prototype.parent = function() {
        return this._parent;
    };
    var _Selection_instances, _a, _Selection_maybeAppend;
    _a = Selection, _Selection_instances = new WeakSet(), _Selection_maybeAppend = function _Selection_maybeAppend(selector, node) {
        var element = this._elements[0];
        var child = element.querySelector(selector);
        if (child) return new _a([
            child
        ], null, this._parent, this._document);
        var newChild = typeof node === 'string' ? this.createElement(node) : node();
        element.appendChild(newChild);
        return new _a([
            newChild
        ], null, this._parent, this._document);
    };
    Selection.registry = {
        g: (0, $2eDEB.Group),
        rect: (0, $2eDEB.Rect),
        circle: (0, $2eDEB.Circle),
        path: (0, $2eDEB.Path),
        text: (0, $eNeqF.Text),
        ellipse: (0, $2eDEB.Ellipse),
        image: (0, $2eDEB.Image),
        line: (0, $2eDEB.Line),
        polygon: (0, $2eDEB.Polygon),
        polyline: (0, $2eDEB.Polyline),
        html: (0, $2eDEB.HTML)
    };
    return Selection;
}();
function $875db6effa85e2eb$export$2e6c959c16ff56b8(node) {
    return new $875db6effa85e2eb$export$52baac22726c72bf([
        node
    ], null, node, node.ownerDocument);
}
function $875db6effa85e2eb$export$96036e1b1324c263(parent, selector, node) {
    if (!parent.querySelector(selector)) return $875db6effa85e2eb$export$2e6c959c16ff56b8(parent).append(node);
    return $875db6effa85e2eb$export$2e6c959c16ff56b8(parent).select(selector);
}

});
parcelRegister("gVoA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5250997b3461d54$export$2e2bcd8739ae039);

var $1uF5a = parcelRequire("1uF5a");
/**
 * Flattens `array` a single level deep.
 *
 * @param {Array} arr The array to flatten.
 * @return {Array} Returns the new flattened array.
 * @example
 *
 * flatten([1, [2, [3, [4]], 5]]);  // => [1, 2, [3, [4]], 5]
 */ var $c5250997b3461d54$var$flatten = function(arr) {
    if (!(0, $1uF5a.default)(arr)) return [];
    var rst = [];
    for(var i = 0; i < arr.length; i++)rst = rst.concat(arr[i]);
    return rst;
};
var $c5250997b3461d54$export$2e2bcd8739ae039 = $c5250997b3461d54$var$flatten;

});

parcelRegister("eNeqF", function(module, exports) {

$parcel$export(module.exports, "Text", () => $ac50d5a2fc28680a$export$5f1af8db9871e1d6);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $1qXAC = parcelRequire("1qXAC");
var $ac50d5a2fc28680a$export$5f1af8db9871e1d6 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Text, _super);
    function Text(_a) {
        if (_a === void 0) _a = {};
        var style = _a.style, restOptions = (0, $7WQrb.__rest)(_a, [
            "style"
        ]);
        return _super.call(this, (0, $7WQrb.__assign)({
            style: (0, $7WQrb.__assign)({
                text: '',
                fill: 'black',
                fontFamily: 'sans-serif',
                fontSize: 16,
                fontStyle: 'normal',
                fontVariant: 'normal',
                fontWeight: 'normal',
                lineWidth: 1,
                textAlign: 'start',
                textBaseline: 'middle'
            }, style)
        }, restOptions)) || this;
    }
    Object.defineProperty(Text.prototype, "offscreenGroup", {
        get: function() {
            if (!this._offscreen) this._offscreen = (0, $1qXAC.createOffscreenGroup)(this);
            return this._offscreen;
        },
        enumerable: false,
        configurable: true
    });
    Text.prototype.disconnectedCallback = function() {
        var _a;
        (_a = this._offscreen) === null || _a === void 0 || _a.destroy();
    };
    return Text;
}((0, $2eDEB.Text));

});

parcelRegister("01ZX5", function(module, exports) {

$parcel$export(module.exports, "group", () => $00602678d153ff49$export$e5e25fbcc1f7affe);
function $00602678d153ff49$export$e5e25fbcc1f7affe(array, keyFunc) {
    var grouped = new Map();
    array.forEach(function(item) {
        var key = keyFunc(item);
        if (!grouped.has(key)) grouped.set(key, []);
        grouped.get(key).push(item);
    });
    return grouped;
}

});


parcelRegister("8UxPj", function(module, exports) {

$parcel$export(module.exports, "applyStyleSheet", () => $67cdcaf7a3d6c8e0$export$9c9fa7e4aa4f70ff);
$parcel$export(module.exports, "subStyleProps", () => $67cdcaf7a3d6c8e0$export$f38e4d4b23aef199);
$parcel$export(module.exports, "superStyleProps", () => $67cdcaf7a3d6c8e0$export$d02e2f41ee79d54b);
$parcel$export(module.exports, "splitStyle", () => $67cdcaf7a3d6c8e0$export$1b8b982f95931e75);

var $7WQrb = parcelRequire("7WQrb");

var $kPuYL = parcelRequire("kPuYL");
function $67cdcaf7a3d6c8e0$export$9c9fa7e4aa4f70ff(element, style) {
    Object.entries(style).forEach(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), selector = _b[0], styleString = _b[1];
        // apply styles to element and children
        (0, $7WQrb.__spreadArray)([
            element
        ], (0, $7WQrb.__read)(element.querySelectorAll(selector)), false).filter(function(el) {
            return el.matches(selector);
        }).forEach(function(target) {
            if (!target) return;
            var temp = target;
            temp.style.cssText += Object.entries(styleString).reduce(function(total, currVal) {
                return "".concat(total).concat(currVal.join(':'), ";");
            }, '');
        });
    });
}
var $67cdcaf7a3d6c8e0$var$startsWith = function(text, prefix) {
    if (!(text === null || text === void 0 ? void 0 : text.startsWith(prefix))) return false;
    var nextChart = text[prefix.length];
    return nextChart >= 'A' && nextChart <= 'Z';
};
function $67cdcaf7a3d6c8e0$export$f38e4d4b23aef199(style, prefix, invert) {
    if (invert === void 0) invert = false;
    var result = {};
    Object.entries(style).forEach(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], value = _b[1];
        // never transfer class property
        if (key === 'className' || key === 'class') ;
        else if ($67cdcaf7a3d6c8e0$var$startsWith(key, 'show') && $67cdcaf7a3d6c8e0$var$startsWith((0, $kPuYL.removePrefix)(key, 'show'), prefix) !== invert) {
            if (key === (0, $kPuYL.addPrefix)(prefix, 'show')) result[key] = value;
            else result[key.replace(new RegExp((0, $kPuYL.toUppercaseFirstLetter)(prefix)), '')] = value;
        } else if (!$67cdcaf7a3d6c8e0$var$startsWith(key, 'show') && $67cdcaf7a3d6c8e0$var$startsWith(key, prefix) !== invert) {
            var name_1 = (0, $kPuYL.removePrefix)(key, prefix);
            // don't transfer filter if it represents “过滤器”
            if (name_1 === 'filter' && typeof value === 'function') ;
            else result[name_1] = value;
        }
    });
    return result;
}
function $67cdcaf7a3d6c8e0$export$d02e2f41ee79d54b(style, prefix) {
    return Object.entries(style).reduce(function(acc, _a) {
        var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], value = _b[1];
        if (key.startsWith('show')) acc["show".concat(prefix).concat(key.slice(4))] = value;
        else acc["".concat(prefix).concat((0, $kPuYL.toUppercaseFirstLetter)(key))] = value;
        return acc;
    }, {});
}
function $67cdcaf7a3d6c8e0$export$1b8b982f95931e75(style, ignoreStyleDict) {
    if (ignoreStyleDict === void 0) ignoreStyleDict = [
        'x',
        'y',
        'class',
        'className'
    ];
    var groupStyleDict = [
        'transform',
        'transformOrigin',
        'anchor',
        'visibility',
        'pointerEvents',
        'zIndex',
        'cursor',
        'clipPath',
        'clipPathTargets',
        'offsetPath',
        'offsetPathTargets',
        'offsetDistance',
        'draggable',
        'droppable'
    ];
    var output = {};
    var groupStyle = {};
    Object.entries(style).forEach(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], val = _b[1];
        if (ignoreStyleDict.includes(key)) ;
        else if (groupStyleDict.indexOf(key) !== -1) groupStyle[key] = val;
        else output[key] = val;
    });
    return [
        output,
        groupStyle
    ];
}

});
parcelRegister("kPuYL", function(module, exports) {

$parcel$export(module.exports, "toUppercaseFirstLetter", () => $f2a099d7e3609cfc$export$16e3d8ca06b20549);
$parcel$export(module.exports, "addPrefix", () => $f2a099d7e3609cfc$export$9748efee331ec573);
$parcel$export(module.exports, "removePrefix", () => $f2a099d7e3609cfc$export$f2888183a34644d4);
function $f2a099d7e3609cfc$export$16e3d8ca06b20549(string) {
    return string.toString().charAt(0).toUpperCase() + string.toString().slice(1);
}
function $f2a099d7e3609cfc$export$44ae0b6901f45389(string) {
    return string.toString().charAt(0).toLowerCase() + string.toString().slice(1);
}
function $f2a099d7e3609cfc$export$9748efee331ec573(string, prefix) {
    return "".concat(prefix).concat($f2a099d7e3609cfc$export$16e3d8ca06b20549(string));
}
function $f2a099d7e3609cfc$export$f2888183a34644d4(string, prefix, lowercaseFirstLetter) {
    var _a;
    if (lowercaseFirstLetter === void 0) lowercaseFirstLetter = true;
    var inferPrefix = prefix || ((_a = string.match(/^([a-z][a-z0-9]+)/)) === null || _a === void 0 ? void 0 : _a[0]) || '';
    var withoutPrefix = string.replace(new RegExp("^(".concat(inferPrefix, ")")), '');
    return lowercaseFirstLetter ? $f2a099d7e3609cfc$export$44ae0b6901f45389(withoutPrefix) : withoutPrefix;
}

});


parcelRegister("2IgUM", function(module, exports) {

$parcel$export(module.exports, "getBBox", () => $1f9ccfc415d743a4$export$9cafdf24ffa90680);
$parcel$export(module.exports, "Title", () => $1f9ccfc415d743a4$export$f99233281efd08a0);

var $7WQrb = parcelRequire("7WQrb");

var $e7n3C = parcelRequire("e7n3C");

var $7agTx = parcelRequire("7agTx");
var $1SiGY = parcelRequire("1SiGY");
var $aJozt = parcelRequire("aJozt");
var $11HCp = parcelRequire("11HCp");
var $le54I = parcelRequire("le54I");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $heTcj = parcelRequire("heTcj");

var $6GpDK = parcelRequire("6GpDK");
var $1f9ccfc415d743a4$var$CLASS_NAMES = (0, $1SiGY.classNames)({
    text: 'text'
}, 'title');
function $1f9ccfc415d743a4$export$9cafdf24ffa90680(title, content) {
    var _a = title.attributes, position = _a.position, spacing = _a.spacing, inset = _a.inset, text = _a.text;
    var titleBBox = title.getBBox();
    var contentBBox = content.getBBox();
    var pos = (0, $11HCp.parsePosition)(position);
    var _b = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(text ? spacing : 0), 4), spacingTop = _b[0], spacingRight = _b[1], spacingBottom = _b[2], spacingLeft = _b[3];
    var _c = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(inset), 4), insetTop = _c[0], insetRight = _c[1], insetBottom = _c[2], insetLeft = _c[3];
    var _d = (0, $7WQrb.__read)([
        spacingLeft + spacingRight,
        spacingTop + spacingBottom
    ], 2), spacingWidth = _d[0], spacingHeight = _d[1];
    var _e = (0, $7WQrb.__read)([
        insetLeft + insetRight,
        insetTop + insetBottom
    ], 2), insetWidth = _e[0], insetHeight = _e[1];
    // 只基于第一个 pos 进行判断
    // 如果在左边或者上边，直接包围盒相加再加上间距
    if (pos[0] === 'l') return new (0, $7agTx.BBox)(titleBBox.x, titleBBox.y, contentBBox.width + titleBBox.width + spacingWidth + insetWidth, Math.max(contentBBox.height + insetHeight, titleBBox.height));
    if (pos[0] === 't') return new (0, $7agTx.BBox)(titleBBox.x, titleBBox.y, Math.max(contentBBox.width + insetWidth, titleBBox.width), contentBBox.height + titleBBox.height + spacingHeight + insetHeight);
    // 如果在右边或者下边，基于 content.width, content.height 相加再加上间距
    var _f = (0, $7WQrb.__read)([
        content.attributes.width || contentBBox.width,
        content.attributes.height || contentBBox.height
    ], 2), contentWidth = _f[0], contentHeight = _f[1];
    return new (0, $7agTx.BBox)(contentBBox.x, contentBBox.y, contentWidth + titleBBox.width + spacingWidth + insetWidth, contentHeight + titleBBox.height + spacingHeight + insetHeight);
}
function $1f9ccfc415d743a4$var$mayApplyStyle(el, style) {
    var finalStyle = Object.entries(style).reduce(function(acc, _a) {
        var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], value = _b[1];
        var currAttr = el.node().attr(key);
        if (!currAttr) acc[key] = value;
        return acc;
    }, {});
    el.styles(finalStyle);
}
function $1f9ccfc415d743a4$var$getTitleLayout(cfg) {
    var _a, _b, _c, _d;
    var _e = cfg, width = _e.width, height = _e.height, position = _e.position;
    var _f = (0, $7WQrb.__read)([
        +width / 2,
        +height / 2
    ], 2), hW = _f[0], hH = _f[1];
    var _g = (0, $7WQrb.__read)([
        +hW,
        +hH,
        'center',
        'middle'
    ], 4), x = _g[0], y = _g[1], textAlign = _g[2], textBaseline = _g[3];
    var pos = (0, $11HCp.parsePosition)(position);
    if (pos.includes('l')) _a = (0, $7WQrb.__read)([
        0,
        'start'
    ], 2), x = _a[0], textAlign = _a[1];
    if (pos.includes('r')) _b = (0, $7WQrb.__read)([
        +width,
        'end'
    ], 2), x = _b[0], textAlign = _b[1];
    if (pos.includes('t')) _c = (0, $7WQrb.__read)([
        0,
        'top'
    ], 2), y = _c[0], textBaseline = _c[1];
    if (pos.includes('b')) _d = (0, $7WQrb.__read)([
        +height,
        'bottom'
    ], 2), y = _d[0], textBaseline = _d[1];
    return {
        x: x,
        y: y,
        textAlign: textAlign,
        textBaseline: textBaseline
    };
}
var $1f9ccfc415d743a4$export$f99233281efd08a0 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Title, _super);
    function Title(options) {
        return _super.call(this, options, {
            text: '',
            width: 0,
            height: 0,
            fill: '#4a505a',
            fontWeight: 'bold',
            fontSize: 12,
            fontFamily: 'sans-serif',
            inset: 0,
            spacing: 0,
            position: 'top-left'
        }) || this;
    }
    Title.prototype.getAvailableSpace = function() {
        var container = this;
        var _a = this.attributes, containerWidth = _a.width, containerHeight = _a.height, position = _a.position, spacing = _a.spacing, inset = _a.inset;
        var title = container.querySelector($1f9ccfc415d743a4$var$CLASS_NAMES.text.class);
        if (!title) return new (0, $7agTx.BBox)(0, 0, +containerWidth, +containerHeight);
        var _b = title.getBBox(), titleWidth = _b.width, titleHeight = _b.height;
        var _c = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(spacing), 4), spacingTop = _c[0], spacingRight = _c[1], spacingBottom = _c[2], spacingLeft = _c[3];
        var _d = (0, $7WQrb.__read)([
            0,
            0,
            +containerWidth,
            +containerHeight
        ], 4), x = _d[0], y = _d[1], width = _d[2], height = _d[3];
        var pos = (0, $11HCp.parsePosition)(position);
        if (pos.includes('i')) return new (0, $7agTx.BBox)(x, y, width, height);
        pos.forEach(function(p, i) {
            var _a, _b, _c, _d;
            if (p === 't') _a = (0, $7WQrb.__read)(i === 0 ? [
                titleHeight + spacingBottom,
                +containerHeight - titleHeight - spacingBottom
            ] : [
                0,
                +containerHeight
            ], 2), y = _a[0], height = _a[1];
            if (p === 'r') _b = (0, $7WQrb.__read)([
                +containerWidth - titleWidth - spacingLeft
            ], 1), width = _b[0];
            if (p === 'b') _c = (0, $7WQrb.__read)([
                +containerHeight - titleHeight - spacingTop
            ], 1), height = _c[0];
            if (p === 'l') _d = (0, $7WQrb.__read)(i === 0 ? [
                titleWidth + spacingRight,
                +containerWidth - titleWidth - spacingRight
            ] : [
                0,
                +containerWidth
            ], 2), x = _d[0], width = _d[1];
        });
        var _e = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(inset), 4), insetTop = _e[0], insetRight = _e[1], insetBottom = _e[2], insetLeft = _e[3];
        var _f = (0, $7WQrb.__read)([
            insetLeft + insetRight,
            insetTop + insetBottom
        ], 2), insetWidth = _f[0], insetHeight = _f[1];
        return new (0, $7agTx.BBox)(x + insetLeft, y + insetTop, width - insetWidth, height - insetHeight);
    };
    Title.prototype.getBBox = function() {
        if (this.title) return this.title.getBBox();
        return new (0, $7agTx.BBox)(0, 0, 0, 0);
    };
    Title.prototype.render = function(attributes, container) {
        var _this = this;
        var width = attributes.width, height = attributes.height, position = attributes.position, spacing = attributes.spacing, classNamePrefix = attributes.classNamePrefix, restStyle = (0, $7WQrb.__rest)(attributes, [
            "width",
            "height",
            "position",
            "spacing",
            "classNamePrefix"
        ]);
        var _a = (0, $7WQrb.__read)((0, $8UxPj.splitStyle)(restStyle), 1), titleStyle = _a[0];
        var _b = $1f9ccfc415d743a4$var$getTitleLayout(attributes), x = _b.x, y = _b.y, textAlign = _b.textAlign, textBaseline = _b.textBaseline;
        (0, $aJozt.ifShow)(!!restStyle.text, (0, $bCy7Q.select)(container), function(group) {
            var titleClassName = (0, $heTcj.getLegendClassName)($1f9ccfc415d743a4$var$CLASS_NAMES.text.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).title, classNamePrefix);
            _this.title = group.maybeAppendByClassName($1f9ccfc415d743a4$var$CLASS_NAMES.text, 'text').attr('className', titleClassName).styles(titleStyle).call($1f9ccfc415d743a4$var$mayApplyStyle, {
                x: x,
                y: y,
                textAlign: textAlign,
                textBaseline: textBaseline
            }).node();
        });
    };
    return Title;
}((0, $e7n3C.Component));

});
parcelRegister("1SiGY", function(module, exports) {

$parcel$export(module.exports, "classNames", () => $15d95575de8662e1$export$ce4ab0c55987d1ff);

var $7WQrb = parcelRequire("7WQrb");
var $15d95575de8662e1$export$ce4ab0c55987d1ff = function(cls, prefix) {
    var PREFIX = function(str) {
        return "".concat(prefix, "-").concat(str);
    };
    var obj = Object.fromEntries(Object.entries(cls).map(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), k = _b[0], v = _b[1];
        var name = PREFIX(v);
        return [
            k,
            {
                name: name,
                class: ".".concat(name),
                id: "#".concat(name),
                toString: function() {
                    return name;
                }
            }
        ];
    }));
    Object.assign(obj, {
        prefix: PREFIX
    });
    return obj;
};

});

parcelRegister("aJozt", function(module, exports) {

$parcel$export(module.exports, "ifShow", () => $7d012aa8b6d99964$export$e64fd2022921d7b1);
function $7d012aa8b6d99964$export$e64fd2022921d7b1(show, container, creator, removeChildren, removeHandler) {
    if (removeChildren === void 0) removeChildren = true;
    if (removeHandler === void 0) removeHandler = function(g) {
        g.node().removeChildren();
    };
    if (show) return creator(container);
    if (removeChildren) removeHandler(container);
    return null;
}

});

parcelRegister("11HCp", function(module, exports) {

$parcel$export(module.exports, "parsePosition", () => $0bf7b82be683e737$export$16d1640ef8464a10);
/**
 * @example
 * lt -> ['l', 't']
 * left-top -> ['l', 't']
 * inner -> i
 */ function $0bf7b82be683e737$export$16d1640ef8464a10(position) {
    if (!/\S+-\S+/g.test(position)) return position.length > 2 ? [
        position[0]
    ] : position.split('');
    return position.split('-').map(function(str) {
        return str[0];
    });
}

});

parcelRegister("le54I", function(module, exports) {

$parcel$export(module.exports, "parseSeriesAttr", () => $f73ed78f050cad67$export$b54eecece019ea44);

var $1uF5a = parcelRequire("1uF5a");
var $jyI49 = parcelRequire("jyI49");
function $f73ed78f050cad67$export$b54eecece019ea44(series) {
    if ((0, $jyI49.default)(series)) return [
        series,
        series,
        series,
        series
    ];
    if ((0, $1uF5a.default)(series)) {
        var len = series.length;
        if (len === 1) return [
            series[0],
            series[0],
            series[0],
            series[0]
        ];
        if (len === 2) return [
            series[0],
            series[1],
            series[0],
            series[1]
        ];
        if (len === 3) return [
            series[0],
            series[1],
            series[2],
            series[1]
        ];
        if (len === 4) return series;
    }
    return [
        0,
        0,
        0,
        0
    ];
}

});

parcelRegister("heTcj", function(module, exports) {

$parcel$export(module.exports, "getLegendClassName", () => $c8ce8f96e8648bba$export$640a27982e0faa7a);
/**
 * Legend className utility functions
 */ /**
 * Generate legend className with optional prefix
 * @param baseClassName - Base className, e.g., 'title-text'
 * @param suffix - Suffix for prefixed className, e.g., 'title' -> '{prefix}legend-title'
 * @param classNamePrefix - Optional className prefix, e.g., 'g2-'
 * @returns Complete className, e.g., 'title-text g2-legend-title'
 *
 * @example
 * getLegendClassName('title-text', 'title', 'g2-')
 * // Returns: 'title-text g2-legend-title'
 */ function $c8ce8f96e8648bba$export$640a27982e0faa7a(baseClassName, suffix, classNamePrefix) {
    if (!classNamePrefix) return baseClassName;
    return "".concat(baseClassName, " ").concat(classNamePrefix, "legend-").concat(suffix);
}
function $c8ce8f96e8648bba$export$e11d365bafb9ea37(attributes, baseClassName, suffix) {
    var _a = attributes.classNamePrefix, classNamePrefix = _a === void 0 ? '' : _a;
    return $c8ce8f96e8648bba$export$640a27982e0faa7a(baseClassName.name, suffix, classNamePrefix);
}

});

parcelRegister("6GpDK", function(module, exports) {

$parcel$export(module.exports, "CLASSNAME_SUFFIX_MAP", () => $4dda8de47852173c$export$bd9266606cea9ca1);
/**
 * className suffix mapping for legend elements
 * Used to generate prefixed classNames, e.g., classNamePrefix='g2-' generates 'g2-legend-{suffix}'
 *
 * @example
 * import { CLASSNAME_SUFFIX_MAP, getLegendClassName } from './utils';
 *
 * const titleClassName = getLegendClassName(
 *   CLASS_NAMES.text.name,
 *   CLASSNAME_SUFFIX_MAP.title,
 *   'g2-'
 * );
 * // Returns: 'title-text g2-legend-title'
 */ var $4dda8de47852173c$export$bd9266606cea9ca1 = {
    // Common elements
    title: 'title',
    // Category legend elements
    item: 'item',
    marker: 'marker',
    label: 'label',
    value: 'value',
    focusIcon: 'focus-icon',
    background: 'background',
    // Continuous legend elements
    ribbon: 'ribbon',
    track: 'track',
    selection: 'selection',
    handle: 'handle',
    handleMarker: 'handle-marker',
    handleLabel: 'handle-label',
    indicator: 'indicator',
    // Navigator elements (reserved)
    prevBtn: 'prev-btn',
    nextBtn: 'next-btn',
    pageInfo: 'page-info'
};

});


parcelRegister("caSBp", function(module, exports) {

$parcel$export(module.exports, "CategoryItems", () => $8dd0c61c166e7d5b$export$d6714fb3cf798183);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $hXz41 = parcelRequire("hXz41");
var $5vprq = parcelRequire("5vprq");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $1SiGY = parcelRequire("1SiGY");
var $6LvUc = parcelRequire("6LvUc");
var $pzxZu = parcelRequire("pzxZu");
var $hBSL0 = parcelRequire("hBSL0");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $lsO0n = parcelRequire("lsO0n");

var $ljupB = parcelRequire("ljupB");

var $7Ap9w = parcelRequire("7Ap9w");

var $heTcj = parcelRequire("heTcj");

var $6GpDK = parcelRequire("6GpDK");
var $8dd0c61c166e7d5b$var$CLASS_NAMES = (0, $1SiGY.classNames)({
    page: 'item-page',
    navigator: 'navigator',
    item: 'item'
}, 'items');
/**
 * if value exists, it need to follow rule, otherwise, return default value
 * @param value
 * @param rule
 * @param defaultValue
 * @returns
 */ var $8dd0c61c166e7d5b$var$ifSatisfied = function(value, rule, defaultValue) {
    if (defaultValue === void 0) defaultValue = true;
    if (value) return rule(value);
    return defaultValue;
};
var $8dd0c61c166e7d5b$export$d6714fb3cf798183 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(CategoryItems, _super);
    function CategoryItems(options) {
        var _this = _super.call(this, options, {
            data: [],
            gridRow: Infinity,
            gridCol: undefined,
            padding: 0,
            width: 1000,
            height: 100,
            rowPadding: 0,
            colPadding: 0,
            layout: 'flex',
            orientation: 'horizontal',
            click: (0, $hXz41.default),
            mouseenter: (0, $hXz41.default),
            mouseleave: (0, $hXz41.default)
        }) || this;
        _this.navigatorShape = [
            0,
            0
        ];
        return _this;
    }
    Object.defineProperty(CategoryItems.prototype, "pageViews", {
        get: function() {
            return this.navigator.getContainer();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CategoryItems.prototype, "grid", {
        get: function() {
            var _a = this.attributes, gridRow = _a.gridRow, gridCol = _a.gridCol, data = _a.data;
            if (!gridRow && !gridCol) throw new Error('gridRow and gridCol can not be set null at the same time');
            if (!!gridRow && !!gridCol) return [
                gridRow,
                gridCol
            ];
            if (gridRow) return [
                gridRow,
                data.length
            ];
            return [
                data.length,
                gridCol
            ]; // !!gridCol
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CategoryItems.prototype, "renderData", {
        get: function() {
            var _a = this.attributes, data = _a.data, layout = _a.layout, poptip = _a.poptip, focus = _a.focus, focusMarkerSize = _a.focusMarkerSize, classNamePrefix = _a.classNamePrefix;
            var style = (0, $8UxPj.subStyleProps)(this.attributes, 'item');
            var d = data.map(function(datum, index) {
                var _a = datum.id, id = _a === void 0 ? index : _a, labelText = datum.label, valueText = datum.value;
                return {
                    id: "".concat(id),
                    index: index,
                    style: (0, $7WQrb.__assign)({
                        layout: layout,
                        labelText: labelText,
                        valueText: valueText,
                        poptip: poptip,
                        focus: focus,
                        focusMarkerSize: focusMarkerSize,
                        classNamePrefix: classNamePrefix
                    }, Object.fromEntries(Object.entries(style).map(function(_a) {
                        var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], val = _b[1];
                        return [
                            key,
                            (0, $pzxZu.getCallbackValue)(val, [
                                datum,
                                index,
                                data
                            ])
                        ];
                    })))
                };
            });
            return d;
        },
        enumerable: false,
        configurable: true
    });
    CategoryItems.prototype.getGridLayout = function() {
        var _this = this;
        var _a = this.attributes, orientation = _a.orientation, width = _a.width, rowPadding = _a.rowPadding, colPadding = _a.colPadding;
        var _b = (0, $7WQrb.__read)(this.navigatorShape, 1), navWidth = _b[0];
        var _c = (0, $7WQrb.__read)(this.grid, 2), gridRow = _c[0], gridCol = _c[1];
        var pageSize = gridCol * gridRow;
        var prevOffset = 0;
        return this.pageViews.children.map(function(item, index) {
            var _a, _b;
            // calc page, row and column
            var page = Math.floor(index / pageSize);
            var pageIndex = index % pageSize;
            var dir = _this.ifHorizontal(gridCol, gridRow);
            var pos = [
                Math.floor(pageIndex / dir),
                pageIndex % dir
            ];
            if (orientation === 'vertical') pos.reverse();
            var _c = (0, $7WQrb.__read)(pos, 2), row = _c[0], col = _c[1];
            // calc x, y and shape
            var colWidth = (width - navWidth - (gridCol - 1) * colPadding) / gridCol;
            // const rowHeight = getRenderBBox(item).height;
            var rowHeight = item.getBBox().height;
            var _d = (0, $7WQrb.__read)([
                0,
                0
            ], 2), x = _d[0], y = _d[1];
            if (orientation === 'horizontal') {
                _a = (0, $7WQrb.__read)([
                    prevOffset,
                    row * (rowHeight + rowPadding)
                ], 2), x = _a[0], y = _a[1];
                prevOffset = col === gridCol - 1 ? 0 : prevOffset + colWidth + colPadding;
            } else {
                _b = (0, $7WQrb.__read)([
                    col * (colWidth + colPadding),
                    prevOffset
                ], 2), x = _b[0], y = _b[1];
                prevOffset = row === gridRow - 1 ? 0 : prevOffset + rowHeight + rowPadding;
            }
            return {
                page: page,
                index: index,
                row: row,
                col: col,
                pageIndex: pageIndex,
                width: colWidth,
                height: rowHeight,
                x: x,
                y: y
            };
        });
    };
    CategoryItems.prototype.getFlexLayout = function() {
        var _a = this.attributes, maxWidth = _a.width, maxHeight = _a.height, rowPadding = _a.rowPadding, cP = _a.colPadding;
        var _b = (0, $7WQrb.__read)(this.navigatorShape, 1), navWidth = _b[0];
        var _c = (0, $7WQrb.__read)(this.grid, 2), gridRow = _c[0], gridCol = _c[1];
        var _d = (0, $7WQrb.__read)([
            maxWidth - navWidth,
            maxHeight
        ], 2), limitWidth = _d[0], limitHeight = _d[1];
        var _e = (0, $7WQrb.__read)([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], 8), x = _e[0], y = _e[1], page = _e[2], pageIndex = _e[3], col = _e[4], row = _e[5], prevWidth = _e[6], prevHeight = _e[7];
        return this.pageViews.children.map(function(item, index) {
            var _a, _b, _c, _d;
            // const { width, height } = getRenderBBox(item);
            var _e = item.getBBox(), width = _e.width, height = _e.height;
            var colPadding = prevWidth === 0 ? 0 : cP;
            // assume that every item has the same height
            var nextWidth = prevWidth + colPadding + width;
            // inline
            if (nextWidth <= limitWidth && $8dd0c61c166e7d5b$var$ifSatisfied(col, function(c) {
                return c < gridCol;
            })) {
                _a = (0, $7WQrb.__read)([
                    prevWidth + colPadding,
                    prevHeight,
                    nextWidth
                ], 3), x = _a[0], y = _a[1], prevWidth = _a[2];
                return {
                    width: width,
                    height: height,
                    x: x,
                    y: y,
                    page: page,
                    index: index,
                    pageIndex: pageIndex++,
                    row: row,
                    col: col++
                };
            }
            // wrap
            _b = (0, $7WQrb.__read)([
                row + 1,
                0,
                0,
                prevHeight + height + rowPadding
            ], 4), row = _b[0], col = _b[1], prevWidth = _b[2], prevHeight = _b[3];
            var nextHeight = prevHeight + height;
            if (nextHeight <= limitHeight && $8dd0c61c166e7d5b$var$ifSatisfied(row, function(r) {
                return r < gridRow;
            })) {
                _c = (0, $7WQrb.__read)([
                    prevWidth,
                    prevHeight,
                    width
                ], 3), x = _c[0], y = _c[1], prevWidth = _c[2];
                return {
                    width: width,
                    height: height,
                    x: x,
                    y: y,
                    page: page,
                    index: index,
                    pageIndex: pageIndex++,
                    row: row,
                    col: col++
                };
            }
            // paging
            _d = (0, $7WQrb.__read)([
                0,
                0,
                width,
                0,
                page + 1,
                0,
                0,
                0
            ], 8), x = _d[0], y = _d[1], prevWidth = _d[2], prevHeight = _d[3], page = _d[4], pageIndex = _d[5], row = _d[6], col = _d[7];
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                page: page,
                index: index,
                pageIndex: pageIndex++,
                row: row,
                col: col++
            };
        });
    };
    Object.defineProperty(CategoryItems.prototype, "itemsLayout", {
        get: function() {
            this.navigatorShape = [
                0,
                0
            ];
            var cb = this.attributes.layout === 'grid' ? this.getGridLayout : this.getFlexLayout;
            var layout = cb.call(this);
            // re layout
            if (layout.slice(-1)[0].page > 0) {
                this.navigatorShape = [
                    55,
                    0
                ];
                return cb.call(this);
            }
            return layout;
        },
        enumerable: false,
        configurable: true
    });
    CategoryItems.prototype.ifHorizontal = function(a, b) {
        var orientation = this.attributes.orientation;
        return (0, $ljupB.ifHorizontal)(orientation, a, b);
    };
    CategoryItems.prototype.flattenPage = function(container) {
        container.querySelectorAll($8dd0c61c166e7d5b$var$CLASS_NAMES.item.class).forEach(function(item) {
            container.appendChild(item);
        });
        container.querySelectorAll($8dd0c61c166e7d5b$var$CLASS_NAMES.page.class).forEach(function(page) {
            var removedPage = container.removeChild(page);
            removedPage.destroy();
        });
    };
    CategoryItems.prototype.renderItems = function(container) {
        var _a = this.attributes, click = _a.click, mouseenter = _a.mouseenter, mouseleave = _a.mouseleave, classNamePrefix = _a.classNamePrefix;
        this.flattenPage(container);
        var dispatchCustomEvent = this.dispatchCustomEvent.bind(this);
        var itemClassName = (0, $heTcj.getLegendClassName)($8dd0c61c166e7d5b$var$CLASS_NAMES.item.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).item, classNamePrefix);
        (0, $bCy7Q.select)(container).selectAll($8dd0c61c166e7d5b$var$CLASS_NAMES.item.class).data(this.renderData, function(d) {
            return d.id;
        }).join(function(enter) {
            return enter.append(function(_a) {
                var style = _a.style, rest = (0, $7WQrb.__rest)(_a, [
                    "style"
                ]);
                return new (0, $7Ap9w.CategoryItem)({
                    style: style
                }, rest);
            }).attr('className', itemClassName).on('click', function() {
                click === null || click === void 0 || click(this);
                dispatchCustomEvent('itemClick', {
                    item: this
                });
            }).on('pointerenter', function() {
                mouseenter === null || mouseenter === void 0 || mouseenter(this);
                dispatchCustomEvent('itemMouseenter', {
                    item: this
                });
            }).on('pointerleave', function() {
                mouseleave === null || mouseleave === void 0 || mouseleave(this);
                dispatchCustomEvent('itemMouseleave', {
                    item: this
                });
            });
        }, function(update) {
            return update.each(function(_a) {
                var style = _a.style;
                this.update(style);
            });
        }, function(exit) {
            return exit.remove();
        });
    };
    CategoryItems.prototype.relayoutNavigator = function() {
        var _a;
        var _b = this.attributes, layout = _b.layout, width = _b.width;
        var height = ((_a = this.pageViews.children[0]) === null || _a === void 0 ? void 0 : _a.getBBox().height) || 0;
        var _c = (0, $7WQrb.__read)(this.navigatorShape, 2), navWidth = _c[0], navHeight = _c[1];
        this.navigator.update(layout === 'grid' ? {
            pageWidth: width - navWidth,
            pageHeight: height - navHeight
        } : {});
    };
    CategoryItems.prototype.adjustLayout = function() {
        var _this = this;
        var itemsLayouts = Object.entries((0, $hBSL0.groupBy)(this.itemsLayout, 'page')).map(function(_a) {
            var _b = (0, $7WQrb.__read)(_a, 2), page = _b[0], layouts = _b[1];
            return {
                page: page,
                layouts: layouts
            };
        });
        var categoryItems = (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(this.navigator.getContainer().children), false);
        itemsLayouts.forEach(function(_a) {
            var layouts = _a.layouts;
            var page = _this.pageViews.appendChild(new (0, $2eDEB.Group)({
                className: $8dd0c61c166e7d5b$var$CLASS_NAMES.page.name
            }));
            layouts.forEach(function(layout) {
                var x = layout.x, y = layout.y, index = layout.index, width = layout.width, height = layout.height;
                var item = categoryItems[index];
                // @ts-ignore
                page.appendChild(item);
                (0, $5vprq.default)(item, '__layout__', layout);
                item.update({
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            });
        });
        this.relayoutNavigator();
    };
    CategoryItems.prototype.renderNavigator = function(container) {
        var _a = this.attributes, orientation = _a.orientation, classNamePrefix = _a.classNamePrefix;
        var navStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'nav');
        var style = (0, $6LvUc.deepAssign)({
            orientation: orientation,
            classNamePrefix: classNamePrefix
        }, navStyle);
        var that = this;
        container.selectAll($8dd0c61c166e7d5b$var$CLASS_NAMES.navigator.class).data([
            'nav'
        ]).join(function(enter) {
            return enter.append(function() {
                return new (0, $lsO0n.Navigator)({
                    style: style
                });
            }).attr('className', $8dd0c61c166e7d5b$var$CLASS_NAMES.navigator.name).each(function() {
                that.navigator = this;
            });
        }, function(update) {
            return update.each(function() {
                this.update(style);
            });
        }, function(exit) {
            return exit.remove();
        });
        return this.navigator;
    };
    CategoryItems.prototype.getBBox = function() {
        return this.navigator.getBBox();
    };
    CategoryItems.prototype.render = function(attributes, container) {
        var data = this.attributes.data;
        if (!data || data.length === 0) return;
        /**
         * 1. render items
         * 2. paging
         * 3. layout
         */ var navigator = this.renderNavigator((0, $bCy7Q.select)(container));
        this.renderItems(navigator.getContainer());
        this.adjustLayout();
    };
    CategoryItems.prototype.dispatchCustomEvent = function(type, payload) {
        var evt = new (0, $2eDEB.CustomEvent)(type, {
            detail: payload
        });
        this.dispatchEvent(evt);
    };
    return CategoryItems;
}((0, $e7n3C.Component));

});
parcelRegister("hXz41", function(module, exports) {

$parcel$export(module.exports, "default", () => $d133255341d07d32$export$2e2bcd8739ae039);
var $d133255341d07d32$export$2e2bcd8739ae039 = function() {};

});

parcelRegister("pzxZu", function(module, exports) {

$parcel$export(module.exports, "getCallbackValue", () => $04cde8dae4f9558a$export$6f9019edd08b2944);

var $7WQrb = parcelRequire("7WQrb");

var $ky7aH = parcelRequire("ky7aH");
function $04cde8dae4f9558a$export$6f9019edd08b2944(value, params) {
    return (0, $ky7aH.default)(value) ? value.apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(params), false)) : value;
}

});

parcelRegister("hBSL0", function(module, exports) {

$parcel$export(module.exports, "groupBy", () => $cd205e0116ee71a2$export$3f063810d7bf01bd);
function $cd205e0116ee71a2$export$3f063810d7bf01bd(source, by) {
    return source.reduce(function(acc, curr) {
        (acc[curr[by]] = acc[curr[by]] || []).push(curr);
        return acc;
    }, {});
}

});

parcelRegister("lsO0n", function(module, exports) {

$parcel$export(module.exports, "Navigator", () => $fa03007d48eb0766$export$c894e24133a9bea);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $8hhuV = parcelRequire("8hhuV");
var $2ZmO4 = parcelRequire("2ZmO4");

var $bhYrQ = parcelRequire("bhYrQ");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $7agTx = parcelRequire("7agTx");
var $1SiGY = parcelRequire("1SiGY");
var $2gch2 = parcelRequire("2gch2");
var $9JcvC = parcelRequire("9JcvC");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");
var $1yRJ1 = parcelRequire("1yRJ1");

var $1qM54 = parcelRequire("1qM54");

var $6GpDK = parcelRequire("6GpDK");

var $heTcj = parcelRequire("heTcj");
var $fa03007d48eb0766$var$CLASS_NAMES = (0, $1SiGY.classNames)({
    prevBtnGroup: 'prev-btn-group',
    prevBtn: 'prev-btn',
    nextBtnGroup: 'next-btn-group',
    nextBtn: 'next-btn',
    pageInfoGroup: 'page-info-group',
    pageInfo: 'page-info',
    playWindow: 'play-window',
    contentGroup: 'content-group',
    controller: 'controller',
    clipPath: 'clip-path'
}, 'navigator');
var $fa03007d48eb0766$export$c894e24133a9bea = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Navigator, _super);
    function Navigator(options) {
        var _this = _super.call(this, options, {
            x: 0,
            y: 0,
            animate: {
                easing: 'linear',
                duration: 200,
                fill: 'both'
            },
            buttonCursor: 'pointer',
            buttonFill: 'black',
            buttonD: (0, $1qM54.button)(0, 0, 6),
            buttonSize: 12,
            controllerPadding: 5,
            controllerSpacing: 5,
            formatter: function(curr, total) {
                return "".concat(curr, "/").concat(total);
            },
            defaultPage: 0,
            loop: false,
            orientation: 'horizontal',
            pageNumFill: 'black',
            pageNumFontSize: 12,
            pageNumTextAlign: 'start',
            pageNumTextBaseline: 'middle'
        }) || this;
        _this.playState = 'idle';
        _this.contentGroup = _this.appendChild(new (0, $2eDEB.Group)({
            class: $fa03007d48eb0766$var$CLASS_NAMES.contentGroup.name
        }));
        _this.playWindow = _this.contentGroup.appendChild(new (0, $2eDEB.Group)({
            class: $fa03007d48eb0766$var$CLASS_NAMES.playWindow.name
        }));
        _this.innerCurrPage = _this.defaultPage;
        return _this;
    }
    Object.defineProperty(Navigator.prototype, "defaultPage", {
        get: function() {
            var defaultPage = this.attributes.defaultPage;
            return (0, $8hhuV.default)(defaultPage, 0, Math.max(this.pageViews.length - 1, 0));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Navigator.prototype, "pageViews", {
        get: function() {
            return this.playWindow.children;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Navigator.prototype, "controllerShape", {
        // todo fixme
        get: function() {
            return this.totalPages > 1 ? {
                width: 55,
                height: 0
            } : {
                width: 0,
                height: 0
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Navigator.prototype, "pageShape", {
        get: function() {
            var pageViews = this.pageViews;
            var _a = (0, $7WQrb.__read)((0, $1yRJ1.transpose)(pageViews.map(function(pageView) {
                var _a = pageView.getBBox(), width = _a.width, height = _a.height;
                return [
                    width,
                    height
                ];
            })).map(function(arr) {
                return Math.max.apply(Math, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(arr), false));
            }), 2), maxWidth = _a[0], maxHeight = _a[1];
            var _b = this.attributes, _c = _b.pageWidth, pageWidth = _c === void 0 ? maxWidth : _c, _d = _b.pageHeight, pageHeight = _d === void 0 ? maxHeight : _d;
            return {
                pageWidth: pageWidth,
                pageHeight: pageHeight
            };
        },
        enumerable: false,
        configurable: true
    });
    Navigator.prototype.getContainer = function() {
        return this.playWindow;
    };
    Object.defineProperty(Navigator.prototype, "totalPages", {
        get: function() {
            return this.pageViews.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Navigator.prototype, "currPage", {
        get: function() {
            return this.innerCurrPage;
        },
        enumerable: false,
        configurable: true
    });
    Navigator.prototype.getBBox = function() {
        var _a = _super.prototype.getBBox.call(this), x = _a.x, y = _a.y;
        var controllerShape = this.controllerShape;
        var _b = this.pageShape, pageWidth = _b.pageWidth, pageHeight = _b.pageHeight;
        return new (0, $7agTx.BBox)(x, y, pageWidth + controllerShape.width, pageHeight);
    };
    Navigator.prototype.goTo = function(pageNum) {
        var _this = this;
        var animateOptions = this.attributes.animate;
        var _a = this, currPage = _a.currPage, playState = _a.playState, playWindow = _a.playWindow, pageViews = _a.pageViews;
        if (playState !== 'idle' || pageNum < 0 || pageViews.length <= 0 || pageNum >= pageViews.length) return null;
        pageViews[currPage].setLocalPosition(0, 0);
        this.prepareFollowingPage(pageNum);
        var _b = (0, $7WQrb.__read)(this.getFollowingPageDiff(pageNum), 2), dx = _b[0], dy = _b[1];
        this.playState = 'running';
        var animation = (0, $bhYrQ.animate)(playWindow, [
            {
                transform: "translate(0, 0)"
            },
            {
                transform: "translate(".concat(-dx, ", ").concat(-dy, ")")
            }
        ], animateOptions);
        (0, $bhYrQ.onAnimateFinished)(animation, function() {
            _this.innerCurrPage = pageNum;
            _this.playState = 'idle';
            _this.setVisiblePages([
                pageNum
            ]);
            _this.updatePageInfo();
        });
        return animation;
    };
    Navigator.prototype.prev = function() {
        var loop = this.attributes.loop;
        var pages = this.pageViews.length;
        var page = this.currPage;
        if (!loop && page <= 0) return null;
        var following = loop ? (page - 1 + pages) % pages : (0, $8hhuV.default)(page - 1, 0, pages);
        return this.goTo(following);
    };
    Navigator.prototype.next = function() {
        var loop = this.attributes.loop;
        var pages = this.pageViews.length;
        var page = this.currPage;
        if (!loop && page >= pages - 1) return null;
        var following = loop ? (page + 1) % pages : (0, $8hhuV.default)(page + 1, 0, pages);
        return this.goTo(following);
    };
    Navigator.prototype.renderClipPath = function(container) {
        var _a = this.pageShape, pageWidth = _a.pageWidth, pageHeight = _a.pageHeight;
        if (!pageWidth || !pageHeight) {
            this.contentGroup.style.clipPath = undefined;
            return;
        }
        this.clipPath = container.maybeAppendByClassName($fa03007d48eb0766$var$CLASS_NAMES.clipPath, 'rect').styles({
            width: pageWidth,
            height: pageHeight
        });
        this.contentGroup.attr('clipPath', this.clipPath.node());
    };
    Navigator.prototype.setVisiblePages = function(pages) {
        this.playWindow.children.forEach(function(page, index) {
            if (pages.includes(index)) (0, $2gch2.show)(page);
            else (0, $2gch2.hide)(page);
        });
    };
    Navigator.prototype.adjustControllerLayout = function() {
        var _a = this, prevBtn = _a.prevBtnGroup, nextBtn = _a.nextBtnGroup, pageNum = _a.pageInfoGroup;
        var _b = this.attributes, orientation = _b.orientation, padding = _b.controllerPadding;
        var _c = pageNum.getBBox(), pW = _c.width, pH = _c.height;
        var _d = (0, $7WQrb.__read)(orientation === 'horizontal' ? [
            -180,
            0
        ] : [
            -90,
            90
        ], 2), r1 = _d[0], r2 = _d[1];
        prevBtn.setLocalEulerAngles(r1);
        nextBtn.setLocalEulerAngles(r2);
        var _e = prevBtn.getBBox(), bpW = _e.width, bpH = _e.height;
        var _f = nextBtn.getBBox(), bnW = _f.width, bnH = _f.height;
        var maxWidth = Math.max(bpW, pW, bnW);
        var _g = orientation === 'horizontal' ? {
            offset: [
                [
                    0,
                    0
                ],
                [
                    bpW / 2 + padding,
                    0
                ],
                [
                    bpW + pW + padding * 2,
                    0
                ]
            ],
            textAlign: 'start'
        } : {
            offset: [
                [
                    maxWidth / 2,
                    -bpH - padding
                ],
                [
                    maxWidth / 2,
                    0
                ],
                [
                    maxWidth / 2,
                    bnH + padding
                ]
            ],
            textAlign: 'center'
        }, _h = (0, $7WQrb.__read)(_g.offset, 3), _j = (0, $7WQrb.__read)(_h[0], 2), o1x = _j[0], o1y = _j[1], _k = (0, $7WQrb.__read)(_h[1], 2), o2x = _k[0], o2y = _k[1], _l = (0, $7WQrb.__read)(_h[2], 2), o3x = _l[0], o3y = _l[1], textAlign = _g.textAlign;
        var pageNumText = pageNum.querySelector('text');
        pageNumText && (pageNumText.style.textAlign = textAlign);
        prevBtn.setLocalPosition(o1x, o1y);
        pageNum.setLocalPosition(o2x, o2y);
        nextBtn.setLocalPosition(o3x, o3y);
    };
    Navigator.prototype.updatePageInfo = function() {
        var _a;
        var _b = this, currPage = _b.currPage, pageViews = _b.pageViews, formatter = _b.attributes.formatter;
        if (pageViews.length < 2) return;
        (_a = this.pageInfoGroup.querySelector($fa03007d48eb0766$var$CLASS_NAMES.pageInfo.class)) === null || _a === void 0 || _a.attr('text', formatter(currPage + 1, pageViews.length));
        this.adjustControllerLayout();
    };
    Navigator.prototype.getFollowingPageDiff = function(pageNum) {
        var currPage = this.currPage;
        if (currPage === pageNum) return [
            0,
            0
        ];
        var orientation = this.attributes.orientation;
        var _a = this.pageShape, pageWidth = _a.pageWidth, pageHeight = _a.pageHeight;
        var sign = pageNum < currPage ? -1 : 1;
        return orientation === 'horizontal' ? [
            sign * pageWidth,
            0
        ] : [
            0,
            sign * pageHeight
        ];
    };
    Navigator.prototype.prepareFollowingPage = function(pageNum) {
        var _a = this, currPage = _a.currPage, pageViews = _a.pageViews;
        this.setVisiblePages([
            pageNum,
            currPage
        ]);
        if (pageNum !== currPage) {
            var _b = (0, $7WQrb.__read)(this.getFollowingPageDiff(pageNum), 2), dx = _b[0], dy = _b[1];
            pageViews[pageNum].setLocalPosition(dx, dy);
        }
    };
    Navigator.prototype.renderController = function(container) {
        var _this = this;
        var _a = this.attributes, spacing = _a.controllerSpacing, _b = _a.classNamePrefix, classNamePrefix = _b === void 0 ? '' : _b;
        var _c = this.pageShape, pageWidth = _c.pageWidth, pageHeight = _c.pageHeight;
        var visible = this.pageViews.length >= 2;
        var group = container.maybeAppendByClassName($fa03007d48eb0766$var$CLASS_NAMES.controller, 'g');
        (0, $2gch2.visibility)(group.node(), visible);
        if (!visible) return;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'button');
        var textStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'pageNum');
        var _d = (0, $7WQrb.__read)((0, $8UxPj.splitStyle)(style), 2), _e = _d[0], groupStyle = _d[1], size = _e.size, pathStyle = (0, $7WQrb.__rest)(_e, [
            "size"
        ]);
        var whetherToAddEventListener = !group.select($fa03007d48eb0766$var$CLASS_NAMES.prevBtnGroup.class).node();
        var prevBtnGroup = group.maybeAppendByClassName($fa03007d48eb0766$var$CLASS_NAMES.prevBtnGroup, 'g').styles(groupStyle);
        this.prevBtnGroup = prevBtnGroup.node();
        var prevBtn = prevBtnGroup.maybeAppendByClassName($fa03007d48eb0766$var$CLASS_NAMES.prevBtn, 'path');
        if (classNamePrefix) {
            var prevBtnClassName = (0, $heTcj.getLegendClassName)($fa03007d48eb0766$var$CLASS_NAMES.prevBtn.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).prevBtn, classNamePrefix);
            prevBtn.node().setAttribute('class', prevBtnClassName);
        }
        var nextBtnGroup = group.maybeAppendByClassName($fa03007d48eb0766$var$CLASS_NAMES.nextBtnGroup, 'g').styles(groupStyle);
        this.nextBtnGroup = nextBtnGroup.node();
        var nextBtn = nextBtnGroup.maybeAppendByClassName($fa03007d48eb0766$var$CLASS_NAMES.nextBtn, 'path');
        if (classNamePrefix) {
            var nextBtnClassName = (0, $heTcj.getLegendClassName)($fa03007d48eb0766$var$CLASS_NAMES.nextBtn.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).nextBtn, classNamePrefix);
            nextBtn.node().setAttribute('class', nextBtnClassName);
        }
        [
            prevBtn,
            nextBtn
        ].forEach(function(btn) {
            btn.styles((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, pathStyle), {
                transformOrigin: 'center'
            }));
            (0, $9JcvC.scaleToPixel)(btn.node(), size, true);
        });
        var pageInfoGroup = group.maybeAppendByClassName($fa03007d48eb0766$var$CLASS_NAMES.pageInfoGroup, 'g');
        this.pageInfoGroup = pageInfoGroup.node();
        var pageInfoElement = pageInfoGroup.maybeAppendByClassName($fa03007d48eb0766$var$CLASS_NAMES.pageInfo, 'text');
        pageInfoElement.styles(textStyle);
        if (classNamePrefix) {
            var pageInfoClassName = (0, $heTcj.getLegendClassName)($fa03007d48eb0766$var$CLASS_NAMES.pageInfo.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).pageInfo, classNamePrefix);
            pageInfoElement.node().setAttribute('class', pageInfoClassName);
        }
        this.updatePageInfo();
        // group.node().style.transform = `translate(${pageWidth + spacing}, ${pageHeight / 2})`;
        // put it on the right side of the container
        group.node().setLocalPosition(pageWidth + spacing, pageHeight / 2);
        if (whetherToAddEventListener) {
            this.prevBtnGroup.addEventListener('click', function() {
                _this.prev();
            });
            this.nextBtnGroup.addEventListener('click', function() {
                _this.next();
            });
        }
    };
    Navigator.prototype.render = function(attributes, container) {
        var _a = attributes.x, x = _a === void 0 ? 0 : _a, _b = attributes.y, y = _b === void 0 ? 0 : _b;
        this.attr('transform', "translate(".concat(x, ", ").concat(y, ")"));
        /**
         * container
         *  |- contentGroup (with clip path)
         *    |- playWindow (with animation)
         *      |- pages
         *  |- clipPath
         */ var containerSelection = (0, $bCy7Q.select)(container);
        this.renderClipPath(containerSelection);
        this.renderController(containerSelection);
        this.setVisiblePages([
            this.defaultPage
        ]);
        this.goTo(this.defaultPage);
    };
    Navigator.prototype.bindEvents = function() {
        var _this = this;
        var render = (0, $2ZmO4.default)(function() {
            return _this.render(_this.attributes, _this);
        }, 50);
        this.playWindow.addEventListener((0, $2eDEB.ElementEvent).INSERTED, render);
        this.playWindow.addEventListener((0, $2eDEB.ElementEvent).REMOVED, render);
    };
    return Navigator;
}((0, $e7n3C.Component));

});
parcelRegister("bhYrQ", function(module, exports) {

$parcel$export(module.exports, "parseAnimationOption", () => $83802bfd3e3452cb$export$4ef8b8254528bea4);
$parcel$export(module.exports, "onAnimateFinished", () => $83802bfd3e3452cb$export$a92bf4641625a9d6);
$parcel$export(module.exports, "onAnimatesFinished", () => $83802bfd3e3452cb$export$e332a1c57be32d76);
$parcel$export(module.exports, "animate", () => $83802bfd3e3452cb$export$e3607ec2d7a891c4);
$parcel$export(module.exports, "transitionShape", () => $83802bfd3e3452cb$export$fe2303876b4ad3cb);
$parcel$export(module.exports, "transition", () => $83802bfd3e3452cb$export$66bb15e2994e6a26);

var $7WQrb = parcelRequire("7WQrb");

var $geZBG = parcelRequire("geZBG");

var $2gch2 = parcelRequire("2gch2");
function $83802bfd3e3452cb$var$isStandardAnimationOption(option) {
    if (typeof option === 'boolean') return false;
    return 'enter' in option && 'update' in option && 'exit' in option;
}
function $83802bfd3e3452cb$export$4ef8b8254528bea4(option) {
    // option is false => all animation is false
    // option is { enter: {}, update: {}, exit: {}, ...baseOption } =>
    //    { enter: { ...enter, ...baseOption }, update: { ...update, ...baseOption }, exit: { ...exit, ...baseOption } }
    // option is { enter: {}, update: {}, exit: {} } => option
    if (!option) return {
        enter: false,
        update: false,
        exit: false
    };
    var keys = [
        'enter',
        'update',
        'exit'
    ];
    var baseOption = Object.fromEntries(Object.entries(option).filter(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 1), k = _b[0];
        return !keys.includes(k);
    }));
    return Object.fromEntries(keys.map(function(k) {
        if ($83802bfd3e3452cb$var$isStandardAnimationOption(option)) {
            if (option[k] === false) return [
                k,
                false
            ];
            return [
                k,
                (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, option[k]), baseOption)
            ];
        }
        return [
            k,
            baseOption
        ];
    }));
}
function $83802bfd3e3452cb$export$a92bf4641625a9d6(animation, callback) {
    if (!animation) callback();
    else animation.finished.then(callback);
}
function $83802bfd3e3452cb$export$e332a1c57be32d76(animations, callback) {
    if (animations.length === 0) callback();
    else Promise.all(animations.map(function(a) {
        return a === null || a === void 0 ? void 0 : a.finished;
    })).then(callback);
}
function $83802bfd3e3452cb$var$attr(target, value) {
    if ('update' in target) target.update(value);
    else target.attr(value);
}
function $83802bfd3e3452cb$export$e3607ec2d7a891c4(target, keyframes, options) {
    if (keyframes.length === 0) return null;
    if (!options) {
        var state = keyframes.slice(-1)[0];
        $83802bfd3e3452cb$var$attr(target, {
            style: state
        });
        return null;
    }
    return target.animate(keyframes, options);
}
function $83802bfd3e3452cb$var$identicalTextNode(source, target) {
    if (source.nodeName !== 'text' || target.nodeName !== 'text') return false;
    if (source.attributes.text !== target.attributes.text) return false;
    return true;
}
function $83802bfd3e3452cb$export$fe2303876b4ad3cb(source, target, options, after) {
    if (after === void 0) after = 'destroy';
    // If source and target are both text node and with same text,
    // do not apply shape animation.
    if ($83802bfd3e3452cb$var$identicalTextNode(source, target)) {
        source.remove();
        return [
            null
        ];
    }
    var afterTransition = function() {
        if (after === 'destroy') source.destroy();
        else if (after === 'hide') (0, $2gch2.hide)(source);
        if (target.isVisible()) (0, $2gch2.show)(target);
    };
    if (!options) {
        afterTransition();
        return [
            null
        ];
    }
    var _a = options.duration, duration = _a === void 0 ? 0 : _a, _b = options.delay, delay = _b === void 0 ? 0 : _b;
    var middle = Math.ceil(+duration / 2);
    var offset = +duration / 4;
    var _c = (0, $7WQrb.__read)(source.getGeometryBounds().center, 2), sx = _c[0], sy = _c[1];
    var _d = (0, $7WQrb.__read)(target.getGeometryBounds().center, 2), ex = _d[0], ey = _d[1];
    var _e = (0, $7WQrb.__read)([
        (sx + ex) / 2 - sx,
        (sy + ey) / 2 - sy
    ], 2), mx = _e[0], my = _e[1];
    var _f = source.style.opacity, so = _f === void 0 ? 1 : _f;
    var _g = target.style.opacity, to = _g === void 0 ? 1 : _g;
    var st = source.style.transform || '';
    var tt = target.style.transform || '';
    // const st = source.style._transform || '';
    // const tt = target.style._transform || '';
    var sourceAnimation = source.animate([
        {
            opacity: so,
            transform: "translate(0, 0) ".concat(st)
        },
        {
            opacity: 0,
            transform: "translate(".concat(mx, ", ").concat(my, ") ").concat(st)
        }
    ], (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
        fill: 'both'
    }, options), {
        duration: delay + middle + offset
    }));
    var targetAnimation = target.animate([
        {
            opacity: 0,
            transform: "translate(".concat(-mx, ", ").concat(-my, ") ").concat(tt),
            offset: 0.01
        },
        {
            opacity: to,
            transform: "translate(0, 0) ".concat(tt)
        }
    ], (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
        fill: 'both'
    }, options), {
        duration: middle + offset,
        delay: delay + middle - offset
    }));
    $83802bfd3e3452cb$export$a92bf4641625a9d6(targetAnimation, afterTransition);
    return [
        sourceAnimation,
        targetAnimation
    ];
}
function $83802bfd3e3452cb$export$66bb15e2994e6a26(target, state, options) {
    var from = {};
    var to = {};
    Object.entries(state).forEach(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], tarStyle = _b[1];
        if (!(0, $geZBG.default)(tarStyle)) {
            // 关闭 CSS 解析后，attr / getAttribute 只能获取到用户显式传入的属性，此时可以
            // 获取解析值，如果仍获取不到（例如 x/y），则使用 0 作为默认值
            var currStyle = target.style[key] || target.parsedStyle[key] || 0; // x/y
            if (currStyle !== tarStyle) {
                from[key] = currStyle;
                to[key] = tarStyle;
            }
        }
    });
    if (!options) {
        $83802bfd3e3452cb$var$attr(target, to);
        return null;
    }
    return $83802bfd3e3452cb$export$e3607ec2d7a891c4(target, [
        from,
        to
    ], (0, $7WQrb.__assign)({
        fill: 'both'
    }, options));
}

});

parcelRegister("9JcvC", function(module, exports) {

$parcel$export(module.exports, "scaleToPixel", () => $71520511521763dc$export$ee38b54958fef074);
/**
 * scale a shape to a given size
 */ function $71520511521763dc$export$ee38b54958fef074(el, size, applyScale) {
    if (applyScale === void 0) applyScale = false;
    var _a = el.getBBox(), width = _a.width, height = _a.height;
    var scale = size / Math.max(width, height);
    if (applyScale) el.style.transform = "scale(".concat(scale, ")");
    return scale;
}

});

parcelRegister("1yRJ1", function(module, exports) {

$parcel$export(module.exports, "transpose", () => $1232a41c604010e3$export$9cb09a71b7d66923);
function $1232a41c604010e3$export$9cb09a71b7d66923(m) {
    var _a;
    return ((_a = m[0]) === null || _a === void 0 ? void 0 : _a.map(function(x, i) {
        return m.map(function(x) {
            return x[i];
        });
    })) || [];
}

});

parcelRegister("1qM54", function(module, exports) {

$parcel$export(module.exports, "circle", () => $10ad8404f8cccd1f$export$e1d786d2f707b414);
$parcel$export(module.exports, "point", () => $10ad8404f8cccd1f$export$105684a3041cb6f3);
$parcel$export(module.exports, "square", () => $10ad8404f8cccd1f$export$dd4f28cef696bc7d);
$parcel$export(module.exports, "diamond", () => $10ad8404f8cccd1f$export$bc2a8782c99449da);
$parcel$export(module.exports, "triangle", () => $10ad8404f8cccd1f$export$9eed783d03e0135c);
$parcel$export(module.exports, "triangleDown", () => $10ad8404f8cccd1f$export$78873ef66b647b0f);
$parcel$export(module.exports, "hexagon", () => $10ad8404f8cccd1f$export$578abc0d25ff055c);
$parcel$export(module.exports, "bowtie", () => $10ad8404f8cccd1f$export$4e0cab437d8bd837);
$parcel$export(module.exports, "line", () => $10ad8404f8cccd1f$export$53f1d5ea8de3d7c);
$parcel$export(module.exports, "cross", () => $10ad8404f8cccd1f$export$bb646b20bb93d339);
$parcel$export(module.exports, "tick", () => $10ad8404f8cccd1f$export$55d7f61db91b7b70);
$parcel$export(module.exports, "plus", () => $10ad8404f8cccd1f$export$f25d54de1f4102d2);
$parcel$export(module.exports, "hyphen", () => $10ad8404f8cccd1f$export$2a80451517ee8334);
$parcel$export(module.exports, "dot", () => $10ad8404f8cccd1f$export$94132a0e348806d4);
$parcel$export(module.exports, "dash", () => $10ad8404f8cccd1f$export$eb03490a10c3abc9);
$parcel$export(module.exports, "smooth", () => $10ad8404f8cccd1f$export$3ab94c50cd824f15);
$parcel$export(module.exports, "hv", () => $10ad8404f8cccd1f$export$1529212a7bc5f169);
$parcel$export(module.exports, "vh", () => $10ad8404f8cccd1f$export$f91e8c45a95a32f2);
$parcel$export(module.exports, "hvh", () => $10ad8404f8cccd1f$export$7dd105b8ff305419);
$parcel$export(module.exports, "vhv", () => $10ad8404f8cccd1f$export$1b894645d39a39b9);
$parcel$export(module.exports, "button", () => $10ad8404f8cccd1f$export$2ba01fb71ed41cb6);
$parcel$export(module.exports, "focus", () => $10ad8404f8cccd1f$export$d7ddd398f22d79ef);
/**
 * ○
 */ var $10ad8404f8cccd1f$export$e1d786d2f707b414 = function(x, y, r) {
    return [
        [
            'M',
            x - r,
            y
        ],
        [
            'A',
            r,
            r,
            0,
            1,
            0,
            x + r,
            y
        ],
        [
            'A',
            r,
            r,
            0,
            1,
            0,
            x - r,
            y
        ],
        [
            'Z'
        ]
    ];
};
var $10ad8404f8cccd1f$export$105684a3041cb6f3 = $10ad8404f8cccd1f$export$e1d786d2f707b414;
var $10ad8404f8cccd1f$export$dd4f28cef696bc7d = function(x, y, r) {
    return [
        [
            'M',
            x - r,
            y - r
        ],
        [
            'L',
            x + r,
            y - r
        ],
        [
            'L',
            x + r,
            y + r
        ],
        [
            'L',
            x - r,
            y + r
        ],
        [
            'Z'
        ]
    ];
};
var $10ad8404f8cccd1f$export$bc2a8782c99449da = function(x, y, r) {
    return [
        [
            'M',
            x - r,
            y
        ],
        [
            'L',
            x,
            y - r
        ],
        [
            'L',
            x + r,
            y
        ],
        [
            'L',
            x,
            y + r
        ],
        [
            'Z'
        ]
    ];
};
var $10ad8404f8cccd1f$export$9eed783d03e0135c = function(x, y, r) {
    var diffY = r * Math.sin(1 / 3 * Math.PI);
    return [
        [
            'M',
            x - r,
            y + diffY
        ],
        [
            'L',
            x,
            y - diffY
        ],
        [
            'L',
            x + r,
            y + diffY
        ],
        [
            'Z'
        ]
    ];
};
var $10ad8404f8cccd1f$export$78873ef66b647b0f = function(x, y, r) {
    var diffY = r * Math.sin(1 / 3 * Math.PI);
    return [
        [
            'M',
            x - r,
            y - diffY
        ],
        [
            'L',
            x + r,
            y - diffY
        ],
        [
            'L',
            x,
            y + diffY
        ],
        [
            'Z'
        ]
    ];
};
var $10ad8404f8cccd1f$export$578abc0d25ff055c = function(x, y, r) {
    var diffX = r / 2 * Math.sqrt(3);
    return [
        [
            'M',
            x,
            y - r
        ],
        [
            'L',
            x + diffX,
            y - r / 2
        ],
        [
            'L',
            x + diffX,
            y + r / 2
        ],
        [
            'L',
            x,
            y + r
        ],
        [
            'L',
            x - diffX,
            y + r / 2
        ],
        [
            'L',
            x - diffX,
            y - r / 2
        ],
        [
            'Z'
        ]
    ];
};
var $10ad8404f8cccd1f$export$4e0cab437d8bd837 = function(x, y, r) {
    var diffY = r - 1.5;
    return [
        [
            'M',
            x - r,
            y - diffY
        ],
        [
            'L',
            x + r,
            y + diffY
        ],
        [
            'L',
            x + r,
            y - diffY
        ],
        [
            'L',
            x - r,
            y + diffY
        ],
        [
            'Z'
        ]
    ];
};
var $10ad8404f8cccd1f$export$53f1d5ea8de3d7c = function(x, y, r) {
    return [
        [
            'M',
            x,
            y + r
        ],
        [
            'L',
            x,
            y - r
        ]
    ];
};
var $10ad8404f8cccd1f$export$bb646b20bb93d339 = function(x, y, r) {
    return [
        [
            'M',
            x - r,
            y - r
        ],
        [
            'L',
            x + r,
            y + r
        ],
        [
            'M',
            x + r,
            y - r
        ],
        [
            'L',
            x - r,
            y + r
        ]
    ];
};
var $10ad8404f8cccd1f$export$55d7f61db91b7b70 = function(x, y, r) {
    return [
        [
            'M',
            x - r / 2,
            y - r
        ],
        [
            'L',
            x + r / 2,
            y - r
        ],
        [
            'M',
            x,
            y - r
        ],
        [
            'L',
            x,
            y + r
        ],
        [
            'M',
            x - r / 2,
            y + r
        ],
        [
            'L',
            x + r / 2,
            y + r
        ]
    ];
};
var $10ad8404f8cccd1f$export$f25d54de1f4102d2 = function(x, y, r) {
    return [
        [
            'M',
            x - r,
            y
        ],
        [
            'L',
            x + r,
            y
        ],
        [
            'M',
            x,
            y - r
        ],
        [
            'L',
            x,
            y + r
        ]
    ];
};
var $10ad8404f8cccd1f$export$2a80451517ee8334 = function(x, y, r) {
    return [
        [
            'M',
            x - r,
            y
        ],
        [
            'L',
            x + r,
            y
        ]
    ];
};
var $10ad8404f8cccd1f$export$94132a0e348806d4 = function(x, y, r) {
    return [
        [
            'M',
            x - r,
            y
        ],
        [
            'L',
            x + r,
            y
        ]
    ];
};
var $10ad8404f8cccd1f$export$eb03490a10c3abc9 = $10ad8404f8cccd1f$export$94132a0e348806d4;
var $10ad8404f8cccd1f$export$3ab94c50cd824f15 = function(x, y, r) {
    return [
        [
            'M',
            x - r,
            y
        ],
        [
            'A',
            r / 2,
            r / 2,
            0,
            1,
            1,
            x,
            y
        ],
        [
            'A',
            r / 2,
            r / 2,
            0,
            1,
            0,
            x + r,
            y
        ]
    ];
};
var $10ad8404f8cccd1f$export$1529212a7bc5f169 = function(x, y, r) {
    return [
        [
            'M',
            x - r - 1,
            y - 2.5
        ],
        [
            'L',
            x,
            y - 2.5
        ],
        [
            'L',
            x,
            y + 2.5
        ],
        [
            'L',
            x + r + 1,
            y + 2.5
        ]
    ];
};
var $10ad8404f8cccd1f$export$f91e8c45a95a32f2 = function(x, y, r) {
    return [
        [
            'M',
            x - r - 1,
            y + 2.5
        ],
        [
            'L',
            x,
            y + 2.5
        ],
        [
            'L',
            x,
            y - 2.5
        ],
        [
            'L',
            x + r + 1,
            y - 2.5
        ]
    ];
};
var $10ad8404f8cccd1f$export$7dd105b8ff305419 = function(x, y, r) {
    return [
        [
            'M',
            x - (r + 1),
            y + 2.5
        ],
        [
            'L',
            x - r / 2,
            y + 2.5
        ],
        [
            'L',
            x - r / 2,
            y - 2.5
        ],
        [
            'L',
            x + r / 2,
            y - 2.5
        ],
        [
            'L',
            x + r / 2,
            y + 2.5
        ],
        [
            'L',
            x + r + 1,
            y + 2.5
        ]
    ];
};
function $10ad8404f8cccd1f$export$1b894645d39a39b9(x, y) {
    // 宽 13px，高 8px
    return [
        [
            'M',
            x - 5,
            y + 2.5
        ],
        [
            'L',
            x - 5,
            y
        ],
        [
            'L',
            x,
            y
        ],
        [
            'L',
            x,
            y - 3
        ],
        [
            'L',
            x,
            y + 3
        ],
        [
            'L',
            x + 6.5,
            y + 3
        ]
    ];
}
var $10ad8404f8cccd1f$export$2ba01fb71ed41cb6 = function(x, y, r) {
    return [
        [
            'M',
            x - r,
            y - r
        ],
        [
            'L',
            x + r,
            y
        ],
        [
            'L',
            x - r,
            y + r
        ],
        [
            'Z'
        ]
    ];
};
var $10ad8404f8cccd1f$export$d7ddd398f22d79ef = function(x, y, r) {
    var outerRadius = r;
    var innerRadius = r * 0.2;
    var crossLength = r * 0.7;
    return [
        // 外圆
        [
            'M',
            x - outerRadius,
            y
        ],
        [
            'A',
            outerRadius,
            outerRadius,
            0,
            1,
            0,
            x + outerRadius,
            y
        ],
        [
            'A',
            outerRadius,
            outerRadius,
            0,
            1,
            0,
            x - outerRadius,
            y
        ],
        [
            'Z'
        ],
        // 水平十字线 (简单线条)
        [
            'M',
            x - crossLength,
            y
        ],
        [
            'L',
            x - innerRadius,
            y
        ],
        [
            'M',
            x + innerRadius,
            y
        ],
        [
            'L',
            x + crossLength,
            y
        ],
        // 垂直十字线 (简单线条)
        [
            'M',
            x,
            y - crossLength
        ],
        [
            'L',
            x,
            y - innerRadius
        ],
        [
            'M',
            x,
            y + innerRadius
        ],
        [
            'L',
            x,
            y + crossLength
        ]
    ];
};

});


parcelRegister("ljupB", function(module, exports) {

$parcel$export(module.exports, "ifHorizontal", () => $f842f67ed2fd4e16$export$3350ebc5b99692d1);

var $7WQrb = parcelRequire("7WQrb");

var $hj9tl = parcelRequire("hj9tl");
function $f842f67ed2fd4e16$export$f1e91a39bdb0bd64(value, step, min) {
    var count = Math.round((value - min) / step);
    return min + count * step;
}
function $f842f67ed2fd4e16$export$9c705812e145f494(x, y, r) {
    // 长宽比
    var ratio = 1.4;
    var diffY = ratio * r;
    return [
        [
            'M',
            x - r,
            y - diffY
        ],
        [
            'L',
            x + r,
            y - diffY
        ],
        [
            'L',
            x + r,
            y + diffY
        ],
        [
            'L',
            x - r,
            y + diffY
        ],
        [
            'Z'
        ]
    ];
}
// 控制手柄
var $f842f67ed2fd4e16$var$HANDLE_HEIGHT_RATIO = 1.4;
var $f842f67ed2fd4e16$var$HANDLE_TRIANGLE_RATIO = 0.4;
function $f842f67ed2fd4e16$export$16825b4140080dee(x, y, r) {
    var width = r;
    var height = width * $f842f67ed2fd4e16$var$HANDLE_HEIGHT_RATIO;
    var halfWidth = width / 2;
    var oneSixthWidth = width / 6;
    var triangleX = x + height * $f842f67ed2fd4e16$var$HANDLE_TRIANGLE_RATIO;
    return [
        [
            'M',
            x,
            y
        ],
        [
            'L',
            triangleX,
            y + halfWidth
        ],
        [
            'L',
            x + height,
            y + halfWidth
        ],
        [
            'L',
            x + height,
            y - halfWidth
        ],
        [
            'L',
            triangleX,
            y - halfWidth
        ],
        [
            'Z'
        ],
        // 绘制两条横线
        [
            'M',
            triangleX,
            y + oneSixthWidth
        ],
        [
            'L',
            x + height - 2,
            y + oneSixthWidth
        ],
        [
            'M',
            triangleX,
            y - oneSixthWidth
        ],
        [
            'L',
            x + height - 2,
            y - oneSixthWidth
        ]
    ];
}
function $f842f67ed2fd4e16$export$91278cff27f7e132(x, y, r) {
    var width = r;
    var height = width * $f842f67ed2fd4e16$var$HANDLE_HEIGHT_RATIO;
    var halfWidth = width / 2;
    var oneSixthWidth = width / 6;
    var triangleY = y + height * $f842f67ed2fd4e16$var$HANDLE_TRIANGLE_RATIO;
    return [
        [
            'M',
            x,
            y
        ],
        [
            'L',
            x - halfWidth,
            triangleY
        ],
        [
            'L',
            x - halfWidth,
            y + height
        ],
        [
            'L',
            x + halfWidth,
            y + height
        ],
        [
            'L',
            x + halfWidth,
            triangleY
        ],
        [
            'Z'
        ],
        // 绘制两条竖线
        [
            'M',
            x - oneSixthWidth,
            triangleY
        ],
        [
            'L',
            x - oneSixthWidth,
            y + height - 2
        ],
        [
            'M',
            x + oneSixthWidth,
            triangleY
        ],
        [
            'L',
            x + oneSixthWidth,
            y + height - 2
        ]
    ];
}
(0, $hj9tl.Marker).registerSymbol('hiddenHandle', $f842f67ed2fd4e16$export$9c705812e145f494);
(0, $hj9tl.Marker).registerSymbol('verticalHandle', $f842f67ed2fd4e16$export$16825b4140080dee);
(0, $hj9tl.Marker).registerSymbol('horizontalHandle', $f842f67ed2fd4e16$export$91278cff27f7e132);
var $f842f67ed2fd4e16$export$666b95d6ca61610b = function(orientation, a, b) {
    if (orientation === void 0) orientation = 'horizontal';
    return orientation === 'horizontal' ? a : b;
};
function $f842f67ed2fd4e16$export$4b47eaba612179f9(domain, newSelection, oldSelection, precision) {
    var _a;
    if (precision === void 0) precision = 4;
    var _b = (0, $7WQrb.__read)(domain, 2), min = _b[0], max = _b[1];
    var _c = (0, $7WQrb.__read)(newSelection, 2), start = _c[0], end = _c[1];
    var _d = (0, $7WQrb.__read)(oldSelection, 2), prevStart = _d[0], prevEnd = _d[1];
    var _e = (0, $7WQrb.__read)([
        start,
        end
    ], 2), startVal = _e[0], endVal = _e[1];
    var range = endVal - startVal;
    // 交换startVal endVal
    if (startVal > endVal) _a = (0, $7WQrb.__read)([
        endVal,
        startVal
    ], 2), startVal = _a[0], endVal = _a[1];
    // 超出范围就全选
    if (range > max - min) return [
        min,
        max
    ];
    if (startVal < min) {
        if (prevStart === min && prevEnd === endVal) return [
            min,
            endVal
        ];
        return [
            min,
            range + min
        ];
    }
    if (endVal > max) {
        if (prevEnd === max && prevStart === startVal) return [
            startVal,
            max
        ];
        return [
            max - range,
            max
        ];
    }
    // 保留小数
    return [
        startVal,
        endVal
    ];
}
function $f842f67ed2fd4e16$export$3350ebc5b99692d1(orientation, a, b) {
    if (orientation === void 0) orientation = 'horizontal';
    return orientation === 'horizontal' ? a : b;
}

});
parcelRegister("hj9tl", function(module, exports) {

$parcel$export(module.exports, "Marker", () => $c99b8efeb1d2c9e0$export$e98856a975cab58e);

var $7WQrb = parcelRequire("7WQrb");

var $ky7aH = parcelRequire("ky7aH");

var $e7n3C = parcelRequire("e7n3C");

var $aJozt = parcelRequire("aJozt");
var $bCy7Q = parcelRequire("bCy7Q");

var $1qM54 = parcelRequire("1qM54");

var $jyCav = parcelRequire("jyCav");
function $c99b8efeb1d2c9e0$var$getType(symbol) {
    var markerType = (0, $jyCav.parseMarker)(symbol);
    if ([
        'base64',
        'url',
        'image'
    ].includes(markerType)) return 'image';
    if (symbol && markerType === 'symbol') return 'path';
    return null;
}
var $c99b8efeb1d2c9e0$export$e98856a975cab58e = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Marker, _super);
    function Marker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Marker.prototype.render = function(attributes, container) {
        var _a = attributes.x, x = _a === void 0 ? 0 : _a, _b = attributes.y, y = _b === void 0 ? 0 : _b;
        var _c = this.getSubShapeStyle(attributes), symbol = _c.symbol, _d = _c.size, size = _d === void 0 ? 16 : _d, style = (0, $7WQrb.__rest)(_c, [
            "symbol",
            "size"
        ]);
        var type = $c99b8efeb1d2c9e0$var$getType(symbol);
        (0, $aJozt.ifShow)(!!type, (0, $bCy7Q.select)(container), function(group) {
            group.maybeAppendByClassName("marker", type).attr('className', "marker ".concat(type, "-marker")).call(function(selection) {
                if (type === 'image') {
                    // todo 大小和 path symbol 保持一致
                    var r = size * 2;
                    selection.styles({
                        img: symbol,
                        width: r,
                        height: r,
                        x: x - size,
                        y: y - size
                    });
                } else {
                    var r = size / 2;
                    var symbolFn = (0, $ky7aH.default)(symbol) ? symbol : Marker.getSymbol(symbol);
                    selection.styles((0, $7WQrb.__assign)({
                        d: symbolFn === null || symbolFn === void 0 ? void 0 : symbolFn(x, y, r)
                    }, style));
                }
            });
        });
    };
    Marker.MARKER_SYMBOL_MAP = new Map();
    /**
     * 注册 icon 类型
     * @param type
     * @param path
     */ Marker.registerSymbol = function(type, symbol) {
        Marker.MARKER_SYMBOL_MAP.set(type, symbol);
    };
    /**
     * 获取已经注册的 icon 的 path
     */ Marker.getSymbol = function(type) {
        return Marker.MARKER_SYMBOL_MAP.get(type);
    };
    /**
     * @returns 获取已经注册的 icon 的类型
     */ Marker.getSymbols = function() {
        return Array.from(Marker.MARKER_SYMBOL_MAP.keys());
    };
    return Marker;
}((0, $e7n3C.Component));
/** Shapes for Point Geometry */ $c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('cross', (0, $1qM54.cross));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('hyphen', (0, $1qM54.hyphen));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('line', (0, $1qM54.line));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('plus', (0, $1qM54.plus));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('tick', (0, $1qM54.tick));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('circle', (0, $1qM54.circle));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('point', (0, $1qM54.point));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('bowtie', (0, $1qM54.bowtie));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('hexagon', (0, $1qM54.hexagon));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('square', (0, $1qM54.square));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('diamond', (0, $1qM54.diamond));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('triangle', (0, $1qM54.triangle));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('triangle-down', (0, $1qM54.triangleDown));
/** LineSymbols */ $c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('line', (0, $1qM54.line));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('dot', (0, $1qM54.dot));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('dash', (0, $1qM54.dash));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('smooth', (0, $1qM54.smooth));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('hv', (0, $1qM54.hv));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('vh', (0, $1qM54.vh));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('hvh', (0, $1qM54.hvh));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('vhv', (0, $1qM54.vhv));
$c99b8efeb1d2c9e0$export$e98856a975cab58e.registerSymbol('focus', (0, $1qM54.focus));

});
parcelRegister("jyCav", function(module, exports) {

$parcel$export(module.exports, "parseMarker", () => $e3ceccbcacfadc2c$export$1d3696c478d68206);

var $ky7aH = parcelRequire("ky7aH");
var $6JKSc = parcelRequire("6JKSc");
var $kVcyu = parcelRequire("kVcyu");
function $e3ceccbcacfadc2c$export$1d3696c478d68206(icon) {
    var type = 'default';
    if ((0, $6JKSc.default)(icon) && icon instanceof Image) type = 'image';
    else if ((0, $ky7aH.default)(icon)) type = 'symbol';
    else if ((0, $kVcyu.default)(icon)) {
        var dataURLsPattern = new RegExp('data:(image|text)');
        if (icon.match(dataURLsPattern)) type = 'base64';
        else if (/^(https?:\/\/(([a-zA-Z0-9]+-?)+[a-zA-Z0-9]+\.)+[a-zA-Z]+)(:\d+)?(\/.*)?(\?.*)?(#.*)?$/.test(icon)) type = 'url';
        else // 不然就当作symbol string 处理
        type = 'symbol';
    }
    return type;
}

});



parcelRegister("7Ap9w", function(module, exports) {

$parcel$export(module.exports, "CategoryItem", () => $585f67f8993c6376$export$41d1d7fbacf843);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $aFcWQ = parcelRequire("aFcWQ");

var $hj9tl = parcelRequire("hj9tl");

var $e7n3C = parcelRequire("e7n3C");

var $1SiGY = parcelRequire("1SiGY");
var $3tYe7 = parcelRequire("3tYe7");
var $6LvUc = parcelRequire("6LvUc");
var $0gesb = parcelRequire("0gesb");
var $aJozt = parcelRequire("aJozt");
var $le54I = parcelRequire("le54I");
var $i1HPZ = parcelRequire("i1HPZ");
var $9JcvC = parcelRequire("9JcvC");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $jtyct = parcelRequire("jtyct");

var $heTcj = parcelRequire("heTcj");

var $6GpDK = parcelRequire("6GpDK");
var $585f67f8993c6376$var$CLASS_NAMES = (0, $1SiGY.classNames)({
    layout: 'flex',
    markerGroup: 'marker-group',
    marker: 'marker',
    labelGroup: 'label-group',
    label: 'label',
    valueGroup: 'value-group',
    focusGroup: 'focus-group',
    focus: 'focus',
    value: 'value',
    backgroundGroup: 'background-group',
    background: 'background'
}, 'legend-category-item');
var $585f67f8993c6376$var$DEFAULT_POPTIP_PROPS = {
    offset: [
        0,
        20
    ],
    domStyles: {
        '.component-poptip': {
            opacity: '1',
            padding: '8px 12px',
            background: '#fff',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'
        },
        '.component-poptip-arrow': {
            display: 'none'
        },
        '.component-poptip-text': {
            color: '#000',
            lineHeight: '20px'
        }
    }
};
function $585f67f8993c6376$var$styleOfMarker(group) {
    var marker = group.querySelector($585f67f8993c6376$var$CLASS_NAMES.marker.class);
    if (marker) return marker.style;
    return {};
}
var $585f67f8993c6376$export$41d1d7fbacf843 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(CategoryItem, _super);
    function CategoryItem(options, keyFields) {
        var _this = _super.call(this, options, {
            span: [
                1,
                1
            ],
            marker: function() {
                return new (0, $2eDEB.Circle)({
                    style: {
                        r: 6
                    }
                });
            },
            markerSize: 10,
            labelFill: '#646464',
            valueFill: '#646464',
            labelFontSize: 12,
            valueFontSize: 12,
            labelTextBaseline: 'middle',
            valueTextBaseline: 'middle'
        }) || this;
        // Key fields, used to pass extra info like id, index for poptip rendering
        _this.keyFields = {};
        _this.keyFields = keyFields || {};
        return _this;
    }
    Object.defineProperty(CategoryItem.prototype, "showValue", {
        get: function() {
            var valueText = this.attributes.valueText;
            if (!valueText) return false;
            if (typeof valueText === 'string' || typeof valueText === 'number') return valueText !== '';
            if (typeof valueText === 'function') return true;
            return valueText.attr('text') !== '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CategoryItem.prototype, "actualSpace", {
        get: function() {
            var label = this.labelGroup;
            var value = this.valueGroup;
            var _a = this.attributes, markerSize = _a.markerSize, focus = _a.focus, focusMarkerSize = _a.focusMarkerSize;
            var _b = label.node().getBBox(), labelWidth = _b.width, labelHeight = _b.height;
            var _c = value.node().getBBox(), valueWidth = _c.width, valueHeight = _c.height;
            var focusWidth = focus ? focusMarkerSize !== null && focusMarkerSize !== void 0 ? focusMarkerSize : 12 : 0;
            return {
                markerWidth: markerSize,
                labelWidth: labelWidth,
                valueWidth: valueWidth,
                focusWidth: focusWidth,
                height: Math.max(markerSize, labelHeight, valueHeight)
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CategoryItem.prototype, "span", {
        get: function() {
            var span = this.attributes.span;
            if (!span) return [
                1,
                1
            ];
            var _a = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(span), 2), span1 = _a[0], innerSpan = _a[1];
            var span2 = this.showValue ? innerSpan : 0;
            var basis = span1 + span2;
            return [
                span1 / basis,
                span2 / basis
            ];
        },
        enumerable: false,
        configurable: true
    });
    CategoryItem.prototype.setAttribute = function(n, v) {
        _super.prototype.setAttribute.call(this, n, v);
    };
    Object.defineProperty(CategoryItem.prototype, "shape", {
        get: function() {
            var _a;
            var _b = this.attributes, markerSize = _b.markerSize, fullWidth = _b.width;
            var actualSpace = this.actualSpace;
            var markerWidth = actualSpace.markerWidth, focusWidth = actualSpace.focusWidth, height = actualSpace.height;
            var _c = this.actualSpace, labelWidth = _c.labelWidth, valueWidth = _c.valueWidth;
            var _d = (0, $7WQrb.__read)(this.spacing, 3), spacing1 = _d[0], spacing2 = _d[1], spacing3 = _d[2];
            if (fullWidth) {
                var width_1 = fullWidth - markerSize - spacing1 - spacing2 - focusWidth - spacing3;
                var _e = (0, $7WQrb.__read)(this.span, 2), span1 = _e[0], span2 = _e[1];
                _a = (0, $7WQrb.__read)([
                    span1 * width_1,
                    span2 * width_1
                ], 2), labelWidth = _a[0], valueWidth = _a[1];
            }
            var width = markerWidth + labelWidth + valueWidth + spacing1 + spacing2 + focusWidth + spacing3;
            return {
                width: width,
                height: height,
                markerWidth: markerWidth,
                labelWidth: labelWidth,
                valueWidth: valueWidth,
                focusWidth: focusWidth
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CategoryItem.prototype, "spacing", {
        get: function() {
            var _a = this.attributes, spacing = _a.spacing, focus = _a.focus;
            if (!spacing) return [
                0,
                0,
                0
            ];
            var _b = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(spacing), 3), spacing1 = _b[0], spacing2 = _b[1], spacing3 = _b[2];
            return [
                spacing1,
                this.showValue ? spacing2 : 0,
                focus ? spacing3 : 0
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CategoryItem.prototype, "layout", {
        get: function() {
            var _a = this.shape, markerWidth = _a.markerWidth, labelWidth = _a.labelWidth, valueWidth = _a.valueWidth, focusWidth = _a.focusWidth, width = _a.width, height = _a.height;
            var _b = (0, $7WQrb.__read)(this.spacing, 3), spacing1 = _b[0], spacing2 = _b[1], spacing3 = _b[2];
            return {
                height: height,
                width: width,
                markerWidth: markerWidth,
                labelWidth: labelWidth,
                valueWidth: valueWidth,
                focusWidth: focusWidth,
                position: [
                    markerWidth / 2,
                    markerWidth + spacing1,
                    markerWidth + labelWidth + spacing1 + spacing2,
                    markerWidth + labelWidth + valueWidth + spacing1 + spacing2 + spacing3 + focusWidth / 2
                ]
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CategoryItem.prototype, "scaleSize", {
        get: function() {
            var markerShapeStyle = $585f67f8993c6376$var$styleOfMarker(this.markerGroup.node());
            var _a = this.attributes, markerSize = _a.markerSize, _b = _a.markerStrokeWidth, markerStrokeWidth = _b === void 0 ? markerShapeStyle.strokeWidth : _b, _c = _a.markerLineWidth, markerLineWidth = _c === void 0 ? markerShapeStyle.lineWidth : _c, _d = _a.markerStroke, markerStroke = _d === void 0 ? markerShapeStyle.stroke : _d;
            // empirical value
            var strokeWidth = +(markerStrokeWidth || markerLineWidth || (markerStroke ? 1 : 0)) * Math.sqrt(2);
            var _e = this.markerGroup.node().getBBox(), width = _e.width, height = _e.height;
            return (1 - strokeWidth / Math.max(width, height)) * markerSize;
        },
        enumerable: false,
        configurable: true
    });
    CategoryItem.prototype.renderMarker = function(container) {
        var _this = this;
        var _a = this.attributes, marker = _a.marker, classNamePrefix = _a.classNamePrefix;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'marker');
        this.markerGroup = container.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.markerGroup, 'g').style('zIndex', 0);
        (0, $aJozt.ifShow)(!!marker, this.markerGroup, function() {
            var _a;
            var parent = _this.markerGroup.node();
            var oldMarker = (_a = parent.childNodes) === null || _a === void 0 ? void 0 : _a[0];
            var markerClassName = (0, $heTcj.getLegendClassName)($585f67f8993c6376$var$CLASS_NAMES.marker.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).marker, classNamePrefix);
            var newMarker = typeof marker === 'string' ? new (0, $hj9tl.Marker)({
                style: {
                    symbol: marker
                },
                className: markerClassName
            }) : marker();
            if (!oldMarker) {
                if (!(newMarker instanceof (0, $hj9tl.Marker))) {
                    var markerClassName_1 = (0, $heTcj.getLegendClassName)($585f67f8993c6376$var$CLASS_NAMES.marker.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).marker, classNamePrefix);
                    newMarker.className = markerClassName_1;
                    (0, $bCy7Q.select)(newMarker).styles(style);
                }
                parent.appendChild(newMarker);
            } else if (newMarker.nodeName === oldMarker.nodeName) {
                if (oldMarker instanceof (0, $hj9tl.Marker)) oldMarker.update((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, style), {
                    symbol: marker
                }));
                else {
                    (0, $3tYe7.copyAttributes)(oldMarker, newMarker);
                    (0, $bCy7Q.select)(oldMarker).styles(style);
                }
            } else {
                oldMarker.remove();
                if (!(newMarker instanceof (0, $hj9tl.Marker))) {
                    var markerClassName_2 = (0, $heTcj.getLegendClassName)($585f67f8993c6376$var$CLASS_NAMES.marker.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).marker, classNamePrefix);
                    newMarker.className = markerClassName_2;
                }
                (0, $bCy7Q.select)(newMarker).styles(style);
                parent.appendChild(newMarker);
            }
            // record the scale of marker
            _this.markerGroup.node().scale(1 / _this.markerGroup.node().getScale()[0]);
            var scale = (0, $9JcvC.scaleToPixel)(_this.markerGroup.node(), _this.scaleSize, true);
            _this.markerGroup.node().style._transform = "scale(".concat(scale, ")");
        });
    };
    CategoryItem.prototype.renderLabel = function(container) {
        var _a = (0, $8UxPj.subStyleProps)(this.attributes, 'label'), label = _a.text, style = (0, $7WQrb.__rest)(_a, [
            "text"
        ]);
        var classNamePrefix = this.attributes.classNamePrefix;
        this.labelGroup = container.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.labelGroup, 'g').style('zIndex', 0);
        var labelClassName = (0, $heTcj.getLegendClassName)($585f67f8993c6376$var$CLASS_NAMES.label.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).label, classNamePrefix);
        var labelElement = this.labelGroup.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.label, function() {
            return (0, $i1HPZ.renderExtDo)(label);
        });
        labelElement.node().setAttribute('class', labelClassName);
        labelElement.styles(style);
    };
    CategoryItem.prototype.renderValue = function(container) {
        var _this = this;
        var _a = (0, $8UxPj.subStyleProps)(this.attributes, 'value'), value = _a.text, style = (0, $7WQrb.__rest)(_a, [
            "text"
        ]);
        var classNamePrefix = this.attributes.classNamePrefix;
        this.valueGroup = container.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.valueGroup, 'g').style('zIndex', 0);
        (0, $aJozt.ifShow)(this.showValue, this.valueGroup, function() {
            var valueClassName = (0, $heTcj.getLegendClassName)($585f67f8993c6376$var$CLASS_NAMES.value.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).value, classNamePrefix);
            var valueElement = _this.valueGroup.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.value, function() {
                return (0, $i1HPZ.renderExtDo)(value);
            });
            valueElement.node().setAttribute('class', valueClassName);
            valueElement.styles(style);
        });
    };
    CategoryItem.prototype.createPoptip = function() {
        var poptip = this.attributes.poptip;
        var _a = poptip || {}, render = _a.render, poptipStyle = (0, $7WQrb.__rest)(_a, [
            "render"
        ]);
        var poptipGroup = new (0, $jtyct.Poptip)({
            style: (0, $6LvUc.deepAssign)($585f67f8993c6376$var$DEFAULT_POPTIP_PROPS, poptipStyle)
        });
        this.poptipGroup = poptipGroup;
        return poptipGroup;
    };
    CategoryItem.prototype.bindPoptip = function(node) {
        var _this = this;
        var poptip = this.attributes.poptip;
        if (!poptip) return;
        var poptipGroup = this.poptipGroup || this.createPoptip();
        poptipGroup.bind(node, function() {
            var _a = _this.attributes, labelText = _a.labelText, valueText = _a.valueText, markerFill = _a.markerFill;
            var label = typeof labelText === 'string' ? labelText : labelText === null || labelText === void 0 ? void 0 : labelText.attr('text');
            var value = typeof valueText === 'string' ? valueText : valueText === null || valueText === void 0 ? void 0 : valueText.attr('text');
            if (typeof poptip.render === 'function') return {
                html: poptip.render((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, _this.keyFields), {
                    label: label,
                    value: value,
                    color: markerFill
                }))
            };
            var html = '';
            if (typeof label === 'string' || typeof label === 'number') html += "<div class=\"component-poptip-label\">".concat(label, "</div>");
            if (typeof value === 'string' || typeof value === 'number') html += "<div class=\"component-poptip-value\">".concat(value, "</div>");
            return {
                html: html
            };
        });
    };
    CategoryItem.prototype.renderFocus = function(ctn) {
        var _this = this;
        var _a = this.attributes, focus = _a.focus, focusMarkerSize = _a.focusMarkerSize, classNamePrefix = _a.classNamePrefix;
        var defaultOptions = {
            x: 0,
            y: 0,
            size: focusMarkerSize,
            opacity: 0.6,
            symbol: 'focus',
            stroke: '#aaaaaa',
            lineWidth: 1
        };
        if ((0, $aFcWQ.default)(focus)) return;
        this.focusGroup = ctn.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.focusGroup, 'g').style('zIndex', 0);
        (0, $aJozt.ifShow)(focus, this.focusGroup, function() {
            var focusClassName = (0, $heTcj.getLegendClassName)($585f67f8993c6376$var$CLASS_NAMES.focus.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).focusIcon, classNamePrefix);
            var marker = new (0, $hj9tl.Marker)({
                style: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, defaultOptions), {
                    symbol: 'focus'
                }),
                className: focusClassName
            });
            var interactiveCircle = new (0, $2eDEB.Circle)({
                style: {
                    r: defaultOptions.size / 2,
                    fill: 'transparent'
                }
            });
            var container = _this.focusGroup.node();
            container.appendChild(interactiveCircle);
            container.appendChild(marker);
            marker.update({
                opacity: 0
            });
            ctn.node().addEventListener('pointerenter', function() {
                marker.update({
                    opacity: 1
                });
            });
            ctn.node().addEventListener('pointerleave', function() {
                marker.update({
                    opacity: 0
                });
            });
        });
    };
    CategoryItem.prototype.renderPoptip = function(ctn) {
        var _this = this;
        var poptip = this.attributes.poptip;
        if (!poptip) return;
        var valueNode = ctn.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.value, 'g').node();
        var labelNode = ctn.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.label, 'g').node();
        [
            valueNode,
            labelNode
        ].forEach(function(node) {
            if (node) _this.bindPoptip(node);
        });
    };
    CategoryItem.prototype.renderBackground = function(container) {
        var _a = this.shape, width = _a.width, height = _a.height;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'background');
        this.background = container.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.backgroundGroup, 'g').style('zIndex', -1);
        var backgroundElement = this.background.maybeAppendByClassName($585f67f8993c6376$var$CLASS_NAMES.background, 'rect');
        backgroundElement.styles((0, $7WQrb.__assign)({
            width: width,
            height: height
        }, style));
        var _b = this.attributes.classNamePrefix, classNamePrefix = _b === void 0 ? '' : _b;
        if (classNamePrefix) {
            var backgroundClassName = (0, $heTcj.getLegendClassName)($585f67f8993c6376$var$CLASS_NAMES.background.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).background, classNamePrefix);
            backgroundElement.node().setAttribute('class', backgroundClassName);
        }
    };
    CategoryItem.prototype.adjustLayout = function() {
        var _a = this.layout, labelWidth = _a.labelWidth, valueWidth = _a.valueWidth, height = _a.height, _b = (0, $7WQrb.__read)(_a.position, 4), markerX = _b[0], labelX = _b[1], valueX = _b[2], focusX = _b[3];
        var halfHeight = height / 2;
        // console.log(this.markerGroup.node().style._transform);
        this.markerGroup.styles({
            transform: "translate(".concat(markerX, ", ").concat(halfHeight, ")").concat(this.markerGroup.node().style._transform)
        });
        this.labelGroup.styles({
            transform: "translate(".concat(labelX, ", ").concat(halfHeight, ")")
        });
        if (this.focusGroup) this.focusGroup.styles({
            transform: "translate(".concat(focusX, ", ").concat(halfHeight, ")")
        });
        (0, $0gesb.ellipsisIt)(this.labelGroup.select($585f67f8993c6376$var$CLASS_NAMES.label.class).node(), Math.ceil(labelWidth));
        if (this.showValue) {
            this.valueGroup.styles({
                transform: "translate(".concat(valueX, ", ").concat(halfHeight, ")")
            });
            (0, $0gesb.ellipsisIt)(this.valueGroup.select($585f67f8993c6376$var$CLASS_NAMES.value.class).node(), Math.ceil(valueWidth));
        }
    };
    CategoryItem.prototype.render = function(attributes, container) {
        var ctn = (0, $bCy7Q.select)(container);
        var _a = attributes.x, x = _a === void 0 ? 0 : _a, _b = attributes.y, y = _b === void 0 ? 0 : _b;
        ctn.styles({
            transform: "translate(".concat(x, ", ").concat(y, ")")
        });
        this.renderMarker(ctn);
        this.renderLabel(ctn);
        this.renderValue(ctn);
        this.renderBackground(ctn);
        this.renderPoptip(ctn);
        this.renderFocus(ctn);
        this.adjustLayout();
    };
    return CategoryItem;
}((0, $e7n3C.Component));

});
parcelRegister("3tYe7", function(module, exports) {

$parcel$export(module.exports, "getLocalBBox", () => $2892cc4fcb50eb40$export$b069decf822a93b0);
$parcel$export(module.exports, "isHorizontal", () => $2892cc4fcb50eb40$export$2a62b49acb270576);
$parcel$export(module.exports, "copyAttributes", () => $2892cc4fcb50eb40$export$98ee8012024fe993);

var $7WQrb = parcelRequire("7WQrb");

var $bCy7Q = parcelRequire("bCy7Q");
function $2892cc4fcb50eb40$export$7501316b9eb909dd(shape) {
    var bounds = shape && shape.getRenderBounds();
    if (!bounds) return {
        width: 0,
        height: 0
    };
    var max = bounds.getMax();
    var min = bounds.getMin();
    return {
        width: max[0] - min[0],
        height: max[1] - min[1]
    };
}
function $2892cc4fcb50eb40$export$b069decf822a93b0(shape) {
    var _a = shape.getLocalBounds(), min = _a.min, max = _a.max;
    var _b = (0, $7WQrb.__read)([
        min,
        max
    ], 2), _c = (0, $7WQrb.__read)(_b[0], 2), x1 = _c[0], y1 = _c[1], _d = (0, $7WQrb.__read)(_b[1], 2), x2 = _d[0], y2 = _d[1];
    return {
        x: x1,
        y: y1,
        width: x2 - x1,
        height: y2 - y1,
        left: x1,
        bottom: y2,
        top: y1,
        right: x2
    };
}
function $2892cc4fcb50eb40$export$45a20809fb1b706d(group, attrs) {
    var textNode = (0, $bCy7Q.select)(group).append('text').node();
    textNode.attr((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, attrs), {
        visibility: 'hidden'
    }));
    return textNode;
}
function $2892cc4fcb50eb40$export$2a62b49acb270576(p1, p2) {
    var _a = (0, $7WQrb.__read)(p1, 2), x1 = _a[0], y1 = _a[1];
    var _b = (0, $7WQrb.__read)(p2, 2), x2 = _b[0], y2 = _b[1];
    return x1 !== x2 && y1 === y2;
}
function $2892cc4fcb50eb40$export$42c0085b96d0f4c4(p1, p2) {
    var _a = (0, $7WQrb.__read)(p1, 2), x1 = _a[0], y1 = _a[1];
    var _b = (0, $7WQrb.__read)(p2, 2), x2 = _b[0], y2 = _b[1];
    return x1 === x2 && y1 !== y2;
}
function $2892cc4fcb50eb40$export$98ee8012024fe993(target, source) {
    var e_1, _a;
    var attributes = source.attributes;
    try {
        for(var _b = (0, $7WQrb.__values)(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()){
            var _d = (0, $7WQrb.__read)(_c.value, 2), key = _d[0], value = _d[1];
            if (key !== 'id' && key !== 'className') target.attr(key, value);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}

});

parcelRegister("0gesb", function(module, exports) {

$parcel$export(module.exports, "ellipsisIt", () => $000c979028ca94b2$export$24bd75dee4fd3ee0);

var $9J3on = parcelRequire("9J3on");
function $000c979028ca94b2$export$24bd75dee4fd3ee0(node, w, suffix) {
    if (suffix === void 0) suffix = '...';
    (0, $9J3on.applyToText)(node, {
        wordWrap: true,
        wordWrapWidth: w,
        maxLines: 1,
        textOverflow: suffix
    });
}

});
parcelRegister("9J3on", function(module, exports) {

$parcel$export(module.exports, "measureTextWidth", () => $714af29ebb392d8d$export$4ea92329b673abd1);
$parcel$export(module.exports, "getFont", () => $714af29ebb392d8d$export$155316a870a9d61e);
$parcel$export(module.exports, "textOf", () => $714af29ebb392d8d$export$6b030a2ba76fa77e);
$parcel$export(module.exports, "applyToText", () => $714af29ebb392d8d$export$5ee5289282258848);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $amGwr = parcelRequire("amGwr");
var $714af29ebb392d8d$var$ctx;
var $714af29ebb392d8d$var$mockMeasureTextWidth;
function $714af29ebb392d8d$export$db9198f1820ec01c(mock) {
    $714af29ebb392d8d$var$mockMeasureTextWidth = mock;
}
var $714af29ebb392d8d$export$4ea92329b673abd1 = (0, $amGwr.default)(function(text, font) {
    var fontSize = font.fontSize, fontFamily = font.fontFamily, fontWeight = font.fontWeight, fontStyle = font.fontStyle, fontVariant = font.fontVariant;
    if ($714af29ebb392d8d$var$mockMeasureTextWidth) return $714af29ebb392d8d$var$mockMeasureTextWidth(text, fontSize);
    if (!$714af29ebb392d8d$var$ctx) // @ts-ignore
    $714af29ebb392d8d$var$ctx = (0, $2eDEB.runtime).offscreenCanvasCreator.getOrCreateContext(undefined);
    $714af29ebb392d8d$var$ctx.font = [
        fontStyle,
        fontVariant,
        fontWeight,
        "".concat(fontSize, "px"),
        fontFamily
    ].join(' ');
    return $714af29ebb392d8d$var$ctx.measureText(text).width;
}, function(text, font) {
    return [
        text,
        Object.values(font || $714af29ebb392d8d$export$155316a870a9d61e(text)).join()
    ].join('');
}, 4096);
var $714af29ebb392d8d$export$155316a870a9d61e = function(textShape) {
    var fontFamily = textShape.style.fontFamily || 'sans-serif';
    var fontWeight = textShape.style.fontWeight || 'normal';
    var fontStyle = textShape.style.fontStyle || 'normal';
    var fontVariant = textShape.style.fontVariant;
    var fontSize = textShape.style.fontSize;
    fontSize = typeof fontSize === 'object' ? fontSize.value : fontSize;
    return {
        fontSize: fontSize,
        fontFamily: fontFamily,
        fontWeight: fontWeight,
        fontStyle: fontStyle,
        fontVariant: fontVariant
    };
};
function $714af29ebb392d8d$export$6b030a2ba76fa77e(node) {
    if (node.nodeName === 'text') return node;
    if (node.nodeName === 'g' && node.children.length === 1 && node.children[0].nodeName === 'text') return node.children[0];
    return null;
}
function $714af29ebb392d8d$export$5ee5289282258848(node, style) {
    var text = $714af29ebb392d8d$export$6b030a2ba76fa77e(node);
    if (text) text.attr(style);
}

});


parcelRegister("i1HPZ", function(module, exports) {

$parcel$export(module.exports, "renderExtDo", () => $d1fa53350a3d0fbe$export$5605f99f058c272c);
$parcel$export(module.exports, "renderHtmlExtDo", () => $d1fa53350a3d0fbe$export$51aa4e8f31212e90);

var $7WQrb = parcelRequire("7WQrb");

var $jyI49 = parcelRequire("jyI49");
var $kVcyu = parcelRequire("kVcyu");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");
var $eNeqF = parcelRequire("eNeqF");
function $d1fa53350a3d0fbe$export$5605f99f058c272c(el) {
    if (typeof el === 'function') return el();
    return (0, $kVcyu.default)(el) || (0, $jyI49.default)(el) ? new (0, $eNeqF.Text)({
        style: {
            text: String(el)
        }
    }) : el;
}
function $d1fa53350a3d0fbe$export$51aa4e8f31212e90(el, style) {
    if (typeof el === 'function') return el();
    return (0, $kVcyu.default)(el) || (0, $jyI49.default)(el) ? new (0, $2eDEB.HTML)({
        style: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
            pointerEvents: 'auto'
        }, style), {
            innerHTML: el
        })
    }) : el;
}

});

parcelRegister("jtyct", function(module, exports) {

$parcel$export(module.exports, "Poptip", () => $e2db41345d8088e7$export$52a0c188e2ae100f);

var $7WQrb = parcelRequire("7WQrb");

var $7bjru = parcelRequire("7bjru");
var $iE4so = parcelRequire("iE4so");
var $6XARU = parcelRequire("6XARU");
var $jabbR = parcelRequire("jabbR");
var $kVcyu = parcelRequire("kVcyu");

var $e7n3C = parcelRequire("e7n3C");

var $6LvUc = parcelRequire("6LvUc");

var $hjXwT = parcelRequire("hjXwT");

var $61ruR = parcelRequire("61ruR");
var $e2db41345d8088e7$export$52a0c188e2ae100f = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Poptip, _super);
    function Poptip(options) {
        var _this = _super.call(this, (0, $iE4so.default)({
            style: {
                id: (0, $hjXwT.POPTIP_ID)
            }
        }, Poptip.defaultOptions, options)) || this;
        /** 显影控制 */ _this.visibility = 'visible';
        /** 所有绑定的目标对象 */ _this.map = new Map();
        /** 节点样式 */ _this.domStyles = '';
        _this.initShape();
        _this.render(_this.attributes, _this);
        return _this;
    }
    Object.defineProperty(Poptip.prototype, "visible", {
        get: function() {
            return this.visibility === 'visible';
        },
        enumerable: false,
        configurable: true
    });
    Poptip.prototype.render = function(attributes, container) {
        this.visibility = this.style.visibility;
        this.updatePoptipElement();
    };
    /**
     * poptip 组件更新
     */ Poptip.prototype.update = function(cfg) {
        this.attr((0, $iE4so.default)({}, this.style, cfg));
        this.render(this.attributes, this);
    };
    /**
     * 绑定元素
     */ Poptip.prototype.bind = function(element, callback) {
        var _this = this;
        if (!element) return;
        var defaultText = this.style.text;
        var onmousemove = function(e) {
            var target = element;
            var options = _this.style;
            var text = defaultText;
            if (callback) {
                var _a = typeof callback === 'function' ? callback.call(null, e) : callback, html = _a.html, ele = _a.target, restOptions = (0, $7WQrb.__rest)(_a, [
                    "html",
                    "target"
                ]);
                options = (0, $7bjru.default)({}, _this.style, restOptions);
                if (ele || ele === false) target = ele;
                if (typeof html === 'string') text = html;
            }
            var position = options.position, arrowPointAtCenter = options.arrowPointAtCenter, follow = options.follow, offset = options.offset;
            if (target) {
                var _b = e, clientX = _b.clientX, clientY = _b.clientY;
                var _c = (0, $7WQrb.__read)((0, $61ruR.getPositionXY)(clientX, clientY, target, position, arrowPointAtCenter, follow), 2), x = _c[0], y = _c[1];
                _this.showTip(x, y, {
                    text: text,
                    position: position,
                    offset: offset
                });
            } else // 没有移动到指定的目标 关闭弹框
            _this.hideTip();
        };
        var onmouseleave = function() {
            _this.hideTip();
        };
        element.addEventListener('mousemove', onmousemove);
        element.addEventListener('mouseleave', onmouseleave);
        // 存储监听
        this.map.set(element, [
            onmousemove,
            onmouseleave
        ]);
    };
    Poptip.prototype.unbind = function(element) {
        if (this.map.has(element)) {
            var _a = (0, $7WQrb.__read)(this.map.get(element) || [], 2), listener1 = _a[0], listener2 = _a[1];
            listener1 && element.removeEventListener('mousemove', listener1);
            listener2 && element.removeEventListener('mouseleave', listener2);
            this.map.delete(element);
        }
    };
    /**
     * 清空容器内容
     */ Poptip.prototype.clear = function() {
        this.container.innerHTML = '';
    };
    /**
     * 清除
     */ Poptip.prototype.destroy = function() {
        var _this = this;
        var _a;
        (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(this.map.keys()), false).forEach(function(ele) {
            return _this.unbind(ele);
        });
        (_a = this.container) === null || _a === void 0 || _a.remove();
        _super.prototype.destroy.call(this);
    };
    /**
     * 显示 + 改变位置
     * @param x 可选 改变位置 x 方向
     * @param y 可选 改变位置 y 方向
     * @param text 文本变化
     */ Poptip.prototype.showTip = function(x, y, options) {
        var text = (0, $6XARU.default)(options, 'text');
        if (text && typeof text !== 'string') return;
        this.applyStyles();
        // 不传入 不希望改变 x y
        if (x && y && options) {
            var offset = options.offset, position = options.position;
            position && this.container.setAttribute('data-position', position);
            this.setOffsetPosition(x, y, offset);
            if (typeof text === 'string') {
                // do something
                var textElement = this.container.querySelector(".".concat((0, $hjXwT.CLASS_NAME).TEXT));
                if (textElement) textElement.innerHTML = text;
            }
            this.visibility = 'visible';
            this.container.style.visibility = 'visible';
        }
    };
    /**
     * 隐藏
     */ Poptip.prototype.hideTip = function() {
        this.visibility = 'hidden';
        this.container.style.visibility = 'hidden';
    };
    /**
     * 获取内部容器 HTMLElement
     * @returns this.element:HTMLElement;
     */ Poptip.prototype.getContainer = function() {
        return this.container;
    };
    Poptip.prototype.getClassName = function() {
        var containerClassName = this.style.containerClassName;
        return "".concat((0, $hjXwT.CLASS_NAME).CONTAINER).concat(containerClassName ? " ".concat(containerClassName) : '');
    };
    /**
     * 初始化容器
     */ Poptip.prototype.initShape = function() {
        var _this = this;
        var id = this.style.id;
        this.container = (0, $61ruR.getSingleTonElement)(id);
        this.container.className = this.getClassName();
        // 盒子添加交互
        this.container.addEventListener('mousemove', function() {
            return _this.showTip();
        });
        this.container.addEventListener('mouseleave', function() {
            return _this.hideTip();
        });
    };
    /**
     * 更新 HTML 上的内容
     */ Poptip.prototype.updatePoptipElement = function() {
        var container = this.container;
        this.clear();
        var _a = this.style, id = _a.id, template = _a.template, text = _a.text;
        this.container.setAttribute('id', id);
        this.container.className = this.getClassName();
        // 增加 arrow 元素
        var arrowNode = "<span class=\"".concat((0, $hjXwT.CLASS_NAME).ARROW, "\"></span>");
        container.innerHTML = arrowNode;
        // 置入 text 模版
        if ((0, $kVcyu.default)(template)) container.innerHTML += template;
        else if (template && (0, $jabbR.default)(template)) container.appendChild(template);
        // 置入 text
        if (text) container.getElementsByClassName((0, $hjXwT.CLASS_NAME).TEXT)[0].textContent = text;
        this.applyStyles();
        this.container.style.visibility = this.visibility;
    };
    /**
     * 应用样式表
     */ Poptip.prototype.applyStyles = function() {
        var styles = (0, $6LvUc.deepAssign)({}, (0, $hjXwT.POPTIP_STYLE), this.style.domStyles);
        var styleStr = Object.entries(styles).reduce(function(r, _a) {
            var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], value = _b[1];
            var styleStr = Object.entries(value).reduce(function(r, _a) {
                var _b = (0, $7WQrb.__read)(_a, 2), k = _b[0], v = _b[1];
                return "".concat(r).concat(k, ": ").concat(v, ";");
            }, '');
            return "".concat(r).concat(key, "{").concat(styleStr, "}");
        }, '');
        if (this.domStyles !== styleStr) {
            this.domStyles = styleStr;
            var styleDOM = this.container.querySelector('style');
            if (styleDOM) this.container.removeChild(styleDOM);
            styleDOM = document.createElement('style');
            styleDOM.innerHTML = styleStr;
            this.container.appendChild(styleDOM);
        }
    };
    /**
     * 将相对于指针的偏移量生效到dom元素上
     * @param x 盒子相对于页面 x 的位置
     * @param y 盒子相对于页面 y 的位置
     */ Poptip.prototype.setOffsetPosition = function(x, y, offset) {
        if (offset === void 0) offset = this.style.offset;
        var _a = (0, $7WQrb.__read)(offset, 2), _b = _a[0], offsetX = _b === void 0 ? 0 : _b, _c = _a[1], offsetY = _c === void 0 ? 0 : _c;
        this.container.style.left = "".concat(x + offsetX, "px");
        this.container.style.top = "".concat(y + offsetY, "px");
    };
    Poptip.tag = 'poptip';
    Poptip.defaultOptions = {
        style: {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            target: null,
            visibility: 'hidden',
            text: '',
            position: 'top',
            follow: false,
            offset: [
                0,
                0
            ],
            domStyles: (0, $hjXwT.POPTIP_STYLE),
            template: "<div class=\"".concat((0, $hjXwT.CLASS_NAME).TEXT, "\"></div>")
        }
    };
    return Poptip;
}((0, $e7n3C.Component));

});
parcelRegister("7bjru", function(module, exports) {

$parcel$export(module.exports, "default", () => $53a8a4536af78174$export$2e2bcd8739ae039);
// FIXME: Mutable param should be forbidden in static lang.
function $53a8a4536af78174$var$_mix(dist, obj) {
    for(var key in obj)if (obj.hasOwnProperty(key) && key !== 'constructor' && obj[key] !== undefined) dist[key] = obj[key];
}
function $53a8a4536af78174$export$2e2bcd8739ae039(dist, src1, src2, src3) {
    if (src1) $53a8a4536af78174$var$_mix(dist, src1);
    if (src2) $53a8a4536af78174$var$_mix(dist, src2);
    if (src3) $53a8a4536af78174$var$_mix(dist, src3);
    return dist;
}

});

parcelRegister("jabbR", function(module, exports) {

$parcel$export(module.exports, "default", () => $df37a1a1abe154f7$export$2e2bcd8739ae039);
/**
 * 判断值是否为 HTML Element 或 Document
 * @return 是否为 HTML Element 或 Document
 */ function $df37a1a1abe154f7$export$2e2bcd8739ae039(value) {
    return value instanceof Element || value instanceof Document;
}

});

parcelRegister("hjXwT", function(module, exports) {

$parcel$export(module.exports, "POPTIP_ID", () => $c9c2635dc1bf76ad$export$88e732b8ef8f770);
$parcel$export(module.exports, "CLASS_NAME", () => $c9c2635dc1bf76ad$export$5049bb931784de52);
$parcel$export(module.exports, "POPTIP_STYLE", () => $c9c2635dc1bf76ad$export$285aaccac5ad5c68);
var $c9c2635dc1bf76ad$var$_a;
var $c9c2635dc1bf76ad$export$88e732b8ef8f770 = 'component-poptip';
var $c9c2635dc1bf76ad$export$5049bb931784de52 = {
    CONTAINER: 'component-poptip',
    ARROW: 'component-poptip-arrow',
    TEXT: 'component-poptip-text'
};
var $c9c2635dc1bf76ad$export$285aaccac5ad5c68 = ($c9c2635dc1bf76ad$var$_a = {}, // 容器 默认 style
$c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER)] = {
    visibility: 'visible',
    position: 'absolute',
    'background-color': 'rgba(0, 0, 0)',
    'box-shadow': '0px 0px 10px #aeaeae',
    'border-radius': '3px',
    color: '#fff',
    opacity: 0.8,
    'font-size': '12px',
    padding: '4px 6px',
    display: 'flex',
    'justify-content': 'center',
    'align-items': 'center',
    'z-index': 8,
    transition: 'visibility 50ms'
}, // 文本内容 默认 style
$c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.TEXT)] = {
    'text-align': 'center'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='top']")] = {
    transform: "translate(-50%, -100%)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='left']")] = {
    transform: "translate(-100%, -50%)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='right']")] = {
    transform: "translate(0, -50%)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='bottom']")] = {
    transform: "translate(-50%, 0)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='top-left']")] = {
    transform: "translate(0,-100%)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='top-right']")] = {
    transform: "translate(-100%,-100%)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='left-top']")] = {
    transform: "translate(-100%, 0)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='left-bottom']")] = {
    transform: "translate(-100%, -100%)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='right-top']")] = {
    transform: "translate(0, 0)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='right-bottom']")] = {
    transform: "translate(0, -100%)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='bottom-left']")] = {
    transform: "translate(0, 0)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='bottom-right']")] = {
    transform: "translate(-100%, 0)"
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    width: '4px',
    height: '4px',
    transform: 'rotate(45deg)',
    'background-color': 'rgba(0, 0, 0)',
    position: 'absolute',
    'z-index': -1
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='top']")] = {
    transform: "translate(-50%, calc(-100% - 5px))"
}, $c9c2635dc1bf76ad$var$_a["[data-position='top'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    bottom: '-2px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='left']")] = {
    transform: "translate(calc(-100% - 5px), -50%)"
}, $c9c2635dc1bf76ad$var$_a["[data-position='left'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    right: '-2px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='right']")] = {
    transform: "translate(5px, -50%)"
}, $c9c2635dc1bf76ad$var$_a["[data-position='right'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    left: '-2px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='bottom']")] = {
    transform: "translate(-50%, 5px)"
}, $c9c2635dc1bf76ad$var$_a["[data-position='bottom'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    top: '-2px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='top-left']")] = {
    transform: "translate(0, calc(-100% - 5px))"
}, $c9c2635dc1bf76ad$var$_a["[data-position='top-left'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    left: '10px',
    bottom: '-2px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='top-right']")] = {
    transform: "translate(-100%, calc(-100% - 5px))"
}, $c9c2635dc1bf76ad$var$_a["[data-position='top-right'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    right: '10px',
    bottom: '-2px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='left-top']")] = {
    transform: "translate(calc(-100% - 5px), 0)"
}, $c9c2635dc1bf76ad$var$_a["[data-position='left-top'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    right: '-2px',
    top: '8px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='left-bottom']")] = {
    transform: "translate(calc(-100% - 5px), -100%)"
}, $c9c2635dc1bf76ad$var$_a["[data-position='left-bottom'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    right: '-2px',
    bottom: '8px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='right-top']")] = {
    transform: "translate(5px, 0)"
}, $c9c2635dc1bf76ad$var$_a["[data-position='right-top'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    left: '-2px',
    top: '8px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='right-bottom']")] = {
    transform: "translate(5px, -100%)"
}, $c9c2635dc1bf76ad$var$_a["[data-position='right-bottom'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    left: '-2px',
    bottom: '8px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='bottom-left']")] = {
    transform: "translate(0, 5px)"
}, $c9c2635dc1bf76ad$var$_a["[data-position='bottom-left'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    top: '-2px',
    left: '8px'
}, $c9c2635dc1bf76ad$var$_a[".".concat($c9c2635dc1bf76ad$export$5049bb931784de52.CONTAINER, "[data-position='bottom-right']")] = {
    transform: "translate(-100%, 5px)"
}, $c9c2635dc1bf76ad$var$_a["[data-position='bottom-right'] .".concat($c9c2635dc1bf76ad$export$5049bb931784de52.ARROW)] = {
    top: '-2px',
    right: '8px'
}, $c9c2635dc1bf76ad$var$_a);

});

parcelRegister("61ruR", function(module, exports) {

$parcel$export(module.exports, "getPositionXY", () => $46282a5997ac3a86$export$b76a2413c1915d94);
$parcel$export(module.exports, "getSingleTonElement", () => $46282a5997ac3a86$export$60906e8f71281d2a);
var $46282a5997ac3a86$var$_this = undefined;
function $46282a5997ac3a86$export$b76a2413c1915d94(clientX, clientY, target, position, arrowPointAtCenter, follow) {
    if (arrowPointAtCenter === void 0) arrowPointAtCenter = false;
    if (follow === void 0) follow = false;
    if (follow) return [
        clientX,
        clientY
    ];
    // @ts-ignore
    var _a = target.getBoundingClientRect(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    switch(position){
        case 'top':
            return arrowPointAtCenter ? [
                x + width / 2,
                y
            ] : [
                clientX,
                y
            ];
        case 'left':
            return arrowPointAtCenter ? [
                x,
                y + height / 2
            ] : [
                x,
                clientY
            ];
        case 'bottom':
            return arrowPointAtCenter ? [
                x + width / 2,
                y + height
            ] : [
                clientX,
                y + height
            ];
        case 'right':
            return arrowPointAtCenter ? [
                x + width,
                y + height / 2
            ] : [
                x + width,
                clientY
            ];
        case 'top-right':
        case 'right-top':
            return [
                x + width,
                y
            ];
        case 'left-bottom':
        case 'bottom-left':
            return [
                x,
                y + height
            ];
        case 'right-bottom':
        case 'bottom-right':
            return [
                x + width,
                y + height
            ];
        case 'top-left':
        case 'left-top':
        default:
            return [
                x,
                y
            ];
    }
}
var $46282a5997ac3a86$var$getSingleTon = function(fn) {
    var instance;
    return function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!instance) instance = fn.apply($46282a5997ac3a86$var$_this, args);
        return instance;
    };
};
function $46282a5997ac3a86$var$createElement(id) {
    var div = id && document.getElementById(id);
    if (!div) {
        div = document.createElement('div');
        div.setAttribute('id', id);
        document.body.appendChild(div);
    }
    return div;
}
function $46282a5997ac3a86$export$60906e8f71281d2a(id) {
    var element = $46282a5997ac3a86$var$getSingleTon($46282a5997ac3a86$var$createElement)(id);
    return element;
}

});




parcelRegister("ieO5k", function(module, exports) {

$parcel$export(module.exports, "CATEGORY_DEFAULT_OPTIONS", () => $d47062a2acc1f8e1$export$b55cc8316d9d8d34);
$parcel$export(module.exports, "CLASS_NAMES", () => $d47062a2acc1f8e1$export$1ba50affd1ee3341);

var $1SiGY = parcelRequire("1SiGY");
var $6LvUc = parcelRequire("6LvUc");
var $8UxPj = parcelRequire("8UxPj");

var $aGSDj = parcelRequire("aGSDj");

var $6GpDK = parcelRequire("6GpDK");
var $d47062a2acc1f8e1$export$52088effa545f9a = {
    showTitle: true,
    padding: 0,
    orientation: 'horizontal',
    backgroundFill: 'transparent',
    titleText: '',
    titleSpacing: 4,
    titlePosition: 'top-left',
    titleFill: '#2C3542',
    titleFontWeight: 'bold',
    titleFontFamily: 'sans-serif',
    titleFontSize: 12
};
var $d47062a2acc1f8e1$export$b55cc8316d9d8d34 = (0, $6LvUc.deepAssign)({}, $d47062a2acc1f8e1$export$52088effa545f9a, {});
var $d47062a2acc1f8e1$export$cb7065793e8856c4 = (0, $6LvUc.deepAssign)({}, $d47062a2acc1f8e1$export$52088effa545f9a, (0, $8UxPj.superStyleProps)((0, $aGSDj.DEFAULT_HANDLE_CFG), 'handle'), {
    color: [
        '#d0e3fa',
        '#acc7f6',
        '#8daaf2',
        '#6d8eea',
        '#4d73cd',
        '#325bb1',
        '#5a3e75',
        '#8c3c79',
        '#e23455',
        '#e7655b'
    ],
    indicatorBackgroundFill: '#262626',
    indicatorLabelFill: 'white',
    indicatorLabelFontSize: 12,
    indicatorVisibility: 'hidden',
    labelAlign: 'value',
    labelDirection: 'positive',
    labelSpacing: 5,
    showHandle: true,
    showIndicator: true,
    showLabel: true,
    slidable: true,
    titleText: '',
    type: 'continuous'
});
var $d47062a2acc1f8e1$export$6a5960f4fcfa36d7 = 0.01;
var $d47062a2acc1f8e1$export$4e3eaafb5a05871d = 0.5;
var $d47062a2acc1f8e1$export$1ba50affd1ee3341 = (0, $1SiGY.classNames)({
    title: 'title',
    html: 'html',
    titleGroup: 'title-group',
    items: 'items',
    itemsGroup: 'items-group',
    contentGroup: 'content-group',
    ribbonGroup: 'ribbon-group',
    ribbon: 'ribbon',
    handlesGroup: 'handles-group',
    handle: 'handle',
    startHandle: 'start-handle',
    endHandle: 'end-handle',
    labelGroup: 'label-group',
    label: 'label',
    indicator: 'indicator'
}, 'legend');

});
parcelRegister("aGSDj", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_HANDLE_CFG", () => $7c8834a3fe088d47$export$9bb25a9970a745a6);

var $7WQrb = parcelRequire("7WQrb");

var $e7n3C = parcelRequire("e7n3C");

var $1SiGY = parcelRequire("1SiGY");
var $aJozt = parcelRequire("aJozt");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $hj9tl = parcelRequire("hj9tl");

var $ljupB = parcelRequire("ljupB");

var $heTcj = parcelRequire("heTcj");

var $6GpDK = parcelRequire("6GpDK");
var $7c8834a3fe088d47$var$CLASS_NAMES = (0, $1SiGY.classNames)({
    markerGroup: 'marker-group',
    marker: 'marker',
    labelGroup: 'label-group',
    label: 'label'
}, 'handle');
var $7c8834a3fe088d47$export$9bb25a9970a745a6 = {
    showLabel: true,
    formatter: function(val) {
        return val.toString();
    },
    markerSize: 25,
    markerStroke: '#c5c5c5',
    markerFill: '#fff',
    markerLineWidth: 1,
    labelFontSize: 12,
    labelFill: '#c5c5c5',
    labelText: '',
    orientation: 'vertical',
    spacing: 0
};
var $7c8834a3fe088d47$export$94890c79f4cae6d6 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Handle, _super);
    function Handle(options) {
        return _super.call(this, options, $7c8834a3fe088d47$export$9bb25a9970a745a6) || this;
    }
    Handle.prototype.render = function(attributes, container) {
        var markerGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName($7c8834a3fe088d47$var$CLASS_NAMES.markerGroup, 'g');
        this.renderMarker(markerGroup);
        var labelGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName($7c8834a3fe088d47$var$CLASS_NAMES.labelGroup, 'g');
        this.renderLabel(labelGroup);
    };
    Handle.prototype.renderMarker = function(container) {
        var _this = this;
        var _a = this.attributes, orientation = _a.orientation, classNamePrefix = _a.classNamePrefix, _b = _a.markerSymbol, markerSymbol = _b === void 0 ? (0, $ljupB.ifHorizontal)(orientation, 'horizontalHandle', 'verticalHandle') : _b;
        (0, $aJozt.ifShow)(!!markerSymbol, container, function(group) {
            var handleStyle = (0, $8UxPj.subStyleProps)(_this.attributes, 'marker');
            var markerStyle = (0, $7WQrb.__assign)({
                symbol: markerSymbol
            }, handleStyle);
            var markerClassName = (0, $heTcj.getLegendClassName)($7c8834a3fe088d47$var$CLASS_NAMES.marker.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).handleMarker, classNamePrefix);
            _this.marker = group.maybeAppendByClassName($7c8834a3fe088d47$var$CLASS_NAMES.marker, function() {
                return new (0, $hj9tl.Marker)({
                    style: markerStyle,
                    className: markerClassName
                });
            }).update(markerStyle);
            // Update Marker's child element className (Marker component overrides className internally)
            if (classNamePrefix) {
                var markerElement = _this.marker.node().querySelector('.marker');
                if (markerElement) {
                    var currentClass = markerElement.getAttribute('class') || '';
                    var baseClass = currentClass.split(' ')[0]; // e.g., 'marker'
                    var legendClassName = (0, $heTcj.getLegendClassName)(baseClass, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).handleMarker, classNamePrefix);
                    markerElement.setAttribute('class', legendClassName);
                }
            }
        });
    };
    Handle.prototype.renderLabel = function(container) {
        var _this = this;
        var _a = this.attributes, showLabel = _a.showLabel, orientation = _a.orientation, _b = _a.spacing, spacing = _b === void 0 ? 0 : _b, formatter = _a.formatter, classNamePrefix = _a.classNamePrefix;
        (0, $aJozt.ifShow)(showLabel, container, function(group) {
            var _a;
            var _b = (0, $8UxPj.subStyleProps)(_this.attributes, 'label'), text = _b.text, labelStyle = (0, $7WQrb.__rest)(_b, [
                "text"
            ]);
            // adjust layout
            var _c = ((_a = group.select($7c8834a3fe088d47$var$CLASS_NAMES.marker.class)) === null || _a === void 0 ? void 0 : _a.node().getBBox()) || {}, _d = _c.width, width = _d === void 0 ? 0 : _d, _e = _c.height, height = _e === void 0 ? 0 : _e;
            var _f = (0, $7WQrb.__read)((0, $ljupB.ifHorizontal)(orientation, [
                0,
                height + spacing,
                'center',
                'top'
            ], [
                width + spacing,
                0,
                'start',
                'middle'
            ]), 4), x = _f[0], y = _f[1], textAlign = _f[2], textBaseline = _f[3];
            var labelClassName = (0, $heTcj.getLegendClassName)($7c8834a3fe088d47$var$CLASS_NAMES.label.name, (0, $6GpDK.CLASSNAME_SUFFIX_MAP).handleLabel, classNamePrefix);
            group.maybeAppendByClassName($7c8834a3fe088d47$var$CLASS_NAMES.label, 'text').attr('className', labelClassName).styles((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, labelStyle), {
                x: x,
                y: y,
                text: formatter(text).toString(),
                textAlign: textAlign,
                textBaseline: textBaseline
            }));
        });
    };
    return Handle;
}((0, $e7n3C.Component));

});



parcelRegister("5Pn1Q", function(module, exports) {

$parcel$export(module.exports, "createPluginCanvas", () => $43e3942eb7605b74$export$9b2b3154e33e9c49);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $ci3lc = parcelRequire("ci3lc");

var $jtAhq = parcelRequire("jtAhq");

var $bEb16 = parcelRequire("bEb16");
function $43e3942eb7605b74$export$9b2b3154e33e9c49(options) {
    const { width: width, height: height, renderer: renderer } = options;
    const $container = $43e3942eb7605b74$var$getContainer(options);
    const canvas = new (0, $2eDEB.Canvas)({
        width: width,
        height: height,
        container: $container,
        renderer: renderer || new (0, $ci3lc.Renderer)()
    });
    return [
        $container,
        canvas
    ];
}
/**
 * <zh/> 获取容器
 *
 * <en/> Get container
 * @param options - <zh/> 配置项 | <en/> options
 * @returns <zh/> 容器 | <en/> container
 */ function $43e3942eb7605b74$var$getContainer(options) {
    var _a;
    const { container: container, className: className, graphCanvas: graphCanvas } = options;
    if (container) return typeof container === 'string' ? document.getElementById(container) : container;
    const $container = (0, $bEb16.createPluginContainer)(className, false);
    const { width: width, height: height, containerStyle: containerStyle } = options;
    const [x, y] = $43e3942eb7605b74$var$computePosition(options);
    Object.assign($container.style, Object.assign({
        position: 'absolute',
        left: x + 'px',
        top: y + 'px',
        width: width + 'px',
        height: height + 'px'
    }, containerStyle));
    (_a = graphCanvas.getContainer()) === null || _a === void 0 || _a.appendChild($container);
    return $container;
}
/**
 * <zh/> 计算容器位置
 *
 * <en/> Compute the position of the container
 * @param options - <zh/> 配置项 | <en/> options
 * @returns <zh/> 位置 | <en/> position
 */ function $43e3942eb7605b74$var$computePosition(options) {
    const { width: width, height: height, placement: placement, graphCanvas: graphCanvas } = options;
    const [W, H] = graphCanvas.getSize();
    const [xRatio, yRatio] = (0, $jtAhq.parsePlacement)(placement);
    return [
        xRatio * (W - width),
        yRatio * (H - height)
    ];
}

});


parcelRegister("gICz0", function(module, exports) {

$parcel$export(module.exports, "Minimap", () => $c2beab52a813427a$export$a8b4308ba35ee473);

var $2ZmO4 = parcelRequire("2ZmO4");
var $12lyH = parcelRequire("12lyH");
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $hn4z6 = parcelRequire("hn4z6");

var $brtTw = parcelRequire("brtTw");

var $1uR12 = parcelRequire("1uR12");

var $dnXls = parcelRequire("dnXls");

var $WdqOS = parcelRequire("WdqOS");

var $5Pn1Q = parcelRequire("5Pn1Q");
class $c2beab52a813427a$export$a8b4308ba35ee473 extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $c2beab52a813427a$export$a8b4308ba35ee473.defaultOptions, options));
        this.onDraw = (event)=>{
            var _a;
            if ((_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.render) return;
            this.onRender();
        };
        this.landmarkMap = new Map();
        this.mask = null;
        this.isMaskDragging = false;
        this.onMaskDragStart = (event)=>{
            if (!this.mask) return;
            this.isMaskDragging = true;
            this.mask.setPointerCapture(event.pointerId);
            this.mask.addEventListener('pointermove', this.onMaskDrag);
            this.mask.addEventListener('pointerup', this.onMaskDragEnd);
            this.mask.addEventListener('pointercancel', this.onMaskDragEnd);
        };
        this.onMaskDrag = (event)=>{
            if (!this.mask || !this.isMaskDragging) return;
            const { size: [minimapWidth, minimapHeight] } = this.options;
            const { movementX: movementX, movementY: movementY } = event;
            const { left: left, top: top, width: w, height: h } = this.mask.style;
            const [, , fullWidth, fullHeight] = this.maskBBox;
            let x = parseInt(left) + movementX;
            let y = parseInt(top) + movementY;
            let width = parseInt(w);
            let height = parseInt(h);
            // 确保 mask 在 minimap 内部
            // Ensure that the mask is inside the minimap
            if (x < 0) x = 0;
            if (y < 0) y = 0;
            if (x + width > minimapWidth) x = $c2beab52a813427a$var$lower(minimapWidth - width, 0);
            if (y + height > minimapHeight) y = $c2beab52a813427a$var$lower(minimapHeight - height, 0);
            // 当拖拽画布导致 mask 缩小时，拖拽 mask 时，能够恢复到实际大小
            // When dragging the canvas causes the mask to shrink, dragging the mask will restore it to its actual size
            if (width < fullWidth) {
                if (movementX > 0) {
                    x = $c2beab52a813427a$var$lower(x - movementX, 0);
                    width = $c2beab52a813427a$var$upper(width + movementX, minimapWidth);
                } else if (movementX < 0) width = $c2beab52a813427a$var$upper(width - movementX, minimapWidth);
            }
            if (height < fullHeight) {
                if (movementY > 0) {
                    y = $c2beab52a813427a$var$lower(y - movementY, 0);
                    height = $c2beab52a813427a$var$upper(height + movementY, minimapHeight);
                } else if (movementY < 0) height = $c2beab52a813427a$var$upper(height - movementY, minimapHeight);
            }
            Object.assign(this.mask.style, {
                left: x + 'px',
                top: y + 'px',
                width: width + 'px',
                height: height + 'px'
            });
            // 基于 movement 进行相对移动
            // Move relative to movement
            const deltaX = parseInt(left) - x;
            const deltaY = parseInt(top) - y;
            if (deltaX === 0 && deltaY === 0) return;
            const zoom1 = this.context.canvas.getCamera().getZoom();
            const zoom2 = this.canvas.getCamera().getZoom();
            const ratio = zoom1 / zoom2;
            this.context.graph.translateBy([
                deltaX * ratio,
                deltaY * ratio
            ], false);
        };
        this.onMaskDragEnd = (event)=>{
            if (!this.mask) return;
            this.isMaskDragging = false;
            this.mask.releasePointerCapture(event.pointerId);
            this.mask.removeEventListener('pointermove', this.onMaskDrag);
            this.mask.removeEventListener('pointerup', this.onMaskDragEnd);
            this.mask.removeEventListener('pointercancel', this.onMaskDragEnd);
        };
        this.onTransform = (0, $12lyH.default)(()=>{
            if (this.isMaskDragging) return;
            this.updateMask();
            this.setCamera();
        }, 32, {
            leading: true
        });
        this.setOnRender();
        this.bindEvents();
    }
    update(options) {
        this.unbindEvents();
        super.update(options);
        if ('delay' in options) this.setOnRender();
        this.bindEvents();
    }
    setOnRender() {
        this.onRender = (0, $2ZmO4.default)(()=>{
            this.renderMinimap();
            this.renderMask();
        }, this.options.delay);
    }
    bindEvents() {
        const { graph: graph } = this.context;
        graph.on((0, $4EzN9.GraphEvent).AFTER_DRAW, this.onDraw);
        graph.on((0, $4EzN9.GraphEvent).AFTER_RENDER, this.onRender);
        graph.on((0, $4EzN9.GraphEvent).AFTER_ANIMATE, this.onRender);
        graph.on((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.onTransform);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        graph.off((0, $4EzN9.GraphEvent).AFTER_DRAW, this.onDraw);
        graph.off((0, $4EzN9.GraphEvent).AFTER_RENDER, this.onRender);
        graph.off((0, $4EzN9.GraphEvent).AFTER_ANIMATE, this.onRender);
        graph.off((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, this.onTransform);
    }
    /**
     * <zh/> 创建或更新缩略图
     *
     * <en/> Create or update the minimap
     */ renderMinimap() {
        const data = this.getElements();
        const canvas = this.initCanvas();
        this.setShapes(canvas, data);
    }
    getElements() {
        const { filter: filter } = this.options;
        const { model: model, element: element } = this.context;
        const originData = model.getData();
        //过滤那些不存在于elementMap中的数据
        const data = {
            nodes: originData.nodes.filter((node)=>element === null || element === void 0 ? void 0 : element.getElement((0, $brtTw.idOf)(node))),
            edges: originData.edges.filter((edge)=>{
                const edgeElement = element === null || element === void 0 ? void 0 : element.getElement((0, $brtTw.idOf)(edge));
                // 边数据存在且可见时才保留
                return edgeElement && (0, $hn4z6.isVisible)(edgeElement);
            }),
            combos: originData.combos.filter((combo)=>element === null || element === void 0 ? void 0 : element.getElement((0, $brtTw.idOf)(combo)))
        };
        if (!filter) return data;
        const { nodes: nodes, edges: edges, combos: combos } = data;
        return {
            nodes: nodes.filter((node)=>filter((0, $brtTw.idOf)(node), 'node')),
            edges: edges.filter((edge)=>filter((0, $brtTw.idOf)(edge), 'edge')),
            combos: combos.filter((combo)=>filter((0, $brtTw.idOf)(combo), 'combo'))
        };
    }
    setShapes(canvas, data) {
        const { nodes: nodes, edges: edges, combos: combos } = data;
        const { shape: shape } = this.options;
        const { element: element } = this.context;
        const iterate = (datum, elType)=>{
            const id = (0, $brtTw.idOf)(datum);
            const target = element === null || element === void 0 ? void 0 : element.getElement(id);
            if (!target) return;
            const keyShape = target.getShape('key');
            let cloneShape;
            if (typeof shape === 'string') {
                const shapeName = shape;
                const miniShape = target.getShape(shapeName);
                cloneShape = miniShape.cloneNode();
            } else {
                const miniShape = shape(id, elType, target);
                if (miniShape === target) cloneShape = miniShape.cloneNode(true);
                else cloneShape = miniShape;
            }
            /**
             * 这里使用的是 keyShape 的位置
             * 对于整个元素的位置而言，使用 keyShape 位置会比较准确
             * 也比较合理
             */ cloneShape.setPosition(keyShape.getPosition());
            // keep zIndex / id
            if (target.style.zIndex) cloneShape.style.zIndex = target.style.zIndex;
            cloneShape.id = target.id;
            canvas.appendChild(cloneShape);
        };
        canvas.removeChildren();
        // 注意执行顺序 / Note the execution order
        edges.forEach((datum)=>iterate(datum, 'edge'));
        combos.forEach((datum)=>iterate(datum, 'combo'));
        nodes.forEach((datum)=>iterate(datum, 'node'));
    }
    initCanvas() {
        const { renderer: renderer, size: [width, height] } = this.options;
        if (this.canvas) {
            const { width: w, height: h } = this.canvas.getConfig();
            if (width !== w || height !== h) this.canvas.resize(width, height);
            if (renderer) this.canvas.setRenderer(renderer);
        } else {
            const { className: className, position: position, container: container, containerStyle: containerStyle } = this.options;
            const [$container, canvas] = (0, $5Pn1Q.createPluginCanvas)({
                renderer: renderer,
                width: width,
                height: height,
                placement: position,
                className: 'minimap',
                container: container,
                containerStyle: containerStyle,
                graphCanvas: this.context.canvas
            });
            if (className) $container.classList.add(className);
            this.container = $container;
            this.canvas = canvas;
        }
        this.setCamera();
        return this.canvas;
    }
    createLandmark(position, focalPoint, zoom) {
        const key = `${position.join(',')}-${focalPoint.join(',')}-${zoom}`;
        if (this.landmarkMap.has(key)) return this.landmarkMap.get(key);
        const camera = this.canvas.getCamera();
        const landmark = camera.createLandmark(key, {
            position: position,
            focalPoint: focalPoint,
            zoom: zoom
        });
        this.landmarkMap.set(key, landmark);
        return landmark;
    }
    setCamera() {
        var _a;
        const { canvas: canvas } = this.context;
        const camera = (_a = this.canvas) === null || _a === void 0 ? void 0 : _a.getCamera();
        if (!camera) return;
        const { size: [minimapWidth, minimapHeight], padding: padding } = this.options;
        const [top, right, bottom, left] = (0, $1uR12.parsePadding)(padding);
        const { min: boundsMin, max: boundsMax, center: center } = canvas.getBounds('elements');
        const boundsWidth = boundsMax[0] - boundsMin[0];
        const boundsHeight = boundsMax[1] - boundsMin[1];
        const availableWidth = minimapWidth - left - right;
        const availableHeight = minimapHeight - top - bottom;
        const scaleX = availableWidth / boundsWidth;
        const scaleY = availableHeight / boundsHeight;
        const scale = Math.min(scaleX, scaleY);
        const landmark = this.createLandmark(center, center, scale);
        camera.gotoLandmark(landmark, 0);
    }
    get maskBBox() {
        const { canvas: graphCanvas } = this.context;
        const canvasSize = graphCanvas.getSize();
        const canvasMin = graphCanvas.getCanvasByViewport([
            0,
            0
        ]);
        const canvasMax = graphCanvas.getCanvasByViewport(canvasSize);
        const maskMin = this.canvas.canvas2Viewport((0, $dnXls.toPointObject)(canvasMin));
        const maskMax = this.canvas.canvas2Viewport((0, $dnXls.toPointObject)(canvasMax));
        const width = maskMax.x - maskMin.x;
        const height = maskMax.y - maskMin.y;
        return [
            maskMin.x,
            maskMin.y,
            width,
            height
        ];
    }
    /**
     * <zh/> 计算遮罩包围盒
     *
     * <en/> Calculate the bounding box of the mask
     * @returns <zh/> 遮罩包围盒 | <en/> Mask bounding box
     */ calculateMaskBBox() {
        const { size: [minimapWidth, minimapHeight] } = this.options;
        let [x, y, width, height] = this.maskBBox;
        // clamp x, y, width, height
        if (x < 0) {
            width = $c2beab52a813427a$var$upper(width + x, minimapWidth);
            x = 0;
        }
        if (y < 0) {
            height = $c2beab52a813427a$var$upper(height + y, minimapHeight);
            y = 0;
        }
        if (x + width > minimapWidth) width = $c2beab52a813427a$var$lower(minimapWidth - x, 0);
        if (y + height > minimapHeight) height = $c2beab52a813427a$var$lower(minimapHeight - y, 0);
        return [
            $c2beab52a813427a$var$upper(x, minimapWidth),
            $c2beab52a813427a$var$upper(y, minimapHeight),
            $c2beab52a813427a$var$lower(width, 0),
            $c2beab52a813427a$var$lower(height, 0)
        ];
    }
    /**
     * <zh/> 创建或更新遮罩
     *
     * <en/> Create or update the mask
     */ renderMask() {
        const { maskStyle: maskStyle } = this.options;
        if (!this.mask) {
            this.mask = document.createElement('div');
            this.mask.addEventListener('pointerdown', this.onMaskDragStart);
            this.mask.draggable = true;
            this.mask.addEventListener('dragstart', (event)=>event.preventDefault && event.preventDefault());
        }
        this.container.appendChild(this.mask);
        Object.assign(this.mask.style, Object.assign(Object.assign({}, maskStyle), {
            cursor: 'move',
            position: 'absolute',
            pointerEvents: 'auto'
        }));
        this.updateMask();
    }
    updateMask() {
        if (!this.mask) return;
        const [x, y, width, height] = this.calculateMaskBBox();
        Object.assign(this.mask.style, {
            top: y + 'px',
            left: x + 'px',
            width: width + 'px',
            height: height + 'px'
        });
    }
    destroy() {
        var _a, _b, _c;
        this.unbindEvents();
        (_a = this.canvas) === null || _a === void 0 || _a.destroy();
        (_b = this.mask) === null || _b === void 0 || _b.remove();
        (_c = this.container) === null || _c === void 0 || _c.remove();
        super.destroy();
    }
}
$c2beab52a813427a$export$a8b4308ba35ee473.defaultOptions = {
    size: [
        240,
        160
    ],
    shape: 'key',
    padding: 10,
    position: 'right-bottom',
    maskStyle: {
        border: '1px solid #ddd',
        background: 'rgba(0, 0, 0, 0.1)'
    },
    containerStyle: {
        border: '1px solid #ddd',
        background: '#fff'
    },
    delay: 128
};
const $c2beab52a813427a$var$upper = (value, max)=>Math.min(value, max);
const $c2beab52a813427a$var$lower = (value, min)=>Math.max(value, min);

});

parcelRegister("bU3Ie", function(module, exports) {

$parcel$export(module.exports, "Snapline", () => $8aa7cde132b471ea$export$6e87dce409707f6e);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $4ETMA = parcelRequire("4ETMA");
parcelRequire("ahJ7k");
var $eO2am = parcelRequire("eO2am");

var $hn4z6 = parcelRequire("hn4z6");

var $dOidW = parcelRequire("dOidW");

var $WdqOS = parcelRequire("WdqOS");
var $8aa7cde132b471ea$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8aa7cde132b471ea$var$defaultLineStyle = {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    visibility: 'hidden'
};
class $8aa7cde132b471ea$export$6e87dce409707f6e extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $8aa7cde132b471ea$export$6e87dce409707f6e.defaultOptions, options));
        this.initSnapline = ()=>{
            const canvas = this.context.canvas.getLayer('transient');
            if (!this.horizontalLine) this.horizontalLine = canvas.appendChild(new (0, $2eDEB.Line)({
                style: Object.assign(Object.assign({}, $8aa7cde132b471ea$var$defaultLineStyle), this.options.horizontalLineStyle)
            }));
            if (!this.verticalLine) this.verticalLine = canvas.appendChild(new (0, $2eDEB.Line)({
                style: Object.assign(Object.assign({}, $8aa7cde132b471ea$var$defaultLineStyle), this.options.verticalLineStyle)
            }));
        };
        this.isHorizontalSticking = false;
        this.isVerticalSticking = false;
        this.enableStick = true;
        this.autoSnapToLine = (nodeId, bbox, metadata)=>$8aa7cde132b471ea$var$__awaiter(this, void 0, void 0, function*() {
                const { verticalX: verticalX, horizontalY: horizontalY } = metadata;
                const { tolerance: tolerance } = this.options;
                const { min: [nodeMinX, nodeMinY], max: [nodeMaxX, nodeMaxY], center: [nodeCenterX, nodeCenterY] } = bbox;
                let dx = 0;
                let dy = 0;
                if (verticalX !== null) {
                    if ($8aa7cde132b471ea$var$distance(nodeMaxX, verticalX) < tolerance) dx = verticalX - nodeMaxX;
                    if ($8aa7cde132b471ea$var$distance(nodeMinX, verticalX) < tolerance) dx = verticalX - nodeMinX;
                    if ($8aa7cde132b471ea$var$distance(nodeCenterX, verticalX) < tolerance) dx = verticalX - nodeCenterX;
                    if (dx !== 0) this.isVerticalSticking = true;
                }
                if (horizontalY !== null) {
                    if ($8aa7cde132b471ea$var$distance(nodeMaxY, horizontalY) < tolerance) dy = horizontalY - nodeMaxY;
                    if ($8aa7cde132b471ea$var$distance(nodeMinY, horizontalY) < tolerance) dy = horizontalY - nodeMinY;
                    if ($8aa7cde132b471ea$var$distance(nodeCenterY, horizontalY) < tolerance) dy = horizontalY - nodeCenterY;
                    if (dy !== 0) this.isHorizontalSticking = true;
                }
                if (dx !== 0 || dy !== 0) // Stick to the line
                yield this.context.graph.translateElementBy({
                    [nodeId]: [
                        dx,
                        dy
                    ]
                }, false);
            });
        this.enableSnap = (event)=>{
            const { target: target } = event;
            const threshold = 0.5;
            if (this.isHorizontalSticking || this.isVerticalSticking) {
                const [dx, dy] = this.getDelta(event);
                if (this.isHorizontalSticking && this.isVerticalSticking && Math.abs(dx) <= threshold && Math.abs(dy) <= threshold) {
                    this.context.graph.translateElementBy({
                        [target.id]: [
                            -dx,
                            -dy
                        ]
                    }, false);
                    return false;
                } else if (this.isHorizontalSticking && Math.abs(dy) <= threshold) {
                    this.context.graph.translateElementBy({
                        [target.id]: [
                            0,
                            -dy
                        ]
                    }, false);
                    return false;
                } else if (this.isVerticalSticking && Math.abs(dx) <= threshold) {
                    this.context.graph.translateElementBy({
                        [target.id]: [
                            -dx,
                            0
                        ]
                    }, false);
                    return false;
                } else {
                    this.isHorizontalSticking = false;
                    this.isVerticalSticking = false;
                    this.enableStick = false;
                    setTimeout(()=>{
                        this.enableStick = true;
                    }, 200);
                }
            }
            return this.enableStick;
        };
        this.calcSnaplineMetadata = (target, nodeBBox)=>{
            const { tolerance: tolerance, shape: shape } = this.options;
            const { min: [nodeMinX, nodeMinY], max: [nodeMaxX, nodeMaxY], center: [nodeCenterX, nodeCenterY] } = nodeBBox;
            let verticalX = null;
            let verticalMinY = null;
            let verticalMaxY = null;
            let horizontalY = null;
            let horizontalMinX = null;
            let horizontalMaxX = null;
            this.getNodes().some((snapNode)=>{
                if ((0, $4ETMA.default)(target.id, snapNode.id)) return false;
                const snapBBox = $8aa7cde132b471ea$var$getShape(snapNode, shape).getRenderBounds();
                const { min: [snapMinX, snapMinY], max: [snapMaxX, snapMaxY], center: [snapCenterX, snapCenterY] } = snapBBox;
                if (verticalX === null) {
                    if ($8aa7cde132b471ea$var$distance(snapCenterX, nodeCenterX) < tolerance) verticalX = snapCenterX;
                    else if ($8aa7cde132b471ea$var$distance(snapMinX, nodeMinX) < tolerance) verticalX = snapMinX;
                    else if ($8aa7cde132b471ea$var$distance(snapMinX, nodeMaxX) < tolerance) verticalX = snapMinX;
                    else if ($8aa7cde132b471ea$var$distance(snapMaxX, nodeMaxX) < tolerance) verticalX = snapMaxX;
                    else if ($8aa7cde132b471ea$var$distance(snapMaxX, nodeMinX) < tolerance) verticalX = snapMaxX;
                    if (verticalX !== null) {
                        verticalMinY = Math.min(snapMinY, nodeMinY);
                        verticalMaxY = Math.max(snapMaxY, nodeMaxY);
                    }
                }
                if (horizontalY === null) {
                    if ($8aa7cde132b471ea$var$distance(snapCenterY, nodeCenterY) < tolerance) horizontalY = snapCenterY;
                    else if ($8aa7cde132b471ea$var$distance(snapMinY, nodeMinY) < tolerance) horizontalY = snapMinY;
                    else if ($8aa7cde132b471ea$var$distance(snapMinY, nodeMaxY) < tolerance) horizontalY = snapMinY;
                    else if ($8aa7cde132b471ea$var$distance(snapMaxY, nodeMaxY) < tolerance) horizontalY = snapMaxY;
                    else if ($8aa7cde132b471ea$var$distance(snapMaxY, nodeMinY) < tolerance) horizontalY = snapMaxY;
                    if (horizontalY !== null) {
                        horizontalMinX = Math.min(snapMinX, nodeMinX);
                        horizontalMaxX = Math.max(snapMaxX, nodeMaxX);
                    }
                }
                return verticalX !== null && horizontalY !== null;
            });
            return {
                verticalX: verticalX,
                verticalMinY: verticalMinY,
                verticalMaxY: verticalMaxY,
                horizontalY: horizontalY,
                horizontalMinX: horizontalMinX,
                horizontalMaxX: horizontalMaxX
            };
        };
        this.onDragStart = ()=>{
            this.initSnapline();
        };
        this.onDrag = (event)=>$8aa7cde132b471ea$var$__awaiter(this, void 0, void 0, function*() {
                const { target: target } = event;
                if (this.options.autoSnap) {
                    const enable = this.enableSnap(event);
                    if (!enable) return;
                }
                const nodeBBox = $8aa7cde132b471ea$var$getShape(target, this.options.shape).getRenderBounds();
                const metadata = this.calcSnaplineMetadata(target, nodeBBox);
                this.hideSnapline();
                if (metadata.verticalX !== null || metadata.horizontalY !== null) this.updateSnapline(metadata);
                if (this.options.autoSnap) yield this.autoSnapToLine(target.id, nodeBBox, metadata);
            });
        this.onDragEnd = ()=>{
            this.hideSnapline();
        };
        this.bindEvents();
    }
    getNodes() {
        var _a;
        const { filter: filter } = this.options;
        const allNodes = ((_a = this.context.element) === null || _a === void 0 ? void 0 : _a.getNodes()) || [];
        // 不考虑超出画布视口范围、不可见的节点
        // Nodes that are out of the canvas viewport range, invisible are not considered
        const nodes = allNodes.filter((node)=>{
            var _a;
            return (0, $hn4z6.isVisible)(node) && ((_a = this.context.viewport) === null || _a === void 0 ? void 0 : _a.isInViewport(node.getRenderBounds()));
        });
        if (!filter) return nodes;
        return nodes.filter((node)=>filter(node));
    }
    hideSnapline() {
        this.horizontalLine.style.visibility = 'hidden';
        this.verticalLine.style.visibility = 'hidden';
    }
    getLineWidth(direction) {
        const { lineWidth: lineWidth } = this.options[`${direction}LineStyle`];
        return +(lineWidth || $8aa7cde132b471ea$var$defaultLineStyle.lineWidth || 1) / this.context.graph.getZoom();
    }
    updateSnapline(metadata) {
        const { verticalX: verticalX, verticalMinY: verticalMinY, verticalMaxY: verticalMaxY, horizontalY: horizontalY, horizontalMinX: horizontalMinX, horizontalMaxX: horizontalMaxX } = metadata;
        const [canvasWidth, canvasHeight] = this.context.canvas.getSize();
        const { offset: offset } = this.options;
        if (horizontalY !== null) Object.assign(this.horizontalLine.style, {
            x1: offset === Infinity ? 0 : horizontalMinX - offset,
            y1: horizontalY,
            x2: offset === Infinity ? canvasWidth : horizontalMaxX + offset,
            y2: horizontalY,
            visibility: 'visible',
            lineWidth: this.getLineWidth('horizontal')
        });
        else this.horizontalLine.style.visibility = 'hidden';
        if (verticalX !== null) Object.assign(this.verticalLine.style, {
            x1: verticalX,
            y1: offset === Infinity ? 0 : verticalMinY - offset,
            x2: verticalX,
            y2: offset === Infinity ? canvasHeight : verticalMaxY + offset,
            visibility: 'visible',
            lineWidth: this.getLineWidth('vertical')
        });
        else this.verticalLine.style.visibility = 'hidden';
    }
    /**
     * Get the delta of the drag
     * @param event - drag event object
     * @returns delta
     * @internal
     */ getDelta(event) {
        const zoom = this.context.graph.getZoom();
        return (0, $dOidW.divide)([
            event.dx,
            event.dy
        ], zoom);
    }
    bindEvents() {
        return $8aa7cde132b471ea$var$__awaiter(this, void 0, void 0, function*() {
            const { graph: graph } = this.context;
            graph.on((0, $eO2am.NodeEvent).DRAG_START, this.onDragStart);
            graph.on((0, $eO2am.NodeEvent).DRAG, this.onDrag);
            graph.on((0, $eO2am.NodeEvent).DRAG_END, this.onDragEnd);
        });
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        graph.off((0, $eO2am.NodeEvent).DRAG_START, this.onDragStart);
        graph.off((0, $eO2am.NodeEvent).DRAG, this.onDrag);
        graph.off((0, $eO2am.NodeEvent).DRAG_END, this.onDragEnd);
    }
    destroyElements() {
        var _a, _b;
        (_a = this.horizontalLine) === null || _a === void 0 || _a.destroy();
        (_b = this.verticalLine) === null || _b === void 0 || _b.destroy();
    }
    destroy() {
        this.destroyElements();
        this.unbindEvents();
        super.destroy();
    }
}
$8aa7cde132b471ea$export$6e87dce409707f6e.defaultOptions = {
    tolerance: 5,
    offset: 20,
    autoSnap: true,
    shape: 'key',
    verticalLineStyle: {
        stroke: '#1783FF'
    },
    horizontalLineStyle: {
        stroke: '#1783FF'
    },
    filter: ()=>true
};
const $8aa7cde132b471ea$var$distance = (a, b)=>Math.abs(a - b);
const $8aa7cde132b471ea$var$getShape = (node, shapeFilter)=>{
    return typeof shapeFilter === 'function' ? shapeFilter(node) : node.getShape(shapeFilter);
};

});

parcelRegister("7Ns1A", function(module, exports) {

$parcel$export(module.exports, "Timebar", () => $5ad2d91fcdab255a$export$c3bc4d4ebfc8f2a);

var $7YpVo = parcelRequire("7YpVo");

var $1uF5a = parcelRequire("1uF5a");
var $fx0bg = parcelRequire("fx0bg");
var $jyI49 = parcelRequire("jyI49");

var $brtTw = parcelRequire("brtTw");

var $1uR12 = parcelRequire("1uR12");

var $WdqOS = parcelRequire("WdqOS");

var $5Pn1Q = parcelRequire("5Pn1Q");
var $5ad2d91fcdab255a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $5ad2d91fcdab255a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $5ad2d91fcdab255a$var$prospectiveTimeKeys = [
    'timestamp',
    'time',
    'date',
    'datetime'
];
class $5ad2d91fcdab255a$export$c3bc4d4ebfc8f2a extends (0, $WdqOS.BasePlugin) {
    get padding() {
        return (0, $1uR12.parsePadding)(this.options.padding);
    }
    constructor(context, options){
        super(context, Object.assign({}, $5ad2d91fcdab255a$export$c3bc4d4ebfc8f2a.defaultOptions, options));
        this.backup();
        this.upsertTimebar();
    }
    /**
     * <zh/> 播放
     *
     * <en/> Play
     */ play() {
        var _a;
        (_a = this.timebar) === null || _a === void 0 || _a.play();
    }
    /**
     * <zh/> 暂停
     *
     * <en/> Pause
     */ pause() {
        var _a;
        (_a = this.timebar) === null || _a === void 0 || _a.pause();
    }
    /**
     * <zh/> 前进
     *
     * <en/> Forward
     */ forward() {
        var _a;
        (_a = this.timebar) === null || _a === void 0 || _a.forward();
    }
    /**
     * <zh/> 后退
     *
     * <en/> Backward
     */ backward() {
        var _a;
        (_a = this.timebar) === null || _a === void 0 || _a.backward();
    }
    /**
     * <zh/> 重置
     *
     * <en/> Reset
     */ reset() {
        var _a;
        (_a = this.timebar) === null || _a === void 0 || _a.reset();
    }
    /**
     * <zh/> 更新时间条配置项
     *
     * <en/> Update timebar configuration options
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */ update(options) {
        super.update(options);
        this.backup();
        this.upsertTimebar();
    }
    /**
     * <zh/> 备份数据
     *
     * <en/> Backup data
     */ backup() {
        this.originalData = $5ad2d91fcdab255a$var$shallowCopy(this.context.graph.getData());
    }
    upsertTimebar() {
        const { canvas: canvas } = this.context;
        const _a = this.options, { onChange: onChange, timebarType: timebarType, data: data, x: x, y: y, width: width, height: height, mode: mode } = _a, restOptions = $5ad2d91fcdab255a$var$__rest(_a, [
            "onChange",
            "timebarType",
            "data",
            "x",
            "y",
            "width",
            "height",
            "mode"
        ]);
        const canvasSize = canvas.getSize();
        const [top] = this.padding;
        this.upsertCanvas().ready.then(()=>{
            var _a;
            const style = Object.assign(Object.assign({
                x: canvasSize[0] / 2 - width / 2,
                y: top,
                onChange: (value)=>{
                    const range = ((0, $1uF5a.default)(value) ? value : [
                        value,
                        value
                    ]).map((time)=>(0, $fx0bg.default)(time) ? time.getTime() : time);
                    if (this.options.mode === 'modify') this.filterElements(range);
                    else this.hiddenElements(range);
                    onChange === null || onChange === void 0 || onChange(range);
                }
            }, restOptions), {
                data: data.map((datum)=>(0, $jyI49.default)(datum) ? {
                        time: datum,
                        value: 0
                    } : datum),
                width: width,
                height: height,
                type: timebarType
            });
            if (!this.timebar) {
                this.timebar = new (0, $7YpVo.Timebar)({
                    style: style
                });
                (_a = this.canvas) === null || _a === void 0 || _a.appendChild(this.timebar);
            } else this.timebar.update(style);
        });
    }
    upsertCanvas() {
        if (this.canvas) return this.canvas;
        const { className: className, height: height, position: position } = this.options;
        const graphCanvas = this.context.canvas;
        const [width] = graphCanvas.getSize();
        const [top, , bottom] = this.padding;
        const [$container, canvas] = (0, $5Pn1Q.createPluginCanvas)({
            width: width,
            height: height + top + bottom,
            graphCanvas: graphCanvas,
            className: 'timebar',
            placement: position
        });
        this.container = $container;
        if (className) $container.classList.add(className);
        this.canvas = canvas;
        return this.canvas;
    }
    filterElements(range) {
        return $5ad2d91fcdab255a$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (!this.originalData) return;
            const { elementTypes: elementTypes, getTime: getTime } = this.options;
            const { graph: graph, element: element } = this.context;
            const newData = $5ad2d91fcdab255a$var$shallowCopy(this.originalData);
            elementTypes.forEach((type)=>{
                const key = `${type}s`;
                newData[key] = (this.originalData[key] || []).filter((datum)=>{
                    const time = getTime(datum);
                    if ($5ad2d91fcdab255a$var$match(time, range)) return true;
                    return false;
                });
            });
            const nodeLikeIds = [
                ...newData.nodes,
                ...newData.combos
            ].map((datum)=>(0, $brtTw.idOf)(datum));
            newData.edges = newData.edges.filter((edge)=>{
                const source = edge.source;
                const target = edge.target;
                return nodeLikeIds.includes(source) && nodeLikeIds.includes(target);
            });
            graph.setData(newData);
            yield (_a = element.draw({
                animation: false,
                silence: true
            })) === null || _a === void 0 ? void 0 : _a.finished;
        });
    }
    hiddenElements(range) {
        const { graph: graph } = this.context;
        const { elementTypes: elementTypes, getTime: getTime } = this.options;
        const hideElementId = [];
        const showElementId = [];
        elementTypes.forEach((elementType)=>{
            var _a;
            const key = `${elementType}s`;
            const elementData = ((_a = this.originalData) === null || _a === void 0 ? void 0 : _a[key]) || [];
            elementData.forEach((elementDatum)=>{
                const id = (0, $brtTw.idOf)(elementDatum);
                const time = getTime(elementDatum);
                if ($5ad2d91fcdab255a$var$match(time, range)) showElementId.push(id);
                else hideElementId.push(id);
            });
        });
        graph.hideElement(hideElementId, false);
        graph.showElement(showElementId, false);
    }
    /**
     * <zh/> 销毁时间条
     *
     * <en/> Destroy the timebar
     * @internal
     */ destroy() {
        var _a, _b, _c;
        const { graph: graph } = this.context;
        this.originalData && graph.setData(Object.assign({}, this.originalData));
        (_a = this.timebar) === null || _a === void 0 || _a.destroy();
        (_b = this.canvas) === null || _b === void 0 || _b.destroy();
        (_c = this.container) === null || _c === void 0 || _c.remove();
        this.originalData = undefined;
        this.container = undefined;
        this.timebar = undefined;
        this.canvas = undefined;
        super.destroy();
    }
}
$5ad2d91fcdab255a$export$c3bc4d4ebfc8f2a.defaultOptions = {
    position: 'bottom',
    enable: true,
    timebarType: 'time',
    className: 'g6-timebar',
    width: 450,
    height: 60,
    zIndex: 3,
    elementTypes: [
        'node'
    ],
    padding: 10,
    mode: 'modify',
    getTime: (datum)=>$5ad2d91fcdab255a$var$inferTime(datum, $5ad2d91fcdab255a$var$prospectiveTimeKeys, undefined),
    loop: false
};
const $5ad2d91fcdab255a$var$shallowCopy = (data)=>{
    const { nodes: nodes = [], edges: edges = [], combos: combos = [] } = data;
    return {
        nodes: [
            ...nodes
        ],
        edges: [
            ...edges
        ],
        combos: [
            ...combos
        ]
    };
};
const $5ad2d91fcdab255a$var$match = (time, range)=>{
    if ((0, $jyI49.default)(range)) return time === range;
    const [start, end] = range;
    return time >= start && time <= end;
};
const $5ad2d91fcdab255a$var$inferTime = (datum, optionsKeys, defaultValue)=>{
    var _a;
    for(let i = 0; i < optionsKeys.length; i++){
        const key = optionsKeys[i];
        const val = (_a = datum.data) === null || _a === void 0 ? void 0 : _a[key];
        if (val) return val;
    }
    return defaultValue;
};

});
parcelRegister("7YpVo", function(module, exports) {

$parcel$export(module.exports, "Timebar", () => $5ce23f18654d97d1$export$c3bc4d4ebfc8f2a);

var $7WQrb = parcelRequire("7WQrb");

var $8hhuV = parcelRequire("8hhuV");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $7agTx = parcelRequire("7agTx");
var $6LvUc = parcelRequire("6LvUc");
var $c6FtR = parcelRequire("c6FtR");
var $8UxPj = parcelRequire("8UxPj");

var $7v2I9 = parcelRequire("7v2I9");

var $3rtR3 = parcelRequire("3rtR3");

var $aHmUQ = parcelRequire("aHmUQ");

var $bQmzU = parcelRequire("bQmzU");

var $eyxXn = parcelRequire("eyxXn");
var $5ce23f18654d97d1$export$c3bc4d4ebfc8f2a = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Timebar, _super);
    function Timebar(options) {
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, Timebar.defaultOptions, options)) || this;
        _this.axis = _this.appendChild(new (0, $7v2I9.Axis)({
            style: {
                type: 'linear',
                startPos: [
                    0,
                    0
                ],
                endPos: [
                    0,
                    0
                ],
                data: [],
                showArrow: false,
                animate: false
            }
        }));
        /** 时间线 group，用于放置 timeline 或者 chart */ _this.timeline = _this.appendChild(new (0, $3rtR3.Slider)({
            style: {
                onChange: function(values) {
                    _this.handleSliderChange(values);
                }
            }
        }));
        _this.controller = _this.appendChild(new (0, $aHmUQ.Controller)({}));
        _this.states = {};
        _this.handleSliderChange = function(values) {
            var prevValues = function() {
                var val = _this.states.values;
                if (Array.isArray(val)) return (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(val), false);
                return val;
            }();
            _this.setBySliderValues(values);
            _this.dispatchOnChange(prevValues);
        };
        var _a = _this.attributes, selectionType = _a.selectionType, chartType = _a.chartType, speed = _a.speed, state = _a.state, playMode = _a.playMode, values = _a.values;
        _this.states = {
            chartType: chartType,
            playMode: playMode,
            selectionType: selectionType,
            speed: speed,
            state: state
        };
        _this.setByTimebarValues(values);
        return _this;
    }
    Object.defineProperty(Timebar.prototype, "data", {
        get: function() {
            var data = this.attributes.data;
            var compareFn = function(a, b) {
                if (a.time < b.time) return -1;
                if (a.time > b.time) return 1;
                return 0;
            };
            return data.sort(compareFn);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timebar.prototype, "space", {
        /** 计算空间分配 */ get: function() {
            var _a = this.attributes, x = _a.x, y = _a.y, width = _a.width, height = _a.height, type = _a.type, controllerHeight = _a.controllerHeight;
            var availableTimelineHeight = (0, $8hhuV.default)(+height - controllerHeight, 0, +height);
            var controllerBBox = new (0, $7agTx.BBox)(x, y + +height - controllerHeight, +width, controllerHeight);
            // chart 模式下可用
            var axisBBox;
            var axisHeight = 0;
            if (type === 'chart') {
                // axis 默认分配高度为 35
                axisHeight = 35;
                axisBBox = new (0, $7agTx.BBox)(x, y + availableTimelineHeight - axisHeight, +width, axisHeight);
            } else axisBBox = new (0, $7agTx.BBox)();
            var timelineHeight = type === 'time' ? 10 : availableTimelineHeight;
            var timelineBBox = new (0, $7agTx.BBox)(x, y + (type === 'time' ? availableTimelineHeight : availableTimelineHeight - timelineHeight), +width, timelineHeight - axisHeight);
            return {
                axisBBox: axisBBox,
                controllerBBox: controllerBBox,
                timelineBBox: timelineBBox
            };
        },
        enumerable: false,
        configurable: true
    });
    Timebar.prototype.setBySliderValues = function(val) {
        var _a, _b;
        var data = this.data;
        var _c = (0, $7WQrb.__read)(Array.isArray(val) ? val : [
            0,
            val
        ], 2), startRatio = _c[0], endRatio = _c[1];
        var length = data.length;
        var startDatum = data[Math.floor(startRatio * length)];
        var endDatum = data[Math.ceil(endRatio * length) - (Array.isArray(val) ? 0 : 1)];
        // 如果 endDatum 不存在，则其已经比最大的时间范围更大
        this.states.values = [
            (_a = startDatum === null || startDatum === void 0 ? void 0 : startDatum.time) !== null && _a !== void 0 ? _a : data[0].time,
            (_b = endDatum === null || endDatum === void 0 ? void 0 : endDatum.time) !== null && _b !== void 0 ? _b : Infinity
        ];
    };
    Timebar.prototype.setByTimebarValues = function(val) {
        var _a, _b, _c;
        var data = this.data;
        var _d = (0, $7WQrb.__read)(Array.isArray(val) ? val : [
            undefined,
            val
        ], 2), start = _d[0], end = _d[1];
        var startDatum = data.find(function(_a) {
            var time = _a.time;
            return time === start;
        });
        var endDatum = data.find(function(_a) {
            var time = _a.time;
            return time === end;
        });
        this.states.values = [
            (_a = startDatum === null || startDatum === void 0 ? void 0 : startDatum.time) !== null && _a !== void 0 ? _a : (_b = data[0]) === null || _b === void 0 ? void 0 : _b.time,
            (_c = endDatum === null || endDatum === void 0 ? void 0 : endDatum.time) !== null && _c !== void 0 ? _c : Infinity
        ];
    };
    Timebar.prototype.setByIndex = function(index) {
        var _a, _b, _c, _d;
        var data = this.data;
        var _e = (0, $7WQrb.__read)(index, 2), startIndex = _e[0], endIndex = _e[1];
        this.states.values = [
            (_b = (_a = data[startIndex]) === null || _a === void 0 ? void 0 : _a.time) !== null && _b !== void 0 ? _b : data[0].time,
            (_d = (_c = this.data[endIndex]) === null || _c === void 0 ? void 0 : _c.time) !== null && _d !== void 0 ? _d : Infinity
        ];
    };
    Object.defineProperty(Timebar.prototype, "sliderValues", {
        /**
         * 获取 timebar 的 values
         */ get: function() {
            var _a = this.states, values = _a.values, selectionType = _a.selectionType;
            var _b = (0, $7WQrb.__read)(Array.isArray(values) ? values : [
                undefined,
                values
            ], 2), start = _b[0], end = _b[1];
            var data = this.data;
            var length = data.length;
            var isValue = selectionType === 'value';
            var getStartValue = function() {
                var startDatumIndex = data.findIndex(function(_a) {
                    var time = _a.time;
                    return time === start;
                });
                if (isValue) return 0;
                if (startDatumIndex > -1) return startDatumIndex / length;
                // value 模式下默认取 0
                return 0;
            };
            var getEndValue = function() {
                if (end === Infinity) return 1;
                var endDatumIndex = data.findIndex(function(_a) {
                    var time = _a.time;
                    return time === end;
                });
                if (endDatumIndex > -1) return endDatumIndex / length;
                // range 模式下默认取 1，value 模式下默认取 0.5
                if (isValue) return 0.5;
                return 1;
            };
            return [
                getStartValue(),
                getEndValue()
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Timebar.prototype, "values", {
        get: function() {
            var _a = this.states, values = _a.values, selectionType = _a.selectionType;
            var _b = (0, $7WQrb.__read)(Array.isArray(values) ? values : [
                this.data[0].time,
                values
            ], 2), start = _b[0], end = _b[1];
            if (selectionType === 'value') return end;
            return [
                start,
                end
            ];
        },
        enumerable: false,
        configurable: true
    });
    Timebar.prototype.getDatumByRatio = function(ratio) {
        var data = this.data;
        var length = data.length;
        var index = Math.floor(ratio * (length - 1));
        return data[index];
    };
    Object.defineProperty(Timebar.prototype, "chartHandleIconShape", {
        get: function() {
            var selectionType = this.states.selectionType;
            var height = this.space.timelineBBox.height;
            if (selectionType === 'range') return function(type) {
                return new (0, $bQmzU.ChartModeHandle)({
                    style: {
                        type: type,
                        height: height,
                        iconSize: height / 6
                    }
                });
            };
            return function() {
                return new (0, $2eDEB.Line)({
                    style: {
                        x1: 0,
                        y1: -height / 2,
                        x2: 0,
                        y2: height / 2,
                        lineWidth: 2,
                        stroke: '#c8c8c8'
                    }
                });
            };
        },
        enumerable: false,
        configurable: true
    });
    Timebar.prototype.getChartStyle = function(bbox) {
        var _this = this;
        var x = bbox.x, y = bbox.y, width = bbox.width, height = bbox.height;
        var _a = this.states, selectionType = _a.selectionType, chartType = _a.chartType;
        var data = this.data;
        var _b = this.attributes, type = _b.type, userDefinedLabelFormatter = _b.labelFormatter;
        var _c = (0, $8UxPj.subStyleProps)(this.attributes, 'chart'), ignoreType = _c.type, userDefinedChartStyle = (0, $7WQrb.__rest)(_c, [
            "type"
        ]);
        var isRange = selectionType === 'range';
        if (type === 'time') return (0, $7WQrb.__assign)({
            handleIconShape: function() {
                return new (0, $bQmzU.TimeModeHandle)({});
            },
            selectionFill: '#2e7ff8',
            selectionFillOpacity: 1,
            showLabelOnInteraction: true,
            handleLabelDy: isRange ? -15 : 0,
            autoFitLabel: isRange,
            handleSpacing: isRange ? -15 : 0,
            trackFill: '#edeeef',
            trackLength: width,
            trackOpacity: 0.5,
            trackRadius: height / 2,
            trackSize: height / 2,
            type: selectionType,
            values: this.sliderValues,
            formatter: function(value) {
                if (userDefinedLabelFormatter) return userDefinedLabelFormatter(value);
                var time = _this.getDatumByRatio(value).time;
                if (typeof time === 'number') return (0, $eyxXn.parseBySeries)(time);
                return (0, $c6FtR.formatTime)(time, 'YYYY-MM-DD HH:mm:ss');
            },
            transform: "translate(".concat(x, ", ").concat(y, ")"),
            // x,
            // y,
            zIndex: 1
        }, userDefinedChartStyle);
        // type === 'chart'
        var handleIconOffset = selectionType === 'range' ? 5 : 0;
        var sparklineData = data.map(function(_a) {
            var value = _a.value;
            return value;
        });
        return (0, $7WQrb.__assign)({
            handleIconOffset: handleIconOffset,
            handleIconShape: this.chartHandleIconShape,
            selectionFill: '#fff',
            selectionFillOpacity: 0.5,
            selectionType: 'invert',
            sparklineSpacing: 0.1,
            sparklineColumnLineWidth: 0,
            sparklineColor: '#d4e5fd',
            sparklineAreaOpacity: 1,
            sparklineAreaLineWidth: 0,
            sparklineData: sparklineData,
            sparklineType: chartType,
            sparklineScale: 0.8,
            trackLength: width,
            trackSize: height,
            type: selectionType,
            values: this.sliderValues,
            // x,
            // y,
            transform: "translate(".concat(x, ", ").concat(y, ")"),
            zIndex: 1
        }, userDefinedChartStyle);
    };
    Timebar.prototype.renderChart = function(bbox) {
        if (bbox === void 0) bbox = this.space.timelineBBox;
        this.timeline.update(this.getChartStyle(bbox));
    };
    Timebar.prototype.updateSelection = function() {
        this.timeline.setValues(this.sliderValues, true);
        this.handleSliderChange(this.sliderValues);
    };
    Timebar.prototype.getAxisStyle = function(bbox) {
        var data = this.data;
        var _a = this.attributes, interval = _a.interval, userDefinedLabelFormatter = _a.labelFormatter;
        var userDefinedAxisStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'axis');
        var x = bbox.x, y = bbox.y, width = bbox.width;
        // 需要补一个刻度
        var axisData = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(data), false), [
            {
                time: 0
            }
        ], false).map(function(_a, index, arr) {
            var time = _a.time;
            return {
                label: "".concat(time),
                value: index / (arr.length - 1),
                time: time
            };
        });
        var style = (0, $7WQrb.__assign)({
            startPos: [
                x,
                y
            ],
            endPos: [
                x + width,
                y
            ],
            data: axisData,
            // hide last label
            labelFilter: function(_datum, index) {
                return index < axisData.length - 1;
            },
            labelFormatter: function(_a) {
                var time = _a.time;
                return userDefinedLabelFormatter ? userDefinedLabelFormatter(time) : (0, $eyxXn.labelFormatter)(time, interval);
            }
        }, userDefinedAxisStyle);
        return style;
    };
    Timebar.prototype.renderAxis = function(bbox) {
        if (bbox === void 0) bbox = this.space.axisBBox;
        var type = this.attributes.type;
        if (type !== 'chart') return;
        this.axis.update(this.getAxisStyle(bbox));
    };
    Timebar.prototype.renderController = function(bbox) {
        if (bbox === void 0) bbox = this.space.controllerBBox;
        var type = this.attributes.type;
        var _a = this.states, state = _a.state, speed = _a.speed, selectionType = _a.selectionType, chartType = _a.chartType;
        var userDefinedControllerStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'controller');
        var that = this;
        var style = (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, bbox), {
            iconSize: 20,
            speed: speed,
            state: state,
            selectionType: selectionType,
            chartType: chartType,
            onChange: function(type, _a) {
                var value = _a.value;
                switch(type){
                    case 'reset':
                        that.internalReset();
                        break;
                    case 'speed':
                        that.handleSpeedChange(value);
                        break;
                    case 'backward':
                        that.internalBackward();
                        break;
                    case 'playPause':
                        if (value === 'play') that.internalPlay();
                        else that.internalPause();
                        break;
                    case 'forward':
                        that.internalForward();
                        break;
                    case 'selectionType':
                        that.handleSelectionTypeChange(value);
                        break;
                    case 'chartType':
                        that.handleChartTypeChange(value);
                        break;
                    default:
                        break;
                }
            }
        }), userDefinedControllerStyle);
        if (type === 'time') style.functions = [
            [
                'reset',
                'speed'
            ],
            [
                'backward',
                'playPause',
                'forward'
            ],
            [
                'selectionType'
            ]
        ];
        this.controller.update(style);
    };
    Timebar.prototype.dispatchOnChange = function(prevValues) {
        var data = this.data;
        var onChange = this.attributes.onChange;
        var _a = this.states, values = _a.values, selectionType = _a.selectionType;
        var _b = (0, $7WQrb.__read)(values, 2), start = _b[0], end = _b[1];
        var endTime = end === Infinity ? data.at(-1).time : end;
        var newValues = selectionType === 'range' ? [
            start,
            endTime
        ] : endTime;
        var isEqual = function(val1, val2) {
            if (Array.isArray(val1)) {
                if (!Array.isArray(val2)) return false;
                if (val1[0] === val2[0]) {
                    if (val1[1] === val2[1]) return true;
                    if (val1[1] === Infinity || val2[1] === Infinity) return true;
                }
                return false;
            }
            if (Array.isArray(val2)) return false;
            return val1 === val2;
        };
        // 如果和当前值不同，才响应
        if (!prevValues || !isEqual(prevValues, newValues)) onChange === null || onChange === void 0 || onChange(selectionType === 'range' ? [
            start,
            endTime
        ] : endTime);
    };
    Timebar.prototype.internalReset = function(preventEvent) {
        var _a, _b;
        var selectionType = this.states.selectionType;
        this.internalPause();
        this.setBySliderValues(selectionType === 'range' ? [
            0,
            1
        ] : [
            0,
            0
        ]);
        this.renderController();
        this.updateSelection();
        if (!preventEvent) {
            (_b = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.onReset) === null || _b === void 0 || _b.call(_a);
            this.dispatchOnChange();
        }
    };
    Timebar.prototype.reset = function() {
        this.internalReset();
    };
    Timebar.prototype.moveSelection = function(direction, preventEvent) {
        var data = this.data;
        var length = data.length;
        var _a = this.states, values = _a.values, selectionType = _a.selectionType, playMode = _a.playMode;
        var _b = (0, $7WQrb.__read)(values, 2), startTime = _b[0], endTime = _b[1];
        var startIndex = data.findIndex(function(_a) {
            var time = _a.time;
            return time === startTime;
        });
        var endIndex = data.findIndex(function(_a) {
            var time = _a.time;
            return time === endTime;
        });
        if (endIndex === -1) endIndex = length;
        var diff = direction === 'backward' ? -1 : 1;
        var currentIndexes;
        if (selectionType === 'range') {
            // end 后移一个时间间隔
            if (playMode === 'acc') {
                currentIndexes = [
                    startIndex,
                    endIndex + diff
                ];
                // 如果回退过程中，start 和 end 相遇，则 end 重置到 length
                if (diff === -1 && startIndex === endIndex) currentIndexes = [
                    startIndex,
                    length
                ];
            } else currentIndexes = [
                startIndex + diff,
                endIndex + diff
            ];
        } else currentIndexes = [
            startIndex,
            endIndex + diff
        ];
        var normalizeIndexes = function(indexes) {
            // 先进行排序
            var _a = (0, $7WQrb.__read)(indexes.sort(function(a, b) {
                return a - b;
            }), 2), start = _a[0], end = _a[1];
            // 保证 index 在 [0, length]
            var clampIndex = function(index) {
                return (0, $8hhuV.default)(index, 0, length);
            };
            // 如果 end 超出最大值
            if (end > length) {
                // value 模式下，重置到 0
                if (selectionType === 'value') return [
                    0,
                    0
                ];
                // 移动到 start
                if (playMode === 'acc') return [
                    clampIndex(start),
                    clampIndex(start)
                ];
                // 整体移动到起始位置
                return [
                    0,
                    clampIndex(end - start)
                ];
            }
            // 如果是倒放，到头时，整体移动到末尾
            if (start < 0) {
                if (playMode === 'acc') return [
                    0,
                    clampIndex(end)
                ];
                return [
                    clampIndex(start + length - end),
                    length
                ];
            }
            return [
                clampIndex(start),
                clampIndex(end)
            ];
        };
        var normalizedIndexes = normalizeIndexes(currentIndexes);
        this.setByIndex(normalizedIndexes);
        this.updateSelection();
        return normalizedIndexes;
    };
    Timebar.prototype.internalBackward = function(preventEvent) {
        var _a, _b;
        var indexes = this.moveSelection('backward', preventEvent);
        if (!preventEvent) {
            (_b = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.onBackward) === null || _b === void 0 || _b.call(_a);
            this.dispatchOnChange();
        }
        return indexes;
    };
    Timebar.prototype.backward = function() {
        this.internalBackward();
    };
    Timebar.prototype.internalPlay = function(preventEvent) {
        var _this = this;
        var _a, _b;
        var data = this.data;
        var loop = this.attributes.loop;
        var _c = this.states.speed, speed = _c === void 0 ? 1 : _c;
        this.playInterval = window.setInterval(function() {
            var indexes = _this.internalForward();
            // 如果不是循环播放，则播放到最后一个值时暂停
            if (indexes[1] === data.length && !loop) {
                // 这里需要抛出暂停事件
                _this.internalPause();
                _this.renderController();
            }
        }, 1000 / speed);
        this.states.state = 'play';
        !preventEvent && ((_b = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.onPlay) === null || _b === void 0 || _b.call(_a));
    };
    Timebar.prototype.play = function() {
        this.internalPlay();
    };
    Timebar.prototype.internalPause = function(preventEvent) {
        var _a, _b;
        clearInterval(this.playInterval);
        this.states.state = 'pause';
        !preventEvent && ((_b = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.onPause) === null || _b === void 0 || _b.call(_a));
    };
    Timebar.prototype.pause = function() {
        this.internalPause();
    };
    Timebar.prototype.internalForward = function(preventEvent) {
        var _a, _b;
        var indexes = this.moveSelection('forward', preventEvent);
        if (!preventEvent) {
            (_b = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.onForward) === null || _b === void 0 || _b.call(_a);
            this.dispatchOnChange();
        }
        return indexes;
    };
    Timebar.prototype.forward = function() {
        this.internalForward();
    };
    Timebar.prototype.handleSpeedChange = function(value) {
        var _a, _b;
        this.states.speed = value;
        var state = this.states.state;
        if (state === 'play') {
            // 重新设定 interval
            this.internalPause(true);
            this.internalPlay(true);
        }
        (_b = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.onSpeedChange) === null || _b === void 0 || _b.call(_a, value);
    };
    Timebar.prototype.handleSelectionTypeChange = function(type) {
        var _a, _b;
        this.states.selectionType = type;
        this.renderChart();
        (_b = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.onSelectionTypeChange) === null || _b === void 0 || _b.call(_a, type);
    };
    Timebar.prototype.handleChartTypeChange = function(type) {
        var _a, _b;
        this.states.chartType = type;
        this.renderChart();
        (_b = (_a = this.attributes) === null || _a === void 0 ? void 0 : _a.onChartTypeChange) === null || _b === void 0 || _b.call(_a, type);
    };
    Timebar.prototype.render = function() {
        var _a = this.space, axisBBox = _a.axisBBox, controllerBBox = _a.controllerBBox, timelineBBox = _a.timelineBBox;
        this.renderController(controllerBBox);
        this.renderAxis(axisBBox);
        this.renderChart(timelineBBox);
        if (this.states.state === 'play') this.internalPlay();
    };
    Timebar.prototype.destroy = function() {
        _super.prototype.destroy.call(this);
        this.internalPause(true);
    };
    Timebar.defaultOptions = {
        style: {
            x: 0,
            y: 0,
            axisLabelFill: '#6e6e6e',
            axisLabelTextAlign: 'left',
            axisLabelTextBaseline: 'top',
            axisLabelTransform: 'translate(5, -12)',
            axisLineLineWidth: 1,
            axisLineStroke: '#cacdd1',
            axisTickLength: 15,
            axisTickLineWidth: 1,
            axisTickStroke: '#cacdd1',
            chartShowLabel: false,
            chartType: 'line',
            controllerAlign: 'center',
            controllerHeight: 40,
            data: [],
            interval: 'day',
            loop: false,
            playMode: 'acc',
            selectionType: 'range',
            type: 'time'
        }
    };
    return Timebar;
}((0, $e7n3C.Component));

});
parcelRegister("c6FtR", function(module, exports) {

$parcel$export(module.exports, "formatTime", () => $02464b3ce243586c$export$3203edd9e5edd663);

var $7WQrb = parcelRequire("7WQrb");
var $02464b3ce243586c$var$scale = [
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second'
];
var $02464b3ce243586c$var$masks = [
    'YYYY',
    'MM',
    'DD',
    'hh',
    'mm',
    'ss'
];
function $02464b3ce243586c$export$6b862160d295c8e(date) {
    return date instanceof Date ? date : new Date(date);
}
function $02464b3ce243586c$export$19e60219fa06d99f(_a) {
    var _b = (0, $7WQrb.__read)(_a, 2), maxUnit = _b[0], minUnit = _b[1];
    var startIndex = $02464b3ce243586c$var$scale.indexOf(maxUnit);
    var endIndex = $02464b3ce243586c$var$scale.indexOf(minUnit);
    var format = '';
    for(var i = startIndex; i <= endIndex; i += 1){
        format += $02464b3ce243586c$var$masks[i];
        if (i < endIndex) {
            var connect = '-';
            if (i === 2) connect = ' ';
            else if (i > 2) connect = ':';
            format += connect;
        }
    }
    return format;
}
function $02464b3ce243586c$export$3203edd9e5edd663(date, mask) {
    var timeMap = {
        YYYY: date.getFullYear(),
        MM: date.getMonth() + 1,
        DD: date.getDate(),
        HH: date.getHours(),
        mm: date.getMinutes(),
        ss: date.getSeconds()
    };
    var strftime = mask;
    Object.keys(timeMap).forEach(function(key) {
        var val = timeMap[key];
        strftime = strftime.replace(key, key === 'YYYY' ? "".concat(val) : "".concat(val).padStart(2, '0'));
    });
    return strftime;
}
function $02464b3ce243586c$export$f831cf4a1c30a3b3(a, b) {
    return $02464b3ce243586c$export$6b862160d295c8e(a).getTime() - $02464b3ce243586c$export$6b862160d295c8e(b).getTime();
}
function $02464b3ce243586c$export$a53beca3bcfc33c1(a, b) {
    var _a = (0, $7WQrb.__read)([
        $02464b3ce243586c$export$6b862160d295c8e(a),
        $02464b3ce243586c$export$6b862160d295c8e(b)
    ], 2), ma = _a[0], mb = _a[1];
    if (ma.getFullYear() !== mb.getFullYear()) return 'year';
    if (ma.getMonth() !== mb.getMonth()) return 'month';
    if (ma.getDay() !== mb.getDay()) return 'day';
    if (ma.getHours() !== mb.getHours()) return 'hour';
    if (ma.getMinutes() !== mb.getMinutes()) return 'minute';
    return 'second';
}
function $02464b3ce243586c$export$a46c590fff9bf38c(date, scale) {
    var result = new Date(date);
    var timeMap = {
        year: function(d) {
            d.setMonth(0);
            d.setHours(0, 0, 0, 0);
        },
        month: function(d) {
            d.setDate(1);
            d.setHours(0, 0, 0, 0);
        },
        day: function(d) {
            return d.setHours(0, 0, 0, 0);
        },
        hour: function(d) {
            return d.setMinutes(0, 0, 0);
        },
        minute: function(d) {
            return d.setSeconds(0, 0);
        },
        second: function(d) {
            return d.setMilliseconds(0);
        }
    };
    timeMap[scale](result);
    return $02464b3ce243586c$export$3203edd9e5edd663(result, $02464b3ce243586c$export$19e60219fa06d99f([
        'year',
        scale
    ]));
}

});

parcelRegister("7v2I9", function(module, exports) {

$parcel$export(module.exports, "Axis", () => $575d88076f946e72$export$d06866a9fb0606da);

var $7WQrb = parcelRequire("7WQrb");

var $bhYrQ = parcelRequire("bhYrQ");

var $e7n3C = parcelRequire("e7n3C");

var $aJozt = parcelRequire("aJozt");
var $iYgD4 = parcelRequire("iYgD4");
var $bCy7Q = parcelRequire("bCy7Q");

var $7h0mn = parcelRequire("7h0mn");

var $kA8fj = parcelRequire("kA8fj");

var $lhdae = parcelRequire("lhdae");

var $4KYCs = parcelRequire("4KYCs");

var $9RJbj = parcelRequire("9RJbj");

var $c67j2 = parcelRequire("c67j2");

var $cAfhA = parcelRequire("cAfhA");

var $74vg6 = parcelRequire("74vg6");
function $575d88076f946e72$var$renderAxisMain(attributes, container, data, animation) {
    var showLine = attributes.showLine, showTick = attributes.showTick, showLabel = attributes.showLabel, classNamePrefix = attributes.classNamePrefix;
    /** line */ var lineGroup = container.maybeAppendByClassName((0, $7h0mn.CLASS_NAMES).lineGroup, 'g');
    (0, $cAfhA.applyClassName)(lineGroup, (0, $7h0mn.CLASS_NAMES).lineGroup, (0, $74vg6.CLASSNAME_SUFFIX_MAP).lineGroup, classNamePrefix);
    var lineTransitions = (0, $aJozt.ifShow)(showLine, lineGroup, function(group) {
        return (0, $4KYCs.renderAxisLine)(group, attributes, animation);
    }) || [];
    /** tick */ var tickGroup = container.maybeAppendByClassName((0, $7h0mn.CLASS_NAMES).tickGroup, 'g');
    (0, $cAfhA.applyClassName)(tickGroup, (0, $7h0mn.CLASS_NAMES).tickGroup, (0, $74vg6.CLASSNAME_SUFFIX_MAP).tickGroup, classNamePrefix);
    var tickTransitions = (0, $aJozt.ifShow)(showTick, tickGroup, function(group) {
        return (0, $9RJbj.renderTicks)(group, data, attributes, animation);
    }) || [];
    /** label */ var labelGroup = container.maybeAppendByClassName((0, $7h0mn.CLASS_NAMES).labelGroup, 'g');
    (0, $cAfhA.applyClassName)(labelGroup, (0, $7h0mn.CLASS_NAMES).labelGroup, (0, $74vg6.CLASSNAME_SUFFIX_MAP).labelGroup, classNamePrefix);
    var labelTransitions = (0, $aJozt.ifShow)(showLabel, labelGroup, function(group) {
        return (0, $lhdae.renderLabels)(group, data, attributes, animation, container.node());
    }) || [];
    return (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(lineTransitions), false), (0, $7WQrb.__read)(tickTransitions), false), (0, $7WQrb.__read)(labelTransitions), false).filter(function(t) {
        return !!t;
    });
}
var $575d88076f946e72$export$d06866a9fb0606da = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Axis, _super);
    function Axis(options) {
        return _super.call(this, options, (0, $7h0mn.AXIS_BASE_DEFAULT_ATTR)) || this;
    }
    Axis.prototype.render = function(attributes, container, specificAnimation) {
        var _this = this;
        var titleText = attributes.titleText, data = attributes.data, animate = attributes.animate, showTitle = attributes.showTitle, showGrid = attributes.showGrid, dataThreshold = attributes.dataThreshold, truncRange = attributes.truncRange, classNamePrefix = attributes.classNamePrefix;
        // Set root container className
        var baseClassName = container.className || 'axis';
        if (classNamePrefix) container.attr('className', "".concat(baseClassName, " ").concat(classNamePrefix, "axis"));
        else if (!container.className) container.attr('className', 'axis');
        var sampledData = (0, $iYgD4.sampling)(data, dataThreshold).filter(function(_a) {
            var value = _a.value;
            if (truncRange && value > truncRange[0] && value < truncRange[1]) return false;
            return true;
        });
        var finalAnimation = (0, $bhYrQ.parseAnimationOption)(specificAnimation === undefined ? animate : specificAnimation);
        /** grid */ var gridGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName((0, $7h0mn.CLASS_NAMES).gridGroup, 'g');
        (0, $cAfhA.applyClassName)(gridGroup, (0, $7h0mn.CLASS_NAMES).gridGroup, (0, $74vg6.CLASSNAME_SUFFIX_MAP).gridGroup, classNamePrefix);
        var gridTransitions = (0, $aJozt.ifShow)(showGrid, gridGroup, function(group) {
            return (0, $kA8fj.renderGrid)(group, sampledData, attributes, finalAnimation);
        }) || [];
        /** main group */ var mainGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName((0, $7h0mn.CLASS_NAMES).mainGroup, 'g');
        (0, $cAfhA.applyClassName)(mainGroup, (0, $7h0mn.CLASS_NAMES).mainGroup, (0, $74vg6.CLASSNAME_SUFFIX_MAP).mainGroup, classNamePrefix);
        if (titleText && (!this.initialized && finalAnimation.enter || this.initialized && finalAnimation.update)) $575d88076f946e72$var$renderAxisMain(attributes, (0, $bCy7Q.select)(this.offscreenGroup), sampledData, (0, $bhYrQ.parseAnimationOption)(false));
        // render
        var mainTransitions = $575d88076f946e72$var$renderAxisMain(attributes, (0, $bCy7Q.select)(mainGroup.node()), sampledData, finalAnimation);
        /** title */ var titleGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName((0, $7h0mn.CLASS_NAMES).titleGroup, 'g');
        (0, $cAfhA.applyClassName)(titleGroup, (0, $7h0mn.CLASS_NAMES).titleGroup, (0, $74vg6.CLASSNAME_SUFFIX_MAP).titleGroup, classNamePrefix);
        var titleTransitions = (0, $aJozt.ifShow)(showTitle, titleGroup, function(group) {
            return (0, $c67j2.renderTitle)(group, _this, attributes, finalAnimation);
        }) || [];
        return (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(gridTransitions), false), (0, $7WQrb.__read)(mainTransitions), false), (0, $7WQrb.__read)(titleTransitions), false).flat().filter(function(t) {
            return !!t;
        });
    };
    return Axis;
}((0, $e7n3C.Component));

});
parcelRegister("iYgD4", function(module, exports) {

$parcel$export(module.exports, "sampling", () => $dcfabacd67b929f9$export$5eb8bf6df3022720);
function $dcfabacd67b929f9$export$5eb8bf6df3022720(data, size) {
    if (data.length <= size) return data;
    var step = Math.floor(data.length / size);
    var result = [];
    for(var i = 0; i < data.length; i += step)result.push(data[i]);
    return result;
}

});

parcelRegister("7h0mn", function(module, exports) {

$parcel$export(module.exports, "AXIS_BASE_DEFAULT_ATTR", () => $54ba6662bf1ea877$export$902deb18ea0d86ca);
$parcel$export(module.exports, "CLASS_NAMES", () => $54ba6662bf1ea877$export$1ba50affd1ee3341);

var $iE4so = parcelRequire("iE4so");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $1SiGY = parcelRequire("1SiGY");

var $74vg6 = parcelRequire("74vg6");
var $54ba6662bf1ea877$export$902deb18ea0d86ca = {
    data: [],
    animate: {
        enter: false,
        update: {
            duration: 100,
            easing: 'ease-in-out-sine',
            fill: 'both'
        },
        exit: {
            duration: 100,
            fill: 'both'
        }
    },
    showArrow: true,
    showGrid: true,
    showLabel: true,
    showLine: true,
    showTick: true,
    showTitle: true,
    showTrunc: false,
    dataThreshold: 100,
    lineLineWidth: 1,
    lineStroke: 'black',
    crossPadding: 10,
    titleFill: 'black',
    titleFontSize: 12,
    titlePosition: 'lb',
    titleSpacing: 0,
    titleTextAlign: 'center',
    titleTextBaseline: 'middle',
    lineArrow: function() {
        return new (0, $2eDEB.Path)({
            style: {
                d: [
                    [
                        'M',
                        10,
                        10
                    ],
                    [
                        'L',
                        -10,
                        0
                    ],
                    [
                        'L',
                        10,
                        -10
                    ],
                    [
                        'L',
                        0,
                        0
                    ],
                    [
                        'L',
                        10,
                        10
                    ],
                    [
                        'Z'
                    ]
                ],
                fill: 'black',
                transformOrigin: 'center'
            }
        });
    },
    labelAlign: 'parallel',
    labelDirection: 'positive',
    labelFontSize: 12,
    labelSpacing: 0,
    gridConnect: 'line',
    gridControlAngles: [],
    gridDirection: 'positive',
    gridLength: 0,
    gridType: 'segment',
    lineArrowOffset: 15,
    lineArrowSize: 10,
    tickDirection: 'positive',
    tickLength: 5,
    tickLineWidth: 1,
    tickStroke: 'black',
    labelOverlap: []
};
var $54ba6662bf1ea877$export$4cb784b297f4b179 = (0, $iE4so.default)({}, $54ba6662bf1ea877$export$902deb18ea0d86ca, {
    style: {
        type: 'arc'
    }
});
var $54ba6662bf1ea877$export$8e908b1ceb6edc46 = (0, $iE4so.default)({}, $54ba6662bf1ea877$export$902deb18ea0d86ca, {
    style: {}
});
var $54ba6662bf1ea877$export$1ba50affd1ee3341 = (0, $1SiGY.classNames)({
    mainGroup: (0, $74vg6.CLASSNAME_SUFFIX_MAP).mainGroup,
    gridGroup: (0, $74vg6.CLASSNAME_SUFFIX_MAP).gridGroup,
    grid: (0, $74vg6.CLASSNAME_SUFFIX_MAP).grid,
    lineGroup: (0, $74vg6.CLASSNAME_SUFFIX_MAP).lineGroup,
    line: (0, $74vg6.CLASSNAME_SUFFIX_MAP).line,
    tickGroup: (0, $74vg6.CLASSNAME_SUFFIX_MAP).tickGroup,
    tick: (0, $74vg6.CLASSNAME_SUFFIX_MAP).tick,
    tickItem: (0, $74vg6.CLASSNAME_SUFFIX_MAP).tickItem,
    labelGroup: (0, $74vg6.CLASSNAME_SUFFIX_MAP).labelGroup,
    label: (0, $74vg6.CLASSNAME_SUFFIX_MAP).label,
    labelItem: (0, $74vg6.CLASSNAME_SUFFIX_MAP).labelItem,
    titleGroup: (0, $74vg6.CLASSNAME_SUFFIX_MAP).titleGroup,
    title: (0, $74vg6.CLASSNAME_SUFFIX_MAP).title,
    lineFirst: (0, $74vg6.CLASSNAME_SUFFIX_MAP).lineFirst,
    lineSecond: (0, $74vg6.CLASSNAME_SUFFIX_MAP).lineSecond
}, 'axis');

});
parcelRegister("74vg6", function(module, exports) {

$parcel$export(module.exports, "CLASSNAME_SUFFIX_MAP", () => $526127747d757ce7$export$bd9266606cea9ca1);
var $526127747d757ce7$export$bd9266606cea9ca1 = {
    // group
    gridGroup: 'grid-group',
    mainGroup: 'main-group',
    lineGroup: 'line-group',
    tickGroup: 'tick-group',
    labelGroup: 'label-group',
    titleGroup: 'title-group',
    // content
    grid: 'grid',
    line: 'line',
    lineFirst: 'line-first',
    lineSecond: 'line-second',
    tick: 'tick',
    tickItem: 'tick-item',
    label: 'label',
    labelItem: 'label-item',
    title: 'title'
};

});


parcelRegister("kA8fj", function(module, exports) {

$parcel$export(module.exports, "renderGrid", () => $efbd90e9defac110$export$3abeae83581a9f42);

var $7WQrb = parcelRequire("7WQrb");

var $ky7aH = parcelRequire("ky7aH");

var $amQwj = parcelRequire("amQwj");
var $pzxZu = parcelRequire("pzxZu");
var $8jlEv = parcelRequire("8jlEv");
var $8UxPj = parcelRequire("8UxPj");

var $3jvL9 = parcelRequire("3jvL9");

var $7h0mn = parcelRequire("7h0mn");

var $4KYCs = parcelRequire("4KYCs");

var $1GIDL = parcelRequire("1GIDL");

var $cAfhA = parcelRequire("cAfhA");

var $74vg6 = parcelRequire("74vg6");
function $efbd90e9defac110$var$getGridVector(value, attr) {
    return (0, $1GIDL.getDirectionVector)(value, attr.gridDirection, attr);
}
function $efbd90e9defac110$var$getGridCenter(attr) {
    var type = attr.type, gridCenter = attr.gridCenter;
    if (type === 'linear') return gridCenter;
    return gridCenter || attr.center;
}
function $efbd90e9defac110$var$renderStraight(data, attr) {
    var gridLength = attr.gridLength;
    return data.map(function(_a, index) {
        var value = _a.value;
        var _b = (0, $7WQrb.__read)((0, $4KYCs.getValuePos)(value, attr), 2), x = _b[0], y = _b[1];
        var _c = (0, $7WQrb.__read)((0, $8jlEv.scale)($efbd90e9defac110$var$getGridVector(value, attr), gridLength), 2), dx = _c[0], dy = _c[1];
        return {
            id: index,
            points: [
                [
                    x,
                    y
                ],
                [
                    x + dx,
                    y + dy
                ]
            ]
        };
    });
}
function $efbd90e9defac110$var$renderSurround(data, attr) {
    var controlAngles = attr.gridControlAngles;
    var center = $efbd90e9defac110$var$getGridCenter(attr);
    if (!center) throw new Error('grid center is not provide');
    if (data.length < 2) throw new Error('Invalid grid data');
    if (!controlAngles || controlAngles.length === 0) throw new Error('Invalid gridControlAngles');
    var _a = (0, $7WQrb.__read)(center, 2), cx = _a[0], cy = _a[1];
    return data.map(function(_a, index) {
        var value = _a.value;
        var _b = (0, $7WQrb.__read)((0, $4KYCs.getValuePos)(value, attr), 2), sx = _b[0], sy = _b[1];
        var _c = (0, $7WQrb.__read)([
            sx - cx,
            sy - cy
        ], 2), dx = _c[0], dy = _c[1];
        var points = [];
        controlAngles.forEach(function(angle) {
            var angleInRad = (0, $amQwj.degToRad)(angle);
            var _a = (0, $7WQrb.__read)([
                Math.cos(angleInRad),
                Math.sin(angleInRad)
            ], 2), cosa = _a[0], sina = _a[1];
            var x = dx * cosa - dy * sina + cx;
            var y = dx * sina + dy * cosa + cy;
            points.push([
                x,
                y
            ]);
        });
        return {
            points: points,
            id: index
        };
    });
}
function $efbd90e9defac110$export$3abeae83581a9f42(container, data, attr, animate) {
    var classNamePrefix = attr.classNamePrefix;
    var gridAttr = (0, $8UxPj.subStyleProps)(attr, 'grid');
    var type = gridAttr.type, areaFill = gridAttr.areaFill;
    var center = $efbd90e9defac110$var$getGridCenter(attr);
    var finalData = (0, $1GIDL.filterExec)(data, attr.gridFilter);
    var gridItems = type === 'segment' ? $efbd90e9defac110$var$renderStraight(finalData, attr) : $efbd90e9defac110$var$renderSurround(finalData, attr);
    var style = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, gridAttr), {
        center: center,
        areaFill: (0, $ky7aH.default)(areaFill) ? finalData.map(function(datum, index) {
            return (0, $pzxZu.getCallbackValue)(areaFill, [
                datum,
                index,
                finalData
            ]);
        }) : areaFill,
        animate: animate,
        data: gridItems
    });
    return container.selectAll((0, $7h0mn.CLASS_NAMES).grid.class).data([
        1
    ]).join(function(enter) {
        var grid = enter.append(function() {
            return new (0, $3jvL9.Grid)({
                style: style
            });
        }).attr('className', (0, $7h0mn.CLASS_NAMES).grid.name);
        (0, $cAfhA.applyClassName)(grid, (0, $7h0mn.CLASS_NAMES).grid, (0, $74vg6.CLASSNAME_SUFFIX_MAP).grid, classNamePrefix);
        return grid;
    }, function(update) {
        return update.transition(function() {
            return this.update(style);
        });
    }, function(exit) {
        return exit.remove();
    }).transitions();
}

});
parcelRegister("amQwj", function(module, exports) {

$parcel$export(module.exports, "degToRad", () => $78c4b2e20fb10e84$export$e6bfdeff8bfc94f9);
$parcel$export(module.exports, "radToDeg", () => $78c4b2e20fb10e84$export$54390e3b44c4a9cb);
function $78c4b2e20fb10e84$export$e6bfdeff8bfc94f9(deg) {
    return deg * Math.PI / 180;
}
function $78c4b2e20fb10e84$export$54390e3b44c4a9cb(rad) {
    return Number((rad * 180 / Math.PI).toPrecision(5));
}

});

parcelRegister("8jlEv", function(module, exports) {

$parcel$export(module.exports, "scale", () => $60d0e4c9802aaba4$export$dcdf75081b88279d);
$parcel$export(module.exports, "add", () => $60d0e4c9802aaba4$export$e16d8520af44a096);
$parcel$export(module.exports, "sub", () => $60d0e4c9802aaba4$export$f93b5905241a7cca);
$parcel$export(module.exports, "min", () => $60d0e4c9802aaba4$export$96ec731ed4dcb222);
$parcel$export(module.exports, "max", () => $60d0e4c9802aaba4$export$8960430cfd85939f);
$parcel$export(module.exports, "distance", () => $60d0e4c9802aaba4$export$9f17032d917177de);
$parcel$export(module.exports, "normalize", () => $60d0e4c9802aaba4$export$a3295358bff77e);
$parcel$export(module.exports, "vertical", () => $60d0e4c9802aaba4$export$32f8a6eb41d46820);

var $7WQrb = parcelRequire("7WQrb");
function $60d0e4c9802aaba4$export$dcdf75081b88279d(vec, s) {
    return [
        vec[0] * s,
        vec[1] * s
    ];
}
function $60d0e4c9802aaba4$export$e16d8520af44a096(vec1, vec2) {
    return [
        vec1[0] + vec2[0],
        vec1[1] + vec2[1]
    ];
}
function $60d0e4c9802aaba4$export$f93b5905241a7cca(vec1, vec2) {
    return [
        vec1[0] - vec2[0],
        vec1[1] - vec2[1]
    ];
}
function $60d0e4c9802aaba4$export$96ec731ed4dcb222(vec1, vec2) {
    return [
        Math.min(vec1[0], vec2[0]),
        Math.min(vec1[1], vec2[1])
    ];
}
function $60d0e4c9802aaba4$export$8960430cfd85939f(vec1, vec2) {
    return [
        Math.max(vec1[0], vec2[0]),
        Math.max(vec1[1], vec2[1])
    ];
}
function $60d0e4c9802aaba4$export$9f17032d917177de(vec1, vec2) {
    return Math.sqrt(Math.pow(vec1[0] - vec2[0], 2) + Math.pow(vec1[1] - vec2[1], 2));
}
function $60d0e4c9802aaba4$export$a3295358bff77e(vec) {
    if (vec[0] === 0 && vec[1] === 0) return [
        0,
        0
    ];
    var len = Math.sqrt(Math.pow(vec[0], 2) + Math.pow(vec[1], 2));
    return [
        vec[0] / len,
        vec[1] / len
    ];
}
function $60d0e4c9802aaba4$export$bb628a54ab399bc9(vec, origin, angle) {
    var _a = (0, $7WQrb.__read)(vec, 2), x = _a[0], y = _a[1];
    var _b = (0, $7WQrb.__read)(origin, 2), ox = _b[0], oy = _b[1];
    var dx = x - ox;
    var dy = y - oy;
    var sin = Math.sin(angle);
    var cos = Math.cos(angle);
    return [
        dx * cos - dy * sin + ox,
        dx * sin + dy * cos + oy
    ];
}
function $60d0e4c9802aaba4$export$32f8a6eb41d46820(vec, flag) {
    return flag ? [
        vec[1],
        -vec[0]
    ] : [
        -vec[1],
        vec[0]
    ];
}

});

parcelRegister("3jvL9", function(module, exports) {

$parcel$export(module.exports, "Grid", () => $269bc8371271f65b$export$ef2184bd89960b14);

var $7WQrb = parcelRequire("7WQrb");

var $ZP1jD = parcelRequire("ZP1jD");
var $bhYrQ = parcelRequire("bhYrQ");

var $e7n3C = parcelRequire("e7n3C");

var $1SiGY = parcelRequire("1SiGY");
var $8jlEv = parcelRequire("8jlEv");
var $pzxZu = parcelRequire("pzxZu");
var $46q2p = parcelRequire("46q2p");
var $bCy7Q = parcelRequire("bCy7Q");
var $269bc8371271f65b$var$CLASS_NAMES = (0, $1SiGY.classNames)({
    lineGroup: 'line-group',
    line: 'line',
    regionGroup: 'region-group',
    region: 'region'
}, 'grid');
function $269bc8371271f65b$var$getStraightPath(points) {
    return points.reduce(function(acc, curr, idx) {
        acc.push((0, $7WQrb.__spreadArray)([
            idx === 0 ? 'M' : 'L'
        ], (0, $7WQrb.__read)(curr), false));
        return acc;
    }, []);
}
function $269bc8371271f65b$var$getSurroundPath(points, attr, reversed) {
    var _a = attr.connect, connect = _a === void 0 ? 'line' : _a, center = attr.center;
    if (connect === 'line') return $269bc8371271f65b$var$getStraightPath(points);
    if (!center) return [];
    var radius = (0, $8jlEv.distance)(points[0], center);
    var sweepFlag = reversed ? 0 : 1;
    return points.reduce(function(r, p, idx) {
        if (idx === 0) r.push((0, $7WQrb.__spreadArray)([
            'M'
        ], (0, $7WQrb.__read)(p), false));
        else r.push((0, $7WQrb.__spreadArray)([
            'A',
            radius,
            radius,
            0,
            0,
            sweepFlag
        ], (0, $7WQrb.__read)(p), false));
        return r;
    }, []);
}
function $269bc8371271f65b$var$getLinePath(points, cfg, reversed) {
    if (cfg.type === 'surround') return $269bc8371271f65b$var$getSurroundPath(points, cfg, reversed);
    return $269bc8371271f65b$var$getStraightPath(points);
}
function $269bc8371271f65b$var$connectPaths(from, to, cfg) {
    var type = cfg.type, connect = cfg.connect, center = cfg.center, closed = cfg.closed;
    var closeFlag = closed ? [
        [
            'Z'
        ]
    ] : [];
    var _a = (0, $7WQrb.__read)([
        $269bc8371271f65b$var$getLinePath(from, cfg),
        $269bc8371271f65b$var$getLinePath(to.slice().reverse(), cfg, true)
    ], 2), path1 = _a[0], path2 = _a[1];
    var _b = (0, $7WQrb.__read)([
        from[0],
        to.slice(-1)[0]
    ], 2), startOfFrom = _b[0], endOfTo = _b[1];
    var createPath = function(insertA, insertB) {
        return [
            path1,
            insertA,
            path2,
            insertB,
            closeFlag
        ].flat();
    };
    if (connect === 'line' || type === 'surround') return createPath([
        (0, $7WQrb.__spreadArray)([
            'L'
        ], (0, $7WQrb.__read)(endOfTo), false)
    ], [
        (0, $7WQrb.__spreadArray)([
            'L'
        ], (0, $7WQrb.__read)(startOfFrom), false)
    ]);
    if (!center) throw new Error('Arc grid need to specified center');
    var _c = (0, $7WQrb.__read)([
        (0, $8jlEv.distance)(endOfTo, center),
        (0, $8jlEv.distance)(startOfFrom, center)
    ], 2), raduis1 = _c[0], radius2 = _c[1];
    return createPath([
        (0, $7WQrb.__spreadArray)([
            'A',
            raduis1,
            raduis1,
            0,
            0,
            1
        ], (0, $7WQrb.__read)(endOfTo), false),
        (0, $7WQrb.__spreadArray)([
            'L'
        ], (0, $7WQrb.__read)(endOfTo), false)
    ], [
        (0, $7WQrb.__spreadArray)([
            'A',
            radius2,
            radius2,
            0,
            0,
            0
        ], (0, $7WQrb.__read)(startOfFrom), false),
        (0, $7WQrb.__spreadArray)([
            'L'
        ], (0, $7WQrb.__read)(startOfFrom), false)
    ]);
}
function $269bc8371271f65b$var$renderGridLine(container, data, attr, style) {
    var animate = attr.animate, isBillboard = attr.isBillboard;
    var lines = data.map(function(item, idx) {
        return {
            id: item.id || "grid-line-".concat(idx),
            d: $269bc8371271f65b$var$getLinePath(item.points, attr)
        };
    });
    return container.selectAll($269bc8371271f65b$var$CLASS_NAMES.line.class).data(lines, function(d) {
        return d.id;
    }).join(function(enter) {
        return enter.append('path').each(function(datum, index) {
            var lineStyle = (0, $pzxZu.getCallbackValue)((0, $46q2p.getPrimitiveAttributes)((0, $7WQrb.__assign)({
                d: datum.d
            }, style)), [
                datum,
                index,
                lines
            ]);
            this.attr((0, $7WQrb.__assign)({
                class: $269bc8371271f65b$var$CLASS_NAMES.line.name,
                stroke: '#D9D9D9',
                lineWidth: 1,
                lineDash: [
                    4,
                    4
                ],
                isBillboard: isBillboard
            }, lineStyle));
        });
    }, function(update) {
        return update.transition(function(datum, index) {
            var lineStyle = (0, $pzxZu.getCallbackValue)((0, $46q2p.getPrimitiveAttributes)((0, $7WQrb.__assign)({
                d: datum.d
            }, style)), [
                datum,
                index,
                lines
            ]);
            return (0, $bhYrQ.transition)(this, lineStyle, animate.update);
        });
    }, function(exit) {
        return exit.transition(function() {
            var _this = this;
            var animation = (0, $ZP1jD.default)(this, animate.exit);
            (0, $bhYrQ.onAnimateFinished)(animation, function() {
                return _this.remove();
            });
            return animation;
        });
    }).transitions();
}
function $269bc8371271f65b$var$renderAlternateRegion(container, data, style) {
    var animate = style.animate, connect = style.connect, areaFill = style.areaFill;
    if (data.length < 2 || !areaFill || !connect) return [];
    var colors = Array.isArray(areaFill) ? areaFill : [
        areaFill,
        'transparent'
    ];
    var getColor = function(idx) {
        return colors[idx % colors.length];
    };
    var regions = [];
    for(var idx = 0; idx < data.length - 1; idx++){
        var _a = (0, $7WQrb.__read)([
            data[idx].points,
            data[idx + 1].points
        ], 2), prev = _a[0], curr = _a[1];
        var path = $269bc8371271f65b$var$connectPaths(prev, curr, style);
        regions.push({
            d: path,
            fill: getColor(idx)
        });
    }
    return container.selectAll($269bc8371271f65b$var$CLASS_NAMES.region.class).data(regions, function(_, i) {
        return i;
    }).join(function(enter) {
        return enter.append('path').each(function(datum, index) {
            var regionStyle = (0, $pzxZu.getCallbackValue)(datum, [
                datum,
                index,
                regions
            ]);
            this.attr(regionStyle);
        }).attr('className', $269bc8371271f65b$var$CLASS_NAMES.region.name);
    }, function(update) {
        return update.transition(function(datum, index) {
            var regionStyle = (0, $pzxZu.getCallbackValue)(datum, [
                datum,
                index,
                regions
            ]);
            return (0, $bhYrQ.transition)(this, regionStyle, animate.update);
        });
    }, function(exit) {
        return exit.transition(function() {
            var _this = this;
            var animation = (0, $ZP1jD.default)(this, animate.exit);
            (0, $bhYrQ.onAnimateFinished)(animation, function() {
                return _this.remove();
            });
            return animation;
        });
    }).transitions();
}
function $269bc8371271f65b$var$getData(attr) {
    var _a = attr.data, data = _a === void 0 ? [] : _a, closed = attr.closed;
    if (!closed) return data;
    return data.map(function(datum) {
        var points = datum.points;
        var _a = (0, $7WQrb.__read)(points, 1), start = _a[0];
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, datum), {
            points: (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(points), false), [
                start
            ], false)
        });
    });
}
var $269bc8371271f65b$export$ef2184bd89960b14 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Grid, _super);
    function Grid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Grid.prototype.render = function(attributes, container) {
        // @ts-ignore do no passBy className
        var type = attributes.type, center = attributes.center, areaFill = attributes.areaFill, closed = attributes.closed, style = (0, $7WQrb.__rest)(attributes, [
            "type",
            "center",
            "areaFill",
            "closed"
        ]);
        var data = $269bc8371271f65b$var$getData(attributes);
        var lineGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName($269bc8371271f65b$var$CLASS_NAMES.lineGroup, 'g');
        var regionGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName($269bc8371271f65b$var$CLASS_NAMES.regionGroup, 'g');
        var lineTransitions = $269bc8371271f65b$var$renderGridLine(lineGroup, data, attributes, style);
        var reigionTransitions = $269bc8371271f65b$var$renderAlternateRegion(regionGroup, data, attributes);
        return (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(lineTransitions), false), (0, $7WQrb.__read)(reigionTransitions), false);
    };
    return Grid;
}((0, $e7n3C.Component));

});
parcelRegister("ZP1jD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b9d462c3daf0ce5$export$2e2bcd8739ae039);

var $bhYrQ = parcelRequire("bhYrQ");
function $0b9d462c3daf0ce5$export$2e2bcd8739ae039(element, options) {
    if (!element.style.opacity) element.style.opacity = 1;
    return (0, $bhYrQ.transition)(element, {
        opacity: 0
    }, options);
}

});

parcelRegister("46q2p", function(module, exports) {

$parcel$export(module.exports, "getPrimitiveAttributes", () => $2fcbeb8c2a75db34$export$d95e567fe923d958);
var $2fcbeb8c2a75db34$export$5f7360ccb07775fb = [
    '$el',
    'cx',
    'cy',
    'd',
    'dx',
    'dy',
    'fill',
    'fillOpacity',
    'filter',
    'fontFamily',
    'fontSize',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'height',
    'img',
    'increasedLineWidthForHitTesting',
    'innerHTML',
    'isBillboard',
    'billboardRotation',
    'isSizeAttenuation',
    'isClosed',
    'isOverflowing',
    'leading',
    'letterSpacing',
    'lineDash',
    'lineHeight',
    'lineWidth',
    'markerEnd',
    'markerEndOffset',
    'markerMid',
    'markerStart',
    'markerStartOffset',
    'maxLines',
    'metrics',
    'miterLimit',
    'offsetX',
    'offsetY',
    'opacity',
    'path',
    'points',
    'r',
    'radius',
    'rx',
    'ry',
    'shadowColor',
    'src',
    'stroke',
    'strokeOpacity',
    'text',
    'textAlign',
    'textBaseline',
    'textDecorationColor',
    'textDecorationLine',
    'textDecorationStyle',
    'textOverflow',
    'textPath',
    'textPathSide',
    'textPathStartOffset',
    'transform',
    'transformOrigin',
    'visibility',
    'width',
    'wordWrap',
    'wordWrapWidth',
    'x',
    'x1',
    'x2',
    'y',
    'y1',
    'y2',
    'z1',
    'z2',
    'zIndex'
];
function $2fcbeb8c2a75db34$export$4a51cd640dedf(key) {
    return $2fcbeb8c2a75db34$export$5f7360ccb07775fb.includes(key);
}
function $2fcbeb8c2a75db34$export$d95e567fe923d958(attributes) {
    var object = {};
    for(var key in attributes)if ($2fcbeb8c2a75db34$export$4a51cd640dedf(key)) object[key] = attributes[key];
    return object;
}

});


parcelRegister("4KYCs", function(module, exports) {

$parcel$export(module.exports, "getValuePos", () => $376a7b0473b1759a$export$5a02054d26e0e06e);
$parcel$export(module.exports, "isAxisHorizontal", () => $376a7b0473b1759a$export$fa52f0e5c3e964d);
$parcel$export(module.exports, "isAxisVertical", () => $376a7b0473b1759a$export$fb35ad4cde171086);
$parcel$export(module.exports, "renderAxisLine", () => $376a7b0473b1759a$export$6f302ad1d34c1016);

var $7WQrb = parcelRequire("7WQrb");

var $6XARU = parcelRequire("6XARU");

var $bhYrQ = parcelRequire("bhYrQ");

var $amQwj = parcelRequire("amQwj");
var $fYEmE = parcelRequire("fYEmE");
var $yHOgd = parcelRequire("yHOgd");
var $i1HPZ = parcelRequire("i1HPZ");
var $9JcvC = parcelRequire("9JcvC");
var $8UxPj = parcelRequire("8UxPj");

var $7h0mn = parcelRequire("7h0mn");

var $1GIDL = parcelRequire("1GIDL");

var $cAfhA = parcelRequire("cAfhA");

var $74vg6 = parcelRequire("74vg6");
function $376a7b0473b1759a$export$4addc5405d4e8229(value, attr) {
    var _a = (0, $7WQrb.__read)(attr.startPos, 2), sx = _a[0], sy = _a[1], _b = (0, $7WQrb.__read)(attr.endPos, 2), ex = _b[0], ey = _b[1];
    var _c = (0, $7WQrb.__read)([
        ex - sx,
        ey - sy
    ], 2), dx = _c[0], dy = _c[1];
    return [
        sx + dx * value,
        sy + dy * value
    ];
}
function $376a7b0473b1759a$export$ace5045e5fed3a48(value, attr) {
    var radius = attr.radius, _a = (0, $7WQrb.__read)(attr.center, 2), cx = _a[0], cy = _a[1];
    var angle = (0, $amQwj.degToRad)((0, $1GIDL.getLineAngle)(value, attr));
    return [
        cx + radius * Math.cos(angle),
        cy + radius * Math.sin(angle)
    ];
}
function $376a7b0473b1759a$export$5a02054d26e0e06e(value, attr) {
    if (attr.type === 'linear') return $376a7b0473b1759a$export$4addc5405d4e8229(value, attr);
    return $376a7b0473b1759a$export$ace5045e5fed3a48(value, attr);
}
function $376a7b0473b1759a$export$fa52f0e5c3e964d(attr) {
    return (0, $1GIDL.getLineTangentVector)(0, attr)[1] === 0;
}
function $376a7b0473b1759a$export$fb35ad4cde171086(attr) {
    return (0, $1GIDL.getLineTangentVector)(0, attr)[0] === 0;
}
function $376a7b0473b1759a$var$isCircle(startAngle, endAngle) {
    return endAngle - startAngle === 360;
}
function $376a7b0473b1759a$var$getArcPath(startAngle, endAngle, cx, cy, radius) {
    var diffAngle = endAngle - startAngle;
    var _a = (0, $7WQrb.__read)([
        radius,
        radius
    ], 2), rx = _a[0], ry = _a[1];
    var _b = (0, $7WQrb.__read)([
        (0, $amQwj.degToRad)(startAngle),
        (0, $amQwj.degToRad)(endAngle)
    ], 2), startAngleRadians = _b[0], endAngleRadians = _b[1];
    var getPosByAngle = function(angle) {
        return [
            cx + radius * Math.cos(angle),
            cy + radius * Math.sin(angle)
        ];
    };
    var _c = (0, $7WQrb.__read)(getPosByAngle(startAngleRadians), 2), x1 = _c[0], y1 = _c[1];
    var _d = (0, $7WQrb.__read)(getPosByAngle(endAngleRadians), 2), x2 = _d[0], y2 = _d[1];
    if ($376a7b0473b1759a$var$isCircle(startAngle, endAngle)) {
        var middleAngleRadians = (endAngleRadians + startAngleRadians) / 2;
        var _e = (0, $7WQrb.__read)(getPosByAngle(middleAngleRadians), 2), xm = _e[0], ym = _e[1];
        return [
            [
                'M',
                x1,
                y1
            ],
            [
                'A',
                rx,
                ry,
                0,
                1,
                0,
                xm,
                ym
            ],
            [
                'A',
                rx,
                ry,
                0,
                1,
                0,
                x2,
                y2
            ]
        ];
    }
    // 大小弧
    var large = diffAngle > 180 ? 1 : 0;
    // 1-顺时针 0-逆时针
    var sweep = startAngle > endAngle ? 0 : 1;
    var isClosePath = false;
    return isClosePath ? "M".concat(cx, ",").concat(cy, ",L").concat(x1, ",").concat(y1, ",A").concat(rx, ",").concat(ry, ",0,").concat(large, ",").concat(sweep, ",").concat(x2, ",").concat(y2, ",L").concat(cx, ",").concat(cy) : "M".concat(x1, ",").concat(y1, ",A").concat(rx, ",").concat(ry, ",0,").concat(large, ",").concat(sweep, ",").concat(x2, ",").concat(y2);
}
function $376a7b0473b1759a$var$getArcAttr(arc) {
    var _a = arc.attributes, startAngle = _a.startAngle, endAngle = _a.endAngle, center = _a.center, radius = _a.radius;
    return (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([
        startAngle,
        endAngle
    ], (0, $7WQrb.__read)(center), false), [
        radius
    ], false);
}
function $376a7b0473b1759a$var$renderArc(container, attr, style, animate) {
    var startAngle = attr.startAngle, endAngle = attr.endAngle, center = attr.center, radius = attr.radius, classNamePrefix = attr.classNamePrefix;
    return container.selectAll((0, $7h0mn.CLASS_NAMES).line.class).data([
        {
            d: $376a7b0473b1759a$var$getArcPath.apply(void 0, (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([
                startAngle,
                endAngle
            ], (0, $7WQrb.__read)(center), false), [
                radius
            ], false))
        }
    ], function(d, i) {
        return i;
    }).join(function(enter) {
        var line = enter.append('path').attr('className', (0, $7h0mn.CLASS_NAMES).line.name).styles(attr).styles({
            d: function(d) {
                return d.d;
            }
        });
        (0, $cAfhA.applyClassName)(line, (0, $7h0mn.CLASS_NAMES).line, (0, $74vg6.CLASSNAME_SUFFIX_MAP).line, classNamePrefix);
        return line;
    }, function(update) {
        return update.transition(function() {
            var _this = this;
            var animation = (0, $fYEmE.keyframeInterpolate)(this, $376a7b0473b1759a$var$getArcAttr(this), (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([
                startAngle,
                endAngle
            ], (0, $7WQrb.__read)(center), false), [
                radius
            ], false), animate.update);
            if (animation) {
                var layout = function() {
                    var data = (0, $6XARU.default)(_this.attributes, '__keyframe_data__');
                    _this.style.d = $376a7b0473b1759a$var$getArcPath.apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(data), false));
                };
                animation.onframe = layout;
                animation.onfinish = layout;
            }
            return animation;
        }).styles(attr);
    }, function(exit) {
        return exit.remove();
    }).styles(style).transitions();
}
function $376a7b0473b1759a$var$renderTruncation(container, _a) {
    var truncRange = _a.truncRange, truncShape = _a.truncShape, lineExtension = _a.lineExtension;
// TODO
}
function $376a7b0473b1759a$var$extendLine(startPos, endPos, range) {
    if (range === void 0) range = [
        0,
        0
    ];
    var _a = (0, $7WQrb.__read)([
        startPos,
        endPos,
        range
    ], 3), _b = (0, $7WQrb.__read)(_a[0], 2), x1 = _b[0], y1 = _b[1], _c = (0, $7WQrb.__read)(_a[1], 2), x2 = _c[0], y2 = _c[1], _d = (0, $7WQrb.__read)(_a[2], 2), l1 = _d[0], l2 = _d[1];
    var _e = (0, $7WQrb.__read)([
        x2 - x1,
        y2 - y1
    ], 2), x = _e[0], y = _e[1];
    var L = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    var _f = (0, $7WQrb.__read)([
        -l1 / L,
        l2 / L
    ], 2), s1 = _f[0], s2 = _f[1];
    return [
        s1 * x,
        s1 * y,
        s2 * x,
        s2 * y
    ];
}
function $376a7b0473b1759a$var$getLinePath(points) {
    var _a = (0, $7WQrb.__read)(points, 2), _b = (0, $7WQrb.__read)(_a[0], 2), x1 = _b[0], y1 = _b[1], _c = (0, $7WQrb.__read)(_a[1], 2), x2 = _c[0], y2 = _c[1];
    return {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    };
}
function $376a7b0473b1759a$var$renderLinear(container, attr, style, animate) {
    var showTrunc = attr.showTrunc, startPos = attr.startPos, endPos = attr.endPos, truncRange = attr.truncRange, lineExtension = attr.lineExtension, classNamePrefix = attr.classNamePrefix;
    var _a = (0, $7WQrb.__read)([
        startPos,
        endPos
    ], 2), _b = (0, $7WQrb.__read)(_a[0], 2), x1 = _b[0], y1 = _b[1], _c = (0, $7WQrb.__read)(_a[1], 2), x2 = _c[0], y2 = _c[1];
    var _d = (0, $7WQrb.__read)(lineExtension ? $376a7b0473b1759a$var$extendLine(startPos, endPos, lineExtension) : new Array(4).fill(0), 4), ox1 = _d[0], oy1 = _d[1], ox2 = _d[2], oy2 = _d[3];
    var renderLine = function(data) {
        return container.selectAll((0, $7h0mn.CLASS_NAMES).line.class).data(data, function(d, i) {
            return i;
        }).join(function(enter) {
            var lines = enter.append('line').styles(style).transition(function(d) {
                return (0, $bhYrQ.transition)(this, $376a7b0473b1759a$var$getLinePath(d.line), false);
            });
            // Set className with appropriate logic for line elements
            lines.attr('className', function(d) {
                if (!classNamePrefix) return "".concat((0, $7h0mn.CLASS_NAMES).line.name, " ").concat(d.className);
                var baseLineClassName = (0, $cAfhA.getAxisClassName)((0, $7h0mn.CLASS_NAMES).line.name, (0, $74vg6.CLASSNAME_SUFFIX_MAP).line, classNamePrefix);
                if (d.className === (0, $7h0mn.CLASS_NAMES).lineFirst.name) {
                    var specificClassName = (0, $cAfhA.getAxisClassName)((0, $7h0mn.CLASS_NAMES).lineFirst.name, (0, $74vg6.CLASSNAME_SUFFIX_MAP).lineFirst, classNamePrefix);
                    return "".concat(baseLineClassName, " ").concat(specificClassName);
                }
                if (d.className === (0, $7h0mn.CLASS_NAMES).lineSecond.name) {
                    var specificClassName = (0, $cAfhA.getAxisClassName)((0, $7h0mn.CLASS_NAMES).lineSecond.name, (0, $74vg6.CLASSNAME_SUFFIX_MAP).lineSecond, classNamePrefix);
                    return "".concat(baseLineClassName, " ").concat(specificClassName);
                }
                return baseLineClassName;
            });
            return lines;
        }, function(update) {
            return update.styles(style).transition(function(_a) {
                var line = _a.line;
                return (0, $bhYrQ.transition)(this, $376a7b0473b1759a$var$getLinePath(line), animate.update);
            });
        }, function(exit) {
            return exit.remove();
        }).transitions();
    };
    if (!showTrunc || !truncRange) return renderLine([
        {
            line: [
                [
                    x1 + ox1,
                    y1 + oy1
                ],
                [
                    x2 + ox2,
                    y2 + oy2
                ]
            ],
            className: (0, $7h0mn.CLASS_NAMES).line.name
        }
    ]);
    var _e = (0, $7WQrb.__read)(truncRange, 2), r1 = _e[0], r2 = _e[1];
    var dx = x2 - x1;
    var dy = y2 - y1;
    var _f = (0, $7WQrb.__read)([
        x1 + dx * r1,
        y1 + dy * r1
    ], 2), x3 = _f[0], y3 = _f[1];
    var _g = (0, $7WQrb.__read)([
        x1 + dx * r2,
        y1 + dy * r2
    ], 2), x4 = _g[0], y4 = _g[1];
    var animation = renderLine([
        {
            line: [
                [
                    x1 + ox1,
                    y1 + oy1
                ],
                [
                    x3,
                    y3
                ]
            ],
            className: (0, $7h0mn.CLASS_NAMES).lineFirst.name
        },
        {
            line: [
                [
                    x4,
                    y4
                ],
                [
                    x2 + ox2,
                    y2 + oy2
                ]
            ],
            className: (0, $7h0mn.CLASS_NAMES).lineSecond.name
        }
    ]);
    $376a7b0473b1759a$var$renderTruncation(container, attr);
    return animation;
}
function $376a7b0473b1759a$var$renderAxisArrow(container, type, attr, style) {
    var showArrow = attr.showArrow, showTrunc = attr.showTrunc, lineArrow = attr.lineArrow, lineArrowOffset = attr.lineArrowOffset, lineArrowSize = attr.lineArrowSize;
    var shapeToAddArrow;
    if (type === 'arc') shapeToAddArrow = container.select((0, $7h0mn.CLASS_NAMES).line.class);
    else if (showTrunc) shapeToAddArrow = container.select((0, $7h0mn.CLASS_NAMES).lineSecond.class);
    else shapeToAddArrow = container.select((0, $7h0mn.CLASS_NAMES).line.class);
    if (!showArrow || !lineArrow || attr.type === 'arc' && $376a7b0473b1759a$var$isCircle(attr.startAngle, attr.endAngle)) {
        var node = shapeToAddArrow.node();
        if (node) node.style.markerEnd = undefined;
        return;
    }
    var arrow = (0, $i1HPZ.renderExtDo)(lineArrow);
    arrow.attr(style);
    (0, $9JcvC.scaleToPixel)(arrow, lineArrowSize, true);
    shapeToAddArrow.style('markerEnd', arrow).style('markerEndOffset', -lineArrowOffset);
}
function $376a7b0473b1759a$export$6f302ad1d34c1016(container, attr, animate) {
    var type = attr.type;
    var animation;
    var style = (0, $8UxPj.subStyleProps)(attr, 'line');
    if (type === 'linear') animation = $376a7b0473b1759a$var$renderLinear(container, attr, (0, $yHOgd.omit)(style, 'arrow'), animate);
    else animation = $376a7b0473b1759a$var$renderArc(container, attr, (0, $yHOgd.omit)(style, 'arrow'), animate);
    $376a7b0473b1759a$var$renderAxisArrow(container, type, attr, style);
    return animation;
}

});
parcelRegister("fYEmE", function(module, exports) {

$parcel$export(module.exports, "keyframeInterpolate", () => $ba1bc523283d6d20$export$95aacb5dc74f4328);

var $7WQrb = parcelRequire("7WQrb");

var $dr4J9 = parcelRequire("dr4J9");
function $ba1bc523283d6d20$export$95aacb5dc74f4328(element, from, to, options) {
    if (!options) {
        element.attr('__keyframe_data__', to);
        return null;
    }
    var _a = options.duration, duration = _a === void 0 ? 0 : _a;
    var int = (0, $dr4J9.interpolate)(from, to);
    var count = Math.ceil(+duration / 16);
    var keyframes = new Array(count).fill(0).map(function(datum, index, array) {
        return {
            __keyframe_data__: int(index / (array.length - 1))
        };
    });
    // @ts-ignore
    return element.animate(keyframes, (0, $7WQrb.__assign)({
        fill: 'both'
    }, options));
}

});
parcelRegister("dr4J9", function(module, exports) {

$parcel$export(module.exports, "interpolate", () => $9c8176b60c2a180b$export$89e29e4ab65e70a9);

var $7WQrb = parcelRequire("7WQrb");
var $9c8176b60c2a180b$export$14535bef28b63dd4 = function(from, to) {
    return function(t) {
        return from * (1 - t) + to * t;
    };
};
function $9c8176b60c2a180b$export$f7bb9f94066ecb8b(from, to) {
    var nb = to ? to.length : 0;
    var na = from ? Math.min(nb, from.length) : 0;
    return function(t) {
        var x = new Array(na);
        var c = new Array(nb);
        var i = 0;
        for(i = 0; i < na; ++i)x[i] = $9c8176b60c2a180b$export$89e29e4ab65e70a9(from[i], to[i]);
        for(; i < nb; ++i)c[i] = to[i];
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}
function $9c8176b60c2a180b$export$63f0b47547d27b0e(from, to) {
    if (from === void 0) from = {};
    if (to === void 0) to = {};
    var i = {};
    var c = {};
    Object.entries(to).forEach(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), k = _b[0], v = _b[1];
        if (k in from) i[k] = $9c8176b60c2a180b$export$89e29e4ab65e70a9(from[k], v);
        else c[k] = v;
    });
    return function(t) {
        Object.entries(i).forEach(function(_a) {
            var _b = (0, $7WQrb.__read)(_a, 2), k = _b[0], v = _b[1];
            return c[k] = v(t);
        });
        return c;
    };
}
function $9c8176b60c2a180b$export$89e29e4ab65e70a9(from, to) {
    if (typeof from === 'number' && typeof to === 'number') // @ts-ignore
    return $9c8176b60c2a180b$export$14535bef28b63dd4(from, to);
    if (Array.isArray(from) && Array.isArray(to)) // @ts-ignore
    return $9c8176b60c2a180b$export$f7bb9f94066ecb8b(from, to);
    if (typeof from === 'object' && typeof to === 'object') // @ts-ignore
    return $9c8176b60c2a180b$export$63f0b47547d27b0e(from, to);
    return function(t) {
        return from;
    };
}

});


parcelRegister("yHOgd", function(module, exports) {

$parcel$export(module.exports, "omit", () => $068528c66873e5cb$export$30a06c8d3562193f);
function $068528c66873e5cb$export$30a06c8d3562193f(obj, keys) {
    var res = {};
    var innerKeys = Array.isArray(keys) ? keys : [
        keys
    ];
    for(var key in obj)if (!innerKeys.includes(key)) res[key] = obj[key];
    return res;
}

});

parcelRegister("1GIDL", function(module, exports) {

$parcel$export(module.exports, "getCallbackStyle", () => $13ac575107f3e7db$export$7f5c05eed4fb53fd);
$parcel$export(module.exports, "filterExec", () => $13ac575107f3e7db$export$b699db305a353e7);
$parcel$export(module.exports, "getLineAngle", () => $13ac575107f3e7db$export$795d6a40a33d2048);
$parcel$export(module.exports, "getLineTangentVector", () => $13ac575107f3e7db$export$83b151ae803fac5a);
$parcel$export(module.exports, "getDirectionVector", () => $13ac575107f3e7db$export$fa1853a0a5d44d41);
$parcel$export(module.exports, "getLabelVector", () => $13ac575107f3e7db$export$4ead5433833ce3de);

var $7WQrb = parcelRequire("7WQrb");

var $ky7aH = parcelRequire("ky7aH");

var $amQwj = parcelRequire("amQwj");
var $pzxZu = parcelRequire("pzxZu");
var $8jlEv = parcelRequire("8jlEv");
function $13ac575107f3e7db$export$7f5c05eed4fb53fd(style, params) {
    return Object.fromEntries(Object.entries(style).map(function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), key = _b[0], val = _b[1];
        return [
            key,
            (0, $pzxZu.getCallbackValue)(val, params)
        ];
    }));
}
function $13ac575107f3e7db$export$f2deb5eea5b105c6(attr) {
    if (attr.type === 'linear') {
        var startPos = attr.startPos, endPos = attr.endPos;
        return (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(startPos), false), (0, $7WQrb.__read)(endPos), false);
    }
    var startAngle = attr.startAngle, endAngle = attr.endAngle, center = attr.center, radius = attr.radius;
    return (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([
        startAngle,
        endAngle
    ], (0, $7WQrb.__read)(center), false), [
        radius
    ], false);
}
function $13ac575107f3e7db$export$b699db305a353e7(data, filter) {
    return !!filter && (0, $ky7aH.default)(filter) ? data.filter(filter) : data;
}
function $13ac575107f3e7db$export$795d6a40a33d2048(value, attr) {
    var startAngle = attr.startAngle, endAngle = attr.endAngle;
    return (endAngle - startAngle) * value + startAngle;
}
function $13ac575107f3e7db$export$83b151ae803fac5a(value, attr) {
    if (attr.type === 'linear') {
        var _a = (0, $7WQrb.__read)(attr.startPos, 2), startX = _a[0], startY = _a[1], _b = (0, $7WQrb.__read)(attr.endPos, 2), endX = _b[0], endY = _b[1];
        var _c = (0, $7WQrb.__read)([
            endX - startX,
            endY - startY
        ], 2), dx = _c[0], dy = _c[1];
        return (0, $8jlEv.normalize)([
            dx,
            dy
        ]);
    }
    var angle = (0, $amQwj.degToRad)($13ac575107f3e7db$export$795d6a40a33d2048(value, attr));
    return [
        -Math.sin(angle),
        Math.cos(angle)
    ];
}
function $13ac575107f3e7db$export$fa1853a0a5d44d41(value, direction, attr) {
    var tangentVector = $13ac575107f3e7db$export$83b151ae803fac5a(value, attr);
    return (0, $8jlEv.vertical)(tangentVector, direction !== 'positive');
}
function $13ac575107f3e7db$export$4ead5433833ce3de(value, attr) {
    return $13ac575107f3e7db$export$fa1853a0a5d44d41(value, attr.labelDirection, attr);
}

});

parcelRegister("cAfhA", function(module, exports) {

$parcel$export(module.exports, "getAxisClassName", () => $9294b3a556ac8f9a$export$2f0bcade147624fc);
$parcel$export(module.exports, "applyClassName", () => $9294b3a556ac8f9a$export$5f8d65d990aec86b);
/**
 * Generate axis className with optional prefix
 * @param baseClassName Base className (e.g., 'axis-line')
 * @param suffix Suffix (e.g., 'line')
 * @param classNamePrefix User-defined prefix (e.g., 'g2-')
 * @returns Concatenated className
 *
 * @example
 * getAxisClassName('axis-line', 'line', 'g2-')
 * // => 'axis-line g2-axis-line'
 *
 * getAxisClassName('axis-line', 'line', undefined)
 * // => 'axis-line'
 */ function $9294b3a556ac8f9a$export$2f0bcade147624fc(baseClassName, suffix, classNamePrefix) {
    if (!classNamePrefix) return baseClassName;
    return "".concat(baseClassName, " ").concat(classNamePrefix, "axis-").concat(suffix);
}
function $9294b3a556ac8f9a$export$e11d365bafb9ea37(attributes, baseClassName, suffix) {
    var _a = attributes.classNamePrefix, classNamePrefix = _a === void 0 ? '' : _a;
    return $9294b3a556ac8f9a$export$2f0bcade147624fc(baseClassName.name, suffix, classNamePrefix);
}
function $9294b3a556ac8f9a$export$5f8d65d990aec86b(selection, baseClassName, suffix, classNamePrefix) {
    if (classNamePrefix) selection.attr('className', $9294b3a556ac8f9a$export$2f0bcade147624fc(baseClassName.name, suffix, classNamePrefix));
    return selection;
}

});



parcelRegister("lhdae", function(module, exports) {

$parcel$export(module.exports, "renderLabels", () => $f7d5659744f9d59a$export$cb5328a998141874);

var $7WQrb = parcelRequire("7WQrb");

var $6XARU = parcelRequire("6XARU");
var $ky7aH = parcelRequire("ky7aH");

var $ZP1jD = parcelRequire("ZP1jD");
var $bhYrQ = parcelRequire("bhYrQ");

var $8jlEv = parcelRequire("8jlEv");
var $0gesb = parcelRequire("0gesb");
var $pzxZu = parcelRequire("pzxZu");
var $2gch2 = parcelRequire("2gch2");
var $fgSEr = parcelRequire("fgSEr");
var $yHOgd = parcelRequire("yHOgd");
var $5TGTu = parcelRequire("5TGTu");
var $3wJtB = parcelRequire("3wJtB");
var $amQwj = parcelRequire("amQwj");
var $i1HPZ = parcelRequire("i1HPZ");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");
var $gvxmh = parcelRequire("gvxmh");

var $7h0mn = parcelRequire("7h0mn");

var $glLj8 = parcelRequire("glLj8");

var $4vyZO = parcelRequire("4vyZO");

var $4KYCs = parcelRequire("4KYCs");

var $1GIDL = parcelRequire("1GIDL");

var $cAfhA = parcelRequire("cAfhA");

var $74vg6 = parcelRequire("74vg6");
function $f7d5659744f9d59a$var$angleNormalizer(angle) {
    var normalizedAngle = angle;
    while(normalizedAngle < 0)normalizedAngle += 360;
    return Math.round(normalizedAngle % 360);
}
function $f7d5659744f9d59a$var$getAngle(v1, v2) {
    var _a = (0, $7WQrb.__read)(v1, 2), x1 = _a[0], y1 = _a[1];
    var _b = (0, $7WQrb.__read)(v2, 2), x2 = _b[0], y2 = _b[1];
    var _c = (0, $7WQrb.__read)([
        x1 * x2 + y1 * y2,
        x1 * y2 - y1 * x2
    ], 2), dot = _c[0], det = _c[1];
    return Math.atan2(det, dot);
}
/** to correct label rotation to avoid inverted character */ function $f7d5659744f9d59a$var$correctLabelRotation(_rotate) {
    var rotate = (_rotate + 360) % 180;
    if (!(0, $fgSEr.inRange)(rotate, -90, 90)) rotate += 180;
    return rotate;
}
/** get rotation from preset or layout */ function $f7d5659744f9d59a$var$getLabelRotation(datum, label, attr) {
    var _a;
    var labelAlign = attr.labelAlign;
    // if label rotate is set, use it
    var customRotate = (_a = label.style.transform) === null || _a === void 0 ? void 0 : _a.includes('rotate');
    if (customRotate) return label.getLocalEulerAngles();
    var rotate = 0;
    var labelVector = (0, $1GIDL.getLabelVector)(datum.value, attr);
    var tangentVector = (0, $1GIDL.getLineTangentVector)(datum.value, attr);
    if (labelAlign === 'horizontal') return 0;
    if (labelAlign === 'perpendicular') rotate = $f7d5659744f9d59a$var$getAngle([
        1,
        0
    ], labelVector);
    else rotate = $f7d5659744f9d59a$var$getAngle([
        tangentVector[0] < 0 ? -1 : 1,
        0
    ], tangentVector);
    return $f7d5659744f9d59a$var$correctLabelRotation((0, $amQwj.radToDeg)(rotate));
}
/** get the label align according to its tick and label angle  */ function $f7d5659744f9d59a$var$getLabelStyle(value, rotate, attr) {
    var type = attr.type, labelAlign = attr.labelAlign;
    var labelVector = (0, $1GIDL.getLabelVector)(value, attr);
    var labelAngle = $f7d5659744f9d59a$var$angleNormalizer(rotate);
    var tickAngle = $f7d5659744f9d59a$var$angleNormalizer((0, $amQwj.radToDeg)($f7d5659744f9d59a$var$getAngle([
        1,
        0
    ], labelVector)));
    var textAlign = 'center';
    var textBaseline = 'middle';
    if (type === 'linear') {
        // tick 和 label 均为水平或垂直时，做快速判断
        if ([
            90,
            270
        ].includes(tickAngle) && labelAngle === 0) {
            textAlign = 'center';
            textBaseline = labelVector[1] === 1 ? 'top' : 'bottom';
        } else if (!(tickAngle % 180) && [
            90,
            270
        ].includes(labelAngle)) textAlign = 'center';
        else if (tickAngle === 0) {
            if ((0, $fgSEr.inRange)(labelAngle, 0, 90, false, true)) textAlign = 'start';
            else if ((0, $fgSEr.inRange)(labelAngle, 0, 90) || (0, $fgSEr.inRange)(labelAngle, 270, 360)) textAlign = 'start';
        } else if (tickAngle === 90) {
            if ((0, $fgSEr.inRange)(labelAngle, 0, 90, false, true)) textAlign = 'start';
            else if ((0, $fgSEr.inRange)(labelAngle, 90, 180) || (0, $fgSEr.inRange)(labelAngle, 270, 360)) textAlign = 'end';
        } else if (tickAngle === 270) {
            if ((0, $fgSEr.inRange)(labelAngle, 0, 90, false, true)) textAlign = 'end';
            else if ((0, $fgSEr.inRange)(labelAngle, 90, 180) || (0, $fgSEr.inRange)(labelAngle, 270, 360)) textAlign = 'start';
        } else if (tickAngle === 180) {
            if (labelAngle === 90) textAlign = 'start';
            else if ((0, $fgSEr.inRange)(labelAngle, 0, 90) || (0, $fgSEr.inRange)(labelAngle, 270, 360)) textAlign = 'end';
        }
    /**
         * todo tick 倾斜时的判断逻辑，该情况下坐标轴非垂直或水平
         */ } else {
        // 弧线坐标轴 label 的对齐方式判断逻辑
        if (labelAlign === 'parallel') {
            if ((0, $fgSEr.inRange)(tickAngle, 0, 180, true)) textBaseline = 'top';
            else textBaseline = 'bottom';
        } else if (labelAlign === 'horizontal') {
            if ((0, $fgSEr.inRange)(tickAngle, 90, 270, false)) textAlign = 'end';
            else if ((0, $fgSEr.inRange)(tickAngle, 270, 360, false) || (0, $fgSEr.inRange)(tickAngle, 0, 90)) textAlign = 'start';
        } else if (labelAlign === 'perpendicular') {
            if ((0, $fgSEr.inRange)(tickAngle, 90, 270)) textAlign = 'end';
            else textAlign = 'start';
        }
    }
    return {
        textAlign: textAlign,
        textBaseline: textBaseline
    };
}
function $f7d5659744f9d59a$var$setRotateAndAdjustLabelAlign(rotate, group, attr) {
    group.setLocalEulerAngles(rotate);
    var value = group.__data__.value;
    var textStyle = $f7d5659744f9d59a$var$getLabelStyle(value, rotate, attr);
    var label = group.querySelector((0, $7h0mn.CLASS_NAMES).labelItem.class);
    if (label) $f7d5659744f9d59a$var$applyTextStyle(label, textStyle);
}
function $f7d5659744f9d59a$var$getLabelPos(datum, data, attr) {
    var showTick = attr.showTick, tickLength = attr.tickLength, tickDirection = attr.tickDirection, labelDirection = attr.labelDirection, labelSpacing = attr.labelSpacing;
    var index = data.indexOf(datum);
    var finalLabelSpacing = (0, $pzxZu.getCallbackValue)(labelSpacing, [
        datum,
        index,
        data
    ]);
    var _a = (0, $7WQrb.__read)([
        (0, $1GIDL.getLabelVector)(datum.value, attr),
        (0, $4vyZO.getFactor)(labelDirection, tickDirection)
    ], 2), labelVector = _a[0], unionFactor = _a[1];
    var extraLength = unionFactor === 1 ? (0, $pzxZu.getCallbackValue)(showTick ? tickLength : 0, [
        datum,
        index,
        data
    ]) : 0;
    var _b = (0, $7WQrb.__read)((0, $8jlEv.add)((0, $8jlEv.scale)(labelVector, finalLabelSpacing + extraLength), (0, $4KYCs.getValuePos)(datum.value, attr)), 2), x = _b[0], y = _b[1];
    return {
        x: x,
        y: y
    };
}
function $f7d5659744f9d59a$var$formatter(datum, index, data, attr) {
    var labelFormatter = attr.labelFormatter;
    var element = (0, $ky7aH.default)(labelFormatter) ? function() {
        return (0, $i1HPZ.renderExtDo)((0, $pzxZu.getCallbackValue)(labelFormatter, [
            datum,
            index,
            data,
            (0, $1GIDL.getLabelVector)(datum.value, attr)
        ]));
    } : function() {
        return (0, $i1HPZ.renderExtDo)(datum.label || '');
    };
    return element;
}
function $f7d5659744f9d59a$var$renderHTMLLabel(datum, index, data, attr) {
    var labelRender = attr.labelRender;
    var elementWidth = ((0, $6XARU.default)(attr, 'endPos.0', 400) - (0, $6XARU.default)(attr, 'startPos.0', 0)) / data.length;
    var elStr = (0, $ky7aH.default)(labelRender) ? (0, $pzxZu.getCallbackValue)(labelRender, [
        datum,
        index,
        data,
        (0, $1GIDL.getLabelVector)(datum.value, attr)
    ]) : datum.label || '';
    var elementHeight = (0, $5TGTu.parseHeightFromHTML)(elStr) || 30;
    return function() {
        return (0, $i1HPZ.renderHtmlExtDo)(elStr, {
            width: elementWidth,
            height: elementHeight
        });
    };
}
var $f7d5659744f9d59a$var$STYLE_OMIT_MAP = {
    html: [
        'fill'
    ],
    text: []
};
function $f7d5659744f9d59a$var$applyTextStyle(node, style) {
    if ([
        'text',
        'html'
    ].includes(node.nodeName)) node.attr((0, $yHOgd.omit)(style, $f7d5659744f9d59a$var$STYLE_OMIT_MAP[node.nodeName]));
}
function $f7d5659744f9d59a$var$overlapHandler(attr, main) {
    (0, $glLj8.processOverlap)(this.node().childNodes, attr, main, {
        hide: (0, $2gch2.hide),
        show: (0, $2gch2.show),
        rotate: function(label, angle) {
            $f7d5659744f9d59a$var$setRotateAndAdjustLabelAlign(+angle, label, attr);
        },
        ellipsis: function(label, len, suffix) {
            label && (0, $0gesb.ellipsisIt)(label, len || Infinity, suffix);
        },
        wrap: function(label, width, lines) {
            label && (0, $gvxmh.wrapIt)(label, width, lines);
        },
        getTextShape: function(label) {
            return label.querySelector((0, $7h0mn.CLASS_NAMES).labelItem.class);
        }
    });
}
function $f7d5659744f9d59a$var$renderLabel(container, datum, data, style, attr) {
    var index = data.indexOf(datum);
    var labelRender = attr.labelRender, classNamePrefix = attr.classNamePrefix;
    var label = (0, $bCy7Q.select)(container).append(labelRender ? $f7d5659744f9d59a$var$renderHTMLLabel(datum, index, data, attr) : $f7d5659744f9d59a$var$formatter(datum, index, data, attr)).attr('className', (0, $7h0mn.CLASS_NAMES).labelItem.name).node();
    (0, $cAfhA.applyClassName)((0, $bCy7Q.select)(label), (0, $7h0mn.CLASS_NAMES).labelItem, (0, $74vg6.CLASSNAME_SUFFIX_MAP).labelItem, classNamePrefix);
    var _a = (0, $7WQrb.__read)((0, $8UxPj.splitStyle)((0, $1GIDL.getCallbackStyle)(style, [
        datum,
        index,
        data
    ])), 2), labelStyle = _a[0], _b = _a[1], transform = _b.transform, groupStyle = (0, $7WQrb.__rest)(_b, [
        "transform"
    ]);
    (0, $3wJtB.percentTransform)(label, transform);
    var rotate = $f7d5659744f9d59a$var$getLabelRotation(datum, label, attr);
    if (!label.getLocalEulerAngles()) label.setLocalEulerAngles(rotate);
    $f7d5659744f9d59a$var$applyTextStyle(label, (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, $f7d5659744f9d59a$var$getLabelStyle(datum.value, rotate, attr)), labelStyle));
    // For HTML labels, adjust x position to center align.
    if (label.nodeName === 'html') {
        var bbox = label.getBBox();
        var currentX = label.style.x || 0;
        label.attr('x', currentX - bbox.width / 2);
    }
    container.attr(groupStyle);
    return label;
}
function $f7d5659744f9d59a$export$cb5328a998141874(container, data, attr, animate, main) {
    var classNamePrefix = attr.classNamePrefix;
    var finalData = (0, $1GIDL.filterExec)(data, attr.labelFilter);
    var style = (0, $8UxPj.subStyleProps)(attr, 'label');
    var _exit;
    var transitions = container.selectAll((0, $7h0mn.CLASS_NAMES).label.class).data(finalData, function(d, i) {
        return i;
    }).join(function(enter) {
        var labels = enter.append('g').attr('className', (0, $7h0mn.CLASS_NAMES).label.name).transition(function(datum) {
            $f7d5659744f9d59a$var$renderLabel(this, datum, data, style, attr);
            var _a = $f7d5659744f9d59a$var$getLabelPos(datum, data, attr), x = _a.x, y = _a.y;
            this.style.transform = "translate(".concat(x, ", ").concat(y, ")");
            return null;
        });
        (0, $cAfhA.applyClassName)(labels, (0, $7h0mn.CLASS_NAMES).label, (0, $74vg6.CLASSNAME_SUFFIX_MAP).label, classNamePrefix);
        return labels;
    }, function(update) {
        return update.transition(function(datum) {
            var prevLabel = this.querySelector((0, $7h0mn.CLASS_NAMES).labelItem.class);
            var label = $f7d5659744f9d59a$var$renderLabel(this, datum, data, style, attr);
            var shapeAnimation = (0, $bhYrQ.transitionShape)(prevLabel, label, animate.update);
            var _a = $f7d5659744f9d59a$var$getLabelPos(datum, data, attr), x = _a.x, y = _a.y;
            var animation = (0, $bhYrQ.transition)(this, {
                transform: "translate(".concat(x, ", ").concat(y, ")")
            }, animate.update);
            return (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(shapeAnimation), false), [
                animation
            ], false);
        // return [animation];
        });
    }, function(exit) {
        _exit = exit;
        exit.transition(function() {
            var _this = this;
            var animation = (0, $ZP1jD.default)(this.childNodes[0], animate.exit);
            (0, $bhYrQ.onAnimateFinished)(animation, function() {
                return (0, $bCy7Q.select)(_this).remove();
            });
            return animation;
        });
        return _exit;
    }).transitions();
    // handle overlapping after transitions finished
    (0, $bhYrQ.onAnimatesFinished)(transitions, function() {
        $f7d5659744f9d59a$var$overlapHandler.call(container, attr, main);
    });
    return transitions;
}

});
parcelRegister("fgSEr", function(module, exports) {

$parcel$export(module.exports, "inRange", () => $b1e2be3c97bd3270$export$ddf89a9c5af38f94);
function $b1e2be3c97bd3270$export$ddf89a9c5af38f94(n, start, end, includeLeft, includeRight) {
    if (includeLeft === void 0) includeLeft = true;
    if (includeRight === void 0) includeRight = false;
    if (includeLeft && n === start || includeRight && n === end) return true;
    return n > start && n < end;
}

});

parcelRegister("5TGTu", function(module, exports) {

$parcel$export(module.exports, "parseHeightFromHTML", () => $44b35caa1a7f938b$export$4131aa61fd102d25);

var $7WQrb = parcelRequire("7WQrb");
var $44b35caa1a7f938b$export$4131aa61fd102d25 = function(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var el = doc.body.firstElementChild;
    console.log(el === null || el === void 0 ? void 0 : el.getClientRects(), 11);
    if (!el) return 0;
    var style = el.getAttribute('style') || '';
    var rules = Object.fromEntries(style.split(';').map(function(r) {
        return r.trim();
    }).filter(function(r) {
        return r.includes(':');
    }).map(function(r) {
        var _a = (0, $7WQrb.__read)(r.split(':').map(function(s) {
            return s.trim();
        }), 2), key = _a[0], value = _a[1];
        return [
            key.toLowerCase(),
            value
        ];
    }));
    var parsePx = function(v) {
        if (!v) return 0;
        var match = v.match(/([\d.]+)px/);
        return match ? parseFloat(match[1]) : 0;
    };
    if (rules.height) return parsePx(rules.height);
    var fontSize = parsePx(rules['font-size']) || 16;
    // line-height
    var lineHeight = rules['line-height'];
    var baseHeight;
    if (!lineHeight || lineHeight === 'normal') baseHeight = 1.2 * fontSize; // 默认 normal ≈ 1.2
    else if (lineHeight.endsWith('px')) baseHeight = parsePx(lineHeight);
    else if (/^[\d.]+$/.test(lineHeight)) baseHeight = parseFloat(lineHeight) * fontSize;
    else baseHeight = fontSize; // fallback
    var paddingTop = parsePx(rules['padding-top']);
    var paddingBottom = parsePx(rules['padding-bottom']);
    if (rules.padding) {
        var parts = rules.padding.split(/\s+/).map(parsePx);
        if (parts.length === 1) {
            paddingTop = parts[0];
            paddingBottom = parts[0];
        } else if (parts.length === 2) {
            paddingTop = parts[0];
            paddingBottom = parts[0];
        } else if (parts.length === 3) {
            paddingTop = parts[0];
            paddingBottom = parts[2];
        } else if (parts.length === 4) {
            paddingTop = parts[0];
            paddingBottom = parts[2];
        }
    }
    var borderTop = parsePx(rules['border-top-width']);
    var borderBottom = parsePx(rules['border-bottom-width']);
    if (rules.border) {
        var match = rules.border.match(/([\d.]+)px/);
        if (match) {
            borderTop = parseFloat(match[1]);
            borderBottom = parseFloat(match[1]);
        }
    }
    if (rules['border-width']) {
        var parts = rules['border-width'].split(/\s+/).map(parsePx);
        if (parts.length === 1) {
            borderTop = parts[0];
            borderBottom = parts[0];
        } else if (parts.length === 2) {
            borderTop = parts[0];
            borderBottom = parts[0];
        } else if (parts.length === 3) {
            borderTop = parts[0];
            borderBottom = parts[2];
        } else if (parts.length === 4) {
            borderTop = parts[0];
            borderBottom = parts[2];
        }
    }
    return baseHeight + paddingTop + paddingBottom + borderTop + borderBottom;
};

});

parcelRegister("3wJtB", function(module, exports) {

$parcel$export(module.exports, "percentTransform", () => $2917a2f1b2b9843b$export$21d4c721b7d403d9);

var $7WQrb = parcelRequire("7WQrb");
function $2917a2f1b2b9843b$export$5ec402b7fcf74398(node, x, y) {
    var _a = node.getBBox(), width = _a.width, height = _a.height;
    var _b = (0, $7WQrb.__read)([
        x,
        y
    ].map(function(v, i) {
        var _a;
        return v.includes('%') ? parseFloat(((_a = v.match(/[+-]?([0-9]*[.])?[0-9]+/)) === null || _a === void 0 ? void 0 : _a[0]) || '0') / 100 * (i === 0 ? width : height) : v;
    }), 2), tx = _b[0], ty = _b[1];
    return [
        tx,
        ty
    ];
}
function $2917a2f1b2b9843b$export$21d4c721b7d403d9(node, val) {
    if (!val) return;
    try {
        var reg = /translate\(([+-]*[\d]+[%]*),[ ]*([+-]*[\d]+[%]*)\)/g;
        var computedVal = val.replace(reg, function(match, x, y) {
            return "translate(".concat($2917a2f1b2b9843b$export$5ec402b7fcf74398(node, x, y), ")");
        });
        node.attr('transform', computedVal);
    } catch (e) {
    // do nothing
    }
}

});

parcelRegister("gvxmh", function(module, exports) {

$parcel$export(module.exports, "wrapIt", () => $c0496addce788d3e$export$9ee98c3b0edd564b);

var $9J3on = parcelRequire("9J3on");
function $c0496addce788d3e$export$9ee98c3b0edd564b(node, wordWrapWidth, maxLines, textBaseline) {
    if (maxLines === void 0) maxLines = 2;
    if (textBaseline === void 0) textBaseline = 'top';
    (0, $9J3on.applyToText)(node, {
        wordWrap: true,
        wordWrapWidth: wordWrapWidth,
        maxLines: maxLines,
        textBaseline: textBaseline
    });
}

});

parcelRegister("glLj8", function(module, exports) {

$parcel$export(module.exports, "processOverlap", () => $be734dcffa989a87$export$7299abcc6f8d1247);

var $1qXAC = parcelRequire("1qXAC");

var $aedfp = parcelRequire("aedfp");

var $lOv6x = parcelRequire("lOv6x");

var $6aNA9 = parcelRequire("6aNA9");

var $WWdoN = parcelRequire("WWdoN");
var $be734dcffa989a87$export$f306f3e820edd572 = new Map([
    [
        'hide',
        (0, $lOv6x.default)
    ],
    [
        'rotate',
        (0, $6aNA9.default)
    ],
    [
        'ellipsis',
        (0, $aedfp.default)
    ],
    [
        'wrap',
        (0, $WWdoN.default)
    ]
]);
function $be734dcffa989a87$export$1b6d39304dd9501b(labels, attr, type) {
    if (attr.labelOverlap.length < 1) return false;
    if (type === 'hide') return !(0, $1qXAC.isInOffscreenGroup)(labels[0]);
    if (type === 'rotate') return !labels.some(function(label) {
        var _a;
        return !!((_a = label.attr('transform')) === null || _a === void 0 ? void 0 : _a.includes('rotate'));
    });
    if (type === 'ellipsis' || type === 'wrap') return labels.filter(function(item) {
        return item.querySelector('text');
    }).length >= 1;
    return true;
}
function $be734dcffa989a87$export$7299abcc6f8d1247(labels, attr, main, utils) {
    var _a = attr.labelOverlap, labelOverlap = _a === void 0 ? [] : _a;
    if (!labelOverlap.length) return;
    labelOverlap.forEach(function(overlapCfg) {
        var type = overlapCfg.type;
        var util = $be734dcffa989a87$export$f306f3e820edd572.get(type);
        if ($be734dcffa989a87$export$1b6d39304dd9501b(labels, attr, type)) util === null || util === void 0 || util(labels, overlapCfg, attr, utils, main);
    });
}

});
parcelRegister("aedfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $77257ce1bbbb3c0f$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $geZBG = parcelRequire("geZBG");

var $9J3on = parcelRequire("9J3on");

var $lNGGT = parcelRequire("lNGGT");
function $77257ce1bbbb3c0f$var$parseLengthString(str, font) {
    if (font === void 0) font = {};
    if ((0, $geZBG.default)(str)) return 0;
    if (typeof str === 'number') return str;
    return Math.floor((0, $9J3on.measureTextWidth)(str, font));
}
function $77257ce1bbbb3c0f$export$2e2bcd8739ae039(labels, overlapCfg, attr, utils) {
    if (labels.length <= 0) return;
    var _a = overlapCfg.suffix, suffix = _a === void 0 ? '...' : _a, minLength = overlapCfg.minLength, _b = overlapCfg.maxLength, maxLength = _b === void 0 ? Infinity : _b, _c = overlapCfg.step, ellipsisStep = _c === void 0 ? ' ' : _c, _d = overlapCfg.margin, margin = _d === void 0 ? [
        0,
        0,
        0,
        0
    ] : _d;
    var font = (0, $9J3on.getFont)(utils.getTextShape(labels[0]));
    var step = $77257ce1bbbb3c0f$var$parseLengthString(ellipsisStep, font);
    var min = minLength ? $77257ce1bbbb3c0f$var$parseLengthString(minLength, font) : step;
    var max = $77257ce1bbbb3c0f$var$parseLengthString(maxLength, font);
    // Enable to ellipsis label when overlap.
    if ((0, $geZBG.default)(max) || max === Infinity) max = Math.max.apply(null, labels.map(function(d) {
        return d.getBBox().width;
    }));
    // Generally, 100 ticks cost less than 300ms. If cost time exceed, means ticks count is too large to see.
    var source = labels.slice();
    var _e = (0, $7WQrb.__read)(margin, 4), _f = _e[0], top = _f === void 0 ? 0 : _f, _g = _e[1], right = _g === void 0 ? 0 : _g, _h = _e[2], bottom = _h === void 0 ? top : _h, _j = _e[3], left = _j === void 0 ? right : _j;
    var _loop_1 = function(allowedLength) {
        source.forEach(function(label) {
            utils.ellipsis(utils.getTextShape(label), allowedLength, suffix);
        });
        source = (0, $lNGGT.boundTest)(labels, attr, margin);
        // 碰撞检测
        if (source.length < 1) return {
            value: void 0
        };
    };
    for(var allowedLength = max; allowedLength > min + step; allowedLength -= step){
        var state_1 = _loop_1(allowedLength);
        if (typeof state_1 === "object") return state_1.value;
    }
}

});
parcelRegister("lNGGT", function(module, exports) {

$parcel$export(module.exports, "boundTest", () => $fdef4a1a1a4cea36$export$1b770fb580da2a20);

var $7WQrb = parcelRequire("7WQrb");

var $le54I = parcelRequire("le54I");
var $8jlEv = parcelRequire("8jlEv");

var $1GIDL = parcelRequire("1GIDL");

var $4KYCs = parcelRequire("4KYCs");

var $20RI8 = parcelRequire("20RI8");

var $7Xehs = parcelRequire("7Xehs");

var $XbTbf = parcelRequire("XbTbf");
/**
 * 创建副轴包围盒
 * @returns return false if no crossSize, else croseBBox
 */ function $fdef4a1a1a4cea36$var$createCrossBBox(attr, padding) {
    var type = attr.type, labelDirection = attr.labelDirection, crossSize = attr.crossSize;
    if (!crossSize) return false;
    if (type === 'arc') {
        var center = attr.center, radius = attr.radius;
        var _a = (0, $7WQrb.__read)(center, 2), cx = _a[0], cy = _a[1];
        var size = labelDirection === 'negative' ? 0 : crossSize;
        var dMin = -radius - size;
        var dMax = radius + size;
        var _b = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(padding), 4), top_1 = _b[0], right_1 = _b[1], bottom_1 = _b[2], left_1 = _b[3];
        // 假定始终为顺时针方向
        return new (0, $20RI8.Bounds)(cx + dMin - left_1, cy + dMin - top_1, cx + dMax + right_1, cy + dMax + bottom_1);
    }
    var _c = (0, $7WQrb.__read)(attr.startPos, 2), sx = _c[0], sy = _c[1], _d = (0, $7WQrb.__read)(attr.endPos, 2), ex = _d[0], ey = _d[1];
    // 水平时取左右，垂直时取上下
    var _e = (0, $7WQrb.__read)((0, $4KYCs.isAxisVertical)(attr) ? [
        -padding,
        0,
        padding,
        0
    ] : [
        0,
        padding,
        0,
        -padding
    ], 4), top = _e[0], right = _e[1], bottom = _e[2], left = _e[3];
    var labelVector = (0, $1GIDL.getLabelVector)(0, attr);
    var diff = (0, $8jlEv.scale)(labelVector, crossSize);
    var bbox = new (0, $20RI8.Bounds)(sx, sy, ex, ey);
    bbox.x1 += left;
    bbox.y1 += top;
    bbox.x2 += right + diff[0];
    bbox.y2 += bottom + diff[1];
    return bbox;
}
function $fdef4a1a1a4cea36$export$1b770fb580da2a20(items, attr, margin) {
    var e_1, _a;
    var crossPadding = attr.crossPadding;
    var resultSet = new Set();
    var prev = null;
    var crossBBox = $fdef4a1a1a4cea36$var$createCrossBBox(attr, crossPadding);
    var testContain = function(item) {
        if (crossBBox) return (0, $7Xehs.contain)(crossBBox, item);
        return true;
    };
    var testIntersect = function(prevItem, currItem) {
        if (!prevItem || !prevItem.firstChild) return true;
        // Get the first child of the item(Text).
        // @ts-ignore
        return !(0, $XbTbf.intersect)(prevItem.firstChild, currItem.firstChild, (0, $le54I.parseSeriesAttr)(margin));
    };
    try {
        for(var items_1 = (0, $7WQrb.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var curr = items_1_1.value;
            if (!testContain(curr)) resultSet.add(curr);
            else if (!prev || testIntersect(prev, curr)) prev = curr;
            else {
                resultSet.add(prev);
                resultSet.add(curr);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return Array.from(resultSet);
}

});
parcelRegister("20RI8", function(module, exports) {

$parcel$export(module.exports, "Bounds", () => $17753eb9e902ab00$export$c4e9d269599ab4b4);
$parcel$export(module.exports, "getBounds", () => $17753eb9e902ab00$export$becd1e645219fa23);

var $7WQrb = parcelRequire("7WQrb");

var $amQwj = parcelRequire("amQwj");
var $le54I = parcelRequire("le54I");
var $9J3on = parcelRequire("9J3on");
var $17753eb9e902ab00$export$c4e9d269599ab4b4 = /** @class */ function() {
    function Bounds(x1, y1, x2, y2) {
        this.set(x1, y1, x2, y2);
    }
    Object.defineProperty(Bounds.prototype, "left", {
        get: function() {
            return this.x1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "top", {
        get: function() {
            return this.y1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "right", {
        get: function() {
            return this.x2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "bottom", {
        get: function() {
            return this.y2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "width", {
        get: function() {
            return this.defined('x2') && this.defined('x1') ? this.x2 - this.x1 : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Bounds.prototype, "height", {
        get: function() {
            return this.defined('y2') && this.defined('y1') ? this.y2 - this.y1 : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Bounds.prototype.rotatedPoints = function(radian, x, y) {
        var _a = this, x1 = _a.x1, y1 = _a.y1, x2 = _a.x2, y2 = _a.y2;
        var cos = Math.cos(radian);
        var sin = Math.sin(radian);
        var cx = x - x * cos + y * sin;
        var cy = y - x * sin - y * cos;
        var points = [
            [
                cos * x1 - sin * y2 + cx,
                sin * x1 + cos * y2 + cy
            ],
            [
                cos * x2 - sin * y2 + cx,
                sin * x2 + cos * y2 + cy
            ],
            [
                cos * x1 - sin * y1 + cx,
                sin * x1 + cos * y1 + cy
            ],
            [
                cos * x2 - sin * y1 + cx,
                sin * x2 + cos * y1 + cy
            ]
        ];
        return points;
    };
    Bounds.prototype.set = function(x1, y1, x2, y2) {
        if (x2 < x1) {
            this.x2 = x1;
            this.x1 = x2;
        } else {
            this.x1 = x1;
            this.x2 = x2;
        }
        if (y2 < y1) {
            this.y2 = y1;
            this.y1 = y2;
        } else {
            this.y1 = y1;
            this.y2 = y2;
        }
        return this;
    };
    Bounds.prototype.defined = function(key) {
        return this[key] !== Number.MAX_VALUE && this[key] !== -Number.MAX_VALUE;
    };
    return Bounds;
}();
function $17753eb9e902ab00$export$becd1e645219fa23(item, margin) {
    var angle = item.getEulerAngles() || 0;
    item.setEulerAngles(0);
    // get dimensions
    var _a = item.getBounds(), _b = (0, $7WQrb.__read)(_a.min, 2), x = _b[0], y = _b[1], _c = (0, $7WQrb.__read)(_a.max, 2), right = _c[0], bottom = _c[1];
    var _d = item.getBBox(), w = _d.width, h = _d.height;
    var height = h;
    var dx = 0;
    var dy = 0;
    var anchorX = x;
    var anchorY = y;
    var text = (0, $9J3on.textOf)(item);
    if (text) {
        // [to fix] 目前 G 上计算 bbox 有一点误差
        height -= 1.5;
        var a = text.style.textAlign;
        var b_1 = text.style.textBaseline;
        // horizontal alignment
        if (a === 'center') anchorX = (x + right) / 2;
        else if (a === 'right' || a === 'end') anchorX = right;
        // vertical alignment
        if (b_1 === 'middle') anchorY = (y + bottom) / 2;
        else if (b_1 === 'bottom') anchorY = bottom;
    }
    var _e = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(margin), 4), _f = _e[0], t = _f === void 0 ? 0 : _f, _g = _e[1], r = _g === void 0 ? 0 : _g, _h = _e[2], b = _h === void 0 ? t : _h, _j = _e[3], l = _j === void 0 ? r : _j;
    var bounds = new $17753eb9e902ab00$export$c4e9d269599ab4b4((dx += x) - l, (dy += y) - t, dx + w + r, dy + height + b);
    item.setEulerAngles(angle);
    return bounds.rotatedPoints((0, $amQwj.degToRad)(angle), anchorX, anchorY);
}

});

parcelRegister("7Xehs", function(module, exports) {

$parcel$export(module.exports, "contain", () => $5ca91ee6c101eef2$export$8893e2b90ba10d92);

var $20RI8 = parcelRequire("20RI8");
function $5ca91ee6c101eef2$var$onLine(line, point) {
    return point[0] <= Math.max(line[0][0], line[1][0]) && point[0] <= Math.min(line[0][0], line[1][0]) && point[1] <= Math.max(line[0][1], line[1][1]) && point[1] <= Math.min(line[0][1], line[1][1]);
}
function $5ca91ee6c101eef2$var$direction(a, b, c) {
    var val = (b[1] - a[1]) * (c[0] - b[0]) - (b[0] - a[0]) * (c[1] - b[1]);
    if (val === 0) return 0;
    return val < 0 ? 2 : 1;
}
function $5ca91ee6c101eef2$var$isIntersect(line1, line2) {
    var dir1 = $5ca91ee6c101eef2$var$direction(line1[0], line1[1], line2[0]);
    var dir2 = $5ca91ee6c101eef2$var$direction(line1[0], line1[1], line2[1]);
    var dir3 = $5ca91ee6c101eef2$var$direction(line2[0], line2[1], line1[0]);
    var dir4 = $5ca91ee6c101eef2$var$direction(line2[0], line2[1], line1[1]);
    if (dir1 !== dir2 && dir3 !== dir4) return true;
    if (dir1 === 0 && $5ca91ee6c101eef2$var$onLine(line1, line2[0])) return true;
    if (dir2 === 0 && $5ca91ee6c101eef2$var$onLine(line1, line2[1])) return true;
    if (dir3 === 0 && $5ca91ee6c101eef2$var$onLine(line2, line1[0])) return true;
    if (dir4 === 0 && $5ca91ee6c101eef2$var$onLine(line2, line1[1])) return true;
    return false;
}
function $5ca91ee6c101eef2$export$551a376ab478102b(polygon, point) {
    var n = polygon.length;
    if (n < 3) return false;
    var lineToInfinity = [
        point,
        [
            9999,
            point[1]
        ]
    ];
    var count = 0;
    var i = 0;
    do {
        var side = [
            polygon[i],
            polygon[(i + 1) % n]
        ];
        if ($5ca91ee6c101eef2$var$isIntersect(side, lineToInfinity)) {
            if ($5ca91ee6c101eef2$var$direction(side[0], point, side[1]) === 0) return $5ca91ee6c101eef2$var$onLine(side, point);
            count++;
        }
        i = (i + 1) % n;
    }while (i !== 0);
    return !!(count & 1);
}
function $5ca91ee6c101eef2$export$89cacd06107f33c8(rectA, rectB) {
    return rectB.every(function(point) {
        return $5ca91ee6c101eef2$export$551a376ab478102b(rectA, point);
    });
}
function $5ca91ee6c101eef2$export$8893e2b90ba10d92(container, child, margin) {
    var x1 = container.x1, x2 = container.x2, y1 = container.y1, y2 = container.y2;
    var parent = [
        [
            x1,
            y1
        ],
        [
            x2,
            y1
        ],
        [
            x2,
            y2
        ],
        [
            x1,
            y2
        ]
    ];
    var element = (0, $20RI8.getBounds)(child, margin);
    return $5ca91ee6c101eef2$export$89cacd06107f33c8(parent, element);
}

});

parcelRegister("XbTbf", function(module, exports) {

$parcel$export(module.exports, "intersect", () => $0b1ebbb63a90f3ed$export$1f4807a235930d45);

var $7WQrb = parcelRequire("7WQrb");

var $20RI8 = parcelRequire("20RI8");
/**
 * Detect whether line-line collision.
 * From: https://stackoverflow.com/questions/563198/how-do-you-detect-where-two-line-segments-intersect
 */ function $0b1ebbb63a90f3ed$var$lineToLine(line1, line2) {
    var _a = (0, $7WQrb.__read)(line1, 4), x0 = _a[0], y0 = _a[1], x1 = _a[2], y1 = _a[3];
    var _b = (0, $7WQrb.__read)(line2, 4), x2 = _b[0], y2 = _b[1], x3 = _b[2], y3 = _b[3];
    var s10x = x1 - x0;
    var s10y = y1 - y0;
    var s32x = x3 - x2;
    var s32y = y3 - y2;
    var denom = s10x * s32y - s32x * s10y;
    if (denom === 0) return false;
    var denomPositive = denom > 0;
    var s02x = x0 - x2;
    var s02y = y0 - y2;
    var sNum = s10x * s02y - s10y * s02x;
    if (sNum < 0 === denomPositive) return false;
    var tNum = s32x * s02y - s32y * s02x;
    if (tNum < 0 === denomPositive) return false;
    if (sNum > denom === denomPositive || tNum > denom === denomPositive) return false;
    return true;
}
function $0b1ebbb63a90f3ed$var$intersectBoxLine(box /** 八个顶点 */ , line) {
    var lines = [
        [
            box[0],
            box[1],
            box[2],
            box[3]
        ],
        [
            box[2],
            box[3],
            box[4],
            box[5]
        ],
        [
            box[4],
            box[5],
            box[6],
            box[7]
        ],
        [
            box[6],
            box[7],
            box[0],
            box[1]
        ]
    ];
    return lines.some(function(boxLine) {
        return $0b1ebbb63a90f3ed$var$lineToLine(line, boxLine);
    });
}
var $0b1ebbb63a90f3ed$export$fb9595d3369262fc = {
    lineToLine: $0b1ebbb63a90f3ed$var$lineToLine,
    intersectBoxLine: $0b1ebbb63a90f3ed$var$intersectBoxLine,
    getBounds: (0, $20RI8.getBounds)
};
function $0b1ebbb63a90f3ed$export$1f4807a235930d45(a, b, margin) {
    var e_1, _a;
    var p = (0, $20RI8.getBounds)(a, margin).flat(1);
    var q = (0, $20RI8.getBounds)(b, margin).flat(1);
    var linesP = [
        [
            p[0],
            p[1],
            p[2],
            p[3]
        ],
        [
            p[0],
            p[1],
            p[4],
            p[5]
        ],
        [
            p[4],
            p[5],
            p[6],
            p[7]
        ],
        [
            p[2],
            p[3],
            p[6],
            p[7]
        ]
    ];
    try {
        for(var linesP_1 = (0, $7WQrb.__values)(linesP), linesP_1_1 = linesP_1.next(); !linesP_1_1.done; linesP_1_1 = linesP_1.next()){
            var line = linesP_1_1.value;
            if ($0b1ebbb63a90f3ed$var$intersectBoxLine(q, line)) return true;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (linesP_1_1 && !linesP_1_1.done && (_a = linesP_1.return)) _a.call(linesP_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return false;
}

});



parcelRegister("lOv6x", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe16652ae05bc811$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $aKixQ = parcelRequire("aKixQ");
var $3tYe7 = parcelRequire("3tYe7");
var $2gch2 = parcelRequire("2gch2");

var $4KYCs = parcelRequire("4KYCs");

var $lNGGT = parcelRequire("lNGGT");
var $fe16652ae05bc811$var$methods = {
    parity: function(items, _a) {
        var _b = _a.seq, seq = _b === void 0 ? 2 : _b;
        return items.filter(function(item, i) {
            return i % seq ? ((0, $2gch2.hide)(item), false) : true;
        });
    }
};
var $fe16652ae05bc811$var$filterDefined = function(arr) {
    return arr.filter((0, $aKixQ.defined));
};
function $fe16652ae05bc811$export$2e2bcd8739ae039(labels, overlapCfg, attr, utils) {
    var count = labels.length;
    var keepHeader = overlapCfg.keepHeader, keepTail = overlapCfg.keepTail;
    if (count <= 1 || count === 2 && keepHeader && keepTail) return;
    var parityHide = $fe16652ae05bc811$var$methods.parity;
    var reset = function(els) {
        return els.forEach(utils.show), els;
    };
    var seq = 2;
    var source = labels.slice();
    var target = labels.slice();
    var minLabelWidth = Math.min.apply(Math, (0, $7WQrb.__spreadArray)([
        1
    ], (0, $7WQrb.__read)(labels.map(function(d) {
        return d.getBBox().width;
    })), false));
    if (attr.type === 'linear' && ((0, $4KYCs.isAxisHorizontal)(attr) || (0, $4KYCs.isAxisVertical)(attr))) {
        var minX = (0, $3tYe7.getLocalBBox)(labels[0]).left;
        var maxX = (0, $3tYe7.getLocalBBox)(labels[count - 1]).right;
        var distance = Math.abs(maxX - minX) || 1;
        seq = Math.max(Math.floor(count * minLabelWidth / distance), seq);
    }
    var first;
    var last;
    if (keepHeader) first = source.splice(0, 1)[0];
    if (keepTail) {
        last = source.splice(-1, 1)[0];
        source.reverse();
    }
    reset(source);
    while(seq < labels.length && (0, $lNGGT.boundTest)($fe16652ae05bc811$var$filterDefined(last ? (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([
        last
    ], (0, $7WQrb.__read)(target), false), [
        first
    ], false) : (0, $7WQrb.__spreadArray)([
        first
    ], (0, $7WQrb.__read)(target), false)), attr, overlapCfg === null || overlapCfg === void 0 ? void 0 : overlapCfg.margin).length){
        // 每两步，减一个 (不需要考虑保留 first)
        if (last && !first && seq % 2 === 0) {
            var rest = source.splice(0, 1);
            rest.forEach(utils.hide);
        } else if (last && first) {
            // 如果有 first 的话，每一步，减一个（增加迭代次数）
            var rest = source.splice(0, 1);
            rest.forEach(utils.hide);
        }
        target = parityHide(reset(source), {
            seq: seq
        });
        seq++;
    }
}

});
parcelRegister("aKixQ", function(module, exports) {

$parcel$export(module.exports, "defined", () => $7d2c95dd5e7a4425$export$43f40ad3fa1d5c97);
var $7d2c95dd5e7a4425$export$43f40ad3fa1d5c97 = function(x) {
    return x !== undefined && x != null && !Number.isNaN(x);
};

});


parcelRegister("6aNA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $47ea233d7aae9a08$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $lNGGT = parcelRequire("lNGGT");
function $47ea233d7aae9a08$export$2e2bcd8739ae039(labels, overlapCfg, attr, utils) {
    var e_1, _a;
    var _b = overlapCfg.optionalAngles, optionalAngles = _b === void 0 ? [
        0,
        45,
        90
    ] : _b, margin = overlapCfg.margin, _c = overlapCfg.recoverWhenFailed, recoverWhenFailed = _c === void 0 ? true : _c;
    var defaultAngles = labels.map(function(label) {
        return label.getLocalEulerAngles();
    });
    var runAndPassed = function() {
        return (0, $lNGGT.boundTest)(labels, attr, margin).length < 1;
    };
    var setLabelsRotate = function(angle) {
        return labels.forEach(function(label, index) {
            var rotate = Array.isArray(angle) ? angle[index] : angle;
            utils.rotate(label, +rotate);
        });
    };
    try {
        for(var optionalAngles_1 = (0, $7WQrb.__values)(optionalAngles), optionalAngles_1_1 = optionalAngles_1.next(); !optionalAngles_1_1.done; optionalAngles_1_1 = optionalAngles_1.next()){
            var angle = optionalAngles_1_1.value;
            setLabelsRotate(angle);
            if (runAndPassed()) return;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (optionalAngles_1_1 && !optionalAngles_1_1.done && (_a = optionalAngles_1.return)) _a.call(optionalAngles_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    if (recoverWhenFailed) setLabelsRotate(defaultAngles);
}

});

parcelRegister("WWdoN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b129333ec2a959e$export$2e2bcd8739ae039);

var $7WQrb = parcelRequire("7WQrb");

var $pzxZu = parcelRequire("pzxZu");

var $4KYCs = parcelRequire("4KYCs");

var $lNGGT = parcelRequire("lNGGT");
function $0b129333ec2a959e$var$inferTextBaseline(attr) {
    var type = attr.type, labelDirection = attr.labelDirection;
    if (type === 'linear' && (0, $4KYCs.isAxisHorizontal)(attr)) return labelDirection === 'negative' ? 'bottom' : 'top';
    return 'middle';
}
function $0b129333ec2a959e$export$2e2bcd8739ae039(labels, overlapCfg, attr, utils, main) {
    var _a;
    var _b = overlapCfg.maxLines, maxLines = _b === void 0 ? 3 : _b, _c = overlapCfg.recoverWhenFailed, recoverWhenFailed = _c === void 0 ? true : _c, _d = overlapCfg.margin, margin = _d === void 0 ? [
        0,
        0,
        0,
        0
    ] : _d;
    var wordWrapWidth = (0, $pzxZu.getCallbackValue)((_a = overlapCfg.wordWrapWidth) !== null && _a !== void 0 ? _a : 50, [
        main
    ]);
    var defaultLines = labels.map(function(label) {
        return label.attr('maxLines') || 1;
    });
    var minLines = Math.min.apply(Math, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(defaultLines), false));
    var runAndPassed = function() {
        return (0, $lNGGT.boundTest)(labels, attr, margin).length < 1;
    };
    var textBaseline = $0b129333ec2a959e$var$inferTextBaseline(attr);
    var setLabelsWrap = function(lines) {
        return labels.forEach(function(label, index) {
            var maxLines = Array.isArray(lines) ? lines[index] : lines;
            utils.wrap(label, wordWrapWidth, maxLines, textBaseline);
        });
    };
    if (minLines > maxLines) return;
    if (attr.type === 'linear' && (0, $4KYCs.isAxisHorizontal)(attr)) {
        setLabelsWrap(maxLines);
        if (runAndPassed()) return;
    } else for(var lines = minLines; lines <= maxLines; lines++){
        setLabelsWrap(lines);
        if (runAndPassed()) return;
    }
    if (recoverWhenFailed) setLabelsWrap(defaultLines);
}

});


parcelRegister("4vyZO", function(module, exports) {

$parcel$export(module.exports, "getFactor", () => $348534251d3b5bc8$export$5fe69c201fe12def);


function $348534251d3b5bc8$export$5fe69c201fe12def() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var fn = function(str) {
        return str === 'positive' ? -1 : 1;
    };
    return args.reduce(function(acc, cur) {
        return acc * fn(cur);
    }, 1);
}

});


parcelRegister("9RJbj", function(module, exports) {

$parcel$export(module.exports, "renderTicks", () => $72ec1c68a507d8dd$export$3b831c6f8e8a0608);

var $7WQrb = parcelRequire("7WQrb");

var $ky7aH = parcelRequire("ky7aH");

var $ZP1jD = parcelRequire("ZP1jD");
var $bhYrQ = parcelRequire("bhYrQ");

var $pzxZu = parcelRequire("pzxZu");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $7h0mn = parcelRequire("7h0mn");

var $4KYCs = parcelRequire("4KYCs");

var $1GIDL = parcelRequire("1GIDL");

var $cAfhA = parcelRequire("cAfhA");

var $74vg6 = parcelRequire("74vg6");
function $72ec1c68a507d8dd$export$f1b1eebdc32250ee(value, attr) {
    return (0, $1GIDL.getDirectionVector)(value, attr.tickDirection, attr);
}
function $72ec1c68a507d8dd$export$5cb343d7acff7430(unitVector, tickLength) {
    var _a = (0, $7WQrb.__read)(unitVector, 2), dx = _a[0], dy = _a[1];
    return [
        [
            0,
            0
        ],
        [
            dx * tickLength,
            dy * tickLength
        ]
    ];
}
function $72ec1c68a507d8dd$var$getTickLineLayout(datum, index, data, tickVector, attr) {
    var tickLength = attr.tickLength;
    var _a = (0, $7WQrb.__read)($72ec1c68a507d8dd$export$5cb343d7acff7430(tickVector, (0, $pzxZu.getCallbackValue)(tickLength, [
        datum,
        index,
        data
    ])), 2), _b = (0, $7WQrb.__read)(_a[0], 2), x1 = _b[0], y1 = _b[1], _c = (0, $7WQrb.__read)(_a[1], 2), x2 = _c[0], y2 = _c[1];
    return {
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2
    };
}
function $72ec1c68a507d8dd$var$createTickEl(container, datum, index, data, attr) {
    var formatter = attr.tickFormatter, classNamePrefix = attr.classNamePrefix;
    var tickVector = $72ec1c68a507d8dd$export$f1b1eebdc32250ee(datum.value, attr);
    var el = 'line';
    if ((0, $ky7aH.default)(formatter)) el = function() {
        return (0, $pzxZu.getCallbackValue)(formatter, [
            datum,
            index,
            data,
            tickVector
        ]);
    };
    var tick = container.append(el).attr('className', (0, $7h0mn.CLASS_NAMES).tickItem.name);
    (0, $cAfhA.applyClassName)(tick, (0, $7h0mn.CLASS_NAMES).tickItem, (0, $74vg6.CLASSNAME_SUFFIX_MAP).tickItem, classNamePrefix);
    return tick;
}
function $72ec1c68a507d8dd$var$applyTickStyle(datum, index, data, tick, group, attr, style) {
    var tickVector = $72ec1c68a507d8dd$export$f1b1eebdc32250ee(datum.value, attr);
    var _a = $72ec1c68a507d8dd$var$getTickLineLayout(datum, index, data, tickVector, attr), x1 = _a.x1, x2 = _a.x2, y1 = _a.y1, y2 = _a.y2;
    var _b = (0, $7WQrb.__read)((0, $8UxPj.splitStyle)((0, $1GIDL.getCallbackStyle)(style, [
        datum,
        index,
        data,
        tickVector
    ])), 2), tickStyle = _b[0], groupStyle = _b[1];
    tick.node().nodeName === 'line' && tick.styles((0, $7WQrb.__assign)({
        x1: x1,
        x2: x2,
        y1: y1,
        y2: y2
    }, tickStyle));
    group.attr(groupStyle);
    tick.styles(tickStyle);
}
function $72ec1c68a507d8dd$var$createTick(datum, index, data, attr, tickAttr, animate) {
    var tick = $72ec1c68a507d8dd$var$createTickEl((0, $bCy7Q.select)(this), datum, index, data, attr);
    $72ec1c68a507d8dd$var$applyTickStyle(datum, index, data, tick, this, attr, tickAttr);
    var _a = (0, $7WQrb.__read)((0, $4KYCs.getValuePos)(datum.value, attr), 2), x = _a[0], y = _a[1];
    return (0, $bhYrQ.transition)(this, {
        transform: "translate(".concat(x, ", ").concat(y, ")")
    }, animate);
}
function $72ec1c68a507d8dd$export$3b831c6f8e8a0608(container, axisData, attr, animate) {
    var classNamePrefix = attr.classNamePrefix;
    var finalData = (0, $1GIDL.filterExec)(axisData, attr.tickFilter);
    var tickAttr = (0, $8UxPj.subStyleProps)(attr, 'tick');
    return container.selectAll((0, $7h0mn.CLASS_NAMES).tick.class).data(finalData, function(d) {
        return d.id || d.label;
    }).join(function(enter) {
        var ticks = enter.append('g').attr('className', (0, $7h0mn.CLASS_NAMES).tick.name).transition(function(datum, index) {
            return $72ec1c68a507d8dd$var$createTick.call(this, datum, index, finalData, attr, tickAttr, false);
        });
        (0, $cAfhA.applyClassName)(ticks, (0, $7h0mn.CLASS_NAMES).tick, (0, $74vg6.CLASSNAME_SUFFIX_MAP).tick, classNamePrefix);
        return ticks;
    }, function(update) {
        return update.transition(function(datum, index) {
            this.removeChildren();
            return $72ec1c68a507d8dd$var$createTick.call(this, datum, index, finalData, attr, tickAttr, animate.update);
        });
    }, function(exit) {
        return exit.transition(function() {
            var _this = this;
            var animation = (0, $ZP1jD.default)(this.childNodes[0], animate.exit);
            (0, $bhYrQ.onAnimateFinished)(animation, function() {
                return _this.remove();
            });
            return animation;
        });
    }).transitions();
}

});

parcelRegister("c67j2", function(module, exports) {

$parcel$export(module.exports, "renderTitle", () => $8cebb66800a7019d$export$553f274869ee0a8f);

var $7WQrb = parcelRequire("7WQrb");

var $bhYrQ = parcelRequire("bhYrQ");

var $8jlEv = parcelRequire("8jlEv");
var $11HCp = parcelRequire("11HCp");
var $le54I = parcelRequire("le54I");
var $3wJtB = parcelRequire("3wJtB");
var $i1HPZ = parcelRequire("i1HPZ");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $7h0mn = parcelRequire("7h0mn");

var $cAfhA = parcelRequire("cAfhA");

var $74vg6 = parcelRequire("74vg6");
function $8cebb66800a7019d$var$getTitlePosition(mainGroup, titleGroup, attr) {
    var _a = attr.titlePosition, position = _a === void 0 ? 'lb' : _a, spacing = attr.titleSpacing;
    var pos = (0, $11HCp.parsePosition)(position);
    var _b = mainGroup.node().getLocalBounds(), _c = (0, $7WQrb.__read)(_b.min, 2), mainX = _c[0], mainY = _c[1], _d = (0, $7WQrb.__read)(_b.halfExtents, 2), mainHalfWidth = _d[0], mainHalfHeight = _d[1];
    var _e = (0, $7WQrb.__read)(titleGroup.node().getLocalBounds().halfExtents, 2), titleHalfWidth = _e[0], titleHalfHeight = _e[1];
    var _f = (0, $7WQrb.__read)([
        mainX + mainHalfWidth,
        mainY + mainHalfHeight
    ], 2), x = _f[0], y = _f[1];
    var _g = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(spacing), 4), spacingTop = _g[0], spacingRight = _g[1], spacingBottom = _g[2], spacingLeft = _g[3];
    if ([
        'start',
        'end'
    ].includes(position) && attr.type === 'linear') {
        var startPos = attr.startPos, endPos = attr.endPos;
        // todo did not consider the truncate case
        var _h = (0, $7WQrb.__read)(position === 'start' ? [
            startPos,
            endPos
        ] : [
            endPos,
            startPos
        ], 2), from = _h[0], to = _h[1];
        var direction = (0, $8jlEv.normalize)([
            -to[0] + from[0],
            -to[1] + from[1]
        ]);
        var _j = (0, $7WQrb.__read)((0, $8jlEv.scale)(direction, spacingTop), 2), dx = _j[0], dy = _j[1];
        return {
            x: from[0] + dx,
            y: from[1] + dy
        };
    }
    if (pos.includes('t')) y -= mainHalfHeight + titleHalfHeight + spacingTop;
    if (pos.includes('r')) x += mainHalfWidth + titleHalfWidth + spacingRight;
    if (pos.includes('l')) x -= mainHalfWidth + titleHalfWidth + spacingLeft;
    if (pos.includes('b')) y += mainHalfHeight + titleHalfHeight + spacingBottom;
    return {
        x: x,
        y: y
    };
}
function $8cebb66800a7019d$var$inferTransform(n, direction, position) {
    var halfExtents = n.getGeometryBounds().halfExtents;
    var height = halfExtents[1] * 2;
    if (direction === 'vertical') {
        if (position === 'left') return "rotate(-90) translate(0, ".concat(height / 2, ")");
        if (position === 'right') return "rotate(-90) translate(0, -".concat(height / 2, ")");
    }
    return '';
}
function $8cebb66800a7019d$var$applyTitleStyle(title, group, axis, attr, animate) {
    var style = (0, $8UxPj.subStyleProps)(attr, 'title');
    var _a = (0, $7WQrb.__read)((0, $8UxPj.splitStyle)(style), 2), titleStyle = _a[0], _b = _a[1], specified = _b.transform, transformOrigin = _b.transformOrigin, groupStyle = (0, $7WQrb.__rest)(_b, [
        "transform",
        "transformOrigin"
    ]);
    group.styles(groupStyle);
    var transform = specified || $8cebb66800a7019d$var$inferTransform(title.node(), titleStyle.direction, titleStyle.position);
    title.styles((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, titleStyle), {
        transformOrigin: transformOrigin
    }));
    (0, $3wJtB.percentTransform)(title.node(), transform);
    var _c = $8cebb66800a7019d$var$getTitlePosition(// @ts-ignore
    (0, $bCy7Q.select)(axis._offscreen || axis.querySelector((0, $7h0mn.CLASS_NAMES).mainGroup.class)), group, attr), x = _c.x, y = _c.y;
    var animation = (0, $bhYrQ.transition)(group.node(), {
        transform: "translate(".concat(x, ", ").concat(y, ")")
    }, animate);
    return animation;
}
function $8cebb66800a7019d$export$553f274869ee0a8f(container, axis, attr, animate) {
    var titleText = attr.titleText, classNamePrefix = attr.classNamePrefix;
    return container.selectAll((0, $7h0mn.CLASS_NAMES).title.class).data([
        {
            title: titleText
        }
    ].filter(function(d) {
        return !!d.title;
    }), function(d, i) {
        return d.title;
    }).join(function(enter) {
        var titles = enter.append(function() {
            return (0, $i1HPZ.renderExtDo)(titleText);
        }).attr('className', (0, $7h0mn.CLASS_NAMES).title.name).transition(function() {
            return $8cebb66800a7019d$var$applyTitleStyle((0, $bCy7Q.select)(this), container, axis, attr, animate.enter);
        });
        (0, $cAfhA.applyClassName)(titles, (0, $7h0mn.CLASS_NAMES).title, (0, $74vg6.CLASSNAME_SUFFIX_MAP).title, classNamePrefix);
        return titles;
    }, function(update) {
        return update.transition(function() {
            return $8cebb66800a7019d$var$applyTitleStyle((0, $bCy7Q.select)(this), container, axis, attr, animate.update);
        });
    }, function(exit) {
        return exit.remove();
    }).transitions();
}

});


parcelRegister("3rtR3", function(module, exports) {

$parcel$export(module.exports, "Slider", () => $281b0d37a08aa46d$export$472062a354075cee);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $8hhuV = parcelRequire("8hhuV");

var $bhYrQ = parcelRequire("bhYrQ");

var $e7n3C = parcelRequire("e7n3C");

var $eNeqF = parcelRequire("eNeqF");

var $8wrwN = parcelRequire("8wrwN");
var $aJozt = parcelRequire("aJozt");
var $le54I = parcelRequire("le54I");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");
var $4pazZ = parcelRequire("4pazZ");

var $4FtGs = parcelRequire("4FtGs");

var $3INFv = parcelRequire("3INFv");

var $lkPq8 = parcelRequire("lkPq8");
var $281b0d37a08aa46d$export$472062a354075cee = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Slider, _super);
    function Slider(options) {
        var _this = _super.call(this, options, (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({
            x: 0,
            y: 0,
            animate: {
                duration: 100,
                fill: 'both'
            },
            brushable: true,
            formatter: function(val) {
                return val.toString();
            },
            handleSpacing: 2,
            orientation: 'horizontal',
            padding: 0,
            autoFitLabel: true,
            scrollable: true,
            selectionFill: '#5B8FF9',
            selectionFillOpacity: 0.45,
            selectionZIndex: 2,
            showHandle: true,
            showLabel: true,
            slidable: true,
            trackFill: '#416180',
            trackLength: 200,
            trackOpacity: 0.05,
            trackSize: 20,
            trackZIndex: -1,
            values: [
                0,
                1
            ],
            type: 'range',
            selectionType: 'select',
            handleIconOffset: 0
        }, (0, $8UxPj.superStyleProps)((0, $3INFv.HANDLE_DEFAULT_CFG), 'handle')), (0, $8UxPj.superStyleProps)((0, $3INFv.HANDLE_ICON_DEFAULT_CFG), 'handleIcon')), (0, $8UxPj.superStyleProps)((0, $3INFv.HANDLE_LABEL_DEFAULT_CFG), 'handleLabel'))) || this;
        _this.range = [
            0,
            1
        ];
        _this.onDragStart = function(target) {
            return function(e) {
                e.stopPropagation();
                _this.target = target;
                _this.prevPos = _this.getOrientVal((0, $8wrwN.getEventViewportPos)(e));
                var _a = _this.availableSpace, x = _a.x, y = _a.y;
                var _b = _this.getBBox(), X = _b.x, Y = _b.y;
                _this.selectionStartPos = _this.getRatio(_this.prevPos - _this.getOrientVal([
                    x,
                    y
                ]) - _this.getOrientVal([
                    +X,
                    +Y
                ]));
                _this.selectionWidth = 0;
                document.addEventListener('pointermove', _this.onDragging);
                document.addEventListener('pointerup', _this.onDragEnd);
            };
        };
        _this.onDragging = function(e) {
            var _a = _this.attributes, slidable = _a.slidable, brushable = _a.brushable, type = _a.type;
            e.stopPropagation();
            var currPos = _this.getOrientVal((0, $8wrwN.getEventViewportPos)(e));
            var diffPos = currPos - _this.prevPos;
            if (!diffPos) return;
            var deltaVal = _this.getRatio(diffPos);
            switch(_this.target){
                case 'start':
                    if (slidable) _this.setValuesOffset(deltaVal);
                    break;
                case 'end':
                    if (slidable) _this.setValuesOffset(0, deltaVal);
                    break;
                case 'selection':
                    if (slidable) _this.setValuesOffset(deltaVal, deltaVal);
                    break;
                case 'track':
                    if (!brushable) return;
                    // 绘制蒙板
                    _this.selectionWidth += deltaVal;
                    if (type === 'range') _this.innerSetValues([
                        _this.selectionStartPos,
                        _this.selectionStartPos + _this.selectionWidth
                    ].sort(), true);
                    else _this.innerSetValues([
                        0,
                        _this.selectionStartPos + _this.selectionWidth
                    ], true);
                    break;
                default:
                    break;
            }
            _this.prevPos = currPos;
        };
        _this.onDragEnd = function() {
            document.removeEventListener('pointermove', _this.onDragging);
            document.removeEventListener('pointermove', _this.onDragging);
            document.removeEventListener('pointerup', _this.onDragEnd);
            _this.target = '';
            // 更新 handle 状态
            _this.updateHandlesPosition(false);
        };
        _this.onValueChange = function(oldValue) {
            var _a = _this.attributes, onChange = _a.onChange, type = _a.type;
            var internalOldValue = type === 'range' ? oldValue : oldValue[1];
            var value = type === 'range' ? _this.getValues() : _this.getValues()[1];
            var evt = new (0, $2eDEB.CustomEvent)('valuechange', {
                detail: {
                    oldValue: internalOldValue,
                    value: value
                }
            });
            _this.dispatchEvent(evt);
            onChange === null || onChange === void 0 || onChange(value);
        };
        _this.selectionStartPos = 0;
        _this.selectionWidth = 0;
        _this.prevPos = 0;
        _this.target = '';
        return _this;
    }
    Object.defineProperty(Slider.prototype, "values", {
        get: function() {
            return this.attributes.values;
        },
        set: function(values) {
            this.attributes.values = this.clampValues(values);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "sparklineStyle", {
        get: function() {
            var orientation = this.attributes.orientation;
            if (orientation !== 'horizontal') return null;
            var attr = (0, $8UxPj.subStyleProps)(this.attributes, 'sparkline');
            return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
                zIndex: 0
            }, this.availableSpace), attr);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "shape", {
        get: function() {
            var _a = this.attributes, trackLength = _a.trackLength, trackSize = _a.trackSize;
            var _b = (0, $7WQrb.__read)(this.getOrientVal([
                [
                    trackLength,
                    trackSize
                ],
                [
                    trackSize,
                    trackLength
                ]
            ]), 2), width = _b[0], height = _b[1];
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Slider.prototype, "availableSpace", {
        get: function() {
            var _a = this.attributes, x = _a.x, y = _a.y, padding = _a.padding;
            var _b = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(padding), 4), top = _b[0], right = _b[1], bottom = _b[2], left = _b[3];
            var _c = this.shape, width = _c.width, height = _c.height;
            return {
                x: left,
                y: top,
                width: width - (left + right),
                height: height - (top + bottom)
            };
        },
        enumerable: false,
        configurable: true
    });
    Slider.prototype.getValues = function() {
        return this.values;
    };
    /** 不触发重绘 */ Slider.prototype.setValues = function(values, animate) {
        if (values === void 0) values = [
            0,
            0
        ];
        if (animate === void 0) animate = false;
        this.attributes.values = values;
        var animation = animate === false ? false : this.attributes.animate;
        this.updateSelectionArea(animation);
        this.updateHandlesPosition(animation);
    };
    Slider.prototype.updateSelectionArea = function(animation) {
        var newSelectionArea = this.calcSelectionArea();
        this.foregroundGroup.selectAll((0, $3INFv.CLASS_NAMES).selection.class).each(function(datum, index) {
            (0, $bhYrQ.transition)(this, newSelectionArea[index], animation);
        });
    };
    Slider.prototype.updateHandlesPosition = function(animation) {
        if (!this.attributes.showHandle) return;
        this.startHandle && (0, $bhYrQ.transition)(this.startHandle, this.getHandleStyle('start'), animation);
        this.endHandle && (0, $bhYrQ.transition)(this.endHandle, this.getHandleStyle('end'), animation);
    };
    Slider.prototype.innerSetValues = function(values, trigger) {
        if (values === void 0) values = [
            0,
            0
        ];
        if (trigger === void 0) trigger = false;
        var oldValues = this.values;
        var newValues = this.clampValues(values);
        this.attributes.values = newValues;
        this.setValues(newValues);
        if (trigger) this.onValueChange(oldValues);
    };
    Slider.prototype.renderTrack = function(container) {
        var _a = this.attributes, x = _a.x, y = _a.y;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'track');
        this.trackShape = (0, $bCy7Q.select)(container).maybeAppendByClassName((0, $3INFv.CLASS_NAMES).track, 'rect').styles((0, $7WQrb.__assign)((0, $7WQrb.__assign)({
            x: x,
            y: y
        }, this.shape), style));
    };
    Slider.prototype.renderBrushArea = function(container) {
        var _a = this.attributes, x = _a.x, y = _a.y, brushable = _a.brushable;
        this.brushArea = (0, $bCy7Q.select)(container).maybeAppendByClassName((0, $3INFv.CLASS_NAMES).brushArea, 'rect').styles((0, $7WQrb.__assign)({
            x: x,
            y: y,
            fill: 'transparent',
            cursor: brushable ? 'crosshair' : 'default'
        }, this.shape));
    };
    Slider.prototype.renderSparkline = function(container) {
        var _this = this;
        var _a = this.attributes, x = _a.x, y = _a.y, orientation = _a.orientation;
        var sparklineGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName((0, $3INFv.CLASS_NAMES).sparklineGroup, 'g');
        (0, $aJozt.ifShow)(orientation === 'horizontal', sparklineGroup, function(group) {
            var style = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, _this.sparklineStyle), {
                x: x,
                y: y
            });
            group.maybeAppendByClassName((0, $3INFv.CLASS_NAMES).sparkline, function() {
                return new (0, $4FtGs.Sparkline)({
                    style: style
                });
            }).update(style);
        });
    };
    Slider.prototype.renderHandles = function() {
        var _this = this;
        var _a;
        var _b = this.attributes, showHandle = _b.showHandle, type = _b.type;
        var availableHandle = type === 'range' ? [
            'start',
            'end'
        ] : [
            'end'
        ];
        var data = showHandle ? availableHandle : [];
        var that = this;
        (_a = this.foregroundGroup) === null || _a === void 0 || _a.selectAll((0, $3INFv.CLASS_NAMES).handle.class).data(data.map(function(type) {
            return {
                type: type
            };
        }), function(d) {
            return d.type;
        }).join(function(enter) {
            return enter.append(function(_a) {
                var type = _a.type;
                return new (0, $lkPq8.Handle)({
                    style: _this.getHandleStyle(type)
                });
            }).each(function(_a) {
                var type = _a.type;
                this.attr('class', "".concat((0, $3INFv.CLASS_NAMES).handle.name, " ").concat(type, "-handle"));
                var name = "".concat(type, "Handle");
                that[name] = this;
                this.addEventListener('pointerdown', that.onDragStart(type));
            });
        }, function(update) {
            return update.each(function(_a) {
                var type = _a.type;
                this.update(that.getHandleStyle(type));
            });
        }, function(exit) {
            return exit.each(function(_a) {
                var type = _a.type;
                var name = "".concat(type, "Handle");
                that[name] = undefined;
            }).remove();
        });
    };
    Slider.prototype.renderSelection = function(container) {
        var _a = this.attributes, x = _a.x, y = _a.y, type = _a.type, selectionType = _a.selectionType;
        this.foregroundGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName((0, $3INFv.CLASS_NAMES).foreground, 'g');
        // value 类型的 slider 不渲染选区
        var selectionStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'selection');
        var applyStyle = function(selection) {
            return selection.style('visibility', function(d) {
                return d.show ? 'visible' : 'hidden';
            }).style('cursor', function(d) {
                if (selectionType === 'select') return 'grab';
                if (selectionType === 'invert') return 'crosshair';
                return 'default';
            }).styles((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, selectionStyle), {
                transform: "translate(".concat(x, ", ").concat(y, ")")
            }));
        };
        var that = this;
        this.foregroundGroup.selectAll((0, $3INFv.CLASS_NAMES).selection.class).data(type === 'value' ? [] : this.calcSelectionArea().map(function(area, index) {
            return {
                style: (0, $7WQrb.__assign)({}, area),
                index: index,
                // 是否可见
                show: selectionType === 'select' ? index === 1 : index !== 1
            };
        }), function(d) {
            return d.index;
        }).join(function(enter) {
            return enter.append('rect').attr('className', (0, $3INFv.CLASS_NAMES).selection.name).call(applyStyle).each(function(datum, index) {
                var _this = this;
                if (index === 1) {
                    that.selectionShape = (0, $bCy7Q.select)(this);
                    // 选区drag事件
                    this.on('pointerdown', function(e) {
                        _this.attr('cursor', 'grabbing');
                        that.onDragStart('selection')(e);
                    });
                    // 选区hover事件
                    that.dispatchCustomEvent(this, 'pointerenter', 'selectionMouseenter');
                    that.dispatchCustomEvent(this, 'pointerleave', 'selectionMouseleave');
                    that.dispatchCustomEvent(this, 'click', 'selectionClick');
                    // 拖拽交互
                    this.addEventListener('pointerdown', function() {
                        _this.attr('cursor', 'grabbing');
                    });
                    this.addEventListener('pointerup', function() {
                        _this.attr('cursor', 'pointer');
                    });
                    this.addEventListener('pointerover', function() {
                        _this.attr('cursor', 'pointer');
                    });
                } else this.on('pointerdown', that.onDragStart('track'));
            });
        }, function(update) {
            return update.call(applyStyle);
        }, function(exit) {
            return exit.remove();
        });
        this.updateSelectionArea(false);
        this.renderHandles();
    };
    Slider.prototype.render = function(attributes, container) {
        this.renderTrack(container);
        this.renderSparkline(container);
        this.renderBrushArea(container);
        this.renderSelection(container);
    };
    Slider.prototype.clampValues = function(values, precision) {
        var _a;
        if (precision === void 0) precision = 4;
        var _b = (0, $7WQrb.__read)(this.range, 2), min = _b[0], max = _b[1];
        var _c = (0, $7WQrb.__read)(this.getValues().map(function(num) {
            return (0, $4pazZ.toPrecision)(num, precision);
        }), 2), prevStart = _c[0], prevEnd = _c[1];
        var internalValues = Array.isArray(values) ? values : [
            prevStart,
            values !== null && values !== void 0 ? values : prevEnd
        ];
        var _d = (0, $7WQrb.__read)((internalValues || [
            prevStart,
            prevEnd
        ]).map(function(num) {
            return (0, $4pazZ.toPrecision)(num, precision);
        }), 2), startVal = _d[0], endVal = _d[1];
        if (this.attributes.type === 'value') return [
            0,
            (0, $8hhuV.default)(endVal, min, max)
        ];
        // 交换startVal endVal
        if (startVal > endVal) _a = (0, $7WQrb.__read)([
            endVal,
            startVal
        ], 2), startVal = _a[0], endVal = _a[1];
        var range = endVal - startVal;
        // 超出范围就全选
        if (range > max - min) return [
            min,
            max
        ];
        if (startVal < min) {
            if (prevStart === min && prevEnd === endVal) return [
                min,
                endVal
            ];
            return [
                min,
                range + min
            ];
        }
        if (endVal > max) {
            if (prevEnd === max && prevStart === startVal) return [
                startVal,
                max
            ];
            return [
                max - range,
                max
            ];
        }
        // 保留小数
        return [
            startVal,
            endVal
        ];
    };
    /**
     * 计算选区坐标和宽高
     * 默认用来计算前景位置大小
     */ Slider.prototype.calcSelectionArea = function(values) {
        var _a = (0, $7WQrb.__read)(this.clampValues(values), 2), start = _a[0], end = _a[1];
        var _b = this.availableSpace, x = _b.x, y = _b.y, width = _b.width, height = _b.height;
        // 中间为选区，两端为反选区
        return this.getOrientVal([
            [
                {
                    y: y,
                    height: height,
                    x: x,
                    width: start * width
                },
                {
                    y: y,
                    height: height,
                    x: start * width + x,
                    width: (end - start) * width
                },
                {
                    y: y,
                    height: height,
                    x: end * width,
                    width: (1 - end) * width
                }
            ],
            [
                {
                    x: x,
                    width: width,
                    y: y,
                    height: start * height
                },
                {
                    x: x,
                    width: width,
                    y: start * height + y,
                    height: (end - start) * height
                },
                {
                    x: x,
                    width: width,
                    y: end * height,
                    height: (1 - end) * height
                }
            ]
        ]);
    };
    /**
     * 计算手柄的x y
     */ Slider.prototype.calcHandlePosition = function(handleType) {
        var handleIconOffset = this.attributes.handleIconOffset;
        var _a = this.availableSpace, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var _b = (0, $7WQrb.__read)(this.clampValues(), 2), stVal = _b[0], endVal = _b[1];
        var offset = handleType === 'start' ? -handleIconOffset : handleIconOffset;
        var L = (handleType === 'start' ? stVal : endVal) * this.getOrientVal([
            width,
            height
        ]) + offset;
        return {
            x: x + this.getOrientVal([
                L,
                width / 2
            ]),
            y: y + this.getOrientVal([
                height / 2,
                L
            ])
        };
    };
    Slider.prototype.inferTextStyle = function(handleType) {
        var orientation = this.attributes.orientation;
        if (orientation === 'horizontal') return {};
        if (handleType === 'start') return {
            transformOrigin: 'left center',
            transform: 'rotate(90)',
            textAlign: 'start'
        };
        if (handleType === 'end') return {
            transformOrigin: 'right center',
            transform: 'rotate(90)',
            textAlign: 'end'
        };
        return {};
    };
    /**
     * 计算手柄应当处于的位置
     * @param handleType start手柄还是end手柄
     * @returns
     */ Slider.prototype.calcHandleText = function(handleType) {
        var _a;
        var _b = this.attributes, type = _b.type, orientation = _b.orientation, formatter = _b.formatter, autoFitLabel = _b.autoFitLabel;
        var handleStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'handle');
        var labelStyle = (0, $8UxPj.subStyleProps)(handleStyle, 'label');
        var spacing = handleStyle.spacing;
        var size = this.getHandleSize();
        var values = this.clampValues();
        var value = handleType === 'start' ? values[0] : values[1];
        var text = formatter(value);
        var temp = new (0, $eNeqF.Text)({
            style: (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, labelStyle), this.inferTextStyle(handleType)), {
                text: text
            })
        });
        // 文字包围盒的宽高
        var _c = temp.getBBox(), textWidth = _c.width, textHeight = _c.height;
        temp.destroy();
        if (!autoFitLabel) {
            if (type === 'value') return {
                text: text,
                x: 0,
                y: -textHeight - spacing
            };
            var finaleWidth = spacing + size + (orientation === 'horizontal' ? textWidth / 2 : 0);
            return _a = {
                text: text
            }, _a[orientation === 'horizontal' ? 'x' : 'y'] = handleType === 'start' ? -finaleWidth : finaleWidth, _a;
        }
        var x = 0;
        var y = 0;
        // 相对于获取两端可用空间
        var _d = this.availableSpace, iW = _d.width, iH = _d.height;
        var _e = this.calcSelectionArea()[1], fX = _e.x, fY = _e.y, fW = _e.width, fH = _e.height;
        var totalSpacing = spacing + size;
        if (orientation === 'horizontal') {
            var finalWidth = totalSpacing + textWidth / 2;
            if (handleType === 'start') {
                var left = fX - totalSpacing - textWidth;
                x = left > 0 ? -finalWidth : finalWidth;
            } else {
                var sign = iW - fX - fW - totalSpacing > textWidth;
                x = sign ? finalWidth : -finalWidth;
            }
        } else {
            var positiveSize = totalSpacing;
            var negativeSize = textHeight + totalSpacing;
            if (handleType === 'start') y = fY - size > textHeight ? -negativeSize : positiveSize;
            else y = iH - (fY + fH) - size > textHeight ? negativeSize : -positiveSize;
        }
        return {
            x: x,
            y: y,
            text: text
        };
    };
    Slider.prototype.getHandleLabelStyle = function(handleType) {
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'handleLabel');
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, style), this.calcHandleText(handleType)), this.inferTextStyle(handleType));
    };
    Slider.prototype.getHandleIconStyle = function() {
        var shape = this.attributes.handleIconShape;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'handleIcon');
        var cursor = this.getOrientVal([
            'ew-resize',
            'ns-resize'
        ]);
        var size = this.getHandleSize();
        return (0, $7WQrb.__assign)({
            cursor: cursor,
            shape: shape,
            size: size
        }, style);
    };
    Slider.prototype.getHandleStyle = function(handleType) {
        var _a = this.attributes, ox = _a.x, oy = _a.y, showLabel = _a.showLabel, showLabelOnInteraction = _a.showLabelOnInteraction, orientation = _a.orientation;
        var _b = this.calcHandlePosition(handleType), x = _b.x, y = _b.y;
        var textStyle = this.calcHandleText(handleType);
        var internalShowLabel = showLabel;
        if (!showLabel && showLabelOnInteraction) {
            if (this.target) internalShowLabel = true;
            else internalShowLabel = false;
        }
        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $8UxPj.superStyleProps)(this.getHandleIconStyle(), 'icon')), (0, $8UxPj.superStyleProps)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, this.getHandleLabelStyle(handleType)), textStyle), 'label')), {
            transform: "translate(".concat(x + ox, ", ").concat(y + oy, ")"),
            orientation: orientation,
            showLabel: internalShowLabel,
            type: handleType,
            zIndex: 3
        });
    };
    Slider.prototype.getHandleSize = function() {
        var _a = this.attributes, size = _a.handleIconSize, width = _a.width, height = _a.height;
        if (size) return size;
        // 没设置 size 的话，高度就取 height + 4 高度，手柄宽度是高度的 1/ 2.4
        return Math.floor((this.getOrientVal([
            +height,
            +width
        ]) + 4) / 2.4);
    };
    Slider.prototype.getOrientVal = function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), x = _b[0], y = _b[1];
        var orientation = this.attributes.orientation;
        return orientation === 'horizontal' ? x : y;
    };
    Slider.prototype.setValuesOffset = function(stOffset, endOffset) {
        if (endOffset === void 0) endOffset = 0;
        var type = this.attributes.type;
        var _a = (0, $7WQrb.__read)(this.getValues(), 2), oldStartVal = _a[0], oldEndVal = _a[1];
        var internalStartOffset = type === 'range' ? stOffset : 0;
        var values = [
            oldStartVal + internalStartOffset,
            oldEndVal + endOffset
        ].sort();
        this.innerSetValues(values, true);
    };
    Slider.prototype.getRatio = function(val) {
        var _a = this.availableSpace, width = _a.width, height = _a.height;
        return val / this.getOrientVal([
            width,
            height
        ]);
    };
    Slider.prototype.dispatchCustomEvent = function(target, event, name) {
        var _this = this;
        target.on(event, function(e) {
            e.stopPropagation();
            _this.dispatchEvent(new (0, $2eDEB.CustomEvent)(name, {
                detail: e
            }));
        });
    };
    Slider.prototype.bindEvents = function() {
        // scroll 事件
        this.addEventListener('wheel', this.onScroll);
        var brushArea = this.brushArea;
        this.dispatchCustomEvent(brushArea, 'click', 'trackClick');
        this.dispatchCustomEvent(brushArea, 'pointerenter', 'trackMouseenter');
        this.dispatchCustomEvent(brushArea, 'pointerleave', 'trackMouseleave');
        // Drag and brush
        brushArea.on('pointerdown', this.onDragStart('track'));
    };
    Slider.prototype.onScroll = function(event) {
        var scrollable = this.attributes.scrollable;
        if (scrollable) {
            var deltaX = event.deltaX, deltaY = event.deltaY;
            var offset = deltaY || deltaX;
            var deltaVal = this.getRatio(offset);
            this.setValuesOffset(deltaVal, deltaVal);
        }
    };
    Slider.tag = 'slider';
    return Slider;
}((0, $e7n3C.Component));

});
parcelRegister("8wrwN", function(module, exports) {

$parcel$export(module.exports, "getEventViewportPos", () => $6346aa6024e8a06e$export$28bb1989979f36d7);
/**
 * 获得触发事件的坐标
 */ function $6346aa6024e8a06e$export$75e45a73035aac3f(e) {
    var canvas = e.canvas, touches = e.touches, offsetX = e.offsetX, offsetY = e.offsetY;
    if (canvas) {
        var x = canvas.x, y = canvas.y;
        return [
            x,
            y
        ];
    }
    if (touches) {
        var _a = touches[0], clientX = _a.clientX, clientY = _a.clientY;
        return [
            clientX,
            clientY
        ];
    }
    if (offsetX && offsetY) return [
        offsetX,
        offsetY
    ];
    return [
        0,
        0
    ];
}
function $6346aa6024e8a06e$export$28bb1989979f36d7(e) {
    var nativeEvent = e.nativeEvent, touches = e.touches, clientX = e.clientX, clientY = e.clientY;
    if (nativeEvent) return [
        nativeEvent.clientX,
        nativeEvent.clientY
    ];
    if (touches) {
        var _a = touches[0], clientX_1 = _a.clientX, clientY_1 = _a.clientY;
        return [
            clientX_1,
            clientY_1
        ];
    }
    if (typeof clientX === 'number' && typeof clientY === 'number') return [
        clientX,
        clientY
    ];
    return [
        0,
        0
    ];
}

});

parcelRegister("4pazZ", function(module, exports) {

$parcel$export(module.exports, "toPrecision", () => $3351b41d0817bce3$export$3e91a10e66078270);
/**
 * 保留x位小数
 */ function $3351b41d0817bce3$export$3e91a10e66078270(num, precision) {
    return +num.toPrecision(precision);
}
function $3351b41d0817bce3$export$c35af5bb02c0f293(num) {
    return num.toLocaleString();
}
function $3351b41d0817bce3$export$807af96fd23a50a5(num) {
    return num.toExponential();
}
function $3351b41d0817bce3$export$62df1a9e46f13759(num, precision) {
    if (precision === void 0) precision = 0;
    if (Math.abs(num) < 1000) return String(num);
    return "".concat($3351b41d0817bce3$export$3e91a10e66078270(num / 1000, precision).toLocaleString(), "K");
}
var $3351b41d0817bce3$export$705f249f7d8d4fc0 = function(x, a, b) {
    return x < 0 && Number.isFinite(x) ? a : b;
};
var $3351b41d0817bce3$export$82604a4a3e9213b9 = function(x, a, b) {
    return x > 0 && Number.isFinite(x) ? a : b;
};
var $3351b41d0817bce3$export$13e2537ceeaf8a3a = function(a, b) {
    return a * b;
};
var $3351b41d0817bce3$export$a61423b330c3444c = function(a, b) {
    return a / 2 + (b || 0) / 2;
};

});

parcelRegister("4FtGs", function(module, exports) {

$parcel$export(module.exports, "Sparkline", () => $36620459e8e83955$export$725eacad24cfb311);

var $7WQrb = parcelRequire("7WQrb");

var $ilyef = parcelRequire("ilyef");
var $7sqOp = parcelRequire("7sqOp");

var $iGRaJ = parcelRequire("iGRaJ");
var $1uF5a = parcelRequire("1uF5a");
var $ky7aH = parcelRequire("ky7aH");
var $jyI49 = parcelRequire("jyI49");

var $e7n3C = parcelRequire("e7n3C");

var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $h0O6x = parcelRequire("h0O6x");

var $4Hc63 = parcelRequire("4Hc63");

var $7Mulo = parcelRequire("7Mulo");

var $iU7nv = parcelRequire("iU7nv");
var $36620459e8e83955$export$725eacad24cfb311 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Sparkline, _super);
    function Sparkline(options) {
        return _super.call(this, options, {
            type: 'line',
            x: 0,
            y: 0,
            width: 200,
            height: 20,
            isStack: false,
            color: [
                '#83daad',
                '#edbf45',
                '#d2cef9',
                '#e290b3',
                '#6f63f4'
            ],
            smooth: true,
            lineLineWidth: 1,
            areaOpacity: 0,
            isGroup: false,
            columnLineWidth: 1,
            columnStroke: '#fff',
            scale: 1,
            spacing: 0
        }) || this;
    }
    Object.defineProperty(Sparkline.prototype, "rawData", {
        /**
         * 将data统一格式化为数组形式
         * 如果堆叠，则生成堆叠数据
         */ get: function() {
            var rawData = this.attributes.data;
            if (!rawData || (rawData === null || rawData === void 0 ? void 0 : rawData.length) === 0) return [
                []
            ];
            var data = (0, $iGRaJ.default)(rawData);
            // number[] -> number[][]
            return (0, $jyI49.default)(data[0]) ? [
                data
            ] : data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sparkline.prototype, "data", {
        get: function() {
            if (this.attributes.isStack) return (0, $iU7nv.getStackedData)(this.rawData);
            return this.rawData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sparkline.prototype, "scales", {
        get: function() {
            return this.createScales(this.data);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sparkline.prototype, "baseline", {
        /**
         * 基准线，默认为 0
         */ get: function() {
            var y = this.scales.y;
            var _a = (0, $7WQrb.__read)(y.getOptions().domain || [
                0,
                0
            ], 2), y1 = _a[0], y2 = _a[1];
            if (y2 < 0) return y.map(y2);
            return y.map(y1 < 0 ? 0 : y1);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sparkline.prototype, "containerShape", {
        get: function() {
            var _a = this.attributes, width = _a.width, height = _a.height;
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sparkline.prototype, "linesStyle", {
        get: function() {
            var _this = this;
            var _a = this.attributes, type = _a.type, isStack = _a.isStack, smooth = _a.smooth;
            if (type !== 'line') throw new Error('linesStyle can only be used in line type');
            var areaStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'area');
            var lineStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'line');
            var width = this.containerShape.width;
            var data = this.data;
            if (data[0].length === 0) return {
                lines: [],
                areas: []
            };
            var _b = this.scales, x = _b.x, y = _b.y;
            // 线条Path
            var lines = (0, $7Mulo.dataToLines)(data, {
                type: 'line',
                x: x,
                y: y
            });
            // 生成区域path
            var areas = [];
            if (areaStyle) {
                var baseline = this.baseline;
                if (isStack) areas = smooth ? (0, $7Mulo.linesToStackCurveAreaPaths)(lines, width, baseline) : (0, $7Mulo.linesToStackAreaPaths)(lines, width, baseline);
                else areas = (0, $7Mulo.linesToAreaPaths)(lines, smooth, width, baseline);
            }
            return {
                lines: lines.map(function(line, idx) {
                    return (0, $7WQrb.__assign)({
                        stroke: _this.getColor(idx),
                        d: smooth ? (0, $7Mulo.lineToCurvePath)(line) : (0, $7Mulo.lineToLinePath)(line)
                    }, lineStyle);
                }),
                areas: areas.map(function(path, idx) {
                    return (0, $7WQrb.__assign)({
                        d: path,
                        fill: _this.getColor(idx)
                    }, areaStyle);
                })
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Sparkline.prototype, "columnsStyle", {
        get: function() {
            var _this = this;
            var columnStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'column');
            var _a = this.attributes, isStack = _a.isStack, type = _a.type, scale = _a.scale;
            if (type !== 'column') throw new Error('columnsStyle can only be used in column type');
            var height = this.containerShape.height;
            var data = this.rawData;
            if (!data) return {
                columns: []
            };
            if (isStack) data = (0, $iU7nv.getStackedData)(data);
            var _b = this.createScales(data), x = _b.x, y = _b.y;
            var _c = (0, $7WQrb.__read)((0, $iU7nv.getRange)(data), 2), minVal = _c[0], maxVal = _c[1];
            var heightScale = new (0, $7sqOp.Linear)({
                domain: [
                    0,
                    maxVal - (minVal > 0 ? 0 : minVal)
                ],
                range: [
                    0,
                    height * scale
                ]
            });
            var bandWidth = x.getBandWidth();
            var rawData = this.rawData;
            return {
                columns: data.map(function(column, i) {
                    return column.map(function(val, j) {
                        var barWidth = bandWidth / data.length;
                        var getShape = function() {
                            return {
                                x: x.map(j) + barWidth * i,
                                y: val >= 0 ? y.map(val) : y.map(0),
                                width: barWidth,
                                height: heightScale.map(Math.abs(val))
                            };
                        };
                        var getStackShape = function() {
                            return {
                                x: x.map(j),
                                y: y.map(val),
                                width: bandWidth,
                                height: heightScale.map(rawData[i][j])
                            };
                        };
                        return (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
                            fill: _this.getColor(i)
                        }, columnStyle), isStack ? getStackShape() : getShape());
                    });
                })
            };
        },
        enumerable: false,
        configurable: true
    });
    Sparkline.prototype.render = function(attributes, container) {
        (0, $bCy7Q.maybeAppend)(container, '.container', 'rect').attr('className', 'container').node();
        var type = attributes.type, x = attributes.x, y = attributes.y;
        var className = "spark".concat(type);
        var style = (0, $7WQrb.__assign)({
            x: x,
            y: y
        }, type === 'line' ? this.linesStyle : this.columnsStyle);
        (0, $bCy7Q.select)(container).selectAll('.spark').data([
            type
        ]).join(function(enter) {
            return enter.append(function(type) {
                if (type === 'line') return new (0, $4Hc63.Lines)({
                    className: className,
                    style: style
                });
                return new (0, $h0O6x.Columns)({
                    className: className,
                    style: style
                });
            }).attr('className', "spark ".concat(className));
        }, function(update) {
            return update.update(style);
        }, function(exit) {
            return exit.remove();
        });
    };
    /**
     * 根据数据索引获取color
     */ Sparkline.prototype.getColor = function(index) {
        var color = this.attributes.color;
        if ((0, $1uF5a.default)(color)) return color[index % color.length];
        if ((0, $ky7aH.default)(color)) return color.call(null, index);
        return color;
    };
    /**
     * 根据数据生成scale
     */ Sparkline.prototype.createScales = function(data) {
        var _a, _b;
        var _c = this.attributes, type = _c.type, scale = _c.scale, _d = _c.range, range = _d === void 0 ? [] : _d, spacing = _c.spacing;
        var _e = this.containerShape, width = _e.width, height = _e.height;
        var _f = (0, $7WQrb.__read)((0, $iU7nv.getRange)(data), 2), minVal = _f[0], maxVal = _f[1];
        var yScale = new (0, $7sqOp.Linear)({
            domain: [
                (_a = range[0]) !== null && _a !== void 0 ? _a : minVal,
                (_b = range[1]) !== null && _b !== void 0 ? _b : maxVal
            ],
            range: [
                height,
                height * (1 - scale)
            ]
        });
        if (type === 'line') return {
            type: type,
            x: new (0, $7sqOp.Linear)({
                domain: [
                    0,
                    data[0].length - 1
                ],
                range: [
                    0,
                    width
                ]
            }),
            y: yScale
        };
        return {
            type: type,
            x: new (0, $ilyef.Band)({
                domain: data[0].map(function(val, idx) {
                    return idx;
                }),
                range: [
                    0,
                    width
                ],
                paddingInner: spacing,
                paddingOuter: spacing / 2,
                align: 0.5
            }),
            y: yScale
        };
    };
    Sparkline.tag = 'sparkline';
    return Sparkline;
}((0, $e7n3C.Component));

});
parcelRegister("ilyef", function(module, exports) {

$parcel$export(module.exports, "Band", () => $d5b4bd4ec70ba233$export$5b22a87d7feca398);

var $e449m = parcelRequire("e449m");

var $ic8Qo = parcelRequire("ic8Qo");
function $d5b4bd4ec70ba233$var$normalize(array) {
    const min = Math.min(...array);
    return array.map((d)=>d / min);
}
function $d5b4bd4ec70ba233$var$splice(array, n) {
    const sn = array.length;
    const diff = n - sn;
    return diff > 0 ? [
        ...array,
        ...new Array(diff).fill(1)
    ] : diff < 0 ? array.slice(0, n) : array;
}
function $d5b4bd4ec70ba233$var$pretty(n) {
    return Math.round(n * 1e12) / 1e12;
}
/**
 * 基于 band 基础配置获取存在 flex band 的状态
 */ function $d5b4bd4ec70ba233$var$computeFlexBandState(options) {
    // 如果 flex 比 domain 少，那么就补全
    // 如果 flex 比 domain 多，就截取
    const { domain: domain, range: range, paddingOuter: paddingOuter, paddingInner: paddingInner, flex: F, round: round, align: align } = options;
    const n = domain.length;
    const flex = $d5b4bd4ec70ba233$var$splice(F, n);
    // 根据下面的等式可以计算出所有 step 的总和
    // stepSum = step1 + step2 ... + stepN;
    // stepAverage = stepSum / n;
    // PO = stepAverage * paddingOuter;
    // PI = stepAverage * paddingInner;
    // width = PO * 2 + stepSum - PI;
    const [start, end] = range;
    const width = end - start;
    const ratio = 2 / n * paddingOuter + 1 - 1 / n * paddingInner;
    const stepSum = width / ratio;
    // stepSum = (b1 + PI) + (b2 + PI) ... + (bN + PI)
    // = bandSum + PI * n;
    const PI = stepSum * paddingInner / n;
    const bandWidthSum = stepSum - n * PI;
    // 计算出最小的 bandWidth
    const normalizedFlex = $d5b4bd4ec70ba233$var$normalize(flex);
    const flexSum = normalizedFlex.reduce((sum, value)=>sum + value);
    const minBandWidth = bandWidthSum / flexSum;
    // 计算每个 bandWidth 和 step，并且用定义域内的值索引
    const valueBandWidth = new (0, $e449m.InternMap)(domain.map((d, i)=>{
        const bandWidth = normalizedFlex[i] * minBandWidth;
        return [
            d,
            round ? Math.floor(bandWidth) : bandWidth
        ];
    }));
    const valueStep = new (0, $e449m.InternMap)(domain.map((d, i)=>{
        const bandWidth = normalizedFlex[i] * minBandWidth;
        const step = bandWidth + PI;
        return [
            d,
            round ? Math.floor(step) : step
        ];
    }));
    // 计算起始位置的偏移量
    // 因为 step 可能被 round 了，重新计算所有的 step 的总和
    const finalStepSum = Array.from(valueStep.values()).reduce((sum, value)=>sum + value);
    const outerPaddingSum = width - (finalStepSum - finalStepSum / n * paddingInner);
    const offset = outerPaddingSum * align;
    // 计算 adjustedRange，也就是 domain 中每个值映射之后的值
    const bandStart = start + offset;
    let prev = round ? Math.round(bandStart) : bandStart;
    const adjustedRange = new Array(n);
    for(let i = 0; i < n; i += 1){
        // 简单处理精度问题
        adjustedRange[i] = $d5b4bd4ec70ba233$var$pretty(prev);
        const value = domain[i];
        prev += valueStep.get(value);
    }
    return {
        valueBandWidth: valueBandWidth,
        valueStep: valueStep,
        adjustedRange: adjustedRange
    };
}
/**
 * 基于 band 基础配置获取 band 的状态
 */ function $d5b4bd4ec70ba233$var$computeBandState(options) {
    var _a;
    const { domain: domain } = options;
    const n = domain.length;
    if (n === 0) return {
        valueBandWidth: undefined,
        valueStep: undefined,
        adjustedRange: []
    };
    const hasFlex = !!((_a = options.flex) === null || _a === void 0 ? void 0 : _a.length);
    if (hasFlex) return $d5b4bd4ec70ba233$var$computeFlexBandState(options);
    const { range: range, paddingOuter: paddingOuter, paddingInner: paddingInner, round: round, align: align } = options;
    let step;
    let bandWidth;
    let rangeStart = range[0];
    const rangeEnd = range[1];
    // range 的计算方式如下：
    // = stop - start
    // = (n * step(n 个 step) )
    // + (2 * step * paddingOuter(两边的 padding))
    // - (1 * step * paddingInner(多出的一个 inner))
    const deltaRange = rangeEnd - rangeStart;
    const outerTotal = paddingOuter * 2;
    const innerTotal = n - paddingInner;
    step = deltaRange / Math.max(1, outerTotal + innerTotal);
    // 优化成整数
    if (round) step = Math.floor(step);
    // 基于 align 实现偏移
    rangeStart += (deltaRange - step * (n - paddingInner)) * align;
    // 一个 step 的组成如下：
    // step = bandWidth + step * paddingInner，
    // 则 bandWidth = step - step * (paddingInner)
    bandWidth = step * (1 - paddingInner);
    if (round) {
        rangeStart = Math.round(rangeStart);
        bandWidth = Math.round(bandWidth);
    }
    // 转化后的 range
    const adjustedRange = new Array(n).fill(0).map((_, i)=>rangeStart + i * step);
    return {
        valueStep: step,
        valueBandWidth: bandWidth,
        adjustedRange: adjustedRange
    };
}
class $d5b4bd4ec70ba233$export$5b22a87d7feca398 extends (0, $ic8Qo.Ordinal) {
    // 覆盖默认配置
    getDefaultOptions() {
        return {
            domain: [],
            range: [
                0,
                1
            ],
            align: 0.5,
            round: false,
            paddingInner: 0,
            paddingOuter: 0,
            padding: 0,
            unknown: (0, $ic8Qo.defaultUnknown),
            flex: []
        };
    }
    // 显示指定 options 的类型为 OrdinalOptions，从而推断出 O 的类型
    constructor(options){
        super(options);
    }
    clone() {
        return new $d5b4bd4ec70ba233$export$5b22a87d7feca398(this.options);
    }
    getStep(x) {
        if (this.valueStep === undefined) return 1;
        // 没有 flex 的情况时, valueStep 是 number 类型
        if (typeof this.valueStep === 'number') return this.valueStep;
        // 对于 flex 都为 1 的情况，x 不是必须要传入的
        // 这种情况所有的条的 step 都相等，所以返回第一个就好
        if (x === undefined) return Array.from(this.valueStep.values())[0];
        return this.valueStep.get(x);
    }
    getBandWidth(x) {
        if (this.valueBandWidth === undefined) return 1;
        // 没有 flex, valueBandWidth 是 number 类型
        if (typeof this.valueBandWidth === 'number') return this.valueBandWidth;
        // 对于 flex 都为 1 的情况，x 不是必须要传入的
        // 这种情况所有的条的 bandWidth 都相等，所以返回第一个
        if (x === undefined) return Array.from(this.valueBandWidth.values())[0];
        return this.valueBandWidth.get(x);
    }
    getRange() {
        return this.adjustedRange;
    }
    getPaddingInner() {
        const { padding: padding, paddingInner: paddingInner } = this.options;
        return padding > 0 ? padding : paddingInner;
    }
    getPaddingOuter() {
        const { padding: padding, paddingOuter: paddingOuter } = this.options;
        return padding > 0 ? padding : paddingOuter;
    }
    rescale() {
        super.rescale();
        // 当用户配置了opt.padding 且非 0 时，我们覆盖已经设置的 paddingInner paddingOuter
        // 我们约定 padding 的优先级较 paddingInner 和 paddingOuter 高
        const { align: align, domain: domain, range: range, round: round, flex: flex } = this.options;
        const { adjustedRange: adjustedRange, valueBandWidth: valueBandWidth, valueStep: valueStep } = $d5b4bd4ec70ba233$var$computeBandState({
            align: align,
            range: range,
            round: round,
            flex: flex,
            paddingInner: this.getPaddingInner(),
            paddingOuter: this.getPaddingOuter(),
            domain: domain
        });
        // 更新必要的属性
        this.valueStep = valueStep;
        this.valueBandWidth = valueBandWidth;
        this.adjustedRange = adjustedRange;
    }
}

});
parcelRegister("e449m", function(module, exports) {

$parcel$export(module.exports, "InternMap", () => $a3d4a87ed7b2db06$export$dcc6fb7d82b5bc7b);
function $a3d4a87ed7b2db06$var$internGet({ map: map, initKey: initKey }, value) {
    const key = initKey(value);
    return map.has(key) ? map.get(key) : value;
}
function $a3d4a87ed7b2db06$var$internSet({ map: map, initKey: initKey }, value) {
    const key = initKey(value);
    if (map.has(key)) return map.get(key);
    map.set(key, value);
    return value;
}
function $a3d4a87ed7b2db06$var$internDelete({ map: map, initKey: initKey }, value) {
    const key = initKey(value);
    if (map.has(key)) {
        value = map.get(key);
        map.delete(key);
    }
    return value;
}
function $a3d4a87ed7b2db06$var$keyof(value) {
    return typeof value === 'object' ? value.valueOf() : value;
}
class $a3d4a87ed7b2db06$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries){
        super();
        this.map = new Map();
        this.initKey = $a3d4a87ed7b2db06$var$keyof;
        if (entries !== null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($a3d4a87ed7b2db06$var$internGet({
            map: this.map,
            initKey: this.initKey
        }, key));
    }
    has(key) {
        return super.has($a3d4a87ed7b2db06$var$internGet({
            map: this.map,
            initKey: this.initKey
        }, key));
    }
    set(key, value) {
        return super.set($a3d4a87ed7b2db06$var$internSet({
            map: this.map,
            initKey: this.initKey
        }, key), value);
    }
    delete(key) {
        return super.delete($a3d4a87ed7b2db06$var$internDelete({
            map: this.map,
            initKey: this.initKey
        }, key));
    }
}

});

parcelRegister("ic8Qo", function(module, exports) {

$parcel$export(module.exports, "defaultUnknown", () => $d3f03536d796a8d7$export$5a7bd8fd362eb651);
$parcel$export(module.exports, "Ordinal", () => $d3f03536d796a8d7$export$9bee3ea40d61d982);

var $jRUzV = parcelRequire("jRUzV");
const $d3f03536d796a8d7$export$5a7bd8fd362eb651 = Symbol('defaultUnknown');
/**
 * 更新 indexMap
 *
 * @param arr 初始的数组
 * @param target 目标 map
 * @returns {Map<string, any>} 生成的 indexMap
 */ function $d3f03536d796a8d7$var$updateIndexMap(target, arr, key) {
    for(let i = 0; i < arr.length; i += 1)if (!target.has(arr[i])) target.set(key(arr[i]), i);
}
/**
 * 基于 indexMap 进行映射
 *
 * @param options 相关选项
 * @see MapBetweenArrOptions
 * @return {any} 映射结果
 */ function $d3f03536d796a8d7$var$mapBetweenArrByMapIndex(options) {
    const { value: value, from: from, to: to, mapper: mapper, notFoundReturn: notFoundReturn } = options;
    let mappedIndex = mapper.get(value);
    // index 不存在时，
    // 如果用户显式设置了 unknown 的值，那么就返回 unknown 的值
    // 否者我们将 value 添加到原数组, 并更新 Map
    if (mappedIndex === undefined) {
        if (notFoundReturn !== $d3f03536d796a8d7$export$5a7bd8fd362eb651) return notFoundReturn;
        mappedIndex = from.push(value) - 1;
        mapper.set(value, mappedIndex);
    }
    return to[mappedIndex % to.length];
}
function $d3f03536d796a8d7$var$createKey(d) {
    if (d instanceof Date) return (d)=>`${d}`;
    if (typeof d === 'object') return (d)=>JSON.stringify(d);
    return (d)=>d;
}
class $d3f03536d796a8d7$export$9bee3ea40d61d982 extends (0, $jRUzV.Base) {
    // 覆盖默认配置
    getDefaultOptions() {
        return {
            domain: [],
            range: [],
            unknown: $d3f03536d796a8d7$export$5a7bd8fd362eb651
        };
    }
    // 显示指定 options 的类型为 OrdinalOptions，从而推断出 O 的类型
    constructor(options){
        super(options);
    }
    map(x) {
        if (this.domainIndexMap.size === 0) $d3f03536d796a8d7$var$updateIndexMap(this.domainIndexMap, this.getDomain(), this.domainKey);
        return $d3f03536d796a8d7$var$mapBetweenArrByMapIndex({
            value: this.domainKey(x),
            mapper: this.domainIndexMap,
            from: this.getDomain(),
            to: this.getRange(),
            notFoundReturn: this.options.unknown
        });
    }
    invert(y) {
        if (this.rangeIndexMap.size === 0) $d3f03536d796a8d7$var$updateIndexMap(this.rangeIndexMap, this.getRange(), this.rangeKey);
        return $d3f03536d796a8d7$var$mapBetweenArrByMapIndex({
            value: this.rangeKey(y),
            mapper: this.rangeIndexMap,
            from: this.getRange(),
            to: this.getDomain(),
            notFoundReturn: this.options.unknown
        });
    }
    // 因为 ordinal 比例尺更新内部状态的开销较大，所以按需更新
    rescale(options) {
        const [d] = this.options.domain;
        const [r] = this.options.range;
        this.domainKey = $d3f03536d796a8d7$var$createKey(d);
        this.rangeKey = $d3f03536d796a8d7$var$createKey(r);
        // 如果 rangeIndexMap 没有初始化，说明是在初始化阶段
        if (!this.rangeIndexMap) {
            this.rangeIndexMap = new Map();
            this.domainIndexMap = new Map();
            return;
        }
        // 否者是在更新阶段
        if (!options || options.range) this.rangeIndexMap.clear();
        if (!options || options.domain || options.compare) {
            this.domainIndexMap.clear();
            this.sortedDomain = undefined;
        }
    }
    clone() {
        return new $d3f03536d796a8d7$export$9bee3ea40d61d982(this.options);
    }
    getRange() {
        return this.options.range;
    }
    getDomain() {
        // 如果设置了比较器，就排序
        if (this.sortedDomain) return this.sortedDomain;
        const { domain: domain, compare: compare } = this.options;
        this.sortedDomain = compare ? [
            ...domain
        ].sort(compare) : domain;
        return this.sortedDomain;
    }
}

});
parcelRegister("jRUzV", function(module, exports) {

$parcel$export(module.exports, "Base", () => $e76edad65cec01a3$export$ef88aa0d34c34520);

var $iE4so = parcelRequire("iE4so");
class $e76edad65cec01a3$export$ef88aa0d34c34520 {
    /**
     * 构造函数，根据自定义的选项和默认选项生成当前选项
     * @param options 需要自定义配置的选项
     */ constructor(options){
        this.options = (0, $iE4so.default)({}, this.getDefaultOptions());
        this.update(options);
    }
    /**
     * 返回当前的所有选项
     * @returns 当前的所有选项
     */ getOptions() {
        return this.options;
    }
    /**
     * 更新选项和比例尺的内部状态
     * @param updateOptions 需要更新的选项
     */ update(updateOptions = {}) {
        this.options = (0, $iE4so.default)({}, this.options, updateOptions);
        this.rescale(updateOptions);
    }
    /**
     * 根据需要更新 options 和更新后的 options 更新 scale 的内部状态，
     * 在函数内部可以用 this.options 获得更新后的 options
     * @param options 需要更新的 options
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    rescale(options) {}
}

});



parcelRegister("7sqOp", function(module, exports) {

$parcel$export(module.exports, "Linear", () => $56dff23e84661e69$export$cff00ccf6e2392de);

var $6AtqT = parcelRequire("6AtqT");

var $cb3ud = parcelRequire("cb3ud");

var $8wktA = parcelRequire("8wktA");

var $4YlCQ = parcelRequire("4YlCQ");
class $56dff23e84661e69$export$cff00ccf6e2392de extends (0, $cb3ud.Continuous) {
    getDefaultOptions() {
        return {
            domain: [
                0,
                1
            ],
            range: [
                0,
                1
            ],
            unknown: undefined,
            nice: false,
            clamp: false,
            round: false,
            interpolate: (0, $8wktA.createInterpolateValue),
            tickMethod: (0, $4YlCQ.d3Ticks),
            tickCount: 5
        };
    }
    chooseTransforms() {
        return [
            (0, $6AtqT.default),
            (0, $6AtqT.default)
        ];
    }
    clone() {
        return new $56dff23e84661e69$export$cff00ccf6e2392de(this.options);
    }
}

});
parcelRegister("6AtqT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cbcef9fd963bb3e$export$2e2bcd8739ae039);
var $4cbcef9fd963bb3e$export$2e2bcd8739ae039 = function(v) {
    return v;
};

});

parcelRegister("cb3ud", function(module, exports) {

$parcel$export(module.exports, "Continuous", () => $8dd9376ee2cdf026$export$ea8999ff595187c4);

var $6AtqT = parcelRequire("6AtqT");

var $jRUzV = parcelRequire("jRUzV");

var $gm7ZG = parcelRequire("gm7ZG");
var $430GS = parcelRequire("430GS");
var $h9CWJ = parcelRequire("h9CWJ");
var $8wktA = parcelRequire("8wktA");
var $hkqD4 = parcelRequire("hkqD4");
var $g3yEl = parcelRequire("g3yEl");
var $de2t2 = parcelRequire("de2t2");
/** 当 domain 和 range 只有一段的时候的 map 的 工厂函数 */ const $8dd9376ee2cdf026$var$createBiMap = (domain, range, createInterpolate)=>{
    const [d0, d1] = domain;
    const [r0, r1] = range;
    let normalize;
    let interpolate;
    if (d0 < d1) {
        normalize = (0, $hkqD4.createNormalize)(d0, d1);
        interpolate = createInterpolate(r0, r1);
    } else {
        normalize = (0, $hkqD4.createNormalize)(d1, d0);
        interpolate = createInterpolate(r1, r0);
    }
    return (0, $430GS.compose)(interpolate, normalize);
};
/** 当 domain 和 range 有多段时候的 map 的 工厂函数 */ const $8dd9376ee2cdf026$var$createPolyMap = (domain, range, createInterpolate)=>{
    const len = Math.min(domain.length, range.length) - 1;
    const normalizeList = new Array(len);
    const interpolateList = new Array(len);
    const reverse = domain[0] > domain[len];
    const ascendingDomain = reverse ? [
        ...domain
    ].reverse() : domain;
    const ascendingRange = reverse ? [
        ...range
    ].reverse() : range;
    // 每一段都生成 normalize 和 interpolate
    for(let i = 0; i < len; i += 1){
        normalizeList[i] = (0, $hkqD4.createNormalize)(ascendingDomain[i], ascendingDomain[i + 1]);
        interpolateList[i] = createInterpolate(ascendingRange[i], ascendingRange[i + 1]);
    }
    // 二分最右查找到相应的 normalize 和 interpolate
    return (x)=>{
        const i = (0, $gm7ZG.bisect)(domain, x, 1, len) - 1;
        const normalize = normalizeList[i];
        const interpolate = interpolateList[i];
        return (0, $430GS.compose)(interpolate, normalize)(x);
    };
};
/** 选择一个分段映射的函数 */ const $8dd9376ee2cdf026$var$choosePiecewise = (domain, range, interpolate, shouldRound)=>{
    const n = Math.min(domain.length, range.length);
    const createPiecewise = n > 2 ? $8dd9376ee2cdf026$var$createPolyMap : $8dd9376ee2cdf026$var$createBiMap;
    const createInterpolate = shouldRound ? (0, $8wktA.createInterpolateRound) : interpolate;
    return createPiecewise(domain, range, createInterpolate);
};
class $8dd9376ee2cdf026$export$ea8999ff595187c4 extends (0, $jRUzV.Base) {
    getDefaultOptions() {
        return {
            domain: [
                0,
                1
            ],
            range: [
                0,
                1
            ],
            nice: false,
            clamp: false,
            round: false,
            interpolate: (0, $8wktA.createInterpolateNumber),
            tickCount: 5
        };
    }
    /**
     * y = interpolate(normalize(clamp(transform(x))))
     */ map(x) {
        if (!(0, $de2t2.isValid)(x)) return this.options.unknown;
        return this.output(x);
    }
    /**
     * x = transform(clamp(interpolate(normalize(y))))
     */ invert(x) {
        if (!(0, $de2t2.isValid)(x)) return this.options.unknown;
        return this.input(x);
    }
    nice() {
        if (!this.options.nice) return;
        const [min, max, tickCount, ...rest] = this.getTickMethodOptions();
        this.options.domain = this.chooseNice()(min, max, tickCount, ...rest);
    }
    getTicks() {
        const { tickMethod: tickMethod } = this.options;
        const [min, max, tickCount, ...rest] = this.getTickMethodOptions();
        return tickMethod(min, max, tickCount, ...rest);
    }
    getTickMethodOptions() {
        const { domain: domain, tickCount: tickCount } = this.options;
        const min = domain[0];
        const max = domain[domain.length - 1];
        return [
            min,
            max,
            tickCount
        ];
    }
    chooseNice() {
        return 0, $g3yEl.d3LinearNice;
    }
    rescale() {
        this.nice();
        const [transform, untransform] = this.chooseTransforms();
        this.composeOutput(transform, this.chooseClamp(transform));
        this.composeInput(transform, untransform, this.chooseClamp(untransform));
    }
    chooseClamp(transform) {
        const { clamp: shouldClamp, range: range } = this.options;
        const domain = this.options.domain.map(transform);
        const n = Math.min(domain.length, range.length);
        return shouldClamp ? (0, $h9CWJ.createClamp)(domain[0], domain[n - 1]) : (0, $6AtqT.default);
    }
    composeOutput(transform, clamp) {
        const { domain: domain, range: range, round: round, interpolate: interpolate } = this.options;
        const piecewise = $8dd9376ee2cdf026$var$choosePiecewise(domain.map(transform), range, interpolate, round);
        this.output = (0, $430GS.compose)(piecewise, clamp, transform);
    }
    composeInput(transform, untransform, clamp) {
        const { domain: domain, range: range } = this.options;
        const piecewise = $8dd9376ee2cdf026$var$choosePiecewise(range, domain.map(transform), (0, $8wktA.createInterpolateNumber));
        this.input = (0, $430GS.compose)(untransform, clamp, piecewise);
    }
}

});
parcelRegister("gm7ZG", function(module, exports) {

$parcel$export(module.exports, "bisect", () => $be84e6d27563aa8d$export$a668c821d9678ea6);
/**
 * 在一个升序的序列指定范围内 array[lo, hi) 二分查找一个值 x，返回最右边一个匹配的值后面的索引 i
 * https://github.com/d3/d3-array/blob/master/src/bisector.js
 * @param array 升序的目标数组
 * @param x 查找的值
 * @param lo 开始的索引
 * @param hi 结束的索引
 * @returns 最右边一个匹配的值后一个的索引
 */ function $be84e6d27563aa8d$export$a668c821d9678ea6(array, x, lo, hi, getter) {
    let i = lo || 0;
    let j = hi || array.length;
    const get = getter || ((x)=>x);
    while(i < j){
        const mid = Math.floor((i + j) / 2);
        if (get(array[mid]) > x) j = mid;
        else i = mid + 1;
    }
    return i;
}

});

parcelRegister("430GS", function(module, exports) {

$parcel$export(module.exports, "compose", () => $2f27fa648662f82d$export$f672e0b6f7222cd7);
/**
 * 将多个单个参数的函数合成为一个函数，执行顺序为从右到左
 * @param fn 第一个函数
 * @param rest 剩余函数
 * @returns 复合后的函数
 */ function $2f27fa648662f82d$export$f672e0b6f7222cd7(fn, ...rest) {
    return rest.reduce((pre, cur)=>(x)=>pre(cur(x)), fn);
}

});

parcelRegister("h9CWJ", function(module, exports) {

$parcel$export(module.exports, "createClamp", () => $c7d17cdeb6646a44$export$b97b9272facffabd);
/**
 * 返回一个 clamp 函数，将输入限定在指定范围之内
 * @param a 范围的第一个端点
 * @param b 范围的第二个端点
 * @returns clamp 函数
 */ function $c7d17cdeb6646a44$export$b97b9272facffabd(a, b) {
    const lo = b < a ? b : a;
    const hi = a > b ? a : b;
    return (x)=>Math.min(Math.max(lo, x), hi);
}

});

parcelRegister("8wktA", function(module, exports) {

$parcel$export(module.exports, "createInterpolateNumber", () => $6341320dcca8359a$export$2cf116dba5c3919);
$parcel$export(module.exports, "createInterpolateValue", () => $6341320dcca8359a$export$bb0345d278a65c5e);
$parcel$export(module.exports, "createInterpolateRound", () => $6341320dcca8359a$export$af9e98d7525d8dc5);

var $039YO = parcelRequire("039YO");
const $6341320dcca8359a$export$2cf116dba5c3919 = (a, b)=>{
    return (t)=>a * (1 - t) + b * t;
};
const $6341320dcca8359a$export$88ad13106f0d2a9a = (a, b)=>{
    const c1 = (0, $039YO.string2rbg)(a);
    const c2 = (0, $039YO.string2rbg)(b);
    if (c1 === null || c2 === null) return c1 ? ()=>a : ()=>b;
    return (t)=>{
        const values = new Array(4);
        for(let i = 0; i < 4; i += 1){
            const from = c1[i];
            const to = c2[i];
            values[i] = from * (1 - t) + to * t;
        }
        const [r, g, b, a] = values;
        return `rgba(${Math.round(r)}, ${Math.round(g)}, ${Math.round(b)}, ${a})`;
    };
};
const $6341320dcca8359a$export$bb0345d278a65c5e = (a, b)=>{
    if (typeof a === 'number' && typeof b === 'number') return $6341320dcca8359a$export$2cf116dba5c3919(a, b);
    if (typeof a === 'string' && typeof b === 'string') return $6341320dcca8359a$export$88ad13106f0d2a9a(a, b);
    return ()=>a;
};
const $6341320dcca8359a$export$af9e98d7525d8dc5 = (a, b)=>{
    const interpolateNumber = $6341320dcca8359a$export$2cf116dba5c3919(a, b);
    return (t)=>Math.round(interpolateNumber(t));
};

});
parcelRegister("039YO", function(module, exports) {

$parcel$export(module.exports, "string2rbg", () => $009805b701ba6eea$export$17635a35d04e914b);

var $bA74c = parcelRequire("bA74c");
function $009805b701ba6eea$var$hue2rgb(p, q, m) {
    let t = m;
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $009805b701ba6eea$var$hsl2rbg(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const a = hsl[3];
    if (s === 0) return [
        l * 255,
        l * 255,
        l * 255,
        a
    ];
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $009805b701ba6eea$var$hue2rgb(p, q, h + 1 / 3);
    const g = $009805b701ba6eea$var$hue2rgb(p, q, h);
    const b = $009805b701ba6eea$var$hue2rgb(p, q, h - 1 / 3);
    return [
        r * 255,
        g * 255,
        b * 255,
        a
    ];
}
function $009805b701ba6eea$export$17635a35d04e914b(s) {
    const color = (0, (/*@__PURE__*/$parcel$interopDefault($bA74c))).get(s);
    if (!color) return null;
    const { model: model, value: value } = color;
    if (model === 'rgb') return value;
    if (model === 'hsl') return $009805b701ba6eea$var$hsl2rbg(value);
    return null;
}

});
parcelRegister("bA74c", function(module, exports) {
/* MIT license */ 
var $jVuP9 = parcelRequire("jVuP9");

var $8mXov = parcelRequire("8mXov");
var $86e889c881e89501$var$hasOwnProperty = Object.hasOwnProperty;
var $86e889c881e89501$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $86e889c881e89501$var$name in $jVuP9)if ($86e889c881e89501$var$hasOwnProperty.call($jVuP9, $86e889c881e89501$var$name)) $86e889c881e89501$var$reverseNames[$jVuP9[$86e889c881e89501$var$name]] = $86e889c881e89501$var$name;
var $86e889c881e89501$var$cs = module.exports = {
    to: {},
    get: {}
};
$86e889c881e89501$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case 'hsl':
            val = $86e889c881e89501$var$cs.get.hsl(string);
            model = 'hsl';
            break;
        case 'hwb':
            val = $86e889c881e89501$var$cs.get.hwb(string);
            model = 'hwb';
            break;
        default:
            val = $86e889c881e89501$var$cs.get.rgb(string);
            model = 'rgb';
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$86e889c881e89501$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === 'transparent') return [
            0,
            0,
            0,
            0
        ];
        if (!$86e889c881e89501$var$hasOwnProperty.call($jVuP9, match[1])) return null;
        rgb = $jVuP9[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $86e889c881e89501$var$clamp(rgb[i], 0, 255);
    rgb[3] = $86e889c881e89501$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$86e889c881e89501$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $86e889c881e89501$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $86e889c881e89501$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $86e889c881e89501$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$86e889c881e89501$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $86e889c881e89501$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $86e889c881e89501$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $86e889c881e89501$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$86e889c881e89501$var$cs.to.hex = function() {
    var rgba = $8mXov(arguments);
    return '#' + $86e889c881e89501$var$hexDouble(rgba[0]) + $86e889c881e89501$var$hexDouble(rgba[1]) + $86e889c881e89501$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $86e889c881e89501$var$hexDouble(Math.round(rgba[3] * 255)) : '');
};
$86e889c881e89501$var$cs.to.rgb = function() {
    var rgba = $8mXov(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ')' : 'rgba(' + Math.round(rgba[0]) + ', ' + Math.round(rgba[1]) + ', ' + Math.round(rgba[2]) + ', ' + rgba[3] + ')';
};
$86e889c881e89501$var$cs.to.rgb.percent = function() {
    var rgba = $8mXov(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? 'rgb(' + r + '%, ' + g + '%, ' + b + '%)' : 'rgba(' + r + '%, ' + g + '%, ' + b + '%, ' + rgba[3] + ')';
};
$86e889c881e89501$var$cs.to.hsl = function() {
    var hsla = $8mXov(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? 'hsl(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%)' : 'hsla(' + hsla[0] + ', ' + hsla[1] + '%, ' + hsla[2] + '%, ' + hsla[3] + ')';
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$86e889c881e89501$var$cs.to.hwb = function() {
    var hwba = $8mXov(arguments);
    var a = '';
    if (hwba.length >= 4 && hwba[3] !== 1) a = ', ' + hwba[3];
    return 'hwb(' + hwba[0] + ', ' + hwba[1] + '%, ' + hwba[2] + '%' + a + ')';
};
$86e889c881e89501$var$cs.to.keyword = function(rgb) {
    return $86e889c881e89501$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $86e889c881e89501$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $86e889c881e89501$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? '0' + str : str;
}

});
parcelRegister("jVuP9", function(module, exports) {
'use strict';
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});

parcelRegister("8mXov", function(module, exports) {
'use strict';

var $2y1I3 = parcelRequire("2y1I3");
var $617e73434a6cfefb$var$concat = Array.prototype.concat;
var $617e73434a6cfefb$var$slice = Array.prototype.slice;
var $617e73434a6cfefb$var$swizzle = module.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($2y1I3(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $617e73434a6cfefb$var$concat.call(results, $617e73434a6cfefb$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$617e73434a6cfefb$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($617e73434a6cfefb$var$swizzle(arguments));
    };
};

});
parcelRegister("2y1I3", function(module, exports) {
module.exports = function isArrayish(obj) {
    if (!obj || typeof obj === 'string') return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== 'String');
};

});





parcelRegister("hkqD4", function(module, exports) {

$parcel$export(module.exports, "createNormalize", () => $c9d8f5f0cbb8391a$export$40383e483d0846a4);
/**
 * 返回一个 normalize 函数，该函数将输入的 t 从 [a, b] 线性变换到 [0, 1]
 * @param a 输入 t 的最小值
 * @param b 输入 t 的最大值
 * @returns normalize 函数
 */ function $c9d8f5f0cbb8391a$export$40383e483d0846a4(a, b) {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    return b - a ? (t)=>(t - a) / (b - a) : (_)=>0.5;
}

});

parcelRegister("g3yEl", function(module, exports) {

$parcel$export(module.exports, "d3LinearNice", () => $bb07cdd91d270a7f$export$cb0db72b309dc071);
// 参考 d3-ticks nice 的实现
// https://github.com/d3/d3-scale

var $a0oMV = parcelRequire("a0oMV");
const $bb07cdd91d270a7f$export$cb0db72b309dc071 = (min, max, count = 5)=>{
    const d = [
        min,
        max
    ];
    let i0 = 0;
    let i1 = d.length - 1;
    let start = d[i0];
    let stop = d[i1];
    let step;
    if (stop < start) {
        [start, stop] = [
            stop,
            start
        ];
        [i0, i1] = [
            i1,
            i0
        ];
    }
    step = (0, $a0oMV.tickIncrement)(start, stop, count);
    if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
        step = (0, $a0oMV.tickIncrement)(start, stop, count);
    } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
        step = (0, $a0oMV.tickIncrement)(start, stop, count);
    }
    if (step > 0) {
        d[i0] = Math.floor(start / step) * step;
        d[i1] = Math.ceil(stop / step) * step;
    } else if (step < 0) {
        d[i0] = Math.ceil(start * step) / step;
        d[i1] = Math.floor(stop * step) / step;
    }
    return d;
};

});
parcelRegister("a0oMV", function(module, exports) {

$parcel$export(module.exports, "tickIncrement", () => $748d21e158457101$export$bc64d00cc98e7e95);
const $748d21e158457101$var$e10 = Math.sqrt(50);
const $748d21e158457101$var$e5 = Math.sqrt(10);
const $748d21e158457101$var$e2 = Math.sqrt(2);
function $748d21e158457101$export$bc64d00cc98e7e95(start, stop, count) {
    const step = (stop - start) / Math.max(0, count);
    const power = Math.floor(Math.log(step) / Math.LN10);
    const error = step / 10 ** power;
    if (power >= 0) // eslint-disable-next-line no-nested-ternary
    return (error >= $748d21e158457101$var$e10 ? 10 : error >= $748d21e158457101$var$e5 ? 5 : error >= $748d21e158457101$var$e2 ? 2 : 1) * 10 ** power;
    // eslint-disable-next-line no-nested-ternary
    return -(10 ** -power) / (error >= $748d21e158457101$var$e10 ? 10 : error >= $748d21e158457101$var$e5 ? 5 : error >= $748d21e158457101$var$e2 ? 2 : 1);
}
function $748d21e158457101$export$81087d9b915d4ede(start, stop, count) {
    const step0 = Math.abs(stop - start) / Math.max(0, count);
    let step1 = 10 ** Math.floor(Math.log(step0) / Math.LN10);
    const error = step0 / step1;
    if (error >= $748d21e158457101$var$e10) step1 *= 10;
    else if (error >= $748d21e158457101$var$e5) step1 *= 5;
    else if (error >= $748d21e158457101$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("de2t2", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $9a0e7f1c64581783$export$1ea939691cdc45b8);

var $lrrSP = parcelRequire("lrrSP");
var $aFcWQ = parcelRequire("aFcWQ");
function $9a0e7f1c64581783$export$1ea939691cdc45b8(x) {
    return !(0, $aFcWQ.default)(x) && !(0, $lrrSP.default)(x) && !Number.isNaN(x);
}

});
parcelRegister("lrrSP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9c1bfa6541077a0$export$2e2bcd8739ae039);
/**
 * 判断值是否为 null
 * @return 是否为 null
 */ function $f9c1bfa6541077a0$export$2e2bcd8739ae039(value) {
    return value === null;
}

});



parcelRegister("4YlCQ", function(module, exports) {

$parcel$export(module.exports, "d3Ticks", () => $39ed8a6b99a529b7$export$954a2d1bba6aa9e5);

var $a0oMV = parcelRequire("a0oMV");
const $39ed8a6b99a529b7$export$954a2d1bba6aa9e5 = (begin, end, count)=>{
    let n;
    let ticks;
    let start = begin;
    let stop = end;
    if (start === stop && count > 0) return [
        start
    ];
    let step = (0, $a0oMV.tickIncrement)(start, stop, count);
    if (step === 0 || !Number.isFinite(step)) return [];
    if (step > 0) {
        start = Math.ceil(start / step);
        stop = Math.floor(stop / step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        for(let i = 0; i < n; i += 1)ticks[i] = (start + i) * step;
    } else {
        step = -step;
        start = Math.ceil(start * step);
        stop = Math.floor(stop * step);
        ticks = new Array(n = Math.ceil(stop - start + 1));
        for(let i = 0; i < n; i += 1)ticks[i] = (start + i) / step;
    }
    return ticks;
};

});


parcelRegister("h0O6x", function(module, exports) {

$parcel$export(module.exports, "Columns", () => $c6294d705a1e8197$export$f02cc02ad0e0bba3);

var $7WQrb = parcelRequire("7WQrb");

var $iE4so = parcelRequire("iE4so");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $6LvUc = parcelRequire("6LvUc");
var $bCy7Q = parcelRequire("bCy7Q");
var $c6294d705a1e8197$export$f02cc02ad0e0bba3 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Columns, _super);
    function Columns(_a) {
        var _this = this;
        var style = _a.style, rest = (0, $7WQrb.__rest)(_a, [
            "style"
        ]);
        _this = _super.call(this, (0, $iE4so.default)({}, {
            type: 'column'
        }, (0, $7WQrb.__assign)({
            style: style
        }, rest))) || this;
        _this.columnsGroup = new (0, $2eDEB.Group)({
            name: 'columns'
        });
        _this.appendChild(_this.columnsGroup);
        _this.render();
        return _this;
    }
    Columns.prototype.render = function() {
        var _a = this.attributes, columns = _a.columns, x = _a.x, y = _a.y;
        this.columnsGroup.style.transform = "translate(".concat(x, ", ").concat(y, ")");
        (0, $bCy7Q.select)(this.columnsGroup).selectAll('.column').data(columns.flat()).join(function(enter) {
            return enter.append('rect').attr('className', 'column').each(function(style) {
                this.attr(style);
            });
        }, function(update) {
            return update.each(function(style) {
                this.attr(style);
            });
        }, function(exit) {
            return exit.remove();
        });
    };
    Columns.prototype.update = function(attr) {
        this.attr((0, $6LvUc.deepAssign)({}, this.attributes, attr));
        this.render();
    };
    Columns.prototype.clear = function() {
        this.removeChildren();
    };
    return Columns;
}((0, $2eDEB.DisplayObject));

});

parcelRegister("4Hc63", function(module, exports) {

$parcel$export(module.exports, "Lines", () => $36b48fb642b23d80$export$36e96f90176c65bc);

var $7WQrb = parcelRequire("7WQrb");

var $iE4so = parcelRequire("iE4so");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $6LvUc = parcelRequire("6LvUc");
var $bCy7Q = parcelRequire("bCy7Q");
var $36b48fb642b23d80$export$36e96f90176c65bc = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Lines, _super);
    function Lines(_a) {
        var _this = this;
        var style = _a.style, rest = (0, $7WQrb.__rest)(_a, [
            "style"
        ]);
        _this = _super.call(this, (0, $iE4so.default)({}, {
            type: 'lines'
        }, (0, $7WQrb.__assign)({
            style: style
        }, rest))) || this;
        _this.linesGroup = _this.appendChild(new (0, $2eDEB.Group)());
        _this.areasGroup = _this.appendChild(new (0, $2eDEB.Group)());
        _this.render();
        return _this;
    }
    Lines.prototype.render = function() {
        var _a = this.attributes, lines = _a.lines, areas = _a.areas, x = _a.x, y = _a.y;
        this.style.transform = "translate(".concat(x, ", ").concat(y, ")");
        if (lines) this.renderLines(lines);
        if (areas) this.renderAreas(areas);
    };
    Lines.prototype.clear = function() {
        this.linesGroup.removeChildren();
        this.areasGroup.removeChildren();
    };
    Lines.prototype.update = function(attr) {
        this.attr((0, $6LvUc.deepAssign)({}, this.attributes, attr));
        this.render();
    };
    Lines.prototype.renderLines = function(lines) {
        (0, $bCy7Q.select)(this.linesGroup).selectAll('.line').data(lines).join(function(enter) {
            return enter.append('path').attr('className', 'line').each(function(style) {
                this.attr(style);
            });
        }, function(update) {
            return update.each(function(style) {
                this.attr(style);
            });
        }, function(exit) {
            return exit.remove();
        });
    };
    Lines.prototype.renderAreas = function(areas) {
        (0, $bCy7Q.select)(this.linesGroup).selectAll('.area').data(areas).join(function(enter) {
            return enter.append('path').attr('className', 'area').each(function(style) {
                this.attr(style);
            });
        }, function(update) {
            return update.each(function(style) {
                this.style(style);
            });
        }, function(exit) {
            return exit.remove();
        });
    };
    return Lines;
}((0, $2eDEB.DisplayObject));

});

parcelRegister("7Mulo", function(module, exports) {

$parcel$export(module.exports, "dataToLines", () => $5aa48dcdd518865b$export$e64c81e9efbf6522);
$parcel$export(module.exports, "lineToLinePath", () => $5aa48dcdd518865b$export$abbddfd5c8dd7756);
$parcel$export(module.exports, "lineToCurvePath", () => $5aa48dcdd518865b$export$9421dafcce3089d2);
$parcel$export(module.exports, "linesToAreaPaths", () => $5aa48dcdd518865b$export$fc72bf14db34ac3f);
$parcel$export(module.exports, "linesToStackAreaPaths", () => $5aa48dcdd518865b$export$a945a02624e734b6);
$parcel$export(module.exports, "linesToStackCurveAreaPaths", () => $5aa48dcdd518865b$export$6da782d3e6103aac);

var $7WQrb = parcelRequire("7WQrb");

var $8hhuV = parcelRequire("8hhuV");
var $iGRaJ = parcelRequire("iGRaJ");
var $4ETMA = parcelRequire("4ETMA");

var $99EnD = parcelRequire("99EnD");
function $5aa48dcdd518865b$export$e64c81e9efbf6522(data, scales) {
    var _a;
    var x = scales.x, y = scales.y;
    var _b = (0, $7WQrb.__read)(y.getOptions().range || [
        0,
        0
    ], 2), max = _b[0], min = _b[1];
    if (min > max) _a = (0, $7WQrb.__read)([
        max,
        min
    ], 2), min = _a[0], max = _a[1];
    return data.map(function(points) {
        var lines = points.map(function(val, idx) {
            return [
                x.map(idx),
                (0, $8hhuV.default)(y.map(val), min, max)
            ];
        });
        return lines;
    });
}
function $5aa48dcdd518865b$export$abbddfd5c8dd7756(line, reverse) {
    if (reverse === void 0) reverse = false;
    var M = reverse ? line.length - 1 : 0;
    var linePath = line.map(function(point, idx) {
        return (0, $7WQrb.__spreadArray)([
            idx === M ? 'M' : 'L'
        ], (0, $7WQrb.__read)(point), false);
    });
    return reverse ? linePath.reverse() : linePath;
}
function $5aa48dcdd518865b$export$9421dafcce3089d2(line, reverse) {
    if (reverse === void 0) reverse = false;
    if (line.length <= 2) return $5aa48dcdd518865b$export$abbddfd5c8dd7756(line);
    var data = [];
    var len = line.length;
    for(var idx = 0; idx < len; idx += 1){
        var point = reverse ? line[len - idx - 1] : line[idx];
        if (!(0, $4ETMA.default)(point, data.slice(-2))) data.push.apply(data, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(point), false));
    }
    var path = (0, $99EnD.catmullRom2Bezier)(data, false);
    if (reverse) path.unshift((0, $7WQrb.__spreadArray)([
        'M'
    ], (0, $7WQrb.__read)(line[len - 1]), false));
    else path.unshift((0, $7WQrb.__spreadArray)([
        'M'
    ], (0, $7WQrb.__read)(line[0]), false));
    return path;
}
function $5aa48dcdd518865b$export$77f07635b1e9db81(path, width, baseline) {
    var closedPath = (0, $iGRaJ.default)(path);
    closedPath.push([
        'L',
        width,
        baseline
    ], [
        'L',
        0,
        baseline
    ], [
        'Z'
    ]);
    return closedPath;
}
function $5aa48dcdd518865b$export$fc72bf14db34ac3f(lines, smooth, width, baseline) {
    return lines.map(function(line) {
        return $5aa48dcdd518865b$export$77f07635b1e9db81(smooth ? $5aa48dcdd518865b$export$9421dafcce3089d2(line) : $5aa48dcdd518865b$export$abbddfd5c8dd7756(line), width, baseline);
    });
}
function $5aa48dcdd518865b$export$a945a02624e734b6(lines, width, baseline) {
    var paths = [];
    for(var idx = lines.length - 1; idx >= 0; idx -= 1){
        var currLine = lines[idx];
        var currCurvePath = $5aa48dcdd518865b$export$abbddfd5c8dd7756(currLine);
        var path = void 0;
        if (idx === 0) // 最底部的线直接与y=0连接成闭合区域
        path = $5aa48dcdd518865b$export$77f07635b1e9db81(currCurvePath, width, baseline);
        else {
            // 计算下一根曲线的反向路径
            var belowLine = lines[idx - 1];
            var belowCurvePath = $5aa48dcdd518865b$export$abbddfd5c8dd7756(belowLine, true);
            belowCurvePath[0][0] = 'L';
            // 连接路径
            path = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(currCurvePath), false), (0, $7WQrb.__read)(belowCurvePath), false), [
                [
                    'Z'
                ]
            ], false);
        }
        paths.push(path);
    }
    return paths;
}
function $5aa48dcdd518865b$export$6da782d3e6103aac(lines, width, baseline) {
    var paths = [];
    for(var idx = lines.length - 1; idx >= 0; idx -= 1){
        var currLine = lines[idx];
        var currCurvePath = $5aa48dcdd518865b$export$9421dafcce3089d2(currLine);
        var path = void 0;
        if (idx === 0) // 最底部的线直接与y=0连接成闭合区域
        path = $5aa48dcdd518865b$export$77f07635b1e9db81(currCurvePath, width, baseline);
        else {
            // 计算下一根曲线的反向路径
            var belowLine = lines[idx - 1];
            var belowCurvePath = $5aa48dcdd518865b$export$9421dafcce3089d2(belowLine, true);
            /**
             * 将线条连接成闭合路径
             *  M C C C C C
             *  A ～ -> ～ B
             *  ⬆        ⬇
             *  D ～ <- ～ C
             *  C C C C C M
             *
             */ var A = currLine[0];
            // const B = currLine[currLine.length - 1];
            // const C = belowLine[belowLine.length - 1];
            // const D = belowLine[0];
            // 将反向曲线开头 M X Y 改为 L X Y
            belowCurvePath[0][0] = 'L';
            // 连接路径
            path = (0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)((0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(currCurvePath), false), (0, $7WQrb.__read)(belowCurvePath), false), [
                (0, $7WQrb.__spreadArray)([
                    'M'
                ], (0, $7WQrb.__read)(A), false),
                [
                    'Z'
                ]
            ], false);
        }
        paths.push(path);
    }
    return paths;
}

});
parcelRegister("99EnD", function(module, exports) {

$parcel$export(module.exports, "catmullRom2Bezier", () => $6aa446f9e1c4f4de$export$a0228848244ce699);

var $7WQrb = parcelRequire("7WQrb");

var $8jlEv = parcelRequire("8jlEv");
function $6aa446f9e1c4f4de$var$smoothBezier(points, smooth, isLoop, constraint) {
    var _a;
    var cps = [];
    var hasConstraint = !!constraint;
    var prevPoint;
    var nextPoint;
    var min = [
        Infinity,
        Infinity
    ];
    var max = [
        -Infinity,
        -Infinity
    ];
    var nextCp0;
    var cp1;
    var cp0;
    if (hasConstraint) {
        _a = (0, $7WQrb.__read)(constraint, 2), min = _a[0], max = _a[1];
        for(var i = 0, l = points.length; i < l; i += 1){
            var point = points[i];
            min = (0, $8jlEv.min)(min, point);
            max = (0, $8jlEv.max)(max, point);
        }
    }
    for(var i = 0, len = points.length; i < len; i += 1){
        var point = points[i];
        if (i === 0 && !isLoop) cp0 = point;
        else if (i === len - 1 && !isLoop) {
            cp1 = point;
            cps.push(cp0);
            cps.push(cp1);
        } else {
            var prevIdx = [
                i ? i - 1 : len - 1,
                i - 1
            ][isLoop ? 0 : 1];
            prevPoint = points[prevIdx];
            nextPoint = points[isLoop ? (i + 1) % len : i + 1];
            var v = [
                0,
                0
            ];
            v = (0, $8jlEv.sub)(nextPoint, prevPoint);
            v = (0, $8jlEv.scale)(v, smooth);
            var d0 = (0, $8jlEv.distance)(point, prevPoint);
            var d1 = (0, $8jlEv.distance)(point, nextPoint);
            var sum = d0 + d1;
            if (sum !== 0) {
                d0 /= sum;
                d1 /= sum;
            }
            var v1 = (0, $8jlEv.scale)(v, -d0);
            var v2 = (0, $8jlEv.scale)(v, d1);
            cp1 = (0, $8jlEv.add)(point, v1);
            nextCp0 = (0, $8jlEv.add)(point, v2);
            // 下一个控制点必须在这个点和下一个点之间
            nextCp0 = (0, $8jlEv.min)(nextCp0, (0, $8jlEv.max)(nextPoint, point));
            nextCp0 = (0, $8jlEv.max)(nextCp0, (0, $8jlEv.min)(nextPoint, point));
            // 重新计算 cp1 的值
            v1 = (0, $8jlEv.sub)(nextCp0, point);
            v1 = (0, $8jlEv.scale)(v1, -d0 / d1);
            cp1 = (0, $8jlEv.add)(point, v1);
            // 上一个控制点必须要在上一个点和这一个点之间
            cp1 = (0, $8jlEv.min)(cp1, (0, $8jlEv.max)(prevPoint, point));
            cp1 = (0, $8jlEv.max)(cp1, (0, $8jlEv.min)(prevPoint, point));
            // 重新计算 nextCp0 的值
            v2 = (0, $8jlEv.sub)(point, cp1);
            v2 = (0, $8jlEv.scale)(v2, d1 / d0);
            nextCp0 = (0, $8jlEv.add)(point, v2);
            if (hasConstraint) {
                cp1 = (0, $8jlEv.max)(cp1, min);
                cp1 = (0, $8jlEv.min)(cp1, max);
                nextCp0 = (0, $8jlEv.max)(nextCp0, min);
                nextCp0 = (0, $8jlEv.min)(nextCp0, max);
            }
            cps.push(cp0);
            cps.push(cp1);
            cp0 = nextCp0;
        }
    }
    if (isLoop) cps.push(cps.shift());
    return cps;
}
function $6aa446f9e1c4f4de$export$a0228848244ce699(crp, z, constraint) {
    var _a;
    if (z === void 0) z = false;
    if (constraint === void 0) constraint = [
        [
            0,
            0
        ],
        [
            1,
            1
        ]
    ];
    var isLoop = !!z;
    var pointList = [];
    for(var i = 0, l = crp.length; i < l; i += 2)pointList.push([
        crp[i],
        crp[i + 1]
    ]);
    var controlPointList = $6aa446f9e1c4f4de$var$smoothBezier(pointList, 0.4, isLoop, constraint);
    var len = pointList.length;
    var d1 = [];
    var cp1;
    var cp2;
    var p;
    for(var i = 0; i < len - 1; i += 1){
        cp1 = controlPointList[i * 2];
        cp2 = controlPointList[i * 2 + 1];
        p = pointList[i + 1];
        d1.push([
            'C',
            cp1[0],
            cp1[1],
            cp2[0],
            cp2[1],
            p[0],
            p[1]
        ]);
    }
    if (isLoop) {
        cp1 = controlPointList[len];
        cp2 = controlPointList[len + 1];
        _a = (0, $7WQrb.__read)(pointList, 1), p = _a[0];
        d1.push([
            'C',
            cp1[0],
            cp1[1],
            cp2[0],
            cp2[1],
            p[0],
            p[1]
        ]);
    }
    return d1;
}

});


parcelRegister("iU7nv", function(module, exports) {

$parcel$export(module.exports, "getRange", () => $dc332e1f02cad007$export$fef151b94550e9f5);
$parcel$export(module.exports, "getStackedData", () => $dc332e1f02cad007$export$c2170542cfc0177c);

var $7WQrb = parcelRequire("7WQrb");

var $iGRaJ = parcelRequire("iGRaJ");
var $bFgqX = parcelRequire("bFgqX");
var $1opJu = parcelRequire("1opJu");
var $04Wz9 = parcelRequire("04Wz9");
var $jL3iK = parcelRequire("jL3iK");
function $dc332e1f02cad007$export$fef151b94550e9f5(data) {
    if (data.length === 0) return [
        0,
        0
    ];
    return [
        (0, $04Wz9.default)((0, $jL3iK.default)(data, function(arr) {
            return (0, $04Wz9.default)(arr) || 0;
        })),
        (0, $bFgqX.default)((0, $1opJu.default)(data, function(arr) {
            return (0, $bFgqX.default)(arr) || 0;
        }))
    ];
}
function $dc332e1f02cad007$export$c2170542cfc0177c(_) {
    var data = (0, $iGRaJ.default)(_);
    // 生成堆叠数据
    var datumLen = data[0].length;
    // 上一个堆叠的数据值，分别记录正负
    var _a = (0, $7WQrb.__read)([
        Array(datumLen).fill(0),
        Array(datumLen).fill(0)
    ], 2), positivePrev = _a[0], negativePrev = _a[1];
    for(var i = 0; i < data.length; i += 1){
        var datum = data[i];
        for(var j = 0; j < datumLen; j += 1)if (datum[j] >= 0) {
            datum[j] += positivePrev[j];
            positivePrev[j] = datum[j];
        } else {
            datum[j] += negativePrev[j];
            negativePrev[j] = datum[j];
        }
    }
    return data;
}

});
parcelRegister("1opJu", function(module, exports) {

$parcel$export(module.exports, "default", () => $103bfe5337be4c43$export$2e2bcd8739ae039);

var $1uF5a = parcelRequire("1uF5a");

var $ky7aH = parcelRequire("ky7aH");
var /**
 * @param {Array} arr The array to iterate over.
 * @param {Function} [fn] The iteratee invoked per element.
 * @return {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * maxBy(objects, 'n');
 * // => { 'n': 2 }
 */ $103bfe5337be4c43$export$2e2bcd8739ae039 = function(arr, fn) {
    if (!(0, $1uF5a.default)(arr)) return undefined;
    var maxItem;
    var max = -Infinity;
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        var v = (0, $ky7aH.default)(fn) ? fn(item) : item[fn];
        if (v > max) {
            maxItem = item;
            max = v;
        }
    }
    return maxItem;
};

});

parcelRegister("jL3iK", function(module, exports) {

$parcel$export(module.exports, "default", () => $e624f7b28ed82283$export$2e2bcd8739ae039);

var $1uF5a = parcelRequire("1uF5a");

var $ky7aH = parcelRequire("ky7aH");
var /**
 * @param {Array} arr The array to iterate over.
 * @param {Function} [fn] The iteratee invoked per element.
 * @return {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * minBy(objects, 'n');
 * // => { 'n': 1 }
 */ $e624f7b28ed82283$export$2e2bcd8739ae039 = function(arr, fn) {
    if (!(0, $1uF5a.default)(arr)) return undefined;
    var minItem;
    var min = Infinity;
    for(var i = 0; i < arr.length; i++){
        var item = arr[i];
        var v = (0, $ky7aH.default)(fn) ? fn(item) : item[fn];
        if (v < min) {
            minItem = item;
            min = v;
        }
    }
    return minItem;
};

});



parcelRegister("3INFv", function(module, exports) {

$parcel$export(module.exports, "HANDLE_ICON_DEFAULT_CFG", () => $2b5c0241b536f385$export$871cebda41b1cad0);
$parcel$export(module.exports, "HANDLE_LABEL_DEFAULT_CFG", () => $2b5c0241b536f385$export$93ff0baa2ec4faf2);
$parcel$export(module.exports, "HANDLE_DEFAULT_CFG", () => $2b5c0241b536f385$export$b6622ca14247f486);
$parcel$export(module.exports, "CLASS_NAMES", () => $2b5c0241b536f385$export$1ba50affd1ee3341);

var $1SiGY = parcelRequire("1SiGY");
var $2b5c0241b536f385$export$871cebda41b1cad0 = {
    fill: '#fff',
    lineWidth: 1,
    radius: 2,
    size: 10,
    stroke: '#bfbfbf',
    strokeOpacity: 1,
    zIndex: 0
};
var $2b5c0241b536f385$export$93ff0baa2ec4faf2 = {
    fill: '#000',
    fillOpacity: 0.45,
    fontSize: 12,
    textAlign: 'center',
    textBaseline: 'middle',
    zIndex: 1
};
var $2b5c0241b536f385$export$b6622ca14247f486 = {
    x: 0,
    y: 0,
    orientation: 'horizontal',
    showLabel: true,
    type: 'start'
};
var $2b5c0241b536f385$export$1ba50affd1ee3341 = (0, $1SiGY.classNames)({
    foreground: 'foreground',
    handle: 'handle',
    selection: 'selection',
    sparkline: 'sparkline',
    sparklineGroup: 'sparkline-group',
    track: 'track',
    brushArea: 'brush-area'
}, 'slider');

});

parcelRegister("lkPq8", function(module, exports) {

$parcel$export(module.exports, "Handle", () => $f8835a45fa122a36$export$94890c79f4cae6d6);

var $7WQrb = parcelRequire("7WQrb");

var $e7n3C = parcelRequire("e7n3C");

var $1SiGY = parcelRequire("1SiGY");
var $aJozt = parcelRequire("aJozt");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $3INFv = parcelRequire("3INFv");
var $f8835a45fa122a36$var$CLASS_NAMES = (0, $1SiGY.classNames)({
    labelGroup: 'label-group',
    label: 'label',
    iconGroup: 'icon-group',
    icon: 'icon',
    iconRect: 'icon-rect',
    iconLine: 'icon-line'
}, 'handle');
var $f8835a45fa122a36$var$HandleIcon = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(HandleIcon, _super);
    function HandleIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HandleIcon.prototype.render = function(attributes, container) {
        var x = attributes.x, y = attributes.y, _a = attributes.size, size = _a === void 0 ? 10 : _a, _b = attributes.radius, radius = _b === void 0 ? size / 4 : _b, orientation = attributes.orientation, classNamePrefix = attributes.classNamePrefix, iconStyle = (0, $7WQrb.__rest)(attributes, [
            "x",
            "y",
            "size",
            "radius",
            "orientation",
            "classNamePrefix"
        ]);
        // default handle
        var width = size;
        var height = width * 2.4;
        var rectClassName = classNamePrefix ? "".concat($f8835a45fa122a36$var$CLASS_NAMES.iconRect.name, " ").concat(classNamePrefix, "handle-icon-rect") : $f8835a45fa122a36$var$CLASS_NAMES.iconRect.name;
        var lineClassName = function(index) {
            return classNamePrefix ? "".concat($f8835a45fa122a36$var$CLASS_NAMES.iconLine, "-").concat(index, " ").concat(classNamePrefix, "handle-icon-line") : "".concat($f8835a45fa122a36$var$CLASS_NAMES.iconLine, "-").concat(index);
        };
        var rect = (0, $bCy7Q.select)(container).maybeAppendByClassName($f8835a45fa122a36$var$CLASS_NAMES.iconRect, 'rect').attr('className', rectClassName).styles((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, iconStyle), {
            width: width,
            height: height,
            radius: radius,
            x: x - width / 2,
            y: y - height / 2,
            transformOrigin: 'center'
        }));
        var x1 = x + 1 / 3 * width - width / 2;
        var x2 = x + 2 / 3 * width - width / 2;
        var y1 = y + 1 / 4 * height - height / 2;
        var y2 = y + 3 / 4 * height - height / 2;
        rect.maybeAppendByClassName("".concat($f8835a45fa122a36$var$CLASS_NAMES.iconLine, "-1"), 'line').attr('className', lineClassName(1)).styles((0, $7WQrb.__assign)({
            x1: x1,
            x2: x1,
            y1: y1,
            y2: y2
        }, iconStyle));
        rect.maybeAppendByClassName("".concat($f8835a45fa122a36$var$CLASS_NAMES.iconLine, "-2"), 'line').attr('className', lineClassName(2)).styles((0, $7WQrb.__assign)({
            x1: x2,
            x2: x2,
            y1: y1,
            y2: y2
        }, iconStyle));
        if (orientation === 'vertical') rect.node().style.transform = 'rotate(90)';
    };
    return HandleIcon;
}((0, $e7n3C.Component));
var $f8835a45fa122a36$export$94890c79f4cae6d6 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Handle, _super);
    function Handle(options) {
        return _super.call(this, options, (0, $3INFv.HANDLE_DEFAULT_CFG)) || this;
    }
    Handle.prototype.renderLabel = function(container) {
        var _this = this;
        var _a = this.attributes, x = _a.x, y = _a.y, showLabel = _a.showLabel;
        var _b = (0, $8UxPj.subStyleProps)(this.attributes, 'label'), _c = _b.x, labelX = _c === void 0 ? 0 : _c, _d = _b.y, labelY = _d === void 0 ? 0 : _d, transform = _b.transform, transformOrigin = _b.transformOrigin, style = (0, $7WQrb.__rest)(_b, [
            "x",
            "y",
            "transform",
            "transformOrigin"
        ]);
        var _e = (0, $7WQrb.__read)((0, $8UxPj.splitStyle)(style, []), 2), labelStyle = _e[0], groupStyle = _e[1];
        var labelGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName($f8835a45fa122a36$var$CLASS_NAMES.labelGroup, 'g').styles(groupStyle);
        // @ts-ignore
        var _f = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, (0, $3INFv.HANDLE_LABEL_DEFAULT_CFG)), labelStyle), text = _f.text, rest = (0, $7WQrb.__rest)(_f, [
            "text"
        ]);
        (0, $aJozt.ifShow)(!!showLabel, labelGroup, function(group) {
            _this.label = group.maybeAppendByClassName($f8835a45fa122a36$var$CLASS_NAMES.label, 'text').styles((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, rest), {
                x: x + labelX,
                y: y + labelY,
                transform: transform,
                transformOrigin: transformOrigin,
                text: "".concat(text)
            }));
            /** avoid trigger event on label */ _this.label.on('mousedown', function(e) {
                e.stopPropagation();
            });
            _this.label.on('touchstart', function(e) {
                e.stopPropagation();
            });
        });
    };
    Handle.prototype.renderIcon = function(container) {
        var _a = this.attributes, x = _a.x, y = _a.y, orientation = _a.orientation, type = _a.type, classNamePrefix = _a.classNamePrefix;
        var iconStyle = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({
            x: x,
            y: y,
            orientation: orientation,
            classNamePrefix: classNamePrefix
        }, (0, $3INFv.HANDLE_ICON_DEFAULT_CFG)), (0, $8UxPj.subStyleProps)(this.attributes, 'icon'));
        var _b = this.attributes.iconShape, iconShape = _b === void 0 ? function() {
            return new $f8835a45fa122a36$var$HandleIcon({
                style: iconStyle
            });
        } : _b;
        var iconGroup = (0, $bCy7Q.select)(container).maybeAppendByClassName($f8835a45fa122a36$var$CLASS_NAMES.iconGroup, 'g');
        iconGroup.selectAll($f8835a45fa122a36$var$CLASS_NAMES.icon.class).data([
            iconShape
        ]).join(function(enter) {
            return enter.append(typeof iconShape === 'string' ? iconShape : function() {
                return iconShape(type);
            }).attr('className', $f8835a45fa122a36$var$CLASS_NAMES.icon.name);
        }, function(update) {
            return update.update(iconStyle);
        }, function(exit) {
            return exit.remove();
        });
    };
    Handle.prototype.render = function(attributes, container) {
        this.renderIcon(container);
        this.renderLabel(container);
    };
    return Handle;
}((0, $e7n3C.Component));

});


parcelRegister("aHmUQ", function(module, exports) {

$parcel$export(module.exports, "Controller", () => $7c9fb227694751ae$export$bd0bf19f25da8474);

var $7WQrb = parcelRequire("7WQrb");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $6LvUc = parcelRequire("6LvUc");
var $le54I = parcelRequire("le54I");
var $8UxPj = parcelRequire("8UxPj");

var $4vlXW = parcelRequire("4vlXW");
var $7c9fb227694751ae$var$componentsMap = {
    reset: (0, $4vlXW.Reset),
    speed: (0, $4vlXW.SpeedSelect),
    backward: (0, $4vlXW.Backward),
    playPause: (0, $4vlXW.PlayPause),
    forward: (0, $4vlXW.Forward),
    selectionType: (0, $4vlXW.SelectionType),
    chartType: (0, $4vlXW.ChartType),
    split: (0, $4vlXW.Split)
};
var $7c9fb227694751ae$export$bd0bf19f25da8474 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Controller, _super);
    function Controller(options) {
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, Controller.defaultOptions, options)) || this;
        _this.background = _this.appendChild(new (0, $2eDEB.Rect)({}));
        _this.functions = _this.appendChild(new (0, $2eDEB.Group)({}));
        return _this;
    }
    Object.defineProperty(Controller.prototype, "padding", {
        get: function() {
            return (0, $le54I.parseSeriesAttr)(this.attributes.padding);
        },
        enumerable: false,
        configurable: true
    });
    Controller.prototype.renderBackground = function() {
        var _a = this.style, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var backgroundStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'background');
        this.background.attr((0, $7WQrb.__assign)({
            x: x,
            y: y,
            width: width,
            height: height
        }, backgroundStyle));
    };
    Controller.prototype.renderFunctions = function() {
        var _this = this;
        var _a;
        var _b = this.attributes, functions = _b.functions, iconSize = _b.iconSize, iconSpacing = _b.iconSpacing, x = _b.x, y = _b.y, width = _b.width, height = _b.height, align = _b.align;
        var _c = (0, $7WQrb.__read)(this.padding, 4), right = _c[1], left = _c[3];
        var components = functions.reduce(function(prev, curr) {
            if (prev.length && curr.length) return prev.concat.apply(prev, (0, $7WQrb.__spreadArray)([
                'split'
            ], (0, $7WQrb.__read)(curr), false));
            return prev.concat.apply(prev, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(curr), false));
        }, []);
        var componentsWidth = components.length * (iconSize + iconSpacing) - iconSpacing;
        var xOffset = {
            left: left + iconSize / 2,
            center: (width - componentsWidth) / 2 + iconSize / 2,
            right: width - componentsWidth - left - right + iconSize / 2
        }[align] || 0;
        (_a = this.speedSelect) === null || _a === void 0 || _a.destroy();
        this.functions.removeChildren();
        components.forEach(function(name, index) {
            var _a;
            var Ctor = $7c9fb227694751ae$var$componentsMap[name];
            var style = {
                x: x + index * (iconSize + iconSpacing) + xOffset,
                y: y + height / 2,
                size: iconSize
            };
            if (Ctor === (0, $4vlXW.SpeedSelect)) {
                style.speed = _this.attributes.speed;
                style.onSelect = function(value) {
                    return _this.handleFunctionChange(name, {
                        value: value
                    });
                };
            } else if ([
                (0, $4vlXW.PlayPause),
                (0, $4vlXW.SelectionType),
                (0, $4vlXW.ChartType)
            ].includes(Ctor)) {
                style.onChange = function(value) {
                    return _this.handleFunctionChange(name, {
                        value: value
                    });
                };
                if (Ctor === (0, $4vlXW.PlayPause)) style.type = _this.attributes.state === 'play' ? 'pause' : 'play';
                if (Ctor === (0, $4vlXW.SelectionType)) style.type = _this.attributes.selectionType === 'range' ? 'value' : 'range';
                if (Ctor === (0, $4vlXW.ChartType)) style.type = _this.attributes.chartType === 'line' ? 'column' : 'line';
            } else // IconBase
            style.onClick = function() {
                return _this.handleFunctionChange(name, {
                    value: name
                });
            };
            if (Ctor === (0, $4vlXW.SpeedSelect)) {
                // SpeedSelect 直接插入到 canvas
                var canvas = (_a = _this.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
                if (canvas) {
                    _this.speedSelect = new Ctor({
                        style: (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, style), {
                            zIndex: 100
                        })
                    });
                    canvas.appendChild(_this.speedSelect);
                }
            } else _this.functions.appendChild(new Ctor({
                style: style
            }));
        });
    };
    Controller.prototype.disconnectedCallback = function() {
        var _a;
        _super.prototype.disconnectedCallback.call(this);
        (_a = this.speedSelect) === null || _a === void 0 || _a.destroy();
    };
    Controller.prototype.render = function() {
        this.renderBackground();
        this.renderFunctions();
    };
    Controller.prototype.handleFunctionChange = function(name, value) {
        var onChange = this.attributes.onChange;
        onChange === null || onChange === void 0 || onChange(name, value);
    };
    Controller.defaultOptions = {
        style: {
            x: 0,
            y: 0,
            width: 300,
            height: 40,
            padding: 0,
            align: 'center',
            iconSize: 25,
            iconSpacing: 0,
            speed: 1,
            state: 'pause',
            chartType: 'line',
            selectionType: 'range',
            backgroundFill: '#fbfdff',
            backgroundStroke: '#ebedf0',
            functions: [
                [
                    'reset',
                    'speed'
                ],
                [
                    'backward',
                    'playPause',
                    'forward'
                ],
                [
                    'selectionType',
                    'chartType'
                ]
            ]
        }
    };
    return Controller;
}((0, $e7n3C.Component));

});
parcelRegister("4vlXW", function(module, exports) {

$parcel$export(module.exports, "Reset", () => $347b18a5125cb83b$export$fcc683c36751f67a);
$parcel$export(module.exports, "Backward", () => $347b18a5125cb83b$export$277588d017c813a);
$parcel$export(module.exports, "Forward", () => $347b18a5125cb83b$export$7724b1686f1f8cff);
$parcel$export(module.exports, "Split", () => $347b18a5125cb83b$export$f836382419f64c98);
$parcel$export(module.exports, "SpeedSelect", () => $347b18a5125cb83b$export$e7a90a3d395c8d4);
$parcel$export(module.exports, "PlayPause", () => $347b18a5125cb83b$export$c73916fe05296ede);
$parcel$export(module.exports, "SelectionType", () => $347b18a5125cb83b$export$46ad9defb55f383d);
$parcel$export(module.exports, "ChartType", () => $347b18a5125cb83b$export$bdfcecc9ce2b3550);

var $7WQrb = parcelRequire("7WQrb");

var $8hhuV = parcelRequire("8hhuV");
var $64w8j = parcelRequire("64w8j");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $6LvUc = parcelRequire("6LvUc");
var $le54I = parcelRequire("le54I");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $b7x6Z = parcelRequire("b7x6Z");

var $kHEGr = parcelRequire("kHEGr");
var $347b18a5125cb83b$export$a188ecdd443fe91a = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(IconBase, _super);
    function IconBase(options) {
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, {
            style: {
                backgroundOpacity: IconBase.backgroundOpacities.default
            }
        }, IconBase.defaultOptions, options)) || this;
        /** hover 时是否显示背景 */ _this.showBackground = true;
        _this.background = _this.appendChild(new (0, $2eDEB.Rect)({}));
        _this.icon = _this.appendChild(new (0, $2eDEB.Group)({}));
        return _this;
    }
    Object.defineProperty(IconBase.prototype, "label", {
        get: function() {
            return 'BaseIcon';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IconBase.prototype, "lineWidth", {
        get: function() {
            return Math.log10(this.attributes.size);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IconBase.prototype, "padding", {
        get: function() {
            return (0, $le54I.parseSeriesAttr)(this.attributes.size / 5);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(IconBase.prototype, "iconSize", {
        get: function() {
            var size = this.attributes.size;
            var _a = (0, $7WQrb.__read)(this.padding, 4), top = _a[0], right = _a[1], bottom = _a[2], left = _a[3];
            return Math.max(size - Math.max(left + right, top + bottom), this.lineWidth * 2 + 1);
        },
        enumerable: false,
        configurable: true
    });
    IconBase.prototype.renderBackground = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, size = _a.size;
        var halfSize = size / 2;
        var backgroundStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'background');
        this.background.attr((0, $7WQrb.__assign)({
            x: x - halfSize,
            y: y - halfSize,
            width: size,
            height: size
        }, backgroundStyle));
    };
    IconBase.prototype.showIndicator = function() {
        if (!this.label) return;
        var size = this.attributes.size;
        var _a = this.background.getBBox(), x = _a.x, y = _a.y;
        this.indicator.update({
            x: x + size / 2,
            y: y - 5,
            labelText: this.label,
            visibility: 'visible'
        });
    };
    IconBase.prototype.hideIndicator = function() {
        this.indicator.update({
            visibility: 'hidden'
        });
    };
    IconBase.prototype.connectedCallback = function() {
        var _a;
        _super.prototype.connectedCallback.call(this);
        // indicator 脱离文档流，需要手动添加到 canvas
        var size = this.attributes.size;
        var _b = this.background.getBBox(), x = _b.x, y = _b.y;
        var canvas = (_a = this.ownerDocument) === null || _a === void 0 ? void 0 : _a.defaultView;
        if (canvas) this.indicator = canvas.appendChild(new (0, $b7x6Z.Indicator)({
            style: {
                x: x + size / 2,
                y: y - size / 2,
                visibility: 'hidden',
                position: 'top',
                radius: 3,
                zIndex: 100
            }
        }));
    };
    IconBase.prototype.disconnectedCallback = function() {
        this.indicator.destroy();
    };
    IconBase.prototype.render = function() {
        this.renderIcon();
        if (this.showBackground) this.renderBackground();
    };
    IconBase.prototype.bindEvents = function() {
        var _this = this;
        var onClick = this.attributes.onClick;
        this.addEventListener('click', function() {
            onClick === null || onClick === void 0 || onClick(_this);
        });
        if (this.showBackground) {
            var resetBackground_1 = function() {
                return _this.background.attr({
                    opacity: IconBase.backgroundOpacities.default
                });
            };
            var hoverBackground_1 = function() {
                return _this.background.attr({
                    opacity: IconBase.backgroundOpacities.hover
                });
            };
            var activeBackground_1 = function() {
                return _this.background.attr({
                    opacity: IconBase.backgroundOpacities.active
                });
            };
            this.addEventListener('pointerenter', function() {
                hoverBackground_1();
                _this.showIndicator();
            });
            this.addEventListener('pointerleave', function() {
                resetBackground_1();
                _this.hideIndicator();
            });
            this.addEventListener('pointerdown', function() {
                activeBackground_1();
            });
            this.addEventListener('pointerup', function() {
                resetBackground_1();
            });
        }
    };
    IconBase.tag = 'IconBase';
    IconBase.defaultOptions = {
        style: {
            x: 0,
            y: 0,
            size: 10,
            color: '#565758',
            backgroundRadius: 4,
            backgroundFill: '#e2e2e2'
        }
    };
    IconBase.backgroundOpacities = {
        default: 0,
        hover: 0.8,
        active: 1
    };
    return IconBase;
}((0, $e7n3C.Component));
var $347b18a5125cb83b$var$arrow = function(size, color) {
    if (color === void 0) color = '#565758';
    return new (0, $2eDEB.Path)({
        style: {
            fill: color,
            d: "M ".concat(size, ",").concat(size, " L -").concat(size, ",0 L ").concat(size, ",-").concat(size, " Z"),
            transformOrigin: 'center'
        }
    });
};
/** 重置 */ var $347b18a5125cb83b$export$fcc683c36751f67a = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Reset, _super);
    function Reset() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Reset.prototype.arcPath = function(cx, cy, radius) {
        var _a = (0, $7WQrb.__read)([
            radius,
            radius
        ], 2), rx = _a[0], ry = _a[1];
        var getPosByAngle = function(angle) {
            return [
                cx + radius * Math.cos(angle),
                cy + radius * Math.sin(angle)
            ];
        };
        var _b = (0, $7WQrb.__read)(getPosByAngle(-5 / 4 * Math.PI), 2), x1 = _b[0], y1 = _b[1];
        var _c = (0, $7WQrb.__read)(getPosByAngle(1 / 4 * Math.PI), 2), x2 = _c[0], y2 = _c[1];
        return "M".concat(x1, ",").concat(y1, ",A").concat(rx, ",").concat(ry, ",0,1,1,").concat(x2, ",").concat(y2);
    };
    Object.defineProperty(Reset.prototype, "label", {
        get: function() {
            return "\u91CD\u7F6E";
        },
        enumerable: false,
        configurable: true
    });
    Reset.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var size = this.iconSize;
        var lineWidth = this.lineWidth;
        var arrowSize = lineWidth + 0.5;
        (0, $bCy7Q.select)(this.icon).maybeAppend('.reset', 'path').styles({
            stroke: color,
            lineWidth: lineWidth,
            d: this.arcPath(x, y, size / 2 - lineWidth),
            markerStart: $347b18a5125cb83b$var$arrow(arrowSize, color)
        });
    };
    return Reset;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
/** 快退 */ var $347b18a5125cb83b$export$277588d017c813a = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Backward, _super);
    function Backward() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Backward.prototype, "label", {
        get: function() {
            return "\u5FEB\u9000";
        },
        enumerable: false,
        configurable: true
    });
    Backward.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var size = this.iconSize;
        var deltaX = size / 2;
        var deltaY = size / 2 / Math.pow(3, 0.5);
        var points = [
            [
                x,
                y
            ],
            [
                x,
                y - deltaY
            ],
            [
                x - deltaX,
                y
            ],
            [
                x,
                y + deltaY
            ],
            [
                x,
                y
            ],
            [
                x + deltaX,
                y - deltaY
            ],
            [
                x + deltaX,
                y + deltaY
            ],
            [
                x,
                y
            ]
        ];
        (0, $bCy7Q.select)(this.icon).maybeAppend('.backward', 'polygon').styles({
            points: points,
            fill: color
        });
    };
    return Backward;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
/** 快进 */ var $347b18a5125cb83b$export$7724b1686f1f8cff = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Forward, _super);
    function Forward() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Forward.prototype, "label", {
        get: function() {
            return "\u5FEB\u8FDB";
        },
        enumerable: false,
        configurable: true
    });
    Forward.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var size = this.iconSize;
        var deltaX = size / 2;
        var deltaY = size / 2 / Math.pow(3, 0.5);
        var points = [
            [
                x,
                y
            ],
            [
                x,
                y - deltaY
            ],
            [
                x + deltaX,
                y
            ],
            [
                x,
                y + deltaY
            ],
            [
                x,
                y
            ],
            [
                x - deltaX,
                y - deltaY
            ],
            [
                x - deltaX,
                y + deltaY
            ],
            [
                x,
                y
            ]
        ];
        (0, $bCy7Q.select)(this.icon).maybeAppend('.forward', 'polygon').styles({
            points: points,
            fill: color
        });
    };
    return Forward;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
var $347b18a5125cb83b$export$480db61f4dcd7727 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Play, _super);
    function Play() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Play.prototype, "label", {
        get: function() {
            return "\u64AD\u653E";
        },
        enumerable: false,
        configurable: true
    });
    Play.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var size = this.iconSize;
        var deltaX = size / 3 * Math.pow(3, 0.5) * 0.8;
        var points = [
            [
                x + deltaX,
                y
            ],
            [
                x - deltaX / 2,
                y - size / 2 * 0.8
            ],
            [
                x - deltaX / 2,
                y + size / 2 * 0.8
            ],
            [
                x + deltaX,
                y
            ]
        ];
        (0, $bCy7Q.select)(this.icon).maybeAppend('.play', 'polygon').styles({
            points: points,
            fill: color
        });
    };
    return Play;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
var $347b18a5125cb83b$export$59704c468e1a1527 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Pause, _super);
    function Pause() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Pause.prototype, "label", {
        get: function() {
            return "\u6682\u505C";
        },
        enumerable: false,
        configurable: true
    });
    Pause.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var size = this.iconSize;
        var deltaX = size / 3;
        var points = [
            [
                x - deltaX,
                y - size / 2
            ],
            [
                x - deltaX,
                y + size / 2
            ],
            [
                x - deltaX / 2,
                y + size / 2
            ],
            [
                x - deltaX / 2,
                y - size / 2
            ],
            [
                x - deltaX,
                y - size / 2
            ],
            [
                x + deltaX / 2,
                y - size / 2
            ],
            [
                x + deltaX / 2,
                y + size / 2
            ],
            [
                x + deltaX,
                y + size / 2
            ],
            [
                x + deltaX,
                y - size / 2
            ]
        ];
        (0, $bCy7Q.select)(this.icon).maybeAppend('.pause', 'polygon').styles({
            points: points,
            fill: color
        });
    };
    return Pause;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
/** 时间范围 */ var $347b18a5125cb83b$export$9a58ef0d7ad3278c = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Range, _super);
    function Range() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Range.prototype, "label", {
        get: function() {
            return "\u8303\u56F4\u65F6\u95F4";
        },
        enumerable: false,
        configurable: true
    });
    Range.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var _b = this, size = _b.iconSize, lineWidth = _b.lineWidth;
        var gap = lineWidth;
        (0, $bCy7Q.select)(this.icon).maybeAppend('.left-line', 'line').styles({
            x1: x - size / 2,
            y1: y - size / 2,
            x2: x - size / 2,
            y2: y + size / 2,
            stroke: color,
            lineWidth: lineWidth
        });
        (0, $bCy7Q.select)(this.icon).maybeAppend('.right-line', 'line').styles({
            x1: x + size / 2,
            y1: y - size / 2,
            x2: x + size / 2,
            y2: y + size / 2,
            stroke: color,
            lineWidth: lineWidth
        });
        (0, $bCy7Q.select)(this.icon).maybeAppend('.left-arrow', 'line').styles({
            x1: x,
            y1: y,
            x2: x - size / 2 + gap * 2,
            y2: y,
            stroke: color,
            lineWidth: lineWidth,
            markerEnd: $347b18a5125cb83b$var$arrow(lineWidth * 2, color)
        });
        (0, $bCy7Q.select)(this.icon).maybeAppend('.right-arrow', 'line').styles({
            x1: x,
            y1: y,
            x2: x + size / 2 - gap * 2,
            y2: y,
            stroke: color,
            lineWidth: lineWidth,
            markerEnd: $347b18a5125cb83b$var$arrow(lineWidth * 2, color)
        });
    };
    return Range;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
/** 值范围 */ var $347b18a5125cb83b$export$4c8d1a57a761ef94 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Value, _super);
    function Value() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Value.prototype, "label", {
        get: function() {
            return "\u5355\u4E00\u65F6\u95F4";
        },
        enumerable: false,
        configurable: true
    });
    Value.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var _b = this, size = _b.iconSize, lineWidth = _b.lineWidth;
        (0, $bCy7Q.select)(this.icon).maybeAppend('.line', 'line').styles({
            x1: x,
            y1: y - size / 2,
            x2: x,
            y2: y + size / 2,
            stroke: color,
            lineWidth: lineWidth
        });
        var gap = lineWidth;
        (0, $bCy7Q.select)(this.icon).maybeAppend('.left-arrow', 'line').styles({
            x1: x - size / 2 - gap * 2,
            y1: y,
            x2: x - gap * 2,
            y2: y,
            stroke: color,
            lineWidth: lineWidth,
            markerEnd: $347b18a5125cb83b$var$arrow(lineWidth * 2, color)
        });
        (0, $bCy7Q.select)(this.icon).maybeAppend('.right-arrow', 'line').styles({
            x1: x + size / 2 + gap * 2,
            y1: y,
            x2: x + gap * 2,
            y2: y,
            stroke: color,
            lineWidth: lineWidth,
            markerEnd: $347b18a5125cb83b$var$arrow(lineWidth * 2, color)
        });
    };
    return Value;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
var $347b18a5125cb83b$var$getCoordinatePoints = function(size) {
    return [
        [
            -size / 2,
            -size / 2
        ],
        [
            -size / 2,
            size / 2
        ],
        [
            size / 2,
            size / 2
        ]
    ];
};
var $347b18a5125cb83b$export$54d0e8420ac838ac = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(LineChart, _super);
    function LineChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(LineChart.prototype, "label", {
        get: function() {
            return "\u6298\u7EBF\u56FE";
        },
        enumerable: false,
        configurable: true
    });
    LineChart.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var _b = this, size = _b.iconSize, lineWidth = _b.lineWidth;
        var gap = lineWidth;
        var deltaX = (size - gap * 2 - lineWidth) / 4;
        var deltaY = (size - gap * 2 - lineWidth) / 2;
        var _c = (0, $7WQrb.__read)([
            x - size / 2 + gap,
            y + size / 2 - gap * 2
        ], 2), ox = _c[0], oy = _c[1];
        (0, $bCy7Q.select)(this.icon).maybeAppend('.coordinate', 'polyline').styles({
            points: $347b18a5125cb83b$var$getCoordinatePoints(size).map(function(_a) {
                var _b = (0, $7WQrb.__read)(_a, 2), px = _b[0], py = _b[1];
                return [
                    px + x,
                    py + y
                ];
            }),
            stroke: color,
            lineWidth: lineWidth
        });
        (0, $bCy7Q.select)(this.icon).maybeAppend('.line', 'polyline').styles({
            points: [
                [
                    ox,
                    oy
                ],
                [
                    ox + deltaX,
                    oy - deltaY
                ],
                [
                    ox + deltaX * 2,
                    oy
                ],
                [
                    ox + deltaX * 4,
                    oy - deltaY * 2
                ]
            ],
            stroke: color,
            lineWidth: lineWidth
        });
    };
    return LineChart;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
var $347b18a5125cb83b$export$94aefc399ef206a9 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(BarChart, _super);
    function BarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BarChart.prototype, "label", {
        get: function() {
            return "\u6761\u5F62\u56FE";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "data", {
        get: function() {
            return [
                1,
                4,
                2,
                4,
                3
            ];
        },
        enumerable: false,
        configurable: true
    });
    BarChart.prototype.renderIcon = function() {
        var data = this.data;
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var _b = this, size = _b.iconSize, lineWidth = _b.lineWidth;
        var gap = lineWidth;
        var deltaX = (size - gap) / data.length;
        var deltaY = (size - gap * 2) / 4;
        var _c = (0, $7WQrb.__read)([
            x - size / 2 + gap * 2,
            y + size / 2 - gap
        ], 2), ox = _c[0], oy = _c[1];
        (0, $bCy7Q.select)(this.icon).maybeAppend('.coordinate', 'polyline').styles({
            points: $347b18a5125cb83b$var$getCoordinatePoints(size).map(function(_a) {
                var _b = (0, $7WQrb.__read)(_a, 2), px = _b[0], py = _b[1];
                return [
                    px + x,
                    py + y
                ];
            }),
            stroke: color,
            lineWidth: lineWidth
        });
        (0, $bCy7Q.select)(this.icon).maybeAppend('.bars', 'g').selectAll('.column').data(this.data.map(function(value, index) {
            return {
                value: value,
                index: index
            };
        })).join(function(enter) {
            return enter.append('line').attr('className', 'column').style('x1', function(_a) {
                var index = _a.index;
                return ox + deltaX * index;
            }).style('y1', oy).style('x2', function(_a) {
                var index = _a.index;
                return ox + deltaX * index;
            }).style('y2', function(_a) {
                var value = _a.value;
                return oy - deltaY * value;
            }).styles({
                y1: oy,
                stroke: color,
                lineWidth: lineWidth
            });
        });
    };
    return BarChart;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
/** 分割线 */ var $347b18a5125cb83b$export$f836382419f64c98 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Split, _super);
    function Split(options) {
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, {
            style: {
                color: '#d8d9d9'
            }
        }, options)) || this;
        _this.showBackground = false;
        return _this;
    }
    Split.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, color = _a.color;
        var _b = this, size = _b.iconSize, lineWidth = _b.lineWidth;
        (0, $bCy7Q.select)(this.icon).maybeAppend('.split', 'line').styles({
            x1: x,
            y1: y - size / 2,
            x2: x,
            y2: y + size / 2,
            stroke: color,
            lineWidth: lineWidth
        });
    };
    return Split;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
var $347b18a5125cb83b$export$e7a90a3d395c8d4 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(SpeedSelect, _super);
    function SpeedSelect() {
        var _this = _super.apply(this, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(arguments), false)) || this;
        _this.showBackground = false;
        return _this;
    }
    Object.defineProperty(SpeedSelect.prototype, "padding", {
        get: function() {
            return (0, $le54I.parseSeriesAttr)(0);
        },
        enumerable: false,
        configurable: true
    });
    SpeedSelect.prototype.renderIcon = function() {
        var iconSize = this.iconSize;
        var _a = this.attributes, x = _a.x, y = _a.y, _b = _a.speed, speed = _b === void 0 ? 1 : _b;
        var inheritStyle = (0, $64w8j.default)(this.attributes, [
            'x',
            'y',
            'transform',
            'transformOrigin',
            'width',
            'height',
            'size',
            'color',
            'speed'
        ]);
        var width = (0, $8hhuV.default)(iconSize, 20, Infinity);
        var height = 20;
        var style = (0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, inheritStyle), {
            x: x - width / 2,
            y: y - height / 2,
            width: width,
            height: height,
            defaultValue: speed,
            bordered: false,
            showDropdownIcon: false,
            selectRadius: 2,
            dropdownPadding: this.padding,
            dropdownRadius: 2,
            dropdownSpacing: iconSize / 5,
            placeholderFontSize: iconSize / 2,
            optionPadding: 0,
            optionLabelFontSize: iconSize / 2,
            optionBackgroundRadius: 1,
            options: [
                {
                    label: '1x',
                    value: 1
                },
                {
                    label: '1.5x',
                    value: 1.5
                },
                {
                    label: '2x',
                    value: 2
                }
            ]
        });
        (0, $bCy7Q.select)(this.icon).maybeAppend('.speed', function() {
            return new (0, $kHEGr.Select)({
                style: style
            });
        }).attr('className', 'speed').each(function() {
            this.update(style);
        });
    };
    SpeedSelect.tag = 'SpeedSelect';
    return SpeedSelect;
}($347b18a5125cb83b$export$a188ecdd443fe91a);
var $347b18a5125cb83b$export$6b23d6a1daba3d74 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(ToggleIcon, _super);
    function ToggleIcon(options) {
        var _this = _super.call(this, options) || this;
        _this.icon = _this.appendChild(new (0, $2eDEB.Group)({}));
        _this.currentType = _this.attributes.type;
        return _this;
    }
    ToggleIcon.prototype.getType = function() {
        return this.currentType;
    };
    ToggleIcon.prototype.render = function() {
        var _this = this;
        var _a = this.attributes, onChange = _a.onChange, restStyles = (0, $7WQrb.__rest)(_a, [
            "onChange"
        ]);
        (0, $bCy7Q.select)(this.icon).selectAll('.icon').data([
            this.currentType
        ]).join(function(enter) {
            return enter.append(function(type) {
                var _a;
                var Ctor = (_a = _this.toggles.find(function(_a) {
                    var _b = (0, $7WQrb.__read)(_a, 1), key = _b[0];
                    return key === type;
                })) === null || _a === void 0 ? void 0 : _a[1];
                if (!Ctor) throw new Error("Invalid type: ".concat(type));
                return new Ctor({});
            }).attr('className', 'icon').styles(restStyles, false).update({});
        }, function(update) {
            return update.styles({
                restStyles: restStyles
            }).update({});
        }, function(exit) {
            return exit.remove();
        });
    };
    ToggleIcon.prototype.bindEvents = function() {
        var _this = this;
        var onChange = this.attributes.onChange;
        this.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            var nextIndex = (_this.toggles.findIndex(function(_a) {
                var _b = (0, $7WQrb.__read)(_a, 1), key = _b[0];
                return key === _this.currentType;
            }) + 1) % _this.toggles.length;
            var nextType = _this.toggles[nextIndex][0];
            onChange === null || onChange === void 0 || onChange(_this.currentType);
            _this.currentType = nextType;
            _this.render();
        });
    };
    ToggleIcon.tag = 'ToggleIcon';
    return ToggleIcon;
}((0, $e7n3C.Component));
var $347b18a5125cb83b$export$c73916fe05296ede = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(PlayPause, _super);
    function PlayPause(options) {
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, {
            style: {
                type: 'play'
            }
        }, options)) || this;
        _this.toggles = [
            [
                'play',
                $347b18a5125cb83b$export$480db61f4dcd7727
            ],
            [
                'pause',
                $347b18a5125cb83b$export$59704c468e1a1527
            ]
        ];
        return _this;
    }
    return PlayPause;
}($347b18a5125cb83b$export$6b23d6a1daba3d74);
var $347b18a5125cb83b$export$46ad9defb55f383d = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(SelectionType, _super);
    function SelectionType(options) {
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, {
            style: {
                type: 'range'
            }
        }, options)) || this;
        _this.toggles = [
            [
                'range',
                $347b18a5125cb83b$export$9a58ef0d7ad3278c
            ],
            [
                'value',
                $347b18a5125cb83b$export$4c8d1a57a761ef94
            ]
        ];
        return _this;
    }
    return SelectionType;
}($347b18a5125cb83b$export$6b23d6a1daba3d74);
var $347b18a5125cb83b$export$bdfcecc9ce2b3550 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(ChartType, _super);
    function ChartType(options) {
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, {
            style: {
                type: 'column'
            }
        }, options)) || this;
        _this.toggles = [
            [
                'line',
                $347b18a5125cb83b$export$54d0e8420ac838ac
            ],
            [
                'column',
                $347b18a5125cb83b$export$94aefc399ef206a9
            ]
        ];
        return _this;
    }
    return ChartType;
}($347b18a5125cb83b$export$6b23d6a1daba3d74);

});
parcelRegister("b7x6Z", function(module, exports) {

$parcel$export(module.exports, "Indicator", () => $818a08780248bb3a$export$adb584737d712b70);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $7agTx = parcelRequire("7agTx");
var $1SiGY = parcelRequire("1SiGY");
var $2gch2 = parcelRequire("2gch2");
var $3tYe7 = parcelRequire("3tYe7");
var $le54I = parcelRequire("le54I");
var $i1HPZ = parcelRequire("i1HPZ");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $gqxWW = parcelRequire("gqxWW");
var $818a08780248bb3a$var$CLASS_NAMES = (0, $1SiGY.classNames)({
    background: 'background',
    labelGroup: 'label-group',
    label: 'label'
}, 'indicator');
var $818a08780248bb3a$export$adb584737d712b70 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Indicator, _super);
    function Indicator(options) {
        var _this = _super.call(this, options, (0, $gqxWW.DEFAULT_INDICATOR_STYLE_PROPS)) || this;
        _this.point = [
            0,
            0
        ];
        _this.group = _this.appendChild(new (0, $2eDEB.Group)({}));
        _this.isMutationObserved = true;
        return _this;
    }
    Indicator.prototype.renderBackground = function() {
        if (!this.label) return;
        var _a = this.attributes, position = _a.position, padding = _a.padding;
        var _b = (0, $7WQrb.__read)((0, $le54I.parseSeriesAttr)(padding), 4), t = _b[0], r = _b[1], b = _b[2], l = _b[3];
        var _c = this.label.node().getLocalBounds(), min = _c.min, max = _c.max;
        var bbox = new (0, $7agTx.BBox)(min[0] - l, min[1] - t, max[0] + r - min[0] + l, max[1] + b - min[1] + t);
        var path = this.getPath(position, bbox);
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'background');
        this.background = (0, $bCy7Q.select)(this.group).maybeAppendByClassName($818a08780248bb3a$var$CLASS_NAMES.background, 'path').styles((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, style), {
            d: path
        }));
        this.group.appendChild(this.label.node());
    };
    Indicator.prototype.renderLabel = function() {
        var _a = this.attributes, formatter = _a.formatter, labelText = _a.labelText;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'label');
        var _b = (0, $7WQrb.__read)((0, $8UxPj.splitStyle)(style), 2), _c = _b[0], groupStyle = _b[1], rawText = _c.text, textStyle = (0, $7WQrb.__rest)(_c, [
            "text"
        ]);
        this.label = (0, $bCy7Q.select)(this.group).maybeAppendByClassName($818a08780248bb3a$var$CLASS_NAMES.labelGroup, 'g').styles(groupStyle);
        if (!labelText) return;
        var text = this.label.maybeAppendByClassName($818a08780248bb3a$var$CLASS_NAMES.label, function() {
            return (0, $i1HPZ.renderExtDo)(formatter(labelText));
        }).style('text', formatter(labelText).toString());
        text.selectAll('text').styles(textStyle);
    };
    Indicator.prototype.adjustLayout = function() {
        var _a = (0, $7WQrb.__read)(this.point, 2), dx = _a[0], dy = _a[1];
        var _b = this.attributes, x = _b.x, y = _b.y;
        this.group.attr('transform', "translate(".concat(x - dx, ", ").concat(y - dy, ")"));
    };
    Indicator.prototype.getPath = function(position, bbox) {
        var r = this.attributes.radius;
        var x = bbox.x, y = bbox.y, width = bbox.width, height = bbox.height;
        var pathArray = [
            // 0 开始路径
            [
                'M',
                x + r,
                y
            ],
            // 1 上边线
            [
                'L',
                x + width - r,
                y
            ],
            // 2 右上角圆弧
            [
                'A',
                r,
                r,
                0,
                0,
                1,
                x + width,
                y + r
            ],
            // 3 右边线
            [
                'L',
                x + width,
                y + height - r
            ],
            // 4 右下角圆弧
            [
                'A',
                r,
                r,
                0,
                0,
                1,
                x + width - r,
                y + height
            ],
            // 5 下边线
            [
                'L',
                x + r,
                y + height
            ],
            // 6 左下角圆弧
            [
                'A',
                r,
                r,
                0,
                0,
                1,
                x,
                y + height - r
            ],
            // 7 左边线
            [
                'L',
                x,
                y + r
            ],
            // 8 左上角圆弧
            [
                'A',
                r,
                r,
                0,
                0,
                1,
                x + r,
                y
            ],
            // 9 关闭路径
            [
                'Z'
            ]
        ];
        // 将 position 反方向的边线替换为带尖角的边线
        var revertPositionMap = {
            top: 4,
            right: 6,
            bottom: 0,
            left: 2
        };
        var index = revertPositionMap[position];
        var newPath = this.createCorner([
            pathArray[index].slice(-2),
            pathArray[index + 1].slice(-2)
        ]);
        // 替换
        pathArray.splice.apply(pathArray, (0, $7WQrb.__spreadArray)([
            index + 1,
            1
        ], (0, $7WQrb.__read)(newPath), false));
        pathArray[0][0] = 'M';
        return pathArray;
    };
    Indicator.prototype.createCorner = function(edge, size) {
        if (size === void 0) size = 10;
        // intrinsic parameter
        var cornerScale = 0.8;
        var isH = (0, $3tYe7.isHorizontal).apply(void 0, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(edge), false));
        var _a = (0, $7WQrb.__read)(edge, 2), _b = (0, $7WQrb.__read)(_a[0], 2), x0 = _b[0], y0 = _b[1], _c = (0, $7WQrb.__read)(_a[1], 2), x1 = _c[0], y1 = _c[1];
        var _d = (0, $7WQrb.__read)(isH ? [
            x1 - x0,
            [
                x0,
                x1
            ]
        ] : [
            y1 - y0,
            [
                y0,
                y1
            ]
        ], 2), len = _d[0], _e = (0, $7WQrb.__read)(_d[1], 2), b0 = _e[0], b1 = _e[1];
        var hL = len / 2;
        var sign = len / Math.abs(len);
        var cL = size * sign;
        var hCL = cL / 2;
        var cS = cL * Math.sqrt(3) / 2 * cornerScale;
        var _f = (0, $7WQrb.__read)([
            b0,
            b0 + hL - hCL,
            b0 + hL,
            b0 + hL + hCL,
            b1
        ], 5), a0 = _f[0], a1 = _f[1], a2 = _f[2], a3 = _f[3], a4 = _f[4];
        if (isH) {
            this.point = [
                a2,
                y0 - cS
            ];
            return [
                [
                    'L',
                    a0,
                    y0
                ],
                [
                    'L',
                    a1,
                    y0
                ],
                [
                    'L',
                    a2,
                    y0 - cS
                ],
                [
                    'L',
                    a3,
                    y0
                ],
                [
                    'L',
                    a4,
                    y0
                ]
            ];
        }
        this.point = [
            x0 + cS,
            a2
        ];
        return [
            [
                'L',
                x0,
                a0
            ],
            [
                'L',
                x0,
                a1
            ],
            [
                'L',
                x0 + cS,
                a2
            ],
            [
                'L',
                x0,
                a3
            ],
            [
                'L',
                x0,
                a4
            ]
        ];
    };
    Indicator.prototype.applyVisibility = function() {
        var visibility = this.attributes.visibility;
        if (visibility === 'hidden') (0, $2gch2.hide)(this);
        else (0, $2gch2.show)(this);
    };
    Indicator.prototype.bindEvents = function() {
        this.label.on((0, $2eDEB.ElementEvent).BOUNDS_CHANGED, this.renderBackground);
    };
    Indicator.prototype.render = function() {
        this.renderLabel();
        this.renderBackground();
        this.adjustLayout();
        this.applyVisibility();
    };
    return Indicator;
}((0, $e7n3C.Component));

});
parcelRegister("gqxWW", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_INDICATOR_STYLE_PROPS", () => $bf5968bd817c27c4$export$c1859be0fd527504);
var $bf5968bd817c27c4$export$c1859be0fd527504 = {
    backgroundFill: '#262626',
    backgroundLineCap: 'round',
    backgroundLineWidth: 1,
    backgroundStroke: '#333',
    backgroundZIndex: -1,
    formatter: function(val) {
        return val.toString();
    },
    labelFill: '#fff',
    labelFontSize: 12,
    labelTextBaseline: 'middle',
    padding: [
        2,
        4
    ],
    position: 'right',
    radius: 0,
    zIndex: 999
};

});


parcelRegister("kHEGr", function(module, exports) {

$parcel$export(module.exports, "Select", () => $f12761b9674f9ffc$export$ef9b1a59e592288f);

var $7WQrb = parcelRequire("7WQrb");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $2gch2 = parcelRequire("2gch2");
var $le54I = parcelRequire("le54I");
var $i1HPZ = parcelRequire("i1HPZ");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $6LvUc = parcelRequire("6LvUc");

var $3EwmK = parcelRequire("3EwmK");
var $f12761b9674f9ffc$export$ef9b1a59e592288f = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Select, _super);
    function Select(options) {
        var _a, _b;
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, Select.defaultOptions, options)) || this;
        /** 当前 value */ _this.currentValue = (_a = Select.defaultOptions.style) === null || _a === void 0 ? void 0 : _a.defaultValue;
        _this.isPointerInSelect = false;
        _this.select = _this.appendChild(new (0, $2eDEB.Rect)({
            className: 'select',
            style: {
                cursor: 'pointer',
                width: 0,
                height: 0
            }
        }));
        _this.dropdown = _this.appendChild(new (0, $2eDEB.Rect)({
            className: 'dropdown'
        }));
        var defaultValue = _this.style.defaultValue;
        if (defaultValue && ((_b = _this.style.options) === null || _b === void 0 ? void 0 : _b.some(function(option) {
            return option.value === defaultValue;
        }))) _this.currentValue = defaultValue;
        return _this;
    }
    Select.prototype.setValue = function(value) {
        this.currentValue = value;
        this.render();
    };
    Select.prototype.getValue = function() {
        return this.currentValue;
    };
    Object.defineProperty(Select.prototype, "dropdownPadding", {
        get: function() {
            return (0, $le54I.parseSeriesAttr)(this.style.dropdownPadding);
        },
        enumerable: false,
        configurable: true
    });
    Select.prototype.renderSelect = function() {
        var _this = this;
        var _a;
        var _b = this.style, x = _b.x, y = _b.y, width = _b.width, height = _b.height, bordered = _b.bordered, showDropdownIcon = _b.showDropdownIcon;
        var selectStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'select');
        var placeholderStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'placeholder');
        this.select.attr((0, $7WQrb.__assign)((0, $7WQrb.__assign)({
            x: x,
            y: y,
            width: width,
            height: height
        }, selectStyle), {
            fill: '#fff',
            strokeWidth: bordered ? 1 : 0
        }));
        var padding = this.dropdownPadding;
        // dropdown icon
        var iconSize = 10;
        if (showDropdownIcon) (0, $bCy7Q.select)(this.select).maybeAppend('.dropdown-icon', 'path').style('d', 'M-5,-3.5 L0,3.5 L5,-3.5').style('transform', "translate(".concat(x + width - iconSize - padding[1] - padding[3], ", ").concat(y + height / 2, ")")).style('lineWidth', 1).style('stroke', this.select.style.stroke);
        var currentOption = (_a = this.style.options) === null || _a === void 0 ? void 0 : _a.find(function(option) {
            return option.value === _this.currentValue;
        });
        // placeholder
        var finalPlaceholderStyle = (0, $7WQrb.__assign)({
            x: x + padding[3]
        }, placeholderStyle);
        (0, $bCy7Q.select)(this.select).selectAll('.placeholder').data(!currentOption ? [
            1
        ] : []).join(function(enter) {
            return enter.append('text').attr('className', 'placeholder').styles(finalPlaceholderStyle).style('y', function() {
                var bbox = this.getBBox();
                return y + (height - bbox.height) / 2;
            });
        }, function(update) {
            return update.styles(finalPlaceholderStyle);
        }, function(exit) {
            return exit.remove();
        });
        // value
        var labelStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'optionLabel');
        var finalValueStyle = (0, $7WQrb.__assign)({
            x: x + padding[3]
        }, labelStyle);
        (0, $bCy7Q.select)(this.select).selectAll('.value').data(currentOption ? [
            currentOption
        ] : []).join(function(enter) {
            return enter.append(function(datum) {
                return (0, $i1HPZ.renderExtDo)(datum.label);
            }).attr('className', 'value').styles(finalValueStyle).style('y', function() {
                var bbox = this.getBBox();
                return y + (height - bbox.height) / 2;
            });
        }, function(update) {
            return update.styles(finalValueStyle);
        }, function(exit) {
            return exit.remove();
        });
    };
    Select.prototype.renderDropdown = function() {
        var _this = this;
        var _a, _b;
        var _c = this.style, x = _c.x, y = _c.y, width = _c.width, height = _c.height, options = _c.options, onSelect = _c.onSelect, open = _c.open;
        var dropdownStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'dropdown');
        var optionStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'option');
        var padding = this.dropdownPadding;
        (0, $bCy7Q.select)(this.dropdown).maybeAppend('.dropdown-container', 'g').attr('className', 'dropdown-container').selectAll('.dropdown-item').data(options, function(datum) {
            return datum.value;
        }).join(function(enter) {
            return enter.append(function(datum) {
                return new (0, $3EwmK.Option)({
                    className: 'dropdown-item',
                    style: (0, $7WQrb.__assign)((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, datum), optionStyle), {
                        width: width - padding[1] - padding[3],
                        selected: datum.value === _this.currentValue,
                        onClick: function(value, option, item) {
                            _this.setValue(value);
                            onSelect === null || onSelect === void 0 || onSelect(value, option, item);
                            _this.dispatchEvent(new (0, $2eDEB.CustomEvent)('change', {
                                detail: {
                                    value: value,
                                    option: option,
                                    item: item
                                }
                            }));
                            (0, $2gch2.hide)(_this.dropdown);
                        }
                    })
                });
            }).each(function(datum, i) {
                var _a;
                var nodes = (_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.children;
                var accHeight = nodes.reduce(function(acc, curr, index) {
                    if (index < i) acc += curr.getBBox().height;
                    return acc;
                }, 0);
                // 设置偏移
                this.attr('transform', "translate(".concat(padding[3], ", ").concat(padding[0] + accHeight, ")"));
            });
        }, function(update) {
            return update.update(function(datum) {
                return {
                    selected: datum.value === _this.currentValue
                };
            });
        }, function(exit) {
            return exit.remove();
        });
        var bbox = (_b = (_a = this.dropdown.getElementsByClassName('dropdown-container')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.getBBox();
        var spacing = dropdownStyle.spacing;
        this.dropdown.attr((0, $7WQrb.__assign)({
            transform: "translate(".concat(x, ", ").concat(y + height + spacing, ")"),
            width: bbox.width + padding[1] + padding[3],
            height: bbox.height + padding[0] + padding[2]
        }, dropdownStyle));
        // 默认隐藏
        !open && (0, $2gch2.hide)(this.dropdown);
    };
    Select.prototype.render = function() {
        this.renderSelect();
        this.renderDropdown();
    };
    Select.prototype.bindEvents = function() {
        var _this = this;
        this.addEventListener('click', function(e) {
            e.stopPropagation();
        });
        this.select.addEventListener('click', function() {
            if (_this.dropdown.style.visibility === 'visible') (0, $2gch2.hide)(_this.dropdown);
            else (0, $2gch2.show)(_this.dropdown);
        });
        // mock blur
        this.addEventListener('pointerenter', function() {
            _this.isPointerInSelect = true;
        });
        this.addEventListener('pointerleave', function() {
            _this.isPointerInSelect = false;
        });
        document === null || document === void 0 || document.addEventListener('click', function() {
            if (!_this.isPointerInSelect) (0, $2gch2.hide)(_this.dropdown);
        });
    };
    Select.defaultOptions = {
        style: {
            x: 0,
            y: 0,
            width: 140,
            height: 32,
            options: [],
            bordered: true,
            defaultValue: '',
            selectRadius: 8,
            selectStroke: '#d9d9d9',
            showDropdownIcon: true,
            placeholderText: "\u8BF7\u9009\u62E9",
            placeholderFontSize: 12,
            placeholderTextBaseline: 'top',
            placeholderFill: '#c2c2c2',
            dropdownFill: '#fff',
            dropdownStroke: '#d9d9d9',
            dropdownRadius: 8,
            dropdownShadowBlur: 4,
            dropdownShadowColor: 'rgba(0, 0, 0, 0.08)',
            dropdownPadding: 8,
            dropdownSpacing: 10,
            optionPadding: [
                8,
                12
            ],
            optionFontSize: 12,
            optionTextBaseline: 'top',
            optionBackgroundFill: '#fff',
            optionBackgroundRadius: 4,
            optionLabelFontSize: 12,
            optionLabelTextBaseline: 'top'
        }
    };
    return Select;
}((0, $e7n3C.Component));

});
parcelRegister("3EwmK", function(module, exports) {

$parcel$export(module.exports, "Option", () => $2a8e36b2134cc2b2$export$36d18380658d5d20);

var $7WQrb = parcelRequire("7WQrb");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $le54I = parcelRequire("le54I");
var $i1HPZ = parcelRequire("i1HPZ");
var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $6LvUc = parcelRequire("6LvUc");
var $2a8e36b2134cc2b2$export$36d18380658d5d20 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Option, _super);
    function Option(options) {
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, Option.defaultOptions, options)) || this;
        _this.hoverColor = '#f5f5f5';
        _this.selectedColor = '#e6f7ff';
        _this.background = _this.appendChild(new (0, $2eDEB.Rect)({}));
        _this.label = _this.background.appendChild(new (0, $2eDEB.Group)({}));
        return _this;
    }
    Object.defineProperty(Option.prototype, "padding", {
        get: function() {
            return (0, $le54I.parseSeriesAttr)(this.style.padding);
        },
        enumerable: false,
        configurable: true
    });
    Option.prototype.renderLabel = function() {
        var _a = this.style, label = _a.label, value = _a.value;
        var labelStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'label');
        (0, $bCy7Q.select)(this.label).maybeAppend('.label', function() {
            return (0, $i1HPZ.renderExtDo)(label);
        }).attr('className', 'label').styles(labelStyle);
        // bind data to label
        this.label.attr('__data__', value);
    };
    Option.prototype.renderBackground = function() {
        var labelBBox = this.label.getBBox();
        var _a = (0, $7WQrb.__read)(this.padding, 4), top = _a[0], right = _a[1], bottom = _a[2], left = _a[3];
        var labelWidth = labelBBox.width, labelHeight = labelBBox.height;
        var backgroundWidth = labelWidth + left + right;
        var backgroundHeight = labelHeight + top + bottom;
        var backgroundStyle = (0, $8UxPj.subStyleProps)(this.attributes, 'background');
        var _b = this.style, _c = _b.width, styleWidth = _c === void 0 ? 0 : _c, _d = _b.height, styleHeight = _d === void 0 ? 0 : _d, selected = _b.selected;
        this.background.attr((0, $7WQrb.__assign)((0, $7WQrb.__assign)({}, backgroundStyle), {
            width: Math.max(backgroundWidth, styleWidth),
            height: Math.max(backgroundHeight, styleHeight),
            fill: selected ? this.selectedColor : '#fff'
        }));
        // place label
        this.label.attr({
            transform: "translate(".concat(left, ", ").concat((backgroundHeight - labelHeight) / 2, ")")
        });
    };
    Option.prototype.render = function() {
        this.renderLabel();
        this.renderBackground();
    };
    Option.prototype.bindEvents = function() {
        var _this = this;
        this.addEventListener('pointerenter', function() {
            if (_this.style.selected) return;
            _this.background.attr('fill', _this.hoverColor);
        });
        this.addEventListener('pointerleave', function() {
            if (_this.style.selected) return;
            _this.background.attr('fill', _this.style.backgroundFill);
        });
        var item = this;
        this.addEventListener('click', function() {
            var _a = _this.style, label = _a.label, value = _a.value, onClick = _a.onClick;
            onClick === null || onClick === void 0 || onClick(value, {
                label: label,
                value: value
            }, item);
        });
    };
    Option.defaultOptions = {
        style: {
            value: '',
            label: '',
            cursor: 'pointer'
        }
    };
    return Option;
}((0, $e7n3C.Component));

});




parcelRegister("bQmzU", function(module, exports) {

$parcel$export(module.exports, "TimeModeHandle", () => $89f6109d104c8518$export$fa419da06637bb38);
$parcel$export(module.exports, "ChartModeHandle", () => $89f6109d104c8518$export$8c076c49ef0b78a8);

var $7WQrb = parcelRequire("7WQrb");

var $e7n3C = parcelRequire("e7n3C");
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $bCy7Q = parcelRequire("bCy7Q");
var $8UxPj = parcelRequire("8UxPj");

var $6LvUc = parcelRequire("6LvUc");
var $89f6109d104c8518$export$fa419da06637bb38 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(TimeModeHandle, _super);
    function TimeModeHandle(options) {
        var _this = _super.call(this, (0, $6LvUc.deepAssign)({}, TimeModeHandle.defaultOptions, options)) || this;
        _this.bindEvents();
        return _this;
    }
    TimeModeHandle.prototype.bindEvents = function() {
        var _this = this;
        this.addEventListener('mouseenter', function() {
            _this.attr('lineWidth', Math.ceil(+(_this.style.r || 0) / 2));
        });
        this.addEventListener('mouseleave', function() {
            _this.attr('lineWidth', 0);
        });
    };
    TimeModeHandle.defaultOptions = {
        style: {
            r: 5,
            fill: '#3f7cf7',
            lineWidth: 0,
            stroke: '#3f7cf7',
            strokeOpacity: 0.5,
            cursor: 'pointer'
        }
    };
    return TimeModeHandle;
}((0, $2eDEB.Circle));
var $89f6109d104c8518$export$8c076c49ef0b78a8 = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(ChartModeHandle, _super);
    function ChartModeHandle(options) {
        return _super.call(this, (0, $6LvUc.deepAssign)({}, ChartModeHandle.defaultOptions, options)) || this;
    }
    ChartModeHandle.prototype.renderBackground = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'background');
        (0, $bCy7Q.select)(this).maybeAppend('background', 'rect').attr('className', 'background').styles((0, $7WQrb.__assign)({
            x: x - width / 2,
            y: y - height / 2,
            width: width,
            height: height
        }, style));
    };
    ChartModeHandle.prototype.renderIcon = function() {
        var _a = this.attributes, x = _a.x, y = _a.y, iconSize = _a.iconSize;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'icon');
        var diffX = 1;
        var diffY = iconSize / 2;
        (0, $bCy7Q.select)(this).maybeAppend('icon-left-line', 'line').attr('className', 'icon-left-line').styles((0, $7WQrb.__assign)({
            x1: x - diffX,
            y1: y - diffY,
            x2: x - diffX,
            y2: y + diffY
        }, style));
        (0, $bCy7Q.select)(this).maybeAppend('icon-right-line', 'line').attr('className', 'icon-right-line').styles((0, $7WQrb.__assign)({
            x1: x + diffX,
            y1: y - diffY,
            x2: x + diffX,
            y2: y + diffY
        }, style));
    };
    ChartModeHandle.prototype.renderBorder = function() {
        var _a = this.attributes, xx = _a.x, y = _a.y, width = _a.width, height = _a.height, type = _a.type;
        var style = (0, $8UxPj.subStyleProps)(this.attributes, 'border');
        var x = type === 'start' ? +width / 2 : -width / 2;
        (0, $bCy7Q.select)(this).maybeAppend('border', 'line').attr('className', 'border').styles((0, $7WQrb.__assign)({
            x1: x + xx,
            y1: y - height / 2,
            x2: x + xx,
            y2: y + height / 2
        }, style));
    };
    ChartModeHandle.prototype.render = function() {
        this.renderBackground();
        this.renderIcon();
        this.renderBorder();
    };
    ChartModeHandle.defaultOptions = {
        style: {
            x: 0,
            y: 0,
            width: 10,
            height: 50,
            iconSize: 10,
            type: 'start',
            backgroundFill: '#fff',
            backgroundFillOpacity: 0.5,
            iconStroke: '#9a9a9a',
            iconLineWidth: 1,
            borderStroke: '#e8e8e8',
            borderLineWidth: 1
        }
    };
    return ChartModeHandle;
}((0, $e7n3C.Component));

});

parcelRegister("eyxXn", function(module, exports) {

$parcel$export(module.exports, "labelFormatter", () => $a98e94c182d24a4c$export$17b23e7708daf03e);
$parcel$export(module.exports, "parseBySeries", () => $a98e94c182d24a4c$export$b76824f206f6ec92);

var $c6FtR = parcelRequire("c6FtR");
function $a98e94c182d24a4c$export$17b23e7708daf03e(time, interval) {
    if (typeof time === 'number') return $a98e94c182d24a4c$export$b76824f206f6ec92(time);
    return $a98e94c182d24a4c$export$5324d513bec63c97(time, interval);
}
function $a98e94c182d24a4c$export$5324d513bec63c97(time, interval) {
    var date = new Date(time);
    switch(interval){
        case 'half-hour':
        case 'hour':
        case 'four-hour':
            if ([
                0,
                6,
                12,
                18
            ].includes(date.getHours()) && date.getMinutes() === 0) // HH:mm\nYYYY-MM-DD
            return (0, $c6FtR.formatTime)(date, 'HH:mm\nYYYY-MM-DD');
            // HH:mm
            return (0, $c6FtR.formatTime)(date, 'HH:mm');
        case 'half-day':
            // A\nYYYY-MM-DD
            if (date.getHours() < 12) return "AM\n".concat((0, $c6FtR.formatTime)(date, 'YYYY-MM-DD'));
            // A
            return 'PM';
        case 'day':
            if ([
                1,
                10,
                20
            ].includes(date.getDate())) // DD\nYYYY-MM
            return (0, $c6FtR.formatTime)(date, 'DD\nYYYY-MM');
            // DD
            return (0, $c6FtR.formatTime)(date, 'DD');
        case 'week':
            if (date.getDate() <= 7) // DD\nYYYY-MM
            return (0, $c6FtR.formatTime)(date, 'DD\nYYYY-MM');
            // DD
            return (0, $c6FtR.formatTime)(date, 'DD');
        case 'month':
            if ([
                0,
                6
            ].includes(date.getMonth())) // MM月\nYYYY
            return (0, $c6FtR.formatTime)(date, "MM\u6708\nYYYY");
            // MM月
            return (0, $c6FtR.formatTime)(date, "MM\u6708");
        case 'season':
            if ([
                0
            ].includes(date.getMonth())) // MM月\nYYYY
            return (0, $c6FtR.formatTime)(date, "MM\u6708\nYYYY");
            // MM月
            return (0, $c6FtR.formatTime)(date, "MM\u6708");
        case 'year':
            // YYYY
            return (0, $c6FtR.formatTime)(date, 'YYYY');
        default:
            // YYYY-MM-DD HH:mm
            return (0, $c6FtR.formatTime)(date, 'YYYY-MM-DD HH:mm');
    }
}
function $a98e94c182d24a4c$export$b76824f206f6ec92(time) {
    var hours = String(Math.floor(time / 3600)).padStart(2, '0');
    var minutes = String(Math.floor(time % 3600 / 60)).padStart(2, '0');
    var seconds = String(Math.floor(time % 60)).padStart(2, '0');
    if (time < 3600) // mm:ss
    return "".concat(minutes, ":").concat(seconds);
    return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}

});


parcelRegister("fx0bg", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4ea13f84759041a$export$2e2bcd8739ae039);
/**
 * 判断值是否为 Date
 * @return 是否为 Date
 */ function $b4ea13f84759041a$export$2e2bcd8739ae039(value) {
    return value instanceof Date;
}

});


parcelRegister("ly6UE", function(module, exports) {

$parcel$export(module.exports, "Title", () => $fb0222a76df69535$export$f99233281efd08a0);
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");

var $1DkzN = parcelRequire("1DkzN");

var $1uR12 = parcelRequire("1uR12");

var $icwVF = parcelRequire("icwVF");

var $WdqOS = parcelRequire("WdqOS");

var $5Pn1Q = parcelRequire("5Pn1Q");
var $fb0222a76df69535$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $fb0222a76df69535$var$commonStyle = {
    fill: '#1D2129',
    wordWrap: true,
    maxLines: 1,
    textOverflow: 'ellipsis',
    textBaseline: 'top',
    /**
     * textAlign 需要和 x 结合使用
     * 举例: 前提条件: 画布 width = 600
     * - textAlign: 'start' | 'left
     *    需要设 x = 0
     * - textAlign: 'end' | 'right'
     *    需要设 x = 600 (即画布的宽度)
     * - textAlign: 'center'
     *    需要设 x = 300 (即画布的宽度 / 2)
     */ textAlign: 'start',
    x: 0
};
const $fb0222a76df69535$var$defaultTitleStyle = Object.assign(Object.assign({}, $fb0222a76df69535$var$commonStyle), {
    fillOpacity: 0.9,
    fontSize: 16,
    fontWeight: 'bold'
});
const $fb0222a76df69535$var$defaultSubTitleStyle = Object.assign(Object.assign({}, $fb0222a76df69535$var$commonStyle), {
    fillOpacity: 0.65,
    fontSize: 12,
    fontWeight: 'normal'
});
const $fb0222a76df69535$var$defaultOptions = {
    align: 'left',
    spacing: 8,
    size: 44,
    padding: [
        16,
        24,
        0,
        24
    ]
};
const $fb0222a76df69535$var$titleKey = 'title';
const $fb0222a76df69535$var$subtitleKey = 'subtitle';
class $fb0222a76df69535$export$f99233281efd08a0 extends (0, $WdqOS.BasePlugin) {
    get padding() {
        return (0, $1uR12.parsePadding)(this.options.padding);
    }
    constructor(context, options){
        const combineOption = Object.assign({}, $fb0222a76df69535$var$defaultOptions, options);
        super(context, combineOption);
        this.onRender = ()=>{
            const canvas = this.updateCanvas();
            this.renderTitle(canvas);
        };
        this.bindEvents();
    }
    bindEvents() {
        const { graph: graph } = this.context;
        graph.on((0, $4EzN9.GraphEvent).AFTER_RENDER, this.onRender);
        graph.on((0, $4EzN9.GraphEvent).AFTER_ANIMATE, this.onRender);
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        graph.off((0, $4EzN9.GraphEvent).AFTER_RENDER, this.onRender);
        graph.off((0, $4EzN9.GraphEvent).AFTER_ANIMATE, this.onRender);
    }
    destroy() {
        var _a, _b;
        this.unbindEvents();
        (_a = this.canvas) === null || _a === void 0 || _a.destroy();
        (_b = this.container) === null || _b === void 0 || _b.remove();
        super.destroy();
    }
    updateCanvas() {
        const { size: size, className: className, align: align } = this.options;
        const [width] = this.context.canvas.getSize();
        const [pt = 0, , pb = 0] = this.padding;
        const height = size + pt + pb;
        if (this.canvas) {
            const { width: w, height: h } = this.canvas.getConfig();
            if (width !== w || height !== h) this.canvas.resize(width, height);
        } else {
            const positions = {
                left: 'left-top',
                center: 'top',
                right: 'right-top'
            };
            const [$container, canvas] = (0, $5Pn1Q.createPluginCanvas)({
                width: width,
                height: height,
                placement: positions[align] || positions.left,
                className: 'title-canvas',
                graphCanvas: this.context.canvas
            });
            if (className) $container.classList.add(className);
            this.container = $container;
            this.canvas = canvas;
        }
        return this.canvas;
    }
    renderTitle(canvas) {
        const titles = new $fb0222a76df69535$var$TitleComponent({
            options: this.options,
            ctx: this.context
        });
        canvas.removeChildren();
        titles.getTitle().forEach((label)=>{
            if (label) canvas.appendChild(label);
        });
    }
}
class $fb0222a76df69535$var$TitleComponent {
    get padding() {
        return (0, $1uR12.parsePadding)(this.options.padding);
    }
    constructor(props){
        const { options: options, ctx: ctx } = props;
        this.options = options;
        this.context = ctx;
    }
    getTitle() {
        const _a = this.options, _b = $fb0222a76df69535$var$titleKey, propsTitle = _a[_b], _c = $fb0222a76df69535$var$subtitleKey, propsSubtitle = _a[_c], { spacing: spacing = 44, padding: padding, align: align } = _a, style = $fb0222a76df69535$var$__rest(_a, [
            typeof _b === "symbol" ? _b : _b + "",
            typeof _c === "symbol" ? _c : _c + "",
            "spacing",
            "padding",
            "align"
        ]);
        const titleText = propsTitle;
        const subTitleText = propsSubtitle;
        const titleStyle = (0, $icwVF.subStyleProps)(style, $fb0222a76df69535$var$titleKey);
        const subtitleStyle = (0, $icwVF.subStyleProps)(style, $fb0222a76df69535$var$subtitleKey);
        const [topGraphWidth] = this.context.graph.getSize();
        const [pt = 0, pr = 0, , pl = 0] = this.padding;
        const canvasWidth = topGraphWidth;
        const textWidth = canvasWidth - pl - pr;
        let subTitle = null;
        let alignX = pl;
        let textAlign = 'left';
        switch(align){
            case 'left':
                alignX = pl;
                textAlign = 'left';
                break;
            case 'center':
                alignX = canvasWidth / 2;
                textAlign = 'center';
                break;
            case 'right':
                alignX = canvasWidth - pr;
                textAlign = 'right';
                break;
            default:
                alignX = pl;
                textAlign = 'left';
        }
        const title = new (0, $1DkzN.Label)({
            className: $fb0222a76df69535$var$titleKey,
            style: Object.assign(Object.assign(Object.assign(Object.assign({}, $fb0222a76df69535$var$defaultTitleStyle), {
                wordWrapWidth: textWidth - 5,
                x: alignX,
                y: pt,
                textAlign: textAlign
            }), titleStyle), {
                text: titleText
            })
        });
        const titleBBox = title.getBBox();
        if (subTitleText) subTitle = new (0, $1DkzN.Label)({
            className: 'subTitle',
            style: Object.assign(Object.assign(Object.assign(Object.assign({}, $fb0222a76df69535$var$defaultSubTitleStyle), {
                wordWrapWidth: textWidth - 5,
                x: alignX,
                y: titleBBox.height + spacing + pt,
                textAlign: textAlign
            }), subtitleStyle), {
                text: subTitleText
            })
        });
        return [
            title,
            subTitle
        ];
    }
}

});

parcelRegister("4Phbm", function(module, exports) {

$parcel$export(module.exports, "Toolbar", () => $383940dd88ee661c$export$4c260019440d418f);

var $WdqOS = parcelRequire("WdqOS");

var $bEb16 = parcelRequire("bEb16");

var $91qvz = parcelRequire("91qvz");
var $383940dd88ee661c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $383940dd88ee661c$export$4c260019440d418f extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $383940dd88ee661c$export$4c260019440d418f.defaultOptions, options));
        this.$element = (0, $bEb16.createPluginContainer)('toolbar', false);
        this.onToolbarItemClick = (e)=>{
            const { onClick: onClick } = this.options;
            if (e.target instanceof Element) {
                if (e.target.className.includes('g6-toolbar-item')) {
                    const v = e.target.getAttribute('value');
                    onClick === null || onClick === void 0 || onClick(v, e.target);
                }
            }
        };
        const $container = this.context.canvas.getContainer();
        this.$element.style.display = 'flex';
        $container.appendChild(this.$element);
        // 设置样式
        (0, $bEb16.insertDOM)('g6-toolbar-css', 'style', {}, (0, $91qvz.TOOLBAR_CSS), document.head);
        (0, $bEb16.insertDOM)('g6-toolbar-svgicon', 'div', {
            display: 'none'
        }, (0, $91qvz.BUILD_IN_SVG_ICON));
        this.$element.addEventListener('click', this.onToolbarItemClick);
        this.update(options);
    }
    /**
     * <zh/> 更新工具栏的配置项
     *
     * <en/> Update the configuration of the toolbar
     * @param options - <zh/> 工具栏的配置项 | <en/> The options of the toolbar
     * @internal
     */ update(options) {
        const _super = Object.create(null, {
            update: {
                get: ()=>super.update
            }
        });
        return $383940dd88ee661c$var$__awaiter(this, void 0, void 0, function*() {
            _super.update.call(this, options);
            const { className: className, position: position, style: style } = this.options;
            this.$element.className = `g6-toolbar ${className || ''}`;
            // 设置容器的样式，主要是位置，背景之类的
            Object.assign(this.$element.style, style, (0, $91qvz.parsePositionToStyle)(position));
            this.$element.innerHTML = yield this.getDOMContent();
        });
    }
    /**
     * <zh/> 销毁工具栏
     *
     * <en/> Destroy the toolbar
     * @internal
     */ destroy() {
        this.$element.removeEventListener('click', this.onToolbarItemClick);
        this.$element.remove();
        super.destroy();
    }
    getDOMContent() {
        return $383940dd88ee661c$var$__awaiter(this, void 0, void 0, function*() {
            const items = yield this.options.getItems();
            return items.map((item)=>{
                var _a;
                return `
          <div class="g6-toolbar-item" value="${item.value}" title="${(_a = item.title) !== null && _a !== void 0 ? _a : ''}">
            <svg aria-hidden="true" focusable="false">
              <use xlink:href="#${item.id}"></use>
            </svg>
          </div>`;
            }).join('');
        });
    }
}
$383940dd88ee661c$export$4c260019440d418f.defaultOptions = {
    position: 'top-left'
};

});
parcelRegister("91qvz", function(module, exports) {

$parcel$export(module.exports, "parsePositionToStyle", () => $6918c50d29ea0bbc$export$f9f7ba3d23cc5e04);
$parcel$export(module.exports, "TOOLBAR_CSS", () => $6918c50d29ea0bbc$export$8dc660ec2ecd48ee);
$parcel$export(module.exports, "BUILD_IN_SVG_ICON", () => $6918c50d29ea0bbc$export$f04f86b724b61bc6);
/**
 * <zh/> 解析 toolbar 的 position 为位置样式。
 *
 * <en/> Parse the position of the toolbar into position style.
 * @param position - position
 * @returns style
 */ function $6918c50d29ea0bbc$export$f9f7ba3d23cc5e04(position) {
    const style = {
        top: 'unset',
        right: 'unset',
        bottom: 'unset',
        left: 'unset'
    };
    const directions = position.split('-');
    directions.forEach((d)=>{
        style[d] = '8px';
    });
    style.flexDirection = position.startsWith('top') || position.startsWith('bottom') ? 'row' : 'column';
    return style;
}
const $6918c50d29ea0bbc$export$8dc660ec2ecd48ee = `
  .g6-toolbar {
    position: absolute;
    z-index: 100;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    opacity: 0.65;
  }
  .g6-toolbar .g6-toolbar-item {
    display: inline-block;
    width: 16px;
    height: 16px;
    padding: 4px;
    cursor: pointer;
    box-sizing: content-box;
  }

  .g6-toolbar .g6-toolbar-item:hover {
    background-color: #f0f0f0;
  }

  .g6-toolbar .g6-toolbar-item svg {
    display: inline-block;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }
`;
const $6918c50d29ea0bbc$export$f04f86b724b61bc6 = `
  <svg>
    <symbol id="zoom-in" viewBox="64 64 896 896">
      <path d="M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"></path>
    </symbol>
    <symbol id="zoom-out" viewBox="64 64 896 896">
      <path d="M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z"></path>
    </symbol>
    <symbol id="edit" viewBox="64 64 896 896">
      <path d="M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z"></path>
    </symbol>
    <symbol id="delete" viewBox="64 64 896 896">
      <path d="M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"></path>
    </symbol>
    <symbol id="redo" viewBox="64 64 896 896">
      <path d="M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 00-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z"></path>
    </symbol>
    <symbol id="undo" viewBox="64 64 896 896">
      <path d="M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 00-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 01-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 01-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 00-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z"></path>
    </symbol>
    <symbol id="export" viewBox="64 64 896 896">
      <path d="M880 912H144c-17.7 0-32-14.3-32-32V144c0-17.7 14.3-32 32-32h360c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8H184v656h656V520c0-4.4 3.6-8 8-8h56c4.4 0 8 3.6 8 8v360c0 17.7-14.3 32-32 32zM770.87 199.13l-52.2-52.2a8.01 8.01 0 014.7-13.6l179.4-21c5.1-.6 9.5 3.7 8.9 8.9l-21 179.4c-.8 6.6-8.9 9.4-13.6 4.7l-52.4-52.4-256.2 256.2a8.03 8.03 0 01-11.3 0l-42.4-42.4a8.03 8.03 0 010-11.3l256.1-256.3z"></path>
    </symbol>
    <symbol id="auto-fit" viewBox="64 64 896 896">
      <path d="M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z"></path>
      <path d="M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8A118.57 118.57 0 00512 392z"></path>
    </symbol>
    <symbol id="reset" viewBox="64 64 896 896">
      <path d="M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 00-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 01655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 01279 755.2a342.16 342.16 0 01-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 01109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 003 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z"></path>
    </symbol>
    <symbol id="exit-fullscreen" viewBox="0 0 1024 1024">
      <path d="M418.13333333 361.43786666c0 0.2048-0.13653333 0.4096-0.13653334 0.68266667C417.99679999 362.32533333 418.13333333 362.53013333 418.13333333 362.73493333 418.13333333 371.54133333 414.44693333 379.392 408.78079999 385.39946666 408.43946666 385.7408 408.30293333 386.21866666 408.02986666 386.49173333c-1.09226667 1.09226667-2.59413333 1.77493333-3.82293333 2.73066667C398.40426666 393.65973333 391.64586666 396.8 383.93173333 396.8 383.72693333 396.8 383.59039999 396.73173333 383.38559999 396.73173333S382.97599999 396.8 382.77119999 396.8L112.29866666 396.8C92.50133333 396.8 76.79999999 381.50826666 76.79999999 362.66666666 76.66346666 343.89333333 92.63786666 328.53333333 112.16213333 328.53333333l189.44 0L87.44959999 114.51733333C73.59146666 100.59093333 73.25013333 78.5408 86.63039999 65.29706666c13.17546667-13.44853333 35.36213333-12.97066667 49.152 0.88746667l214.08426667 214.08426667L349.86666666 90.89706666C349.79839999 71.23626666 365.22666666 55.46666666 383.99999999 55.46666666 402.77333333 55.33013333 418.13333333 71.30453333 418.13333333 90.8288L418.13333333 361.43786666zM928.90453333 328.53333333l-189.44 0 214.15253333-214.08426667c13.85813333-13.9264 14.19946667-35.90826667 0.88746667-49.22026666-13.17546667-13.44853333-35.36213333-12.97066667-49.152 0.88746666l-214.08426667 214.08426667L691.26826666 90.89706666C691.26826666 71.23626666 675.83999999 55.46666666 657.06666666 55.46666666 638.29333333 55.33013333 622.93333333 71.30453333 622.93333333 90.8288l0 270.60906666c0 0.2048 0.13653333 0.4096 0.13653333 0.68266667C623.06986666 362.32533333 622.93333333 362.53013333 622.93333333 362.73493333 622.93333333 371.54133333 626.61973333 379.392 632.28586666 385.39946666c0.34133333 0.34133333 0.47786667 0.8192 0.8192 1.09226667 1.09226667 1.09226667 2.59413333 1.77493333 3.8912 2.73066667C642.66239999 393.65973333 649.42079999 396.8 657.13493333 396.8c0.2048 0 0.34133333-0.06826667 0.54613333-0.06826667S658.09066666 396.8 658.29546666 396.8l270.5408 0C948.56533333 396.8 964.26666666 381.50826666 964.26666666 362.66666666 964.40319999 343.89333333 948.42879999 328.53333333 928.90453333 328.53333333zM418.13333333 635.73333333c0-8.8064-3.6864-16.5888-9.35253334-22.66453333C408.43946666 612.72746666 408.30293333 612.2496 408.02986666 611.90826666 406.86933333 610.88426666 405.43573333 610.2016 404.20693333 609.24586666 398.47253333 604.80853333 391.64586666 601.6 383.93173333 601.6 383.72693333 601.6 383.59039999 601.73653333 383.38559999 601.73653333S382.97599999 601.6 382.77119999 601.6L112.29866666 601.6C92.50133333 601.6 76.79999999 616.96 76.79999999 635.73333333 76.66346666 654.50666666 92.63786666 669.86666666 112.16213333 669.86666666l189.44 0-214.15253334 214.15253334c-13.85813333 13.85813333-14.19946667 35.84-0.88746666 49.22026666 13.17546667 13.44853333 35.36213333 12.9024 49.152-0.95573333l214.08426666-214.08426667 0 189.37173334c0 19.59253333 15.42826667 35.49866667 34.2016 35.36213333C402.77333333 943.2064 418.13333333 927.232 418.13333333 907.5712L418.13333333 637.09866666c0-0.27306667-0.13653333-0.47786667-0.13653334-0.68266666C417.99679999 636.14293333 418.13333333 635.93813333 418.13333333 635.73333333zM739.46453333 669.86666666l189.44 0c19.456 0 35.49866667-15.36 35.36213333-34.13333333C964.26666666 616.96 948.56533333 601.6 928.76799999 601.6L658.29546666 601.6C658.09066666 601.6 657.88586666 601.73653333 657.68106666 601.73653333S657.33973333 601.6 657.13493333 601.6C649.42079999 601.6 642.59413333 604.80853333 636.85973333 609.24586666 635.63093333 610.2016 634.19733333 610.88426666 633.03679999 611.90826666 632.76373333 612.2496 632.62719999 612.72746666 632.28586666 613.0688 626.61973333 619.14453333 622.93333333 626.92693333 622.93333333 635.73333333c0 0.2048 0.13653333 0.4096 0.13653333 0.68266667C623.06986666 636.6208 622.93333333 636.8256 622.93333333 637.09866666l0 270.5408C622.93333333 927.232 638.29333333 943.2064 657.06666666 942.93333333c18.77333333 0.13653333 34.2016-15.70133333 34.2016-35.36213333l0-189.37173334 214.08426667 214.08426667c13.78986667 13.85813333 35.90826667 14.40426667 49.152 0.95573333 13.312-13.312 12.97066667-35.36213333-0.88746667-49.22026666L739.46453333 669.86666666z"  ></path></symbol>
    <symbol id="request-fullscreen" viewBox="0 0 1024 1024">
      <path d="M69.818182 87.598545v273.128728a34.909091 34.909091 0 0 0 69.818182 0V163.653818l221.928727 222.021818a33.512727 33.512727 0 0 0 47.383273-47.383272L186.926545 116.363636h197.073455a34.909091 34.909091 0 0 0 0-69.818181H110.871273C85.364364 46.545455 69.818182 59.671273 69.818182 87.598545zM938.542545 46.545455H665.413818a34.909091 34.909091 0 0 0 0 69.818181h197.073455L640.465455 338.292364a33.512727 33.512727 0 0 0 47.383272 47.383272l221.928728-222.021818v197.073455a34.909091 34.909091 0 0 0 69.818181 0V87.598545c0-27.927273-15.453091-41.053091-40.96-41.05309z m-827.671272 907.636363h273.128727a34.909091 34.909091 0 0 0 0-69.818182H186.926545l222.021819-221.928727a33.512727 33.512727 0 0 0-47.383273-47.383273L139.636364 837.073455V640a34.909091 34.909091 0 0 0-69.818182 0v273.128727c0 27.927273 15.546182 41.053091 41.053091 41.053091z m868.724363-41.053091V640a34.909091 34.909091 0 0 0-69.818181 0v197.073455L687.941818 615.051636a33.512727 33.512727 0 0 0-47.383273 47.383273L862.487273 884.363636H665.413818a34.909091 34.909091 0 0 0 0 69.818182h273.128727c25.6 0 41.053091-13.125818 41.053091-41.053091z"  ></path></symbol>
  </svg>
`;

});


parcelRegister("fha4x", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $b1f041abdb089fd8$export$28c660c63b792dea);

var $7RAla = parcelRequire("7RAla");

var $6XARU = parcelRequire("6XARU");

var $hn4z6 = parcelRequire("hn4z6");

var $WdqOS = parcelRequire("WdqOS");
var $b1f041abdb089fd8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $b1f041abdb089fd8$export$28c660c63b792dea extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $b1f041abdb089fd8$export$28c660c63b792dea.defaultOptions, options));
        this.currentTarget = null;
        this.tooltipElement = null;
        this.container = null;
        this.isEnable = (event, items)=>{
            const { enable: enable } = this.options;
            if (typeof enable === 'function') return enable(event, items);
            return enable;
        };
        /**
         * <zh/> 点击事件
         *
         * <en/> Click event
         * @param event - <zh/> 元素 | <en/> element
         */ this.onClick = (event)=>{
            const { target: { id: id } } = event;
            // click the same item twice, tooltip will be hidden
            if (this.currentTarget === id) this.hide(event);
            else this.show(event);
        };
        /**
         * <zh/> 在目标元素(node/edge/combo)上移动
         *
         * <en/> Move on target element (node/edge/combo)
         * @param event - <zh/> 目标元素 | <en/> target element
         */ this.onPointerMove = (event)=>{
            const { target: target } = event;
            if (!this.currentTarget || target.id === this.currentTarget) return;
            this.show(event);
        };
        /**
         * <zh/> 点击画布/触发拖拽/出现上下文菜单隐藏tooltip
         *
         * <en/> Hide tooltip when clicking canvas/triggering drag/appearing context menu
         * @param event - <zh/> 目标元素 | <en/> target element
         */ this.onPointerLeave = (event)=>{
            this.hide(event);
        };
        /**
         * <zh/> 移动画布
         *
         * <en/> Move canvas
         * @param event - <zh/> 目标元素 | <en/> target element
         */ this.onCanvasMove = (event)=>{
            this.hide(event);
        };
        this.onPointerOver = (event)=>{
            this.show(event);
        };
        /**
         * <zh/> 显示目标元素的提示框
         *
         * <en/> Show tooltip of target element
         * @param id - <zh/> 元素 ID | <en/> element ID
         */ this.showById = (id)=>$b1f041abdb089fd8$var$__awaiter(this, void 0, void 0, function*() {
                const event = {
                    target: {
                        id: id
                    }
                };
                yield this.show(event);
            });
        this.getElementData = (id, targetType)=>{
            const { model: model } = this.context;
            switch(targetType){
                case 'node':
                    return model.getNodeData([
                        id
                    ]);
                case 'edge':
                    return model.getEdgeData([
                        id
                    ]);
                case 'combo':
                    return model.getComboData([
                        id
                    ]);
                default:
                    return [];
            }
        };
        /**
         * <zh/> 在目标元素上显示tooltip
         *
         * <en/> Show tooltip on target element
         * @param event - <zh/> 目标元素 | <en/> target element
         * @internal
         */ this.show = (event)=>$b1f041abdb089fd8$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                const { client: client, target: { id: id } } = event;
                if ((0, $hn4z6.isToBeDestroyed)(event.target)) return;
                const targetType = this.context.graph.getElementType(id);
                const { getContent: getContent, title: title } = this.options;
                const items = this.getElementData(id, targetType);
                if (!this.tooltipElement) return;
                // if shown, when is not enable, hide
                if (!this.isEnable(event, items)) {
                    this.hide(event);
                    return;
                }
                let tooltipContent = {};
                if (getContent) {
                    tooltipContent.content = yield getContent(event, items);
                    if (!tooltipContent.content) return;
                } else {
                    const style = this.context.graph.getElementRenderStyle(id);
                    const color = targetType === 'node' ? style.fill : style.stroke;
                    tooltipContent = {
                        title: title || targetType,
                        data: items.map((item)=>{
                            return {
                                name: 'ID',
                                value: item.id || `${item.source} -> ${item.target}`,
                                color: color
                            };
                        })
                    };
                }
                this.currentTarget = id;
                let x;
                let y;
                if (client) {
                    x = client.x;
                    y = client.y;
                } else {
                    const style = (0, $6XARU.default)(items, '0.style', {
                        x: 0,
                        y: 0
                    });
                    x = style.x;
                    y = style.y;
                }
                (_b = (_a = this.options).onOpenChange) === null || _b === void 0 || _b.call(_a, true);
                this.tooltipElement.update(Object.assign(Object.assign(Object.assign({}, this.tooltipStyleProps), {
                    x: x,
                    y: y,
                    style: {
                        '.tooltip': {
                            visibility: 'visible'
                        }
                    }
                }), tooltipContent));
            });
        /**
         * <zh/> 隐藏tooltip
         *
         * <en/> Hidden tooltip
         * @param event - <zh/> 目标元素,不传则为外部调用 | <en/> Target element, not passed in as external call
         */ this.hide = (event)=>{
            var _a, _b, _c, _d, _e;
            // if e is undefined, hide the tooltip， external call
            if (!event) {
                (_b = (_a = this.options).onOpenChange) === null || _b === void 0 || _b.call(_a, false);
                (_c = this.tooltipElement) === null || _c === void 0 || _c.hide();
                this.currentTarget = null;
                return;
            }
            if (!this.tooltipElement) return;
            // No target node: tooltip has been hidden. No need for duplicated call.
            if (!this.currentTarget) return;
            const { client: { x: x, y: y } } = event;
            (_e = (_d = this.options).onOpenChange) === null || _e === void 0 || _e.call(_d, false);
            this.tooltipElement.hide(x, y);
            this.currentTarget = null;
        };
        this.initTooltip = ()=>{
            var _a;
            const tooltipElement = new (0, $7RAla.Tooltip)({
                className: 'tooltip',
                style: this.tooltipStyleProps
            });
            (_a = this.container) === null || _a === void 0 || _a.appendChild(tooltipElement.HTMLTooltipElement);
            return tooltipElement;
        };
        this.render();
        this.bindEvents();
    }
    /**
     * <zh/> 获取事件及处理事件的方法
     *
     * <en/> Get event and handle event methods
     * @returns <zh/> 事件及处理事件的方法 | <en/> Event and handling event methods
     */ getEvents() {
        if (this.options.trigger === 'click') return {
            'node:click': this.onClick,
            'edge:click': this.onClick,
            'combo:click': this.onClick,
            'canvas:click': this.onPointerLeave,
            contextmenu: this.onPointerLeave,
            drag: this.onPointerLeave
        };
        return {
            'node:pointerover': this.onPointerOver,
            'node:pointermove': this.onPointerMove,
            'canvas:pointermove': this.onCanvasMove,
            'edge:pointerover': this.onPointerOver,
            'edge:pointermove': this.onPointerMove,
            'combo:pointerover': this.onPointerOver,
            'combo:pointermove': this.onPointerMove,
            contextmenu: this.onPointerLeave,
            'node:drag': this.onPointerLeave
        };
    }
    /**
     * <zh/> 更新tooltip配置
     *
     * <en/> Update the tooltip configuration
     * @param options - <zh/> 配置项 | <en/> options
     * @internal
     */ update(options) {
        var _a;
        this.unbindEvents();
        super.update(options);
        if (this.tooltipElement) (_a = this.container) === null || _a === void 0 || _a.removeChild(this.tooltipElement.HTMLTooltipElement);
        this.tooltipElement = this.initTooltip();
        this.bindEvents();
    }
    render() {
        const { canvas: canvas } = this.context;
        const $container = canvas.getContainer();
        if (!$container) return;
        this.container = $container;
        this.tooltipElement = this.initTooltip();
    }
    unbindEvents() {
        const { graph: graph } = this.context;
        /** The previous event binding needs to be removed when updating the trigger. */ const events = this.getEvents();
        Object.keys(events).forEach((eventName)=>{
            graph.off(eventName, events[eventName]);
        });
    }
    bindEvents() {
        const { graph: graph } = this.context;
        const events = this.getEvents();
        Object.keys(events).forEach((eventName)=>{
            graph.on(eventName, events[eventName]);
        });
    }
    get tooltipStyleProps() {
        const { canvas: canvas } = this.context;
        const { center: center } = canvas.getBounds();
        const $container = canvas.getContainer();
        const { top: top, left: left } = $container.getBoundingClientRect();
        const { style: style, position: position, enterable: enterable, container: container = {
            x: -left,
            y: -top
        }, title: title, offset: offset } = this.options;
        const [x, y] = center;
        const [width, height] = canvas.getSize();
        return {
            x: x,
            y: y,
            container: container,
            title: title,
            bounding: {
                x: 0,
                y: 0,
                width: width,
                height: height
            },
            position: position,
            enterable: enterable,
            offset: offset,
            style: style
        };
    }
    /**
     * <zh/> 销毁tooltip
     *
     * <en/> Destroy tooltip
     * @internal
     */ destroy() {
        var _a;
        this.unbindEvents();
        if (this.tooltipElement) (_a = this.container) === null || _a === void 0 || _a.removeChild(this.tooltipElement.HTMLTooltipElement);
        super.destroy();
    }
}
$b1f041abdb089fd8$export$28c660c63b792dea.defaultOptions = {
    trigger: 'hover',
    position: 'top-right',
    enterable: false,
    enable: true,
    offset: [
        10,
        10
    ],
    style: {
        '.tooltip': {
            visibility: 'hidden'
        }
    }
};

});
parcelRegister("7RAla", function(module, exports) {

$parcel$export(module.exports, "Tooltip", () => $5b99ac1498af8eb6$export$28c660c63b792dea);

var $7WQrb = parcelRequire("7WQrb");

var $3vLaV = parcelRequire("3vLaV");
var $80oQS = parcelRequire("80oQS");

var $e7n3C = parcelRequire("e7n3C");

var $8UxPj = parcelRequire("8UxPj");
var $7agTx = parcelRequire("7agTx");
var $iqKA2 = parcelRequire("iqKA2");

var $9JTto = parcelRequire("9JTto");
var $5b99ac1498af8eb6$export$28c660c63b792dea = /** @class */ function(_super) {
    (0, $7WQrb.__extends)(Tooltip, _super);
    function Tooltip(options) {
        var _this = this;
        var _a, _b;
        var prefixCls = (_b = (_a = options.style) === null || _a === void 0 ? void 0 : _a.template) === null || _b === void 0 ? void 0 : _b.prefixCls;
        var CLASS_NAME = (0, $9JTto.getClassNames)(prefixCls);
        _this = _super.call(this, options, {
            data: [],
            x: 0,
            y: 0,
            visibility: 'visible',
            title: '',
            position: 'bottom-right',
            offset: [
                5,
                5
            ],
            enterable: false,
            container: {
                x: 0,
                y: 0
            },
            bounding: null,
            template: {
                prefixCls: '',
                container: "<div class=\"".concat(CLASS_NAME.CONTAINER, "\"></div>"),
                title: "<div class=\"".concat(CLASS_NAME.TITLE, "\"></div>"),
                item: "<li class=\"".concat(CLASS_NAME.LIST_ITEM, "\" data-index={index}>\n        <span class=\"").concat(CLASS_NAME.NAME, "\">\n          <span class=\"").concat(CLASS_NAME.MARKER, "\" style=\"background:{color}\"></span>\n          <span class=\"").concat(CLASS_NAME.NAME_LABEL, "\" title=\"{name}\">{name}</span>\n        </span>\n        <span class=\"").concat(CLASS_NAME.VALUE, "\" title=\"{value}\">{value}</span>\n      </li>")
            },
            style: (0, $9JTto.getDefaultTooltipStyle)(prefixCls)
        }) || this;
        _this.timestamp = -1;
        _this.prevCustomContentKey = _this.attributes.contentKey;
        _this.initShape();
        _this.render(_this.attributes, _this);
        return _this;
    }
    Object.defineProperty(Tooltip.prototype, "HTMLTooltipElement", {
        get: function() {
            return this.element;
        },
        enumerable: false,
        configurable: true
    });
    Tooltip.prototype.getContainer = function() {
        return this.element;
    };
    Object.defineProperty(Tooltip.prototype, "elementSize", {
        get: function() {
            var width = this.element.offsetWidth;
            var height = this.element.offsetHeight;
            return {
                width: width,
                height: height
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Tooltip.prototype, "HTMLTooltipItemsElements", {
        get: function() {
            var _a = this.attributes, data = _a.data, template = _a.template;
            return data.map(function(_a, idx) {
                var _b = _a.name, name = _b === void 0 ? '' : _b, _c = _a.color, color = _c === void 0 ? 'black' : _c, index = _a.index, rest = (0, $7WQrb.__rest)(_a, [
                    "name",
                    "color",
                    "index"
                ]);
                var datum = (0, $7WQrb.__assign)({
                    name: name,
                    color: color,
                    index: index !== null && index !== void 0 ? index : idx
                }, rest);
                return (0, $3vLaV.createDOM)((0, $80oQS.default)(template.item, datum));
            });
        },
        enumerable: false,
        configurable: true
    });
    Tooltip.prototype.render = function(attributes, container) {
        this.renderHTMLTooltipElement();
        this.updatePosition();
    };
    Tooltip.prototype.destroy = function() {
        var _a;
        (_a = this.element) === null || _a === void 0 || _a.remove();
        _super.prototype.destroy.call(this);
    };
    /**
     * 如果设置了坐标值，显示过程中会立即更新位置并关闭过渡动画
     */ Tooltip.prototype.show = function(x, y) {
        var _this = this;
        if (x !== undefined && y !== undefined) {
            var isToggle = this.element.style.visibility === 'hidden';
            var setPosition = function() {
                _this.attributes.x = x !== null && x !== void 0 ? x : _this.attributes.x;
                _this.attributes.y = y !== null && y !== void 0 ? y : _this.attributes.y;
                _this.updatePosition();
            };
            // 只有从 hidden 状态变为 visible 状态时才需要关闭过渡动画
            isToggle ? this.closeTransition(setPosition) : setPosition();
        }
        this.element.style.visibility = 'visible';
    };
    /**
     * 如果 hide 时传入了坐标值，那么只有当鼠标不在 tooltip 上时才会隐藏
     * 对于 enterable = true 的时候，需要传入 x y，为了避免问题，建议上层在使用的时候，都传入 x y
     * @param x
     * @param y
     * @returns
     */ Tooltip.prototype.hide = function(x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        var enterable = this.attributes.enterable;
        // 如果当前鼠标在 tooltip 上，则不隐藏
        if (enterable && this.isCursorEntered(x, y)) return;
        this.element.style.visibility = 'hidden';
    };
    /**
     * 初始化容器
     */ Tooltip.prototype.initShape = function() {
        var template = this.attributes.template;
        this.element = (0, $3vLaV.createDOM)(template.container);
        if (this.id) this.element.setAttribute('id', this.id);
    };
    Tooltip.prototype.renderCustomContent = function() {
        if (this.prevCustomContentKey !== undefined && this.prevCustomContentKey === this.attributes.contentKey) return;
        this.prevCustomContentKey = this.attributes.contentKey;
        var content = this.attributes.content;
        if (!content) return;
        if (typeof content === 'string') this.element.innerHTML = content;
        else (0, $iqKA2.replaceChildren)(this.element, content);
    };
    /**
     * 更新 HTML 上的内容
     */ Tooltip.prototype.renderHTMLTooltipElement = function() {
        var _a, _b;
        var _c = this.attributes, template = _c.template, title = _c.title, enterable = _c.enterable, style = _c.style, content = _c.content;
        var CLASS_NAME = (0, $9JTto.getClassNames)(template.prefixCls);
        var container = this.element;
        this.element.style.pointerEvents = enterable ? 'auto' : 'none';
        if (content) this.renderCustomContent();
        else {
            if (title) {
                container.innerHTML = template.title;
                container.getElementsByClassName(CLASS_NAME.TITLE)[0].innerHTML = title;
            } else (_b = (_a = container.getElementsByClassName(CLASS_NAME.TITLE)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 || _b.remove();
            var itemsElements = this.HTMLTooltipItemsElements;
            var ul = document.createElement('ul');
            ul.className = CLASS_NAME.LIST;
            (0, $iqKA2.replaceChildren)(ul, itemsElements);
            var list = this.element.querySelector(".".concat(CLASS_NAME.LIST));
            if (list) list.replaceWith(ul);
            else container.appendChild(ul);
        }
        (0, $8UxPj.applyStyleSheet)(container, style);
    };
    /**
     * 根据 position 和指针位置，计算出 tooltip 相对于指针的偏移量
     * @param assignPosition {TooltipPosition} tooltip相对于指针的位置，不指定时使用默认参数
     */ Tooltip.prototype.getRelativeOffsetFromCursor = function(assignPosition) {
        var _a = this.attributes, position = _a.position, offset = _a.offset;
        var interPosition = assignPosition || position;
        var finalPosition = interPosition.split('-');
        var positionScore = {
            left: [
                -1,
                0
            ],
            right: [
                1,
                0
            ],
            top: [
                0,
                -1
            ],
            bottom: [
                0,
                1
            ]
        };
        var _b = this.elementSize, width = _b.width, height = _b.height;
        var absolutelyOffset = [
            -width / 2,
            -height / 2
        ];
        finalPosition.forEach(function(pos) {
            var _a = (0, $7WQrb.__read)(absolutelyOffset, 2), abs1 = _a[0], abs2 = _a[1];
            var _b = (0, $7WQrb.__read)(positionScore[pos], 2), pos1 = _b[0], pos2 = _b[1];
            absolutelyOffset = [
                abs1 + (width / 2 + offset[0]) * pos1,
                abs2 + (height / 2 + offset[1]) * pos2
            ];
        });
        return absolutelyOffset;
    };
    /**
     * 将相对于指针的偏移量生效到dom元素上
     */ Tooltip.prototype.setOffsetPosition = function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), offsetX = _b[0], offsetY = _b[1];
        var _c = this.attributes, _d = _c.x, x = _d === void 0 ? 0 : _d, _e = _c.y, y = _e === void 0 ? 0 : _e, _f = _c.container, cx = _f.x, cy = _f.y;
        this.element.style.left = "".concat(+x + cx + offsetX, "px");
        this.element.style.top = "".concat(+y + cy + offsetY, "px");
    };
    /**
     * 更新tooltip的位置
     */ Tooltip.prototype.updatePosition = function() {
        var _a = this.attributes.showDelay, showDelay = _a === void 0 ? 60 : _a;
        var currentTimestamp = Date.now();
        if (this.timestamp > 0 && currentTimestamp - this.timestamp < showDelay) return;
        this.timestamp = currentTimestamp;
        // 尝试当前的位置使用默认 position 能否放下
        // 如果不能，则改变取溢出边的反向 position
        /**
         * 默认位置
         *    ⬇️
         * 计算自动调整位置
         *    ⬇️
         * 实际摆放位置
         */ this.setOffsetPosition(this.autoPosition(this.getRelativeOffsetFromCursor()));
    };
    /**
     * 计算自动调整位置后的相对位置
     * @param offsetX 根据position计算的横向偏移量
     * @param offsetY 根据position计算的纵向偏移量
     */ Tooltip.prototype.autoPosition = function(_a) {
        var _b = (0, $7WQrb.__read)(_a, 2), offsetX = _b[0], offsetY = _b[1];
        var _c = this.attributes, cursorX = _c.x, cursorY = _c.y, bounding = _c.bounding, position = _c.position;
        // 如果没有设置 bounds，那么意思就是不限制空间
        if (!bounding) return [
            offsetX,
            offsetY
        ];
        // 更新前的位置和宽度
        var _d = this.element, offsetWidth = _d.offsetWidth, offsetHeight = _d.offsetHeight;
        // 预期放置的位置
        var _e = (0, $7WQrb.__read)([
            +cursorX + offsetX,
            +cursorY + offsetY
        ], 2), expectLeft = _e[0], expectTop = _e[1];
        // 反方向
        var inversion = {
            left: 'right',
            right: 'left',
            top: 'bottom',
            bottom: 'top'
        };
        // 各个边界是否超出容器边界
        var boundingX = bounding.x, boundingY = bounding.y, boundingWidth = bounding.width, boundingHeight = bounding.height;
        var edgeCompare = {
            left: expectLeft < boundingX,
            right: expectLeft + offsetWidth > boundingX + boundingWidth,
            top: expectTop < boundingY,
            bottom: expectTop + offsetHeight > boundingY + boundingHeight
        };
        // 修正的位置
        var correctivePosition = [];
        // 判断是否超出边界
        position.split('-').forEach(function(pos) {
            // 如果在当前方向超出边界，则设置其反方向
            if (edgeCompare[pos]) correctivePosition.push(inversion[pos]);
            else correctivePosition.push(pos);
        });
        var correctedPositionString = correctivePosition.join('-');
        return this.getRelativeOffsetFromCursor(correctedPositionString);
    };
    Tooltip.prototype.isCursorEntered = function(clientX, clientY) {
        // 是可捕获的，并且点在 tooltip dom 上
        if (this.element) {
            var _a = this.element.getBoundingClientRect(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
            // const { container } = this.attributes;
            // const { x: cx, y: cy } = container;
            // console.log(1113, [clientX, clientY], [x, y, width, height], [cx, cy], new BBox(x - cx, y - cy, width, height).isPointIn(cursorX, cursorY));
            return new (0, $7agTx.BBox)(x, y, width, height).isPointIn(clientX, clientY);
        }
        return false;
    };
    Tooltip.prototype.closeTransition = function(callback) {
        var _this = this;
        var transition = this.element.style.transition;
        this.element.style.transition = 'none';
        callback();
        setTimeout(function() {
            _this.element.style.transition = transition;
        }, 10);
    };
    Tooltip.tag = 'tooltip';
    return Tooltip;
}((0, $e7n3C.Component));

});
parcelRegister("3vLaV", function(module, exports) {

$parcel$export(module.exports, "createDOM", () => $28e8dc564963ca40$export$16c46881e3c0a463);
/**
 * Create DOM from a html string.
 * @param str
 * @returns
 */ function $28e8dc564963ca40$export$16c46881e3c0a463(str) {
    var container = document.createElement('div');
    container.innerHTML = str;
    var dom = container.childNodes[0];
    if (dom && container.contains(dom)) container.removeChild(dom);
    return dom;
}

});

parcelRegister("80oQS", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d4199dcbc14dcad$export$2e2bcd8739ae039);
function $5d4199dcbc14dcad$var$substitute(str, o) {
    if (!str || !o) return str;
    return str.replace(/\\?\{([^{}]+)\}/g, function(match, name) {
        if (match.charAt(0) === '\\') return match.slice(1);
        return o[name] === undefined ? '' : o[name];
    });
}
var $5d4199dcbc14dcad$export$2e2bcd8739ae039 = $5d4199dcbc14dcad$var$substitute;

});

parcelRegister("iqKA2", function(module, exports) {

$parcel$export(module.exports, "replaceChildren", () => $d6aec9960cefe3f7$export$caeacfe04f52533a);

var $7WQrb = parcelRequire("7WQrb");
var $d6aec9960cefe3f7$export$caeacfe04f52533a = function(el, content) {
    if (content == null) {
        el.innerHTML = '';
        return;
    }
    if (el.replaceChildren) {
        if (Array.isArray(content)) el.replaceChildren.apply(el, (0, $7WQrb.__spreadArray)([], (0, $7WQrb.__read)(content), false));
        else el.replaceChildren(content);
    } else {
        el.innerHTML = '';
        if (Array.isArray(content)) content.forEach(function(child) {
            return el.appendChild(child);
        });
        else el.appendChild(content);
    }
};

});

parcelRegister("9JTto", function(module, exports) {

$parcel$export(module.exports, "getClassNames", () => $717358d6fc0897cd$export$18505e447a7bb2d5);
$parcel$export(module.exports, "getDefaultTooltipStyle", () => $717358d6fc0897cd$export$b844d8baccf75270);

var $7WQrb = parcelRequire("7WQrb");
function $717358d6fc0897cd$export$18505e447a7bb2d5(prefixCls) {
    if (prefixCls === void 0) prefixCls = '';
    return {
        CONTAINER: "".concat(prefixCls, "tooltip"),
        TITLE: "".concat(prefixCls, "tooltip-title"),
        LIST: "".concat(prefixCls, "tooltip-list"),
        LIST_ITEM: "".concat(prefixCls, "tooltip-list-item"),
        NAME: "".concat(prefixCls, "tooltip-list-item-name"),
        MARKER: "".concat(prefixCls, "tooltip-list-item-marker"),
        NAME_LABEL: "".concat(prefixCls, "tooltip-list-item-name-label"),
        VALUE: "".concat(prefixCls, "tooltip-list-item-value"),
        CROSSHAIR_X: "".concat(prefixCls, "tooltip-crosshair-x"),
        CROSSHAIR_Y: "".concat(prefixCls, "tooltip-crosshair-y")
    };
}
var $717358d6fc0897cd$var$TEXT_OVERFLOW_STYLE = {
    overflow: 'hidden',
    'white-space': 'nowrap',
    'text-overflow': 'ellipsis'
};
function $717358d6fc0897cd$export$b844d8baccf75270(prefixCls) {
    var _a;
    if (prefixCls === void 0) prefixCls = '';
    var CLASS_NAME = $717358d6fc0897cd$export$18505e447a7bb2d5(prefixCls);
    return _a = {}, _a[".".concat(CLASS_NAME.CONTAINER)] = {
        position: 'absolute',
        visibility: 'visible',
        // 'white-space': 'nowrap',
        'z-index': 8,
        transition: "visibility 0.2s cubic-bezier(0.23, 1, 0.32, 1), left 0.4s cubic-bezier(0.23, 1, 0.32, 1), top 0.4s cubic-bezier(0.23, 1, 0.32, 1)",
        'background-color': 'rgba(255, 255, 255, 0.96)',
        'box-shadow': '0 6px 12px 0 rgba(0, 0, 0, 0.12)',
        'border-radius': '4px',
        color: 'rgba(0, 0, 0, 0.65)',
        'font-size': '12px',
        // 'font-family': ,
        'line-height': '20px',
        padding: '12px',
        'min-width': '120px',
        'max-width': '360px',
        'font-family': 'Roboto-Regular'
    }, _a[".".concat(CLASS_NAME.TITLE)] = {
        color: 'rgba(0, 0, 0, 0.45)'
    }, _a[".".concat(CLASS_NAME.LIST)] = {
        margin: '0px',
        'list-style-type': 'none',
        padding: '0px'
    }, _a[".".concat(CLASS_NAME.LIST_ITEM)] = {
        'list-style-type': 'none',
        display: 'flex',
        'line-height': '2em',
        'align-items': 'center',
        'justify-content': 'space-between',
        'white-space': 'nowrap'
    }, _a[".".concat(CLASS_NAME.MARKER)] = {
        width: '8px',
        height: '8px',
        'border-radius': '50%',
        display: 'inline-block',
        'margin-right': '4px'
    }, _a[".".concat(CLASS_NAME.NAME)] = {
        display: 'flex',
        'align-items': 'center',
        'max-width': '216px'
    }, _a[".".concat(CLASS_NAME.NAME_LABEL)] = (0, $7WQrb.__assign)({
        flex: 1
    }, $717358d6fc0897cd$var$TEXT_OVERFLOW_STYLE), _a[".".concat(CLASS_NAME.VALUE)] = (0, $7WQrb.__assign)({
        display: 'inline-block',
        float: 'right',
        flex: 1,
        'text-align': 'right',
        'min-width': '28px',
        'margin-left': '30px',
        color: 'rgba(0, 0, 0, 0.85)'
    }, $717358d6fc0897cd$var$TEXT_OVERFLOW_STYLE), _a[".".concat(CLASS_NAME.CROSSHAIR_X)] = {
        position: 'absolute',
        width: '1px',
        'background-color': 'rgba(0, 0, 0, 0.25)'
    }, _a[".".concat(CLASS_NAME.CROSSHAIR_Y)] = {
        position: 'absolute',
        height: '1px',
        'background-color': 'rgba(0, 0, 0, 0.25)'
    }, _a;
}

});



parcelRegister("7mp9z", function(module, exports) {

$parcel$export(module.exports, "Watermark", () => $55be196ca1c2ed2b$export$e94943a72132ebdf);

var $WdqOS = parcelRequire("WdqOS");

var $bEb16 = parcelRequire("bEb16");

var $fNWe9 = parcelRequire("fNWe9");
var $55be196ca1c2ed2b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $55be196ca1c2ed2b$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $55be196ca1c2ed2b$export$e94943a72132ebdf extends (0, $WdqOS.BasePlugin) {
    constructor(context, options){
        super(context, Object.assign({}, $55be196ca1c2ed2b$export$e94943a72132ebdf.defaultOptions, options));
        this.$element = (0, $bEb16.createPluginContainer)('watermark');
        const $container = this.context.canvas.getContainer();
        $container.appendChild(this.$element);
        this.update(options);
    }
    /**
     * <zh/> 更新水印配置
     *
     * <en/> Update the watermark configuration
     * @param options - <zh/> 配置项 | <en/> Options
     * @internal
     */ update(options) {
        const _super = Object.create(null, {
            update: {
                get: ()=>super.update
            }
        });
        return $55be196ca1c2ed2b$var$__awaiter(this, void 0, void 0, function*() {
            _super.update.call(this, options);
            const _a = this.options, { width: width, height: height, text: text, imageURL: imageURL } = _a, rest = $55be196ca1c2ed2b$var$__rest(_a, [
                "width",
                "height",
                "text",
                "imageURL"
            ]);
            // Set the background style.
            Object.keys(rest).forEach((key)=>{
                if (key.startsWith('background')) // @ts-expect-error ignore
                this.$element.style[key] = options[key];
            });
            // Set the background image
            const base64 = imageURL ? yield (0, $fNWe9.getImageWatermark)(width, height, imageURL, rest) : yield (0, $fNWe9.getTextWatermark)(width, height, text, rest);
            this.$element.style.backgroundImage = `url(${base64})`;
        });
    }
    /**
     * <zh/> 销毁水印
     *
     * <en/> Destroy the watermark
     * @internal
     */ destroy() {
        super.destroy();
        // Remove the background dom.
        this.$element.remove();
    }
}
$55be196ca1c2ed2b$export$e94943a72132ebdf.defaultOptions = {
    width: 200,
    height: 100,
    opacity: 0.2,
    rotate: Math.PI / 12,
    text: '',
    textFill: '#000',
    textFontSize: 16,
    textAlign: 'center',
    textBaseline: 'middle',
    backgroundRepeat: 'repeat'
};

});
parcelRegister("fNWe9", function(module, exports) {

$parcel$export(module.exports, "getTextWatermark", () => $b8189953cc63cee8$export$6f519baf1b85315f);
$parcel$export(module.exports, "getImageWatermark", () => $b8189953cc63cee8$export$b4af04126d0b605c);
var $b8189953cc63cee8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Only use one instance.
let $b8189953cc63cee8$var$canvas;
/**
 * Create a canvas instance.
 * @param width - width
 * @param height - height
 * @returns a new Canvas
 */ function $b8189953cc63cee8$var$createCanvas(width, height) {
    if (!$b8189953cc63cee8$var$canvas) $b8189953cc63cee8$var$canvas = document.createElement('canvas');
    $b8189953cc63cee8$var$canvas.width = width;
    $b8189953cc63cee8$var$canvas.height = height;
    const ctx = $b8189953cc63cee8$var$canvas.getContext('2d');
    ctx.clearRect(0, 0, width, height);
    return $b8189953cc63cee8$var$canvas;
}
function $b8189953cc63cee8$export$6f519baf1b85315f(width, height, text, style) {
    return $b8189953cc63cee8$var$__awaiter(this, void 0, void 0, function*() {
        const canvas = $b8189953cc63cee8$var$createCanvas(width, height);
        const ctx = canvas.getContext('2d');
        const { rotate: rotate, opacity: opacity, textFill: textFill, textFontSize: textFontSize, textFontFamily: textFontFamily, textFontVariant: textFontVariant, textFontWeight: textFontWeight, textAlign: textAlign, textBaseline: textBaseline } = style;
        // Set the style.
        // Default is align center and middle.
        ctx.textAlign = textAlign;
        ctx.textBaseline = textBaseline;
        ctx.translate(width / 2, height / 2);
        ctx.font = `${textFontSize}px ${textFontFamily} ${textFontVariant} ${textFontWeight}`;
        rotate && ctx.rotate(rotate);
        opacity && (ctx.globalAlpha = opacity);
        if (textFill) {
            ctx.fillStyle = textFill;
            // Draw the text.
            ctx.fillText(`${text}`, 0, 0);
        }
        // Return the base64.
        return canvas.toDataURL();
    });
}
function $b8189953cc63cee8$export$b4af04126d0b605c(width, height, imageURL, style) {
    return $b8189953cc63cee8$var$__awaiter(this, void 0, void 0, function*() {
        const canvas = $b8189953cc63cee8$var$createCanvas(width, height);
        const ctx = canvas.getContext('2d');
        const { rotate: rotate, opacity: opacity } = style;
        rotate && ctx.rotate(rotate);
        opacity && (ctx.globalAlpha = opacity);
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = imageURL;
        return new Promise((resolve)=>{
            img.onload = function() {
                const sepX = width > img.width ? (width - img.width) / 2 : 0;
                const sepY = height > img.height ? (height - img.height) / 2 : 0;
                ctx.drawImage(img, 0, 0, img.width, img.height, sepX, sepY, width - sepX * 2, height - sepY * 2);
                resolve(canvas.toDataURL());
            };
        });
    });
}

});



parcelRegister("jQdow", function(module, exports) {

$parcel$export(module.exports, "dark", () => (parcelRequire("92uCt")).dark);
$parcel$export(module.exports, "light", () => (parcelRequire("cbrrv")).light);

var $92uCt = parcelRequire("92uCt");

var $cbrrv = parcelRequire("cbrrv");

});
parcelRegister("92uCt", function(module, exports) {

$parcel$export(module.exports, "dark", () => $694c0d63224c3f19$export$55ce6f3a06c59543);

var $P5Y30 = parcelRequire("P5Y30");
const $694c0d63224c3f19$var$EDGE_PALETTE_OPTIONS = {
    type: 'group',
    color: [
        '#637088',
        '#0F55A6',
        '#008383',
        '#9C5D38',
        '#8B53A6',
        '#4E40A6',
        '#8F6608',
        '#3E801D',
        '#A65383',
        '#175E75',
        '#0F8248'
    ]
};
const $694c0d63224c3f19$var$tokens = {
    bgColor: '#000000',
    comboColor: '#fdfdfd',
    comboColorDisabled: '#d0e4ff',
    comboStroke: '#99add1',
    comboStrokeDisabled: '#969696',
    edgeColor: '#637088',
    edgeColorDisabled: '#637088',
    edgeColorInactive: '#D0E4FF',
    edgePaletteOptions: $694c0d63224c3f19$var$EDGE_PALETTE_OPTIONS,
    nodeColor: '#1783ff',
    nodeColorDisabled: '#D0E4FF',
    nodeHaloStrokeOpacityActive: 0.25,
    nodeHaloStrokeOpacitySelected: 0.45,
    nodeIconOpacityInactive: 0.45,
    nodeOpacityDisabled: 0.25,
    nodeOpacityInactive: 0.45,
    nodeStroke: '#d0e4ff',
    textColor: '#ffffff'
};
const $694c0d63224c3f19$export$55ce6f3a06c59543 = (0, $P5Y30.create)($694c0d63224c3f19$var$tokens);

});
parcelRegister("P5Y30", function(module, exports) {

$parcel$export(module.exports, "create", () => $0999648ecc056c6b$export$185802fd694ee1f5);
const $0999648ecc056c6b$var$BADGE_PALETTE = [
    '#7E92B5',
    '#F4664A',
    '#FFBE3A'
];
const $0999648ecc056c6b$var$NODE_PALETTE_OPTIONS = {
    type: 'group',
    color: [
        '#1783FF',
        '#00C9C9',
        '#F08F56',
        '#D580FF',
        '#7863FF',
        '#DB9D0D',
        '#60C42D',
        '#FF80CA',
        '#2491B3',
        '#17C76F'
    ]
};
const $0999648ecc056c6b$var$EDGE_PALETTE_OPTIONS = {
    type: 'group',
    color: [
        '#99ADD1',
        '#1783FF',
        '#00C9C9',
        '#F08F56',
        '#D580FF',
        '#7863FF',
        '#DB9D0D',
        '#60C42D',
        '#FF80CA',
        '#2491B3',
        '#17C76F'
    ]
};
function $0999648ecc056c6b$export$185802fd694ee1f5(tokens) {
    const { bgColor: bgColor, textColor: textColor, nodeColor: nodeColor, nodeColorDisabled: nodeColorDisabled, nodeStroke: nodeStroke, nodeHaloStrokeOpacityActive: nodeHaloStrokeOpacityActive = 0.15, nodeHaloStrokeOpacitySelected: nodeHaloStrokeOpacitySelected = 0.25, nodeOpacityDisabled: nodeOpacityDisabled = 0.06, nodeIconOpacityInactive: nodeIconOpacityInactive = 0.85, nodeOpacityInactive: nodeOpacityInactive = 0.25, nodeBadgePalette: nodeBadgePalette = $0999648ecc056c6b$var$BADGE_PALETTE, nodePaletteOptions: nodePaletteOptions = $0999648ecc056c6b$var$NODE_PALETTE_OPTIONS, edgeColor: edgeColor, edgeColorDisabled: edgeColorDisabled, edgePaletteOptions: edgePaletteOptions = $0999648ecc056c6b$var$EDGE_PALETTE_OPTIONS, comboColor: comboColor, comboColorDisabled: comboColorDisabled, comboStroke: comboStroke, comboStrokeDisabled: comboStrokeDisabled, edgeColorInactive: edgeColorInactive } = tokens;
    return {
        background: bgColor,
        node: {
            palette: nodePaletteOptions,
            style: {
                donutOpacity: 1,
                badgeBackgroundOpacity: 1,
                badgeFill: '#fff',
                badgeFontSize: 8,
                badgePadding: [
                    0,
                    4
                ],
                badgePalette: nodeBadgePalette,
                fill: nodeColor,
                fillOpacity: 1,
                halo: false,
                iconFill: '#fff',
                iconOpacity: 1,
                labelBackground: false,
                labelBackgroundFill: bgColor,
                labelBackgroundLineWidth: 0,
                labelBackgroundOpacity: 0.75,
                labelFill: textColor,
                labelFillOpacity: 0.85,
                labelLineHeight: 16,
                labelPadding: [
                    0,
                    2
                ],
                labelFontSize: 12,
                labelFontWeight: 400,
                labelOpacity: 1,
                labelOffsetY: 2,
                lineWidth: 0,
                portFill: nodeColor,
                portLineWidth: 1,
                portStroke: nodeStroke,
                portStrokeOpacity: 0.65,
                size: 32,
                stroke: nodeStroke,
                strokeOpacity: 1,
                zIndex: 2
            },
            state: {
                selected: {
                    halo: true,
                    haloLineWidth: 24,
                    haloStrokeOpacity: nodeHaloStrokeOpacitySelected,
                    labelFontSize: 12,
                    labelFontWeight: 'bold',
                    lineWidth: 4,
                    stroke: nodeStroke
                },
                active: {
                    halo: true,
                    haloLineWidth: 12,
                    haloStrokeOpacity: nodeHaloStrokeOpacityActive
                },
                highlight: {
                    labelFontWeight: 'bold',
                    lineWidth: 4,
                    stroke: nodeStroke,
                    strokeOpacity: 0.85
                },
                inactive: {
                    badgeBackgroundOpacity: nodeOpacityInactive,
                    donutOpacity: nodeOpacityInactive,
                    fillOpacity: nodeOpacityInactive,
                    iconOpacity: nodeIconOpacityInactive,
                    labelFill: textColor,
                    labelFillOpacity: nodeOpacityInactive,
                    strokeOpacity: nodeOpacityInactive
                },
                disabled: {
                    badgeBackgroundOpacity: 0.25,
                    donutOpacity: nodeOpacityDisabled,
                    fill: nodeColorDisabled,
                    fillOpacity: nodeOpacityDisabled,
                    iconFill: nodeColorDisabled,
                    iconOpacity: 0.25,
                    labelFill: textColor,
                    labelFillOpacity: 0.25,
                    strokeOpacity: nodeOpacityDisabled
                }
            },
            animation: {
                enter: 'fade',
                exit: 'fade',
                show: 'fade',
                hide: 'fade',
                expand: 'node-expand',
                collapse: 'node-collapse',
                update: [
                    {
                        fields: [
                            'x',
                            'y',
                            'fill',
                            'stroke'
                        ]
                    }
                ],
                translate: [
                    {
                        fields: [
                            'x',
                            'y'
                        ]
                    }
                ]
            }
        },
        edge: {
            palette: edgePaletteOptions,
            style: {
                badgeBackgroundFill: edgeColor,
                badgeFill: '#fff',
                badgeFontSize: 8,
                badgeOffsetX: 10,
                badgeBackgroundOpacity: 1,
                fillOpacity: 1,
                halo: false,
                haloLineWidth: 12,
                haloStrokeOpacity: 1,
                increasedLineWidthForHitTesting: 2,
                labelBackground: false,
                labelBackgroundFill: bgColor,
                labelBackgroundLineWidth: 0,
                labelBackgroundOpacity: 0.75,
                labelBackgroundPadding: [
                    4,
                    4,
                    4,
                    4
                ],
                labelFill: textColor,
                labelFontSize: 12,
                labelFontWeight: 400,
                labelOpacity: 1,
                labelPlacement: 'center',
                labelTextBaseline: 'middle',
                lineWidth: 1,
                stroke: edgeColor,
                strokeOpacity: 1,
                zIndex: 1
            },
            state: {
                selected: {
                    halo: true,
                    haloStrokeOpacity: 0.25,
                    labelFontSize: 14,
                    labelFontWeight: 'bold',
                    lineWidth: 3
                },
                active: {
                    halo: true,
                    haloStrokeOpacity: 0.15
                },
                highlight: {
                    labelFontWeight: 'bold',
                    lineWidth: 3
                },
                inactive: {
                    stroke: edgeColorInactive,
                    fillOpacity: 0.08,
                    labelOpacity: 0.25,
                    strokeOpacity: 0.08,
                    badgeBackgroundOpacity: 0.25
                },
                disabled: {
                    stroke: edgeColorDisabled,
                    fillOpacity: 0.45,
                    strokeOpacity: 0.45,
                    labelOpacity: 0.25,
                    badgeBackgroundOpacity: 0.45
                }
            },
            animation: {
                enter: 'fade',
                exit: 'fade',
                expand: 'path-in',
                collapse: 'path-out',
                show: 'fade',
                hide: 'fade',
                update: [
                    {
                        fields: [
                            'sourceNode',
                            'targetNode'
                        ]
                    },
                    {
                        fields: [
                            'stroke'
                        ],
                        shape: 'key'
                    }
                ],
                translate: [
                    {
                        fields: [
                            'sourceNode',
                            'targetNode'
                        ]
                    }
                ]
            }
        },
        combo: {
            style: {
                collapsedMarkerFill: bgColor,
                collapsedMarkerFontSize: 12,
                collapsedMarkerFillOpacity: 1,
                collapsedSize: 32,
                collapsedFillOpacity: 1,
                fill: comboColor,
                halo: false,
                haloLineWidth: 12,
                haloStroke: comboStroke,
                haloStrokeOpacity: 0.25,
                labelBackground: false,
                labelBackgroundFill: bgColor,
                labelBackgroundLineWidth: 0,
                labelBackgroundOpacity: 0.75,
                labelBackgroundPadding: [
                    2,
                    4,
                    2,
                    4
                ],
                labelFill: textColor,
                labelFontSize: 12,
                labelFontWeight: 400,
                labelOpacity: 1,
                lineDash: 0,
                lineWidth: 1,
                fillOpacity: 0.04,
                strokeOpacity: 1,
                padding: 10,
                stroke: comboStroke
            },
            state: {
                selected: {
                    halo: true,
                    labelFontSize: 14,
                    labelFontWeight: 700,
                    lineWidth: 4
                },
                active: {
                    halo: true
                },
                highlight: {
                    labelFontWeight: 700,
                    lineWidth: 4
                },
                inactive: {
                    fillOpacity: 0.65,
                    labelOpacity: 0.25,
                    strokeOpacity: 0.65
                },
                disabled: {
                    fill: comboColorDisabled,
                    fillOpacity: 0.25,
                    labelOpacity: 0.25,
                    stroke: comboStrokeDisabled,
                    strokeOpacity: 0.25
                }
            },
            animation: {
                enter: 'fade',
                exit: 'fade',
                show: 'fade',
                hide: 'fade',
                expand: 'combo-expand',
                collapse: 'combo-collapse',
                update: [
                    {
                        fields: [
                            'x',
                            'y'
                        ]
                    },
                    {
                        fields: [
                            'fill',
                            'stroke',
                            'lineWidth'
                        ],
                        shape: 'key'
                    }
                ],
                translate: [
                    {
                        fields: [
                            'x',
                            'y'
                        ]
                    }
                ]
            }
        }
    };
}

});


parcelRegister("cbrrv", function(module, exports) {

$parcel$export(module.exports, "light", () => $8debcca65f7f6928$export$a43af521ac8c3202);

var $P5Y30 = parcelRequire("P5Y30");
const $8debcca65f7f6928$var$tokens = {
    bgColor: '#ffffff',
    comboColor: '#99ADD1',
    comboColorDisabled: '#f0f0f0',
    comboStroke: '#99add1',
    comboStrokeDisabled: '#d9d9d9',
    edgeColor: '#99add1',
    edgeColorDisabled: '#d9d9d9',
    edgeColorInactive: '#1B324F',
    nodeColor: '#1783ff',
    nodeColorDisabled: '#1B324F',
    nodeHaloStrokeOpacityActive: 0.15,
    nodeHaloStrokeOpacitySelected: 0.25,
    nodeIconOpacityInactive: 0.85,
    nodeOpacityDisabled: 0.06,
    nodeOpacityInactive: 0.25,
    nodeStroke: '#000000',
    textColor: '#000000'
};
const $8debcca65f7f6928$export$a43af521ac8c3202 = (0, $P5Y30.create)($8debcca65f7f6928$var$tokens);

});


parcelRegister("dVtfL", function(module, exports) {

$parcel$export(module.exports, "ArrangeDrawOrder", () => (parcelRequire("5OxDh")).ArrangeDrawOrder);
$parcel$export(module.exports, "CollapseExpandCombo", () => (parcelRequire("hBwIB")).CollapseExpandCombo);
$parcel$export(module.exports, "CollapseExpandNode", () => (parcelRequire("5wIhF")).CollapseExpandNode);
$parcel$export(module.exports, "GetEdgeActualEnds", () => (parcelRequire("3ykVL")).GetEdgeActualEnds);
$parcel$export(module.exports, "MapNodeSize", () => (parcelRequire("7Sobs")).MapNodeSize);
$parcel$export(module.exports, "PlaceRadialLabels", () => (parcelRequire("5EwC3")).PlaceRadialLabels);
$parcel$export(module.exports, "ProcessParallelEdges", () => (parcelRequire("96oLK")).ProcessParallelEdges);
$parcel$export(module.exports, "UpdateRelatedEdge", () => (parcelRequire("inULK")).UpdateRelatedEdge);

var $5OxDh = parcelRequire("5OxDh");

var $kzVEQ = parcelRequire("kzVEQ");

var $hBwIB = parcelRequire("hBwIB");

var $5wIhF = parcelRequire("5wIhF");

var $3ykVL = parcelRequire("3ykVL");

var $7Sobs = parcelRequire("7Sobs");

var $5EwC3 = parcelRequire("5EwC3");

var $96oLK = parcelRequire("96oLK");

var $inULK = parcelRequire("inULK");

});
parcelRegister("5OxDh", function(module, exports) {

$parcel$export(module.exports, "ArrangeDrawOrder", () => $43bbb5ff3edc8ebd$export$6408b5465295706a);

var $brtTw = parcelRequire("brtTw");

var $kzVEQ = parcelRequire("kzVEQ");
class $43bbb5ff3edc8ebd$export$6408b5465295706a extends (0, $kzVEQ.BaseTransform) {
    beforeDraw(input) {
        const { model: model } = this.context;
        const combosToAdd = input.add.combos;
        const arrangeCombo = (combos)=>{
            // id, data, zIndex
            const order = [];
            combos.forEach((combo, id)=>{
                const ancestors = model.getAncestorsData(id, 'combo');
                const path = ancestors.map((ancestor)=>(0, $brtTw.idOf)(ancestor)).reverse();
                // combo 的 zIndex 为距离根 combo 的深度
                // The zIndex of the combo is the depth from the root combo
                order.push([
                    id,
                    combo,
                    path.length
                ]);
            });
            return new Map(order// 基于 zIndex 降序排序，优先绘制子 combo / Sort based on zIndex in descending order, draw child combo first
            .sort(([, , zIndex1], [, , zIndex2])=>zIndex2 - zIndex1).map(([id, datum])=>[
                    id,
                    datum
                ]));
        };
        input.add.combos = arrangeCombo(combosToAdd);
        input.update.combos = arrangeCombo(input.update.combos);
        return input;
    }
}

});
parcelRegister("kzVEQ", function(module, exports) {

$parcel$export(module.exports, "BaseTransform", () => $efb3cd27d590b212$export$66879e0d35917e92);

var $dhEO8 = parcelRequire("dhEO8");
class $efb3cd27d590b212$export$66879e0d35917e92 extends (0, $dhEO8.BaseExtension) {
    beforeDraw(data, context) {
        return data;
    }
    afterLayout(type, data) {}
}

});


parcelRegister("hBwIB", function(module, exports) {

$parcel$export(module.exports, "CollapseExpandCombo", () => $cd0f4595bb655b6a$export$44965b94b4add17a);
parcelRequire("ahJ7k");
var $lDPR9 = parcelRequire("lDPR9");

var $VNNBO = parcelRequire("VNNBO");

var $25dP3 = parcelRequire("25dP3");

var $brtTw = parcelRequire("brtTw");

var $kzVEQ = parcelRequire("kzVEQ");

var $evi0t = parcelRequire("evi0t");
class $cd0f4595bb655b6a$export$44965b94b4add17a extends (0, $kzVEQ.BaseTransform) {
    beforeDraw(input, context) {
        if (context.stage === 'visibility') return input;
        if (!this.context.model.model.hasTreeStructure((0, $lDPR9.COMBO_KEY))) return input;
        const { model: model } = this.context;
        const { add: add, update: update } = input;
        // combo 添加和更新的顺序为先子后父，因此采用倒序遍历
        // The order of adding and updating combos is first child and then parent, so reverse traversal is used
        const combos = [
            ...input.update.combos.entries(),
            ...input.add.combos.entries()
        ];
        while(combos.length){
            const [id, combo] = combos.pop();
            if ((0, $VNNBO.isCollapsed)(combo)) {
                const descendants = model.getDescendantsData(id);
                const descendantIds = descendants.map((0, $brtTw.idOf));
                const { internal: internal, external: external } = (0, $25dP3.getSubgraphRelatedEdges)(descendantIds, (id)=>model.getRelatedEdgesData(id));
                // 移除所有后代元素 / Remove all descendant elements
                descendants.forEach((descendant)=>{
                    const descendantId = (0, $brtTw.idOf)(descendant);
                    // 不再处理当前 combo 的后代 combo
                    // No longer process the descendant combo of the current combo
                    const comboIndex = combos.findIndex(([id])=>id === descendantId);
                    if (comboIndex !== -1) combos.splice(comboIndex, 1);
                    const elementType = model.getElementType(descendantId);
                    (0, $evi0t.reassignTo)(input, 'remove', elementType, descendant);
                });
                // 如果是内部边/节点 销毁
                // If it is an internal edge/node, destroy it
                internal.forEach((edge)=>(0, $evi0t.reassignTo)(input, 'remove', 'edge', edge));
                // 如果是外部边，连接到收起对象上
                // If it is an external edge, connect to the collapsed object
                external.forEach((edge)=>{
                    var _a;
                    const id = (0, $brtTw.idOf)(edge);
                    const edgeElement = (_a = this.context.element) === null || _a === void 0 ? void 0 : _a.getElement(id);
                    if (edgeElement) update.edges.set(id, edge);
                    else add.edges.set(id, edge);
                });
            } else {
                const children = model.getChildrenData(id);
                const childrenIds = children.map((0, $brtTw.idOf));
                const { edges: edges } = (0, $25dP3.getSubgraphRelatedEdges)(childrenIds, (id)=>model.getRelatedEdgesData(id));
                [
                    ...children,
                    ...edges
                ].forEach((descendant)=>{
                    var _a;
                    const id = (0, $brtTw.idOf)(descendant);
                    const elementType = model.getElementType(id);
                    const element = (_a = this.context.element) === null || _a === void 0 ? void 0 : _a.getElement(id);
                    // 如果节点不存在，则添加到新增列表，如果存在，添加到更新列表
                    // If the node does not exist, add it to the new list, if it exists, add it to the update list
                    if (element) (0, $evi0t.reassignTo)(input, 'update', elementType, descendant);
                    else (0, $evi0t.reassignTo)(input, 'add', elementType, descendant);
                    // 继续展开子节点 / Continue to expand child nodes
                    if (elementType === 'combo') combos.push([
                        id,
                        descendant
                    ]);
                });
            }
        }
        return input;
    }
}

});
parcelRegister("evi0t", function(module, exports) {

$parcel$export(module.exports, "reassignTo", () => $a8f1edaecbe78e91$export$87efa8438ce91570);
$parcel$export(module.exports, "isStyleEqual", () => $a8f1edaecbe78e91$export$781298f23b06b645);

var $brtTw = parcelRequire("brtTw");
function $a8f1edaecbe78e91$export$87efa8438ce91570(input, type, elementType, datum, overwrite) {
    const id = (0, $brtTw.idOf)(datum);
    const typeName = `${elementType}s`;
    const exitsDatum = overwrite ? datum : input.add[typeName].get(id) || input.update[typeName].get(id) || input.remove[typeName].get(id) || datum;
    Object.entries(input).forEach(([_type, value])=>{
        if (type === _type) value[typeName].set(id, exitsDatum);
        else value[typeName].delete(id);
    });
}
function $a8f1edaecbe78e91$export$781298f23b06b645(style, originalStyle) {
    return Object.keys(style).every((key)=>style[key] === originalStyle[key]);
}

});


parcelRegister("5wIhF", function(module, exports) {

$parcel$export(module.exports, "CollapseExpandNode", () => $40624acd972f533d$export$c006a266a9c0c0f4);
parcelRequire("ahJ7k");
var $lDPR9 = parcelRequire("lDPR9");

var $VNNBO = parcelRequire("VNNBO");

var $brtTw = parcelRequire("brtTw");

var $kzVEQ = parcelRequire("kzVEQ");

var $evi0t = parcelRequire("evi0t");
// 如果在任务列表中不存在，则添加到任务列表
// If it does not exist in the task list, add it to the task list
const $40624acd972f533d$var$weakAssignTo = (input, type, elementType, datum)=>{
    const typeName = `${elementType}s`;
    const id = (0, $brtTw.idOf)(datum);
    if (!input.add[typeName].has(id) && !input.update[typeName].has(id)) input[type][typeName].set((0, $brtTw.idOf)(datum), datum);
};
class $40624acd972f533d$export$c006a266a9c0c0f4 extends (0, $kzVEQ.BaseTransform) {
    getElement(id) {
        return this.context.element.getElement(id);
    }
    handleExpand(node, input) {
        $40624acd972f533d$var$weakAssignTo(input, 'add', 'node', node);
        if ((0, $VNNBO.isCollapsed)(node)) return;
        const id = (0, $brtTw.idOf)(node);
        $40624acd972f533d$var$weakAssignTo(input, 'add', 'node', node);
        const relatedEdges = this.context.model.getRelatedEdgesData(id);
        relatedEdges.forEach((edge)=>{
            (0, $evi0t.reassignTo)(input, 'add', 'edge', edge);
        });
        const children = this.context.model.getChildrenData(id);
        children.forEach((child)=>{
            this.handleExpand(child, input);
        });
    }
    beforeDraw(input) {
        const { graph: graph, model: model } = this.context;
        if (!model.model.hasTreeStructure((0, $lDPR9.TREE_KEY))) return input;
        const { add: { nodes: nodesToAdd, edges: edgesToAdd }, update: { nodes: nodesToUpdate } } = input;
        const nodesToCollapse = new Map();
        const nodesToExpand = new Map();
        nodesToAdd.forEach((node, id)=>{
            if ((0, $VNNBO.isCollapsed)(node)) nodesToCollapse.set(id, node);
        });
        // 如果创建了一条连接到收起的节点的边，则将其添加到待展开列表
        // If an edge is created that connects to a collapsed node, add it to the list to be expanded
        edgesToAdd.forEach((edge)=>{
            if (graph.getElementType(edge.source) !== 'node') return;
            const source = graph.getNodeData(edge.source);
            if ((0, $VNNBO.isCollapsed)(source)) nodesToCollapse.set(edge.source, source);
        });
        nodesToUpdate.forEach((node, id)=>{
            const nodeElement = this.getElement(id);
            if (!nodeElement) return;
            const isCurrentCollapsed = nodeElement.attributes.collapsed;
            if ((0, $VNNBO.isCollapsed)(node)) {
                if (!isCurrentCollapsed) nodesToCollapse.set(id, node);
            } else if (isCurrentCollapsed) nodesToExpand.set(id, node);
        });
        const handledNodes = new Set();
        nodesToCollapse.forEach((node, id)=>{
            // 将子节点添加到待删除列表，并删除关联的边
            // Add child nodes to the list to be deleted，and delete the associated edges
            const descendants = model.getDescendantsData(id);
            descendants.forEach((descendant)=>{
                const id = (0, $brtTw.idOf)(descendant);
                if (handledNodes.has(id)) return;
                (0, $evi0t.reassignTo)(input, 'remove', 'node', descendant);
                const relatedEdges = model.getRelatedEdgesData(id);
                relatedEdges.forEach((edge)=>{
                    (0, $evi0t.reassignTo)(input, 'remove', 'edge', edge);
                });
                handledNodes.add(id);
            });
        });
        nodesToExpand.forEach((node, id)=>{
            const ancestors = model.getAncestorsData(id, (0, $lDPR9.TREE_KEY));
            // 如果祖先节点是收起的，添加到移除列表
            // If the ancestor node is collapsed, add it to the removal list
            if (ancestors.some((0, $VNNBO.isCollapsed))) {
                (0, $evi0t.reassignTo)(input, 'remove', 'node', node);
                return;
            }
            this.handleExpand(node, input);
        });
        return input;
    }
}

});

parcelRegister("3ykVL", function(module, exports) {

$parcel$export(module.exports, "GetEdgeActualEnds", () => $2964c87b2f0c8deb$export$fcc020c2bc32e91);
$parcel$export(module.exports, "getEdgeEndsContext", () => $2964c87b2f0c8deb$export$155e0d07278fb6cb);
parcelRequire("ahJ7k");
var $lDPR9 = parcelRequire("lDPR9");
parcelRequire("7ElQg");
var $brtTw = parcelRequire("brtTw");

var $25dP3 = parcelRequire("25dP3");

var $kzVEQ = parcelRequire("kzVEQ");
class $2964c87b2f0c8deb$export$fcc020c2bc32e91 extends (0, $kzVEQ.BaseTransform) {
    beforeDraw(input) {
        const { add: add, update: update } = input;
        const { model: model } = this.context;
        [
            ...add.edges.entries(),
            ...update.edges.entries()
        ].forEach(([, edge])=>{
            $2964c87b2f0c8deb$export$155e0d07278fb6cb(model, edge);
        });
        return input;
    }
}
const $2964c87b2f0c8deb$export$155e0d07278fb6cb = (model, edge)=>{
    const { source: source, target: target } = edge;
    const sourceNodeData = model.getElementDataById(source);
    const targetNodeData = model.getElementDataById(target);
    const actualSourceNode = (0, $25dP3.findActualConnectNodeData)(sourceNodeData, (id)=>model.getParentData(id, (0, $lDPR9.COMBO_KEY)));
    const actualTargetNode = (0, $25dP3.findActualConnectNodeData)(targetNodeData, (id)=>model.getParentData(id, (0, $lDPR9.COMBO_KEY)));
    const sourceNode = (0, $brtTw.idOf)(actualSourceNode);
    const targetNode = (0, $brtTw.idOf)(actualTargetNode);
    const ends = {
        sourceNode: sourceNode,
        targetNode: targetNode
    };
    if (edge.style) Object.assign(edge.style, ends);
    else edge.style = ends;
    return edge;
};

});
parcelRegister("7ElQg", function(module, exports) {

$parcel$export(module.exports, "Graph", () => (parcelRequire("cA8ew")).Graph);
$parcel$export(module.exports, "idOf", () => (parcelRequire("brtTw")).idOf);
parcelRequire("kVOIy");
var $cAn0T = parcelRequire("cAn0T");
var $hQIOr = parcelRequire("hQIOr");
var $8FmDy = parcelRequire("8FmDy");
var $hgdlM = parcelRequire("hgdlM");
var $0y4XY = parcelRequire("0y4XY");
var $h3bBs = parcelRequire("h3bBs");
var $1hotb = parcelRequire("1hotb");
var $hDdHF = parcelRequire("hDdHF");
var $g3gkU = parcelRequire("g3gkU");
var $apMdk = parcelRequire("apMdk");
var $hDdip = parcelRequire("hDdip");
var $5DaKb = parcelRequire("5DaKb");
var $8yr5d = parcelRequire("8yr5d");
var $bC6xM = parcelRequire("bC6xM");
var $62Rza = parcelRequire("62Rza");
var $02HiP = parcelRequire("02HiP");
parcelRequire("ahJ7k");
var $1igYm = parcelRequire("1igYm");
var $jjMBX = parcelRequire("jjMBX");
var $9Iel2 = parcelRequire("9Iel2");
var $je0UY = parcelRequire("je0UY");
var $5vtWi = parcelRequire("5vtWi");
var $jRLln = parcelRequire("jRLln");
var $4EzN9 = parcelRequire("4EzN9");
var $5TVj3 = parcelRequire("5TVj3");
var $eO2am = parcelRequire("eO2am");
parcelRequire("jC8VT");
var $jK4lK = parcelRequire("jK4lK");
var $f2zuq = parcelRequire("f2zuq");
var $4zzq7 = parcelRequire("4zzq7");
parcelRequire("l6dDw");
var $clFkI = parcelRequire("clFkI");
var $4tI2g = parcelRequire("4tI2g");
var $hjONv = parcelRequire("hjONv");
var $bs4me = parcelRequire("bs4me");
var $ln2PG = parcelRequire("ln2PG");
var $95A9Q = parcelRequire("95A9Q");
var $5felS = parcelRequire("5felS");
var $Fb2Dh = parcelRequire("Fb2Dh");

var $7uTzp = parcelRequire("7uTzp");
parcelRequire("kcFIc");
var $63haX = parcelRequire("63haX");
var $dbxRO = parcelRequire("dbxRO");
var $8nW3T = parcelRequire("8nW3T");
var $483tH = parcelRequire("483tH");
var $hoxMw = parcelRequire("hoxMw");
var $bHEt9 = parcelRequire("bHEt9");
var $R3ntv = parcelRequire("R3ntv");
var $gF4ts = parcelRequire("gF4ts");
var $3VmXJ = parcelRequire("3VmXJ");
var $d1sdh = parcelRequire("d1sdh");
var $dIvRz = parcelRequire("dIvRz");
parcelRequire("hIZ0D");
var $2jk2f = parcelRequire("2jk2f");
var $3D5nF = parcelRequire("3D5nF");
var $1TY6s = parcelRequire("1TY6s");
var $1DkzN = parcelRequire("1DkzN");
parcelRequire("2oT5h");
var $3MWMO = parcelRequire("3MWMO");
var $ht4Ur = parcelRequire("ht4Ur");
var $1IlsW = parcelRequire("1IlsW");
var $5n8Ib = parcelRequire("5n8Ib");
var $hFThh = parcelRequire("hFThh");
var $kd0OI = parcelRequire("kd0OI");
var $hhpea = parcelRequire("hhpea");
var $iMTgF = parcelRequire("iMTgF");
var $7C1fc = parcelRequire("7C1fc");
var $eyWFr = parcelRequire("eyWFr");
var $irTWF = parcelRequire("irTWF");
var $eifoa = parcelRequire("eifoa");
var $e7HzC = parcelRequire("e7HzC");
var $k9H1V = parcelRequire("k9H1V");
var $1aclp = parcelRequire("1aclp");
var $4JXd9 = parcelRequire("4JXd9");
var $2D9MF = parcelRequire("2D9MF");
parcelRequire("i257J");
var $3uNWk = parcelRequire("3uNWk");
var $WdqOS = parcelRequire("WdqOS");
var $isds8 = parcelRequire("isds8");
var $fuTQ7 = parcelRequire("fuTQ7");
var $4XBSa = parcelRequire("4XBSa");
var $1uN78 = parcelRequire("1uN78");
var $cCF4r = parcelRequire("cCF4r");
var $5OSjO = parcelRequire("5OSjO");
var $bbw6O = parcelRequire("bbw6O");
var $86w7z = parcelRequire("86w7z");
var $cqIFg = parcelRequire("cqIFg");
var $7ZR3h = parcelRequire("7ZR3h");
var $7C4rJ = parcelRequire("7C4rJ");
var $gICz0 = parcelRequire("gICz0");
var $bU3Ie = parcelRequire("bU3Ie");
var $7Ns1A = parcelRequire("7Ns1A");
var $ly6UE = parcelRequire("ly6UE");
var $4Phbm = parcelRequire("4Phbm");
var $fha4x = parcelRequire("fha4x");
var $7mp9z = parcelRequire("7mp9z");

var $hW6vf = parcelRequire("hW6vf");

var $4H9Ri = parcelRequire("4H9Ri");

var $6BfoV = parcelRequire("6BfoV");

var $cA8ew = parcelRequire("cA8ew");
parcelRequire("dVtfL");
var $kzVEQ = parcelRequire("kzVEQ");
var $7Sobs = parcelRequire("7Sobs");
var $5EwC3 = parcelRequire("5EwC3");
var $96oLK = parcelRequire("96oLK");

var $VNNBO = parcelRequire("VNNBO");

var $brtTw = parcelRequire("brtTw");

var $fYedv = parcelRequire("fYedv");

var $46bcR = parcelRequire("46bcR");

var $icwVF = parcelRequire("icwVF");

var $lXl1S = parcelRequire("lXl1S");

var $e6Msm = parcelRequire("e6Msm");

var $2E0Sw = parcelRequire("2E0Sw");

var $kzdag = parcelRequire("kzdag");

});
parcelRegister("7uTzp", function(module, exports) {
const $575670d208385f35$var$EFFECT_WEAKMAP = new WeakMap();
function $575670d208385f35$export$dc573d8a6576cdb3(target, key, style) {
    // return true;
    if (!$575670d208385f35$var$EFFECT_WEAKMAP.has(target)) $575670d208385f35$var$EFFECT_WEAKMAP.set(target, {});
    const cache = $575670d208385f35$var$EFFECT_WEAKMAP.get(target);
    if (!cache[key]) {
        cache[key] = style;
        return true;
    }
    const original = cache[key];
    if ($575670d208385f35$var$isStyleEqual(original, style)) return false;
    cache[key] = style;
    return true;
}
/**
 * <zh/> 比较两个样式属性是否相等
 *
 * <en/> Compare whether two style attributes are equal
 * @param a - <zh/> 样式属性 a | <en/> Style attribute a
 * @param b - <zh/> 样式属性 b | <en/> Style attribute b
 * @param depth - <zh/> 比较深度 | <en/> Comparison depth
 * @returns <zh/> 是否相等 | <en/> Whether they are equal
 * @remarks
 * <zh/> 进行第二层浅比较用于比较 badges、ports 等复合图形属性
 *
 * <en/> Perform a second-level shallow comparison to compare complex shape attributes such as badges and ports
 */ const $575670d208385f35$var$isStyleEqual = (a, b, depth = 2)=>{
    if (typeof a !== 'object' || typeof b !== 'object') return a === b;
    const keys1 = Object.keys(a);
    const keys2 = Object.keys(b);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = a[key];
        const val2 = b[key];
        if (depth > 1 && typeof val1 === 'object' && typeof val2 === 'object') {
            if (!$575670d208385f35$var$isStyleEqual(val1, val2, depth - 1)) return false;
        } else if (val1 !== val2) return false;
    }
    return true;
};

});

parcelRegister("4H9Ri", function(module, exports) {

$parcel$export(module.exports, "register", () => $36b2d3460adc8590$export$6503ec6e8aabbaf);

var $aBpmX = parcelRequire("aBpmX");

var $e3xJb = parcelRequire("e3xJb");
function $36b2d3460adc8590$export$6503ec6e8aabbaf(category, type, Ctor) {
    const ext = (0, $e3xJb.EXTENSION_REGISTRY)[category][type];
    if (ext) (0, $aBpmX.print).warn(`The extension ${type} of ${category} has been registered before, and will be overridden.`);
    Object.assign((0, $e3xJb.EXTENSION_REGISTRY)[category], {
        [type]: Ctor
    });
}

});

parcelRegister("6BfoV", function(module, exports) {

$parcel$export(module.exports, "Canvas", () => $4ce22517a458a77a$export$8d01c972ee8b14a9);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $ci3lc = parcelRequire("ci3lc");

var $3BKTp = parcelRequire("3BKTp");

var $3vLaV = parcelRequire("3vLaV");

var $6BVcW = parcelRequire("6BVcW");

var $dnXls = parcelRequire("dnXls");
var $4ce22517a458a77a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $4ce22517a458a77a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
const $4ce22517a458a77a$var$SINGLE_LAYER_NAME = [
    'main'
];
const $4ce22517a458a77a$var$MULTI_LAYER_NAME = [
    'background',
    'main',
    'label',
    'transient'
];
/**
 * <zh/> 获取主画布图层
 *
 * <en/> Get the main canvas layer
 * @param layers - <zh/> 画布图层 | <en/> Canvas layer
 * @returns <zh/> 主画布图层 | <en/> Main canvas layer
 */ function $4ce22517a458a77a$var$getMainLayerOf(layers) {
    return layers.main;
}
class $4ce22517a458a77a$export$8d01c972ee8b14a9 {
    getConfig() {
        return this.config;
    }
    getLayer(layer = 'main') {
        return this.extends.layers[layer] || $4ce22517a458a77a$var$getMainLayerOf(this.getLayers());
    }
    /**
     * <zh/> 获取所有图层
     *
     * <en/> Get all layers
     * @returns <zh/> 图层 <en/> Layer
     */ getLayers() {
        return this.extends.layers;
    }
    /**
     * <zh/> 获取渲染器
     *
     * <en/> Get renderer
     * @param layer - <zh/> 图层 <en/> Layer
     * @returns <zh/> 渲染器 <en/> Renderer
     */ getRenderer(layer) {
        return this.extends.renderers[layer];
    }
    /**
     * <zh/> 获取相机
     *
     * <en/> Get camera
     * @param layer - <zh/> 图层 <en/> Layer
     * @returns <zh/> 相机 <en/> Camera
     */ getCamera(layer = 'main') {
        return this.getLayer(layer).getCamera();
    }
    getRoot(layer = 'main') {
        return this.getLayer(layer).getRoot();
    }
    getContextService(layer = 'main') {
        return this.getLayer(layer).getContextService();
    }
    setCursor(cursor) {
        this.config.cursor = cursor;
        this.getLayer().setCursor(cursor);
    }
    get document() {
        return this.getLayer().document;
    }
    get context() {
        return this.getLayer().context;
    }
    constructor(config){
        this.config = {
            enableMultiLayer: true
        };
        Object.assign(this.config, config);
        const _a = this.config, { renderer: renderer, background: background, cursor: cursor, enableMultiLayer: enableMultiLayer } = _a, restConfig = $4ce22517a458a77a$var$__rest(_a, [
            "renderer",
            "background",
            "cursor",
            "enableMultiLayer"
        ]);
        const layersName = enableMultiLayer ? $4ce22517a458a77a$var$MULTI_LAYER_NAME : $4ce22517a458a77a$var$SINGLE_LAYER_NAME;
        const renderers = $4ce22517a458a77a$var$createRenderers(renderer, layersName);
        const layers = Object.fromEntries(layersName.map((layer)=>{
            const canvas = new (0, $2eDEB.Canvas)(Object.assign(Object.assign({}, restConfig), {
                supportsMutipleCanvasesInOneContainer: enableMultiLayer,
                renderer: renderers[layer],
                background: enableMultiLayer ? layer === 'background' ? background : undefined : background
            }));
            return [
                layer,
                canvas
            ];
        }));
        $4ce22517a458a77a$var$configCanvasDom(layers);
        this.extends = {
            config: this.config,
            renderer: renderer,
            renderers: renderers,
            layers: layers
        };
    }
    get ready() {
        return Promise.all(Object.entries(this.getLayers()).map(([, canvas])=>canvas.ready));
    }
    resize(width, height) {
        Object.assign(this.extends.config, {
            width: width,
            height: height
        });
        Object.values(this.getLayers()).forEach((canvas)=>{
            const camera = canvas.getCamera();
            const position = camera.getPosition();
            const focalPoint = camera.getFocalPoint();
            canvas.resize(width, height);
            camera.setPosition(position);
            camera.setFocalPoint(focalPoint);
        });
    }
    /**
     * <zh/> 获取画布边界
     *
     * <en/> Get canvas boundary
     * @param group
     * <zh/> 元素分组
     * - undefined: 获取整个画布边界
     * - 'elements': 仅获取元素边界
     * - 'plugins': 仅获取插件边界
     *
     * <en/> Element group
     * - undefined: Get the entire canvas boundary
     * - 'elements': Get only the element boundary
     * - 'plugins': Get only the plugin boundary
     * @returns <zh/> 边界 <en/> Boundary
     */ getBounds(group) {
        return (0, $6BVcW.getCombinedBBox)(Object.values(this.getLayers()).map((canvas)=>{
            const g = group ? canvas.getRoot().childNodes.find((node)=>node.classList.includes(group)) : canvas.getRoot();
            return g;
        }).filter((el)=>(el === null || el === void 0 ? void 0 : el.childNodes.length) > 0).map((el)=>el.getBounds()));
    }
    getContainer() {
        const container = this.extends.config.container;
        return typeof container === 'string' ? document.getElementById(container) : container;
    }
    getSize() {
        return [
            this.extends.config.width || 0,
            this.extends.config.height || 0
        ];
    }
    appendChild(child, index) {
        var _a;
        const layer = ((_a = child.style) === null || _a === void 0 ? void 0 : _a.$layer) || 'main';
        return this.getLayer(layer).appendChild(child, index);
    }
    setRenderer(renderer) {
        if (renderer === this.extends.renderer) return;
        const renderers = $4ce22517a458a77a$var$createRenderers(renderer, this.config.enableMultiLayer ? $4ce22517a458a77a$var$MULTI_LAYER_NAME : $4ce22517a458a77a$var$SINGLE_LAYER_NAME);
        this.extends.renderers = renderers;
        Object.entries(renderers).forEach(([layer, instance])=>this.getLayer(layer).setRenderer(instance));
        $4ce22517a458a77a$var$configCanvasDom(this.getLayers());
    }
    getCanvasByViewport(point) {
        return (0, $dnXls.parsePoint)(this.getLayer().viewport2Canvas((0, $dnXls.toPointObject)(point)));
    }
    getViewportByCanvas(point) {
        return (0, $dnXls.parsePoint)(this.getLayer().canvas2Viewport((0, $dnXls.toPointObject)(point)));
    }
    getViewportByClient(point) {
        return (0, $dnXls.parsePoint)(this.getLayer().client2Viewport((0, $dnXls.toPointObject)(point)));
    }
    getClientByViewport(point) {
        return (0, $dnXls.parsePoint)(this.getLayer().viewport2Client((0, $dnXls.toPointObject)(point)));
    }
    getClientByCanvas(point) {
        return this.getClientByViewport(this.getViewportByCanvas(point));
    }
    getCanvasByClient(point) {
        const main = this.getLayer();
        const viewportPoint = main.client2Viewport((0, $dnXls.toPointObject)(point));
        return (0, $dnXls.parsePoint)(main.viewport2Canvas(viewportPoint));
    }
    toDataURL() {
        return $4ce22517a458a77a$var$__awaiter(this, arguments, void 0, function*(options = {}) {
            const devicePixelRatio = globalThis.devicePixelRatio || 1;
            const { mode: mode = 'viewport' } = options, restOptions = $4ce22517a458a77a$var$__rest(options, [
                "mode"
            ]);
            let [startX, startY, width, height] = [
                0,
                0,
                0,
                0
            ];
            if (mode === 'viewport') [width, height] = this.getSize();
            else if (mode === 'overall') {
                const bounds = this.getBounds();
                const size = (0, $6BVcW.getBBoxSize)(bounds);
                [startX, startY] = bounds.min;
                [width, height] = size;
            }
            const container = (0, $3vLaV.createDOM)('<div id="virtual-image"></div>');
            const offscreenCanvas = new (0, $2eDEB.Canvas)({
                width: width,
                height: height,
                renderer: new (0, $ci3lc.Renderer)(),
                devicePixelRatio: devicePixelRatio,
                container: container,
                background: this.extends.config.background
            });
            yield offscreenCanvas.ready;
            offscreenCanvas.appendChild(this.getLayer('background').getRoot().cloneNode(true));
            offscreenCanvas.appendChild(this.getRoot().cloneNode(true));
            // Handle label canvas
            const label = this.getLayer('label').getRoot().cloneNode(true);
            const originCanvasPosition = offscreenCanvas.viewport2Canvas({
                x: 0,
                y: 0
            });
            const currentCanvasPosition = this.getCanvasByViewport([
                0,
                0
            ]);
            label.translate([
                currentCanvasPosition[0] - originCanvasPosition.x,
                currentCanvasPosition[1] - originCanvasPosition.y
            ]);
            label.scale(1 / this.getCamera().getZoom());
            offscreenCanvas.appendChild(label);
            offscreenCanvas.appendChild(this.getLayer('transient').getRoot().cloneNode(true));
            const camera = this.getCamera();
            const offscreenCamera = offscreenCanvas.getCamera();
            if (mode === 'viewport') {
                offscreenCamera.setZoom(camera.getZoom());
                offscreenCamera.setPosition(camera.getPosition());
                offscreenCamera.setFocalPoint(camera.getFocalPoint());
            } else if (mode === 'overall') {
                const [x, y, z] = offscreenCamera.getPosition();
                const [fx, fy, fz] = offscreenCamera.getFocalPoint();
                offscreenCamera.setPosition([
                    x + startX,
                    y + startY,
                    z
                ]);
                offscreenCamera.setFocalPoint([
                    fx + startX,
                    fy + startY,
                    fz
                ]);
            }
            const contextService = offscreenCanvas.getContextService();
            return new Promise((resolve)=>{
                offscreenCanvas.addEventListener((0, $2eDEB.CanvasEvent).RERENDER, ()=>$4ce22517a458a77a$var$__awaiter(this, void 0, void 0, function*() {
                        // 等待图片渲染完成 / Wait for the image to render
                        yield new Promise((r)=>setTimeout(r, 300));
                        const url = yield contextService.toDataURL(restOptions);
                        resolve(url);
                    }));
            });
        });
    }
    destroy() {
        Object.values(this.getLayers()).forEach((canvas)=>{
            const camera = canvas.getCamera();
            camera.cancelLandmarkAnimation();
            canvas.destroy();
        });
    }
}
/**
 * <zh/> 创建渲染器
 *
 * <en/> Create renderers
 * @param renderer - <zh/> 渲染器创建器 <en/> Renderer creator
 * @param layersName - <zh/> 图层名称 <en/> Layer name
 * @returns <zh/> 渲染器 <en/> Renderer
 */ function $4ce22517a458a77a$var$createRenderers(renderer, layersName) {
    return Object.fromEntries(layersName.map((layer)=>{
        const instance = (renderer === null || renderer === void 0 ? void 0 : renderer(layer)) || new (0, $ci3lc.Renderer)();
        if (instance instanceof (0, $ci3lc.Renderer)) instance.setConfig({
            enableDirtyRectangleRendering: false
        });
        if (layer === 'main') instance.registerPlugin(new (0, $3BKTp.Plugin)({
            isDocumentDraggable: true,
            isDocumentDroppable: true,
            dragstartDistanceThreshold: 10,
            dragstartTimeThreshold: 100
        }));
        else instance.unregisterPlugin(instance.getPlugin('dom-interaction'));
        return [
            layer,
            instance
        ];
    }));
}
/**
 * <zh/> 配置画布 DOM
 *
 * <en/> Configure canvas DOM
 * @param layers - <zh/> 画布 <en/> Canvas
 */ function $4ce22517a458a77a$var$configCanvasDom(layers) {
    Object.entries(layers).forEach(([layer, canvas])=>{
        const domElement = canvas.getContextService().getDomElement();
        // 浏览器环境下，设置画布样式
        // Set canvas style in browser environment
        if (domElement === null || domElement === void 0 ? void 0 : domElement.style) {
            domElement.style.gridArea = '1 / 1 / 2 / 2';
            domElement.style.outline = 'none';
            domElement.tabIndex = 1;
            if (layer !== 'main') domElement.style.pointerEvents = 'none';
        }
        if (domElement === null || domElement === void 0 ? void 0 : domElement.parentElement) {
            domElement.parentElement.style.display = 'grid';
            // 给父元素设置独立的层叠上下文，避免外部元素影响内部的层叠逻辑
            domElement.parentElement.style.isolation = 'isolate';
        }
    });
}

});
parcelRegister("3BKTp", function(module, exports) {

$parcel$export(module.exports, "Plugin", () => $2a0933b65ebd8c1c$export$901cf72dabf2112a);
/*!
 * @antv/g-plugin-dragndrop
 * @description A G plugin for Drag n Drop implemented with PointerEvents
 * @version 2.1.1
 * @date 12/24/2025, 11:56:44 AM
 * @author AntVis
 * @docs https://g.antv.antgroup.com/
 */ 
var $cbdLd = parcelRequire("cbdLd");

var $fu0YK = parcelRequire("fu0YK");

var $lR7jo = parcelRequire("lR7jo");

var $jLNr1 = parcelRequire("jLNr1");

var $f8wIT = parcelRequire("f8wIT");

var $2eDEB = parcelRequire("2eDEB");

var $8HV7i = parcelRequire("8HV7i");

var $fOd0O = parcelRequire("fOd0O");

var $aoFex = parcelRequire("aoFex");
var $2a0933b65ebd8c1c$var$DragndropPlugin = /*#__PURE__*/ function() {
    function DragndropPlugin(dragndropPluginOptions) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, DragndropPlugin);
        this.dragndropPluginOptions = dragndropPluginOptions;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(DragndropPlugin, [
        {
            key: "apply",
            value: function apply(context) {
                var _this = this;
                var renderingService = context.renderingService, renderingContext = context.renderingContext;
                var document = renderingContext.root.ownerDocument;
                // TODO: should we add an option like `draggable` to Canvas
                var canvas = document.defaultView;
                var handlePointerdown = function handlePointerdown(event) {
                    var target = event.target;
                    var isDocument = target === document;
                    var draggableEventTarget = isDocument && _this.dragndropPluginOptions.isDocumentDraggable ? document : target.closest && target.closest('[draggable=true]');
                    // `draggable` may be set on ancestor nodes:
                    // @see https://github.com/antvis/G/issues/1088
                    if (draggableEventTarget) {
                        // delay triggering dragstart event
                        var dragstartTriggered = false;
                        var dragstartTimeStamp = event.timeStamp;
                        var dragstartClientCoordinates = [
                            event.clientX,
                            event.clientY
                        ];
                        var currentDroppable = null;
                        var lastDragClientCoordinates = [
                            event.clientX,
                            event.clientY
                        ];
                        // @ts-ignore
                        // eslint-disable-next-line no-inner-declarations
                        var handlePointermove = /*#__PURE__*/ function() {
                            var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($fOd0O)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().mark(function _callee(event) {
                                var timeElapsed, distanceMoved, point, elementsBelow, elementBelow, droppableBelow;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($8HV7i)))().wrap(function(_context) {
                                    while(true)switch(_context.prev = _context.next){
                                        case 0:
                                            if (dragstartTriggered) {
                                                _context.next = 2;
                                                break;
                                            }
                                            timeElapsed = event.timeStamp - dragstartTimeStamp;
                                            distanceMoved = (0, $aoFex.distanceSquareRoot)([
                                                event.clientX,
                                                event.clientY
                                            ], dragstartClientCoordinates); // check thresholds
                                            if (!(timeElapsed <= _this.dragndropPluginOptions.dragstartTimeThreshold || distanceMoved <= _this.dragndropPluginOptions.dragstartDistanceThreshold)) {
                                                _context.next = 1;
                                                break;
                                            }
                                            return _context.abrupt("return");
                                        case 1:
                                            // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Document/dragstart_event
                                            event.type = 'dragstart';
                                            draggableEventTarget.dispatchEvent(event);
                                            dragstartTriggered = true;
                                        case 2:
                                            // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Document/drag_event
                                            event.type = 'drag';
                                            // @ts-ignore
                                            event.dx = event.clientX - lastDragClientCoordinates[0];
                                            // @ts-ignore
                                            event.dy = event.clientY - lastDragClientCoordinates[1];
                                            draggableEventTarget.dispatchEvent(event);
                                            lastDragClientCoordinates = [
                                                event.clientX,
                                                event.clientY
                                            ];
                                            if (isDocument) {
                                                _context.next = 4;
                                                break;
                                            }
                                            point = _this.dragndropPluginOptions.overlap === 'pointer' ? [
                                                event.canvasX,
                                                event.canvasY
                                            ] : target.getBounds().center;
                                            _context.next = 3;
                                            return document.elementsFromPoint(point[0], point[1]);
                                        case 3:
                                            elementsBelow = _context.sent;
                                            // prevent from picking the dragging element
                                            elementBelow = elementsBelow[elementsBelow.indexOf(target) + 1];
                                            droppableBelow = (elementBelow === null || elementBelow === void 0 ? void 0 : elementBelow.closest('[droppable=true]')) || (_this.dragndropPluginOptions.isDocumentDroppable ? document : null);
                                            if (currentDroppable !== droppableBelow) {
                                                if (currentDroppable) {
                                                    // null when we were not over a droppable before this event
                                                    // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Document/dragleave_event
                                                    event.type = 'dragleave';
                                                    event.target = currentDroppable;
                                                    currentDroppable.dispatchEvent(event);
                                                }
                                                if (droppableBelow) {
                                                    // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Document/dragleave_event
                                                    event.type = 'dragenter';
                                                    event.target = droppableBelow;
                                                    droppableBelow.dispatchEvent(event);
                                                }
                                                currentDroppable = droppableBelow;
                                                if (currentDroppable) {
                                                    // null if we're not coming over a droppable now
                                                    // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Document/dragover_event
                                                    event.type = 'dragover';
                                                    event.target = currentDroppable;
                                                    currentDroppable.dispatchEvent(event);
                                                }
                                            }
                                        case 4:
                                        case "end":
                                            return _context.stop();
                                    }
                                }, _callee);
                            }));
                            return function handlePointermove(_x) {
                                return _ref.apply(this, arguments);
                            };
                        }();
                        canvas.addEventListener('pointermove', handlePointermove);
                        var stopDragging = function stopDragging(originalPointerUpEvent) {
                            if (dragstartTriggered) {
                                // prevent click event being triggerd
                                // @see https://github.com/antvis/G/issues/1091
                                originalPointerUpEvent.detail = {
                                    preventClick: true
                                };
                                // clone event first
                                var _event = originalPointerUpEvent.clone();
                                // drop should fire before dragend
                                // @see https://javascript.tutorialink.com/is-there-a-defined-ordering-between-dragend-and-drop-events/
                                if (currentDroppable) {
                                    // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Document/drop_event
                                    _event.type = 'drop';
                                    _event.target = currentDroppable;
                                    currentDroppable.dispatchEvent(_event);
                                }
                                // @see https://developer.mozilla.org/zh-CN/docs/Web/API/Document/dragend_event
                                _event.type = 'dragend';
                                draggableEventTarget.dispatchEvent(_event);
                                dragstartTriggered = false;
                            }
                            canvas.removeEventListener('pointermove', handlePointermove);
                        };
                        target.addEventListener('pointerup', stopDragging, {
                            once: true
                        });
                        target.addEventListener('pointerupoutside', stopDragging, {
                            once: true
                        });
                    }
                };
                renderingService.hooks.init.tap(DragndropPlugin.tag, function() {
                    canvas.addEventListener('pointerdown', handlePointerdown);
                });
                renderingService.hooks.destroy.tap(DragndropPlugin.tag, function() {
                    canvas.removeEventListener('pointerdown', handlePointerdown);
                });
            }
        }
    ]);
}();
$2a0933b65ebd8c1c$var$DragndropPlugin.tag = 'Dragndrop';
var $2a0933b65ebd8c1c$export$901cf72dabf2112a = /*#__PURE__*/ function(_AbstractRendererPlug) {
    function Plugin() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($fu0YK)))(this, Plugin);
        _this = (0, (/*@__PURE__*/$parcel$interopDefault($jLNr1)))(this, Plugin);
        _this.name = 'dragndrop';
        _this.options = options;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($f8wIT)))(Plugin, _AbstractRendererPlug);
    return (0, (/*@__PURE__*/$parcel$interopDefault($lR7jo)))(Plugin, [
        {
            key: "init",
            value: function init() {
                this.addRenderingPlugin(new $2a0933b65ebd8c1c$var$DragndropPlugin((0, (/*@__PURE__*/$parcel$interopDefault($cbdLd)))({
                    overlap: 'pointer',
                    isDocumentDraggable: false,
                    isDocumentDroppable: false,
                    dragstartDistanceThreshold: 0,
                    dragstartTimeThreshold: 0
                }, this.options)));
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.removeAllRenderingPlugins();
            }
        },
        {
            key: "setOptions",
            value: function setOptions(options) {
                Object.assign(this.plugins[0].dragndropPluginOptions, options);
            }
        }
    ]);
}((0, $2eDEB.AbstractRendererPlugin));

});


parcelRegister("cA8ew", function(module, exports) {

$parcel$export(module.exports, "Graph", () => $928f3bcc6a617758$export$614db49f3febe941);

var $7VXo7 = parcelRequire("7VXo7");

var $2ZmO4 = parcelRequire("2ZmO4");
var $4ETMA = parcelRequire("4ETMA");
var $ky7aH = parcelRequire("ky7aH");
var $jyI49 = parcelRequire("jyI49");
var $6JKSc = parcelRequire("6JKSc");
var $kVcyu = parcelRequire("kVcyu");
var $64w8j = parcelRequire("64w8j");
parcelRequire("ahJ7k");
var $lDPR9 = parcelRequire("lDPR9");
var $4EzN9 = parcelRequire("4EzN9");

var $VNNBO = parcelRequire("VNNBO");

var $fELnD = parcelRequire("fELnD");

var $25dP3 = parcelRequire("25dP3");

var $3hhcj = parcelRequire("3hhcj");
var $8Fqus = parcelRequire("8Fqus");

var $brtTw = parcelRequire("brtTw");

var $fYedv = parcelRequire("fYedv");

var $aBpmX = parcelRequire("aBpmX");

var $dOidW = parcelRequire("dOidW");

var $2sBE1 = parcelRequire("2sBE1");

var $5dLqa = parcelRequire("5dLqa");

var $7P9bx = parcelRequire("7P9bx");

var $3LpK5 = parcelRequire("3LpK5");

var $6BfoV = parcelRequire("6BfoV");

var $csx45 = parcelRequire("csx45");

var $3IeB3 = parcelRequire("3IeB3");

var $pzJSN = parcelRequire("pzJSN");

var $k1ICh = parcelRequire("k1ICh");

var $dZHuo = parcelRequire("dZHuo");

var $M9i2f = parcelRequire("M9i2f");

var $7goJ4 = parcelRequire("7goJ4");
var $928f3bcc6a617758$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $928f3bcc6a617758$export$614db49f3febe941 extends (0, $7VXo7.default) {
    constructor(options){
        var _a;
        super();
        this.options = {};
        /**
         * <zh/> 当前图实例是否已经渲染
         *
         * <en/> Whether the current graph instance has been rendered
         */ this.rendered = false;
        /**
         * <zh/> 当前图实例是否已经被销毁
         *
         * <en/> Whether the current graph instance has been destroyed
         */ this.destroyed = false;
        // @ts-expect-error will be initialized in createRuntime
        this.context = {
            model: new (0, $csx45.DataController)()
        };
        this.isCollapsingExpanding = false;
        this.onResize = (0, $2ZmO4.default)(()=>{
            this.resize();
        }, 300);
        this._setOptions(Object.assign({}, $928f3bcc6a617758$export$614db49f3febe941.defaultOptions, options), true);
        this.context.graph = this;
        // Listening resize to autoResize.
        this.options.autoResize && ((_a = globalThis.addEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.onResize));
    }
    /**
     * <zh/> 获取配置项
     *
     * <en/> Get options
     * @returns <zh/> 配置项 | <en/> options
     * @apiCategory option
     */ getOptions() {
        return this.options;
    }
    /**
     * <zh/> 设置配置项
     *
     * <en/> Set options
     * @param options - <zh/> 配置项 | <en/> options
     * @remarks
     * <zh/> 要更新 devicePixelRatio、container 属性请销毁后重新创建实例
     *
     * <en/> To update devicePixelRatio and container properties, please destroy and recreate the instance
     * @apiCategory option
     */ setOptions(options) {
        this._setOptions(options, false);
    }
    _setOptions(options, isInit) {
        this.updateCanvas(options);
        Object.assign(this.options, (0, $k1ICh.inferOptions)(options));
        if (isInit) {
            const { data: data } = options;
            if (data) this.addData(data);
            return;
        }
        const { behaviors: behaviors, combo: combo, data: data, edge: edge, layout: layout, node: node, plugins: plugins, theme: theme, transforms: transforms } = options;
        if (behaviors) this.setBehaviors(behaviors);
        if (data) this.setData(data);
        if (node) this.setNode(node);
        if (edge) this.setEdge(edge);
        if (combo) this.setCombo(combo);
        if (layout) this.setLayout(layout);
        if (theme) this.setTheme(theme);
        if (plugins) this.setPlugins(plugins);
        if (transforms) this.setTransforms(transforms);
    }
    /**
     * <zh/> 获取当前画布容器的尺寸
     *
     * <en/> Get the size of the current canvas container
     * @returns <zh/> 画布尺寸 | <en/> canvas size
     * @apiCategory canvas
     */ getSize() {
        if (this.context.canvas) return this.context.canvas.getSize();
        return [
            this.options.width || 0,
            this.options.height || 0
        ];
    }
    /**
     * <zh/> 设置当前画布容器的尺寸
     *
     * <en/> Set the size of the current canvas container
     * @param width - <zh/> 画布宽度 | <en/> canvas width
     * @param height - <zh/> 画布高度 | <en/> canvas height
     * @apiCategory canvas
     */ setSize(width, height) {
        if (width) this.options.width = width;
        if (height) this.options.height = height;
        this.resize(width, height);
    }
    /**
     * <zh/> 设置当前图的缩放区间
     *
     * <en/> Get the zoom range of the current graph
     * @param zoomRange - <zh/> 缩放区间 | <en/> zoom range
     * @apiCategory viewport
     */ setZoomRange(zoomRange) {
        this.options.zoomRange = zoomRange;
    }
    /**
     * <zh/> 获取当前图的缩放区间
     *
     * <en/> Get the zoom range of the current graph
     * @returns <zh/> 缩放区间 | <en/> zoom range
     * @apiCategory viewport
     */ getZoomRange() {
        return this.options.zoomRange;
    }
    /**
     * <zh/> 设置节点样式映射
     *
     * <en/> Set node mapper
     * @param node - <zh/> 节点配置 | <en/> node options
     * @remarks
     * <zh/> 即 `options.node` 的值
     *
     * <en/> The value of `options.node`
     * @apiCategory element
     */ setNode(node) {
        this.options.node = node;
        this.context.model.refreshData();
    }
    /**
     * <zh/> 设置边样式映射
     *
     * <en/> Set edge mapper
     * @param edge - <zh/> 边配置 | <en/> edge options
     * @remarks
     * <zh/> 即 `options.edge` 的值
     *
     * <en/> The value of `options.edge`
     * @apiCategory element
     */ setEdge(edge) {
        this.options.edge = edge;
        this.context.model.refreshData();
    }
    /**
     * <zh/> 设置组合样式映射
     *
     * <en/> Set combo mapper
     * @param combo - <zh/> 组合配置 | <en/> combo options
     * @remarks
     * <zh/> 即 `options.combo` 的值
     *
     * <en/> The value of `options.combo`
     * @apiCategory element
     */ setCombo(combo) {
        this.options.combo = combo;
        this.context.model.refreshData();
    }
    /**
     * <zh/> 获取主题
     *
     * <en/> Get theme
     * @returns <zh/> 当前主题 | <en/> current theme
     * @apiCategory theme
     */ getTheme() {
        return this.options.theme;
    }
    /**
     * <zh/> 设置主题
     *
     * <en/> Set theme
     * @param theme - <zh/> 主题名 | <en/> theme name
     * @example
     * ```ts
     * graph.setTheme('dark');
     * ```
     * @apiCategory theme
     */ setTheme(theme) {
        this.options.theme = (0, $ky7aH.default)(theme) ? theme(this.getTheme()) : theme;
    }
    /**
     * <zh/> 设置布局
     *
     * <en/> Set layout
     * @param layout - <zh/> 布局配置 | <en/> layout options
     * @example
     * ```ts
     * graph.setLayout({
     *  type: 'dagre',
     * })
     * ```
     * @apiCategory layout
     */ setLayout(layout) {
        this.options.layout = (0, $ky7aH.default)(layout) ? layout(this.getLayout()) : layout;
    }
    /**
     * <zh/> 获取布局配置
     *
     * <en/> Get layout options
     * @returns <zh/> 布局配置 | <en/> layout options
     * @apiCategory layout
     */ getLayout() {
        return this.options.layout;
    }
    /**
     * <zh/> 设置交互
     *
     * <en/> Set behaviors
     * @param behaviors - <zh/> 交互配置 | <en/> behavior options
     * @remarks
     * <zh/> 设置的交互会全量替换原有的交互，如果需要新增交互可以使用如下方式：
     *
     * <en/> The set behavior will completely replace the original behavior. If you need to add behavior, you can use the following method:
     *
     * ```ts
     * graph.setBehaviors((behaviors) => [...behaviors, { type: 'zoom-canvas' }])
     * ```
     * @apiCategory behavior
     */ setBehaviors(behaviors) {
        var _a;
        this.options.behaviors = (0, $ky7aH.default)(behaviors) ? behaviors(this.getBehaviors()) : behaviors;
        (_a = this.context.behavior) === null || _a === void 0 || _a.setBehaviors(this.options.behaviors);
    }
    /**
     * <zh/> 更新指定的交互配置
     *
     * <en/> Update specified behavior options
     * @param behavior - <zh/> 交互配置 | <en/> behavior options
     * @remarks
     * <zh/> 如果要更新一个交互，那么必须在交互配置中指定 key 字段，例如：
     *
     * <en/> If you want to update a behavior, you must specify the key field in the behavior options, for example:
     * ```ts
     * {
     *   behaviors: [{ type: 'zoom-canvas', key: 'zoom-canvas' }]
     * }
     *
     * graph.updateBehavior({ key: 'zoom-canvas', enable: false })
     * ```
     * @apiCategory behavior
     */ updateBehavior(behavior) {
        this.setBehaviors((behaviors)=>behaviors.map((_behavior)=>{
                if (typeof _behavior === 'object' && _behavior.key === behavior.key) return Object.assign(Object.assign({}, _behavior), behavior);
                return _behavior;
            }));
    }
    /**
     * <zh/> 获取交互配置
     *
     * <en/> Get behaviors options
     * @returns <zh/> 交互配置 | <en/> behavior options
     * @apiCategory behavior
     */ getBehaviors() {
        return this.options.behaviors || [];
    }
    /**
     * <zh/> 设置插件配置
     *
     * <en/> Set plugins options
     * @param plugins - <zh/> 插件配置 | <en/> plugin options
     * @remarks
     * <zh/> 设置的插件会全量替换原有的插件配置，如果需要新增插件可以使用如下方式：
     *
     * <en/> The set plugin will completely replace the original plugin configuration. If you need to add a plugin, you can use the following method:
     * ```ts
     * graph.setPlugins((plugins) => [...plugins, { key: 'grid-line' }])
     * ```
     * @apiCategory plugin
     */ setPlugins(plugins) {
        var _a;
        this.options.plugins = (0, $ky7aH.default)(plugins) ? plugins(this.getPlugins()) : plugins;
        (_a = this.context.plugin) === null || _a === void 0 || _a.setPlugins(this.options.plugins);
    }
    /**
     * <zh/> 更新插件配置
     *
     * <en/> Update plugin options
     * @param plugin - <zh/> 插件配置 | <en/> plugin options
     * @remarks
     * <zh/> 如果要更新一个插件，那么必须在插件配置中指定 key 字段，例如：
     *
     * <en/> If you want to update a plugin, you must specify the key field in the plugin options, for example:
     * ```ts
     * {
     *   plugins: [{ key: 'grid-line' }]
     * }
     *
     * graph.updatePlugin({ key: 'grid-line', follow: true })
     * ```
     * @apiCategory plugin
     */ updatePlugin(plugin) {
        this.setPlugins((plugins)=>plugins.map((_plugin)=>{
                if (typeof _plugin === 'object' && _plugin.key === plugin.key) return Object.assign(Object.assign({}, _plugin), plugin);
                return _plugin;
            }));
    }
    /**
     * <zh/> 获取插件配置
     *
     * <en/> Get plugins options
     * @returns <zh/> 插件配置 | <en/> plugin options
     * @apiCategory plugin
     */ getPlugins() {
        return this.options.plugins || [];
    }
    /**
     * <zh/> 获取插件实例
     *
     * <en/> Get plugin instance
     * @param key - <zh/> 插件 key（在配置 plugin 时需要手动传入指定） | <en/> plugin key(need to be specified manually when configuring plugin)
     * @returns <zh/> 插件实例 | <en/> plugin instance
     * @remarks
     * <zh/> 一些插件提供了 API 方法可供调用，例如全屏插件可以调用 `request` 和 `exit` 方法来请求和退出全屏
     *
     * <en/> Some plugins provide API methods for calling, such as the full-screen plugin can call the `request` and `exit` methods to request and exit full-screen
     * ```ts
     * const fullscreen = graph.getPluginInstance('fullscreen');
     *
     * fullscreen.request();
     *
     * fullscreen.exit();
     * ```
     * @apiCategory plugin
     */ getPluginInstance(key) {
        return this.context.plugin.getPluginInstance(key);
    }
    /**
     * <zh/> 设置数据转换器
     *
     * <en/> Set data transforms
     * @param transforms - <zh/> 数据转换配置 | <en/> data transform options
     * @remarks
     * <zh/> 数据转换器能够在图渲染过程中执行数据转换，目前支持在渲染前对绘制数据进行转化。
     *
     * <en/> Data transforms can perform data transformation during the rendering process of the graph. Currently, it supports transforming the drawing data before rendering.
     * @apiCategory transform
     */ setTransforms(transforms) {
        var _a;
        this.options.transforms = (0, $ky7aH.default)(transforms) ? transforms(this.getTransforms()) : transforms;
        (_a = this.context.transform) === null || _a === void 0 || _a.setTransforms(this.options.transforms);
    }
    /**
     * <zh/> 更新数据转换器
     *
     * <en/> Update data transform
     * @param transform - <zh/> 数据转换器配置 | <en/> data transform options
     * @apiCategory transform
     */ updateTransform(transform) {
        this.setTransforms((transforms)=>transforms.map((_transform)=>{
                if (typeof _transform === 'object' && _transform.key === transform.key) return Object.assign(Object.assign({}, _transform), transform);
                return _transform;
            }));
        this.context.model.refreshData();
    }
    /**
     * <zh/> 获取数据转换器配置
     *
     * <en/> Get data transforms options
     * @returns <zh/> 数据转换配置 | <en/> data transform options
     * @apiCategory transform
     */ getTransforms() {
        return this.options.transforms || [];
    }
    /**
     * <zh/> 获取图数据
     *
     * <en/> Get graph data
     * @returns <zh/> 图数据 | <en/> Graph data
     * <zh/> 获取当前图的数据，包括节点、边、组合数据
     *
     * <en/> Get the data of the current graph, including node, edge, and combo data
     * @apiCategory data
     */ getData() {
        return this.context.model.getData();
    }
    /**
     * <zh/> 判断图中是否存在指定节点
     * <en/> Determine whether a specified node exists in the graph
     * @param {ID} id
     * @returns {boolean}
     * @remarks <zh/> 判断图中是否存在指定节点,避免在不存在的节点上进行操作
     * <en/> Determine whether a specified node exists in the graph and avoid operating on non-existent nodes
     */ hasNode(id) {
        return this.context.model.hasNode(id);
    }
    /**
     * <zh/> 判断图中是否存在指定边
     * <en/> Determine whether a specified edge exists in the graph
     * @param {ID} id
     * @returns  {boolean}
     * @remarks <zh/> 判断图中是否存在指定边,避免在不存在的边上进行操作
     * <en/> Determine whether a specified edge exists in the graph and avoid operating on non-existent edges
     */ hasEdge(id) {
        return this.context.model.hasEdge(id);
    }
    /**
     * <zh/> 判断图中是否存在指定组合
     * <en/> Determine whether a specified combo exists in the graph
     * @param {ID} id
     * @returns  {boolean}
     * @remarks <zh/> 判断图中是否存在指定组合,避免在不存在的组合上进行操作
     * <en/> Determine whether a specified combo exists in the graph and avoid operating on non-existent combos
     */ hasCombo(id) {
        return this.context.model.hasCombo(id);
    }
    getElementData(ids) {
        if (Array.isArray(ids)) return ids.map((id)=>this.context.model.getElementDataById(id));
        return this.context.model.getElementDataById(ids);
    }
    getNodeData(id) {
        if (id === undefined) return this.context.model.getNodeData();
        if (Array.isArray(id)) return this.context.model.getNodeData(id);
        return this.context.model.getNodeLikeDatum(id);
    }
    getEdgeData(id) {
        if (id === undefined) return this.context.model.getEdgeData();
        if (Array.isArray(id)) return this.context.model.getEdgeData(id);
        return this.context.model.getEdgeDatum(id);
    }
    getComboData(id) {
        if (id === undefined) return this.context.model.getComboData();
        if (Array.isArray(id)) return this.context.model.getComboData(id);
        return this.context.model.getNodeLikeDatum(id);
    }
    /**
     * <zh/> 设置全量数据
     *
     * <en/> Set full data
     * @param data - <zh/> 数据 | <en/> data
     * @remarks
     * <zh/> 设置全量数据会替换当前图中的所有数据，G6 会自动进行数据差异计算
     *
     * <en/> Setting full data will replace all data in the current graph, and G6 will automatically calculate the data difference
     * @apiCategory data
     */ setData(data) {
        this.context.model.setData((0, $ky7aH.default)(data) ? data(this.getData()) : data);
    }
    /**
     * <zh/> 新增元素数据
     *
     * <en/> Add element data
     * @param data - <zh/> 元素数据 | <en/> element data
     * @example
     * ```ts
     * graph.addData({
     *  nodes: [{ id: 'node-1' }, { id: 'node-2' }],
     *  edges: [{ source: 'node-1', target: 'node-2' }],
     * });
     * ```
     * @apiCategory data
     */ addData(data) {
        this.context.model.addData((0, $ky7aH.default)(data) ? data(this.getData()) : data);
    }
    /**
     * <zh/> 新增节点数据
     *
     * <en/> Add node data
     * @param data - <zh/> 节点数据 | <en/> node data
     * @example
     * ```ts
     * graph.addNodeData([{ id: 'node-1' }, { id: 'node-2' }]);
     * ```
     * @apiCategory data
     */ addNodeData(data) {
        this.context.model.addNodeData((0, $ky7aH.default)(data) ? data(this.getNodeData()) : data);
    }
    /**
     * <zh/> 新增边数据
     *
     * <en/> Add edge data
     * @param data - <zh/> 边数据 | <en/> edge data
     * @example
     * ```ts
     * graph.addEdgeData([{ source: 'node-1', target: 'node-2' }]);
     * ```
     * @apiCategory data
     */ addEdgeData(data) {
        this.context.model.addEdgeData((0, $ky7aH.default)(data) ? data(this.getEdgeData()) : data);
    }
    /**
     * <zh/> 新增组合数据
     *
     * <en/> Add combo data
     * @param data - <zh/> 组合数据 | <en/> combo data
     * @example
     * ```ts
     * graph.addComboData([{ id: 'combo-1' }]);
     * ```
     * @apiCategory data
     */ addComboData(data) {
        this.context.model.addComboData((0, $ky7aH.default)(data) ? data(this.getComboData()) : data);
    }
    /**
     * <zh/> 为树图节点添加子节点数据
     *
     * <en/> Add child node data to the tree node
     * @param parentId - <zh/> 父节点 ID | <en/> parent node ID
     * @param childrenData - <zh/> 子节点数据 | <en/> child node data
     * @remarks
     * <zh/> 为组合添加子节点使用 addNodeData / addComboData 方法
     *
     * <en/> Use addNodeData / addComboData method to add child nodes to the combo
     * @apiCategory data
     */ addChildrenData(parentId, childrenData) {
        this.context.model.addChildrenData(parentId, childrenData);
    }
    /**
     * <zh/> 更新元素数据
     *
     * <en/> Update element data
     * @param data - <zh/> 元素数据 | <en/> element data
     * @remarks
     * <zh/> 只需要传入需要更新的数据即可，不必传入完整的数据
     *
     * <en/> Just pass in the data that needs to be updated, no need to pass in the complete data
     * @example
     * ```ts
     * graph.updateData({
     *   nodes: [{ id: 'node-1', style: { x: 100, y: 100 } }],
     *   edges: [{ id: 'edge-1', style: { lineWidth: 2 } }]
     * });
     * ```
     * @apiCategory data
     */ updateData(data) {
        this.context.model.updateData((0, $ky7aH.default)(data) ? data(this.getData()) : data);
    }
    /**
     * <zh/> 更新节点数据
     *
     * <en/> Update node data
     * @param data - <zh/> 节点数据 | <en/> node data
     * @remarks
     * <zh/> 只需要传入需要更新的数据即可，不必传入完整的数据
     *
     * <en/> Just pass in the data that needs to be updated, no need to pass in the complete data
     * @example
     * ```ts
     * graph.updateNodeData([{ id: 'node-1', style: { x: 100, y: 100 } }]);
     * ```
     * @apiCategory data
     */ updateNodeData(data) {
        this.context.model.updateNodeData((0, $ky7aH.default)(data) ? data(this.getNodeData()) : data);
    }
    /**
     * <zh/> 更新边数据
     *
     * <en/> Update edge data
     * @param data - <zh/> 边数据 | <en/> edge data
     * @remarks
     * <zh/> 只需要传入需要更新的数据即可，不必传入完整的数据
     *
     * <en/> Just pass in the data that needs to be updated, no need to pass in the complete data
     * @example
     * ```ts
     * graph.updateEdgeData([{ id: 'edge-1', style: { lineWidth: 2 } }]);
     * ```
     * @apiCategory data
     */ updateEdgeData(data) {
        this.context.model.updateEdgeData((0, $ky7aH.default)(data) ? data(this.getEdgeData()) : data);
    }
    /**
     * <zh/> 更新组合数据
     *
     * <en/> Update combo data
     * @param data - <zh/> 组合数据 | <en/> combo data
     * @remarks
     * <zh/> 只需要传入需要更新的数据即可，不必传入完整的数据
     *
     * <en/> Just pass in the data that needs to be updated, no need to pass in the complete data
     * @example
     * ```ts
     * graph.updateComboData([{ id: 'combo-1', style: { x: 100, y: 100 } }]);
     * ```
     * @apiCategory data
     */ updateComboData(data) {
        this.context.model.updateComboData((0, $ky7aH.default)(data) ? data(this.getComboData()) : data);
    }
    /**
     * <zh/> 删除元素数据
     *
     * <en/> Remove element data
     * @param ids - <zh/> 元素 ID 数组 | <en/> element ID array
     * @example
     * ```ts
     * graph.removeData({
     *   nodes: ['node-1', 'node-2'],
     *   edges: ['edge-1'],
     * });
     * ```
     * @apiCategory data
     */ removeData(ids) {
        this.context.model.removeData((0, $ky7aH.default)(ids) ? ids(this.getData()) : ids);
    }
    /**
     * <zh/> 删除节点数据
     *
     * <en/> Remove node data
     * @param ids - <zh/> 节点 ID 数组 | <en/> node ID array
     * @example
     * ```ts
     * graph.removeNodeData(['node-1', 'node-2']);
     * ```
     * @apiCategory data
     */ removeNodeData(ids) {
        this.context.model.removeNodeData((0, $ky7aH.default)(ids) ? ids(this.getNodeData()) : ids);
    }
    /**
     * <zh/> 删除边数据
     *
     * <en/> Remove edge data
     * @param ids - <zh/> 边 ID 数组 | <en/> edge ID array
     * @remarks
     * <zh/> 如果传入边数据时仅提供了 source 和 target，那么需要通过 `idOf` 方法获取边的实际 ID
     *
     * <en/> If only the source and target are provided when passing in the edge data, you need to get the actual ID of the edge through the `idOf` method
     * @example
     * ```ts
     * graph.removeEdgeData(['edge-1']);
     * ```
     * @apiCategory data
     */ removeEdgeData(ids) {
        this.context.model.removeEdgeData((0, $ky7aH.default)(ids) ? ids(this.getEdgeData()) : ids);
    }
    /**
     * <zh/> 删除组合数据
     *
     * <en/> Remove combo data
     * @param ids - <zh/> 组合 ID 数组 | <en/> 组合 ID array
     * @example
     * ```ts
     * graph.removeComboData(['combo-1']);
     * ```
     * @apiCategory data
     */ removeComboData(ids) {
        this.context.model.removeComboData((0, $ky7aH.default)(ids) ? ids(this.getComboData()) : ids);
    }
    /**
     * <zh/> 获取元素类型
     *
     * <en/> Get element type
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @returns <zh/> 元素类型 | <en/> element type
     * @apiCategory element
     */ getElementType(id) {
        return this.context.model.getElementType(id);
    }
    /**
     * <zh/> 获取节点或组合关联边的数据
     *
     * <en/> Get edge data related to the node or combo
     * @param id - <zh/> 节点或组合ID | <en/> node or combo ID
     * @param direction - <zh/> 边的方向 | <en/> edge direction
     * @returns <zh/> 边数据 | <en/> edge data
     * @apiCategory data
     */ getRelatedEdgesData(id, direction = 'both') {
        return this.context.model.getRelatedEdgesData(id, direction);
    }
    /**
     * <zh/> 获取节点或组合的一跳邻居节点数据
     *
     * <en/> Get the one-hop neighbor node data of the node or combo
     * @param id - <zh/> 节点或组合ID | <en/> node or combo ID
     * @returns <zh/> 邻居节点数据 | <en/> neighbor node data
     * @apiCategory data
     */ getNeighborNodesData(id) {
        return this.context.model.getNeighborNodesData(id);
    }
    /**
     * <zh/> 获取节点或组合的祖先元素数据
     *
     * <en/> Get the ancestor element data of the node or combo
     * @param id - <zh/> 节点或组合ID | <en/> node or combo ID
     * @param hierarchy - <zh/> 指定树图层级关系还是组合层级关系 | <en/> specify tree or combo hierarchy relationship
     * @returns <zh/> 祖先元素数据 | <en/> ancestor element data
     * @remarks
     * <zh/> 数组中的顺序是从父节点到祖先节点
     *
     * <en/> The order in the array is from the parent node to the ancestor node
     * @apiCategory data
     */ getAncestorsData(id, hierarchy) {
        return this.context.model.getAncestorsData(id, hierarchy);
    }
    /**
     * <zh/> 获取节点或组合的父元素数据
     *
     * <en/> Get the parent element data of the node or combo
     * @param id - <zh/> 节点或组合ID | <en/> node or combo ID
     * @param hierarchy - <zh/> 指定树图层级关系还是组合层级关系 | <en/> specify tree or combo hierarchy relationship
     * @returns <zh/> 父元素数据 | <en/> parent element data
     * @apiCategory data
     */ getParentData(id, hierarchy) {
        return this.context.model.getParentData(id, hierarchy);
    }
    /**
     * <zh/> 获取节点或组合的子元素数据
     *
     * <en/> Get the child element data of the node or combo
     * @param id - <zh/> 节点或组合ID | <en/> node or combo ID
     * @returns <zh/> 子元素数据 | <en/> child element data
     * @apiCategory data
     */ getChildrenData(id) {
        return this.context.model.getChildrenData(id);
    }
    /**
     * <zh/> 获取节点或组合的后代元素数据
     *
     * <en/> Get the descendant element data of the node or combo
     * @param id - <zh/> 节点或组合ID | <en/> node or combo ID
     * @returns <zh/> 后代元素数据 | <en/> descendant element data
     * @apiCategory data
     */ getDescendantsData(id) {
        return this.context.model.getDescendantsData(id);
    }
    getElementDataByState(elementType, state) {
        return this.context.model.getElementDataByState(elementType, state);
    }
    initCanvas() {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            if (this.context.canvas) return yield this.context.canvas.ready;
            const { container: container = 'container', width: width, height: height, renderer: renderer, cursor: cursor, background: background, canvas: canvasOptions, devicePixelRatio: devicePixelRatio = (_a = globalThis.devicePixelRatio) !== null && _a !== void 0 ? _a : 1 } = this.options;
            if (container instanceof (0, $6BfoV.Canvas)) {
                this.context.canvas = container;
                if (cursor) container.setCursor(cursor);
                if (renderer) container.setRenderer(renderer);
                yield container.ready;
            } else {
                const $container = (0, $kVcyu.default)(container) ? document.getElementById(container) : container;
                const containerSize = (0, $fELnD.sizeOf)($container);
                this.emit((0, $4EzN9.GraphEvent).BEFORE_CANVAS_INIT, {
                    container: $container,
                    width: width,
                    height: height
                });
                const options = Object.assign(Object.assign({}, canvasOptions), {
                    container: $container,
                    width: width || containerSize[0],
                    height: height || containerSize[1],
                    background: background,
                    renderer: renderer,
                    cursor: cursor,
                    devicePixelRatio: devicePixelRatio
                });
                const canvas = new (0, $6BfoV.Canvas)(options);
                this.context.canvas = canvas;
                yield canvas.ready;
                this.emit((0, $4EzN9.GraphEvent).AFTER_CANVAS_INIT, {
                    canvas: canvas
                });
            }
        });
    }
    updateCanvas(options) {
        var _a, _b;
        const { renderer: renderer, cursor: cursor, height: height, width: width } = options;
        const canvas = this.context.canvas;
        if (!canvas) return;
        if (renderer) {
            this.emit((0, $4EzN9.GraphEvent).BEFORE_RENDERER_CHANGE, {
                renderer: this.options.renderer
            });
            canvas.setRenderer(renderer);
            this.emit((0, $4EzN9.GraphEvent).AFTER_RENDERER_CHANGE, {
                renderer: renderer
            });
        }
        if (cursor) canvas.setCursor(cursor);
        if ((0, $jyI49.default)(width) || (0, $jyI49.default)(height)) this.setSize((_a = width !== null && width !== void 0 ? width : this.options.width) !== null && _a !== void 0 ? _a : 0, (_b = height !== null && height !== void 0 ? height : this.options.height) !== null && _b !== void 0 ? _b : 0);
    }
    initRuntime() {
        this.context.options = this.options;
        if (!this.context.batch) this.context.batch = new (0, $7P9bx.BatchController)(this.context);
        if (!this.context.plugin) this.context.plugin = new (0, $dZHuo.PluginController)(this.context);
        if (!this.context.viewport) this.context.viewport = new (0, $7goJ4.ViewportController)(this.context);
        if (!this.context.transform) this.context.transform = new (0, $M9i2f.TransformController)(this.context);
        if (!this.context.element) this.context.element = new (0, $3IeB3.ElementController)(this.context);
        if (!this.context.animation) this.context.animation = new (0, $5dLqa.Animation)(this.context);
        if (!this.context.layout) this.context.layout = new (0, $pzJSN.LayoutController)(this.context);
        if (!this.context.behavior) this.context.behavior = new (0, $3LpK5.BehaviorController)(this.context);
    }
    prepare() {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            // 等待同步任务执行完成，避免 render 后立即调用 destroy 导致的问题
            // Wait for synchronous tasks to complete, to avoid problems caused by calling destroy immediately after render
            yield Promise.resolve();
            if (this.destroyed) {
                // 如果图实例已经被销毁，则不再执行任何操作
                // If the graph instance has been destroyed, no further operations will be performed
                // eslint-disable-next-line no-console
                console.error((0, $aBpmX.format)('The graph instance has been destroyed'));
                return;
            }
            yield this.initCanvas();
            this.initRuntime();
        });
    }
    /**
     * <zh/> 执行渲染
     *
     * <en/> Render
     * @remarks
     * <zh/> 此过程会执行数据更新、绘制元素、执行布局
     *
     * > ⚠️ render 为异步方法，如果需要在 render 后执行一些操作，可以使用 `await graph.render()` 或者监听 GraphEvent.AFTER_RENDER 事件
     *
     * <en/> This process will execute data update, element rendering, and layout execution
     *
     * > ⚠️ render is an asynchronous method. If you need to perform some operations after render, you can use `await graph.render()` or listen to the GraphEvent.AFTER_RENDER event
     * @apiCategory render
     */ render() {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            yield this.prepare();
            (0, $3hhcj.emit)(this, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_RENDER));
            if (!this.options.layout) {
                const animation = this.context.element.draw({
                    type: 'render'
                });
                yield Promise.all([
                    animation === null || animation === void 0 ? void 0 : animation.finished,
                    this.autoFit()
                ]);
            } else if (!this.rendered && (0, $fYedv.isPreLayout)(this.options.layout)) {
                const animation = yield this.context.element.preLayoutDraw({
                    type: 'render'
                });
                yield Promise.all([
                    animation === null || animation === void 0 ? void 0 : animation.finished,
                    this.autoFit()
                ]);
            } else {
                const animation = this.context.element.draw({
                    type: 'render'
                });
                yield Promise.all([
                    animation === null || animation === void 0 ? void 0 : animation.finished,
                    this.context.layout.postLayout()
                ]);
                yield this.autoFit();
            }
            this.rendered = true;
            (0, $3hhcj.emit)(this, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_RENDER));
        });
    }
    /**
     * <zh/> 绘制元素
     *
     * <en/> Draw elements
     * @returns <zh/> 渲染结果 | <en/> draw result
     * @remarks
     * <zh/> 仅执行元素绘制，不会重新布局
     *
     * <zh/> ⚠️ draw 为异步方法，如果需要在 draw 后执行一些操作，可以使用 `await graph.draw()` 或者监听 GraphEvent.AFTER_DRAW 事件
     *
     * <en/> Only execute element drawing, no re-layout
     *
     * <en/> ⚠️ draw is an asynchronous method. If you need to perform some operations after draw, you can use `await graph.draw()` or listen to the GraphEvent.AFTER_DRAW event
     * @apiCategory render
     */ draw() {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield this.prepare();
            yield (_a = this.context.element.draw()) === null || _a === void 0 ? void 0 : _a.finished;
        });
    }
    /**
     * <zh/> 执行布局
     *
     * <en/> Execute layout
     * @param layoutOptions - <zh/> 布局配置项 | <en/> Layout options
     * @apiCategory layout
     */ layout(layoutOptions) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            yield this.context.layout.postLayout(layoutOptions);
        });
    }
    /**
     * <zh/> 停止布局
     *
     * <en/> Stop layout
     * @remarks
     * <zh/> 适用于带有迭代动画的布局，目前有 `force` 属于此类布局，即停止力导布局的迭代，一般用于布局迭代时间过长情况下的手动停止迭代动画，例如在点击画布/节点的监听中调用
     *
     * <en/> Suitable for layouts with iterative animations. Currently, `force` belongs to this type of layout, that is, stop the iteration of the force-directed layout. It is generally used to manually stop the iteration animation when the layout iteration time is too long, such as calling in the click canvas/node listener
     * @apiCategory layout
     */ stopLayout() {
        this.context.layout.stopLayout();
    }
    /**
     * <zh/> 清空画布元素
     *
     * <en/> Clear canvas elements
     * @apiCategory canvas
     */ clear() {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            const { model: model, element: element } = this.context;
            model.setData({});
            model.clearChanges();
            element === null || element === void 0 || element.clear();
        });
    }
    /**
     * <zh/> 销毁当前图实例
     *
     * <en/> Destroy the current graph instance
     * @remarks
     * <zh/> 销毁后无法进行任何操作，如果需要重新使用，需要重新创建一个新的图实例
     *
     * <en/> After destruction, no operations can be performed. If you need to reuse it, you need to create a new graph instance
     * @apiCategory instance
     */ destroy() {
        var _a;
        (0, $3hhcj.emit)(this, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_DESTROY));
        const { layout: layout, animation: animation, element: element, model: model, canvas: canvas, behavior: behavior, plugin: plugin } = this.context;
        plugin === null || plugin === void 0 || plugin.destroy();
        behavior === null || behavior === void 0 || behavior.destroy();
        layout === null || layout === void 0 || layout.destroy();
        animation === null || animation === void 0 || animation.destroy();
        element === null || element === void 0 || element.destroy();
        model.destroy();
        canvas === null || canvas === void 0 || canvas.destroy();
        this.options = {};
        // @ts-expect-error force delete
        this.context = {};
        this.off();
        (_a = globalThis.removeEventListener) === null || _a === void 0 || _a.call(globalThis, 'resize', this.onResize);
        this.destroyed = true;
        (0, $3hhcj.emit)(this, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_DESTROY));
    }
    /**
     * <zh/> 获取画布实例
     *
     * <en/> Get canvas instance
     * @returns - <zh/> 画布实例 | <en/> canvas instance
     * @apiCategory canvas
     */ getCanvas() {
        return this.context.canvas;
    }
    resize(width, height) {
        var _a;
        const containerSize = (0, $fELnD.sizeOf)((_a = this.context.canvas) === null || _a === void 0 ? void 0 : _a.getContainer());
        const specificSize = [
            width || containerSize[0],
            height || containerSize[1]
        ];
        if (!this.context.canvas) return;
        const canvasSize = this.context.canvas.getSize();
        if ((0, $4ETMA.default)(specificSize, canvasSize)) return;
        (0, $3hhcj.emit)(this, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_SIZE_CHANGE, {
            size: specificSize
        }));
        this.context.canvas.resize(...specificSize);
        (0, $3hhcj.emit)(this, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_SIZE_CHANGE, {
            size: specificSize
        }));
    }
    /**
     * <zh/> 将图缩放至合适大小并平移至视口中心
     *
     * <en/> Zoom the graph to fit the viewport and move it to the center of the viewport
     * @param options - <zh/> 适配配置 | <en/> fit options
     * @param animation - <zh/> 动画配置 | <en/> animation options
     * @apiCategory viewport
     */ fitView(options, animation) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.context.viewport) === null || _a === void 0 ? void 0 : _a.fitView(options, animation);
        });
    }
    /**
     * <zh/> 将图平移至视口中心
     *
     * <en/> Move the graph to the center of the viewport
     * @param animation - <zh/> 动画配置 | <en/> animation options
     * @apiCategory viewport
     */ fitCenter(animation) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.context.viewport) === null || _a === void 0 ? void 0 : _a.fitCenter({
                animation: animation
            });
        });
    }
    autoFit() {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            const { autoFit: autoFit } = this.context.options;
            if (!autoFit) return;
            if ((0, $kVcyu.default)(autoFit)) {
                if (autoFit === 'view') yield this.fitView();
                else if (autoFit === 'center') yield this.fitCenter();
            } else {
                const { type: type, animation: animation } = autoFit;
                if (type === 'view') yield this.fitView(autoFit.options, animation);
                else if (type === 'center') yield this.fitCenter(animation);
            }
        });
    }
    /**
     * <zh/> 聚焦元素
     *
     * <en/> Focus on element
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @param animation - <zh/> 动画配置 | <en/> animation options
     * @remarks
     * <zh/> 移动图，使得元素对齐到视口中心
     *
     * <en/> Move the graph so that the element is aligned to the center of the viewport
     * @apiCategory viewport
     */ focusElement(id, animation) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            yield (_a = this.context.viewport) === null || _a === void 0 ? void 0 : _a.focusElements(Array.isArray(id) ? id : [
                id
            ], {
                animation: animation
            });
        });
    }
    /**
     * <zh/> 基于当前缩放比例进行缩放（相对缩放）
     *
     * <en/> Zoom based on the current zoom ratio (relative zoom)
     * @param ratio - <zh/> 缩放比例 | <en/> zoom ratio
     * @param animation - <zh/> 动画配置 | <en/> animation options
     * @param origin - <zh/> 缩放中心(视口坐标) | <en/> zoom center(viewport coordinates)
     * @remarks
     * <zh/>
     * - ratio > 1 放大
     * - ratio < 1 缩小
     *
     * <en/>
     * - ratio > 1 zoom in
     * - ratio < 1 zoom out
     * @apiCategory viewport
     */ zoomBy(ratio, animation, origin) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            yield this.context.viewport.transform({
                mode: 'relative',
                scale: ratio,
                origin: origin
            }, animation);
        });
    }
    /**
     * <zh/> 缩放画布至指定比例（绝对缩放）
     *
     * <en/> Zoom the canvas to the specified ratio (absolute zoom)
     * @param zoom - <zh/> 指定缩放比例 | <en/> specified zoom ratio
     * @param animation - <zh/> 动画配置 | <en/> animation options
     * @param origin - <zh/> 缩放中心(视口坐标) | <en/> zoom center(viewport coordinates)
     * @remarks
     * <zh/>
     * - zoom = 1 默认大小
     * - zoom > 1 放大
     * - zoom < 1 缩小
     *
     * <en/>
     * - zoom = 1 default size
     * - zoom > 1 zoom in
     * - zoom < 1 zoom out
     * @apiCategory viewport
     */ zoomTo(zoom, animation, origin) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            yield this.context.viewport.transform({
                mode: 'absolute',
                scale: zoom,
                origin: origin
            }, animation);
        });
    }
    /**
     * <zh/> 获取当前缩放比例
     *
     * <en/> Get the current zoom ratio
     * @returns <zh/> 缩放比例 | <en/> zoom ratio
     * @apiCategory viewport
     */ getZoom() {
        return this.context.viewport.getZoom();
    }
    /**
     * <zh/> 基于当前旋转角度进行旋转（相对旋转）
     *
     * <en/> Rotate based on the current rotation angle (relative rotation)
     * @param angle - <zh/> 旋转角度 | <en/> rotation angle
     * @param animation - <zh/> 动画配置 | <en/> animation options
     * @param origin - <zh/> 旋转中心(视口坐标) | <en/> rotation center(viewport coordinates)
     * @apiCategory viewport
     */ rotateBy(angle, animation, origin) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            yield this.context.viewport.transform({
                mode: 'relative',
                rotate: angle,
                origin: origin
            }, animation);
        });
    }
    /**
     * <zh/> 旋转画布至指定角度 (绝对旋转)
     *
     * <en/> Rotate the canvas to the specified angle (absolute rotation)
     * @param angle - <zh/> 目标角度 | <en/> target angle
     * @param animation - <zh/> 动画配置 | <en/> animation options
     * @param origin - <zh/> 旋转中心(视口坐标) | <en/> rotation center(viewport coordinates)
     * @apiCategory viewport
     */ rotateTo(angle, animation, origin) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            yield this.context.viewport.transform({
                mode: 'absolute',
                rotate: angle,
                origin: origin
            }, animation);
        });
    }
    /**
     * <zh/> 获取当前旋转角度
     *
     * <en/> Get the current rotation angle
     * @returns <zh/> 旋转角度 | <en/> rotation angle
     * @apiCategory viewport
     */ getRotation() {
        return this.context.viewport.getRotation();
    }
    /**
     * <zh/> 将图平移指定距离 (相对平移)
     *
     * <en/> Translate the graph by the specified distance (relative translation)
     * @param offset - <zh/> 偏移量 | <en/> offset
     * @param animation - <zh/> 动画配置 | <en/> animation options
     * @apiCategory viewport
     */ translateBy(offset, animation) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            yield this.context.viewport.transform({
                mode: 'relative',
                translate: offset
            }, animation);
        });
    }
    /**
     * <zh/> 将图平移至指定位置 (绝对平移)
     *
     * <en/> Translate the graph to the specified position (absolute translation)
     * @param position - <zh/> 指定位置 | <en/> specified position
     * @param animation - <zh/> 动画配置 | <en/> animation options
     * @apiCategory viewport
     */ translateTo(position, animation) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            yield this.context.viewport.transform({
                mode: 'absolute',
                translate: position
            }, animation);
        });
    }
    /**
     * <zh/> 获取图的位置
     *
     * <en/> Get the position of the graph
     * @returns <zh/> 图的位置 | <en/> position of the graph
     * @remarks
     * <zh/> 即画布原点在视口坐标系下的位置。默认状态下，图的位置为 [0, 0]
     *
     * <en/> That is, the position of the canvas origin in the viewport coordinate system. By default, the position of the graph is [0, 0]
     * @apiCategory viewport
     */ getPosition() {
        return (0, $dOidW.subtract)([
            0,
            0
        ], this.getCanvasByViewport([
            0,
            0
        ]));
    }
    translateElementBy(args1_1, args2_1) {
        return $928f3bcc6a617758$var$__awaiter(this, arguments, void 0, function*(args1, args2, args3 = true) {
            var _a, _b;
            const [config, animation] = (0, $6JKSc.default)(args1) ? [
                args1,
                (_a = args2) !== null && _a !== void 0 ? _a : true
            ] : [
                {
                    [args1]: args2
                },
                args3
            ];
            Object.entries(config).forEach(([id, offset])=>this.context.model.translateNodeLikeBy(id, offset));
            yield (_b = this.context.element.draw({
                animation: animation,
                stage: 'translate'
            })) === null || _b === void 0 ? void 0 : _b.finished;
        });
    }
    translateElementTo(args1_1, args2_1) {
        return $928f3bcc6a617758$var$__awaiter(this, arguments, void 0, function*(args1, args2, args3 = true) {
            var _a, _b;
            const [config, animation] = (0, $6JKSc.default)(args1) ? [
                args1,
                (_a = args2) !== null && _a !== void 0 ? _a : true
            ] : [
                {
                    [args1]: args2
                },
                args3
            ];
            Object.entries(config).forEach(([id, position])=>this.context.model.translateNodeLikeTo(id, position));
            yield (_b = this.context.element.draw({
                animation: animation,
                stage: 'translate'
            })) === null || _b === void 0 ? void 0 : _b.finished;
        });
    }
    /**
     * <zh/> 获取元素位置
     *
     * <en/> Get element position
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @returns <zh/> 元素位置 | <en/> element position
     * @apiCategory element
     */ getElementPosition(id) {
        return this.context.model.getElementPosition(id);
    }
    /**
     * <zh/> 获取元素渲染样式
     *
     * <en/> Get element rendering style
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @returns <zh/> 元素渲染样式 | <en/> element rendering style
     * @apiCategory element
     */ getElementRenderStyle(id) {
        return (0, $64w8j.default)(this.context.element.getElement(id).attributes, [
            'context'
        ]);
    }
    setElementVisibility(args1_1, args2_1) {
        return $928f3bcc6a617758$var$__awaiter(this, arguments, void 0, function*(args1, args2, args3 = true) {
            var _a, _b;
            const [config, animation] = (0, $6JKSc.default)(args1) ? [
                args1,
                (_a = args2) !== null && _a !== void 0 ? _a : true
            ] : [
                {
                    [args1]: args2
                },
                args3
            ];
            const dataToUpdate = {
                nodes: [],
                edges: [],
                combos: []
            };
            Object.entries(config).forEach(([id, value])=>{
                const elementType = this.getElementType(id);
                dataToUpdate[`${elementType}s`].push({
                    id: id,
                    style: {
                        visibility: value
                    }
                });
            });
            const { model: model, element: element } = this.context;
            model.preventUpdateNodeLikeHierarchy(()=>{
                model.updateData(dataToUpdate);
            });
            yield (_b = element.draw({
                animation: animation,
                stage: 'visibility'
            })) === null || _b === void 0 ? void 0 : _b.finished;
        });
    }
    /**
     * <zh/> 显示元素
     *
     * <en/> Show element
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @param animation - <zh/> 是否启用动画 | <en/> whether to enable animation
     * @apiCategory element
     */ showElement(id, animation) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            const ids = Array.isArray(id) ? id : [
                id
            ];
            yield this.setElementVisibility(Object.fromEntries(ids.map((_id)=>[
                    _id,
                    'visible'
                ])), animation);
        });
    }
    /**
     * <zh/> 隐藏元素
     *
     * <en/> Hide element
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @param animation - <zh/> 是否启用动画 | <en/> whether to enable animation
     * @apiCategory element
     */ hideElement(id, animation) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            const ids = Array.isArray(id) ? id : [
                id
            ];
            yield this.setElementVisibility(Object.fromEntries(ids.map((_id)=>[
                    _id,
                    'hidden'
                ])), animation);
        });
    }
    /**
     * <zh/> 获取元素可见性
     *
     * <en/> Get element visibility
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @returns <zh/> 元素可见性 | <en/> element visibility
     * @apiCategory element
     */ getElementVisibility(id) {
        var _a, _b;
        const element = this.context.element.getElement(id);
        return (_b = (_a = element === null || element === void 0 ? void 0 : element.style) === null || _a === void 0 ? void 0 : _a.visibility) !== null && _b !== void 0 ? _b : 'visible';
    }
    setElementZIndex(args1, args2) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const dataToUpdate = {
                nodes: [],
                edges: [],
                combos: []
            };
            const config = (0, $6JKSc.default)(args1) ? args1 : {
                [args1]: args2
            };
            Object.entries(config).forEach(([id, value])=>{
                const elementType = this.getElementType(id);
                dataToUpdate[`${elementType}s`].push({
                    id: id,
                    style: {
                        zIndex: value
                    }
                });
            });
            const { model: model, element: element } = this.context;
            model.preventUpdateNodeLikeHierarchy(()=>model.updateData(dataToUpdate));
            yield (_a = element.draw({
                animation: false,
                stage: 'zIndex'
            })) === null || _a === void 0 ? void 0 : _a.finished;
        });
    }
    /**
     * <zh/> 将元素置于最顶层
     *
     * <en/> Bring the element to the front
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @apiCategory element
     */ frontElement(id) {
        return $928f3bcc6a617758$var$__awaiter(this, void 0, void 0, function*() {
            const ids = Array.isArray(id) ? id : [
                id
            ];
            const { model: model } = this.context;
            const zIndexes = {};
            ids.map((_id)=>{
                const zIndex = model.getFrontZIndex(_id);
                const elementType = model.getElementType(_id);
                if (elementType === 'combo') {
                    const ancestor = model.getAncestorsData(_id, (0, $lDPR9.COMBO_KEY)).at(-1) || this.getComboData(_id);
                    const descendants = [
                        ancestor,
                        ...model.getDescendantsData((0, $brtTw.idOf)(ancestor))
                    ];
                    const delta = zIndex - (0, $2sBE1.getZIndexOf)(ancestor);
                    descendants.forEach((combo)=>{
                        zIndexes[(0, $brtTw.idOf)(combo)] = this.getElementZIndex((0, $brtTw.idOf)(combo)) + delta;
                    });
                    const { internal: internal } = (0, $25dP3.getSubgraphRelatedEdges)(descendants.map((0, $brtTw.idOf)), (id)=>model.getRelatedEdgesData(id));
                    internal.forEach((edge)=>{
                        const edgeId = (0, $brtTw.idOf)(edge);
                        zIndexes[edgeId] = this.getElementZIndex(edgeId) + delta;
                    });
                } else zIndexes[_id] = zIndex;
            });
            yield this.setElementZIndex(zIndexes);
        });
    }
    /**
     * <zh/> 获取元素层级
     *
     * <en/> Get element z-index
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @returns <zh/> 元素层级 | <en/> element z-index
     * @apiCategory element
     */ getElementZIndex(id) {
        return (0, $2sBE1.getZIndexOf)(this.context.model.getElementDataById(id));
    }
    setElementState(args1_1, args2_1) {
        return $928f3bcc6a617758$var$__awaiter(this, arguments, void 0, function*(args1, args2, args3 = true) {
            var _a, _b;
            const [config, animation] = (0, $6JKSc.default)(args1) ? [
                args1,
                (_a = args2) !== null && _a !== void 0 ? _a : true
            ] : [
                {
                    [args1]: args2
                },
                args3
            ];
            const parseState = (state)=>{
                if (!state) return [];
                return Array.isArray(state) ? state : [
                    state
                ];
            };
            const dataToUpdate = {
                nodes: [],
                edges: [],
                combos: []
            };
            Object.entries(config).forEach(([id, value])=>{
                const elementType = this.getElementType(id);
                dataToUpdate[`${elementType}s`].push({
                    id: id,
                    states: parseState(value)
                });
            });
            this.updateData(dataToUpdate);
            yield (_b = this.context.element.draw({
                animation: animation,
                stage: 'state'
            })) === null || _b === void 0 ? void 0 : _b.finished;
        });
    }
    /**
     * <zh/> 获取元素状态
     *
     * <en/> Get element state
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @returns <zh/> 元素状态 | <en/> element state
     * @apiCategory element
     */ getElementState(id) {
        return this.context.model.getElementState(id);
    }
    /**
     * <zh/> 获取元素自身以及子节点在世界坐标系下的渲染包围盒
     *
     * <en/> Get the rendering bounding box of the element itself and its child nodes in the world coordinate system
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @returns <zh/> 渲染包围盒 | <en/> render bounding box
     * @apiCategory element
     */ getElementRenderBounds(id) {
        return this.context.element.getElement(id).getRenderBounds();
    }
    /**
     * <zh/> 收起元素
     *
     * <en/> Collapse element
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @param options - <zh/> 是否启用动画或者配置收起节点的配置项 | <en/> whether to enable animation or the options of collapsing node
     * @apiCategory element
     */ collapseElement(id_1) {
        return $928f3bcc6a617758$var$__awaiter(this, arguments, void 0, function*(id, options = true) {
            const { model: model, element: element } = this.context;
            if ((0, $VNNBO.isCollapsed)(model.getNodeLikeData([
                id
            ])[0])) return;
            if (this.isCollapsingExpanding) return;
            if (typeof options === 'boolean') options = {
                animation: options,
                align: false
            };
            const elementType = model.getElementType(id);
            yield this.frontElement(id);
            this.isCollapsingExpanding = true;
            // 更新折叠状态 / Update collapse style
            model.updateData(elementType === 'node' ? {
                nodes: [
                    {
                        id: id,
                        style: {
                            collapsed: true
                        }
                    }
                ]
            } : {
                combos: [
                    {
                        id: id,
                        style: {
                            collapsed: true
                        }
                    }
                ]
            });
            if (elementType === 'node') yield element.collapseNode(id, options);
            else if (elementType === 'combo') yield element.collapseCombo(id, !!options.animation);
            this.isCollapsingExpanding = false;
        });
    }
    /**
     * <zh/> 展开元素
     *
     * <en/> Expand Element
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @param animation - <zh/> 是否启用动画或者配置收起节点的配置项 | <en/> whether to enable animation or the options of collapsing node
     * @param options
     * @apiCategory element
     */ expandElement(id_1) {
        return $928f3bcc6a617758$var$__awaiter(this, arguments, void 0, function*(id, options = true) {
            const { model: model, element: element } = this.context;
            if (!(0, $VNNBO.isCollapsed)(model.getNodeLikeData([
                id
            ])[0])) return;
            if (this.isCollapsingExpanding) return;
            if (typeof options === 'boolean') options = {
                animation: options,
                align: false
            };
            const elementType = model.getElementType(id);
            this.isCollapsingExpanding = true;
            // 更新折叠状态 / Update collapse style
            model.updateData(elementType === 'node' ? {
                nodes: [
                    {
                        id: id,
                        style: {
                            collapsed: false
                        }
                    }
                ]
            } : {
                combos: [
                    {
                        id: id,
                        style: {
                            collapsed: false
                        }
                    }
                ]
            });
            if (elementType === 'node') yield element.expandNode(id, options);
            else if (elementType === 'combo') yield element.expandCombo(id, !!options.animation);
            this.isCollapsingExpanding = false;
        });
    }
    setElementCollapsibility(id, collapsed) {
        const elementType = this.getElementType(id);
        if (elementType === 'node') this.updateNodeData([
            {
                id: id,
                style: {
                    collapsed: collapsed
                }
            }
        ]);
        else if (elementType === 'combo') this.updateComboData([
            {
                id: id,
                style: {
                    collapsed: collapsed
                }
            }
        ]);
    }
    /**
     * <zh/> 导出画布内容为 DataURL
     *
     * <en/> Export canvas content as DataURL
     * @param options - <zh/> 导出配置 | <en/> export options
     * @returns <zh/> DataURL | <en/> DataURL
     * @apiCategory exportImage
     */ toDataURL() {
        return $928f3bcc6a617758$var$__awaiter(this, arguments, void 0, function*(options = {}) {
            return this.context.canvas.toDataURL(options);
        });
    }
    /**
     * <zh/> 给定的视窗 DOM 坐标，转换为画布上的绘制坐标
     *
     * <en/> Convert the given viewport DOM coordinates to the drawing coordinates on the canvas
     * @param point - <zh/> 视窗坐标 | <en/> viewport coordinates
     * @returns <zh/> 画布上的绘制坐标 | <en/> drawing coordinates on the canvas
     * @apiCategory viewport
     */ getCanvasByViewport(point) {
        return this.context.canvas.getCanvasByViewport(point);
    }
    /**
     * <zh/> 给定画布上的绘制坐标，转换为视窗 DOM 的坐标
     *
     * <en/> Convert the given drawing coordinates on the canvas to the coordinates of the viewport DOM
     * @param point - <zh/> 画布坐标 | <en/> canvas coordinates
     * @returns <zh/> 视窗 DOM 的坐标 | <en/> coordinates of the viewport DOM
     * @apiCategory viewport
     */ getViewportByCanvas(point) {
        return this.context.canvas.getViewportByCanvas(point);
    }
    /**
     * <zh/> 给定画布上的绘制坐标，转换为浏览器坐标
     *
     * <en/> Convert the given drawing coordinates on the canvas to browser coordinates
     * @param point - <zh/> 画布坐标 | <en/> canvas coordinates
     * @returns <zh/> 浏览器坐标 | <en/> browser coordinates
     * @apiCategory viewport
     */ getClientByCanvas(point) {
        return this.context.canvas.getClientByCanvas(point);
    }
    /**
     * <zh/> 给定的浏览器坐标，转换为画布上的绘制坐标
     *
     * <en/> Convert the given browser coordinates to drawing coordinates on the canvas
     * @param point - <zh/> 浏览器坐标 | <en/> browser coordinates
     * @returns <zh/> 画布上的绘制坐标 | <en/> drawing coordinates on the canvas
     * @apiCategory viewport
     */ getCanvasByClient(point) {
        return this.context.canvas.getCanvasByClient(point);
    }
    /**
     * <zh/> 获取视口中心的画布坐标
     *
     * <en/> Get the canvas coordinates of the viewport center
     * @returns <zh/> 视口中心的画布坐标 | <en/> Canvas coordinates of the viewport center
     * @apiCategory viewport
     */ getViewportCenter() {
        return this.context.viewport.getViewportCenter();
    }
    /**
     * <zh/> 获取视口中心的视口坐标
     *
     * <en/> Get the viewport coordinates of the viewport center
     * @returns <zh/> 视口中心的视口坐标 | <en/> Viewport coordinates of the viewport center
     * @apiCategory viewport
     */ getCanvasCenter() {
        return this.context.viewport.getCanvasCenter();
    }
    /**
     * <zh/> 监听事件
     *
     * <en/> Listen to events
     * @param eventName - <zh/> 事件名称 | <en/> event name
     * @param callback - <zh/> 回调函数 | <en/> callback function
     * @param once - <zh/> 是否只监听一次 | <en/> whether to listen only once
     * @returns <zh/> Graph 实例 | <en/> Graph instance
     * @apiCategory event
     */ on(eventName, callback, once) {
        return super.on(eventName, callback, once);
    }
    /**
     * <zh/> 一次性监听事件
     *
     * <en/> Listen to events once
     * @param eventName - <zh/> 事件名称 | <en/> event name
     * @param callback - <zh/> 回调函数 | <en/> callback function
     * @returns <zh/> Graph 实例 | <en/> Graph instance
     * @apiCategory event
     */ once(eventName, callback) {
        return super.once(eventName, callback);
    }
    off(eventName, callback) {
        return super.off(eventName, callback);
    }
}
/**
 * @internal
 */ $928f3bcc6a617758$export$614db49f3febe941.defaultOptions = {
    autoResize: false,
    theme: 'light',
    rotation: 0,
    zoom: 1,
    zoomRange: [
        0.01,
        10
    ]
};

});
parcelRegister("fELnD", function(module, exports) {

$parcel$export(module.exports, "sizeOf", () => $b65f582fe6744721$export$30043de3fae42dd1);

var $jyI49 = parcelRequire("jyI49");
const $b65f582fe6744721$var$parseInt10 = (d)=>d ? parseInt(d) : 0;
/**
 * Get the container's bounding size.
 * @param container dom element.
 * @returns the container width and height
 */ function $b65f582fe6744721$var$getContainerSize(container) {
    const style = getComputedStyle(container);
    const wrapperWidth = container.clientWidth || $b65f582fe6744721$var$parseInt10(style.width);
    const wrapperHeight = container.clientHeight || $b65f582fe6744721$var$parseInt10(style.height);
    const widthPadding = $b65f582fe6744721$var$parseInt10(style.paddingLeft) + $b65f582fe6744721$var$parseInt10(style.paddingRight);
    const heightPadding = $b65f582fe6744721$var$parseInt10(style.paddingTop) + $b65f582fe6744721$var$parseInt10(style.paddingBottom);
    return [
        wrapperWidth - widthPadding,
        wrapperHeight - heightPadding
    ];
}
function $b65f582fe6744721$export$30043de3fae42dd1(container) {
    if (!container) return [
        0,
        0
    ];
    let effectiveWidth = 640;
    let effectiveHeight = 480;
    const [containerWidth, containerHeight] = $b65f582fe6744721$var$getContainerSize(container);
    effectiveWidth = containerWidth || effectiveWidth;
    effectiveHeight = containerHeight || effectiveHeight;
    /** Minimum width */ const MIN_CHART_WIDTH = 1;
    /** Minimum height */ const MIN_CHART_HEIGHT = 1;
    return [
        Math.max((0, $jyI49.default)(effectiveWidth) ? effectiveWidth : MIN_CHART_WIDTH, MIN_CHART_WIDTH),
        Math.max((0, $jyI49.default)(effectiveHeight) ? effectiveHeight : MIN_CHART_HEIGHT, MIN_CHART_HEIGHT)
    ];
}

});

parcelRegister("3hhcj", function(module, exports) {
$parcel$export(module.exports, "AnimateEvent", () => (parcelRequire("8Fqus")).AnimateEvent);
$parcel$export(module.exports, "ElementLifeCycleEvent", () => (parcelRequire("8Fqus")).ElementLifeCycleEvent);
$parcel$export(module.exports, "GraphLifeCycleEvent", () => (parcelRequire("8Fqus")).GraphLifeCycleEvent);
$parcel$export(module.exports, "ViewportEvent", () => (parcelRequire("8Fqus")).ViewportEvent);

$parcel$export(module.exports, "emit", () => $26304cb64a5c5b36$export$8f35fbd5db0f3634);
$parcel$export(module.exports, "eventTargetOf", () => $26304cb64a5c5b36$export$609216a75f3b683d);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $hn4z6 = parcelRequire("hn4z6");
parcelRequire("8Fqus");
function $26304cb64a5c5b36$export$8f35fbd5db0f3634(emitter, event) {
    emitter.emit(event.type, event);
}
function $26304cb64a5c5b36$export$609216a75f3b683d(shape) {
    if (!shape) return null;
    if (shape instanceof (0, $2eDEB.Document)) return {
        type: 'canvas',
        element: shape
    };
    let element = shape;
    while(element){
        // 此判断条件不适用于 label 和 节点分开渲染的情况
        // This condition is not applicable to the case where the label and node are rendered separately
        if ((0, $hn4z6.isNode)(element)) return {
            type: 'node',
            element: element
        };
        if ((0, $hn4z6.isEdge)(element)) return {
            type: 'edge',
            element: element
        };
        if ((0, $hn4z6.isCombo)(element)) return {
            type: 'combo',
            element: element
        };
        element = element.parentElement;
    }
    return null;
}

});
parcelRegister("8Fqus", function(module, exports) {

$parcel$export(module.exports, "GraphLifeCycleEvent", () => $64f6b3787e1dbcfd$export$d6731db965f8c403);
$parcel$export(module.exports, "AnimateEvent", () => $64f6b3787e1dbcfd$export$e0855970ff505f0b);
$parcel$export(module.exports, "ElementLifeCycleEvent", () => $64f6b3787e1dbcfd$export$cfbdd5792bf7efcd);
$parcel$export(module.exports, "ViewportEvent", () => $64f6b3787e1dbcfd$export$a100db4463e37ee4);
class $64f6b3787e1dbcfd$export$df414a03c2905461 {
    constructor(type){
        this.type = type;
    }
}
class $64f6b3787e1dbcfd$export$d6731db965f8c403 extends $64f6b3787e1dbcfd$export$df414a03c2905461 {
    constructor(type, data){
        super(type);
        this.data = data;
    }
}
class $64f6b3787e1dbcfd$export$e0855970ff505f0b extends $64f6b3787e1dbcfd$export$df414a03c2905461 {
    constructor(type, animationType, animation, data){
        super(type);
        this.animationType = animationType;
        this.animation = animation;
        this.data = data;
    }
}
class $64f6b3787e1dbcfd$export$cfbdd5792bf7efcd extends $64f6b3787e1dbcfd$export$df414a03c2905461 {
    constructor(type, elementType, data){
        super(type);
        this.elementType = elementType;
        this.data = data;
    }
}
class $64f6b3787e1dbcfd$export$a100db4463e37ee4 extends $64f6b3787e1dbcfd$export$df414a03c2905461 {
    constructor(type, data){
        super(type);
        this.data = data;
    }
}

});


parcelRegister("2sBE1", function(module, exports) {

$parcel$export(module.exports, "getZIndexOf", () => $1cab65b92a077270$export$90f4ad96143bb8e1);
/**
 * <zh/> 获取元素的 zIndex
 * <en/> Get the zIndex of the element
 * @param datum - <zh/> 元素数据 | <en/> element data
 * @returns - <zh/> zIndex | <en/> zIndex
 */ function $1cab65b92a077270$export$90f4ad96143bb8e1(datum) {
    var _a;
    return ((_a = datum === null || datum === void 0 ? void 0 : datum.style) === null || _a === void 0 ? void 0 : _a.zIndex) || 0;
}

});

parcelRegister("5dLqa", function(module, exports) {

$parcel$export(module.exports, "Animation", () => $3cd2f37e6aa065de$export$c35d437ae5945fcd);

var $lbDhQ = parcelRequire("lbDhQ");

var $dtz9V = parcelRequire("dtz9V");

var $730pp = parcelRequire("730pp");
class $3cd2f37e6aa065de$export$c35d437ae5945fcd {
    constructor(context){
        this.tasks = [];
        this.animations = new Set();
        this.context = context;
    }
    getTasks() {
        const tasks = [
            ...this.tasks
        ];
        this.tasks = [];
        return tasks;
    }
    add(context, callbacks) {
        this.tasks.push([
            context,
            callbacks
        ]);
    }
    animate(localAnimation, callbacks, extendOptions) {
        var _a, _b, _c;
        (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.before) === null || _a === void 0 || _a.call(callbacks);
        const animations = this.getTasks().map(([context, cb])=>{
            var _a, _b, _c;
            const { element: element, elementType: elementType, stage: stage } = context;
            const options = (0, $dtz9V.getElementAnimationOptions)(this.context.options, elementType, stage, localAnimation);
            (_a = cb === null || cb === void 0 ? void 0 : cb.before) === null || _a === void 0 || _a.call(cb);
            const animation = options.length ? (0, $lbDhQ.executor)(element, this.inferStyle(context, extendOptions), options) : null;
            if (animation) {
                (_b = cb === null || cb === void 0 ? void 0 : cb.beforeAnimate) === null || _b === void 0 || _b.call(cb, animation);
                animation.finished.then(()=>{
                    var _a, _b;
                    (_a = cb === null || cb === void 0 ? void 0 : cb.afterAnimate) === null || _a === void 0 || _a.call(cb, animation);
                    (_b = cb === null || cb === void 0 ? void 0 : cb.after) === null || _b === void 0 || _b.call(cb);
                    this.animations.delete(animation);
                });
            } else (_c = cb === null || cb === void 0 ? void 0 : cb.after) === null || _c === void 0 || _c.call(cb);
            return animation;
        }).filter(Boolean);
        animations.forEach((animation)=>this.animations.add(animation));
        const animation = (0, $dtz9V.createAnimationsProxy)(animations);
        if (animation) {
            (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.beforeAnimate) === null || _b === void 0 || _b.call(callbacks, animation);
            animation.finished.then(()=>{
                var _a, _b;
                (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.afterAnimate) === null || _a === void 0 || _a.call(callbacks, animation);
                (_b = callbacks === null || callbacks === void 0 ? void 0 : callbacks.after) === null || _b === void 0 || _b.call(callbacks);
                this.release();
            });
        } else (_c = callbacks === null || callbacks === void 0 ? void 0 : callbacks.after) === null || _c === void 0 || _c.call(callbacks);
        return animation;
    }
    /**
     * <zh/> 推断额外的动画样式
     *
     * <en/> Infer additional animation styles
     * @param context - <zh/> 动画上下文 | <en/> Animation context
     * @param options - <zh/> 扩展选项 | <en/> Extend options
     * @returns <zh/> 始态样式与终态样式 | <en/> Initial style and final style
     */ inferStyle(context, options) {
        var _a, _b;
        const { element: element, elementType: elementType, stage: stage, originalStyle: originalStyle, updatedStyle: updatedStyle = {} } = context;
        if (!context.modifiedStyle) context.modifiedStyle = Object.assign(Object.assign({}, originalStyle), updatedStyle);
        const { modifiedStyle: modifiedStyle } = context;
        const fromStyle = {};
        const toStyle = {};
        if (stage === 'enter') Object.assign(fromStyle, {
            opacity: 0
        });
        else if (stage === 'exit') Object.assign(toStyle, {
            opacity: 0
        });
        else if (stage === 'show') {
            Object.assign(fromStyle, {
                opacity: 0
            });
            Object.assign(toStyle, {
                opacity: (_a = (0, $730pp.getCachedStyle)(element, 'opacity')) !== null && _a !== void 0 ? _a : (0, $dtz9V.inferDefaultValue)('opacity')
            });
        } else if (stage === 'hide') {
            Object.assign(fromStyle, {
                opacity: (_b = (0, $730pp.getCachedStyle)(element, 'opacity')) !== null && _b !== void 0 ? _b : (0, $dtz9V.inferDefaultValue)('opacity')
            });
            Object.assign(toStyle, {
                opacity: 0
            });
        } else if (stage === 'collapse') {
            const { collapse: collapse } = options || {};
            const { target: target, descendants: descendants, position: position } = collapse;
            if (elementType === 'node') // 为即将被删除的元素设置目标位置
            // Set the target position for the element to be deleted
            {
                if (descendants.includes(element.id)) {
                    const [x, y, z] = position;
                    Object.assign(toStyle, {
                        x: x,
                        y: y,
                        z: z
                    });
                }
            } else if (elementType === 'combo') {
                if (element.id === target || descendants.includes(element.id)) {
                    const [x, y] = position;
                    Object.assign(toStyle, {
                        x: x,
                        y: y,
                        childrenNode: originalStyle.childrenNode
                    });
                }
            } else if (elementType === 'edge') Object.assign(toStyle, {
                sourceNode: modifiedStyle.sourceNode,
                targetNode: modifiedStyle.targetNode
            });
        } else if (stage === 'expand') {
            const { expand: expand } = options || {};
            const { target: target, descendants: descendants, position: position } = expand;
            if (elementType === 'node') // 设置展开节点的起点位置
            // Set the starting position of the expanded node
            {
                if (element.id === target || descendants.includes(element.id)) {
                    const [x, y, z] = position;
                    Object.assign(fromStyle, {
                        x: x,
                        y: y,
                        z: z
                    });
                }
            } else if (elementType === 'combo') // 设置展开后的组合子元素
            // Set the child elements of the expanded combo
            {
                if (element.id === target || descendants.includes(element.id)) {
                    const [x, y, z] = position;
                    Object.assign(fromStyle, {
                        x: x,
                        y: y,
                        z: z,
                        childrenNode: modifiedStyle.childrenNode
                    });
                }
            } else if (elementType === 'edge') // 设置展开后的边的起点和终点
            // Set the starting point and end point of the edge after expansion
            Object.assign(fromStyle, {
                sourceNode: modifiedStyle.sourceNode,
                targetNode: modifiedStyle.targetNode
            });
        }
        return [
            Object.keys(fromStyle).length > 0 ? Object.assign({}, originalStyle, fromStyle) : originalStyle,
            Object.keys(toStyle).length > 0 ? Object.assign({}, modifiedStyle, toStyle) : modifiedStyle
        ];
    }
    stop() {
        this.animations.forEach((animation)=>animation.cancel());
    }
    clear() {
        this.tasks = [];
    }
    /**
     * <zh/> 释放存量动画对象
     *
     * <en/> Release stock animation objects
     * @description see: https://github.com/antvis/G/issues/1731
     */ release() {
        var _a, _b;
        const { canvas: canvas } = this.context;
        // @ts-expect-error private property
        const animationsWithPromises = (_b = (_a = canvas.document) === null || _a === void 0 ? void 0 : _a.timeline) === null || _b === void 0 ? void 0 : _b.animationsWithPromises;
        if (animationsWithPromises) // @ts-expect-error private property
        canvas.document.timeline.animationsWithPromises = animationsWithPromises.filter((animation)=>animation.playState !== 'finished');
    }
    destroy() {
        this.stop();
        this.animations.clear();
        this.tasks = [];
    }
}

});
parcelRegister("730pp", function(module, exports) {

$parcel$export(module.exports, "cacheStyle", () => $52192165f47d2527$export$26589b7c65445060);
$parcel$export(module.exports, "getCachedStyle", () => $52192165f47d2527$export$b942722635489ed7);
$parcel$export(module.exports, "hasCachedStyle", () => $52192165f47d2527$export$a1ac8de4d8242db6);

var $6XARU = parcelRequire("6XARU");
var $5vprq = parcelRequire("5vprq");
const $52192165f47d2527$var$CacheTargetKey = 'cachedStyle';
const $52192165f47d2527$var$getStyleCacheKey = (name)=>`__${name}__`;
function $52192165f47d2527$export$26589b7c65445060(element, name) {
    const names = Array.isArray(name) ? name : [
        name
    ];
    if (!(0, $6XARU.default)(element, $52192165f47d2527$var$CacheTargetKey)) (0, $5vprq.default)(element, $52192165f47d2527$var$CacheTargetKey, {});
    names.forEach((n)=>{
        (0, $5vprq.default)((0, $6XARU.default)(element, $52192165f47d2527$var$CacheTargetKey), $52192165f47d2527$var$getStyleCacheKey(n), element.attributes[n]);
    });
}
function $52192165f47d2527$export$b942722635489ed7(element, name) {
    return (0, $6XARU.default)(element, [
        $52192165f47d2527$var$CacheTargetKey,
        $52192165f47d2527$var$getStyleCacheKey(name)
    ]);
}
function $52192165f47d2527$export$a1ac8de4d8242db6(element, name) {
    return $52192165f47d2527$var$getStyleCacheKey(name) in ((0, $6XARU.default)(element, $52192165f47d2527$var$CacheTargetKey) || {});
}
function $52192165f47d2527$export$b399ca495f32d2ae(element, name, value) {
    (0, $5vprq.default)(element, [
        $52192165f47d2527$var$CacheTargetKey,
        $52192165f47d2527$var$getStyleCacheKey(name)
    ], value);
}

});


parcelRegister("7P9bx", function(module, exports) {

$parcel$export(module.exports, "BatchController", () => $5b246bcbb8733766$export$1c7dbc2e99774d35);
parcelRequire("ahJ7k");
var $4EzN9 = parcelRequire("4EzN9");
parcelRequire("3hhcj");
var $8Fqus = parcelRequire("8Fqus");
class $5b246bcbb8733766$export$1c7dbc2e99774d35 {
    constructor(context){
        this.batchCount = 0;
        this.context = context;
    }
    emit(event) {
        const { graph: graph } = this.context;
        graph.emit(event.type, event);
    }
    startBatch(initiate = true) {
        this.batchCount++;
        if (this.batchCount === 1) this.emit(new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BATCH_START, {
            initiate: initiate
        }));
    }
    endBatch() {
        this.batchCount--;
        if (this.batchCount === 0) this.emit(new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BATCH_END));
    }
    get isBatching() {
        return this.batchCount > 0;
    }
    destroy() {
        // @ts-ignore
        this.context = null;
    }
}

});

parcelRegister("3LpK5", function(module, exports) {

$parcel$export(module.exports, "BehaviorController", () => $2bd9bacac68c5993$export$49cc6c1f3e488456);
parcelRequire("ahJ7k");
var $9Iel2 = parcelRequire("9Iel2");
var $je0UY = parcelRequire("je0UY");

var $dhEO8 = parcelRequire("dhEO8");

var $hn4z6 = parcelRequire("hn4z6");

var $3hhcj = parcelRequire("3hhcj");
class $2bd9bacac68c5993$export$49cc6c1f3e488456 extends (0, $dhEO8.ExtensionController) {
    constructor(context){
        super(context);
        /**
         * <zh/> 当前事件的目标
         *
         *  <en/> The current event target
         */ this.currentTarget = null;
        this.currentTargetType = null;
        this.category = 'behavior';
        this.forwardCanvasEvents = (event)=>{
            const { target: originalTarget } = event;
            const target = (0, $3hhcj.eventTargetOf)(originalTarget);
            if (!target) return;
            const { graph: graph, canvas: canvas } = this.context;
            const { type: targetType, element: targetElement } = target;
            // 即将销毁或已销毁的元素不再触发事件
            // Elements that are about to be destroyed or have been destroyed no longer trigger events
            if ('destroyed' in targetElement && ((0, $hn4z6.isToBeDestroyed)(targetElement) || targetElement.destroyed)) return;
            const { type: type, detail: detail, button: button } = event;
            const stdEvent = Object.assign(Object.assign({}, event), {
                target: targetElement,
                targetType: targetType,
                originalTarget: originalTarget
            });
            if (type === (0, $9Iel2.CommonEvent).POINTER_MOVE) {
                if (this.currentTarget !== targetElement) {
                    if (this.currentTarget) graph.emit(`${this.currentTargetType}:${(0, $9Iel2.CommonEvent).POINTER_LEAVE}`, Object.assign(Object.assign({}, stdEvent), {
                        type: (0, $9Iel2.CommonEvent).POINTER_LEAVE,
                        target: this.currentTarget,
                        targetType: this.currentTargetType
                    }));
                    if (targetElement) {
                        Object.assign(stdEvent, {
                            type: (0, $9Iel2.CommonEvent).POINTER_ENTER
                        });
                        graph.emit(`${targetType}:${(0, $9Iel2.CommonEvent).POINTER_ENTER}`, stdEvent);
                    }
                }
                this.currentTarget = targetElement;
                this.currentTargetType = targetType;
            }
            // 非右键点击事件 / Click event except right click
            if (!(type === (0, $9Iel2.CommonEvent).CLICK && button === 2)) {
                graph.emit(`${targetType}:${type}`, stdEvent);
                graph.emit(type, stdEvent);
            }
            // 双击事件 / Double click event
            if (type === (0, $9Iel2.CommonEvent).CLICK && detail === 2) {
                Object.assign(stdEvent, {
                    type: (0, $9Iel2.CommonEvent).DBLCLICK
                });
                graph.emit(`${targetType}:${(0, $9Iel2.CommonEvent).DBLCLICK}`, stdEvent);
                graph.emit((0, $9Iel2.CommonEvent).DBLCLICK, stdEvent);
            }
            // 右键菜单 / Contextmenu
            if (type === (0, $9Iel2.CommonEvent).POINTER_DOWN && button === 2) {
                Object.assign(stdEvent, {
                    type: (0, $9Iel2.CommonEvent).CONTEXT_MENU,
                    preventDefault: ()=>{
                        var _a;
                        (_a = canvas.getContainer()) === null || _a === void 0 || _a.addEventListener((0, $9Iel2.CommonEvent).CONTEXT_MENU, (e)=>e.preventDefault(), {
                            once: true
                        });
                    }
                });
                graph.emit(`${targetType}:${(0, $9Iel2.CommonEvent).CONTEXT_MENU}`, stdEvent);
                graph.emit((0, $9Iel2.CommonEvent).CONTEXT_MENU, stdEvent);
            }
        };
        this.forwardContainerEvents = (event)=>{
            this.context.graph.emit(event.type, event);
        };
        this.forwardEvents();
        this.setBehaviors(this.context.options.behaviors || []);
    }
    setBehaviors(behaviors) {
        this.setExtensions(behaviors);
    }
    forwardEvents() {
        const container = this.context.canvas.getContainer();
        if (container) [
            (0, $je0UY.ContainerEvent).KEY_DOWN,
            (0, $je0UY.ContainerEvent).KEY_UP
        ].forEach((name)=>{
            container.addEventListener(name, this.forwardContainerEvents);
        });
        const canvas = this.context.canvas.document;
        if (canvas) [
            (0, $9Iel2.CommonEvent).CLICK,
            (0, $9Iel2.CommonEvent).DBLCLICK,
            (0, $9Iel2.CommonEvent).POINTER_OVER,
            (0, $9Iel2.CommonEvent).POINTER_LEAVE,
            (0, $9Iel2.CommonEvent).POINTER_ENTER,
            (0, $9Iel2.CommonEvent).POINTER_MOVE,
            (0, $9Iel2.CommonEvent).POINTER_OUT,
            (0, $9Iel2.CommonEvent).POINTER_DOWN,
            (0, $9Iel2.CommonEvent).POINTER_UP,
            (0, $9Iel2.CommonEvent).CONTEXT_MENU,
            (0, $9Iel2.CommonEvent).DRAG_START,
            (0, $9Iel2.CommonEvent).DRAG,
            (0, $9Iel2.CommonEvent).DRAG_END,
            (0, $9Iel2.CommonEvent).DRAG_ENTER,
            (0, $9Iel2.CommonEvent).DRAG_OVER,
            (0, $9Iel2.CommonEvent).DRAG_LEAVE,
            (0, $9Iel2.CommonEvent).DROP,
            (0, $9Iel2.CommonEvent).WHEEL
        ].forEach((name)=>{
            canvas.addEventListener(name, this.forwardCanvasEvents);
        });
    }
    destroy() {
        const container = this.context.canvas.getContainer();
        if (container) [
            (0, $je0UY.ContainerEvent).KEY_DOWN,
            (0, $je0UY.ContainerEvent).KEY_UP
        ].forEach((name)=>{
            container.removeEventListener(name, this.forwardContainerEvents);
        });
        this.context.canvas.document.removeAllEventListeners();
        super.destroy();
    }
}

});

parcelRegister("csx45", function(module, exports) {

$parcel$export(module.exports, "DataController", () => $9121bf8ab1d2392d$export$af704488d7d0ffb8);

var $fc2XC = parcelRequire("fc2XC");

var $geZBG = parcelRequire("geZBG");
var $jyI49 = parcelRequire("jyI49");
var $3cpV4 = parcelRequire("3cpV4");
parcelRequire("ahJ7k");
var $cFz2C = parcelRequire("cFz2C");
var $lDPR9 = parcelRequire("lDPR9");

var $VNNBO = parcelRequire("VNNBO");

var $b8Sbq = parcelRequire("b8Sbq");

var $6SQtU = parcelRequire("6SQtU");

var $8awWK = parcelRequire("8awWK");

var $brtTw = parcelRequire("brtTw");

var $46bcR = parcelRequire("46bcR");

var $aBpmX = parcelRequire("aBpmX");

var $dTE8j = parcelRequire("dTE8j");

var $dOidW = parcelRequire("dOidW");
class $9121bf8ab1d2392d$export$af704488d7d0ffb8 {
    constructor(){
        /**
         * <zh/> 最近一次删除的 combo 的 id
         *
         * <en/> The ids of the last deleted combos
         * @remarks
         * <zh/> 当删除 combo 后，会将其 id 从 comboIds 中移除，此时根据 Graphlib 的 changes 事件获取到的 NodeRemoved 无法区分是 combo 还是 node。
         * 因此需要记录最近一次删除的 combo 的 id，并用于 isCombo 的判断
         *
         * <en/> When the combo is deleted, its id will be removed from comboIds. At this time, the NodeRemoved obtained according to the changes event of Graphlib cannot distinguish whether it is a combo or a node.
         * Therefore, it is necessary to record the id of the last deleted combo and use it to judge isCombo
         */ this.latestRemovedComboIds = new Set();
        this.comboIds = new Set();
        /**
         * <zh/> 获取详细数据变更
         *
         * <en/> Get detailed data changes
         */ this.changes = [];
        /**
         * <zh/> 批处理计数器
         *
         * <en/> Batch processing counter
         */ this.batchCount = 0;
        /**
         * <zh/> 是否处于无痕模式
         *
         * <en/> Whether it is in traceless mode
         */ this.isTraceless = false;
        this.enableUpdateNodeLikeHierarchy = true;
        this.model = new (0, $fc2XC.Graph)();
    }
    pushChange(change) {
        if (this.isTraceless) return;
        const { type: type } = change;
        if (type === (0, $cFz2C.ChangeType).NodeUpdated || type === (0, $cFz2C.ChangeType).EdgeUpdated || type === (0, $cFz2C.ChangeType).ComboUpdated) {
            const { value: value, original: original } = change;
            this.changes.push({
                value: (0, $b8Sbq.cloneElementData)(value),
                original: (0, $b8Sbq.cloneElementData)(original),
                type: type
            });
        } else this.changes.push({
            value: (0, $b8Sbq.cloneElementData)(change.value),
            type: type
        });
    }
    getChanges() {
        return this.changes;
    }
    clearChanges() {
        this.changes = [];
    }
    batch(callback) {
        this.batchCount++;
        this.model.batch(callback);
        this.batchCount--;
    }
    isBatching() {
        return this.batchCount > 0;
    }
    /**
     * <zh/> 执行操作而不会留下记录
     *
     * <en/> Perform operations without leaving records
     * @param callback - <zh/> 回调函数 | <en/> callback function
     * @remarks
     * <zh/> 通常用于运行时调整元素并同步数据，避免触发数据变更导致重绘
     *
     * <en/> Usually used to adjust elements at runtime and synchronize data to avoid triggering data changes and causing redraws
     */ silence(callback) {
        this.isTraceless = true;
        callback();
        this.isTraceless = false;
    }
    isCombo(id) {
        return this.comboIds.has(id) || this.latestRemovedComboIds.has(id);
    }
    getData() {
        return {
            nodes: this.getNodeData(),
            edges: this.getEdgeData(),
            combos: this.getComboData()
        };
    }
    getNodeData(ids) {
        return this.model.getAllNodes().reduce((acc, node)=>{
            const data = (0, $8awWK.toG6Data)(node);
            if (this.isCombo((0, $brtTw.idOf)(data))) return acc;
            if (ids === undefined) acc.push(data);
            else ids.includes((0, $brtTw.idOf)(data)) && acc.push(data);
            return acc;
        }, []);
    }
    getEdgeDatum(id) {
        return (0, $8awWK.toG6Data)(this.model.getEdge(id));
    }
    getEdgeData(ids) {
        return this.model.getAllEdges().reduce((acc, edge)=>{
            const data = (0, $8awWK.toG6Data)(edge);
            if (ids === undefined) acc.push(data);
            else ids.includes((0, $brtTw.idOf)(data)) && acc.push(data);
            return acc;
        }, []);
    }
    getComboData(ids) {
        return this.model.getAllNodes().reduce((acc, combo)=>{
            const data = (0, $8awWK.toG6Data)(combo);
            if (!this.isCombo((0, $brtTw.idOf)(data))) return acc;
            if (ids === undefined) acc.push(data);
            else ids.includes((0, $brtTw.idOf)(data)) && acc.push(data);
            return acc;
        }, []);
    }
    getRootsData(hierarchyKey = (0, $lDPR9.TREE_KEY)) {
        return this.model.getRoots(hierarchyKey).map((0, $8awWK.toG6Data));
    }
    getAncestorsData(id, hierarchyKey) {
        const { model: model } = this;
        if (!model.hasNode(id) || !model.hasTreeStructure(hierarchyKey)) return [];
        return model.getAncestors(id, hierarchyKey).map((0, $8awWK.toG6Data));
    }
    getDescendantsData(id) {
        const root = this.getElementDataById(id);
        const data = [];
        (0, $dTE8j.dfs)(root, (node)=>{
            if (node !== root) data.push(node);
        }, (node)=>this.getChildrenData((0, $brtTw.idOf)(node)), 'TB');
        return data;
    }
    getParentData(id, hierarchyKey) {
        const { model: model } = this;
        if (!hierarchyKey) {
            (0, $aBpmX.print).warn('The hierarchy structure key is not specified');
            return undefined;
        }
        if (!model.hasNode(id) || !model.hasTreeStructure(hierarchyKey)) return undefined;
        const parent = model.getParent(id, hierarchyKey);
        return parent ? (0, $8awWK.toG6Data)(parent) : undefined;
    }
    getChildrenData(id) {
        const structureKey = this.getElementType(id) === 'node' ? (0, $lDPR9.TREE_KEY) : (0, $lDPR9.COMBO_KEY);
        const { model: model } = this;
        if (!model.hasNode(id) || !model.hasTreeStructure(structureKey)) return [];
        return model.getChildren(id, structureKey).map((0, $8awWK.toG6Data));
    }
    /**
     * <zh/> 获取指定类型元素的数据
     *
     * <en/> Get the data of the specified type of element
     * @param elementType - <zh/> 元素类型 | <en/> element type
     * @returns <zh/> 元素数据 | <en/> element data
     */ getElementsDataByType(elementType) {
        if (elementType === 'node') return this.getNodeData();
        if (elementType === 'edge') return this.getEdgeData();
        if (elementType === 'combo') return this.getComboData();
        return [];
    }
    /**
     * <zh/> 根据 ID 获取元素的数据，不用关心元素的类型
     *
     * <en/> Get the data of the element by ID, no need to care about the type of the element
     * @param id - <zh/> 元素 ID 数组 | <en/> element ID array
     * @returns <zh/> 元素数据 | <en/> data of the element
     */ getElementDataById(id) {
        const type = this.getElementType(id);
        if (type === 'edge') return this.getEdgeDatum(id);
        return this.getNodeLikeDatum(id);
    }
    /**
     * <zh/> 获取节点的数据
     *
     * <en/> Get node data
     * @param id - <zh/> 节点 ID | <en/> node ID
     * @returns <zh/> 节点数据 | <en/> node data
     */ getNodeLikeDatum(id) {
        const data = this.model.getNode(id);
        return (0, $8awWK.toG6Data)(data);
    }
    /**
     * <zh/> 获取所有节点和 combo 的数据
     *
     * <en/> Get all node and combo data
     * @param ids - <zh/> 节点和 combo ID 数组 | <en/> node and combo ID array
     * @returns <zh/> 节点和 combo 的数据 | <en/> node and combo data
     */ getNodeLikeData(ids) {
        return this.model.getAllNodes().reduce((acc, node)=>{
            const data = (0, $8awWK.toG6Data)(node);
            if (ids) ids.includes((0, $brtTw.idOf)(data)) && acc.push(data);
            else acc.push(data);
            return acc;
        }, []);
    }
    getElementDataByState(elementType, state) {
        const elementData = this.getElementsDataByType(elementType);
        return elementData.filter((datum)=>{
            var _a;
            return (_a = datum.states) === null || _a === void 0 ? void 0 : _a.includes(state);
        });
    }
    getElementState(id) {
        var _a;
        return ((_a = this.getElementDataById(id)) === null || _a === void 0 ? void 0 : _a.states) || [];
    }
    hasNode(id) {
        return this.model.hasNode(id) && !this.isCombo(id);
    }
    hasEdge(id) {
        return this.model.hasEdge(id);
    }
    hasCombo(id) {
        return this.model.hasNode(id) && this.isCombo(id);
    }
    getRelatedEdgesData(id, direction = 'both') {
        return this.model.getRelatedEdges(id, direction).map((0, $8awWK.toG6Data));
    }
    getNeighborNodesData(id) {
        return this.model.getNeighbors(id).map((0, $8awWK.toG6Data));
    }
    setData(data) {
        const { nodes: modifiedNodes = [], edges: modifiedEdges = [], combos: modifiedCombos = [] } = data;
        const { nodes: originalNodes, edges: originalEdges, combos: originalCombos } = this.getData();
        const nodeDiff = (0, $6SQtU.arrayDiff)(originalNodes, modifiedNodes, (node)=>(0, $brtTw.idOf)(node), (0, $b8Sbq.isElementDataEqual));
        const edgeDiff = (0, $6SQtU.arrayDiff)(originalEdges, modifiedEdges, (edge)=>(0, $brtTw.idOf)(edge), (0, $b8Sbq.isElementDataEqual));
        const comboDiff = (0, $6SQtU.arrayDiff)(originalCombos, modifiedCombos, (combo)=>(0, $brtTw.idOf)(combo), (0, $b8Sbq.isElementDataEqual));
        this.batch(()=>{
            const dataToAdd = {
                nodes: nodeDiff.enter,
                edges: edgeDiff.enter,
                combos: comboDiff.enter
            };
            this.addData(dataToAdd);
            this.computeZIndex(dataToAdd, 'add', true);
            const dataToUpdate = {
                nodes: nodeDiff.update,
                edges: edgeDiff.update,
                combos: comboDiff.update
            };
            this.updateData(dataToUpdate);
            this.computeZIndex(dataToUpdate, 'update', true);
            const dataToRemove = {
                nodes: nodeDiff.exit.map((0, $brtTw.idOf)),
                edges: edgeDiff.exit.map((0, $brtTw.idOf)),
                combos: comboDiff.exit.map((0, $brtTw.idOf))
            };
            this.removeData(dataToRemove);
        });
    }
    addData(data) {
        const { nodes: nodes, edges: edges, combos: combos } = data;
        this.batch(()=>{
            // add combo first
            this.addComboData(combos);
            this.addNodeData(nodes);
            this.addEdgeData(edges);
        });
        this.computeZIndex(data, 'add');
    }
    addNodeData(nodes = []) {
        if (!nodes.length) return;
        this.model.addNodes(nodes.map((node)=>{
            this.pushChange({
                value: node,
                type: (0, $cFz2C.ChangeType).NodeAdded
            });
            return (0, $8awWK.toGraphlibData)(node);
        }));
        this.updateNodeLikeHierarchy(nodes);
        this.computeZIndex({
            nodes: nodes
        }, 'add');
    }
    addEdgeData(edges = []) {
        if (!edges.length) return;
        this.model.addEdges(edges.map((edge)=>{
            this.pushChange({
                value: edge,
                type: (0, $cFz2C.ChangeType).EdgeAdded
            });
            return (0, $8awWK.toGraphlibData)(edge);
        }));
        this.computeZIndex({
            edges: edges
        }, 'add');
    }
    addComboData(combos = []) {
        if (!combos.length) return;
        const { model: model } = this;
        if (!model.hasTreeStructure((0, $lDPR9.COMBO_KEY))) model.attachTreeStructure((0, $lDPR9.COMBO_KEY));
        model.addNodes(combos.map((combo)=>{
            this.comboIds.add((0, $brtTw.idOf)(combo));
            this.pushChange({
                value: combo,
                type: (0, $cFz2C.ChangeType).ComboAdded
            });
            return (0, $8awWK.toGraphlibData)(combo);
        }));
        this.updateNodeLikeHierarchy(combos);
        this.computeZIndex({
            combos: combos
        }, 'add');
    }
    addChildrenData(parentId, childrenData) {
        const parentData = this.getNodeLikeDatum(parentId);
        const childrenId = childrenData.map((0, $brtTw.idOf));
        this.addNodeData(childrenData);
        this.updateNodeData([
            {
                id: parentId,
                children: [
                    ...parentData.children || [],
                    ...childrenId
                ]
            }
        ]);
        this.addEdgeData(childrenId.map((childId)=>({
                source: parentId,
                target: childId
            })));
    }
    /**
     * <zh/> 计算 zIndex
     *
     * <en/> Calculate zIndex
     * @param data - <zh/> 新增的数据 | <en/> newly added data
     * @param type - <zh/> 操作类型 | <en/> operation type
     * @param force - <zh/> 忽略批处理 | <en/> ignore batch processing
     * @remarks
     * <zh/> 调用该函数的情况：
     * - 新增元素
     * - 更新节点/组合的 combo
     * - 更新节点的 children
     *
     * <en/> The situation of calling this function:
     * - Add element
     * - Update the combo of the node/combo
     * - Update the children of the node
     */ computeZIndex(data, type, force = false) {
        if (!force && this.isBatching()) return;
        this.batch(()=>{
            const { nodes: nodes = [], edges: edges = [], combos: combos = [] } = data;
            combos.forEach((combo)=>{
                var _a, _b, _c;
                const id = (0, $brtTw.idOf)(combo);
                if (type === 'add' && (0, $jyI49.default)((_a = combo.style) === null || _a === void 0 ? void 0 : _a.zIndex)) return;
                if (type === 'update' && !('combo' in combo)) return;
                const parent = this.getParentData(id, (0, $lDPR9.COMBO_KEY));
                const zIndex = parent ? ((_c = (_b = parent.style) === null || _b === void 0 ? void 0 : _b.zIndex) !== null && _c !== void 0 ? _c : 0) + 1 : 0;
                this.preventUpdateNodeLikeHierarchy(()=>{
                    this.updateComboData([
                        {
                            id: id,
                            style: {
                                zIndex: zIndex
                            }
                        }
                    ]);
                });
            });
            nodes.forEach((node)=>{
                var _a, _b, _c;
                const id = (0, $brtTw.idOf)(node);
                if (type === 'add' && (0, $jyI49.default)((_a = node.style) === null || _a === void 0 ? void 0 : _a.zIndex)) return;
                if (type === 'update' && !('combo' in node) && !('children' in node)) return;
                let zIndex = 0;
                const comboParent = this.getParentData(id, (0, $lDPR9.COMBO_KEY));
                if (comboParent) zIndex = (((_b = comboParent.style) === null || _b === void 0 ? void 0 : _b.zIndex) || 0) + 1;
                else {
                    const nodeParent = this.getParentData(id, (0, $lDPR9.TREE_KEY));
                    if (nodeParent) zIndex = ((_c = nodeParent === null || nodeParent === void 0 ? void 0 : nodeParent.style) === null || _c === void 0 ? void 0 : _c.zIndex) || 0;
                }
                this.preventUpdateNodeLikeHierarchy(()=>{
                    this.updateNodeData([
                        {
                            id: id,
                            style: {
                                zIndex: zIndex
                            }
                        }
                    ]);
                });
            });
            edges.forEach((edge)=>{
                var _a, _b, _c, _d, _e;
                if ((0, $jyI49.default)((_a = edge.style) === null || _a === void 0 ? void 0 : _a.zIndex)) return;
                let { id: id, source: source, target: target } = edge;
                if (!id) id = (0, $brtTw.idOf)(edge);
                else {
                    const datum = this.getEdgeDatum(id);
                    source = datum.source;
                    target = datum.target;
                }
                if (!source || !target) return;
                const sourceZIndex = ((_c = (_b = this.getNodeLikeDatum(source)) === null || _b === void 0 ? void 0 : _b.style) === null || _c === void 0 ? void 0 : _c.zIndex) || 0;
                const targetZIndex = ((_e = (_d = this.getNodeLikeDatum(target)) === null || _d === void 0 ? void 0 : _d.style) === null || _e === void 0 ? void 0 : _e.zIndex) || 0;
                this.updateEdgeData([
                    {
                        id: (0, $brtTw.idOf)(edge),
                        style: {
                            zIndex: Math.max(sourceZIndex, targetZIndex) - 1
                        }
                    }
                ]);
            });
        });
    }
    /**
     * <zh/> 计算元素置顶后的 zIndex
     *
     * <en/> Calculate the zIndex after the element is placed on top
     * @param id - <zh/> 元素 ID | <en/> ID of the element
     * @returns <zh/> zIndex | <en/> zIndex
     */ getFrontZIndex(id) {
        var _a;
        const elementType = this.getElementType(id);
        const elementData = this.getElementDataById(id);
        const data = this.getData();
        // 排除当前元素 / Exclude the current element
        Object.assign(data, {
            [`${elementType}s`]: data[`${elementType}s`].filter((element)=>(0, $brtTw.idOf)(element) !== id)
        });
        if (elementType === 'combo') // 如果 combo 展开，则排除 combo 的子节点/combo 及内部边
        // If the combo is expanded, exclude the child nodes/combos of the combo and the internal edges
        {
            if (!(0, $VNNBO.isCollapsed)(elementData)) {
                const ancestorIds = new Set(this.getAncestorsData(id, (0, $lDPR9.COMBO_KEY)).map((0, $brtTw.idOf)));
                data.nodes = data.nodes.filter((element)=>!ancestorIds.has((0, $brtTw.idOf)(element)));
                data.combos = data.combos.filter((element)=>!ancestorIds.has((0, $brtTw.idOf)(element)));
                data.edges = data.edges.filter(({ source: source, target: target })=>!ancestorIds.has(source) && !ancestorIds.has(target));
            }
        }
        return Math.max(((_a = elementData.style) === null || _a === void 0 ? void 0 : _a.zIndex) || 0, 0, ...Object.values(data).flat().map((datum)=>{
            var _a;
            return (((_a = datum === null || datum === void 0 ? void 0 : datum.style) === null || _a === void 0 ? void 0 : _a.zIndex) || 0) + 1;
        }));
    }
    updateNodeLikeHierarchy(data) {
        if (!this.enableUpdateNodeLikeHierarchy) return;
        const { model: model } = this;
        data.forEach((datum)=>{
            const id = (0, $brtTw.idOf)(datum);
            const parent = (0, $brtTw.parentIdOf)(datum);
            if (parent !== undefined) {
                if (!model.hasTreeStructure((0, $lDPR9.COMBO_KEY))) model.attachTreeStructure((0, $lDPR9.COMBO_KEY));
                // 解除原父节点的子节点关系，更新原父节点及其祖先的数据
                // Remove the child relationship of the original parent node, update the data of the original parent node and its ancestors
                if (parent === null) this.refreshComboData(id);
                this.setParent(id, (0, $brtTw.parentIdOf)(datum), (0, $lDPR9.COMBO_KEY));
            }
            const children = datum.children || [];
            if (children.length) {
                if (!model.hasTreeStructure((0, $lDPR9.TREE_KEY))) model.attachTreeStructure((0, $lDPR9.TREE_KEY));
                const _children = children.filter((child)=>model.hasNode(child));
                _children.forEach((child)=>this.setParent(child, id, (0, $lDPR9.TREE_KEY)));
                if (_children.length !== children.length) // 从数据中移除不存在的子节点
                // Remove non-existent child nodes from the data
                this.updateNodeData([
                    {
                        id: id,
                        children: _children
                    }
                ]);
            }
        });
    }
    /**
     * <zh/> 执行变更时不要更新节点层次结构
     *
     * <en/> Do not update the node hierarchy when executing changes
     * @param callback - <zh/> 变更函数 | <en/> change function
     */ preventUpdateNodeLikeHierarchy(callback) {
        this.enableUpdateNodeLikeHierarchy = false;
        callback();
        this.enableUpdateNodeLikeHierarchy = true;
    }
    updateData(data) {
        const { nodes: nodes, edges: edges, combos: combos } = data;
        this.batch(()=>{
            this.updateNodeData(nodes);
            this.updateComboData(combos);
            this.updateEdgeData(edges);
        });
        this.computeZIndex(data, 'update');
    }
    updateNodeData(nodes = []) {
        if (!nodes.length) return;
        const { model: model } = this;
        this.batch(()=>{
            const modifiedNodes = [];
            nodes.forEach((modifiedNode)=>{
                const id = (0, $brtTw.idOf)(modifiedNode);
                const originalNode = (0, $8awWK.toG6Data)(model.getNode(id));
                if ((0, $b8Sbq.isElementDataEqual)(originalNode, modifiedNode)) return;
                const value = (0, $b8Sbq.mergeElementsData)(originalNode, modifiedNode);
                this.pushChange({
                    value: value,
                    original: originalNode,
                    type: (0, $cFz2C.ChangeType).NodeUpdated
                });
                model.mergeNodeData(id, value);
                modifiedNodes.push(value);
            });
            this.updateNodeLikeHierarchy(modifiedNodes);
        });
        this.computeZIndex({
            nodes: nodes
        }, 'update');
    }
    /**
     * <zh/> 将所有数据提交到变更记录中以进行重绘
     *
     * <en/> Submit all data to the change record for redrawing
     */ refreshData() {
        const { nodes: nodes, edges: edges, combos: combos } = this.getData();
        nodes.forEach((node)=>{
            this.pushChange({
                value: node,
                original: node,
                type: (0, $cFz2C.ChangeType).NodeUpdated
            });
        });
        edges.forEach((edge)=>{
            this.pushChange({
                value: edge,
                original: edge,
                type: (0, $cFz2C.ChangeType).EdgeUpdated
            });
        });
        combos.forEach((combo)=>{
            this.pushChange({
                value: combo,
                original: combo,
                type: (0, $cFz2C.ChangeType).ComboUpdated
            });
        });
    }
    syncNodeLikeDatum(datum) {
        const { model: model } = this;
        const id = (0, $brtTw.idOf)(datum);
        if (!model.hasNode(id)) return;
        const original = (0, $8awWK.toG6Data)(model.getNode(id));
        const value = (0, $b8Sbq.mergeElementsData)(original, datum);
        model.mergeNodeData(id, value);
    }
    syncEdgeDatum(datum) {
        const { model: model } = this;
        const id = (0, $brtTw.idOf)(datum);
        if (!model.hasEdge(id)) return;
        const original = (0, $8awWK.toG6Data)(model.getEdge(id));
        const value = (0, $b8Sbq.mergeElementsData)(original, datum);
        model.mergeEdgeData(id, value);
    }
    updateEdgeData(edges = []) {
        if (!edges.length) return;
        const { model: model } = this;
        this.batch(()=>{
            edges.forEach((modifiedEdge)=>{
                const id = (0, $brtTw.idOf)(modifiedEdge);
                const originalEdge = (0, $8awWK.toG6Data)(model.getEdge(id));
                if ((0, $b8Sbq.isElementDataEqual)(originalEdge, modifiedEdge)) return;
                if (modifiedEdge.source && originalEdge.source !== modifiedEdge.source) model.updateEdgeSource(id, modifiedEdge.source);
                if (modifiedEdge.target && originalEdge.target !== modifiedEdge.target) model.updateEdgeTarget(id, modifiedEdge.target);
                const updatedData = (0, $b8Sbq.mergeElementsData)(originalEdge, modifiedEdge);
                this.pushChange({
                    value: updatedData,
                    original: originalEdge,
                    type: (0, $cFz2C.ChangeType).EdgeUpdated
                });
                model.mergeEdgeData(id, updatedData);
            });
        });
        this.computeZIndex({
            edges: edges
        }, 'update');
    }
    updateComboData(combos = []) {
        if (!combos.length) return;
        const { model: model } = this;
        model.batch(()=>{
            const modifiedCombos = [];
            combos.forEach((modifiedCombo)=>{
                const id = (0, $brtTw.idOf)(modifiedCombo);
                const originalCombo = (0, $8awWK.toG6Data)(model.getNode(id));
                if ((0, $b8Sbq.isElementDataEqual)(originalCombo, modifiedCombo)) return;
                const value = (0, $b8Sbq.mergeElementsData)(originalCombo, modifiedCombo);
                this.pushChange({
                    value: value,
                    original: originalCombo,
                    type: (0, $cFz2C.ChangeType).ComboUpdated
                });
                model.mergeNodeData(id, value);
                modifiedCombos.push(value);
            });
            this.updateNodeLikeHierarchy(modifiedCombos);
        });
        this.computeZIndex({
            combos: combos
        }, 'update');
    }
    /**
     * <zh/> 设置节点的父节点
     *
     * <en/> Set the parent node of the node
     * @param id - <zh/> 节点 ID | <en/> node ID
     * @param parent - <zh/> 父节点 ID | <en/> parent node ID
     * @param hierarchyKey - <zh/> 层次结构类型 | <en/> hierarchy type
     * @param update - <zh/> 添加新/旧父节点数据更新记录 | <en/> add new/old parent node data update record
     */ setParent(id, parent, hierarchyKey, update = true) {
        if (id === parent) return;
        const elementData = this.getNodeLikeDatum(id);
        const originalParentId = (0, $brtTw.parentIdOf)(elementData);
        if (originalParentId !== parent && hierarchyKey === (0, $lDPR9.COMBO_KEY)) {
            const modifiedDatum = {
                id: id,
                combo: parent
            };
            if (this.isCombo(id)) this.syncNodeLikeDatum(modifiedDatum);
            else this.syncNodeLikeDatum(modifiedDatum);
        }
        this.model.setParent(id, parent, hierarchyKey);
        if (update && hierarchyKey === (0, $lDPR9.COMBO_KEY)) (0, $3cpV4.default)([
            originalParentId,
            parent
        ]).forEach((pId)=>{
            if (pId !== undefined) this.refreshComboData(pId);
        });
    }
    /**
     * <zh/> 刷新 combo 数据
     *
     * <en/> Refresh combo data
     * @param id - <zh/> combo ID | <en/> combo ID
     * @remarks
     * <zh/> 不会更改数据，但会触发数据变更事件
     *
     * <en/> Will not change the data, but will trigger data change events
     */ refreshComboData(id) {
        const combo = this.getComboData([
            id
        ])[0];
        const ancestors = this.getAncestorsData(id, (0, $lDPR9.COMBO_KEY));
        if (combo) this.pushChange({
            value: combo,
            original: combo,
            type: (0, $cFz2C.ChangeType).ComboUpdated
        });
        ancestors.forEach((value)=>{
            this.pushChange({
                value: value,
                original: value,
                type: (0, $cFz2C.ChangeType).ComboUpdated
            });
        });
    }
    getElementPosition(id) {
        const datum = this.getElementDataById(id);
        return (0, $46bcR.positionOf)(datum);
    }
    translateNodeLikeBy(id, offset) {
        if (this.isCombo(id)) this.translateComboBy(id, offset);
        else this.translateNodeBy(id, offset);
    }
    translateNodeLikeTo(id, position) {
        if (this.isCombo(id)) this.translateComboTo(id, position);
        else this.translateNodeTo(id, position);
    }
    translateNodeBy(id, offset) {
        const curr = this.getElementPosition(id);
        const position = (0, $dOidW.add)(curr, [
            ...offset,
            0
        ].slice(0, 3));
        this.translateNodeTo(id, position);
    }
    translateNodeTo(id, position) {
        const [x = 0, y = 0, z = 0] = position;
        this.preventUpdateNodeLikeHierarchy(()=>{
            this.updateNodeData([
                {
                    id: id,
                    style: {
                        x: x,
                        y: y,
                        z: z
                    }
                }
            ]);
        });
    }
    translateComboBy(id, offset) {
        const [dx = 0, dy = 0, dz = 0] = offset;
        if ([
            dx,
            dy,
            dz
        ].some(isNaN) || [
            dx,
            dy,
            dz
        ].every((o)=>o === 0)) return;
        const combo = this.getComboData([
            id
        ])[0];
        if (!combo) return;
        const seenNodeLikeIds = new Set();
        (0, $dTE8j.dfs)(combo, (succeed)=>{
            const succeedID = (0, $brtTw.idOf)(succeed);
            if (seenNodeLikeIds.has(succeedID)) return;
            seenNodeLikeIds.add(succeedID);
            const [x, y, z] = (0, $46bcR.positionOf)(succeed);
            const value = (0, $b8Sbq.mergeElementsData)(succeed, {
                style: {
                    x: x + dx,
                    y: y + dy,
                    z: z + dz
                }
            });
            this.pushChange({
                value: value,
                // @ts-ignore
                original: succeed,
                type: this.isCombo(succeedID) ? (0, $cFz2C.ChangeType).ComboUpdated : (0, $cFz2C.ChangeType).NodeUpdated
            });
            this.model.mergeNodeData(succeedID, value);
        }, (node)=>this.getChildrenData((0, $brtTw.idOf)(node)), 'BT');
    }
    translateComboTo(id, position) {
        var _a;
        if (position.some(isNaN)) return;
        const [tx = 0, ty = 0, tz = 0] = position;
        const combo = (_a = this.getComboData([
            id
        ])) === null || _a === void 0 ? void 0 : _a[0];
        if (!combo) return;
        const [comboX, comboY, comboZ] = (0, $46bcR.positionOf)(combo);
        const dx = tx - comboX;
        const dy = ty - comboY;
        const dz = tz - comboZ;
        (0, $dTE8j.dfs)(combo, (succeed)=>{
            const succeedId = (0, $brtTw.idOf)(succeed);
            const [x, y, z] = (0, $46bcR.positionOf)(succeed);
            const value = (0, $b8Sbq.mergeElementsData)(succeed, {
                style: {
                    x: x + dx,
                    y: y + dy,
                    z: z + dz
                }
            });
            this.pushChange({
                value: value,
                // @ts-ignore
                original: succeed,
                type: this.isCombo(succeedId) ? (0, $cFz2C.ChangeType).ComboUpdated : (0, $cFz2C.ChangeType).NodeUpdated
            });
            this.model.mergeNodeData(succeedId, value);
        }, (node)=>this.getChildrenData((0, $brtTw.idOf)(node)), 'BT');
    }
    removeData(data) {
        const { nodes: nodes, edges: edges, combos: combos } = data;
        this.batch(()=>{
            // remove edges first
            this.removeEdgeData(edges);
            this.removeNodeData(nodes);
            this.removeComboData(combos);
            this.latestRemovedComboIds = new Set(combos);
        });
    }
    removeNodeData(ids = []) {
        if (!ids.length) return;
        this.batch(()=>{
            ids.forEach((id)=>{
                // 移除关联边、子节点
                // remove related edges and child nodes
                this.removeEdgeData(this.getRelatedEdgesData(id).map((0, $brtTw.idOf)));
                // TODO 树图情况下移除子节点
                this.pushChange({
                    value: this.getNodeData([
                        id
                    ])[0],
                    type: (0, $cFz2C.ChangeType).NodeRemoved
                });
                this.removeNodeLikeHierarchy(id);
            });
            this.model.removeNodes(ids);
        });
    }
    removeEdgeData(ids = []) {
        if (!ids.length) return;
        ids.forEach((id)=>this.pushChange({
                value: this.getEdgeData([
                    id
                ])[0],
                type: (0, $cFz2C.ChangeType).EdgeRemoved
            }));
        this.model.removeEdges(ids);
    }
    removeComboData(ids = []) {
        if (!ids.length) return;
        this.batch(()=>{
            ids.forEach((id)=>{
                this.pushChange({
                    value: this.getComboData([
                        id
                    ])[0],
                    type: (0, $cFz2C.ChangeType).ComboRemoved
                });
                this.removeNodeLikeHierarchy(id);
                this.comboIds.delete(id);
            });
            this.model.removeNodes(ids);
        });
    }
    /**
     * <zh/> 移除节点层次结构，将其子节点移动到父节点的 children 列表中
     *
     * <en/> Remove the node hierarchy and move its child nodes to the parent node's children list
     * @param id - <zh/> 待处理的节点 | <en/> node to be processed
     */ removeNodeLikeHierarchy(id) {
        if (this.model.hasTreeStructure((0, $lDPR9.COMBO_KEY))) {
            const grandParent = (0, $brtTw.parentIdOf)(this.getNodeLikeDatum(id));
            // 从父节点的 children 列表中移除
            // remove from its parent's children list
            // 调用 graphlib.setParent，不需要更新数据
            this.setParent(id, undefined, (0, $lDPR9.COMBO_KEY), false);
            // 将子节点移动到父节点的 children 列表中
            // move the children to the grandparent's children list
            this.model.getChildren(id, (0, $lDPR9.COMBO_KEY)).forEach((child)=>{
                const childData = (0, $8awWK.toG6Data)(child);
                const childId = (0, $brtTw.idOf)(childData);
                this.setParent((0, $brtTw.idOf)(childData), grandParent, (0, $lDPR9.COMBO_KEY), false);
                const value = (0, $b8Sbq.mergeElementsData)(childData, {
                    id: (0, $brtTw.idOf)(childData),
                    combo: grandParent
                });
                this.pushChange({
                    value: value,
                    original: childData,
                    type: this.isCombo(childId) ? (0, $cFz2C.ChangeType).ComboUpdated : (0, $cFz2C.ChangeType).NodeUpdated
                });
                this.model.mergeNodeData((0, $brtTw.idOf)(childData), value);
            });
            if (!(0, $geZBG.default)(grandParent)) this.refreshComboData(grandParent);
        }
    }
    /**
     * <zh/> 获取元素的类型
     *
     * <en/> Get the type of the element
     * @param id - <zh/> 元素 ID | <en/> ID of the element
     * @returns <zh/> 元素类型 | <en/> type of the element
     */ getElementType(id) {
        if (this.model.hasNode(id)) {
            if (this.isCombo(id)) return 'combo';
            return 'node';
        }
        if (this.model.hasEdge(id)) return 'edge';
        throw new Error((0, $aBpmX.format)(`Unknown element type of id: ${id}`));
    }
    destroy() {
        const { model: model } = this;
        const nodes = model.getAllNodes();
        const edges = model.getAllEdges();
        model.removeEdges(edges.map((edge)=>edge.id));
        model.removeNodes(nodes.map((node)=>node.id));
        // @ts-expect-error force delete
        this.context = {};
    }
}

});
parcelRegister("3cpV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2546992c8f372855$export$2e2bcd8739ae039);
function $2546992c8f372855$export$2e2bcd8739ae039(arr, cache) {
    if (cache === void 0) cache = new Map();
    var r = [];
    if (Array.isArray(arr)) for(var i = 0, len = arr.length; i < len; i++){
        var item = arr[i];
        // 加一个 cache，提升性能
        if (!cache.has(item)) {
            r.push(item);
            cache.set(item, true);
        }
    }
    return r;
}

});

parcelRegister("8awWK", function(module, exports) {

$parcel$export(module.exports, "toGraphlibData", () => $5f28d06c721c9272$export$bcc8996157ab2d44);
$parcel$export(module.exports, "toG6Data", () => $5f28d06c721c9272$export$b8eff479410ded55);
$parcel$export(module.exports, "createTreeStructure", () => $5f28d06c721c9272$export$8b5836a30f74a453);
parcelRequire("ahJ7k");
var $lDPR9 = parcelRequire("lDPR9");

var $brtTw = parcelRequire("brtTw");

var $lEe0S = parcelRequire("lEe0S");
var $5f28d06c721c9272$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $5f28d06c721c9272$export$bcc8996157ab2d44(data) {
    const { id: id = (0, $brtTw.idOf)(data), style: style, data: customData } = data, rest = $5f28d06c721c9272$var$__rest(data, [
        "id",
        "style",
        "data"
    ]);
    const _data = Object.assign(Object.assign({}, data), {
        style: Object.assign({}, style),
        data: Object.assign({}, customData)
    });
    if ((0, $lEe0S.isEdgeData)(data)) return Object.assign({
        id: id,
        data: _data
    }, rest);
    return {
        id: id,
        data: _data
    };
}
function $5f28d06c721c9272$export$b8eff479410ded55(data) {
    return data.data;
}
function $5f28d06c721c9272$export$8b5836a30f74a453(model) {
    if (model.hasTreeStructure((0, $lDPR9.TREE_KEY))) return;
    model.attachTreeStructure((0, $lDPR9.TREE_KEY));
    const edges = model.getAllEdges();
    for (const edge of edges){
        const { source: source, target: target } = edge;
        model.setParent(target, source, (0, $lDPR9.TREE_KEY));
    }
}

});


parcelRegister("3IeB3", function(module, exports) {

$parcel$export(module.exports, "ElementController", () => $2b40cdbd7fbf8140$export$c72c0f72b4b26c7e);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $gYaPK = parcelRequire("gYaPK");
parcelRequire("ahJ7k");
var $cFuSs = parcelRequire("cFuSs");
var $lDPR9 = parcelRequire("lDPR9");
var $4EzN9 = parcelRequire("4EzN9");

var $hXCXB = parcelRequire("hXCXB");

var $hW6vf = parcelRequire("hW6vf");

var $730pp = parcelRequire("730pp");

var $gO13V = parcelRequire("gO13V");

var $VNNBO = parcelRequire("VNNBO");

var $b8Sbq = parcelRequire("b8Sbq");

var $hn4z6 = parcelRequire("hn4z6");
parcelRequire("3hhcj");
var $8Fqus = parcelRequire("8Fqus");
var $3hhcj = parcelRequire("3hhcj");

var $brtTw = parcelRequire("brtTw");

var $cHWaM = parcelRequire("cHWaM");

var $46bcR = parcelRequire("46bcR");

var $aBpmX = parcelRequire("aBpmX");

var $j4n8g = parcelRequire("j4n8g");

var $3SjwL = parcelRequire("3SjwL");

var $dOidW = parcelRequire("dOidW");

var $kzdag = parcelRequire("kzdag");
var $2b40cdbd7fbf8140$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $2b40cdbd7fbf8140$export$c72c0f72b4b26c7e {
    constructor(context){
        this.elementMap = {};
        this.shapeTypeMap = {};
        this.paletteStyle = {};
        this.defaultStyle = {};
        this.stateStyle = {};
        this.visibilityCache = new WeakMap();
        this.context = context;
    }
    init() {
        this.initContainer();
    }
    initContainer() {
        if (!this.container || this.container.destroyed) {
            const { canvas: canvas } = this.context;
            this.container = canvas.appendChild(new (0, $2eDEB.Group)({
                className: 'elements'
            }));
        }
    }
    emit(event, context) {
        if (context.silence) return;
        (0, $3hhcj.emit)(this.context.graph, event);
    }
    forEachElementData(callback) {
        (0, $hXCXB.ELEMENT_TYPES).forEach((elementType)=>{
            const elementData = this.context.model.getElementsDataByType(elementType);
            callback(elementType, elementData);
        });
    }
    getElementType(elementType, datum) {
        var _a;
        const { options: options, graph: graph } = this.context;
        const userDefinedType = (0, $b8Sbq.isOverridable)(datum) ? ((_a = options[elementType]) === null || _a === void 0 ? void 0 : _a.type) || datum.type : datum.type;
        if (!userDefinedType) {
            if (elementType === 'edge') return 'line';
            else return 'circle';
        }
        if (typeof userDefinedType === 'string') return userDefinedType;
        // @ts-expect-error skip type check
        return userDefinedType.call(graph, datum);
    }
    getTheme(elementType) {
        return (0, $3SjwL.themeOf)(this.context.options)[elementType] || {};
    }
    getThemeStyle(elementType) {
        return this.getTheme(elementType).style || {};
    }
    getThemeStateStyle(elementType, states) {
        const { state: state = {} } = this.getTheme(elementType);
        return Object.assign({}, ...states.map((name)=>state[name] || {}));
    }
    computePaletteStyle() {
        const { options: options } = this.context;
        this.paletteStyle = {};
        this.forEachElementData((elementType, elementData)=>{
            var _a, _b;
            const palette = Object.assign({}, (0, $cHWaM.parsePalette)((_a = this.getTheme(elementType)) === null || _a === void 0 ? void 0 : _a.palette), (0, $cHWaM.parsePalette)((_b = options[elementType]) === null || _b === void 0 ? void 0 : _b.palette));
            if (palette === null || palette === void 0 ? void 0 : palette.field) Object.assign(this.paletteStyle, (0, $cHWaM.assignColorByPalette)(elementData, palette));
        });
    }
    getPaletteStyle(elementType, id) {
        const color = this.paletteStyle[id];
        if (!color) return {};
        if (elementType === 'edge') return {
            stroke: color
        };
        return {
            fill: color
        };
    }
    /**
     * <zh/> 计算单个元素的默认样式
     *
     * <en/> compute default style of single element
     */ computeElementDefaultStyle(elementType, context) {
        var _a;
        const { options: options } = this.context;
        const defaultStyle = ((_a = options[elementType]) === null || _a === void 0 ? void 0 : _a.style) || {};
        if ('transform' in defaultStyle && Array.isArray(defaultStyle.transform)) defaultStyle.transform = [
            ...defaultStyle.transform
        ];
        this.defaultStyle[(0, $brtTw.idOf)(context.datum)] = (0, $j4n8g.computeElementCallbackStyle)(defaultStyle, context);
    }
    computeElementsDefaultStyle(ids) {
        const { graph: graph } = this.context;
        this.forEachElementData((elementType, elementData)=>{
            const length = elementData.length;
            for(let i = 0; i < length; i++){
                const datum = elementData[i];
                if (ids === undefined || ids.includes((0, $brtTw.idOf)(datum))) this.computeElementDefaultStyle(elementType, {
                    datum: datum,
                    graph: graph
                });
            }
        });
    }
    getDefaultStyle(id) {
        return this.defaultStyle[id] || {};
    }
    getElementState(id) {
        try {
            const { model: model } = this.context;
            return model.getElementState(id);
        } catch (_a) {
            return [];
        }
    }
    /**
     * <zh/> 获取单个元素的单个状态的样式
     *
     * <en/> get single state style of single element
     */ getElementStateStyle(elementType, state, context) {
        var _a, _b;
        const { options: options } = this.context;
        const stateStyle = ((_b = (_a = options[elementType]) === null || _a === void 0 ? void 0 : _a.state) === null || _b === void 0 ? void 0 : _b[state]) || {};
        return (0, $j4n8g.computeElementCallbackStyle)(stateStyle, context);
    }
    /**
     * <zh/> 计算单个元素的合并状态样式
     *
     * <en/> compute merged state style of single element
     */ computeElementStatesStyle(elementType, states, context) {
        this.stateStyle[(0, $brtTw.idOf)(context.datum)] = Object.assign({}, ...states.map((state)=>this.getElementStateStyle(elementType, state, context)));
    }
    /**
     * <zh/> 计算全部元素的状态样式
     *
     * <en/> compute state style of all elements
     * @param ids - <zh/> 计算指定元素的状态样式 | <en/> compute state style of specified elements
     */ computeElementsStatesStyle(ids) {
        const { graph: graph } = this.context;
        this.forEachElementData((elementType, elementData)=>{
            const length = elementData.length;
            for(let i = 0; i < length; i++){
                const datum = elementData[i];
                if (ids === undefined || ids.includes((0, $brtTw.idOf)(datum))) {
                    const states = this.getElementState((0, $brtTw.idOf)(datum));
                    this.computeElementStatesStyle(elementType, states, {
                        datum: datum,
                        graph: graph
                    });
                }
            }
        });
    }
    getStateStyle(id) {
        return this.stateStyle[id] || {};
    }
    computeStyle(stage, ids) {
        const skip = [
            'translate',
            'zIndex'
        ];
        if (stage && skip.includes(stage)) return;
        this.computePaletteStyle();
        this.computeElementsDefaultStyle(ids);
        this.computeElementsStatesStyle(ids);
    }
    getElement(id) {
        return this.elementMap[id];
    }
    getNodes() {
        return this.context.model.getNodeData().map(({ id: id })=>this.elementMap[id]);
    }
    getEdges() {
        return this.context.model.getEdgeData().map((edge)=>this.elementMap[(0, $brtTw.idOf)(edge)]);
    }
    getCombos() {
        return this.context.model.getComboData().map(({ id: id })=>this.elementMap[id]);
    }
    getElementComputedStyle(elementType, datum) {
        const id = (0, $brtTw.idOf)(datum);
        // 优先级(从低到高) Priority (from low to high):
        const themeStyle = this.getThemeStyle(elementType);
        const paletteStyle = this.getPaletteStyle(elementType, id);
        const dataStyle = datum.style || {};
        const defaultStyle = this.getDefaultStyle(id);
        const themeStateStyle = this.getThemeStateStyle(elementType, this.getElementState(id));
        const stateStyle = this.getStateStyle(id);
        const style = (0, $b8Sbq.isOverridable)(datum) ? Object.assign({}, themeStyle, paletteStyle, dataStyle, defaultStyle, themeStateStyle, stateStyle) : Object.assign({}, dataStyle);
        if (elementType === 'combo') {
            const childrenData = this.context.model.getChildrenData(id);
            const isCollapsed = !!style.collapsed;
            const childrenNode = isCollapsed ? [] : childrenData.map((0, $brtTw.idOf)).filter((id)=>this.getElement(id));
            Object.assign(style, {
                childrenNode: childrenNode,
                childrenData: childrenData
            });
        }
        return style;
    }
    getDrawData(context) {
        this.init();
        const data = this.computeChangesAndDrawData(context);
        if (!data) return null;
        const { type: type = 'draw', stage: stage = type } = context;
        this.markDestroyElement(data.drawData);
        // 计算样式 / Calculate style
        this.computeStyle(stage);
        return {
            type: type,
            stage: stage,
            data: data
        };
    }
    /**
     * <zh/> 开始绘制流程
     *
     * <en/> start render process
     */ draw(context = {
        animation: true
    }) {
        const drawData = this.getDrawData(context);
        if (!drawData) return;
        const { data: { drawData: { add: add, update: update, remove: remove } } } = drawData;
        this.destroyElements(remove, context);
        this.createElements(add, context);
        this.updateElements(update, context);
        return this.setAnimationTask(context, drawData);
    }
    preLayoutDraw() {
        return $2b40cdbd7fbf8140$var$__awaiter(this, arguments, void 0, function*(context = {
            animation: true
        }) {
            var _a, _b;
            const preResult = this.getDrawData(context);
            if (!preResult) return;
            const { data: { drawData: drawData } } = preResult;
            yield (_b = (_a = this.context.layout) === null || _a === void 0 ? void 0 : _a.preLayout) === null || _b === void 0 ? void 0 : _b.call(_a, drawData);
            const { add: add, update: update, remove: remove } = drawData;
            this.destroyElements(remove, context);
            this.createElements(add, context);
            this.updateElements(update, context);
            return this.setAnimationTask(context, preResult);
        });
    }
    setAnimationTask(context, data) {
        const { animation: animation, silence: silence } = context;
        const { data: { dataChanges: dataChanges, drawData: drawData }, stage: stage, type: type } = data;
        return this.context.animation.animate(animation, silence ? {} : {
            before: ()=>this.emit(new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_DRAW, {
                    dataChanges: dataChanges,
                    animation: animation,
                    stage: stage,
                    render: type === 'render'
                }), context),
            beforeAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).BEFORE_ANIMATE, (0, $cFuSs.AnimationType).DRAW, animation, drawData), context),
            afterAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).AFTER_ANIMATE, (0, $cFuSs.AnimationType).DRAW, animation, drawData), context),
            after: ()=>this.emit(new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_DRAW, {
                    dataChanges: dataChanges,
                    animation: animation,
                    stage: stage,
                    render: type === 'render',
                    firstRender: this.context.graph.rendered === false
                }), context)
        });
    }
    computeChangesAndDrawData(context) {
        const { model: model } = this.context;
        const dataChanges = model.getChanges();
        const tasks = (0, $gO13V.reduceDataChanges)(dataChanges);
        if (tasks.length === 0) return null;
        const { NodeAdded: NodeAdded = [], NodeUpdated: NodeUpdated = [], NodeRemoved: NodeRemoved = [], EdgeAdded: EdgeAdded = [], EdgeUpdated: EdgeUpdated = [], EdgeRemoved: EdgeRemoved = [], ComboAdded: ComboAdded = [], ComboUpdated: ComboUpdated = [], ComboRemoved: ComboRemoved = [] } = (0, $gYaPK.default)(tasks, (change)=>change.type);
        const moveToAddedIfUnrendered = (updated, added)=>{
            const keptUpdates = [];
            updated.forEach((change)=>{
                const id = (0, $brtTw.idOf)(change.value);
                if (!this.getElement(id)) added.push(change);
                else keptUpdates.push(change);
            });
            return keptUpdates;
        };
        const finalNodeUpdated = moveToAddedIfUnrendered(NodeUpdated, NodeAdded);
        const finalEdgeUpdated = moveToAddedIfUnrendered(EdgeUpdated, EdgeAdded);
        const finalComboUpdated = moveToAddedIfUnrendered(ComboUpdated, ComboAdded);
        const dataOf = (data)=>new Map(data.map((datum)=>{
                const data = datum.value;
                return [
                    (0, $brtTw.idOf)(data),
                    data
                ];
            }));
        const input = {
            add: {
                nodes: dataOf(NodeAdded),
                edges: dataOf(EdgeAdded),
                combos: dataOf(ComboAdded)
            },
            update: {
                nodes: dataOf(finalNodeUpdated),
                edges: dataOf(finalEdgeUpdated),
                combos: dataOf(finalComboUpdated)
            },
            remove: {
                nodes: dataOf(NodeRemoved),
                edges: dataOf(EdgeRemoved),
                combos: dataOf(ComboRemoved)
            }
        };
        const drawData = this.transformData(input, context);
        // 清空变更 / Clear changes
        model.clearChanges();
        return {
            dataChanges: dataChanges,
            drawData: drawData
        };
    }
    transformData(input, context) {
        const transforms = this.context.transform.getTransformInstance();
        return Object.values(transforms).reduce((data, transform)=>transform.beforeDraw(data, context), input);
    }
    createElement(elementType, datum, context) {
        var _a;
        const id = (0, $brtTw.idOf)(datum);
        const currentElement = this.getElement(id);
        if (currentElement) return;
        const type = this.getElementType(elementType, datum);
        const style = this.getElementComputedStyle(elementType, datum);
        // get shape constructor
        const Ctor = (0, $hW6vf.getExtension)(elementType, type);
        if (!Ctor) return (0, $aBpmX.print).warn(`The element ${type} of ${elementType} is not registered.`);
        this.emit(new (0, $8Fqus.ElementLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_ELEMENT_CREATE, elementType, datum), context);
        const element = this.container.appendChild(new Ctor({
            id: id,
            context: this.context,
            style: style
        }));
        this.shapeTypeMap[id] = type;
        this.elementMap[id] = element;
        const { stage: stage = 'enter' } = context;
        (_a = this.context.animation) === null || _a === void 0 || _a.add({
            element: element,
            elementType: elementType,
            stage: stage,
            originalStyle: Object.assign({}, element.attributes),
            updatedStyle: style
        }, {
            after: ()=>{
                var _a;
                this.emit(new (0, $8Fqus.ElementLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_ELEMENT_CREATE, elementType, datum), context);
                (_a = element.onCreate) === null || _a === void 0 || _a.call(element);
            }
        });
    }
    createElements(data, context) {
        const { nodes: nodes, edges: edges, combos: combos } = data;
        const iteration = [
            [
                'node',
                nodes
            ],
            [
                'combo',
                combos
            ],
            [
                'edge',
                edges
            ]
        ];
        iteration.forEach(([elementType, elementData])=>{
            elementData.forEach((datum)=>this.createElement(elementType, datum, context));
        });
    }
    getUpdateStageStyle(elementType, datum, context) {
        const { stage: stage = 'update' } = context;
        // 优化 translate 阶段，直接返回 x, y, z，避免计算样式
        // Optimize the translate stage, return x, y, z directly to avoid calculating style
        if (stage === 'translate') {
            if (elementType === 'node' || elementType === 'combo') {
                const { style: { x: x = 0, y: y = 0, z: z = 0 } = {} } = datum;
                return {
                    x: x,
                    y: y,
                    z: z
                };
            } else return {};
        }
        return this.getElementComputedStyle(elementType, datum);
    }
    updateElement(elementType, datum, context) {
        var _a;
        const id = (0, $brtTw.idOf)(datum);
        const { stage: stage = 'update' } = context;
        const element = this.getElement(id);
        if (!element) return ()=>null;
        this.emit(new (0, $8Fqus.ElementLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_ELEMENT_UPDATE, elementType, datum), context);
        const type = this.getElementType(elementType, datum);
        const style = this.getUpdateStageStyle(elementType, datum, context);
        // 如果类型不同，需要先销毁原有元素，再创建新元素
        // If the type is different, you need to destroy the original element first, and then create a new element
        if (this.shapeTypeMap[id] !== type) {
            element.destroy();
            delete this.shapeTypeMap[id];
            delete this.elementMap[id];
            this.createElement(elementType, datum, {
                animation: false,
                silence: true
            });
        }
        const exactStage = stage !== 'visibility' ? stage : style.visibility === 'hidden' ? 'hide' : 'show';
        // 避免立即将 visibility 设置为 hidden，导致元素不可见，而是在 after 阶段再设置
        // Avoid setting visibility to hidden immediately, causing the element to be invisible, but set it in the after phase
        if (exactStage === 'hide') delete style['visibility'];
        (_a = this.context.animation) === null || _a === void 0 || _a.add({
            element: element,
            elementType: elementType,
            stage: exactStage,
            originalStyle: Object.assign({}, element.attributes),
            updatedStyle: style
        }, {
            before: ()=>{
                // 通过 elementMap[id] 访问最新的 element，防止 type 不同导致的 element 丢失
                // Access the latest element through elementMap[id] to prevent the loss of element caused by different types
                const element = this.elementMap[id];
                if (stage !== 'collapse') (0, $hn4z6.updateStyle)(element, style);
                if (stage === 'visibility') {
                    // 缓存原始透明度 / Cache original opacity
                    // 会在 animation controller 中访问该缓存值 / The cached value will be accessed in the animation controller
                    if (!(0, $730pp.hasCachedStyle)(element, 'opacity')) (0, $730pp.cacheStyle)(element, 'opacity');
                    this.visibilityCache.set(element, exactStage === 'show' ? 'visible' : 'hidden');
                    if (exactStage === 'show') (0, $kzdag.setVisibility)(element, 'visible');
                }
            },
            after: ()=>{
                var _a;
                const element = this.elementMap[id];
                if (stage === 'collapse') (0, $hn4z6.updateStyle)(element, style);
                if (exactStage === 'hide') (0, $kzdag.setVisibility)(element, this.visibilityCache.get(element));
                this.emit(new (0, $8Fqus.ElementLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_ELEMENT_UPDATE, elementType, datum), context);
                (_a = element.onUpdate) === null || _a === void 0 || _a.call(element);
            }
        });
    }
    updateElements(data, context) {
        const { nodes: nodes, edges: edges, combos: combos } = data;
        const iteration = [
            [
                'node',
                nodes
            ],
            [
                'combo',
                combos
            ],
            [
                'edge',
                edges
            ]
        ];
        iteration.forEach(([elementType, elementData])=>{
            elementData.forEach((datum)=>this.updateElement(elementType, datum, context));
        });
    }
    /**
     * <zh/> 标记销毁元素
     *
     * <en/> mark destroy element
     * @param data - <zh/> 绘制数据 | <en/> draw data
     */ markDestroyElement(data) {
        Object.values(data.remove).forEach((elementData)=>{
            elementData.forEach((datum)=>{
                const id = (0, $brtTw.idOf)(datum);
                const element = this.getElement(id);
                if (element) (0, $hn4z6.markToBeDestroyed)(element);
            });
        });
    }
    destroyElement(elementType, datum, context) {
        var _a;
        const { stage: stage = 'exit' } = context;
        const id = (0, $brtTw.idOf)(datum);
        const element = this.elementMap[id];
        if (!element) return ()=>null;
        this.emit(new (0, $8Fqus.ElementLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_ELEMENT_DESTROY, elementType, datum), context);
        (_a = this.context.animation) === null || _a === void 0 || _a.add({
            element: element,
            elementType: elementType,
            stage: stage,
            originalStyle: Object.assign({}, element.attributes),
            updatedStyle: {}
        }, {
            after: ()=>{
                var _a;
                this.clearElement(id);
                element.destroy();
                (_a = element.onDestroy) === null || _a === void 0 || _a.call(element);
                this.emit(new (0, $8Fqus.ElementLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_ELEMENT_DESTROY, elementType, datum), context);
            }
        });
    }
    destroyElements(data, context) {
        const { nodes: nodes, edges: edges, combos: combos } = data;
        const iteration = [
            [
                'combo',
                combos
            ],
            [
                'edge',
                edges
            ],
            [
                'node',
                nodes
            ]
        ];
        iteration.forEach(([elementType, elementData])=>{
            elementData.forEach((datum)=>this.destroyElement(elementType, datum, context));
        });
    // TODO 重新计算色板样式，如果是分组色板，则不需要重新计算
    }
    clearElement(id) {
        delete this.paletteStyle[id];
        delete this.defaultStyle[id];
        delete this.stateStyle[id];
        delete this.elementMap[id];
        delete this.shapeTypeMap[id];
    }
    /**
     * <zh/> 将布局结果对齐到元素，避免视图偏移。会修改布局结果
     *
     * <en/> Align the layout result to the element to avoid view offset. Will modify the layout result
     * @param layoutResult - <zh/> 布局结果 | <en/> layout result
     * @param id - <zh/> 元素 ID | <en/> element ID
     */ alignLayoutResultToElement(layoutResult, id) {
        var _a, _b;
        const target = (_a = layoutResult.nodes) === null || _a === void 0 ? void 0 : _a.find((node)=>(0, $brtTw.idOf)(node) === id);
        if (target) {
            const originalPosition = (0, $46bcR.positionOf)(this.context.model.getNodeLikeDatum(id));
            const modifiedPosition = (0, $46bcR.positionOf)(target);
            const delta = (0, $dOidW.subtract)(originalPosition, modifiedPosition);
            (_b = layoutResult.nodes) === null || _b === void 0 || _b.forEach((node)=>{
                var _a, _b, _c;
                if ((_a = node.style) === null || _a === void 0 ? void 0 : _a.x) node.style.x += delta[0];
                if ((_b = node.style) === null || _b === void 0 ? void 0 : _b.y) node.style.y += delta[1];
                if ((_c = node.style) === null || _c === void 0 ? void 0 : _c.z) node.style.z += delta[2] || 0;
            });
        }
    }
    /**
     * <zh/> 同步布局结果
     *
     * <en/> Sync layout result
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @param align - <zh/> 是否对齐 | <en/> whether to align
     */ syncLayoutResult(id, align) {
        return $2b40cdbd7fbf8140$var$__awaiter(this, void 0, void 0, function*() {
            const { layout: layout, model: model } = this.context;
            if (!layout) return;
            const layoutOptions = this.context.options.layout;
            const forcePreLayout = (opts)=>{
                if (Array.isArray(opts)) return opts.map((o)=>Object.assign(Object.assign({}, o), {
                        preLayout: true
                    }));
                return Object.assign(Object.assign({}, opts), {
                    preLayout: true
                });
            };
            const layoutResult = yield layout.simulate(layoutOptions ? forcePreLayout(layoutOptions) : undefined);
            if (align) this.alignLayoutResultToElement(layoutResult, id);
            model.updateData(layoutResult);
        });
    }
    /**
     * <zh/> 收起节点
     *
     * <en/> collapse node
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @param options - <zh/> 选项 | <en/> options
     */ collapseNode(id, options) {
        return $2b40cdbd7fbf8140$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const { animation: animation, align: align } = options;
            yield this.syncLayoutResult(id, align);
            // 重新计算数据 / Recalculate data
            const data = this.computeChangesAndDrawData({
                stage: 'collapse',
                animation: animation
            });
            if (!data) return;
            const { drawData: drawData } = data;
            const { add: add, remove: remove, update: update } = drawData;
            this.markDestroyElement(drawData);
            const context = {
                animation: animation,
                stage: 'collapse',
                data: drawData
            };
            this.destroyElements(remove, context);
            this.createElements(add, context);
            this.updateElements(update, context);
            yield (_a = this.context.animation.animate(animation, {
                beforeAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).BEFORE_ANIMATE, (0, $cFuSs.AnimationType).COLLAPSE, animation, drawData), context),
                afterAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).AFTER_ANIMATE, (0, $cFuSs.AnimationType).COLLAPSE, animation, drawData), context)
            }, {
                collapse: {
                    target: id,
                    descendants: Array.from(remove.nodes).map(([, node])=>(0, $brtTw.idOf)(node)),
                    position: (0, $46bcR.positionOf)(update.nodes.get(id))
                }
            })) === null || _a === void 0 ? void 0 : _a.finished;
        });
    }
    /**
     * <zh/> 展开节点
     *
     * <en/> expand node
     * @param id - <zh/> 元素 ID | <en/> element ID
     * @param animation - <zh/> 是否使用动画，默认为 true | <en/> Whether to use animation, default is true
     */ expandNode(id, options) {
        return $2b40cdbd7fbf8140$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const { model: model } = this.context;
            const { animation: animation, align: align } = options;
            const position = (0, $46bcR.positionOf)(model.getNodeData([
                id
            ])[0]);
            yield this.syncLayoutResult(id, align);
            // 重新计算数据 / Recalculate data
            const data = this.computeChangesAndDrawData({
                stage: 'expand',
                animation: animation
            });
            this.createElements(data.drawData.add, {
                animation: false,
                stage: 'expand',
                target: id
            });
            // 重置动画 / Reset animation
            this.context.animation.clear();
            this.computeStyle('expand');
            if (!data) return;
            const { drawData: drawData } = data;
            const { update: update, add: add } = drawData;
            const context = {
                animation: animation,
                stage: 'expand',
                data: drawData
            };
            // 将新增节点/边添加到更新列表 / Add new nodes/edges to the update list
            add.edges.forEach((edge)=>update.edges.set((0, $brtTw.idOf)(edge), edge));
            add.nodes.forEach((node)=>update.nodes.set((0, $brtTw.idOf)(node), node));
            this.updateElements(update, context);
            yield (_a = this.context.animation.animate(animation, {
                beforeAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).BEFORE_ANIMATE, (0, $cFuSs.AnimationType).EXPAND, animation, drawData), context),
                afterAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).AFTER_ANIMATE, (0, $cFuSs.AnimationType).EXPAND, animation, drawData), context)
            }, {
                expand: {
                    target: id,
                    descendants: Array.from(add.nodes).map(([, node])=>(0, $brtTw.idOf)(node)),
                    position: position
                }
            })) === null || _a === void 0 ? void 0 : _a.finished;
        });
    }
    collapseCombo(id, animation) {
        return $2b40cdbd7fbf8140$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const { model: model, element: element } = this.context;
            if (model.getAncestorsData(id, (0, $lDPR9.COMBO_KEY)).some((datum)=>(0, $VNNBO.isCollapsed)(datum))) return;
            const combo = element.getElement(id);
            const position = combo.getComboPosition(Object.assign(Object.assign({}, combo.attributes), {
                collapsed: true
            }));
            const data = this.computeChangesAndDrawData({
                stage: 'collapse',
                animation: animation
            });
            if (!data) return;
            const { dataChanges: dataChanges, drawData: drawData } = data;
            this.markDestroyElement(drawData);
            const { update: update, remove: remove } = drawData;
            const context = {
                animation: animation,
                stage: 'collapse',
                data: drawData
            };
            this.destroyElements(remove, context);
            this.updateElements(update, context);
            const idsOf = (data)=>Array.from(data).map(([, node])=>(0, $brtTw.idOf)(node));
            yield (_a = this.context.animation.animate(animation, {
                before: ()=>this.emit(new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_DRAW, {
                        dataChanges: dataChanges,
                        animation: animation
                    }), context),
                beforeAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).BEFORE_ANIMATE, (0, $cFuSs.AnimationType).COLLAPSE, animation, drawData), context),
                afterAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).AFTER_ANIMATE, (0, $cFuSs.AnimationType).COLLAPSE, animation, drawData), context),
                after: ()=>this.emit(new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_DRAW, {
                        dataChanges: dataChanges,
                        animation: animation
                    }), context)
            }, {
                collapse: {
                    target: id,
                    descendants: [
                        ...idsOf(remove.nodes),
                        ...idsOf(remove.combos)
                    ],
                    position: position
                }
            })) === null || _a === void 0 ? void 0 : _a.finished;
        });
    }
    expandCombo(id, animation) {
        return $2b40cdbd7fbf8140$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const { model: model } = this.context;
            const position = (0, $46bcR.positionOf)(model.getComboData([
                id
            ])[0]);
            // 重新计算数据 / Recalculate data
            this.computeStyle('expand');
            const data = this.computeChangesAndDrawData({
                stage: 'expand',
                animation: animation
            });
            if (!data) return;
            const { dataChanges: dataChanges, drawData: drawData } = data;
            const { add: add, update: update } = drawData;
            const context = {
                animation: animation,
                stage: 'expand',
                data: drawData,
                target: id
            };
            this.createElements(add, context);
            this.updateElements(update, context);
            const idsOf = (data)=>Array.from(data).map(([, node])=>(0, $brtTw.idOf)(node));
            yield (_a = this.context.animation.animate(animation, {
                before: ()=>this.emit(new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_DRAW, {
                        dataChanges: dataChanges,
                        animation: animation
                    }), context),
                beforeAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).BEFORE_ANIMATE, (0, $cFuSs.AnimationType).EXPAND, animation, drawData), context),
                afterAnimate: (animation)=>this.emit(new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).AFTER_ANIMATE, (0, $cFuSs.AnimationType).EXPAND, animation, drawData), context),
                after: ()=>this.emit(new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_DRAW, {
                        dataChanges: dataChanges,
                        animation: animation
                    }), context)
            }, {
                expand: {
                    target: id,
                    descendants: [
                        ...idsOf(add.nodes),
                        ...idsOf(add.combos)
                    ],
                    position: position
                }
            })) === null || _a === void 0 ? void 0 : _a.finished;
        });
    }
    /**
     * <zh/> 清空所有元素
     *
     * <en/> clear all elements
     */ clear() {
        this.container.destroy();
        this.initContainer();
        this.elementMap = {};
        this.shapeTypeMap = {};
        this.defaultStyle = {};
        this.stateStyle = {};
        this.paletteStyle = {};
    }
    destroy() {
        this.clear();
        this.container.destroy();
        // @ts-expect-error force delete
        this.context = {};
    }
}

});

parcelRegister("pzJSN", function(module, exports) {

$parcel$export(module.exports, "LayoutController", () => $04ce0ef1ab3bf1c8$export$8ddfa6080fb30603);

var $fc2XC = parcelRequire("fc2XC");

var $g98sr = parcelRequire("g98sr");
var $cOT47 = parcelRequire("cOT47");

var $iE4so = parcelRequire("iE4so");
parcelRequire("ahJ7k");
var $lDPR9 = parcelRequire("lDPR9");
var $4EzN9 = parcelRequire("4EzN9");
parcelRequire("2oT5h");
var $ht4Ur = parcelRequire("ht4Ur");

var $hW6vf = parcelRequire("hW6vf");

var $dtz9V = parcelRequire("dtz9V");

var $VNNBO = parcelRequire("VNNBO");

var $hn4z6 = parcelRequire("hn4z6");

var $3hhcj = parcelRequire("3hhcj");
var $8Fqus = parcelRequire("8Fqus");

var $8awWK = parcelRequire("8awWK");

var $brtTw = parcelRequire("brtTw");

var $fYedv = parcelRequire("fYedv");

var $aBpmX = parcelRequire("aBpmX");

var $dTE8j = parcelRequire("dTE8j");
var $04ce0ef1ab3bf1c8$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $04ce0ef1ab3bf1c8$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
class $04ce0ef1ab3bf1c8$export$8ddfa6080fb30603 {
    get presetOptions() {
        return {
            animation: !!(0, $dtz9V.getAnimationOptions)(this.context.options, true)
        };
    }
    get options() {
        const { options: options } = this.context;
        return options.layout;
    }
    constructor(context){
        this.instances = [];
        this.context = context;
    }
    getLayoutInstance() {
        return this.instances;
    }
    /**
     * <zh/> 前布局，即在绘制前执行布局
     *
     * <en/> Pre-layout, that is, perform layout before drawing
     * @param data - <zh/> 绘制数据 | <en/> Draw data
     * @remarks
     * <zh/> 前布局应该只在首次绘制前执行，后续更新不会触发
     *
     * <en/> Pre-layout should only be executed before the first drawing, and subsequent updates will not trigger
     */ preLayout(data) {
        return $04ce0ef1ab3bf1c8$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            const { graph: graph, model: model } = this.context;
            const { add: add } = data;
            (0, $3hhcj.emit)(graph, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_LAYOUT, {
                type: 'pre'
            }));
            const simulate = yield (_a = this.context.layout) === null || _a === void 0 ? void 0 : _a.simulate();
            (_b = simulate === null || simulate === void 0 ? void 0 : simulate.nodes) === null || _b === void 0 || _b.forEach((l)=>{
                const id = (0, $brtTw.idOf)(l);
                const node = add.nodes.get(id);
                model.syncNodeLikeDatum(l);
                if (node) Object.assign(node.style, l.style);
            });
            (_c = simulate === null || simulate === void 0 ? void 0 : simulate.edges) === null || _c === void 0 || _c.forEach((l)=>{
                const id = (0, $brtTw.idOf)(l);
                const edge = add.edges.get(id);
                model.syncEdgeDatum(l);
                if (edge) Object.assign(edge.style, l.style);
            });
            (_d = simulate === null || simulate === void 0 ? void 0 : simulate.combos) === null || _d === void 0 || _d.forEach((l)=>{
                const id = (0, $brtTw.idOf)(l);
                const combo = add.combos.get(id);
                model.syncNodeLikeDatum(l);
                if (combo) Object.assign(combo.style, l.style);
            });
            (0, $3hhcj.emit)(graph, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_LAYOUT, {
                type: 'pre'
            }));
            this.transformDataAfterLayout('pre', data);
        });
    }
    /**
     * <zh/> 后布局，即在完成绘制后执行布局
     *
     * <en/> Post layout, that is, perform layout after drawing
     * @param layoutOptions - <zh/> 布局配置项 | <en/> Layout options
     */ postLayout() {
        return $04ce0ef1ab3bf1c8$var$__awaiter(this, arguments, void 0, function*(layoutOptions = this.options) {
            if (!layoutOptions) return;
            const pipeline = Array.isArray(layoutOptions) ? layoutOptions : [
                layoutOptions
            ];
            const { graph: graph } = this.context;
            (0, $3hhcj.emit)(graph, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_LAYOUT, {
                type: 'post'
            }));
            for(let index = 0; index < pipeline.length; index++){
                const options = pipeline[index];
                const data = this.getLayoutData(options);
                const opts = Object.assign(Object.assign({}, this.presetOptions), options);
                (0, $3hhcj.emit)(graph, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).BEFORE_STAGE_LAYOUT, {
                    options: opts,
                    index: index
                }));
                const result = yield this.stepLayout(data, opts, index);
                (0, $3hhcj.emit)(graph, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_STAGE_LAYOUT, {
                    options: opts,
                    index: index
                }));
                if (!options.animation) this.updateElementPosition(result, false);
            }
            (0, $3hhcj.emit)(graph, new (0, $8Fqus.GraphLifeCycleEvent)((0, $4EzN9.GraphEvent).AFTER_LAYOUT, {
                type: 'post'
            }));
            this.transformDataAfterLayout('post');
        });
    }
    transformDataAfterLayout(type, data) {
        const transforms = this.context.transform.getTransformInstance();
        // @ts-expect-error skip type check
        Object.values(transforms).forEach((transform)=>transform.afterLayout(type, data));
    }
    /**
     * <zh/> 模拟布局
     *
     * <en/> Simulate layout
     * @param options - <zh/> 布局配置项 | <en/> Layout options
     * @returns <zh/> 模拟布局结果 | <en/> Simulated layout result
     */ simulate() {
        return $04ce0ef1ab3bf1c8$var$__awaiter(this, arguments, void 0, function*(options = this.options) {
            if (!options) return {};
            const pipeline = Array.isArray(options) ? options : [
                options
            ];
            let simulation = {};
            for(let index = 0; index < pipeline.length; index++){
                const options = pipeline[index];
                const data = this.getLayoutData(options);
                const result = yield this.stepLayout(data, Object.assign(Object.assign(Object.assign({}, this.presetOptions), options), {
                    animation: false
                }), index);
                simulation = result;
            }
            return simulation;
        });
    }
    stepLayout(data, options, index) {
        return $04ce0ef1ab3bf1c8$var$__awaiter(this, void 0, void 0, function*() {
            if ((0, $fYedv.isTreeLayout)(options)) return yield this.treeLayout(data, options, index);
            return yield this.graphLayout(data, options, index);
        });
    }
    graphLayout(data, options, index) {
        return $04ce0ef1ab3bf1c8$var$__awaiter(this, void 0, void 0, function*() {
            const { animation: animation, enableWorker: enableWorker, iterations: iterations = 300 } = options;
            const layout = this.initGraphLayout(options);
            if (!layout) return {};
            this.instances[index] = layout;
            this.instance = layout;
            // 使用 web worker 执行布局 / Use web worker to execute layout
            if (enableWorker) {
                const rawLayout = layout;
                this.supervisor = new (0, $cOT47.Supervisor)(rawLayout.graphData2LayoutModel(data), rawLayout.instance, {
                    iterations: iterations
                });
                return (0, $fYedv.layoutMapping2GraphData)((yield this.supervisor.execute()));
            }
            if ((0, $g98sr.isLayoutWithIterations)(layout)) {
                // 有动画，基于布局迭代 tick 更新位置 / Update position based on layout iteration tick
                if (animation) return yield layout.execute(data, {
                    onTick: (tickData)=>{
                        this.updateElementPosition(tickData, false);
                    }
                });
                // 无动画，直接返回终态位置 / No animation, return final position directly
                layout.execute(data);
                layout.stop();
                return layout.tick(iterations);
            }
            // 无迭代的布局，直接返回终态位置 / Layout without iteration, return final position directly
            const layoutResult = yield layout.execute(data);
            if (animation) {
                const animationResult = this.updateElementPosition(layoutResult, animation);
                yield animationResult === null || animationResult === void 0 ? void 0 : animationResult.finished;
            }
            return layoutResult;
        });
    }
    treeLayout(data, options, index) {
        return $04ce0ef1ab3bf1c8$var$__awaiter(this, void 0, void 0, function*() {
            const { type: type, animation: animation } = options;
            // @ts-expect-error @antv/hierarchy 布局格式与 @antv/layout 不一致，其导出的是一个方法，而非 class
            // The layout format of @antv/hierarchy is inconsistent with @antv/layout, it exports a method instead of a class
            const layout = (0, $hW6vf.getExtension)('layout', type);
            if (!layout) return {};
            const { nodes: nodes = [], edges: edges = [] } = data;
            const model = new (0, $fc2XC.Graph)({
                nodes: nodes.map((node)=>({
                        id: (0, $brtTw.idOf)(node),
                        data: node.data || {}
                    })),
                edges: edges.map((edge)=>({
                        id: (0, $brtTw.idOf)(edge),
                        source: edge.source,
                        target: edge.target,
                        data: edge.data || {}
                    }))
            });
            (0, $8awWK.createTreeStructure)(model);
            const layoutPreset = {
                nodes: [],
                edges: []
            };
            const layoutResult = {
                nodes: [],
                edges: []
            };
            const roots = model.getRoots((0, $lDPR9.TREE_KEY));
            roots.forEach((root)=>{
                (0, $dTE8j.dfs)(root, (node)=>{
                    node.children = model.getSuccessors(node.id);
                }, (node)=>model.getSuccessors(node.id), 'TB');
                const result = layout(root, options);
                const { x: rx, y: ry, z: rz = 0 } = result;
                // 将布局结果转化为 LayoutMapping 格式 / Convert the layout result to LayoutMapping format
                (0, $dTE8j.dfs)(result, (node)=>{
                    const { id: id, x: x, y: y, z: z = 0 } = node;
                    layoutPreset.nodes.push({
                        id: id,
                        style: {
                            x: rx,
                            y: ry,
                            z: rz
                        }
                    });
                    layoutResult.nodes.push({
                        id: id,
                        style: {
                            x: x,
                            y: y,
                            z: z
                        }
                    });
                }, (node)=>node.children, 'TB');
            });
            const offset = this.inferTreeLayoutOffset(layoutResult);
            $04ce0ef1ab3bf1c8$var$applyTreeLayoutOffset(layoutResult, offset);
            if (animation) {
                // 先将所有节点移动到根节点位置 / Move all nodes to the root node position first
                $04ce0ef1ab3bf1c8$var$applyTreeLayoutOffset(layoutPreset, offset);
                this.updateElementPosition(layoutPreset, false);
                const animationResult = this.updateElementPosition(layoutResult, animation);
                yield animationResult === null || animationResult === void 0 ? void 0 : animationResult.finished;
            }
            return layoutResult;
        });
    }
    inferTreeLayoutOffset(data) {
        var _a;
        let [minX, maxX] = [
            Infinity,
            -Infinity
        ];
        let [minY, maxY] = [
            Infinity,
            -Infinity
        ];
        (_a = data.nodes) === null || _a === void 0 || _a.forEach((node)=>{
            const { x: x = 0, y: y = 0 } = node.style || {};
            minX = Math.min(minX, x);
            maxX = Math.max(maxX, x);
            minY = Math.min(minY, y);
            maxY = Math.max(maxY, y);
        });
        const { canvas: canvas } = this.context;
        const canvasSize = canvas.getSize();
        const [x1, y1] = canvas.getCanvasByViewport([
            0,
            0
        ]);
        const [x2, y2] = canvas.getCanvasByViewport(canvasSize);
        if (minX >= x1 && maxX <= x2 && minY >= y1 && maxY <= y2) return [
            0,
            0
        ];
        const cx = (x1 + x2) / 2;
        const cy = (y1 + y2) / 2;
        return [
            cx - (minX + maxX) / 2,
            cy - (minY + maxY) / 2
        ];
    }
    stopLayout() {
        if (this.instance && (0, $g98sr.isLayoutWithIterations)(this.instance)) {
            this.instance.stop();
            this.instance = undefined;
        }
        if (this.supervisor) {
            this.supervisor.stop();
            this.supervisor = undefined;
        }
        if (this.animationResult) {
            this.animationResult.finish();
            this.animationResult = undefined;
        }
    }
    getLayoutData(options) {
        const { nodeFilter: nodeFilter = ()=>true, comboFilter: comboFilter = ()=>true, preLayout: preLayout = false, isLayoutInvisibleNodes: isLayoutInvisibleNodes = false } = options;
        const { nodes: nodes, edges: edges, combos: combos } = this.context.model.getData();
        const { element: element, model: model } = this.context;
        const getElement = (id)=>element.getElement(id);
        const filterFn = preLayout ? (node)=>{
            var _a;
            if (!isLayoutInvisibleNodes) {
                if (((_a = node.style) === null || _a === void 0 ? void 0 : _a.visibility) === 'hidden') return false;
                if (model.getAncestorsData(node.id, (0, $lDPR9.TREE_KEY)).some((0, $VNNBO.isCollapsed))) return false;
                if (model.getAncestorsData(node.id, (0, $lDPR9.COMBO_KEY)).some((0, $VNNBO.isCollapsed))) return false;
            }
            return nodeFilter(node);
        } : (node)=>{
            const id = (0, $brtTw.idOf)(node);
            const element = getElement(id);
            if (!element) return false;
            if ((0, $hn4z6.isToBeDestroyed)(element)) return false;
            return nodeFilter(node);
        };
        const nodesToLayout = nodes.filter(filterFn);
        const combosToLayout = combos.filter(comboFilter);
        const nodeLikeIdsMap = new Map(nodesToLayout.map((node)=>[
                (0, $brtTw.idOf)(node),
                node
            ]));
        combosToLayout.forEach((combo)=>nodeLikeIdsMap.set((0, $brtTw.idOf)(combo), combo));
        const edgesToLayout = edges.filter(({ source: source, target: target })=>{
            return nodeLikeIdsMap.has(source) && nodeLikeIdsMap.has(target);
        });
        return {
            nodes: nodesToLayout,
            edges: edgesToLayout,
            combos: combosToLayout
        };
    }
    /**
     * <zh/> 创建布局实例
     *
     * <en/> Create layout instance
     * @param options - <zh/> 布局配置项 | <en/> Layout options
     * @returns <zh/> 布局对象 | <en/> Layout object
     */ initGraphLayout(options) {
        var _a;
        const { element: element, viewport: viewport } = this.context;
        const { type: type, enableWorker: enableWorker, animation: animation, iterations: iterations } = options, restOptions = $04ce0ef1ab3bf1c8$var$__rest(options, [
            "type",
            "enableWorker",
            "animation",
            "iterations"
        ]);
        const [width, height] = viewport.getCanvasSize();
        const center = [
            width / 2,
            height / 2
        ];
        const nodeSize = (_a = options === null || options === void 0 ? void 0 : options.nodeSize) !== null && _a !== void 0 ? _a : (node)=>{
            const nodeElement = element === null || element === void 0 ? void 0 : element.getElement(node.id);
            if (nodeElement) return nodeElement.attributes.size;
            return element === null || element === void 0 ? void 0 : element.getElementComputedStyle('node', node).size;
        };
        const Ctor = (0, $hW6vf.getExtension)('layout', type);
        if (!Ctor) return (0, $aBpmX.print).warn(`The layout of ${type} is not registered.`);
        const STDCtor = Object.getPrototypeOf(Ctor.prototype) === (0, $ht4Ur.BaseLayout).prototype ? Ctor : (0, $fYedv.layoutAdapter)(Ctor, this.context);
        const layout = new STDCtor(this.context);
        const config = {
            nodeSize: nodeSize,
            width: width,
            height: height,
            center: center
        };
        switch(layout.id){
            case 'd3-force':
            case 'd3-force-3d':
                Object.assign(config, {
                    center: {
                        x: width / 2,
                        y: height / 2,
                        z: 0
                    }
                });
                break;
            default:
                break;
        }
        (0, $iE4so.default)(layout.options, config, restOptions);
        return layout;
    }
    updateElementPosition(layoutResult, animation) {
        const { model: model, element: element } = this.context;
        if (!element) return null;
        model.updateData(layoutResult);
        return element.draw({
            animation: animation,
            silence: true
        });
    }
    destroy() {
        var _a;
        this.stopLayout();
        // @ts-expect-error force delete
        this.context = {};
        (_a = this.supervisor) === null || _a === void 0 || _a.kill();
        this.supervisor = undefined;
        this.instance = undefined;
        this.instances = [];
        this.animationResult = undefined;
    }
}
/**
 * <zh/> 对树形布局结果应用偏移
 *
 * <en/> Apply offset to tree layout result
 * @param data - <zh/> 布局数据 | <en/> Layout data
 * @param offset - <zh/> 偏移量 | <en/> Offset
 */ const $04ce0ef1ab3bf1c8$var$applyTreeLayoutOffset = (data, offset)=>{
    var _a;
    const [ox, oy] = offset;
    (_a = data.nodes) === null || _a === void 0 || _a.forEach((node)=>{
        if (node.style) {
            const { x: x = 0, y: y = 0 } = node.style;
            node.style.x = x + ox;
            node.style.y = y + oy;
        } else node.style = {
            x: ox,
            y: oy
        };
    });
};

});
parcelRegister("cOT47", function(module, exports) {

$parcel$export(module.exports, "Supervisor", () => $9554de628b1730c3$export$b8cae3445c3b95cb);

var $7WQrb = parcelRequire("7WQrb");

var $7VXo7 = parcelRequire("7VXo7");

var $ky7aH = parcelRequire("ky7aH");

var $dLq9J = parcelRequire("dLq9J");

class $9554de628b1730c3$export$b8cae3445c3b95cb extends (0, $7VXo7.default) {
    constructor(graph, layout, options){
        super();
        this.graph = graph;
        this.layout = layout;
        this.options = options;
        this.spawnWorker();
    }
    spawnWorker() {
        this.proxy = $dLq9J.wrap(// @ts-ignore
        new Worker((parcelRequire("kQ1jH"))));
        if (this.running) {
            this.running = false;
            this.execute();
        }
    }
    execute() {
        var _a;
        return (0, $7WQrb.__awaiter)(this, void 0, void 0, function*() {
            if (this.running) return this;
            this.running = true;
            // Payload should include nodes & edges(if needed).
            const _b = this.layout.options, { onTick: onTick } = _b, rest = (0, $7WQrb.__rest)(_b, [
                "onTick"
            ]);
            const noFunctionOptions = {};
            Object.keys(rest).forEach((name)=>{
                if (!(0, $ky7aH.default)(rest[name])) noFunctionOptions[name] = rest[name];
            });
            const payload = {
                layout: {
                    id: this.layout.id,
                    options: noFunctionOptions,
                    iterations: (_a = this.options) === null || _a === void 0 ? void 0 : _a.iterations
                },
                nodes: this.graph.getAllNodes(),
                edges: this.graph.getAllEdges()
            };
            /**
             * TODO: Convert graph object to linear memory(e.g. csr, adjacency matrix), then transfer the ownership to worker.
             * @example
             * const arraybufferWithNodesEdges = graphToByteArrays(this.graph); // Float32Array
             */ const arraybufferWithNodesEdges = new Float32Array([
                0
            ]);
            // TODO: Support transferables.
            // @see https://www.npmjs.com/package/@naoak/workerize-transferable
            // setupTransferableMethodsOnMain(this.worker, {
            //   calculateLayout: {
            //     // pick a transferable object from the method parameters
            //     pickTransferablesFromParams: (params) => [params[1].buffer],
            //   },
            // });
            const [positions] = yield this.proxy.calculateLayout(payload, [
                arraybufferWithNodesEdges
            ]);
            return positions;
        });
    }
    stop() {
        this.running = false;
        // trigger `layout.stop()` if needed
        this.proxy.stopLayout();
        return this;
    }
    kill() {
        // allow the GC to collect wrapper port
        // @see https://github.com/GoogleChromeLabs/comlink#comlinkreleaseproxy
        this.proxy[$dLq9J.releaseProxy]();
    // TODO: unbind listeners on graph.
    // TODO: release attached memory
    }
    isRunning() {
        return this.running;
    }
}

});
parcelRegister("dLq9J", function(module, exports) {

$parcel$export(module.exports, "releaseProxy", () => $0e112480d1414235$export$89981d4b8d9f48aa);
$parcel$export(module.exports, "wrap", () => $0e112480d1414235$export$4997ffc0176396a6);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $0e112480d1414235$export$be5234c0b764b6e0 = Symbol("Comlink.proxy");
const $0e112480d1414235$export$39fb953702b7fcd7 = Symbol("Comlink.endpoint");
const $0e112480d1414235$export$89981d4b8d9f48aa = Symbol("Comlink.releaseProxy");
const $0e112480d1414235$export$ddc31dfe7c269837 = Symbol("Comlink.finalizer");
const $0e112480d1414235$var$throwMarker = Symbol("Comlink.thrown");
const $0e112480d1414235$var$isObject = (val)=>typeof val === "object" && val !== null || typeof val === "function";
/**
 * Internal transfer handle to handle objects marked to proxy.
 */ const $0e112480d1414235$var$proxyTransferHandler = {
    canHandle: (val)=>$0e112480d1414235$var$isObject(val) && val[$0e112480d1414235$export$be5234c0b764b6e0],
    serialize (obj) {
        const { port1: port1, port2: port2 } = new MessageChannel();
        $0e112480d1414235$export$9b7f6e342a8cbd38(obj, port1);
        return [
            port2,
            [
                port2
            ]
        ];
    },
    deserialize (port) {
        port.start();
        return $0e112480d1414235$export$4997ffc0176396a6(port);
    }
};
/**
 * Internal transfer handler to handle thrown exceptions.
 */ const $0e112480d1414235$var$throwTransferHandler = {
    canHandle: (value)=>$0e112480d1414235$var$isObject(value) && $0e112480d1414235$var$throwMarker in value,
    serialize ({ value: value }) {
        let serialized;
        if (value instanceof Error) serialized = {
            isError: true,
            value: {
                message: value.message,
                name: value.name,
                stack: value.stack
            }
        };
        else serialized = {
            isError: false,
            value: value
        };
        return [
            serialized,
            []
        ];
    },
    deserialize (serialized) {
        if (serialized.isError) throw Object.assign(new Error(serialized.value.message), serialized.value);
        throw serialized.value;
    }
};
/**
 * Allows customizing the serialization of certain values.
 */ const $0e112480d1414235$export$ab8f1c00731ee83e = new Map([
    [
        "proxy",
        $0e112480d1414235$var$proxyTransferHandler
    ],
    [
        "throw",
        $0e112480d1414235$var$throwTransferHandler
    ]
]);
function $0e112480d1414235$var$isAllowedOrigin(allowedOrigins, origin) {
    for (const allowedOrigin of allowedOrigins){
        if (origin === allowedOrigin || allowedOrigin === "*") return true;
        if (allowedOrigin instanceof RegExp && allowedOrigin.test(origin)) return true;
    }
    return false;
}
function $0e112480d1414235$export$9b7f6e342a8cbd38(obj, ep = globalThis, allowedOrigins = [
    "*"
]) {
    ep.addEventListener("message", function callback(ev) {
        if (!ev || !ev.data) return;
        if (!$0e112480d1414235$var$isAllowedOrigin(allowedOrigins, ev.origin)) {
            console.warn(`Invalid origin '${ev.origin}' for comlink proxy`);
            return;
        }
        const { id: id, type: type, path: path } = Object.assign({
            path: []
        }, ev.data);
        const argumentList = (ev.data.argumentList || []).map($0e112480d1414235$var$fromWireValue);
        let returnValue;
        try {
            const parent = path.slice(0, -1).reduce((obj, prop)=>obj[prop], obj);
            const rawValue = path.reduce((obj, prop)=>obj[prop], obj);
            switch(type){
                case "GET" /* MessageType.GET */ :
                    returnValue = rawValue;
                    break;
                case "SET" /* MessageType.SET */ :
                    parent[path.slice(-1)[0]] = $0e112480d1414235$var$fromWireValue(ev.data.value);
                    returnValue = true;
                    break;
                case "APPLY" /* MessageType.APPLY */ :
                    returnValue = rawValue.apply(parent, argumentList);
                    break;
                case "CONSTRUCT" /* MessageType.CONSTRUCT */ :
                    {
                        const value = new rawValue(...argumentList);
                        returnValue = $0e112480d1414235$export$923f96dd5afa9ce6(value);
                    }
                    break;
                case "ENDPOINT" /* MessageType.ENDPOINT */ :
                    {
                        const { port1: port1, port2: port2 } = new MessageChannel();
                        $0e112480d1414235$export$9b7f6e342a8cbd38(obj, port2);
                        returnValue = $0e112480d1414235$export$c9b234447cf4ef7c(port1, [
                            port1
                        ]);
                    }
                    break;
                case "RELEASE" /* MessageType.RELEASE */ :
                    returnValue = undefined;
                    break;
                default:
                    return;
            }
        } catch (value) {
            returnValue = {
                value: value,
                [$0e112480d1414235$var$throwMarker]: 0
            };
        }
        Promise.resolve(returnValue).catch((value)=>{
            return {
                value: value,
                [$0e112480d1414235$var$throwMarker]: 0
            };
        }).then((returnValue)=>{
            const [wireValue, transferables] = $0e112480d1414235$var$toWireValue(returnValue);
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
            if (type === "RELEASE" /* MessageType.RELEASE */ ) {
                // detach and deactive after sending release response above.
                ep.removeEventListener("message", callback);
                $0e112480d1414235$var$closeEndPoint(ep);
                if ($0e112480d1414235$export$ddc31dfe7c269837 in obj && typeof obj[$0e112480d1414235$export$ddc31dfe7c269837] === "function") obj[$0e112480d1414235$export$ddc31dfe7c269837]();
            }
        }).catch((error)=>{
            // Send Serialization Error To Caller
            const [wireValue, transferables] = $0e112480d1414235$var$toWireValue({
                value: new TypeError("Unserializable return value"),
                [$0e112480d1414235$var$throwMarker]: 0
            });
            ep.postMessage(Object.assign(Object.assign({}, wireValue), {
                id: id
            }), transferables);
        });
    });
    if (ep.start) ep.start();
}
function $0e112480d1414235$var$isMessagePort(endpoint) {
    return endpoint.constructor.name === "MessagePort";
}
function $0e112480d1414235$var$closeEndPoint(endpoint) {
    if ($0e112480d1414235$var$isMessagePort(endpoint)) endpoint.close();
}
function $0e112480d1414235$export$4997ffc0176396a6(ep, target) {
    const pendingListeners = new Map();
    ep.addEventListener("message", function handleMessage(ev) {
        const { data: data } = ev;
        if (!data || !data.id) return;
        const resolver = pendingListeners.get(data.id);
        if (!resolver) return;
        try {
            resolver(data);
        } finally{
            pendingListeners.delete(data.id);
        }
    });
    return $0e112480d1414235$var$createProxy(ep, pendingListeners, [], target);
}
function $0e112480d1414235$var$throwIfProxyReleased(isReleased) {
    if (isReleased) throw new Error("Proxy has been released and is not useable");
}
function $0e112480d1414235$var$releaseEndpoint(ep) {
    return $0e112480d1414235$var$requestResponseMessage(ep, new Map(), {
        type: "RELEASE" /* MessageType.RELEASE */ 
    }).then(()=>{
        $0e112480d1414235$var$closeEndPoint(ep);
    });
}
const $0e112480d1414235$var$proxyCounter = new WeakMap();
const $0e112480d1414235$var$proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry((ep)=>{
    const newCount = ($0e112480d1414235$var$proxyCounter.get(ep) || 0) - 1;
    $0e112480d1414235$var$proxyCounter.set(ep, newCount);
    if (newCount === 0) $0e112480d1414235$var$releaseEndpoint(ep);
});
function $0e112480d1414235$var$registerProxy(proxy, ep) {
    const newCount = ($0e112480d1414235$var$proxyCounter.get(ep) || 0) + 1;
    $0e112480d1414235$var$proxyCounter.set(ep, newCount);
    if ($0e112480d1414235$var$proxyFinalizers) $0e112480d1414235$var$proxyFinalizers.register(proxy, ep, proxy);
}
function $0e112480d1414235$var$unregisterProxy(proxy) {
    if ($0e112480d1414235$var$proxyFinalizers) $0e112480d1414235$var$proxyFinalizers.unregister(proxy);
}
function $0e112480d1414235$var$createProxy(ep, pendingListeners, path = [], target = function() {}) {
    let isProxyReleased = false;
    const proxy = new Proxy(target, {
        get (_target, prop) {
            $0e112480d1414235$var$throwIfProxyReleased(isProxyReleased);
            if (prop === $0e112480d1414235$export$89981d4b8d9f48aa) return ()=>{
                $0e112480d1414235$var$unregisterProxy(proxy);
                $0e112480d1414235$var$releaseEndpoint(ep);
                pendingListeners.clear();
                isProxyReleased = true;
            };
            if (prop === "then") {
                if (path.length === 0) return {
                    then: ()=>proxy
                };
                const r = $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                    type: "GET" /* MessageType.GET */ ,
                    path: path.map((p)=>p.toString())
                }).then($0e112480d1414235$var$fromWireValue);
                return r.then.bind(r);
            }
            return $0e112480d1414235$var$createProxy(ep, pendingListeners, [
                ...path,
                prop
            ]);
        },
        set (_target, prop, rawValue) {
            $0e112480d1414235$var$throwIfProxyReleased(isProxyReleased);
            // FIXME: ES6 Proxy Handler `set` methods are supposed to return a
            // boolean. To show good will, we return true asynchronously ¯\_(ツ)_/¯
            const [value, transferables] = $0e112480d1414235$var$toWireValue(rawValue);
            return $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                type: "SET" /* MessageType.SET */ ,
                path: [
                    ...path,
                    prop
                ].map((p)=>p.toString()),
                value: value
            }, transferables).then($0e112480d1414235$var$fromWireValue);
        },
        apply (_target, _thisArg, rawArgumentList) {
            $0e112480d1414235$var$throwIfProxyReleased(isProxyReleased);
            const last = path[path.length - 1];
            if (last === $0e112480d1414235$export$39fb953702b7fcd7) return $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                type: "ENDPOINT" /* MessageType.ENDPOINT */ 
            }).then($0e112480d1414235$var$fromWireValue);
            // We just pretend that `bind()` didn’t happen.
            if (last === "bind") return $0e112480d1414235$var$createProxy(ep, pendingListeners, path.slice(0, -1));
            const [argumentList, transferables] = $0e112480d1414235$var$processArguments(rawArgumentList);
            return $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                type: "APPLY" /* MessageType.APPLY */ ,
                path: path.map((p)=>p.toString()),
                argumentList: argumentList
            }, transferables).then($0e112480d1414235$var$fromWireValue);
        },
        construct (_target, rawArgumentList) {
            $0e112480d1414235$var$throwIfProxyReleased(isProxyReleased);
            const [argumentList, transferables] = $0e112480d1414235$var$processArguments(rawArgumentList);
            return $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, {
                type: "CONSTRUCT" /* MessageType.CONSTRUCT */ ,
                path: path.map((p)=>p.toString()),
                argumentList: argumentList
            }, transferables).then($0e112480d1414235$var$fromWireValue);
        }
    });
    $0e112480d1414235$var$registerProxy(proxy, ep);
    return proxy;
}
function $0e112480d1414235$var$myFlat(arr) {
    return Array.prototype.concat.apply([], arr);
}
function $0e112480d1414235$var$processArguments(argumentList) {
    const processed = argumentList.map($0e112480d1414235$var$toWireValue);
    return [
        processed.map((v)=>v[0]),
        $0e112480d1414235$var$myFlat(processed.map((v)=>v[1]))
    ];
}
const $0e112480d1414235$var$transferCache = new WeakMap();
function $0e112480d1414235$export$c9b234447cf4ef7c(obj, transfers) {
    $0e112480d1414235$var$transferCache.set(obj, transfers);
    return obj;
}
function $0e112480d1414235$export$923f96dd5afa9ce6(obj) {
    return Object.assign(obj, {
        [$0e112480d1414235$export$be5234c0b764b6e0]: true
    });
}
function $0e112480d1414235$export$f2c03fb5a6c19546(w, context = globalThis, targetOrigin = "*") {
    return {
        postMessage: (msg, transferables)=>w.postMessage(msg, targetOrigin, transferables),
        addEventListener: context.addEventListener.bind(context),
        removeEventListener: context.removeEventListener.bind(context)
    };
}
function $0e112480d1414235$var$toWireValue(value) {
    for (const [name, handler] of $0e112480d1414235$export$ab8f1c00731ee83e)if (handler.canHandle(value)) {
        const [serializedValue, transferables] = handler.serialize(value);
        return [
            {
                type: "HANDLER" /* WireValueType.HANDLER */ ,
                name: name,
                value: serializedValue
            },
            transferables
        ];
    }
    return [
        {
            type: "RAW" /* WireValueType.RAW */ ,
            value: value
        },
        $0e112480d1414235$var$transferCache.get(value) || []
    ];
}
function $0e112480d1414235$var$fromWireValue(value) {
    switch(value.type){
        case "HANDLER" /* WireValueType.HANDLER */ :
            return $0e112480d1414235$export$ab8f1c00731ee83e.get(value.name).deserialize(value.value);
        case "RAW" /* WireValueType.RAW */ :
            return value.value;
    }
}
function $0e112480d1414235$var$requestResponseMessage(ep, pendingListeners, msg, transfers) {
    return new Promise((resolve)=>{
        const id = $0e112480d1414235$var$generateUUID();
        pendingListeners.set(id, resolve);
        if (ep.start) ep.start();
        ep.postMessage(Object.assign({
            id: id
        }, msg), transfers);
    });
}
function $0e112480d1414235$var$generateUUID() {
    return new Array(4).fill(0).map(()=>Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16)).join("-");
}

});

parcelRegister("kQ1jH", function(module, exports) {

var $7ryUf = parcelRequire("7ryUf");
let $f2b9af77991fa1f0$var$url = new URL(import.meta.resolve("6mApB"));
module.exports = $7ryUf($f2b9af77991fa1f0$var$url.toString(), $f2b9af77991fa1f0$var$url.origin, true);

});
parcelRegister("7ryUf", function(module, exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};

});




parcelRegister("k1ICh", function(module, exports) {

$parcel$export(module.exports, "inferOptions", () => $e94682873ce94150$export$6556fc80b9b19132);
/**
 * <zh/> 基于用户传入的配置，推断出最终的配置
 *
 * <en/> Infer the final configuration based on the configuration passed by the user
 * @param options - <zh/> 用户传入的配置 | <en/> Configuration passed by the user
 * @returns <zh/> 最终的配置 | <en/> Final configuration
 */ function $e94682873ce94150$export$6556fc80b9b19132(options) {
    const flow = [
        $e94682873ce94150$var$inferLayoutOptions
    ];
    return flow.reduce((acc, infer)=>infer(acc), options);
}
/**
 * <zh/> 推断布局配置
 *
 * <en/> Infer layout configuration
 * @param options - <zh/> 用户传入的配置 | <en/> Configuration passed by the user
 * @returns <zh/> 最终的配置 | <en/> Final configuration
 */ function $e94682873ce94150$var$inferLayoutOptions(options) {
    if (!options.layout) return options;
    if (Array.isArray(options.layout)) return options;
    if ('preLayout' in options.layout) return options;
    if ([
        'antv-dagre',
        'combo-combined',
        'compact-box',
        'circular',
        'concentric',
        'dagre',
        'fishbone',
        'grid',
        'indented',
        'mds',
        'radial',
        'random',
        'snake',
        // <zh/> 下列布局的标签位置待适配，需要手动配置 preLayout false
        // <en/> The label position of the following layouts needs to be adapted, and preLayout needs to be manually configured as false
        'dendrogram',
        'mindmap'
    ].includes(options.layout.type)) options.layout.preLayout = true;
    return options;
}

});

parcelRegister("dZHuo", function(module, exports) {

$parcel$export(module.exports, "PluginController", () => $a302b4ec3f1ba50f$export$1f6ddde802b35147);

var $dhEO8 = parcelRequire("dhEO8");

var $aBpmX = parcelRequire("aBpmX");
class $a302b4ec3f1ba50f$export$1f6ddde802b35147 extends (0, $dhEO8.ExtensionController) {
    constructor(context){
        super(context);
        this.category = 'plugin';
        this.setPlugins(this.context.options.plugins || []);
    }
    setPlugins(plugins) {
        this.setExtensions(plugins);
    }
    getPluginInstance(key) {
        const exactly = this.extensionMap[key];
        if (exactly) return exactly;
        (0, $aBpmX.print).warn(`Cannot find the plugin ${key}, will try to find it by type.`);
        const fussily = this.extensions.find((extension)=>extension.type === key);
        if (fussily) return this.extensionMap[fussily.key];
    }
}

});

parcelRegister("M9i2f", function(module, exports) {

$parcel$export(module.exports, "TransformController", () => $090bb0968635fd8c$export$ee7d1ddda867ce28);

var $dhEO8 = parcelRequire("dhEO8");
const $090bb0968635fd8c$export$8bee9ae9eeeab9f8 = [
    'update-related-edges',
    'collapse-expand-node',
    'collapse-expand-combo',
    'get-edge-actual-ends',
    'arrange-draw-order'
];
class $090bb0968635fd8c$export$ee7d1ddda867ce28 extends (0, $dhEO8.ExtensionController) {
    constructor(context){
        super(context);
        this.category = 'transform';
        this.setTransforms(this.context.options.transforms || []);
    }
    getTransforms() {}
    setTransforms(transforms) {
        this.setExtensions([
            ...$090bb0968635fd8c$export$8bee9ae9eeeab9f8.slice(0, $090bb0968635fd8c$export$8bee9ae9eeeab9f8.length - 1),
            ...transforms,
            $090bb0968635fd8c$export$8bee9ae9eeeab9f8[$090bb0968635fd8c$export$8bee9ae9eeeab9f8.length - 1]
        ]);
    }
    getTransformInstance(key) {
        return key ? this.extensionMap[key] : this.extensionMap;
    }
}

});

parcelRegister("7goJ4", function(module, exports) {

$parcel$export(module.exports, "ViewportController", () => $549d3518b824339d$export$76961f14f31c54bd);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $8hhuV = parcelRequire("8hhuV");
var $jyI49 = parcelRequire("jyI49");
var $cyCCc = parcelRequire("cyCCc");
parcelRequire("ahJ7k");
var $cFuSs = parcelRequire("cFuSs");
var $4EzN9 = parcelRequire("4EzN9");

var $dtz9V = parcelRequire("dtz9V");

var $6BVcW = parcelRequire("6BVcW");
parcelRequire("3hhcj");
var $8Fqus = parcelRequire("8Fqus");
var $3hhcj = parcelRequire("3hhcj");

var $lEe0S = parcelRequire("lEe0S");

var $1uR12 = parcelRequire("1uR12");

var $dOidW = parcelRequire("dOidW");
var $549d3518b824339d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $549d3518b824339d$export$76961f14f31c54bd {
    get padding() {
        return (0, $1uR12.parsePadding)(this.context.options.padding);
    }
    get paddingOffset() {
        const [top, right, bottom, left] = this.padding;
        const [offsetX, offsetY, offsetZ] = [
            (left - right) / 2,
            (top - bottom) / 2,
            0
        ];
        return [
            offsetX,
            offsetY,
            offsetZ
        ];
    }
    constructor(context){
        this.landmarkCounter = 0;
        this.context = context;
        const [px, py] = this.paddingOffset;
        const { zoom: zoom, rotation: rotation, x: x = px, y: y = py } = context.options;
        this.transform({
            mode: 'absolute',
            scale: zoom,
            translate: [
                x,
                y
            ],
            rotate: rotation
        }, false);
    }
    get camera() {
        const { canvas: canvas } = this.context;
        return new Proxy(canvas.getCamera(), {
            get: (target, prop)=>{
                const layers = Object.entries(canvas.getLayers()).filter(([name])=>![
                        'main'
                    ].includes(name));
                const cameras = layers.map(([, layer])=>layer.getCamera());
                const value = target[prop];
                if (typeof value === 'function') return (...args)=>{
                    const result = value.apply(target, args);
                    cameras.forEach((camera)=>{
                        camera[prop].apply(camera, args);
                    });
                    return result;
                };
            }
        });
    }
    createLandmark(options) {
        return this.camera.createLandmark(`landmark-${this.landmarkCounter++}`, options);
    }
    getAnimation(animation) {
        const finalAnimation = (0, $dtz9V.getAnimationOptions)(this.context.options, animation);
        if (!finalAnimation) return false;
        return (0, $cyCCc.default)(Object.assign({}, finalAnimation), [
            'easing',
            'duration'
        ]);
    }
    getCanvasSize() {
        const { canvas: canvas } = this.context;
        const { width: width = 0, height: height = 0 } = canvas.getConfig();
        return [
            width,
            height
        ];
    }
    /**
     * <zh/> 获取画布中心坐标
     *
     * <en/> Get the center coordinates of the canvas
     * @returns - <zh/> 画布中心坐标 | <en/> Center coordinates of the canvas
     * @remarks
     * <zh/> 基于画布的宽高计算中心坐标，不受视口变换影响
     *
     * <en/> Calculate the center coordinates based on the width and height of the canvas, not affected by the viewport transformation
     */ getCanvasCenter() {
        const { canvas: canvas } = this.context;
        const { width: width = 0, height: height = 0 } = canvas.getConfig();
        return [
            width / 2,
            height / 2,
            0
        ];
    }
    /**
     * <zh/> 当前视口中心坐标
     *
     * <en/> Current viewport center coordinates
     * @returns - <zh/> 视口中心坐标 | <en/> Viewport center coordinates
     * @remarks
     * <zh/> 以画布原点为原点，受到视口变换影响
     *
     * <en/> With the origin of the canvas as the origin, affected by the viewport transformation
     */ getViewportCenter() {
        // 理论上应该通过 camera.getFocalPoint() 获取
        // 但在 2D 场景下，通过 pan 操作时，focalPoint 不会变化
        const [x, y] = this.camera.getPosition();
        return [
            x,
            y,
            0
        ];
    }
    getGraphCenter() {
        return this.context.graph.getViewportByCanvas(this.getCanvasCenter());
    }
    getZoom() {
        return this.camera.getZoom();
    }
    getRotation() {
        return this.camera.getRoll();
    }
    getTranslateOptions(options) {
        const { camera: camera } = this;
        const { mode: mode, translate: translate = [] } = options;
        const currentZoom = this.getZoom();
        const position = camera.getPosition();
        const focalPoint = camera.getFocalPoint();
        const [cx, cy] = this.getCanvasCenter();
        const [x = 0, y = 0, z = 0] = translate;
        const delta = (0, $dOidW.divide)([
            -x,
            -y,
            -z
        ], currentZoom);
        return mode === 'relative' ? {
            position: (0, $dOidW.add)(position, delta),
            focalPoint: (0, $dOidW.add)(focalPoint, delta)
        } : {
            position: (0, $dOidW.add)([
                cx,
                cy,
                position[2]
            ], delta),
            focalPoint: (0, $dOidW.add)([
                cx,
                cy,
                focalPoint[2]
            ], delta)
        };
    }
    getRotateOptions(options) {
        const { mode: mode, rotate: rotate = 0 } = options;
        const roll = mode === 'relative' ? this.camera.getRoll() + rotate : rotate;
        return {
            roll: roll
        };
    }
    getZoomOptions(options) {
        const { zoomRange: zoomRange } = this.context.options;
        const currentZoom = this.camera.getZoom();
        const { mode: mode, scale: scale = 1 } = options;
        return (0, $8hhuV.default)(mode === 'relative' ? currentZoom * scale : scale, ...zoomRange);
    }
    transform(options, animation) {
        return $549d3518b824339d$var$__awaiter(this, void 0, void 0, function*() {
            const { graph: graph } = this.context;
            const { translate: translate, rotate: rotate, scale: scale, origin: origin } = options;
            this.cancelAnimation();
            const _animation = this.getAnimation(animation);
            (0, $3hhcj.emit)(graph, new (0, $8Fqus.ViewportEvent)((0, $4EzN9.GraphEvent).BEFORE_TRANSFORM, options));
            // 针对缩放操作，且不涉及平移、旋转、中心点、动画时，直接调用 setZoomByViewportPoint
            // For zoom operations, and no translation, rotation, center point, and animation involved, call setZoomByViewportPoint directly
            if (!rotate && scale && !translate && origin && !_animation) {
                this.camera.setZoomByViewportPoint(this.getZoomOptions(options), origin);
                (0, $3hhcj.emit)(graph, new (0, $8Fqus.ViewportEvent)((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, options));
                return;
            }
            const landmarkOptions = {};
            if (translate) Object.assign(landmarkOptions, this.getTranslateOptions(options));
            if ((0, $jyI49.default)(rotate)) Object.assign(landmarkOptions, this.getRotateOptions(options));
            if ((0, $jyI49.default)(scale)) Object.assign(landmarkOptions, {
                zoom: this.getZoomOptions(options)
            });
            if (_animation) {
                (0, $3hhcj.emit)(graph, new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).BEFORE_ANIMATE, (0, $cFuSs.AnimationType).TRANSFORM, null, options));
                return new Promise((resolve)=>{
                    this.transformResolver = resolve;
                    this.camera.gotoLandmark(this.createLandmark(landmarkOptions), Object.assign(Object.assign({}, _animation), {
                        onfinish: ()=>{
                            (0, $3hhcj.emit)(graph, new (0, $8Fqus.AnimateEvent)((0, $4EzN9.GraphEvent).AFTER_ANIMATE, (0, $cFuSs.AnimationType).TRANSFORM, null, options));
                            (0, $3hhcj.emit)(graph, new (0, $8Fqus.ViewportEvent)((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, options));
                            this.transformResolver = undefined;
                            resolve();
                        }
                    }));
                });
            } else {
                this.camera.gotoLandmark(this.createLandmark(landmarkOptions), {
                    duration: 0
                });
                (0, $3hhcj.emit)(graph, new (0, $8Fqus.ViewportEvent)((0, $4EzN9.GraphEvent).AFTER_TRANSFORM, options));
            }
        });
    }
    fitView(options, animation) {
        return $549d3518b824339d$var$__awaiter(this, void 0, void 0, function*() {
            const [top, right, bottom, left] = this.padding;
            const { when: when = 'always', direction: direction = 'both' } = options || {};
            const [width, height] = this.context.canvas.getSize();
            const innerWidth = width - left - right;
            const innerHeight = height - top - bottom;
            const canvasBounds = this.context.canvas.getBounds();
            const bboxInViewPort = this.getBBoxInViewport(canvasBounds);
            const [contentWidth, contentHeight] = (0, $6BVcW.getBBoxSize)(bboxInViewPort);
            const isOverflow = direction === 'x' && contentWidth >= innerWidth || direction === 'y' && contentHeight >= innerHeight || direction === 'both' && contentWidth >= innerWidth && contentHeight >= innerHeight;
            if (when === 'overflow' && !isOverflow) return yield this.fitCenter({
                animation: animation
            });
            const scaleX = innerWidth / contentWidth;
            const scaleY = innerHeight / contentHeight;
            const scale = direction === 'x' ? scaleX : direction === 'y' ? scaleY : Math.min(scaleX, scaleY);
            const _animation = this.getAnimation(animation);
            if (!Number.isFinite(scale)) return;
            yield this.transform({
                mode: 'relative',
                scale: scale,
                translate: (0, $dOidW.add)((0, $dOidW.subtract)(this.getCanvasCenter(), this.getBBoxInViewport(canvasBounds).center), (0, $dOidW.divide)(this.paddingOffset, scale))
            }, _animation);
        });
    }
    fitCenter(options) {
        return $549d3518b824339d$var$__awaiter(this, void 0, void 0, function*() {
            const canvasBounds = this.context.canvas.getBounds();
            yield this.focus(canvasBounds, options);
        });
    }
    focusElements(ids_1) {
        return $549d3518b824339d$var$__awaiter(this, arguments, void 0, function*(ids, options = {}) {
            const { element: element } = this.context;
            if (!element) return;
            const getBoundsOf = (el)=>options.shapes ? el.getShape(options.shapes).getRenderBounds() : el.getRenderBounds();
            const elementsBounds = (0, $6BVcW.getCombinedBBox)(ids.map((id)=>getBoundsOf(element.getElement(id))));
            yield this.focus(elementsBounds, options);
        });
    }
    focus(bbox, options) {
        return $549d3518b824339d$var$__awaiter(this, void 0, void 0, function*() {
            const center = this.context.graph.getViewportByCanvas(bbox.center);
            const position = options.position || this.getCanvasCenter();
            const delta = (0, $dOidW.subtract)(position, center);
            yield this.transform({
                mode: 'relative',
                translate: (0, $dOidW.add)(delta, this.paddingOffset)
            }, options.animation);
        });
    }
    /**
     * <zh/> 获取画布元素在视口中的包围盒
     *
     * <en/> Get the bounding box of the canvas element in the viewport
     * @param bbox - <zh/> 画布元素包围盒 | <en/> Canvas element bounding box
     * @returns - <zh/> 视口中的包围盒 | <en/> Bounding box in the viewport
     */ getBBoxInViewport(bbox) {
        const { min: min, max: max } = bbox;
        const { graph: graph } = this.context;
        const [x1, y1] = graph.getViewportByCanvas(min);
        const [x2, y2] = graph.getViewportByCanvas(max);
        const bboxInViewport = new (0, $2eDEB.AABB)();
        bboxInViewport.setMinMax([
            x1,
            y1,
            0
        ], [
            x2,
            y2,
            0
        ]);
        return bboxInViewport;
    }
    /**
     * <zh/> 判断点或包围盒是否在视口中
     *
     * <en/> Determine whether the point or bounding box is in the viewport
     * @param target - <zh/> 点或包围盒 | <en/> Point or bounding box
     * @param complete - <zh/> 是否完全在视口中 | <en/> Whether it is completely in the viewport
     * @param tolerance - <zh/> 视口外的容差 | <en/> Tolerance outside the viewport
     * @returns - <zh/> 是否在视口中 | <en/> Whether it is in the viewport
     */ isInViewport(target, complete = false, tolerance = 0) {
        const { graph: graph } = this.context;
        const size = this.getCanvasSize();
        const [x1, y1] = graph.getCanvasByViewport([
            0,
            0
        ]);
        const [x2, y2] = graph.getCanvasByViewport(size);
        let viewportBBox = new (0, $2eDEB.AABB)();
        viewportBBox.setMinMax([
            x1,
            y1,
            0
        ], [
            x2,
            y2,
            0
        ]);
        if (tolerance) viewportBBox = (0, $6BVcW.getExpandedBBox)(viewportBBox, tolerance);
        return (0, $lEe0S.isPoint)(target) ? (0, $6BVcW.isPointInBBox)(target, viewportBBox) : !complete ? viewportBBox.intersects(target) : (0, $6BVcW.isBBoxInside)(target, viewportBBox);
    }
    cancelAnimation() {
        var _a, _b;
        // @ts-expect-error landmarks is private
        if ((_a = this.camera.landmarks) === null || _a === void 0 ? void 0 : _a.length) this.camera.cancelLandmarkAnimation();
        (_b = this.transformResolver) === null || _b === void 0 || _b.call(this);
    }
}

});


parcelRegister("2E0Sw", function(module, exports) {

var $dTE8j = parcelRequire("dTE8j");
var $1ecfffa00414ea87$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
function $1ecfffa00414ea87$export$1fb500d40d327167(treeData, getter) {
    const { getNodeData: getNodeData = (datum, depth)=>{
        datum.depth = depth;
        if (!datum.children) return datum;
        const { children: children } = datum, restDatum = $1ecfffa00414ea87$var$__rest(datum, [
            "children"
        ]);
        return Object.assign(Object.assign({}, restDatum), {
            children: children.map((child)=>child.id)
        });
    }, getEdgeData: getEdgeData = (source, target)=>({
            source: source.id,
            target: target.id
        }), getChildren: getChildren = (datum)=>datum.children || [] } = getter || {};
    const nodes = [];
    const edges = [];
    (0, $dTE8j.dfs)(treeData, (node, depth)=>{
        nodes.push(getNodeData(node, depth));
        const children = getChildren(node);
        for (const child of children)edges.push(getEdgeData(node, child));
    }, (node)=>getChildren(node), 'TB');
    return {
        nodes: nodes,
        edges: edges
    };
}

});



parcelRegister("7Sobs", function(module, exports) {

$parcel$export(module.exports, "MapNodeSize", () => $5bc055ed7f35ea70$export$d49e2dc141b77eb6);

var $iE4so = parcelRequire("iE4so");
var $cyCCc = parcelRequire("cyCCc");

var $eASF9 = parcelRequire("eASF9");

var $brtTw = parcelRequire("brtTw");

var $1uR12 = parcelRequire("1uR12");

var $88HFs = parcelRequire("88HFs");

var $e6Msm = parcelRequire("e6Msm");

var $kzVEQ = parcelRequire("kzVEQ");

var $evi0t = parcelRequire("evi0t");
class $5bc055ed7f35ea70$export$d49e2dc141b77eb6 extends (0, $kzVEQ.BaseTransform) {
    constructor(context, options){
        super(context, (0, $iE4so.default)({}, $5bc055ed7f35ea70$export$d49e2dc141b77eb6.defaultOptions, options));
        this.assignSizeByCentrality = (centrality, minCentrality, maxCentrality, minSize, maxSize, scale)=>{
            const domain = [
                minCentrality,
                maxCentrality
            ];
            const rangeX = [
                minSize[0],
                maxSize[0]
            ];
            const rangeY = [
                minSize[1],
                maxSize[1]
            ];
            const rangeZ = [
                minSize[2],
                maxSize[2]
            ];
            const interpolate = (centrality, range)=>{
                if (typeof scale === 'function') return scale(centrality, domain, range);
                switch(scale){
                    case 'linear':
                        return (0, $88HFs.linear)(centrality, domain, range);
                    case 'log':
                        return (0, $88HFs.log)(centrality, domain, range);
                    case 'pow':
                        return (0, $88HFs.pow)(centrality, domain, range, 2);
                    case 'sqrt':
                        return (0, $88HFs.sqrt)(centrality, domain, range);
                    default:
                        return range[0];
                }
            };
            return [
                interpolate(centrality, rangeX),
                interpolate(centrality, rangeY),
                interpolate(centrality, rangeZ)
            ];
        };
    }
    beforeDraw(input) {
        const { model: model } = this.context;
        const nodes = model.getNodeData();
        const maxSize = (0, $e6Msm.parseSize)(this.options.maxSize);
        const minSize = (0, $e6Msm.parseSize)(this.options.minSize);
        const centralities = this.getCentralities(this.options.centrality);
        const maxCentrality = centralities.size > 0 ? Math.max(...centralities.values()) : 0;
        const minCentrality = centralities.size > 0 ? Math.min(...centralities.values()) : 0;
        nodes.forEach((datum)=>{
            var _a;
            const size = this.assignSizeByCentrality(centralities.get((0, $brtTw.idOf)(datum)) || 0, minCentrality, maxCentrality, minSize, maxSize, this.options.scale);
            const element = (_a = this.context.element) === null || _a === void 0 ? void 0 : _a.getElement((0, $brtTw.idOf)(datum));
            const style = {
                size: size
            };
            this.assignLabelStyle(style, size, datum, element);
            if (!element || !(0, $evi0t.isStyleEqual)(style, element.attributes)) (0, $evi0t.reassignTo)(input, element ? 'update' : 'add', 'node', (0, $iE4so.default)(datum, {
                style: style
            }), true);
        });
        return input;
    }
    assignLabelStyle(style, size, datum, element) {
        var _a;
        const configStyle = element ? element.config.style : (_a = this.context.element) === null || _a === void 0 ? void 0 : _a.getElementComputedStyle('node', datum);
        Object.assign(style, (0, $cyCCc.default)(configStyle, [
            'labelFontSize',
            'labelLineHeight'
        ]));
        if (this.options.mapLabelSize) {
            const fontSize = this.getLabelSizeByNodeSize(size, Infinity, Number(style.labelFontSize));
            Object.assign(style, {
                labelFontSize: fontSize,
                labelLineHeight: fontSize + (0, $1uR12.getVerticalPadding)(style.labelPadding)
            });
        }
        return style;
    }
    getLabelSizeByNodeSize(size, defaultMaxFontSize, defaultMinFontSize) {
        const fontSize = Math.min(...size) / 2;
        const [minFontSize, maxFontSize] = !Array.isArray(this.options.mapLabelSize) ? [
            defaultMinFontSize,
            defaultMaxFontSize
        ] : this.options.mapLabelSize;
        return Math.min(maxFontSize, Math.max(fontSize, minFontSize));
    }
    getCentralities(centrality) {
        const { model: model } = this.context;
        const graphData = model.getData();
        if (typeof centrality === 'function') return centrality(graphData);
        const getRelatedEdgesData = model.getRelatedEdgesData.bind(model);
        return (0, $eASF9.getNodeCentralities)(graphData, getRelatedEdgesData, centrality);
    }
}
$5bc055ed7f35ea70$export$d49e2dc141b77eb6.defaultOptions = {
    centrality: {
        type: 'degree'
    },
    maxSize: 80,
    minSize: 20,
    scale: 'linear',
    mapLabelSize: false
};

});
parcelRegister("88HFs", function(module, exports) {

$parcel$export(module.exports, "linear", () => $5ed0f1956c8163e5$export$45db2fc2f15997e7);
$parcel$export(module.exports, "log", () => $5ed0f1956c8163e5$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "pow", () => $5ed0f1956c8163e5$export$9c297f60e22e3389);
$parcel$export(module.exports, "sqrt", () => $5ed0f1956c8163e5$export$eba8049fb5020b81);
/**
 * <zh/> 将一个值从一个范围线性映射到另一个范围
 *
 * <en/> Linearly maps a value from one range to another range
 * @param value - <zh/> 需要映射的值 | <en/> The value to be mapped
 * @param domain - <zh/> 输入值的范围 [最小值, 最大值] | <en/> The input range [min, max]
 * @param range - <zh/> 输出值的范围 [最小值, 最大值] | <en/> The output range [min, max]
 * @returns <zh/> 映射后的值 | <en/> The mapped value
 */ const $5ed0f1956c8163e5$export$45db2fc2f15997e7 = (value, domain, range)=>{
    const [d0, d1] = domain;
    const [r0, r1] = range;
    if (d1 === d0) return r0;
    const ratio = (value - d0) / (d1 - d0);
    return r0 + ratio * (r1 - r0);
};
const $5ed0f1956c8163e5$export$bef1f36f5486a6a3 = (value, domain, range)=>{
    const [d0, d1] = domain;
    const [r0, r1] = range;
    const ratio = Math.log(value - d0 + 1) / Math.log(d1 - d0 + 1);
    return r0 + ratio * (r1 - r0);
};
const $5ed0f1956c8163e5$export$9c297f60e22e3389 = (value, domain, range, exponent = 2)=>{
    const [d0, d1] = domain;
    const [r0, r1] = range;
    const ratio = Math.pow((value - d0) / (d1 - d0), exponent);
    return r0 + ratio * (r1 - r0);
};
const $5ed0f1956c8163e5$export$eba8049fb5020b81 = (value, domain, range)=>{
    const [d0, d1] = domain;
    const [r0, r1] = range;
    const ratio = Math.sqrt((value - d0) / (d1 - d0));
    return r0 + ratio * (r1 - r0);
};

});


parcelRegister("5EwC3", function(module, exports) {

$parcel$export(module.exports, "PlaceRadialLabels", () => $41d9fc69eb4973ea$export$d7ce83fd5d3cce53);
parcelRequire("cvVku");
var $2eDEB = parcelRequire("2eDEB");

var $brtTw = parcelRequire("brtTw");

var $46bcR = parcelRequire("46bcR");

var $e6Msm = parcelRequire("e6Msm");

var $dOidW = parcelRequire("dOidW");

var $kzVEQ = parcelRequire("kzVEQ");
class $41d9fc69eb4973ea$export$d7ce83fd5d3cce53 extends (0, $kzVEQ.BaseTransform) {
    constructor(context, options){
        super(context, Object.assign({}, $41d9fc69eb4973ea$export$d7ce83fd5d3cce53.defaultOptions, options));
    }
    get ref() {
        return this.context.model.getRootsData()[0];
    }
    afterLayout() {
        var _a;
        const refPoint = (0, $46bcR.positionOf)(this.ref);
        const { graph: graph, model: model } = this.context;
        const data = model.getData();
        (_a = data.nodes) === null || _a === void 0 || _a.forEach((datum)=>{
            var _a;
            if ((0, $brtTw.idOf)(datum) === (0, $brtTw.idOf)(this.ref)) return;
            const radian = (0, $dOidW.rad)((0, $dOidW.subtract)((0, $46bcR.positionOf)(datum), refPoint));
            const isLeft = Math.abs(radian) > Math.PI / 2;
            const isLeaf = !datum.children || datum.children.length === 0;
            const nodeId = (0, $brtTw.idOf)(datum);
            const node = (_a = this.context.element) === null || _a === void 0 ? void 0 : _a.getElement(nodeId);
            if (!node || !node.isVisible()) return;
            const nodeHalfWidth = (0, $e6Msm.parseSize)(graph.getElementRenderStyle(nodeId).size)[0] / 2;
            const offset = (isLeaf ? 1 : -1) * (nodeHalfWidth + this.options.offset);
            const labelTransform = [
                [
                    'translate',
                    offset * Math.cos(radian),
                    offset * Math.sin(radian)
                ],
                [
                    'rotate',
                    isLeft ? (0, $2eDEB.rad2deg)(radian) + 180 : (0, $2eDEB.rad2deg)(radian)
                ]
            ];
            model.updateNodeData([
                {
                    id: (0, $brtTw.idOf)(datum),
                    style: {
                        labelTextAlign: isLeft === isLeaf ? 'right' : 'left',
                        labelTextBaseline: 'middle',
                        labelTransform: labelTransform
                    }
                }
            ]);
        });
        graph.draw();
    }
}
$41d9fc69eb4973ea$export$d7ce83fd5d3cce53.defaultOptions = {
    offset: 5
};

});

parcelRegister("96oLK", function(module, exports) {

$parcel$export(module.exports, "ProcessParallelEdges", () => $6a07e334121e99a2$export$7e9434a83636a841);

var $2LrCM = parcelRequire("2LrCM");
var $hllqz = parcelRequire("hllqz");
var $4ETMA = parcelRequire("4ETMA");
var $ky7aH = parcelRequire("ky7aH");

var $gO13V = parcelRequire("gO13V");

var $brtTw = parcelRequire("brtTw");

var $kzVEQ = parcelRequire("kzVEQ");

var $3ykVL = parcelRequire("3ykVL");

var $evi0t = parcelRequire("evi0t");
const $6a07e334121e99a2$var$CUBIC_EDGE_TYPE = 'quadratic';
const $6a07e334121e99a2$var$CUBIC_LOOP_PLACEMENTS = [
    'top',
    'top-right',
    'right',
    'right-bottom',
    'bottom',
    'bottom-left',
    'left',
    'left-top'
];
class $6a07e334121e99a2$export$7e9434a83636a841 extends (0, $kzVEQ.BaseTransform) {
    constructor(context, options){
        super(context, Object.assign({}, $6a07e334121e99a2$export$7e9434a83636a841.defaultOptions, options));
        this.cacheMergeStyle = new Map();
        /**
         * <zh/> 获取受影响的平行边
         *
         * <en/> Get affected parallel edges
         * @param input
         */ this.getAffectedParallelEdges = (input)=>{
            const { add: { edges: edgesToAdd }, update: { nodes: nodesToUpdate, edges: edgesToUpdate, combos: combosToUpdate }, remove: { edges: edgesToRemove } } = input;
            const { model: model } = this.context;
            const edges = new Map();
            const addRelatedEdges = (_, id)=>{
                const relatedEdgesData = model.getRelatedEdgesData(id);
                relatedEdgesData.forEach((edge)=>!edges.has((0, $brtTw.idOf)(edge)) && edges.set((0, $brtTw.idOf)(edge), edge));
            };
            nodesToUpdate.forEach(addRelatedEdges);
            combosToUpdate.forEach(addRelatedEdges);
            const pushParallelEdges = (edge)=>{
                // 获取已被标记删除的边ID集合
                // Get the set of edge IDs that have been marked for removal
                const removedEdgeIds = new Set(input.remove.edges.keys());
                // 过滤掉已删除的边，避免重定向后重新添加（修复combo收起时内部边变成loop边的问题）
                // Filter out removed edges to prevent them from being re-added after redirection (fixes the issue where internal edges become loop edges when combo collapses)
                const validEdgeData = model.getEdgeData().filter((edge)=>!removedEdgeIds.has((0, $brtTw.idOf)(edge))).map((edge)=>(0, $3ykVL.getEdgeEndsContext)(model, edge));
                // 查找平行边并添加到处理列表，确保只处理有效的边
                // Find parallel edges and add them to the processing list, ensuring only valid edges are processed
                $6a07e334121e99a2$export$87d24010b75bfd55(edge, validEdgeData, true).forEach((e)=>{
                    const id = (0, $brtTw.idOf)(e);
                    if (!edges.has(id)) edges.set(id, e);
                });
            };
            if (edgesToRemove.size) edgesToRemove.forEach(pushParallelEdges);
            if (edgesToAdd.size) edgesToAdd.forEach(pushParallelEdges);
            if (edgesToUpdate.size) {
                const changes = (0, $gO13V.groupByChangeType)((0, $gO13V.reduceDataChanges)(model.getChanges())).update.edges;
                edgesToUpdate.forEach((edge)=>{
                    var _a;
                    pushParallelEdges(edge);
                    // 当边的端点发生变化时，将原始边及其平行边一并添加到更新列表 | Add the original edge and its parallel edges to the update list when the endpoints of the edge change
                    const originalEdge = (_a = changes.find((e)=>(0, $brtTw.idOf)(e.value) === (0, $brtTw.idOf)(edge))) === null || _a === void 0 ? void 0 : _a.original;
                    if (originalEdge && !$6a07e334121e99a2$export$65c3eff8551c6822(edge, originalEdge)) pushParallelEdges(originalEdge);
                });
            }
            if (!(0, $hllqz.default)(this.options.edges)) edges.forEach((_, id)=>!this.options.edges.includes(id) && edges.delete(id));
            // 按照用户指定的顺序排序，防止捆绑时的抖动
            // Sort by user-set order to prevent jitter during bundling
            const edgeIds = model.getEdgeData().map((0, $brtTw.idOf));
            return new Map([
                ...edges
            ].sort((a, b)=>edgeIds.indexOf(a[0]) - edgeIds.indexOf(b[0])));
        };
        this.applyBundlingStyle = (input, edges, distance)=>{
            const { edgeMap: edgeMap, reverses: reverses } = $6a07e334121e99a2$export$f2658b708c5d8fd6(edges);
            edgeMap.forEach((arcEdges)=>{
                arcEdges.forEach((edge, i, edgeArr)=>{
                    var _a;
                    const length = edgeArr.length;
                    const style = edge.style || {};
                    if (edge.source === edge.target) {
                        const len = $6a07e334121e99a2$var$CUBIC_LOOP_PLACEMENTS.length;
                        style.loopPlacement = $6a07e334121e99a2$var$CUBIC_LOOP_PLACEMENTS[i % len];
                        style.loopDist = Math.floor(i / len) * distance + 50;
                    } else if (length === 1) style.curveOffset = 0;
                    else {
                        const sign = (i % 2 === 0 ? 1 : -1) * (reverses[`${edge.source}|${edge.target}|${i}`] ? -1 : 1);
                        style.curveOffset = length % 2 === 1 ? sign * Math.ceil(i / 2) * distance * 2 : sign * (Math.floor(i / 2) * distance * 2 + distance);
                    }
                    const mergedEdgeData = Object.assign(edge, {
                        type: $6a07e334121e99a2$var$CUBIC_EDGE_TYPE,
                        style: style
                    });
                    const element = (_a = this.context.element) === null || _a === void 0 ? void 0 : _a.getElement((0, $brtTw.idOf)(edge));
                    if (!element || !(0, $evi0t.isStyleEqual)(mergedEdgeData.style, element.attributes)) (0, $evi0t.reassignTo)(input, element ? 'update' : 'add', 'edge', mergedEdgeData, true);
                });
            });
        };
        this.resetEdgeStyle = (edge)=>{
            const style = edge.style || {};
            const cacheStyle = this.cacheMergeStyle.get((0, $brtTw.idOf)(edge)) || {};
            Object.keys(cacheStyle).forEach((key)=>{
                if ((0, $4ETMA.default)(style[key], cacheStyle[key])) {
                    if (edge[key]) style[key] = edge[key];
                    else delete style[key];
                }
            });
            return Object.assign(edge, {
                style: style
            });
        };
        this.applyMergingStyle = (input, edges)=>{
            const { edgeMap: edgeMap, reverses: reverses } = $6a07e334121e99a2$export$f2658b708c5d8fd6(edges);
            edgeMap.forEach((edges)=>{
                var _a;
                if (edges.length === 1) {
                    const edge = edges[0];
                    const element = (_a = this.context.element) === null || _a === void 0 ? void 0 : _a.getElement((0, $brtTw.idOf)(edge));
                    const edgeStyle = this.resetEdgeStyle(edge);
                    if (!element || !(0, $evi0t.isStyleEqual)(edgeStyle, element.attributes)) (0, $evi0t.reassignTo)(input, element ? 'update' : 'add', 'edge', edgeStyle);
                    return;
                }
                const mergedStyle = edges.map(({ source: source, target: target, style: style = {} }, i)=>{
                    const { startArrow: startArrow, endArrow: endArrow } = style;
                    const newStyle = {};
                    const [start, end] = reverses[`${source}|${target}|${i}`] ? [
                        'endArrow',
                        'startArrow'
                    ] : [
                        'startArrow',
                        'endArrow'
                    ];
                    if ((0, $2LrCM.default)(startArrow)) newStyle[start] = startArrow;
                    if ((0, $2LrCM.default)(endArrow)) newStyle[end] = endArrow;
                    return newStyle;
                }).reduce((acc, style)=>Object.assign(Object.assign({}, acc), style), {});
                edges.forEach((edge, i, edges)=>{
                    var _a;
                    if (i !== 0) {
                        (0, $evi0t.reassignTo)(input, 'remove', 'edge', edge);
                        return;
                    }
                    const parsedStyle = Object.assign({}, (0, $ky7aH.default)(this.options.style) ? this.options.style(edges) : this.options.style, {
                        childrenData: edges
                    });
                    this.cacheMergeStyle.set((0, $brtTw.idOf)(edge), parsedStyle);
                    const mergedEdgeData = Object.assign(Object.assign({}, edge), {
                        type: 'line',
                        style: Object.assign(Object.assign(Object.assign({}, edge.style), mergedStyle), parsedStyle)
                    });
                    const element = (_a = this.context.element) === null || _a === void 0 ? void 0 : _a.getElement((0, $brtTw.idOf)(edge));
                    if (!element || !(0, $evi0t.isStyleEqual)(mergedEdgeData.style, element.attributes)) (0, $evi0t.reassignTo)(input, element ? 'update' : 'add', 'edge', mergedEdgeData, true);
                });
            });
        };
    }
    /**
     * <zh/> 在每次绘制前处理平行边
     *
     * <en/> Process parallel edges before each drawing
     * @param input
     */ beforeDraw(input) {
        const edges = this.getAffectedParallelEdges(input);
        if (edges.size === 0) return input;
        this.options.mode === 'bundle' ? this.applyBundlingStyle(input, edges, this.options.distance) : this.applyMergingStyle(input, edges);
        return input;
    }
}
$6a07e334121e99a2$export$7e9434a83636a841.defaultOptions = {
    mode: 'bundle',
    distance: 15
};
const $6a07e334121e99a2$export$f2658b708c5d8fd6 = (edges)=>{
    const edgeMap = new Map();
    const processedEdgesSet = new Set();
    const reverses = {};
    const includedEdgesInGroup = new Map();
    for (const [id, edge] of edges){
        if (processedEdgesSet.has(id)) continue;
        const { source: source, target: target } = edge;
        const sourceTarget = `${source}-${target}`;
        if (!edgeMap.has(sourceTarget)) {
            edgeMap.set(sourceTarget, []);
            includedEdgesInGroup.set(sourceTarget, new Set());
        }
        const sourceTargetEdges = edgeMap.get(sourceTarget);
        const includedEdges = includedEdgesInGroup.get(sourceTarget);
        if (sourceTargetEdges && includedEdges && !includedEdges.has(id)) {
            sourceTargetEdges.push(edge);
            includedEdges.add(id);
            processedEdgesSet.add(id);
        }
        for (const [otherId, sedge] of edges){
            if (processedEdgesSet.has(otherId) || otherId === id) continue;
            if ($6a07e334121e99a2$export$65c3eff8551c6822(edge, sedge)) {
                const groupEdges = edgeMap.get(sourceTarget);
                const includedGroupEdges = includedEdgesInGroup.get(sourceTarget);
                if (groupEdges && includedGroupEdges && !includedGroupEdges.has(otherId)) {
                    groupEdges.push(sedge);
                    includedGroupEdges.add(otherId);
                    if (source === sedge.target && target === sedge.source) reverses[`${sedge.source}|${sedge.target}|${groupEdges.length - 1}`] = true;
                    processedEdgesSet.add(otherId);
                }
            }
        }
    }
    return {
        edgeMap: edgeMap,
        reverses: reverses
    };
};
const $6a07e334121e99a2$export$87d24010b75bfd55 = (edge, edges, containsSelf)=>{
    return edges.filter((e)=>(containsSelf || (0, $brtTw.idOf)(e) !== (0, $brtTw.idOf)(edge)) && $6a07e334121e99a2$export$65c3eff8551c6822(e, edge));
};
const $6a07e334121e99a2$export$65c3eff8551c6822 = (edge1, edge2)=>{
    const { sourceNode: src1, targetNode: tgt1 } = edge1.style || {};
    const { sourceNode: src2, targetNode: tgt2 } = edge2.style || {};
    return src1 === src2 && tgt1 === tgt2 || src1 === tgt2 && tgt1 === src2;
};

});

parcelRegister("inULK", function(module, exports) {

$parcel$export(module.exports, "UpdateRelatedEdge", () => $d626691fe52f051b$export$b241b1365d4faf00);

var $brtTw = parcelRequire("brtTw");

var $kzVEQ = parcelRequire("kzVEQ");
class $d626691fe52f051b$export$b241b1365d4faf00 extends (0, $kzVEQ.BaseTransform) {
    beforeDraw(input, context) {
        const { stage: stage } = context;
        if (stage === 'visibility') return input;
        const { model: model } = this.context;
        const { update: { nodes: nodes, edges: edges, combos: combos } } = input;
        const addRelatedEdges = (_, id)=>{
            const relatedEdgesData = model.getRelatedEdgesData(id);
            relatedEdgesData.forEach((edge)=>!edges.has((0, $brtTw.idOf)(edge)) && edges.set((0, $brtTw.idOf)(edge), edge));
        };
        nodes.forEach(addRelatedEdges);
        combos.forEach(addRelatedEdges);
        return input;
    }
}

});





parcelRegister("83ubA", function(module, exports) {

$parcel$export(module.exports, "useGraphStore", () => $465144ff5156b4fc$export$d7bc7ad2072f9aff);

var $i0TKe = parcelRequire("i0TKe");
parcelRequire("cAQvd");
var $7PL6S = parcelRequire("7PL6S");

var $Hm7tz = parcelRequire("Hm7tz");
const $465144ff5156b4fc$export$d7bc7ad2072f9aff = (0, $i0TKe.defineStore)('graph', {
    state: ()=>({
            nodes: [],
            edges: [],
            selectedNodeId: null,
            filters: {
                kinds: [],
                authors: [],
                timeRange: [
                    0,
                    Date.now()
                ]
            }
        }),
    getters: {
        graphData () {
            return {
                nodes: this.nodes,
                edges: this.edges
            };
        },
        nodeCount () {
            return this.nodes.length;
        },
        edgeCount () {
            return this.edges.length;
        },
        selectedNode () {
            return this.nodes.find((n)=>n.id === this.selectedNodeId);
        }
    },
    actions: {
        setGraphData (data) {
            this.nodes = data.nodes;
            this.edges = data.edges;
        },
        addNode (node) {
            const exists = this.nodes.find((n)=>n.id === node.id);
            if (!exists) this.nodes.push(node);
        },
        addEdge (edge) {
            const exists = this.edges.find((e)=>e.source === edge.source && e.target === edge.target);
            if (!exists) this.edges.push(edge);
        },
        removeNode (nodeId) {
            this.nodes = this.nodes.filter((n)=>n.id !== nodeId);
            this.edges = this.edges.filter((e)=>e.source !== nodeId && e.target !== nodeId);
        },
        selectNode (nodeId) {
            this.selectedNodeId = nodeId;
        },
        clearGraph () {
            this.nodes = [];
            this.edges = [];
            this.selectedNodeId = null;
        },
        /**
     * Load all events from IndexedDB and project to graph
     */ async loadFromDatabase () {
            const events = await (0, $7PL6S.getAllEvents)();
            // Apply current filters
            const filtered = (0, $Hm7tz.filterEvents)(events, {
                kinds: this.filters.kinds.length > 0 ? this.filters.kinds : undefined,
                authors: this.filters.authors.length > 0 ? this.filters.authors : undefined,
                timeRange: this.filters.timeRange
            });
            const { nodes: nodes, edges: edges } = (0, $Hm7tz.eventsToGraph)(filtered);
            this.nodes = nodes;
            this.edges = edges;
        },
        /**
     * Load specific event kinds from database
     */ async loadByKind (kinds) {
            const events = await (0, $7PL6S.getEventsByKind)(kinds[0]) // TODO: Support multiple kinds
            ;
            const { nodes: nodes, edges: edges } = (0, $Hm7tz.eventsToGraph)(events);
            this.nodes = nodes;
            this.edges = edges;
        },
        /**
     * Expand a node by loading its connected events
     */ async expandNode (nodeId) {
            // Get events that reference this node
            const references = await (0, $7PL6S.getEventReferences)(nodeId);
            if (references.length > 0) {
                const { nodes: nodes, edges: edges } = (0, $Hm7tz.eventsToGraph)(references);
                // Add new nodes and edges
                nodes.forEach((node)=>this.addNode(node));
                edges.forEach((edge)=>this.addEdge(edge));
            }
        },
        /**
     * Apply filters and reload graph
     */ async applyFilters () {
            await this.loadFromDatabase();
        },
        /**
     * Update graph with new events (for live subscriptions)
     */ updateWithEvents (events) {
            // Pass existing node IDs so edges to existing nodes aren't filtered out
            const existingNodeIds = new Set(this.nodes.map((n)=>n.id));
            const { nodes: nodes, edges: edges } = (0, $Hm7tz.eventsToGraph)(events, existingNodeIds);
            nodes.forEach((node)=>this.addNode(node));
            edges.forEach((edge)=>this.addEdge(edge));
        }
    }
});

});
parcelRegister("i0TKe", function(module, exports) {

$parcel$export(module.exports, "createPinia", () => $52e3354521f75c8c$export$4b9f6a0748623d44);
$parcel$export(module.exports, "defineStore", () => $52e3354521f75c8c$export$5061c4f75bbcb4a);
$parcel$export(module.exports, "storeToRefs", () => $52e3354521f75c8c$export$586af8bd019552de);
/*!
 * pinia v2.3.1
 * (c) 2025 Eduardo San Martin Morote
 * @license MIT
 */ parcelRequire("6TPMk");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $6TPMk = parcelRequire("6TPMk");

var $j6G8F = parcelRequire("j6G8F");
/**
 * setActivePinia must be called to handle SSR at the top of functions like
 * `fetch`, `setup`, `serverPrefetch` and others
 */ let $52e3354521f75c8c$var$activePinia;
/**
 * Sets or unsets the active pinia. Used in SSR and internally when calling
 * actions and getters
 *
 * @param pinia - Pinia instance
 */ // @ts-expect-error: cannot constrain the type of the return
const $52e3354521f75c8c$export$89ffb8149ccd46af = (pinia)=>$52e3354521f75c8c$var$activePinia = pinia;
/**
 * Get the currently active pinia if there is any.
 */ const $52e3354521f75c8c$export$d0cc41ca14a2d060 = ()=>(0, $TusQn.hasInjectionContext)() && (0, $TusQn.inject)($52e3354521f75c8c$var$piniaSymbol) || $52e3354521f75c8c$var$activePinia;
const $52e3354521f75c8c$var$piniaSymbol = /* istanbul ignore next */ Symbol();
function $52e3354521f75c8c$var$isPlainObject(// eslint-disable-next-line @typescript-eslint/no-explicit-any
o) {
    return o && typeof o === 'object' && Object.prototype.toString.call(o) === '[object Object]' && typeof o.toJSON !== 'function';
}
// type DeepReadonly<T> = { readonly [P in keyof T]: DeepReadonly<T[P]> }
// TODO: can we change these to numbers?
/**
 * Possible types for SubscriptionCallback
 */ var $52e3354521f75c8c$export$d97371ba8df8c539;
(function(MutationType) {
    /**
     * Direct mutation of the state:
     *
     * - `store.name = 'new name'`
     * - `store.$state.name = 'new name'`
     * - `store.list.push('new item')`
     */ MutationType["direct"] = "direct";
    /**
     * Mutated the state with `$patch` and an object
     *
     * - `store.$patch({ name: 'newName' })`
     */ MutationType["patchObject"] = "patch object";
    /**
     * Mutated the state with `$patch` and a function
     *
     * - `store.$patch(state => state.name = 'newName')`
     */ MutationType["patchFunction"] = "patch function";
// maybe reset? for $state = {} and $reset
})($52e3354521f75c8c$export$d97371ba8df8c539 || ($52e3354521f75c8c$export$d97371ba8df8c539 = {}));
const $52e3354521f75c8c$var$IS_CLIENT = typeof window !== 'undefined';
/*
 * FileSaver.js A saveAs() FileSaver implementation.
 *
 * Originally by Eli Grey, adapted as an ESM module by Eduardo San Martin
 * Morote.
 *
 * License : MIT
 */ // The one and only way of getting global scope in all environments
// https://stackoverflow.com/q/3277182/1008999
const $52e3354521f75c8c$var$_global = /*#__PURE__*/ (()=>typeof window === 'object' && window.window === window ? window : typeof self === 'object' && self.self === self ? self : typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global ? $parcel$global : typeof globalThis === 'object' ? globalThis : {
        HTMLElement: null
    })();
function $52e3354521f75c8c$var$bom(blob, { autoBom: autoBom = false } = {}) {
    // prepend BOM for UTF-8 XML and text/* types (including HTML)
    // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
    if (autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
        String.fromCharCode(0xfeff),
        blob
    ], {
        type: blob.type
    });
    return blob;
}
function $52e3354521f75c8c$var$download(url, name, opts) {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.onload = function() {
        $52e3354521f75c8c$var$saveAs(xhr.response, name, opts);
    };
    xhr.onerror = function() {
        console.error('could not download file');
    };
    xhr.send();
}
function $52e3354521f75c8c$var$corsEnabled(url) {
    const xhr = new XMLHttpRequest();
    // use sync to avoid popup blocker
    xhr.open('HEAD', url, false);
    try {
        xhr.send();
    } catch (e) {}
    return xhr.status >= 200 && xhr.status <= 299;
}
// `a.click()` doesn't work for all browsers (#465)
function $52e3354521f75c8c$var$click(node) {
    try {
        node.dispatchEvent(new MouseEvent('click'));
    } catch (e) {
        const evt = document.createEvent('MouseEvents');
        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 80, 20, false, false, false, false, 0, null);
        node.dispatchEvent(evt);
    }
}
const $52e3354521f75c8c$var$_navigator = typeof navigator === 'object' ? navigator : {
    userAgent: ''
};
// Detect WebView inside a native macOS app by ruling out all browsers
// We just need to check for 'Safari' because all other browsers (besides Firefox) include that too
// https://www.whatismybrowser.com/guides/the-latest-user-agent/macos
const $52e3354521f75c8c$var$isMacOSWebView = /*#__PURE__*/ (()=>/Macintosh/.test($52e3354521f75c8c$var$_navigator.userAgent) && /AppleWebKit/.test($52e3354521f75c8c$var$_navigator.userAgent) && !/Safari/.test($52e3354521f75c8c$var$_navigator.userAgent))();
const $52e3354521f75c8c$var$saveAs = !$52e3354521f75c8c$var$IS_CLIENT ? ()=>{} // noop
 : typeof HTMLAnchorElement !== 'undefined' && 'download' in HTMLAnchorElement.prototype && !$52e3354521f75c8c$var$isMacOSWebView ? $52e3354521f75c8c$var$downloadSaveAs : 'msSaveOrOpenBlob' in $52e3354521f75c8c$var$_navigator ? $52e3354521f75c8c$var$msSaveAs : $52e3354521f75c8c$var$fileSaverSaveAs;
function $52e3354521f75c8c$var$downloadSaveAs(blob, name = 'download', opts) {
    const a = document.createElement('a');
    a.download = name;
    a.rel = 'noopener'; // tabnabbing
    // TODO: detect chrome extensions & packaged apps
    // a.target = '_blank'
    if (typeof blob === 'string') {
        // Support regular links
        a.href = blob;
        if (a.origin !== location.origin) {
            if ($52e3354521f75c8c$var$corsEnabled(a.href)) $52e3354521f75c8c$var$download(blob, name, opts);
            else {
                a.target = '_blank';
                $52e3354521f75c8c$var$click(a);
            }
        } else $52e3354521f75c8c$var$click(a);
    } else {
        // Support blobs
        a.href = URL.createObjectURL(blob);
        setTimeout(function() {
            URL.revokeObjectURL(a.href);
        }, 4e4); // 40s
        setTimeout(function() {
            $52e3354521f75c8c$var$click(a);
        }, 0);
    }
}
function $52e3354521f75c8c$var$msSaveAs(blob, name = 'download', opts) {
    if (typeof blob === 'string') {
        if ($52e3354521f75c8c$var$corsEnabled(blob)) $52e3354521f75c8c$var$download(blob, name, opts);
        else {
            const a = document.createElement('a');
            a.href = blob;
            a.target = '_blank';
            setTimeout(function() {
                $52e3354521f75c8c$var$click(a);
            });
        }
    } else // @ts-ignore: works on windows
    navigator.msSaveOrOpenBlob($52e3354521f75c8c$var$bom(blob, opts), name);
}
function $52e3354521f75c8c$var$fileSaverSaveAs(blob, name, opts, popup) {
    // Open a popup immediately do go around popup blocker
    // Mostly only available on user interaction and the fileReader is async so...
    popup = popup || open('', '_blank');
    if (popup) popup.document.title = popup.document.body.innerText = 'downloading...';
    if (typeof blob === 'string') return $52e3354521f75c8c$var$download(blob, name, opts);
    const force = blob.type === 'application/octet-stream';
    const isSafari = /constructor/i.test(String($52e3354521f75c8c$var$_global.HTMLElement)) || 'safari' in $52e3354521f75c8c$var$_global;
    const isChromeIOS = /CriOS\/[\d]+/.test(navigator.userAgent);
    if ((isChromeIOS || force && isSafari || $52e3354521f75c8c$var$isMacOSWebView) && typeof FileReader !== 'undefined') {
        // Safari doesn't allow downloading of blob URLs
        const reader = new FileReader();
        reader.onloadend = function() {
            let url = reader.result;
            if (typeof url !== 'string') {
                popup = null;
                throw new Error('Wrong reader.result type');
            }
            url = isChromeIOS ? url : url.replace(/^data:[^;]*;/, 'data:attachment/file;');
            if (popup) popup.location.href = url;
            else location.assign(url);
            popup = null; // reverse-tabnabbing #460
        };
        reader.readAsDataURL(blob);
    } else {
        const url = URL.createObjectURL(blob);
        if (popup) popup.location.assign(url);
        else location.href = url;
        popup = null; // reverse-tabnabbing #460
        setTimeout(function() {
            URL.revokeObjectURL(url);
        }, 4e4); // 40s
    }
}
/**
 * Shows a toast or console.log
 *
 * @param message - message to log
 * @param type - different color of the tooltip
 */ function $52e3354521f75c8c$var$toastMessage(message, type) {
    const piniaMessage = "\uD83C\uDF4D " + message;
    if (typeof __VUE_DEVTOOLS_TOAST__ === 'function') // No longer available :(
    __VUE_DEVTOOLS_TOAST__(piniaMessage, type);
    else if (type === 'error') console.error(piniaMessage);
    else if (type === 'warn') console.warn(piniaMessage);
    else console.log(piniaMessage);
}
function $52e3354521f75c8c$var$isPinia(o) {
    return '_a' in o && 'install' in o;
}
/**
 * This file contain devtools actions, they are not Pinia actions.
 */ // ---
function $52e3354521f75c8c$var$checkClipboardAccess() {
    if (!('clipboard' in navigator)) {
        $52e3354521f75c8c$var$toastMessage(`Your browser doesn't support the Clipboard API`, 'error');
        return true;
    }
}
function $52e3354521f75c8c$var$checkNotFocusedError(error) {
    if (error instanceof Error && error.message.toLowerCase().includes('document is not focused')) {
        $52e3354521f75c8c$var$toastMessage('You need to activate the "Emulate a focused page" setting in the "Rendering" panel of devtools.', 'warn');
        return true;
    }
    return false;
}
async function $52e3354521f75c8c$var$actionGlobalCopyState(pinia) {
    if ($52e3354521f75c8c$var$checkClipboardAccess()) return;
    try {
        await navigator.clipboard.writeText(JSON.stringify(pinia.state.value));
        $52e3354521f75c8c$var$toastMessage('Global state copied to clipboard.');
    } catch (error) {
        if ($52e3354521f75c8c$var$checkNotFocusedError(error)) return;
        $52e3354521f75c8c$var$toastMessage(`Failed to serialize the state. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function $52e3354521f75c8c$var$actionGlobalPasteState(pinia) {
    if ($52e3354521f75c8c$var$checkClipboardAccess()) return;
    try {
        $52e3354521f75c8c$var$loadStoresState(pinia, JSON.parse(await navigator.clipboard.readText()));
        $52e3354521f75c8c$var$toastMessage('Global state pasted from clipboard.');
    } catch (error) {
        if ($52e3354521f75c8c$var$checkNotFocusedError(error)) return;
        $52e3354521f75c8c$var$toastMessage(`Failed to deserialize the state from clipboard. Check the console for more details.`, 'error');
        console.error(error);
    }
}
async function $52e3354521f75c8c$var$actionGlobalSaveState(pinia) {
    try {
        $52e3354521f75c8c$var$saveAs(new Blob([
            JSON.stringify(pinia.state.value)
        ], {
            type: 'text/plain;charset=utf-8'
        }), 'pinia-state.json');
    } catch (error) {
        $52e3354521f75c8c$var$toastMessage(`Failed to export the state as JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
let $52e3354521f75c8c$var$fileInput;
function $52e3354521f75c8c$var$getFileOpener() {
    if (!$52e3354521f75c8c$var$fileInput) {
        $52e3354521f75c8c$var$fileInput = document.createElement('input');
        $52e3354521f75c8c$var$fileInput.type = 'file';
        $52e3354521f75c8c$var$fileInput.accept = '.json';
    }
    function openFile() {
        return new Promise((resolve, reject)=>{
            $52e3354521f75c8c$var$fileInput.onchange = async ()=>{
                const files = $52e3354521f75c8c$var$fileInput.files;
                if (!files) return resolve(null);
                const file = files.item(0);
                if (!file) return resolve(null);
                return resolve({
                    text: await file.text(),
                    file: file
                });
            };
            // @ts-ignore: TODO: changed from 4.3 to 4.4
            $52e3354521f75c8c$var$fileInput.oncancel = ()=>resolve(null);
            $52e3354521f75c8c$var$fileInput.onerror = reject;
            $52e3354521f75c8c$var$fileInput.click();
        });
    }
    return openFile;
}
async function $52e3354521f75c8c$var$actionGlobalOpenStateFile(pinia) {
    try {
        const open1 = $52e3354521f75c8c$var$getFileOpener();
        const result = await open1();
        if (!result) return;
        const { text: text, file: file } = result;
        $52e3354521f75c8c$var$loadStoresState(pinia, JSON.parse(text));
        $52e3354521f75c8c$var$toastMessage(`Global state imported from "${file.name}".`);
    } catch (error) {
        $52e3354521f75c8c$var$toastMessage(`Failed to import the state from JSON. Check the console for more details.`, 'error');
        console.error(error);
    }
}
function $52e3354521f75c8c$var$loadStoresState(pinia, state) {
    for(const key in state){
        const storeState = pinia.state.value[key];
        // store is already instantiated, patch it
        if (storeState) Object.assign(storeState, state[key]);
        else // store is not instantiated, set the initial state
        pinia.state.value[key] = state[key];
    }
}
function $52e3354521f75c8c$var$formatDisplay(display) {
    return {
        _custom: {
            display: display
        }
    };
}
const $52e3354521f75c8c$var$PINIA_ROOT_LABEL = "\uD83C\uDF4D Pinia (root)";
const $52e3354521f75c8c$var$PINIA_ROOT_ID = '_root';
function $52e3354521f75c8c$var$formatStoreForInspectorTree(store) {
    return $52e3354521f75c8c$var$isPinia(store) ? {
        id: $52e3354521f75c8c$var$PINIA_ROOT_ID,
        label: $52e3354521f75c8c$var$PINIA_ROOT_LABEL
    } : {
        id: store.$id,
        label: store.$id
    };
}
function $52e3354521f75c8c$var$formatStoreForInspectorState(store) {
    if ($52e3354521f75c8c$var$isPinia(store)) {
        const storeNames = Array.from(store._s.keys());
        const storeMap = store._s;
        const state = {
            state: storeNames.map((storeId)=>({
                    editable: true,
                    key: storeId,
                    value: store.state.value[storeId]
                })),
            getters: storeNames.filter((id)=>storeMap.get(id)._getters).map((id)=>{
                const store = storeMap.get(id);
                return {
                    editable: false,
                    key: id,
                    value: store._getters.reduce((getters, key)=>{
                        getters[key] = store[key];
                        return getters;
                    }, {})
                };
            })
        };
        return state;
    }
    const state = {
        state: Object.keys(store.$state).map((key)=>({
                editable: true,
                key: key,
                value: store.$state[key]
            }))
    };
    // avoid adding empty getters
    if (store._getters && store._getters.length) state.getters = store._getters.map((getterName)=>({
            editable: false,
            key: getterName,
            value: store[getterName]
        }));
    if (store._customProperties.size) state.customProperties = Array.from(store._customProperties).map((key)=>({
            editable: true,
            key: key,
            value: store[key]
        }));
    return state;
}
function $52e3354521f75c8c$var$formatEventData(events) {
    if (!events) return {};
    if (Array.isArray(events)) // TODO: handle add and delete for arrays and objects
    return events.reduce((data, event)=>{
        data.keys.push(event.key);
        data.operations.push(event.type);
        data.oldValue[event.key] = event.oldValue;
        data.newValue[event.key] = event.newValue;
        return data;
    }, {
        oldValue: {},
        keys: [],
        operations: [],
        newValue: {}
    });
    else return {
        operation: $52e3354521f75c8c$var$formatDisplay(events.type),
        key: $52e3354521f75c8c$var$formatDisplay(events.key),
        oldValue: events.oldValue,
        newValue: events.newValue
    };
}
function $52e3354521f75c8c$var$formatMutationType(type) {
    switch(type){
        case $52e3354521f75c8c$export$d97371ba8df8c539.direct:
            return 'mutation';
        case $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction:
            return '$patch';
        case $52e3354521f75c8c$export$d97371ba8df8c539.patchObject:
            return '$patch';
        default:
            return 'unknown';
    }
}
// timeline can be paused when directly changing the state
let $52e3354521f75c8c$var$isTimelineActive = true;
const $52e3354521f75c8c$var$componentStateTypes = [];
const $52e3354521f75c8c$var$MUTATIONS_LAYER_ID = 'pinia:mutations';
const $52e3354521f75c8c$var$INSPECTOR_ID = 'pinia';
const { assign: $52e3354521f75c8c$var$assign$1 } = Object;
/**
 * Gets the displayed name of a store in devtools
 *
 * @param id - id of the store
 * @returns a formatted string
 */ const $52e3354521f75c8c$var$getStoreType = (id)=>"\uD83C\uDF4D " + id;
/**
 * Add the pinia plugin without any store. Allows displaying a Pinia plugin tab
 * as soon as it is added to the application.
 *
 * @param app - Vue application
 * @param pinia - pinia instance
 */ function $52e3354521f75c8c$var$registerPiniaDevtools(app, pinia) {
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: 'dev.esm.pinia',
        label: "Pinia \uD83C\uDF4D",
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: $52e3354521f75c8c$var$componentStateTypes,
        app: app
    }, (api)=>{
        if (typeof api.now !== 'function') $52e3354521f75c8c$var$toastMessage('You seem to be using an outdated version of Vue Devtools. Are you still using the Beta release instead of the stable one? You can find the links at https://devtools.vuejs.org/guide/installation.html.');
        api.addTimelineLayer({
            id: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
            label: `Pinia \u{1F34D}`,
            color: 0xe5df88
        });
        api.addInspector({
            id: $52e3354521f75c8c$var$INSPECTOR_ID,
            label: "Pinia \uD83C\uDF4D",
            icon: 'storage',
            treeFilterPlaceholder: 'Search stores',
            actions: [
                {
                    icon: 'content_copy',
                    action: ()=>{
                        $52e3354521f75c8c$var$actionGlobalCopyState(pinia);
                    },
                    tooltip: 'Serialize and copy the state'
                },
                {
                    icon: 'content_paste',
                    action: async ()=>{
                        await $52e3354521f75c8c$var$actionGlobalPasteState(pinia);
                        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
                        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                    },
                    tooltip: 'Replace the state with the content of your clipboard'
                },
                {
                    icon: 'save',
                    action: ()=>{
                        $52e3354521f75c8c$var$actionGlobalSaveState(pinia);
                    },
                    tooltip: 'Save the state as a JSON file'
                },
                {
                    icon: 'folder_open',
                    action: async ()=>{
                        await $52e3354521f75c8c$var$actionGlobalOpenStateFile(pinia);
                        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
                        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                    },
                    tooltip: 'Import the state from a JSON file'
                }
            ],
            nodeActions: [
                {
                    icon: 'restore',
                    tooltip: 'Reset the state (with "$reset")',
                    action: (nodeId)=>{
                        const store = pinia._s.get(nodeId);
                        if (!store) $52e3354521f75c8c$var$toastMessage(`Cannot reset "${nodeId}" store because it wasn't found.`, 'warn');
                        else if (typeof store.$reset !== 'function') $52e3354521f75c8c$var$toastMessage(`Cannot reset "${nodeId}" store because it doesn't have a "$reset" method implemented.`, 'warn');
                        else {
                            store.$reset();
                            $52e3354521f75c8c$var$toastMessage(`Store "${nodeId}" reset.`);
                        }
                    }
                }
            ]
        });
        api.on.inspectComponent((payload, ctx)=>{
            const proxy = payload.componentInstance && payload.componentInstance.proxy;
            if (proxy && proxy._pStores) {
                const piniaStores = payload.componentInstance.proxy._pStores;
                Object.values(piniaStores).forEach((store)=>{
                    payload.instanceData.state.push({
                        type: $52e3354521f75c8c$var$getStoreType(store.$id),
                        key: 'state',
                        editable: true,
                        value: store._isOptionsAPI ? {
                            _custom: {
                                value: (0, $01W3b.toRaw)(store.$state),
                                actions: [
                                    {
                                        icon: 'restore',
                                        tooltip: 'Reset the state of this store',
                                        action: ()=>store.$reset()
                                    }
                                ]
                            }
                        } : Object.keys(store.$state).reduce((state, key)=>{
                            state[key] = store.$state[key];
                            return state;
                        }, {})
                    });
                    if (store._getters && store._getters.length) payload.instanceData.state.push({
                        type: $52e3354521f75c8c$var$getStoreType(store.$id),
                        key: 'getters',
                        editable: false,
                        value: store._getters.reduce((getters, key)=>{
                            try {
                                getters[key] = store[key];
                            } catch (error) {
                                // @ts-expect-error: we just want to show it in devtools
                                getters[key] = error;
                            }
                            return getters;
                        }, {})
                    });
                });
            }
        });
        api.on.getInspectorTree((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                let stores = [
                    pinia
                ];
                stores = stores.concat(Array.from(pinia._s.values()));
                payload.rootNodes = (payload.filter ? stores.filter((store)=>'$id' in store ? store.$id.toLowerCase().includes(payload.filter.toLowerCase()) : $52e3354521f75c8c$var$PINIA_ROOT_LABEL.toLowerCase().includes(payload.filter.toLowerCase())) : stores).map($52e3354521f75c8c$var$formatStoreForInspectorTree);
            }
        });
        // Expose pinia instance as $pinia to window
        globalThis.$pinia = pinia;
        api.on.getInspectorState((payload)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $52e3354521f75c8c$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) // this could be the selected store restored for a different project
                // so it's better not to say anything here
                return;
                if (inspectedStore) {
                    // Expose selected store as $store to window
                    if (payload.nodeId !== $52e3354521f75c8c$var$PINIA_ROOT_ID) globalThis.$store = (0, $01W3b.toRaw)(inspectedStore);
                    payload.state = $52e3354521f75c8c$var$formatStoreForInspectorState(inspectedStore);
                }
            }
        });
        api.on.editInspectorState((payload, ctx)=>{
            if (payload.app === app && payload.inspectorId === $52e3354521f75c8c$var$INSPECTOR_ID) {
                const inspectedStore = payload.nodeId === $52e3354521f75c8c$var$PINIA_ROOT_ID ? pinia : pinia._s.get(payload.nodeId);
                if (!inspectedStore) return $52e3354521f75c8c$var$toastMessage(`store "${payload.nodeId}" not found`, 'error');
                const { path: path } = payload;
                if (!$52e3354521f75c8c$var$isPinia(inspectedStore)) // access only the state
                {
                    if (path.length !== 1 || !inspectedStore._customProperties.has(path[0]) || path[0] in inspectedStore.$state) path.unshift('$state');
                } else // Root access, we can omit the `.value` because the devtools API does it for us
                path.unshift('state');
                $52e3354521f75c8c$var$isTimelineActive = false;
                payload.set(inspectedStore, path, payload.state.value);
                $52e3354521f75c8c$var$isTimelineActive = true;
            }
        });
        api.on.editComponentState((payload)=>{
            if (payload.type.startsWith("\uD83C\uDF4D")) {
                const storeId = payload.type.replace(/^🍍\s*/, '');
                const store = pinia._s.get(storeId);
                if (!store) return $52e3354521f75c8c$var$toastMessage(`store "${storeId}" not found`, 'error');
                const { path: path } = payload;
                if (path[0] !== 'state') return $52e3354521f75c8c$var$toastMessage(`Invalid path for store "${storeId}":\n${path}\nOnly state can be modified.`);
                // rewrite the first entry to be able to directly set the state as
                // well as any other path
                path[0] = '$state';
                $52e3354521f75c8c$var$isTimelineActive = false;
                payload.set(store, path, payload.state.value);
                $52e3354521f75c8c$var$isTimelineActive = true;
            }
        });
    });
}
function $52e3354521f75c8c$var$addStoreToDevtools(app, store) {
    if (!$52e3354521f75c8c$var$componentStateTypes.includes($52e3354521f75c8c$var$getStoreType(store.$id))) $52e3354521f75c8c$var$componentStateTypes.push($52e3354521f75c8c$var$getStoreType(store.$id));
    (0, $j6G8F.setupDevtoolsPlugin)({
        id: 'dev.esm.pinia',
        label: "Pinia \uD83C\uDF4D",
        logo: 'https://pinia.vuejs.org/logo.svg',
        packageName: 'pinia',
        homepage: 'https://pinia.vuejs.org',
        componentStateTypes: $52e3354521f75c8c$var$componentStateTypes,
        app: app,
        settings: {
            logStoreChanges: {
                label: 'Notify about new/deleted stores',
                type: 'boolean',
                defaultValue: true
            }
        }
    }, (api)=>{
        // gracefully handle errors
        const now = typeof api.now === 'function' ? api.now.bind(api) : Date.now;
        store.$onAction(({ after: after, onError: onError, name: name, args: args })=>{
            const groupId = $52e3354521f75c8c$var$runningActionId++;
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDEEB " + name,
                    subtitle: 'start',
                    data: {
                        store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                        action: $52e3354521f75c8c$var$formatDisplay(name),
                        args: args
                    },
                    groupId: groupId
                }
            });
            after((result)=>{
                $52e3354521f75c8c$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: "\uD83D\uDEEC " + name,
                        subtitle: 'end',
                        data: {
                            store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                            action: $52e3354521f75c8c$var$formatDisplay(name),
                            args: args,
                            result: result
                        },
                        groupId: groupId
                    }
                });
            });
            onError((error)=>{
                $52e3354521f75c8c$var$activeAction = undefined;
                api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        logType: 'error',
                        title: "\uD83D\uDCA5 " + name,
                        subtitle: 'end',
                        data: {
                            store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                            action: $52e3354521f75c8c$var$formatDisplay(name),
                            args: args,
                            error: error
                        },
                        groupId: groupId
                    }
                });
            });
        }, true);
        store._customProperties.forEach((name)=>{
            (0, $01W3b.watch)(()=>(0, $01W3b.unref)(store[name]), (newValue, oldValue)=>{
                api.notifyComponentUpdate();
                api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
                if ($52e3354521f75c8c$var$isTimelineActive) api.addTimelineEvent({
                    layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                    event: {
                        time: now(),
                        title: 'Change',
                        subtitle: name,
                        data: {
                            newValue: newValue,
                            oldValue: oldValue
                        },
                        groupId: $52e3354521f75c8c$var$activeAction
                    }
                });
            }, {
                deep: true
            });
        });
        store.$subscribe(({ events: events, type: type }, state)=>{
            api.notifyComponentUpdate();
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
            if (!$52e3354521f75c8c$var$isTimelineActive) return;
            // rootStore.state[store.id] = state
            const eventData = {
                time: now(),
                title: $52e3354521f75c8c$var$formatMutationType(type),
                data: $52e3354521f75c8c$var$assign$1({
                    store: $52e3354521f75c8c$var$formatDisplay(store.$id)
                }, $52e3354521f75c8c$var$formatEventData(events)),
                groupId: $52e3354521f75c8c$var$activeAction
            };
            if (type === $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction) eventData.subtitle = "\u2935\uFE0F";
            else if (type === $52e3354521f75c8c$export$d97371ba8df8c539.patchObject) eventData.subtitle = "\uD83E\uDDE9";
            else if (events && !Array.isArray(events)) eventData.subtitle = events.type;
            if (events) eventData.data['rawEvent(s)'] = {
                _custom: {
                    display: 'DebuggerEvent',
                    type: 'object',
                    tooltip: 'raw DebuggerEvent[]',
                    value: events
                }
            };
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: eventData
            });
        }, {
            detached: true,
            flush: 'sync'
        });
        const hotUpdate = store._hotUpdate;
        store._hotUpdate = (0, $01W3b.markRaw)((newStore)=>{
            hotUpdate(newStore);
            api.addTimelineEvent({
                layerId: $52e3354521f75c8c$var$MUTATIONS_LAYER_ID,
                event: {
                    time: now(),
                    title: "\uD83D\uDD25 " + store.$id,
                    subtitle: 'HMR update',
                    data: {
                        store: $52e3354521f75c8c$var$formatDisplay(store.$id),
                        info: $52e3354521f75c8c$var$formatDisplay(`HMR update`)
                    }
                }
            });
            // update the devtools too
            api.notifyComponentUpdate();
            api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
        });
        const { $dispose: $dispose } = store;
        store.$dispose = ()=>{
            $dispose();
            api.notifyComponentUpdate();
            api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
            api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
            api.getSettings().logStoreChanges && $52e3354521f75c8c$var$toastMessage(`Disposed "${store.$id}" store \u{1F5D1}`);
        };
        // trigger an update so it can display new registered stores
        api.notifyComponentUpdate();
        api.sendInspectorTree($52e3354521f75c8c$var$INSPECTOR_ID);
        api.sendInspectorState($52e3354521f75c8c$var$INSPECTOR_ID);
        api.getSettings().logStoreChanges && $52e3354521f75c8c$var$toastMessage(`"${store.$id}" store installed \u{1F195}`);
    });
}
let $52e3354521f75c8c$var$runningActionId = 0;
let $52e3354521f75c8c$var$activeAction;
/**
 * Patches a store to enable action grouping in devtools by wrapping the store with a Proxy that is passed as the
 * context of all actions, allowing us to set `runningAction` on each access and effectively associating any state
 * mutation to the action.
 *
 * @param store - store to patch
 * @param actionNames - list of actionst to patch
 */ function $52e3354521f75c8c$var$patchActionForGrouping(store, actionNames, wrapWithProxy) {
    // original actions of the store as they are given by pinia. We are going to override them
    const actions = actionNames.reduce((storeActions, actionName)=>{
        // use toRaw to avoid tracking #541
        storeActions[actionName] = (0, $01W3b.toRaw)(store)[actionName];
        return storeActions;
    }, {});
    for(const actionName in actions)store[actionName] = function() {
        // the running action id is incremented in a before action hook
        const _actionId = $52e3354521f75c8c$var$runningActionId;
        const trackedStore = wrapWithProxy ? new Proxy(store, {
            get (...args) {
                $52e3354521f75c8c$var$activeAction = _actionId;
                return Reflect.get(...args);
            },
            set (...args) {
                $52e3354521f75c8c$var$activeAction = _actionId;
                return Reflect.set(...args);
            }
        }) : store;
        // For Setup Stores we need https://github.com/tc39/proposal-async-context
        $52e3354521f75c8c$var$activeAction = _actionId;
        const retValue = actions[actionName].apply(trackedStore, arguments);
        // this is safer as async actions in Setup Stores would associate mutations done outside of the action
        $52e3354521f75c8c$var$activeAction = undefined;
        return retValue;
    };
}
/**
 * pinia.use(devtoolsPlugin)
 */ function $52e3354521f75c8c$var$devtoolsPlugin({ app: app, store: store, options: options }) {
    // HMR module
    if (store.$id.startsWith('__hot:')) return;
    // detect option api vs setup api
    store._isOptionsAPI = !!options.state;
    // Do not overwrite actions mocked by @pinia/testing (#2298)
    if (!store._p._testing) {
        $52e3354521f75c8c$var$patchActionForGrouping(store, Object.keys(options.actions), store._isOptionsAPI);
        // Upgrade the HMR to also update the new actions
        const originalHotUpdate = store._hotUpdate;
        (0, $01W3b.toRaw)(store)._hotUpdate = function(newStore) {
            originalHotUpdate.apply(this, arguments);
            $52e3354521f75c8c$var$patchActionForGrouping(store, Object.keys(newStore._hmrPayload.actions), !!store._isOptionsAPI);
        };
    }
    $52e3354521f75c8c$var$addStoreToDevtools(app, // FIXME: is there a way to allow the assignment from Store<Id, S, G, A> to StoreGeneric?
    store);
}
/**
 * Creates a Pinia instance to be used by the application
 */ function $52e3354521f75c8c$export$4b9f6a0748623d44() {
    const scope = (0, $01W3b.effectScope)(true);
    // NOTE: here we could check the window object for a state and directly set it
    // if there is anything like it with Vue 3 SSR
    const state = scope.run(()=>(0, $01W3b.ref)({}));
    let _p = [];
    // plugins added before calling app.use(pinia)
    let toBeInstalled = [];
    const pinia = (0, $01W3b.markRaw)({
        install (app) {
            // this allows calling useStore() outside of a component setup after
            // installing pinia's plugin
            $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
            if (!(0, $6TPMk.isVue2)) {
                pinia._a = app;
                app.provide($52e3354521f75c8c$var$piniaSymbol, pinia);
                app.config.globalProperties.$pinia = pinia;
                /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) $52e3354521f75c8c$var$registerPiniaDevtools(app, pinia);
                toBeInstalled.forEach((plugin)=>_p.push(plugin));
                toBeInstalled = [];
            }
        },
        use (plugin) {
            if (!this._a && !(0, $6TPMk.isVue2)) toBeInstalled.push(plugin);
            else _p.push(plugin);
            return this;
        },
        _p: _p,
        // it's actually undefined here
        // @ts-expect-error
        _a: null,
        _e: scope,
        _s: new Map(),
        state: state
    });
    // pinia devtools rely on dev only features so they cannot be forced unless
    // the dev build of Vue is used. Avoid old browsers like IE11.
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT && typeof Proxy !== 'undefined') pinia.use($52e3354521f75c8c$var$devtoolsPlugin);
    return pinia;
}
/**
 * Dispose a Pinia instance by stopping its effectScope and removing the state, plugins and stores. This is mostly
 * useful in tests, with both a testing pinia or a regular pinia and in applications that use multiple pinia instances.
 * Once disposed, the pinia instance cannot be used anymore.
 *
 * @param pinia - pinia instance
 */ function $52e3354521f75c8c$export$75b0179c67a9344e(pinia) {
    pinia._e.stop();
    pinia._s.clear();
    pinia._p.splice(0);
    pinia.state.value = {};
    // @ts-expect-error: non valid
    pinia._a = null;
}
/**
 * Checks if a function is a `StoreDefinition`.
 *
 * @param fn - object to test
 * @returns true if `fn` is a StoreDefinition
 */ const $52e3354521f75c8c$var$isUseStore = (fn)=>{
    return typeof fn === 'function' && typeof fn.$id === 'string';
};
/**
 * Mutates in place `newState` with `oldState` to _hot update_ it. It will
 * remove any key not existing in `newState` and recursively merge plain
 * objects.
 *
 * @param newState - new state object to be patched
 * @param oldState - old state that should be used to patch newState
 * @returns - newState
 */ function $52e3354521f75c8c$var$patchObject(newState, oldState) {
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in oldState){
        const subPatch = oldState[key];
        // skip the whole sub tree
        if (!(key in newState)) continue;
        const targetValue = newState[key];
        if ($52e3354521f75c8c$var$isPlainObject(targetValue) && $52e3354521f75c8c$var$isPlainObject(subPatch) && !(0, $01W3b.isRef)(subPatch) && !(0, $01W3b.isReactive)(subPatch)) newState[key] = $52e3354521f75c8c$var$patchObject(targetValue, subPatch);
        else // objects are either a bit more complex (e.g. refs) or primitives, so we
        // just set the whole thing
        if (0, $6TPMk.isVue2) (0, $6TPMk.set)(newState, key, subPatch);
        else newState[key] = subPatch;
    }
    return newState;
}
/**
 * Creates an _accept_ function to pass to `import.meta.hot` in Vite applications.
 *
 * @example
 * ```js
 * const useUser = defineStore(...)
 * if (import.meta.hot) {
 *   import.meta.hot.accept(acceptHMRUpdate(useUser, import.meta.hot))
 * }
 * ```
 *
 * @param initialUseStore - return of the defineStore to hot update
 * @param hot - `import.meta.hot`
 */ function $52e3354521f75c8c$export$d3530ca2abd36d5e(initialUseStore, hot) {
    var newModule;
    return ()=>{};
}
const $52e3354521f75c8c$var$noop = ()=>{};
function $52e3354521f75c8c$var$addSubscription(subscriptions, callback, detached, onCleanup = $52e3354521f75c8c$var$noop) {
    subscriptions.push(callback);
    const removeSubscription = ()=>{
        const idx = subscriptions.indexOf(callback);
        if (idx > -1) {
            subscriptions.splice(idx, 1);
            onCleanup();
        }
    };
    if (!detached && (0, $01W3b.getCurrentScope)()) (0, $01W3b.onScopeDispose)(removeSubscription);
    return removeSubscription;
}
function $52e3354521f75c8c$var$triggerSubscriptions(subscriptions, ...args) {
    subscriptions.slice().forEach((callback)=>{
        callback(...args);
    });
}
const $52e3354521f75c8c$var$fallbackRunWithContext = (fn)=>fn();
/**
 * Marks a function as an action for `$onAction`
 * @internal
 */ const $52e3354521f75c8c$var$ACTION_MARKER = Symbol();
/**
 * Action name symbol. Allows to add a name to an action after defining it
 * @internal
 */ const $52e3354521f75c8c$var$ACTION_NAME = Symbol();
function $52e3354521f75c8c$var$mergeReactiveObjects(target, patchToApply) {
    // Handle Map instances
    if (target instanceof Map && patchToApply instanceof Map) patchToApply.forEach((value, key)=>target.set(key, value));
    else if (target instanceof Set && patchToApply instanceof Set) // Handle Set instances
    patchToApply.forEach(target.add, target);
    // no need to go through symbols because they cannot be serialized anyway
    for(const key in patchToApply){
        if (!patchToApply.hasOwnProperty(key)) continue;
        const subPatch = patchToApply[key];
        const targetValue = target[key];
        if ($52e3354521f75c8c$var$isPlainObject(targetValue) && $52e3354521f75c8c$var$isPlainObject(subPatch) && target.hasOwnProperty(key) && !(0, $01W3b.isRef)(subPatch) && !(0, $01W3b.isReactive)(subPatch)) // NOTE: here I wanted to warn about inconsistent types but it's not possible because in setup stores one might
        // start the value of a property as a certain type e.g. a Map, and then for some reason, during SSR, change that
        // to `undefined`. When trying to hydrate, we want to override the Map with `undefined`.
        target[key] = $52e3354521f75c8c$var$mergeReactiveObjects(targetValue, subPatch);
        else // @ts-expect-error: subPatch is a valid value
        target[key] = subPatch;
    }
    return target;
}
const $52e3354521f75c8c$var$skipHydrateSymbol = /* istanbul ignore next */ Symbol();
/**
 * Tells Pinia to skip the hydration process of a given object. This is useful in setup stores (only) when you return a
 * stateful object in the store but it isn't really state. e.g. returning a router instance in a setup store.
 *
 * @param obj - target object
 * @returns obj
 */ function $52e3354521f75c8c$export$dbb88672ab248e88(obj) {
    return Object.defineProperty(obj, $52e3354521f75c8c$var$skipHydrateSymbol, {});
}
/**
 * Returns whether a value should be hydrated
 *
 * @param obj - target variable
 * @returns true if `obj` should be hydrated
 */ function $52e3354521f75c8c$export$bdc3d2e33d3136e5(obj) {
    return !$52e3354521f75c8c$var$isPlainObject(obj) || !obj.hasOwnProperty($52e3354521f75c8c$var$skipHydrateSymbol);
}
const { assign: $52e3354521f75c8c$var$assign } = Object;
function $52e3354521f75c8c$var$isComputed(o) {
    return !!((0, $01W3b.isRef)(o) && o.effect);
}
function $52e3354521f75c8c$var$createOptionsStore(id, options, pinia, hot) {
    const { state: state, actions: actions, getters: getters } = options;
    const initialState = pinia.state.value[id];
    let store;
    function setup() {
        if (!initialState && true) {
            /* istanbul ignore if */ if (0, $6TPMk.isVue2) (0, $6TPMk.set)(pinia.state.value, id, state ? state() : {});
            else pinia.state.value[id] = state ? state() : {};
        }
        // avoid creating a state in pinia.state.value
        const localState = (0, $01W3b.toRefs)(pinia.state.value[id]);
        return $52e3354521f75c8c$var$assign(localState, actions, Object.keys(getters || {}).reduce((computedGetters, name)=>{
            computedGetters[name] = (0, $01W3b.markRaw)((0, $01W3b.computed)(()=>{
                $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
                // it was created just before
                const store = pinia._s.get(id);
                // allow cross using stores
                /* istanbul ignore if */ if ((0, $6TPMk.isVue2) && !store._r) return;
                // @ts-expect-error
                // return getters![name].call(context, context)
                // TODO: avoid reading the getter while assigning with a global variable
                return getters[name].call(store, store);
            }));
            return computedGetters;
        }, {}));
    }
    store = $52e3354521f75c8c$var$createSetupStore(id, setup, options, pinia, hot, true);
    return store;
}
function $52e3354521f75c8c$var$createSetupStore($id, setup, options = {}, pinia, hot, isOptionsStore) {
    let scope;
    const optionsForPlugin = $52e3354521f75c8c$var$assign({
        actions: {}
    }, options);
    // watcher options for $subscribe
    const $subscribeOptions = {
        deep: true
    };
    var event;
    // internal state
    let isListening; // set to true at the end
    let isSyncListening; // set to true at the end
    let subscriptions = [];
    let actionSubscriptions = [];
    let debuggerEvents;
    const initialState = pinia.state.value[$id];
    // avoid setting the state for option stores if it is set
    // by the setup
    if (!isOptionsStore && !initialState && true) {
        /* istanbul ignore if */ if (0, $6TPMk.isVue2) (0, $6TPMk.set)(pinia.state.value, $id, {});
        else pinia.state.value[$id] = {};
    }
    const hotState = (0, $01W3b.ref)({});
    // avoid triggering too many listeners
    // https://github.com/vuejs/pinia/issues/1129
    let activeListener;
    function $patch(partialStateOrMutator) {
        let subscriptionMutation;
        isListening = isSyncListening = false;
        if (typeof partialStateOrMutator === 'function') {
            partialStateOrMutator(pinia.state.value[$id]);
            subscriptionMutation = {
                type: $52e3354521f75c8c$export$d97371ba8df8c539.patchFunction,
                storeId: $id,
                events: debuggerEvents
            };
        } else {
            $52e3354521f75c8c$var$mergeReactiveObjects(pinia.state.value[$id], partialStateOrMutator);
            subscriptionMutation = {
                type: $52e3354521f75c8c$export$d97371ba8df8c539.patchObject,
                payload: partialStateOrMutator,
                storeId: $id,
                events: debuggerEvents
            };
        }
        const myListenerId = activeListener = Symbol();
        (0, $TusQn.nextTick)().then(()=>{
            if (activeListener === myListenerId) isListening = true;
        });
        isSyncListening = true;
        // because we paused the watcher, we need to manually call the subscriptions
        $52e3354521f75c8c$var$triggerSubscriptions(subscriptions, subscriptionMutation, pinia.state.value[$id]);
    }
    const $reset = isOptionsStore ? function $reset() {
        const { state: state } = options;
        const newState = state ? state() : {};
        // we use a patch to group all changes into one single subscription
        this.$patch(($state)=>{
            // @ts-expect-error: FIXME: shouldn't error?
            $52e3354521f75c8c$var$assign($state, newState);
        });
    } : $52e3354521f75c8c$var$noop;
    function $dispose() {
        scope.stop();
        subscriptions = [];
        actionSubscriptions = [];
        pinia._s.delete($id);
    }
    /**
     * Helper that wraps function so it can be tracked with $onAction
     * @param fn - action to wrap
     * @param name - name of the action
     */ const action = (fn, name = '')=>{
        if ($52e3354521f75c8c$var$ACTION_MARKER in fn) {
            fn[$52e3354521f75c8c$var$ACTION_NAME] = name;
            return fn;
        }
        const wrappedAction = function() {
            $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
            const args = Array.from(arguments);
            const afterCallbackList = [];
            const onErrorCallbackList = [];
            function after(callback) {
                afterCallbackList.push(callback);
            }
            function onError(callback) {
                onErrorCallbackList.push(callback);
            }
            // @ts-expect-error
            $52e3354521f75c8c$var$triggerSubscriptions(actionSubscriptions, {
                args: args,
                name: wrappedAction[$52e3354521f75c8c$var$ACTION_NAME],
                store: store,
                after: after,
                onError: onError
            });
            let ret;
            try {
                ret = fn.apply(this && this.$id === $id ? this : store, args);
            // handle sync errors
            } catch (error) {
                $52e3354521f75c8c$var$triggerSubscriptions(onErrorCallbackList, error);
                throw error;
            }
            if (ret instanceof Promise) return ret.then((value)=>{
                $52e3354521f75c8c$var$triggerSubscriptions(afterCallbackList, value);
                return value;
            }).catch((error)=>{
                $52e3354521f75c8c$var$triggerSubscriptions(onErrorCallbackList, error);
                return Promise.reject(error);
            });
            // trigger after callbacks
            $52e3354521f75c8c$var$triggerSubscriptions(afterCallbackList, ret);
            return ret;
        };
        wrappedAction[$52e3354521f75c8c$var$ACTION_MARKER] = true;
        wrappedAction[$52e3354521f75c8c$var$ACTION_NAME] = name; // will be set later
        // @ts-expect-error: we are intentionally limiting the returned type to just Fn
        // because all the added properties are internals that are exposed through `$onAction()` only
        return wrappedAction;
    };
    const _hmrPayload = /*#__PURE__*/ (0, $01W3b.markRaw)({
        actions: {},
        getters: {},
        state: [],
        hotState: hotState
    });
    const partialStore = {
        _p: pinia,
        $id: // _s: scope,
        $id,
        $onAction: $52e3354521f75c8c$var$addSubscription.bind(null, actionSubscriptions),
        $patch: $patch,
        $reset: $reset,
        $subscribe (callback, options = {}) {
            const removeSubscription = $52e3354521f75c8c$var$addSubscription(subscriptions, callback, options.detached, ()=>stopWatcher());
            const stopWatcher = scope.run(()=>(0, $01W3b.watch)(()=>pinia.state.value[$id], (state)=>{
                    if (options.flush === 'sync' ? isSyncListening : isListening) callback({
                        storeId: $id,
                        type: $52e3354521f75c8c$export$d97371ba8df8c539.direct,
                        events: debuggerEvents
                    }, state);
                }, $52e3354521f75c8c$var$assign({}, $subscribeOptions, options)));
            return removeSubscription;
        },
        $dispose: $dispose
    };
    /* istanbul ignore if */ if (0, $6TPMk.isVue2) // start as non ready
    partialStore._r = false;
    const store = (0, $01W3b.reactive)(typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT ? $52e3354521f75c8c$var$assign({
        _hmrPayload: _hmrPayload,
        _customProperties: (0, $01W3b.markRaw)(new Set())
    }, partialStore) : partialStore);
    // store the partial store now so the setup of stores can instantiate each other before they are finished without
    // creating infinite loops.
    pinia._s.set($id, store);
    const runWithContext = pinia._a && pinia._a.runWithContext || $52e3354521f75c8c$var$fallbackRunWithContext;
    // TODO: idea create skipSerialize that marks properties as non serializable and they are skipped
    const setupStore = runWithContext(()=>pinia._e.run(()=>(scope = (0, $01W3b.effectScope)()).run(()=>setup({
                    action: action
                }))));
    // overwrite existing actions to support $onAction
    for(const key in setupStore){
        const prop = setupStore[key];
        if ((0, $01W3b.isRef)(prop) && !$52e3354521f75c8c$var$isComputed(prop) || (0, $01W3b.isReactive)(prop)) {
            if (!isOptionsStore) {
                // in setup stores we must hydrate the state and sync pinia state tree with the refs the user just created
                if (initialState && $52e3354521f75c8c$export$bdc3d2e33d3136e5(prop)) {
                    if ((0, $01W3b.isRef)(prop)) prop.value = initialState[key];
                    else // probably a reactive object, lets recursively assign
                    // @ts-expect-error: prop is unknown
                    $52e3354521f75c8c$var$mergeReactiveObjects(prop, initialState[key]);
                }
                // transfer the ref to the pinia state to keep everything in sync
                /* istanbul ignore if */ if (0, $6TPMk.isVue2) (0, $6TPMk.set)(pinia.state.value[$id], key, prop);
                else pinia.state.value[$id][key] = prop;
            }
        } else if (typeof prop === 'function') {
            const actionValue = action(prop, key);
            // this a hot module replacement store because the hotUpdate method needs
            // to do it with the right context
            /* istanbul ignore if */ if (0, $6TPMk.isVue2) (0, $6TPMk.set)(setupStore, key, actionValue);
            else // @ts-expect-error
            setupStore[key] = actionValue;
            // list actions so they can be used in plugins
            // @ts-expect-error
            optionsForPlugin.actions[key] = prop;
        }
    }
    // add the state, getters, and action properties
    /* istanbul ignore if */ if (0, $6TPMk.isVue2) Object.keys(setupStore).forEach((key)=>{
        (0, $6TPMk.set)(store, key, setupStore[key]);
    });
    else {
        $52e3354521f75c8c$var$assign(store, setupStore);
        // allows retrieving reactive objects with `storeToRefs()`. Must be called after assigning to the reactive object.
        // Make `storeToRefs()` work with `reactive()` #799
        $52e3354521f75c8c$var$assign((0, $01W3b.toRaw)(store), setupStore);
    }
    // use this instead of a computed with setter to be able to create it anywhere
    // without linking the computed lifespan to wherever the store is first
    // created.
    Object.defineProperty(store, '$state', {
        get: ()=>(0, pinia.state.value[$id]),
        set: (state)=>{
            $patch(($state)=>{
                // @ts-expect-error: FIXME: shouldn't error?
                $52e3354521f75c8c$var$assign($state, state);
            });
        }
    });
    var newStore, stateKey, stateKey1, key, key1;
    if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) {
        const nonEnumerable = {
            writable: true,
            configurable: true,
            // avoid warning on devtools trying to display this property
            enumerable: false
        };
        [
            '_p',
            '_hmrPayload',
            '_getters',
            '_customProperties'
        ].forEach((p)=>{
            Object.defineProperty(store, p, $52e3354521f75c8c$var$assign({
                value: store[p]
            }, nonEnumerable));
        });
    }
    /* istanbul ignore if */ if (0, $6TPMk.isVue2) // mark the store as ready before plugins
    store._r = true;
    // apply all plugins
    pinia._p.forEach((extender)=>{
        /* istanbul ignore else */ if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) {
            const extensions = scope.run(()=>extender({
                    store: store,
                    app: pinia._a,
                    pinia: pinia,
                    options: optionsForPlugin
                }));
            Object.keys(extensions || {}).forEach((key)=>store._customProperties.add(key));
            $52e3354521f75c8c$var$assign(store, extensions);
        } else $52e3354521f75c8c$var$assign(store, scope.run(()=>extender({
                store: store,
                app: pinia._a,
                pinia: pinia,
                options: optionsForPlugin
            })));
    });
    // only apply hydrate to option stores with an initial state in pinia
    if (initialState && isOptionsStore && options.hydrate) options.hydrate(store.$state, initialState);
    isListening = true;
    isSyncListening = true;
    return store;
}
// allows unused stores to be tree shaken
/*! #__NO_SIDE_EFFECTS__ */ function $52e3354521f75c8c$export$5061c4f75bbcb4a(// TODO: add proper types from above
idOrOptions, setup, setupOptions) {
    let id;
    let options;
    const isSetupStore = typeof setup === 'function';
    if (typeof idOrOptions === 'string') {
        id = idOrOptions;
        // the option store setup will contain the actual options in this case
        options = isSetupStore ? setupOptions : setup;
    } else {
        options = idOrOptions;
        id = idOrOptions.id;
    }
    function useStore(pinia, hot) {
        const hasContext = (0, $TusQn.hasInjectionContext)();
        pinia = pinia || (hasContext ? (0, $TusQn.inject)($52e3354521f75c8c$var$piniaSymbol, null) : null);
        if (pinia) $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
        pinia = $52e3354521f75c8c$var$activePinia;
        if (!pinia._s.has(id)) {
            // creating the store registers it in `pinia._s`
            if (isSetupStore) $52e3354521f75c8c$var$createSetupStore(id, setup, options, pinia);
            else $52e3354521f75c8c$var$createOptionsStore(id, options, pinia);
        }
        const store = pinia._s.get(id);
        // StoreGeneric cannot be casted towards Store
        return store;
    }
    useStore.$id = id;
    return useStore;
}
let $52e3354521f75c8c$var$mapStoreSuffix = 'Store';
/**
 * Changes the suffix added by `mapStores()`. Can be set to an empty string.
 * Defaults to `"Store"`. Make sure to extend the MapStoresCustomization
 * interface if you are using TypeScript.
 *
 * @param suffix - new suffix
 */ function $52e3354521f75c8c$export$3c0d0850ffd38177(suffix // could be 'Store' but that would be annoying for JS
) {
    $52e3354521f75c8c$var$mapStoreSuffix = suffix;
}
/**
 * Allows using stores without the composition API (`setup()`) by generating an
 * object to be spread in the `computed` field of a component. It accepts a list
 * of store definitions.
 *
 * @example
 * ```js
 * export default {
 *   computed: {
 *     // other computed properties
 *     ...mapStores(useUserStore, useCartStore)
 *   },
 *
 *   created() {
 *     this.userStore // store with id "user"
 *     this.cartStore // store with id "cart"
 *   }
 * }
 * ```
 *
 * @param stores - list of stores to map to an object
 */ function $52e3354521f75c8c$export$4701f243feba9f88(...stores) {
    return stores.reduce((reduced, useStore)=>{
        // @ts-expect-error: $id is added by defineStore
        reduced[useStore.$id + $52e3354521f75c8c$var$mapStoreSuffix] = function() {
            return useStore(this.$pinia);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$a337c713bdba072(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = function() {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[key];
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function() {
            const store = useStore(this.$pinia);
            const storeKey = keysOrMapper[key];
            // for some reason TS is unable to infer the type of storeKey to be a
            // function
            return typeof storeKey === 'function' ? storeKey.call(this, store) : store[storeKey];
        };
        return reduced;
    }, {});
}
/**
 * Alias for `mapState()`. You should use `mapState()` instead.
 * @deprecated use `mapState()` instead.
 */ const $52e3354521f75c8c$export$74d9085e6d5a97cb = $52e3354521f75c8c$export$a337c713bdba072;
/**
 * Allows directly using actions from your store without using the composition
 * API (`setup()`) by generating an object to be spread in the `methods` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$1d73b9b98821f6dc(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[key](...args);
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        // @ts-expect-error
        reduced[key] = function(...args) {
            // @ts-expect-error: FIXME: should work?
            return useStore(this.$pinia)[keysOrMapper[key]](...args);
        };
        return reduced;
    }, {});
}
/**
 * Allows using state and getters from one store without using the composition
 * API (`setup()`) by generating an object to be spread in the `computed` field
 * of a component.
 *
 * @param useStore - store to map from
 * @param keysOrMapper - array or object
 */ function $52e3354521f75c8c$export$c069310e76f1a3e7(useStore, keysOrMapper) {
    return Array.isArray(keysOrMapper) ? keysOrMapper.reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[key];
            },
            set (value) {
                return useStore(this.$pinia)[key] = value;
            }
        };
        return reduced;
    }, {}) : Object.keys(keysOrMapper).reduce((reduced, key)=>{
        reduced[key] = {
            get () {
                return useStore(this.$pinia)[keysOrMapper[key]];
            },
            set (value) {
                return useStore(this.$pinia)[keysOrMapper[key]] = value;
            }
        };
        return reduced;
    }, {});
}
/**
 * Creates an object of references with all the state, getters, and plugin-added
 * state properties of the store. Similar to `toRefs()` but specifically
 * designed for Pinia stores so methods and non reactive properties are
 * completely ignored.
 *
 * @param store - store to extract the refs from
 */ function $52e3354521f75c8c$export$586af8bd019552de(store) {
    // See https://github.com/vuejs/pinia/issues/852
    // It's easier to just use toRefs() even if it includes more stuff
    if (0, $6TPMk.isVue2) // @ts-expect-error: toRefs include methods and others
    return (0, $01W3b.toRefs)(store);
    else {
        const rawStore = (0, $01W3b.toRaw)(store);
        const refs = {};
        for(const key in rawStore){
            const value = rawStore[key];
            // There is no native method to check for a computed
            // https://github.com/vuejs/core/pull/4165
            if (value.effect) // @ts-expect-error: too hard to type correctly
            refs[key] = // ...
            (0, $01W3b.computed)({
                get: ()=>store[key],
                set (value) {
                    store[key] = value;
                }
            });
            else if ((0, $01W3b.isRef)(value) || (0, $01W3b.isReactive)(value)) // @ts-expect-error: the key is state or getter
            refs[key] = // ---
            (0, $01W3b.toRef)(store, key);
        }
        return refs;
    }
}
/**
 * Vue 2 Plugin that must be installed for pinia to work. Note **you don't need
 * this plugin if you are using Nuxt.js**. Use the `buildModule` instead:
 * https://pinia.vuejs.org/ssr/nuxt.html.
 *
 * @example
 * ```js
 * import Vue from 'vue'
 * import { PiniaVuePlugin, createPinia } from 'pinia'
 *
 * Vue.use(PiniaVuePlugin)
 * const pinia = createPinia()
 *
 * new Vue({
 *   el: '#app',
 *   // ...
 *   pinia,
 * })
 * ```
 *
 * @param _Vue - `Vue` imported from 'vue'.
 */ const $52e3354521f75c8c$export$a99c5571bb37058e = function(_Vue) {
    // Equivalent of
    // app.config.globalProperties.$pinia = pinia
    _Vue.mixin({
        beforeCreate () {
            const options = this.$options;
            if (options.pinia) {
                const pinia = options.pinia;
                // HACK: taken from provide(): https://github.com/vuejs/composition-api/blob/main/src/apis/inject.ts#L31
                /* istanbul ignore else */ if (!this._provided) {
                    const provideCache = {};
                    Object.defineProperty(this, '_provided', {
                        get: ()=>provideCache,
                        set: (v)=>Object.assign(provideCache, v)
                    });
                }
                this._provided[$52e3354521f75c8c$var$piniaSymbol] = pinia;
                // propagate the pinia instance in an SSR friendly way
                // avoid adding it to nuxt twice
                /* istanbul ignore else */ if (!this.$pinia) this.$pinia = pinia;
                pinia._a = this;
                if ($52e3354521f75c8c$var$IS_CLIENT) // this allows calling useStore() outside of a component setup after
                // installing pinia's plugin
                $52e3354521f75c8c$export$89ffb8149ccd46af(pinia);
                if (typeof __VUE_PROD_DEVTOOLS__ !== 'undefined' && __VUE_PROD_DEVTOOLS__ && true && $52e3354521f75c8c$var$IS_CLIENT) $52e3354521f75c8c$var$registerPiniaDevtools(pinia._a, pinia);
            } else if (!this.$pinia && options.parent && options.parent.$pinia) this.$pinia = options.parent.$pinia;
        },
        destroyed () {
            delete this._pStores;
        }
    });
};

});
parcelRegister("6TPMk", function(module, exports) {
$parcel$export(module.exports, "computed", () => (parcelRequire("01W3b")).computed);
$parcel$export(module.exports, "effectScope", () => (parcelRequire("01W3b")).effectScope);
$parcel$export(module.exports, "getCurrentScope", () => (parcelRequire("01W3b")).getCurrentScope);
$parcel$export(module.exports, "hasInjectionContext", () => (parcelRequire("TusQn")).hasInjectionContext);
$parcel$export(module.exports, "inject", () => (parcelRequire("TusQn")).inject);
$parcel$export(module.exports, "isReactive", () => (parcelRequire("01W3b")).isReactive);
$parcel$export(module.exports, "isRef", () => (parcelRequire("01W3b")).isRef);
$parcel$export(module.exports, "markRaw", () => (parcelRequire("01W3b")).markRaw);
$parcel$export(module.exports, "nextTick", () => (parcelRequire("TusQn")).nextTick);
$parcel$export(module.exports, "onScopeDispose", () => (parcelRequire("01W3b")).onScopeDispose);
$parcel$export(module.exports, "reactive", () => (parcelRequire("01W3b")).reactive);
$parcel$export(module.exports, "ref", () => (parcelRequire("01W3b")).ref);
$parcel$export(module.exports, "toRaw", () => (parcelRequire("01W3b")).toRaw);
$parcel$export(module.exports, "toRef", () => (parcelRequire("01W3b")).toRef);
$parcel$export(module.exports, "toRefs", () => (parcelRequire("01W3b")).toRefs);
$parcel$export(module.exports, "unref", () => (parcelRequire("01W3b")).unref);
$parcel$export(module.exports, "watch", () => (parcelRequire("01W3b")).watch);

$parcel$export(module.exports, "isVue2", () => $df7568b16c312563$export$1da84e343e81ceb9);
$parcel$export(module.exports, "set", () => $df7568b16c312563$export$adaa4cf7ef1b65be);
parcelRequire("ecd4d");
var $df7568b16c312563$export$1da84e343e81ceb9 = false;
var $df7568b16c312563$export$34b222e3d4733e48 = true;
var $df7568b16c312563$export$a8cb34872e7d8b79 = undefined;
function $df7568b16c312563$export$4b3e715f166fdd78() {}
function $df7568b16c312563$export$adaa4cf7ef1b65be(target, key, val) {
    if (Array.isArray(target)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        return val;
    }
    target[key] = val;
    return val;
}
function $df7568b16c312563$export$1d2f21e549771e67(target, key) {
    if (Array.isArray(target)) {
        target.splice(key, 1);
        return;
    }
    delete target[key];
}

});

parcelRegister("j6G8F", function(module, exports) {

$parcel$export(module.exports, "setupDevtoolsPlugin", () => $de8f43bece76d38a$export$63b9a9bba9f20f3e);

var $jiSSU = parcelRequire("jiSSU");

var $7mHjb = parcelRequire("7mHjb");

var $83xTH = parcelRequire("83xTH");



function $de8f43bece76d38a$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    const descriptor = pluginDescriptor;
    const target = (0, $jiSSU.getTarget)();
    const hook = (0, $jiSSU.getDevtoolsGlobalHook)();
    const enableProxy = (0, $jiSSU.isProxyAvailable) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $7mHjb.HOOK_SETUP), pluginDescriptor, setupFn);
    else {
        const proxy = enableProxy ? new (0, $83xTH.ApiProxy)(descriptor, hook) : null;
        const list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}

});
parcelRegister("jiSSU", function(module, exports) {

$parcel$export(module.exports, "getDevtoolsGlobalHook", () => $e0da45b668fffb6e$export$5a2d366b2d9f38f6);
$parcel$export(module.exports, "getTarget", () => $e0da45b668fffb6e$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "isProxyAvailable", () => $e0da45b668fffb6e$export$bc32a04c49ed7464);
function $e0da45b668fffb6e$export$5a2d366b2d9f38f6() {
    return $e0da45b668fffb6e$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $e0da45b668fffb6e$export$c22522a4dfa48e9c() {
    // @ts-expect-error navigator and windows are not available in all environments
    return typeof navigator !== 'undefined' && typeof window !== 'undefined' ? window : typeof globalThis !== 'undefined' ? globalThis : {};
}
const $e0da45b668fffb6e$export$bc32a04c49ed7464 = typeof Proxy === 'function';

});

parcelRegister("7mHjb", function(module, exports) {

$parcel$export(module.exports, "HOOK_SETUP", () => $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df);
$parcel$export(module.exports, "HOOK_PLUGIN_SETTINGS_SET", () => $55cc2ea2e53f2ca6$export$a0897f44accbe922);
const $55cc2ea2e53f2ca6$export$b1499c3bd2a3f4df = 'devtools-plugin:setup';
const $55cc2ea2e53f2ca6$export$a0897f44accbe922 = 'plugin:settings:set';

});

parcelRegister("83xTH", function(module, exports) {

$parcel$export(module.exports, "ApiProxy", () => $5dd8e5d828be8ae1$export$5728f3776e9b2ac1);

var $7mHjb = parcelRequire("7mHjb");

var $2QQ8V = parcelRequire("2QQ8V");
class $5dd8e5d828be8ae1$export$5728f3776e9b2ac1 {
    constructor(plugin, hook){
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        const defaultSettings = {};
        if (plugin.settings) for(const id in plugin.settings){
            const item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        const localSettingsSaveId = `__vue-devtools-plugin-settings__${plugin.id}`;
        let currentSettings = Object.assign({}, defaultSettings);
        try {
            const raw = localStorage.getItem(localSettingsSaveId);
            const data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings () {
                return currentSettings;
            },
            setSettings (value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now () {
                return (0, $2QQ8V.now)();
            }
        };
        if (hook) hook.on((0, $7mHjb.HOOK_PLUGIN_SETTINGS_SET), (pluginId, value)=>{
            if (pluginId === this.plugin.id) this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target.on[prop];
                else return (...args)=>{
                    this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: (_target, prop)=>{
                if (this.target) return this.target[prop];
                else if (prop === 'on') return this.proxiedOn;
                else if (Object.keys(this.fallbacks).includes(prop)) return (...args)=>{
                    this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: ()=>{}
                    });
                    return this.fallbacks[prop](...args);
                };
                else return (...args)=>{
                    return new Promise((resolve)=>{
                        this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    async setRealTarget(target) {
        this.target = target;
        for (const item of this.onQueue)this.target.on[item.method](...item.args);
        for (const item of this.targetQueue)item.resolve(await this.target[item.method](...item.args));
    }
}

});
parcelRegister("2QQ8V", function(module, exports) {

$parcel$export(module.exports, "now", () => $2138e2947b5f69c4$export$461939dd4422153);
let $2138e2947b5f69c4$var$supported;
let $2138e2947b5f69c4$var$perf;
function $2138e2947b5f69c4$export$70d26280bc1ca547() {
    var _a;
    if ($2138e2947b5f69c4$var$supported !== undefined) return $2138e2947b5f69c4$var$supported;
    if (typeof window !== 'undefined' && window.performance) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = window.performance;
    } else if (typeof globalThis !== 'undefined' && ((_a = globalThis.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $2138e2947b5f69c4$var$supported = true;
        $2138e2947b5f69c4$var$perf = globalThis.perf_hooks.performance;
    } else $2138e2947b5f69c4$var$supported = false;
    return $2138e2947b5f69c4$var$supported;
}
function $2138e2947b5f69c4$export$461939dd4422153() {
    return $2138e2947b5f69c4$export$70d26280bc1ca547() ? $2138e2947b5f69c4$var$perf.now() : Date.now();
}

});




parcelRegister("cAQvd", function(module, exports) {
$parcel$export(module.exports, "getAllEvents", () => (parcelRequire("7PL6S")).getAllEvents);
$parcel$export(module.exports, "getEvent", () => (parcelRequire("7PL6S")).getEvent);
$parcel$export(module.exports, "getEventReferences", () => (parcelRequire("7PL6S")).getEventReferences);
$parcel$export(module.exports, "getEventsByKind", () => (parcelRequire("7PL6S")).getEventsByKind);
$parcel$export(module.exports, "storeEvent", () => (parcelRequire("7PL6S")).storeEvent);
$parcel$export(module.exports, "storeEvents", () => (parcelRequire("7PL6S")).storeEvents);
/**
 * Re-export everything from all database modules for convenience
 */ // Schema
parcelRequire("9Wi0l");
parcelRequire("7PL6S");
parcelRequire("cMDGm");
parcelRequire("59sLQ");
parcelRequire("eWYts");

});
parcelRegister("9Wi0l", function(module, exports) {

$parcel$export(module.exports, "getDB", () => $c82f8a1d31cca6e4$export$b079286a3c21acde);

var $iItpQ = parcelRequire("iItpQ");
const $c82f8a1d31cca6e4$var$DB_NAME = 'nostr-graph';
const $c82f8a1d31cca6e4$var$DB_VERSION = 3 // Incremented for expanded graphStates schema
;
let $c82f8a1d31cca6e4$var$dbInstance = null;
async function $c82f8a1d31cca6e4$export$b079286a3c21acde() {
    if ($c82f8a1d31cca6e4$var$dbInstance) return $c82f8a1d31cca6e4$var$dbInstance;
    $c82f8a1d31cca6e4$var$dbInstance = await (0, $iItpQ.openDB)($c82f8a1d31cca6e4$var$DB_NAME, $c82f8a1d31cca6e4$var$DB_VERSION, {
        upgrade (db, oldVersion, newVersion, transaction) {
            console.log(`Upgrading database from v${oldVersion} to v${newVersion}`);
            // Events store
            if (!db.objectStoreNames.contains('events')) {
                const eventsStore = db.createObjectStore('events', {
                    keyPath: 'id'
                });
                eventsStore.createIndex('by-kind', 'kind', {
                    unique: false
                });
                eventsStore.createIndex('by-pubkey', 'pubkey', {
                    unique: false
                });
                eventsStore.createIndex('by-created', 'created_at', {
                    unique: false
                });
                // Multi-entry index for tags (allows querying by any tag)
                eventsStore.createIndex('by-tag', 'tags', {
                    unique: false,
                    multiEntry: true
                });
            }
            // Annotations store
            if (!db.objectStoreNames.contains('annotations')) {
                const annotationsStore = db.createObjectStore('annotations', {
                    keyPath: 'id'
                });
                annotationsStore.createIndex('by-target', 'targetEventId', {
                    unique: false
                });
                annotationsStore.createIndex('by-created', 'createdAt', {
                    unique: false
                });
            }
            // Graph states store
            if (!db.objectStoreNames.contains('graphStates')) {
                const graphStatesStore = db.createObjectStore('graphStates', {
                    keyPath: 'id'
                });
                graphStatesStore.createIndex('by-created', 'createdAt', {
                    unique: false
                });
                graphStatesStore.createIndex('by-updated', 'updatedAt', {
                    unique: false
                });
            }
            // Search index store
            if (!db.objectStoreNames.contains('searchIndex')) {
                const searchIndexStore = db.createObjectStore('searchIndex', {
                    keyPath: 'eventId'
                });
                searchIndexStore.createIndex('by-indexed', 'indexedAt', {
                    unique: false
                });
            }
            // Relays store (added in v2)
            if (!db.objectStoreNames.contains('relays')) {
                const relaysStore = db.createObjectStore('relays', {
                    keyPath: 'url'
                });
                relaysStore.createIndex('by-enabled', 'enabled', {
                    unique: false
                });
                relaysStore.createIndex('by-status', 'status', {
                    unique: false
                });
                relaysStore.createIndex('by-added', 'addedAt', {
                    unique: false
                });
            }
        },
        blocked () {
            console.warn('Database upgrade blocked by another open connection');
        },
        blocking () {
            console.warn('This database connection is blocking an upgrade');
        },
        terminated () {
            console.error('Database connection was unexpectedly terminated');
            $c82f8a1d31cca6e4$var$dbInstance = null;
        }
    });
    return $c82f8a1d31cca6e4$var$dbInstance;
}
function $c82f8a1d31cca6e4$export$b4820fdc989e4749() {
    if ($c82f8a1d31cca6e4$var$dbInstance) {
        $c82f8a1d31cca6e4$var$dbInstance.close();
        $c82f8a1d31cca6e4$var$dbInstance = null;
    }
}
async function $c82f8a1d31cca6e4$export$e370ed6d69108f35() {
    const db = await $c82f8a1d31cca6e4$export$b079286a3c21acde();
    const tx = db.transaction([
        'events',
        'annotations',
        'graphStates',
        'searchIndex',
        'relays'
    ], 'readwrite');
    await Promise.all([
        tx.objectStore('events').clear(),
        tx.objectStore('annotations').clear(),
        tx.objectStore('graphStates').clear(),
        tx.objectStore('searchIndex').clear(),
        tx.objectStore('relays').clear()
    ]);
    await tx.done;
}
async function $c82f8a1d31cca6e4$export$1c2efdcc3c5021be() {
    const db = await $c82f8a1d31cca6e4$export$b079286a3c21acde();
    const [eventCount, annotationCount, graphStateCount] = await Promise.all([
        db.count('events'),
        db.count('annotations'),
        db.count('graphStates')
    ]);
    return {
        events: eventCount,
        annotations: annotationCount,
        graphStates: graphStateCount
    };
}

});
parcelRegister("iItpQ", function(module, exports) {

$parcel$export(module.exports, "openDB", () => $da032767b57a4aa4$export$ca0ed41b1a2af7e);
const $da032767b57a4aa4$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $da032767b57a4aa4$var$idbProxyableTypes;
let $da032767b57a4aa4$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $da032767b57a4aa4$var$getIdbProxyableTypes() {
    return $da032767b57a4aa4$var$idbProxyableTypes || ($da032767b57a4aa4$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $da032767b57a4aa4$var$getCursorAdvanceMethods() {
    return $da032767b57a4aa4$var$cursorAdvanceMethods || ($da032767b57a4aa4$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $da032767b57a4aa4$var$transactionDoneMap = new WeakMap();
const $da032767b57a4aa4$var$transformCache = new WeakMap();
const $da032767b57a4aa4$var$reverseTransformCache = new WeakMap();
function $da032767b57a4aa4$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve($da032767b57a4aa4$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    // This mapping exists in reverseTransformCache but doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $da032767b57a4aa4$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $da032767b57a4aa4$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($da032767b57a4aa4$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    $da032767b57a4aa4$var$transactionDoneMap.set(tx, done);
}
let $da032767b57a4aa4$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return $da032767b57a4aa4$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $da032767b57a4aa4$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function $da032767b57a4aa4$var$replaceTraps(callback) {
    $da032767b57a4aa4$var$idbProxyTraps = callback($da032767b57a4aa4$var$idbProxyTraps);
}
function $da032767b57a4aa4$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($da032767b57a4aa4$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($da032767b57a4aa4$export$debb760848ca95a(this), args);
        return $da032767b57a4aa4$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $da032767b57a4aa4$export$4997ffc0176396a6(func.apply($da032767b57a4aa4$export$debb760848ca95a(this), args));
    };
}
function $da032767b57a4aa4$var$transformCachableValue(value) {
    if (typeof value === 'function') return $da032767b57a4aa4$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $da032767b57a4aa4$var$cacheDonePromiseForTransaction(value);
    if ($da032767b57a4aa4$var$instanceOfAny(value, $da032767b57a4aa4$var$getIdbProxyableTypes())) return new Proxy(value, $da032767b57a4aa4$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $da032767b57a4aa4$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $da032767b57a4aa4$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($da032767b57a4aa4$var$transformCache.has(value)) return $da032767b57a4aa4$var$transformCache.get(value);
    const newValue = $da032767b57a4aa4$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $da032767b57a4aa4$var$transformCache.set(value, newValue);
        $da032767b57a4aa4$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $da032767b57a4aa4$export$debb760848ca95a = (value)=>$da032767b57a4aa4$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $da032767b57a4aa4$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $da032767b57a4aa4$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade($da032767b57a4aa4$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $da032767b57a4aa4$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $da032767b57a4aa4$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $da032767b57a4aa4$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $da032767b57a4aa4$var$readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const $da032767b57a4aa4$var$writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const $da032767b57a4aa4$var$cachedMethods = new Map();
function $da032767b57a4aa4$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if ($da032767b57a4aa4$var$cachedMethods.get(prop)) return $da032767b57a4aa4$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = $da032767b57a4aa4$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $da032767b57a4aa4$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $da032767b57a4aa4$var$cachedMethods.set(prop, method);
    return method;
}
$da032767b57a4aa4$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$da032767b57a4aa4$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $da032767b57a4aa4$var$advanceMethodProps = [
    'continue',
    'continuePrimaryKey',
    'advance'
];
const $da032767b57a4aa4$var$methodMap = {};
const $da032767b57a4aa4$var$advanceResults = new WeakMap();
const $da032767b57a4aa4$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $da032767b57a4aa4$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$da032767b57a4aa4$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $da032767b57a4aa4$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $da032767b57a4aa4$var$methodMap[prop] = function(...args) {
            $da032767b57a4aa4$var$advanceResults.set(this, $da032767b57a4aa4$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $da032767b57a4aa4$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $da032767b57a4aa4$var$cursorIteratorTraps);
    $da032767b57a4aa4$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $da032767b57a4aa4$var$reverseTransformCache.set(proxiedCursor, $da032767b57a4aa4$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($da032767b57a4aa4$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $da032767b57a4aa4$var$advanceResults.delete(proxiedCursor);
    }
}
function $da032767b57a4aa4$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $da032767b57a4aa4$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === 'iterate' && $da032767b57a4aa4$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$da032767b57a4aa4$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($da032767b57a4aa4$var$isIteratorProp(target, prop)) return $da032767b57a4aa4$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $da032767b57a4aa4$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));

});


parcelRegister("7PL6S", function(module, exports) {

$parcel$export(module.exports, "storeEvent", () => $f42ae2d7c2fbf39e$export$c452b55e9ad3f100);
$parcel$export(module.exports, "storeEvents", () => $f42ae2d7c2fbf39e$export$e8bfd1501bf919b);
$parcel$export(module.exports, "getEvent", () => $f42ae2d7c2fbf39e$export$ee2085e97a04e027);
$parcel$export(module.exports, "getAllEvents", () => $f42ae2d7c2fbf39e$export$86fc571c51e65680);
$parcel$export(module.exports, "getEventsByKind", () => $f42ae2d7c2fbf39e$export$b56c7ee5c3b2a6d1);
$parcel$export(module.exports, "getEventReferences", () => $f42ae2d7c2fbf39e$export$6924e9f7ed2154c7);

var $9Wi0l = parcelRequire("9Wi0l");
async function $f42ae2d7c2fbf39e$export$c452b55e9ad3f100(event) {
    const db = await (0, $9Wi0l.getDB)();
    await db.put('events', event);
}
async function $f42ae2d7c2fbf39e$export$e8bfd1501bf919b(events) {
    if (events.length === 0) return;
    const db = await (0, $9Wi0l.getDB)();
    const tx = db.transaction('events', 'readwrite');
    await Promise.all(events.map((event)=>tx.store.put(event)));
    await tx.done;
}
async function $f42ae2d7c2fbf39e$export$ee2085e97a04e027(eventId) {
    const db = await (0, $9Wi0l.getDB)();
    return db.get('events', eventId);
}
async function $f42ae2d7c2fbf39e$export$3f41ece7d7128238(eventIds) {
    const db = await (0, $9Wi0l.getDB)();
    const events = await Promise.all(eventIds.map((id)=>db.get('events', id)));
    return events.filter((e)=>e !== undefined);
}
async function $f42ae2d7c2fbf39e$export$86fc571c51e65680() {
    const db = await (0, $9Wi0l.getDB)();
    return db.getAll('events');
}
async function $f42ae2d7c2fbf39e$export$b56c7ee5c3b2a6d1(kind) {
    const db = await (0, $9Wi0l.getDB)();
    return db.getAllFromIndex('events', 'by-kind', kind);
}
async function $f42ae2d7c2fbf39e$export$33887c654bf6b15e(pubkey) {
    const db = await (0, $9Wi0l.getDB)();
    return db.getAllFromIndex('events', 'by-pubkey', pubkey);
}
async function $f42ae2d7c2fbf39e$export$b9608a1bddc5af6a(tag) {
    const db = await (0, $9Wi0l.getDB)();
    const tagString = JSON.stringify(tag);
    return db.getAllFromIndex('events', 'by-tag', tagString);
}
async function $f42ae2d7c2fbf39e$export$515f3a91147e3fa6(startTime, endTime) {
    const db = await (0, $9Wi0l.getDB)();
    const range = IDBKeyRange.bound(startTime, endTime);
    return db.getAllFromIndex('events', 'by-created', range);
}
async function $f42ae2d7c2fbf39e$export$95711ec6c6227e9a(eventId) {
    const db = await (0, $9Wi0l.getDB)();
    await db.delete('events', eventId);
}
async function $f42ae2d7c2fbf39e$export$23e62c81c988047b(eventIds) {
    const db = await (0, $9Wi0l.getDB)();
    const tx = db.transaction('events', 'readwrite');
    await Promise.all(eventIds.map((id)=>tx.store.delete(id)));
    await tx.done;
}
async function $f42ae2d7c2fbf39e$export$cd5cda46d147fdf6(eventId) {
    const db = await (0, $9Wi0l.getDB)();
    const count = await db.countFromIndex('events', 'by-kind', eventId);
    return count > 0;
}
async function $f42ae2d7c2fbf39e$export$f0f18751ef0e3cb6(filter) {
    const db = await (0, $9Wi0l.getDB)();
    let results = [];
    // Query by IDs
    if (filter.ids && filter.ids.length > 0) {
        const events = await Promise.all(filter.ids.map((id)=>db.get('events', id)));
        results = events.filter((e)=>e !== undefined);
    } else if (filter.authors && filter.authors.length > 0) {
        const eventsByAuthor = await Promise.all(filter.authors.map((pubkey)=>$f42ae2d7c2fbf39e$export$33887c654bf6b15e(pubkey)));
        results = eventsByAuthor.flat();
    } else if (filter.kinds && filter.kinds.length > 0) {
        const eventsByKind = await Promise.all(filter.kinds.map((kind)=>$f42ae2d7c2fbf39e$export$b56c7ee5c3b2a6d1(kind)));
        results = eventsByKind.flat();
    } else results = await $f42ae2d7c2fbf39e$export$86fc571c51e65680();
    // Apply time filters
    if (filter.since || filter.until) results = results.filter((event)=>{
        if (filter.since && event.created_at < filter.since) return false;
        if (filter.until && event.created_at > filter.until) return false;
        return true;
    });
    // Apply limit
    if (filter.limit) results = results.slice(0, filter.limit);
    return results;
}
async function $f42ae2d7c2fbf39e$export$6924e9f7ed2154c7(eventId) {
    const db = await (0, $9Wi0l.getDB)();
    const allEvents = await $f42ae2d7c2fbf39e$export$86fc571c51e65680();
    // Filter events that have an 'e' tag referencing this event
    return allEvents.filter((event)=>event.tags.some((tag)=>tag[0] === 'e' && tag[1] === eventId));
}
async function $f42ae2d7c2fbf39e$export$ba77455e5e93b968(pubkey) {
    const db = await (0, $9Wi0l.getDB)();
    const allEvents = await $f42ae2d7c2fbf39e$export$86fc571c51e65680();
    // Filter events that have a 'p' tag mentioning this pubkey
    return allEvents.filter((event)=>event.tags.some((tag)=>tag[0] === 'p' && tag[1] === pubkey));
}
async function $f42ae2d7c2fbf39e$export$9dd577440bb260eb() {
    const db = await (0, $9Wi0l.getDB)();
    const allEvents = await $f42ae2d7c2fbf39e$export$86fc571c51e65680();
    const kindCount = {};
    const pubkeyCount = {};
    allEvents.forEach((event)=>{
        kindCount[event.kind] = (kindCount[event.kind] || 0) + 1;
        pubkeyCount[event.pubkey] = (pubkeyCount[event.pubkey] || 0) + 1;
    });
    const earliestEvent = allEvents.reduce((earliest, event)=>event.created_at < earliest ? event.created_at : earliest, Infinity);
    const latestEvent = allEvents.reduce((latest, event)=>event.created_at > latest ? event.created_at : latest, 0);
    return {
        totalEvents: allEvents.length,
        byKind: kindCount,
        byPubkey: pubkeyCount,
        uniquePubkeys: Object.keys(pubkeyCount).length,
        timeRange: {
            earliest: earliestEvent === Infinity ? null : earliestEvent,
            latest: latestEvent === 0 ? null : latestEvent
        }
    };
}

});

parcelRegister("cMDGm", function(module, exports) {

var $9Wi0l = parcelRequire("9Wi0l");
async function $eda1fe95ded318c7$export$51eda81011da4982(targetEventId, content, tags = []) {
    const annotation = {
        id: crypto.randomUUID(),
        targetEventId: targetEventId,
        content: content,
        createdAt: Date.now(),
        tags: tags
    };
    const db = await (0, $9Wi0l.getDB)();
    await db.put('annotations', annotation);
    return annotation;
}
async function $eda1fe95ded318c7$export$6bcd911ecd45d030(eventId) {
    const db = await (0, $9Wi0l.getDB)();
    return db.getAllFromIndex('annotations', 'by-target', eventId);
}
async function $eda1fe95ded318c7$export$f18ebd7013451950(annotationId) {
    const db = await (0, $9Wi0l.getDB)();
    return db.get('annotations', annotationId);
}
async function $eda1fe95ded318c7$export$a0d1273a43af0f5a(annotationId, content, tags) {
    const db = await (0, $9Wi0l.getDB)();
    const annotation = await db.get('annotations', annotationId);
    if (!annotation) throw new Error(`Annotation ${annotationId} not found`);
    annotation.content = content;
    if (tags !== undefined) annotation.tags = tags;
    await db.put('annotations', annotation);
}
async function $eda1fe95ded318c7$export$a193961559973879(annotationId) {
    const db = await (0, $9Wi0l.getDB)();
    await db.delete('annotations', annotationId);
}
async function $eda1fe95ded318c7$export$2ecc008effaefd6e() {
    const db = await (0, $9Wi0l.getDB)();
    return db.getAll('annotations');
}
async function $eda1fe95ded318c7$export$dc9ac37febb16f79(query) {
    const annotations = await $eda1fe95ded318c7$export$2ecc008effaefd6e();
    const lowerQuery = query.toLowerCase();
    return annotations.filter((annotation)=>annotation.content.toLowerCase().includes(lowerQuery) || annotation.tags.some((tag)=>tag.toLowerCase().includes(lowerQuery)));
}

});

parcelRegister("59sLQ", function(module, exports) {

$parcel$export(module.exports, "saveGraphState", () => $4cdf15141a36144c$export$c423f584ca98830b);
$parcel$export(module.exports, "loadGraphState", () => $4cdf15141a36144c$export$982851c6b7999e25);
$parcel$export(module.exports, "updateGraphState", () => $4cdf15141a36144c$export$200f19c0a7ee3687);
$parcel$export(module.exports, "deleteGraphState", () => $4cdf15141a36144c$export$274ba1a40d3db249);
$parcel$export(module.exports, "getAllGraphStates", () => $4cdf15141a36144c$export$96d8f2c3fe7b5289);
$parcel$export(module.exports, "duplicateGraphState", () => $4cdf15141a36144c$export$c9ceeeb2f602c2fb);
$parcel$export(module.exports, "exportGraphState", () => $4cdf15141a36144c$export$2bb5fb0c9a93d8fc);
$parcel$export(module.exports, "importGraphState", () => $4cdf15141a36144c$export$26d98601877aee14);
$parcel$export(module.exports, "setLastActiveState", () => $4cdf15141a36144c$export$7d68e6b8edd2cfae);
$parcel$export(module.exports, "getLastActiveState", () => $4cdf15141a36144c$export$540a53ddf0b16556);

var $9Wi0l = parcelRequire("9Wi0l");
async function $4cdf15141a36144c$export$c423f584ca98830b(state) {
    const fullState = {
        ...state,
        id: crypto.randomUUID(),
        createdAt: Date.now(),
        updatedAt: Date.now()
    };
    const db = await (0, $9Wi0l.getDB)();
    await db.put('graphStates', fullState);
    return fullState;
}
async function $4cdf15141a36144c$export$982851c6b7999e25(stateId) {
    const db = await (0, $9Wi0l.getDB)();
    return db.get('graphStates', stateId);
}
async function $4cdf15141a36144c$export$200f19c0a7ee3687(stateId, updates) {
    const db = await (0, $9Wi0l.getDB)();
    const state = await db.get('graphStates', stateId);
    if (!state) throw new Error(`Graph state ${stateId} not found`);
    Object.assign(state, updates, {
        updatedAt: Date.now()
    });
    await db.put('graphStates', state);
}
async function $4cdf15141a36144c$export$274ba1a40d3db249(stateId) {
    const db = await (0, $9Wi0l.getDB)();
    await db.delete('graphStates', stateId);
}
async function $4cdf15141a36144c$export$96d8f2c3fe7b5289() {
    const db = await (0, $9Wi0l.getDB)();
    const states = await db.getAll('graphStates');
    // Sort by updated time (most recent first)
    return states.sort((a, b)=>b.updatedAt - a.updatedAt);
}
async function $4cdf15141a36144c$export$365bdd7011709b28(limit = 10) {
    const states = await $4cdf15141a36144c$export$96d8f2c3fe7b5289();
    return states.slice(0, limit);
}
async function $4cdf15141a36144c$export$c9ceeeb2f602c2fb(stateId, newName) {
    const db = await (0, $9Wi0l.getDB)();
    const original = await db.get('graphStates', stateId);
    if (!original) throw new Error(`Graph state ${stateId} not found`);
    const duplicate = {
        ...original,
        id: crypto.randomUUID(),
        name: newName || `${original.name} (copy)`,
        createdAt: Date.now(),
        updatedAt: Date.now()
    };
    await db.put('graphStates', duplicate);
    return duplicate;
}
function $4cdf15141a36144c$export$2bb5fb0c9a93d8fc(state) {
    return JSON.stringify(state, null, 2);
}
async function $4cdf15141a36144c$export$26d98601877aee14(json) {
    const state = JSON.parse(json);
    // Generate new ID and timestamps
    state.id = crypto.randomUUID();
    state.createdAt = Date.now();
    state.updatedAt = Date.now();
    const db = await (0, $9Wi0l.getDB)();
    await db.put('graphStates', state);
    return state;
}
// Local storage key for last active state
const $4cdf15141a36144c$var$LAST_STATE_KEY = 'nostr-graph:last-active-state';
function $4cdf15141a36144c$export$7d68e6b8edd2cfae(stateId) {
    if (stateId) localStorage.setItem($4cdf15141a36144c$var$LAST_STATE_KEY, stateId);
    else localStorage.removeItem($4cdf15141a36144c$var$LAST_STATE_KEY);
}
function $4cdf15141a36144c$export$540a53ddf0b16556() {
    return localStorage.getItem($4cdf15141a36144c$var$LAST_STATE_KEY);
}

});

parcelRegister("eWYts", function(module, exports) {

$parcel$export(module.exports, "getAllRelays", () => $8d48d49ecb8709de$export$291703e8598838a8);
$parcel$export(module.exports, "getEnabledRelays", () => $8d48d49ecb8709de$export$783fcedd215a4864);
$parcel$export(module.exports, "addRelay", () => $8d48d49ecb8709de$export$93d95b36d3befb01);
$parcel$export(module.exports, "removeRelay", () => $8d48d49ecb8709de$export$380b9818819a9649);
$parcel$export(module.exports, "updateRelayStatus", () => $8d48d49ecb8709de$export$a72e4803bb943d13);
$parcel$export(module.exports, "updateRelayLatency", () => $8d48d49ecb8709de$export$93229fdda1ad5757);
$parcel$export(module.exports, "incrementRelayEventCount", () => $8d48d49ecb8709de$export$efb54e15d50961e3);
$parcel$export(module.exports, "toggleRelayEnabled", () => $8d48d49ecb8709de$export$50a3d8454f4872a1);
$parcel$export(module.exports, "initializeDefaultRelays", () => $8d48d49ecb8709de$export$1fdf2e6dc67ae1d);

var $9Wi0l = parcelRequire("9Wi0l");
async function $8d48d49ecb8709de$export$291703e8598838a8() {
    const db = await (0, $9Wi0l.getDB)();
    const allRelays = await db.getAll('relays');
    console.log('[relays.ts] getAllRelays - Total in database:', allRelays.length);
    console.log('[relays.ts] All relays:', allRelays.map((r)=>`${r.url} (enabled: ${r.enabled})`));
    return allRelays;
}
async function $8d48d49ecb8709de$export$783fcedd215a4864() {
    const db = await (0, $9Wi0l.getDB)();
    // Get all relays and manually filter - more reliable than index query with boolean values
    const allFromDb = await db.getAll('relays');
    const enabledRelays = allFromDb.filter((r)=>r.enabled === true);
    console.log('[relays.ts] getEnabledRelays - Total relays:', allFromDb.length);
    console.log('[relays.ts] getEnabledRelays - Enabled relays:', enabledRelays.length);
    console.log('[relays.ts] Enabled relay URLs:', enabledRelays.map((r)=>`${r.url} (enabled: ${r.enabled})`));
    return enabledRelays;
}
async function $8d48d49ecb8709de$export$1e0f363384bbe072(url) {
    const db = await (0, $9Wi0l.getDB)();
    return db.get('relays', url);
}
async function $8d48d49ecb8709de$export$bbd12754eb06c9d3(relay) {
    const db = await (0, $9Wi0l.getDB)();
    await db.put('relays', relay);
}
async function $8d48d49ecb8709de$export$93d95b36d3befb01(url) {
    const relay = {
        url: url,
        enabled: true,
        addedAt: Date.now(),
        lastConnected: null,
        lastError: null,
        errorCount: 0,
        status: 'disconnected',
        latency: null,
        eventsReceived: 0
    };
    await $8d48d49ecb8709de$export$bbd12754eb06c9d3(relay);
    return relay;
}
async function $8d48d49ecb8709de$export$380b9818819a9649(url) {
    console.log(`[relays.ts] Removing relay: ${url}`);
    const db = await (0, $9Wi0l.getDB)();
    await db.delete('relays', url);
    console.log(`[relays.ts] Relay removed from database: ${url}`);
}
async function $8d48d49ecb8709de$export$a72e4803bb943d13(url, status, error) {
    const relay = await $8d48d49ecb8709de$export$1e0f363384bbe072(url);
    if (!relay) return;
    relay.status = status;
    if (status === 'connected') {
        relay.lastConnected = Date.now();
        relay.lastError = null;
        relay.errorCount = 0;
    } else if (status === 'error') {
        relay.lastError = error || 'Unknown error';
        relay.errorCount += 1;
    }
    await $8d48d49ecb8709de$export$bbd12754eb06c9d3(relay);
}
async function $8d48d49ecb8709de$export$93229fdda1ad5757(url, latency) {
    const relay = await $8d48d49ecb8709de$export$1e0f363384bbe072(url);
    if (!relay) return;
    relay.latency = latency;
    await $8d48d49ecb8709de$export$bbd12754eb06c9d3(relay);
}
async function $8d48d49ecb8709de$export$efb54e15d50961e3(url) {
    const relay = await $8d48d49ecb8709de$export$1e0f363384bbe072(url);
    if (!relay) return;
    relay.eventsReceived += 1;
    await $8d48d49ecb8709de$export$bbd12754eb06c9d3(relay);
}
async function $8d48d49ecb8709de$export$50a3d8454f4872a1(url) {
    const relay = await $8d48d49ecb8709de$export$1e0f363384bbe072(url);
    if (!relay) return;
    console.log(`[relays.ts] Toggling relay ${url} from ${relay.enabled} to ${!relay.enabled}`);
    relay.enabled = !relay.enabled;
    // When disabling a relay, mark it as disconnected
    // When enabling, also mark as disconnected (will be updated on next connection test)
    relay.status = 'disconnected';
    relay.lastError = null;
    await $8d48d49ecb8709de$export$bbd12754eb06c9d3(relay);
    console.log(`[relays.ts] Relay ${url} now enabled: ${relay.enabled}, status: ${relay.status}`);
}
async function $8d48d49ecb8709de$export$1fdf2e6dc67ae1d() {
    const existing = await $8d48d49ecb8709de$export$291703e8598838a8();
    // Only add defaults if no relays exist
    if (existing.length === 0) {
        const defaultRelays = [
            'wss://relay-rpi.edufeed.org',
            'wss://amb-relay.edufeed.org',
            'wss://relay.edufeed.org'
        ];
        for (const url of defaultRelays)await $8d48d49ecb8709de$export$93d95b36d3befb01(url);
    }
}

});


parcelRegister("Hm7tz", function(module, exports) {

$parcel$export(module.exports, "eventsToGraph", () => $1f4d741281732489$export$f5c92081b3f13745);
$parcel$export(module.exports, "filterEvents", () => $1f4d741281732489$export$abcd98354d9fb0f7);
function $1f4d741281732489$export$2acf9a1ed90eba93(event) {
    const label = $1f4d741281732489$var$getEventLabel(event);
    return {
        id: event.id,
        label: label,
        data: {
            event: event,
            kind: event.kind,
            pubkey: event.pubkey,
            created_at: event.created_at,
            content: event.content.slice(0, 100)
        }
    };
}
function $1f4d741281732489$export$ed2e2c9a94911117(event) {
    const edges = [];
    // Determine base edge type from event kind
    let baseType = 'reference';
    if (event.kind === 6) baseType = 'repost' // Kind 6 = repost
    ;
    else if (event.kind === 7) baseType = 'reaction' // Kind 7 = reaction
    ;
    for (const tag of event.tags){
        // Event references (replies, quotes, reactions, reposts)
        if (tag[0] === 'e' && tag[1]) {
            const marker = tag[3] || 'mention' // root, reply, mention
            ;
            edges.push({
                source: event.id,
                target: tag[1],
                data: {
                    type: baseType === 'reference' ? 'reference' : baseType,
                    marker: marker
                }
            });
        }
        // Pubkey references (mentions)
        if (tag[0] === 'p' && tag[1]) edges.push({
            source: event.id,
            target: tag[1],
            data: {
                type: 'mention',
                pubkey: tag[1]
            }
        });
    }
    // Note: authored-by edges are created only when author nodes exist
    // This is handled explicitly in expansion functions
    // Note: board-card edges (via 'a' tag) are created by connectCardsToBoard() in GraphView
    return edges;
}
/**
 * Get display label for event based on kind
 */ function $1f4d741281732489$var$getEventLabel(event) {
    const kindLabels = {
        0: "\uD83D\uDC64 Profile",
        1: "\uD83D\uDCDD Note",
        3: "\uD83D\uDC65 Contacts",
        4: "\uD83D\uDCAC DM",
        5: "\uD83D\uDDD1\uFE0F Delete",
        6: "\uD83D\uDD04 Repost",
        7: "\u2764\uFE0F Reaction",
        9735: "\u26A1 Zap",
        30023: "\uD83D\uDCC4 Article",
        30301: "\uD83D\uDCCB Board",
        30302: "\uD83D\uDDC2\uFE0F Card",
        30303: "\uD83D\uDCF8 Snapshot"
    };
    const prefix = kindLabels[event.kind] || `Kind ${event.kind}`;
    // For text notes, show first few words
    if (event.kind === 1) {
        const words = event.content.split(/\s+/).slice(0, 5).join(' ');
        return words.length > 30 ? words.slice(0, 30) + '...' : words;
    }
    // For profiles, try to show name
    if (event.kind === 0) try {
        const profile = JSON.parse(event.content);
        return profile.name || profile.display_name || 'Profile';
    } catch  {
        return 'Profile';
    }
    return prefix;
}
function $1f4d741281732489$export$f5c92081b3f13745(events, existingNodeIds) {
    const nodes = [];
    const edges = [];
    const nodeIds = new Set();
    // First pass: collect profile data (kind 0 events)
    const profileMap = new Map();
    for (const event of events){
        if (event.kind === 0) try {
            const profile = JSON.parse(event.content);
            profileMap.set(event.pubkey, {
                name: profile.name,
                display_name: profile.display_name,
                picture: profile.picture,
                about: profile.about,
                nip05: profile.nip05
            });
        } catch (e) {
            console.warn('Failed to parse profile event:', event.id);
        }
    }
    for (const event of events){
        // Add event node
        if (!nodeIds.has(event.id)) {
            nodes.push($1f4d741281732489$export$2acf9a1ed90eba93(event));
            nodeIds.add(event.id);
        }
        // Extract edges (no automatic author nodes)
        const eventEdges = $1f4d741281732489$export$ed2e2c9a94911117(event);
        edges.push(...eventEdges);
    }
    // Combine new node IDs with existing node IDs for edge validation
    const allNodeIds = existingNodeIds ? new Set([
        ...nodeIds,
        ...existingNodeIds
    ]) : nodeIds;
    // Filter edges to only include those where both source and target nodes exist
    const validEdges = edges.filter((edge)=>allNodeIds.has(edge.source) && allNodeIds.has(edge.target));
    console.log(`Graph projection: ${nodes.length} nodes, ${validEdges.length}/${edges.length} edges (${edges.length - validEdges.length} filtered out)`);
    return {
        nodes: nodes,
        edges: validEdges
    };
}
function $1f4d741281732489$export$abcd98354d9fb0f7(events, filters) {
    let filtered = events;
    if (filters.kinds && filters.kinds.length > 0) filtered = filtered.filter((e)=>filters.kinds.includes(e.kind));
    if (filters.authors && filters.authors.length > 0) filtered = filtered.filter((e)=>filters.authors.includes(e.pubkey));
    if (filters.timeRange) {
        const [start, end] = filters.timeRange;
        filtered = filtered.filter((e)=>e.created_at >= start && e.created_at <= end);
    }
    if (filters.searchText) {
        const search = filters.searchText.toLowerCase();
        filtered = filtered.filter((e)=>e.content.toLowerCase().includes(search));
    }
    return filtered;
}
function $1f4d741281732489$export$19f3f543a4bbec6e() {
    return {
        eventToNode: $1f4d741281732489$export$2acf9a1ed90eba93,
        extractEdges: $1f4d741281732489$export$ed2e2c9a94911117,
        eventsToGraph: $1f4d741281732489$export$f5c92081b3f13745,
        filterEvents: $1f4d741281732489$export$abcd98354d9fb0f7
    };
}

});


parcelRegister("2ySf9", function(module, exports) {

$parcel$export(module.exports, "useEventFetcher", () => $e72e90f9684b30a8$export$1785dc9932df1aff);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $ccy11 = parcelRequire("ccy11");
parcelRequire("cAQvd");
var $7PL6S = parcelRequire("7PL6S");
function $e72e90f9684b30a8$export$1785dc9932df1aff() {
    const { fetchEvents: fetchEvents, subscribe: subscribe } = (0, $ccy11.useNostr)();
    const isFetching = (0, $01W3b.ref)(false);
    const progress = (0, $01W3b.ref)({
        total: 0,
        fetched: 0,
        stored: 0
    });
    /**
   * Fetch initial events for a user/topic
   */ async function fetchInitialEvents(filters) {
        isFetching.value = true;
        progress.value = {
            total: 0,
            fetched: 0,
            stored: 0
        };
        try {
            const events = await fetchEvents(filters);
            progress.value.fetched = events.length;
            progress.value.total = events.length;
            // Store in batches for better performance
            await (0, $7PL6S.storeEvents)(events);
            progress.value.stored = events.length;
            return events;
        } finally{
            isFetching.value = false;
        }
    }
    /**
   * Fetch and expand around a specific event (get replies, references, etc.)
   */ async function expandAroundEvent(eventId) {
        isFetching.value = true;
        try {
            // Fetch events that reference this event (replies, quotes, etc.)
            const replyFilter = {
                '#e': [
                    eventId
                ],
                limit: 100
            };
            const replies = await fetchEvents([
                replyFilter
            ]);
            await (0, $7PL6S.storeEvents)(replies);
            return {
                replies: replies,
                mentions: []
            };
        } finally{
            isFetching.value = false;
        }
    }
    /**
   * Fetch user's social graph (follows, followers)
   */ async function fetchUserGraph(pubkey) {
        isFetching.value = true;
        try {
            // Get user's contact list (kind 3)
            const contactFilter = {
                authors: [
                    pubkey
                ],
                kinds: [
                    3
                ],
                limit: 1
            };
            const contactEvents = await fetchEvents([
                contactFilter
            ]);
            const follows = [];
            if (contactEvents.length > 0) {
                const contactList = contactEvents[0];
                // Extract followed pubkeys from tags
                follows.push(...contactList.tags.filter((tag)=>tag[0] === 'p').map((tag)=>tag[1]));
            }
            // Fetch recent events from user and their follows
            const eventFilters = [
                {
                    authors: [
                        pubkey,
                        ...follows.slice(0, 50)
                    ],
                    kinds: [
                        1,
                        6,
                        7,
                        9735
                    ],
                    limit: 200
                }
            ];
            const events = await fetchEvents(eventFilters);
            await (0, $7PL6S.storeEvents)(events);
            return {
                follows: follows,
                events: events
            };
        } finally{
            isFetching.value = false;
        }
    }
    /**
   * Subscribe to live updates for specific filters
   */ function subscribeLive(filters, onNewEvent) {
        const subId = subscribe(filters, async (event)=>{
            // Store new event in IndexedDB
            await (0, $7PL6S.storeEvent)(event);
            // Call user callback if provided
            if (onNewEvent) onNewEvent(event);
        }, ()=>{
            console.log('Subscription EOSE reached');
        });
        return subId;
    }
    /**
   * Fetch events by kind
   */ async function fetchByKind(kinds, limit = 100) {
        const filter = {
            kinds: kinds,
            limit: limit
        };
        return fetchInitialEvents([
            filter
        ]);
    }
    /**
   * Fetch events by author
   */ async function fetchByAuthor(pubkey, limit = 100) {
        const filter = {
            authors: [
                pubkey
            ],
            limit: limit
        };
        return fetchInitialEvents([
            filter
        ]);
    }
    /**
   * Fetch global feed
   */ async function fetchGlobalFeed(limit = 20) {
        const filter = {
            kinds: [
                1
            ],
            limit: limit
        };
        return fetchInitialEvents([
            filter
        ]);
    }
    /**
   * Expand with reactions (kind 7) for a specific event
   */ async function expandReactions(eventId) {
        isFetching.value = true;
        try {
            const filter = {
                kinds: [
                    7
                ],
                '#e': [
                    eventId
                ],
                limit: 100
            };
            const events = await fetchEvents([
                filter
            ]);
            await (0, $7PL6S.storeEvents)(events);
            return events;
        } finally{
            isFetching.value = false;
        }
    }
    /**
   * Expand with replies for a specific event
   */ async function expandReplies(eventId) {
        isFetching.value = true;
        try {
            const filter = {
                kinds: [
                    1,
                    30023
                ],
                '#e': [
                    eventId
                ],
                limit: 100
            };
            const events = await fetchEvents([
                filter
            ]);
            await (0, $7PL6S.storeEvents)(events);
            return events;
        } finally{
            isFetching.value = false;
        }
    }
    /**
   * Expand with reposts (kind 6) for a specific event
   */ async function expandReposts(eventId) {
        isFetching.value = true;
        try {
            const filter = {
                kinds: [
                    6
                ],
                '#e': [
                    eventId
                ],
                limit: 100
            };
            const events = await fetchEvents([
                filter
            ]);
            await (0, $7PL6S.storeEvents)(events);
            return events;
        } finally{
            isFetching.value = false;
        }
    }
    /**
   * Expand with events mentioned in this event's tags
   */ async function expandMentions(eventId) {
        isFetching.value = true;
        try {
            // First get the event from the database to read its tags
            const sourceEvent = await (0, $7PL6S.getEvent)(eventId);
            if (!sourceEvent) return [];
            // Extract event IDs from 'e' tags
            const mentionedIds = sourceEvent.tags.filter((tag)=>tag[0] === 'e' && tag[1]).map((tag)=>tag[1]);
            if (mentionedIds.length === 0) return [];
            // Fetch the mentioned events
            const filter = {
                ids: mentionedIds,
                limit: 100
            };
            const events = await fetchEvents([
                filter
            ]);
            await (0, $7PL6S.storeEvents)(events);
            return events;
        } finally{
            isFetching.value = false;
        }
    }
    /**
   * Expand full thread (parent + all replies)
   */ async function expandThread(eventId) {
        isFetching.value = true;
        try {
            // Get the event to find parent
            const sourceEvent = await (0, $7PL6S.getEvent)(eventId);
            let parent = null;
            if (sourceEvent) {
                // Find parent from 'e' tags (look for reply/root markers)
                const eTags = sourceEvent.tags.filter((tag)=>tag[0] === 'e');
                const replyTag = eTags.find((tag)=>tag[3] === 'reply') || eTags.find((tag)=>tag[3] === 'root');
                if (replyTag && replyTag[1]) {
                    const parentId = replyTag[1];
                    const parentFilter = {
                        ids: [
                            parentId
                        ],
                        limit: 1
                    };
                    const parents = await fetchEvents([
                        parentFilter
                    ]);
                    await (0, $7PL6S.storeEvents)(parents);
                    parent = parents[0] || null;
                }
            }
            // Fetch all replies
            const replyFilter = {
                kinds: [
                    1,
                    30023
                ],
                '#e': [
                    eventId
                ],
                limit: 100
            };
            const replies = await fetchEvents([
                replyFilter
            ]);
            await (0, $7PL6S.storeEvents)(replies);
            return {
                parent: parent,
                replies: replies
            };
        } finally{
            isFetching.value = false;
        }
    }
    return {
        isFetching: isFetching,
        progress: progress,
        fetchInitialEvents: fetchInitialEvents,
        expandAroundEvent: expandAroundEvent,
        fetchUserGraph: fetchUserGraph,
        subscribeLive: subscribeLive,
        fetchByKind: fetchByKind,
        fetchByAuthor: fetchByAuthor,
        fetchGlobalFeed: fetchGlobalFeed,
        expandReactions: expandReactions,
        expandReplies: expandReplies,
        expandReposts: expandReposts,
        expandMentions: expandMentions,
        expandThread: expandThread
    };
}

});
parcelRegister("ccy11", function(module, exports) {

$parcel$export(module.exports, "useNostr", () => $c0c24376abb20391$export$26ee544085fea503);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $fS6LT = parcelRequire("fS6LT");

var $eWYts = parcelRequire("eWYts");
// Shared pool instance across all composable instances
let $c0c24376abb20391$var$poolInstance = null;
// Shared relay list across all composable instances
const $c0c24376abb20391$var$relays = (0, $01W3b.ref)([]);
let $c0c24376abb20391$var$relaysLoaded = false;
// Track relay response times for connection status
const $c0c24376abb20391$var$relayResponseTimers = new Map();
const $c0c24376abb20391$var$CONNECTION_TIMEOUT = 5000 // 5 seconds
;
function $c0c24376abb20391$export$26ee544085fea503() {
    const connected = (0, $01W3b.ref)(false);
    const subscriptions = new Map();
    // Load relays from database on mount (only once)
    (0, $TusQn.onMounted)(async ()=>{
        if (!$c0c24376abb20391$var$relaysLoaded) {
            await loadRelaysFromDB();
            $c0c24376abb20391$var$relaysLoaded = true;
            // Test relay connections in background
            testAllRelayConnections().catch(console.error);
        }
    });
    // Load enabled relays from database
    async function loadRelaysFromDB() {
        console.log('[useNostr] loadRelaysFromDB called');
        try {
            // Initialize defaults if needed
            await (0, $eWYts.initializeDefaultRelays)();
            // Load enabled relays
            const enabledRelays = await (0, $eWYts.getEnabledRelays)();
            const newRelayUrls = enabledRelays.map((r)=>r.url);
            // Check if relay list has changed
            const relaysChanged = $c0c24376abb20391$var$relays.value.length !== newRelayUrls.length || !$c0c24376abb20391$var$relays.value.every((url)=>newRelayUrls.includes(url));
            if (relaysChanged && $c0c24376abb20391$var$poolInstance) {
                // Find relays that were removed or disabled
                const removedRelays = $c0c24376abb20391$var$relays.value.filter((url)=>!newRelayUrls.includes(url));
                if (removedRelays.length > 0) {
                    console.log('[useNostr] Closing connections to disabled/removed relays:', removedRelays);
                    // Close connections to relays that are no longer enabled
                    $c0c24376abb20391$var$poolInstance.close(removedRelays);
                }
            }
            $c0c24376abb20391$var$relays.value = newRelayUrls;
            console.log(`[useNostr] Loaded ${$c0c24376abb20391$var$relays.value.length} enabled relays:`, $c0c24376abb20391$var$relays.value);
            console.log('[useNostr] Full relay details:', enabledRelays);
            // Initialize all relays as disconnected
            for (const url of $c0c24376abb20391$var$relays.value)await (0, $eWYts.updateRelayStatus)(url, 'disconnected');
        } catch (error) {
            console.error('Failed to load relays from database:', error);
            // Fallback to default relays if DB fails
            $c0c24376abb20391$var$relays.value = [
                'wss://relay-rpi.edufeed.org',
                'wss://amb-relay.edufeed.org',
                'wss://relay.edufeed.org'
            ];
        }
    }
    /**
   * Mark relays as connecting and set timeout for error detection
   */ async function markRelaysConnecting() {
        for (const url of $c0c24376abb20391$var$relays.value){
            await (0, $eWYts.updateRelayStatus)(url, 'connecting');
            // Set timeout to detect non-responsive relays
            const timeout = setTimeout(async ()=>{
                // If still connecting after timeout, mark as error
                await (0, $eWYts.updateRelayStatus)(url, 'error', 'Connection timeout');
                $c0c24376abb20391$var$relayResponseTimers.delete(url);
            }, $c0c24376abb20391$var$CONNECTION_TIMEOUT);
            $c0c24376abb20391$var$relayResponseTimers.set(url, timeout);
        }
    }
    /**
   * Mark a relay as successfully connected
   */ async function markRelayConnected(url) {
        // Clear timeout if it exists
        const timeout = $c0c24376abb20391$var$relayResponseTimers.get(url);
        if (timeout) {
            clearTimeout(timeout);
            $c0c24376abb20391$var$relayResponseTimers.delete(url);
        }
        await (0, $eWYts.updateRelayStatus)(url, 'connected');
    }
    /**
   * Test individual relay connection to detect WebSocket errors
   */ async function testRelayConnection(url) {
        console.log(`[useNostr] Testing connection to ${url}...`);
        try {
            const relay = new (0, $fS6LT.Relay)(url);
            let resolved = false;
            return new Promise((resolve)=>{
                const timeout = setTimeout(()=>{
                    if (!resolved) {
                        resolved = true;
                        relay.close();
                        console.log(`[useNostr] ${url} - Connection timeout`);
                        (0, $eWYts.updateRelayStatus)(url, 'error', 'Connection timeout').catch(console.error);
                        resolve(false);
                    }
                }, $c0c24376abb20391$var$CONNECTION_TIMEOUT);
                // Attempt to connect
                relay.connect().then(()=>{
                    console.log(`[useNostr] ${url} - Connected successfully`);
                    clearTimeout(timeout);
                    if (!resolved) {
                        // Successfully connected, test with a simple subscription
                        const sub = relay.subscribe([
                            {
                                kinds: [
                                    1
                                ],
                                limit: 1
                            }
                        ], {
                            onevent: ()=>{
                                if (!resolved) {
                                    resolved = true;
                                    // Got an event
                                    sub.close();
                                    relay.close();
                                    console.log(`[useNostr] ${url} - Received event, marking as connected`);
                                    markRelayConnected(url).catch(console.error);
                                    resolve(true);
                                }
                            },
                            oneose: ()=>{
                                if (!resolved) {
                                    resolved = true;
                                    // End of stored events - relay is working even if no events
                                    sub.close();
                                    relay.close();
                                    console.log(`[useNostr] ${url} - Got EOSE, marking as connected`);
                                    markRelayConnected(url).catch(console.error);
                                    resolve(true);
                                }
                            }
                        });
                        // Set a timeout for the subscription
                        setTimeout(()=>{
                            if (!resolved) {
                                resolved = true;
                                sub.close();
                                relay.close();
                                console.log(`[useNostr] ${url} - Subscription timeout, marking as connected`);
                                markRelayConnected(url).catch(console.error);
                                resolve(true);
                            }
                        }, 2000);
                    }
                }).catch((error)=>{
                    clearTimeout(timeout);
                    if (!resolved) {
                        resolved = true;
                        relay.close();
                        const errorMsg = error.message || 'Connection failed';
                        console.error(`[useNostr] ${url} - Connection error:`, errorMsg);
                        (0, $eWYts.updateRelayStatus)(url, 'error', errorMsg).catch(console.error);
                        resolve(false);
                    }
                });
            });
        } catch (error) {
            const errorMsg = error instanceof Error ? error.message : 'Connection failed';
            console.error(`[useNostr] ${url} - Exception:`, errorMsg);
            await (0, $eWYts.updateRelayStatus)(url, 'error', errorMsg);
            return false;
        }
    }
    /**
   * Test all relay connections
   */ async function testAllRelayConnections() {
        console.log(`[useNostr] Testing ${$c0c24376abb20391$var$relays.value.length} relay connections...`);
        const promises = $c0c24376abb20391$var$relays.value.map((url)=>testRelayConnection(url));
        const results = await Promise.allSettled(promises);
        const successful = results.filter((r)=>r.status === 'fulfilled' && r.value).length;
        console.log(`[useNostr] Connection test complete: ${successful}/${$c0c24376abb20391$var$relays.value.length} successful`);
    }
    // Get or create pool
    function getPool() {
        if (!$c0c24376abb20391$var$poolInstance) $c0c24376abb20391$var$poolInstance = new (0, $fS6LT.SimplePool)();
        return $c0c24376abb20391$var$poolInstance;
    }
    /**
   * Add a relay to the pool
   */ function addRelay(url) {
        if (!$c0c24376abb20391$var$relays.value.includes(url)) $c0c24376abb20391$var$relays.value.push(url);
    }
    /**
   * Remove a relay from the pool
   */ function removeRelay(url) {
        $c0c24376abb20391$var$relays.value = $c0c24376abb20391$var$relays.value.filter((r)=>r !== url);
    }
    /**
   * Subscribe to events matching filters
   */ function subscribe(filters, onEvent, onEOSE) {
        const pool = getPool();
        const subId = crypto.randomUUID();
        // Mark relays as connecting
        markRelaysConnecting().catch(console.error);
        // Merge filters into a single filter object
        const filter = filters.reduce((acc, f)=>{
            // Merge arrays for kinds, authors, etc.
            if (f.kinds) acc.kinds = [
                ...acc.kinds || [],
                ...f.kinds
            ];
            if (f.authors) acc.authors = [
                ...acc.authors || [],
                ...f.authors
            ];
            if (f.limit) acc.limit = Math.max(acc.limit || 0, f.limit);
            return acc;
        }, {});
        // Track first event/EOSE per relay to mark as connected
        const connectedRelays = new Set();
        // Use subscribeMany with correct params
        const sub = pool.subscribeMany($c0c24376abb20391$var$relays.value, filter, {
            onevent: (event)=>{
                // Call original handler
                onEvent(event);
            },
            oneose: ()=>{
                // Mark all relays as connected when we get EOSE and increment activity
                for (const url of $c0c24376abb20391$var$relays.value)if (!connectedRelays.has(url)) {
                    markRelayConnected(url).catch(console.error);
                    connectedRelays.add(url);
                    // Increment once per EOSE as a simple activity indicator
                    (0, $eWYts.incrementRelayEventCount)(url).catch(console.error);
                }
                // Call original handler
                if (onEOSE) onEOSE();
            },
            id: subId
        });
        // Store cleanup function
        subscriptions.set(subId, ()=>sub.close());
        connected.value = true;
        return subId;
    }
    /**
   * Unsubscribe from a specific subscription
   */ function unsubscribe(subId) {
        const cleanup = subscriptions.get(subId);
        if (cleanup) {
            cleanup();
            subscriptions.delete(subId);
        }
    }
    /**
   * Fetch events (one-time query, closes automatically)
   */ async function fetchEvents(filters) {
        const pool = getPool();
        try {
            console.log('Fetching from relays:', $c0c24376abb20391$var$relays.value);
            console.log('Filters:', JSON.stringify(filters, null, 2));
            // Mark relays as connecting
            await markRelaysConnecting();
            // Merge multiple filters into one
            const filter = filters.reduce((acc, f)=>{
                // Merge arrays for kinds, authors, etc.
                if (f.kinds) acc.kinds = [
                    ...acc.kinds || [],
                    ...f.kinds
                ];
                if (f.authors) acc.authors = [
                    ...acc.authors || [],
                    ...f.authors
                ];
                if (f.limit) acc.limit = Math.max(acc.limit || 0, f.limit);
                // Copy other filter properties
                Object.keys(f).forEach((key)=>{
                    if (![
                        'kinds',
                        'authors',
                        'limit'
                    ].includes(key)) acc[key] = f[key];
                });
                return acc;
            }, {});
            console.log('Merged filter:', JSON.stringify(filter, null, 2));
            // Use querySync with a single filter
            const events = await pool.querySync($c0c24376abb20391$var$relays.value, filter);
            // Mark all relays as connected and increment their activity count
            if (events.length > 0) for (const url of $c0c24376abb20391$var$relays.value){
                await markRelayConnected(url);
                // Increment once per successful fetch as a simple activity indicator
                await (0, $eWYts.incrementRelayEventCount)(url);
            }
            connected.value = true;
            console.log('Received events:', events.length);
            return events;
        } catch (error) {
            console.error('Failed to fetch events:', error);
            // Mark all relays as error
            for (const url of $c0c24376abb20391$var$relays.value)await (0, $eWYts.updateRelayStatus)(url, 'error', error instanceof Error ? error.message : 'Unknown error');
            throw error;
        }
    }
    /**
   * Publish an event to relays
   */ async function publishEvent(event) {
        const pool = getPool();
        const publishedTo = [];
        await Promise.allSettled($c0c24376abb20391$var$relays.value.map(async (relay)=>{
            try {
                await pool.publish([
                    relay
                ], event);
                publishedTo.push(relay);
            } catch (err) {
                console.error(`Failed to publish to ${relay}:`, err);
            }
        }));
        return publishedTo;
    }
    /**
   * Close all subscriptions and pool connections
   */ function closeAll() {
        console.log('[useNostr] Closing all subscriptions and connections');
        subscriptions.forEach((cleanup)=>cleanup());
        subscriptions.clear();
        // Close pool connections to all relays
        if ($c0c24376abb20391$var$poolInstance && $c0c24376abb20391$var$relays.value.length > 0) {
            $c0c24376abb20391$var$poolInstance.close($c0c24376abb20391$var$relays.value);
            console.log('[useNostr] Pool connections closed');
        }
        connected.value = false;
    }
    /**
   * Cleanup on unmount
   */ (0, $TusQn.onUnmounted)(()=>{
        closeAll();
    });
    return {
        connected: connected,
        relays: $c0c24376abb20391$var$relays,
        addRelay: addRelay,
        removeRelay: removeRelay,
        subscribe: subscribe,
        unsubscribe: unsubscribe,
        fetchEvents: fetchEvents,
        publishEvent: publishEvent,
        closeAll: closeAll,
        getPool: getPool,
        loadRelaysFromDB: loadRelaysFromDB,
        testAllRelayConnections: testAllRelayConnections
    };
}

});
parcelRegister("fS6LT", function(module, exports) {

$parcel$export(module.exports, "Relay", () => $b8e126da42a4b9e3$export$325be0d991c73dc2);
$parcel$export(module.exports, "SimplePool", () => $b8e126da42a4b9e3$export$db45add7d1880f0c);
$parcel$export(module.exports, "nip19", () => $b8e126da42a4b9e3$export$10660ae21dbef115);

var $5r7db = parcelRequire("5r7db");

var $3Bcdj = parcelRequire("3Bcdj");

var $htQ8Z = parcelRequire("htQ8Z");

var $83RRd = parcelRequire("83RRd");

var $3RPiR = parcelRequire("3RPiR");

var $lAjhr = parcelRequire("lAjhr");

var $38xio = parcelRequire("38xio");

var $aN9nT = parcelRequire("aN9nT");

var $70Xw9 = parcelRequire("70Xw9");
var $b8e126da42a4b9e3$var$__defProp = Object.defineProperty;
var $b8e126da42a4b9e3$var$__export = (target, all)=>{
    for(var name in all)$b8e126da42a4b9e3$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// core.ts
var $b8e126da42a4b9e3$export$31a1b605a7b8e0bf = Symbol("verified");
var $b8e126da42a4b9e3$var$isRecord = (obj)=>obj instanceof Object;
function $b8e126da42a4b9e3$export$d08d852dd562b1ce(event) {
    if (!$b8e126da42a4b9e3$var$isRecord(event)) return false;
    if (typeof event.kind !== "number") return false;
    if (typeof event.content !== "string") return false;
    if (typeof event.created_at !== "number") return false;
    if (typeof event.pubkey !== "string") return false;
    if (!event.pubkey.match(/^[a-f0-9]{64}$/)) return false;
    if (!Array.isArray(event.tags)) return false;
    for(let i2 = 0; i2 < event.tags.length; i2++){
        let tag = event.tags[i2];
        if (!Array.isArray(tag)) return false;
        for(let j = 0; j < tag.length; j++){
            if (typeof tag[j] !== "string") return false;
        }
    }
    return true;
}
function $b8e126da42a4b9e3$export$d425309ca6befbaf(events) {
    return events.sort((a, b)=>{
        if (a.created_at !== b.created_at) return b.created_at - a.created_at;
        return a.id.localeCompare(b.id);
    });
}
// utils.ts
var $b8e126da42a4b9e3$export$eab97d15b1788b8d = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$eab97d15b1788b8d, {
    binarySearch: ()=>$b8e126da42a4b9e3$var$binarySearch,
    bytesToHex: ()=>(0, $3Bcdj.bytesToHex),
    hexToBytes: ()=>(0, $3Bcdj.hexToBytes),
    insertEventIntoAscendingList: ()=>$b8e126da42a4b9e3$var$insertEventIntoAscendingList,
    insertEventIntoDescendingList: ()=>$b8e126da42a4b9e3$var$insertEventIntoDescendingList,
    mergeReverseSortedLists: ()=>$b8e126da42a4b9e3$var$mergeReverseSortedLists,
    normalizeURL: ()=>$b8e126da42a4b9e3$var$normalizeURL,
    utf8Decoder: ()=>$b8e126da42a4b9e3$var$utf8Decoder,
    utf8Encoder: ()=>$b8e126da42a4b9e3$var$utf8Encoder
});
var $b8e126da42a4b9e3$var$utf8Decoder = new TextDecoder("utf-8");
var $b8e126da42a4b9e3$var$utf8Encoder = new TextEncoder();
function $b8e126da42a4b9e3$var$normalizeURL(url) {
    try {
        if (url.indexOf("://") === -1) url = "wss://" + url;
        let p = new URL(url);
        if (p.protocol === "http:") p.protocol = "ws:";
        else if (p.protocol === "https:") p.protocol = "wss:";
        p.pathname = p.pathname.replace(/\/+/g, "/");
        if (p.pathname.endsWith("/")) p.pathname = p.pathname.slice(0, -1);
        if (p.port === "80" && p.protocol === "ws:" || p.port === "443" && p.protocol === "wss:") p.port = "";
        p.searchParams.sort();
        p.hash = "";
        return p.toString();
    } catch (e) {
        throw new Error(`Invalid URL: ${url}`);
    }
}
function $b8e126da42a4b9e3$var$insertEventIntoDescendingList(sortedArray, event) {
    const [idx, found] = $b8e126da42a4b9e3$var$binarySearch(sortedArray, (b)=>{
        if (event.id === b.id) return 0;
        if (event.created_at === b.created_at) return -1;
        return b.created_at - event.created_at;
    });
    if (!found) sortedArray.splice(idx, 0, event);
    return sortedArray;
}
function $b8e126da42a4b9e3$var$insertEventIntoAscendingList(sortedArray, event) {
    const [idx, found] = $b8e126da42a4b9e3$var$binarySearch(sortedArray, (b)=>{
        if (event.id === b.id) return 0;
        if (event.created_at === b.created_at) return -1;
        return event.created_at - b.created_at;
    });
    if (!found) sortedArray.splice(idx, 0, event);
    return sortedArray;
}
function $b8e126da42a4b9e3$var$binarySearch(arr, compare) {
    let start = 0;
    let end = arr.length - 1;
    while(start <= end){
        const mid = Math.floor((start + end) / 2);
        const cmp = compare(arr[mid]);
        if (cmp === 0) return [
            mid,
            true
        ];
        if (cmp < 0) end = mid - 1;
        else start = mid + 1;
    }
    return [
        start,
        false
    ];
}
function $b8e126da42a4b9e3$var$mergeReverseSortedLists(list1, list2) {
    const result = new Array(list1.length + list2.length);
    result.length = 0;
    let i1 = 0;
    let i2 = 0;
    let sameTimestampIds = [];
    while(i1 < list1.length && i2 < list2.length){
        let next;
        if (list1[i1]?.created_at > list2[i2]?.created_at) {
            next = list1[i1];
            i1++;
        } else {
            next = list2[i2];
            i2++;
        }
        if (result.length > 0 && result[result.length - 1].created_at === next.created_at) {
            if (sameTimestampIds.includes(next.id)) continue;
        } else sameTimestampIds.length = 0;
        result.push(next);
        sameTimestampIds.push(next.id);
    }
    while(i1 < list1.length){
        const next = list1[i1];
        i1++;
        if (result.length > 0 && result[result.length - 1].created_at === next.created_at) {
            if (sameTimestampIds.includes(next.id)) continue;
        } else sameTimestampIds.length = 0;
        result.push(next);
        sameTimestampIds.push(next.id);
    }
    while(i2 < list2.length){
        const next = list2[i2];
        i2++;
        if (result.length > 0 && result[result.length - 1].created_at === next.created_at) {
            if (sameTimestampIds.includes(next.id)) continue;
        } else sameTimestampIds.length = 0;
        result.push(next);
        sameTimestampIds.push(next.id);
    }
    return result;
}
// pure.ts
var $b8e126da42a4b9e3$var$JS = class {
    generateSecretKey() {
        return (0, $5r7db.schnorr).utils.randomSecretKey();
    }
    getPublicKey(secretKey) {
        return (0, $3Bcdj.bytesToHex)((0, $5r7db.schnorr).getPublicKey(secretKey));
    }
    finalizeEvent(t, secretKey) {
        const event = t;
        event.pubkey = (0, $3Bcdj.bytesToHex)((0, $5r7db.schnorr).getPublicKey(secretKey));
        event.id = $b8e126da42a4b9e3$export$11a838ad4e557e0e(event);
        event.sig = (0, $3Bcdj.bytesToHex)((0, $5r7db.schnorr).sign((0, $3Bcdj.hexToBytes)($b8e126da42a4b9e3$export$11a838ad4e557e0e(event)), secretKey));
        event[$b8e126da42a4b9e3$export$31a1b605a7b8e0bf] = true;
        return event;
    }
    verifyEvent(event) {
        if (typeof event[$b8e126da42a4b9e3$export$31a1b605a7b8e0bf] === "boolean") return event[$b8e126da42a4b9e3$export$31a1b605a7b8e0bf];
        const hash = $b8e126da42a4b9e3$export$11a838ad4e557e0e(event);
        if (hash !== event.id) {
            event[$b8e126da42a4b9e3$export$31a1b605a7b8e0bf] = false;
            return false;
        }
        try {
            const valid = (0, $5r7db.schnorr).verify((0, $3Bcdj.hexToBytes)(event.sig), (0, $3Bcdj.hexToBytes)(hash), (0, $3Bcdj.hexToBytes)(event.pubkey));
            event[$b8e126da42a4b9e3$export$31a1b605a7b8e0bf] = valid;
            return valid;
        } catch (err) {
            event[$b8e126da42a4b9e3$export$31a1b605a7b8e0bf] = false;
            return false;
        }
    }
};
function $b8e126da42a4b9e3$export$d32d86987f616a9e(evt) {
    if (!$b8e126da42a4b9e3$export$d08d852dd562b1ce(evt)) throw new Error("can't serialize event with wrong or missing properties");
    return JSON.stringify([
        0,
        evt.pubkey,
        evt.created_at,
        evt.kind,
        evt.tags,
        evt.content
    ]);
}
function $b8e126da42a4b9e3$export$11a838ad4e557e0e(event) {
    let eventHash = (0, $htQ8Z.sha256)($b8e126da42a4b9e3$var$utf8Encoder.encode($b8e126da42a4b9e3$export$d32d86987f616a9e(event)));
    return (0, $3Bcdj.bytesToHex)(eventHash);
}
var $b8e126da42a4b9e3$var$i = new $b8e126da42a4b9e3$var$JS();
var $b8e126da42a4b9e3$export$16ca411381fc81c8 = $b8e126da42a4b9e3$var$i.generateSecretKey;
var $b8e126da42a4b9e3$export$889def73691f9837 = $b8e126da42a4b9e3$var$i.getPublicKey;
var $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20 = $b8e126da42a4b9e3$var$i.finalizeEvent;
var $b8e126da42a4b9e3$export$909d658b5069e986 = $b8e126da42a4b9e3$var$i.verifyEvent;
// kinds.ts
var $b8e126da42a4b9e3$export$9ef7793a01f1f377 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$9ef7793a01f1f377, {
    Application: ()=>$b8e126da42a4b9e3$var$Application,
    BadgeAward: ()=>$b8e126da42a4b9e3$var$BadgeAward,
    BadgeDefinition: ()=>$b8e126da42a4b9e3$var$BadgeDefinition,
    BlockedRelaysList: ()=>$b8e126da42a4b9e3$var$BlockedRelaysList,
    BlossomServerList: ()=>$b8e126da42a4b9e3$var$BlossomServerList,
    BookmarkList: ()=>$b8e126da42a4b9e3$var$BookmarkList,
    Bookmarksets: ()=>$b8e126da42a4b9e3$var$Bookmarksets,
    Calendar: ()=>$b8e126da42a4b9e3$var$Calendar,
    CalendarEventRSVP: ()=>$b8e126da42a4b9e3$var$CalendarEventRSVP,
    ChannelCreation: ()=>$b8e126da42a4b9e3$var$ChannelCreation,
    ChannelHideMessage: ()=>$b8e126da42a4b9e3$var$ChannelHideMessage,
    ChannelMessage: ()=>$b8e126da42a4b9e3$var$ChannelMessage,
    ChannelMetadata: ()=>$b8e126da42a4b9e3$var$ChannelMetadata,
    ChannelMuteUser: ()=>$b8e126da42a4b9e3$var$ChannelMuteUser,
    ChatMessage: ()=>$b8e126da42a4b9e3$var$ChatMessage,
    ClassifiedListing: ()=>$b8e126da42a4b9e3$var$ClassifiedListing,
    ClientAuth: ()=>$b8e126da42a4b9e3$var$ClientAuth,
    Comment: ()=>$b8e126da42a4b9e3$var$Comment,
    CommunitiesList: ()=>$b8e126da42a4b9e3$var$CommunitiesList,
    CommunityDefinition: ()=>$b8e126da42a4b9e3$var$CommunityDefinition,
    CommunityPostApproval: ()=>$b8e126da42a4b9e3$var$CommunityPostApproval,
    Contacts: ()=>$b8e126da42a4b9e3$var$Contacts,
    CreateOrUpdateProduct: ()=>$b8e126da42a4b9e3$var$CreateOrUpdateProduct,
    CreateOrUpdateStall: ()=>$b8e126da42a4b9e3$var$CreateOrUpdateStall,
    Curationsets: ()=>$b8e126da42a4b9e3$var$Curationsets,
    Date: ()=>$b8e126da42a4b9e3$var$Date2,
    DirectMessageRelaysList: ()=>$b8e126da42a4b9e3$var$DirectMessageRelaysList,
    DraftClassifiedListing: ()=>$b8e126da42a4b9e3$var$DraftClassifiedListing,
    DraftLong: ()=>$b8e126da42a4b9e3$var$DraftLong,
    Emojisets: ()=>$b8e126da42a4b9e3$var$Emojisets,
    EncryptedDirectMessage: ()=>$b8e126da42a4b9e3$var$EncryptedDirectMessage,
    EventDeletion: ()=>$b8e126da42a4b9e3$var$EventDeletion,
    FavoriteRelays: ()=>$b8e126da42a4b9e3$var$FavoriteRelays,
    FileMessage: ()=>$b8e126da42a4b9e3$var$FileMessage,
    FileMetadata: ()=>$b8e126da42a4b9e3$var$FileMetadata,
    FileServerPreference: ()=>$b8e126da42a4b9e3$var$FileServerPreference,
    Followsets: ()=>$b8e126da42a4b9e3$var$Followsets,
    ForumThread: ()=>$b8e126da42a4b9e3$var$ForumThread,
    GenericRepost: ()=>$b8e126da42a4b9e3$var$GenericRepost,
    Genericlists: ()=>$b8e126da42a4b9e3$var$Genericlists,
    GiftWrap: ()=>$b8e126da42a4b9e3$var$GiftWrap,
    GroupMetadata: ()=>$b8e126da42a4b9e3$var$GroupMetadata,
    HTTPAuth: ()=>$b8e126da42a4b9e3$var$HTTPAuth,
    Handlerinformation: ()=>$b8e126da42a4b9e3$var$Handlerinformation,
    Handlerrecommendation: ()=>$b8e126da42a4b9e3$var$Handlerrecommendation,
    Highlights: ()=>$b8e126da42a4b9e3$var$Highlights,
    InterestsList: ()=>$b8e126da42a4b9e3$var$InterestsList,
    Interestsets: ()=>$b8e126da42a4b9e3$var$Interestsets,
    JobFeedback: ()=>$b8e126da42a4b9e3$var$JobFeedback,
    JobRequest: ()=>$b8e126da42a4b9e3$var$JobRequest,
    JobResult: ()=>$b8e126da42a4b9e3$var$JobResult,
    Label: ()=>$b8e126da42a4b9e3$var$Label,
    LightningPubRPC: ()=>$b8e126da42a4b9e3$var$LightningPubRPC,
    LiveChatMessage: ()=>$b8e126da42a4b9e3$var$LiveChatMessage,
    LiveEvent: ()=>$b8e126da42a4b9e3$var$LiveEvent,
    LongFormArticle: ()=>$b8e126da42a4b9e3$var$LongFormArticle,
    Metadata: ()=>$b8e126da42a4b9e3$var$Metadata,
    Mutelist: ()=>$b8e126da42a4b9e3$var$Mutelist,
    NWCWalletInfo: ()=>$b8e126da42a4b9e3$var$NWCWalletInfo,
    NWCWalletRequest: ()=>$b8e126da42a4b9e3$var$NWCWalletRequest,
    NWCWalletResponse: ()=>$b8e126da42a4b9e3$var$NWCWalletResponse,
    NormalVideo: ()=>$b8e126da42a4b9e3$var$NormalVideo,
    NostrConnect: ()=>$b8e126da42a4b9e3$var$NostrConnect,
    OpenTimestamps: ()=>$b8e126da42a4b9e3$var$OpenTimestamps,
    Photo: ()=>$b8e126da42a4b9e3$var$Photo,
    Pinlist: ()=>$b8e126da42a4b9e3$var$Pinlist,
    Poll: ()=>$b8e126da42a4b9e3$var$Poll,
    PollResponse: ()=>$b8e126da42a4b9e3$var$PollResponse,
    PrivateDirectMessage: ()=>$b8e126da42a4b9e3$var$PrivateDirectMessage,
    ProblemTracker: ()=>$b8e126da42a4b9e3$var$ProblemTracker,
    ProfileBadges: ()=>$b8e126da42a4b9e3$var$ProfileBadges,
    PublicChatsList: ()=>$b8e126da42a4b9e3$var$PublicChatsList,
    Reaction: ()=>$b8e126da42a4b9e3$var$Reaction,
    RecommendRelay: ()=>$b8e126da42a4b9e3$var$RecommendRelay,
    RelayList: ()=>$b8e126da42a4b9e3$var$RelayList,
    RelayReview: ()=>$b8e126da42a4b9e3$var$RelayReview,
    Relaysets: ()=>$b8e126da42a4b9e3$var$Relaysets,
    Report: ()=>$b8e126da42a4b9e3$var$Report,
    Reporting: ()=>$b8e126da42a4b9e3$var$Reporting,
    Repost: ()=>$b8e126da42a4b9e3$var$Repost,
    Seal: ()=>$b8e126da42a4b9e3$var$Seal,
    SearchRelaysList: ()=>$b8e126da42a4b9e3$var$SearchRelaysList,
    ShortTextNote: ()=>$b8e126da42a4b9e3$var$ShortTextNote,
    ShortVideo: ()=>$b8e126da42a4b9e3$var$ShortVideo,
    Time: ()=>$b8e126da42a4b9e3$var$Time,
    UserEmojiList: ()=>$b8e126da42a4b9e3$var$UserEmojiList,
    UserStatuses: ()=>$b8e126da42a4b9e3$var$UserStatuses,
    Voice: ()=>$b8e126da42a4b9e3$var$Voice,
    VoiceComment: ()=>$b8e126da42a4b9e3$var$VoiceComment,
    Zap: ()=>$b8e126da42a4b9e3$var$Zap,
    ZapGoal: ()=>$b8e126da42a4b9e3$var$ZapGoal,
    ZapRequest: ()=>$b8e126da42a4b9e3$var$ZapRequest,
    classifyKind: ()=>$b8e126da42a4b9e3$var$classifyKind,
    isAddressableKind: ()=>$b8e126da42a4b9e3$var$isAddressableKind,
    isEphemeralKind: ()=>$b8e126da42a4b9e3$var$isEphemeralKind,
    isKind: ()=>$b8e126da42a4b9e3$var$isKind,
    isRegularKind: ()=>$b8e126da42a4b9e3$var$isRegularKind,
    isReplaceableKind: ()=>$b8e126da42a4b9e3$var$isReplaceableKind
});
function $b8e126da42a4b9e3$var$isRegularKind(kind) {
    return kind < 1e4 && kind !== 0 && kind !== 3;
}
function $b8e126da42a4b9e3$var$isReplaceableKind(kind) {
    return kind === 0 || kind === 3 || 1e4 <= kind && kind < 2e4;
}
function $b8e126da42a4b9e3$var$isEphemeralKind(kind) {
    return 2e4 <= kind && kind < 3e4;
}
function $b8e126da42a4b9e3$var$isAddressableKind(kind) {
    return 3e4 <= kind && kind < 4e4;
}
function $b8e126da42a4b9e3$var$classifyKind(kind) {
    if ($b8e126da42a4b9e3$var$isRegularKind(kind)) return "regular";
    if ($b8e126da42a4b9e3$var$isReplaceableKind(kind)) return "replaceable";
    if ($b8e126da42a4b9e3$var$isEphemeralKind(kind)) return "ephemeral";
    if ($b8e126da42a4b9e3$var$isAddressableKind(kind)) return "parameterized";
    return "unknown";
}
function $b8e126da42a4b9e3$var$isKind(event, kind) {
    const kindAsArray = kind instanceof Array ? kind : [
        kind
    ];
    return $b8e126da42a4b9e3$export$d08d852dd562b1ce(event) && kindAsArray.includes(event.kind) || false;
}
var $b8e126da42a4b9e3$var$Metadata = 0;
var $b8e126da42a4b9e3$var$ShortTextNote = 1;
var $b8e126da42a4b9e3$var$RecommendRelay = 2;
var $b8e126da42a4b9e3$var$Contacts = 3;
var $b8e126da42a4b9e3$var$EncryptedDirectMessage = 4;
var $b8e126da42a4b9e3$var$EventDeletion = 5;
var $b8e126da42a4b9e3$var$Repost = 6;
var $b8e126da42a4b9e3$var$Reaction = 7;
var $b8e126da42a4b9e3$var$BadgeAward = 8;
var $b8e126da42a4b9e3$var$ChatMessage = 9;
var $b8e126da42a4b9e3$var$ForumThread = 11;
var $b8e126da42a4b9e3$var$Seal = 13;
var $b8e126da42a4b9e3$var$PrivateDirectMessage = 14;
var $b8e126da42a4b9e3$var$FileMessage = 15;
var $b8e126da42a4b9e3$var$GenericRepost = 16;
var $b8e126da42a4b9e3$var$Photo = 20;
var $b8e126da42a4b9e3$var$NormalVideo = 21;
var $b8e126da42a4b9e3$var$ShortVideo = 22;
var $b8e126da42a4b9e3$var$ChannelCreation = 40;
var $b8e126da42a4b9e3$var$ChannelMetadata = 41;
var $b8e126da42a4b9e3$var$ChannelMessage = 42;
var $b8e126da42a4b9e3$var$ChannelHideMessage = 43;
var $b8e126da42a4b9e3$var$ChannelMuteUser = 44;
var $b8e126da42a4b9e3$var$OpenTimestamps = 1040;
var $b8e126da42a4b9e3$var$GiftWrap = 1059;
var $b8e126da42a4b9e3$var$Poll = 1068;
var $b8e126da42a4b9e3$var$FileMetadata = 1063;
var $b8e126da42a4b9e3$var$Comment = 1111;
var $b8e126da42a4b9e3$var$LiveChatMessage = 1311;
var $b8e126da42a4b9e3$var$Voice = 1222;
var $b8e126da42a4b9e3$var$VoiceComment = 1244;
var $b8e126da42a4b9e3$var$ProblemTracker = 1971;
var $b8e126da42a4b9e3$var$Report = 1984;
var $b8e126da42a4b9e3$var$Reporting = 1984;
var $b8e126da42a4b9e3$var$Label = 1985;
var $b8e126da42a4b9e3$var$CommunityPostApproval = 4550;
var $b8e126da42a4b9e3$var$JobRequest = 5999;
var $b8e126da42a4b9e3$var$JobResult = 6999;
var $b8e126da42a4b9e3$var$JobFeedback = 7e3;
var $b8e126da42a4b9e3$var$ZapGoal = 9041;
var $b8e126da42a4b9e3$var$ZapRequest = 9734;
var $b8e126da42a4b9e3$var$Zap = 9735;
var $b8e126da42a4b9e3$var$Highlights = 9802;
var $b8e126da42a4b9e3$var$PollResponse = 1018;
var $b8e126da42a4b9e3$var$Mutelist = 1e4;
var $b8e126da42a4b9e3$var$Pinlist = 10001;
var $b8e126da42a4b9e3$var$RelayList = 10002;
var $b8e126da42a4b9e3$var$BookmarkList = 10003;
var $b8e126da42a4b9e3$var$CommunitiesList = 10004;
var $b8e126da42a4b9e3$var$PublicChatsList = 10005;
var $b8e126da42a4b9e3$var$BlockedRelaysList = 10006;
var $b8e126da42a4b9e3$var$SearchRelaysList = 10007;
var $b8e126da42a4b9e3$var$FavoriteRelays = 10012;
var $b8e126da42a4b9e3$var$InterestsList = 10015;
var $b8e126da42a4b9e3$var$UserEmojiList = 10030;
var $b8e126da42a4b9e3$var$DirectMessageRelaysList = 10050;
var $b8e126da42a4b9e3$var$FileServerPreference = 10096;
var $b8e126da42a4b9e3$var$BlossomServerList = 10063;
var $b8e126da42a4b9e3$var$NWCWalletInfo = 13194;
var $b8e126da42a4b9e3$var$LightningPubRPC = 21e3;
var $b8e126da42a4b9e3$var$ClientAuth = 22242;
var $b8e126da42a4b9e3$var$NWCWalletRequest = 23194;
var $b8e126da42a4b9e3$var$NWCWalletResponse = 23195;
var $b8e126da42a4b9e3$var$NostrConnect = 24133;
var $b8e126da42a4b9e3$var$HTTPAuth = 27235;
var $b8e126da42a4b9e3$var$Followsets = 3e4;
var $b8e126da42a4b9e3$var$Genericlists = 30001;
var $b8e126da42a4b9e3$var$Relaysets = 30002;
var $b8e126da42a4b9e3$var$Bookmarksets = 30003;
var $b8e126da42a4b9e3$var$Curationsets = 30004;
var $b8e126da42a4b9e3$var$ProfileBadges = 30008;
var $b8e126da42a4b9e3$var$BadgeDefinition = 30009;
var $b8e126da42a4b9e3$var$Interestsets = 30015;
var $b8e126da42a4b9e3$var$CreateOrUpdateStall = 30017;
var $b8e126da42a4b9e3$var$CreateOrUpdateProduct = 30018;
var $b8e126da42a4b9e3$var$LongFormArticle = 30023;
var $b8e126da42a4b9e3$var$DraftLong = 30024;
var $b8e126da42a4b9e3$var$Emojisets = 30030;
var $b8e126da42a4b9e3$var$Application = 30078;
var $b8e126da42a4b9e3$var$LiveEvent = 30311;
var $b8e126da42a4b9e3$var$UserStatuses = 30315;
var $b8e126da42a4b9e3$var$ClassifiedListing = 30402;
var $b8e126da42a4b9e3$var$DraftClassifiedListing = 30403;
var $b8e126da42a4b9e3$var$Date2 = 31922;
var $b8e126da42a4b9e3$var$Time = 31923;
var $b8e126da42a4b9e3$var$Calendar = 31924;
var $b8e126da42a4b9e3$var$CalendarEventRSVP = 31925;
var $b8e126da42a4b9e3$var$RelayReview = 31987;
var $b8e126da42a4b9e3$var$Handlerrecommendation = 31989;
var $b8e126da42a4b9e3$var$Handlerinformation = 31990;
var $b8e126da42a4b9e3$var$CommunityDefinition = 34550;
var $b8e126da42a4b9e3$var$GroupMetadata = 39e3;
// filter.ts
function $b8e126da42a4b9e3$export$c6f8482e724e56c5(filter, event) {
    if (filter.ids && filter.ids.indexOf(event.id) === -1) return false;
    if (filter.kinds && filter.kinds.indexOf(event.kind) === -1) return false;
    if (filter.authors && filter.authors.indexOf(event.pubkey) === -1) return false;
    for(let f in filter)if (f[0] === "#") {
        let tagName = f.slice(1);
        let values = filter[`#${tagName}`];
        if (values && !event.tags.find(([t, v])=>t === f.slice(1) && values.indexOf(v) !== -1)) return false;
    }
    if (filter.since && event.created_at < filter.since) return false;
    if (filter.until && event.created_at > filter.until) return false;
    return true;
}
function $b8e126da42a4b9e3$export$4bbf3f173cb9a4eb(filters, event) {
    for(let i2 = 0; i2 < filters.length; i2++){
        if ($b8e126da42a4b9e3$export$c6f8482e724e56c5(filters[i2], event)) return true;
    }
    return false;
}
function $b8e126da42a4b9e3$export$aa787302ec03bf2a(...filters) {
    let result = {};
    for(let i2 = 0; i2 < filters.length; i2++){
        let filter = filters[i2];
        Object.entries(filter).forEach(([property, values])=>{
            if (property === "kinds" || property === "ids" || property === "authors" || property[0] === "#") {
                result[property] = result[property] || [];
                for(let v = 0; v < values.length; v++){
                    let value = values[v];
                    if (!result[property].includes(value)) result[property].push(value);
                }
            }
        });
        if (filter.limit && (!result.limit || filter.limit > result.limit)) result.limit = filter.limit;
        if (filter.until && (!result.until || filter.until > result.until)) result.until = filter.until;
        if (filter.since && (!result.since || filter.since < result.since)) result.since = filter.since;
    }
    return result;
}
function $b8e126da42a4b9e3$export$74b8728d117779ba(filter) {
    if (filter.ids && !filter.ids.length) return 0;
    if (filter.kinds && !filter.kinds.length) return 0;
    if (filter.authors && !filter.authors.length) return 0;
    for (const [key, value] of Object.entries(filter)){
        if (key[0] === "#" && Array.isArray(value) && !value.length) return 0;
    }
    return Math.min(Math.max(0, filter.limit ?? Infinity), filter.ids?.length ?? Infinity, filter.authors?.length && filter.kinds?.every((kind)=>$b8e126da42a4b9e3$var$isReplaceableKind(kind)) ? filter.authors.length * filter.kinds.length : Infinity, filter.authors?.length && filter.kinds?.every((kind)=>$b8e126da42a4b9e3$var$isAddressableKind(kind)) && filter["#d"]?.length ? filter.authors.length * filter.kinds.length * filter["#d"].length : Infinity);
}
// fakejson.ts
var $b8e126da42a4b9e3$export$7712baafc4f0e06e = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$7712baafc4f0e06e, {
    getHex64: ()=>$b8e126da42a4b9e3$var$getHex64,
    getInt: ()=>$b8e126da42a4b9e3$var$getInt,
    getSubscriptionId: ()=>$b8e126da42a4b9e3$var$getSubscriptionId,
    matchEventId: ()=>$b8e126da42a4b9e3$var$matchEventId,
    matchEventKind: ()=>$b8e126da42a4b9e3$var$matchEventKind,
    matchEventPubkey: ()=>$b8e126da42a4b9e3$var$matchEventPubkey
});
function $b8e126da42a4b9e3$var$getHex64(json, field) {
    let len = field.length + 3;
    let idx = json.indexOf(`"${field}":`) + len;
    let s = json.slice(idx).indexOf(`"`) + idx + 1;
    return json.slice(s, s + 64);
}
function $b8e126da42a4b9e3$var$getInt(json, field) {
    let len = field.length;
    let idx = json.indexOf(`"${field}":`) + len + 3;
    let sliced = json.slice(idx);
    let end = Math.min(sliced.indexOf(","), sliced.indexOf("}"));
    return parseInt(sliced.slice(0, end), 10);
}
function $b8e126da42a4b9e3$var$getSubscriptionId(json) {
    let idx = json.slice(0, 22).indexOf(`"EVENT"`);
    if (idx === -1) return null;
    let pstart = json.slice(idx + 7 + 1).indexOf(`"`);
    if (pstart === -1) return null;
    let start = idx + 7 + 1 + pstart;
    let pend = json.slice(start + 1, 80).indexOf(`"`);
    if (pend === -1) return null;
    let end = start + 1 + pend;
    return json.slice(start + 1, end);
}
function $b8e126da42a4b9e3$var$matchEventId(json, id) {
    return id === $b8e126da42a4b9e3$var$getHex64(json, "id");
}
function $b8e126da42a4b9e3$var$matchEventPubkey(json, pubkey) {
    return pubkey === $b8e126da42a4b9e3$var$getHex64(json, "pubkey");
}
function $b8e126da42a4b9e3$var$matchEventKind(json, kind) {
    return kind === $b8e126da42a4b9e3$var$getInt(json, "kind");
}
// nip42.ts
var $b8e126da42a4b9e3$export$900cb248cdec72b = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$900cb248cdec72b, {
    makeAuthEvent: ()=>$b8e126da42a4b9e3$var$makeAuthEvent
});
function $b8e126da42a4b9e3$var$makeAuthEvent(relayURL, challenge) {
    return {
        kind: $b8e126da42a4b9e3$var$ClientAuth,
        created_at: Math.floor(Date.now() / 1e3),
        tags: [
            [
                "relay",
                relayURL
            ],
            [
                "challenge",
                challenge
            ]
        ],
        content: ""
    };
}
// abstract-relay.ts
var $b8e126da42a4b9e3$var$SendingOnClosedConnection = class extends Error {
    constructor(message, relay){
        super(`Tried to send message '${message} on a closed connection to ${relay}.`);
        this.name = "SendingOnClosedConnection";
    }
};
var $b8e126da42a4b9e3$var$AbstractRelay = class {
    url;
    _connected = false;
    onclose = null;
    onnotice = (msg)=>console.debug(`NOTICE from ${this.url}: ${msg}`);
    onauth;
    baseEoseTimeout = 4400;
    publishTimeout = 4400;
    pingFrequency = 29e3;
    pingTimeout = 2e4;
    resubscribeBackoff = [
        1e4,
        1e4,
        1e4,
        2e4,
        2e4,
        3e4,
        6e4
    ];
    openSubs = /* @__PURE__ */ new Map();
    enablePing;
    enableReconnect;
    idleSince = Date.now();
    ongoingOperations = 0;
    reconnectTimeoutHandle;
    pingIntervalHandle;
    reconnectAttempts = 0;
    skipReconnection = false;
    connectionPromise;
    openCountRequests = /* @__PURE__ */ new Map();
    openEventPublishes = /* @__PURE__ */ new Map();
    ws;
    challenge;
    authPromise;
    serial = 0;
    verifyEvent;
    _WebSocket;
    constructor(url, opts){
        this.url = $b8e126da42a4b9e3$var$normalizeURL(url);
        this.verifyEvent = opts.verifyEvent;
        this._WebSocket = opts.websocketImplementation || WebSocket;
        this.enablePing = opts.enablePing;
        this.enableReconnect = opts.enableReconnect || false;
    }
    static async connect(url, opts) {
        const relay = new $b8e126da42a4b9e3$var$AbstractRelay(url, opts);
        await relay.connect(opts);
        return relay;
    }
    closeAllSubscriptions(reason) {
        for (let [_, sub] of this.openSubs)sub.close(reason);
        this.openSubs.clear();
        for (let [_, ep] of this.openEventPublishes)ep.reject(new Error(reason));
        this.openEventPublishes.clear();
        for (let [_, cr] of this.openCountRequests)cr.reject(new Error(reason));
        this.openCountRequests.clear();
    }
    get connected() {
        return this._connected;
    }
    async reconnect() {
        const backoff = this.resubscribeBackoff[Math.min(this.reconnectAttempts, this.resubscribeBackoff.length - 1)];
        this.reconnectAttempts++;
        this.reconnectTimeoutHandle = setTimeout(async ()=>{
            try {
                await this.connect();
            } catch (err) {}
        }, backoff);
    }
    handleHardClose(reason) {
        if (this.pingIntervalHandle) {
            clearInterval(this.pingIntervalHandle);
            this.pingIntervalHandle = void 0;
        }
        this._connected = false;
        this.connectionPromise = void 0;
        this.idleSince = void 0;
        if (this.enableReconnect && !this.skipReconnection) this.reconnect();
        else {
            this.onclose?.();
            this.closeAllSubscriptions(reason);
        }
    }
    async connect(opts) {
        let connectionTimeoutHandle;
        if (this.connectionPromise) return this.connectionPromise;
        this.challenge = void 0;
        this.authPromise = void 0;
        this.skipReconnection = false;
        this.connectionPromise = new Promise((resolve, reject)=>{
            if (opts?.timeout) connectionTimeoutHandle = setTimeout(()=>{
                reject("connection timed out");
                this.connectionPromise = void 0;
                this.skipReconnection = true;
                this.onclose?.();
                this.handleHardClose("relay connection timed out");
            }, opts.timeout);
            if (opts?.abort) opts.abort.onabort = reject;
            try {
                this.ws = new this._WebSocket(this.url);
            } catch (err) {
                clearTimeout(connectionTimeoutHandle);
                reject(err);
                return;
            }
            this.ws.onopen = ()=>{
                if (this.reconnectTimeoutHandle) {
                    clearTimeout(this.reconnectTimeoutHandle);
                    this.reconnectTimeoutHandle = void 0;
                }
                clearTimeout(connectionTimeoutHandle);
                this._connected = true;
                const isReconnection = this.reconnectAttempts > 0;
                this.reconnectAttempts = 0;
                for (const sub of this.openSubs.values()){
                    sub.eosed = false;
                    if (isReconnection) {
                        for(let f = 0; f < sub.filters.length; f++)if (sub.lastEmitted) sub.filters[f].since = sub.lastEmitted + 1;
                    }
                    sub.fire();
                }
                if (this.enablePing) this.pingIntervalHandle = setInterval(()=>this.pingpong(), this.pingFrequency);
                resolve();
            };
            this.ws.onerror = ()=>{
                clearTimeout(connectionTimeoutHandle);
                reject("connection failed");
                this.connectionPromise = void 0;
                this.skipReconnection = true;
                this.onclose?.();
                this.handleHardClose("relay connection failed");
            };
            this.ws.onclose = (ev)=>{
                clearTimeout(connectionTimeoutHandle);
                reject(ev.message || "websocket closed");
                this.handleHardClose("relay connection closed");
            };
            this.ws.onmessage = this._onmessage.bind(this);
        });
        return this.connectionPromise;
    }
    waitForPingPong() {
        return new Promise((resolve)=>{
            this.ws.once("pong", ()=>resolve(true));
            this.ws.ping();
        });
    }
    waitForDummyReq() {
        return new Promise((resolve, reject)=>{
            if (!this.connectionPromise) return reject(new Error(`no connection to ${this.url}, can't ping`));
            try {
                const sub = this.subscribe([
                    {
                        ids: [
                            "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa"
                        ],
                        limit: 0
                    }
                ], {
                    label: "<forced-ping>",
                    oneose: ()=>{
                        resolve(true);
                        sub.close();
                    },
                    onclose () {
                        resolve(true);
                    },
                    eoseTimeout: this.pingTimeout + 1e3
                });
            } catch (err) {
                reject(err);
            }
        });
    }
    async pingpong() {
        if (this.ws?.readyState === 1) {
            const result = await Promise.any([
                this.ws && this.ws.ping && this.ws.once ? this.waitForPingPong() : this.waitForDummyReq(),
                new Promise((res)=>setTimeout(()=>res(false), this.pingTimeout))
            ]);
            if (!result) {
                if (this.ws?.readyState === this._WebSocket.OPEN) this.ws?.close();
            }
        }
    }
    async send(message) {
        if (!this.connectionPromise) throw new $b8e126da42a4b9e3$var$SendingOnClosedConnection(message, this.url);
        this.connectionPromise.then(()=>{
            this.ws?.send(message);
        });
    }
    async auth(signAuthEvent) {
        const challenge = this.challenge;
        if (!challenge) throw new Error("can't perform auth, no challenge was received");
        if (this.authPromise) return this.authPromise;
        this.authPromise = new Promise(async (resolve, reject)=>{
            try {
                let evt = await signAuthEvent($b8e126da42a4b9e3$var$makeAuthEvent(this.url, challenge));
                let timeout = setTimeout(()=>{
                    let ep = this.openEventPublishes.get(evt.id);
                    if (ep) {
                        ep.reject(new Error("auth timed out"));
                        this.openEventPublishes.delete(evt.id);
                    }
                }, this.publishTimeout);
                this.openEventPublishes.set(evt.id, {
                    resolve: resolve,
                    reject: reject,
                    timeout: timeout
                });
                this.send('["AUTH",' + JSON.stringify(evt) + "]");
            } catch (err) {
                console.warn("subscribe auth function failed:", err);
            }
        });
        return this.authPromise;
    }
    async publish(event) {
        this.idleSince = void 0;
        this.ongoingOperations++;
        const ret = new Promise((resolve, reject)=>{
            const timeout = setTimeout(()=>{
                const ep = this.openEventPublishes.get(event.id);
                if (ep) {
                    ep.reject(new Error("publish timed out"));
                    this.openEventPublishes.delete(event.id);
                }
            }, this.publishTimeout);
            this.openEventPublishes.set(event.id, {
                resolve: resolve,
                reject: reject,
                timeout: timeout
            });
        });
        this.send('["EVENT",' + JSON.stringify(event) + "]");
        this.ongoingOperations--;
        if (this.ongoingOperations === 0) this.idleSince = Date.now();
        return ret;
    }
    async count(filters, params) {
        this.serial++;
        const id = params?.id || "count:" + this.serial;
        const ret = new Promise((resolve, reject)=>{
            this.openCountRequests.set(id, {
                resolve: resolve,
                reject: reject
            });
        });
        this.send('["COUNT","' + id + '",' + JSON.stringify(filters).substring(1));
        return ret;
    }
    subscribe(filters, params) {
        if (params.label !== "<forced-ping>") {
            this.idleSince = void 0;
            this.ongoingOperations++;
        }
        const sub = this.prepareSubscription(filters, params);
        sub.fire();
        if (params.abort) params.abort.onabort = ()=>sub.close(String(params.abort.reason || "<aborted>"));
        return sub;
    }
    prepareSubscription(filters, params) {
        this.serial++;
        const id = params.id || (params.label ? params.label + ":" : "sub:") + this.serial;
        const sub = new $b8e126da42a4b9e3$var$Subscription(this, id, filters, params);
        this.openSubs.set(id, sub);
        return sub;
    }
    close() {
        this.skipReconnection = true;
        if (this.reconnectTimeoutHandle) {
            clearTimeout(this.reconnectTimeoutHandle);
            this.reconnectTimeoutHandle = void 0;
        }
        if (this.pingIntervalHandle) {
            clearInterval(this.pingIntervalHandle);
            this.pingIntervalHandle = void 0;
        }
        this.closeAllSubscriptions("relay connection closed by us");
        this._connected = false;
        this.idleSince = void 0;
        this.onclose?.();
        if (this.ws?.readyState === this._WebSocket.OPEN) this.ws?.close();
    }
    _onmessage(ev) {
        const json = ev.data;
        if (!json) return;
        const subid = $b8e126da42a4b9e3$var$getSubscriptionId(json);
        if (subid) {
            const so = this.openSubs.get(subid);
            if (!so) return;
            const id = $b8e126da42a4b9e3$var$getHex64(json, "id");
            const alreadyHave = so.alreadyHaveEvent?.(id);
            so.receivedEvent?.(this, id);
            if (alreadyHave) return;
        }
        try {
            let data = JSON.parse(json);
            switch(data[0]){
                case "EVENT":
                    {
                        const so = this.openSubs.get(data[1]);
                        const event = data[2];
                        if (this.verifyEvent(event) && $b8e126da42a4b9e3$export$4bbf3f173cb9a4eb(so.filters, event)) so.onevent(event);
                        if (!so.lastEmitted || so.lastEmitted < event.created_at) so.lastEmitted = event.created_at;
                        return;
                    }
                case "COUNT":
                    {
                        const id = data[1];
                        const payload = data[2];
                        const cr = this.openCountRequests.get(id);
                        if (cr) {
                            cr.resolve(payload.count);
                            this.openCountRequests.delete(id);
                        }
                        return;
                    }
                case "EOSE":
                    {
                        const so = this.openSubs.get(data[1]);
                        if (!so) return;
                        so.receivedEose();
                        return;
                    }
                case "OK":
                    {
                        const id = data[1];
                        const ok = data[2];
                        const reason = data[3];
                        const ep = this.openEventPublishes.get(id);
                        if (ep) {
                            clearTimeout(ep.timeout);
                            if (ok) ep.resolve(reason);
                            else ep.reject(new Error(reason));
                            this.openEventPublishes.delete(id);
                        }
                        return;
                    }
                case "CLOSED":
                    {
                        const id = data[1];
                        const so = this.openSubs.get(id);
                        if (!so) return;
                        so.closed = true;
                        so.close(data[2]);
                        return;
                    }
                case "NOTICE":
                    this.onnotice(data[1]);
                    return;
                case "AUTH":
                    this.challenge = data[1];
                    if (this.onauth) this.auth(this.onauth);
                    return;
                default:
                    {
                        const so = this.openSubs.get(data[1]);
                        so?.oncustom?.(data);
                        return;
                    }
            }
        } catch (err) {
            const [_, __, event] = JSON.parse(json);
            window.printer.maybe(event.pubkey, ":: caught err", event, this.url, err);
            return;
        }
    }
};
var $b8e126da42a4b9e3$var$Subscription = class {
    relay;
    id;
    lastEmitted;
    closed = false;
    eosed = false;
    filters;
    alreadyHaveEvent;
    receivedEvent;
    onevent;
    oneose;
    onclose;
    oncustom;
    eoseTimeout;
    eoseTimeoutHandle;
    constructor(relay, id, filters, params){
        if (filters.length === 0) throw new Error("subscription can't be created with zero filters");
        this.relay = relay;
        this.filters = filters;
        this.id = id;
        this.alreadyHaveEvent = params.alreadyHaveEvent;
        this.receivedEvent = params.receivedEvent;
        this.eoseTimeout = params.eoseTimeout || relay.baseEoseTimeout;
        this.oneose = params.oneose;
        this.onclose = params.onclose;
        this.onevent = params.onevent || ((event)=>{
            console.warn(`onevent() callback not defined for subscription '${this.id}' in relay ${this.relay.url}. event received:`, event);
        });
    }
    fire() {
        this.relay.send('["REQ","' + this.id + '",' + JSON.stringify(this.filters).substring(1));
        this.eoseTimeoutHandle = setTimeout(this.receivedEose.bind(this), this.eoseTimeout);
    }
    receivedEose() {
        if (this.eosed) return;
        clearTimeout(this.eoseTimeoutHandle);
        this.eosed = true;
        this.oneose?.();
    }
    close(reason = "closed by caller") {
        if (!this.closed && this.relay.connected) {
            try {
                this.relay.send('["CLOSE",' + JSON.stringify(this.id) + "]");
            } catch (err) {
                if (err instanceof $b8e126da42a4b9e3$var$SendingOnClosedConnection) ;
                else throw err;
            }
            this.closed = true;
        }
        this.relay.openSubs.delete(this.id);
        this.relay.ongoingOperations--;
        if (this.relay.ongoingOperations === 0) this.relay.idleSince = Date.now();
        this.onclose?.(reason);
    }
};
// relay.ts
var $b8e126da42a4b9e3$var$_WebSocket;
try {
    $b8e126da42a4b9e3$var$_WebSocket = WebSocket;
} catch  {}
var $b8e126da42a4b9e3$export$325be0d991c73dc2 = class extends $b8e126da42a4b9e3$var$AbstractRelay {
    constructor(url, options){
        super(url, {
            verifyEvent: $b8e126da42a4b9e3$export$909d658b5069e986,
            websocketImplementation: $b8e126da42a4b9e3$var$_WebSocket,
            ...options
        });
    }
    static async connect(url, options) {
        const relay = new $b8e126da42a4b9e3$export$325be0d991c73dc2(url, options);
        await relay.connect();
        return relay;
    }
};
// helpers.ts
var $b8e126da42a4b9e3$var$alwaysTrue = (t)=>{
    t[$b8e126da42a4b9e3$export$31a1b605a7b8e0bf] = true;
    return true;
};
// abstract-pool.ts
var $b8e126da42a4b9e3$var$AbstractSimplePool = class {
    relays = /* @__PURE__ */ new Map();
    seenOn = /* @__PURE__ */ new Map();
    trackRelays = false;
    verifyEvent;
    enablePing;
    enableReconnect;
    automaticallyAuth;
    trustedRelayURLs = /* @__PURE__ */ new Set();
    onRelayConnectionFailure;
    onRelayConnectionSuccess;
    allowConnectingToRelay;
    maxWaitForConnection;
    _WebSocket;
    constructor(opts){
        this.verifyEvent = opts.verifyEvent;
        this._WebSocket = opts.websocketImplementation;
        this.enablePing = opts.enablePing;
        this.enableReconnect = opts.enableReconnect || false;
        this.automaticallyAuth = opts.automaticallyAuth;
        this.onRelayConnectionFailure = opts.onRelayConnectionFailure;
        this.onRelayConnectionSuccess = opts.onRelayConnectionSuccess;
        this.allowConnectingToRelay = opts.allowConnectingToRelay;
        this.maxWaitForConnection = opts.maxWaitForConnection || 3e3;
    }
    async ensureRelay(url, params) {
        url = $b8e126da42a4b9e3$var$normalizeURL(url);
        let relay = this.relays.get(url);
        if (!relay) {
            relay = new $b8e126da42a4b9e3$var$AbstractRelay(url, {
                verifyEvent: this.trustedRelayURLs.has(url) ? $b8e126da42a4b9e3$var$alwaysTrue : this.verifyEvent,
                websocketImplementation: this._WebSocket,
                enablePing: this.enablePing,
                enableReconnect: this.enableReconnect
            });
            relay.onclose = ()=>{
                this.relays.delete(url);
            };
            this.relays.set(url, relay);
        }
        if (this.automaticallyAuth) {
            const authSignerFn = this.automaticallyAuth(url);
            if (authSignerFn) relay.onauth = authSignerFn;
        }
        try {
            await relay.connect({
                timeout: params?.connectionTimeout,
                abort: params?.abort
            });
        } catch (err) {
            this.relays.delete(url);
            throw err;
        }
        return relay;
    }
    close(relays) {
        relays.map($b8e126da42a4b9e3$var$normalizeURL).forEach((url)=>{
            this.relays.get(url)?.close();
            this.relays.delete(url);
        });
    }
    subscribe(relays, filter, params) {
        const request = [];
        const uniqUrls = [];
        for(let i2 = 0; i2 < relays.length; i2++){
            const url = $b8e126da42a4b9e3$var$normalizeURL(relays[i2]);
            if (!request.find((r)=>r.url === url)) {
                if (uniqUrls.indexOf(url) === -1) {
                    uniqUrls.push(url);
                    request.push({
                        url: url,
                        filter: filter
                    });
                }
            }
        }
        return this.subscribeMap(request, params);
    }
    subscribeMany(relays, filter, params) {
        return this.subscribe(relays, filter, params);
    }
    subscribeMap(requests, params) {
        const grouped = /* @__PURE__ */ new Map();
        for (const req of requests){
            const { url: url, filter: filter } = req;
            if (!grouped.has(url)) grouped.set(url, []);
            grouped.get(url).push(filter);
        }
        const groupedRequests = Array.from(grouped.entries()).map(([url, filters])=>({
                url: url,
                filters: filters
            }));
        if (this.trackRelays) params.receivedEvent = (relay, id)=>{
            let set = this.seenOn.get(id);
            if (!set) {
                set = /* @__PURE__ */ new Set();
                this.seenOn.set(id, set);
            }
            set.add(relay);
        };
        const _knownIds = /* @__PURE__ */ new Set();
        const subs = [];
        const eosesReceived = [];
        let handleEose = (i2)=>{
            if (eosesReceived[i2]) return;
            eosesReceived[i2] = true;
            if (eosesReceived.filter((a)=>a).length === groupedRequests.length) {
                params.oneose?.();
                handleEose = ()=>{};
            }
        };
        const closesReceived = [];
        let handleClose = (i2, reason)=>{
            if (closesReceived[i2]) return;
            handleEose(i2);
            closesReceived[i2] = reason;
            if (closesReceived.filter((a)=>a).length === groupedRequests.length) {
                params.onclose?.(closesReceived);
                handleClose = ()=>{};
            }
        };
        const localAlreadyHaveEventHandler = (id)=>{
            if (params.alreadyHaveEvent?.(id)) return true;
            const have = _knownIds.has(id);
            _knownIds.add(id);
            return have;
        };
        const allOpened = Promise.all(groupedRequests.map(async ({ url: url, filters: filters }, i2)=>{
            if (this.allowConnectingToRelay?.(url, [
                "read",
                filters
            ]) === false) {
                handleClose(i2, "connection skipped by allowConnectingToRelay");
                return;
            }
            let relay;
            try {
                relay = await this.ensureRelay(url, {
                    connectionTimeout: this.maxWaitForConnection < (params.maxWait || 0) ? Math.max(params.maxWait * 0.8, params.maxWait - 1e3) : this.maxWaitForConnection,
                    abort: params.abort
                });
            } catch (err) {
                this.onRelayConnectionFailure?.(url);
                handleClose(i2, err?.message || String(err));
                return;
            }
            this.onRelayConnectionSuccess?.(url);
            let subscription = relay.subscribe(filters, {
                ...params,
                oneose: ()=>handleEose(i2),
                onclose: (reason)=>{
                    if (reason.startsWith("auth-required: ") && params.onauth) relay.auth(params.onauth).then(()=>{
                        relay.subscribe(filters, {
                            ...params,
                            oneose: ()=>handleEose(i2),
                            onclose: (reason2)=>{
                                handleClose(i2, reason2);
                            },
                            alreadyHaveEvent: localAlreadyHaveEventHandler,
                            eoseTimeout: params.maxWait,
                            abort: params.abort
                        });
                    }).catch((err)=>{
                        handleClose(i2, `auth was required and attempted, but failed with: ${err}`);
                    });
                    else handleClose(i2, reason);
                },
                alreadyHaveEvent: localAlreadyHaveEventHandler,
                eoseTimeout: params.maxWait,
                abort: params.abort
            });
            subs.push(subscription);
        }));
        return {
            async close (reason) {
                await allOpened;
                subs.forEach((sub)=>{
                    sub.close(reason);
                });
            }
        };
    }
    subscribeEose(relays, filter, params) {
        let subcloser;
        subcloser = this.subscribe(relays, filter, {
            ...params,
            oneose () {
                const reason = "closed automatically on eose";
                if (subcloser) subcloser.close(reason);
                else params.onclose?.(relays.map((_)=>reason));
            }
        });
        return subcloser;
    }
    subscribeManyEose(relays, filter, params) {
        return this.subscribeEose(relays, filter, params);
    }
    async querySync(relays, filter, params) {
        return new Promise(async (resolve)=>{
            const events = [];
            this.subscribeEose(relays, filter, {
                ...params,
                onevent (event) {
                    events.push(event);
                },
                onclose (_) {
                    resolve(events);
                }
            });
        });
    }
    async get(relays, filter, params) {
        filter.limit = 1;
        const events = await this.querySync(relays, filter, params);
        events.sort((a, b)=>b.created_at - a.created_at);
        return events[0] || null;
    }
    publish(relays, event, params) {
        return relays.map($b8e126da42a4b9e3$var$normalizeURL).map(async (url, i2, arr)=>{
            if (arr.indexOf(url) !== i2) return Promise.reject("duplicate url");
            if (this.allowConnectingToRelay?.(url, [
                "write",
                event
            ]) === false) return Promise.reject("connection skipped by allowConnectingToRelay");
            let r;
            try {
                r = await this.ensureRelay(url, {
                    connectionTimeout: this.maxWaitForConnection < (params?.maxWait || 0) ? Math.max(params.maxWait * 0.8, params.maxWait - 1e3) : this.maxWaitForConnection,
                    abort: params?.abort
                });
            } catch (err) {
                this.onRelayConnectionFailure?.(url);
                return String("connection failure: " + String(err));
            }
            return r.publish(event).catch(async (err)=>{
                if (err instanceof Error && err.message.startsWith("auth-required: ") && params?.onauth) {
                    await r.auth(params.onauth);
                    return r.publish(event);
                }
                throw err;
            }).then((reason)=>{
                if (this.trackRelays) {
                    let set = this.seenOn.get(event.id);
                    if (!set) {
                        set = /* @__PURE__ */ new Set();
                        this.seenOn.set(event.id, set);
                    }
                    set.add(r);
                }
                return reason;
            });
        });
    }
    listConnectionStatus() {
        const map = /* @__PURE__ */ new Map();
        this.relays.forEach((relay, url)=>map.set(url, relay.connected));
        return map;
    }
    destroy() {
        this.relays.forEach((conn)=>conn.close());
        this.relays = /* @__PURE__ */ new Map();
    }
    pruneIdleRelays(idleThresholdMs = 1e4) {
        const prunedUrls = [];
        for (const [url, relay] of this.relays)if (relay.idleSince && Date.now() - relay.idleSince >= idleThresholdMs) {
            this.relays.delete(url);
            prunedUrls.push(url);
            relay.close();
        }
        return prunedUrls;
    }
};
// pool.ts
var $b8e126da42a4b9e3$var$_WebSocket2;
try {
    $b8e126da42a4b9e3$var$_WebSocket2 = WebSocket;
} catch  {}
var $b8e126da42a4b9e3$export$db45add7d1880f0c = class extends $b8e126da42a4b9e3$var$AbstractSimplePool {
    constructor(options){
        super({
            verifyEvent: $b8e126da42a4b9e3$export$909d658b5069e986,
            websocketImplementation: $b8e126da42a4b9e3$var$_WebSocket2,
            maxWaitForConnection: 3e3,
            ...options
        });
    }
};
// nip19.ts
var $b8e126da42a4b9e3$export$10660ae21dbef115 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$10660ae21dbef115, {
    BECH32_REGEX: ()=>$b8e126da42a4b9e3$var$BECH32_REGEX,
    Bech32MaxSize: ()=>$b8e126da42a4b9e3$var$Bech32MaxSize,
    NostrTypeGuard: ()=>$b8e126da42a4b9e3$var$NostrTypeGuard,
    decode: ()=>$b8e126da42a4b9e3$var$decode,
    decodeNostrURI: ()=>$b8e126da42a4b9e3$var$decodeNostrURI,
    encodeBytes: ()=>$b8e126da42a4b9e3$var$encodeBytes,
    naddrEncode: ()=>$b8e126da42a4b9e3$var$naddrEncode,
    neventEncode: ()=>$b8e126da42a4b9e3$var$neventEncode,
    noteEncode: ()=>$b8e126da42a4b9e3$var$noteEncode,
    nprofileEncode: ()=>$b8e126da42a4b9e3$var$nprofileEncode,
    npubEncode: ()=>$b8e126da42a4b9e3$var$npubEncode,
    nsecEncode: ()=>$b8e126da42a4b9e3$var$nsecEncode
});
var $b8e126da42a4b9e3$var$NostrTypeGuard = {
    isNProfile: (value)=>/^nprofile1[a-z\d]+$/.test(value || ""),
    isNEvent: (value)=>/^nevent1[a-z\d]+$/.test(value || ""),
    isNAddr: (value)=>/^naddr1[a-z\d]+$/.test(value || ""),
    isNSec: (value)=>/^nsec1[a-z\d]{58}$/.test(value || ""),
    isNPub: (value)=>/^npub1[a-z\d]{58}$/.test(value || ""),
    isNote: (value)=>/^note1[a-z\d]+$/.test(value || ""),
    isNcryptsec: (value)=>/^ncryptsec1[a-z\d]+$/.test(value || "")
};
var $b8e126da42a4b9e3$var$Bech32MaxSize = 5e3;
var $b8e126da42a4b9e3$var$BECH32_REGEX = /[\x21-\x7E]{1,83}1[023456789acdefghjklmnpqrstuvwxyz]{6,}/;
function $b8e126da42a4b9e3$var$integerToUint8Array(number) {
    const uint8Array = new Uint8Array(4);
    uint8Array[0] = number >> 24 & 255;
    uint8Array[1] = number >> 16 & 255;
    uint8Array[2] = number >> 8 & 255;
    uint8Array[3] = number & 255;
    return uint8Array;
}
function $b8e126da42a4b9e3$var$decodeNostrURI(nip19code) {
    try {
        if (nip19code.startsWith("nostr:")) nip19code = nip19code.substring(6);
        return $b8e126da42a4b9e3$var$decode(nip19code);
    } catch (_err) {
        return {
            type: "invalid",
            data: null
        };
    }
}
function $b8e126da42a4b9e3$var$decode(code) {
    let { prefix: prefix, words: words } = (0, $83RRd.bech32).decode(code, $b8e126da42a4b9e3$var$Bech32MaxSize);
    let data = new Uint8Array((0, $83RRd.bech32).fromWords(words));
    switch(prefix){
        case "nprofile":
            {
                let tlv = $b8e126da42a4b9e3$var$parseTLV(data);
                if (!tlv[0]?.[0]) throw new Error("missing TLV 0 for nprofile");
                if (tlv[0][0].length !== 32) throw new Error("TLV 0 should be 32 bytes");
                return {
                    type: "nprofile",
                    data: {
                        pubkey: (0, $3Bcdj.bytesToHex)(tlv[0][0]),
                        relays: tlv[1] ? tlv[1].map((d)=>$b8e126da42a4b9e3$var$utf8Decoder.decode(d)) : []
                    }
                };
            }
        case "nevent":
            {
                let tlv = $b8e126da42a4b9e3$var$parseTLV(data);
                if (!tlv[0]?.[0]) throw new Error("missing TLV 0 for nevent");
                if (tlv[0][0].length !== 32) throw new Error("TLV 0 should be 32 bytes");
                if (tlv[2] && tlv[2][0].length !== 32) throw new Error("TLV 2 should be 32 bytes");
                if (tlv[3] && tlv[3][0].length !== 4) throw new Error("TLV 3 should be 4 bytes");
                return {
                    type: "nevent",
                    data: {
                        id: (0, $3Bcdj.bytesToHex)(tlv[0][0]),
                        relays: tlv[1] ? tlv[1].map((d)=>$b8e126da42a4b9e3$var$utf8Decoder.decode(d)) : [],
                        author: tlv[2]?.[0] ? (0, $3Bcdj.bytesToHex)(tlv[2][0]) : void 0,
                        kind: tlv[3]?.[0] ? parseInt((0, $3Bcdj.bytesToHex)(tlv[3][0]), 16) : void 0
                    }
                };
            }
        case "naddr":
            {
                let tlv = $b8e126da42a4b9e3$var$parseTLV(data);
                if (!tlv[0]?.[0]) throw new Error("missing TLV 0 for naddr");
                if (!tlv[2]?.[0]) throw new Error("missing TLV 2 for naddr");
                if (tlv[2][0].length !== 32) throw new Error("TLV 2 should be 32 bytes");
                if (!tlv[3]?.[0]) throw new Error("missing TLV 3 for naddr");
                if (tlv[3][0].length !== 4) throw new Error("TLV 3 should be 4 bytes");
                return {
                    type: "naddr",
                    data: {
                        identifier: $b8e126da42a4b9e3$var$utf8Decoder.decode(tlv[0][0]),
                        pubkey: (0, $3Bcdj.bytesToHex)(tlv[2][0]),
                        kind: parseInt((0, $3Bcdj.bytesToHex)(tlv[3][0]), 16),
                        relays: tlv[1] ? tlv[1].map((d)=>$b8e126da42a4b9e3$var$utf8Decoder.decode(d)) : []
                    }
                };
            }
        case "nsec":
            return {
                type: prefix,
                data: data
            };
        case "npub":
        case "note":
            return {
                type: prefix,
                data: (0, $3Bcdj.bytesToHex)(data)
            };
        default:
            throw new Error(`unknown prefix ${prefix}`);
    }
}
function $b8e126da42a4b9e3$var$parseTLV(data) {
    let result = {};
    let rest = data;
    while(rest.length > 0){
        let t = rest[0];
        let l = rest[1];
        let v = rest.slice(2, 2 + l);
        rest = rest.slice(2 + l);
        if (v.length < l) throw new Error(`not enough data to read on TLV ${t}`);
        result[t] = result[t] || [];
        result[t].push(v);
    }
    return result;
}
function $b8e126da42a4b9e3$var$nsecEncode(key) {
    return $b8e126da42a4b9e3$var$encodeBytes("nsec", key);
}
function $b8e126da42a4b9e3$var$npubEncode(hex) {
    return $b8e126da42a4b9e3$var$encodeBytes("npub", (0, $3Bcdj.hexToBytes)(hex));
}
function $b8e126da42a4b9e3$var$noteEncode(hex) {
    return $b8e126da42a4b9e3$var$encodeBytes("note", (0, $3Bcdj.hexToBytes)(hex));
}
function $b8e126da42a4b9e3$var$encodeBech32(prefix, data) {
    let words = (0, $83RRd.bech32).toWords(data);
    return (0, $83RRd.bech32).encode(prefix, words, $b8e126da42a4b9e3$var$Bech32MaxSize);
}
function $b8e126da42a4b9e3$var$encodeBytes(prefix, bytes) {
    return $b8e126da42a4b9e3$var$encodeBech32(prefix, bytes);
}
function $b8e126da42a4b9e3$var$nprofileEncode(profile) {
    let data = $b8e126da42a4b9e3$var$encodeTLV({
        0: [
            (0, $3Bcdj.hexToBytes)(profile.pubkey)
        ],
        1: (profile.relays || []).map((url)=>$b8e126da42a4b9e3$var$utf8Encoder.encode(url))
    });
    return $b8e126da42a4b9e3$var$encodeBech32("nprofile", data);
}
function $b8e126da42a4b9e3$var$neventEncode(event) {
    let kindArray;
    if (event.kind !== void 0) kindArray = $b8e126da42a4b9e3$var$integerToUint8Array(event.kind);
    let data = $b8e126da42a4b9e3$var$encodeTLV({
        0: [
            (0, $3Bcdj.hexToBytes)(event.id)
        ],
        1: (event.relays || []).map((url)=>$b8e126da42a4b9e3$var$utf8Encoder.encode(url)),
        2: event.author ? [
            (0, $3Bcdj.hexToBytes)(event.author)
        ] : [],
        3: kindArray ? [
            new Uint8Array(kindArray)
        ] : []
    });
    return $b8e126da42a4b9e3$var$encodeBech32("nevent", data);
}
function $b8e126da42a4b9e3$var$naddrEncode(addr) {
    let kind = new ArrayBuffer(4);
    new DataView(kind).setUint32(0, addr.kind, false);
    let data = $b8e126da42a4b9e3$var$encodeTLV({
        0: [
            $b8e126da42a4b9e3$var$utf8Encoder.encode(addr.identifier)
        ],
        1: (addr.relays || []).map((url)=>$b8e126da42a4b9e3$var$utf8Encoder.encode(url)),
        2: [
            (0, $3Bcdj.hexToBytes)(addr.pubkey)
        ],
        3: [
            new Uint8Array(kind)
        ]
    });
    return $b8e126da42a4b9e3$var$encodeBech32("naddr", data);
}
function $b8e126da42a4b9e3$var$encodeTLV(tlv) {
    let entries = [];
    Object.entries(tlv).reverse().forEach(([t, vs])=>{
        vs.forEach((v)=>{
            let entry = new Uint8Array(v.length + 2);
            entry.set([
                parseInt(t)
            ], 0);
            entry.set([
                v.length
            ], 1);
            entry.set(v, 2);
            entries.push(entry);
        });
    });
    return (0, $3Bcdj.concatBytes)(...entries);
}
// references.ts
var $b8e126da42a4b9e3$var$mentionRegex = /\bnostr:((note|npub|naddr|nevent|nprofile)1\w+)\b|#\[(\d+)\]/g;
function $b8e126da42a4b9e3$export$2b054a310b694903(evt) {
    let references = [];
    for (let ref of evt.content.matchAll($b8e126da42a4b9e3$var$mentionRegex)){
        if (ref[2]) try {
            let { type: type, data: data } = $b8e126da42a4b9e3$var$decode(ref[1]);
            switch(type){
                case "npub":
                    references.push({
                        text: ref[0],
                        profile: {
                            pubkey: data,
                            relays: []
                        }
                    });
                    break;
                case "nprofile":
                    references.push({
                        text: ref[0],
                        profile: data
                    });
                    break;
                case "note":
                    references.push({
                        text: ref[0],
                        event: {
                            id: data,
                            relays: []
                        }
                    });
                    break;
                case "nevent":
                    references.push({
                        text: ref[0],
                        event: data
                    });
                    break;
                case "naddr":
                    references.push({
                        text: ref[0],
                        address: data
                    });
                    break;
            }
        } catch (err) {}
        else if (ref[3]) {
            let idx = parseInt(ref[3], 10);
            let tag = evt.tags[idx];
            if (!tag) continue;
            switch(tag[0]){
                case "p":
                    references.push({
                        text: ref[0],
                        profile: {
                            pubkey: tag[1],
                            relays: tag[2] ? [
                                tag[2]
                            ] : []
                        }
                    });
                    break;
                case "e":
                    references.push({
                        text: ref[0],
                        event: {
                            id: tag[1],
                            relays: tag[2] ? [
                                tag[2]
                            ] : []
                        }
                    });
                    break;
                case "a":
                    try {
                        let [kind, pubkey, identifier] = tag[1].split(":");
                        references.push({
                            text: ref[0],
                            address: {
                                identifier: identifier,
                                pubkey: pubkey,
                                kind: parseInt(kind, 10),
                                relays: tag[2] ? [
                                    tag[2]
                                ] : []
                            }
                        });
                    } catch (err) {}
                    break;
            }
        }
    }
    return references;
}
// nip04.ts
var $b8e126da42a4b9e3$export$4793e42c2cc9b120 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$4793e42c2cc9b120, {
    decrypt: ()=>$b8e126da42a4b9e3$var$decrypt,
    encrypt: ()=>$b8e126da42a4b9e3$var$encrypt
});
function $b8e126da42a4b9e3$var$encrypt(secretKey, pubkey, text) {
    const privkey = secretKey instanceof Uint8Array ? secretKey : (0, $3Bcdj.hexToBytes)(secretKey);
    const key = (0, $5r7db.secp256k1).getSharedSecret(privkey, (0, $3Bcdj.hexToBytes)("02" + pubkey));
    const normalizedKey = $b8e126da42a4b9e3$var$getNormalizedX(key);
    let iv = Uint8Array.from((0, $3Bcdj.randomBytes)(16));
    let plaintext = $b8e126da42a4b9e3$var$utf8Encoder.encode(text);
    let ciphertext = (0, $3RPiR.cbc)(normalizedKey, iv).encrypt(plaintext);
    let ctb64 = (0, $83RRd.base64).encode(new Uint8Array(ciphertext));
    let ivb64 = (0, $83RRd.base64).encode(new Uint8Array(iv.buffer));
    return `${ctb64}?iv=${ivb64}`;
}
function $b8e126da42a4b9e3$var$decrypt(secretKey, pubkey, data) {
    const privkey = secretKey instanceof Uint8Array ? secretKey : (0, $3Bcdj.hexToBytes)(secretKey);
    let [ctb64, ivb64] = data.split("?iv=");
    let key = (0, $5r7db.secp256k1).getSharedSecret(privkey, (0, $3Bcdj.hexToBytes)("02" + pubkey));
    let normalizedKey = $b8e126da42a4b9e3$var$getNormalizedX(key);
    let iv = (0, $83RRd.base64).decode(ivb64);
    let ciphertext = (0, $83RRd.base64).decode(ctb64);
    let plaintext = (0, $3RPiR.cbc)(normalizedKey, iv).decrypt(ciphertext);
    return $b8e126da42a4b9e3$var$utf8Decoder.decode(plaintext);
}
function $b8e126da42a4b9e3$var$getNormalizedX(key) {
    return key.slice(1, 33);
}
// nip05.ts
var $b8e126da42a4b9e3$export$a60e5b740ad8d13e = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$a60e5b740ad8d13e, {
    NIP05_REGEX: ()=>$b8e126da42a4b9e3$var$NIP05_REGEX,
    isNip05: ()=>$b8e126da42a4b9e3$var$isNip05,
    isValid: ()=>$b8e126da42a4b9e3$var$isValid,
    queryProfile: ()=>$b8e126da42a4b9e3$var$queryProfile,
    searchDomain: ()=>$b8e126da42a4b9e3$var$searchDomain,
    useFetchImplementation: ()=>$b8e126da42a4b9e3$var$useFetchImplementation
});
var $b8e126da42a4b9e3$var$NIP05_REGEX = /^(?:([\w.+-]+)@)?([\w_-]+(\.[\w_-]+)+)$/;
var $b8e126da42a4b9e3$var$isNip05 = (value)=>$b8e126da42a4b9e3$var$NIP05_REGEX.test(value || "");
var $b8e126da42a4b9e3$var$_fetch;
try {
    $b8e126da42a4b9e3$var$_fetch = fetch;
} catch (_) {}
function $b8e126da42a4b9e3$var$useFetchImplementation(fetchImplementation) {
    $b8e126da42a4b9e3$var$_fetch = fetchImplementation;
}
async function $b8e126da42a4b9e3$var$searchDomain(domain, query = "") {
    try {
        const url = `https://${domain}/.well-known/nostr.json?name=${query}`;
        const res = await $b8e126da42a4b9e3$var$_fetch(url, {
            redirect: "manual"
        });
        if (res.status !== 200) throw Error("Wrong response code");
        const json = await res.json();
        return json.names;
    } catch (_) {
        return {};
    }
}
async function $b8e126da42a4b9e3$var$queryProfile(fullname) {
    const match = fullname.match($b8e126da42a4b9e3$var$NIP05_REGEX);
    if (!match) return null;
    const [, name = "_", domain] = match;
    try {
        const url = `https://${domain}/.well-known/nostr.json?name=${name}`;
        const res = await $b8e126da42a4b9e3$var$_fetch(url, {
            redirect: "manual"
        });
        if (res.status !== 200) throw Error("Wrong response code");
        const json = await res.json();
        const pubkey = json.names[name];
        return pubkey ? {
            pubkey: pubkey,
            relays: json.relays?.[pubkey]
        } : null;
    } catch (_e) {
        return null;
    }
}
async function $b8e126da42a4b9e3$var$isValid(pubkey, nip05) {
    const res = await $b8e126da42a4b9e3$var$queryProfile(nip05);
    return res ? res.pubkey === pubkey : false;
}
// nip10.ts
var $b8e126da42a4b9e3$export$ce5090ce1281ef76 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$ce5090ce1281ef76, {
    parse: ()=>$b8e126da42a4b9e3$var$parse
});
function $b8e126da42a4b9e3$var$parse(event) {
    const result = {
        reply: void 0,
        root: void 0,
        mentions: [],
        profiles: [],
        quotes: []
    };
    let maybeParent;
    let maybeRoot;
    for(let i2 = event.tags.length - 1; i2 >= 0; i2--){
        const tag = event.tags[i2];
        if (tag[0] === "e" && tag[1]) {
            const [_, eTagEventId, eTagRelayUrl, eTagMarker, eTagAuthor] = tag;
            const eventPointer = {
                id: eTagEventId,
                relays: eTagRelayUrl ? [
                    eTagRelayUrl
                ] : [],
                author: eTagAuthor
            };
            if (eTagMarker === "root") {
                result.root = eventPointer;
                continue;
            }
            if (eTagMarker === "reply") {
                result.reply = eventPointer;
                continue;
            }
            if (eTagMarker === "mention") {
                result.mentions.push(eventPointer);
                continue;
            }
            if (!maybeParent) maybeParent = eventPointer;
            else maybeRoot = eventPointer;
            result.mentions.push(eventPointer);
            continue;
        }
        if (tag[0] === "q" && tag[1]) {
            const [_, eTagEventId, eTagRelayUrl] = tag;
            result.quotes.push({
                id: eTagEventId,
                relays: eTagRelayUrl ? [
                    eTagRelayUrl
                ] : []
            });
        }
        if (tag[0] === "p" && tag[1]) {
            result.profiles.push({
                pubkey: tag[1],
                relays: tag[2] ? [
                    tag[2]
                ] : []
            });
            continue;
        }
    }
    if (!result.root) result.root = maybeRoot || maybeParent || result.reply;
    if (!result.reply) result.reply = maybeParent || result.root;
    [
        result.reply,
        result.root
    ].forEach((ref)=>{
        if (!ref) return;
        let idx = result.mentions.indexOf(ref);
        if (idx !== -1) result.mentions.splice(idx, 1);
        if (ref.author) {
            let author = result.profiles.find((p)=>p.pubkey === ref.author);
            if (author && author.relays) {
                if (!ref.relays) ref.relays = [];
                author.relays.forEach((url)=>{
                    if (ref.relays?.indexOf(url) === -1) ref.relays.push(url);
                });
                author.relays = ref.relays;
            }
        }
    });
    result.mentions.forEach((ref)=>{
        if (ref.author) {
            let author = result.profiles.find((p)=>p.pubkey === ref.author);
            if (author && author.relays) {
                if (!ref.relays) ref.relays = [];
                author.relays.forEach((url)=>{
                    if (ref.relays.indexOf(url) === -1) ref.relays.push(url);
                });
                author.relays = ref.relays;
            }
        }
    });
    return result;
}
// nip11.ts
var $b8e126da42a4b9e3$export$86cbe01fda153e74 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$86cbe01fda153e74, {
    fetchRelayInformation: ()=>$b8e126da42a4b9e3$var$fetchRelayInformation,
    useFetchImplementation: ()=>$b8e126da42a4b9e3$var$useFetchImplementation2
});
var $b8e126da42a4b9e3$var$_fetch2;
try {
    $b8e126da42a4b9e3$var$_fetch2 = fetch;
} catch  {}
function $b8e126da42a4b9e3$var$useFetchImplementation2(fetchImplementation) {
    $b8e126da42a4b9e3$var$_fetch2 = fetchImplementation;
}
async function $b8e126da42a4b9e3$var$fetchRelayInformation(url) {
    return await (await fetch(url.replace("ws://", "http://").replace("wss://", "https://"), {
        headers: {
            Accept: "application/nostr+json"
        }
    })).json();
}
// nip13.ts
var $b8e126da42a4b9e3$export$215f75f26b6c95fe = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$215f75f26b6c95fe, {
    getPow: ()=>$b8e126da42a4b9e3$var$getPow,
    minePow: ()=>$b8e126da42a4b9e3$var$minePow
});
function $b8e126da42a4b9e3$var$getPow(hex) {
    let count = 0;
    for(let i2 = 0; i2 < 64; i2 += 8){
        const nibble = parseInt(hex.substring(i2, i2 + 8), 16);
        if (nibble === 0) count += 32;
        else {
            count += Math.clz32(nibble);
            break;
        }
    }
    return count;
}
function $b8e126da42a4b9e3$var$getPowFromBytes(hash) {
    let count = 0;
    for(let i2 = 0; i2 < hash.length; i2++){
        const byte = hash[i2];
        if (byte === 0) count += 8;
        else {
            count += Math.clz32(byte) - 24;
            break;
        }
    }
    return count;
}
function $b8e126da42a4b9e3$var$minePow(unsigned, difficulty) {
    let count = 0;
    const event = unsigned;
    const tag = [
        "nonce",
        count.toString(),
        difficulty.toString()
    ];
    event.tags.push(tag);
    while(true){
        const now2 = Math.floor(new Date().getTime() / 1e3);
        if (now2 !== event.created_at) {
            count = 0;
            event.created_at = now2;
        }
        tag[1] = (++count).toString();
        const hash = (0, $htQ8Z.sha256)($b8e126da42a4b9e3$var$utf8Encoder.encode(JSON.stringify([
            0,
            event.pubkey,
            event.created_at,
            event.kind,
            event.tags,
            event.content
        ])));
        if ($b8e126da42a4b9e3$var$getPowFromBytes(hash) >= difficulty) {
            event.id = (0, $3Bcdj.bytesToHex)(hash);
            break;
        }
    }
    return event;
}
// nip17.ts
var $b8e126da42a4b9e3$export$b2365d93b6f57df6 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$b2365d93b6f57df6, {
    unwrapEvent: ()=>$b8e126da42a4b9e3$var$unwrapEvent2,
    unwrapManyEvents: ()=>$b8e126da42a4b9e3$var$unwrapManyEvents2,
    wrapEvent: ()=>$b8e126da42a4b9e3$var$wrapEvent2,
    wrapManyEvents: ()=>$b8e126da42a4b9e3$var$wrapManyEvents2
});
// nip59.ts
var $b8e126da42a4b9e3$export$c928dafb9718f202 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$c928dafb9718f202, {
    createRumor: ()=>$b8e126da42a4b9e3$var$createRumor,
    createSeal: ()=>$b8e126da42a4b9e3$var$createSeal,
    createWrap: ()=>$b8e126da42a4b9e3$var$createWrap,
    unwrapEvent: ()=>$b8e126da42a4b9e3$var$unwrapEvent,
    unwrapManyEvents: ()=>$b8e126da42a4b9e3$var$unwrapManyEvents,
    wrapEvent: ()=>$b8e126da42a4b9e3$var$wrapEvent,
    wrapManyEvents: ()=>$b8e126da42a4b9e3$var$wrapManyEvents
});
// nip44.ts
var $b8e126da42a4b9e3$export$7f3384dd63301b54 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$7f3384dd63301b54, {
    decrypt: ()=>$b8e126da42a4b9e3$var$decrypt2,
    encrypt: ()=>$b8e126da42a4b9e3$var$encrypt2,
    getConversationKey: ()=>$b8e126da42a4b9e3$var$getConversationKey,
    v2: ()=>$b8e126da42a4b9e3$var$v2
});
var $b8e126da42a4b9e3$var$minPlaintextSize = 1;
var $b8e126da42a4b9e3$var$maxPlaintextSize = 65535;
function $b8e126da42a4b9e3$var$getConversationKey(privkeyA, pubkeyB) {
    const sharedX = (0, $5r7db.secp256k1).getSharedSecret(privkeyA, (0, $3Bcdj.hexToBytes)("02" + pubkeyB)).subarray(1, 33);
    return (0, $aN9nT.extract)((0, $htQ8Z.sha256), sharedX, $b8e126da42a4b9e3$var$utf8Encoder.encode("nip44-v2"));
}
function $b8e126da42a4b9e3$var$getMessageKeys(conversationKey, nonce) {
    const keys = (0, $aN9nT.expand)((0, $htQ8Z.sha256), conversationKey, nonce, 76);
    return {
        chacha_key: keys.subarray(0, 32),
        chacha_nonce: keys.subarray(32, 44),
        hmac_key: keys.subarray(44, 76)
    };
}
function $b8e126da42a4b9e3$var$calcPaddedLen(len) {
    if (!Number.isSafeInteger(len) || len < 1) throw new Error("expected positive integer");
    if (len <= 32) return 32;
    const nextPower = 1 << Math.floor(Math.log2(len - 1)) + 1;
    const chunk = nextPower <= 256 ? 32 : nextPower / 8;
    return chunk * (Math.floor((len - 1) / chunk) + 1);
}
function $b8e126da42a4b9e3$var$writeU16BE(num) {
    if (!Number.isSafeInteger(num) || num < $b8e126da42a4b9e3$var$minPlaintextSize || num > $b8e126da42a4b9e3$var$maxPlaintextSize) throw new Error("invalid plaintext size: must be between 1 and 65535 bytes");
    const arr = new Uint8Array(2);
    new DataView(arr.buffer).setUint16(0, num, false);
    return arr;
}
function $b8e126da42a4b9e3$var$pad(plaintext) {
    const unpadded = $b8e126da42a4b9e3$var$utf8Encoder.encode(plaintext);
    const unpaddedLen = unpadded.length;
    const prefix = $b8e126da42a4b9e3$var$writeU16BE(unpaddedLen);
    const suffix = new Uint8Array($b8e126da42a4b9e3$var$calcPaddedLen(unpaddedLen) - unpaddedLen);
    return (0, $3Bcdj.concatBytes)(prefix, unpadded, suffix);
}
function $b8e126da42a4b9e3$var$unpad(padded) {
    const unpaddedLen = new DataView(padded.buffer).getUint16(0);
    const unpadded = padded.subarray(2, 2 + unpaddedLen);
    if (unpaddedLen < $b8e126da42a4b9e3$var$minPlaintextSize || unpaddedLen > $b8e126da42a4b9e3$var$maxPlaintextSize || unpadded.length !== unpaddedLen || padded.length !== 2 + $b8e126da42a4b9e3$var$calcPaddedLen(unpaddedLen)) throw new Error("invalid padding");
    return $b8e126da42a4b9e3$var$utf8Decoder.decode(unpadded);
}
function $b8e126da42a4b9e3$var$hmacAad(key, message, aad) {
    if (aad.length !== 32) throw new Error("AAD associated data must be 32 bytes");
    const combined = (0, $3Bcdj.concatBytes)(aad, message);
    return (0, $70Xw9.hmac)((0, $htQ8Z.sha256), key, combined);
}
function $b8e126da42a4b9e3$var$decodePayload(payload) {
    if (typeof payload !== "string") throw new Error("payload must be a valid string");
    const plen = payload.length;
    if (plen < 132 || plen > 87472) throw new Error("invalid payload length: " + plen);
    if (payload[0] === "#") throw new Error("unknown encryption version");
    let data;
    try {
        data = (0, $83RRd.base64).decode(payload);
    } catch (error) {
        throw new Error("invalid base64: " + error.message);
    }
    const dlen = data.length;
    if (dlen < 99 || dlen > 65603) throw new Error("invalid data length: " + dlen);
    const vers = data[0];
    if (vers !== 2) throw new Error("unknown encryption version " + vers);
    return {
        nonce: data.subarray(1, 33),
        ciphertext: data.subarray(33, -32),
        mac: data.subarray(-32)
    };
}
function $b8e126da42a4b9e3$var$encrypt2(plaintext, conversationKey, nonce = (0, $3Bcdj.randomBytes)(32)) {
    const { chacha_key: chacha_key, chacha_nonce: chacha_nonce, hmac_key: hmac_key } = $b8e126da42a4b9e3$var$getMessageKeys(conversationKey, nonce);
    const padded = $b8e126da42a4b9e3$var$pad(plaintext);
    const ciphertext = (0, $lAjhr.chacha20)(chacha_key, chacha_nonce, padded);
    const mac = $b8e126da42a4b9e3$var$hmacAad(hmac_key, ciphertext, nonce);
    return (0, $83RRd.base64).encode((0, $3Bcdj.concatBytes)(new Uint8Array([
        2
    ]), nonce, ciphertext, mac));
}
function $b8e126da42a4b9e3$var$decrypt2(payload, conversationKey) {
    const { nonce: nonce, ciphertext: ciphertext, mac: mac } = $b8e126da42a4b9e3$var$decodePayload(payload);
    const { chacha_key: chacha_key, chacha_nonce: chacha_nonce, hmac_key: hmac_key } = $b8e126da42a4b9e3$var$getMessageKeys(conversationKey, nonce);
    const calculatedMac = $b8e126da42a4b9e3$var$hmacAad(hmac_key, ciphertext, nonce);
    if (!(0, $38xio.equalBytes)(calculatedMac, mac)) throw new Error("invalid MAC");
    const padded = (0, $lAjhr.chacha20)(chacha_key, chacha_nonce, ciphertext);
    return $b8e126da42a4b9e3$var$unpad(padded);
}
var $b8e126da42a4b9e3$var$v2 = {
    utils: {
        getConversationKey: $b8e126da42a4b9e3$var$getConversationKey,
        calcPaddedLen: $b8e126da42a4b9e3$var$calcPaddedLen
    },
    encrypt: $b8e126da42a4b9e3$var$encrypt2,
    decrypt: $b8e126da42a4b9e3$var$decrypt2
};
// nip59.ts
var $b8e126da42a4b9e3$var$TWO_DAYS = 172800;
var $b8e126da42a4b9e3$var$now = ()=>Math.round(Date.now() / 1e3);
var $b8e126da42a4b9e3$var$randomNow = ()=>Math.round($b8e126da42a4b9e3$var$now() - Math.random() * $b8e126da42a4b9e3$var$TWO_DAYS);
var $b8e126da42a4b9e3$var$nip44ConversationKey = (privateKey, publicKey)=>$b8e126da42a4b9e3$var$getConversationKey(privateKey, publicKey);
var $b8e126da42a4b9e3$var$nip44Encrypt = (data, privateKey, publicKey)=>$b8e126da42a4b9e3$var$encrypt2(JSON.stringify(data), $b8e126da42a4b9e3$var$nip44ConversationKey(privateKey, publicKey));
var $b8e126da42a4b9e3$var$nip44Decrypt = (data, privateKey)=>JSON.parse($b8e126da42a4b9e3$var$decrypt2(data.content, $b8e126da42a4b9e3$var$nip44ConversationKey(privateKey, data.pubkey)));
function $b8e126da42a4b9e3$var$createRumor(event, privateKey) {
    const rumor = {
        created_at: $b8e126da42a4b9e3$var$now(),
        content: "",
        tags: [],
        ...event,
        pubkey: $b8e126da42a4b9e3$export$889def73691f9837(privateKey)
    };
    rumor.id = $b8e126da42a4b9e3$export$11a838ad4e557e0e(rumor);
    return rumor;
}
function $b8e126da42a4b9e3$var$createSeal(rumor, privateKey, recipientPublicKey) {
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20({
        kind: $b8e126da42a4b9e3$var$Seal,
        content: $b8e126da42a4b9e3$var$nip44Encrypt(rumor, privateKey, recipientPublicKey),
        created_at: $b8e126da42a4b9e3$var$randomNow(),
        tags: []
    }, privateKey);
}
function $b8e126da42a4b9e3$var$createWrap(seal, recipientPublicKey) {
    const randomKey = $b8e126da42a4b9e3$export$16ca411381fc81c8();
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20({
        kind: $b8e126da42a4b9e3$var$GiftWrap,
        content: $b8e126da42a4b9e3$var$nip44Encrypt(seal, randomKey, recipientPublicKey),
        created_at: $b8e126da42a4b9e3$var$randomNow(),
        tags: [
            [
                "p",
                recipientPublicKey
            ]
        ]
    }, randomKey);
}
function $b8e126da42a4b9e3$var$wrapEvent(event, senderPrivateKey, recipientPublicKey) {
    const rumor = $b8e126da42a4b9e3$var$createRumor(event, senderPrivateKey);
    const seal = $b8e126da42a4b9e3$var$createSeal(rumor, senderPrivateKey, recipientPublicKey);
    return $b8e126da42a4b9e3$var$createWrap(seal, recipientPublicKey);
}
function $b8e126da42a4b9e3$var$wrapManyEvents(event, senderPrivateKey, recipientsPublicKeys) {
    if (!recipientsPublicKeys || recipientsPublicKeys.length === 0) throw new Error("At least one recipient is required.");
    const senderPublicKey = $b8e126da42a4b9e3$export$889def73691f9837(senderPrivateKey);
    const wrappeds = [
        $b8e126da42a4b9e3$var$wrapEvent(event, senderPrivateKey, senderPublicKey)
    ];
    recipientsPublicKeys.forEach((recipientPublicKey)=>{
        wrappeds.push($b8e126da42a4b9e3$var$wrapEvent(event, senderPrivateKey, recipientPublicKey));
    });
    return wrappeds;
}
function $b8e126da42a4b9e3$var$unwrapEvent(wrap, recipientPrivateKey) {
    const unwrappedSeal = $b8e126da42a4b9e3$var$nip44Decrypt(wrap, recipientPrivateKey);
    return $b8e126da42a4b9e3$var$nip44Decrypt(unwrappedSeal, recipientPrivateKey);
}
function $b8e126da42a4b9e3$var$unwrapManyEvents(wrappedEvents, recipientPrivateKey) {
    let unwrappedEvents = [];
    wrappedEvents.forEach((e)=>{
        unwrappedEvents.push($b8e126da42a4b9e3$var$unwrapEvent(e, recipientPrivateKey));
    });
    unwrappedEvents.sort((a, b)=>a.created_at - b.created_at);
    return unwrappedEvents;
}
// nip17.ts
function $b8e126da42a4b9e3$var$createEvent(recipients, message, conversationTitle, replyTo) {
    const baseEvent = {
        created_at: Math.ceil(Date.now() / 1e3),
        kind: $b8e126da42a4b9e3$var$PrivateDirectMessage,
        tags: [],
        content: message
    };
    const recipientsArray = Array.isArray(recipients) ? recipients : [
        recipients
    ];
    recipientsArray.forEach(({ publicKey: publicKey, relayUrl: relayUrl })=>{
        baseEvent.tags.push(relayUrl ? [
            "p",
            publicKey,
            relayUrl
        ] : [
            "p",
            publicKey
        ]);
    });
    if (replyTo) baseEvent.tags.push([
        "e",
        replyTo.eventId,
        replyTo.relayUrl || "",
        "reply"
    ]);
    if (conversationTitle) baseEvent.tags.push([
        "subject",
        conversationTitle
    ]);
    return baseEvent;
}
function $b8e126da42a4b9e3$var$wrapEvent2(senderPrivateKey, recipient, message, conversationTitle, replyTo) {
    const event = $b8e126da42a4b9e3$var$createEvent(recipient, message, conversationTitle, replyTo);
    return $b8e126da42a4b9e3$var$wrapEvent(event, senderPrivateKey, recipient.publicKey);
}
function $b8e126da42a4b9e3$var$wrapManyEvents2(senderPrivateKey, recipients, message, conversationTitle, replyTo) {
    if (!recipients || recipients.length === 0) throw new Error("At least one recipient is required.");
    const senderPublicKey = $b8e126da42a4b9e3$export$889def73691f9837(senderPrivateKey);
    return [
        {
            publicKey: senderPublicKey
        },
        ...recipients
    ].map((recipient)=>$b8e126da42a4b9e3$var$wrapEvent2(senderPrivateKey, recipient, message, conversationTitle, replyTo));
}
var $b8e126da42a4b9e3$var$unwrapEvent2 = $b8e126da42a4b9e3$var$unwrapEvent;
var $b8e126da42a4b9e3$var$unwrapManyEvents2 = $b8e126da42a4b9e3$var$unwrapManyEvents;
// nip18.ts
var $b8e126da42a4b9e3$export$4ea8e35b5adc7369 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$4ea8e35b5adc7369, {
    finishRepostEvent: ()=>$b8e126da42a4b9e3$var$finishRepostEvent,
    getRepostedEvent: ()=>$b8e126da42a4b9e3$var$getRepostedEvent,
    getRepostedEventPointer: ()=>$b8e126da42a4b9e3$var$getRepostedEventPointer
});
function $b8e126da42a4b9e3$var$finishRepostEvent(t, reposted, relayUrl, privateKey) {
    let kind;
    const tags = [
        ...t.tags ?? [],
        [
            "e",
            reposted.id,
            relayUrl
        ],
        [
            "p",
            reposted.pubkey
        ]
    ];
    if (reposted.kind === $b8e126da42a4b9e3$var$ShortTextNote) kind = $b8e126da42a4b9e3$var$Repost;
    else {
        kind = $b8e126da42a4b9e3$var$GenericRepost;
        tags.push([
            "k",
            String(reposted.kind)
        ]);
    }
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20({
        kind: kind,
        tags: tags,
        content: t.content === "" || reposted.tags?.find((tag)=>tag[0] === "-") ? "" : JSON.stringify(reposted),
        created_at: t.created_at
    }, privateKey);
}
function $b8e126da42a4b9e3$var$getRepostedEventPointer(event) {
    if (![
        $b8e126da42a4b9e3$var$Repost,
        $b8e126da42a4b9e3$var$GenericRepost
    ].includes(event.kind)) return void 0;
    let lastETag;
    let lastPTag;
    for(let i2 = event.tags.length - 1; i2 >= 0 && (lastETag === void 0 || lastPTag === void 0); i2--){
        const tag = event.tags[i2];
        if (tag.length >= 2) {
            if (tag[0] === "e" && lastETag === void 0) lastETag = tag;
            else if (tag[0] === "p" && lastPTag === void 0) lastPTag = tag;
        }
    }
    if (lastETag === void 0) return void 0;
    return {
        id: lastETag[1],
        relays: [
            lastETag[2],
            lastPTag?.[2]
        ].filter((x)=>typeof x === "string"),
        author: lastPTag?.[1]
    };
}
function $b8e126da42a4b9e3$var$getRepostedEvent(event, { skipVerification: skipVerification } = {}) {
    const pointer = $b8e126da42a4b9e3$var$getRepostedEventPointer(event);
    if (pointer === void 0 || event.content === "") return void 0;
    let repostedEvent;
    try {
        repostedEvent = JSON.parse(event.content);
    } catch (error) {
        return void 0;
    }
    if (repostedEvent.id !== pointer.id) return void 0;
    if (!skipVerification && !$b8e126da42a4b9e3$export$909d658b5069e986(repostedEvent)) return void 0;
    return repostedEvent;
}
// nip21.ts
var $b8e126da42a4b9e3$export$60e8a8091cb0f224 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$60e8a8091cb0f224, {
    NOSTR_URI_REGEX: ()=>$b8e126da42a4b9e3$var$NOSTR_URI_REGEX,
    parse: ()=>$b8e126da42a4b9e3$var$parse2,
    test: ()=>$b8e126da42a4b9e3$var$test
});
var $b8e126da42a4b9e3$var$NOSTR_URI_REGEX = new RegExp(`nostr:(${$b8e126da42a4b9e3$var$BECH32_REGEX.source})`);
function $b8e126da42a4b9e3$var$test(value) {
    return typeof value === "string" && new RegExp(`^${$b8e126da42a4b9e3$var$NOSTR_URI_REGEX.source}$`).test(value);
}
function $b8e126da42a4b9e3$var$parse2(uri) {
    const match = uri.match(new RegExp(`^${$b8e126da42a4b9e3$var$NOSTR_URI_REGEX.source}$`));
    if (!match) throw new Error(`Invalid Nostr URI: ${uri}`);
    return {
        uri: match[0],
        value: match[1],
        decoded: $b8e126da42a4b9e3$var$decode(match[1])
    };
}
// nip25.ts
var $b8e126da42a4b9e3$export$b1c1f2c9e30679b1 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$b1c1f2c9e30679b1, {
    finishReactionEvent: ()=>$b8e126da42a4b9e3$var$finishReactionEvent,
    getReactedEventPointer: ()=>$b8e126da42a4b9e3$var$getReactedEventPointer
});
function $b8e126da42a4b9e3$var$finishReactionEvent(t, reacted, privateKey) {
    const inheritedTags = reacted.tags.filter((tag)=>tag.length >= 2 && (tag[0] === "e" || tag[0] === "p"));
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20({
        ...t,
        kind: $b8e126da42a4b9e3$var$Reaction,
        tags: [
            ...t.tags ?? [],
            ...inheritedTags,
            [
                "e",
                reacted.id
            ],
            [
                "p",
                reacted.pubkey
            ]
        ],
        content: t.content ?? "+"
    }, privateKey);
}
function $b8e126da42a4b9e3$var$getReactedEventPointer(event) {
    if (event.kind !== $b8e126da42a4b9e3$var$Reaction) return void 0;
    let lastETag;
    let lastPTag;
    for(let i2 = event.tags.length - 1; i2 >= 0 && (lastETag === void 0 || lastPTag === void 0); i2--){
        const tag = event.tags[i2];
        if (tag.length >= 2) {
            if (tag[0] === "e" && lastETag === void 0) lastETag = tag;
            else if (tag[0] === "p" && lastPTag === void 0) lastPTag = tag;
        }
    }
    if (lastETag === void 0 || lastPTag === void 0) return void 0;
    return {
        id: lastETag[1],
        relays: [
            lastETag[2],
            lastPTag[2]
        ].filter((x)=>x !== void 0),
        author: lastPTag[1]
    };
}
// nip27.ts
var $b8e126da42a4b9e3$export$9ccc31c93a561269 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$9ccc31c93a561269, {
    parse: ()=>$b8e126da42a4b9e3$var$parse3
});
var $b8e126da42a4b9e3$var$noCharacter = /\W/m;
var $b8e126da42a4b9e3$var$noURLCharacter = /[^\w\/] |[^\w\/]$|$|,| /m;
var $b8e126da42a4b9e3$var$MAX_HASHTAG_LENGTH = 42;
function* $b8e126da42a4b9e3$var$parse3(content) {
    let emojis = [];
    if (typeof content !== "string") {
        for(let i2 = 0; i2 < content.tags.length; i2++){
            const tag = content.tags[i2];
            if (tag[0] === "emoji" && tag.length >= 3) emojis.push({
                type: "emoji",
                shortcode: tag[1],
                url: tag[2]
            });
        }
        content = content.content;
    }
    const max = content.length;
    let prevIndex = 0;
    let index = 0;
    mainloop: while(index < max){
        const u = content.indexOf(":", index);
        const h = content.indexOf("#", index);
        if (u === -1 && h === -1) break mainloop;
        if (u === -1 || h >= 0 && h < u) {
            if (h === 0 || content[h - 1].match($b8e126da42a4b9e3$var$noCharacter)) {
                const m = content.slice(h + 1, h + $b8e126da42a4b9e3$var$MAX_HASHTAG_LENGTH).match($b8e126da42a4b9e3$var$noCharacter);
                const end = m ? h + 1 + m.index : max;
                yield {
                    type: "text",
                    text: content.slice(prevIndex, h)
                };
                yield {
                    type: "hashtag",
                    value: content.slice(h + 1, end)
                };
                index = end;
                prevIndex = index;
                continue mainloop;
            }
            index = h + 1;
            continue mainloop;
        }
        if (content.slice(u - 5, u) === "nostr") {
            const m = content.slice(u + 60).match($b8e126da42a4b9e3$var$noCharacter);
            const end = m ? u + 60 + m.index : max;
            try {
                let pointer;
                let { data: data, type: type } = $b8e126da42a4b9e3$var$decode(content.slice(u + 1, end));
                switch(type){
                    case "npub":
                        pointer = {
                            pubkey: data
                        };
                        break;
                    case "note":
                        pointer = {
                            id: data
                        };
                        break;
                    case "nsec":
                        index = end + 1;
                        continue;
                    default:
                        pointer = data;
                }
                if (prevIndex !== u - 5) yield {
                    type: "text",
                    text: content.slice(prevIndex, u - 5)
                };
                yield {
                    type: "reference",
                    pointer: pointer
                };
                index = end;
                prevIndex = index;
                continue mainloop;
            } catch (_err) {
                index = u + 1;
                continue mainloop;
            }
        } else if (content.slice(u - 5, u) === "https" || content.slice(u - 4, u) === "http") {
            const m = content.slice(u + 4).match($b8e126da42a4b9e3$var$noURLCharacter);
            const end = m ? u + 4 + m.index : max;
            const prefixLen = content[u - 1] === "s" ? 5 : 4;
            try {
                let url = new URL(content.slice(u - prefixLen, end));
                if (url.hostname.indexOf(".") === -1) throw new Error("invalid url");
                if (prevIndex !== u - prefixLen) yield {
                    type: "text",
                    text: content.slice(prevIndex, u - prefixLen)
                };
                if (/\.(png|jpe?g|gif|webp|heic|svg)$/i.test(url.pathname)) {
                    yield {
                        type: "image",
                        url: url.toString()
                    };
                    index = end;
                    prevIndex = index;
                    continue mainloop;
                }
                if (/\.(mp4|avi|webm|mkv|mov)$/i.test(url.pathname)) {
                    yield {
                        type: "video",
                        url: url.toString()
                    };
                    index = end;
                    prevIndex = index;
                    continue mainloop;
                }
                if (/\.(mp3|aac|ogg|opus|wav|flac)$/i.test(url.pathname)) {
                    yield {
                        type: "audio",
                        url: url.toString()
                    };
                    index = end;
                    prevIndex = index;
                    continue mainloop;
                }
                yield {
                    type: "url",
                    url: url.toString()
                };
                index = end;
                prevIndex = index;
                continue mainloop;
            } catch (_err) {
                index = end + 1;
                continue mainloop;
            }
        } else if (content.slice(u - 3, u) === "wss" || content.slice(u - 2, u) === "ws") {
            const m = content.slice(u + 4).match($b8e126da42a4b9e3$var$noURLCharacter);
            const end = m ? u + 4 + m.index : max;
            const prefixLen = content[u - 1] === "s" ? 3 : 2;
            try {
                let url = new URL(content.slice(u - prefixLen, end));
                if (url.hostname.indexOf(".") === -1) throw new Error("invalid ws url");
                if (prevIndex !== u - prefixLen) yield {
                    type: "text",
                    text: content.slice(prevIndex, u - prefixLen)
                };
                yield {
                    type: "relay",
                    url: url.toString()
                };
                index = end;
                prevIndex = index;
                continue mainloop;
            } catch (_err) {
                index = end + 1;
                continue mainloop;
            }
        } else {
            for(let e = 0; e < emojis.length; e++){
                const emoji = emojis[e];
                if (content[u + emoji.shortcode.length + 1] === ":" && content.slice(u + 1, u + emoji.shortcode.length + 1) === emoji.shortcode) {
                    if (prevIndex !== u) yield {
                        type: "text",
                        text: content.slice(prevIndex, u)
                    };
                    yield emoji;
                    index = u + emoji.shortcode.length + 2;
                    prevIndex = index;
                    continue mainloop;
                }
            }
            index = u + 1;
            continue mainloop;
        }
    }
    if (prevIndex !== max) yield {
        type: "text",
        text: content.slice(prevIndex)
    };
}
// nip28.ts
var $b8e126da42a4b9e3$export$7071f77a07a6a6f4 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$7071f77a07a6a6f4, {
    channelCreateEvent: ()=>$b8e126da42a4b9e3$var$channelCreateEvent,
    channelHideMessageEvent: ()=>$b8e126da42a4b9e3$var$channelHideMessageEvent,
    channelMessageEvent: ()=>$b8e126da42a4b9e3$var$channelMessageEvent,
    channelMetadataEvent: ()=>$b8e126da42a4b9e3$var$channelMetadataEvent,
    channelMuteUserEvent: ()=>$b8e126da42a4b9e3$var$channelMuteUserEvent
});
var $b8e126da42a4b9e3$var$channelCreateEvent = (t, privateKey)=>{
    let content;
    if (typeof t.content === "object") content = JSON.stringify(t.content);
    else if (typeof t.content === "string") content = t.content;
    else return void 0;
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20({
        kind: $b8e126da42a4b9e3$var$ChannelCreation,
        tags: [
            ...t.tags ?? []
        ],
        content: content,
        created_at: t.created_at
    }, privateKey);
};
var $b8e126da42a4b9e3$var$channelMetadataEvent = (t, privateKey)=>{
    let content;
    if (typeof t.content === "object") content = JSON.stringify(t.content);
    else if (typeof t.content === "string") content = t.content;
    else return void 0;
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20({
        kind: $b8e126da42a4b9e3$var$ChannelMetadata,
        tags: [
            [
                "e",
                t.channel_create_event_id
            ],
            ...t.tags ?? []
        ],
        content: content,
        created_at: t.created_at
    }, privateKey);
};
var $b8e126da42a4b9e3$var$channelMessageEvent = (t, privateKey)=>{
    const tags = [
        [
            "e",
            t.channel_create_event_id,
            t.relay_url,
            "root"
        ]
    ];
    if (t.reply_to_channel_message_event_id) tags.push([
        "e",
        t.reply_to_channel_message_event_id,
        t.relay_url,
        "reply"
    ]);
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20({
        kind: $b8e126da42a4b9e3$var$ChannelMessage,
        tags: [
            ...tags,
            ...t.tags ?? []
        ],
        content: t.content,
        created_at: t.created_at
    }, privateKey);
};
var $b8e126da42a4b9e3$var$channelHideMessageEvent = (t, privateKey)=>{
    let content;
    if (typeof t.content === "object") content = JSON.stringify(t.content);
    else if (typeof t.content === "string") content = t.content;
    else return void 0;
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20({
        kind: $b8e126da42a4b9e3$var$ChannelHideMessage,
        tags: [
            [
                "e",
                t.channel_message_event_id
            ],
            ...t.tags ?? []
        ],
        content: content,
        created_at: t.created_at
    }, privateKey);
};
var $b8e126da42a4b9e3$var$channelMuteUserEvent = (t, privateKey)=>{
    let content;
    if (typeof t.content === "object") content = JSON.stringify(t.content);
    else if (typeof t.content === "string") content = t.content;
    else return void 0;
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20({
        kind: $b8e126da42a4b9e3$var$ChannelMuteUser,
        tags: [
            [
                "p",
                t.pubkey_to_mute
            ],
            ...t.tags ?? []
        ],
        content: content,
        created_at: t.created_at
    }, privateKey);
};
// nip30.ts
var $b8e126da42a4b9e3$export$66c1afb78a5c4d11 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$66c1afb78a5c4d11, {
    EMOJI_SHORTCODE_REGEX: ()=>$b8e126da42a4b9e3$var$EMOJI_SHORTCODE_REGEX,
    matchAll: ()=>$b8e126da42a4b9e3$var$matchAll,
    regex: ()=>$b8e126da42a4b9e3$var$regex,
    replaceAll: ()=>$b8e126da42a4b9e3$var$replaceAll
});
var $b8e126da42a4b9e3$var$EMOJI_SHORTCODE_REGEX = /:(\w+):/;
var $b8e126da42a4b9e3$var$regex = ()=>new RegExp(`\\B${$b8e126da42a4b9e3$var$EMOJI_SHORTCODE_REGEX.source}\\B`, "g");
function* $b8e126da42a4b9e3$var$matchAll(content) {
    const matches = content.matchAll($b8e126da42a4b9e3$var$regex());
    for (const match of matches)try {
        const [shortcode, name] = match;
        yield {
            shortcode: shortcode,
            name: name,
            start: match.index,
            end: match.index + shortcode.length
        };
    } catch (_e) {}
}
function $b8e126da42a4b9e3$var$replaceAll(content, replacer) {
    return content.replaceAll($b8e126da42a4b9e3$var$regex(), (shortcode, name)=>{
        return replacer({
            shortcode: shortcode,
            name: name
        });
    });
}
// nip39.ts
var $b8e126da42a4b9e3$export$13ad325f8a2de8f7 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$13ad325f8a2de8f7, {
    useFetchImplementation: ()=>$b8e126da42a4b9e3$var$useFetchImplementation3,
    validateGithub: ()=>$b8e126da42a4b9e3$var$validateGithub
});
var $b8e126da42a4b9e3$var$_fetch3;
try {
    $b8e126da42a4b9e3$var$_fetch3 = fetch;
} catch  {}
function $b8e126da42a4b9e3$var$useFetchImplementation3(fetchImplementation) {
    $b8e126da42a4b9e3$var$_fetch3 = fetchImplementation;
}
async function $b8e126da42a4b9e3$var$validateGithub(pubkey, username, proof) {
    try {
        let res = await (await $b8e126da42a4b9e3$var$_fetch3(`https://gist.github.com/${username}/${proof}/raw`)).text();
        return res === `Verifying that I control the following Nostr public key: ${pubkey}`;
    } catch (_) {
        return false;
    }
}
// nip47.ts
var $b8e126da42a4b9e3$export$ae4a1ae308afd39c = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$ae4a1ae308afd39c, {
    makeNwcRequestEvent: ()=>$b8e126da42a4b9e3$var$makeNwcRequestEvent,
    parseConnectionString: ()=>$b8e126da42a4b9e3$var$parseConnectionString
});
function $b8e126da42a4b9e3$var$parseConnectionString(connectionString) {
    const { host: host, pathname: pathname, searchParams: searchParams } = new URL(connectionString);
    const pubkey = pathname || host;
    const relay = searchParams.get("relay");
    const secret = searchParams.get("secret");
    if (!pubkey || !relay || !secret) throw new Error("invalid connection string");
    return {
        pubkey: pubkey,
        relay: relay,
        secret: secret
    };
}
async function $b8e126da42a4b9e3$var$makeNwcRequestEvent(pubkey, secretKey, invoice) {
    const content = {
        method: "pay_invoice",
        params: {
            invoice: invoice
        }
    };
    const encryptedContent = $b8e126da42a4b9e3$var$encrypt(secretKey, pubkey, JSON.stringify(content));
    const eventTemplate = {
        kind: $b8e126da42a4b9e3$var$NWCWalletRequest,
        created_at: Math.round(Date.now() / 1e3),
        content: encryptedContent,
        tags: [
            [
                "p",
                pubkey
            ]
        ]
    };
    return $b8e126da42a4b9e3$export$bc33d3bdc1ddcd20(eventTemplate, secretKey);
}
// nip54.ts
var $b8e126da42a4b9e3$export$bfde88566f6f2a51 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$bfde88566f6f2a51, {
    normalizeIdentifier: ()=>$b8e126da42a4b9e3$var$normalizeIdentifier
});
function $b8e126da42a4b9e3$var$normalizeIdentifier(name) {
    name = name.trim().toLowerCase();
    name = name.normalize("NFKC");
    return Array.from(name).map((char)=>{
        if (/\p{Letter}/u.test(char) || /\p{Number}/u.test(char)) return char;
        return "-";
    }).join("");
}
// nip57.ts
var $b8e126da42a4b9e3$export$14e0982e3a536e29 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$14e0982e3a536e29, {
    getSatoshisAmountFromBolt11: ()=>$b8e126da42a4b9e3$var$getSatoshisAmountFromBolt11,
    getZapEndpoint: ()=>$b8e126da42a4b9e3$var$getZapEndpoint,
    makeZapReceipt: ()=>$b8e126da42a4b9e3$var$makeZapReceipt,
    makeZapRequest: ()=>$b8e126da42a4b9e3$var$makeZapRequest,
    useFetchImplementation: ()=>$b8e126da42a4b9e3$var$useFetchImplementation4,
    validateZapRequest: ()=>$b8e126da42a4b9e3$var$validateZapRequest
});
var $b8e126da42a4b9e3$var$_fetch4;
try {
    $b8e126da42a4b9e3$var$_fetch4 = fetch;
} catch  {}
function $b8e126da42a4b9e3$var$useFetchImplementation4(fetchImplementation) {
    $b8e126da42a4b9e3$var$_fetch4 = fetchImplementation;
}
async function $b8e126da42a4b9e3$var$getZapEndpoint(metadata) {
    try {
        let lnurl = "";
        let { lud06: lud06, lud16: lud16 } = JSON.parse(metadata.content);
        if (lud16) {
            let [name, domain] = lud16.split("@");
            lnurl = new URL(`/.well-known/lnurlp/${name}`, `https://${domain}`).toString();
        } else if (lud06) {
            let { words: words } = (0, $83RRd.bech32).decode(lud06, 1e3);
            let data = (0, $83RRd.bech32).fromWords(words);
            lnurl = $b8e126da42a4b9e3$var$utf8Decoder.decode(data);
        } else return null;
        let res = await $b8e126da42a4b9e3$var$_fetch4(lnurl);
        let body = await res.json();
        if (body.allowsNostr && body.nostrPubkey) return body.callback;
    } catch (err) {}
    return null;
}
function $b8e126da42a4b9e3$var$makeZapRequest(params) {
    let zr = {
        kind: 9734,
        created_at: Math.round(Date.now() / 1e3),
        content: params.comment || "",
        tags: [
            [
                "p",
                "pubkey" in params ? params.pubkey : params.event.pubkey
            ],
            [
                "amount",
                params.amount.toString()
            ],
            [
                "relays",
                ...params.relays
            ]
        ]
    };
    if ("event" in params) {
        zr.tags.push([
            "e",
            params.event.id
        ]);
        if ($b8e126da42a4b9e3$var$isReplaceableKind(params.event.kind)) {
            const a = [
                "a",
                `${params.event.kind}:${params.event.pubkey}:`
            ];
            zr.tags.push(a);
        } else if ($b8e126da42a4b9e3$var$isAddressableKind(params.event.kind)) {
            let d = params.event.tags.find(([t, v])=>t === "d" && v);
            if (!d) throw new Error("d tag not found or is empty");
            const a = [
                "a",
                `${params.event.kind}:${params.event.pubkey}:${d[1]}`
            ];
            zr.tags.push(a);
        }
        zr.tags.push([
            "k",
            params.event.kind.toString()
        ]);
    }
    return zr;
}
function $b8e126da42a4b9e3$var$validateZapRequest(zapRequestString) {
    let zapRequest;
    try {
        zapRequest = JSON.parse(zapRequestString);
    } catch (err) {
        return "Invalid zap request JSON.";
    }
    if (!$b8e126da42a4b9e3$export$d08d852dd562b1ce(zapRequest)) return "Zap request is not a valid Nostr event.";
    if (!$b8e126da42a4b9e3$export$909d658b5069e986(zapRequest)) return "Invalid signature on zap request.";
    let p = zapRequest.tags.find(([t, v])=>t === "p" && v);
    if (!p) return "Zap request doesn't have a 'p' tag.";
    if (!p[1].match(/^[a-f0-9]{64}$/)) return "Zap request 'p' tag is not valid hex.";
    let e = zapRequest.tags.find(([t, v])=>t === "e" && v);
    if (e && !e[1].match(/^[a-f0-9]{64}$/)) return "Zap request 'e' tag is not valid hex.";
    let relays = zapRequest.tags.find(([t, v])=>t === "relays" && v);
    if (!relays) return "Zap request doesn't have a 'relays' tag.";
    return null;
}
function $b8e126da42a4b9e3$var$makeZapReceipt({ zapRequest: zapRequest, preimage: preimage, bolt11: bolt11, paidAt: paidAt }) {
    let zr = JSON.parse(zapRequest);
    let tagsFromZapRequest = zr.tags.filter(([t])=>t === "e" || t === "p" || t === "a");
    let zap = {
        kind: 9735,
        created_at: Math.round(paidAt.getTime() / 1e3),
        content: "",
        tags: [
            ...tagsFromZapRequest,
            [
                "P",
                zr.pubkey
            ],
            [
                "bolt11",
                bolt11
            ],
            [
                "description",
                zapRequest
            ]
        ]
    };
    if (preimage) zap.tags.push([
        "preimage",
        preimage
    ]);
    return zap;
}
function $b8e126da42a4b9e3$var$getSatoshisAmountFromBolt11(bolt11) {
    if (bolt11.length < 50) return 0;
    bolt11 = bolt11.substring(0, 50);
    const idx = bolt11.lastIndexOf("1");
    if (idx === -1) return 0;
    const hrp = bolt11.substring(0, idx);
    if (!hrp.startsWith("lnbc")) return 0;
    const amount = hrp.substring(4);
    if (amount.length < 1) return 0;
    const char = amount[amount.length - 1];
    const digit = char.charCodeAt(0) - "0".charCodeAt(0);
    const isDigit = digit >= 0 && digit <= 9;
    let cutPoint = amount.length - 1;
    if (isDigit) cutPoint++;
    if (cutPoint < 1) return 0;
    const num = parseInt(amount.substring(0, cutPoint));
    switch(char){
        case "m":
            return num * 1e5;
        case "u":
            return num * 100;
        case "n":
            return num / 10;
        case "p":
            return num / 1e4;
        default:
            return num * 1e8;
    }
}
// nip77.ts
var $b8e126da42a4b9e3$export$2bf7b3c2a8871429 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$2bf7b3c2a8871429, {
    Negentropy: ()=>$b8e126da42a4b9e3$var$Negentropy,
    NegentropyStorageVector: ()=>$b8e126da42a4b9e3$var$NegentropyStorageVector,
    NegentropySync: ()=>$b8e126da42a4b9e3$var$NegentropySync
});
var $b8e126da42a4b9e3$var$PROTOCOL_VERSION = 97;
var $b8e126da42a4b9e3$var$ID_SIZE = 32;
var $b8e126da42a4b9e3$var$FINGERPRINT_SIZE = 16;
var $b8e126da42a4b9e3$var$Mode = {
    Skip: 0,
    Fingerprint: 1,
    IdList: 2
};
var $b8e126da42a4b9e3$var$WrappedBuffer = class {
    _raw;
    length;
    constructor(buffer){
        if (typeof buffer === "number") {
            this._raw = new Uint8Array(buffer);
            this.length = 0;
        } else if (buffer instanceof Uint8Array) {
            this._raw = new Uint8Array(buffer);
            this.length = buffer.length;
        } else {
            this._raw = new Uint8Array(512);
            this.length = 0;
        }
    }
    unwrap() {
        return this._raw.subarray(0, this.length);
    }
    get capacity() {
        return this._raw.byteLength;
    }
    extend(buf) {
        if (buf instanceof $b8e126da42a4b9e3$var$WrappedBuffer) buf = buf.unwrap();
        if (typeof buf.length !== "number") throw Error("bad length");
        const targetSize = buf.length + this.length;
        if (this.capacity < targetSize) {
            const oldRaw = this._raw;
            const newCapacity = Math.max(this.capacity * 2, targetSize);
            this._raw = new Uint8Array(newCapacity);
            this._raw.set(oldRaw);
        }
        this._raw.set(buf, this.length);
        this.length += buf.length;
    }
    shift() {
        const first = this._raw[0];
        this._raw = this._raw.subarray(1);
        this.length--;
        return first;
    }
    shiftN(n = 1) {
        const firstSubarray = this._raw.subarray(0, n);
        this._raw = this._raw.subarray(n);
        this.length -= n;
        return firstSubarray;
    }
};
function $b8e126da42a4b9e3$var$decodeVarInt(buf) {
    let res = 0;
    while(true){
        if (buf.length === 0) throw Error("parse ends prematurely");
        let byte = buf.shift();
        res = res << 7 | byte & 127;
        if ((byte & 128) === 0) break;
    }
    return res;
}
function $b8e126da42a4b9e3$var$encodeVarInt(n) {
    if (n === 0) return new $b8e126da42a4b9e3$var$WrappedBuffer(new Uint8Array([
        0
    ]));
    let o = [];
    while(n !== 0){
        o.push(n & 127);
        n >>>= 7;
    }
    o.reverse();
    for(let i2 = 0; i2 < o.length - 1; i2++)o[i2] |= 128;
    return new $b8e126da42a4b9e3$var$WrappedBuffer(new Uint8Array(o));
}
function $b8e126da42a4b9e3$var$getByte(buf) {
    return $b8e126da42a4b9e3$var$getBytes(buf, 1)[0];
}
function $b8e126da42a4b9e3$var$getBytes(buf, n) {
    if (buf.length < n) throw Error("parse ends prematurely");
    return buf.shiftN(n);
}
var $b8e126da42a4b9e3$var$Accumulator = class {
    buf;
    constructor(){
        this.setToZero();
    }
    setToZero() {
        this.buf = new Uint8Array($b8e126da42a4b9e3$var$ID_SIZE);
    }
    add(otherBuf) {
        let currCarry = 0, nextCarry = 0;
        let p = new DataView(this.buf.buffer);
        let po = new DataView(otherBuf.buffer);
        for(let i2 = 0; i2 < 8; i2++){
            let offset = i2 * 4;
            let orig = p.getUint32(offset, true);
            let otherV = po.getUint32(offset, true);
            let next = orig;
            next += currCarry;
            next += otherV;
            if (next > 4294967295) nextCarry = 1;
            p.setUint32(offset, next & 4294967295, true);
            currCarry = nextCarry;
            nextCarry = 0;
        }
    }
    negate() {
        let p = new DataView(this.buf.buffer);
        for(let i2 = 0; i2 < 8; i2++){
            let offset = i2 * 4;
            p.setUint32(offset, ~p.getUint32(offset, true));
        }
        let one = new Uint8Array($b8e126da42a4b9e3$var$ID_SIZE);
        one[0] = 1;
        this.add(one);
    }
    getFingerprint(n) {
        let input = new $b8e126da42a4b9e3$var$WrappedBuffer();
        input.extend(this.buf);
        input.extend($b8e126da42a4b9e3$var$encodeVarInt(n));
        let hash = (0, $htQ8Z.sha256)(input.unwrap());
        return hash.subarray(0, $b8e126da42a4b9e3$var$FINGERPRINT_SIZE);
    }
};
var $b8e126da42a4b9e3$var$NegentropyStorageVector = class {
    items;
    sealed;
    constructor(){
        this.items = [];
        this.sealed = false;
    }
    insert(timestamp, id) {
        if (this.sealed) throw Error("already sealed");
        const idb = (0, $3Bcdj.hexToBytes)(id);
        if (idb.byteLength !== $b8e126da42a4b9e3$var$ID_SIZE) throw Error("bad id size for added item");
        this.items.push({
            timestamp: timestamp,
            id: idb
        });
    }
    seal() {
        if (this.sealed) throw Error("already sealed");
        this.sealed = true;
        this.items.sort($b8e126da42a4b9e3$var$itemCompare);
        for(let i2 = 1; i2 < this.items.length; i2++){
            if ($b8e126da42a4b9e3$var$itemCompare(this.items[i2 - 1], this.items[i2]) === 0) throw Error("duplicate item inserted");
        }
    }
    unseal() {
        this.sealed = false;
    }
    size() {
        this._checkSealed();
        return this.items.length;
    }
    getItem(i2) {
        this._checkSealed();
        if (i2 >= this.items.length) throw Error("out of range");
        return this.items[i2];
    }
    iterate(begin, end, cb) {
        this._checkSealed();
        this._checkBounds(begin, end);
        for(let i2 = begin; i2 < end; ++i2){
            if (!cb(this.items[i2], i2)) break;
        }
    }
    findLowerBound(begin, end, bound) {
        this._checkSealed();
        this._checkBounds(begin, end);
        return this._binarySearch(this.items, begin, end, (a)=>$b8e126da42a4b9e3$var$itemCompare(a, bound) < 0);
    }
    fingerprint(begin, end) {
        let out = new $b8e126da42a4b9e3$var$Accumulator();
        out.setToZero();
        this.iterate(begin, end, (item)=>{
            out.add(item.id);
            return true;
        });
        return out.getFingerprint(end - begin);
    }
    _checkSealed() {
        if (!this.sealed) throw Error("not sealed");
    }
    _checkBounds(begin, end) {
        if (begin > end || end > this.items.length) throw Error("bad range");
    }
    _binarySearch(arr, first, last, cmp) {
        let count = last - first;
        while(count > 0){
            let it = first;
            let step = Math.floor(count / 2);
            it += step;
            if (cmp(arr[it])) {
                first = ++it;
                count -= step + 1;
            } else count = step;
        }
        return first;
    }
};
var $b8e126da42a4b9e3$var$Negentropy = class {
    storage;
    frameSizeLimit;
    lastTimestampIn;
    lastTimestampOut;
    constructor(storage, frameSizeLimit = 6e4){
        if (frameSizeLimit < 4096) throw Error("frameSizeLimit too small");
        this.storage = storage;
        this.frameSizeLimit = frameSizeLimit;
        this.lastTimestampIn = 0;
        this.lastTimestampOut = 0;
    }
    _bound(timestamp, id) {
        return {
            timestamp: timestamp,
            id: id || new Uint8Array(0)
        };
    }
    initiate() {
        let output = new $b8e126da42a4b9e3$var$WrappedBuffer();
        output.extend(new Uint8Array([
            $b8e126da42a4b9e3$var$PROTOCOL_VERSION
        ]));
        this.splitRange(0, this.storage.size(), this._bound(Number.MAX_VALUE), output);
        return (0, $3Bcdj.bytesToHex)(output.unwrap());
    }
    reconcile(queryMsg, onhave, onneed) {
        const query = new $b8e126da42a4b9e3$var$WrappedBuffer((0, $3Bcdj.hexToBytes)(queryMsg));
        this.lastTimestampIn = this.lastTimestampOut = 0;
        let fullOutput = new $b8e126da42a4b9e3$var$WrappedBuffer();
        fullOutput.extend(new Uint8Array([
            $b8e126da42a4b9e3$var$PROTOCOL_VERSION
        ]));
        let protocolVersion = $b8e126da42a4b9e3$var$getByte(query);
        if (protocolVersion < 96 || protocolVersion > 111) throw Error("invalid negentropy protocol version byte");
        if (protocolVersion !== $b8e126da42a4b9e3$var$PROTOCOL_VERSION) throw Error("unsupported negentropy protocol version requested: " + (protocolVersion - 96));
        let storageSize = this.storage.size();
        let prevBound = this._bound(0);
        let prevIndex = 0;
        let skip = false;
        while(query.length !== 0){
            let o = new $b8e126da42a4b9e3$var$WrappedBuffer();
            let doSkip = ()=>{
                if (skip) {
                    skip = false;
                    o.extend(this.encodeBound(prevBound));
                    o.extend($b8e126da42a4b9e3$var$encodeVarInt($b8e126da42a4b9e3$var$Mode.Skip));
                }
            };
            let currBound = this.decodeBound(query);
            let mode = $b8e126da42a4b9e3$var$decodeVarInt(query);
            let lower = prevIndex;
            let upper = this.storage.findLowerBound(prevIndex, storageSize, currBound);
            if (mode === $b8e126da42a4b9e3$var$Mode.Skip) skip = true;
            else if (mode === $b8e126da42a4b9e3$var$Mode.Fingerprint) {
                let theirFingerprint = $b8e126da42a4b9e3$var$getBytes(query, $b8e126da42a4b9e3$var$FINGERPRINT_SIZE);
                let ourFingerprint = this.storage.fingerprint(lower, upper);
                if ($b8e126da42a4b9e3$var$compareUint8Array(theirFingerprint, ourFingerprint) !== 0) {
                    doSkip();
                    this.splitRange(lower, upper, currBound, o);
                } else skip = true;
            } else if (mode === $b8e126da42a4b9e3$var$Mode.IdList) {
                let numIds = $b8e126da42a4b9e3$var$decodeVarInt(query);
                let theirElems = {};
                for(let i2 = 0; i2 < numIds; i2++){
                    let e = $b8e126da42a4b9e3$var$getBytes(query, $b8e126da42a4b9e3$var$ID_SIZE);
                    theirElems[(0, $3Bcdj.bytesToHex)(e)] = e;
                }
                skip = true;
                this.storage.iterate(lower, upper, (item)=>{
                    let k = item.id;
                    const id = (0, $3Bcdj.bytesToHex)(k);
                    if (!theirElems[id]) onhave?.(id);
                    else delete theirElems[(0, $3Bcdj.bytesToHex)(k)];
                    return true;
                });
                if (onneed) for (let v of Object.values(theirElems))onneed((0, $3Bcdj.bytesToHex)(v));
            } else throw Error("unexpected mode");
            if (this.exceededFrameSizeLimit(fullOutput.length + o.length)) {
                let remainingFingerprint = this.storage.fingerprint(upper, storageSize);
                fullOutput.extend(this.encodeBound(this._bound(Number.MAX_VALUE)));
                fullOutput.extend($b8e126da42a4b9e3$var$encodeVarInt($b8e126da42a4b9e3$var$Mode.Fingerprint));
                fullOutput.extend(remainingFingerprint);
                break;
            } else fullOutput.extend(o);
            prevIndex = upper;
            prevBound = currBound;
        }
        return fullOutput.length === 1 ? null : (0, $3Bcdj.bytesToHex)(fullOutput.unwrap());
    }
    splitRange(lower, upper, upperBound, o) {
        let numElems = upper - lower;
        let buckets = 16;
        if (numElems < buckets * 2) {
            o.extend(this.encodeBound(upperBound));
            o.extend($b8e126da42a4b9e3$var$encodeVarInt($b8e126da42a4b9e3$var$Mode.IdList));
            o.extend($b8e126da42a4b9e3$var$encodeVarInt(numElems));
            this.storage.iterate(lower, upper, (item)=>{
                o.extend(item.id);
                return true;
            });
        } else {
            let itemsPerBucket = Math.floor(numElems / buckets);
            let bucketsWithExtra = numElems % buckets;
            let curr = lower;
            for(let i2 = 0; i2 < buckets; i2++){
                let bucketSize = itemsPerBucket + (i2 < bucketsWithExtra ? 1 : 0);
                let ourFingerprint = this.storage.fingerprint(curr, curr + bucketSize);
                curr += bucketSize;
                let nextBound;
                if (curr === upper) nextBound = upperBound;
                else {
                    let prevItem;
                    let currItem;
                    this.storage.iterate(curr - 1, curr + 1, (item, index)=>{
                        if (index === curr - 1) prevItem = item;
                        else currItem = item;
                        return true;
                    });
                    nextBound = this.getMinimalBound(prevItem, currItem);
                }
                o.extend(this.encodeBound(nextBound));
                o.extend($b8e126da42a4b9e3$var$encodeVarInt($b8e126da42a4b9e3$var$Mode.Fingerprint));
                o.extend(ourFingerprint);
            }
        }
    }
    exceededFrameSizeLimit(n) {
        return n > this.frameSizeLimit - 200;
    }
    decodeTimestampIn(encoded) {
        let timestamp = $b8e126da42a4b9e3$var$decodeVarInt(encoded);
        timestamp = timestamp === 0 ? Number.MAX_VALUE : timestamp - 1;
        if (this.lastTimestampIn === Number.MAX_VALUE || timestamp === Number.MAX_VALUE) {
            this.lastTimestampIn = Number.MAX_VALUE;
            return Number.MAX_VALUE;
        }
        timestamp += this.lastTimestampIn;
        this.lastTimestampIn = timestamp;
        return timestamp;
    }
    decodeBound(encoded) {
        let timestamp = this.decodeTimestampIn(encoded);
        let len = $b8e126da42a4b9e3$var$decodeVarInt(encoded);
        if (len > $b8e126da42a4b9e3$var$ID_SIZE) throw Error("bound key too long");
        let id = $b8e126da42a4b9e3$var$getBytes(encoded, len);
        return {
            timestamp: timestamp,
            id: id
        };
    }
    encodeTimestampOut(timestamp) {
        if (timestamp === Number.MAX_VALUE) {
            this.lastTimestampOut = Number.MAX_VALUE;
            return $b8e126da42a4b9e3$var$encodeVarInt(0);
        }
        let temp = timestamp;
        timestamp -= this.lastTimestampOut;
        this.lastTimestampOut = temp;
        return $b8e126da42a4b9e3$var$encodeVarInt(timestamp + 1);
    }
    encodeBound(key) {
        let output = new $b8e126da42a4b9e3$var$WrappedBuffer();
        output.extend(this.encodeTimestampOut(key.timestamp));
        output.extend($b8e126da42a4b9e3$var$encodeVarInt(key.id.length));
        output.extend(key.id);
        return output;
    }
    getMinimalBound(prev, curr) {
        if (curr.timestamp !== prev.timestamp) return this._bound(curr.timestamp);
        else {
            let sharedPrefixBytes = 0;
            let currKey = curr.id;
            let prevKey = prev.id;
            for(let i2 = 0; i2 < $b8e126da42a4b9e3$var$ID_SIZE; i2++){
                if (currKey[i2] !== prevKey[i2]) break;
                sharedPrefixBytes++;
            }
            return this._bound(curr.timestamp, curr.id.subarray(0, sharedPrefixBytes + 1));
        }
    }
};
function $b8e126da42a4b9e3$var$compareUint8Array(a, b) {
    for(let i2 = 0; i2 < a.byteLength; i2++){
        if (a[i2] < b[i2]) return -1;
        if (a[i2] > b[i2]) return 1;
    }
    if (a.byteLength > b.byteLength) return 1;
    if (a.byteLength < b.byteLength) return -1;
    return 0;
}
function $b8e126da42a4b9e3$var$itemCompare(a, b) {
    if (a.timestamp === b.timestamp) return $b8e126da42a4b9e3$var$compareUint8Array(a.id, b.id);
    return a.timestamp - b.timestamp;
}
var $b8e126da42a4b9e3$var$NegentropySync = class {
    relay;
    storage;
    neg;
    filter;
    subscription;
    onhave;
    onneed;
    constructor(relay, storage, filter, params = {}){
        this.relay = relay;
        this.storage = storage;
        this.neg = new $b8e126da42a4b9e3$var$Negentropy(storage);
        this.onhave = params.onhave;
        this.onneed = params.onneed;
        this.filter = filter;
        this.subscription = this.relay.prepareSubscription([
            {}
        ], {
            label: params.label || "negentropy"
        });
        this.subscription.oncustom = (data)=>{
            switch(data[0]){
                case "NEG-MSG":
                    if (data.length < 3) console.warn(`got invalid NEG-MSG from ${this.relay.url}: ${data}`);
                    try {
                        const response = this.neg.reconcile(data[2], this.onhave, this.onneed);
                        if (response) this.relay.send(`["NEG-MSG", "${this.subscription.id}", "${response}"]`);
                        else {
                            this.close();
                            params.onclose?.();
                        }
                    } catch (error) {
                        console.error("negentropy reconcile error:", error);
                        params?.onclose?.(`reconcile error: ${error}`);
                    }
                    break;
                case "NEG-CLOSE":
                    {
                        const reason = data[2];
                        console.warn("negentropy error:", reason);
                        params.onclose?.(reason);
                        break;
                    }
                case "NEG-ERR":
                    params.onclose?.();
            }
        };
    }
    async start() {
        const initMsg = this.neg.initiate();
        this.relay.send(`["NEG-OPEN","${this.subscription.id}",${JSON.stringify(this.filter)},"${initMsg}"]`);
    }
    close() {
        this.relay.send(`["NEG-CLOSE","${this.subscription.id}"]`);
        this.subscription.close();
    }
};
// nip98.ts
var $b8e126da42a4b9e3$export$dbfcdd2f6b6e41d9 = {};
$b8e126da42a4b9e3$var$__export($b8e126da42a4b9e3$export$dbfcdd2f6b6e41d9, {
    getToken: ()=>$b8e126da42a4b9e3$var$getToken,
    hashPayload: ()=>$b8e126da42a4b9e3$var$hashPayload,
    unpackEventFromToken: ()=>$b8e126da42a4b9e3$var$unpackEventFromToken,
    validateEvent: ()=>$b8e126da42a4b9e3$var$validateEvent2,
    validateEventKind: ()=>$b8e126da42a4b9e3$var$validateEventKind,
    validateEventMethodTag: ()=>$b8e126da42a4b9e3$var$validateEventMethodTag,
    validateEventPayloadTag: ()=>$b8e126da42a4b9e3$var$validateEventPayloadTag,
    validateEventTimestamp: ()=>$b8e126da42a4b9e3$var$validateEventTimestamp,
    validateEventUrlTag: ()=>$b8e126da42a4b9e3$var$validateEventUrlTag,
    validateToken: ()=>$b8e126da42a4b9e3$var$validateToken
});
var $b8e126da42a4b9e3$var$_authorizationScheme = "Nostr ";
async function $b8e126da42a4b9e3$var$getToken(loginUrl, httpMethod, sign, includeAuthorizationScheme = false, payload) {
    const event = {
        kind: $b8e126da42a4b9e3$var$HTTPAuth,
        tags: [
            [
                "u",
                loginUrl
            ],
            [
                "method",
                httpMethod
            ]
        ],
        created_at: Math.round(new Date().getTime() / 1e3),
        content: ""
    };
    if (payload) event.tags.push([
        "payload",
        $b8e126da42a4b9e3$var$hashPayload(payload)
    ]);
    const signedEvent = await sign(event);
    const authorizationScheme = includeAuthorizationScheme ? $b8e126da42a4b9e3$var$_authorizationScheme : "";
    return authorizationScheme + (0, $83RRd.base64).encode($b8e126da42a4b9e3$var$utf8Encoder.encode(JSON.stringify(signedEvent)));
}
async function $b8e126da42a4b9e3$var$validateToken(token, url, method) {
    const event = await $b8e126da42a4b9e3$var$unpackEventFromToken(token).catch((error)=>{
        throw error;
    });
    const valid = await $b8e126da42a4b9e3$var$validateEvent2(event, url, method).catch((error)=>{
        throw error;
    });
    return valid;
}
async function $b8e126da42a4b9e3$var$unpackEventFromToken(token) {
    if (!token) throw new Error("Missing token");
    token = token.replace($b8e126da42a4b9e3$var$_authorizationScheme, "");
    const eventB64 = $b8e126da42a4b9e3$var$utf8Decoder.decode((0, $83RRd.base64).decode(token));
    if (!eventB64 || eventB64.length === 0 || !eventB64.startsWith("{")) throw new Error("Invalid token");
    const event = JSON.parse(eventB64);
    return event;
}
function $b8e126da42a4b9e3$var$validateEventTimestamp(event) {
    if (!event.created_at) return false;
    return Math.round(new Date().getTime() / 1e3) - event.created_at < 60;
}
function $b8e126da42a4b9e3$var$validateEventKind(event) {
    return event.kind === $b8e126da42a4b9e3$var$HTTPAuth;
}
function $b8e126da42a4b9e3$var$validateEventUrlTag(event, url) {
    const urlTag = event.tags.find((t)=>t[0] === "u");
    if (!urlTag) return false;
    return urlTag.length > 0 && urlTag[1] === url;
}
function $b8e126da42a4b9e3$var$validateEventMethodTag(event, method) {
    const methodTag = event.tags.find((t)=>t[0] === "method");
    if (!methodTag) return false;
    return methodTag.length > 0 && methodTag[1].toLowerCase() === method.toLowerCase();
}
function $b8e126da42a4b9e3$var$hashPayload(payload) {
    const hash = (0, $htQ8Z.sha256)($b8e126da42a4b9e3$var$utf8Encoder.encode(JSON.stringify(payload)));
    return (0, $3Bcdj.bytesToHex)(hash);
}
function $b8e126da42a4b9e3$var$validateEventPayloadTag(event, payload) {
    const payloadTag = event.tags.find((t)=>t[0] === "payload");
    if (!payloadTag) return false;
    const payloadHash = $b8e126da42a4b9e3$var$hashPayload(payload);
    return payloadTag.length > 0 && payloadTag[1] === payloadHash;
}
async function $b8e126da42a4b9e3$var$validateEvent2(event, url, method, body) {
    if (!$b8e126da42a4b9e3$export$909d658b5069e986(event)) throw new Error("Invalid nostr event, signature invalid");
    if (!$b8e126da42a4b9e3$var$validateEventKind(event)) throw new Error("Invalid nostr event, kind invalid");
    if (!$b8e126da42a4b9e3$var$validateEventTimestamp(event)) throw new Error("Invalid nostr event, created_at timestamp invalid");
    if (!$b8e126da42a4b9e3$var$validateEventUrlTag(event, url)) throw new Error("Invalid nostr event, url tag invalid");
    if (!$b8e126da42a4b9e3$var$validateEventMethodTag(event, method)) throw new Error("Invalid nostr event, method tag invalid");
    if (Boolean(body) && typeof body === "object" && Object.keys(body).length > 0) {
        if (!$b8e126da42a4b9e3$var$validateEventPayloadTag(event, body)) throw new Error("Invalid nostr event, payload tag does not match request body hash");
    }
    return true;
}

});
parcelRegister("5r7db", function(module, exports) {

$parcel$export(module.exports, "secp256k1", () => $3f551179096121b9$export$529e6123e9353a90);
$parcel$export(module.exports, "schnorr", () => $3f551179096121b9$export$1f2401df071be9f);
/**
 * SECG secp256k1. See [pdf](https://www.secg.org/sec2-v2.pdf).
 *
 * Belongs to Koblitz curves: it has efficiently-computable GLV endomorphism ψ,
 * check out {@link EndomorphismOpts}. Seems to be rigid (not backdoored).
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $htQ8Z = parcelRequire("htQ8Z");

var $3Bcdj = parcelRequire("3Bcdj");

var $lkFCe = parcelRequire("lkFCe");

var $rkPJ6 = parcelRequire("rkPJ6");

var $2D9sF = parcelRequire("2D9sF");

var $gNPqy = parcelRequire("gNPqy");
parcelRequire("f2mJU");
var $3Bcdj = parcelRequire("3Bcdj");
var $f2mJU = parcelRequire("f2mJU");
// Seems like generator was produced from some seed:
// `Pointk1.BASE.multiply(Pointk1.Fn.inv(2n, N)).toAffine().x`
// // gives short x 0x3b78ce563f89a0ed9414f5aa28ad0d96d6795f9c63n
const $3f551179096121b9$var$secp256k1_CURVE = {
    p: BigInt('0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f'),
    n: BigInt('0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141'),
    h: BigInt(1),
    a: BigInt(0),
    b: BigInt(7),
    Gx: BigInt('0x79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798'),
    Gy: BigInt('0x483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8')
};
const $3f551179096121b9$var$secp256k1_ENDO = {
    beta: BigInt('0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee'),
    basises: [
        [
            BigInt('0x3086d221a7d46bcde86c90e49284eb15'),
            -BigInt('0xe4437ed6010e88286f547fa90abfe4c3')
        ],
        [
            BigInt('0x114ca50f7a8e2f3f657c1108d9d44cfd8'),
            BigInt('0x3086d221a7d46bcde86c90e49284eb15')
        ]
    ]
};
const $3f551179096121b9$var$_0n = /* @__PURE__ */ BigInt(0);
const $3f551179096121b9$var$_2n = /* @__PURE__ */ BigInt(2);
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $3f551179096121b9$var$sqrtMod(y) {
    const P = $3f551179096121b9$var$secp256k1_CURVE.p;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $2D9sF.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $2D9sF.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $2D9sF.pow2)(b9, $3f551179096121b9$var$_2n, P) * b2 % P;
    const b22 = (0, $2D9sF.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $2D9sF.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $2D9sF.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $2D9sF.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $2D9sF.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $2D9sF.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $2D9sF.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $2D9sF.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $2D9sF.pow2)(t2, $3f551179096121b9$var$_2n, P);
    if (!$3f551179096121b9$var$Fpk1.eql($3f551179096121b9$var$Fpk1.sqr(root), y)) throw new Error('Cannot find square root');
    return root;
}
const $3f551179096121b9$var$Fpk1 = (0, $2D9sF.Field)($3f551179096121b9$var$secp256k1_CURVE.p, {
    sqrt: $3f551179096121b9$var$sqrtMod
});
const $3f551179096121b9$var$Pointk1 = /* @__PURE__ */ (0, $gNPqy.weierstrass)($3f551179096121b9$var$secp256k1_CURVE, {
    Fp: $3f551179096121b9$var$Fpk1,
    endo: $3f551179096121b9$var$secp256k1_ENDO
});
const $3f551179096121b9$export$529e6123e9353a90 = /* @__PURE__ */ (0, $gNPqy.ecdsa)($3f551179096121b9$var$Pointk1, (0, $htQ8Z.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $3f551179096121b9$var$TAGGED_HASH_PREFIXES = {};
function $3f551179096121b9$var$taggedHash(tag, ...messages) {
    let tagP = $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $htQ8Z.sha256)((0, $f2mJU.asciiToBytes)(tag));
        tagP = (0, $3Bcdj.concatBytes)(tagH, tagH);
        $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $htQ8Z.sha256)((0, $3Bcdj.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $3f551179096121b9$var$pointToBytes = (point)=>point.toBytes(true).slice(1);
const $3f551179096121b9$var$hasEven = (y)=>y % $3f551179096121b9$var$_2n === $3f551179096121b9$var$_0n;
// Calculate point, scalar and bytes
function $3f551179096121b9$var$schnorrGetExtPubKey(priv) {
    const { Fn: Fn, BASE: BASE } = $3f551179096121b9$var$Pointk1;
    const d_ = Fn.fromBytes(priv);
    const p = BASE.multiply(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = $3f551179096121b9$var$hasEven(p.y) ? d_ : Fn.neg(d_);
    return {
        scalar: scalar,
        bytes: $3f551179096121b9$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $3f551179096121b9$var$lift_x(x) {
    const Fp = $3f551179096121b9$var$Fpk1;
    if (!Fp.isValidNot0(x)) throw new Error("invalid x: Fail if x \u2265 p");
    const xx = Fp.create(x * x);
    const c = Fp.create(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = Fp.sqrt(c); // Let y = c^(p+1)/4 mod p. Same as sqrt().
    // Return the unique point P such that x(P) = x and
    // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    if (!$3f551179096121b9$var$hasEven(y)) y = Fp.neg(y);
    const p = $3f551179096121b9$var$Pointk1.fromAffine({
        x: x,
        y: y
    });
    p.assertValidity();
    return p;
}
const $3f551179096121b9$var$num = (0, $f2mJU.bytesToNumberBE);
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $3f551179096121b9$var$challenge(...args) {
    return $3f551179096121b9$var$Pointk1.Fn.create($3f551179096121b9$var$num($3f551179096121b9$var$taggedHash('BIP0340/challenge', ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $3f551179096121b9$var$schnorrGetPublicKey(secretKey) {
    return $3f551179096121b9$var$schnorrGetExtPubKey(secretKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $3f551179096121b9$var$schnorrSign(message, secretKey, auxRand = (0, $3Bcdj.randomBytes)(32)) {
    const { Fn: Fn } = $3f551179096121b9$var$Pointk1;
    const m = (0, $3Bcdj.abytes)(message, undefined, 'message');
    const { bytes: px, scalar: d } = $3f551179096121b9$var$schnorrGetExtPubKey(secretKey); // checks for isWithinCurveOrder
    const a = (0, $3Bcdj.abytes)(auxRand, 32, 'auxRand'); // Auxiliary random data a: a 32-byte array
    const t = Fn.toBytes(d ^ $3f551179096121b9$var$num($3f551179096121b9$var$taggedHash('BIP0340/aux', a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $3f551179096121b9$var$taggedHash('BIP0340/nonce', t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    // Let k' = int(rand) mod n. Fail if k' = 0. Let R = k'⋅G
    const { bytes: rx, scalar: k } = $3f551179096121b9$var$schnorrGetExtPubKey(rand);
    const e = $3f551179096121b9$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set(Fn.toBytes(Fn.create(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$3f551179096121b9$var$schnorrVerify(sig, m, px)) throw new Error('sign: Invalid signature produced');
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $3f551179096121b9$var$schnorrVerify(signature, message, publicKey) {
    const { Fp: Fp, Fn: Fn, BASE: BASE } = $3f551179096121b9$var$Pointk1;
    const sig = (0, $3Bcdj.abytes)(signature, 64, 'signature');
    const m = (0, $3Bcdj.abytes)(message, undefined, 'message');
    const pub = (0, $3Bcdj.abytes)(publicKey, 32, 'publicKey');
    try {
        const P = $3f551179096121b9$var$lift_x($3f551179096121b9$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $3f551179096121b9$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!Fp.isValidNot0(r)) return false;
        const s = $3f551179096121b9$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!Fn.isValidNot0(s)) return false;
        const e = $3f551179096121b9$var$challenge(Fn.toBytes(r), $3f551179096121b9$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        // R = s⋅G - e⋅P, where -eP == (n-e)P
        const R = BASE.multiplyUnsafe(s).add(P.multiplyUnsafe(Fn.neg(e)));
        const { x: x, y: y } = R.toAffine();
        // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
        if (R.is0() || !$3f551179096121b9$var$hasEven(y) || x !== r) return false;
        return true;
    } catch (error) {
        return false;
    }
}
const $3f551179096121b9$export$1f2401df071be9f = /* @__PURE__ */ (()=>{
    const size = 32;
    const seedLength = 48;
    const randomSecretKey = (seed = (0, $3Bcdj.randomBytes)(seedLength))=>{
        return (0, $2D9sF.mapHashToField)(seed, $3f551179096121b9$var$secp256k1_CURVE.n);
    };
    return {
        keygen: (0, $lkFCe.createKeygen)(randomSecretKey, $3f551179096121b9$var$schnorrGetPublicKey),
        getPublicKey: $3f551179096121b9$var$schnorrGetPublicKey,
        sign: $3f551179096121b9$var$schnorrSign,
        verify: $3f551179096121b9$var$schnorrVerify,
        Point: $3f551179096121b9$var$Pointk1,
        utils: {
            randomSecretKey: randomSecretKey,
            taggedHash: $3f551179096121b9$var$taggedHash,
            lift_x: $3f551179096121b9$var$lift_x,
            pointToBytes: $3f551179096121b9$var$pointToBytes
        },
        lengths: {
            secretKey: size,
            publicKey: size,
            publicKeyHasPrefix: false,
            signature: size * 2,
            seed: seedLength
        }
    };
})();
const $3f551179096121b9$var$isoMap = /* @__PURE__ */ (()=>(0, $rkPJ6.isogenyMap)($3f551179096121b9$var$Fpk1, [
        // xNum
        [
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7',
            '0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581',
            '0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262',
            '0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c'
        ],
        // xDen
        [
            '0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b',
            '0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ],
        // yNum
        [
            '0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c',
            '0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3',
            '0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931',
            '0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84'
        ],
        // yDen
        [
            '0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b',
            '0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573',
            '0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f',
            '0x0000000000000000000000000000000000000000000000000000000000000001'
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $3f551179096121b9$var$mapSWU = /* @__PURE__ */ (()=>(0, $gNPqy.mapToCurveSimpleSWU)($3f551179096121b9$var$Fpk1, {
        A: BigInt('0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533'),
        B: BigInt('1771'),
        Z: $3f551179096121b9$var$Fpk1.create(BigInt('-11'))
    }))();
const $3f551179096121b9$export$e7a33585c78e532a = /* @__PURE__ */ (()=>(0, $rkPJ6.createHasher)($3f551179096121b9$var$Pointk1, (scalars)=>{
        const { x: x, y: y } = $3f551179096121b9$var$mapSWU($3f551179096121b9$var$Fpk1.create(scalars[0]));
        return $3f551179096121b9$var$isoMap(x, y);
    }, {
        DST: 'secp256k1_XMD:SHA-256_SSWU_RO_',
        encodeDST: 'secp256k1_XMD:SHA-256_SSWU_NU_',
        p: $3f551179096121b9$var$Fpk1.ORDER,
        m: 1,
        k: 128,
        expand: 'xmd',
        hash: (0, $htQ8Z.sha256)
    }))();

});
parcelRegister("htQ8Z", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $cb9d97d4d61a5a71$export$bced8d2aada2d1c9);
/**
 * SHA2 hash function. A.k.a. sha256, sha384, sha512, sha512_224, sha512_256.
 * SHA256 is the fastest hash implementable in JS, even faster than Blake3.
 * Check out [RFC 4634](https://www.rfc-editor.org/rfc/rfc4634) and
 * [FIPS 180-4](https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf).
 * @module
 */ 
var $iYRTw = parcelRequire("iYRTw");

var $eDgKs = parcelRequire("eDgKs");

var $3Bcdj = parcelRequire("3Bcdj");
/**
 * Round constants:
 * First 32 bits of fractional parts of the cube roots of the first 64 primes 2..311)
 */ // prettier-ignore
const $cb9d97d4d61a5a71$var$SHA256_K = /* @__PURE__ */ Uint32Array.from([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/** Reusable temporary buffer. "W" comes straight from spec. */ const $cb9d97d4d61a5a71$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
/** Internal 32-byte base SHA2 hash class. */ class $cb9d97d4d61a5a71$var$SHA2_32B extends (0, $iYRTw.HashMD) {
    constructor(outputLen){
        super(64, outputLen, 8, false);
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$cb9d97d4d61a5a71$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $cb9d97d4d61a5a71$var$SHA256_W[i - 15];
            const W2 = $cb9d97d4d61a5a71$var$SHA256_W[i - 2];
            const s0 = (0, $3Bcdj.rotr)(W15, 7) ^ (0, $3Bcdj.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3Bcdj.rotr)(W2, 17) ^ (0, $3Bcdj.rotr)(W2, 19) ^ W2 >>> 10;
            $cb9d97d4d61a5a71$var$SHA256_W[i] = s1 + $cb9d97d4d61a5a71$var$SHA256_W[i - 7] + s0 + $cb9d97d4d61a5a71$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3Bcdj.rotr)(E, 6) ^ (0, $3Bcdj.rotr)(E, 11) ^ (0, $3Bcdj.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $iYRTw.Chi)(E, F, G) + $cb9d97d4d61a5a71$var$SHA256_K[i] + $cb9d97d4d61a5a71$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3Bcdj.rotr)(A, 2) ^ (0, $3Bcdj.rotr)(A, 13) ^ (0, $3Bcdj.rotr)(A, 22);
            const T2 = sigma0 + (0, $iYRTw.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        (0, $3Bcdj.clean)($cb9d97d4d61a5a71$var$SHA256_W);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        (0, $3Bcdj.clean)(this.buffer);
    }
}
class $cb9d97d4d61a5a71$export$978b14127c36190d extends $cb9d97d4d61a5a71$var$SHA2_32B {
    // We cannot use array here since array allows indexing by variable
    // which means optimizer/compiler cannot use registers.
    A = (0, $iYRTw.SHA256_IV)[0] | 0;
    B = (0, $iYRTw.SHA256_IV)[1] | 0;
    C = (0, $iYRTw.SHA256_IV)[2] | 0;
    D = (0, $iYRTw.SHA256_IV)[3] | 0;
    E = (0, $iYRTw.SHA256_IV)[4] | 0;
    F = (0, $iYRTw.SHA256_IV)[5] | 0;
    G = (0, $iYRTw.SHA256_IV)[6] | 0;
    H = (0, $iYRTw.SHA256_IV)[7] | 0;
    constructor(){
        super(32);
    }
}
class $cb9d97d4d61a5a71$export$bb11dd29d05650f6 extends $cb9d97d4d61a5a71$var$SHA2_32B {
    A = (0, $iYRTw.SHA224_IV)[0] | 0;
    B = (0, $iYRTw.SHA224_IV)[1] | 0;
    C = (0, $iYRTw.SHA224_IV)[2] | 0;
    D = (0, $iYRTw.SHA224_IV)[3] | 0;
    E = (0, $iYRTw.SHA224_IV)[4] | 0;
    F = (0, $iYRTw.SHA224_IV)[5] | 0;
    G = (0, $iYRTw.SHA224_IV)[6] | 0;
    H = (0, $iYRTw.SHA224_IV)[7] | 0;
    constructor(){
        super(28);
    }
}
// SHA2-512 is slower than sha256 in js because u64 operations are slow.
// Round contants
// First 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409
// prettier-ignore
const $cb9d97d4d61a5a71$var$K512 = /* @__PURE__ */ (()=>$eDgKs.split([
        '0x428a2f98d728ae22',
        '0x7137449123ef65cd',
        '0xb5c0fbcfec4d3b2f',
        '0xe9b5dba58189dbbc',
        '0x3956c25bf348b538',
        '0x59f111f1b605d019',
        '0x923f82a4af194f9b',
        '0xab1c5ed5da6d8118',
        '0xd807aa98a3030242',
        '0x12835b0145706fbe',
        '0x243185be4ee4b28c',
        '0x550c7dc3d5ffb4e2',
        '0x72be5d74f27b896f',
        '0x80deb1fe3b1696b1',
        '0x9bdc06a725c71235',
        '0xc19bf174cf692694',
        '0xe49b69c19ef14ad2',
        '0xefbe4786384f25e3',
        '0x0fc19dc68b8cd5b5',
        '0x240ca1cc77ac9c65',
        '0x2de92c6f592b0275',
        '0x4a7484aa6ea6e483',
        '0x5cb0a9dcbd41fbd4',
        '0x76f988da831153b5',
        '0x983e5152ee66dfab',
        '0xa831c66d2db43210',
        '0xb00327c898fb213f',
        '0xbf597fc7beef0ee4',
        '0xc6e00bf33da88fc2',
        '0xd5a79147930aa725',
        '0x06ca6351e003826f',
        '0x142929670a0e6e70',
        '0x27b70a8546d22ffc',
        '0x2e1b21385c26c926',
        '0x4d2c6dfc5ac42aed',
        '0x53380d139d95b3df',
        '0x650a73548baf63de',
        '0x766a0abb3c77b2a8',
        '0x81c2c92e47edaee6',
        '0x92722c851482353b',
        '0xa2bfe8a14cf10364',
        '0xa81a664bbc423001',
        '0xc24b8b70d0f89791',
        '0xc76c51a30654be30',
        '0xd192e819d6ef5218',
        '0xd69906245565a910',
        '0xf40e35855771202a',
        '0x106aa07032bbd1b8',
        '0x19a4c116b8d2d0c8',
        '0x1e376c085141ab53',
        '0x2748774cdf8eeb99',
        '0x34b0bcb5e19b48a8',
        '0x391c0cb3c5c95a63',
        '0x4ed8aa4ae3418acb',
        '0x5b9cca4f7763e373',
        '0x682e6ff3d6b2b8a3',
        '0x748f82ee5defb2fc',
        '0x78a5636f43172f60',
        '0x84c87814a1f0ab72',
        '0x8cc702081a6439ec',
        '0x90befffa23631e28',
        '0xa4506cebde82bde9',
        '0xbef9a3f7b2c67915',
        '0xc67178f2e372532b',
        '0xca273eceea26619c',
        '0xd186b8c721c0c207',
        '0xeada7dd6cde0eb1e',
        '0xf57d4f7fee6ed178',
        '0x06f067aa72176fba',
        '0x0a637dc5a2c898a6',
        '0x113f9804bef90dae',
        '0x1b710b35131c471b',
        '0x28db77f523047d84',
        '0x32caab7b40c72493',
        '0x3c9ebe0a15c9bebc',
        '0x431d67c49c100d4c',
        '0x4cc5d4becb3e42b6',
        '0x597f299cfc657e2a',
        '0x5fcb6fab3ad6faec',
        '0x6c44198c4a475817'
    ].map((n)=>BigInt(n))))();
const $cb9d97d4d61a5a71$var$SHA512_Kh = /* @__PURE__ */ (()=>$cb9d97d4d61a5a71$var$K512[0])();
const $cb9d97d4d61a5a71$var$SHA512_Kl = /* @__PURE__ */ (()=>$cb9d97d4d61a5a71$var$K512[1])();
// Reusable temporary buffers
const $cb9d97d4d61a5a71$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $cb9d97d4d61a5a71$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
/** Internal 64-byte base SHA2 hash class. */ class $cb9d97d4d61a5a71$var$SHA2_64B extends (0, $iYRTw.HashMD) {
    constructor(outputLen){
        super(128, outputLen, 16, false);
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $cb9d97d4d61a5a71$var$SHA512_W_H[i] = view.getUint32(offset);
            $cb9d97d4d61a5a71$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $cb9d97d4d61a5a71$var$SHA512_W_H[i - 15] | 0;
            const W15l = $cb9d97d4d61a5a71$var$SHA512_W_L[i - 15] | 0;
            const s0h = $eDgKs.rotrSH(W15h, W15l, 1) ^ $eDgKs.rotrSH(W15h, W15l, 8) ^ $eDgKs.shrSH(W15h, W15l, 7);
            const s0l = $eDgKs.rotrSL(W15h, W15l, 1) ^ $eDgKs.rotrSL(W15h, W15l, 8) ^ $eDgKs.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $cb9d97d4d61a5a71$var$SHA512_W_H[i - 2] | 0;
            const W2l = $cb9d97d4d61a5a71$var$SHA512_W_L[i - 2] | 0;
            const s1h = $eDgKs.rotrSH(W2h, W2l, 19) ^ $eDgKs.rotrBH(W2h, W2l, 61) ^ $eDgKs.shrSH(W2h, W2l, 6);
            const s1l = $eDgKs.rotrSL(W2h, W2l, 19) ^ $eDgKs.rotrBL(W2h, W2l, 61) ^ $eDgKs.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $eDgKs.add4L(s0l, s1l, $cb9d97d4d61a5a71$var$SHA512_W_L[i - 7], $cb9d97d4d61a5a71$var$SHA512_W_L[i - 16]);
            const SUMh = $eDgKs.add4H(SUMl, s0h, s1h, $cb9d97d4d61a5a71$var$SHA512_W_H[i - 7], $cb9d97d4d61a5a71$var$SHA512_W_H[i - 16]);
            $cb9d97d4d61a5a71$var$SHA512_W_H[i] = SUMh | 0;
            $cb9d97d4d61a5a71$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $eDgKs.rotrSH(Eh, El, 14) ^ $eDgKs.rotrSH(Eh, El, 18) ^ $eDgKs.rotrBH(Eh, El, 41);
            const sigma1l = $eDgKs.rotrSL(Eh, El, 14) ^ $eDgKs.rotrSL(Eh, El, 18) ^ $eDgKs.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $eDgKs.add5L(Hl, sigma1l, CHIl, $cb9d97d4d61a5a71$var$SHA512_Kl[i], $cb9d97d4d61a5a71$var$SHA512_W_L[i]);
            const T1h = $eDgKs.add5H(T1ll, Hh, sigma1h, CHIh, $cb9d97d4d61a5a71$var$SHA512_Kh[i], $cb9d97d4d61a5a71$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $eDgKs.rotrSH(Ah, Al, 28) ^ $eDgKs.rotrBH(Ah, Al, 34) ^ $eDgKs.rotrBH(Ah, Al, 39);
            const sigma0l = $eDgKs.rotrSL(Ah, Al, 28) ^ $eDgKs.rotrBL(Ah, Al, 34) ^ $eDgKs.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $eDgKs.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $eDgKs.add3L(T1l, sigma0l, MAJl);
            Ah = $eDgKs.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $eDgKs.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $eDgKs.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $eDgKs.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $eDgKs.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $eDgKs.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $eDgKs.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $eDgKs.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $eDgKs.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        (0, $3Bcdj.clean)($cb9d97d4d61a5a71$var$SHA512_W_H, $cb9d97d4d61a5a71$var$SHA512_W_L);
    }
    destroy() {
        (0, $3Bcdj.clean)(this.buffer);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $cb9d97d4d61a5a71$export$f1b13c91499a6586 extends $cb9d97d4d61a5a71$var$SHA2_64B {
    Ah = (0, $iYRTw.SHA512_IV)[0] | 0;
    Al = (0, $iYRTw.SHA512_IV)[1] | 0;
    Bh = (0, $iYRTw.SHA512_IV)[2] | 0;
    Bl = (0, $iYRTw.SHA512_IV)[3] | 0;
    Ch = (0, $iYRTw.SHA512_IV)[4] | 0;
    Cl = (0, $iYRTw.SHA512_IV)[5] | 0;
    Dh = (0, $iYRTw.SHA512_IV)[6] | 0;
    Dl = (0, $iYRTw.SHA512_IV)[7] | 0;
    Eh = (0, $iYRTw.SHA512_IV)[8] | 0;
    El = (0, $iYRTw.SHA512_IV)[9] | 0;
    Fh = (0, $iYRTw.SHA512_IV)[10] | 0;
    Fl = (0, $iYRTw.SHA512_IV)[11] | 0;
    Gh = (0, $iYRTw.SHA512_IV)[12] | 0;
    Gl = (0, $iYRTw.SHA512_IV)[13] | 0;
    Hh = (0, $iYRTw.SHA512_IV)[14] | 0;
    Hl = (0, $iYRTw.SHA512_IV)[15] | 0;
    constructor(){
        super(64);
    }
}
class $cb9d97d4d61a5a71$export$f4ad3bd28f228957 extends $cb9d97d4d61a5a71$var$SHA2_64B {
    Ah = (0, $iYRTw.SHA384_IV)[0] | 0;
    Al = (0, $iYRTw.SHA384_IV)[1] | 0;
    Bh = (0, $iYRTw.SHA384_IV)[2] | 0;
    Bl = (0, $iYRTw.SHA384_IV)[3] | 0;
    Ch = (0, $iYRTw.SHA384_IV)[4] | 0;
    Cl = (0, $iYRTw.SHA384_IV)[5] | 0;
    Dh = (0, $iYRTw.SHA384_IV)[6] | 0;
    Dl = (0, $iYRTw.SHA384_IV)[7] | 0;
    Eh = (0, $iYRTw.SHA384_IV)[8] | 0;
    El = (0, $iYRTw.SHA384_IV)[9] | 0;
    Fh = (0, $iYRTw.SHA384_IV)[10] | 0;
    Fl = (0, $iYRTw.SHA384_IV)[11] | 0;
    Gh = (0, $iYRTw.SHA384_IV)[12] | 0;
    Gl = (0, $iYRTw.SHA384_IV)[13] | 0;
    Hh = (0, $iYRTw.SHA384_IV)[14] | 0;
    Hl = (0, $iYRTw.SHA384_IV)[15] | 0;
    constructor(){
        super(48);
    }
}
/**
 * Truncated SHA512/256 and SHA512/224.
 * SHA512_IV is XORed with 0xa5a5a5a5a5a5a5a5, then used as "intermediary" IV of SHA512/t.
 * Then t hashes string to produce result IV.
 * See `test/misc/sha2-gen-iv.js`.
 */ /** SHA512/224 IV */ const $cb9d97d4d61a5a71$var$T224_IV = /* @__PURE__ */ Uint32Array.from([
    0x8c3d37c8,
    0x19544da2,
    0x73e19966,
    0x89dcd4d6,
    0x1dfab7ae,
    0x32ff9c82,
    0x679dd514,
    0x582f9fcf,
    0x0f6d2b69,
    0x7bd44da8,
    0x77e36f73,
    0x04c48942,
    0x3f9d85a8,
    0x6a1d36c8,
    0x1112e6ad,
    0x91d692a1
]);
/** SHA512/256 IV */ const $cb9d97d4d61a5a71$var$T256_IV = /* @__PURE__ */ Uint32Array.from([
    0x22312194,
    0xfc2bf72c,
    0x9f555fa3,
    0xc84c64c2,
    0x2393b86b,
    0x6f53b151,
    0x96387719,
    0x5940eabd,
    0x96283ee2,
    0xa88effe3,
    0xbe5e1e25,
    0x53863992,
    0x2b0199fc,
    0x2c85b8aa,
    0x0eb72ddc,
    0x81c52ca2
]);
class $cb9d97d4d61a5a71$export$224cfee675191366 extends $cb9d97d4d61a5a71$var$SHA2_64B {
    Ah = $cb9d97d4d61a5a71$var$T224_IV[0] | 0;
    Al = $cb9d97d4d61a5a71$var$T224_IV[1] | 0;
    Bh = $cb9d97d4d61a5a71$var$T224_IV[2] | 0;
    Bl = $cb9d97d4d61a5a71$var$T224_IV[3] | 0;
    Ch = $cb9d97d4d61a5a71$var$T224_IV[4] | 0;
    Cl = $cb9d97d4d61a5a71$var$T224_IV[5] | 0;
    Dh = $cb9d97d4d61a5a71$var$T224_IV[6] | 0;
    Dl = $cb9d97d4d61a5a71$var$T224_IV[7] | 0;
    Eh = $cb9d97d4d61a5a71$var$T224_IV[8] | 0;
    El = $cb9d97d4d61a5a71$var$T224_IV[9] | 0;
    Fh = $cb9d97d4d61a5a71$var$T224_IV[10] | 0;
    Fl = $cb9d97d4d61a5a71$var$T224_IV[11] | 0;
    Gh = $cb9d97d4d61a5a71$var$T224_IV[12] | 0;
    Gl = $cb9d97d4d61a5a71$var$T224_IV[13] | 0;
    Hh = $cb9d97d4d61a5a71$var$T224_IV[14] | 0;
    Hl = $cb9d97d4d61a5a71$var$T224_IV[15] | 0;
    constructor(){
        super(28);
    }
}
class $cb9d97d4d61a5a71$export$9705f0e3a7ee4586 extends $cb9d97d4d61a5a71$var$SHA2_64B {
    Ah = $cb9d97d4d61a5a71$var$T256_IV[0] | 0;
    Al = $cb9d97d4d61a5a71$var$T256_IV[1] | 0;
    Bh = $cb9d97d4d61a5a71$var$T256_IV[2] | 0;
    Bl = $cb9d97d4d61a5a71$var$T256_IV[3] | 0;
    Ch = $cb9d97d4d61a5a71$var$T256_IV[4] | 0;
    Cl = $cb9d97d4d61a5a71$var$T256_IV[5] | 0;
    Dh = $cb9d97d4d61a5a71$var$T256_IV[6] | 0;
    Dl = $cb9d97d4d61a5a71$var$T256_IV[7] | 0;
    Eh = $cb9d97d4d61a5a71$var$T256_IV[8] | 0;
    El = $cb9d97d4d61a5a71$var$T256_IV[9] | 0;
    Fh = $cb9d97d4d61a5a71$var$T256_IV[10] | 0;
    Fl = $cb9d97d4d61a5a71$var$T256_IV[11] | 0;
    Gh = $cb9d97d4d61a5a71$var$T256_IV[12] | 0;
    Gl = $cb9d97d4d61a5a71$var$T256_IV[13] | 0;
    Hh = $cb9d97d4d61a5a71$var$T256_IV[14] | 0;
    Hl = $cb9d97d4d61a5a71$var$T256_IV[15] | 0;
    constructor(){
        super(32);
    }
}
const $cb9d97d4d61a5a71$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$export$978b14127c36190d(), /* @__PURE__ */ (0, $3Bcdj.oidNist)(0x01));
const $cb9d97d4d61a5a71$export$97b70509d4e397ea = /* @__PURE__ */ (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$export$bb11dd29d05650f6(), /* @__PURE__ */ (0, $3Bcdj.oidNist)(0x04));
const $cb9d97d4d61a5a71$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$export$f1b13c91499a6586(), /* @__PURE__ */ (0, $3Bcdj.oidNist)(0x03));
const $cb9d97d4d61a5a71$export$612d47d55dedde45 = /* @__PURE__ */ (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$export$f4ad3bd28f228957(), /* @__PURE__ */ (0, $3Bcdj.oidNist)(0x02));
const $cb9d97d4d61a5a71$export$c78786b6da86db2a = /* @__PURE__ */ (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$export$9705f0e3a7ee4586(), /* @__PURE__ */ (0, $3Bcdj.oidNist)(0x06));
const $cb9d97d4d61a5a71$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $3Bcdj.createHasher)(()=>new $cb9d97d4d61a5a71$export$224cfee675191366(), /* @__PURE__ */ (0, $3Bcdj.oidNist)(0x05));

});
parcelRegister("iYRTw", function(module, exports) {

$parcel$export(module.exports, "Chi", () => $dd17a2ee919821c7$export$d0d97f016526eaf0);
$parcel$export(module.exports, "Maj", () => $dd17a2ee919821c7$export$8b1d810b1bd30adf);
$parcel$export(module.exports, "HashMD", () => $dd17a2ee919821c7$export$f9f830659f932cb2);
$parcel$export(module.exports, "SHA256_IV", () => $dd17a2ee919821c7$export$a986fdf7a5bdfdf8);
$parcel$export(module.exports, "SHA224_IV", () => $dd17a2ee919821c7$export$104dc246f4c65f21);
$parcel$export(module.exports, "SHA384_IV", () => $dd17a2ee919821c7$export$b5217b4b948279ee);
$parcel$export(module.exports, "SHA512_IV", () => $dd17a2ee919821c7$export$f2cbb88a1784d2d1);
/**
 * Internal Merkle-Damgard hash utils.
 * @module
 */ 
var $3Bcdj = parcelRequire("3Bcdj");
function $dd17a2ee919821c7$export$d0d97f016526eaf0(a, b, c) {
    return a & b ^ ~a & c;
}
function $dd17a2ee919821c7$export$8b1d810b1bd30adf(a, b, c) {
    return a & b ^ a & c ^ b & c;
}
class $dd17a2ee919821c7$export$f9f830659f932cb2 {
    blockLen;
    outputLen;
    padOffset;
    isLE;
    // For partial updates less than block size
    buffer;
    view;
    finished = false;
    length = 0;
    pos = 0;
    destroyed = false;
    constructor(blockLen, outputLen, padOffset, isLE){
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3Bcdj.createView)(this.buffer);
    }
    update(data) {
        (0, $3Bcdj.aexists)(this);
        (0, $3Bcdj.abytes)(data);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3Bcdj.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $3Bcdj.aexists)(this);
        (0, $3Bcdj.aoutput)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        (0, $3Bcdj.clean)(this.buffer.subarray(pos));
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        view.setBigUint64(blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3Bcdj.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which must be fused in single op with modulo by JIT
        if (len % 4) throw new Error('_sha2: outputLen must be aligned to 32bit');
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error('_sha2: outputLen bigger than state');
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to ||= new this.constructor();
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.destroyed = destroyed;
        to.finished = finished;
        to.length = length;
        to.pos = pos;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
}
const $dd17a2ee919821c7$export$a986fdf7a5bdfdf8 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
const $dd17a2ee919821c7$export$104dc246f4c65f21 = /* @__PURE__ */ Uint32Array.from([
    0xc1059ed8,
    0x367cd507,
    0x3070dd17,
    0xf70e5939,
    0xffc00b31,
    0x68581511,
    0x64f98fa7,
    0xbefa4fa4
]);
const $dd17a2ee919821c7$export$b5217b4b948279ee = /* @__PURE__ */ Uint32Array.from([
    0xcbbb9d5d,
    0xc1059ed8,
    0x629a292a,
    0x367cd507,
    0x9159015a,
    0x3070dd17,
    0x152fecd8,
    0xf70e5939,
    0x67332667,
    0xffc00b31,
    0x8eb44a87,
    0x68581511,
    0xdb0c2e0d,
    0x64f98fa7,
    0x47b5481d,
    0xbefa4fa4
]);
const $dd17a2ee919821c7$export$f2cbb88a1784d2d1 = /* @__PURE__ */ Uint32Array.from([
    0x6a09e667,
    0xf3bcc908,
    0xbb67ae85,
    0x84caa73b,
    0x3c6ef372,
    0xfe94f82b,
    0xa54ff53a,
    0x5f1d36f1,
    0x510e527f,
    0xade682d1,
    0x9b05688c,
    0x2b3e6c1f,
    0x1f83d9ab,
    0xfb41bd6b,
    0x5be0cd19,
    0x137e2179
]);

});
parcelRegister("3Bcdj", function(module, exports) {

$parcel$export(module.exports, "isBytes", () => $29ee4d3171d9809b$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "anumber", () => $29ee4d3171d9809b$export$75364c6cb16d43b6);
$parcel$export(module.exports, "abytes", () => $29ee4d3171d9809b$export$e8a750b9efad93f5);
$parcel$export(module.exports, "ahash", () => $29ee4d3171d9809b$export$3ff5a4f04de7e52e);
$parcel$export(module.exports, "aexists", () => $29ee4d3171d9809b$export$20871f6b1d047d77);
$parcel$export(module.exports, "aoutput", () => $29ee4d3171d9809b$export$e8e53abee12b995e);
$parcel$export(module.exports, "clean", () => $29ee4d3171d9809b$export$cf0b2a6c63f9e656);
$parcel$export(module.exports, "createView", () => $29ee4d3171d9809b$export$d7febe7b891e79f0);
$parcel$export(module.exports, "rotr", () => $29ee4d3171d9809b$export$466993d7d0d272aa);
$parcel$export(module.exports, "bytesToHex", () => $29ee4d3171d9809b$export$58b867e287a802c8);
$parcel$export(module.exports, "hexToBytes", () => $29ee4d3171d9809b$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "concatBytes", () => $29ee4d3171d9809b$export$287dd7971339c972);
$parcel$export(module.exports, "createHasher", () => $29ee4d3171d9809b$export$14b114effbc08b6b);
$parcel$export(module.exports, "randomBytes", () => $29ee4d3171d9809b$export$5f828d93ff035aa8);
$parcel$export(module.exports, "oidNist", () => $29ee4d3171d9809b$export$6befe166550a2fc1);
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ /** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function $29ee4d3171d9809b$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $29ee4d3171d9809b$export$75364c6cb16d43b6(n, title = '') {
    if (!Number.isSafeInteger(n) || n < 0) {
        const prefix = title && `"${title}" `;
        throw new Error(`${prefix}expected integer >= 0, got ${n}`);
    }
}
function $29ee4d3171d9809b$export$e8a750b9efad93f5(value, length, title = '') {
    const bytes = $29ee4d3171d9809b$export$c6fabfbfd097fc30(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || needsLen && len !== length) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : '';
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        throw new Error(prefix + 'expected Uint8Array' + ofLen + ', got ' + got);
    }
    return value;
}
function $29ee4d3171d9809b$export$3ff5a4f04de7e52e(h) {
    if (typeof h !== 'function' || typeof h.create !== 'function') throw new Error('Hash must wrapped by utils.createHasher');
    $29ee4d3171d9809b$export$75364c6cb16d43b6(h.outputLen);
    $29ee4d3171d9809b$export$75364c6cb16d43b6(h.blockLen);
}
function $29ee4d3171d9809b$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $29ee4d3171d9809b$export$e8e53abee12b995e(out, instance) {
    $29ee4d3171d9809b$export$e8a750b9efad93f5(out, undefined, 'digestInto() output');
    const min = instance.outputLen;
    if (out.length < min) throw new Error('"digestInto() output" expected to be of length >=' + min);
}
function $29ee4d3171d9809b$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $29ee4d3171d9809b$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $29ee4d3171d9809b$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $29ee4d3171d9809b$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $29ee4d3171d9809b$export$466993d7d0d272aa(word, shift) {
    return word << 32 - shift | word >>> shift;
}
function $29ee4d3171d9809b$export$ac5e39599698b562(word, shift) {
    return word << shift | word >>> 32 - shift >>> 0;
}
const $29ee4d3171d9809b$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
function $29ee4d3171d9809b$export$a4170f7f8be47425(word) {
    return word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
}
const $29ee4d3171d9809b$export$e108944b32ae0e38 = $29ee4d3171d9809b$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$29ee4d3171d9809b$export$a4170f7f8be47425(n);
function $29ee4d3171d9809b$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $29ee4d3171d9809b$export$a4170f7f8be47425(arr[i]);
    return arr;
}
const $29ee4d3171d9809b$export$f3e5ccb1e5f96d20 = $29ee4d3171d9809b$export$a0f88e38d4cf9577 ? (u)=>u : $29ee4d3171d9809b$export$97b40fc37f25d711;
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $29ee4d3171d9809b$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $29ee4d3171d9809b$export$58b867e287a802c8(bytes) {
    $29ee4d3171d9809b$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($29ee4d3171d9809b$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $29ee4d3171d9809b$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $29ee4d3171d9809b$var$asciiToBase16(ch) {
    if (ch >= $29ee4d3171d9809b$var$asciis._0 && ch <= $29ee4d3171d9809b$var$asciis._9) return ch - $29ee4d3171d9809b$var$asciis._0; // '2' => 50-48
    if (ch >= $29ee4d3171d9809b$var$asciis.A && ch <= $29ee4d3171d9809b$var$asciis.F) return ch - ($29ee4d3171d9809b$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $29ee4d3171d9809b$var$asciis.a && ch <= $29ee4d3171d9809b$var$asciis.f) return ch - ($29ee4d3171d9809b$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $29ee4d3171d9809b$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($29ee4d3171d9809b$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
const $29ee4d3171d9809b$export$bdd553fddd433dcb = async ()=>{};
async function $29ee4d3171d9809b$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $29ee4d3171d9809b$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $29ee4d3171d9809b$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $29ee4d3171d9809b$export$e01ba4a527b8942d(data, errorTitle = '') {
    if (typeof data === 'string') return $29ee4d3171d9809b$export$3df70a15530b5e81(data);
    return $29ee4d3171d9809b$export$e8a750b9efad93f5(data, undefined, errorTitle);
}
function $29ee4d3171d9809b$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $29ee4d3171d9809b$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $29ee4d3171d9809b$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && ({}).toString.call(opts) !== '[object Object]') throw new Error('options must be object or undefined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $29ee4d3171d9809b$export$14b114effbc08b6b(hashCons, info = {}) {
    const hashC = (msg, opts)=>hashCons(opts).update(msg).digest();
    const tmp = hashCons(undefined);
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    Object.assign(hashC, info);
    return Object.freeze(hashC);
}
function $29ee4d3171d9809b$export$5f828d93ff035aa8(bytesLength = 32) {
    const cr = typeof globalThis === 'object' ? globalThis.crypto : null;
    if (typeof cr?.getRandomValues !== 'function') throw new Error('crypto.getRandomValues must be defined');
    return cr.getRandomValues(new Uint8Array(bytesLength));
}
const $29ee4d3171d9809b$export$6befe166550a2fc1 = (suffix)=>({
        oid: Uint8Array.from([
            0x06,
            0x09,
            0x60,
            0x86,
            0x48,
            0x01,
            0x65,
            0x03,
            0x04,
            0x02,
            suffix
        ])
    });

});


parcelRegister("eDgKs", function(module, exports) {

$parcel$export(module.exports, "split", () => $aa71b30d36adb919$export$65980d18b75784e2);
$parcel$export(module.exports, "shrSH", () => $aa71b30d36adb919$export$75aa78dc5bd52853);
$parcel$export(module.exports, "shrSL", () => $aa71b30d36adb919$export$a0225ff0aee14e25);
$parcel$export(module.exports, "rotrSH", () => $aa71b30d36adb919$export$97f812dfd830ca87);
$parcel$export(module.exports, "rotrSL", () => $aa71b30d36adb919$export$60987e30e2c9d9d);
$parcel$export(module.exports, "rotrBH", () => $aa71b30d36adb919$export$af9c7fbac44dcb76);
$parcel$export(module.exports, "rotrBL", () => $aa71b30d36adb919$export$f619171d6d5ac414);
$parcel$export(module.exports, "add", () => $aa71b30d36adb919$export$e16d8520af44a096);
$parcel$export(module.exports, "add3L", () => $aa71b30d36adb919$export$c0c22b91f08911f);
$parcel$export(module.exports, "add3H", () => $aa71b30d36adb919$export$ef7b26044977a8ec);
$parcel$export(module.exports, "add4L", () => $aa71b30d36adb919$export$2f4e199c560f545d);
$parcel$export(module.exports, "add4H", () => $aa71b30d36adb919$export$e909220d675a7741);
$parcel$export(module.exports, "add5L", () => $aa71b30d36adb919$export$d732b061fe9c9ae4);
$parcel$export(module.exports, "add5H", () => $aa71b30d36adb919$export$b45ee8d78c965098);
/**
 * Internal helpers for u64. BigUint64Array is too slow as per 2025, so we implement it using Uint32Array.
 * @todo re-check https://issues.chromium.org/issues/42212588
 * @module
 */ const $aa71b30d36adb919$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = /* @__PURE__ */ BigInt(32);
function $aa71b30d36adb919$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
function $aa71b30d36adb919$export$65980d18b75784e2(lst, le = false) {
    const len = lst.length;
    let Ah = new Uint32Array(len);
    let Al = new Uint32Array(len);
    for(let i = 0; i < len; i++){
        const { h: h, l: l } = $aa71b30d36adb919$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $aa71b30d36adb919$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $aa71b30d36adb919$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $aa71b30d36adb919$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $aa71b30d36adb919$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $aa71b30d36adb919$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$export$a088d44bd387d2a3 = (_h, l)=>l;
const $aa71b30d36adb919$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $aa71b30d36adb919$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $aa71b30d36adb919$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aa71b30d36adb919$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $aa71b30d36adb919$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $aa71b30d36adb919$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $aa71b30d36adb919$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $aa71b30d36adb919$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $aa71b30d36adb919$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $aa71b30d36adb919$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$export$9625d4333cb56c3f,
    split: $aa71b30d36adb919$export$65980d18b75784e2,
    toBig: $aa71b30d36adb919$export$30f78adcaaa2eb7,
    shrSH: $aa71b30d36adb919$export$75aa78dc5bd52853,
    shrSL: $aa71b30d36adb919$export$a0225ff0aee14e25,
    rotrSH: $aa71b30d36adb919$export$97f812dfd830ca87,
    rotrSL: $aa71b30d36adb919$export$60987e30e2c9d9d,
    rotrBH: $aa71b30d36adb919$export$af9c7fbac44dcb76,
    rotrBL: $aa71b30d36adb919$export$f619171d6d5ac414,
    rotr32H: $aa71b30d36adb919$export$a088d44bd387d2a3,
    rotr32L: $aa71b30d36adb919$export$8415aae4d1f69577,
    rotlSH: $aa71b30d36adb919$export$4b80a2917447870e,
    rotlSL: $aa71b30d36adb919$export$20652918a7b63b3,
    rotlBH: $aa71b30d36adb919$export$a52f14bf902f9977,
    rotlBL: $aa71b30d36adb919$export$5d12cc1da441323f,
    add: $aa71b30d36adb919$export$e16d8520af44a096,
    add3L: $aa71b30d36adb919$export$c0c22b91f08911f,
    add3H: $aa71b30d36adb919$export$ef7b26044977a8ec,
    add4L: $aa71b30d36adb919$export$2f4e199c560f545d,
    add4H: $aa71b30d36adb919$export$e909220d675a7741,
    add5H: $aa71b30d36adb919$export$b45ee8d78c965098,
    add5L: $aa71b30d36adb919$export$d732b061fe9c9ae4
};
var $aa71b30d36adb919$export$2e2bcd8739ae039 = $aa71b30d36adb919$var$u64;

});


parcelRegister("lkFCe", function(module, exports) {

$parcel$export(module.exports, "negateCt", () => $f87bbf3c04a0ea6d$export$c6bd445aafe431ea);
$parcel$export(module.exports, "normalizeZ", () => $f87bbf3c04a0ea6d$export$bc27bc65d7bff1c7);
$parcel$export(module.exports, "wNAF", () => $f87bbf3c04a0ea6d$export$1c8afd86ce547420);
$parcel$export(module.exports, "mulEndoUnsafe", () => $f87bbf3c04a0ea6d$export$4e37e5581461a31);
$parcel$export(module.exports, "createCurveFields", () => $f87bbf3c04a0ea6d$export$1fe76009d71a4957);
$parcel$export(module.exports, "createKeygen", () => $f87bbf3c04a0ea6d$export$f3f81ccca4e43a9b);
/**
 * Methods for elliptic curve multiplication by scalars.
 * Contains wNAF, pippenger.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $f2mJU = parcelRequire("f2mJU");

var $2D9sF = parcelRequire("2D9sF");
const $f87bbf3c04a0ea6d$var$_0n = /* @__PURE__ */ BigInt(0);
const $f87bbf3c04a0ea6d$var$_1n = /* @__PURE__ */ BigInt(1);
function $f87bbf3c04a0ea6d$export$c6bd445aafe431ea(condition, item) {
    const neg = item.negate();
    return condition ? neg : item;
}
function $f87bbf3c04a0ea6d$export$bc27bc65d7bff1c7(c, points) {
    const invertedZs = (0, $2D9sF.FpInvertBatch)(c.Fp, points.map((p)=>p.Z));
    return points.map((p, i)=>c.fromAffine(p.toAffine(invertedZs[i])));
}
function $f87bbf3c04a0ea6d$var$validateW(W, bits) {
    if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error('invalid window size, expected [1..' + bits + '], got W=' + W);
}
function $f87bbf3c04a0ea6d$var$calcWOpts(W, scalarBits) {
    $f87bbf3c04a0ea6d$var$validateW(W, scalarBits);
    const windows = Math.ceil(scalarBits / W) + 1; // W=8 33. Not 32, because we skip zero
    const windowSize = 2 ** (W - 1); // W=8 128. Not 256, because we skip zero
    const maxNumber = 2 ** W; // W=8 256
    const mask = (0, $f2mJU.bitMask)(W); // W=8 255 == mask 0b11111111
    const shiftBy = BigInt(W); // W=8 8
    return {
        windows: windows,
        windowSize: windowSize,
        mask: mask,
        maxNumber: maxNumber,
        shiftBy: shiftBy
    };
}
function $f87bbf3c04a0ea6d$var$calcOffsets(n, window, wOpts) {
    const { windowSize: windowSize, mask: mask, maxNumber: maxNumber, shiftBy: shiftBy } = wOpts;
    let wbits = Number(n & mask); // extract W bits.
    let nextN = n >> shiftBy; // shift number by W bits.
    // What actually happens here:
    // const highestBit = Number(mask ^ (mask >> 1n));
    // let wbits2 = wbits - 1; // skip zero
    // if (wbits2 & highestBit) { wbits2 ^= Number(mask); // (~);
    // split if bits > max: +224 => 256-32
    if (wbits > windowSize) {
        // we skip zero, which means instead of `>= size-1`, we do `> size`
        wbits -= maxNumber; // -32, can be maxNumber - wbits, but then we need to set isNeg here.
        nextN += $f87bbf3c04a0ea6d$var$_1n; // +256 (carry)
    }
    const offsetStart = window * windowSize;
    const offset = offsetStart + Math.abs(wbits) - 1; // -1 because we skip zero
    const isZero = wbits === 0; // is current window slice a 0?
    const isNeg = wbits < 0; // is current window slice negative?
    const isNegF = window % 2 !== 0; // fake random statement for noise
    const offsetF = offsetStart; // fake offset for noise
    return {
        nextN: nextN,
        offset: offset,
        isZero: isZero,
        isNeg: isNeg,
        isNegF: isNegF,
        offsetF: offsetF
    };
}
function $f87bbf3c04a0ea6d$var$validateMSMPoints(points, c) {
    if (!Array.isArray(points)) throw new Error('array expected');
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error('invalid point at index ' + i);
    });
}
function $f87bbf3c04a0ea6d$var$validateMSMScalars(scalars, field) {
    if (!Array.isArray(scalars)) throw new Error('array of scalars expected');
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error('invalid scalar at index ' + i);
    });
}
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes.
// Allows to make points frozen / immutable.
const $f87bbf3c04a0ea6d$var$pointPrecomputes = new WeakMap();
const $f87bbf3c04a0ea6d$var$pointWindowSizes = new WeakMap();
function $f87bbf3c04a0ea6d$var$getW(P) {
    // To disable precomputes:
    // return 1;
    return $f87bbf3c04a0ea6d$var$pointWindowSizes.get(P) || 1;
}
function $f87bbf3c04a0ea6d$var$assert0(n) {
    if (n !== $f87bbf3c04a0ea6d$var$_0n) throw new Error('invalid wNAF');
}
class $f87bbf3c04a0ea6d$export$1c8afd86ce547420 {
    BASE;
    ZERO;
    Fn;
    bits;
    // Parametrized with a given Point class (not individual point)
    constructor(Point, bits){
        this.BASE = Point.BASE;
        this.ZERO = Point.ZERO;
        this.Fn = Point.Fn;
        this.bits = bits;
    }
    // non-const time multiplication ladder
    _unsafeLadder(elm, n, p = this.ZERO) {
        let d = elm;
        while(n > $f87bbf3c04a0ea6d$var$_0n){
            if (n & $f87bbf3c04a0ea6d$var$_1n) p = p.add(d);
            d = d.double();
            n >>= $f87bbf3c04a0ea6d$var$_1n;
        }
        return p;
    }
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param point Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */ precomputeWindow(point, W) {
        const { windows: windows, windowSize: windowSize } = $f87bbf3c04a0ea6d$var$calcWOpts(W, this.bits);
        const points = [];
        let p = point;
        let base = p;
        for(let window = 0; window < windows; window++){
            base = p;
            points.push(base);
            // i=1, bc we skip 0
            for(let i = 1; i < windowSize; i++){
                base = base.add(p);
                points.push(base);
            }
            p = base.double();
        }
        return points;
    }
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * More compact implementation:
     * https://github.com/paulmillr/noble-secp256k1/blob/47cb1669b6e506ad66b35fe7d76132ae97465da2/index.ts#L502-L541
     * @returns real and fake (for const-time) points
     */ wNAF(W, precomputes, n) {
        // Scalar should be smaller than field order
        if (!this.Fn.isValid(n)) throw new Error('invalid scalar');
        // Accumulators
        let p = this.ZERO;
        let f = this.BASE;
        // This code was first written with assumption that 'f' and 'p' will never be infinity point:
        // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
        // there is negate now: it is possible that negated element from low value
        // would be the same as high element, which will create carry into next window.
        // It's not obvious how this can fail, but still worth investigating later.
        const wo = $f87bbf3c04a0ea6d$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            // (n === _0n) is handled and not early-exited. isEven and offsetF are used for noise
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg, isNegF: isNegF, offsetF: offsetF } = $f87bbf3c04a0ea6d$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) // bits are 0: add garbage to fake point
            // Important part for const-time getPublicKey: add random "noise" point to f.
            f = f.add($f87bbf3c04a0ea6d$export$c6bd445aafe431ea(isNegF, precomputes[offsetF]));
            else // bits are 1: add to result point
            p = p.add($f87bbf3c04a0ea6d$export$c6bd445aafe431ea(isNeg, precomputes[offset]));
        }
        $f87bbf3c04a0ea6d$var$assert0(n);
        // Return both real and fake points: JIT won't eliminate f.
        // At this point there is a way to F be infinity-point even if p is not,
        // which makes it less const-time: around 1 bigint multiply.
        return {
            p: p,
            f: f
        };
    }
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */ wNAFUnsafe(W, precomputes, n, acc = this.ZERO) {
        const wo = $f87bbf3c04a0ea6d$var$calcWOpts(W, this.bits);
        for(let window = 0; window < wo.windows; window++){
            if (n === $f87bbf3c04a0ea6d$var$_0n) break; // Early-exit, skip 0 value
            const { nextN: nextN, offset: offset, isZero: isZero, isNeg: isNeg } = $f87bbf3c04a0ea6d$var$calcOffsets(n, window, wo);
            n = nextN;
            if (isZero) continue;
            else {
                const item = precomputes[offset];
                acc = acc.add(isNeg ? item.negate() : item); // Re-using acc allows to save adds in MSM
            }
        }
        $f87bbf3c04a0ea6d$var$assert0(n);
        return acc;
    }
    getPrecomputes(W, point, transform) {
        // Calculate precomputes on a first run, reuse them after
        let comp = $f87bbf3c04a0ea6d$var$pointPrecomputes.get(point);
        if (!comp) {
            comp = this.precomputeWindow(point, W);
            if (W !== 1) {
                // Doing transform outside of if brings 15% perf hit
                if (typeof transform === 'function') comp = transform(comp);
                $f87bbf3c04a0ea6d$var$pointPrecomputes.set(point, comp);
            }
        }
        return comp;
    }
    cached(point, scalar, transform) {
        const W = $f87bbf3c04a0ea6d$var$getW(point);
        return this.wNAF(W, this.getPrecomputes(W, point, transform), scalar);
    }
    unsafe(point, scalar, transform, prev) {
        const W = $f87bbf3c04a0ea6d$var$getW(point);
        if (W === 1) return this._unsafeLadder(point, scalar, prev); // For W=1 ladder is ~x2 faster
        return this.wNAFUnsafe(W, this.getPrecomputes(W, point, transform), scalar, prev);
    }
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    createCache(P, W) {
        $f87bbf3c04a0ea6d$var$validateW(W, this.bits);
        $f87bbf3c04a0ea6d$var$pointWindowSizes.set(P, W);
        $f87bbf3c04a0ea6d$var$pointPrecomputes.delete(P);
    }
    hasCache(elm) {
        return $f87bbf3c04a0ea6d$var$getW(elm) !== 1;
    }
}
function $f87bbf3c04a0ea6d$export$4e37e5581461a31(Point, point, k1, k2) {
    let acc = point;
    let p1 = Point.ZERO;
    let p2 = Point.ZERO;
    while(k1 > $f87bbf3c04a0ea6d$var$_0n || k2 > $f87bbf3c04a0ea6d$var$_0n){
        if (k1 & $f87bbf3c04a0ea6d$var$_1n) p1 = p1.add(acc);
        if (k2 & $f87bbf3c04a0ea6d$var$_1n) p2 = p2.add(acc);
        acc = acc.double();
        k1 >>= $f87bbf3c04a0ea6d$var$_1n;
        k2 >>= $f87bbf3c04a0ea6d$var$_1n;
    }
    return {
        p1: p1,
        p2: p2
    };
}
function $f87bbf3c04a0ea6d$export$8e2f6717424463a3(c, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    const fieldN = c.Fn;
    $f87bbf3c04a0ea6d$var$validateMSMPoints(points, c);
    $f87bbf3c04a0ea6d$var$validateMSMScalars(scalars, fieldN);
    const plength = points.length;
    const slength = scalars.length;
    if (plength !== slength) throw new Error('arrays of points and scalars must have equal length');
    // if (plength === 0) throw new Error('array must be of length >= 2');
    const zero = c.ZERO;
    const wbits = (0, $f2mJU.bitLen)(BigInt(plength));
    let windowSize = 1; // bits
    if (wbits > 12) windowSize = wbits - 3;
    else if (wbits > 4) windowSize = wbits - 2;
    else if (wbits > 0) windowSize = 2;
    const MASK = (0, $f2mJU.bitMask)(windowSize);
    const buckets = new Array(Number(MASK) + 1).fill(zero); // +1 for zero array
    const lastBits = Math.floor((fieldN.BITS - 1) / windowSize) * windowSize;
    let sum = zero;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(zero);
        for(let j = 0; j < slength; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & MASK);
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = zero; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = zero; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
function $f87bbf3c04a0ea6d$export$c33f75a98e3bde1d(c, points, windowSize) {
    /**
     * Performance Analysis of Window-based Precomputation
     *
     * Base Case (256-bit scalar, 8-bit window):
     * - Standard precomputation requires:
     *   - 31 additions per scalar × 256 scalars = 7,936 ops
     *   - Plus 255 summary additions = 8,191 total ops
     *   Note: Summary additions can be optimized via accumulator
     *
     * Chunked Precomputation Analysis:
     * - Using 32 chunks requires:
     *   - 255 additions per chunk
     *   - 256 doublings
     *   - Total: (255 × 32) + 256 = 8,416 ops
     *
     * Memory Usage Comparison:
     * Window Size | Standard Points | Chunked Points
     * ------------|-----------------|---------------
     *     4-bit   |     520         |      15
     *     8-bit   |    4,224        |     255
     *    10-bit   |   13,824        |   1,023
     *    16-bit   |  557,056        |  65,535
     *
     * Key Advantages:
     * 1. Enables larger window sizes due to reduced memory overhead
     * 2. More efficient for smaller scalar counts:
     *    - 16 chunks: (16 × 255) + 256 = 4,336 ops
     *    - ~2x faster than standard 8,191 ops
     *
     * Limitations:
     * - Not suitable for plain precomputes (requires 256 constant doublings)
     * - Performance degrades with larger scalar counts:
     *   - Optimal for ~256 scalars
     *   - Less efficient for 4096+ scalars (Pippenger preferred)
     */ const fieldN = c.Fn;
    $f87bbf3c04a0ea6d$var$validateW(windowSize, fieldN.BITS);
    $f87bbf3c04a0ea6d$var$validateMSMPoints(points, c);
    const zero = c.ZERO;
    const tableSize = 2 ** windowSize - 1; // table size (without zero)
    const chunks = Math.ceil(fieldN.BITS / windowSize); // chunks of item
    const MASK = (0, $f2mJU.bitMask)(windowSize);
    const tables = points.map((p)=>{
        const res = [];
        for(let i = 0, acc = p; i < tableSize; i++){
            res.push(acc);
            acc = acc.add(p);
        }
        return res;
    });
    return (scalars)=>{
        $f87bbf3c04a0ea6d$var$validateMSMScalars(scalars, fieldN);
        if (scalars.length > points.length) throw new Error('array of scalars must be smaller than array of points');
        let res = zero;
        for(let i = 0; i < chunks; i++){
            // No need to double if accumulator is still zero.
            if (res !== zero) for(let j = 0; j < windowSize; j++)res = res.double();
            const shiftBy = BigInt(chunks * windowSize - (i + 1) * windowSize);
            for(let j = 0; j < scalars.length; j++){
                const n = scalars[j];
                const curr = Number(n >> shiftBy & MASK);
                if (!curr) continue; // skip zero scalars chunks
                res = res.add(tables[j][curr - 1]);
            }
        }
        return res;
    };
}
function $f87bbf3c04a0ea6d$var$createField(order, field, isLE) {
    if (field) {
        if (field.ORDER !== order) throw new Error('Field.ORDER must match order: Fp == p, Fn == n');
        (0, $2D9sF.validateField)(field);
        return field;
    } else return (0, $2D9sF.Field)(order, {
        isLE: isLE
    });
}
function $f87bbf3c04a0ea6d$export$1fe76009d71a4957(type, CURVE, curveOpts = {}, FpFnLE) {
    if (FpFnLE === undefined) FpFnLE = type === 'edwards';
    if (!CURVE || typeof CURVE !== 'object') throw new Error(`expected valid ${type} CURVE object`);
    for (const p of [
        'p',
        'n',
        'h'
    ]){
        const val = CURVE[p];
        if (!(typeof val === 'bigint' && val > $f87bbf3c04a0ea6d$var$_0n)) throw new Error(`CURVE.${p} must be positive bigint`);
    }
    const Fp = $f87bbf3c04a0ea6d$var$createField(CURVE.p, curveOpts.Fp, FpFnLE);
    const Fn = $f87bbf3c04a0ea6d$var$createField(CURVE.n, curveOpts.Fn, FpFnLE);
    const _b = type === 'weierstrass' ? 'b' : 'd';
    const params = [
        'Gx',
        'Gy',
        'a',
        _b
    ];
    for (const p of params){
        // @ts-ignore
        if (!Fp.isValid(CURVE[p])) throw new Error(`CURVE.${p} must be valid field element of CURVE.Fp`);
    }
    CURVE = Object.freeze(Object.assign({}, CURVE));
    return {
        CURVE: CURVE,
        Fp: Fp,
        Fn: Fn
    };
}
function $f87bbf3c04a0ea6d$export$f3f81ccca4e43a9b(randomSecretKey, getPublicKey) {
    return function keygen(seed) {
        const secretKey = randomSecretKey(seed);
        return {
            secretKey: secretKey,
            publicKey: getPublicKey(secretKey)
        };
    };
}

});
parcelRegister("f2mJU", function(module, exports) {

$parcel$export(module.exports, "abool", () => $af28ae8020b219da$export$809304d28d77d92d);
$parcel$export(module.exports, "asafenumber", () => $af28ae8020b219da$export$4f3315d97e288446);
$parcel$export(module.exports, "numberToHexUnpadded", () => $af28ae8020b219da$export$4ed2545b622827c1);
$parcel$export(module.exports, "bytesToNumberBE", () => $af28ae8020b219da$export$d609354794974f8);
$parcel$export(module.exports, "bytesToNumberLE", () => $af28ae8020b219da$export$d67b1d03392107e7);
$parcel$export(module.exports, "numberToBytesBE", () => $af28ae8020b219da$export$1459dafd057611cb);
$parcel$export(module.exports, "numberToBytesLE", () => $af28ae8020b219da$export$ba2172e58d139f6d);
$parcel$export(module.exports, "asciiToBytes", () => $af28ae8020b219da$export$e151636497a65339);
$parcel$export(module.exports, "aInRange", () => $af28ae8020b219da$export$86cc12b5dde3c1e4);
$parcel$export(module.exports, "bitLen", () => $af28ae8020b219da$export$e93ef600c41761a9);
$parcel$export(module.exports, "bitMask", () => $af28ae8020b219da$export$803efa2fa1c7279);
$parcel$export(module.exports, "createHmacDrbg", () => $af28ae8020b219da$export$d459d139192e4fba);
$parcel$export(module.exports, "validateObject", () => $af28ae8020b219da$export$381bae2d0f08004f);
$parcel$export(module.exports, "memoized", () => $af28ae8020b219da$export$9756366f7cb6f62b);
$parcel$export(module.exports, "abytes", () => (parcelRequire("3Bcdj")).abytes);
$parcel$export(module.exports, "anumber", () => (parcelRequire("3Bcdj")).anumber);
$parcel$export(module.exports, "bytesToHex", () => (parcelRequire("3Bcdj")).bytesToHex);
$parcel$export(module.exports, "concatBytes", () => (parcelRequire("3Bcdj")).concatBytes);
$parcel$export(module.exports, "hexToBytes", () => (parcelRequire("3Bcdj")).hexToBytes);
/**
 * Hex, bytes and number utilities.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $3Bcdj = parcelRequire("3Bcdj");
const $af28ae8020b219da$var$_0n = /* @__PURE__ */ BigInt(0);
const $af28ae8020b219da$var$_1n = /* @__PURE__ */ BigInt(1);
function $af28ae8020b219da$export$809304d28d77d92d(value, title = '') {
    if (typeof value !== 'boolean') {
        const prefix = title && `"${title}" `;
        throw new Error(prefix + 'expected boolean, got type=' + typeof value);
    }
    return value;
}
// Used in weierstrass, der
function $af28ae8020b219da$var$abignumber(n) {
    if (typeof n === 'bigint') {
        if (!$af28ae8020b219da$var$isPosBig(n)) throw new Error('positive bigint expected, got ' + n);
    } else (0, $3Bcdj.anumber)(n);
    return n;
}
function $af28ae8020b219da$export$4f3315d97e288446(value, title = '') {
    if (!Number.isSafeInteger(value)) {
        const prefix = title && `"${title}" `;
        throw new Error(prefix + 'expected safe integer, got type=' + typeof value);
    }
}
function $af28ae8020b219da$export$4ed2545b622827c1(num) {
    const hex = $af28ae8020b219da$var$abignumber(num).toString(16);
    return hex.length & 1 ? '0' + hex : hex;
}
function $af28ae8020b219da$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return hex === '' ? $af28ae8020b219da$var$_0n : BigInt('0x' + hex); // Big Endian
}
function $af28ae8020b219da$export$d609354794974f8(bytes) {
    return $af28ae8020b219da$export$d57f2bacc26b4249((0, $3Bcdj.bytesToHex)(bytes));
}
function $af28ae8020b219da$export$d67b1d03392107e7(bytes) {
    return $af28ae8020b219da$export$d57f2bacc26b4249((0, $3Bcdj.bytesToHex)($af28ae8020b219da$export$56728fb2d7dba34e((0, $3Bcdj.abytes)(bytes)).reverse()));
}
function $af28ae8020b219da$export$1459dafd057611cb(n, len) {
    (0, $3Bcdj.anumber)(len);
    n = $af28ae8020b219da$var$abignumber(n);
    const res = (0, $3Bcdj.hexToBytes)(n.toString(16).padStart(len * 2, '0'));
    if (res.length !== len) throw new Error('number too large');
    return res;
}
function $af28ae8020b219da$export$ba2172e58d139f6d(n, len) {
    return $af28ae8020b219da$export$1459dafd057611cb(n, len).reverse();
}
function $af28ae8020b219da$export$80ee8c1914de6dde(n) {
    return (0, $3Bcdj.hexToBytes)($af28ae8020b219da$export$4ed2545b622827c1($af28ae8020b219da$var$abignumber(n)));
}
function $af28ae8020b219da$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $af28ae8020b219da$export$56728fb2d7dba34e(bytes) {
    return Uint8Array.from(bytes);
}
function $af28ae8020b219da$export$e151636497a65339(ascii) {
    return Uint8Array.from(ascii, (c, i)=>{
        const charCode = c.charCodeAt(0);
        if (c.length !== 1 || charCode > 127) throw new Error(`string contains non-ASCII character "${ascii[i]}" with code ${charCode} at position ${i}`);
        return charCode;
    });
}
// Is positive bigint
const $af28ae8020b219da$var$isPosBig = (n)=>typeof n === 'bigint' && $af28ae8020b219da$var$_0n <= n;
function $af28ae8020b219da$export$ddf89a9c5af38f94(n, min, max) {
    return $af28ae8020b219da$var$isPosBig(n) && $af28ae8020b219da$var$isPosBig(min) && $af28ae8020b219da$var$isPosBig(max) && min <= n && n < max;
}
function $af28ae8020b219da$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$af28ae8020b219da$export$ddf89a9c5af38f94(n, min, max)) throw new Error('expected valid ' + title + ': ' + min + ' <= n < ' + max + ', got ' + n);
}
function $af28ae8020b219da$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $af28ae8020b219da$var$_0n; n >>= $af28ae8020b219da$var$_1n, len += 1);
    return len;
}
function $af28ae8020b219da$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $af28ae8020b219da$var$_1n;
}
function $af28ae8020b219da$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $af28ae8020b219da$var$_1n : $af28ae8020b219da$var$_0n) << BigInt(pos);
}
const $af28ae8020b219da$export$803efa2fa1c7279 = (n)=>($af28ae8020b219da$var$_1n << BigInt(n)) - $af28ae8020b219da$var$_1n;
function $af28ae8020b219da$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    (0, $3Bcdj.anumber)(hashLen, 'hashLen');
    (0, $3Bcdj.anumber)(qByteLen, 'qByteLen');
    if (typeof hmacFn !== 'function') throw new Error('hmacFn must be a function');
    const u8n = (len)=>new Uint8Array(len); // creates Uint8Array
    const NULL = Uint8Array.of();
    const byte0 = Uint8Array.of(0x00);
    const byte1 = Uint8Array.of(0x01);
    const _maxDrbgIters = 1000;
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...msgs)=>hmacFn(k, (0, $3Bcdj.concatBytes)(v, ...msgs)); // hmac(k)(v, ...values)
    const reseed = (seed = NULL)=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h(byte0, seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h(byte1, seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= _maxDrbgIters) throw new Error('drbg: tried max amount of iterations');
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return (0, $3Bcdj.concatBytes)(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
function $af28ae8020b219da$export$381bae2d0f08004f(object, fields = {}, optFields = {}) {
    if (!object || typeof object !== 'object') throw new Error('expected valid options object');
    function checkField(fieldName, expectedType, isOpt) {
        const val = object[fieldName];
        if (isOpt && val === undefined) return;
        const current = typeof val;
        if (current !== expectedType || val === null) throw new Error(`param "${fieldName}" is invalid: expected ${expectedType}, got ${current}`);
    }
    const iter = (f, isOpt)=>Object.entries(f).forEach(([k, v])=>checkField(k, v, isOpt));
    iter(fields, false);
    iter(optFields, true);
}
const $af28ae8020b219da$export$94a5f06e658f87e2 = ()=>{
    throw new Error('not implemented');
};
function $af28ae8020b219da$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});

parcelRegister("2D9sF", function(module, exports) {

$parcel$export(module.exports, "mod", () => $1ea6901afdde618b$export$842a2cf37af977e1);
$parcel$export(module.exports, "Field", () => $1ea6901afdde618b$export$a455218a85c89869);
$parcel$export(module.exports, "pow2", () => $1ea6901afdde618b$export$fa569bd808b67eef);
$parcel$export(module.exports, "validateField", () => $1ea6901afdde618b$export$bd454f0cef11418d);
$parcel$export(module.exports, "FpInvertBatch", () => $1ea6901afdde618b$export$a492e3387142c0e9);
$parcel$export(module.exports, "getMinHashLength", () => $1ea6901afdde618b$export$d058763b563056af);
$parcel$export(module.exports, "mapHashToField", () => $1ea6901afdde618b$export$20cb21dbfa61dac3);
/**
 * Utils for modular division and fields.
 * Field over 11 is a finite (Galois) field is integer number operations `mod 11`.
 * There is no division: it is replaced by modular multiplicative inverse.
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ parcelRequire("f2mJU");
var $3Bcdj = parcelRequire("3Bcdj");
var $f2mJU = parcelRequire("f2mJU");
// Numbers aren't used in x25519 / x448 builds
// prettier-ignore
const $1ea6901afdde618b$var$_0n = /* @__PURE__ */ BigInt(0), $1ea6901afdde618b$var$_1n = /* @__PURE__ */ BigInt(1), $1ea6901afdde618b$var$_2n = /* @__PURE__ */ BigInt(2);
// prettier-ignore
const $1ea6901afdde618b$var$_3n = /* @__PURE__ */ BigInt(3), $1ea6901afdde618b$var$_4n = /* @__PURE__ */ BigInt(4), $1ea6901afdde618b$var$_5n = /* @__PURE__ */ BigInt(5);
// prettier-ignore
const $1ea6901afdde618b$var$_7n = /* @__PURE__ */ BigInt(7), $1ea6901afdde618b$var$_8n = /* @__PURE__ */ BigInt(8), $1ea6901afdde618b$var$_9n = /* @__PURE__ */ BigInt(9);
const $1ea6901afdde618b$var$_16n = /* @__PURE__ */ BigInt(16);
function $1ea6901afdde618b$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $1ea6901afdde618b$var$_0n ? result : b + result;
}
function $1ea6901afdde618b$export$9c297f60e22e3389(num, power, modulo) {
    return $1ea6901afdde618b$export$5d8ce3717733a987($1ea6901afdde618b$export$a455218a85c89869(modulo), num, power);
}
function $1ea6901afdde618b$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $1ea6901afdde618b$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $1ea6901afdde618b$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $1ea6901afdde618b$var$_0n) throw new Error('invert: expected non-zero number');
    if (modulo <= $1ea6901afdde618b$var$_0n) throw new Error('invert: expected positive modulus, got ' + modulo);
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $1ea6901afdde618b$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $1ea6901afdde618b$var$_0n, y = $1ea6901afdde618b$var$_1n, u = $1ea6901afdde618b$var$_1n, v = $1ea6901afdde618b$var$_0n;
    while(a !== $1ea6901afdde618b$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $1ea6901afdde618b$var$_1n) throw new Error('invert: does not exist');
    return $1ea6901afdde618b$export$842a2cf37af977e1(x, modulo);
}
function $1ea6901afdde618b$var$assertIsSquare(Fp, root, n) {
    if (!Fp.eql(Fp.sqr(root), n)) throw new Error('Cannot find square root');
}
// Not all roots are possible! Example which will throw:
// const NUM =
// n = 72057594037927816n;
// Fp = Field(BigInt('0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaab'));
function $1ea6901afdde618b$var$sqrt3mod4(Fp, n) {
    const p1div4 = (Fp.ORDER + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
    const root = Fp.pow(n, p1div4);
    $1ea6901afdde618b$var$assertIsSquare(Fp, root, n);
    return root;
}
function $1ea6901afdde618b$var$sqrt5mod8(Fp, n) {
    const p5div8 = (Fp.ORDER - $1ea6901afdde618b$var$_5n) / $1ea6901afdde618b$var$_8n;
    const n2 = Fp.mul(n, $1ea6901afdde618b$var$_2n);
    const v = Fp.pow(n2, p5div8);
    const nv = Fp.mul(n, v);
    const i = Fp.mul(Fp.mul(nv, $1ea6901afdde618b$var$_2n), v);
    const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
    $1ea6901afdde618b$var$assertIsSquare(Fp, root, n);
    return root;
}
// Based on RFC9380, Kong algorithm
// prettier-ignore
function $1ea6901afdde618b$var$sqrt9mod16(P) {
    const Fp_ = $1ea6901afdde618b$export$a455218a85c89869(P);
    const tn = $1ea6901afdde618b$export$69f29ab1f3e9a234(P);
    const c1 = tn(Fp_, Fp_.neg(Fp_.ONE)); //  1. c1 = sqrt(-1) in F, i.e., (c1^2) == -1 in F
    const c2 = tn(Fp_, c1); //  2. c2 = sqrt(c1) in F, i.e., (c2^2) == c1 in F
    const c3 = tn(Fp_, Fp_.neg(c1)); //  3. c3 = sqrt(-c1) in F, i.e., (c3^2) == -c1 in F
    const c4 = (P + $1ea6901afdde618b$var$_7n) / $1ea6901afdde618b$var$_16n; //  4. c4 = (q + 7) / 16        # Integer arithmetic
    return (Fp, n)=>{
        let tv1 = Fp.pow(n, c4); //  1. tv1 = x^c4
        let tv2 = Fp.mul(tv1, c1); //  2. tv2 = c1 * tv1
        const tv3 = Fp.mul(tv1, c2); //  3. tv3 = c2 * tv1
        const tv4 = Fp.mul(tv1, c3); //  4. tv4 = c3 * tv1
        const e1 = Fp.eql(Fp.sqr(tv2), n); //  5.  e1 = (tv2^2) == x
        const e2 = Fp.eql(Fp.sqr(tv3), n); //  6.  e2 = (tv3^2) == x
        tv1 = Fp.cmov(tv1, tv2, e1); //  7. tv1 = CMOV(tv1, tv2, e1)  # Select tv2 if (tv2^2) == x
        tv2 = Fp.cmov(tv4, tv3, e2); //  8. tv2 = CMOV(tv4, tv3, e2)  # Select tv3 if (tv3^2) == x
        const e3 = Fp.eql(Fp.sqr(tv2), n); //  9.  e3 = (tv2^2) == x
        const root = Fp.cmov(tv1, tv2, e3); // 10.  z = CMOV(tv1, tv2, e3)   # Select sqrt from tv1 & tv2
        $1ea6901afdde618b$var$assertIsSquare(Fp, root, n);
        return root;
    };
}
function $1ea6901afdde618b$export$69f29ab1f3e9a234(P) {
    // Initialization (precomputation).
    // Caching initialization could boost perf by 7%.
    if (P < $1ea6901afdde618b$var$_3n) throw new Error('sqrt is not defined for small field');
    // Factor P - 1 = Q * 2^S, where Q is odd
    let Q = P - $1ea6901afdde618b$var$_1n;
    let S = 0;
    while(Q % $1ea6901afdde618b$var$_2n === $1ea6901afdde618b$var$_0n){
        Q /= $1ea6901afdde618b$var$_2n;
        S++;
    }
    // Find the first quadratic non-residue Z >= 2
    let Z = $1ea6901afdde618b$var$_2n;
    const _Fp = $1ea6901afdde618b$export$a455218a85c89869(P);
    while($1ea6901afdde618b$export$77ed22730026dd0d(_Fp, Z) === 1){
        // Basic primality test for P. After x iterations, chance of
        // not finding quadratic non-residue is 2^x, so 2^1000.
        if (Z++ > 1000) throw new Error('Cannot find square root: probably non-prime P');
    }
    // Fast-path; usually done before Z, but we do "primality test".
    if (S === 1) return $1ea6901afdde618b$var$sqrt3mod4;
    // Slow-path
    // TODO: test on Fp2 and others
    let cc = _Fp.pow(Z, Q); // c = z^Q
    const Q1div2 = (Q + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    return function tonelliSlow(Fp, n) {
        if (Fp.is0(n)) return n;
        // Check if n is a quadratic residue using Legendre symbol
        if ($1ea6901afdde618b$export$77ed22730026dd0d(Fp, n) !== 1) throw new Error('Cannot find square root');
        // Initialize variables for the main loop
        let M = S;
        let c = Fp.mul(Fp.ONE, cc); // c = z^Q, move cc from field _Fp into field Fp
        let t = Fp.pow(n, Q); // t = n^Q, first guess at the fudge factor
        let R = Fp.pow(n, Q1div2); // R = n^((Q+1)/2), first guess at the square root
        // Main loop
        // while t != 1
        while(!Fp.eql(t, Fp.ONE)){
            if (Fp.is0(t)) return Fp.ZERO; // if t=0 return R=0
            let i = 1;
            // Find the smallest i >= 1 such that t^(2^i) ≡ 1 (mod P)
            let t_tmp = Fp.sqr(t); // t^(2^1)
            while(!Fp.eql(t_tmp, Fp.ONE)){
                i++;
                t_tmp = Fp.sqr(t_tmp); // t^(2^2)...
                if (i === M) throw new Error('Cannot find square root');
            }
            // Calculate the exponent for b: 2^(M - i - 1)
            const exponent = $1ea6901afdde618b$var$_1n << BigInt(M - i - 1); // bigint is important
            const b = Fp.pow(c, exponent); // b = 2^(M - i - 1)
            // Update variables
            M = i;
            c = Fp.sqr(b); // c = b^2
            t = Fp.mul(t, c); // t = (t * b^2)
            R = Fp.mul(R, b); // R = R*b
        }
        return R;
    };
}
function $1ea6901afdde618b$export$33bda048c6b8ea7d(P) {
    // P ≡ 3 (mod 4) => √n = n^((P+1)/4)
    if (P % $1ea6901afdde618b$var$_4n === $1ea6901afdde618b$var$_3n) return $1ea6901afdde618b$var$sqrt3mod4;
    // P ≡ 5 (mod 8) => Atkin algorithm, page 10 of https://eprint.iacr.org/2012/685.pdf
    if (P % $1ea6901afdde618b$var$_8n === $1ea6901afdde618b$var$_5n) return $1ea6901afdde618b$var$sqrt5mod8;
    // P ≡ 9 (mod 16) => Kong algorithm, page 11 of https://eprint.iacr.org/2012/685.pdf (algorithm 4)
    if (P % $1ea6901afdde618b$var$_16n === $1ea6901afdde618b$var$_9n) return $1ea6901afdde618b$var$sqrt9mod16(P);
    // Tonelli-Shanks algorithm
    return $1ea6901afdde618b$export$69f29ab1f3e9a234(P);
}
const $1ea6901afdde618b$export$7806f13ad5078b2f = (num, modulo)=>($1ea6901afdde618b$export$842a2cf37af977e1(num, modulo) & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n;
// prettier-ignore
const $1ea6901afdde618b$var$FIELD_FIELDS = [
    'create',
    'isValid',
    'is0',
    'neg',
    'inv',
    'sqrt',
    'sqr',
    'eql',
    'add',
    'sub',
    'mul',
    'pow',
    'div',
    'addN',
    'subN',
    'mulN',
    'sqrN'
];
function $1ea6901afdde618b$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: 'bigint',
        BYTES: 'number',
        BITS: 'number'
    };
    const opts = $1ea6901afdde618b$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = 'function';
        return map;
    }, initial);
    (0, $f2mJU.validateObject)(field, opts);
    // const max = 16384;
    // if (field.BYTES < 1 || field.BYTES > max) throw new Error('invalid field');
    // if (field.BITS < 1 || field.BITS > 8 * max) throw new Error('invalid field');
    return field;
}
function $1ea6901afdde618b$export$5d8ce3717733a987(Fp, num, power) {
    if (power < $1ea6901afdde618b$var$_0n) throw new Error('invalid exponent, negatives unsupported');
    if (power === $1ea6901afdde618b$var$_0n) return Fp.ONE;
    if (power === $1ea6901afdde618b$var$_1n) return num;
    let p = Fp.ONE;
    let d = num;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) p = Fp.mul(p, d);
        d = Fp.sqr(d);
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return p;
}
function $1ea6901afdde618b$export$a492e3387142c0e9(Fp, nums, passZero = false) {
    const inverted = new Array(nums.length).fill(passZero ? Fp.ZERO : undefined);
    // Walk from first to last, multiply them by each other MOD p
    const multipliedAcc = nums.reduce((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = acc;
        return Fp.mul(acc, num);
    }, Fp.ONE);
    // Invert last element
    const invertedAcc = Fp.inv(multipliedAcc);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (Fp.is0(num)) return acc;
        inverted[i] = Fp.mul(acc, inverted[i]);
        return Fp.mul(acc, num);
    }, invertedAcc);
    return inverted;
}
function $1ea6901afdde618b$export$e74c665040343df6(Fp, lhs, rhs) {
    return Fp.mul(lhs, typeof rhs === 'bigint' ? $1ea6901afdde618b$export$6897c284b6f9f4dc(rhs, Fp.ORDER) : Fp.inv(rhs));
}
function $1ea6901afdde618b$export$77ed22730026dd0d(Fp, n) {
    // We can use 3rd argument as optional cache of this value
    // but seems unneeded for now. The operation is very fast.
    const p1mod2 = (Fp.ORDER - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    const powered = Fp.pow(n, p1mod2);
    const yes = Fp.eql(powered, Fp.ONE);
    const zero = Fp.eql(powered, Fp.ZERO);
    const no = Fp.eql(powered, Fp.neg(Fp.ONE));
    if (!yes && !zero && !no) throw new Error('invalid Legendre symbol result');
    return yes ? 1 : zero ? 0 : -1;
}
function $1ea6901afdde618b$export$5e2b6e87f2891ea7(Fp, n) {
    const l = $1ea6901afdde618b$export$77ed22730026dd0d(Fp, n);
    return l === 1;
}
function $1ea6901afdde618b$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    if (nBitLength !== undefined) (0, $3Bcdj.anumber)(nBitLength);
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
class $1ea6901afdde618b$var$_Field {
    ORDER;
    BITS;
    BYTES;
    isLE;
    ZERO = $1ea6901afdde618b$var$_0n;
    ONE = $1ea6901afdde618b$var$_1n;
    _lengths;
    _sqrt;
    _mod;
    constructor(ORDER, opts = {}){
        if (ORDER <= $1ea6901afdde618b$var$_0n) throw new Error('invalid field: expected ORDER > 0, got ' + ORDER);
        let _nbitLength = undefined;
        this.isLE = false;
        if (opts != null && typeof opts === 'object') {
            if (typeof opts.BITS === 'number') _nbitLength = opts.BITS;
            if (typeof opts.sqrt === 'function') this.sqrt = opts.sqrt;
            if (typeof opts.isLE === 'boolean') this.isLE = opts.isLE;
            if (opts.allowedLengths) this._lengths = opts.allowedLengths?.slice();
            if (typeof opts.modFromBytes === 'boolean') this._mod = opts.modFromBytes;
        }
        const { nBitLength: nBitLength, nByteLength: nByteLength } = $1ea6901afdde618b$export$c79df43ecd7e66c2(ORDER, _nbitLength);
        if (nByteLength > 2048) throw new Error('invalid field: expected ORDER of <= 2048 bytes');
        this.ORDER = ORDER;
        this.BITS = nBitLength;
        this.BYTES = nByteLength;
        this._sqrt = undefined;
        Object.preventExtensions(this);
    }
    create(num) {
        return $1ea6901afdde618b$export$842a2cf37af977e1(num, this.ORDER);
    }
    isValid(num) {
        if (typeof num !== 'bigint') throw new Error('invalid field element: expected bigint, got ' + typeof num);
        return $1ea6901afdde618b$var$_0n <= num && num < this.ORDER; // 0 is valid element, but it's not invertible
    }
    is0(num) {
        return num === $1ea6901afdde618b$var$_0n;
    }
    // is valid and invertible
    isValidNot0(num) {
        return !this.is0(num) && this.isValid(num);
    }
    isOdd(num) {
        return (num & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n;
    }
    neg(num) {
        return $1ea6901afdde618b$export$842a2cf37af977e1(-num, this.ORDER);
    }
    eql(lhs, rhs) {
        return lhs === rhs;
    }
    sqr(num) {
        return $1ea6901afdde618b$export$842a2cf37af977e1(num * num, this.ORDER);
    }
    add(lhs, rhs) {
        return $1ea6901afdde618b$export$842a2cf37af977e1(lhs + rhs, this.ORDER);
    }
    sub(lhs, rhs) {
        return $1ea6901afdde618b$export$842a2cf37af977e1(lhs - rhs, this.ORDER);
    }
    mul(lhs, rhs) {
        return $1ea6901afdde618b$export$842a2cf37af977e1(lhs * rhs, this.ORDER);
    }
    pow(num, power) {
        return $1ea6901afdde618b$export$5d8ce3717733a987(this, num, power);
    }
    div(lhs, rhs) {
        return $1ea6901afdde618b$export$842a2cf37af977e1(lhs * $1ea6901afdde618b$export$6897c284b6f9f4dc(rhs, this.ORDER), this.ORDER);
    }
    // Same as above, but doesn't normalize
    sqrN(num) {
        return num * num;
    }
    addN(lhs, rhs) {
        return lhs + rhs;
    }
    subN(lhs, rhs) {
        return lhs - rhs;
    }
    mulN(lhs, rhs) {
        return lhs * rhs;
    }
    inv(num) {
        return $1ea6901afdde618b$export$6897c284b6f9f4dc(num, this.ORDER);
    }
    sqrt(num) {
        // Caching _sqrt speeds up sqrt9mod16 by 5x and tonneli-shanks by 10%
        if (!this._sqrt) this._sqrt = $1ea6901afdde618b$export$33bda048c6b8ea7d(this.ORDER);
        return this._sqrt(this, num);
    }
    toBytes(num) {
        return this.isLE ? (0, $f2mJU.numberToBytesLE)(num, this.BYTES) : (0, $f2mJU.numberToBytesBE)(num, this.BYTES);
    }
    fromBytes(bytes, skipValidation = false) {
        (0, $3Bcdj.abytes)(bytes);
        const { _lengths: allowedLengths, BYTES: BYTES, isLE: isLE, ORDER: ORDER, _mod: modFromBytes } = this;
        if (allowedLengths) {
            if (!allowedLengths.includes(bytes.length) || bytes.length > BYTES) throw new Error('Field.fromBytes: expected ' + allowedLengths + ' bytes, got ' + bytes.length);
            const padded = new Uint8Array(BYTES);
            // isLE add 0 to right, !isLE to the left.
            padded.set(bytes, isLE ? 0 : padded.length - bytes.length);
            bytes = padded;
        }
        if (bytes.length !== BYTES) throw new Error('Field.fromBytes: expected ' + BYTES + ' bytes, got ' + bytes.length);
        let scalar = isLE ? (0, $f2mJU.bytesToNumberLE)(bytes) : (0, $f2mJU.bytesToNumberBE)(bytes);
        if (modFromBytes) scalar = $1ea6901afdde618b$export$842a2cf37af977e1(scalar, ORDER);
        if (!skipValidation) {
            if (!this.isValid(scalar)) throw new Error('invalid field element: outside of range 0..ORDER');
        }
        // NOTE: we don't validate scalar here, please use isValid. This done such way because some
        // protocol may allow non-reduced scalar that reduced later or changed some other way.
        return scalar;
    }
    // TODO: we don't need it here, move out to separate fn
    invertBatch(lst) {
        return $1ea6901afdde618b$export$a492e3387142c0e9(this, lst);
    }
    // We can't move this out because Fp6, Fp12 implement it
    // and it's unclear what to return in there.
    cmov(a, b, condition) {
        return condition ? b : a;
    }
}
function $1ea6901afdde618b$export$a455218a85c89869(ORDER, opts = {}) {
    return new $1ea6901afdde618b$var$_Field(ORDER, opts);
}
function $1ea6901afdde618b$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $1ea6901afdde618b$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error("Field doesn't have isOdd");
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $1ea6901afdde618b$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== 'bigint') throw new Error('field order must be bigint');
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $1ea6901afdde618b$export$d058763b563056af(fieldOrder) {
    const length = $1ea6901afdde618b$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $1ea6901afdde618b$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    (0, $3Bcdj.abytes)(key);
    const len = key.length;
    const fieldLen = $1ea6901afdde618b$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $1ea6901afdde618b$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error('expected ' + minLen + '-1024 bytes of input, got ' + len);
    const num = isLE ? (0, $f2mJU.bytesToNumberLE)(key) : (0, $f2mJU.bytesToNumberBE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $1ea6901afdde618b$export$842a2cf37af977e1(num, fieldOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
    return isLE ? (0, $f2mJU.numberToBytesLE)(reduced, fieldLen) : (0, $f2mJU.numberToBytesBE)(reduced, fieldLen);
}

});


parcelRegister("rkPJ6", function(module, exports) {

$parcel$export(module.exports, "isogenyMap", () => $0522aeca5769187c$export$9393380cf1075f28);
$parcel$export(module.exports, "createHasher", () => $0522aeca5769187c$export$14b114effbc08b6b);
parcelRequire("f2mJU");
var $3Bcdj = parcelRequire("3Bcdj");
var $f2mJU = parcelRequire("f2mJU");
var $3Bcdj = parcelRequire("3Bcdj");

var $2D9sF = parcelRequire("2D9sF");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $0522aeca5769187c$var$os2ip = (0, $f2mJU.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $0522aeca5769187c$var$i2osp(value, length) {
    (0, $f2mJU.asafenumber)(value);
    (0, $f2mJU.asafenumber)(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error('invalid I2OSP input: ' + value);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $0522aeca5769187c$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
// User can always use utf8 if they want, by passing Uint8Array.
// If string is passed, we treat it as ASCII: other formats are likely a mistake.
function $0522aeca5769187c$var$normDST(DST) {
    if (!(0, $3Bcdj.isBytes)(DST) && typeof DST !== 'string') throw new Error('DST must be Uint8Array or ascii string');
    return typeof DST === 'string' ? (0, $f2mJU.asciiToBytes)(DST) : DST;
}
function $0522aeca5769187c$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $3Bcdj.abytes)(msg);
    (0, $f2mJU.asafenumber)(lenInBytes);
    DST = $0522aeca5769187c$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $3Bcdj.concatBytes)((0, $f2mJU.asciiToBytes)('H2C-OVERSIZE-DST-'), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error('expand_message_xmd: invalid lenInBytes');
    const DST_prime = (0, $3Bcdj.concatBytes)(DST, $0522aeca5769187c$var$i2osp(DST.length, 1));
    const Z_pad = $0522aeca5769187c$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $0522aeca5769187c$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $3Bcdj.concatBytes)(Z_pad, msg, l_i_b_str, $0522aeca5769187c$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $3Bcdj.concatBytes)(b_0, $0522aeca5769187c$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $0522aeca5769187c$var$strxor(b_0, b[i - 1]),
            $0522aeca5769187c$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $3Bcdj.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $3Bcdj.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $0522aeca5769187c$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $3Bcdj.abytes)(msg);
    (0, $f2mJU.asafenumber)(lenInBytes);
    DST = $0522aeca5769187c$var$normDST(DST);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $f2mJU.asciiToBytes)('H2C-OVERSIZE-DST-')).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error('expand_message_xof: invalid lenInBytes');
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($0522aeca5769187c$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($0522aeca5769187c$var$i2osp(DST.length, 1)).digest();
}
function $0522aeca5769187c$export$97cdd5ee18de8172(msg, count, options) {
    (0, $f2mJU.validateObject)(options, {
        p: 'bigint',
        m: 'number',
        k: 'number',
        hash: 'function'
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: DST } = options;
    (0, $f2mJU.asafenumber)(hash.outputLen, 'valid hash');
    (0, $3Bcdj.abytes)(msg);
    (0, $f2mJU.asafenumber)(count);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === 'xmd') prb = $0522aeca5769187c$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === 'xof') prb = $0522aeca5769187c$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === '_internal_pass') // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $2D9sF.mod)($0522aeca5769187c$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $0522aeca5769187c$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const coeff = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xn, xd, yn, yd] = coeff.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        // 6.6.3
        // Exceptional cases of iso_map are inputs that cause the denominator of
        // either rational function to evaluate to zero; such cases MUST return
        // the identity point on E.
        const [xd_inv, yd_inv] = (0, $2D9sF.FpInvertBatch)(field, [
            xd,
            yd
        ], true);
        x = field.mul(xn, xd_inv); // xNum / xDen
        y = field.mul(y, field.mul(yn, yd_inv)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
const $0522aeca5769187c$export$eaf8c8caa9e37fdf = (0, $f2mJU.asciiToBytes)('HashToScalar-');
function $0522aeca5769187c$export$14b114effbc08b6b(Point, mapToCurve, defaults) {
    if (typeof mapToCurve !== 'function') throw new Error('mapToCurve() must be defined');
    function map(num) {
        return Point.fromAffine(mapToCurve(num));
    }
    function clear(initial) {
        const P = initial.clearCofactor();
        if (P.equals(Point.ZERO)) return Point.ZERO; // zero will throw in assert
        P.assertValidity();
        return P;
    }
    return {
        defaults: Object.freeze(defaults),
        Point: Point,
        hashToCurve (msg, options) {
            const opts = Object.assign({}, defaults, options);
            const u = $0522aeca5769187c$export$97cdd5ee18de8172(msg, 2, opts);
            const u0 = map(u[0]);
            const u1 = map(u[1]);
            return clear(u0.add(u1));
        },
        encodeToCurve (msg, options) {
            const optsDst = defaults.encodeDST ? {
                DST: defaults.encodeDST
            } : {};
            const opts = Object.assign({}, defaults, optsDst, options);
            const u = $0522aeca5769187c$export$97cdd5ee18de8172(msg, 1, opts);
            const u0 = map(u[0]);
            return clear(u0);
        },
        /** See {@link H2CHasher} */ mapToCurve (scalars) {
            // Curves with m=1 accept only single scalar
            if (defaults.m === 1) {
                if (typeof scalars !== 'bigint') throw new Error('expected bigint (m=1)');
                return clear(map([
                    scalars
                ]));
            }
            if (!Array.isArray(scalars)) throw new Error('expected array of bigints');
            for (const i of scalars)if (typeof i !== 'bigint') throw new Error('expected array of bigints');
            return clear(map(scalars));
        },
        // hash_to_scalar can produce 0: https://www.rfc-editor.org/errata/eid8393
        // RFC 9380, draft-irtf-cfrg-bbs-signatures-08
        hashToScalar (msg, options) {
            // @ts-ignore
            const N = Point.Fn.ORDER;
            const opts = Object.assign({}, defaults, {
                p: N,
                m: 1,
                DST: $0522aeca5769187c$export$eaf8c8caa9e37fdf
            }, options);
            return $0522aeca5769187c$export$97cdd5ee18de8172(msg, 1, opts)[0][0];
        }
    };
}

});

parcelRegister("gNPqy", function(module, exports) {

$parcel$export(module.exports, "weierstrass", () => $c3b91d553ab14e64$export$350b8ea6f1c27fae);
$parcel$export(module.exports, "mapToCurveSimpleSWU", () => $c3b91d553ab14e64$export$cc7fea9756a17416);
$parcel$export(module.exports, "ecdsa", () => $c3b91d553ab14e64$export$4812c9a1c4ca02a);
/**
 * Short Weierstrass curve methods. The formula is: y² = x³ + ax + b.
 *
 * ### Design rationale for types
 *
 * * Interaction between classes from different curves should fail:
 *   `k256.Point.BASE.add(p256.Point.BASE)`
 * * For this purpose we want to use `instanceof` operator, which is fast and works during runtime
 * * Different calls of `curve()` would return different classes -
 *   `curve(params) !== curve(params)`: if somebody decided to monkey-patch their curve,
 *   it won't affect others
 *
 * TypeScript can't infer types for classes created inside a function. Classes is one instance
 * of nominative types in TypeScript and interfaces only check for shape, so it's hard to create
 * unique type for every function call.
 *
 * We can use generic types via some param, like curve opts, but that would:
 *     1. Enable interaction between `curve(params)` and `curve(params)` (curves of same params)
 *     which is hard to debug.
 *     2. Params can be generic and we can't enforce them to be constant value:
 *     if somebody creates curve from non-constant params,
 *     it would be allowed to interact with other curves with non-constant params
 *
 * @todo https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-7.html#unique-symbol
 * @module
 */ /*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $70Xw9 = parcelRequire("70Xw9");

var $3Bcdj = parcelRequire("3Bcdj");

var $f2mJU = parcelRequire("f2mJU");
var $3Bcdj = parcelRequire("3Bcdj");
var $3Bcdj = parcelRequire("3Bcdj");

var $lkFCe = parcelRequire("lkFCe");

var $2D9sF = parcelRequire("2D9sF");
// We construct basis in such way that den is always positive and equals n, but num sign depends on basis (not on secret value)
const $c3b91d553ab14e64$var$divNearest = (num, den)=>(num + (num >= 0 ? den : -den) / $c3b91d553ab14e64$var$_2n) / den;
function $c3b91d553ab14e64$export$2e78c1c514ef8576(k, basis, n) {
    // Split scalar into two such that part is ~half bits: `abs(part) < sqrt(N)`
    // Since part can be negative, we need to do this on point.
    // TODO: verifyScalar function which consumes lambda
    const [[a1, b1], [a2, b2]] = basis;
    const c1 = $c3b91d553ab14e64$var$divNearest(b2 * k, n);
    const c2 = $c3b91d553ab14e64$var$divNearest(-b1 * k, n);
    // |k1|/|k2| is < sqrt(N), but can be negative.
    // If we do `k1 mod N`, we'll get big scalar (`> sqrt(N)`): so, we do cheaper negation instead.
    let k1 = k - c1 * a1 - c2 * a2;
    let k2 = -c1 * b1 - c2 * b2;
    const k1neg = k1 < $c3b91d553ab14e64$var$_0n;
    const k2neg = k2 < $c3b91d553ab14e64$var$_0n;
    if (k1neg) k1 = -k1;
    if (k2neg) k2 = -k2;
    // Double check that resulting scalar less than half bits of N: otherwise wNAF will fail.
    // This should only happen on wrong basises. Also, math inside is too complex and I don't trust it.
    const MAX_NUM = (0, $f2mJU.bitMask)(Math.ceil((0, $f2mJU.bitLen)(n) / 2)) + $c3b91d553ab14e64$var$_1n; // Half bits of N
    if (k1 < $c3b91d553ab14e64$var$_0n || k1 >= MAX_NUM || k2 < $c3b91d553ab14e64$var$_0n || k2 >= MAX_NUM) throw new Error('splitScalar (endomorphism): failed, k=' + k);
    return {
        k1neg: k1neg,
        k1: k1,
        k2neg: k2neg,
        k2: k2
    };
}
function $c3b91d553ab14e64$var$validateSigFormat(format) {
    if (![
        'compact',
        'recovered',
        'der'
    ].includes(format)) throw new Error('Signature format must be "compact", "recovered", or "der"');
    return format;
}
function $c3b91d553ab14e64$var$validateSigOpts(opts, def) {
    const optsn = {};
    for (let optName of Object.keys(def))// @ts-ignore
    optsn[optName] = opts[optName] === undefined ? def[optName] : opts[optName];
    (0, $f2mJU.abool)(optsn.lowS, 'lowS');
    (0, $f2mJU.abool)(optsn.prehash, 'prehash');
    if (optsn.format !== undefined) $c3b91d553ab14e64$var$validateSigFormat(optsn.format);
    return optsn;
}
class $c3b91d553ab14e64$export$523a36accd0afb37 extends Error {
    constructor(m = ''){
        super(m);
    }
}
const $c3b91d553ab14e64$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: $c3b91d553ab14e64$export$523a36accd0afb37,
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = $c3b91d553ab14e64$export$56ac33195d7076db;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length & 1) throw new E('tlv.encode: unpadded data');
            const dataLen = data.length / 2;
            const len = (0, $f2mJU.numberToHexUnpadded)(dataLen);
            if (len.length / 2 & 128) throw new E('tlv.encode: long form length too big');
            // length of length with long form flag
            const lenLen = dataLen > 127 ? (0, $f2mJU.numberToHexUnpadded)(len.length / 2 | 128) : '';
            const t = (0, $f2mJU.numberToHexUnpadded)(tag);
            return t + lenLen + len + data;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = $c3b91d553ab14e64$export$56ac33195d7076db;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E('tlv.encode: wrong tag');
            if (data.length < 2 || data[pos++] !== tag) throw new E('tlv.decode: wrong tlv');
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E('tlv.decode(long): indefinite length not supported');
                if (lenLen > 4) throw new E('tlv.decode(long): byte length is too big'); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E('tlv.decode: length bytes not complete');
                if (lengthBytes[0] === 0) throw new E('tlv.decode(long): zero leftmost byte');
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E('tlv.decode(long): not minimal encoding');
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E('tlv.decode: wrong value length');
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = $c3b91d553ab14e64$export$56ac33195d7076db;
            if (num < $c3b91d553ab14e64$var$_0n) throw new E('integer: negative integers are not allowed');
            let hex = (0, $f2mJU.numberToHexUnpadded)(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = '00' + hex;
            if (hex.length & 1) throw new E('unexpected DER parsing assertion: unpadded hex');
            return hex;
        },
        decode (data) {
            const { Err: E } = $c3b91d553ab14e64$export$56ac33195d7076db;
            if (data[0] & 128) throw new E('invalid signature integer: negative');
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E('invalid signature integer: unnecessary leading zero');
            return (0, $f2mJU.bytesToNumberBE)(data);
        }
    },
    toSig (bytes) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = $c3b91d553ab14e64$export$56ac33195d7076db;
        const data = (0, $3Bcdj.abytes)(bytes, undefined, 'signature');
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E('invalid signature: left bytes after parsing');
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = $c3b91d553ab14e64$export$56ac33195d7076db;
        const rs = tlv.encode(0x02, int.encode(sig.r));
        const ss = tlv.encode(0x02, int.encode(sig.s));
        const seq = rs + ss;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $c3b91d553ab14e64$var$_0n = BigInt(0), $c3b91d553ab14e64$var$_1n = BigInt(1), $c3b91d553ab14e64$var$_2n = BigInt(2), $c3b91d553ab14e64$var$_3n = BigInt(3), $c3b91d553ab14e64$var$_4n = BigInt(4);
function $c3b91d553ab14e64$export$350b8ea6f1c27fae(params, extraOpts = {}) {
    const validated = (0, $lkFCe.createCurveFields)('weierstrass', params, extraOpts);
    const { Fp: Fp, Fn: Fn } = validated;
    let CURVE = validated.CURVE;
    const { h: cofactor, n: CURVE_ORDER } = CURVE;
    (0, $f2mJU.validateObject)(extraOpts, {}, {
        allowInfinityPoint: 'boolean',
        clearCofactor: 'function',
        isTorsionFree: 'function',
        fromBytes: 'function',
        toBytes: 'function',
        endo: 'object'
    });
    const { endo: endo } = extraOpts;
    if (endo) {
        // validateObject(endo, { beta: 'bigint', splitScalar: 'function' });
        if (!Fp.is0(CURVE.a) || typeof endo.beta !== 'bigint' || !Array.isArray(endo.basises)) throw new Error('invalid endo: expected "beta": bigint and "basises": array');
    }
    const lengths = $c3b91d553ab14e64$var$getWLengths(Fp, Fn);
    function assertCompressionIsSupported() {
        if (!Fp.isOdd) throw new Error('compression is not supported: Field does not have .isOdd()');
    }
    // Implements IEEE P1363 point encoding
    function pointToBytes(_c, point, isCompressed) {
        const { x: x, y: y } = point.toAffine();
        const bx = Fp.toBytes(x);
        (0, $f2mJU.abool)(isCompressed, 'isCompressed');
        if (isCompressed) {
            assertCompressionIsSupported();
            const hasEvenY = !Fp.isOdd(y);
            return (0, $3Bcdj.concatBytes)($c3b91d553ab14e64$var$pprefix(hasEvenY), bx);
        } else return (0, $3Bcdj.concatBytes)(Uint8Array.of(0x04), bx, Fp.toBytes(y));
    }
    function pointFromBytes(bytes) {
        (0, $3Bcdj.abytes)(bytes, undefined, 'Point');
        const { publicKey: comp, publicKeyUncompressed: uncomp } = lengths; // e.g. for 32-byte: 33, 65
        const length = bytes.length;
        const head = bytes[0];
        const tail = bytes.subarray(1);
        // No actual validation is done here: use .assertValidity()
        if (length === comp && (head === 0x02 || head === 0x03)) {
            const x = Fp.fromBytes(tail);
            if (!Fp.isValid(x)) throw new Error('bad point: is not on curve, wrong x');
            const y2 = weierstrassEquation(x); // y² = x³ + ax + b
            let y;
            try {
                y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
            } catch (sqrtError) {
                const err = sqrtError instanceof Error ? ': ' + sqrtError.message : '';
                throw new Error('bad point: is not on curve, sqrt error' + err);
            }
            assertCompressionIsSupported();
            const evenY = Fp.isOdd(y);
            const evenH = (head & 1) === 1; // ECDSA-specific
            if (evenH !== evenY) y = Fp.neg(y);
            return {
                x: x,
                y: y
            };
        } else if (length === uncomp && head === 0x04) {
            // TODO: more checks
            const L = Fp.BYTES;
            const x = Fp.fromBytes(tail.subarray(0, L));
            const y = Fp.fromBytes(tail.subarray(L, L * 2));
            if (!isValidXY(x, y)) throw new Error('bad point: is not on curve');
            return {
                x: x,
                y: y
            };
        } else throw new Error(`bad point: got length ${length}, expected compressed=${comp} or uncompressed=${uncomp}`);
    }
    const encodePoint = extraOpts.toBytes || pointToBytes;
    const decodePoint = extraOpts.fromBytes || pointFromBytes;
    function weierstrassEquation(x) {
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x² * x
        return Fp.add(Fp.add(x3, Fp.mul(x, CURVE.a)), CURVE.b); // x³ + a * x + b
    }
    // TODO: move top-level
    /** Checks whether equation holds for given x, y: y² == x³ + ax + b */ function isValidXY(x, y) {
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        return Fp.eql(left, right);
    }
    // Validate whether the passed curve params are valid.
    // Test 1: equation y² = x³ + ax + b should work for generator point.
    if (!isValidXY(CURVE.Gx, CURVE.Gy)) throw new Error('bad curve params: generator point');
    // Test 2: discriminant Δ part should be non-zero: 4a³ + 27b² != 0.
    // Guarantees curve is genus-1, smooth (non-singular).
    const _4a3 = Fp.mul(Fp.pow(CURVE.a, $c3b91d553ab14e64$var$_3n), $c3b91d553ab14e64$var$_4n);
    const _27b2 = Fp.mul(Fp.sqr(CURVE.b), BigInt(27));
    if (Fp.is0(Fp.add(_4a3, _27b2))) throw new Error('bad curve params: a or b');
    /** Asserts coordinate is valid: 0 <= n < Fp.ORDER. */ function acoord(title, n, banZero = false) {
        if (!Fp.isValid(n) || banZero && Fp.is0(n)) throw new Error(`bad point coordinate ${title}`);
        return n;
    }
    function aprjpoint(other) {
        if (!(other instanceof Point)) throw new Error('Weierstrass Point expected');
    }
    function splitEndoScalarN(k) {
        if (!endo || !endo.basises) throw new Error('no endo');
        return $c3b91d553ab14e64$export$2e78c1c514ef8576(k, endo.basises, Fn.ORDER);
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (X, Y, Z) ∋ (x=X/Z, y=Y/Z)
    const toAffineMemo = (0, $f2mJU.memoized)((p, iz)=>{
        const { X: X, Y: Y, Z: Z } = p;
        // Fast-path for normalized points
        if (Fp.eql(Z, Fp.ONE)) return {
            x: X,
            y: Y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(Z);
        const x = Fp.mul(X, iz);
        const y = Fp.mul(Y, iz);
        const zz = Fp.mul(Z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error('invZ was invalid');
        return {
            x: x,
            y: y
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $f2mJU.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is invalid representation of ZERO.
            if (extraOpts.allowInfinityPoint && !Fp.is0(p.Y)) return;
            throw new Error('bad point: ZERO');
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error('bad point: x or y not field elements');
        if (!isValidXY(x, y)) throw new Error('bad point: equation left != right');
        if (!p.isTorsionFree()) throw new Error('bad point: not in prime-order subgroup');
        return true;
    });
    function finishEndo(endoBeta, k1p, k2p, k1neg, k2neg) {
        k2p = new Point(Fp.mul(k2p.X, endoBeta), k2p.Y, k2p.Z);
        k1p = (0, $lkFCe.negateCt)(k1neg, k1p);
        k2p = (0, $lkFCe.negateCt)(k2neg, k2p);
        return k1p.add(k2p);
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates:(X, Y, Z) ∋ (x=X/Z, y=Y/Z).
     * Default Point works in 2d / affine coordinates: (x, y).
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        // base / generator point
        static BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
        // zero / infinity / identity point
        static ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
        // math field
        static Fp = Fp;
        // scalar field
        static Fn = Fn;
        X;
        Y;
        Z;
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ constructor(X, Y, Z){
            this.X = acoord('x', X);
            this.Y = acoord('y', Y, true);
            this.Z = acoord('z', Z);
            Object.freeze(this);
        }
        static CURVE() {
            return CURVE;
        }
        /** Does NOT validate if the point is valid. Use `.assertValidity()`. */ static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error('invalid affine point');
            if (p instanceof Point) throw new Error('projective point not allowed');
            // (0, 0) would've produced (0, 0, 1) - instead, we need (0, 1, 0)
            if (Fp.is0(x) && Fp.is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        static fromBytes(bytes) {
            const P = Point.fromAffine(decodePoint((0, $3Bcdj.abytes)(bytes, undefined, 'point')));
            P.assertValidity();
            return P;
        }
        static fromHex(hex) {
            return Point.fromBytes((0, $3Bcdj.hexToBytes)(hex));
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         *
         * @param windowSize
         * @param isLazy true will defer table computation until the first multiplication
         * @returns
         */ precompute(windowSize = 8, isLazy = true) {
            wnaf.createCache(this, windowSize);
            if (!isLazy) this.multiply($c3b91d553ab14e64$var$_3n); // random number
            return this;
        }
        // TODO: return `this`
        /** A point on curve is valid if it conforms to equation. */ assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (!Fp.isOdd) throw new Error("Field doesn't support isOdd");
            return !Fp.isOdd(y);
        }
        /** Compare one point to another. */ equals(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /** Flips point to one corresponding to (x, -y) in Affine coordinates. */ negate() {
            return new Point(this.X, Fp.neg(this.Y), this.Z);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $c3b91d553ab14e64$var$_3n);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            aprjpoint(other);
            const { X: X1, Y: Y1, Z: Z1 } = this;
            const { X: X2, Y: Y2, Z: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $c3b91d553ab14e64$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo } = extraOpts;
            if (!Fn.isValidNot0(scalar)) throw new Error('invalid scalar: out of range'); // 0 is invalid
            let point, fake; // Fake point is used to const-time mult
            const mul = (n)=>wnaf.cached(this, n, (p)=>(0, $lkFCe.normalizeZ)(Point, p));
            /** See docs for {@link EndomorphismOpts} */ if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = splitEndoScalarN(scalar);
                const { p: k1p, f: k1f } = mul(k1);
                const { p: k2p, f: k2f } = mul(k2);
                fake = k1f.add(k2f);
                point = finishEndo(endo.beta, k1p, k2p, k1neg, k2neg);
            } else {
                const { p: p, f: f } = mul(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return (0, $lkFCe.normalizeZ)(Point, [
                point,
                fake
            ])[0];
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed secret key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            const { endo: endo } = extraOpts;
            const p = this;
            if (!Fn.isValid(sc)) throw new Error('invalid scalar: out of range'); // 0 is valid
            if (sc === $c3b91d553ab14e64$var$_0n || p.is0()) return Point.ZERO; // 0
            if (sc === $c3b91d553ab14e64$var$_1n) return p; // 1
            if (wnaf.hasCache(this)) return this.multiply(sc); // precomputes
            // We don't have method for double scalar multiplication (aP + bQ):
            // Even with using Strauss-Shamir trick, it's 35% slower than naïve mul+add.
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = splitEndoScalarN(sc);
                const { p1: p1, p2: p2 } = (0, $lkFCe.mulEndoUnsafe)(Point, p, k1, k2); // 30% faster vs wnaf.unsafe
                return finishEndo(endo.beta, p1, p2, k1neg, k2neg);
            } else return wnaf.unsafe(p, sc);
        }
        /**
         * Converts Projective point to affine (x, y) coordinates.
         * @param invertedZ Z^-1 (inverted zero) - optional, precomputation is useful for invertBatch
         */ toAffine(invertedZ) {
            return toAffineMemo(this, invertedZ);
        }
        /**
         * Checks whether Point is free of torsion elements (is in prime subgroup).
         * Always torsion-free for cofactor=1 curves.
         */ isTorsionFree() {
            const { isTorsionFree: isTorsionFree } = extraOpts;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return true;
            if (isTorsionFree) return isTorsionFree(Point, this);
            return wnaf.unsafe(this, CURVE_ORDER).is0();
        }
        clearCofactor() {
            const { clearCofactor: clearCofactor } = extraOpts;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(cofactor);
        }
        isSmallOrder() {
            // can we use this.clearCofactor()?
            return this.multiplyUnsafe(cofactor).is0();
        }
        toBytes(isCompressed = true) {
            (0, $f2mJU.abool)(isCompressed, 'isCompressed');
            this.assertValidity();
            return encodePoint(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return (0, $3Bcdj.bytesToHex)(this.toBytes(isCompressed));
        }
        toString() {
            return `<Point ${this.is0() ? 'ZERO' : this.toHex()}>`;
        }
    }
    const bits = Fn.BITS;
    const wnaf = new (0, $lkFCe.wNAF)(Point, extraOpts.endo ? Math.ceil(bits / 2) : bits);
    Point.BASE.precompute(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    return Point;
}
// Points start with byte 0x02 when y is even; otherwise 0x03
function $c3b91d553ab14e64$var$pprefix(hasEvenY) {
    return Uint8Array.of(hasEvenY ? 0x02 : 0x03);
}
function $c3b91d553ab14e64$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $c3b91d553ab14e64$var$_0n;
    for(let o = q - $c3b91d553ab14e64$var$_1n; o % $c3b91d553ab14e64$var$_2n === $c3b91d553ab14e64$var$_0n; o /= $c3b91d553ab14e64$var$_2n)l += $c3b91d553ab14e64$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $c3b91d553ab14e64$var$_2n << c1 - $c3b91d553ab14e64$var$_1n - $c3b91d553ab14e64$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $c3b91d553ab14e64$var$_2n;
    const c2 = (q - $c3b91d553ab14e64$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $c3b91d553ab14e64$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $c3b91d553ab14e64$var$_1n; i--){
            let tv5 = i - $c3b91d553ab14e64$var$_2n; // 18.    tv5 = i - 2
            tv5 = $c3b91d553ab14e64$var$_2n << tv5 - $c3b91d553ab14e64$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $c3b91d553ab14e64$var$_4n === $c3b91d553ab14e64$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $c3b91d553ab14e64$var$_3n) / $c3b91d553ab14e64$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $c3b91d553ab14e64$export$cc7fea9756a17416(Fp, opts) {
    (0, $2D9sF.validateField)(Fp);
    const { A: A, B: B, Z: Z } = opts;
    if (!Fp.isValid(A) || !Fp.isValid(B) || !Fp.isValid(Z)) throw new Error('mapToCurveSimpleSWU: invalid opts');
    const sqrtRatio = $c3b91d553ab14e64$export$8324ae9483e33241(Fp, Z);
    if (!Fp.isOdd) throw new Error('Field does not have .isOdd()');
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        const tv4_inv = (0, $2D9sF.FpInvertBatch)(Fp, [
            tv4
        ], true)[0];
        x = Fp.mul(x, tv4_inv); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
function $c3b91d553ab14e64$var$getWLengths(Fp, Fn) {
    return {
        secretKey: Fn.BYTES,
        publicKey: 1 + Fp.BYTES,
        publicKeyUncompressed: 1 + 2 * Fp.BYTES,
        publicKeyHasPrefix: true,
        signature: 2 * Fn.BYTES
    };
}
function $c3b91d553ab14e64$export$cb44b25bcf287f5d(Point, ecdhOpts = {}) {
    const { Fn: Fn } = Point;
    const randomBytes_ = ecdhOpts.randomBytes || (0, $3Bcdj.randomBytes);
    const lengths = Object.assign($c3b91d553ab14e64$var$getWLengths(Point.Fp, Fn), {
        seed: (0, $2D9sF.getMinHashLength)(Fn.ORDER)
    });
    function isValidSecretKey(secretKey) {
        try {
            const num = Fn.fromBytes(secretKey);
            return Fn.isValidNot0(num);
        } catch (error) {
            return false;
        }
    }
    function isValidPublicKey(publicKey, isCompressed) {
        const { publicKey: comp, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        try {
            const l = publicKey.length;
            if (isCompressed === true && l !== comp) return false;
            if (isCompressed === false && l !== publicKeyUncompressed) return false;
            return !!Point.fromBytes(publicKey);
        } catch (error) {
            return false;
        }
    }
    /**
     * Produces cryptographically secure secret key from random of size
     * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
     */ function randomSecretKey(seed = randomBytes_(lengths.seed)) {
        return (0, $2D9sF.mapHashToField)((0, $3Bcdj.abytes)(seed, lengths.seed, 'seed'), Fn.ORDER);
    }
    /**
     * Computes public key for a secret key. Checks for validity of the secret key.
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(secretKey, isCompressed = true) {
        return Point.BASE.multiply(Fn.fromBytes(secretKey)).toBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const { secretKey: secretKey, publicKey: publicKey, publicKeyUncompressed: publicKeyUncompressed } = lengths;
        if (!(0, $3Bcdj.isBytes)(item)) return undefined;
        if ('_lengths' in Fn && Fn._lengths || secretKey === publicKey) return undefined;
        const l = (0, $3Bcdj.abytes)(item, undefined, 'key').length;
        return l === publicKey || l === publicKeyUncompressed;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from secret key A and public key B.
     * Checks: 1) secret key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(secretKeyA, publicKeyB, isCompressed = true) {
        if (isProbPub(secretKeyA) === true) throw new Error('first arg must be private key');
        if (isProbPub(publicKeyB) === false) throw new Error('second arg must be public key');
        const s = Fn.fromBytes(secretKeyA);
        const b = Point.fromBytes(publicKeyB); // checks for being on-curve
        return b.multiply(s).toBytes(isCompressed);
    }
    const utils = {
        isValidSecretKey: isValidSecretKey,
        isValidPublicKey: isValidPublicKey,
        randomSecretKey: randomSecretKey
    };
    const keygen = (0, $lkFCe.createKeygen)(randomSecretKey, getPublicKey);
    return Object.freeze({
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        keygen: keygen,
        Point: Point,
        utils: utils,
        lengths: lengths
    });
}
function $c3b91d553ab14e64$export$4812c9a1c4ca02a(Point, hash, ecdsaOpts = {}) {
    (0, $3Bcdj.ahash)(hash);
    (0, $f2mJU.validateObject)(ecdsaOpts, {}, {
        hmac: 'function',
        lowS: 'boolean',
        randomBytes: 'function',
        bits2int: 'function',
        bits2int_modN: 'function'
    });
    ecdsaOpts = Object.assign({}, ecdsaOpts);
    const randomBytes = ecdsaOpts.randomBytes || (0, $3Bcdj.randomBytes);
    const hmac = ecdsaOpts.hmac || ((key, msg)=>(0, $70Xw9.hmac)(hash, key, msg));
    const { Fp: Fp, Fn: Fn } = Point;
    const { ORDER: CURVE_ORDER, BITS: fnBits } = Fn;
    const { keygen: keygen, getPublicKey: getPublicKey, getSharedSecret: getSharedSecret, utils: utils, lengths: lengths } = $c3b91d553ab14e64$export$cb44b25bcf287f5d(Point, ecdsaOpts);
    const defaultSigOpts = {
        prehash: true,
        lowS: typeof ecdsaOpts.lowS === 'boolean' ? ecdsaOpts.lowS : true,
        format: 'compact',
        extraEntropy: false
    };
    const hasLargeCofactor = CURVE_ORDER * $c3b91d553ab14e64$var$_2n < Fp.ORDER; // Won't CURVE().h > 2n be more effective?
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $c3b91d553ab14e64$var$_1n;
        return number > HALF;
    }
    function validateRS(title, num) {
        if (!Fn.isValidNot0(num)) throw new Error(`invalid signature ${title}: out of range 1..Point.Fn.ORDER`);
        return num;
    }
    function assertSmallCofactor() {
        // ECDSA recovery is hard for cofactor > 1 curves.
        // In sign, `r = q.x mod n`, and here we recover q.x from r.
        // While recovering q.x >= n, we need to add r+n for cofactor=1 curves.
        // However, for cofactor>1, r+n may not get q.x:
        // r+n*i would need to be done instead where i is unknown.
        // To easily get i, we either need to:
        // a. increase amount of valid recid values (4, 5...); OR
        // b. prohibit non-prime-order signatures (recid > 1).
        if (hasLargeCofactor) throw new Error('"recovered" sig type is not supported for cofactor >2 curves');
    }
    function validateSigLength(bytes, format) {
        $c3b91d553ab14e64$var$validateSigFormat(format);
        const size = lengths.signature;
        const sizer = format === 'compact' ? size : format === 'recovered' ? size + 1 : undefined;
        return (0, $3Bcdj.abytes)(bytes, sizer);
    }
    /**
     * ECDSA signature with its (r, s) properties. Supports compact, recovered & DER representations.
     */ class Signature {
        r;
        s;
        recovery;
        constructor(r, s, recovery){
            this.r = validateRS('r', r); // r in [1..N-1];
            this.s = validateRS('s', s); // s in [1..N-1];
            if (recovery != null) {
                assertSmallCofactor();
                if (![
                    0,
                    1,
                    2,
                    3
                ].includes(recovery)) throw new Error('invalid recovery id');
                this.recovery = recovery;
            }
            Object.freeze(this);
        }
        static fromBytes(bytes, format = defaultSigOpts.format) {
            validateSigLength(bytes, format);
            let recid;
            if (format === 'der') {
                const { r: r, s: s } = $c3b91d553ab14e64$export$56ac33195d7076db.toSig((0, $3Bcdj.abytes)(bytes));
                return new Signature(r, s);
            }
            if (format === 'recovered') {
                recid = bytes[0];
                format = 'compact';
                bytes = bytes.subarray(1);
            }
            const L = lengths.signature / 2;
            const r = bytes.subarray(0, L);
            const s = bytes.subarray(L, L * 2);
            return new Signature(Fn.fromBytes(r), Fn.fromBytes(s), recid);
        }
        static fromHex(hex, format) {
            return this.fromBytes((0, $3Bcdj.hexToBytes)(hex), format);
        }
        assertRecovery() {
            const { recovery: recovery } = this;
            if (recovery == null) throw new Error('invalid recovery id: must be present');
            return recovery;
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(messageHash) {
            const { r: r, s: s } = this;
            const recovery = this.assertRecovery();
            const radj = recovery === 2 || recovery === 3 ? r + CURVE_ORDER : r;
            if (!Fp.isValid(radj)) throw new Error('invalid recovery id: sig.r+curve.n != R.x');
            const x = Fp.toBytes(radj);
            const R = Point.fromBytes((0, $3Bcdj.concatBytes)($c3b91d553ab14e64$var$pprefix((recovery & 1) === 0), x));
            const ir = Fn.inv(radj); // r^-1
            const h = bits2int_modN((0, $3Bcdj.abytes)(messageHash, undefined, 'msgHash')); // Truncate hash
            const u1 = Fn.create(-h * ir); // -hr^-1
            const u2 = Fn.create(s * ir); // sr^-1
            // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1). unsafe is fine: there is no private data.
            const Q = Point.BASE.multiplyUnsafe(u1).add(R.multiplyUnsafe(u2));
            if (Q.is0()) throw new Error('invalid recovery: point at infinify');
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        toBytes(format = defaultSigOpts.format) {
            $c3b91d553ab14e64$var$validateSigFormat(format);
            if (format === 'der') return (0, $3Bcdj.hexToBytes)($c3b91d553ab14e64$export$56ac33195d7076db.hexFromSig(this));
            const { r: r, s: s } = this;
            const rb = Fn.toBytes(r);
            const sb = Fn.toBytes(s);
            if (format === 'recovered') {
                assertSmallCofactor();
                return (0, $3Bcdj.concatBytes)(Uint8Array.of(this.assertRecovery()), rb, sb);
            }
            return (0, $3Bcdj.concatBytes)(rb, sb);
        }
        toHex(format) {
            return (0, $3Bcdj.bytesToHex)(this.toBytes(format));
        }
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = ecdsaOpts.bits2int || function bits2int_def(bytes) {
        // Our custom check "just in case", for protection against DoS
        if (bytes.length > 8192) throw new Error('input is too large');
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = (0, $f2mJU.bytesToNumberBE)(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - fnBits; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = ecdsaOpts.bits2int_modN || function bits2int_modN_def(bytes) {
        return Fn.create(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // Pads output with zero as per spec
    const ORDER_MASK = (0, $f2mJU.bitMask)(fnBits);
    /** Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`. */ function int2octets(num) {
        // IMPORTANT: the check ensures working for case `Fn.BYTES != Fn.BITS * 8`
        (0, $f2mJU.aInRange)('num < 2^' + fnBits, num, $c3b91d553ab14e64$var$_0n, ORDER_MASK);
        return Fn.toBytes(num);
    }
    function validateMsgAndHash(message, prehash) {
        (0, $3Bcdj.abytes)(message, undefined, 'message');
        return prehash ? (0, $3Bcdj.abytes)(hash(message), undefined, 'prehashed message') : message;
    }
    /**
     * Steps A, D of RFC6979 3.2.
     * Creates RFC6979 seed; converts msg/privKey to numbers.
     * Used only in sign, not in verify.
     *
     * Warning: we cannot assume here that message has same amount of bytes as curve order,
     * this will be invalid at least for P521. Also it can be bigger for P224 + SHA256.
     */ function prepSig(message, secretKey, opts) {
        const { lowS: lowS, prehash: prehash, extraEntropy: extraEntropy } = $c3b91d553ab14e64$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash); // RFC6979 3.2 A: h1 = H(m)
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with fnBits % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(message);
        const d = Fn.fromBytes(secretKey); // validate secret key, convert to bigint
        if (!Fn.isValidNot0(d)) throw new Error('invalid private key');
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (extraEntropy != null && extraEntropy !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            // gen random bytes OR pass as-is
            const e = extraEntropy === true ? randomBytes(lengths.secretKey) : extraEntropy;
            seedArgs.push((0, $3Bcdj.abytes)(e, undefined, 'extraEntropy')); // check for being bytes
        }
        const seed = (0, $3Bcdj.concatBytes)(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        // To transform k => Signature:
        // q = k⋅G
        // r = q.x mod n
        // s = k^-1(m + rd) mod n
        // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
        // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
        // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            // Important: all mod() calls here must be done over N
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!Fn.isValidNot0(k)) return; // Valid scalars (including k) must be in 1..N-1
            const ik = Fn.inv(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = k⋅G
            const r = Fn.create(q.x); // r = q.x mod n
            if (r === $c3b91d553ab14e64$var$_0n) return;
            const s = Fn.create(ik * Fn.create(m + r * d)); // s = k^-1(m + rd) mod n
            if (s === $c3b91d553ab14e64$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $c3b91d553ab14e64$var$_1n); // recovery bit (2 or 3 when q.x>n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = Fn.neg(s); // if lowS was passed, ensure s is always in the bottom half of N
                recovery ^= 1;
            }
            return new Signature(r, normS, hasLargeCofactor ? undefined : recovery);
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    /**
     * Signs message hash with a secret key.
     *
     * ```
     * sign(m, d) where
     *   k = rfc6979_hmac_drbg(m, d)
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr) / k mod n
     * ```
     */ function sign(message, secretKey, opts = {}) {
        const { seed: seed, k2sig: k2sig } = prepSig(message, secretKey, opts); // Steps A, D of RFC6979 3.2.
        const drbg = (0, $f2mJU.createHmacDrbg)(hash.outputLen, Fn.BYTES, hmac);
        const sig = drbg(seed, k2sig); // Steps B, C, D, E, F, G
        return sig.toBytes(opts.format);
    }
    /**
     * Verifies a signature against message and public key.
     * Rejects lowS signatures by default: see {@link ECDSAVerifyOpts}.
     * Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   u1 = hs^-1 mod n
     *   u2 = rs^-1 mod n
     *   R = u1⋅G + u2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, message, publicKey, opts = {}) {
        const { lowS: lowS, prehash: prehash, format: format } = $c3b91d553ab14e64$var$validateSigOpts(opts, defaultSigOpts);
        publicKey = (0, $3Bcdj.abytes)(publicKey, undefined, 'publicKey');
        message = validateMsgAndHash(message, prehash);
        if (!(0, $3Bcdj.isBytes)(signature)) {
            const end = signature instanceof Signature ? ', use sig.toBytes()' : '';
            throw new Error('verify expects Uint8Array signature' + end);
        }
        validateSigLength(signature, format); // execute this twice because we want loud error
        try {
            const sig = Signature.fromBytes(signature, format);
            const P = Point.fromBytes(publicKey);
            if (lowS && sig.hasHighS()) return false;
            const { r: r, s: s } = sig;
            const h = bits2int_modN(message); // mod n, not mod p
            const is = Fn.inv(s); // s^-1 mod n
            const u1 = Fn.create(h * is); // u1 = hs^-1 mod n
            const u2 = Fn.create(r * is); // u2 = rs^-1 mod n
            const R = Point.BASE.multiplyUnsafe(u1).add(P.multiplyUnsafe(u2)); // u1⋅G + u2⋅P
            if (R.is0()) return false;
            const v = Fn.create(R.x); // v = r.x mod n
            return v === r;
        } catch (e) {
            return false;
        }
    }
    function recoverPublicKey(signature, message, opts = {}) {
        const { prehash: prehash } = $c3b91d553ab14e64$var$validateSigOpts(opts, defaultSigOpts);
        message = validateMsgAndHash(message, prehash);
        return Signature.fromBytes(signature, 'recovered').recoverPublicKey(message).toBytes();
    }
    return Object.freeze({
        keygen: keygen,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        utils: utils,
        lengths: lengths,
        Point: Point,
        sign: sign,
        verify: verify,
        recoverPublicKey: recoverPublicKey,
        Signature: Signature,
        hash: hash
    });
}

});
parcelRegister("70Xw9", function(module, exports) {

$parcel$export(module.exports, "hmac", () => $51b6b372898f65c0$export$355af40f8ab02f34);
/**
 * HMAC: RFC2104 message authentication code.
 * @module
 */ 
var $3Bcdj = parcelRequire("3Bcdj");
class $51b6b372898f65c0$export$7d0ef403e43ad532 {
    oHash;
    iHash;
    blockLen;
    outputLen;
    finished = false;
    destroyed = false;
    constructor(hash, key){
        (0, $3Bcdj.ahash)(hash);
        (0, $3Bcdj.abytes)(key, undefined, 'key');
        this.iHash = hash.create();
        if (typeof this.iHash.update !== 'function') throw new Error('Expected instance of class which extends utils.Hash');
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        (0, $3Bcdj.clean)(pad);
    }
    update(buf) {
        (0, $3Bcdj.aexists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $3Bcdj.aexists)(this);
        (0, $3Bcdj.abytes)(out, this.outputLen, 'output');
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to ||= Object.create(Object.getPrototypeOf(this), {});
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    clone() {
        return this._cloneInto();
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $51b6b372898f65c0$export$355af40f8ab02f34 = (hash, key, message)=>new $51b6b372898f65c0$export$7d0ef403e43ad532(hash, key).update(message).digest();
$51b6b372898f65c0$export$355af40f8ab02f34.create = (hash, key)=>new $51b6b372898f65c0$export$7d0ef403e43ad532(hash, key);

});



parcelRegister("83RRd", function(module, exports) {

$parcel$export(module.exports, "base64", () => $5de861824b024e83$export$b3b2de96497acc47);
$parcel$export(module.exports, "bech32", () => $5de861824b024e83$export$27c42482533637da);
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function $5de861824b024e83$var$isBytes(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
/** Asserts something is Uint8Array. */ function $5de861824b024e83$var$abytes(b) {
    if (!$5de861824b024e83$var$isBytes(b)) throw new Error('Uint8Array expected');
}
function $5de861824b024e83$var$isArrayOf(isString, arr) {
    if (!Array.isArray(arr)) return false;
    if (arr.length === 0) return true;
    if (isString) return arr.every((item)=>typeof item === 'string');
    else return arr.every((item)=>Number.isSafeInteger(item));
}
function $5de861824b024e83$var$afn(input) {
    if (typeof input !== 'function') throw new Error('function expected');
    return true;
}
function $5de861824b024e83$var$astr(label, input) {
    if (typeof input !== 'string') throw new Error(`${label}: string expected`);
    return true;
}
function $5de861824b024e83$var$anumber(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`invalid integer: ${n}`);
}
function $5de861824b024e83$var$aArr(input) {
    if (!Array.isArray(input)) throw new Error('array expected');
}
function $5de861824b024e83$var$astrArr(label, input) {
    if (!$5de861824b024e83$var$isArrayOf(true, input)) throw new Error(`${label}: array of strings expected`);
}
function $5de861824b024e83$var$anumArr(label, input) {
    if (!$5de861824b024e83$var$isArrayOf(false, input)) throw new Error(`${label}: array of numbers expected`);
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $5de861824b024e83$var$chain(...args) {
    const id = (a)=>a;
    // Wrap call in closure so JIT can inline calls
    const wrap = (a, b)=>(c)=>a(b(c));
    // Construct chain of args[-1].encode(args[-2].encode([...]))
    const encode = args.map((x)=>x.encode).reduceRight(wrap, id);
    // Construct chain of args[0].decode(args[1].decode(...))
    const decode = args.map((x)=>x.decode).reduce(wrap, id);
    return {
        encode: encode,
        decode: decode
    };
}
/**
 * Encodes integer radix representation to array of strings using alphabet and back.
 * Could also be array of strings.
 * @__NO_SIDE_EFFECTS__
 */ function $5de861824b024e83$var$alphabet(letters) {
    // mapping 1 to "b"
    const lettersA = typeof letters === 'string' ? letters.split('') : letters;
    const len = lettersA.length;
    $5de861824b024e83$var$astrArr('alphabet', lettersA);
    // mapping "b" to 1
    const indexes = new Map(lettersA.map((l, i)=>[
            l,
            i
        ]));
    return {
        encode: (digits)=>{
            $5de861824b024e83$var$aArr(digits);
            return digits.map((i)=>{
                if (!Number.isSafeInteger(i) || i < 0 || i >= len) throw new Error(`alphabet.encode: digit index outside alphabet "${i}". Allowed: ${letters}`);
                return lettersA[i];
            });
        },
        decode: (input)=>{
            $5de861824b024e83$var$aArr(input);
            return input.map((letter)=>{
                $5de861824b024e83$var$astr('alphabet.decode', letter);
                const i = indexes.get(letter);
                if (i === undefined) throw new Error(`Unknown letter: "${letter}". Allowed: ${letters}`);
                return i;
            });
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $5de861824b024e83$var$join(separator = '') {
    $5de861824b024e83$var$astr('join', separator);
    return {
        encode: (from)=>{
            $5de861824b024e83$var$astrArr('join.decode', from);
            return from.join(separator);
        },
        decode: (to)=>{
            $5de861824b024e83$var$astr('join.decode', to);
            return to.split(separator);
        }
    };
}
/**
 * Pad strings array so it has integer number of bits
 * @__NO_SIDE_EFFECTS__
 */ function $5de861824b024e83$var$padding(bits, chr = '=') {
    $5de861824b024e83$var$anumber(bits);
    $5de861824b024e83$var$astr('padding', chr);
    return {
        encode (data) {
            $5de861824b024e83$var$astrArr('padding.encode', data);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            $5de861824b024e83$var$astrArr('padding.decode', input);
            let end = input.length;
            if (end * bits % 8) throw new Error('padding: invalid, string should have whole number of bytes');
            for(; end > 0 && input[end - 1] === chr; end--){
                const last = end - 1;
                const byte = last * bits;
                if (byte % 8 === 0) throw new Error('padding: invalid, string has too much padding');
            }
            return input.slice(0, end);
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $5de861824b024e83$var$normalize(fn) {
    $5de861824b024e83$var$afn(fn);
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
/**
 * Slow: O(n^2) time complexity
 */ function $5de861824b024e83$var$convertRadix(data, from, to) {
    // base 1 is impossible
    if (from < 2) throw new Error(`convertRadix: invalid from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: invalid to=${to}, base cannot be less than 2`);
    $5de861824b024e83$var$aArr(data);
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data, (d)=>{
        $5de861824b024e83$var$anumber(d);
        if (d < 0 || d >= from) throw new Error(`invalid integer: ${d}`);
        return d;
    });
    const dlen = digits.length;
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < dlen; i++){
            const digit = digits[i];
            const fromCarry = from * carry;
            const digitBase = fromCarry + digit;
            if (!Number.isSafeInteger(digitBase) || fromCarry / from !== carry || digitBase - digit !== fromCarry) throw new Error('convertRadix: carry overflow');
            const div = digitBase / to;
            carry = digitBase % to;
            const rounded = Math.floor(div);
            digits[i] = rounded;
            if (!Number.isSafeInteger(rounded) || rounded * to + carry !== digitBase) throw new Error('convertRadix: carry overflow');
            if (!done) continue;
            else if (!rounded) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $5de861824b024e83$var$gcd = (a, b)=>b === 0 ? a : $5de861824b024e83$var$gcd(b, a % b);
const $5de861824b024e83$var$radix2carry = /* @__NO_SIDE_EFFECTS__ */ (from, to)=>from + (to - $5de861824b024e83$var$gcd(from, to));
const $5de861824b024e83$var$powers = /* @__PURE__ */ (()=>{
    let res = [];
    for(let i = 0; i < 40; i++)res.push(2 ** i);
    return res;
})();
/**
 * Implemented with numbers, because BigInt is 5x slower
 */ function $5de861824b024e83$var$convertRadix2(data, from, to, padding) {
    $5de861824b024e83$var$aArr(data);
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($5de861824b024e83$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$5de861824b024e83$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0; // bitwise position in current element
    const max = $5de861824b024e83$var$powers[from];
    const mask = $5de861824b024e83$var$powers[to] - 1;
    const res = [];
    for (const n of data){
        $5de861824b024e83$var$anumber(n);
        if (n >= max) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        const pow = $5de861824b024e83$var$powers[pos];
        if (pow === undefined) throw new Error('invalid carry');
        carry &= pow - 1; // clean carry, otherwise it will cause overflow
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error('Excess padding');
    if (!padding && carry > 0) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $5de861824b024e83$var$radix(num) {
    $5de861824b024e83$var$anumber(num);
    const _256 = 256;
    return {
        encode: (bytes)=>{
            if (!$5de861824b024e83$var$isBytes(bytes)) throw new Error('radix.encode input should be Uint8Array');
            return $5de861824b024e83$var$convertRadix(Array.from(bytes), _256, num);
        },
        decode: (digits)=>{
            $5de861824b024e83$var$anumArr('radix.decode', digits);
            return Uint8Array.from($5de861824b024e83$var$convertRadix(digits, num, _256));
        }
    };
}
/**
 * If both bases are power of same number (like `2**8 <-> 2**64`),
 * there is a linear algorithm. For now we have implementation for power-of-two bases only.
 * @__NO_SIDE_EFFECTS__
 */ function $5de861824b024e83$var$radix2(bits, revPadding = false) {
    $5de861824b024e83$var$anumber(bits);
    if (bits <= 0 || bits > 32) throw new Error('radix2: bits should be in (0..32]');
    if ($5de861824b024e83$var$radix2carry(8, bits) > 32 || $5de861824b024e83$var$radix2carry(bits, 8) > 32) throw new Error('radix2: carry overflow');
    return {
        encode: (bytes)=>{
            if (!$5de861824b024e83$var$isBytes(bytes)) throw new Error('radix2.encode input should be Uint8Array');
            return $5de861824b024e83$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            $5de861824b024e83$var$anumArr('radix2.decode', digits);
            return Uint8Array.from($5de861824b024e83$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
function $5de861824b024e83$var$unsafeWrapper(fn) {
    $5de861824b024e83$var$afn(fn);
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
function $5de861824b024e83$var$checksum(len, fn) {
    $5de861824b024e83$var$anumber(len);
    $5de861824b024e83$var$afn(fn);
    return {
        encode (data) {
            if (!$5de861824b024e83$var$isBytes(data)) throw new Error('checksum.encode: input should be Uint8Array');
            const sum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(sum, data.length);
            return res;
        },
        decode (data) {
            if (!$5de861824b024e83$var$isBytes(data)) throw new Error('checksum.decode: input should be Uint8Array');
            const payload = data.slice(0, -len);
            const oldChecksum = data.slice(-len);
            const newChecksum = fn(payload).slice(0, len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error('Invalid checksum');
            return payload;
        }
    };
}
const $5de861824b024e83$export$eab97d15b1788b8d = {
    alphabet: $5de861824b024e83$var$alphabet,
    chain: $5de861824b024e83$var$chain,
    checksum: $5de861824b024e83$var$checksum,
    convertRadix: $5de861824b024e83$var$convertRadix,
    convertRadix2: $5de861824b024e83$var$convertRadix2,
    radix: $5de861824b024e83$var$radix,
    radix2: $5de861824b024e83$var$radix2,
    join: $5de861824b024e83$var$join,
    padding: $5de861824b024e83$var$padding
};
const $5de861824b024e83$export$586f61c71cb02fe4 = $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(4), $5de861824b024e83$var$alphabet('0123456789ABCDEF'), $5de861824b024e83$var$join(''));
const $5de861824b024e83$export$4a4d5965e2738b2a = $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(5), $5de861824b024e83$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'), $5de861824b024e83$var$padding(5), $5de861824b024e83$var$join(''));
const $5de861824b024e83$export$e077e39445e9b6db = $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(5), $5de861824b024e83$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZ234567'), $5de861824b024e83$var$join(''));
const $5de861824b024e83$export$c57d6760d519c8ac = $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(5), $5de861824b024e83$var$alphabet('0123456789ABCDEFGHIJKLMNOPQRSTUV'), $5de861824b024e83$var$padding(5), $5de861824b024e83$var$join(''));
const $5de861824b024e83$export$e37c85831a779eb9 = $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(5), $5de861824b024e83$var$alphabet('0123456789ABCDEFGHIJKLMNOPQRSTUV'), $5de861824b024e83$var$join(''));
const $5de861824b024e83$export$5fbcb08925249358 = $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(5), $5de861824b024e83$var$alphabet('0123456789ABCDEFGHJKMNPQRSTVWXYZ'), $5de861824b024e83$var$join(''), $5de861824b024e83$var$normalize((s)=>s.toUpperCase().replace(/O/g, '0').replace(/[IL]/g, '1')));
// Built-in base64 conversion https://caniuse.com/mdn-javascript_builtins_uint8array_frombase64
// prettier-ignore
const $5de861824b024e83$var$hasBase64Builtin = /* @__PURE__ */ (()=>typeof Uint8Array.from([]).toBase64 === 'function' && typeof Uint8Array.fromBase64 === 'function')();
const $5de861824b024e83$var$decodeBase64Builtin = (s, isUrl)=>{
    $5de861824b024e83$var$astr('base64', s);
    const re = isUrl ? /^[A-Za-z0-9=_-]+$/ : /^[A-Za-z0-9=+/]+$/;
    const alphabet = isUrl ? 'base64url' : 'base64';
    if (s.length > 0 && !re.test(s)) throw new Error('invalid base64');
    return Uint8Array.fromBase64(s, {
        alphabet: alphabet,
        lastChunkHandling: 'strict'
    });
};
const $5de861824b024e83$export$b3b2de96497acc47 = $5de861824b024e83$var$hasBase64Builtin ? {
    encode (b) {
        $5de861824b024e83$var$abytes(b);
        return b.toBase64();
    },
    decode (s) {
        return $5de861824b024e83$var$decodeBase64Builtin(s, false);
    }
} : $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(6), $5de861824b024e83$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'), $5de861824b024e83$var$padding(6), $5de861824b024e83$var$join(''));
const $5de861824b024e83$export$c907e660b9401ec7 = $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(6), $5de861824b024e83$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'), $5de861824b024e83$var$join(''));
const $5de861824b024e83$export$7d21597c7bc64465 = $5de861824b024e83$var$hasBase64Builtin ? {
    encode (b) {
        $5de861824b024e83$var$abytes(b);
        return b.toBase64({
            alphabet: 'base64url'
        });
    },
    decode (s) {
        return $5de861824b024e83$var$decodeBase64Builtin(s, true);
    }
} : $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(6), $5de861824b024e83$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'), $5de861824b024e83$var$padding(6), $5de861824b024e83$var$join(''));
const $5de861824b024e83$export$963cd24a38dd2f90 = $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(6), $5de861824b024e83$var$alphabet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_'), $5de861824b024e83$var$join(''));
// base58 code
// -----------
const $5de861824b024e83$var$genBase58 = /* @__NO_SIDE_EFFECTS__ */ (abc)=>$5de861824b024e83$var$chain($5de861824b024e83$var$radix(58), $5de861824b024e83$var$alphabet(abc), $5de861824b024e83$var$join(''));
const $5de861824b024e83$export$61f53211c069eefb = $5de861824b024e83$var$genBase58('123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz');
const $5de861824b024e83$export$c6a7baed2941aad2 = $5de861824b024e83$var$genBase58('123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ');
const $5de861824b024e83$export$cbd4c72942a9201d = $5de861824b024e83$var$genBase58('rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz');
// Data len (index) -> encoded block len
const $5de861824b024e83$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
const $5de861824b024e83$export$e86cd8e7f8cff4a6 = {
    encode (data) {
        let res = '';
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += $5de861824b024e83$export$61f53211c069eefb.encode(block).padStart($5de861824b024e83$var$XMR_BLOCK_LEN[block.length], '1');
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $5de861824b024e83$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = $5de861824b024e83$export$61f53211c069eefb.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error('base58xmr: wrong padding');
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $5de861824b024e83$export$2217e0412f7b06b6 = (sha256)=>$5de861824b024e83$var$chain($5de861824b024e83$var$checksum(4, (data)=>sha256(sha256(data))), $5de861824b024e83$export$61f53211c069eefb);
const $5de861824b024e83$export$fff625c574161df6 = $5de861824b024e83$export$2217e0412f7b06b6;
const $5de861824b024e83$var$BECH_ALPHABET = $5de861824b024e83$var$chain($5de861824b024e83$var$alphabet('qpzry9x8gf2tvdw0s3jn54khce6mua7l'), $5de861824b024e83$var$join(''));
const $5de861824b024e83$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
function $5de861824b024e83$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $5de861824b024e83$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $5de861824b024e83$var$POLYMOD_GENERATORS[i];
    return chk;
}
function $5de861824b024e83$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $5de861824b024e83$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $5de861824b024e83$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $5de861824b024e83$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $5de861824b024e83$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $5de861824b024e83$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $5de861824b024e83$var$BECH_ALPHABET.encode($5de861824b024e83$var$convertRadix2([
        chk % $5de861824b024e83$var$powers[30]
    ], 30, 5, false));
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $5de861824b024e83$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === 'bech32' ? 1 : 0x2bc830a3;
    const _words = $5de861824b024e83$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $5de861824b024e83$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        $5de861824b024e83$var$astr('bech32.encode prefix', prefix);
        if ($5de861824b024e83$var$isBytes(words)) words = Array.from(words);
        $5de861824b024e83$var$anumArr('bech32.encode', words);
        const plen = prefix.length;
        if (plen === 0) throw new TypeError(`Invalid prefix length ${plen}`);
        const actualLength = plen + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        const lowered = prefix.toLowerCase();
        const sum = $5de861824b024e83$var$bechChecksum(lowered, words, ENCODING_CONST);
        return `${lowered}1${$5de861824b024e83$var$BECH_ALPHABET.encode(words)}${sum}`;
    }
    function decode(str, limit = 90) {
        $5de861824b024e83$var$astr('bech32.decode input', str);
        const slen = str.length;
        if (slen < 8 || limit !== false && slen > limit) throw new TypeError(`invalid string length: ${slen} (${str}). Expected (8..${limit})`);
        // don't allow mixed case
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        const sepIndex = lowered.lastIndexOf('1');
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = lowered.slice(0, sepIndex);
        const data = lowered.slice(sepIndex + 1);
        if (data.length < 6) throw new Error('Data must be at least 6 characters long');
        const words = $5de861824b024e83$var$BECH_ALPHABET.decode(data).slice(0, -6);
        const sum = $5de861824b024e83$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!data.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $5de861824b024e83$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    function encodeFromBytes(prefix, bytes) {
        return encode(prefix, toWords(bytes));
    }
    return {
        encode: encode,
        decode: decode,
        encodeFromBytes: encodeFromBytes,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
const $5de861824b024e83$export$27c42482533637da = $5de861824b024e83$var$genBech32('bech32');
const $5de861824b024e83$export$4963f7e473ccf819 = $5de861824b024e83$var$genBech32('bech32m');
const $5de861824b024e83$export$74329b762b589566 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
// prettier-ignore
const $5de861824b024e83$var$hasHexBuiltin = /* @__PURE__ */ (()=>typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// prettier-ignore
const $5de861824b024e83$var$hexBuiltin = {
    encode (data) {
        $5de861824b024e83$var$abytes(data);
        return data.toHex();
    },
    decode (s) {
        $5de861824b024e83$var$astr('hex', s);
        return Uint8Array.fromHex(s);
    }
};
const $5de861824b024e83$export$834dfc94dde4b3d8 = $5de861824b024e83$var$hasHexBuiltin ? $5de861824b024e83$var$hexBuiltin : $5de861824b024e83$var$chain($5de861824b024e83$var$radix2(4), $5de861824b024e83$var$alphabet('0123456789abcdef'), $5de861824b024e83$var$join(''), $5de861824b024e83$var$normalize((s)=>{
    if (typeof s !== 'string' || s.length % 2 !== 0) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
// prettier-ignore
const $5de861824b024e83$var$CODERS = {
    utf8: $5de861824b024e83$export$74329b762b589566,
    hex: $5de861824b024e83$export$834dfc94dde4b3d8,
    base16: $5de861824b024e83$export$586f61c71cb02fe4,
    base32: $5de861824b024e83$export$4a4d5965e2738b2a,
    base64: $5de861824b024e83$export$b3b2de96497acc47,
    base64url: $5de861824b024e83$export$7d21597c7bc64465,
    base58: $5de861824b024e83$export$61f53211c069eefb,
    base58xmr: $5de861824b024e83$export$e86cd8e7f8cff4a6
};
const $5de861824b024e83$var$coderTypeError = 'Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr';
const $5de861824b024e83$export$7c746b75f47c9c7d = (type, bytes)=>{
    if (typeof type !== 'string' || !$5de861824b024e83$var$CODERS.hasOwnProperty(type)) throw new TypeError($5de861824b024e83$var$coderTypeError);
    if (!$5de861824b024e83$var$isBytes(bytes)) throw new TypeError('bytesToString() expects Uint8Array');
    return $5de861824b024e83$var$CODERS[type].encode(bytes);
};
const $5de861824b024e83$export$42d51816ce590c93 = $5de861824b024e83$export$7c746b75f47c9c7d; // as in python, but for bytes only
const $5de861824b024e83$export$c8dd6bc66a63753c = (type, str)=>{
    if (!$5de861824b024e83$var$CODERS.hasOwnProperty(type)) throw new TypeError($5de861824b024e83$var$coderTypeError);
    if (typeof str !== 'string') throw new TypeError('stringToBytes() expects string');
    return $5de861824b024e83$var$CODERS[type].decode(str);
};
const $5de861824b024e83$export$b3317979f9250576 = $5de861824b024e83$export$c8dd6bc66a63753c;

});

parcelRegister("3RPiR", function(module, exports) {

$parcel$export(module.exports, "cbc", () => $2d0e1e19edfeea80$export$f98efb84b25ee206);
/**
 * [AES](https://en.wikipedia.org/wiki/Advanced_Encryption_Standard)
 * a.k.a. Advanced Encryption Standard
 * is a variant of Rijndael block cipher, standardized by NIST in 2001.
 * We provide the fastest available pure JS implementation.
 *
 * `cipher = encrypt(block, key)`
 *
 * Data is split into 128-bit blocks. Encrypted in 10/12/14 rounds (128/192/256 bits). In every round:
 * 1. **S-box**, table substitution
 * 2. **Shift rows**, cyclic shift left of all rows of data array
 * 3. **Mix columns**, multiplying every column by fixed polynomial
 * 4. **Add round key**, round_key xor i-th column of array
 *
 * Check out [FIPS-197](https://csrc.nist.gov/files/pubs/fips/197/final/docs/fips-197.pdf),
 * [NIST 800-38G](https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-38G.pdf)
 * and [original proposal](https://csrc.nist.gov/csrc/media/projects/cryptographic-standards-and-guidelines/documents/aes-development/rijndael-ammended.pdf)
 * @module
 */ 
var $8wowT = parcelRequire("8wowT");

var $38xio = parcelRequire("38xio");
const $2d0e1e19edfeea80$var$BLOCK_SIZE = 16;
const $2d0e1e19edfeea80$var$BLOCK_SIZE32 = 4;
const $2d0e1e19edfeea80$var$EMPTY_BLOCK = /* @__PURE__ */ new Uint8Array($2d0e1e19edfeea80$var$BLOCK_SIZE);
const $2d0e1e19edfeea80$var$ONE_BLOCK = /* @__PURE__ */ Uint8Array.from([
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x01
]);
const $2d0e1e19edfeea80$var$POLY = 0x11b; // 1 + x + x**3 + x**4 + x**8
function $2d0e1e19edfeea80$var$validateKeyLength(key) {
    if (![
        16,
        24,
        32
    ].includes(key.length)) throw new Error('"aes key" expected Uint8Array of length 16/24/32, got length=' + key.length);
}
// TODO: remove multiplication, binary ops only
function $2d0e1e19edfeea80$var$mul2(n) {
    return n << 1 ^ $2d0e1e19edfeea80$var$POLY & -(n >> 7);
}
function $2d0e1e19edfeea80$var$mul(a, b) {
    let res = 0;
    for(; b > 0; b >>= 1){
        // Montgomery ladder
        res ^= a & -(b & 1); // if (b&1) res ^=a (but const-time).
        a = $2d0e1e19edfeea80$var$mul2(a); // a = 2*a
    }
    return res;
}
// Increments bigint with wrap around
// NOTE: we cannot use u32 here since it may overflow on carry!
const $2d0e1e19edfeea80$var$incBytes = (data, isLE, carry = 1)=>{
    if (!Number.isSafeInteger(carry)) throw new Error('incBytes: wrong carry ' + carry);
    (0, $38xio.abytes)(data);
    for(let i = 0; i < data.length; i++){
        const pos = !isLE ? data.length - 1 - i : i;
        carry = carry + (data[pos] & 0xff) | 0;
        data[pos] = carry & 0xff;
        carry >>>= 8;
    }
};
// AES S-box is generated using finite field inversion,
// an affine transform, and xor of a constant 0x63.
const $2d0e1e19edfeea80$var$sbox = /* @__PURE__ */ (()=>{
    const t = new Uint8Array(256);
    for(let i = 0, x = 1; i < 256; i++, x ^= $2d0e1e19edfeea80$var$mul2(x))t[i] = x;
    const box = new Uint8Array(256);
    box[0] = 0x63; // first elm
    for(let i = 0; i < 255; i++){
        let x = t[255 - i];
        x |= x << 8;
        box[t[i]] = (x ^ x >> 4 ^ x >> 5 ^ x >> 6 ^ x >> 7 ^ 0x63) & 0xff;
    }
    (0, $38xio.clean)(t);
    return box;
})();
// Inverted S-box
const $2d0e1e19edfeea80$var$invSbox = /* @__PURE__ */ $2d0e1e19edfeea80$var$sbox.map((_, j)=>$2d0e1e19edfeea80$var$sbox.indexOf(j));
// Rotate u32 by 8
const $2d0e1e19edfeea80$var$rotr32_8 = (n)=>n << 24 | n >>> 8;
const $2d0e1e19edfeea80$var$rotl32_8 = (n)=>n << 8 | n >>> 24;
// The byte swap operation for uint32 (LE<->BE)
const $2d0e1e19edfeea80$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
// T-table is optimization suggested in 5.2 of original proposal (missed from FIPS-197). Changes:
// - LE instead of BE
// - bigger tables: T0 and T1 are merged into T01 table and T2 & T3 into T23;
//   so index is u16, instead of u8. This speeds up things, unexpectedly
function $2d0e1e19edfeea80$var$genTtable(sbox, fn) {
    if (sbox.length !== 256) throw new Error('Wrong sbox length');
    const T0 = new Uint32Array(256).map((_, j)=>fn(sbox[j]));
    const T1 = T0.map($2d0e1e19edfeea80$var$rotl32_8);
    const T2 = T1.map($2d0e1e19edfeea80$var$rotl32_8);
    const T3 = T2.map($2d0e1e19edfeea80$var$rotl32_8);
    const T01 = new Uint32Array(65536);
    const T23 = new Uint32Array(65536);
    const sbox2 = new Uint16Array(65536);
    for(let i = 0; i < 256; i++)for(let j = 0; j < 256; j++){
        const idx = i * 256 + j;
        T01[idx] = T0[i] ^ T1[j];
        T23[idx] = T2[i] ^ T3[j];
        sbox2[idx] = sbox[i] << 8 | sbox[j];
    }
    return {
        sbox: sbox,
        sbox2: sbox2,
        T0: T0,
        T1: T1,
        T2: T2,
        T3: T3,
        T01: T01,
        T23: T23
    };
}
const $2d0e1e19edfeea80$var$tableEncoding = /* @__PURE__ */ $2d0e1e19edfeea80$var$genTtable($2d0e1e19edfeea80$var$sbox, (s)=>$2d0e1e19edfeea80$var$mul(s, 3) << 24 | s << 16 | s << 8 | $2d0e1e19edfeea80$var$mul(s, 2));
const $2d0e1e19edfeea80$var$tableDecoding = /* @__PURE__ */ $2d0e1e19edfeea80$var$genTtable($2d0e1e19edfeea80$var$invSbox, (s)=>$2d0e1e19edfeea80$var$mul(s, 11) << 24 | $2d0e1e19edfeea80$var$mul(s, 13) << 16 | $2d0e1e19edfeea80$var$mul(s, 9) << 8 | $2d0e1e19edfeea80$var$mul(s, 14));
const $2d0e1e19edfeea80$var$xPowers = /* @__PURE__ */ (()=>{
    const p = new Uint8Array(16);
    for(let i = 0, x = 1; i < 16; i++, x = $2d0e1e19edfeea80$var$mul2(x))p[i] = x;
    return p;
})();
/** Key expansion used in CTR. */ function $2d0e1e19edfeea80$var$expandKeyLE(key) {
    (0, $38xio.abytes)(key);
    const len = key.length;
    $2d0e1e19edfeea80$var$validateKeyLength(key);
    const { sbox2: sbox2 } = $2d0e1e19edfeea80$var$tableEncoding;
    const toClean = [];
    if (!(0, $38xio.isAligned32)(key)) toClean.push(key = (0, $38xio.copyBytes)(key));
    const k32 = (0, $38xio.u32)(key);
    const Nk = k32.length;
    const subByte = (n)=>$2d0e1e19edfeea80$var$applySbox(sbox2, n, n, n, n);
    const xk = new Uint32Array(len + 28); // expanded key
    xk.set(k32);
    // 4.3.1 Key expansion
    for(let i = Nk; i < xk.length; i++){
        let t = xk[i - 1];
        if (i % Nk === 0) t = subByte($2d0e1e19edfeea80$var$rotr32_8(t)) ^ $2d0e1e19edfeea80$var$xPowers[i / Nk - 1];
        else if (Nk > 6 && i % Nk === 4) t = subByte(t);
        xk[i] = xk[i - Nk] ^ t;
    }
    (0, $38xio.clean)(...toClean);
    return xk;
}
function $2d0e1e19edfeea80$var$expandKeyDecLE(key) {
    const encKey = $2d0e1e19edfeea80$var$expandKeyLE(key);
    const xk = encKey.slice();
    const Nk = encKey.length;
    const { sbox2: sbox2 } = $2d0e1e19edfeea80$var$tableEncoding;
    const { T0: T0, T1: T1, T2: T2, T3: T3 } = $2d0e1e19edfeea80$var$tableDecoding;
    // Inverse key by chunks of 4 (rounds)
    for(let i = 0; i < Nk; i += 4)for(let j = 0; j < 4; j++)xk[i + j] = encKey[Nk - i - 4 + j];
    (0, $38xio.clean)(encKey);
    // apply InvMixColumn except first & last round
    for(let i = 4; i < Nk - 4; i++){
        const x = xk[i];
        const w = $2d0e1e19edfeea80$var$applySbox(sbox2, x, x, x, x);
        xk[i] = T0[w & 0xff] ^ T1[w >>> 8 & 0xff] ^ T2[w >>> 16 & 0xff] ^ T3[w >>> 24];
    }
    return xk;
}
// Apply tables
function $2d0e1e19edfeea80$var$apply0123(T01, T23, s0, s1, s2, s3) {
    return T01[s0 << 8 & 0xff00 | s1 >>> 8 & 0xff] ^ T23[s2 >>> 8 & 0xff00 | s3 >>> 24 & 0xff];
}
function $2d0e1e19edfeea80$var$applySbox(sbox2, s0, s1, s2, s3) {
    return sbox2[s0 & 0xff | s1 & 0xff00] | sbox2[s2 >>> 16 & 0xff | s3 >>> 16 & 0xff00] << 16;
}
function $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $2d0e1e19edfeea80$var$tableEncoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s0, s1, s2, s3);
        const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s1, s2, s3, s0);
        const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s2, s3, s0, s1);
        const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s3, s0, s1, s2);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // last round (without mixcolumns, so using SBOX2 table)
    const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s0, s1, s2, s3);
    const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s1, s2, s3, s0);
    const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s2, s3, s0, s1);
    const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s3, s0, s1, s2);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
// Can't be merged with encrypt: arg positions for apply0123 / applySbox are different
function $2d0e1e19edfeea80$var$decrypt(xk, s0, s1, s2, s3) {
    const { sbox2: sbox2, T01: T01, T23: T23 } = $2d0e1e19edfeea80$var$tableDecoding;
    let k = 0;
    s0 ^= xk[k++], s1 ^= xk[k++], s2 ^= xk[k++], s3 ^= xk[k++];
    const rounds = xk.length / 4 - 2;
    for(let i = 0; i < rounds; i++){
        const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s0, s3, s2, s1);
        const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s1, s0, s3, s2);
        const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s2, s1, s0, s3);
        const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$apply0123(T01, T23, s3, s2, s1, s0);
        s0 = t0, s1 = t1, s2 = t2, s3 = t3;
    }
    // Last round
    const t0 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s0, s3, s2, s1);
    const t1 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s1, s0, s3, s2);
    const t2 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s2, s1, s0, s3);
    const t3 = xk[k++] ^ $2d0e1e19edfeea80$var$applySbox(sbox2, s3, s2, s1, s0);
    return {
        s0: t0,
        s1: t1,
        s2: t2,
        s3: t3
    };
}
// TODO: investigate merging with ctr32
function $2d0e1e19edfeea80$var$ctrCounter(xk, nonce, src, dst) {
    (0, $38xio.abytes)(nonce, $2d0e1e19edfeea80$var$BLOCK_SIZE, 'nonce');
    (0, $38xio.abytes)(src);
    const srcLen = src.length;
    dst = (0, $38xio.getOutput)(srcLen, dst);
    (0, $38xio.complexOverlapBytes)(src, dst);
    const ctr = nonce;
    const c32 = (0, $38xio.u32)(ctr);
    // Fill block (empty, ctr=0)
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    const src32 = (0, $38xio.u32)(src);
    const dst32 = (0, $38xio.u32)(dst);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        $2d0e1e19edfeea80$var$incBytes(ctr, false, 1); // Full 128 bit counter with wrap around
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than block)
    // It's possible to handle > u32 fast, but is it worth it?
    const start = $2d0e1e19edfeea80$var$BLOCK_SIZE * Math.floor(src32.length / $2d0e1e19edfeea80$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $38xio.u8)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
        (0, $38xio.clean)(b32);
    }
    return dst;
}
// AES CTR with overflowing 32 bit counter
// It's possible to do 32le significantly simpler (and probably faster) by using u32.
// But, we need both, and perf bottleneck is in ghash anyway.
function $2d0e1e19edfeea80$var$ctr32(xk, isLE, nonce, src, dst) {
    (0, $38xio.abytes)(nonce, $2d0e1e19edfeea80$var$BLOCK_SIZE, 'nonce');
    (0, $38xio.abytes)(src);
    dst = (0, $38xio.getOutput)(src.length, dst);
    const ctr = nonce; // write new value to nonce, so it can be re-used
    const c32 = (0, $38xio.u32)(ctr);
    const view = (0, $38xio.createView)(ctr);
    const src32 = (0, $38xio.u32)(src);
    const dst32 = (0, $38xio.u32)(dst);
    const ctrPos = isLE ? 0 : 12;
    const srcLen = src.length;
    // Fill block (empty, ctr=0)
    let ctrNum = view.getUint32(ctrPos, isLE); // read current counter value
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]);
    // process blocks
    for(let i = 0; i + 4 <= src32.length; i += 4){
        dst32[i + 0] = src32[i + 0] ^ s0;
        dst32[i + 1] = src32[i + 1] ^ s1;
        dst32[i + 2] = src32[i + 2] ^ s2;
        dst32[i + 3] = src32[i + 3] ^ s3;
        ctrNum = ctrNum + 1 >>> 0; // u32 wrap
        view.setUint32(ctrPos, ctrNum, isLE);
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, c32[0], c32[1], c32[2], c32[3]));
    }
    // leftovers (less than a block)
    const start = $2d0e1e19edfeea80$var$BLOCK_SIZE * Math.floor(src32.length / $2d0e1e19edfeea80$var$BLOCK_SIZE32);
    if (start < srcLen) {
        const b32 = new Uint32Array([
            s0,
            s1,
            s2,
            s3
        ]);
        const buf = (0, $38xio.u8)(b32);
        for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
        (0, $38xio.clean)(b32);
    }
    return dst;
}
const $2d0e1e19edfeea80$export$5f70e4be40e1a294 = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function aesctr(key, nonce) {
    function processCtr(buf, dst) {
        (0, $38xio.abytes)(buf);
        if (dst !== undefined) {
            (0, $38xio.abytes)(dst);
            if (!(0, $38xio.isAligned32)(dst)) throw new Error('unaligned destination');
        }
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        const n = (0, $38xio.copyBytes)(nonce); // align + avoid changing
        const toClean = [
            xk,
            n
        ];
        if (!(0, $38xio.isAligned32)(buf)) toClean.push(buf = (0, $38xio.copyBytes)(buf));
        const out = $2d0e1e19edfeea80$var$ctrCounter(xk, n, buf, dst);
        (0, $38xio.clean)(...toClean);
        return out;
    }
    return {
        encrypt: (plaintext, dst)=>processCtr(plaintext, dst),
        decrypt: (ciphertext, dst)=>processCtr(ciphertext, dst)
    };
});
function $2d0e1e19edfeea80$var$validateBlockDecrypt(data) {
    (0, $38xio.abytes)(data);
    if (data.length % $2d0e1e19edfeea80$var$BLOCK_SIZE !== 0) throw new Error('aes-(cbc/ecb).decrypt ciphertext should consist of blocks with size ' + $2d0e1e19edfeea80$var$BLOCK_SIZE);
}
function $2d0e1e19edfeea80$var$validateBlockEncrypt(plaintext, pcks5, dst) {
    (0, $38xio.abytes)(plaintext);
    let outLen = plaintext.length;
    const remaining = outLen % $2d0e1e19edfeea80$var$BLOCK_SIZE;
    if (!pcks5 && remaining !== 0) throw new Error('aec/(cbc-ecb): unpadded plaintext with disabled padding');
    if (!(0, $38xio.isAligned32)(plaintext)) plaintext = (0, $38xio.copyBytes)(plaintext);
    const b = (0, $38xio.u32)(plaintext);
    if (pcks5) {
        let left = $2d0e1e19edfeea80$var$BLOCK_SIZE - remaining;
        if (!left) left = $2d0e1e19edfeea80$var$BLOCK_SIZE; // if no bytes left, create empty padding block
        outLen = outLen + left;
    }
    dst = (0, $38xio.getOutput)(outLen, dst);
    (0, $38xio.complexOverlapBytes)(plaintext, dst);
    const o = (0, $38xio.u32)(dst);
    return {
        b: b,
        o: o,
        out: dst
    };
}
function $2d0e1e19edfeea80$var$validatePCKS(data, pcks5) {
    if (!pcks5) return data;
    const len = data.length;
    if (!len) throw new Error('aes/pcks5: empty ciphertext not allowed');
    const lastByte = data[len - 1];
    if (lastByte <= 0 || lastByte > 16) throw new Error('aes/pcks5: wrong padding');
    const out = data.subarray(0, -lastByte);
    for(let i = 0; i < lastByte; i++)if (data[len - i - 1] !== lastByte) throw new Error('aes/pcks5: wrong padding');
    return out;
}
function $2d0e1e19edfeea80$var$padPCKS(left) {
    const tmp = new Uint8Array(16);
    const tmp32 = (0, $38xio.u32)(tmp);
    tmp.set(left);
    const paddingByte = $2d0e1e19edfeea80$var$BLOCK_SIZE - left.length;
    for(let i = $2d0e1e19edfeea80$var$BLOCK_SIZE - paddingByte; i < $2d0e1e19edfeea80$var$BLOCK_SIZE; i++)tmp[i] = paddingByte;
    return tmp32;
}
const $2d0e1e19edfeea80$export$bf364bd2354bf4a = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 16
}, function aesecb(key, opts = {}) {
    const pcks5 = !opts.disablePadding;
    return {
        encrypt (plaintext, dst) {
            const { b: b, o: o, out: _out } = $2d0e1e19edfeea80$var$validateBlockEncrypt(plaintext, pcks5, dst);
            const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
            let i = 0;
            for(; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $2d0e1e19edfeea80$var$padPCKS(plaintext.subarray(i * 4));
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, tmp32[0], tmp32[1], tmp32[2], tmp32[3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $38xio.clean)(xk);
            return _out;
        },
        decrypt (ciphertext, dst) {
            $2d0e1e19edfeea80$var$validateBlockDecrypt(ciphertext);
            const xk = $2d0e1e19edfeea80$var$expandKeyDecLE(key);
            dst = (0, $38xio.getOutput)(ciphertext.length, dst);
            const toClean = [
                xk
            ];
            if (!(0, $38xio.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $38xio.copyBytes)(ciphertext));
            (0, $38xio.complexOverlapBytes)(ciphertext, dst);
            const b = (0, $38xio.u32)(ciphertext);
            const o = (0, $38xio.u32)(dst);
            for(let i = 0; i + 4 <= b.length;){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$decrypt(xk, b[i + 0], b[i + 1], b[i + 2], b[i + 3]);
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $38xio.clean)(...toClean);
            return $2d0e1e19edfeea80$var$validatePCKS(dst, pcks5);
        }
    };
});
const $2d0e1e19edfeea80$export$f98efb84b25ee206 = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function aescbc(key, iv, opts = {}) {
    const pcks5 = !opts.disablePadding;
    return {
        encrypt (plaintext, dst) {
            const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
            const { b: b, o: o, out: _out } = $2d0e1e19edfeea80$var$validateBlockEncrypt(plaintext, pcks5, dst);
            let _iv = iv;
            const toClean = [
                xk
            ];
            if (!(0, $38xio.isAligned32)(_iv)) toClean.push(_iv = (0, $38xio.copyBytes)(_iv));
            const n32 = (0, $38xio.u32)(_iv);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            let i = 0;
            for(; i + 4 <= b.length;){
                s0 ^= b[i + 0], s1 ^= b[i + 1], s2 ^= b[i + 2], s3 ^= b[i + 3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            if (pcks5) {
                const tmp32 = $2d0e1e19edfeea80$var$padPCKS(plaintext.subarray(i * 4));
                s0 ^= tmp32[0], s1 ^= tmp32[1], s2 ^= tmp32[2], s3 ^= tmp32[3];
                ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3));
                o[i++] = s0, o[i++] = s1, o[i++] = s2, o[i++] = s3;
            }
            (0, $38xio.clean)(...toClean);
            return _out;
        },
        decrypt (ciphertext, dst) {
            $2d0e1e19edfeea80$var$validateBlockDecrypt(ciphertext);
            const xk = $2d0e1e19edfeea80$var$expandKeyDecLE(key);
            let _iv = iv;
            const toClean = [
                xk
            ];
            if (!(0, $38xio.isAligned32)(_iv)) toClean.push(_iv = (0, $38xio.copyBytes)(_iv));
            const n32 = (0, $38xio.u32)(_iv);
            dst = (0, $38xio.getOutput)(ciphertext.length, dst);
            if (!(0, $38xio.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $38xio.copyBytes)(ciphertext));
            (0, $38xio.complexOverlapBytes)(ciphertext, dst);
            const b = (0, $38xio.u32)(ciphertext);
            const o = (0, $38xio.u32)(dst);
            // prettier-ignore
            let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
            for(let i = 0; i + 4 <= b.length;){
                // prettier-ignore
                const ps0 = s0, ps1 = s1, ps2 = s2, ps3 = s3;
                s0 = b[i + 0], s1 = b[i + 1], s2 = b[i + 2], s3 = b[i + 3];
                const { s0: o0, s1: o1, s2: o2, s3: o3 } = $2d0e1e19edfeea80$var$decrypt(xk, s0, s1, s2, s3);
                o[i++] = o0 ^ ps0, o[i++] = o1 ^ ps1, o[i++] = o2 ^ ps2, o[i++] = o3 ^ ps3;
            }
            (0, $38xio.clean)(...toClean);
            return $2d0e1e19edfeea80$var$validatePCKS(dst, pcks5);
        }
    };
});
const $2d0e1e19edfeea80$export$385fe64256455ced = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 16
}, function aescfb(key, iv) {
    function processCfb(src, isEncrypt, dst) {
        (0, $38xio.abytes)(src);
        const srcLen = src.length;
        dst = (0, $38xio.getOutput)(srcLen, dst);
        if ((0, $38xio.overlapBytes)(src, dst)) throw new Error('overlapping src and dst not supported.');
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        let _iv = iv;
        const toClean = [
            xk
        ];
        if (!(0, $38xio.isAligned32)(_iv)) toClean.push(_iv = (0, $38xio.copyBytes)(_iv));
        if (!(0, $38xio.isAligned32)(src)) toClean.push(src = (0, $38xio.copyBytes)(src));
        const src32 = (0, $38xio.u32)(src);
        const dst32 = (0, $38xio.u32)(dst);
        const next32 = isEncrypt ? dst32 : src32;
        const n32 = (0, $38xio.u32)(_iv);
        // prettier-ignore
        let s0 = n32[0], s1 = n32[1], s2 = n32[2], s3 = n32[3];
        for(let i = 0; i + 4 <= src32.length;){
            const { s0: e0, s1: e1, s2: e2, s3: e3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3);
            dst32[i + 0] = src32[i + 0] ^ e0;
            dst32[i + 1] = src32[i + 1] ^ e1;
            dst32[i + 2] = src32[i + 2] ^ e2;
            dst32[i + 3] = src32[i + 3] ^ e3;
            s0 = next32[i++], s1 = next32[i++], s2 = next32[i++], s3 = next32[i++];
        }
        // leftovers (less than block)
        const start = $2d0e1e19edfeea80$var$BLOCK_SIZE * Math.floor(src32.length / $2d0e1e19edfeea80$var$BLOCK_SIZE32);
        if (start < srcLen) {
            ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3));
            const buf = (0, $38xio.u8)(new Uint32Array([
                s0,
                s1,
                s2,
                s3
            ]));
            for(let i = start, pos = 0; i < srcLen; i++, pos++)dst[i] = src[i] ^ buf[pos];
            (0, $38xio.clean)(buf);
        }
        (0, $38xio.clean)(...toClean);
        return dst;
    }
    return {
        encrypt: (plaintext, dst)=>processCfb(plaintext, true, dst),
        decrypt: (ciphertext, dst)=>processCfb(ciphertext, false, dst)
    };
});
// TODO: merge with chacha, however gcm has bitLen while chacha has byteLen
function $2d0e1e19edfeea80$var$computeTag(fn, isLE, key, data, AAD) {
    const aadLength = AAD ? AAD.length : 0;
    const h = fn.create(key, data.length + aadLength);
    if (AAD) h.update(AAD);
    const num = (0, $38xio.u64Lengths)(8 * data.length, 8 * aadLength, isLE);
    h.update(data);
    h.update(num);
    const res = h.digest();
    (0, $38xio.clean)(num);
    return res;
}
const $2d0e1e19edfeea80$export$1c2d3f5179fe12a4 = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16,
    varSizeNonce: true
}, function aesgcm(key, nonce, AAD) {
    // NIST 800-38d doesn't enforce minimum nonce length.
    // We enforce 8 bytes for compat with openssl.
    // 12 bytes are recommended. More than 12 bytes would be converted into 12.
    if (nonce.length < 8) throw new Error('aes/gcm: invalid nonce length');
    const tagLength = 16;
    function _computeTag(authKey, tagMask, data) {
        const tag = $2d0e1e19edfeea80$var$computeTag((0, $8wowT.ghash), false, authKey, data, AAD);
        for(let i = 0; i < tagMask.length; i++)tag[i] ^= tagMask[i];
        return tag;
    }
    function deriveKeys() {
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        const authKey = $2d0e1e19edfeea80$var$EMPTY_BLOCK.slice();
        const counter = $2d0e1e19edfeea80$var$EMPTY_BLOCK.slice();
        $2d0e1e19edfeea80$var$ctr32(xk, false, counter, counter, authKey);
        // NIST 800-38d, page 15: different behavior for 96-bit and non-96-bit nonces
        if (nonce.length === 12) counter.set(nonce);
        else {
            const nonceLen = $2d0e1e19edfeea80$var$EMPTY_BLOCK.slice();
            const view = (0, $38xio.createView)(nonceLen);
            view.setBigUint64(8, BigInt(nonce.length * 8), false);
            // ghash(nonce || u64be(0) || u64be(nonceLen*8))
            const g = (0, $8wowT.ghash).create(authKey).update(nonce).update(nonceLen);
            g.digestInto(counter); // digestInto doesn't trigger '.destroy'
            g.destroy();
        }
        const tagMask = $2d0e1e19edfeea80$var$ctr32(xk, false, counter, $2d0e1e19edfeea80$var$EMPTY_BLOCK);
        return {
            xk: xk,
            authKey: authKey,
            counter: counter,
            tagMask: tagMask
        };
    }
    return {
        encrypt (plaintext) {
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const out = new Uint8Array(plaintext.length + tagLength);
            const toClean = [
                xk,
                authKey,
                counter,
                tagMask
            ];
            if (!(0, $38xio.isAligned32)(plaintext)) toClean.push(plaintext = (0, $38xio.copyBytes)(plaintext));
            $2d0e1e19edfeea80$var$ctr32(xk, false, counter, plaintext, out.subarray(0, plaintext.length));
            const tag = _computeTag(authKey, tagMask, out.subarray(0, out.length - tagLength));
            toClean.push(tag);
            out.set(tag, plaintext.length);
            (0, $38xio.clean)(...toClean);
            return out;
        },
        decrypt (ciphertext) {
            const { xk: xk, authKey: authKey, counter: counter, tagMask: tagMask } = deriveKeys();
            const toClean = [
                xk,
                authKey,
                tagMask,
                counter
            ];
            if (!(0, $38xio.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $38xio.copyBytes)(ciphertext));
            const data = ciphertext.subarray(0, -tagLength);
            const passedTag = ciphertext.subarray(-tagLength);
            const tag = _computeTag(authKey, tagMask, data);
            toClean.push(tag);
            if (!(0, $38xio.equalBytes)(tag, passedTag)) throw new Error('aes/gcm: invalid ghash tag');
            const out = $2d0e1e19edfeea80$var$ctr32(xk, false, counter, data);
            (0, $38xio.clean)(...toClean);
            return out;
        }
    };
});
const $2d0e1e19edfeea80$var$limit = (name, min, max)=>(value)=>{
        if (!Number.isSafeInteger(value) || min > value || value > max) {
            const minmax = '[' + min + '..' + max + ']';
            throw new Error('' + name + ': expected value in range ' + minmax + ', got ' + value);
        }
    };
const $2d0e1e19edfeea80$export$d27cb3d8a42e5ca1 = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 16,
    nonceLength: 12,
    tagLength: 16,
    varSizeNonce: true
}, function aessiv(key, nonce, AAD) {
    const tagLength = 16;
    // From RFC 8452: Section 6
    const AAD_LIMIT = $2d0e1e19edfeea80$var$limit('AAD', 0, 2 ** 36);
    const PLAIN_LIMIT = $2d0e1e19edfeea80$var$limit('plaintext', 0, 2 ** 36);
    const NONCE_LIMIT = $2d0e1e19edfeea80$var$limit('nonce', 12, 12);
    const CIPHER_LIMIT = $2d0e1e19edfeea80$var$limit('ciphertext', 16, 2 ** 36 + 16);
    (0, $38xio.abytes)(key);
    $2d0e1e19edfeea80$var$validateKeyLength(key);
    NONCE_LIMIT(nonce.length);
    if (AAD !== undefined) AAD_LIMIT(AAD.length);
    function deriveKeys() {
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        const encKey = new Uint8Array(key.length);
        const authKey = new Uint8Array(16);
        const toClean = [
            xk,
            encKey
        ];
        let _nonce = nonce;
        if (!(0, $38xio.isAligned32)(_nonce)) toClean.push(_nonce = (0, $38xio.copyBytes)(_nonce));
        const n32 = (0, $38xio.u32)(_nonce);
        // prettier-ignore
        let s0 = 0, s1 = n32[0], s2 = n32[1], s3 = n32[2];
        let counter = 0;
        for (const derivedKey of [
            authKey,
            encKey
        ].map((0, $38xio.u32))){
            const d32 = (0, $38xio.u32)(derivedKey);
            for(let i = 0; i < d32.length; i += 2){
                // aes(u32le(0) || nonce)[:8] || aes(u32le(1) || nonce)[:8] ...
                const { s0: o0, s1: o1 } = $2d0e1e19edfeea80$var$encrypt(xk, s0, s1, s2, s3);
                d32[i + 0] = o0;
                d32[i + 1] = o1;
                s0 = ++counter; // increment counter inside state
            }
        }
        const res = {
            authKey: authKey,
            encKey: $2d0e1e19edfeea80$var$expandKeyLE(encKey)
        };
        // Cleanup
        (0, $38xio.clean)(...toClean);
        return res;
    }
    function _computeTag(encKey, authKey, data) {
        const tag = $2d0e1e19edfeea80$var$computeTag((0, $8wowT.polyval), true, authKey, data, AAD);
        // Compute the expected tag by XORing S_s and the nonce, clearing the
        // most significant bit of the last byte and encrypting with the
        // message-encryption key.
        for(let i = 0; i < 12; i++)tag[i] ^= nonce[i];
        tag[15] &= 0x7f; // Clear the highest bit
        // encrypt tag as block
        const t32 = (0, $38xio.u32)(tag);
        // prettier-ignore
        let s0 = t32[0], s1 = t32[1], s2 = t32[2], s3 = t32[3];
        ({ s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(encKey, s0, s1, s2, s3));
        t32[0] = s0, t32[1] = s1, t32[2] = s2, t32[3] = s3;
        return tag;
    }
    // actual decrypt/encrypt of message.
    function processSiv(encKey, tag, input) {
        let block = (0, $38xio.copyBytes)(tag);
        block[15] |= 0x80; // Force highest bit
        const res = $2d0e1e19edfeea80$var$ctr32(encKey, true, block, input);
        // Cleanup
        (0, $38xio.clean)(block);
        return res;
    }
    return {
        encrypt (plaintext) {
            PLAIN_LIMIT(plaintext.length);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const tag = _computeTag(encKey, authKey, plaintext);
            const toClean = [
                encKey,
                authKey,
                tag
            ];
            if (!(0, $38xio.isAligned32)(plaintext)) toClean.push(plaintext = (0, $38xio.copyBytes)(plaintext));
            const out = new Uint8Array(plaintext.length + tagLength);
            out.set(tag, plaintext.length);
            out.set(processSiv(encKey, tag, plaintext));
            // Cleanup
            (0, $38xio.clean)(...toClean);
            return out;
        },
        decrypt (ciphertext) {
            CIPHER_LIMIT(ciphertext.length);
            const tag = ciphertext.subarray(-tagLength);
            const { encKey: encKey, authKey: authKey } = deriveKeys();
            const toClean = [
                encKey,
                authKey
            ];
            if (!(0, $38xio.isAligned32)(ciphertext)) toClean.push(ciphertext = (0, $38xio.copyBytes)(ciphertext));
            const plaintext = processSiv(encKey, tag, ciphertext.subarray(0, -tagLength));
            const expectedTag = _computeTag(encKey, authKey, plaintext);
            toClean.push(expectedTag);
            if (!(0, $38xio.equalBytes)(tag, expectedTag)) {
                (0, $38xio.clean)(...toClean);
                throw new Error('invalid polyval tag');
            }
            // Cleanup
            (0, $38xio.clean)(...toClean);
            return plaintext;
        }
    };
});
function $2d0e1e19edfeea80$var$isBytes32(a) {
    return a instanceof Uint32Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint32Array';
}
function $2d0e1e19edfeea80$var$encryptBlock(xk, block) {
    (0, $38xio.abytes)(block, 16, 'block');
    if (!$2d0e1e19edfeea80$var$isBytes32(xk)) throw new Error('_encryptBlock accepts result of expandKeyLE');
    const b32 = (0, $38xio.u32)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
function $2d0e1e19edfeea80$var$decryptBlock(xk, block) {
    (0, $38xio.abytes)(block, 16, 'block');
    if (!$2d0e1e19edfeea80$var$isBytes32(xk)) throw new Error('_decryptBlock accepts result of expandKeyLE');
    const b32 = (0, $38xio.u32)(block);
    let { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$decrypt(xk, b32[0], b32[1], b32[2], b32[3]);
    b32[0] = s0, b32[1] = s1, b32[2] = s2, b32[3] = s3;
    return block;
}
/**
 * AES-W (base for AESKW/AESKWP).
 * Specs: [SP800-38F](https://nvlpubs.nist.gov/nistpubs/SpecialPublications/NIST.SP.800-38F.pdf),
 * [RFC 3394](https://www.rfc-editor.org/rfc/rfc3394),
 * [RFC 5649](https://www.rfc-editor.org/rfc/rfc5649).
 */ const $2d0e1e19edfeea80$var$AESW = {
    /*
    High-level pseudocode:
    ```
    A: u64 = IV
    out = []
    for (let i=0, ctr = 0; i<6; i++) {
      for (const chunk of chunks(plaintext, 8)) {
        A ^= swapEndianess(ctr++)
        [A, res] = chunks(encrypt(A || chunk), 8);
        out ||= res
      }
    }
    out = A || out
    ```
    Decrypt is the same, but reversed.
    */ encrypt (kek, out) {
        // Size is limited to 4GB, otherwise ctr will overflow and we'll need to switch to bigints.
        // If you need it larger, open an issue.
        if (out.length >= 2 ** 32) throw new Error('plaintext should be less than 4gb');
        const xk = $2d0e1e19edfeea80$var$expandKeyLE(kek);
        if (out.length === 16) $2d0e1e19edfeea80$var$encryptBlock(xk, out);
        else {
            const o32 = (0, $38xio.u32)(out);
            // prettier-ignore
            let a0 = o32[0], a1 = o32[1]; // A
            for(let j = 0, ctr = 1; j < 6; j++)for(let pos = 2; pos < o32.length; pos += 2, ctr++){
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$encrypt(xk, a0, a1, o32[pos], o32[pos + 1]);
                // A = MSB(64, B) ^ t where t = (n*j)+i
                a0 = s0, a1 = s1 ^ $2d0e1e19edfeea80$var$byteSwap(ctr), o32[pos] = s2, o32[pos + 1] = s3;
            }
            o32[0] = a0, o32[1] = a1; // out = A || out
        }
        xk.fill(0);
    },
    decrypt (kek, out) {
        if (out.length - 8 >= 2 ** 32) throw new Error('ciphertext should be less than 4gb');
        const xk = $2d0e1e19edfeea80$var$expandKeyDecLE(kek);
        const chunks = out.length / 8 - 1; // first chunk is IV
        if (chunks === 1) $2d0e1e19edfeea80$var$decryptBlock(xk, out);
        else {
            const o32 = (0, $38xio.u32)(out);
            // prettier-ignore
            let a0 = o32[0], a1 = o32[1]; // A
            for(let j = 0, ctr = chunks * 6; j < 6; j++)for(let pos = chunks * 2; pos >= 1; pos -= 2, ctr--){
                a1 ^= $2d0e1e19edfeea80$var$byteSwap(ctr);
                const { s0: s0, s1: s1, s2: s2, s3: s3 } = $2d0e1e19edfeea80$var$decrypt(xk, a0, a1, o32[pos], o32[pos + 1]);
                a0 = s0, a1 = s1, o32[pos] = s2, o32[pos + 1] = s3;
            }
            o32[0] = a0, o32[1] = a1;
        }
        xk.fill(0);
    }
};
const $2d0e1e19edfeea80$var$AESKW_IV = /* @__PURE__ */ new Uint8Array(8).fill(0xa6); // A6A6A6A6A6A6A6A6
const $2d0e1e19edfeea80$export$2d31b8efd960783 = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 8
}, (kek)=>({
        encrypt (plaintext) {
            if (!plaintext.length || plaintext.length % 8 !== 0) throw new Error('invalid plaintext length');
            if (plaintext.length === 8) throw new Error('8-byte keys not allowed in AESKW, use AESKWP instead');
            const out = (0, $38xio.concatBytes)($2d0e1e19edfeea80$var$AESKW_IV, plaintext);
            $2d0e1e19edfeea80$var$AESW.encrypt(kek, out);
            return out;
        },
        decrypt (ciphertext) {
            // ciphertext must be at least 24 bytes and a multiple of 8 bytes
            // 24 because should have at least two block (1 iv + 2).
            // Replace with 16 to enable '8-byte keys'
            if (ciphertext.length % 8 !== 0 || ciphertext.length < 24) throw new Error('invalid ciphertext length');
            const out = (0, $38xio.copyBytes)(ciphertext);
            $2d0e1e19edfeea80$var$AESW.decrypt(kek, out);
            if (!(0, $38xio.equalBytes)(out.subarray(0, 8), $2d0e1e19edfeea80$var$AESKW_IV)) throw new Error('integrity check failed');
            out.subarray(0, 8).fill(0); // ciphertext.subarray(0, 8) === IV, but we clean it anyway
            return out.subarray(8);
        }
    }));
/*
We don't support 8-byte keys. The rabbit hole:

- Wycheproof says: "NIST SP 800-38F does not define the wrapping of 8 byte keys.
  RFC 3394 Section 2  on the other hand specifies that 8 byte keys are wrapped
  by directly encrypting one block with AES."
    - https://github.com/C2SP/wycheproof/blob/master/doc/key_wrap.md
    - "RFC 3394 specifies in Section 2, that the input for the key wrap
      algorithm must be at least two blocks and otherwise the constant
      field and key are simply encrypted with ECB as a single block"
- What RFC 3394 actually says (in Section 2):
    - "Before being wrapped, the key data is parsed into n blocks of 64 bits.
      The only restriction the key wrap algorithm places on n is that n be
      at least two"
    - "For key data with length less than or equal to 64 bits, the constant
      field used in this specification and the key data form a single
      128-bit codebook input making this key wrap unnecessary."
- Which means "assert(n >= 2)" and "use something else for 8 byte keys"
- NIST SP800-38F actually prohibits 8-byte in "5.3.1 Mandatory Limits".
  It states that plaintext for KW should be "2 to 2^54 -1 semiblocks".
- So, where does "directly encrypt single block with AES" come from?
    - Not RFC 3394. Pseudocode of key wrap in 2.2 explicitly uses
      loop of 6 for any code path
    - There is a weird W3C spec:
      https://www.w3.org/TR/2002/REC-xmlenc-core-20021210/Overview.html#kw-aes128
    - This spec is outdated, as admitted by Wycheproof authors
    - There is RFC 5649 for padded key wrap, which is padding construction on
      top of AESKW. In '4.1.2' it says: "If the padded plaintext contains exactly
      eight octets, then prepend the AIV as defined in Section 3 above to P[1] and
      encrypt the resulting 128-bit block using AES in ECB mode [Modes] with key
      K (the KEK).  In this case, the output is two 64-bit blocks C[0] and C[1]:"
    - Browser subtle crypto is actually crashes on wrapping keys less than 16 bytes:
      `Error: error:1C8000E6:Provider routines::invalid input length] { opensslErrorStack: [ 'error:030000BD:digital envelope routines::update error' ]`

In the end, seems like a bug in Wycheproof.
The 8-byte check can be easily disabled inside of AES_W.
*/ const $2d0e1e19edfeea80$var$AESKWP_IV = 0xa65959a6; // single u32le value
const $2d0e1e19edfeea80$export$37b019a3c0609713 = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 8
}, (kek)=>({
        encrypt (plaintext) {
            if (!plaintext.length) throw new Error('invalid plaintext length');
            const padded = Math.ceil(plaintext.length / 8) * 8;
            const out = new Uint8Array(8 + padded);
            out.set(plaintext, 8);
            const out32 = (0, $38xio.u32)(out);
            out32[0] = $2d0e1e19edfeea80$var$AESKWP_IV;
            out32[1] = $2d0e1e19edfeea80$var$byteSwap(plaintext.length);
            $2d0e1e19edfeea80$var$AESW.encrypt(kek, out);
            return out;
        },
        decrypt (ciphertext) {
            // 16 because should have at least one block
            if (ciphertext.length < 16) throw new Error('invalid ciphertext length');
            const out = (0, $38xio.copyBytes)(ciphertext);
            const o32 = (0, $38xio.u32)(out);
            $2d0e1e19edfeea80$var$AESW.decrypt(kek, out);
            const len = $2d0e1e19edfeea80$var$byteSwap(o32[1]) >>> 0;
            const padded = Math.ceil(len / 8) * 8;
            if (o32[0] !== $2d0e1e19edfeea80$var$AESKWP_IV || out.length - 8 !== padded) throw new Error('integrity check failed');
            for(let i = len; i < padded; i++)if (out[8 + i] !== 0) throw new Error('integrity check failed');
            out.subarray(0, 8).fill(0); // ciphertext.subarray(0, 8) === IV, but we clean it anyway
            return out.subarray(8, 8 + len);
        }
    }));
class $2d0e1e19edfeea80$var$_AesCtrDRBG {
    blockLen;
    key;
    nonce;
    state;
    reseedCnt;
    constructor(keyLen, seed, personalization){
        this.blockLen = $2d0e1e19edfeea80$export$5f70e4be40e1a294.blockSize;
        const keyLenBytes = keyLen / 8;
        const nonceLen = 16;
        this.state = new Uint8Array(keyLenBytes + nonceLen);
        this.key = this.state.subarray(0, keyLenBytes);
        this.nonce = this.state.subarray(keyLenBytes, keyLenBytes + nonceLen);
        this.reseedCnt = 1;
        $2d0e1e19edfeea80$var$incBytes(this.nonce, false, 1);
        this.addEntropy(seed, personalization);
    }
    update(data) {
        // cannot re-use state here, because we will wipe current key
        $2d0e1e19edfeea80$export$5f70e4be40e1a294(this.key, this.nonce).encrypt(new Uint8Array(this.state.length), this.state);
        if (data) {
            (0, $38xio.abytes)(data);
            for(let i = 0; i < data.length; i++)this.state[i] ^= data[i];
        }
        $2d0e1e19edfeea80$var$incBytes(this.nonce, false, 1);
    }
    addEntropy(seed, info) {
        (0, $38xio.abytes)(seed, this.state.length, 'seed');
        const _seed = seed.slice();
        if (info) {
            (0, $38xio.abytes)(info);
            if (info.length > _seed.length) throw new Error('info length is too big');
            for(let i = 0; i < info.length; i++)_seed[i] ^= info[i];
        }
        this.update(_seed);
        _seed.fill(0);
        this.reseedCnt = 1;
    }
    randomBytes(len, info) {
        (0, $38xio.anumber)(len);
        if (this.reseedCnt++ >= 2 ** 48) throw new Error('entropy exhausted');
        if (info) this.update(info);
        const res = new Uint8Array(len);
        $2d0e1e19edfeea80$export$5f70e4be40e1a294(this.key, this.nonce).encrypt(res, res);
        $2d0e1e19edfeea80$var$incBytes(this.nonce, false, Math.ceil(len / this.blockLen));
        this.update(info);
        return res;
    }
    clean() {
        this.state.fill(0);
        this.reseedCnt = 0;
    }
}
const $2d0e1e19edfeea80$var$createAesDrbg = (keyLen)=>{
    return (seed, personalization)=>new $2d0e1e19edfeea80$var$_AesCtrDRBG(keyLen, seed, personalization);
};
const $2d0e1e19edfeea80$export$7e150c368c9a2f72 = /* @__PURE__ */ $2d0e1e19edfeea80$var$createAesDrbg(128);
const $2d0e1e19edfeea80$export$9ea933847dda7524 = /* @__PURE__ */ $2d0e1e19edfeea80$var$createAesDrbg(256);
//#region CMAC
/**
 * Left-shift by one bit and conditionally XOR with 0x87:
 * ```
 * if MSB(L) is equal to 0
 * then    K1 := L << 1;
 * else    K1 := (L << 1) XOR const_Rb;
 * ```
 *
 * Specs: [RFC 4493, Section 2.3](https://www.rfc-editor.org/rfc/rfc4493.html#section-2.3),
 *        [RFC 5297 Section 2.3](https://datatracker.ietf.org/doc/html/rfc5297.html#section-2.3)
 *
 * @returns modified `block` (for chaining)
 */ function $2d0e1e19edfeea80$var$dbl(block) {
    let carry = 0;
    // Left shift by 1 bit
    for(let i = $2d0e1e19edfeea80$var$BLOCK_SIZE - 1; i >= 0; i--){
        const newCarry = (block[i] & 0x80) >>> 7;
        block[i] = block[i] << 1 | carry;
        carry = newCarry;
    }
    // XOR with 0x87 if there was a carry from the most significant bit
    if (carry) block[$2d0e1e19edfeea80$var$BLOCK_SIZE - 1] ^= 0x87;
    return block;
}
/**
 * `a XOR b`, running in-site on `a`.
 * @param a left operand and output
 * @param b right operand
 * @returns `a` (for chaining)
 */ function $2d0e1e19edfeea80$var$xorBlock(a, b) {
    if (a.length !== b.length) throw new Error('xorBlock: blocks must have same length');
    for(let i = 0; i < a.length; i++)a[i] = a[i] ^ b[i];
    return a;
}
/**
 * xorend as defined in [RFC 5297 Section 2.1](https://datatracker.ietf.org/doc/html/rfc5297.html#section-2.1).
 *
 * ```
 * leftmost(A, len(A)-len(B)) || (rightmost(A, len(B)) xor B)
 * ```
 */ function $2d0e1e19edfeea80$var$xorend(a, b) {
    if (b.length > a.length) throw new Error('xorend: len(B) must be less than or equal to len(A)');
    // keep leftmost part of `a` unchanged
    // and xor only the rightmost part:
    const offset = a.length - b.length;
    for(let i = 0; i < b.length; i++)a[offset + i] = a[offset + i] ^ b[i];
    return a;
}
/**
 * Internal CMAC class.
 */ class $2d0e1e19edfeea80$var$_CMAC {
    buffer;
    destroyed;
    k1;
    k2;
    xk;
    constructor(key){
        (0, $38xio.abytes)(key);
        $2d0e1e19edfeea80$var$validateKeyLength(key);
        this.xk = $2d0e1e19edfeea80$var$expandKeyLE(key);
        this.buffer = new Uint8Array(0);
        this.destroyed = false;
        // L = AES_encrypt(K, const_Zero)
        const L = new Uint8Array($2d0e1e19edfeea80$var$BLOCK_SIZE);
        $2d0e1e19edfeea80$var$encryptBlock(this.xk, L);
        // Generate subkeys K1 and K2 from the main key according to
        // [RFC 4493, Section 2.3](https://www.rfc-editor.org/rfc/rfc4493.html#section-2.3)
        // K1
        this.k1 = $2d0e1e19edfeea80$var$dbl(L);
        this.k2 = $2d0e1e19edfeea80$var$dbl(new Uint8Array(this.k1));
    }
    update(data) {
        const { destroyed: destroyed, buffer: buffer } = this;
        if (destroyed) throw new Error('CMAC instance was destroyed');
        (0, $38xio.abytes)(data);
        const newBuffer = new Uint8Array(buffer.length + data.length);
        newBuffer.set(buffer);
        newBuffer.set(data, buffer.length);
        this.buffer = newBuffer;
        return this;
    }
    // see https://www.rfc-editor.org/rfc/rfc4493.html#section-2.4
    digest() {
        if (this.destroyed) throw new Error('CMAC instance was destroyed');
        const { buffer: buffer } = this;
        const msgLen = buffer.length;
        // Step 2:
        let n = Math.ceil(msgLen / $2d0e1e19edfeea80$var$BLOCK_SIZE); // n := ceil(len/const_Bsize);
        // Step 3:
        let flag; // denoting if last block is complete or not
        if (n === 0) {
            n = 1;
            flag = false;
        } else flag = msgLen % $2d0e1e19edfeea80$var$BLOCK_SIZE === 0; // if len mod const_Bsize is 0
        // Step 4:
        const lastBlockStart = (n - 1) * $2d0e1e19edfeea80$var$BLOCK_SIZE;
        const lastBlockData = buffer.subarray(lastBlockStart);
        let m_last;
        if (flag) // M_last := M_n XOR K1;
        m_last = $2d0e1e19edfeea80$var$xorBlock(new Uint8Array(lastBlockData), this.k1);
        else {
            // M_last := padding(M_n) XOR K2;
            //
            // [...] padding(x) is the concatenation of x and a single '1',
            // followed by the minimum number of '0's, so that the total length is
            // equal to 128 bits.
            const padded = new Uint8Array($2d0e1e19edfeea80$var$BLOCK_SIZE);
            padded.set(lastBlockData);
            padded[lastBlockData.length] = 0x80; // single '1' bit
            m_last = $2d0e1e19edfeea80$var$xorBlock(padded, this.k2);
        }
        // Step 5:
        let x = new Uint8Array($2d0e1e19edfeea80$var$BLOCK_SIZE); // X := const_Zero;
        // Step 6:
        for(let i = 0; i < n - 1; i++){
            const m_i = buffer.subarray(i * $2d0e1e19edfeea80$var$BLOCK_SIZE, (i + 1) * $2d0e1e19edfeea80$var$BLOCK_SIZE); // M_i
            $2d0e1e19edfeea80$var$xorBlock(x, m_i); // Y := X XOR M_i;
            $2d0e1e19edfeea80$var$encryptBlock(this.xk, x); // X := AES-128(K,Y);
        }
        // Step 7:
        $2d0e1e19edfeea80$var$xorBlock(x, m_last); // Y := M_last XOR X;
        $2d0e1e19edfeea80$var$encryptBlock(this.xk, x); // T := AES-128(K,Y);
        // cleanup:
        (0, $38xio.clean)(m_last);
        return x; // T
    }
    destroy() {
        const { buffer: buffer, destroyed: destroyed, xk: xk, k1: k1, k2: k2 } = this;
        if (destroyed) return;
        this.destroyed = true;
        (0, $38xio.clean)(buffer, xk, k1, k2);
    }
}
const $2d0e1e19edfeea80$export$cc5a1ecb29fae6e1 = (key, message)=>new $2d0e1e19edfeea80$var$_CMAC(key).update(message).digest();
$2d0e1e19edfeea80$export$cc5a1ecb29fae6e1.create = (key)=>new $2d0e1e19edfeea80$var$_CMAC(key);
/**
 * S2V (Synthetic Initialization Vector) function as described in [RFC 5297 Section 2.4](https://datatracker.ietf.org/doc/html/rfc5297.html#section-2.4).
 *
 * ```
 * S2V(K, S1, ..., Sn) {
 *   if n = 0 then
 *     return V = AES-CMAC(K, <one>)
 *   fi
 *   D = AES-CMAC(K, <zero>)
 *   for i = 1 to n-1 do
 *     D = dbl(D) xor AES-CMAC(K, Si)
 *   done
 *   if len(Sn) >= 128 then
 *     T = Sn xorend D
 *   else
 *     T = dbl(D) xor pad(Sn)
 *   fi
 *   return V = AES-CMAC(K, T)
 * }
 * ```
 *
 * S2V takes a key and a vector of strings S1, S2, ..., Sn and returns a 128-bit string.
 * The S2V function is used to generate a synthetic IV for AES-SIV.
 *
 * @param key - AES key (128, 192, or 256 bits)
 * @param strings - Array of byte arrays to process
 * @returns 128-bit synthetic IV
 */ function $2d0e1e19edfeea80$var$s2v(key, strings) {
    $2d0e1e19edfeea80$var$validateKeyLength(key);
    const len = strings.length;
    if (len > 127) // see https://datatracker.ietf.org/doc/html/rfc5297.html#section-7
    throw new Error('s2v: number of input strings must be less than or equal to 127');
    if (len === 0) return $2d0e1e19edfeea80$export$cc5a1ecb29fae6e1(key, $2d0e1e19edfeea80$var$ONE_BLOCK);
    // D = AES-CMAC(K, <zero>)
    let d = $2d0e1e19edfeea80$export$cc5a1ecb29fae6e1(key, $2d0e1e19edfeea80$var$EMPTY_BLOCK);
    // for i = 1 to n-1 do
    //   D = dbl(D) xor AES-CMAC(K, Si)
    for(let i = 0; i < len - 1; i++){
        $2d0e1e19edfeea80$var$dbl(d);
        const cmacResult = $2d0e1e19edfeea80$export$cc5a1ecb29fae6e1(key, strings[i]);
        $2d0e1e19edfeea80$var$xorBlock(d, cmacResult);
        (0, $38xio.clean)(cmacResult);
    }
    const s_n = strings[len - 1];
    let t;
    // if len(Sn) >= 128 then
    if (s_n.byteLength >= $2d0e1e19edfeea80$var$BLOCK_SIZE) // T = Sn xorend D
    t = $2d0e1e19edfeea80$var$xorend(Uint8Array.from(s_n), d);
    else {
        // pad(Sn):
        const paddedSn = new Uint8Array($2d0e1e19edfeea80$var$BLOCK_SIZE);
        paddedSn.set(s_n);
        paddedSn[s_n.length] = 0x80; // padding: 0x80 followed by zeros
        // T = dbl(D) xor pad(Sn)
        t = $2d0e1e19edfeea80$var$xorBlock($2d0e1e19edfeea80$var$dbl(d), paddedSn);
        (0, $38xio.clean)(paddedSn);
    }
    // V = AES-CMAC(K, T)
    const result = $2d0e1e19edfeea80$export$cc5a1ecb29fae6e1(key, t);
    (0, $38xio.clean)(d, t);
    return result;
}
const $2d0e1e19edfeea80$export$f45e8835a0f9974d = ()=>{
    throw new Error('"siv" from v1 is now "gcmsiv"');
};
const $2d0e1e19edfeea80$export$a7912347cfd65d14 = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 16,
    tagLength: 16
}, function aessiv(key, ...AAD) {
    // From RFC 5297: Section 6.1, 6.2, 6.3:
    const PLAIN_LIMIT = $2d0e1e19edfeea80$var$limit('plaintext', 0, 2 ** 132);
    const CIPHER_LIMIT = $2d0e1e19edfeea80$var$limit('ciphertext', 16, 2 ** 132 + 16);
    if (AAD.length > 126) // see https://datatracker.ietf.org/doc/html/rfc5297.html#section-7
    throw new Error('"AAD" number of elements must be less than or equal to 126');
    AAD.forEach((aad)=>(0, $38xio.abytes)(aad));
    (0, $38xio.abytes)(key);
    if (![
        32,
        48,
        64
    ].includes(key.length)) throw new Error('"aes key" expected Uint8Array of length 32/48/64, got length=' + key.length);
    // The key is split into equal halves, K1 = leftmost(K, len(K)/2) and
    // K2 = rightmost(K, len(K)/2).  K1 is used for S2V and K2 is used for CTR.
    const k1 = key.subarray(0, key.length / 2);
    const k2 = key.subarray(key.length / 2);
    return {
        // https://datatracker.ietf.org/doc/html/rfc5297.html#section-2.6
        encrypt (plaintext) {
            PLAIN_LIMIT(plaintext.length);
            const v = $2d0e1e19edfeea80$var$s2v(k1, [
                ...AAD,
                plaintext
            ]);
            // clear out the 31st and 63rd (rightmost) bit:
            const q = Uint8Array.from(v);
            q[8] &= 0x7f;
            q[12] &= 0x7f;
            // encrypt:
            const c = $2d0e1e19edfeea80$export$5f70e4be40e1a294(k2, q).encrypt(plaintext);
            return (0, $38xio.concatBytes)(v, c);
        },
        // https://datatracker.ietf.org/doc/html/rfc5297.html#section-2.7
        decrypt (ciphertext) {
            CIPHER_LIMIT(ciphertext.length);
            const v = ciphertext.subarray(0, $2d0e1e19edfeea80$var$BLOCK_SIZE);
            const c = ciphertext.subarray($2d0e1e19edfeea80$var$BLOCK_SIZE);
            // clear out the 31st and 63rd (rightmost) bit:
            const q = Uint8Array.from(v);
            q[8] &= 0x7f;
            q[12] &= 0x7f;
            // decrypt:
            const p = $2d0e1e19edfeea80$export$5f70e4be40e1a294(k2, q).decrypt(c);
            // verify tag:
            const t = $2d0e1e19edfeea80$var$s2v(k1, [
                ...AAD,
                p
            ]);
            if ((0, $38xio.equalBytes)(t, v)) return p;
            else throw new Error('invalid siv tag');
        }
    };
});
const $2d0e1e19edfeea80$export$aa1c11b655786597 = {
    expandKeyLE: $2d0e1e19edfeea80$var$expandKeyLE,
    expandKeyDecLE: $2d0e1e19edfeea80$var$expandKeyDecLE,
    encrypt: $2d0e1e19edfeea80$var$encrypt,
    decrypt: $2d0e1e19edfeea80$var$decrypt,
    encryptBlock: $2d0e1e19edfeea80$var$encryptBlock,
    decryptBlock: $2d0e1e19edfeea80$var$decryptBlock,
    ctrCounter: $2d0e1e19edfeea80$var$ctrCounter,
    ctr32: $2d0e1e19edfeea80$var$ctr32,
    dbl: $2d0e1e19edfeea80$var$dbl,
    xorBlock: $2d0e1e19edfeea80$var$xorBlock,
    xorend: $2d0e1e19edfeea80$var$xorend,
    s2v: $2d0e1e19edfeea80$var$s2v
};

});
parcelRegister("8wowT", function(module, exports) {

$parcel$export(module.exports, "ghash", () => $634456ee3058786c$export$f562b99c67f83a33);
$parcel$export(module.exports, "polyval", () => $634456ee3058786c$export$4dd5f33d13f59946);
/**
 * GHash from AES-GCM and its little-endian "mirror image" Polyval from AES-SIV.
 *
 * Implemented in terms of GHash with conversion function for keys
 * GCM GHASH from
 * [NIST SP800-38d](https://nvlpubs.nist.gov/nistpubs/Legacy/SP/nistspecialpublication800-38d.pdf),
 * SIV from
 * [RFC 8452](https://www.rfc-editor.org/rfc/rfc8452).
 *
 * GHASH   modulo: x^128 + x^7   + x^2   + x     + 1
 * POLYVAL modulo: x^128 + x^127 + x^126 + x^121 + 1
 *
 * @module
 */ 
var $38xio = parcelRequire("38xio");
const $634456ee3058786c$var$BLOCK_SIZE = 16;
// TODO: rewrite
// temporary padding buffer
const $634456ee3058786c$var$ZEROS16 = /* @__PURE__ */ new Uint8Array(16);
const $634456ee3058786c$var$ZEROS32 = (0, $38xio.u32)($634456ee3058786c$var$ZEROS16);
const $634456ee3058786c$var$POLY = 0xe1; // v = 2*v % POLY
// v = 2*v % POLY
// NOTE: because x + x = 0 (add/sub is same), mul2(x) != x+x
// We can multiply any number using montgomery ladder and this function (works as double, add is simple xor)
const $634456ee3058786c$var$mul2 = (s0, s1, s2, s3)=>{
    const hiBit = s3 & 1;
    return {
        s3: s2 << 31 | s3 >>> 1,
        s2: s1 << 31 | s2 >>> 1,
        s1: s0 << 31 | s1 >>> 1,
        s0: s0 >>> 1 ^ $634456ee3058786c$var$POLY << 24 & -(hiBit & 1)
    };
};
const $634456ee3058786c$var$swapLE = (n)=>(n >>> 0 & 0xff) << 24 | (n >>> 8 & 0xff) << 16 | (n >>> 16 & 0xff) << 8 | n >>> 24 & 0xff | 0;
function $634456ee3058786c$export$9517f61de5da9b07(k) {
    k.reverse();
    const hiBit = k[15] & 1;
    // k >>= 1
    let carry = 0;
    for(let i = 0; i < k.length; i++){
        const t = k[i];
        k[i] = t >>> 1 | carry;
        carry = (t & 1) << 7;
    }
    k[0] ^= -hiBit & 0xe1; // if (hiBit) n ^= 0xe1000000000000000000000000000000;
    return k;
}
const $634456ee3058786c$var$estimateWindow = (bytes)=>{
    if (bytes > 65536) return 8;
    if (bytes > 1024) return 4;
    return 2;
};
class $634456ee3058786c$export$e2912953303bb544 {
    blockLen = $634456ee3058786c$var$BLOCK_SIZE;
    outputLen = $634456ee3058786c$var$BLOCK_SIZE;
    s0 = 0;
    s1 = 0;
    s2 = 0;
    s3 = 0;
    finished = false;
    t;
    W;
    windowSize;
    // We select bits per window adaptively based on expectedLength
    constructor(key, expectedLength){
        (0, $38xio.abytes)(key, 16, 'key');
        key = (0, $38xio.copyBytes)(key);
        const kView = (0, $38xio.createView)(key);
        let k0 = kView.getUint32(0, false);
        let k1 = kView.getUint32(4, false);
        let k2 = kView.getUint32(8, false);
        let k3 = kView.getUint32(12, false);
        // generate table of doubled keys (half of montgomery ladder)
        const doubles = [];
        for(let i = 0; i < 128; i++){
            doubles.push({
                s0: $634456ee3058786c$var$swapLE(k0),
                s1: $634456ee3058786c$var$swapLE(k1),
                s2: $634456ee3058786c$var$swapLE(k2),
                s3: $634456ee3058786c$var$swapLE(k3)
            });
            ({ s0: k0, s1: k1, s2: k2, s3: k3 } = $634456ee3058786c$var$mul2(k0, k1, k2, k3));
        }
        const W = $634456ee3058786c$var$estimateWindow(expectedLength || 1024);
        if (![
            1,
            2,
            4,
            8
        ].includes(W)) throw new Error('ghash: invalid window size, expected 2, 4 or 8');
        this.W = W;
        const bits = 128; // always 128 bits;
        const windows = bits / W;
        const windowSize = this.windowSize = 2 ** W;
        const items = [];
        // Create precompute table for window of W bits
        for(let w = 0; w < windows; w++)// truth table: 00, 01, 10, 11
        for(let byte = 0; byte < windowSize; byte++){
            // prettier-ignore
            let s0 = 0, s1 = 0, s2 = 0, s3 = 0;
            for(let j = 0; j < W; j++){
                const bit = byte >>> W - j - 1 & 1;
                if (!bit) continue;
                const { s0: d0, s1: d1, s2: d2, s3: d3 } = doubles[W * w + j];
                s0 ^= d0, s1 ^= d1, s2 ^= d2, s3 ^= d3;
            }
            items.push({
                s0: s0,
                s1: s1,
                s2: s2,
                s3: s3
            });
        }
        this.t = items;
    }
    _updateBlock(s0, s1, s2, s3) {
        s0 ^= this.s0, s1 ^= this.s1, s2 ^= this.s2, s3 ^= this.s3;
        const { W: W, t: t, windowSize: windowSize } = this;
        // prettier-ignore
        let o0 = 0, o1 = 0, o2 = 0, o3 = 0;
        const mask = (1 << W) - 1; // 2**W will kill performance.
        let w = 0;
        for (const num of [
            s0,
            s1,
            s2,
            s3
        ])for(let bytePos = 0; bytePos < 4; bytePos++){
            const byte = num >>> 8 * bytePos & 0xff;
            for(let bitPos = 8 / W - 1; bitPos >= 0; bitPos--){
                const bit = byte >>> W * bitPos & mask;
                const { s0: e0, s1: e1, s2: e2, s3: e3 } = t[w * windowSize + bit];
                o0 ^= e0, o1 ^= e1, o2 ^= e2, o3 ^= e3;
                w += 1;
            }
        }
        this.s0 = o0;
        this.s1 = o1;
        this.s2 = o2;
        this.s3 = o3;
    }
    update(data) {
        (0, $38xio.aexists)(this);
        (0, $38xio.abytes)(data);
        data = (0, $38xio.copyBytes)(data);
        const b32 = (0, $38xio.u32)(data);
        const blocks = Math.floor(data.length / $634456ee3058786c$var$BLOCK_SIZE);
        const left = data.length % $634456ee3058786c$var$BLOCK_SIZE;
        for(let i = 0; i < blocks; i++)this._updateBlock(b32[i * 4 + 0], b32[i * 4 + 1], b32[i * 4 + 2], b32[i * 4 + 3]);
        if (left) {
            $634456ee3058786c$var$ZEROS16.set(data.subarray(blocks * $634456ee3058786c$var$BLOCK_SIZE));
            this._updateBlock($634456ee3058786c$var$ZEROS32[0], $634456ee3058786c$var$ZEROS32[1], $634456ee3058786c$var$ZEROS32[2], $634456ee3058786c$var$ZEROS32[3]);
            (0, $38xio.clean)($634456ee3058786c$var$ZEROS32); // clean tmp buffer
        }
        return this;
    }
    destroy() {
        const { t: t } = this;
        // clean precompute table
        for (const elm of t)elm.s0 = 0, elm.s1 = 0, elm.s2 = 0, elm.s3 = 0;
    }
    digestInto(out) {
        (0, $38xio.aexists)(this);
        (0, $38xio.aoutput)(out, this);
        this.finished = true;
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $38xio.u32)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out;
    }
    digest() {
        const res = new Uint8Array($634456ee3058786c$var$BLOCK_SIZE);
        this.digestInto(res);
        this.destroy();
        return res;
    }
}
class $634456ee3058786c$export$63a93cc1afc0351d extends $634456ee3058786c$export$e2912953303bb544 {
    constructor(key, expectedLength){
        (0, $38xio.abytes)(key);
        const ghKey = $634456ee3058786c$export$9517f61de5da9b07((0, $38xio.copyBytes)(key));
        super(ghKey, expectedLength);
        (0, $38xio.clean)(ghKey);
    }
    update(data) {
        (0, $38xio.aexists)(this);
        (0, $38xio.abytes)(data);
        data = (0, $38xio.copyBytes)(data);
        const b32 = (0, $38xio.u32)(data);
        const left = data.length % $634456ee3058786c$var$BLOCK_SIZE;
        const blocks = Math.floor(data.length / $634456ee3058786c$var$BLOCK_SIZE);
        for(let i = 0; i < blocks; i++)this._updateBlock($634456ee3058786c$var$swapLE(b32[i * 4 + 3]), $634456ee3058786c$var$swapLE(b32[i * 4 + 2]), $634456ee3058786c$var$swapLE(b32[i * 4 + 1]), $634456ee3058786c$var$swapLE(b32[i * 4 + 0]));
        if (left) {
            $634456ee3058786c$var$ZEROS16.set(data.subarray(blocks * $634456ee3058786c$var$BLOCK_SIZE));
            this._updateBlock($634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[3]), $634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[2]), $634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[1]), $634456ee3058786c$var$swapLE($634456ee3058786c$var$ZEROS32[0]));
            (0, $38xio.clean)($634456ee3058786c$var$ZEROS32);
        }
        return this;
    }
    digestInto(out) {
        (0, $38xio.aexists)(this);
        (0, $38xio.aoutput)(out, this);
        this.finished = true;
        // tmp ugly hack
        const { s0: s0, s1: s1, s2: s2, s3: s3 } = this;
        const o32 = (0, $38xio.u32)(out);
        o32[0] = s0;
        o32[1] = s1;
        o32[2] = s2;
        o32[3] = s3;
        return out.reverse();
    }
}
function $634456ee3058786c$var$wrapConstructorWithKey(hashCons) {
    const hashC = (msg, key)=>hashCons(key, msg.length).update(msg).digest();
    const tmp = hashCons(new Uint8Array(16), 0);
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (key, expectedLength)=>hashCons(key, expectedLength);
    return hashC;
}
const $634456ee3058786c$export$f562b99c67f83a33 = $634456ee3058786c$var$wrapConstructorWithKey((key, expectedLength)=>new $634456ee3058786c$export$e2912953303bb544(key, expectedLength));
const $634456ee3058786c$export$4dd5f33d13f59946 = $634456ee3058786c$var$wrapConstructorWithKey((key, expectedLength)=>new $634456ee3058786c$export$63a93cc1afc0351d(key, expectedLength));

});
parcelRegister("38xio", function(module, exports) {

$parcel$export(module.exports, "abool", () => $248bf24903c02b9f$export$809304d28d77d92d);
$parcel$export(module.exports, "anumber", () => $248bf24903c02b9f$export$75364c6cb16d43b6);
$parcel$export(module.exports, "abytes", () => $248bf24903c02b9f$export$e8a750b9efad93f5);
$parcel$export(module.exports, "aexists", () => $248bf24903c02b9f$export$20871f6b1d047d77);
$parcel$export(module.exports, "aoutput", () => $248bf24903c02b9f$export$e8e53abee12b995e);
$parcel$export(module.exports, "u8", () => $248bf24903c02b9f$export$9813fca58c0b9f71);
$parcel$export(module.exports, "u32", () => $248bf24903c02b9f$export$8bacf4ad828c7fe7);
$parcel$export(module.exports, "clean", () => $248bf24903c02b9f$export$cf0b2a6c63f9e656);
$parcel$export(module.exports, "createView", () => $248bf24903c02b9f$export$d7febe7b891e79f0);
$parcel$export(module.exports, "bytesToHex", () => $248bf24903c02b9f$export$58b867e287a802c8);
$parcel$export(module.exports, "hexToNumber", () => $248bf24903c02b9f$export$d57f2bacc26b4249);
$parcel$export(module.exports, "numberToBytesBE", () => $248bf24903c02b9f$export$1459dafd057611cb);
$parcel$export(module.exports, "overlapBytes", () => $248bf24903c02b9f$export$8a4fd82309bf1d6a);
$parcel$export(module.exports, "complexOverlapBytes", () => $248bf24903c02b9f$export$8ee902273e96266b);
$parcel$export(module.exports, "concatBytes", () => $248bf24903c02b9f$export$287dd7971339c972);
$parcel$export(module.exports, "checkOpts", () => $248bf24903c02b9f$export$6fcee72895eceb1e);
$parcel$export(module.exports, "equalBytes", () => $248bf24903c02b9f$export$2aa59cef064b0333);
$parcel$export(module.exports, "wrapCipher", () => $248bf24903c02b9f$export$9a6138f9eba70f82);
$parcel$export(module.exports, "getOutput", () => $248bf24903c02b9f$export$e504884fb8831d9d);
$parcel$export(module.exports, "isAligned32", () => $248bf24903c02b9f$export$c50aefb83d1cf2a2);
$parcel$export(module.exports, "u64Lengths", () => $248bf24903c02b9f$export$342c09f6517ae3b8);
$parcel$export(module.exports, "copyBytes", () => $248bf24903c02b9f$export$56728fb2d7dba34e);
$parcel$export(module.exports, "randomBytes", () => $248bf24903c02b9f$export$5f828d93ff035aa8);
/**
 * Utilities for hex, bytes, CSPRNG.
 * @module
 */ /*! noble-ciphers - MIT License (c) 2023 Paul Miller (paulmillr.com) */ /** Checks if something is Uint8Array. Be careful: nodejs Buffer will return true. */ function $248bf24903c02b9f$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || ArrayBuffer.isView(a) && a.constructor.name === 'Uint8Array';
}
function $248bf24903c02b9f$export$809304d28d77d92d(b) {
    if (typeof b !== 'boolean') throw new Error(`boolean expected, not ${b}`);
}
function $248bf24903c02b9f$export$75364c6cb16d43b6(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error('positive integer expected, got ' + n);
}
function $248bf24903c02b9f$export$e8a750b9efad93f5(value, length, title = '') {
    const bytes = $248bf24903c02b9f$export$c6fabfbfd097fc30(value);
    const len = value?.length;
    const needsLen = length !== undefined;
    if (!bytes || needsLen && len !== length) {
        const prefix = title && `"${title}" `;
        const ofLen = needsLen ? ` of length ${length}` : '';
        const got = bytes ? `length=${len}` : `type=${typeof value}`;
        throw new Error(prefix + 'expected Uint8Array' + ofLen + ', got ' + got);
    }
    return value;
}
function $248bf24903c02b9f$export$20871f6b1d047d77(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error('Hash instance has been destroyed');
    if (checkFinished && instance.finished) throw new Error('Hash#digest() has already been called');
}
function $248bf24903c02b9f$export$e8e53abee12b995e(out, instance) {
    $248bf24903c02b9f$export$e8a750b9efad93f5(out, undefined, 'output');
    const min = instance.outputLen;
    if (out.length < min) throw new Error('digestInto() expects output buffer of length at least ' + min);
}
function $248bf24903c02b9f$export$9813fca58c0b9f71(arr) {
    return new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
}
function $248bf24903c02b9f$export$8bacf4ad828c7fe7(arr) {
    return new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
}
function $248bf24903c02b9f$export$cf0b2a6c63f9e656(...arrays) {
    for(let i = 0; i < arrays.length; i++)arrays[i].fill(0);
}
function $248bf24903c02b9f$export$d7febe7b891e79f0(arr) {
    return new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
}
const $248bf24903c02b9f$export$a0f88e38d4cf9577 = /* @__PURE__ */ (()=>new Uint8Array(new Uint32Array([
        0x11223344
    ]).buffer)[0] === 0x44)();
// Built-in hex conversion https://caniuse.com/mdn-javascript_builtins_uint8array_fromhex
const $248bf24903c02b9f$var$hasHexBuiltin = /* @__PURE__ */ (()=>// @ts-ignore
    typeof Uint8Array.from([]).toHex === 'function' && typeof Uint8Array.fromHex === 'function')();
// Array where index 0xf0 (240) is mapped to string 'f0'
const $248bf24903c02b9f$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, '0'));
function $248bf24903c02b9f$export$58b867e287a802c8(bytes) {
    $248bf24903c02b9f$export$e8a750b9efad93f5(bytes);
    // @ts-ignore
    if ($248bf24903c02b9f$var$hasHexBuiltin) return bytes.toHex();
    // pre-caching improves the speed 6x
    let hex = '';
    for(let i = 0; i < bytes.length; i++)hex += $248bf24903c02b9f$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $248bf24903c02b9f$var$asciis = {
    _0: 48,
    _9: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $248bf24903c02b9f$var$asciiToBase16(ch) {
    if (ch >= $248bf24903c02b9f$var$asciis._0 && ch <= $248bf24903c02b9f$var$asciis._9) return ch - $248bf24903c02b9f$var$asciis._0; // '2' => 50-48
    if (ch >= $248bf24903c02b9f$var$asciis.A && ch <= $248bf24903c02b9f$var$asciis.F) return ch - ($248bf24903c02b9f$var$asciis.A - 10); // 'B' => 66-(65-10)
    if (ch >= $248bf24903c02b9f$var$asciis.a && ch <= $248bf24903c02b9f$var$asciis.f) return ch - ($248bf24903c02b9f$var$asciis.a - 10); // 'b' => 98-(97-10)
    return;
}
function $248bf24903c02b9f$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    // @ts-ignore
    if ($248bf24903c02b9f$var$hasHexBuiltin) return Uint8Array.fromHex(hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error('hex string expected, got unpadded hex of length ' + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $248bf24903c02b9f$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $248bf24903c02b9f$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2; // multiply first octet, e.g. 'a3' => 10*16+3 => 160 + 3 => 163
    }
    return array;
}
function $248bf24903c02b9f$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== 'string') throw new Error('hex string expected, got ' + typeof hex);
    return BigInt(hex === '' ? '0' : '0x' + hex); // Big Endian
}
function $248bf24903c02b9f$export$d609354794974f8(bytes) {
    return $248bf24903c02b9f$export$d57f2bacc26b4249($248bf24903c02b9f$export$58b867e287a802c8(bytes));
}
function $248bf24903c02b9f$export$1459dafd057611cb(n, len) {
    return $248bf24903c02b9f$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, '0'));
}
function $248bf24903c02b9f$export$3df70a15530b5e81(str) {
    if (typeof str !== 'string') throw new Error('string expected');
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $248bf24903c02b9f$export$5f46301b4a1d43db(bytes) {
    return new TextDecoder().decode(bytes);
}
function $248bf24903c02b9f$export$8a4fd82309bf1d6a(a, b) {
    return a.buffer === b.buffer && // best we can do, may fail with an obscure Proxy
    a.byteOffset < b.byteOffset + b.byteLength && // a starts before b end
    b.byteOffset < a.byteOffset + a.byteLength // b starts before a end
    ;
}
function $248bf24903c02b9f$export$8ee902273e96266b(input, output) {
    // This is very cursed. It works somehow, but I'm completely unsure,
    // reasoning about overlapping aligned windows is very hard.
    if ($248bf24903c02b9f$export$8a4fd82309bf1d6a(input, output) && input.byteOffset < output.byteOffset) throw new Error('complex overlap of input and output is not supported');
}
function $248bf24903c02b9f$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $248bf24903c02b9f$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $248bf24903c02b9f$export$6fcee72895eceb1e(defaults, opts) {
    if (opts == null || typeof opts !== 'object') throw new Error('options must be defined');
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $248bf24903c02b9f$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
const $248bf24903c02b9f$export$9a6138f9eba70f82 = (params, constructor)=>{
    function wrappedCipher(key, ...args) {
        // Validate key
        $248bf24903c02b9f$export$e8a750b9efad93f5(key, undefined, 'key');
        // Big-Endian hardware is rare. Just in case someone still decides to run ciphers:
        if (!$248bf24903c02b9f$export$a0f88e38d4cf9577) throw new Error('Non little-endian hardware is not yet supported');
        // Validate nonce if nonceLength is present
        if (params.nonceLength !== undefined) {
            const nonce = args[0];
            $248bf24903c02b9f$export$e8a750b9efad93f5(nonce, params.varSizeNonce ? undefined : params.nonceLength, 'nonce');
        }
        // Validate AAD if tagLength present
        const tagl = params.tagLength;
        if (tagl && args[1] !== undefined) $248bf24903c02b9f$export$e8a750b9efad93f5(args[1], undefined, 'AAD');
        const cipher = constructor(key, ...args);
        const checkOutput = (fnLength, output)=>{
            if (output !== undefined) {
                if (fnLength !== 2) throw new Error('cipher output not supported');
                $248bf24903c02b9f$export$e8a750b9efad93f5(output, undefined, 'output');
            }
        };
        // Create wrapped cipher with validation and single-use encryption
        let called = false;
        const wrCipher = {
            encrypt (data, output) {
                if (called) throw new Error('cannot encrypt() twice with same key + nonce');
                called = true;
                $248bf24903c02b9f$export$e8a750b9efad93f5(data);
                checkOutput(cipher.encrypt.length, output);
                return cipher.encrypt(data, output);
            },
            decrypt (data, output) {
                $248bf24903c02b9f$export$e8a750b9efad93f5(data);
                if (tagl && data.length < tagl) throw new Error('"ciphertext" expected length bigger than tagLength=' + tagl);
                checkOutput(cipher.decrypt.length, output);
                return cipher.decrypt(data, output);
            }
        };
        return wrCipher;
    }
    Object.assign(wrappedCipher, params);
    return wrappedCipher;
};
function $248bf24903c02b9f$export$e504884fb8831d9d(expectedLength, out, onlyAligned = true) {
    if (out === undefined) return new Uint8Array(expectedLength);
    if (out.length !== expectedLength) throw new Error('"output" expected Uint8Array of length ' + expectedLength + ', got: ' + out.length);
    if (onlyAligned && !$248bf24903c02b9f$export$c50aefb83d1cf2a2(out)) throw new Error('invalid output, must be aligned');
    return out;
}
function $248bf24903c02b9f$export$342c09f6517ae3b8(dataLength, aadLength, isLE) {
    $248bf24903c02b9f$export$809304d28d77d92d(isLE);
    const num = new Uint8Array(16);
    const view = $248bf24903c02b9f$export$d7febe7b891e79f0(num);
    view.setBigUint64(0, BigInt(aadLength), isLE);
    view.setBigUint64(8, BigInt(dataLength), isLE);
    return num;
}
function $248bf24903c02b9f$export$c50aefb83d1cf2a2(bytes) {
    return bytes.byteOffset % 4 === 0;
}
function $248bf24903c02b9f$export$56728fb2d7dba34e(bytes) {
    return Uint8Array.from(bytes);
}
function $248bf24903c02b9f$export$5f828d93ff035aa8(bytesLength = 32) {
    const cr = typeof globalThis === 'object' ? globalThis.crypto : null;
    if (typeof cr?.getRandomValues !== 'function') throw new Error('crypto.getRandomValues must be defined');
    return cr.getRandomValues(new Uint8Array(bytesLength));
}
function $248bf24903c02b9f$export$3da2574c141471e(fn, randomBytes_ = $248bf24903c02b9f$export$5f828d93ff035aa8) {
    const { nonceLength: nonceLength } = fn;
    $248bf24903c02b9f$export$75364c6cb16d43b6(nonceLength);
    const addNonce = (nonce, ciphertext)=>{
        const out = $248bf24903c02b9f$export$287dd7971339c972(nonce, ciphertext);
        ciphertext.fill(0);
        return out;
    };
    // NOTE: we cannot support DST here, it would be mistake:
    // - we don't know how much dst length cipher requires
    // - nonce may unalign dst and break everything
    // - we create new u8a anyway (concatBytes)
    // - previously we passed all args to cipher, but that was mistake!
    return (key, ...args)=>({
            encrypt (plaintext) {
                $248bf24903c02b9f$export$e8a750b9efad93f5(plaintext);
                const nonce = randomBytes_(nonceLength);
                const encrypted = fn(key, nonce, ...args).encrypt(plaintext);
                // @ts-ignore
                if (encrypted instanceof Promise) return encrypted.then((ct)=>addNonce(nonce, ct));
                return addNonce(nonce, encrypted);
            },
            decrypt (ciphertext) {
                $248bf24903c02b9f$export$e8a750b9efad93f5(ciphertext);
                const nonce = ciphertext.subarray(0, nonceLength);
                const decrypted = ciphertext.subarray(nonceLength);
                return fn(key, nonce, ...args).decrypt(decrypted);
            }
        });
}

});



parcelRegister("lAjhr", function(module, exports) {

$parcel$export(module.exports, "chacha20", () => $040e20af249c8886$export$8e0a42fdbca06555);
/**
 * ChaCha stream cipher, released
 * in 2008. Developed after Salsa20, ChaCha aims to increase diffusion per round.
 * It was standardized in [RFC 8439](https://www.rfc-editor.org/rfc/rfc8439) and
 * is now used in TLS 1.3.
 *
 * [XChaCha20](https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-xchacha)
 * extended-nonce variant is also provided. Similar to XSalsa, it's safe to use with
 * randomly-generated nonces.
 *
 * Check out [PDF](http://cr.yp.to/chacha/chacha-20080128.pdf) and
 * [wiki](https://en.wikipedia.org/wiki/Salsa20) and
 * [website](https://cr.yp.to/chacha.html).
 *
 * @module
 */ 
var $8niJx = parcelRequire("8niJx");

var $byidz = parcelRequire("byidz");

var $38xio = parcelRequire("38xio");
/**
 * ChaCha core function. It is implemented twice:
 * 1. Simple loop (chachaCore_small, hchacha_small)
 * 2. Unrolled loop (chachaCore, hchacha) - 4x faster, but larger & harder to read
 * The specific implementation is selected in `createCipher` below.
 */ /** quarter-round */ // prettier-ignore
function $040e20af249c8886$var$chachaQR(x, a, b, c, d) {
    x[a] = x[a] + x[b] | 0;
    x[d] = (0, $8niJx.rotl)(x[d] ^ x[a], 16);
    x[c] = x[c] + x[d] | 0;
    x[b] = (0, $8niJx.rotl)(x[b] ^ x[c], 12);
    x[a] = x[a] + x[b] | 0;
    x[d] = (0, $8niJx.rotl)(x[d] ^ x[a], 8);
    x[c] = x[c] + x[d] | 0;
    x[b] = (0, $8niJx.rotl)(x[b] ^ x[c], 7);
}
/** single round */ function $040e20af249c8886$var$chachaRound(x, rounds = 20) {
    for(let r = 0; r < rounds; r += 2){
        $040e20af249c8886$var$chachaQR(x, 0, 4, 8, 12);
        $040e20af249c8886$var$chachaQR(x, 1, 5, 9, 13);
        $040e20af249c8886$var$chachaQR(x, 2, 6, 10, 14);
        $040e20af249c8886$var$chachaQR(x, 3, 7, 11, 15);
        $040e20af249c8886$var$chachaQR(x, 0, 5, 10, 15);
        $040e20af249c8886$var$chachaQR(x, 1, 6, 11, 12);
        $040e20af249c8886$var$chachaQR(x, 2, 7, 8, 13);
        $040e20af249c8886$var$chachaQR(x, 3, 4, 9, 14);
    }
}
const $040e20af249c8886$var$ctmp = /* @__PURE__ */ new Uint32Array(16);
/** Small version of chacha without loop unrolling. Unused, provided for auditability. */ // prettier-ignore
function $040e20af249c8886$var$chacha(s, k, i, out, isHChacha = true, rounds = 20) {
    // Create initial array using common pattern
    const y = Uint32Array.from([
        s[0],
        s[1],
        s[2],
        s[3],
        k[0],
        k[1],
        k[2],
        k[3],
        k[4],
        k[5],
        k[6],
        k[7],
        i[0],
        i[1],
        i[2],
        i[3]
    ]);
    const x = $040e20af249c8886$var$ctmp;
    x.set(y);
    $040e20af249c8886$var$chachaRound(x, rounds);
    // hchacha extracts 8 specific bytes, chacha adds orig to result
    if (isHChacha) {
        const xindexes = [
            0,
            1,
            2,
            3,
            12,
            13,
            14,
            15
        ];
        for(let i = 0; i < 8; i++)out[i] = x[xindexes[i]];
    } else for(let i = 0; i < 16; i++)out[i] = y[i] + x[i] | 0;
}
/** Identical to `chachaCore`. Unused. */ // @ts-ignore
const $040e20af249c8886$var$chachaCore_small = (s, k, n, out, cnt, rounds)=>$040e20af249c8886$var$chacha(s, k, Uint32Array.from([
        n[0],
        n[1],
        cnt,
        0
    ]), out, false, rounds);
/** Identical to `hchacha`. Unused. */ // @ts-ignore
const $040e20af249c8886$var$hchacha_small = $040e20af249c8886$var$chacha;
/** Identical to `chachaCore_small`. Unused. */ // prettier-ignore
function $040e20af249c8886$var$chachaCore(s, k, n, out, cnt, rounds = 20) {
    let y00 = s[0], y01 = s[1], y02 = s[2], y03 = s[3], y04 = k[0], y05 = k[1], y06 = k[2], y07 = k[3], y08 = k[4], y09 = k[5], y10 = k[6], y11 = k[7], y12 = cnt, y13 = n[0], y14 = n[1], y15 = n[2]; // Counter  Counter	Nonce   Nonce
    // Save state to temporary variables
    let x00 = y00, x01 = y01, x02 = y02, x03 = y03, x04 = y04, x05 = y05, x06 = y06, x07 = y07, x08 = y08, x09 = y09, x10 = y10, x11 = y11, x12 = y12, x13 = y13, x14 = y14, x15 = y15;
    for(let r = 0; r < rounds; r += 2){
        x00 = x00 + x04 | 0;
        x12 = (0, $8niJx.rotl)(x12 ^ x00, 16);
        x08 = x08 + x12 | 0;
        x04 = (0, $8niJx.rotl)(x04 ^ x08, 12);
        x00 = x00 + x04 | 0;
        x12 = (0, $8niJx.rotl)(x12 ^ x00, 8);
        x08 = x08 + x12 | 0;
        x04 = (0, $8niJx.rotl)(x04 ^ x08, 7);
        x01 = x01 + x05 | 0;
        x13 = (0, $8niJx.rotl)(x13 ^ x01, 16);
        x09 = x09 + x13 | 0;
        x05 = (0, $8niJx.rotl)(x05 ^ x09, 12);
        x01 = x01 + x05 | 0;
        x13 = (0, $8niJx.rotl)(x13 ^ x01, 8);
        x09 = x09 + x13 | 0;
        x05 = (0, $8niJx.rotl)(x05 ^ x09, 7);
        x02 = x02 + x06 | 0;
        x14 = (0, $8niJx.rotl)(x14 ^ x02, 16);
        x10 = x10 + x14 | 0;
        x06 = (0, $8niJx.rotl)(x06 ^ x10, 12);
        x02 = x02 + x06 | 0;
        x14 = (0, $8niJx.rotl)(x14 ^ x02, 8);
        x10 = x10 + x14 | 0;
        x06 = (0, $8niJx.rotl)(x06 ^ x10, 7);
        x03 = x03 + x07 | 0;
        x15 = (0, $8niJx.rotl)(x15 ^ x03, 16);
        x11 = x11 + x15 | 0;
        x07 = (0, $8niJx.rotl)(x07 ^ x11, 12);
        x03 = x03 + x07 | 0;
        x15 = (0, $8niJx.rotl)(x15 ^ x03, 8);
        x11 = x11 + x15 | 0;
        x07 = (0, $8niJx.rotl)(x07 ^ x11, 7);
        x00 = x00 + x05 | 0;
        x15 = (0, $8niJx.rotl)(x15 ^ x00, 16);
        x10 = x10 + x15 | 0;
        x05 = (0, $8niJx.rotl)(x05 ^ x10, 12);
        x00 = x00 + x05 | 0;
        x15 = (0, $8niJx.rotl)(x15 ^ x00, 8);
        x10 = x10 + x15 | 0;
        x05 = (0, $8niJx.rotl)(x05 ^ x10, 7);
        x01 = x01 + x06 | 0;
        x12 = (0, $8niJx.rotl)(x12 ^ x01, 16);
        x11 = x11 + x12 | 0;
        x06 = (0, $8niJx.rotl)(x06 ^ x11, 12);
        x01 = x01 + x06 | 0;
        x12 = (0, $8niJx.rotl)(x12 ^ x01, 8);
        x11 = x11 + x12 | 0;
        x06 = (0, $8niJx.rotl)(x06 ^ x11, 7);
        x02 = x02 + x07 | 0;
        x13 = (0, $8niJx.rotl)(x13 ^ x02, 16);
        x08 = x08 + x13 | 0;
        x07 = (0, $8niJx.rotl)(x07 ^ x08, 12);
        x02 = x02 + x07 | 0;
        x13 = (0, $8niJx.rotl)(x13 ^ x02, 8);
        x08 = x08 + x13 | 0;
        x07 = (0, $8niJx.rotl)(x07 ^ x08, 7);
        x03 = x03 + x04 | 0;
        x14 = (0, $8niJx.rotl)(x14 ^ x03, 16);
        x09 = x09 + x14 | 0;
        x04 = (0, $8niJx.rotl)(x04 ^ x09, 12);
        x03 = x03 + x04 | 0;
        x14 = (0, $8niJx.rotl)(x14 ^ x03, 8);
        x09 = x09 + x14 | 0;
        x04 = (0, $8niJx.rotl)(x04 ^ x09, 7);
    }
    // Write output
    let oi = 0;
    out[oi++] = y00 + x00 | 0;
    out[oi++] = y01 + x01 | 0;
    out[oi++] = y02 + x02 | 0;
    out[oi++] = y03 + x03 | 0;
    out[oi++] = y04 + x04 | 0;
    out[oi++] = y05 + x05 | 0;
    out[oi++] = y06 + x06 | 0;
    out[oi++] = y07 + x07 | 0;
    out[oi++] = y08 + x08 | 0;
    out[oi++] = y09 + x09 | 0;
    out[oi++] = y10 + x10 | 0;
    out[oi++] = y11 + x11 | 0;
    out[oi++] = y12 + x12 | 0;
    out[oi++] = y13 + x13 | 0;
    out[oi++] = y14 + x14 | 0;
    out[oi++] = y15 + x15 | 0;
}
function $040e20af249c8886$export$81d7140ca2e77b3d(s, k, i, out) {
    let x00 = s[0], x01 = s[1], x02 = s[2], x03 = s[3], x04 = k[0], x05 = k[1], x06 = k[2], x07 = k[3], x08 = k[4], x09 = k[5], x10 = k[6], x11 = k[7], x12 = i[0], x13 = i[1], x14 = i[2], x15 = i[3];
    for(let r = 0; r < 20; r += 2){
        x00 = x00 + x04 | 0;
        x12 = (0, $8niJx.rotl)(x12 ^ x00, 16);
        x08 = x08 + x12 | 0;
        x04 = (0, $8niJx.rotl)(x04 ^ x08, 12);
        x00 = x00 + x04 | 0;
        x12 = (0, $8niJx.rotl)(x12 ^ x00, 8);
        x08 = x08 + x12 | 0;
        x04 = (0, $8niJx.rotl)(x04 ^ x08, 7);
        x01 = x01 + x05 | 0;
        x13 = (0, $8niJx.rotl)(x13 ^ x01, 16);
        x09 = x09 + x13 | 0;
        x05 = (0, $8niJx.rotl)(x05 ^ x09, 12);
        x01 = x01 + x05 | 0;
        x13 = (0, $8niJx.rotl)(x13 ^ x01, 8);
        x09 = x09 + x13 | 0;
        x05 = (0, $8niJx.rotl)(x05 ^ x09, 7);
        x02 = x02 + x06 | 0;
        x14 = (0, $8niJx.rotl)(x14 ^ x02, 16);
        x10 = x10 + x14 | 0;
        x06 = (0, $8niJx.rotl)(x06 ^ x10, 12);
        x02 = x02 + x06 | 0;
        x14 = (0, $8niJx.rotl)(x14 ^ x02, 8);
        x10 = x10 + x14 | 0;
        x06 = (0, $8niJx.rotl)(x06 ^ x10, 7);
        x03 = x03 + x07 | 0;
        x15 = (0, $8niJx.rotl)(x15 ^ x03, 16);
        x11 = x11 + x15 | 0;
        x07 = (0, $8niJx.rotl)(x07 ^ x11, 12);
        x03 = x03 + x07 | 0;
        x15 = (0, $8niJx.rotl)(x15 ^ x03, 8);
        x11 = x11 + x15 | 0;
        x07 = (0, $8niJx.rotl)(x07 ^ x11, 7);
        x00 = x00 + x05 | 0;
        x15 = (0, $8niJx.rotl)(x15 ^ x00, 16);
        x10 = x10 + x15 | 0;
        x05 = (0, $8niJx.rotl)(x05 ^ x10, 12);
        x00 = x00 + x05 | 0;
        x15 = (0, $8niJx.rotl)(x15 ^ x00, 8);
        x10 = x10 + x15 | 0;
        x05 = (0, $8niJx.rotl)(x05 ^ x10, 7);
        x01 = x01 + x06 | 0;
        x12 = (0, $8niJx.rotl)(x12 ^ x01, 16);
        x11 = x11 + x12 | 0;
        x06 = (0, $8niJx.rotl)(x06 ^ x11, 12);
        x01 = x01 + x06 | 0;
        x12 = (0, $8niJx.rotl)(x12 ^ x01, 8);
        x11 = x11 + x12 | 0;
        x06 = (0, $8niJx.rotl)(x06 ^ x11, 7);
        x02 = x02 + x07 | 0;
        x13 = (0, $8niJx.rotl)(x13 ^ x02, 16);
        x08 = x08 + x13 | 0;
        x07 = (0, $8niJx.rotl)(x07 ^ x08, 12);
        x02 = x02 + x07 | 0;
        x13 = (0, $8niJx.rotl)(x13 ^ x02, 8);
        x08 = x08 + x13 | 0;
        x07 = (0, $8niJx.rotl)(x07 ^ x08, 7);
        x03 = x03 + x04 | 0;
        x14 = (0, $8niJx.rotl)(x14 ^ x03, 16);
        x09 = x09 + x14 | 0;
        x04 = (0, $8niJx.rotl)(x04 ^ x09, 12);
        x03 = x03 + x04 | 0;
        x14 = (0, $8niJx.rotl)(x14 ^ x03, 8);
        x09 = x09 + x14 | 0;
        x04 = (0, $8niJx.rotl)(x04 ^ x09, 7);
    }
    let oi = 0;
    out[oi++] = x00;
    out[oi++] = x01;
    out[oi++] = x02;
    out[oi++] = x03;
    out[oi++] = x12;
    out[oi++] = x13;
    out[oi++] = x14;
    out[oi++] = x15;
}
const $040e20af249c8886$export$b55a45dabc2febcc = /* @__PURE__ */ (0, $8niJx.createCipher)($040e20af249c8886$var$chachaCore, {
    counterRight: false,
    counterLength: 8,
    allowShortKeys: true
});
const $040e20af249c8886$export$8e0a42fdbca06555 = /* @__PURE__ */ (0, $8niJx.createCipher)($040e20af249c8886$var$chachaCore, {
    counterRight: false,
    counterLength: 4,
    allowShortKeys: false
});
const $040e20af249c8886$export$f4c63d095e1b0ecd = /* @__PURE__ */ (0, $8niJx.createCipher)($040e20af249c8886$var$chachaCore, {
    counterRight: false,
    counterLength: 8,
    extendNonceFn: $040e20af249c8886$export$81d7140ca2e77b3d,
    allowShortKeys: false
});
const $040e20af249c8886$export$5da3e887d4315063 = /* @__PURE__ */ (0, $8niJx.createCipher)($040e20af249c8886$var$chachaCore, {
    counterRight: false,
    counterLength: 4,
    rounds: 8
});
const $040e20af249c8886$export$d86f240838b738bc = /* @__PURE__ */ (0, $8niJx.createCipher)($040e20af249c8886$var$chachaCore, {
    counterRight: false,
    counterLength: 4,
    rounds: 12
});
const $040e20af249c8886$var$ZEROS16 = /* @__PURE__ */ new Uint8Array(16);
// Pad to digest size with zeros
const $040e20af249c8886$var$updatePadded = (h, msg)=>{
    h.update(msg);
    const leftover = msg.length % 16;
    if (leftover) h.update($040e20af249c8886$var$ZEROS16.subarray(leftover));
};
const $040e20af249c8886$var$ZEROS32 = /* @__PURE__ */ new Uint8Array(32);
function $040e20af249c8886$var$computeTag(fn, key, nonce, ciphertext, AAD) {
    if (AAD !== undefined) (0, $38xio.abytes)(AAD, undefined, 'AAD');
    const authKey = fn(key, nonce, $040e20af249c8886$var$ZEROS32);
    const lengths = (0, $38xio.u64Lengths)(ciphertext.length, AAD ? AAD.length : 0, true);
    // Methods below can be replaced with
    // return poly1305_computeTag_small(authKey, lengths, ciphertext, AAD)
    const h = (0, $byidz.poly1305).create(authKey);
    if (AAD) $040e20af249c8886$var$updatePadded(h, AAD);
    $040e20af249c8886$var$updatePadded(h, ciphertext);
    h.update(lengths);
    const res = h.digest();
    (0, $38xio.clean)(authKey, lengths);
    return res;
}
const $040e20af249c8886$export$393d77349b0943d5 = (xorStream)=>(key, nonce, AAD)=>{
        const tagLength = 16;
        return {
            encrypt (plaintext, output) {
                const plength = plaintext.length;
                output = (0, $38xio.getOutput)(plength + tagLength, output, false);
                output.set(plaintext);
                const oPlain = output.subarray(0, -tagLength);
                // Actual encryption
                xorStream(key, nonce, oPlain, oPlain, 1);
                const tag = $040e20af249c8886$var$computeTag(xorStream, key, nonce, oPlain, AAD);
                output.set(tag, plength); // append tag
                (0, $38xio.clean)(tag);
                return output;
            },
            decrypt (ciphertext, output) {
                output = (0, $38xio.getOutput)(ciphertext.length - tagLength, output, false);
                const data = ciphertext.subarray(0, -tagLength);
                const passedTag = ciphertext.subarray(-tagLength);
                const tag = $040e20af249c8886$var$computeTag(xorStream, key, nonce, data, AAD);
                if (!(0, $38xio.equalBytes)(passedTag, tag)) throw new Error('invalid tag');
                output.set(ciphertext.subarray(0, -tagLength));
                // Actual decryption
                xorStream(key, nonce, output, output, 1); // start stream with i=1
                (0, $38xio.clean)(tag);
                return output;
            }
        };
    };
const $040e20af249c8886$export$c29357eacf2310e7 = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 64,
    nonceLength: 12,
    tagLength: 16
}, $040e20af249c8886$export$393d77349b0943d5($040e20af249c8886$export$8e0a42fdbca06555));
const $040e20af249c8886$export$52d6b418bf85cef8 = /* @__PURE__ */ (0, $38xio.wrapCipher)({
    blockSize: 64,
    nonceLength: 24,
    tagLength: 16
}, $040e20af249c8886$export$393d77349b0943d5($040e20af249c8886$export$f4c63d095e1b0ecd));
const $040e20af249c8886$export$e69a66dd9a20d70f = /* @__PURE__ */ (0, $8niJx.createPRG)($040e20af249c8886$export$b55a45dabc2febcc, 64, 32, 8);
const $040e20af249c8886$export$684f0cf44a9e5797 = /* @__PURE__ */ (0, $8niJx.createPRG)($040e20af249c8886$export$5da3e887d4315063, 64, 32, 12);

});
parcelRegister("8niJx", function(module, exports) {

$parcel$export(module.exports, "rotl", () => $618f00ce983d19db$export$ac5e39599698b562);
$parcel$export(module.exports, "createCipher", () => $618f00ce983d19db$export$bdd223f16383713e);
$parcel$export(module.exports, "createPRG", () => $618f00ce983d19db$export$1a09838f46bab7c1);
/**
 * Basic utils for ARX (add-rotate-xor) salsa and chacha ciphers.

RFC8439 requires multi-step cipher stream, where
authKey starts with counter: 0, actual msg with counter: 1.

For this, we need a way to re-use nonce / counter:

    const counter = new Uint8Array(4);
    chacha(..., counter, ...); // counter is now 1
    chacha(..., counter, ...); // counter is now 2

This is complicated:

- 32-bit counters are enough, no need for 64-bit: max ArrayBuffer size in JS is 4GB
- Original papers don't allow mutating counters
- Counter overflow is undefined [^1]
- Idea A: allow providing (nonce | counter) instead of just nonce, re-use it
- Caveat: Cannot be re-used through all cases:
- * chacha has (counter | nonce)
- * xchacha has (nonce16 | counter | nonce16)
- Idea B: separate nonce / counter and provide separate API for counter re-use
- Caveat: there are different counter sizes depending on an algorithm.
- salsa & chacha also differ in structures of key & sigma:
  salsa20:      s[0] | k(4) | s[1] | nonce(2) | cnt(2) | s[2] | k(4) | s[3]
  chacha:       s(4) | k(8) | cnt(1) | nonce(3)
  chacha20orig: s(4) | k(8) | cnt(2) | nonce(2)
- Idea C: helper method such as `setSalsaState(key, nonce, sigma, data)`
- Caveat: we can't re-use counter array

xchacha [^2] uses the subkey and remaining 8 byte nonce with ChaCha20 as normal
(prefixed by 4 NUL bytes, since [RFC8439] specifies a 12-byte nonce).

[^1]: https://mailarchive.ietf.org/arch/msg/cfrg/gsOnTJzcbgG6OqD8Sc0GO5aR_tU/
[^2]: https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-xchacha#appendix-A.2

 * @module
 */ 
var $38xio = parcelRequire("38xio");
// Replaces `TextEncoder`, which is not available in all environments
const $618f00ce983d19db$var$encodeStr = (str)=>Uint8Array.from(str.split(''), (c)=>c.charCodeAt(0));
const $618f00ce983d19db$var$sigma16 = $618f00ce983d19db$var$encodeStr('expand 16-byte k');
const $618f00ce983d19db$var$sigma32 = $618f00ce983d19db$var$encodeStr('expand 32-byte k');
const $618f00ce983d19db$var$sigma16_32 = (0, $38xio.u32)($618f00ce983d19db$var$sigma16);
const $618f00ce983d19db$var$sigma32_32 = (0, $38xio.u32)($618f00ce983d19db$var$sigma32);
function $618f00ce983d19db$export$ac5e39599698b562(a, b) {
    return a << b | a >>> 32 - b;
}
// Is byte array aligned to 4 byte offset (u32)?
function $618f00ce983d19db$var$isAligned32(b) {
    return b.byteOffset % 4 === 0;
}
// Salsa and Chacha block length is always 512-bit
const $618f00ce983d19db$var$BLOCK_LEN = 64;
const $618f00ce983d19db$var$BLOCK_LEN32 = 16;
// new Uint32Array([2**32])   // => Uint32Array(1) [ 0 ]
// new Uint32Array([2**32-1]) // => Uint32Array(1) [ 4294967295 ]
const $618f00ce983d19db$var$MAX_COUNTER = 2 ** 32 - 1;
const $618f00ce983d19db$var$U32_EMPTY = Uint32Array.of();
function $618f00ce983d19db$var$runCipher(core, sigma, key, nonce, data, output, counter, rounds) {
    const len = data.length;
    const block = new Uint8Array($618f00ce983d19db$var$BLOCK_LEN);
    const b32 = (0, $38xio.u32)(block);
    // Make sure that buffers aligned to 4 bytes
    const isAligned = $618f00ce983d19db$var$isAligned32(data) && $618f00ce983d19db$var$isAligned32(output);
    const d32 = isAligned ? (0, $38xio.u32)(data) : $618f00ce983d19db$var$U32_EMPTY;
    const o32 = isAligned ? (0, $38xio.u32)(output) : $618f00ce983d19db$var$U32_EMPTY;
    for(let pos = 0; pos < len; counter++){
        core(sigma, key, nonce, b32, counter, rounds);
        if (counter >= $618f00ce983d19db$var$MAX_COUNTER) throw new Error('arx: counter overflow');
        const take = Math.min($618f00ce983d19db$var$BLOCK_LEN, len - pos);
        // aligned to 4 bytes
        if (isAligned && take === $618f00ce983d19db$var$BLOCK_LEN) {
            const pos32 = pos / 4;
            if (pos % 4 !== 0) throw new Error('arx: invalid block position');
            for(let j = 0, posj; j < $618f00ce983d19db$var$BLOCK_LEN32; j++){
                posj = pos32 + j;
                o32[posj] = d32[posj] ^ b32[j];
            }
            pos += $618f00ce983d19db$var$BLOCK_LEN;
            continue;
        }
        for(let j = 0, posj; j < take; j++){
            posj = pos + j;
            output[posj] = data[posj] ^ block[j];
        }
        pos += take;
    }
}
function $618f00ce983d19db$export$bdd223f16383713e(core, opts) {
    const { allowShortKeys: allowShortKeys, extendNonceFn: extendNonceFn, counterLength: counterLength, counterRight: counterRight, rounds: rounds } = (0, $38xio.checkOpts)({
        allowShortKeys: false,
        counterLength: 8,
        counterRight: false,
        rounds: 20
    }, opts);
    if (typeof core !== 'function') throw new Error('core must be a function');
    (0, $38xio.anumber)(counterLength);
    (0, $38xio.anumber)(rounds);
    (0, $38xio.abool)(counterRight);
    (0, $38xio.abool)(allowShortKeys);
    return (key, nonce, data, output, counter = 0)=>{
        (0, $38xio.abytes)(key, undefined, 'key');
        (0, $38xio.abytes)(nonce, undefined, 'nonce');
        (0, $38xio.abytes)(data, undefined, 'data');
        const len = data.length;
        if (output === undefined) output = new Uint8Array(len);
        (0, $38xio.abytes)(output, undefined, 'output');
        (0, $38xio.anumber)(counter);
        if (counter < 0 || counter >= $618f00ce983d19db$var$MAX_COUNTER) throw new Error('arx: counter overflow');
        if (output.length < len) throw new Error(`arx: output (${output.length}) is shorter than data (${len})`);
        const toClean = [];
        // Key & sigma
        // key=16 -> sigma16, k=key|key
        // key=32 -> sigma32, k=key
        let l = key.length;
        let k;
        let sigma;
        if (l === 32) {
            toClean.push(k = (0, $38xio.copyBytes)(key));
            sigma = $618f00ce983d19db$var$sigma32_32;
        } else if (l === 16 && allowShortKeys) {
            k = new Uint8Array(32);
            k.set(key);
            k.set(key, 16);
            sigma = $618f00ce983d19db$var$sigma16_32;
            toClean.push(k);
        } else {
            (0, $38xio.abytes)(key, 32, 'arx key');
            throw new Error('invalid key size');
        // throw new Error(`"arx key" expected Uint8Array of length 32, got length=${l}`);
        }
        // Nonce
        // salsa20:      8   (8-byte counter)
        // chacha20orig: 8   (8-byte counter)
        // chacha20:     12  (4-byte counter)
        // xsalsa20:     24  (16 -> hsalsa,  8 -> old nonce)
        // xchacha20:    24  (16 -> hchacha, 8 -> old nonce)
        // Align nonce to 4 bytes
        if (!$618f00ce983d19db$var$isAligned32(nonce)) toClean.push(nonce = (0, $38xio.copyBytes)(nonce));
        const k32 = (0, $38xio.u32)(k);
        // hsalsa & hchacha: handle extended nonce
        if (extendNonceFn) {
            if (nonce.length !== 24) throw new Error(`arx: extended nonce must be 24 bytes`);
            extendNonceFn(sigma, k32, (0, $38xio.u32)(nonce.subarray(0, 16)), k32);
            nonce = nonce.subarray(16);
        }
        // Handle nonce counter
        const nonceNcLen = 16 - counterLength;
        if (nonceNcLen !== nonce.length) throw new Error(`arx: nonce must be ${nonceNcLen} or 16 bytes`);
        // Pad counter when nonce is 64 bit
        if (nonceNcLen !== 12) {
            const nc = new Uint8Array(12);
            nc.set(nonce, counterRight ? 0 : 12 - nonce.length);
            nonce = nc;
            toClean.push(nonce);
        }
        const n32 = (0, $38xio.u32)(nonce);
        $618f00ce983d19db$var$runCipher(core, sigma, k32, n32, data, output, counter, rounds);
        (0, $38xio.clean)(...toClean);
        return output;
    };
}
class $618f00ce983d19db$export$cade11f16aa58a5e {
    blockLen;
    keyLen;
    nonceLen;
    state;
    buf;
    key;
    nonce;
    pos;
    ctr;
    cipher;
    constructor(cipher, blockLen, keyLen, nonceLen, seed){
        this.cipher = cipher;
        this.blockLen = blockLen;
        this.keyLen = keyLen;
        this.nonceLen = nonceLen;
        this.state = new Uint8Array(this.keyLen + this.nonceLen);
        this.reseed(seed);
        this.ctr = 0;
        this.pos = this.blockLen;
        this.buf = new Uint8Array(this.blockLen);
        this.key = this.state.subarray(0, this.keyLen);
        this.nonce = this.state.subarray(this.keyLen);
    }
    reseed(seed) {
        (0, $38xio.abytes)(seed);
        if (!seed || seed.length === 0) throw new Error('entropy required');
        for(let i = 0; i < seed.length; i++)this.state[i % this.state.length] ^= seed[i];
        this.ctr = 0;
        this.pos = this.blockLen;
    }
    addEntropy(seed) {
        this.state.set(this.randomBytes(this.state.length));
        this.reseed(seed);
    }
    randomBytes(len) {
        (0, $38xio.anumber)(len);
        if (len === 0) return new Uint8Array(0);
        const out = new Uint8Array(len);
        let outPos = 0;
        // Leftovers
        if (this.pos < this.blockLen) {
            const take = Math.min(len, this.blockLen - this.pos);
            out.set(this.buf.subarray(this.pos, this.pos + take), 0);
            this.pos += take;
            outPos += take;
            if (outPos === len) return out; // fast path
        }
        // Full blocks directly to out
        const blocks = Math.floor((len - outPos) / this.blockLen);
        if (blocks > 0) {
            const blockBytes = blocks * this.blockLen;
            const b = out.subarray(outPos, outPos + blockBytes);
            this.cipher(this.key, this.nonce, b, b, this.ctr);
            this.ctr += blocks;
            outPos += blockBytes;
        }
        // Save leftovers
        const left = len - outPos;
        if (left > 0) {
            this.buf.fill(0);
            // NOTE: cipher will handle overflow
            this.cipher(this.key, this.nonce, this.buf, this.buf, this.ctr++);
            out.set(this.buf.subarray(0, left), outPos);
            this.pos = left;
        }
        return out;
    }
    clone() {
        return new $618f00ce983d19db$export$cade11f16aa58a5e(this.cipher, this.blockLen, this.keyLen, this.nonceLen, this.randomBytes(this.state.length));
    }
    clean() {
        this.pos = 0;
        this.ctr = 0;
        this.buf.fill(0);
        this.state.fill(0);
    }
}
const $618f00ce983d19db$export$1a09838f46bab7c1 = (cipher, blockLen, keyLen, nonceLen)=>{
    return (seed = (0, $38xio.randomBytes)(32))=>new $618f00ce983d19db$export$cade11f16aa58a5e(cipher, blockLen, keyLen, nonceLen, seed);
};

});

parcelRegister("byidz", function(module, exports) {

$parcel$export(module.exports, "poly1305", () => $8691005ce78b9c39$export$7228b37eebb44175);
/**
 * Poly1305 ([PDF](https://cr.yp.to/mac/poly1305-20050329.pdf),
 * [wiki](https://en.wikipedia.org/wiki/Poly1305))
 * is a fast and parallel secret-key message-authentication code suitable for
 * a wide variety of applications. It was standardized in
 * [RFC 8439](https://www.rfc-editor.org/rfc/rfc8439) and is now used in TLS 1.3.
 *
 * Polynomial MACs are not perfect for every situation:
 * they lack Random Key Robustness: the MAC can be forged, and can't be used in PAKE schemes.
 * See [invisible salamanders attack](https://keymaterial.net/2020/09/07/invisible-salamanders-in-aes-gcm-siv/).
 * To combat invisible salamanders, `hash(key)` can be included in ciphertext,
 * however, this would violate ciphertext indistinguishability:
 * an attacker would know which key was used - so `HKDF(key, i)`
 * could be used instead.
 *
 * Check out [original website](https://cr.yp.to/mac.html).
 * Based on Public Domain [poly1305-donna](https://github.com/floodyberry/poly1305-donna).
 * @module
 */ // prettier-ignore

var $38xio = parcelRequire("38xio");
function $8691005ce78b9c39$var$u8to16(a, i) {
    return a[i++] & 0xff | (a[i++] & 0xff) << 8;
}
function $8691005ce78b9c39$var$bytesToNumberLE(bytes) {
    return (0, $38xio.hexToNumber)((0, $38xio.bytesToHex)(Uint8Array.from(bytes).reverse()));
}
/** Small version of `poly1305` without loop unrolling. Unused, provided for auditability. */ function $8691005ce78b9c39$var$poly1305_small(msg, key) {
    (0, $38xio.abytes)(msg);
    (0, $38xio.abytes)(key, 32, 'key');
    const POW_2_130_5 = BigInt(2) ** BigInt(130) - BigInt(5); // 2^130-5
    const POW_2_128_1 = BigInt(2) ** BigInt(128) - BigInt(1); // 2^128-1
    const CLAMP_R = BigInt('0x0ffffffc0ffffffc0ffffffc0fffffff');
    const r = $8691005ce78b9c39$var$bytesToNumberLE(key.subarray(0, 16)) & CLAMP_R;
    const s = $8691005ce78b9c39$var$bytesToNumberLE(key.subarray(16));
    // Process by 16 byte chunks
    let acc = BigInt(0);
    for(let i = 0; i < msg.length; i += 16){
        const m = msg.subarray(i, i + 16);
        const n = $8691005ce78b9c39$var$bytesToNumberLE(m) | BigInt(1) << BigInt(8 * m.length);
        acc = (acc + n) * r % POW_2_130_5;
    }
    const res = acc + s & POW_2_128_1;
    return (0, $38xio.numberToBytesBE)(res, 16).reverse(); // LE
}
// Can be used to replace `computeTag` in chacha.ts. Unused, provided for auditability.
// @ts-expect-error
function $8691005ce78b9c39$var$poly1305_computeTag_small(authKey, lengths, ciphertext, AAD) {
    const res = [];
    const updatePadded2 = (msg)=>{
        res.push(msg);
        const leftover = msg.length % 16;
        if (leftover) res.push(new Uint8Array(16).slice(leftover));
    };
    if (AAD) updatePadded2(AAD);
    updatePadded2(ciphertext);
    res.push(lengths);
    return $8691005ce78b9c39$var$poly1305_small((0, $38xio.concatBytes)(...res), authKey);
}
class $8691005ce78b9c39$export$c048faf97da45308 {
    blockLen = 16;
    outputLen = 16;
    buffer = new Uint8Array(16);
    r = new Uint16Array(10);
    h = new Uint16Array(10);
    pad = new Uint16Array(8);
    pos = 0;
    finished = false;
    // Can be speed-up using BigUint64Array, at the cost of complexity
    constructor(key){
        key = (0, $38xio.copyBytes)((0, $38xio.abytes)(key, 32, 'key'));
        const t0 = $8691005ce78b9c39$var$u8to16(key, 0);
        const t1 = $8691005ce78b9c39$var$u8to16(key, 2);
        const t2 = $8691005ce78b9c39$var$u8to16(key, 4);
        const t3 = $8691005ce78b9c39$var$u8to16(key, 6);
        const t4 = $8691005ce78b9c39$var$u8to16(key, 8);
        const t5 = $8691005ce78b9c39$var$u8to16(key, 10);
        const t6 = $8691005ce78b9c39$var$u8to16(key, 12);
        const t7 = $8691005ce78b9c39$var$u8to16(key, 14);
        // https://github.com/floodyberry/poly1305-donna/blob/e6ad6e091d30d7f4ec2d4f978be1fcfcbce72781/poly1305-donna-16.h#L47
        this.r[0] = t0 & 0x1fff;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        for(let i = 0; i < 8; i++)this.pad[i] = $8691005ce78b9c39$var$u8to16(key, 16 + 2 * i);
    }
    process(data, offset, isLast = false) {
        const hibit = isLast ? 0 : 2048;
        const { h: h, r: r } = this;
        const r0 = r[0];
        const r1 = r[1];
        const r2 = r[2];
        const r3 = r[3];
        const r4 = r[4];
        const r5 = r[5];
        const r6 = r[6];
        const r7 = r[7];
        const r8 = r[8];
        const r9 = r[9];
        const t0 = $8691005ce78b9c39$var$u8to16(data, offset + 0);
        const t1 = $8691005ce78b9c39$var$u8to16(data, offset + 2);
        const t2 = $8691005ce78b9c39$var$u8to16(data, offset + 4);
        const t3 = $8691005ce78b9c39$var$u8to16(data, offset + 6);
        const t4 = $8691005ce78b9c39$var$u8to16(data, offset + 8);
        const t5 = $8691005ce78b9c39$var$u8to16(data, offset + 10);
        const t6 = $8691005ce78b9c39$var$u8to16(data, offset + 12);
        const t7 = $8691005ce78b9c39$var$u8to16(data, offset + 14);
        let h0 = h[0] + (t0 & 0x1fff);
        let h1 = h[1] + ((t0 >>> 13 | t1 << 3) & 0x1fff);
        let h2 = h[2] + ((t1 >>> 10 | t2 << 6) & 0x1fff);
        let h3 = h[3] + ((t2 >>> 7 | t3 << 9) & 0x1fff);
        let h4 = h[4] + ((t3 >>> 4 | t4 << 12) & 0x1fff);
        let h5 = h[5] + (t4 >>> 1 & 0x1fff);
        let h6 = h[6] + ((t4 >>> 14 | t5 << 2) & 0x1fff);
        let h7 = h[7] + ((t5 >>> 11 | t6 << 5) & 0x1fff);
        let h8 = h[8] + ((t6 >>> 8 | t7 << 8) & 0x1fff);
        let h9 = h[9] + (t7 >>> 5 | hibit);
        let c = 0;
        let d0 = c + h0 * r0 + h1 * (5 * r9) + h2 * (5 * r8) + h3 * (5 * r7) + h4 * (5 * r6);
        c = d0 >>> 13;
        d0 &= 0x1fff;
        d0 += h5 * (5 * r5) + h6 * (5 * r4) + h7 * (5 * r3) + h8 * (5 * r2) + h9 * (5 * r1);
        c += d0 >>> 13;
        d0 &= 0x1fff;
        let d1 = c + h0 * r1 + h1 * r0 + h2 * (5 * r9) + h3 * (5 * r8) + h4 * (5 * r7);
        c = d1 >>> 13;
        d1 &= 0x1fff;
        d1 += h5 * (5 * r6) + h6 * (5 * r5) + h7 * (5 * r4) + h8 * (5 * r3) + h9 * (5 * r2);
        c += d1 >>> 13;
        d1 &= 0x1fff;
        let d2 = c + h0 * r2 + h1 * r1 + h2 * r0 + h3 * (5 * r9) + h4 * (5 * r8);
        c = d2 >>> 13;
        d2 &= 0x1fff;
        d2 += h5 * (5 * r7) + h6 * (5 * r6) + h7 * (5 * r5) + h8 * (5 * r4) + h9 * (5 * r3);
        c += d2 >>> 13;
        d2 &= 0x1fff;
        let d3 = c + h0 * r3 + h1 * r2 + h2 * r1 + h3 * r0 + h4 * (5 * r9);
        c = d3 >>> 13;
        d3 &= 0x1fff;
        d3 += h5 * (5 * r8) + h6 * (5 * r7) + h7 * (5 * r6) + h8 * (5 * r5) + h9 * (5 * r4);
        c += d3 >>> 13;
        d3 &= 0x1fff;
        let d4 = c + h0 * r4 + h1 * r3 + h2 * r2 + h3 * r1 + h4 * r0;
        c = d4 >>> 13;
        d4 &= 0x1fff;
        d4 += h5 * (5 * r9) + h6 * (5 * r8) + h7 * (5 * r7) + h8 * (5 * r6) + h9 * (5 * r5);
        c += d4 >>> 13;
        d4 &= 0x1fff;
        let d5 = c + h0 * r5 + h1 * r4 + h2 * r3 + h3 * r2 + h4 * r1;
        c = d5 >>> 13;
        d5 &= 0x1fff;
        d5 += h5 * r0 + h6 * (5 * r9) + h7 * (5 * r8) + h8 * (5 * r7) + h9 * (5 * r6);
        c += d5 >>> 13;
        d5 &= 0x1fff;
        let d6 = c + h0 * r6 + h1 * r5 + h2 * r4 + h3 * r3 + h4 * r2;
        c = d6 >>> 13;
        d6 &= 0x1fff;
        d6 += h5 * r1 + h6 * r0 + h7 * (5 * r9) + h8 * (5 * r8) + h9 * (5 * r7);
        c += d6 >>> 13;
        d6 &= 0x1fff;
        let d7 = c + h0 * r7 + h1 * r6 + h2 * r5 + h3 * r4 + h4 * r3;
        c = d7 >>> 13;
        d7 &= 0x1fff;
        d7 += h5 * r2 + h6 * r1 + h7 * r0 + h8 * (5 * r9) + h9 * (5 * r8);
        c += d7 >>> 13;
        d7 &= 0x1fff;
        let d8 = c + h0 * r8 + h1 * r7 + h2 * r6 + h3 * r5 + h4 * r4;
        c = d8 >>> 13;
        d8 &= 0x1fff;
        d8 += h5 * r3 + h6 * r2 + h7 * r1 + h8 * r0 + h9 * (5 * r9);
        c += d8 >>> 13;
        d8 &= 0x1fff;
        let d9 = c + h0 * r9 + h1 * r8 + h2 * r7 + h3 * r6 + h4 * r5;
        c = d9 >>> 13;
        d9 &= 0x1fff;
        d9 += h5 * r4 + h6 * r3 + h7 * r2 + h8 * r1 + h9 * r0;
        c += d9 >>> 13;
        d9 &= 0x1fff;
        c = (c << 2) + c | 0;
        c = c + d0 | 0;
        d0 = c & 0x1fff;
        c = c >>> 13;
        d1 += c;
        h[0] = d0;
        h[1] = d1;
        h[2] = d2;
        h[3] = d3;
        h[4] = d4;
        h[5] = d5;
        h[6] = d6;
        h[7] = d7;
        h[8] = d8;
        h[9] = d9;
    }
    finalize() {
        const { h: h, pad: pad } = this;
        const g = new Uint16Array(10);
        let c = h[1] >>> 13;
        h[1] &= 0x1fff;
        for(let i = 2; i < 10; i++){
            h[i] += c;
            c = h[i] >>> 13;
            h[i] &= 0x1fff;
        }
        h[0] += c * 5;
        c = h[0] >>> 13;
        h[0] &= 0x1fff;
        h[1] += c;
        c = h[1] >>> 13;
        h[1] &= 0x1fff;
        h[2] += c;
        g[0] = h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(let i = 1; i < 10; i++){
            g[i] = h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        let mask = (c ^ 1) - 1;
        for(let i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(let i = 0; i < 10; i++)h[i] = h[i] & mask | g[i];
        h[0] = (h[0] | h[1] << 13) & 0xffff;
        h[1] = (h[1] >>> 3 | h[2] << 10) & 0xffff;
        h[2] = (h[2] >>> 6 | h[3] << 7) & 0xffff;
        h[3] = (h[3] >>> 9 | h[4] << 4) & 0xffff;
        h[4] = (h[4] >>> 12 | h[5] << 1 | h[6] << 14) & 0xffff;
        h[5] = (h[6] >>> 2 | h[7] << 11) & 0xffff;
        h[6] = (h[7] >>> 5 | h[8] << 8) & 0xffff;
        h[7] = (h[8] >>> 8 | h[9] << 5) & 0xffff;
        let f = h[0] + pad[0];
        h[0] = f & 0xffff;
        for(let i = 1; i < 8; i++){
            f = (h[i] + pad[i] | 0) + (f >>> 16) | 0;
            h[i] = f & 0xffff;
        }
        (0, $38xio.clean)(g);
    }
    update(data) {
        (0, $38xio.aexists)(this);
        (0, $38xio.abytes)(data);
        data = (0, $38xio.copyBytes)(data);
        const { buffer: buffer, blockLen: blockLen } = this;
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input
            if (take === blockLen) {
                for(; blockLen <= len - pos; pos += blockLen)this.process(data, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(buffer, 0, false);
                this.pos = 0;
            }
        }
        return this;
    }
    destroy() {
        (0, $38xio.clean)(this.h, this.r, this.buffer, this.pad);
    }
    digestInto(out) {
        (0, $38xio.aexists)(this);
        (0, $38xio.aoutput)(out, this);
        this.finished = true;
        const { buffer: buffer, h: h } = this;
        let { pos: pos } = this;
        if (pos) {
            buffer[pos++] = 1;
            for(; pos < 16; pos++)buffer[pos] = 0;
            this.process(buffer, 0, true);
        }
        this.finalize();
        let opos = 0;
        for(let i = 0; i < 8; i++){
            out[opos++] = h[i] >>> 0;
            out[opos++] = h[i] >>> 8;
        }
        return out;
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
}
function $8691005ce78b9c39$export$1fd745bcb2f0b7a8(hashCons) {
    const hashC = (msg, key)=>hashCons(key).update(msg).digest();
    const tmp = hashCons(new Uint8Array(32)); // tmp array, used just once below
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (key)=>hashCons(key);
    return hashC;
}
const $8691005ce78b9c39$export$7228b37eebb44175 = /** @__PURE__ */ (()=>$8691005ce78b9c39$export$1fd745bcb2f0b7a8((key)=>new $8691005ce78b9c39$export$c048faf97da45308(key)))();

});


parcelRegister("aN9nT", function(module, exports) {

$parcel$export(module.exports, "extract", () => $7db5c28b27589b25$export$f9380c9a627682d3);
$parcel$export(module.exports, "expand", () => $7db5c28b27589b25$export$9f77e0932fb78f72);
/**
 * HKDF (RFC 5869): extract + expand in one step.
 * See https://soatok.blog/2021/11/17/understanding-hkdf/.
 * @module
 */ 
var $70Xw9 = parcelRequire("70Xw9");

var $3Bcdj = parcelRequire("3Bcdj");
function $7db5c28b27589b25$export$f9380c9a627682d3(hash, ikm, salt) {
    (0, $3Bcdj.ahash)(hash);
    // NOTE: some libraries treat zero-length array as 'not provided';
    // we don't, since we have undefined as 'not provided'
    // https://github.com/RustCrypto/KDFs/issues/15
    if (salt === undefined) salt = new Uint8Array(hash.outputLen);
    return (0, $70Xw9.hmac)(hash, salt, ikm);
}
const $7db5c28b27589b25$var$HKDF_COUNTER = /* @__PURE__ */ Uint8Array.of(0);
const $7db5c28b27589b25$var$EMPTY_BUFFER = /* @__PURE__ */ Uint8Array.of();
function $7db5c28b27589b25$export$9f77e0932fb78f72(hash, prk, info, length = 32) {
    (0, $3Bcdj.ahash)(hash);
    (0, $3Bcdj.anumber)(length, 'length');
    const olen = hash.outputLen;
    if (length > 255 * olen) throw new Error('Length must be <= 255*HashLen');
    const blocks = Math.ceil(length / olen);
    if (info === undefined) info = $7db5c28b27589b25$var$EMPTY_BUFFER;
    else (0, $3Bcdj.abytes)(info, undefined, 'info');
    // first L(ength) octets of T
    const okm = new Uint8Array(blocks * olen);
    // Re-use HMAC instance between blocks
    const HMAC = (0, $70Xw9.hmac).create(hash, prk);
    const HMACTmp = HMAC._cloneInto();
    const T = new Uint8Array(HMAC.outputLen);
    for(let counter = 0; counter < blocks; counter++){
        $7db5c28b27589b25$var$HKDF_COUNTER[0] = counter + 1;
        // T(0) = empty string (zero length)
        // T(N) = HMAC-Hash(PRK, T(N-1) | info | N)
        HMACTmp.update(counter === 0 ? $7db5c28b27589b25$var$EMPTY_BUFFER : T).update(info).update($7db5c28b27589b25$var$HKDF_COUNTER).digestInto(T);
        okm.set(T, olen * counter);
        HMAC._cloneInto(HMACTmp);
    }
    HMAC.destroy();
    HMACTmp.destroy();
    (0, $3Bcdj.clean)(T, $7db5c28b27589b25$var$HKDF_COUNTER);
    return okm.slice(0, length);
}
const $7db5c28b27589b25$export$223341ca60fa42e2 = (hash, ikm, salt, info, length)=>$7db5c28b27589b25$export$9f77e0932fb78f72(hash, $7db5c28b27589b25$export$f9380c9a627682d3(hash, ikm, salt), info, length);

});




parcelRegister("dAcw4", function(module, exports) {

$parcel$export(module.exports, "useRelayManager", () => $bbdc9ed8fe10aeea$export$1892981fdd237f18);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

var $eWYts = parcelRequire("eWYts");
function $bbdc9ed8fe10aeea$export$1892981fdd237f18() {
    const relays = (0, $01W3b.ref)([]);
    const loading = (0, $01W3b.ref)(false);
    const error = (0, $01W3b.ref)(null);
    /**
   * Load relays from database
   */ async function loadRelays() {
        loading.value = true;
        error.value = null;
        try {
            // Initialize defaults if needed
            await (0, $eWYts.initializeDefaultRelays)();
            // Load all relays
            const allRelays = await (0, $eWYts.getAllRelays)();
            relays.value = allRelays.sort((a, b)=>a.addedAt - b.addedAt);
        } catch (err) {
            console.error('Failed to load relays:', err);
            error.value = 'Failed to load relays';
        } finally{
            loading.value = false;
        }
    }
    /**
   * Get only enabled relay URLs
   */ async function getEnabledRelayUrls() {
        const enabled = await (0, $eWYts.getEnabledRelays)();
        return enabled.map((r)=>r.url);
    }
    /**
   * Add a new relay
   */ async function addRelay(url) {
        try {
            // Validate URL
            if (!url.trim() || !url.startsWith('ws://') && !url.startsWith('wss://')) {
                error.value = 'Invalid relay URL. Must start with ws:// or wss://';
                return false;
            }
            // Check if already exists
            if (relays.value.some((r)=>r.url === url)) {
                error.value = 'Relay already exists';
                return false;
            }
            await (0, $eWYts.addRelay)(url);
            await loadRelays();
            return true;
        } catch (err) {
            console.error('Failed to add relay:', err);
            error.value = 'Failed to add relay';
            return false;
        }
    }
    /**
   * Remove a relay
   */ async function removeRelay(url) {
        try {
            await (0, $eWYts.removeRelay)(url);
            await loadRelays();
        } catch (err) {
            console.error('Failed to remove relay:', err);
            error.value = 'Failed to remove relay';
        }
    }
    /**
   * Toggle relay enabled/disabled
   */ async function toggleRelay(url) {
        try {
            await (0, $eWYts.toggleRelayEnabled)(url);
            await loadRelays();
        } catch (err) {
            console.error('Failed to toggle relay:', err);
            error.value = 'Failed to toggle relay';
        }
    }
    /**
   * Update relay connection status
   */ async function setRelayStatus(url, status, errorMsg) {
        try {
            await (0, $eWYts.updateRelayStatus)(url, status, errorMsg);
            await loadRelays();
        } catch (err) {
            console.error('Failed to update relay status:', err);
        }
    }
    /**
   * Update relay latency measurement
   */ async function setRelayLatency(url, latency) {
        try {
            await (0, $eWYts.updateRelayLatency)(url, latency);
            await loadRelays();
        } catch (err) {
            console.error('Failed to update relay latency:', err);
        }
    }
    /**
   * Get stats about relays
   */ const stats = (0, $01W3b.ref)({
        total: 0,
        enabled: 0,
        connected: 0,
        errors: 0
    });
    function updateStats() {
        stats.value = {
            total: relays.value.length,
            enabled: relays.value.filter((r)=>r.enabled).length,
            connected: relays.value.filter((r)=>r.enabled && r.status === 'connected').length,
            errors: relays.value.filter((r)=>r.enabled && r.status === 'error').length
        };
    }
    // Load relays on mount
    (0, $TusQn.onMounted)(async ()=>{
        await loadRelays();
        updateStats();
    });
    return {
        relays: relays,
        loading: loading,
        error: error,
        stats: stats,
        loadRelays: loadRelays,
        getEnabledRelayUrls: getEnabledRelayUrls,
        addRelay: addRelay,
        removeRelay: removeRelay,
        toggleRelay: toggleRelay,
        setRelayStatus: setRelayStatus,
        setRelayLatency: setRelayLatency,
        updateStats: updateStats
    };
}

});

parcelRegister("jYHYW", function(module, exports) {

$parcel$export(module.exports, "parseNostrQuery", () => $957daa7c6719d6a5$export$f772fbd8a9290551);

var $fS6LT = parcelRequire("fS6LT");
const $957daa7c6719d6a5$var$DEFAULT_KINDS = [
    1,
    30023
];
const $957daa7c6719d6a5$var$KIND_ALIASES = {
    // ─────────────────────────────
    // SOCIAL CORE
    // ─────────────────────────────
    post: [
        1
    ],
    note: [
        1
    ],
    text: [
        1
    ],
    blog: [
        30023
    ],
    longform: [
        30023
    ],
    reply: [
        1
    ],
    thread: [
        1
    ],
    repost: [
        6
    ],
    reaction: [
        7
    ],
    like: [
        7
    ],
    highlight: [
        9802
    ],
    // ─────────────────────────────
    // PROFILE / IDENTITY
    // ─────────────────────────────
    profile: [
        0
    ],
    metadata: [
        0
    ],
    contacts: [
        3
    ],
    followlist: [
        3
    ],
    relays: [
        10002
    ],
    mutelist: [
        10000
    ],
    pinlist: [
        10001
    ],
    // ─────────────────────────────
    // MESSAGING
    // ─────────────────────────────
    dm: [
        4,
        1059
    ],
    private: [
        4,
        1059
    ],
    chat: [
        42
    ],
    // ─────────────────────────────
    // EVENTS / CALENDAR (NIP-52)
    // ─────────────────────────────
    event: [
        31922,
        31923
    ],
    calendar: [
        31922,
        31923
    ],
    meeting: [
        31922,
        31923
    ],
    live: [
        30311
    ],
    // ─────────────────────────────
    // MEDIA / FILES
    // ─────────────────────────────
    file: [
        1063
    ],
    media: [
        1063
    ],
    image: [
        1063
    ],
    video: [
        1063
    ],
    // ─────────────────────────────
    // MARKETPLACE (NIP-15)
    // ─────────────────────────────
    product: [
        30017
    ],
    listing: [
        30018
    ],
    shop: [
        30017,
        30018
    ],
    // ─────────────────────────────
    // DEVELOPMENT / GIT
    // ─────────────────────────────
    issue: [
        1311
    ],
    patch: [
        1617
    ],
    repo: [
        30617
    ],
    // ─────────────────────────────
    // MODERATION / REPORTING
    // ─────────────────────────────
    report: [
        1984
    ],
    moderation: [
        1984
    ],
    // ─────────────────────────────
    // KANBAN (Kanban-NIP)
    // ─────────────────────────────
    kanban: [
        30301,
        30302
    ],
    board: [
        30301
    ],
    card: [
        30302
    ],
    tracker: [
        30302
    ],
    snapshot: [
        30303
    ],
    // ─────────────────────────────
    // ADDRESSABLE GENERIC
    // ─────────────────────────────
    document: [
        30000
    ]
};
function $957daa7c6719d6a5$var$parseDateToUnix(input) {
    if (/^\d+$/.test(input)) return Number(input);
    const match = input.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return undefined;
    const [, y, m, d] = match;
    return Math.floor(Date.UTC(+y, +m - 1, +d) / 1000);
}
function $957daa7c6719d6a5$var$decodeAuthor(value) {
    try {
        const decoded = (0, $fS6LT.nip19).decode(value);
        if (decoded.type === 'npub') return decoded.data;
        if (decoded.type === 'nprofile') return decoded.data.pubkey;
    } catch  {}
    return value;
}
function $957daa7c6719d6a5$var$decodeEventId(value) {
    try {
        const decoded = (0, $fS6LT.nip19).decode(value);
        if (decoded.type === 'note') return decoded.data;
        if (decoded.type === 'nevent') return decoded.data.id;
    } catch  {}
    return null;
}
function $957daa7c6719d6a5$var$decodeNaddr(value) {
    try {
        const decoded = (0, $fS6LT.nip19).decode(value);
        if (decoded.type === 'naddr') {
            const data = decoded.data;
            return {
                kind: data.kind,
                pubkey: data.pubkey,
                identifier: data.identifier,
                relays: data.relays
            };
        }
    } catch  {}
    return null;
}
function $957daa7c6719d6a5$var$isNostrIdentifier(value) {
    // Check if it looks like a nostr bech32 identifier
    return /^(npub|nprofile|note|nevent|naddr)[a-z0-9]{59,}$/i.test(value);
}
function $957daa7c6719d6a5$export$f772fbd8a9290551(q) {
    const filter = {};
    const searchParts = [];
    const tokens = q.match(/"[^"]*"|\S+/g) || [];
    for (const token of tokens){
        const match = token.match(/^([^:]+):(.+)$/);
        if (!match) {
            // Token without "field:" prefix
            const cleanToken = token.replace(/^"|"$/g, '');
            // Check if it's a nostr identifier (npub, nprofile, note, nevent, etc.)
            if ($957daa7c6719d6a5$var$isNostrIdentifier(cleanToken)) {
                // Try to decode as author (npub/nprofile)
                const authorPubkey = $957daa7c6719d6a5$var$decodeAuthor(cleanToken);
                if (authorPubkey !== cleanToken) {
                    // Successfully decoded as npub/nprofile
                    filter.authors ??= [];
                    filter.authors.push(authorPubkey);
                    continue;
                }
                // Try to decode as event ID (note/nevent)
                const eventId = $957daa7c6719d6a5$var$decodeEventId(cleanToken);
                if (eventId) {
                    filter.ids ??= [];
                    filter.ids.push(eventId);
                    continue;
                }
                // Try to decode as naddr (addressable event)
                const naddr = $957daa7c6719d6a5$var$decodeNaddr(cleanToken);
                if (naddr) {
                    filter.kinds = [
                        naddr.kind
                    ];
                    filter.authors ??= [];
                    filter.authors.push(naddr.pubkey);
                    filter['#d'] ??= [];
                    filter['#d'].push(naddr.identifier);
                    if (naddr.relays?.length) filter._relays = naddr.relays;
                    continue;
                }
            }
            // Not a nostr identifier, add to search text
            searchParts.push(cleanToken);
            continue;
        }
        const [, fieldRaw, raw] = match;
        const field = fieldRaw.toLowerCase();
        const values = raw.split(',').map((v)=>v.replace(/^"|"$/g, '').toLowerCase());
        switch(field){
            case 'kind':
                filter.kinds ??= [];
                values.forEach((v)=>{
                    if (/^\d+$/.test(v)) filter.kinds.push(Number(v));
                    else if ($957daa7c6719d6a5$var$KIND_ALIASES[v]) filter.kinds.push(...$957daa7c6719d6a5$var$KIND_ALIASES[v]);
                });
                break;
            case 'from':
            case 'author':
                filter.authors ??= [];
                values.forEach((v)=>filter.authors.push($957daa7c6719d6a5$var$decodeAuthor(v)));
                break;
            case 'id':
                filter.ids ??= [];
                values.forEach((v)=>{
                    // Try to decode note/nevent, otherwise use as-is
                    const eventId = $957daa7c6719d6a5$var$decodeEventId(v);
                    filter.ids.push(eventId || v);
                });
                break;
            case '#t':
            case 'tag':
                filter['#t'] ??= [];
                values.forEach((v)=>filter['#t'].push(v));
                break;
            case '#p':
                filter['#p'] ??= [];
                values.forEach((v)=>filter['#p'].push($957daa7c6719d6a5$var$decodeAuthor(v)));
                break;
            case '#e':
                filter['#e'] ??= [];
                values.forEach((v)=>filter['#e'].push(v));
                break;
            case 'since':
                const since = $957daa7c6719d6a5$var$parseDateToUnix(values[0]);
                if (since) filter.since = since;
                break;
            case 'until':
                const until = $957daa7c6719d6a5$var$parseDateToUnix(values[0]);
                if (until) filter.until = until;
                break;
            case 'limit':
                if (/^\d+$/.test(values[0])) filter.limit = Number(values[0]);
                else filter.limit = 100;
                break;
            default:
                searchParts.push(token);
        }
    }
    // Default kinds wenn keine angegeben
    if (!filter.kinds || filter.kinds.length === 0) filter.kinds = [
        ...$957daa7c6719d6a5$var$DEFAULT_KINDS
    ];
    // Dedupe arrays
    for(const key in filter)if (Array.isArray(filter[key])) filter[key] = [
        ...new Set(filter[key])
    ];
    if (searchParts.length) filter.search = searchParts.join(' ').trim();
    return filter;
}

});

parcelRegister("6zZma", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("5ycI5")).default);

var $5ycI5 = parcelRequire("5ycI5");

});
parcelRegister("5ycI5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d15360f132ce1e2$export$2e2bcd8739ae039);
// Main parser class

var $l5FiO = parcelRequire("l5FiO");

var $4oH8P = parcelRequire("4oH8P");

var $9FY5l = parcelRequire("9FY5l");

var $k9yBo = parcelRequire("k9yBo");

var $85F5r = parcelRequire("85F5r");

var $9FoBR = parcelRequire("9FoBR");

var $kIdHQ = parcelRequire("kIdHQ");
parcelRequire("iE1pk");
var $kmYAe = parcelRequire("kmYAe");
var $aFwAD = parcelRequire("aFwAD");
var $aBYW1 = parcelRequire("aBYW1");
var $70wrN = parcelRequire("70wrN");

var $hwtSr = parcelRequire("hwtSr");

var $3haLu = parcelRequire("3haLu");

var $acdgp = parcelRequire("acdgp");

var $7GnFn = parcelRequire("7GnFn");
const $0d15360f132ce1e2$var$config = {
    default: (0, $3haLu.default),
    zero: (0, $acdgp.default),
    commonmark: (0, $7GnFn.default)
};
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
const $0d15360f132ce1e2$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
const $0d15360f132ce1e2$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $0d15360f132ce1e2$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    const str = url.trim().toLowerCase();
    return $0d15360f132ce1e2$var$BAD_PROTO_RE.test(str) ? $0d15360f132ce1e2$var$GOOD_DATA_RE.test(str) : true;
}
const $0d15360f132ce1e2$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $0d15360f132ce1e2$var$normalizeLink(url) {
    const parsed = $70wrN.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $0d15360f132ce1e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $hwtSr.default).toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $aFwAD.default($aBYW1.default(parsed));
}
function $0d15360f132ce1e2$var$normalizeLinkText(url) {
    const parsed = $70wrN.default(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $0d15360f132ce1e2$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = (0, $hwtSr.default).toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $kmYAe.default($aBYW1.default(parsed), $kmYAe.default.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.mjs) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.mjs) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.mjs) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.mjs) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>` or `<code>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre><code class="hljs">' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre><code class="hljs">' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $0d15360f132ce1e2$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $0d15360f132ce1e2$var$MarkdownIt)) return new $0d15360f132ce1e2$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$l5FiO.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new (0, $9FoBR.default)();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new (0, $85F5r.default)();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new (0, $k9yBo.default)();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs).
   **/ this.renderer = new (0, $9FY5l.default)();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.mjs)
   * rule.
   **/ this.linkify = new (0, $kIdHQ.default)();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $0d15360f132ce1e2$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $0d15360f132ce1e2$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $0d15360f132ce1e2$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.mjs).
   **/ this.utils = $l5FiO;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $l5FiO.assign({}, $4oH8P);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.set = function(options) {
    $l5FiO.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.configure = function(presets) {
    const self = this;
    if ($l5FiO.isString(presets)) {
        const presetName = presets;
        presets = $0d15360f132ce1e2$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    let result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    const missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    const args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    const state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.parseInline = function(src, env) {
    const state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $0d15360f132ce1e2$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
var $0d15360f132ce1e2$export$2e2bcd8739ae039 = $0d15360f132ce1e2$var$MarkdownIt;

});
parcelRegister("l5FiO", function(module, exports) {

$parcel$export(module.exports, "isString", () => $acb166200129f66e$export$844ec244b1367d54);
$parcel$export(module.exports, "has", () => $acb166200129f66e$export$a4f4bb6b1453fff5);
$parcel$export(module.exports, "assign", () => $acb166200129f66e$export$e6e34fd1f2686227);
$parcel$export(module.exports, "arrayReplaceAt", () => $acb166200129f66e$export$f78478f71955b6bc);
$parcel$export(module.exports, "isValidEntityCode", () => $acb166200129f66e$export$644a8f5b13b2a36d);
$parcel$export(module.exports, "fromCodePoint", () => $acb166200129f66e$export$73bfc63873071f74);
$parcel$export(module.exports, "unescapeMd", () => $acb166200129f66e$export$5ccde1ea0c14bb03);
$parcel$export(module.exports, "unescapeAll", () => $acb166200129f66e$export$db8a17c6655f7e2c);
$parcel$export(module.exports, "escapeHtml", () => $acb166200129f66e$export$4cf11838cdc2a8a8);
$parcel$export(module.exports, "escapeRE", () => $acb166200129f66e$export$bc616c8f7dc20d5d);
$parcel$export(module.exports, "isSpace", () => $acb166200129f66e$export$1d5ccafae59b4926);
$parcel$export(module.exports, "isWhiteSpace", () => $acb166200129f66e$export$3c52dd84024ae72c);
$parcel$export(module.exports, "isPunctChar", () => $acb166200129f66e$export$4888a643af800fc1);
$parcel$export(module.exports, "isMdAsciiPunct", () => $acb166200129f66e$export$829a0d33ae4e744);
$parcel$export(module.exports, "normalizeReference", () => $acb166200129f66e$export$20ef46802c8744b);
$parcel$export(module.exports, "lib", () => $acb166200129f66e$export$16c08b91f883959a);
// Utilities
//

var $iE1pk = parcelRequire("iE1pk");
parcelRequire("jV8ld");
var $65ucj = parcelRequire("65ucj");
var $uBtD2 = parcelRequire("uBtD2");
var $jV8ld = parcelRequire("jV8ld");
parcelRequire("b9bcs");
var $gsyDe = parcelRequire("gsyDe");
function $acb166200129f66e$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $acb166200129f66e$export$844ec244b1367d54(obj) {
    return $acb166200129f66e$var$_class(obj) === '[object String]';
}
const $acb166200129f66e$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $acb166200129f66e$export$a4f4bb6b1453fff5(object, key) {
    return $acb166200129f66e$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $acb166200129f66e$export$e6e34fd1f2686227(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $acb166200129f66e$export$f78478f71955b6bc(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
function $acb166200129f66e$export$644a8f5b13b2a36d(c) {
    /* eslint no-bitwise:0 */ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $acb166200129f66e$export$73bfc63873071f74(c) {
    /* eslint no-bitwise:0 */ if (c > 0xffff) {
        c -= 0x10000;
        const surrogate1 = 0xd800 + (c >> 10);
        const surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
const $acb166200129f66e$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g;
const $acb166200129f66e$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
const $acb166200129f66e$var$UNESCAPE_ALL_RE = new RegExp($acb166200129f66e$var$UNESCAPE_MD_RE.source + '|' + $acb166200129f66e$var$ENTITY_RE.source, 'gi');
const $acb166200129f66e$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function $acb166200129f66e$var$replaceEntityPattern(match, name) {
    if (name.charCodeAt(0) === 0x23 /* # */  && $acb166200129f66e$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        const code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($acb166200129f66e$export$644a8f5b13b2a36d(code)) return $acb166200129f66e$export$73bfc63873071f74(code);
        return match;
    }
    const decoded = (0, $gsyDe.decodeHTML)(match);
    if (decoded !== match) return decoded;
    return match;
}
/* function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
} */ function $acb166200129f66e$export$5ccde1ea0c14bb03(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($acb166200129f66e$var$UNESCAPE_MD_RE, '$1');
}
function $acb166200129f66e$export$db8a17c6655f7e2c(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($acb166200129f66e$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $acb166200129f66e$var$replaceEntityPattern(match, entity);
    });
}
const $acb166200129f66e$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
const $acb166200129f66e$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
const $acb166200129f66e$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $acb166200129f66e$var$replaceUnsafeChar(ch) {
    return $acb166200129f66e$var$HTML_REPLACEMENTS[ch];
}
function $acb166200129f66e$export$4cf11838cdc2a8a8(str) {
    if ($acb166200129f66e$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($acb166200129f66e$var$HTML_ESCAPE_REPLACE_RE, $acb166200129f66e$var$replaceUnsafeChar);
    return str;
}
const $acb166200129f66e$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $acb166200129f66e$export$bc616c8f7dc20d5d(str) {
    return str.replace($acb166200129f66e$var$REGEXP_ESCAPE_RE, '\\$&');
}
function $acb166200129f66e$export$1d5ccafae59b4926(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $acb166200129f66e$export$3c52dd84024ae72c(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}
/* eslint-disable max-len */ // Currently without astral characters support.
function $acb166200129f66e$export$4888a643af800fc1(ch) {
    return $65ucj.default.test(ch) || $uBtD2.default.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $acb166200129f66e$export$829a0d33ae4e744(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $acb166200129f66e$export$20ef46802c8744b(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
const $acb166200129f66e$export$16c08b91f883959a = {
    mdurl: $iE1pk,
    ucmicro: $jV8ld
};

});
parcelRegister("iE1pk", function(module, exports) {

$parcel$export(module.exports, "decode", () => (parcelRequire("kmYAe")).default);
$parcel$export(module.exports, "encode", () => (parcelRequire("aFwAD")).default);
$parcel$export(module.exports, "format", () => (parcelRequire("aBYW1")).default);
$parcel$export(module.exports, "parse", () => (parcelRequire("70wrN")).default);

var $kmYAe = parcelRequire("kmYAe");

var $aFwAD = parcelRequire("aFwAD");

var $aBYW1 = parcelRequire("aBYW1");

var $70wrN = parcelRequire("70wrN");

});
parcelRegister("kmYAe", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d34e69e6f2a0359$export$2e2bcd8739ae039);
/* eslint-disable no-bitwise */ const $0d34e69e6f2a0359$var$decodeCache = {};
function $0d34e69e6f2a0359$var$getDecodeCache(exclude) {
    let cache = $0d34e69e6f2a0359$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $0d34e69e6f2a0359$var$decodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(let i = 0; i < exclude.length; i++){
        const ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $0d34e69e6f2a0359$var$decode(string, exclude) {
    if (typeof exclude !== 'string') exclude = $0d34e69e6f2a0359$var$decode.defaultChars;
    const cache = $0d34e69e6f2a0359$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        let result = '';
        for(let i = 0, l = seq.length; i < l; i += 3){
            const b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    const chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    const chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                const b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                const b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                const b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    let chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$0d34e69e6f2a0359$var$decode.defaultChars = ';/?:@&=+$,#';
$0d34e69e6f2a0359$var$decode.componentChars = '';
var $0d34e69e6f2a0359$export$2e2bcd8739ae039 = $0d34e69e6f2a0359$var$decode;

});

parcelRegister("aFwAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a16db32880174ee4$export$2e2bcd8739ae039);
const $a16db32880174ee4$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $a16db32880174ee4$var$getEncodeCache(exclude) {
    let cache = $a16db32880174ee4$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $a16db32880174ee4$var$encodeCache[exclude] = [];
    for(let i = 0; i < 128; i++){
        const ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(let i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $a16db32880174ee4$var$encode(string, exclude, keepEscaped) {
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $a16db32880174ee4$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    const cache = $a16db32880174ee4$var$getEncodeCache(exclude);
    let result = '';
    for(let i = 0, l = string.length; i < l; i++){
        const code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                const nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$a16db32880174ee4$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$a16db32880174ee4$var$encode.componentChars = "-_.!~*'()";
var $a16db32880174ee4$export$2e2bcd8739ae039 = $a16db32880174ee4$var$encode;

});

parcelRegister("aBYW1", function(module, exports) {

$parcel$export(module.exports, "default", () => $555640cbd60e2fdc$export$2e2bcd8739ae039);
function $555640cbd60e2fdc$export$2e2bcd8739ae039(url) {
    let result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
}

});

parcelRegister("70wrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $544ec39afc7ce01f$export$2e2bcd8739ae039);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $544ec39afc7ce01f$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
const $544ec39afc7ce01f$var$protocolPattern = /^([a-z0-9.+-]+:)/i;
const $544ec39afc7ce01f$var$portPattern = /:[0-9]*$/;
// Special case for a simple path URL
/* eslint-disable-next-line no-useless-escape */ const $544ec39afc7ce01f$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/;
// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
const $544ec39afc7ce01f$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
];
// RFC 2396: characters not allowed for various reasons.
const $544ec39afc7ce01f$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($544ec39afc7ce01f$var$delims);
// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
const $544ec39afc7ce01f$var$autoEscape = [
    '\''
].concat($544ec39afc7ce01f$var$unwise);
// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
const $544ec39afc7ce01f$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($544ec39afc7ce01f$var$autoEscape);
const $544ec39afc7ce01f$var$hostEndingChars = [
    '/',
    '?',
    '#'
];
const $544ec39afc7ce01f$var$hostnameMaxLen = 255;
const $544ec39afc7ce01f$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/;
const $544ec39afc7ce01f$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/;
// protocols that can allow "unsafe" and "unwise" chars.
// protocols that never have a hostname.
const $544ec39afc7ce01f$var$hostlessProtocol = {
    javascript: true,
    'javascript:': true
};
// protocols that always contain a // bit.
const $544ec39afc7ce01f$var$slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
function $544ec39afc7ce01f$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $544ec39afc7ce01f$var$Url) return url;
    const u = new $544ec39afc7ce01f$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$544ec39afc7ce01f$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    let lowerProto, hec, slashes;
    let rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        const simplePath = $544ec39afc7ce01f$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    let proto = $544ec39afc7ce01f$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    /* eslint-disable-next-line no-useless-escape */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $544ec39afc7ce01f$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$544ec39afc7ce01f$var$hostlessProtocol[proto] && (slashes || proto && !$544ec39afc7ce01f$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        let hostEnd = -1;
        for(let i = 0; i < $544ec39afc7ce01f$var$hostEndingChars.length; i++){
            hec = rest.indexOf($544ec39afc7ce01f$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        let auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(let i = 0; i < $544ec39afc7ce01f$var$nonHostChars.length; i++){
            hec = rest.indexOf($544ec39afc7ce01f$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        const host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        const ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            const hostparts = this.hostname.split(/\./);
            for(let i = 0, l = hostparts.length; i < l; i++){
                const part = hostparts[i];
                if (!part) continue;
                if (!part.match($544ec39afc7ce01f$var$hostnamePartPattern)) {
                    let newpart = '';
                    for(let j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($544ec39afc7ce01f$var$hostnamePartPattern)) {
                        const validParts = hostparts.slice(0, i);
                        const notHost = hostparts.slice(i + 1);
                        const bit = part.match($544ec39afc7ce01f$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $544ec39afc7ce01f$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    const hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    const qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($544ec39afc7ce01f$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$544ec39afc7ce01f$var$Url.prototype.parseHost = function(host) {
    let port = $544ec39afc7ce01f$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
var $544ec39afc7ce01f$export$2e2bcd8739ae039 = $544ec39afc7ce01f$var$urlParse;

});


parcelRegister("jV8ld", function(module, exports) {

$parcel$export(module.exports, "Any", () => (parcelRequire("2JiuG")).default);
$parcel$export(module.exports, "Cc", () => (parcelRequire("9hAfm")).default);
$parcel$export(module.exports, "Cf", () => (parcelRequire("jbbXc")).default);
$parcel$export(module.exports, "P", () => (parcelRequire("65ucj")).default);
$parcel$export(module.exports, "S", () => (parcelRequire("uBtD2")).default);
$parcel$export(module.exports, "Z", () => (parcelRequire("36wNu")).default);

var $2JiuG = parcelRequire("2JiuG");

var $9hAfm = parcelRequire("9hAfm");

var $jbbXc = parcelRequire("jbbXc");

var $65ucj = parcelRequire("65ucj");

var $uBtD2 = parcelRequire("uBtD2");

var $36wNu = parcelRequire("36wNu");

});
parcelRegister("2JiuG", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbc832af4f488565$export$2e2bcd8739ae039);
var $cbc832af4f488565$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("9hAfm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23f5f283a1bf321$export$2e2bcd8739ae039);
var $c23f5f283a1bf321$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("jbbXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b025739c405fffe$export$2e2bcd8739ae039);
var $8b025739c405fffe$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});

parcelRegister("65ucj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e24366eb89af439c$export$2e2bcd8739ae039);
var $e24366eb89af439c$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("uBtD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $add59bdd531def5c$export$2e2bcd8739ae039);
var $add59bdd531def5c$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;

});

parcelRegister("36wNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $df20dc3bfc54166a$export$2e2bcd8739ae039);
var $df20dc3bfc54166a$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});


parcelRegister("b9bcs", function(module, exports) {

$parcel$export(module.exports, "decodeHTML", () => (parcelRequire("gsyDe")).decodeHTML);

var $gsyDe = parcelRequire("gsyDe");

var $1Ociz = parcelRequire("1Ociz");

var $hsX54 = parcelRequire("hsX54");
var $81d939112055885e$export$b8c86583d9718b50;
(function(EntityLevel) {
    /** Support only XML entities. */ EntityLevel[EntityLevel["XML"] = 0] = "XML";
    /** Support HTML entities, which are a superset of XML entities. */ EntityLevel[EntityLevel["HTML"] = 1] = "HTML";
})($81d939112055885e$export$b8c86583d9718b50 || ($81d939112055885e$export$b8c86583d9718b50 = {}));
var $81d939112055885e$export$1851b20d614eb756;
(function(EncodingMode) {
    /**
     * The output is UTF-8 encoded. Only characters that need escaping within
     * XML will be escaped.
     */ EncodingMode[EncodingMode["UTF8"] = 0] = "UTF8";
    /**
     * The output consists only of ASCII characters. Characters that need
     * escaping within HTML, and characters that aren't ASCII characters will
     * be escaped.
     */ EncodingMode[EncodingMode["ASCII"] = 1] = "ASCII";
    /**
     * Encode all characters that have an equivalent entity, as well as all
     * characters that are not ASCII characters.
     */ EncodingMode[EncodingMode["Extensive"] = 2] = "Extensive";
    /**
     * Encode all characters that have to be escaped in HTML attributes,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Attribute"] = 3] = "Attribute";
    /**
     * Encode all characters that have to be escaped in HTML text,
     * following {@link https://html.spec.whatwg.org/multipage/parsing.html#escapingString}.
     */ EncodingMode[EncodingMode["Text"] = 4] = "Text";
})($81d939112055885e$export$1851b20d614eb756 || ($81d939112055885e$export$1851b20d614eb756 = {}));
function $81d939112055885e$export$2f872c0f2117be69(data, options = $81d939112055885e$export$b8c86583d9718b50.XML) {
    const level = typeof options === "number" ? options : options.level;
    if (level === $81d939112055885e$export$b8c86583d9718b50.HTML) {
        const mode = typeof options === "object" ? options.mode : undefined;
        return (0, $gsyDe.decodeHTML)(data, mode);
    }
    return (0, $gsyDe.decodeXML)(data);
}
function $81d939112055885e$export$c94669f4c7d36be4(data, options = $81d939112055885e$export$b8c86583d9718b50.XML) {
    var _a;
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    (_a = opts.mode) !== null && _a !== void 0 ? _a : opts.mode = (0, $gsyDe.DecodingMode).Strict;
    return $81d939112055885e$export$2f872c0f2117be69(data, opts);
}
function $81d939112055885e$export$c564cdbbe6da493(data, options = $81d939112055885e$export$b8c86583d9718b50.XML) {
    const opts = typeof options === "number" ? {
        level: options
    } : options;
    // Mode `UTF8` just escapes XML entities
    if (opts.mode === $81d939112055885e$export$1851b20d614eb756.UTF8) return (0, $hsX54.escapeUTF8)(data);
    if (opts.mode === $81d939112055885e$export$1851b20d614eb756.Attribute) return (0, $hsX54.escapeAttribute)(data);
    if (opts.mode === $81d939112055885e$export$1851b20d614eb756.Text) return (0, $hsX54.escapeText)(data);
    if (opts.level === $81d939112055885e$export$b8c86583d9718b50.HTML) {
        if (opts.mode === $81d939112055885e$export$1851b20d614eb756.ASCII) return (0, $1Ociz.encodeNonAsciiHTML)(data);
        return (0, $1Ociz.encodeHTML)(data);
    }
    // ASCII and Extensive are equivalent
    return (0, $hsX54.encodeXML)(data);
}

});
parcelRegister("gsyDe", function(module, exports) {

$parcel$export(module.exports, "DecodingMode", () => $bfba20002d453b69$export$8c8f129ce60f53c);
$parcel$export(module.exports, "decodeHTML", () => $bfba20002d453b69$export$f045cb747ce77a19);
$parcel$export(module.exports, "decodeXML", () => $bfba20002d453b69$export$88e3b9643a8bd06e);

var $dbWqt = parcelRequire("dbWqt");

var $atroa = parcelRequire("atroa");

var $6cIyx = parcelRequire("6cIyx");
var $bfba20002d453b69$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["NUM"] = 35] = "NUM";
    CharCodes[CharCodes["SEMI"] = 59] = "SEMI";
    CharCodes[CharCodes["EQUALS"] = 61] = "EQUALS";
    CharCodes[CharCodes["ZERO"] = 48] = "ZERO";
    CharCodes[CharCodes["NINE"] = 57] = "NINE";
    CharCodes[CharCodes["LOWER_A"] = 97] = "LOWER_A";
    CharCodes[CharCodes["LOWER_F"] = 102] = "LOWER_F";
    CharCodes[CharCodes["LOWER_X"] = 120] = "LOWER_X";
    CharCodes[CharCodes["LOWER_Z"] = 122] = "LOWER_Z";
    CharCodes[CharCodes["UPPER_A"] = 65] = "UPPER_A";
    CharCodes[CharCodes["UPPER_F"] = 70] = "UPPER_F";
    CharCodes[CharCodes["UPPER_Z"] = 90] = "UPPER_Z";
})($bfba20002d453b69$var$CharCodes || ($bfba20002d453b69$var$CharCodes = {}));
/** Bit that needs to be set to convert an upper case ASCII character to lower case */ const $bfba20002d453b69$var$TO_LOWER_BIT = 32;
var $bfba20002d453b69$export$6a4325c613e0faec;
(function(BinTrieFlags) {
    BinTrieFlags[BinTrieFlags["VALUE_LENGTH"] = 49152] = "VALUE_LENGTH";
    BinTrieFlags[BinTrieFlags["BRANCH_LENGTH"] = 16256] = "BRANCH_LENGTH";
    BinTrieFlags[BinTrieFlags["JUMP_TABLE"] = 127] = "JUMP_TABLE";
})($bfba20002d453b69$export$6a4325c613e0faec || ($bfba20002d453b69$export$6a4325c613e0faec = {}));
function $bfba20002d453b69$var$isNumber(code) {
    return code >= $bfba20002d453b69$var$CharCodes.ZERO && code <= $bfba20002d453b69$var$CharCodes.NINE;
}
function $bfba20002d453b69$var$isHexadecimalCharacter(code) {
    return code >= $bfba20002d453b69$var$CharCodes.UPPER_A && code <= $bfba20002d453b69$var$CharCodes.UPPER_F || code >= $bfba20002d453b69$var$CharCodes.LOWER_A && code <= $bfba20002d453b69$var$CharCodes.LOWER_F;
}
function $bfba20002d453b69$var$isAsciiAlphaNumeric(code) {
    return code >= $bfba20002d453b69$var$CharCodes.UPPER_A && code <= $bfba20002d453b69$var$CharCodes.UPPER_Z || code >= $bfba20002d453b69$var$CharCodes.LOWER_A && code <= $bfba20002d453b69$var$CharCodes.LOWER_Z || $bfba20002d453b69$var$isNumber(code);
}
/**
 * Checks if the given character is a valid end character for an entity in an attribute.
 *
 * Attribute values that aren't terminated properly aren't parsed, and shouldn't lead to a parser error.
 * See the example in https://html.spec.whatwg.org/multipage/parsing.html#named-character-reference-state
 */ function $bfba20002d453b69$var$isEntityInAttributeInvalidEnd(code) {
    return code === $bfba20002d453b69$var$CharCodes.EQUALS || $bfba20002d453b69$var$isAsciiAlphaNumeric(code);
}
var $bfba20002d453b69$var$EntityDecoderState;
(function(EntityDecoderState) {
    EntityDecoderState[EntityDecoderState["EntityStart"] = 0] = "EntityStart";
    EntityDecoderState[EntityDecoderState["NumericStart"] = 1] = "NumericStart";
    EntityDecoderState[EntityDecoderState["NumericDecimal"] = 2] = "NumericDecimal";
    EntityDecoderState[EntityDecoderState["NumericHex"] = 3] = "NumericHex";
    EntityDecoderState[EntityDecoderState["NamedEntity"] = 4] = "NamedEntity";
})($bfba20002d453b69$var$EntityDecoderState || ($bfba20002d453b69$var$EntityDecoderState = {}));
var $bfba20002d453b69$export$8c8f129ce60f53c;
(function(DecodingMode) {
    /** Entities in text nodes that can end with any character. */ DecodingMode[DecodingMode["Legacy"] = 0] = "Legacy";
    /** Only allow entities terminated with a semicolon. */ DecodingMode[DecodingMode["Strict"] = 1] = "Strict";
    /** Entities in attributes have limitations on ending characters. */ DecodingMode[DecodingMode["Attribute"] = 2] = "Attribute";
})($bfba20002d453b69$export$8c8f129ce60f53c || ($bfba20002d453b69$export$8c8f129ce60f53c = {}));
class $bfba20002d453b69$export$15263a93ff7ec8ba {
    constructor(/** The tree used to decode entities. */ decodeTree, /**
     * The function that is called when a codepoint is decoded.
     *
     * For multi-byte named entities, this will be called multiple times,
     * with the second codepoint, and the same `consumed` value.
     *
     * @param codepoint The decoded codepoint.
     * @param consumed The number of bytes consumed by the decoder.
     */ emitCodePoint, /** An object that is used to produce errors. */ errors){
        this.decodeTree = decodeTree;
        this.emitCodePoint = emitCodePoint;
        this.errors = errors;
        /** The current state of the decoder. */ this.state = $bfba20002d453b69$var$EntityDecoderState.EntityStart;
        /** Characters that were consumed while parsing an entity. */ this.consumed = 1;
        /**
         * The result of the entity.
         *
         * Either the result index of a numeric entity, or the codepoint of a
         * numeric entity.
         */ this.result = 0;
        /** The current index in the decode tree. */ this.treeIndex = 0;
        /** The number of characters that were consumed in excess. */ this.excess = 1;
        /** The mode in which the decoder is operating. */ this.decodeMode = $bfba20002d453b69$export$8c8f129ce60f53c.Strict;
    }
    /** Resets the instance to make it reusable. */ startEntity(decodeMode) {
        this.decodeMode = decodeMode;
        this.state = $bfba20002d453b69$var$EntityDecoderState.EntityStart;
        this.result = 0;
        this.treeIndex = 0;
        this.excess = 1;
        this.consumed = 1;
    }
    /**
     * Write an entity to the decoder. This can be called multiple times with partial entities.
     * If the entity is incomplete, the decoder will return -1.
     *
     * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
     * entity is incomplete, and resume when the next string is written.
     *
     * @param string The string containing the entity (or a continuation of the entity).
     * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ write(str, offset) {
        switch(this.state){
            case $bfba20002d453b69$var$EntityDecoderState.EntityStart:
                if (str.charCodeAt(offset) === $bfba20002d453b69$var$CharCodes.NUM) {
                    this.state = $bfba20002d453b69$var$EntityDecoderState.NumericStart;
                    this.consumed += 1;
                    return this.stateNumericStart(str, offset + 1);
                }
                this.state = $bfba20002d453b69$var$EntityDecoderState.NamedEntity;
                return this.stateNamedEntity(str, offset);
            case $bfba20002d453b69$var$EntityDecoderState.NumericStart:
                return this.stateNumericStart(str, offset);
            case $bfba20002d453b69$var$EntityDecoderState.NumericDecimal:
                return this.stateNumericDecimal(str, offset);
            case $bfba20002d453b69$var$EntityDecoderState.NumericHex:
                return this.stateNumericHex(str, offset);
            case $bfba20002d453b69$var$EntityDecoderState.NamedEntity:
                return this.stateNamedEntity(str, offset);
        }
    }
    /**
     * Switches between the numeric decimal and hexadecimal states.
     *
     * Equivalent to the `Numeric character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericStart(str, offset) {
        if (offset >= str.length) return -1;
        if ((str.charCodeAt(offset) | $bfba20002d453b69$var$TO_LOWER_BIT) === $bfba20002d453b69$var$CharCodes.LOWER_X) {
            this.state = $bfba20002d453b69$var$EntityDecoderState.NumericHex;
            this.consumed += 1;
            return this.stateNumericHex(str, offset + 1);
        }
        this.state = $bfba20002d453b69$var$EntityDecoderState.NumericDecimal;
        return this.stateNumericDecimal(str, offset);
    }
    addToNumericResult(str, start, end, base) {
        if (start !== end) {
            const digitCount = end - start;
            this.result = this.result * Math.pow(base, digitCount) + parseInt(str.substr(start, digitCount), base);
            this.consumed += digitCount;
        }
    }
    /**
     * Parses a hexadecimal numeric entity.
     *
     * Equivalent to the `Hexademical character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericHex(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($bfba20002d453b69$var$isNumber(char) || $bfba20002d453b69$var$isHexadecimalCharacter(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 16);
                return this.emitNumericEntity(char, 3);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 16);
        return -1;
    }
    /**
     * Parses a decimal numeric entity.
     *
     * Equivalent to the `Decimal character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNumericDecimal(str, offset) {
        const startIdx = offset;
        while(offset < str.length){
            const char = str.charCodeAt(offset);
            if ($bfba20002d453b69$var$isNumber(char)) offset += 1;
            else {
                this.addToNumericResult(str, startIdx, offset, 10);
                return this.emitNumericEntity(char, 2);
            }
        }
        this.addToNumericResult(str, startIdx, offset, 10);
        return -1;
    }
    /**
     * Validate and emit a numeric entity.
     *
     * Implements the logic from the `Hexademical character reference start
     * state` and `Numeric character reference end state` in the HTML spec.
     *
     * @param lastCp The last code point of the entity. Used to see if the
     *               entity was terminated with a semicolon.
     * @param expectedLength The minimum number of characters that should be
     *                       consumed. Used to validate that at least one digit
     *                       was consumed.
     * @returns The number of characters that were consumed.
     */ emitNumericEntity(lastCp, expectedLength) {
        var _a;
        // Ensure we consumed at least one digit.
        if (this.consumed <= expectedLength) {
            (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
            return 0;
        }
        // Figure out if this is a legit end of the entity
        if (lastCp === $bfba20002d453b69$var$CharCodes.SEMI) this.consumed += 1;
        else if (this.decodeMode === $bfba20002d453b69$export$8c8f129ce60f53c.Strict) return 0;
        this.emitCodePoint((0, $6cIyx.replaceCodePoint)(this.result), this.consumed);
        if (this.errors) {
            if (lastCp !== $bfba20002d453b69$var$CharCodes.SEMI) this.errors.missingSemicolonAfterCharacterReference();
            this.errors.validateNumericCharacterReference(this.result);
        }
        return this.consumed;
    }
    /**
     * Parses a named entity.
     *
     * Equivalent to the `Named character reference state` in the HTML spec.
     *
     * @param str The string containing the entity (or a continuation of the entity).
     * @param offset The current offset.
     * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
     */ stateNamedEntity(str, offset) {
        const { decodeTree: decodeTree } = this;
        let current = decodeTree[this.treeIndex];
        // The mask is the number of bytes of the value, including the current byte.
        let valueLength = (current & $bfba20002d453b69$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        for(; offset < str.length; offset++, this.excess++){
            const char = str.charCodeAt(offset);
            this.treeIndex = $bfba20002d453b69$export$44c08d99945e6276(decodeTree, current, this.treeIndex + Math.max(1, valueLength), char);
            if (this.treeIndex < 0) return this.result === 0 || // If we are parsing an attribute
            this.decodeMode === $bfba20002d453b69$export$8c8f129ce60f53c.Attribute && // We shouldn't have consumed any characters after the entity,
            (valueLength === 0 || // And there should be no invalid characters.
            $bfba20002d453b69$var$isEntityInAttributeInvalidEnd(char)) ? 0 : this.emitNotTerminatedNamedEntity();
            current = decodeTree[this.treeIndex];
            valueLength = (current & $bfba20002d453b69$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
            // If the branch is a value, store it and continue
            if (valueLength !== 0) {
                // If the entity is terminated by a semicolon, we are done.
                if (char === $bfba20002d453b69$var$CharCodes.SEMI) return this.emitNamedEntityData(this.treeIndex, valueLength, this.consumed + this.excess);
                // If we encounter a non-terminated (legacy) entity while parsing strictly, then ignore it.
                if (this.decodeMode !== $bfba20002d453b69$export$8c8f129ce60f53c.Strict) {
                    this.result = this.treeIndex;
                    this.consumed += this.excess;
                    this.excess = 0;
                }
            }
        }
        return -1;
    }
    /**
     * Emit a named entity that was not terminated with a semicolon.
     *
     * @returns The number of characters consumed.
     */ emitNotTerminatedNamedEntity() {
        var _a;
        const { result: result, decodeTree: decodeTree } = this;
        const valueLength = (decodeTree[result] & $bfba20002d453b69$export$6a4325c613e0faec.VALUE_LENGTH) >> 14;
        this.emitNamedEntityData(result, valueLength, this.consumed);
        (_a = this.errors) === null || _a === void 0 || _a.missingSemicolonAfterCharacterReference();
        return this.consumed;
    }
    /**
     * Emit a named entity.
     *
     * @param result The index of the entity in the decode tree.
     * @param valueLength The number of bytes in the entity.
     * @param consumed The number of characters consumed.
     *
     * @returns The number of characters consumed.
     */ emitNamedEntityData(result, valueLength, consumed) {
        const { decodeTree: decodeTree } = this;
        this.emitCodePoint(valueLength === 1 ? decodeTree[result] & ~$bfba20002d453b69$export$6a4325c613e0faec.VALUE_LENGTH : decodeTree[result + 1], consumed);
        if (valueLength === 3) // For multi-byte values, we need to emit the second byte.
        this.emitCodePoint(decodeTree[result + 2], consumed);
        return consumed;
    }
    /**
     * Signal to the parser that the end of the input was reached.
     *
     * Remaining data will be emitted and relevant errors will be produced.
     *
     * @returns The number of characters consumed.
     */ end() {
        var _a;
        switch(this.state){
            case $bfba20002d453b69$var$EntityDecoderState.NamedEntity:
                // Emit a named entity if we have one.
                return this.result !== 0 && (this.decodeMode !== $bfba20002d453b69$export$8c8f129ce60f53c.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
            // Otherwise, emit a numeric entity if we have one.
            case $bfba20002d453b69$var$EntityDecoderState.NumericDecimal:
                return this.emitNumericEntity(0, 2);
            case $bfba20002d453b69$var$EntityDecoderState.NumericHex:
                return this.emitNumericEntity(0, 3);
            case $bfba20002d453b69$var$EntityDecoderState.NumericStart:
                (_a = this.errors) === null || _a === void 0 || _a.absenceOfDigitsInNumericCharacterReference(this.consumed);
                return 0;
            case $bfba20002d453b69$var$EntityDecoderState.EntityStart:
                // Return 0 if we have no entity.
                return 0;
        }
    }
}
/**
 * Creates a function that decodes entities in a string.
 *
 * @param decodeTree The decode tree.
 * @returns A function that decodes entities in a string.
 */ function $bfba20002d453b69$var$getDecoder(decodeTree) {
    let ret = "";
    const decoder = new $bfba20002d453b69$export$15263a93ff7ec8ba(decodeTree, (str)=>ret += (0, $6cIyx.fromCodePoint)(str));
    return function decodeWithTrie(str, decodeMode) {
        let lastIndex = 0;
        let offset = 0;
        while((offset = str.indexOf("&", offset)) >= 0){
            ret += str.slice(lastIndex, offset);
            decoder.startEntity(decodeMode);
            const len = decoder.write(str, // Skip the "&"
            offset + 1);
            if (len < 0) {
                lastIndex = offset + decoder.end();
                break;
            }
            lastIndex = offset + len;
            // If `len` is 0, skip the current `&` and continue.
            offset = len === 0 ? lastIndex + 1 : lastIndex;
        }
        const result = ret + str.slice(lastIndex);
        // Make sure we don't keep a reference to the final string.
        ret = "";
        return result;
    };
}
function $bfba20002d453b69$export$44c08d99945e6276(decodeTree, current, nodeIdx, char) {
    const branchCount = (current & $bfba20002d453b69$export$6a4325c613e0faec.BRANCH_LENGTH) >> 7;
    const jumpOffset = current & $bfba20002d453b69$export$6a4325c613e0faec.JUMP_TABLE;
    // Case 1: Single branch encoded in jump offset
    if (branchCount === 0) return jumpOffset !== 0 && char === jumpOffset ? nodeIdx : -1;
    // Case 2: Multiple branches encoded in jump table
    if (jumpOffset) {
        const value = char - jumpOffset;
        return value < 0 || value >= branchCount ? -1 : decodeTree[nodeIdx + value] - 1;
    }
    // Case 3: Multiple branches encoded in dictionary
    // Binary search for the character.
    let lo = nodeIdx;
    let hi = lo + branchCount - 1;
    while(lo <= hi){
        const mid = lo + hi >>> 1;
        const midVal = decodeTree[mid];
        if (midVal < char) lo = mid + 1;
        else if (midVal > char) hi = mid - 1;
        else return decodeTree[mid + branchCount];
    }
    return -1;
}
const $bfba20002d453b69$var$htmlDecoder = $bfba20002d453b69$var$getDecoder((0, $dbWqt.default));
const $bfba20002d453b69$var$xmlDecoder = $bfba20002d453b69$var$getDecoder((0, $atroa.default));
function $bfba20002d453b69$export$f045cb747ce77a19(str, mode = $bfba20002d453b69$export$8c8f129ce60f53c.Legacy) {
    return $bfba20002d453b69$var$htmlDecoder(str, mode);
}
function $bfba20002d453b69$export$49f5e8089adb006a(str) {
    return $bfba20002d453b69$var$htmlDecoder(str, $bfba20002d453b69$export$8c8f129ce60f53c.Attribute);
}
function $bfba20002d453b69$export$da52f4371b3f37de(str) {
    return $bfba20002d453b69$var$htmlDecoder(str, $bfba20002d453b69$export$8c8f129ce60f53c.Strict);
}
function $bfba20002d453b69$export$88e3b9643a8bd06e(str) {
    return $bfba20002d453b69$var$xmlDecoder(str, $bfba20002d453b69$export$8c8f129ce60f53c.Strict);
}

});
parcelRegister("dbWqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $99a99fa061c6495f$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $99a99fa061c6495f$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u1d41<\xd5\u0131\u028a\u049d\u057b\u05d0\u0675\u06de\u07a2\u07d6\u080f\u0a4a\u0a91\u0da1\u0e6d\u0f09\u0f26\u10ca\u1228\u12e1\u1415\u149d\u14c3\u14df\u1525\0\0\0\0\0\0\u156b\u16cd\u198d\u1c12\u1ddd\u1f7e\u2060\u21b0\u228d\u23c0\u23fb\u2442\u2824\u2912\u2d08\u2e48\u2fce\u3016\u32ba\u3639\u37ac\u38fe\u3a28\u3a71\u3ae0\u3b2e\u0800EMabcfglmnoprstu\\bfms\x7f\x84\x8b\x90\x95\x98\xa6\xb3\xb9\xc8\xcflig\u803b\xc6\u40c6P\u803b&\u4026cute\u803b\xc1\u40c1reve;\u4102\u0100iyx}rc\u803b\xc2\u40c2;\u4410r;\uc000\ud835\udd04rave\u803b\xc0\u40c0pha;\u4391acr;\u4100d;\u6a53\u0100gp\x9d\xa1on;\u4104f;\uc000\ud835\udd38plyFunction;\u6061ing\u803b\xc5\u40c5\u0100cs\xbe\xc3r;\uc000\ud835\udc9cign;\u6254ilde\u803b\xc3\u40c3ml\u803b\xc4\u40c4\u0400aceforsu\xe5\xfb\xfe\u0117\u011c\u0122\u0127\u012a\u0100cr\xea\xf2kslash;\u6216\u0176\xf6\xf8;\u6ae7ed;\u6306y;\u4411\u0180crt\u0105\u010b\u0114ause;\u6235noullis;\u612ca;\u4392r;\uc000\ud835\udd05pf;\uc000\ud835\udd39eve;\u42d8c\xf2\u0113mpeq;\u624e\u0700HOacdefhilorsu\u014d\u0151\u0156\u0180\u019e\u01a2\u01b5\u01b7\u01ba\u01dc\u0215\u0273\u0278\u027ecy;\u4427PY\u803b\xa9\u40a9\u0180cpy\u015d\u0162\u017aute;\u4106\u0100;i\u0167\u0168\u62d2talDifferentialD;\u6145leys;\u612d\u0200aeio\u0189\u018e\u0194\u0198ron;\u410cdil\u803b\xc7\u40c7rc;\u4108nint;\u6230ot;\u410a\u0100dn\u01a7\u01adilla;\u40b8terDot;\u40b7\xf2\u017fi;\u43a7rcle\u0200DMPT\u01c7\u01cb\u01d1\u01d6ot;\u6299inus;\u6296lus;\u6295imes;\u6297o\u0100cs\u01e2\u01f8kwiseContourIntegral;\u6232eCurly\u0100DQ\u0203\u020foubleQuote;\u601duote;\u6019\u0200lnpu\u021e\u0228\u0247\u0255on\u0100;e\u0225\u0226\u6237;\u6a74\u0180git\u022f\u0236\u023aruent;\u6261nt;\u622fourIntegral;\u622e\u0100fr\u024c\u024e;\u6102oduct;\u6210nterClockwiseContourIntegral;\u6233oss;\u6a2fcr;\uc000\ud835\udc9ep\u0100;C\u0284\u0285\u62d3ap;\u624d\u0580DJSZacefios\u02a0\u02ac\u02b0\u02b4\u02b8\u02cb\u02d7\u02e1\u02e6\u0333\u048d\u0100;o\u0179\u02a5trahd;\u6911cy;\u4402cy;\u4405cy;\u440f\u0180grs\u02bf\u02c4\u02c7ger;\u6021r;\u61a1hv;\u6ae4\u0100ay\u02d0\u02d5ron;\u410e;\u4414l\u0100;t\u02dd\u02de\u6207a;\u4394r;\uc000\ud835\udd07\u0100af\u02eb\u0327\u0100cm\u02f0\u0322ritical\u0200ADGT\u0300\u0306\u0316\u031ccute;\u40b4o\u0174\u030b\u030d;\u42d9bleAcute;\u42ddrave;\u4060ilde;\u42dcond;\u62c4ferentialD;\u6146\u0470\u033d\0\0\0\u0342\u0354\0\u0405f;\uc000\ud835\udd3b\u0180;DE\u0348\u0349\u034d\u40a8ot;\u60dcqual;\u6250ble\u0300CDLRUV\u0363\u0372\u0382\u03cf\u03e2\u03f8ontourIntegra\xec\u0239o\u0274\u0379\0\0\u037b\xbb\u0349nArrow;\u61d3\u0100eo\u0387\u03a4ft\u0180ART\u0390\u0396\u03a1rrow;\u61d0ightArrow;\u61d4e\xe5\u02cang\u0100LR\u03ab\u03c4eft\u0100AR\u03b3\u03b9rrow;\u67f8ightArrow;\u67faightArrow;\u67f9ight\u0100AT\u03d8\u03derrow;\u61d2ee;\u62a8p\u0241\u03e9\0\0\u03efrrow;\u61d1ownArrow;\u61d5erticalBar;\u6225n\u0300ABLRTa\u0412\u042a\u0430\u045e\u047f\u037crrow\u0180;BU\u041d\u041e\u0422\u6193ar;\u6913pArrow;\u61f5reve;\u4311eft\u02d2\u043a\0\u0446\0\u0450ightVector;\u6950eeVector;\u695eector\u0100;B\u0459\u045a\u61bdar;\u6956ight\u01d4\u0467\0\u0471eeVector;\u695fector\u0100;B\u047a\u047b\u61c1ar;\u6957ee\u0100;A\u0486\u0487\u62a4rrow;\u61a7\u0100ct\u0492\u0497r;\uc000\ud835\udc9frok;\u4110\u0800NTacdfglmopqstux\u04bd\u04c0\u04c4\u04cb\u04de\u04e2\u04e7\u04ee\u04f5\u0521\u052f\u0536\u0552\u055d\u0560\u0565G;\u414aH\u803b\xd0\u40d0cute\u803b\xc9\u40c9\u0180aiy\u04d2\u04d7\u04dcron;\u411arc\u803b\xca\u40ca;\u442dot;\u4116r;\uc000\ud835\udd08rave\u803b\xc8\u40c8ement;\u6208\u0100ap\u04fa\u04fecr;\u4112ty\u0253\u0506\0\0\u0512mallSquare;\u65fberySmallSquare;\u65ab\u0100gp\u0526\u052aon;\u4118f;\uc000\ud835\udd3csilon;\u4395u\u0100ai\u053c\u0549l\u0100;T\u0542\u0543\u6a75ilde;\u6242librium;\u61cc\u0100ci\u0557\u055ar;\u6130m;\u6a73a;\u4397ml\u803b\xcb\u40cb\u0100ip\u056a\u056fsts;\u6203onentialE;\u6147\u0280cfios\u0585\u0588\u058d\u05b2\u05ccy;\u4424r;\uc000\ud835\udd09lled\u0253\u0597\0\0\u05a3mallSquare;\u65fcerySmallSquare;\u65aa\u0370\u05ba\0\u05bf\0\0\u05c4f;\uc000\ud835\udd3dAll;\u6200riertrf;\u6131c\xf2\u05cb\u0600JTabcdfgorst\u05e8\u05ec\u05ef\u05fa\u0600\u0612\u0616\u061b\u061d\u0623\u066c\u0672cy;\u4403\u803b>\u403emma\u0100;d\u05f7\u05f8\u4393;\u43dcreve;\u411e\u0180eiy\u0607\u060c\u0610dil;\u4122rc;\u411c;\u4413ot;\u4120r;\uc000\ud835\udd0a;\u62d9pf;\uc000\ud835\udd3eeater\u0300EFGLST\u0635\u0644\u064e\u0656\u065b\u0666qual\u0100;L\u063e\u063f\u6265ess;\u62dbullEqual;\u6267reater;\u6aa2ess;\u6277lantEqual;\u6a7eilde;\u6273cr;\uc000\ud835\udca2;\u626b\u0400Aacfiosu\u0685\u068b\u0696\u069b\u069e\u06aa\u06be\u06caRDcy;\u442a\u0100ct\u0690\u0694ek;\u42c7;\u405eirc;\u4124r;\u610clbertSpace;\u610b\u01f0\u06af\0\u06b2f;\u610dizontalLine;\u6500\u0100ct\u06c3\u06c5\xf2\u06a9rok;\u4126mp\u0144\u06d0\u06d8ownHum\xf0\u012fqual;\u624f\u0700EJOacdfgmnostu\u06fa\u06fe\u0703\u0707\u070e\u071a\u071e\u0721\u0728\u0744\u0778\u078b\u078f\u0795cy;\u4415lig;\u4132cy;\u4401cute\u803b\xcd\u40cd\u0100iy\u0713\u0718rc\u803b\xce\u40ce;\u4418ot;\u4130r;\u6111rave\u803b\xcc\u40cc\u0180;ap\u0720\u072f\u073f\u0100cg\u0734\u0737r;\u412ainaryI;\u6148lie\xf3\u03dd\u01f4\u0749\0\u0762\u0100;e\u074d\u074e\u622c\u0100gr\u0753\u0758ral;\u622bsection;\u62c2isible\u0100CT\u076c\u0772omma;\u6063imes;\u6062\u0180gpt\u077f\u0783\u0788on;\u412ef;\uc000\ud835\udd40a;\u4399cr;\u6110ilde;\u4128\u01eb\u079a\0\u079ecy;\u4406l\u803b\xcf\u40cf\u0280cfosu\u07ac\u07b7\u07bc\u07c2\u07d0\u0100iy\u07b1\u07b5rc;\u4134;\u4419r;\uc000\ud835\udd0dpf;\uc000\ud835\udd41\u01e3\u07c7\0\u07ccr;\uc000\ud835\udca5rcy;\u4408kcy;\u4404\u0380HJacfos\u07e4\u07e8\u07ec\u07f1\u07fd\u0802\u0808cy;\u4425cy;\u440cppa;\u439a\u0100ey\u07f6\u07fbdil;\u4136;\u441ar;\uc000\ud835\udd0epf;\uc000\ud835\udd42cr;\uc000\ud835\udca6\u0580JTaceflmost\u0825\u0829\u082c\u0850\u0863\u09b3\u09b8\u09c7\u09cd\u0a37\u0a47cy;\u4409\u803b<\u403c\u0280cmnpr\u0837\u083c\u0841\u0844\u084dute;\u4139bda;\u439bg;\u67ealacetrf;\u6112r;\u619e\u0180aey\u0857\u085c\u0861ron;\u413ddil;\u413b;\u441b\u0100fs\u0868\u0970t\u0500ACDFRTUVar\u087e\u08a9\u08b1\u08e0\u08e6\u08fc\u092f\u095b\u0390\u096a\u0100nr\u0883\u088fgleBracket;\u67e8row\u0180;BR\u0899\u089a\u089e\u6190ar;\u61e4ightArrow;\u61c6eiling;\u6308o\u01f5\u08b7\0\u08c3bleBracket;\u67e6n\u01d4\u08c8\0\u08d2eeVector;\u6961ector\u0100;B\u08db\u08dc\u61c3ar;\u6959loor;\u630aight\u0100AV\u08ef\u08f5rrow;\u6194ector;\u694e\u0100er\u0901\u0917e\u0180;AV\u0909\u090a\u0910\u62a3rrow;\u61a4ector;\u695aiangle\u0180;BE\u0924\u0925\u0929\u62b2ar;\u69cfqual;\u62b4p\u0180DTV\u0937\u0942\u094cownVector;\u6951eeVector;\u6960ector\u0100;B\u0956\u0957\u61bfar;\u6958ector\u0100;B\u0965\u0966\u61bcar;\u6952ight\xe1\u039cs\u0300EFGLST\u097e\u098b\u0995\u099d\u09a2\u09adqualGreater;\u62daullEqual;\u6266reater;\u6276ess;\u6aa1lantEqual;\u6a7dilde;\u6272r;\uc000\ud835\udd0f\u0100;e\u09bd\u09be\u62d8ftarrow;\u61daidot;\u413f\u0180npw\u09d4\u0a16\u0a1bg\u0200LRlr\u09de\u09f7\u0a02\u0a10eft\u0100AR\u09e6\u09ecrrow;\u67f5ightArrow;\u67f7ightArrow;\u67f6eft\u0100ar\u03b3\u0a0aight\xe1\u03bfight\xe1\u03caf;\uc000\ud835\udd43er\u0100LR\u0a22\u0a2ceftArrow;\u6199ightArrow;\u6198\u0180cht\u0a3e\u0a40\u0a42\xf2\u084c;\u61b0rok;\u4141;\u626a\u0400acefiosu\u0a5a\u0a5d\u0a60\u0a77\u0a7c\u0a85\u0a8b\u0a8ep;\u6905y;\u441c\u0100dl\u0a65\u0a6fiumSpace;\u605flintrf;\u6133r;\uc000\ud835\udd10nusPlus;\u6213pf;\uc000\ud835\udd44c\xf2\u0a76;\u439c\u0480Jacefostu\u0aa3\u0aa7\u0aad\u0ac0\u0b14\u0b19\u0d91\u0d97\u0d9ecy;\u440acute;\u4143\u0180aey\u0ab4\u0ab9\u0aberon;\u4147dil;\u4145;\u441d\u0180gsw\u0ac7\u0af0\u0b0eative\u0180MTV\u0ad3\u0adf\u0ae8ediumSpace;\u600bhi\u0100cn\u0ae6\u0ad8\xeb\u0ad9eryThi\xee\u0ad9ted\u0100GL\u0af8\u0b06reaterGreate\xf2\u0673essLes\xf3\u0a48Line;\u400ar;\uc000\ud835\udd11\u0200Bnpt\u0b22\u0b28\u0b37\u0b3areak;\u6060BreakingSpace;\u40a0f;\u6115\u0680;CDEGHLNPRSTV\u0b55\u0b56\u0b6a\u0b7c\u0ba1\u0beb\u0c04\u0c5e\u0c84\u0ca6\u0cd8\u0d61\u0d85\u6aec\u0100ou\u0b5b\u0b64ngruent;\u6262pCap;\u626doubleVerticalBar;\u6226\u0180lqx\u0b83\u0b8a\u0b9bement;\u6209ual\u0100;T\u0b92\u0b93\u6260ilde;\uc000\u2242\u0338ists;\u6204reater\u0380;EFGLST\u0bb6\u0bb7\u0bbd\u0bc9\u0bd3\u0bd8\u0be5\u626fqual;\u6271ullEqual;\uc000\u2267\u0338reater;\uc000\u226b\u0338ess;\u6279lantEqual;\uc000\u2a7e\u0338ilde;\u6275ump\u0144\u0bf2\u0bfdownHump;\uc000\u224e\u0338qual;\uc000\u224f\u0338e\u0100fs\u0c0a\u0c27tTriangle\u0180;BE\u0c1a\u0c1b\u0c21\u62eaar;\uc000\u29cf\u0338qual;\u62ecs\u0300;EGLST\u0c35\u0c36\u0c3c\u0c44\u0c4b\u0c58\u626equal;\u6270reater;\u6278ess;\uc000\u226a\u0338lantEqual;\uc000\u2a7d\u0338ilde;\u6274ested\u0100GL\u0c68\u0c79reaterGreater;\uc000\u2aa2\u0338essLess;\uc000\u2aa1\u0338recedes\u0180;ES\u0c92\u0c93\u0c9b\u6280qual;\uc000\u2aaf\u0338lantEqual;\u62e0\u0100ei\u0cab\u0cb9verseElement;\u620cghtTriangle\u0180;BE\u0ccb\u0ccc\u0cd2\u62ebar;\uc000\u29d0\u0338qual;\u62ed\u0100qu\u0cdd\u0d0cuareSu\u0100bp\u0ce8\u0cf9set\u0100;E\u0cf0\u0cf3\uc000\u228f\u0338qual;\u62e2erset\u0100;E\u0d03\u0d06\uc000\u2290\u0338qual;\u62e3\u0180bcp\u0d13\u0d24\u0d4eset\u0100;E\u0d1b\u0d1e\uc000\u2282\u20d2qual;\u6288ceeds\u0200;EST\u0d32\u0d33\u0d3b\u0d46\u6281qual;\uc000\u2ab0\u0338lantEqual;\u62e1ilde;\uc000\u227f\u0338erset\u0100;E\u0d58\u0d5b\uc000\u2283\u20d2qual;\u6289ilde\u0200;EFT\u0d6e\u0d6f\u0d75\u0d7f\u6241qual;\u6244ullEqual;\u6247ilde;\u6249erticalBar;\u6224cr;\uc000\ud835\udca9ilde\u803b\xd1\u40d1;\u439d\u0700Eacdfgmoprstuv\u0dbd\u0dc2\u0dc9\u0dd5\u0ddb\u0de0\u0de7\u0dfc\u0e02\u0e20\u0e22\u0e32\u0e3f\u0e44lig;\u4152cute\u803b\xd3\u40d3\u0100iy\u0dce\u0dd3rc\u803b\xd4\u40d4;\u441eblac;\u4150r;\uc000\ud835\udd12rave\u803b\xd2\u40d2\u0180aei\u0dee\u0df2\u0df6cr;\u414cga;\u43a9cron;\u439fpf;\uc000\ud835\udd46enCurly\u0100DQ\u0e0e\u0e1aoubleQuote;\u601cuote;\u6018;\u6a54\u0100cl\u0e27\u0e2cr;\uc000\ud835\udcaaash\u803b\xd8\u40d8i\u016c\u0e37\u0e3cde\u803b\xd5\u40d5es;\u6a37ml\u803b\xd6\u40d6er\u0100BP\u0e4b\u0e60\u0100ar\u0e50\u0e53r;\u603eac\u0100ek\u0e5a\u0e5c;\u63deet;\u63b4arenthesis;\u63dc\u0480acfhilors\u0e7f\u0e87\u0e8a\u0e8f\u0e92\u0e94\u0e9d\u0eb0\u0efcrtialD;\u6202y;\u441fr;\uc000\ud835\udd13i;\u43a6;\u43a0usMinus;\u40b1\u0100ip\u0ea2\u0eadncareplan\xe5\u069df;\u6119\u0200;eio\u0eb9\u0eba\u0ee0\u0ee4\u6abbcedes\u0200;EST\u0ec8\u0ec9\u0ecf\u0eda\u627aqual;\u6aaflantEqual;\u627cilde;\u627eme;\u6033\u0100dp\u0ee9\u0eeeuct;\u620fortion\u0100;a\u0225\u0ef9l;\u621d\u0100ci\u0f01\u0f06r;\uc000\ud835\udcab;\u43a8\u0200Ufos\u0f11\u0f16\u0f1b\u0f1fOT\u803b\"\u4022r;\uc000\ud835\udd14pf;\u611acr;\uc000\ud835\udcac\u0600BEacefhiorsu\u0f3e\u0f43\u0f47\u0f60\u0f73\u0fa7\u0faa\u0fad\u1096\u10a9\u10b4\u10bearr;\u6910G\u803b\xae\u40ae\u0180cnr\u0f4e\u0f53\u0f56ute;\u4154g;\u67ebr\u0100;t\u0f5c\u0f5d\u61a0l;\u6916\u0180aey\u0f67\u0f6c\u0f71ron;\u4158dil;\u4156;\u4420\u0100;v\u0f78\u0f79\u611cerse\u0100EU\u0f82\u0f99\u0100lq\u0f87\u0f8eement;\u620builibrium;\u61cbpEquilibrium;\u696fr\xbb\u0f79o;\u43a1ght\u0400ACDFTUVa\u0fc1\u0feb\u0ff3\u1022\u1028\u105b\u1087\u03d8\u0100nr\u0fc6\u0fd2gleBracket;\u67e9row\u0180;BL\u0fdc\u0fdd\u0fe1\u6192ar;\u61e5eftArrow;\u61c4eiling;\u6309o\u01f5\u0ff9\0\u1005bleBracket;\u67e7n\u01d4\u100a\0\u1014eeVector;\u695dector\u0100;B\u101d\u101e\u61c2ar;\u6955loor;\u630b\u0100er\u102d\u1043e\u0180;AV\u1035\u1036\u103c\u62a2rrow;\u61a6ector;\u695biangle\u0180;BE\u1050\u1051\u1055\u62b3ar;\u69d0qual;\u62b5p\u0180DTV\u1063\u106e\u1078ownVector;\u694feeVector;\u695cector\u0100;B\u1082\u1083\u61bear;\u6954ector\u0100;B\u1091\u1092\u61c0ar;\u6953\u0100pu\u109b\u109ef;\u611dndImplies;\u6970ightarrow;\u61db\u0100ch\u10b9\u10bcr;\u611b;\u61b1leDelayed;\u69f4\u0680HOacfhimoqstu\u10e4\u10f1\u10f7\u10fd\u1119\u111e\u1151\u1156\u1161\u1167\u11b5\u11bb\u11bf\u0100Cc\u10e9\u10eeHcy;\u4429y;\u4428FTcy;\u442ccute;\u415a\u0280;aeiy\u1108\u1109\u110e\u1113\u1117\u6abcron;\u4160dil;\u415erc;\u415c;\u4421r;\uc000\ud835\udd16ort\u0200DLRU\u112a\u1134\u113e\u1149ownArrow\xbb\u041eeftArrow\xbb\u089aightArrow\xbb\u0fddpArrow;\u6191gma;\u43a3allCircle;\u6218pf;\uc000\ud835\udd4a\u0272\u116d\0\0\u1170t;\u621aare\u0200;ISU\u117b\u117c\u1189\u11af\u65a1ntersection;\u6293u\u0100bp\u118f\u119eset\u0100;E\u1197\u1198\u628fqual;\u6291erset\u0100;E\u11a8\u11a9\u6290qual;\u6292nion;\u6294cr;\uc000\ud835\udcaear;\u62c6\u0200bcmp\u11c8\u11db\u1209\u120b\u0100;s\u11cd\u11ce\u62d0et\u0100;E\u11cd\u11d5qual;\u6286\u0100ch\u11e0\u1205eeds\u0200;EST\u11ed\u11ee\u11f4\u11ff\u627bqual;\u6ab0lantEqual;\u627dilde;\u627fTh\xe1\u0f8c;\u6211\u0180;es\u1212\u1213\u1223\u62d1rset\u0100;E\u121c\u121d\u6283qual;\u6287et\xbb\u1213\u0580HRSacfhiors\u123e\u1244\u1249\u1255\u125e\u1271\u1276\u129f\u12c2\u12c8\u12d1ORN\u803b\xde\u40deADE;\u6122\u0100Hc\u124e\u1252cy;\u440by;\u4426\u0100bu\u125a\u125c;\u4009;\u43a4\u0180aey\u1265\u126a\u126fron;\u4164dil;\u4162;\u4422r;\uc000\ud835\udd17\u0100ei\u127b\u1289\u01f2\u1280\0\u1287efore;\u6234a;\u4398\u0100cn\u128e\u1298kSpace;\uc000\u205f\u200aSpace;\u6009lde\u0200;EFT\u12ab\u12ac\u12b2\u12bc\u623cqual;\u6243ullEqual;\u6245ilde;\u6248pf;\uc000\ud835\udd4bipleDot;\u60db\u0100ct\u12d6\u12dbr;\uc000\ud835\udcafrok;\u4166\u0ae1\u12f7\u130e\u131a\u1326\0\u132c\u1331\0\0\0\0\0\u1338\u133d\u1377\u1385\0\u13ff\u1404\u140a\u1410\u0100cr\u12fb\u1301ute\u803b\xda\u40dar\u0100;o\u1307\u1308\u619fcir;\u6949r\u01e3\u1313\0\u1316y;\u440eve;\u416c\u0100iy\u131e\u1323rc\u803b\xdb\u40db;\u4423blac;\u4170r;\uc000\ud835\udd18rave\u803b\xd9\u40d9acr;\u416a\u0100di\u1341\u1369er\u0100BP\u1348\u135d\u0100ar\u134d\u1350r;\u405fac\u0100ek\u1357\u1359;\u63dfet;\u63b5arenthesis;\u63ddon\u0100;P\u1370\u1371\u62c3lus;\u628e\u0100gp\u137b\u137fon;\u4172f;\uc000\ud835\udd4c\u0400ADETadps\u1395\u13ae\u13b8\u13c4\u03e8\u13d2\u13d7\u13f3rrow\u0180;BD\u1150\u13a0\u13a4ar;\u6912ownArrow;\u61c5ownArrow;\u6195quilibrium;\u696eee\u0100;A\u13cb\u13cc\u62a5rrow;\u61a5own\xe1\u03f3er\u0100LR\u13de\u13e8eftArrow;\u6196ightArrow;\u6197i\u0100;l\u13f9\u13fa\u43d2on;\u43a5ing;\u416ecr;\uc000\ud835\udcb0ilde;\u4168ml\u803b\xdc\u40dc\u0480Dbcdefosv\u1427\u142c\u1430\u1433\u143e\u1485\u148a\u1490\u1496ash;\u62abar;\u6aeby;\u4412ash\u0100;l\u143b\u143c\u62a9;\u6ae6\u0100er\u1443\u1445;\u62c1\u0180bty\u144c\u1450\u147aar;\u6016\u0100;i\u144f\u1455cal\u0200BLST\u1461\u1465\u146a\u1474ar;\u6223ine;\u407ceparator;\u6758ilde;\u6240ThinSpace;\u600ar;\uc000\ud835\udd19pf;\uc000\ud835\udd4dcr;\uc000\ud835\udcb1dash;\u62aa\u0280cefos\u14a7\u14ac\u14b1\u14b6\u14bcirc;\u4174dge;\u62c0r;\uc000\ud835\udd1apf;\uc000\ud835\udd4ecr;\uc000\ud835\udcb2\u0200fios\u14cb\u14d0\u14d2\u14d8r;\uc000\ud835\udd1b;\u439epf;\uc000\ud835\udd4fcr;\uc000\ud835\udcb3\u0480AIUacfosu\u14f1\u14f5\u14f9\u14fd\u1504\u150f\u1514\u151a\u1520cy;\u442fcy;\u4407cy;\u442ecute\u803b\xdd\u40dd\u0100iy\u1509\u150drc;\u4176;\u442br;\uc000\ud835\udd1cpf;\uc000\ud835\udd50cr;\uc000\ud835\udcb4ml;\u4178\u0400Hacdefos\u1535\u1539\u153f\u154b\u154f\u155d\u1560\u1564cy;\u4416cute;\u4179\u0100ay\u1544\u1549ron;\u417d;\u4417ot;\u417b\u01f2\u1554\0\u155boWidt\xe8\u0ad9a;\u4396r;\u6128pf;\u6124cr;\uc000\ud835\udcb5\u0be1\u1583\u158a\u1590\0\u15b0\u15b6\u15bf\0\0\0\0\u15c6\u15db\u15eb\u165f\u166d\0\u1695\u169b\u16b2\u16b9\0\u16becute\u803b\xe1\u40e1reve;\u4103\u0300;Ediuy\u159c\u159d\u15a1\u15a3\u15a8\u15ad\u623e;\uc000\u223e\u0333;\u623frc\u803b\xe2\u40e2te\u80bb\xb4\u0306;\u4430lig\u803b\xe6\u40e6\u0100;r\xb2\u15ba;\uc000\ud835\udd1erave\u803b\xe0\u40e0\u0100ep\u15ca\u15d6\u0100fp\u15cf\u15d4sym;\u6135\xe8\u15d3ha;\u43b1\u0100ap\u15dfc\u0100cl\u15e4\u15e7r;\u4101g;\u6a3f\u0264\u15f0\0\0\u160a\u0280;adsv\u15fa\u15fb\u15ff\u1601\u1607\u6227nd;\u6a55;\u6a5clope;\u6a58;\u6a5a\u0380;elmrsz\u1618\u1619\u161b\u161e\u163f\u164f\u1659\u6220;\u69a4e\xbb\u1619sd\u0100;a\u1625\u1626\u6221\u0461\u1630\u1632\u1634\u1636\u1638\u163a\u163c\u163e;\u69a8;\u69a9;\u69aa;\u69ab;\u69ac;\u69ad;\u69ae;\u69aft\u0100;v\u1645\u1646\u621fb\u0100;d\u164c\u164d\u62be;\u699d\u0100pt\u1654\u1657h;\u6222\xbb\xb9arr;\u637c\u0100gp\u1663\u1667on;\u4105f;\uc000\ud835\udd52\u0380;Eaeiop\u12c1\u167b\u167d\u1682\u1684\u1687\u168a;\u6a70cir;\u6a6f;\u624ad;\u624bs;\u4027rox\u0100;e\u12c1\u1692\xf1\u1683ing\u803b\xe5\u40e5\u0180cty\u16a1\u16a6\u16a8r;\uc000\ud835\udcb6;\u402amp\u0100;e\u12c1\u16af\xf1\u0288ilde\u803b\xe3\u40e3ml\u803b\xe4\u40e4\u0100ci\u16c2\u16c8onin\xf4\u0272nt;\u6a11\u0800Nabcdefiklnoprsu\u16ed\u16f1\u1730\u173c\u1743\u1748\u1778\u177d\u17e0\u17e6\u1839\u1850\u170d\u193d\u1948\u1970ot;\u6aed\u0100cr\u16f6\u171ek\u0200ceps\u1700\u1705\u170d\u1713ong;\u624cpsilon;\u43f6rime;\u6035im\u0100;e\u171a\u171b\u623dq;\u62cd\u0176\u1722\u1726ee;\u62bded\u0100;g\u172c\u172d\u6305e\xbb\u172drk\u0100;t\u135c\u1737brk;\u63b6\u0100oy\u1701\u1741;\u4431quo;\u601e\u0280cmprt\u1753\u175b\u1761\u1764\u1768aus\u0100;e\u010a\u0109ptyv;\u69b0s\xe9\u170cno\xf5\u0113\u0180ahw\u176f\u1771\u1773;\u43b2;\u6136een;\u626cr;\uc000\ud835\udd1fg\u0380costuvw\u178d\u179d\u17b3\u17c1\u17d5\u17db\u17de\u0180aiu\u1794\u1796\u179a\xf0\u0760rc;\u65efp\xbb\u1371\u0180dpt\u17a4\u17a8\u17adot;\u6a00lus;\u6a01imes;\u6a02\u0271\u17b9\0\0\u17becup;\u6a06ar;\u6605riangle\u0100du\u17cd\u17d2own;\u65bdp;\u65b3plus;\u6a04e\xe5\u1444\xe5\u14adarow;\u690d\u0180ako\u17ed\u1826\u1835\u0100cn\u17f2\u1823k\u0180lst\u17fa\u05ab\u1802ozenge;\u69ebriangle\u0200;dlr\u1812\u1813\u1818\u181d\u65b4own;\u65beeft;\u65c2ight;\u65b8k;\u6423\u01b1\u182b\0\u1833\u01b2\u182f\0\u1831;\u6592;\u65914;\u6593ck;\u6588\u0100eo\u183e\u184d\u0100;q\u1843\u1846\uc000=\u20e5uiv;\uc000\u2261\u20e5t;\u6310\u0200ptwx\u1859\u185e\u1867\u186cf;\uc000\ud835\udd53\u0100;t\u13cb\u1863om\xbb\u13cctie;\u62c8\u0600DHUVbdhmptuv\u1885\u1896\u18aa\u18bb\u18d7\u18db\u18ec\u18ff\u1905\u190a\u1910\u1921\u0200LRlr\u188e\u1890\u1892\u1894;\u6557;\u6554;\u6556;\u6553\u0280;DUdu\u18a1\u18a2\u18a4\u18a6\u18a8\u6550;\u6566;\u6569;\u6564;\u6567\u0200LRlr\u18b3\u18b5\u18b7\u18b9;\u655d;\u655a;\u655c;\u6559\u0380;HLRhlr\u18ca\u18cb\u18cd\u18cf\u18d1\u18d3\u18d5\u6551;\u656c;\u6563;\u6560;\u656b;\u6562;\u655fox;\u69c9\u0200LRlr\u18e4\u18e6\u18e8\u18ea;\u6555;\u6552;\u6510;\u650c\u0280;DUdu\u06bd\u18f7\u18f9\u18fb\u18fd;\u6565;\u6568;\u652c;\u6534inus;\u629flus;\u629eimes;\u62a0\u0200LRlr\u1919\u191b\u191d\u191f;\u655b;\u6558;\u6518;\u6514\u0380;HLRhlr\u1930\u1931\u1933\u1935\u1937\u1939\u193b\u6502;\u656a;\u6561;\u655e;\u653c;\u6524;\u651c\u0100ev\u0123\u1942bar\u803b\xa6\u40a6\u0200ceio\u1951\u1956\u195a\u1960r;\uc000\ud835\udcb7mi;\u604fm\u0100;e\u171a\u171cl\u0180;bh\u1968\u1969\u196b\u405c;\u69c5sub;\u67c8\u016c\u1974\u197el\u0100;e\u1979\u197a\u6022t\xbb\u197ap\u0180;Ee\u012f\u1985\u1987;\u6aae\u0100;q\u06dc\u06db\u0ce1\u19a7\0\u19e8\u1a11\u1a15\u1a32\0\u1a37\u1a50\0\0\u1ab4\0\0\u1ac1\0\0\u1b21\u1b2e\u1b4d\u1b52\0\u1bfd\0\u1c0c\u0180cpr\u19ad\u19b2\u19ddute;\u4107\u0300;abcds\u19bf\u19c0\u19c4\u19ca\u19d5\u19d9\u6229nd;\u6a44rcup;\u6a49\u0100au\u19cf\u19d2p;\u6a4bp;\u6a47ot;\u6a40;\uc000\u2229\ufe00\u0100eo\u19e2\u19e5t;\u6041\xee\u0693\u0200aeiu\u19f0\u19fb\u1a01\u1a05\u01f0\u19f5\0\u19f8s;\u6a4don;\u410ddil\u803b\xe7\u40e7rc;\u4109ps\u0100;s\u1a0c\u1a0d\u6a4cm;\u6a50ot;\u410b\u0180dmn\u1a1b\u1a20\u1a26il\u80bb\xb8\u01adptyv;\u69b2t\u8100\xa2;e\u1a2d\u1a2e\u40a2r\xe4\u01b2r;\uc000\ud835\udd20\u0180cei\u1a3d\u1a40\u1a4dy;\u4447ck\u0100;m\u1a47\u1a48\u6713ark\xbb\u1a48;\u43c7r\u0380;Ecefms\u1a5f\u1a60\u1a62\u1a6b\u1aa4\u1aaa\u1aae\u65cb;\u69c3\u0180;el\u1a69\u1a6a\u1a6d\u42c6q;\u6257e\u0261\u1a74\0\0\u1a88rrow\u0100lr\u1a7c\u1a81eft;\u61baight;\u61bb\u0280RSacd\u1a92\u1a94\u1a96\u1a9a\u1a9f\xbb\u0f47;\u64c8st;\u629birc;\u629aash;\u629dnint;\u6a10id;\u6aefcir;\u69c2ubs\u0100;u\u1abb\u1abc\u6663it\xbb\u1abc\u02ec\u1ac7\u1ad4\u1afa\0\u1b0aon\u0100;e\u1acd\u1ace\u403a\u0100;q\xc7\xc6\u026d\u1ad9\0\0\u1ae2a\u0100;t\u1ade\u1adf\u402c;\u4040\u0180;fl\u1ae8\u1ae9\u1aeb\u6201\xee\u1160e\u0100mx\u1af1\u1af6ent\xbb\u1ae9e\xf3\u024d\u01e7\u1afe\0\u1b07\u0100;d\u12bb\u1b02ot;\u6a6dn\xf4\u0246\u0180fry\u1b10\u1b14\u1b17;\uc000\ud835\udd54o\xe4\u0254\u8100\xa9;s\u0155\u1b1dr;\u6117\u0100ao\u1b25\u1b29rr;\u61b5ss;\u6717\u0100cu\u1b32\u1b37r;\uc000\ud835\udcb8\u0100bp\u1b3c\u1b44\u0100;e\u1b41\u1b42\u6acf;\u6ad1\u0100;e\u1b49\u1b4a\u6ad0;\u6ad2dot;\u62ef\u0380delprvw\u1b60\u1b6c\u1b77\u1b82\u1bac\u1bd4\u1bf9arr\u0100lr\u1b68\u1b6a;\u6938;\u6935\u0270\u1b72\0\0\u1b75r;\u62dec;\u62dfarr\u0100;p\u1b7f\u1b80\u61b6;\u693d\u0300;bcdos\u1b8f\u1b90\u1b96\u1ba1\u1ba5\u1ba8\u622arcap;\u6a48\u0100au\u1b9b\u1b9ep;\u6a46p;\u6a4aot;\u628dr;\u6a45;\uc000\u222a\ufe00\u0200alrv\u1bb5\u1bbf\u1bde\u1be3rr\u0100;m\u1bbc\u1bbd\u61b7;\u693cy\u0180evw\u1bc7\u1bd4\u1bd8q\u0270\u1bce\0\0\u1bd2re\xe3\u1b73u\xe3\u1b75ee;\u62ceedge;\u62cfen\u803b\xa4\u40a4earrow\u0100lr\u1bee\u1bf3eft\xbb\u1b80ight\xbb\u1bbde\xe4\u1bdd\u0100ci\u1c01\u1c07onin\xf4\u01f7nt;\u6231lcty;\u632d\u0980AHabcdefhijlorstuwz\u1c38\u1c3b\u1c3f\u1c5d\u1c69\u1c75\u1c8a\u1c9e\u1cac\u1cb7\u1cfb\u1cff\u1d0d\u1d7b\u1d91\u1dab\u1dbb\u1dc6\u1dcdr\xf2\u0381ar;\u6965\u0200glrs\u1c48\u1c4d\u1c52\u1c54ger;\u6020eth;\u6138\xf2\u1133h\u0100;v\u1c5a\u1c5b\u6010\xbb\u090a\u016b\u1c61\u1c67arow;\u690fa\xe3\u0315\u0100ay\u1c6e\u1c73ron;\u410f;\u4434\u0180;ao\u0332\u1c7c\u1c84\u0100gr\u02bf\u1c81r;\u61catseq;\u6a77\u0180glm\u1c91\u1c94\u1c98\u803b\xb0\u40b0ta;\u43b4ptyv;\u69b1\u0100ir\u1ca3\u1ca8sht;\u697f;\uc000\ud835\udd21ar\u0100lr\u1cb3\u1cb5\xbb\u08dc\xbb\u101e\u0280aegsv\u1cc2\u0378\u1cd6\u1cdc\u1ce0m\u0180;os\u0326\u1cca\u1cd4nd\u0100;s\u0326\u1cd1uit;\u6666amma;\u43ddin;\u62f2\u0180;io\u1ce7\u1ce8\u1cf8\u40f7de\u8100\xf7;o\u1ce7\u1cf0ntimes;\u62c7n\xf8\u1cf7cy;\u4452c\u026f\u1d06\0\0\u1d0arn;\u631eop;\u630d\u0280lptuw\u1d18\u1d1d\u1d22\u1d49\u1d55lar;\u4024f;\uc000\ud835\udd55\u0280;emps\u030b\u1d2d\u1d37\u1d3d\u1d42q\u0100;d\u0352\u1d33ot;\u6251inus;\u6238lus;\u6214quare;\u62a1blebarwedg\xe5\xfan\u0180adh\u112e\u1d5d\u1d67ownarrow\xf3\u1c83arpoon\u0100lr\u1d72\u1d76ef\xf4\u1cb4igh\xf4\u1cb6\u0162\u1d7f\u1d85karo\xf7\u0f42\u026f\u1d8a\0\0\u1d8ern;\u631fop;\u630c\u0180cot\u1d98\u1da3\u1da6\u0100ry\u1d9d\u1da1;\uc000\ud835\udcb9;\u4455l;\u69f6rok;\u4111\u0100dr\u1db0\u1db4ot;\u62f1i\u0100;f\u1dba\u1816\u65bf\u0100ah\u1dc0\u1dc3r\xf2\u0429a\xf2\u0fa6angle;\u69a6\u0100ci\u1dd2\u1dd5y;\u445fgrarr;\u67ff\u0900Dacdefglmnopqrstux\u1e01\u1e09\u1e19\u1e38\u0578\u1e3c\u1e49\u1e61\u1e7e\u1ea5\u1eaf\u1ebd\u1ee1\u1f2a\u1f37\u1f44\u1f4e\u1f5a\u0100Do\u1e06\u1d34o\xf4\u1c89\u0100cs\u1e0e\u1e14ute\u803b\xe9\u40e9ter;\u6a6e\u0200aioy\u1e22\u1e27\u1e31\u1e36ron;\u411br\u0100;c\u1e2d\u1e2e\u6256\u803b\xea\u40ealon;\u6255;\u444dot;\u4117\u0100Dr\u1e41\u1e45ot;\u6252;\uc000\ud835\udd22\u0180;rs\u1e50\u1e51\u1e57\u6a9aave\u803b\xe8\u40e8\u0100;d\u1e5c\u1e5d\u6a96ot;\u6a98\u0200;ils\u1e6a\u1e6b\u1e72\u1e74\u6a99nters;\u63e7;\u6113\u0100;d\u1e79\u1e7a\u6a95ot;\u6a97\u0180aps\u1e85\u1e89\u1e97cr;\u4113ty\u0180;sv\u1e92\u1e93\u1e95\u6205et\xbb\u1e93p\u01001;\u1e9d\u1ea4\u0133\u1ea1\u1ea3;\u6004;\u6005\u6003\u0100gs\u1eaa\u1eac;\u414bp;\u6002\u0100gp\u1eb4\u1eb8on;\u4119f;\uc000\ud835\udd56\u0180als\u1ec4\u1ece\u1ed2r\u0100;s\u1eca\u1ecb\u62d5l;\u69e3us;\u6a71i\u0180;lv\u1eda\u1edb\u1edf\u43b5on\xbb\u1edb;\u43f5\u0200csuv\u1eea\u1ef3\u1f0b\u1f23\u0100io\u1eef\u1e31rc\xbb\u1e2e\u0269\u1ef9\0\0\u1efb\xed\u0548ant\u0100gl\u1f02\u1f06tr\xbb\u1e5dess\xbb\u1e7a\u0180aei\u1f12\u1f16\u1f1als;\u403dst;\u625fv\u0100;D\u0235\u1f20D;\u6a78parsl;\u69e5\u0100Da\u1f2f\u1f33ot;\u6253rr;\u6971\u0180cdi\u1f3e\u1f41\u1ef8r;\u612fo\xf4\u0352\u0100ah\u1f49\u1f4b;\u43b7\u803b\xf0\u40f0\u0100mr\u1f53\u1f57l\u803b\xeb\u40ebo;\u60ac\u0180cip\u1f61\u1f64\u1f67l;\u4021s\xf4\u056e\u0100eo\u1f6c\u1f74ctatio\xee\u0559nential\xe5\u0579\u09e1\u1f92\0\u1f9e\0\u1fa1\u1fa7\0\0\u1fc6\u1fcc\0\u1fd3\0\u1fe6\u1fea\u2000\0\u2008\u205allingdotse\xf1\u1e44y;\u4444male;\u6640\u0180ilr\u1fad\u1fb3\u1fc1lig;\u8000\ufb03\u0269\u1fb9\0\0\u1fbdg;\u8000\ufb00ig;\u8000\ufb04;\uc000\ud835\udd23lig;\u8000\ufb01lig;\uc000fj\u0180alt\u1fd9\u1fdc\u1fe1t;\u666dig;\u8000\ufb02ns;\u65b1of;\u4192\u01f0\u1fee\0\u1ff3f;\uc000\ud835\udd57\u0100ak\u05bf\u1ff7\u0100;v\u1ffc\u1ffd\u62d4;\u6ad9artint;\u6a0d\u0100ao\u200c\u2055\u0100cs\u2011\u2052\u03b1\u201a\u2030\u2038\u2045\u2048\0\u2050\u03b2\u2022\u2025\u2027\u202a\u202c\0\u202e\u803b\xbd\u40bd;\u6153\u803b\xbc\u40bc;\u6155;\u6159;\u615b\u01b3\u2034\0\u2036;\u6154;\u6156\u02b4\u203e\u2041\0\0\u2043\u803b\xbe\u40be;\u6157;\u615c5;\u6158\u01b6\u204c\0\u204e;\u615a;\u615d8;\u615el;\u6044wn;\u6322cr;\uc000\ud835\udcbb\u0880Eabcdefgijlnorstv\u2082\u2089\u209f\u20a5\u20b0\u20b4\u20f0\u20f5\u20fa\u20ff\u2103\u2112\u2138\u0317\u213e\u2152\u219e\u0100;l\u064d\u2087;\u6a8c\u0180cmp\u2090\u2095\u209dute;\u41f5ma\u0100;d\u209c\u1cda\u43b3;\u6a86reve;\u411f\u0100iy\u20aa\u20aerc;\u411d;\u4433ot;\u4121\u0200;lqs\u063e\u0642\u20bd\u20c9\u0180;qs\u063e\u064c\u20c4lan\xf4\u0665\u0200;cdl\u0665\u20d2\u20d5\u20e5c;\u6aa9ot\u0100;o\u20dc\u20dd\u6a80\u0100;l\u20e2\u20e3\u6a82;\u6a84\u0100;e\u20ea\u20ed\uc000\u22db\ufe00s;\u6a94r;\uc000\ud835\udd24\u0100;g\u0673\u061bmel;\u6137cy;\u4453\u0200;Eaj\u065a\u210c\u210e\u2110;\u6a92;\u6aa5;\u6aa4\u0200Eaes\u211b\u211d\u2129\u2134;\u6269p\u0100;p\u2123\u2124\u6a8arox\xbb\u2124\u0100;q\u212e\u212f\u6a88\u0100;q\u212e\u211bim;\u62e7pf;\uc000\ud835\udd58\u0100ci\u2143\u2146r;\u610am\u0180;el\u066b\u214e\u2150;\u6a8e;\u6a90\u8300>;cdlqr\u05ee\u2160\u216a\u216e\u2173\u2179\u0100ci\u2165\u2167;\u6aa7r;\u6a7aot;\u62d7Par;\u6995uest;\u6a7c\u0280adels\u2184\u216a\u2190\u0656\u219b\u01f0\u2189\0\u218epro\xf8\u209er;\u6978q\u0100lq\u063f\u2196les\xf3\u2088i\xed\u066b\u0100en\u21a3\u21adrtneqq;\uc000\u2269\ufe00\xc5\u21aa\u0500Aabcefkosy\u21c4\u21c7\u21f1\u21f5\u21fa\u2218\u221d\u222f\u2268\u227dr\xf2\u03a0\u0200ilmr\u21d0\u21d4\u21d7\u21dbrs\xf0\u1484f\xbb\u2024il\xf4\u06a9\u0100dr\u21e0\u21e4cy;\u444a\u0180;cw\u08f4\u21eb\u21efir;\u6948;\u61adar;\u610firc;\u4125\u0180alr\u2201\u220e\u2213rts\u0100;u\u2209\u220a\u6665it\xbb\u220alip;\u6026con;\u62b9r;\uc000\ud835\udd25s\u0100ew\u2223\u2229arow;\u6925arow;\u6926\u0280amopr\u223a\u223e\u2243\u225e\u2263rr;\u61fftht;\u623bk\u0100lr\u2249\u2253eftarrow;\u61a9ightarrow;\u61aaf;\uc000\ud835\udd59bar;\u6015\u0180clt\u226f\u2274\u2278r;\uc000\ud835\udcbdas\xe8\u21f4rok;\u4127\u0100bp\u2282\u2287ull;\u6043hen\xbb\u1c5b\u0ae1\u22a3\0\u22aa\0\u22b8\u22c5\u22ce\0\u22d5\u22f3\0\0\u22f8\u2322\u2367\u2362\u237f\0\u2386\u23aa\u23b4cute\u803b\xed\u40ed\u0180;iy\u0771\u22b0\u22b5rc\u803b\xee\u40ee;\u4438\u0100cx\u22bc\u22bfy;\u4435cl\u803b\xa1\u40a1\u0100fr\u039f\u22c9;\uc000\ud835\udd26rave\u803b\xec\u40ec\u0200;ino\u073e\u22dd\u22e9\u22ee\u0100in\u22e2\u22e6nt;\u6a0ct;\u622dfin;\u69dcta;\u6129lig;\u4133\u0180aop\u22fe\u231a\u231d\u0180cgt\u2305\u2308\u2317r;\u412b\u0180elp\u071f\u230f\u2313in\xe5\u078ear\xf4\u0720h;\u4131f;\u62b7ed;\u41b5\u0280;cfot\u04f4\u232c\u2331\u233d\u2341are;\u6105in\u0100;t\u2338\u2339\u621eie;\u69dddo\xf4\u2319\u0280;celp\u0757\u234c\u2350\u235b\u2361al;\u62ba\u0100gr\u2355\u2359er\xf3\u1563\xe3\u234darhk;\u6a17rod;\u6a3c\u0200cgpt\u236f\u2372\u2376\u237by;\u4451on;\u412ff;\uc000\ud835\udd5aa;\u43b9uest\u803b\xbf\u40bf\u0100ci\u238a\u238fr;\uc000\ud835\udcben\u0280;Edsv\u04f4\u239b\u239d\u23a1\u04f3;\u62f9ot;\u62f5\u0100;v\u23a6\u23a7\u62f4;\u62f3\u0100;i\u0777\u23aelde;\u4129\u01eb\u23b8\0\u23bccy;\u4456l\u803b\xef\u40ef\u0300cfmosu\u23cc\u23d7\u23dc\u23e1\u23e7\u23f5\u0100iy\u23d1\u23d5rc;\u4135;\u4439r;\uc000\ud835\udd27ath;\u4237pf;\uc000\ud835\udd5b\u01e3\u23ec\0\u23f1r;\uc000\ud835\udcbfrcy;\u4458kcy;\u4454\u0400acfghjos\u240b\u2416\u2422\u2427\u242d\u2431\u2435\u243bppa\u0100;v\u2413\u2414\u43ba;\u43f0\u0100ey\u241b\u2420dil;\u4137;\u443ar;\uc000\ud835\udd28reen;\u4138cy;\u4445cy;\u445cpf;\uc000\ud835\udd5ccr;\uc000\ud835\udcc0\u0b80ABEHabcdefghjlmnoprstuv\u2470\u2481\u2486\u248d\u2491\u250e\u253d\u255a\u2580\u264e\u265e\u2665\u2679\u267d\u269a\u26b2\u26d8\u275d\u2768\u278b\u27c0\u2801\u2812\u0180art\u2477\u247a\u247cr\xf2\u09c6\xf2\u0395ail;\u691barr;\u690e\u0100;g\u0994\u248b;\u6a8bar;\u6962\u0963\u24a5\0\u24aa\0\u24b1\0\0\0\0\0\u24b5\u24ba\0\u24c6\u24c8\u24cd\0\u24f9ute;\u413amptyv;\u69b4ra\xee\u084cbda;\u43bbg\u0180;dl\u088e\u24c1\u24c3;\u6991\xe5\u088e;\u6a85uo\u803b\xab\u40abr\u0400;bfhlpst\u0899\u24de\u24e6\u24e9\u24eb\u24ee\u24f1\u24f5\u0100;f\u089d\u24e3s;\u691fs;\u691d\xeb\u2252p;\u61abl;\u6939im;\u6973l;\u61a2\u0180;ae\u24ff\u2500\u2504\u6aabil;\u6919\u0100;s\u2509\u250a\u6aad;\uc000\u2aad\ufe00\u0180abr\u2515\u2519\u251drr;\u690crk;\u6772\u0100ak\u2522\u252cc\u0100ek\u2528\u252a;\u407b;\u405b\u0100es\u2531\u2533;\u698bl\u0100du\u2539\u253b;\u698f;\u698d\u0200aeuy\u2546\u254b\u2556\u2558ron;\u413e\u0100di\u2550\u2554il;\u413c\xec\u08b0\xe2\u2529;\u443b\u0200cqrs\u2563\u2566\u256d\u257da;\u6936uo\u0100;r\u0e19\u1746\u0100du\u2572\u2577har;\u6967shar;\u694bh;\u61b2\u0280;fgqs\u258b\u258c\u0989\u25f3\u25ff\u6264t\u0280ahlrt\u2598\u25a4\u25b7\u25c2\u25e8rrow\u0100;t\u0899\u25a1a\xe9\u24f6arpoon\u0100du\u25af\u25b4own\xbb\u045ap\xbb\u0966eftarrows;\u61c7ight\u0180ahs\u25cd\u25d6\u25derrow\u0100;s\u08f4\u08a7arpoon\xf3\u0f98quigarro\xf7\u21f0hreetimes;\u62cb\u0180;qs\u258b\u0993\u25falan\xf4\u09ac\u0280;cdgs\u09ac\u260a\u260d\u261d\u2628c;\u6aa8ot\u0100;o\u2614\u2615\u6a7f\u0100;r\u261a\u261b\u6a81;\u6a83\u0100;e\u2622\u2625\uc000\u22da\ufe00s;\u6a93\u0280adegs\u2633\u2639\u263d\u2649\u264bppro\xf8\u24c6ot;\u62d6q\u0100gq\u2643\u2645\xf4\u0989gt\xf2\u248c\xf4\u099bi\xed\u09b2\u0180ilr\u2655\u08e1\u265asht;\u697c;\uc000\ud835\udd29\u0100;E\u099c\u2663;\u6a91\u0161\u2669\u2676r\u0100du\u25b2\u266e\u0100;l\u0965\u2673;\u696alk;\u6584cy;\u4459\u0280;acht\u0a48\u2688\u268b\u2691\u2696r\xf2\u25c1orne\xf2\u1d08ard;\u696bri;\u65fa\u0100io\u269f\u26a4dot;\u4140ust\u0100;a\u26ac\u26ad\u63b0che\xbb\u26ad\u0200Eaes\u26bb\u26bd\u26c9\u26d4;\u6268p\u0100;p\u26c3\u26c4\u6a89rox\xbb\u26c4\u0100;q\u26ce\u26cf\u6a87\u0100;q\u26ce\u26bbim;\u62e6\u0400abnoptwz\u26e9\u26f4\u26f7\u271a\u272f\u2741\u2747\u2750\u0100nr\u26ee\u26f1g;\u67ecr;\u61fdr\xeb\u08c1g\u0180lmr\u26ff\u270d\u2714eft\u0100ar\u09e6\u2707ight\xe1\u09f2apsto;\u67fcight\xe1\u09fdparrow\u0100lr\u2725\u2729ef\xf4\u24edight;\u61ac\u0180afl\u2736\u2739\u273dr;\u6985;\uc000\ud835\udd5dus;\u6a2dimes;\u6a34\u0161\u274b\u274fst;\u6217\xe1\u134e\u0180;ef\u2757\u2758\u1800\u65cange\xbb\u2758ar\u0100;l\u2764\u2765\u4028t;\u6993\u0280achmt\u2773\u2776\u277c\u2785\u2787r\xf2\u08a8orne\xf2\u1d8car\u0100;d\u0f98\u2783;\u696d;\u600eri;\u62bf\u0300achiqt\u2798\u279d\u0a40\u27a2\u27ae\u27bbquo;\u6039r;\uc000\ud835\udcc1m\u0180;eg\u09b2\u27aa\u27ac;\u6a8d;\u6a8f\u0100bu\u252a\u27b3o\u0100;r\u0e1f\u27b9;\u601arok;\u4142\u8400<;cdhilqr\u082b\u27d2\u2639\u27dc\u27e0\u27e5\u27ea\u27f0\u0100ci\u27d7\u27d9;\u6aa6r;\u6a79re\xe5\u25f2mes;\u62c9arr;\u6976uest;\u6a7b\u0100Pi\u27f5\u27f9ar;\u6996\u0180;ef\u2800\u092d\u181b\u65c3r\u0100du\u2807\u280dshar;\u694ahar;\u6966\u0100en\u2817\u2821rtneqq;\uc000\u2268\ufe00\xc5\u281e\u0700Dacdefhilnopsu\u2840\u2845\u2882\u288e\u2893\u28a0\u28a5\u28a8\u28da\u28e2\u28e4\u0a83\u28f3\u2902Dot;\u623a\u0200clpr\u284e\u2852\u2863\u287dr\u803b\xaf\u40af\u0100et\u2857\u2859;\u6642\u0100;e\u285e\u285f\u6720se\xbb\u285f\u0100;s\u103b\u2868to\u0200;dlu\u103b\u2873\u2877\u287bow\xee\u048cef\xf4\u090f\xf0\u13d1ker;\u65ae\u0100oy\u2887\u288cmma;\u6a29;\u443cash;\u6014asuredangle\xbb\u1626r;\uc000\ud835\udd2ao;\u6127\u0180cdn\u28af\u28b4\u28c9ro\u803b\xb5\u40b5\u0200;acd\u1464\u28bd\u28c0\u28c4s\xf4\u16a7ir;\u6af0ot\u80bb\xb7\u01b5us\u0180;bd\u28d2\u1903\u28d3\u6212\u0100;u\u1d3c\u28d8;\u6a2a\u0163\u28de\u28e1p;\u6adb\xf2\u2212\xf0\u0a81\u0100dp\u28e9\u28eeels;\u62a7f;\uc000\ud835\udd5e\u0100ct\u28f8\u28fdr;\uc000\ud835\udcc2pos\xbb\u159d\u0180;lm\u2909\u290a\u290d\u43bctimap;\u62b8\u0c00GLRVabcdefghijlmoprstuvw\u2942\u2953\u297e\u2989\u2998\u29da\u29e9\u2a15\u2a1a\u2a58\u2a5d\u2a83\u2a95\u2aa4\u2aa8\u2b04\u2b07\u2b44\u2b7f\u2bae\u2c34\u2c67\u2c7c\u2ce9\u0100gt\u2947\u294b;\uc000\u22d9\u0338\u0100;v\u2950\u0bcf\uc000\u226b\u20d2\u0180elt\u295a\u2972\u2976ft\u0100ar\u2961\u2967rrow;\u61cdightarrow;\u61ce;\uc000\u22d8\u0338\u0100;v\u297b\u0c47\uc000\u226a\u20d2ightarrow;\u61cf\u0100Dd\u298e\u2993ash;\u62afash;\u62ae\u0280bcnpt\u29a3\u29a7\u29ac\u29b1\u29ccla\xbb\u02deute;\u4144g;\uc000\u2220\u20d2\u0280;Eiop\u0d84\u29bc\u29c0\u29c5\u29c8;\uc000\u2a70\u0338d;\uc000\u224b\u0338s;\u4149ro\xf8\u0d84ur\u0100;a\u29d3\u29d4\u666el\u0100;s\u29d3\u0b38\u01f3\u29df\0\u29e3p\u80bb\xa0\u0b37mp\u0100;e\u0bf9\u0c00\u0280aeouy\u29f4\u29fe\u2a03\u2a10\u2a13\u01f0\u29f9\0\u29fb;\u6a43on;\u4148dil;\u4146ng\u0100;d\u0d7e\u2a0aot;\uc000\u2a6d\u0338p;\u6a42;\u443dash;\u6013\u0380;Aadqsx\u0b92\u2a29\u2a2d\u2a3b\u2a41\u2a45\u2a50rr;\u61d7r\u0100hr\u2a33\u2a36k;\u6924\u0100;o\u13f2\u13f0ot;\uc000\u2250\u0338ui\xf6\u0b63\u0100ei\u2a4a\u2a4ear;\u6928\xed\u0b98ist\u0100;s\u0ba0\u0b9fr;\uc000\ud835\udd2b\u0200Eest\u0bc5\u2a66\u2a79\u2a7c\u0180;qs\u0bbc\u2a6d\u0be1\u0180;qs\u0bbc\u0bc5\u2a74lan\xf4\u0be2i\xed\u0bea\u0100;r\u0bb6\u2a81\xbb\u0bb7\u0180Aap\u2a8a\u2a8d\u2a91r\xf2\u2971rr;\u61aear;\u6af2\u0180;sv\u0f8d\u2a9c\u0f8c\u0100;d\u2aa1\u2aa2\u62fc;\u62facy;\u445a\u0380AEadest\u2ab7\u2aba\u2abe\u2ac2\u2ac5\u2af6\u2af9r\xf2\u2966;\uc000\u2266\u0338rr;\u619ar;\u6025\u0200;fqs\u0c3b\u2ace\u2ae3\u2aeft\u0100ar\u2ad4\u2ad9rro\xf7\u2ac1ightarro\xf7\u2a90\u0180;qs\u0c3b\u2aba\u2aealan\xf4\u0c55\u0100;s\u0c55\u2af4\xbb\u0c36i\xed\u0c5d\u0100;r\u0c35\u2afei\u0100;e\u0c1a\u0c25i\xe4\u0d90\u0100pt\u2b0c\u2b11f;\uc000\ud835\udd5f\u8180\xac;in\u2b19\u2b1a\u2b36\u40acn\u0200;Edv\u0b89\u2b24\u2b28\u2b2e;\uc000\u22f9\u0338ot;\uc000\u22f5\u0338\u01e1\u0b89\u2b33\u2b35;\u62f7;\u62f6i\u0100;v\u0cb8\u2b3c\u01e1\u0cb8\u2b41\u2b43;\u62fe;\u62fd\u0180aor\u2b4b\u2b63\u2b69r\u0200;ast\u0b7b\u2b55\u2b5a\u2b5flle\xec\u0b7bl;\uc000\u2afd\u20e5;\uc000\u2202\u0338lint;\u6a14\u0180;ce\u0c92\u2b70\u2b73u\xe5\u0ca5\u0100;c\u0c98\u2b78\u0100;e\u0c92\u2b7d\xf1\u0c98\u0200Aait\u2b88\u2b8b\u2b9d\u2ba7r\xf2\u2988rr\u0180;cw\u2b94\u2b95\u2b99\u619b;\uc000\u2933\u0338;\uc000\u219d\u0338ghtarrow\xbb\u2b95ri\u0100;e\u0ccb\u0cd6\u0380chimpqu\u2bbd\u2bcd\u2bd9\u2b04\u0b78\u2be4\u2bef\u0200;cer\u0d32\u2bc6\u0d37\u2bc9u\xe5\u0d45;\uc000\ud835\udcc3ort\u026d\u2b05\0\0\u2bd6ar\xe1\u2b56m\u0100;e\u0d6e\u2bdf\u0100;q\u0d74\u0d73su\u0100bp\u2beb\u2bed\xe5\u0cf8\xe5\u0d0b\u0180bcp\u2bf6\u2c11\u2c19\u0200;Ees\u2bff\u2c00\u0d22\u2c04\u6284;\uc000\u2ac5\u0338et\u0100;e\u0d1b\u2c0bq\u0100;q\u0d23\u2c00c\u0100;e\u0d32\u2c17\xf1\u0d38\u0200;Ees\u2c22\u2c23\u0d5f\u2c27\u6285;\uc000\u2ac6\u0338et\u0100;e\u0d58\u2c2eq\u0100;q\u0d60\u2c23\u0200gilr\u2c3d\u2c3f\u2c45\u2c47\xec\u0bd7lde\u803b\xf1\u40f1\xe7\u0c43iangle\u0100lr\u2c52\u2c5ceft\u0100;e\u0c1a\u2c5a\xf1\u0c26ight\u0100;e\u0ccb\u2c65\xf1\u0cd7\u0100;m\u2c6c\u2c6d\u43bd\u0180;es\u2c74\u2c75\u2c79\u4023ro;\u6116p;\u6007\u0480DHadgilrs\u2c8f\u2c94\u2c99\u2c9e\u2ca3\u2cb0\u2cb6\u2cd3\u2ce3ash;\u62adarr;\u6904p;\uc000\u224d\u20d2ash;\u62ac\u0100et\u2ca8\u2cac;\uc000\u2265\u20d2;\uc000>\u20d2nfin;\u69de\u0180Aet\u2cbd\u2cc1\u2cc5rr;\u6902;\uc000\u2264\u20d2\u0100;r\u2cca\u2ccd\uc000<\u20d2ie;\uc000\u22b4\u20d2\u0100At\u2cd8\u2cdcrr;\u6903rie;\uc000\u22b5\u20d2im;\uc000\u223c\u20d2\u0180Aan\u2cf0\u2cf4\u2d02rr;\u61d6r\u0100hr\u2cfa\u2cfdk;\u6923\u0100;o\u13e7\u13e5ear;\u6927\u1253\u1a95\0\0\0\0\0\0\0\0\0\0\0\0\0\u2d2d\0\u2d38\u2d48\u2d60\u2d65\u2d72\u2d84\u1b07\0\0\u2d8d\u2dab\0\u2dc8\u2dce\0\u2ddc\u2e19\u2e2b\u2e3e\u2e43\u0100cs\u2d31\u1a97ute\u803b\xf3\u40f3\u0100iy\u2d3c\u2d45r\u0100;c\u1a9e\u2d42\u803b\xf4\u40f4;\u443e\u0280abios\u1aa0\u2d52\u2d57\u01c8\u2d5alac;\u4151v;\u6a38old;\u69bclig;\u4153\u0100cr\u2d69\u2d6dir;\u69bf;\uc000\ud835\udd2c\u036f\u2d79\0\0\u2d7c\0\u2d82n;\u42dbave\u803b\xf2\u40f2;\u69c1\u0100bm\u2d88\u0df4ar;\u69b5\u0200acit\u2d95\u2d98\u2da5\u2da8r\xf2\u1a80\u0100ir\u2d9d\u2da0r;\u69beoss;\u69bbn\xe5\u0e52;\u69c0\u0180aei\u2db1\u2db5\u2db9cr;\u414dga;\u43c9\u0180cdn\u2dc0\u2dc5\u01cdron;\u43bf;\u69b6pf;\uc000\ud835\udd60\u0180ael\u2dd4\u2dd7\u01d2r;\u69b7rp;\u69b9\u0380;adiosv\u2dea\u2deb\u2dee\u2e08\u2e0d\u2e10\u2e16\u6228r\xf2\u1a86\u0200;efm\u2df7\u2df8\u2e02\u2e05\u6a5dr\u0100;o\u2dfe\u2dff\u6134f\xbb\u2dff\u803b\xaa\u40aa\u803b\xba\u40bagof;\u62b6r;\u6a56lope;\u6a57;\u6a5b\u0180clo\u2e1f\u2e21\u2e27\xf2\u2e01ash\u803b\xf8\u40f8l;\u6298i\u016c\u2e2f\u2e34de\u803b\xf5\u40f5es\u0100;a\u01db\u2e3as;\u6a36ml\u803b\xf6\u40f6bar;\u633d\u0ae1\u2e5e\0\u2e7d\0\u2e80\u2e9d\0\u2ea2\u2eb9\0\0\u2ecb\u0e9c\0\u2f13\0\0\u2f2b\u2fbc\0\u2fc8r\u0200;ast\u0403\u2e67\u2e72\u0e85\u8100\xb6;l\u2e6d\u2e6e\u40b6le\xec\u0403\u0269\u2e78\0\0\u2e7bm;\u6af3;\u6afdy;\u443fr\u0280cimpt\u2e8b\u2e8f\u2e93\u1865\u2e97nt;\u4025od;\u402eil;\u6030enk;\u6031r;\uc000\ud835\udd2d\u0180imo\u2ea8\u2eb0\u2eb4\u0100;v\u2ead\u2eae\u43c6;\u43d5ma\xf4\u0a76ne;\u660e\u0180;tv\u2ebf\u2ec0\u2ec8\u43c0chfork\xbb\u1ffd;\u43d6\u0100au\u2ecf\u2edfn\u0100ck\u2ed5\u2eddk\u0100;h\u21f4\u2edb;\u610e\xf6\u21f4s\u0480;abcdemst\u2ef3\u2ef4\u1908\u2ef9\u2efd\u2f04\u2f06\u2f0a\u2f0e\u402bcir;\u6a23ir;\u6a22\u0100ou\u1d40\u2f02;\u6a25;\u6a72n\u80bb\xb1\u0e9dim;\u6a26wo;\u6a27\u0180ipu\u2f19\u2f20\u2f25ntint;\u6a15f;\uc000\ud835\udd61nd\u803b\xa3\u40a3\u0500;Eaceinosu\u0ec8\u2f3f\u2f41\u2f44\u2f47\u2f81\u2f89\u2f92\u2f7e\u2fb6;\u6ab3p;\u6ab7u\xe5\u0ed9\u0100;c\u0ece\u2f4c\u0300;acens\u0ec8\u2f59\u2f5f\u2f66\u2f68\u2f7eppro\xf8\u2f43urlye\xf1\u0ed9\xf1\u0ece\u0180aes\u2f6f\u2f76\u2f7approx;\u6ab9qq;\u6ab5im;\u62e8i\xed\u0edfme\u0100;s\u2f88\u0eae\u6032\u0180Eas\u2f78\u2f90\u2f7a\xf0\u2f75\u0180dfp\u0eec\u2f99\u2faf\u0180als\u2fa0\u2fa5\u2faalar;\u632eine;\u6312urf;\u6313\u0100;t\u0efb\u2fb4\xef\u0efbrel;\u62b0\u0100ci\u2fc0\u2fc5r;\uc000\ud835\udcc5;\u43c8ncsp;\u6008\u0300fiopsu\u2fda\u22e2\u2fdf\u2fe5\u2feb\u2ff1r;\uc000\ud835\udd2epf;\uc000\ud835\udd62rime;\u6057cr;\uc000\ud835\udcc6\u0180aeo\u2ff8\u3009\u3013t\u0100ei\u2ffe\u3005rnion\xf3\u06b0nt;\u6a16st\u0100;e\u3010\u3011\u403f\xf1\u1f19\xf4\u0f14\u0a80ABHabcdefhilmnoprstux\u3040\u3051\u3055\u3059\u30e0\u310e\u312b\u3147\u3162\u3172\u318e\u3206\u3215\u3224\u3229\u3258\u326e\u3272\u3290\u32b0\u32b7\u0180art\u3047\u304a\u304cr\xf2\u10b3\xf2\u03ddail;\u691car\xf2\u1c65ar;\u6964\u0380cdenqrt\u3068\u3075\u3078\u307f\u308f\u3094\u30cc\u0100eu\u306d\u3071;\uc000\u223d\u0331te;\u4155i\xe3\u116emptyv;\u69b3g\u0200;del\u0fd1\u3089\u308b\u308d;\u6992;\u69a5\xe5\u0fd1uo\u803b\xbb\u40bbr\u0580;abcfhlpstw\u0fdc\u30ac\u30af\u30b7\u30b9\u30bc\u30be\u30c0\u30c3\u30c7\u30cap;\u6975\u0100;f\u0fe0\u30b4s;\u6920;\u6933s;\u691e\xeb\u225d\xf0\u272el;\u6945im;\u6974l;\u61a3;\u619d\u0100ai\u30d1\u30d5il;\u691ao\u0100;n\u30db\u30dc\u6236al\xf3\u0f1e\u0180abr\u30e7\u30ea\u30eer\xf2\u17e5rk;\u6773\u0100ak\u30f3\u30fdc\u0100ek\u30f9\u30fb;\u407d;\u405d\u0100es\u3102\u3104;\u698cl\u0100du\u310a\u310c;\u698e;\u6990\u0200aeuy\u3117\u311c\u3127\u3129ron;\u4159\u0100di\u3121\u3125il;\u4157\xec\u0ff2\xe2\u30fa;\u4440\u0200clqs\u3134\u3137\u313d\u3144a;\u6937dhar;\u6969uo\u0100;r\u020e\u020dh;\u61b3\u0180acg\u314e\u315f\u0f44l\u0200;ips\u0f78\u3158\u315b\u109cn\xe5\u10bbar\xf4\u0fa9t;\u65ad\u0180ilr\u3169\u1023\u316esht;\u697d;\uc000\ud835\udd2f\u0100ao\u3177\u3186r\u0100du\u317d\u317f\xbb\u047b\u0100;l\u1091\u3184;\u696c\u0100;v\u318b\u318c\u43c1;\u43f1\u0180gns\u3195\u31f9\u31fcht\u0300ahlrst\u31a4\u31b0\u31c2\u31d8\u31e4\u31eerrow\u0100;t\u0fdc\u31ada\xe9\u30c8arpoon\u0100du\u31bb\u31bfow\xee\u317ep\xbb\u1092eft\u0100ah\u31ca\u31d0rrow\xf3\u0feaarpoon\xf3\u0551ightarrows;\u61c9quigarro\xf7\u30cbhreetimes;\u62ccg;\u42daingdotse\xf1\u1f32\u0180ahm\u320d\u3210\u3213r\xf2\u0feaa\xf2\u0551;\u600foust\u0100;a\u321e\u321f\u63b1che\xbb\u321fmid;\u6aee\u0200abpt\u3232\u323d\u3240\u3252\u0100nr\u3237\u323ag;\u67edr;\u61fer\xeb\u1003\u0180afl\u3247\u324a\u324er;\u6986;\uc000\ud835\udd63us;\u6a2eimes;\u6a35\u0100ap\u325d\u3267r\u0100;g\u3263\u3264\u4029t;\u6994olint;\u6a12ar\xf2\u31e3\u0200achq\u327b\u3280\u10bc\u3285quo;\u603ar;\uc000\ud835\udcc7\u0100bu\u30fb\u328ao\u0100;r\u0214\u0213\u0180hir\u3297\u329b\u32a0re\xe5\u31f8mes;\u62cai\u0200;efl\u32aa\u1059\u1821\u32ab\u65b9tri;\u69celuhar;\u6968;\u611e\u0d61\u32d5\u32db\u32df\u332c\u3338\u3371\0\u337a\u33a4\0\0\u33ec\u33f0\0\u3428\u3448\u345a\u34ad\u34b1\u34ca\u34f1\0\u3616\0\0\u3633cute;\u415bqu\xef\u27ba\u0500;Eaceinpsy\u11ed\u32f3\u32f5\u32ff\u3302\u330b\u330f\u331f\u3326\u3329;\u6ab4\u01f0\u32fa\0\u32fc;\u6ab8on;\u4161u\xe5\u11fe\u0100;d\u11f3\u3307il;\u415frc;\u415d\u0180Eas\u3316\u3318\u331b;\u6ab6p;\u6abaim;\u62e9olint;\u6a13i\xed\u1204;\u4441ot\u0180;be\u3334\u1d47\u3335\u62c5;\u6a66\u0380Aacmstx\u3346\u334a\u3357\u335b\u335e\u3363\u336drr;\u61d8r\u0100hr\u3350\u3352\xeb\u2228\u0100;o\u0a36\u0a34t\u803b\xa7\u40a7i;\u403bwar;\u6929m\u0100in\u3369\xf0nu\xf3\xf1t;\u6736r\u0100;o\u3376\u2055\uc000\ud835\udd30\u0200acoy\u3382\u3386\u3391\u33a0rp;\u666f\u0100hy\u338b\u338fcy;\u4449;\u4448rt\u026d\u3399\0\0\u339ci\xe4\u1464ara\xec\u2e6f\u803b\xad\u40ad\u0100gm\u33a8\u33b4ma\u0180;fv\u33b1\u33b2\u33b2\u43c3;\u43c2\u0400;deglnpr\u12ab\u33c5\u33c9\u33ce\u33d6\u33de\u33e1\u33e6ot;\u6a6a\u0100;q\u12b1\u12b0\u0100;E\u33d3\u33d4\u6a9e;\u6aa0\u0100;E\u33db\u33dc\u6a9d;\u6a9fe;\u6246lus;\u6a24arr;\u6972ar\xf2\u113d\u0200aeit\u33f8\u3408\u340f\u3417\u0100ls\u33fd\u3404lsetm\xe9\u336ahp;\u6a33parsl;\u69e4\u0100dl\u1463\u3414e;\u6323\u0100;e\u341c\u341d\u6aaa\u0100;s\u3422\u3423\u6aac;\uc000\u2aac\ufe00\u0180flp\u342e\u3433\u3442tcy;\u444c\u0100;b\u3438\u3439\u402f\u0100;a\u343e\u343f\u69c4r;\u633ff;\uc000\ud835\udd64a\u0100dr\u344d\u0402es\u0100;u\u3454\u3455\u6660it\xbb\u3455\u0180csu\u3460\u3479\u349f\u0100au\u3465\u346fp\u0100;s\u1188\u346b;\uc000\u2293\ufe00p\u0100;s\u11b4\u3475;\uc000\u2294\ufe00u\u0100bp\u347f\u348f\u0180;es\u1197\u119c\u3486et\u0100;e\u1197\u348d\xf1\u119d\u0180;es\u11a8\u11ad\u3496et\u0100;e\u11a8\u349d\xf1\u11ae\u0180;af\u117b\u34a6\u05b0r\u0165\u34ab\u05b1\xbb\u117car\xf2\u1148\u0200cemt\u34b9\u34be\u34c2\u34c5r;\uc000\ud835\udcc8tm\xee\xf1i\xec\u3415ar\xe6\u11be\u0100ar\u34ce\u34d5r\u0100;f\u34d4\u17bf\u6606\u0100an\u34da\u34edight\u0100ep\u34e3\u34eapsilo\xee\u1ee0h\xe9\u2eafs\xbb\u2852\u0280bcmnp\u34fb\u355e\u1209\u358b\u358e\u0480;Edemnprs\u350e\u350f\u3511\u3515\u351e\u3523\u352c\u3531\u3536\u6282;\u6ac5ot;\u6abd\u0100;d\u11da\u351aot;\u6ac3ult;\u6ac1\u0100Ee\u3528\u352a;\u6acb;\u628alus;\u6abfarr;\u6979\u0180eiu\u353d\u3552\u3555t\u0180;en\u350e\u3545\u354bq\u0100;q\u11da\u350feq\u0100;q\u352b\u3528m;\u6ac7\u0100bp\u355a\u355c;\u6ad5;\u6ad3c\u0300;acens\u11ed\u356c\u3572\u3579\u357b\u3326ppro\xf8\u32faurlye\xf1\u11fe\xf1\u11f3\u0180aes\u3582\u3588\u331bppro\xf8\u331aq\xf1\u3317g;\u666a\u0680123;Edehlmnps\u35a9\u35ac\u35af\u121c\u35b2\u35b4\u35c0\u35c9\u35d5\u35da\u35df\u35e8\u35ed\u803b\xb9\u40b9\u803b\xb2\u40b2\u803b\xb3\u40b3;\u6ac6\u0100os\u35b9\u35bct;\u6abeub;\u6ad8\u0100;d\u1222\u35c5ot;\u6ac4s\u0100ou\u35cf\u35d2l;\u67c9b;\u6ad7arr;\u697bult;\u6ac2\u0100Ee\u35e4\u35e6;\u6acc;\u628blus;\u6ac0\u0180eiu\u35f4\u3609\u360ct\u0180;en\u121c\u35fc\u3602q\u0100;q\u1222\u35b2eq\u0100;q\u35e7\u35e4m;\u6ac8\u0100bp\u3611\u3613;\u6ad4;\u6ad6\u0180Aan\u361c\u3620\u362drr;\u61d9r\u0100hr\u3626\u3628\xeb\u222e\u0100;o\u0a2b\u0a29war;\u692alig\u803b\xdf\u40df\u0be1\u3651\u365d\u3660\u12ce\u3673\u3679\0\u367e\u36c2\0\0\0\0\0\u36db\u3703\0\u3709\u376c\0\0\0\u3787\u0272\u3656\0\0\u365bget;\u6316;\u43c4r\xeb\u0e5f\u0180aey\u3666\u366b\u3670ron;\u4165dil;\u4163;\u4442lrec;\u6315r;\uc000\ud835\udd31\u0200eiko\u3686\u369d\u36b5\u36bc\u01f2\u368b\0\u3691e\u01004f\u1284\u1281a\u0180;sv\u3698\u3699\u369b\u43b8ym;\u43d1\u0100cn\u36a2\u36b2k\u0100as\u36a8\u36aeppro\xf8\u12c1im\xbb\u12acs\xf0\u129e\u0100as\u36ba\u36ae\xf0\u12c1rn\u803b\xfe\u40fe\u01ec\u031f\u36c6\u22e7es\u8180\xd7;bd\u36cf\u36d0\u36d8\u40d7\u0100;a\u190f\u36d5r;\u6a31;\u6a30\u0180eps\u36e1\u36e3\u3700\xe1\u2a4d\u0200;bcf\u0486\u36ec\u36f0\u36f4ot;\u6336ir;\u6af1\u0100;o\u36f9\u36fc\uc000\ud835\udd65rk;\u6ada\xe1\u3362rime;\u6034\u0180aip\u370f\u3712\u3764d\xe5\u1248\u0380adempst\u3721\u374d\u3740\u3751\u3757\u375c\u375fngle\u0280;dlqr\u3730\u3731\u3736\u3740\u3742\u65b5own\xbb\u1dbbeft\u0100;e\u2800\u373e\xf1\u092e;\u625cight\u0100;e\u32aa\u374b\xf1\u105aot;\u65ecinus;\u6a3alus;\u6a39b;\u69cdime;\u6a3bezium;\u63e2\u0180cht\u3772\u377d\u3781\u0100ry\u3777\u377b;\uc000\ud835\udcc9;\u4446cy;\u445brok;\u4167\u0100io\u378b\u378ex\xf4\u1777head\u0100lr\u3797\u37a0eftarro\xf7\u084fightarrow\xbb\u0f5d\u0900AHabcdfghlmoprstuw\u37d0\u37d3\u37d7\u37e4\u37f0\u37fc\u380e\u381c\u3823\u3834\u3851\u385d\u386b\u38a9\u38cc\u38d2\u38ea\u38f6r\xf2\u03edar;\u6963\u0100cr\u37dc\u37e2ute\u803b\xfa\u40fa\xf2\u1150r\u01e3\u37ea\0\u37edy;\u445eve;\u416d\u0100iy\u37f5\u37farc\u803b\xfb\u40fb;\u4443\u0180abh\u3803\u3806\u380br\xf2\u13adlac;\u4171a\xf2\u13c3\u0100ir\u3813\u3818sht;\u697e;\uc000\ud835\udd32rave\u803b\xf9\u40f9\u0161\u3827\u3831r\u0100lr\u382c\u382e\xbb\u0957\xbb\u1083lk;\u6580\u0100ct\u3839\u384d\u026f\u383f\0\0\u384arn\u0100;e\u3845\u3846\u631cr\xbb\u3846op;\u630fri;\u65f8\u0100al\u3856\u385acr;\u416b\u80bb\xa8\u0349\u0100gp\u3862\u3866on;\u4173f;\uc000\ud835\udd66\u0300adhlsu\u114b\u3878\u387d\u1372\u3891\u38a0own\xe1\u13b3arpoon\u0100lr\u3888\u388cef\xf4\u382digh\xf4\u382fi\u0180;hl\u3899\u389a\u389c\u43c5\xbb\u13faon\xbb\u389aparrows;\u61c8\u0180cit\u38b0\u38c4\u38c8\u026f\u38b6\0\0\u38c1rn\u0100;e\u38bc\u38bd\u631dr\xbb\u38bdop;\u630eng;\u416fri;\u65f9cr;\uc000\ud835\udcca\u0180dir\u38d9\u38dd\u38e2ot;\u62f0lde;\u4169i\u0100;f\u3730\u38e8\xbb\u1813\u0100am\u38ef\u38f2r\xf2\u38a8l\u803b\xfc\u40fcangle;\u69a7\u0780ABDacdeflnoprsz\u391c\u391f\u3929\u392d\u39b5\u39b8\u39bd\u39df\u39e4\u39e8\u39f3\u39f9\u39fd\u3a01\u3a20r\xf2\u03f7ar\u0100;v\u3926\u3927\u6ae8;\u6ae9as\xe8\u03e1\u0100nr\u3932\u3937grt;\u699c\u0380eknprst\u34e3\u3946\u394b\u3952\u395d\u3964\u3996app\xe1\u2415othin\xe7\u1e96\u0180hir\u34eb\u2ec8\u3959op\xf4\u2fb5\u0100;h\u13b7\u3962\xef\u318d\u0100iu\u3969\u396dgm\xe1\u33b3\u0100bp\u3972\u3984setneq\u0100;q\u397d\u3980\uc000\u228a\ufe00;\uc000\u2acb\ufe00setneq\u0100;q\u398f\u3992\uc000\u228b\ufe00;\uc000\u2acc\ufe00\u0100hr\u399b\u399fet\xe1\u369ciangle\u0100lr\u39aa\u39afeft\xbb\u0925ight\xbb\u1051y;\u4432ash\xbb\u1036\u0180elr\u39c4\u39d2\u39d7\u0180;be\u2dea\u39cb\u39cfar;\u62bbq;\u625alip;\u62ee\u0100bt\u39dc\u1468a\xf2\u1469r;\uc000\ud835\udd33tr\xe9\u39aesu\u0100bp\u39ef\u39f1\xbb\u0d1c\xbb\u0d59pf;\uc000\ud835\udd67ro\xf0\u0efbtr\xe9\u39b4\u0100cu\u3a06\u3a0br;\uc000\ud835\udccb\u0100bp\u3a10\u3a18n\u0100Ee\u3980\u3a16\xbb\u397en\u0100Ee\u3992\u3a1e\xbb\u3990igzag;\u699a\u0380cefoprs\u3a36\u3a3b\u3a56\u3a5b\u3a54\u3a61\u3a6airc;\u4175\u0100di\u3a40\u3a51\u0100bg\u3a45\u3a49ar;\u6a5fe\u0100;q\u15fa\u3a4f;\u6259erp;\u6118r;\uc000\ud835\udd34pf;\uc000\ud835\udd68\u0100;e\u1479\u3a66at\xe8\u1479cr;\uc000\ud835\udccc\u0ae3\u178e\u3a87\0\u3a8b\0\u3a90\u3a9b\0\0\u3a9d\u3aa8\u3aab\u3aaf\0\0\u3ac3\u3ace\0\u3ad8\u17dc\u17dftr\xe9\u17d1r;\uc000\ud835\udd35\u0100Aa\u3a94\u3a97r\xf2\u03c3r\xf2\u09f6;\u43be\u0100Aa\u3aa1\u3aa4r\xf2\u03b8r\xf2\u09eba\xf0\u2713is;\u62fb\u0180dpt\u17a4\u3ab5\u3abe\u0100fl\u3aba\u17a9;\uc000\ud835\udd69im\xe5\u17b2\u0100Aa\u3ac7\u3acar\xf2\u03cer\xf2\u0a01\u0100cq\u3ad2\u17b8r;\uc000\ud835\udccd\u0100pt\u17d6\u3adcr\xe9\u17d4\u0400acefiosu\u3af0\u3afd\u3b08\u3b0c\u3b11\u3b15\u3b1b\u3b21c\u0100uy\u3af6\u3afbte\u803b\xfd\u40fd;\u444f\u0100iy\u3b02\u3b06rc;\u4177;\u444bn\u803b\xa5\u40a5r;\uc000\ud835\udd36cy;\u4457pf;\uc000\ud835\udd6acr;\uc000\ud835\udcce\u0100cm\u3b26\u3b29y;\u444el\u803b\xff\u40ff\u0500acdefhiosw\u3b42\u3b48\u3b54\u3b58\u3b64\u3b69\u3b6d\u3b74\u3b7a\u3b80cute;\u417a\u0100ay\u3b4d\u3b52ron;\u417e;\u4437ot;\u417c\u0100et\u3b5d\u3b61tr\xe6\u155fa;\u43b6r;\uc000\ud835\udd37cy;\u4436grarr;\u61ddpf;\uc000\ud835\udd6bcr;\uc000\ud835\udccf\u0100jn\u3b85\u3b87;\u600dj;\u600c".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("atroa", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a01dba917e4352e$export$2e2bcd8739ae039);
// Generated using scripts/write-decode-map.ts
var $7a01dba917e4352e$export$2e2bcd8739ae039 = new Uint16Array(// prettier-ignore
"\u0200aglq\t\x15\x18\x1b\u026d\x0f\0\0\x12p;\u4026os;\u4027t;\u403et;\u403cuot;\u4022".split("").map((c)=>c.charCodeAt(0)));

});

parcelRegister("6cIyx", function(module, exports) {

$parcel$export(module.exports, "fromCodePoint", () => $48466cfbfe7abca9$export$73bfc63873071f74);
$parcel$export(module.exports, "replaceCodePoint", () => $48466cfbfe7abca9$export$b978ab756102108a);
// Adapted from https://github.com/mathiasbynens/he/blob/36afe179392226cf1b6ccdb16ebbb7a5a844d93a/src/he.js#L106-L134
var $48466cfbfe7abca9$var$_a;
const $48466cfbfe7abca9$var$decodeMap = new Map([
    [
        0,
        65533
    ],
    // C1 Unicode control character reference replacements
    [
        128,
        8364
    ],
    [
        130,
        8218
    ],
    [
        131,
        402
    ],
    [
        132,
        8222
    ],
    [
        133,
        8230
    ],
    [
        134,
        8224
    ],
    [
        135,
        8225
    ],
    [
        136,
        710
    ],
    [
        137,
        8240
    ],
    [
        138,
        352
    ],
    [
        139,
        8249
    ],
    [
        140,
        338
    ],
    [
        142,
        381
    ],
    [
        145,
        8216
    ],
    [
        146,
        8217
    ],
    [
        147,
        8220
    ],
    [
        148,
        8221
    ],
    [
        149,
        8226
    ],
    [
        150,
        8211
    ],
    [
        151,
        8212
    ],
    [
        152,
        732
    ],
    [
        153,
        8482
    ],
    [
        154,
        353
    ],
    [
        155,
        8250
    ],
    [
        156,
        339
    ],
    [
        158,
        382
    ],
    [
        159,
        376
    ]
]);
const $48466cfbfe7abca9$export$73bfc63873071f74 = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
($48466cfbfe7abca9$var$_a = String.fromCodePoint) !== null && $48466cfbfe7abca9$var$_a !== void 0 ? $48466cfbfe7abca9$var$_a : function(codePoint) {
    let output = "";
    if (codePoint > 0xffff) {
        codePoint -= 0x10000;
        output += String.fromCharCode(codePoint >>> 10 & 0x3ff | 0xd800);
        codePoint = 0xdc00 | codePoint & 0x3ff;
    }
    output += String.fromCharCode(codePoint);
    return output;
};
function $48466cfbfe7abca9$export$b978ab756102108a(codePoint) {
    var _a;
    if (codePoint >= 0xd800 && codePoint <= 0xdfff || codePoint > 0x10ffff) return 0xfffd;
    return (_a = $48466cfbfe7abca9$var$decodeMap.get(codePoint)) !== null && _a !== void 0 ? _a : codePoint;
}
function $48466cfbfe7abca9$export$2e2bcd8739ae039(codePoint) {
    return $48466cfbfe7abca9$export$73bfc63873071f74($48466cfbfe7abca9$export$b978ab756102108a(codePoint));
}

});


parcelRegister("1Ociz", function(module, exports) {

$parcel$export(module.exports, "encodeHTML", () => $1514002e2552be2e$export$f9d6449b9af28dc1);
$parcel$export(module.exports, "encodeNonAsciiHTML", () => $1514002e2552be2e$export$e6e86c76506f1190);

var $gMJtd = parcelRequire("gMJtd");

var $hsX54 = parcelRequire("hsX54");
const $1514002e2552be2e$var$htmlReplacer = /[\t\n!-,./:-@[-`\f{-}$\x80-\uFFFF]/g;
function $1514002e2552be2e$export$f9d6449b9af28dc1(data) {
    return $1514002e2552be2e$var$encodeHTMLTrieRe($1514002e2552be2e$var$htmlReplacer, data);
}
function $1514002e2552be2e$export$e6e86c76506f1190(data) {
    return $1514002e2552be2e$var$encodeHTMLTrieRe((0, $hsX54.xmlReplacer), data);
}
function $1514002e2552be2e$var$encodeHTMLTrieRe(regExp, str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = regExp.exec(str)) !== null){
        const i = match.index;
        ret += str.substring(lastIdx, i);
        const char = str.charCodeAt(i);
        let next = (0, $gMJtd.default).get(char);
        if (typeof next === "object") {
            // We are in a branch. Try to match the next char.
            if (i + 1 < str.length) {
                const nextChar = str.charCodeAt(i + 1);
                const value = typeof next.n === "number" ? next.n === nextChar ? next.o : undefined : next.n.get(nextChar);
                if (value !== undefined) {
                    ret += value;
                    lastIdx = regExp.lastIndex += 1;
                    continue;
                }
            }
            next = next.v;
        }
        // We might have a tree node without a value; skip and use a numeric entity.
        if (next !== undefined) {
            ret += next;
            lastIdx = i + 1;
        } else {
            const cp = (0, $hsX54.getCodePoint)(str, i);
            ret += `&#x${cp.toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = regExp.lastIndex += Number(cp !== char);
        }
    }
    return ret + str.substr(lastIdx);
}

});
parcelRegister("gMJtd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c38466786e15a6f1$export$2e2bcd8739ae039);
// Generated using scripts/write-encode-map.ts
function $c38466786e15a6f1$var$restoreDiff(arr) {
    for(let i = 1; i < arr.length; i++)arr[i][0] += arr[i - 1][0] + 1;
    return arr;
}
var // prettier-ignore
$c38466786e15a6f1$export$2e2bcd8739ae039 = new Map(/* #__PURE__ */ $c38466786e15a6f1$var$restoreDiff([
    [
        9,
        "&Tab;"
    ],
    [
        0,
        "&NewLine;"
    ],
    [
        22,
        "&excl;"
    ],
    [
        0,
        "&quot;"
    ],
    [
        0,
        "&num;"
    ],
    [
        0,
        "&dollar;"
    ],
    [
        0,
        "&percnt;"
    ],
    [
        0,
        "&amp;"
    ],
    [
        0,
        "&apos;"
    ],
    [
        0,
        "&lpar;"
    ],
    [
        0,
        "&rpar;"
    ],
    [
        0,
        "&ast;"
    ],
    [
        0,
        "&plus;"
    ],
    [
        0,
        "&comma;"
    ],
    [
        1,
        "&period;"
    ],
    [
        0,
        "&sol;"
    ],
    [
        10,
        "&colon;"
    ],
    [
        0,
        "&semi;"
    ],
    [
        0,
        {
            v: "&lt;",
            n: 8402,
            o: "&nvlt;"
        }
    ],
    [
        0,
        {
            v: "&equals;",
            n: 8421,
            o: "&bne;"
        }
    ],
    [
        0,
        {
            v: "&gt;",
            n: 8402,
            o: "&nvgt;"
        }
    ],
    [
        0,
        "&quest;"
    ],
    [
        0,
        "&commat;"
    ],
    [
        26,
        "&lbrack;"
    ],
    [
        0,
        "&bsol;"
    ],
    [
        0,
        "&rbrack;"
    ],
    [
        0,
        "&Hat;"
    ],
    [
        0,
        "&lowbar;"
    ],
    [
        0,
        "&DiacriticalGrave;"
    ],
    [
        5,
        {
            n: 106,
            o: "&fjlig;"
        }
    ],
    [
        20,
        "&lbrace;"
    ],
    [
        0,
        "&verbar;"
    ],
    [
        0,
        "&rbrace;"
    ],
    [
        34,
        "&nbsp;"
    ],
    [
        0,
        "&iexcl;"
    ],
    [
        0,
        "&cent;"
    ],
    [
        0,
        "&pound;"
    ],
    [
        0,
        "&curren;"
    ],
    [
        0,
        "&yen;"
    ],
    [
        0,
        "&brvbar;"
    ],
    [
        0,
        "&sect;"
    ],
    [
        0,
        "&die;"
    ],
    [
        0,
        "&copy;"
    ],
    [
        0,
        "&ordf;"
    ],
    [
        0,
        "&laquo;"
    ],
    [
        0,
        "&not;"
    ],
    [
        0,
        "&shy;"
    ],
    [
        0,
        "&circledR;"
    ],
    [
        0,
        "&macr;"
    ],
    [
        0,
        "&deg;"
    ],
    [
        0,
        "&PlusMinus;"
    ],
    [
        0,
        "&sup2;"
    ],
    [
        0,
        "&sup3;"
    ],
    [
        0,
        "&acute;"
    ],
    [
        0,
        "&micro;"
    ],
    [
        0,
        "&para;"
    ],
    [
        0,
        "&centerdot;"
    ],
    [
        0,
        "&cedil;"
    ],
    [
        0,
        "&sup1;"
    ],
    [
        0,
        "&ordm;"
    ],
    [
        0,
        "&raquo;"
    ],
    [
        0,
        "&frac14;"
    ],
    [
        0,
        "&frac12;"
    ],
    [
        0,
        "&frac34;"
    ],
    [
        0,
        "&iquest;"
    ],
    [
        0,
        "&Agrave;"
    ],
    [
        0,
        "&Aacute;"
    ],
    [
        0,
        "&Acirc;"
    ],
    [
        0,
        "&Atilde;"
    ],
    [
        0,
        "&Auml;"
    ],
    [
        0,
        "&angst;"
    ],
    [
        0,
        "&AElig;"
    ],
    [
        0,
        "&Ccedil;"
    ],
    [
        0,
        "&Egrave;"
    ],
    [
        0,
        "&Eacute;"
    ],
    [
        0,
        "&Ecirc;"
    ],
    [
        0,
        "&Euml;"
    ],
    [
        0,
        "&Igrave;"
    ],
    [
        0,
        "&Iacute;"
    ],
    [
        0,
        "&Icirc;"
    ],
    [
        0,
        "&Iuml;"
    ],
    [
        0,
        "&ETH;"
    ],
    [
        0,
        "&Ntilde;"
    ],
    [
        0,
        "&Ograve;"
    ],
    [
        0,
        "&Oacute;"
    ],
    [
        0,
        "&Ocirc;"
    ],
    [
        0,
        "&Otilde;"
    ],
    [
        0,
        "&Ouml;"
    ],
    [
        0,
        "&times;"
    ],
    [
        0,
        "&Oslash;"
    ],
    [
        0,
        "&Ugrave;"
    ],
    [
        0,
        "&Uacute;"
    ],
    [
        0,
        "&Ucirc;"
    ],
    [
        0,
        "&Uuml;"
    ],
    [
        0,
        "&Yacute;"
    ],
    [
        0,
        "&THORN;"
    ],
    [
        0,
        "&szlig;"
    ],
    [
        0,
        "&agrave;"
    ],
    [
        0,
        "&aacute;"
    ],
    [
        0,
        "&acirc;"
    ],
    [
        0,
        "&atilde;"
    ],
    [
        0,
        "&auml;"
    ],
    [
        0,
        "&aring;"
    ],
    [
        0,
        "&aelig;"
    ],
    [
        0,
        "&ccedil;"
    ],
    [
        0,
        "&egrave;"
    ],
    [
        0,
        "&eacute;"
    ],
    [
        0,
        "&ecirc;"
    ],
    [
        0,
        "&euml;"
    ],
    [
        0,
        "&igrave;"
    ],
    [
        0,
        "&iacute;"
    ],
    [
        0,
        "&icirc;"
    ],
    [
        0,
        "&iuml;"
    ],
    [
        0,
        "&eth;"
    ],
    [
        0,
        "&ntilde;"
    ],
    [
        0,
        "&ograve;"
    ],
    [
        0,
        "&oacute;"
    ],
    [
        0,
        "&ocirc;"
    ],
    [
        0,
        "&otilde;"
    ],
    [
        0,
        "&ouml;"
    ],
    [
        0,
        "&div;"
    ],
    [
        0,
        "&oslash;"
    ],
    [
        0,
        "&ugrave;"
    ],
    [
        0,
        "&uacute;"
    ],
    [
        0,
        "&ucirc;"
    ],
    [
        0,
        "&uuml;"
    ],
    [
        0,
        "&yacute;"
    ],
    [
        0,
        "&thorn;"
    ],
    [
        0,
        "&yuml;"
    ],
    [
        0,
        "&Amacr;"
    ],
    [
        0,
        "&amacr;"
    ],
    [
        0,
        "&Abreve;"
    ],
    [
        0,
        "&abreve;"
    ],
    [
        0,
        "&Aogon;"
    ],
    [
        0,
        "&aogon;"
    ],
    [
        0,
        "&Cacute;"
    ],
    [
        0,
        "&cacute;"
    ],
    [
        0,
        "&Ccirc;"
    ],
    [
        0,
        "&ccirc;"
    ],
    [
        0,
        "&Cdot;"
    ],
    [
        0,
        "&cdot;"
    ],
    [
        0,
        "&Ccaron;"
    ],
    [
        0,
        "&ccaron;"
    ],
    [
        0,
        "&Dcaron;"
    ],
    [
        0,
        "&dcaron;"
    ],
    [
        0,
        "&Dstrok;"
    ],
    [
        0,
        "&dstrok;"
    ],
    [
        0,
        "&Emacr;"
    ],
    [
        0,
        "&emacr;"
    ],
    [
        2,
        "&Edot;"
    ],
    [
        0,
        "&edot;"
    ],
    [
        0,
        "&Eogon;"
    ],
    [
        0,
        "&eogon;"
    ],
    [
        0,
        "&Ecaron;"
    ],
    [
        0,
        "&ecaron;"
    ],
    [
        0,
        "&Gcirc;"
    ],
    [
        0,
        "&gcirc;"
    ],
    [
        0,
        "&Gbreve;"
    ],
    [
        0,
        "&gbreve;"
    ],
    [
        0,
        "&Gdot;"
    ],
    [
        0,
        "&gdot;"
    ],
    [
        0,
        "&Gcedil;"
    ],
    [
        1,
        "&Hcirc;"
    ],
    [
        0,
        "&hcirc;"
    ],
    [
        0,
        "&Hstrok;"
    ],
    [
        0,
        "&hstrok;"
    ],
    [
        0,
        "&Itilde;"
    ],
    [
        0,
        "&itilde;"
    ],
    [
        0,
        "&Imacr;"
    ],
    [
        0,
        "&imacr;"
    ],
    [
        2,
        "&Iogon;"
    ],
    [
        0,
        "&iogon;"
    ],
    [
        0,
        "&Idot;"
    ],
    [
        0,
        "&imath;"
    ],
    [
        0,
        "&IJlig;"
    ],
    [
        0,
        "&ijlig;"
    ],
    [
        0,
        "&Jcirc;"
    ],
    [
        0,
        "&jcirc;"
    ],
    [
        0,
        "&Kcedil;"
    ],
    [
        0,
        "&kcedil;"
    ],
    [
        0,
        "&kgreen;"
    ],
    [
        0,
        "&Lacute;"
    ],
    [
        0,
        "&lacute;"
    ],
    [
        0,
        "&Lcedil;"
    ],
    [
        0,
        "&lcedil;"
    ],
    [
        0,
        "&Lcaron;"
    ],
    [
        0,
        "&lcaron;"
    ],
    [
        0,
        "&Lmidot;"
    ],
    [
        0,
        "&lmidot;"
    ],
    [
        0,
        "&Lstrok;"
    ],
    [
        0,
        "&lstrok;"
    ],
    [
        0,
        "&Nacute;"
    ],
    [
        0,
        "&nacute;"
    ],
    [
        0,
        "&Ncedil;"
    ],
    [
        0,
        "&ncedil;"
    ],
    [
        0,
        "&Ncaron;"
    ],
    [
        0,
        "&ncaron;"
    ],
    [
        0,
        "&napos;"
    ],
    [
        0,
        "&ENG;"
    ],
    [
        0,
        "&eng;"
    ],
    [
        0,
        "&Omacr;"
    ],
    [
        0,
        "&omacr;"
    ],
    [
        2,
        "&Odblac;"
    ],
    [
        0,
        "&odblac;"
    ],
    [
        0,
        "&OElig;"
    ],
    [
        0,
        "&oelig;"
    ],
    [
        0,
        "&Racute;"
    ],
    [
        0,
        "&racute;"
    ],
    [
        0,
        "&Rcedil;"
    ],
    [
        0,
        "&rcedil;"
    ],
    [
        0,
        "&Rcaron;"
    ],
    [
        0,
        "&rcaron;"
    ],
    [
        0,
        "&Sacute;"
    ],
    [
        0,
        "&sacute;"
    ],
    [
        0,
        "&Scirc;"
    ],
    [
        0,
        "&scirc;"
    ],
    [
        0,
        "&Scedil;"
    ],
    [
        0,
        "&scedil;"
    ],
    [
        0,
        "&Scaron;"
    ],
    [
        0,
        "&scaron;"
    ],
    [
        0,
        "&Tcedil;"
    ],
    [
        0,
        "&tcedil;"
    ],
    [
        0,
        "&Tcaron;"
    ],
    [
        0,
        "&tcaron;"
    ],
    [
        0,
        "&Tstrok;"
    ],
    [
        0,
        "&tstrok;"
    ],
    [
        0,
        "&Utilde;"
    ],
    [
        0,
        "&utilde;"
    ],
    [
        0,
        "&Umacr;"
    ],
    [
        0,
        "&umacr;"
    ],
    [
        0,
        "&Ubreve;"
    ],
    [
        0,
        "&ubreve;"
    ],
    [
        0,
        "&Uring;"
    ],
    [
        0,
        "&uring;"
    ],
    [
        0,
        "&Udblac;"
    ],
    [
        0,
        "&udblac;"
    ],
    [
        0,
        "&Uogon;"
    ],
    [
        0,
        "&uogon;"
    ],
    [
        0,
        "&Wcirc;"
    ],
    [
        0,
        "&wcirc;"
    ],
    [
        0,
        "&Ycirc;"
    ],
    [
        0,
        "&ycirc;"
    ],
    [
        0,
        "&Yuml;"
    ],
    [
        0,
        "&Zacute;"
    ],
    [
        0,
        "&zacute;"
    ],
    [
        0,
        "&Zdot;"
    ],
    [
        0,
        "&zdot;"
    ],
    [
        0,
        "&Zcaron;"
    ],
    [
        0,
        "&zcaron;"
    ],
    [
        19,
        "&fnof;"
    ],
    [
        34,
        "&imped;"
    ],
    [
        63,
        "&gacute;"
    ],
    [
        65,
        "&jmath;"
    ],
    [
        142,
        "&circ;"
    ],
    [
        0,
        "&caron;"
    ],
    [
        16,
        "&breve;"
    ],
    [
        0,
        "&DiacriticalDot;"
    ],
    [
        0,
        "&ring;"
    ],
    [
        0,
        "&ogon;"
    ],
    [
        0,
        "&DiacriticalTilde;"
    ],
    [
        0,
        "&dblac;"
    ],
    [
        51,
        "&DownBreve;"
    ],
    [
        127,
        "&Alpha;"
    ],
    [
        0,
        "&Beta;"
    ],
    [
        0,
        "&Gamma;"
    ],
    [
        0,
        "&Delta;"
    ],
    [
        0,
        "&Epsilon;"
    ],
    [
        0,
        "&Zeta;"
    ],
    [
        0,
        "&Eta;"
    ],
    [
        0,
        "&Theta;"
    ],
    [
        0,
        "&Iota;"
    ],
    [
        0,
        "&Kappa;"
    ],
    [
        0,
        "&Lambda;"
    ],
    [
        0,
        "&Mu;"
    ],
    [
        0,
        "&Nu;"
    ],
    [
        0,
        "&Xi;"
    ],
    [
        0,
        "&Omicron;"
    ],
    [
        0,
        "&Pi;"
    ],
    [
        0,
        "&Rho;"
    ],
    [
        1,
        "&Sigma;"
    ],
    [
        0,
        "&Tau;"
    ],
    [
        0,
        "&Upsilon;"
    ],
    [
        0,
        "&Phi;"
    ],
    [
        0,
        "&Chi;"
    ],
    [
        0,
        "&Psi;"
    ],
    [
        0,
        "&ohm;"
    ],
    [
        7,
        "&alpha;"
    ],
    [
        0,
        "&beta;"
    ],
    [
        0,
        "&gamma;"
    ],
    [
        0,
        "&delta;"
    ],
    [
        0,
        "&epsi;"
    ],
    [
        0,
        "&zeta;"
    ],
    [
        0,
        "&eta;"
    ],
    [
        0,
        "&theta;"
    ],
    [
        0,
        "&iota;"
    ],
    [
        0,
        "&kappa;"
    ],
    [
        0,
        "&lambda;"
    ],
    [
        0,
        "&mu;"
    ],
    [
        0,
        "&nu;"
    ],
    [
        0,
        "&xi;"
    ],
    [
        0,
        "&omicron;"
    ],
    [
        0,
        "&pi;"
    ],
    [
        0,
        "&rho;"
    ],
    [
        0,
        "&sigmaf;"
    ],
    [
        0,
        "&sigma;"
    ],
    [
        0,
        "&tau;"
    ],
    [
        0,
        "&upsi;"
    ],
    [
        0,
        "&phi;"
    ],
    [
        0,
        "&chi;"
    ],
    [
        0,
        "&psi;"
    ],
    [
        0,
        "&omega;"
    ],
    [
        7,
        "&thetasym;"
    ],
    [
        0,
        "&Upsi;"
    ],
    [
        2,
        "&phiv;"
    ],
    [
        0,
        "&piv;"
    ],
    [
        5,
        "&Gammad;"
    ],
    [
        0,
        "&digamma;"
    ],
    [
        18,
        "&kappav;"
    ],
    [
        0,
        "&rhov;"
    ],
    [
        3,
        "&epsiv;"
    ],
    [
        0,
        "&backepsilon;"
    ],
    [
        10,
        "&IOcy;"
    ],
    [
        0,
        "&DJcy;"
    ],
    [
        0,
        "&GJcy;"
    ],
    [
        0,
        "&Jukcy;"
    ],
    [
        0,
        "&DScy;"
    ],
    [
        0,
        "&Iukcy;"
    ],
    [
        0,
        "&YIcy;"
    ],
    [
        0,
        "&Jsercy;"
    ],
    [
        0,
        "&LJcy;"
    ],
    [
        0,
        "&NJcy;"
    ],
    [
        0,
        "&TSHcy;"
    ],
    [
        0,
        "&KJcy;"
    ],
    [
        1,
        "&Ubrcy;"
    ],
    [
        0,
        "&DZcy;"
    ],
    [
        0,
        "&Acy;"
    ],
    [
        0,
        "&Bcy;"
    ],
    [
        0,
        "&Vcy;"
    ],
    [
        0,
        "&Gcy;"
    ],
    [
        0,
        "&Dcy;"
    ],
    [
        0,
        "&IEcy;"
    ],
    [
        0,
        "&ZHcy;"
    ],
    [
        0,
        "&Zcy;"
    ],
    [
        0,
        "&Icy;"
    ],
    [
        0,
        "&Jcy;"
    ],
    [
        0,
        "&Kcy;"
    ],
    [
        0,
        "&Lcy;"
    ],
    [
        0,
        "&Mcy;"
    ],
    [
        0,
        "&Ncy;"
    ],
    [
        0,
        "&Ocy;"
    ],
    [
        0,
        "&Pcy;"
    ],
    [
        0,
        "&Rcy;"
    ],
    [
        0,
        "&Scy;"
    ],
    [
        0,
        "&Tcy;"
    ],
    [
        0,
        "&Ucy;"
    ],
    [
        0,
        "&Fcy;"
    ],
    [
        0,
        "&KHcy;"
    ],
    [
        0,
        "&TScy;"
    ],
    [
        0,
        "&CHcy;"
    ],
    [
        0,
        "&SHcy;"
    ],
    [
        0,
        "&SHCHcy;"
    ],
    [
        0,
        "&HARDcy;"
    ],
    [
        0,
        "&Ycy;"
    ],
    [
        0,
        "&SOFTcy;"
    ],
    [
        0,
        "&Ecy;"
    ],
    [
        0,
        "&YUcy;"
    ],
    [
        0,
        "&YAcy;"
    ],
    [
        0,
        "&acy;"
    ],
    [
        0,
        "&bcy;"
    ],
    [
        0,
        "&vcy;"
    ],
    [
        0,
        "&gcy;"
    ],
    [
        0,
        "&dcy;"
    ],
    [
        0,
        "&iecy;"
    ],
    [
        0,
        "&zhcy;"
    ],
    [
        0,
        "&zcy;"
    ],
    [
        0,
        "&icy;"
    ],
    [
        0,
        "&jcy;"
    ],
    [
        0,
        "&kcy;"
    ],
    [
        0,
        "&lcy;"
    ],
    [
        0,
        "&mcy;"
    ],
    [
        0,
        "&ncy;"
    ],
    [
        0,
        "&ocy;"
    ],
    [
        0,
        "&pcy;"
    ],
    [
        0,
        "&rcy;"
    ],
    [
        0,
        "&scy;"
    ],
    [
        0,
        "&tcy;"
    ],
    [
        0,
        "&ucy;"
    ],
    [
        0,
        "&fcy;"
    ],
    [
        0,
        "&khcy;"
    ],
    [
        0,
        "&tscy;"
    ],
    [
        0,
        "&chcy;"
    ],
    [
        0,
        "&shcy;"
    ],
    [
        0,
        "&shchcy;"
    ],
    [
        0,
        "&hardcy;"
    ],
    [
        0,
        "&ycy;"
    ],
    [
        0,
        "&softcy;"
    ],
    [
        0,
        "&ecy;"
    ],
    [
        0,
        "&yucy;"
    ],
    [
        0,
        "&yacy;"
    ],
    [
        1,
        "&iocy;"
    ],
    [
        0,
        "&djcy;"
    ],
    [
        0,
        "&gjcy;"
    ],
    [
        0,
        "&jukcy;"
    ],
    [
        0,
        "&dscy;"
    ],
    [
        0,
        "&iukcy;"
    ],
    [
        0,
        "&yicy;"
    ],
    [
        0,
        "&jsercy;"
    ],
    [
        0,
        "&ljcy;"
    ],
    [
        0,
        "&njcy;"
    ],
    [
        0,
        "&tshcy;"
    ],
    [
        0,
        "&kjcy;"
    ],
    [
        1,
        "&ubrcy;"
    ],
    [
        0,
        "&dzcy;"
    ],
    [
        7074,
        "&ensp;"
    ],
    [
        0,
        "&emsp;"
    ],
    [
        0,
        "&emsp13;"
    ],
    [
        0,
        "&emsp14;"
    ],
    [
        1,
        "&numsp;"
    ],
    [
        0,
        "&puncsp;"
    ],
    [
        0,
        "&ThinSpace;"
    ],
    [
        0,
        "&hairsp;"
    ],
    [
        0,
        "&NegativeMediumSpace;"
    ],
    [
        0,
        "&zwnj;"
    ],
    [
        0,
        "&zwj;"
    ],
    [
        0,
        "&lrm;"
    ],
    [
        0,
        "&rlm;"
    ],
    [
        0,
        "&dash;"
    ],
    [
        2,
        "&ndash;"
    ],
    [
        0,
        "&mdash;"
    ],
    [
        0,
        "&horbar;"
    ],
    [
        0,
        "&Verbar;"
    ],
    [
        1,
        "&lsquo;"
    ],
    [
        0,
        "&CloseCurlyQuote;"
    ],
    [
        0,
        "&lsquor;"
    ],
    [
        1,
        "&ldquo;"
    ],
    [
        0,
        "&CloseCurlyDoubleQuote;"
    ],
    [
        0,
        "&bdquo;"
    ],
    [
        1,
        "&dagger;"
    ],
    [
        0,
        "&Dagger;"
    ],
    [
        0,
        "&bull;"
    ],
    [
        2,
        "&nldr;"
    ],
    [
        0,
        "&hellip;"
    ],
    [
        9,
        "&permil;"
    ],
    [
        0,
        "&pertenk;"
    ],
    [
        0,
        "&prime;"
    ],
    [
        0,
        "&Prime;"
    ],
    [
        0,
        "&tprime;"
    ],
    [
        0,
        "&backprime;"
    ],
    [
        3,
        "&lsaquo;"
    ],
    [
        0,
        "&rsaquo;"
    ],
    [
        3,
        "&oline;"
    ],
    [
        2,
        "&caret;"
    ],
    [
        1,
        "&hybull;"
    ],
    [
        0,
        "&frasl;"
    ],
    [
        10,
        "&bsemi;"
    ],
    [
        7,
        "&qprime;"
    ],
    [
        7,
        {
            v: "&MediumSpace;",
            n: 8202,
            o: "&ThickSpace;"
        }
    ],
    [
        0,
        "&NoBreak;"
    ],
    [
        0,
        "&af;"
    ],
    [
        0,
        "&InvisibleTimes;"
    ],
    [
        0,
        "&ic;"
    ],
    [
        72,
        "&euro;"
    ],
    [
        46,
        "&tdot;"
    ],
    [
        0,
        "&DotDot;"
    ],
    [
        37,
        "&complexes;"
    ],
    [
        2,
        "&incare;"
    ],
    [
        4,
        "&gscr;"
    ],
    [
        0,
        "&hamilt;"
    ],
    [
        0,
        "&Hfr;"
    ],
    [
        0,
        "&Hopf;"
    ],
    [
        0,
        "&planckh;"
    ],
    [
        0,
        "&hbar;"
    ],
    [
        0,
        "&imagline;"
    ],
    [
        0,
        "&Ifr;"
    ],
    [
        0,
        "&lagran;"
    ],
    [
        0,
        "&ell;"
    ],
    [
        1,
        "&naturals;"
    ],
    [
        0,
        "&numero;"
    ],
    [
        0,
        "&copysr;"
    ],
    [
        0,
        "&weierp;"
    ],
    [
        0,
        "&Popf;"
    ],
    [
        0,
        "&Qopf;"
    ],
    [
        0,
        "&realine;"
    ],
    [
        0,
        "&real;"
    ],
    [
        0,
        "&reals;"
    ],
    [
        0,
        "&rx;"
    ],
    [
        3,
        "&trade;"
    ],
    [
        1,
        "&integers;"
    ],
    [
        2,
        "&mho;"
    ],
    [
        0,
        "&zeetrf;"
    ],
    [
        0,
        "&iiota;"
    ],
    [
        2,
        "&bernou;"
    ],
    [
        0,
        "&Cayleys;"
    ],
    [
        1,
        "&escr;"
    ],
    [
        0,
        "&Escr;"
    ],
    [
        0,
        "&Fouriertrf;"
    ],
    [
        1,
        "&Mellintrf;"
    ],
    [
        0,
        "&order;"
    ],
    [
        0,
        "&alefsym;"
    ],
    [
        0,
        "&beth;"
    ],
    [
        0,
        "&gimel;"
    ],
    [
        0,
        "&daleth;"
    ],
    [
        12,
        "&CapitalDifferentialD;"
    ],
    [
        0,
        "&dd;"
    ],
    [
        0,
        "&ee;"
    ],
    [
        0,
        "&ii;"
    ],
    [
        10,
        "&frac13;"
    ],
    [
        0,
        "&frac23;"
    ],
    [
        0,
        "&frac15;"
    ],
    [
        0,
        "&frac25;"
    ],
    [
        0,
        "&frac35;"
    ],
    [
        0,
        "&frac45;"
    ],
    [
        0,
        "&frac16;"
    ],
    [
        0,
        "&frac56;"
    ],
    [
        0,
        "&frac18;"
    ],
    [
        0,
        "&frac38;"
    ],
    [
        0,
        "&frac58;"
    ],
    [
        0,
        "&frac78;"
    ],
    [
        49,
        "&larr;"
    ],
    [
        0,
        "&ShortUpArrow;"
    ],
    [
        0,
        "&rarr;"
    ],
    [
        0,
        "&darr;"
    ],
    [
        0,
        "&harr;"
    ],
    [
        0,
        "&updownarrow;"
    ],
    [
        0,
        "&nwarr;"
    ],
    [
        0,
        "&nearr;"
    ],
    [
        0,
        "&LowerRightArrow;"
    ],
    [
        0,
        "&LowerLeftArrow;"
    ],
    [
        0,
        "&nlarr;"
    ],
    [
        0,
        "&nrarr;"
    ],
    [
        1,
        {
            v: "&rarrw;",
            n: 824,
            o: "&nrarrw;"
        }
    ],
    [
        0,
        "&Larr;"
    ],
    [
        0,
        "&Uarr;"
    ],
    [
        0,
        "&Rarr;"
    ],
    [
        0,
        "&Darr;"
    ],
    [
        0,
        "&larrtl;"
    ],
    [
        0,
        "&rarrtl;"
    ],
    [
        0,
        "&LeftTeeArrow;"
    ],
    [
        0,
        "&mapstoup;"
    ],
    [
        0,
        "&map;"
    ],
    [
        0,
        "&DownTeeArrow;"
    ],
    [
        1,
        "&hookleftarrow;"
    ],
    [
        0,
        "&hookrightarrow;"
    ],
    [
        0,
        "&larrlp;"
    ],
    [
        0,
        "&looparrowright;"
    ],
    [
        0,
        "&harrw;"
    ],
    [
        0,
        "&nharr;"
    ],
    [
        1,
        "&lsh;"
    ],
    [
        0,
        "&rsh;"
    ],
    [
        0,
        "&ldsh;"
    ],
    [
        0,
        "&rdsh;"
    ],
    [
        1,
        "&crarr;"
    ],
    [
        0,
        "&cularr;"
    ],
    [
        0,
        "&curarr;"
    ],
    [
        2,
        "&circlearrowleft;"
    ],
    [
        0,
        "&circlearrowright;"
    ],
    [
        0,
        "&leftharpoonup;"
    ],
    [
        0,
        "&DownLeftVector;"
    ],
    [
        0,
        "&RightUpVector;"
    ],
    [
        0,
        "&LeftUpVector;"
    ],
    [
        0,
        "&rharu;"
    ],
    [
        0,
        "&DownRightVector;"
    ],
    [
        0,
        "&dharr;"
    ],
    [
        0,
        "&dharl;"
    ],
    [
        0,
        "&RightArrowLeftArrow;"
    ],
    [
        0,
        "&udarr;"
    ],
    [
        0,
        "&LeftArrowRightArrow;"
    ],
    [
        0,
        "&leftleftarrows;"
    ],
    [
        0,
        "&upuparrows;"
    ],
    [
        0,
        "&rightrightarrows;"
    ],
    [
        0,
        "&ddarr;"
    ],
    [
        0,
        "&leftrightharpoons;"
    ],
    [
        0,
        "&Equilibrium;"
    ],
    [
        0,
        "&nlArr;"
    ],
    [
        0,
        "&nhArr;"
    ],
    [
        0,
        "&nrArr;"
    ],
    [
        0,
        "&DoubleLeftArrow;"
    ],
    [
        0,
        "&DoubleUpArrow;"
    ],
    [
        0,
        "&DoubleRightArrow;"
    ],
    [
        0,
        "&dArr;"
    ],
    [
        0,
        "&DoubleLeftRightArrow;"
    ],
    [
        0,
        "&DoubleUpDownArrow;"
    ],
    [
        0,
        "&nwArr;"
    ],
    [
        0,
        "&neArr;"
    ],
    [
        0,
        "&seArr;"
    ],
    [
        0,
        "&swArr;"
    ],
    [
        0,
        "&lAarr;"
    ],
    [
        0,
        "&rAarr;"
    ],
    [
        1,
        "&zigrarr;"
    ],
    [
        6,
        "&larrb;"
    ],
    [
        0,
        "&rarrb;"
    ],
    [
        15,
        "&DownArrowUpArrow;"
    ],
    [
        7,
        "&loarr;"
    ],
    [
        0,
        "&roarr;"
    ],
    [
        0,
        "&hoarr;"
    ],
    [
        0,
        "&forall;"
    ],
    [
        0,
        "&comp;"
    ],
    [
        0,
        {
            v: "&part;",
            n: 824,
            o: "&npart;"
        }
    ],
    [
        0,
        "&exist;"
    ],
    [
        0,
        "&nexist;"
    ],
    [
        0,
        "&empty;"
    ],
    [
        1,
        "&Del;"
    ],
    [
        0,
        "&Element;"
    ],
    [
        0,
        "&NotElement;"
    ],
    [
        1,
        "&ni;"
    ],
    [
        0,
        "&notni;"
    ],
    [
        2,
        "&prod;"
    ],
    [
        0,
        "&coprod;"
    ],
    [
        0,
        "&sum;"
    ],
    [
        0,
        "&minus;"
    ],
    [
        0,
        "&MinusPlus;"
    ],
    [
        0,
        "&dotplus;"
    ],
    [
        1,
        "&Backslash;"
    ],
    [
        0,
        "&lowast;"
    ],
    [
        0,
        "&compfn;"
    ],
    [
        1,
        "&radic;"
    ],
    [
        2,
        "&prop;"
    ],
    [
        0,
        "&infin;"
    ],
    [
        0,
        "&angrt;"
    ],
    [
        0,
        {
            v: "&ang;",
            n: 8402,
            o: "&nang;"
        }
    ],
    [
        0,
        "&angmsd;"
    ],
    [
        0,
        "&angsph;"
    ],
    [
        0,
        "&mid;"
    ],
    [
        0,
        "&nmid;"
    ],
    [
        0,
        "&DoubleVerticalBar;"
    ],
    [
        0,
        "&NotDoubleVerticalBar;"
    ],
    [
        0,
        "&and;"
    ],
    [
        0,
        "&or;"
    ],
    [
        0,
        {
            v: "&cap;",
            n: 65024,
            o: "&caps;"
        }
    ],
    [
        0,
        {
            v: "&cup;",
            n: 65024,
            o: "&cups;"
        }
    ],
    [
        0,
        "&int;"
    ],
    [
        0,
        "&Int;"
    ],
    [
        0,
        "&iiint;"
    ],
    [
        0,
        "&conint;"
    ],
    [
        0,
        "&Conint;"
    ],
    [
        0,
        "&Cconint;"
    ],
    [
        0,
        "&cwint;"
    ],
    [
        0,
        "&ClockwiseContourIntegral;"
    ],
    [
        0,
        "&awconint;"
    ],
    [
        0,
        "&there4;"
    ],
    [
        0,
        "&becaus;"
    ],
    [
        0,
        "&ratio;"
    ],
    [
        0,
        "&Colon;"
    ],
    [
        0,
        "&dotminus;"
    ],
    [
        1,
        "&mDDot;"
    ],
    [
        0,
        "&homtht;"
    ],
    [
        0,
        {
            v: "&sim;",
            n: 8402,
            o: "&nvsim;"
        }
    ],
    [
        0,
        {
            v: "&backsim;",
            n: 817,
            o: "&race;"
        }
    ],
    [
        0,
        {
            v: "&ac;",
            n: 819,
            o: "&acE;"
        }
    ],
    [
        0,
        "&acd;"
    ],
    [
        0,
        "&VerticalTilde;"
    ],
    [
        0,
        "&NotTilde;"
    ],
    [
        0,
        {
            v: "&eqsim;",
            n: 824,
            o: "&nesim;"
        }
    ],
    [
        0,
        "&sime;"
    ],
    [
        0,
        "&NotTildeEqual;"
    ],
    [
        0,
        "&cong;"
    ],
    [
        0,
        "&simne;"
    ],
    [
        0,
        "&ncong;"
    ],
    [
        0,
        "&ap;"
    ],
    [
        0,
        "&nap;"
    ],
    [
        0,
        "&ape;"
    ],
    [
        0,
        {
            v: "&apid;",
            n: 824,
            o: "&napid;"
        }
    ],
    [
        0,
        "&backcong;"
    ],
    [
        0,
        {
            v: "&asympeq;",
            n: 8402,
            o: "&nvap;"
        }
    ],
    [
        0,
        {
            v: "&bump;",
            n: 824,
            o: "&nbump;"
        }
    ],
    [
        0,
        {
            v: "&bumpe;",
            n: 824,
            o: "&nbumpe;"
        }
    ],
    [
        0,
        {
            v: "&doteq;",
            n: 824,
            o: "&nedot;"
        }
    ],
    [
        0,
        "&doteqdot;"
    ],
    [
        0,
        "&efDot;"
    ],
    [
        0,
        "&erDot;"
    ],
    [
        0,
        "&Assign;"
    ],
    [
        0,
        "&ecolon;"
    ],
    [
        0,
        "&ecir;"
    ],
    [
        0,
        "&circeq;"
    ],
    [
        1,
        "&wedgeq;"
    ],
    [
        0,
        "&veeeq;"
    ],
    [
        1,
        "&triangleq;"
    ],
    [
        2,
        "&equest;"
    ],
    [
        0,
        "&ne;"
    ],
    [
        0,
        {
            v: "&Congruent;",
            n: 8421,
            o: "&bnequiv;"
        }
    ],
    [
        0,
        "&nequiv;"
    ],
    [
        1,
        {
            v: "&le;",
            n: 8402,
            o: "&nvle;"
        }
    ],
    [
        0,
        {
            v: "&ge;",
            n: 8402,
            o: "&nvge;"
        }
    ],
    [
        0,
        {
            v: "&lE;",
            n: 824,
            o: "&nlE;"
        }
    ],
    [
        0,
        {
            v: "&gE;",
            n: 824,
            o: "&ngE;"
        }
    ],
    [
        0,
        {
            v: "&lnE;",
            n: 65024,
            o: "&lvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&gnE;",
            n: 65024,
            o: "&gvertneqq;"
        }
    ],
    [
        0,
        {
            v: "&ll;",
            n: new Map(/* #__PURE__ */ $c38466786e15a6f1$var$restoreDiff([
                [
                    824,
                    "&nLtv;"
                ],
                [
                    7577,
                    "&nLt;"
                ]
            ]))
        }
    ],
    [
        0,
        {
            v: "&gg;",
            n: new Map(/* #__PURE__ */ $c38466786e15a6f1$var$restoreDiff([
                [
                    824,
                    "&nGtv;"
                ],
                [
                    7577,
                    "&nGt;"
                ]
            ]))
        }
    ],
    [
        0,
        "&between;"
    ],
    [
        0,
        "&NotCupCap;"
    ],
    [
        0,
        "&nless;"
    ],
    [
        0,
        "&ngt;"
    ],
    [
        0,
        "&nle;"
    ],
    [
        0,
        "&nge;"
    ],
    [
        0,
        "&lesssim;"
    ],
    [
        0,
        "&GreaterTilde;"
    ],
    [
        0,
        "&nlsim;"
    ],
    [
        0,
        "&ngsim;"
    ],
    [
        0,
        "&LessGreater;"
    ],
    [
        0,
        "&gl;"
    ],
    [
        0,
        "&NotLessGreater;"
    ],
    [
        0,
        "&NotGreaterLess;"
    ],
    [
        0,
        "&pr;"
    ],
    [
        0,
        "&sc;"
    ],
    [
        0,
        "&prcue;"
    ],
    [
        0,
        "&sccue;"
    ],
    [
        0,
        "&PrecedesTilde;"
    ],
    [
        0,
        {
            v: "&scsim;",
            n: 824,
            o: "&NotSucceedsTilde;"
        }
    ],
    [
        0,
        "&NotPrecedes;"
    ],
    [
        0,
        "&NotSucceeds;"
    ],
    [
        0,
        {
            v: "&sub;",
            n: 8402,
            o: "&NotSubset;"
        }
    ],
    [
        0,
        {
            v: "&sup;",
            n: 8402,
            o: "&NotSuperset;"
        }
    ],
    [
        0,
        "&nsub;"
    ],
    [
        0,
        "&nsup;"
    ],
    [
        0,
        "&sube;"
    ],
    [
        0,
        "&supe;"
    ],
    [
        0,
        "&NotSubsetEqual;"
    ],
    [
        0,
        "&NotSupersetEqual;"
    ],
    [
        0,
        {
            v: "&subne;",
            n: 65024,
            o: "&varsubsetneq;"
        }
    ],
    [
        0,
        {
            v: "&supne;",
            n: 65024,
            o: "&varsupsetneq;"
        }
    ],
    [
        1,
        "&cupdot;"
    ],
    [
        0,
        "&UnionPlus;"
    ],
    [
        0,
        {
            v: "&sqsub;",
            n: 824,
            o: "&NotSquareSubset;"
        }
    ],
    [
        0,
        {
            v: "&sqsup;",
            n: 824,
            o: "&NotSquareSuperset;"
        }
    ],
    [
        0,
        "&sqsube;"
    ],
    [
        0,
        "&sqsupe;"
    ],
    [
        0,
        {
            v: "&sqcap;",
            n: 65024,
            o: "&sqcaps;"
        }
    ],
    [
        0,
        {
            v: "&sqcup;",
            n: 65024,
            o: "&sqcups;"
        }
    ],
    [
        0,
        "&CirclePlus;"
    ],
    [
        0,
        "&CircleMinus;"
    ],
    [
        0,
        "&CircleTimes;"
    ],
    [
        0,
        "&osol;"
    ],
    [
        0,
        "&CircleDot;"
    ],
    [
        0,
        "&circledcirc;"
    ],
    [
        0,
        "&circledast;"
    ],
    [
        1,
        "&circleddash;"
    ],
    [
        0,
        "&boxplus;"
    ],
    [
        0,
        "&boxminus;"
    ],
    [
        0,
        "&boxtimes;"
    ],
    [
        0,
        "&dotsquare;"
    ],
    [
        0,
        "&RightTee;"
    ],
    [
        0,
        "&dashv;"
    ],
    [
        0,
        "&DownTee;"
    ],
    [
        0,
        "&bot;"
    ],
    [
        1,
        "&models;"
    ],
    [
        0,
        "&DoubleRightTee;"
    ],
    [
        0,
        "&Vdash;"
    ],
    [
        0,
        "&Vvdash;"
    ],
    [
        0,
        "&VDash;"
    ],
    [
        0,
        "&nvdash;"
    ],
    [
        0,
        "&nvDash;"
    ],
    [
        0,
        "&nVdash;"
    ],
    [
        0,
        "&nVDash;"
    ],
    [
        0,
        "&prurel;"
    ],
    [
        1,
        "&LeftTriangle;"
    ],
    [
        0,
        "&RightTriangle;"
    ],
    [
        0,
        {
            v: "&LeftTriangleEqual;",
            n: 8402,
            o: "&nvltrie;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleEqual;",
            n: 8402,
            o: "&nvrtrie;"
        }
    ],
    [
        0,
        "&origof;"
    ],
    [
        0,
        "&imof;"
    ],
    [
        0,
        "&multimap;"
    ],
    [
        0,
        "&hercon;"
    ],
    [
        0,
        "&intcal;"
    ],
    [
        0,
        "&veebar;"
    ],
    [
        1,
        "&barvee;"
    ],
    [
        0,
        "&angrtvb;"
    ],
    [
        0,
        "&lrtri;"
    ],
    [
        0,
        "&bigwedge;"
    ],
    [
        0,
        "&bigvee;"
    ],
    [
        0,
        "&bigcap;"
    ],
    [
        0,
        "&bigcup;"
    ],
    [
        0,
        "&diam;"
    ],
    [
        0,
        "&sdot;"
    ],
    [
        0,
        "&sstarf;"
    ],
    [
        0,
        "&divideontimes;"
    ],
    [
        0,
        "&bowtie;"
    ],
    [
        0,
        "&ltimes;"
    ],
    [
        0,
        "&rtimes;"
    ],
    [
        0,
        "&leftthreetimes;"
    ],
    [
        0,
        "&rightthreetimes;"
    ],
    [
        0,
        "&backsimeq;"
    ],
    [
        0,
        "&curlyvee;"
    ],
    [
        0,
        "&curlywedge;"
    ],
    [
        0,
        "&Sub;"
    ],
    [
        0,
        "&Sup;"
    ],
    [
        0,
        "&Cap;"
    ],
    [
        0,
        "&Cup;"
    ],
    [
        0,
        "&fork;"
    ],
    [
        0,
        "&epar;"
    ],
    [
        0,
        "&lessdot;"
    ],
    [
        0,
        "&gtdot;"
    ],
    [
        0,
        {
            v: "&Ll;",
            n: 824,
            o: "&nLl;"
        }
    ],
    [
        0,
        {
            v: "&Gg;",
            n: 824,
            o: "&nGg;"
        }
    ],
    [
        0,
        {
            v: "&leg;",
            n: 65024,
            o: "&lesg;"
        }
    ],
    [
        0,
        {
            v: "&gel;",
            n: 65024,
            o: "&gesl;"
        }
    ],
    [
        2,
        "&cuepr;"
    ],
    [
        0,
        "&cuesc;"
    ],
    [
        0,
        "&NotPrecedesSlantEqual;"
    ],
    [
        0,
        "&NotSucceedsSlantEqual;"
    ],
    [
        0,
        "&NotSquareSubsetEqual;"
    ],
    [
        0,
        "&NotSquareSupersetEqual;"
    ],
    [
        2,
        "&lnsim;"
    ],
    [
        0,
        "&gnsim;"
    ],
    [
        0,
        "&precnsim;"
    ],
    [
        0,
        "&scnsim;"
    ],
    [
        0,
        "&nltri;"
    ],
    [
        0,
        "&NotRightTriangle;"
    ],
    [
        0,
        "&nltrie;"
    ],
    [
        0,
        "&NotRightTriangleEqual;"
    ],
    [
        0,
        "&vellip;"
    ],
    [
        0,
        "&ctdot;"
    ],
    [
        0,
        "&utdot;"
    ],
    [
        0,
        "&dtdot;"
    ],
    [
        0,
        "&disin;"
    ],
    [
        0,
        "&isinsv;"
    ],
    [
        0,
        "&isins;"
    ],
    [
        0,
        {
            v: "&isindot;",
            n: 824,
            o: "&notindot;"
        }
    ],
    [
        0,
        "&notinvc;"
    ],
    [
        0,
        "&notinvb;"
    ],
    [
        1,
        {
            v: "&isinE;",
            n: 824,
            o: "&notinE;"
        }
    ],
    [
        0,
        "&nisd;"
    ],
    [
        0,
        "&xnis;"
    ],
    [
        0,
        "&nis;"
    ],
    [
        0,
        "&notnivc;"
    ],
    [
        0,
        "&notnivb;"
    ],
    [
        6,
        "&barwed;"
    ],
    [
        0,
        "&Barwed;"
    ],
    [
        1,
        "&lceil;"
    ],
    [
        0,
        "&rceil;"
    ],
    [
        0,
        "&LeftFloor;"
    ],
    [
        0,
        "&rfloor;"
    ],
    [
        0,
        "&drcrop;"
    ],
    [
        0,
        "&dlcrop;"
    ],
    [
        0,
        "&urcrop;"
    ],
    [
        0,
        "&ulcrop;"
    ],
    [
        0,
        "&bnot;"
    ],
    [
        1,
        "&profline;"
    ],
    [
        0,
        "&profsurf;"
    ],
    [
        1,
        "&telrec;"
    ],
    [
        0,
        "&target;"
    ],
    [
        5,
        "&ulcorn;"
    ],
    [
        0,
        "&urcorn;"
    ],
    [
        0,
        "&dlcorn;"
    ],
    [
        0,
        "&drcorn;"
    ],
    [
        2,
        "&frown;"
    ],
    [
        0,
        "&smile;"
    ],
    [
        9,
        "&cylcty;"
    ],
    [
        0,
        "&profalar;"
    ],
    [
        7,
        "&topbot;"
    ],
    [
        6,
        "&ovbar;"
    ],
    [
        1,
        "&solbar;"
    ],
    [
        60,
        "&angzarr;"
    ],
    [
        51,
        "&lmoustache;"
    ],
    [
        0,
        "&rmoustache;"
    ],
    [
        2,
        "&OverBracket;"
    ],
    [
        0,
        "&bbrk;"
    ],
    [
        0,
        "&bbrktbrk;"
    ],
    [
        37,
        "&OverParenthesis;"
    ],
    [
        0,
        "&UnderParenthesis;"
    ],
    [
        0,
        "&OverBrace;"
    ],
    [
        0,
        "&UnderBrace;"
    ],
    [
        2,
        "&trpezium;"
    ],
    [
        4,
        "&elinters;"
    ],
    [
        59,
        "&blank;"
    ],
    [
        164,
        "&circledS;"
    ],
    [
        55,
        "&boxh;"
    ],
    [
        1,
        "&boxv;"
    ],
    [
        9,
        "&boxdr;"
    ],
    [
        3,
        "&boxdl;"
    ],
    [
        3,
        "&boxur;"
    ],
    [
        3,
        "&boxul;"
    ],
    [
        3,
        "&boxvr;"
    ],
    [
        7,
        "&boxvl;"
    ],
    [
        7,
        "&boxhd;"
    ],
    [
        7,
        "&boxhu;"
    ],
    [
        7,
        "&boxvh;"
    ],
    [
        19,
        "&boxH;"
    ],
    [
        0,
        "&boxV;"
    ],
    [
        0,
        "&boxdR;"
    ],
    [
        0,
        "&boxDr;"
    ],
    [
        0,
        "&boxDR;"
    ],
    [
        0,
        "&boxdL;"
    ],
    [
        0,
        "&boxDl;"
    ],
    [
        0,
        "&boxDL;"
    ],
    [
        0,
        "&boxuR;"
    ],
    [
        0,
        "&boxUr;"
    ],
    [
        0,
        "&boxUR;"
    ],
    [
        0,
        "&boxuL;"
    ],
    [
        0,
        "&boxUl;"
    ],
    [
        0,
        "&boxUL;"
    ],
    [
        0,
        "&boxvR;"
    ],
    [
        0,
        "&boxVr;"
    ],
    [
        0,
        "&boxVR;"
    ],
    [
        0,
        "&boxvL;"
    ],
    [
        0,
        "&boxVl;"
    ],
    [
        0,
        "&boxVL;"
    ],
    [
        0,
        "&boxHd;"
    ],
    [
        0,
        "&boxhD;"
    ],
    [
        0,
        "&boxHD;"
    ],
    [
        0,
        "&boxHu;"
    ],
    [
        0,
        "&boxhU;"
    ],
    [
        0,
        "&boxHU;"
    ],
    [
        0,
        "&boxvH;"
    ],
    [
        0,
        "&boxVh;"
    ],
    [
        0,
        "&boxVH;"
    ],
    [
        19,
        "&uhblk;"
    ],
    [
        3,
        "&lhblk;"
    ],
    [
        3,
        "&block;"
    ],
    [
        8,
        "&blk14;"
    ],
    [
        0,
        "&blk12;"
    ],
    [
        0,
        "&blk34;"
    ],
    [
        13,
        "&square;"
    ],
    [
        8,
        "&blacksquare;"
    ],
    [
        0,
        "&EmptyVerySmallSquare;"
    ],
    [
        1,
        "&rect;"
    ],
    [
        0,
        "&marker;"
    ],
    [
        2,
        "&fltns;"
    ],
    [
        1,
        "&bigtriangleup;"
    ],
    [
        0,
        "&blacktriangle;"
    ],
    [
        0,
        "&triangle;"
    ],
    [
        2,
        "&blacktriangleright;"
    ],
    [
        0,
        "&rtri;"
    ],
    [
        3,
        "&bigtriangledown;"
    ],
    [
        0,
        "&blacktriangledown;"
    ],
    [
        0,
        "&dtri;"
    ],
    [
        2,
        "&blacktriangleleft;"
    ],
    [
        0,
        "&ltri;"
    ],
    [
        6,
        "&loz;"
    ],
    [
        0,
        "&cir;"
    ],
    [
        32,
        "&tridot;"
    ],
    [
        2,
        "&bigcirc;"
    ],
    [
        8,
        "&ultri;"
    ],
    [
        0,
        "&urtri;"
    ],
    [
        0,
        "&lltri;"
    ],
    [
        0,
        "&EmptySmallSquare;"
    ],
    [
        0,
        "&FilledSmallSquare;"
    ],
    [
        8,
        "&bigstar;"
    ],
    [
        0,
        "&star;"
    ],
    [
        7,
        "&phone;"
    ],
    [
        49,
        "&female;"
    ],
    [
        1,
        "&male;"
    ],
    [
        29,
        "&spades;"
    ],
    [
        2,
        "&clubs;"
    ],
    [
        1,
        "&hearts;"
    ],
    [
        0,
        "&diamondsuit;"
    ],
    [
        3,
        "&sung;"
    ],
    [
        2,
        "&flat;"
    ],
    [
        0,
        "&natural;"
    ],
    [
        0,
        "&sharp;"
    ],
    [
        163,
        "&check;"
    ],
    [
        3,
        "&cross;"
    ],
    [
        8,
        "&malt;"
    ],
    [
        21,
        "&sext;"
    ],
    [
        33,
        "&VerticalSeparator;"
    ],
    [
        25,
        "&lbbrk;"
    ],
    [
        0,
        "&rbbrk;"
    ],
    [
        84,
        "&bsolhsub;"
    ],
    [
        0,
        "&suphsol;"
    ],
    [
        28,
        "&LeftDoubleBracket;"
    ],
    [
        0,
        "&RightDoubleBracket;"
    ],
    [
        0,
        "&lang;"
    ],
    [
        0,
        "&rang;"
    ],
    [
        0,
        "&Lang;"
    ],
    [
        0,
        "&Rang;"
    ],
    [
        0,
        "&loang;"
    ],
    [
        0,
        "&roang;"
    ],
    [
        7,
        "&longleftarrow;"
    ],
    [
        0,
        "&longrightarrow;"
    ],
    [
        0,
        "&longleftrightarrow;"
    ],
    [
        0,
        "&DoubleLongLeftArrow;"
    ],
    [
        0,
        "&DoubleLongRightArrow;"
    ],
    [
        0,
        "&DoubleLongLeftRightArrow;"
    ],
    [
        1,
        "&longmapsto;"
    ],
    [
        2,
        "&dzigrarr;"
    ],
    [
        258,
        "&nvlArr;"
    ],
    [
        0,
        "&nvrArr;"
    ],
    [
        0,
        "&nvHarr;"
    ],
    [
        0,
        "&Map;"
    ],
    [
        6,
        "&lbarr;"
    ],
    [
        0,
        "&bkarow;"
    ],
    [
        0,
        "&lBarr;"
    ],
    [
        0,
        "&dbkarow;"
    ],
    [
        0,
        "&drbkarow;"
    ],
    [
        0,
        "&DDotrahd;"
    ],
    [
        0,
        "&UpArrowBar;"
    ],
    [
        0,
        "&DownArrowBar;"
    ],
    [
        2,
        "&Rarrtl;"
    ],
    [
        2,
        "&latail;"
    ],
    [
        0,
        "&ratail;"
    ],
    [
        0,
        "&lAtail;"
    ],
    [
        0,
        "&rAtail;"
    ],
    [
        0,
        "&larrfs;"
    ],
    [
        0,
        "&rarrfs;"
    ],
    [
        0,
        "&larrbfs;"
    ],
    [
        0,
        "&rarrbfs;"
    ],
    [
        2,
        "&nwarhk;"
    ],
    [
        0,
        "&nearhk;"
    ],
    [
        0,
        "&hksearow;"
    ],
    [
        0,
        "&hkswarow;"
    ],
    [
        0,
        "&nwnear;"
    ],
    [
        0,
        "&nesear;"
    ],
    [
        0,
        "&seswar;"
    ],
    [
        0,
        "&swnwar;"
    ],
    [
        8,
        {
            v: "&rarrc;",
            n: 824,
            o: "&nrarrc;"
        }
    ],
    [
        1,
        "&cudarrr;"
    ],
    [
        0,
        "&ldca;"
    ],
    [
        0,
        "&rdca;"
    ],
    [
        0,
        "&cudarrl;"
    ],
    [
        0,
        "&larrpl;"
    ],
    [
        2,
        "&curarrm;"
    ],
    [
        0,
        "&cularrp;"
    ],
    [
        7,
        "&rarrpl;"
    ],
    [
        2,
        "&harrcir;"
    ],
    [
        0,
        "&Uarrocir;"
    ],
    [
        0,
        "&lurdshar;"
    ],
    [
        0,
        "&ldrushar;"
    ],
    [
        2,
        "&LeftRightVector;"
    ],
    [
        0,
        "&RightUpDownVector;"
    ],
    [
        0,
        "&DownLeftRightVector;"
    ],
    [
        0,
        "&LeftUpDownVector;"
    ],
    [
        0,
        "&LeftVectorBar;"
    ],
    [
        0,
        "&RightVectorBar;"
    ],
    [
        0,
        "&RightUpVectorBar;"
    ],
    [
        0,
        "&RightDownVectorBar;"
    ],
    [
        0,
        "&DownLeftVectorBar;"
    ],
    [
        0,
        "&DownRightVectorBar;"
    ],
    [
        0,
        "&LeftUpVectorBar;"
    ],
    [
        0,
        "&LeftDownVectorBar;"
    ],
    [
        0,
        "&LeftTeeVector;"
    ],
    [
        0,
        "&RightTeeVector;"
    ],
    [
        0,
        "&RightUpTeeVector;"
    ],
    [
        0,
        "&RightDownTeeVector;"
    ],
    [
        0,
        "&DownLeftTeeVector;"
    ],
    [
        0,
        "&DownRightTeeVector;"
    ],
    [
        0,
        "&LeftUpTeeVector;"
    ],
    [
        0,
        "&LeftDownTeeVector;"
    ],
    [
        0,
        "&lHar;"
    ],
    [
        0,
        "&uHar;"
    ],
    [
        0,
        "&rHar;"
    ],
    [
        0,
        "&dHar;"
    ],
    [
        0,
        "&luruhar;"
    ],
    [
        0,
        "&ldrdhar;"
    ],
    [
        0,
        "&ruluhar;"
    ],
    [
        0,
        "&rdldhar;"
    ],
    [
        0,
        "&lharul;"
    ],
    [
        0,
        "&llhard;"
    ],
    [
        0,
        "&rharul;"
    ],
    [
        0,
        "&lrhard;"
    ],
    [
        0,
        "&udhar;"
    ],
    [
        0,
        "&duhar;"
    ],
    [
        0,
        "&RoundImplies;"
    ],
    [
        0,
        "&erarr;"
    ],
    [
        0,
        "&simrarr;"
    ],
    [
        0,
        "&larrsim;"
    ],
    [
        0,
        "&rarrsim;"
    ],
    [
        0,
        "&rarrap;"
    ],
    [
        0,
        "&ltlarr;"
    ],
    [
        1,
        "&gtrarr;"
    ],
    [
        0,
        "&subrarr;"
    ],
    [
        1,
        "&suplarr;"
    ],
    [
        0,
        "&lfisht;"
    ],
    [
        0,
        "&rfisht;"
    ],
    [
        0,
        "&ufisht;"
    ],
    [
        0,
        "&dfisht;"
    ],
    [
        5,
        "&lopar;"
    ],
    [
        0,
        "&ropar;"
    ],
    [
        4,
        "&lbrke;"
    ],
    [
        0,
        "&rbrke;"
    ],
    [
        0,
        "&lbrkslu;"
    ],
    [
        0,
        "&rbrksld;"
    ],
    [
        0,
        "&lbrksld;"
    ],
    [
        0,
        "&rbrkslu;"
    ],
    [
        0,
        "&langd;"
    ],
    [
        0,
        "&rangd;"
    ],
    [
        0,
        "&lparlt;"
    ],
    [
        0,
        "&rpargt;"
    ],
    [
        0,
        "&gtlPar;"
    ],
    [
        0,
        "&ltrPar;"
    ],
    [
        3,
        "&vzigzag;"
    ],
    [
        1,
        "&vangrt;"
    ],
    [
        0,
        "&angrtvbd;"
    ],
    [
        6,
        "&ange;"
    ],
    [
        0,
        "&range;"
    ],
    [
        0,
        "&dwangle;"
    ],
    [
        0,
        "&uwangle;"
    ],
    [
        0,
        "&angmsdaa;"
    ],
    [
        0,
        "&angmsdab;"
    ],
    [
        0,
        "&angmsdac;"
    ],
    [
        0,
        "&angmsdad;"
    ],
    [
        0,
        "&angmsdae;"
    ],
    [
        0,
        "&angmsdaf;"
    ],
    [
        0,
        "&angmsdag;"
    ],
    [
        0,
        "&angmsdah;"
    ],
    [
        0,
        "&bemptyv;"
    ],
    [
        0,
        "&demptyv;"
    ],
    [
        0,
        "&cemptyv;"
    ],
    [
        0,
        "&raemptyv;"
    ],
    [
        0,
        "&laemptyv;"
    ],
    [
        0,
        "&ohbar;"
    ],
    [
        0,
        "&omid;"
    ],
    [
        0,
        "&opar;"
    ],
    [
        1,
        "&operp;"
    ],
    [
        1,
        "&olcross;"
    ],
    [
        0,
        "&odsold;"
    ],
    [
        1,
        "&olcir;"
    ],
    [
        0,
        "&ofcir;"
    ],
    [
        0,
        "&olt;"
    ],
    [
        0,
        "&ogt;"
    ],
    [
        0,
        "&cirscir;"
    ],
    [
        0,
        "&cirE;"
    ],
    [
        0,
        "&solb;"
    ],
    [
        0,
        "&bsolb;"
    ],
    [
        3,
        "&boxbox;"
    ],
    [
        3,
        "&trisb;"
    ],
    [
        0,
        "&rtriltri;"
    ],
    [
        0,
        {
            v: "&LeftTriangleBar;",
            n: 824,
            o: "&NotLeftTriangleBar;"
        }
    ],
    [
        0,
        {
            v: "&RightTriangleBar;",
            n: 824,
            o: "&NotRightTriangleBar;"
        }
    ],
    [
        11,
        "&iinfin;"
    ],
    [
        0,
        "&infintie;"
    ],
    [
        0,
        "&nvinfin;"
    ],
    [
        4,
        "&eparsl;"
    ],
    [
        0,
        "&smeparsl;"
    ],
    [
        0,
        "&eqvparsl;"
    ],
    [
        5,
        "&blacklozenge;"
    ],
    [
        8,
        "&RuleDelayed;"
    ],
    [
        1,
        "&dsol;"
    ],
    [
        9,
        "&bigodot;"
    ],
    [
        0,
        "&bigoplus;"
    ],
    [
        0,
        "&bigotimes;"
    ],
    [
        1,
        "&biguplus;"
    ],
    [
        1,
        "&bigsqcup;"
    ],
    [
        5,
        "&iiiint;"
    ],
    [
        0,
        "&fpartint;"
    ],
    [
        2,
        "&cirfnint;"
    ],
    [
        0,
        "&awint;"
    ],
    [
        0,
        "&rppolint;"
    ],
    [
        0,
        "&scpolint;"
    ],
    [
        0,
        "&npolint;"
    ],
    [
        0,
        "&pointint;"
    ],
    [
        0,
        "&quatint;"
    ],
    [
        0,
        "&intlarhk;"
    ],
    [
        10,
        "&pluscir;"
    ],
    [
        0,
        "&plusacir;"
    ],
    [
        0,
        "&simplus;"
    ],
    [
        0,
        "&plusdu;"
    ],
    [
        0,
        "&plussim;"
    ],
    [
        0,
        "&plustwo;"
    ],
    [
        1,
        "&mcomma;"
    ],
    [
        0,
        "&minusdu;"
    ],
    [
        2,
        "&loplus;"
    ],
    [
        0,
        "&roplus;"
    ],
    [
        0,
        "&Cross;"
    ],
    [
        0,
        "&timesd;"
    ],
    [
        0,
        "&timesbar;"
    ],
    [
        1,
        "&smashp;"
    ],
    [
        0,
        "&lotimes;"
    ],
    [
        0,
        "&rotimes;"
    ],
    [
        0,
        "&otimesas;"
    ],
    [
        0,
        "&Otimes;"
    ],
    [
        0,
        "&odiv;"
    ],
    [
        0,
        "&triplus;"
    ],
    [
        0,
        "&triminus;"
    ],
    [
        0,
        "&tritime;"
    ],
    [
        0,
        "&intprod;"
    ],
    [
        2,
        "&amalg;"
    ],
    [
        0,
        "&capdot;"
    ],
    [
        1,
        "&ncup;"
    ],
    [
        0,
        "&ncap;"
    ],
    [
        0,
        "&capand;"
    ],
    [
        0,
        "&cupor;"
    ],
    [
        0,
        "&cupcap;"
    ],
    [
        0,
        "&capcup;"
    ],
    [
        0,
        "&cupbrcap;"
    ],
    [
        0,
        "&capbrcup;"
    ],
    [
        0,
        "&cupcup;"
    ],
    [
        0,
        "&capcap;"
    ],
    [
        0,
        "&ccups;"
    ],
    [
        0,
        "&ccaps;"
    ],
    [
        2,
        "&ccupssm;"
    ],
    [
        2,
        "&And;"
    ],
    [
        0,
        "&Or;"
    ],
    [
        0,
        "&andand;"
    ],
    [
        0,
        "&oror;"
    ],
    [
        0,
        "&orslope;"
    ],
    [
        0,
        "&andslope;"
    ],
    [
        1,
        "&andv;"
    ],
    [
        0,
        "&orv;"
    ],
    [
        0,
        "&andd;"
    ],
    [
        0,
        "&ord;"
    ],
    [
        1,
        "&wedbar;"
    ],
    [
        6,
        "&sdote;"
    ],
    [
        3,
        "&simdot;"
    ],
    [
        2,
        {
            v: "&congdot;",
            n: 824,
            o: "&ncongdot;"
        }
    ],
    [
        0,
        "&easter;"
    ],
    [
        0,
        "&apacir;"
    ],
    [
        0,
        {
            v: "&apE;",
            n: 824,
            o: "&napE;"
        }
    ],
    [
        0,
        "&eplus;"
    ],
    [
        0,
        "&pluse;"
    ],
    [
        0,
        "&Esim;"
    ],
    [
        0,
        "&Colone;"
    ],
    [
        0,
        "&Equal;"
    ],
    [
        1,
        "&ddotseq;"
    ],
    [
        0,
        "&equivDD;"
    ],
    [
        0,
        "&ltcir;"
    ],
    [
        0,
        "&gtcir;"
    ],
    [
        0,
        "&ltquest;"
    ],
    [
        0,
        "&gtquest;"
    ],
    [
        0,
        {
            v: "&leqslant;",
            n: 824,
            o: "&nleqslant;"
        }
    ],
    [
        0,
        {
            v: "&geqslant;",
            n: 824,
            o: "&ngeqslant;"
        }
    ],
    [
        0,
        "&lesdot;"
    ],
    [
        0,
        "&gesdot;"
    ],
    [
        0,
        "&lesdoto;"
    ],
    [
        0,
        "&gesdoto;"
    ],
    [
        0,
        "&lesdotor;"
    ],
    [
        0,
        "&gesdotol;"
    ],
    [
        0,
        "&lap;"
    ],
    [
        0,
        "&gap;"
    ],
    [
        0,
        "&lne;"
    ],
    [
        0,
        "&gne;"
    ],
    [
        0,
        "&lnap;"
    ],
    [
        0,
        "&gnap;"
    ],
    [
        0,
        "&lEg;"
    ],
    [
        0,
        "&gEl;"
    ],
    [
        0,
        "&lsime;"
    ],
    [
        0,
        "&gsime;"
    ],
    [
        0,
        "&lsimg;"
    ],
    [
        0,
        "&gsiml;"
    ],
    [
        0,
        "&lgE;"
    ],
    [
        0,
        "&glE;"
    ],
    [
        0,
        "&lesges;"
    ],
    [
        0,
        "&gesles;"
    ],
    [
        0,
        "&els;"
    ],
    [
        0,
        "&egs;"
    ],
    [
        0,
        "&elsdot;"
    ],
    [
        0,
        "&egsdot;"
    ],
    [
        0,
        "&el;"
    ],
    [
        0,
        "&eg;"
    ],
    [
        2,
        "&siml;"
    ],
    [
        0,
        "&simg;"
    ],
    [
        0,
        "&simlE;"
    ],
    [
        0,
        "&simgE;"
    ],
    [
        0,
        {
            v: "&LessLess;",
            n: 824,
            o: "&NotNestedLessLess;"
        }
    ],
    [
        0,
        {
            v: "&GreaterGreater;",
            n: 824,
            o: "&NotNestedGreaterGreater;"
        }
    ],
    [
        1,
        "&glj;"
    ],
    [
        0,
        "&gla;"
    ],
    [
        0,
        "&ltcc;"
    ],
    [
        0,
        "&gtcc;"
    ],
    [
        0,
        "&lescc;"
    ],
    [
        0,
        "&gescc;"
    ],
    [
        0,
        "&smt;"
    ],
    [
        0,
        "&lat;"
    ],
    [
        0,
        {
            v: "&smte;",
            n: 65024,
            o: "&smtes;"
        }
    ],
    [
        0,
        {
            v: "&late;",
            n: 65024,
            o: "&lates;"
        }
    ],
    [
        0,
        "&bumpE;"
    ],
    [
        0,
        {
            v: "&PrecedesEqual;",
            n: 824,
            o: "&NotPrecedesEqual;"
        }
    ],
    [
        0,
        {
            v: "&sce;",
            n: 824,
            o: "&NotSucceedsEqual;"
        }
    ],
    [
        2,
        "&prE;"
    ],
    [
        0,
        "&scE;"
    ],
    [
        0,
        "&precneqq;"
    ],
    [
        0,
        "&scnE;"
    ],
    [
        0,
        "&prap;"
    ],
    [
        0,
        "&scap;"
    ],
    [
        0,
        "&precnapprox;"
    ],
    [
        0,
        "&scnap;"
    ],
    [
        0,
        "&Pr;"
    ],
    [
        0,
        "&Sc;"
    ],
    [
        0,
        "&subdot;"
    ],
    [
        0,
        "&supdot;"
    ],
    [
        0,
        "&subplus;"
    ],
    [
        0,
        "&supplus;"
    ],
    [
        0,
        "&submult;"
    ],
    [
        0,
        "&supmult;"
    ],
    [
        0,
        "&subedot;"
    ],
    [
        0,
        "&supedot;"
    ],
    [
        0,
        {
            v: "&subE;",
            n: 824,
            o: "&nsubE;"
        }
    ],
    [
        0,
        {
            v: "&supE;",
            n: 824,
            o: "&nsupE;"
        }
    ],
    [
        0,
        "&subsim;"
    ],
    [
        0,
        "&supsim;"
    ],
    [
        2,
        {
            v: "&subnE;",
            n: 65024,
            o: "&varsubsetneqq;"
        }
    ],
    [
        0,
        {
            v: "&supnE;",
            n: 65024,
            o: "&varsupsetneqq;"
        }
    ],
    [
        2,
        "&csub;"
    ],
    [
        0,
        "&csup;"
    ],
    [
        0,
        "&csube;"
    ],
    [
        0,
        "&csupe;"
    ],
    [
        0,
        "&subsup;"
    ],
    [
        0,
        "&supsub;"
    ],
    [
        0,
        "&subsub;"
    ],
    [
        0,
        "&supsup;"
    ],
    [
        0,
        "&suphsub;"
    ],
    [
        0,
        "&supdsub;"
    ],
    [
        0,
        "&forkv;"
    ],
    [
        0,
        "&topfork;"
    ],
    [
        0,
        "&mlcp;"
    ],
    [
        8,
        "&Dashv;"
    ],
    [
        1,
        "&Vdashl;"
    ],
    [
        0,
        "&Barv;"
    ],
    [
        0,
        "&vBar;"
    ],
    [
        0,
        "&vBarv;"
    ],
    [
        1,
        "&Vbar;"
    ],
    [
        0,
        "&Not;"
    ],
    [
        0,
        "&bNot;"
    ],
    [
        0,
        "&rnmid;"
    ],
    [
        0,
        "&cirmid;"
    ],
    [
        0,
        "&midcir;"
    ],
    [
        0,
        "&topcir;"
    ],
    [
        0,
        "&nhpar;"
    ],
    [
        0,
        "&parsim;"
    ],
    [
        9,
        {
            v: "&parsl;",
            n: 8421,
            o: "&nparsl;"
        }
    ],
    [
        44343,
        {
            n: new Map(/* #__PURE__ */ $c38466786e15a6f1$var$restoreDiff([
                [
                    56476,
                    "&Ascr;"
                ],
                [
                    1,
                    "&Cscr;"
                ],
                [
                    0,
                    "&Dscr;"
                ],
                [
                    2,
                    "&Gscr;"
                ],
                [
                    2,
                    "&Jscr;"
                ],
                [
                    0,
                    "&Kscr;"
                ],
                [
                    2,
                    "&Nscr;"
                ],
                [
                    0,
                    "&Oscr;"
                ],
                [
                    0,
                    "&Pscr;"
                ],
                [
                    0,
                    "&Qscr;"
                ],
                [
                    1,
                    "&Sscr;"
                ],
                [
                    0,
                    "&Tscr;"
                ],
                [
                    0,
                    "&Uscr;"
                ],
                [
                    0,
                    "&Vscr;"
                ],
                [
                    0,
                    "&Wscr;"
                ],
                [
                    0,
                    "&Xscr;"
                ],
                [
                    0,
                    "&Yscr;"
                ],
                [
                    0,
                    "&Zscr;"
                ],
                [
                    0,
                    "&ascr;"
                ],
                [
                    0,
                    "&bscr;"
                ],
                [
                    0,
                    "&cscr;"
                ],
                [
                    0,
                    "&dscr;"
                ],
                [
                    1,
                    "&fscr;"
                ],
                [
                    1,
                    "&hscr;"
                ],
                [
                    0,
                    "&iscr;"
                ],
                [
                    0,
                    "&jscr;"
                ],
                [
                    0,
                    "&kscr;"
                ],
                [
                    0,
                    "&lscr;"
                ],
                [
                    0,
                    "&mscr;"
                ],
                [
                    0,
                    "&nscr;"
                ],
                [
                    1,
                    "&pscr;"
                ],
                [
                    0,
                    "&qscr;"
                ],
                [
                    0,
                    "&rscr;"
                ],
                [
                    0,
                    "&sscr;"
                ],
                [
                    0,
                    "&tscr;"
                ],
                [
                    0,
                    "&uscr;"
                ],
                [
                    0,
                    "&vscr;"
                ],
                [
                    0,
                    "&wscr;"
                ],
                [
                    0,
                    "&xscr;"
                ],
                [
                    0,
                    "&yscr;"
                ],
                [
                    0,
                    "&zscr;"
                ],
                [
                    52,
                    "&Afr;"
                ],
                [
                    0,
                    "&Bfr;"
                ],
                [
                    1,
                    "&Dfr;"
                ],
                [
                    0,
                    "&Efr;"
                ],
                [
                    0,
                    "&Ffr;"
                ],
                [
                    0,
                    "&Gfr;"
                ],
                [
                    2,
                    "&Jfr;"
                ],
                [
                    0,
                    "&Kfr;"
                ],
                [
                    0,
                    "&Lfr;"
                ],
                [
                    0,
                    "&Mfr;"
                ],
                [
                    0,
                    "&Nfr;"
                ],
                [
                    0,
                    "&Ofr;"
                ],
                [
                    0,
                    "&Pfr;"
                ],
                [
                    0,
                    "&Qfr;"
                ],
                [
                    1,
                    "&Sfr;"
                ],
                [
                    0,
                    "&Tfr;"
                ],
                [
                    0,
                    "&Ufr;"
                ],
                [
                    0,
                    "&Vfr;"
                ],
                [
                    0,
                    "&Wfr;"
                ],
                [
                    0,
                    "&Xfr;"
                ],
                [
                    0,
                    "&Yfr;"
                ],
                [
                    1,
                    "&afr;"
                ],
                [
                    0,
                    "&bfr;"
                ],
                [
                    0,
                    "&cfr;"
                ],
                [
                    0,
                    "&dfr;"
                ],
                [
                    0,
                    "&efr;"
                ],
                [
                    0,
                    "&ffr;"
                ],
                [
                    0,
                    "&gfr;"
                ],
                [
                    0,
                    "&hfr;"
                ],
                [
                    0,
                    "&ifr;"
                ],
                [
                    0,
                    "&jfr;"
                ],
                [
                    0,
                    "&kfr;"
                ],
                [
                    0,
                    "&lfr;"
                ],
                [
                    0,
                    "&mfr;"
                ],
                [
                    0,
                    "&nfr;"
                ],
                [
                    0,
                    "&ofr;"
                ],
                [
                    0,
                    "&pfr;"
                ],
                [
                    0,
                    "&qfr;"
                ],
                [
                    0,
                    "&rfr;"
                ],
                [
                    0,
                    "&sfr;"
                ],
                [
                    0,
                    "&tfr;"
                ],
                [
                    0,
                    "&ufr;"
                ],
                [
                    0,
                    "&vfr;"
                ],
                [
                    0,
                    "&wfr;"
                ],
                [
                    0,
                    "&xfr;"
                ],
                [
                    0,
                    "&yfr;"
                ],
                [
                    0,
                    "&zfr;"
                ],
                [
                    0,
                    "&Aopf;"
                ],
                [
                    0,
                    "&Bopf;"
                ],
                [
                    1,
                    "&Dopf;"
                ],
                [
                    0,
                    "&Eopf;"
                ],
                [
                    0,
                    "&Fopf;"
                ],
                [
                    0,
                    "&Gopf;"
                ],
                [
                    1,
                    "&Iopf;"
                ],
                [
                    0,
                    "&Jopf;"
                ],
                [
                    0,
                    "&Kopf;"
                ],
                [
                    0,
                    "&Lopf;"
                ],
                [
                    0,
                    "&Mopf;"
                ],
                [
                    1,
                    "&Oopf;"
                ],
                [
                    3,
                    "&Sopf;"
                ],
                [
                    0,
                    "&Topf;"
                ],
                [
                    0,
                    "&Uopf;"
                ],
                [
                    0,
                    "&Vopf;"
                ],
                [
                    0,
                    "&Wopf;"
                ],
                [
                    0,
                    "&Xopf;"
                ],
                [
                    0,
                    "&Yopf;"
                ],
                [
                    1,
                    "&aopf;"
                ],
                [
                    0,
                    "&bopf;"
                ],
                [
                    0,
                    "&copf;"
                ],
                [
                    0,
                    "&dopf;"
                ],
                [
                    0,
                    "&eopf;"
                ],
                [
                    0,
                    "&fopf;"
                ],
                [
                    0,
                    "&gopf;"
                ],
                [
                    0,
                    "&hopf;"
                ],
                [
                    0,
                    "&iopf;"
                ],
                [
                    0,
                    "&jopf;"
                ],
                [
                    0,
                    "&kopf;"
                ],
                [
                    0,
                    "&lopf;"
                ],
                [
                    0,
                    "&mopf;"
                ],
                [
                    0,
                    "&nopf;"
                ],
                [
                    0,
                    "&oopf;"
                ],
                [
                    0,
                    "&popf;"
                ],
                [
                    0,
                    "&qopf;"
                ],
                [
                    0,
                    "&ropf;"
                ],
                [
                    0,
                    "&sopf;"
                ],
                [
                    0,
                    "&topf;"
                ],
                [
                    0,
                    "&uopf;"
                ],
                [
                    0,
                    "&vopf;"
                ],
                [
                    0,
                    "&wopf;"
                ],
                [
                    0,
                    "&xopf;"
                ],
                [
                    0,
                    "&yopf;"
                ],
                [
                    0,
                    "&zopf;"
                ]
            ]))
        }
    ],
    [
        8906,
        "&fflig;"
    ],
    [
        0,
        "&filig;"
    ],
    [
        0,
        "&fllig;"
    ],
    [
        0,
        "&ffilig;"
    ],
    [
        0,
        "&ffllig;"
    ]
]));

});

parcelRegister("hsX54", function(module, exports) {

$parcel$export(module.exports, "xmlReplacer", () => $cb72e16de943c83b$export$5699810ce3244ab8);
$parcel$export(module.exports, "getCodePoint", () => $cb72e16de943c83b$export$e02688b8085d016b);
$parcel$export(module.exports, "encodeXML", () => $cb72e16de943c83b$export$18855ec5be97da16);
$parcel$export(module.exports, "escapeUTF8", () => $cb72e16de943c83b$export$9e081872deefdcb0);
$parcel$export(module.exports, "escapeAttribute", () => $cb72e16de943c83b$export$30330f3d5eb70e11);
$parcel$export(module.exports, "escapeText", () => $cb72e16de943c83b$export$96e6fc3a139b2555);
const $cb72e16de943c83b$export$5699810ce3244ab8 = /["&'<>$\x80-\uFFFF]/g;
const $cb72e16de943c83b$var$xmlCodeMap = new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        39,
        "&apos;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ]
]);
const $cb72e16de943c83b$export$e02688b8085d016b = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
String.prototype.codePointAt != null ? (str, index)=>str.codePointAt(index) : (c, index)=>(c.charCodeAt(index) & 0xfc00) === 0xd800 ? (c.charCodeAt(index) - 0xd800) * 0x400 + c.charCodeAt(index + 1) - 0xdc00 + 0x10000 : c.charCodeAt(index);
function $cb72e16de943c83b$export$18855ec5be97da16(str) {
    let ret = "";
    let lastIdx = 0;
    let match;
    while((match = $cb72e16de943c83b$export$5699810ce3244ab8.exec(str)) !== null){
        const i = match.index;
        const char = str.charCodeAt(i);
        const next = $cb72e16de943c83b$var$xmlCodeMap.get(char);
        if (next !== undefined) {
            ret += str.substring(lastIdx, i) + next;
            lastIdx = i + 1;
        } else {
            ret += `${str.substring(lastIdx, i)}&#x${$cb72e16de943c83b$export$e02688b8085d016b(str, i).toString(16)};`;
            // Increase by 1 if we have a surrogate pair
            lastIdx = $cb72e16de943c83b$export$5699810ce3244ab8.lastIndex += Number((char & 0xfc00) === 0xd800);
        }
    }
    return ret + str.substr(lastIdx);
}
const $cb72e16de943c83b$export$4e7f196112fea3c5 = $cb72e16de943c83b$export$18855ec5be97da16;
/**
 * Creates a function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 *
 * @param regex Regular expression to match characters to escape.
 * @param map Map of characters to escape to their entities.
 *
 * @returns Function that escapes all characters matched by the given regular
 * expression using the given map of characters to escape to their entities.
 */ function $cb72e16de943c83b$var$getEscaper(regex, map) {
    return function escape(data) {
        let match;
        let lastIdx = 0;
        let result = "";
        while(match = regex.exec(data)){
            if (lastIdx !== match.index) result += data.substring(lastIdx, match.index);
            // We know that this character will be in the map.
            result += map.get(match[0].charCodeAt(0));
            // Every match will be of length 1
            lastIdx = match.index + 1;
        }
        return result + data.substring(lastIdx);
    };
}
const $cb72e16de943c83b$export$9e081872deefdcb0 = $cb72e16de943c83b$var$getEscaper(/[&<>'"]/g, $cb72e16de943c83b$var$xmlCodeMap);
const $cb72e16de943c83b$export$30330f3d5eb70e11 = $cb72e16de943c83b$var$getEscaper(/["&\u00A0]/g, new Map([
    [
        34,
        "&quot;"
    ],
    [
        38,
        "&amp;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));
const $cb72e16de943c83b$export$96e6fc3a139b2555 = $cb72e16de943c83b$var$getEscaper(/[&<>\u00A0]/g, new Map([
    [
        38,
        "&amp;"
    ],
    [
        60,
        "&lt;"
    ],
    [
        62,
        "&gt;"
    ],
    [
        160,
        "&nbsp;"
    ]
]));

});




parcelRegister("4oH8P", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => (parcelRequire("6SWZJ")).default);
$parcel$export(module.exports, "parseLinkDestination", () => (parcelRequire("f2GAG")).default);
$parcel$export(module.exports, "parseLinkTitle", () => (parcelRequire("6nY1O")).default);
// Just a shortcut for bulk export

var $6SWZJ = parcelRequire("6SWZJ");

var $f2GAG = parcelRequire("f2GAG");

var $6nY1O = parcelRequire("6nY1O");

});
parcelRegister("6SWZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd2f48303995751$export$2e2bcd8739ae039);
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
function $abd2f48303995751$export$2e2bcd8739ae039(state, start, disableNested) {
    let level, found, marker, prevPos;
    const max = state.posMax;
    const oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    let labelEnd = -1;
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
}

});

parcelRegister("f2GAG", function(module, exports) {

$parcel$export(module.exports, "default", () => $edde6865825d92e7$export$2e2bcd8739ae039);
// Parse link destination
//

var $l5FiO = parcelRequire("l5FiO");
function $edde6865825d92e7$export$2e2bcd8739ae039(str, start, max) {
    let code;
    let pos = start;
    const result = {
        ok: false,
        pos: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = (0, $l5FiO.unescapeAll)(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    let level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = (0, $l5FiO.unescapeAll)(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
}

});

parcelRegister("6nY1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1d3017a5ae96057$export$2e2bcd8739ae039);
// Parse link title
//

var $l5FiO = parcelRequire("l5FiO");
function $f1d3017a5ae96057$export$2e2bcd8739ae039(str, start, max, prev_state) {
    let code;
    let pos = start;
    const state = {
        // if `true`, this is a valid link title
        ok: false,
        // if `true`, this link can be continued on the next line
        can_continue: false,
        // if `ok`, it's the position of the first character after the closing marker
        pos: 0,
        // if `ok`, it's the unescaped title
        str: '',
        // expected closing marker character code
        marker: 0
    };
    if (prev_state) {
        // this is a continuation of a previous parseLinkTitle call on the next line,
        // used in reference links only
        state.str = prev_state.str;
        state.marker = prev_state.marker;
    } else {
        if (pos >= max) return state;
        let marker = str.charCodeAt(pos);
        if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return state;
        start++;
        pos++;
        // if opening marker is "(", switch it to closing marker ")"
        if (marker === 0x28) marker = 0x29;
        state.marker = marker;
    }
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === state.marker) {
            state.pos = pos + 1;
            state.str += (0, $l5FiO.unescapeAll)(str.slice(start, pos));
            state.ok = true;
            return state;
        } else if (code === 0x28 /* ( */  && state.marker === 0x29 /* ) */ ) return state;
        else if (code === 0x5C /* \ */  && pos + 1 < max) pos++;
        pos++;
    }
    // no closing marker found, but this link title may continue on the next line (for references)
    state.can_continue = true;
    state.str += (0, $l5FiO.unescapeAll)(str.slice(start, pos));
    return state;
}

});


parcelRegister("9FY5l", function(module, exports) {

$parcel$export(module.exports, "default", () => $1aad198f750e42d7$export$2e2bcd8739ae039);
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 
var $l5FiO = parcelRequire("l5FiO");
const $1aad198f750e42d7$var$default_rules = {};
$1aad198f750e42d7$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + (0, $l5FiO.escapeHtml)(token.content) + '</code>';
};
$1aad198f750e42d7$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + (0, $l5FiO.escapeHtml)(tokens[idx].content) + '</code></pre>\n';
};
$1aad198f750e42d7$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    const info = token.info ? (0, $l5FiO.unescapeAll)(token.info).trim() : '';
    let langName = '';
    let langAttrs = '';
    if (info) {
        const arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    let highlighted;
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || (0, $l5FiO.escapeHtml)(token.content);
    else highlighted = (0, $l5FiO.escapeHtml)(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        const i = token.attrIndex('class');
        const tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        const tmpToken = {
            attrs: tmpAttrs
        };
        return `<pre><code${slf.renderAttrs(tmpToken)}>${highlighted}</code></pre>\n`;
    }
    return `<pre><code${slf.renderAttrs(token)}>${highlighted}</code></pre>\n`;
};
$1aad198f750e42d7$var$default_rules.image = function(tokens, idx, options, env, slf) {
    const token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$1aad198f750e42d7$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$1aad198f750e42d7$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$1aad198f750e42d7$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return (0, $l5FiO.escapeHtml)(tokens[idx].content);
};
$1aad198f750e42d7$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$1aad198f750e42d7$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $1aad198f750e42d7$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.mjs)
   * for more details and examples.
   **/ this.rules = (0, $l5FiO.assign)({}, $1aad198f750e42d7$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    let i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + (0, $l5FiO.escapeHtml)(token.attrs[i][0]) + '="' + (0, $l5FiO.escapeHtml)(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    const token = tokens[idx];
    let result = '';
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    let needLf = false;
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                const nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $1aad198f750e42d7$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    let result = '';
    for(let i = 0, len = tokens.length; i < len; i++)switch(tokens[i].type){
        case 'text':
            result += tokens[i].content;
            break;
        case 'image':
            result += this.renderInlineAsText(tokens[i].children, options, env);
            break;
        case 'html_inline':
        case 'html_block':
            result += tokens[i].content;
            break;
        case 'softbreak':
        case 'hardbreak':
            result += '\n';
            break;
        default:
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $1aad198f750e42d7$var$Renderer.prototype.render = function(tokens, options, env) {
    let result = '';
    const rules = this.rules;
    for(let i = 0, len = tokens.length; i < len; i++){
        const type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
var $1aad198f750e42d7$export$2e2bcd8739ae039 = $1aad198f750e42d7$var$Renderer;

});

parcelRegister("k9yBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dbd8732bf2ea1e5$export$2e2bcd8739ae039);
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 
var $ivdLE = parcelRequire("ivdLE");

var $go9ta = parcelRequire("go9ta");

var $7Wb5y = parcelRequire("7Wb5y");

var $kyAUR = parcelRequire("kyAUR");

var $kZRQ9 = parcelRequire("kZRQ9");

var $bPtYp = parcelRequire("bPtYp");

var $7SEiM = parcelRequire("7SEiM");

var $1CMIq = parcelRequire("1CMIq");

var $321t5 = parcelRequire("321t5");
const $1dbd8732bf2ea1e5$var$_rules = [
    [
        'normalize',
        (0, $7Wb5y.default)
    ],
    [
        'block',
        (0, $kyAUR.default)
    ],
    [
        'inline',
        (0, $kZRQ9.default)
    ],
    [
        'linkify',
        (0, $bPtYp.default)
    ],
    [
        'replacements',
        (0, $7SEiM.default)
    ],
    [
        'smartquotes',
        (0, $1CMIq.default)
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (0, $321t5.default)
    ]
];
/**
 * new Core()
 **/ function $1dbd8732bf2ea1e5$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new (0, $ivdLE.default)();
    for(let i = 0; i < $1dbd8732bf2ea1e5$var$_rules.length; i++)this.ruler.push($1dbd8732bf2ea1e5$var$_rules[i][0], $1dbd8732bf2ea1e5$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $1dbd8732bf2ea1e5$var$Core.prototype.process = function(state) {
    const rules = this.ruler.getRules('');
    for(let i = 0, l = rules.length; i < l; i++)rules[i](state);
};
$1dbd8732bf2ea1e5$var$Core.prototype.State = (0, $go9ta.default);
var $1dbd8732bf2ea1e5$export$2e2bcd8739ae039 = $1dbd8732bf2ea1e5$var$Core;

});
parcelRegister("ivdLE", function(module, exports) {

$parcel$export(module.exports, "default", () => $41ea3ea6c70806b8$export$2e2bcd8739ae039);
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ /**
 * new Ruler()
 **/ function $41ea3ea6c70806b8$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
// Helper methods, should not be used directly
// Find rule index by name
//
$41ea3ea6c70806b8$var$Ruler.prototype.__find__ = function(name) {
    for(let i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$41ea3ea6c70806b8$var$Ruler.prototype.__compile__ = function() {
    const self = this;
    const chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.at = function(name, fn, options) {
    const index = this.__find__(name);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    const index = this.__find__(beforeName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    const index = this.__find__(afterName);
    const opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.push = function(ruleName, fn, options) {
    const opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and enable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    const result = [];
    // Search by name and disable
    list.forEach(function(name) {
        const idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $41ea3ea6c70806b8$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
var $41ea3ea6c70806b8$export$2e2bcd8739ae039 = $41ea3ea6c70806b8$var$Ruler;

});

parcelRegister("go9ta", function(module, exports) {

$parcel$export(module.exports, "default", () => $8993a444d7ae3c83$export$2e2bcd8739ae039);
// Core state object
//

var $kt13Y = parcelRequire("kt13Y");
function $8993a444d7ae3c83$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md // link to parser instance
    ;
}
// re-export Token class to use in core rules
$8993a444d7ae3c83$var$StateCore.prototype.Token = (0, $kt13Y.default);
var $8993a444d7ae3c83$export$2e2bcd8739ae039 = $8993a444d7ae3c83$var$StateCore;

});
parcelRegister("kt13Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ac17e6d91b036a$export$2e2bcd8739ae039);
// Token class
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $59ac17e6d91b036a$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrIndex = function attrIndex(name) {
    if (!this.attrs) return -1;
    const attrs = this.attrs;
    for(let i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $59ac17e6d91b036a$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrSet = function attrSet(name, value) {
    const idx = this.attrIndex(name);
    const attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrGet = function attrGet(name) {
    const idx = this.attrIndex(name);
    let value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $59ac17e6d91b036a$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    const idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
var $59ac17e6d91b036a$export$2e2bcd8739ae039 = $59ac17e6d91b036a$var$Token;

});


parcelRegister("7Wb5y", function(module, exports) {

$parcel$export(module.exports, "default", () => $5203c6838a32c344$export$2e2bcd8739ae039);
// Normalize input string
// https://spec.commonmark.org/0.29/#line-ending
const $5203c6838a32c344$var$NEWLINES_RE = /\r\n?|\n/g;
const $5203c6838a32c344$var$NULL_RE = /\0/g;
function $5203c6838a32c344$export$2e2bcd8739ae039(state) {
    let str;
    // Normalize newlines
    str = state.src.replace($5203c6838a32c344$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($5203c6838a32c344$var$NULL_RE, '\uFFFD');
    state.src = str;
}

});

parcelRegister("kyAUR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd7698881deefc7d$export$2e2bcd8739ae039);
function $cd7698881deefc7d$export$2e2bcd8739ae039(state) {
    let token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
}

});

parcelRegister("kZRQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $196eb58ba8a882c3$export$2e2bcd8739ae039);
function $196eb58ba8a882c3$export$2e2bcd8739ae039(state) {
    const tokens = state.tokens;
    // Parse inlines
    for(let i = 0, l = tokens.length; i < l; i++){
        const tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
}

});

parcelRegister("bPtYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e017aabd93d74ca7$export$2e2bcd8739ae039);
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//

var $l5FiO = parcelRequire("l5FiO");
function $e017aabd93d74ca7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $e017aabd93d74ca7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $e017aabd93d74ca7$export$2e2bcd8739ae039(state) {
    const blockTokens = state.tokens;
    if (!state.md.options.linkify) return;
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($e017aabd93d74ca7$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($e017aabd93d74ca7$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = state.md.linkify.match(text);
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(let ln = 0; ln < links.length; ln++){
                    const url = links[ln].url;
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    const token_o = new state.Token('link_open', 'a', 1);
                    token_o.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token_o.level = level++;
                    token_o.markup = 'linkify';
                    token_o.info = 'auto';
                    nodes.push(token_o);
                    const token_t = new state.Token('text', '', 0);
                    token_t.content = urlText;
                    token_t.level = level;
                    nodes.push(token_t);
                    const token_c = new state.Token('link_close', 'a', -1);
                    token_c.level = --level;
                    token_c.markup = 'linkify';
                    token_c.info = 'auto';
                    nodes.push(token_c);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = (0, $l5FiO.arrayReplaceAt)(tokens, i, nodes);
            }
        }
    }
}

});

parcelRegister("7SEiM", function(module, exports) {

$parcel$export(module.exports, "default", () => $71faf318b045012d$export$2e2bcd8739ae039);
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
const $71faf318b045012d$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
const $71faf318b045012d$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
const $71faf318b045012d$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
const $71faf318b045012d$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $71faf318b045012d$var$replaceFn(match, name) {
    return $71faf318b045012d$var$SCOPED_ABBR[name.toLowerCase()];
}
function $71faf318b045012d$var$replace_scoped(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($71faf318b045012d$var$SCOPED_ABBR_RE, $71faf318b045012d$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $71faf318b045012d$var$replace_rare(inlineTokens) {
    let inside_autolink = 0;
    for(let i = inlineTokens.length - 1; i >= 0; i--){
        const token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($71faf318b045012d$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $71faf318b045012d$export$2e2bcd8739ae039(state) {
    let blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($71faf318b045012d$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $71faf318b045012d$var$replace_scoped(state.tokens[blkIdx].children);
        if ($71faf318b045012d$var$RARE_RE.test(state.tokens[blkIdx].content)) $71faf318b045012d$var$replace_rare(state.tokens[blkIdx].children);
    }
}

});

parcelRegister("1CMIq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18c84f826c38cf40$export$2e2bcd8739ae039);
// Convert straight quotation marks to typographic ones
//

var $l5FiO = parcelRequire("l5FiO");
const $18c84f826c38cf40$var$QUOTE_TEST_RE = /['"]/;
const $18c84f826c38cf40$var$QUOTE_RE = /['"]/g;
const $18c84f826c38cf40$var$APOSTROPHE = '\u2019' /* ’ */ ;
function $18c84f826c38cf40$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $18c84f826c38cf40$var$process_inlines(tokens, state) {
    let j;
    const stack = [];
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        const thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        let text = token.content;
        let pos = 0;
        let max = text.length;
        /* eslint no-labels:0,block-scoped-var:0 */ OUTER: while(pos < max){
            $18c84f826c38cf40$var$QUOTE_RE.lastIndex = pos;
            const t = $18c84f826c38cf40$var$QUOTE_RE.exec(text);
            if (!t) break;
            let canOpen = true;
            let canClose = true;
            pos = t.index + 1;
            const isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            let lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            let nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            const isLastPunctChar = (0, $l5FiO.isMdAsciiPunct)(lastChar) || (0, $l5FiO.isPunctChar)(String.fromCharCode(lastChar));
            const isNextPunctChar = (0, $l5FiO.isMdAsciiPunct)(nextChar) || (0, $l5FiO.isPunctChar)(String.fromCharCode(nextChar));
            const isLastWhiteSpace = (0, $l5FiO.isWhiteSpace)(lastChar);
            const isNextWhiteSpace = (0, $l5FiO.isWhiteSpace)(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $18c84f826c38cf40$var$replaceAt(token.content, t.index, $18c84f826c38cf40$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                let item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    let openQuote;
                    let closeQuote;
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $18c84f826c38cf40$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $18c84f826c38cf40$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $18c84f826c38cf40$var$replaceAt(token.content, t.index, $18c84f826c38cf40$var$APOSTROPHE);
        }
    }
}
function $18c84f826c38cf40$export$2e2bcd8739ae039(state) {
    /* eslint max-depth:0 */ if (!state.md.options.typographer) return;
    for(let blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$18c84f826c38cf40$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $18c84f826c38cf40$var$process_inlines(state.tokens[blkIdx].children, state);
    }
}

});

parcelRegister("321t5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a6cf0d0aa696419$export$2e2bcd8739ae039);
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
function $7a6cf0d0aa696419$export$2e2bcd8739ae039(state) {
    let curr, last;
    const blockTokens = state.tokens;
    const l = blockTokens.length;
    for(let j = 0; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        const tokens = blockTokens[j].children;
        const max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
}

});


parcelRegister("85F5r", function(module, exports) {

$parcel$export(module.exports, "default", () => $3349c57a2e9a47a9$export$2e2bcd8739ae039);
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 
var $ivdLE = parcelRequire("ivdLE");

var $6L8OF = parcelRequire("6L8OF");

var $j9ipK = parcelRequire("j9ipK");

var $agd2S = parcelRequire("agd2S");

var $iGy8g = parcelRequire("iGy8g");

var $be3Cl = parcelRequire("be3Cl");

var $20Khv = parcelRequire("20Khv");

var $hSRTK = parcelRequire("hSRTK");

var $2tsdn = parcelRequire("2tsdn");

var $8wbQn = parcelRequire("8wbQn");

var $k2e4T = parcelRequire("k2e4T");

var $eet15 = parcelRequire("eet15");

var $jRtc6 = parcelRequire("jRtc6");
const $3349c57a2e9a47a9$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (0, $j9ipK.default),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (0, $agd2S.default)
    ],
    [
        'fence',
        (0, $iGy8g.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (0, $be3Cl.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (0, $20Khv.default),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (0, $hSRTK.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (0, $2tsdn.default)
    ],
    [
        'html_block',
        (0, $8wbQn.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (0, $k2e4T.default),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (0, $eet15.default)
    ],
    [
        'paragraph',
        (0, $jRtc6.default)
    ]
];
/**
 * new ParserBlock()
 **/ function $3349c57a2e9a47a9$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new (0, $ivdLE.default)();
    for(let i = 0; i < $3349c57a2e9a47a9$var$_rules.length; i++)this.ruler.push($3349c57a2e9a47a9$var$_rules[i][0], $3349c57a2e9a47a9$var$_rules[i][1], {
        alt: ($3349c57a2e9a47a9$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$3349c57a2e9a47a9$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    let line = startLine;
    let hasEmptyLines = false;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        const prevLine = state.line;
        let ok = false;
        for(let i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $3349c57a2e9a47a9$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    if (!src) return;
    const state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};
$3349c57a2e9a47a9$var$ParserBlock.prototype.State = (0, $6L8OF.default);
var $3349c57a2e9a47a9$export$2e2bcd8739ae039 = $3349c57a2e9a47a9$var$ParserBlock;

});
parcelRegister("6L8OF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad2420667aa7c8e8$export$2e2bcd8739ae039);
// Parser state class

var $kt13Y = parcelRequire("kt13Y");

var $l5FiO = parcelRequire("l5FiO");
function $ad2420667aa7c8e8$var$StateBlock(src, md, env, tokens) {
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = [] // line begin offsets for fast jumps
    ;
    this.eMarks = [] // line end offsets for fast jumps
    ;
    this.tShift = [] // offsets of the first non-space characters (tabs not expanded)
    ;
    this.sCount = [] // indents for each line (tabs expanded)
    ;
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.blkIndent = 0;
    this.line = 0 // line index in src
    ;
    this.lineMax = 0 // lines count
    ;
    this.tight = false // loose/tight mode for lists
    ;
    this.ddIndent = -1 // indent of the current dd block (-1 if there isn't any)
    ;
    this.listIndent = -1 // indent of the current list block (-1 if there isn't any)
    ;
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // Create caches
    // Generate markers.
    const s = this.src;
    for(let start = 0, pos = 0, indent = 0, offset = 0, len = s.length, indent_found = false; pos < len; pos++){
        const ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ((0, $l5FiO.isSpace)(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1 // don't count last fake line
    ;
}
// Push new token to "stream".
//
$ad2420667aa7c8e8$var$StateBlock.prototype.push = function(type, tag, nesting) {
    const token = new (0, $kt13Y.default)(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level-- // closing tag
    ;
    token.level = this.level;
    if (nesting > 0) this.level++ // opening tag
    ;
    this.tokens.push(token);
    return token;
};
$ad2420667aa7c8e8$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$ad2420667aa7c8e8$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(let max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$ad2420667aa7c8e8$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    for(let max = this.src.length; pos < max; pos++){
        const ch = this.src.charCodeAt(pos);
        if (!(0, $l5FiO.isSpace)(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$ad2420667aa7c8e8$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!(0, $l5FiO.isSpace)(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$ad2420667aa7c8e8$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(let max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$ad2420667aa7c8e8$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$ad2420667aa7c8e8$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    if (begin >= end) return '';
    const queue = new Array(end - begin);
    for(let i = 0, line = begin; line < end; line++, i++){
        let lineIndent = 0;
        const lineStart = this.bMarks[line];
        let first = lineStart;
        let last;
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            const ch = this.src.charCodeAt(first);
            if ((0, $l5FiO.isSpace)(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$ad2420667aa7c8e8$var$StateBlock.prototype.Token = (0, $kt13Y.default);
var $ad2420667aa7c8e8$export$2e2bcd8739ae039 = $ad2420667aa7c8e8$var$StateBlock;

});

parcelRegister("j9ipK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef92aecf350006a$export$2e2bcd8739ae039);
// GFM table, https://github.github.com/gfm/#tables-extension-

var $l5FiO = parcelRequire("l5FiO");
// Limit the amount of empty autocompleted cells in a table,
// see https://github.com/markdown-it/markdown-it/issues/1000,
//
// Both pulldown-cmark and commonmark-hs limit the number of cells this way to ~200k.
// We set it to 65k, which can expand user input by a factor of x370
// (256x256 square is 1.8kB expanded into 650kB).
const $2ef92aecf350006a$var$MAX_AUTOCOMPLETED_CELLS = 0x10000;
function $2ef92aecf350006a$var$getLine(state, line) {
    const pos = state.bMarks[line] + state.tShift[line];
    const max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $2ef92aecf350006a$var$escapedSplit(str) {
    const result = [];
    const max = str.length;
    let pos = 0;
    let ch = str.charCodeAt(pos);
    let isEscaped = false;
    let lastPos = 0;
    let current = '';
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
function $2ef92aecf350006a$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    let nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    let pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    const firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    const secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !(0, $l5FiO.isSpace)(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && (0, $l5FiO.isSpace)(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        const ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !(0, $l5FiO.isSpace)(ch)) return false;
        pos++;
    }
    let lineText = $2ef92aecf350006a$var$getLine(state, startLine + 1);
    let columns = lineText.split('|');
    const aligns = [];
    for(let i = 0; i < columns.length; i++){
        const t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $2ef92aecf350006a$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $2ef92aecf350006a$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    const columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    const oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const token_to = state.push('table_open', 'table', 1);
    const tableLines = [
        startLine,
        0
    ];
    token_to.map = tableLines;
    const token_tho = state.push('thead_open', 'thead', 1);
    token_tho.map = [
        startLine,
        startLine + 1
    ];
    const token_htro = state.push('tr_open', 'tr', 1);
    token_htro.map = [
        startLine,
        startLine + 1
    ];
    for(let i = 0; i < columns.length; i++){
        const token_ho = state.push('th_open', 'th', 1);
        if (aligns[i]) token_ho.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        const token_il = state.push('inline', '', 0);
        token_il.content = columns[i].trim();
        token_il.children = [];
        state.push('th_close', 'th', -1);
    }
    state.push('tr_close', 'tr', -1);
    state.push('thead_close', 'thead', -1);
    let tbodyLines;
    let autocompletedCells = 0;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $2ef92aecf350006a$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $2ef92aecf350006a$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        // note: autocomplete count can be negative if user specifies more columns than header,
        // but that does not affect intended use (which is limiting expansion)
        autocompletedCells += columnCount - columns.length;
        if (autocompletedCells > $2ef92aecf350006a$var$MAX_AUTOCOMPLETED_CELLS) break;
        if (nextLine === startLine + 2) {
            const token_tbo = state.push('tbody_open', 'tbody', 1);
            token_tbo.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        const token_tro = state.push('tr_open', 'tr', 1);
        token_tro.map = [
            nextLine,
            nextLine + 1
        ];
        for(let i = 0; i < columnCount; i++){
            const token_tdo = state.push('td_open', 'td', 1);
            if (aligns[i]) token_tdo.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            const token_il = state.push('inline', '', 0);
            token_il.content = columns[i] ? columns[i].trim() : '';
            token_il.children = [];
            state.push('td_close', 'td', -1);
        }
        state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
}

});

parcelRegister("agd2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $319716b5135e5657$export$2e2bcd8739ae039);
// Code block (4 spaces padded)
function $319716b5135e5657$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    let nextLine = startLine + 1;
    let last = nextLine;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    const token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("iGy8g", function(module, exports) {

$parcel$export(module.exports, "default", () => $96fff8032daf3c7b$export$2e2bcd8739ae039);
// fences (``` lang, ~~~ lang)
function $96fff8032daf3c7b$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    const marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    let mem = pos;
    pos = state.skipChars(pos, marker);
    let len = pos - mem;
    if (len < 3) return false;
    const markup = state.src.slice(mem, pos);
    const params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    let nextLine = startLine;
    let haveEndMarker = false;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    const token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
}

});

parcelRegister("be3Cl", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f381d401e94dfa$export$2e2bcd8739ae039);
// Block quotes

var $l5FiO = parcelRequire("l5FiO");
function $56f381d401e94dfa$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    const oldLineMax = state.lineMax;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    const oldBMarks = [];
    const oldBSCount = [];
    const oldSCount = [];
    const oldTShift = [];
    const terminatorRules = state.md.block.ruler.getRules('blockquote');
    const oldParentType = state.parentType;
    state.parentType = 'blockquote';
    let lastLineEmpty = false;
    let nextLine;
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        const isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            let initial = state.sCount[nextLine] + 1;
            let spaceAfterMarker;
            let adjustTab;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            let offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                const ch = state.src.charCodeAt(pos);
                if ((0, $l5FiO.isSpace)(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    const oldIndent = state.blkIndent;
    state.blkIndent = 0;
    const token_o = state.push('blockquote_open', 'blockquote', 1);
    token_o.markup = '>';
    const lines = [
        startLine,
        0
    ];
    token_o.map = lines;
    state.md.block.tokenize(state, startLine, nextLine);
    const token_c = state.push('blockquote_close', 'blockquote', -1);
    token_c.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(let i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
}

});

parcelRegister("20Khv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd654477b14b4267$export$2e2bcd8739ae039);
// Horizontal rule

var $l5FiO = parcelRequire("l5FiO");
function $bd654477b14b4267$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    const max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    let cnt = 1;
    while(pos < max){
        const ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !(0, $l5FiO.isSpace)(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    const token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
}

});

parcelRegister("hSRTK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b7cbf7838646e8a$export$2e2bcd8739ae039);
// Lists

var $l5FiO = parcelRequire("l5FiO");
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $3b7cbf7838646e8a$var$skipBulletListMarker(state, startLine) {
    const max = state.eMarks[startLine];
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    const marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        const ch = state.src.charCodeAt(pos);
        if (!(0, $l5FiO.isSpace)(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $3b7cbf7838646e8a$var$skipOrderedListMarker(state, startLine) {
    const start = state.bMarks[startLine] + state.tShift[startLine];
    const max = state.eMarks[startLine];
    let pos = start;
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    let ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!(0, $l5FiO.isSpace)(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $3b7cbf7838646e8a$var$markTightParagraphs(state, idx) {
    const level = state.level + 2;
    for(let i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
function $3b7cbf7838646e8a$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let max, pos, start, token;
    let nextLine = startLine;
    let tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    let isTerminatingParagraph = false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    let isOrdered;
    let markerValue;
    let posAfterMarker;
    if ((posAfterMarker = $3b7cbf7838646e8a$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $3b7cbf7838646e8a$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    const markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    const listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    const listLines = [
        nextLine,
        0
    ];
    token.map = listLines;
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    let prevEmptyEnd = false;
    const terminatorRules = state.md.block.ruler.getRules('list');
    const oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        const initial = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        let offset = initial;
        while(pos < max){
            const ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        const contentStart = pos;
        let indentAfterMarker;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        const indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        const itemLines = [
            nextLine,
            0
        ];
        token.map = itemLines;
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        const oldTight = state.tight;
        const oldTShift = state.tShift[nextLine];
        const oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        const oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $3b7cbf7838646e8a$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $3b7cbf7838646e8a$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $3b7cbf7838646e8a$var$markTightParagraphs(state, listTokIdx);
    return true;
}

});

parcelRegister("2tsdn", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc5cd5db6853c1d8$export$2e2bcd8739ae039);

var $l5FiO = parcelRequire("l5FiO");
function $dc5cd5db6853c1d8$export$2e2bcd8739ae039(state, startLine, _endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    let nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    function getNextLine(nextLine) {
        const endLine = state.lineMax;
        if (nextLine >= endLine || state.isEmpty(nextLine)) // empty line or end of input
        return null;
        let isContinuation = false;
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) isContinuation = true;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) isContinuation = true;
        if (!isContinuation) {
            const terminatorRules = state.md.block.ruler.getRules('reference');
            const oldParentType = state.parentType;
            state.parentType = 'reference';
            // Some tags can terminate paragraph without empty line.
            let terminate = false;
            for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
                terminate = true;
                break;
            }
            state.parentType = oldParentType;
            if (terminate) // terminated by another block
            return null;
        }
        const pos = state.bMarks[nextLine] + state.tShift[nextLine];
        const max = state.eMarks[nextLine];
        // max + 1 explicitly includes the newline
        return state.src.slice(pos, max + 1);
    }
    let str = state.src.slice(pos, max + 1);
    max = str.length;
    let labelEnd = -1;
    for(pos = 1; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) {
                const lineContent = getNextLine(nextLine);
                if (lineContent !== null) {
                    str += lineContent;
                    max = str.length;
                    nextLine++;
                }
            }
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $l5FiO.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    const destRes = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!destRes.ok) return false;
    const href = state.md.normalizeLink(destRes.str);
    if (!state.md.validateLink(href)) return false;
    pos = destRes.pos;
    // save cursor state, we could require to rollback later
    const destEndPos = pos;
    const destEndLineNo = nextLine;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    const start = pos;
    for(; pos < max; pos++){
        const ch = str.charCodeAt(pos);
        if (ch === 0x0A) {
            const lineContent = getNextLine(nextLine);
            if (lineContent !== null) {
                str += lineContent;
                max = str.length;
                nextLine++;
            }
        } else if ((0, $l5FiO.isSpace)(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    let titleRes = state.md.helpers.parseLinkTitle(str, pos, max);
    while(titleRes.can_continue){
        const lineContent = getNextLine(nextLine);
        if (lineContent === null) break;
        str += lineContent;
        pos = max;
        max = str.length;
        nextLine++;
        titleRes = state.md.helpers.parseLinkTitle(str, pos, max, titleRes);
    }
    let title;
    if (pos < max && start !== pos && titleRes.ok) {
        title = titleRes.str;
        pos = titleRes.pos;
    } else {
        title = '';
        pos = destEndPos;
        nextLine = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        const ch = str.charCodeAt(pos);
        if (!(0, $l5FiO.isSpace)(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            nextLine = destEndLineNo;
            while(pos < max){
                const ch = str.charCodeAt(pos);
                if (!(0, $l5FiO.isSpace)(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    const label = (0, $l5FiO.normalizeReference)(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /* istanbul ignore if */ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.line = nextLine;
    return true;
}

});

parcelRegister("8wbQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9386c6e85fc1b48$export$2e2bcd8739ae039);
// HTML block

var $cfJ3G = parcelRequire("cfJ3G");

var $cL6Zf = parcelRequire("cL6Zf");
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
const $d9386c6e85fc1b48$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + (0, $cfJ3G.default).join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp((0, $cL6Zf.HTML_OPEN_CLOSE_TAG_RE).source + '\\s*$'),
        /^$/,
        false
    ]
];
function $d9386c6e85fc1b48$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    let lineText = state.src.slice(pos, max);
    let i = 0;
    for(; i < $d9386c6e85fc1b48$var$HTML_SEQUENCES.length; i++){
        if ($d9386c6e85fc1b48$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $d9386c6e85fc1b48$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $d9386c6e85fc1b48$var$HTML_SEQUENCES[i][2];
    let nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$d9386c6e85fc1b48$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($d9386c6e85fc1b48$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    const token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
}

});
parcelRegister("cfJ3G", function(module, exports) {

$parcel$export(module.exports, "default", () => $8955e68447e3f9db$export$2e2bcd8739ae039);
// List of valid html blocks names, according to commonmark spec
// https://spec.commonmark.org/0.30/#html-blocks
var $8955e68447e3f9db$export$2e2bcd8739ae039 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("cL6Zf", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $08e6c33d10f51cc6$export$6db61d2c3a16e419);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $08e6c33d10f51cc6$export$cd48660d06f74639);
// Regexps to match html elements
const $08e6c33d10f51cc6$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
const $08e6c33d10f51cc6$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
const $08e6c33d10f51cc6$var$single_quoted = "'[^']*'";
const $08e6c33d10f51cc6$var$double_quoted = '"[^"]*"';
const $08e6c33d10f51cc6$var$attr_value = '(?:' + $08e6c33d10f51cc6$var$unquoted + '|' + $08e6c33d10f51cc6$var$single_quoted + '|' + $08e6c33d10f51cc6$var$double_quoted + ')';
const $08e6c33d10f51cc6$var$attribute = '(?:\\s+' + $08e6c33d10f51cc6$var$attr_name + '(?:\\s*=\\s*' + $08e6c33d10f51cc6$var$attr_value + ')?)';
const $08e6c33d10f51cc6$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $08e6c33d10f51cc6$var$attribute + '*\\s*\\/?>';
const $08e6c33d10f51cc6$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
const $08e6c33d10f51cc6$var$comment = '<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->';
const $08e6c33d10f51cc6$var$processing = '<[?][\\s\\S]*?[?]>';
const $08e6c33d10f51cc6$var$declaration = '<![A-Za-z][^>]*>';
const $08e6c33d10f51cc6$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
const $08e6c33d10f51cc6$export$6db61d2c3a16e419 = new RegExp('^(?:' + $08e6c33d10f51cc6$var$open_tag + '|' + $08e6c33d10f51cc6$var$close_tag + '|' + $08e6c33d10f51cc6$var$comment + '|' + $08e6c33d10f51cc6$var$processing + '|' + $08e6c33d10f51cc6$var$declaration + '|' + $08e6c33d10f51cc6$var$cdata + ')');
const $08e6c33d10f51cc6$export$cd48660d06f74639 = new RegExp('^(?:' + $08e6c33d10f51cc6$var$open_tag + '|' + $08e6c33d10f51cc6$var$close_tag + ')');

});


parcelRegister("k2e4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd7f552fbefa4306$export$2e2bcd8739ae039);
// heading (#, ##, ...)

var $l5FiO = parcelRequire("l5FiO");
function $dd7f552fbefa4306$export$2e2bcd8739ae039(state, startLine, endLine, silent) {
    let pos = state.bMarks[startLine] + state.tShift[startLine];
    let max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    let ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    let level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !(0, $l5FiO.isSpace)(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    const tmp = state.skipCharsBack(max, 0x23, pos) // #
    ;
    if (tmp > pos && (0, $l5FiO.isSpace)(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = '########'.slice(0, level);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = state.src.slice(pos, max).trim();
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = '########'.slice(0, level);
    return true;
}

});

parcelRegister("eet15", function(module, exports) {

$parcel$export(module.exports, "default", () => $acb81d8044351f9f$export$2e2bcd8739ae039);
// lheading (---, ===)
function $acb81d8044351f9f$export$2e2bcd8739ae039(state, startLine, endLine /*, silent */ ) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph' // use paragraph to match terminatorRules
    ;
    // jump line-by-line until empty one or EOF
    let level = 0;
    let marker;
    let nextLine = startLine + 1;
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            let pos = state.bMarks[nextLine] + state.tShift[nextLine];
            const max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    const token_o = state.push('heading_open', 'h' + String(level), 1);
    token_o.markup = String.fromCharCode(marker);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line - 1
    ];
    token_i.children = [];
    const token_c = state.push('heading_close', 'h' + String(level), -1);
    token_c.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
}

});

parcelRegister("jRtc6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d374391f851a68ad$export$2e2bcd8739ae039);
// Paragraph
function $d374391f851a68ad$export$2e2bcd8739ae039(state, startLine, endLine) {
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const oldParentType = state.parentType;
    let nextLine = startLine + 1;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        let terminate = false;
        for(let i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    const content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    const token_o = state.push('paragraph_open', 'p', 1);
    token_o.map = [
        startLine,
        state.line
    ];
    const token_i = state.push('inline', '', 0);
    token_i.content = content;
    token_i.map = [
        startLine,
        state.line
    ];
    token_i.children = [];
    state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
}

});


parcelRegister("9FoBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $086c870d02d0d269$export$2e2bcd8739ae039);
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 
var $ivdLE = parcelRequire("ivdLE");

var $1czcs = parcelRequire("1czcs");

var $8PMIO = parcelRequire("8PMIO");

var $7euv9 = parcelRequire("7euv9");

var $dZU79 = parcelRequire("dZU79");

var $6dd0R = parcelRequire("6dd0R");

var $58ovT = parcelRequire("58ovT");

var $lzhv2 = parcelRequire("lzhv2");

var $eFZln = parcelRequire("eFZln");

var $gXGl2 = parcelRequire("gXGl2");

var $6daCp = parcelRequire("6daCp");

var $5NxXN = parcelRequire("5NxXN");

var $ic1xE = parcelRequire("ic1xE");

var $5G7nR = parcelRequire("5G7nR");

var $3k9cA = parcelRequire("3k9cA");

var $nTs4s = parcelRequire("nTs4s");
// Parser rules
const $086c870d02d0d269$var$_rules = [
    [
        'text',
        (0, $8PMIO.default)
    ],
    [
        'linkify',
        (0, $7euv9.default)
    ],
    [
        'newline',
        (0, $dZU79.default)
    ],
    [
        'escape',
        (0, $6dd0R.default)
    ],
    [
        'backticks',
        (0, $58ovT.default)
    ],
    [
        'strikethrough',
        (0, $lzhv2.default).tokenize
    ],
    [
        'emphasis',
        (0, $eFZln.default).tokenize
    ],
    [
        'link',
        (0, $gXGl2.default)
    ],
    [
        'image',
        (0, $6daCp.default)
    ],
    [
        'autolink',
        (0, $5NxXN.default)
    ],
    [
        'html_inline',
        (0, $ic1xE.default)
    ],
    [
        'entity',
        (0, $5G7nR.default)
    ]
];
// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
const $086c870d02d0d269$var$_rules2 = [
    [
        'balance_pairs',
        (0, $3k9cA.default)
    ],
    [
        'strikethrough',
        (0, $lzhv2.default).postProcess
    ],
    [
        'emphasis',
        (0, $eFZln.default).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (0, $nTs4s.default)
    ]
];
/**
 * new ParserInline()
 **/ function $086c870d02d0d269$var$ParserInline() {
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new (0, $ivdLE.default)();
    for(let i = 0; i < $086c870d02d0d269$var$_rules.length; i++)this.ruler.push($086c870d02d0d269$var$_rules[i][0], $086c870d02d0d269$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new (0, $ivdLE.default)();
    for(let i = 0; i < $086c870d02d0d269$var$_rules2.length; i++)this.ruler2.push($086c870d02d0d269$var$_rules2[i][0], $086c870d02d0d269$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$086c870d02d0d269$var$ParserInline.prototype.skipToken = function(state) {
    const pos = state.pos;
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const maxNesting = state.md.options.maxNesting;
    const cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    let ok = false;
    if (state.level < maxNesting) for(let i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$086c870d02d0d269$var$ParserInline.prototype.tokenize = function(state) {
    const rules = this.ruler.getRules('');
    const len = rules.length;
    const end = state.posMax;
    const maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        const prevPos = state.pos;
        let ok = false;
        if (state.level < maxNesting) for(let i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $086c870d02d0d269$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    const state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    const rules = this.ruler2.getRules('');
    const len = rules.length;
    for(let i = 0; i < len; i++)rules[i](state);
};
$086c870d02d0d269$var$ParserInline.prototype.State = (0, $1czcs.default);
var $086c870d02d0d269$export$2e2bcd8739ae039 = $086c870d02d0d269$var$ParserInline;

});
parcelRegister("1czcs", function(module, exports) {

$parcel$export(module.exports, "default", () => $78766ebe20d230e1$export$2e2bcd8739ae039);
// Inline parser state

var $kt13Y = parcelRequire("kt13Y");

var $l5FiO = parcelRequire("l5FiO");
function $78766ebe20d230e1$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$78766ebe20d230e1$var$StateInline.prototype.pushPending = function() {
    const token = new (0, $kt13Y.default)('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$78766ebe20d230e1$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    const token = new (0, $kt13Y.default)(type, tag, nesting);
    let token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$78766ebe20d230e1$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    const max = this.posMax;
    const marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    const lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    let pos = start;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    const count = pos - start;
    // treat end of the line as a whitespace
    const nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    const isLastPunctChar = (0, $l5FiO.isMdAsciiPunct)(lastChar) || (0, $l5FiO.isPunctChar)(String.fromCharCode(lastChar));
    const isNextPunctChar = (0, $l5FiO.isMdAsciiPunct)(nextChar) || (0, $l5FiO.isPunctChar)(String.fromCharCode(nextChar));
    const isLastWhiteSpace = (0, $l5FiO.isWhiteSpace)(lastChar);
    const isNextWhiteSpace = (0, $l5FiO.isWhiteSpace)(nextChar);
    const left_flanking = !isNextWhiteSpace && (!isNextPunctChar || isLastWhiteSpace || isLastPunctChar);
    const right_flanking = !isLastWhiteSpace && (!isLastPunctChar || isNextWhiteSpace || isNextPunctChar);
    const can_open = left_flanking && (canSplitWord || !right_flanking || isLastPunctChar);
    const can_close = right_flanking && (canSplitWord || !left_flanking || isNextPunctChar);
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$78766ebe20d230e1$var$StateInline.prototype.Token = (0, $kt13Y.default);
var $78766ebe20d230e1$export$2e2bcd8739ae039 = $78766ebe20d230e1$var$StateInline;

});

parcelRegister("8PMIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $52dad52dbdb68874$export$2e2bcd8739ae039);
// Skip text characters for text token, place those to pending buffer
// and increment current pos
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $52dad52dbdb68874$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
function $52dad52dbdb68874$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    while(pos < state.posMax && !$52dad52dbdb68874$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
} // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParserInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
}; */ 

});

parcelRegister("7euv9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d922190b2670a68c$export$2e2bcd8739ae039);
// Process links like https://example.org/
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
const $d922190b2670a68c$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function $d922190b2670a68c$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    const pos = state.pos;
    const max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    const match = state.pending.match($d922190b2670a68c$var$SCHEME_RE);
    if (!match) return false;
    const proto = match[1];
    const link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    let url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    // do manual backsearch to avoid perf issues with regex /\*+$/ on "****...****a".
    let urlEnd = url.length;
    while(urlEnd > 0 && url.charCodeAt(urlEnd - 1) === 0x2A /* * */ )urlEnd--;
    if (urlEnd !== url.length) url = url.slice(0, urlEnd);
    const fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        const token_o = state.push('link_open', 'a', 1);
        token_o.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token_o.markup = 'linkify';
        token_o.info = 'auto';
        const token_t = state.push('text', '', 0);
        token_t.content = state.md.normalizeLinkText(url);
        const token_c = state.push('link_close', 'a', -1);
        token_c.markup = 'linkify';
        token_c.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
}

});

parcelRegister("dZU79", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da0439b0e5b89ea$export$2e2bcd8739ae039);
// Proceess '\n'

var $l5FiO = parcelRequire("l5FiO");
function $4da0439b0e5b89ea$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    const max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                let ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && (0, $l5FiO.isSpace)(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
}

});

parcelRegister("6dd0R", function(module, exports) {

$parcel$export(module.exports, "default", () => $b91dce80827c08a1$export$2e2bcd8739ae039);
// Process escaped chars and hardbreaks

var $l5FiO = parcelRequire("l5FiO");
const $b91dce80827c08a1$var$ESCAPED = [];
for(let i = 0; i < 256; i++)$b91dce80827c08a1$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $b91dce80827c08a1$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
function $b91dce80827c08a1$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    let ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!(0, $l5FiO.isSpace)(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    let escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        const ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    const origStr = '\\' + escapedStr;
    if (!silent) {
        const token = state.push('text_special', '', 0);
        if (ch1 < 256 && $b91dce80827c08a1$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
}

});

parcelRegister("58ovT", function(module, exports) {

$parcel$export(module.exports, "default", () => $b39c44d4094d07d3$export$2e2bcd8739ae039);
// Parse backticks
function $b39c44d4094d07d3$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    const ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    const start = pos;
    pos++;
    const max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    const marker = state.src.slice(start, pos);
    const openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    let matchEnd = pos;
    let matchStart;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        const closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                const token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
}

});

parcelRegister("lzhv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e44d3b61071958$export$2e2bcd8739ae039);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $c4e44d3b61071958$var$strikethrough_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    const scanned = state.scanDelims(state.pos, true);
    let len = scanned.length;
    const ch = String.fromCharCode(marker);
    if (len < 2) return false;
    let token;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(let i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $c4e44d3b61071958$var$postProcess(state, delimiters) {
    let token;
    const loneMarkers = [];
    const max = delimiters.length;
    for(let i = 0; i < max; i++){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        const i = loneMarkers.pop();
        let j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $c4e44d3b61071958$var$strikethrough_postProcess(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $c4e44d3b61071958$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $c4e44d3b61071958$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $c4e44d3b61071958$export$2e2bcd8739ae039 = {
    tokenize: $c4e44d3b61071958$var$strikethrough_tokenize,
    postProcess: $c4e44d3b61071958$var$strikethrough_postProcess
};

});

parcelRegister("eFZln", function(module, exports) {

$parcel$export(module.exports, "default", () => $354922e1ef651ea3$export$2e2bcd8739ae039);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
function $354922e1ef651ea3$var$emphasis_tokenize(state, silent) {
    const start = state.pos;
    const marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    const scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(let i = 0; i < scanned.length; i++){
        const token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            marker: // Char code of the starting marker (number).
            //
            marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
}
function $354922e1ef651ea3$var$postProcess(state, delimiters) {
    const max = delimiters.length;
    for(let i = max - 1; i >= 0; i--){
        const startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        const endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        const isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        const ch = String.fromCharCode(startDelim.marker);
        const token_o = state.tokens[startDelim.token];
        token_o.type = isStrong ? 'strong_open' : 'em_open';
        token_o.tag = isStrong ? 'strong' : 'em';
        token_o.nesting = 1;
        token_o.markup = isStrong ? ch + ch : ch;
        token_o.content = '';
        const token_c = state.tokens[endDelim.token];
        token_c.type = isStrong ? 'strong_close' : 'em_close';
        token_c.tag = isStrong ? 'strong' : 'em';
        token_c.nesting = -1;
        token_c.markup = isStrong ? ch + ch : ch;
        token_c.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
// Walk through delimiter list and replace text tokens with tags
//
function $354922e1ef651ea3$var$emphasis_post_process(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $354922e1ef651ea3$var$postProcess(state, state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $354922e1ef651ea3$var$postProcess(state, tokens_meta[curr].delimiters);
}
var $354922e1ef651ea3$export$2e2bcd8739ae039 = {
    tokenize: $354922e1ef651ea3$var$emphasis_tokenize,
    postProcess: $354922e1ef651ea3$var$emphasis_post_process
};

});

parcelRegister("gXGl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $019ddf5760813e0c$export$2e2bcd8739ae039);
// Process [link](<to> "stuff")

var $l5FiO = parcelRequire("l5FiO");
function $019ddf5760813e0c$export$2e2bcd8739ae039(state, silent) {
    let code, label, res, ref;
    let href = '';
    let title = '';
    let start = state.pos;
    let parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    const oldPos = state.pos;
    const max = state.posMax;
    const labelStart = state.pos + 1;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    let pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $l5FiO.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $l5FiO.isSpace)(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!(0, $l5FiO.isSpace)(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $l5FiO.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        const token_o = state.push('link_open', 'a', 1);
        const attrs = [
            [
                'href',
                href
            ]
        ];
        token_o.attrs = attrs;
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("6daCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2e767ae90fa58fa$export$2e2bcd8739ae039);
// Process ![image](<src> "title")

var $l5FiO = parcelRequire("l5FiO");
function $f2e767ae90fa58fa$export$2e2bcd8739ae039(state, silent) {
    let code, content, label, pos, ref, res, title, start;
    let href = '';
    const oldPos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    const labelStart = state.pos + 2;
    const labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $l5FiO.isSpace)(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!(0, $l5FiO.isSpace)(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!(0, $l5FiO.isSpace)(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[(0, $l5FiO.normalizeReference)(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        const tokens = [];
        state.md.inline.parse(content, state.md, state.env, tokens);
        const token = state.push('image', 'img', 0);
        const attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.attrs = attrs;
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
}

});

parcelRegister("5NxXN", function(module, exports) {

$parcel$export(module.exports, "default", () => $38fe1de13dbca06b$export$2e2bcd8739ae039);
// Process autolinks '<protocol:...>'
/* eslint max-len:0 */ const $38fe1de13dbca06b$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
/* eslint-disable-next-line no-control-regex */ const $38fe1de13dbca06b$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function $38fe1de13dbca06b$export$2e2bcd8739ae039(state, silent) {
    let pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    const start = state.pos;
    const max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        const ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    const url = state.src.slice(start + 1, pos);
    if ($38fe1de13dbca06b$var$AUTOLINK_RE.test(url)) {
        const fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($38fe1de13dbca06b$var$EMAIL_RE.test(url)) {
        const fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            const token_o = state.push('link_open', 'a', 1);
            token_o.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token_o.markup = 'autolink';
            token_o.info = 'auto';
            const token_t = state.push('text', '', 0);
            token_t.content = state.md.normalizeLinkText(url);
            const token_c = state.push('link_close', 'a', -1);
            token_c.markup = 'autolink';
            token_c.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
}

});

parcelRegister("ic1xE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c398d6df9e0474f7$export$2e2bcd8739ae039);
// Process html tags

var $cL6Zf = parcelRequire("cL6Zf");
function $c398d6df9e0474f7$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $c398d6df9e0474f7$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $c398d6df9e0474f7$var$isLetter(ch) {
    /* eslint no-bitwise:0 */ const lc = ch | 0x20 // to lower case
    ;
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
function $c398d6df9e0474f7$export$2e2bcd8739ae039(state, silent) {
    if (!state.md.options.html) return false;
    // Check start
    const max = state.posMax;
    const pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    const ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$c398d6df9e0474f7$var$isLetter(ch)) return false;
    const match = state.src.slice(pos).match((0, $cL6Zf.HTML_TAG_RE));
    if (!match) return false;
    if (!silent) {
        const token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($c398d6df9e0474f7$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($c398d6df9e0474f7$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
}

});

parcelRegister("5G7nR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2605af2f776ac07c$export$2e2bcd8739ae039);
// Process html entity - &#123;, &#xAF;, &quot;, ...
parcelRequire("b9bcs");
var $gsyDe = parcelRequire("gsyDe");

var $l5FiO = parcelRequire("l5FiO");
const $2605af2f776ac07c$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
const $2605af2f776ac07c$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
function $2605af2f776ac07c$export$2e2bcd8739ae039(state, silent) {
    const pos = state.pos;
    const max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    const ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        const match = state.src.slice(pos).match($2605af2f776ac07c$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                const code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                const token = state.push('text_special', '', 0);
                token.content = (0, $l5FiO.isValidEntityCode)(code) ? (0, $l5FiO.fromCodePoint)(code) : (0, $l5FiO.fromCodePoint)(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        const match = state.src.slice(pos).match($2605af2f776ac07c$var$NAMED_RE);
        if (match) {
            const decoded = (0, $gsyDe.decodeHTML)(match[0]);
            if (decoded !== match[0]) {
                if (!silent) {
                    const token = state.push('text_special', '', 0);
                    token.content = decoded;
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
}

});

parcelRegister("3k9cA", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b620d722e5f8d3$export$2e2bcd8739ae039);
// For each opening emphasis-like marker find a matching closing one
//
function $86b620d722e5f8d3$var$processDelimiters(delimiters) {
    const openersBottom = {};
    const max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    let headerIdx = 0;
    let lastTokenIdx = -2 // needs any value lower than -1
    ;
    const jumps = [];
    for(let closerIdx = 0; closerIdx < max; closerIdx++){
        const closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        /* eslint-disable-next-line no-prototype-builtins */ if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        const minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        let openerIdx = headerIdx - jumps[headerIdx] - 1;
        let newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            const opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                let isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    const lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
function $86b620d722e5f8d3$export$2e2bcd8739ae039(state) {
    const tokens_meta = state.tokens_meta;
    const max = state.tokens_meta.length;
    $86b620d722e5f8d3$var$processDelimiters(state.delimiters);
    for(let curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $86b620d722e5f8d3$var$processDelimiters(tokens_meta[curr].delimiters);
}

});

parcelRegister("nTs4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $657f3da74a75df34$export$2e2bcd8739ae039);
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
function $657f3da74a75df34$export$2e2bcd8739ae039(state) {
    let curr, last;
    let level = 0;
    const tokens = state.tokens;
    const max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level-- // closing tag
        ;
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++ // opening tag
        ;
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
}

});


parcelRegister("kIdHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdfb0b45a2ba540e$export$2e2bcd8739ae039);

var $4buG7 = parcelRequire("4buG7");
//
// Helpers
//
// Merge objects
//
function $fdfb0b45a2ba540e$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $fdfb0b45a2ba540e$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $fdfb0b45a2ba540e$var$isString(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === '[object String]';
}
function $fdfb0b45a2ba540e$var$isObject(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === '[object Object]';
}
function $fdfb0b45a2ba540e$var$isRegExp(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === '[object RegExp]';
}
function $fdfb0b45a2ba540e$var$isFunction(obj) {
    return $fdfb0b45a2ba540e$var$_class(obj) === '[object Function]';
}
function $fdfb0b45a2ba540e$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
//
const $fdfb0b45a2ba540e$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $fdfb0b45a2ba540e$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $fdfb0b45a2ba540e$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $fdfb0b45a2ba540e$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $fdfb0b45a2ba540e$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $fdfb0b45a2ba540e$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
function $fdfb0b45a2ba540e$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $fdfb0b45a2ba540e$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $fdfb0b45a2ba540e$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $fdfb0b45a2ba540e$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $4buG7.default)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($fdfb0b45a2ba540e$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($fdfb0b45a2ba540e$var$isObject(val)) {
            if ($fdfb0b45a2ba540e$var$isRegExp(val.validate)) compiled.validate = $fdfb0b45a2ba540e$var$createValidator(val.validate);
            else if ($fdfb0b45a2ba540e$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($fdfb0b45a2ba540e$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $fdfb0b45a2ba540e$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($fdfb0b45a2ba540e$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $fdfb0b45a2ba540e$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($fdfb0b45a2ba540e$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $fdfb0b45a2ba540e$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $fdfb0b45a2ba540e$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $fdfb0b45a2ba540e$var$createMatch(self, shift) {
    const match = new $fdfb0b45a2ba540e$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $fdfb0b45a2ba540e$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $fdfb0b45a2ba540e$var$LinkifyIt)) return new $fdfb0b45a2ba540e$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($fdfb0b45a2ba540e$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $fdfb0b45a2ba540e$var$assign({}, $fdfb0b45a2ba540e$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1 // Next scan position
    ;
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $fdfb0b45a2ba540e$var$assign({}, $fdfb0b45a2ba540e$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $fdfb0b45a2ba540e$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $fdfb0b45a2ba540e$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $fdfb0b45a2ba540e$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $fdfb0b45a2ba540e$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($fdfb0b45a2ba540e$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($fdfb0b45a2ba540e$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $fdfb0b45a2ba540e$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $fdfb0b45a2ba540e$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $fdfb0b45a2ba540e$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $fdfb0b45a2ba540e$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $fdfb0b45a2ba540e$export$2e2bcd8739ae039 = $fdfb0b45a2ba540e$var$LinkifyIt;

});
parcelRegister("4buG7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8395954499c294bc$export$2e2bcd8739ae039);
parcelRequire("jV8ld");
var $2JiuG = parcelRequire("2JiuG");
var $9hAfm = parcelRequire("9hAfm");
var $65ucj = parcelRequire("65ucj");
var $36wNu = parcelRequire("36wNu");
function $8395954499c294bc$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $2JiuG.default).source;
    re.src_Cc = (0, $9hAfm.default).source;
    re.src_Z = (0, $36wNu.default).source;
    re.src_P = (0, $65ucj.default).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.{2,}[a-zA-Z0-9%/&]|' + '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + // allow `,,,` in paths
    ',(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    ';(?!' + re.src_ZCc + '|$)|' + // allow `!!!` in paths, but not at the end
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /* _root */  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
}

});


parcelRegister("hwtSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc1c99c5745bccf3$export$2e2bcd8739ae039);
'use strict';
/** Highest positive signed 32-bit float value */ const $cc1c99c5745bccf3$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $cc1c99c5745bccf3$var$base = 36;
const $cc1c99c5745bccf3$var$tMin = 1;
const $cc1c99c5745bccf3$var$tMax = 26;
const $cc1c99c5745bccf3$var$skew = 38;
const $cc1c99c5745bccf3$var$damp = 700;
const $cc1c99c5745bccf3$var$initialBias = 72;
const $cc1c99c5745bccf3$var$initialN = 128; // 0x80
const $cc1c99c5745bccf3$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $cc1c99c5745bccf3$var$regexPunycode = /^xn--/;
const $cc1c99c5745bccf3$var$regexNonASCII = /[^\0-\x7F]/; // Note: U+007F DEL is excluded too.
const $cc1c99c5745bccf3$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $cc1c99c5745bccf3$var$errors = {
    'overflow': 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
/** Convenience shortcuts */ const $cc1c99c5745bccf3$var$baseMinusTMin = $cc1c99c5745bccf3$var$base - $cc1c99c5745bccf3$var$tMin;
const $cc1c99c5745bccf3$var$floor = Math.floor;
const $cc1c99c5745bccf3$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $cc1c99c5745bccf3$var$error(type) {
    throw new RangeError($cc1c99c5745bccf3$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $cc1c99c5745bccf3$var$map(array, callback) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = callback(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {String} A new string of characters returned by the callback
 * function.
 */ function $cc1c99c5745bccf3$var$mapDomain(domain, callback) {
    const parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    domain = domain.replace($cc1c99c5745bccf3$var$regexSeparators, '\x2E');
    const labels = domain.split('.');
    const encoded = $cc1c99c5745bccf3$var$map(labels, callback).join('.');
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $cc1c99c5745bccf3$export$c1700176c90f250f(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $cc1c99c5745bccf3$export$f999239d9b149395 = (codePoints)=>String.fromCodePoint(...codePoints);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $cc1c99c5745bccf3$var$basicToDigit = function(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3A) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5B) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7B) return codePoint - 0x61;
    return $cc1c99c5745bccf3$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $cc1c99c5745bccf3$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $cc1c99c5745bccf3$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $cc1c99c5745bccf3$var$floor(delta / $cc1c99c5745bccf3$var$damp) : delta >> 1;
    delta += $cc1c99c5745bccf3$var$floor(delta / numPoints);
    for(; delta > $cc1c99c5745bccf3$var$baseMinusTMin * $cc1c99c5745bccf3$var$tMax >> 1; k += $cc1c99c5745bccf3$var$base)delta = $cc1c99c5745bccf3$var$floor(delta / $cc1c99c5745bccf3$var$baseMinusTMin);
    return $cc1c99c5745bccf3$var$floor(k + ($cc1c99c5745bccf3$var$baseMinusTMin + 1) * delta / (delta + $cc1c99c5745bccf3$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $cc1c99c5745bccf3$export$2f872c0f2117be69 = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $cc1c99c5745bccf3$var$initialN;
    let bias = $cc1c99c5745bccf3$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($cc1c99c5745bccf3$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $cc1c99c5745bccf3$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        const oldi = i;
        for(let w = 1, k = $cc1c99c5745bccf3$var$base;; k += $cc1c99c5745bccf3$var$base){
            if (index >= inputLength) $cc1c99c5745bccf3$var$error('invalid-input');
            const digit = $cc1c99c5745bccf3$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $cc1c99c5745bccf3$var$base) $cc1c99c5745bccf3$var$error('invalid-input');
            if (digit > $cc1c99c5745bccf3$var$floor(($cc1c99c5745bccf3$var$maxInt - i) / w)) $cc1c99c5745bccf3$var$error('overflow');
            i += digit * w;
            const t = k <= bias ? $cc1c99c5745bccf3$var$tMin : k >= bias + $cc1c99c5745bccf3$var$tMax ? $cc1c99c5745bccf3$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $cc1c99c5745bccf3$var$base - t;
            if (w > $cc1c99c5745bccf3$var$floor($cc1c99c5745bccf3$var$maxInt / baseMinusT)) $cc1c99c5745bccf3$var$error('overflow');
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $cc1c99c5745bccf3$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($cc1c99c5745bccf3$var$floor(i / out) > $cc1c99c5745bccf3$var$maxInt - n) $cc1c99c5745bccf3$var$error('overflow');
        n += $cc1c99c5745bccf3$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $cc1c99c5745bccf3$export$c564cdbbe6da493 = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $cc1c99c5745bccf3$export$c1700176c90f250f(input);
    // Cache the length.
    const inputLength = input.length;
    // Initialize the state.
    let n = $cc1c99c5745bccf3$var$initialN;
    let delta = 0;
    let bias = $cc1c99c5745bccf3$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($cc1c99c5745bccf3$var$stringFromCharCode(currentValue));
    const basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($cc1c99c5745bccf3$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $cc1c99c5745bccf3$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $cc1c99c5745bccf3$var$floor(($cc1c99c5745bccf3$var$maxInt - delta) / handledCPCountPlusOne)) $cc1c99c5745bccf3$var$error('overflow');
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $cc1c99c5745bccf3$var$maxInt) $cc1c99c5745bccf3$var$error('overflow');
            if (currentValue === n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $cc1c99c5745bccf3$var$base;; k += $cc1c99c5745bccf3$var$base){
                    const t = k <= bias ? $cc1c99c5745bccf3$var$tMin : k >= bias + $cc1c99c5745bccf3$var$tMax ? $cc1c99c5745bccf3$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $cc1c99c5745bccf3$var$base - t;
                    output.push($cc1c99c5745bccf3$var$stringFromCharCode($cc1c99c5745bccf3$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $cc1c99c5745bccf3$var$floor(qMinusT / baseMinusT);
                }
                output.push($cc1c99c5745bccf3$var$stringFromCharCode($cc1c99c5745bccf3$var$digitToBasic(q, 0)));
                bias = $cc1c99c5745bccf3$var$adapt(delta, handledCPCountPlusOne, handledCPCount === basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join('');
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $cc1c99c5745bccf3$export$110c810e8727e62b = function(input) {
    return $cc1c99c5745bccf3$var$mapDomain(input, function(string) {
        return $cc1c99c5745bccf3$var$regexPunycode.test(string) ? $cc1c99c5745bccf3$export$2f872c0f2117be69(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $cc1c99c5745bccf3$export$69111c4ea6e0c4a0 = function(input) {
    return $cc1c99c5745bccf3$var$mapDomain(input, function(string) {
        return $cc1c99c5745bccf3$var$regexNonASCII.test(string) ? 'xn--' + $cc1c99c5745bccf3$export$c564cdbbe6da493(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $cc1c99c5745bccf3$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ 'version': '2.3.1',
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ 'ucs2': {
        'decode': $cc1c99c5745bccf3$export$c1700176c90f250f,
        'encode': $cc1c99c5745bccf3$export$f999239d9b149395
    },
    'decode': $cc1c99c5745bccf3$export$2f872c0f2117be69,
    'encode': $cc1c99c5745bccf3$export$c564cdbbe6da493,
    'toASCII': $cc1c99c5745bccf3$export$69111c4ea6e0c4a0,
    'toUnicode': $cc1c99c5745bccf3$export$110c810e8727e62b
};
var $cc1c99c5745bccf3$export$2e2bcd8739ae039 = $cc1c99c5745bccf3$var$punycode;

});

parcelRegister("3haLu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fe4a7f778f0f36e$export$2e2bcd8739ae039);
// markdown-it default options
var $3fe4a7f778f0f36e$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 100
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("acdgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8eecf2af6991231$export$2e2bcd8739ae039);
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
var $d8eecf2af6991231$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: false,
        // Use '/' to close single tags (<br />)
        xhtmlOut: false,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("7GnFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b06235d334be6c3f$export$2e2bcd8739ae039);
// Commonmark default options
var $b06235d334be6c3f$export$2e2bcd8739ae039 = {
    options: {
        // Enable HTML tags in source
        html: true,
        // Use '/' to close single tags (<br />)
        xhtmlOut: true,
        // Convert '\n' in paragraphs into <br>
        breaks: false,
        // CSS language prefix for fenced blocks
        langPrefix: 'language-',
        // autoconvert URL-like texts to links
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        // Internal protection, recursion limit
        maxNesting: 20
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});




parcelRegister("98nnt", function(module, exports) {

$parcel$export(module.exports, "render", () => $6a66feba3e0a1bb6$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $6a66feba3e0a1bb6$var$_hoisted_1 = {
    ref: "graphRef",
    class: "graph-canvas"
};
const $6a66feba3e0a1bb6$var$_hoisted_2 = {
    class: "graph-controls"
};
const $6a66feba3e0a1bb6$var$_hoisted_3 = {
    key: 0,
    class: "d-flex ga-1 mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_4 = {
    class: "d-flex gap-1 mt-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_5 = {
    key: 3,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_6 = {
    key: 4,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_7 = {
    key: 5,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_8 = {
    key: 6,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_9 = {
    key: 7,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_10 = {
    key: 8,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_11 = {
    key: 9,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_12 = {
    key: 10,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_13 = {
    key: 11,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_14 = {
    key: 12,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_15 = {
    key: 13,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_16 = {
    key: 14,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_17 = {
    key: 15,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_18 = {
    key: 16,
    class: "mb-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_19 = {
    class: "d-flex ga-1"
};
const $6a66feba3e0a1bb6$var$_hoisted_20 = {
    class: "data-controls"
};
const $6a66feba3e0a1bb6$var$_hoisted_21 = {
    class: "d-flex flex-column ga-2"
};
const $6a66feba3e0a1bb6$var$_hoisted_22 = {
    class: "status-bar"
};
const $6a66feba3e0a1bb6$var$_hoisted_23 = {
    class: "mb-4"
};
const $6a66feba3e0a1bb6$var$_hoisted_24 = {
    key: 0
};
const $6a66feba3e0a1bb6$var$_hoisted_25 = {
    class: "relay-info"
};
const $6a66feba3e0a1bb6$var$_hoisted_26 = {
    class: "relay-url"
};
const $6a66feba3e0a1bb6$var$_hoisted_27 = {
    class: "relay-details"
};
const $6a66feba3e0a1bb6$var$_hoisted_28 = {
    key: 0
};
const $6a66feba3e0a1bb6$var$_hoisted_29 = {
    key: 1
};
const $6a66feba3e0a1bb6$var$_hoisted_30 = {
    key: 0,
    class: "relay-error"
};
const $6a66feba3e0a1bb6$var$_hoisted_31 = {
    class: "relay-actions"
};
function $6a66feba3e0a1bb6$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_btn = (0, $TusQn.resolveComponent)("v-btn");
    const _component_v_text_field = (0, $TusQn.resolveComponent)("v-text-field");
    const _component_v_icon = (0, $TusQn.resolveComponent)("v-icon");
    const _component_v_chip = (0, $TusQn.resolveComponent)("v-chip");
    const _component_v_divider = (0, $TusQn.resolveComponent)("v-divider");
    const _component_v_select = (0, $TusQn.resolveComponent)("v-select");
    const _component_v_slider = (0, $TusQn.resolveComponent)("v-slider");
    const _component_v_switch = (0, $TusQn.resolveComponent)("v-switch");
    const _component_v_card = (0, $TusQn.resolveComponent)("v-card");
    const _component_v_tooltip = (0, $TusQn.resolveComponent)("v-tooltip");
    const _component_v_snackbar = (0, $TusQn.resolveComponent)("v-snackbar");
    const _component_v_list_subheader = (0, $TusQn.resolveComponent)("v-list-subheader");
    const _component_v_list_item_title = (0, $TusQn.resolveComponent)("v-list-item-title");
    const _component_v_list_item = (0, $TusQn.resolveComponent)("v-list-item");
    const _component_v_list = (0, $TusQn.resolveComponent)("v-list");
    const _component_v_menu = (0, $TusQn.resolveComponent)("v-menu");
    const _component_v_card_title = (0, $TusQn.resolveComponent)("v-card-title");
    const _component_v_alert = (0, $TusQn.resolveComponent)("v-alert");
    const _component_v_card_text = (0, $TusQn.resolveComponent)("v-card-text");
    const _component_v_spacer = (0, $TusQn.resolveComponent)("v-spacer");
    const _component_v_card_actions = (0, $TusQn.resolveComponent)("v-card-actions");
    const _component_v_dialog = (0, $TusQn.resolveComponent)("v-dialog");
    const _component_v_container = (0, $TusQn.resolveComponent)("v-container");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_container, {
        fluid: "",
        class: "graph-container pa-0"
    }, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_1, null, 512),
                (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_2, [
                    (0, $TusQn.createVNode)(_component_v_card, {
                        class: "pa-2",
                        style: {
                            "min-width": "280px",
                            "max-height": "90vh",
                            "overflow-y": "auto"
                        }
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_v_text_field, {
                                    modelValue: $setup.searchQuery,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event)=>$setup.searchQuery = $event),
                                    label: "Search events...",
                                    placeholder: "Content, tags, authors...",
                                    density: "compact",
                                    "hide-details": "",
                                    "prepend-inner-icon": "mdi-magnify",
                                    clearable: "",
                                    onKeyup: (0, $eeJ70.withKeys)($setup.performSearch, [
                                        "enter"
                                    ]),
                                    "onClick:clear": $setup.clearSearch,
                                    class: "mb-2"
                                }, {
                                    append: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createVNode)(_component_v_btn, {
                                                size: "x-small",
                                                icon: "mdi-magnify",
                                                variant: "tonal",
                                                color: "primary",
                                                onClick: $setup.performSearch,
                                                loading: $setup.isSearching
                                            }, null, 8, [
                                                "loading"
                                            ])
                                        ]),
                                    _: 1
                                }, 8, [
                                    "modelValue"
                                ]),
                                $setup.searchQuery ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_3, [
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        size: "x-small",
                                        variant: "tonal",
                                        "prepend-icon": "mdi-web",
                                        onClick: $setup.searchNostrRelays,
                                        loading: $setup.isSearching,
                                        style: {
                                            "flex": "1"
                                        }
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                ..._cache[99] || (_cache[99] = [
                                                    (0, $TusQn.createTextVNode)(" Search Nostr ", -1)
                                                ])
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "loading"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        size: "x-small",
                                        variant: "tonal",
                                        "prepend-icon": $setup.searchMode === 'AND' ? 'mdi-set-center' : 'mdi-set-all',
                                        onClick: $setup.toggleSearchMode,
                                        title: $setup.searchMode + ' mode'
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($setup.searchMode), 1)
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "prepend-icon",
                                        "title"
                                    ])
                                ])) : (0, $TusQn.createCommentVNode)("", true),
                                $setup.searchActive ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_chip, {
                                    key: 1,
                                    size: "small",
                                    variant: "flat",
                                    color: "primary",
                                    closable: "",
                                    "onClick:close": $setup.clearSearch,
                                    class: "mb-2"
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createVNode)(_component_v_icon, {
                                                start: ""
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        ..._cache[100] || (_cache[100] = [
                                                            (0, $TusQn.createTextVNode)("mdi-filter-check", -1)
                                                        ])
                                                    ]),
                                                _: 1
                                            }),
                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($setup.searchResults.size) + " matches ", 1)
                                        ]),
                                    _: 1
                                })) : (0, $TusQn.createCommentVNode)("", true),
                                $setup.searchQuery || $setup.searchActive ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_divider, {
                                    key: 2,
                                    class: "mb-2"
                                })) : (0, $TusQn.createCommentVNode)("", true),
                                (0, $TusQn.createVNode)(_component_v_select, {
                                    modelValue: $setup.layoutMode,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event)=>$setup.layoutMode = $event),
                                    items: $setup.layoutOptions,
                                    "item-title": "label",
                                    "item-value": "value",
                                    label: "Layout",
                                    density: "compact",
                                    "hide-details": ""
                                }, null, 8, [
                                    "modelValue",
                                    "items"
                                ]),
                                (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_4, [
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        onClick: $setup.clearFilters,
                                        size: "small",
                                        variant: "tonal",
                                        color: "primary",
                                        "prepend-icon": "mdi-filter-off",
                                        block: ""
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                ..._cache[101] || (_cache[101] = [
                                                    (0, $TusQn.createTextVNode)(" Clear Filters ", -1)
                                                ])
                                            ]),
                                        _: 1
                                    }),
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        onClick: $setup.resetHighlights,
                                        size: "small",
                                        variant: "tonal",
                                        color: "secondary",
                                        "prepend-icon": "mdi-format-color-highlight-off",
                                        block: ""
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                ..._cache[102] || (_cache[102] = [
                                                    (0, $TusQn.createTextVNode)(" Reset Style ", -1)
                                                ])
                                            ]),
                                        _: 1
                                    })
                                ]),
                                (0, $TusQn.createVNode)(_component_v_divider, {
                                    class: "my-2"
                                }),
                                _cache[129] || (_cache[129] = (0, $TusQn.createElementVNode)("div", {
                                    class: "text-caption text-medium-emphasis mb-1"
                                }, "Layout Settings", -1)),
                                $setup.layoutMode === 'd3-force' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_5, [
                                    _cache[103] || (_cache[103] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Link Force", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.linkDistance,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.layoutSettings.d3Force.linkDistance = $event),
                                        min: 10,
                                        max: 500,
                                        label: "Distance",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.linkStrength,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event)=>$setup.layoutSettings.d3Force.linkStrength = $event),
                                        min: 0,
                                        max: 2,
                                        step: 0.1,
                                        label: "Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.linkIterations,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event)=>$setup.layoutSettings.d3Force.linkIterations = $event),
                                        min: 1,
                                        max: 10,
                                        label: "Iterations",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[104] || (_cache[104] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, " Many-Body Force (Repulsion) ", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.manyBodyStrength,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event)=>$setup.layoutSettings.d3Force.manyBodyStrength = $event),
                                        min: -2000,
                                        max: 100,
                                        label: "Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.manyBodyTheta,
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.layoutSettings.d3Force.manyBodyTheta = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.1,
                                        label: "Theta (Accuracy)",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.manyBodyDistanceMin,
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event)=>$setup.layoutSettings.d3Force.manyBodyDistanceMin = $event),
                                        min: 1,
                                        max: 100,
                                        label: "Min Distance",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.manyBodyDistanceMax,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event)=>$setup.layoutSettings.d3Force.manyBodyDistanceMax = $event),
                                        min: 100,
                                        max: 2000,
                                        label: "Max Distance",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[105] || (_cache[105] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Center Force", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.centerX,
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event)=>$setup.layoutSettings.d3Force.centerX = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center X",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.centerY,
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.layoutSettings.d3Force.centerY = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center Y",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.centerStrength,
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event)=>$setup.layoutSettings.d3Force.centerStrength = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.05,
                                        label: "Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[106] || (_cache[106] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Collision Force", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.collideRadius,
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event)=>$setup.layoutSettings.d3Force.collideRadius = $event),
                                        min: 5,
                                        max: 100,
                                        label: "Radius",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.collideStrength,
                                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event)=>$setup.layoutSettings.d3Force.collideStrength = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.1,
                                        label: "Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.collideIterations,
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event)=>$setup.layoutSettings.d3Force.collideIterations = $event),
                                        min: 1,
                                        max: 10,
                                        label: "Iterations",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[107] || (_cache[107] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, " ForceX (Horizontal Positioning) ", -1)),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.d3Force.forceXEnabled,
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event)=>$setup.layoutSettings.d3Force.forceXEnabled = $event),
                                        label: "Enable ForceX",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.forceXX,
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event)=>$setup.layoutSettings.d3Force.forceXX = $event),
                                        min: -500,
                                        max: 500,
                                        label: "X Position",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: !$setup.layoutSettings.d3Force.forceXEnabled,
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.forceXStrength,
                                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event)=>$setup.layoutSettings.d3Force.forceXStrength = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.05,
                                        label: "Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: !$setup.layoutSettings.d3Force.forceXEnabled,
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    _cache[108] || (_cache[108] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, " ForceY (Vertical Positioning) ", -1)),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.d3Force.forceYEnabled,
                                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event)=>$setup.layoutSettings.d3Force.forceYEnabled = $event),
                                        label: "Enable ForceY",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.forceYY,
                                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event)=>$setup.layoutSettings.d3Force.forceYY = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Y Position",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: !$setup.layoutSettings.d3Force.forceYEnabled,
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.forceYStrength,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event)=>$setup.layoutSettings.d3Force.forceYStrength = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.05,
                                        label: "Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: !$setup.layoutSettings.d3Force.forceYEnabled,
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    _cache[109] || (_cache[109] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Radial Force", -1)),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.d3Force.radialEnabled,
                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event)=>$setup.layoutSettings.d3Force.radialEnabled = $event),
                                        label: "Enable Radial",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.radialX,
                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event)=>$setup.layoutSettings.d3Force.radialX = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center X",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: !$setup.layoutSettings.d3Force.radialEnabled,
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.radialY,
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event)=>$setup.layoutSettings.d3Force.radialY = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center Y",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: !$setup.layoutSettings.d3Force.radialEnabled,
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.radialRadius,
                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event)=>$setup.layoutSettings.d3Force.radialRadius = $event),
                                        min: 50,
                                        max: 500,
                                        label: "Radius",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: !$setup.layoutSettings.d3Force.radialEnabled,
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.radialStrength,
                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event)=>$setup.layoutSettings.d3Force.radialStrength = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.05,
                                        label: "Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: !$setup.layoutSettings.d3Force.radialEnabled,
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    _cache[110] || (_cache[110] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Iteration Control", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.alpha,
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event)=>$setup.layoutSettings.d3Force.alpha = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.1,
                                        label: "Alpha (Energy)",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.alphaMin,
                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event)=>$setup.layoutSettings.d3Force.alphaMin = $event),
                                        min: 0,
                                        max: 0.1,
                                        step: 0.001,
                                        label: "Min Alpha",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.alphaDecay,
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event)=>$setup.layoutSettings.d3Force.alphaDecay = $event),
                                        min: 0,
                                        max: 0.1,
                                        step: 0.001,
                                        label: "Alpha Decay",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.alphaTarget,
                                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event)=>$setup.layoutSettings.d3Force.alphaTarget = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.01,
                                        label: "Alpha Target",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.d3Force.velocityDecay,
                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event)=>$setup.layoutSettings.d3Force.velocityDecay = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.05,
                                        label: "Velocity Decay",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'force' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_6, [
                                    _cache[111] || (_cache[111] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Center Position", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.centerX,
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event)=>$setup.layoutSettings.force.centerX = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center X",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.centerY,
                                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event)=>$setup.layoutSettings.force.centerY = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center Y",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[112] || (_cache[112] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Link/Edge Properties", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.linkDistance,
                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event)=>$setup.layoutSettings.force.linkDistance = $event),
                                        min: 10,
                                        max: 500,
                                        label: "Link Distance",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.edgeStrength,
                                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event)=>$setup.layoutSettings.force.edgeStrength = $event),
                                        min: 0,
                                        max: 2,
                                        step: 0.1,
                                        label: "Edge Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[113] || (_cache[113] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Node Properties", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.nodeStrength,
                                        "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event)=>$setup.layoutSettings.force.nodeStrength = $event),
                                        min: -100,
                                        max: 100,
                                        label: "Node Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.nodeSize,
                                        "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event)=>$setup.layoutSettings.force.nodeSize = $event),
                                        min: 20,
                                        max: 100,
                                        label: "Node Size",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.nodeSpacing,
                                        "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event)=>$setup.layoutSettings.force.nodeSpacing = $event),
                                        min: 10,
                                        max: 100,
                                        label: "Node Spacing",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.force.preventOverlap,
                                        "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event)=>$setup.layoutSettings.force.preventOverlap = $event),
                                        label: "Prevent Overlap",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[114] || (_cache[114] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Clustering", -1)),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.force.clustering,
                                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event)=>$setup.layoutSettings.force.clustering = $event),
                                        label: "Enable Clustering",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.clusterNodeStrength,
                                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event)=>$setup.layoutSettings.force.clusterNodeStrength = $event),
                                        min: -50,
                                        max: 100,
                                        label: "Cluster Node Strength",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: !$setup.layoutSettings.force.clustering,
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    _cache[115] || (_cache[115] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Iteration Control", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.alpha,
                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event)=>$setup.layoutSettings.force.alpha = $event),
                                        min: 0,
                                        max: 1,
                                        step: 0.05,
                                        label: "Alpha (Energy)",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.alphaDecay,
                                        "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event)=>$setup.layoutSettings.force.alphaDecay = $event),
                                        min: 0,
                                        max: 0.1,
                                        step: 0.001,
                                        label: "Alpha Decay",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.force.alphaMin,
                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event)=>$setup.layoutSettings.force.alphaMin = $event),
                                        min: 0,
                                        max: 0.1,
                                        step: 0.001,
                                        label: "Min Alpha",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'circular' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_7, [
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.circular.radius,
                                        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event)=>$setup.layoutSettings.circular.radius = $event),
                                        min: 200,
                                        max: 1000,
                                        label: "Radius",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.circular.startRadius,
                                        "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event)=>$setup.layoutSettings.circular.startRadius = $event),
                                        min: 100,
                                        max: 500,
                                        label: "Start Radius (Spiral)",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.circular.endRadius,
                                        "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event)=>$setup.layoutSettings.circular.endRadius = $event),
                                        min: 400,
                                        max: 1200,
                                        label: "End Radius (Spiral)",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.circular.divisions,
                                        "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event)=>$setup.layoutSettings.circular.divisions = $event),
                                        min: 1,
                                        max: 10,
                                        label: "Divisions",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.circular.angleRatio,
                                        "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event)=>$setup.layoutSettings.circular.angleRatio = $event),
                                        min: 0.1,
                                        max: 2,
                                        step: 0.1,
                                        label: "Angle Ratio",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.circular.startAngle,
                                        "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event)=>$setup.layoutSettings.circular.startAngle = $event),
                                        min: 0,
                                        max: 6.28,
                                        step: 0.1,
                                        label: "Start Angle",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.circular.endAngle,
                                        "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event)=>$setup.layoutSettings.circular.endAngle = $event),
                                        min: 0,
                                        max: 6.28,
                                        step: 0.1,
                                        label: "End Angle",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.circular.nodeSize,
                                        "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event)=>$setup.layoutSettings.circular.nodeSize = $event),
                                        min: 20,
                                        max: 120,
                                        label: "Node Size",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.circular.nodeSpacing,
                                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event)=>$setup.layoutSettings.circular.nodeSpacing = $event),
                                        min: 5,
                                        max: 50,
                                        label: "Node Spacing",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_select, {
                                        modelValue: $setup.layoutSettings.circular.ordering,
                                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event)=>$setup.layoutSettings.circular.ordering = $event),
                                        items: [
                                            'topology',
                                            'topology-directed',
                                            'degree',
                                            null
                                        ],
                                        label: "Ordering",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.circular.clockwise,
                                        "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event)=>$setup.layoutSettings.circular.clockwise = $event),
                                        label: "Clockwise",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'compact-box' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_8, [
                                    (0, $TusQn.createVNode)(_component_v_select, {
                                        modelValue: $setup.layoutSettings.compactBox.direction,
                                        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event)=>$setup.layoutSettings.compactBox.direction = $event),
                                        items: [
                                            'LR',
                                            'RL',
                                            'TB',
                                            'BT',
                                            'H',
                                            'V'
                                        ],
                                        label: "Direction",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.compactBox.nodeWidth,
                                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event)=>$setup.layoutSettings.compactBox.nodeWidth = $event),
                                        min: 20,
                                        max: 100,
                                        label: "Node Width",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.compactBox.nodeHeight,
                                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event)=>$setup.layoutSettings.compactBox.nodeHeight = $event),
                                        min: 20,
                                        max: 100,
                                        label: "Node Height",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.compactBox.hGap,
                                        "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event)=>$setup.layoutSettings.compactBox.hGap = $event),
                                        min: 50,
                                        max: 200,
                                        label: "Horizontal Gap",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.compactBox.vGap,
                                        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event)=>$setup.layoutSettings.compactBox.vGap = $event),
                                        min: 50,
                                        max: 200,
                                        label: "Vertical Gap",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'dagre' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_9, [
                                    (0, $TusQn.createVNode)(_component_v_select, {
                                        modelValue: $setup.layoutSettings.dagre.rankdir,
                                        "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event)=>$setup.layoutSettings.dagre.rankdir = $event),
                                        items: [
                                            'TB',
                                            'BT',
                                            'LR',
                                            'RL'
                                        ],
                                        label: "Direction",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.dagre.nodesep,
                                        "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event)=>$setup.layoutSettings.dagre.nodesep = $event),
                                        min: 20,
                                        max: 200,
                                        label: "Node Separation",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.dagre.ranksep,
                                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event)=>$setup.layoutSettings.dagre.ranksep = $event),
                                        min: 50,
                                        max: 300,
                                        label: "Rank Separation",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'concentric' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_10, [
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.concentric.minNodeSpacing,
                                        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event)=>$setup.layoutSettings.concentric.minNodeSpacing = $event),
                                        min: 10,
                                        max: 100,
                                        label: "Min Node Spacing",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.concentric.preventOverlap,
                                        "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event)=>$setup.layoutSettings.concentric.preventOverlap = $event),
                                        label: "Prevent Overlap",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'grid' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_11, [
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.grid.rows,
                                        "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event)=>$setup.layoutSettings.grid.rows = $event),
                                        min: 1,
                                        max: 20,
                                        label: "Rows",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.grid.cols,
                                        "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event)=>$setup.layoutSettings.grid.cols = $event),
                                        min: 1,
                                        max: 20,
                                        label: "Columns",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.grid.preventOverlap,
                                        "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event)=>$setup.layoutSettings.grid.preventOverlap = $event),
                                        label: "Prevent Overlap",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'radial' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_12, [
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.radial.unitRadius,
                                        "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event)=>$setup.layoutSettings.radial.unitRadius = $event),
                                        min: 50,
                                        max: 200,
                                        label: "Unit Radius",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.radial.preventOverlap,
                                        "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event)=>$setup.layoutSettings.radial.preventOverlap = $event),
                                        label: "Prevent Overlap",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'dendrogram' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_13, [
                                    _cache[116] || (_cache[116] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Layout Type", -1)),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.dendrogram.radial,
                                        "onUpdate:modelValue": _cache[70] || (_cache[70] = ($event)=>$setup.layoutSettings.dendrogram.radial = $event),
                                        label: "Radial Mode",
                                        color: "primary",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[117] || (_cache[117] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Direction", -1)),
                                    (0, $TusQn.createVNode)(_component_v_select, {
                                        modelValue: $setup.layoutSettings.dendrogram.direction,
                                        "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event)=>$setup.layoutSettings.dendrogram.direction = $event),
                                        items: [
                                            'LR',
                                            'RL',
                                            'TB',
                                            'BT',
                                            'H',
                                            'V'
                                        ],
                                        label: "Direction",
                                        density: "compact",
                                        "hide-details": "",
                                        disabled: $setup.layoutSettings.dendrogram.radial,
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ]),
                                    _cache[118] || (_cache[118] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Spacing", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.dendrogram.nodeSep,
                                        "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event)=>$setup.layoutSettings.dendrogram.nodeSep = $event),
                                        min: 10,
                                        max: 200,
                                        label: "Node Separation",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.dendrogram.rankSep,
                                        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event)=>$setup.layoutSettings.dendrogram.rankSep = $event),
                                        min: 50,
                                        max: 400,
                                        label: "Rank Separation",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'mindmap' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_14, [
                                    _cache[119] || (_cache[119] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Direction", -1)),
                                    (0, $TusQn.createVNode)(_component_v_select, {
                                        modelValue: $setup.layoutSettings.mindmap.direction,
                                        "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event)=>$setup.layoutSettings.mindmap.direction = $event),
                                        items: [
                                            {
                                                title: 'Horizontal (H)',
                                                value: 'H'
                                            },
                                            {
                                                title: 'Vertical (V)',
                                                value: 'V'
                                            },
                                            {
                                                title: 'Left to Right (LR)',
                                                value: 'LR'
                                            },
                                            {
                                                title: 'Right to Left (RL)',
                                                value: 'RL'
                                            },
                                            {
                                                title: 'Top to Bottom (TB)',
                                                value: 'TB'
                                            },
                                            {
                                                title: 'Bottom to Top (BT)',
                                                value: 'BT'
                                            }
                                        ],
                                        label: "Direction",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[120] || (_cache[120] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Spacing", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.mindmap.hGap,
                                        "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event)=>$setup.layoutSettings.mindmap.hGap = $event),
                                        min: 10,
                                        max: 200,
                                        label: "Horizontal Gap",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.mindmap.vGap,
                                        "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event)=>$setup.layoutSettings.mindmap.vGap = $event),
                                        min: 10,
                                        max: 200,
                                        label: "Vertical Gap",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[121] || (_cache[121] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Node Size", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.mindmap.getHeight,
                                        "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event)=>$setup.layoutSettings.mindmap.getHeight = $event),
                                        min: 20,
                                        max: 100,
                                        label: "Node Height",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.mindmap.getWidth,
                                        "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event)=>$setup.layoutSettings.mindmap.getWidth = $event),
                                        min: 50,
                                        max: 300,
                                        label: "Node Width",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'fruchterman' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_15, [
                                    _cache[122] || (_cache[122] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Center Position", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.fruchterman.centerX,
                                        "onUpdate:modelValue": _cache[79] || (_cache[79] = ($event)=>$setup.layoutSettings.fruchterman.centerX = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center X",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.fruchterman.centerY,
                                        "onUpdate:modelValue": _cache[80] || (_cache[80] = ($event)=>$setup.layoutSettings.fruchterman.centerY = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center Y",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[123] || (_cache[123] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Physics Parameters", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.fruchterman.maxIteration,
                                        "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event)=>$setup.layoutSettings.fruchterman.maxIteration = $event),
                                        min: 100,
                                        max: 5000,
                                        step: 100,
                                        label: "Max Iterations",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.fruchterman.gravity,
                                        "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event)=>$setup.layoutSettings.fruchterman.gravity = $event),
                                        min: 1,
                                        max: 50,
                                        label: "Gravity",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.fruchterman.speed,
                                        "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event)=>$setup.layoutSettings.fruchterman.speed = $event),
                                        min: 1,
                                        max: 20,
                                        label: "Speed",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[124] || (_cache[124] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Clustering", -1)),
                                    (0, $TusQn.createVNode)(_component_v_switch, {
                                        modelValue: $setup.layoutSettings.fruchterman.clustering,
                                        "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event)=>$setup.layoutSettings.fruchterman.clustering = $event),
                                        label: "Enable Clustering",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.fruchterman.clusterGravity,
                                        "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event)=>$setup.layoutSettings.fruchterman.clusterGravity = $event),
                                        min: 1,
                                        max: 50,
                                        label: "Cluster Gravity",
                                        disabled: !$setup.layoutSettings.fruchterman.clustering,
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue",
                                        "disabled"
                                    ])
                                ])) : $setup.layoutMode === 'mds' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_16, [
                                    _cache[125] || (_cache[125] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "MDS Layout Settings", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.mds.linkDistance,
                                        "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event)=>$setup.layoutSettings.mds.linkDistance = $event),
                                        min: 50,
                                        max: 5000,
                                        step: 10,
                                        label: "Link Distance",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.mds.center.x,
                                        "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event)=>$setup.layoutSettings.mds.center.x = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center X",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.mds.center.y,
                                        "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event)=>$setup.layoutSettings.mds.center.y = $event),
                                        min: -500,
                                        max: 500,
                                        label: "Center Y",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : $setup.layoutMode === 'fishbone' ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_17, [
                                    _cache[126] || (_cache[126] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Direction", -1)),
                                    (0, $TusQn.createVNode)(_component_v_select, {
                                        modelValue: $setup.layoutSettings.fishbone.direction,
                                        "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event)=>$setup.layoutSettings.fishbone.direction = $event),
                                        items: [
                                            {
                                                title: 'Horizontal (H)',
                                                value: 'H'
                                            },
                                            {
                                                title: 'Vertical (V)',
                                                value: 'V'
                                            },
                                            {
                                                title: 'Left to Right (LR)',
                                                value: 'LR'
                                            },
                                            {
                                                title: 'Right to Left (RL)',
                                                value: 'RL'
                                            },
                                            {
                                                title: 'Top to Bottom (TB)',
                                                value: 'TB'
                                            },
                                            {
                                                title: 'Bottom to Top (BT)',
                                                value: 'BT'
                                            }
                                        ],
                                        label: "Direction",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-2"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    _cache[127] || (_cache[127] = (0, $TusQn.createElementVNode)("div", {
                                        class: "text-caption text-medium-emphasis mb-1"
                                    }, "Spacing", -1)),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.fishbone.hGap,
                                        "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event)=>$setup.layoutSettings.fishbone.hGap = $event),
                                        min: 10,
                                        max: 200,
                                        label: "Horizontal Gap",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": "",
                                        class: "mb-1"
                                    }, null, 8, [
                                        "modelValue"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_slider, {
                                        modelValue: $setup.layoutSettings.fishbone.vGap,
                                        "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event)=>$setup.layoutSettings.fishbone.vGap = $event),
                                        min: 10,
                                        max: 200,
                                        label: "Vertical Gap",
                                        "thumb-label": "",
                                        density: "compact",
                                        "hide-details": ""
                                    }, null, 8, [
                                        "modelValue"
                                    ])
                                ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_18, [
                                    ..._cache[128] || (_cache[128] = [
                                        (0, $TusQn.createElementVNode)("p", {
                                            class: "text-caption text-medium-emphasis"
                                        }, "No settings for this layout", -1)
                                    ])
                                ])),
                                (0, $TusQn.createVNode)(_component_v_divider, {
                                    class: "my-2"
                                }),
                                (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_19, [
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        icon: "mdi-fit-to-screen",
                                        size: "small",
                                        onClick: $setup.fitView,
                                        title: "Fit to screen"
                                    }),
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        icon: $setup.isAnimating ? 'mdi-pause' : 'mdi-play',
                                        size: "small",
                                        onClick: $setup.toggleAnimation,
                                        title: $setup.isAnimating ? 'Stop animation' : 'Resume animation'
                                    }, null, 8, [
                                        "icon",
                                        "title"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        icon: "mdi-refresh",
                                        size: "small",
                                        onClick: $setup.refreshGraph,
                                        title: "Refresh"
                                    })
                                ])
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_20, [
                    (0, $TusQn.createVNode)(_component_v_card, {
                        class: "pa-2"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_21, [
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        size: "small",
                                        color: "primary",
                                        "prepend-icon": "mdi-download",
                                        loading: $setup.isFetching,
                                        onClick: $setup.fetchGlobal
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                ..._cache[130] || (_cache[130] = [
                                                    (0, $TusQn.createTextVNode)(" Fetch Global ", -1)
                                                ])
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "loading"
                                    ]),
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        size: "small",
                                        "prepend-icon": "mdi-database",
                                        onClick: $setup.loadFromDb
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                ..._cache[131] || (_cache[131] = [
                                                    (0, $TusQn.createTextVNode)(" Load from DB ", -1)
                                                ])
                                            ]),
                                        _: 1
                                    }),
                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                        size: "small",
                                        "prepend-icon": "mdi-delete",
                                        onClick: $setup.clearAll
                                    }, {
                                        default: (0, $TusQn.withCtx)(()=>[
                                                ..._cache[132] || (_cache[132] = [
                                                    (0, $TusQn.createTextVNode)(" Clear ", -1)
                                                ])
                                            ]),
                                        _: 1
                                    }),
                                    (0, $TusQn.createVNode)(_component_v_divider, {
                                        class: "my-1"
                                    }),
                                    (0, $TusQn.createVNode)(_component_v_tooltip, {
                                        text: `${$setup.relayManager.stats.value.enabled} enabled, ${$setup.relayManager.stats.value.connected} connected`,
                                        location: "end"
                                    }, {
                                        activator: (0, $TusQn.withCtx)(({ props: props })=>[
                                                (0, $TusQn.createVNode)(_component_v_chip, (0, $TusQn.mergeProps)(props, {
                                                    size: "small",
                                                    variant: "tonal",
                                                    "prepend-icon": "mdi-server-network",
                                                    color: $setup.relayManager.stats.value.connected > 0 ? 'success' : 'error',
                                                    onClick: _cache[92] || (_cache[92] = ($event)=>$setup.relayDialog.show = true),
                                                    style: {
                                                        "cursor": "pointer"
                                                    }
                                                }), {
                                                    default: (0, $TusQn.withCtx)(()=>[
                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($setup.relayManager.stats.value.total) + " Relays ", 1)
                                                        ]),
                                                    _: 1
                                                }, 16, [
                                                    "color"
                                                ])
                                            ]),
                                        _: 1
                                    }, 8, [
                                        "text"
                                    ])
                                ])
                            ]),
                        _: 1
                    })
                ]),
                (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_22, [
                    (0, $TusQn.createVNode)(_component_v_chip, {
                        size: "small",
                        variant: "flat"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_v_icon, {
                                    start: ""
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            ..._cache[133] || (_cache[133] = [
                                                (0, $TusQn.createTextVNode)("mdi-chart-bubble", -1)
                                            ])
                                        ]),
                                    _: 1
                                }),
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($setup.nodeCount) + " nodes ", 1)
                            ]),
                        _: 1
                    }),
                    (0, $TusQn.createVNode)(_component_v_chip, {
                        size: "small",
                        variant: "flat",
                        class: "ml-2"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_v_icon, {
                                    start: ""
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            ..._cache[134] || (_cache[134] = [
                                                (0, $TusQn.createTextVNode)("mdi-connection", -1)
                                            ])
                                        ]),
                                    _: 1
                                }),
                                (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($setup.edgeCount) + " edges ", 1)
                            ]),
                        _: 1
                    }),
                    $setup.isFetching ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_chip, {
                        key: 0,
                        size: "small",
                        variant: "flat",
                        color: "primary",
                        class: "ml-2"
                    }, {
                        default: (0, $TusQn.withCtx)(()=>[
                                (0, $TusQn.createVNode)(_component_v_icon, {
                                    start: ""
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            ..._cache[135] || (_cache[135] = [
                                                (0, $TusQn.createTextVNode)("mdi-loading mdi-spin", -1)
                                            ])
                                        ]),
                                    _: 1
                                }),
                                _cache[136] || (_cache[136] = (0, $TusQn.createTextVNode)(" Fetching... ", -1))
                            ]),
                        _: 1
                    })) : (0, $TusQn.createCommentVNode)("", true)
                ]),
                (0, $TusQn.createVNode)(_component_v_snackbar, {
                    modelValue: $setup.snackbar.show,
                    "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event)=>$setup.snackbar.show = $event),
                    color: $setup.snackbar.color,
                    timeout: $setup.snackbar.timeout,
                    location: "top"
                }, {
                    actions: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_v_btn, {
                                variant: "text",
                                onClick: _cache[93] || (_cache[93] = ($event)=>$setup.snackbar.show = false)
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        ..._cache[137] || (_cache[137] = [
                                            (0, $TusQn.createTextVNode)("Close", -1)
                                        ])
                                    ]),
                                _: 1
                            })
                        ]),
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($setup.snackbar.message) + " ", 1)
                        ]),
                    _: 1
                }, 8, [
                    "modelValue",
                    "color",
                    "timeout"
                ]),
                (0, $TusQn.createVNode)(_component_v_menu, {
                    modelValue: $setup.contextMenu.show,
                    "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event)=>$setup.contextMenu.show = $event),
                    location: 'bottom',
                    style: (0, $8POXm.normalizeStyle)({
                        position: 'fixed',
                        left: $setup.contextMenu.x + 'px',
                        top: $setup.contextMenu.y + 'px'
                    })
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_v_list, {
                                density: "compact",
                                "min-width": "200"
                            }, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createVNode)(_component_v_list_subheader, null, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($setup.contextMenu.title), 1)
                                                ]),
                                            _: 1
                                        }),
                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.contextMenu.actions, (action)=>{
                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_list_item, {
                                                key: action.label,
                                                onClick: action.handler,
                                                "prepend-icon": action.icon
                                            }, {
                                                default: (0, $TusQn.withCtx)(()=>[
                                                        (0, $TusQn.createVNode)(_component_v_list_item_title, null, {
                                                            default: (0, $TusQn.withCtx)(()=>[
                                                                    (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(action.label), 1)
                                                                ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]),
                                                _: 2
                                            }, 1032, [
                                                "onClick",
                                                "prepend-icon"
                                            ]);
                                        }), 128))
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                }, 8, [
                    "modelValue",
                    "style"
                ]),
                (0, $TusQn.createVNode)(_component_v_dialog, {
                    modelValue: $setup.relayDialog.show,
                    "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event)=>$setup.relayDialog.show = $event),
                    "max-width": "700"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_v_card, null, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createVNode)(_component_v_card_title, {
                                            class: "d-flex align-center justify-space-between"
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    _cache[138] || (_cache[138] = (0, $TusQn.createElementVNode)("span", null, "Relay Manager", -1)),
                                                    (0, $TusQn.createVNode)(_component_v_chip, {
                                                        size: "small",
                                                        color: $setup.relayManager.stats.value.connected > 0 ? 'success' : 'error'
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($setup.relayManager.stats.value.connected) + "/" + (0, $8POXm.toDisplayString)($setup.relayManager.stats.value.enabled) + " Connected ", 1)
                                                            ]),
                                                        _: 1
                                                    }, 8, [
                                                        "color"
                                                    ])
                                                ]),
                                            _: 1
                                        }),
                                        (0, $TusQn.createVNode)(_component_v_divider),
                                        (0, $TusQn.createVNode)(_component_v_card_text, {
                                            style: {
                                                "max-height": "500px",
                                                "overflow-y": "auto"
                                            }
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_23, [
                                                        (0, $TusQn.createVNode)(_component_v_text_field, {
                                                            modelValue: $setup.newRelayUrl,
                                                            "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event)=>$setup.newRelayUrl = $event),
                                                            label: "Add New Relay",
                                                            placeholder: "wss://relay.example.com",
                                                            density: "compact",
                                                            "prepend-inner-icon": "mdi-plus",
                                                            "error-messages": $setup.relayManager.error.value || undefined,
                                                            onKeyup: (0, $eeJ70.withKeys)($setup.handleAddRelay, [
                                                                "enter"
                                                            ])
                                                        }, {
                                                            append: (0, $TusQn.withCtx)(()=>[
                                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                                        size: "small",
                                                                        color: "primary",
                                                                        onClick: $setup.handleAddRelay,
                                                                        loading: $setup.relayManager.loading.value
                                                                    }, {
                                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                                ..._cache[139] || (_cache[139] = [
                                                                                    (0, $TusQn.createTextVNode)(" Add ", -1)
                                                                                ])
                                                                            ]),
                                                                        _: 1
                                                                    }, 8, [
                                                                        "loading"
                                                                    ])
                                                                ]),
                                                            _: 1
                                                        }, 8, [
                                                            "modelValue",
                                                            "error-messages"
                                                        ])
                                                    ]),
                                                    $setup.relayManager.relays.value.length > 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_24, [
                                                        ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.relayManager.relays.value, (relay)=>{
                                                            return (0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", {
                                                                key: relay.url,
                                                                class: "relay-item"
                                                            }, [
                                                                (0, $TusQn.createVNode)(_component_v_icon, {
                                                                    size: "small",
                                                                    color: $setup.getRelayStatusColor(relay.status),
                                                                    icon: $setup.getRelayStatusIcon(relay.status)
                                                                }, null, 8, [
                                                                    "color",
                                                                    "icon"
                                                                ]),
                                                                (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_25, [
                                                                    (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_26, (0, $8POXm.toDisplayString)(relay.url), 1),
                                                                    (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_27, [
                                                                        relay.lastConnected ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6a66feba3e0a1bb6$var$_hoisted_28, [
                                                                            (0, $TusQn.createVNode)(_component_v_icon, {
                                                                                size: "x-small"
                                                                            }, {
                                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                                        ..._cache[140] || (_cache[140] = [
                                                                                            (0, $TusQn.createTextVNode)("mdi-clock-outline", -1)
                                                                                        ])
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)($setup.formatRelativeTime(relay.lastConnected)), 1)
                                                                        ])) : (0, $TusQn.createCommentVNode)("", true),
                                                                        relay.latency !== null ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("span", $6a66feba3e0a1bb6$var$_hoisted_29, [
                                                                            (0, $TusQn.createVNode)(_component_v_icon, {
                                                                                size: "x-small"
                                                                            }, {
                                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                                        ..._cache[141] || (_cache[141] = [
                                                                                            (0, $TusQn.createTextVNode)("mdi-speedometer", -1)
                                                                                        ])
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(relay.latency) + "ms ", 1)
                                                                        ])) : (0, $TusQn.createCommentVNode)("", true),
                                                                        (0, $TusQn.createElementVNode)("span", null, [
                                                                            (0, $TusQn.createVNode)(_component_v_icon, {
                                                                                size: "x-small"
                                                                            }, {
                                                                                default: (0, $TusQn.withCtx)(()=>[
                                                                                        ..._cache[142] || (_cache[142] = [
                                                                                            (0, $TusQn.createTextVNode)("mdi-email-multiple-outline", -1)
                                                                                        ])
                                                                                    ]),
                                                                                _: 1
                                                                            }),
                                                                            (0, $TusQn.createTextVNode)(" " + (0, $8POXm.toDisplayString)(relay.eventsReceived) + " events ", 1)
                                                                        ])
                                                                    ]),
                                                                    relay.lastError ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $6a66feba3e0a1bb6$var$_hoisted_30, (0, $8POXm.toDisplayString)(relay.lastError), 1)) : (0, $TusQn.createCommentVNode)("", true)
                                                                ]),
                                                                (0, $TusQn.createElementVNode)("div", $6a66feba3e0a1bb6$var$_hoisted_31, [
                                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                                        size: "small",
                                                                        icon: relay.enabled ? 'mdi-pause' : 'mdi-play',
                                                                        color: relay.enabled ? 'warning' : 'success',
                                                                        variant: "tonal",
                                                                        onClick: ($event)=>$setup.handleToggleRelay(relay.url)
                                                                    }, null, 8, [
                                                                        "icon",
                                                                        "color",
                                                                        "onClick"
                                                                    ]),
                                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                                        size: "small",
                                                                        icon: "mdi-delete",
                                                                        color: "error",
                                                                        variant: "tonal",
                                                                        onClick: ($event)=>$setup.handleRemoveRelay(relay.url)
                                                                    }, null, 8, [
                                                                        "onClick"
                                                                    ])
                                                                ])
                                                            ]);
                                                        }), 128))
                                                    ])) : (0, $TusQn.createCommentVNode)("", true),
                                                    $setup.relayManager.relays.value.length === 0 ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_alert, {
                                                        key: 1,
                                                        type: "info",
                                                        variant: "tonal",
                                                        class: "mt-4"
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ..._cache[143] || (_cache[143] = [
                                                                    (0, $TusQn.createTextVNode)(" No relays configured. Add your first relay above. ", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    })) : (0, $TusQn.createCommentVNode)("", true)
                                                ]),
                                            _: 1
                                        }),
                                        (0, $TusQn.createVNode)(_component_v_divider),
                                        (0, $TusQn.createVNode)(_component_v_card_actions, null, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                        "prepend-icon": "mdi-refresh",
                                                        onClick: $setup.handleTestConnections,
                                                        loading: $setup.testingConnections
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ..._cache[144] || (_cache[144] = [
                                                                    (0, $TusQn.createTextVNode)(" Test Connections ", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    }, 8, [
                                                        "loading"
                                                    ]),
                                                    (0, $TusQn.createVNode)(_component_v_spacer),
                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                        onClick: _cache[97] || (_cache[97] = ($event)=>$setup.relayDialog.show = false)
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ..._cache[145] || (_cache[145] = [
                                                                    (0, $TusQn.createTextVNode)("Close", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    })
                                                ]),
                                            _: 1
                                        })
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                }, 8, [
                    "modelValue"
                ])
            ]),
        _: 1
    });
}

});

parcelRegister("lAtD9", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb73f1c3a425da79$export$2e2bcd8739ae039);
let $fb73f1c3a425da79$var$NOOP = ()=>{};
var $fb73f1c3a425da79$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRegister("3NNX1", function(module, exports) {

$parcel$export(module.exports, "render", () => $2c4cb1eb429dee56$export$b3890eb0ae9dca99);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");
const $2c4cb1eb429dee56$var$_hoisted_1 = {
    key: 0,
    class: "d-flex align-center gap-2 mr-2"
};
const $2c4cb1eb429dee56$var$_hoisted_2 = {
    key: 1,
    class: "text-center py-8"
};
const $2c4cb1eb429dee56$var$_hoisted_3 = {
    class: "d-flex gap-1"
};
function $2c4cb1eb429dee56$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_app_bar_nav_icon = (0, $TusQn.resolveComponent)("v-app-bar-nav-icon");
    const _component_v_toolbar_title = (0, $TusQn.resolveComponent)("v-toolbar-title");
    const _component_v_spacer = (0, $TusQn.resolveComponent)("v-spacer");
    const _component_v_chip = (0, $TusQn.resolveComponent)("v-chip");
    const _component_v_text_field = (0, $TusQn.resolveComponent)("v-text-field");
    const _component_v_btn = (0, $TusQn.resolveComponent)("v-btn");
    const _component_v_tooltip = (0, $TusQn.resolveComponent)("v-tooltip");
    const _component_v_app_bar = (0, $TusQn.resolveComponent)("v-app-bar");
    const _component_v_list_item = (0, $TusQn.resolveComponent)("v-list-item");
    const _component_v_list = (0, $TusQn.resolveComponent)("v-list");
    const _component_v_navigation_drawer = (0, $TusQn.resolveComponent)("v-navigation-drawer");
    const _component_v_main = (0, $TusQn.resolveComponent)("v-main");
    const _component_v_icon = (0, $TusQn.resolveComponent)("v-icon");
    const _component_v_card_title = (0, $TusQn.resolveComponent)("v-card-title");
    const _component_v_progress_linear = (0, $TusQn.resolveComponent)("v-progress-linear");
    const _component_v_list_item_title = (0, $TusQn.resolveComponent)("v-list-item-title");
    const _component_v_list_item_subtitle = (0, $TusQn.resolveComponent)("v-list-item-subtitle");
    const _component_v_card_text = (0, $TusQn.resolveComponent)("v-card-text");
    const _component_v_card_actions = (0, $TusQn.resolveComponent)("v-card-actions");
    const _component_v_card = (0, $TusQn.resolveComponent)("v-card");
    const _component_v_dialog = (0, $TusQn.resolveComponent)("v-dialog");
    const _component_v_app = (0, $TusQn.resolveComponent)("v-app");
    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_app, null, {
        default: (0, $TusQn.withCtx)(()=>[
                (0, $TusQn.createVNode)(_component_v_app_bar, {
                    color: "primary",
                    prominent: ""
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_v_app_bar_nav_icon, {
                                variant: "text",
                                onClick: _cache[0] || (_cache[0] = (0, $eeJ70.withModifiers)(($event)=>$setup.drawer = !$setup.drawer, [
                                    "stop"
                                ]))
                            }),
                            (0, $TusQn.createVNode)(_component_v_toolbar_title, null, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        ..._cache[11] || (_cache[11] = [
                                            (0, $TusQn.createTextVNode)("Nostr Graph Explorer", -1)
                                        ])
                                    ]),
                                _: 1
                            }),
                            (0, $TusQn.createVNode)(_component_v_spacer),
                            $setup.graphViewRef ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_1, [
                                !$setup.graphViewRef.isEditingName ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_chip, {
                                    key: 0,
                                    color: "white",
                                    variant: "flat",
                                    "prepend-icon": "mdi-file-document",
                                    onClick: _cache[1] || (_cache[1] = ($event)=>$setup.graphViewRef.startRenaming()),
                                    style: {
                                        "cursor": "pointer"
                                    },
                                    title: 'Click to rename'
                                }, {
                                    default: (0, $TusQn.withCtx)(()=>[
                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)($setup.graphViewRef.currentInvestigationName), 1)
                                        ]),
                                    _: 1
                                })) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_text_field, {
                                    key: 1,
                                    modelValue: $setup.graphViewRef.currentInvestigationName,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event)=>$setup.graphViewRef.currentInvestigationName = $event),
                                    density: "compact",
                                    "hide-details": "",
                                    variant: "solo",
                                    autofocus: "",
                                    onBlur: _cache[3] || (_cache[3] = ($event)=>$setup.graphViewRef.finishRenaming()),
                                    onKeyup: _cache[4] || (_cache[4] = (0, $eeJ70.withKeys)(($event)=>$setup.graphViewRef.finishRenaming(), [
                                        "enter"
                                    ])),
                                    style: {
                                        "max-width": "300px"
                                    },
                                    "bg-color": "white"
                                }, null, 8, [
                                    "modelValue"
                                ])),
                                (0, $TusQn.createVNode)(_component_v_tooltip, {
                                    location: "bottom"
                                }, {
                                    activator: (0, $TusQn.withCtx)(({ props: props })=>[
                                            (0, $TusQn.createVNode)(_component_v_btn, (0, $TusQn.mergeProps)(props, {
                                                icon: "mdi-content-save",
                                                variant: "text",
                                                color: "white",
                                                onClick: _cache[5] || (_cache[5] = ($event)=>$setup.graphViewRef.saveCurrentInvestigation()),
                                                title: 'Save current investigation'
                                            }), null, 16)
                                        ]),
                                    default: (0, $TusQn.withCtx)(()=>[
                                            _cache[12] || (_cache[12] = (0, $TusQn.createElementVNode)("span", null, "Save Investigation", -1))
                                        ]),
                                    _: 1
                                }),
                                (0, $TusQn.createVNode)(_component_v_tooltip, {
                                    location: "bottom"
                                }, {
                                    activator: (0, $TusQn.withCtx)(({ props: props })=>[
                                            (0, $TusQn.createVNode)(_component_v_btn, (0, $TusQn.mergeProps)(props, {
                                                icon: "mdi-bookmark-multiple",
                                                variant: "text",
                                                color: "white",
                                                onClick: $setup.openSavedDialog,
                                                title: 'Manage saved investigations'
                                            }), null, 16)
                                        ]),
                                    default: (0, $TusQn.withCtx)(()=>[
                                            _cache[13] || (_cache[13] = (0, $TusQn.createElementVNode)("span", null, "Manage Saved", -1))
                                        ]),
                                    _: 1
                                })
                            ])) : (0, $TusQn.createCommentVNode)("", true)
                        ]),
                    _: 1
                }),
                (0, $TusQn.createVNode)(_component_v_navigation_drawer, {
                    modelValue: $setup.drawer,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event)=>$setup.drawer = $event),
                    temporary: ""
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_v_list, null, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createVNode)(_component_v_list_item, {
                                            "prepend-icon": "mdi-graph",
                                            title: "Graph View",
                                            value: "graph"
                                        }),
                                        (0, $TusQn.createVNode)(_component_v_list_item, {
                                            "prepend-icon": "mdi-filter",
                                            title: "Filters",
                                            value: "filters"
                                        }),
                                        (0, $TusQn.createVNode)(_component_v_list_item, {
                                            "prepend-icon": "mdi-note-text",
                                            title: "My Notes",
                                            value: "notes"
                                        }),
                                        (0, $TusQn.createVNode)(_component_v_list_item, {
                                            "prepend-icon": "mdi-cog",
                                            title: "Settings",
                                            value: "settings"
                                        })
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                }, 8, [
                    "modelValue"
                ]),
                (0, $TusQn.createVNode)(_component_v_main, null, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)($setup["GraphView"], {
                                ref: "graphViewRef"
                            }, null, 512)
                        ]),
                    _: 1
                }),
                $setup.graphViewRef ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_dialog, {
                    key: 0,
                    modelValue: $setup.graphViewRef.savedStatesDialog,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event)=>$setup.graphViewRef.savedStatesDialog = $event),
                    "max-width": "800"
                }, {
                    default: (0, $TusQn.withCtx)(()=>[
                            (0, $TusQn.createVNode)(_component_v_card, null, {
                                default: (0, $TusQn.withCtx)(()=>[
                                        (0, $TusQn.createVNode)(_component_v_card_title, {
                                            class: "d-flex align-center"
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_v_icon, {
                                                        class: "mr-2"
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ..._cache[14] || (_cache[14] = [
                                                                    (0, $TusQn.createTextVNode)("mdi-bookmark-multiple", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    }),
                                                    _cache[17] || (_cache[17] = (0, $TusQn.createTextVNode)(" Saved Investigations ", -1)),
                                                    (0, $TusQn.createVNode)(_component_v_spacer),
                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                        size: "small",
                                                        variant: "tonal",
                                                        "prepend-icon": "mdi-plus",
                                                        onClick: _cache[7] || (_cache[7] = ($event)=>{
                                                            $setup.graphViewRef.createNewInvestigation();
                                                            $setup.graphViewRef.savedStatesDialog = false;
                                                        }),
                                                        class: "mr-2"
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ..._cache[15] || (_cache[15] = [
                                                                    (0, $TusQn.createTextVNode)(" New ", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    }),
                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                        size: "small",
                                                        variant: "tonal",
                                                        "prepend-icon": "mdi-import",
                                                        onClick: _cache[8] || (_cache[8] = ($event)=>$setup.graphViewRef.importInvestigation())
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ..._cache[16] || (_cache[16] = [
                                                                    (0, $TusQn.createTextVNode)(" Import ", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    })
                                                ]),
                                            _: 1
                                        }),
                                        (0, $TusQn.createVNode)(_component_v_card_text, {
                                            style: {
                                                "max-height": "60vh",
                                                "overflow-y": "auto"
                                            }
                                        }, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    $setup.graphViewRef.loadingStates ? ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_progress_linear, {
                                                        key: 0,
                                                        indeterminate: ""
                                                    })) : (0, $TusQn.createCommentVNode)("", true),
                                                    $setup.graphViewRef.savedStates.length === 0 && !$setup.graphViewRef.loadingStates ? ((0, $TusQn.openBlock)(), (0, $TusQn.createElementBlock)("div", $2c4cb1eb429dee56$var$_hoisted_2, [
                                                        (0, $TusQn.createVNode)(_component_v_icon, {
                                                            size: "64",
                                                            color: "grey-lighten-1"
                                                        }, {
                                                            default: (0, $TusQn.withCtx)(()=>[
                                                                    ..._cache[18] || (_cache[18] = [
                                                                        (0, $TusQn.createTextVNode)("mdi-bookmark-off", -1)
                                                                    ])
                                                                ]),
                                                            _: 1
                                                        }),
                                                        _cache[19] || (_cache[19] = (0, $TusQn.createElementVNode)("div", {
                                                            class: "text-h6 mt-4 text-grey"
                                                        }, "No saved investigations yet", -1)),
                                                        _cache[20] || (_cache[20] = (0, $TusQn.createElementVNode)("div", {
                                                            class: "text-body-2 text-grey"
                                                        }, " Click the save button to save your current investigation ", -1))
                                                    ])) : ((0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_list, {
                                                        key: 2,
                                                        lines: "two"
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ((0, $TusQn.openBlock)(true), (0, $TusQn.createElementBlock)((0, $TusQn.Fragment), null, (0, $TusQn.renderList)($setup.graphViewRef.savedStates, (state)=>{
                                                                    return (0, $TusQn.openBlock)(), (0, $TusQn.createBlock)(_component_v_list_item, {
                                                                        key: state.id,
                                                                        active: state.id === $setup.graphViewRef.currentInvestigationId,
                                                                        onClick: ($event)=>$setup.graphViewRef.restoreInvestigation(state.id),
                                                                        class: "mb-2"
                                                                    }, {
                                                                        prepend: (0, $TusQn.withCtx)(()=>[
                                                                                (0, $TusQn.createVNode)(_component_v_icon, {
                                                                                    color: state.id === $setup.graphViewRef.currentInvestigationId ? 'primary' : 'grey'
                                                                                }, {
                                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(state.id === $setup.graphViewRef.currentInvestigationId ? "mdi-bookmark-check" : "mdi-bookmark"), 1)
                                                                                        ]),
                                                                                    _: 2
                                                                                }, 1032, [
                                                                                    "color"
                                                                                ])
                                                                            ]),
                                                                        append: (0, $TusQn.withCtx)(()=>[
                                                                                (0, $TusQn.createElementVNode)("div", $2c4cb1eb429dee56$var$_hoisted_3, [
                                                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                                                        size: "x-small",
                                                                                        icon: "mdi-content-copy",
                                                                                        variant: "text",
                                                                                        onClick: (0, $eeJ70.withModifiers)(($event)=>$setup.graphViewRef.duplicateInvestigation(state.id), [
                                                                                            "stop"
                                                                                        ]),
                                                                                        title: 'Duplicate'
                                                                                    }, null, 8, [
                                                                                        "onClick"
                                                                                    ]),
                                                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                                                        size: "x-small",
                                                                                        icon: "mdi-export",
                                                                                        variant: "text",
                                                                                        onClick: (0, $eeJ70.withModifiers)(($event)=>$setup.graphViewRef.exportInvestigation(state.id), [
                                                                                            "stop"
                                                                                        ]),
                                                                                        title: 'Export to file'
                                                                                    }, null, 8, [
                                                                                        "onClick"
                                                                                    ]),
                                                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                                                        size: "x-small",
                                                                                        icon: "mdi-delete",
                                                                                        variant: "text",
                                                                                        color: "error",
                                                                                        onClick: (0, $eeJ70.withModifiers)(($event)=>$setup.graphViewRef.deleteInvestigation(state.id), [
                                                                                            "stop"
                                                                                        ]),
                                                                                        title: 'Delete'
                                                                                    }, null, 8, [
                                                                                        "onClick"
                                                                                    ])
                                                                                ])
                                                                            ]),
                                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                                (0, $TusQn.createVNode)(_component_v_list_item_title, null, {
                                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(state.name), 1)
                                                                                        ]),
                                                                                    _: 2
                                                                                }, 1024),
                                                                                (0, $TusQn.createVNode)(_component_v_list_item_subtitle, null, {
                                                                                    default: (0, $TusQn.withCtx)(()=>[
                                                                                            (0, $TusQn.createTextVNode)((0, $8POXm.toDisplayString)(state.graphData.nodes.length) + " nodes, " + (0, $8POXm.toDisplayString)(state.graphData.edges.length) + " edges \u2022 " + (0, $8POXm.toDisplayString)(state.layoutType) + " layout \u2022 " + (0, $8POXm.toDisplayString)(new Date(state.updatedAt).toLocaleString()), 1)
                                                                                        ]),
                                                                                    _: 2
                                                                                }, 1024)
                                                                            ]),
                                                                        _: 2
                                                                    }, 1032, [
                                                                        "active",
                                                                        "onClick"
                                                                    ]);
                                                                }), 128))
                                                            ]),
                                                        _: 1
                                                    }))
                                                ]),
                                            _: 1
                                        }),
                                        (0, $TusQn.createVNode)(_component_v_card_actions, null, {
                                            default: (0, $TusQn.withCtx)(()=>[
                                                    (0, $TusQn.createVNode)(_component_v_spacer),
                                                    (0, $TusQn.createVNode)(_component_v_btn, {
                                                        onClick: _cache[9] || (_cache[9] = ($event)=>$setup.graphViewRef.savedStatesDialog = false)
                                                    }, {
                                                        default: (0, $TusQn.withCtx)(()=>[
                                                                ..._cache[21] || (_cache[21] = [
                                                                    (0, $TusQn.createTextVNode)("Close", -1)
                                                                ])
                                                            ]),
                                                        _: 1
                                                    })
                                                ]),
                                            _: 1
                                        })
                                    ]),
                                _: 1
                            })
                        ]),
                    _: 1
                }, 8, [
                    "modelValue"
                ])) : (0, $TusQn.createCommentVNode)("", true)
            ]),
        _: 1
    });
}

});

parcelRegister("1rrBo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10cdb945e864b702$export$2e2bcd8739ae039);
let $10cdb945e864b702$var$NOOP = ()=>{};
var $10cdb945e864b702$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire("ecd4d");
var $eeJ70 = parcelRequire("eeJ70");

var $i0TKe = parcelRequire("i0TKe");
let $ae3de8900c09c2f9$var$script;




let $ae3de8900c09c2f9$var$initialize = ()=>{
    $ae3de8900c09c2f9$var$script = (parcelRequire("boZNq"));
    if ($ae3de8900c09c2f9$var$script.__esModule) $ae3de8900c09c2f9$var$script = $ae3de8900c09c2f9$var$script.default;
    $ae3de8900c09c2f9$var$script.render = (parcelRequire("3NNX1")).render;
    $ae3de8900c09c2f9$var$script.__cssModules = {};
    (parcelRequire("1rrBo")).default($ae3de8900c09c2f9$var$script);
    $ae3de8900c09c2f9$var$script.__scopeId = 'data-v-c258a8';
    $ae3de8900c09c2f9$var$script.__file = "App.vue";
};
$ae3de8900c09c2f9$var$initialize();
var $ae3de8900c09c2f9$export$2e2bcd8739ae039 = $ae3de8900c09c2f9$var$script;


// Composables
// Composables
// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
/* eslint-disable no-console */ // Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
function $5384ffc78a9e124c$export$222ba5e7254f2402(message) {
    (0, $TusQn.warn)(`Vuetify: ${message}`);
}
function $5384ffc78a9e124c$export$bf36f23bad3e1069(message) {
    (0, $TusQn.warn)(`Vuetify error: ${message}`);
}
function $5384ffc78a9e124c$export$b680e6b2c82f8c2f(original, replacement) {
    replacement = Array.isArray(replacement) ? replacement.slice(0, -1).map((s)=>`'${s}'`).join(', ') + ` or '${replacement.at(-1)}'` : `'${replacement}'`;
    (0, $TusQn.warn)(`[Vuetify UPGRADE] '${original}' is deprecated, use ${replacement} instead.`);
}
function $5384ffc78a9e124c$export$64074568ee7deb5d(original, replacement) {
// warn(`[Vuetify BREAKING] '${original}' has been removed, use '${replacement}' instead. For more information, see the upgrade guide https://github.com/vuetifyjs/vuetify/releases/tag/v2.0.0#user-content-upgrade-guide`)
}
function $5384ffc78a9e124c$export$714b9f069b251186(original) {
// warn(`[Vuetify REMOVED] '${original}' has been removed. You can safely omit it.`)
}

// Composables
// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
parcelRequire("ecd4d");
var $8POXm = parcelRequire("8POXm");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

const $90a48ad178b943d3$export$13a6ee1b6d6a0cfd = typeof window !== 'undefined';
const $90a48ad178b943d3$export$8cb82f5817a92ac4 = $90a48ad178b943d3$export$13a6ee1b6d6a0cfd && 'IntersectionObserver' in window;
const $90a48ad178b943d3$export$a5f9edc0876666e5 = $90a48ad178b943d3$export$13a6ee1b6d6a0cfd && ('ontouchstart' in window || window.navigator.maxTouchPoints > 0);
const $90a48ad178b943d3$export$c0654247a3e5665d = $90a48ad178b943d3$export$13a6ee1b6d6a0cfd && 'EyeDropper' in window;
const $90a48ad178b943d3$export$622094c5d6c3013b = $90a48ad178b943d3$export$13a6ee1b6d6a0cfd && 'matchMedia' in window && typeof window.matchMedia === 'function';
const $90a48ad178b943d3$export$2022ae7bc01fd4dd = ()=>$90a48ad178b943d3$export$622094c5d6c3013b && window.matchMedia('(prefers-reduced-motion: reduce)').matches;


function $8590040a7833369a$var$_classPrivateFieldInitSpec(e, t, a) {
    $8590040a7833369a$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $8590040a7833369a$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $8590040a7833369a$var$_classPrivateFieldSet(s, a, r) {
    return s.set($8590040a7833369a$var$_assertClassBrand(s, a), r), r;
}
function $8590040a7833369a$var$_classPrivateFieldGet(s, a) {
    return s.get($8590040a7833369a$var$_assertClassBrand(s, a));
}
function $8590040a7833369a$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $8590040a7833369a$export$2516322ffbb7f3fb(obj, path, fallback) {
    const last = path.length - 1;
    if (last < 0) return obj === undefined ? fallback : obj;
    for(let i = 0; i < last; i++){
        if (obj == null) return fallback;
        obj = obj[path[i]];
    }
    if (obj == null) return fallback;
    return obj[path[last]] === undefined ? fallback : obj[path[last]];
}
function $8590040a7833369a$export$f5474208cafa7b66(obj, path, fallback) {
    // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
    if (obj == null || !path || typeof path !== 'string') return fallback;
    if (obj[path] !== undefined) return obj[path];
    path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    path = path.replace(/^\./, ''); // strip a leading dot
    return $8590040a7833369a$export$2516322ffbb7f3fb(obj, path.split('.'), fallback);
}
function $8590040a7833369a$export$655f0e681f1365dc(item, property, fallback) {
    if (property === true) return item === undefined ? fallback : item;
    if (property == null || typeof property === 'boolean') return fallback;
    if (item !== Object(item)) {
        if (typeof property !== 'function') return fallback;
        const value = property(item, fallback);
        return typeof value === 'undefined' ? fallback : value;
    }
    if (typeof property === 'string') return $8590040a7833369a$export$f5474208cafa7b66(item, property, fallback);
    if (Array.isArray(property)) return $8590040a7833369a$export$2516322ffbb7f3fb(item, property, fallback);
    if (typeof property !== 'function') return fallback;
    const value = property(item, fallback);
    return typeof value === 'undefined' ? fallback : value;
}
function $8590040a7833369a$export$d372f2f3c4d1b8e5(length) {
    let start = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return Array.from({
        length: length
    }, (v, k)=>start + k);
}
function $8590040a7833369a$export$9b544f58430fc883(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
    const index = Number(window.getComputedStyle(el).getPropertyValue('z-index'));
    if (!index) return $8590040a7833369a$export$9b544f58430fc883(el.parentNode);
    return index;
}
function $8590040a7833369a$export$286ad215293a0860(str) {
    let unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'px';
    if (str == null || str === '') return undefined;
    const num = Number(str);
    if (isNaN(num)) return String(str);
    else if (!isFinite(num)) return undefined;
    else return `${num}${unit}`;
}
function $8590040a7833369a$export$a6cdc56e425d0d0a(obj) {
    return obj !== null && typeof obj === 'object' && !Array.isArray(obj);
}
function $8590040a7833369a$export$53b83ca8eaab0383(obj) {
    let proto;
    return obj !== null && typeof obj === 'object' && ((proto = Object.getPrototypeOf(obj)) === Object.prototype || proto === null);
}
function $8590040a7833369a$export$2bffc57ac06742e2(obj) {
    if (obj && '$el' in obj) {
        const el = obj.$el;
        if (el?.nodeType === Node.TEXT_NODE) // Multi-root component, use the first element
        return el.nextElementSibling;
        return el;
    }
    return obj;
}
const $8590040a7833369a$export$6d3e562ac77a9517 = Object.freeze({
    enter: 13,
    tab: 9,
    delete: 46,
    esc: 27,
    space: 32,
    up: 38,
    down: 40,
    left: 37,
    right: 39,
    end: 35,
    home: 36,
    del: 46,
    backspace: 8,
    insert: 45,
    pageup: 33,
    pagedown: 34,
    shift: 16
});
const $8590040a7833369a$export$4f79075d7446a261 = Object.freeze({
    enter: 'Enter',
    tab: 'Tab',
    delete: 'Delete',
    esc: 'Escape',
    space: 'Space',
    up: 'ArrowUp',
    down: 'ArrowDown',
    left: 'ArrowLeft',
    right: 'ArrowRight',
    end: 'End',
    home: 'Home',
    del: 'Delete',
    backspace: 'Backspace',
    insert: 'Insert',
    pageup: 'PageUp',
    pagedown: 'PageDown',
    shift: 'Shift'
});
function $8590040a7833369a$export$ed97f33186d4b816(o) {
    return Object.keys(o);
}
function $8590040a7833369a$export$a4f4bb6b1453fff5(obj, key) {
    return key.every((k)=>obj.hasOwnProperty(k));
}
function $8590040a7833369a$export$357523c63a2253b9(obj, paths) {
    const found = {};
    for (const key of paths)if (Object.prototype.hasOwnProperty.call(obj, key)) found[key] = obj[key];
    return found;
}
function $8590040a7833369a$export$b25139123a794551(obj, paths, exclude) {
    const found = Object.create(null);
    const rest = Object.create(null);
    for(const key in obj)if (paths.some((path)=>path instanceof RegExp ? path.test(key) : path === key) && !exclude?.some((path)=>path === key)) found[key] = obj[key];
    else rest[key] = obj[key];
    return [
        found,
        rest
    ];
}
function $8590040a7833369a$export$30a06c8d3562193f(obj, exclude) {
    const clone = {
        ...obj
    };
    exclude.forEach((prop)=>delete clone[prop]);
    return clone;
}
const $8590040a7833369a$var$onRE = /^on[^a-z]/;
const $8590040a7833369a$export$1a2d97de39ecbb75 = (key)=>$8590040a7833369a$var$onRE.test(key);
const $8590040a7833369a$var$bubblingEvents = [
    'onAfterscriptexecute',
    'onAnimationcancel',
    'onAnimationend',
    'onAnimationiteration',
    'onAnimationstart',
    'onAuxclick',
    'onBeforeinput',
    'onBeforescriptexecute',
    'onChange',
    'onClick',
    'onCompositionend',
    'onCompositionstart',
    'onCompositionupdate',
    'onContextmenu',
    'onCopy',
    'onCut',
    'onDblclick',
    'onFocusin',
    'onFocusout',
    'onFullscreenchange',
    'onFullscreenerror',
    'onGesturechange',
    'onGestureend',
    'onGesturestart',
    'onGotpointercapture',
    'onInput',
    'onKeydown',
    'onKeypress',
    'onKeyup',
    'onLostpointercapture',
    'onMousedown',
    'onMousemove',
    'onMouseout',
    'onMouseover',
    'onMouseup',
    'onMousewheel',
    'onPaste',
    'onPointercancel',
    'onPointerdown',
    'onPointerenter',
    'onPointerleave',
    'onPointermove',
    'onPointerout',
    'onPointerover',
    'onPointerup',
    'onReset',
    'onSelect',
    'onSubmit',
    'onTouchcancel',
    'onTouchend',
    'onTouchmove',
    'onTouchstart',
    'onTransitioncancel',
    'onTransitionend',
    'onTransitionrun',
    'onTransitionstart',
    'onWheel'
];
const $8590040a7833369a$var$compositionIgnoreKeys = [
    'ArrowUp',
    'ArrowDown',
    'ArrowRight',
    'ArrowLeft',
    'Enter',
    'Escape',
    'Tab',
    ' '
];
function $8590040a7833369a$export$af97bfee12e57e9c(e) {
    return e.isComposing && $8590040a7833369a$var$compositionIgnoreKeys.includes(e.key);
}
function $8590040a7833369a$export$c46dde8a23cbfcf2(attrs) {
    const [events, props] = $8590040a7833369a$export$b25139123a794551(attrs, [
        $8590040a7833369a$var$onRE
    ]);
    const inputEvents = $8590040a7833369a$export$30a06c8d3562193f(events, $8590040a7833369a$var$bubblingEvents);
    const [rootAttrs, inputAttrs] = $8590040a7833369a$export$b25139123a794551(props, [
        'class',
        'style',
        'id',
        'inert',
        /^data-/
    ]);
    Object.assign(rootAttrs, events);
    Object.assign(inputAttrs, inputEvents);
    return [
        rootAttrs,
        inputAttrs
    ];
}
function $8590040a7833369a$export$c60e0e71ff2ff066(a, b) {
    const diff = [];
    for(let i = 0; i < b.length; i++)if (!a.includes(b[i])) diff.push(b[i]);
    return diff;
}
function $8590040a7833369a$export$76411cac38121ecb(v) {
    return v == null ? [] : Array.isArray(v) ? v : [
        v
    ];
}
function $8590040a7833369a$export$3f6f640afaf1ec43(value, search, item) {
    return value != null && search != null && typeof value !== 'boolean' && value.toString().toLocaleLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;
}
function $8590040a7833369a$export$61fc7d43ac8f84b0(fn, delay) {
    let timeoutId = 0;
    const wrap = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>fn(...args), (0, $01W3b.unref)(delay));
    };
    wrap.clear = ()=>{
        clearTimeout(timeoutId);
    };
    wrap.immediate = fn;
    return wrap;
}
function $8590040a7833369a$export$7d15b64cf5a3a4c4(value) {
    let min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    return Math.max(min, Math.min(max, value));
}
function $8590040a7833369a$export$1ecb455da4aa739b(value) {
    const trimmedStr = value.toString().trim();
    return trimmedStr.includes('.') ? trimmedStr.length - trimmedStr.indexOf('.') - 1 : 0;
}
function $8590040a7833369a$export$23a07ddfce9fad49(str, length) {
    let char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    return str + char.repeat(Math.max(0, length - str.length));
}
function $8590040a7833369a$export$36cf564d487b5178(str, length) {
    let char = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    return char.repeat(Math.max(0, length - str.length)) + str;
}
function $8590040a7833369a$export$5f7ec48d69707ddd(str) {
    let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    const chunked = [];
    let index = 0;
    while(index < str.length){
        chunked.push(str.substr(index, size));
        index += size;
    }
    return chunked;
}
function $8590040a7833369a$export$f922ebe57f2c36e8(array) {
    let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Array.from({
        length: Math.ceil(array.length / size)
    }, (v, i)=>array.slice(i * size, i * size + size));
}
function $8590040a7833369a$export$dfc82bc1332b0cba(bytes) {
    let base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
    if (bytes < base) return `${bytes} B`;
    const prefix = base === 1024 ? [
        'Ki',
        'Mi',
        'Gi'
    ] : [
        'k',
        'M',
        'G'
    ];
    let unit = -1;
    while(Math.abs(bytes) >= base && unit < prefix.length - 1){
        bytes /= base;
        ++unit;
    }
    return `${bytes.toFixed(1)} ${prefix[unit]}B`;
}
function $8590040a7833369a$export$dd702b3c8240390c() {
    let source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let arrayFn = arguments.length > 2 ? arguments[2] : undefined;
    const out = {};
    for(const key in source)out[key] = source[key];
    for(const key in target){
        const sourceProperty = source[key];
        const targetProperty = target[key];
        // Only continue deep merging if
        // both properties are plain objects
        if ($8590040a7833369a$export$53b83ca8eaab0383(sourceProperty) && $8590040a7833369a$export$53b83ca8eaab0383(targetProperty)) {
            out[key] = $8590040a7833369a$export$dd702b3c8240390c(sourceProperty, targetProperty, arrayFn);
            continue;
        }
        if (arrayFn && Array.isArray(sourceProperty) && Array.isArray(targetProperty)) {
            out[key] = arrayFn(sourceProperty, targetProperty);
            continue;
        }
        out[key] = targetProperty;
    }
    return out;
}
function $8590040a7833369a$export$c556ee00a0535018(nodes) {
    return nodes.map((node)=>{
        if (node.type === (0, $TusQn.Fragment)) return $8590040a7833369a$export$c556ee00a0535018(node.children);
        else return node;
    }).flat();
}
function $8590040a7833369a$export$73bda83cddbc7187() {
    let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if ($8590040a7833369a$export$73bda83cddbc7187.cache.has(str)) return $8590040a7833369a$export$73bda83cddbc7187.cache.get(str);
    const kebab = str.replace(/[^a-z]/gi, '-').replace(/\B([A-Z])/g, '-$1').toLowerCase();
    $8590040a7833369a$export$73bda83cddbc7187.cache.set(str, kebab);
    return kebab;
}
$8590040a7833369a$export$73bda83cddbc7187.cache = new Map();
function $8590040a7833369a$export$424fe43b65f39668(key, vnode) {
    if (!vnode || typeof vnode !== 'object') return [];
    if (Array.isArray(vnode)) return vnode.map((child)=>$8590040a7833369a$export$424fe43b65f39668(key, child)).flat(1);
    else if (vnode.suspense) return $8590040a7833369a$export$424fe43b65f39668(key, vnode.ssContent);
    else if (Array.isArray(vnode.children)) return vnode.children.map((child)=>$8590040a7833369a$export$424fe43b65f39668(key, child)).flat(1);
    else if (vnode.component) {
        if (Object.getOwnPropertyDescriptor(vnode.component.provides, key)) return [
            vnode.component
        ];
        else if (vnode.component.subTree) return $8590040a7833369a$export$424fe43b65f39668(key, vnode.component.subTree).flat(1);
    }
    return [];
}
var $8590040a7833369a$var$_arr = /*#__PURE__*/ new WeakMap();
var $8590040a7833369a$var$_pointer = /*#__PURE__*/ new WeakMap();
class $8590040a7833369a$export$5900cd5f89b9a13a {
    constructor(size){
        $8590040a7833369a$var$_classPrivateFieldInitSpec(this, $8590040a7833369a$var$_arr, []);
        $8590040a7833369a$var$_classPrivateFieldInitSpec(this, $8590040a7833369a$var$_pointer, 0);
        this.size = size;
    }
    get isFull() {
        return $8590040a7833369a$var$_classPrivateFieldGet($8590040a7833369a$var$_arr, this).length === this.size;
    }
    push(val) {
        $8590040a7833369a$var$_classPrivateFieldGet($8590040a7833369a$var$_arr, this)[$8590040a7833369a$var$_classPrivateFieldGet($8590040a7833369a$var$_pointer, this)] = val;
        $8590040a7833369a$var$_classPrivateFieldSet($8590040a7833369a$var$_pointer, this, ($8590040a7833369a$var$_classPrivateFieldGet($8590040a7833369a$var$_pointer, this) + 1) % this.size);
    }
    values() {
        return $8590040a7833369a$var$_classPrivateFieldGet($8590040a7833369a$var$_arr, this).slice($8590040a7833369a$var$_classPrivateFieldGet($8590040a7833369a$var$_pointer, this)).concat($8590040a7833369a$var$_classPrivateFieldGet($8590040a7833369a$var$_arr, this).slice(0, $8590040a7833369a$var$_classPrivateFieldGet($8590040a7833369a$var$_pointer, this)));
    }
    clear() {
        $8590040a7833369a$var$_classPrivateFieldGet($8590040a7833369a$var$_arr, this).length = 0;
        $8590040a7833369a$var$_classPrivateFieldSet($8590040a7833369a$var$_pointer, this, 0);
    }
}
function $8590040a7833369a$export$36195c8aa1517e04(e) {
    if ('touches' in e) return {
        clientX: e.touches[0].clientX,
        clientY: e.touches[0].clientY
    };
    return {
        clientX: e.clientX,
        clientY: e.clientY
    };
}
function $8590040a7833369a$export$fe6a5b56d01db4f5(getter) {
    const refs = (0, $01W3b.reactive)({});
    (0, $TusQn.watchEffect)(()=>{
        const base = getter();
        for(const key in base)refs[key] = base[key];
    }, {
        flush: 'sync'
    });
    const obj = {};
    for(const key in refs)obj[key] = (0, $01W3b.toRef)(()=>refs[key]);
    return obj;
}
function $8590040a7833369a$export$ee2e0f811dca1807(arr, val) {
    return arr.includes(val);
}
function $8590040a7833369a$export$a0305a8c6cff19c8(propName) {
    return propName[2].toLowerCase() + propName.slice(3);
}
const $8590040a7833369a$export$cefab237a347bf23 = ()=>[
        Function,
        Array
    ];
function $8590040a7833369a$export$1f08a0593c4a067d(props, name) {
    name = 'on' + (0, $8POXm.capitalize)(name);
    return !!(props[name] || props[`${name}Once`] || props[`${name}Capture`] || props[`${name}OnceCapture`] || props[`${name}CaptureOnce`]);
}
function $8590040a7833369a$export$293b251ea77dc2b7(handler) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    if (Array.isArray(handler)) for (const h of handler)h(...args);
    else if (typeof handler === 'function') handler(...args);
}
function $8590040a7833369a$export$aea49dace3f6ca76(el) {
    let filterByTabIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    const targets = [
        'button',
        '[href]',
        'input:not([type="hidden"])',
        'select',
        'textarea',
        'details:not(:has(> summary))',
        'details > summary',
        '[tabindex]',
        '[contenteditable]:not([contenteditable="false"])',
        'audio[controls]',
        'video[controls]'
    ].map((s)=>`${s}${filterByTabIndex ? ':not([tabindex="-1"])' : ''}:not([disabled], [inert])`).join(', ');
    let elements;
    try {
        elements = [
            ...el.querySelectorAll(targets)
        ];
    } catch (err) {
        (0, $5384ffc78a9e124c$export$bf36f23bad3e1069)(String(err));
        return [];
    }
    return elements.filter((x)=>!x.closest('[inert]')) // does not have inert parent
    .filter((x)=>!!x.offsetParent || x.getClientRects().length > 0) // is rendered
    .filter((x)=>!x.parentElement?.closest('details:not([open])') || x.tagName === 'SUMMARY' && x.parentElement?.tagName === 'DETAILS');
}
function $8590040a7833369a$export$4109ed81edd7716d(elements, location, condition) {
    let _el;
    let idx = elements.indexOf(document.activeElement);
    const inc = location === 'next' ? 1 : -1;
    do {
        idx += inc;
        _el = elements[idx];
    }while ((!_el || _el.offsetParent == null || !(condition?.(_el) ?? true)) && idx < elements.length && idx >= 0);
    return _el;
}
function $8590040a7833369a$export$da2eafa20d5ebba(el, location) {
    const focusable = $8590040a7833369a$export$aea49dace3f6ca76(el);
    if (location == null) {
        if (el === document.activeElement || !el.contains(document.activeElement)) focusable[0]?.focus();
    } else if (location === 'first') focusable[0]?.focus();
    else if (location === 'last') focusable.at(-1)?.focus();
    else if (typeof location === 'number') focusable[location]?.focus();
    else {
        const _el = $8590040a7833369a$export$4109ed81edd7716d(focusable, location);
        if (_el) _el.focus();
        else $8590040a7833369a$export$da2eafa20d5ebba(el, location === 'next' ? 'first' : 'last');
    }
}
function $8590040a7833369a$export$dd1bc94b04021eeb(val) {
    return val === null || val === undefined || typeof val === 'string' && val.trim() === '';
}
function $8590040a7833369a$export$8793edee2d425525() {}
function $8590040a7833369a$export$b06a2f5618961e1e(el, selector) {
    const supportsSelector = (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && typeof CSS !== 'undefined' && typeof CSS.supports !== 'undefined' && CSS.supports(`selector(${selector})`);
    if (!supportsSelector) return null;
    try {
        return !!el && el.matches(selector);
    } catch (err) {
        return null;
    }
}
function $8590040a7833369a$export$9fc41f261330971f(vnodes) {
    return vnodes.some((child)=>{
        if (!(0, $TusQn.isVNode)(child)) return true;
        if (child.type === (0, $TusQn.Comment)) return false;
        return child.type !== (0, $TusQn.Fragment) || $8590040a7833369a$export$9fc41f261330971f(child.children);
    }) ? vnodes : null;
}
function $8590040a7833369a$export$4abee4c34694ada1(slot, props, fallback) {
    // TODO: check if slot returns elements: #18308
    return slot?.(props) ?? fallback?.(props);
}
function $8590040a7833369a$export$260e5c0943f31606(timeout, cb) {
    if (!(0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) || timeout === 0) {
        cb();
        return ()=>{};
    }
    const timeoutId = window.setTimeout(cb, timeout);
    return ()=>window.clearTimeout(timeoutId);
}
function $8590040a7833369a$export$4430641350aec15f(event, targetDiv) {
    const mouseX = event.clientX;
    const mouseY = event.clientY;
    const divRect = targetDiv.getBoundingClientRect();
    const divLeft = divRect.left;
    const divTop = divRect.top;
    const divRight = divRect.right;
    const divBottom = divRect.bottom;
    return mouseX >= divLeft && mouseX <= divRight && mouseY >= divTop && mouseY <= divBottom;
}
function $8590040a7833369a$export$fc38e812d383221() {
    const el = (0, $01W3b.shallowRef)();
    const fn = (target)=>{
        el.value = target;
    };
    Object.defineProperty(fn, 'value', {
        enumerable: true,
        get: ()=>el.value,
        set: (val)=>el.value = val
    });
    Object.defineProperty(fn, 'el', {
        enumerable: true,
        get: ()=>$8590040a7833369a$export$2bffc57ac06742e2(el.value)
    });
    return fn;
}
function $8590040a7833369a$export$d9d503bf19df5a70(e) {
    const isPrintableChar = e.key.length === 1;
    const noModifier = !e.ctrlKey && !e.metaKey && !e.altKey;
    return isPrintableChar && noModifier;
}
function $8590040a7833369a$export$c3825b437cbdea5c(value) {
    return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint';
}
function $8590040a7833369a$export$211de94a4ac98986(sign) {
    return '\\^$*+?.()|{}[]'.includes(sign) ? `\\${sign}` : sign;
}
function $8590040a7833369a$export$ee2b54e92bdbaa0c(text, decimalDigitsLimit, decimalSeparator) {
    const onlyValidCharacters = new RegExp(`[\\d\\-${$8590040a7833369a$export$211de94a4ac98986(decimalSeparator)}]`);
    const cleanText = text.split('').filter((x)=>onlyValidCharacters.test(x)).filter((x, i, all)=>i === 0 && /[-]/.test(x) || // sign allowed at the start
        x === decimalSeparator && i === all.indexOf(x) || // decimal separator allowed only once
        /\d/.test(x)).join('');
    if (decimalDigitsLimit === 0) return cleanText.split(decimalSeparator)[0];
    const decimalPart = new RegExp(`${$8590040a7833369a$export$211de94a4ac98986(decimalSeparator)}\\d`);
    if (decimalDigitsLimit !== null && decimalPart.test(cleanText)) {
        const parts = cleanText.split(decimalSeparator);
        return [
            parts[0],
            parts[1].substring(0, decimalDigitsLimit)
        ].join(decimalSeparator);
    }
    return cleanText;
}
function $8590040a7833369a$export$32263599c7ddd4ae(props) {
    const out = {};
    for(const prop in props)out[(0, $8POXm.camelize)(prop)] = props[prop];
    return out;
}
function $8590040a7833369a$export$bdca1cff95cf548c(props) {
    const booleanAttributes = [
        'checked',
        'disabled'
    ];
    return Object.fromEntries(Object.entries(props).filter((_ref)=>{
        let [key, v] = _ref;
        return booleanAttributes.includes(key) ? !!v : v !== undefined;
    }));
}
function $8590040a7833369a$export$dbf440cef0efdf87(value) {
    const objectIterator = (input)=>{
        if (Array.isArray(input)) return input.map((item)=>objectIterator(item));
        if ((0, $01W3b.isRef)(input) || (0, $01W3b.isReactive)(input) || (0, $01W3b.isProxy)(input)) return objectIterator((0, $01W3b.toRaw)(input));
        if ($8590040a7833369a$export$53b83ca8eaab0383(input)) return Object.keys(input).reduce((acc, key)=>{
            acc[key] = objectIterator(input[key]);
            return acc;
        }, {});
        return input;
    };
    return objectIterator(value);
}


function $b65c26e77f158b6f$export$f13e630aa3915748(name, message) {
    const vm = (0, $TusQn.getCurrentInstance)();
    if (!vm) throw new Error(`[Vuetify] ${name} ${message || 'must be called from inside a setup function'}`);
    return vm;
}
function $b65c26e77f158b6f$export$8adb83c1b7a9d7ae() {
    let name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'composables';
    const vm = $b65c26e77f158b6f$export$f13e630aa3915748(name).type;
    return (0, $8590040a7833369a$export$73bda83cddbc7187)(vm?.aliasName || vm?.name);
}



// Utilities

function $9d6d64004f549f25$export$af450d6d100990eb(key) {
    let vm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$f13e630aa3915748)('injectSelf');
    const { provides: provides } = vm;
    if (provides && key in provides) // TS doesn't allow symbol as index type
    return provides[key];
    return undefined;
}


const $8b1159e2b202edcf$export$84318fce2211c0fd = Symbol.for('vuetify:defaults');
function $8b1159e2b202edcf$export$e149fd47ce43e254(options) {
    return (0, $01W3b.ref)(options);
}
function $8b1159e2b202edcf$export$def078ca8538d812() {
    const defaults = (0, $TusQn.inject)($8b1159e2b202edcf$export$84318fce2211c0fd);
    if (!defaults) throw new Error('[Vuetify] Could not find defaults instance');
    return defaults;
}
function $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee(defaults, options) {
    const injectedDefaults = $8b1159e2b202edcf$export$def078ca8538d812();
    const providedDefaults = (0, $01W3b.ref)(defaults);
    const newDefaults = (0, $01W3b.computed)(()=>{
        const disabled = (0, $01W3b.unref)(options?.disabled);
        if (disabled) return injectedDefaults.value;
        const scoped = (0, $01W3b.unref)(options?.scoped);
        const reset = (0, $01W3b.unref)(options?.reset);
        const root = (0, $01W3b.unref)(options?.root);
        if (providedDefaults.value == null && !(scoped || reset || root)) return injectedDefaults.value;
        let properties = (0, $8590040a7833369a$export$dd702b3c8240390c)(providedDefaults.value, {
            prev: injectedDefaults.value
        });
        if (scoped) return properties;
        if (reset || root) {
            const len = Number(reset || Infinity);
            for(let i = 0; i <= len; i++){
                if (!properties || !('prev' in properties)) break;
                properties = properties.prev;
            }
            if (properties && typeof root === 'string' && root in properties) properties = (0, $8590040a7833369a$export$dd702b3c8240390c)((0, $8590040a7833369a$export$dd702b3c8240390c)(properties, {
                prev: properties
            }), properties[root]);
            return properties;
        }
        return properties.prev ? (0, $8590040a7833369a$export$dd702b3c8240390c)(properties.prev, properties) : properties;
    });
    (0, $TusQn.provide)($8b1159e2b202edcf$export$84318fce2211c0fd, newDefaults);
    return newDefaults;
}
function $8b1159e2b202edcf$var$propIsDefined(vnode, prop) {
    return vnode.props && (typeof vnode.props[prop] !== 'undefined' || typeof vnode.props[(0, $8590040a7833369a$export$73bda83cddbc7187)(prop)] !== 'undefined');
}
function $8b1159e2b202edcf$export$c8b014c4fb5d670b() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let name = arguments.length > 1 ? arguments[1] : undefined;
    let defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $8b1159e2b202edcf$export$def078ca8538d812();
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useDefaults');
    name = name ?? vm.type.name ?? vm.type.__name;
    if (!name) throw new Error('[Vuetify] Could not determine component name');
    const componentDefaults = (0, $01W3b.computed)(()=>defaults.value?.[props._as ?? name]);
    const _props = new Proxy(props, {
        get (target, prop) {
            const propValue = Reflect.get(target, prop);
            if (prop === 'class' || prop === 'style') return [
                componentDefaults.value?.[prop],
                propValue
            ].filter((v)=>v != null);
            if ($8b1159e2b202edcf$var$propIsDefined(vm.vnode, prop)) return propValue;
            const _componentDefault = componentDefaults.value?.[prop];
            if (_componentDefault !== undefined) return _componentDefault;
            const _globalDefault = defaults.value?.global?.[prop];
            if (_globalDefault !== undefined) return _globalDefault;
            return propValue;
        }
    });
    const _subcomponentDefaults = (0, $01W3b.shallowRef)();
    (0, $TusQn.watchEffect)(()=>{
        if (componentDefaults.value) {
            const subComponents = Object.entries(componentDefaults.value).filter((_ref)=>{
                let [key] = _ref;
                return key.startsWith(key[0].toUpperCase());
            });
            _subcomponentDefaults.value = subComponents.length ? Object.fromEntries(subComponents) : undefined;
        } else _subcomponentDefaults.value = undefined;
    });
    function provideSubDefaults() {
        const injected = (0, $9d6d64004f549f25$export$af450d6d100990eb)($8b1159e2b202edcf$export$84318fce2211c0fd, vm);
        (0, $TusQn.provide)($8b1159e2b202edcf$export$84318fce2211c0fd, (0, $01W3b.computed)(()=>{
            return _subcomponentDefaults.value ? (0, $8590040a7833369a$export$dd702b3c8240390c)(injected?.value ?? {}, _subcomponentDefaults.value) : injected?.value;
        }));
    }
    return {
        props: _props,
        provideSubDefaults: provideSubDefaults
    };
}
function $8b1159e2b202edcf$export$8a73fd45e606bcfb() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let name = arguments.length > 1 ? arguments[1] : undefined;
    const { props: _props, provideSubDefaults: provideSubDefaults } = $8b1159e2b202edcf$export$c8b014c4fb5d670b(props, name);
    provideSubDefaults();
    return _props;
}


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");


// Types
// eslint-disable-line vue/prefer-import-from-vue
/**
 * Creates a factory function for props definitions.
 * This is used to define props in a composable then override
 * default values in an implementing component.
 *
 * @example Simplified signature
 * (props: Props) => (defaults?: Record<keyof props, any>) => Props
 *
 * @example Usage
 * const makeProps = propsFactory({
 *   foo: String,
 * })
 *
 * defineComponent({
 *   props: {
 *     ...makeProps({
 *       foo: 'a',
 *     }),
 *   },
 *   setup (props) {
 *     // would be "string | undefined", now "string" because a default has been provided
 *     props.foo
 *   },
 * }
 */ function $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df(props, source) {
    return (defaults)=>{
        return Object.keys(props).reduce((obj, prop)=>{
            const isObjectDefinition = typeof props[prop] === 'object' && props[prop] != null && !Array.isArray(props[prop]);
            const definition = isObjectDefinition ? props[prop] : {
                type: props[prop]
            };
            if (defaults && prop in defaults) obj[prop] = {
                ...definition,
                default: defaults[prop]
            };
            else obj[prop] = definition;
            if (source && !obj[prop].source) obj[prop].source = source;
            return obj;
        }, {});
    };
} /**
 * Like `Partial<T>` but doesn't care what the value is
 */  // Copied from Vue


function $2b7aafe61499bf6b$export$afa64b67e5a01c3b(options) {
    options._setup = options._setup ?? options.setup;
    if (!options.name) {
        (0, $5384ffc78a9e124c$export$222ba5e7254f2402)('The component is missing an explicit name, unable to generate default prop value');
        return options;
    }
    if (options._setup) {
        options.props = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)(options.props ?? {}, options.name)();
        const propKeys = Object.keys(options.props).filter((key)=>key !== 'class' && key !== 'style');
        options.filterProps = function filterProps(props) {
            return (0, $8590040a7833369a$export$357523c63a2253b9)(props, propKeys);
        };
        options.props._as = String;
        options.setup = function setup(props, ctx) {
            const defaults = (0, $8b1159e2b202edcf$export$def078ca8538d812)();
            // Skip props proxy if defaults are not provided
            if (!defaults.value) return options._setup(props, ctx);
            const { props: _props, provideSubDefaults: provideSubDefaults } = (0, $8b1159e2b202edcf$export$c8b014c4fb5d670b)(props, props._as ?? options.name, defaults);
            const setupBindings = options._setup(_props, ctx);
            provideSubDefaults();
            return setupBindings;
        };
    }
    return options;
}
function $2b7aafe61499bf6b$export$6925fd0bc332cf90() {
    let exposeDefaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return (options)=>(exposeDefaults ? $2b7aafe61499bf6b$export$afa64b67e5a01c3b : (0, $TusQn.defineComponent))(options);
}
function $2b7aafe61499bf6b$export$c5e8501a3a1b4e53(props, render) {
    render.props = props;
    return render;
} // Adds a filterProps method to the component options
 // https://github.com/vuejs/core/pull/10557
 // not a vue Component


const $834ffcae3192e85e$export$84527c6e3556c23f = [
    String,
    Function,
    Object,
    Array
];
const $834ffcae3192e85e$export$d477c077e2856eb1 = Symbol.for('vuetify:icons');
const $834ffcae3192e85e$export$bae2637a732731e2 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    icon: {
        type: $834ffcae3192e85e$export$84527c6e3556c23f
    },
    // Could not remove this and use makeTagProps, types complained because it is not required
    tag: {
        type: [
            String,
            Object,
            Function
        ],
        required: true
    }
}, 'icon');
const $834ffcae3192e85e$export$151a4e51f3246587 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VComponentIcon',
    props: $834ffcae3192e85e$export$bae2637a732731e2(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        return ()=>{
            const Icon = props.icon;
            return (0, $TusQn.createVNode)(props.tag, null, {
                default: ()=>[
                        props.icon ? (0, $TusQn.createVNode)(Icon, null, null) : slots.default?.()
                    ]
            });
        };
    }
});
const $834ffcae3192e85e$export$4cc49047f32a5a44 = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VSvgIcon',
    inheritAttrs: false,
    props: $834ffcae3192e85e$export$bae2637a732731e2(),
    setup (props, _ref2) {
        let { attrs: attrs } = _ref2;
        return ()=>{
            return (0, $TusQn.createVNode)(props.tag, (0, $TusQn.mergeProps)(attrs, {
                "style": null
            }), {
                default: ()=>[
                        (0, $TusQn.createElementVNode)("svg", {
                            "class": "v-icon__svg",
                            "xmlns": "http://www.w3.org/2000/svg",
                            "viewBox": "0 0 24 24",
                            "role": "img",
                            "aria-hidden": "true"
                        }, [
                            Array.isArray(props.icon) ? props.icon.map((path)=>Array.isArray(path) ? (0, $TusQn.createElementVNode)("path", {
                                    "d": path[0],
                                    "fill-opacity": path[1]
                                }, null) : (0, $TusQn.createElementVNode)("path", {
                                    "d": path
                                }, null)) : (0, $TusQn.createElementVNode)("path", {
                                "d": props.icon
                            }, null)
                        ])
                    ]
            });
        };
    }
});
const $834ffcae3192e85e$export$d478d4439906e556 = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VLigatureIcon',
    props: $834ffcae3192e85e$export$bae2637a732731e2(),
    setup (props) {
        return ()=>{
            return (0, $TusQn.createVNode)(props.tag, null, {
                default: ()=>[
                        props.icon
                    ]
            });
        };
    }
});
const $834ffcae3192e85e$export$87ef10dabc6ea763 = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VClassIcon',
    props: $834ffcae3192e85e$export$bae2637a732731e2(),
    setup (props) {
        return ()=>{
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)(props.icon)
            }, null);
        };
    }
});
const $834ffcae3192e85e$export$27cb60208885277b = (props)=>{
    const icons = (0, $TusQn.inject)($834ffcae3192e85e$export$d477c077e2856eb1);
    if (!icons) throw new Error('Missing Vuetify Icons provide!');
    const iconData = (0, $01W3b.computed)(()=>{
        const iconAlias = (0, $01W3b.toValue)(props);
        if (!iconAlias) return {
            component: $834ffcae3192e85e$export$151a4e51f3246587
        };
        let icon = iconAlias;
        if (typeof icon === 'string') {
            icon = icon.trim();
            if (icon.startsWith('$')) icon = icons.aliases?.[icon.slice(1)];
        }
        if (!icon) (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`Could not find aliased icon "${iconAlias}"`);
        if (Array.isArray(icon)) return {
            component: $834ffcae3192e85e$export$4cc49047f32a5a44,
            icon: icon
        };
        else if (typeof icon !== 'string') return {
            component: $834ffcae3192e85e$export$151a4e51f3246587,
            icon: icon
        };
        const iconSetName = Object.keys(icons.sets).find((setName)=>typeof icon === 'string' && icon.startsWith(`${setName}:`));
        const iconName = iconSetName ? icon.slice(iconSetName.length + 1) : icon;
        const iconSet = icons.sets[iconSetName ?? icons.defaultSet];
        return {
            component: iconSet.component,
            icon: iconName
        };
    });
    return {
        iconData: iconData
    };
};


// Composables

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
// Types
const $69eac3e379d14be4$export$9af93bb9e9126a2 = {
    collapse: 'mdi-chevron-up',
    complete: 'mdi-check',
    cancel: 'mdi-close-circle',
    close: 'mdi-close',
    delete: 'mdi-close-circle',
    // delete (e.g. v-chip close)
    clear: 'mdi-close-circle',
    success: 'mdi-check-circle',
    info: 'mdi-information',
    warning: 'mdi-alert-circle',
    error: 'mdi-close-circle',
    prev: 'mdi-chevron-left',
    next: 'mdi-chevron-right',
    checkboxOn: 'mdi-checkbox-marked',
    checkboxOff: 'mdi-checkbox-blank-outline',
    checkboxIndeterminate: 'mdi-minus-box',
    delimiter: 'mdi-circle',
    // for carousel
    sortAsc: 'mdi-arrow-up',
    sortDesc: 'mdi-arrow-down',
    expand: 'mdi-chevron-down',
    menu: 'mdi-menu',
    subgroup: 'mdi-menu-down',
    dropdown: 'mdi-menu-down',
    radioOn: 'mdi-radiobox-marked',
    radioOff: 'mdi-radiobox-blank',
    edit: 'mdi-pencil',
    ratingEmpty: 'mdi-star-outline',
    ratingFull: 'mdi-star',
    ratingHalf: 'mdi-star-half-full',
    loading: 'mdi-cached',
    first: 'mdi-page-first',
    last: 'mdi-page-last',
    unfold: 'mdi-unfold-more-horizontal',
    file: 'mdi-paperclip',
    plus: 'mdi-plus',
    minus: 'mdi-minus',
    calendar: 'mdi-calendar',
    treeviewCollapse: 'mdi-menu-down',
    treeviewExpand: 'mdi-menu-right',
    tableGroupCollapse: 'mdi-chevron-down',
    tableGroupExpand: 'mdi-chevron-right',
    eyeDropper: 'mdi-eyedropper',
    upload: 'mdi-cloud-upload',
    color: 'mdi-palette',
    command: 'mdi-apple-keyboard-command',
    ctrl: 'mdi-apple-keyboard-control',
    space: 'mdi-keyboard-space',
    shift: 'mdi-apple-keyboard-shift',
    alt: 'mdi-apple-keyboard-option',
    enter: 'mdi-keyboard-return',
    arrowup: 'mdi-arrow-up',
    arrowdown: 'mdi-arrow-down',
    arrowleft: 'mdi-arrow-left',
    arrowright: 'mdi-arrow-right',
    backspace: 'mdi-backspace',
    play: 'mdi-play',
    pause: 'mdi-pause',
    fullscreen: 'mdi-fullscreen',
    fullscreenExit: 'mdi-fullscreen-exit',
    volumeHigh: 'mdi-volume-high',
    volumeMedium: 'mdi-volume-medium',
    volumeLow: 'mdi-volume-low',
    volumeOff: 'mdi-volume-variant-off',
    search: 'mdi-magnify'
};
const $69eac3e379d14be4$export$179238ba74376e8c = {
    // Not using mergeProps here, functional components merge props by default (?)
    component: (props)=>(0, $TusQn.h)((0, $834ffcae3192e85e$export$87ef10dabc6ea763), {
            ...props,
            class: 'mdi'
        })
};



function $cebee00dd6d52041$var$genDefaults() {
    return {
        svg: {
            component: (0, $834ffcae3192e85e$export$4cc49047f32a5a44)
        },
        class: {
            component: (0, $834ffcae3192e85e$export$87ef10dabc6ea763)
        }
    };
}
function $cebee00dd6d52041$export$f8761611413a374e(options) {
    const sets = $cebee00dd6d52041$var$genDefaults();
    const defaultSet = options?.defaultSet ?? 'mdi';
    if (defaultSet === 'mdi' && !sets.mdi) sets.mdi = (0, $69eac3e379d14be4$export$179238ba74376e8c);
    return (0, $8590040a7833369a$export$dd702b3c8240390c)({
        defaultSet: defaultSet,
        sets: sets,
        aliases: {
            ...(0, $69eac3e379d14be4$export$9af93bb9e9126a2),
            /* eslint-disable max-len */ vuetify: [
                'M8.2241 14.2009L12 21L22 3H14.4459L8.2241 14.2009Z',
                [
                    'M7.26303 12.4733L7.00113 12L2 3H12.5261C12.5261 3 12.5261 3 12.5261 3L7.26303 12.4733Z',
                    0.6
                ]
            ],
            'vuetify-outline': 'svg:M7.26 12.47 12.53 3H2L7.26 12.47ZM14.45 3 8.22 14.2 12 21 22 3H14.45ZM18.6 5 12 16.88 10.51 14.2 15.62 5ZM7.26 8.35 5.4 5H9.13L7.26 8.35Z',
            'vuetify-play': [
                'm6.376 13.184-4.11-7.192C1.505 4.66 2.467 3 4.003 3h8.532l-.953 1.576-.006.01-.396.677c-.429.732-.214 1.507.194 2.015.404.503 1.092.878 1.869.806a3.72 3.72 0 0 1 1.005.022c.276.053.434.143.523.237.138.146.38.635-.25 2.09-.893 1.63-1.553 1.722-1.847 1.677-.213-.033-.468-.158-.756-.406a4.95 4.95 0 0 1-.8-.927c-.39-.564-1.04-.84-1.66-.846-.625-.006-1.316.27-1.693.921l-.478.826-.911 1.506Z',
                [
                    'M9.093 11.552c.046-.079.144-.15.32-.148a.53.53 0 0 1 .43.207c.285.414.636.847 1.046 1.2.405.35.914.662 1.516.754 1.334.205 2.502-.698 3.48-2.495l.014-.028.013-.03c.687-1.574.774-2.852-.005-3.675-.37-.391-.861-.586-1.333-.676a5.243 5.243 0 0 0-1.447-.044c-.173.016-.393-.073-.54-.257-.145-.18-.127-.316-.082-.392l.393-.672L14.287 3h5.71c1.536 0 2.499 1.659 1.737 2.992l-7.997 13.996c-.768 1.344-2.706 1.344-3.473 0l-3.037-5.314 1.377-2.278.004-.006.004-.007.481-.831Z',
                    0.6
                ]
            ]
        }
    }, options);
}


// Composables
// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
// Composables
// Composables
// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
function $97b67326d41c53e5$export$fa3cd679bf7c4ed(source, fn) {
    let scope;
    function start() {
        scope = (0, $01W3b.effectScope)();
        scope.run(()=>fn.length ? fn(()=>{
                scope?.stop();
                start();
            }) : fn());
    }
    (0, $01W3b.watch)(source, (active)=>{
        if (active && !scope) start();
        else if (!active) {
            scope?.stop();
            scope = undefined;
        }
    }, {
        immediate: true
    });
    (0, $01W3b.onScopeDispose)(()=>{
        scope?.stop();
    });
}


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

function $9518c0cac3056c0f$export$6f3ae48335514a2(props, prop, defaultValue) {
    let transformIn = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (v)=>v;
    let transformOut = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : (v)=>v;
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useProxiedModel');
    const internal = (0, $01W3b.ref)(props[prop] !== undefined ? props[prop] : defaultValue);
    const kebabProp = (0, $8590040a7833369a$export$73bda83cddbc7187)(prop);
    const checkKebab = kebabProp !== prop;
    const isControlled = checkKebab ? (0, $01W3b.computed)(()=>{
        props[prop];
        return !!((vm.vnode.props?.hasOwnProperty(prop) || vm.vnode.props?.hasOwnProperty(kebabProp)) && (vm.vnode.props?.hasOwnProperty(`onUpdate:${prop}`) || vm.vnode.props?.hasOwnProperty(`onUpdate:${kebabProp}`)));
    }) : (0, $01W3b.computed)(()=>{
        props[prop];
        return !!(vm.vnode.props?.hasOwnProperty(prop) && vm.vnode.props?.hasOwnProperty(`onUpdate:${prop}`));
    });
    (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>!isControlled.value, ()=>{
        (0, $01W3b.watch)(()=>props[prop], (val)=>{
            internal.value = val;
        });
    });
    const model = (0, $01W3b.computed)({
        get () {
            const externalValue = props[prop];
            return transformIn(isControlled.value ? externalValue : internal.value);
        },
        set (internalValue) {
            const newValue = transformOut(internalValue);
            const value = (0, $01W3b.toRaw)(isControlled.value ? props[prop] : internal.value);
            if (value === newValue || transformIn(value) === internalValue) return;
            internal.value = newValue;
            vm?.emit(`update:${prop}`, newValue);
        }
    });
    Object.defineProperty(model, 'externalValue', {
        get: ()=>isControlled.value ? props[prop] : internal.value
    });
    return model;
}


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

var $1a7fe2a2aaceda09$export$2e2bcd8739ae039 = {
    badge: 'Badge',
    open: 'Open',
    close: 'Close',
    dismiss: 'Dismiss',
    confirmEdit: {
        ok: 'OK',
        cancel: 'Cancel'
    },
    dataIterator: {
        noResultsText: 'No matching records found',
        loadingText: 'Loading items...'
    },
    dataTable: {
        itemsPerPageText: 'Rows per page:',
        ariaLabel: {
            sortDescending: 'Sorted descending.',
            sortAscending: 'Sorted ascending.',
            sortNone: 'Not sorted.',
            activateNone: 'Activate to remove sorting.',
            activateDescending: 'Activate to sort descending.',
            activateAscending: 'Activate to sort ascending.'
        },
        sortBy: 'Sort by'
    },
    dataFooter: {
        itemsPerPageText: 'Items per page:',
        itemsPerPageAll: 'All',
        nextPage: 'Next page',
        prevPage: 'Previous page',
        firstPage: 'First page',
        lastPage: 'Last page',
        pageText: '{0}-{1} of {2}'
    },
    dateRangeInput: {
        divider: 'to'
    },
    datePicker: {
        itemsSelected: '{0} selected',
        range: {
            title: 'Select dates',
            header: 'Enter dates'
        },
        title: 'Select date',
        header: 'Enter date',
        input: {
            placeholder: 'Enter date'
        },
        ariaLabel: {
            previousMonth: 'Previous month',
            nextMonth: 'Next month',
            selectYear: 'Select year',
            previousYear: 'Previous year',
            nextYear: 'Next year',
            selectMonth: 'Select month',
            selectDate: '{0}',
            // Full date format
            currentDate: 'Today, {0}'
        }
    },
    noDataText: 'No data available',
    carousel: {
        prev: 'Previous visual',
        next: 'Next visual',
        ariaLabel: {
            delimiter: 'Carousel slide {0} of {1}'
        }
    },
    calendar: {
        moreEvents: '{0} more',
        today: 'Today'
    },
    input: {
        clear: 'Clear {0}',
        prependAction: '{0} prepended action',
        appendAction: '{0} appended action',
        otp: 'Please enter OTP character {0}'
    },
    fileInput: {
        counter: '{0} files',
        counterSize: '{0} files ({1} in total)'
    },
    fileUpload: {
        title: 'Drag and drop files here',
        divider: 'or',
        browse: 'Browse Files'
    },
    timePicker: {
        am: 'AM',
        pm: 'PM',
        title: 'Select Time',
        hour: 'Hour',
        minute: 'Minute',
        second: 'Second',
        notAllowed: 'Value is not allowed'
    },
    pagination: {
        ariaLabel: {
            root: 'Pagination Navigation',
            next: 'Next page',
            previous: 'Previous page',
            page: 'Go to page {0}',
            currentPage: 'Page {0}, Current page',
            first: 'First page',
            last: 'Last page'
        }
    },
    stepper: {
        next: 'Next',
        prev: 'Previous'
    },
    rating: {
        ariaLabel: {
            item: 'Rating {0} of {1}'
        }
    },
    loading: 'Loading...',
    infiniteScroll: {
        loadMore: 'Load more',
        empty: 'No more'
    },
    rules: {
        required: 'This field is required',
        email: 'Please enter a valid email',
        number: 'This field can only contain numbers',
        integer: 'This field can only contain integer values',
        capital: 'This field can only contain uppercase letters',
        maxLength: 'You must enter a maximum of {0} characters',
        minLength: 'You must enter a minimum of {0} characters',
        strictLength: 'The length of the entered field is invalid',
        exclude: 'The {0} character is not allowed',
        notEmpty: 'Please choose at least one value',
        pattern: 'Invalid format'
    },
    command: {
        search: 'Type a command or search...'
    },
    hotkey: {
        then: 'then',
        ctrl: 'Ctrl',
        command: 'Command',
        space: 'Space',
        shift: 'Shift',
        alt: 'Alt',
        enter: 'Enter',
        escape: 'Escape',
        upArrow: 'Up Arrow',
        downArrow: 'Down Arrow',
        leftArrow: 'Left Arrow',
        rightArrow: 'Right Arrow',
        backspace: 'Backspace',
        option: 'Option',
        plus: 'plus',
        shortcut: 'Keyboard shortcut: {0}',
        or: 'or'
    },
    video: {
        play: 'Play',
        pause: 'Pause',
        seek: 'Seek',
        volume: 'Volume',
        showVolume: 'Show volume control',
        mute: 'Mute',
        unmute: 'Unmute',
        enterFullscreen: 'Full screen',
        exitFullscreen: 'Exit full screen'
    },
    colorPicker: {
        ariaLabel: {
            eyedropper: 'Select color with eyedropper',
            hueSlider: 'Hue',
            alphaSlider: 'Alpha',
            redInput: 'Red value',
            greenInput: 'Green value',
            blueInput: 'Blue value',
            alphaInput: 'Alpha value',
            hueInput: 'Hue value',
            saturationInput: 'Saturation value',
            lightnessInput: 'Lightness value',
            hexInput: 'HEX value',
            hexaInput: 'HEX with alpha value',
            changeFormat: 'Change color format'
        }
    }
};


const $5412efe615a57cb0$var$LANG_PREFIX = '$vuetify.';
const $5412efe615a57cb0$var$replace = (str, params)=>{
    return str.replace(/\{(\d+)\}/g, (match, index)=>{
        return String(params[Number(index)]);
    });
};
const $5412efe615a57cb0$var$createTranslateFunction = (current, fallback, messages)=>{
    return function(key) {
        for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
        if (!key.startsWith($5412efe615a57cb0$var$LANG_PREFIX)) return $5412efe615a57cb0$var$replace(key, params);
        const shortKey = key.replace($5412efe615a57cb0$var$LANG_PREFIX, '');
        const currentLocale = current.value && messages.value[current.value];
        const fallbackLocale = fallback.value && messages.value[fallback.value];
        let str = (0, $8590040a7833369a$export$f5474208cafa7b66)(currentLocale, shortKey, null);
        if (!str) {
            (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`Translation key "${key}" not found in "${current.value}", trying fallback locale`);
            str = (0, $8590040a7833369a$export$f5474208cafa7b66)(fallbackLocale, shortKey, null);
        }
        if (!str) {
            (0, $5384ffc78a9e124c$export$bf36f23bad3e1069)(`Translation key "${key}" not found in fallback`);
            str = key;
        }
        if (typeof str !== 'string') {
            (0, $5384ffc78a9e124c$export$bf36f23bad3e1069)(`Translation key "${key}" has a non-string value`);
            str = key;
        }
        return $5412efe615a57cb0$var$replace(str, params);
    };
};
function $5412efe615a57cb0$var$createNumberFunction(current, fallback) {
    return (value, options)=>{
        const numberFormat = new Intl.NumberFormat([
            current.value,
            fallback.value
        ], options);
        return numberFormat.format(value);
    };
}
function $5412efe615a57cb0$var$inferDecimalSeparator(current, fallback) {
    const format = $5412efe615a57cb0$var$createNumberFunction(current, fallback);
    return format(0.1).includes(',') ? ',' : '.';
}
function $5412efe615a57cb0$var$useProvided(props, prop, provided) {
    const internal = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, prop, props[prop] ?? provided.value);
    // TODO: Remove when defaultValue works
    internal.value = props[prop] ?? provided.value;
    (0, $01W3b.watch)(provided, (v)=>{
        if (props[prop] == null) internal.value = provided.value;
    });
    return internal;
}
function $5412efe615a57cb0$var$createProvideFunction(state) {
    return (props)=>{
        const current = $5412efe615a57cb0$var$useProvided(props, 'locale', state.current);
        const fallback = $5412efe615a57cb0$var$useProvided(props, 'fallback', state.fallback);
        const messages = $5412efe615a57cb0$var$useProvided(props, 'messages', state.messages);
        return {
            name: 'vuetify',
            current: current,
            fallback: fallback,
            messages: messages,
            decimalSeparator: (0, $01W3b.toRef)(()=>$5412efe615a57cb0$var$inferDecimalSeparator(current, fallback)),
            t: $5412efe615a57cb0$var$createTranslateFunction(current, fallback, messages),
            n: $5412efe615a57cb0$var$createNumberFunction(current, fallback),
            provide: $5412efe615a57cb0$var$createProvideFunction({
                current: current,
                fallback: fallback,
                messages: messages
            })
        };
    };
}
function $5412efe615a57cb0$export$237d5ea61ba0121d(options) {
    const current = (0, $01W3b.shallowRef)(options?.locale ?? 'en');
    const fallback = (0, $01W3b.shallowRef)(options?.fallback ?? 'en');
    const messages = (0, $01W3b.ref)({
        en: $1a7fe2a2aaceda09$export$2e2bcd8739ae039,
        ...options?.messages
    });
    return {
        name: 'vuetify',
        current: current,
        fallback: fallback,
        messages: messages,
        decimalSeparator: (0, $01W3b.toRef)(()=>options?.decimalSeparator ?? $5412efe615a57cb0$var$inferDecimalSeparator(current, fallback)),
        t: $5412efe615a57cb0$var$createTranslateFunction(current, fallback, messages),
        n: $5412efe615a57cb0$var$createNumberFunction(current, fallback),
        provide: $5412efe615a57cb0$var$createProvideFunction({
            current: current,
            fallback: fallback,
            messages: messages
        })
    };
}


const $13e23564052bdddd$export$36c469862c41ebd3 = Symbol.for('vuetify:locale');
function $13e23564052bdddd$var$isLocaleInstance(obj) {
    return obj.name != null;
}
function $13e23564052bdddd$export$9af58f1cfd1fbeb4(options) {
    const i18n = options?.adapter && $13e23564052bdddd$var$isLocaleInstance(options?.adapter) ? options?.adapter : (0, $5412efe615a57cb0$export$237d5ea61ba0121d)(options);
    const rtl = $13e23564052bdddd$export$c160809e625ae6e9(i18n, options);
    return {
        ...i18n,
        ...rtl
    };
}
function $13e23564052bdddd$export$43bb16f9c6d9e3f7() {
    const locale = (0, $TusQn.inject)($13e23564052bdddd$export$36c469862c41ebd3);
    if (!locale) throw new Error('[Vuetify] Could not find injected locale instance');
    return locale;
}
function $13e23564052bdddd$export$4e518c250eba4aac(props) {
    const locale = (0, $TusQn.inject)($13e23564052bdddd$export$36c469862c41ebd3);
    if (!locale) throw new Error('[Vuetify] Could not find injected locale instance');
    const i18n = locale.provide(props);
    const rtl = $13e23564052bdddd$export$10d7c3ce240853fd(i18n, locale.rtl, props);
    const data = {
        ...i18n,
        ...rtl
    };
    (0, $TusQn.provide)($13e23564052bdddd$export$36c469862c41ebd3, data);
    return data;
}
const $13e23564052bdddd$export$c982f8cf16d318ef = Symbol.for('vuetify:rtl');
function $13e23564052bdddd$var$genDefaults() {
    return {
        af: false,
        ar: true,
        bg: false,
        ca: false,
        ckb: false,
        cs: false,
        de: false,
        el: false,
        en: false,
        es: false,
        et: false,
        fa: true,
        fi: false,
        fr: false,
        hr: false,
        hu: false,
        he: true,
        id: false,
        it: false,
        ja: false,
        km: false,
        ko: false,
        lv: false,
        lt: false,
        nl: false,
        no: false,
        pl: false,
        pt: false,
        ro: false,
        ru: false,
        sk: false,
        sl: false,
        srCyrl: false,
        srLatn: false,
        sv: false,
        th: false,
        tr: false,
        az: false,
        uk: false,
        vi: false,
        zhHans: false,
        zhHant: false
    };
}
function $13e23564052bdddd$export$c160809e625ae6e9(i18n, options) {
    const rtl = (0, $01W3b.ref)(options?.rtl ?? $13e23564052bdddd$var$genDefaults());
    const isRtl = (0, $01W3b.computed)(()=>rtl.value[i18n.current.value] ?? false);
    return {
        isRtl: isRtl,
        rtl: rtl,
        rtlClasses: (0, $01W3b.toRef)(()=>`v-locale--is-${isRtl.value ? 'rtl' : 'ltr'}`)
    };
}
function $13e23564052bdddd$export$10d7c3ce240853fd(locale, rtl, props) {
    const isRtl = (0, $01W3b.computed)(()=>props.rtl ?? rtl.value[locale.current.value] ?? false);
    return {
        isRtl: isRtl,
        rtl: rtl,
        rtlClasses: (0, $01W3b.toRef)(()=>`v-locale--is-${isRtl.value ? 'rtl' : 'ltr'}`)
    };
}
function $13e23564052bdddd$export$b2dd014b6c321cb() {
    const locale = (0, $TusQn.inject)($13e23564052bdddd$export$36c469862c41ebd3);
    if (!locale) throw new Error('[Vuetify] Could not find injected rtl instance');
    return {
        isRtl: locale.isRtl,
        rtlClasses: locale.rtlClasses
    };
}


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

// Utilities

function $3b4e4640ef333cff$var$weekInfo(locale) {
    // https://simplelocalize.io/data/locales/
    // then `new Intl.Locale(...).getWeekInfo()`
    const code = locale.slice(-2).toUpperCase();
    switch(true){
        case locale === 'GB-alt-variant':
            return {
                firstDay: 0,
                firstWeekSize: 4
            };
        case locale === '001':
            return {
                firstDay: 1,
                firstWeekSize: 1
            };
        case `AG AS BD BR BS BT BW BZ CA CO DM DO ET GT GU HK HN ID IL IN JM JP KE
    KH KR LA MH MM MO MT MX MZ NI NP PA PE PH PK PR PY SA SG SV TH TT TW UM US
    VE VI WS YE ZA ZW`.includes(code):
            return {
                firstDay: 0,
                firstWeekSize: 1
            };
        case `AI AL AM AR AU AZ BA BM BN BY CL CM CN CR CY EC GE HR KG KZ LB LK LV
    MD ME MK MN MY NZ RO RS SI TJ TM TR UA UY UZ VN XK`.includes(code):
            return {
                firstDay: 1,
                firstWeekSize: 1
            };
        case `AD AN AT AX BE BG CH CZ DE DK EE ES FI FJ FO FR GB GF GP GR HU IE IS
    IT LI LT LU MC MQ NL NO PL RE RU SE SK SM VA`.includes(code):
            return {
                firstDay: 1,
                firstWeekSize: 4
            };
        case `AE AF BH DJ DZ EG IQ IR JO KW LY OM QA SD SY`.includes(code):
            return {
                firstDay: 6,
                firstWeekSize: 1
            };
        case code === 'MV':
            return {
                firstDay: 5,
                firstWeekSize: 1
            };
        case code === 'PT':
            return {
                firstDay: 0,
                firstWeekSize: 4
            };
        default:
            return null;
    }
}
function $3b4e4640ef333cff$var$getWeekArray(date, locale, firstDayOfWeek) {
    const weeks = [];
    let currentWeek = [];
    const firstDayOfMonth = $3b4e4640ef333cff$var$startOfMonth(date);
    const lastDayOfMonth = $3b4e4640ef333cff$var$endOfMonth(date);
    const first = firstDayOfWeek ?? $3b4e4640ef333cff$var$weekInfo(locale)?.firstDay ?? 0;
    const firstDayWeekIndex = (firstDayOfMonth.getDay() - first + 7) % 7;
    const lastDayWeekIndex = (lastDayOfMonth.getDay() - first + 7) % 7;
    for(let i = 0; i < firstDayWeekIndex; i++){
        const adjacentDay = new Date(firstDayOfMonth);
        adjacentDay.setDate(adjacentDay.getDate() - (firstDayWeekIndex - i));
        currentWeek.push(adjacentDay);
    }
    for(let i = 1; i <= lastDayOfMonth.getDate(); i++){
        const day = new Date(date.getFullYear(), date.getMonth(), i);
        // Add the day to the current week
        currentWeek.push(day);
        // If the current week has 7 days, add it to the weeks array and start a new week
        if (currentWeek.length === 7) {
            weeks.push(currentWeek);
            currentWeek = [];
        }
    }
    for(let i = 1; i < 7 - lastDayWeekIndex; i++){
        const adjacentDay = new Date(lastDayOfMonth);
        adjacentDay.setDate(adjacentDay.getDate() + i);
        currentWeek.push(adjacentDay);
    }
    if (currentWeek.length > 0) weeks.push(currentWeek);
    return weeks;
}
function $3b4e4640ef333cff$var$startOfWeek(date, locale, firstDayOfWeek) {
    let day = (firstDayOfWeek ?? $3b4e4640ef333cff$var$weekInfo(locale)?.firstDay ?? 0) % 7;
    // prevent infinite loop
    if (![
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].includes(day)) {
        (0, $5384ffc78a9e124c$export$222ba5e7254f2402)('Invalid firstDayOfWeek, expected discrete number in range [0-6]');
        day = 0;
    }
    const d = new Date(date);
    while(d.getDay() !== day)d.setDate(d.getDate() - 1);
    return d;
}
function $3b4e4640ef333cff$var$endOfWeek(date, locale) {
    const d = new Date(date);
    const lastDay = (($3b4e4640ef333cff$var$weekInfo(locale)?.firstDay ?? 0) + 6) % 7;
    while(d.getDay() !== lastDay)d.setDate(d.getDate() + 1);
    return d;
}
function $3b4e4640ef333cff$var$startOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 1);
}
function $3b4e4640ef333cff$var$endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}
function $3b4e4640ef333cff$var$parseLocalDate(value) {
    const parts = value.split('-').map(Number);
    // new Date() uses local time zone when passing individual date component values
    return new Date(parts[0], parts[1] - 1, parts[2]);
}
const $3b4e4640ef333cff$var$_YYYMMDD = /^([12]\d{3}-([1-9]|0[1-9]|1[0-2])-([1-9]|0[1-9]|[12]\d|3[01]))$/;
function $3b4e4640ef333cff$var$date(value) {
    if (value == null) return new Date();
    if (value instanceof Date) return value;
    if (typeof value === 'string') {
        let parsed;
        if ($3b4e4640ef333cff$var$_YYYMMDD.test(value)) return $3b4e4640ef333cff$var$parseLocalDate(value);
        else parsed = Date.parse(value);
        if (!isNaN(parsed)) return new Date(parsed);
    }
    return null;
}
const $3b4e4640ef333cff$var$sundayJanuarySecond2000 = new Date(2000, 0, 2);
function $3b4e4640ef333cff$var$getWeekdays(locale, firstDayOfWeek, weekdayFormat) {
    const daysFromSunday = firstDayOfWeek ?? $3b4e4640ef333cff$var$weekInfo(locale)?.firstDay ?? 0;
    return (0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(7).map((i)=>{
        const weekday = new Date($3b4e4640ef333cff$var$sundayJanuarySecond2000);
        weekday.setDate($3b4e4640ef333cff$var$sundayJanuarySecond2000.getDate() + daysFromSunday + i);
        return new Intl.DateTimeFormat(locale, {
            weekday: weekdayFormat ?? 'narrow'
        }).format(weekday);
    });
}
function $3b4e4640ef333cff$var$format(value, formatString, locale, formats) {
    const newDate = $3b4e4640ef333cff$var$date(value) ?? new Date();
    const customFormat = formats?.[formatString];
    if (typeof customFormat === 'function') return customFormat(newDate, formatString, locale);
    let options = {};
    switch(formatString){
        case 'fullDate':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
            };
            break;
        case 'fullDateWithWeekday':
            options = {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            };
            break;
        case 'normalDate':
            const day = newDate.getDate();
            const month = new Intl.DateTimeFormat(locale, {
                month: 'long'
            }).format(newDate);
            return `${day} ${month}`;
        case 'normalDateWithWeekday':
            options = {
                weekday: 'short',
                day: 'numeric',
                month: 'short'
            };
            break;
        case 'shortDate':
            options = {
                month: 'short',
                day: 'numeric'
            };
            break;
        case 'year':
            options = {
                year: 'numeric'
            };
            break;
        case 'month':
            options = {
                month: 'long'
            };
            break;
        case 'monthShort':
            options = {
                month: 'short'
            };
            break;
        case 'monthAndYear':
            options = {
                month: 'long',
                year: 'numeric'
            };
            break;
        case 'monthAndDate':
            options = {
                month: 'long',
                day: 'numeric'
            };
            break;
        case 'weekday':
            options = {
                weekday: 'long'
            };
            break;
        case 'weekdayShort':
            options = {
                weekday: 'short'
            };
            break;
        case 'dayOfMonth':
            return new Intl.NumberFormat(locale).format(newDate.getDate());
        case 'hours12h':
            options = {
                hour: 'numeric',
                hour12: true
            };
            break;
        case 'hours24h':
            options = {
                hour: 'numeric',
                hour12: false
            };
            break;
        case 'minutes':
            options = {
                minute: 'numeric'
            };
            break;
        case 'seconds':
            options = {
                second: 'numeric'
            };
            break;
        case 'fullTime':
            options = {
                hour: 'numeric',
                minute: 'numeric'
            };
            break;
        case 'fullTime12h':
            options = {
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };
            break;
        case 'fullTime24h':
            options = {
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            };
            break;
        case 'fullDateTime':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric'
            };
            break;
        case 'fullDateTime12h':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };
            break;
        case 'fullDateTime24h':
            options = {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            };
            break;
        case 'keyboardDate':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            break;
        case 'keyboardDateTime':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric'
            };
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
        case 'keyboardDateTime12h':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                hour12: true
            };
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
        case 'keyboardDateTime24h':
            options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: 'numeric',
                minute: 'numeric',
                hour12: false
            };
            return new Intl.DateTimeFormat(locale, options).format(newDate).replace(/, /g, ' ');
        default:
            options = customFormat ?? {
                timeZone: 'UTC',
                timeZoneName: 'short'
            };
    }
    return new Intl.DateTimeFormat(locale, options).format(newDate);
}
function $3b4e4640ef333cff$var$toISO(adapter, value) {
    const date = adapter.toJsDate(value);
    const year = date.getFullYear();
    const month = (0, $8590040a7833369a$export$36cf564d487b5178)(String(date.getMonth() + 1), 2, '0');
    const day = (0, $8590040a7833369a$export$36cf564d487b5178)(String(date.getDate()), 2, '0');
    return `${year}-${month}-${day}`;
}
function $3b4e4640ef333cff$var$parseISO(value) {
    const [year, month, day] = value.split('-').map(Number);
    return new Date(year, month - 1, day);
}
function $3b4e4640ef333cff$var$addMinutes(date, amount) {
    const d = new Date(date);
    d.setMinutes(d.getMinutes() + amount);
    return d;
}
function $3b4e4640ef333cff$var$addHours(date, amount) {
    const d = new Date(date);
    d.setHours(d.getHours() + amount);
    return d;
}
function $3b4e4640ef333cff$var$addDays(date, amount) {
    const d = new Date(date);
    d.setDate(d.getDate() + amount);
    return d;
}
function $3b4e4640ef333cff$var$addWeeks(date, amount) {
    const d = new Date(date);
    d.setDate(d.getDate() + amount * 7);
    return d;
}
function $3b4e4640ef333cff$var$addMonths(date, amount) {
    const d = new Date(date);
    d.setDate(1);
    d.setMonth(d.getMonth() + amount);
    return d;
}
function $3b4e4640ef333cff$var$getYear(date) {
    return date.getFullYear();
}
function $3b4e4640ef333cff$var$getMonth(date) {
    return date.getMonth();
}
function $3b4e4640ef333cff$var$getWeek(date, locale, firstDayOfWeek, firstDayOfYear) {
    const weekInfoFromLocale = $3b4e4640ef333cff$var$weekInfo(locale);
    const weekStart = firstDayOfWeek ?? weekInfoFromLocale?.firstDay ?? 0;
    const minWeekSize = weekInfoFromLocale?.firstWeekSize ?? 1;
    return firstDayOfYear !== undefined ? $3b4e4640ef333cff$var$calculateWeekWithFirstDayOfYear(date, locale, weekStart, firstDayOfYear) : $3b4e4640ef333cff$var$calculateWeekWithMinWeekSize(date, locale, weekStart, minWeekSize);
}
function $3b4e4640ef333cff$var$calculateWeekWithFirstDayOfYear(date, locale, weekStart, firstDayOfYear) {
    const firstDayOfYearOffset = (7 + firstDayOfYear - weekStart) % 7;
    const currentWeekStart = $3b4e4640ef333cff$var$startOfWeek(date, locale, weekStart);
    const currentWeekEnd = $3b4e4640ef333cff$var$addDays(currentWeekStart, 6);
    function yearStartWeekdayOffset(year) {
        return (7 + new Date(year, 0, 1).getDay() - weekStart) % 7;
    }
    let year = $3b4e4640ef333cff$var$getYear(currentWeekStart);
    if (year < $3b4e4640ef333cff$var$getYear(currentWeekEnd) && yearStartWeekdayOffset(year + 1) <= firstDayOfYearOffset) year++;
    const yearStart = new Date(year, 0, 1);
    const offset = yearStartWeekdayOffset(year);
    const d1w1 = offset <= firstDayOfYearOffset ? $3b4e4640ef333cff$var$addDays(yearStart, -offset) : $3b4e4640ef333cff$var$addDays(yearStart, 7 - offset);
    return 1 + $3b4e4640ef333cff$var$getDiff($3b4e4640ef333cff$var$endOfDay(currentWeekStart), $3b4e4640ef333cff$var$startOfDay(d1w1), 'weeks');
}
function $3b4e4640ef333cff$var$calculateWeekWithMinWeekSize(date, locale, weekStart, minWeekSize) {
    const currentWeekStart = $3b4e4640ef333cff$var$startOfWeek(date, locale, weekStart);
    const currentWeekEnd = $3b4e4640ef333cff$var$addDays($3b4e4640ef333cff$var$startOfWeek(date, locale, weekStart), 6);
    function firstWeekSize(year) {
        const yearStart = new Date(year, 0, 1);
        return 7 - $3b4e4640ef333cff$var$getDiff(yearStart, $3b4e4640ef333cff$var$startOfWeek(yearStart, locale, weekStart), 'days');
    }
    let year = $3b4e4640ef333cff$var$getYear(currentWeekStart);
    if (year < $3b4e4640ef333cff$var$getYear(currentWeekEnd) && firstWeekSize(year + 1) >= minWeekSize) year++;
    const yearStart = new Date(year, 0, 1);
    const size = firstWeekSize(year);
    const d1w1 = size >= minWeekSize ? $3b4e4640ef333cff$var$addDays(yearStart, size - 7) : $3b4e4640ef333cff$var$addDays(yearStart, size);
    return 1 + $3b4e4640ef333cff$var$getDiff($3b4e4640ef333cff$var$endOfDay(currentWeekStart), $3b4e4640ef333cff$var$startOfDay(d1w1), 'weeks');
}
function $3b4e4640ef333cff$var$getDate(date) {
    return date.getDate();
}
function $3b4e4640ef333cff$var$getNextMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() + 1, 1);
}
function $3b4e4640ef333cff$var$getPreviousMonth(date) {
    return new Date(date.getFullYear(), date.getMonth() - 1, 1);
}
function $3b4e4640ef333cff$var$getHours(date) {
    return date.getHours();
}
function $3b4e4640ef333cff$var$getMinutes(date) {
    return date.getMinutes();
}
function $3b4e4640ef333cff$var$startOfYear(date) {
    return new Date(date.getFullYear(), 0, 1);
}
function $3b4e4640ef333cff$var$endOfYear(date) {
    return new Date(date.getFullYear(), 11, 31);
}
function $3b4e4640ef333cff$var$isWithinRange(date, range) {
    return $3b4e4640ef333cff$var$isAfter(date, range[0]) && $3b4e4640ef333cff$var$isBefore(date, range[1]);
}
function $3b4e4640ef333cff$var$isValid(date) {
    const d = new Date(date);
    return d instanceof Date && !isNaN(d.getTime());
}
function $3b4e4640ef333cff$var$isAfter(date, comparing) {
    return date.getTime() > comparing.getTime();
}
function $3b4e4640ef333cff$var$isAfterDay(date, comparing) {
    return $3b4e4640ef333cff$var$isAfter($3b4e4640ef333cff$var$startOfDay(date), $3b4e4640ef333cff$var$startOfDay(comparing));
}
function $3b4e4640ef333cff$var$isBefore(date, comparing) {
    return date.getTime() < comparing.getTime();
}
function $3b4e4640ef333cff$var$isEqual(date, comparing) {
    return date.getTime() === comparing.getTime();
}
function $3b4e4640ef333cff$var$isSameDay(date, comparing) {
    return date.getDate() === comparing.getDate() && date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
}
function $3b4e4640ef333cff$var$isSameMonth(date, comparing) {
    return date.getMonth() === comparing.getMonth() && date.getFullYear() === comparing.getFullYear();
}
function $3b4e4640ef333cff$var$isSameYear(date, comparing) {
    return date.getFullYear() === comparing.getFullYear();
}
function $3b4e4640ef333cff$var$getDiff(date, comparing, unit) {
    const d = new Date(date);
    const c = new Date(comparing);
    switch(unit){
        case 'years':
            return d.getFullYear() - c.getFullYear();
        case 'quarters':
            return Math.floor((d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12) / 4);
        case 'months':
            return d.getMonth() - c.getMonth() + (d.getFullYear() - c.getFullYear()) * 12;
        case 'weeks':
            return Math.floor((d.getTime() - c.getTime()) / 604800000);
        case 'days':
            return Math.floor((d.getTime() - c.getTime()) / 86400000);
        case 'hours':
            return Math.floor((d.getTime() - c.getTime()) / 3600000);
        case 'minutes':
            return Math.floor((d.getTime() - c.getTime()) / 60000);
        case 'seconds':
            return Math.floor((d.getTime() - c.getTime()) / 1000);
        default:
            return d.getTime() - c.getTime();
    }
}
function $3b4e4640ef333cff$var$setHours(date, count) {
    const d = new Date(date);
    d.setHours(count);
    return d;
}
function $3b4e4640ef333cff$var$setMinutes(date, count) {
    const d = new Date(date);
    d.setMinutes(count);
    return d;
}
function $3b4e4640ef333cff$var$setMonth(date, count) {
    const d = new Date(date);
    d.setMonth(count);
    return d;
}
function $3b4e4640ef333cff$var$setDate(date, day) {
    const d = new Date(date);
    d.setDate(day);
    return d;
}
function $3b4e4640ef333cff$var$setYear(date, year) {
    const d = new Date(date);
    d.setFullYear(year);
    return d;
}
function $3b4e4640ef333cff$var$startOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
}
function $3b4e4640ef333cff$var$endOfDay(date) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
}
class $3b4e4640ef333cff$export$de9f337e316457b5 {
    constructor(options){
        this.locale = options.locale;
        this.formats = options.formats;
    }
    date(value) {
        return $3b4e4640ef333cff$var$date(value);
    }
    toJsDate(date) {
        return date;
    }
    toISO(date) {
        return $3b4e4640ef333cff$var$toISO(this, date);
    }
    parseISO(date) {
        return $3b4e4640ef333cff$var$parseISO(date);
    }
    addMinutes(date, amount) {
        return $3b4e4640ef333cff$var$addMinutes(date, amount);
    }
    addHours(date, amount) {
        return $3b4e4640ef333cff$var$addHours(date, amount);
    }
    addDays(date, amount) {
        return $3b4e4640ef333cff$var$addDays(date, amount);
    }
    addWeeks(date, amount) {
        return $3b4e4640ef333cff$var$addWeeks(date, amount);
    }
    addMonths(date, amount) {
        return $3b4e4640ef333cff$var$addMonths(date, amount);
    }
    getWeekArray(date, firstDayOfWeek) {
        const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
        return $3b4e4640ef333cff$var$getWeekArray(date, this.locale, firstDay);
    }
    startOfWeek(date, firstDayOfWeek) {
        const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
        return $3b4e4640ef333cff$var$startOfWeek(date, this.locale, firstDay);
    }
    endOfWeek(date) {
        return $3b4e4640ef333cff$var$endOfWeek(date, this.locale);
    }
    startOfMonth(date) {
        return $3b4e4640ef333cff$var$startOfMonth(date);
    }
    endOfMonth(date) {
        return $3b4e4640ef333cff$var$endOfMonth(date);
    }
    format(date, formatString) {
        return $3b4e4640ef333cff$var$format(date, formatString, this.locale, this.formats);
    }
    isEqual(date, comparing) {
        return $3b4e4640ef333cff$var$isEqual(date, comparing);
    }
    isValid(date) {
        return $3b4e4640ef333cff$var$isValid(date);
    }
    isWithinRange(date, range) {
        return $3b4e4640ef333cff$var$isWithinRange(date, range);
    }
    isAfter(date, comparing) {
        return $3b4e4640ef333cff$var$isAfter(date, comparing);
    }
    isAfterDay(date, comparing) {
        return $3b4e4640ef333cff$var$isAfterDay(date, comparing);
    }
    isBefore(date, comparing) {
        return !$3b4e4640ef333cff$var$isAfter(date, comparing) && !$3b4e4640ef333cff$var$isEqual(date, comparing);
    }
    isSameDay(date, comparing) {
        return $3b4e4640ef333cff$var$isSameDay(date, comparing);
    }
    isSameMonth(date, comparing) {
        return $3b4e4640ef333cff$var$isSameMonth(date, comparing);
    }
    isSameYear(date, comparing) {
        return $3b4e4640ef333cff$var$isSameYear(date, comparing);
    }
    setMinutes(date, count) {
        return $3b4e4640ef333cff$var$setMinutes(date, count);
    }
    setHours(date, count) {
        return $3b4e4640ef333cff$var$setHours(date, count);
    }
    setMonth(date, count) {
        return $3b4e4640ef333cff$var$setMonth(date, count);
    }
    setDate(date, day) {
        return $3b4e4640ef333cff$var$setDate(date, day);
    }
    setYear(date, year) {
        return $3b4e4640ef333cff$var$setYear(date, year);
    }
    getDiff(date, comparing, unit) {
        return $3b4e4640ef333cff$var$getDiff(date, comparing, unit);
    }
    getWeekdays(firstDayOfWeek, weekdayFormat) {
        const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
        return $3b4e4640ef333cff$var$getWeekdays(this.locale, firstDay, weekdayFormat);
    }
    getYear(date) {
        return $3b4e4640ef333cff$var$getYear(date);
    }
    getMonth(date) {
        return $3b4e4640ef333cff$var$getMonth(date);
    }
    getWeek(date, firstDayOfWeek, firstDayOfYear) {
        const firstDay = firstDayOfWeek !== undefined ? Number(firstDayOfWeek) : undefined;
        const firstWeekStart = firstDayOfYear !== undefined ? Number(firstDayOfYear) : undefined;
        return $3b4e4640ef333cff$var$getWeek(date, this.locale, firstDay, firstWeekStart);
    }
    getDate(date) {
        return $3b4e4640ef333cff$var$getDate(date);
    }
    getNextMonth(date) {
        return $3b4e4640ef333cff$var$getNextMonth(date);
    }
    getPreviousMonth(date) {
        return $3b4e4640ef333cff$var$getPreviousMonth(date);
    }
    getHours(date) {
        return $3b4e4640ef333cff$var$getHours(date);
    }
    getMinutes(date) {
        return $3b4e4640ef333cff$var$getMinutes(date);
    }
    startOfDay(date) {
        return $3b4e4640ef333cff$var$startOfDay(date);
    }
    endOfDay(date) {
        return $3b4e4640ef333cff$var$endOfDay(date);
    }
    startOfYear(date) {
        return $3b4e4640ef333cff$var$startOfYear(date);
    }
    endOfYear(date) {
        return $3b4e4640ef333cff$var$endOfYear(date);
    }
}


let $917deb9c892fd486$export$f5446553d2f72d7;
const $917deb9c892fd486$export$ee409445cb0eea8f = Symbol.for('vuetify:date-options');
const $917deb9c892fd486$export$77c3d555e2fd633c = Symbol.for('vuetify:date-adapter');
function $917deb9c892fd486$export$e029667a62135fd0(options, locale) {
    const _options = (0, $8590040a7833369a$export$dd702b3c8240390c)({
        adapter: (0, $3b4e4640ef333cff$export$de9f337e316457b5),
        locale: {
            af: 'af-ZA',
            // ar: '', # not the same value for all variants
            bg: 'bg-BG',
            ca: 'ca-ES',
            ckb: '',
            cs: 'cs-CZ',
            de: 'de-DE',
            el: 'el-GR',
            en: 'en-US',
            // es: '', # not the same value for all variants
            et: 'et-EE',
            fa: 'fa-IR',
            fi: 'fi-FI',
            // fr: '', #not the same value for all variants
            hr: 'hr-HR',
            hu: 'hu-HU',
            he: 'he-IL',
            id: 'id-ID',
            it: 'it-IT',
            ja: 'ja-JP',
            ko: 'ko-KR',
            lv: 'lv-LV',
            lt: 'lt-LT',
            nl: 'nl-NL',
            no: 'no-NO',
            pl: 'pl-PL',
            pt: 'pt-PT',
            ro: 'ro-RO',
            ru: 'ru-RU',
            sk: 'sk-SK',
            sl: 'sl-SI',
            srCyrl: 'sr-SP',
            srLatn: 'sr-SP',
            sv: 'sv-SE',
            th: 'th-TH',
            tr: 'tr-TR',
            az: 'az-AZ',
            uk: 'uk-UA',
            vi: 'vi-VN',
            zhHans: 'zh-CN',
            zhHant: 'zh-TW'
        }
    }, options);
    return {
        options: _options,
        instance: $917deb9c892fd486$var$createInstance(_options, locale)
    };
}
function $917deb9c892fd486$export$788d03e430c3bd7a(adapter, start, stop) {
    const diff = $917deb9c892fd486$export$32fd2fd703380680(adapter, start, stop);
    const datesInRange = [
        start
    ];
    for(let i = 1; i < diff; i++){
        const nextDate = adapter.addDays(start, i);
        datesInRange.push(nextDate);
    }
    if (stop) datesInRange.push(adapter.endOfDay(stop));
    return datesInRange;
}
function $917deb9c892fd486$export$32fd2fd703380680(adapter, start, stop) {
    const iso = [
        `${adapter.toISO(stop ?? start).split('T')[0]}T00:00:00Z`,
        `${adapter.toISO(start).split('T')[0]}T00:00:00Z`
    ];
    return typeof adapter.date() === 'string' ? adapter.getDiff(iso[0], iso[1], 'days') // for StringDateAdapter
     : adapter.getDiff(adapter.date(iso[0]), adapter.date(iso[1]), 'days');
}
function $917deb9c892fd486$var$createInstance(options, locale) {
    const instance = (0, $01W3b.reactive)(typeof options.adapter === 'function' ? new options.adapter({
        locale: options.locale[locale.current.value] ?? locale.current.value,
        formats: options.formats
    }) : options.adapter);
    (0, $01W3b.watch)(locale.current, (value)=>{
        instance.locale = options.locale[value] ?? value ?? instance.locale;
    });
    return instance;
}
function $917deb9c892fd486$export$e51e224239492327() {
    const options = (0, $TusQn.inject)($917deb9c892fd486$export$ee409445cb0eea8f);
    if (!options) throw new Error('[Vuetify] Could not find injected date options');
    const locale = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
    return $917deb9c892fd486$var$createInstance(options, locale);
}



// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");


const $1444e2cf1a712792$export$d07517a676ce386f = [
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
]; // no xs
const $1444e2cf1a712792$export$9a65027cbda1c19 = Symbol.for('vuetify:display');
const $1444e2cf1a712792$var$defaultDisplayOptions = {
    mobileBreakpoint: 'lg',
    thresholds: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
        xxl: 2560
    }
};
const $1444e2cf1a712792$var$parseDisplayOptions = function() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $1444e2cf1a712792$var$defaultDisplayOptions;
    return (0, $8590040a7833369a$export$dd702b3c8240390c)($1444e2cf1a712792$var$defaultDisplayOptions, options);
};
function $1444e2cf1a712792$var$getClientWidth(ssr) {
    return (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && !ssr ? window.innerWidth : typeof ssr === 'object' && ssr.clientWidth || 0;
}
function $1444e2cf1a712792$var$getClientHeight(ssr) {
    return (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && !ssr ? window.innerHeight : typeof ssr === 'object' && ssr.clientHeight || 0;
}
function $1444e2cf1a712792$var$getPlatform(ssr) {
    const userAgent = (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && !ssr ? window.navigator.userAgent : 'ssr';
    function match(regexp) {
        return Boolean(userAgent.match(regexp));
    }
    const android = match(/android/i);
    const ios = match(/iphone|ipad|ipod/i);
    const cordova = match(/cordova/i);
    const electron = match(/electron/i);
    const chrome = match(/chrome/i);
    const edge = match(/edge/i);
    const firefox = match(/firefox/i);
    const opera = match(/opera/i);
    const win = match(/win/i);
    const mac = match(/mac/i);
    const linux = match(/linux/i);
    return {
        android: android,
        ios: ios,
        cordova: cordova,
        electron: electron,
        chrome: chrome,
        edge: edge,
        firefox: firefox,
        opera: opera,
        win: win,
        mac: mac,
        linux: linux,
        touch: (0, $90a48ad178b943d3$export$a5f9edc0876666e5),
        ssr: userAgent === 'ssr'
    };
}
function $1444e2cf1a712792$export$630b3f7014e81311(options, ssr) {
    const { thresholds: thresholds, mobileBreakpoint: mobileBreakpoint } = $1444e2cf1a712792$var$parseDisplayOptions(options);
    const height = (0, $01W3b.shallowRef)($1444e2cf1a712792$var$getClientHeight(ssr));
    const platform = (0, $01W3b.shallowRef)($1444e2cf1a712792$var$getPlatform(ssr));
    const state = (0, $01W3b.reactive)({});
    const width = (0, $01W3b.shallowRef)($1444e2cf1a712792$var$getClientWidth(ssr));
    function updateSize() {
        height.value = $1444e2cf1a712792$var$getClientHeight();
        width.value = $1444e2cf1a712792$var$getClientWidth();
    }
    function update() {
        updateSize();
        platform.value = $1444e2cf1a712792$var$getPlatform();
    }
    // eslint-disable-next-line max-statements
    (0, $TusQn.watchEffect)(()=>{
        const xs = width.value < thresholds.sm;
        const sm = width.value < thresholds.md && !xs;
        const md = width.value < thresholds.lg && !(sm || xs);
        const lg = width.value < thresholds.xl && !(md || sm || xs);
        const xl = width.value < thresholds.xxl && !(lg || md || sm || xs);
        const xxl = width.value >= thresholds.xxl;
        const name = xs ? 'xs' : sm ? 'sm' : md ? 'md' : lg ? 'lg' : xl ? 'xl' : 'xxl';
        const breakpointValue = typeof mobileBreakpoint === 'number' ? mobileBreakpoint : thresholds[mobileBreakpoint];
        const mobile = width.value < breakpointValue;
        state.xs = xs;
        state.sm = sm;
        state.md = md;
        state.lg = lg;
        state.xl = xl;
        state.xxl = xxl;
        state.smAndUp = !xs;
        state.mdAndUp = !(xs || sm);
        state.lgAndUp = !(xs || sm || md);
        state.xlAndUp = !(xs || sm || md || lg);
        state.smAndDown = !(md || lg || xl || xxl);
        state.mdAndDown = !(lg || xl || xxl);
        state.lgAndDown = !(xl || xxl);
        state.xlAndDown = !xxl;
        state.name = name;
        state.height = height.value;
        state.width = width.value;
        state.mobile = mobile;
        state.mobileBreakpoint = mobileBreakpoint;
        state.platform = platform.value;
        state.thresholds = thresholds;
    });
    if (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) {
        window.addEventListener('resize', updateSize, {
            passive: true
        });
        (0, $01W3b.onScopeDispose)(()=>{
            window.removeEventListener('resize', updateSize);
        }, true);
    }
    return {
        ...(0, $01W3b.toRefs)(state),
        update: update,
        ssr: !!ssr
    };
}
const $1444e2cf1a712792$export$d0badecb383b472a = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    mobile: {
        type: Boolean,
        default: false
    },
    mobileBreakpoint: [
        Number,
        String
    ]
}, 'display');
function $1444e2cf1a712792$export$8406b7efc286d284() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        mobile: null
    };
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    const display = (0, $TusQn.inject)($1444e2cf1a712792$export$9a65027cbda1c19);
    if (!display) throw new Error('Could not find Vuetify display injection');
    const mobile = (0, $01W3b.computed)(()=>{
        if (props.mobile) return true;
        else if (typeof props.mobileBreakpoint === 'number') return display.width.value < props.mobileBreakpoint;
        else if (props.mobileBreakpoint) return display.width.value < display.thresholds.value[props.mobileBreakpoint];
        else if (props.mobile === null) return display.mobile.value;
        else return false;
    });
    const displayClasses = (0, $01W3b.toRef)(()=>{
        if (!name) return {};
        return {
            [`${name}--mobile`]: mobile.value
        };
    });
    return {
        ...display,
        displayClasses: displayClasses,
        mobile: mobile
    };
}


// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");


const $f725c9134abb2fa7$export$bf86e2ccec972a06 = 'cubic-bezier(0.4, 0, 0.2, 1)';
const $f725c9134abb2fa7$export$749971f7490e97da = 'cubic-bezier(0.0, 0, 0.2, 1)'; // Entering
const $f725c9134abb2fa7$export$7b997795cd9fbbcb = 'cubic-bezier(0.4, 0, 1, 1)'; // Leaving
const $f725c9134abb2fa7$export$64de9e3688307961 = {
    linear: (t)=>t,
    easeInQuad: (t)=>t ** 2,
    easeOutQuad: (t)=>t * (2 - t),
    easeInOutQuad: (t)=>t < 0.5 ? 2 * t ** 2 : -1 + (4 - 2 * t) * t,
    easeInCubic: (t)=>t ** 3,
    easeOutCubic: (t)=>--t ** 3 + 1,
    easeInOutCubic: (t)=>t < 0.5 ? 4 * t ** 3 : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    easeInQuart: (t)=>t ** 4,
    easeOutQuart: (t)=>1 - --t ** 4,
    easeInOutQuart: (t)=>t < 0.5 ? 8 * t ** 4 : 1 - 8 * --t ** 4,
    easeInQuint: (t)=>t ** 5,
    easeOutQuint: (t)=>1 + --t ** 5,
    easeInOutQuint: (t)=>t < 0.5 ? 16 * t ** 5 : 1 + 16 * --t ** 5,
    instant: (t)=>1
};
function $f725c9134abb2fa7$export$7b286972b8d8ccbf(source, options) {
    const defaultTransition = {
        duration: 300,
        transition: $f725c9134abb2fa7$export$64de9e3688307961.easeInOutCubic
    };
    let raf = -1;
    const outputRef = (0, $01W3b.shallowRef)((0, $01W3b.toValue)(source));
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(source), async (to)=>{
        cancelAnimationFrame(raf);
        const easing = {
            ...defaultTransition,
            ...(0, $01W3b.toValue)(options)
        };
        await executeTransition(outputRef, outputRef.value, to, easing);
    });
    function executeTransition(out, from, to, options) {
        const startTime = performance.now();
        const ease = (0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)() ? $f725c9134abb2fa7$export$64de9e3688307961.instant : options.transition ?? $f725c9134abb2fa7$export$64de9e3688307961.easeInOutCubic;
        return new Promise((resolve)=>{
            raf = requestAnimationFrame(function step(currentTime) {
                const timeElapsed = currentTime - startTime;
                const progress = timeElapsed / options.duration;
                out.value = from + (to - from) * ease((0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(progress, 0, 1));
                if (progress < 1) raf = requestAnimationFrame(step);
                else {
                    out.value = to;
                    resolve();
                }
            });
        });
    }
    return (0, $01W3b.computed)(()=>outputRef.value);
}


const $63ad461311545872$export$b6ccca179d0dbca4 = Symbol.for('vuetify:goto');
function $63ad461311545872$var$genDefaults() {
    return {
        container: undefined,
        duration: 300,
        layout: false,
        offset: 0,
        easing: 'easeInOutCubic',
        patterns: (0, $f725c9134abb2fa7$export$64de9e3688307961)
    };
}
function $63ad461311545872$var$getContainer(el) {
    return $63ad461311545872$var$getTarget(el) ?? (document.scrollingElement || document.body);
}
function $63ad461311545872$var$getTarget(el) {
    return typeof el === 'string' ? document.querySelector(el) : (0, $8590040a7833369a$export$2bffc57ac06742e2)(el);
}
function $63ad461311545872$var$getOffset(target, horizontal, rtl) {
    if (typeof target === 'number') return horizontal && rtl ? -target : target;
    let el = $63ad461311545872$var$getTarget(target);
    let totalOffset = 0;
    while(el){
        totalOffset += horizontal ? el.offsetLeft : el.offsetTop;
        el = el.offsetParent;
    }
    return totalOffset;
}
function $63ad461311545872$export$68787d8a6f2b811a(options, locale) {
    return {
        rtl: locale.isRtl,
        options: (0, $8590040a7833369a$export$dd702b3c8240390c)($63ad461311545872$var$genDefaults(), options)
    };
}
async function $63ad461311545872$export$3f99968195accfaf(_target, _options, horizontal, goTo) {
    const property = horizontal ? 'scrollLeft' : 'scrollTop';
    const options = (0, $8590040a7833369a$export$dd702b3c8240390c)(goTo?.options ?? $63ad461311545872$var$genDefaults(), _options);
    const rtl = goTo?.rtl.value;
    const target = (typeof _target === 'number' ? _target : $63ad461311545872$var$getTarget(_target)) ?? 0;
    const container = options.container === 'parent' && target instanceof HTMLElement ? target.parentElement : $63ad461311545872$var$getContainer(options.container);
    const ease = (0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)() ? options.patterns.instant : typeof options.easing === 'function' ? options.easing : options.patterns[options.easing];
    if (!ease) throw new TypeError(`Easing function "${options.easing}" not found.`);
    let targetLocation;
    if (typeof target === 'number') targetLocation = $63ad461311545872$var$getOffset(target, horizontal, rtl);
    else {
        targetLocation = $63ad461311545872$var$getOffset(target, horizontal, rtl) - $63ad461311545872$var$getOffset(container, horizontal, rtl);
        if (options.layout) {
            const styles = window.getComputedStyle(target);
            const layoutOffset = styles.getPropertyValue('--v-layout-top');
            if (layoutOffset) targetLocation -= parseInt(layoutOffset, 10);
        }
    }
    targetLocation += options.offset;
    targetLocation = $63ad461311545872$var$clampTarget(container, targetLocation, !!rtl, !!horizontal);
    const startLocation = container[property] ?? 0;
    if (targetLocation === startLocation) return Promise.resolve(targetLocation);
    const startTime = performance.now();
    return new Promise((resolve)=>requestAnimationFrame(function step(currentTime) {
            const timeElapsed = currentTime - startTime;
            const progress = timeElapsed / options.duration;
            const location = Math.floor(startLocation + (targetLocation - startLocation) * ease((0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(progress, 0, 1)));
            container[property] = location;
            // Allow for some jitter if target time has elapsed
            if (progress >= 1 && Math.abs(location - container[property]) < 10) return resolve(targetLocation);
            else if (progress > 2) {
                // The target might not be reachable
                (0, $5384ffc78a9e124c$export$222ba5e7254f2402)('Scroll target is not reachable');
                return resolve(container[property]);
            }
            requestAnimationFrame(step);
        }));
}
function $63ad461311545872$export$427b5df65b729c6() {
    let _options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const goToInstance = (0, $TusQn.inject)($63ad461311545872$export$b6ccca179d0dbca4);
    const { isRtl: isRtl } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
    if (!goToInstance) throw new Error('[Vuetify] Could not find injected goto instance');
    const goTo = {
        ...goToInstance,
        // can be set via VLocaleProvider
        rtl: (0, $01W3b.toRef)(()=>goToInstance.rtl.value || isRtl.value)
    };
    async function go(target, options) {
        return $63ad461311545872$export$3f99968195accfaf(target, (0, $8590040a7833369a$export$dd702b3c8240390c)(_options, options), false, goTo);
    }
    go.horizontal = async (target, options)=>{
        return $63ad461311545872$export$3f99968195accfaf(target, (0, $8590040a7833369a$export$dd702b3c8240390c)(_options, options), true, goTo);
    };
    return go;
}
/**
 * Clamp target value to achieve a smooth scroll animation
 * when the value goes outside the scroll container size
 */ function $63ad461311545872$var$clampTarget(container, value, rtl, horizontal) {
    const { scrollWidth: scrollWidth, scrollHeight: scrollHeight } = container;
    const [containerWidth, containerHeight] = container === document.scrollingElement ? [
        window.innerWidth,
        window.innerHeight
    ] : [
        container.offsetWidth,
        container.offsetHeight
    ];
    let min;
    let max;
    if (horizontal) {
        if (rtl) {
            min = -(scrollWidth - containerWidth);
            max = 0;
        } else {
            min = 0;
            max = scrollWidth - containerWidth;
        }
    } else {
        min = 0;
        max = scrollHeight + -containerHeight;
    }
    return (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(value, min, max);
}




// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
// Utilities
/**
 * WCAG 3.0 APCA perceptual contrast algorithm from https://github.com/Myndex/SAPC-APCA
 * @licence https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 * @see https://www.w3.org/WAI/GL/task-forces/silver/wiki/Visual_Contrast_of_Text_Subgroup
 */ // Types
// MAGICAL NUMBERS
// sRGB Conversion to Relative Luminance (Y)
// Transfer Curve (aka "Gamma") for sRGB linearization
// Simple power curve vs piecewise described in docs
// Essentially, 2.4 best models actual display
// characteristics in combination with the total method
const $79063e0744bbddd4$var$mainTRC = 2.4;
const $79063e0744bbddd4$var$Rco = 0.2126729; // sRGB Red Coefficient (from matrix)
const $79063e0744bbddd4$var$Gco = 0.7151522; // sRGB Green Coefficient (from matrix)
const $79063e0744bbddd4$var$Bco = 0.0721750; // sRGB Blue Coefficient (from matrix)
// For Finding Raw SAPC Contrast from Relative Luminance (Y)
// Constants for SAPC Power Curve Exponents
// One pair for normal text, and one for reverse
// These are the "beating heart" of SAPC
const $79063e0744bbddd4$var$normBG = 0.55;
const $79063e0744bbddd4$var$normTXT = 0.58;
const $79063e0744bbddd4$var$revTXT = 0.57;
const $79063e0744bbddd4$var$revBG = 0.62;
// For Clamping and Scaling Values
const $79063e0744bbddd4$var$blkThrs = 0.03; // Level that triggers the soft black clamp
const $79063e0744bbddd4$var$blkClmp = 1.45; // Exponent for the soft black clamp curve
const $79063e0744bbddd4$var$deltaYmin = 0.0005; // Lint trap
const $79063e0744bbddd4$var$scaleBoW = 1.25; // Scaling for dark text on light
const $79063e0744bbddd4$var$scaleWoB = 1.25; // Scaling for light text on dark
const $79063e0744bbddd4$var$loConThresh = 0.078; // Threshold for new simple offset scale
const $79063e0744bbddd4$var$loConFactor = 12.82051282051282; // = 1/0.078,
const $79063e0744bbddd4$var$loConOffset = 0.06; // The simple offset
const $79063e0744bbddd4$var$loClip = 0.001; // Output clip (lint trap #2)
function $79063e0744bbddd4$export$31c9349e1a210963(text, background) {
    // Linearize sRGB
    const Rtxt = (text.r / 255) ** $79063e0744bbddd4$var$mainTRC;
    const Gtxt = (text.g / 255) ** $79063e0744bbddd4$var$mainTRC;
    const Btxt = (text.b / 255) ** $79063e0744bbddd4$var$mainTRC;
    const Rbg = (background.r / 255) ** $79063e0744bbddd4$var$mainTRC;
    const Gbg = (background.g / 255) ** $79063e0744bbddd4$var$mainTRC;
    const Bbg = (background.b / 255) ** $79063e0744bbddd4$var$mainTRC;
    // Apply the standard coefficients and sum to Y
    let Ytxt = Rtxt * $79063e0744bbddd4$var$Rco + Gtxt * $79063e0744bbddd4$var$Gco + Btxt * $79063e0744bbddd4$var$Bco;
    let Ybg = Rbg * $79063e0744bbddd4$var$Rco + Gbg * $79063e0744bbddd4$var$Gco + Bbg * $79063e0744bbddd4$var$Bco;
    // Soft clamp Y when near black.
    // Now clamping all colors to prevent crossover errors
    if (Ytxt <= $79063e0744bbddd4$var$blkThrs) Ytxt += ($79063e0744bbddd4$var$blkThrs - Ytxt) ** $79063e0744bbddd4$var$blkClmp;
    if (Ybg <= $79063e0744bbddd4$var$blkThrs) Ybg += ($79063e0744bbddd4$var$blkThrs - Ybg) ** $79063e0744bbddd4$var$blkClmp;
    // Return 0 Early for extremely low ∆Y (lint trap #1)
    if (Math.abs(Ybg - Ytxt) < $79063e0744bbddd4$var$deltaYmin) return 0.0;
    // SAPC CONTRAST
    let outputContrast; // For weighted final values
    if (Ybg > Ytxt) {
        // For normal polarity, black text on white
        // Calculate the SAPC contrast value and scale
        const SAPC = (Ybg ** $79063e0744bbddd4$var$normBG - Ytxt ** $79063e0744bbddd4$var$normTXT) * $79063e0744bbddd4$var$scaleBoW;
        // NEW! SAPC SmoothScale™
        // Low Contrast Smooth Scale Rollout to prevent polarity reversal
        // and also a low clip for very low contrasts (lint trap #2)
        // much of this is for very low contrasts, less than 10
        // therefore for most reversing needs, only loConOffset is important
        outputContrast = SAPC < $79063e0744bbddd4$var$loClip ? 0.0 : SAPC < $79063e0744bbddd4$var$loConThresh ? SAPC - SAPC * $79063e0744bbddd4$var$loConFactor * $79063e0744bbddd4$var$loConOffset : SAPC - $79063e0744bbddd4$var$loConOffset;
    } else {
        // For reverse polarity, light text on dark
        // WoB should always return negative value.
        const SAPC = (Ybg ** $79063e0744bbddd4$var$revBG - Ytxt ** $79063e0744bbddd4$var$revTXT) * $79063e0744bbddd4$var$scaleWoB;
        outputContrast = SAPC > -$79063e0744bbddd4$var$loClip ? 0.0 : SAPC > -$79063e0744bbddd4$var$loConThresh ? SAPC - SAPC * $79063e0744bbddd4$var$loConFactor * $79063e0744bbddd4$var$loConOffset : SAPC + $79063e0744bbddd4$var$loConOffset;
    }
    return outputContrast * 100;
}




// Types
const $086b74bf3d3bb44e$var$delta = 0.20689655172413793; // 6÷29
const $086b74bf3d3bb44e$var$cielabForwardTransform = (t)=>t > $086b74bf3d3bb44e$var$delta ** 3 ? Math.cbrt(t) : t / (3 * $086b74bf3d3bb44e$var$delta ** 2) + 4 / 29;
const $086b74bf3d3bb44e$var$cielabReverseTransform = (t)=>t > $086b74bf3d3bb44e$var$delta ? t ** 3 : 3 * $086b74bf3d3bb44e$var$delta ** 2 * (t - 4 / 29);
function $086b74bf3d3bb44e$export$33c70ec5bb47f0fb(xyz) {
    const transform = $086b74bf3d3bb44e$var$cielabForwardTransform;
    const transformedY = transform(xyz[1]);
    return [
        116 * transformedY - 16,
        500 * (transform(xyz[0] / 0.95047) - transformedY),
        200 * (transformedY - transform(xyz[2] / 1.08883))
    ];
}
function $086b74bf3d3bb44e$export$22e8438d63a97037(lab) {
    const transform = $086b74bf3d3bb44e$var$cielabReverseTransform;
    const Ln = (lab[0] + 16) / 116;
    return [
        transform(Ln + lab[1] / 500) * 0.95047,
        transform(Ln),
        transform(Ln - lab[2] / 200) * 1.08883
    ];
}


// Utilities

// For converting XYZ to sRGB
const $0d484a093f8aa8f9$var$srgbForwardMatrix = [
    [
        3.2406,
        -1.5372,
        -0.4986
    ],
    [
        -0.9689,
        1.8758,
        0.0415
    ],
    [
        0.0557,
        -0.204,
        1.0570
    ]
];
// Forward gamma adjust
const $0d484a093f8aa8f9$var$srgbForwardTransform = (C)=>C <= 0.0031308 ? C * 12.92 : 1.055 * C ** (1 / 2.4) - 0.055;
// For converting sRGB to XYZ
const $0d484a093f8aa8f9$var$srgbReverseMatrix = [
    [
        0.4124,
        0.3576,
        0.1805
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.0193,
        0.1192,
        0.9505
    ]
];
// Reverse gamma adjust
const $0d484a093f8aa8f9$var$srgbReverseTransform = (C)=>C <= 0.04045 ? C / 12.92 : ((C + 0.055) / 1.055) ** 2.4;
function $0d484a093f8aa8f9$export$33c70ec5bb47f0fb(xyz) {
    const rgb = Array(3);
    const transform = $0d484a093f8aa8f9$var$srgbForwardTransform;
    const matrix = $0d484a093f8aa8f9$var$srgbForwardMatrix;
    // Matrix transform, then gamma adjustment
    for(let i = 0; i < 3; ++i)// Rescale back to [0, 255]
    rgb[i] = Math.round((0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(transform(matrix[i][0] * xyz[0] + matrix[i][1] * xyz[1] + matrix[i][2] * xyz[2])) * 255);
    return {
        r: rgb[0],
        g: rgb[1],
        b: rgb[2]
    };
}
function $0d484a093f8aa8f9$export$22e8438d63a97037(_ref) {
    let { r: r, g: g, b: b } = _ref;
    const xyz = [
        0,
        0,
        0
    ];
    const transform = $0d484a093f8aa8f9$var$srgbReverseTransform;
    const matrix = $0d484a093f8aa8f9$var$srgbReverseMatrix;
    // Rescale from [0, 255] to [0, 1] then adjust sRGB gamma to linear RGB
    r = transform(r / 255);
    g = transform(g / 255);
    b = transform(b / 255);
    // Matrix color space transform
    for(let i = 0; i < 3; ++i)xyz[i] = matrix[i][0] * r + matrix[i][1] * g + matrix[i][2] * b;
    return xyz;
}


function $44de4fc7c15df730$export$773f39ab8b9369ea(color) {
    return !!color && /^(#|var\(--|(rgb|hsl)a?\()/.test(color);
}
function $44de4fc7c15df730$export$d546aa95bdefc037(color) {
    return $44de4fc7c15df730$export$773f39ab8b9369ea(color) && !/^((rgb|hsl)a?\()?var\(--/.test(color);
}
const $44de4fc7c15df730$var$cssColorRe = /^(?<fn>(?:rgb|hsl)a?)\((?<values>.+)\)/;
const $44de4fc7c15df730$var$mappers = {
    rgb: (r, g, b, a)=>({
            r: r,
            g: g,
            b: b,
            a: a
        }),
    rgba: (r, g, b, a)=>({
            r: r,
            g: g,
            b: b,
            a: a
        }),
    hsl: (h, s, l, a)=>$44de4fc7c15df730$export$7d768da925875d05({
            h: h,
            s: s,
            l: l,
            a: a
        }),
    hsla: (h, s, l, a)=>$44de4fc7c15df730$export$7d768da925875d05({
            h: h,
            s: s,
            l: l,
            a: a
        }),
    hsv: (h, s, v, a)=>$44de4fc7c15df730$export$61dbc3014460e6c3({
            h: h,
            s: s,
            v: v,
            a: a
        }),
    hsva: (h, s, v, a)=>$44de4fc7c15df730$export$61dbc3014460e6c3({
            h: h,
            s: s,
            v: v,
            a: a
        })
};
function $44de4fc7c15df730$export$6e865ea70d7724f(color) {
    if (typeof color === 'number') {
        if (isNaN(color) || color < 0 || color > 0xFFFFFF) // int can't have opacity
        (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`'${color}' is not a valid hex color`);
        return {
            r: (color & 0xFF0000) >> 16,
            g: (color & 0xFF00) >> 8,
            b: color & 0xFF
        };
    } else if (typeof color === 'string' && $44de4fc7c15df730$var$cssColorRe.test(color)) {
        const { groups: groups } = color.match($44de4fc7c15df730$var$cssColorRe);
        const { fn: fn, values: values } = groups;
        const realValues = values.split(/,\s*|\s*\/\s*|\s+/).map((v, i)=>{
            if (v.endsWith('%') || // unitless slv are %
            i > 0 && i < 3 && [
                'hsl',
                'hsla',
                'hsv',
                'hsva'
            ].includes(fn)) return parseFloat(v) / 100;
            else return parseFloat(v);
        });
        return $44de4fc7c15df730$var$mappers[fn](...realValues);
    } else if (typeof color === 'string') {
        let hex = color.startsWith('#') ? color.slice(1) : color;
        if ([
            3,
            4
        ].includes(hex.length)) hex = hex.split('').map((char)=>char + char).join('');
        else if (![
            6,
            8
        ].includes(hex.length)) (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`'${color}' is not a valid hex(a) color`);
        const int = parseInt(hex, 16);
        if (isNaN(int) || int < 0 || int > 0xFFFFFFFF) (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`'${color}' is not a valid hex(a) color`);
        return $44de4fc7c15df730$export$a0c6ffd8592ca32(hex);
    } else if (typeof color === 'object') {
        if ((0, $8590040a7833369a$export$a4f4bb6b1453fff5)(color, [
            'r',
            'g',
            'b'
        ])) return color;
        else if ((0, $8590040a7833369a$export$a4f4bb6b1453fff5)(color, [
            'h',
            's',
            'l'
        ])) return $44de4fc7c15df730$export$61dbc3014460e6c3($44de4fc7c15df730$export$8917074272868d95(color));
        else if ((0, $8590040a7833369a$export$a4f4bb6b1453fff5)(color, [
            'h',
            's',
            'v'
        ])) return $44de4fc7c15df730$export$61dbc3014460e6c3(color);
    }
    throw new TypeError(`Invalid color: ${color == null ? color : String(color) || color.constructor.name}\nExpected #hex, #hexa, rgb(), rgba(), hsl(), hsla(), object or number`);
}
function $44de4fc7c15df730$export$2b8e7f0534b33198(color) {
    return (color.r << 16) + (color.g << 8) + color.b;
}
function $44de4fc7c15df730$export$8400161f82277749(color, colors, currentTheme) {
    const [colorName, colorModifier] = color.toString().trim().replace('-', '').split(' ', 2);
    let hexColor = '';
    if (colorName && colorName in colors) {
        if (colorModifier && colorModifier in colors[colorName]) hexColor = colors[colorName][colorModifier];
        else if ('base' in colors[colorName]) hexColor = colors[colorName].base;
    } else if (colorName && colorName in currentTheme) hexColor = currentTheme[colorName];
    return hexColor;
}
function $44de4fc7c15df730$export$61dbc3014460e6c3(hsva) {
    const { h: h, s: s, v: v, a: a } = hsva;
    const f = (n)=>{
        const k = (n + h / 60) % 6;
        return v - v * s * Math.max(Math.min(k, 4 - k, 1), 0);
    };
    const rgb = [
        f(5),
        f(3),
        f(1)
    ].map((v)=>Math.round(v * 255));
    return {
        r: rgb[0],
        g: rgb[1],
        b: rgb[2],
        a: a
    };
}
function $44de4fc7c15df730$export$7d768da925875d05(hsla) {
    return $44de4fc7c15df730$export$61dbc3014460e6c3($44de4fc7c15df730$export$8917074272868d95(hsla));
}
function $44de4fc7c15df730$export$62bb88c9baab039f(rgba) {
    if (!rgba) return {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    };
    const r = rgba.r / 255;
    const g = rgba.g / 255;
    const b = rgba.b / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = 0;
    if (max !== min) {
        if (max === r) h = 60 * (0 + (g - b) / (max - min));
        else if (max === g) h = 60 * (2 + (b - r) / (max - min));
        else if (max === b) h = 60 * (4 + (r - g) / (max - min));
    }
    if (h < 0) h = h + 360;
    const s = max === 0 ? 0 : (max - min) / max;
    const hsv = [
        h,
        s,
        max
    ];
    return {
        h: hsv[0],
        s: hsv[1],
        v: hsv[2],
        a: rgba.a
    };
}
function $44de4fc7c15df730$export$f24257e859bd61bb(hsva) {
    const { h: h, s: s, v: v, a: a } = hsva;
    const l = v - v * s / 2;
    const sprime = l === 1 || l === 0 ? 0 : (v - l) / Math.min(l, 1 - l);
    return {
        h: h,
        s: sprime,
        l: l,
        a: a
    };
}
function $44de4fc7c15df730$export$8917074272868d95(hsl) {
    const { h: h, s: s, l: l, a: a } = hsl;
    const v = l + s * Math.min(l, 1 - l);
    const sprime = v === 0 ? 0 : 2 - 2 * l / v;
    return {
        h: h,
        s: sprime,
        v: v,
        a: a
    };
}
function $44de4fc7c15df730$export$db9c9368f923228e(_ref) {
    let { r: r, g: g, b: b, a: a } = _ref;
    return a === undefined ? `rgb(${r}, ${g}, ${b})` : `rgba(${r}, ${g}, ${b}, ${a})`;
}
function $44de4fc7c15df730$export$25aeffa982c279d7(hsva) {
    return $44de4fc7c15df730$export$db9c9368f923228e($44de4fc7c15df730$export$61dbc3014460e6c3(hsva));
}
function $44de4fc7c15df730$var$toHex(v) {
    const h = Math.round(v).toString(16);
    return ('00'.substr(0, 2 - h.length) + h).toUpperCase();
}
function $44de4fc7c15df730$export$bf61bc94b2104040(_ref2) {
    let { r: r, g: g, b: b, a: a } = _ref2;
    return `#${[
        $44de4fc7c15df730$var$toHex(r),
        $44de4fc7c15df730$var$toHex(g),
        $44de4fc7c15df730$var$toHex(b),
        a !== undefined ? $44de4fc7c15df730$var$toHex(Math.round(a * 255)) : ''
    ].join('')}`;
}
function $44de4fc7c15df730$export$a0c6ffd8592ca32(hex) {
    hex = $44de4fc7c15df730$export$103711ef09c6edec(hex);
    let [r, g, b, a] = (0, $8590040a7833369a$export$5f7ec48d69707ddd)(hex, 2).map((c)=>parseInt(c, 16));
    a = a === undefined ? a : a / 255;
    return {
        r: r,
        g: g,
        b: b,
        a: a
    };
}
function $44de4fc7c15df730$export$4e9396b641d87477(hex) {
    const rgb = $44de4fc7c15df730$export$a0c6ffd8592ca32(hex);
    return $44de4fc7c15df730$export$62bb88c9baab039f(rgb);
}
function $44de4fc7c15df730$export$883c749ec82cf1f2(hsva) {
    return $44de4fc7c15df730$export$bf61bc94b2104040($44de4fc7c15df730$export$61dbc3014460e6c3(hsva));
}
function $44de4fc7c15df730$export$103711ef09c6edec(hex) {
    if (hex.startsWith('#')) hex = hex.slice(1);
    hex = hex.replace(/([^0-9a-f])/gi, 'F');
    if (hex.length === 3 || hex.length === 4) hex = hex.split('').map((x)=>x + x).join('');
    if (hex.length !== 6) hex = (0, $8590040a7833369a$export$23a07ddfce9fad49)((0, $8590040a7833369a$export$23a07ddfce9fad49)(hex, 6), 8, 'F');
    return hex;
}
function $44de4fc7c15df730$export$1089ae7f4d02cd2e(gradient, colors, currentTheme) {
    return gradient.replace(/([a-z]+(\s[a-z]+-[1-5])?)(?=$|,)/gi, (x)=>{
        return $44de4fc7c15df730$export$8400161f82277749(x, colors, currentTheme) || x;
    }).replace(/(rgba\()#[0-9a-f]+(?=,)/gi, (x)=>{
        return 'rgba(' + Object.values($44de4fc7c15df730$export$a0c6ffd8592ca32($44de4fc7c15df730$export$103711ef09c6edec(x.replace(/rgba\(/, '')))).slice(0, 3).join(',');
    });
}
function $44de4fc7c15df730$export$c0816ed86df316af(value, amount) {
    const lab = $086b74bf3d3bb44e$export$33c70ec5bb47f0fb($0d484a093f8aa8f9$export$22e8438d63a97037(value));
    lab[0] = lab[0] + amount * 10;
    return $0d484a093f8aa8f9$export$33c70ec5bb47f0fb($086b74bf3d3bb44e$export$22e8438d63a97037(lab));
}
function $44de4fc7c15df730$export$4b073707ff63303(value, amount) {
    const lab = $086b74bf3d3bb44e$export$33c70ec5bb47f0fb($0d484a093f8aa8f9$export$22e8438d63a97037(value));
    lab[0] = lab[0] - amount * 10;
    return $0d484a093f8aa8f9$export$33c70ec5bb47f0fb($086b74bf3d3bb44e$export$22e8438d63a97037(lab));
}
function $44de4fc7c15df730$export$606ef4b19aeb1c9c(color) {
    const rgb = $44de4fc7c15df730$export$6e865ea70d7724f(color);
    return $0d484a093f8aa8f9$export$22e8438d63a97037(rgb)[1];
}
function $44de4fc7c15df730$export$850ce485a60d103b(first, second) {
    const l1 = $44de4fc7c15df730$export$606ef4b19aeb1c9c(first);
    const l2 = $44de4fc7c15df730$export$606ef4b19aeb1c9c(second);
    const light = Math.max(l1, l2);
    const dark = Math.min(l1, l2);
    return (light + 0.05) / (dark + 0.05);
}
function $44de4fc7c15df730$export$27d3ce2b326d356d(color) {
    const blackContrast = Math.abs((0, $79063e0744bbddd4$export$31c9349e1a210963)($44de4fc7c15df730$export$6e865ea70d7724f(0), $44de4fc7c15df730$export$6e865ea70d7724f(color)));
    const whiteContrast = Math.abs((0, $79063e0744bbddd4$export$31c9349e1a210963)($44de4fc7c15df730$export$6e865ea70d7724f(0xffffff), $44de4fc7c15df730$export$6e865ea70d7724f(color)));
    // TODO: warn about poor color selections
    // const contrastAsText = Math.abs(APCAcontrast(colorVal, colorToInt(theme.colors.background)))
    // const minContrast = Math.max(blackContrast, whiteContrast)
    // if (minContrast < 60) {
    //   consoleInfo(`${key} theme color ${color} has poor contrast (${minContrast.toFixed()}%)`)
    // } else if (contrastAsText < 60 && !['background', 'surface'].includes(color)) {
    //   consoleInfo(`${key} theme color ${color} has poor contrast as text (${contrastAsText.toFixed()}%)`)
    // }
    // Prefer white text if both have an acceptable contrast ratio
    return whiteContrast > Math.min(blackContrast, 50) ? '#fff' : '#000';
}


const $cd59fdf0d9176afa$export$607927b8ce46d117 = Symbol.for('vuetify:theme');
const $cd59fdf0d9176afa$export$d0fc5ddd543b4149 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    theme: String
}, 'theme');
function $cd59fdf0d9176afa$var$genDefaults() {
    return {
        defaultTheme: 'light',
        prefix: 'v-',
        variations: {
            colors: [],
            lighten: 0,
            darken: 0
        },
        themes: {
            light: {
                dark: false,
                colors: {
                    background: '#FFFFFF',
                    surface: '#FFFFFF',
                    'surface-bright': '#FFFFFF',
                    'surface-light': '#EEEEEE',
                    'surface-variant': '#424242',
                    'on-surface-variant': '#EEEEEE',
                    primary: '#1867C0',
                    'primary-darken-1': '#1F5592',
                    secondary: '#48A9A6',
                    'secondary-darken-1': '#018786',
                    error: '#B00020',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                },
                variables: {
                    'border-color': '#000000',
                    'border-opacity': 0.12,
                    'high-emphasis-opacity': 0.87,
                    'medium-emphasis-opacity': 0.60,
                    'disabled-opacity': 0.38,
                    'idle-opacity': 0.04,
                    'hover-opacity': 0.04,
                    'focus-opacity': 0.12,
                    'selected-opacity': 0.08,
                    'activated-opacity': 0.12,
                    'pressed-opacity': 0.12,
                    'dragged-opacity': 0.08,
                    'theme-kbd': '#EEEEEE',
                    'theme-on-kbd': '#000000',
                    'theme-code': '#F5F5F5',
                    'theme-on-code': '#000000'
                }
            },
            dark: {
                dark: true,
                colors: {
                    background: '#121212',
                    surface: '#212121',
                    'surface-bright': '#ccbfd6',
                    'surface-light': '#424242',
                    'surface-variant': '#c8c8c8',
                    'on-surface-variant': '#000000',
                    primary: '#2196F3',
                    'primary-darken-1': '#277CC1',
                    secondary: '#54B6B2',
                    'secondary-darken-1': '#48A9A6',
                    error: '#CF6679',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                },
                variables: {
                    'border-color': '#FFFFFF',
                    'border-opacity': 0.12,
                    'high-emphasis-opacity': 1,
                    'medium-emphasis-opacity': 0.70,
                    'disabled-opacity': 0.50,
                    'idle-opacity': 0.10,
                    'hover-opacity': 0.04,
                    'focus-opacity': 0.12,
                    'selected-opacity': 0.08,
                    'activated-opacity': 0.12,
                    'pressed-opacity': 0.16,
                    'dragged-opacity': 0.08,
                    'theme-kbd': '#424242',
                    'theme-on-kbd': '#FFFFFF',
                    'theme-code': '#343434',
                    'theme-on-code': '#CCCCCC'
                }
            }
        },
        stylesheetId: 'vuetify-theme-stylesheet',
        scoped: false,
        unimportant: false,
        utilities: true
    };
}
function $cd59fdf0d9176afa$var$parseThemeOptions() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $cd59fdf0d9176afa$var$genDefaults();
    const defaults = $cd59fdf0d9176afa$var$genDefaults();
    if (!options) return {
        ...defaults,
        isDisabled: true
    };
    const themes = {};
    for (const [key, theme] of Object.entries(options.themes ?? {})){
        const defaultTheme = theme.dark || key === 'dark' ? defaults.themes?.dark : defaults.themes?.light;
        themes[key] = (0, $8590040a7833369a$export$dd702b3c8240390c)(defaultTheme, theme);
    }
    return (0, $8590040a7833369a$export$dd702b3c8240390c)(defaults, {
        ...options,
        themes: themes
    });
}
function $cd59fdf0d9176afa$var$createCssClass(lines, selector, content, scope) {
    lines.push(`${$cd59fdf0d9176afa$var$getScopedSelector(selector, scope)} {\n`, ...content.map((line)=>`  ${line};\n`), '}\n');
}
function $cd59fdf0d9176afa$var$genCssVariables(theme, prefix) {
    const lightOverlay = theme.dark ? 2 : 1;
    const darkOverlay = theme.dark ? 1 : 2;
    const variables = [];
    for (const [key, value] of Object.entries(theme.colors)){
        const rgb = (0, $44de4fc7c15df730$export$6e865ea70d7724f)(value);
        variables.push(`--${prefix}theme-${key}: ${rgb.r},${rgb.g},${rgb.b}`);
        if (!key.startsWith('on-')) variables.push(`--${prefix}theme-${key}-overlay-multiplier: ${(0, $44de4fc7c15df730$export$606ef4b19aeb1c9c)(value) > 0.18 ? lightOverlay : darkOverlay}`);
    }
    for (const [key, value] of Object.entries(theme.variables)){
        const color = typeof value === 'string' && value.startsWith('#') ? (0, $44de4fc7c15df730$export$6e865ea70d7724f)(value) : undefined;
        const rgb = color ? `${color.r}, ${color.g}, ${color.b}` : undefined;
        variables.push(`--${prefix}${key}: ${rgb ?? value}`);
    }
    return variables;
}
function $cd59fdf0d9176afa$var$genVariation(name, color, variations) {
    const object = {};
    if (variations) for (const variation of [
        'lighten',
        'darken'
    ]){
        const fn = variation === 'lighten' ? (0, $44de4fc7c15df730$export$c0816ed86df316af) : (0, $44de4fc7c15df730$export$4b073707ff63303);
        for (const amount of (0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(variations[variation], 1))object[`${name}-${variation}-${amount}`] = (0, $44de4fc7c15df730$export$bf61bc94b2104040)(fn((0, $44de4fc7c15df730$export$6e865ea70d7724f)(color), amount));
    }
    return object;
}
function $cd59fdf0d9176afa$var$genVariations(colors, variations) {
    if (!variations) return {};
    let variationColors = {};
    for (const name of variations.colors){
        const color = colors[name];
        if (!color) continue;
        variationColors = {
            ...variationColors,
            ...$cd59fdf0d9176afa$var$genVariation(name, color, variations)
        };
    }
    return variationColors;
}
function $cd59fdf0d9176afa$var$genOnColors(colors) {
    const onColors = {};
    for (const color of Object.keys(colors)){
        if (color.startsWith('on-') || colors[`on-${color}`]) continue;
        const onColor = `on-${color}`;
        const colorVal = (0, $44de4fc7c15df730$export$6e865ea70d7724f)(colors[color]);
        onColors[onColor] = (0, $44de4fc7c15df730$export$27d3ce2b326d356d)(colorVal);
    }
    return onColors;
}
function $cd59fdf0d9176afa$var$getScopedSelector(selector, scope) {
    if (!scope) return selector;
    const scopeSelector = `:where(${scope})`;
    return selector === ':root' ? scopeSelector : `${scopeSelector} ${selector}`;
}
function $cd59fdf0d9176afa$var$upsertStyles(id, cspNonce, styles) {
    const styleEl = $cd59fdf0d9176afa$var$getOrCreateStyleElement(id, cspNonce);
    if (!styleEl) return;
    styleEl.innerHTML = styles;
}
function $cd59fdf0d9176afa$var$getOrCreateStyleElement(id, cspNonce) {
    if (!(0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd)) return null;
    let style = document.getElementById(id);
    if (!style) {
        style = document.createElement('style');
        style.id = id;
        style.type = 'text/css';
        if (cspNonce) style.setAttribute('nonce', cspNonce);
        document.head.appendChild(style);
    }
    return style;
}
function $cd59fdf0d9176afa$export$25d302a5b900a763(options) {
    const parsedOptions = $cd59fdf0d9176afa$var$parseThemeOptions(options);
    const _name = (0, $01W3b.shallowRef)(parsedOptions.defaultTheme);
    const themes = (0, $01W3b.ref)(parsedOptions.themes);
    const systemName = (0, $01W3b.shallowRef)('light');
    const name = (0, $01W3b.computed)({
        get () {
            return _name.value === 'system' ? systemName.value : _name.value;
        },
        set (val) {
            _name.value = val;
        }
    });
    const computedThemes = (0, $01W3b.computed)(()=>{
        const acc = {};
        for (const [name, original] of Object.entries(themes.value)){
            const colors = {
                ...original.colors,
                ...$cd59fdf0d9176afa$var$genVariations(original.colors, parsedOptions.variations)
            };
            acc[name] = {
                ...original,
                colors: {
                    ...colors,
                    ...$cd59fdf0d9176afa$var$genOnColors(colors)
                }
            };
        }
        return acc;
    });
    const current = (0, $01W3b.toRef)(()=>computedThemes.value[name.value]);
    const isSystem = (0, $01W3b.toRef)(()=>_name.value === 'system');
    const styles = (0, $01W3b.computed)(()=>{
        const lines = [];
        const important = parsedOptions.unimportant ? '' : ' !important';
        const scoped = parsedOptions.scoped ? parsedOptions.prefix : '';
        if (current.value?.dark) $cd59fdf0d9176afa$var$createCssClass(lines, ':root', [
            'color-scheme: dark'
        ], parsedOptions.scope);
        $cd59fdf0d9176afa$var$createCssClass(lines, ':root', $cd59fdf0d9176afa$var$genCssVariables(current.value, parsedOptions.prefix), parsedOptions.scope);
        for (const [themeName, theme] of Object.entries(computedThemes.value))$cd59fdf0d9176afa$var$createCssClass(lines, `.${parsedOptions.prefix}theme--${themeName}`, [
            `color-scheme: ${theme.dark ? 'dark' : 'normal'}`,
            ...$cd59fdf0d9176afa$var$genCssVariables(theme, parsedOptions.prefix)
        ], parsedOptions.scope);
        if (parsedOptions.utilities) {
            const bgLines = [];
            const fgLines = [];
            const colors = new Set(Object.values(computedThemes.value).flatMap((theme)=>Object.keys(theme.colors)));
            for (const key of colors)if (key.startsWith('on-')) $cd59fdf0d9176afa$var$createCssClass(fgLines, `.${key}`, [
                `color: rgb(var(--${parsedOptions.prefix}theme-${key}))${important}`
            ], parsedOptions.scope);
            else {
                $cd59fdf0d9176afa$var$createCssClass(bgLines, `.${scoped}bg-${key}`, [
                    `--${parsedOptions.prefix}theme-overlay-multiplier: var(--${parsedOptions.prefix}theme-${key}-overlay-multiplier)`,
                    `background-color: rgb(var(--${parsedOptions.prefix}theme-${key}))${important}`,
                    `color: rgb(var(--${parsedOptions.prefix}theme-on-${key}))${important}`
                ], parsedOptions.scope);
                $cd59fdf0d9176afa$var$createCssClass(fgLines, `.${scoped}text-${key}`, [
                    `color: rgb(var(--${parsedOptions.prefix}theme-${key}))${important}`
                ], parsedOptions.scope);
                $cd59fdf0d9176afa$var$createCssClass(fgLines, `.${scoped}border-${key}`, [
                    `--${parsedOptions.prefix}border-color: var(--${parsedOptions.prefix}theme-${key})`
                ], parsedOptions.scope);
            }
            if (parsedOptions.layers) lines.push('@layer background {\n', ...bgLines.map((v)=>`  ${v}`), '}\n', '@layer foreground {\n', ...fgLines.map((v)=>`  ${v}`), '}\n');
            else lines.push(...bgLines, ...fgLines);
        }
        let final = lines.map((str, i)=>i === 0 ? str : `    ${str}`).join('');
        if (parsedOptions.layers) final = '@layer vuetify.theme {\n' + lines.map((v)=>`  ${v}`).join('') + '\n}';
        return final;
    });
    const themeClasses = (0, $01W3b.toRef)(()=>parsedOptions.isDisabled ? undefined : `${parsedOptions.prefix}theme--${name.value}`);
    const themeNames = (0, $01W3b.toRef)(()=>Object.keys(computedThemes.value));
    if (0, $90a48ad178b943d3$export$622094c5d6c3013b) {
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        function updateSystemName() {
            systemName.value = media.matches ? 'dark' : 'light';
        }
        updateSystemName();
        media.addEventListener('change', updateSystemName, {
            passive: true
        });
        if ((0, $01W3b.getCurrentScope)()) (0, $01W3b.onScopeDispose)(()=>{
            media.removeEventListener('change', updateSystemName);
        });
    }
    function install(app) {
        if (parsedOptions.isDisabled) return;
        const head = app._context.provides.usehead;
        if (head) {
            function getHead() {
                return {
                    style: [
                        {
                            textContent: styles.value,
                            id: parsedOptions.stylesheetId,
                            nonce: parsedOptions.cspNonce || false
                        }
                    ]
                };
            }
            if (head.push) {
                const entry = head.push(getHead);
                if (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) (0, $01W3b.watch)(styles, ()=>{
                    entry.patch(getHead);
                });
            } else if (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) {
                head.addHeadObjs((0, $01W3b.toRef)(getHead));
                (0, $TusQn.watchEffect)(()=>head.updateDOM());
            } else head.addHeadObjs(getHead());
        } else {
            if (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) (0, $01W3b.watch)(styles, updateStyles, {
                immediate: true
            });
            else updateStyles();
            function updateStyles() {
                $cd59fdf0d9176afa$var$upsertStyles(parsedOptions.stylesheetId, parsedOptions.cspNonce, styles.value);
            }
        }
    }
    function change(themeName) {
        if (themeName !== 'system' && !themeNames.value.includes(themeName)) {
            (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`Theme "${themeName}" not found on the Vuetify theme instance`);
            return;
        }
        name.value = themeName;
    }
    function cycle() {
        let themeArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : themeNames.value;
        const currentIndex = themeArray.indexOf(name.value);
        const nextIndex = currentIndex === -1 ? 0 : (currentIndex + 1) % themeArray.length;
        change(themeArray[nextIndex]);
    }
    function toggle() {
        let themeArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            'light',
            'dark'
        ];
        cycle(themeArray);
    }
    const globalName = new Proxy(name, {
        get (target, prop) {
            return Reflect.get(target, prop);
        },
        set (target, prop, val) {
            if (prop === 'value') (0, $5384ffc78a9e124c$export$b680e6b2c82f8c2f)(`theme.global.name.value = ${val}`, `theme.change('${val}')`);
            return Reflect.set(target, prop, val);
        }
    });
    return {
        install: install,
        change: change,
        cycle: cycle,
        toggle: toggle,
        isDisabled: parsedOptions.isDisabled,
        isSystem: isSystem,
        name: name,
        themes: themes,
        current: current,
        computedThemes: computedThemes,
        prefix: parsedOptions.prefix,
        themeClasses: themeClasses,
        styles: styles,
        global: {
            name: globalName,
            current: current
        }
    };
}
function $cd59fdf0d9176afa$export$307b27329074e447(props) {
    (0, $b65c26e77f158b6f$export$f13e630aa3915748)('provideTheme');
    const theme = (0, $TusQn.inject)($cd59fdf0d9176afa$export$607927b8ce46d117, null);
    if (!theme) throw new Error('Could not find Vuetify theme injection');
    const name = (0, $01W3b.toRef)(()=>props.theme ?? theme.name.value);
    const current = (0, $01W3b.toRef)(()=>theme.themes.value[name.value]);
    const themeClasses = (0, $01W3b.toRef)(()=>theme.isDisabled ? undefined : `${theme.prefix}theme--${name.value}`);
    const newTheme = {
        ...theme,
        name: name,
        current: current,
        themeClasses: themeClasses
    };
    (0, $TusQn.provide)($cd59fdf0d9176afa$export$607927b8ce46d117, newTheme);
    return newTheme;
}
function $cd59fdf0d9176afa$export$93d4e7f90805808f() {
    (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useTheme');
    const theme = (0, $TusQn.inject)($cd59fdf0d9176afa$export$607927b8ce46d117, null);
    if (!theme) throw new Error('Could not find Vuetify theme injection');
    return theme;
}


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");



function $579bd3b95fd3a255$export$ef34132de12b844b() {
    let vuetify = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const { blueprint: blueprint, ...rest } = vuetify;
    const options = (0, $8590040a7833369a$export$dd702b3c8240390c)(blueprint, rest);
    const { aliases: aliases = {}, components: components = {}, directives: directives = {} } = options;
    const scope = (0, $01W3b.effectScope)();
    return scope.run(()=>{
        const defaults = (0, $8b1159e2b202edcf$export$e149fd47ce43e254)(options.defaults);
        const display = (0, $1444e2cf1a712792$export$630b3f7014e81311)(options.display, options.ssr);
        const theme = (0, $cd59fdf0d9176afa$export$25d302a5b900a763)(options.theme);
        const icons = (0, $cebee00dd6d52041$export$f8761611413a374e)(options.icons);
        const locale = (0, $13e23564052bdddd$export$9af58f1cfd1fbeb4)(options.locale);
        const date = (0, $917deb9c892fd486$export$e029667a62135fd0)(options.date, locale);
        const goTo = (0, $63ad461311545872$export$68787d8a6f2b811a)(options.goTo, locale);
        function install(app) {
            for(const key in directives)app.directive(key, directives[key]);
            for(const key in components)app.component(key, components[key]);
            for(const key in aliases)app.component(key, (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
                ...aliases[key],
                name: key,
                aliasName: aliases[key].name
            }));
            const appScope = (0, $01W3b.effectScope)();
            appScope.run(()=>{
                theme.install(app);
            });
            app.onUnmount(()=>appScope.stop());
            app.provide((0, $8b1159e2b202edcf$export$84318fce2211c0fd), defaults);
            app.provide((0, $1444e2cf1a712792$export$9a65027cbda1c19), display);
            app.provide((0, $cd59fdf0d9176afa$export$607927b8ce46d117), theme);
            app.provide((0, $834ffcae3192e85e$export$d477c077e2856eb1), icons);
            app.provide((0, $13e23564052bdddd$export$36c469862c41ebd3), locale);
            app.provide((0, $917deb9c892fd486$export$ee409445cb0eea8f), date.options);
            app.provide((0, $917deb9c892fd486$export$77c3d555e2fd633c), date.instance);
            app.provide((0, $63ad461311545872$export$b6ccca179d0dbca4), goTo);
            if ((0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && options.ssr) {
                if (app.$nuxt) app.$nuxt.hook('app:suspense:resolve', ()=>{
                    display.update();
                });
                else {
                    const { mount: mount } = app;
                    app.mount = function() {
                        const vm = mount(...arguments);
                        (0, $TusQn.nextTick)(()=>display.update());
                        app.mount = mount;
                        return vm;
                    };
                }
            }
            if (typeof __VUE_OPTIONS_API__ !== 'boolean' || __VUE_OPTIONS_API__) app.mixin({
                computed: {
                    $vuetify () {
                        return (0, $01W3b.reactive)({
                            defaults: $579bd3b95fd3a255$var$inject.call(this, (0, $8b1159e2b202edcf$export$84318fce2211c0fd)),
                            display: $579bd3b95fd3a255$var$inject.call(this, (0, $1444e2cf1a712792$export$9a65027cbda1c19)),
                            theme: $579bd3b95fd3a255$var$inject.call(this, (0, $cd59fdf0d9176afa$export$607927b8ce46d117)),
                            icons: $579bd3b95fd3a255$var$inject.call(this, (0, $834ffcae3192e85e$export$d477c077e2856eb1)),
                            locale: $579bd3b95fd3a255$var$inject.call(this, (0, $13e23564052bdddd$export$36c469862c41ebd3)),
                            date: $579bd3b95fd3a255$var$inject.call(this, (0, $917deb9c892fd486$export$77c3d555e2fd633c))
                        });
                    }
                }
            });
        }
        function unmount() {
            scope.stop();
        }
        return {
            install: install,
            unmount: unmount,
            defaults: defaults,
            display: display,
            theme: theme,
            icons: icons,
            locale: locale,
            date: date,
            goTo: goTo
        };
    });
}
const $579bd3b95fd3a255$export$83d89fbfd8236492 = "3.12.0";
$579bd3b95fd3a255$export$ef34132de12b844b.version = $579bd3b95fd3a255$export$83d89fbfd8236492;
// Vue's inject() can only be used in setup
function $579bd3b95fd3a255$var$inject(key) {
    const vm = this.$;
    const provides = vm.parent?.provides ?? vm.vnode.appContext?.provides;
    if (provides && key in provides) return provides[key];
}


var $38548887993916f0$exports = {};
var $ebf0728bf7f44045$exports = {};

$parcel$export($ebf0728bf7f44045$exports, "VApp", () => $19d74c57460727d9$export$60414d50d930f930);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

// Utilities

const $b1955b9b553f9f53$export$d271552babda0448 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    class: [
        String,
        Array,
        Object
    ],
    style: {
        type: [
            String,
            Array,
            Object
        ],
        default: null
    }
}, 'component');


// Composables
// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");


function $d80db15b6452c606$export$683480f191c0e3ea(callback) {
    let box = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'content';
    const resizeRef = (0, $8590040a7833369a$export$fc38e812d383221)();
    const contentRect = (0, $01W3b.ref)();
    if (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) {
        const observer = new ResizeObserver((entries)=>{
            callback?.(entries, observer);
            if (!entries.length) return;
            if (box === 'content') contentRect.value = entries[0].contentRect;
            else contentRect.value = entries[0].target.getBoundingClientRect();
        });
        (0, $TusQn.onBeforeUnmount)(()=>{
            observer.disconnect();
        });
        (0, $01W3b.watch)(()=>resizeRef.el, (newValue, oldValue)=>{
            if (oldValue) {
                observer.unobserve(oldValue);
                contentRect.value = undefined;
            }
            if (newValue) observer.observe(newValue);
        }, {
            flush: 'post'
        });
    }
    return {
        resizeRef: resizeRef,
        contentRect: (0, $01W3b.readonly)(contentRect)
    };
}


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $56e08e0125137781$export$6c0af7fe4dd9b19b = Symbol.for('vuetify:layout');
const $56e08e0125137781$export$e8f59a037946a8c0 = Symbol.for('vuetify:layout-item');
const $56e08e0125137781$var$ROOT_ZINDEX = 1000;
const $56e08e0125137781$export$f0037fcffb4e2081 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    overlaps: {
        type: Array,
        default: ()=>[]
    },
    fullHeight: Boolean
}, 'layout');
const $56e08e0125137781$export$d42abac634ace931 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    name: {
        type: String
    },
    order: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    absolute: Boolean
}, 'layout-item');
function $56e08e0125137781$export$f47430f7ffdcc134() {
    const layout = (0, $TusQn.inject)($56e08e0125137781$export$6c0af7fe4dd9b19b);
    if (!layout) throw new Error('[Vuetify] Could not find injected layout');
    return {
        getLayoutItem: layout.getLayoutItem,
        mainRect: layout.mainRect,
        mainStyles: layout.mainStyles
    };
}
function $56e08e0125137781$export$e2f4c0dffffc8723(options) {
    const layout = (0, $TusQn.inject)($56e08e0125137781$export$6c0af7fe4dd9b19b);
    if (!layout) throw new Error('[Vuetify] Could not find injected layout');
    const id = options.id ?? `layout-item-${(0, $TusQn.useId)()}`;
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useLayoutItem');
    (0, $TusQn.provide)($56e08e0125137781$export$e8f59a037946a8c0, {
        id: id
    });
    const isKeptAlive = (0, $01W3b.shallowRef)(false);
    (0, $TusQn.onDeactivated)(()=>isKeptAlive.value = true);
    (0, $TusQn.onActivated)(()=>isKeptAlive.value = false);
    const { layoutItemStyles: layoutItemStyles, layoutItemScrimStyles: layoutItemScrimStyles } = layout.register(vm, {
        ...options,
        active: (0, $01W3b.computed)(()=>isKeptAlive.value ? false : options.active.value),
        id: id
    });
    (0, $TusQn.onBeforeUnmount)(()=>layout.unregister(id));
    return {
        layoutItemStyles: layoutItemStyles,
        layoutRect: layout.layoutRect,
        layoutItemScrimStyles: layoutItemScrimStyles
    };
}
const $56e08e0125137781$var$generateLayers = (layout, positions, layoutSizes, activeItems)=>{
    let previousLayer = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    };
    const layers = [
        {
            id: '',
            layer: {
                ...previousLayer
            }
        }
    ];
    for (const id of layout){
        const position = positions.get(id);
        const amount = layoutSizes.get(id);
        const active = activeItems.get(id);
        if (!position || !amount || !active) continue;
        const layer = {
            ...previousLayer,
            [position.value]: parseInt(previousLayer[position.value], 10) + (active.value ? parseInt(amount.value, 10) : 0)
        };
        layers.push({
            id: id,
            layer: layer
        });
        previousLayer = layer;
    }
    return layers;
};
function $56e08e0125137781$export$3dd437ade36ede40(props) {
    const parentLayout = (0, $TusQn.inject)($56e08e0125137781$export$6c0af7fe4dd9b19b, null);
    const rootZIndex = (0, $01W3b.computed)(()=>parentLayout ? parentLayout.rootZIndex.value - 100 : $56e08e0125137781$var$ROOT_ZINDEX);
    const registered = (0, $01W3b.ref)([]);
    const positions = (0, $01W3b.reactive)(new Map());
    const layoutSizes = (0, $01W3b.reactive)(new Map());
    const priorities = (0, $01W3b.reactive)(new Map());
    const activeItems = (0, $01W3b.reactive)(new Map());
    const disabledTransitions = (0, $01W3b.reactive)(new Map());
    const { resizeRef: resizeRef, contentRect: layoutRect } = (0, $d80db15b6452c606$export$683480f191c0e3ea)();
    const computedOverlaps = (0, $01W3b.computed)(()=>{
        const map = new Map();
        const overlaps = props.overlaps ?? [];
        for (const overlap of overlaps.filter((item)=>item.includes(':'))){
            const [top, bottom] = overlap.split(':');
            if (!registered.value.includes(top) || !registered.value.includes(bottom)) continue;
            const topPosition = positions.get(top);
            const bottomPosition = positions.get(bottom);
            const topAmount = layoutSizes.get(top);
            const bottomAmount = layoutSizes.get(bottom);
            if (!topPosition || !bottomPosition || !topAmount || !bottomAmount) continue;
            map.set(bottom, {
                position: topPosition.value,
                amount: parseInt(topAmount.value, 10)
            });
            map.set(top, {
                position: bottomPosition.value,
                amount: -parseInt(bottomAmount.value, 10)
            });
        }
        return map;
    });
    const layers = (0, $01W3b.computed)(()=>{
        const uniquePriorities = [
            ...new Set([
                ...priorities.values()
            ].map((p)=>p.value))
        ].sort((a, b)=>a - b);
        const layout = [];
        for (const p of uniquePriorities){
            const items = registered.value.filter((id)=>priorities.get(id)?.value === p);
            layout.push(...items);
        }
        return $56e08e0125137781$var$generateLayers(layout, positions, layoutSizes, activeItems);
    });
    const transitionsEnabled = (0, $01W3b.computed)(()=>{
        return !Array.from(disabledTransitions.values()).some((ref)=>ref.value);
    });
    const mainRect = (0, $01W3b.computed)(()=>{
        return layers.value[layers.value.length - 1].layer;
    });
    const mainStyles = (0, $01W3b.toRef)(()=>{
        return {
            '--v-layout-left': (0, $8590040a7833369a$export$286ad215293a0860)(mainRect.value.left),
            '--v-layout-right': (0, $8590040a7833369a$export$286ad215293a0860)(mainRect.value.right),
            '--v-layout-top': (0, $8590040a7833369a$export$286ad215293a0860)(mainRect.value.top),
            '--v-layout-bottom': (0, $8590040a7833369a$export$286ad215293a0860)(mainRect.value.bottom),
            ...transitionsEnabled.value ? undefined : {
                transition: 'none'
            }
        };
    });
    const items = (0, $01W3b.computed)(()=>{
        return layers.value.slice(1).map((_ref, index)=>{
            let { id: id } = _ref;
            const { layer: layer } = layers.value[index];
            const size = layoutSizes.get(id);
            const position = positions.get(id);
            return {
                id: id,
                ...layer,
                size: Number(size.value),
                position: position.value
            };
        });
    });
    const getLayoutItem = (id)=>{
        return items.value.find((item)=>item.id === id);
    };
    const rootVm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('createLayout');
    const isMounted = (0, $01W3b.shallowRef)(false);
    (0, $TusQn.onMounted)(()=>{
        isMounted.value = true;
    });
    (0, $TusQn.provide)($56e08e0125137781$export$6c0af7fe4dd9b19b, {
        register: (vm, _ref2)=>{
            let { id: id, order: order, position: position, layoutSize: layoutSize, elementSize: elementSize, active: active, disableTransitions: disableTransitions, absolute: absolute } = _ref2;
            priorities.set(id, order);
            positions.set(id, position);
            layoutSizes.set(id, layoutSize);
            activeItems.set(id, active);
            disableTransitions && disabledTransitions.set(id, disableTransitions);
            const instances = (0, $8590040a7833369a$export$424fe43b65f39668)($56e08e0125137781$export$e8f59a037946a8c0, rootVm?.vnode);
            const instanceIndex = instances.indexOf(vm);
            if (instanceIndex > -1) registered.value.splice(instanceIndex, 0, id);
            else registered.value.push(id);
            const index = (0, $01W3b.computed)(()=>items.value.findIndex((i)=>i.id === id));
            const zIndex = (0, $01W3b.computed)(()=>rootZIndex.value + layers.value.length * 2 - index.value * 2);
            const layoutItemStyles = (0, $01W3b.computed)(()=>{
                const isHorizontal = position.value === 'left' || position.value === 'right';
                const isOppositeHorizontal = position.value === 'right';
                const isOppositeVertical = position.value === 'bottom';
                const size = elementSize.value ?? layoutSize.value;
                const unit = size === 0 ? '%' : 'px';
                const styles = {
                    [position.value]: 0,
                    zIndex: zIndex.value,
                    transform: `translate${isHorizontal ? 'X' : 'Y'}(${(active.value ? 0 : -(size === 0 ? 100 : size)) * (isOppositeHorizontal || isOppositeVertical ? -1 : 1)}${unit})`,
                    position: absolute.value || rootZIndex.value !== $56e08e0125137781$var$ROOT_ZINDEX ? 'absolute' : 'fixed',
                    ...transitionsEnabled.value ? undefined : {
                        transition: 'none'
                    }
                };
                if (!isMounted.value) return styles;
                const item = items.value[index.value];
                if (!item) (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`[Vuetify] Could not find layout item "${id}"`);
                const overlap = computedOverlaps.value.get(id);
                if (overlap) item[overlap.position] += overlap.amount;
                return {
                    ...styles,
                    height: isHorizontal ? `calc(100% - ${item.top}px - ${item.bottom}px)` : elementSize.value ? `${elementSize.value}px` : undefined,
                    left: isOppositeHorizontal ? undefined : `${item.left}px`,
                    right: isOppositeHorizontal ? `${item.right}px` : undefined,
                    top: position.value !== 'bottom' ? `${item.top}px` : undefined,
                    bottom: position.value !== 'top' ? `${item.bottom}px` : undefined,
                    width: !isHorizontal ? `calc(100% - ${item.left}px - ${item.right}px)` : elementSize.value ? `${elementSize.value}px` : undefined
                };
            });
            const layoutItemScrimStyles = (0, $01W3b.computed)(()=>({
                    zIndex: zIndex.value - 1
                }));
            return {
                layoutItemStyles: layoutItemStyles,
                layoutItemScrimStyles: layoutItemScrimStyles,
                zIndex: zIndex
            };
        },
        unregister: (id)=>{
            priorities.delete(id);
            positions.delete(id);
            layoutSizes.delete(id);
            activeItems.delete(id);
            disabledTransitions.delete(id);
            registered.value = registered.value.filter((v)=>v !== id);
        },
        mainRect: mainRect,
        mainStyles: mainStyles,
        getLayoutItem: getLayoutItem,
        items: items,
        layoutRect: layoutRect,
        rootZIndex: rootZIndex
    });
    const layoutClasses = (0, $01W3b.toRef)(()=>[
            'v-layout',
            {
                'v-layout--full-height': props.fullHeight
            }
        ]);
    const layoutStyles = (0, $01W3b.toRef)(()=>({
            zIndex: parentLayout ? rootZIndex.value : undefined,
            position: parentLayout ? 'relative' : undefined,
            overflow: parentLayout ? 'hidden' : undefined
        }));
    return {
        layoutClasses: layoutClasses,
        layoutStyles: layoutStyles,
        getLayoutItem: getLayoutItem,
        items: items,
        layoutRect: layoutRect,
        layoutRef: resizeRef
    };
}




// Utilities

function $a006457100ae975f$export$e25bb1e5b53cbdff(render) {
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useRender');
    vm.render = render;
}


const $19d74c57460727d9$export$4d0e7713f668e677 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $56e08e0125137781$export$f0037fcffb4e2081)(), [
        'fullHeight'
    ]),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VApp');
const $19d74c57460727d9$export$60414d50d930f930 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VApp',
    props: $19d74c57460727d9$export$4d0e7713f668e677(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const theme = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { layoutClasses: layoutClasses, getLayoutItem: getLayoutItem, items: items, layoutRef: layoutRef } = (0, $56e08e0125137781$export$3dd437ade36ede40)({
            ...props,
            fullHeight: true
        });
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "ref": layoutRef,
                "class": (0, $8POXm.normalizeClass)([
                    'v-application',
                    theme.themeClasses.value,
                    layoutClasses.value,
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    props.style
                ])
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-application__wrap"
                }, [
                    slots.default?.()
                ])
            ]));
        return {
            getLayoutItem: getLayoutItem,
            items: items,
            theme: theme
        };
    }
});




var $cf858201179e51b0$exports = {};

$parcel$export($cf858201179e51b0$exports, "VAppBar", () => $54a8bd238fe4aa7e$export$2fbc8fb55736252a);
$parcel$export($cf858201179e51b0$exports, "VAppBarNavIcon", () => $4c2d4cfe4881b62f$export$692fce24359c3843);
$parcel$export($cf858201179e51b0$exports, "VAppBarTitle", () => $f0ac698606000754$export$657ba4c199549e9b);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

// Utilities

const $7339ea6cd3ccffba$export$1e45edda911c93db = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    tag: {
        type: [
            String,
            Object,
            Function
        ],
        default: 'div'
    }
}, 'tag');



const $19fdabc79dfb07a7$export$6afad7cb17124872 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    text: String,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VToolbarTitle');
const $19fdabc79dfb07a7$export$deaeca9428bfc9a4 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VToolbarTitle',
    props: $19fdabc79dfb07a7$export$6afad7cb17124872(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasText = !!(slots.default || slots.text || props.text);
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-toolbar-title',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        hasText && (0, $TusQn.createElementVNode)("div", {
                            "class": "v-toolbar-title__placeholder"
                        }, [
                            slots.text ? slots.text() : props.text,
                            slots.default?.()
                        ])
                    ]
            });
        });
        return {};
    }
});


var $7ec1b0ef33b04126$exports = {};

$parcel$export($7ec1b0ef33b04126$exports, "VFabTransition", () => $7ec1b0ef33b04126$export$e41ac6a607c71844);
$parcel$export($7ec1b0ef33b04126$exports, "VDialogBottomTransition", () => $7ec1b0ef33b04126$export$bc7471894fc4ecf0);
$parcel$export($7ec1b0ef33b04126$exports, "VDialogTopTransition", () => $7ec1b0ef33b04126$export$32d110114067327f);
$parcel$export($7ec1b0ef33b04126$exports, "VFadeTransition", () => $7ec1b0ef33b04126$export$13ce8c44634b158c);
$parcel$export($7ec1b0ef33b04126$exports, "VScaleTransition", () => $7ec1b0ef33b04126$export$5d9397de61546474);
$parcel$export($7ec1b0ef33b04126$exports, "VScrollXTransition", () => $7ec1b0ef33b04126$export$ec1a91eaaf33fc1a);
$parcel$export($7ec1b0ef33b04126$exports, "VScrollXReverseTransition", () => $7ec1b0ef33b04126$export$1c31b47261d53f89);
$parcel$export($7ec1b0ef33b04126$exports, "VScrollYTransition", () => $7ec1b0ef33b04126$export$727e6b700671cc9c);
$parcel$export($7ec1b0ef33b04126$exports, "VScrollYReverseTransition", () => $7ec1b0ef33b04126$export$65ab0ce785466dae);
$parcel$export($7ec1b0ef33b04126$exports, "VSlideXTransition", () => $7ec1b0ef33b04126$export$6997cd6ab1645575);
$parcel$export($7ec1b0ef33b04126$exports, "VSlideXReverseTransition", () => $7ec1b0ef33b04126$export$cb28325bdb6e20c2);
$parcel$export($7ec1b0ef33b04126$exports, "VSlideYTransition", () => $7ec1b0ef33b04126$export$5d9f875feb4d9ee6);
$parcel$export($7ec1b0ef33b04126$exports, "VSlideYReverseTransition", () => $7ec1b0ef33b04126$export$f24f0bc0b4f2bbd2);
$parcel$export($7ec1b0ef33b04126$exports, "VExpandTransition", () => $7ec1b0ef33b04126$export$1cd1e8deb97d798d);
$parcel$export($7ec1b0ef33b04126$exports, "VExpandXTransition", () => $7ec1b0ef33b04126$export$d54edbcba7869f36);
$parcel$export($7ec1b0ef33b04126$exports, "VExpandBothTransition", () => $7ec1b0ef33b04126$export$72ef08ce8c082a3c);
$parcel$export($7ec1b0ef33b04126$exports, "VDialogTransition", () => $6d83cccc3a7f7c51$export$9778a08df954f36c);
// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");

const $e00858d23308ef8c$export$e5b7ff1a0fbdc00e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    disabled: Boolean,
    group: Boolean,
    hideOnLeave: Boolean,
    leaveAbsolute: Boolean,
    mode: String,
    origin: String
}, 'transition');
function $e00858d23308ef8c$export$a21bd7b30fd40589(name, origin, mode) {
    return (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
        name: name,
        props: $e00858d23308ef8c$export$e5b7ff1a0fbdc00e({
            mode: mode,
            origin: origin
        }),
        setup (props, _ref) {
            let { slots: slots } = _ref;
            const functions = {
                onBeforeEnter (el) {
                    if (props.origin) el.style.transformOrigin = props.origin;
                },
                onLeave (el) {
                    if (props.leaveAbsolute) {
                        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = el;
                        el._transitionInitialStyles = {
                            position: el.style.position,
                            top: el.style.top,
                            left: el.style.left,
                            width: el.style.width,
                            height: el.style.height
                        };
                        el.style.position = 'absolute';
                        el.style.top = `${offsetTop}px`;
                        el.style.left = `${offsetLeft}px`;
                        el.style.width = `${offsetWidth}px`;
                        el.style.height = `${offsetHeight}px`;
                    }
                    if (props.hideOnLeave) el.style.setProperty('display', 'none', 'important');
                },
                onAfterLeave (el) {
                    if (props.leaveAbsolute && el?._transitionInitialStyles) {
                        const { position: position, top: top, left: left, width: width, height: height } = el._transitionInitialStyles;
                        delete el._transitionInitialStyles;
                        el.style.position = position || '';
                        el.style.top = top || '';
                        el.style.left = left || '';
                        el.style.width = width || '';
                        el.style.height = height || '';
                    }
                }
            };
            return ()=>{
                const tag = props.group ? (0, $eeJ70.TransitionGroup) : (0, $eeJ70.Transition);
                return (0, $TusQn.h)(tag, {
                    name: props.disabled ? '' : name,
                    css: !props.disabled,
                    ...props.group ? undefined : {
                        mode: props.mode
                    },
                    ...props.disabled ? {} : functions
                }, slots.default);
            };
        }
    });
}
function $e00858d23308ef8c$export$1b9d9cdc486aa921(name, functions) {
    let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'in-out';
    return (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
        name: name,
        props: {
            mode: {
                type: String,
                default: mode
            },
            disabled: {
                type: Boolean,
                default: (0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)()
            },
            group: Boolean,
            hideOnLeave: Boolean
        },
        setup (props, _ref2) {
            let { slots: slots } = _ref2;
            const tag = props.group ? (0, $eeJ70.TransitionGroup) : (0, $eeJ70.Transition);
            return ()=>{
                return (0, $TusQn.h)(tag, {
                    name: props.disabled ? '' : name,
                    css: !props.disabled,
                    // mode: props.mode, // TODO: vuejs/vue-next#3104
                    ...props.disabled ? {} : {
                        ...functions,
                        onLeave: (el)=>{
                            if (props.hideOnLeave) el.style.setProperty('display', 'none', 'important');
                            else functions.onLeave?.(el);
                        }
                    }
                }, slots.default);
            };
        }
    });
}


function $ded41289a6a38e5c$export$2e2bcd8739ae039() {
    let expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'y';
    return {
        onBeforeEnter (el) {
            el._parent = el.parentNode;
            el._initialStyle = {
                transition: el.style.transition,
                overflow: el.style.overflow,
                width: el.style.width,
                height: el.style.height
            };
        },
        onEnter (el) {
            const initialStyle = el._initialStyle;
            if (!initialStyle) return;
            el.style.setProperty('transition', 'none', 'important');
            // Hide overflow to account for collapsed margins in the calculated height
            el.style.overflow = 'hidden';
            const offsetWidth = `${el.offsetWidth}px`;
            const offsetHeight = `${el.offsetHeight}px`;
            if ([
                'x',
                'both'
            ].includes(type)) el.style.width = '0';
            if ([
                'y',
                'both'
            ].includes(type)) el.style.height = '0';
            el.offsetHeight; // force reflow
            el.style.transition = initialStyle.transition;
            if (expandedParentClass && el._parent) el._parent.classList.add(expandedParentClass);
            requestAnimationFrame(()=>{
                if ([
                    'x',
                    'both'
                ].includes(type)) el.style.width = offsetWidth;
                if ([
                    'y',
                    'both'
                ].includes(type)) el.style.height = offsetHeight;
            });
        },
        onAfterEnter: resetStyles,
        onEnterCancelled: resetStyles,
        onLeave (el) {
            el._initialStyle = {
                transition: '',
                overflow: el.style.overflow,
                width: el.style.width,
                height: el.style.height
            };
            el.style.overflow = 'hidden';
            if ([
                'x',
                'both'
            ].includes(type)) el.style.width = `${el.offsetWidth}px`;
            if ([
                'y',
                'both'
            ].includes(type)) el.style.height = `${el.offsetHeight}px`;
            el.offsetHeight; // force reflow
            requestAnimationFrame(()=>{
                if ([
                    'x',
                    'both'
                ].includes(type)) el.style.width = '0';
                if ([
                    'y',
                    'both'
                ].includes(type)) el.style.height = '0';
            });
        },
        onAfterLeave: onAfterLeave,
        onLeaveCancelled: onAfterLeave
    };
    function onAfterLeave(el) {
        if (expandedParentClass && el._parent) el._parent.classList.remove(expandedParentClass);
        resetStyles(el);
    }
    function resetStyles(el) {
        if (!el._initialStyle) return;
        const { width: w, height: h } = el._initialStyle;
        el.style.overflow = el._initialStyle.overflow;
        if (w != null && [
            'x',
            'both'
        ].includes(type)) el.style.width = w;
        if (h != null && [
            'y',
            'both'
        ].includes(type)) el.style.height = h;
        delete el._initialStyle;
    }
}


// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");
// Utilities
class $300dbef0cc33a399$export$e71c4d32a2263218 {
    constructor(args){
        const pageScale = document.body.currentCSSZoom ?? 1;
        const isElement = args instanceof Element;
        const factor = isElement ? 1 + (1 - pageScale) / pageScale : 1;
        const { x: x, y: y, width: width, height: height } = isElement ? args.getBoundingClientRect() : args;
        this.x = x * factor;
        this.y = y * factor;
        this.width = width * factor;
        this.height = height * factor;
    }
    get top() {
        return this.y;
    }
    get bottom() {
        return this.y + this.height;
    }
    get left() {
        return this.x;
    }
    get right() {
        return this.x + this.width;
    }
}
function $300dbef0cc33a399$export$f63a1e5ecde5e3c4(a, b) {
    return {
        x: {
            before: Math.max(0, b.left - a.left),
            after: Math.max(0, a.right - b.right)
        },
        y: {
            before: Math.max(0, b.top - a.top),
            after: Math.max(0, a.bottom - b.bottom)
        }
    };
}
function $300dbef0cc33a399$export$abd662d1b0b39d49(target) {
    if (Array.isArray(target)) {
        const pageScale = document.body.currentCSSZoom ?? 1;
        const factor = 1 + (1 - pageScale) / pageScale;
        return new $300dbef0cc33a399$export$e71c4d32a2263218({
            x: target[0] * factor,
            y: target[1] * factor,
            width: 0 * factor,
            height: 0 * factor
        });
    } else return new $300dbef0cc33a399$export$e71c4d32a2263218(target);
}
function $300dbef0cc33a399$export$6f532722e5bcfbac(el) {
    if (el === document.documentElement) {
        if (!visualViewport) return new $300dbef0cc33a399$export$e71c4d32a2263218({
            x: 0,
            y: 0,
            width: document.documentElement.clientWidth,
            height: document.documentElement.clientHeight
        });
        else {
            const pageScale = document.body.currentCSSZoom ?? 1;
            return new $300dbef0cc33a399$export$e71c4d32a2263218({
                x: visualViewport.scale > 1 ? 0 : visualViewport.offsetLeft,
                y: visualViewport.scale > 1 ? 0 : visualViewport.offsetTop,
                width: visualViewport.width * visualViewport.scale / pageScale,
                height: visualViewport.height * visualViewport.scale / pageScale
            });
        }
    } else return new $300dbef0cc33a399$export$e71c4d32a2263218(el);
}


function $d14b85b5564a2ed0$export$38c5b68336448fc8(el) {
    const rect = new (0, $300dbef0cc33a399$export$e71c4d32a2263218)(el);
    const style = getComputedStyle(el);
    const tx = style.transform;
    if (tx) {
        let ta, sx, sy, dx, dy;
        if (tx.startsWith('matrix3d(')) {
            ta = tx.slice(9, -1).split(/, /);
            sx = Number(ta[0]);
            sy = Number(ta[5]);
            dx = Number(ta[12]);
            dy = Number(ta[13]);
        } else if (tx.startsWith('matrix(')) {
            ta = tx.slice(7, -1).split(/, /);
            sx = Number(ta[0]);
            sy = Number(ta[3]);
            dx = Number(ta[4]);
            dy = Number(ta[5]);
        } else return new (0, $300dbef0cc33a399$export$e71c4d32a2263218)(rect);
        const to = style.transformOrigin;
        const x = rect.x - dx - (1 - sx) * parseFloat(to);
        const y = rect.y - dy - (1 - sy) * parseFloat(to.slice(to.indexOf(' ') + 1));
        const w = sx ? rect.width / sx : el.offsetWidth + 1;
        const h = sy ? rect.height / sy : el.offsetHeight + 1;
        return new (0, $300dbef0cc33a399$export$e71c4d32a2263218)({
            x: x,
            y: y,
            width: w,
            height: h
        });
    } else return new (0, $300dbef0cc33a399$export$e71c4d32a2263218)(rect);
}
function $d14b85b5564a2ed0$export$e3607ec2d7a891c4(el, keyframes, options) {
    if (typeof el.animate === 'undefined') return {
        finished: Promise.resolve()
    };
    let animation;
    try {
        animation = el.animate(keyframes, options);
    } catch (err) {
        return {
            finished: Promise.resolve()
        };
    }
    if (typeof animation.finished === 'undefined') animation.finished = new Promise((resolve)=>{
        animation.onfinish = ()=>{
            resolve(animation);
        };
    });
    return animation;
}



const $6d83cccc3a7f7c51$export$4284bdd72239dfb4 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    target: [
        Object,
        Array
    ]
}, 'v-dialog-transition');
const $6d83cccc3a7f7c51$var$saved = new WeakMap();
const $6d83cccc3a7f7c51$export$9778a08df954f36c = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDialogTransition',
    props: $6d83cccc3a7f7c51$export$4284bdd72239dfb4(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const functions = {
            onBeforeEnter (el) {
                el.style.pointerEvents = 'none';
                el.style.visibility = 'hidden';
            },
            async onEnter (el, done) {
                await new Promise((resolve)=>requestAnimationFrame(resolve));
                await new Promise((resolve)=>requestAnimationFrame(resolve));
                el.style.visibility = '';
                const dimensions = $6d83cccc3a7f7c51$var$getDimensions(props.target, el);
                const { x: x, y: y, sx: sx, sy: sy, speed: speed } = dimensions;
                $6d83cccc3a7f7c51$var$saved.set(el, dimensions);
                if ((0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)()) (0, $d14b85b5564a2ed0$export$e3607ec2d7a891c4)(el, [
                    {
                        opacity: 0
                    },
                    {}
                ], {
                    duration: 125 * speed,
                    easing: (0, $f725c9134abb2fa7$export$749971f7490e97da)
                }).finished.then(()=>done());
                else {
                    const animation = (0, $d14b85b5564a2ed0$export$e3607ec2d7a891c4)(el, [
                        {
                            transform: `translate(${x}px, ${y}px) scale(${sx}, ${sy})`,
                            opacity: 0
                        },
                        {}
                    ], {
                        duration: 225 * speed,
                        easing: (0, $f725c9134abb2fa7$export$749971f7490e97da)
                    });
                    $6d83cccc3a7f7c51$var$getChildren(el)?.forEach((el)=>{
                        (0, $d14b85b5564a2ed0$export$e3607ec2d7a891c4)(el, [
                            {
                                opacity: 0
                            },
                            {
                                opacity: 0,
                                offset: 0.33
                            },
                            {}
                        ], {
                            duration: 225 * 2 * speed,
                            easing: (0, $f725c9134abb2fa7$export$bf86e2ccec972a06)
                        });
                    });
                    animation.finished.then(()=>done());
                }
            },
            onAfterEnter (el) {
                el.style.removeProperty('pointer-events');
            },
            onBeforeLeave (el) {
                el.style.pointerEvents = 'none';
            },
            async onLeave (el, done) {
                await new Promise((resolve)=>requestAnimationFrame(resolve));
                let dimensions;
                if (!$6d83cccc3a7f7c51$var$saved.has(el) || Array.isArray(props.target) || props.target.offsetParent || props.target.getClientRects().length) dimensions = $6d83cccc3a7f7c51$var$getDimensions(props.target, el);
                else dimensions = $6d83cccc3a7f7c51$var$saved.get(el);
                const { x: x, y: y, sx: sx, sy: sy, speed: speed } = dimensions;
                if ((0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)()) (0, $d14b85b5564a2ed0$export$e3607ec2d7a891c4)(el, [
                    {},
                    {
                        opacity: 0
                    }
                ], {
                    duration: 85 * speed,
                    easing: (0, $f725c9134abb2fa7$export$7b997795cd9fbbcb)
                }).finished.then(()=>done());
                else {
                    const animation = (0, $d14b85b5564a2ed0$export$e3607ec2d7a891c4)(el, [
                        {},
                        {
                            transform: `translate(${x}px, ${y}px) scale(${sx}, ${sy})`,
                            opacity: 0
                        }
                    ], {
                        duration: 125 * speed,
                        easing: (0, $f725c9134abb2fa7$export$7b997795cd9fbbcb)
                    });
                    animation.finished.then(()=>done());
                    $6d83cccc3a7f7c51$var$getChildren(el)?.forEach((el)=>{
                        (0, $d14b85b5564a2ed0$export$e3607ec2d7a891c4)(el, [
                            {},
                            {
                                opacity: 0,
                                offset: 0.2
                            },
                            {
                                opacity: 0
                            }
                        ], {
                            duration: 125 * 2 * speed,
                            easing: (0, $f725c9134abb2fa7$export$bf86e2ccec972a06)
                        });
                    });
                }
            },
            onAfterLeave (el) {
                el.style.removeProperty('pointer-events');
            }
        };
        return ()=>{
            return props.target ? (0, $TusQn.createVNode)((0, $eeJ70.Transition), (0, $TusQn.mergeProps)({
                "name": "dialog-transition"
            }, functions, {
                "css": false
            }), slots) : (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
                "name": "dialog-transition"
            }, slots);
        };
    }
});
/** Animatable children (card, sheet, list) */ function $6d83cccc3a7f7c51$var$getChildren(el) {
    const els = el.querySelector(':scope > .v-card, :scope > .v-sheet, :scope > .v-list')?.children;
    return els && [
        ...els
    ];
}
function $6d83cccc3a7f7c51$var$getDimensions(target, el) {
    const targetBox = (0, $300dbef0cc33a399$export$abd662d1b0b39d49)(target);
    const elBox = (0, $d14b85b5564a2ed0$export$38c5b68336448fc8)(el);
    const [originX, originY] = getComputedStyle(el).transformOrigin.split(' ').map((v)=>parseFloat(v));
    const [anchorSide, anchorOffset] = getComputedStyle(el).getPropertyValue('--v-overlay-anchor-origin').split(' ');
    let offsetX = targetBox.left + targetBox.width / 2;
    if (anchorSide === 'left' || anchorOffset === 'left') offsetX -= targetBox.width / 2;
    else if (anchorSide === 'right' || anchorOffset === 'right') offsetX += targetBox.width / 2;
    let offsetY = targetBox.top + targetBox.height / 2;
    if (anchorSide === 'top' || anchorOffset === 'top') offsetY -= targetBox.height / 2;
    else if (anchorSide === 'bottom' || anchorOffset === 'bottom') offsetY += targetBox.height / 2;
    const tsx = targetBox.width / elBox.width;
    const tsy = targetBox.height / elBox.height;
    const maxs = Math.max(1, tsx, tsy);
    const sx = tsx / maxs || 0;
    const sy = tsy / maxs || 0;
    // Animate elements larger than 12% of the screen area up to 1.5x slower
    const asa = elBox.width * elBox.height / (window.innerWidth * window.innerHeight);
    const speed = asa > 0.12 ? Math.min(1.5, (asa - 0.12) * 10 + 1) : 1;
    return {
        x: offsetX - (originX + elBox.left),
        y: offsetY - (originY + elBox.top),
        sx: sx,
        sy: sy,
        speed: speed
    };
}


const $7ec1b0ef33b04126$export$e41ac6a607c71844 = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('fab-transition', 'center center', 'out-in');
const $7ec1b0ef33b04126$export$bc7471894fc4ecf0 = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('dialog-bottom-transition');
const $7ec1b0ef33b04126$export$32d110114067327f = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('dialog-top-transition');
const $7ec1b0ef33b04126$export$13ce8c44634b158c = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('fade-transition');
const $7ec1b0ef33b04126$export$5d9397de61546474 = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('scale-transition');
const $7ec1b0ef33b04126$export$ec1a91eaaf33fc1a = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('scroll-x-transition');
const $7ec1b0ef33b04126$export$1c31b47261d53f89 = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('scroll-x-reverse-transition');
const $7ec1b0ef33b04126$export$727e6b700671cc9c = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('scroll-y-transition');
const $7ec1b0ef33b04126$export$65ab0ce785466dae = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('scroll-y-reverse-transition');
const $7ec1b0ef33b04126$export$6997cd6ab1645575 = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('slide-x-transition');
const $7ec1b0ef33b04126$export$cb28325bdb6e20c2 = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('slide-x-reverse-transition');
const $7ec1b0ef33b04126$export$5d9f875feb4d9ee6 = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('slide-y-transition');
const $7ec1b0ef33b04126$export$f24f0bc0b4f2bbd2 = (0, $e00858d23308ef8c$export$a21bd7b30fd40589)('slide-y-reverse-transition');
const $7ec1b0ef33b04126$export$1cd1e8deb97d798d = (0, $e00858d23308ef8c$export$1b9d9cdc486aa921)('expand-transition', (0, $ded41289a6a38e5c$export$2e2bcd8739ae039)());
const $7ec1b0ef33b04126$export$d54edbcba7869f36 = (0, $e00858d23308ef8c$export$1b9d9cdc486aa921)('expand-x-transition', (0, $ded41289a6a38e5c$export$2e2bcd8739ae039)('', 'x'));
const $7ec1b0ef33b04126$export$72ef08ce8c082a3c = (0, $e00858d23308ef8c$export$1b9d9cdc486aa921)('expand-both-transition', (0, $ded41289a6a38e5c$export$2e2bcd8739ae039)('', 'both'));


// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $d16c59ae67056c43$export$deb03e83a53b330e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    defaults: Object,
    disabled: Boolean,
    reset: [
        Number,
        String
    ],
    root: [
        Boolean,
        String
    ],
    scoped: Boolean
}, 'VDefaultsProvider');
const $d16c59ae67056c43$export$ee4fab30a254e5ee = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)(false)({
    name: 'VDefaultsProvider',
    props: $d16c59ae67056c43$export$deb03e83a53b330e(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { defaults: defaults, disabled: disabled, reset: reset, root: root, scoped: scoped } = (0, $01W3b.toRefs)(props);
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)(defaults, {
            reset: reset,
            root: root,
            scoped: scoped,
            disabled: disabled
        });
        return ()=>slots.default?.();
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $159635b8c4ce014b$export$f37f46640cc8dd75 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    height: [
        Number,
        String
    ],
    maxHeight: [
        Number,
        String
    ],
    maxWidth: [
        Number,
        String
    ],
    minHeight: [
        Number,
        String
    ],
    minWidth: [
        Number,
        String
    ],
    width: [
        Number,
        String
    ]
}, 'dimension');
function $159635b8c4ce014b$export$2b21de4fc4968be5(props) {
    const dimensionStyles = (0, $01W3b.computed)(()=>{
        const styles = {};
        const height = (0, $8590040a7833369a$export$286ad215293a0860)(props.height);
        const maxHeight = (0, $8590040a7833369a$export$286ad215293a0860)(props.maxHeight);
        const maxWidth = (0, $8590040a7833369a$export$286ad215293a0860)(props.maxWidth);
        const minHeight = (0, $8590040a7833369a$export$286ad215293a0860)(props.minHeight);
        const minWidth = (0, $8590040a7833369a$export$286ad215293a0860)(props.minWidth);
        const width = (0, $8590040a7833369a$export$286ad215293a0860)(props.width);
        if (height != null) styles.height = height;
        if (maxHeight != null) styles.maxHeight = maxHeight;
        if (maxWidth != null) styles.maxWidth = maxWidth;
        if (minHeight != null) styles.minHeight = minHeight;
        if (minWidth != null) styles.minWidth = minWidth;
        if (width != null) styles.width = width;
        return styles;
    });
    return {
        dimensionStyles: dimensionStyles
    };
}



function $e95efe0a40ff253f$export$745903863ef9867b(props) {
    return {
        aspectStyles: (0, $01W3b.computed)(()=>{
            const ratio = Number(props.aspectRatio);
            return ratio ? {
                paddingBottom: String(1 / ratio * 100) + '%'
            } : undefined;
        })
    };
}
const $e95efe0a40ff253f$export$7e0413dfe71e96cc = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    aspectRatio: [
        String,
        Number
    ],
    contentClass: null,
    inline: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)()
}, 'VResponsive');
const $e95efe0a40ff253f$export$fede2db8a3499569 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VResponsive',
    props: $e95efe0a40ff253f$export$7e0413dfe71e96cc(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { aspectStyles: aspectStyles } = $e95efe0a40ff253f$export$745903863ef9867b(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-responsive',
                    {
                        'v-responsive--inline': props.inline
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-responsive__sizer",
                    "style": (0, $8POXm.normalizeStyle)(aspectStyles.value)
                }, null),
                slots.additional?.(),
                slots.default && (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-responsive__content',
                        props.contentClass
                    ])
                }, [
                    slots.default()
                ])
            ]));
        return {};
    }
});


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

function $3cd60c4ecc68ec90$export$5aadd9c0606af5c2(colors) {
    return (0, $8590040a7833369a$export$fe6a5b56d01db4f5)(()=>{
        const { class: colorClasses, style: colorStyles } = $3cd60c4ecc68ec90$export$7c60041aa39ebc59(colors);
        return {
            colorClasses: colorClasses,
            colorStyles: colorStyles
        };
    });
}
function $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec(color) {
    const { colorClasses: textColorClasses, colorStyles: textColorStyles } = $3cd60c4ecc68ec90$export$5aadd9c0606af5c2(()=>({
            text: (0, $01W3b.toValue)(color)
        }));
    return {
        textColorClasses: textColorClasses,
        textColorStyles: textColorStyles
    };
}
function $3cd60c4ecc68ec90$export$de4733d8105ed3f2(color) {
    const { colorClasses: backgroundColorClasses, colorStyles: backgroundColorStyles } = $3cd60c4ecc68ec90$export$5aadd9c0606af5c2(()=>({
            background: (0, $01W3b.toValue)(color)
        }));
    return {
        backgroundColorClasses: backgroundColorClasses,
        backgroundColorStyles: backgroundColorStyles
    };
}
function $3cd60c4ecc68ec90$var$normalizeColors(colors) {
    return {
        text: typeof colors.text === 'string' ? colors.text.replace(/^text-/, '') : colors.text,
        background: typeof colors.background === 'string' ? colors.background.replace(/^bg-/, '') : colors.background
    };
}
function $3cd60c4ecc68ec90$export$7c60041aa39ebc59(colors) {
    const _colors = $3cd60c4ecc68ec90$var$normalizeColors((0, $01W3b.toValue)(colors));
    const classes = [];
    const styles = {};
    if (_colors.background) {
        if ((0, $44de4fc7c15df730$export$773f39ab8b9369ea)(_colors.background)) {
            styles.backgroundColor = _colors.background;
            if (!_colors.text && (0, $44de4fc7c15df730$export$d546aa95bdefc037)(_colors.background)) {
                const backgroundColor = (0, $44de4fc7c15df730$export$6e865ea70d7724f)(_colors.background);
                if (backgroundColor.a == null || backgroundColor.a === 1) {
                    const textColor = (0, $44de4fc7c15df730$export$27d3ce2b326d356d)(backgroundColor);
                    styles.color = textColor;
                    styles.caretColor = textColor;
                }
            }
        } else classes.push(`bg-${_colors.background}`);
    }
    if (_colors.text) {
        if ((0, $44de4fc7c15df730$export$773f39ab8b9369ea)(_colors.text)) {
            styles.color = _colors.text;
            styles.caretColor = _colors.text;
        } else classes.push(`text-${_colors.text}`);
    }
    return {
        class: classes,
        style: styles
    };
}



// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $64be4fce992a7084$export$7bbc36c81a352d50 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    rounded: {
        type: [
            Boolean,
            Number,
            String
        ],
        default: undefined
    },
    tile: Boolean
}, 'rounded');
function $64be4fce992a7084$export$36c3a2ea94409e5e(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    const roundedClasses = (0, $01W3b.computed)(()=>{
        const rounded = (0, $01W3b.isRef)(props) ? props.value : props.rounded;
        const tile = (0, $01W3b.isRef)(props) ? false : props.tile;
        const classes = [];
        if (tile || rounded === false) classes.push('rounded-0');
        else if (rounded === true || rounded === '') classes.push(`${name}--rounded`);
        else if (typeof rounded === 'string' || rounded === 0) for (const value of String(rounded).split(' '))classes.push(`rounded-${value}`);
        return classes;
    });
    return {
        roundedClasses: roundedClasses
    };
}


// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");

const $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    transition: {
        type: null,
        default: 'fade-transition',
        validator: (val)=>val !== true
    }
}, 'transition');
const $fcbabbbc201ae8b0$export$dee7d6ab6955c95e = (props, _ref)=>{
    let { slots: slots } = _ref;
    const { transition: transition, disabled: disabled, group: group, ...rest } = props;
    const { component: component = group ? (0, $eeJ70.TransitionGroup) : (0, $eeJ70.Transition), ...customProps } = (0, $8590040a7833369a$export$a6cdc56e425d0d0a)(transition) ? transition : {};
    let transitionProps;
    if ((0, $8590040a7833369a$export$a6cdc56e425d0d0a)(transition)) transitionProps = (0, $TusQn.mergeProps)(customProps, (0, $8590040a7833369a$export$bdca1cff95cf548c)({
        disabled: disabled,
        group: group
    }), rest);
    else transitionProps = (0, $TusQn.mergeProps)({
        name: disabled || !transition ? '' : transition
    }, rest);
    return (0, $TusQn.h)(component, transitionProps, slots);
};


// Utilities

function $8d31333abb7bf4e7$var$mounted(el, binding) {
    if (!(0, $90a48ad178b943d3$export$8cb82f5817a92ac4)) return;
    const modifiers = binding.modifiers || {};
    const value = binding.value;
    const { handler: handler, options: options } = typeof value === 'object' ? value : {
        handler: value,
        options: {}
    };
    const observer = new IntersectionObserver(function() {
        let entries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let observer = arguments.length > 1 ? arguments[1] : undefined;
        const _observe = el._observe?.[binding.instance.$.uid];
        if (!_observe) return; // Just in case, should never fire
        const isIntersecting = entries.some((entry)=>entry.isIntersecting);
        // If is not quiet or has already been
        // initted, invoke the user callback
        if (handler && (!modifiers.quiet || _observe.init) && (!modifiers.once || isIntersecting || _observe.init)) handler(isIntersecting, entries, observer);
        if (isIntersecting && modifiers.once) $8d31333abb7bf4e7$var$unmounted(el, binding);
        else _observe.init = true;
    }, options);
    el._observe = Object(el._observe);
    el._observe[binding.instance.$.uid] = {
        init: false,
        observer: observer
    };
    observer.observe(el);
}
function $8d31333abb7bf4e7$var$unmounted(el, binding) {
    const observe = el._observe?.[binding.instance.$.uid];
    if (!observe) return;
    observe.observer.unobserve(el);
    delete el._observe[binding.instance.$.uid];
}
const $8d31333abb7bf4e7$export$56a6b724e0c8deeb = {
    mounted: $8d31333abb7bf4e7$var$mounted,
    unmounted: $8d31333abb7bf4e7$var$unmounted,
    updated: (el, binding)=>{
        if (el._observe?.[binding.instance.$.uid]) {
            $8d31333abb7bf4e7$var$unmounted(el, binding);
            $8d31333abb7bf4e7$var$mounted(el, binding);
        }
    }
};
var $8d31333abb7bf4e7$export$2e2bcd8739ae039 = $8d31333abb7bf4e7$export$56a6b724e0c8deeb;



const $b2937780237888c4$export$aeeda8cb473ca4b4 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    absolute: Boolean,
    alt: String,
    cover: Boolean,
    color: String,
    draggable: {
        type: [
            Boolean,
            String
        ],
        default: undefined
    },
    eager: Boolean,
    gradient: String,
    imageClass: null,
    lazySrc: String,
    options: {
        type: Object,
        // For more information on types, navigate to:
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        default: ()=>({
                root: undefined,
                rootMargin: undefined,
                threshold: undefined
            })
    },
    sizes: String,
    src: {
        type: [
            String,
            Object
        ],
        default: ''
    },
    crossorigin: String,
    referrerpolicy: String,
    srcset: String,
    position: String,
    ...(0, $e95efe0a40ff253f$export$7e0413dfe71e96cc)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e)()
}, 'VImg');
const $b2937780237888c4$export$126ec614c536f27c = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VImg',
    directives: {
        vIntersect: $8d31333abb7bf4e7$export$2e2bcd8739ae039
    },
    props: $b2937780237888c4$export$aeeda8cb473ca4b4(),
    emits: {
        loadstart: (value)=>true,
        load: (value)=>true,
        error: (value)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('VImg');
        const currentSrc = (0, $01W3b.shallowRef)(''); // Set from srcset
        const image = (0, $01W3b.ref)();
        const state = (0, $01W3b.shallowRef)(props.eager ? 'loading' : 'idle');
        const naturalWidth = (0, $01W3b.shallowRef)();
        const naturalHeight = (0, $01W3b.shallowRef)();
        const normalisedSrc = (0, $01W3b.computed)(()=>{
            return props.src && typeof props.src === 'object' ? {
                src: props.src.src,
                srcset: props.srcset || props.src.srcset,
                lazySrc: props.lazySrc || props.src.lazySrc,
                aspect: Number(props.aspectRatio || props.src.aspect || 0)
            } : {
                src: props.src,
                srcset: props.srcset,
                lazySrc: props.lazySrc,
                aspect: Number(props.aspectRatio || 0)
            };
        });
        const aspectRatio = (0, $01W3b.computed)(()=>{
            return normalisedSrc.value.aspect || naturalWidth.value / naturalHeight.value || 0;
        });
        (0, $01W3b.watch)(()=>props.src, ()=>{
            init(state.value !== 'idle');
        });
        (0, $01W3b.watch)(aspectRatio, (val, oldVal)=>{
            if (!val && oldVal && image.value) pollForSize(image.value);
        });
        // TODO: getSrc when window width changes
        (0, $TusQn.onBeforeMount)(()=>init());
        function init(isIntersecting) {
            if (props.eager && isIntersecting) return;
            if ((0, $90a48ad178b943d3$export$8cb82f5817a92ac4) && !isIntersecting && !props.eager) return;
            state.value = 'loading';
            if (normalisedSrc.value.lazySrc) {
                const lazyImg = new Image();
                lazyImg.src = normalisedSrc.value.lazySrc;
                pollForSize(lazyImg, null);
            }
            if (!normalisedSrc.value.src) return;
            (0, $TusQn.nextTick)(()=>{
                emit('loadstart', image.value?.currentSrc || normalisedSrc.value.src);
                setTimeout(()=>{
                    if (vm.isUnmounted) return;
                    if (image.value?.complete) {
                        if (!image.value.naturalWidth) onError();
                        if (state.value === 'error') return;
                        if (!aspectRatio.value) pollForSize(image.value, null);
                        if (state.value === 'loading') onLoad();
                    } else {
                        if (!aspectRatio.value) pollForSize(image.value);
                        getSrc();
                    }
                });
            });
        }
        function onLoad() {
            if (vm.isUnmounted) return;
            getSrc();
            pollForSize(image.value);
            state.value = 'loaded';
            emit('load', image.value?.currentSrc || normalisedSrc.value.src);
        }
        function onError() {
            if (vm.isUnmounted) return;
            state.value = 'error';
            emit('error', image.value?.currentSrc || normalisedSrc.value.src);
        }
        function getSrc() {
            const img = image.value;
            if (img) currentSrc.value = img.currentSrc || img.src;
        }
        let timer = -1;
        (0, $TusQn.onBeforeUnmount)(()=>{
            clearTimeout(timer);
        });
        function pollForSize(img) {
            let timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
            const poll = ()=>{
                clearTimeout(timer);
                if (vm.isUnmounted) return;
                const { naturalHeight: imgHeight, naturalWidth: imgWidth } = img;
                if (imgHeight || imgWidth) {
                    naturalWidth.value = imgWidth;
                    naturalHeight.value = imgHeight;
                } else if (!img.complete && state.value === 'loading' && timeout != null) timer = window.setTimeout(poll, timeout);
                else if (img.currentSrc.endsWith('.svg') || img.currentSrc.startsWith('data:image/svg+xml')) {
                    naturalWidth.value = 1;
                    naturalHeight.value = 1;
                }
            };
            poll();
        }
        const containClasses = (0, $01W3b.toRef)(()=>({
                'v-img__img--cover': props.cover,
                'v-img__img--contain': !props.cover
            }));
        const __image = ()=>{
            if (!normalisedSrc.value.src || state.value === 'idle') return null;
            const img = (0, $TusQn.createElementVNode)("img", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-img__img',
                    containClasses.value,
                    props.imageClass
                ]),
                "style": {
                    objectPosition: props.position
                },
                "crossorigin": props.crossorigin,
                "src": normalisedSrc.value.src,
                "srcset": normalisedSrc.value.srcset,
                "alt": props.alt,
                "referrerpolicy": props.referrerpolicy,
                "draggable": props.draggable,
                "sizes": props.sizes,
                "ref": image,
                "onLoad": onLoad,
                "onError": onError
            }, null);
            const sources = slots.sources?.();
            return (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                "transition": props.transition,
                "appear": true
            }, {
                default: ()=>[
                        (0, $TusQn.withDirectives)(sources ? (0, $TusQn.createElementVNode)("picture", {
                            "class": "v-img__picture"
                        }, [
                            sources,
                            img
                        ]) : img, [
                            [
                                (0, $eeJ70.vShow),
                                state.value === 'loaded'
                            ]
                        ])
                    ]
            });
        };
        const __preloadImage = ()=>(0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                "transition": props.transition
            }, {
                default: ()=>[
                        normalisedSrc.value.lazySrc && state.value !== 'loaded' && (0, $TusQn.createElementVNode)("img", {
                            "class": (0, $8POXm.normalizeClass)([
                                'v-img__img',
                                'v-img__img--preload',
                                containClasses.value
                            ]),
                            "style": {
                                objectPosition: props.position
                            },
                            "crossorigin": props.crossorigin,
                            "src": normalisedSrc.value.lazySrc,
                            "alt": props.alt,
                            "referrerpolicy": props.referrerpolicy,
                            "draggable": props.draggable
                        }, null)
                    ]
            });
        const __placeholder = ()=>{
            if (!slots.placeholder) return null;
            return (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                "transition": props.transition,
                "appear": true
            }, {
                default: ()=>[
                        (state.value === 'loading' || state.value === 'error' && !slots.error) && (0, $TusQn.createElementVNode)("div", {
                            "class": "v-img__placeholder"
                        }, [
                            slots.placeholder()
                        ])
                    ]
            });
        };
        const __error = ()=>{
            if (!slots.error) return null;
            return (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                "transition": props.transition,
                "appear": true
            }, {
                default: ()=>[
                        state.value === 'error' && (0, $TusQn.createElementVNode)("div", {
                            "class": "v-img__error"
                        }, [
                            slots.error()
                        ])
                    ]
            });
        };
        const __gradient = ()=>{
            if (!props.gradient) return null;
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-img__gradient",
                "style": {
                    backgroundImage: `linear-gradient(${props.gradient})`
                }
            }, null);
        };
        const isBooted = (0, $01W3b.shallowRef)(false);
        {
            const stop = (0, $01W3b.watch)(aspectRatio, (val)=>{
                if (val) {
                    // Doesn't work with nextTick, idk why
                    requestAnimationFrame(()=>{
                        requestAnimationFrame(()=>{
                            isBooted.value = true;
                        });
                    });
                    stop();
                }
            });
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const responsiveProps = (0, $e95efe0a40ff253f$export$fede2db8a3499569).filterProps(props);
            return (0, $TusQn.withDirectives)((0, $TusQn.createVNode)((0, $e95efe0a40ff253f$export$fede2db8a3499569), (0, $TusQn.mergeProps)({
                "class": [
                    'v-img',
                    {
                        'v-img--absolute': props.absolute,
                        'v-img--booting': !isBooted.value,
                        'v-img--fit-content': props.width === 'fit-content'
                    },
                    backgroundColorClasses.value,
                    roundedClasses.value,
                    props.class
                ],
                "style": [
                    {
                        width: (0, $8590040a7833369a$export$286ad215293a0860)(props.width === 'auto' ? naturalWidth.value : props.width)
                    },
                    backgroundColorStyles.value,
                    props.style
                ]
            }, responsiveProps, {
                "aspectRatio": aspectRatio.value,
                "aria-label": props.alt,
                "role": props.alt ? 'img' : undefined
            }), {
                additional: ()=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createVNode)(__image, null, null),
                        (0, $TusQn.createVNode)(__preloadImage, null, null),
                        (0, $TusQn.createVNode)(__gradient, null, null),
                        (0, $TusQn.createVNode)(__placeholder, null, null),
                        (0, $TusQn.createVNode)(__error, null, null)
                    ]),
                default: slots.default
            }), [
                [
                    (0, $8d31333abb7bf4e7$export$2e2bcd8739ae039),
                    {
                        handler: init,
                        options: props.options
                    },
                    null,
                    {
                        once: true
                    }
                ]
            ]);
        });
        return {
            currentSrc: currentSrc,
            image: image,
            state: state,
            naturalWidth: naturalWidth,
            naturalHeight: naturalHeight
        };
    }
});


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $fa4dc4422e1db62c$export$70b8b174e7d601ce = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    border: [
        Boolean,
        Number,
        String
    ]
}, 'border');
function $fa4dc4422e1db62c$export$6185a16c7b2926fb(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    const borderClasses = (0, $01W3b.computed)(()=>{
        const border = props.border;
        if (border === true || border === '') return `${name}--border`;
        else if (typeof border === 'string' || border === 0) return String(border).split(' ').map((v)=>`border-${v}`);
        return [];
    });
    return {
        borderClasses: borderClasses
    };
}





// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $b79619148bc437a4$export$858059d20a48304b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    elevation: {
        type: [
            Number,
            String
        ],
        validator (v) {
            const value = parseInt(v);
            return !isNaN(value) && value >= 0 && // Material Design has a maximum elevation of 24
            // https://material.io/design/environment/elevation.html#default-elevations
            value <= 24;
        }
    }
}, 'elevation');
function $b79619148bc437a4$export$617be03f9f20f78c(props) {
    const elevationClasses = (0, $01W3b.toRef)(()=>{
        const elevation = (0, $01W3b.isRef)(props) ? props.value : props.elevation;
        if (elevation == null) return [];
        return [
            `elevation-${elevation}`
        ];
    });
    return {
        elevationClasses: elevationClasses
    };
}



// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
// Utilities

const $aa564bd137c45a62$var$block = [
    'top',
    'bottom'
];
const $aa564bd137c45a62$var$inline = [
    'start',
    'end',
    'left',
    'right'
];
function $aa564bd137c45a62$export$49d416a6d8a07bbb(anchor, isRtl) {
    let [side, align] = anchor.split(' ');
    if (!align) align = (0, $8590040a7833369a$export$ee2e0f811dca1807)($aa564bd137c45a62$var$block, side) ? 'start' : (0, $8590040a7833369a$export$ee2e0f811dca1807)($aa564bd137c45a62$var$inline, side) ? 'top' : 'center';
    return {
        side: $aa564bd137c45a62$export$b56cedd93dedafd4(side, isRtl),
        align: $aa564bd137c45a62$export$b56cedd93dedafd4(align, isRtl)
    };
}
function $aa564bd137c45a62$export$b56cedd93dedafd4(str, isRtl) {
    if (str === 'start') return isRtl ? 'right' : 'left';
    if (str === 'end') return isRtl ? 'left' : 'right';
    return str;
}
function $aa564bd137c45a62$export$1bbdb13cd7175683(anchor) {
    return {
        side: ({
            center: 'center',
            top: 'bottom',
            bottom: 'top',
            left: 'right',
            right: 'left'
        })[anchor.side],
        align: anchor.align
    };
}
function $aa564bd137c45a62$export$ae4fe0e90a9c983d(anchor) {
    return {
        side: anchor.side,
        align: ({
            center: 'center',
            top: 'bottom',
            bottom: 'top',
            left: 'right',
            right: 'left'
        })[anchor.align]
    };
}
function $aa564bd137c45a62$export$af41802054d9b2a8(anchor) {
    return {
        side: anchor.align,
        align: anchor.side
    };
}
function $aa564bd137c45a62$export$8a3a0724d206787a(anchor) {
    return (0, $8590040a7833369a$export$ee2e0f811dca1807)($aa564bd137c45a62$var$block, anchor.side) ? 'y' : 'x';
}


const $636e88b893afba47$var$oppositeMap = {
    center: 'center',
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
const $636e88b893afba47$export$2831add577f947cb = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    location: String
}, 'location');
function $636e88b893afba47$export$45d76561a5302f2b(props) {
    let opposite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let offset = arguments.length > 2 ? arguments[2] : undefined;
    const { isRtl: isRtl } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
    const locationStyles = (0, $01W3b.computed)(()=>{
        if (!props.location) return {};
        const { side: side, align: align } = (0, $aa564bd137c45a62$export$49d416a6d8a07bbb)(props.location.split(' ').length > 1 ? props.location : `${props.location} center`, isRtl.value);
        function getOffset(side) {
            return offset ? offset(side) : 0;
        }
        const styles = {};
        if (side !== 'center') {
            if (opposite) styles[$636e88b893afba47$var$oppositeMap[side]] = `calc(100% - ${getOffset(side)}px)`;
            else styles[side] = 0;
        }
        if (align !== 'center') {
            if (opposite) styles[$636e88b893afba47$var$oppositeMap[align]] = `calc(100% - ${getOffset(align)}px)`;
            else styles[align] = 0;
        } else {
            if (side === 'center') styles.top = styles.left = '50%';
            else styles[({
                top: 'left',
                bottom: 'left',
                left: 'top',
                right: 'top'
            })[side]] = '50%';
            styles.transform = ({
                top: 'translateX(-50%)',
                bottom: 'translateX(-50%)',
                left: 'translateY(-50%)',
                right: 'translateY(-50%)',
                center: 'translate(-50%, -50%)'
            })[side];
        }
        return styles;
    });
    return {
        locationStyles: locationStyles
    };
}






const $2d6a3d21f95681cf$var$allowedDensities = [
    null,
    'prominent',
    'default',
    'comfortable',
    'compact'
];
const $2d6a3d21f95681cf$export$bdd0e6e03d2a507e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    absolute: Boolean,
    collapse: Boolean,
    collapsePosition: {
        type: String,
        default: 'start'
    },
    color: String,
    density: {
        type: String,
        default: 'default',
        validator: (v)=>$2d6a3d21f95681cf$var$allowedDensities.includes(v)
    },
    extended: {
        type: Boolean,
        default: null
    },
    extensionHeight: {
        type: [
            Number,
            String
        ],
        default: 48
    },
    flat: Boolean,
    floating: Boolean,
    height: {
        type: [
            Number,
            String
        ],
        default: 64
    },
    image: String,
    title: String,
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $636e88b893afba47$export$2831add577f947cb)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'header'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VToolbar');
const $2d6a3d21f95681cf$export$42c906c84e26a6d1 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VToolbar',
    props: $2d6a3d21f95681cf$export$bdd0e6e03d2a507e(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { locationStyles: locationStyles } = (0, $636e88b893afba47$export$45d76561a5302f2b)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const isExtended = (0, $01W3b.shallowRef)(props.extended === null ? !!slots.extension?.() : props.extended);
        const contentHeight = (0, $01W3b.computed)(()=>parseInt(Number(props.height) + (props.density === 'prominent' ? Number(props.height) : 0) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0), 10));
        const extensionHeight = (0, $01W3b.computed)(()=>isExtended.value ? parseInt(Number(props.extensionHeight) + (props.density === 'prominent' ? Number(props.extensionHeight) : 0) - (props.density === 'comfortable' ? 4 : 0) - (props.density === 'compact' ? 8 : 0), 10) : 0);
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                variant: 'text'
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasTitle = !!(props.title || slots.title);
            const hasImage = !!(slots.image || props.image);
            const extension = slots.extension?.();
            isExtended.value = props.extended === null ? !!extension : props.extended;
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-toolbar',
                    `v-toolbar--collapse-${props.collapsePosition}`,
                    {
                        'v-toolbar--absolute': props.absolute,
                        'v-toolbar--collapse': props.collapse,
                        'v-toolbar--flat': props.flat,
                        'v-toolbar--floating': props.floating,
                        [`v-toolbar--density-${props.density}`]: true
                    },
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    themeClasses.value,
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    locationStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        hasImage && (0, $TusQn.createElementVNode)("div", {
                            "key": "image",
                            "class": "v-toolbar__image"
                        }, [
                            !slots.image ? (0, $TusQn.createVNode)((0, $b2937780237888c4$export$126ec614c536f27c), {
                                "key": "image-img",
                                "cover": true,
                                "src": props.image
                            }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "image-defaults",
                                "disabled": !props.image,
                                "defaults": {
                                    VImg: {
                                        cover: true,
                                        src: props.image
                                    }
                                }
                            }, slots.image)
                        ]),
                        (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VTabs: {
                                    height: (0, $8590040a7833369a$export$286ad215293a0860)(contentHeight.value)
                                }
                            }
                        }, {
                            default: ()=>[
                                    (0, $TusQn.createElementVNode)("div", {
                                        "class": "v-toolbar__content",
                                        "style": {
                                            height: (0, $8590040a7833369a$export$286ad215293a0860)(contentHeight.value)
                                        }
                                    }, [
                                        slots.prepend && (0, $TusQn.createElementVNode)("div", {
                                            "class": "v-toolbar__prepend"
                                        }, [
                                            slots.prepend?.()
                                        ]),
                                        hasTitle && (0, $TusQn.createVNode)((0, $19fdabc79dfb07a7$export$deaeca9428bfc9a4), {
                                            "key": "title",
                                            "text": props.title
                                        }, {
                                            text: slots.title
                                        }),
                                        slots.default?.(),
                                        slots.append && (0, $TusQn.createElementVNode)("div", {
                                            "class": "v-toolbar__append"
                                        }, [
                                            slots.append?.()
                                        ])
                                    ])
                                ]
                        }),
                        (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VTabs: {
                                    height: (0, $8590040a7833369a$export$286ad215293a0860)(extensionHeight.value)
                                }
                            }
                        }, {
                            default: ()=>[
                                    (0, $TusQn.createVNode)((0, $7ec1b0ef33b04126$export$1cd1e8deb97d798d), null, {
                                        default: ()=>[
                                                isExtended.value && (0, $TusQn.createElementVNode)("div", {
                                                    "class": "v-toolbar__extension",
                                                    "style": {
                                                        height: (0, $8590040a7833369a$export$286ad215293a0860)(extensionHeight.value)
                                                    }
                                                }, [
                                                    extension
                                                ])
                                            ]
                                    })
                                ]
                        })
                    ]
            });
        });
        return {
            contentHeight: contentHeight,
            extensionHeight: extensionHeight
        };
    }
});




// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $01b8676e292c7994$export$ada6e0f640b9c21f = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    scrollTarget: {
        type: String
    },
    scrollThreshold: {
        type: [
            String,
            Number
        ],
        default: 300
    }
}, 'scroll');
function $01b8676e292c7994$export$d928051c8cd740b(props) {
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const { canScroll: canScroll, layoutSize: layoutSize } = args;
    let previousScroll = 0;
    let previousScrollHeight = 0;
    const target = (0, $01W3b.ref)(null);
    const currentScroll = (0, $01W3b.shallowRef)(0);
    const savedScroll = (0, $01W3b.shallowRef)(0);
    const currentThreshold = (0, $01W3b.shallowRef)(0);
    const isScrollActive = (0, $01W3b.shallowRef)(false);
    const isScrollingUp = (0, $01W3b.shallowRef)(false);
    const isAtBottom = (0, $01W3b.shallowRef)(false);
    const reachedBottomWhileScrollingDown = (0, $01W3b.shallowRef)(false);
    const hasEnoughScrollableSpace = (0, $01W3b.shallowRef)(true);
    const scrollThreshold = (0, $01W3b.computed)(()=>{
        return Number(props.scrollThreshold);
    });
    /**
   * 1: at top
   * 0: at threshold
   */ const scrollRatio = (0, $01W3b.computed)(()=>{
        return (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)((scrollThreshold.value - currentScroll.value) / scrollThreshold.value || 0);
    });
    function getScrollMetrics(targetEl) {
        const clientHeight = 'window' in targetEl ? window.innerHeight : targetEl.clientHeight;
        const scrollHeight = 'window' in targetEl ? document.documentElement.scrollHeight : targetEl.scrollHeight;
        return {
            clientHeight: clientHeight,
            scrollHeight: scrollHeight
        };
    }
    function checkScrollableSpace() {
        const targetEl = target.value;
        if (!targetEl) return;
        const { clientHeight: clientHeight, scrollHeight: scrollHeight } = getScrollMetrics(targetEl);
        const maxScrollableDistance = scrollHeight - clientHeight;
        // When the scroll-hide element (like AppBar) hides, it causes the page to grow
        // We need extra scrollable space beyond the threshold to prevent bouncing
        // Add the element's height to the required minimum distance
        const elementHeight = layoutSize?.value || 0;
        const minRequiredDistance = scrollThreshold.value + elementHeight;
        // Only enable scroll-hide if there's enough scrollable space
        hasEnoughScrollableSpace.value = maxScrollableDistance > minRequiredDistance;
    }
    function onResize() {
        checkScrollableSpace();
    }
    function onScroll() {
        const targetEl = target.value;
        if (!targetEl || canScroll && !canScroll.value) return;
        previousScroll = currentScroll.value;
        currentScroll.value = 'window' in targetEl ? targetEl.pageYOffset : targetEl.scrollTop;
        const currentScrollHeight = targetEl instanceof Window ? document.documentElement.scrollHeight : targetEl.scrollHeight;
        if (previousScrollHeight !== currentScrollHeight) {
            // If page is growing (content loading), recalculate scrollable space
            // If page is shrinking (likely due to navbar animation), don't recalculate
            if (currentScrollHeight > previousScrollHeight) checkScrollableSpace();
            previousScrollHeight = currentScrollHeight;
        }
        isScrollingUp.value = currentScroll.value < previousScroll;
        currentThreshold.value = Math.abs(currentScroll.value - scrollThreshold.value);
        // Detect if at bottom of page
        const { clientHeight: clientHeight, scrollHeight: scrollHeight } = getScrollMetrics(targetEl);
        const atBottom = currentScroll.value + clientHeight >= scrollHeight - 5;
        // Track when bottom is reached during downward scroll
        // Only set flag if ALL conditions are met:
        // 1. Scrolled past threshold (navbar is hiding)
        // 2. Page has enough scrollable space for scroll-hide
        // This prevents activation on short pages or edge cases
        if (!isScrollingUp.value && atBottom && currentScroll.value >= scrollThreshold.value && hasEnoughScrollableSpace.value) reachedBottomWhileScrollingDown.value = true;
        // Reset the flag when:
        // 1. Scrolling up away from bottom (with small tolerance for touchpad/momentum scrolling)
        // 2. Scroll position jumped significantly (e.g., navigation, scroll restoration)
        // 3. Scroll is at the very top (page navigation resets to top)
        const scrollJumped = Math.abs(currentScroll.value - previousScroll) > 100;
        const atTop = currentScroll.value <= 5;
        const scrolledUpSignificantly = isScrollingUp.value && previousScroll - currentScroll.value > 1;
        if (scrolledUpSignificantly && !atBottom || scrollJumped && currentScroll.value < scrollThreshold.value || atTop) reachedBottomWhileScrollingDown.value = false;
        // Update state
        isAtBottom.value = atBottom;
    }
    (0, $01W3b.watch)(isScrollingUp, ()=>{
        savedScroll.value = savedScroll.value || currentScroll.value;
    });
    (0, $01W3b.watch)(isScrollActive, ()=>{
        savedScroll.value = 0;
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $01W3b.watch)(()=>props.scrollTarget, (scrollTarget)=>{
            const newTarget = scrollTarget ? document.querySelector(scrollTarget) : window;
            if (!newTarget) {
                (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`Unable to locate element with identifier ${scrollTarget}`);
                return;
            }
            if (newTarget === target.value) return;
            target.value?.removeEventListener('scroll', onScroll);
            target.value = newTarget;
            target.value.addEventListener('scroll', onScroll, {
                passive: true
            });
            // Check scrollable space when target is set
            Promise.resolve().then(()=>{
                checkScrollableSpace();
            });
        }, {
            immediate: true
        });
        // Listen to window resize to recalculate scrollable space
        window.addEventListener('resize', onResize, {
            passive: true
        });
    });
    (0, $TusQn.onBeforeUnmount)(()=>{
        target.value?.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onResize);
    });
    // Do we need this? If yes - seems that
    // there's no need to expose onScroll
    canScroll && (0, $01W3b.watch)(canScroll, onScroll, {
        immediate: true
    });
    return {
        scrollThreshold: scrollThreshold,
        currentScroll: currentScroll,
        currentThreshold: currentThreshold,
        isScrollActive: isScrollActive,
        scrollRatio: scrollRatio,
        isScrollingUp: // required only for testing
        // probably can be removed
        // later (2 chars chlng)
        isScrollingUp,
        savedScroll: savedScroll,
        isAtBottom: isAtBottom,
        reachedBottomWhileScrollingDown: reachedBottomWhileScrollingDown,
        hasEnoughScrollableSpace: hasEnoughScrollableSpace
    };
}


// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
function $0f95b8d0184d7fa9$export$f385cca8ac2b2f35() {
    const isBooted = (0, $01W3b.shallowRef)(false);
    (0, $TusQn.onMounted)(()=>{
        window.requestAnimationFrame(()=>{
            isBooted.value = true;
        });
    });
    const ssrBootStyles = (0, $01W3b.toRef)(()=>!isBooted.value ? {
            transition: 'none !important'
        } : undefined);
    return {
        ssrBootStyles: ssrBootStyles,
        isBooted: (0, $01W3b.readonly)(isBooted)
    };
}




const $54a8bd238fe4aa7e$export$46ee10ae454fcfcd = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    scrollBehavior: String,
    modelValue: {
        type: Boolean,
        default: true
    },
    location: {
        type: String,
        default: 'top',
        validator: (value)=>[
                'top',
                'bottom'
            ].includes(value)
    },
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $2d6a3d21f95681cf$export$bdd0e6e03d2a507e)(), [
        'location'
    ]),
    ...(0, $56e08e0125137781$export$d42abac634ace931)(),
    ...(0, $01b8676e292c7994$export$ada6e0f640b9c21f)(),
    height: {
        type: [
            Number,
            String
        ],
        default: 64
    }
}, 'VAppBar');
const $54a8bd238fe4aa7e$export$2fbc8fb55736252a = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VAppBar',
    props: $54a8bd238fe4aa7e$export$46ee10ae454fcfcd(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const vToolbarRef = (0, $01W3b.ref)();
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const scrollBehavior = (0, $01W3b.computed)(()=>{
            const behavior = new Set(props.scrollBehavior?.split(' ') ?? []);
            return {
                hide: behavior.has('hide'),
                fullyHide: behavior.has('fully-hide'),
                inverted: behavior.has('inverted'),
                collapse: behavior.has('collapse'),
                elevate: behavior.has('elevate'),
                fadeImage: behavior.has('fade-image')
            };
        });
        const canScroll = (0, $01W3b.computed)(()=>{
            const behavior = scrollBehavior.value;
            return behavior.hide || behavior.fullyHide || behavior.inverted || behavior.collapse || behavior.elevate || behavior.fadeImage || // behavior.shrink ||
            !isActive.value;
        });
        const appBarHeight = (0, $01W3b.computed)(()=>{
            const height = vToolbarRef.value?.contentHeight ?? 0;
            const extensionHeight = vToolbarRef.value?.extensionHeight ?? 0;
            return height + extensionHeight;
        });
        const { currentScroll: currentScroll, scrollThreshold: scrollThreshold, isScrollingUp: isScrollingUp, scrollRatio: scrollRatio, isAtBottom: isAtBottom, reachedBottomWhileScrollingDown: reachedBottomWhileScrollingDown, hasEnoughScrollableSpace: hasEnoughScrollableSpace } = (0, $01b8676e292c7994$export$d928051c8cd740b)(props, {
            canScroll: canScroll,
            layoutSize: appBarHeight
        });
        const canHide = (0, $01W3b.toRef)(()=>scrollBehavior.value.hide || scrollBehavior.value.fullyHide);
        const isCollapsed = (0, $01W3b.computed)(()=>props.collapse || scrollBehavior.value.collapse && (scrollBehavior.value.inverted ? scrollRatio.value > 0 : scrollRatio.value === 0));
        const isFlat = (0, $01W3b.computed)(()=>props.flat || scrollBehavior.value.fullyHide && !isActive.value || scrollBehavior.value.elevate && (scrollBehavior.value.inverted ? currentScroll.value > 0 : currentScroll.value === 0));
        const opacity = (0, $01W3b.computed)(()=>scrollBehavior.value.fadeImage ? scrollBehavior.value.inverted ? 1 - scrollRatio.value : scrollRatio.value : undefined);
        const height = (0, $01W3b.computed)(()=>{
            if (scrollBehavior.value.hide && scrollBehavior.value.inverted) return 0;
            const height = vToolbarRef.value?.contentHeight ?? 0;
            const extensionHeight = vToolbarRef.value?.extensionHeight ?? 0;
            if (!canHide.value) return height + extensionHeight;
            return currentScroll.value < scrollThreshold.value || scrollBehavior.value.fullyHide ? height + extensionHeight : height;
        });
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>!!props.scrollBehavior, ()=>{
            (0, $TusQn.watchEffect)(()=>{
                if (!canHide.value) {
                    isActive.value = true;
                    return;
                }
                if (scrollBehavior.value.inverted) {
                    isActive.value = currentScroll.value > scrollThreshold.value;
                    return;
                }
                // If there's not enough scrollable space, don't apply scroll-hide behavior at all
                // This prevents flickering/bouncing animations on short pages
                if (!hasEnoughScrollableSpace.value) {
                    isActive.value = true;
                    return;
                }
                // Prevent navbar from showing when we reached bottom while scrolling down
                // This handles the case where scroll momentum causes to hit bottom during hide transition
                if (reachedBottomWhileScrollingDown.value) {
                    isActive.value = false;
                    return;
                }
                // Normal behavior: show when scrolling up (and not at bottom) or above threshold
                isActive.value = isScrollingUp.value && !isAtBottom.value || currentScroll.value < scrollThreshold.value;
            });
        });
        const { ssrBootStyles: ssrBootStyles } = (0, $0f95b8d0184d7fa9$export$f385cca8ac2b2f35)();
        const { layoutItemStyles: layoutItemStyles } = (0, $56e08e0125137781$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $01W3b.computed)(()=>parseInt(props.order, 10)),
            position: (0, $01W3b.toRef)(()=>props.location),
            layoutSize: height,
            elementSize: (0, $01W3b.shallowRef)(undefined),
            active: isActive,
            absolute: (0, $01W3b.toRef)(()=>props.absolute)
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const toolbarProps = (0, $8590040a7833369a$export$30a06c8d3562193f)((0, $2d6a3d21f95681cf$export$42c906c84e26a6d1).filterProps(props), [
                'location'
            ]);
            return (0, $TusQn.createVNode)((0, $2d6a3d21f95681cf$export$42c906c84e26a6d1), (0, $TusQn.mergeProps)({
                "ref": vToolbarRef,
                "class": [
                    'v-app-bar',
                    {
                        'v-app-bar--bottom': props.location === 'bottom'
                    },
                    props.class
                ],
                "style": [
                    {
                        ...layoutItemStyles.value,
                        '--v-toolbar-image-opacity': opacity.value,
                        height: undefined,
                        ...ssrBootStyles.value
                    },
                    props.style
                ]
            }, toolbarProps, {
                "collapse": isCollapsed.value,
                "flat": isFlat.value
            }), slots);
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");




// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $667123557e1d36ef$var$allowedDensities = [
    null,
    'default',
    'comfortable',
    'compact'
];
const $667123557e1d36ef$export$aac8956235d563cb = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    density: {
        type: String,
        default: 'default',
        validator: (v)=>$667123557e1d36ef$var$allowedDensities.includes(v)
    }
}, 'density');
function $667123557e1d36ef$export$29e89a97ff256b5f(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    const densityClasses = (0, $01W3b.toRef)(()=>{
        return `${name}--density-${props.density}`;
    });
    return {
        densityClasses: densityClasses
    };
}






parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");


const $567f01637e3e83ec$export$2f93f3a46970d4f0 = [
    'elevated',
    'flat',
    'tonal',
    'outlined',
    'text',
    'plain'
];
function $567f01637e3e83ec$export$e27cd265ed232373(isClickable, name) {
    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
        isClickable && (0, $TusQn.createElementVNode)("span", {
            "key": "overlay",
            "class": (0, $8POXm.normalizeClass)(`${name}__overlay`)
        }, null),
        (0, $TusQn.createElementVNode)("span", {
            "key": "underlay",
            "class": (0, $8POXm.normalizeClass)(`${name}__underlay`)
        }, null)
    ]);
}
const $567f01637e3e83ec$export$7c4064f4acce0348 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    variant: {
        type: String,
        default: 'elevated',
        validator: (v)=>$567f01637e3e83ec$export$2f93f3a46970d4f0.includes(v)
    }
}, 'variant');
function $567f01637e3e83ec$export$36ef81613f8f20fc(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    const variantClasses = (0, $01W3b.toRef)(()=>{
        const { variant: variant } = (0, $01W3b.toValue)(props);
        return `${name}--variant-${variant}`;
    });
    const { colorClasses: colorClasses, colorStyles: colorStyles } = (0, $3cd60c4ecc68ec90$export$5aadd9c0606af5c2)(()=>{
        const { variant: variant, color: color } = (0, $01W3b.toValue)(props);
        return {
            [[
                'elevated',
                'flat'
            ].includes(variant) ? 'background' : 'text']: color
        };
    });
    return {
        colorClasses: colorClasses,
        colorStyles: colorStyles,
        variantClasses: variantClasses
    };
}



const $b1d00c9a9b585242$export$3294be1f7b2d41ce = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    baseColor: String,
    divided: Boolean,
    direction: {
        type: String,
        default: 'horizontal'
    },
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)()
}, 'VBtnGroup');
const $b1d00c9a9b585242$export$9901e555ac223efb = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBtnGroup',
    props: $b1d00c9a9b585242$export$3294be1f7b2d41ce(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                height: (0, $01W3b.toRef)(()=>props.direction === 'horizontal' ? 'auto' : null),
                baseColor: (0, $01W3b.toRef)(()=>props.baseColor),
                color: (0, $01W3b.toRef)(()=>props.color),
                density: (0, $01W3b.toRef)(()=>props.density),
                flat: true,
                variant: (0, $01W3b.toRef)(()=>props.variant)
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-btn-group',
                    `v-btn-group--${props.direction}`,
                    {
                        'v-btn-group--divided': props.divided
                    },
                    themeClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, slots);
        });
    }
});


// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

function $bf1718679e817e1f$var$updateRecursionCache(a, b, cache, result) {
    if (!cache || (0, $8590040a7833369a$export$c3825b437cbdea5c)(a) || (0, $8590040a7833369a$export$c3825b437cbdea5c)(b)) return;
    const visitedObject = cache.get(a);
    if (visitedObject) visitedObject.set(b, result);
    else {
        const newCacheItem = new WeakMap();
        newCacheItem.set(b, result);
        cache.set(a, newCacheItem);
    }
}
function $bf1718679e817e1f$var$findCachedComparison(a, b, cache) {
    if (!cache || (0, $8590040a7833369a$export$c3825b437cbdea5c)(a) || (0, $8590040a7833369a$export$c3825b437cbdea5c)(b)) return null;
    const r1 = cache.get(a)?.get(b);
    if (typeof r1 === 'boolean') return r1;
    const r2 = cache.get(b)?.get(a);
    if (typeof r2 === 'boolean') return r2;
    return null;
}
function $bf1718679e817e1f$export$9cb4719e2e525b7a(a, b) {
    let recursionCache = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new WeakMap();
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date && a.getTime() !== b.getTime()) // If the values are Date, compare them as timestamps
    return false;
    if (a !== Object(a) || b !== Object(b)) // If the values aren't objects, they were already checked for equality
    return false;
    const props = Object.keys(a);
    if (props.length !== Object.keys(b).length) // Different number of props, don't bother to check
    return false;
    const cachedComparisonResult = $bf1718679e817e1f$var$findCachedComparison(a, b, recursionCache);
    if (cachedComparisonResult) return cachedComparisonResult;
    $bf1718679e817e1f$var$updateRecursionCache(a, b, recursionCache, true);
    return props.every((p)=>$bf1718679e817e1f$export$9cb4719e2e525b7a(a[p], b[p], recursionCache));
}


const $0befa53cf46b542b$export$fa4c05b3520340e6 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    modelValue: {
        type: null,
        default: undefined
    },
    multiple: Boolean,
    mandatory: [
        Boolean,
        String
    ],
    max: Number,
    selectedClass: String,
    disabled: Boolean
}, 'group');
const $0befa53cf46b542b$export$e9e3b570044587e8 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    value: null,
    disabled: Boolean,
    selectedClass: String
}, 'group-item');
function $0befa53cf46b542b$export$eebde8160f061c26(props, injectKey) {
    let required = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useGroupItem');
    if (!vm) throw new Error('[Vuetify] useGroupItem composable must be used inside a component setup function');
    const id = (0, $TusQn.useId)();
    (0, $TusQn.provide)(Symbol.for(`${injectKey.description}:id`), id);
    const group = (0, $TusQn.inject)(injectKey, null);
    if (!group) {
        if (!required) return group;
        throw new Error(`[Vuetify] Could not find useGroup injection with symbol ${injectKey.description}`);
    }
    const value = (0, $01W3b.toRef)(()=>props.value);
    const disabled = (0, $01W3b.computed)(()=>!!(group.disabled.value || props.disabled));
    function register() {
        group?.register({
            id: id,
            value: value,
            disabled: disabled
        }, vm);
    }
    function unregister() {
        group?.unregister(id);
    }
    register();
    (0, $TusQn.onBeforeUnmount)(()=>unregister());
    const isSelected = (0, $01W3b.computed)(()=>{
        return group.isSelected(id);
    });
    const isFirst = (0, $01W3b.computed)(()=>{
        return group.items.value[0].id === id;
    });
    const isLast = (0, $01W3b.computed)(()=>{
        return group.items.value[group.items.value.length - 1].id === id;
    });
    const selectedClass = (0, $01W3b.computed)(()=>isSelected.value && [
            group.selectedClass.value,
            props.selectedClass
        ]);
    (0, $01W3b.watch)(isSelected, (value)=>{
        vm.emit('group:selected', {
            value: value
        });
    }, {
        flush: 'sync'
    });
    return {
        id: id,
        isSelected: isSelected,
        isFirst: isFirst,
        isLast: isLast,
        toggle: ()=>group.select(id, !isSelected.value),
        select: (value)=>group.select(id, value),
        selectedClass: selectedClass,
        value: value,
        disabled: disabled,
        group: group,
        register: register,
        unregister: unregister
    };
}
function $0befa53cf46b542b$export$bfb6a372146ddc96(props, injectKey) {
    let isUnmounted = false;
    const items = (0, $01W3b.reactive)([]);
    const selected = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>{
        if (v === undefined) return [];
        return $0befa53cf46b542b$var$getIds(items, v === null ? [
            null
        ] : (0, $8590040a7833369a$export$76411cac38121ecb)(v));
    }, (v)=>{
        const arr = $0befa53cf46b542b$var$getValues(items, v);
        return props.multiple ? arr : arr[0];
    });
    const groupVm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useGroup');
    function register(item, vm) {
        // Is there a better way to fix this typing?
        const unwrapped = item;
        const key = Symbol.for(`${injectKey.description}:id`);
        const children = (0, $8590040a7833369a$export$424fe43b65f39668)(key, groupVm?.vnode);
        const index = children.indexOf(vm);
        if ((0, $01W3b.unref)(unwrapped.value) === undefined) {
            unwrapped.value = index;
            unwrapped.useIndexAsValue = true;
        }
        if (index > -1) items.splice(index, 0, unwrapped);
        else items.push(unwrapped);
    }
    function unregister(id) {
        if (isUnmounted) return;
        // TODO: re-evaluate this line's importance in the future
        // should we only modify the model if mandatory is set.
        // selected.value = selected.value.filter(v => v !== id)
        forceMandatoryValue();
        const index = items.findIndex((item)=>item.id === id);
        items.splice(index, 1);
    }
    // If mandatory and nothing is selected, then select first non-disabled item
    function forceMandatoryValue() {
        const item = items.find((item)=>!item.disabled);
        if (item && props.mandatory === 'force' && !selected.value.length) selected.value = [
            item.id
        ];
    }
    (0, $TusQn.onMounted)(()=>{
        forceMandatoryValue();
    });
    (0, $TusQn.onBeforeUnmount)(()=>{
        isUnmounted = true;
    });
    (0, $TusQn.onUpdated)(()=>{
        // #19655 update the items that use the index as the value.
        for(let i = 0; i < items.length; i++)if (items[i].useIndexAsValue) items[i].value = i;
    });
    function select(id, value) {
        const item = items.find((item)=>item.id === id);
        if (value && item?.disabled) return;
        if (props.multiple) {
            const internalValue = selected.value.slice();
            const index = internalValue.findIndex((v)=>v === id);
            const isSelected = ~index;
            value = value ?? !isSelected;
            // We can't remove value if group is
            // mandatory, value already exists,
            // and it is the only value
            if (isSelected && props.mandatory && internalValue.length <= 1) return;
            // We can't add value if it would
            // cause max limit to be exceeded
            if (!isSelected && props.max != null && internalValue.length + 1 > props.max) return;
            if (index < 0 && value) internalValue.push(id);
            else if (index >= 0 && !value) internalValue.splice(index, 1);
            selected.value = internalValue;
        } else {
            const isSelected = selected.value.includes(id);
            if (props.mandatory && isSelected) return;
            if (!isSelected && !value) return;
            selected.value = value ?? !isSelected ? [
                id
            ] : [];
        }
    }
    function step(offset) {
        // getting an offset from selected value obviously won't work with multiple values
        if (props.multiple) (0, $5384ffc78a9e124c$export$222ba5e7254f2402)('This method is not supported when using "multiple" prop');
        if (!selected.value.length) {
            const item = items.find((item)=>!item.disabled);
            item && (selected.value = [
                item.id
            ]);
        } else {
            const currentId = selected.value[0];
            const currentIndex = items.findIndex((i)=>i.id === currentId);
            let newIndex = (currentIndex + offset) % items.length;
            let newItem = items[newIndex];
            while(newItem.disabled && newIndex !== currentIndex){
                newIndex = (newIndex + offset) % items.length;
                newItem = items[newIndex];
            }
            if (newItem.disabled) return;
            selected.value = [
                items[newIndex].id
            ];
        }
    }
    const state = {
        register: register,
        unregister: unregister,
        selected: selected,
        select: select,
        disabled: (0, $01W3b.toRef)(()=>props.disabled),
        prev: ()=>step(items.length - 1),
        next: ()=>step(1),
        isSelected: (id)=>selected.value.includes(id),
        selectedClass: (0, $01W3b.toRef)(()=>props.selectedClass),
        items: (0, $01W3b.toRef)(()=>items),
        getItemIndex: (value)=>$0befa53cf46b542b$var$getItemIndex(items, value)
    };
    (0, $TusQn.provide)(injectKey, state);
    return state;
}
function $0befa53cf46b542b$var$getItemIndex(items, value) {
    const ids = $0befa53cf46b542b$var$getIds(items, [
        value
    ]);
    if (!ids.length) return -1;
    return items.findIndex((item)=>item.id === ids[0]);
}
function $0befa53cf46b542b$var$getIds(items, modelValue) {
    const ids = [];
    modelValue.forEach((value)=>{
        const item = items.find((item)=>(0, $bf1718679e817e1f$export$9cb4719e2e525b7a)(value, item.value));
        const itemByIndex = items[value];
        if (item?.value !== undefined) ids.push(item.id);
        else if (itemByIndex?.useIndexAsValue) ids.push(itemByIndex.id);
    });
    return ids;
}
function $0befa53cf46b542b$var$getValues(items, ids) {
    const values = [];
    ids.forEach((id)=>{
        const itemIndex = items.findIndex((item)=>item.id === id);
        if (~itemIndex) {
            const item = items[itemIndex];
            values.push(item.value !== undefined ? item.value : itemIndex);
        }
    });
    return values;
}



const $b08d2d2d797cb622$export$7ccf67e9366faa19 = Symbol.for('vuetify:v-btn-toggle');
const $b08d2d2d797cb622$export$4be96eb43616f3ac = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b1d00c9a9b585242$export$3294be1f7b2d41ce)(),
    ...(0, $0befa53cf46b542b$export$fa4c05b3520340e6)()
}, 'VBtnToggle');
const $b08d2d2d797cb622$export$2097e77d7f4058c7 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBtnToggle',
    props: $b08d2d2d797cb622$export$4be96eb43616f3ac(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { isSelected: isSelected, next: next, prev: prev, select: select, selected: selected } = (0, $0befa53cf46b542b$export$bfb6a372146ddc96)(props, $b08d2d2d797cb622$export$7ccf67e9366faa19);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const btnGroupProps = (0, $b1d00c9a9b585242$export$9901e555ac223efb).filterProps(props);
            return (0, $TusQn.createVNode)((0, $b1d00c9a9b585242$export$9901e555ac223efb), (0, $TusQn.mergeProps)({
                "class": [
                    'v-btn-toggle',
                    props.class
                ]
            }, btnGroupProps, {
                "style": props.style
            }), {
                default: ()=>[
                        slots.default?.({
                            isSelected: isSelected,
                            next: next,
                            prev: prev,
                            select: select,
                            selected: selected
                        })
                    ]
            });
        });
        return {
            next: next,
            prev: prev,
            select: select
        };
    }
});



parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");




// Utilities

const $b9afb2891b9aa639$var$predefinedSizes = [
    'x-small',
    'small',
    'default',
    'large',
    'x-large'
];
const $b9afb2891b9aa639$export$c7a32fb00df3ff20 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    size: {
        type: [
            String,
            Number
        ],
        default: 'default'
    }
}, 'size');
function $b9afb2891b9aa639$export$1ab7ae714698c4b8(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    return (0, $8590040a7833369a$export$fe6a5b56d01db4f5)(()=>{
        const size = props.size;
        let sizeClasses;
        let sizeStyles;
        if ((0, $8590040a7833369a$export$ee2e0f811dca1807)($b9afb2891b9aa639$var$predefinedSizes, size)) sizeClasses = `${name}--size-${size}`;
        else if (size) sizeStyles = {
            width: (0, $8590040a7833369a$export$286ad215293a0860)(size),
            height: (0, $8590040a7833369a$export$286ad215293a0860)(size)
        };
        return {
            sizeClasses: sizeClasses,
            sizeStyles: sizeStyles
        };
    });
}





const $8ebccd09f8e016c4$export$7248a8743d8f7621 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    disabled: Boolean,
    start: Boolean,
    end: Boolean,
    icon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    opacity: [
        String,
        Number
    ],
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'i'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VIcon');
const $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VIcon',
    props: $8ebccd09f8e016c4$export$7248a8743d8f7621(),
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const slotIcon = (0, $01W3b.shallowRef)();
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$93d4e7f90805808f)();
        const { iconData: iconData } = (0, $834ffcae3192e85e$export$27cb60208885277b)(()=>slotIcon.value || props.icon);
        const { sizeClasses: sizeClasses } = (0, $b9afb2891b9aa639$export$1ab7ae714698c4b8)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.color);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const slotValue = slots.default?.();
            if (slotValue) slotIcon.value = (0, $8590040a7833369a$export$c556ee00a0535018)(slotValue).filter((node)=>node.type === (0, $TusQn.Text) && node.children && typeof node.children === 'string')[0]?.children;
            const hasClick = !!(attrs.onClick || attrs.onClickOnce);
            return (0, $TusQn.createVNode)(iconData.value.component, {
                "tag": props.tag,
                "icon": iconData.value.icon,
                "class": (0, $8POXm.normalizeClass)([
                    'v-icon',
                    'notranslate',
                    themeClasses.value,
                    sizeClasses.value,
                    textColorClasses.value,
                    {
                        'v-icon--clickable': hasClick,
                        'v-icon--disabled': props.disabled,
                        'v-icon--start': props.start,
                        'v-icon--end': props.end
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-icon-opacity': props.opacity
                    },
                    !sizeClasses.value ? {
                        fontSize: (0, $8590040a7833369a$export$286ad215293a0860)(props.size),
                        height: (0, $8590040a7833369a$export$286ad215293a0860)(props.size),
                        width: (0, $8590040a7833369a$export$286ad215293a0860)(props.size)
                    } : undefined,
                    textColorStyles.value,
                    props.style
                ]),
                "role": hasClick ? 'button' : undefined,
                "aria-hidden": !hasClick,
                "tabindex": hasClick ? props.disabled ? -1 : 0 : undefined
            }, {
                default: ()=>[
                        slotValue
                    ]
            });
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

function $16d02f6dfabde683$export$a7395f9832c00176(callback, options) {
    const intersectionRef = (0, $01W3b.ref)();
    const isIntersecting = (0, $01W3b.shallowRef)(false);
    if (0, $90a48ad178b943d3$export$8cb82f5817a92ac4) {
        const observer = new IntersectionObserver((entries)=>{
            callback?.(entries, observer);
            isIntersecting.value = !!entries.find((entry)=>entry.isIntersecting);
        }, options);
        (0, $01W3b.onScopeDispose)(()=>{
            observer.disconnect();
        });
        (0, $01W3b.watch)(intersectionRef, (newValue, oldValue)=>{
            if (oldValue) {
                observer.unobserve(oldValue);
                isIntersecting.value = false;
            }
            if (newValue) observer.observe(newValue);
        }, {
            flush: 'post'
        });
    }
    return {
        intersectionRef: intersectionRef,
        isIntersecting: isIntersecting
    };
}



// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

const $58c70e2903e86f06$export$87be6e453f2c0218 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    reveal: {
        type: [
            Boolean,
            Object
        ],
        default: false
    }
}, 'reveal');
function $58c70e2903e86f06$export$145a783b8793b02(props) {
    const defaultDuration = 900;
    const duration = (0, $01W3b.toRef)(()=>typeof props.reveal === 'object' ? Math.max(0, Number(props.reveal.duration ?? defaultDuration)) : defaultDuration);
    const state = (0, $01W3b.shallowRef)(props.reveal ? 'initial' : 'disabled');
    (0, $TusQn.onMounted)(async ()=>{
        if (props.reveal) {
            state.value = 'initial';
            await new Promise((resolve)=>requestAnimationFrame(resolve));
            state.value = 'pending';
            await new Promise((resolve)=>setTimeout(resolve, duration.value));
            state.value = 'done';
        }
    });
    return {
        duration: duration,
        state: state
    };
}






const $26f3a281106a205d$export$ffe0c85d1e4bac48 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    bgColor: String,
    color: String,
    indeterminate: [
        Boolean,
        String
    ],
    rounded: Boolean,
    modelValue: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    rotate: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    width: {
        type: [
            Number,
            String
        ],
        default: 4
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $58c70e2903e86f06$export$87be6e453f2c0218)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'div'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VProgressCircular');
const $26f3a281106a205d$export$2b4afd8de42c0c21 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VProgressCircular',
    props: $26f3a281106a205d$export$ffe0c85d1e4bac48(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const MAGIC_RADIUS_CONSTANT = 20;
        const CIRCUMFERENCE = 2 * Math.PI * MAGIC_RADIUS_CONSTANT;
        const root = (0, $01W3b.ref)();
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = (0, $b9afb2891b9aa639$export$1ab7ae714698c4b8)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.color);
        const { textColorClasses: underlayColorClasses, textColorStyles: underlayColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.bgColor);
        const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $16d02f6dfabde683$export$a7395f9832c00176)();
        const { resizeRef: resizeRef, contentRect: contentRect } = (0, $d80db15b6452c606$export$683480f191c0e3ea)();
        const { state: revealState, duration: revealDuration } = (0, $58c70e2903e86f06$export$145a783b8793b02)(props);
        const normalizedValue = (0, $01W3b.toRef)(()=>revealState.value === 'initial' ? 0 : (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(parseFloat(props.modelValue), 0, 100));
        const width = (0, $01W3b.toRef)(()=>Number(props.width));
        const size = (0, $01W3b.toRef)(()=>{
            // Get size from element if size prop value is small, large etc
            return sizeStyles.value ? Number(props.size) : contentRect.value ? contentRect.value.width : Math.max(width.value, 32);
        });
        const diameter = (0, $01W3b.toRef)(()=>MAGIC_RADIUS_CONSTANT / (1 - width.value / size.value) * 2);
        const strokeWidth = (0, $01W3b.toRef)(()=>width.value / size.value * diameter.value);
        const strokeDashOffset = (0, $01W3b.toRef)(()=>{
            const baseLength = (100 - normalizedValue.value) / 100 * CIRCUMFERENCE;
            return props.rounded && normalizedValue.value > 0 && normalizedValue.value < 100 ? (0, $8590040a7833369a$export$286ad215293a0860)(Math.min(CIRCUMFERENCE - 0.01, baseLength + strokeWidth.value)) : (0, $8590040a7833369a$export$286ad215293a0860)(baseLength);
        });
        const startAngle = (0, $01W3b.computed)(()=>{
            const baseAngle = Number(props.rotate);
            return props.rounded ? baseAngle + strokeWidth.value / 2 / CIRCUMFERENCE * 360 : baseAngle;
        });
        (0, $TusQn.watchEffect)(()=>{
            intersectionRef.value = root.value;
            resizeRef.value = root.value;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "ref": root,
                "class": (0, $8POXm.normalizeClass)([
                    'v-progress-circular',
                    {
                        'v-progress-circular--indeterminate': !!props.indeterminate,
                        'v-progress-circular--visible': isIntersecting.value,
                        'v-progress-circular--disable-shrink': props.indeterminate && (props.indeterminate === 'disable-shrink' || (0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)()),
                        'v-progress-circular--revealing': [
                            'initial',
                            'pending'
                        ].includes(revealState.value)
                    },
                    themeClasses.value,
                    sizeClasses.value,
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    sizeStyles.value,
                    textColorStyles.value,
                    {
                        '--progress-reveal-duration': `${revealDuration.value}ms`
                    },
                    props.style
                ]),
                "role": "progressbar",
                "aria-valuemin": "0",
                "aria-valuemax": "100",
                "aria-valuenow": props.indeterminate ? undefined : normalizedValue.value
            }, {
                default: ()=>[
                        (0, $TusQn.createElementVNode)("svg", {
                            "style": {
                                transform: `rotate(calc(-90deg + ${startAngle.value}deg))`
                            },
                            "xmlns": "http://www.w3.org/2000/svg",
                            "viewBox": `0 0 ${diameter.value} ${diameter.value}`
                        }, [
                            (0, $TusQn.createElementVNode)("circle", {
                                "class": (0, $8POXm.normalizeClass)([
                                    'v-progress-circular__underlay',
                                    underlayColorClasses.value
                                ]),
                                "style": (0, $8POXm.normalizeStyle)(underlayColorStyles.value),
                                "fill": "transparent",
                                "cx": "50%",
                                "cy": "50%",
                                "r": MAGIC_RADIUS_CONSTANT,
                                "stroke-width": strokeWidth.value,
                                "stroke-dasharray": CIRCUMFERENCE,
                                "stroke-dashoffset": 0
                            }, null),
                            (0, $TusQn.createElementVNode)("circle", {
                                "class": "v-progress-circular__overlay",
                                "fill": "transparent",
                                "cx": "50%",
                                "cy": "50%",
                                "r": MAGIC_RADIUS_CONSTANT,
                                "stroke-width": strokeWidth.value,
                                "stroke-dasharray": CIRCUMFERENCE,
                                "stroke-dashoffset": strokeDashOffset.value,
                                "stroke-linecap": props.rounded ? 'round' : undefined
                            }, null)
                        ]),
                        slots.default && (0, $TusQn.createElementVNode)("div", {
                            "class": "v-progress-circular__content"
                        }, [
                            slots.default({
                                value: normalizedValue.value
                            })
                        ])
                    ]
            }));
        return {};
    }
});









parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");












// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $f727e13eeaf511a7$export$4b5633ed87e28257 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    chunkCount: {
        type: [
            Number,
            String
        ],
        default: null
    },
    chunkWidth: {
        type: [
            Number,
            String
        ],
        default: null
    },
    chunkGap: {
        type: [
            Number,
            String
        ],
        default: 4
    }
}, 'chunks');
function $f727e13eeaf511a7$export$a174c058f819ac6f(props, containerWidth) {
    const hasChunks = (0, $01W3b.toRef)(()=>!!props.chunkCount || !!props.chunkWidth);
    const chunkWidth = (0, $01W3b.computed)(()=>{
        const containerSize = (0, $01W3b.toValue)(containerWidth);
        if (!containerSize) return 0;
        if (!props.chunkCount) return Number(props.chunkWidth);
        const count = Number(props.chunkCount);
        const availableWidth = containerSize - Number(props.chunkGap) * (count - 1);
        return availableWidth / count;
    });
    const chunkGap = (0, $01W3b.toRef)(()=>Number(props.chunkGap));
    const chunksMaskStyles = (0, $01W3b.computed)(()=>{
        if (!hasChunks.value) return {};
        const chunkGapPx = (0, $8590040a7833369a$export$286ad215293a0860)(chunkGap.value);
        const chunkWidthPx = (0, $8590040a7833369a$export$286ad215293a0860)(chunkWidth.value);
        return {
            maskRepeat: 'repeat-x',
            maskImage: `linear-gradient(90deg, #000, #000 ${chunkWidthPx}, transparent ${chunkWidthPx}, transparent)`,
            maskSize: `calc(${chunkWidthPx} + ${chunkGapPx}) 100%`
        };
    });
    function snapValueToChunk(val) {
        const containerSize = (0, $01W3b.toValue)(containerWidth);
        if (!containerSize) return val;
        const gapRelativeSize = 100 * chunkGap.value / containerSize;
        const chunkRelativeSize = 100 * (chunkWidth.value + chunkGap.value) / containerSize;
        const filledChunks = Math.floor((val + gapRelativeSize) / chunkRelativeSize);
        return (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(0, filledChunks * chunkRelativeSize - gapRelativeSize / 2, 100);
    }
    return {
        hasChunks: hasChunks,
        chunksMaskStyles: chunksMaskStyles,
        snapValueToChunk: snapValueToChunk
    };
}



const $b256c0debf2f88ca$export$1d0642f81c4ed710 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    absolute: Boolean,
    active: {
        type: Boolean,
        default: true
    },
    bgColor: String,
    bgOpacity: [
        Number,
        String
    ],
    bufferValue: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    bufferColor: String,
    bufferOpacity: [
        Number,
        String
    ],
    clickable: Boolean,
    color: String,
    height: {
        type: [
            Number,
            String
        ],
        default: 4
    },
    indeterminate: Boolean,
    max: {
        type: [
            Number,
            String
        ],
        default: 100
    },
    modelValue: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    opacity: [
        Number,
        String
    ],
    reverse: Boolean,
    stream: Boolean,
    striped: Boolean,
    roundedBar: Boolean,
    ...(0, $f727e13eeaf511a7$export$4b5633ed87e28257)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $636e88b893afba47$export$2831add577f947cb)({
        location: 'top'
    }),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VProgressLinear');
const $b256c0debf2f88ca$export$86b13ad59f1a1627 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VProgressLinear',
    props: $b256c0debf2f88ca$export$1d0642f81c4ed710(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const root = (0, $01W3b.ref)();
        const progress = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { isRtl: isRtl, rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { locationStyles: locationStyles } = (0, $636e88b893afba47$export$45d76561a5302f2b)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.color);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bgColor || props.color);
        const { backgroundColorClasses: bufferColorClasses, backgroundColorStyles: bufferColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bufferColor || props.bgColor || props.color);
        const { backgroundColorClasses: barColorClasses, backgroundColorStyles: barColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $16d02f6dfabde683$export$a7395f9832c00176)();
        const max = (0, $01W3b.computed)(()=>parseFloat(props.max));
        const height = (0, $01W3b.computed)(()=>parseFloat(props.height));
        const normalizedBuffer = (0, $01W3b.computed)(()=>(0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(parseFloat(props.bufferValue) / max.value * 100, 0, 100));
        const normalizedValue = (0, $01W3b.computed)(()=>(0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(parseFloat(progress.value) / max.value * 100, 0, 100));
        const isReversed = (0, $01W3b.computed)(()=>isRtl.value !== props.reverse);
        const transition = (0, $01W3b.computed)(()=>props.indeterminate ? 'fade-transition' : 'slide-x-transition');
        const containerWidth = (0, $01W3b.shallowRef)(0);
        const { hasChunks: hasChunks, chunksMaskStyles: chunksMaskStyles, snapValueToChunk: snapValueToChunk } = (0, $f727e13eeaf511a7$export$a174c058f819ac6f)(props, containerWidth);
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(hasChunks, ()=>{
            const { resizeRef: resizeRef } = (0, $d80db15b6452c606$export$683480f191c0e3ea)((entries)=>containerWidth.value = entries[0].contentRect.width);
            (0, $TusQn.watchEffect)(()=>resizeRef.value = root.value);
        });
        const bufferWidth = (0, $01W3b.computed)(()=>{
            return hasChunks.value ? snapValueToChunk(normalizedBuffer.value) : normalizedBuffer.value;
        });
        const barWidth = (0, $01W3b.computed)(()=>{
            return hasChunks.value ? snapValueToChunk(normalizedValue.value) : normalizedValue.value;
        });
        function handleClick(e) {
            if (!intersectionRef.value) return;
            const { left: left, right: right, width: width } = intersectionRef.value.getBoundingClientRect();
            const value = isReversed.value ? width - e.clientX + (right - width) : e.clientX - left;
            progress.value = Math.round(value / width * max.value);
        }
        (0, $TusQn.watchEffect)(()=>{
            intersectionRef.value = root.value;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "ref": root,
                "class": (0, $8POXm.normalizeClass)([
                    'v-progress-linear',
                    {
                        'v-progress-linear--absolute': props.absolute,
                        'v-progress-linear--active': props.active && isIntersecting.value,
                        'v-progress-linear--reverse': isReversed.value,
                        'v-progress-linear--rounded': props.rounded,
                        'v-progress-linear--rounded-bar': props.roundedBar,
                        'v-progress-linear--striped': props.striped,
                        'v-progress-linear--clickable': props.clickable
                    },
                    roundedClasses.value,
                    themeClasses.value,
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        bottom: props.location === 'bottom' ? 0 : undefined,
                        top: props.location === 'top' ? 0 : undefined,
                        height: props.active ? (0, $8590040a7833369a$export$286ad215293a0860)(height.value) : 0,
                        '--v-progress-linear-height': (0, $8590040a7833369a$export$286ad215293a0860)(height.value),
                        ...props.absolute ? locationStyles.value : {}
                    },
                    chunksMaskStyles.value,
                    props.style
                ]),
                "role": "progressbar",
                "aria-hidden": props.active ? 'false' : 'true',
                "aria-valuemin": "0",
                "aria-valuemax": props.max,
                "aria-valuenow": props.indeterminate ? undefined : Math.min(parseFloat(progress.value), max.value),
                "onClick": props.clickable && handleClick
            }, {
                default: ()=>[
                        props.stream && (0, $TusQn.createElementVNode)("div", {
                            "key": "stream",
                            "class": (0, $8POXm.normalizeClass)([
                                'v-progress-linear__stream',
                                textColorClasses.value
                            ]),
                            "style": {
                                ...textColorStyles.value,
                                [isReversed.value ? 'left' : 'right']: (0, $8590040a7833369a$export$286ad215293a0860)(-height.value),
                                borderTop: `${(0, $8590040a7833369a$export$286ad215293a0860)(height.value / 2)} dotted`,
                                opacity: parseFloat(props.bufferOpacity),
                                top: `calc(50% - ${(0, $8590040a7833369a$export$286ad215293a0860)(height.value / 4)})`,
                                width: (0, $8590040a7833369a$export$286ad215293a0860)(100 - normalizedBuffer.value, '%'),
                                '--v-progress-linear-stream-to': (0, $8590040a7833369a$export$286ad215293a0860)(height.value * (isReversed.value ? 1 : -1))
                            }
                        }, null),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": (0, $8POXm.normalizeClass)([
                                'v-progress-linear__background',
                                backgroundColorClasses.value
                            ]),
                            "style": (0, $8POXm.normalizeStyle)([
                                backgroundColorStyles.value,
                                {
                                    opacity: parseFloat(props.bgOpacity),
                                    width: props.stream ? 0 : undefined
                                }
                            ])
                        }, null),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": (0, $8POXm.normalizeClass)([
                                'v-progress-linear__buffer',
                                bufferColorClasses.value
                            ]),
                            "style": (0, $8POXm.normalizeStyle)([
                                bufferColorStyles.value,
                                {
                                    opacity: parseFloat(props.bufferOpacity),
                                    width: (0, $8590040a7833369a$export$286ad215293a0860)(bufferWidth.value, '%')
                                }
                            ])
                        }, null),
                        (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
                            "name": transition.value
                        }, {
                            default: ()=>[
                                    !props.indeterminate ? (0, $TusQn.createElementVNode)("div", {
                                        "class": (0, $8POXm.normalizeClass)([
                                            'v-progress-linear__determinate',
                                            barColorClasses.value
                                        ]),
                                        "style": (0, $8POXm.normalizeStyle)([
                                            barColorStyles.value,
                                            {
                                                width: (0, $8590040a7833369a$export$286ad215293a0860)(barWidth.value, '%')
                                            }
                                        ])
                                    }, null) : (0, $TusQn.createElementVNode)("div", {
                                        "class": "v-progress-linear__indeterminate"
                                    }, [
                                        [
                                            'long',
                                            'short'
                                        ].map((bar)=>(0, $TusQn.createElementVNode)("div", {
                                                "key": bar,
                                                "class": (0, $8POXm.normalizeClass)([
                                                    'v-progress-linear__indeterminate',
                                                    bar,
                                                    barColorClasses.value
                                                ]),
                                                "style": (0, $8POXm.normalizeStyle)(barColorStyles.value)
                                            }, null))
                                    ])
                                ]
                        }),
                        slots.default && (0, $TusQn.createElementVNode)("div", {
                            "class": "v-progress-linear__content"
                        }, [
                            slots.default({
                                value: normalizedValue.value,
                                buffer: normalizedBuffer.value
                            })
                        ])
                    ]
            }));
        return {};
    }
});



const $aec6311fd012b86e$export$149f04e0cba4dbc1 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    loading: [
        Boolean,
        String
    ]
}, 'loader');
function $aec6311fd012b86e$export$14095de704efe3f9(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    const loaderClasses = (0, $01W3b.toRef)(()=>({
            [`${name}--loading`]: props.loading
        }));
    return {
        loaderClasses: loaderClasses
    };
}
function $aec6311fd012b86e$export$9a5d46a3538da529(props, _ref) {
    let { slots: slots } = _ref;
    return (0, $TusQn.createElementVNode)("div", {
        "class": (0, $8POXm.normalizeClass)(`${props.name}__loader`)
    }, [
        slots.default?.({
            color: props.color,
            isActive: props.active
        }) || (0, $TusQn.createVNode)((0, $b256c0debf2f88ca$export$86b13ad59f1a1627), {
            "absolute": props.absolute,
            "active": props.active,
            "color": props.color,
            "height": "2",
            "indeterminate": true
        }, null)
    ]);
}



// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $572b8e75d6c9689d$var$positionValues = [
    'static',
    'relative',
    'fixed',
    'absolute',
    'sticky'
];
const $572b8e75d6c9689d$export$f84374c9369ae887 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    position: {
        type: String,
        validator: /* istanbul ignore next */ (v)=>$572b8e75d6c9689d$var$positionValues.includes(v)
    }
}, 'position');
function $572b8e75d6c9689d$export$8169801eda3f797f(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    const positionClasses = (0, $01W3b.toRef)(()=>{
        return props.position ? `${name}--${props.position}` : undefined;
    });
    return {
        positionClasses: positionClasses
    };
}



// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

function $1c0236248fe13b4c$export$3f79f0b98112cf57() {
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useRoute');
    return (0, $01W3b.computed)(()=>vm?.proxy?.$route);
}
function $1c0236248fe13b4c$export$9a302a45f65d0572() {
    return (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useRouter')?.proxy?.$router;
}
function $1c0236248fe13b4c$export$dcf14c9974fe2767(props, attrs) {
    const RouterLink = (0, $TusQn.resolveDynamicComponent)('RouterLink');
    const isLink = (0, $01W3b.toRef)(()=>!!(props.href || props.to));
    const isClickable = (0, $01W3b.computed)(()=>{
        return isLink?.value || (0, $8590040a7833369a$export$1f08a0593c4a067d)(attrs, 'click') || (0, $8590040a7833369a$export$1f08a0593c4a067d)(props, 'click');
    });
    if (typeof RouterLink === 'string' || !('useLink' in RouterLink)) {
        const href = (0, $01W3b.toRef)(()=>props.href);
        return {
            isLink: isLink,
            isRouterLink: (0, $01W3b.toRef)(()=>false),
            isClickable: isClickable,
            href: href,
            linkProps: (0, $01W3b.reactive)({
                href: href
            }),
            route: (0, $01W3b.toRef)(()=>undefined),
            navigate: (0, $01W3b.toRef)(()=>undefined)
        };
    }
    // vue-router useLink `to` prop needs to be reactive and useLink will crash if undefined
    const routerLink = RouterLink.useLink({
        to: (0, $01W3b.toRef)(()=>props.to || ''),
        replace: (0, $01W3b.toRef)(()=>props.replace)
    });
    // Actual link needs to be undefined when to prop is not used
    const link = (0, $01W3b.computed)(()=>props.to ? routerLink : undefined);
    const route = $1c0236248fe13b4c$export$3f79f0b98112cf57();
    const isActive = (0, $01W3b.computed)(()=>{
        if (!link.value) return false;
        if (!props.exact) return link.value.isActive?.value ?? false;
        if (!route.value) return link.value.isExactActive?.value ?? false;
        return link.value.isExactActive?.value && (0, $bf1718679e817e1f$export$9cb4719e2e525b7a)(link.value.route.value.query, route.value.query);
    });
    const href = (0, $01W3b.computed)(()=>props.to ? link.value?.route.value.href : props.href);
    const isRouterLink = (0, $01W3b.toRef)(()=>!!props.to);
    return {
        isLink: isLink,
        isRouterLink: isRouterLink,
        isClickable: isClickable,
        isActive: isActive,
        route: (0, $01W3b.toRef)(()=>link.value?.route.value),
        navigate: (0, $01W3b.toRef)(()=>link.value?.navigate),
        href: href,
        linkProps: (0, $01W3b.reactive)({
            href: href,
            'aria-current': (0, $01W3b.toRef)(()=>isActive.value ? 'page' : undefined),
            'aria-disabled': (0, $01W3b.toRef)(()=>props.disabled && isLink.value ? 'true' : undefined),
            tabindex: (0, $01W3b.toRef)(()=>props.disabled && isLink.value ? '-1' : undefined)
        })
    };
}
const $1c0236248fe13b4c$export$78d5db5e8f9b041d = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    href: String,
    replace: Boolean,
    to: [
        String,
        Object
    ],
    exact: Boolean
}, 'router');
let $1c0236248fe13b4c$var$inTransition = false;
function $1c0236248fe13b4c$export$a519bdc484beda0(router, cb) {
    let popped = false;
    let removeBefore;
    let removeAfter;
    if ((0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && router?.beforeEach) {
        (0, $TusQn.nextTick)(()=>{
            window.addEventListener('popstate', onPopstate);
            removeBefore = router.beforeEach((to, from, next)=>{
                if (!$1c0236248fe13b4c$var$inTransition) setTimeout(()=>popped ? cb(next) : next());
                else popped ? cb(next) : next();
                $1c0236248fe13b4c$var$inTransition = true;
            });
            removeAfter = router?.afterEach(()=>{
                $1c0236248fe13b4c$var$inTransition = false;
            });
        });
        (0, $01W3b.onScopeDispose)(()=>{
            window.removeEventListener('popstate', onPopstate);
            removeBefore?.();
            removeAfter?.();
        });
    }
    function onPopstate(e) {
        if (e.state?.replaced) return;
        popped = true;
        setTimeout(()=>popped = false);
    }
}


// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
function $a6818b438c9f1e8f$export$549d64cb44cfc0cc(link, select) {
    (0, $01W3b.watch)(()=>link.isActive?.value, (isActive)=>{
        if (link.isLink.value && isActive != null && select) (0, $TusQn.nextTick)(()=>{
            select(isActive);
        });
    }, {
        immediate: true
    });
}






// Styles


const $907916373bf62ceb$var$stopSymbol = Symbol('rippleStop');
const $907916373bf62ceb$var$DELAY_RIPPLE = 80;
function $907916373bf62ceb$var$transform(el, value) {
    el.style.transform = value;
    el.style.webkitTransform = value;
}
function $907916373bf62ceb$var$isTouchEvent(e) {
    return e.constructor.name === 'TouchEvent';
}
function $907916373bf62ceb$var$isKeyboardEvent(e) {
    return e.constructor.name === 'KeyboardEvent';
}
const $907916373bf62ceb$var$calculate = function(e, el) {
    let value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let localX = 0;
    let localY = 0;
    if (!$907916373bf62ceb$var$isKeyboardEvent(e)) {
        const offset = el.getBoundingClientRect();
        const target = $907916373bf62ceb$var$isTouchEvent(e) ? e.touches[e.touches.length - 1] : e;
        localX = target.clientX - offset.left;
        localY = target.clientY - offset.top;
    }
    let radius = 0;
    let scale = 0.3;
    if (el._ripple?.circle) {
        scale = 0.15;
        radius = el.clientWidth / 2;
        radius = value.center ? radius : radius + Math.sqrt((localX - radius) ** 2 + (localY - radius) ** 2) / 4;
    } else radius = Math.sqrt(el.clientWidth ** 2 + el.clientHeight ** 2) / 2;
    const centerX = `${(el.clientWidth - radius * 2) / 2}px`;
    const centerY = `${(el.clientHeight - radius * 2) / 2}px`;
    const x = value.center ? centerX : `${localX - radius}px`;
    const y = value.center ? centerY : `${localY - radius}px`;
    return {
        radius: radius,
        scale: scale,
        x: x,
        y: y,
        centerX: centerX,
        centerY: centerY
    };
};
const $907916373bf62ceb$var$ripples = {
    /* eslint-disable max-statements */ show (e, el) {
        let value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!el?._ripple?.enabled) return;
        const container = document.createElement('span');
        const animation = document.createElement('span');
        container.appendChild(animation);
        container.className = 'v-ripple__container';
        if (value.class) container.className += ` ${value.class}`;
        const { radius: radius, scale: scale, x: x, y: y, centerX: centerX, centerY: centerY } = $907916373bf62ceb$var$calculate(e, el, value);
        const size = `${radius * 2}px`;
        animation.className = 'v-ripple__animation';
        animation.style.width = size;
        animation.style.height = size;
        el.appendChild(container);
        const computed = window.getComputedStyle(el);
        if (computed && computed.position === 'static') {
            el.style.position = 'relative';
            el.dataset.previousPosition = 'static';
        }
        animation.classList.add('v-ripple__animation--enter');
        animation.classList.add('v-ripple__animation--visible');
        $907916373bf62ceb$var$transform(animation, `translate(${x}, ${y}) scale3d(${scale},${scale},${scale})`);
        animation.dataset.activated = String(performance.now());
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                animation.classList.remove('v-ripple__animation--enter');
                animation.classList.add('v-ripple__animation--in');
                $907916373bf62ceb$var$transform(animation, `translate(${centerX}, ${centerY}) scale3d(1,1,1)`);
            });
        });
    },
    hide (el) {
        if (!el?._ripple?.enabled) return;
        const ripples = el.getElementsByClassName('v-ripple__animation');
        if (ripples.length === 0) return;
        const animation = Array.from(ripples).findLast((ripple)=>!ripple.dataset.isHiding);
        if (!animation) return;
        else animation.dataset.isHiding = 'true';
        const diff = performance.now() - Number(animation.dataset.activated);
        const delay = Math.max(250 - diff, 0);
        setTimeout(()=>{
            animation.classList.remove('v-ripple__animation--in');
            animation.classList.add('v-ripple__animation--out');
            setTimeout(()=>{
                const ripples = el.getElementsByClassName('v-ripple__animation');
                if (ripples.length === 1 && el.dataset.previousPosition) {
                    el.style.position = el.dataset.previousPosition;
                    delete el.dataset.previousPosition;
                }
                if (animation.parentNode?.parentNode === el) el.removeChild(animation.parentNode);
            }, 300);
        }, delay);
    }
};
function $907916373bf62ceb$var$isRippleEnabled(value) {
    return typeof value === 'undefined' || !!value;
}
function $907916373bf62ceb$var$rippleShow(e) {
    const value = {};
    const element = e.currentTarget;
    if (!element?._ripple || element._ripple.touched || e[$907916373bf62ceb$var$stopSymbol]) return;
    // Don't allow the event to trigger ripples on any other elements
    e[$907916373bf62ceb$var$stopSymbol] = true;
    if ($907916373bf62ceb$var$isTouchEvent(e)) {
        element._ripple.touched = true;
        element._ripple.isTouch = true;
    } else {
        // It's possible for touch events to fire
        // as mouse events on Android/iOS, this
        // will skip the event call if it has
        // already been registered as touch
        if (element._ripple.isTouch) return;
    }
    value.center = element._ripple.centered || $907916373bf62ceb$var$isKeyboardEvent(e);
    if (element._ripple.class) value.class = element._ripple.class;
    if ($907916373bf62ceb$var$isTouchEvent(e)) {
        // already queued that shows or hides the ripple
        if (element._ripple.showTimerCommit) return;
        element._ripple.showTimerCommit = ()=>{
            $907916373bf62ceb$var$ripples.show(e, element, value);
        };
        element._ripple.showTimer = window.setTimeout(()=>{
            if (element?._ripple?.showTimerCommit) {
                element._ripple.showTimerCommit();
                element._ripple.showTimerCommit = null;
            }
        }, $907916373bf62ceb$var$DELAY_RIPPLE);
    } else $907916373bf62ceb$var$ripples.show(e, element, value);
}
function $907916373bf62ceb$var$rippleStop(e) {
    e[$907916373bf62ceb$var$stopSymbol] = true;
}
function $907916373bf62ceb$var$rippleHide(e) {
    const element = e.currentTarget;
    if (!element?._ripple) return;
    window.clearTimeout(element._ripple.showTimer);
    // The touch interaction occurs before the show timer is triggered.
    // We still want to show ripple effect.
    if (e.type === 'touchend' && element._ripple.showTimerCommit) {
        element._ripple.showTimerCommit();
        element._ripple.showTimerCommit = null;
        // re-queue ripple hiding
        element._ripple.showTimer = window.setTimeout(()=>{
            $907916373bf62ceb$var$rippleHide(e);
        });
        return;
    }
    window.setTimeout(()=>{
        if (element._ripple) element._ripple.touched = false;
    });
    $907916373bf62ceb$var$ripples.hide(element);
}
function $907916373bf62ceb$var$rippleCancelShow(e) {
    const element = e.currentTarget;
    if (!element?._ripple) return;
    if (element._ripple.showTimerCommit) element._ripple.showTimerCommit = null;
    window.clearTimeout(element._ripple.showTimer);
}
let $907916373bf62ceb$var$keyboardRipple = false;
function $907916373bf62ceb$var$keyboardRippleShow(e, keys) {
    if (!$907916373bf62ceb$var$keyboardRipple && keys.includes(e.key)) {
        $907916373bf62ceb$var$keyboardRipple = true;
        $907916373bf62ceb$var$rippleShow(e);
    }
}
function $907916373bf62ceb$var$keyboardRippleHide(e) {
    $907916373bf62ceb$var$keyboardRipple = false;
    $907916373bf62ceb$var$rippleHide(e);
}
function $907916373bf62ceb$var$focusRippleHide(e) {
    if ($907916373bf62ceb$var$keyboardRipple) {
        $907916373bf62ceb$var$keyboardRipple = false;
        $907916373bf62ceb$var$rippleHide(e);
    }
}
function $907916373bf62ceb$var$updateRipple(el, binding, wasEnabled) {
    const { value: value, modifiers: modifiers } = binding;
    const enabled = $907916373bf62ceb$var$isRippleEnabled(value);
    if (!enabled) $907916373bf62ceb$var$ripples.hide(el);
    el._ripple = el._ripple ?? {};
    el._ripple.enabled = enabled;
    el._ripple.centered = modifiers.center;
    el._ripple.circle = modifiers.circle;
    const bindingValue = (0, $8590040a7833369a$export$a6cdc56e425d0d0a)(value) ? value : {};
    if (bindingValue.class) el._ripple.class = bindingValue.class;
    const allowedKeys = bindingValue.keys ?? [
        'Enter',
        'Space'
    ];
    el._ripple.keyDownHandler = (e)=>$907916373bf62ceb$var$keyboardRippleShow(e, allowedKeys);
    if (enabled && !wasEnabled) {
        if (modifiers.stop) {
            el.addEventListener('touchstart', $907916373bf62ceb$var$rippleStop, {
                passive: true
            });
            el.addEventListener('mousedown', $907916373bf62ceb$var$rippleStop);
            return;
        }
        el.addEventListener('touchstart', $907916373bf62ceb$var$rippleShow, {
            passive: true
        });
        el.addEventListener('touchend', $907916373bf62ceb$var$rippleHide, {
            passive: true
        });
        el.addEventListener('touchmove', $907916373bf62ceb$var$rippleCancelShow, {
            passive: true
        });
        el.addEventListener('touchcancel', $907916373bf62ceb$var$rippleHide);
        el.addEventListener('mousedown', $907916373bf62ceb$var$rippleShow);
        el.addEventListener('mouseup', $907916373bf62ceb$var$rippleHide);
        el.addEventListener('mouseleave', $907916373bf62ceb$var$rippleHide);
        el.addEventListener('keydown', el._ripple.keyDownHandler);
        el.addEventListener('keyup', $907916373bf62ceb$var$keyboardRippleHide);
        el.addEventListener('blur', $907916373bf62ceb$var$focusRippleHide);
        // Anchor tags can be dragged, causes other hides to fail - #1537
        el.addEventListener('dragstart', $907916373bf62ceb$var$rippleHide, {
            passive: true
        });
    } else if (!enabled && wasEnabled) $907916373bf62ceb$var$removeListeners(el);
}
function $907916373bf62ceb$var$removeListeners(el) {
    el.removeEventListener('touchstart', $907916373bf62ceb$var$rippleStop);
    el.removeEventListener('mousedown', $907916373bf62ceb$var$rippleStop);
    el.removeEventListener('touchstart', $907916373bf62ceb$var$rippleShow);
    el.removeEventListener('touchend', $907916373bf62ceb$var$rippleHide);
    el.removeEventListener('touchmove', $907916373bf62ceb$var$rippleCancelShow);
    el.removeEventListener('touchcancel', $907916373bf62ceb$var$rippleHide);
    el.removeEventListener('mousedown', $907916373bf62ceb$var$rippleShow);
    el.removeEventListener('mouseup', $907916373bf62ceb$var$rippleHide);
    el.removeEventListener('mouseleave', $907916373bf62ceb$var$rippleHide);
    if (el._ripple?.keyDownHandler) el.removeEventListener('keydown', el._ripple.keyDownHandler);
    el.removeEventListener('keyup', $907916373bf62ceb$var$keyboardRippleHide);
    el.removeEventListener('blur', $907916373bf62ceb$var$focusRippleHide);
    el.removeEventListener('dragstart', $907916373bf62ceb$var$rippleHide);
}
function $907916373bf62ceb$var$mounted(el, binding) {
    $907916373bf62ceb$var$updateRipple(el, binding, false);
}
function $907916373bf62ceb$var$unmounted(el) {
    $907916373bf62ceb$var$removeListeners(el);
    delete el._ripple;
}
function $907916373bf62ceb$var$updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    const wasEnabled = $907916373bf62ceb$var$isRippleEnabled(binding.oldValue);
    $907916373bf62ceb$var$updateRipple(el, binding, wasEnabled);
}
const $907916373bf62ceb$export$9e9146f7e027fdaa = {
    mounted: $907916373bf62ceb$var$mounted,
    unmounted: $907916373bf62ceb$var$unmounted,
    updated: $907916373bf62ceb$var$updated
};
var $907916373bf62ceb$export$2e2bcd8739ae039 = $907916373bf62ceb$export$9e9146f7e027fdaa;



const $a343b25403be30b7$export$64daea74540bd34d = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    active: {
        type: Boolean,
        default: undefined
    },
    activeColor: String,
    baseColor: String,
    symbol: {
        type: null,
        default: (0, $b08d2d2d797cb622$export$7ccf67e9366faa19)
    },
    flat: Boolean,
    icon: [
        Boolean,
        String,
        Function,
        Object
    ],
    prependIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    appendIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    block: Boolean,
    readonly: Boolean,
    slim: Boolean,
    stacked: Boolean,
    spaced: String,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $0befa53cf46b542b$export$e9e3b570044587e8)(),
    ...(0, $aec6311fd012b86e$export$149f04e0cba4dbc1)(),
    ...(0, $636e88b893afba47$export$2831add577f947cb)(),
    ...(0, $572b8e75d6c9689d$export$f84374c9369ae887)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $1c0236248fe13b4c$export$78d5db5e8f9b041d)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'button'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'elevated'
    })
}, 'VBtn');
const $a343b25403be30b7$export$657f28cf887b91a6 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBtn',
    props: $a343b25403be30b7$export$64daea74540bd34d(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { loaderClasses: loaderClasses } = (0, $aec6311fd012b86e$export$14095de704efe3f9)(props);
        const { locationStyles: locationStyles } = (0, $636e88b893afba47$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $572b8e75d6c9689d$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = (0, $b9afb2891b9aa639$export$1ab7ae714698c4b8)(props);
        const group = (0, $0befa53cf46b542b$export$eebde8160f061c26)(props, props.symbol, false);
        const link = (0, $1c0236248fe13b4c$export$dcf14c9974fe2767)(props, attrs);
        const isActive = (0, $01W3b.computed)(()=>{
            if (props.active !== undefined) return props.active;
            if (link.isRouterLink.value) return link.isActive?.value;
            return group?.isSelected.value;
        });
        const color = (0, $01W3b.toRef)(()=>isActive.value ? props.activeColor ?? props.color : props.color);
        const variantProps = (0, $01W3b.computed)(()=>{
            const showColor = group?.isSelected.value && (!link.isLink.value || link.isActive?.value) || !group || link.isActive?.value;
            return {
                color: showColor ? color.value ?? props.baseColor : props.baseColor,
                variant: props.variant
            };
        });
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $567f01637e3e83ec$export$36ef81613f8f20fc)(variantProps);
        const isDisabled = (0, $01W3b.computed)(()=>group?.disabled.value || props.disabled);
        const isElevated = (0, $01W3b.toRef)(()=>{
            return props.variant === 'elevated' && !(props.disabled || props.flat || props.border);
        });
        const valueAttr = (0, $01W3b.computed)(()=>{
            if (props.value === undefined || typeof props.value === 'symbol') return undefined;
            return Object(props.value) === props.value ? JSON.stringify(props.value, null, 0) : props.value;
        });
        function onClick(e) {
            if (isDisabled.value || link.isLink.value && (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0 || attrs.target === '_blank')) return;
            if (link.isRouterLink.value) link.navigate.value?.(e);
            else // Group active state for links is handled by useSelectLink
            group?.toggle();
        }
        (0, $a6818b438c9f1e8f$export$549d64cb44cfc0cc)(link, group?.select);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const Tag = link.isLink.value ? 'a' : props.tag;
            const hasPrepend = !!(props.prependIcon || slots.prepend);
            const hasAppend = !!(props.appendIcon || slots.append);
            const hasIcon = !!(props.icon && props.icon !== true);
            return (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(Tag, (0, $TusQn.mergeProps)(link.linkProps, {
                "type": Tag === 'a' ? undefined : 'button',
                "class": [
                    'v-btn',
                    group?.selectedClass.value,
                    {
                        'v-btn--active': isActive.value,
                        'v-btn--block': props.block,
                        'v-btn--disabled': isDisabled.value,
                        'v-btn--elevated': isElevated.value,
                        'v-btn--flat': props.flat,
                        'v-btn--icon': !!props.icon,
                        'v-btn--loading': props.loading,
                        'v-btn--readonly': props.readonly,
                        'v-btn--slim': props.slim,
                        'v-btn--stacked': props.stacked
                    },
                    props.spaced ? [
                        'v-btn--spaced',
                        `v-btn--spaced-${props.spaced}`
                    ] : [],
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    loaderClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    sizeClasses.value,
                    variantClasses.value,
                    props.class
                ],
                "style": [
                    colorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    sizeStyles.value,
                    props.style
                ],
                "aria-busy": props.loading ? true : undefined,
                "disabled": isDisabled.value && Tag !== 'a' || undefined,
                "tabindex": props.loading || props.readonly ? -1 : undefined,
                "onClick": onClick,
                "value": valueAttr.value
            }), {
                default: ()=>[
                        (0, $567f01637e3e83ec$export$e27cd265ed232373)(true, 'v-btn'),
                        !props.icon && hasPrepend && (0, $TusQn.createElementVNode)("span", {
                            "key": "prepend",
                            "class": "v-btn__prepend"
                        }, [
                            !slots.prepend ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                "key": "prepend-icon",
                                "icon": props.prependIcon
                            }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !props.prependIcon,
                                "defaults": {
                                    VIcon: {
                                        icon: props.prependIcon
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $TusQn.createElementVNode)("span", {
                            "class": "v-btn__content",
                            "data-no-activator": ""
                        }, [
                            !slots.default && hasIcon ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                "key": "content-icon",
                                "icon": props.icon
                            }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "content-defaults",
                                "disabled": !hasIcon,
                                "defaults": {
                                    VIcon: {
                                        icon: props.icon
                                    }
                                }
                            }, {
                                default: ()=>[
                                        slots.default?.() ?? (0, $8POXm.toDisplayString)(props.text)
                                    ]
                            })
                        ]),
                        !props.icon && hasAppend && (0, $TusQn.createElementVNode)("span", {
                            "key": "append",
                            "class": "v-btn__append"
                        }, [
                            !slots.append ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                "key": "append-icon",
                                "icon": props.appendIcon
                            }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "append-defaults",
                                "disabled": !props.appendIcon,
                                "defaults": {
                                    VIcon: {
                                        icon: props.appendIcon
                                    }
                                }
                            }, slots.append)
                        ]),
                        !!props.loading && (0, $TusQn.createElementVNode)("span", {
                            "key": "loader",
                            "class": "v-btn__loader"
                        }, [
                            slots.loader?.() ?? (0, $TusQn.createVNode)((0, $26f3a281106a205d$export$2b4afd8de42c0c21), {
                                "color": typeof props.loading === 'boolean' ? undefined : props.loading,
                                "indeterminate": true,
                                "width": "2"
                            }, null)
                        ])
                    ]
            }), [
                [
                    (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                    !isDisabled.value && props.ripple,
                    '',
                    {
                        center: !!props.icon
                    }
                ]
            ]);
        });
        return {
            group: group
        };
    }
});



const $4c2d4cfe4881b62f$export$d185179e2c3c040b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $a343b25403be30b7$export$64daea74540bd34d)({
        icon: '$menu',
        variant: 'text'
    }), [
        'spaced'
    ])
}, 'VAppBarNavIcon');
const $4c2d4cfe4881b62f$export$692fce24359c3843 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VAppBarNavIcon',
    props: $4c2d4cfe4881b62f$export$d185179e2c3c040b(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)(props, {
                "class": [
                    'v-app-bar-nav-icon'
                ]
            }), slots));
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");


const $f0ac698606000754$export$657ba4c199549e9b = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VAppBarTitle',
    props: (0, $19fdabc79dfb07a7$export$6afad7cb17124872)(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)((0, $19fdabc79dfb07a7$export$deaeca9428bfc9a4), (0, $TusQn.mergeProps)(props, {
                "class": "v-app-bar-title"
            }), slots));
        return {};
    }
});




var $96f9927811cb207b$exports = {};

$parcel$export($96f9927811cb207b$exports, "VAlert", () => $679ae6e83c1be1d4$export$8eebf457c668f05a);
$parcel$export($96f9927811cb207b$exports, "VAlertTitle", () => $125ba2f5db57e87d$export$628ef577672e443a);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");

// Utilities
// Composables

parcelRequire("ecd4d");
var $8POXm = parcelRequire("8POXm");
var $TusQn = parcelRequire("TusQn");

function $5224ab9d69b8c3e0$export$b3680ae2c271b9f3(klass) {
    let tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
    let name = arguments.length > 2 ? arguments[2] : undefined;
    return (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
        name: name ?? (0, $8POXm.capitalize)((0, $8POXm.camelize)(klass.replace(/__/g, '-'))),
        props: {
            tag: {
                type: String,
                default: tag
            },
            ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
        },
        setup (props, _ref) {
            let { slots: slots } = _ref;
            return ()=>{
                return (0, $TusQn.h)(props.tag, {
                    class: [
                        klass,
                        props.class
                    ],
                    style: props.style
                }, slots.default?.());
            };
        }
    });
}


const $125ba2f5db57e87d$export$628ef577672e443a = (0, $5224ab9d69b8c3e0$export$b3680ae2c271b9f3)('v-alert-title');











// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $49fd8db83c6afc6c$export$32a89e97443766e5 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    iconSize: [
        Number,
        String
    ],
    iconSizes: {
        type: Array,
        default: ()=>[
                [
                    'x-small',
                    10
                ],
                [
                    'small',
                    16
                ],
                [
                    'default',
                    24
                ],
                [
                    'large',
                    28
                ],
                [
                    'x-large',
                    32
                ]
            ]
    }
}, 'iconSize');
function $49fd8db83c6afc6c$export$d456a6cf49d1aad6(props, fallback) {
    const iconSize = (0, $01W3b.computed)(()=>{
        const iconSizeMap = new Map(props.iconSizes);
        const _iconSize = props.iconSize ?? fallback() ?? 'default';
        return iconSizeMap.has(_iconSize) ? iconSizeMap.get(_iconSize) : _iconSize;
    });
    return {
        iconSize: iconSize
    };
}











const $679ae6e83c1be1d4$var$allowedTypes = [
    'success',
    'info',
    'warning',
    'error'
];
const $679ae6e83c1be1d4$export$d79b2456dccb8959 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    border: {
        type: [
            Boolean,
            String
        ],
        validator: (val)=>{
            return typeof val === 'boolean' || [
                'top',
                'end',
                'bottom',
                'start'
            ].includes(val);
        }
    },
    borderColor: String,
    closable: Boolean,
    closeIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$close'
    },
    closeLabel: {
        type: String,
        default: '$vuetify.close'
    },
    icon: {
        type: [
            Boolean,
            String,
            Function,
            Object
        ],
        default: null
    },
    modelValue: {
        type: Boolean,
        default: true
    },
    prominent: Boolean,
    title: String,
    text: String,
    type: {
        type: String,
        validator: (val)=>$679ae6e83c1be1d4$var$allowedTypes.includes(val)
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $49fd8db83c6afc6c$export$32a89e97443766e5)(),
    ...(0, $636e88b893afba47$export$2831add577f947cb)(),
    ...(0, $572b8e75d6c9689d$export$f84374c9369ae887)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'flat'
    })
}, 'VAlert');
const $679ae6e83c1be1d4$export$8eebf457c668f05a = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VAlert',
    props: $679ae6e83c1be1d4$export$d79b2456dccb8959(),
    emits: {
        'click:close': (e)=>true,
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const icon = (0, $01W3b.toRef)(()=>{
            if (props.icon === false) return undefined;
            if (!props.type) return props.icon;
            return props.icon ?? `$${props.type}`;
        });
        const { iconSize: iconSize } = (0, $49fd8db83c6afc6c$export$d456a6cf49d1aad6)(props, ()=>props.prominent ? 44 : undefined);
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $567f01637e3e83ec$export$36ef81613f8f20fc)(()=>({
                color: props.color ?? props.type,
                variant: props.variant
            }));
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { locationStyles: locationStyles } = (0, $636e88b893afba47$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $572b8e75d6c9689d$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.borderColor);
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const closeProps = (0, $01W3b.toRef)(()=>({
                'aria-label': t(props.closeLabel),
                onClick (e) {
                    isActive.value = false;
                    emit('click:close', e);
                }
            }));
        return ()=>{
            const hasPrepend = !!(slots.prepend || icon.value);
            const hasTitle = !!(slots.title || props.title);
            const hasClose = !!(slots.close || props.closable);
            const iconProps = {
                density: props.density,
                icon: icon.value,
                size: props.iconSize || props.prominent ? iconSize.value : undefined
            };
            return isActive.value && (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-alert',
                    props.border && {
                        'v-alert--border': !!props.border,
                        [`v-alert--border-${props.border === true ? 'start' : props.border}`]: true
                    },
                    {
                        'v-alert--prominent': props.prominent
                    },
                    themeClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    colorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ]),
                "role": "alert"
            }, {
                default: ()=>[
                        (0, $567f01637e3e83ec$export$e27cd265ed232373)(false, 'v-alert'),
                        props.border && (0, $TusQn.createElementVNode)("div", {
                            "key": "border",
                            "class": (0, $8POXm.normalizeClass)([
                                'v-alert__border',
                                textColorClasses.value
                            ]),
                            "style": (0, $8POXm.normalizeStyle)(textColorStyles.value)
                        }, null),
                        hasPrepend && (0, $TusQn.createElementVNode)("div", {
                            "key": "prepend",
                            "class": "v-alert__prepend"
                        }, [
                            !slots.prepend ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), (0, $TusQn.mergeProps)({
                                "key": "prepend-icon"
                            }, iconProps), null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !icon.value,
                                "defaults": {
                                    VIcon: {
                                        ...iconProps
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-alert__content"
                        }, [
                            hasTitle && (0, $TusQn.createVNode)((0, $125ba2f5db57e87d$export$628ef577672e443a), {
                                "key": "title"
                            }, {
                                default: ()=>[
                                        slots.title?.() ?? props.title
                                    ]
                            }),
                            slots.text?.() ?? props.text,
                            slots.default?.()
                        ]),
                        slots.append && (0, $TusQn.createElementVNode)("div", {
                            "key": "append",
                            "class": "v-alert__append"
                        }, [
                            slots.append()
                        ]),
                        hasClose && (0, $TusQn.createElementVNode)("div", {
                            "key": "close",
                            "class": "v-alert__close"
                        }, [
                            !slots.close ? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                                "key": "close-btn",
                                "icon": props.closeIcon,
                                "size": "x-small",
                                "variant": "text"
                            }, closeProps.value), null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "close-defaults",
                                "defaults": {
                                    VBtn: {
                                        icon: props.closeIcon,
                                        size: 'x-small',
                                        variant: 'text'
                                    }
                                }
                            }, {
                                default: ()=>[
                                        slots.close?.({
                                            props: closeProps.value
                                        })
                                    ]
                            })
                        ])
                    ]
            });
        };
    }
});





var $218d14aecf3c4b8e$exports = {};

$parcel$export($218d14aecf3c4b8e$exports, "VAutocomplete", () => $30b50b21f01bc544$export$4fa8d945b1b14087);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");














const $acc7f6236cd87eac$export$c5e97f606ca9e65c = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    start: Boolean,
    end: Boolean,
    icon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    image: String,
    text: String,
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'flat'
    })
}, 'VAvatar');
const $acc7f6236cd87eac$export$dbee61bc703cd5ff = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VAvatar',
    props: $acc7f6236cd87eac$export$c5e97f606ca9e65c(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $567f01637e3e83ec$export$36ef81613f8f20fc)(props);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = (0, $b9afb2891b9aa639$export$1ab7ae714698c4b8)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-avatar',
                    {
                        'v-avatar--start': props.start,
                        'v-avatar--end': props.end
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    roundedClasses.value,
                    sizeClasses.value,
                    variantClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    colorStyles.value,
                    sizeStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        !slots.default ? props.image ? (0, $TusQn.createVNode)((0, $b2937780237888c4$export$126ec614c536f27c), {
                            "key": "image",
                            "src": props.image,
                            "alt": "",
                            "cover": true
                        }, null) : props.icon ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                            "key": "icon",
                            "icon": props.icon
                        }, null) : props.text : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "key": "content-defaults",
                            "defaults": {
                                VImg: {
                                    cover: true,
                                    src: props.image
                                },
                                VIcon: {
                                    icon: props.icon
                                }
                            }
                        }, {
                            default: ()=>[
                                    slots.default()
                                ]
                        }),
                        (0, $567f01637e3e83ec$export$e27cd265ed232373)(false, 'v-avatar')
                    ]
            }));
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");




const $e23bfa10b64d3f5e$export$87bbab332de32d3 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    text: String,
    onClick: (0, $8590040a7833369a$export$cefab237a347bf23)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VLabel');
const $e23bfa10b64d3f5e$export$90281af35207eb21 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VLabel',
    props: $e23bfa10b64d3f5e$export$87bbab332de32d3(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("label", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-label',
                    {
                        'v-label--clickable': !!props.onClick
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style),
                "onClick": props.onClick
            }, [
                props.text,
                slots.default?.()
            ]));
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");








const $ad8cfeb89b25efca$export$dc483627378c8c37 = Symbol.for('vuetify:selection-control-group');
const $ad8cfeb89b25efca$export$f6307c62fd1b0ce3 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    disabled: {
        type: Boolean,
        default: null
    },
    defaultsTarget: String,
    error: Boolean,
    id: String,
    inline: Boolean,
    falseIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    trueIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    multiple: {
        type: Boolean,
        default: null
    },
    name: String,
    readonly: {
        type: Boolean,
        default: null
    },
    modelValue: null,
    type: String,
    valueComparator: {
        type: Function,
        default: (0, $bf1718679e817e1f$export$9cb4719e2e525b7a)
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'SelectionControlGroup');
const $ad8cfeb89b25efca$export$859877846b10e869 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...$ad8cfeb89b25efca$export$f6307c62fd1b0ce3({
        defaultsTarget: 'VSelectionControl'
    })
}, 'VSelectionControlGroup');
const $ad8cfeb89b25efca$export$fbaa479cb0704980 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSelectionControlGroup',
    props: $ad8cfeb89b25efca$export$859877846b10e869(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const modelValue = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const uid = (0, $TusQn.useId)();
        const id = (0, $01W3b.toRef)(()=>props.id || `v-selection-control-group-${uid}`);
        const name = (0, $01W3b.toRef)(()=>props.name || id.value);
        const updateHandlers = new Set();
        (0, $TusQn.provide)($ad8cfeb89b25efca$export$dc483627378c8c37, {
            modelValue: modelValue,
            forceUpdate: ()=>{
                updateHandlers.forEach((fn)=>fn());
            },
            onForceUpdate: (cb)=>{
                updateHandlers.add(cb);
                (0, $01W3b.onScopeDispose)(()=>{
                    updateHandlers.delete(cb);
                });
            }
        });
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            [props.defaultsTarget]: {
                color: (0, $01W3b.toRef)(()=>props.color),
                disabled: (0, $01W3b.toRef)(()=>props.disabled),
                density: (0, $01W3b.toRef)(()=>props.density),
                error: (0, $01W3b.toRef)(()=>props.error),
                inline: (0, $01W3b.toRef)(()=>props.inline),
                modelValue: modelValue,
                multiple: (0, $01W3b.toRef)(()=>!!props.multiple || props.multiple == null && Array.isArray(modelValue.value)),
                name: name,
                falseIcon: (0, $01W3b.toRef)(()=>props.falseIcon),
                trueIcon: (0, $01W3b.toRef)(()=>props.trueIcon),
                readonly: (0, $01W3b.toRef)(()=>props.readonly),
                ripple: (0, $01W3b.toRef)(()=>props.ripple),
                type: (0, $01W3b.toRef)(()=>props.type),
                valueComparator: (0, $01W3b.toRef)(()=>props.valueComparator)
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-selection-control-group',
                    {
                        'v-selection-control-group--inline': props.inline
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style),
                "role": props.type === 'radio' ? 'radiogroup' : undefined
            }, [
                slots.default?.()
            ]));
        return {};
    }
});








const $6bf6692b535e8488$export$a15300eeb449da9c = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    label: String,
    baseColor: String,
    trueValue: null,
    falseValue: null,
    value: null,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $ad8cfeb89b25efca$export$f6307c62fd1b0ce3)()
}, 'VSelectionControl');
function $6bf6692b535e8488$export$d7418bbd9b6d5f0c(props) {
    const group = (0, $TusQn.inject)((0, $ad8cfeb89b25efca$export$dc483627378c8c37), undefined);
    const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
    const modelValue = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
    const trueValue = (0, $01W3b.computed)(()=>props.trueValue !== undefined ? props.trueValue : props.value !== undefined ? props.value : true);
    const falseValue = (0, $01W3b.computed)(()=>props.falseValue !== undefined ? props.falseValue : false);
    const isMultiple = (0, $01W3b.computed)(()=>!!props.multiple || props.multiple == null && Array.isArray(modelValue.value));
    const model = (0, $01W3b.computed)({
        get () {
            const val = group ? group.modelValue.value : modelValue.value;
            return isMultiple.value ? (0, $8590040a7833369a$export$76411cac38121ecb)(val).some((v)=>props.valueComparator(v, trueValue.value)) : props.valueComparator(val, trueValue.value);
        },
        set (val) {
            if (props.readonly) return;
            const currentValue = val ? trueValue.value : falseValue.value;
            let newVal = currentValue;
            if (isMultiple.value) newVal = val ? [
                ...(0, $8590040a7833369a$export$76411cac38121ecb)(modelValue.value),
                currentValue
            ] : (0, $8590040a7833369a$export$76411cac38121ecb)(modelValue.value).filter((item)=>!props.valueComparator(item, trueValue.value));
            if (group) group.modelValue.value = newVal;
            else modelValue.value = newVal;
        }
    });
    const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>{
        if (props.error || props.disabled) return undefined;
        return model.value ? props.color : props.baseColor;
    });
    const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>{
        return model.value && !props.error && !props.disabled ? props.color : props.baseColor;
    });
    const icon = (0, $01W3b.computed)(()=>model.value ? props.trueIcon : props.falseIcon);
    return {
        group: group,
        densityClasses: densityClasses,
        trueValue: trueValue,
        falseValue: falseValue,
        model: model,
        textColorClasses: textColorClasses,
        textColorStyles: textColorStyles,
        backgroundColorClasses: backgroundColorClasses,
        backgroundColorStyles: backgroundColorStyles,
        icon: icon
    };
}
const $6bf6692b535e8488$export$ada18d63da74fb09 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSelectionControl',
    directives: {
        vRipple: $907916373bf62ceb$export$2e2bcd8739ae039
    },
    inheritAttrs: false,
    props: $6bf6692b535e8488$export$a15300eeb449da9c(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { group: group, densityClasses: densityClasses, icon: icon, model: model, textColorClasses: textColorClasses, textColorStyles: textColorStyles, backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles, trueValue: trueValue } = $6bf6692b535e8488$export$d7418bbd9b6d5f0c(props);
        const uid = (0, $TusQn.useId)();
        const isFocused = (0, $01W3b.shallowRef)(false);
        const isFocusVisible = (0, $01W3b.shallowRef)(false);
        const input = (0, $01W3b.ref)();
        const id = (0, $01W3b.toRef)(()=>props.id || `input-${uid}`);
        const isInteractive = (0, $01W3b.toRef)(()=>!props.disabled && !props.readonly);
        group?.onForceUpdate(()=>{
            if (input.value) input.value.checked = model.value;
        });
        function onFocus(e) {
            if (!isInteractive.value) return;
            isFocused.value = true;
            if ((0, $8590040a7833369a$export$b06a2f5618961e1e)(e.target, ':focus-visible') !== false) isFocusVisible.value = true;
        }
        function onBlur() {
            isFocused.value = false;
            isFocusVisible.value = false;
        }
        function onClickLabel(e) {
            e.stopPropagation();
        }
        function onInput(e) {
            if (!isInteractive.value) {
                if (input.value) // model value is not updated when input is not interactive
                // but the internal checked state of the input is still updated,
                // so here it's value is restored
                input.value.checked = model.value;
                return;
            }
            if (props.readonly && group) (0, $TusQn.nextTick)(()=>group.forceUpdate());
            model.value = e.target.checked;
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const label = slots.label ? slots.label({
                label: props.label,
                props: {
                    for: id.value
                }
            }) : props.label;
            const [rootAttrs, inputAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            const inputNode = (0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                "ref": input,
                "checked": model.value,
                "disabled": !!props.disabled,
                "id": id.value,
                "onBlur": onBlur,
                "onFocus": onFocus,
                "onInput": onInput,
                "aria-disabled": !!props.disabled,
                "aria-label": props.label,
                "type": props.type,
                "value": trueValue.value,
                "name": props.name,
                "aria-checked": props.type === 'checkbox' ? model.value : undefined
            }, inputAttrs), null);
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "class": [
                    'v-selection-control',
                    {
                        'v-selection-control--dirty': model.value,
                        'v-selection-control--disabled': props.disabled,
                        'v-selection-control--error': props.error,
                        'v-selection-control--focused': isFocused.value,
                        'v-selection-control--focus-visible': isFocusVisible.value,
                        'v-selection-control--inline': props.inline
                    },
                    densityClasses.value,
                    props.class
                ]
            }, rootAttrs, {
                "style": props.style
            }), [
                (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-selection-control__wrapper',
                        textColorClasses.value
                    ]),
                    "style": (0, $8POXm.normalizeStyle)(textColorStyles.value)
                }, [
                    slots.default?.({
                        backgroundColorClasses: backgroundColorClasses,
                        backgroundColorStyles: backgroundColorStyles
                    }),
                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                        "class": (0, $8POXm.normalizeClass)([
                            'v-selection-control__input'
                        ])
                    }, [
                        slots.input?.({
                            model: model,
                            textColorClasses: textColorClasses,
                            textColorStyles: textColorStyles,
                            backgroundColorClasses: backgroundColorClasses,
                            backgroundColorStyles: backgroundColorStyles,
                            inputNode: inputNode,
                            icon: icon.value,
                            props: {
                                onFocus: onFocus,
                                onBlur: onBlur,
                                id: id.value
                            }
                        }) ?? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                            icon.value && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                "key": "icon",
                                "icon": icon.value
                            }, null),
                            inputNode
                        ])
                    ]), [
                        [
                            (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                            !props.disabled && !props.readonly && props.ripple,
                            null,
                            {
                                center: true,
                                circle: true
                            }
                        ]
                    ])
                ]),
                label && (0, $TusQn.createVNode)((0, $e23bfa10b64d3f5e$export$90281af35207eb21), {
                    "for": id.value,
                    "onClick": onClickLabel
                }, {
                    default: ()=>[
                            label
                        ]
                })
            ]);
        });
        return {
            isFocused: isFocused,
            input: input
        };
    }
});





const $c8f17ec9401c8898$export$b10b3450c190da23 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    indeterminate: Boolean,
    indeterminateIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$checkboxIndeterminate'
    },
    ...(0, $6bf6692b535e8488$export$a15300eeb449da9c)({
        falseIcon: '$checkboxOff',
        trueIcon: '$checkboxOn'
    })
}, 'VCheckboxBtn');
const $c8f17ec9401c8898$export$2c5503cb3c38fdb6 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCheckboxBtn',
    props: $c8f17ec9401c8898$export$b10b3450c190da23(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:indeterminate': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const indeterminate = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'indeterminate');
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        function onChange(v) {
            if (indeterminate.value) indeterminate.value = false;
        }
        const falseIcon = (0, $01W3b.toRef)(()=>{
            return indeterminate.value ? props.indeterminateIcon : props.falseIcon;
        });
        const trueIcon = (0, $01W3b.toRef)(()=>{
            return indeterminate.value ? props.indeterminateIcon : props.trueIcon;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const controlProps = (0, $8590040a7833369a$export$30a06c8d3562193f)((0, $6bf6692b535e8488$export$ada18d63da74fb09).filterProps(props), [
                'modelValue'
            ]);
            return (0, $TusQn.createVNode)((0, $6bf6692b535e8488$export$ada18d63da74fb09), (0, $TusQn.mergeProps)(controlProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": [
                    ($event)=>model.value = $event,
                    onChange
                ],
                "class": [
                    'v-checkbox-btn',
                    props.class
                ],
                "style": props.style,
                "type": "checkbox",
                "falseIcon": falseIcon.value,
                "trueIcon": trueIcon.value,
                "aria-checked": indeterminate.value ? 'mixed' : undefined
            }), slots);
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");



parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");











function $86a93f2c01fb08bc$export$72671e4b692fd502(_ref) {
    let { selectedElement: selectedElement, containerElement: containerElement, isRtl: isRtl, isHorizontal: isHorizontal } = _ref;
    const containerSize = $86a93f2c01fb08bc$export$e474b82ad079053b(isHorizontal, containerElement);
    const scrollPosition = $86a93f2c01fb08bc$export$3abe133d5501edeb(isHorizontal, isRtl, containerElement);
    const childrenSize = $86a93f2c01fb08bc$export$e474b82ad079053b(isHorizontal, selectedElement);
    const childrenStartPosition = $86a93f2c01fb08bc$export$456611cab2a1cf25(isHorizontal, selectedElement);
    const additionalOffset = childrenSize * 0.4;
    if (scrollPosition > childrenStartPosition) return childrenStartPosition - additionalOffset;
    else if (scrollPosition + containerSize < childrenStartPosition + childrenSize) return childrenStartPosition - containerSize + childrenSize + additionalOffset;
    return scrollPosition;
}
function $86a93f2c01fb08bc$export$1d9da49cc5a9a084(_ref2) {
    let { selectedElement: selectedElement, containerElement: containerElement, isHorizontal: isHorizontal } = _ref2;
    const containerOffsetSize = $86a93f2c01fb08bc$export$e474b82ad079053b(isHorizontal, containerElement);
    const childrenOffsetPosition = $86a93f2c01fb08bc$export$456611cab2a1cf25(isHorizontal, selectedElement);
    const childrenOffsetSize = $86a93f2c01fb08bc$export$e474b82ad079053b(isHorizontal, selectedElement);
    return childrenOffsetPosition - containerOffsetSize / 2 + childrenOffsetSize / 2;
}
function $86a93f2c01fb08bc$export$d9d87c520f59b2d3(isHorizontal, element) {
    const key = isHorizontal ? 'scrollWidth' : 'scrollHeight';
    return element?.[key] || 0;
}
function $86a93f2c01fb08bc$export$1feb45891927fcb4(isHorizontal, element) {
    const key = isHorizontal ? 'clientWidth' : 'clientHeight';
    return element?.[key] || 0;
}
function $86a93f2c01fb08bc$export$3abe133d5501edeb(isHorizontal, rtl, element) {
    if (!element) return 0;
    const { scrollLeft: scrollLeft, offsetWidth: offsetWidth, scrollWidth: scrollWidth } = element;
    if (isHorizontal) return rtl ? scrollWidth - offsetWidth + scrollLeft : scrollLeft;
    return element.scrollTop;
}
function $86a93f2c01fb08bc$export$e474b82ad079053b(isHorizontal, element) {
    const key = isHorizontal ? 'offsetWidth' : 'offsetHeight';
    return element?.[key] || 0;
}
function $86a93f2c01fb08bc$export$456611cab2a1cf25(isHorizontal, element) {
    const key = isHorizontal ? 'offsetLeft' : 'offsetTop';
    return element?.[key] || 0;
}



const $d5c54c6c3d49c30f$export$f8d4255bddd9d04c = Symbol.for('vuetify:v-slide-group');
const $d5c54c6c3d49c30f$export$8d9f6ad26ccf07ca = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    centerActive: Boolean,
    scrollToActive: {
        type: Boolean,
        default: true
    },
    contentClass: null,
    direction: {
        type: String,
        default: 'horizontal'
    },
    symbol: {
        type: null,
        default: $d5c54c6c3d49c30f$export$f8d4255bddd9d04c
    },
    nextIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$next'
    },
    prevIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$prev'
    },
    showArrows: {
        type: [
            Boolean,
            String
        ],
        validator: (v)=>typeof v === 'boolean' || [
                'always',
                'desktop',
                'mobile',
                'never'
            ].includes(v)
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $1444e2cf1a712792$export$d0badecb383b472a)({
        mobile: null
    }),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $0befa53cf46b542b$export$fa4c05b3520340e6)({
        selectedClass: 'v-slide-group-item--active'
    })
}, 'VSlideGroup');
const $d5c54c6c3d49c30f$export$f3e025e558a486a4 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSlideGroup',
    props: $d5c54c6c3d49c30f$export$8d9f6ad26ccf07ca(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { isRtl: isRtl } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const { displayClasses: displayClasses, mobile: mobile } = (0, $1444e2cf1a712792$export$8406b7efc286d284)(props);
        const group = (0, $0befa53cf46b542b$export$bfb6a372146ddc96)(props, props.symbol);
        const isOverflowing = (0, $01W3b.shallowRef)(false);
        const scrollOffset = (0, $01W3b.shallowRef)(0);
        const containerSize = (0, $01W3b.shallowRef)(0);
        const contentSize = (0, $01W3b.shallowRef)(0);
        const isHorizontal = (0, $01W3b.computed)(()=>props.direction === 'horizontal');
        const { resizeRef: containerRef, contentRect: containerRect } = (0, $d80db15b6452c606$export$683480f191c0e3ea)();
        const { resizeRef: contentRef, contentRect: contentRect } = (0, $d80db15b6452c606$export$683480f191c0e3ea)();
        const goTo = (0, $63ad461311545872$export$427b5df65b729c6)();
        const goToOptions = (0, $01W3b.computed)(()=>{
            return {
                container: containerRef.el,
                duration: 200,
                easing: 'easeOutQuart'
            };
        });
        const firstSelectedIndex = (0, $01W3b.computed)(()=>{
            if (!group.selected.value.length) return -1;
            return group.items.value.findIndex((item)=>item.id === group.selected.value[0]);
        });
        const lastSelectedIndex = (0, $01W3b.computed)(()=>{
            if (!group.selected.value.length) return -1;
            return group.items.value.findIndex((item)=>item.id === group.selected.value[group.selected.value.length - 1]);
        });
        if (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) {
            let frame = -1;
            (0, $01W3b.watch)(()=>[
                    group.selected.value,
                    containerRect.value,
                    contentRect.value,
                    isHorizontal.value
                ], ()=>{
                cancelAnimationFrame(frame);
                frame = requestAnimationFrame(()=>{
                    if (containerRect.value && contentRect.value) {
                        const sizeProperty = isHorizontal.value ? 'width' : 'height';
                        containerSize.value = containerRect.value[sizeProperty];
                        contentSize.value = contentRect.value[sizeProperty];
                        isOverflowing.value = containerSize.value + 1 < contentSize.value;
                    }
                    if (props.scrollToActive && firstSelectedIndex.value >= 0 && contentRef.el) {
                        // TODO: Is this too naive? Should we store element references in group composable?
                        const selectedElement = contentRef.el.children[lastSelectedIndex.value];
                        scrollToChildren(selectedElement, props.centerActive);
                    }
                });
            });
        }
        const isFocused = (0, $01W3b.shallowRef)(false);
        function scrollToChildren(children, center) {
            let target = 0;
            if (center) target = (0, $86a93f2c01fb08bc$export$1d9da49cc5a9a084)({
                containerElement: containerRef.el,
                isHorizontal: isHorizontal.value,
                selectedElement: children
            });
            else target = (0, $86a93f2c01fb08bc$export$72671e4b692fd502)({
                containerElement: containerRef.el,
                isHorizontal: isHorizontal.value,
                isRtl: isRtl.value,
                selectedElement: children
            });
            scrollToPosition(target);
        }
        function scrollToPosition(newPosition) {
            if (!(0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) || !containerRef.el) return;
            const offsetSize = (0, $86a93f2c01fb08bc$export$e474b82ad079053b)(isHorizontal.value, containerRef.el);
            const scrollPosition = (0, $86a93f2c01fb08bc$export$3abe133d5501edeb)(isHorizontal.value, isRtl.value, containerRef.el);
            const scrollSize = (0, $86a93f2c01fb08bc$export$d9d87c520f59b2d3)(isHorizontal.value, containerRef.el);
            if (scrollSize <= offsetSize || // Prevent scrolling by only a couple of pixels, which doesn't look smooth
            Math.abs(newPosition - scrollPosition) < 16) return;
            if (isHorizontal.value && isRtl.value && containerRef.el) {
                const { scrollWidth: scrollWidth, offsetWidth: containerWidth } = containerRef.el;
                newPosition = scrollWidth - containerWidth - newPosition;
            }
            if (isHorizontal.value) goTo.horizontal(newPosition, goToOptions.value);
            else goTo(newPosition, goToOptions.value);
        }
        function onScroll(e) {
            const { scrollTop: scrollTop, scrollLeft: scrollLeft } = e.target;
            scrollOffset.value = isHorizontal.value ? scrollLeft : scrollTop;
        }
        function onFocusin(e) {
            isFocused.value = true;
            if (!isOverflowing.value || !contentRef.el) return;
            // Focused element is likely to be the root of an item, so a
            // breadth-first search will probably find it in the first iteration
            for (const el of e.composedPath()){
                for (const item of contentRef.el.children)if (item === el) {
                    scrollToChildren(item);
                    return;
                }
            }
        }
        function onFocusout(e) {
            isFocused.value = false;
        }
        // Affix clicks produce onFocus that we have to ignore to avoid extra scrollToChildren
        let ignoreFocusEvent = false;
        function onFocus(e) {
            if (!ignoreFocusEvent && !isFocused.value && !(e.relatedTarget && contentRef.el?.contains(e.relatedTarget))) focus();
            ignoreFocusEvent = false;
        }
        function onFocusAffixes() {
            ignoreFocusEvent = true;
        }
        function onKeydown(e) {
            if (!contentRef.el) return;
            function toFocus(location) {
                e.preventDefault();
                focus(location);
            }
            if (isHorizontal.value) {
                if (e.key === 'ArrowRight') toFocus(isRtl.value ? 'prev' : 'next');
                else if (e.key === 'ArrowLeft') toFocus(isRtl.value ? 'next' : 'prev');
            } else {
                if (e.key === 'ArrowDown') toFocus('next');
                else if (e.key === 'ArrowUp') toFocus('prev');
            }
            if (e.key === 'Home') toFocus('first');
            else if (e.key === 'End') toFocus('last');
        }
        function getSiblingElement(el, location) {
            if (!el) return undefined;
            let sibling = el;
            do sibling = sibling?.[location === 'next' ? 'nextElementSibling' : 'previousElementSibling'];
            while (sibling?.hasAttribute('disabled'));
            return sibling;
        }
        function focus(location) {
            if (!contentRef.el) return;
            let el;
            if (!location) {
                const focusable = (0, $8590040a7833369a$export$aea49dace3f6ca76)(contentRef.el);
                el = focusable[0];
            } else if (location === 'next') {
                el = getSiblingElement(contentRef.el.querySelector(':focus'), location);
                if (!el) return focus('first');
            } else if (location === 'prev') {
                el = getSiblingElement(contentRef.el.querySelector(':focus'), location);
                if (!el) return focus('last');
            } else if (location === 'first') {
                el = contentRef.el.firstElementChild;
                if (el?.hasAttribute('disabled')) el = getSiblingElement(el, 'next');
            } else if (location === 'last') {
                el = contentRef.el.lastElementChild;
                if (el?.hasAttribute('disabled')) el = getSiblingElement(el, 'prev');
            }
            if (el) el.focus({
                preventScroll: true
            });
        }
        function scrollTo(location) {
            const direction = isHorizontal.value && isRtl.value ? -1 : 1;
            const offsetStep = (location === 'prev' ? -direction : direction) * containerSize.value;
            let newPosition = scrollOffset.value + offsetStep;
            // TODO: improve it
            if (isHorizontal.value && isRtl.value && containerRef.el) {
                const { scrollWidth: scrollWidth, offsetWidth: containerWidth } = containerRef.el;
                newPosition += scrollWidth - containerWidth;
            }
            scrollToPosition(newPosition);
        }
        const slotProps = (0, $01W3b.computed)(()=>({
                next: group.next,
                prev: group.prev,
                select: group.select,
                isSelected: group.isSelected
            }));
        const hasOverflowOrScroll = (0, $01W3b.computed)(()=>isOverflowing.value || Math.abs(scrollOffset.value) > 0);
        const hasAffixes = (0, $01W3b.computed)(()=>{
            switch(props.showArrows){
                case 'never':
                    return false;
                // Always show arrows on desktop & mobile
                case 'always':
                    return true;
                // Always show arrows on desktop
                case 'desktop':
                    return !mobile.value;
                // Show arrows on mobile when overflowing.
                // This matches the default 2.2 behavior
                case true:
                    return hasOverflowOrScroll.value;
                // Always show on mobile
                case 'mobile':
                    return mobile.value || hasOverflowOrScroll.value;
                // https://material.io/components/tabs#scrollable-tabs
                // Always show arrows when
                // overflowed on desktop
                default:
                    return !mobile.value && hasOverflowOrScroll.value;
            }
        });
        const hasPrev = (0, $01W3b.computed)(()=>{
            // 1 pixel in reserve, may be lost after rounding
            return Math.abs(scrollOffset.value) > 1;
        });
        const hasNext = (0, $01W3b.computed)(()=>{
            if (!containerRef.value || !hasOverflowOrScroll.value) return false;
            const scrollSize = (0, $86a93f2c01fb08bc$export$d9d87c520f59b2d3)(isHorizontal.value, containerRef.el);
            const clientSize = (0, $86a93f2c01fb08bc$export$1feb45891927fcb4)(isHorizontal.value, containerRef.el);
            const scrollSizeMax = scrollSize - clientSize;
            // 1 pixel in reserve, may be lost after rounding
            return scrollSizeMax - Math.abs(scrollOffset.value) > 1;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-slide-group',
                    {
                        'v-slide-group--vertical': !isHorizontal.value,
                        'v-slide-group--has-affixes': hasAffixes.value,
                        'v-slide-group--is-overflowing': isOverflowing.value
                    },
                    displayClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style),
                "tabindex": isFocused.value || group.selected.value.length ? -1 : 0,
                "onFocus": onFocus
            }, {
                default: ()=>[
                        hasAffixes.value && (0, $TusQn.createElementVNode)("div", {
                            "key": "prev",
                            "class": (0, $8POXm.normalizeClass)([
                                'v-slide-group__prev',
                                {
                                    'v-slide-group__prev--disabled': !hasPrev.value
                                }
                            ]),
                            "onMousedown": onFocusAffixes,
                            "onClick": ()=>hasPrev.value && scrollTo('prev')
                        }, [
                            slots.prev?.(slotProps.value) ?? (0, $TusQn.createVNode)((0, $7ec1b0ef33b04126$export$13ce8c44634b158c), null, {
                                default: ()=>[
                                        (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                            "icon": isRtl.value ? props.nextIcon : props.prevIcon
                                        }, null)
                                    ]
                            })
                        ]),
                        (0, $TusQn.createElementVNode)("div", {
                            "key": "container",
                            "ref": containerRef,
                            "class": (0, $8POXm.normalizeClass)([
                                'v-slide-group__container',
                                props.contentClass
                            ]),
                            "onScroll": onScroll
                        }, [
                            (0, $TusQn.createElementVNode)("div", {
                                "ref": contentRef,
                                "class": "v-slide-group__content",
                                "onFocusin": onFocusin,
                                "onFocusout": onFocusout,
                                "onKeydown": onKeydown
                            }, [
                                slots.default?.(slotProps.value)
                            ])
                        ]),
                        hasAffixes.value && (0, $TusQn.createElementVNode)("div", {
                            "key": "next",
                            "class": (0, $8POXm.normalizeClass)([
                                'v-slide-group__next',
                                {
                                    'v-slide-group__next--disabled': !hasNext.value
                                }
                            ]),
                            "onMousedown": onFocusAffixes,
                            "onClick": ()=>hasNext.value && scrollTo('next')
                        }, [
                            slots.next?.(slotProps.value) ?? (0, $TusQn.createVNode)((0, $7ec1b0ef33b04126$export$13ce8c44634b158c), null, {
                                default: ()=>[
                                        (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                            "icon": isRtl.value ? props.prevIcon : props.nextIcon
                                        }, null)
                                    ]
                            })
                        ])
                    ]
            }));
        return {
            selected: group.selected,
            scrollTo: scrollTo,
            scrollOffset: scrollOffset,
            focus: focus,
            hasPrev: hasPrev,
            hasNext: hasNext
        };
    }
});









const $7cb2aa0b88b3d8d4$export$74b52ffc27c1a17c = Symbol.for('vuetify:v-chip-group');
const $7cb2aa0b88b3d8d4$export$66871af2e011e6cd = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    baseColor: String,
    column: Boolean,
    filter: Boolean,
    valueComparator: {
        type: Function,
        default: (0, $bf1718679e817e1f$export$9cb4719e2e525b7a)
    },
    ...(0, $d5c54c6c3d49c30f$export$8d9f6ad26ccf07ca)({
        scrollToActive: false
    }),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $0befa53cf46b542b$export$fa4c05b3520340e6)({
        selectedClass: 'v-chip--selected'
    }),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'tonal'
    })
}, 'VChipGroup');
const $7cb2aa0b88b3d8d4$export$d38779cb67beb087 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VChipGroup',
    props: $7cb2aa0b88b3d8d4$export$66871af2e011e6cd(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { isSelected: isSelected, select: select, next: next, prev: prev, selected: selected } = (0, $0befa53cf46b542b$export$bfb6a372146ddc96)(props, $7cb2aa0b88b3d8d4$export$74b52ffc27c1a17c);
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VChip: {
                baseColor: (0, $01W3b.toRef)(()=>props.baseColor),
                color: (0, $01W3b.toRef)(()=>props.color),
                disabled: (0, $01W3b.toRef)(()=>props.disabled),
                filter: (0, $01W3b.toRef)(()=>props.filter),
                variant: (0, $01W3b.toRef)(()=>props.variant)
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const slideGroupProps = (0, $d5c54c6c3d49c30f$export$f3e025e558a486a4).filterProps(props);
            return (0, $TusQn.createVNode)((0, $d5c54c6c3d49c30f$export$f3e025e558a486a4), (0, $TusQn.mergeProps)(slideGroupProps, {
                "class": [
                    'v-chip-group',
                    {
                        'v-chip-group--column': props.column
                    },
                    themeClasses.value,
                    props.class
                ],
                "style": props.style
            }), {
                default: ()=>[
                        slots.default?.({
                            isSelected: isSelected,
                            select: select,
                            next: next,
                            prev: prev,
                            selected: selected.value
                        })
                    ]
            });
        });
        return {};
    }
});





















const $fd0891698b65ffb1$export$5b6b76de0aa76ecc = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    activeClass: String,
    appendAvatar: String,
    appendIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    baseColor: String,
    closable: Boolean,
    closeIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$delete'
    },
    closeLabel: {
        type: String,
        default: '$vuetify.close'
    },
    draggable: Boolean,
    filter: Boolean,
    filterIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$complete'
    },
    label: Boolean,
    link: {
        type: Boolean,
        default: undefined
    },
    pill: Boolean,
    prependAvatar: String,
    prependIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    modelValue: {
        type: Boolean,
        default: true
    },
    onClick: (0, $8590040a7833369a$export$cefab237a347bf23)(),
    onClickOnce: (0, $8590040a7833369a$export$cefab237a347bf23)(),
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $0befa53cf46b542b$export$e9e3b570044587e8)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $1c0236248fe13b4c$export$78d5db5e8f9b041d)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'span'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'tonal'
    })
}, 'VChip');
const $fd0891698b65ffb1$export$1b5fab12cd17b4fb = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VChip',
    directives: {
        vRipple: $907916373bf62ceb$export$2e2bcd8739ae039
    },
    props: $fd0891698b65ffb1$export$5b6b76de0aa76ecc(),
    emits: {
        'click:close': (e)=>true,
        'update:modelValue': (value)=>true,
        'group:selected': (val)=>true,
        click: (e)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { sizeClasses: sizeClasses } = (0, $b9afb2891b9aa639$export$1ab7ae714698c4b8)(props);
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const group = (0, $0befa53cf46b542b$export$eebde8160f061c26)(props, (0, $7cb2aa0b88b3d8d4$export$74b52ffc27c1a17c), false);
        const slideGroup = (0, $0befa53cf46b542b$export$eebde8160f061c26)(props, (0, $d5c54c6c3d49c30f$export$f8d4255bddd9d04c), false);
        const link = (0, $1c0236248fe13b4c$export$dcf14c9974fe2767)(props, attrs);
        const isLink = (0, $01W3b.toRef)(()=>props.link !== false && link.isLink.value);
        const isClickable = (0, $01W3b.computed)(()=>!props.disabled && props.link !== false && (!!group || props.link || link.isClickable.value));
        const closeProps = (0, $01W3b.toRef)(()=>({
                'aria-label': t(props.closeLabel),
                disabled: props.disabled,
                onClick (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    isActive.value = false;
                    emit('click:close', e);
                }
            }));
        (0, $01W3b.watch)(isActive, (val)=>{
            if (val) {
                group?.register();
                slideGroup?.register();
            } else {
                group?.unregister();
                slideGroup?.unregister();
            }
        });
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $567f01637e3e83ec$export$36ef81613f8f20fc)(()=>{
            const showColor = !group || group.isSelected.value;
            return {
                color: showColor ? props.color ?? props.baseColor : props.baseColor,
                variant: props.variant
            };
        });
        function onClick(e) {
            emit('click', e);
            if (!isClickable.value) return;
            link.navigate.value?.(e);
            group?.toggle();
        }
        function onKeyDown(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
            }
        }
        return ()=>{
            const Tag = link.isLink.value ? 'a' : props.tag;
            const hasAppendMedia = !!(props.appendIcon || props.appendAvatar);
            const hasAppend = !!(hasAppendMedia || slots.append);
            const hasClose = !!(slots.close || props.closable);
            const hasFilter = !!(slots.filter || props.filter) && group;
            const hasPrependMedia = !!(props.prependIcon || props.prependAvatar);
            const hasPrepend = !!(hasPrependMedia || slots.prepend);
            return isActive.value && (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(Tag, (0, $TusQn.mergeProps)(link.linkProps, {
                "class": [
                    'v-chip',
                    {
                        'v-chip--disabled': props.disabled,
                        'v-chip--label': props.label,
                        'v-chip--link': isClickable.value,
                        'v-chip--filter': hasFilter,
                        'v-chip--pill': props.pill,
                        [`${props.activeClass}`]: props.activeClass && link.isActive?.value
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    sizeClasses.value,
                    variantClasses.value,
                    group?.selectedClass.value,
                    props.class
                ],
                "style": [
                    colorStyles.value,
                    props.style
                ],
                "disabled": props.disabled || undefined,
                "draggable": props.draggable,
                "tabindex": isClickable.value ? 0 : undefined,
                "onClick": onClick,
                "onKeydown": isClickable.value && !isLink.value && onKeyDown
            }), {
                default: ()=>[
                        (0, $567f01637e3e83ec$export$e27cd265ed232373)(isClickable.value, 'v-chip'),
                        hasFilter && (0, $TusQn.createVNode)((0, $7ec1b0ef33b04126$export$d54edbcba7869f36), {
                            "key": "filter"
                        }, {
                            default: ()=>[
                                    (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                                        "class": "v-chip__filter"
                                    }, [
                                        !slots.filter ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                            "key": "filter-icon",
                                            "icon": props.filterIcon
                                        }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                            "key": "filter-defaults",
                                            "disabled": !props.filterIcon,
                                            "defaults": {
                                                VIcon: {
                                                    icon: props.filterIcon
                                                }
                                            }
                                        }, slots.filter)
                                    ]), [
                                        [
                                            (0, $eeJ70.vShow),
                                            group.isSelected.value
                                        ]
                                    ])
                                ]
                        }),
                        hasPrepend && (0, $TusQn.createElementVNode)("div", {
                            "key": "prepend",
                            "class": "v-chip__prepend"
                        }, [
                            !slots.prepend ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                props.prependIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                    "key": "prepend-icon",
                                    "icon": props.prependIcon,
                                    "start": true
                                }, null),
                                props.prependAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                    "key": "prepend-avatar",
                                    "image": props.prependAvatar,
                                    "start": true
                                }, null)
                            ]) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !hasPrependMedia,
                                "defaults": {
                                    VAvatar: {
                                        image: props.prependAvatar,
                                        start: true
                                    },
                                    VIcon: {
                                        icon: props.prependIcon,
                                        start: true
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-chip__content",
                            "data-no-activator": ""
                        }, [
                            slots.default?.({
                                isSelected: group?.isSelected.value,
                                selectedClass: group?.selectedClass.value,
                                select: group?.select,
                                toggle: group?.toggle,
                                value: group?.value.value,
                                disabled: props.disabled
                            }) ?? (0, $8POXm.toDisplayString)(props.text)
                        ]),
                        hasAppend && (0, $TusQn.createElementVNode)("div", {
                            "key": "append",
                            "class": "v-chip__append"
                        }, [
                            !slots.append ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                props.appendIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                    "key": "append-icon",
                                    "end": true,
                                    "icon": props.appendIcon
                                }, null),
                                props.appendAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                    "key": "append-avatar",
                                    "end": true,
                                    "image": props.appendAvatar
                                }, null)
                            ]) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "append-defaults",
                                "disabled": !hasAppendMedia,
                                "defaults": {
                                    VAvatar: {
                                        end: true,
                                        image: props.appendAvatar
                                    },
                                    VIcon: {
                                        end: true,
                                        icon: props.appendIcon
                                    }
                                }
                            }, slots.append)
                        ]),
                        hasClose && (0, $TusQn.createElementVNode)("button", (0, $TusQn.mergeProps)({
                            "key": "close",
                            "class": "v-chip__close",
                            "type": "button",
                            "data-testid": "close-chip"
                        }, closeProps.value), [
                            !slots.close ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                "key": "close-icon",
                                "icon": props.closeIcon,
                                "size": "x-small"
                            }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "close-defaults",
                                "defaults": {
                                    VIcon: {
                                        icon: props.closeIcon,
                                        size: 'x-small'
                                    }
                                }
                            }, slots.close)
                        ])
                    ]
            }), [
                [
                    (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                    isClickable.value && props.ripple,
                    null
                ]
            ]);
        };
    }
});



parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");





const $7eecf16f7970712c$var$allowedVariants = [
    'dotted',
    'dashed',
    'solid',
    'double'
];
const $7eecf16f7970712c$export$1c23c63c3209ac98 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    contentOffset: [
        Number,
        String,
        Array
    ],
    gradient: Boolean,
    inset: Boolean,
    length: [
        Number,
        String
    ],
    opacity: [
        Number,
        String
    ],
    thickness: [
        Number,
        String
    ],
    vertical: Boolean,
    variant: {
        type: String,
        default: 'solid',
        validator: (v)=>$7eecf16f7970712c$var$allowedVariants.includes(v)
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VDivider');
const $7eecf16f7970712c$export$a2636a5d9a866ca1 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDivider',
    props: $7eecf16f7970712c$export$1c23c63c3209ac98(),
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.color);
        const dividerStyles = (0, $01W3b.computed)(()=>{
            const styles = {};
            if (props.length) styles[props.vertical ? 'height' : 'width'] = (0, $8590040a7833369a$export$286ad215293a0860)(props.length);
            if (props.thickness) styles[props.vertical ? 'borderRightWidth' : 'borderTopWidth'] = (0, $8590040a7833369a$export$286ad215293a0860)(props.thickness);
            return styles;
        });
        const contentStyles = (0, $01W3b.toRef)(()=>{
            const margin = Array.isArray(props.contentOffset) ? props.contentOffset[0] : props.contentOffset;
            const shift = Array.isArray(props.contentOffset) ? props.contentOffset[1] : 0;
            return {
                marginBlock: props.vertical && margin ? (0, $8590040a7833369a$export$286ad215293a0860)(margin) : undefined,
                marginInline: !props.vertical && margin ? (0, $8590040a7833369a$export$286ad215293a0860)(margin) : undefined,
                transform: shift ? `translate${props.vertical ? 'X' : 'Y'}(${(0, $8590040a7833369a$export$286ad215293a0860)(shift)})` : undefined
            };
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const divider = (0, $TusQn.createElementVNode)("hr", {
                "class": (0, $8POXm.normalizeClass)([
                    {
                        'v-divider': true,
                        'v-divider--gradient': props.gradient && !slots.default,
                        'v-divider--inset': props.inset,
                        'v-divider--vertical': props.vertical
                    },
                    themeClasses.value,
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    dividerStyles.value,
                    textColorStyles.value,
                    {
                        '--v-border-opacity': props.opacity
                    },
                    {
                        'border-style': props.variant
                    },
                    props.style
                ]),
                "aria-orientation": !attrs.role || attrs.role === 'separator' ? props.vertical ? 'vertical' : 'horizontal' : undefined,
                "role": `${attrs.role || 'separator'}`
            }, null);
            if (!slots.default) return divider;
            return (0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-divider__wrapper',
                    {
                        'v-divider__wrapper--gradient': props.gradient,
                        'v-divider__wrapper--inset': props.inset,
                        'v-divider__wrapper--vertical': props.vertical
                    }
                ])
            }, [
                divider,
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-divider__content",
                    "style": (0, $8POXm.normalizeStyle)(contentStyles.value)
                }, [
                    slots.default()
                ]),
                divider
            ]);
        });
        return {};
    }
});



parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");



function $9a9409ba39d4a5b8$export$d08cb507a9c34d4b(props) {
    const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
    function InputIcon(_ref) {
        let { name: name, color: color, ...attrs } = _ref;
        const localeKey = {
            prepend: 'prependAction',
            prependInner: 'prependAction',
            append: 'appendAction',
            appendInner: 'appendAction',
            clear: 'clear'
        }[name];
        const listener = props[`onClick:${name}`];
        function onKeydown(e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            e.stopPropagation();
            (0, $8590040a7833369a$export$293b251ea77dc2b7)(listener, new PointerEvent('click', e));
        }
        const label = listener && localeKey ? t(`$vuetify.input.${localeKey}`, props.label ?? '') : undefined;
        return (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), (0, $TusQn.mergeProps)({
            "icon": props[`${name}Icon`],
            "aria-label": label,
            "onClick": listener,
            "onKeydown": onKeydown,
            "color": color
        }, attrs), null);
    }
    return {
        InputIcon: InputIcon
    };
}


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
const $862a9b1b0084874a$export$48075a67713cd8aa = Symbol.for('vuetify:depth');
function $862a9b1b0084874a$export$ea435a089f01433c(hasPrepend) {
    const parent = (0, $TusQn.inject)($862a9b1b0084874a$export$48075a67713cd8aa, (0, $01W3b.shallowRef)(-1));
    const depth = (0, $01W3b.computed)(()=>parent.value + 1 + (hasPrepend?.value ? 1 : 0));
    (0, $TusQn.provide)($862a9b1b0084874a$export$48075a67713cd8aa, depth);
    return depth;
}
const $862a9b1b0084874a$export$f69297c4748e8734 = Symbol.for('vuetify:list');
function $862a9b1b0084874a$export$5897d8d7c7a3d871() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        filterable: false
    };
    const parent = (0, $TusQn.inject)($862a9b1b0084874a$export$f69297c4748e8734, {
        filterable: false,
        hasPrepend: (0, $01W3b.shallowRef)(false),
        updateHasPrepend: ()=>null,
        trackingIndex: (0, $01W3b.shallowRef)(-1),
        navigationStrategy: (0, $01W3b.shallowRef)('focus'),
        uid: ''
    });
    const { filterable: filterable, trackingIndex: trackingIndex = parent.trackingIndex, navigationStrategy: navigationStrategy = parent.navigationStrategy, uid: uid = parent.uid || (0, $TusQn.useId)() } = options;
    const data = {
        filterable: parent.filterable || filterable,
        hasPrepend: (0, $01W3b.shallowRef)(false),
        updateHasPrepend: (value)=>{
            if (value) data.hasPrepend.value = value;
        },
        trackingIndex: trackingIndex,
        navigationStrategy: navigationStrategy,
        uid: uid
    };
    (0, $TusQn.provide)($862a9b1b0084874a$export$f69297c4748e8734, data);
    return parent;
}
function $862a9b1b0084874a$export$f9763ecd339e95eb() {
    return (0, $TusQn.inject)($862a9b1b0084874a$export$f69297c4748e8734, null);
}




// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
/* eslint-disable sonarjs/no-identical-functions */ // Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $c1099c3be34efdbc$export$9387f2baf58fc090 = (mandatory)=>{
    const strategy = {
        activate: (_ref)=>{
            let { id: id, value: value, activated: activated } = _ref;
            id = (0, $01W3b.toRaw)(id);
            // When mandatory and we're trying to deselect when id
            // is the only currently selected item then do nothing
            if (mandatory && !value && activated.size === 1 && activated.has(id)) return activated;
            if (value) activated.add(id);
            else activated.delete(id);
            return activated;
        },
        in: (v, children, parents)=>{
            let set = new Set();
            if (v != null) for (const id of (0, $8590040a7833369a$export$76411cac38121ecb)(v))set = strategy.activate({
                id: id,
                value: true,
                activated: new Set(set),
                children: children,
                parents: parents
            });
            return set;
        },
        out: (v)=>{
            return Array.from(v);
        }
    };
    return strategy;
};
const $c1099c3be34efdbc$export$5b58acd5140059d7 = (mandatory)=>{
    const parentStrategy = $c1099c3be34efdbc$export$9387f2baf58fc090(mandatory);
    const strategy = {
        activate: (_ref2)=>{
            let { activated: activated, id: id, ...rest } = _ref2;
            id = (0, $01W3b.toRaw)(id);
            const singleSelected = activated.has(id) ? new Set([
                id
            ]) : new Set();
            return parentStrategy.activate({
                ...rest,
                id: id,
                activated: singleSelected
            });
        },
        in: (v, children, parents)=>{
            let set = new Set();
            if (v != null) {
                const arr = (0, $8590040a7833369a$export$76411cac38121ecb)(v);
                if (arr.length) set = parentStrategy.in(arr.slice(0, 1), children, parents);
            }
            return set;
        },
        out: (v, children, parents)=>{
            return parentStrategy.out(v, children, parents);
        }
    };
    return strategy;
};
const $c1099c3be34efdbc$export$86506b87e5d93888 = (mandatory)=>{
    const parentStrategy = $c1099c3be34efdbc$export$9387f2baf58fc090(mandatory);
    const strategy = {
        activate: (_ref3)=>{
            let { id: id, activated: activated, children: children, ...rest } = _ref3;
            id = (0, $01W3b.toRaw)(id);
            if (children.has(id)) return activated;
            return parentStrategy.activate({
                id: id,
                activated: activated,
                children: children,
                ...rest
            });
        },
        in: parentStrategy.in,
        out: parentStrategy.out
    };
    return strategy;
};
const $c1099c3be34efdbc$export$910c1ade9a9231fc = (mandatory)=>{
    const parentStrategy = $c1099c3be34efdbc$export$5b58acd5140059d7(mandatory);
    const strategy = {
        activate: (_ref4)=>{
            let { id: id, activated: activated, children: children, ...rest } = _ref4;
            id = (0, $01W3b.toRaw)(id);
            if (children.has(id)) return activated;
            return parentStrategy.activate({
                id: id,
                activated: activated,
                children: children,
                ...rest
            });
        },
        in: parentStrategy.in,
        out: parentStrategy.out
    };
    return strategy;
};


const $53fefb2eac92b059$export$7a4693cebcd37a8a = {
    open: (_ref)=>{
        let { id: id, value: value, opened: opened, parents: parents } = _ref;
        if (value) {
            const newOpened = new Set();
            newOpened.add(id);
            let parent = parents.get(id);
            while(parent != null){
                newOpened.add(parent);
                parent = parents.get(parent);
            }
            return newOpened;
        } else {
            opened.delete(id);
            return opened;
        }
    },
    select: ()=>null
};
const $53fefb2eac92b059$export$3e2f656d3630f9a4 = {
    open: (_ref2)=>{
        let { id: id, value: value, opened: opened, parents: parents } = _ref2;
        if (value) {
            let parent = parents.get(id);
            opened.add(id);
            while(parent != null && parent !== id){
                opened.add(parent);
                parent = parents.get(parent);
            }
            return opened;
        } else opened.delete(id);
        return opened;
    },
    select: ()=>null
};
const $53fefb2eac92b059$export$d7952eef3b24cbdf = {
    open: $53fefb2eac92b059$export$3e2f656d3630f9a4.open,
    select: (_ref3)=>{
        let { id: id, value: value, opened: opened, parents: parents } = _ref3;
        if (!value) return opened;
        const path = [];
        let parent = parents.get(id);
        while(parent != null){
            path.push(parent);
            parent = parents.get(parent);
        }
        return new Set(path);
    }
};


/* eslint-disable sonarjs/no-identical-functions */ // Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
const $168091b4f5487239$export$ed77aaa4426be279 = (mandatory)=>{
    const strategy = {
        select: (_ref)=>{
            let { id: id, value: value, selected: selected } = _ref;
            id = (0, $01W3b.toRaw)(id);
            // When mandatory and we're trying to deselect when id
            // is the only currently selected item then do nothing
            if (mandatory && !value) {
                const on = Array.from(selected.entries()).reduce((arr, _ref2)=>{
                    let [key, value] = _ref2;
                    if (value === 'on') arr.push(key);
                    return arr;
                }, []);
                if (on.length === 1 && on[0] === id) return selected;
            }
            selected.set(id, value ? 'on' : 'off');
            return selected;
        },
        in: (v, children, parents, disabled)=>{
            const map = new Map();
            for (const id of v || [])strategy.select({
                id: id,
                value: true,
                selected: map,
                children: children,
                parents: parents,
                disabled: disabled
            });
            return map;
        },
        out: (v)=>{
            const arr = [];
            for (const [key, value] of v.entries())if (value === 'on') arr.push(key);
            return arr;
        }
    };
    return strategy;
};
const $168091b4f5487239$export$628b10e27c96fc1f = (mandatory)=>{
    const parentStrategy = $168091b4f5487239$export$ed77aaa4426be279(mandatory);
    const strategy = {
        select: (_ref3)=>{
            let { selected: selected, id: id, ...rest } = _ref3;
            id = (0, $01W3b.toRaw)(id);
            const singleSelected = selected.has(id) ? new Map([
                [
                    id,
                    selected.get(id)
                ]
            ]) : new Map();
            return parentStrategy.select({
                ...rest,
                id: id,
                selected: singleSelected
            });
        },
        in: (v, children, parents, disabled)=>{
            if (v?.length) return parentStrategy.in(v.slice(0, 1), children, parents, disabled);
            return new Map();
        },
        out: (v, children, parents)=>{
            return parentStrategy.out(v, children, parents);
        }
    };
    return strategy;
};
const $168091b4f5487239$export$8c4b1b6128aa22d2 = (mandatory)=>{
    const parentStrategy = $168091b4f5487239$export$ed77aaa4426be279(mandatory);
    const strategy = {
        select: (_ref4)=>{
            let { id: id, selected: selected, children: children, ...rest } = _ref4;
            id = (0, $01W3b.toRaw)(id);
            if (children.has(id)) return selected;
            return parentStrategy.select({
                id: id,
                selected: selected,
                children: children,
                ...rest
            });
        },
        in: parentStrategy.in,
        out: parentStrategy.out
    };
    return strategy;
};
const $168091b4f5487239$export$e37e092494950e24 = (mandatory)=>{
    const parentStrategy = $168091b4f5487239$export$628b10e27c96fc1f(mandatory);
    const strategy = {
        select: (_ref5)=>{
            let { id: id, selected: selected, children: children, ...rest } = _ref5;
            id = (0, $01W3b.toRaw)(id);
            if (children.has(id)) return selected;
            return parentStrategy.select({
                id: id,
                selected: selected,
                children: children,
                ...rest
            });
        },
        in: parentStrategy.in,
        out: parentStrategy.out
    };
    return strategy;
};
const $168091b4f5487239$export$f0c808686d74df5b = (mandatory)=>{
    const strategy = {
        select: (_ref6)=>{
            let { id: id, value: value, selected: selected, children: children, parents: parents, disabled: disabled } = _ref6;
            id = (0, $01W3b.toRaw)(id);
            const original = new Map(selected);
            const items = [
                id
            ];
            while(items.length){
                const item = items.shift();
                if (!disabled.has(item)) selected.set((0, $01W3b.toRaw)(item), value ? 'on' : 'off');
                if (children.has(item)) items.push(...children.get(item));
            }
            let parent = (0, $01W3b.toRaw)(parents.get(id));
            while(parent){
                let everySelected = true;
                let noneSelected = true;
                for (const child of children.get(parent)){
                    const cid = (0, $01W3b.toRaw)(child);
                    if (disabled.has(cid)) continue;
                    if (selected.get(cid) !== 'on') everySelected = false;
                    if (selected.has(cid) && selected.get(cid) !== 'off') noneSelected = false;
                    if (!everySelected && !noneSelected) break;
                }
                selected.set(parent, everySelected ? 'on' : noneSelected ? 'off' : 'indeterminate');
                parent = (0, $01W3b.toRaw)(parents.get(parent));
            }
            // If mandatory and planned deselect results in no selected
            // items then we can't do it, so return original state
            if (mandatory && !value) {
                const on = Array.from(selected.entries()).reduce((arr, _ref7)=>{
                    let [key, value] = _ref7;
                    if (value === 'on') arr.push(key);
                    return arr;
                }, []);
                if (on.length === 0) return original;
            }
            return selected;
        },
        in: (v, children, parents)=>{
            let map = new Map();
            for (const id of v || [])map = strategy.select({
                id: id,
                value: true,
                selected: map,
                children: children,
                parents: parents,
                disabled: new Set()
            });
            return map;
        },
        out: (v, children)=>{
            const arr = [];
            for (const [key, value] of v.entries())if (value === 'on' && !children.has(key)) arr.push(key);
            return arr;
        }
    };
    return strategy;
};
const $168091b4f5487239$export$5b6c8d1edcea7d04 = (mandatory)=>{
    const parentStrategy = $168091b4f5487239$export$f0c808686d74df5b(mandatory);
    const strategy = {
        select: parentStrategy.select,
        in: parentStrategy.in,
        out: (v, children, parents)=>{
            const arr = [];
            for (const [key, value] of v.entries())if (value === 'on') {
                if (parents.has(key)) {
                    const parent = parents.get(key);
                    if (v.get(parent) === 'on') continue;
                }
                arr.push(key);
            }
            return arr;
        }
    };
    return strategy;
};
const $168091b4f5487239$export$78b31068c3887698 = (mandatory)=>{
    const parentStrategy = $168091b4f5487239$export$f0c808686d74df5b(mandatory);
    const strategy = {
        select: parentStrategy.select,
        in: (v, children, parents, disabled)=>{
            let map = new Map();
            for (const id of v || []){
                if (children.has(id)) continue;
                map = strategy.select({
                    id: id,
                    value: true,
                    selected: map,
                    children: children,
                    parents: parents,
                    disabled: disabled
                });
            }
            return map;
        },
        out: (v)=>{
            const arr = [];
            for (const [key, value] of v.entries())if (value === 'on' || value === 'indeterminate') arr.push(key);
            return arr;
        }
    };
    return strategy;
};


function $ad621c05f977da7f$export$de363e709c412c8a(fn, delay) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        leading: true,
        trailing: true
    };
    let timeoutId = 0;
    let lastExec = 0;
    let throttling = false;
    let start = 0;
    function clear() {
        clearTimeout(timeoutId);
        throttling = false;
        start = 0;
    }
    const wrap = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timeoutId);
        const now = Date.now();
        if (!start) start = now;
        const elapsed = now - Math.max(start, lastExec);
        function invoke() {
            lastExec = Date.now();
            timeoutId = setTimeout(clear, delay);
            fn(...args);
        }
        if (!throttling) {
            throttling = true;
            if (options.leading) invoke();
        } else if (elapsed >= delay) invoke();
        else if (options.trailing) timeoutId = setTimeout(invoke, delay - elapsed);
    };
    wrap.clear = clear;
    wrap.immediate = fn;
    return wrap;
}


const $deff84b42a51c299$export$f92820fd04593012 = Symbol.for('vuetify:nested');
const $deff84b42a51c299$export$ac77f7834a1bdcdb = {
    id: (0, $01W3b.shallowRef)(),
    root: {
        itemsRegistration: (0, $01W3b.ref)('render'),
        register: ()=>null,
        unregister: ()=>null,
        updateDisabled: ()=>null,
        children: (0, $01W3b.ref)(new Map()),
        parents: (0, $01W3b.ref)(new Map()),
        disabled: (0, $01W3b.ref)(new Set()),
        open: ()=>null,
        openOnSelect: ()=>null,
        activate: ()=>null,
        select: ()=>null,
        activatable: (0, $01W3b.ref)(false),
        scrollToActive: (0, $01W3b.ref)(false),
        selectable: (0, $01W3b.ref)(false),
        opened: (0, $01W3b.ref)(new Set()),
        activated: (0, $01W3b.ref)(new Set()),
        selected: (0, $01W3b.ref)(new Map()),
        selectedValues: (0, $01W3b.ref)([]),
        getPath: ()=>[]
    }
};
const $deff84b42a51c299$export$d902bc556a68188 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    activatable: Boolean,
    selectable: Boolean,
    activeStrategy: [
        String,
        Function,
        Object
    ],
    selectStrategy: [
        String,
        Function,
        Object
    ],
    openStrategy: [
        String,
        Object
    ],
    opened: null,
    activated: null,
    selected: null,
    mandatory: Boolean,
    itemsRegistration: {
        type: String,
        default: 'render'
    }
}, 'nested');
const $deff84b42a51c299$export$3fe10dd37d604a36 = (props, _ref)=>{
    let { items: items, returnObject: returnObject, scrollToActive: scrollToActive } = _ref;
    let isUnmounted = false;
    const children = (0, $01W3b.shallowRef)(new Map());
    const parents = (0, $01W3b.shallowRef)(new Map());
    const disabled = (0, $01W3b.shallowRef)(new Set());
    const opened = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'opened', props.opened, (v)=>new Set(Array.isArray(v) ? v.map((i)=>(0, $01W3b.toRaw)(i)) : v), (v)=>[
            ...v.values()
        ]);
    const activeStrategy = (0, $01W3b.computed)(()=>{
        if (typeof props.activeStrategy === 'object') return props.activeStrategy;
        if (typeof props.activeStrategy === 'function') return props.activeStrategy(props.mandatory);
        switch(props.activeStrategy){
            case 'leaf':
                return (0, $c1099c3be34efdbc$export$86506b87e5d93888)(props.mandatory);
            case 'single-leaf':
                return (0, $c1099c3be34efdbc$export$910c1ade9a9231fc)(props.mandatory);
            case 'independent':
                return (0, $c1099c3be34efdbc$export$9387f2baf58fc090)(props.mandatory);
            case 'single-independent':
            default:
                return (0, $c1099c3be34efdbc$export$5b58acd5140059d7)(props.mandatory);
        }
    });
    const selectStrategy = (0, $01W3b.computed)(()=>{
        if (typeof props.selectStrategy === 'object') return props.selectStrategy;
        if (typeof props.selectStrategy === 'function') return props.selectStrategy(props.mandatory);
        switch(props.selectStrategy){
            case 'single-leaf':
                return (0, $168091b4f5487239$export$e37e092494950e24)(props.mandatory);
            case 'leaf':
                return (0, $168091b4f5487239$export$8c4b1b6128aa22d2)(props.mandatory);
            case 'independent':
                return (0, $168091b4f5487239$export$ed77aaa4426be279)(props.mandatory);
            case 'single-independent':
                return (0, $168091b4f5487239$export$628b10e27c96fc1f)(props.mandatory);
            case 'trunk':
                return (0, $168091b4f5487239$export$5b6c8d1edcea7d04)(props.mandatory);
            case 'branch':
                return (0, $168091b4f5487239$export$78b31068c3887698)(props.mandatory);
            case 'classic':
            default:
                return (0, $168091b4f5487239$export$f0c808686d74df5b)(props.mandatory);
        }
    });
    const openStrategy = (0, $01W3b.computed)(()=>{
        if (typeof props.openStrategy === 'object') return props.openStrategy;
        switch(props.openStrategy){
            case 'list':
                return 0, $53fefb2eac92b059$export$d7952eef3b24cbdf;
            case 'single':
                return 0, $53fefb2eac92b059$export$7a4693cebcd37a8a;
            case 'multiple':
            default:
                return 0, $53fefb2eac92b059$export$3e2f656d3630f9a4;
        }
    });
    const activated = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'activated', props.activated, (v)=>activeStrategy.value.in(v, children.value, parents.value), (v)=>activeStrategy.value.out(v, children.value, parents.value));
    const selected = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'selected', props.selected, (v)=>selectStrategy.value.in(v, children.value, parents.value, disabled.value), (v)=>selectStrategy.value.out(v, children.value, parents.value));
    (0, $TusQn.onBeforeUnmount)(()=>{
        isUnmounted = true;
    });
    function getPath(id) {
        const path = [];
        let parent = (0, $01W3b.toRaw)(id);
        while(parent !== undefined){
            path.unshift(parent);
            parent = parents.value.get(parent);
        }
        return path;
    }
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('nested');
    const nodeIds = new Set();
    const itemsUpdatePropagation = (0, $ad621c05f977da7f$export$de363e709c412c8a)(()=>{
        (0, $TusQn.nextTick)(()=>{
            children.value = new Map(children.value);
            parents.value = new Map(parents.value);
        });
    }, 100);
    (0, $01W3b.watch)(()=>[
            items.value,
            (0, $01W3b.toValue)(returnObject)
        ], ()=>{
        if (props.itemsRegistration === 'props') updateInternalMaps();
    }, {
        immediate: true
    });
    function updateInternalMaps() {
        const _parents = new Map();
        const _children = new Map();
        const _disabled = new Set();
        const getValue = (0, $01W3b.toValue)(returnObject) ? (item)=>(0, $01W3b.toRaw)(item.raw) : (item)=>item.value;
        const stack = [
            ...items.value
        ];
        let i = 0;
        while(i < stack.length){
            const item = stack[i++];
            const itemValue = getValue(item);
            if (item.children) {
                const childValues = [];
                for (const child of item.children){
                    const childValue = getValue(child);
                    _parents.set(childValue, itemValue);
                    childValues.push(childValue);
                    stack.push(child);
                }
                _children.set(itemValue, childValues);
            }
            if (item.props.disabled) _disabled.add(itemValue);
        }
        children.value = _children;
        parents.value = _parents;
        disabled.value = _disabled;
    }
    const nested = {
        id: (0, $01W3b.shallowRef)(),
        root: {
            opened: opened,
            activatable: (0, $01W3b.toRef)(()=>props.activatable),
            scrollToActive: (0, $01W3b.toRef)(()=>(0, $01W3b.toValue)(scrollToActive)),
            selectable: (0, $01W3b.toRef)(()=>props.selectable),
            activated: activated,
            selected: selected,
            selectedValues: (0, $01W3b.computed)(()=>{
                const arr = [];
                for (const [key, value] of selected.value.entries())if (value === 'on') arr.push(key);
                return arr;
            }),
            itemsRegistration: (0, $01W3b.toRef)(()=>props.itemsRegistration),
            register: (id, parentId, isDisabled, isGroup)=>{
                if (nodeIds.has(id)) {
                    const path = getPath(id).map(String).join(' -> ');
                    const newPath = getPath(parentId).concat(id).map(String).join(' -> ');
                    (0, $5384ffc78a9e124c$export$bf36f23bad3e1069)(`Multiple nodes with the same ID\n\t${path}\n\t${newPath}`);
                    return;
                } else nodeIds.add(id);
                parentId && id !== parentId && parents.value.set(id, parentId);
                isDisabled && disabled.value.add(id);
                isGroup && children.value.set(id, []);
                if (parentId != null) children.value.set(parentId, [
                    ...children.value.get(parentId) || [],
                    id
                ]);
                itemsUpdatePropagation();
            },
            unregister: (id)=>{
                if (isUnmounted) return;
                nodeIds.delete(id);
                children.value.delete(id);
                disabled.value.delete(id);
                const parent = parents.value.get(id);
                if (parent) {
                    const list = children.value.get(parent) ?? [];
                    children.value.set(parent, list.filter((child)=>child !== id));
                }
                parents.value.delete(id);
                itemsUpdatePropagation();
            },
            updateDisabled: (id, isDisabled)=>{
                if (isDisabled) disabled.value.add(id);
                else disabled.value.delete(id);
            // classic selection requires refresh to re-evaluate on/off/indeterminate but
            // currently it is only run for selection interactions, so it will set new disabled
            // to "off" and the visual state becomes out of sync
            // -- selected.value = new Map(selected.value)
            // it is not clear if the framework should un-select when disabled changed to true
            // more discussion is needed
            },
            open: (id, value, event)=>{
                vm.emit('click:open', {
                    id: id,
                    value: value,
                    path: getPath(id),
                    event: event
                });
                const newOpened = openStrategy.value.open({
                    id: id,
                    value: value,
                    opened: new Set(opened.value),
                    children: children.value,
                    parents: parents.value,
                    event: event
                });
                newOpened && (opened.value = newOpened);
            },
            openOnSelect: (id, value, event)=>{
                const newOpened = openStrategy.value.select({
                    id: id,
                    value: value,
                    selected: new Map(selected.value),
                    opened: new Set(opened.value),
                    children: children.value,
                    parents: parents.value,
                    event: event
                });
                newOpened && (opened.value = newOpened);
            },
            select: (id, value, event)=>{
                vm.emit('click:select', {
                    id: id,
                    value: value,
                    path: getPath(id),
                    event: event
                });
                const newSelected = selectStrategy.value.select({
                    id: id,
                    value: value,
                    selected: new Map(selected.value),
                    children: children.value,
                    parents: parents.value,
                    disabled: disabled.value,
                    event: event
                });
                newSelected && (selected.value = newSelected);
                nested.root.openOnSelect(id, value, event);
            },
            activate: (id, value, event)=>{
                if (!props.activatable) return nested.root.select(id, true, event);
                vm.emit('click:activate', {
                    id: id,
                    value: value,
                    path: getPath(id),
                    event: event
                });
                const newActivated = activeStrategy.value.activate({
                    id: id,
                    value: value,
                    activated: new Set(activated.value),
                    children: children.value,
                    parents: parents.value,
                    event: event
                });
                if (newActivated.size !== activated.value.size) activated.value = newActivated;
                else {
                    for (const value of newActivated)if (!activated.value.has(value)) {
                        activated.value = newActivated;
                        return;
                    }
                    for (const value of activated.value)if (!newActivated.has(value)) {
                        activated.value = newActivated;
                        return;
                    }
                }
            },
            children: children,
            parents: parents,
            disabled: disabled,
            getPath: getPath
        }
    };
    (0, $TusQn.provide)($deff84b42a51c299$export$f92820fd04593012, nested);
    return nested.root;
};
const $deff84b42a51c299$export$5d8af1afc0bf0f02 = (id, isDisabled, isGroup)=>{
    const parent = (0, $TusQn.inject)($deff84b42a51c299$export$f92820fd04593012, $deff84b42a51c299$export$ac77f7834a1bdcdb);
    const uidSymbol = Symbol('nested item');
    const computedId = (0, $01W3b.computed)(()=>{
        const idValue = (0, $01W3b.toRaw)((0, $01W3b.toValue)(id));
        return idValue !== undefined ? idValue : uidSymbol;
    });
    const item = {
        ...parent,
        id: computedId,
        open: (open, e)=>parent.root.open(computedId.value, open, e),
        openOnSelect: (open, e)=>parent.root.openOnSelect(computedId.value, open, e),
        isOpen: (0, $01W3b.computed)(()=>parent.root.opened.value.has(computedId.value)),
        parent: (0, $01W3b.computed)(()=>parent.root.parents.value.get(computedId.value)),
        activate: (activated, e)=>parent.root.activate(computedId.value, activated, e),
        isActivated: (0, $01W3b.computed)(()=>parent.root.activated.value.has(computedId.value)),
        scrollToActive: parent.root.scrollToActive,
        select: (selected, e)=>parent.root.select(computedId.value, selected, e),
        isSelected: (0, $01W3b.computed)(()=>parent.root.selected.value.get(computedId.value) === 'on'),
        isIndeterminate: (0, $01W3b.computed)(()=>parent.root.selected.value.get(computedId.value) === 'indeterminate'),
        isLeaf: (0, $01W3b.computed)(()=>!parent.root.children.value.get(computedId.value)),
        isGroupActivator: parent.isGroupActivator
    };
    (0, $TusQn.onBeforeMount)(()=>{
        if (parent.isGroupActivator || parent.root.itemsRegistration.value === 'props') return;
        (0, $TusQn.nextTick)(()=>{
            parent.root.register(computedId.value, parent.id.value, (0, $01W3b.toValue)(isDisabled), isGroup);
        });
    });
    (0, $TusQn.onBeforeUnmount)(()=>{
        if (parent.isGroupActivator || parent.root.itemsRegistration.value === 'props') return;
        parent.root.unregister(computedId.value);
    });
    (0, $01W3b.watch)(computedId, (val, oldVal)=>{
        if (parent.isGroupActivator || parent.root.itemsRegistration.value === 'props') return;
        parent.root.unregister(oldVal);
        (0, $TusQn.nextTick)(()=>{
            parent.root.register(val, parent.id.value, (0, $01W3b.toValue)(isDisabled), isGroup);
        });
    });
    (0, $01W3b.watch)(()=>(0, $01W3b.toValue)(isDisabled), (val)=>{
        parent.root.updateDisabled(computedId.value, val);
    });
    isGroup && (0, $TusQn.provide)($deff84b42a51c299$export$f92820fd04593012, item);
    return item;
};
const $deff84b42a51c299$export$8ce11cb83a582280 = ()=>{
    const parent = (0, $TusQn.inject)($deff84b42a51c299$export$f92820fd04593012, $deff84b42a51c299$export$ac77f7834a1bdcdb);
    (0, $TusQn.provide)($deff84b42a51c299$export$f92820fd04593012, {
        ...parent,
        isGroupActivator: true
    });
};






const $7522211dead698f4$var$VListGroupActivator = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VListGroupActivator',
    setup (_, _ref) {
        let { slots: slots } = _ref;
        (0, $deff84b42a51c299$export$8ce11cb83a582280)();
        return ()=>slots.default?.();
    }
});
const $7522211dead698f4$export$4ba1284b16a5c704 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    /* @deprecated */ activeColor: String,
    baseColor: String,
    color: String,
    collapseIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$collapse'
    },
    disabled: Boolean,
    expandIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$expand'
    },
    rawId: [
        String,
        Number
    ],
    prependIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    appendIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    fluid: Boolean,
    subgroup: Boolean,
    title: String,
    value: null,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VListGroup');
const $7522211dead698f4$export$22fc03a43764dcc7 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VListGroup',
    props: $7522211dead698f4$export$4ba1284b16a5c704(),
    setup (props, _ref2) {
        let { slots: slots } = _ref2;
        const { isOpen: isOpen, open: open, id: _id } = (0, $deff84b42a51c299$export$5d8af1afc0bf0f02)(()=>props.value, ()=>props.disabled, true);
        const id = (0, $01W3b.computed)(()=>`v-list-group--id-${String(props.rawId ?? _id.value)}`);
        const list = (0, $862a9b1b0084874a$export$f9763ecd339e95eb)();
        const { isBooted: isBooted } = (0, $0f95b8d0184d7fa9$export$f385cca8ac2b2f35)();
        const parent = (0, $TusQn.inject)((0, $deff84b42a51c299$export$f92820fd04593012));
        const renderWhenClosed = (0, $01W3b.toRef)(()=>parent?.root?.itemsRegistration.value === 'render');
        function onClick(e) {
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes(e.target?.tagName)) return;
            open(!isOpen.value, e);
        }
        const activatorProps = (0, $01W3b.computed)(()=>({
                onClick: onClick,
                class: 'v-list-group__header',
                id: id.value
            }));
        const toggleIcon = (0, $01W3b.computed)(()=>isOpen.value ? props.collapseIcon : props.expandIcon);
        const activatorDefaults = (0, $01W3b.computed)(()=>({
                VListItem: {
                    activeColor: props.activeColor,
                    baseColor: props.baseColor,
                    color: props.color,
                    prependIcon: props.prependIcon || props.subgroup && toggleIcon.value,
                    appendIcon: props.appendIcon || !props.subgroup && toggleIcon.value,
                    title: props.title,
                    value: props.value
                }
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-list-group',
                    {
                        'v-list-group--prepend': list?.hasPrepend.value,
                        'v-list-group--fluid': props.fluid,
                        'v-list-group--subgroup': props.subgroup,
                        'v-list-group--open': isOpen.value
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        slots.activator && (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "defaults": activatorDefaults.value
                        }, {
                            default: ()=>[
                                    (0, $TusQn.createVNode)($7522211dead698f4$var$VListGroupActivator, null, {
                                        default: ()=>[
                                                slots.activator({
                                                    props: activatorProps.value,
                                                    isOpen: isOpen.value
                                                })
                                            ]
                                    })
                                ]
                        }),
                        (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                            "transition": {
                                component: (0, $7ec1b0ef33b04126$export$1cd1e8deb97d798d)
                            },
                            "disabled": !isBooted.value
                        }, {
                            default: ()=>[
                                    renderWhenClosed.value ? (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                                        "class": "v-list-group__items",
                                        "role": "group",
                                        "aria-labelledby": id.value
                                    }, [
                                        slots.default?.()
                                    ]), [
                                        [
                                            (0, $eeJ70.vShow),
                                            isOpen.value
                                        ]
                                    ]) : isOpen.value && (0, $TusQn.createElementVNode)("div", {
                                        "class": "v-list-group__items",
                                        "role": "group",
                                        "aria-labelledby": id.value
                                    }, [
                                        slots.default?.()
                                    ])
                                ]
                        })
                    ]
            }));
        return {
            isOpen: isOpen
        };
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



const $55851011ab134ecf$export$5fec5a0bd8520c4b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    opacity: [
        Number,
        String
    ],
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VListItemSubtitle');
const $55851011ab134ecf$export$822b84d77d050116 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VListItemSubtitle',
    props: $55851011ab134ecf$export$5fec5a0bd8520c4b(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-list-item-subtitle',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-list-item-subtitle-opacity': props.opacity
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});


// Utilities

const $2d03267b9a3b6c6c$export$d3fcc52550436b5b = (0, $5224ab9d69b8c3e0$export$b3680ae2c271b9f3)('v-list-item-title');




















const $3d00ebc3c7505e27$export$b1024b817bbb948b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    active: {
        type: Boolean,
        default: undefined
    },
    activeClass: String,
    /* @deprecated */ activeColor: String,
    appendAvatar: String,
    appendIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    baseColor: String,
    disabled: Boolean,
    lines: [
        Boolean,
        String
    ],
    link: {
        type: Boolean,
        default: undefined
    },
    nav: Boolean,
    prependAvatar: String,
    prependIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    slim: Boolean,
    prependGap: [
        Number,
        String
    ],
    subtitle: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    title: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    value: null,
    index: Number,
    tabindex: [
        Number,
        String
    ],
    onClick: (0, $8590040a7833369a$export$cefab237a347bf23)(),
    onClickOnce: (0, $8590040a7833369a$export$cefab237a347bf23)(),
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $1c0236248fe13b4c$export$78d5db5e8f9b041d)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'text'
    })
}, 'VListItem');
const $3d00ebc3c7505e27$export$a6ee5a73ee56a146 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VListItem',
    directives: {
        vRipple: $907916373bf62ceb$export$2e2bcd8739ae039
    },
    props: $3d00ebc3c7505e27$export$b1024b817bbb948b(),
    emits: {
        click: (e)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots, emit: emit } = _ref;
        const link = (0, $1c0236248fe13b4c$export$dcf14c9974fe2767)(props, attrs);
        const rootEl = (0, $01W3b.ref)();
        const id = (0, $01W3b.computed)(()=>props.value === undefined ? link.href.value : props.value);
        const { activate: activate, isActivated: isActivated, select: select, isOpen: isOpen, isSelected: isSelected, isIndeterminate: isIndeterminate, isGroupActivator: isGroupActivator, root: root, parent: parent, openOnSelect: openOnSelect, scrollToActive: scrollToActive, id: uid } = (0, $deff84b42a51c299$export$5d8af1afc0bf0f02)(id, ()=>props.disabled, false);
        const list = (0, $862a9b1b0084874a$export$f9763ecd339e95eb)();
        const isActive = (0, $01W3b.computed)(()=>props.active !== false && (props.active || link.isActive?.value || (root.activatable.value ? isActivated.value : isSelected.value)));
        const isLink = (0, $01W3b.toRef)(()=>props.link !== false && link.isLink.value);
        const isSelectable = (0, $01W3b.computed)(()=>!!list && (root.selectable.value || root.activatable.value || props.value != null));
        const isClickable = (0, $01W3b.computed)(()=>!props.disabled && props.link !== false && (props.link || link.isClickable.value || isSelectable.value));
        const isTracked = (0, $01W3b.computed)(()=>list && list.navigationStrategy.value === 'track' && props.index !== undefined && list.trackingIndex.value === props.index);
        const role = (0, $01W3b.computed)(()=>list ? isLink.value ? 'link' : isSelectable.value ? 'option' : 'listitem' : undefined);
        const ariaSelected = (0, $01W3b.computed)(()=>{
            if (!isSelectable.value) return undefined;
            return root.activatable.value ? isActivated.value : root.selectable.value ? isSelected.value : isActive.value;
        });
        const roundedProps = (0, $01W3b.toRef)(()=>props.rounded || props.nav);
        const color = (0, $01W3b.toRef)(()=>props.color ?? props.activeColor);
        const variantProps = (0, $01W3b.toRef)(()=>({
                color: isActive.value ? color.value ?? props.baseColor : props.baseColor,
                variant: props.variant
            }));
        // useNestedItem doesn't call register until beforeMount,
        // so this can't be an immediate watcher as we don't know parent yet
        (0, $01W3b.watch)(()=>link.isActive?.value, (val)=>{
            if (!val) return;
            handleActiveLink();
        });
        (0, $01W3b.watch)(isActivated, (val)=>{
            if (!val || !scrollToActive) return;
            rootEl.value?.scrollIntoView({
                block: 'nearest',
                behavior: 'instant'
            });
        });
        (0, $01W3b.watch)(isTracked, (val)=>{
            if (!val) return;
            rootEl.value?.scrollIntoView({
                block: 'nearest',
                behavior: 'instant'
            });
        });
        (0, $TusQn.onBeforeMount)(()=>{
            if (link.isActive?.value) (0, $TusQn.nextTick)(()=>handleActiveLink());
        });
        function handleActiveLink() {
            if (parent.value != null) root.open(parent.value, true);
            openOnSelect(true);
        }
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $567f01637e3e83ec$export$36ef81613f8f20fc)(variantProps);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(roundedProps);
        const lineClasses = (0, $01W3b.toRef)(()=>props.lines ? `v-list-item--${props.lines}-line` : undefined);
        const rippleOptions = (0, $01W3b.toRef)(()=>props.ripple !== undefined && !!props.ripple && list?.filterable ? {
                keys: [
                    'Enter'
                ]
            } : props.ripple);
        const slotProps = (0, $01W3b.computed)(()=>({
                isActive: isActive.value,
                select: select,
                isOpen: isOpen.value,
                isSelected: isSelected.value,
                isIndeterminate: isIndeterminate.value,
                isDisabled: props.disabled
            }));
        function onClick(e) {
            emit('click', e);
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes(e.target?.tagName)) return;
            if (!isClickable.value) return;
            link.navigate.value?.(e);
            if (isGroupActivator) return;
            if (root.activatable.value) activate(!isActivated.value, e);
            else if (root.selectable.value) select(!isSelected.value, e);
            else if (props.value != null && !isLink.value) select(!isSelected.value, e);
        }
        function onKeyDown(e) {
            const target = e.target;
            if ([
                'INPUT',
                'TEXTAREA'
            ].includes(target.tagName)) return;
            if (e.key === 'Enter' || e.key === ' ' && !list?.filterable) {
                e.preventDefault();
                e.stopPropagation();
                e.target.dispatchEvent(new MouseEvent('click', e));
            }
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const Tag = isLink.value ? 'a' : props.tag;
            const hasTitle = slots.title || props.title != null;
            const hasSubtitle = slots.subtitle || props.subtitle != null;
            const hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
            const hasAppend = !!(hasAppendMedia || slots.append);
            const hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
            const hasPrepend = !!(hasPrependMedia || slots.prepend);
            list?.updateHasPrepend(hasPrepend);
            if (props.activeColor) (0, $5384ffc78a9e124c$export$b680e6b2c82f8c2f)('active-color', [
                'color',
                'base-color'
            ]);
            return (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(Tag, (0, $TusQn.mergeProps)(link.linkProps, {
                "ref": rootEl,
                "id": props.index !== undefined && list ? `v-list-item-${list.uid}-${props.index}` : undefined,
                "class": [
                    'v-list-item',
                    {
                        'v-list-item--active': isActive.value,
                        'v-list-item--disabled': props.disabled,
                        'v-list-item--link': isClickable.value,
                        'v-list-item--nav': props.nav,
                        'v-list-item--prepend': !hasPrepend && list?.hasPrepend.value,
                        'v-list-item--slim': props.slim,
                        'v-list-item--focus-visible': isTracked.value,
                        [`${props.activeClass}`]: props.activeClass && isActive.value
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    lineClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props.class
                ],
                "style": [
                    {
                        '--v-list-prepend-gap': (0, $8590040a7833369a$export$286ad215293a0860)(props.prependGap)
                    },
                    colorStyles.value,
                    dimensionStyles.value,
                    props.style
                ],
                "tabindex": props.tabindex ?? (isClickable.value ? list ? -2 : 0 : undefined),
                "aria-selected": ariaSelected.value,
                "role": role.value,
                "onClick": onClick,
                "onKeydown": isClickable.value && !isLink.value && onKeyDown
            }), {
                default: ()=>[
                        (0, $567f01637e3e83ec$export$e27cd265ed232373)(isClickable.value || isActive.value, 'v-list-item'),
                        hasPrepend && (0, $TusQn.createElementVNode)("div", {
                            "key": "prepend",
                            "class": "v-list-item__prepend"
                        }, [
                            !slots.prepend ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                props.prependAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                    "key": "prepend-avatar",
                                    "density": props.density,
                                    "image": props.prependAvatar
                                }, null),
                                props.prependIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                    "key": "prepend-icon",
                                    "density": props.density,
                                    "icon": props.prependIcon
                                }, null)
                            ]) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "defaults": {
                                    VAvatar: {
                                        density: props.density,
                                        image: props.prependAvatar
                                    },
                                    VIcon: {
                                        density: props.density,
                                        icon: props.prependIcon
                                    },
                                    VListItemAction: {
                                        start: true
                                    },
                                    VCheckboxBtn: {
                                        density: props.density
                                    }
                                }
                            }, {
                                default: ()=>[
                                        slots.prepend?.(slotProps.value)
                                    ]
                            }),
                            (0, $TusQn.createElementVNode)("div", {
                                "class": "v-list-item__spacer"
                            }, null)
                        ]),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-list-item__content",
                            "data-no-activator": ""
                        }, [
                            hasTitle && (0, $TusQn.createVNode)((0, $2d03267b9a3b6c6c$export$d3fcc52550436b5b), {
                                "key": "title"
                            }, {
                                default: ()=>[
                                        slots.title?.({
                                            title: props.title
                                        }) ?? (0, $8POXm.toDisplayString)(props.title)
                                    ]
                            }),
                            hasSubtitle && (0, $TusQn.createVNode)((0, $55851011ab134ecf$export$822b84d77d050116), {
                                "key": "subtitle"
                            }, {
                                default: ()=>[
                                        slots.subtitle?.({
                                            subtitle: props.subtitle
                                        }) ?? (0, $8POXm.toDisplayString)(props.subtitle)
                                    ]
                            }),
                            slots.default?.(slotProps.value)
                        ]),
                        hasAppend && (0, $TusQn.createElementVNode)("div", {
                            "key": "append",
                            "class": "v-list-item__append"
                        }, [
                            !slots.append ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                props.appendIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                    "key": "append-icon",
                                    "density": props.density,
                                    "icon": props.appendIcon
                                }, null),
                                props.appendAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                    "key": "append-avatar",
                                    "density": props.density,
                                    "image": props.appendAvatar
                                }, null)
                            ]) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "append-defaults",
                                "defaults": {
                                    VAvatar: {
                                        density: props.density,
                                        image: props.appendAvatar
                                    },
                                    VIcon: {
                                        density: props.density,
                                        icon: props.appendIcon
                                    },
                                    VListItemAction: {
                                        end: true
                                    },
                                    VCheckboxBtn: {
                                        density: props.density
                                    }
                                }
                            }, {
                                default: ()=>[
                                        slots.append?.(slotProps.value)
                                    ]
                            }),
                            (0, $TusQn.createElementVNode)("div", {
                                "class": "v-list-item__spacer"
                            }, null)
                        ])
                    ]
            }), [
                [
                    (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                    isClickable.value && rippleOptions.value
                ]
            ]);
        });
        return {
            activate: activate,
            isActivated: isActivated,
            isGroupActivator: isGroupActivator,
            isSelected: isSelected,
            list: list,
            select: select,
            root: root,
            id: uid,
            link: link
        };
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");




const $96a2eb5e8711f0cc$export$c27aa42ccb7a1e64 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    inset: Boolean,
    sticky: Boolean,
    title: String,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VListSubheader');
const $96a2eb5e8711f0cc$export$70c4aba7bf48e22a = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VListSubheader',
    props: $96a2eb5e8711f0cc$export$c27aa42ccb7a1e64(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.color);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasText = !!(slots.default || props.title);
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-list-subheader',
                    {
                        'v-list-subheader--inset': props.inset,
                        'v-list-subheader--sticky': props.sticky
                    },
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        textColorStyles: textColorStyles
                    },
                    props.style
                ])
            }, {
                default: ()=>[
                        hasText && (0, $TusQn.createElementVNode)("div", {
                            "class": "v-list-subheader__text"
                        }, [
                            slots.default?.() ?? props.title
                        ])
                    ]
            });
        });
        return {};
    }
});





const $6cee302e69f97720$export$ee17920dc327659a = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    items: Array,
    returnObject: Boolean
}, 'VListChildren');
const $6cee302e69f97720$export$c0f3d26dd5c4f15a = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VListChildren',
    props: $6cee302e69f97720$export$ee17920dc327659a(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $862a9b1b0084874a$export$5897d8d7c7a3d871)();
        return ()=>slots.default?.() ?? props.items?.map((_ref2, index)=>{
                let { children: children, props: itemProps, type: type, raw: item } = _ref2;
                if (type === 'divider') return slots.divider?.({
                    props: itemProps
                }) ?? (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), itemProps, null);
                if (type === 'subheader') return slots.subheader?.({
                    props: itemProps
                }) ?? (0, $TusQn.createVNode)((0, $96a2eb5e8711f0cc$export$70c4aba7bf48e22a), itemProps, null);
                const slotsWithItem = {
                    subtitle: slots.subtitle ? (slotProps)=>slots.subtitle?.({
                            ...slotProps,
                            item: item
                        }) : undefined,
                    prepend: slots.prepend ? (slotProps)=>slots.prepend?.({
                            ...slotProps,
                            item: item
                        }) : undefined,
                    append: slots.append ? (slotProps)=>slots.append?.({
                            ...slotProps,
                            item: item
                        }) : undefined,
                    title: slots.title ? (slotProps)=>slots.title?.({
                            ...slotProps,
                            item: item
                        }) : undefined
                };
                const listGroupProps = (0, $7522211dead698f4$export$22fc03a43764dcc7).filterProps(itemProps);
                return children ? (0, $TusQn.createVNode)((0, $7522211dead698f4$export$22fc03a43764dcc7), (0, $TusQn.mergeProps)(listGroupProps, {
                    "value": props.returnObject ? item : itemProps?.value,
                    "rawId": itemProps?.value
                }), {
                    activator: (_ref3)=>{
                        let { props: activatorProps } = _ref3;
                        const listItemProps = (0, $TusQn.mergeProps)(itemProps, activatorProps, {
                            value: props.returnObject ? item : itemProps.value
                        });
                        return slots.header ? slots.header({
                            props: listItemProps
                        }) : (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), (0, $TusQn.mergeProps)(listItemProps, {
                            "index": index
                        }), slotsWithItem);
                    },
                    default: ()=>(0, $TusQn.createVNode)($6cee302e69f97720$export$c0f3d26dd5c4f15a, {
                            "items": children,
                            "returnObject": props.returnObject
                        }, slots)
                }) : slots.item ? slots.item({
                    props: {
                        ...itemProps,
                        index: index
                    }
                }) : (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), (0, $TusQn.mergeProps)(itemProps, {
                    "index": index,
                    "value": props.returnObject ? item : itemProps.value
                }), slotsWithItem);
            });
    }
});











// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $9d0414e5c866e7bc$export$899bb842e69e7bd4 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        default: ()=>[]
    },
    itemTitle: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'title'
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'value'
    },
    itemChildren: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        default: 'children'
    },
    itemProps: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        default: 'props'
    },
    itemType: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        default: 'type'
    },
    returnObject: Boolean,
    valueComparator: Function
}, 'list-items');
const $9d0414e5c866e7bc$var$itemTypes = new Set([
    'item',
    'divider',
    'subheader'
]);
function $9d0414e5c866e7bc$export$ef3b10464ff5e4ec(props, item) {
    const title = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemTitle, item);
    const value = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemValue, title);
    const children = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemChildren);
    const itemProps = props.itemProps === true ? typeof item === 'object' && item != null && !Array.isArray(item) ? 'children' in item ? (0, $8590040a7833369a$export$30a06c8d3562193f)(item, [
        'children'
    ]) : item : undefined : (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemProps);
    let type = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemType, 'item');
    if (!$9d0414e5c866e7bc$var$itemTypes.has(type)) type = 'item';
    const _props = {
        title: title,
        value: value,
        ...itemProps
    };
    return {
        type: type,
        title: String(_props.title ?? ''),
        value: _props.value,
        props: _props,
        children: type === 'item' && Array.isArray(children) ? $9d0414e5c866e7bc$export$f8e983a9ac6ba971(props, children) : undefined,
        raw: item
    };
}
$9d0414e5c866e7bc$export$ef3b10464ff5e4ec.neededProps = [
    'itemTitle',
    'itemValue',
    'itemChildren',
    'itemProps',
    'itemType'
];
function $9d0414e5c866e7bc$export$f8e983a9ac6ba971(props, items) {
    // avoid reactive access in the loop
    const _props = (0, $8590040a7833369a$export$357523c63a2253b9)(props, $9d0414e5c866e7bc$export$ef3b10464ff5e4ec.neededProps);
    const array = [];
    for (const item of items)array.push($9d0414e5c866e7bc$export$ef3b10464ff5e4ec(_props, item));
    return array;
}
function $9d0414e5c866e7bc$export$7bfdd97581ca93c(props) {
    const items = (0, $01W3b.computed)(()=>$9d0414e5c866e7bc$export$f8e983a9ac6ba971(props, props.items));
    const hasNullItem = (0, $01W3b.computed)(()=>items.value.some((item)=>item.value === null));
    const itemsMap = (0, $01W3b.shallowRef)(new Map());
    const keylessItems = (0, $01W3b.shallowRef)([]);
    (0, $TusQn.watchEffect)(()=>{
        const _items = items.value;
        const map = new Map();
        const keyless = [];
        for(let i = 0; i < _items.length; i++){
            const item = _items[i];
            if ((0, $8590040a7833369a$export$c3825b437cbdea5c)(item.value) || item.value === null) {
                let values = map.get(item.value);
                if (!values) {
                    values = [];
                    map.set(item.value, values);
                }
                values.push(item);
            } else keyless.push(item);
        }
        itemsMap.value = map;
        keylessItems.value = keyless;
    });
    function transformIn(value) {
        // Cache unrefed values outside the loop,
        // proxy getters can be slow when you call them a billion times
        const _items = itemsMap.value;
        const _allItems = items.value;
        const _keylessItems = keylessItems.value;
        const _hasNullItem = hasNullItem.value;
        const _returnObject = props.returnObject;
        const hasValueComparator = !!props.valueComparator;
        const valueComparator = props.valueComparator || (0, $bf1718679e817e1f$export$9cb4719e2e525b7a);
        const _props = (0, $8590040a7833369a$export$357523c63a2253b9)(props, $9d0414e5c866e7bc$export$ef3b10464ff5e4ec.neededProps);
        const returnValue = [];
        main: for (const v of value){
            // When the model value is null, return an InternalItem
            // based on null only if null is one of the items
            if (!_hasNullItem && v === null) continue;
            // String model value means value is a custom input value from combobox
            // Don't look up existing items if the model value is a string
            if (_returnObject && typeof v === 'string') {
                returnValue.push($9d0414e5c866e7bc$export$ef3b10464ff5e4ec(_props, v));
                continue;
            }
            // Fast path, items with primitive values and no
            // custom valueComparator can use a constant-time
            // map lookup instead of searching the items array
            const fastItems = _items.get(v);
            // Slow path, always use valueComparator.
            // This is O(n^2) so we really don't want to
            // do it for more than a couple hundred items.
            if (hasValueComparator || !fastItems) {
                for (const item of hasValueComparator ? _allItems : _keylessItems)if (valueComparator(v, item.value)) {
                    returnValue.push(item);
                    continue main;
                }
                // Not an existing item, construct it from the model (#4000)
                returnValue.push($9d0414e5c866e7bc$export$ef3b10464ff5e4ec(_props, v));
                continue;
            }
            returnValue.push(...fastItems);
        }
        return returnValue;
    }
    function transformOut(value) {
        return props.returnObject ? value.map((_ref)=>{
            let { raw: raw } = _ref;
            return raw;
        }) : value.map((_ref2)=>{
            let { value: value } = _ref2;
            return value;
        });
    }
    return {
        items: items,
        transformIn: transformIn,
        transformOut: transformOut
    };
}









const $8f3cccf9308874bc$var$itemTypes = new Set([
    'item',
    'divider',
    'subheader'
]);
function $8f3cccf9308874bc$var$transformItem(props, item) {
    const title = (0, $8590040a7833369a$export$c3825b437cbdea5c)(item) ? item : (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemTitle);
    const value = (0, $8590040a7833369a$export$c3825b437cbdea5c)(item) ? item : (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemValue, undefined);
    const children = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemChildren);
    const itemProps = props.itemProps === true ? (0, $8590040a7833369a$export$30a06c8d3562193f)(item, [
        'children'
    ]) : (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemProps);
    let type = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemType, 'item');
    if (!$8f3cccf9308874bc$var$itemTypes.has(type)) type = 'item';
    const _props = {
        title: title,
        value: value,
        ...itemProps
    };
    return {
        type: type,
        title: _props.title,
        value: _props.value,
        props: _props,
        children: type === 'item' && children ? $8f3cccf9308874bc$var$transformItems(props, children) : undefined,
        raw: item
    };
}
function $8f3cccf9308874bc$var$transformItems(props, items) {
    const array = [];
    for (const item of items)array.push($8f3cccf9308874bc$var$transformItem(props, item));
    return array;
}
function $8f3cccf9308874bc$export$d0ca4790a6d27133(props) {
    const items = (0, $01W3b.computed)(()=>$8f3cccf9308874bc$var$transformItems(props, props.items));
    return {
        items: items
    };
}
const $8f3cccf9308874bc$export$b385b2bc1ebed11d = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    baseColor: String,
    /* @deprecated */ activeColor: String,
    activeClass: String,
    bgColor: String,
    disabled: Boolean,
    filterable: Boolean,
    expandIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    collapseIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    lines: {
        type: [
            Boolean,
            String
        ],
        default: 'one'
    },
    slim: Boolean,
    prependGap: [
        Number,
        String
    ],
    indent: [
        Number,
        String
    ],
    nav: Boolean,
    navigationStrategy: {
        type: String,
        default: 'focus'
    },
    navigationIndex: Number,
    'onClick:open': (0, $8590040a7833369a$export$cefab237a347bf23)(),
    'onClick:select': (0, $8590040a7833369a$export$cefab237a347bf23)(),
    'onUpdate:opened': (0, $8590040a7833369a$export$cefab237a347bf23)(),
    ...(0, $deff84b42a51c299$export$d902bc556a68188)({
        selectStrategy: 'single-leaf',
        openStrategy: 'list'
    }),
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $9d0414e5c866e7bc$export$899bb842e69e7bd4)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'text'
    })
}, 'VList');
const $8f3cccf9308874bc$export$3b010b0401837103 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VList',
    props: $8f3cccf9308874bc$export$b385b2bc1ebed11d(),
    emits: {
        'update:selected': (value)=>true,
        'update:activated': (value)=>true,
        'update:opened': (value)=>true,
        'update:navigationIndex': (value)=>true,
        'click:open': (value)=>true,
        'click:activate': (value)=>true,
        'click:select': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots, emit: emit } = _ref;
        const { items: items } = $8f3cccf9308874bc$export$d0ca4790a6d27133(props);
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { children: children, open: open, parents: parents, select: select, getPath: getPath } = (0, $deff84b42a51c299$export$3fe10dd37d604a36)(props, {
            items: items,
            returnObject: (0, $01W3b.toRef)(()=>props.returnObject),
            scrollToActive: (0, $01W3b.toRef)(()=>props.navigationStrategy === 'track')
        });
        const lineClasses = (0, $01W3b.toRef)(()=>props.lines ? `v-list--${props.lines}-line` : undefined);
        const activeColor = (0, $01W3b.toRef)(()=>props.activeColor);
        const baseColor = (0, $01W3b.toRef)(()=>props.baseColor);
        const color = (0, $01W3b.toRef)(()=>props.color);
        const isSelectable = (0, $01W3b.toRef)(()=>props.selectable || props.activatable);
        const navigationIndex = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'navigationIndex', -1, (v)=>v ?? -1);
        const uid = (0, $TusQn.useId)();
        (0, $862a9b1b0084874a$export$5897d8d7c7a3d871)({
            filterable: props.filterable,
            trackingIndex: navigationIndex,
            navigationStrategy: (0, $01W3b.toRef)(()=>props.navigationStrategy),
            uid: uid
        });
        (0, $01W3b.watch)(items, ()=>{
            if (props.navigationStrategy === 'track') navigationIndex.value = -1;
        });
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VListGroup: {
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                expandIcon: (0, $01W3b.toRef)(()=>props.expandIcon),
                collapseIcon: (0, $01W3b.toRef)(()=>props.collapseIcon)
            },
            VListItem: {
                activeClass: (0, $01W3b.toRef)(()=>props.activeClass),
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                density: (0, $01W3b.toRef)(()=>props.density),
                disabled: (0, $01W3b.toRef)(()=>props.disabled),
                lines: (0, $01W3b.toRef)(()=>props.lines),
                nav: (0, $01W3b.toRef)(()=>props.nav),
                slim: (0, $01W3b.toRef)(()=>props.slim),
                variant: (0, $01W3b.toRef)(()=>props.variant),
                tabindex: (0, $01W3b.toRef)(()=>props.navigationStrategy === 'track' ? -1 : undefined)
            }
        });
        const isFocused = (0, $01W3b.shallowRef)(false);
        const contentRef = (0, $01W3b.ref)();
        function onFocusin(e) {
            isFocused.value = true;
        }
        function onFocusout(e) {
            isFocused.value = false;
        }
        function onFocus(e) {
            if (props.navigationStrategy === 'track') {
                if (!~navigationIndex.value) navigationIndex.value = getNextIndex('first');
            } else if (!isFocused.value && !(e.relatedTarget && contentRef.value?.contains(e.relatedTarget))) focus();
        }
        function onBlur() {
            if (props.navigationStrategy === 'track') navigationIndex.value = -1;
        }
        function getNavigationDirection(key) {
            switch(key){
                case 'ArrowDown':
                    return 'next';
                case 'ArrowUp':
                    return 'prev';
                case 'Home':
                    return 'first';
                case 'End':
                    return 'last';
                default:
                    return null;
            }
        }
        function getNextIndex(direction) {
            const itemCount = items.value.length;
            if (itemCount === 0) return -1;
            let nextIndex;
            if (direction === 'first') nextIndex = 0;
            else if (direction === 'last') nextIndex = itemCount - 1;
            else {
                nextIndex = navigationIndex.value + (direction === 'next' ? 1 : -1);
                if (nextIndex < 0) nextIndex = itemCount - 1;
                if (nextIndex >= itemCount) nextIndex = 0;
            }
            const startIndex = nextIndex;
            let attempts = 0;
            while(attempts < itemCount){
                const item = items.value[nextIndex];
                if (item && item.type !== 'divider' && item.type !== 'subheader') return nextIndex;
                nextIndex += direction === 'next' || direction === 'first' ? 1 : -1;
                if (nextIndex < 0) nextIndex = itemCount - 1;
                if (nextIndex >= itemCount) nextIndex = 0;
                if (nextIndex === startIndex) return -1;
                attempts++;
            }
            return -1;
        }
        function onKeydown(e) {
            const target = e.target;
            if (!contentRef.value || target.tagName === 'INPUT' && [
                'Home',
                'End'
            ].includes(e.key) || target.tagName === 'TEXTAREA') return;
            const direction = getNavigationDirection(e.key);
            if (direction !== null) {
                e.preventDefault();
                if (props.navigationStrategy === 'track') {
                    const nextIndex = getNextIndex(direction);
                    if (nextIndex !== -1) navigationIndex.value = nextIndex;
                } else focus(direction);
            }
        }
        function onMousedown(e) {
            isFocused.value = true;
        }
        function focus(location) {
            if (contentRef.value) return (0, $8590040a7833369a$export$da2eafa20d5ebba)(contentRef.value, location);
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const ariaMultiselectable = isSelectable.value ? attrs.ariaMultiselectable ?? !String(props.selectStrategy).startsWith('single-') : undefined;
            return (0, $TusQn.createVNode)(props.tag, {
                "ref": contentRef,
                "class": (0, $8POXm.normalizeClass)([
                    'v-list',
                    {
                        'v-list--disabled': props.disabled,
                        'v-list--nav': props.nav,
                        'v-list--slim': props.slim
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    lineClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-list-indent': (0, $8590040a7833369a$export$286ad215293a0860)(props.indent),
                        '--v-list-prepend-gap': (0, $8590040a7833369a$export$286ad215293a0860)(props.prependGap)
                    },
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ]),
                "tabindex": props.disabled ? -1 : 0,
                "role": isSelectable.value ? 'listbox' : 'list',
                "aria-activedescendant": props.navigationStrategy === 'track' && navigationIndex.value >= 0 ? `v-list-item-${uid}-${navigationIndex.value}` : undefined,
                "aria-multiselectable": ariaMultiselectable,
                "onFocusin": onFocusin,
                "onFocusout": onFocusout,
                "onFocus": onFocus,
                "onBlur": onBlur,
                "onKeydown": onKeydown,
                "onMousedown": onMousedown
            }, {
                default: ()=>[
                        (0, $TusQn.createVNode)((0, $6cee302e69f97720$export$c0f3d26dd5c4f15a), {
                            "items": items.value,
                            "returnObject": props.returnObject
                        }, slots)
                    ]
            });
        });
        return {
            open: open,
            select: select,
            focus: focus,
            children: children,
            parents: parents,
            getPath: getPath,
            navigationIndex: navigationIndex
        };
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");



parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");

// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
// Types
/** Convert a point in local space to viewport space */ function $f61368e3f96f8e77$export$93ab817a3ebd510(point, offset) {
    return {
        x: point.x + offset.x,
        y: point.y + offset.y
    };
}
function $f61368e3f96f8e77$export$c44b1fec6bb4bd91(point, offset) {
    return {
        x: point.x - offset.x,
        y: point.y - offset.y
    };
}
function $f61368e3f96f8e77$export$622cea445a1c5b7d(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $f61368e3f96f8e77$export$461579dcc7f15045(anchor, box) {
    if (anchor.side === 'top' || anchor.side === 'bottom') {
        const { side: side, align: align } = anchor;
        const x = align === 'left' ? 0 : align === 'center' ? box.width / 2 : align === 'right' ? box.width : align;
        const y = side === 'top' ? 0 : side === 'bottom' ? box.height : side;
        return $f61368e3f96f8e77$export$93ab817a3ebd510({
            x: x,
            y: y
        }, box);
    } else if (anchor.side === 'left' || anchor.side === 'right') {
        const { side: side, align: align } = anchor;
        const x = side === 'left' ? 0 : side === 'right' ? box.width : side;
        const y = align === 'top' ? 0 : align === 'center' ? box.height / 2 : align === 'bottom' ? box.height : align;
        return $f61368e3f96f8e77$export$93ab817a3ebd510({
            x: x,
            y: y
        }, box);
    }
    return $f61368e3f96f8e77$export$93ab817a3ebd510({
        x: box.width / 2,
        y: box.height / 2
    }, box);
}


function $fa6a71feb92f218b$export$cfa2225e87938781(el) {
    let includeHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    while(el){
        if (includeHidden ? $fa6a71feb92f218b$var$isPotentiallyScrollable(el) : $fa6a71feb92f218b$export$4d450e1748530b6a(el)) return el;
        el = el.parentElement;
    }
    return document.scrollingElement;
}
function $fa6a71feb92f218b$export$94ed1c92c7beeb22(el, stopAt) {
    const elements = [];
    if (stopAt && el && !stopAt.contains(el)) return elements;
    while(el){
        if ($fa6a71feb92f218b$export$4d450e1748530b6a(el)) elements.push(el);
        if (el === stopAt) break;
        el = el.parentElement;
    }
    return elements;
}
function $fa6a71feb92f218b$export$4d450e1748530b6a(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
    const style = window.getComputedStyle(el);
    const hasVerticalScrollbar = style.overflowY === 'scroll' || style.overflowY === 'auto' && el.scrollHeight > el.clientHeight;
    const hasHorizontalScrollbar = style.overflowX === 'scroll' || style.overflowX === 'auto' && el.scrollWidth > el.clientWidth;
    return hasVerticalScrollbar || hasHorizontalScrollbar;
}
function $fa6a71feb92f218b$var$isPotentiallyScrollable(el) {
    if (!el || el.nodeType !== Node.ELEMENT_NODE) return false;
    const style = window.getComputedStyle(el);
    return [
        'scroll',
        'auto'
    ].includes(style.overflowY);
}

function $66cd1c74daef81e4$export$a5b46f8533f8cf74(el) {
    while(el){
        if (window.getComputedStyle(el).position === 'fixed') return true;
        el = el.offsetParent;
    }
    return false;
}



const $a5ace7faaea60e83$var$locationStrategies = {
    static: $a5ace7faaea60e83$var$staticLocationStrategy,
    // specific viewport position, usually centered
    connected: $a5ace7faaea60e83$var$connectedLocationStrategy // connected to a certain element
};
const $a5ace7faaea60e83$export$4182dc895ddc707b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    locationStrategy: {
        type: [
            String,
            Function
        ],
        default: 'static',
        validator: (val)=>typeof val === 'function' || val in $a5ace7faaea60e83$var$locationStrategies
    },
    location: {
        type: String,
        default: 'bottom'
    },
    origin: {
        type: String,
        default: 'auto'
    },
    offset: [
        Number,
        String,
        Array
    ],
    stickToTarget: Boolean,
    viewportMargin: {
        type: [
            Number,
            String
        ],
        default: 12
    }
}, 'VOverlay-location-strategies');
function $a5ace7faaea60e83$export$ddfd163f9bbe3913(props, data) {
    const contentStyles = (0, $01W3b.ref)({});
    const updateLocation = (0, $01W3b.ref)();
    if (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>!!(data.isActive.value && props.locationStrategy), (reset)=>{
        (0, $01W3b.watch)(()=>props.locationStrategy, reset);
        (0, $01W3b.onScopeDispose)(()=>{
            window.removeEventListener('resize', onResize);
            visualViewport?.removeEventListener('resize', onVisualResize);
            visualViewport?.removeEventListener('scroll', onVisualScroll);
            updateLocation.value = undefined;
        });
        window.addEventListener('resize', onResize, {
            passive: true
        });
        visualViewport?.addEventListener('resize', onVisualResize, {
            passive: true
        });
        visualViewport?.addEventListener('scroll', onVisualScroll, {
            passive: true
        });
        if (typeof props.locationStrategy === 'function') updateLocation.value = props.locationStrategy(data, props, contentStyles)?.updateLocation;
        else updateLocation.value = $a5ace7faaea60e83$var$locationStrategies[props.locationStrategy](data, props, contentStyles)?.updateLocation;
    });
    function onResize(e) {
        updateLocation.value?.(e);
    }
    function onVisualResize(e) {
        updateLocation.value?.(e);
    }
    function onVisualScroll(e) {
        updateLocation.value?.(e);
    }
    return {
        contentStyles: contentStyles,
        updateLocation: updateLocation
    };
}
function $a5ace7faaea60e83$var$staticLocationStrategy() {
// TODO
}
/** Get size of element ignoring max-width/max-height */ function $a5ace7faaea60e83$var$getIntrinsicSize(el, isRtl) {
    // const scrollables = new Map<Element, [number, number]>()
    // el.querySelectorAll('*').forEach(el => {
    //   const x = el.scrollLeft
    //   const y = el.scrollTop
    //   if (x || y) {
    //     scrollables.set(el, [x, y])
    //   }
    // })
    // const initialMaxWidth = el.style.maxWidth
    // const initialMaxHeight = el.style.maxHeight
    // el.style.removeProperty('max-width')
    // el.style.removeProperty('max-height')
    /* eslint-disable-next-line sonarjs/prefer-immediate-return */ const contentBox = (0, $d14b85b5564a2ed0$export$38c5b68336448fc8)(el);
    if (isRtl) contentBox.x += parseFloat(el.style.right || 0);
    else contentBox.x -= parseFloat(el.style.left || 0);
    contentBox.y -= parseFloat(el.style.top || 0);
    // el.style.maxWidth = initialMaxWidth
    // el.style.maxHeight = initialMaxHeight
    // scrollables.forEach((position, el) => {
    //   el.scrollTo(...position)
    // })
    return contentBox;
}
function $a5ace7faaea60e83$var$connectedLocationStrategy(data, props, contentStyles) {
    const activatorFixed = Array.isArray(data.target.value) || (0, $66cd1c74daef81e4$export$a5b46f8533f8cf74)(data.target.value);
    if (activatorFixed) Object.assign(contentStyles.value, {
        position: 'fixed',
        top: 0,
        [data.isRtl.value ? 'right' : 'left']: 0
    });
    const { preferredAnchor: preferredAnchor, preferredOrigin: preferredOrigin } = (0, $8590040a7833369a$export$fe6a5b56d01db4f5)(()=>{
        const parsedAnchor = (0, $aa564bd137c45a62$export$49d416a6d8a07bbb)(props.location, data.isRtl.value);
        const parsedOrigin = props.origin === 'overlap' ? parsedAnchor : props.origin === 'auto' ? (0, $aa564bd137c45a62$export$1bbdb13cd7175683)(parsedAnchor) : (0, $aa564bd137c45a62$export$49d416a6d8a07bbb)(props.origin, data.isRtl.value);
        // Some combinations of props may produce an invalid origin
        if (parsedAnchor.side === parsedOrigin.side && parsedAnchor.align === (0, $aa564bd137c45a62$export$ae4fe0e90a9c983d)(parsedOrigin).align) return {
            preferredAnchor: (0, $aa564bd137c45a62$export$af41802054d9b2a8)(parsedAnchor),
            preferredOrigin: (0, $aa564bd137c45a62$export$af41802054d9b2a8)(parsedOrigin)
        };
        else return {
            preferredAnchor: parsedAnchor,
            preferredOrigin: parsedOrigin
        };
    });
    const [minWidth, minHeight, maxWidth, maxHeight] = [
        'minWidth',
        'minHeight',
        'maxWidth',
        'maxHeight'
    ].map((key)=>{
        return (0, $01W3b.computed)(()=>{
            const val = parseFloat(props[key]);
            return isNaN(val) ? Infinity : val;
        });
    });
    const offset = (0, $01W3b.computed)(()=>{
        if (Array.isArray(props.offset)) return props.offset;
        if (typeof props.offset === 'string') {
            const offset = props.offset.split(' ').map(parseFloat);
            if (offset.length < 2) offset.push(0);
            return offset;
        }
        return typeof props.offset === 'number' ? [
            props.offset,
            0
        ] : [
            0,
            0
        ];
    });
    let observe = false;
    let lastFrame = -1;
    const flipped = new (0, $8590040a7833369a$export$5900cd5f89b9a13a)(4);
    const observer = new ResizeObserver(()=>{
        if (!observe) return;
        // Detect consecutive frames
        requestAnimationFrame((newTime)=>{
            if (newTime !== lastFrame) flipped.clear();
            requestAnimationFrame((newNewTime)=>{
                lastFrame = newNewTime;
            });
        });
        if (flipped.isFull) {
            const values = flipped.values();
            if ((0, $bf1718679e817e1f$export$9cb4719e2e525b7a)(values.at(-1), values.at(-3)) && !(0, $bf1718679e817e1f$export$9cb4719e2e525b7a)(values.at(-1), values.at(-2))) // Flipping is causing a container resize loop
            return;
        }
        const result = updateLocation();
        if (result) flipped.push(result.flipped);
    });
    let targetBox = new (0, $300dbef0cc33a399$export$e71c4d32a2263218)({
        x: 0,
        y: 0,
        width: 0,
        height: 0
    });
    (0, $01W3b.watch)(data.target, (newTarget, oldTarget)=>{
        if (oldTarget && !Array.isArray(oldTarget)) observer.unobserve(oldTarget);
        if (!Array.isArray(newTarget)) {
            if (newTarget) observer.observe(newTarget);
        } else if (!(0, $bf1718679e817e1f$export$9cb4719e2e525b7a)(newTarget, oldTarget)) updateLocation();
    }, {
        immediate: true
    });
    (0, $01W3b.watch)(data.contentEl, (newContentEl, oldContentEl)=>{
        if (oldContentEl) observer.unobserve(oldContentEl);
        if (newContentEl) observer.observe(newContentEl);
    }, {
        immediate: true
    });
    (0, $01W3b.onScopeDispose)(()=>{
        observer.disconnect();
    });
    // eslint-disable-next-line max-statements
    function updateLocation() {
        observe = false;
        requestAnimationFrame(()=>observe = true);
        if (!data.target.value || !data.contentEl.value) return;
        if (Array.isArray(data.target.value) || data.target.value.offsetParent || data.target.value.getClientRects().length) targetBox = (0, $300dbef0cc33a399$export$abd662d1b0b39d49)(data.target.value);
         // Otherwise target element is hidden, use last known value
        const contentBox = $a5ace7faaea60e83$var$getIntrinsicSize(data.contentEl.value, data.isRtl.value);
        const scrollParents = (0, $fa6a71feb92f218b$export$94ed1c92c7beeb22)(data.contentEl.value);
        const viewportMargin = Number(props.viewportMargin);
        if (!scrollParents.length) {
            scrollParents.push(document.documentElement);
            if (!(data.contentEl.value.style.top && data.contentEl.value.style.left)) {
                contentBox.x -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-x') || 0);
                contentBox.y -= parseFloat(document.documentElement.style.getPropertyValue('--v-body-scroll-y') || 0);
            }
        }
        const viewport = scrollParents.reduce((box, el)=>{
            const scrollBox = (0, $300dbef0cc33a399$export$6f532722e5bcfbac)(el);
            if (box) return new (0, $300dbef0cc33a399$export$e71c4d32a2263218)({
                x: Math.max(box.left, scrollBox.left),
                y: Math.max(box.top, scrollBox.top),
                width: Math.min(box.right, scrollBox.right) - Math.max(box.left, scrollBox.left),
                height: Math.min(box.bottom, scrollBox.bottom) - Math.max(box.top, scrollBox.top)
            });
            return scrollBox;
        }, undefined);
        if (props.stickToTarget) {
            viewport.x += Math.min(viewportMargin, targetBox.x);
            viewport.y += Math.min(viewportMargin, targetBox.y);
            viewport.width = Math.max(viewport.width - viewportMargin * 2, targetBox.x + targetBox.width - viewportMargin);
            viewport.height = Math.max(viewport.height - viewportMargin * 2, targetBox.y + targetBox.height - viewportMargin);
        } else {
            viewport.x += viewportMargin;
            viewport.y += viewportMargin;
            viewport.width -= viewportMargin * 2;
            viewport.height -= viewportMargin * 2;
        }
        let placement = {
            anchor: preferredAnchor.value,
            origin: preferredOrigin.value
        };
        function checkOverflow(_placement) {
            const box = new (0, $300dbef0cc33a399$export$e71c4d32a2263218)(contentBox);
            const targetPoint = (0, $f61368e3f96f8e77$export$461579dcc7f15045)(_placement.anchor, targetBox);
            const contentPoint = (0, $f61368e3f96f8e77$export$461579dcc7f15045)(_placement.origin, box);
            let { x: x, y: y } = (0, $f61368e3f96f8e77$export$622cea445a1c5b7d)(targetPoint, contentPoint);
            switch(_placement.anchor.side){
                case 'top':
                    y -= offset.value[0];
                    break;
                case 'bottom':
                    y += offset.value[0];
                    break;
                case 'left':
                    x -= offset.value[0];
                    break;
                case 'right':
                    x += offset.value[0];
                    break;
            }
            switch(_placement.anchor.align){
                case 'top':
                    y -= offset.value[1];
                    break;
                case 'bottom':
                    y += offset.value[1];
                    break;
                case 'left':
                    x -= offset.value[1];
                    break;
                case 'right':
                    x += offset.value[1];
                    break;
            }
            box.x += x;
            box.y += y;
            box.width = Math.min(box.width, maxWidth.value);
            box.height = Math.min(box.height, maxHeight.value);
            const overflows = (0, $300dbef0cc33a399$export$f63a1e5ecde5e3c4)(box, viewport);
            return {
                overflows: overflows,
                x: x,
                y: y
            };
        }
        let x = 0;
        let y = 0;
        const available = {
            x: 0,
            y: 0
        };
        const flipped = {
            x: false,
            y: false
        };
        let resets = -1;
        while(true){
            if (resets++ > 10) {
                (0, $5384ffc78a9e124c$export$bf36f23bad3e1069)('Infinite loop detected in connectedLocationStrategy');
                break;
            }
            const { x: _x, y: _y, overflows: overflows } = checkOverflow(placement);
            x += _x;
            y += _y;
            contentBox.x += _x;
            contentBox.y += _y;
            // flip
            {
                const axis = (0, $aa564bd137c45a62$export$8a3a0724d206787a)(placement.anchor);
                const hasOverflowX = overflows.x.before || overflows.x.after;
                const hasOverflowY = overflows.y.before || overflows.y.after;
                let reset = false;
                [
                    'x',
                    'y'
                ].forEach((key)=>{
                    if (key === 'x' && hasOverflowX && !flipped.x || key === 'y' && hasOverflowY && !flipped.y) {
                        const newPlacement = {
                            anchor: {
                                ...placement.anchor
                            },
                            origin: {
                                ...placement.origin
                            }
                        };
                        const flip = key === 'x' ? axis === 'y' ? (0, $aa564bd137c45a62$export$ae4fe0e90a9c983d) : (0, $aa564bd137c45a62$export$1bbdb13cd7175683) : axis === 'y' ? (0, $aa564bd137c45a62$export$1bbdb13cd7175683) : (0, $aa564bd137c45a62$export$ae4fe0e90a9c983d);
                        newPlacement.anchor = flip(newPlacement.anchor);
                        newPlacement.origin = flip(newPlacement.origin);
                        const { overflows: newOverflows } = checkOverflow(newPlacement);
                        if (newOverflows[key].before <= overflows[key].before && newOverflows[key].after <= overflows[key].after || newOverflows[key].before + newOverflows[key].after < (overflows[key].before + overflows[key].after) / 2) {
                            placement = newPlacement;
                            reset = flipped[key] = true;
                        }
                    }
                });
                if (reset) continue;
            }
            // shift
            if (overflows.x.before) {
                x += overflows.x.before;
                contentBox.x += overflows.x.before;
            }
            if (overflows.x.after) {
                x -= overflows.x.after;
                contentBox.x -= overflows.x.after;
            }
            if (overflows.y.before) {
                y += overflows.y.before;
                contentBox.y += overflows.y.before;
            }
            if (overflows.y.after) {
                y -= overflows.y.after;
                contentBox.y -= overflows.y.after;
            }
            // size
            {
                const overflows = (0, $300dbef0cc33a399$export$f63a1e5ecde5e3c4)(contentBox, viewport);
                available.x = viewport.width - overflows.x.before - overflows.x.after;
                available.y = viewport.height - overflows.y.before - overflows.y.after;
                x += overflows.x.before;
                contentBox.x += overflows.x.before;
                y += overflows.y.before;
                contentBox.y += overflows.y.before;
            }
            break;
        }
        const axis = (0, $aa564bd137c45a62$export$8a3a0724d206787a)(placement.anchor);
        Object.assign(contentStyles.value, {
            '--v-overlay-anchor-origin': `${placement.anchor.side} ${placement.anchor.align}`,
            transformOrigin: `${placement.origin.side} ${placement.origin.align}`,
            // transform: `translate(${pixelRound(x)}px, ${pixelRound(y)}px)`,
            top: (0, $8590040a7833369a$export$286ad215293a0860)($a5ace7faaea60e83$var$pixelRound(y)),
            left: data.isRtl.value ? undefined : (0, $8590040a7833369a$export$286ad215293a0860)($a5ace7faaea60e83$var$pixelRound(x)),
            right: data.isRtl.value ? (0, $8590040a7833369a$export$286ad215293a0860)($a5ace7faaea60e83$var$pixelRound(-x)) : undefined,
            minWidth: (0, $8590040a7833369a$export$286ad215293a0860)(axis === 'y' ? Math.min(minWidth.value, targetBox.width) : minWidth.value),
            maxWidth: (0, $8590040a7833369a$export$286ad215293a0860)($a5ace7faaea60e83$var$pixelCeil((0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(available.x, minWidth.value === Infinity ? 0 : minWidth.value, maxWidth.value))),
            maxHeight: (0, $8590040a7833369a$export$286ad215293a0860)($a5ace7faaea60e83$var$pixelCeil((0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(available.y, minHeight.value === Infinity ? 0 : minHeight.value, maxHeight.value)))
        });
        return {
            available: available,
            contentBox: contentBox,
            flipped: flipped
        };
    }
    (0, $01W3b.watch)(()=>[
            preferredAnchor.value,
            preferredOrigin.value,
            props.offset,
            props.minWidth,
            props.minHeight,
            props.maxWidth,
            props.maxHeight
        ], ()=>updateLocation());
    (0, $TusQn.nextTick)(()=>{
        const result = updateLocation();
        // TODO: overflowing content should only require a single updateLocation call
        // Icky hack to make sure the content is positioned consistently
        if (!result) return;
        const { available: available, contentBox: contentBox } = result;
        if (contentBox.height > available.y) requestAnimationFrame(()=>{
            updateLocation();
            requestAnimationFrame(()=>{
                updateLocation();
            });
        });
    });
    return {
        updateLocation: updateLocation
    };
}
function $a5ace7faaea60e83$var$pixelRound(val) {
    return Math.round(val * devicePixelRatio) / devicePixelRatio;
}
function $a5ace7faaea60e83$var$pixelCeil(val) {
    return Math.ceil(val * devicePixelRatio) / devicePixelRatio;
}


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
let $fb61b286aa826e96$var$clean = true;
const $fb61b286aa826e96$var$frames = [];
function $fb61b286aa826e96$export$feb8bc9b30dfb99(cb) {
    if (!$fb61b286aa826e96$var$clean || $fb61b286aa826e96$var$frames.length) {
        $fb61b286aa826e96$var$frames.push(cb);
        $fb61b286aa826e96$var$run();
    } else {
        $fb61b286aa826e96$var$clean = false;
        cb();
        $fb61b286aa826e96$var$run();
    }
}
let $fb61b286aa826e96$var$raf = -1;
function $fb61b286aa826e96$var$run() {
    cancelAnimationFrame($fb61b286aa826e96$var$raf);
    $fb61b286aa826e96$var$raf = requestAnimationFrame(()=>{
        const frame = $fb61b286aa826e96$var$frames.shift();
        if (frame) frame();
        if ($fb61b286aa826e96$var$frames.length) $fb61b286aa826e96$var$run();
        else $fb61b286aa826e96$var$clean = true;
    });
}



const $c028fa3fe78820c7$var$scrollStrategies = {
    none: null,
    close: $c028fa3fe78820c7$var$closeScrollStrategy,
    block: $c028fa3fe78820c7$var$blockScrollStrategy,
    reposition: $c028fa3fe78820c7$var$repositionScrollStrategy
};
const $c028fa3fe78820c7$export$5844d560a14f1eae = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    scrollStrategy: {
        type: [
            String,
            Function
        ],
        default: 'block',
        validator: (val)=>typeof val === 'function' || val in $c028fa3fe78820c7$var$scrollStrategies
    }
}, 'VOverlay-scroll-strategies');
function $c028fa3fe78820c7$export$a9bfea786f4e2928(props, data) {
    if (!(0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd)) return;
    let scope;
    (0, $TusQn.watchEffect)(async ()=>{
        scope?.stop();
        if (!(data.isActive.value && props.scrollStrategy)) return;
        scope = (0, $01W3b.effectScope)();
        await new Promise((resolve)=>setTimeout(resolve));
        scope.active && scope.run(()=>{
            if (typeof props.scrollStrategy === 'function') props.scrollStrategy(data, props, scope);
            else $c028fa3fe78820c7$var$scrollStrategies[props.scrollStrategy]?.(data, props, scope);
        });
    });
    (0, $01W3b.onScopeDispose)(()=>{
        scope?.stop();
    });
}
function $c028fa3fe78820c7$var$closeScrollStrategy(data) {
    function onScroll(e) {
        data.isActive.value = false;
    }
    $c028fa3fe78820c7$var$bindScroll($c028fa3fe78820c7$var$getTargetEl(data.target.value, data.contentEl.value), onScroll);
}
function $c028fa3fe78820c7$var$blockScrollStrategy(data, props) {
    const offsetParent = data.root.value?.offsetParent;
    const target = $c028fa3fe78820c7$var$getTargetEl(data.target.value, data.contentEl.value);
    const scrollElements = [
        ...new Set([
            ...(0, $fa6a71feb92f218b$export$94ed1c92c7beeb22)(target, props.contained ? offsetParent : undefined),
            ...(0, $fa6a71feb92f218b$export$94ed1c92c7beeb22)(data.contentEl.value, props.contained ? offsetParent : undefined)
        ])
    ].filter((el)=>!el.classList.contains('v-overlay-scroll-blocked'));
    const scrollbarWidth = window.innerWidth - document.documentElement.offsetWidth;
    const scrollableParent = ((el)=>(0, $fa6a71feb92f218b$export$4d450e1748530b6a)(el) && el)(offsetParent || document.documentElement);
    if (scrollableParent) data.root.value.classList.add('v-overlay--scroll-blocked');
    scrollElements.forEach((el, i)=>{
        el.style.setProperty('--v-body-scroll-x', (0, $8590040a7833369a$export$286ad215293a0860)(-el.scrollLeft));
        el.style.setProperty('--v-body-scroll-y', (0, $8590040a7833369a$export$286ad215293a0860)(-el.scrollTop));
        if (el !== document.documentElement) el.style.setProperty('--v-scrollbar-offset', (0, $8590040a7833369a$export$286ad215293a0860)(scrollbarWidth));
        el.classList.add('v-overlay-scroll-blocked');
    });
    (0, $01W3b.onScopeDispose)(()=>{
        scrollElements.forEach((el, i)=>{
            const x = parseFloat(el.style.getPropertyValue('--v-body-scroll-x'));
            const y = parseFloat(el.style.getPropertyValue('--v-body-scroll-y'));
            const scrollBehavior = el.style.scrollBehavior;
            el.style.scrollBehavior = 'auto';
            el.style.removeProperty('--v-body-scroll-x');
            el.style.removeProperty('--v-body-scroll-y');
            el.style.removeProperty('--v-scrollbar-offset');
            el.classList.remove('v-overlay-scroll-blocked');
            el.scrollLeft = -x;
            el.scrollTop = -y;
            el.style.scrollBehavior = scrollBehavior;
        });
        if (scrollableParent) data.root.value.classList.remove('v-overlay--scroll-blocked');
    });
}
function $c028fa3fe78820c7$var$repositionScrollStrategy(data, props, scope) {
    let slow = false;
    let raf = -1;
    let ric = -1;
    function update(e) {
        (0, $fb61b286aa826e96$export$feb8bc9b30dfb99)(()=>{
            const start = performance.now();
            data.updateLocation.value?.(e);
            const time = performance.now() - start;
            slow = time / (1000 / 60) > 2;
        });
    }
    ric = (typeof requestIdleCallback === 'undefined' ? (cb)=>cb() : requestIdleCallback)(()=>{
        scope.run(()=>{
            $c028fa3fe78820c7$var$bindScroll($c028fa3fe78820c7$var$getTargetEl(data.target.value, data.contentEl.value), (e)=>{
                if (slow) {
                    // If the position calculation is slow,
                    // defer updates until scrolling is finished.
                    // Browsers usually fire one scroll event per frame so
                    // we just wait until we've got two frames without an event
                    cancelAnimationFrame(raf);
                    raf = requestAnimationFrame(()=>{
                        raf = requestAnimationFrame(()=>{
                            update(e);
                        });
                    });
                } else update(e);
            });
        });
    });
    (0, $01W3b.onScopeDispose)(()=>{
        typeof cancelIdleCallback !== 'undefined' && cancelIdleCallback(ric);
        cancelAnimationFrame(raf);
    });
}
function $c028fa3fe78820c7$var$getTargetEl(target, contentEl) {
    return Array.isArray(target) ? document.elementsFromPoint(...target).find((el)=>!contentEl?.contains(el)) : target ?? contentEl;
}
function $c028fa3fe78820c7$var$bindScroll(el, onScroll) {
    const scrollElements = [
        document,
        ...(0, $fa6a71feb92f218b$export$94ed1c92c7beeb22)(el)
    ];
    scrollElements.forEach((el)=>{
        el.addEventListener('scroll', onScroll, {
            passive: true
        });
    });
    (0, $01W3b.onScopeDispose)(()=>{
        scrollElements.forEach((el)=>{
            el.removeEventListener('scroll', onScroll);
        });
    });
}


// Components
// Types
const $b8a1247336888f38$export$d60452ec716149a1 = Symbol.for('vuetify:v-menu');


// Utilities

const $f7bca629b3eb404a$export$1fd3611e92a5a94 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    closeDelay: [
        Number,
        String
    ],
    openDelay: [
        Number,
        String
    ]
}, 'delay');
function $f7bca629b3eb404a$export$69f38700ea0cb3b9(props, cb) {
    let clearDelay = ()=>{};
    function runDelay(isOpening, options) {
        clearDelay?.();
        const delay = isOpening ? props.openDelay : props.closeDelay;
        const normalizedDelay = Math.max(options?.minDelay ?? 0, Number(delay ?? 0));
        return new Promise((resolve)=>{
            clearDelay = (0, $8590040a7833369a$export$260e5c0943f31606)(normalizedDelay, ()=>{
                cb?.(isOpening);
                resolve(isOpening);
            });
        });
    }
    function runOpenDelay() {
        return runDelay(true);
    }
    function runCloseDelay(options) {
        return runDelay(false, options);
    }
    return {
        clearDelay: clearDelay,
        runOpenDelay: runOpenDelay,
        runCloseDelay: runCloseDelay
    };
}


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
// Utilities

const $1f14d950cf27c45f$var$handlers = new WeakMap();
function $1f14d950cf27c45f$export$b89d4640a29d673a(el, props) {
    Object.keys(props).forEach((k)=>{
        if ((0, $8590040a7833369a$export$1a2d97de39ecbb75)(k)) {
            const name = (0, $8590040a7833369a$export$a0305a8c6cff19c8)(k);
            const handler = $1f14d950cf27c45f$var$handlers.get(el);
            if (props[k] == null) handler?.forEach((v)=>{
                const [n, fn] = v;
                if (n === name) {
                    el.removeEventListener(name, fn);
                    handler.delete(v);
                }
            });
            else if (!handler || ![
                ...handler
            ]?.some((v)=>v[0] === name && v[1] === props[k])) {
                el.addEventListener(name, props[k]);
                const _handler = handler || new Set();
                _handler.add([
                    name,
                    props[k]
                ]);
                if (!$1f14d950cf27c45f$var$handlers.has(el)) $1f14d950cf27c45f$var$handlers.set(el, _handler);
            }
        } else if (props[k] == null) el.removeAttribute(k);
        else el.setAttribute(k, props[k]);
    });
}
function $1f14d950cf27c45f$export$58b6a9c1df4f180e(el, props) {
    Object.keys(props).forEach((k)=>{
        if ((0, $8590040a7833369a$export$1a2d97de39ecbb75)(k)) {
            const name = (0, $8590040a7833369a$export$a0305a8c6cff19c8)(k);
            const handler = $1f14d950cf27c45f$var$handlers.get(el);
            handler?.forEach((v)=>{
                const [n, fn] = v;
                if (n === name) {
                    el.removeEventListener(name, fn);
                    handler.delete(v);
                }
            });
        } else el.removeAttribute(k);
    });
}


const $8cb7ad4bc8138431$export$86105a8dfc563397 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    target: [
        String,
        Object
    ],
    activator: [
        String,
        Object
    ],
    activatorProps: {
        type: Object,
        default: ()=>({})
    },
    openOnClick: {
        type: Boolean,
        default: undefined
    },
    openOnHover: Boolean,
    openOnFocus: {
        type: Boolean,
        default: undefined
    },
    closeOnContentClick: Boolean,
    ...(0, $f7bca629b3eb404a$export$1fd3611e92a5a94)()
}, 'VOverlay-activator');
function $8cb7ad4bc8138431$export$c66a9a6f2d14727a(props, _ref) {
    let { isActive: isActive, isTop: isTop, contentEl: contentEl } = _ref;
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useActivator');
    const activatorEl = (0, $01W3b.ref)();
    let isHovered = false;
    let isFocused = false;
    let firstEnter = true;
    const openOnFocus = (0, $01W3b.computed)(()=>props.openOnFocus || props.openOnFocus == null && props.openOnHover);
    const openOnClick = (0, $01W3b.computed)(()=>props.openOnClick || props.openOnClick == null && !props.openOnHover && !openOnFocus.value);
    const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = (0, $f7bca629b3eb404a$export$69f38700ea0cb3b9)(props, (value)=>{
        if (value === (props.openOnHover && isHovered || openOnFocus.value && isFocused) && !(props.openOnHover && isActive.value && !isTop.value)) {
            if (isActive.value !== value) firstEnter = true;
            isActive.value = value;
        }
    });
    const cursorTarget = (0, $01W3b.ref)();
    const availableEvents = {
        onClick: (e)=>{
            e.stopPropagation();
            activatorEl.value = e.currentTarget || e.target;
            if (!isActive.value) cursorTarget.value = [
                e.clientX,
                e.clientY
            ];
            isActive.value = !isActive.value;
        },
        onMouseenter: (e)=>{
            isHovered = true;
            activatorEl.value = e.currentTarget || e.target;
            runOpenDelay();
        },
        onMouseleave: (e)=>{
            isHovered = false;
            runCloseDelay();
        },
        onFocus: (e)=>{
            if ((0, $8590040a7833369a$export$b06a2f5618961e1e)(e.target, ':focus-visible') === false) return;
            isFocused = true;
            e.stopPropagation();
            activatorEl.value = e.currentTarget || e.target;
            runOpenDelay();
        },
        onBlur: (e)=>{
            isFocused = false;
            e.stopPropagation();
            runCloseDelay({
                minDelay: 1
            });
        }
    };
    const activatorEvents = (0, $01W3b.computed)(()=>{
        const events = {};
        if (openOnClick.value) events.onClick = availableEvents.onClick;
        if (props.openOnHover) {
            events.onMouseenter = availableEvents.onMouseenter;
            events.onMouseleave = availableEvents.onMouseleave;
        }
        if (openOnFocus.value) {
            events.onFocus = availableEvents.onFocus;
            events.onBlur = availableEvents.onBlur;
        }
        return events;
    });
    const contentEvents = (0, $01W3b.computed)(()=>{
        const events = {};
        if (props.openOnHover) {
            events.onMouseenter = ()=>{
                isHovered = true;
                runOpenDelay();
            };
            events.onMouseleave = ()=>{
                isHovered = false;
                runCloseDelay();
            };
        }
        if (openOnFocus.value) {
            events.onFocusin = (e)=>{
                if (!e.target.matches(':focus-visible')) return;
                isFocused = true;
                runOpenDelay();
            };
            events.onFocusout = ()=>{
                isFocused = false;
                runCloseDelay({
                    minDelay: 1
                });
            };
        }
        if (props.closeOnContentClick) {
            const menu = (0, $TusQn.inject)((0, $b8a1247336888f38$export$d60452ec716149a1), null);
            events.onClick = ()=>{
                isActive.value = false;
                menu?.closeParents();
            };
        }
        return events;
    });
    const scrimEvents = (0, $01W3b.computed)(()=>{
        const events = {};
        if (props.openOnHover) {
            events.onMouseenter = ()=>{
                if (firstEnter) {
                    isHovered = true;
                    firstEnter = false;
                    runOpenDelay();
                }
            };
            events.onMouseleave = ()=>{
                isHovered = false;
                runCloseDelay();
            };
        }
        return events;
    });
    (0, $01W3b.watch)(isTop, (val)=>{
        if (val && (props.openOnHover && !isHovered && (!openOnFocus.value || !isFocused) || openOnFocus.value && !isFocused && (!props.openOnHover || !isHovered)) && !contentEl.value?.contains(document.activeElement)) isActive.value = false;
    });
    (0, $01W3b.watch)(isActive, (val)=>{
        if (!val) setTimeout(()=>{
            cursorTarget.value = undefined;
        });
    }, {
        flush: 'post'
    });
    const activatorRef = (0, $8590040a7833369a$export$fc38e812d383221)();
    (0, $TusQn.watchEffect)(()=>{
        if (!activatorRef.value) return;
        (0, $TusQn.nextTick)(()=>{
            activatorEl.value = activatorRef.el;
        });
    });
    const targetRef = (0, $8590040a7833369a$export$fc38e812d383221)();
    const target = (0, $01W3b.computed)(()=>{
        if (props.target === 'cursor' && cursorTarget.value) return cursorTarget.value;
        if (targetRef.value) return targetRef.el;
        return $8cb7ad4bc8138431$var$getTarget(props.target, vm) || activatorEl.value;
    });
    const targetEl = (0, $01W3b.computed)(()=>{
        return Array.isArray(target.value) ? undefined : target.value;
    });
    let scope;
    (0, $01W3b.watch)(()=>!!props.activator, (val)=>{
        if (val && (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd)) {
            scope = (0, $01W3b.effectScope)();
            scope.run(()=>{
                $8cb7ad4bc8138431$var$_useActivator(props, vm, {
                    activatorEl: activatorEl,
                    activatorEvents: activatorEvents
                });
            });
        } else if (scope) scope.stop();
    }, {
        flush: 'post',
        immediate: true
    });
    (0, $01W3b.onScopeDispose)(()=>{
        scope?.stop();
    });
    return {
        activatorEl: activatorEl,
        activatorRef: activatorRef,
        target: target,
        targetEl: targetEl,
        targetRef: targetRef,
        activatorEvents: activatorEvents,
        contentEvents: contentEvents,
        scrimEvents: scrimEvents
    };
}
function $8cb7ad4bc8138431$var$_useActivator(props, vm, _ref2) {
    let { activatorEl: activatorEl, activatorEvents: activatorEvents } = _ref2;
    (0, $01W3b.watch)(()=>props.activator, (val, oldVal)=>{
        if (oldVal && val !== oldVal) {
            const activator = getActivator(oldVal);
            activator && unbindActivatorProps(activator);
        }
        if (val) (0, $TusQn.nextTick)(()=>bindActivatorProps());
    }, {
        immediate: true
    });
    (0, $01W3b.watch)(()=>props.activatorProps, ()=>{
        bindActivatorProps();
    });
    (0, $01W3b.onScopeDispose)(()=>{
        unbindActivatorProps();
    });
    function bindActivatorProps() {
        let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getActivator();
        let _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.activatorProps;
        if (!el) return;
        (0, $1f14d950cf27c45f$export$b89d4640a29d673a)(el, (0, $TusQn.mergeProps)(activatorEvents.value, _props));
    }
    function unbindActivatorProps() {
        let el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getActivator();
        let _props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.activatorProps;
        if (!el) return;
        (0, $1f14d950cf27c45f$export$58b6a9c1df4f180e)(el, (0, $TusQn.mergeProps)(activatorEvents.value, _props));
    }
    function getActivator() {
        let selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : props.activator;
        const activator = $8cb7ad4bc8138431$var$getTarget(selector, vm);
        // The activator should only be a valid element (Ignore comments and text nodes)
        activatorEl.value = activator?.nodeType === Node.ELEMENT_NODE ? activator : undefined;
        return activatorEl.value;
    }
}
function $8cb7ad4bc8138431$var$getTarget(selector, vm) {
    if (!selector) return;
    let target;
    if (selector === 'parent') {
        let el = vm?.proxy?.$el?.parentNode;
        while(el?.hasAttribute('data-no-activator'))el = el.parentNode;
        target = el;
    } else if (typeof selector === 'string') // Selector
    target = document.querySelector(selector);
    else if ('$el' in selector) // Component (ref)
    target = selector.$el;
    else // HTMLElement | Element | [x, y]
    target = selector;
    return target;
}





// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

const $a72168ea6a0ee1b7$export$bfa779dd7c86a172 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    retainFocus: Boolean,
    captureFocus: Boolean,
    /** @deprecated */ disableInitialFocus: Boolean
}, 'focusTrap');
const $a72168ea6a0ee1b7$var$registry = new Map();
let $a72168ea6a0ee1b7$var$subscribers = 0;
function $a72168ea6a0ee1b7$var$onKeydown(e) {
    const activeElement = document.activeElement;
    if (e.key !== 'Tab' || !activeElement) return;
    const parentTraps = Array.from($a72168ea6a0ee1b7$var$registry.values()).filter((_ref)=>{
        let { isActive: isActive, contentEl: contentEl } = _ref;
        return isActive.value && contentEl.value?.contains(activeElement);
    }).map((x)=>x.contentEl.value);
    let closestTrap;
    let currentParent = activeElement.parentElement;
    while(currentParent){
        if (parentTraps.includes(currentParent)) {
            closestTrap = currentParent;
            break;
        }
        currentParent = currentParent.parentElement;
    }
    if (!closestTrap) return;
    const focusable = (0, $8590040a7833369a$export$aea49dace3f6ca76)(closestTrap)// excluding VListItems with tabindex="-2"
    .filter((x)=>x.tabIndex >= 0);
    if (!focusable.length) return;
    const active = document.activeElement;
    if (focusable.length === 1 && focusable[0].classList.contains('v-list') && focusable[0].contains(active)) {
        e.preventDefault();
        return;
    }
    const firstElement = focusable[0];
    const lastElement = focusable[focusable.length - 1];
    if (e.shiftKey && (active === firstElement || firstElement.classList.contains('v-list') && firstElement.contains(active))) {
        e.preventDefault();
        lastElement.focus();
    }
    if (!e.shiftKey && (active === lastElement || lastElement.classList.contains('v-list') && lastElement.contains(active))) {
        e.preventDefault();
        firstElement.focus();
    }
}
function $a72168ea6a0ee1b7$export$5562a1f223a0d314(props, _ref2) {
    let { isActive: isActive, localTop: localTop, activatorEl: activatorEl, contentEl: contentEl } = _ref2;
    const trapId = Symbol('trap');
    let focusTrapSuppressed = false;
    let focusTrapSuppressionTimeout = -1;
    async function onPointerdown() {
        focusTrapSuppressed = true;
        focusTrapSuppressionTimeout = window.setTimeout(()=>{
            focusTrapSuppressed = false;
        }, 100);
    }
    async function captureOnFocus(e) {
        const before = e.relatedTarget;
        const after = e.target;
        document.removeEventListener('pointerdown', onPointerdown);
        document.removeEventListener('keydown', captureOnKeydown);
        await (0, $TusQn.nextTick)();
        if (isActive.value && !focusTrapSuppressed && before !== after && contentEl.value && // We're the menu without open submenus or overlays
        (0, $01W3b.toValue)(localTop) && // It isn't the document or the container body
        ![
            document,
            contentEl.value
        ].includes(after) && // It isn't inside the container body
        !contentEl.value.contains(after)) {
            const focusable = (0, $8590040a7833369a$export$aea49dace3f6ca76)(contentEl.value);
            focusable[0]?.focus();
        }
    }
    function captureOnKeydown(e) {
        if (e.key !== 'Tab') return;
        document.removeEventListener('keydown', captureOnKeydown);
        if (isActive.value && contentEl.value && e.target && !contentEl.value.contains(e.target)) {
            const allFocusableElements = (0, $8590040a7833369a$export$aea49dace3f6ca76)(document.documentElement);
            if (e.shiftKey && e.target === allFocusableElements.at(0) || !e.shiftKey && e.target === allFocusableElements.at(-1)) {
                const focusable = (0, $8590040a7833369a$export$aea49dace3f6ca76)(contentEl.value);
                if (focusable.length > 0) {
                    e.preventDefault();
                    focusable[0].focus();
                }
            }
        }
    }
    const shouldCapture = (0, $01W3b.toRef)(()=>isActive.value && props.captureFocus && !props.disableInitialFocus);
    if (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) {
        (0, $01W3b.watch)(()=>props.retainFocus, (val)=>{
            if (val) $a72168ea6a0ee1b7$var$registry.set(trapId, {
                isActive: isActive,
                contentEl: contentEl
            });
            else $a72168ea6a0ee1b7$var$registry.delete(trapId);
        }, {
            immediate: true
        });
        (0, $01W3b.watch)(shouldCapture, (val)=>{
            if (val) {
                document.addEventListener('pointerdown', onPointerdown);
                document.addEventListener('focusin', captureOnFocus, {
                    once: true
                });
                document.addEventListener('keydown', captureOnKeydown);
            } else {
                document.removeEventListener('pointerdown', onPointerdown);
                document.removeEventListener('focusin', captureOnFocus);
                document.removeEventListener('keydown', captureOnKeydown);
            }
        }, {
            immediate: true
        });
        if ($a72168ea6a0ee1b7$var$subscribers++ < 1) document.addEventListener('keydown', $a72168ea6a0ee1b7$var$onKeydown);
    }
    (0, $01W3b.onScopeDispose)(()=>{
        $a72168ea6a0ee1b7$var$registry.delete(trapId);
        clearTimeout(focusTrapSuppressionTimeout);
        document.removeEventListener('pointerdown', onPointerdown);
        document.removeEventListener('focusin', captureOnFocus);
        document.removeEventListener('keydown', captureOnKeydown);
        if (--$a72168ea6a0ee1b7$var$subscribers < 1) document.removeEventListener('keydown', $a72168ea6a0ee1b7$var$onKeydown);
    });
}


// Composables

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

function $48cd263ee58eedc4$export$5b8689c380bcb3d5() {
    if (!(0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd)) return (0, $01W3b.shallowRef)(false);
    const { ssr: ssr } = (0, $1444e2cf1a712792$export$8406b7efc286d284)();
    if (ssr) {
        const isMounted = (0, $01W3b.shallowRef)(false);
        (0, $TusQn.onMounted)(()=>{
            isMounted.value = true;
        });
        return isMounted;
    } else return (0, $01W3b.shallowRef)(true);
}


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $1ee69ec23e68548b$export$3557c26df64490a4 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    eager: Boolean
}, 'lazy');
function $1ee69ec23e68548b$export$965f98646215a1bd(props, active) {
    const isBooted = (0, $01W3b.shallowRef)(false);
    const hasContent = (0, $01W3b.toRef)(()=>isBooted.value || props.eager || active.value);
    (0, $01W3b.watch)(active, ()=>isBooted.value = true);
    function onAfterLeave() {
        if (!props.eager) isBooted.value = false;
    }
    return {
        isBooted: isBooted,
        hasContent: hasContent,
        onAfterLeave: onAfterLeave
    };
}





// Utilities

function $d897445671465531$export$eeabe5cda932100d() {
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useScopeId');
    const scopeId = vm.vnode.scopeId;
    return {
        scopeId: scopeId ? {
            [scopeId]: ''
        } : undefined
    };
}


// Composables

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

const $5329ec9e262d5746$var$StackSymbol = Symbol.for('vuetify:stack');
const $5329ec9e262d5746$var$globalStack = (0, $01W3b.reactive)([]);
function $5329ec9e262d5746$export$df58951aab233134(isActive, zIndex, disableGlobalStack) {
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('useStack');
    const createStackEntry = !disableGlobalStack;
    const parent = (0, $TusQn.inject)($5329ec9e262d5746$var$StackSymbol, undefined);
    const stack = (0, $01W3b.reactive)({
        activeChildren: new Set()
    });
    (0, $TusQn.provide)($5329ec9e262d5746$var$StackSymbol, stack);
    const _zIndex = (0, $01W3b.shallowRef)(Number((0, $01W3b.toValue)(zIndex)));
    (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(isActive, ()=>{
        const lastZIndex = $5329ec9e262d5746$var$globalStack.at(-1)?.[1];
        _zIndex.value = lastZIndex ? lastZIndex + 10 : Number((0, $01W3b.toValue)(zIndex));
        if (createStackEntry) $5329ec9e262d5746$var$globalStack.push([
            vm.uid,
            _zIndex.value
        ]);
        parent?.activeChildren.add(vm.uid);
        (0, $01W3b.onScopeDispose)(()=>{
            if (createStackEntry) {
                const idx = (0, $01W3b.toRaw)($5329ec9e262d5746$var$globalStack).findIndex((v)=>v[0] === vm.uid);
                $5329ec9e262d5746$var$globalStack.splice(idx, 1);
            }
            parent?.activeChildren.delete(vm.uid);
        });
    });
    const globalTop = (0, $01W3b.shallowRef)(true);
    if (createStackEntry) (0, $TusQn.watchEffect)(()=>{
        const _isTop = $5329ec9e262d5746$var$globalStack.at(-1)?.[0] === vm.uid;
        setTimeout(()=>globalTop.value = _isTop);
    });
    const localTop = (0, $01W3b.toRef)(()=>!stack.activeChildren.size);
    return {
        globalTop: (0, $01W3b.readonly)(globalTop),
        localTop: localTop,
        stackStyles: (0, $01W3b.toRef)(()=>({
                zIndex: _zIndex.value
            }))
    };
}


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

function $e2e092047f3f4aef$export$b6ab74bf6ad20b87(target) {
    const teleportTarget = (0, $01W3b.computed)(()=>{
        const _target = target();
        if (_target === true || !(0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd)) return undefined;
        const targetElement = _target === false ? document.body : typeof _target === 'string' ? document.querySelector(_target) : _target;
        if (targetElement == null) {
            (0, $TusQn.warn)(`Unable to locate target ${_target}`);
            return undefined;
        }
        let container = [
            ...targetElement.children
        ].find((el)=>el.matches('.v-overlay-container'));
        if (!container) {
            container = document.createElement('div');
            container.className = 'v-overlay-container';
            targetElement.appendChild(container);
        }
        return container;
    });
    return {
        teleportTarget: teleportTarget
    };
}





// Utilities
/**
 * Returns:
 *  - 'null' if the node is not attached to the DOM
 *  - the root node (HTMLDocument | ShadowRoot) otherwise
 */ function $ae9975d2de08ed32$export$3be35968ed281992(node) {
    /* istanbul ignore next */ if (typeof node.getRootNode !== 'function') {
        // Shadow DOM not supported (IE11), lets find the root of this node
        while(node.parentNode)node = node.parentNode;
        // The root parent is the document if the node is attached to the DOM
        if (node !== document) return null;
        return document;
    }
    const root = node.getRootNode();
    // The composed root node is the document if the node is attached to the DOM
    if (root !== document && root.getRootNode({
        composed: true
    }) !== document) return null;
    return root;
}


function $5d336c60fc44541c$var$defaultConditional() {
    return true;
}
function $5d336c60fc44541c$var$checkEvent(e, el, binding) {
    // The include element callbacks below can be expensive
    // so we should avoid calling them when we're not active.
    // Explicitly check for false to allow fallback compatibility
    // with non-toggleable components
    if (!e || $5d336c60fc44541c$var$checkIsActive(e, binding) === false) return false;
    // If we're clicking inside the shadowroot, then the app root doesn't get the same
    // level of introspection as to _what_ we're clicking. We want to check to see if
    // our target is the shadowroot parent container, and if it is, ignore.
    const root = (0, $ae9975d2de08ed32$export$3be35968ed281992)(el);
    if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot && root.host === e.target) return false;
    // Check if additional elements were passed to be included in check
    // (click must be outside all included elements, if any)
    const elements = (typeof binding.value === 'object' && binding.value.include || (()=>[]))();
    // Add the root element for the component this directive was defined on
    elements.push(el);
    // Check if it's a click outside our elements, and then if our callback returns true.
    // Non-toggleable components should take action in their callback and return falsy.
    // Toggleable can return true if it wants to deactivate.
    // Note that, because we're in the capture phase, this callback will occur before
    // the bubbling click event on any outside elements.
    return !elements.some((el)=>el?.contains(e.target));
}
function $5d336c60fc44541c$var$checkIsActive(e, binding) {
    const isActive = typeof binding.value === 'object' && binding.value.closeConditional || $5d336c60fc44541c$var$defaultConditional;
    return isActive(e);
}
function $5d336c60fc44541c$var$directive(e, el, binding) {
    const handler = typeof binding.value === 'function' ? binding.value : binding.value.handler;
    // Clicks in the Shadow DOM change their target while using setTimeout, so the original target is saved here
    e.shadowTarget = e.target;
    el._clickOutside.lastMousedownWasOutside && $5d336c60fc44541c$var$checkEvent(e, el, binding) && setTimeout(()=>{
        $5d336c60fc44541c$var$checkIsActive(e, binding) && handler && handler(e);
    }, 0);
}
function $5d336c60fc44541c$var$handleShadow(el, callback) {
    const root = (0, $ae9975d2de08ed32$export$3be35968ed281992)(el);
    callback(document);
    if (typeof ShadowRoot !== 'undefined' && root instanceof ShadowRoot) callback(root);
}
const $5d336c60fc44541c$export$c16e4f034c84cb3f = {
    // [data-app] may not be found
    // if using bind, inserted makes
    // sure that the root element is
    // available, iOS does not support
    // clicks on body
    mounted (el, binding) {
        const onClick = (e)=>$5d336c60fc44541c$var$directive(e, el, binding);
        const onMousedown = (e)=>{
            el._clickOutside.lastMousedownWasOutside = $5d336c60fc44541c$var$checkEvent(e, el, binding);
        };
        $5d336c60fc44541c$var$handleShadow(el, (app)=>{
            app.addEventListener('click', onClick, true);
            app.addEventListener('mousedown', onMousedown, true);
        });
        if (!el._clickOutside) el._clickOutside = {
            lastMousedownWasOutside: false
        };
        el._clickOutside[binding.instance.$.uid] = {
            onClick: onClick,
            onMousedown: onMousedown
        };
    },
    beforeUnmount (el, binding) {
        if (!el._clickOutside) return;
        $5d336c60fc44541c$var$handleShadow(el, (app)=>{
            if (!app || !el._clickOutside?.[binding.instance.$.uid]) return;
            const { onClick: onClick, onMousedown: onMousedown } = el._clickOutside[binding.instance.$.uid];
            app.removeEventListener('click', onClick, true);
            app.removeEventListener('mousedown', onMousedown, true);
        });
        delete el._clickOutside[binding.instance.$.uid];
    }
};
var $5d336c60fc44541c$export$2e2bcd8739ae039 = $5d336c60fc44541c$export$c16e4f034c84cb3f;



function $0eb6b57fb5d95344$var$Scrim(props) {
    const { modelValue: modelValue, color: color, ...rest } = props;
    return (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
        "name": "fade-transition",
        "appear": true
    }, {
        default: ()=>[
                props.modelValue && (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                    "class": [
                        'v-overlay__scrim',
                        props.color.backgroundColorClasses.value
                    ],
                    "style": props.color.backgroundColorStyles.value
                }, rest), null)
            ]
    });
}
const $0eb6b57fb5d95344$export$357b25d59a7fb3fa = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    absolute: Boolean,
    attach: [
        Boolean,
        String,
        Object
    ],
    closeOnBack: {
        type: Boolean,
        default: true
    },
    contained: Boolean,
    contentClass: null,
    contentProps: null,
    disabled: Boolean,
    opacity: [
        Number,
        String
    ],
    noClickAnimation: Boolean,
    modelValue: Boolean,
    persistent: Boolean,
    scrim: {
        type: [
            Boolean,
            String
        ],
        default: true
    },
    zIndex: {
        type: [
            Number,
            String
        ],
        default: 2000
    },
    ...(0, $8cb7ad4bc8138431$export$86105a8dfc563397)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $1ee69ec23e68548b$export$3557c26df64490a4)(),
    ...(0, $a5ace7faaea60e83$export$4182dc895ddc707b)(),
    ...(0, $c028fa3fe78820c7$export$5844d560a14f1eae)(),
    ...(0, $a72168ea6a0ee1b7$export$bfa779dd7c86a172)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e)()
}, 'VOverlay');
const $0eb6b57fb5d95344$export$32caf7e8170352aa = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VOverlay',
    directives: {
        vClickOutside: $5d336c60fc44541c$export$2e2bcd8739ae039
    },
    inheritAttrs: false,
    props: {
        _disableGlobalStack: Boolean,
        ...(0, $8590040a7833369a$export$30a06c8d3562193f)($0eb6b57fb5d95344$export$357b25d59a7fb3fa(), [
            'disableInitialFocus'
        ])
    },
    emits: {
        'click:outside': (e)=>true,
        'update:modelValue': (value)=>true,
        keydown: (e)=>true,
        afterEnter: ()=>true,
        afterLeave: ()=>true
    },
    setup (props, _ref) {
        let { slots: slots, attrs: attrs, emit: emit } = _ref;
        const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('VOverlay');
        const root = (0, $01W3b.ref)();
        const scrimEl = (0, $01W3b.ref)();
        const contentEl = (0, $01W3b.ref)();
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const isActive = (0, $01W3b.computed)({
            get: ()=>model.value,
            set: (v)=>{
                if (!(v && props.disabled)) model.value = v;
            }
        });
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { rtlClasses: rtlClasses, isRtl: isRtl } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const { hasContent: hasContent, onAfterLeave: _onAfterLeave } = (0, $1ee69ec23e68548b$export$965f98646215a1bd)(props, isActive);
        const scrimColor = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>{
            return typeof props.scrim === 'string' ? props.scrim : null;
        });
        const { globalTop: globalTop, localTop: localTop, stackStyles: stackStyles } = (0, $5329ec9e262d5746$export$df58951aab233134)(isActive, ()=>props.zIndex, props._disableGlobalStack);
        const { activatorEl: activatorEl, activatorRef: activatorRef, target: target, targetEl: targetEl, targetRef: targetRef, activatorEvents: activatorEvents, contentEvents: contentEvents, scrimEvents: scrimEvents } = (0, $8cb7ad4bc8138431$export$c66a9a6f2d14727a)(props, {
            isActive: isActive,
            isTop: localTop,
            contentEl: contentEl
        });
        const { teleportTarget: teleportTarget } = (0, $e2e092047f3f4aef$export$b6ab74bf6ad20b87)(()=>{
            const target = props.attach || props.contained;
            if (target) return target;
            const rootNode = activatorEl?.value?.getRootNode() || vm.proxy?.$el?.getRootNode();
            if (rootNode instanceof ShadowRoot) return rootNode;
            return false;
        });
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const isMounted = (0, $48cd263ee58eedc4$export$5b8689c380bcb3d5)();
        const { scopeId: scopeId } = (0, $d897445671465531$export$eeabe5cda932100d)();
        (0, $01W3b.watch)(()=>props.disabled, (v)=>{
            if (v) isActive.value = false;
        });
        const { contentStyles: contentStyles, updateLocation: updateLocation } = (0, $a5ace7faaea60e83$export$ddfd163f9bbe3913)(props, {
            isRtl: isRtl,
            contentEl: contentEl,
            target: target,
            isActive: isActive
        });
        (0, $c028fa3fe78820c7$export$a9bfea786f4e2928)(props, {
            root: root,
            contentEl: contentEl,
            targetEl: targetEl,
            target: target,
            isActive: isActive,
            updateLocation: updateLocation
        });
        function onClickOutside(e) {
            emit('click:outside', e);
            if (!props.persistent) isActive.value = false;
            else animateClick();
        }
        function closeConditional(e) {
            return isActive.value && localTop.value && // If using scrim, only close if clicking on it rather than anything opened on top
            (!props.scrim || e.target === scrimEl.value || e instanceof MouseEvent && e.shadowTarget === scrimEl.value);
        }
        (0, $a72168ea6a0ee1b7$export$5562a1f223a0d314)(props, {
            isActive: isActive,
            localTop: localTop,
            contentEl: contentEl,
            activatorEl: activatorEl
        });
        (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && (0, $01W3b.watch)(isActive, (val)=>{
            if (val) window.addEventListener('keydown', onKeydown);
            else window.removeEventListener('keydown', onKeydown);
        }, {
            immediate: true
        });
        (0, $TusQn.onBeforeUnmount)(()=>{
            if (!(0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd)) return;
            window.removeEventListener('keydown', onKeydown);
        });
        function onKeydown(e) {
            if (e.key === 'Escape' && globalTop.value) {
                if (!contentEl.value?.contains(document.activeElement)) emit('keydown', e);
                if (!props.persistent) {
                    isActive.value = false;
                    if (contentEl.value?.contains(document.activeElement)) activatorEl.value?.focus();
                } else animateClick();
            }
        }
        function onKeydownSelf(e) {
            if (e.key === 'Escape' && !globalTop.value) return;
            emit('keydown', e);
        }
        const router = (0, $1c0236248fe13b4c$export$9a302a45f65d0572)();
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>props.closeOnBack, ()=>{
            (0, $1c0236248fe13b4c$export$a519bdc484beda0)(router, (next)=>{
                if (globalTop.value && isActive.value) {
                    next(false);
                    if (!props.persistent) isActive.value = false;
                    else animateClick();
                } else next();
            });
        });
        const top = (0, $01W3b.ref)();
        (0, $01W3b.watch)(()=>isActive.value && (props.absolute || props.contained) && teleportTarget.value == null, (val)=>{
            if (val) {
                const scrollParent = (0, $fa6a71feb92f218b$export$cfa2225e87938781)(root.value);
                if (scrollParent && scrollParent !== document.scrollingElement) top.value = scrollParent.scrollTop;
            }
        });
        // Add a quick "bounce" animation to the content
        function animateClick() {
            if (props.noClickAnimation) return;
            contentEl.value && (0, $d14b85b5564a2ed0$export$e3607ec2d7a891c4)(contentEl.value, [
                {
                    transformOrigin: 'center'
                },
                {
                    transform: 'scale(1.03)'
                },
                {
                    transformOrigin: 'center'
                }
            ], {
                duration: 150,
                easing: (0, $f725c9134abb2fa7$export$bf86e2ccec972a06)
            });
        }
        function onAfterEnter() {
            emit('afterEnter');
        }
        function onAfterLeave() {
            _onAfterLeave();
            emit('afterLeave');
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                slots.activator?.({
                    isActive: isActive.value,
                    targetRef: targetRef,
                    props: (0, $TusQn.mergeProps)({
                        ref: activatorRef
                    }, activatorEvents.value, props.activatorProps)
                }),
                isMounted.value && hasContent.value && (0, $TusQn.createVNode)((0, $TusQn.Teleport), {
                    "disabled": !teleportTarget.value,
                    "to": teleportTarget.value
                }, {
                    default: ()=>[
                            (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                                "class": [
                                    'v-overlay',
                                    {
                                        'v-overlay--absolute': props.absolute || props.contained,
                                        'v-overlay--active': isActive.value,
                                        'v-overlay--contained': props.contained
                                    },
                                    themeClasses.value,
                                    rtlClasses.value,
                                    props.class
                                ],
                                "style": [
                                    stackStyles.value,
                                    {
                                        '--v-overlay-opacity': props.opacity,
                                        top: (0, $8590040a7833369a$export$286ad215293a0860)(top.value)
                                    },
                                    props.style
                                ],
                                "ref": root,
                                "onKeydown": onKeydownSelf
                            }, scopeId, attrs), [
                                (0, $TusQn.createVNode)($0eb6b57fb5d95344$var$Scrim, (0, $TusQn.mergeProps)({
                                    "color": scrimColor,
                                    "modelValue": isActive.value && !!props.scrim,
                                    "ref": scrimEl
                                }, scrimEvents.value), null),
                                (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                                    "appear": true,
                                    "persisted": true,
                                    "transition": props.transition,
                                    "target": target.value,
                                    "onAfterEnter": onAfterEnter,
                                    "onAfterLeave": onAfterLeave
                                }, {
                                    default: ()=>[
                                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                                                "ref": contentEl,
                                                "class": [
                                                    'v-overlay__content',
                                                    props.contentClass
                                                ],
                                                "style": [
                                                    dimensionStyles.value,
                                                    contentStyles.value
                                                ]
                                            }, contentEvents.value, props.contentProps), [
                                                slots.default?.({
                                                    isActive: isActive
                                                })
                                            ]), [
                                                [
                                                    (0, $eeJ70.vShow),
                                                    isActive.value
                                                ],
                                                [
                                                    (0, $5d336c60fc44541c$export$2e2bcd8739ae039),
                                                    {
                                                        handler: onClickOutside,
                                                        closeConditional: closeConditional,
                                                        include: ()=>[
                                                                activatorEl.value
                                                            ]
                                                    }
                                                ]
                                            ])
                                        ]
                                })
                            ])
                        ]
                })
            ]));
        return {
            activatorEl: activatorEl,
            scrimEl: scrimEl,
            target: target,
            animateClick: animateClick,
            contentEl: contentEl,
            rootEl: root,
            globalTop: globalTop,
            localTop: localTop,
            updateLocation: updateLocation
        };
    }
});



// Types
const $c1e610bfc2557356$var$Refs = Symbol('Forwarded refs');
/** Omit properties starting with P */ /** Omit keyof $props from T */ function $c1e610bfc2557356$var$getDescriptor(obj, key) {
    let currentObj = obj;
    while(currentObj){
        const descriptor = Reflect.getOwnPropertyDescriptor(currentObj, key);
        if (descriptor) return descriptor;
        currentObj = Object.getPrototypeOf(currentObj);
    }
    return undefined;
}
function $c1e610bfc2557356$export$e091cd9ead0744b3(target) {
    for(var _len = arguments.length, refs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)refs[_key - 1] = arguments[_key];
    target[$c1e610bfc2557356$var$Refs] = refs;
    return new Proxy(target, {
        get (target, key) {
            if (Reflect.has(target, key)) return Reflect.get(target, key);
            // Skip internal properties
            if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;
            for (const ref of refs)if (ref.value && Reflect.has(ref.value, key)) {
                const val = Reflect.get(ref.value, key);
                return typeof val === 'function' ? val.bind(ref.value) : val;
            }
        },
        has (target, key) {
            if (Reflect.has(target, key)) return true;
            // Skip internal properties
            if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
            for (const ref of refs){
                if (ref.value && Reflect.has(ref.value, key)) return true;
            }
            return false;
        },
        set (target, key, value) {
            if (Reflect.has(target, key)) return Reflect.set(target, key, value);
            // Skip internal properties
            if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return false;
            for (const ref of refs){
                if (ref.value && Reflect.has(ref.value, key)) return Reflect.set(ref.value, key, value);
            }
            return false;
        },
        getOwnPropertyDescriptor (target, key) {
            const descriptor = Reflect.getOwnPropertyDescriptor(target, key);
            if (descriptor) return descriptor;
            // Skip internal properties
            if (typeof key === 'symbol' || key.startsWith('$') || key.startsWith('__')) return;
            // Check each ref's own properties
            for (const ref of refs){
                if (!ref.value) continue;
                const descriptor = $c1e610bfc2557356$var$getDescriptor(ref.value, key) ?? ('_' in ref.value ? $c1e610bfc2557356$var$getDescriptor(ref.value._?.setupState, key) : undefined);
                if (descriptor) return descriptor;
            }
            // Recursive search up each ref's prototype
            for (const ref of refs){
                const childRefs = ref.value && ref.value[$c1e610bfc2557356$var$Refs];
                if (!childRefs) continue;
                const queue = childRefs.slice();
                while(queue.length){
                    const ref = queue.shift();
                    const descriptor = $c1e610bfc2557356$var$getDescriptor(ref.value, key);
                    if (descriptor) return descriptor;
                    const childRefs = ref.value && ref.value[$c1e610bfc2557356$var$Refs];
                    if (childRefs) queue.push(...childRefs);
                }
            }
            return undefined;
        }
    });
}







const $9208258024e22101$export$d914c5b32001cb2e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    // TODO
    // disableKeys: Boolean,
    id: String,
    submenu: Boolean,
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $0eb6b57fb5d95344$export$357b25d59a7fb3fa)({
        captureFocus: true,
        closeDelay: 250,
        closeOnContentClick: true,
        locationStrategy: 'connected',
        location: undefined,
        openDelay: 300,
        scrim: false,
        scrollStrategy: 'reposition',
        transition: {
            component: (0, $6d83cccc3a7f7c51$export$9778a08df954f36c)
        }
    }), [
        'absolute'
    ])
}, 'VMenu');
const $9208258024e22101$export$a347888d6b8f252a = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VMenu',
    props: $9208258024e22101$export$d914c5b32001cb2e(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { scopeId: scopeId } = (0, $d897445671465531$export$eeabe5cda932100d)();
        const { isRtl: isRtl } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const uid = (0, $TusQn.useId)();
        const id = (0, $01W3b.toRef)(()=>props.id || `v-menu-${uid}`);
        const overlay = (0, $01W3b.ref)();
        const parent = (0, $TusQn.inject)((0, $b8a1247336888f38$export$d60452ec716149a1), null);
        const openChildren = (0, $01W3b.shallowRef)(new Set());
        (0, $TusQn.provide)((0, $b8a1247336888f38$export$d60452ec716149a1), {
            register () {
                openChildren.value.add(uid);
            },
            unregister () {
                openChildren.value.delete(uid);
            },
            closeParents (e) {
                setTimeout(()=>{
                    if (!openChildren.value.size && !props.persistent && (e == null || overlay.value?.contentEl && !(0, $8590040a7833369a$export$4430641350aec15f)(e, overlay.value.contentEl))) {
                        isActive.value = false;
                        parent?.closeParents();
                    }
                }, 40);
            }
        });
        (0, $TusQn.onBeforeUnmount)(()=>parent?.unregister());
        (0, $TusQn.onDeactivated)(()=>isActive.value = false);
        (0, $01W3b.watch)(isActive, (val)=>{
            val ? parent?.register() : parent?.unregister();
        }, {
            immediate: true
        });
        function onClickOutside(e) {
            parent?.closeParents(e);
        }
        function onKeydown(e) {
            if (props.disabled) return;
            if (e.key === 'Tab' || e.key === 'Enter' && !props.closeOnContentClick) {
                if (e.key === 'Enter' && (e.target instanceof HTMLTextAreaElement || e.target instanceof HTMLInputElement && !!e.target.closest('form'))) return;
                if (e.key === 'Enter') e.preventDefault();
                const nextElement = (0, $8590040a7833369a$export$4109ed81edd7716d)((0, $8590040a7833369a$export$aea49dace3f6ca76)(overlay.value?.contentEl, false), e.shiftKey ? 'prev' : 'next', (el)=>el.tabIndex >= 0);
                if (!nextElement && !props.retainFocus) {
                    isActive.value = false;
                    overlay.value?.activatorEl?.focus();
                }
            } else if (props.submenu && e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) {
                isActive.value = false;
                overlay.value?.activatorEl?.focus();
            }
        }
        function onActivatorKeydown(e) {
            if (props.disabled) return;
            const el = overlay.value?.contentEl;
            if (el && isActive.value) {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    (0, $8590040a7833369a$export$da2eafa20d5ebba)(el, 'next');
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    (0, $8590040a7833369a$export$da2eafa20d5ebba)(el, 'prev');
                } else if (props.submenu) {
                    if (e.key === (isRtl.value ? 'ArrowRight' : 'ArrowLeft')) isActive.value = false;
                    else if (e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight')) {
                        e.preventDefault();
                        (0, $8590040a7833369a$export$da2eafa20d5ebba)(el, 'first');
                    }
                }
            } else if (props.submenu ? e.key === (isRtl.value ? 'ArrowLeft' : 'ArrowRight') : [
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) {
                isActive.value = true;
                e.preventDefault();
                setTimeout(()=>setTimeout(()=>onActivatorKeydown(e)));
            }
        }
        const activatorProps = (0, $01W3b.computed)(()=>(0, $TusQn.mergeProps)({
                'aria-haspopup': 'menu',
                'aria-expanded': String(isActive.value),
                'aria-controls': id.value,
                'aria-owns': id.value,
                onKeydown: onActivatorKeydown
            }, props.activatorProps));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const overlayProps = (0, $0eb6b57fb5d95344$export$32caf7e8170352aa).filterProps(props);
            return (0, $TusQn.createVNode)((0, $0eb6b57fb5d95344$export$32caf7e8170352aa), (0, $TusQn.mergeProps)({
                "ref": overlay,
                "id": id.value,
                "class": [
                    'v-menu',
                    props.class
                ],
                "style": props.style
            }, overlayProps, {
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "absolute": true,
                "activatorProps": activatorProps.value,
                "location": props.location ?? (props.submenu ? 'end' : 'bottom'),
                "onClick:outside": onClickOutside,
                "onKeydown": onKeydown
            }, scopeId), {
                activator: slots.activator,
                default: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                        "root": "VMenu"
                    }, {
                        default: ()=>[
                                slots.default?.(...args)
                            ]
                    });
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({
            id: id,
            \u03A8openChildren: openChildren
        }, overlay);
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");











parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");












const $ce059966358db8b1$export$a0ee5621cbdcc362 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $636e88b893afba47$export$2831add577f947cb)(),
    ...(0, $572b8e75d6c9689d$export$f84374c9369ae887)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VSheet');
const $ce059966358db8b1$export$d41b26ce18186ef0 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSheet',
    props: $ce059966358db8b1$export$a0ee5621cbdcc362(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { locationStyles: locationStyles } = (0, $636e88b893afba47$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $572b8e75d6c9689d$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-sheet',
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ])
            }, slots));
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
var $8POXm = parcelRequire("8POXm");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
var $eeJ70 = parcelRequire("eeJ70");





const $b240aced8b361832$export$499a42a6fe2c0ed3 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    active: Boolean,
    disabled: Boolean,
    max: [
        Number,
        String
    ],
    value: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e)({
        transition: {
            component: (0, $7ec1b0ef33b04126$export$5d9f875feb4d9ee6)
        }
    })
}, 'VCounter');
const $b240aced8b361832$export$45efeae449ff2094 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCounter',
    functional: true,
    props: $b240aced8b361832$export$499a42a6fe2c0ed3(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const counter = (0, $01W3b.toRef)(()=>{
            return props.max ? `${props.value} / ${props.max}` : String(props.value);
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                "transition": props.transition
            }, {
                default: ()=>[
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                            "class": (0, $8POXm.normalizeClass)([
                                'v-counter',
                                {
                                    'text-error': props.max && !props.disabled && parseFloat(props.value) > parseFloat(props.max)
                                },
                                props.class
                            ]),
                            "style": (0, $8POXm.normalizeStyle)(props.style)
                        }, [
                            slots.default ? slots.default({
                                counter: counter.value,
                                max: props.max,
                                value: props.value
                            }) : counter.value
                        ]), [
                            [
                                (0, $eeJ70.vShow),
                                props.active
                            ]
                        ])
                    ]
            }));
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



const $17964605b7b058af$export$5951acb17a4319b2 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    floating: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VFieldLabel');
const $17964605b7b058af$export$1a74b2f7ba75e1db = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VFieldLabel',
    props: $17964605b7b058af$export$5951acb17a4319b2(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)((0, $e23bfa10b64d3f5e$export$90281af35207eb21), {
                "class": (0, $8POXm.normalizeClass)([
                    'v-field-label',
                    {
                        'v-field-label--floating': props.floating
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, slots));
        return {};
    }
});







// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $fdb5f7d63722b03f$export$676d4e684e4b0e1e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    focused: Boolean,
    'onUpdate:focused': (0, $8590040a7833369a$export$cefab237a347bf23)()
}, 'focus');
function $fdb5f7d63722b03f$export$f8168d8dd8fd66e6(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    const isFocused = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'focused');
    const focusClasses = (0, $01W3b.toRef)(()=>{
        return {
            [`${name}--focused`]: isFocused.value
        };
    });
    function focus() {
        isFocused.value = true;
    }
    function blur() {
        isFocused.value = false;
    }
    return {
        focusClasses: focusClasses,
        isFocused: isFocused,
        focus: focus,
        blur: blur
    };
}








const $d4f131cf7ef9c4a9$var$allowedVariants = [
    'underlined',
    'outlined',
    'filled',
    'solo',
    'solo-inverted',
    'solo-filled',
    'plain'
];
const $d4f131cf7ef9c4a9$export$1e13429dc53b9634 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    appendInnerIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    bgColor: String,
    clearable: Boolean,
    clearIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$clear'
    },
    active: Boolean,
    centerAffix: {
        type: Boolean,
        default: undefined
    },
    color: String,
    baseColor: String,
    dirty: Boolean,
    disabled: {
        type: Boolean,
        default: null
    },
    glow: Boolean,
    error: Boolean,
    flat: Boolean,
    iconColor: [
        Boolean,
        String
    ],
    label: String,
    persistentClear: Boolean,
    prependInnerIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    reverse: Boolean,
    singleLine: Boolean,
    variant: {
        type: String,
        default: 'filled',
        validator: (v)=>$d4f131cf7ef9c4a9$var$allowedVariants.includes(v)
    },
    'onClick:clear': (0, $8590040a7833369a$export$cefab237a347bf23)(),
    'onClick:appendInner': (0, $8590040a7833369a$export$cefab237a347bf23)(),
    'onClick:prependInner': (0, $8590040a7833369a$export$cefab237a347bf23)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $aec6311fd012b86e$export$149f04e0cba4dbc1)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VField');
const $d4f131cf7ef9c4a9$export$3180fb4997e9f72d = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VField',
    inheritAttrs: false,
    props: {
        id: String,
        details: Boolean,
        labelId: String,
        ...(0, $fdb5f7d63722b03f$export$676d4e684e4b0e1e)(),
        ...$d4f131cf7ef9c4a9$export$1e13429dc53b9634()
    },
    emits: {
        'update:focused': (focused)=>true,
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { loaderClasses: loaderClasses } = (0, $aec6311fd012b86e$export$14095de704efe3f9)(props);
        const { focusClasses: focusClasses, isFocused: isFocused, focus: focus, blur: blur } = (0, $fdb5f7d63722b03f$export$f8168d8dd8fd66e6)(props);
        const { InputIcon: InputIcon } = (0, $9a9409ba39d4a5b8$export$d08cb507a9c34d4b)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const isActive = (0, $01W3b.toRef)(()=>props.dirty || props.active);
        const hasLabel = (0, $01W3b.toRef)(()=>!!(props.label || slots.label));
        const hasFloatingLabel = (0, $01W3b.toRef)(()=>!props.singleLine && hasLabel.value);
        const uid = (0, $TusQn.useId)();
        const id = (0, $01W3b.computed)(()=>props.id || `input-${uid}`);
        const messagesId = (0, $01W3b.toRef)(()=>!props.details ? undefined : `${id.value}-messages`);
        const labelRef = (0, $01W3b.ref)();
        const floatingLabelRef = (0, $01W3b.ref)();
        const controlRef = (0, $01W3b.ref)();
        const isPlainOrUnderlined = (0, $01W3b.computed)(()=>[
                'plain',
                'underlined'
            ].includes(props.variant));
        const color = (0, $01W3b.computed)(()=>{
            return props.error || props.disabled ? undefined : isActive.value && isFocused.value ? props.color : props.baseColor;
        });
        const iconColor = (0, $01W3b.computed)(()=>{
            if (!props.iconColor || props.glow && !isFocused.value) return undefined;
            return props.iconColor === true ? color.value : props.iconColor;
        });
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(color);
        (0, $01W3b.watch)(isActive, (val)=>{
            if (hasFloatingLabel.value && !(0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)()) {
                const el = labelRef.value.$el;
                const targetEl = floatingLabelRef.value.$el;
                requestAnimationFrame(()=>{
                    const rect = (0, $d14b85b5564a2ed0$export$38c5b68336448fc8)(el);
                    const targetRect = targetEl.getBoundingClientRect();
                    const x = targetRect.x - rect.x;
                    const y = targetRect.y - rect.y - (rect.height / 2 - targetRect.height / 2);
                    const targetWidth = targetRect.width / 0.75;
                    const width = Math.abs(targetWidth - rect.width) > 1 ? {
                        maxWidth: (0, $8590040a7833369a$export$286ad215293a0860)(targetWidth)
                    } : undefined;
                    const style = getComputedStyle(el);
                    const targetStyle = getComputedStyle(targetEl);
                    const duration = parseFloat(style.transitionDuration) * 1000 || 150;
                    const scale = parseFloat(targetStyle.getPropertyValue('--v-field-label-scale'));
                    const color = targetStyle.getPropertyValue('color');
                    el.style.visibility = 'visible';
                    targetEl.style.visibility = 'hidden';
                    (0, $d14b85b5564a2ed0$export$e3607ec2d7a891c4)(el, {
                        transform: `translate(${x}px, ${y}px) scale(${scale})`,
                        color: color,
                        ...width
                    }, {
                        duration: duration,
                        easing: (0, $f725c9134abb2fa7$export$bf86e2ccec972a06),
                        direction: val ? 'normal' : 'reverse'
                    }).finished.then(()=>{
                        el.style.removeProperty('visibility');
                        targetEl.style.removeProperty('visibility');
                    });
                });
            }
        }, {
            flush: 'post'
        });
        const slotProps = (0, $01W3b.computed)(()=>({
                isActive: isActive,
                isFocused: isFocused,
                controlRef: controlRef,
                iconColor: iconColor,
                blur: blur,
                focus: focus
            }));
        const floatingLabelProps = (0, $01W3b.toRef)(()=>{
            const ariaHidden = !isActive.value;
            return {
                'aria-hidden': ariaHidden,
                for: ariaHidden ? undefined : id.value
            };
        });
        const mainLabelProps = (0, $01W3b.toRef)(()=>{
            const ariaHidden = hasFloatingLabel.value && isActive.value;
            return {
                'aria-hidden': ariaHidden,
                for: ariaHidden ? undefined : id.value
            };
        });
        function onClick(e) {
            if (e.target !== document.activeElement) e.preventDefault();
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const isOutlined = props.variant === 'outlined';
            const hasPrepend = !!(slots['prepend-inner'] || props.prependInnerIcon);
            const hasClear = !!(props.clearable || slots.clear) && !props.disabled;
            const hasAppend = !!(slots['append-inner'] || props.appendInnerIcon || hasClear);
            const label = ()=>slots.label ? slots.label({
                    ...slotProps.value,
                    label: props.label,
                    props: {
                        for: id.value
                    }
                }) : props.label;
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "class": [
                    'v-field',
                    {
                        'v-field--active': isActive.value,
                        'v-field--appended': hasAppend,
                        'v-field--center-affix': props.centerAffix ?? !isPlainOrUnderlined.value,
                        'v-field--disabled': props.disabled,
                        'v-field--dirty': props.dirty,
                        'v-field--error': props.error,
                        'v-field--glow': props.glow,
                        'v-field--flat': props.flat,
                        'v-field--has-background': !!props.bgColor,
                        'v-field--persistent-clear': props.persistentClear,
                        'v-field--prepended': hasPrepend,
                        'v-field--reverse': props.reverse,
                        'v-field--single-line': props.singleLine,
                        'v-field--no-label': !label(),
                        [`v-field--variant-${props.variant}`]: true
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    focusClasses.value,
                    loaderClasses.value,
                    roundedClasses.value,
                    rtlClasses.value,
                    props.class
                ],
                "style": [
                    backgroundColorStyles.value,
                    props.style
                ],
                "onClick": onClick
            }, attrs), [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-field__overlay"
                }, null),
                (0, $TusQn.createVNode)((0, $aec6311fd012b86e$export$9a5d46a3538da529), {
                    "name": "v-field",
                    "active": !!props.loading,
                    "color": props.error ? 'error' : typeof props.loading === 'string' ? props.loading : props.color
                }, {
                    default: slots.loader
                }),
                hasPrepend && (0, $TusQn.createElementVNode)("div", {
                    "key": "prepend",
                    "class": "v-field__prepend-inner"
                }, [
                    slots['prepend-inner'] ? slots['prepend-inner'](slotProps.value) : props.prependInnerIcon && (0, $TusQn.createVNode)(InputIcon, {
                        "key": "prepend-icon",
                        "name": "prependInner",
                        "color": iconColor.value
                    }, null)
                ]),
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-field__field",
                    "data-no-activator": ""
                }, [
                    [
                        'filled',
                        'solo',
                        'solo-inverted',
                        'solo-filled'
                    ].includes(props.variant) && hasFloatingLabel.value && (0, $TusQn.createVNode)((0, $17964605b7b058af$export$1a74b2f7ba75e1db), (0, $TusQn.mergeProps)({
                        "key": "floating-label",
                        "ref": floatingLabelRef,
                        "class": [
                            textColorClasses.value
                        ],
                        "floating": true
                    }, floatingLabelProps.value, {
                        "style": textColorStyles.value
                    }), {
                        default: ()=>[
                                label()
                            ]
                    }),
                    hasLabel.value && (0, $TusQn.createVNode)((0, $17964605b7b058af$export$1a74b2f7ba75e1db), (0, $TusQn.mergeProps)({
                        "key": "label",
                        "ref": labelRef,
                        "id": props.labelId
                    }, mainLabelProps.value), {
                        default: ()=>[
                                label()
                            ]
                    }),
                    slots.default?.({
                        ...slotProps.value,
                        props: {
                            id: id.value,
                            class: 'v-field__input',
                            'aria-describedby': messagesId.value
                        },
                        focus: focus,
                        blur: blur
                    }) ?? (0, $TusQn.createElementVNode)("div", {
                        "id": id.value,
                        "class": "v-field__input",
                        "aria-describedby": messagesId.value
                    }, null)
                ]),
                hasClear && (0, $TusQn.createVNode)((0, $7ec1b0ef33b04126$export$d54edbcba7869f36), {
                    "key": "clear"
                }, {
                    default: ()=>[
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                                "class": "v-field__clearable",
                                "onMousedown": (e)=>{
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            }, [
                                (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                    "defaults": {
                                        VIcon: {
                                            icon: props.clearIcon
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slots.clear ? slots.clear({
                                                ...slotProps.value,
                                                props: {
                                                    onFocus: focus,
                                                    onBlur: blur,
                                                    onClick: props['onClick:clear'],
                                                    tabindex: -1
                                                }
                                            }) : (0, $TusQn.createVNode)(InputIcon, {
                                                "name": "clear",
                                                "onFocus": focus,
                                                "onBlur": blur,
                                                "tabindex": -1
                                            }, null)
                                        ]
                                })
                            ]), [
                                [
                                    (0, $eeJ70.vShow),
                                    props.dirty
                                ]
                            ])
                        ]
                }),
                hasAppend && (0, $TusQn.createElementVNode)("div", {
                    "key": "append",
                    "class": "v-field__append-inner"
                }, [
                    slots['append-inner'] ? slots['append-inner'](slotProps.value) : props.appendInnerIcon && (0, $TusQn.createVNode)(InputIcon, {
                        "key": "append-icon",
                        "name": "appendInner",
                        "color": iconColor.value
                    }, null)
                ]),
                (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-field__outline',
                        textColorClasses.value
                    ]),
                    "style": (0, $8POXm.normalizeStyle)(textColorStyles.value)
                }, [
                    isOutlined && (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-field__outline__start"
                        }, null),
                        hasFloatingLabel.value && (0, $TusQn.createElementVNode)("div", {
                            "class": "v-field__outline__notch"
                        }, [
                            (0, $TusQn.createVNode)((0, $17964605b7b058af$export$1a74b2f7ba75e1db), (0, $TusQn.mergeProps)({
                                "ref": floatingLabelRef,
                                "floating": true
                            }, floatingLabelProps.value), {
                                default: ()=>[
                                        label()
                                    ]
                            })
                        ]),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-field__outline__end"
                        }, null)
                    ]),
                    isPlainOrUnderlined.value && hasFloatingLabel.value && (0, $TusQn.createVNode)((0, $17964605b7b058af$export$1a74b2f7ba75e1db), (0, $TusQn.mergeProps)({
                        "ref": floatingLabelRef,
                        "floating": true
                    }, floatingLabelProps.value), {
                        default: ()=>[
                                label()
                            ]
                    })
                ])
            ]);
        });
        return {
            controlRef: controlRef,
            fieldIconColor: iconColor
        };
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");






const $95c386a7139dfc13$export$79b8b232ea22263 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    active: Boolean,
    color: String,
    messages: {
        type: [
            Array,
            String
        ],
        default: ()=>[]
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e)({
        transition: {
            component: (0, $7ec1b0ef33b04126$export$5d9f875feb4d9ee6),
            leaveAbsolute: true,
            group: true
        }
    })
}, 'VMessages');
const $95c386a7139dfc13$export$31afdc787fe64f1d = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VMessages',
    props: $95c386a7139dfc13$export$79b8b232ea22263(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const messages = (0, $01W3b.computed)(()=>(0, $8590040a7833369a$export$76411cac38121ecb)(props.messages));
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.color);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                "transition": props.transition,
                "tag": "div",
                "class": (0, $8POXm.normalizeClass)([
                    'v-messages',
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    textColorStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        props.active && messages.value.map((message, i)=>(0, $TusQn.createElementVNode)("div", {
                                "class": "v-messages__message",
                                "key": `${i}-${messages.value}`
                            }, [
                                slots.message ? slots.message({
                                    message: message
                                }) : message
                            ]))
                    ]
            }));
        return {};
    }
});








// Composables

// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $72bfe1fa0cde9e24$export$cf3347e5e7e1bef5 = Symbol.for('vuetify:form');
const $72bfe1fa0cde9e24$export$be046af95b8d4645 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    disabled: Boolean,
    fastFail: Boolean,
    readonly: Boolean,
    modelValue: {
        type: Boolean,
        default: null
    },
    validateOn: {
        type: String,
        default: 'input'
    }
}, 'form');
function $72bfe1fa0cde9e24$export$f681a8129d2e9d28(props) {
    const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
    const isDisabled = (0, $01W3b.toRef)(()=>props.disabled);
    const isReadonly = (0, $01W3b.toRef)(()=>props.readonly);
    const isValidating = (0, $01W3b.shallowRef)(false);
    const items = (0, $01W3b.ref)([]);
    const errors = (0, $01W3b.ref)([]);
    async function validate() {
        const results = [];
        let valid = true;
        errors.value = [];
        isValidating.value = true;
        for (const item of items.value){
            const itemErrorMessages = await item.validate();
            if (itemErrorMessages.length > 0) {
                valid = false;
                results.push({
                    id: item.id,
                    errorMessages: itemErrorMessages
                });
            }
            if (!valid && props.fastFail) break;
        }
        errors.value = results;
        isValidating.value = false;
        return {
            valid: valid,
            errors: errors.value
        };
    }
    function reset() {
        items.value.forEach((item)=>item.reset());
    }
    function resetValidation() {
        items.value.forEach((item)=>item.resetValidation());
    }
    (0, $01W3b.watch)(items, ()=>{
        let valid = 0;
        let invalid = 0;
        const results = [];
        for (const item of items.value){
            if (item.isValid === false) {
                invalid++;
                results.push({
                    id: item.id,
                    errorMessages: item.errorMessages
                });
            } else if (item.isValid === true) valid++;
        }
        errors.value = results;
        model.value = invalid > 0 ? false : valid === items.value.length ? true : null;
    }, {
        deep: true,
        flush: 'post'
    });
    (0, $TusQn.provide)($72bfe1fa0cde9e24$export$cf3347e5e7e1bef5, {
        register: (_ref)=>{
            let { id: id, vm: vm, validate: validate, reset: reset, resetValidation: resetValidation } = _ref;
            if (items.value.some((item)=>item.id === id)) (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`Duplicate input name "${id}"`);
            items.value.push({
                id: id,
                validate: validate,
                reset: reset,
                resetValidation: resetValidation,
                vm: (0, $01W3b.markRaw)(vm),
                isValid: null,
                errorMessages: []
            });
        },
        unregister: (id)=>{
            items.value = items.value.filter((item)=>{
                return item.id !== id;
            });
        },
        update: (id, isValid, errorMessages)=>{
            const found = items.value.find((item)=>item.id === id);
            if (!found) return;
            found.isValid = isValid;
            found.errorMessages = errorMessages;
        },
        isDisabled: isDisabled,
        isReadonly: isReadonly,
        isValidating: isValidating,
        isValid: model,
        items: items,
        validateOn: (0, $01W3b.toRef)(()=>props.validateOn)
    });
    return {
        errors: errors,
        isDisabled: isDisabled,
        isReadonly: isReadonly,
        isValidating: isValidating,
        isValid: model,
        items: items,
        validate: validate,
        reset: reset,
        resetValidation: resetValidation
    };
}
function $72bfe1fa0cde9e24$export$87c0cf8eb5a167e0(props) {
    const form = (0, $TusQn.inject)($72bfe1fa0cde9e24$export$cf3347e5e7e1bef5, null);
    return {
        ...form,
        isReadonly: (0, $01W3b.computed)(()=>!!(props?.readonly ?? form?.isReadonly.value)),
        isDisabled: (0, $01W3b.computed)(()=>!!(props?.disabled ?? form?.isDisabled.value))
    };
}




// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
function $7d51d107f42d2e03$export$826a84970f4c98e0(options, locale) {
    const { t: t } = locale;
    const aliases = {
        required: (err)=>{
            return (v)=>{
                // If the modifier .number is used, the 0 will be a number and it's a falsy value so we need to check for it
                return v === 0 || !!v || t(err || '$vuetify.rules.required');
            };
        },
        email: (err)=>{
            return (v)=>!v || typeof v === 'string' && /^.+@\S+\.\S+$/.test(v) || t(err || '$vuetify.rules.email');
        },
        number: (err)=>{
            return (v)=>!v || !isNaN(Number(v)) || t(err || '$vuetify.rules.number');
        },
        integer: (err)=>{
            return (v)=>/^[\d]*$/.test(v) || t(err || '$vuetify.rules.integer');
        },
        capital: (err)=>{
            return (v)=>/^[A-Z]*$/.test(v) || t(err || '$vuetify.rules.capital');
        },
        maxLength: (len, err)=>{
            return (v)=>!v || v.length <= len || t(err || '$vuetify.rules.maxLength', len);
        },
        minLength: (len, err)=>{
            return (v)=>!v || v.length >= len || t(err || '$vuetify.rules.minLength', len);
        },
        strictLength: (len, err)=>{
            return (v)=>!v || v.length === len || t(err || '$vuetify.rules.strictLength', len);
        },
        exclude: (forbiddenCharacters, err)=>{
            return (v)=>{
                let error = true;
                for (const character of forbiddenCharacters)if (v.includes(character)) error = err || t('$vuetify.rules.exclude', character);
                return error;
            };
        },
        notEmpty: (err)=>{
            return (v)=>v && v.length > 0 || t(err || '$vuetify.rules.notEmpty');
        },
        pattern: (pattern, err)=>{
            return (v)=>!v || pattern.test(v) || t(err || '$vuetify.rules.pattern');
        },
        ...options?.aliases
    };
    function resolve(fn) {
        return (0, $01W3b.computed)(()=>fn().map((rule)=>{
                let ruleName = null;
                let ruleParams = [
                    undefined
                ];
                if (Array.isArray(rule)) {
                    ruleName = rule[0];
                    ruleParams = rule.slice(1);
                } else if (typeof rule === 'string') ruleName = rule;
                if (ruleName !== null) {
                    if (ruleName.startsWith('$')) ruleName = ruleName.slice(1);
                    return aliases[ruleName]?.(...ruleParams);
                } else return rule;
            }));
    }
    return {
        resolve: resolve,
        aliases: aliases
    };
}
const $7d51d107f42d2e03$export$51fa63c9ca80112b = Symbol.for('vuetify:rules');
function $7d51d107f42d2e03$export$806b060f31753ef2(fn) {
    const rules = (0, $TusQn.inject)($7d51d107f42d2e03$export$51fa63c9ca80112b, null);
    if (!fn) {
        if (!rules) throw new Error('Could not find Vuetify rules injection');
        return rules.aliases;
    }
    return rules?.resolve(fn) ?? (0, $01W3b.toRef)(fn);
}


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $d31a46cb498bdea9$export$42513dbc731a0133 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    disabled: {
        type: Boolean,
        default: null
    },
    error: Boolean,
    errorMessages: {
        type: [
            Array,
            String
        ],
        default: ()=>[]
    },
    maxErrors: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    name: String,
    label: String,
    readonly: {
        type: Boolean,
        default: null
    },
    rules: {
        type: Array,
        default: ()=>[]
    },
    modelValue: null,
    validateOn: String,
    validationValue: null,
    ...(0, $fdb5f7d63722b03f$export$676d4e684e4b0e1e)()
}, 'validation');
function $d31a46cb498bdea9$export$87fe492f99f25a20(props) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $b65c26e77f158b6f$export$8adb83c1b7a9d7ae)();
    let id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, $TusQn.useId)();
    const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
    const validationModel = (0, $01W3b.computed)(()=>props.validationValue === undefined ? model.value : props.validationValue);
    const form = (0, $72bfe1fa0cde9e24$export$87c0cf8eb5a167e0)(props);
    const rules = (0, $7d51d107f42d2e03$export$806b060f31753ef2)(()=>props.rules);
    const internalErrorMessages = (0, $01W3b.ref)([]);
    const isPristine = (0, $01W3b.shallowRef)(true);
    const isDirty = (0, $01W3b.computed)(()=>!!((0, $8590040a7833369a$export$76411cac38121ecb)(model.value === '' ? null : model.value).length || (0, $8590040a7833369a$export$76411cac38121ecb)(validationModel.value === '' ? null : validationModel.value).length));
    const errorMessages = (0, $01W3b.computed)(()=>{
        return props.errorMessages?.length ? (0, $8590040a7833369a$export$76411cac38121ecb)(props.errorMessages).concat(internalErrorMessages.value).slice(0, Math.max(0, Number(props.maxErrors))) : internalErrorMessages.value;
    });
    const validateOn = (0, $01W3b.computed)(()=>{
        let value = (props.validateOn ?? form.validateOn?.value) || 'input';
        if (value === 'lazy') value = 'input lazy';
        if (value === 'eager') value = 'input eager';
        const set = new Set(value?.split(' ') ?? []);
        return {
            input: set.has('input'),
            blur: set.has('blur') || set.has('input') || set.has('invalid-input'),
            invalidInput: set.has('invalid-input'),
            lazy: set.has('lazy'),
            eager: set.has('eager')
        };
    });
    const isValid = (0, $01W3b.computed)(()=>{
        if (props.error || props.errorMessages?.length) return false;
        if (!props.rules.length) return true;
        if (isPristine.value) return internalErrorMessages.value.length || validateOn.value.lazy ? null : true;
        else return !internalErrorMessages.value.length;
    });
    const isValidating = (0, $01W3b.shallowRef)(false);
    const validationClasses = (0, $01W3b.computed)(()=>{
        return {
            [`${name}--error`]: isValid.value === false,
            [`${name}--dirty`]: isDirty.value,
            [`${name}--disabled`]: form.isDisabled.value,
            [`${name}--readonly`]: form.isReadonly.value
        };
    });
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('validation');
    const uid = (0, $01W3b.computed)(()=>props.name ?? (0, $01W3b.unref)(id));
    (0, $TusQn.onBeforeMount)(()=>{
        form.register?.({
            id: uid.value,
            vm: vm,
            validate: validate,
            reset: reset,
            resetValidation: resetValidation
        });
    });
    (0, $TusQn.onBeforeUnmount)(()=>{
        form.unregister?.(uid.value);
    });
    (0, $TusQn.onMounted)(async ()=>{
        if (!validateOn.value.lazy) await validate(!validateOn.value.eager);
        form.update?.(uid.value, isValid.value, errorMessages.value);
    });
    (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>validateOn.value.input || validateOn.value.invalidInput && isValid.value === false, ()=>{
        (0, $01W3b.watch)(validationModel, ()=>{
            if (validationModel.value != null) validate();
            else if (props.focused) {
                const unwatch = (0, $01W3b.watch)(()=>props.focused, (val)=>{
                    if (!val) validate();
                    unwatch();
                });
            }
        });
    });
    (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>validateOn.value.blur, ()=>{
        (0, $01W3b.watch)(()=>props.focused, (val)=>{
            if (!val) validate();
        });
    });
    (0, $01W3b.watch)([
        isValid,
        errorMessages
    ], ()=>{
        form.update?.(uid.value, isValid.value, errorMessages.value);
    });
    async function reset() {
        model.value = null;
        await (0, $TusQn.nextTick)();
        await resetValidation();
    }
    async function resetValidation() {
        isPristine.value = true;
        if (!validateOn.value.lazy) await validate(!validateOn.value.eager);
        else internalErrorMessages.value = [];
    }
    async function validate() {
        let silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        const results = [];
        isValidating.value = true;
        for (const rule of rules.value){
            if (results.length >= Number(props.maxErrors ?? 1)) break;
            const handler = typeof rule === 'function' ? rule : ()=>rule;
            const result = await handler(validationModel.value);
            if (result === true) continue;
            if (result !== false && typeof result !== 'string') {
                // eslint-disable-next-line no-console
                console.warn(`${result} is not a valid value. Rule functions must return boolean true or a string.`);
                continue;
            }
            results.push(result || '');
        }
        internalErrorMessages.value = results;
        isValidating.value = false;
        isPristine.value = silent;
        return internalErrorMessages.value;
    }
    return {
        errorMessages: errorMessages,
        isDirty: isDirty,
        isDisabled: form.isDisabled,
        isReadonly: form.isReadonly,
        isPristine: isPristine,
        isValid: isValid,
        isValidating: isValidating,
        reset: reset,
        resetValidation: resetValidation,
        validate: validate,
        validationClasses: validationClasses
    };
}



const $97e8c489e405a584$export$525655a73981d616 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    id: String,
    appendIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    baseColor: String,
    centerAffix: {
        type: Boolean,
        default: true
    },
    color: String,
    glow: Boolean,
    iconColor: [
        Boolean,
        String
    ],
    prependIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    hideDetails: [
        Boolean,
        String
    ],
    hideSpinButtons: Boolean,
    hint: String,
    persistentHint: Boolean,
    messages: {
        type: [
            Array,
            String
        ],
        default: ()=>[]
    },
    direction: {
        type: String,
        default: 'horizontal',
        validator: (v)=>[
                'horizontal',
                'vertical'
            ].includes(v)
    },
    'onClick:prepend': (0, $8590040a7833369a$export$cefab237a347bf23)(),
    'onClick:append': (0, $8590040a7833369a$export$cefab237a347bf23)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $159635b8c4ce014b$export$f37f46640cc8dd75)(), [
        'maxWidth',
        'minWidth',
        'width'
    ]),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $d31a46cb498bdea9$export$42513dbc731a0133)()
}, 'VInput');
const $97e8c489e405a584$export$2aca538d9f87f6ac = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VInput',
    props: {
        ...$97e8c489e405a584$export$525655a73981d616()
    },
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots, emit: emit } = _ref;
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const { InputIcon: InputIcon } = (0, $9a9409ba39d4a5b8$export$d08cb507a9c34d4b)(props);
        const uid = (0, $TusQn.useId)();
        const id = (0, $01W3b.computed)(()=>props.id || `input-${uid}`);
        const { errorMessages: errorMessages, isDirty: isDirty, isDisabled: isDisabled, isReadonly: isReadonly, isPristine: isPristine, isValid: isValid, isValidating: isValidating, reset: reset, resetValidation: resetValidation, validate: validate, validationClasses: validationClasses } = (0, $d31a46cb498bdea9$export$87fe492f99f25a20)(props, 'v-input', id);
        const messages = (0, $01W3b.computed)(()=>{
            if (props.errorMessages?.length || !isPristine.value && errorMessages.value.length) return errorMessages.value;
            else if (props.hint && (props.persistentHint || props.focused)) return props.hint;
            else return props.messages;
        });
        const hasMessages = (0, $01W3b.toRef)(()=>messages.value.length > 0);
        const hasDetails = (0, $01W3b.toRef)(()=>!props.hideDetails || props.hideDetails === 'auto' && (hasMessages.value || !!slots.details));
        const messagesId = (0, $01W3b.computed)(()=>hasDetails.value ? `${id.value}-messages` : undefined);
        const slotProps = (0, $01W3b.computed)(()=>({
                id: id,
                messagesId: messagesId,
                isDirty: isDirty,
                isDisabled: isDisabled,
                isReadonly: isReadonly,
                isPristine: isPristine,
                isValid: isValid,
                isValidating: isValidating,
                hasDetails: hasDetails,
                reset: reset,
                resetValidation: resetValidation,
                validate: validate
            }));
        const color = (0, $01W3b.toRef)(()=>{
            return props.error || props.disabled ? undefined : props.focused ? props.color : props.baseColor;
        });
        const iconColor = (0, $01W3b.toRef)(()=>{
            if (!props.iconColor) return undefined;
            return props.iconColor === true ? color.value : props.iconColor;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasPrepend = !!(slots.prepend || props.prependIcon);
            const hasAppend = !!(slots.append || props.appendIcon);
            return (0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-input',
                    `v-input--${props.direction}`,
                    {
                        'v-input--center-affix': props.centerAffix,
                        'v-input--focused': props.focused,
                        'v-input--glow': props.glow,
                        'v-input--hide-spin-buttons': props.hideSpinButtons
                    },
                    densityClasses.value,
                    themeClasses.value,
                    rtlClasses.value,
                    validationClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                hasPrepend && (0, $TusQn.createElementVNode)("div", {
                    "key": "prepend",
                    "class": "v-input__prepend"
                }, [
                    slots.prepend ? slots.prepend(slotProps.value) : props.prependIcon && (0, $TusQn.createVNode)(InputIcon, {
                        "key": "prepend-icon",
                        "name": "prepend",
                        "color": iconColor.value
                    }, null)
                ]),
                slots.default && (0, $TusQn.createElementVNode)("div", {
                    "class": "v-input__control"
                }, [
                    slots.default?.(slotProps.value)
                ]),
                hasAppend && (0, $TusQn.createElementVNode)("div", {
                    "key": "append",
                    "class": "v-input__append"
                }, [
                    slots.append ? slots.append(slotProps.value) : props.appendIcon && (0, $TusQn.createVNode)(InputIcon, {
                        "key": "append-icon",
                        "name": "append",
                        "color": iconColor.value
                    }, null)
                ]),
                hasDetails.value && (0, $TusQn.createElementVNode)("div", {
                    "id": messagesId.value,
                    "class": "v-input__details",
                    "role": "alert",
                    "aria-live": "polite"
                }, [
                    (0, $TusQn.createVNode)((0, $95c386a7139dfc13$export$31afdc787fe64f1d), {
                        "active": hasMessages.value,
                        "messages": messages.value
                    }, {
                        message: slots.message
                    }),
                    slots.details?.(slotProps.value)
                ])
            ]);
        });
        return {
            reset: reset,
            resetValidation: resetValidation,
            validate: validate,
            isValid: isValid,
            errorMessages: errorMessages
        };
    }
});


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $beb849cd8f948406$export$899f6d4fa8e79208 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    autocomplete: String
}, 'autocomplete');
function $beb849cd8f948406$export$1e40b3ca02d92d21(props) {
    const uniqueId = (0, $TusQn.useId)();
    const reloadTrigger = (0, $01W3b.shallowRef)(0);
    const isSuppressing = (0, $01W3b.toRef)(()=>props.autocomplete === 'suppress');
    const fieldName = (0, $01W3b.toRef)(()=>{
        if (!props.name) return undefined;
        return isSuppressing.value ? `${props.name}-${uniqueId}-${reloadTrigger.value}` : props.name;
    });
    const fieldAutocomplete = (0, $01W3b.toRef)(()=>{
        return isSuppressing.value ? 'off' : props.autocomplete;
    });
    return {
        isSuppressing: isSuppressing,
        fieldAutocomplete: fieldAutocomplete,
        fieldName: fieldName,
        update: ()=>reloadTrigger.value = new Date().getTime()
    };
}


function $8b87581f7b79111a$export$a9c05560d717b4fe(props) {
    function onIntersect(isIntersecting, entries) {
        if (!props.autofocus || !isIntersecting) return;
        const el = entries[0].target;
        const target = el.matches('input,textarea') ? el : el.querySelector('input,textarea');
        target?.focus();
    }
    return {
        onIntersect: onIntersect
    };
}







const $1df180b07e489866$var$activeTypes = [
    'color',
    'file',
    'time',
    'date',
    'datetime-local',
    'week',
    'month'
];
const $1df180b07e489866$export$c9f7484641b0b190 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    autofocus: Boolean,
    counter: [
        Boolean,
        Number,
        String
    ],
    counterValue: [
        Number,
        Function
    ],
    prefix: String,
    placeholder: String,
    persistentPlaceholder: Boolean,
    persistentCounter: Boolean,
    suffix: String,
    role: String,
    type: {
        type: String,
        default: 'text'
    },
    modelModifiers: Object,
    ...(0, $beb849cd8f948406$export$899f6d4fa8e79208)(),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $97e8c489e405a584$export$525655a73981d616)(), [
        'direction'
    ]),
    ...(0, $d4f131cf7ef9c4a9$export$1e13429dc53b9634)()
}, 'VTextField');
const $1df180b07e489866$export$d591c92dea965c28 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTextField',
    directives: {
        vIntersect: $8d31333abb7bf4e7$export$2e2bcd8739ae039
    },
    inheritAttrs: false,
    props: $1df180b07e489866$export$c9f7484641b0b190(),
    emits: {
        'click:control': (e)=>true,
        'mousedown:control': (e)=>true,
        'update:focused': (focused)=>true,
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', undefined, (v)=>{
            if (Object.is(v, -0)) return '-0';
            return v;
        });
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $fdb5f7d63722b03f$export$f8168d8dd8fd66e6)(props);
        const { onIntersect: onIntersect } = (0, $8b87581f7b79111a$export$a9c05560d717b4fe)(props);
        const counterValue = (0, $01W3b.computed)(()=>{
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : (model.value ?? '').toString().length;
        });
        const max = (0, $01W3b.computed)(()=>{
            if (attrs.maxlength) return attrs.maxlength;
            if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
            return props.counter;
        });
        const isPlainOrUnderlined = (0, $01W3b.computed)(()=>[
                'plain',
                'underlined'
            ].includes(props.variant));
        const vInputRef = (0, $01W3b.ref)();
        const vFieldRef = (0, $01W3b.ref)();
        const inputRef = (0, $01W3b.ref)();
        const autocomplete = (0, $beb849cd8f948406$export$1e40b3ca02d92d21)(props);
        const isActive = (0, $01W3b.computed)(()=>$1df180b07e489866$var$activeTypes.includes(props.type) || props.persistentPlaceholder || isFocused.value || props.active);
        function onFocus() {
            if (autocomplete.isSuppressing.value) autocomplete.update();
            if (!isFocused.value) focus();
            (0, $TusQn.nextTick)(()=>{
                if (inputRef.value !== document.activeElement) inputRef.value?.focus();
            });
        }
        function onControlMousedown(e) {
            emit('mousedown:control', e);
            if (e.target === inputRef.value) return;
            onFocus();
            e.preventDefault();
        }
        function onControlClick(e) {
            emit('click:control', e);
        }
        function onClear(e, reset) {
            e.stopPropagation();
            onFocus();
            (0, $TusQn.nextTick)(()=>{
                reset();
                (0, $8590040a7833369a$export$293b251ea77dc2b7)(props['onClick:clear'], e);
            });
        }
        function onInput(e) {
            const el = e.target;
            if (!(props.modelModifiers?.trim && [
                'text',
                'search',
                'password',
                'tel',
                'url'
            ].includes(props.type))) {
                model.value = el.value;
                return;
            }
            const value = el.value;
            const start = el.selectionStart;
            const end = el.selectionEnd;
            model.value = value;
            (0, $TusQn.nextTick)(()=>{
                let offset = 0;
                if (value.trimStart().length === el.value.length) // #22307 - Whitespace has been removed from the
                // start, offset the caret position to compensate
                offset = value.length - el.value.length;
                if (start != null) el.selectionStart = start - offset;
                if (end != null) el.selectionEnd = end - offset;
            });
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasCounter = !!(slots.counter || props.counter !== false && props.counter != null);
            const hasDetails = !!(hasCounter || slots.details);
            const [rootAttrs, inputAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            const { modelValue: _, ...inputProps } = (0, $97e8c489e405a584$export$2aca538d9f87f6ac).filterProps(props);
            const fieldProps = (0, $d4f131cf7ef9c4a9$export$3180fb4997e9f72d).filterProps(props);
            return (0, $TusQn.createVNode)((0, $97e8c489e405a584$export$2aca538d9f87f6ac), (0, $TusQn.mergeProps)({
                "ref": vInputRef,
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-text-field',
                    {
                        'v-text-field--prefixed': props.prefix,
                        'v-text-field--suffixed': props.suffix,
                        'v-input--plain-underlined': isPlainOrUnderlined.value
                    },
                    props.class
                ],
                "style": props.style
            }, rootAttrs, inputProps, {
                "centerAffix": !isPlainOrUnderlined.value,
                "focused": isFocused.value
            }), {
                ...slots,
                default: (_ref2)=>{
                    let { id: id, isDisabled: isDisabled, isDirty: isDirty, isReadonly: isReadonly, isValid: isValid, hasDetails: hasDetails, reset: reset } = _ref2;
                    return (0, $TusQn.createVNode)((0, $d4f131cf7ef9c4a9$export$3180fb4997e9f72d), (0, $TusQn.mergeProps)({
                        "ref": vFieldRef,
                        "onMousedown": onControlMousedown,
                        "onClick": onControlClick,
                        "onClick:clear": (e)=>onClear(e, reset),
                        "role": props.role
                    }, (0, $8590040a7833369a$export$30a06c8d3562193f)(fieldProps, [
                        'onClick:clear'
                    ]), {
                        "id": id.value,
                        "labelId": `${id.value}-label`,
                        "active": isActive.value || isDirty.value,
                        "dirty": isDirty.value || props.dirty,
                        "disabled": isDisabled.value,
                        "focused": isFocused.value,
                        "details": hasDetails.value,
                        "error": isValid.value === false
                    }), {
                        ...slots,
                        default: (_ref3)=>{
                            let { props: { class: fieldClass, ...slotProps }, controlRef: controlRef } = _ref3;
                            const inputNode = (0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                                "ref": (val)=>inputRef.value = controlRef.value = val,
                                "value": model.value,
                                "onInput": onInput,
                                "autofocus": props.autofocus,
                                "readonly": isReadonly.value,
                                "disabled": isDisabled.value,
                                "name": autocomplete.fieldName.value,
                                "autocomplete": autocomplete.fieldAutocomplete.value,
                                "placeholder": props.placeholder,
                                "size": 1,
                                "role": props.role,
                                "type": props.type,
                                "onFocus": focus,
                                "onBlur": blur,
                                "aria-labelledby": `${id.value}-label`
                            }, slotProps, inputAttrs), null);
                            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                props.prefix && (0, $TusQn.createElementVNode)("span", {
                                    "class": "v-text-field__prefix"
                                }, [
                                    (0, $TusQn.createElementVNode)("span", {
                                        "class": "v-text-field__prefix__text"
                                    }, [
                                        props.prefix
                                    ])
                                ]),
                                (0, $TusQn.withDirectives)(slots.default ? (0, $TusQn.createElementVNode)("div", {
                                    "class": (0, $8POXm.normalizeClass)(fieldClass),
                                    "data-no-activator": ""
                                }, [
                                    slots.default({
                                        id: id
                                    }),
                                    inputNode
                                ]) : (0, $TusQn.cloneVNode)(inputNode, {
                                    class: fieldClass
                                }), [
                                    [
                                        (0, $8d31333abb7bf4e7$export$2e2bcd8739ae039),
                                        onIntersect,
                                        null,
                                        {
                                            once: true
                                        }
                                    ]
                                ]),
                                props.suffix && (0, $TusQn.createElementVNode)("span", {
                                    "class": "v-text-field__suffix"
                                }, [
                                    (0, $TusQn.createElementVNode)("span", {
                                        "class": "v-text-field__suffix__text"
                                    }, [
                                        props.suffix
                                    ])
                                ])
                            ]);
                        }
                    });
                },
                details: hasDetails ? (slotProps)=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots.details?.(slotProps),
                        hasCounter && (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                            (0, $TusQn.createElementVNode)("span", null, null),
                            (0, $TusQn.createVNode)((0, $b240aced8b361832$export$45efeae449ff2094), {
                                "active": props.persistentCounter || isFocused.value,
                                "value": counterValue.value,
                                "max": max.value,
                                "disabled": props.disabled
                            }, slots.counter)
                        ])
                    ]) : undefined
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, vInputRef, vFieldRef, inputRef);
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");



const $0b8f4225788ce420$export$aed5522ef094d4d0 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    renderless: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VVirtualScrollItem');
const $0b8f4225788ce420$export$e996ecbe8aa756e9 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VVirtualScrollItem',
    inheritAttrs: false,
    props: $0b8f4225788ce420$export$aed5522ef094d4d0(),
    emits: {
        'update:height': (height)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { resizeRef: resizeRef, contentRect: contentRect } = (0, $d80db15b6452c606$export$683480f191c0e3ea)(undefined, 'border');
        (0, $01W3b.watch)(()=>contentRect.value?.height, (height)=>{
            if (height != null) emit('update:height', height);
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>props.renderless ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                slots.default?.({
                    itemRef: resizeRef
                })
            ]) : (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "ref": resizeRef,
                "class": [
                    'v-virtual-scroll__item',
                    props.class
                ],
                "style": props.style
            }, attrs), [
                slots.default?.()
            ]));
    }
});





// Composables


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $8af1531278c9785d$var$UP = -1;
const $8af1531278c9785d$var$DOWN = 1;
/** Determines how large each batch of items should be */ const $8af1531278c9785d$var$BUFFER_PX = 100;
const $8af1531278c9785d$export$7703b7ab4acf2c49 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    itemHeight: {
        type: [
            Number,
            String
        ],
        default: null
    },
    itemKey: {
        type: [
            String,
            Array,
            Function
        ],
        default: null
    },
    height: [
        Number,
        String
    ]
}, 'virtual');
function $8af1531278c9785d$export$ebc1863da693699a(props, items) {
    const display = (0, $1444e2cf1a712792$export$8406b7efc286d284)();
    const itemHeight = (0, $01W3b.shallowRef)(0);
    (0, $TusQn.watchEffect)(()=>{
        itemHeight.value = parseFloat(props.itemHeight || 0);
    });
    const first = (0, $01W3b.shallowRef)(0);
    const last = (0, $01W3b.shallowRef)(Math.ceil(// Assume 16px items filling the entire screen height if
    // not provided. This is probably incorrect but it minimises
    // the chance of ending up with empty space at the bottom.
    // The default value is set here to avoid poisoning getSize()
    (parseInt(props.height) || display.height.value) / (itemHeight.value || 16)) || 1);
    const paddingTop = (0, $01W3b.shallowRef)(0);
    const paddingBottom = (0, $01W3b.shallowRef)(0);
    /** The scrollable element */ const containerRef = (0, $01W3b.ref)();
    /** An element marking the top of the scrollable area,
   * used to add an offset if there's padding or other elements above the virtual list */ const markerRef = (0, $01W3b.ref)();
    /** markerRef's offsetTop, lazily evaluated */ let markerOffset = 0;
    const { resizeRef: resizeRef, contentRect: contentRect } = (0, $d80db15b6452c606$export$683480f191c0e3ea)();
    (0, $TusQn.watchEffect)(()=>{
        resizeRef.value = containerRef.value;
    });
    const viewportHeight = (0, $01W3b.computed)(()=>{
        return containerRef.value === document.documentElement ? display.height.value : contentRect.value?.height || parseInt(props.height) || 0;
    });
    /** All static elements have been rendered and we have an assumed item height */ const hasInitialRender = (0, $01W3b.computed)(()=>{
        return !!(containerRef.value && markerRef.value && viewportHeight.value && itemHeight.value);
    });
    let sizes = Array.from({
        length: items.value.length
    });
    let offsets = Array.from({
        length: items.value.length
    });
    const updateTime = (0, $01W3b.shallowRef)(0);
    let targetScrollIndex = -1;
    function getSize(index) {
        return sizes[index] || itemHeight.value;
    }
    const updateOffsets = (0, $8590040a7833369a$export$61fc7d43ac8f84b0)(()=>{
        const start = performance.now();
        offsets[0] = 0;
        const length = items.value.length;
        for(let i = 1; i <= length; i++)offsets[i] = (offsets[i - 1] || 0) + getSize(i - 1);
        updateTime.value = Math.max(updateTime.value, performance.now() - start);
    }, updateTime);
    const unwatch = (0, $01W3b.watch)(hasInitialRender, (v)=>{
        if (!v) return;
        // First render is complete, update offsets and visible
        // items in case our assumed item height was incorrect
        unwatch();
        markerOffset = markerRef.value.offsetTop;
        updateOffsets.immediate();
        calculateVisibleItems();
        if (!~targetScrollIndex) return;
        (0, $TusQn.nextTick)(()=>{
            (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && window.requestAnimationFrame(()=>{
                scrollToIndex(targetScrollIndex);
                targetScrollIndex = -1;
            });
        });
    });
    (0, $01W3b.onScopeDispose)(()=>{
        updateOffsets.clear();
    });
    function handleItemResize(index, height) {
        const prevHeight = sizes[index];
        const prevMinHeight = itemHeight.value;
        itemHeight.value = prevMinHeight ? Math.min(itemHeight.value, height) : height;
        if (prevHeight !== height || prevMinHeight !== itemHeight.value) {
            sizes[index] = height;
            updateOffsets();
        }
    }
    function calculateOffset(index) {
        index = (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(index, 0, items.value.length);
        const whole = Math.floor(index);
        const fraction = index % 1;
        const next = whole + 1;
        const wholeOffset = offsets[whole] || 0;
        const nextOffset = offsets[next] || wholeOffset;
        return wholeOffset + (nextOffset - wholeOffset) * fraction;
    }
    function calculateIndex(scrollTop) {
        return $8af1531278c9785d$var$binaryClosest(offsets, scrollTop);
    }
    let lastScrollTop = 0;
    let scrollVelocity = 0;
    let lastScrollTime = 0;
    (0, $01W3b.watch)(viewportHeight, (val, oldVal)=>{
        calculateVisibleItems();
        if (val < oldVal) requestAnimationFrame(()=>{
            scrollVelocity = 0;
            calculateVisibleItems();
        });
    });
    let scrollTimeout = -1;
    function handleScroll() {
        if (!containerRef.value || !markerRef.value) return;
        const scrollTop = containerRef.value.scrollTop;
        const scrollTime = performance.now();
        const scrollDeltaT = scrollTime - lastScrollTime;
        if (scrollDeltaT > 500) {
            scrollVelocity = Math.sign(scrollTop - lastScrollTop);
            // Not super important, only update at the
            // start of a scroll sequence to avoid reflows
            markerOffset = markerRef.value.offsetTop;
        } else scrollVelocity = scrollTop - lastScrollTop;
        lastScrollTop = scrollTop;
        lastScrollTime = scrollTime;
        window.clearTimeout(scrollTimeout);
        scrollTimeout = window.setTimeout(handleScrollend, 500);
        calculateVisibleItems();
    }
    function handleScrollend() {
        if (!containerRef.value || !markerRef.value) return;
        scrollVelocity = 0;
        lastScrollTime = 0;
        window.clearTimeout(scrollTimeout);
        calculateVisibleItems();
    }
    let raf = -1;
    function calculateVisibleItems() {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(_calculateVisibleItems);
    }
    function _calculateVisibleItems() {
        if (!containerRef.value || !viewportHeight.value || !itemHeight.value) return;
        const scrollTop = lastScrollTop - markerOffset;
        const direction = Math.sign(scrollVelocity);
        const startPx = Math.max(0, scrollTop - $8af1531278c9785d$var$BUFFER_PX);
        const start = (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(calculateIndex(startPx), 0, items.value.length);
        const endPx = scrollTop + viewportHeight.value + $8af1531278c9785d$var$BUFFER_PX;
        const end = (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(calculateIndex(endPx) + 1, start + 1, items.value.length);
        if (// Only update the side we're scrolling towards,
        // the other side will be updated incidentally
        (direction !== $8af1531278c9785d$var$UP || start < first.value) && (direction !== $8af1531278c9785d$var$DOWN || end > last.value)) {
            const topOverflow = calculateOffset(first.value) - calculateOffset(start);
            const bottomOverflow = calculateOffset(end) - calculateOffset(last.value);
            const bufferOverflow = Math.max(topOverflow, bottomOverflow);
            if (bufferOverflow > $8af1531278c9785d$var$BUFFER_PX) {
                first.value = start;
                last.value = end;
            } else {
                // Only update the side that's reached its limit if there's still buffer left
                if (start <= 0) first.value = start;
                if (end >= items.value.length) last.value = end;
            }
        }
        paddingTop.value = calculateOffset(first.value);
        paddingBottom.value = calculateOffset(items.value.length) - calculateOffset(last.value);
    }
    function scrollToIndex(index) {
        const offset = calculateOffset(index);
        if (!containerRef.value || index && !offset) targetScrollIndex = index;
        else containerRef.value.scrollTop = offset;
    }
    const computedItems = (0, $01W3b.computed)(()=>{
        return items.value.slice(first.value, last.value).map((item, index)=>{
            const _index = index + first.value;
            return {
                raw: item,
                index: _index,
                key: (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemKey, _index)
            };
        });
    });
    (0, $01W3b.watch)(items, ()=>{
        sizes = Array.from({
            length: items.value.length
        });
        offsets = Array.from({
            length: items.value.length
        });
        updateOffsets.immediate();
        calculateVisibleItems();
    }, {
        deep: 1
    });
    return {
        calculateVisibleItems: calculateVisibleItems,
        containerRef: containerRef,
        markerRef: markerRef,
        computedItems: computedItems,
        paddingTop: paddingTop,
        paddingBottom: paddingBottom,
        scrollToIndex: scrollToIndex,
        handleScroll: handleScroll,
        handleScrollend: handleScrollend,
        handleItemResize: handleItemResize
    };
}
// https://gist.github.com/robertleeplummerjr/1cc657191d34ecd0a324
function $8af1531278c9785d$var$binaryClosest(arr, val) {
    let high = arr.length - 1;
    let low = 0;
    let mid = 0;
    let item = null;
    let target = -1;
    if (arr[high] < val) return high;
    while(low <= high){
        mid = low + high >> 1;
        item = arr[mid];
        if (item > val) high = mid - 1;
        else if (item < val) {
            target = mid;
            low = mid + 1;
        } else if (item === val) return mid;
        else return low;
    }
    return target;
}



const $28b14115b5680302$export$f8006e3167d3452e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        default: ()=>[]
    },
    renderless: Boolean,
    ...(0, $8af1531278c9785d$export$7703b7ab4acf2c49)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)()
}, 'VVirtualScroll');
const $28b14115b5680302$export$bdb136bf2d9028a4 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VVirtualScroll',
    props: $28b14115b5680302$export$f8006e3167d3452e(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('VVirtualScroll');
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { calculateVisibleItems: calculateVisibleItems, containerRef: containerRef, markerRef: markerRef, handleScroll: handleScroll, handleScrollend: handleScrollend, handleItemResize: handleItemResize, scrollToIndex: scrollToIndex, paddingTop: paddingTop, paddingBottom: paddingBottom, computedItems: computedItems } = (0, $8af1531278c9785d$export$ebc1863da693699a)(props, (0, $01W3b.toRef)(()=>props.items));
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>props.renderless, ()=>{
            function handleListeners() {
                let add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                const method = add ? 'addEventListener' : 'removeEventListener';
                if (containerRef.value === document.documentElement) {
                    document[method]('scroll', handleScroll, {
                        passive: true
                    });
                    document[method]('scrollend', handleScrollend);
                } else {
                    containerRef.value?.[method]('scroll', handleScroll, {
                        passive: true
                    });
                    containerRef.value?.[method]('scrollend', handleScrollend);
                }
            }
            (0, $TusQn.onMounted)(()=>{
                containerRef.value = (0, $fa6a71feb92f218b$export$cfa2225e87938781)(vm.vnode.el, true);
                handleListeners(true);
            });
            (0, $01W3b.onScopeDispose)(handleListeners);
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const children = computedItems.value.map((item)=>(0, $TusQn.createVNode)((0, $0b8f4225788ce420$export$e996ecbe8aa756e9), {
                    "key": item.key,
                    "renderless": props.renderless,
                    "onUpdate:height": (height)=>handleItemResize(item.index, height)
                }, {
                    default: (slotProps)=>slots.default?.({
                            item: item.raw,
                            index: item.index,
                            ...slotProps
                        })
                }));
            return props.renderless ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                (0, $TusQn.createElementVNode)("div", {
                    "ref": markerRef,
                    "class": "v-virtual-scroll__spacer",
                    "style": {
                        paddingTop: (0, $8590040a7833369a$export$286ad215293a0860)(paddingTop.value)
                    }
                }, null),
                children,
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-virtual-scroll__spacer",
                    "style": {
                        paddingBottom: (0, $8590040a7833369a$export$286ad215293a0860)(paddingBottom.value)
                    }
                }, null)
            ]) : (0, $TusQn.createElementVNode)("div", {
                "ref": containerRef,
                "class": (0, $8POXm.normalizeClass)([
                    'v-virtual-scroll',
                    props.class
                ]),
                "onScrollPassive": handleScroll,
                "onScrollend": handleScrollend,
                "style": (0, $8POXm.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "ref": markerRef,
                    "class": "v-virtual-scroll__container",
                    "style": {
                        paddingTop: (0, $8590040a7833369a$export$286ad215293a0860)(paddingTop.value),
                        paddingBottom: (0, $8590040a7833369a$export$286ad215293a0860)(paddingBottom.value)
                    }
                }, [
                    children
                ])
            ]);
        });
        return {
            calculateVisibleItems: calculateVisibleItems,
            scrollToIndex: scrollToIndex
        };
    }
});


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
function $31951e38cd8c6afc$export$5081bf709ff6ca2c(listRef, textFieldRef) {
    const isScrolling = (0, $01W3b.shallowRef)(false);
    let scrollTimeout;
    function onListScroll(e) {
        cancelAnimationFrame(scrollTimeout);
        isScrolling.value = true;
        scrollTimeout = requestAnimationFrame(()=>{
            scrollTimeout = requestAnimationFrame(()=>{
                isScrolling.value = false;
            });
        });
    }
    async function finishScrolling() {
        await new Promise((resolve)=>requestAnimationFrame(resolve));
        await new Promise((resolve)=>requestAnimationFrame(resolve));
        await new Promise((resolve)=>requestAnimationFrame(resolve));
        await new Promise((resolve)=>{
            if (isScrolling.value) {
                const stop = (0, $01W3b.watch)(isScrolling, ()=>{
                    stop();
                    resolve();
                });
            } else resolve();
        });
    }
    async function onListKeydown(e) {
        if (e.key === 'Tab') textFieldRef.value?.focus();
        if (![
            'PageDown',
            'PageUp',
            'Home',
            'End'
        ].includes(e.key)) return;
        const el = listRef.value?.$el;
        if (!el) return;
        if (e.key === 'Home' || e.key === 'End') el.scrollTo({
            top: e.key === 'Home' ? 0 : el.scrollHeight,
            behavior: 'smooth'
        });
        await finishScrolling();
        const children = el.querySelectorAll(':scope > :not(.v-virtual-scroll__spacer)');
        if (e.key === 'PageDown' || e.key === 'Home') {
            const top = el.getBoundingClientRect().top;
            for (const child of children)if (child.getBoundingClientRect().top >= top) {
                child.focus();
                break;
            }
        } else {
            const bottom = el.getBoundingClientRect().bottom;
            for (const child of [
                ...children
            ].reverse())if (child.getBoundingClientRect().bottom <= bottom) {
                child.focus();
                break;
            }
        }
    }
    return {
        onScrollPassive: onListScroll,
        onKeydown: onListKeydown
    }; // typescript doesn't know about vue's event merging
}


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

function $9b72d3360b6fdbc5$export$d0c035d5199a1ad2(_ref) {
    let { groups: groups, onLeave: onLeave } = _ref;
    function getContentRef(group) {
        return group.type === 'list' ? group.contentRef.value?.$el : group.contentRef.value;
    }
    function getChildren(group) {
        const contentRef = getContentRef(group);
        return contentRef ? (0, $8590040a7833369a$export$aea49dace3f6ca76)(contentRef) : [];
    }
    function onTabKeydown(e) {
        const target = e.target;
        const direction = e.shiftKey ? 'backward' : 'forward';
        const children = groups.map(getChildren);
        const currentGroupIndex = groups.map((g)=>g.type === 'list' ? g.contentRef.value?.$el : g.contentRef.value).findIndex((el)=>el?.contains(target));
        const nextIndex = nextFocusGroup(children, currentGroupIndex, direction, target);
        if (nextIndex === null) {
            const originGroup = groups[currentGroupIndex];
            const origin = children[currentGroupIndex];
            const isListGroup = originGroup.type === 'list';
            const atEdge = isListGroup || (direction === 'forward' ? origin.at(-1) === e.target : origin.at(0) === e.target);
            if (atEdge) onLeave();
        } else {
            e.preventDefault();
            e.stopImmediatePropagation();
            const nextGroup = groups[nextIndex];
            if (nextGroup.type === 'list' && (0, $01W3b.toValue)(nextGroup.displayItemsCount) > 0) nextGroup.contentRef.value?.focus(0);
            else {
                const fromBefore = direction === 'forward';
                children[nextIndex].at(fromBefore ? 0 : -1).focus();
            }
        }
    }
    function nextFocusGroup(children, currentIndex, direction, target) {
        const originGroup = groups[currentIndex];
        const origin = children[currentIndex];
        // List groups always allow leaving (VList manages internal focus)
        // Element groups require being at the edge focusable child
        if (originGroup.type !== 'list') {
            const isAtEdge = direction === 'forward' ? origin.at(-1) === target : origin.at(0) === target;
            if (!isAtEdge) return null;
        }
        const step = direction === 'forward' ? 1 : -1;
        for(let i = currentIndex + step; i >= 0 && i < groups.length; i += step){
            const group = groups[i];
            if (children[i].length > 0 || group.type === 'list' && (0, $01W3b.toValue)(group.displayItemsCount) > 0) return i;
        }
        return null;
    }
    return {
        onTabKeydown: onTabKeydown
    };
}



/* eslint-disable max-statements */ /* eslint-disable no-labels */ // Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

const $06230a510138477a$export$3f6f640afaf1ec43 = (value, query, item)=>{
    if (value == null || query == null) return -1;
    if (!query.length) return 0;
    value = value.toString().toLocaleLowerCase();
    query = query.toString().toLocaleLowerCase();
    const result = [];
    let idx = value.indexOf(query);
    while(~idx){
        result.push([
            idx,
            idx + query.length
        ]);
        idx = value.indexOf(query, idx + query.length);
    }
    return result.length ? result : -1;
};
function $06230a510138477a$var$normaliseMatch(match, query) {
    if (match == null || typeof match === 'boolean' || match === -1) return;
    if (typeof match === 'number') return [
        [
            match,
            match + query.length
        ]
    ];
    if (Array.isArray(match[0])) return match;
    return [
        match
    ];
}
const $06230a510138477a$export$a99bb5c4eecafb96 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    customFilter: Function,
    customKeyFilter: Object,
    filterKeys: [
        Array,
        String
    ],
    filterMode: {
        type: String,
        default: 'intersection'
    },
    noFilter: Boolean
}, 'filter');
function $06230a510138477a$export$16c4c0987c894b8c(items, query, options) {
    const array = [];
    // always ensure we fall back to a functioning filter
    const filter = options?.default ?? $06230a510138477a$export$3f6f640afaf1ec43;
    const keys = options?.filterKeys ? (0, $8590040a7833369a$export$76411cac38121ecb)(options.filterKeys) : false;
    const customFiltersLength = Object.keys(options?.customKeyFilter ?? {}).length;
    if (!items?.length) return array;
    let lookAheadItems = [];
    loop: for(let i = 0; i < items.length; i++){
        const [item, transformed = item] = (0, $8590040a7833369a$export$76411cac38121ecb)(items[i]);
        const customMatches = {};
        const defaultMatches = {};
        let match = -1;
        if ((query || customFiltersLength > 0) && !options?.noFilter) {
            let hasOnlyCustomFilters = false;
            if (typeof item === 'object') {
                if (item.type === 'divider' || item.type === 'subheader') {
                    if (lookAheadItems.at(-1)?.type !== 'divider' || item.type !== 'subheader') // clear unless, divider appears before subheader
                    lookAheadItems = [];
                    lookAheadItems.push({
                        index: i,
                        matches: {},
                        type: item.type
                    });
                    continue;
                }
                const filterKeys = keys || Object.keys(transformed);
                hasOnlyCustomFilters = filterKeys.length === customFiltersLength;
                for (const key of filterKeys){
                    const value = (0, $8590040a7833369a$export$655f0e681f1365dc)(transformed, key);
                    const keyFilter = options?.customKeyFilter?.[key];
                    match = keyFilter ? keyFilter(value, query, item) : filter(value, query, item);
                    if (match !== -1 && match !== false) {
                        if (keyFilter) customMatches[key] = $06230a510138477a$var$normaliseMatch(match, query);
                        else defaultMatches[key] = $06230a510138477a$var$normaliseMatch(match, query);
                    } else if (options?.filterMode === 'every') continue loop;
                }
            } else {
                match = filter(item, query, item);
                if (match !== -1 && match !== false) defaultMatches.title = $06230a510138477a$var$normaliseMatch(match, query);
            }
            const defaultMatchesLength = Object.keys(defaultMatches).length;
            const customMatchesLength = Object.keys(customMatches).length;
            if (!defaultMatchesLength && !customMatchesLength) continue;
            if (options?.filterMode === 'union' && customMatchesLength !== customFiltersLength && !defaultMatchesLength) continue;
            if (options?.filterMode === 'intersection' && (customMatchesLength !== customFiltersLength || !defaultMatchesLength && customFiltersLength > 0 && !hasOnlyCustomFilters)) continue;
        }
        if (lookAheadItems.length) {
            array.push(...lookAheadItems);
            lookAheadItems = [];
        }
        array.push({
            index: i,
            matches: {
                ...defaultMatches,
                ...customMatches
            }
        });
    }
    return array;
}
function $06230a510138477a$export$3274cf84b703fff(props, items, query, options) {
    const filteredItems = (0, $01W3b.shallowRef)([]);
    const filteredMatches = (0, $01W3b.shallowRef)(new Map());
    const transformedItems = (0, $01W3b.computed)(()=>options?.transform ? (0, $01W3b.unref)(items).map((item)=>[
                item,
                options.transform(item)
            ]) : (0, $01W3b.unref)(items));
    (0, $TusQn.watchEffect)(()=>{
        const _query = typeof query === 'function' ? query() : (0, $01W3b.unref)(query);
        const strQuery = typeof _query !== 'string' && typeof _query !== 'number' ? '' : String(_query);
        const results = $06230a510138477a$export$16c4c0987c894b8c(transformedItems.value, strQuery, {
            customKeyFilter: {
                ...props.customKeyFilter,
                ...(0, $01W3b.unref)(options?.customKeyFilter)
            },
            default: props.customFilter,
            filterKeys: props.filterKeys,
            filterMode: props.filterMode,
            noFilter: props.noFilter
        });
        const originalItems = (0, $01W3b.unref)(items);
        const _filteredItems = [];
        const _filteredMatches = new Map();
        results.forEach((_ref)=>{
            let { index: index, matches: matches } = _ref;
            const item = originalItems[index];
            _filteredItems.push(item);
            _filteredMatches.set(item.value, matches);
        });
        filteredItems.value = _filteredItems;
        filteredMatches.value = _filteredMatches;
    });
    function getMatches(item) {
        return filteredMatches.value.get(item.value);
    }
    return {
        filteredItems: filteredItems,
        filteredMatches: filteredMatches,
        getMatches: getMatches
    };
}
function $06230a510138477a$export$71650bdcd27abbc4(name, text, matches) {
    if (matches == null || !matches.length) return text;
    return matches.map((match, i)=>{
        const start = i === 0 ? 0 : matches[i - 1][1];
        const result = [
            (0, $TusQn.createElementVNode)("span", {
                "class": (0, $8POXm.normalizeClass)(`${name}__unmask`)
            }, [
                text.slice(start, match[0])
            ]),
            (0, $TusQn.createElementVNode)("span", {
                "class": (0, $8POXm.normalizeClass)(`${name}__mask`)
            }, [
                text.slice(match[0], match[1])
            ])
        ];
        if (i === matches.length - 1) result.push((0, $TusQn.createElementVNode)("span", {
            "class": (0, $8POXm.normalizeClass)(`${name}__unmask`)
        }, [
            text.slice(match[1])
        ]));
        return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
            result
        ]);
    });
}







// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $db0abbb2e7605284$export$dcb9721619fb53ff = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    closeText: {
        type: String,
        default: '$vuetify.close'
    },
    openText: {
        type: String,
        default: '$vuetify.open'
    }
}, 'autocomplete');
function $db0abbb2e7605284$export$336f022c1e31f429(props, isOpen) {
    const uid = (0, $TusQn.useId)();
    const menuId = (0, $01W3b.computed)(()=>`menu-${uid}`);
    const ariaExpanded = (0, $01W3b.toRef)(()=>(0, $01W3b.toValue)(isOpen));
    const ariaControls = (0, $01W3b.toRef)(()=>menuId.value);
    return {
        menuId: menuId,
        ariaExpanded: ariaExpanded,
        ariaControls: ariaControls
    };
}





const $118e5e4309583a1b$export$c210933f6eecdb37 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    chips: Boolean,
    closableChips: Boolean,
    eager: Boolean,
    hideNoData: Boolean,
    hideSelected: Boolean,
    listProps: {
        type: Object
    },
    menu: Boolean,
    menuIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$dropdown'
    },
    menuProps: {
        type: Object
    },
    multiple: Boolean,
    noDataText: {
        type: String,
        default: '$vuetify.noDataText'
    },
    openOnClear: Boolean,
    itemColor: String,
    noAutoScroll: Boolean,
    ...(0, $db0abbb2e7605284$export$dcb9721619fb53ff)(),
    ...(0, $9d0414e5c866e7bc$export$899bb842e69e7bd4)({
        itemChildren: false
    })
}, 'Select');
const $118e5e4309583a1b$export$38d465e3bb404772 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    search: String,
    ...(0, $06230a510138477a$export$a99bb5c4eecafb96)({
        filterKeys: [
            'title'
        ]
    }),
    ...$118e5e4309583a1b$export$c210933f6eecdb37(),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $1df180b07e489866$export$c9f7484641b0b190)({
        modelValue: null,
        role: 'combobox'
    }), [
        'validationValue',
        'dirty'
    ]),
    ...(0, $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e)({
        transition: {
            component: (0, $6d83cccc3a7f7c51$export$9778a08df954f36c)
        }
    })
}, 'VSelect');
const $118e5e4309583a1b$export$1d8182ee812485f5 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSelect',
    props: $118e5e4309583a1b$export$38d465e3bb404772(),
    emits: {
        'update:focused': (focused)=>true,
        'update:modelValue': (value)=>true,
        'update:menu': (ue)=>true,
        'update:search': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const vTextFieldRef = (0, $01W3b.ref)();
        const vMenuRef = (0, $01W3b.ref)();
        const headerRef = (0, $01W3b.ref)();
        const footerRef = (0, $01W3b.ref)();
        const vVirtualScrollRef = (0, $01W3b.ref)();
        const { items: items, transformIn: transformIn, transformOut: transformOut } = (0, $9d0414e5c866e7bc$export$7bfdd97581ca93c)(props);
        const search = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'search', '');
        const { filteredItems: filteredItems, getMatches: getMatches } = (0, $06230a510138477a$export$3274cf84b703fff)(props, items, ()=>search.value);
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>transformIn(v === null ? [
                null
            ] : (0, $8590040a7833369a$export$76411cac38121ecb)(v)), (v)=>{
            const transformed = transformOut(v);
            return props.multiple ? transformed : transformed[0] ?? null;
        });
        const counterValue = (0, $01W3b.computed)(()=>{
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
        });
        const form = (0, $72bfe1fa0cde9e24$export$87c0cf8eb5a167e0)(props);
        const autocomplete = (0, $beb849cd8f948406$export$1e40b3ca02d92d21)(props);
        const selectedValues = (0, $01W3b.computed)(()=>model.value.map((selection)=>selection.value));
        const isFocused = (0, $01W3b.shallowRef)(false);
        const closableChips = (0, $01W3b.toRef)(()=>props.closableChips && !form.isReadonly.value && !form.isDisabled.value);
        const { InputIcon: InputIcon } = (0, $9a9409ba39d4a5b8$export$d08cb507a9c34d4b)(props);
        let keyboardLookupPrefix = '';
        let keyboardLookupIndex = 0;
        let keyboardLookupLastTime;
        const displayItems = (0, $01W3b.computed)(()=>{
            const baseItems = search.value ? filteredItems.value : items.value;
            if (props.hideSelected) return baseItems.filter((item)=>!model.value.some((s)=>(props.valueComparator || (0, $bf1718679e817e1f$export$9cb4719e2e525b7a))(s, item)));
            return baseItems;
        });
        const menuDisabled = (0, $01W3b.computed)(()=>props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
        const _menu = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'menu');
        const menu = (0, $01W3b.computed)({
            get: ()=>_menu.value,
            set: (v)=>{
                if (_menu.value && !v && vMenuRef.value?.\u03A8openChildren.size) return;
                if (v && menuDisabled.value) return;
                _menu.value = v;
            }
        });
        const { menuId: menuId, ariaExpanded: ariaExpanded, ariaControls: ariaControls } = (0, $db0abbb2e7605284$export$336f022c1e31f429)(props, menu);
        const computedMenuProps = (0, $01W3b.computed)(()=>{
            return {
                ...props.menuProps,
                activatorProps: {
                    ...props.menuProps?.activatorProps || {},
                    'aria-haspopup': 'listbox' // Set aria-haspopup to 'listbox'
                }
            };
        });
        const listRef = (0, $01W3b.ref)();
        const listEvents = (0, $31951e38cd8c6afc$export$5081bf709ff6ca2c)(listRef, vTextFieldRef);
        const { onTabKeydown: onTabKeydown } = (0, $9b72d3360b6fdbc5$export$d0c035d5199a1ad2)({
            groups: [
                {
                    type: 'element',
                    contentRef: headerRef
                },
                {
                    type: 'list',
                    contentRef: listRef,
                    displayItemsCount: ()=>displayItems.value.length
                },
                {
                    type: 'element',
                    contentRef: footerRef
                }
            ],
            onLeave: ()=>{
                menu.value = false;
                vTextFieldRef.value?.focus();
            }
        });
        function onClear(e) {
            if (props.openOnClear) menu.value = true;
        }
        function onMousedownControl() {
            if (menuDisabled.value) return;
            menu.value = !menu.value;
        }
        function onMenuKeydown(e) {
            if (e.key === 'Tab') onTabKeydown(e);
            if (listRef.value?.$el.contains(e.target) && (0, $8590040a7833369a$export$d9d503bf19df5a70)(e)) onKeydown(e);
        }
        function onKeydown(e) {
            if (!e.key || form.isReadonly.value) return;
            if ([
                'Enter',
                ' ',
                'ArrowDown',
                'ArrowUp',
                'Home',
                'End'
            ].includes(e.key)) e.preventDefault();
            if ([
                'Enter',
                'ArrowDown',
                ' '
            ].includes(e.key)) menu.value = true;
            if ([
                'Escape',
                'Tab'
            ].includes(e.key)) menu.value = false;
            if (props.clearable && e.key === 'Backspace') {
                e.preventDefault();
                model.value = [];
                onClear(e);
                return;
            }
            if (e.key === 'Home') listRef.value?.focus('first');
            else if (e.key === 'End') listRef.value?.focus('last');
            // html select hotkeys
            const KEYBOARD_LOOKUP_THRESHOLD = 1000; // milliseconds
            if (!(0, $8590040a7833369a$export$d9d503bf19df5a70)(e)) return;
            const now = performance.now();
            if (now - keyboardLookupLastTime > KEYBOARD_LOOKUP_THRESHOLD) {
                keyboardLookupPrefix = '';
                keyboardLookupIndex = 0;
            }
            keyboardLookupPrefix += e.key.toLowerCase();
            keyboardLookupLastTime = now;
            const items = displayItems.value;
            function findItem() {
                let result = findItemBase();
                if (result) return result;
                if (keyboardLookupPrefix.at(-1) === keyboardLookupPrefix.at(-2)) {
                    // No matches but we have a repeated letter, try the next item with that prefix
                    keyboardLookupPrefix = keyboardLookupPrefix.slice(0, -1);
                    keyboardLookupIndex++;
                    result = findItemBase();
                    if (result) return result;
                }
                // Still nothing, wrap around to the top
                keyboardLookupIndex = 0;
                result = findItemBase();
                if (result) return result;
                // Still nothing, try just the new letter
                keyboardLookupPrefix = e.key.toLowerCase();
                return findItemBase();
            }
            function findItemBase() {
                for(let i = keyboardLookupIndex; i < items.length; i++){
                    const _item = items[i];
                    if (_item.title.toLowerCase().startsWith(keyboardLookupPrefix)) return [
                        _item,
                        i
                    ];
                }
                return undefined;
            }
            const result = findItem();
            if (!result) return;
            const [item, index] = result;
            keyboardLookupIndex = index;
            listRef.value?.focus(index);
            if (!props.multiple) model.value = [
                item
            ];
        }
        /** @param set - null means toggle */ function select(item) {
            let set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (item.props.disabled) return;
            if (props.multiple) {
                const index = model.value.findIndex((selection)=>(props.valueComparator || (0, $bf1718679e817e1f$export$9cb4719e2e525b7a))(selection.value, item.value));
                const add = set == null ? !~index : set;
                if (~index) {
                    const value = add ? [
                        ...model.value,
                        item
                    ] : [
                        ...model.value
                    ];
                    value.splice(index, 1);
                    model.value = value;
                } else if (add) model.value = [
                    ...model.value,
                    item
                ];
            } else {
                const add = set !== false;
                model.value = add ? [
                    item
                ] : [];
                (0, $TusQn.nextTick)(()=>{
                    menu.value = false;
                });
            }
        }
        function onBlur(e) {
            const target = e.target;
            if (!vTextFieldRef.value?.$el.contains(target)) menu.value = false;
        }
        function onAfterEnter() {
            if (props.eager) vVirtualScrollRef.value?.calculateVisibleItems();
        }
        function onAfterLeave() {
            search.value = '';
            if (isFocused.value) vTextFieldRef.value?.focus();
        }
        function onFocusin(e) {
            isFocused.value = true;
        }
        function onModelUpdate(v) {
            if (v == null) model.value = [];
            else if ((0, $8590040a7833369a$export$b06a2f5618961e1e)(vTextFieldRef.value, ':autofill') || (0, $8590040a7833369a$export$b06a2f5618961e1e)(vTextFieldRef.value, ':-webkit-autofill')) {
                const item = items.value.find((item)=>item.title === v);
                if (item) select(item);
            } else if (vTextFieldRef.value) vTextFieldRef.value.value = '';
        }
        (0, $01W3b.watch)(menu, ()=>{
            if (!props.hideSelected && menu.value && model.value.length) {
                const index = displayItems.value.findIndex((item)=>model.value.some((s)=>(props.valueComparator || (0, $bf1718679e817e1f$export$9cb4719e2e525b7a))(s.value, item.value)));
                (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && !props.noAutoScroll && window.requestAnimationFrame(()=>{
                    index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
                });
            }
        });
        (0, $01W3b.watch)(items, (newVal, oldVal)=>{
            if (menu.value) return;
            if (isFocused.value && props.hideNoData && !oldVal.length && newVal.length) menu.value = true;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasChips = !!(props.chips || slots.chip);
            const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
            const isDirty = model.value.length > 0;
            const textFieldProps = (0, $1df180b07e489866$export$d591c92dea965c28).filterProps(props);
            const placeholder = isDirty || !isFocused.value && props.label && !props.persistentPlaceholder ? undefined : props.placeholder;
            const menuSlotProps = {
                search: search,
                filteredItems: filteredItems.value
            };
            return (0, $TusQn.createVNode)((0, $1df180b07e489866$export$d591c92dea965c28), (0, $TusQn.mergeProps)({
                "ref": vTextFieldRef
            }, textFieldProps, {
                "modelValue": model.value.map((v)=>v.props.title).join(', '),
                "name": undefined,
                "onUpdate:modelValue": onModelUpdate,
                "focused": isFocused.value,
                "onUpdate:focused": ($event)=>isFocused.value = $event,
                "validationValue": model.externalValue,
                "counterValue": counterValue.value,
                "dirty": isDirty,
                "class": [
                    'v-select',
                    {
                        'v-select--active-menu': menu.value,
                        'v-select--chips': !!props.chips,
                        [`v-select--${props.multiple ? 'multiple' : 'single'}`]: true,
                        'v-select--selected': model.value.length,
                        'v-select--selection-slot': !!slots.selection
                    },
                    props.class
                ],
                "style": props.style,
                "inputmode": "none",
                "placeholder": placeholder,
                "onClick:clear": onClear,
                "onMousedown:control": onMousedownControl,
                "onBlur": onBlur,
                "onKeydown": onKeydown,
                "aria-expanded": ariaExpanded.value,
                "aria-controls": ariaControls.value
            }), {
                ...slots,
                default: (_ref2)=>{
                    let { id: id } = _ref2;
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createElementVNode)("select", {
                            "hidden": true,
                            "multiple": props.multiple,
                            "name": autocomplete.fieldName.value
                        }, [
                            items.value.map((item)=>(0, $TusQn.createElementVNode)("option", {
                                    "key": item.value,
                                    "value": item.value,
                                    "selected": selectedValues.value.includes(item.value)
                                }, null))
                        ]),
                        (0, $TusQn.createVNode)((0, $9208258024e22101$export$a347888d6b8f252a), (0, $TusQn.mergeProps)({
                            "id": menuId.value,
                            "ref": vMenuRef,
                            "modelValue": menu.value,
                            "onUpdate:modelValue": ($event)=>menu.value = $event,
                            "activator": "parent",
                            "contentClass": "v-select__content",
                            "disabled": menuDisabled.value,
                            "eager": props.eager,
                            "maxHeight": 310,
                            "openOnClick": false,
                            "closeOnContentClick": false,
                            "transition": props.transition,
                            "onAfterEnter": onAfterEnter,
                            "onAfterLeave": onAfterLeave
                        }, computedMenuProps.value), {
                            default: ()=>[
                                    (0, $TusQn.createVNode)((0, $ce059966358db8b1$export$d41b26ce18186ef0), {
                                        "onFocusin": onFocusin,
                                        "onKeydown": onMenuKeydown
                                    }, {
                                        default: ()=>[
                                                slots['menu-header'] && (0, $TusQn.createElementVNode)("header", {
                                                    "ref": headerRef
                                                }, [
                                                    slots['menu-header'](menuSlotProps)
                                                ]),
                                                hasList && (0, $TusQn.createVNode)((0, $8f3cccf9308874bc$export$3b010b0401837103), (0, $TusQn.mergeProps)({
                                                    "key": "select-list",
                                                    "ref": listRef,
                                                    "selected": selectedValues.value,
                                                    "selectStrategy": props.multiple ? 'independent' : 'single-independent',
                                                    "tabindex": "-1",
                                                    "selectable": !!displayItems.value.length,
                                                    "aria-live": "polite",
                                                    "aria-labelledby": `${id.value}-label`,
                                                    "aria-multiselectable": props.multiple,
                                                    "color": props.itemColor ?? props.color
                                                }, listEvents, props.listProps), {
                                                    default: ()=>[
                                                            slots['prepend-item']?.(),
                                                            !displayItems.value.length && !props.hideNoData && (slots['no-data']?.() ?? (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), {
                                                                "key": "no-data",
                                                                "title": t(props.noDataText)
                                                            }, null)),
                                                            (0, $TusQn.createVNode)((0, $28b14115b5680302$export$bdb136bf2d9028a4), {
                                                                "ref": vVirtualScrollRef,
                                                                "renderless": true,
                                                                "items": displayItems.value,
                                                                "itemKey": "value"
                                                            }, {
                                                                default: (_ref3)=>{
                                                                    let { item: item, index: index, itemRef: itemRef } = _ref3;
                                                                    const camelizedProps = (0, $8590040a7833369a$export$32263599c7ddd4ae)(item.props);
                                                                    const itemProps = (0, $TusQn.mergeProps)(item.props, {
                                                                        ref: itemRef,
                                                                        key: item.value,
                                                                        onClick: ()=>select(item, null),
                                                                        'aria-posinset': index + 1,
                                                                        'aria-setsize': displayItems.value.length
                                                                    });
                                                                    if (item.type === 'divider') return slots.divider?.({
                                                                        props: item.raw,
                                                                        index: index
                                                                    }) ?? (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), (0, $TusQn.mergeProps)(item.props, {
                                                                        "key": `divider-${index}`
                                                                    }), null);
                                                                    if (item.type === 'subheader') return slots.subheader?.({
                                                                        props: item.raw,
                                                                        index: index
                                                                    }) ?? (0, $TusQn.createVNode)((0, $96a2eb5e8711f0cc$export$70c4aba7bf48e22a), (0, $TusQn.mergeProps)(item.props, {
                                                                        "key": `subheader-${index}`
                                                                    }), null);
                                                                    return slots.item?.({
                                                                        item: item,
                                                                        index: index,
                                                                        props: itemProps
                                                                    }) ?? (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), (0, $TusQn.mergeProps)(itemProps, {
                                                                        "role": "option"
                                                                    }), {
                                                                        prepend: (_ref4)=>{
                                                                            let { isSelected: isSelected } = _ref4;
                                                                            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                                                                props.multiple && !props.hideSelected ? (0, $TusQn.createVNode)((0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6), {
                                                                                    "key": item.value,
                                                                                    "modelValue": isSelected,
                                                                                    "ripple": false,
                                                                                    "tabindex": "-1",
                                                                                    "aria-hidden": true,
                                                                                    "onClick": (event)=>event.preventDefault()
                                                                                }, null) : undefined,
                                                                                camelizedProps.prependAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                                                                    "image": camelizedProps.prependAvatar
                                                                                }, null),
                                                                                camelizedProps.prependIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                                                                    "icon": camelizedProps.prependIcon
                                                                                }, null)
                                                                            ]);
                                                                        },
                                                                        title: ()=>{
                                                                            return search.value ? (0, $06230a510138477a$export$71650bdcd27abbc4)('v-select', item.title, getMatches(item)?.title) : item.title;
                                                                        }
                                                                    });
                                                                }
                                                            }),
                                                            slots['append-item']?.()
                                                        ]
                                                }),
                                                slots['menu-footer'] && (0, $TusQn.createElementVNode)("footer", {
                                                    "ref": footerRef
                                                }, [
                                                    slots['menu-footer'](menuSlotProps)
                                                ])
                                            ]
                                    })
                                ]
                        }),
                        model.value.map((item, index)=>{
                            function onChipClose(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                select(item, false);
                            }
                            const slotProps = (0, $TusQn.mergeProps)((0, $fd0891698b65ffb1$export$1b5fab12cd17b4fb).filterProps(item.props), {
                                'onClick:close': onChipClose,
                                onKeydown (e) {
                                    if (e.key !== 'Enter' && e.key !== ' ') return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onChipClose(e);
                                },
                                onMousedown (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                modelValue: true,
                                'onUpdate:modelValue': undefined
                            });
                            const hasSlot = hasChips ? !!slots.chip : !!slots.selection;
                            const slotContent = hasSlot ? (0, $8590040a7833369a$export$9fc41f261330971f)(hasChips ? slots.chip({
                                item: item,
                                index: index,
                                props: slotProps
                            }) : slots.selection({
                                item: item,
                                index: index
                            })) : undefined;
                            if (hasSlot && !slotContent) return undefined;
                            return (0, $TusQn.createElementVNode)("div", {
                                "key": item.value,
                                "class": "v-select__selection"
                            }, [
                                hasChips ? !slots.chip ? (0, $TusQn.createVNode)((0, $fd0891698b65ffb1$export$1b5fab12cd17b4fb), (0, $TusQn.mergeProps)({
                                    "key": "chip",
                                    "closable": closableChips.value,
                                    "size": "small",
                                    "text": item.title,
                                    "disabled": item.props.disabled
                                }, slotProps), null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                    "key": "chip-defaults",
                                    "defaults": {
                                        VChip: {
                                            closable: closableChips.value,
                                            size: 'small',
                                            text: item.title
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slotContent
                                        ]
                                }) : slotContent ?? (0, $TusQn.createElementVNode)("span", {
                                    "class": "v-select__selection-text"
                                }, [
                                    item.title,
                                    props.multiple && index < model.value.length - 1 && (0, $TusQn.createElementVNode)("span", {
                                        "class": "v-select__selection-comma"
                                    }, [
                                        (0, $TusQn.createTextVNode)(",")
                                    ])
                                ])
                            ]);
                        })
                    ]);
                },
                'append-inner': function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots['append-inner']?.(...args),
                        props.menuIcon ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                            "class": "v-select__menu-icon",
                            "color": vTextFieldRef.value?.fieldIconColor,
                            "icon": props.menuIcon,
                            "aria-hidden": true
                        }, null) : undefined,
                        props.appendInnerIcon && (0, $TusQn.createVNode)(InputIcon, {
                            "key": "append-icon",
                            "name": "appendInner",
                            "color": args[0].iconColor.value
                        }, null)
                    ]);
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({
            isFocused: isFocused,
            menu: menu,
            search: search,
            filteredItems: filteredItems,
            select: select
        }, vTextFieldRef);
    }
});
















const $30b50b21f01bc544$export$22346519bf6a5f32 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    autoSelectFirst: {
        type: [
            Boolean,
            String
        ]
    },
    clearOnSelect: Boolean,
    search: String,
    ...(0, $06230a510138477a$export$a99bb5c4eecafb96)({
        filterKeys: [
            'title'
        ]
    }),
    ...(0, $118e5e4309583a1b$export$c210933f6eecdb37)(),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $1df180b07e489866$export$c9f7484641b0b190)({
        modelValue: null,
        role: 'combobox'
    }), [
        'validationValue',
        'dirty'
    ])
}, 'VAutocomplete');
const $30b50b21f01bc544$export$4fa8d945b1b14087 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VAutocomplete',
    props: $30b50b21f01bc544$export$22346519bf6a5f32(),
    emits: {
        'update:focused': (focused)=>true,
        'update:search': (value)=>true,
        'update:modelValue': (value)=>true,
        'update:menu': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const vTextFieldRef = (0, $01W3b.ref)();
        const isFocused = (0, $01W3b.shallowRef)(false);
        const isPristine = (0, $01W3b.shallowRef)(true);
        const listHasFocus = (0, $01W3b.shallowRef)(false);
        const vMenuRef = (0, $01W3b.ref)();
        const vVirtualScrollRef = (0, $01W3b.ref)();
        const selectionIndex = (0, $01W3b.shallowRef)(-1);
        const _searchLock = (0, $01W3b.shallowRef)(null);
        const { items: items, transformIn: transformIn, transformOut: transformOut } = (0, $9d0414e5c866e7bc$export$7bfdd97581ca93c)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>vTextFieldRef.value?.color);
        const { InputIcon: InputIcon } = (0, $9a9409ba39d4a5b8$export$d08cb507a9c34d4b)(props);
        const search = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'search', '');
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>transformIn(v === null ? [
                null
            ] : (0, $8590040a7833369a$export$76411cac38121ecb)(v)), (v)=>{
            const transformed = transformOut(v);
            return props.multiple ? transformed : transformed[0] ?? null;
        });
        const counterValue = (0, $01W3b.computed)(()=>{
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : model.value.length;
        });
        const form = (0, $72bfe1fa0cde9e24$export$87c0cf8eb5a167e0)(props);
        const { filteredItems: filteredItems, getMatches: getMatches } = (0, $06230a510138477a$export$3274cf84b703fff)(props, items, ()=>_searchLock.value ?? (isPristine.value ? '' : search.value));
        const displayItems = (0, $01W3b.computed)(()=>{
            if (props.hideSelected && _searchLock.value === null) return filteredItems.value.filter((filteredItem)=>!model.value.some((s)=>s.value === filteredItem.value));
            return filteredItems.value;
        });
        const closableChips = (0, $01W3b.toRef)(()=>props.closableChips && !form.isReadonly.value && !form.isDisabled.value);
        const hasChips = (0, $01W3b.computed)(()=>!!(props.chips || slots.chip));
        const hasSelectionSlot = (0, $01W3b.computed)(()=>hasChips.value || !!slots.selection);
        const selectedValues = (0, $01W3b.computed)(()=>model.value.map((selection)=>selection.props.value));
        const firstSelectableItem = (0, $01W3b.computed)(()=>displayItems.value.find((x)=>x.type === 'item' && !x.props.disabled));
        const highlightFirst = (0, $01W3b.computed)(()=>{
            const selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === firstSelectableItem.value?.title;
            return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
        });
        const menuDisabled = (0, $01W3b.computed)(()=>props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
        const _menu = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'menu');
        const menu = (0, $01W3b.computed)({
            get: ()=>_menu.value,
            set: (v)=>{
                if (_menu.value && !v && vMenuRef.value?.\u03A8openChildren.size) return;
                if (v && menuDisabled.value) return;
                _menu.value = v;
            }
        });
        const { menuId: menuId, ariaExpanded: ariaExpanded, ariaControls: ariaControls } = (0, $db0abbb2e7605284$export$336f022c1e31f429)(props, menu);
        const listRef = (0, $01W3b.ref)();
        const headerRef = (0, $01W3b.ref)();
        const footerRef = (0, $01W3b.ref)();
        const listEvents = (0, $31951e38cd8c6afc$export$5081bf709ff6ca2c)(listRef, vTextFieldRef);
        const { onTabKeydown: onTabKeydown } = (0, $9b72d3360b6fdbc5$export$d0c035d5199a1ad2)({
            groups: [
                {
                    type: 'element',
                    contentRef: headerRef
                },
                {
                    type: 'list',
                    contentRef: listRef,
                    displayItemsCount: ()=>displayItems.value.length
                },
                {
                    type: 'element',
                    contentRef: footerRef
                }
            ],
            onLeave: ()=>{
                menu.value = false;
                vTextFieldRef.value?.focus();
            }
        });
        function onClear(e) {
            if (props.openOnClear) menu.value = true;
            search.value = '';
        }
        function onMousedownControl() {
            if (menuDisabled.value) return;
            menu.value = true;
        }
        function onMousedownMenuIcon(e) {
            if (menuDisabled.value) return;
            if (isFocused.value) {
                e.preventDefault();
                e.stopPropagation();
            }
            menu.value = !menu.value;
        }
        function onMenuKeydown(e) {
            if (e.key === 'Tab') onTabKeydown(e);
            if (listRef.value?.$el.contains(e.target) && ((0, $8590040a7833369a$export$d9d503bf19df5a70)(e) || e.key === 'Backspace')) vTextFieldRef.value?.focus();
        }
        // eslint-disable-next-line complexity
        function onKeydown(e) {
            if (form.isReadonly.value) return;
            const selectionStart = vTextFieldRef.value?.selectionStart;
            const length = model.value.length;
            if ([
                'Enter',
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) e.preventDefault();
            if ([
                'Enter',
                'ArrowDown'
            ].includes(e.key)) menu.value = true;
            if ([
                'Escape'
            ].includes(e.key)) menu.value = false;
            if (highlightFirst.value && [
                'Enter',
                'Tab'
            ].includes(e.key) && firstSelectableItem.value && !model.value.some((_ref2)=>{
                let { value: value } = _ref2;
                return value === firstSelectableItem.value.value;
            })) select(firstSelectableItem.value);
            if (e.key === 'ArrowDown' && highlightFirst.value) listRef.value?.focus('next');
            if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
                if (~selectionIndex.value) {
                    e.preventDefault();
                    const originalSelectionIndex = selectionIndex.value;
                    select(model.value[selectionIndex.value], false);
                    selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
                } else if (e.key === 'Backspace' && !search.value) selectionIndex.value = length - 1;
                return;
            }
            if (!props.multiple) return;
            if (e.key === 'ArrowLeft') {
                if (selectionIndex.value < 0 && selectionStart && selectionStart > 0) return;
                const prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
                if (model.value[prev]) selectionIndex.value = prev;
                else {
                    const searchLength = search.value?.length ?? null;
                    selectionIndex.value = -1;
                    vTextFieldRef.value?.setSelectionRange(searchLength, searchLength);
                }
            } else if (e.key === 'ArrowRight') {
                if (selectionIndex.value < 0) return;
                const next = selectionIndex.value + 1;
                if (model.value[next]) selectionIndex.value = next;
                else {
                    selectionIndex.value = -1;
                    vTextFieldRef.value?.setSelectionRange(0, 0);
                }
            } else if (~selectionIndex.value && (0, $8590040a7833369a$export$d9d503bf19df5a70)(e)) selectionIndex.value = -1;
        }
        function onChange(e) {
            if ((0, $8590040a7833369a$export$b06a2f5618961e1e)(vTextFieldRef.value, ':autofill') || (0, $8590040a7833369a$export$b06a2f5618961e1e)(vTextFieldRef.value, ':-webkit-autofill')) {
                const item = items.value.find((item)=>item.title === e.target.value);
                if (item) select(item);
            }
        }
        function onAfterEnter() {
            if (props.eager) vVirtualScrollRef.value?.calculateVisibleItems();
        }
        function onAfterLeave() {
            if (isFocused.value) {
                isPristine.value = true;
                vTextFieldRef.value?.focus();
            }
            _searchLock.value = null;
        }
        function onFocusin(e) {
            isFocused.value = true;
            setTimeout(()=>{
                listHasFocus.value = true;
            });
        }
        function onFocusout(e) {
            listHasFocus.value = false;
        }
        function onUpdateModelValue(v) {
            if (v == null || v === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
        }
        function onBlur(e) {
            const menuContent = vMenuRef.value?.contentEl;
            if (menuContent?.contains(e.relatedTarget)) isFocused.value = true;
        }
        const isSelecting = (0, $01W3b.shallowRef)(false);
        /** @param set - null means toggle */ function select(item) {
            let set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (!item || item.props.disabled) return;
            if (props.multiple) {
                const index = model.value.findIndex((selection)=>(props.valueComparator || (0, $bf1718679e817e1f$export$9cb4719e2e525b7a))(selection.value, item.value));
                const add = set == null ? !~index : set;
                if (~index) {
                    const value = add ? [
                        ...model.value,
                        item
                    ] : [
                        ...model.value
                    ];
                    value.splice(index, 1);
                    model.value = value;
                } else if (add) model.value = [
                    ...model.value,
                    item
                ];
                if (props.clearOnSelect) search.value = '';
            } else {
                const add = set !== false;
                model.value = add ? [
                    item
                ] : [];
                _searchLock.value = isPristine.value ? '' : search.value ?? '';
                search.value = add && !hasSelectionSlot.value ? item.title : '';
                // watch for search watcher to trigger
                (0, $TusQn.nextTick)(()=>{
                    menu.value = false;
                    isPristine.value = true;
                });
            }
        }
        (0, $01W3b.watch)(isFocused, (val, oldVal)=>{
            if (val === oldVal) return;
            if (val) {
                isSelecting.value = true;
                search.value = props.multiple || hasSelectionSlot.value ? '' : String(model.value.at(-1)?.props.title ?? '');
                isPristine.value = true;
                (0, $TusQn.nextTick)(()=>isSelecting.value = false);
            } else {
                if (!props.multiple && search.value == null) model.value = [];
                menu.value = false;
                if (!isPristine.value && search.value) _searchLock.value = search.value;
                search.value = '';
                selectionIndex.value = -1;
            }
        });
        (0, $01W3b.watch)(search, (val)=>{
            if (!isFocused.value || isSelecting.value) return;
            if (val) menu.value = true;
            isPristine.value = !val;
        });
        (0, $01W3b.watch)(menu, (val)=>{
            if (!props.hideSelected && val && model.value.length && isPristine.value) {
                const index = displayItems.value.findIndex((item)=>model.value.some((s)=>item.value === s.value));
                (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && window.requestAnimationFrame(()=>{
                    index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
                });
            }
            if (val) _searchLock.value = null;
        });
        (0, $01W3b.watch)(items, (newVal, oldVal)=>{
            if (menu.value) return;
            if (isFocused.value && !oldVal.length && newVal.length) menu.value = true;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
            const isDirty = model.value.length > 0;
            const textFieldProps = (0, $1df180b07e489866$export$d591c92dea965c28).filterProps(props);
            const menuSlotProps = {
                search: search,
                filteredItems: filteredItems.value
            };
            return (0, $TusQn.createVNode)((0, $1df180b07e489866$export$d591c92dea965c28), (0, $TusQn.mergeProps)({
                "ref": vTextFieldRef
            }, textFieldProps, {
                "modelValue": search.value,
                "onUpdate:modelValue": [
                    ($event)=>search.value = $event,
                    onUpdateModelValue
                ],
                "focused": isFocused.value,
                "onUpdate:focused": ($event)=>isFocused.value = $event,
                "validationValue": model.externalValue,
                "counterValue": counterValue.value,
                "dirty": isDirty,
                "onChange": onChange,
                "class": [
                    'v-autocomplete',
                    `v-autocomplete--${props.multiple ? 'multiple' : 'single'}`,
                    {
                        'v-autocomplete--active-menu': menu.value,
                        'v-autocomplete--chips': !!props.chips,
                        'v-autocomplete--selection-slot': !!hasSelectionSlot.value,
                        'v-autocomplete--selecting-index': selectionIndex.value > -1
                    },
                    props.class
                ],
                "style": props.style,
                "readonly": form.isReadonly.value,
                "placeholder": isDirty ? undefined : props.placeholder,
                "onClick:clear": onClear,
                "onMousedown:control": onMousedownControl,
                "onKeydown": onKeydown,
                "onBlur": onBlur,
                "aria-expanded": ariaExpanded.value,
                "aria-controls": ariaControls.value
            }), {
                ...slots,
                default: (_ref3)=>{
                    let { id: id } = _ref3;
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createVNode)((0, $9208258024e22101$export$a347888d6b8f252a), (0, $TusQn.mergeProps)({
                            "id": menuId.value,
                            "ref": vMenuRef,
                            "modelValue": menu.value,
                            "onUpdate:modelValue": ($event)=>menu.value = $event,
                            "activator": "parent",
                            "contentClass": "v-autocomplete__content",
                            "disabled": menuDisabled.value,
                            "eager": props.eager,
                            "maxHeight": 310,
                            "openOnClick": false,
                            "closeOnContentClick": false,
                            "onAfterEnter": onAfterEnter,
                            "onAfterLeave": onAfterLeave
                        }, props.menuProps), {
                            default: ()=>[
                                    (0, $TusQn.createVNode)((0, $ce059966358db8b1$export$d41b26ce18186ef0), {
                                        "onFocusin": onFocusin,
                                        "onKeydown": onMenuKeydown
                                    }, {
                                        default: ()=>[
                                                slots['menu-header'] && (0, $TusQn.createElementVNode)("header", {
                                                    "ref": headerRef
                                                }, [
                                                    slots['menu-header'](menuSlotProps)
                                                ]),
                                                hasList && (0, $TusQn.createVNode)((0, $8f3cccf9308874bc$export$3b010b0401837103), (0, $TusQn.mergeProps)({
                                                    "key": "autocomplete-list",
                                                    "ref": listRef,
                                                    "filterable": true,
                                                    "selected": selectedValues.value,
                                                    "selectStrategy": props.multiple ? 'independent' : 'single-independent',
                                                    "onMousedown": (e)=>e.preventDefault(),
                                                    "onFocusout": onFocusout,
                                                    "tabindex": "-1",
                                                    "selectable": !!displayItems.value.length,
                                                    "aria-live": "polite",
                                                    "aria-labelledby": `${id.value}-label`,
                                                    "aria-multiselectable": props.multiple,
                                                    "color": props.itemColor ?? props.color
                                                }, listEvents, props.listProps), {
                                                    default: ()=>[
                                                            slots['prepend-item']?.(),
                                                            !displayItems.value.length && !props.hideNoData && (slots['no-data']?.() ?? (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), {
                                                                "key": "no-data",
                                                                "title": t(props.noDataText)
                                                            }, null)),
                                                            (0, $TusQn.createVNode)((0, $28b14115b5680302$export$bdb136bf2d9028a4), {
                                                                "ref": vVirtualScrollRef,
                                                                "renderless": true,
                                                                "items": displayItems.value,
                                                                "itemKey": "value"
                                                            }, {
                                                                default: (_ref4)=>{
                                                                    let { item: item, index: index, itemRef: itemRef } = _ref4;
                                                                    const itemProps = (0, $TusQn.mergeProps)(item.props, {
                                                                        ref: itemRef,
                                                                        key: item.value,
                                                                        active: highlightFirst.value && item === firstSelectableItem.value ? true : undefined,
                                                                        onClick: ()=>select(item, null),
                                                                        'aria-posinset': index + 1,
                                                                        'aria-setsize': displayItems.value.length
                                                                    });
                                                                    if (item.type === 'divider') return slots.divider?.({
                                                                        props: item.raw,
                                                                        index: index
                                                                    }) ?? (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), (0, $TusQn.mergeProps)(item.props, {
                                                                        "key": `divider-${index}`
                                                                    }), null);
                                                                    if (item.type === 'subheader') return slots.subheader?.({
                                                                        props: item.raw,
                                                                        index: index
                                                                    }) ?? (0, $TusQn.createVNode)((0, $96a2eb5e8711f0cc$export$70c4aba7bf48e22a), (0, $TusQn.mergeProps)(item.props, {
                                                                        "key": `subheader-${index}`
                                                                    }), null);
                                                                    return slots.item?.({
                                                                        item: item,
                                                                        index: index,
                                                                        props: itemProps
                                                                    }) ?? (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), (0, $TusQn.mergeProps)(itemProps, {
                                                                        "role": "option"
                                                                    }), {
                                                                        prepend: (_ref5)=>{
                                                                            let { isSelected: isSelected } = _ref5;
                                                                            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                                                                props.multiple && !props.hideSelected ? (0, $TusQn.createVNode)((0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6), {
                                                                                    "key": item.value,
                                                                                    "modelValue": isSelected,
                                                                                    "ripple": false,
                                                                                    "tabindex": "-1",
                                                                                    "aria-hidden": true,
                                                                                    "onClick": (event)=>event.preventDefault()
                                                                                }, null) : undefined,
                                                                                item.props.prependAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                                                                    "image": item.props.prependAvatar
                                                                                }, null),
                                                                                item.props.prependIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                                                                    "icon": item.props.prependIcon
                                                                                }, null)
                                                                            ]);
                                                                        },
                                                                        title: ()=>{
                                                                            return isPristine.value ? item.title : (0, $06230a510138477a$export$71650bdcd27abbc4)('v-autocomplete', item.title, getMatches(item)?.title);
                                                                        }
                                                                    });
                                                                }
                                                            }),
                                                            slots['append-item']?.()
                                                        ]
                                                }),
                                                slots['menu-footer'] && (0, $TusQn.createElementVNode)("footer", {
                                                    "ref": footerRef
                                                }, [
                                                    slots['menu-footer'](menuSlotProps)
                                                ])
                                            ]
                                    })
                                ]
                        }),
                        model.value.map((item, index)=>{
                            function onChipClose(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                select(item, false);
                            }
                            const slotProps = (0, $TusQn.mergeProps)((0, $fd0891698b65ffb1$export$1b5fab12cd17b4fb).filterProps(item.props), {
                                'onClick:close': onChipClose,
                                onKeydown (e) {
                                    if (e.key !== 'Enter' && e.key !== ' ') return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onChipClose(e);
                                },
                                onMousedown (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                modelValue: true,
                                'onUpdate:modelValue': undefined
                            });
                            const hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
                            const slotContent = hasSlot ? (0, $8590040a7833369a$export$9fc41f261330971f)(hasChips.value ? slots.chip({
                                item: item,
                                index: index,
                                props: slotProps
                            }) : slots.selection({
                                item: item,
                                index: index
                            })) : undefined;
                            if (hasSlot && !slotContent) return undefined;
                            return (0, $TusQn.createElementVNode)("div", {
                                "key": item.value,
                                "class": (0, $8POXm.normalizeClass)([
                                    'v-autocomplete__selection',
                                    index === selectionIndex.value && [
                                        'v-autocomplete__selection--selected',
                                        textColorClasses.value
                                    ]
                                ]),
                                "style": (0, $8POXm.normalizeStyle)(index === selectionIndex.value ? textColorStyles.value : {})
                            }, [
                                hasChips.value ? !slots.chip ? (0, $TusQn.createVNode)((0, $fd0891698b65ffb1$export$1b5fab12cd17b4fb), (0, $TusQn.mergeProps)({
                                    "key": "chip",
                                    "closable": closableChips.value,
                                    "size": "small",
                                    "text": item.title,
                                    "disabled": item.props.disabled
                                }, slotProps), null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                    "key": "chip-defaults",
                                    "defaults": {
                                        VChip: {
                                            closable: closableChips.value,
                                            size: 'small',
                                            text: item.title
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slotContent
                                        ]
                                }) : slotContent ?? (0, $TusQn.createElementVNode)("span", {
                                    "class": "v-autocomplete__selection-text"
                                }, [
                                    item.title,
                                    props.multiple && index < model.value.length - 1 && (0, $TusQn.createElementVNode)("span", {
                                        "class": "v-autocomplete__selection-comma"
                                    }, [
                                        (0, $TusQn.createTextVNode)(",")
                                    ])
                                ])
                            ]);
                        })
                    ]);
                },
                'append-inner': function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots['append-inner']?.(...args),
                        props.menuIcon ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                            "class": "v-autocomplete__menu-icon",
                            "color": vTextFieldRef.value?.fieldIconColor,
                            "icon": props.menuIcon,
                            "onMousedown": onMousedownMenuIcon,
                            "onClick": (0, $8590040a7833369a$export$8793edee2d425525),
                            "aria-hidden": true,
                            "tabindex": "-1"
                        }, null) : undefined,
                        props.appendInnerIcon && (0, $TusQn.createVNode)(InputIcon, {
                            "key": "append-icon",
                            "name": "appendInner",
                            "color": args[0].iconColor.value
                        }, null)
                    ]);
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({
            isFocused: isFocused,
            isPristine: isPristine,
            menu: menu,
            search: search,
            filteredItems: filteredItems,
            select: select
        }, vTextFieldRef);
    }
});




var $b2b68bd3ae60455a$exports = {};

$parcel$export($b2b68bd3ae60455a$exports, "VAvatar", () => $acc7f6236cd87eac$export$dbee61bc703cd5ff);



var $ca444c3a57a6644f$exports = {};

$parcel$export($ca444c3a57a6644f$exports, "VBadge", () => $6dbda73bad13a718$export$756a89601026c160);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");













const $6dbda73bad13a718$export$7cb2ab2d38a3d5cf = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    bordered: Boolean,
    color: String,
    content: [
        Number,
        String
    ],
    dot: Boolean,
    floating: Boolean,
    icon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    inline: Boolean,
    label: {
        type: String,
        default: '$vuetify.badge'
    },
    max: [
        Number,
        String
    ],
    modelValue: {
        type: Boolean,
        default: true
    },
    offsetX: [
        Number,
        String
    ],
    offsetY: [
        Number,
        String
    ],
    textColor: String,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $636e88b893afba47$export$2831add577f947cb)({
        location: 'top end'
    }),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e)({
        transition: 'scale-rotate-transition'
    }),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)()
}, 'VBadge');
const $6dbda73bad13a718$export$756a89601026c160 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBadge',
    inheritAttrs: false,
    props: $6dbda73bad13a718$export$7cb2ab2d38a3d5cf(),
    setup (props, ctx) {
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.textColor);
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$93d4e7f90805808f)();
        const { locationStyles: locationStyles } = (0, $636e88b893afba47$export$45d76561a5302f2b)(props, true, (side)=>{
            const base = props.floating ? props.dot ? 2 : 4 : props.dot ? 8 : 12;
            return base + ([
                'top',
                'bottom'
            ].includes(side) ? Number(props.offsetY ?? 0) : [
                'left',
                'right'
            ].includes(side) ? Number(props.offsetX ?? 0) : 0);
        });
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const value = Number(props.content);
            const content = !props.max || isNaN(value) ? props.content : value <= Number(props.max) ? value : `${props.max}+`;
            const [badgeAttrs, attrs] = (0, $8590040a7833369a$export$b25139123a794551)(ctx.attrs, [
                'aria-atomic',
                'aria-label',
                'aria-live',
                'role',
                'title'
            ]);
            return (0, $TusQn.createVNode)(props.tag, (0, $TusQn.mergeProps)({
                "class": [
                    'v-badge',
                    {
                        'v-badge--bordered': props.bordered,
                        'v-badge--dot': props.dot,
                        'v-badge--floating': props.floating,
                        'v-badge--inline': props.inline
                    },
                    props.class
                ]
            }, attrs, {
                "style": props.style
            }), {
                default: ()=>[
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-badge__wrapper"
                        }, [
                            ctx.slots.default?.(),
                            (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                                "transition": props.transition
                            }, {
                                default: ()=>[
                                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("span", (0, $TusQn.mergeProps)({
                                            "class": [
                                                'v-badge__badge',
                                                themeClasses.value,
                                                backgroundColorClasses.value,
                                                roundedClasses.value,
                                                textColorClasses.value
                                            ],
                                            "style": [
                                                backgroundColorStyles.value,
                                                textColorStyles.value,
                                                dimensionStyles.value,
                                                props.inline ? {} : locationStyles.value
                                            ],
                                            "aria-atomic": "true",
                                            "aria-label": t(props.label, value),
                                            "aria-live": "polite",
                                            "role": "status"
                                        }, badgeAttrs), [
                                            props.dot ? undefined : ctx.slots.badge ? ctx.slots.badge?.() : props.icon ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                                "icon": props.icon
                                            }, null) : content
                                        ]), [
                                            [
                                                (0, $eeJ70.vShow),
                                                props.modelValue
                                            ]
                                        ])
                                    ]
                            })
                        ])
                    ]
            });
        });
        return {};
    }
});




var $ed0b086061beadb8$exports = {};

$parcel$export($ed0b086061beadb8$exports, "VBanner", () => $d31662a3d3855c16$export$c2d33ab72aac6785);
$parcel$export($ed0b086061beadb8$exports, "VBannerActions", () => $e04fa1759df35a0b$export$e69c7c0ca29b4fe6);
$parcel$export($ed0b086061beadb8$exports, "VBannerText", () => $2edca5a7fe79e789$export$158eb3bfc74b118);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



const $e04fa1759df35a0b$export$189027806d15462b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    density: String,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VBannerActions');
const $e04fa1759df35a0b$export$e69c7c0ca29b4fe6 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBannerActions',
    props: $e04fa1759df35a0b$export$189027806d15462b(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                color: props.color,
                density: props.density,
                slim: true,
                variant: 'text'
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-banner-actions',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, [
                slots.default?.()
            ]));
        return {};
    }
});


// Utilities

const $2edca5a7fe79e789$export$158eb3bfc74b118 = (0, $5224ab9d69b8c3e0$export$b3680ae2c271b9f3)('v-banner-text');



















const $d31662a3d3855c16$export$292ce6c93f0af4a8 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    avatar: String,
    bgColor: String,
    color: String,
    icon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    lines: String,
    stacked: Boolean,
    sticky: Boolean,
    text: String,
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $1444e2cf1a712792$export$d0badecb383b472a)({
        mobile: null
    }),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $636e88b893afba47$export$2831add577f947cb)(),
    ...(0, $572b8e75d6c9689d$export$f84374c9369ae887)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VBanner');
const $d31662a3d3855c16$export$c2d33ab72aac6785 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBanner',
    props: $d31662a3d3855c16$export$292ce6c93f0af4a8(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { displayClasses: displayClasses, mobile: mobile } = (0, $1444e2cf1a712792$export$8406b7efc286d284)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { locationStyles: locationStyles } = (0, $636e88b893afba47$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $572b8e75d6c9689d$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const color = (0, $01W3b.toRef)(()=>props.color);
        const density = (0, $01W3b.toRef)(()=>props.density);
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VBannerActions: {
                color: color,
                density: density
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasText = !!(props.text || slots.text);
            const hasPrependMedia = !!(props.avatar || props.icon);
            const hasPrepend = !!(hasPrependMedia || slots.prepend);
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-banner',
                    {
                        'v-banner--stacked': props.stacked || mobile.value,
                        'v-banner--sticky': props.sticky,
                        [`v-banner--${props.lines}-line`]: !!props.lines
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    displayClasses.value,
                    elevationClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    props.style
                ]),
                "role": "banner"
            }, {
                default: ()=>[
                        hasPrepend && (0, $TusQn.createElementVNode)("div", {
                            "key": "prepend",
                            "class": "v-banner__prepend"
                        }, [
                            !slots.prepend ? (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                "key": "prepend-avatar",
                                "color": color.value,
                                "density": density.value,
                                "icon": props.icon,
                                "image": props.avatar
                            }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !hasPrependMedia,
                                "defaults": {
                                    VAvatar: {
                                        color: color.value,
                                        density: density.value,
                                        icon: props.icon,
                                        image: props.avatar
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-banner__content"
                        }, [
                            hasText && (0, $TusQn.createVNode)((0, $2edca5a7fe79e789$export$158eb3bfc74b118), {
                                "key": "text"
                            }, {
                                default: ()=>[
                                        slots.text?.() ?? props.text
                                    ]
                            }),
                            slots.default?.()
                        ]),
                        slots.actions && (0, $TusQn.createVNode)((0, $e04fa1759df35a0b$export$e69c7c0ca29b4fe6), {
                            "key": "actions"
                        }, slots.actions)
                    ]
            });
        });
    }
});






var $b9cb57178cbe1437$exports = {};

$parcel$export($b9cb57178cbe1437$exports, "VBottomNavigation", () => $e48dcbad6b711dea$export$a78f8fd6d8f91925);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
















const $e48dcbad6b711dea$export$e625b1378c94739b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    baseColor: String,
    bgColor: String,
    color: String,
    grow: Boolean,
    mode: {
        type: String,
        validator: (v)=>!v || [
                'horizontal',
                'shift'
            ].includes(v)
    },
    height: {
        type: [
            Number,
            String
        ],
        default: 56
    },
    active: {
        type: Boolean,
        default: true
    },
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $56e08e0125137781$export$d42abac634ace931)({
        name: 'bottom-navigation'
    }),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'header'
    }),
    ...(0, $0befa53cf46b542b$export$fa4c05b3520340e6)({
        selectedClass: 'v-btn--selected'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VBottomNavigation');
const $e48dcbad6b711dea$export$a78f8fd6d8f91925 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBottomNavigation',
    props: $e48dcbad6b711dea$export$e625b1378c94739b(),
    emits: {
        'update:active': (value)=>true,
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$93d4e7f90805808f)();
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { ssrBootStyles: ssrBootStyles } = (0, $0f95b8d0184d7fa9$export$f385cca8ac2b2f35)();
        const height = (0, $01W3b.computed)(()=>Number(props.height) - (props.density === 'comfortable' ? 8 : 0) - (props.density === 'compact' ? 16 : 0));
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'active', props.active);
        const { layoutItemStyles: layoutItemStyles } = (0, $56e08e0125137781$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $01W3b.computed)(()=>parseInt(props.order, 10)),
            position: (0, $01W3b.toRef)(()=>'bottom'),
            layoutSize: (0, $01W3b.toRef)(()=>isActive.value ? height.value : 0),
            elementSize: height,
            active: isActive,
            absolute: (0, $01W3b.toRef)(()=>props.absolute)
        });
        (0, $0befa53cf46b542b$export$bfb6a372146ddc96)(props, (0, $b08d2d2d797cb622$export$7ccf67e9366faa19));
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                baseColor: (0, $01W3b.toRef)(()=>props.baseColor),
                color: (0, $01W3b.toRef)(()=>props.color),
                density: (0, $01W3b.toRef)(()=>props.density),
                stacked: (0, $01W3b.toRef)(()=>props.mode !== 'horizontal'),
                variant: 'text'
            }
        }, {
            scoped: true
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-bottom-navigation',
                    {
                        'v-bottom-navigation--active': isActive.value,
                        'v-bottom-navigation--grow': props.grow,
                        'v-bottom-navigation--shift': props.mode === 'shift'
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    layoutItemStyles.value,
                    {
                        height: (0, $8590040a7833369a$export$286ad215293a0860)(height.value)
                    },
                    ssrBootStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        slots.default && (0, $TusQn.createElementVNode)("div", {
                            "class": "v-bottom-navigation__content"
                        }, [
                            slots.default()
                        ])
                    ]
            });
        });
        return {};
    }
});




var $f08aaa852fcc04ca$exports = {};

$parcel$export($f08aaa852fcc04ca$exports, "VBottomSheet", () => $60edee8a281ec134$export$ffa2be562e251695);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");









const $cfe199962634e1c9$export$1dd88499e1cfbb15 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    fullscreen: Boolean,
    scrollable: Boolean,
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $0eb6b57fb5d95344$export$357b25d59a7fb3fa)({
        captureFocus: true,
        origin: 'center center',
        scrollStrategy: 'block',
        transition: {
            component: (0, $6d83cccc3a7f7c51$export$9778a08df954f36c)
        },
        zIndex: 2400,
        retainFocus: true
    }), [
        'disableInitialFocus'
    ])
}, 'VDialog');
const $cfe199962634e1c9$export$d399a452706dd20b = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDialog',
    props: $cfe199962634e1c9$export$1dd88499e1cfbb15(),
    emits: {
        'update:modelValue': (value)=>true,
        afterEnter: ()=>true,
        afterLeave: ()=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { scopeId: scopeId } = (0, $d897445671465531$export$eeabe5cda932100d)();
        const overlay = (0, $01W3b.ref)();
        function onAfterEnter() {
            emit('afterEnter');
            if ((props.scrim || props.retainFocus) && overlay.value?.contentEl && !overlay.value.contentEl.contains(document.activeElement)) overlay.value.contentEl.focus({
                preventScroll: true
            });
        }
        function onAfterLeave() {
            emit('afterLeave');
        }
        (0, $01W3b.watch)(isActive, async (val)=>{
            if (!val) {
                await (0, $TusQn.nextTick)();
                overlay.value.activatorEl?.focus({
                    preventScroll: true
                });
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const overlayProps = (0, $0eb6b57fb5d95344$export$32caf7e8170352aa).filterProps(props);
            const activatorProps = (0, $TusQn.mergeProps)({
                'aria-haspopup': 'dialog'
            }, props.activatorProps);
            const contentProps = (0, $TusQn.mergeProps)({
                tabindex: -1
            }, props.contentProps);
            return (0, $TusQn.createVNode)((0, $0eb6b57fb5d95344$export$32caf7e8170352aa), (0, $TusQn.mergeProps)({
                "ref": overlay,
                "class": [
                    'v-dialog',
                    {
                        'v-dialog--fullscreen': props.fullscreen,
                        'v-dialog--scrollable': props.scrollable
                    },
                    props.class
                ],
                "style": props.style
            }, overlayProps, {
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "aria-modal": "true",
                "activatorProps": activatorProps,
                "contentProps": contentProps,
                "height": !props.fullscreen ? props.height : undefined,
                "width": !props.fullscreen ? props.width : undefined,
                "maxHeight": !props.fullscreen ? props.maxHeight : undefined,
                "maxWidth": !props.fullscreen ? props.maxWidth : undefined,
                "role": "dialog",
                "onAfterEnter": onAfterEnter,
                "onAfterLeave": onAfterLeave
            }, scopeId), {
                activator: slots.activator,
                default: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                        "root": "VDialog"
                    }, {
                        default: ()=>[
                                slots.default?.(...args)
                            ]
                    });
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, overlay);
    }
});




const $60edee8a281ec134$export$157847aac9a791f2 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    inset: Boolean,
    ...(0, $cfe199962634e1c9$export$1dd88499e1cfbb15)({
        transition: 'bottom-sheet-transition'
    })
}, 'VBottomSheet');
const $60edee8a281ec134$export$ffa2be562e251695 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBottomSheet',
    props: $60edee8a281ec134$export$157847aac9a791f2(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const dialogProps = (0, $cfe199962634e1c9$export$d399a452706dd20b).filterProps(props);
            return (0, $TusQn.createVNode)((0, $cfe199962634e1c9$export$d399a452706dd20b), (0, $TusQn.mergeProps)(dialogProps, {
                "contentClass": [
                    'v-bottom-sheet__content',
                    props.contentClass
                ],
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "class": [
                    'v-bottom-sheet',
                    {
                        'v-bottom-sheet--inset': props.inset
                    },
                    props.class
                ],
                "style": props.style
            }), slots);
        });
        return {};
    }
});




var $237097937e36c9fd$exports = {};

$parcel$export($237097937e36c9fd$exports, "VBreadcrumbs", () => $169aafc5845b356a$export$4adad37ff360fc23);
$parcel$export($237097937e36c9fd$exports, "VBreadcrumbsItem", () => $508d8a7771f46ae8$export$df843ef038f9da80);
$parcel$export($237097937e36c9fd$exports, "VBreadcrumbsDivider", () => $c2f8506a0f8102b2$export$bfb57897322e706b);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");


const $c2f8506a0f8102b2$export$b093c80cf91e2910 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    divider: [
        Number,
        String
    ],
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VBreadcrumbsDivider');
const $c2f8506a0f8102b2$export$bfb57897322e706b = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBreadcrumbsDivider',
    props: $c2f8506a0f8102b2$export$b093c80cf91e2910(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("li", {
                "aria-hidden": "true",
                "class": (0, $8POXm.normalizeClass)([
                    'v-breadcrumbs-divider',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, [
                slots?.default?.() ?? props.divider
            ]));
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");






const $508d8a7771f46ae8$export$339a9a46f2eb74a8 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    active: Boolean,
    activeClass: String,
    activeColor: String,
    color: String,
    disabled: Boolean,
    title: String,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $159635b8c4ce014b$export$f37f46640cc8dd75)(), [
        'width',
        'maxWidth'
    ]),
    ...(0, $1c0236248fe13b4c$export$78d5db5e8f9b041d)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'li'
    })
}, 'VBreadcrumbsItem');
const $508d8a7771f46ae8$export$df843ef038f9da80 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBreadcrumbsItem',
    props: $508d8a7771f46ae8$export$339a9a46f2eb74a8(),
    setup (props, _ref) {
        let { slots: slots, attrs: attrs } = _ref;
        const link = (0, $1c0236248fe13b4c$export$dcf14c9974fe2767)(props, attrs);
        const isActive = (0, $01W3b.computed)(()=>props.active || link.isActive?.value);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>isActive.value ? props.activeColor : props.color);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-breadcrumbs-item',
                    {
                        'v-breadcrumbs-item--active': isActive.value,
                        'v-breadcrumbs-item--disabled': props.disabled,
                        [`${props.activeClass}`]: isActive.value && props.activeClass
                    },
                    textColorClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    textColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ]),
                "aria-current": isActive.value ? 'page' : undefined
            }, {
                default: ()=>[
                        !link.isLink.value ? slots.default?.() ?? props.title : (0, $TusQn.createElementVNode)("a", (0, $TusQn.mergeProps)({
                            "class": "v-breadcrumbs-item--link",
                            "onClick": link.navigate.value
                        }, link.linkProps), [
                            slots.default?.() ?? props.title
                        ])
                    ]
            });
        });
        return {};
    }
});












const $169aafc5845b356a$export$4c1cf1d12d4da1ac = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    activeClass: String,
    activeColor: String,
    bgColor: String,
    color: String,
    disabled: Boolean,
    divider: {
        type: String,
        default: '/'
    },
    icon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    items: {
        type: Array,
        default: ()=>[]
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'ul'
    })
}, 'VBreadcrumbs');
const $169aafc5845b356a$export$4adad37ff360fc23 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBreadcrumbs',
    props: $169aafc5845b356a$export$4c1cf1d12d4da1ac(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VBreadcrumbsDivider: {
                divider: (0, $01W3b.toRef)(()=>props.divider)
            },
            VBreadcrumbsItem: {
                activeClass: (0, $01W3b.toRef)(()=>props.activeClass),
                activeColor: (0, $01W3b.toRef)(()=>props.activeColor),
                color: (0, $01W3b.toRef)(()=>props.color),
                disabled: (0, $01W3b.toRef)(()=>props.disabled)
            }
        });
        const items = (0, $01W3b.computed)(()=>props.items.map((item)=>{
                return typeof item === 'string' ? {
                    item: {
                        title: item
                    },
                    raw: item
                } : {
                    item: item,
                    raw: item
                };
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasPrepend = !!(slots.prepend || props.icon);
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-breadcrumbs',
                    backgroundColorClasses.value,
                    densityClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        hasPrepend && (0, $TusQn.createElementVNode)("li", {
                            "key": "prepend",
                            "class": "v-breadcrumbs__prepend"
                        }, [
                            !slots.prepend ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                "key": "prepend-icon",
                                "start": true,
                                "icon": props.icon
                            }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !props.icon,
                                "defaults": {
                                    VIcon: {
                                        icon: props.icon,
                                        start: true
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        items.value.map((_ref2, index, array)=>{
                            let { item: item, raw: raw } = _ref2;
                            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                slots.item?.({
                                    item: item,
                                    index: index
                                }) ?? (0, $TusQn.createVNode)((0, $508d8a7771f46ae8$export$df843ef038f9da80), (0, $TusQn.mergeProps)({
                                    "key": index,
                                    "disabled": index >= array.length - 1
                                }, typeof item === 'string' ? {
                                    title: item
                                } : item), {
                                    default: slots.title ? ()=>slots.title?.({
                                            item: item,
                                            index: index
                                        }) : undefined
                                }),
                                index < array.length - 1 && (0, $TusQn.createVNode)((0, $c2f8506a0f8102b2$export$bfb57897322e706b), null, {
                                    default: slots.divider ? ()=>slots.divider?.({
                                            item: raw,
                                            index: index
                                        }) : undefined
                                })
                            ]);
                        }),
                        slots.default?.()
                    ]
            });
        });
        return {};
    }
});






var $7c4f9b0b38ecbcd1$exports = {};

$parcel$export($7c4f9b0b38ecbcd1$exports, "VBtn", () => $a343b25403be30b7$export$657f28cf887b91a6);



var $45e1890342be83db$exports = {};

$parcel$export($45e1890342be83db$exports, "VBtnGroup", () => $b1d00c9a9b585242$export$9901e555ac223efb);



var $2df59982fba7fb16$exports = {};

$parcel$export($2df59982fba7fb16$exports, "VBtnToggle", () => $b08d2d2d797cb622$export$2097e77d7f4058c7);



var $04065abceb254e5d$exports = {};

$parcel$export($04065abceb254e5d$exports, "VCalendar", () => $f41775a2d5957979$export$f7fa51e4c8e83b1f);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");



parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");














const $f05757d4ecc644dc$export$d61af62663b9b046 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    active: {
        type: Boolean,
        default: undefined
    },
    activeColor: String,
    activeIcon: [
        String,
        Function,
        Object
    ],
    activeVariant: String,
    baseVariant: {
        type: String,
        default: 'tonal'
    },
    disabled: Boolean,
    height: [
        Number,
        String
    ],
    width: [
        Number,
        String
    ],
    hideOverlay: Boolean,
    icon: [
        String,
        Function,
        Object
    ],
    iconColor: String,
    loading: Boolean,
    opacity: [
        Number,
        String
    ],
    readonly: Boolean,
    rotate: [
        Number,
        String
    ],
    size: {
        type: [
            Number,
            String
        ],
        default: 'default'
    },
    sizes: {
        type: Array,
        default: ()=>[
                [
                    'x-small',
                    16
                ],
                [
                    'small',
                    24
                ],
                [
                    'default',
                    40
                ],
                [
                    'large',
                    48
                ],
                [
                    'x-large',
                    56
                ]
            ]
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $49fd8db83c6afc6c$export$32a89e97443766e5)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'button'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'flat'
    })
}, 'VIconBtn');
const $f05757d4ecc644dc$export$d35ef2d5f4f4551c = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VIconBtn',
    props: $f05757d4ecc644dc$export$d61af62663b9b046(),
    emits: {
        'update:active': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'active');
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $567f01637e3e83ec$export$36ef81613f8f20fc)(()=>({
                color: (()=>{
                    if (props.disabled) return undefined;
                    if (!isActive.value) return props.color;
                    // Use an inline fallback as opposed to setting a default color
                    // because non-toggle buttons are default flat whereas toggle
                    // buttons are default tonal and active flat. The exact use
                    // case for this is a toggle button with no active color.
                    return props.activeColor ?? props.color ?? 'surface-variant';
                })(),
                variant: (()=>{
                    if (isActive.value === undefined) return props.variant;
                    if (isActive.value) return props.activeVariant ?? props.variant;
                    return props.baseVariant ?? props.variant;
                })()
            }));
        const btnSizeMap = new Map(props.sizes);
        function onClick() {
            if (props.disabled || props.readonly || isActive.value === undefined || props.tag === 'a' && attrs.href) return;
            isActive.value = !isActive.value;
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const icon = isActive.value ? props.activeIcon ?? props.icon : props.icon;
            const _btnSize = props.size;
            const hasNamedSize = btnSizeMap.has(_btnSize);
            const btnSize = hasNamedSize ? btnSizeMap.get(_btnSize) : _btnSize;
            const btnHeight = props.height ?? btnSize;
            const btnWidth = props.width ?? btnSize;
            const { iconSize: iconSize } = (0, $49fd8db83c6afc6c$export$d456a6cf49d1aad6)(props, ()=>new Map(props.iconSizes).get(_btnSize));
            const iconProps = {
                icon: icon,
                size: iconSize.value,
                color: props.iconColor,
                opacity: props.opacity
            };
            return (0, $TusQn.createVNode)(props.tag, {
                "type": props.tag === 'button' ? 'button' : undefined,
                "class": (0, $8POXm.normalizeClass)([
                    {
                        'v-icon-btn': true,
                        'v-icon-btn--active': isActive.value,
                        'v-icon-btn--disabled': props.disabled,
                        'v-icon-btn--loading': props.loading,
                        'v-icon-btn--readonly': props.readonly,
                        [`v-icon-btn--${props.size}`]: true
                    },
                    themeClasses.value,
                    colorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-icon-btn-rotate': (0, $8590040a7833369a$export$286ad215293a0860)(props.rotate, 'deg'),
                        '--v-icon-btn-height': (0, $8590040a7833369a$export$286ad215293a0860)(btnHeight),
                        '--v-icon-btn-width': (0, $8590040a7833369a$export$286ad215293a0860)(btnWidth)
                    },
                    colorStyles.value,
                    props.style
                ]),
                "tabindex": props.disabled || props.readonly ? -1 : 0,
                "onClick": onClick
            }, {
                default: ()=>[
                        (0, $567f01637e3e83ec$export$e27cd265ed232373)(!props.hideOverlay, 'v-icon-btn'),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-icon-btn__content",
                            "data-no-activator": ""
                        }, [
                            !slots.default && icon ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), (0, $TusQn.mergeProps)({
                                "key": "content-icon"
                            }, iconProps), null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "content-defaults",
                                "disabled": !icon,
                                "defaults": {
                                    VIcon: {
                                        ...iconProps
                                    }
                                }
                            }, {
                                default: ()=>slots.default?.() ?? (0, $8POXm.toDisplayString)(props.text)
                            })
                        ]),
                        !!props.loading && (0, $TusQn.createElementVNode)("span", {
                            "key": "loader",
                            "class": "v-icon-btn__loader"
                        }, [
                            slots.loader?.() ?? (0, $TusQn.createVNode)((0, $26f3a281106a205d$export$2b4afd8de42c0c21), {
                                "color": typeof props.loading === 'boolean' ? undefined : props.loading,
                                "indeterminate": "disable-shrink",
                                "width": "2",
                                "size": iconSize.value
                            }, null)
                        ])
                    ]
            });
        });
        return {};
    }
});


// Composables
// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
function $4b46046dc9bf1cfd$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
}


const $f32372070b64b5ae$export$d667538f0d39ccbc = /^(\d{4})-(\d{1,2})(-(\d{1,2}))?([^\d]+(\d{1,2}))?(:(\d{1,2}))?(:(\d{1,2}))?$/;
const $f32372070b64b5ae$export$7c971e80bdf56c29 = /(\d\d?)(:(\d\d?)|)(:(\d\d?)|)/;
const $f32372070b64b5ae$export$fa53a399e4b6b821 = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $f32372070b64b5ae$export$b015633a9816886c = [
    0,
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $f32372070b64b5ae$export$60a714e75b55f438 = 28;
const $f32372070b64b5ae$export$5ccd0df9c49c1f5f = 31;
const $f32372070b64b5ae$export$6b344f8693e1dade = 12;
const $f32372070b64b5ae$export$c71f787df6a8523 = 1;
const $f32372070b64b5ae$export$f0d374539487f66 = 1;
const $f32372070b64b5ae$export$f669a45420d15194 = 7;
const $f32372070b64b5ae$export$802677262e924bef = 60;
const $f32372070b64b5ae$export$d91839fc8da0ba2a = 59;
const $f32372070b64b5ae$export$5eae234f5f3162be = 1440;
const $f32372070b64b5ae$export$db433e91a7c4594 = 24;
const $f32372070b64b5ae$export$497c16ed077d7bd0 = 23;
const $f32372070b64b5ae$export$27b147670908da68 = 0;
const $f32372070b64b5ae$export$f05f11922a752304 = 10000;
const $f32372070b64b5ae$export$7fc74efb02a6f761 = 100;
const $f32372070b64b5ae$export$98cc082a460226e5 = 100;
const $f32372070b64b5ae$export$41146f115a887cb8 = 10000;
function $f32372070b64b5ae$export$548348775833e7f8(timestamp, weekdays, today) {
    const start = $f32372070b64b5ae$export$1d1e1fb06fb01050(timestamp);
    $f32372070b64b5ae$export$ee1634550ff107d4(start, weekdays[0], $f32372070b64b5ae$export$83d9f8120102adf8);
    $f32372070b64b5ae$export$311eb4d04bca27b0(start);
    if (today) $f32372070b64b5ae$export$691f4625508e8fd4(start, today, start.hasTime);
    return start;
}
function $f32372070b64b5ae$export$82940377b1d9aa33(timestamp, weekdays, today) {
    const end = $f32372070b64b5ae$export$1d1e1fb06fb01050(timestamp);
    $f32372070b64b5ae$export$ee1634550ff107d4(end, weekdays[weekdays.length - 1]);
    $f32372070b64b5ae$export$311eb4d04bca27b0(end);
    if (today) $f32372070b64b5ae$export$691f4625508e8fd4(end, today, end.hasTime);
    return end;
}
function $f32372070b64b5ae$export$fb9b45fbf5d9b232(timestamp) {
    const start = $f32372070b64b5ae$export$1d1e1fb06fb01050(timestamp);
    start.day = $f32372070b64b5ae$export$f0d374539487f66;
    $f32372070b64b5ae$export$ef436cc98004512d(start);
    $f32372070b64b5ae$export$311eb4d04bca27b0(start);
    return start;
}
function $f32372070b64b5ae$export$6ac2712656da4fd7(timestamp) {
    const end = $f32372070b64b5ae$export$1d1e1fb06fb01050(timestamp);
    end.day = $f32372070b64b5ae$export$4169ecd548fbc13a(end.year, end.month);
    $f32372070b64b5ae$export$ef436cc98004512d(end);
    $f32372070b64b5ae$export$311eb4d04bca27b0(end);
    return end;
}
function $f32372070b64b5ae$export$b3d198e17b370bec(input) {
    return isFinite(parseInt(input));
}
function $f32372070b64b5ae$export$7bd013ac69eb590c(input) {
    return typeof input === 'number' && isFinite(input) || !!$f32372070b64b5ae$export$7c971e80bdf56c29.exec(input) || typeof input === 'object' && isFinite(input.hour) && isFinite(input.minute);
}
function $f32372070b64b5ae$export$c9698ec7f05a07e1(input) {
    if (typeof input === 'number') // when a number is given, it's minutes since 12:00am
    return input;
    else if (typeof input === 'string') {
        // when a string is given, it's a hh:mm:ss format where seconds are optional
        const parts = $f32372070b64b5ae$export$7c971e80bdf56c29.exec(input);
        if (!parts) return false;
        return parseInt(parts[1]) * 60 + parseInt(parts[3] || 0);
    } else if (typeof input === 'object') {
        // when an object is given, it must have hour and minute
        if (typeof input.hour !== 'number' || typeof input.minute !== 'number') return false;
        return input.hour * 60 + input.minute;
    } else // unsupported type
    return false;
}
function $f32372070b64b5ae$export$2d7830448c2dbdbd(input) {
    return typeof input === 'number' && isFinite(input) || typeof input === 'string' && !!$f32372070b64b5ae$export$d667538f0d39ccbc.exec(input) || input instanceof Date;
}
function $f32372070b64b5ae$export$9fc5011a778dc2d8(input) {
    let required = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let now = arguments.length > 2 ? arguments[2] : undefined;
    if (typeof input === 'number' && isFinite(input)) input = new Date(input);
    if (input instanceof Date) {
        const date = $f32372070b64b5ae$export$6b862160d295c8e(input);
        if (now) $f32372070b64b5ae$export$691f4625508e8fd4(date, now, date.hasTime);
        return date;
    }
    if (typeof input !== 'string') {
        if (required) throw new Error(`${input} is not a valid timestamp. It must be a Date, number of milliseconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored.`);
        return null;
    }
    // YYYY-MM-DD hh:mm:ss
    const parts = $f32372070b64b5ae$export$d667538f0d39ccbc.exec(input);
    if (!parts) {
        if (required) throw new Error(`${input} is not a valid timestamp. It must be a Date, number of milliseconds since Epoch, or a string in the format of YYYY-MM-DD or YYYY-MM-DD hh:mm. Zero-padding is optional and seconds are ignored.`);
        return null;
    }
    const timestamp = {
        date: input,
        time: '',
        year: parseInt(parts[1]),
        month: parseInt(parts[2]),
        day: parseInt(parts[4]) || 1,
        hour: parseInt(parts[6]) || 0,
        minute: parseInt(parts[8]) || 0,
        weekday: 0,
        hasDay: !!parts[4],
        hasTime: !!(parts[6] && parts[8]),
        past: false,
        present: false,
        future: false
    };
    $f32372070b64b5ae$export$ef436cc98004512d(timestamp);
    $f32372070b64b5ae$export$311eb4d04bca27b0(timestamp);
    if (now) $f32372070b64b5ae$export$691f4625508e8fd4(timestamp, now, timestamp.hasTime);
    return timestamp;
}
function $f32372070b64b5ae$export$6b862160d295c8e(date) {
    return $f32372070b64b5ae$export$311eb4d04bca27b0({
        date: '',
        time: '',
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate(),
        weekday: date.getDay(),
        hour: date.getHours(),
        minute: date.getMinutes(),
        hasDay: true,
        hasTime: true,
        past: false,
        present: true,
        future: false
    });
}
function $f32372070b64b5ae$export$a696b9fd3900684e(timestamp) {
    return timestamp.year * $f32372070b64b5ae$export$f05f11922a752304 + timestamp.month * $f32372070b64b5ae$export$7fc74efb02a6f761 + timestamp.day;
}
function $f32372070b64b5ae$export$5d75929d11f27c05(timestamp) {
    return timestamp.hour * $f32372070b64b5ae$export$98cc082a460226e5 + timestamp.minute;
}
function $f32372070b64b5ae$export$c9c199c1ef374128(timestamp) {
    return $f32372070b64b5ae$export$a696b9fd3900684e(timestamp) * $f32372070b64b5ae$export$41146f115a887cb8 + $f32372070b64b5ae$export$5d75929d11f27c05(timestamp);
}
function $f32372070b64b5ae$export$691f4625508e8fd4(timestamp, now) {
    let time = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let a = $f32372070b64b5ae$export$a696b9fd3900684e(now);
    let b = $f32372070b64b5ae$export$a696b9fd3900684e(timestamp);
    let present = a === b;
    if (timestamp.hasTime && time && present) {
        a = $f32372070b64b5ae$export$5d75929d11f27c05(now);
        b = $f32372070b64b5ae$export$5d75929d11f27c05(timestamp);
        present = a === b;
    }
    timestamp.past = b < a;
    timestamp.present = present;
    timestamp.future = b > a;
    return timestamp;
}
function $f32372070b64b5ae$export$a9ff3f4e7dc50ac7(input) {
    return input instanceof Date || typeof input === 'number' && isFinite(input);
}
function $f32372070b64b5ae$export$78dc5db788b5e904(timestamp, hasTime, now) {
    if (timestamp.hasTime !== hasTime) {
        timestamp.hasTime = hasTime;
        if (!hasTime) {
            timestamp.hour = $f32372070b64b5ae$export$497c16ed077d7bd0;
            timestamp.minute = $f32372070b64b5ae$export$d91839fc8da0ba2a;
            timestamp.time = $f32372070b64b5ae$export$1428f42a7de81803(timestamp);
        }
        if (now) $f32372070b64b5ae$export$691f4625508e8fd4(timestamp, now, timestamp.hasTime);
    }
    return timestamp;
}
function $f32372070b64b5ae$export$49eccff0c4a8f20b(timestamp, minutes, now) {
    timestamp.hasTime = true;
    timestamp.hour = 0;
    timestamp.minute = 0;
    $f32372070b64b5ae$export$88061d15ba6d1ea4(timestamp, minutes);
    $f32372070b64b5ae$export$311eb4d04bca27b0(timestamp);
    if (now) $f32372070b64b5ae$export$691f4625508e8fd4(timestamp, now, true);
    return timestamp;
}
function $f32372070b64b5ae$export$ef436cc98004512d(timestamp) {
    timestamp.weekday = $f32372070b64b5ae$export$3cd955dfd2b0d79c(timestamp);
    return timestamp;
}
function $f32372070b64b5ae$export$311eb4d04bca27b0(timestamp) {
    timestamp.time = $f32372070b64b5ae$export$1428f42a7de81803(timestamp);
    timestamp.date = $f32372070b64b5ae$export$aa350b96d91cd94(timestamp);
    return timestamp;
}
function $f32372070b64b5ae$export$3cd955dfd2b0d79c(timestamp) {
    if (timestamp.hasDay) {
        const _ = Math.floor;
        const k = timestamp.day;
        const m = (timestamp.month + 9) % $f32372070b64b5ae$export$6b344f8693e1dade + 1;
        const C = _(timestamp.year / 100);
        const Y = timestamp.year % 100 - (timestamp.month <= 2 ? 1 : 0);
        return ((k + _(2.6 * m - 0.2) - 2 * C + Y + _(Y / 4) + _(C / 4)) % 7 + 7) % 7;
    }
    return timestamp.weekday;
}
function $f32372070b64b5ae$export$4169ecd548fbc13a(year, month) {
    return (0, $4b46046dc9bf1cfd$export$553d7fa8e3805fc0)(year) ? $f32372070b64b5ae$export$b015633a9816886c[month] : $f32372070b64b5ae$export$fa53a399e4b6b821[month];
}
function $f32372070b64b5ae$export$1d1e1fb06fb01050(timestamp) {
    if (timestamp == null) return null;
    const { date: date, time: time, year: year, month: month, day: day, weekday: weekday, hour: hour, minute: minute, hasDay: hasDay, hasTime: hasTime, past: past, present: present, future: future } = timestamp;
    return {
        date: date,
        time: time,
        year: year,
        month: month,
        day: day,
        weekday: weekday,
        hour: hour,
        minute: minute,
        hasDay: hasDay,
        hasTime: hasTime,
        past: past,
        present: present,
        future: future
    };
}
function $f32372070b64b5ae$export$24be126cb0a7bbeb(x, length) {
    let padded = String(x);
    while(padded.length < length)padded = '0' + padded;
    return padded;
}
function $f32372070b64b5ae$export$aa350b96d91cd94(timestamp) {
    let str = `${$f32372070b64b5ae$export$24be126cb0a7bbeb(timestamp.year, 4)}-${$f32372070b64b5ae$export$24be126cb0a7bbeb(timestamp.month, 2)}`;
    if (timestamp.hasDay) str += `-${$f32372070b64b5ae$export$24be126cb0a7bbeb(timestamp.day, 2)}`;
    return str;
}
function $f32372070b64b5ae$export$1428f42a7de81803(timestamp) {
    if (!timestamp.hasTime) return '';
    return `${$f32372070b64b5ae$export$24be126cb0a7bbeb(timestamp.hour, 2)}:${$f32372070b64b5ae$export$24be126cb0a7bbeb(timestamp.minute, 2)}`;
}
function $f32372070b64b5ae$export$88061d15ba6d1ea4(timestamp, minutes) {
    timestamp.minute += minutes;
    while(timestamp.minute >= $f32372070b64b5ae$export$802677262e924bef){
        timestamp.minute -= $f32372070b64b5ae$export$802677262e924bef;
        timestamp.hour++;
        if (timestamp.hour >= $f32372070b64b5ae$export$db433e91a7c4594) {
            $f32372070b64b5ae$export$992728922317ffc8(timestamp);
            timestamp.hour = $f32372070b64b5ae$export$27b147670908da68;
        }
    }
    return timestamp;
}
function $f32372070b64b5ae$export$992728922317ffc8(timestamp) {
    timestamp.day++;
    timestamp.weekday = (timestamp.weekday + 1) % $f32372070b64b5ae$export$f669a45420d15194;
    if (timestamp.day > $f32372070b64b5ae$export$60a714e75b55f438 && timestamp.day > $f32372070b64b5ae$export$4169ecd548fbc13a(timestamp.year, timestamp.month)) {
        timestamp.day = $f32372070b64b5ae$export$f0d374539487f66;
        timestamp.month++;
        if (timestamp.month > $f32372070b64b5ae$export$6b344f8693e1dade) {
            timestamp.month = $f32372070b64b5ae$export$c71f787df6a8523;
            timestamp.year++;
        }
    }
    return timestamp;
}
function $f32372070b64b5ae$export$83d9f8120102adf8(timestamp) {
    timestamp.day--;
    timestamp.weekday = (timestamp.weekday + 6) % $f32372070b64b5ae$export$f669a45420d15194;
    if (timestamp.day < $f32372070b64b5ae$export$f0d374539487f66) {
        timestamp.month--;
        if (timestamp.month < $f32372070b64b5ae$export$c71f787df6a8523) {
            timestamp.year--;
            timestamp.month = $f32372070b64b5ae$export$6b344f8693e1dade;
        }
        timestamp.day = $f32372070b64b5ae$export$4169ecd548fbc13a(timestamp.year, timestamp.month);
    }
    return timestamp;
}
function $f32372070b64b5ae$export$f31e827513f08f84(timestamp) {
    let mover = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f32372070b64b5ae$export$992728922317ffc8;
    let days = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    while(--days >= 0)mover(timestamp);
    return timestamp;
}
function $f32372070b64b5ae$export$49c90754e1099334(min, max) {
    const Y = (max.year - min.year) * 525600;
    const M = (max.month - min.month) * 43800;
    const D = (max.day - min.day) * 1440;
    const h = (max.hour - min.hour) * 60;
    const m = max.minute - min.minute;
    return Y + M + D + h + m;
}
function $f32372070b64b5ae$export$ee1634550ff107d4(timestamp, weekday) {
    let mover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $f32372070b64b5ae$export$992728922317ffc8;
    let maxDays = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 6;
    while(timestamp.weekday !== weekday && --maxDays >= 0)mover(timestamp);
    return timestamp;
}
function $f32372070b64b5ae$export$859fb76d8ed4fb57(weekdays) {
    const skips = [
        1,
        1,
        1,
        1,
        1,
        1,
        1
    ];
    const filled = [
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    for(let i = 0; i < weekdays.length; i++)filled[weekdays[i]] = 1;
    for(let k = 0; k < $f32372070b64b5ae$export$f669a45420d15194; k++){
        let skip = 1;
        for(let j = 1; j < $f32372070b64b5ae$export$f669a45420d15194; j++){
            const next = (k + j) % $f32372070b64b5ae$export$f669a45420d15194;
            if (filled[next]) break;
            skip++;
        }
        skips[k] = filled[k] * skip;
    }
    return skips;
}
function $f32372070b64b5ae$export$64d33c59520c51c1(timestamp) {
    const time = `${$f32372070b64b5ae$export$24be126cb0a7bbeb(timestamp.hour, 2)}:${$f32372070b64b5ae$export$24be126cb0a7bbeb(timestamp.minute, 2)}`;
    const date = timestamp.date;
    return new Date(`${date}T${time}:00+00:00`);
}
function $f32372070b64b5ae$export$1d09e514f6624491(start, end, now, weekdaySkips) {
    let max = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 42;
    let min = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    const stop = $f32372070b64b5ae$export$a696b9fd3900684e(end);
    const days = [];
    let current = $f32372070b64b5ae$export$1d1e1fb06fb01050(start);
    let currentIdentifier = 0;
    let stopped = currentIdentifier === stop;
    if (stop < $f32372070b64b5ae$export$a696b9fd3900684e(start)) throw new Error('End date is earlier than start date.');
    while((!stopped || days.length < min) && days.length < max){
        currentIdentifier = $f32372070b64b5ae$export$a696b9fd3900684e(current);
        stopped = stopped || currentIdentifier === stop;
        if (weekdaySkips[current.weekday] === 0) {
            current = $f32372070b64b5ae$export$992728922317ffc8(current);
            continue;
        }
        const day = $f32372070b64b5ae$export$1d1e1fb06fb01050(current);
        $f32372070b64b5ae$export$311eb4d04bca27b0(day);
        $f32372070b64b5ae$export$691f4625508e8fd4(day, now);
        days.push(day);
        current = $f32372070b64b5ae$export$f31e827513f08f84(current, $f32372070b64b5ae$export$992728922317ffc8, weekdaySkips[current.weekday]);
    }
    if (!days.length) throw new Error('No dates found using specified start date, end date, and weekdays.');
    return days;
}
function $f32372070b64b5ae$export$9957158369b86be4(timestamp, first, minutes, count, now) {
    const intervals = [];
    for(let i = 0; i < count; i++){
        const mins = first + i * minutes;
        const int = $f32372070b64b5ae$export$1d1e1fb06fb01050(timestamp);
        intervals.push($f32372070b64b5ae$export$49eccff0c4a8f20b(int, mins, now));
    }
    return intervals;
}
function $f32372070b64b5ae$export$ad673d34a6c4c002(locale, getOptions) {
    const emptyFormatter = (_t, _s)=>'';
    if (typeof Intl === 'undefined' || typeof Intl.DateTimeFormat === 'undefined') return emptyFormatter;
    return (timestamp, short)=>{
        try {
            const intlFormatter = new Intl.DateTimeFormat(locale || undefined, getOptions(timestamp, short));
            return intlFormatter.format($f32372070b64b5ae$export$64d33c59520c51c1(timestamp));
        } catch (e) {
            return '';
        }
    };
}
function $f32372070b64b5ae$export$64ee157efaa984c6(input) {
    if (typeof input === 'string') input = input.split(',');
    if (Array.isArray(input)) {
        const ints = input.map((x)=>parseInt(x));
        if (ints.length > $f32372070b64b5ae$export$f669a45420d15194 || ints.length === 0) return false;
        const visited = {};
        let wrapped = false;
        for(let i = 0; i < ints.length; i++){
            const x = ints[i];
            if (!isFinite(x) || x < 0 || x >= $f32372070b64b5ae$export$f669a45420d15194) return false;
            if (i > 0) {
                const d = x - ints[i - 1];
                if (d < 0) {
                    if (wrapped) return false;
                    wrapped = true;
                } else if (d === 0) return false;
            }
            if (visited[x]) return false;
            visited[x] = true;
        }
        return true;
    }
    return false;
}


function $dbec9a11a4e5d3c2$export$81f28d8f5590a939(props) {
    const times = (0, $01W3b.reactive)({
        now: (0, $f32372070b64b5ae$export$9fc5011a778dc2d8)('0000-00-00 00:00', true),
        today: (0, $f32372070b64b5ae$export$9fc5011a778dc2d8)('0000-00-00', true)
    });
    const parsedNow = (0, $01W3b.computed)(()=>{
        return props.now && (0, $f32372070b64b5ae$export$2d7830448c2dbdbd)(props.now) ? (0, $f32372070b64b5ae$export$9fc5011a778dc2d8)(props.now, true) : null;
    });
    function setPresent() {
        times.now.present = times.today.present = true;
        times.now.past = times.today.past = false;
        times.now.future = times.today.future = false;
    }
    function getNow() {
        return (0, $f32372070b64b5ae$export$6b862160d295c8e)(new Date());
    }
    function updateDay(now, target) {
        if (now.date !== target.date) {
            target.year = now.year;
            target.month = now.month;
            target.day = now.day;
            target.weekday = now.weekday;
            target.date = now.date;
        }
    }
    function updateTime(now, target) {
        if (now.time !== target.time) {
            target.hour = now.hour;
            target.minute = now.minute;
            target.time = now.time;
        }
    }
    function updateTimes() {
        const now = parsedNow.value || getNow();
        updateDay(now, times.now);
        updateTime(now, times.now);
        updateDay(now, times.today);
    }
    (0, $01W3b.watch)(parsedNow, updateTimes);
    updateTimes();
    setPresent();
    return {
        times: times,
        parsedNow: parsedNow,
        updateTimes: updateTimes,
        setPresent: setPresent,
        getNow: getNow,
        updateDay: updateDay,
        updateTime: updateTime
    };
}





parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");


const $ac4aa0418ddc4fee$export$6e6a01d14d1ad010 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    start: {
        type: [
            String,
            Number,
            Date
        ],
        validate: (0, $f32372070b64b5ae$export$2d7830448c2dbdbd),
        default: ()=>(0, $f32372070b64b5ae$export$6b862160d295c8e)(new Date()).date
    },
    end: {
        type: [
            String,
            Number,
            Date
        ],
        validate: (0, $f32372070b64b5ae$export$2d7830448c2dbdbd)
    },
    weekdays: {
        type: [
            Array,
            String
        ],
        default: ()=>[
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ],
        validate: (0, $f32372070b64b5ae$export$64ee157efaa984c6)
    },
    firstDayOfWeek: [
        Number,
        String
    ],
    firstDayOfYear: [
        Number,
        String
    ],
    weekdayFormat: {
        type: Function,
        default: null
    },
    dayFormat: {
        type: Function,
        default: null
    },
    locale: String,
    now: {
        type: String,
        validator: (0, $f32372070b64b5ae$export$2d7830448c2dbdbd)
    },
    type: {
        type: String,
        default: 'month'
    }
}, 'VCalendar-base');
function $ac4aa0418ddc4fee$export$d652b3ea2d672d5b(props) {
    const { times: times, updateTimes: updateTimes } = (0, $dbec9a11a4e5d3c2$export$81f28d8f5590a939)({
        now: props.now
    });
    const locale = (0, $13e23564052bdddd$export$4e518c250eba4aac)(props);
    const adapter = (0, $917deb9c892fd486$export$e51e224239492327)();
    const parsedStart = (0, $01W3b.computed)(()=>{
        if (props.type === 'month') return (0, $f32372070b64b5ae$export$fb9b45fbf5d9b232)((0, $f32372070b64b5ae$export$9fc5011a778dc2d8)(props.start, true));
        return (0, $f32372070b64b5ae$export$9fc5011a778dc2d8)(props.start, true);
    });
    const parsedEnd = (0, $01W3b.computed)(()=>{
        const start = parsedStart.value;
        const end = props.end ? (0, $f32372070b64b5ae$export$9fc5011a778dc2d8)(props.end) || start : start;
        const value = (0, $f32372070b64b5ae$export$c9c199c1ef374128)(end) < (0, $f32372070b64b5ae$export$c9c199c1ef374128)(start) ? start : end;
        if (props.type === 'month') return (0, $f32372070b64b5ae$export$6ac2712656da4fd7)(value);
        return value;
    });
    const parsedValue = (0, $01W3b.computed)(()=>{
        return (0, $f32372070b64b5ae$export$2d7830448c2dbdbd)(props.modelValue) ? (0, $f32372070b64b5ae$export$9fc5011a778dc2d8)(props.modelValue, true) : parsedStart.value || times.today;
    });
    const parsedWeekdays = (0, $01W3b.computed)(()=>{
        const weekdays = Array.isArray(props.weekdays) ? props.weekdays : (props.weekdays || '').split(',').map((x)=>parseInt(x, 10));
        const first = adapter.toJsDate(adapter.startOfWeek(adapter.date(), props.firstDayOfWeek)).getDay();
        return [
            ...weekdays.toSorted().filter((v)=>v >= first),
            ...weekdays.toSorted().filter((v)=>v < first)
        ];
    });
    const effectiveWeekdays = (0, $01W3b.computed)(()=>{
        const start = parsedValue.value;
        const days = parseInt(String(props.categoryDays)) || 1;
        switch(props.type){
            case 'day':
                return [
                    start.weekday
                ];
            case '4day':
                return [
                    start.weekday,
                    (start.weekday + 1) % 7,
                    (start.weekday + 2) % 7,
                    (start.weekday + 3) % 7
                ];
            case 'category':
                return Array.from({
                    length: days
                }, (_, i)=>(start.weekday + i) % 7);
            default:
                return parsedWeekdays.value;
        }
    });
    const weekdaySkips = (0, $01W3b.computed)(()=>{
        return (0, $f32372070b64b5ae$export$859fb76d8ed4fb57)(parsedWeekdays.value);
    });
    const days = (0, $01W3b.computed)(()=>{
        return (0, $f32372070b64b5ae$export$1d09e514f6624491)(parsedStart.value, parsedEnd.value, times.today, weekdaySkips.value);
    });
    const dayFormatter = (0, $01W3b.computed)(()=>{
        if (props.dayFormat) return props.dayFormat;
        return (0, $f32372070b64b5ae$export$ad673d34a6c4c002)(locale.current.value, ()=>({
                timeZone: 'UTC',
                day: 'numeric'
            }));
    });
    const weekdayFormatter = (0, $01W3b.computed)(()=>{
        if (props.weekdayFormat) return props.weekdayFormat;
        return (0, $f32372070b64b5ae$export$ad673d34a6c4c002)(locale.current.value, (_tms, short)=>({
                timeZone: 'UTC',
                weekday: short ? 'short' : 'long'
            }));
    });
    function getColorProps(colors) {
        return (0, $3cd60c4ecc68ec90$export$7c60041aa39ebc59)(colors);
    }
    function getRelativeClasses(timestamp) {
        let outside = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return {
            'v-present': timestamp.present,
            'v-past': timestamp.past,
            'v-future': timestamp.future,
            'v-outside': outside
        };
    }
    function getWeekNumber(timestamp) {
        return adapter.getWeek(adapter.date(timestamp.date), props.firstDayOfWeek, props.firstDayOfYear);
    }
    function _getStartOfWeek(timestamp) {
        return (0, $f32372070b64b5ae$export$548348775833e7f8)(timestamp, parsedWeekdays.value, times.today);
    }
    function _getEndOfWeek(timestamp) {
        return (0, $f32372070b64b5ae$export$82940377b1d9aa33)(timestamp, parsedWeekdays.value, times.today);
    }
    function getFormatter(options) {
        return (0, $f32372070b64b5ae$export$ad673d34a6c4c002)(locale.current.value, ()=>options);
    }
    return {
        times: times,
        locale: locale,
        parsedValue: parsedValue,
        parsedWeekdays: parsedWeekdays,
        effectiveWeekdays: effectiveWeekdays,
        weekdaySkips: weekdaySkips,
        parsedStart: parsedStart,
        parsedEnd: parsedEnd,
        days: days,
        dayFormatter: dayFormatter,
        weekdayFormatter: weekdayFormatter,
        getColorProps: getColorProps,
        getRelativeClasses: getRelativeClasses,
        getWeekNumber: getWeekNumber,
        getStartOfWeek: _getStartOfWeek,
        getEndOfWeek: _getEndOfWeek,
        getFormatter: getFormatter,
        updateTimes: updateTimes
    };
}


// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");


const $1198addfc01a94bb$export$80abb86decb9e373 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    maxDays: {
        type: Number,
        default: 7
    },
    intervalHeight: {
        type: [
            Number,
            String
        ],
        default: 48,
        validate: (0, $f32372070b64b5ae$export$b3d198e17b370bec)
    },
    intervalWidth: {
        type: [
            Number,
            String
        ],
        default: 60,
        validate: (0, $f32372070b64b5ae$export$b3d198e17b370bec)
    },
    intervalMinutes: {
        type: [
            Number,
            String
        ],
        default: 60,
        validate: (0, $f32372070b64b5ae$export$b3d198e17b370bec)
    },
    firstInterval: {
        type: [
            Number,
            String
        ],
        default: 0,
        validate: (0, $f32372070b64b5ae$export$b3d198e17b370bec)
    },
    firstTime: {
        type: [
            Number,
            String,
            Object
        ],
        validate: (0, $f32372070b64b5ae$export$7bd013ac69eb590c)
    },
    intervalCount: {
        type: [
            Number,
            String
        ],
        default: 24,
        validate: (0, $f32372070b64b5ae$export$b3d198e17b370bec)
    },
    intervalFormat: {
        type: Function,
        default: null
    },
    intervalStyle: {
        type: Function,
        default: null
    },
    showIntervalLabel: {
        type: Function,
        default: null
    }
}, 'VCalendar-intervals');
function $1198addfc01a94bb$export$4b303b08a678f168(props) {
    const base = (0, $ac4aa0418ddc4fee$export$d652b3ea2d672d5b)(props);
    const scrollAreaRef = (0, $01W3b.shallowRef)();
    const parsedFirstInterval = (0, $01W3b.computed)(()=>{
        return parseInt(String(props.firstInterval || 0));
    });
    const parsedIntervalMinutes = (0, $01W3b.computed)(()=>{
        return parseInt(String(props.intervalMinutes || 60));
    });
    const parsedIntervalCount = (0, $01W3b.computed)(()=>{
        return parseInt(String(props.intervalCount || 24));
    });
    const parsedIntervalHeight = (0, $01W3b.computed)(()=>{
        return parseFloat(String(props.intervalHeight || 48));
    });
    const parsedFirstTime = (0, $01W3b.computed)(()=>{
        return (0, $f32372070b64b5ae$export$c9698ec7f05a07e1)(props.firstTime);
    });
    const firstMinute = (0, $01W3b.computed)(()=>{
        const time = parsedFirstTime.value;
        return time !== false && time >= 0 && time <= (0, $f32372070b64b5ae$export$5eae234f5f3162be) ? time : parsedFirstInterval.value * parsedIntervalMinutes.value;
    });
    const bodyHeight = (0, $01W3b.computed)(()=>{
        return parsedIntervalCount.value * parsedIntervalHeight.value;
    });
    const days = (0, $01W3b.computed)(()=>{
        return (0, $f32372070b64b5ae$export$1d09e514f6624491)(base.parsedStart.value, base.parsedEnd.value, base.times.today, base.weekdaySkips.value, props.maxDays);
    });
    const intervals = (0, $01W3b.computed)(()=>{
        const daysValue = days.value;
        const first = firstMinute.value;
        const minutes = parsedIntervalMinutes.value;
        const count = parsedIntervalCount.value;
        const now = base.times.now;
        return daysValue.map((d)=>(0, $f32372070b64b5ae$export$9957158369b86be4)(d, first, minutes, count, now));
    });
    const intervalFormatter = (0, $01W3b.computed)(()=>{
        if (props.intervalFormat) return props.intervalFormat;
        return (0, $f32372070b64b5ae$export$ad673d34a6c4c002)(base.locale.current.value, (tms, short)=>!short ? {
                timeZone: 'UTC',
                hour: '2-digit',
                minute: '2-digit'
            } : tms.minute === 0 ? {
                timeZone: 'UTC',
                hour: 'numeric'
            } : {
                timeZone: 'UTC',
                hour: 'numeric',
                minute: '2-digit'
            });
    });
    function showIntervalLabelDefault(interval) {
        const first = intervals.value[0][0];
        const isFirst = first.hour === interval.hour && first.minute === interval.minute;
        return !isFirst;
    }
    function intervalStyleDefault(_interval) {
        return undefined;
    }
    function getTimestampAtEvent(e, day) {
        const timestamp = (0, $f32372070b64b5ae$export$1d1e1fb06fb01050)(day);
        const bounds = e.currentTarget.getBoundingClientRect();
        const baseMinutes = firstMinute.value;
        const touchEvent = e;
        const mouseEvent = e;
        const touches = touchEvent.changedTouches || touchEvent.touches;
        const clientY = touches && touches[0] ? touches[0].clientY : mouseEvent.clientY;
        const addIntervals = (clientY - bounds.top) / parsedIntervalHeight.value;
        const addMinutes = Math.floor(addIntervals * parsedIntervalMinutes.value);
        const minutes = baseMinutes + addMinutes;
        return (0, $f32372070b64b5ae$export$49eccff0c4a8f20b)(timestamp, minutes, base.times.now);
    }
    function getSlotScope(timestamp) {
        const scope = (0, $f32372070b64b5ae$export$1d1e1fb06fb01050)(timestamp);
        scope.timeToY = timeToY;
        scope.timeDelta = timeDelta;
        scope.minutesToPixels = minutesToPixels;
        scope.week = days.value;
        scope.intervalRange = [
            firstMinute.value,
            firstMinute.value + parsedIntervalCount.value * parsedIntervalMinutes.value
        ];
        return scope;
    }
    function scrollToTime(time) {
        const y = timeToY(time);
        const pane = scrollAreaRef.value;
        if (y === false || !pane) return false;
        pane.scrollTop = y;
        return true;
    }
    function minutesToPixels(minutes) {
        return minutes / parsedIntervalMinutes.value * parsedIntervalHeight.value;
    }
    function timeToY(time) {
        let targetDateOrClamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const clamp = targetDateOrClamp !== false;
        const targetDate = typeof targetDateOrClamp !== 'boolean' ? targetDateOrClamp : undefined;
        let y = timeDelta(time, targetDate);
        if (y === false) return y;
        y *= bodyHeight.value;
        if (clamp) {
            if (y < 0) y = 0;
            else if (y > bodyHeight.value) y = bodyHeight.value;
        } else {
            if (y < 0) y = y + bodyHeight.value;
            else if (y > bodyHeight.value) y = y - bodyHeight.value;
        }
        return y;
    }
    function timeDelta(time, targetDate) {
        let minutes = (0, $f32372070b64b5ae$export$c9698ec7f05a07e1)(time);
        if (minutes === false) return false;
        const gap = parsedIntervalCount.value * parsedIntervalMinutes.value;
        if (targetDate && typeof time === 'object' && 'day' in time) {
            const a = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(time);
            const b = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(targetDate);
            minutes += (a - b) * gap;
        }
        const min = firstMinute.value;
        return (minutes - min) / gap;
    }
    return {
        ...base,
        scrollAreaRef: scrollAreaRef,
        parsedFirstInterval: parsedFirstInterval,
        parsedIntervalMinutes: parsedIntervalMinutes,
        parsedIntervalCount: parsedIntervalCount,
        parsedIntervalHeight: parsedIntervalHeight,
        parsedFirstTime: parsedFirstTime,
        firstMinute: firstMinute,
        bodyHeight: bodyHeight,
        days: days,
        intervals: intervals,
        intervalFormatter: intervalFormatter,
        showIntervalLabelDefault: showIntervalLabelDefault,
        intervalStyleDefault: intervalStyleDefault,
        getTimestampAtEvent: getTimestampAtEvent,
        getSlotScope: getSlotScope,
        scrollToTime: scrollToTime,
        minutesToPixels: minutesToPixels,
        timeToY: timeToY,
        timeDelta: timeDelta
    };
}


// Types
function $a30ddb8f02846b0e$var$mounted(el, binding) {
    const handler = binding.value;
    const options = {
        passive: !binding.modifiers?.active
    };
    window.addEventListener('resize', handler, options);
    el._onResize = Object(el._onResize);
    el._onResize[binding.instance.$.uid] = {
        handler: handler,
        options: options
    };
    if (!binding.modifiers?.quiet) handler();
}
function $a30ddb8f02846b0e$var$unmounted(el, binding) {
    if (!el._onResize?.[binding.instance.$.uid]) return;
    const { handler: handler, options: options } = el._onResize[binding.instance.$.uid];
    window.removeEventListener('resize', handler, options);
    delete el._onResize[binding.instance.$.uid];
}
const $a30ddb8f02846b0e$export$76856258f71db1ea = {
    mounted: $a30ddb8f02846b0e$var$mounted,
    unmounted: $a30ddb8f02846b0e$var$unmounted
};
var $a30ddb8f02846b0e$export$2e2bcd8739ae039 = $a30ddb8f02846b0e$export$76856258f71db1ea;


// Utilities

function $ee6bae7c747c9258$export$b5ac16d47f658674(attrs, suffix, getData) {
    return Object.keys(attrs).filter((key)=>(0, $8590040a7833369a$export$1a2d97de39ecbb75)(key) && key.endsWith(suffix)).reduce((acc, key)=>{
        acc[key.slice(0, -suffix.length)] = (event)=>(0, $8590040a7833369a$export$293b251ea77dc2b7)(attrs[key], event, getData(event));
        return acc;
    }, {});
}


const $d11e4111bab56c26$export$a8a1230763a685fd = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VCalendarDaily',
    directives: {
        vResize: $a30ddb8f02846b0e$export$2e2bcd8739ae039
    },
    props: {
        color: String,
        shortWeekdays: {
            type: Boolean,
            default: true
        },
        shortIntervals: {
            type: Boolean,
            default: true
        },
        hideHeader: Boolean,
        ...(0, $ac4aa0418ddc4fee$export$6e6a01d14d1ad010)(),
        ...(0, $1198addfc01a94bb$export$80abb86decb9e373)()
    },
    setup (props, _ref) {
        let { slots: slots, attrs: attrs } = _ref;
        const scrollPush = (0, $01W3b.ref)(0);
        const pane = (0, $01W3b.ref)();
        const base = (0, $1198addfc01a94bb$export$4b303b08a678f168)(props);
        function init() {
            (0, $TusQn.nextTick)(onResize);
        }
        function onResize() {
            scrollPush.value = getScrollPush();
        }
        function getScrollPush() {
            return base.scrollAreaRef.value && pane.value ? base.scrollAreaRef.value.offsetWidth - pane.value.offsetWidth : 0;
        }
        function genHead() {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-daily__head",
                "style": {
                    marginRight: scrollPush.value + 'px'
                }
            }, [
                genHeadIntervals(),
                genHeadDays()
            ]);
        }
        function genHeadIntervals() {
            const width = (0, $8590040a7833369a$export$286ad215293a0860)(props.intervalWidth);
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-daily__intervals-head",
                "style": {
                    width: width
                }
            }, [
                slots['interval-header']?.()
            ]);
        }
        function genHeadDays() {
            return base.days.value.map(genHeadDay);
        }
        function genHeadDay(day, index) {
            const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':day', (nativeEvent)=>({
                    nativeEvent: nativeEvent,
                    ...base.getSlotScope(day)
                }));
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "key": day.date,
                "class": [
                    'v-calendar-daily_head-day',
                    base.getRelativeClasses(day)
                ]
            }, events), [
                genHeadWeekday(day),
                genHeadDayLabel(day),
                genDayHeader(day, index)
            ]);
        }
        function genDayHeader(day, index) {
            return slots['day-header']?.({
                week: base.days.value,
                ...day,
                index: index
            }) ?? [];
        }
        function genHeadWeekday(day) {
            const color = day.present ? props.color : undefined;
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)(base.getColorProps({
                text: color
            }), {
                "class": "v-calendar-daily_head-weekday"
            }), [
                base.weekdayFormatter.value(day, props.shortWeekdays)
            ]);
        }
        function genHeadDayLabel(day) {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-daily_head-day-label"
            }, [
                slots['day-label-header']?.(day) ?? genHeadDayButton(day)
            ]);
        }
        function genHeadDayButton(day) {
            const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':date', (nativeEvent)=>({
                    nativeEvent: nativeEvent,
                    ...day
                }));
            return (0, $TusQn.createVNode)((0, $f05757d4ecc644dc$export$d35ef2d5f4f4551c), (0, $TusQn.mergeProps)({
                "active": day.present,
                "activeColor": props.color,
                "variant": "outlined",
                "baseVariant": "text",
                "onUpdate:active": (0, $8590040a7833369a$export$8793edee2d425525)
            }, events), {
                default: ()=>[
                        base.dayFormatter.value(day, false)
                    ]
            });
        }
        function genBody() {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-daily__body"
            }, [
                genScrollArea()
            ]);
        }
        function genScrollArea() {
            return (0, $TusQn.createElementVNode)("div", {
                "ref": base.scrollAreaRef,
                "class": "v-calendar-daily__scroll-area"
            }, [
                genPane()
            ]);
        }
        function genPane() {
            return (0, $TusQn.createElementVNode)("div", {
                "ref": pane,
                "class": "v-calendar-daily__pane",
                "style": {
                    height: (0, $8590040a7833369a$export$286ad215293a0860)(base.bodyHeight.value)
                }
            }, [
                genDayContainer()
            ]);
        }
        function genDayContainer() {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-daily__day-container"
            }, [
                genBodyIntervals(),
                slots.days?.() ?? genDays()
            ]);
        }
        function genDays() {
            return base.days.value.map((day, index)=>{
                const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':time', (nativeEvent)=>({
                        nativeEvent: nativeEvent,
                        ...base.getSlotScope(base.getTimestampAtEvent(nativeEvent, day))
                    }));
                return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                    "key": day.date,
                    "class": [
                        'v-calendar-daily__day',
                        base.getRelativeClasses(day)
                    ]
                }, events), [
                    genDayIntervals(index),
                    genDayBody(day)
                ]);
            });
        }
        function genDayBody(day) {
            return slots['day-body']?.(base.getSlotScope(day)) ?? [];
        }
        function genDayIntervals(index) {
            return base.intervals.value[index].map(genDayInterval);
        }
        function genDayInterval(interval) {
            const height = (0, $8590040a7833369a$export$286ad215293a0860)(props.intervalHeight);
            const styler = props.intervalStyle || base.intervalStyleDefault;
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-daily__day-interval",
                "key": interval.time,
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        height: height
                    },
                    styler(interval)
                ])
            }, [
                slots.interval?.(base.getSlotScope(interval))
            ]);
        }
        function genBodyIntervals() {
            const width = (0, $8590040a7833369a$export$286ad215293a0860)(props.intervalWidth);
            const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':interval', (nativeEvent)=>({
                    nativeEvent: nativeEvent,
                    ...base.getTimestampAtEvent(nativeEvent, base.parsedStart.value)
                }));
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "class": "v-calendar-daily__intervals-body",
                "style": {
                    width: width
                }
            }, events), [
                genIntervalLabels()
            ]);
        }
        function genIntervalLabels() {
            if (!base.intervals.value.length) return null;
            return base.intervals.value[0].map(genIntervalLabel);
        }
        function genIntervalLabel(interval) {
            const height = (0, $8590040a7833369a$export$286ad215293a0860)(props.intervalHeight);
            const short = props.shortIntervals;
            const shower = props.showIntervalLabel || base.showIntervalLabelDefault;
            const show = shower(interval);
            const label = show ? base.intervalFormatter.value(interval, short) : undefined;
            return (0, $TusQn.createElementVNode)("div", {
                "key": interval.time,
                "class": "v-calendar-daily__interval",
                "style": {
                    height: height
                }
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-calendar-daily__interval-text"
                }, [
                    label
                ])
            ]);
        }
        (0, $TusQn.onMounted)(init);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-calendar-daily',
                    attrs.class
                ]),
                "onDragstart": (e)=>e.preventDefault()
            }, [
                !props.hideHeader ? genHead() : undefined,
                genBody()
            ]), [
                [
                    (0, $a30ddb8f02846b0e$export$2e2bcd8739ae039),
                    onResize,
                    void 0,
                    {
                        quiet: true
                    }
                ]
            ]));
        return {
            ...base,
            scrollPush: scrollPush,
            pane: pane,
            init: init,
            onResize: onResize,
            getScrollPush: getScrollPush
        };
    }
});




// Types
function $01f03a1219a9b6e5$export$b974304e921521c5(category, categoryText) {
    return typeof categoryText === 'function' ? categoryText(category) : typeof categoryText === 'string' && typeof category === 'object' && category ? category[categoryText] : typeof category === 'string' ? category : '';
}
function $01f03a1219a9b6e5$export$20f1a4bf379f9eda(categories, categoryText) {
    if (typeof categories === 'string') return categories.split(/\s*,\s/);
    if (Array.isArray(categories)) return categories.map((category)=>{
        if (typeof category === 'string') return category;
        const categoryName = typeof category.categoryName === 'string' ? category.categoryName : $01f03a1219a9b6e5$export$b974304e921521c5(category, categoryText);
        return {
            ...category,
            categoryName: categoryName
        };
    });
    return [];
}



const $f1a541941011c6ad$export$70906a2545c91cdc = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VCalendarCategory',
    props: {
        categories: {
            type: [
                Array,
                String
            ],
            default: ''
        },
        categoryText: [
            String,
            Function
        ],
        categoryForInvalid: {
            type: String,
            default: ''
        },
        ...(0, $ac4aa0418ddc4fee$export$6e6a01d14d1ad010)(),
        ...(0, $1198addfc01a94bb$export$80abb86decb9e373)()
    },
    setup (props, _ref) {
        let { slots: slots, attrs: attrs } = _ref;
        const base = (0, $1198addfc01a94bb$export$4b303b08a678f168)(props);
        const parsedCategories = (0, $01W3b.computed)(()=>{
            return (0, $01f03a1219a9b6e5$export$20f1a4bf379f9eda)(props.categories, props.categoryText);
        });
        function getCategoryScope(scope, category) {
            const cat = typeof category === 'object' && category && category.categoryName === props.categoryForInvalid ? null : category;
            return {
                ...scope,
                category: cat
            };
        }
        function genDayHeader(scope) {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-category__columns"
            }, [
                parsedCategories.value.map((category)=>{
                    return genDayHeaderCategory(scope, getCategoryScope(scope, category));
                })
            ]);
        }
        function genDayHeaderCategory(day, scope) {
            const headerTitle = typeof scope.category === 'object' ? scope.category.categoryName : scope.category;
            const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':dayCategory', ()=>{
                return getCategoryScope(base.getSlotScope(day) || day, scope.category);
            });
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "class": "v-calendar-category__column-header"
            }, events), [
                slots.category?.(scope) ?? genDayHeaderCategoryTitle(headerTitle),
                slots['day-header']?.(scope)
            ]);
        }
        function genDayHeaderCategoryTitle(categoryName) {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-category__category"
            }, [
                categoryName === null ? props.categoryForInvalid : categoryName
            ]);
        }
        function genDays() {
            const days = [];
            base.days.value.forEach((d, j)=>{
                const day = new Array(parsedCategories.value.length || 1);
                day.fill(d);
                days.push(...day.map((v, i)=>genDay(v, j, i)));
            });
            return days;
        }
        function genDay(day, index, categoryIndex) {
            const category = parsedCategories.value[categoryIndex];
            const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':time', (e)=>{
                return base.getSlotScope(base.getTimestampAtEvent(e, day));
            });
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "key": day.date + '-' + categoryIndex,
                "class": [
                    'v-calendar-daily__day',
                    base.getRelativeClasses(day)
                ]
            }, events), [
                genDayIntervals(index, category),
                genDayBody(day, category)
            ]);
        }
        function genDayIntervals(index, category) {
            return base.intervals.value[index].map((v)=>genDayInterval(v, category));
        }
        function genDayInterval(interval, category) {
            const height = (0, $8590040a7833369a$export$286ad215293a0860)(props.intervalHeight);
            const styler = props.intervalStyle || base.intervalStyleDefault;
            return (0, $TusQn.createElementVNode)("div", {
                "key": interval.time,
                "class": "v-calendar-daily__day-interval",
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        height: height
                    },
                    styler({
                        ...interval,
                        category: category
                    })
                ])
            }, [
                slots.interval?.(getCategoryScope(base.getSlotScope(interval), category))
            ]);
        }
        function genDayBody(day, category) {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-category__columns"
            }, [
                genDayBodyCategory(day, category)
            ]);
        }
        function genDayBodyCategory(day, category) {
            const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':timeCategory', (e)=>{
                return getCategoryScope(base.getSlotScope(base.getTimestampAtEvent(e, day)), category);
            });
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "class": "v-calendar-category__column"
            }, events), [
                slots['day-body']?.(getCategoryScope(base.getSlotScope(day), category))
            ]);
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)((0, $d11e4111bab56c26$export$a8a1230763a685fd), (0, $TusQn.mergeProps)({
                "class": [
                    'v-calendar-daily',
                    'v-calendar-category'
                ]
            }, props), {
                ...slots,
                days: genDays,
                'day-header': genDayHeader
            }));
        return {
            ...base,
            parsedCategories: parsedCategories
        };
    }
});



parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");





const $66969ccd266e5994$export$9032a1126982ac76 = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VCalendarWeekly',
    props: {
        minWeeks: {
            validate: (0, $f32372070b64b5ae$export$b3d198e17b370bec),
            default: 1
        },
        monthFormat: Function,
        showWeek: Boolean,
        color: String,
        shortWeekdays: {
            type: Boolean,
            default: true
        },
        showMonthOnFirst: {
            type: Boolean,
            default: true
        },
        shortMonths: {
            type: Boolean,
            default: true
        },
        hideHeader: Boolean,
        ...(0, $ac4aa0418ddc4fee$export$6e6a01d14d1ad010)()
    },
    setup (props, _ref) {
        let { slots: slots, attrs: attrs } = _ref;
        const base = (0, $ac4aa0418ddc4fee$export$d652b3ea2d672d5b)(props);
        const theme = (0, $cd59fdf0d9176afa$export$93d4e7f90805808f)();
        const parsedMinWeeks = (0, $01W3b.computed)(()=>{
            return parseInt(String(props.minWeeks));
        });
        const days = (0, $01W3b.computed)(()=>{
            const minDays = parsedMinWeeks.value * base.parsedWeekdays.value.length;
            const start = base.getStartOfWeek(base.parsedStart.value);
            const end = base.getEndOfWeek(base.parsedEnd.value);
            return (0, $f32372070b64b5ae$export$1d09e514f6624491)(start, end, base.times.today, base.weekdaySkips.value, Number.MAX_SAFE_INTEGER, minDays);
        });
        const todayWeek = (0, $01W3b.computed)(()=>{
            const today = base.times.today;
            const start = base.getStartOfWeek(today);
            const end = base.getEndOfWeek(today);
            return (0, $f32372070b64b5ae$export$1d09e514f6624491)(start, end, today, base.weekdaySkips.value, base.parsedWeekdays.value.length, base.parsedWeekdays.value.length);
        });
        const monthFormatter = (0, $01W3b.computed)(()=>{
            if (props.monthFormat) // TODO: what happens when this is a string?
            return props.monthFormat;
            return (0, $f32372070b64b5ae$export$ad673d34a6c4c002)(base.locale.current.value, (_tms, short)=>({
                    timeZone: 'UTC',
                    month: short ? 'short' : 'long'
                }));
        });
        function isOutside(day) {
            const dayIdentifier = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(day);
            return dayIdentifier < (0, $f32372070b64b5ae$export$a696b9fd3900684e)(base.parsedStart.value) || dayIdentifier > (0, $f32372070b64b5ae$export$a696b9fd3900684e)(base.parsedEnd.value);
        }
        function genHead() {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-weekly__head",
                "role": "row"
            }, [
                genHeadDays()
            ]);
        }
        function genHeadDays() {
            const header = todayWeek.value.map(genHeadDay);
            if (props.showWeek) header.unshift((0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-weekly__head-weeknumber"
            }, null));
            return header;
        }
        function genHeadDay(day, index) {
            const outside = isOutside(days.value[index]);
            const color = day.present ? props.color : undefined;
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)(base.getColorProps({
                text: color
            }), {
                "key": day.date,
                "class": [
                    'v-calendar-weekly__head-weekday',
                    base.getRelativeClasses(day, outside)
                ],
                "role": "columnheader"
            }), [
                base.weekdayFormatter.value(day, props.shortWeekdays)
            ]);
        }
        function genWeeks() {
            const daysValue = days.value;
            const weekDays = base.parsedWeekdays.value.length;
            const weeks = [];
            for(let i = 0; i < daysValue.length; i += weekDays)weeks.push(genWeek(daysValue.slice(i, i + weekDays), getWeekNumber(daysValue[i])));
            return weeks;
        }
        function genWeek(week, weekNumber) {
            const weekNodes = week.map((day, index)=>genDay(day, index, week));
            if (props.showWeek) weekNodes.unshift(genWeekNumber(weekNumber));
            return (0, $TusQn.createElementVNode)("div", {
                "key": week[0].date,
                "class": "v-calendar-weekly__week",
                "role": "row"
            }, [
                weekNodes
            ]);
        }
        function getWeekNumber(determineDay) {
            return base.getWeekNumber(determineDay);
        }
        function genWeekNumber(weekNumber) {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-weekly__weeknumber"
            }, [
                (0, $TusQn.createElementVNode)("small", null, [
                    String(weekNumber)
                ])
            ]);
        }
        function genDay(day, index, week) {
            const outside = isOutside(day);
            const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':day', (nativeEvent)=>{
                return {
                    nativeEvent: nativeEvent,
                    ...day
                };
            });
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "key": day.date,
                "class": [
                    'v-calendar-weekly__day',
                    base.getRelativeClasses(day, outside)
                ],
                "role": "cell"
            }, events), [
                genDayLabel(day),
                slots.day?.({
                    outside: outside,
                    index: index,
                    week: week,
                    ...day
                })
            ]);
        }
        function genDayLabel(day) {
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-calendar-weekly__day-label"
            }, [
                slots['day-label']?.(day) ?? genDayLabelButton(day)
            ]);
        }
        function genDayLabelButton(day) {
            const hasMonth = day.day === 1 && props.showMonthOnFirst;
            const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':date', (nativeEvent)=>({
                    nativeEvent: nativeEvent,
                    ...day
                }));
            return (0, $TusQn.createVNode)((0, $f05757d4ecc644dc$export$d35ef2d5f4f4551c), (0, $TusQn.mergeProps)({
                "active": day.present,
                "activeColor": props.color,
                "variant": "outlined",
                "baseVariant": "text",
                "onUpdate:active": (0, $8590040a7833369a$export$8793edee2d425525)
            }, events), {
                default: ()=>[
                        hasMonth ? monthFormatter.value(day, props.shortMonths) + ' ' + base.dayFormatter.value(day, false) : base.dayFormatter.value(day, false)
                    ]
            });
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-calendar-weekly',
                    theme.themeClasses.value
                ]),
                "onDragstart": (e)=>e.preventDefault()
            }, [
                !props.hideHeader ? genHead() : undefined,
                genWeeks()
            ]));
        return {
            ...base,
            days: days,
            todayWeek: todayWeek,
            monthFormatter: monthFormatter,
            isOutside: isOutside
        };
    }
});



parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");



// Types
// Types
// Types

const $1e4e2560ca0070f3$var$MILLIS_IN_DAY = 86400000;
function $1e4e2560ca0070f3$export$845c02bd1dbe490(events) {
    let minStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    const visuals = events.map((event)=>({
            event: event,
            columnCount: 0,
            column: 0,
            left: 0,
            width: 100
        }));
    visuals.sort((a, b)=>{
        return Math.max(minStart, a.event.startTimestampIdentifier) - Math.max(minStart, b.event.startTimestampIdentifier) || b.event.endTimestampIdentifier - a.event.endTimestampIdentifier;
    });
    return visuals;
}
function $1e4e2560ca0070f3$export$1468a49de573f7f9(s0, e0, s1, e1) {
    let exclude = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    return exclude ? !(s0 >= e1 || e0 <= s1) : !(s0 > e1 || e0 < s1);
}
function $1e4e2560ca0070f3$export$d1f3e09a64cc3796(groups) {
    groups.forEach((group)=>{
        group.visuals.forEach((groupVisual)=>{
            groupVisual.columnCount = groups.length;
        });
    });
}
function $1e4e2560ca0070f3$export$fef151b94550e9f5(event) {
    return [
        event.startTimestampIdentifier,
        event.endTimestampIdentifier
    ];
}
function $1e4e2560ca0070f3$export$adb5aef569605e64(event) {
    return [
        event.startIdentifier,
        event.endIdentifier
    ];
}
function $1e4e2560ca0070f3$export$bd131b5809121dda(event, dayStart) {
    return [
        Math.max(dayStart, event.startTimestampIdentifier),
        Math.min(dayStart + $1e4e2560ca0070f3$var$MILLIS_IN_DAY, event.endTimestampIdentifier)
    ];
}
function $1e4e2560ca0070f3$export$915a7fe8d8568327(groups, start, end, timed) {
    for(let i = 0; i < groups.length; i++){
        const group = groups[i];
        let intersected = false;
        if ($1e4e2560ca0070f3$export$1468a49de573f7f9(start, end, group.start, group.end, timed)) for(let k = 0; k < group.visuals.length; k++){
            const groupVisual = group.visuals[k];
            const [groupStart, groupEnd] = timed ? $1e4e2560ca0070f3$export$fef151b94550e9f5(groupVisual.event) : $1e4e2560ca0070f3$export$adb5aef569605e64(groupVisual.event);
            if ($1e4e2560ca0070f3$export$1468a49de573f7f9(start, end, groupStart, groupEnd, timed)) {
                intersected = true;
                break;
            }
        }
        if (!intersected) return i;
    }
    return -1;
}
function $1e4e2560ca0070f3$export$842aa98654ee9a06(firstWeekday) {
    const handler = {
        groups: [],
        min: -1,
        max: -1,
        reset: ()=>{
            handler.groups = [];
            handler.min = handler.max = -1;
        },
        getVisuals: function(day, dayEvents, timed) {
            let reset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
            if (day.weekday === firstWeekday || reset) handler.reset();
            const dayStart = (0, $f32372070b64b5ae$export$c9c199c1ef374128)(day);
            const visuals = $1e4e2560ca0070f3$export$845c02bd1dbe490(dayEvents, dayStart);
            visuals.forEach((visual)=>{
                const [start, end] = timed ? $1e4e2560ca0070f3$export$fef151b94550e9f5(visual.event) : $1e4e2560ca0070f3$export$adb5aef569605e64(visual.event);
                if (handler.groups.length > 0 && !$1e4e2560ca0070f3$export$1468a49de573f7f9(start, end, handler.min, handler.max, timed)) {
                    $1e4e2560ca0070f3$export$d1f3e09a64cc3796(handler.groups);
                    handler.reset();
                }
                let targetGroup = $1e4e2560ca0070f3$export$915a7fe8d8568327(handler.groups, start, end, timed);
                if (targetGroup === -1) {
                    targetGroup = handler.groups.length;
                    handler.groups.push({
                        start: start,
                        end: end,
                        visuals: []
                    });
                }
                const target = handler.groups[targetGroup];
                target.visuals.push(visual);
                target.start = Math.min(target.start, start);
                target.end = Math.max(target.end, end);
                visual.column = targetGroup;
                if (handler.min === -1) {
                    handler.min = start;
                    handler.max = end;
                } else {
                    handler.min = Math.min(handler.min, start);
                    handler.max = Math.max(handler.max, end);
                }
            });
            $1e4e2560ca0070f3$export$d1f3e09a64cc3796(handler.groups);
            if (timed) handler.reset();
            return visuals;
        }
    };
    return handler;
}


const $03fe2da0872fb43a$var$FULL_WIDTH = 100;
const $03fe2da0872fb43a$export$4e0c71f277ca26b3 = (events, firstWeekday, overlapThreshold)=>{
    const handler = (0, $1e4e2560ca0070f3$export$842aa98654ee9a06)(firstWeekday);
    return (day, dayEvents, timed, reset)=>{
        const visuals = handler.getVisuals(day, dayEvents, timed, reset);
        if (timed) visuals.forEach((visual)=>{
            visual.left = visual.column * $03fe2da0872fb43a$var$FULL_WIDTH / visual.columnCount;
            visual.width = $03fe2da0872fb43a$var$FULL_WIDTH / visual.columnCount;
        });
        return visuals;
    };
};


// Types


const $6742a653a30381ff$var$FULL_WIDTH = 100;
const $6742a653a30381ff$var$DEFAULT_OFFSET = 5;
const $6742a653a30381ff$var$WIDTH_MULTIPLIER = 1.7;
const $6742a653a30381ff$export$a57ab32f40f83ea9 = (events, firstWeekday, overlapThreshold)=>{
    const handler = (0, $1e4e2560ca0070f3$export$842aa98654ee9a06)(firstWeekday);
    // eslint-disable-next-line max-statements
    return (day, dayEvents, timed, reset)=>{
        if (!timed) return handler.getVisuals(day, dayEvents, timed, reset);
        const dayStart = (0, $f32372070b64b5ae$export$c9c199c1ef374128)(day);
        const visuals = (0, $1e4e2560ca0070f3$export$845c02bd1dbe490)(dayEvents, dayStart);
        const groups = $6742a653a30381ff$var$getGroups(visuals, dayStart);
        for (const group of groups){
            const nodes = [];
            for (const visual of group.visuals){
                const child = $6742a653a30381ff$var$getNode(visual, dayStart);
                const index = $6742a653a30381ff$var$getNextIndex(child, nodes);
                if (index === false) {
                    const parent = $6742a653a30381ff$var$getParent(child, nodes);
                    if (parent) {
                        child.parent = parent;
                        child.sibling = (0, $1e4e2560ca0070f3$export$1468a49de573f7f9)(child.start, child.end, parent.start, $6742a653a30381ff$var$addTime(parent.start, overlapThreshold));
                        child.index = parent.index + 1;
                        parent.children.push(child);
                    }
                } else {
                    const [parent] = $6742a653a30381ff$var$getOverlappingRange(child, nodes, index - 1, index - 1);
                    const children = $6742a653a30381ff$var$getOverlappingRange(child, nodes, index + 1, index + nodes.length, true);
                    child.children = children;
                    child.index = index;
                    if (parent) {
                        child.parent = parent;
                        child.sibling = (0, $1e4e2560ca0070f3$export$1468a49de573f7f9)(child.start, child.end, parent.start, $6742a653a30381ff$var$addTime(parent.start, overlapThreshold));
                        parent.children.push(child);
                    }
                    for (const grand of children){
                        if (grand.parent === parent) grand.parent = child;
                        const grandNext = grand.index - child.index <= 1;
                        if (grandNext && child.sibling && (0, $1e4e2560ca0070f3$export$1468a49de573f7f9)(child.start, $6742a653a30381ff$var$addTime(child.start, overlapThreshold), grand.start, grand.end)) grand.sibling = true;
                    }
                }
                nodes.push(child);
            }
            $6742a653a30381ff$var$calculateBounds(nodes, overlapThreshold);
        }
        visuals.sort((a, b)=>a.left - b.left || a.event.startTimestampIdentifier - b.event.startTimestampIdentifier);
        return visuals;
    };
};
function $6742a653a30381ff$var$calculateBounds(nodes, overlapThreshold) {
    for (const node of nodes){
        const { visual: visual, parent: parent } = node;
        const columns = $6742a653a30381ff$var$getMaxChildIndex(node) + 1;
        const spaceLeft = parent ? parent.visual.left : 0;
        const spaceWidth = $6742a653a30381ff$var$FULL_WIDTH - spaceLeft;
        const offset = Math.min($6742a653a30381ff$var$DEFAULT_OFFSET, $6742a653a30381ff$var$FULL_WIDTH / columns);
        const columnWidthMultiplier = $6742a653a30381ff$var$getColumnWidthMultiplier(node, nodes);
        const columnOffset = spaceWidth / (columns - node.index + 1);
        const columnWidth = spaceWidth / (columns - node.index + (node.sibling ? 1 : 0)) * columnWidthMultiplier;
        if (parent) visual.left = node.sibling ? spaceLeft + columnOffset : spaceLeft + offset;
        visual.width = $6742a653a30381ff$var$hasFullWidth(node, nodes, overlapThreshold) ? $6742a653a30381ff$var$FULL_WIDTH - visual.left : Math.min($6742a653a30381ff$var$FULL_WIDTH - visual.left, columnWidth * $6742a653a30381ff$var$WIDTH_MULTIPLIER);
    }
}
function $6742a653a30381ff$var$getColumnWidthMultiplier(node, nodes) {
    if (!node.children.length) return 1;
    const maxColumn = node.index + nodes.length;
    const minColumn = node.children.reduce((min, c)=>Math.min(min, c.index), maxColumn);
    return minColumn - node.index;
}
function $6742a653a30381ff$var$getOverlappingIndices(node, nodes) {
    const indices = [];
    for (const other of nodes)if ((0, $1e4e2560ca0070f3$export$1468a49de573f7f9)(node.start, node.end, other.start, other.end)) indices.push(other.index);
    return indices;
}
function $6742a653a30381ff$var$getNextIndex(node, nodes) {
    const indices = $6742a653a30381ff$var$getOverlappingIndices(node, nodes);
    indices.sort();
    for(let i = 0; i < indices.length; i++){
        if (i < indices[i]) return i;
    }
    return false;
}
function $6742a653a30381ff$var$getOverlappingRange(node, nodes, indexMin, indexMax) {
    let returnFirstColumn = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    const overlapping = [];
    for (const other of nodes)if (other.index >= indexMin && other.index <= indexMax && (0, $1e4e2560ca0070f3$export$1468a49de573f7f9)(node.start, node.end, other.start, other.end)) overlapping.push(other);
    if (returnFirstColumn && overlapping.length > 0) {
        const first = overlapping.reduce((min, n)=>Math.min(min, n.index), overlapping[0].index);
        return overlapping.filter((n)=>n.index === first);
    }
    return overlapping;
}
function $6742a653a30381ff$var$getParent(node, nodes) {
    let parent = null;
    for (const other of nodes)if ((0, $1e4e2560ca0070f3$export$1468a49de573f7f9)(node.start, node.end, other.start, other.end) && (parent === null || other.index > parent.index)) parent = other;
    return parent;
}
function $6742a653a30381ff$var$hasFullWidth(node, nodes, overlapThreshold) {
    for (const other of nodes){
        if (other !== node && other.index > node.index && (0, $1e4e2560ca0070f3$export$1468a49de573f7f9)(node.start, $6742a653a30381ff$var$addTime(node.start, overlapThreshold), other.start, other.end)) return false;
    }
    return true;
}
function $6742a653a30381ff$var$getGroups(visuals, dayStart) {
    const groups = [];
    for (const visual of visuals){
        const [start, end] = (0, $1e4e2560ca0070f3$export$bd131b5809121dda)(visual.event, dayStart);
        let added = false;
        for (const group of groups)if ((0, $1e4e2560ca0070f3$export$1468a49de573f7f9)(start, end, group.start, group.end)) {
            group.visuals.push(visual);
            group.end = Math.max(group.end, end);
            added = true;
            break;
        }
        if (!added) groups.push({
            start: start,
            end: end,
            visuals: [
                visual
            ]
        });
    }
    return groups;
}
function $6742a653a30381ff$var$getNode(visual, dayStart) {
    const [start, end] = (0, $1e4e2560ca0070f3$export$bd131b5809121dda)(visual.event, dayStart);
    return {
        parent: null,
        sibling: true,
        index: 0,
        visual: visual,
        start: start,
        end: end,
        children: []
    };
}
function $6742a653a30381ff$var$getMaxChildIndex(node) {
    let max = node.index;
    for (const child of node.children){
        const childMax = $6742a653a30381ff$var$getMaxChildIndex(child);
        if (childMax > max) max = childMax;
    }
    return max;
}
function $6742a653a30381ff$var$addTime(identifier, minutes) {
    const removeMinutes = identifier % 100;
    const totalMinutes = removeMinutes + minutes;
    const addHours = Math.floor(totalMinutes / 60);
    const addMinutes = totalMinutes % 60;
    return identifier - removeMinutes + addHours * 100 + addMinutes;
}


const $001ebfe309a7ee48$export$78c56965610b471a = {
    stack: $6742a653a30381ff$export$a57ab32f40f83ea9,
    column: $03fe2da0872fb43a$export$4e0c71f277ca26b3
};



function $2e5df7f2c8635cfa$export$9945f989cdbcb339(input, index, startProperty, endProperty) {
    let timed = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    let category = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    const startInput = input[startProperty];
    const endInput = input[endProperty];
    const startParsed = (0, $f32372070b64b5ae$export$9fc5011a778dc2d8)(startInput, true);
    const endParsed = endInput ? (0, $f32372070b64b5ae$export$9fc5011a778dc2d8)(endInput, true) : startParsed;
    const start = (0, $f32372070b64b5ae$export$a9ff3f4e7dc50ac7)(startInput) ? (0, $f32372070b64b5ae$export$78dc5db788b5e904)(startParsed, timed) : startParsed;
    const end = (0, $f32372070b64b5ae$export$a9ff3f4e7dc50ac7)(endInput) ? (0, $f32372070b64b5ae$export$78dc5db788b5e904)(endParsed, timed) : endParsed;
    const startIdentifier = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(start);
    const startTimestampIdentifier = (0, $f32372070b64b5ae$export$c9c199c1ef374128)(start);
    const endIdentifier = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(end);
    const endOffset = start.hasTime ? 0 : 2359;
    const endTimestampIdentifier = (0, $f32372070b64b5ae$export$c9c199c1ef374128)(end) + endOffset;
    const allDay = !start.hasTime;
    return {
        input: input,
        start: start,
        startIdentifier: startIdentifier,
        startTimestampIdentifier: startTimestampIdentifier,
        end: end,
        endIdentifier: endIdentifier,
        endTimestampIdentifier: endTimestampIdentifier,
        allDay: allDay,
        index: index,
        category: category
    };
}
function $2e5df7f2c8635cfa$export$39cfe03d18fc9419(event, dayIdentifier) {
    return dayIdentifier >= event.startIdentifier && dayIdentifier <= event.endIdentifier;
}
function $2e5df7f2c8635cfa$export$6b8f493db111f4ae(event, day, inRange) {
    if (inRange) {
        const dayStart = (0, $f32372070b64b5ae$export$88061d15ba6d1ea4)((0, $f32372070b64b5ae$export$1d1e1fb06fb01050)(day), inRange[0]);
        const dayEnd = (0, $f32372070b64b5ae$export$88061d15ba6d1ea4)((0, $f32372070b64b5ae$export$1d1e1fb06fb01050)(day), inRange[1]);
        const starts = event.startTimestampIdentifier < (0, $f32372070b64b5ae$export$c9c199c1ef374128)(dayEnd);
        const ends = event.endTimestampIdentifier > (0, $f32372070b64b5ae$export$c9c199c1ef374128)(dayStart);
        return starts && ends;
    }
    return $2e5df7f2c8635cfa$export$39cfe03d18fc9419(event, (0, $f32372070b64b5ae$export$a696b9fd3900684e)(day));
}
function $2e5df7f2c8635cfa$export$75e58522719a18b3(event, day) {
    return event.end.time === '00:00' && event.end.date === day.date && event.start.date !== day.date;
}
function $2e5df7f2c8635cfa$export$c6581e8225bf5cf7(event, day, dayIdentifier, firstWeekday) {
    return dayIdentifier === event.startIdentifier || firstWeekday === day.weekday && $2e5df7f2c8635cfa$export$39cfe03d18fc9419(event, dayIdentifier);
}
function $2e5df7f2c8635cfa$export$39926ef53dc69d9f(event, startIdentifier, endIdentifier) {
    return startIdentifier <= event.endIdentifier && endIdentifier >= event.startIdentifier;
}




// Constants
const $351af6c6960fc8dc$var$WIDTH_FULL = 100;
const $351af6c6960fc8dc$var$WIDTH_START = 95;
const $351af6c6960fc8dc$export$d8731ae3ce6f880d = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    events: {
        type: Array,
        default: ()=>[]
    },
    eventStart: {
        type: String,
        default: 'start'
    },
    eventEnd: {
        type: String,
        default: 'end'
    },
    eventTimed: {
        type: [
            String,
            Function
        ],
        default: 'timed'
    },
    eventCategory: {
        type: [
            String,
            Function
        ],
        default: 'category'
    },
    eventHeight: {
        type: Number,
        default: 20
    },
    eventColor: {
        type: [
            String,
            Function
        ],
        default: 'primary'
    },
    eventTextColor: {
        type: [
            String,
            Function
        ]
    },
    eventName: {
        type: [
            String,
            Function
        ],
        default: 'name'
    },
    eventOverlapThreshold: {
        type: [
            String,
            Number
        ],
        default: 60
    },
    eventOverlapMode: {
        type: [
            String,
            Function
        ],
        default: 'stack',
        validate: (mode)=>mode in (0, $001ebfe309a7ee48$export$78c56965610b471a) || typeof mode === 'function'
    },
    eventMore: {
        type: Boolean,
        default: true
    },
    eventMoreText: {
        type: String,
        default: '$vuetify.calendar.moreEvents'
    },
    eventRipple: {
        type: [
            Boolean,
            Object
        ],
        default: null
    },
    eventMarginBottom: {
        type: Number,
        default: 1
    }
}, 'VCalendar-events');
function $351af6c6960fc8dc$export$d2ebd301565f9877(props, slots, attrs) {
    const base = (0, $ac4aa0418ddc4fee$export$d652b3ea2d672d5b)(props);
    const noEvents = (0, $01W3b.computed)(()=>{
        return !Array.isArray(props.events) || props.events.length === 0;
    });
    const categoryMode = (0, $01W3b.computed)(()=>{
        return props.type === 'category';
    });
    const eventTimedFunction = (0, $01W3b.computed)(()=>{
        return typeof props.eventTimed === 'function' ? props.eventTimed : (event)=>!!event[props.eventTimed];
    });
    const eventCategoryFunction = (0, $01W3b.computed)(()=>{
        return typeof props.eventCategory === 'function' ? props.eventCategory : (event)=>event[props.eventCategory];
    });
    const parsedEvents = (0, $01W3b.computed)(()=>{
        if (!props.events) return [];
        return props.events.map((event, index)=>(0, $2e5df7f2c8635cfa$export$9945f989cdbcb339)(event, index, props.eventStart || '', props.eventEnd || '', eventTimedFunction.value(event), categoryMode.value ? eventCategoryFunction.value(event) : false));
    });
    const parsedEventOverlapThreshold = (0, $01W3b.computed)(()=>{
        return parseInt(String(props.eventOverlapThreshold || 0));
    });
    const eventTextColorFunction = (0, $01W3b.computed)(()=>{
        return typeof props.eventTextColor === 'function' ? props.eventTextColor : ()=>props.eventTextColor;
    });
    const eventNameFunction = (0, $01W3b.computed)(()=>{
        return typeof props.eventName === 'function' ? props.eventName : (event, timedEvent)=>event.input[props.eventName] || '';
    });
    const eventModeFunction = (0, $01W3b.computed)(()=>{
        return typeof props.eventOverlapMode === 'function' ? props.eventOverlapMode : (0, $001ebfe309a7ee48$export$78c56965610b471a)[props.eventOverlapMode];
    });
    const eventWeekdays = (0, $01W3b.computed)(()=>{
        return base.effectiveWeekdays.value;
    });
    function eventColorFunction(e) {
        return typeof props.eventColor === 'function' ? props.eventColor(e) : e.color || props.eventColor;
    }
    const eventsRef = (0, $01W3b.ref)([]);
    function updateEventVisibility() {
        if (noEvents.value || !props.eventMore) return;
        const eventHeight = props.eventHeight || 0;
        const eventsMap = getEventsMap();
        for(const date in eventsMap){
            const { parent: parent, events: events, more: more } = eventsMap[date];
            if (!more) break;
            const parentBounds = parent.getBoundingClientRect();
            const last = events.length - 1;
            const eventsSorted = events.map((event)=>({
                    event: event,
                    bottom: event.getBoundingClientRect().bottom
                })).sort((a, b)=>a.bottom - b.bottom);
            let hidden = 0;
            for(let i = 0; i <= last; i++){
                const bottom = eventsSorted[i].bottom;
                const hide = i === last ? bottom > parentBounds.bottom : bottom + eventHeight > parentBounds.bottom;
                if (hide) {
                    eventsSorted[i].event.style.display = 'none';
                    hidden++;
                }
            }
            // TODO: avoid direct DOM manipulation
            if (hidden) {
                more.style.display = '';
                more.innerHTML = base.locale.t(props.eventMoreText, hidden);
            } else more.style.display = 'none';
        }
    }
    function getEventsMap() {
        const eventsMap = {};
        const elements = eventsRef.value;
        if (!elements || !elements.length) return eventsMap;
        elements.forEach((el)=>{
            const date = el.getAttribute('data-date');
            if (el.parentElement && date) {
                if (!(date in eventsMap)) eventsMap[date] = {
                    parent: el.parentElement,
                    more: null,
                    events: []
                };
                if (el.getAttribute('data-more')) eventsMap[date].more = el;
                else {
                    eventsMap[date].events.push(el);
                    el.style.display = '';
                }
            }
        });
        return eventsMap;
    }
    function genDayEvent(_ref, day) {
        let { event: event } = _ref;
        const eventHeight = props.eventHeight || 0;
        const eventMarginBottom = props.eventMarginBottom || 0;
        const dayIdentifier = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(day);
        const week = day.week;
        const start = dayIdentifier === event.startIdentifier;
        let end = dayIdentifier === event.endIdentifier;
        let width = $351af6c6960fc8dc$var$WIDTH_START;
        if (!categoryMode.value) for(let i = day.index + 1; i < week.length; i++){
            const weekdayIdentifier = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(week[i]);
            if (event.endIdentifier >= weekdayIdentifier) {
                width += $351af6c6960fc8dc$var$WIDTH_FULL;
                end = end || weekdayIdentifier === event.endIdentifier;
            } else {
                end = true;
                break;
            }
        }
        const scope = {
            eventParsed: event,
            day: day,
            start: start,
            end: end,
            timed: false
        };
        return genEvent(event, scope, false, {
            class: [
                'v-event',
                {
                    'v-event-start': start,
                    'v-event-end': end
                }
            ],
            style: {
                height: `${eventHeight}px`,
                width: `${width}%`,
                marginBottom: `${eventMarginBottom}px`
            },
            'data-date': day.date
        });
    }
    function genTimedEvent(_ref2, day) {
        let { event: event, left: left, width: width } = _ref2;
        const startDelta = day.timeDelta(event.start, day);
        const endDelta = day.timeDelta(event.end, day);
        if (endDelta === false || startDelta === false || endDelta < 0 || startDelta >= 1 || (0, $2e5df7f2c8635cfa$export$75e58522719a18b3)(event, day)) return false;
        const dayIdentifier = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(day);
        const start = event.startIdentifier >= dayIdentifier;
        const end = event.endIdentifier > dayIdentifier;
        const top = day.timeToY(event.start, day);
        const bottom = day.timeToY(event.end, day);
        const height = Math.max(props.eventHeight || 0, bottom - top);
        const scope = {
            eventParsed: event,
            day: day,
            start: start,
            end: end,
            timed: true
        };
        return genEvent(event, scope, true, {
            class: 'v-event-timed',
            style: {
                top: `${top}px`,
                height: `${height}px`,
                left: `${left}%`,
                width: `${width}%`
            }
        });
    }
    function genEvent(event, scopeInput, timedEvent, data) {
        const slot = slots.event;
        const text = eventTextColorFunction.value(event.input);
        const background = eventColorFunction(event.input);
        const overlapsNoon = event.start.hour < 12 && event.end.hour >= 12;
        const singline = (0, $f32372070b64b5ae$export$49c90754e1099334)(event.start, event.end) <= parsedEventOverlapThreshold.value;
        const formatTime = (withTime, ampm)=>{
            const formatter = base.getFormatter({
                timeZone: 'UTC',
                hour: 'numeric',
                minute: withTime.minute > 0 ? 'numeric' : undefined
            });
            return formatter(withTime, true);
        };
        const timeSummary = ()=>formatTime(event.start, overlapsNoon) + ' - ' + formatTime(event.end, true);
        const eventSummary = ()=>{
            const name = eventNameFunction.value(event, timedEvent);
            if (event.start.hasTime) {
                if (timedEvent) {
                    const time = timeSummary();
                    const delimiter = singline ? ', ' : (0, $TusQn.createElementVNode)("br", null, null);
                    return (0, $TusQn.createElementVNode)("span", {
                        "class": "v-event-summary"
                    }, [
                        (0, $TusQn.createElementVNode)("strong", null, [
                            name
                        ]),
                        delimiter,
                        time
                    ]);
                } else {
                    const time = formatTime(event.start, true);
                    return (0, $TusQn.createElementVNode)("span", {
                        "class": "v-event-summary"
                    }, [
                        (0, $TusQn.createElementVNode)("strong", null, [
                            time
                        ]),
                        (0, $TusQn.createTextVNode)(" "),
                        name
                    ]);
                }
            }
            return (0, $TusQn.createElementVNode)("span", {
                "class": "v-event-summary"
            }, [
                name
            ]);
        };
        const scope = {
            ...scopeInput,
            event: event.input,
            outside: scopeInput.day.outside,
            singline: singline,
            overlapsNoon: overlapsNoon,
            formatTime: formatTime,
            timeSummary: timeSummary,
            eventSummary: eventSummary
        };
        const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':event', (nativeEvent)=>({
                ...scope,
                nativeEvent: nativeEvent
            }));
        return (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)(base.getColorProps({
            text: text,
            background: background
        }), events, data, {
            "ref_for": true,
            "ref": eventsRef
        }), [
            slot?.(scope) ?? genName(eventSummary)
        ]), [
            [
                (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                props.eventRipple ?? true
            ]
        ]);
    }
    function genName(eventSummary) {
        return (0, $TusQn.createElementVNode)("div", {
            "class": "pl-1"
        }, [
            eventSummary()
        ]);
    }
    function genPlaceholder(day) {
        const height = (props.eventHeight || 0) + (props.eventMarginBottom || 0);
        return (0, $TusQn.createElementVNode)("div", {
            "style": {
                height: `${height}px`
            },
            "data-date": day.date,
            "ref_for": true,
            "ref": eventsRef
        }, null);
    }
    function genMore(day) {
        const eventHeight = props.eventHeight || 0;
        const eventMarginBottom = props.eventMarginBottom || 0;
        const events = (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':more', (nativeEvent)=>({
                nativeEvent: nativeEvent,
                ...day
            }));
        return (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
            "class": [
                'v-event-more pl-1',
                {
                    'v-outside': day.outside
                }
            ],
            "data-date": day.date,
            "data-more": "1",
            "style": {
                display: 'none',
                height: `${eventHeight}px`,
                marginBottom: `${eventMarginBottom}px`
            },
            "ref_for": true,
            "ref": eventsRef
        }, events), null), [
            [
                (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                props.eventRipple ?? true
            ]
        ]);
    }
    function getVisibleEvents() {
        const days = base.days.value;
        const start = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(days[0]);
        const end = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(days[days.length - 1]);
        return parsedEvents.value.filter((event)=>(0, $2e5df7f2c8635cfa$export$39926ef53dc69d9f)(event, start, end));
    }
    function isEventForCategory(event, category) {
        return !categoryMode.value || typeof category === 'object' && category.categoryName && category.categoryName === event.category || typeof event.category === 'string' && category === event.category || typeof event.category !== 'string' && category === null;
    }
    function getEventsForDay(day) {
        const identifier = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(day);
        const firstWeekday = eventWeekdays.value[0];
        return parsedEvents.value.filter((event)=>(0, $2e5df7f2c8635cfa$export$c6581e8225bf5cf7)(event, day, identifier, firstWeekday));
    }
    function getEventsForDayAll(day) {
        const identifier = (0, $f32372070b64b5ae$export$a696b9fd3900684e)(day);
        const firstWeekday = eventWeekdays.value[0];
        return parsedEvents.value.filter((event)=>event.allDay && (categoryMode.value ? (0, $2e5df7f2c8635cfa$export$39cfe03d18fc9419)(event, identifier) : (0, $2e5df7f2c8635cfa$export$c6581e8225bf5cf7)(event, day, identifier, firstWeekday)) && isEventForCategory(event, day.category));
    }
    function getEventsForDayTimed(day) {
        return parsedEvents.value.filter((event)=>!event.allDay && (0, $2e5df7f2c8635cfa$export$6b8f493db111f4ae)(event, day, day.intervalRange) && isEventForCategory(event, day.category));
    }
    function getScopedSlots() {
        if (noEvents.value) return {
            ...slots
        };
        const mode = eventModeFunction.value(parsedEvents.value, eventWeekdays.value[0], parsedEventOverlapThreshold.value);
        const isNode = (input)=>!!input;
        const getSlotChildren = (day, getter, mapper, timed)=>{
            const events = getter(day);
            const visuals = mode(day, events, timed, categoryMode.value);
            if (timed) return visuals.map((visual)=>mapper(visual, day)).filter(isNode);
            const children = [];
            visuals.forEach((visual, index)=>{
                while(children.length < visual.column)children.push(genPlaceholder(day));
                const mapped = mapper(visual, day);
                if (mapped) children.push(mapped);
            });
            return children;
        };
        return {
            ...slots,
            day: (day)=>{
                let children = getSlotChildren(day, getEventsForDay, genDayEvent, false);
                if (children && children.length > 0 && props.eventMore) children.push(genMore(day));
                if (slots.day) {
                    const slot = slots.day(day);
                    if (slot) children = children ? children.concat(slot) : slot;
                }
                return children;
            },
            'day-header': (day)=>{
                let children = getSlotChildren(day, getEventsForDayAll, genDayEvent, false);
                if (slots['day-header']) {
                    const slot = slots['day-header'](day);
                    if (slot) children = children ? children.concat(slot) : slot;
                }
                return children;
            },
            'day-body': (day)=>{
                const events = getSlotChildren(day, getEventsForDayTimed, genTimedEvent, true);
                let children = [
                    (0, $TusQn.createElementVNode)("div", {
                        "class": "v-event-timed-container"
                    }, [
                        events
                    ])
                ];
                if (slots['day-body']) {
                    const slot = slots['day-body'](day);
                    if (slot) children = children.concat(slot);
                }
                return children;
            }
        };
    }
    return {
        ...base,
        noEvents: noEvents,
        parsedEvents: parsedEvents,
        parsedEventOverlapThreshold: parsedEventOverlapThreshold,
        eventTimedFunction: eventTimedFunction,
        eventCategoryFunction: eventCategoryFunction,
        eventTextColorFunction: eventTextColorFunction,
        eventNameFunction: eventNameFunction,
        eventModeFunction: eventModeFunction,
        eventWeekdays: eventWeekdays,
        categoryMode: categoryMode,
        eventColorFunction: eventColorFunction,
        eventsRef: eventsRef,
        updateEventVisibility: updateEventVisibility,
        getEventsMap: getEventsMap,
        genDayEvent: genDayEvent,
        genTimedEvent: genTimedEvent,
        genEvent: genEvent,
        genName: genName,
        genPlaceholder: genPlaceholder,
        genMore: genMore,
        getVisibleEvents: getVisibleEvents,
        isEventForCategory: isEventForCategory,
        getEventsForDay: getEventsForDay,
        getEventsForDayAll: getEventsForDayAll,
        getEventsForDayTimed: getEventsForDayTimed,
        getScopedSlots: getScopedSlots
    };
}







const $f41775a2d5957979$export$f7fa51e4c8e83b1f = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCalendar',
    directives: {
        vResize: $a30ddb8f02846b0e$export$2e2bcd8739ae039
    },
    props: {
        modelValue: {
            type: [
                String,
                Number,
                Date
            ],
            validate: (0, $f32372070b64b5ae$export$2d7830448c2dbdbd)
        },
        categoryDays: {
            type: [
                Number,
                String
            ],
            default: 1,
            validate: (x)=>isFinite(parseInt(x)) && parseInt(x) > 0
        },
        categories: {
            type: [
                Array,
                String
            ],
            default: ''
        },
        categoryText: {
            type: [
                String,
                Function
            ]
        },
        maxDays: {
            type: Number,
            default: 7
        },
        categoryHideDynamic: {
            type: Boolean
        },
        categoryShowAll: {
            type: Boolean
        },
        categoryForInvalid: {
            type: String,
            default: ''
        },
        ...(0, $ac4aa0418ddc4fee$export$6e6a01d14d1ad010)(),
        ...(0, $351af6c6960fc8dc$export$d8731ae3ce6f880d)()
    },
    setup (props, _ref) {
        let { slots: slots, attrs: attrs, emit: emit } = _ref;
        const root = (0, $01W3b.ref)();
        const base = (0, $351af6c6960fc8dc$export$d2ebd301565f9877)(props, slots, attrs);
        const lastStart = (0, $01W3b.ref)(null);
        const lastEnd = (0, $01W3b.ref)(null);
        const parsedCategoryDays = (0, $01W3b.computed)(()=>{
            return parseInt(String(props.categoryDays)) || 1;
        });
        const parsedCategories = (0, $01W3b.computed)(()=>{
            return (0, $01f03a1219a9b6e5$export$20f1a4bf379f9eda)(props.categories, props.categoryText);
        });
        const renderProps = (0, $01W3b.computed)(()=>{
            const around = base.parsedValue.value;
            let component = null;
            let maxDays = props.maxDays;
            let categories = parsedCategories.value;
            let start = around;
            let end = around;
            switch(props.type){
                case 'month':
                    component = (0, $66969ccd266e5994$export$9032a1126982ac76);
                    start = (0, $f32372070b64b5ae$export$fb9b45fbf5d9b232)(around);
                    end = (0, $f32372070b64b5ae$export$6ac2712656da4fd7)(around);
                    break;
                case 'week':
                    component = (0, $d11e4111bab56c26$export$a8a1230763a685fd);
                    start = base.getStartOfWeek(around);
                    end = base.getEndOfWeek(around);
                    maxDays = 7;
                    break;
                case 'day':
                    component = (0, $d11e4111bab56c26$export$a8a1230763a685fd);
                    maxDays = 1;
                    break;
                case '4day':
                    component = (0, $d11e4111bab56c26$export$a8a1230763a685fd);
                    end = (0, $f32372070b64b5ae$export$f31e827513f08f84)((0, $f32372070b64b5ae$export$1d1e1fb06fb01050)(end), (0, $f32372070b64b5ae$export$992728922317ffc8), 3);
                    (0, $f32372070b64b5ae$export$311eb4d04bca27b0)(end);
                    maxDays = 4;
                    break;
                case 'custom-weekly':
                    component = (0, $66969ccd266e5994$export$9032a1126982ac76);
                    start = base.parsedStart.value || around;
                    end = base.parsedEnd.value;
                    break;
                case 'custom-daily':
                    component = (0, $d11e4111bab56c26$export$a8a1230763a685fd);
                    start = base.parsedStart.value || around;
                    end = base.parsedEnd.value;
                    break;
                case 'category':
                    const days = parsedCategoryDays.value;
                    component = (0, $f1a541941011c6ad$export$70906a2545c91cdc);
                    end = (0, $f32372070b64b5ae$export$f31e827513f08f84)((0, $f32372070b64b5ae$export$1d1e1fb06fb01050)(end), (0, $f32372070b64b5ae$export$992728922317ffc8), days);
                    (0, $f32372070b64b5ae$export$311eb4d04bca27b0)(end);
                    maxDays = days;
                    categories = getCategoryList(categories);
                    break;
                default:
                    const type = props.type;
                    throw new Error(`${type} is not a valid Calendar type`);
            }
            return {
                component: component,
                start: start,
                end: end,
                maxDays: maxDays,
                categories: categories
            };
        });
        const eventWeekdays = (0, $01W3b.computed)(()=>{
            return base.effectiveWeekdays.value;
        });
        const categoryMode = (0, $01W3b.computed)(()=>{
            return props.type === 'category';
        });
        const monthLongFormatter = (0, $01W3b.computed)(()=>{
            return base.getFormatter({
                timeZone: 'UTC',
                month: 'long'
            });
        });
        const monthShortFormatter = (0, $01W3b.computed)(()=>{
            return base.getFormatter({
                timeZone: 'UTC',
                month: 'short'
            });
        });
        const title = (0, $01W3b.computed)(()=>{
            const { start: start, end: end } = renderProps.value;
            const spanYears = start.year !== end.year;
            const spanMonths = spanYears || start.month !== end.month;
            if (spanYears) return monthShortFormatter.value(start, true) + ' ' + start.year + ' - ' + monthShortFormatter.value(end, true) + ' ' + end.year;
            if (spanMonths) return monthShortFormatter.value(start, true) + ' - ' + monthShortFormatter.value(end, true) + ' ' + end.year;
            else return monthLongFormatter.value(start, false) + ' ' + start.year;
        });
        function checkChange() {
            const { start: start, end: end } = renderProps.value;
            if (!lastStart.value || !lastEnd.value || start.date !== lastStart.value.date || end.date !== lastEnd.value.date) {
                lastStart.value = start;
                lastEnd.value = end;
                emit('change', {
                    start: start,
                    end: end
                });
            }
        }
        function move() {
            let amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            const moved = (0, $f32372070b64b5ae$export$1d1e1fb06fb01050)(base.parsedValue.value);
            const forward = amount > 0;
            const mover = forward ? (0, $f32372070b64b5ae$export$992728922317ffc8) : (0, $f32372070b64b5ae$export$83d9f8120102adf8);
            const limit = forward ? (0, $f32372070b64b5ae$export$5ccd0df9c49c1f5f) : (0, $f32372070b64b5ae$export$f0d374539487f66);
            let times = forward ? amount : -amount;
            while(--times >= 0)switch(props.type){
                case 'month':
                    moved.day = limit;
                    mover(moved);
                    break;
                case 'week':
                    (0, $f32372070b64b5ae$export$f31e827513f08f84)(moved, mover, (0, $f32372070b64b5ae$export$f669a45420d15194));
                    break;
                case 'day':
                    (0, $f32372070b64b5ae$export$f31e827513f08f84)(moved, mover, 1);
                    break;
                case '4day':
                    (0, $f32372070b64b5ae$export$f31e827513f08f84)(moved, mover, 4);
                    break;
                case 'category':
                    (0, $f32372070b64b5ae$export$f31e827513f08f84)(moved, mover, parsedCategoryDays.value);
                    break;
            }
            (0, $f32372070b64b5ae$export$ef436cc98004512d)(moved);
            (0, $f32372070b64b5ae$export$311eb4d04bca27b0)(moved);
            (0, $f32372070b64b5ae$export$691f4625508e8fd4)(moved, base.times.now);
            if (props.modelValue instanceof Date) emit('update:modelValue', (0, $f32372070b64b5ae$export$64d33c59520c51c1)(moved));
            else if (typeof props.modelValue === 'number') emit('update:modelValue', (0, $f32372070b64b5ae$export$64d33c59520c51c1)(moved).getTime());
            else emit('update:modelValue', moved.date);
            emit('moved', moved);
        }
        function next() {
            let amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            move(amount);
        }
        function prev() {
            let amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
            move(-amount);
        }
        function getCategoryList(categories) {
            if (!base.noEvents.value) {
                const categoryMap = categories.reduce((map, category, index)=>{
                    if (typeof category === 'object' && category.categoryName) map[category.categoryName] = {
                        index: index,
                        count: 0
                    };
                    else if (typeof category === 'string') map[category] = {
                        index: index,
                        count: 0
                    };
                    return map;
                }, {});
                if (!props.categoryHideDynamic || !props.categoryShowAll) {
                    let categoryLength = categories.length;
                    base.parsedEvents.value.forEach((ev)=>{
                        let category = ev.category;
                        if (typeof category !== 'string') category = props.categoryForInvalid;
                        if (!category) return;
                        if (category in categoryMap) categoryMap[category].count++;
                        else if (!props.categoryHideDynamic) categoryMap[category] = {
                            index: categoryLength++,
                            count: 1
                        };
                    });
                }
                if (!props.categoryShowAll) {
                    for(const category in categoryMap)if (categoryMap[category].count === 0) delete categoryMap[category];
                }
                categories = categories.filter((category)=>{
                    if (typeof category === 'object' && category.categoryName) return categoryMap.hasOwnProperty(category.categoryName);
                    else if (typeof category === 'string') return categoryMap.hasOwnProperty(category);
                    return false;
                });
            }
            return categories;
        }
        (0, $01W3b.watch)(renderProps, checkChange);
        (0, $TusQn.onMounted)(()=>{
            base.updateEventVisibility();
            checkChange();
        });
        (0, $TusQn.onUpdated)(()=>{
            window.requestAnimationFrame(base.updateEventVisibility);
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const { start: start, end: end, maxDays: maxDays, component: Component, categories: categories } = renderProps.value;
            return (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(Component, (0, $TusQn.mergeProps)({
                "ref": root,
                "class": [
                    'v-calendar',
                    {
                        'v-calendar-events': !base.noEvents.value
                    }
                ],
                "role": "grid"
            }, Component.filterProps(props), {
                "start": start.date,
                "end": end.date,
                "maxDays": maxDays,
                "weekdays": base.effectiveWeekdays.value,
                "categories": categories,
                "onClick:date": (e, day)=>{
                    if (attrs['onUpdate:modelValue']) emit('update:modelValue', day.date);
                }
            }), base.getScopedSlots()), [
                [
                    (0, $a30ddb8f02846b0e$export$2e2bcd8739ae039),
                    base.updateEventVisibility,
                    void 0,
                    {
                        quiet: true
                    }
                ]
            ]);
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({
            ...base,
            lastStart: lastStart,
            lastEnd: lastEnd,
            parsedCategoryDays: parsedCategoryDays,
            renderProps: renderProps,
            eventWeekdays: eventWeekdays,
            categoryMode: categoryMode,
            title: title,
            monthLongFormatter: monthLongFormatter,
            monthShortFormatter: monthShortFormatter,
            parsedCategories: parsedCategories,
            checkChange: checkChange,
            move: move,
            next: next,
            prev: prev,
            getCategoryList: getCategoryList
        }, root);
    }
});


 // export { VCalendarCategory as VCalendarCategory } from './VCalendarDaily'
 // export { VCalendarDaily as VCalendarDaily } from './VCalendarWeekly'
 // export { VCalendarWeekly as VCalendarWeekly } from './VCalendarMonthly'
 // export { VCalendarMonthly as VCalendarMonthly } from './VCalendarCategory'


var $a8a0907b18bce8e1$exports = {};

$parcel$export($a8a0907b18bce8e1$exports, "VCard", () => $1419c60fcc1bc8ff$export$f0844a5a421f3a0e);
$parcel$export($a8a0907b18bce8e1$exports, "VCardActions", () => $a2ae4bfdc2091c51$export$e69b3a0bf7ef1418);
$parcel$export($a8a0907b18bce8e1$exports, "VCardItem", () => $e98723d6b9e6cac3$export$dd7f0ecce28a1ff6);
$parcel$export($a8a0907b18bce8e1$exports, "VCardSubtitle", () => $7cb7f3b36c12e211$export$acbd6c585934256e);
$parcel$export($a8a0907b18bce8e1$exports, "VCardText", () => $5801c50143bd74fc$export$e431c8b8253b7d00);
$parcel$export($a8a0907b18bce8e1$exports, "VCardTitle", () => $6ef37c573b288ce0$export$41a39a17ca7a66db);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");




const $a2ae4bfdc2091c51$export$11fe0ebee47bb16 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VCardActions');
const $a2ae4bfdc2091c51$export$e69b3a0bf7ef1418 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCardActions',
    props: $a2ae4bfdc2091c51$export$11fe0ebee47bb16(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                slim: true,
                variant: 'text'
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-card-actions',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, slots));
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



const $7cb7f3b36c12e211$export$3b690aa7c7da0b30 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    opacity: [
        Number,
        String
    ],
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VCardSubtitle');
const $7cb7f3b36c12e211$export$acbd6c585934256e = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCardSubtitle',
    props: $7cb7f3b36c12e211$export$3b690aa7c7da0b30(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-card-subtitle',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-card-subtitle-opacity': props.opacity
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});


// Utilities

const $6ef37c573b288ce0$export$41a39a17ca7a66db = (0, $5224ab9d69b8c3e0$export$b3680ae2c271b9f3)('v-card-title');










const $e98723d6b9e6cac3$export$778ce5b6f64b1823 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    appendAvatar: String,
    appendIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    prependAvatar: String,
    prependIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    subtitle: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    title: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VCardItem');
const $e98723d6b9e6cac3$export$dd7f0ecce28a1ff6 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCardItem',
    props: $e98723d6b9e6cac3$export$778ce5b6f64b1823(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasPrependMedia = !!(props.prependAvatar || props.prependIcon);
            const hasPrepend = !!(hasPrependMedia || slots.prepend);
            const hasAppendMedia = !!(props.appendAvatar || props.appendIcon);
            const hasAppend = !!(hasAppendMedia || slots.append);
            const hasTitle = !!(props.title != null || slots.title);
            const hasSubtitle = !!(props.subtitle != null || slots.subtitle);
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-card-item',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        hasPrepend && (0, $TusQn.createElementVNode)("div", {
                            "key": "prepend",
                            "class": "v-card-item__prepend"
                        }, [
                            !slots.prepend ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                props.prependAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                    "key": "prepend-avatar",
                                    "density": props.density,
                                    "image": props.prependAvatar
                                }, null),
                                props.prependIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                    "key": "prepend-icon",
                                    "density": props.density,
                                    "icon": props.prependIcon
                                }, null)
                            ]) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "prepend-defaults",
                                "disabled": !hasPrependMedia,
                                "defaults": {
                                    VAvatar: {
                                        density: props.density,
                                        image: props.prependAvatar
                                    },
                                    VIcon: {
                                        density: props.density,
                                        icon: props.prependIcon
                                    }
                                }
                            }, slots.prepend)
                        ]),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-card-item__content"
                        }, [
                            hasTitle && (0, $TusQn.createVNode)((0, $6ef37c573b288ce0$export$41a39a17ca7a66db), {
                                "key": "title"
                            }, {
                                default: ()=>[
                                        slots.title?.() ?? (0, $8POXm.toDisplayString)(props.title)
                                    ]
                            }),
                            hasSubtitle && (0, $TusQn.createVNode)((0, $7cb7f3b36c12e211$export$acbd6c585934256e), {
                                "key": "subtitle"
                            }, {
                                default: ()=>[
                                        slots.subtitle?.() ?? (0, $8POXm.toDisplayString)(props.subtitle)
                                    ]
                            }),
                            slots.default?.()
                        ]),
                        hasAppend && (0, $TusQn.createElementVNode)("div", {
                            "key": "append",
                            "class": "v-card-item__append"
                        }, [
                            !slots.append ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                props.appendIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                    "key": "append-icon",
                                    "density": props.density,
                                    "icon": props.appendIcon
                                }, null),
                                props.appendAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                    "key": "append-avatar",
                                    "density": props.density,
                                    "image": props.appendAvatar
                                }, null)
                            ]) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "append-defaults",
                                "disabled": !hasAppendMedia,
                                "defaults": {
                                    VAvatar: {
                                        density: props.density,
                                        image: props.appendAvatar
                                    },
                                    VIcon: {
                                        density: props.density,
                                        icon: props.appendIcon
                                    }
                                }
                            }, slots.append)
                        ])
                    ]
            });
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



const $5801c50143bd74fc$export$8962dbd2532ec6c4 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    opacity: [
        Number,
        String
    ],
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VCardText');
const $5801c50143bd74fc$export$e431c8b8253b7d00 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCardText',
    props: $5801c50143bd74fc$export$8962dbd2532ec6c4(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-card-text',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-card-text-opacity': props.opacity
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});




















const $1419c60fcc1bc8ff$export$13f829be95cb0bf2 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    appendAvatar: String,
    appendIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    disabled: Boolean,
    flat: Boolean,
    hover: Boolean,
    image: String,
    link: {
        type: Boolean,
        default: undefined
    },
    prependAvatar: String,
    prependIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    subtitle: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    text: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    title: {
        type: [
            String,
            Number,
            Boolean
        ],
        default: undefined
    },
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $aec6311fd012b86e$export$149f04e0cba4dbc1)(),
    ...(0, $636e88b893afba47$export$2831add577f947cb)(),
    ...(0, $572b8e75d6c9689d$export$f84374c9369ae887)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $1c0236248fe13b4c$export$78d5db5e8f9b041d)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'elevated'
    })
}, 'VCard');
const $1419c60fcc1bc8ff$export$f0844a5a421f3a0e = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCard',
    directives: {
        vRipple: $907916373bf62ceb$export$2e2bcd8739ae039
    },
    props: $1419c60fcc1bc8ff$export$13f829be95cb0bf2(),
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $567f01637e3e83ec$export$36ef81613f8f20fc)(props);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { loaderClasses: loaderClasses } = (0, $aec6311fd012b86e$export$14095de704efe3f9)(props);
        const { locationStyles: locationStyles } = (0, $636e88b893afba47$export$45d76561a5302f2b)(props);
        const { positionClasses: positionClasses } = (0, $572b8e75d6c9689d$export$8169801eda3f797f)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const link = (0, $1c0236248fe13b4c$export$dcf14c9974fe2767)(props, attrs);
        const loadingColor = (0, $01W3b.shallowRef)(undefined);
        (0, $01W3b.watch)(()=>props.loading, (val, old)=>{
            loadingColor.value = !val && typeof old === 'string' ? old : typeof val === 'boolean' ? undefined : val;
        }, {
            immediate: true
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const isLink = props.link !== false && link.isLink.value;
            const isClickable = !props.disabled && props.link !== false && (props.link || link.isClickable.value);
            const Tag = isLink ? 'a' : props.tag;
            const hasTitle = !!(slots.title || props.title != null);
            const hasSubtitle = !!(slots.subtitle || props.subtitle != null);
            const hasHeader = hasTitle || hasSubtitle;
            const hasAppend = !!(slots.append || props.appendAvatar || props.appendIcon);
            const hasPrepend = !!(slots.prepend || props.prependAvatar || props.prependIcon);
            const hasImage = !!(slots.image || props.image);
            const hasCardItem = hasHeader || hasPrepend || hasAppend;
            const hasText = !!(slots.text || props.text != null);
            return (0, $TusQn.withDirectives)((0, $TusQn.createVNode)(Tag, (0, $TusQn.mergeProps)(link.linkProps, {
                "class": [
                    'v-card',
                    {
                        'v-card--disabled': props.disabled,
                        'v-card--flat': props.flat,
                        'v-card--hover': props.hover && !(props.disabled || props.flat),
                        'v-card--link': isClickable
                    },
                    themeClasses.value,
                    borderClasses.value,
                    colorClasses.value,
                    densityClasses.value,
                    elevationClasses.value,
                    loaderClasses.value,
                    positionClasses.value,
                    roundedClasses.value,
                    variantClasses.value,
                    props.class
                ],
                "style": [
                    colorStyles.value,
                    dimensionStyles.value,
                    locationStyles.value,
                    {
                        '--v-card-height': (0, $8590040a7833369a$export$286ad215293a0860)(props.height)
                    },
                    props.style
                ],
                "onClick": isClickable && link.navigate.value,
                "tabindex": props.disabled ? -1 : undefined
            }), {
                default: ()=>[
                        hasImage && (0, $TusQn.createElementVNode)("div", {
                            "key": "image",
                            "class": "v-card__image"
                        }, [
                            !slots.image ? (0, $TusQn.createVNode)((0, $b2937780237888c4$export$126ec614c536f27c), {
                                "key": "image-img",
                                "cover": true,
                                "src": props.image
                            }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "key": "image-defaults",
                                "disabled": !props.image,
                                "defaults": {
                                    VImg: {
                                        cover: true,
                                        src: props.image
                                    }
                                }
                            }, slots.image)
                        ]),
                        (0, $TusQn.createVNode)((0, $aec6311fd012b86e$export$9a5d46a3538da529), {
                            "name": "v-card",
                            "active": !!props.loading,
                            "color": loadingColor.value
                        }, {
                            default: slots.loader
                        }),
                        hasCardItem && (0, $TusQn.createVNode)((0, $e98723d6b9e6cac3$export$dd7f0ecce28a1ff6), {
                            "key": "item",
                            "prependAvatar": props.prependAvatar,
                            "prependIcon": props.prependIcon,
                            "title": props.title,
                            "subtitle": props.subtitle,
                            "appendAvatar": props.appendAvatar,
                            "appendIcon": props.appendIcon
                        }, {
                            default: slots.item,
                            prepend: slots.prepend,
                            title: slots.title,
                            subtitle: slots.subtitle,
                            append: slots.append
                        }),
                        hasText && (0, $TusQn.createVNode)((0, $5801c50143bd74fc$export$e431c8b8253b7d00), {
                            "key": "text"
                        }, {
                            default: ()=>[
                                    slots.text?.() ?? props.text
                                ]
                        }),
                        slots.default?.(),
                        slots.actions && (0, $TusQn.createVNode)((0, $a2ae4bfdc2091c51$export$e69b3a0bf7ef1418), null, {
                            default: slots.actions
                        }),
                        (0, $567f01637e3e83ec$export$e27cd265ed232373)(isClickable, 'v-card')
                    ]
            }), [
                [
                    (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                    isClickable && props.ripple
                ]
            ]);
        });
        return {};
    }
});









var $981f2f954f40ddcb$exports = {};

$parcel$export($981f2f954f40ddcb$exports, "VCarousel", () => $a580b92d752e9f42$export$2ec2bd507cbf58ac);
$parcel$export($981f2f954f40ddcb$exports, "VCarouselItem", () => $280389f82296200c$export$273c2e14a4f3f313);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");




parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");







// Utilities

const $1f99184c55023168$var$handleGesture = (wrapper)=>{
    const { touchstartX: touchstartX, touchendX: touchendX, touchstartY: touchstartY, touchendY: touchendY } = wrapper;
    const dirRatio = 0.5;
    const minDistance = 16;
    wrapper.offsetX = touchendX - touchstartX;
    wrapper.offsetY = touchendY - touchstartY;
    if (Math.abs(wrapper.offsetY) < dirRatio * Math.abs(wrapper.offsetX)) {
        wrapper.left && touchendX < touchstartX - minDistance && wrapper.left(wrapper);
        wrapper.right && touchendX > touchstartX + minDistance && wrapper.right(wrapper);
    }
    if (Math.abs(wrapper.offsetX) < dirRatio * Math.abs(wrapper.offsetY)) {
        wrapper.up && touchendY < touchstartY - minDistance && wrapper.up(wrapper);
        wrapper.down && touchendY > touchstartY + minDistance && wrapper.down(wrapper);
    }
};
function $1f99184c55023168$var$touchstart(event, wrapper) {
    const touch = event.changedTouches[0];
    wrapper.touchstartX = touch.clientX;
    wrapper.touchstartY = touch.clientY;
    wrapper.start?.({
        originalEvent: event,
        ...wrapper
    });
}
function $1f99184c55023168$var$touchend(event, wrapper) {
    const touch = event.changedTouches[0];
    wrapper.touchendX = touch.clientX;
    wrapper.touchendY = touch.clientY;
    wrapper.end?.({
        originalEvent: event,
        ...wrapper
    });
    $1f99184c55023168$var$handleGesture(wrapper);
}
function $1f99184c55023168$var$touchmove(event, wrapper) {
    const touch = event.changedTouches[0];
    wrapper.touchmoveX = touch.clientX;
    wrapper.touchmoveY = touch.clientY;
    wrapper.move?.({
        originalEvent: event,
        ...wrapper
    });
}
function $1f99184c55023168$var$createHandlers() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const wrapper = {
        touchstartX: 0,
        touchstartY: 0,
        touchendX: 0,
        touchendY: 0,
        touchmoveX: 0,
        touchmoveY: 0,
        offsetX: 0,
        offsetY: 0,
        left: value.left,
        right: value.right,
        up: value.up,
        down: value.down,
        start: value.start,
        move: value.move,
        end: value.end
    };
    return {
        touchstart: (e)=>$1f99184c55023168$var$touchstart(e, wrapper),
        touchend: (e)=>$1f99184c55023168$var$touchend(e, wrapper),
        touchmove: (e)=>$1f99184c55023168$var$touchmove(e, wrapper)
    };
}
function $1f99184c55023168$var$mounted(el, binding) {
    const value = binding.value;
    const target = value?.parent ? el.parentElement : el;
    const options = value?.options ?? {
        passive: true
    };
    const uid = binding.instance?.$.uid; // TODO: use custom uid generator
    if (!target || uid === undefined) return;
    const handlers = $1f99184c55023168$var$createHandlers(binding.value);
    target._touchHandlers = target._touchHandlers ?? Object.create(null);
    target._touchHandlers[uid] = handlers;
    (0, $8590040a7833369a$export$ed97f33186d4b816)(handlers).forEach((eventName)=>{
        target.addEventListener(eventName, handlers[eventName], options);
    });
}
function $1f99184c55023168$var$unmounted(el, binding) {
    const target = binding.value?.parent ? el.parentElement : el;
    const uid = binding.instance?.$.uid;
    if (!target?._touchHandlers || uid === undefined) return;
    const handlers = target._touchHandlers[uid];
    (0, $8590040a7833369a$export$ed97f33186d4b816)(handlers).forEach((eventName)=>{
        target.removeEventListener(eventName, handlers[eventName]);
    });
    delete target._touchHandlers[uid];
}
const $1f99184c55023168$export$746b04bbf92762fd = {
    mounted: $1f99184c55023168$var$mounted,
    unmounted: $1f99184c55023168$var$unmounted
};
var $1f99184c55023168$export$2e2bcd8739ae039 = $1f99184c55023168$export$746b04bbf92762fd;




const $27128a8be1af1448$export$148085e3462a5c9b = Symbol.for('vuetify:v-window');
const $27128a8be1af1448$export$73a02c283e349d7d = Symbol.for('vuetify:v-window-group');
const $27128a8be1af1448$export$25b8cee22976996f = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    continuous: Boolean,
    nextIcon: {
        type: [
            Boolean,
            String,
            Function,
            Object
        ],
        default: '$next'
    },
    prevIcon: {
        type: [
            Boolean,
            String,
            Function,
            Object
        ],
        default: '$prev'
    },
    reverse: Boolean,
    showArrows: {
        type: [
            Boolean,
            String
        ],
        validator: (v)=>typeof v === 'boolean' || v === 'hover'
    },
    verticalArrows: [
        Boolean,
        String
    ],
    touch: {
        type: [
            Object,
            Boolean
        ],
        default: undefined
    },
    direction: {
        type: String,
        default: 'horizontal'
    },
    modelValue: null,
    disabled: Boolean,
    selectedClass: {
        type: String,
        default: 'v-window-item--active'
    },
    // TODO: mandatory should probably not be exposed but do this for now
    mandatory: {
        type: [
            Boolean,
            String
        ],
        default: 'force'
    },
    crossfade: Boolean,
    transitionDuration: Number,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VWindow');
const $27128a8be1af1448$export$7e91eb8d1b90c043 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VWindow',
    directives: {
        vTouch: $1f99184c55023168$export$2e2bcd8739ae039
    },
    props: $27128a8be1af1448$export$25b8cee22976996f(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { isRtl: isRtl } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const group = (0, $0befa53cf46b542b$export$bfb6a372146ddc96)(props, $27128a8be1af1448$export$73a02c283e349d7d);
        const rootRef = (0, $01W3b.ref)();
        const isRtlReverse = (0, $01W3b.computed)(()=>isRtl.value ? !props.reverse : props.reverse);
        const isReversed = (0, $01W3b.shallowRef)(false);
        const transition = (0, $01W3b.computed)(()=>{
            if (props.crossfade) return 'v-window-crossfade-transition';
            const axis = props.direction === 'vertical' ? 'y' : 'x';
            const reverse = isRtlReverse.value ? !isReversed.value : isReversed.value;
            const direction = reverse ? '-reverse' : '';
            return `v-window-${axis}${direction}-transition`;
        });
        const transitionCount = (0, $01W3b.shallowRef)(0);
        const transitionHeight = (0, $01W3b.ref)(undefined);
        const activeIndex = (0, $01W3b.computed)(()=>{
            return group.items.value.findIndex((item)=>group.selected.value.includes(item.id));
        });
        // Fix for https://github.com/vuetifyjs/vuetify/issues/18447
        (0, $01W3b.watch)(activeIndex, (newVal, oldVal)=>{
            let scrollableParent;
            const savedScrollPosition = {
                left: 0,
                top: 0
            };
            if ((0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && oldVal >= 0) {
                scrollableParent = (0, $fa6a71feb92f218b$export$cfa2225e87938781)(rootRef.value);
                savedScrollPosition.left = scrollableParent?.scrollLeft;
                savedScrollPosition.top = scrollableParent?.scrollTop;
            }
            const itemsLength = group.items.value.length;
            const lastIndex = itemsLength - 1;
            if (itemsLength <= 2) isReversed.value = newVal < oldVal;
            else if (newVal === lastIndex && oldVal === 0) isReversed.value = false;
            else if (newVal === 0 && oldVal === lastIndex) isReversed.value = true;
            else isReversed.value = newVal < oldVal;
            (0, $TusQn.nextTick)(()=>{
                if (!(0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) || !scrollableParent) return;
                const currentScrollY = scrollableParent.scrollTop;
                if (currentScrollY !== savedScrollPosition.top) scrollableParent.scrollTo({
                    ...savedScrollPosition,
                    behavior: 'instant'
                });
                requestAnimationFrame(()=>{
                    if (!scrollableParent) return;
                    const rafScrollY = scrollableParent.scrollTop;
                    if (rafScrollY !== savedScrollPosition.top) scrollableParent.scrollTo({
                        ...savedScrollPosition,
                        behavior: 'instant'
                    });
                });
            });
        }, {
            flush: 'sync'
        }); // Run synchronously before DOM updates
        (0, $TusQn.provide)($27128a8be1af1448$export$148085e3462a5c9b, {
            transition: transition,
            isReversed: isReversed,
            transitionCount: transitionCount,
            transitionHeight: transitionHeight,
            rootRef: rootRef
        });
        const canMoveBack = (0, $01W3b.toRef)(()=>props.continuous || activeIndex.value !== 0);
        const canMoveForward = (0, $01W3b.toRef)(()=>props.continuous || activeIndex.value !== group.items.value.length - 1);
        function prev() {
            canMoveBack.value && group.prev();
        }
        function next() {
            canMoveForward.value && group.next();
        }
        const arrows = (0, $01W3b.computed)(()=>{
            const arrows = [];
            const prevProps = {
                icon: isRtl.value ? props.nextIcon : props.prevIcon,
                class: `v-window__${isRtlReverse.value ? 'right' : 'left'}`,
                onClick: group.prev,
                'aria-label': t('$vuetify.carousel.prev')
            };
            arrows.push(canMoveBack.value ? slots.prev ? slots.prev({
                props: prevProps
            }) : (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), prevProps, null) : (0, $TusQn.createElementVNode)("div", null, null));
            const nextProps = {
                icon: isRtl.value ? props.prevIcon : props.nextIcon,
                class: `v-window__${isRtlReverse.value ? 'left' : 'right'}`,
                onClick: group.next,
                'aria-label': t('$vuetify.carousel.next')
            };
            arrows.push(canMoveForward.value ? slots.next ? slots.next({
                props: nextProps
            }) : (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), nextProps, null) : (0, $TusQn.createElementVNode)("div", null, null));
            return arrows;
        });
        const touchOptions = (0, $01W3b.computed)(()=>{
            if (props.touch === false) return props.touch;
            const options = {
                left: ()=>{
                    isRtlReverse.value ? prev() : next();
                },
                right: ()=>{
                    isRtlReverse.value ? next() : prev();
                },
                start: (_ref2)=>{
                    let { originalEvent: originalEvent } = _ref2;
                    originalEvent.stopPropagation();
                }
            };
            return {
                ...options,
                ...props.touch === true ? {} : props.touch
            };
        });
        function onKeyDown(e) {
            if (props.direction === 'horizontal' && e.key === 'ArrowLeft' || props.direction === 'vertical' && e.key === 'ArrowUp') {
                e.preventDefault();
                prev();
                (0, $TusQn.nextTick)(()=>{
                    canMoveBack.value ? focusArrow(0) : focusArrow(1);
                });
            }
            if (props.direction === 'horizontal' && e.key === 'ArrowRight' || props.direction === 'vertical' && e.key === 'ArrowDown') {
                e.preventDefault();
                next();
                (0, $TusQn.nextTick)(()=>{
                    canMoveForward.value ? focusArrow(1) : focusArrow(0);
                });
            }
        }
        function focusArrow(index) {
            const arrow = arrows.value[index];
            if (!arrow) return;
            const arrowEl = Array.isArray(arrow) ? arrow[0] : arrow;
            arrowEl.el?.focus();
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.withDirectives)((0, $TusQn.createVNode)(props.tag, {
                "ref": rootRef,
                "class": (0, $8POXm.normalizeClass)([
                    'v-window',
                    {
                        'v-window--show-arrows-on-hover': props.showArrows === 'hover',
                        'v-window--vertical-arrows': !!props.verticalArrows,
                        'v-window--crossfade': !!props.crossfade
                    },
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    props.style,
                    {
                        '--v-window-transition-duration': !(0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)() ? (0, $8590040a7833369a$export$286ad215293a0860)(props.transitionDuration, 'ms') : null
                    }
                ])
            }, {
                default: ()=>[
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-window__container",
                            "style": {
                                height: transitionHeight.value
                            }
                        }, [
                            slots.default?.({
                                group: group
                            }),
                            props.showArrows !== false && (0, $TusQn.createElementVNode)("div", {
                                "class": (0, $8POXm.normalizeClass)([
                                    'v-window__controls',
                                    {
                                        'v-window__controls--left': props.verticalArrows === 'left' || props.verticalArrows === true
                                    },
                                    {
                                        'v-window__controls--right': props.verticalArrows === 'right'
                                    }
                                ]),
                                "onKeydown": onKeyDown
                            }, [
                                arrows.value
                            ])
                        ]),
                        slots.additional?.({
                            group: group
                        })
                    ]
            }), [
                [
                    (0, $1f99184c55023168$export$2e2bcd8739ae039),
                    touchOptions.value
                ]
            ]));
        return {
            group: group
        };
    }
});






const $a580b92d752e9f42$export$6dfae5d31ad6b376 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    cycle: Boolean,
    delimiterIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$delimiter'
    },
    height: {
        type: [
            Number,
            String
        ],
        default: 500
    },
    hideDelimiters: Boolean,
    hideDelimiterBackground: Boolean,
    interval: {
        type: [
            Number,
            String
        ],
        default: 6000,
        validator: (value)=>Number(value) > 0
    },
    progress: [
        Boolean,
        String
    ],
    verticalDelimiters: [
        Boolean,
        String
    ],
    ...(0, $27128a8be1af1448$export$25b8cee22976996f)({
        continuous: true,
        mandatory: 'force',
        showArrows: true
    })
}, 'VCarousel');
const $a580b92d752e9f42$export$2ec2bd507cbf58ac = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCarousel',
    props: $a580b92d752e9f42$export$6dfae5d31ad6b376(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const windowRef = (0, $01W3b.ref)();
        let slideTimeout = -1;
        (0, $01W3b.watch)(model, restartTimeout);
        (0, $01W3b.watch)(()=>props.interval, restartTimeout);
        (0, $01W3b.watch)(()=>props.cycle, (val)=>{
            if (val) restartTimeout();
            else window.clearTimeout(slideTimeout);
        });
        (0, $TusQn.onMounted)(startTimeout);
        function startTimeout() {
            if (!props.cycle || !windowRef.value) return;
            slideTimeout = window.setTimeout(windowRef.value.group.next, Number(props.interval) > 0 ? Number(props.interval) : 6000);
        }
        function restartTimeout() {
            window.clearTimeout(slideTimeout);
            window.requestAnimationFrame(startTimeout);
        }
        function onDelimiterKeyDown(e, group) {
            if (props.direction === 'horizontal' && e.key === 'ArrowLeft' || props.direction === 'vertical' && e.key === 'ArrowUp') {
                e.preventDefault();
                group.prev();
                (0, $TusQn.nextTick)(()=>windowRef.value?.$el.querySelector('.v-btn--active')?.focus());
            }
            if (props.direction === 'horizontal' && e.key === 'ArrowRight' || props.direction === 'vertical' && e.key === 'ArrowDown') {
                e.preventDefault();
                group.next();
                (0, $TusQn.nextTick)(()=>windowRef.value?.$el.querySelector('.v-btn--active')?.focus());
            }
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const windowProps = (0, $27128a8be1af1448$export$7e91eb8d1b90c043).filterProps(props);
            return (0, $TusQn.createVNode)((0, $27128a8be1af1448$export$7e91eb8d1b90c043), (0, $TusQn.mergeProps)({
                "ref": windowRef
            }, windowProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-carousel',
                    {
                        'v-carousel--hide-delimiter-background': props.hideDelimiterBackground,
                        'v-carousel--vertical-delimiters': props.verticalDelimiters
                    },
                    props.class
                ],
                "style": [
                    {
                        height: (0, $8590040a7833369a$export$286ad215293a0860)(props.height)
                    },
                    props.style
                ]
            }), {
                default: slots.default,
                additional: (_ref2)=>{
                    let { group: group } = _ref2;
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        !props.hideDelimiters && (0, $TusQn.createElementVNode)("div", {
                            "class": "v-carousel__controls",
                            "style": {
                                left: props.verticalDelimiters === 'left' && props.verticalDelimiters ? 0 : 'auto',
                                right: props.verticalDelimiters === 'right' ? 0 : 'auto'
                            }
                        }, [
                            group.items.value.length > 0 && (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "defaults": {
                                    VBtn: {
                                        color: props.color,
                                        icon: props.delimiterIcon,
                                        size: 'x-small',
                                        variant: 'text'
                                    }
                                },
                                "scoped": true
                            }, {
                                default: ()=>[
                                        group.items.value.map((item, index)=>{
                                            const props = {
                                                id: `carousel-item-${item.id}`,
                                                'aria-label': t('$vuetify.carousel.ariaLabel.delimiter', index + 1, group.items.value.length),
                                                class: [
                                                    'v-carousel__controls__item',
                                                    group.isSelected(item.id) && 'v-btn--active'
                                                ],
                                                onClick: ()=>group.select(item.id, true),
                                                onKeydown: (e)=>onDelimiterKeyDown(e, group)
                                            };
                                            return slots.item ? slots.item({
                                                props: props,
                                                item: item
                                            }) : (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)(item, props), null);
                                        })
                                    ]
                            })
                        ]),
                        props.progress && (0, $TusQn.createVNode)((0, $b256c0debf2f88ca$export$86b13ad59f1a1627), {
                            "absolute": true,
                            "class": "v-carousel__progress",
                            "color": typeof props.progress === 'string' ? props.progress : undefined,
                            "modelValue": (group.getItemIndex(model.value) + 1) / group.items.value.length * 100
                        }, null)
                    ]);
                },
                prev: slots.prev,
                next: slots.next
            });
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");








const $2441fb35357f80c2$export$7fb6acff7c00736c = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    reverseTransition: {
        type: [
            Boolean,
            String
        ],
        default: undefined
    },
    transition: {
        type: [
            Boolean,
            String
        ],
        default: undefined
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $0befa53cf46b542b$export$e9e3b570044587e8)(),
    ...(0, $1ee69ec23e68548b$export$3557c26df64490a4)()
}, 'VWindowItem');
const $2441fb35357f80c2$export$5dd5457a16e4a360 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VWindowItem',
    directives: {
        vTouch: $1f99184c55023168$export$2e2bcd8739ae039
    },
    props: $2441fb35357f80c2$export$7fb6acff7c00736c(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const window = (0, $TusQn.inject)((0, $27128a8be1af1448$export$148085e3462a5c9b));
        const groupItem = (0, $0befa53cf46b542b$export$eebde8160f061c26)(props, (0, $27128a8be1af1448$export$73a02c283e349d7d));
        const { isBooted: isBooted } = (0, $0f95b8d0184d7fa9$export$f385cca8ac2b2f35)();
        if (!window || !groupItem) throw new Error('[Vuetify] VWindowItem must be used inside VWindow');
        const isTransitioning = (0, $01W3b.shallowRef)(false);
        const hasTransition = (0, $01W3b.computed)(()=>isBooted.value && (window.isReversed.value ? props.reverseTransition !== false : props.transition !== false));
        function onAfterTransition() {
            if (!isTransitioning.value || !window) return;
            // Finalize transition state.
            isTransitioning.value = false;
            if (window.transitionCount.value > 0) {
                window.transitionCount.value -= 1;
                // Remove container height if we are out of transition.
                if (window.transitionCount.value === 0) window.transitionHeight.value = undefined;
            }
        }
        function onBeforeTransition() {
            if (isTransitioning.value || !window) return;
            // Initialize transition state here.
            isTransitioning.value = true;
            if (window.transitionCount.value === 0) // Set initial height for height transition.
            window.transitionHeight.value = (0, $8590040a7833369a$export$286ad215293a0860)(window.rootRef.value?.clientHeight);
            window.transitionCount.value += 1;
        }
        function onTransitionCancelled() {
            onAfterTransition(); // This should have the same path as normal transition end.
        }
        function onEnterTransition(el) {
            if (!isTransitioning.value) return;
            (0, $TusQn.nextTick)(()=>{
                // Do not set height if no transition or cancelled.
                if (!hasTransition.value || !isTransitioning.value || !window) return;
                // Set transition target height.
                window.transitionHeight.value = (0, $8590040a7833369a$export$286ad215293a0860)(el.clientHeight);
            });
        }
        const transition = (0, $01W3b.computed)(()=>{
            const name = window.isReversed.value ? props.reverseTransition : props.transition;
            return !hasTransition.value ? false : {
                name: typeof name !== 'string' ? window.transition.value : name,
                onBeforeEnter: onBeforeTransition,
                onAfterEnter: onAfterTransition,
                onEnterCancelled: onTransitionCancelled,
                onBeforeLeave: onBeforeTransition,
                onAfterLeave: onAfterTransition,
                onLeaveCancelled: onTransitionCancelled,
                onEnter: onEnterTransition
            };
        });
        const { hasContent: hasContent } = (0, $1ee69ec23e68548b$export$965f98646215a1bd)(props, groupItem.isSelected);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                "transition": transition.value,
                "disabled": !isBooted.value
            }, {
                default: ()=>[
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                            "class": (0, $8POXm.normalizeClass)([
                                'v-window-item',
                                groupItem.selectedClass.value,
                                props.class
                            ]),
                            "style": (0, $8POXm.normalizeStyle)(props.style)
                        }, [
                            hasContent.value && slots.default?.()
                        ]), [
                            [
                                (0, $eeJ70.vShow),
                                groupItem.isSelected.value
                            ]
                        ])
                    ]
            }));
        return {
            groupItem: groupItem
        };
    }
});



const $280389f82296200c$export$c5a1ee6865246241 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b2937780237888c4$export$aeeda8cb473ca4b4)(),
    ...(0, $2441fb35357f80c2$export$7fb6acff7c00736c)()
}, 'VCarouselItem');
const $280389f82296200c$export$273c2e14a4f3f313 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCarouselItem',
    inheritAttrs: false,
    props: $280389f82296200c$export$c5a1ee6865246241(),
    setup (props, _ref) {
        let { slots: slots, attrs: attrs } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const imgProps = (0, $b2937780237888c4$export$126ec614c536f27c).filterProps(props);
            const windowItemProps = (0, $2441fb35357f80c2$export$5dd5457a16e4a360).filterProps(props);
            return (0, $TusQn.createVNode)((0, $2441fb35357f80c2$export$5dd5457a16e4a360), (0, $TusQn.mergeProps)({
                "class": [
                    'v-carousel-item',
                    props.class
                ]
            }, windowItemProps), {
                default: ()=>[
                        (0, $TusQn.createVNode)((0, $b2937780237888c4$export$126ec614c536f27c), (0, $TusQn.mergeProps)(attrs, imgProps), slots)
                    ]
            });
        });
    }
});




var $35a09098ab68b0d7$exports = {};

$parcel$export($35a09098ab68b0d7$exports, "VCheckbox", () => $187bcd2d932c7bb2$export$12ceaa6dc3f28416);
$parcel$export($35a09098ab68b0d7$exports, "VCheckboxBtn", () => $c8f17ec9401c8898$export$2c5503cb3c38fdb6);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");







const $187bcd2d932c7bb2$export$641547da5603a1c9 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $97e8c489e405a584$export$525655a73981d616)(), [
        'direction'
    ]),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $c8f17ec9401c8898$export$b10b3450c190da23)(), [
        'inline'
    ])
}, 'VCheckbox');
const $187bcd2d932c7bb2$export$12ceaa6dc3f28416 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCheckbox',
    inheritAttrs: false,
    props: $187bcd2d932c7bb2$export$641547da5603a1c9(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:focused': (focused)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $fdb5f7d63722b03f$export$f8168d8dd8fd66e6)(props);
        const inputRef = (0, $01W3b.ref)();
        const uid = (0, $TusQn.useId)();
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const [rootAttrs, controlAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            const inputProps = (0, $97e8c489e405a584$export$2aca538d9f87f6ac).filterProps(props);
            const checkboxProps = (0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6).filterProps(props);
            return (0, $TusQn.createVNode)((0, $97e8c489e405a584$export$2aca538d9f87f6ac), (0, $TusQn.mergeProps)({
                "ref": inputRef,
                "class": [
                    'v-checkbox',
                    props.class
                ]
            }, rootAttrs, inputProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "id": props.id || `checkbox-${uid}`,
                "focused": isFocused.value,
                "style": props.style
            }), {
                ...slots,
                default: (_ref2)=>{
                    let { id: id, messagesId: messagesId, isDisabled: isDisabled, isReadonly: isReadonly, isValid: isValid } = _ref2;
                    return (0, $TusQn.createVNode)((0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6), (0, $TusQn.mergeProps)(checkboxProps, {
                        "id": id.value,
                        "aria-describedby": messagesId.value,
                        "disabled": isDisabled.value,
                        "readonly": isReadonly.value
                    }, controlAttrs, {
                        "error": isValid.value === false,
                        "modelValue": model.value,
                        "onUpdate:modelValue": ($event)=>model.value = $event,
                        "onFocus": focus,
                        "onBlur": blur
                    }), slots);
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, inputRef);
    }
});





var $2c5f26ff21301e8d$exports = {};

$parcel$export($2c5f26ff21301e8d$exports, "VChip", () => $fd0891698b65ffb1$export$1b5fab12cd17b4fb);



var $d173f64cfcf7eae3$exports = {};

$parcel$export($d173f64cfcf7eae3$exports, "VChipGroup", () => $7cb2aa0b88b3d8d4$export$d38779cb67beb087);



var $a622aa128c6ec569$exports = {};

$parcel$export($a622aa128c6ec569$exports, "VCode", () => $a622aa128c6ec569$export$34e1eb2aa2c1e4b2);
// Styles


const $a622aa128c6ec569$export$34e1eb2aa2c1e4b2 = (0, $5224ab9d69b8c3e0$export$b3680ae2c271b9f3)('v-code', 'code');


var $24d72b8d1fbc2286$exports = {};

$parcel$export($24d72b8d1fbc2286$exports, "VColorPicker", () => $6f27e561a8b73c54$export$9359e1f82effabe6);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");




const $f3b1bcf45613b56e$export$1d1a7b322d185d94 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: {
        type: Object
    },
    disabled: Boolean,
    readonly: Boolean,
    dotSize: {
        type: [
            Number,
            String
        ],
        default: 10
    },
    height: {
        type: [
            Number,
            String
        ],
        default: 150
    },
    width: {
        type: [
            Number,
            String
        ],
        default: 300
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VColorPickerCanvas');
const $f3b1bcf45613b56e$export$5142c1b9e4f0ab2e = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VColorPickerCanvas',
    props: $f3b1bcf45613b56e$export$1d1a7b322d185d94(),
    emits: {
        'update:color': (color)=>true,
        'update:position': (hue)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const isInteracting = (0, $01W3b.shallowRef)(false);
        const canvasRef = (0, $01W3b.ref)();
        const canvasWidth = (0, $01W3b.shallowRef)(parseFloat(props.width));
        const canvasHeight = (0, $01W3b.shallowRef)(parseFloat(props.height));
        const _dotPosition = (0, $01W3b.ref)({
            x: 0,
            y: 0
        });
        const isInteractive = (0, $01W3b.toRef)(()=>!props.disabled && !props.readonly);
        const dotPosition = (0, $01W3b.computed)({
            get: ()=>_dotPosition.value,
            set (val) {
                if (!canvasRef.value) return;
                const { x: x, y: y } = val;
                _dotPosition.value = val;
                emit('update:color', {
                    h: props.color?.h ?? 0,
                    s: (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(x, 0, canvasWidth.value) / canvasWidth.value,
                    v: 1 - (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(y, 0, canvasHeight.value) / canvasHeight.value,
                    a: props.color?.a ?? 1
                });
            }
        });
        const dotStyles = (0, $01W3b.computed)(()=>{
            const { x: x, y: y } = dotPosition.value;
            const radius = parseInt(props.dotSize, 10) / 2;
            return {
                width: (0, $8590040a7833369a$export$286ad215293a0860)(props.dotSize),
                height: (0, $8590040a7833369a$export$286ad215293a0860)(props.dotSize),
                transform: `translate(${(0, $8590040a7833369a$export$286ad215293a0860)(x - radius)}, ${(0, $8590040a7833369a$export$286ad215293a0860)(y - radius)})`
            };
        });
        const { resizeRef: resizeRef } = (0, $d80db15b6452c606$export$683480f191c0e3ea)((entries)=>{
            if (!resizeRef.el?.offsetParent) return;
            const { width: width, height: height } = entries[0].contentRect;
            canvasWidth.value = Math.round(width);
            canvasHeight.value = Math.round(height);
        });
        function updateDotPosition(x, y, rect) {
            const { left: left, top: top, width: width, height: height } = rect;
            dotPosition.value = {
                x: (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(x - left, 0, width),
                y: (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(y - top, 0, height)
            };
        }
        function handleMouseDown(e) {
            if (e.type === 'mousedown') // Prevent text selection while dragging
            e.preventDefault();
            if (!isInteractive.value) return;
            handleMouseMove(e);
            window.addEventListener('mousemove', handleMouseMove);
            window.addEventListener('mouseup', handleMouseUp);
            window.addEventListener('touchmove', handleMouseMove);
            window.addEventListener('touchend', handleMouseUp);
        }
        function handleMouseMove(e) {
            if (!isInteractive.value || !canvasRef.value) return;
            isInteracting.value = true;
            const coords = (0, $8590040a7833369a$export$36195c8aa1517e04)(e);
            updateDotPosition(coords.clientX, coords.clientY, canvasRef.value.getBoundingClientRect());
        }
        function handleMouseUp() {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            window.removeEventListener('touchmove', handleMouseMove);
            window.removeEventListener('touchend', handleMouseUp);
        }
        function updateCanvas() {
            if (!canvasRef.value) return;
            const canvas = canvasRef.value;
            const ctx = canvas.getContext('2d');
            if (!ctx) return;
            const saturationGradient = ctx.createLinearGradient(0, 0, canvas.width, 0);
            saturationGradient.addColorStop(0, 'hsla(0, 0%, 100%, 1)'); // white
            saturationGradient.addColorStop(1, `hsla(${props.color?.h ?? 0}, 100%, 50%, 1)`);
            ctx.fillStyle = saturationGradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            const valueGradient = ctx.createLinearGradient(0, 0, 0, canvas.height);
            valueGradient.addColorStop(0, 'hsla(0, 0%, 0%, 0)'); // transparent
            valueGradient.addColorStop(1, 'hsla(0, 0%, 0%, 1)'); // black
            ctx.fillStyle = valueGradient;
            ctx.fillRect(0, 0, canvas.width, canvas.height);
        }
        (0, $01W3b.watch)(()=>props.color?.h, updateCanvas, {
            immediate: true
        });
        (0, $01W3b.watch)(()=>[
                canvasWidth.value,
                canvasHeight.value
            ], (newVal, oldVal)=>{
            updateCanvas();
            _dotPosition.value = {
                x: dotPosition.value.x * newVal[0] / oldVal[0],
                y: dotPosition.value.y * newVal[1] / oldVal[1]
            };
        }, {
            flush: 'post'
        });
        (0, $01W3b.watch)(()=>props.color, ()=>{
            if (isInteracting.value) {
                isInteracting.value = false;
                return;
            }
            _dotPosition.value = props.color ? {
                x: props.color.s * canvasWidth.value,
                y: (1 - props.color.v) * canvasHeight.value
            } : {
                x: 0,
                y: 0
            };
        }, {
            deep: true,
            immediate: true
        });
        (0, $TusQn.onMounted)(()=>updateCanvas());
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "ref": resizeRef,
                "class": (0, $8POXm.normalizeClass)([
                    'v-color-picker-canvas',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style),
                "onMousedown": handleMouseDown,
                "onTouchstartPassive": handleMouseDown
            }, [
                (0, $TusQn.createElementVNode)("canvas", {
                    "ref": canvasRef,
                    "width": canvasWidth.value,
                    "height": canvasHeight.value
                }, null),
                props.color && (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-color-picker-canvas__dot',
                        {
                            'v-color-picker-canvas__dot--disabled': props.disabled
                        }
                    ]),
                    "style": (0, $8POXm.normalizeStyle)(dotStyles.value)
                }, null)
            ]));
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");




// Utilities


function $9d51d153ec08ddd1$var$stripAlpha(color, stripAlpha) {
    if (stripAlpha) {
        const { a: a, ...rest } = color;
        return rest;
    }
    return color;
}
function $9d51d153ec08ddd1$export$a5d74e2261ad8c75(color, input) {
    if (input == null || typeof input === 'string') {
        const hasA = typeof color.a === 'number' && color.a < 1;
        if (input?.startsWith('rgb(')) {
            const { r: r, g: g, b: b, a: a } = (0, $44de4fc7c15df730$export$61dbc3014460e6c3)(color);
            return `rgb(${r} ${g} ${b}` + (hasA ? ` / ${a})` : ')');
        } else if (input?.startsWith('hsl(')) {
            const { h: h, s: s, l: l, a: a } = (0, $44de4fc7c15df730$export$f24257e859bd61bb)(color);
            return `hsl(${h} ${Math.round(s * 100)} ${Math.round(l * 100)}` + (hasA ? ` / ${a})` : ')');
        }
        const hex = (0, $44de4fc7c15df730$export$883c749ec82cf1f2)(color);
        if (color.a === 1) return hex.slice(0, 7);
        else return hex;
    }
    if (typeof input === 'object') {
        let converted;
        if ((0, $8590040a7833369a$export$a4f4bb6b1453fff5)(input, [
            'r',
            'g',
            'b'
        ])) converted = (0, $44de4fc7c15df730$export$61dbc3014460e6c3)(color);
        else if ((0, $8590040a7833369a$export$a4f4bb6b1453fff5)(input, [
            'h',
            's',
            'l'
        ])) converted = (0, $44de4fc7c15df730$export$f24257e859bd61bb)(color);
        else if ((0, $8590040a7833369a$export$a4f4bb6b1453fff5)(input, [
            'h',
            's',
            'v'
        ])) converted = color;
        return $9d51d153ec08ddd1$var$stripAlpha(converted, !(0, $8590040a7833369a$export$a4f4bb6b1453fff5)(input, [
            'a'
        ]) && color.a === 1);
    }
    return color;
}
function $9d51d153ec08ddd1$export$7c6623716c246f1(color) {
    if (!color) return false;
    if (typeof color === 'string') return color.length > 7;
    if (typeof color === 'object') return (0, $8590040a7833369a$export$a4f4bb6b1453fff5)(color, [
        'a'
    ]) || (0, $8590040a7833369a$export$a4f4bb6b1453fff5)(color, [
        'alpha'
    ]);
    return false;
}
const $9d51d153ec08ddd1$export$8b018767dd6f3cea = {
    h: 0,
    s: 0,
    v: 0,
    a: 1
};
const $9d51d153ec08ddd1$var$rgba = {
    inputProps: {
        type: 'number',
        min: 0
    },
    inputs: [
        {
            label: 'R',
            max: 255,
            step: 1,
            getValue: (c)=>Math.round(c.r),
            getColor: (c, v)=>({
                    ...c,
                    r: Number(v)
                }),
            localeKey: 'redInput'
        },
        {
            label: 'G',
            max: 255,
            step: 1,
            getValue: (c)=>Math.round(c.g),
            getColor: (c, v)=>({
                    ...c,
                    g: Number(v)
                }),
            localeKey: 'greenInput'
        },
        {
            label: 'B',
            max: 255,
            step: 1,
            getValue: (c)=>Math.round(c.b),
            getColor: (c, v)=>({
                    ...c,
                    b: Number(v)
                }),
            localeKey: 'blueInput'
        },
        {
            label: 'A',
            max: 1,
            step: 0.01,
            getValue: (_ref)=>{
                let { a: a } = _ref;
                return a != null ? Math.round(a * 100) / 100 : 1;
            },
            getColor: (c, v)=>({
                    ...c,
                    a: Number(v)
                }),
            localeKey: 'alphaInput'
        }
    ],
    to: (0, $44de4fc7c15df730$export$61dbc3014460e6c3),
    from: (0, $44de4fc7c15df730$export$62bb88c9baab039f)
};
const $9d51d153ec08ddd1$var$rgb = {
    ...$9d51d153ec08ddd1$var$rgba,
    inputs: $9d51d153ec08ddd1$var$rgba.inputs?.slice(0, 3)
};
const $9d51d153ec08ddd1$var$hsla = {
    inputProps: {
        type: 'number',
        min: 0
    },
    inputs: [
        {
            label: 'H',
            max: 360,
            step: 1,
            getValue: (c)=>Math.round(c.h),
            getColor: (c, v)=>({
                    ...c,
                    h: Number(v)
                }),
            localeKey: 'hueInput'
        },
        {
            label: 'S',
            max: 1,
            step: 0.01,
            getValue: (c)=>Math.round(c.s * 100) / 100,
            getColor: (c, v)=>({
                    ...c,
                    s: Number(v)
                }),
            localeKey: 'saturationInput'
        },
        {
            label: 'L',
            max: 1,
            step: 0.01,
            getValue: (c)=>Math.round(c.l * 100) / 100,
            getColor: (c, v)=>({
                    ...c,
                    l: Number(v)
                }),
            localeKey: 'lightnessInput'
        },
        {
            label: 'A',
            max: 1,
            step: 0.01,
            getValue: (_ref2)=>{
                let { a: a } = _ref2;
                return a != null ? Math.round(a * 100) / 100 : 1;
            },
            getColor: (c, v)=>({
                    ...c,
                    a: Number(v)
                }),
            localeKey: 'alphaInput'
        }
    ],
    to: (0, $44de4fc7c15df730$export$f24257e859bd61bb),
    from: (0, $44de4fc7c15df730$export$8917074272868d95)
};
const $9d51d153ec08ddd1$var$hsl = {
    ...$9d51d153ec08ddd1$var$hsla,
    inputs: $9d51d153ec08ddd1$var$hsla.inputs.slice(0, 3)
};
const $9d51d153ec08ddd1$var$hexa = {
    inputProps: {
        type: 'text'
    },
    inputs: [
        {
            label: 'HEXA',
            getValue: (c)=>c,
            getColor: (c, v)=>v,
            localeKey: 'hexaInput'
        }
    ],
    to: (0, $44de4fc7c15df730$export$883c749ec82cf1f2),
    from: (0, $44de4fc7c15df730$export$4e9396b641d87477)
};
const $9d51d153ec08ddd1$var$hex = {
    ...$9d51d153ec08ddd1$var$hexa,
    inputs: [
        {
            label: 'HEX',
            getValue: (c)=>c.slice(0, 7),
            getColor: (c, v)=>v,
            localeKey: 'hexInput'
        }
    ]
};
const $9d51d153ec08ddd1$export$4a6bdc0a840be00 = {
    rgb: $9d51d153ec08ddd1$var$rgb,
    rgba: $9d51d153ec08ddd1$var$rgba,
    hsl: $9d51d153ec08ddd1$var$hsl,
    hsla: $9d51d153ec08ddd1$var$hsla,
    hex: $9d51d153ec08ddd1$var$hex,
    hexa: $9d51d153ec08ddd1$var$hexa
};



const $f9ab1bbd66c306f9$var$VColorPickerInput = (_ref)=>{
    let { label: label, ...rest } = _ref;
    return (0, $TusQn.createElementVNode)("div", {
        "class": "v-color-picker-edit__input"
    }, [
        (0, $TusQn.createElementVNode)("input", (0, $8POXm.normalizeProps)((0, $TusQn.guardReactiveProps)(rest)), null),
        (0, $TusQn.createElementVNode)("span", null, [
            label
        ])
    ]);
};
const $f9ab1bbd66c306f9$export$eb4aa077dbc110bc = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: Object,
    disabled: Boolean,
    readonly: Boolean,
    mode: {
        type: String,
        default: 'rgba',
        validator: (v)=>Object.keys((0, $9d51d153ec08ddd1$export$4a6bdc0a840be00)).includes(v)
    },
    modes: {
        type: Array,
        default: ()=>Object.keys((0, $9d51d153ec08ddd1$export$4a6bdc0a840be00)),
        validator: (v)=>Array.isArray(v) && v.every((m)=>Object.keys((0, $9d51d153ec08ddd1$export$4a6bdc0a840be00)).includes(m))
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VColorPickerEdit');
const $f9ab1bbd66c306f9$export$85684b51105c3c4c = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VColorPickerEdit',
    props: $f9ab1bbd66c306f9$export$eb4aa077dbc110bc(),
    emits: {
        'update:color': (color)=>true,
        'update:mode': (mode)=>true
    },
    setup (props, _ref2) {
        let { emit: emit } = _ref2;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const enabledModes = (0, $01W3b.computed)(()=>{
            return props.modes.map((key)=>({
                    ...(0, $9d51d153ec08ddd1$export$4a6bdc0a840be00)[key],
                    name: key
                }));
        });
        const inputs = (0, $01W3b.computed)(()=>{
            const mode = enabledModes.value.find((m)=>m.name === props.mode);
            if (!mode) return [];
            const color = props.color ? mode.to(props.color) : null;
            return mode.inputs?.map((_ref3)=>{
                let { getValue: getValue, getColor: getColor, localeKey: localeKey, ...inputProps } = _ref3;
                return {
                    ...mode.inputProps,
                    ...inputProps,
                    ariaLabel: t(`$vuetify.colorPicker.ariaLabel.${localeKey}`),
                    disabled: props.disabled,
                    readonly: props.readonly,
                    value: color && getValue(color),
                    onChange: (e)=>{
                        const target = e.target;
                        if (!target) return;
                        emit('update:color', mode.from(getColor(color ?? mode.to((0, $9d51d153ec08ddd1$export$8b018767dd6f3cea)), target.value)));
                    }
                };
            });
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-color-picker-edit',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, [
                inputs.value?.map((props)=>(0, $TusQn.createVNode)($f9ab1bbd66c306f9$var$VColorPickerInput, props, null)),
                enabledModes.value.length > 1 && (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                    "icon": "$unfold",
                    "size": "x-small",
                    "variant": "plain",
                    "aria-label": t('$vuetify.colorPicker.ariaLabel.changeFormat'),
                    "onClick": ()=>{
                        const mi = enabledModes.value.findIndex((m)=>m.name === props.mode);
                        emit('update:mode', enabledModes.value[(mi + 1) % enabledModes.value.length].name);
                    }
                }, null)
            ]));
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");

/* eslint-disable max-statements */ // Composables




parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $6095f26041a1265e$export$79c7763ce3e7900b = Symbol.for('vuetify:v-slider');
function $6095f26041a1265e$export$622cea445a1c5b7d(e, el, direction) {
    const vertical = direction === 'vertical';
    const rect = el.getBoundingClientRect();
    const touch = 'touches' in e ? e.touches[0] : e;
    return vertical ? touch.clientY - (rect.top + rect.height / 2) : touch.clientX - (rect.left + rect.width / 2);
}
function $6095f26041a1265e$var$getPosition(e, position) {
    if ('touches' in e && e.touches.length) return e.touches[0][position];
    else if ('changedTouches' in e && e.changedTouches.length) return e.changedTouches[0][position];
    else return e[position];
}
const $6095f26041a1265e$export$f4533040d074ed75 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    disabled: {
        type: Boolean,
        default: null
    },
    error: Boolean,
    readonly: {
        type: Boolean,
        default: null
    },
    max: {
        type: [
            Number,
            String
        ],
        default: 100
    },
    min: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    step: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    thumbColor: String,
    thumbLabel: {
        type: [
            Boolean,
            String
        ],
        default: undefined,
        validator: (v)=>typeof v === 'boolean' || v === 'always' || v === 'hover'
    },
    thumbSize: {
        type: [
            Number,
            String
        ],
        default: 20
    },
    showTicks: {
        type: [
            Boolean,
            String
        ],
        default: false,
        validator: (v)=>typeof v === 'boolean' || v === 'always'
    },
    ticks: {
        type: [
            Array,
            Object
        ]
    },
    tickSize: {
        type: [
            Number,
            String
        ],
        default: 2
    },
    color: String,
    trackColor: String,
    trackFillColor: String,
    trackSize: {
        type: [
            Number,
            String
        ],
        default: 4
    },
    direction: {
        type: String,
        default: 'horizontal',
        validator: (v)=>[
                'vertical',
                'horizontal'
            ].includes(v)
    },
    reverse: Boolean,
    noKeyboard: Boolean,
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)({
        elevation: 2
    }),
    ripple: {
        type: Boolean,
        default: true
    }
}, 'Slider');
const $6095f26041a1265e$export$302911c449e17ea4 = (props)=>{
    const min = (0, $01W3b.computed)(()=>parseFloat(props.min));
    const max = (0, $01W3b.computed)(()=>parseFloat(props.max));
    const step = (0, $01W3b.computed)(()=>Number(props.step) > 0 ? parseFloat(props.step) : 0);
    const decimals = (0, $01W3b.computed)(()=>Math.max((0, $8590040a7833369a$export$1ecb455da4aa739b)(step.value), (0, $8590040a7833369a$export$1ecb455da4aa739b)(min.value)));
    function roundValue(value) {
        value = parseFloat(value);
        if (step.value <= 0) return value;
        const clamped = (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(value, min.value, max.value);
        const offset = min.value % step.value;
        let newValue = Math.round((clamped - offset) / step.value) * step.value + offset;
        if (clamped > newValue && newValue + step.value > max.value) newValue = max.value;
        return parseFloat(Math.min(newValue, max.value).toFixed(decimals.value));
    }
    return {
        min: min,
        max: max,
        step: step,
        decimals: decimals,
        roundValue: roundValue
    };
};
const $6095f26041a1265e$export$56b2c08e277f365 = (_ref)=>{
    let { props: props, steps: steps, onSliderStart: onSliderStart, onSliderMove: onSliderMove, onSliderEnd: onSliderEnd, getActiveThumb: getActiveThumb } = _ref;
    const form = (0, $72bfe1fa0cde9e24$export$87c0cf8eb5a167e0)(props);
    const { isRtl: isRtl } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
    const isReversed = (0, $01W3b.toRef)(()=>props.reverse);
    const vertical = (0, $01W3b.computed)(()=>props.direction === 'vertical');
    const indexFromEnd = (0, $01W3b.computed)(()=>vertical.value !== isReversed.value);
    const { min: min, max: max, step: step, decimals: decimals, roundValue: roundValue } = steps;
    const thumbSize = (0, $01W3b.computed)(()=>parseInt(props.thumbSize, 10));
    const tickSize = (0, $01W3b.computed)(()=>parseInt(props.tickSize, 10));
    const trackSize = (0, $01W3b.computed)(()=>parseInt(props.trackSize, 10));
    const numTicks = (0, $01W3b.computed)(()=>(max.value - min.value) / step.value);
    const thumbColor = (0, $01W3b.computed)(()=>props.error || form.isDisabled.value ? undefined : props.thumbColor ?? props.color);
    const thumbLabelColor = (0, $01W3b.computed)(()=>props.error || form.isDisabled.value ? undefined : props.thumbColor);
    const trackColor = (0, $01W3b.computed)(()=>props.error || form.isDisabled.value ? undefined : props.trackColor ?? props.color);
    const trackFillColor = (0, $01W3b.computed)(()=>props.error || form.isDisabled.value ? undefined : props.trackFillColor ?? props.color);
    const mousePressed = (0, $01W3b.shallowRef)(false);
    const startOffset = (0, $01W3b.shallowRef)(0);
    const trackContainerRef = (0, $01W3b.ref)();
    const activeThumbRef = (0, $01W3b.ref)();
    function parseMouseMove(e) {
        const el = trackContainerRef.value?.$el;
        if (!el) return;
        const vertical = props.direction === 'vertical';
        const start = vertical ? 'top' : 'left';
        const length = vertical ? 'height' : 'width';
        const position = vertical ? 'clientY' : 'clientX';
        const { [start]: trackStart, [length]: trackLength } = el.getBoundingClientRect();
        const clickOffset = $6095f26041a1265e$var$getPosition(e, position);
        // It is possible for left to be NaN, force to number
        let clickPos = (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)((clickOffset - trackStart - startOffset.value) / trackLength) || 0;
        if (vertical ? indexFromEnd.value : indexFromEnd.value !== isRtl.value) clickPos = 1 - clickPos;
        return roundValue(min.value + clickPos * (max.value - min.value));
    }
    const handleStop = (e)=>{
        const value = parseMouseMove(e);
        if (value != null) onSliderEnd({
            value: value
        });
        mousePressed.value = false;
        startOffset.value = 0;
    };
    const handleStart = (e)=>{
        const value = parseMouseMove(e);
        activeThumbRef.value = getActiveThumb(e);
        if (!activeThumbRef.value) return;
        mousePressed.value = true;
        if (activeThumbRef.value.contains(e.target)) startOffset.value = $6095f26041a1265e$export$622cea445a1c5b7d(e, activeThumbRef.value, props.direction);
        else {
            startOffset.value = 0;
            if (value != null) onSliderMove({
                value: value
            });
        }
        if (value != null) onSliderStart({
            value: value
        });
        (0, $TusQn.nextTick)(()=>activeThumbRef.value?.focus());
    };
    const moveListenerOptions = {
        passive: true,
        capture: true
    };
    function onMouseMove(e) {
        const value = parseMouseMove(e);
        if (value != null) onSliderMove({
            value: value
        });
    }
    function onSliderMouseUp(e) {
        e.stopPropagation();
        e.preventDefault();
        handleStop(e);
        window.removeEventListener('mousemove', onMouseMove, moveListenerOptions);
        window.removeEventListener('mouseup', onSliderMouseUp);
    }
    function onSliderTouchend(e) {
        handleStop(e);
        window.removeEventListener('touchmove', onMouseMove, moveListenerOptions);
        e.target?.removeEventListener('touchend', onSliderTouchend);
    }
    function onSliderTouchstart(e) {
        handleStart(e);
        window.addEventListener('touchmove', onMouseMove, moveListenerOptions);
        e.target?.addEventListener('touchend', onSliderTouchend, {
            passive: false
        });
    }
    function onSliderMousedown(e) {
        if (e.button !== 0) return;
        e.preventDefault();
        handleStart(e);
        window.addEventListener('mousemove', onMouseMove, moveListenerOptions);
        window.addEventListener('mouseup', onSliderMouseUp, {
            passive: false
        });
    }
    (0, $01W3b.onScopeDispose)(()=>{
        window.removeEventListener('touchmove', onMouseMove);
        window.removeEventListener('mousemove', onMouseMove);
        window.removeEventListener('mouseup', onSliderMouseUp);
    });
    const position = (val)=>{
        const percentage = (val - min.value) / (max.value - min.value) * 100;
        return (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(isNaN(percentage) ? 0 : percentage, 0, 100);
    };
    const showTicks = (0, $01W3b.toRef)(()=>props.showTicks);
    const parsedTicks = (0, $01W3b.computed)(()=>{
        if (!showTicks.value) return [];
        if (!props.ticks) return numTicks.value !== Infinity ? (0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(numTicks.value + 1).map((t)=>{
            const value = min.value + t * step.value;
            return {
                value: value,
                position: position(value)
            };
        }) : [];
        if (Array.isArray(props.ticks)) return props.ticks.map((t)=>({
                value: t,
                position: position(t),
                label: t.toString()
            }));
        return Object.keys(props.ticks).map((key)=>({
                value: parseFloat(key),
                position: position(parseFloat(key)),
                label: props.ticks[key]
            }));
    });
    const hasLabels = (0, $01W3b.computed)(()=>parsedTicks.value.some((_ref2)=>{
            let { label: label } = _ref2;
            return !!label;
        }));
    const data = {
        activeThumbRef: activeThumbRef,
        color: (0, $01W3b.toRef)(()=>props.color),
        decimals: decimals,
        disabled: form.isDisabled,
        direction: (0, $01W3b.toRef)(()=>props.direction),
        elevation: (0, $01W3b.toRef)(()=>props.elevation),
        hasLabels: hasLabels,
        isReversed: isReversed,
        indexFromEnd: indexFromEnd,
        min: min,
        max: max,
        mousePressed: mousePressed,
        noKeyboard: (0, $01W3b.toRef)(()=>props.noKeyboard),
        numTicks: numTicks,
        onSliderMousedown: onSliderMousedown,
        onSliderTouchstart: onSliderTouchstart,
        parsedTicks: parsedTicks,
        parseMouseMove: parseMouseMove,
        position: position,
        readonly: form.isReadonly,
        rounded: (0, $01W3b.toRef)(()=>props.rounded),
        roundValue: roundValue,
        showTicks: showTicks,
        startOffset: startOffset,
        step: step,
        thumbSize: thumbSize,
        thumbColor: thumbColor,
        thumbLabelColor: thumbLabelColor,
        thumbLabel: (0, $01W3b.toRef)(()=>props.thumbLabel),
        ticks: (0, $01W3b.toRef)(()=>props.ticks),
        tickSize: tickSize,
        trackColor: trackColor,
        trackContainerRef: trackContainerRef,
        trackFillColor: trackFillColor,
        trackSize: trackSize,
        vertical: vertical
    };
    (0, $TusQn.provide)($6095f26041a1265e$export$79c7763ce3e7900b, data);
    return data;
};









const $fd8eb3afc9358766$export$cc943e61932e6a97 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    focused: Boolean,
    max: {
        type: Number,
        required: true
    },
    min: {
        type: Number,
        required: true
    },
    modelValue: {
        type: Number,
        required: true
    },
    position: {
        type: Number,
        required: true
    },
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    name: String,
    noKeyboard: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VSliderThumb');
const $fd8eb3afc9358766$export$64ccdeab5f3618a7 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSliderThumb',
    directives: {
        vRipple: $907916373bf62ceb$export$2e2bcd8739ae039
    },
    props: $fd8eb3afc9358766$export$cc943e61932e6a97(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const slider = (0, $TusQn.inject)((0, $6095f26041a1265e$export$79c7763ce3e7900b));
        const { isRtl: isRtl, rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        if (!slider) throw new Error('[Vuetify] v-slider-thumb must be used inside v-slider or v-range-slider');
        const { min: min, max: max, thumbColor: thumbColor, thumbLabelColor: thumbLabelColor, step: step, disabled: disabled, thumbSize: thumbSize, thumbLabel: thumbLabel, direction: direction, isReversed: isReversed, vertical: vertical, readonly: readonly, elevation: elevation, mousePressed: mousePressed, decimals: decimals, indexFromEnd: indexFromEnd } = slider;
        const isHovered = (0, $01W3b.shallowRef)(false);
        const isHidden = (0, $01W3b.shallowRef)(false);
        const elevationProps = (0, $01W3b.computed)(()=>!disabled.value ? elevation.value : undefined);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(elevationProps);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(thumbColor);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(thumbLabelColor);
        const { pageup: pageup, pagedown: pagedown, end: end, home: home, left: left, right: right, down: down, up: up } = (0, $8590040a7833369a$export$4f79075d7446a261);
        const relevantKeys = [
            pageup,
            pagedown,
            end,
            home,
            left,
            right,
            down,
            up
        ];
        const multipliers = (0, $01W3b.computed)(()=>{
            if (step.value) return [
                1,
                2,
                3
            ];
            else return [
                1,
                5,
                10
            ];
        });
        function parseKeydown(e, value) {
            if (props.noKeyboard || disabled.value) return;
            if (!relevantKeys.includes(e.key)) return;
            e.preventDefault();
            const _step = step.value || 0.1;
            const steps = (max.value - min.value) / _step;
            if ([
                left,
                right,
                down,
                up
            ].includes(e.key)) {
                const increase = vertical.value ? [
                    isRtl.value ? left : right,
                    isReversed.value ? down : up
                ] : indexFromEnd.value !== isRtl.value ? [
                    left,
                    up
                ] : [
                    right,
                    up
                ];
                const direction = increase.includes(e.key) ? 1 : -1;
                const multiplier = e.shiftKey ? 2 : e.ctrlKey ? 1 : 0;
                if (direction === -1 && value === max.value && !multiplier && !Number.isInteger(steps)) value = value - steps % 1 * _step;
                else value = value + direction * _step * multipliers.value[multiplier];
            } else if (e.key === home) value = min.value;
            else if (e.key === end) value = max.value;
            else {
                const direction = e.key === pagedown ? 1 : -1;
                value = value - direction * _step * (steps > 100 ? steps / 10 : 10);
            }
            return Math.max(props.min, Math.min(props.max, value));
        }
        function onKeydown(e) {
            const newValue = parseKeydown(e, props.modelValue);
            if (newValue != null) {
                isHidden.value = false;
                emit('update:modelValue', newValue);
            }
        }
        (0, $01W3b.watch)(()=>props.focused, (val)=>{
            if (val) isHidden.value = false;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const positionPercentage = (0, $8590040a7833369a$export$286ad215293a0860)(indexFromEnd.value ? 100 - props.position : props.position, '%');
            const thumbLabelVisible = thumbLabel.value === 'always' || thumbLabel.value === true && props.focused || thumbLabel.value === 'hover' && (isHovered.value || props.focused && !isHidden.value);
            return (0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-slider-thumb',
                    {
                        'v-slider-thumb--focused': props.focused,
                        'v-slider-thumb--pressed': props.focused && mousePressed.value
                    },
                    props.class,
                    rtlClasses.value
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-slider-thumb-position': positionPercentage,
                        '--v-slider-thumb-size': (0, $8590040a7833369a$export$286ad215293a0860)(thumbSize.value)
                    },
                    props.style
                ]),
                "role": "slider",
                "tabindex": disabled.value ? -1 : 0,
                "aria-label": props.name,
                "aria-valuemin": min.value,
                "aria-valuemax": max.value,
                "aria-valuenow": props.modelValue,
                "aria-readonly": !!readonly.value,
                "aria-orientation": direction.value,
                "onKeydown": !readonly.value ? onKeydown : undefined,
                "onMouseenter": ()=>{
                    isHovered.value = true;
                },
                "onMouseleave": ()=>{
                    isHovered.value = false;
                    isHidden.value = true;
                }
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-slider-thumb__surface',
                        textColorClasses.value,
                        elevationClasses.value
                    ]),
                    "style": (0, $8POXm.normalizeStyle)(textColorStyles.value)
                }, null),
                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-slider-thumb__ripple',
                        textColorClasses.value
                    ]),
                    "style": (0, $8POXm.normalizeStyle)(textColorStyles.value)
                }, null), [
                    [
                        (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                        props.ripple,
                        null,
                        {
                            circle: true,
                            center: true
                        }
                    ]
                ]),
                (0, $TusQn.createVNode)((0, $7ec1b0ef33b04126$export$5d9397de61546474), {
                    "origin": "bottom center"
                }, {
                    default: ()=>[
                            (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                                "class": "v-slider-thumb__label-container"
                            }, [
                                (0, $TusQn.createElementVNode)("div", {
                                    "class": (0, $8POXm.normalizeClass)([
                                        'v-slider-thumb__label',
                                        backgroundColorClasses.value
                                    ]),
                                    "style": (0, $8POXm.normalizeStyle)(backgroundColorStyles.value)
                                }, [
                                    (0, $TusQn.createElementVNode)("div", null, [
                                        slots['thumb-label']?.({
                                            modelValue: props.modelValue
                                        }) ?? props.modelValue.toFixed(step.value ? decimals.value : 1)
                                    ]),
                                    (0, $TusQn.createElementVNode)("div", {
                                        "class": "v-slider-thumb__label-wedge"
                                    }, null)
                                ])
                            ]), [
                                [
                                    (0, $eeJ70.vShow),
                                    thumbLabelVisible
                                ]
                            ])
                        ]
                })
            ]);
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");






const $01bae8296be19b22$export$ae787ca82c06929d = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    start: {
        type: Number,
        required: true
    },
    stop: {
        type: Number,
        required: true
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VSliderTrack');
const $01bae8296be19b22$export$bf1154fbd075ef2 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSliderTrack',
    props: $01bae8296be19b22$export$ae787ca82c06929d(),
    emits: {},
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const slider = (0, $TusQn.inject)((0, $6095f26041a1265e$export$79c7763ce3e7900b));
        if (!slider) throw new Error('[Vuetify] v-slider-track must be inside v-slider or v-range-slider');
        const { color: color, parsedTicks: parsedTicks, rounded: rounded, showTicks: showTicks, tickSize: tickSize, trackColor: trackColor, trackFillColor: trackFillColor, trackSize: trackSize, vertical: vertical, min: min, max: max, indexFromEnd: indexFromEnd } = slider;
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(rounded);
        const { backgroundColorClasses: trackFillColorClasses, backgroundColorStyles: trackFillColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(trackFillColor);
        const { backgroundColorClasses: trackColorClasses, backgroundColorStyles: trackColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(trackColor);
        const startDir = (0, $01W3b.computed)(()=>`inset-${vertical.value ? 'block' : 'inline'}-${indexFromEnd.value ? 'end' : 'start'}`);
        const endDir = (0, $01W3b.computed)(()=>vertical.value ? 'height' : 'width');
        const backgroundStyles = (0, $01W3b.computed)(()=>{
            return {
                [startDir.value]: '0%',
                [endDir.value]: '100%'
            };
        });
        const trackFillWidth = (0, $01W3b.computed)(()=>props.stop - props.start);
        const trackFillStyles = (0, $01W3b.computed)(()=>{
            return {
                [startDir.value]: (0, $8590040a7833369a$export$286ad215293a0860)(props.start, '%'),
                [endDir.value]: (0, $8590040a7833369a$export$286ad215293a0860)(trackFillWidth.value, '%')
            };
        });
        const computedTicks = (0, $01W3b.computed)(()=>{
            if (!showTicks.value) return [];
            const ticks = vertical.value ? parsedTicks.value.slice().reverse() : parsedTicks.value;
            return ticks.map((tick, index)=>{
                const directionValue = tick.value !== min.value && tick.value !== max.value ? (0, $8590040a7833369a$export$286ad215293a0860)(tick.position, '%') : undefined;
                return (0, $TusQn.createElementVNode)("div", {
                    "key": tick.value,
                    "class": (0, $8POXm.normalizeClass)([
                        'v-slider-track__tick',
                        {
                            'v-slider-track__tick--filled': tick.position >= props.start && tick.position <= props.stop,
                            'v-slider-track__tick--first': tick.value === min.value,
                            'v-slider-track__tick--last': tick.value === max.value
                        }
                    ]),
                    "style": {
                        [startDir.value]: directionValue
                    }
                }, [
                    (tick.label || slots['tick-label']) && (0, $TusQn.createElementVNode)("div", {
                        "class": "v-slider-track__tick-label"
                    }, [
                        slots['tick-label']?.({
                            tick: tick,
                            index: index
                        }) ?? tick.label
                    ])
                ]);
            });
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return (0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-slider-track',
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-slider-track-size': (0, $8590040a7833369a$export$286ad215293a0860)(trackSize.value),
                        '--v-slider-tick-size': (0, $8590040a7833369a$export$286ad215293a0860)(tickSize.value)
                    },
                    props.style
                ])
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-slider-track__background',
                        trackColorClasses.value,
                        {
                            'v-slider-track__background--opacity': !!color.value || !trackFillColor.value
                        }
                    ]),
                    "style": {
                        ...backgroundStyles.value,
                        ...trackColorStyles.value
                    }
                }, null),
                (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-slider-track__fill',
                        trackFillColorClasses.value
                    ]),
                    "style": {
                        ...trackFillStyles.value,
                        ...trackFillColorStyles.value
                    }
                }, null),
                showTicks.value && (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-slider-track__ticks',
                        {
                            'v-slider-track__ticks--always-show': showTicks.value === 'always'
                        }
                    ])
                }, [
                    computedTicks.value
                ])
            ]);
        });
        return {};
    }
});










const $a0f15d3038334c2f$export$7eb22fe22e0c7b1b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $fdb5f7d63722b03f$export$676d4e684e4b0e1e)(),
    ...(0, $6095f26041a1265e$export$f4533040d074ed75)(),
    ...(0, $97e8c489e405a584$export$525655a73981d616)(),
    modelValue: {
        type: [
            Number,
            String
        ],
        default: 0
    }
}, 'VSlider');
const $a0f15d3038334c2f$export$e0368715924ca04f = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSlider',
    inheritAttrs: false,
    props: $a0f15d3038334c2f$export$7eb22fe22e0c7b1b(),
    emits: {
        'update:focused': (value)=>true,
        'update:modelValue': (v)=>true,
        start: (value)=>true,
        end: (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit, attrs: attrs } = _ref;
        const thumbContainerRef = (0, $01W3b.ref)();
        const inputRef = (0, $01W3b.ref)();
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const steps = (0, $6095f26041a1265e$export$302911c449e17ea4)(props);
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', undefined, (value)=>{
            return steps.roundValue(value == null ? steps.min.value : value);
        });
        const { min: min, max: max, mousePressed: mousePressed, roundValue: roundValue, onSliderMousedown: onSliderMousedown, onSliderTouchstart: onSliderTouchstart, trackContainerRef: trackContainerRef, position: position, hasLabels: hasLabels, disabled: disabled, readonly: readonly, noKeyboard: noKeyboard } = (0, $6095f26041a1265e$export$56b2c08e277f365)({
            props: props,
            steps: steps,
            onSliderStart: ()=>{
                if (!disabled.value && !readonly.value) emit('start', model.value);
            },
            onSliderEnd: (_ref2)=>{
                let { value: value } = _ref2;
                const roundedValue = roundValue(value);
                if (!disabled.value && !readonly.value) model.value = roundedValue;
                emit('end', roundedValue);
            },
            onSliderMove: (_ref3)=>{
                let { value: value } = _ref3;
                if (!disabled.value && !readonly.value) model.value = roundValue(value);
            },
            getActiveThumb: ()=>thumbContainerRef.value?.$el
        });
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $fdb5f7d63722b03f$export$f8168d8dd8fd66e6)(props);
        const trackStop = (0, $01W3b.computed)(()=>position(model.value));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const inputProps = (0, $97e8c489e405a584$export$2aca538d9f87f6ac).filterProps(props);
            const [rootAttrs, inputAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            const hasPrepend = !!(props.label || slots.label || slots.prepend);
            return (0, $TusQn.createVNode)((0, $97e8c489e405a584$export$2aca538d9f87f6ac), (0, $TusQn.mergeProps)({
                "ref": inputRef,
                "class": [
                    'v-slider',
                    {
                        'v-slider--has-labels': !!slots['tick-label'] || hasLabels.value,
                        'v-slider--focused': isFocused.value,
                        'v-slider--pressed': mousePressed.value,
                        'v-slider--disabled': disabled.value
                    },
                    rtlClasses.value,
                    props.class
                ],
                "style": props.style
            }, inputProps, rootAttrs, {
                "focused": isFocused.value
            }), {
                ...slots,
                prepend: hasPrepend ? (slotProps)=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots.label?.(slotProps) ?? (props.label ? (0, $TusQn.createVNode)((0, $e23bfa10b64d3f5e$export$90281af35207eb21), {
                            "id": slotProps.id.value,
                            "class": "v-slider__label",
                            "text": props.label
                        }, null) : undefined),
                        slots.prepend?.(slotProps)
                    ]) : undefined,
                default: (_ref4)=>{
                    let { id: id, messagesId: messagesId } = _ref4;
                    return (0, $TusQn.createElementVNode)("div", {
                        "class": "v-slider__container",
                        "onMousedown": !readonly.value ? onSliderMousedown : undefined,
                        "onTouchstartPassive": !readonly.value ? onSliderTouchstart : undefined
                    }, [
                        (0, $TusQn.createElementVNode)("input", {
                            "id": id.value,
                            "name": props.name || id.value,
                            "disabled": disabled.value,
                            "readonly": readonly.value,
                            "tabindex": "-1",
                            "value": model.value
                        }, null),
                        (0, $TusQn.createVNode)((0, $01bae8296be19b22$export$bf1154fbd075ef2), {
                            "ref": trackContainerRef,
                            "start": 0,
                            "stop": trackStop.value
                        }, {
                            'tick-label': slots['tick-label']
                        }),
                        (0, $TusQn.createVNode)((0, $fd8eb3afc9358766$export$64ccdeab5f3618a7), (0, $TusQn.mergeProps)({
                            "ref": thumbContainerRef,
                            "aria-describedby": messagesId.value,
                            "focused": isFocused.value,
                            "noKeyboard": noKeyboard.value,
                            "min": min.value,
                            "max": max.value,
                            "modelValue": model.value,
                            "onUpdate:modelValue": (v)=>model.value = v,
                            "position": trackStop.value,
                            "elevation": props.elevation,
                            "onFocus": focus,
                            "onBlur": blur,
                            "ripple": props.ripple,
                            "name": props.name
                        }, inputAttrs), {
                            'thumb-label': slots['thumb-label']
                        })
                    ]);
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({
            focus: ()=>thumbContainerRef.value?.$el.focus()
        }, inputRef);
    }
});







const $14fda2a5207b1bb1$export$fb8ae246551c1c5c = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: {
        type: Object
    },
    disabled: Boolean,
    readonly: Boolean,
    hideAlpha: Boolean,
    hideEyeDropper: Boolean,
    eyeDropperIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$eyeDropper'
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VColorPickerPreview');
const $14fda2a5207b1bb1$export$82b96236d6e48b4a = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VColorPickerPreview',
    props: $14fda2a5207b1bb1$export$fb8ae246551c1c5c(),
    emits: {
        'update:color': (color)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const abortController = new AbortController();
        const isInteractive = (0, $01W3b.toRef)(()=>!props.disabled && !props.readonly);
        (0, $TusQn.onUnmounted)(()=>abortController.abort());
        async function openEyeDropper() {
            if (!(0, $90a48ad178b943d3$export$c0654247a3e5665d) || !isInteractive.value) return;
            const eyeDropper = new window.EyeDropper();
            try {
                const result = await eyeDropper.open({
                    signal: abortController.signal
                });
                const colorHexValue = (0, $44de4fc7c15df730$export$62bb88c9baab039f)((0, $44de4fc7c15df730$export$6e865ea70d7724f)(result.sRGBHex));
                emit('update:color', {
                    ...props.color ?? (0, $9d51d153ec08ddd1$export$8b018767dd6f3cea),
                    ...colorHexValue
                });
            } catch (e) {}
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-color-picker-preview',
                    {
                        'v-color-picker-preview--hide-alpha': props.hideAlpha
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, [
                (0, $90a48ad178b943d3$export$c0654247a3e5665d) && !props.hideEyeDropper && (0, $TusQn.createElementVNode)("div", {
                    "class": "v-color-picker-preview__eye-dropper",
                    "key": "eyeDropper"
                }, [
                    (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                        "aria-label": t('$vuetify.colorPicker.ariaLabel.eyedropper'),
                        "density": "comfortable",
                        "disabled": props.disabled,
                        "readonly": props.readonly,
                        "icon": props.eyeDropperIcon,
                        "variant": "plain",
                        "onClick": openEyeDropper
                    }, null)
                ]),
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-color-picker-preview__dot"
                }, [
                    (0, $TusQn.createElementVNode)("div", {
                        "style": {
                            background: (0, $44de4fc7c15df730$export$25aeffa982c279d7)(props.color ?? (0, $9d51d153ec08ddd1$export$8b018767dd6f3cea))
                        }
                    }, null)
                ]),
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-color-picker-preview__sliders"
                }, [
                    (0, $TusQn.createVNode)((0, $a0f15d3038334c2f$export$e0368715924ca04f), {
                        "class": "v-color-picker-preview__track v-color-picker-preview__hue",
                        "aria-label": t('$vuetify.colorPicker.ariaLabel.hueSlider'),
                        "modelValue": props.color?.h,
                        "onUpdate:modelValue": (h)=>emit('update:color', {
                                ...props.color ?? (0, $9d51d153ec08ddd1$export$8b018767dd6f3cea),
                                h: h
                            }),
                        "step": 1,
                        "min": 0,
                        "max": 360,
                        "disabled": props.disabled,
                        "readonly": props.readonly,
                        "thumbSize": 14,
                        "trackSize": 8,
                        "trackFillColor": "white",
                        "hideDetails": true
                    }, null),
                    !props.hideAlpha && (0, $TusQn.createVNode)((0, $a0f15d3038334c2f$export$e0368715924ca04f), {
                        "class": "v-color-picker-preview__track v-color-picker-preview__alpha",
                        "aria-label": t('$vuetify.colorPicker.ariaLabel.alphaSlider'),
                        "modelValue": props.color?.a ?? 1,
                        "onUpdate:modelValue": (a)=>emit('update:color', {
                                ...props.color ?? (0, $9d51d153ec08ddd1$export$8b018767dd6f3cea),
                                a: a
                            }),
                        "step": 0.01,
                        "min": 0,
                        "max": 1,
                        "disabled": props.disabled,
                        "readonly": props.readonly,
                        "thumbSize": 14,
                        "trackSize": 8,
                        "trackFillColor": "white",
                        "hideDetails": true
                    }, null)
                ])
            ]));
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");




const $8c208b2b27ab0e36$export$a90204d1394caf30 = {
    base: '#f44336',
    lighten5: '#ffebee',
    lighten4: '#ffcdd2',
    lighten3: '#ef9a9a',
    lighten2: '#e57373',
    lighten1: '#ef5350',
    darken1: '#e53935',
    darken2: '#d32f2f',
    darken3: '#c62828',
    darken4: '#b71c1c',
    accent1: '#ff8a80',
    accent2: '#ff5252',
    accent3: '#ff1744',
    accent4: '#d50000'
};
const $8c208b2b27ab0e36$export$47853bc718611763 = {
    base: '#e91e63',
    lighten5: '#fce4ec',
    lighten4: '#f8bbd0',
    lighten3: '#f48fb1',
    lighten2: '#f06292',
    lighten1: '#ec407a',
    darken1: '#d81b60',
    darken2: '#c2185b',
    darken3: '#ad1457',
    darken4: '#880e4f',
    accent1: '#ff80ab',
    accent2: '#ff4081',
    accent3: '#f50057',
    accent4: '#c51162'
};
const $8c208b2b27ab0e36$export$e13cce2a2d16a9d4 = {
    base: '#9c27b0',
    lighten5: '#f3e5f5',
    lighten4: '#e1bee7',
    lighten3: '#ce93d8',
    lighten2: '#ba68c8',
    lighten1: '#ab47bc',
    darken1: '#8e24aa',
    darken2: '#7b1fa2',
    darken3: '#6a1b9a',
    darken4: '#4a148c',
    accent1: '#ea80fc',
    accent2: '#e040fb',
    accent3: '#d500f9',
    accent4: '#aa00ff'
};
const $8c208b2b27ab0e36$export$51ef95b19086af57 = {
    base: '#673ab7',
    lighten5: '#ede7f6',
    lighten4: '#d1c4e9',
    lighten3: '#b39ddb',
    lighten2: '#9575cd',
    lighten1: '#7e57c2',
    darken1: '#5e35b1',
    darken2: '#512da8',
    darken3: '#4527a0',
    darken4: '#311b92',
    accent1: '#b388ff',
    accent2: '#7c4dff',
    accent3: '#651fff',
    accent4: '#6200ea'
};
const $8c208b2b27ab0e36$export$3e6ccc7b8562d453 = {
    base: '#3f51b5',
    lighten5: '#e8eaf6',
    lighten4: '#c5cae9',
    lighten3: '#9fa8da',
    lighten2: '#7986cb',
    lighten1: '#5c6bc0',
    darken1: '#3949ab',
    darken2: '#303f9f',
    darken3: '#283593',
    darken4: '#1a237e',
    accent1: '#8c9eff',
    accent2: '#536dfe',
    accent3: '#3d5afe',
    accent4: '#304ffe'
};
const $8c208b2b27ab0e36$export$2aa0182783e7e9de = {
    base: '#2196f3',
    lighten5: '#e3f2fd',
    lighten4: '#bbdefb',
    lighten3: '#90caf9',
    lighten2: '#64b5f6',
    lighten1: '#42a5f5',
    darken1: '#1e88e5',
    darken2: '#1976d2',
    darken3: '#1565c0',
    darken4: '#0d47a1',
    accent1: '#82b1ff',
    accent2: '#448aff',
    accent3: '#2979ff',
    accent4: '#2962ff'
};
const $8c208b2b27ab0e36$export$7b0d29b70b435c21 = {
    base: '#03a9f4',
    lighten5: '#e1f5fe',
    lighten4: '#b3e5fc',
    lighten3: '#81d4fa',
    lighten2: '#4fc3f7',
    lighten1: '#29b6f6',
    darken1: '#039be5',
    darken2: '#0288d1',
    darken3: '#0277bd',
    darken4: '#01579b',
    accent1: '#80d8ff',
    accent2: '#40c4ff',
    accent3: '#00b0ff',
    accent4: '#0091ea'
};
const $8c208b2b27ab0e36$export$7474046f446842ee = {
    base: '#00bcd4',
    lighten5: '#e0f7fa',
    lighten4: '#b2ebf2',
    lighten3: '#80deea',
    lighten2: '#4dd0e1',
    lighten1: '#26c6da',
    darken1: '#00acc1',
    darken2: '#0097a7',
    darken3: '#00838f',
    darken4: '#006064',
    accent1: '#84ffff',
    accent2: '#18ffff',
    accent3: '#00e5ff',
    accent4: '#00b8d4'
};
const $8c208b2b27ab0e36$export$8bf7dff220b82b4a = {
    base: '#009688',
    lighten5: '#e0f2f1',
    lighten4: '#b2dfdb',
    lighten3: '#80cbc4',
    lighten2: '#4db6ac',
    lighten1: '#26a69a',
    darken1: '#00897b',
    darken2: '#00796b',
    darken3: '#00695c',
    darken4: '#004d40',
    accent1: '#a7ffeb',
    accent2: '#64ffda',
    accent3: '#1de9b6',
    accent4: '#00bfa5'
};
const $8c208b2b27ab0e36$export$955a2ebd2fb142ae = {
    base: '#4caf50',
    lighten5: '#e8f5e9',
    lighten4: '#c8e6c9',
    lighten3: '#a5d6a7',
    lighten2: '#81c784',
    lighten1: '#66bb6a',
    darken1: '#43a047',
    darken2: '#388e3c',
    darken3: '#2e7d32',
    darken4: '#1b5e20',
    accent1: '#b9f6ca',
    accent2: '#69f0ae',
    accent3: '#00e676',
    accent4: '#00c853'
};
const $8c208b2b27ab0e36$export$559a8c00376dc936 = {
    base: '#8bc34a',
    lighten5: '#f1f8e9',
    lighten4: '#dcedc8',
    lighten3: '#c5e1a5',
    lighten2: '#aed581',
    lighten1: '#9ccc65',
    darken1: '#7cb342',
    darken2: '#689f38',
    darken3: '#558b2f',
    darken4: '#33691e',
    accent1: '#ccff90',
    accent2: '#b2ff59',
    accent3: '#76ff03',
    accent4: '#64dd17'
};
const $8c208b2b27ab0e36$export$221d31baf2636aad = {
    base: '#cddc39',
    lighten5: '#f9fbe7',
    lighten4: '#f0f4c3',
    lighten3: '#e6ee9c',
    lighten2: '#dce775',
    lighten1: '#d4e157',
    darken1: '#c0ca33',
    darken2: '#afb42b',
    darken3: '#9e9d24',
    darken4: '#827717',
    accent1: '#f4ff81',
    accent2: '#eeff41',
    accent3: '#c6ff00',
    accent4: '#aeea00'
};
const $8c208b2b27ab0e36$export$594c5a8758200c32 = {
    base: '#ffeb3b',
    lighten5: '#fffde7',
    lighten4: '#fff9c4',
    lighten3: '#fff59d',
    lighten2: '#fff176',
    lighten1: '#ffee58',
    darken1: '#fdd835',
    darken2: '#fbc02d',
    darken3: '#f9a825',
    darken4: '#f57f17',
    accent1: '#ffff8d',
    accent2: '#ffff00',
    accent3: '#ffea00',
    accent4: '#ffd600'
};
const $8c208b2b27ab0e36$export$7c1ecc66643fdbd6 = {
    base: '#ffc107',
    lighten5: '#fff8e1',
    lighten4: '#ffecb3',
    lighten3: '#ffe082',
    lighten2: '#ffd54f',
    lighten1: '#ffca28',
    darken1: '#ffb300',
    darken2: '#ffa000',
    darken3: '#ff8f00',
    darken4: '#ff6f00',
    accent1: '#ffe57f',
    accent2: '#ffd740',
    accent3: '#ffc400',
    accent4: '#ffab00'
};
const $8c208b2b27ab0e36$export$ad766f34ace1cafd = {
    base: '#ff9800',
    lighten5: '#fff3e0',
    lighten4: '#ffe0b2',
    lighten3: '#ffcc80',
    lighten2: '#ffb74d',
    lighten1: '#ffa726',
    darken1: '#fb8c00',
    darken2: '#f57c00',
    darken3: '#ef6c00',
    darken4: '#e65100',
    accent1: '#ffd180',
    accent2: '#ffab40',
    accent3: '#ff9100',
    accent4: '#ff6d00'
};
const $8c208b2b27ab0e36$export$1ceed3dd9ec11704 = {
    base: '#ff5722',
    lighten5: '#fbe9e7',
    lighten4: '#ffccbc',
    lighten3: '#ffab91',
    lighten2: '#ff8a65',
    lighten1: '#ff7043',
    darken1: '#f4511e',
    darken2: '#e64a19',
    darken3: '#d84315',
    darken4: '#bf360c',
    accent1: '#ff9e80',
    accent2: '#ff6e40',
    accent3: '#ff3d00',
    accent4: '#dd2c00'
};
const $8c208b2b27ab0e36$export$b6e6178d3f565007 = {
    base: '#795548',
    lighten5: '#efebe9',
    lighten4: '#d7ccc8',
    lighten3: '#bcaaa4',
    lighten2: '#a1887f',
    lighten1: '#8d6e63',
    darken1: '#6d4c41',
    darken2: '#5d4037',
    darken3: '#4e342e',
    darken4: '#3e2723'
};
const $8c208b2b27ab0e36$export$7c2da42d08c019c9 = {
    base: '#607d8b',
    lighten5: '#eceff1',
    lighten4: '#cfd8dc',
    lighten3: '#b0bec5',
    lighten2: '#90a4ae',
    lighten1: '#78909c',
    darken1: '#546e7a',
    darken2: '#455a64',
    darken3: '#37474f',
    darken4: '#263238'
};
const $8c208b2b27ab0e36$export$e4c89085febbc618 = {
    base: '#9e9e9e',
    lighten5: '#fafafa',
    lighten4: '#f5f5f5',
    lighten3: '#eeeeee',
    lighten2: '#e0e0e0',
    lighten1: '#bdbdbd',
    darken1: '#757575',
    darken2: '#616161',
    darken3: '#424242',
    darken4: '#212121'
};
const $8c208b2b27ab0e36$export$feb21b986204d651 = {
    black: '#000000',
    white: '#ffffff',
    transparent: '#ffffff00'
};
var $8c208b2b27ab0e36$export$2e2bcd8739ae039 = {
    red: $8c208b2b27ab0e36$export$a90204d1394caf30,
    pink: $8c208b2b27ab0e36$export$47853bc718611763,
    purple: $8c208b2b27ab0e36$export$e13cce2a2d16a9d4,
    deepPurple: $8c208b2b27ab0e36$export$51ef95b19086af57,
    indigo: $8c208b2b27ab0e36$export$3e6ccc7b8562d453,
    blue: $8c208b2b27ab0e36$export$2aa0182783e7e9de,
    lightBlue: $8c208b2b27ab0e36$export$7b0d29b70b435c21,
    cyan: $8c208b2b27ab0e36$export$7474046f446842ee,
    teal: $8c208b2b27ab0e36$export$8bf7dff220b82b4a,
    green: $8c208b2b27ab0e36$export$955a2ebd2fb142ae,
    lightGreen: $8c208b2b27ab0e36$export$559a8c00376dc936,
    lime: $8c208b2b27ab0e36$export$221d31baf2636aad,
    yellow: $8c208b2b27ab0e36$export$594c5a8758200c32,
    amber: $8c208b2b27ab0e36$export$7c1ecc66643fdbd6,
    orange: $8c208b2b27ab0e36$export$ad766f34ace1cafd,
    deepOrange: $8c208b2b27ab0e36$export$1ceed3dd9ec11704,
    brown: $8c208b2b27ab0e36$export$b6e6178d3f565007,
    blueGrey: $8c208b2b27ab0e36$export$7c2da42d08c019c9,
    grey: $8c208b2b27ab0e36$export$e4c89085febbc618,
    shades: $8c208b2b27ab0e36$export$feb21b986204d651
};


const $ac56109586b44d4a$export$414641dc09963608 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    swatches: {
        type: Array,
        default: ()=>$ac56109586b44d4a$var$parseDefaultColors((0, $8c208b2b27ab0e36$export$2e2bcd8739ae039))
    },
    disabled: Boolean,
    readonly: Boolean,
    color: Object,
    maxHeight: [
        Number,
        String
    ],
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VColorPickerSwatches');
function $ac56109586b44d4a$var$parseDefaultColors(colors) {
    return Object.keys(colors).map((key)=>{
        const color = colors[key];
        return color.base ? [
            color.base,
            color.darken4,
            color.darken3,
            color.darken2,
            color.darken1,
            color.lighten1,
            color.lighten2,
            color.lighten3,
            color.lighten4,
            color.lighten5
        ] : [
            color.black,
            color.white,
            color.transparent
        ];
    });
}
const $ac56109586b44d4a$export$d9ba9354ad14b89d = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VColorPickerSwatches',
    props: $ac56109586b44d4a$export$414641dc09963608(),
    emits: {
        'update:color': (color)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const isInteractive = (0, $01W3b.toRef)(()=>!props.disabled && !props.readonly);
        function onSwatchClick(hsva) {
            if (!isInteractive.value || !hsva) return;
            emit('update:color', hsva);
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-color-picker-swatches',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        maxHeight: (0, $8590040a7833369a$export$286ad215293a0860)(props.maxHeight)
                    },
                    props.style
                ])
            }, [
                (0, $TusQn.createElementVNode)("div", null, [
                    props.swatches.map((swatch)=>(0, $TusQn.createElementVNode)("div", {
                            "class": "v-color-picker-swatches__swatch"
                        }, [
                            swatch.map((color)=>{
                                const rgba = (0, $44de4fc7c15df730$export$6e865ea70d7724f)(color);
                                const hsva = (0, $44de4fc7c15df730$export$62bb88c9baab039f)(rgba);
                                const background = (0, $44de4fc7c15df730$export$db9c9368f923228e)(rgba);
                                return (0, $TusQn.createElementVNode)("div", {
                                    "class": (0, $8POXm.normalizeClass)([
                                        'v-color-picker-swatches__color',
                                        {
                                            'v-color-picker-swatches__color--disabled': props.disabled
                                        }
                                    ]),
                                    "onClick": ()=>onSwatchClick(hsva)
                                }, [
                                    (0, $TusQn.createElementVNode)("div", {
                                        "style": {
                                            background: background
                                        }
                                    }, [
                                        props.color && (0, $bf1718679e817e1f$export$9cb4719e2e525b7a)(props.color, hsva) ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                            "size": "x-small",
                                            "icon": "$success",
                                            "color": (0, $44de4fc7c15df730$export$850ce485a60d103b)(color, '#FFFFFF') > 2 ? 'white' : 'black'
                                        }, null) : undefined
                                    ])
                                ]);
                            })
                        ]))
                ])
            ]));
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

// Utilities

const $af9bbb3d66f96220$export$4a5fc38152ad5af8 = (0, $5224ab9d69b8c3e0$export$b3680ae2c271b9f3)('v-picker-title');






const $dbc8d169fef91a15$export$78d2911f7e2f59e2 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    bgColor: String,
    divided: Boolean,
    landscape: Boolean,
    title: String,
    hideHeader: Boolean,
    hideTitle: Boolean,
    ...(0, $ce059966358db8b1$export$a0ee5621cbdcc362)()
}, 'VPicker');
const $dbc8d169fef91a15$export$37f35d9b6bd5d714 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VPicker',
    props: $dbc8d169fef91a15$export$78d2911f7e2f59e2(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const sheetProps = (0, $ce059966358db8b1$export$d41b26ce18186ef0).filterProps(props);
            const hasTitle = !props.hideTitle && !!(props.title || slots.title);
            return (0, $TusQn.createVNode)((0, $ce059966358db8b1$export$d41b26ce18186ef0), (0, $TusQn.mergeProps)(sheetProps, {
                "color": props.bgColor,
                "class": [
                    'v-picker',
                    {
                        'v-picker--divided': props.divided,
                        'v-picker--landscape': props.landscape,
                        'v-picker--with-actions': !!slots.actions
                    },
                    props.class
                ],
                "style": props.style
            }), {
                default: ()=>[
                        !props.hideHeader && (0, $TusQn.createElementVNode)("div", {
                            "key": "header",
                            "class": (0, $8POXm.normalizeClass)([
                                'v-picker__header-wrapper',
                                backgroundColorClasses.value
                            ]),
                            "style": (0, $8POXm.normalizeStyle)([
                                backgroundColorStyles.value
                            ])
                        }, [
                            hasTitle && (0, $TusQn.createVNode)((0, $af9bbb3d66f96220$export$4a5fc38152ad5af8), {
                                "key": "picker-title"
                            }, {
                                default: ()=>[
                                        slots.title?.() ?? props.title
                                    ]
                            }),
                            slots.header && (0, $TusQn.createElementVNode)("div", {
                                "class": "v-picker__header"
                            }, [
                                slots.header()
                            ])
                        ]),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-picker__body"
                        }, [
                            slots.default?.()
                        ]),
                        slots.actions && (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VBtn: {
                                    slim: true,
                                    variant: 'text'
                                }
                            }
                        }, {
                            default: ()=>[
                                    (0, $TusQn.createElementVNode)("div", {
                                        "class": "v-picker__actions"
                                    }, [
                                        slots.actions()
                                    ])
                                ]
                        })
                    ]
            });
        });
        return {};
    }
});







const $6f27e561a8b73c54$export$27a13bb09ff7d1f7 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    canvasHeight: {
        type: [
            String,
            Number
        ],
        default: 150
    },
    disabled: Boolean,
    dotSize: {
        type: [
            Number,
            String
        ],
        default: 10
    },
    hideCanvas: Boolean,
    hideSliders: Boolean,
    hideInputs: Boolean,
    mode: {
        type: String,
        default: 'rgba',
        validator: (v)=>Object.keys((0, $9d51d153ec08ddd1$export$4a6bdc0a840be00)).includes(v)
    },
    modes: {
        type: Array,
        default: ()=>Object.keys((0, $9d51d153ec08ddd1$export$4a6bdc0a840be00)),
        validator: (v)=>Array.isArray(v) && v.every((m)=>Object.keys((0, $9d51d153ec08ddd1$export$4a6bdc0a840be00)).includes(m))
    },
    showSwatches: Boolean,
    readonly: Boolean,
    swatches: Array,
    swatchesMaxHeight: {
        type: [
            Number,
            String
        ],
        default: 150
    },
    modelValue: {
        type: [
            Object,
            String
        ]
    },
    ...(0, $dbc8d169fef91a15$export$78d2911f7e2f59e2)({
        hideHeader: true
    }),
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $14fda2a5207b1bb1$export$fb8ae246551c1c5c)(), [
        'hideEyeDropper',
        'eyeDropperIcon'
    ])
}, 'VColorPicker');
const $6f27e561a8b73c54$export$9359e1f82effabe6 = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VColorPicker',
    props: $6f27e561a8b73c54$export$27a13bb09ff7d1f7(),
    emits: {
        'update:modelValue': (color)=>true,
        'update:mode': (mode)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const mode = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'mode');
        const hue = (0, $01W3b.ref)(null);
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', undefined, (v)=>{
            if (v == null || v === '') return null;
            let c;
            try {
                c = (0, $44de4fc7c15df730$export$62bb88c9baab039f)((0, $44de4fc7c15df730$export$6e865ea70d7724f)(v));
            } catch (err) {
                (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(err);
                return null;
            }
            return c;
        }, (v)=>{
            if (!v) return null;
            return (0, $9d51d153ec08ddd1$export$a5d74e2261ad8c75)(v, props.modelValue);
        });
        const currentColor = (0, $01W3b.computed)(()=>{
            return model.value ? {
                ...model.value,
                h: hue.value ?? model.value.h
            } : null;
        });
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        let externalChange = true;
        (0, $01W3b.watch)(model, (v)=>{
            if (!externalChange) {
                // prevent hue shift from rgb conversion inaccuracy
                externalChange = true;
                return;
            }
            if (!v) return;
            hue.value = v.h;
        }, {
            immediate: true
        });
        const updateColor = (hsva)=>{
            externalChange = false;
            hue.value = hsva.h;
            model.value = hsva;
        };
        (0, $TusQn.onBeforeMount)(()=>{
            if (!props.modes.includes(mode.value)) mode.value = props.modes[0];
        });
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VSlider: {
                color: undefined,
                trackColor: undefined,
                trackFillColor: undefined
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const pickerProps = (0, $dbc8d169fef91a15$export$37f35d9b6bd5d714).filterProps(props);
            return (0, $TusQn.createVNode)((0, $dbc8d169fef91a15$export$37f35d9b6bd5d714), (0, $TusQn.mergeProps)(pickerProps, {
                "class": [
                    'v-color-picker',
                    rtlClasses.value,
                    props.class
                ],
                "style": [
                    {
                        '--v-color-picker-color-hsv': (0, $44de4fc7c15df730$export$25aeffa982c279d7)({
                            ...currentColor.value ?? (0, $9d51d153ec08ddd1$export$8b018767dd6f3cea),
                            a: 1
                        })
                    },
                    props.style
                ]
            }), {
                ...slots,
                default: ()=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        !props.hideCanvas && (0, $TusQn.createVNode)((0, $f3b1bcf45613b56e$export$5142c1b9e4f0ab2e), {
                            "key": "canvas",
                            "color": currentColor.value,
                            "onUpdate:color": updateColor,
                            "disabled": props.disabled,
                            "readonly": props.readonly,
                            "dotSize": props.dotSize,
                            "width": props.width,
                            "height": props.canvasHeight
                        }, null),
                        (!props.hideSliders || !props.hideInputs) && (0, $TusQn.createElementVNode)("div", {
                            "key": "controls",
                            "class": "v-color-picker__controls"
                        }, [
                            !props.hideSliders && (0, $TusQn.createVNode)((0, $14fda2a5207b1bb1$export$82b96236d6e48b4a), {
                                "key": "preview",
                                "color": currentColor.value,
                                "onUpdate:color": updateColor,
                                "hideAlpha": !mode.value.endsWith('a'),
                                "disabled": props.disabled,
                                "readonly": props.readonly,
                                "hideEyeDropper": props.hideEyeDropper,
                                "eyeDropperIcon": props.eyeDropperIcon
                            }, null),
                            !props.hideInputs && (0, $TusQn.createVNode)((0, $f9ab1bbd66c306f9$export$85684b51105c3c4c), {
                                "key": "edit",
                                "modes": props.modes,
                                "mode": mode.value,
                                "onUpdate:mode": (m)=>mode.value = m,
                                "color": currentColor.value,
                                "onUpdate:color": updateColor,
                                "disabled": props.disabled,
                                "readonly": props.readonly
                            }, null)
                        ]),
                        props.showSwatches && (0, $TusQn.createVNode)((0, $ac56109586b44d4a$export$d9ba9354ad14b89d), {
                            "key": "swatches",
                            "color": currentColor.value,
                            "onUpdate:color": updateColor,
                            "maxHeight": props.swatchesMaxHeight,
                            "swatches": props.swatches,
                            "disabled": props.disabled,
                            "readonly": props.readonly
                        }, null)
                    ])
            });
        });
        return {};
    }
});




var $419e4a176bc46a1e$exports = {};

$parcel$export($419e4a176bc46a1e$exports, "VCombobox", () => $5369793868d5197a$export$8bb5629127e0cc34);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");


























const $5369793868d5197a$export$cdb4b7fe6cafd6c6 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    alwaysFilter: Boolean,
    autoSelectFirst: {
        type: [
            Boolean,
            String
        ]
    },
    clearOnSelect: {
        type: Boolean,
        default: true
    },
    delimiters: Array,
    ...(0, $06230a510138477a$export$a99bb5c4eecafb96)({
        filterKeys: [
            'title'
        ]
    }),
    ...(0, $118e5e4309583a1b$export$c210933f6eecdb37)({
        hideNoData: true,
        returnObject: true
    }),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $1df180b07e489866$export$c9f7484641b0b190)({
        modelValue: null,
        role: 'combobox'
    }), [
        'validationValue',
        'dirty'
    ])
}, 'VCombobox');
const $5369793868d5197a$export$8bb5629127e0cc34 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCombobox',
    props: $5369793868d5197a$export$cdb4b7fe6cafd6c6(),
    emits: {
        'update:focused': (focused)=>true,
        'update:modelValue': (value)=>true,
        'update:search': (value)=>true,
        'update:menu': (value)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const vTextFieldRef = (0, $01W3b.ref)();
        const isFocused = (0, $01W3b.shallowRef)(false);
        const isPristine = (0, $01W3b.shallowRef)(true);
        const listHasFocus = (0, $01W3b.shallowRef)(false);
        const vMenuRef = (0, $01W3b.ref)();
        const vVirtualScrollRef = (0, $01W3b.ref)();
        const selectionIndex = (0, $01W3b.shallowRef)(-1);
        let cleared = false;
        const { items: items, transformIn: transformIn, transformOut: transformOut } = (0, $9d0414e5c866e7bc$export$7bfdd97581ca93c)(props);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>vTextFieldRef.value?.color);
        const { InputIcon: InputIcon } = (0, $9a9409ba39d4a5b8$export$d08cb507a9c34d4b)(props);
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>transformIn((0, $8590040a7833369a$export$76411cac38121ecb)(v)), (v)=>{
            const transformed = transformOut(v);
            return props.multiple ? transformed : transformed[0] ?? null;
        });
        const form = (0, $72bfe1fa0cde9e24$export$87c0cf8eb5a167e0)(props);
        const closableChips = (0, $01W3b.toRef)(()=>props.closableChips && !form.isReadonly.value && !form.isDisabled.value);
        const hasChips = (0, $01W3b.computed)(()=>!!(props.chips || slots.chip));
        const hasSelectionSlot = (0, $01W3b.computed)(()=>hasChips.value || !!slots.selection);
        const _search = (0, $01W3b.shallowRef)(!props.multiple && !hasSelectionSlot.value ? model.value[0]?.title ?? '' : '');
        const _searchLock = (0, $01W3b.shallowRef)(null);
        const search = (0, $01W3b.computed)({
            get: ()=>{
                return _search.value;
            },
            set: async (val)=>{
                _search.value = val ?? '';
                if (val === null || val === '' && !props.multiple && !hasSelectionSlot.value) model.value = [];
                else if (!props.multiple && !hasSelectionSlot.value) {
                    model.value = [
                        (0, $9d0414e5c866e7bc$export$ef3b10464ff5e4ec)(props, val)
                    ];
                    (0, $TusQn.nextTick)(()=>vVirtualScrollRef.value?.scrollToIndex(0));
                }
                if (val && props.multiple && props.delimiters?.length) {
                    const values = splitByDelimiters(val);
                    if (values.length > 1) {
                        selectMultiple(values);
                        _search.value = '';
                    }
                }
                if (!val) selectionIndex.value = -1;
                isPristine.value = !val;
            }
        });
        const counterValue = (0, $01W3b.computed)(()=>{
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : typeof props.counterValue === 'number' ? props.counterValue : props.multiple ? model.value.length : search.value.length;
        });
        const { filteredItems: filteredItems, getMatches: getMatches } = (0, $06230a510138477a$export$3274cf84b703fff)(props, items, ()=>_searchLock.value ?? (props.alwaysFilter || !isPristine.value ? search.value : ''));
        const displayItems = (0, $01W3b.computed)(()=>{
            if (props.hideSelected && _searchLock.value === null) return filteredItems.value.filter((filteredItem)=>!model.value.some((s)=>s.value === filteredItem.value));
            return filteredItems.value;
        });
        const menuDisabled = (0, $01W3b.computed)(()=>props.hideNoData && !displayItems.value.length || form.isReadonly.value || form.isDisabled.value);
        const _menu = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'menu');
        const menu = (0, $01W3b.computed)({
            get: ()=>_menu.value,
            set: (v)=>{
                if (_menu.value && !v && vMenuRef.value?.\u03A8openChildren.size) return;
                if (v && menuDisabled.value) return;
                _menu.value = v;
            }
        });
        const { menuId: menuId, ariaExpanded: ariaExpanded, ariaControls: ariaControls } = (0, $db0abbb2e7605284$export$336f022c1e31f429)(props, menu);
        (0, $01W3b.watch)(_search, (value)=>{
            if (cleared) // wait for clear to finish, VTextField sets _search to null
            // then search computed triggers and updates _search to ''
            (0, $TusQn.nextTick)(()=>cleared = false);
            else if (isFocused.value && !menu.value) menu.value = true;
            emit('update:search', value);
        });
        (0, $01W3b.watch)(model, (value)=>{
            if (!props.multiple && !hasSelectionSlot.value) _search.value = value[0]?.title ?? '';
        });
        const selectedValues = (0, $01W3b.computed)(()=>model.value.map((selection)=>selection.value));
        const firstSelectableItem = (0, $01W3b.computed)(()=>displayItems.value.find((x)=>x.type === 'item' && !x.props.disabled));
        const highlightFirst = (0, $01W3b.computed)(()=>{
            const selectFirst = props.autoSelectFirst === true || props.autoSelectFirst === 'exact' && search.value === firstSelectableItem.value?.title;
            return selectFirst && displayItems.value.length > 0 && !isPristine.value && !listHasFocus.value;
        });
        const listRef = (0, $01W3b.ref)();
        const headerRef = (0, $01W3b.ref)();
        const footerRef = (0, $01W3b.ref)();
        const listEvents = (0, $31951e38cd8c6afc$export$5081bf709ff6ca2c)(listRef, vTextFieldRef);
        const { onTabKeydown: onTabKeydown } = (0, $9b72d3360b6fdbc5$export$d0c035d5199a1ad2)({
            groups: [
                {
                    type: 'element',
                    contentRef: headerRef
                },
                {
                    type: 'list',
                    contentRef: listRef,
                    displayItemsCount: ()=>displayItems.value.length
                },
                {
                    type: 'element',
                    contentRef: footerRef
                }
            ],
            onLeave: ()=>{
                menu.value = false;
                vTextFieldRef.value?.focus();
            }
        });
        function onClear(e) {
            cleared = true;
            (0, $TusQn.nextTick)(()=>cleared = false);
            if (props.openOnClear) menu.value = true;
        }
        function onMousedownControl() {
            if (menuDisabled.value) return;
            menu.value = true;
        }
        function onMousedownMenuIcon(e) {
            if (menuDisabled.value) return;
            if (isFocused.value) {
                e.preventDefault();
                e.stopPropagation();
            }
            menu.value = !menu.value;
        }
        function onMenuKeydown(e) {
            if (e.key === 'Tab') onTabKeydown(e);
            if (listRef.value?.$el.contains(e.target) && ((0, $8590040a7833369a$export$d9d503bf19df5a70)(e) || e.key === 'Backspace')) vTextFieldRef.value?.focus();
        }
        // eslint-disable-next-line complexity
        function onKeydown(e) {
            if ((0, $8590040a7833369a$export$af97bfee12e57e9c)(e) || form.isReadonly.value) return;
            const selectionStart = vTextFieldRef.value?.selectionStart;
            const length = model.value.length;
            if ([
                'Enter',
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) e.preventDefault();
            if ([
                'Enter',
                'ArrowDown'
            ].includes(e.key)) menu.value = true;
            if ([
                'Escape'
            ].includes(e.key)) menu.value = false;
            if (highlightFirst.value && [
                'Enter',
                'Tab'
            ].includes(e.key) && firstSelectableItem.value && !model.value.some((_ref2)=>{
                let { value: value } = _ref2;
                return value === firstSelectableItem.value.value;
            })) select(firstSelectableItem.value);
            if (e.key === 'ArrowDown' && highlightFirst.value) listRef.value?.focus('next');
            if (e.key === 'Enter' && search.value) {
                select((0, $9d0414e5c866e7bc$export$ef3b10464ff5e4ec)(props, search.value), true, true);
                if (hasSelectionSlot.value) _search.value = '';
            }
            if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                if (!props.multiple && hasSelectionSlot.value && model.value.length > 0 && !search.value) return select(model.value[0], false);
                if (~selectionIndex.value) {
                    e.preventDefault();
                    const originalSelectionIndex = selectionIndex.value;
                    select(model.value[selectionIndex.value], false);
                    selectionIndex.value = originalSelectionIndex >= length - 1 ? length - 2 : originalSelectionIndex;
                } else if (e.key === 'Backspace' && !search.value) selectionIndex.value = length - 1;
                return;
            }
            if (!props.multiple) return;
            if (e.key === 'ArrowLeft') {
                if (selectionIndex.value < 0 && selectionStart && selectionStart > 0) return;
                const prev = selectionIndex.value > -1 ? selectionIndex.value - 1 : length - 1;
                if (model.value[prev]) selectionIndex.value = prev;
                else {
                    selectionIndex.value = -1;
                    vTextFieldRef.value?.setSelectionRange(search.value.length, search.value.length);
                }
            } else if (e.key === 'ArrowRight') {
                if (selectionIndex.value < 0) return;
                const next = selectionIndex.value + 1;
                if (model.value[next]) selectionIndex.value = next;
                else {
                    selectionIndex.value = -1;
                    vTextFieldRef.value?.setSelectionRange(0, 0);
                }
            } else if (~selectionIndex.value && (0, $8590040a7833369a$export$d9d503bf19df5a70)(e)) selectionIndex.value = -1;
        }
        function onPaste(e) {
            const clipboardText = e?.clipboardData?.getData('Text') ?? '';
            const values = splitByDelimiters(clipboardText);
            if (values.length > 1 && props.multiple) {
                e.preventDefault();
                selectMultiple(values);
            }
        }
        function onAfterEnter() {
            if (props.eager) vVirtualScrollRef.value?.calculateVisibleItems();
        }
        function onAfterLeave() {
            if (isFocused.value) vTextFieldRef.value?.focus();
            isPristine.value = true;
            _searchLock.value = null;
        }
        /** @param set - null means toggle */ function select(item) {
            let set = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            let keepMenu = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            if (!item || item.props.disabled) return;
            if (props.multiple) {
                const index = model.value.findIndex((selection)=>(props.valueComparator || (0, $bf1718679e817e1f$export$9cb4719e2e525b7a))(selection.value, item.value));
                const add = set == null ? !~index : set;
                if (~index) {
                    const value = add ? [
                        ...model.value,
                        item
                    ] : [
                        ...model.value
                    ];
                    value.splice(index, 1);
                    model.value = value;
                } else if (add) model.value = [
                    ...model.value,
                    item
                ];
                if (props.clearOnSelect) search.value = '';
            } else {
                const add = set !== false;
                model.value = add ? [
                    item
                ] : [];
                if ((!isPristine.value || props.alwaysFilter) && _search.value) _searchLock.value = _search.value;
                _search.value = add && !hasSelectionSlot.value ? item.title : '';
                // watch for search watcher to trigger
                (0, $TusQn.nextTick)(()=>{
                    menu.value = keepMenu;
                    isPristine.value = true;
                });
            }
        }
        function splitByDelimiters(val) {
            const effectiveDelimiters = [
                '\n',
                ...props.delimiters ?? []
            ];
            const signsToMatch = effectiveDelimiters.map((0, $8590040a7833369a$export$211de94a4ac98986)).join('|');
            return val.split(new RegExp(`(?:${signsToMatch})+`));
        }
        async function selectMultiple(values) {
            for (let value of values){
                value = value.trim();
                if (value) {
                    select((0, $9d0414e5c866e7bc$export$ef3b10464ff5e4ec)(props, value));
                    await (0, $TusQn.nextTick)();
                }
            }
        }
        function onFocusin(e) {
            isFocused.value = true;
            setTimeout(()=>{
                listHasFocus.value = true;
            });
        }
        function onFocusout(e) {
            listHasFocus.value = false;
        }
        function onBlur(e) {
            const menuContent = vMenuRef.value?.contentEl;
            if (menuContent?.contains(e.relatedTarget)) isFocused.value = true;
        }
        (0, $01W3b.watch)(isFocused, (val, oldVal)=>{
            if (val || val === oldVal) return;
            selectionIndex.value = -1;
            menu.value = false;
            if (search.value) {
                if (props.multiple) {
                    select((0, $9d0414e5c866e7bc$export$ef3b10464ff5e4ec)(props, search.value));
                    return;
                }
                if (!hasSelectionSlot.value) return;
                if (model.value.some((_ref3)=>{
                    let { title: title } = _ref3;
                    return title === search.value;
                })) _search.value = '';
                else select((0, $9d0414e5c866e7bc$export$ef3b10464ff5e4ec)(props, search.value));
            }
        });
        (0, $01W3b.watch)(menu, (val)=>{
            if (!props.hideSelected && val && model.value.length && isPristine.value) {
                const index = displayItems.value.findIndex((item)=>model.value.some((s)=>(props.valueComparator || (0, $bf1718679e817e1f$export$9cb4719e2e525b7a))(s.value, item.value)));
                (0, $90a48ad178b943d3$export$13a6ee1b6d6a0cfd) && window.requestAnimationFrame(()=>{
                    index >= 0 && vVirtualScrollRef.value?.scrollToIndex(index);
                });
            }
            if (val) _searchLock.value = null;
        });
        (0, $01W3b.watch)(items, (newVal, oldVal)=>{
            if (menu.value) return;
            if (isFocused.value && !oldVal.length && newVal.length) menu.value = true;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasList = !!(!props.hideNoData || displayItems.value.length || slots['prepend-item'] || slots['append-item'] || slots['no-data']);
            const isDirty = model.value.length > 0;
            const textFieldProps = (0, $1df180b07e489866$export$d591c92dea965c28).filterProps(props);
            const menuSlotProps = {
                search: search,
                filteredItems: filteredItems.value
            };
            return (0, $TusQn.createVNode)((0, $1df180b07e489866$export$d591c92dea965c28), (0, $TusQn.mergeProps)({
                "ref": vTextFieldRef
            }, textFieldProps, {
                "modelValue": search.value,
                "onUpdate:modelValue": ($event)=>search.value = $event,
                "focused": isFocused.value,
                "onUpdate:focused": ($event)=>isFocused.value = $event,
                "validationValue": model.externalValue,
                "counterValue": counterValue.value,
                "dirty": isDirty,
                "class": [
                    'v-combobox',
                    {
                        'v-combobox--active-menu': menu.value,
                        'v-combobox--chips': !!props.chips,
                        'v-combobox--selection-slot': !!hasSelectionSlot.value,
                        'v-combobox--selecting-index': selectionIndex.value > -1,
                        [`v-combobox--${props.multiple ? 'multiple' : 'single'}`]: true
                    },
                    props.class
                ],
                "style": props.style,
                "readonly": form.isReadonly.value,
                "placeholder": isDirty ? undefined : props.placeholder,
                "onClick:clear": onClear,
                "onMousedown:control": onMousedownControl,
                "onKeydown": onKeydown,
                "onPaste": onPaste,
                "onBlur": onBlur,
                "aria-expanded": ariaExpanded.value,
                "aria-controls": ariaControls.value
            }), {
                ...slots,
                default: (_ref4)=>{
                    let { id: id } = _ref4;
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createVNode)((0, $9208258024e22101$export$a347888d6b8f252a), (0, $TusQn.mergeProps)({
                            "id": menuId.value,
                            "ref": vMenuRef,
                            "modelValue": menu.value,
                            "onUpdate:modelValue": ($event)=>menu.value = $event,
                            "activator": "parent",
                            "contentClass": "v-combobox__content",
                            "disabled": menuDisabled.value,
                            "eager": props.eager,
                            "maxHeight": 310,
                            "openOnClick": false,
                            "closeOnContentClick": false,
                            "onAfterEnter": onAfterEnter,
                            "onAfterLeave": onAfterLeave
                        }, props.menuProps), {
                            default: ()=>[
                                    (0, $TusQn.createVNode)((0, $ce059966358db8b1$export$d41b26ce18186ef0), {
                                        "onFocusin": onFocusin,
                                        "onKeydown": onMenuKeydown
                                    }, {
                                        default: ()=>[
                                                slots['menu-header'] && (0, $TusQn.createElementVNode)("header", {
                                                    "ref": headerRef
                                                }, [
                                                    slots['menu-header'](menuSlotProps)
                                                ]),
                                                hasList && (0, $TusQn.createVNode)((0, $8f3cccf9308874bc$export$3b010b0401837103), (0, $TusQn.mergeProps)({
                                                    "key": "combobox-list",
                                                    "ref": listRef,
                                                    "filterable": true,
                                                    "selected": selectedValues.value,
                                                    "selectStrategy": props.multiple ? 'independent' : 'single-independent',
                                                    "onMousedown": (e)=>e.preventDefault(),
                                                    "selectable": !!displayItems.value.length,
                                                    "onFocusout": onFocusout,
                                                    "tabindex": "-1",
                                                    "aria-live": "polite",
                                                    "aria-labelledby": `${id.value}-label`,
                                                    "aria-multiselectable": props.multiple,
                                                    "color": props.itemColor ?? props.color
                                                }, listEvents, props.listProps), {
                                                    default: ()=>[
                                                            slots['prepend-item']?.(),
                                                            !displayItems.value.length && !props.hideNoData && (slots['no-data']?.() ?? (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), {
                                                                "key": "no-data",
                                                                "title": t(props.noDataText)
                                                            }, null)),
                                                            (0, $TusQn.createVNode)((0, $28b14115b5680302$export$bdb136bf2d9028a4), {
                                                                "ref": vVirtualScrollRef,
                                                                "renderless": true,
                                                                "items": displayItems.value,
                                                                "itemKey": "value"
                                                            }, {
                                                                default: (_ref5)=>{
                                                                    let { item: item, index: index, itemRef: itemRef } = _ref5;
                                                                    const itemProps = (0, $TusQn.mergeProps)(item.props, {
                                                                        ref: itemRef,
                                                                        key: item.value,
                                                                        active: highlightFirst.value && item === firstSelectableItem.value ? true : undefined,
                                                                        onClick: ()=>select(item, null),
                                                                        'aria-posinset': index + 1,
                                                                        'aria-setsize': displayItems.value.length
                                                                    });
                                                                    if (item.type === 'divider') return slots.divider?.({
                                                                        props: item.raw,
                                                                        index: index
                                                                    }) ?? (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), (0, $TusQn.mergeProps)(item.props, {
                                                                        "key": `divider-${index}`
                                                                    }), null);
                                                                    if (item.type === 'subheader') return slots.subheader?.({
                                                                        props: item.raw,
                                                                        index: index
                                                                    }) ?? (0, $TusQn.createVNode)((0, $96a2eb5e8711f0cc$export$70c4aba7bf48e22a), (0, $TusQn.mergeProps)(item.props, {
                                                                        "key": `subheader-${index}`
                                                                    }), null);
                                                                    return slots.item?.({
                                                                        item: item,
                                                                        index: index,
                                                                        props: itemProps
                                                                    }) ?? (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), (0, $TusQn.mergeProps)(itemProps, {
                                                                        "role": "option"
                                                                    }), {
                                                                        prepend: (_ref6)=>{
                                                                            let { isSelected: isSelected } = _ref6;
                                                                            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                                                                props.multiple && !props.hideSelected ? (0, $TusQn.createVNode)((0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6), {
                                                                                    "key": item.value,
                                                                                    "modelValue": isSelected,
                                                                                    "ripple": false,
                                                                                    "tabindex": "-1",
                                                                                    "aria-hidden": true,
                                                                                    "onClick": (event)=>event.preventDefault()
                                                                                }, null) : undefined,
                                                                                item.props.prependAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                                                                    "image": item.props.prependAvatar
                                                                                }, null),
                                                                                item.props.prependIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                                                                    "icon": item.props.prependIcon
                                                                                }, null)
                                                                            ]);
                                                                        },
                                                                        title: ()=>{
                                                                            return isPristine.value ? item.title : (0, $06230a510138477a$export$71650bdcd27abbc4)('v-combobox', item.title, getMatches(item)?.title);
                                                                        }
                                                                    });
                                                                }
                                                            }),
                                                            slots['append-item']?.()
                                                        ]
                                                }),
                                                slots['menu-footer'] && (0, $TusQn.createElementVNode)("footer", {
                                                    "ref": footerRef
                                                }, [
                                                    slots['menu-footer'](menuSlotProps)
                                                ])
                                            ]
                                    })
                                ]
                        }),
                        model.value.map((item, index)=>{
                            function onChipClose(e) {
                                e.stopPropagation();
                                e.preventDefault();
                                select(item, false);
                            }
                            const slotProps = (0, $TusQn.mergeProps)((0, $fd0891698b65ffb1$export$1b5fab12cd17b4fb).filterProps(item.props), {
                                'onClick:close': onChipClose,
                                onKeydown (e) {
                                    if (e.key !== 'Enter' && e.key !== ' ') return;
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onChipClose(e);
                                },
                                onMousedown (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                },
                                modelValue: true,
                                'onUpdate:modelValue': undefined
                            });
                            const hasSlot = hasChips.value ? !!slots.chip : !!slots.selection;
                            const slotContent = hasSlot ? (0, $8590040a7833369a$export$9fc41f261330971f)(hasChips.value ? slots.chip({
                                item: item,
                                index: index,
                                props: slotProps
                            }) : slots.selection({
                                item: item,
                                index: index
                            })) : undefined;
                            if (hasSlot && !slotContent) return undefined;
                            return (0, $TusQn.createElementVNode)("div", {
                                "key": item.value,
                                "class": (0, $8POXm.normalizeClass)([
                                    'v-combobox__selection',
                                    index === selectionIndex.value && [
                                        'v-combobox__selection--selected',
                                        textColorClasses.value
                                    ]
                                ]),
                                "style": (0, $8POXm.normalizeStyle)(index === selectionIndex.value ? textColorStyles.value : {})
                            }, [
                                hasChips.value ? !slots.chip ? (0, $TusQn.createVNode)((0, $fd0891698b65ffb1$export$1b5fab12cd17b4fb), (0, $TusQn.mergeProps)({
                                    "key": "chip",
                                    "closable": closableChips.value,
                                    "size": "small",
                                    "text": item.title,
                                    "disabled": item.props.disabled
                                }, slotProps), null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                    "key": "chip-defaults",
                                    "defaults": {
                                        VChip: {
                                            closable: closableChips.value,
                                            size: 'small',
                                            text: item.title
                                        }
                                    }
                                }, {
                                    default: ()=>[
                                            slotContent
                                        ]
                                }) : slotContent ?? (0, $TusQn.createElementVNode)("span", {
                                    "class": "v-combobox__selection-text"
                                }, [
                                    item.title,
                                    props.multiple && index < model.value.length - 1 && (0, $TusQn.createElementVNode)("span", {
                                        "class": "v-combobox__selection-comma"
                                    }, [
                                        (0, $TusQn.createTextVNode)(",")
                                    ])
                                ])
                            ]);
                        })
                    ]);
                },
                'append-inner': function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots['append-inner']?.(...args),
                        (!props.hideNoData || props.items.length) && props.menuIcon ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                            "class": "v-combobox__menu-icon",
                            "color": vTextFieldRef.value?.fieldIconColor,
                            "icon": props.menuIcon,
                            "onMousedown": onMousedownMenuIcon,
                            "onClick": (0, $8590040a7833369a$export$8793edee2d425525),
                            "aria-hidden": true,
                            "tabindex": "-1"
                        }, null) : undefined,
                        props.appendInnerIcon && (0, $TusQn.createVNode)(InputIcon, {
                            "key": "append-icon",
                            "name": "appendInner",
                            "color": args[0].iconColor.value
                        }, null)
                    ]);
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({
            isFocused: isFocused,
            isPristine: isPristine,
            menu: menu,
            search: search,
            selectionIndex: selectionIndex,
            filteredItems: filteredItems,
            select: select
        }, vTextFieldRef);
    }
});




var $83658c5835b97f53$exports = {};

$parcel$export($83658c5835b97f53$exports, "VConfirmEdit", () => $9cc9b474ccefc8b4$export$1bc4c6f1c359537);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");




const $9cc9b474ccefc8b4$export$8432eef2b93cb2e1 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    modelValue: null,
    color: String,
    cancelText: {
        type: String,
        default: '$vuetify.confirmEdit.cancel'
    },
    okText: {
        type: String,
        default: '$vuetify.confirmEdit.ok'
    },
    disabled: {
        type: [
            Boolean,
            Array
        ],
        default: undefined
    },
    hideActions: Boolean
}, 'VConfirmEdit');
const $9cc9b474ccefc8b4$export$1bc4c6f1c359537 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VConfirmEdit',
    props: $9cc9b474ccefc8b4$export$8432eef2b93cb2e1(),
    emits: {
        cancel: ()=>true,
        save: (value)=>true,
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const internalModel = (0, $01W3b.ref)();
        (0, $TusQn.watchEffect)(()=>{
            internalModel.value = structuredClone((0, $8590040a7833369a$export$dbf440cef0efdf87)(model.value));
        });
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const isPristine = (0, $01W3b.computed)(()=>{
            return (0, $bf1718679e817e1f$export$9cb4719e2e525b7a)(model.value, internalModel.value);
        });
        function isActionDisabled(action) {
            if (typeof props.disabled === 'boolean') return props.disabled;
            if (Array.isArray(props.disabled)) return props.disabled.includes(action);
            return isPristine.value;
        }
        const isSaveDisabled = (0, $01W3b.computed)(()=>isActionDisabled('save'));
        const isCancelDisabled = (0, $01W3b.computed)(()=>isActionDisabled('cancel'));
        function save() {
            model.value = internalModel.value;
            emit('save', internalModel.value);
        }
        function cancel() {
            internalModel.value = structuredClone((0, $8590040a7833369a$export$dbf440cef0efdf87)(model.value));
            emit('cancel');
        }
        function actions(actionsProps) {
            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                    "disabled": isCancelDisabled.value,
                    "variant": "text",
                    "color": props.color,
                    "onClick": cancel,
                    "text": t(props.cancelText)
                }, actionsProps), null),
                (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                    "disabled": isSaveDisabled.value,
                    "variant": "text",
                    "color": props.color,
                    "onClick": save,
                    "text": t(props.okText)
                }, actionsProps), null)
            ]);
        }
        let actionsUsed = false;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                slots.default?.({
                    model: internalModel,
                    save: save,
                    cancel: cancel,
                    isPristine: isPristine.value,
                    get actions () {
                        actionsUsed = true;
                        return actions;
                    }
                }),
                !props.hideActions && !actionsUsed && actions()
            ]);
        });
        return {
            save: save,
            cancel: cancel,
            isPristine: isPristine
        };
    }
});




var $bb8e4fdfd979e333$exports = {};

$parcel$export($bb8e4fdfd979e333$exports, "VCounter", () => $b240aced8b361832$export$45efeae449ff2094);



var $a9283406b3cdf2dc$exports = {};

$parcel$export($a9283406b3cdf2dc$exports, "VDataIterator", () => $8cdc764877aebc42$export$be5a6c7bb6e0c13d);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

// Composables

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

const $e1f46a36607fc04a$export$a6d4f3c269410395 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    expandOnClick: Boolean,
    showExpand: Boolean,
    expanded: {
        type: Array,
        default: ()=>[]
    }
}, 'DataTable-expand');
const $e1f46a36607fc04a$export$2583f5f5b5e13a84 = Symbol.for('vuetify:datatable:expanded');
function $e1f46a36607fc04a$export$6c2637d154b76687(props) {
    const expandOnClick = (0, $01W3b.toRef)(()=>props.expandOnClick);
    const expanded = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'expanded', props.expanded, (v)=>{
        return new Set(v);
    }, (v)=>{
        return [
            ...v.values()
        ];
    });
    function expand(item, value) {
        const newExpanded = new Set(expanded.value);
        const rawValue = (0, $01W3b.toRaw)(item.value);
        if (!value) {
            const item = [
                ...expanded.value
            ].find((x)=>(0, $01W3b.toRaw)(x) === rawValue);
            newExpanded.delete(item);
        } else newExpanded.add(rawValue);
        expanded.value = newExpanded;
    }
    function isExpanded(item) {
        const rawValue = (0, $01W3b.toRaw)(item.value);
        return [
            ...expanded.value
        ].some((x)=>(0, $01W3b.toRaw)(x) === rawValue);
    }
    function toggleExpand(item) {
        expand(item, !isExpanded(item));
    }
    const data = {
        expand: expand,
        expanded: expanded,
        expandOnClick: expandOnClick,
        isExpanded: isExpanded,
        toggleExpand: toggleExpand
    };
    (0, $TusQn.provide)($e1f46a36607fc04a$export$2583f5f5b5e13a84, data);
    return data;
}
function $e1f46a36607fc04a$export$7d3f3306ac4d54ef() {
    const data = (0, $TusQn.inject)($e1f46a36607fc04a$export$2583f5f5b5e13a84);
    if (!data) throw new Error('foo');
    return data;
}


// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $866d0c3f3c648c13$export$406ee928c389045b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    groupBy: {
        type: Array,
        default: ()=>[]
    }
}, 'DataTable-group');
const $866d0c3f3c648c13$var$VDataTableGroupSymbol = Symbol.for('vuetify:data-table-group');
function $866d0c3f3c648c13$export$543cf685fafb29db(props) {
    const groupBy = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'groupBy');
    return {
        groupBy: groupBy
    };
}
function $866d0c3f3c648c13$export$93a5542df6d97bc8(options) {
    const { disableSort: disableSort, groupBy: groupBy, sortBy: sortBy } = options;
    const opened = (0, $01W3b.ref)(new Set());
    const sortByWithGroups = (0, $01W3b.computed)(()=>{
        return groupBy.value.map((val)=>({
                ...val,
                order: val.order ?? false
            })).concat(disableSort?.value ? [] : sortBy.value);
    });
    function isGroupOpen(group) {
        return opened.value.has(group.id);
    }
    function toggleGroup(group) {
        const newOpened = new Set(opened.value);
        if (!isGroupOpen(group)) newOpened.add(group.id);
        else newOpened.delete(group.id);
        opened.value = newOpened;
    }
    function extractRows(items) {
        function dive(group) {
            const arr = [];
            for (const item of group.items)if ('type' in item && item.type === 'group') arr.push(...dive(item));
            else arr.push(item);
            return [
                ...new Set(arr)
            ];
        }
        return dive({
            type: 'group',
            items: items,
            id: 'dummy',
            key: 'dummy',
            value: 'dummy',
            depth: 0
        });
    }
    // onBeforeMount(() => {
    //   for (const key of groupedItems.value.keys()) {
    //     opened.value.add(key)
    //   }
    // })
    const data = {
        sortByWithGroups: sortByWithGroups,
        toggleGroup: toggleGroup,
        opened: opened,
        groupBy: groupBy,
        extractRows: extractRows,
        isGroupOpen: isGroupOpen
    };
    (0, $TusQn.provide)($866d0c3f3c648c13$var$VDataTableGroupSymbol, data);
    return data;
}
function $866d0c3f3c648c13$export$c4ec754551fa3ff4() {
    const data = (0, $TusQn.inject)($866d0c3f3c648c13$var$VDataTableGroupSymbol);
    if (!data) throw new Error('Missing group!');
    return data;
}
function $866d0c3f3c648c13$var$groupItemsByProperty(items, groupBy) {
    if (!items.length) return [];
    const groups = new Map();
    for (const item of items){
        const value = (0, $8590040a7833369a$export$f5474208cafa7b66)(item.raw, groupBy);
        if (!groups.has(value)) groups.set(value, []);
        groups.get(value).push(item);
    }
    return groups;
}
function $866d0c3f3c648c13$var$groupItems(items, groupBy) {
    let depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    let prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'root';
    if (!groupBy.length) return [];
    const groupedItems = $866d0c3f3c648c13$var$groupItemsByProperty(items, groupBy[0]);
    const groups = [];
    const rest = groupBy.slice(1);
    groupedItems.forEach((items, value)=>{
        const key = groupBy[0];
        const id = `${prefix}_${key}_${value}`;
        groups.push({
            depth: depth,
            id: id,
            key: key,
            value: value,
            items: rest.length ? $866d0c3f3c648c13$var$groupItems(items, rest, depth + 1, id) : items,
            type: 'group'
        });
    });
    return groups;
}
function $866d0c3f3c648c13$var$flattenItems(items, opened, hasSummary) {
    const flatItems = [];
    for (const item of items)// TODO: make this better
    if ('type' in item && item.type === 'group') {
        if (item.value != null) flatItems.push(item);
        if (opened.has(item.id) || item.value == null) {
            flatItems.push(...$866d0c3f3c648c13$var$flattenItems(item.items, opened, hasSummary));
            if (hasSummary) flatItems.push({
                ...item,
                type: 'group-summary'
            });
        }
    } else flatItems.push(item);
    return flatItems;
}
function $866d0c3f3c648c13$export$1d90b49b81ed368a(items, groupBy, opened, hasSummary) {
    const groups = (0, $01W3b.computed)(()=>{
        if (!groupBy.value.length) return [];
        return $866d0c3f3c648c13$var$groupItems((0, $01W3b.toValue)(items), groupBy.value.map((item)=>item.key));
    });
    const flatItems = (0, $01W3b.computed)(()=>{
        if (!groupBy.value.length) return (0, $01W3b.toValue)(items);
        return $866d0c3f3c648c13$var$flattenItems(groups.value, opened.value, (0, $01W3b.toValue)(hasSummary));
    });
    return {
        groups: groups,
        flatItems: flatItems
    };
}


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

function $57d3f2dac529a040$export$b8ae39f344200a7d(_ref) {
    let { page: page, itemsPerPage: itemsPerPage, sortBy: sortBy, groupBy: groupBy, search: search } = _ref;
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('VDataTable');
    const options = ()=>({
            page: page.value,
            itemsPerPage: itemsPerPage.value,
            sortBy: sortBy.value,
            groupBy: groupBy.value,
            search: search.value
        });
    let oldOptions = null;
    (0, $01W3b.watch)(options, (value)=>{
        if ((0, $bf1718679e817e1f$export$9cb4719e2e525b7a)(oldOptions, value)) return;
        // Reset page when searching
        if (oldOptions && oldOptions.search !== value.search) page.value = 1;
        vm.emit('update:options', value);
        oldOptions = value;
    }, {
        deep: true,
        immediate: true
    });
}


// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $bf4c535de5649725$export$a02e477b3b971dbd = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    page: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    itemsPerPage: {
        type: [
            Number,
            String
        ],
        default: 10
    },
    pageBy: {
        type: String,
        default: 'any'
    }
}, 'DataTable-paginate');
const $bf4c535de5649725$var$VDataTablePaginationSymbol = Symbol.for('vuetify:data-table-pagination');
function $bf4c535de5649725$export$7f3155e3cda021fd(props) {
    const page = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'page', undefined, (value)=>Number(value ?? 1));
    const itemsPerPage = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'itemsPerPage', undefined, (value)=>Number(value ?? 10));
    return {
        page: page,
        itemsPerPage: itemsPerPage
    };
}
function $bf4c535de5649725$export$5d615e9f3908e3a9(options) {
    const { page: page, itemsPerPage: itemsPerPage, itemsLength: itemsLength } = options;
    const startIndex = (0, $01W3b.computed)(()=>{
        if (itemsPerPage.value === -1) return 0;
        return itemsPerPage.value * (page.value - 1);
    });
    const stopIndex = (0, $01W3b.computed)(()=>{
        if (itemsPerPage.value === -1) return itemsLength.value;
        return Math.min(itemsLength.value, startIndex.value + itemsPerPage.value);
    });
    const pageCount = (0, $01W3b.computed)(()=>{
        if (itemsPerPage.value === -1 || itemsLength.value === 0) return 1;
        return Math.ceil(itemsLength.value / itemsPerPage.value);
    });
    // Don't run immediately, items may not have been loaded yet: #17966
    (0, $01W3b.watch)([
        page,
        pageCount
    ], ()=>{
        if (page.value > pageCount.value) page.value = pageCount.value;
    });
    function setItemsPerPage(value) {
        itemsPerPage.value = value;
        page.value = 1;
    }
    function nextPage() {
        page.value = (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(page.value + 1, 1, pageCount.value);
    }
    function prevPage() {
        page.value = (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(page.value - 1, 1, pageCount.value);
    }
    function setPage(value) {
        page.value = (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(value, 1, pageCount.value);
    }
    const data = {
        page: page,
        itemsPerPage: itemsPerPage,
        startIndex: startIndex,
        stopIndex: stopIndex,
        pageCount: pageCount,
        itemsLength: itemsLength,
        nextPage: nextPage,
        prevPage: prevPage,
        setPage: setPage,
        setItemsPerPage: setItemsPerPage
    };
    (0, $TusQn.provide)($bf4c535de5649725$var$VDataTablePaginationSymbol, data);
    return data;
}
function $bf4c535de5649725$export$f80c710216eae131() {
    const data = (0, $TusQn.inject)($bf4c535de5649725$var$VDataTablePaginationSymbol);
    if (!data) throw new Error('Missing pagination!');
    return data;
}
function $bf4c535de5649725$export$e196d5e55ca1e2d5(options) {
    const vm = (0, $b65c26e77f158b6f$export$f13e630aa3915748)('usePaginatedItems');
    const { items: items, startIndex: startIndex, stopIndex: stopIndex, itemsPerPage: itemsPerPage } = options;
    const paginatedItems = (0, $01W3b.computed)(()=>{
        if (itemsPerPage.value <= 0) return (0, $01W3b.toValue)(items);
        return (0, $01W3b.toValue)(items).slice(startIndex.value, stopIndex.value);
    });
    (0, $01W3b.watch)(paginatedItems, (val)=>{
        vm.emit('update:currentItems', val);
    }, {
        immediate: true
    });
    return {
        paginatedItems: paginatedItems
    };
}
function $bf4c535de5649725$export$a11ce7f683674cd(options) {
    const { sortedItems: sortedItems, paginate: paginate, group: group } = options;
    const pageBy = (0, $01W3b.toValue)(options.pageBy); // TODO: make reactive
    if (pageBy === 'item') {
        const { paginatedItems: paginatedItems, pageCount: pageCount, setItemsPerPage: setItemsPerPage } = paginate(sortedItems);
        const { flatItems: paginatedItemsWithGroups } = group(paginatedItems);
        return {
            pageCount: pageCount,
            setItemsPerPage: setItemsPerPage,
            paginatedItems: paginatedItemsWithGroups
        };
    }
    if (pageBy === 'group') {
        const { flatItems: flatItems, groups: groups } = group(sortedItems);
        const { paginatedItems: paginatedGroups, pageCount: pageCount, setItemsPerPage: setItemsPerPage } = paginate(groups);
        const paginatedItemsWithGroups = (0, $01W3b.computed)(()=>{
            if (!paginatedGroups.value.length) return [];
            const firstGroupId = paginatedGroups.value.at(0).id;
            const lastGroupId = paginatedGroups.value.at(-1).id;
            const start = flatItems.value.findIndex((item)=>item.type === 'group' && item.id === firstGroupId);
            const lastGroupIndex = flatItems.value.findIndex((item)=>item.type === 'group' && item.id === lastGroupId);
            const stop = flatItems.value.findIndex((item, i)=>i > lastGroupIndex && item.type === 'group' && item.depth === 0);
            return flatItems.value.slice(start, stop === -1 ? undefined : stop);
        });
        return {
            pageCount: pageCount,
            setItemsPerPage: setItemsPerPage,
            paginatedItems: paginatedItemsWithGroups
        };
    }
    if (pageBy === 'any') {
        const { flatItems: flatItems } = group(sortedItems);
        const { paginatedItems: paginatedItemsWithGroups, pageCount: pageCount, setItemsPerPage: setItemsPerPage } = paginate(flatItems);
        return {
            pageCount: pageCount,
            setItemsPerPage: setItemsPerPage,
            paginatedItems: paginatedItemsWithGroups
        };
    }
    throw new Error(`Unrecognized pagination target ${pageBy}`);
}


// Composables

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $df9d913850eebaf1$var$singleSelectStrategy = {
    showSelectAll: false,
    allSelected: ()=>[],
    select: (_ref)=>{
        let { items: items, value: value } = _ref;
        return new Set(value ? [
            items[0]?.value
        ] : []);
    },
    selectAll: (_ref2)=>{
        let { selected: selected } = _ref2;
        return selected;
    }
};
const $df9d913850eebaf1$var$pageSelectStrategy = {
    showSelectAll: true,
    allSelected: (_ref3)=>{
        let { currentPage: currentPage } = _ref3;
        return currentPage;
    },
    select: (_ref4)=>{
        let { items: items, value: value, selected: selected } = _ref4;
        for (const item of items)if (value) selected.add(item.value);
        else selected.delete(item.value);
        return selected;
    },
    selectAll: (_ref5)=>{
        let { value: value, currentPage: currentPage, selected: selected } = _ref5;
        return $df9d913850eebaf1$var$pageSelectStrategy.select({
            items: currentPage,
            value: value,
            selected: selected
        });
    }
};
const $df9d913850eebaf1$var$allSelectStrategy = {
    showSelectAll: true,
    allSelected: (_ref6)=>{
        let { allItems: allItems } = _ref6;
        return allItems;
    },
    select: (_ref7)=>{
        let { items: items, value: value, selected: selected } = _ref7;
        for (const item of items)if (value) selected.add(item.value);
        else selected.delete(item.value);
        return selected;
    },
    selectAll: (_ref8)=>{
        let { value: value, allItems: allItems } = _ref8;
        return new Set(value ? allItems.map((item)=>item.value) : []);
    }
};
const $df9d913850eebaf1$export$95e1272f163aea67 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    showSelect: Boolean,
    selectStrategy: {
        type: [
            String,
            Object
        ],
        default: 'page'
    },
    modelValue: {
        type: Array,
        default: ()=>[]
    },
    valueComparator: Function
}, 'DataTable-select');
const $df9d913850eebaf1$export$d1c147632a3c0ba2 = Symbol.for('vuetify:data-table-selection');
function $df9d913850eebaf1$export$c7142f0d6d0f341b(props, _ref9) {
    let { allItems: allItems, currentPage: currentPage } = _ref9;
    const selected = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', props.modelValue, (v)=>{
        const customComparator = props.valueComparator;
        if (customComparator) return new Set((0, $8590040a7833369a$export$76411cac38121ecb)(v).map((v)=>{
            return allItems.value.find((item)=>customComparator(v, item.value))?.value ?? v;
        }));
        return new Set((0, $8590040a7833369a$export$76411cac38121ecb)(v).map((v)=>{
            return (0, $8590040a7833369a$export$c3825b437cbdea5c)(v) ? allItems.value.find((item)=>v === item.value)?.value ?? v : allItems.value.find((item)=>(0, $bf1718679e817e1f$export$9cb4719e2e525b7a)(v, item.value))?.value ?? v;
        }));
    }, (v)=>{
        return [
            ...v.values()
        ];
    });
    const allSelectable = (0, $01W3b.computed)(()=>allItems.value.filter((item)=>item.selectable));
    const currentPageSelectable = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(currentPage).filter((item)=>item.selectable));
    const selectStrategy = (0, $01W3b.computed)(()=>{
        if (typeof props.selectStrategy === 'object') return props.selectStrategy;
        switch(props.selectStrategy){
            case 'single':
                return $df9d913850eebaf1$var$singleSelectStrategy;
            case 'all':
                return $df9d913850eebaf1$var$allSelectStrategy;
            case 'page':
            default:
                return $df9d913850eebaf1$var$pageSelectStrategy;
        }
    });
    const lastSelectedIndex = (0, $01W3b.shallowRef)(null);
    function isSelected(items) {
        return (0, $8590040a7833369a$export$76411cac38121ecb)(items).every((item)=>selected.value.has(item.value));
    }
    function isSomeSelected(items) {
        return (0, $8590040a7833369a$export$76411cac38121ecb)(items).some((item)=>selected.value.has(item.value));
    }
    function select(items, value) {
        const newSelected = selectStrategy.value.select({
            items: items,
            value: value,
            selected: new Set(selected.value)
        });
        selected.value = newSelected;
    }
    function toggleSelect(item, index, event) {
        const items = [];
        const pageItems = (0, $01W3b.toValue)(currentPage);
        index = index ?? pageItems.findIndex((i)=>i.value === item.value);
        if (props.selectStrategy !== 'single' && event?.shiftKey && lastSelectedIndex.value !== null) {
            const [start, end] = [
                lastSelectedIndex.value,
                index
            ].sort((a, b)=>a - b);
            items.push(...pageItems.slice(start, end + 1).filter((item)=>item.selectable));
        } else {
            items.push(item);
            lastSelectedIndex.value = index;
        }
        select(items, !isSelected([
            item
        ]));
    }
    function selectAll(value) {
        const newSelected = selectStrategy.value.selectAll({
            value: value,
            allItems: allSelectable.value,
            currentPage: currentPageSelectable.value,
            selected: new Set(selected.value)
        });
        selected.value = newSelected;
    }
    const someSelected = (0, $01W3b.computed)(()=>selected.value.size > 0);
    const allSelected = (0, $01W3b.computed)(()=>{
        const items = selectStrategy.value.allSelected({
            allItems: allSelectable.value,
            currentPage: currentPageSelectable.value
        });
        return !!items.length && isSelected(items);
    });
    const showSelectAll = (0, $01W3b.toRef)(()=>selectStrategy.value.showSelectAll);
    const data = {
        toggleSelect: toggleSelect,
        select: select,
        selectAll: selectAll,
        isSelected: isSelected,
        isSomeSelected: isSomeSelected,
        someSelected: someSelected,
        allSelected: allSelected,
        showSelectAll: showSelectAll,
        lastSelectedIndex: lastSelectedIndex,
        selectStrategy: selectStrategy
    };
    (0, $TusQn.provide)($df9d913850eebaf1$export$d1c147632a3c0ba2, data);
    return data;
}
function $df9d913850eebaf1$export$a97c3cc4bf1da1ca() {
    const data = (0, $TusQn.inject)($df9d913850eebaf1$export$d1c147632a3c0ba2);
    if (!data) throw new Error('Missing selection!');
    return data;
}


// Composables


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $a13ed0e44b3de083$export$944604c1e22b4d13 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    initialSortOrder: {
        type: String,
        default: 'asc',
        validator: (v)=>!v || [
                'asc',
                'desc'
            ].includes(v)
    },
    sortBy: {
        type: Array,
        default: ()=>[]
    },
    customKeySort: Object,
    multiSort: {
        type: [
            Boolean,
            Object
        ],
        default: false
    },
    mustSort: Boolean
}, 'DataTable-sort');
const $a13ed0e44b3de083$var$VDataTableSortSymbol = Symbol.for('vuetify:data-table-sort');
function $a13ed0e44b3de083$export$10463693a2093403(props) {
    const initialSortOrder = (0, $01W3b.toRef)(()=>props.initialSortOrder);
    const sortBy = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'sortBy');
    const mustSort = (0, $01W3b.toRef)(()=>props.mustSort);
    const multiSort = (0, $01W3b.toRef)(()=>props.multiSort);
    return {
        initialSortOrder: initialSortOrder,
        sortBy: sortBy,
        multiSort: multiSort,
        mustSort: mustSort
    };
}
function $a13ed0e44b3de083$var$resolveMultiSort(multiSort, event) {
    if (!(0, $8590040a7833369a$export$a6cdc56e425d0d0a)(multiSort)) return {
        active: !!multiSort
    };
    const { key: key, mode: mode, modifier: modifier } = multiSort;
    const reverseMode = modifier === 'alt' && event?.altKey || modifier === 'shift' && event?.shiftKey;
    return {
        active: !key || event?.ctrlKey || event?.metaKey || false,
        mode: reverseMode ? mode === 'append' ? 'prepend' : 'append' : mode
    };
}
function $a13ed0e44b3de083$export$ea3d4520bd5f18b7(options) {
    const { initialSortOrder: initialSortOrder, sortBy: sortBy, mustSort: mustSort, multiSort: multiSort, page: page } = options;
    const toggleSort = (column, event)=>{
        if (column.key == null) return;
        let newSortBy = sortBy.value.map((x)=>({
                ...x
            })) ?? [];
        const item = newSortBy.find((x)=>x.key === column.key);
        const initialOrder = initialSortOrder.value;
        const secondaryOrder = initialSortOrder.value === 'desc' ? 'asc' : 'desc';
        if (!item) {
            const { active: active, mode: mode } = $a13ed0e44b3de083$var$resolveMultiSort(multiSort.value, event);
            if (active) {
                if (mode === 'prepend') newSortBy.unshift({
                    key: column.key,
                    order: initialOrder
                });
                else newSortBy.push({
                    key: column.key,
                    order: initialOrder
                });
            } else newSortBy = [
                {
                    key: column.key,
                    order: initialOrder
                }
            ];
        } else if (item.order === secondaryOrder) {
            if (mustSort.value && newSortBy.length === 1) item.order = initialSortOrder.value;
            else newSortBy = newSortBy.filter((x)=>x.key !== column.key);
        } else item.order = secondaryOrder;
        sortBy.value = newSortBy;
        if (page) page.value = 1;
    };
    function isSorted(column) {
        return !!sortBy.value.find((item)=>item.key === column.key);
    }
    const data = {
        sortBy: sortBy,
        toggleSort: toggleSort,
        isSorted: isSorted
    };
    (0, $TusQn.provide)($a13ed0e44b3de083$var$VDataTableSortSymbol, data);
    return data;
}
function $a13ed0e44b3de083$export$6292515ceca0b297() {
    const data = (0, $TusQn.inject)($a13ed0e44b3de083$var$VDataTableSortSymbol);
    if (!data) throw new Error('Missing sort!');
    return data;
}
function $a13ed0e44b3de083$export$3e492f5677b6952c(props, items, sortBy, options) {
    const locale = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
    const sortedItems = (0, $01W3b.computed)(()=>{
        if (!sortBy.value.length) return items.value;
        return $a13ed0e44b3de083$export$6b06fb9375cf2225(items.value, sortBy.value, locale.current.value, {
            transform: options?.transform,
            sortFunctions: {
                ...props.customKeySort,
                ...options?.sortFunctions?.value
            },
            sortRawFunctions: options?.sortRawFunctions?.value
        });
    });
    return {
        sortedItems: sortedItems
    };
}
function $a13ed0e44b3de083$export$6b06fb9375cf2225(items, sortByItems, locale, options) {
    const stringCollator = new Intl.Collator(locale, {
        sensitivity: 'accent',
        usage: 'sort'
    });
    const transformedItems = items.map((item)=>[
            item,
            options?.transform ? options.transform(item) : item
        ]);
    return transformedItems.sort((a, b)=>{
        for(let i = 0; i < sortByItems.length; i++){
            let hasCustomResult = false;
            const sortKey = sortByItems[i].key;
            const sortOrder = sortByItems[i].order ?? 'asc';
            if (sortOrder === false) continue;
            let sortA = (0, $8590040a7833369a$export$f5474208cafa7b66)(a[1], sortKey);
            let sortB = (0, $8590040a7833369a$export$f5474208cafa7b66)(b[1], sortKey);
            let sortARaw = a[0].raw;
            let sortBRaw = b[0].raw;
            if (sortOrder === 'desc') {
                [sortA, sortB] = [
                    sortB,
                    sortA
                ];
                [sortARaw, sortBRaw] = [
                    sortBRaw,
                    sortARaw
                ];
            }
            if (options?.sortRawFunctions?.[sortKey]) {
                const customResult = options.sortRawFunctions[sortKey](sortARaw, sortBRaw);
                if (customResult == null) continue;
                hasCustomResult = true;
                if (customResult) return customResult;
            }
            if (options?.sortFunctions?.[sortKey]) {
                const customResult = options.sortFunctions[sortKey](sortA, sortB);
                if (customResult == null) continue;
                hasCustomResult = true;
                if (customResult) return customResult;
            }
            if (hasCustomResult) continue;
            // Dates should be compared numerically
            if (sortA instanceof Date && sortB instanceof Date) {
                sortA = sortA.getTime();
                sortB = sortB.getTime();
            }
            [sortA, sortB] = [
                sortA,
                sortB
            ].map((s)=>s != null ? s.toString().toLocaleLowerCase() : s);
            if (sortA !== sortB) {
                if ((0, $8590040a7833369a$export$dd1bc94b04021eeb)(sortA) && (0, $8590040a7833369a$export$dd1bc94b04021eeb)(sortB)) return 0;
                if ((0, $8590040a7833369a$export$dd1bc94b04021eeb)(sortA)) return -1;
                if ((0, $8590040a7833369a$export$dd1bc94b04021eeb)(sortB)) return 1;
                if (!isNaN(sortA) && !isNaN(sortB)) return Number(sortA) - Number(sortB);
                return stringCollator.compare(sortA, sortB);
            }
        }
        return 0;
    }).map((_ref)=>{
        let [item] = _ref;
        return item;
    });
}


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $115e220fc8214aac$export$a384df6acd57afc3 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        default: ()=>[]
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'id'
    },
    itemSelectable: {
        type: [
            String,
            Array,
            Function
        ],
        default: null
    },
    returnObject: Boolean
}, 'DataIterator-items');
function $115e220fc8214aac$export$ef3b10464ff5e4ec(props, item) {
    const value = props.returnObject ? item : (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemValue);
    const selectable = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemSelectable, true);
    return {
        type: 'item',
        value: value,
        selectable: selectable,
        raw: item
    };
}
function $115e220fc8214aac$export$f8e983a9ac6ba971(props, items) {
    const array = [];
    for (const item of items)array.push($115e220fc8214aac$export$ef3b10464ff5e4ec(props, item));
    return array;
}
function $115e220fc8214aac$export$a0c659b63ecb3159(props) {
    const items = (0, $01W3b.computed)(()=>$115e220fc8214aac$export$f8e983a9ac6ba971(props, props.items));
    return {
        items: items
    };
}










const $8cdc764877aebc42$export$aa9ffd475fbf48dc = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    search: String,
    loading: Boolean,
    itemsLength: [
        Number,
        String
    ],
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $115e220fc8214aac$export$a384df6acd57afc3)(),
    ...(0, $df9d913850eebaf1$export$95e1272f163aea67)(),
    ...(0, $a13ed0e44b3de083$export$944604c1e22b4d13)(),
    ...(0, $bf4c535de5649725$export$a02e477b3b971dbd)({
        itemsPerPage: 5
    }),
    ...(0, $e1f46a36607fc04a$export$a6d4f3c269410395)(),
    ...(0, $866d0c3f3c648c13$export$406ee928c389045b)(),
    ...(0, $06230a510138477a$export$a99bb5c4eecafb96)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e)({
        transition: {
            component: (0, $7ec1b0ef33b04126$export$13ce8c44634b158c),
            hideOnLeave: true
        }
    })
}, 'VDataIterator');
const $8cdc764877aebc42$export$be5a6c7bb6e0c13d = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDataIterator',
    props: $8cdc764877aebc42$export$aa9ffd475fbf48dc(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:groupBy': (value)=>true,
        'update:page': (value)=>true,
        'update:itemsPerPage': (value)=>true,
        'update:sortBy': (value)=>true,
        'update:options': (value)=>true,
        'update:expanded': (value)=>true,
        'update:currentItems': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const groupBy = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'groupBy');
        const search = (0, $01W3b.toRef)(()=>props.search);
        const { items: items } = (0, $115e220fc8214aac$export$a0c659b63ecb3159)(props);
        const { filteredItems: filteredItems } = (0, $06230a510138477a$export$3274cf84b703fff)(props, items, search, {
            transform: (item)=>item.raw
        });
        const { initialSortOrder: initialSortOrder, sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = (0, $a13ed0e44b3de083$export$10463693a2093403)(props);
        const { page: page, itemsPerPage: itemsPerPage } = (0, $bf4c535de5649725$export$7f3155e3cda021fd)(props);
        const { toggleSort: toggleSort } = (0, $a13ed0e44b3de083$export$ea3d4520bd5f18b7)({
            initialSortOrder: initialSortOrder,
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort,
            page: page
        });
        const { sortByWithGroups: sortByWithGroups, opened: opened, extractRows: extractRows, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup } = (0, $866d0c3f3c648c13$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy
        });
        const { sortedItems: sortedItems } = (0, $a13ed0e44b3de083$export$3e492f5677b6952c)(props, filteredItems, sortByWithGroups, {
            transform: (item)=>item.raw
        });
        const { flatItems: flatItems } = (0, $866d0c3f3c648c13$export$1d90b49b81ed368a)(sortedItems, groupBy, opened, false);
        const manualPagination = (0, $01W3b.toRef)(()=>!(0, $8590040a7833369a$export$dd1bc94b04021eeb)(props.itemsLength));
        const itemsLength = (0, $01W3b.toRef)(()=>manualPagination.value ? Number(props.itemsLength) : flatItems.value.length);
        const { startIndex: startIndex, stopIndex: stopIndex, pageCount: pageCount, prevPage: prevPage, nextPage: nextPage, setItemsPerPage: setItemsPerPage, setPage: setPage } = (0, $bf4c535de5649725$export$5d615e9f3908e3a9)({
            page: page,
            itemsPerPage: itemsPerPage,
            itemsLength: itemsLength
        });
        const paginatedItems = (0, $01W3b.shallowRef)([]);
        const currentItems = (0, $01W3b.computed)(()=>manualPagination.value ? flatItems.value : paginatedItems.value);
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>!manualPagination.value, ()=>{
            const { paginatedItems: items } = (0, $bf4c535de5649725$export$e196d5e55ca1e2d5)({
                items: flatItems,
                startIndex: startIndex,
                stopIndex: stopIndex,
                itemsPerPage: itemsPerPage
            });
            (0, $TusQn.watchEffect)(()=>{
                paginatedItems.value = items.value;
            });
        });
        const currentItemsWithoutGroups = (0, $01W3b.computed)(()=>extractRows(currentItems.value));
        const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect } = (0, $df9d913850eebaf1$export$c7142f0d6d0f341b)(props, {
            allItems: items,
            currentPage: currentItemsWithoutGroups
        });
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $e1f46a36607fc04a$export$6c2637d154b76687)(props);
        (0, $57d3f2dac529a040$export$b8ae39f344200a7d)({
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy,
            groupBy: groupBy,
            search: search
        });
        const slotProps = (0, $01W3b.computed)(()=>({
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                pageCount: pageCount.value,
                toggleSort: toggleSort,
                prevPage: prevPage,
                nextPage: nextPage,
                setPage: setPage,
                setItemsPerPage: setItemsPerPage,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: currentItemsWithoutGroups.value,
                itemsCount: filteredItems.value.length,
                groupedItems: currentItems.value
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-data-iterator',
                    {
                        'v-data-iterator--loading': props.loading
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        slots.header?.(slotProps.value),
                        (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                            "transition": props.transition
                        }, {
                            default: ()=>[
                                    props.loading ? (0, $TusQn.createVNode)((0, $aec6311fd012b86e$export$9a5d46a3538da529), {
                                        "key": "loader",
                                        "name": "v-data-iterator",
                                        "active": true
                                    }, {
                                        default: (slotProps)=>slots.loader?.(slotProps)
                                    }) : (0, $TusQn.createElementVNode)("div", {
                                        "key": "items"
                                    }, [
                                        !currentItems.value.length ? slots['no-data']?.() : slots.default?.(slotProps.value)
                                    ])
                                ]
                        }),
                        slots.footer?.(slotProps.value)
                    ]
            }));
        return {};
    }
});




var $2c7d14fd8421973a$exports = {};

$parcel$export($2c7d14fd8421973a$exports, "VDataTable", () => $a35305d49528e574$export$4cdfcef9678998c7);
$parcel$export($2c7d14fd8421973a$exports, "VDataTableHeaders", () => $b28d463380ae597a$export$c619622075eadff7);
$parcel$export($2c7d14fd8421973a$exports, "VDataTableFooter", () => $f63d1f97304ddede$export$3403786a0c6524a);
$parcel$export($2c7d14fd8421973a$exports, "VDataTableRows", () => $1306576a4a05fde3$export$e10d8e097873db4f);
$parcel$export($2c7d14fd8421973a$exports, "VDataTableRow", () => $1849f4f1aed43755$export$2c0f083ba8593d7);
$parcel$export($2c7d14fd8421973a$exports, "VDataTableVirtual", () => $d466ee2775324617$export$4134771f7c9e4b2);
$parcel$export($2c7d14fd8421973a$exports, "VDataTableServer", () => $67cfece15726b051$export$ad1f17a300f73544);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");











// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");
function $0edf8ce7f3688309$export$14a2d388602b1453() {
    const refs = (0, $01W3b.ref)([]);
    (0, $TusQn.onBeforeUpdate)(()=>refs.value = []);
    function updateRef(e, i) {
        refs.value[i] = e;
    }
    return {
        refs: refs,
        updateRef: updateRef
    };
}









const $bc6c99d39840c0a8$export$fc742cc11f540876 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    activeColor: String,
    start: {
        type: [
            Number,
            String
        ],
        default: 1
    },
    modelValue: {
        type: Number,
        default: (props)=>props.start
    },
    disabled: Boolean,
    length: {
        type: [
            Number,
            String
        ],
        default: 1,
        validator: (val)=>val % 1 === 0
    },
    totalVisible: [
        Number,
        String
    ],
    firstIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$first'
    },
    prevIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$prev'
    },
    nextIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$next'
    },
    lastIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$last'
    },
    ariaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.root'
    },
    pageAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.page'
    },
    currentPageAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.currentPage'
    },
    firstAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.first'
    },
    previousAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.previous'
    },
    nextAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.next'
    },
    lastAriaLabel: {
        type: String,
        default: '$vuetify.pagination.ariaLabel.last'
    },
    ellipsis: {
        type: String,
        default: '...'
    },
    showFirstLastPage: Boolean,
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'nav'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'text'
    })
}, 'VPagination');
const $bc6c99d39840c0a8$export$6353b480ae89e024 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VPagination',
    props: $bc6c99d39840c0a8$export$fc742cc11f540876(),
    emits: {
        'update:modelValue': (value)=>true,
        first: (value)=>true,
        prev: (value)=>true,
        next: (value)=>true,
        last: (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const page = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { t: t, n: n } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { isRtl: isRtl } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { width: width } = (0, $1444e2cf1a712792$export$8406b7efc286d284)();
        const maxButtons = (0, $01W3b.shallowRef)(-1);
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)(undefined, {
            scoped: true
        });
        const { resizeRef: resizeRef } = (0, $d80db15b6452c606$export$683480f191c0e3ea)((entries)=>{
            if (!entries.length) return;
            const { target: target, contentRect: contentRect } = entries[0];
            const firstItem = target.querySelector('.v-pagination__list > *');
            if (!firstItem) return;
            const totalWidth = contentRect.width;
            const itemWidth = firstItem.offsetWidth + parseFloat(getComputedStyle(firstItem).marginRight) * 2;
            maxButtons.value = getMax(totalWidth, itemWidth);
        });
        const length = (0, $01W3b.computed)(()=>parseInt(props.length, 10));
        const start = (0, $01W3b.computed)(()=>parseInt(props.start, 10));
        const totalVisible = (0, $01W3b.computed)(()=>{
            if (props.totalVisible != null) return parseInt(props.totalVisible, 10);
            else if (maxButtons.value >= 0) return maxButtons.value;
            return getMax(width.value, 58);
        });
        function getMax(totalWidth, itemWidth) {
            const minButtons = props.showFirstLastPage ? 5 : 3;
            return Math.max(0, Math.floor(// Round to two decimal places to avoid floating point errors
            Number(((totalWidth - itemWidth * minButtons) / itemWidth).toFixed(2))));
        }
        const range = (0, $01W3b.computed)(()=>{
            if (length.value <= 0 || isNaN(length.value) || length.value > Number.MAX_SAFE_INTEGER) return [];
            if (totalVisible.value <= 0) return [];
            else if (totalVisible.value === 1) return [
                page.value
            ];
            if (length.value <= totalVisible.value) return (0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(length.value, start.value);
            const even = totalVisible.value % 2 === 0;
            const middle = even ? totalVisible.value / 2 : Math.floor(totalVisible.value / 2);
            const left = even ? middle : middle + 1;
            const right = length.value - middle;
            if (left - page.value >= 0) return [
                ...(0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(Math.max(1, totalVisible.value - 1), start.value),
                props.ellipsis,
                length.value
            ];
            else if (page.value - right >= (even ? 1 : 0)) {
                const rangeLength = totalVisible.value - 1;
                const rangeStart = length.value - rangeLength + start.value;
                return [
                    start.value,
                    props.ellipsis,
                    ...(0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(rangeLength, rangeStart)
                ];
            } else {
                const rangeLength = Math.max(1, totalVisible.value - 2);
                const rangeStart = rangeLength === 1 ? page.value : page.value - Math.ceil(rangeLength / 2) + start.value;
                return [
                    start.value,
                    props.ellipsis,
                    ...(0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(rangeLength, rangeStart),
                    props.ellipsis,
                    length.value
                ];
            }
        });
        // TODO: 'first' | 'prev' | 'next' | 'last' does not work here?
        function setValue(e, value, event) {
            e.preventDefault();
            page.value = value;
            event && emit(event, value);
        }
        const { refs: refs, updateRef: updateRef } = (0, $0edf8ce7f3688309$export$14a2d388602b1453)();
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VPaginationBtn: {
                color: (0, $01W3b.toRef)(()=>props.color),
                border: (0, $01W3b.toRef)(()=>props.border),
                density: (0, $01W3b.toRef)(()=>props.density),
                size: (0, $01W3b.toRef)(()=>props.size),
                variant: (0, $01W3b.toRef)(()=>props.variant),
                rounded: (0, $01W3b.toRef)(()=>props.rounded),
                elevation: (0, $01W3b.toRef)(()=>props.elevation)
            }
        });
        const items = (0, $01W3b.computed)(()=>{
            return range.value.map((item, index)=>{
                const ref = (e)=>updateRef(e, index);
                if (typeof item === 'string') return {
                    isActive: false,
                    key: `ellipsis-${index}`,
                    page: item,
                    props: {
                        ref: ref,
                        ellipsis: true,
                        icon: true,
                        disabled: true
                    }
                };
                else {
                    const isActive = item === page.value;
                    return {
                        isActive: isActive,
                        key: item,
                        page: n(item),
                        props: {
                            ref: ref,
                            ellipsis: false,
                            icon: true,
                            disabled: !!props.disabled || Number(props.length) < 2,
                            color: isActive ? props.activeColor : props.color,
                            'aria-current': isActive,
                            'aria-label': t(isActive ? props.currentPageAriaLabel : props.pageAriaLabel, item),
                            onClick: (e)=>setValue(e, item)
                        }
                    };
                }
            });
        });
        const controls = (0, $01W3b.computed)(()=>{
            const prevDisabled = !!props.disabled || page.value <= start.value;
            const nextDisabled = !!props.disabled || page.value >= start.value + length.value - 1;
            return {
                first: props.showFirstLastPage ? {
                    icon: isRtl.value ? props.lastIcon : props.firstIcon,
                    onClick: (e)=>setValue(e, start.value, 'first'),
                    disabled: prevDisabled,
                    'aria-label': t(props.firstAriaLabel),
                    'aria-disabled': prevDisabled
                } : undefined,
                prev: {
                    icon: isRtl.value ? props.nextIcon : props.prevIcon,
                    onClick: (e)=>setValue(e, page.value - 1, 'prev'),
                    disabled: prevDisabled,
                    'aria-label': t(props.previousAriaLabel),
                    'aria-disabled': prevDisabled
                },
                next: {
                    icon: isRtl.value ? props.prevIcon : props.nextIcon,
                    onClick: (e)=>setValue(e, page.value + 1, 'next'),
                    disabled: nextDisabled,
                    'aria-label': t(props.nextAriaLabel),
                    'aria-disabled': nextDisabled
                },
                last: props.showFirstLastPage ? {
                    icon: isRtl.value ? props.firstIcon : props.lastIcon,
                    onClick: (e)=>setValue(e, start.value + length.value - 1, 'last'),
                    disabled: nextDisabled,
                    'aria-label': t(props.lastAriaLabel),
                    'aria-disabled': nextDisabled
                } : undefined
            };
        });
        function updateFocus() {
            const currentIndex = page.value - start.value;
            refs.value[currentIndex]?.$el.focus();
        }
        function onKeydown(e) {
            if (e.key === (0, $8590040a7833369a$export$4f79075d7446a261).left && !props.disabled && page.value > Number(props.start)) {
                page.value = page.value - 1;
                (0, $TusQn.nextTick)(updateFocus);
            } else if (e.key === (0, $8590040a7833369a$export$4f79075d7446a261).right && !props.disabled && page.value < start.value + length.value - 1) {
                page.value = page.value + 1;
                (0, $TusQn.nextTick)(updateFocus);
            }
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "ref": resizeRef,
                "class": (0, $8POXm.normalizeClass)([
                    'v-pagination',
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style),
                "role": "navigation",
                "aria-label": t(props.ariaLabel),
                "onKeydown": onKeydown,
                "data-test": "v-pagination-root"
            }, {
                default: ()=>[
                        (0, $TusQn.createElementVNode)("ul", {
                            "class": "v-pagination__list"
                        }, [
                            props.showFirstLastPage && (0, $TusQn.createElementVNode)("li", {
                                "key": "first",
                                "class": "v-pagination__first",
                                "data-test": "v-pagination-first"
                            }, [
                                slots.first ? slots.first(controls.value.first) : (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                                    "_as": "VPaginationBtn"
                                }, controls.value.first), null)
                            ]),
                            (0, $TusQn.createElementVNode)("li", {
                                "key": "prev",
                                "class": "v-pagination__prev",
                                "data-test": "v-pagination-prev"
                            }, [
                                slots.prev ? slots.prev(controls.value.prev) : (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                                    "_as": "VPaginationBtn"
                                }, controls.value.prev), null)
                            ]),
                            items.value.map((item, index)=>(0, $TusQn.createElementVNode)("li", {
                                    "key": item.key,
                                    "class": (0, $8POXm.normalizeClass)([
                                        'v-pagination__item',
                                        {
                                            'v-pagination__item--is-active': item.isActive
                                        }
                                    ]),
                                    "data-test": "v-pagination-item"
                                }, [
                                    slots.item ? slots.item(item) : (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                                        "_as": "VPaginationBtn"
                                    }, item.props), {
                                        default: ()=>[
                                                item.page
                                            ]
                                    })
                                ])),
                            (0, $TusQn.createElementVNode)("li", {
                                "key": "next",
                                "class": "v-pagination__next",
                                "data-test": "v-pagination-next"
                            }, [
                                slots.next ? slots.next(controls.value.next) : (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                                    "_as": "VPaginationBtn"
                                }, controls.value.next), null)
                            ]),
                            props.showFirstLastPage && (0, $TusQn.createElementVNode)("li", {
                                "key": "last",
                                "class": "v-pagination__last",
                                "data-test": "v-pagination-last"
                            }, [
                                slots.last ? slots.last(controls.value.last) : (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                                    "_as": "VPaginationBtn"
                                }, controls.value.last), null)
                            ])
                        ])
                    ]
            }));
        return {};
    }
});







const $f63d1f97304ddede$export$85788b26c9087beb = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    prevIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$prev'
    },
    nextIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$next'
    },
    firstIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$first'
    },
    lastIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$last'
    },
    itemsPerPageText: {
        type: String,
        default: '$vuetify.dataFooter.itemsPerPageText'
    },
    pageText: {
        type: String,
        default: '$vuetify.dataFooter.pageText'
    },
    firstPageLabel: {
        type: String,
        default: '$vuetify.dataFooter.firstPage'
    },
    prevPageLabel: {
        type: String,
        default: '$vuetify.dataFooter.prevPage'
    },
    nextPageLabel: {
        type: String,
        default: '$vuetify.dataFooter.nextPage'
    },
    lastPageLabel: {
        type: String,
        default: '$vuetify.dataFooter.lastPage'
    },
    itemsPerPageOptions: {
        type: Array,
        default: ()=>[
                {
                    value: 10,
                    title: '10'
                },
                {
                    value: 25,
                    title: '25'
                },
                {
                    value: 50,
                    title: '50'
                },
                {
                    value: 100,
                    title: '100'
                },
                {
                    value: -1,
                    title: '$vuetify.dataFooter.itemsPerPageAll'
                }
            ]
    },
    showCurrentPage: Boolean
}, 'VDataTableFooter');
const $f63d1f97304ddede$export$3403786a0c6524a = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDataTableFooter',
    props: $f63d1f97304ddede$export$85788b26c9087beb(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { page: page, pageCount: pageCount, startIndex: startIndex, stopIndex: stopIndex, itemsLength: itemsLength, itemsPerPage: itemsPerPage, setItemsPerPage: setItemsPerPage } = (0, $bf4c535de5649725$export$f80c710216eae131)();
        const itemsPerPageOptions = (0, $01W3b.computed)(()=>props.itemsPerPageOptions.map((option)=>{
                if (typeof option === 'number') return {
                    value: option,
                    title: option === -1 ? t('$vuetify.dataFooter.itemsPerPageAll') : String(option)
                };
                return {
                    ...option,
                    title: !isNaN(Number(option.title)) ? option.title : t(option.title)
                };
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const paginationProps = (0, $bc6c99d39840c0a8$export$6353b480ae89e024).filterProps(props);
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-data-table-footer"
            }, [
                slots.prepend?.(),
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-data-table-footer__items-per-page"
                }, [
                    (0, $TusQn.createElementVNode)("span", null, [
                        t(props.itemsPerPageText)
                    ]),
                    (0, $TusQn.createVNode)((0, $118e5e4309583a1b$export$1d8182ee812485f5), {
                        "items": itemsPerPageOptions.value,
                        "itemColor": props.color,
                        "modelValue": itemsPerPage.value,
                        "onUpdate:modelValue": (v)=>setItemsPerPage(Number(v)),
                        "density": "compact",
                        "variant": "outlined",
                        "aria-label": t(props.itemsPerPageText),
                        "hideDetails": true
                    }, null)
                ]),
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-data-table-footer__info"
                }, [
                    (0, $TusQn.createElementVNode)("div", null, [
                        t(props.pageText, !itemsLength.value ? 0 : startIndex.value + 1, stopIndex.value, itemsLength.value)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-data-table-footer__pagination"
                }, [
                    (0, $TusQn.createVNode)((0, $bc6c99d39840c0a8$export$6353b480ae89e024), (0, $TusQn.mergeProps)({
                        "modelValue": page.value,
                        "onUpdate:modelValue": ($event)=>page.value = $event,
                        "density": "comfortable",
                        "firstAriaLabel": props.firstPageLabel,
                        "lastAriaLabel": props.lastPageLabel,
                        "length": pageCount.value,
                        "nextAriaLabel": props.nextPageLabel,
                        "previousAriaLabel": props.prevPageLabel,
                        "rounded": true,
                        "showFirstLastPage": true,
                        "totalVisible": props.showCurrentPage ? 1 : 0,
                        "variant": "plain"
                    }, (0, $8590040a7833369a$export$30a06c8d3562193f)(paginationProps, [
                        'color'
                    ])), null)
                ])
            ]);
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

const $a152c5f645d821ba$export$f5a6c4651f7652fe = (0, $2b7aafe61499bf6b$export$c5e8501a3a1b4e53)({
    align: {
        type: String,
        default: 'start'
    },
    fixed: {
        type: [
            Boolean,
            String
        ],
        default: false
    },
    fixedOffset: [
        Number,
        String
    ],
    fixedEndOffset: [
        Number,
        String
    ],
    height: [
        Number,
        String
    ],
    lastFixed: Boolean,
    firstFixedEnd: Boolean,
    noPadding: Boolean,
    indent: [
        Number,
        String
    ],
    empty: Boolean,
    tag: String,
    width: [
        Number,
        String
    ],
    maxWidth: [
        Number,
        String
    ],
    nowrap: Boolean
}, (props, _ref)=>{
    let { slots: slots } = _ref;
    const Tag = props.tag ?? 'td';
    const fixedSide = typeof props.fixed === 'string' ? props.fixed : props.fixed ? 'start' : 'none';
    return (0, $TusQn.createVNode)(Tag, {
        "class": (0, $8POXm.normalizeClass)([
            'v-data-table__td',
            {
                'v-data-table-column--fixed': fixedSide === 'start',
                'v-data-table-column--fixed-end': fixedSide === 'end',
                'v-data-table-column--last-fixed': props.lastFixed,
                'v-data-table-column--first-fixed-end': props.firstFixedEnd,
                'v-data-table-column--no-padding': props.noPadding,
                'v-data-table-column--nowrap': props.nowrap,
                'v-data-table-column--empty': props.empty
            },
            `v-data-table-column--align-${props.align}`
        ]),
        "style": {
            height: (0, $8590040a7833369a$export$286ad215293a0860)(props.height),
            width: (0, $8590040a7833369a$export$286ad215293a0860)(props.width),
            maxWidth: (0, $8590040a7833369a$export$286ad215293a0860)(props.maxWidth),
            left: fixedSide === 'start' ? (0, $8590040a7833369a$export$286ad215293a0860)(props.fixedOffset || null) : undefined,
            right: fixedSide === 'end' ? (0, $8590040a7833369a$export$286ad215293a0860)(props.fixedEndOffset || null) : undefined,
            paddingInlineStart: props.indent ? (0, $8590040a7833369a$export$286ad215293a0860)(props.indent) : undefined
        }
    }, {
        default: ()=>[
                slots.default?.()
            ]
    });
});






// Utilities
parcelRequire("ecd4d");
var $8POXm = parcelRequire("8POXm");
var $TusQn = parcelRequire("TusQn");
var $01W3b = parcelRequire("01W3b");

const $c1b74d7d10506cc2$export$9d1907f8d303b311 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    headers: Array
}, 'DataTable-header');
const $c1b74d7d10506cc2$export$3ab916b4a7fa12ad = Symbol.for('vuetify:data-table-headers');
const $c1b74d7d10506cc2$var$defaultHeader = {
    title: '',
    sortable: false
};
const $c1b74d7d10506cc2$var$defaultActionHeader = {
    ...$c1b74d7d10506cc2$var$defaultHeader,
    width: 48
};
function $c1b74d7d10506cc2$var$priorityQueue() {
    let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const queue = arr.map((element)=>({
            element: element,
            priority: 0
        }));
    return {
        enqueue: (element, priority)=>{
            let added = false;
            for(let i = 0; i < queue.length; i++){
                const item = queue[i];
                if (item.priority > priority) {
                    queue.splice(i, 0, {
                        element: element,
                        priority: priority
                    });
                    added = true;
                    break;
                }
            }
            if (!added) queue.push({
                element: element,
                priority: priority
            });
        },
        size: ()=>queue.length,
        count: ()=>{
            let count = 0;
            if (!queue.length) return 0;
            const whole = Math.floor(queue[0].priority);
            for(let i = 0; i < queue.length; i++)if (Math.floor(queue[i].priority) === whole) count += 1;
            return count;
        },
        dequeue: ()=>{
            return queue.shift();
        }
    };
}
function $c1b74d7d10506cc2$var$extractLeaves(item) {
    let columns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (!item.children) columns.push(item);
    else for (const child of item.children)$c1b74d7d10506cc2$var$extractLeaves(child, columns);
    return columns;
}
function $c1b74d7d10506cc2$var$extractKeys(headers) {
    let keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    for (const item of headers){
        if (item.key) keys.add(item.key);
        if (item.children) $c1b74d7d10506cc2$var$extractKeys(item.children, keys);
    }
    return keys;
}
function $c1b74d7d10506cc2$var$getDefaultItem(item) {
    if (!item.key) return undefined;
    if (item.key === 'data-table-group') return $c1b74d7d10506cc2$var$defaultHeader;
    if ([
        'data-table-expand',
        'data-table-select'
    ].includes(item.key)) return $c1b74d7d10506cc2$var$defaultActionHeader;
    return undefined;
}
function $c1b74d7d10506cc2$var$getDepth(item) {
    let depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!item.children) return depth;
    return Math.max(depth, ...item.children.map((child)=>$c1b74d7d10506cc2$var$getDepth(child, depth + 1)));
}
function $c1b74d7d10506cc2$var$parseFixedColumns(items) {
    let seenFixed = false;
    function setFixed(item, side) {
        let parentFixedSide = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'none';
        if (!item) return;
        if (parentFixedSide !== 'none') item.fixed = parentFixedSide;
        // normalize to simplify logic below
        if (item.fixed === true) item.fixed = 'start';
        if (item.fixed === side) {
            if (item.children) {
                if (side === 'start') for(let i = item.children.length - 1; i >= 0; i--)setFixed(item.children[i], side, side);
                else for(let i = 0; i < item.children.length; i++)setFixed(item.children[i], side, side);
            } else {
                if (!seenFixed && side === 'start') item.lastFixed = true;
                else if (!seenFixed && side === 'end') item.firstFixedEnd = true;
                else if (isNaN(Number(item.width))) (0, $5384ffc78a9e124c$export$bf36f23bad3e1069)(`Multiple fixed columns should have a static width (key: ${item.key})`);
                else item.minWidth = Math.max(Number(item.width) || 0, Number(item.minWidth) || 0);
                seenFixed = true;
            }
        } else if (item.children) {
            if (side === 'start') for(let i = item.children.length - 1; i >= 0; i--)setFixed(item.children[i], side);
            else for(let i = 0; i < item.children.length; i++)setFixed(item.children[i], side);
        } else seenFixed = false;
    }
    for(let i = items.length - 1; i >= 0; i--)setFixed(items[i], 'start');
    for(let i = 0; i < items.length; i++)setFixed(items[i], 'end');
    let fixedOffset = 0;
    for(let i = 0; i < items.length; i++)fixedOffset = $c1b74d7d10506cc2$var$setFixedOffset(items[i], fixedOffset);
    let fixedEndOffset = 0;
    for(let i = items.length - 1; i >= 0; i--)fixedEndOffset = $c1b74d7d10506cc2$var$setFixedEndOffset(items[i], fixedEndOffset);
}
function $c1b74d7d10506cc2$var$setFixedOffset(item) {
    let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!item) return offset;
    if (item.children) {
        item.fixedOffset = offset;
        for (const child of item.children)offset = $c1b74d7d10506cc2$var$setFixedOffset(child, offset);
    } else if (item.fixed && item.fixed !== 'end') {
        item.fixedOffset = offset;
        offset += parseFloat(item.width || '0') || 0;
    }
    return offset;
}
function $c1b74d7d10506cc2$var$setFixedEndOffset(item) {
    let offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    if (!item) return offset;
    if (item.children) {
        item.fixedEndOffset = offset;
        for (const child of item.children)offset = $c1b74d7d10506cc2$var$setFixedEndOffset(child, offset);
    } else if (item.fixed === 'end') {
        item.fixedEndOffset = offset;
        offset += parseFloat(item.width || '0') || 0;
    }
    return offset;
}
function $c1b74d7d10506cc2$var$parse(items, maxDepth) {
    const headers = [];
    let currentDepth = 0;
    const queue = $c1b74d7d10506cc2$var$priorityQueue(items);
    while(queue.size() > 0){
        let rowSize = queue.count();
        const row = [];
        let fraction = 1;
        while(rowSize > 0){
            const { element: item, priority: priority } = queue.dequeue();
            const diff = maxDepth - currentDepth - $c1b74d7d10506cc2$var$getDepth(item);
            row.push({
                ...item,
                rowspan: diff ?? 1,
                colspan: item.children ? $c1b74d7d10506cc2$var$extractLeaves(item).length : 1
            });
            if (item.children) for (const child of item.children){
                // This internally sorts items that are on the same priority "row"
                const sort = priority % 1 + fraction / Math.pow(10, currentDepth + 2);
                queue.enqueue(child, currentDepth + diff + sort);
            }
            fraction += 1;
            rowSize -= 1;
        }
        currentDepth += 1;
        headers.push(row);
    }
    const columns = items.map((item)=>$c1b74d7d10506cc2$var$extractLeaves(item)).flat();
    return {
        columns: columns,
        headers: headers
    };
}
function $c1b74d7d10506cc2$var$convertToInternalHeaders(items) {
    const internalHeaders = [];
    for (const item of items){
        const defaultItem = {
            ...$c1b74d7d10506cc2$var$getDefaultItem(item),
            ...item
        };
        const key = defaultItem.key ?? (typeof defaultItem.value === 'string' ? defaultItem.value : null);
        const value = defaultItem.value ?? key ?? null;
        const internalItem = {
            ...defaultItem,
            key: key,
            value: value,
            sortable: defaultItem.sortable ?? (defaultItem.key != null || !!defaultItem.sort),
            children: defaultItem.children ? $c1b74d7d10506cc2$var$convertToInternalHeaders(defaultItem.children) : undefined
        };
        internalHeaders.push(internalItem);
    }
    return internalHeaders;
}
function $c1b74d7d10506cc2$export$197579c449ddabf4(props, options) {
    const headers = (0, $01W3b.ref)([]);
    const columns = (0, $01W3b.ref)([]);
    const sortFunctions = (0, $01W3b.ref)({});
    const sortRawFunctions = (0, $01W3b.ref)({});
    const filterFunctions = (0, $01W3b.ref)({});
    (0, $TusQn.watchEffect)(()=>{
        const _headers = props.headers || Object.keys(props.items[0] ?? {}).map((key)=>({
                key: key,
                title: (0, $8POXm.capitalize)(key)
            }));
        const items = _headers.slice();
        const keys = $c1b74d7d10506cc2$var$extractKeys(items);
        if (options?.groupBy?.value.length && !keys.has('data-table-group')) items.unshift({
            key: 'data-table-group',
            title: 'Group'
        });
        if (options?.showSelect?.value && !keys.has('data-table-select')) items.unshift({
            key: 'data-table-select'
        });
        if (options?.showExpand?.value && !keys.has('data-table-expand')) items.push({
            key: 'data-table-expand'
        });
        const internalHeaders = $c1b74d7d10506cc2$var$convertToInternalHeaders(items);
        $c1b74d7d10506cc2$var$parseFixedColumns(internalHeaders);
        const maxDepth = Math.max(...internalHeaders.map((item)=>$c1b74d7d10506cc2$var$getDepth(item))) + 1;
        const parsed = $c1b74d7d10506cc2$var$parse(internalHeaders, maxDepth);
        headers.value = parsed.headers;
        columns.value = parsed.columns;
        const flatHeaders = parsed.headers.flat(1);
        for (const header of flatHeaders){
            if (!header.key) continue;
            if (header.sortable) {
                if (header.sort) sortFunctions.value[header.key] = header.sort;
                if (header.sortRaw) sortRawFunctions.value[header.key] = header.sortRaw;
            }
            if (header.filter) filterFunctions.value[header.key] = header.filter;
        }
    });
    const data = {
        headers: headers,
        columns: columns,
        sortFunctions: sortFunctions,
        sortRawFunctions: sortRawFunctions,
        filterFunctions: filterFunctions
    };
    (0, $TusQn.provide)($c1b74d7d10506cc2$export$3ab916b4a7fa12ad, data);
    return data;
}
function $c1b74d7d10506cc2$export$7032d2df28bea3c4() {
    const data = (0, $TusQn.inject)($c1b74d7d10506cc2$export$3ab916b4a7fa12ad);
    if (!data) throw new Error('Missing headers!');
    return data;
}











const $b28d463380ae597a$export$3e579cb6b57f22ae = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    disableSort: Boolean,
    fixedHeader: Boolean,
    multiSort: Boolean,
    initialSortOrder: String,
    sortIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f)
    },
    sortAscIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$sortAsc'
    },
    sortDescIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$sortDesc'
    },
    headerProps: {
        type: Object
    },
    /** @deprecated */ sticky: Boolean,
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $1444e2cf1a712792$export$d0badecb383b472a)(),
    ...(0, $aec6311fd012b86e$export$149f04e0cba4dbc1)()
}, 'VDataTableHeaders');
const $b28d463380ae597a$export$c619622075eadff7 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDataTableHeaders',
    props: $b28d463380ae597a$export$3e579cb6b57f22ae(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { toggleSort: toggleSort, sortBy: sortBy, isSorted: isSorted } = (0, $a13ed0e44b3de083$export$6292515ceca0b297)();
        const { someSelected: someSelected, allSelected: allSelected, selectAll: selectAll, showSelectAll: showSelectAll } = (0, $df9d913850eebaf1$export$a97c3cc4bf1da1ca)();
        const { columns: columns, headers: headers } = (0, $c1b74d7d10506cc2$export$7032d2df28bea3c4)();
        const { loaderClasses: loaderClasses } = (0, $aec6311fd012b86e$export$14095de704efe3f9)(props);
        function getFixedStyles(column, y) {
            if (!(props.sticky || props.fixedHeader) && !column.fixed) return undefined;
            const fixedSide = typeof column.fixed === 'string' ? column.fixed : column.fixed ? 'start' : 'none';
            return {
                position: 'sticky',
                left: fixedSide === 'start' ? (0, $8590040a7833369a$export$286ad215293a0860)(column.fixedOffset) : undefined,
                right: fixedSide === 'end' ? (0, $8590040a7833369a$export$286ad215293a0860)(column.fixedEndOffset) : undefined,
                top: props.sticky || props.fixedHeader ? `calc(var(--v-table-header-height) * ${y})` : undefined
            };
        }
        function handleEnterKeyPress(event, column) {
            if (event.key === 'Enter' && !props.disableSort) toggleSort(column, event);
        }
        function getSortIcon(column) {
            const item = sortBy.value.find((item)=>item.key === column.key);
            switch(item?.order){
                case 'asc':
                    return props.sortAscIcon;
                case 'desc':
                    return props.sortDescIcon;
                default:
                    return props.sortIcon || (props.initialSortOrder === 'asc' ? props.sortAscIcon : props.sortDescIcon);
            }
        }
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { displayClasses: displayClasses, mobile: mobile } = (0, $1444e2cf1a712792$export$8406b7efc286d284)(props);
        const slotProps = (0, $01W3b.computed)(()=>({
                headers: headers.value,
                columns: columns.value,
                toggleSort: toggleSort,
                isSorted: isSorted,
                sortBy: sortBy.value,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                selectAll: selectAll,
                getSortIcon: getSortIcon
            }));
        const headerCellClasses = (0, $01W3b.computed)(()=>[
                'v-data-table__th',
                {
                    'v-data-table__th--sticky': props.sticky || props.fixedHeader
                },
                displayClasses.value,
                loaderClasses.value
            ]);
        const VDataTableHeaderCell = (_ref2)=>{
            let { column: column, x: x, y: y } = _ref2;
            const noPadding = column.key === 'data-table-select' || column.key === 'data-table-expand';
            const isEmpty = column.key === 'data-table-group' && column.width === 0 && !column.title;
            const headerProps = (0, $TusQn.mergeProps)(props.headerProps ?? {}, column.headerProps ?? {});
            return (0, $TusQn.createVNode)((0, $a152c5f645d821ba$export$f5a6c4651f7652fe), (0, $TusQn.mergeProps)({
                "tag": "th",
                "align": column.align,
                "class": [
                    {
                        'v-data-table__th--sortable': column.sortable && !props.disableSort,
                        'v-data-table__th--sorted': isSorted(column),
                        'v-data-table__th--fixed': column.fixed
                    },
                    ...headerCellClasses.value
                ],
                "style": {
                    width: (0, $8590040a7833369a$export$286ad215293a0860)(column.width),
                    minWidth: (0, $8590040a7833369a$export$286ad215293a0860)(column.minWidth),
                    maxWidth: (0, $8590040a7833369a$export$286ad215293a0860)(column.maxWidth),
                    ...getFixedStyles(column, y)
                },
                "colspan": column.colspan,
                "rowspan": column.rowspan,
                "fixed": column.fixed,
                "nowrap": column.nowrap,
                "lastFixed": column.lastFixed,
                "firstFixedEnd": column.firstFixedEnd,
                "noPadding": noPadding,
                "empty": isEmpty,
                "tabindex": column.sortable ? 0 : undefined,
                "onClick": column.sortable ? (event)=>toggleSort(column, event) : undefined,
                "onKeydown": column.sortable ? (event)=>handleEnterKeyPress(event, column) : undefined
            }, headerProps), {
                default: ()=>{
                    const columnSlotName = `header.${column.key}`;
                    const columnSlotProps = {
                        column: column,
                        selectAll: selectAll,
                        isSorted: isSorted,
                        toggleSort: toggleSort,
                        sortBy: sortBy.value,
                        someSelected: someSelected.value,
                        allSelected: allSelected.value,
                        getSortIcon: getSortIcon
                    };
                    if (slots[columnSlotName]) return slots[columnSlotName](columnSlotProps);
                    if (isEmpty) return '';
                    if (column.key === 'data-table-select') return slots['header.data-table-select']?.(columnSlotProps) ?? (showSelectAll.value && (0, $TusQn.createVNode)((0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6), {
                        "color": props.color,
                        "density": props.density,
                        "modelValue": allSelected.value,
                        "indeterminate": someSelected.value && !allSelected.value,
                        "onUpdate:modelValue": selectAll
                    }, null));
                    return (0, $TusQn.createElementVNode)("div", {
                        "class": "v-data-table-header__content"
                    }, [
                        (0, $TusQn.createElementVNode)("span", null, [
                            column.title
                        ]),
                        column.sortable && !props.disableSort && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                            "key": "icon",
                            "class": "v-data-table-header__sort-icon",
                            "icon": getSortIcon(column)
                        }, null),
                        props.multiSort && isSorted(column) && (0, $TusQn.createElementVNode)("div", {
                            "key": "badge",
                            "class": (0, $8POXm.normalizeClass)([
                                'v-data-table-header__sort-badge',
                                ...backgroundColorClasses.value
                            ]),
                            "style": (0, $8POXm.normalizeStyle)(backgroundColorStyles.value)
                        }, [
                            sortBy.value.findIndex((x)=>x.key === column.key) + 1
                        ])
                    ]);
                }
            });
        };
        const VDataTableMobileHeaderCell = ()=>{
            const displayItems = (0, $01W3b.computed)(()=>{
                return columns.value.filter((column)=>column?.sortable && !props.disableSort);
            });
            const showSelectColumn = columns.value.find((column)=>column.key === 'data-table-select');
            return (0, $TusQn.createVNode)((0, $a152c5f645d821ba$export$f5a6c4651f7652fe), (0, $TusQn.mergeProps)({
                "tag": "th",
                "class": [
                    ...headerCellClasses.value
                ],
                "colspan": headers.value.length + 1
            }, props.headerProps), {
                default: ()=>[
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-data-table-header__content"
                        }, [
                            (0, $TusQn.createVNode)((0, $118e5e4309583a1b$export$1d8182ee812485f5), {
                                "chips": true,
                                "color": props.color,
                                "class": "v-data-table__td-sort-select",
                                "clearable": true,
                                "density": "default",
                                "items": displayItems.value,
                                "label": t('$vuetify.dataTable.sortBy'),
                                "multiple": props.multiSort,
                                "variant": "underlined",
                                "onClick:clear": ()=>sortBy.value = []
                            }, {
                                append: showSelectColumn ? ()=>(0, $TusQn.createVNode)((0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6), {
                                        "color": props.color,
                                        "density": "compact",
                                        "modelValue": allSelected.value,
                                        "indeterminate": someSelected.value && !allSelected.value,
                                        "onUpdate:modelValue": ()=>selectAll(!allSelected.value)
                                    }, null) : undefined,
                                chip: (props)=>(0, $TusQn.createVNode)((0, $fd0891698b65ffb1$export$1b5fab12cd17b4fb), {
                                        "onClick": props.item.raw?.sortable ? ()=>toggleSort(props.item.raw) : undefined,
                                        "onMousedown": (e)=>{
                                            e.preventDefault();
                                            e.stopPropagation();
                                        }
                                    }, {
                                        default: ()=>[
                                                props.item.title,
                                                (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                                    "class": (0, $8POXm.normalizeClass)([
                                                        'v-data-table__td-sort-icon',
                                                        isSorted(props.item.raw) && 'v-data-table__td-sort-icon-active'
                                                    ]),
                                                    "icon": getSortIcon(props.item.raw),
                                                    "size": "small"
                                                }, null)
                                            ]
                                    })
                            })
                        ])
                    ]
            });
        };
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return mobile.value ? (0, $TusQn.createElementVNode)("tr", null, [
                (0, $TusQn.createVNode)(VDataTableMobileHeaderCell, null, null)
            ]) : (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                slots.headers ? slots.headers(slotProps.value) : headers.value.map((row, y)=>(0, $TusQn.createElementVNode)("tr", null, [
                        row.map((column, x)=>(0, $TusQn.createVNode)(VDataTableHeaderCell, {
                                "column": column,
                                "x": x,
                                "y": y
                            }, null))
                    ])),
                props.loading && (0, $TusQn.createElementVNode)("tr", {
                    "class": "v-data-table-progress"
                }, [
                    (0, $TusQn.createElementVNode)("th", {
                        "colspan": columns.value.length
                    }, [
                        (0, $TusQn.createVNode)((0, $aec6311fd012b86e$export$9a5d46a3538da529), {
                            "name": "v-data-table-progress",
                            "absolute": true,
                            "active": true,
                            "color": typeof props.loading === 'boolean' || props.loading === 'true' ? props.color : props.loading,
                            "indeterminate": true
                        }, {
                            default: slots.loader
                        })
                    ])
                ])
            ]);
        });
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");









const $2512ee626221076d$export$5943cc4bbec11c64 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    item: {
        type: Object,
        required: true
    },
    groupCollapseIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$tableGroupCollapse'
    },
    groupExpandIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$tableGroupExpand'
    },
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)()
}, 'VDataTableGroupHeaderRow');
const $2512ee626221076d$export$386c218acab36b27 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDataTableGroupHeaderRow',
    props: $2512ee626221076d$export$5943cc4bbec11c64(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { isGroupOpen: isGroupOpen, toggleGroup: toggleGroup, extractRows: extractRows } = (0, $866d0c3f3c648c13$export$c4ec754551fa3ff4)();
        const { isSelected: isSelected, isSomeSelected: isSomeSelected, select: select } = (0, $df9d913850eebaf1$export$a97c3cc4bf1da1ca)();
        const { columns: columns } = (0, $c1b74d7d10506cc2$export$7032d2df28bea3c4)();
        const rows = (0, $01W3b.computed)(()=>{
            return extractRows([
                props.item
            ]);
        });
        const colspan = (0, $01W3b.toRef)(()=>columns.value.length - (columns.value.some((c)=>c.key === 'data-table-select') ? 1 : 0));
        return ()=>(0, $TusQn.createElementVNode)("tr", {
                "class": "v-data-table-group-header-row",
                "style": {
                    '--v-data-table-group-header-row-depth': props.item.depth
                }
            }, [
                columns.value.map((column)=>{
                    if (column.key === 'data-table-group') {
                        const icon = isGroupOpen(props.item) ? props.groupCollapseIcon : props.groupExpandIcon;
                        const onClick = ()=>toggleGroup(props.item);
                        return slots['data-table-group']?.({
                            item: props.item,
                            count: rows.value.length,
                            props: {
                                icon: icon,
                                onClick: onClick
                            }
                        }) ?? (0, $TusQn.createVNode)((0, $a152c5f645d821ba$export$f5a6c4651f7652fe), {
                            "class": "v-data-table-group-header-row__column",
                            "colspan": colspan.value
                        }, {
                            default: ()=>[
                                    (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                                        "size": "small",
                                        "variant": "text",
                                        "icon": icon,
                                        "onClick": onClick
                                    }, null),
                                    (0, $TusQn.createElementVNode)("span", null, [
                                        props.item.value
                                    ]),
                                    (0, $TusQn.createElementVNode)("span", null, [
                                        (0, $TusQn.createTextVNode)("("),
                                        rows.value.length,
                                        (0, $TusQn.createTextVNode)(")")
                                    ])
                                ]
                        });
                    } else if (column.key === 'data-table-select') {
                        const selectableRows = rows.value.filter((x)=>x.selectable);
                        const modelValue = selectableRows.length > 0 && isSelected(selectableRows);
                        const indeterminate = isSomeSelected(selectableRows) && !modelValue;
                        const selectGroup = (v)=>select(selectableRows, v);
                        return slots['data-table-select']?.({
                            props: {
                                modelValue: modelValue,
                                indeterminate: indeterminate,
                                'onUpdate:modelValue': selectGroup
                            }
                        }) ?? (0, $TusQn.createVNode)((0, $a152c5f645d821ba$export$f5a6c4651f7652fe), {
                            "class": "v-data-table__td--select-row",
                            "noPadding": true
                        }, {
                            default: ()=>[
                                    (0, $TusQn.createVNode)((0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6), {
                                        "density": props.density,
                                        "disabled": selectableRows.length === 0,
                                        "modelValue": modelValue,
                                        "indeterminate": indeterminate,
                                        "onUpdate:modelValue": selectGroup
                                    }, null)
                                ]
                        });
                    }
                    return '';
                })
            ]);
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");











const $1849f4f1aed43755$export$5bf56072bb3f07fd = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    index: Number,
    item: Object,
    cellProps: [
        Object,
        Function
    ],
    collapseIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$collapse'
    },
    expandIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$expand'
    },
    onClick: (0, $8590040a7833369a$export$cefab237a347bf23)(),
    onContextmenu: (0, $8590040a7833369a$export$cefab237a347bf23)(),
    onDblclick: (0, $8590040a7833369a$export$cefab237a347bf23)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $1444e2cf1a712792$export$d0badecb383b472a)()
}, 'VDataTableRow');
const $1849f4f1aed43755$export$2c0f083ba8593d7 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDataTableRow',
    props: $1849f4f1aed43755$export$5bf56072bb3f07fd(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { displayClasses: displayClasses, mobile: mobile } = (0, $1444e2cf1a712792$export$8406b7efc286d284)(props, 'v-data-table__tr');
        const { isSelected: isSelected, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected, selectAll: selectAll } = (0, $df9d913850eebaf1$export$a97c3cc4bf1da1ca)();
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $e1f46a36607fc04a$export$7d3f3306ac4d54ef)();
        const { toggleSort: toggleSort, sortBy: sortBy, isSorted: isSorted } = (0, $a13ed0e44b3de083$export$6292515ceca0b297)();
        const { columns: columns } = (0, $c1b74d7d10506cc2$export$7032d2df28bea3c4)();
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("tr", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-data-table__tr',
                    {
                        'v-data-table__tr--clickable': !!(props.onClick || props.onContextmenu || props.onDblclick)
                    },
                    displayClasses.value
                ]),
                "onClick": props.onClick,
                "onContextmenu": props.onContextmenu,
                "onDblclick": props.onDblclick
            }, [
                props.item && columns.value.map((column, i)=>{
                    const item = props.item;
                    const slotName = `item.${column.key}`;
                    const headerSlotName = `header.${column.key}`;
                    const slotProps = {
                        index: props.index,
                        item: item.raw,
                        internalItem: item,
                        value: (0, $8590040a7833369a$export$f5474208cafa7b66)(item.columns, column.key),
                        column: column,
                        isSelected: isSelected,
                        toggleSelect: toggleSelect,
                        isExpanded: isExpanded,
                        toggleExpand: toggleExpand
                    };
                    const columnSlotProps = {
                        column: column,
                        selectAll: selectAll,
                        isSorted: isSorted,
                        toggleSort: toggleSort,
                        sortBy: sortBy.value,
                        someSelected: someSelected.value,
                        allSelected: allSelected.value,
                        getSortIcon: ()=>''
                    };
                    const cellProps = typeof props.cellProps === 'function' ? props.cellProps({
                        index: slotProps.index,
                        item: slotProps.item,
                        internalItem: slotProps.internalItem,
                        value: slotProps.value,
                        column: column
                    }) : props.cellProps;
                    const columnCellProps = typeof column.cellProps === 'function' ? column.cellProps({
                        index: slotProps.index,
                        item: slotProps.item,
                        internalItem: slotProps.internalItem,
                        value: slotProps.value
                    }) : column.cellProps;
                    const noPadding = column.key === 'data-table-select' || column.key === 'data-table-expand';
                    const isEmpty = column.key === 'data-table-group' && column.width === 0 && !column.title;
                    return (0, $TusQn.createVNode)((0, $a152c5f645d821ba$export$f5a6c4651f7652fe), (0, $TusQn.mergeProps)({
                        "align": column.align,
                        "indent": column.indent,
                        "class": {
                            'v-data-table__td--expanded-row': column.key === 'data-table-expand',
                            'v-data-table__td--select-row': column.key === 'data-table-select'
                        },
                        "fixed": column.fixed,
                        "fixedOffset": column.fixedOffset,
                        "fixedEndOffset": column.fixedEndOffset,
                        "lastFixed": column.lastFixed,
                        "firstFixedEnd": column.firstFixedEnd,
                        "maxWidth": !mobile.value ? column.maxWidth : undefined,
                        "noPadding": noPadding,
                        "empty": isEmpty,
                        "nowrap": column.nowrap,
                        "width": !mobile.value ? column.width : undefined
                    }, cellProps, columnCellProps), {
                        default: ()=>{
                            if (column.key === 'data-table-select') return slots['item.data-table-select']?.({
                                ...slotProps,
                                props: {
                                    color: props.color,
                                    disabled: !item.selectable,
                                    modelValue: isSelected([
                                        item
                                    ]),
                                    onClick: (0, $eeJ70.withModifiers)(()=>toggleSelect(item), [
                                        'stop'
                                    ])
                                }
                            }) ?? (0, $TusQn.createVNode)((0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6), {
                                "color": props.color,
                                "disabled": !item.selectable,
                                "density": props.density,
                                "modelValue": isSelected([
                                    item
                                ]),
                                "onClick": (0, $eeJ70.withModifiers)((event)=>toggleSelect(item, props.index, event), [
                                    'stop'
                                ])
                            }, null);
                            if (column.key === 'data-table-expand') return slots['item.data-table-expand']?.({
                                ...slotProps,
                                props: {
                                    icon: isExpanded(item) ? props.collapseIcon : props.expandIcon,
                                    size: 'small',
                                    variant: 'text',
                                    onClick: (0, $eeJ70.withModifiers)(()=>toggleExpand(item), [
                                        'stop'
                                    ])
                                }
                            }) ?? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                                "icon": isExpanded(item) ? props.collapseIcon : props.expandIcon,
                                "size": "small",
                                "variant": "text",
                                "onClick": (0, $eeJ70.withModifiers)(()=>toggleExpand(item), [
                                    'stop'
                                ])
                            }, null);
                            if (slots[slotName] && !mobile.value) return slots[slotName](slotProps);
                            const displayValue = (0, $8POXm.toDisplayString)(slotProps.value);
                            return !mobile.value ? displayValue : (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                (0, $TusQn.createElementVNode)("div", {
                                    "class": "v-data-table__td-title"
                                }, [
                                    slots[headerSlotName]?.(columnSlotProps) ?? column.title
                                ]),
                                (0, $TusQn.createElementVNode)("div", {
                                    "class": "v-data-table__td-value"
                                }, [
                                    slots[slotName]?.(slotProps) ?? displayValue
                                ])
                            ]);
                        }
                    });
                })
            ]));
    }
});









const $1306576a4a05fde3$export$d81faa32148e6046 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    loading: [
        Boolean,
        String
    ],
    loadingText: {
        type: String,
        default: '$vuetify.dataIterator.loadingText'
    },
    hideNoData: Boolean,
    items: {
        type: Array,
        default: ()=>[]
    },
    noDataText: {
        type: String,
        default: '$vuetify.noDataText'
    },
    rowProps: [
        Object,
        Function
    ],
    cellProps: [
        Object,
        Function
    ],
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $1849f4f1aed43755$export$5bf56072bb3f07fd)(), [
        'collapseIcon',
        'expandIcon',
        'density'
    ]),
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $2512ee626221076d$export$5943cc4bbec11c64)(), [
        'groupCollapseIcon',
        'groupExpandIcon',
        'density'
    ]),
    ...(0, $1444e2cf1a712792$export$d0badecb383b472a)()
}, 'VDataTableRows');
const $1306576a4a05fde3$export$e10d8e097873db4f = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDataTableRows',
    inheritAttrs: false,
    props: $1306576a4a05fde3$export$d81faa32148e6046(),
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { columns: columns } = (0, $c1b74d7d10506cc2$export$7032d2df28bea3c4)();
        const { expandOnClick: expandOnClick, toggleExpand: toggleExpand, isExpanded: isExpanded } = (0, $e1f46a36607fc04a$export$7d3f3306ac4d54ef)();
        const { isSelected: isSelected, toggleSelect: toggleSelect } = (0, $df9d913850eebaf1$export$a97c3cc4bf1da1ca)();
        const { toggleGroup: toggleGroup, isGroupOpen: isGroupOpen } = (0, $866d0c3f3c648c13$export$c4ec754551fa3ff4)();
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { mobile: mobile } = (0, $1444e2cf1a712792$export$8406b7efc286d284)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const groupHeaderRowProps = (0, $8590040a7833369a$export$357523c63a2253b9)(props, [
                'groupCollapseIcon',
                'groupExpandIcon',
                'density'
            ]);
            if (props.loading && (!props.items.length || slots.loading)) return (0, $TusQn.createElementVNode)("tr", {
                "class": "v-data-table-rows-loading",
                "key": "loading"
            }, [
                (0, $TusQn.createElementVNode)("td", {
                    "colspan": columns.value.length
                }, [
                    slots.loading?.() ?? t(props.loadingText)
                ])
            ]);
            if (!props.loading && !props.items.length && !props.hideNoData) return (0, $TusQn.createElementVNode)("tr", {
                "class": "v-data-table-rows-no-data",
                "key": "no-data"
            }, [
                (0, $TusQn.createElementVNode)("td", {
                    "colspan": columns.value.length
                }, [
                    slots['no-data']?.() ?? t(props.noDataText)
                ])
            ]);
            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                props.items.map((item, index)=>{
                    if (item.type === 'group') {
                        const slotProps = {
                            index: index,
                            item: item,
                            columns: columns.value,
                            isExpanded: isExpanded,
                            toggleExpand: toggleExpand,
                            isSelected: isSelected,
                            toggleSelect: toggleSelect,
                            toggleGroup: toggleGroup,
                            isGroupOpen: isGroupOpen
                        };
                        return slots['group-header'] ? slots['group-header'](slotProps) : (0, $TusQn.createVNode)((0, $2512ee626221076d$export$386c218acab36b27), (0, $TusQn.mergeProps)({
                            "key": `group-header_${item.id}`,
                            "item": item
                        }, (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':groupHeader', ()=>slotProps), groupHeaderRowProps), slots);
                    }
                    if (item.type === 'group-summary') {
                        const slotProps = {
                            index: index,
                            item: item,
                            columns: columns.value,
                            toggleGroup: toggleGroup
                        };
                        return slots['group-summary']?.(slotProps) ?? '';
                    }
                    const slotProps = {
                        index: item.virtualIndex ?? index,
                        item: item.raw,
                        internalItem: item,
                        columns: columns.value,
                        isExpanded: isExpanded,
                        toggleExpand: toggleExpand,
                        isSelected: isSelected,
                        toggleSelect: toggleSelect
                    };
                    const itemSlotProps = {
                        ...slotProps,
                        props: (0, $TusQn.mergeProps)({
                            key: `item_${item.key ?? item.index}`,
                            onClick: expandOnClick.value ? ()=>{
                                toggleExpand(item);
                            } : undefined,
                            index: index,
                            item: item,
                            color: props.color,
                            cellProps: props.cellProps,
                            collapseIcon: props.collapseIcon,
                            expandIcon: props.expandIcon,
                            density: props.density,
                            mobile: mobile.value
                        }, (0, $ee6bae7c747c9258$export$b5ac16d47f658674)(attrs, ':row', ()=>slotProps), typeof props.rowProps === 'function' ? props.rowProps({
                            item: slotProps.item,
                            index: slotProps.index,
                            internalItem: slotProps.internalItem
                        }) : props.rowProps)
                    };
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), {
                        "key": itemSlotProps.props.key
                    }, [
                        slots.item ? slots.item(itemSlotProps) : (0, $TusQn.createVNode)((0, $1849f4f1aed43755$export$2c0f083ba8593d7), itemSlotProps.props, slots),
                        isExpanded(item) && slots['expanded-row']?.(slotProps)
                    ]);
                })
            ]);
        });
        return {};
    }
});



parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");






const $935374c91796546f$export$ba5ebec34950c99a = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    fixedHeader: Boolean,
    fixedFooter: Boolean,
    height: [
        Number,
        String
    ],
    hover: Boolean,
    striped: {
        type: String,
        default: null,
        validator: (v)=>[
                'even',
                'odd'
            ].includes(v)
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VTable');
const $935374c91796546f$export$95f18d4f6bf10502 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTable',
    props: $935374c91796546f$export$ba5ebec34950c99a(),
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-table',
                    {
                        'v-table--fixed-height': !!props.height,
                        'v-table--fixed-header': props.fixedHeader,
                        'v-table--fixed-footer': props.fixedFooter,
                        'v-table--has-top': !!slots.top,
                        'v-table--has-bottom': !!slots.bottom,
                        'v-table--hover': props.hover,
                        'v-table--striped-even': props.striped === 'even',
                        'v-table--striped-odd': props.striped === 'odd'
                    },
                    themeClasses.value,
                    densityClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        slots.top?.(),
                        slots.default ? (0, $TusQn.createElementVNode)("div", {
                            "class": "v-table__wrapper",
                            "style": {
                                height: (0, $8590040a7833369a$export$286ad215293a0860)(props.height)
                            }
                        }, [
                            (0, $TusQn.createElementVNode)("table", null, [
                                slots.default()
                            ])
                        ]) : slots.wrapper?.(),
                        slots.bottom?.()
                    ]
            }));
        return {};
    }
});





// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $9b056c1c6ce8852e$export$6d88ad3df0986562 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    items: {
        type: Array,
        default: ()=>[]
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'id'
    },
    itemSelectable: {
        type: [
            String,
            Array,
            Function
        ],
        default: null
    },
    rowProps: [
        Object,
        Function
    ],
    cellProps: [
        Object,
        Function
    ],
    returnObject: Boolean
}, 'DataTable-items');
function $9b056c1c6ce8852e$export$ef3b10464ff5e4ec(props, item, index, columns) {
    const value = props.returnObject ? item : (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemValue);
    const selectable = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemSelectable, true);
    const itemColumns = columns.reduce((obj, column)=>{
        if (column.key != null) obj[column.key] = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, column.value);
        return obj;
    }, {});
    return {
        type: 'item',
        key: props.returnObject ? (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemValue) : value,
        index: index,
        value: value,
        selectable: selectable,
        columns: itemColumns,
        raw: item
    };
}
function $9b056c1c6ce8852e$export$f8e983a9ac6ba971(props, items, columns) {
    return items.map((item, index)=>$9b056c1c6ce8852e$export$ef3b10464ff5e4ec(props, item, index, columns));
}
function $9b056c1c6ce8852e$export$c7173575102352f3(props, columns) {
    const items = (0, $01W3b.computed)(()=>$9b056c1c6ce8852e$export$f8e983a9ac6ba971(props, props.items, columns.value));
    return {
        items: items
    };
}









const $a35305d49528e574$export$26a5caa325bbad53 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $1306576a4a05fde3$export$d81faa32148e6046)(),
    hideDefaultBody: Boolean,
    hideDefaultFooter: Boolean,
    hideDefaultHeader: Boolean,
    width: [
        String,
        Number
    ],
    search: String,
    ...(0, $e1f46a36607fc04a$export$a6d4f3c269410395)(),
    ...(0, $866d0c3f3c648c13$export$406ee928c389045b)(),
    ...(0, $c1b74d7d10506cc2$export$9d1907f8d303b311)(),
    ...(0, $9b056c1c6ce8852e$export$6d88ad3df0986562)(),
    ...(0, $df9d913850eebaf1$export$95e1272f163aea67)(),
    ...(0, $a13ed0e44b3de083$export$944604c1e22b4d13)(),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $b28d463380ae597a$export$3e579cb6b57f22ae)(), [
        'multiSort',
        'initialSortOrder'
    ]),
    ...(0, $935374c91796546f$export$ba5ebec34950c99a)()
}, 'DataTable');
const $a35305d49528e574$export$42ac5235dc91d9ce = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $bf4c535de5649725$export$a02e477b3b971dbd)(),
    ...$a35305d49528e574$export$26a5caa325bbad53(),
    ...(0, $06230a510138477a$export$a99bb5c4eecafb96)(),
    ...(0, $f63d1f97304ddede$export$85788b26c9087beb)()
}, 'VDataTable');
const $a35305d49528e574$export$4cdfcef9678998c7 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDataTable',
    props: $a35305d49528e574$export$42ac5235dc91d9ce(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:page': (value)=>true,
        'update:itemsPerPage': (value)=>true,
        'update:sortBy': (value)=>true,
        'update:options': (value)=>true,
        'update:groupBy': (value)=>true,
        'update:expanded': (value)=>true,
        'update:currentItems': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { groupBy: groupBy } = (0, $866d0c3f3c648c13$export$543cf685fafb29db)(props);
        const { initialSortOrder: initialSortOrder, sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = (0, $a13ed0e44b3de083$export$10463693a2093403)(props);
        const { page: page, itemsPerPage: itemsPerPage } = (0, $bf4c535de5649725$export$7f3155e3cda021fd)(props);
        const { disableSort: disableSort } = (0, $01W3b.toRefs)(props);
        const { columns: columns, headers: headers, sortFunctions: sortFunctions, sortRawFunctions: sortRawFunctions, filterFunctions: filterFunctions } = (0, $c1b74d7d10506cc2$export$197579c449ddabf4)(props, {
            groupBy: groupBy,
            showSelect: (0, $01W3b.toRef)(()=>props.showSelect),
            showExpand: (0, $01W3b.toRef)(()=>props.showExpand)
        });
        const { items: items } = (0, $9b056c1c6ce8852e$export$c7173575102352f3)(props, columns);
        const search = (0, $01W3b.toRef)(()=>props.search);
        const { filteredItems: filteredItems } = (0, $06230a510138477a$export$3274cf84b703fff)(props, items, search, {
            transform: (item)=>item.columns,
            customKeyFilter: filterFunctions
        });
        const { toggleSort: toggleSort } = (0, $a13ed0e44b3de083$export$ea3d4520bd5f18b7)({
            initialSortOrder: initialSortOrder,
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort,
            page: page
        });
        const { sortByWithGroups: sortByWithGroups, opened: opened, extractRows: extractRows, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup } = (0, $866d0c3f3c648c13$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy,
            disableSort: disableSort
        });
        const { sortedItems: sortedItems } = (0, $a13ed0e44b3de083$export$3e492f5677b6952c)(props, filteredItems, sortByWithGroups, {
            transform: (item)=>({
                    ...item.raw,
                    ...item.columns
                }),
            sortFunctions: sortFunctions,
            sortRawFunctions: sortRawFunctions
        });
        const pageBy = (0, $01W3b.computed)(()=>{
            if (props.pageBy === 'auto') return props.groupBy.length ? 'group' : 'item';
            return props.pageBy;
        });
        const { pageCount: pageCount, setItemsPerPage: setItemsPerPage, paginatedItems: paginatedItems } = (0, $bf4c535de5649725$export$a11ce7f683674cd)({
            pageBy: pageBy,
            sortedItems: sortedItems,
            paginate: (items)=>{
                const itemsLength = (0, $01W3b.computed)(()=>(0, $01W3b.toValue)(items).length);
                const { startIndex: startIndex, stopIndex: stopIndex, pageCount: pageCount, setItemsPerPage: setItemsPerPage } = (0, $bf4c535de5649725$export$5d615e9f3908e3a9)({
                    page: page,
                    itemsPerPage: itemsPerPage,
                    itemsLength: itemsLength
                });
                const { paginatedItems: paginatedItems } = (0, $bf4c535de5649725$export$e196d5e55ca1e2d5)({
                    items: items,
                    startIndex: startIndex,
                    stopIndex: stopIndex,
                    itemsPerPage: itemsPerPage
                });
                return {
                    paginatedItems: paginatedItems,
                    pageCount: pageCount,
                    setItemsPerPage: setItemsPerPage
                };
            },
            group: (items)=>(0, $866d0c3f3c648c13$export$1d90b49b81ed368a)(items, groupBy, opened, ()=>!!slots['group-summary'])
        });
        const paginatedItemsWithoutGroups = (0, $01W3b.computed)(()=>extractRows(paginatedItems.value));
        const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected } = (0, $df9d913850eebaf1$export$c7142f0d6d0f341b)(props, {
            allItems: items,
            currentPage: paginatedItemsWithoutGroups
        });
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $e1f46a36607fc04a$export$6c2637d154b76687)(props);
        (0, $57d3f2dac529a040$export$b8ae39f344200a7d)({
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy,
            groupBy: groupBy,
            search: search
        });
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VDataTableRows: {
                hideNoData: (0, $01W3b.toRef)(()=>props.hideNoData),
                noDataText: (0, $01W3b.toRef)(()=>props.noDataText),
                loading: (0, $01W3b.toRef)(()=>props.loading),
                loadingText: (0, $01W3b.toRef)(()=>props.loadingText)
            }
        });
        const slotProps = (0, $01W3b.computed)(()=>({
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                pageCount: pageCount.value,
                toggleSort: toggleSort,
                setItemsPerPage: setItemsPerPage,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: paginatedItemsWithoutGroups.value.map((item)=>item.raw),
                internalItems: paginatedItemsWithoutGroups.value,
                groupedItems: paginatedItems.value,
                columns: columns.value,
                headers: headers.value
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const dataTableFooterProps = (0, $f63d1f97304ddede$export$3403786a0c6524a).filterProps(props);
            const dataTableHeadersProps = (0, $b28d463380ae597a$export$c619622075eadff7).filterProps((0, $8590040a7833369a$export$30a06c8d3562193f)(props, [
                'multiSort'
            ]));
            const dataTableRowsProps = (0, $1306576a4a05fde3$export$e10d8e097873db4f).filterProps(props);
            const tableProps = (0, $935374c91796546f$export$95f18d4f6bf10502).filterProps(props);
            return (0, $TusQn.createVNode)((0, $935374c91796546f$export$95f18d4f6bf10502), (0, $TusQn.mergeProps)({
                "class": [
                    'v-data-table',
                    {
                        'v-data-table--show-select': props.showSelect,
                        'v-data-table--loading': props.loading
                    },
                    props.class
                ],
                "style": props.style
            }, tableProps, {
                "fixedHeader": props.fixedHeader || props.sticky
            }), {
                top: ()=>slots.top?.(slotProps.value),
                default: ()=>slots.default ? slots.default(slotProps.value) : (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots.colgroup?.(slotProps.value),
                        !props.hideDefaultHeader && (0, $TusQn.createElementVNode)("thead", {
                            "key": "thead"
                        }, [
                            (0, $TusQn.createVNode)((0, $b28d463380ae597a$export$c619622075eadff7), (0, $TusQn.mergeProps)(dataTableHeadersProps, {
                                "multiSort": !!props.multiSort
                            }), slots)
                        ]),
                        slots.thead?.(slotProps.value),
                        !props.hideDefaultBody && (0, $TusQn.createElementVNode)("tbody", null, [
                            slots['body.prepend']?.(slotProps.value),
                            slots.body ? slots.body(slotProps.value) : (0, $TusQn.createVNode)((0, $1306576a4a05fde3$export$e10d8e097873db4f), (0, $TusQn.mergeProps)(attrs, dataTableRowsProps, {
                                "items": paginatedItems.value
                            }), slots),
                            slots['body.append']?.(slotProps.value)
                        ]),
                        slots.tbody?.(slotProps.value),
                        slots.tfoot?.(slotProps.value)
                    ]),
                bottom: ()=>slots.bottom ? slots.bottom(slotProps.value) : !props.hideDefaultFooter && (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), null, null),
                        (0, $TusQn.createVNode)((0, $f63d1f97304ddede$export$3403786a0c6524a), dataTableFooterProps, {
                            prepend: slots['footer.prepend']
                        })
                    ])
            });
        });
        return {};
    }
});






parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

















const $d466ee2775324617$export$56a6c8c912094255 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $a35305d49528e574$export$26a5caa325bbad53)(), [
        'hideDefaultFooter'
    ]),
    ...(0, $866d0c3f3c648c13$export$406ee928c389045b)(),
    ...(0, $8af1531278c9785d$export$7703b7ab4acf2c49)(),
    ...(0, $06230a510138477a$export$a99bb5c4eecafb96)()
}, 'VDataTableVirtual');
const $d466ee2775324617$export$4134771f7c9e4b2 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDataTableVirtual',
    props: $d466ee2775324617$export$56a6c8c912094255(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:sortBy': (value)=>true,
        'update:options': (value)=>true,
        'update:groupBy': (value)=>true,
        'update:expanded': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { groupBy: groupBy } = (0, $866d0c3f3c648c13$export$543cf685fafb29db)(props);
        const { initialSortOrder: initialSortOrder, sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = (0, $a13ed0e44b3de083$export$10463693a2093403)(props);
        const { disableSort: disableSort } = (0, $01W3b.toRefs)(props);
        const { columns: columns, headers: headers, filterFunctions: filterFunctions, sortFunctions: sortFunctions, sortRawFunctions: sortRawFunctions } = (0, $c1b74d7d10506cc2$export$197579c449ddabf4)(props, {
            groupBy: groupBy,
            showSelect: (0, $01W3b.toRef)(()=>props.showSelect),
            showExpand: (0, $01W3b.toRef)(()=>props.showExpand)
        });
        const { items: items } = (0, $9b056c1c6ce8852e$export$c7173575102352f3)(props, columns);
        const search = (0, $01W3b.toRef)(()=>props.search);
        const { filteredItems: filteredItems } = (0, $06230a510138477a$export$3274cf84b703fff)(props, items, search, {
            transform: (item)=>item.columns,
            customKeyFilter: filterFunctions
        });
        const { toggleSort: toggleSort } = (0, $a13ed0e44b3de083$export$ea3d4520bd5f18b7)({
            initialSortOrder: initialSortOrder,
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort
        });
        const { sortByWithGroups: sortByWithGroups, opened: opened, extractRows: extractRows, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup } = (0, $866d0c3f3c648c13$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy,
            disableSort: disableSort
        });
        const { sortedItems: sortedItems } = (0, $a13ed0e44b3de083$export$3e492f5677b6952c)(props, filteredItems, sortByWithGroups, {
            transform: (item)=>({
                    ...item.raw,
                    ...item.columns
                }),
            sortFunctions: sortFunctions,
            sortRawFunctions: sortRawFunctions
        });
        const { flatItems: flatItems } = (0, $866d0c3f3c648c13$export$1d90b49b81ed368a)(sortedItems, groupBy, opened, ()=>!!slots['group-summary']);
        const allItems = (0, $01W3b.computed)(()=>extractRows(flatItems.value));
        const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected } = (0, $df9d913850eebaf1$export$c7142f0d6d0f341b)(props, {
            allItems: allItems,
            currentPage: allItems
        });
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $e1f46a36607fc04a$export$6c2637d154b76687)(props);
        const { containerRef: containerRef, markerRef: markerRef, paddingTop: paddingTop, paddingBottom: paddingBottom, computedItems: computedItems, handleItemResize: handleItemResize, handleScroll: handleScroll, handleScrollend: handleScrollend, calculateVisibleItems: calculateVisibleItems, scrollToIndex: scrollToIndex } = (0, $8af1531278c9785d$export$ebc1863da693699a)(props, flatItems);
        const displayItems = (0, $01W3b.computed)(()=>computedItems.value.map((item)=>({
                    ...item.raw,
                    virtualIndex: item.index
                })));
        (0, $57d3f2dac529a040$export$b8ae39f344200a7d)({
            sortBy: sortBy,
            page: (0, $01W3b.shallowRef)(1),
            itemsPerPage: (0, $01W3b.shallowRef)(-1),
            groupBy: groupBy,
            search: search
        });
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VDataTableRows: {
                hideNoData: (0, $01W3b.toRef)(()=>props.hideNoData),
                noDataText: (0, $01W3b.toRef)(()=>props.noDataText),
                loading: (0, $01W3b.toRef)(()=>props.loading),
                loadingText: (0, $01W3b.toRef)(()=>props.loadingText)
            }
        });
        const slotProps = (0, $01W3b.computed)(()=>({
                sortBy: sortBy.value,
                toggleSort: toggleSort,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: allItems.value.map((item)=>item.raw),
                internalItems: allItems.value,
                groupedItems: flatItems.value,
                columns: columns.value,
                headers: headers.value
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const dataTableHeadersProps = (0, $b28d463380ae597a$export$c619622075eadff7).filterProps((0, $8590040a7833369a$export$30a06c8d3562193f)(props, [
                'multiSort'
            ]));
            const dataTableRowsProps = (0, $1306576a4a05fde3$export$e10d8e097873db4f).filterProps(props);
            const tableProps = (0, $935374c91796546f$export$95f18d4f6bf10502).filterProps(props);
            return (0, $TusQn.createVNode)((0, $935374c91796546f$export$95f18d4f6bf10502), (0, $TusQn.mergeProps)({
                "class": [
                    'v-data-table',
                    {
                        'v-data-table--loading': props.loading
                    },
                    props.class
                ],
                "style": props.style
            }, tableProps, {
                "fixedHeader": props.fixedHeader || props.sticky
            }), {
                top: ()=>slots.top?.(slotProps.value),
                wrapper: ()=>(0, $TusQn.createElementVNode)("div", {
                        "ref": containerRef,
                        "onScrollPassive": handleScroll,
                        "onScrollend": handleScrollend,
                        "class": "v-table__wrapper",
                        "style": {
                            height: (0, $8590040a7833369a$export$286ad215293a0860)(props.height)
                        }
                    }, [
                        (0, $TusQn.createElementVNode)("table", null, [
                            slots.colgroup?.(slotProps.value),
                            !props.hideDefaultHeader && (0, $TusQn.createElementVNode)("thead", {
                                "key": "thead"
                            }, [
                                (0, $TusQn.createVNode)((0, $b28d463380ae597a$export$c619622075eadff7), (0, $TusQn.mergeProps)(dataTableHeadersProps, {
                                    "multiSort": !!props.multiSort
                                }), slots)
                            ]),
                            slots.thead?.(slotProps.value),
                            !props.hideDefaultBody && (0, $TusQn.createElementVNode)("tbody", {
                                "key": "tbody"
                            }, [
                                (0, $TusQn.createElementVNode)("tr", {
                                    "ref": markerRef,
                                    "style": {
                                        height: (0, $8590040a7833369a$export$286ad215293a0860)(paddingTop.value),
                                        border: 0
                                    }
                                }, [
                                    (0, $TusQn.createElementVNode)("td", {
                                        "colspan": columns.value.length,
                                        "style": {
                                            height: 0,
                                            border: 0
                                        }
                                    }, null)
                                ]),
                                slots['body.prepend']?.(slotProps.value),
                                (0, $TusQn.createVNode)((0, $1306576a4a05fde3$export$e10d8e097873db4f), (0, $TusQn.mergeProps)(attrs, dataTableRowsProps, {
                                    "items": displayItems.value
                                }), {
                                    ...slots,
                                    item: (itemSlotProps)=>(0, $TusQn.createVNode)((0, $0b8f4225788ce420$export$e996ecbe8aa756e9), {
                                            "key": itemSlotProps.internalItem.index,
                                            "renderless": true,
                                            "onUpdate:height": (height)=>handleItemResize(itemSlotProps.internalItem.index, height)
                                        }, {
                                            default: (_ref2)=>{
                                                let { itemRef: itemRef } = _ref2;
                                                return slots.item?.({
                                                    ...itemSlotProps,
                                                    itemRef: itemRef
                                                }) ?? (0, $TusQn.createVNode)((0, $1849f4f1aed43755$export$2c0f083ba8593d7), (0, $TusQn.mergeProps)(itemSlotProps.props, {
                                                    "ref": itemRef,
                                                    "key": itemSlotProps.internalItem.index,
                                                    "index": itemSlotProps.index
                                                }), slots);
                                            }
                                        })
                                }),
                                slots['body.append']?.(slotProps.value),
                                (0, $TusQn.createElementVNode)("tr", {
                                    "style": {
                                        height: (0, $8590040a7833369a$export$286ad215293a0860)(paddingBottom.value),
                                        border: 0
                                    }
                                }, [
                                    (0, $TusQn.createElementVNode)("td", {
                                        "colspan": columns.value.length,
                                        "style": {
                                            height: 0,
                                            border: 0
                                        }
                                    }, null)
                                ])
                            ]),
                            slots.tbody?.(slotProps.value),
                            slots.tfoot?.(slotProps.value)
                        ])
                    ]),
                bottom: ()=>slots.bottom?.(slotProps.value)
            });
        });
        return {
            calculateVisibleItems: calculateVisibleItems,
            scrollToIndex: scrollToIndex
        };
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
















const $67cfece15726b051$export$acc72a1badefcde3 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    itemsLength: {
        type: [
            Number,
            String
        ],
        required: true
    },
    ...(0, $bf4c535de5649725$export$a02e477b3b971dbd)(),
    ...(0, $a35305d49528e574$export$26a5caa325bbad53)(),
    ...(0, $f63d1f97304ddede$export$85788b26c9087beb)()
}, 'VDataTableServer');
const $67cfece15726b051$export$ad1f17a300f73544 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDataTableServer',
    props: $67cfece15726b051$export$acc72a1badefcde3(),
    emits: {
        'update:modelValue': (value)=>true,
        'update:page': (page)=>true,
        'update:itemsPerPage': (page)=>true,
        'update:sortBy': (sortBy)=>true,
        'update:options': (options)=>true,
        'update:expanded': (options)=>true,
        'update:groupBy': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { groupBy: groupBy } = (0, $866d0c3f3c648c13$export$543cf685fafb29db)(props);
        const { initialSortOrder: initialSortOrder, sortBy: sortBy, multiSort: multiSort, mustSort: mustSort } = (0, $a13ed0e44b3de083$export$10463693a2093403)(props);
        const { page: page, itemsPerPage: itemsPerPage } = (0, $bf4c535de5649725$export$7f3155e3cda021fd)(props);
        const { disableSort: disableSort } = (0, $01W3b.toRefs)(props);
        const itemsLength = (0, $01W3b.computed)(()=>parseInt(props.itemsLength, 10));
        const { columns: columns, headers: headers } = (0, $c1b74d7d10506cc2$export$197579c449ddabf4)(props, {
            groupBy: groupBy,
            showSelect: (0, $01W3b.toRef)(()=>props.showSelect),
            showExpand: (0, $01W3b.toRef)(()=>props.showExpand)
        });
        const { items: items } = (0, $9b056c1c6ce8852e$export$c7173575102352f3)(props, columns);
        const { toggleSort: toggleSort } = (0, $a13ed0e44b3de083$export$ea3d4520bd5f18b7)({
            initialSortOrder: initialSortOrder,
            sortBy: sortBy,
            multiSort: multiSort,
            mustSort: mustSort,
            page: page
        });
        const { opened: opened, isGroupOpen: isGroupOpen, toggleGroup: toggleGroup, extractRows: extractRows } = (0, $866d0c3f3c648c13$export$93a5542df6d97bc8)({
            groupBy: groupBy,
            sortBy: sortBy,
            disableSort: disableSort
        });
        const { pageCount: pageCount, setItemsPerPage: setItemsPerPage } = (0, $bf4c535de5649725$export$5d615e9f3908e3a9)({
            page: page,
            itemsPerPage: itemsPerPage,
            itemsLength: itemsLength
        });
        const { flatItems: flatItems } = (0, $866d0c3f3c648c13$export$1d90b49b81ed368a)(items, groupBy, opened, ()=>!!slots['group-summary']);
        const { isSelected: isSelected, select: select, selectAll: selectAll, toggleSelect: toggleSelect, someSelected: someSelected, allSelected: allSelected } = (0, $df9d913850eebaf1$export$c7142f0d6d0f341b)(props, {
            allItems: items,
            currentPage: items
        });
        const { isExpanded: isExpanded, toggleExpand: toggleExpand } = (0, $e1f46a36607fc04a$export$6c2637d154b76687)(props);
        const itemsWithoutGroups = (0, $01W3b.computed)(()=>extractRows(items.value));
        (0, $57d3f2dac529a040$export$b8ae39f344200a7d)({
            page: page,
            itemsPerPage: itemsPerPage,
            sortBy: sortBy,
            groupBy: groupBy,
            search: (0, $01W3b.toRef)(()=>props.search)
        });
        (0, $TusQn.provide)('v-data-table', {
            toggleSort: toggleSort,
            sortBy: sortBy
        });
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VDataTableRows: {
                hideNoData: (0, $01W3b.toRef)(()=>props.hideNoData),
                noDataText: (0, $01W3b.toRef)(()=>props.noDataText),
                loading: (0, $01W3b.toRef)(()=>props.loading),
                loadingText: (0, $01W3b.toRef)(()=>props.loadingText)
            }
        });
        const slotProps = (0, $01W3b.computed)(()=>({
                page: page.value,
                itemsPerPage: itemsPerPage.value,
                sortBy: sortBy.value,
                pageCount: pageCount.value,
                toggleSort: toggleSort,
                setItemsPerPage: setItemsPerPage,
                someSelected: someSelected.value,
                allSelected: allSelected.value,
                isSelected: isSelected,
                select: select,
                selectAll: selectAll,
                toggleSelect: toggleSelect,
                isExpanded: isExpanded,
                toggleExpand: toggleExpand,
                isGroupOpen: isGroupOpen,
                toggleGroup: toggleGroup,
                items: itemsWithoutGroups.value.map((item)=>item.raw),
                internalItems: itemsWithoutGroups.value,
                groupedItems: flatItems.value,
                columns: columns.value,
                headers: headers.value
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const dataTableFooterProps = (0, $f63d1f97304ddede$export$3403786a0c6524a).filterProps(props);
            const dataTableHeadersProps = (0, $b28d463380ae597a$export$c619622075eadff7).filterProps((0, $8590040a7833369a$export$30a06c8d3562193f)(props, [
                'multiSort'
            ]));
            const dataTableRowsProps = (0, $1306576a4a05fde3$export$e10d8e097873db4f).filterProps(props);
            const tableProps = (0, $935374c91796546f$export$95f18d4f6bf10502).filterProps(props);
            return (0, $TusQn.createVNode)((0, $935374c91796546f$export$95f18d4f6bf10502), (0, $TusQn.mergeProps)({
                "class": [
                    'v-data-table',
                    {
                        'v-data-table--loading': props.loading
                    },
                    props.class
                ],
                "style": props.style
            }, tableProps, {
                "fixedHeader": props.fixedHeader || props.sticky
            }), {
                top: ()=>slots.top?.(slotProps.value),
                default: ()=>slots.default ? slots.default(slotProps.value) : (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots.colgroup?.(slotProps.value),
                        !props.hideDefaultHeader && (0, $TusQn.createElementVNode)("thead", {
                            "key": "thead",
                            "class": "v-data-table__thead",
                            "role": "rowgroup"
                        }, [
                            (0, $TusQn.createVNode)((0, $b28d463380ae597a$export$c619622075eadff7), (0, $TusQn.mergeProps)(dataTableHeadersProps, {
                                "multiSort": !!props.multiSort
                            }), slots)
                        ]),
                        slots.thead?.(slotProps.value),
                        !props.hideDefaultBody && (0, $TusQn.createElementVNode)("tbody", {
                            "class": "v-data-table__tbody",
                            "role": "rowgroup"
                        }, [
                            slots['body.prepend']?.(slotProps.value),
                            slots.body ? slots.body(slotProps.value) : (0, $TusQn.createVNode)((0, $1306576a4a05fde3$export$e10d8e097873db4f), (0, $TusQn.mergeProps)(attrs, dataTableRowsProps, {
                                "items": flatItems.value
                            }), slots),
                            slots['body.append']?.(slotProps.value)
                        ]),
                        slots.tbody?.(slotProps.value),
                        slots.tfoot?.(slotProps.value)
                    ]),
                bottom: ()=>slots.bottom ? slots.bottom(slotProps.value) : !props.hideDefaultFooter && (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), null, null),
                        (0, $TusQn.createVNode)((0, $f63d1f97304ddede$export$3403786a0c6524a), dataTableFooterProps, {
                            prepend: slots['footer.prepend']
                        })
                    ])
            });
        });
    }
});




var $ec57a60b0ce96d7c$exports = {};

$parcel$export($ec57a60b0ce96d7c$exports, "VDatePicker", () => $832d3e01ffc24aaa$export$a38ea195118a640d);
$parcel$export($ec57a60b0ce96d7c$exports, "VDatePickerControls", () => $720cca96bbb186bd$export$12f65deebc2d352e);
$parcel$export($ec57a60b0ce96d7c$exports, "VDatePickerHeader", () => $04761560a9b0dbdd$export$47b045316d89f8ff);
$parcel$export($ec57a60b0ce96d7c$exports, "VDatePickerMonth", () => $97103f3450b79ad7$export$7affb9b3ced7ba5e);
$parcel$export($ec57a60b0ce96d7c$exports, "VDatePickerMonths", () => $2303fce940227a33$export$1d5c3cfa8e041a10);
$parcel$export($ec57a60b0ce96d7c$exports, "VDatePickerYears", () => $6860b8410334ea86$export$3faa77515f7b0baa);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



// Styles


const $b2fc64d8d70f01a3$export$78e533170324578f = (0, $5224ab9d69b8c3e0$export$b3680ae2c271b9f3)('v-spacer', 'div', 'VSpacer');





const $720cca96bbb186bd$export$48a55eee69fece84 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    active: {
        type: [
            String,
            Array
        ],
        default: undefined
    },
    controlHeight: [
        Number,
        String
    ],
    controlVariant: {
        type: String,
        default: 'docked'
    },
    noMonthPicker: Boolean,
    disabled: {
        type: [
            Boolean,
            String,
            Array
        ],
        default: null
    },
    nextIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$next'
    },
    prevIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$prev'
    },
    modeIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$subgroup'
    },
    text: String,
    monthText: String,
    yearText: String,
    viewMode: {
        type: String,
        default: 'month'
    }
}, 'VDatePickerControls');
const $720cca96bbb186bd$export$12f65deebc2d352e = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDatePickerControls',
    props: $720cca96bbb186bd$export$48a55eee69fece84(),
    emits: {
        'click:year': ()=>true,
        'click:month': ()=>true,
        'click:prev': ()=>true,
        'click:next': ()=>true,
        'click:prev-year': ()=>true,
        'click:next-year': ()=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const disableMonth = (0, $01W3b.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('text') : !!props.disabled;
        });
        const disableYear = (0, $01W3b.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('mode') : !!props.disabled;
        });
        const disablePrevMonth = (0, $01W3b.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('prev-month') : !!props.disabled;
        });
        const disableNextMonth = (0, $01W3b.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('next-month') : !!props.disabled;
        });
        const disablePrevYear = (0, $01W3b.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('prev-year') : !!props.disabled;
        });
        const disableNextYear = (0, $01W3b.computed)(()=>{
            return Array.isArray(props.disabled) ? props.disabled.includes('next-year') : !!props.disabled;
        });
        function onClickPrevMonth() {
            emit('click:prev');
        }
        function onClickNextMonth() {
            emit('click:next');
        }
        function onClickPrevYear() {
            emit('click:prev-year');
        }
        function onClickNextYear() {
            emit('click:next-year');
        }
        function onClickYear() {
            emit('click:year');
        }
        function onClickMonth() {
            emit('click:month');
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const innerDefaults = {
                VBtn: {
                    density: 'comfortable',
                    variant: 'text'
                }
            };
            const prevMonth = (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                "data-testid": "prev-month",
                "disabled": disablePrevMonth.value,
                "icon": props.prevIcon,
                "aria-label": t('$vuetify.datePicker.ariaLabel.previousMonth'),
                "onClick": onClickPrevMonth
            }, null);
            const nextMonth = (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                "data-testid": "next-month",
                "disabled": disableNextMonth.value,
                "icon": props.nextIcon,
                "aria-label": t('$vuetify.datePicker.ariaLabel.nextMonth'),
                "onClick": onClickNextMonth
            }, null);
            const prevYear = (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                "data-testid": "prev-year",
                "disabled": disablePrevYear.value,
                "icon": props.prevIcon,
                "aria-label": t('$vuetify.datePicker.ariaLabel.previousYear'),
                "onClick": onClickPrevYear
            }, null);
            const nextYear = (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                "data-testid": "next-year",
                "disabled": disableNextYear.value,
                "icon": props.nextIcon,
                "aria-label": t('$vuetify.datePicker.ariaLabel.nextYear'),
                "onClick": onClickNextYear
            }, null);
            const onlyMonthBtn = (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                "class": "v-date-picker-controls__only-month-btn",
                "data-testid": "month-btn",
                "density": "default",
                "disabled": disableMonth.value,
                "text": props.monthText,
                "appendIcon": props.modeIcon,
                "rounded": true,
                "aria-label": t('$vuetify.datePicker.ariaLabel.selectMonth'),
                "onClick": onClickMonth
            }, null);
            const onlyYearBtn = (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                "class": "v-date-picker-controls__only-year-btn",
                "data-testid": "year-btn",
                "density": "default",
                "disabled": disableYear.value,
                "text": props.yearText,
                "appendIcon": props.modeIcon,
                "rounded": true,
                "aria-label": t('$vuetify.datePicker.ariaLabel.selectYear'),
                "onClick": onClickYear
            }, null);
            const monthYearBtn = (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                "class": "v-date-picker-controls__year-btn",
                "data-testid": "year-btn",
                "density": "default",
                "disabled": disableYear.value,
                "text": props.text,
                "appendIcon": props.modeIcon,
                "rounded": true,
                "aria-label": t('$vuetify.datePicker.ariaLabel.selectYear'),
                "onClick": onClickYear
            }, null);
            const monthYearSplit = (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                    "class": "v-date-picker-controls__month-btn",
                    "data-testid": "month-btn",
                    "height": "36",
                    "disabled": disableMonth.value,
                    "text": props.text,
                    "rounded": true,
                    "aria-label": t('$vuetify.datePicker.ariaLabel.selectMonth'),
                    "onClick": onClickMonth
                }, null),
                (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                    "class": "v-date-picker-controls__mode-btn",
                    "data-testid": "year-btn",
                    "disabled": disableYear.value,
                    "icon": props.modeIcon,
                    "aria-label": t('$vuetify.datePicker.ariaLabel.selectYear'),
                    "onClick": onClickYear
                }, null)
            ]);
            const slotProps = {
                viewMode: props.viewMode,
                disabled: Array.isArray(props.disabled) ? props.disabled : [],
                monthYearText: props.text ?? '',
                monthText: props.monthText ?? '',
                yearText: props.yearText ?? '',
                openMonths: onClickMonth,
                openYears: onClickYear,
                prevMonth: onClickPrevMonth,
                nextMonth: onClickNextMonth,
                prevYear: onClickPrevYear,
                nextYear: onClickNextYear
            };
            const modalControls = (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                props.noMonthPicker ? monthYearBtn : monthYearSplit,
                (0, $TusQn.createVNode)((0, $b2fc64d8d70f01a3$export$78e533170324578f), null, null),
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-date-picker-controls__month"
                }, [
                    prevMonth,
                    nextMonth
                ])
            ]);
            const dockedControls = (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-date-picker-controls__month"
                }, [
                    prevMonth,
                    onlyMonthBtn,
                    nextMonth
                ]),
                (0, $TusQn.createVNode)((0, $b2fc64d8d70f01a3$export$78e533170324578f), null, null),
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-date-picker-controls__year"
                }, [
                    prevYear,
                    onlyYearBtn,
                    nextYear
                ])
            ]);
            return (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                "defaults": innerDefaults
            }, {
                default: ()=>[
                        (0, $TusQn.createElementVNode)("div", {
                            "class": (0, $8POXm.normalizeClass)([
                                'v-date-picker-controls',
                                `v-date-picker-controls--variant-${props.controlVariant}`
                            ]),
                            "style": {
                                '--v-date-picker-controls-height': (0, $8590040a7833369a$export$286ad215293a0860)(props.controlHeight)
                            }
                        }, [
                            slots.default?.(slotProps) ?? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                props.controlVariant === 'modal' && modalControls,
                                props.controlVariant === 'docked' && dockedControls
                            ])
                        ])
                    ]
            });
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");







const $04761560a9b0dbdd$export$ad3160ece9498a06 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    appendIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    color: String,
    header: String,
    transition: String,
    onClick: (0, $8590040a7833369a$export$cefab237a347bf23)()
}, 'VDatePickerHeader');
const $04761560a9b0dbdd$export$47b045316d89f8ff = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDatePickerHeader',
    props: $04761560a9b0dbdd$export$ad3160ece9498a06(),
    emits: {
        click: ()=>true,
        'click:append': ()=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        function onClick() {
            emit('click');
        }
        function onClickAppend() {
            emit('click:append');
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasContent = !!(slots.default || props.header);
            const hasAppend = !!(slots.append || props.appendIcon);
            return (0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-date-picker-header',
                    {
                        'v-date-picker-header--clickable': !!props.onClick
                    },
                    backgroundColorClasses.value
                ]),
                "style": (0, $8POXm.normalizeStyle)(backgroundColorStyles.value),
                "onClick": onClick
            }, [
                slots.prepend && (0, $TusQn.createElementVNode)("div", {
                    "key": "prepend",
                    "class": "v-date-picker-header__prepend"
                }, [
                    slots.prepend()
                ]),
                hasContent && (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                    "key": "content",
                    "name": props.transition
                }, {
                    default: ()=>[
                            (0, $TusQn.createElementVNode)("div", {
                                "key": props.header,
                                "class": "v-date-picker-header__content"
                            }, [
                                slots.default?.() ?? props.header
                            ])
                        ]
                }),
                hasAppend && (0, $TusQn.createElementVNode)("div", {
                    "class": "v-date-picker-header__append"
                }, [
                    !slots.append ? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                        "key": "append-btn",
                        "icon": props.appendIcon,
                        "variant": "text",
                        "onClick": onClickAppend
                    }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                        "key": "append-defaults",
                        "disabled": !props.appendIcon,
                        "defaults": {
                            VBtn: {
                                icon: props.appendIcon,
                                variant: 'text'
                            }
                        }
                    }, {
                        default: ()=>[
                                slots.append?.()
                            ]
                    })
                ])
            ]);
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



// Composables


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $cd83dfe515d858a2$export$e6f7535869f26d31 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    allowedDates: [
        Array,
        Function
    ],
    disabled: {
        type: Boolean,
        default: null
    },
    displayValue: null,
    modelValue: Array,
    month: [
        Number,
        String
    ],
    max: null,
    min: null,
    showAdjacentMonths: Boolean,
    year: [
        Number,
        String
    ],
    weekdays: {
        type: Array,
        default: ()=>[
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ]
    },
    weeksInMonth: {
        type: String,
        default: 'dynamic'
    },
    firstDayOfWeek: {
        type: [
            Number,
            String
        ],
        default: undefined
    },
    firstDayOfYear: {
        type: [
            Number,
            String
        ],
        default: undefined
    },
    weekdayFormat: String
}, 'calendar');
function $cd83dfe515d858a2$export$3ee915f8151bd4f1(props) {
    const adapter = (0, $917deb9c892fd486$export$e51e224239492327)();
    const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', [], (v)=>(0, $8590040a7833369a$export$76411cac38121ecb)(v).map((i)=>adapter.date(i)));
    const displayValue = (0, $01W3b.computed)(()=>{
        if (props.displayValue) return adapter.date(props.displayValue);
        if (model.value.length > 0) return adapter.date(model.value[0]);
        if (props.min) return adapter.date(props.min);
        if (Array.isArray(props.allowedDates)) return adapter.date(props.allowedDates[0]);
        return adapter.date();
    });
    const year = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'year', undefined, (v)=>{
        const value = v != null ? Number(v) : adapter.getYear(displayValue.value);
        return adapter.startOfYear(adapter.setYear(adapter.date(), value));
    }, (v)=>adapter.getYear(v));
    const month = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'month', undefined, (v)=>{
        const value = v != null ? Number(v) : adapter.getMonth(displayValue.value);
        const date = adapter.setYear(adapter.startOfMonth(adapter.date()), adapter.getYear(year.value));
        return adapter.setMonth(date, value);
    }, (v)=>adapter.getMonth(v));
    const weekdayLabels = (0, $01W3b.computed)(()=>{
        const firstDayOfWeek = adapter.toJsDate(adapter.startOfWeek(adapter.date(), props.firstDayOfWeek)).getDay();
        return adapter.getWeekdays(props.firstDayOfWeek, props.weekdayFormat).filter((_, i)=>props.weekdays.includes((i + firstDayOfWeek) % 7));
    });
    const weeksInMonth = (0, $01W3b.computed)(()=>{
        const weeks = adapter.getWeekArray(month.value, props.firstDayOfWeek);
        const days = weeks.flat();
        // Make sure there's always 6 weeks in month (6 * 7 days)
        // if weeksInMonth is 'static'
        const daysInMonth = 42;
        if (props.weeksInMonth === 'static' && days.length < daysInMonth) {
            const lastDay = days[days.length - 1];
            let week = [];
            for(let day = 1; day <= daysInMonth - days.length; day++){
                week.push(adapter.addDays(lastDay, day));
                if (day % 7 === 0) {
                    weeks.push(week);
                    week = [];
                }
            }
        }
        return weeks;
    });
    function genDays(days, today) {
        return days.filter((date)=>{
            return props.weekdays.includes(adapter.toJsDate(date).getDay());
        }).map((date, index)=>{
            const isoDate = adapter.toISO(date);
            const isAdjacent = !adapter.isSameMonth(date, month.value);
            const isStart = adapter.isSameDay(date, adapter.startOfMonth(month.value));
            const isEnd = adapter.isSameDay(date, adapter.endOfMonth(month.value));
            const isSame = adapter.isSameDay(date, month.value);
            const weekdaysCount = props.weekdays.length;
            return {
                date: date,
                formatted: adapter.format(date, 'keyboardDate'),
                isAdjacent: isAdjacent,
                isDisabled: isDisabled(date),
                isEnd: isEnd,
                isHidden: isAdjacent && !props.showAdjacentMonths,
                isSame: isSame,
                isSelected: model.value.some((value)=>adapter.isSameDay(date, value)),
                isStart: isStart,
                isToday: adapter.isSameDay(date, today),
                isWeekEnd: index % weekdaysCount === weekdaysCount - 1,
                isWeekStart: index % weekdaysCount === 0,
                isoDate: isoDate,
                localized: adapter.format(date, 'dayOfMonth'),
                month: adapter.getMonth(date),
                year: adapter.getYear(date)
            };
        });
    }
    const daysInWeek = (0, $01W3b.computed)(()=>{
        const lastDay = adapter.startOfWeek(displayValue.value, props.firstDayOfWeek);
        const week = [];
        for(let day = 0; day <= 6; day++)week.push(adapter.addDays(lastDay, day));
        const today = adapter.date();
        return genDays(week, today);
    });
    const daysInMonth = (0, $01W3b.computed)(()=>{
        const days = weeksInMonth.value.flat();
        const today = adapter.date();
        return genDays(days, today);
    });
    const weekNumbers = (0, $01W3b.computed)(()=>{
        return weeksInMonth.value.map((week)=>{
            return week.length ? adapter.getWeek(week[0], props.firstDayOfWeek, props.firstDayOfYear) : null;
        });
    });
    const { minDate: minDate, maxDate: maxDate } = $cd83dfe515d858a2$export$e30c8959f465d41(props);
    function isDisabled(value) {
        if (props.disabled) return true;
        const date = adapter.date(value);
        if (minDate.value && adapter.isBefore(adapter.endOfDay(date), minDate.value)) return true;
        if (maxDate.value && adapter.isAfter(date, maxDate.value)) return true;
        if (Array.isArray(props.allowedDates) && props.allowedDates.length > 0) return !props.allowedDates.some((d)=>adapter.isSameDay(adapter.date(d), date));
        if (typeof props.allowedDates === 'function') return !props.allowedDates(date);
        return false;
    }
    return {
        displayValue: displayValue,
        daysInMonth: daysInMonth,
        daysInWeek: daysInWeek,
        genDays: genDays,
        model: model,
        weeksInMonth: weeksInMonth,
        weekdayLabels: weekdayLabels,
        weekNumbers: weekNumbers
    };
}
function $cd83dfe515d858a2$export$e30c8959f465d41(props) {
    const adapter = (0, $917deb9c892fd486$export$e51e224239492327)();
    const minDate = (0, $01W3b.computed)(()=>{
        if (!props.min) return null;
        const date = adapter.date(props.min);
        return adapter.isValid(date) ? date : null;
    });
    const maxDate = (0, $01W3b.computed)(()=>{
        if (!props.max) return null;
        const date = adapter.date(props.max);
        return adapter.isValid(date) ? date : null;
    });
    function clampDate(date) {
        if (minDate.value && adapter.isBefore(date, minDate.value)) return minDate.value;
        if (maxDate.value && adapter.isAfter(date, maxDate.value)) return maxDate.value;
        return date;
    }
    function isInAllowedRange(date) {
        return (!minDate.value || adapter.isAfter(date, minDate.value)) && (!maxDate.value || adapter.isBefore(date, maxDate.value));
    }
    return {
        minDate: minDate,
        maxDate: maxDate,
        clampDate: clampDate,
        isInAllowedRange: isInAllowedRange
    };
}






const $97103f3450b79ad7$export$ca1dc982fe7d1325 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    hideWeekdays: Boolean,
    multiple: [
        Boolean,
        Number,
        String
    ],
    showWeek: Boolean,
    readonly: Boolean,
    transition: {
        type: String,
        default: 'picker-transition'
    },
    reverseTransition: {
        type: String,
        default: 'picker-reverse-transition'
    },
    events: {
        type: [
            Array,
            Function,
            Object
        ],
        default: ()=>null
    },
    eventColor: {
        type: [
            Array,
            Function,
            Object,
            String
        ],
        default: ()=>null
    },
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $cd83dfe515d858a2$export$e6f7535869f26d31)(), [
        'displayValue'
    ])
}, 'VDatePickerMonth');
const $97103f3450b79ad7$export$7affb9b3ced7ba5e = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDatePickerMonth',
    props: $97103f3450b79ad7$export$ca1dc982fe7d1325(),
    emits: {
        'update:modelValue': (date)=>true,
        'update:month': (date)=>true,
        'update:year': (date)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const daysRef = (0, $01W3b.ref)();
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { daysInMonth: daysInMonth, model: model, weekNumbers: weekNumbers, weekdayLabels: weekdayLabels } = (0, $cd83dfe515d858a2$export$3ee915f8151bd4f1)(props);
        const adapter = (0, $917deb9c892fd486$export$e51e224239492327)();
        const rangeStart = (0, $01W3b.shallowRef)();
        const rangeStop = (0, $01W3b.shallowRef)();
        const isReverse = (0, $01W3b.shallowRef)(false);
        const transition = (0, $01W3b.toRef)(()=>{
            return !isReverse.value ? props.transition : props.reverseTransition;
        });
        if (props.multiple === 'range' && model.value.length > 0) {
            rangeStart.value = model.value[0];
            if (model.value.length > 1) rangeStop.value = model.value[model.value.length - 1];
        }
        const atMax = (0, $01W3b.computed)(()=>{
            const max = [
                'number',
                'string'
            ].includes(typeof props.multiple) ? Number(props.multiple) : Infinity;
            return model.value.length >= max;
        });
        (0, $01W3b.watch)(daysInMonth, (val, oldVal)=>{
            if (!oldVal) return;
            isReverse.value = adapter.isBefore(val[0].date, oldVal[0].date);
        });
        function onRangeClick(value) {
            const _value = adapter.startOfDay(value);
            if (model.value.length === 0) rangeStart.value = undefined;
            else if (model.value.length === 1) {
                rangeStart.value = model.value[0];
                rangeStop.value = undefined;
            }
            if (!rangeStart.value) {
                rangeStart.value = _value;
                model.value = [
                    rangeStart.value
                ];
            } else if (!rangeStop.value) {
                if (adapter.isSameDay(_value, rangeStart.value)) {
                    rangeStart.value = undefined;
                    model.value = [];
                    return;
                } else if (adapter.isBefore(_value, rangeStart.value)) {
                    rangeStop.value = adapter.endOfDay(rangeStart.value);
                    rangeStart.value = _value;
                } else rangeStop.value = adapter.endOfDay(_value);
                model.value = (0, $917deb9c892fd486$export$788d03e430c3bd7a)(adapter, rangeStart.value, rangeStop.value);
            } else {
                rangeStart.value = value;
                rangeStop.value = undefined;
                model.value = [
                    rangeStart.value
                ];
            }
        }
        function getDateAriaLabel(item) {
            const fullDate = adapter.format(item.date, 'fullDateWithWeekday');
            const localeKey = item.isToday ? 'currentDate' : 'selectDate';
            return t(`$vuetify.datePicker.ariaLabel.${localeKey}`, fullDate);
        }
        function onMultipleClick(value) {
            const index = model.value.findIndex((selection)=>adapter.isSameDay(selection, value));
            if (index === -1) model.value = [
                ...model.value,
                value
            ];
            else {
                const value = [
                    ...model.value
                ];
                value.splice(index, 1);
                model.value = value;
            }
        }
        function onClick(value) {
            if (props.multiple === 'range') onRangeClick(value);
            else if (props.multiple) onMultipleClick(value);
            else model.value = [
                value
            ];
        }
        function getEventColors(date) {
            const { events: events, eventColor: eventColor } = props;
            let eventData;
            let eventColors = [];
            if (Array.isArray(events)) eventData = events.includes(date);
            else if (events instanceof Function) eventData = events(date) || false;
            else if (events) eventData = events[date] || false;
            else eventData = false;
            if (!eventData) return [];
            else if (eventData !== true) eventColors = (0, $8590040a7833369a$export$76411cac38121ecb)(eventData);
            else if (typeof eventColor === 'string') eventColors = [
                eventColor
            ];
            else if (typeof eventColor === 'function') eventColors = (0, $8590040a7833369a$export$76411cac38121ecb)(eventColor(date));
            else if (Array.isArray(eventColor)) eventColors = eventColor;
            else if (typeof eventColor === 'object' && eventColor !== null) eventColors = (0, $8590040a7833369a$export$76411cac38121ecb)(eventColor[date]);
            // Fallback to default color if no color is found
            return !eventColors.length ? [
                'surface-variant'
            ] : eventColors.filter(Boolean).map((color)=>typeof color === 'string' ? color : 'surface-variant');
        }
        function genEvents(date) {
            const eventColors = getEventColors(date);
            if (!eventColors.length) return null;
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-date-picker-month__events"
            }, [
                eventColors.map((color)=>(0, $TusQn.createVNode)((0, $6dbda73bad13a718$export$756a89601026c160), {
                        "dot": true,
                        "color": color
                    }, null))
            ]);
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": "v-date-picker-month",
                "style": {
                    '--v-date-picker-days-in-week': props.weekdays.length
                }
            }, [
                props.showWeek && (0, $TusQn.createElementVNode)("div", {
                    "key": "weeks",
                    "class": "v-date-picker-month__weeks"
                }, [
                    !props.hideWeekdays && (0, $TusQn.createElementVNode)("div", {
                        "key": "hide-week-days",
                        "class": "v-date-picker-month__day"
                    }, [
                        (0, $TusQn.createTextVNode)("\xA0")
                    ]),
                    weekNumbers.value.map((week)=>(0, $TusQn.createElementVNode)("div", {
                            "class": (0, $8POXm.normalizeClass)([
                                'v-date-picker-month__day',
                                'v-date-picker-month__day--adjacent'
                            ])
                        }, [
                            week
                        ]))
                ]),
                (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                    "name": transition.value
                }, {
                    default: ()=>[
                            (0, $TusQn.createElementVNode)("div", {
                                "ref": daysRef,
                                "key": daysInMonth.value[0].date?.toString(),
                                "class": "v-date-picker-month__days"
                            }, [
                                !props.hideWeekdays && weekdayLabels.value.map((weekDay)=>(0, $TusQn.createElementVNode)("div", {
                                        "class": (0, $8POXm.normalizeClass)([
                                            'v-date-picker-month__day',
                                            'v-date-picker-month__weekday'
                                        ])
                                    }, [
                                        weekDay
                                    ])),
                                daysInMonth.value.map((item, i)=>{
                                    const slotProps = {
                                        props: {
                                            class: 'v-date-picker-month__day-btn',
                                            color: item.isSelected || item.isToday ? props.color : undefined,
                                            disabled: item.isDisabled,
                                            readonly: props.readonly,
                                            icon: true,
                                            ripple: false,
                                            variant: item.isSelected ? 'flat' : item.isToday ? 'outlined' : 'text',
                                            'aria-label': getDateAriaLabel(item),
                                            'aria-current': item.isToday ? 'date' : undefined,
                                            onClick: ()=>onClick(item.date)
                                        },
                                        item: item,
                                        i: i
                                    };
                                    if (atMax.value && !item.isSelected) item.isDisabled = true;
                                    return (0, $TusQn.createElementVNode)("div", {
                                        "class": (0, $8POXm.normalizeClass)([
                                            'v-date-picker-month__day',
                                            {
                                                'v-date-picker-month__day--adjacent': item.isAdjacent,
                                                'v-date-picker-month__day--hide-adjacent': item.isHidden,
                                                'v-date-picker-month__day--selected': item.isSelected,
                                                'v-date-picker-month__day--week-end': item.isWeekEnd,
                                                'v-date-picker-month__day--week-start': item.isWeekStart
                                            }
                                        ]),
                                        "data-v-date": !item.isDisabled ? item.isoDate : undefined
                                    }, [
                                        (props.showAdjacentMonths || !item.isAdjacent) && (slots.day?.(slotProps) ?? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), slotProps.props, {
                                            default: ()=>[
                                                    item.localized,
                                                    genEvents(item.isoDate)
                                                ]
                                        }))
                                    ]);
                                })
                            ])
                        ]
                })
            ]));
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");





const $2303fce940227a33$export$70df29ae6028d97b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    height: [
        String,
        Number
    ],
    min: null,
    max: null,
    modelValue: Number,
    year: Number,
    allowedMonths: [
        Array,
        Function
    ]
}, 'VDatePickerMonths');
const $2303fce940227a33$export$1d5c3cfa8e041a10 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDatePickerMonths',
    props: $2303fce940227a33$export$70df29ae6028d97b(),
    emits: {
        'update:modelValue': (date)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const adapter = (0, $917deb9c892fd486$export$e51e224239492327)();
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const months = (0, $01W3b.computed)(()=>{
            let date = adapter.startOfYear(adapter.date());
            if (props.year) date = adapter.setYear(date, props.year);
            return (0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(12).map((i)=>{
                const text = adapter.format(date, 'monthShort');
                const label = adapter.format(date, 'month');
                const isDisabled = !!(!isMonthAllowed(i) || props.min && adapter.isAfter(adapter.startOfMonth(adapter.date(props.min)), date) || props.max && adapter.isAfter(date, adapter.startOfMonth(adapter.date(props.max))));
                date = adapter.getNextMonth(date);
                return {
                    isDisabled: isDisabled,
                    text: text,
                    label: label,
                    value: i
                };
            });
        });
        (0, $TusQn.watchEffect)(()=>{
            model.value = model.value ?? adapter.getMonth(adapter.date());
        });
        function isMonthAllowed(month) {
            if (Array.isArray(props.allowedMonths) && props.allowedMonths.length) return props.allowedMonths.includes(month);
            if (typeof props.allowedMonths === 'function') return props.allowedMonths(month);
            return true;
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": "v-date-picker-months",
                "style": {
                    height: (0, $8590040a7833369a$export$286ad215293a0860)(props.height)
                }
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-date-picker-months__content"
                }, [
                    months.value.map((month, i)=>{
                        const btnProps = {
                            active: model.value === i,
                            ariaLabel: month.label,
                            color: model.value === i ? props.color : undefined,
                            disabled: month.isDisabled,
                            rounded: true,
                            text: month.text,
                            variant: model.value === month.value ? 'flat' : 'text',
                            onClick: ()=>onClick(i)
                        };
                        function onClick(i) {
                            if (model.value === i) {
                                emit('update:modelValue', model.value);
                                return;
                            }
                            model.value = i;
                        }
                        return slots.month?.({
                            month: month,
                            i: i,
                            props: btnProps
                        }) ?? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                            "key": "month"
                        }, btnProps), null);
                    })
                ])
            ]));
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");






const $6860b8410334ea86$export$2da6674e7b9ab464 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    height: [
        String,
        Number
    ],
    min: null,
    max: null,
    modelValue: Number,
    allowedYears: [
        Array,
        Function
    ]
}, 'VDatePickerYears');
const $6860b8410334ea86$export$3faa77515f7b0baa = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDatePickerYears',
    props: $6860b8410334ea86$export$2da6674e7b9ab464(),
    directives: {
        vIntersect: $8d31333abb7bf4e7$export$2e2bcd8739ae039
    },
    emits: {
        'update:modelValue': (year)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const adapter = (0, $917deb9c892fd486$export$e51e224239492327)();
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const hasFocusedItem = (0, $01W3b.shallowRef)(false);
        const years = (0, $01W3b.computed)(()=>{
            const year = adapter.getYear(adapter.date());
            let min = year - 100;
            let max = year + 52;
            if (props.min) min = adapter.getYear(adapter.date(props.min));
            if (props.max) max = adapter.getYear(adapter.date(props.max));
            let date = adapter.startOfYear(adapter.date());
            date = adapter.setYear(date, min);
            return (0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(max - min + 1, min).map((i)=>{
                const text = adapter.format(date, 'year');
                date = adapter.setYear(date, adapter.getYear(date) + 1);
                return {
                    text: text,
                    value: i,
                    isDisabled: !isYearAllowed(i)
                };
            });
        });
        (0, $TusQn.watchEffect)(()=>{
            model.value = model.value ?? adapter.getYear(adapter.date());
        });
        const containerRef = (0, $8590040a7833369a$export$fc38e812d383221)();
        const yearRef = (0, $8590040a7833369a$export$fc38e812d383221)();
        function focusSelectedYear() {
            const container = containerRef.el;
            const target = yearRef.el;
            if (!container || !target) return;
            const containerRect = container.getBoundingClientRect();
            const targetRect = target.getBoundingClientRect();
            container.scrollTop += targetRect.top - containerRect.top - container.clientHeight / 2 + targetRect.height / 2;
        }
        function isYearAllowed(year) {
            if (Array.isArray(props.allowedYears) && props.allowedYears.length) return props.allowedYears.includes(year);
            if (typeof props.allowedYears === 'function') return props.allowedYears(year);
            return true;
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                "class": "v-date-picker-years",
                "ref": containerRef,
                "style": {
                    height: (0, $8590040a7833369a$export$286ad215293a0860)(props.height)
                }
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-date-picker-years__content",
                    "onFocus": ()=>yearRef.el?.focus(),
                    "onFocusin": ()=>hasFocusedItem.value = true,
                    "onFocusout": ()=>hasFocusedItem.value = false,
                    "tabindex": hasFocusedItem.value ? -1 : 0
                }, [
                    years.value.map((year, i)=>{
                        const btnProps = {
                            ref: model.value === year.value ? yearRef : undefined,
                            active: model.value === year.value,
                            color: model.value === year.value ? props.color : undefined,
                            rounded: true,
                            text: year.text,
                            disabled: year.isDisabled,
                            variant: model.value === year.value ? 'flat' : 'text',
                            onClick: ()=>{
                                if (model.value === year.value) {
                                    emit('update:modelValue', model.value);
                                    return;
                                }
                                model.value = year.value;
                            }
                        };
                        return slots.year?.({
                            year: year,
                            i: i,
                            props: btnProps
                        }) ?? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                            "key": "month"
                        }, btnProps), null);
                    })
                ])
            ]), [
                [
                    (0, $8d31333abb7bf4e7$export$2e2bcd8739ae039),
                    {
                        handler: focusSelectedYear
                    },
                    null,
                    {
                        once: true
                    }
                ]
            ]));
        return {};
    }
});











const $832d3e01ffc24aaa$export$d29cf0136caebe2c = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    // TODO: implement in v3.5
    // calendarIcon: {
    //   type: String,
    //   default: '$calendar',
    // },
    // keyboardIcon: {
    //   type: String,
    //   default: '$edit',
    // },
    // inputMode: {
    //   type: String as PropType<'calendar' | 'keyboard'>,
    //   default: 'calendar',
    // },
    // inputText: {
    //   type: String,
    //   default: '$vuetify.datePicker.input.placeholder',
    // },
    // inputPlaceholder: {
    //   type: String,
    //   default: 'dd/mm/yyyy',
    // },
    header: {
        type: String,
        default: '$vuetify.datePicker.header'
    },
    headerColor: String,
    headerDateFormat: {
        type: String,
        default: 'normalDateWithWeekday'
    },
    landscapeHeaderWidth: [
        Number,
        String
    ],
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $720cca96bbb186bd$export$48a55eee69fece84)(), [
        'active',
        'monthText',
        'yearText'
    ]),
    ...(0, $97103f3450b79ad7$export$ca1dc982fe7d1325)({
        weeksInMonth: 'static'
    }),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $2303fce940227a33$export$70df29ae6028d97b)(), [
        'modelValue'
    ]),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $6860b8410334ea86$export$2da6674e7b9ab464)(), [
        'modelValue'
    ]),
    ...(0, $dbc8d169fef91a15$export$78d2911f7e2f59e2)({
        title: '$vuetify.datePicker.title'
    }),
    modelValue: null
}, 'VDatePicker');
const $832d3e01ffc24aaa$export$a38ea195118a640d = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VDatePicker',
    props: $832d3e01ffc24aaa$export$d29cf0136caebe2c(),
    emits: {
        'update:modelValue': (date)=>true,
        'update:month': (date)=>true,
        'update:year': (date)=>true,
        // 'update:inputMode': (date: any) => true,
        'update:viewMode': (date)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const adapter = (0, $917deb9c892fd486$export$e51e224239492327)();
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', undefined, (v)=>(0, $8590040a7833369a$export$76411cac38121ecb)(v).map((i)=>adapter.date(i)), (v)=>props.multiple ? v : v[0]);
        const viewMode = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'viewMode');
        // const inputMode = useProxiedModel(props, 'inputMode')
        const { minDate: minDate, maxDate: maxDate, clampDate: clampDate } = (0, $cd83dfe515d858a2$export$e30c8959f465d41)(props);
        const internal = (0, $01W3b.computed)(()=>{
            const today = adapter.date();
            const value = model.value?.[0] ? adapter.date(model.value[0]) : clampDate(today);
            return value && adapter.isValid(value) ? value : today;
        });
        const headerColor = (0, $01W3b.toRef)(()=>props.headerColor ?? props.color);
        const _month = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'month');
        const month = (0, $01W3b.computed)({
            get: ()=>Number(_month.value ?? adapter.getMonth(adapter.startOfMonth(internal.value))),
            set: (v)=>_month.value = v
        });
        const _year = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'year');
        const year = (0, $01W3b.computed)({
            get: ()=>Number(_year.value ?? adapter.getYear(adapter.startOfYear(adapter.setMonth(internal.value, month.value)))),
            set: (v)=>_year.value = v
        });
        const isReversing = (0, $01W3b.shallowRef)(false);
        const header = (0, $01W3b.computed)(()=>{
            if (props.multiple && model.value.length > 1) return t('$vuetify.datePicker.itemsSelected', model.value.length);
            const formattedDate = model.value[0] && adapter.isValid(model.value[0]) ? adapter.format(adapter.date(model.value[0]), props.headerDateFormat) : t(props.header);
            return props.landscape && formattedDate.split(' ').length === 3 ? formattedDate.replace(' ', '\n') : formattedDate;
        });
        const monthStart = (0, $01W3b.toRef)(()=>{
            let date = adapter.date();
            date = adapter.setDate(date, 1);
            date = adapter.setMonth(date, month.value);
            date = adapter.setYear(date, year.value); // year is not always ISO
            return date;
        });
        const monthYearText = (0, $01W3b.toRef)(()=>adapter.format(monthStart.value, 'monthAndYear'));
        const monthText = (0, $01W3b.toRef)(()=>adapter.format(monthStart.value, 'monthShort'));
        const yearText = (0, $01W3b.toRef)(()=>adapter.format(monthStart.value, 'year'));
        // const headerIcon = toRef(() => props.inputMode === 'calendar' ? props.keyboardIcon : props.calendarIcon)
        const headerTransition = (0, $01W3b.toRef)(()=>`date-picker-header${isReversing.value ? '-reverse' : ''}-transition`);
        const disabled = (0, $01W3b.computed)(()=>{
            if (props.disabled) return true;
            const targets = [];
            if (viewMode.value !== 'month') targets.push(...[
                'prev-month',
                'next-month',
                'prev-year',
                'next-year'
            ]);
            else {
                let _date = adapter.date();
                _date = adapter.startOfMonth(_date);
                _date = adapter.setMonth(_date, month.value);
                _date = adapter.setYear(_date, year.value);
                if (minDate.value) {
                    const prevMonthEnd = adapter.addDays(adapter.startOfMonth(_date), -1);
                    const prevYearEnd = adapter.addDays(adapter.startOfYear(_date), -1);
                    adapter.isAfter(minDate.value, prevMonthEnd) && targets.push('prev-month');
                    adapter.isAfter(minDate.value, prevYearEnd) && targets.push('prev-year');
                }
                if (maxDate.value) {
                    const nextMonthStart = adapter.addDays(adapter.endOfMonth(_date), 1);
                    const nextYearStart = adapter.addDays(adapter.endOfYear(_date), 1);
                    adapter.isAfter(nextMonthStart, maxDate.value) && targets.push('next-month');
                    adapter.isAfter(nextYearStart, maxDate.value) && targets.push('next-year');
                }
            }
            return targets;
        });
        const allowedYears = (0, $01W3b.computed)(()=>{
            return props.allowedYears || isYearAllowed;
        });
        const allowedMonths = (0, $01W3b.computed)(()=>{
            return props.allowedMonths || isMonthAllowed;
        });
        function isAllowedInRange(start, end) {
            const allowedDates = props.allowedDates;
            if (typeof allowedDates !== 'function') return true;
            const days = 1 + (0, $917deb9c892fd486$export$32fd2fd703380680)(adapter, start, end);
            for(let i = 0; i < days; i++){
                if (allowedDates(adapter.addDays(start, i))) return true;
            }
            return false;
        }
        function isYearAllowed(year) {
            if (typeof props.allowedDates === 'function') {
                const startOfYear = adapter.parseISO(`${year}-01-01`);
                return isAllowedInRange(startOfYear, adapter.endOfYear(startOfYear));
            }
            if (Array.isArray(props.allowedDates) && props.allowedDates.length) {
                for (const date of props.allowedDates){
                    if (adapter.getYear(adapter.date(date)) === year) return true;
                }
                return false;
            }
            return true;
        }
        function isMonthAllowed(month) {
            if (typeof props.allowedDates === 'function') {
                const monthTwoDigits = String(month + 1).padStart(2, '0');
                const startOfMonth = adapter.parseISO(`${year.value}-${monthTwoDigits}-01`);
                return isAllowedInRange(startOfMonth, adapter.endOfMonth(startOfMonth));
            }
            if (Array.isArray(props.allowedDates) && props.allowedDates.length) {
                for (const date of props.allowedDates){
                    if (adapter.getYear(adapter.date(date)) === year.value && adapter.getMonth(adapter.date(date)) === month) return true;
                }
                return false;
            }
            return true;
        }
        // function onClickAppend () {
        //   inputMode.value = inputMode.value === 'calendar' ? 'keyboard' : 'calendar'
        // }
        function onClickNextMonth() {
            if (month.value < 11) month.value++;
            else {
                year.value++;
                month.value = 0;
                onUpdateYear();
            }
            onUpdateMonth();
        }
        function onClickPrevMonth() {
            if (month.value > 0) month.value--;
            else {
                year.value--;
                month.value = 11;
                onUpdateYear();
            }
            onUpdateMonth();
        }
        function onClickNextYear() {
            year.value++;
            if (maxDate.value) {
                const monthTwoDigits = String(month.value + 1).padStart(2, '0');
                const monthStart = adapter.parseISO(`${year.value}-${monthTwoDigits}-01`);
                if (adapter.isAfter(monthStart, maxDate.value)) month.value = adapter.getMonth(maxDate.value);
            }
            onUpdateYear();
        }
        function onClickPrevYear() {
            year.value--;
            if (minDate.value) {
                const monthTwoDigits = String(month.value + 1).padStart(2, '0');
                const monthStart = adapter.endOfMonth(adapter.parseISO(`${year.value}-${monthTwoDigits}-01`));
                if (adapter.isAfter(minDate.value, monthStart)) month.value = adapter.getMonth(minDate.value);
            }
            onUpdateYear();
        }
        function onClickDate() {
            viewMode.value = 'month';
        }
        function onClickMonth() {
            viewMode.value = viewMode.value === 'months' ? 'month' : 'months';
        }
        function onClickYear() {
            viewMode.value = viewMode.value === 'year' ? 'month' : 'year';
        }
        function onUpdateMonth() {
            if (viewMode.value === 'months') onClickMonth();
        }
        function onUpdateYear() {
            if (viewMode.value === 'year') onClickYear();
        }
        (0, $01W3b.watch)(model, (val, oldVal)=>{
            const arrBefore = (0, $8590040a7833369a$export$76411cac38121ecb)(oldVal);
            const arrAfter = (0, $8590040a7833369a$export$76411cac38121ecb)(val);
            if (!arrAfter.length) return;
            const before = adapter.date(arrBefore[arrBefore.length - 1]);
            const after = adapter.date(arrAfter[arrAfter.length - 1]);
            if (adapter.isSameDay(before, after)) return;
            const newMonth = adapter.getMonth(after);
            const newYear = adapter.getYear(after);
            if (newMonth !== month.value) {
                month.value = newMonth;
                onUpdateMonth();
            }
            if (newYear !== year.value) {
                year.value = newYear;
                onUpdateYear();
            }
            isReversing.value = adapter.isBefore(before, after);
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const pickerProps = (0, $dbc8d169fef91a15$export$37f35d9b6bd5d714).filterProps(props);
            const datePickerControlsProps = (0, $8590040a7833369a$export$30a06c8d3562193f)((0, $720cca96bbb186bd$export$12f65deebc2d352e).filterProps(props), [
                'viewMode'
            ]);
            const datePickerHeaderProps = (0, $04761560a9b0dbdd$export$47b045316d89f8ff).filterProps(props);
            const datePickerMonthProps = (0, $97103f3450b79ad7$export$7affb9b3ced7ba5e).filterProps(props);
            const datePickerMonthsProps = (0, $8590040a7833369a$export$30a06c8d3562193f)((0, $2303fce940227a33$export$1d5c3cfa8e041a10).filterProps(props), [
                'modelValue'
            ]);
            const datePickerYearsProps = (0, $8590040a7833369a$export$30a06c8d3562193f)((0, $6860b8410334ea86$export$3faa77515f7b0baa).filterProps(props), [
                'modelValue'
            ]);
            const headerProps = {
                color: headerColor.value,
                header: header.value,
                transition: headerTransition.value
            };
            return (0, $TusQn.createVNode)((0, $dbc8d169fef91a15$export$37f35d9b6bd5d714), (0, $TusQn.mergeProps)(pickerProps, {
                "color": headerColor.value,
                "class": [
                    'v-date-picker',
                    `v-date-picker--${viewMode.value}`,
                    {
                        'v-date-picker--show-week': props.showWeek
                    },
                    rtlClasses.value,
                    props.class
                ],
                "style": [
                    {
                        '--v-date-picker-landscape-header-width': (0, $8590040a7833369a$export$286ad215293a0860)(props.landscapeHeaderWidth)
                    },
                    props.style
                ]
            }), {
                title: ()=>slots.title?.() ?? (0, $TusQn.createElementVNode)("div", {
                        "class": "v-date-picker__title"
                    }, [
                        t(props.title)
                    ]),
                header: ()=>slots.header ? (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                        "defaults": {
                            VDatePickerHeader: {
                                ...headerProps
                            }
                        }
                    }, {
                        default: ()=>[
                                slots.header?.(headerProps)
                            ]
                    }) : (0, $TusQn.createVNode)((0, $04761560a9b0dbdd$export$47b045316d89f8ff), (0, $TusQn.mergeProps)({
                        "key": "header"
                    }, datePickerHeaderProps, headerProps, {
                        "onClick": viewMode.value !== 'month' ? onClickDate : undefined
                    }), {
                        prepend: slots.prepend,
                        append: slots.append
                    }),
                default: ()=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createVNode)((0, $720cca96bbb186bd$export$12f65deebc2d352e), (0, $TusQn.mergeProps)(datePickerControlsProps, {
                            "disabled": disabled.value,
                            "viewMode": viewMode.value,
                            "text": monthYearText.value,
                            "monthText": monthText.value,
                            "yearText": yearText.value,
                            "onClick:next": onClickNextMonth,
                            "onClick:prev": onClickPrevMonth,
                            "onClick:nextYear": onClickNextYear,
                            "onClick:prevYear": onClickPrevYear,
                            "onClick:month": onClickMonth,
                            "onClick:year": onClickYear
                        }), {
                            default: slots.controls
                        }),
                        (0, $TusQn.createVNode)((0, $7ec1b0ef33b04126$export$13ce8c44634b158c), {
                            "hideOnLeave": true
                        }, {
                            default: ()=>[
                                    viewMode.value === 'months' ? (0, $TusQn.createVNode)((0, $2303fce940227a33$export$1d5c3cfa8e041a10), (0, $TusQn.mergeProps)({
                                        "key": "date-picker-months"
                                    }, datePickerMonthsProps, {
                                        "modelValue": month.value,
                                        "onUpdate:modelValue": [
                                            ($event)=>month.value = $event,
                                            onUpdateMonth
                                        ],
                                        "min": minDate.value,
                                        "max": maxDate.value,
                                        "year": year.value,
                                        "allowedMonths": allowedMonths.value
                                    }), {
                                        month: slots.month
                                    }) : viewMode.value === 'year' ? (0, $TusQn.createVNode)((0, $6860b8410334ea86$export$3faa77515f7b0baa), (0, $TusQn.mergeProps)({
                                        "key": "date-picker-years"
                                    }, datePickerYearsProps, {
                                        "modelValue": year.value,
                                        "onUpdate:modelValue": [
                                            ($event)=>year.value = $event,
                                            onUpdateYear
                                        ],
                                        "min": minDate.value,
                                        "max": maxDate.value,
                                        "allowedYears": allowedYears.value
                                    }), {
                                        year: slots.year
                                    }) : (0, $TusQn.createVNode)((0, $97103f3450b79ad7$export$7affb9b3ced7ba5e), (0, $TusQn.mergeProps)({
                                        "key": "date-picker-month"
                                    }, datePickerMonthProps, {
                                        "modelValue": model.value,
                                        "onUpdate:modelValue": ($event)=>model.value = $event,
                                        "month": month.value,
                                        "onUpdate:month": [
                                            ($event)=>month.value = $event,
                                            onUpdateMonth
                                        ],
                                        "year": year.value,
                                        "onUpdate:year": [
                                            ($event)=>year.value = $event,
                                            onUpdateYear
                                        ],
                                        "min": minDate.value,
                                        "max": maxDate.value
                                    }), {
                                        day: slots.day
                                    })
                                ]
                        })
                    ]),
                actions: slots.actions
            });
        });
        return {};
    }
});









var $28280b5efebf89d5$exports = {};

$parcel$export($28280b5efebf89d5$exports, "VDefaultsProvider", () => $d16c59ae67056c43$export$ee4fab30a254e5ee);



var $1bb6ef3684f65d13$exports = {};

$parcel$export($1bb6ef3684f65d13$exports, "VDialog", () => $cfe199962634e1c9$export$d399a452706dd20b);



var $2824664ba134397c$exports = {};

$parcel$export($2824664ba134397c$exports, "VDivider", () => $7eecf16f7970712c$export$a2636a5d9a866ca1);



var $a77f465cd1dfa7d6$exports = {};

$parcel$export($a77f465cd1dfa7d6$exports, "VEmptyState", () => $7b9ceed38ed77aa9$export$f18859191f4fd437);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");













const $7b9ceed38ed77aa9$export$610881e0844abefd = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    actionText: String,
    bgColor: String,
    color: String,
    icon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    image: String,
    justify: {
        type: String,
        default: 'center'
    },
    headline: String,
    title: String,
    text: String,
    textWidth: {
        type: [
            Number,
            String
        ],
        default: 500
    },
    href: String,
    to: String,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)({
        size: undefined
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VEmptyState');
const $7b9ceed38ed77aa9$export$f18859191f4fd437 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VEmptyState',
    props: $7b9ceed38ed77aa9$export$610881e0844abefd(),
    emits: {
        'click:action': (e)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { displayClasses: displayClasses } = (0, $1444e2cf1a712792$export$8406b7efc286d284)();
        function onClickAction(e) {
            emit('click:action', e);
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasActions = !!(slots.actions || props.actionText);
            const hasHeadline = !!(slots.headline || props.headline);
            const hasTitle = !!(slots.title || props.title);
            const hasText = !!(slots.text || props.text);
            const hasMedia = !!(slots.media || props.image || props.icon);
            const size = props.size || (props.image ? 200 : 96);
            return (0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-empty-state',
                    {
                        [`v-empty-state--${props.justify}`]: true
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    displayClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ])
            }, [
                hasMedia && (0, $TusQn.createElementVNode)("div", {
                    "key": "media",
                    "class": "v-empty-state__media"
                }, [
                    !slots.media ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        props.image ? (0, $TusQn.createVNode)((0, $b2937780237888c4$export$126ec614c536f27c), {
                            "key": "image",
                            "src": props.image,
                            "height": size
                        }, null) : props.icon ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                            "key": "icon",
                            "color": props.color,
                            "size": size,
                            "icon": props.icon
                        }, null) : undefined
                    ]) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                        "key": "media-defaults",
                        "defaults": {
                            VImg: {
                                src: props.image,
                                height: size
                            },
                            VIcon: {
                                size: size,
                                icon: props.icon
                            }
                        }
                    }, {
                        default: ()=>[
                                slots.media()
                            ]
                    })
                ]),
                hasHeadline && (0, $TusQn.createElementVNode)("div", {
                    "key": "headline",
                    "class": "v-empty-state__headline"
                }, [
                    slots.headline?.() ?? props.headline
                ]),
                hasTitle && (0, $TusQn.createElementVNode)("div", {
                    "key": "title",
                    "class": "v-empty-state__title"
                }, [
                    slots.title?.() ?? props.title
                ]),
                hasText && (0, $TusQn.createElementVNode)("div", {
                    "key": "text",
                    "class": "v-empty-state__text",
                    "style": {
                        maxWidth: (0, $8590040a7833369a$export$286ad215293a0860)(props.textWidth)
                    }
                }, [
                    slots.text?.() ?? props.text
                ]),
                slots.default && (0, $TusQn.createElementVNode)("div", {
                    "key": "content",
                    "class": "v-empty-state__content"
                }, [
                    slots.default()
                ]),
                hasActions && (0, $TusQn.createElementVNode)("div", {
                    "key": "actions",
                    "class": "v-empty-state__actions"
                }, [
                    (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                        "defaults": {
                            VBtn: {
                                class: 'v-empty-state__action-btn',
                                color: props.color ?? 'surface-variant',
                                href: props.href,
                                text: props.actionText,
                                to: props.to
                            }
                        }
                    }, {
                        default: ()=>[
                                slots.actions?.({
                                    props: {
                                        onClick: onClickAction
                                    }
                                }) ?? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                                    "onClick": onClickAction
                                }, null)
                            ]
                    })
                ])
            ]);
        });
        return {};
    }
});




var $664b3b93b8737256$exports = {};

$parcel$export($664b3b93b8737256$exports, "VExpansionPanels", () => $6bb95bd3852da65f$export$1d655deb4215c753);
$parcel$export($664b3b93b8737256$exports, "VExpansionPanel", () => $28100b0eb5ce0ee5$export$ee93fd2a8131fa1c);
$parcel$export($664b3b93b8737256$exports, "VExpansionPanelText", () => $0cd6eb0f8550a7eb$export$98a17388a19b123f);
$parcel$export($664b3b93b8737256$exports, "VExpansionPanelTitle", () => $210a098534cf9d91$export$4188f36ee8a3fb9e);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");

// Types
const $3a6bc0570b633afe$export$d2f18f636bf00f54 = Symbol.for('vuetify:v-expansion-panel');


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");





const $0cd6eb0f8550a7eb$export$f3c5154392bfd2e6 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $1ee69ec23e68548b$export$3557c26df64490a4)()
}, 'VExpansionPanelText');
const $0cd6eb0f8550a7eb$export$98a17388a19b123f = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanelText',
    props: $0cd6eb0f8550a7eb$export$f3c5154392bfd2e6(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const expansionPanel = (0, $TusQn.inject)((0, $3a6bc0570b633afe$export$d2f18f636bf00f54));
        if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-text needs to be placed inside v-expansion-panel');
        const { hasContent: hasContent, onAfterLeave: onAfterLeave } = (0, $1ee69ec23e68548b$export$965f98646215a1bd)(props, expansionPanel.isSelected);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)((0, $7ec1b0ef33b04126$export$1cd1e8deb97d798d), {
                "onAfterLeave": onAfterLeave
            }, {
                default: ()=>[
                        (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("div", {
                            "class": (0, $8POXm.normalizeClass)([
                                'v-expansion-panel-text',
                                props.class
                            ]),
                            "style": (0, $8POXm.normalizeStyle)(props.style)
                        }, [
                            slots.default && hasContent.value && (0, $TusQn.createElementVNode)("div", {
                                "class": "v-expansion-panel-text__wrapper"
                            }, [
                                slots.default?.()
                            ])
                        ]), [
                            [
                                (0, $eeJ70.vShow),
                                expansionPanel.isSelected.value
                            ]
                        ])
                    ]
            }));
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");









const $210a098534cf9d91$export$85e1bc773c647163 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    expandIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$expand'
    },
    collapseIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$collapse'
    },
    hideActions: Boolean,
    focusable: Boolean,
    static: Boolean,
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: false
    },
    readonly: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)()
}, 'VExpansionPanelTitle');
const $210a098534cf9d91$export$4188f36ee8a3fb9e = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanelTitle',
    directives: {
        vRipple: $907916373bf62ceb$export$2e2bcd8739ae039
    },
    props: $210a098534cf9d91$export$85e1bc773c647163(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const expansionPanel = (0, $TusQn.inject)((0, $3a6bc0570b633afe$export$d2f18f636bf00f54));
        if (!expansionPanel) throw new Error('[Vuetify] v-expansion-panel-title needs to be placed inside v-expansion-panel');
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const slotProps = (0, $01W3b.computed)(()=>({
                collapseIcon: props.collapseIcon,
                disabled: expansionPanel.disabled.value,
                expanded: expansionPanel.isSelected.value,
                expandIcon: props.expandIcon,
                readonly: props.readonly
            }));
        const icon = (0, $01W3b.toRef)(()=>expansionPanel.isSelected.value ? props.collapseIcon : props.expandIcon);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("button", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-expansion-panel-title',
                    {
                        'v-expansion-panel-title--active': expansionPanel.isSelected.value,
                        'v-expansion-panel-title--focusable': props.focusable,
                        'v-expansion-panel-title--static': props.static
                    },
                    backgroundColorClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    dimensionStyles.value,
                    props.style
                ]),
                "type": "button",
                "tabindex": expansionPanel.disabled.value ? -1 : undefined,
                "disabled": expansionPanel.disabled.value,
                "aria-expanded": expansionPanel.isSelected.value,
                "onClick": !props.readonly ? expansionPanel.toggle : undefined
            }, [
                (0, $TusQn.createElementVNode)("span", {
                    "class": "v-expansion-panel-title__overlay"
                }, null),
                slots.default?.(slotProps.value),
                !props.hideActions && (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                    "defaults": {
                        VIcon: {
                            icon: icon.value
                        }
                    }
                }, {
                    default: ()=>[
                            (0, $TusQn.createElementVNode)("span", {
                                "class": "v-expansion-panel-title__icon"
                            }, [
                                slots.actions?.(slotProps.value) ?? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), null, null)
                            ])
                        ]
                })
            ]), [
                [
                    (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                    props.ripple
                ]
            ]));
        return {};
    }
});









const $28100b0eb5ce0ee5$export$957957cd07e373a6 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    title: String,
    text: String,
    bgColor: String,
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $0befa53cf46b542b$export$e9e3b570044587e8)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $210a098534cf9d91$export$85e1bc773c647163)(),
    ...(0, $0cd6eb0f8550a7eb$export$f3c5154392bfd2e6)()
}, 'VExpansionPanel');
const $28100b0eb5ce0ee5$export$ee93fd2a8131fa1c = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanel',
    props: $28100b0eb5ce0ee5$export$957957cd07e373a6(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const groupItem = (0, $0befa53cf46b542b$export$eebde8160f061c26)(props, (0, $3a6bc0570b633afe$export$d2f18f636bf00f54));
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const isDisabled = (0, $01W3b.toRef)(()=>groupItem?.disabled.value || props.disabled);
        const selectedIndices = (0, $01W3b.computed)(()=>groupItem.group.items.value.reduce((arr, item, index)=>{
                if (groupItem.group.selected.value.includes(item.id)) arr.push(index);
                return arr;
            }, []));
        const isBeforeSelected = (0, $01W3b.computed)(()=>{
            const index = groupItem.group.items.value.findIndex((item)=>item.id === groupItem.id);
            return !groupItem.isSelected.value && selectedIndices.value.some((selectedIndex)=>selectedIndex - index === 1);
        });
        const isAfterSelected = (0, $01W3b.computed)(()=>{
            const index = groupItem.group.items.value.findIndex((item)=>item.id === groupItem.id);
            return !groupItem.isSelected.value && selectedIndices.value.some((selectedIndex)=>selectedIndex - index === -1);
        });
        (0, $TusQn.provide)((0, $3a6bc0570b633afe$export$d2f18f636bf00f54), groupItem);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasText = !!(slots.text || props.text);
            const hasTitle = !!(slots.title || props.title);
            const expansionPanelTitleProps = (0, $210a098534cf9d91$export$4188f36ee8a3fb9e).filterProps(props);
            const expansionPanelTextProps = (0, $0cd6eb0f8550a7eb$export$98a17388a19b123f).filterProps(props);
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-expansion-panel',
                    {
                        'v-expansion-panel--active': groupItem.isSelected.value,
                        'v-expansion-panel--before-active': isBeforeSelected.value,
                        'v-expansion-panel--after-active': isAfterSelected.value,
                        'v-expansion-panel--disabled': isDisabled.value
                    },
                    roundedClasses.value,
                    backgroundColorClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        (0, $TusQn.createElementVNode)("div", {
                            "class": (0, $8POXm.normalizeClass)([
                                'v-expansion-panel__shadow',
                                ...elevationClasses.value
                            ])
                        }, null),
                        (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VExpansionPanelTitle: {
                                    ...expansionPanelTitleProps
                                },
                                VExpansionPanelText: {
                                    ...expansionPanelTextProps
                                }
                            }
                        }, {
                            default: ()=>[
                                    hasTitle && (0, $TusQn.createVNode)((0, $210a098534cf9d91$export$4188f36ee8a3fb9e), {
                                        "key": "title"
                                    }, {
                                        default: ()=>[
                                                slots.title ? slots.title() : props.title
                                            ]
                                    }),
                                    hasText && (0, $TusQn.createVNode)((0, $0cd6eb0f8550a7eb$export$98a17388a19b123f), {
                                        "key": "text"
                                    }, {
                                        default: ()=>[
                                                slots.text ? slots.text() : props.text
                                            ]
                                    }),
                                    slots.default?.()
                                ]
                        })
                    ]
            });
        });
        return {
            groupItem: groupItem
        };
    }
});








const $6bb95bd3852da65f$var$allowedVariants = [
    'default',
    'accordion',
    'inset',
    'popout'
];
const $6bb95bd3852da65f$export$d02e8e924ebac11d = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    flat: Boolean,
    ...(0, $0befa53cf46b542b$export$fa4c05b3520340e6)(),
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $28100b0eb5ce0ee5$export$957957cd07e373a6)(), [
        'bgColor',
        'collapseIcon',
        'color',
        'eager',
        'elevation',
        'expandIcon',
        'focusable',
        'hideActions',
        'readonly',
        'ripple',
        'rounded',
        'tile',
        'static'
    ]),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    variant: {
        type: String,
        default: 'default',
        validator: (v)=>$6bb95bd3852da65f$var$allowedVariants.includes(v)
    }
}, 'VExpansionPanels');
const $6bb95bd3852da65f$export$1d655deb4215c753 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VExpansionPanels',
    props: $6bb95bd3852da65f$export$d02e8e924ebac11d(),
    emits: {
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { next: next, prev: prev } = (0, $0befa53cf46b542b$export$bfb6a372146ddc96)(props, (0, $3a6bc0570b633afe$export$d2f18f636bf00f54));
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const variantClass = (0, $01W3b.toRef)(()=>props.variant && `v-expansion-panels--variant-${props.variant}`);
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VExpansionPanel: {
                bgColor: (0, $01W3b.toRef)(()=>props.bgColor),
                collapseIcon: (0, $01W3b.toRef)(()=>props.collapseIcon),
                color: (0, $01W3b.toRef)(()=>props.color),
                eager: (0, $01W3b.toRef)(()=>props.eager),
                elevation: (0, $01W3b.toRef)(()=>props.elevation),
                expandIcon: (0, $01W3b.toRef)(()=>props.expandIcon),
                focusable: (0, $01W3b.toRef)(()=>props.focusable),
                hideActions: (0, $01W3b.toRef)(()=>props.hideActions),
                readonly: (0, $01W3b.toRef)(()=>props.readonly),
                ripple: (0, $01W3b.toRef)(()=>props.ripple),
                rounded: (0, $01W3b.toRef)(()=>props.rounded),
                static: (0, $01W3b.toRef)(()=>props.static)
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-expansion-panels',
                    {
                        'v-expansion-panels--flat': props.flat,
                        'v-expansion-panels--tile': props.tile
                    },
                    themeClasses.value,
                    variantClass.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        slots.default?.({
                            prev: prev,
                            next: next
                        })
                    ]
            }));
        return {
            next: next,
            prev: prev
        };
    }
});







var $e220c3f8751ffdf3$exports = {};

$parcel$export($e220c3f8751ffdf3$exports, "VFab", () => $442ec98e7c65c495$export$baad3d897c61ee66);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");









const $442ec98e7c65c495$export$7520e5745fcec8e3 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    app: Boolean,
    appear: Boolean,
    extended: Boolean,
    layout: Boolean,
    offset: Boolean,
    modelValue: {
        type: Boolean,
        default: true
    },
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $a343b25403be30b7$export$64daea74540bd34d)({
        active: true
    }), [
        'location',
        'spaced'
    ]),
    ...(0, $56e08e0125137781$export$d42abac634ace931)(),
    ...(0, $636e88b893afba47$export$2831add577f947cb)(),
    ...(0, $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e)({
        transition: 'fab-transition'
    })
}, 'VFab');
const $442ec98e7c65c495$export$baad3d897c61ee66 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VFab',
    props: $442ec98e7c65c495$export$7520e5745fcec8e3(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const height = (0, $01W3b.shallowRef)(56);
        const layoutItemStyles = (0, $01W3b.ref)();
        const { resizeRef: resizeRef } = (0, $d80db15b6452c606$export$683480f191c0e3ea)((entries)=>{
            if (!entries.length) return;
            height.value = entries[0].target.clientHeight;
        });
        const hasPosition = (0, $01W3b.toRef)(()=>props.app || props.absolute);
        const position = (0, $01W3b.computed)(()=>{
            if (!hasPosition.value) return false;
            return props.location?.split(' ').shift() ?? 'bottom';
        });
        const orientation = (0, $01W3b.computed)(()=>{
            if (!hasPosition.value) return false;
            return props.location?.split(' ')[1] ?? 'end';
        });
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>props.app, ()=>{
            const layout = (0, $56e08e0125137781$export$e2f4c0dffffc8723)({
                id: props.name,
                order: (0, $01W3b.computed)(()=>parseInt(props.order, 10)),
                position: position,
                layoutSize: (0, $01W3b.computed)(()=>props.layout ? height.value + 24 : 0),
                elementSize: (0, $01W3b.computed)(()=>height.value + 24),
                active: (0, $01W3b.computed)(()=>props.app && model.value),
                absolute: (0, $01W3b.toRef)(()=>props.absolute)
            });
            (0, $TusQn.watchEffect)(()=>{
                layoutItemStyles.value = layout.layoutItemStyles.value;
            });
        });
        const vFabRef = (0, $01W3b.ref)();
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const btnProps = (0, $a343b25403be30b7$export$657f28cf887b91a6).filterProps(props);
            return (0, $TusQn.createElementVNode)("div", {
                "ref": vFabRef,
                "class": (0, $8POXm.normalizeClass)([
                    'v-fab',
                    {
                        'v-fab--absolute': props.absolute,
                        'v-fab--app': !!props.app,
                        'v-fab--extended': props.extended,
                        'v-fab--offset': props.offset,
                        [`v-fab--${position.value}`]: hasPosition.value,
                        [`v-fab--${orientation.value}`]: hasPosition.value
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    props.app ? {
                        ...layoutItemStyles.value
                    } : {
                        height: props.absolute ? '100%' : 'inherit'
                    },
                    props.style
                ])
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-fab__container"
                }, [
                    (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                        "appear": props.appear,
                        "transition": props.transition
                    }, {
                        default: ()=>[
                                (0, $TusQn.withDirectives)((0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                                    "ref": resizeRef
                                }, btnProps, {
                                    "active": undefined,
                                    "location": undefined
                                }), slots), [
                                    [
                                        (0, $eeJ70.vShow),
                                        props.active
                                    ]
                                ])
                            ]
                    })
                ])
            ]);
        });
        return {};
    }
});




var $b6aef855d25735ca$exports = {};

$parcel$export($b6aef855d25735ca$exports, "VField", () => $d4f131cf7ef9c4a9$export$3180fb4997e9f72d);
$parcel$export($b6aef855d25735ca$exports, "VFieldLabel", () => $17964605b7b058af$export$1a74b2f7ba75e1db);




var $791bb0104a400f65$exports = {};

$parcel$export($791bb0104a400f65$exports, "VFileInput", () => $0daad1377386774e$export$1492afa4b6f123c9);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");






// Types
function $85dca309be8db446$export$fffcc0a7404f3668() {
    function hasFilesOrFolders(e) {
        const entries = [
            ...e.dataTransfer?.items ?? []
        ].filter((x)=>x.kind === 'file').map((x)=>x.webkitGetAsEntry()).filter(Boolean);
        return entries.length > 0 || [
            ...e.dataTransfer?.files ?? []
        ].length > 0;
    }
    async function handleDrop(e) {
        const result = [];
        const entries = [
            ...e.dataTransfer?.items ?? []
        ].filter((x)=>x.kind === 'file').map((x)=>x.webkitGetAsEntry()).filter(Boolean);
        if (entries.length) for (const entry of entries){
            const files = await $85dca309be8db446$var$traverseFileTree(entry, $85dca309be8db446$var$appendIfDirectory('.', entry));
            result.push(...files.map((x)=>x.file));
        }
        else result.push(...[
            ...e.dataTransfer?.files ?? []
        ]);
        return result;
    }
    return {
        handleDrop: handleDrop,
        hasFilesOrFolders: hasFilesOrFolders
    };
}
function $85dca309be8db446$var$traverseFileTree(item) {
    let path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return new Promise((resolve, reject)=>{
        if (item.isFile) {
            const fileEntry = item;
            fileEntry.file((file)=>resolve([
                    {
                        file: file,
                        path: path
                    }
                ]), reject);
        } else if (item.isDirectory) {
            const directoryReader = item.createReader();
            directoryReader.readEntries(async (entries)=>{
                const files = [];
                for (const entry of entries)files.push(...await $85dca309be8db446$var$traverseFileTree(entry, $85dca309be8db446$var$appendIfDirectory(path, entry)));
                resolve(files);
            });
        }
    });
}
function $85dca309be8db446$var$appendIfDirectory(path, item) {
    return item.isDirectory ? `${path}/${item.name}` : path;
}


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");

const $641191aab3d16773$export$5705d7ba596b5e5 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    filterByType: String
}, 'file-accept');
function $641191aab3d16773$export$63ba9a5b23e4762(props) {
    const fileFilter = (0, $01W3b.computed)(()=>props.filterByType ? $641191aab3d16773$var$createFilter(props.filterByType) : null);
    function filterAccepted(files) {
        if (fileFilter.value) {
            const accepted = files.filter(fileFilter.value);
            return {
                accepted: accepted,
                rejected: files.filter((f)=>!accepted.includes(f))
            };
        }
        return {
            accepted: files,
            rejected: []
        };
    }
    return {
        filterAccepted: filterAccepted
    };
}
function $641191aab3d16773$var$createFilter(v) {
    const types = v.split(',').map((x)=>x.trim().toLowerCase());
    const extensionsToMatch = types.filter((x)=>x.startsWith('.'));
    const wildcards = types.filter((x)=>x.endsWith('/*'));
    const typesToMatch = types.filter((x)=>!extensionsToMatch.includes(x) && !wildcards.includes(x));
    return (file)=>{
        const extension = file.name.split('.').at(-1)?.toLowerCase() ?? '';
        const typeGroup = file.type.split('/').at(0)?.toLowerCase() ?? '';
        return typesToMatch.includes(file.type) || extensionsToMatch.includes(`.${extension}`) || wildcards.includes(`${typeGroup}/*`);
    };
}







const $0daad1377386774e$export$252244107ea9668e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    chips: Boolean,
    counter: Boolean,
    counterSizeString: {
        type: String,
        default: '$vuetify.fileInput.counterSize'
    },
    counterString: {
        type: String,
        default: '$vuetify.fileInput.counter'
    },
    hideInput: Boolean,
    multiple: Boolean,
    showSize: {
        type: [
            Boolean,
            Number,
            String
        ],
        default: false,
        validator: (v)=>{
            return typeof v === 'boolean' || [
                1000,
                1024
            ].includes(Number(v));
        }
    },
    truncateLength: {
        type: [
            Number,
            String
        ],
        default: 22
    },
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $97e8c489e405a584$export$525655a73981d616)({
        prependIcon: '$file'
    }), [
        'direction'
    ]),
    modelValue: {
        type: [
            Array,
            Object
        ],
        default: (props)=>props.multiple ? [] : null,
        validator: (val)=>{
            return (0, $8590040a7833369a$export$76411cac38121ecb)(val).every((v)=>v != null && typeof v === 'object');
        }
    },
    ...(0, $641191aab3d16773$export$5705d7ba596b5e5)(),
    ...(0, $d4f131cf7ef9c4a9$export$1e13429dc53b9634)({
        clearable: true
    })
}, 'VFileInput');
const $0daad1377386774e$export$1492afa4b6f123c9 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VFileInput',
    inheritAttrs: false,
    props: $0daad1377386774e$export$252244107ea9668e(),
    emits: {
        'click:control': (e)=>true,
        'mousedown:control': (e)=>true,
        'update:focused': (focused)=>true,
        'update:modelValue': (files)=>true,
        rejected: (files)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { filterAccepted: filterAccepted } = (0, $641191aab3d16773$export$63ba9a5b23e4762)(props);
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', props.modelValue, (val)=>(0, $8590040a7833369a$export$76411cac38121ecb)(val), (val)=>!props.multiple && Array.isArray(val) ? val[0] : val);
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $fdb5f7d63722b03f$export$f8168d8dd8fd66e6)(props);
        const base = (0, $01W3b.computed)(()=>typeof props.showSize !== 'boolean' ? props.showSize : undefined);
        const totalBytes = (0, $01W3b.computed)(()=>(model.value ?? []).reduce((bytes, _ref2)=>{
                let { size: size = 0 } = _ref2;
                return bytes + size;
            }, 0));
        const totalBytesReadable = (0, $01W3b.computed)(()=>(0, $8590040a7833369a$export$dfc82bc1332b0cba)(totalBytes.value, base.value));
        const fileNames = (0, $01W3b.computed)(()=>(model.value ?? []).map((file)=>{
                const { name: name = '', size: size = 0 } = file;
                const truncatedText = truncateText(name);
                return !props.showSize ? truncatedText : `${truncatedText} (${(0, $8590040a7833369a$export$dfc82bc1332b0cba)(size, base.value)})`;
            }));
        const counterValue = (0, $01W3b.computed)(()=>{
            const fileCount = model.value?.length ?? 0;
            if (props.showSize) return t(props.counterSizeString, fileCount, totalBytesReadable.value);
            else return t(props.counterString, fileCount);
        });
        const vInputRef = (0, $01W3b.ref)();
        const vFieldRef = (0, $01W3b.ref)();
        const inputRef = (0, $01W3b.ref)();
        const isActive = (0, $01W3b.toRef)(()=>isFocused.value || props.active);
        const isPlainOrUnderlined = (0, $01W3b.computed)(()=>[
                'plain',
                'underlined'
            ].includes(props.variant));
        const isDragging = (0, $01W3b.shallowRef)(false);
        const { handleDrop: handleDrop, hasFilesOrFolders: hasFilesOrFolders } = (0, $85dca309be8db446$export$fffcc0a7404f3668)();
        function onFocus() {
            if (inputRef.value !== document.activeElement) inputRef.value?.focus();
            if (!isFocused.value) focus();
        }
        function onClickPrepend(e) {
            inputRef.value?.click();
        }
        function onControlMousedown(e) {
            emit('mousedown:control', e);
        }
        function onControlClick(e) {
            inputRef.value?.click();
            emit('click:control', e);
        }
        function onClear(e) {
            e.stopPropagation();
            onFocus();
            (0, $TusQn.nextTick)(()=>{
                model.value = [];
                (0, $8590040a7833369a$export$293b251ea77dc2b7)(props['onClick:clear'], e);
            });
        }
        function truncateText(str) {
            if (str.length < Number(props.truncateLength)) return str;
            const charsKeepOneSide = Math.floor((Number(props.truncateLength) - 1) / 2);
            return `${str.slice(0, charsKeepOneSide)}\u{2026}${str.slice(str.length - charsKeepOneSide)}`;
        }
        function onDragover(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            isDragging.value = true;
        }
        function onDragleave(e) {
            e.preventDefault();
            isDragging.value = false;
        }
        async function onDrop(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            isDragging.value = false;
            if (!inputRef.value || !hasFilesOrFolders(e)) return;
            const allDroppedFiles = await handleDrop(e);
            selectAccepted(allDroppedFiles);
        }
        function onFileSelection(e) {
            if (!e.target || e.repack) return; // prevent loop
            if (!props.filterByType) {
                const target = e.target;
                model.value = [
                    ...target.files ?? []
                ];
            } else selectAccepted([
                ...e.target.files
            ]);
        }
        function selectAccepted(files) {
            const dataTransfer = new DataTransfer();
            const { accepted: accepted, rejected: rejected } = filterAccepted(files);
            if (rejected.length) emit('rejected', rejected);
            for (const file of accepted)dataTransfer.items.add(file);
            inputRef.value.files = dataTransfer.files;
            model.value = [
                ...dataTransfer.files
            ];
            const event = new Event('change', {
                bubbles: true
            });
            event.repack = true;
            inputRef.value.dispatchEvent(event);
        }
        (0, $01W3b.watch)(model, (newValue)=>{
            const hasModelReset = !Array.isArray(newValue) || !newValue.length;
            if (hasModelReset && inputRef.value) inputRef.value.value = '';
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasCounter = !!(slots.counter || props.counter);
            const hasDetails = !!(hasCounter || slots.details);
            const [rootAttrs, inputAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            const { modelValue: _, ...inputProps } = (0, $97e8c489e405a584$export$2aca538d9f87f6ac).filterProps(props);
            const fieldProps = {
                ...(0, $d4f131cf7ef9c4a9$export$3180fb4997e9f72d).filterProps(props),
                'onClick:clear': onClear
            };
            const expectsDirectory = attrs.webkitdirectory !== undefined && attrs.webkitdirectory !== false;
            const acceptFallback = attrs.accept ? String(attrs.accept) : undefined;
            const inputAccept = expectsDirectory ? undefined : props.filterByType ?? acceptFallback;
            return (0, $TusQn.createVNode)((0, $97e8c489e405a584$export$2aca538d9f87f6ac), (0, $TusQn.mergeProps)({
                "ref": vInputRef,
                "modelValue": props.multiple ? model.value : model.value[0],
                "class": [
                    'v-file-input',
                    {
                        'v-file-input--chips': !!props.chips,
                        'v-file-input--dragging': isDragging.value,
                        'v-file-input--hide': props.hideInput,
                        'v-input--plain-underlined': isPlainOrUnderlined.value
                    },
                    props.class
                ],
                "style": props.style,
                "onClick:prepend": onClickPrepend
            }, rootAttrs, inputProps, {
                "centerAffix": !isPlainOrUnderlined.value,
                "focused": isFocused.value
            }), {
                ...slots,
                default: (_ref3)=>{
                    let { id: id, isDisabled: isDisabled, isDirty: isDirty, isReadonly: isReadonly, isValid: isValid, hasDetails: hasDetails } = _ref3;
                    return (0, $TusQn.createVNode)((0, $d4f131cf7ef9c4a9$export$3180fb4997e9f72d), (0, $TusQn.mergeProps)({
                        "ref": vFieldRef,
                        "prependIcon": props.prependIcon,
                        "onMousedown": onControlMousedown,
                        "onClick": onControlClick,
                        "onClick:prependInner": props['onClick:prependInner'],
                        "onClick:appendInner": props['onClick:appendInner']
                    }, fieldProps, {
                        "id": id.value,
                        "active": isActive.value || isDirty.value,
                        "dirty": isDirty.value || props.dirty,
                        "disabled": isDisabled.value,
                        "focused": isFocused.value,
                        "details": hasDetails.value,
                        "error": isValid.value === false,
                        "onDragover": onDragover,
                        "onDrop": onDrop
                    }), {
                        ...slots,
                        default: (_ref4)=>{
                            let { props: { class: fieldClass, ...slotProps }, controlRef: controlRef } = _ref4;
                            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                (0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                                    "ref": (val)=>inputRef.value = controlRef.value = val,
                                    "type": "file",
                                    "accept": inputAccept,
                                    "readonly": isReadonly.value,
                                    "disabled": isDisabled.value,
                                    "multiple": props.multiple,
                                    "name": props.name,
                                    "onClick": (e)=>{
                                        e.stopPropagation();
                                        if (isReadonly.value) e.preventDefault();
                                        onFocus();
                                    },
                                    "onChange": onFileSelection,
                                    "onDragleave": onDragleave,
                                    "onFocus": onFocus,
                                    "onBlur": blur
                                }, slotProps, inputAttrs), null),
                                (0, $TusQn.createElementVNode)("div", {
                                    "class": (0, $8POXm.normalizeClass)(fieldClass)
                                }, [
                                    !!model.value?.length && !props.hideInput && (slots.selection ? slots.selection({
                                        fileNames: fileNames.value,
                                        totalBytes: totalBytes.value,
                                        totalBytesReadable: totalBytesReadable.value
                                    }) : props.chips ? fileNames.value.map((text)=>(0, $TusQn.createVNode)((0, $fd0891698b65ffb1$export$1b5fab12cd17b4fb), {
                                            "key": text,
                                            "size": "small",
                                            "text": text
                                        }, null)) : fileNames.value.join(', '))
                                ])
                            ]);
                        }
                    });
                },
                details: hasDetails ? (slotProps)=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots.details?.(slotProps),
                        hasCounter && (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                            (0, $TusQn.createElementVNode)("span", null, null),
                            (0, $TusQn.createVNode)((0, $b240aced8b361832$export$45efeae449ff2094), {
                                "active": !!model.value?.length,
                                "value": counterValue.value,
                                "disabled": props.disabled
                            }, slots.counter)
                        ])
                    ]) : undefined
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, vInputRef, vFieldRef, inputRef);
    }
});




var $c5b023e19262b277$exports = {};

$parcel$export($c5b023e19262b277$exports, "VFooter", () => $8886226de4991d23$export$81b275eb93e8d5bb);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");












const $8886226de4991d23$export$6f12c637938afaa3 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    app: Boolean,
    color: String,
    height: {
        type: [
            Number,
            String
        ],
        default: 'auto'
    },
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $56e08e0125137781$export$d42abac634ace931)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'footer'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VFooter');
const $8886226de4991d23$export$81b275eb93e8d5bb = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VFooter',
    props: $8886226de4991d23$export$6f12c637938afaa3(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const layoutItemStyles = (0, $01W3b.ref)();
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const autoHeight = (0, $01W3b.shallowRef)(32);
        const { resizeRef: resizeRef } = (0, $d80db15b6452c606$export$683480f191c0e3ea)((entries)=>{
            if (!entries.length) return;
            autoHeight.value = entries[0].target.clientHeight;
        });
        const height = (0, $01W3b.computed)(()=>props.height === 'auto' ? autoHeight.value : parseInt(props.height, 10));
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>props.app, ()=>{
            const layout = (0, $56e08e0125137781$export$e2f4c0dffffc8723)({
                id: props.name,
                order: (0, $01W3b.computed)(()=>parseInt(props.order, 10)),
                position: (0, $01W3b.toRef)(()=>'bottom'),
                layoutSize: height,
                elementSize: (0, $01W3b.computed)(()=>props.height === 'auto' ? undefined : height.value),
                active: (0, $01W3b.toRef)(()=>props.app),
                absolute: (0, $01W3b.toRef)(()=>props.absolute)
            });
            (0, $TusQn.watchEffect)(()=>{
                layoutItemStyles.value = layout.layoutItemStyles.value;
            });
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "ref": resizeRef,
                "class": (0, $8POXm.normalizeClass)([
                    'v-footer',
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.app ? layoutItemStyles.value : {
                        height: (0, $8590040a7833369a$export$286ad215293a0860)(props.height)
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});




var $edd26d6e6e16e2aa$exports = {};

$parcel$export($edd26d6e6e16e2aa$exports, "VForm", () => $251b9f8a41434a22$export$6f5d3162e9efbcf3);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");




const $251b9f8a41434a22$export$af2296a8595b5d52 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $72bfe1fa0cde9e24$export$be046af95b8d4645)()
}, 'VForm');
const $251b9f8a41434a22$export$6f5d3162e9efbcf3 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VForm',
    props: $251b9f8a41434a22$export$af2296a8595b5d52(),
    emits: {
        'update:modelValue': (val)=>true,
        submit: (e)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const form = (0, $72bfe1fa0cde9e24$export$f681a8129d2e9d28)(props);
        const formRef = (0, $01W3b.ref)();
        function onReset(e) {
            e.preventDefault();
            form.reset();
        }
        function onSubmit(_e) {
            const e = _e;
            const ready = form.validate();
            e.then = ready.then.bind(ready);
            e.catch = ready.catch.bind(ready);
            e.finally = ready.finally.bind(ready);
            emit('submit', e);
            if (!e.defaultPrevented) ready.then((_ref2)=>{
                let { valid: valid } = _ref2;
                if (valid) formRef.value?.submit();
            });
            e.preventDefault();
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("form", {
                "ref": formRef,
                "class": (0, $8POXm.normalizeClass)([
                    'v-form',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style),
                "novalidate": true,
                "onReset": onReset,
                "onSubmit": onSubmit
            }, [
                slots.default?.(form)
            ]));
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)(form, formRef);
    }
});




var $34eecb7f838ad241$exports = {};

$parcel$export($34eecb7f838ad241$exports, "VContainer", () => $b31397dd182edfc0$export$e6680f8f89b2ee43);
$parcel$export($34eecb7f838ad241$exports, "VCol", () => $51ab779ea8f1dee3$export$f063fe9fd55e6980);
$parcel$export($34eecb7f838ad241$exports, "VRow", () => $52a4ca3ea778c138$export$978f7f00e11cd63);
$parcel$export($34eecb7f838ad241$exports, "VSpacer", () => $b2fc64d8d70f01a3$export$78e533170324578f);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");






const $b31397dd182edfc0$export$a3b8e03bf0677e95 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    fluid: {
        type: Boolean,
        default: false
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VContainer');
const $b31397dd182edfc0$export$e6680f8f89b2ee43 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VContainer',
    props: $b31397dd182edfc0$export$a3b8e03bf0677e95(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-container',
                    {
                        'v-container--fluid': props.fluid
                    },
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, slots));
        return {};
    }
});


// Styles




parcelRequire("ecd4d");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $51ab779ea8f1dee3$var$breakpointProps = (()=>{
    return (0, $1444e2cf1a712792$export$d07517a676ce386f).reduce((props, val)=>{
        props[val] = {
            type: [
                Boolean,
                String,
                Number
            ],
            default: false
        };
        return props;
    }, {});
})();
const $51ab779ea8f1dee3$var$offsetProps = (()=>{
    return (0, $1444e2cf1a712792$export$d07517a676ce386f).reduce((props, val)=>{
        const offsetKey = 'offset' + (0, $8POXm.capitalize)(val);
        props[offsetKey] = {
            type: [
                String,
                Number
            ],
            default: null
        };
        return props;
    }, {});
})();
const $51ab779ea8f1dee3$var$orderProps = (()=>{
    return (0, $1444e2cf1a712792$export$d07517a676ce386f).reduce((props, val)=>{
        const orderKey = 'order' + (0, $8POXm.capitalize)(val);
        props[orderKey] = {
            type: [
                String,
                Number
            ],
            default: null
        };
        return props;
    }, {});
})();
const $51ab779ea8f1dee3$var$propMap = {
    col: Object.keys($51ab779ea8f1dee3$var$breakpointProps),
    offset: Object.keys($51ab779ea8f1dee3$var$offsetProps),
    order: Object.keys($51ab779ea8f1dee3$var$orderProps)
};
function $51ab779ea8f1dee3$var$breakpointClass(type, prop, val) {
    let className = type;
    if (val == null || val === false) return undefined;
    if (prop) {
        const breakpoint = prop.replace(type, '');
        className += `-${breakpoint}`;
    }
    if (type === 'col') className = 'v-' + className;
    // Handling the boolean style prop when accepting [Boolean, String, Number]
    // means Vue will not convert <v-col sm></v-col> to sm: true for us.
    // Since the default is false, an empty string indicates the prop's presence.
    if (type === 'col' && (val === '' || val === true)) // .v-col-md
    return className.toLowerCase();
    // .order-md-6
    className += `-${val}`;
    return className.toLowerCase();
}
const $51ab779ea8f1dee3$var$ALIGN_SELF_VALUES = [
    'auto',
    'start',
    'end',
    'center',
    'baseline',
    'stretch'
];
const $51ab779ea8f1dee3$export$8170474963c9327d = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    cols: {
        type: [
            Boolean,
            String,
            Number
        ],
        default: false
    },
    ...$51ab779ea8f1dee3$var$breakpointProps,
    offset: {
        type: [
            String,
            Number
        ],
        default: null
    },
    ...$51ab779ea8f1dee3$var$offsetProps,
    order: {
        type: [
            String,
            Number
        ],
        default: null
    },
    ...$51ab779ea8f1dee3$var$orderProps,
    alignSelf: {
        type: String,
        default: null,
        validator: (str)=>$51ab779ea8f1dee3$var$ALIGN_SELF_VALUES.includes(str)
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VCol');
const $51ab779ea8f1dee3$export$f063fe9fd55e6980 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VCol',
    props: $51ab779ea8f1dee3$export$8170474963c9327d(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const classes = (0, $01W3b.computed)(()=>{
            const classList = [];
            // Loop through `col`, `offset`, `order` breakpoint props
            let type;
            for(type in $51ab779ea8f1dee3$var$propMap)$51ab779ea8f1dee3$var$propMap[type].forEach((prop)=>{
                const value = props[prop];
                const className = $51ab779ea8f1dee3$var$breakpointClass(type, prop, value);
                if (className) classList.push(className);
            });
            const hasColClasses = classList.some((className)=>className.startsWith('v-col-'));
            classList.push({
                // Default to .v-col if no other col-{bp}-* classes generated nor `cols` specified.
                'v-col': !hasColClasses || !props.cols,
                [`v-col-${props.cols}`]: props.cols,
                [`offset-${props.offset}`]: props.offset,
                [`order-${props.order}`]: props.order,
                [`align-self-${props.alignSelf}`]: props.alignSelf
            });
            return classList;
        });
        return ()=>(0, $TusQn.h)(props.tag, {
                class: [
                    classes.value,
                    props.class
                ],
                style: props.style
            }, slots.default?.());
    }
});


// Styles




parcelRequire("ecd4d");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

const $52a4ca3ea778c138$var$ALIGNMENT = [
    'start',
    'end',
    'center'
];
const $52a4ca3ea778c138$var$SPACE = [
    'space-between',
    'space-around',
    'space-evenly'
];
function $52a4ca3ea778c138$var$makeRowProps(prefix, def) {
    return (0, $1444e2cf1a712792$export$d07517a676ce386f).reduce((props, val)=>{
        const prefixKey = prefix + (0, $8POXm.capitalize)(val);
        props[prefixKey] = def();
        return props;
    }, {});
}
const $52a4ca3ea778c138$var$ALIGN_VALUES = [
    ...$52a4ca3ea778c138$var$ALIGNMENT,
    'baseline',
    'stretch'
];
const $52a4ca3ea778c138$var$alignValidator = (str)=>$52a4ca3ea778c138$var$ALIGN_VALUES.includes(str);
const $52a4ca3ea778c138$var$alignProps = $52a4ca3ea778c138$var$makeRowProps('align', ()=>({
        type: String,
        default: null,
        validator: $52a4ca3ea778c138$var$alignValidator
    }));
const $52a4ca3ea778c138$var$JUSTIFY_VALUES = [
    ...$52a4ca3ea778c138$var$ALIGNMENT,
    ...$52a4ca3ea778c138$var$SPACE
];
const $52a4ca3ea778c138$var$justifyValidator = (str)=>$52a4ca3ea778c138$var$JUSTIFY_VALUES.includes(str);
const $52a4ca3ea778c138$var$justifyProps = $52a4ca3ea778c138$var$makeRowProps('justify', ()=>({
        type: String,
        default: null,
        validator: $52a4ca3ea778c138$var$justifyValidator
    }));
const $52a4ca3ea778c138$var$ALIGN_CONTENT_VALUES = [
    ...$52a4ca3ea778c138$var$ALIGNMENT,
    ...$52a4ca3ea778c138$var$SPACE,
    'stretch'
];
const $52a4ca3ea778c138$var$alignContentValidator = (str)=>$52a4ca3ea778c138$var$ALIGN_CONTENT_VALUES.includes(str);
const $52a4ca3ea778c138$var$alignContentProps = $52a4ca3ea778c138$var$makeRowProps('alignContent', ()=>({
        type: String,
        default: null,
        validator: $52a4ca3ea778c138$var$alignContentValidator
    }));
const $52a4ca3ea778c138$var$propMap = {
    align: Object.keys($52a4ca3ea778c138$var$alignProps),
    justify: Object.keys($52a4ca3ea778c138$var$justifyProps),
    alignContent: Object.keys($52a4ca3ea778c138$var$alignContentProps)
};
const $52a4ca3ea778c138$var$classMap = {
    align: 'align',
    justify: 'justify',
    alignContent: 'align-content'
};
function $52a4ca3ea778c138$var$breakpointClass(type, prop, val) {
    let className = $52a4ca3ea778c138$var$classMap[type];
    if (val == null) return undefined;
    if (prop) {
        // alignSm -> Sm
        const breakpoint = prop.replace(type, '');
        className += `-${breakpoint}`;
    }
    // .align-items-sm-center
    className += `-${val}`;
    return className.toLowerCase();
}
const $52a4ca3ea778c138$export$aa6139b66bca50c0 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    dense: Boolean,
    noGutters: Boolean,
    align: {
        type: String,
        default: null,
        validator: $52a4ca3ea778c138$var$alignValidator
    },
    ...$52a4ca3ea778c138$var$alignProps,
    justify: {
        type: String,
        default: null,
        validator: $52a4ca3ea778c138$var$justifyValidator
    },
    ...$52a4ca3ea778c138$var$justifyProps,
    alignContent: {
        type: String,
        default: null,
        validator: $52a4ca3ea778c138$var$alignContentValidator
    },
    ...$52a4ca3ea778c138$var$alignContentProps,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VRow');
const $52a4ca3ea778c138$export$978f7f00e11cd63 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VRow',
    props: $52a4ca3ea778c138$export$aa6139b66bca50c0(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const classes = (0, $01W3b.computed)(()=>{
            const classList = [];
            // Loop through `align`, `justify`, `alignContent` breakpoint props
            let type;
            for(type in $52a4ca3ea778c138$var$propMap)$52a4ca3ea778c138$var$propMap[type].forEach((prop)=>{
                const value = props[prop];
                const className = $52a4ca3ea778c138$var$breakpointClass(type, prop, value);
                if (className) classList.push(className);
            });
            classList.push({
                'v-row--no-gutters': props.noGutters,
                'v-row--dense': props.dense,
                [`align-${props.align}`]: props.align,
                [`justify-${props.justify}`]: props.justify,
                [`align-content-${props.alignContent}`]: props.alignContent
            });
            return classList;
        });
        return ()=>(0, $TusQn.h)(props.tag, {
                class: [
                    'v-row',
                    classes.value,
                    props.class
                ],
                style: props.style
            }, slots.default?.());
    }
});





var $ffcda30d3b202e41$exports = {};

$parcel$export($ffcda30d3b202e41$exports, "VHotkey", () => $a2509c3668925ad1$export$89694605191252f);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");









const $1e805f7e5d41bb9a$export$db48029448d91dd8 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'kbd'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)()
}, 'VKbd');
const $1e805f7e5d41bb9a$export$ebd5060d8fa1579 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VKbd',
    props: $1e805f7e5d41bb9a$export$db48029448d91dd8(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-kbd',
                    themeClasses.value,
                    backgroundColorClasses.value,
                    borderClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    props.style
                ])
            }, slots));
        return {};
    }
});





// Utilities
/**
 * Centralized key alias mapping for consistent key normalization across the hotkey system.
 *
 * This maps various user-friendly aliases to canonical key names that match
 * KeyboardEvent.key values (in lowercase) where possible.
 */ const $d93e476df6a2425d$export$a0fa6033703f1d30 = {
    // Modifier aliases (from vue-use, other libraries, and current implementation)
    control: 'ctrl',
    command: 'cmd',
    option: 'alt',
    // Arrow key aliases (common abbreviations)
    up: 'arrowup',
    down: 'arrowdown',
    left: 'arrowleft',
    right: 'arrowright',
    // Other common key aliases
    esc: 'escape',
    spacebar: ' ',
    space: ' ',
    return: 'enter',
    del: 'delete',
    // Symbol aliases (existing from hotkey-parsing.ts)
    minus: '-',
    hyphen: '-'
};
function $d93e476df6a2425d$export$e0c709538cb8ae18(key) {
    const lowerKey = key.toLowerCase();
    return $d93e476df6a2425d$export$a0fa6033703f1d30[lowerKey] || lowerKey;
}



const $f6ac0a015a8ca65c$export$20ace67f8e186cc6 = [
    'ctrl',
    'shift',
    'alt',
    'meta',
    'cmd'
];
function $f6ac0a015a8ca65c$export$fb63ce0034a54b7(combination) {
    let isInternal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const emptyResult = {
        keys: [],
        separators: []
    };
    if (!combination) {
        if (!isInternal) (0, $5384ffc78a9e124c$export$222ba5e7254f2402)('Invalid hotkey combination: empty string provided');
        return emptyResult;
    }
    // --- VALIDATION ---
    const hasInvalidLeadingSeparator = combination.length > 1 && // Starts with a single separator followed by a non-separator character (e.g. '+a', '_a')
    [
        '+',
        '/',
        '_'
    ].some((v)=>combination.startsWith(v)) && ![
        '++',
        '//',
        '__'
    ].some((v)=>combination.startsWith(v));
    const hasInvalidStructure = hasInvalidLeadingSeparator || // Disallow literal + or _ keys (they require shift)
    combination.includes('++') || combination.includes('__') || combination === '+' || combination === '_' || // Ends with a separator that is not part of a doubled literal
    combination.length > 1 && (combination.endsWith('+') || combination.endsWith('_')) && combination.at(-2) !== combination.at(-1) || // Stand-alone doubled separators (dangling)
    combination === '++' || combination === '--' || combination === '__';
    if (hasInvalidStructure) {
        if (!isInternal) (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`Invalid hotkey combination: "${combination}" has invalid structure`);
        return emptyResult;
    }
    const keys = [];
    const separators = [];
    let buffer = '';
    const flushBuffer = (separator)=>{
        if (buffer) {
            separator && separators.push(separator);
            keys.push((0, $d93e476df6a2425d$export$e0c709538cb8ae18)(buffer));
            buffer = '';
        }
    };
    for(let i = 0; i < combination.length; i++){
        const char = combination[i];
        const nextChar = combination[i + 1];
        if ([
            '+',
            '/',
            '_',
            '-'
        ].includes(char)) {
            if (char === nextChar) {
                flushBuffer(char);
                keys.push(char);
                i++;
            } else if ([
                '+',
                '/',
                '_'
            ].includes(char)) flushBuffer(char);
            else buffer += char;
        } else buffer += char;
    }
    flushBuffer();
    // Within a combination, `-` is only valid as a literal key (e.g., `ctrl+-`).
    // `-` cannot be part of a longer key name within a combination.
    const hasInvalidMinus = keys.some((key)=>key.length > 1 && key.includes('-') && key !== '--');
    if (hasInvalidMinus) {
        if (!isInternal) (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`Invalid hotkey combination: "${combination}" has invalid structure`);
        return emptyResult;
    }
    if (keys.length === 0 && combination) return {
        keys: [
            (0, $d93e476df6a2425d$export$e0c709538cb8ae18)(combination)
        ],
        separators: separators
    };
    return {
        keys: keys,
        separators: separators
    };
}
function $f6ac0a015a8ca65c$export$550e35e0d7f2620c(str) {
    if (!str) {
        (0, $5384ffc78a9e124c$export$222ba5e7254f2402)('Invalid hotkey sequence: empty string provided');
        return [];
    }
    // A sequence is invalid if it starts or ends with a separator,
    // unless it is part of a combination (e.g., `shift+-`).
    const hasInvalidStart = str.startsWith('-') && ![
        '---',
        '--+'
    ].includes(str);
    const hasInvalidEnd = str.endsWith('-') && !str.endsWith('+-') && !str.endsWith('_-') && str !== '-' && str !== '---';
    if (hasInvalidStart || hasInvalidEnd) {
        (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`Invalid hotkey sequence: "${str}" contains invalid combinations`);
        return [];
    }
    const result = [];
    let buffer = '';
    let i = 0;
    while(i < str.length){
        const char = str[i];
        if (char === '-') {
            // Determine if this hyphen is part of the current combination
            const prevChar = str[i - 1];
            const prevPrevChar = i > 1 ? str[i - 2] : undefined;
            const precededBySeparator = [
                '+',
                '_'
            ].includes(prevChar) && ![
                '+',
                '/'
            ].includes(prevPrevChar ?? '');
            if (precededBySeparator) {
                // Treat as part of the combination (e.g., 'ctrl+-')
                buffer += char;
                i++;
            } else {
                // Treat as sequence separator
                if (buffer) {
                    result.push(buffer);
                    buffer = '';
                } else // Empty buffer means we have a literal '-' key
                result.push('-');
                i++;
            }
        } else {
            buffer += char;
            i++;
        }
    }
    // Add final buffer if it exists
    if (buffer) result.push(buffer);
    // Collapse runs of '-' so that every second '-' is removed
    const collapsed = [];
    let minusCount = 0;
    for (const part of result)if (part === '-') {
        if (minusCount % 2 === 0) collapsed.push('-');
        minusCount++;
    } else {
        minusCount = 0;
        collapsed.push(part);
    }
    // Validate that each part of the sequence is a valid combination
    const areAllValid = collapsed.every((s)=>$f6ac0a015a8ca65c$export$fb63ce0034a54b7(s, true).keys.length > 0);
    if (!areAllValid) {
        (0, $5384ffc78a9e124c$export$222ba5e7254f2402)(`Invalid hotkey sequence: "${str}" contains invalid combinations`);
        return [];
    }
    return collapsed;
}







// Display mode types for different visual representations
// Extended variant type that includes our custom 'contained' variant
// Key display tuple: [mode, content] where content is string or IconValue
// Key tuple: [mode, content, keycode] where content is string or IconValue
function $a2509c3668925ad1$var$processKey(config, requestedMode, isMac) {
    const keyCfg = isMac && config.mac ? config.mac : config.default;
    // 1. Resolve the safest display mode for the current platform
    const mode = (()=>{
        // If the requested mode lacks an asset, fall back to text
        if (requestedMode === 'icon' && !keyCfg.icon) return 'text';
        if (requestedMode === 'symbol' && !keyCfg.symbol) return 'text';
        return requestedMode;
    })();
    // 2. Pick value for the chosen mode, defaulting to text representation
    let value = keyCfg[mode] ?? keyCfg.text;
    // 3. Guard against icon tokens leaking into text mode (e.g. "$ctrl")
    if (mode === 'text' && typeof value === 'string' && value.startsWith('$') && !value.startsWith('$vuetify.')) value = value.slice(1).toUpperCase(); // "$ctrl" → "CTRL"
    return mode === 'icon' ? [
        'icon',
        value
    ] : [
        mode,
        value
    ];
}
const $a2509c3668925ad1$export$f3a221b103b8ec12 = {
    ctrl: {
        mac: {
            symbol: "\u2303",
            icon: '$ctrl',
            text: '$vuetify.hotkey.ctrl'
        },
        default: {
            text: 'Ctrl'
        }
    },
    meta: {
        mac: {
            symbol: "\u2318",
            icon: '$command',
            text: '$vuetify.hotkey.command'
        },
        default: {
            text: 'Ctrl'
        }
    },
    cmd: {
        mac: {
            symbol: "\u2318",
            icon: '$command',
            text: '$vuetify.hotkey.command'
        },
        default: {
            text: 'Ctrl'
        }
    },
    shift: {
        mac: {
            symbol: "\u21E7",
            icon: '$shift',
            text: '$vuetify.hotkey.shift'
        },
        default: {
            text: 'Shift'
        }
    },
    alt: {
        mac: {
            symbol: "\u2325",
            icon: '$alt',
            text: '$vuetify.hotkey.option'
        },
        default: {
            text: 'Alt'
        }
    },
    enter: {
        default: {
            symbol: "\u21B5",
            icon: '$enter',
            text: '$vuetify.hotkey.enter'
        }
    },
    arrowup: {
        default: {
            symbol: "\u2191",
            icon: '$arrowup',
            text: '$vuetify.hotkey.upArrow'
        }
    },
    arrowdown: {
        default: {
            symbol: "\u2193",
            icon: '$arrowdown',
            text: '$vuetify.hotkey.downArrow'
        }
    },
    arrowleft: {
        default: {
            symbol: "\u2190",
            icon: '$arrowleft',
            text: '$vuetify.hotkey.leftArrow'
        }
    },
    arrowright: {
        default: {
            symbol: "\u2192",
            icon: '$arrowright',
            text: '$vuetify.hotkey.rightArrow'
        }
    },
    backspace: {
        default: {
            symbol: "\u232B",
            icon: '$backspace',
            text: '$vuetify.hotkey.backspace'
        }
    },
    escape: {
        default: {
            text: '$vuetify.hotkey.escape'
        }
    },
    ' ': {
        mac: {
            symbol: "\u2423",
            icon: '$space',
            text: '$vuetify.hotkey.space'
        },
        default: {
            text: '$vuetify.hotkey.space'
        }
    },
    '-': {
        default: {
            text: '-'
        }
    }
};
const $a2509c3668925ad1$export$94e29fcb993e757e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    // String representing keyboard shortcuts (e.g., "ctrl+k", "meta+shift+p")
    keys: String,
    // How to display keys: 'symbol' uses special characters (⌘, ⌃), 'icon' uses SVG icons, 'text' uses words
    displayMode: {
        type: String,
        default: 'icon'
    },
    // Custom key mapping configuration. Users can import and modify the exported hotkeyMap as needed
    keyMap: {
        type: Object,
        default: ()=>$a2509c3668925ad1$export$f3a221b103b8ec12
    },
    platform: {
        type: String,
        default: 'auto'
    },
    inline: Boolean,
    disabled: Boolean,
    prefix: String,
    suffix: String,
    variant: {
        type: String,
        default: 'elevated',
        validator: (v)=>[
                'elevated',
                'flat',
                'tonal',
                'outlined',
                'text',
                'plain',
                'contained'
            ].includes(v)
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    color: String
}, 'VHotkey');
const $a2509c3668925ad1$var$AND_DELINEATOR = Symbol('VHotkey:AND_DELINEATOR'); // For + separators
const $a2509c3668925ad1$var$SLASH_DELINEATOR = Symbol('VHotkey:SLASH_DELINEATOR'); // For / separators
const $a2509c3668925ad1$var$THEN_DELINEATOR = Symbol('VHotkey:THEN_DELINEATOR'); // For - separators
function $a2509c3668925ad1$var$getKeyText(keyMap, key, isMac) {
    const lowerKey = key.toLowerCase();
    if (lowerKey in keyMap) {
        const result = $a2509c3668925ad1$var$processKey(keyMap[lowerKey], 'text', isMac);
        return typeof result[1] === 'string' ? result[1] : String(result[1]);
    }
    return key.toUpperCase();
}
function $a2509c3668925ad1$var$applyDisplayModeToKey(keyMap, mode, key, isMac) {
    const lowerKey = key.toLowerCase();
    if (lowerKey in keyMap) {
        const result = $a2509c3668925ad1$var$processKey(keyMap[lowerKey], mode, isMac);
        if (result[0] === 'text' && typeof result[1] === 'string' && result[1].startsWith('$') && !result[1].startsWith('$vuetify.')) return [
            'text',
            result[1].replace('$', '').toUpperCase(),
            key
        ];
        return [
            ...result,
            key
        ];
    }
    return [
        'text',
        key.toUpperCase(),
        key
    ];
}
const $a2509c3668925ad1$export$89694605191252f = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VHotkey',
    props: $a2509c3668925ad1$export$94e29fcb993e757e(),
    setup (props) {
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $567f01637e3e83ec$export$36ef81613f8f20fc)(()=>({
                color: props.color,
                variant: props.variant === 'contained' ? 'elevated' : props.variant
            }));
        const isMac = (0, $01W3b.computed)(()=>props.platform === 'auto' ? typeof navigator !== 'undefined' && /macintosh/i.test(navigator.userAgent) : props.platform === 'mac');
        const keyCombinations = (0, $01W3b.computed)(()=>{
            if (!props.keys) return [];
            // Split by spaces to handle multiple key combinations
            // Example: "ctrl+k meta+p" -> ["ctrl+k", "meta+p"]
            return props.keys.split(' ').map((combination)=>{
                const result = [];
                const sequenceGroups = (0, $f6ac0a015a8ca65c$export$550e35e0d7f2620c)(combination);
                for(let i = 0; i < sequenceGroups.length; i++){
                    const group = sequenceGroups[i];
                    // Add THEN delineator between sequence groups
                    if (i > 0) result.push($a2509c3668925ad1$var$THEN_DELINEATOR);
                    const { keys: keyParts, separators: separators } = (0, $f6ac0a015a8ca65c$export$fb63ce0034a54b7)(group);
                    for(let j = 0; j < keyParts.length; j++){
                        const part = keyParts[j];
                        // Add AND delineator between keys
                        if (j > 0) result.push(separators[j - 1] === '/' ? $a2509c3668925ad1$var$SLASH_DELINEATOR : $a2509c3668925ad1$var$AND_DELINEATOR);
                        result.push($a2509c3668925ad1$var$applyDisplayModeToKey(props.keyMap, props.displayMode, part, isMac.value));
                    }
                }
                return result;
            });
        });
        const accessibleLabel = (0, $01W3b.computed)(()=>{
            if (!props.keys) return '';
            // Convert the parsed key combinations into readable text
            const readableShortcuts = keyCombinations.value.map((combination)=>{
                const readableParts = [];
                for (const key of combination)if (Array.isArray(key)) {
                    // Always use text representation for screen readers
                    const textKey = key[0] === 'icon' || key[0] === 'symbol' ? $a2509c3668925ad1$var$applyDisplayModeToKey((0, $8590040a7833369a$export$dd702b3c8240390c)($a2509c3668925ad1$export$f3a221b103b8ec12, props.keyMap), 'text', String(key[1]), isMac.value)[1] : key[1];
                    readableParts.push(translateKey(textKey));
                } else {
                    if (key === $a2509c3668925ad1$var$AND_DELINEATOR) readableParts.push(t('$vuetify.hotkey.plus'));
                    else if (key === $a2509c3668925ad1$var$SLASH_DELINEATOR) readableParts.push(t('$vuetify.hotkey.or'));
                    else if (key === $a2509c3668925ad1$var$THEN_DELINEATOR) readableParts.push(t('$vuetify.hotkey.then'));
                }
                return readableParts.join(' ');
            });
            const shortcutText = readableShortcuts.join(', ');
            return t('$vuetify.hotkey.shortcut', shortcutText);
        });
        function translateKey(key) {
            return key.startsWith('$vuetify.') ? t(key) : key;
        }
        function getKeyTooltip(key) {
            if (props.displayMode === 'text') return undefined;
            const textKey = $a2509c3668925ad1$var$getKeyText(props.keyMap, String(key[2]), isMac.value);
            return translateKey(textKey);
        }
        function renderKey(key, keyIndex) {
            const isContained = props.variant === 'contained';
            const KeyComponent = isContained ? 'kbd' : (0, $1e805f7e5d41bb9a$export$ebd5060d8fa1579);
            const keyClasses = [
                'v-hotkey__key',
                `v-hotkey__key-${key[0]}`,
                ...isContained ? [
                    'v-hotkey__key--nested'
                ] : [
                    borderClasses.value,
                    roundedClasses.value,
                    elevationClasses.value,
                    colorClasses.value
                ]
            ];
            return (0, $TusQn.createVNode)(KeyComponent, {
                "key": keyIndex,
                "class": (0, $8POXm.normalizeClass)(keyClasses),
                "style": (0, $8POXm.normalizeStyle)(isContained ? undefined : colorStyles.value),
                "aria-hidden": "true",
                "title": getKeyTooltip(key)
            }, {
                default: ()=>[
                        key[0] === 'icon' ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                            "icon": key[1],
                            "aria-hidden": "true"
                        }, null) : translateKey(key[1])
                    ]
            });
        }
        function renderDivider(key, keyIndex) {
            return (0, $TusQn.createElementVNode)("span", {
                "key": keyIndex,
                "class": "v-hotkey__divider",
                "aria-hidden": "true"
            }, [
                key === $a2509c3668925ad1$var$AND_DELINEATOR ? '+' : key === $a2509c3668925ad1$var$SLASH_DELINEATOR ? '/' : t('$vuetify.hotkey.then')
            ]);
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const content = (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                props.prefix && (0, $TusQn.createElementVNode)("span", {
                    "key": "prefix",
                    "class": "v-hotkey__prefix"
                }, [
                    props.prefix
                ]),
                keyCombinations.value.map((combination, comboIndex)=>(0, $TusQn.createElementVNode)("span", {
                        "class": "v-hotkey__combination",
                        "key": comboIndex
                    }, [
                        combination.map((key, keyIndex)=>Array.isArray(key) ? renderKey(key, keyIndex) : renderDivider(key, keyIndex)),
                        comboIndex < keyCombinations.value.length - 1 && (0, $TusQn.createElementVNode)("span", {
                            "aria-hidden": "true"
                        }, [
                            (0, $TusQn.createTextVNode)("\xA0")
                        ])
                    ])),
                props.suffix && (0, $TusQn.createElementVNode)("span", {
                    "key": "suffix",
                    "class": "v-hotkey__suffix"
                }, [
                    props.suffix
                ])
            ]);
            return (0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-hotkey',
                    {
                        'v-hotkey--disabled': props.disabled,
                        'v-hotkey--inline': props.inline,
                        'v-hotkey--contained': props.variant === 'contained'
                    },
                    themeClasses.value,
                    rtlClasses.value,
                    variantClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style),
                "role": "img",
                "aria-label": accessibleLabel.value
            }, [
                props.variant !== 'contained' ? content : (0, $TusQn.createVNode)((0, $1e805f7e5d41bb9a$export$ebd5060d8fa1579), {
                    "key": "contained",
                    "class": (0, $8POXm.normalizeClass)([
                        'v-hotkey__contained-wrapper',
                        borderClasses.value,
                        roundedClasses.value,
                        elevationClasses.value,
                        colorClasses.value
                    ]),
                    "style": (0, $8POXm.normalizeStyle)(colorStyles.value),
                    "aria-hidden": "true"
                }, {
                    default: ()=>[
                            content
                        ]
                })
            ]);
        });
    }
});




var $6c2fb4dff887d405$exports = {};

$parcel$export($6c2fb4dff887d405$exports, "VHover", () => $87404a72b0c25164$export$18164602f71a6fd2);
// Composables



const $87404a72b0c25164$export$7189cef85a59ecb5 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    disabled: Boolean,
    modelValue: {
        type: Boolean,
        default: null
    },
    ...(0, $f7bca629b3eb404a$export$1fd3611e92a5a94)()
}, 'VHover');
const $87404a72b0c25164$export$18164602f71a6fd2 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VHover',
    props: $87404a72b0c25164$export$7189cef85a59ecb5(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isHovering = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = (0, $f7bca629b3eb404a$export$69f38700ea0cb3b9)(props, (value)=>!props.disabled && (isHovering.value = value));
        return ()=>slots.default?.({
                isHovering: isHovering.value,
                props: {
                    onMouseenter: runOpenDelay,
                    onMouseleave: runCloseDelay
                }
            });
    }
});




var $d5006c207627f7d0$exports = {};

$parcel$export($d5006c207627f7d0$exports, "VIcon", () => $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e);
$parcel$export($d5006c207627f7d0$exports, "VComponentIcon", () => $834ffcae3192e85e$export$151a4e51f3246587);
$parcel$export($d5006c207627f7d0$exports, "VSvgIcon", () => $834ffcae3192e85e$export$4cc49047f32a5a44);
$parcel$export($d5006c207627f7d0$exports, "VLigatureIcon", () => $834ffcae3192e85e$export$d478d4439906e556);
$parcel$export($d5006c207627f7d0$exports, "VClassIcon", () => $834ffcae3192e85e$export$87ef10dabc6ea763);




var $5f256f2181c3198b$exports = {};

$parcel$export($5f256f2181c3198b$exports, "VImg", () => $b2937780237888c4$export$126ec614c536f27c);



var $d7a101752c573377$exports = {};

$parcel$export($d7a101752c573377$exports, "VInfiniteScroll", () => $b38ea93213ed355f$export$ba012ad002651a77);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");








const $b38ea93213ed355f$export$18c07fd75b3c9bd8 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    direction: {
        type: String,
        default: 'vertical',
        validator: (v)=>[
                'vertical',
                'horizontal'
            ].includes(v)
    },
    side: {
        type: String,
        default: 'end',
        validator: (v)=>[
                'start',
                'end',
                'both'
            ].includes(v)
    },
    mode: {
        type: String,
        default: 'intersect',
        validator: (v)=>[
                'intersect',
                'manual'
            ].includes(v)
    },
    margin: [
        Number,
        String
    ],
    loadMoreText: {
        type: String,
        default: '$vuetify.infiniteScroll.loadMore'
    },
    emptyText: {
        type: String,
        default: '$vuetify.infiniteScroll.empty'
    },
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VInfiniteScroll');
const $b38ea93213ed355f$export$84669c010978ac95 = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VInfiniteScrollIntersect',
    props: {
        side: {
            type: String,
            required: true
        },
        rootMargin: String
    },
    emits: {
        intersect: (side, isIntersecting)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $16d02f6dfabde683$export$a7395f9832c00176)();
        (0, $01W3b.watch)(isIntersecting, async (val)=>{
            emit('intersect', props.side, val);
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": "v-infinite-scroll-intersect",
                "style": {
                    '--v-infinite-margin-size': props.rootMargin
                },
                "ref": intersectionRef
            }, [
                (0, $TusQn.createTextVNode)("\xA0")
            ]));
        return {};
    }
});
const $b38ea93213ed355f$export$ba012ad002651a77 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VInfiniteScroll',
    props: $b38ea93213ed355f$export$18c07fd75b3c9bd8(),
    emits: {
        load: (options)=>true
    },
    setup (props, _ref2) {
        let { slots: slots, emit: emit } = _ref2;
        const rootEl = (0, $01W3b.ref)();
        const startStatus = (0, $01W3b.shallowRef)('ok');
        const endStatus = (0, $01W3b.shallowRef)('ok');
        const margin = (0, $01W3b.computed)(()=>(0, $8590040a7833369a$export$286ad215293a0860)(props.margin));
        const isIntersecting = (0, $01W3b.shallowRef)(false);
        function setScrollAmount(amount) {
            if (!rootEl.value) return;
            const property = props.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
            rootEl.value[property] = amount;
        }
        function getScrollAmount() {
            if (!rootEl.value) return 0;
            const property = props.direction === 'vertical' ? 'scrollTop' : 'scrollLeft';
            return rootEl.value[property];
        }
        function getScrollSize() {
            if (!rootEl.value) return 0;
            const property = props.direction === 'vertical' ? 'scrollHeight' : 'scrollWidth';
            return rootEl.value[property];
        }
        function getContainerSize() {
            if (!rootEl.value) return 0;
            const property = props.direction === 'vertical' ? 'clientHeight' : 'clientWidth';
            return rootEl.value[property];
        }
        (0, $TusQn.onMounted)(()=>{
            if (!rootEl.value) return;
            if (props.side === 'start') setScrollAmount(getScrollSize());
            else if (props.side === 'both') setScrollAmount(getScrollSize() / 2 - getContainerSize() / 2);
        });
        function setStatus(side, status) {
            if (side === 'start') startStatus.value = status;
            else if (side === 'end') endStatus.value = status;
            else if (side === 'both') {
                startStatus.value = status;
                endStatus.value = status;
            }
        }
        function getStatus(side) {
            return side === 'start' ? startStatus.value : endStatus.value;
        }
        let previousScrollSize = 0;
        function handleIntersect(side, _isIntersecting) {
            isIntersecting.value = _isIntersecting;
            if (isIntersecting.value) intersecting(side);
        }
        function intersecting(side) {
            if (props.mode !== 'manual' && !isIntersecting.value) return;
            const status = getStatus(side);
            if (!rootEl.value || [
                'empty',
                'loading'
            ].includes(status)) return;
            previousScrollSize = getScrollSize();
            setStatus(side, 'loading');
            function done(status) {
                setStatus(side, status);
                (0, $TusQn.nextTick)(()=>{
                    if (status === 'empty' || status === 'error') return;
                    if (status === 'ok' && side === 'start') setScrollAmount(getScrollSize() - previousScrollSize + getScrollAmount());
                    if (props.mode !== 'manual') (0, $TusQn.nextTick)(()=>{
                        // Browser takes 2 - 3 animation frames to trigger IntersectionObserver after
                        // VInfiniteScrollIntersect leaves the viewpoint. So far I couldn't come up
                        // with a better solution than using 3 nested window.requestAnimationFrame. (#17475)
                        window.requestAnimationFrame(()=>{
                            window.requestAnimationFrame(()=>{
                                window.requestAnimationFrame(()=>{
                                    intersecting(side);
                                });
                            });
                        });
                    });
                });
            }
            emit('load', {
                side: side,
                done: done
            });
        }
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        function renderSide(side, status) {
            if (props.side !== side && props.side !== 'both') return;
            const onClick = ()=>intersecting(side);
            const slotProps = {
                side: side,
                props: {
                    onClick: onClick,
                    color: props.color
                }
            };
            if (status === 'error') return slots.error?.(slotProps);
            if (status === 'empty') return slots.empty?.(slotProps) ?? (0, $TusQn.createElementVNode)("div", null, [
                t(props.emptyText)
            ]);
            if (props.mode === 'manual') {
                if (status === 'loading') return slots.loading?.(slotProps) ?? (0, $TusQn.createVNode)((0, $26f3a281106a205d$export$2b4afd8de42c0c21), {
                    "indeterminate": true,
                    "color": props.color
                }, null);
                return slots['load-more']?.(slotProps) ?? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                    "variant": "outlined",
                    "color": props.color,
                    "onClick": onClick
                }, {
                    default: ()=>[
                            t(props.loadMoreText)
                        ]
                });
            }
            return slots.loading?.(slotProps) ?? (0, $TusQn.createVNode)((0, $26f3a281106a205d$export$2b4afd8de42c0c21), {
                "indeterminate": true,
                "color": props.color
            }, null);
        }
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const Tag = props.tag;
            const hasStartIntersect = props.side === 'start' || props.side === 'both';
            const hasEndIntersect = props.side === 'end' || props.side === 'both';
            const intersectMode = props.mode === 'intersect';
            return (0, $TusQn.createVNode)(Tag, {
                "ref": rootEl,
                "class": (0, $8POXm.normalizeClass)([
                    'v-infinite-scroll',
                    `v-infinite-scroll--${props.direction}`,
                    {
                        'v-infinite-scroll--start': hasStartIntersect,
                        'v-infinite-scroll--end': hasEndIntersect
                    }
                ]),
                "style": (0, $8POXm.normalizeStyle)(dimensionStyles.value)
            }, {
                default: ()=>[
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-infinite-scroll__side"
                        }, [
                            renderSide('start', startStatus.value)
                        ]),
                        hasStartIntersect && intersectMode && (0, $TusQn.createVNode)($b38ea93213ed355f$export$84669c010978ac95, {
                            "key": "start",
                            "side": "start",
                            "onIntersect": handleIntersect,
                            "rootMargin": margin.value
                        }, null),
                        slots.default?.(),
                        hasEndIntersect && intersectMode && (0, $TusQn.createVNode)($b38ea93213ed355f$export$84669c010978ac95, {
                            "key": "end",
                            "side": "end",
                            "onIntersect": handleIntersect,
                            "rootMargin": margin.value
                        }, null),
                        (0, $TusQn.createElementVNode)("div", {
                            "class": "v-infinite-scroll__side"
                        }, [
                            renderSide('end', endStatus.value)
                        ])
                    ]
            });
        });
        function reset(side) {
            const effectiveSide = side ?? props.side;
            setStatus(effectiveSide, 'ok');
            (0, $TusQn.nextTick)(()=>{
                if (effectiveSide !== 'end') setScrollAmount(getScrollSize() - previousScrollSize + getScrollAmount());
                if (props.mode !== 'manual') (0, $TusQn.nextTick)(()=>{
                    // See #17475
                    window.requestAnimationFrame(()=>{
                        window.requestAnimationFrame(()=>{
                            window.requestAnimationFrame(()=>{
                                if (effectiveSide === 'both') {
                                    intersecting('start');
                                    intersecting('end');
                                } else intersecting(effectiveSide);
                            });
                        });
                    });
                });
            });
        }
        return {
            reset: reset
        };
    }
});




var $aa3d51ae0888c1b0$exports = {};

$parcel$export($aa3d51ae0888c1b0$exports, "VInput", () => $97e8c489e405a584$export$2aca538d9f87f6ac);



var $42630e9a38458a70$exports = {};

$parcel$export($42630e9a38458a70$exports, "VItemGroup", () => $c3f951c88dddb804$export$a0421bb7deea7bc9);
$parcel$export($42630e9a38458a70$exports, "VItem", () => $c8ede78fb0aa85ee$export$89f8e1ba496bee4f);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");






const $c3f951c88dddb804$export$d47f675dc7233c18 = Symbol.for('vuetify:v-item-group');
const $c3f951c88dddb804$export$f9dfa1bfb55856d9 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $0befa53cf46b542b$export$fa4c05b3520340e6)({
        selectedClass: 'v-item--selected'
    }),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VItemGroup');
const $c3f951c88dddb804$export$a0421bb7deea7bc9 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VItemGroup',
    props: $c3f951c88dddb804$export$f9dfa1bfb55856d9(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { isSelected: isSelected, select: select, next: next, prev: prev, selected: selected } = (0, $0befa53cf46b542b$export$bfb6a372146ddc96)(props, $c3f951c88dddb804$export$d47f675dc7233c18);
        return ()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-item-group',
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        slots.default?.({
                            isSelected: isSelected,
                            select: select,
                            next: next,
                            prev: prev,
                            selected: selected.value
                        })
                    ]
            });
    }
});


// Composables



const $c8ede78fb0aa85ee$export$89f8e1ba496bee4f = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VItem',
    props: (0, $0befa53cf46b542b$export$e9e3b570044587e8)(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { isSelected: isSelected, select: select, toggle: toggle, selectedClass: selectedClass, value: value, disabled: disabled } = (0, $0befa53cf46b542b$export$eebde8160f061c26)(props, (0, $c3f951c88dddb804$export$d47f675dc7233c18));
        return ()=>slots.default?.({
                isSelected: isSelected.value,
                selectedClass: selectedClass.value,
                select: select,
                toggle: toggle,
                value: value.value,
                disabled: disabled.value
            });
    }
});




var $7043eac6db1dad1b$exports = {};

$parcel$export($7043eac6db1dad1b$exports, "VKbd", () => $1e805f7e5d41bb9a$export$ebd5060d8fa1579);
// Styles




var $cf25016f1e95f8a5$exports = {};

$parcel$export($cf25016f1e95f8a5$exports, "VLabel", () => $e23bfa10b64d3f5e$export$90281af35207eb21);



var $6a3feb2b77125fe4$exports = {};

$parcel$export($6a3feb2b77125fe4$exports, "VLayout", () => $9e8683be3de611af$export$fd7ac754308b2698);
$parcel$export($6a3feb2b77125fe4$exports, "VLayoutItem", () => $a8e19d39567b0f06$export$81da49e5190cd2c4);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");





const $9e8683be3de611af$export$eb6bcdcfbf5fa46c = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $56e08e0125137781$export$f0037fcffb4e2081)()
}, 'VLayout');
const $9e8683be3de611af$export$fd7ac754308b2698 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VLayout',
    props: $9e8683be3de611af$export$eb6bcdcfbf5fa46c(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { layoutClasses: layoutClasses, layoutStyles: layoutStyles, getLayoutItem: getLayoutItem, items: items, layoutRef: layoutRef } = (0, $56e08e0125137781$export$3dd437ade36ede40)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "ref": layoutRef,
                "class": (0, $8POXm.normalizeClass)([
                    layoutClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    dimensionStyles.value,
                    layoutStyles.value,
                    props.style
                ])
            }, [
                slots.default?.()
            ]));
        return {
            getLayoutItem: getLayoutItem,
            items: items
        };
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");




const $a8e19d39567b0f06$export$9e2dea49392136f7 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    position: {
        type: String,
        required: true
    },
    size: {
        type: [
            Number,
            String
        ],
        default: 300
    },
    modelValue: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $56e08e0125137781$export$d42abac634ace931)()
}, 'VLayoutItem');
const $a8e19d39567b0f06$export$81da49e5190cd2c4 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VLayoutItem',
    props: $a8e19d39567b0f06$export$9e2dea49392136f7(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { layoutItemStyles: layoutItemStyles } = (0, $56e08e0125137781$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $01W3b.computed)(()=>parseInt(props.order, 10)),
            position: (0, $01W3b.toRef)(()=>props.position),
            elementSize: (0, $01W3b.toRef)(()=>props.size),
            layoutSize: (0, $01W3b.toRef)(()=>props.size),
            active: (0, $01W3b.toRef)(()=>props.modelValue),
            absolute: (0, $01W3b.toRef)(()=>props.absolute)
        });
        return ()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-layout-item',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    layoutItemStyles.value,
                    props.style
                ])
            }, [
                slots.default?.()
            ]);
    }
});




var $5387367d23df10db$exports = {};

$parcel$export($5387367d23df10db$exports, "VLazy", () => $094a5625a6d30ad4$export$c840683367f2f7cc);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");







const $094a5625a6d30ad4$export$7e0bfdc21d0e5c9a = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    modelValue: Boolean,
    options: {
        type: Object,
        // For more information on types, navigate to:
        // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
        default: ()=>({
                root: undefined,
                rootMargin: undefined,
                threshold: undefined
            })
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $fcbabbbc201ae8b0$export$e5b7ff1a0fbdc00e)({
        transition: 'fade-transition'
    })
}, 'VLazy');
const $094a5625a6d30ad4$export$c840683367f2f7cc = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VLazy',
    directives: {
        vIntersect: $8d31333abb7bf4e7$export$2e2bcd8739ae039
    },
    props: $094a5625a6d30ad4$export$7e0bfdc21d0e5c9a(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        function onIntersect(isIntersecting) {
            if (isActive.value) return;
            isActive.value = isIntersecting;
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.withDirectives)((0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-lazy',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    dimensionStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        isActive.value && (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                            "transition": props.transition,
                            "appear": true
                        }, {
                            default: ()=>[
                                    slots.default?.()
                                ]
                        })
                    ]
            }), [
                [
                    (0, $8d31333abb7bf4e7$export$2e2bcd8739ae039),
                    {
                        handler: onIntersect,
                        options: props.options
                    },
                    null
                ]
            ]));
        return {};
    }
});




var $0b6aa56d4b334646$exports = {};

$parcel$export($0b6aa56d4b334646$exports, "VList", () => $8f3cccf9308874bc$export$3b010b0401837103);
$parcel$export($0b6aa56d4b334646$exports, "VListGroup", () => $7522211dead698f4$export$22fc03a43764dcc7);
$parcel$export($0b6aa56d4b334646$exports, "VListImg", () => $23dc1e27ccb5e50d$export$dad6c498e719f15b);
$parcel$export($0b6aa56d4b334646$exports, "VListItem", () => $3d00ebc3c7505e27$export$a6ee5a73ee56a146);
$parcel$export($0b6aa56d4b334646$exports, "VListItemAction", () => $1315588cb8db08e1$export$104c1ead9d891c55);
$parcel$export($0b6aa56d4b334646$exports, "VListItemMedia", () => $aed668e5c4835f25$export$18c32693f6eb8fdd);
$parcel$export($0b6aa56d4b334646$exports, "VListItemSubtitle", () => $55851011ab134ecf$export$822b84d77d050116);
$parcel$export($0b6aa56d4b334646$exports, "VListItemTitle", () => $2d03267b9a3b6c6c$export$d3fcc52550436b5b);
$parcel$export($0b6aa56d4b334646$exports, "VListSubheader", () => $96a2eb5e8711f0cc$export$70c4aba7bf48e22a);


// Utilities

const $23dc1e27ccb5e50d$export$dad6c498e719f15b = (0, $5224ab9d69b8c3e0$export$b3680ae2c271b9f3)('v-list-img');



parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



const $1315588cb8db08e1$export$fb2699a134c6af57 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    start: Boolean,
    end: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VListItemAction');
const $1315588cb8db08e1$export$104c1ead9d891c55 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VListItemAction',
    props: $1315588cb8db08e1$export$fb2699a134c6af57(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-list-item-action',
                    {
                        'v-list-item-action--start': props.start,
                        'v-list-item-action--end': props.end
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, slots));
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



const $aed668e5c4835f25$export$bc8dec2df83055e0 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    start: Boolean,
    end: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VListItemMedia');
const $aed668e5c4835f25$export$18c32693f6eb8fdd = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VListItemMedia',
    props: $aed668e5c4835f25$export$bc8dec2df83055e0(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-list-item-media',
                    {
                        'v-list-item-media--start': props.start,
                        'v-list-item-media--end': props.end
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, slots);
        });
        return {};
    }
});







var $e6d610c14e7962da$exports = {};

$parcel$export($e6d610c14e7962da$exports, "VLocaleProvider", () => $b806782658fcef7e$export$31df19007ea703da);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");




const $b806782658fcef7e$export$d5c1865211b2711 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    locale: String,
    fallbackLocale: String,
    messages: Object,
    rtl: {
        type: Boolean,
        default: undefined
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VLocaleProvider');
const $b806782658fcef7e$export$31df19007ea703da = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VLocaleProvider',
    props: $b806782658fcef7e$export$d5c1865211b2711(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$4e518c250eba4aac)(props);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-locale-provider',
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, [
                slots.default?.()
            ]));
        return {};
    }
});




var $1e4036ee8bee689f$exports = {};

$parcel$export($1e4036ee8bee689f$exports, "VMain", () => $9a9032cc38f14fe6$export$2ad79366571a8389);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");







const $9a9032cc38f14fe6$export$604b06cdafed258f = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    scrollable: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'main'
    })
}, 'VMain');
const $9a9032cc38f14fe6$export$2ad79366571a8389 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VMain',
    props: $9a9032cc38f14fe6$export$604b06cdafed258f(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { mainStyles: mainStyles } = (0, $56e08e0125137781$export$f47430f7ffdcc134)();
        const { ssrBootStyles: ssrBootStyles } = (0, $0f95b8d0184d7fa9$export$f385cca8ac2b2f35)();
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-main',
                    {
                        'v-main--scrollable': props.scrollable
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    mainStyles.value,
                    ssrBootStyles.value,
                    dimensionStyles.value,
                    props.style
                ])
            }, {
                default: ()=>[
                        props.scrollable ? (0, $TusQn.createElementVNode)("div", {
                            "class": "v-main__scroller"
                        }, [
                            slots.default?.()
                        ]) : slots.default?.()
                    ]
            }));
        return {};
    }
});




var $a0d09cbd97aaf00a$exports = {};

$parcel$export($a0d09cbd97aaf00a$exports, "VMenu", () => $9208258024e22101$export$a347888d6b8f252a);



var $62cef22972307f7e$exports = {};

$parcel$export($62cef22972307f7e$exports, "VMessages", () => $95c386a7139dfc13$export$31afdc787fe64f1d);



var $5e0ba0935e986253$exports = {};

$parcel$export($5e0ba0935e986253$exports, "VNavigationDrawer", () => $e6d872d398cdc55d$export$2092f85d546b77d5);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");



// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

function $83d74799b6046ebf$export$5b8a2f2a5151b421(_ref) {
    let { rootEl: rootEl, isSticky: isSticky, layoutItemStyles: layoutItemStyles } = _ref;
    const isStuck = (0, $01W3b.shallowRef)(false);
    const stuckPosition = (0, $01W3b.shallowRef)(0);
    const stickyStyles = (0, $01W3b.computed)(()=>{
        const side = typeof isStuck.value === 'boolean' ? 'top' : isStuck.value;
        return [
            isSticky.value ? {
                top: 'auto',
                bottom: 'auto',
                height: undefined
            } : undefined,
            isStuck.value ? {
                [side]: (0, $8590040a7833369a$export$286ad215293a0860)(stuckPosition.value)
            } : {
                top: layoutItemStyles.value.top
            }
        ];
    });
    (0, $TusQn.onMounted)(()=>{
        (0, $01W3b.watch)(isSticky, (val)=>{
            if (val) window.addEventListener('scroll', onScroll, {
                passive: true
            });
            else window.removeEventListener('scroll', onScroll);
        }, {
            immediate: true
        });
    });
    (0, $TusQn.onBeforeUnmount)(()=>{
        window.removeEventListener('scroll', onScroll);
    });
    let lastScrollTop = 0;
    function onScroll() {
        const direction = lastScrollTop > window.scrollY ? 'up' : 'down';
        const rect = rootEl.value.getBoundingClientRect();
        const layoutTop = parseFloat(layoutItemStyles.value.top ?? 0);
        const top = window.scrollY - Math.max(0, stuckPosition.value - layoutTop);
        const bottom = rect.height + Math.max(stuckPosition.value, layoutTop) - window.scrollY - window.innerHeight;
        const bodyScroll = parseFloat(getComputedStyle(rootEl.value).getPropertyValue('--v-body-scroll-y')) || 0;
        if (rect.height < window.innerHeight - layoutTop) {
            isStuck.value = 'top';
            stuckPosition.value = layoutTop;
        } else if (direction === 'up' && isStuck.value === 'bottom' || direction === 'down' && isStuck.value === 'top') {
            stuckPosition.value = window.scrollY + rect.top - bodyScroll;
            isStuck.value = true;
        } else if (direction === 'down' && bottom <= 0) {
            stuckPosition.value = 0;
            isStuck.value = 'bottom';
        } else if (direction === 'up' && top <= 0) {
            if (!bodyScroll) {
                stuckPosition.value = rect.top + top;
                isStuck.value = 'top';
            } else if (isStuck.value !== 'top') {
                stuckPosition.value = -top + bodyScroll + layoutTop;
                isStuck.value = 'top';
            }
        }
        lastScrollTop = window.scrollY;
    }
    return {
        isStuck: isStuck,
        stickyStyles: stickyStyles
    };
}


// Composables

// Utilities

const $cdde1856e0b7e8a7$var$HORIZON = 100; // ms
const $cdde1856e0b7e8a7$var$HISTORY = 20; // number of samples to keep
/** @see https://android.googlesource.com/platform/frameworks/native/+/master/libs/input/VelocityTracker.cpp */ function $cdde1856e0b7e8a7$var$kineticEnergyToVelocity(work) {
    const sqrt2 = 1.41421356237;
    return (work < 0 ? -1 : 1.0) * Math.sqrt(Math.abs(work)) * sqrt2;
}
function $cdde1856e0b7e8a7$export$f51fa41ccb9b7df0(samples) {
    // The input should be in reversed time order (most recent sample at index i=0)
    if (samples.length < 2) // if 0 or 1 points, velocity is zero
    return 0;
    // if (samples[1].t > samples[0].t) {
    //   // Algorithm will still work, but not perfectly
    //   consoleWarn('Samples provided to calculateImpulseVelocity in the wrong order')
    // }
    if (samples.length === 2) {
        // if 2 points, basic linear calculation
        if (samples[1].t === samples[0].t) // consoleWarn(`Events have identical time stamps t=${samples[0].t}, setting velocity = 0`)
        return 0;
        return (samples[1].d - samples[0].d) / (samples[1].t - samples[0].t);
    }
    // Guaranteed to have at least 3 points here
    // start with the oldest sample and go forward in time
    let work = 0;
    for(let i = samples.length - 1; i > 0; i--){
        if (samples[i].t === samples[i - 1].t) continue;
        const vprev = $cdde1856e0b7e8a7$var$kineticEnergyToVelocity(work); // v[i-1]
        const vcurr = (samples[i].d - samples[i - 1].d) / (samples[i].t - samples[i - 1].t); // v[i]
        work += (vcurr - vprev) * Math.abs(vcurr);
        if (i === samples.length - 1) work *= 0.5;
    }
    return $cdde1856e0b7e8a7$var$kineticEnergyToVelocity(work) * 1000;
}
function $cdde1856e0b7e8a7$export$9753f5326cc4952a() {
    const touches = {};
    function addMovement(e) {
        Array.from(e.changedTouches).forEach((touch)=>{
            const samples = touches[touch.identifier] ?? (touches[touch.identifier] = new (0, $8590040a7833369a$export$5900cd5f89b9a13a)($cdde1856e0b7e8a7$var$HISTORY));
            samples.push([
                e.timeStamp,
                touch
            ]);
        });
    }
    function endTouch(e) {
        Array.from(e.changedTouches).forEach((touch)=>{
            delete touches[touch.identifier];
        });
    }
    function getVelocity(id) {
        const samples = touches[id]?.values().reverse();
        if (!samples) throw new Error(`No samples for touch id ${id}`);
        const newest = samples[0];
        const x = [];
        const y = [];
        for (const val of samples){
            if (newest[0] - val[0] > $cdde1856e0b7e8a7$var$HORIZON) break;
            x.push({
                t: val[0],
                d: val[1].clientX
            });
            y.push({
                t: val[0],
                d: val[1].clientY
            });
        }
        return {
            x: $cdde1856e0b7e8a7$export$f51fa41ccb9b7df0(x),
            y: $cdde1856e0b7e8a7$export$f51fa41ccb9b7df0(y),
            get direction () {
                const { x: x, y: y } = this;
                const [absX, absY] = [
                    Math.abs(x),
                    Math.abs(y)
                ];
                return absX > absY && x >= 0 ? 'right' : absX > absY && x <= 0 ? 'left' : absY > absX && y >= 0 ? 'down' : absY > absX && y <= 0 ? 'up' : $cdde1856e0b7e8a7$var$oops();
            }
        };
    }
    return {
        addMovement: addMovement,
        endTouch: endTouch,
        getVelocity: getVelocity
    };
}
function $cdde1856e0b7e8a7$var$oops() {
    throw new Error();
}


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

function $f437c74663e8adf6$export$72022e98e0a26546(_ref) {
    let { el: el, isActive: isActive, isTemporary: isTemporary, width: width, touchless: touchless, position: position } = _ref;
    (0, $TusQn.onMounted)(()=>{
        window.addEventListener('touchstart', onTouchstart, {
            passive: true
        });
        window.addEventListener('touchmove', onTouchmove, {
            passive: false
        });
        window.addEventListener('touchend', onTouchend, {
            passive: true
        });
    });
    (0, $TusQn.onBeforeUnmount)(()=>{
        window.removeEventListener('touchstart', onTouchstart);
        window.removeEventListener('touchmove', onTouchmove);
        window.removeEventListener('touchend', onTouchend);
    });
    const isHorizontal = (0, $01W3b.computed)(()=>[
            'left',
            'right'
        ].includes(position.value));
    const { addMovement: addMovement, endTouch: endTouch, getVelocity: getVelocity } = (0, $cdde1856e0b7e8a7$export$9753f5326cc4952a)();
    let maybeDragging = false;
    const isDragging = (0, $01W3b.shallowRef)(false);
    const dragProgress = (0, $01W3b.shallowRef)(0);
    const offset = (0, $01W3b.shallowRef)(0);
    let start;
    function getOffset(pos, active) {
        return (position.value === 'left' ? pos : position.value === 'right' ? document.documentElement.clientWidth - pos : position.value === 'top' ? pos : position.value === 'bottom' ? document.documentElement.clientHeight - pos : $f437c74663e8adf6$var$oops()) - (active ? width.value : 0);
    }
    function getProgress(pos) {
        let limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        const progress = position.value === 'left' ? (pos - offset.value) / width.value : position.value === 'right' ? (document.documentElement.clientWidth - pos - offset.value) / width.value : position.value === 'top' ? (pos - offset.value) / width.value : position.value === 'bottom' ? (document.documentElement.clientHeight - pos - offset.value) / width.value : $f437c74663e8adf6$var$oops();
        return limit ? (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(progress) : progress;
    }
    function onTouchstart(e) {
        if (touchless.value) return;
        const touchX = e.changedTouches[0].clientX;
        const touchY = e.changedTouches[0].clientY;
        const touchZone = 25;
        const inTouchZone = position.value === 'left' ? touchX < touchZone : position.value === 'right' ? touchX > document.documentElement.clientWidth - touchZone : position.value === 'top' ? touchY < touchZone : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - touchZone : $f437c74663e8adf6$var$oops();
        const inElement = isActive.value && (position.value === 'left' ? touchX < width.value : position.value === 'right' ? touchX > document.documentElement.clientWidth - width.value : position.value === 'top' ? touchY < width.value : position.value === 'bottom' ? touchY > document.documentElement.clientHeight - width.value : $f437c74663e8adf6$var$oops());
        if (inTouchZone || inElement || isActive.value && isTemporary.value) {
            start = [
                touchX,
                touchY
            ];
            offset.value = getOffset(isHorizontal.value ? touchX : touchY, isActive.value);
            dragProgress.value = getProgress(isHorizontal.value ? touchX : touchY);
            maybeDragging = offset.value > -20 && offset.value < 80;
            endTouch(e);
            addMovement(e);
        }
    }
    function onTouchmove(e) {
        const touchX = e.changedTouches[0].clientX;
        const touchY = e.changedTouches[0].clientY;
        if (maybeDragging) {
            if (!e.cancelable) {
                maybeDragging = false;
                return;
            }
            const dx = Math.abs(touchX - start[0]);
            const dy = Math.abs(touchY - start[1]);
            const thresholdMet = isHorizontal.value ? dx > dy && dx > 3 : dy > dx && dy > 3;
            if (thresholdMet) {
                isDragging.value = true;
                maybeDragging = false;
            } else if ((isHorizontal.value ? dy : dx) > 3) maybeDragging = false;
        }
        if (!isDragging.value) return;
        e.preventDefault();
        addMovement(e);
        const progress = getProgress(isHorizontal.value ? touchX : touchY, false);
        dragProgress.value = Math.max(0, Math.min(1, progress));
        if (progress > 1) offset.value = getOffset(isHorizontal.value ? touchX : touchY, true);
        else if (progress < 0) offset.value = getOffset(isHorizontal.value ? touchX : touchY, false);
    }
    function onTouchend(e) {
        maybeDragging = false;
        if (!isDragging.value) return;
        addMovement(e);
        isDragging.value = false;
        const velocity = getVelocity(e.changedTouches[0].identifier);
        const vx = Math.abs(velocity.x);
        const vy = Math.abs(velocity.y);
        const thresholdMet = isHorizontal.value ? vx > vy && vx > 400 : vy > vx && vy > 3;
        if (thresholdMet) isActive.value = velocity.direction === (({
            left: 'right',
            right: 'left',
            top: 'down',
            bottom: 'up'
        })[position.value] || $f437c74663e8adf6$var$oops());
        else isActive.value = dragProgress.value > 0.5;
    }
    const dragStyles = (0, $01W3b.computed)(()=>{
        return isDragging.value ? {
            transform: position.value === 'left' ? `translateX(calc(-100% + ${dragProgress.value * width.value}px))` : position.value === 'right' ? `translateX(calc(100% - ${dragProgress.value * width.value}px))` : position.value === 'top' ? `translateY(calc(-100% + ${dragProgress.value * width.value}px))` : position.value === 'bottom' ? `translateY(calc(100% - ${dragProgress.value * width.value}px))` : $f437c74663e8adf6$var$oops(),
            transition: 'none'
        } : undefined;
    });
    (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(isDragging, ()=>{
        const transform = el.value?.style.transform ?? null;
        const transition = el.value?.style.transition ?? null;
        (0, $TusQn.watchEffect)(()=>{
            el.value?.style.setProperty('transform', dragStyles.value?.transform || 'none');
            el.value?.style.setProperty('transition', dragStyles.value?.transition || null);
        });
        (0, $01W3b.onScopeDispose)(()=>{
            el.value?.style.setProperty('transform', transform);
            el.value?.style.setProperty('transition', transition);
        });
    });
    return {
        isDragging: isDragging,
        dragProgress: dragProgress,
        dragStyles: dragStyles
    };
}
function $f437c74663e8adf6$var$oops() {
    throw new Error();
}





















const $e6d872d398cdc55d$var$locations = [
    'start',
    'end',
    'left',
    'right',
    'top',
    'bottom'
];
const $e6d872d398cdc55d$export$b9cc4b5bdef87275 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    disableResizeWatcher: Boolean,
    disableRouteWatcher: Boolean,
    expandOnHover: Boolean,
    floating: Boolean,
    modelValue: {
        type: Boolean,
        default: null
    },
    permanent: Boolean,
    rail: {
        type: Boolean,
        default: null
    },
    railWidth: {
        type: [
            Number,
            String
        ],
        default: 56
    },
    scrim: {
        type: [
            Boolean,
            String
        ],
        default: true
    },
    image: String,
    temporary: Boolean,
    persistent: Boolean,
    touchless: Boolean,
    width: {
        type: [
            Number,
            String
        ],
        default: 256
    },
    location: {
        type: String,
        default: 'start',
        validator: (value)=>$e6d872d398cdc55d$var$locations.includes(value)
    },
    sticky: Boolean,
    ...(0, $fa4dc4422e1db62c$export$70b8b174e7d601ce)(),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $f7bca629b3eb404a$export$1fd3611e92a5a94)(),
    ...(0, $1444e2cf1a712792$export$d0badecb383b472a)({
        mobile: null
    }),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $56e08e0125137781$export$d42abac634ace931)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $a72168ea6a0ee1b7$export$bfa779dd7c86a172)(), [
        'disableInitialFocus'
    ]),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)({
        tag: 'nav'
    }),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VNavigationDrawer');
const $e6d872d398cdc55d$export$2092f85d546b77d5 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VNavigationDrawer',
    props: $e6d872d398cdc55d$export$b9cc4b5bdef87275(),
    emits: {
        'update:modelValue': (val)=>true,
        'update:rail': (val)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { isRtl: isRtl } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { borderClasses: borderClasses } = (0, $fa4dc4422e1db62c$export$6185a16c7b2926fb)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { displayClasses: displayClasses, mobile: mobile } = (0, $1444e2cf1a712792$export$8406b7efc286d284)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const router = (0, $1c0236248fe13b4c$export$9a302a45f65d0572)();
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', null, (v)=>!!v);
        const { ssrBootStyles: ssrBootStyles } = (0, $0f95b8d0184d7fa9$export$f385cca8ac2b2f35)();
        const { scopeId: scopeId } = (0, $d897445671465531$export$eeabe5cda932100d)();
        const rootEl = (0, $01W3b.ref)();
        const isHovering = (0, $01W3b.shallowRef)(false);
        const { runOpenDelay: runOpenDelay, runCloseDelay: runCloseDelay } = (0, $f7bca629b3eb404a$export$69f38700ea0cb3b9)(props, (value)=>{
            isHovering.value = value;
        });
        const width = (0, $01W3b.computed)(()=>{
            return props.rail && props.expandOnHover && isHovering.value ? Number(props.width) : Number(props.rail ? props.railWidth : props.width);
        });
        const location = (0, $01W3b.computed)(()=>{
            return (0, $aa564bd137c45a62$export$b56cedd93dedafd4)(props.location, isRtl.value);
        });
        const isPersistent = (0, $01W3b.toRef)(()=>props.persistent);
        const isTemporary = (0, $01W3b.computed)(()=>!props.permanent && (mobile.value || props.temporary));
        const isSticky = (0, $01W3b.computed)(()=>props.sticky && !isTemporary.value && location.value !== 'bottom');
        (0, $a72168ea6a0ee1b7$export$5562a1f223a0d314)(props, {
            isActive: isActive,
            localTop: isTemporary,
            contentEl: rootEl
        });
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>props.expandOnHover && props.rail != null, ()=>{
            (0, $01W3b.watch)(isHovering, (val)=>emit('update:rail', !val));
        });
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>!props.disableResizeWatcher, ()=>{
            (0, $01W3b.watch)(isTemporary, (val)=>!props.permanent && (0, $TusQn.nextTick)(()=>isActive.value = !val));
        });
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>!props.disableRouteWatcher && !!router, ()=>{
            (0, $01W3b.watch)(router.currentRoute, ()=>isTemporary.value && (isActive.value = false));
        });
        (0, $01W3b.watch)(()=>props.permanent, (val)=>{
            if (val) isActive.value = true;
        });
        if (props.modelValue == null && !isTemporary.value) isActive.value = props.permanent || !mobile.value;
        const { isDragging: isDragging, dragProgress: dragProgress } = (0, $f437c74663e8adf6$export$72022e98e0a26546)({
            el: rootEl,
            isActive: isActive,
            isTemporary: isTemporary,
            width: width,
            touchless: (0, $01W3b.toRef)(()=>props.touchless),
            position: location
        });
        const layoutSize = (0, $01W3b.computed)(()=>{
            const size = isTemporary.value ? 0 : props.rail && props.expandOnHover ? Number(props.railWidth) : width.value;
            return isDragging.value ? size * dragProgress.value : size;
        });
        const { layoutItemStyles: layoutItemStyles, layoutItemScrimStyles: layoutItemScrimStyles } = (0, $56e08e0125137781$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $01W3b.computed)(()=>parseInt(props.order, 10)),
            position: location,
            layoutSize: layoutSize,
            elementSize: width,
            active: (0, $01W3b.readonly)(isActive),
            disableTransitions: (0, $01W3b.toRef)(()=>isDragging.value),
            absolute: (0, $01W3b.computed)(()=>// eslint-disable-next-line @typescript-eslint/no-use-before-define
                props.absolute || isSticky.value && typeof isStuck.value !== 'string')
        });
        const { isStuck: isStuck, stickyStyles: stickyStyles } = (0, $83d74799b6046ebf$export$5b8a2f2a5151b421)({
            rootEl: rootEl,
            isSticky: isSticky,
            layoutItemStyles: layoutItemStyles
        });
        const scrimColor = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>{
            return typeof props.scrim === 'string' ? props.scrim : null;
        });
        const scrimStyles = (0, $01W3b.computed)(()=>({
                ...isDragging.value ? {
                    opacity: dragProgress.value * 0.2,
                    transition: 'none'
                } : undefined,
                ...layoutItemScrimStyles.value
            }));
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VList: {
                bgColor: 'transparent'
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasImage = slots.image || props.image;
            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                (0, $TusQn.createVNode)(props.tag, (0, $TusQn.mergeProps)({
                    "ref": rootEl,
                    "onMouseenter": runOpenDelay,
                    "onMouseleave": runCloseDelay,
                    "class": [
                        'v-navigation-drawer',
                        `v-navigation-drawer--${location.value}`,
                        {
                            'v-navigation-drawer--expand-on-hover': props.expandOnHover,
                            'v-navigation-drawer--floating': props.floating,
                            'v-navigation-drawer--is-hovering': isHovering.value,
                            'v-navigation-drawer--rail': props.rail,
                            'v-navigation-drawer--temporary': isTemporary.value,
                            'v-navigation-drawer--persistent': isPersistent.value,
                            'v-navigation-drawer--active': isActive.value,
                            'v-navigation-drawer--sticky': isSticky.value
                        },
                        themeClasses.value,
                        backgroundColorClasses.value,
                        borderClasses.value,
                        displayClasses.value,
                        elevationClasses.value,
                        roundedClasses.value,
                        props.class
                    ],
                    "style": [
                        backgroundColorStyles.value,
                        layoutItemStyles.value,
                        ssrBootStyles.value,
                        stickyStyles.value,
                        props.style
                    ],
                    "inert": !isActive.value
                }, scopeId, attrs), {
                    default: ()=>[
                            hasImage && (0, $TusQn.createElementVNode)("div", {
                                "key": "image",
                                "class": "v-navigation-drawer__img"
                            }, [
                                !slots.image ? (0, $TusQn.createVNode)((0, $b2937780237888c4$export$126ec614c536f27c), {
                                    "key": "image-img",
                                    "alt": "",
                                    "cover": true,
                                    "height": "inherit",
                                    "src": props.image
                                }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                    "key": "image-defaults",
                                    "disabled": !props.image,
                                    "defaults": {
                                        VImg: {
                                            alt: '',
                                            cover: true,
                                            height: 'inherit',
                                            src: props.image
                                        }
                                    }
                                }, slots.image)
                            ]),
                            slots.prepend && (0, $TusQn.createElementVNode)("div", {
                                "class": "v-navigation-drawer__prepend"
                            }, [
                                slots.prepend?.()
                            ]),
                            (0, $TusQn.createElementVNode)("div", {
                                "class": "v-navigation-drawer__content"
                            }, [
                                slots.default?.()
                            ]),
                            slots.append && (0, $TusQn.createElementVNode)("div", {
                                "class": "v-navigation-drawer__append"
                            }, [
                                slots.append?.()
                            ])
                        ]
                }),
                (0, $TusQn.createVNode)((0, $eeJ70.Transition), {
                    "name": "fade-transition"
                }, {
                    default: ()=>[
                            isTemporary.value && (isDragging.value || isActive.value) && !!props.scrim && (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                                "class": [
                                    'v-navigation-drawer__scrim',
                                    scrimColor.backgroundColorClasses.value
                                ],
                                "style": [
                                    scrimStyles.value,
                                    scrimColor.backgroundColorStyles.value
                                ],
                                "onClick": ()=>{
                                    if (isPersistent.value) return;
                                    isActive.value = false;
                                }
                            }, scopeId), null)
                        ]
                })
            ]);
        });
        return {
            isStuck: isStuck
        };
    }
});




var $3b4070e8589f8a9d$exports = {};

$parcel$export($3b4070e8589f8a9d$exports, "VNoSsr", () => $8560dd47c6fc8f61$export$3be0fc655d27bb1a);
// Composables


const $8560dd47c6fc8f61$export$3be0fc655d27bb1a = (0, $2b7aafe61499bf6b$export$afa64b67e5a01c3b)({
    name: 'VNoSsr',
    setup (_, _ref) {
        let { slots: slots } = _ref;
        const show = (0, $48cd263ee58eedc4$export$5b8689c380bcb3d5)();
        return ()=>show.value && slots.default?.();
    }
});




var $0c4922cce1352ab0$exports = {};

$parcel$export($0c4922cce1352ab0$exports, "VNumberInput", () => $b00986bd079a59bf$export$ecd5b157968c4270);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");





// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
const $41343fd81db7fc06$var$HOLD_REPEAT = 50;
const $41343fd81db7fc06$var$HOLD_DELAY = 500;
function $41343fd81db7fc06$export$9b6ebe8ffd9dc981(_ref) {
    let { toggleUpDown: toggleUpDown } = _ref;
    let timeout = -1;
    let interval = -1;
    (0, $01W3b.onScopeDispose)(holdStop);
    function holdStart(value) {
        holdStop();
        tick(value);
        window.addEventListener('pointerup', holdStop);
        document.addEventListener('blur', holdStop);
        timeout = window.setTimeout(()=>{
            interval = window.setInterval(()=>tick(value), $41343fd81db7fc06$var$HOLD_REPEAT);
        }, $41343fd81db7fc06$var$HOLD_DELAY);
    }
    function holdStop() {
        window.clearTimeout(timeout);
        window.clearInterval(interval);
        window.removeEventListener('pointerup', holdStop);
        document.removeEventListener('blur', holdStop);
    }
    (0, $01W3b.onScopeDispose)(holdStop);
    function tick(value) {
        toggleUpDown(value === 'up');
    }
    return {
        holdStart: holdStart,
        holdStop: holdStop
    };
}







const $b00986bd079a59bf$var$makeVNumberInputProps = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    controlVariant: {
        type: String,
        default: 'default'
    },
    inset: Boolean,
    hideInput: Boolean,
    modelValue: {
        type: Number,
        default: null
    },
    min: {
        type: Number,
        default: Number.MIN_SAFE_INTEGER
    },
    max: {
        type: Number,
        default: Number.MAX_SAFE_INTEGER
    },
    step: {
        type: Number,
        default: 1
    },
    precision: {
        type: Number,
        default: 0
    },
    minFractionDigits: {
        type: Number,
        default: null
    },
    decimalSeparator: {
        type: String,
        validator: (v)=>!v || v.length === 1
    },
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $1df180b07e489866$export$c9f7484641b0b190)(), [
        'modelValue',
        'validationValue'
    ])
}, 'VNumberInput');
const $b00986bd079a59bf$export$ecd5b157968c4270 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VNumberInput',
    props: {
        ...$b00986bd079a59bf$var$makeVNumberInputProps()
    },
    emits: {
        'update:focused': (val)=>true,
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const vTextFieldRef = (0, $01W3b.ref)();
        const { holdStart: holdStart, holdStop: holdStop } = (0, $41343fd81db7fc06$export$9b6ebe8ffd9dc981)({
            toggleUpDown: toggleUpDown
        });
        const form = (0, $72bfe1fa0cde9e24$export$87c0cf8eb5a167e0)(props);
        const controlsDisabled = (0, $01W3b.computed)(()=>form.isDisabled.value || form.isReadonly.value);
        const isFocused = (0, $01W3b.shallowRef)(props.focused);
        const { decimalSeparator: decimalSeparatorFromLocale } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const decimalSeparator = (0, $01W3b.computed)(()=>props.decimalSeparator?.[0] || decimalSeparatorFromLocale.value);
        function correctPrecision(val) {
            let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.precision;
            let trim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
            const fixed = precision == null ? String(val) : val.toFixed(precision);
            if (isFocused.value && trim) return Number(fixed).toString() // trim zeros
            .replace('.', decimalSeparator.value);
            if (props.minFractionDigits === null || precision !== null && precision < props.minFractionDigits) return fixed.replace('.', decimalSeparator.value);
            let [baseDigits, fractionDigits] = fixed.split('.');
            fractionDigits = (fractionDigits ?? '').padEnd(props.minFractionDigits, '0').replace(new RegExp(`(?<=\\d{${props.minFractionDigits}})0+$`, 'g'), '');
            return [
                baseDigits,
                fractionDigits
            ].filter(Boolean).join(decimalSeparator.value);
        }
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', null, (val)=>val ?? null, (val)=>val == null ? val ?? null : (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(Number(val), props.min, props.max));
        const _inputText = (0, $01W3b.shallowRef)(null);
        const _lastParsedValue = (0, $01W3b.shallowRef)(null);
        (0, $01W3b.watch)(model, (val)=>{
            if (isFocused.value && !controlsDisabled.value && Number(_inputText.value?.replace(decimalSeparator.value, '.')) === val) ;
            else if (val == null) {
                _inputText.value = null;
                _lastParsedValue.value = null;
            } else if (!isNaN(val)) {
                _inputText.value = correctPrecision(val);
                _lastParsedValue.value = Number(_inputText.value.replace(decimalSeparator.value, '.'));
            }
        }, {
            immediate: true
        });
        const inputText = (0, $01W3b.computed)({
            get: ()=>_inputText.value,
            set (val) {
                if (val === null || val === '') {
                    model.value = null;
                    _inputText.value = null;
                    _lastParsedValue.value = null;
                    return;
                }
                const parsedValue = Number(val.replace(decimalSeparator.value, '.'));
                if (!isNaN(parsedValue)) {
                    _inputText.value = val;
                    _lastParsedValue.value = parsedValue;
                    if (parsedValue <= props.max && parsedValue >= props.min) model.value = parsedValue;
                }
            }
        });
        const isOutOfRange = (0, $01W3b.computed)(()=>{
            if (_lastParsedValue.value === null) return false;
            const numberFromText = Number(_inputText.value?.replace(decimalSeparator.value, '.'));
            return numberFromText !== (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(numberFromText, props.min, props.max);
        });
        const canIncrease = (0, $01W3b.computed)(()=>{
            if (controlsDisabled.value) return false;
            return (model.value ?? 0) + props.step <= props.max;
        });
        const canDecrease = (0, $01W3b.computed)(()=>{
            if (controlsDisabled.value) return false;
            return (model.value ?? 0) - props.step >= props.min;
        });
        const controlVariant = (0, $01W3b.computed)(()=>{
            return props.hideInput ? 'stacked' : props.controlVariant;
        });
        const incrementIcon = (0, $01W3b.toRef)(()=>controlVariant.value === 'split' ? '$plus' : '$collapse');
        const decrementIcon = (0, $01W3b.toRef)(()=>controlVariant.value === 'split' ? '$minus' : '$expand');
        const controlNodeSize = (0, $01W3b.toRef)(()=>controlVariant.value === 'split' ? 'default' : 'small');
        const controlNodeDefaultHeight = (0, $01W3b.toRef)(()=>controlVariant.value === 'stacked' ? 'auto' : '100%');
        const incrementSlotProps = {
            props: {
                onClick: onControlClick,
                onPointerup: onControlMouseup,
                onPointerdown: onUpControlMousedown,
                onPointercancel: onControlMouseup
            }
        };
        const decrementSlotProps = {
            props: {
                onClick: onControlClick,
                onPointerup: onControlMouseup,
                onPointerdown: onDownControlMousedown,
                onPointercancel: onControlMouseup
            }
        };
        (0, $01W3b.watch)(()=>props.precision, ()=>formatInputValue());
        (0, $01W3b.watch)(()=>props.minFractionDigits, ()=>formatInputValue());
        (0, $TusQn.onMounted)(()=>{
            clampModel();
        });
        function inferPrecision(value) {
            if (value == null) return 0;
            const str = value.toString();
            const idx = str.indexOf('.');
            return ~idx ? str.length - idx : 0;
        }
        function toggleUpDown() {
            let increment = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            if (controlsDisabled.value) return;
            if (model.value == null) {
                inputText.value = correctPrecision((0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(0, props.min, props.max));
                return;
            }
            let inferredPrecision = Math.max(inferPrecision(model.value), inferPrecision(props.step));
            if (props.precision != null) inferredPrecision = Math.max(inferredPrecision, props.precision);
            if (increment) {
                if (canIncrease.value) inputText.value = correctPrecision(model.value + props.step, inferredPrecision);
            } else if (canDecrease.value) inputText.value = correctPrecision(model.value - props.step, inferredPrecision);
        }
        function onBeforeinput(e) {
            if (!e.data) return;
            const inputElement = e.target;
            const { value: existingTxt, selectionStart: selectionStart, selectionEnd: selectionEnd } = inputElement ?? {};
            const potentialNewInputVal = existingTxt ? existingTxt.slice(0, selectionStart) + e.data + existingTxt.slice(selectionEnd) : e.data;
            const potentialNewNumber = (0, $8590040a7833369a$export$ee2b54e92bdbaa0c)(potentialNewInputVal, props.precision, decimalSeparator.value);
            // Allow only numbers, "-" and {decimal separator}
            // Allow "-" and {decimal separator} only once
            // Allow "-" only at the start
            if (!new RegExp(`^-?\\d*${(0, $8590040a7833369a$export$211de94a4ac98986)(decimalSeparator.value)}?\\d*$`).test(potentialNewInputVal)) {
                e.preventDefault();
                inputElement.value = potentialNewNumber;
                (0, $TusQn.nextTick)(()=>inputText.value = potentialNewNumber);
            }
            if (props.precision == null) return;
            // Ignore decimal digits above precision limit
            if (potentialNewInputVal.split(decimalSeparator.value)[1]?.length > props.precision) {
                e.preventDefault();
                inputElement.value = potentialNewNumber;
                (0, $TusQn.nextTick)(()=>inputText.value = potentialNewNumber);
                const cursorPosition = (selectionStart ?? 0) + e.data.length;
                inputElement.setSelectionRange(cursorPosition, cursorPosition);
            }
            // Ignore decimal separator when precision = 0
            if (props.precision === 0 && potentialNewInputVal.endsWith(decimalSeparator.value)) {
                e.preventDefault();
                inputElement.value = potentialNewNumber;
                (0, $TusQn.nextTick)(()=>inputText.value = potentialNewNumber);
            }
        }
        async function onKeydown(e) {
            if ([
                'Enter',
                'ArrowLeft',
                'ArrowRight',
                'Backspace',
                'Delete',
                'Tab'
            ].includes(e.key) || e.ctrlKey) return;
            if ([
                'ArrowDown',
                'ArrowUp'
            ].includes(e.key)) {
                e.preventDefault();
                e.stopPropagation();
                clampModel();
                // _model is controlled, so need to wait until props['modelValue'] is updated
                await (0, $TusQn.nextTick)();
                if (e.key === 'ArrowDown') toggleUpDown(false);
                else toggleUpDown();
            }
        }
        function onControlClick(e) {
            e.stopPropagation();
        }
        function onControlMouseup(e) {
            const el = e.currentTarget;
            el?.releasePointerCapture(e.pointerId);
            e.preventDefault();
            holdStop();
        }
        function onUpControlMousedown(e) {
            const el = e.currentTarget;
            el?.setPointerCapture(e.pointerId);
            e.preventDefault();
            e.stopPropagation();
            holdStart('up');
        }
        function onDownControlMousedown(e) {
            const el = e.currentTarget;
            el?.setPointerCapture(e.pointerId);
            e.preventDefault();
            e.stopPropagation();
            holdStart('down');
        }
        function clampModel() {
            if (controlsDisabled.value) return;
            if (!vTextFieldRef.value) return;
            const actualText = vTextFieldRef.value.value;
            const parsedValue = Number(actualText.replace(decimalSeparator.value, '.'));
            if (actualText && !isNaN(parsedValue)) inputText.value = correctPrecision((0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(parsedValue, props.min, props.max));
            else inputText.value = null;
        }
        function formatInputValue() {
            if (controlsDisabled.value) return;
            inputText.value = model.value !== null && !isNaN(model.value) ? correctPrecision(model.value, props.precision, false) : null;
        }
        function trimDecimalZeros() {
            if (controlsDisabled.value) return;
            if (model.value === null || isNaN(model.value)) {
                inputText.value = null;
                return;
            }
            inputText.value = model.value.toString().replace('.', decimalSeparator.value);
        }
        function onFocus() {
            trimDecimalZeros();
        }
        function onBlur() {
            clampModel();
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const { modelValue: _, type: type, ...textFieldProps } = (0, $1df180b07e489866$export$d591c92dea965c28).filterProps(props);
            function incrementControlNode() {
                return !slots.increment ? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                    "aria-hidden": "true",
                    "data-testid": "increment",
                    "disabled": !canIncrease.value,
                    "height": controlNodeDefaultHeight.value,
                    "icon": incrementIcon.value,
                    "key": "increment-btn",
                    "onClick": onControlClick,
                    "onPointerdown": onUpControlMousedown,
                    "onPointerup": onControlMouseup,
                    "onPointercancel": onControlMouseup,
                    "size": controlNodeSize.value,
                    "variant": "text",
                    "tabindex": "-1"
                }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                    "key": "increment-defaults",
                    "defaults": {
                        VBtn: {
                            disabled: !canIncrease.value,
                            height: controlNodeDefaultHeight.value,
                            size: controlNodeSize.value,
                            icon: incrementIcon.value,
                            variant: 'text'
                        }
                    }
                }, {
                    default: ()=>[
                            slots.increment(incrementSlotProps)
                        ]
                });
            }
            function decrementControlNode() {
                return !slots.decrement ? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                    "aria-hidden": "true",
                    "data-testid": "decrement",
                    "disabled": !canDecrease.value,
                    "height": controlNodeDefaultHeight.value,
                    "icon": decrementIcon.value,
                    "key": "decrement-btn",
                    "onClick": onControlClick,
                    "onPointerdown": onDownControlMousedown,
                    "onPointerup": onControlMouseup,
                    "onPointercancel": onControlMouseup,
                    "size": controlNodeSize.value,
                    "variant": "text",
                    "tabindex": "-1"
                }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                    "key": "decrement-defaults",
                    "defaults": {
                        VBtn: {
                            disabled: !canDecrease.value,
                            height: controlNodeDefaultHeight.value,
                            size: controlNodeSize.value,
                            icon: decrementIcon.value,
                            variant: 'text'
                        }
                    }
                }, {
                    default: ()=>[
                            slots.decrement(decrementSlotProps)
                        ]
                });
            }
            function controlNode() {
                return (0, $TusQn.createElementVNode)("div", {
                    "class": "v-number-input__control"
                }, [
                    decrementControlNode(),
                    (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), {
                        "vertical": controlVariant.value !== 'stacked'
                    }, null),
                    incrementControlNode()
                ]);
            }
            function dividerNode() {
                return !props.hideInput && !props.inset ? (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), {
                    "vertical": true
                }, null) : undefined;
            }
            const appendInnerControl = controlVariant.value === 'split' ? (0, $TusQn.createElementVNode)("div", {
                "class": "v-number-input__control"
            }, [
                (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), {
                    "vertical": true
                }, null),
                incrementControlNode()
            ]) : props.reverse || controlVariant.value === 'hidden' ? undefined : (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                dividerNode(),
                controlNode()
            ]);
            const hasAppendInner = slots['append-inner'] || appendInnerControl;
            const prependInnerControl = controlVariant.value === 'split' ? (0, $TusQn.createElementVNode)("div", {
                "class": "v-number-input__control"
            }, [
                decrementControlNode(),
                (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), {
                    "vertical": true
                }, null)
            ]) : props.reverse && controlVariant.value !== 'hidden' ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                controlNode(),
                dividerNode()
            ]) : undefined;
            const hasPrependInner = slots['prepend-inner'] || prependInnerControl;
            return (0, $TusQn.createVNode)((0, $1df180b07e489866$export$d591c92dea965c28), (0, $TusQn.mergeProps)({
                "ref": vTextFieldRef
            }, textFieldProps, {
                "modelValue": inputText.value,
                "onUpdate:modelValue": ($event)=>inputText.value = $event,
                "focused": isFocused.value,
                "onUpdate:focused": ($event)=>isFocused.value = $event,
                "validationValue": model.value,
                "error": props.error || isOutOfRange.value || undefined,
                "onBeforeinput": onBeforeinput,
                "onFocus": onFocus,
                "onBlur": onBlur,
                "onKeydown": onKeydown,
                "class": [
                    'v-number-input',
                    {
                        'v-number-input--default': controlVariant.value === 'default',
                        'v-number-input--hide-input': props.hideInput,
                        'v-number-input--inset': props.inset,
                        'v-number-input--reverse': props.reverse,
                        'v-number-input--split': controlVariant.value === 'split',
                        'v-number-input--stacked': controlVariant.value === 'stacked'
                    },
                    props.class
                ],
                "style": props.style,
                "inputmode": "decimal"
            }), {
                ...slots,
                'append-inner': hasAppendInner ? function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots['append-inner']?.(...args),
                        appendInnerControl
                    ]);
                } : undefined,
                'prepend-inner': hasPrependInner ? function() {
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        prependInnerControl,
                        slots['prepend-inner']?.(...args)
                    ]);
                } : undefined
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, vTextFieldRef);
    }
});




var $53659e3a889804c7$exports = {};

$parcel$export($53659e3a889804c7$exports, "VOtpInput", () => $f2c4e4b6d7d851e7$export$a3674b497e85ad8);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");













const $f2c4e4b6d7d851e7$export$ad920badd2504e58 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    autofocus: Boolean,
    divider: String,
    focusAll: Boolean,
    label: {
        type: String,
        default: '$vuetify.input.otp'
    },
    length: {
        type: [
            Number,
            String
        ],
        default: 6
    },
    masked: Boolean,
    modelValue: {
        type: [
            Number,
            String
        ],
        default: undefined
    },
    placeholder: String,
    type: {
        type: String,
        default: 'number'
    },
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $fdb5f7d63722b03f$export$676d4e684e4b0e1e)(),
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $d4f131cf7ef9c4a9$export$1e13429dc53b9634)({
        variant: 'outlined'
    }), [
        'baseColor',
        'bgColor',
        'class',
        'color',
        'disabled',
        'error',
        'loading',
        'rounded',
        'style',
        'theme',
        'variant'
    ])
}, 'VOtpInput');
const $f2c4e4b6d7d851e7$export$a3674b497e85ad8 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VOtpInput',
    props: $f2c4e4b6d7d851e7$export$ad920badd2504e58(),
    emits: {
        finish: (val)=>true,
        'update:focused': (val)=>true,
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $fdb5f7d63722b03f$export$f8168d8dd8fd66e6)(props);
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', '', (val)=>val == null ? [] : String(val).split(''), (val)=>val.join(''));
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const length = (0, $01W3b.computed)(()=>Number(props.length));
        const fields = (0, $01W3b.computed)(()=>Array(length.value).fill(0));
        const focusIndex = (0, $01W3b.ref)(-1);
        const contentRef = (0, $01W3b.ref)();
        const inputRef = (0, $01W3b.ref)([]);
        const current = (0, $01W3b.computed)(()=>inputRef.value[focusIndex.value]);
        let _isComposing = false;
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>props.autofocus, ()=>{
            const intersectScope = (0, $01W3b.effectScope)();
            intersectScope.run(()=>{
                const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $16d02f6dfabde683$export$a7395f9832c00176)();
                (0, $TusQn.watchEffect)(()=>{
                    intersectionRef.value = inputRef.value[0];
                });
                (0, $01W3b.watch)(isIntersecting, (v)=>{
                    if (!v) return;
                    intersectionRef.value?.focus();
                    intersectScope.stop();
                });
            });
        });
        function onInput() {
            // The maxlength attribute doesn't work for the number type input, so the text type is used.
            // The following logic simulates the behavior of a number input.
            if (isValidNumber(current.value.value)) {
                current.value.value = '';
                return;
            }
            if (_isComposing) return;
            const array = model.value.slice();
            const value = current.value.value;
            array[focusIndex.value] = value;
            let target = null;
            if (focusIndex.value > model.value.length) target = model.value.length + 1;
            else if (focusIndex.value + 1 !== length.value) target = 'next';
            model.value = array;
            if (target) (0, $8590040a7833369a$export$da2eafa20d5ebba)(contentRef.value, target);
        }
        function onCompositionend() {
            _isComposing = false;
            onInput();
        }
        function onKeydown(e) {
            const array = model.value.slice();
            const index = focusIndex.value;
            let target = null;
            if (![
                'ArrowLeft',
                'ArrowRight',
                'Backspace',
                'Delete'
            ].includes(e.key)) return;
            e.preventDefault();
            if (e.key === 'ArrowLeft') target = 'prev';
            else if (e.key === 'ArrowRight') target = 'next';
            else if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                array[focusIndex.value] = '';
                model.value = array;
                if (focusIndex.value > 0 && e.key === 'Backspace') target = 'prev';
                else requestAnimationFrame(()=>{
                    inputRef.value[index]?.select();
                });
            }
            requestAnimationFrame(()=>{
                if (target != null) (0, $8590040a7833369a$export$da2eafa20d5ebba)(contentRef.value, target);
            });
        }
        function onPaste(index, e) {
            e.preventDefault();
            e.stopPropagation();
            const clipboardText = e?.clipboardData?.getData('Text').trim().slice(0, length.value) ?? '';
            const finalIndex = clipboardText.length - 1 === -1 ? index : clipboardText.length - 1;
            if (isValidNumber(clipboardText)) return;
            model.value = clipboardText.split('');
            focusIndex.value = finalIndex;
        }
        function reset() {
            model.value = [];
        }
        function onFocus(e, index) {
            focus();
            focusIndex.value = index;
        }
        function onBlur() {
            blur();
            focusIndex.value = -1;
        }
        function isValidNumber(value) {
            return props.type === 'number' && /[^0-9]/g.test(value);
        }
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VField: {
                color: (0, $01W3b.toRef)(()=>props.color),
                bgColor: (0, $01W3b.toRef)(()=>props.color),
                baseColor: (0, $01W3b.toRef)(()=>props.baseColor),
                disabled: (0, $01W3b.toRef)(()=>props.disabled),
                error: (0, $01W3b.toRef)(()=>props.error),
                variant: (0, $01W3b.toRef)(()=>props.variant),
                rounded: (0, $01W3b.toRef)(()=>props.rounded)
            }
        }, {
            scoped: true
        });
        (0, $01W3b.watch)(model, (val)=>{
            if (val.length === length.value) emit('finish', val.join(''));
        }, {
            deep: true
        });
        (0, $01W3b.watch)(focusIndex, (val)=>{
            if (val < 0) return;
            (0, $TusQn.nextTick)(()=>{
                inputRef.value[val]?.select();
            });
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const [rootAttrs, inputAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            return (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "class": [
                    'v-otp-input',
                    {
                        'v-otp-input--divided': !!props.divider
                    },
                    densityClasses.value,
                    props.class
                ],
                "style": [
                    props.style
                ]
            }, rootAttrs), [
                (0, $TusQn.createElementVNode)("div", {
                    "ref": contentRef,
                    "class": "v-otp-input__content",
                    "style": (0, $8POXm.normalizeStyle)([
                        dimensionStyles.value
                    ])
                }, [
                    fields.value.map((_, i)=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                            props.divider && i !== 0 && (0, $TusQn.createElementVNode)("span", {
                                "class": "v-otp-input__divider"
                            }, [
                                props.divider
                            ]),
                            (0, $TusQn.createVNode)((0, $d4f131cf7ef9c4a9$export$3180fb4997e9f72d), {
                                "focused": isFocused.value && props.focusAll || focusIndex.value === i,
                                "key": i
                            }, {
                                ...slots,
                                loader: undefined,
                                default: ()=>{
                                    return (0, $TusQn.createElementVNode)("input", {
                                        "ref": (val)=>inputRef.value[i] = val,
                                        "aria-label": t(props.label, i + 1),
                                        "autofocus": i === 0 && props.autofocus,
                                        "autocomplete": "one-time-code",
                                        "class": (0, $8POXm.normalizeClass)([
                                            'v-otp-input__field'
                                        ]),
                                        "disabled": props.disabled,
                                        "inputmode": props.type === 'number' ? 'numeric' : 'text',
                                        "min": props.type === 'number' ? 0 : undefined,
                                        "maxlength": i === 0 ? length.value : '1',
                                        "placeholder": props.placeholder,
                                        "type": props.masked ? 'password' : props.type === 'number' ? 'text' : props.type,
                                        "value": model.value[i],
                                        "onInput": onInput,
                                        "onFocus": (e)=>onFocus(e, i),
                                        "onBlur": onBlur,
                                        "onKeydown": onKeydown,
                                        "onCompositionstart": ()=>_isComposing = true,
                                        "onCompositionend": onCompositionend,
                                        "onPaste": (event)=>onPaste(i, event)
                                    }, null);
                                }
                            })
                        ])),
                    (0, $TusQn.createElementVNode)("input", (0, $TusQn.mergeProps)({
                        "class": "v-otp-input-input",
                        "type": "hidden"
                    }, inputAttrs, {
                        "value": model.value.join('')
                    }), null),
                    (0, $TusQn.createVNode)((0, $0eb6b57fb5d95344$export$32caf7e8170352aa), {
                        "contained": true,
                        "contentClass": "v-otp-input__loader",
                        "modelValue": !!props.loading,
                        "persistent": true
                    }, {
                        default: ()=>[
                                slots.loader?.() ?? (0, $TusQn.createVNode)((0, $26f3a281106a205d$export$2b4afd8de42c0c21), {
                                    "color": typeof props.loading === 'boolean' ? undefined : props.loading,
                                    "indeterminate": true,
                                    "size": "24",
                                    "width": "2"
                                }, null)
                            ]
                    }),
                    slots.default?.()
                ])
            ]);
        });
        return {
            blur: ()=>{
                inputRef.value?.some((input)=>input.blur());
            },
            focus: ()=>{
                inputRef.value?.[0].focus();
            },
            reset: reset,
            isFocused: isFocused
        };
    }
});




var $2a295c32f6e09300$exports = {};

$parcel$export($2a295c32f6e09300$exports, "VOverlay", () => $0eb6b57fb5d95344$export$32caf7e8170352aa);



var $00b3abc2ed1b82c6$exports = {};

$parcel$export($00b3abc2ed1b82c6$exports, "VPagination", () => $bc6c99d39840c0a8$export$6353b480ae89e024);



var $13e1e4927af6989b$exports = {};

$parcel$export($13e1e4927af6989b$exports, "VParallax", () => $31c8a460734940bb$export$7f342706af78ee7a);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");







function $31c8a460734940bb$var$floor(val) {
    return Math.floor(Math.abs(val)) * Math.sign(val);
}
const $31c8a460734940bb$export$615da25b371a0c45 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    scale: {
        type: [
            Number,
            String
        ],
        default: 0.5
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)()
}, 'VParallax');
const $31c8a460734940bb$export$7f342706af78ee7a = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VParallax',
    props: $31c8a460734940bb$export$615da25b371a0c45(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { intersectionRef: intersectionRef, isIntersecting: isIntersecting } = (0, $16d02f6dfabde683$export$a7395f9832c00176)();
        const { resizeRef: resizeRef, contentRect: contentRect } = (0, $d80db15b6452c606$export$683480f191c0e3ea)();
        const { height: displayHeight } = (0, $1444e2cf1a712792$export$8406b7efc286d284)();
        const root = (0, $01W3b.ref)();
        (0, $TusQn.watchEffect)(()=>{
            intersectionRef.value = resizeRef.value = root.value?.$el;
        });
        let scrollParent;
        (0, $01W3b.watch)(isIntersecting, (val)=>{
            if (val) {
                scrollParent = (0, $fa6a71feb92f218b$export$cfa2225e87938781)(intersectionRef.value);
                scrollParent = scrollParent === document.scrollingElement ? document : scrollParent;
                scrollParent.addEventListener('scroll', onScroll, {
                    passive: true
                });
                onScroll();
            } else scrollParent.removeEventListener('scroll', onScroll);
        });
        (0, $TusQn.onBeforeUnmount)(()=>{
            scrollParent?.removeEventListener('scroll', onScroll);
        });
        (0, $01W3b.watch)(displayHeight, onScroll);
        (0, $01W3b.watch)(()=>contentRect.value?.height, onScroll);
        const scale = (0, $01W3b.computed)(()=>{
            return 1 - (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(Number(props.scale));
        });
        let frame = -1;
        function onScroll() {
            if (!isIntersecting.value || (0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)()) return;
            cancelAnimationFrame(frame);
            frame = requestAnimationFrame(()=>{
                const el = (root.value?.$el).querySelector('.v-img__img');
                if (!el) return;
                const scrollHeight = scrollParent instanceof Document ? document.documentElement.clientHeight : scrollParent.clientHeight;
                const scrollPos = scrollParent instanceof Document ? window.scrollY : scrollParent.scrollTop;
                const top = intersectionRef.value.getBoundingClientRect().top + scrollPos;
                const height = contentRect.value.height;
                const center = top + (height - scrollHeight) / 2;
                const translate = $31c8a460734940bb$var$floor((scrollPos - center) * scale.value);
                const sizeScale = Math.max(1, (scale.value * (scrollHeight - height) + height) / height);
                el.style.setProperty('transform', `translateY(${translate}px) scale(${sizeScale})`);
            });
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)((0, $b2937780237888c4$export$126ec614c536f27c), {
                "class": (0, $8POXm.normalizeClass)([
                    'v-parallax',
                    {
                        'v-parallax--active': isIntersecting.value
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style),
                "ref": root,
                "cover": true,
                "onLoadstart": onScroll,
                "onLoad": onScroll
            }, slots));
        return {};
    }
});




var $99ad08acab55760e$exports = {};

$parcel$export($99ad08acab55760e$exports, "VProgressCircular", () => $26f3a281106a205d$export$2b4afd8de42c0c21);



var $fbe6f7fcd4976368$exports = {};

$parcel$export($fbe6f7fcd4976368$exports, "VProgressLinear", () => $b256c0debf2f88ca$export$86b13ad59f1a1627);



var $657e986bca5811c5$exports = {};

$parcel$export($657e986bca5811c5$exports, "VRadio", () => $f5ceccd7ff1a17db$export$3864b5d27f75e85c);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");


const $f5ceccd7ff1a17db$export$428023e8da5ad529 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $6bf6692b535e8488$export$a15300eeb449da9c)({
        falseIcon: '$radioOff',
        trueIcon: '$radioOn'
    })
}, 'VRadio');
const $f5ceccd7ff1a17db$export$3864b5d27f75e85c = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VRadio',
    props: $f5ceccd7ff1a17db$export$428023e8da5ad529(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const controlProps = (0, $6bf6692b535e8488$export$ada18d63da74fb09).filterProps(props);
            return (0, $TusQn.createVNode)((0, $6bf6692b535e8488$export$ada18d63da74fb09), (0, $TusQn.mergeProps)(controlProps, {
                "class": [
                    'v-radio',
                    props.class
                ],
                "style": props.style,
                "type": "radio"
            }), slots);
        });
        return {};
    }
});




var $1f0b3588c8c287c1$exports = {};

$parcel$export($1f0b3588c8c287c1$exports, "VRadioGroup", () => $33eb214d811258d7$export$ec19d6ef76fe208d);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");









const $33eb214d811258d7$export$70413854d01ca5a3 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    height: {
        type: [
            Number,
            String
        ],
        default: 'auto'
    },
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $97e8c489e405a584$export$525655a73981d616)(), [
        'direction'
    ]),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $ad8cfeb89b25efca$export$f6307c62fd1b0ce3)(), [
        'multiple'
    ]),
    trueIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$radioOn'
    },
    falseIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$radioOff'
    },
    type: {
        type: String,
        default: 'radio'
    }
}, 'VRadioGroup');
const $33eb214d811258d7$export$ec19d6ef76fe208d = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VRadioGroup',
    inheritAttrs: false,
    props: $33eb214d811258d7$export$70413854d01ca5a3(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const uid = (0, $TusQn.useId)();
        const id = (0, $01W3b.computed)(()=>props.id || `radio-group-${uid}`);
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const inputRef = (0, $01W3b.ref)();
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const [rootAttrs, controlAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            const inputProps = (0, $97e8c489e405a584$export$2aca538d9f87f6ac).filterProps(props);
            const controlProps = (0, $6bf6692b535e8488$export$ada18d63da74fb09).filterProps(props);
            const label = slots.label ? slots.label({
                label: props.label,
                props: {
                    for: id.value
                }
            }) : props.label;
            return (0, $TusQn.createVNode)((0, $97e8c489e405a584$export$2aca538d9f87f6ac), (0, $TusQn.mergeProps)({
                "ref": inputRef,
                "class": [
                    'v-radio-group',
                    props.class
                ],
                "style": props.style
            }, rootAttrs, inputProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "id": id.value
            }), {
                ...slots,
                default: (_ref2)=>{
                    let { id: id, messagesId: messagesId, isDisabled: isDisabled, isReadonly: isReadonly } = _ref2;
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        label && (0, $TusQn.createVNode)((0, $e23bfa10b64d3f5e$export$90281af35207eb21), {
                            "id": id.value
                        }, {
                            default: ()=>[
                                    label
                                ]
                        }),
                        (0, $TusQn.createVNode)((0, $ad8cfeb89b25efca$export$fbaa479cb0704980), (0, $TusQn.mergeProps)(controlProps, {
                            "id": id.value,
                            "aria-describedby": messagesId.value,
                            "defaultsTarget": "VRadio",
                            "trueIcon": props.trueIcon,
                            "falseIcon": props.falseIcon,
                            "type": props.type,
                            "disabled": isDisabled.value,
                            "readonly": isReadonly.value,
                            "aria-labelledby": label ? id.value : undefined,
                            "multiple": false
                        }, controlAttrs, {
                            "modelValue": model.value,
                            "onUpdate:modelValue": ($event)=>model.value = $event
                        }), slots)
                    ]);
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, inputRef);
    }
});




var $52ef548014b28330$exports = {};

$parcel$export($52ef548014b28330$exports, "VRangeSlider", () => $f60d6621fedec240$export$3106df8cc5c6e9b3);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");











const $f60d6621fedec240$export$973ca10e7fdef000 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $fdb5f7d63722b03f$export$676d4e684e4b0e1e)(),
    ...(0, $97e8c489e405a584$export$525655a73981d616)(),
    ...(0, $6095f26041a1265e$export$f4533040d074ed75)(),
    strict: Boolean,
    modelValue: {
        type: Array,
        default: ()=>[
                0,
                0
            ]
    }
}, 'VRangeSlider');
const $f60d6621fedec240$export$3106df8cc5c6e9b3 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VRangeSlider',
    inheritAttrs: false,
    props: $f60d6621fedec240$export$973ca10e7fdef000(),
    emits: {
        'update:focused': (value)=>true,
        'update:modelValue': (value)=>true,
        end: (value)=>true,
        start: (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit, attrs: attrs } = _ref;
        const startThumbRef = (0, $01W3b.ref)();
        const stopThumbRef = (0, $01W3b.ref)();
        const inputRef = (0, $01W3b.ref)();
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        function getActiveThumb(e) {
            if (!startThumbRef.value || !stopThumbRef.value) return;
            const startOffset = (0, $6095f26041a1265e$export$622cea445a1c5b7d)(e, startThumbRef.value.$el, props.direction);
            const stopOffset = (0, $6095f26041a1265e$export$622cea445a1c5b7d)(e, stopThumbRef.value.$el, props.direction);
            const a = Math.abs(startOffset);
            const b = Math.abs(stopOffset);
            return a < b || a === b && startOffset < 0 ? startThumbRef.value.$el : stopThumbRef.value.$el;
        }
        const steps = (0, $6095f26041a1265e$export$302911c449e17ea4)(props);
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue', undefined, (arr)=>{
            if (!arr?.length) return [
                0,
                0
            ];
            return arr.map((value)=>steps.roundValue(value));
        });
        const { activeThumbRef: activeThumbRef, hasLabels: hasLabels, max: max, min: min, mousePressed: mousePressed, onSliderMousedown: onSliderMousedown, onSliderTouchstart: onSliderTouchstart, position: position, trackContainerRef: trackContainerRef, disabled: disabled, readonly: readonly } = (0, $6095f26041a1265e$export$56b2c08e277f365)({
            props: props,
            steps: steps,
            onSliderStart: ()=>{
                if (disabled.value || readonly.value) {
                    activeThumbRef.value?.blur();
                    return;
                }
                emit('start', model.value);
            },
            onSliderEnd: (_ref2)=>{
                let { value: value } = _ref2;
                if (disabled.value || readonly.value) activeThumbRef.value?.blur();
                else {
                    const newValue = activeThumbRef.value === startThumbRef.value?.$el ? [
                        value,
                        model.value[1]
                    ] : [
                        model.value[0],
                        value
                    ];
                    if (!props.strict && newValue[0] < newValue[1]) model.value = newValue;
                }
                emit('end', model.value);
            },
            onSliderMove: (_ref3)=>{
                let { value: value } = _ref3;
                const [start, stop] = model.value;
                if (disabled.value || readonly.value) {
                    activeThumbRef.value?.blur();
                    return;
                }
                if (!props.strict && start === stop && start !== min.value) {
                    activeThumbRef.value = value > start ? stopThumbRef.value?.$el : startThumbRef.value?.$el;
                    activeThumbRef.value?.focus();
                }
                if (activeThumbRef.value === startThumbRef.value?.$el) model.value = [
                    Math.min(value, stop),
                    stop
                ];
                else model.value = [
                    start,
                    Math.max(start, value)
                ];
            },
            getActiveThumb: getActiveThumb
        });
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $fdb5f7d63722b03f$export$f8168d8dd8fd66e6)(props);
        const trackStart = (0, $01W3b.computed)(()=>position(model.value[0]));
        const trackStop = (0, $01W3b.computed)(()=>position(model.value[1]));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const inputProps = (0, $97e8c489e405a584$export$2aca538d9f87f6ac).filterProps(props);
            const [rootAttrs, inputAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            const hasPrepend = !!(props.label || slots.label || slots.prepend);
            return (0, $TusQn.createVNode)((0, $97e8c489e405a584$export$2aca538d9f87f6ac), (0, $TusQn.mergeProps)({
                "class": [
                    'v-slider',
                    'v-range-slider',
                    {
                        'v-slider--has-labels': !!slots['tick-label'] || hasLabels.value,
                        'v-slider--focused': isFocused.value,
                        'v-slider--pressed': mousePressed.value,
                        'v-slider--disabled': disabled.value
                    },
                    rtlClasses.value,
                    props.class
                ],
                "style": props.style,
                "ref": inputRef
            }, inputProps, rootAttrs, {
                "focused": isFocused.value
            }), {
                ...slots,
                prepend: hasPrepend ? (slotProps)=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots.label?.(slotProps) ?? (props.label ? (0, $TusQn.createVNode)((0, $e23bfa10b64d3f5e$export$90281af35207eb21), {
                            "class": "v-slider__label",
                            "text": props.label
                        }, null) : undefined),
                        slots.prepend?.(slotProps)
                    ]) : undefined,
                default: (_ref4)=>{
                    let { id: id, messagesId: messagesId } = _ref4;
                    return (0, $TusQn.createElementVNode)("div", {
                        "class": "v-slider__container",
                        "onMousedown": !readonly.value ? onSliderMousedown : undefined,
                        "onTouchstartPassive": !readonly.value ? onSliderTouchstart : undefined
                    }, [
                        (0, $TusQn.createElementVNode)("input", {
                            "id": `${id.value}_start`,
                            "name": props.name || id.value,
                            "disabled": disabled.value,
                            "readonly": readonly.value,
                            "tabindex": "-1",
                            "value": model.value[0]
                        }, null),
                        (0, $TusQn.createElementVNode)("input", {
                            "id": `${id.value}_stop`,
                            "name": props.name || id.value,
                            "disabled": disabled.value,
                            "readonly": readonly.value,
                            "tabindex": "-1",
                            "value": model.value[1]
                        }, null),
                        (0, $TusQn.createVNode)((0, $01bae8296be19b22$export$bf1154fbd075ef2), {
                            "ref": trackContainerRef,
                            "start": trackStart.value,
                            "stop": trackStop.value
                        }, {
                            'tick-label': slots['tick-label']
                        }),
                        (0, $TusQn.createVNode)((0, $fd8eb3afc9358766$export$64ccdeab5f3618a7), (0, $TusQn.mergeProps)({
                            "ref": startThumbRef,
                            "aria-describedby": messagesId.value,
                            "focused": isFocused && activeThumbRef.value === startThumbRef.value?.$el,
                            "modelValue": model.value[0],
                            "onUpdate:modelValue": (v)=>model.value = [
                                    v,
                                    model.value[1]
                                ],
                            "onFocus": (e)=>{
                                focus();
                                activeThumbRef.value = startThumbRef.value?.$el;
                                // Make sure second thumb is focused if
                                // the thumbs are on top of each other
                                // and they are both at minimum value
                                // but only if focused from outside.
                                if (max.value !== min.value && model.value[0] === model.value[1] && model.value[1] === min.value && e.relatedTarget !== stopThumbRef.value?.$el) {
                                    startThumbRef.value?.$el.blur();
                                    stopThumbRef.value?.$el.focus();
                                }
                            },
                            "onBlur": ()=>{
                                blur();
                                activeThumbRef.value = undefined;
                            },
                            "min": min.value,
                            "max": model.value[1],
                            "position": trackStart.value,
                            "ripple": props.ripple
                        }, inputAttrs), {
                            'thumb-label': slots['thumb-label']
                        }),
                        (0, $TusQn.createVNode)((0, $fd8eb3afc9358766$export$64ccdeab5f3618a7), (0, $TusQn.mergeProps)({
                            "ref": stopThumbRef,
                            "aria-describedby": messagesId.value,
                            "focused": isFocused && activeThumbRef.value === stopThumbRef.value?.$el,
                            "modelValue": model.value[1],
                            "onUpdate:modelValue": (v)=>model.value = [
                                    model.value[0],
                                    v
                                ],
                            "onFocus": (e)=>{
                                focus();
                                activeThumbRef.value = stopThumbRef.value?.$el;
                                // Make sure first thumb is focused if
                                // the thumbs are on top of each other
                                // and they are both at maximum value
                                // but only if focused from outside.
                                if (max.value !== min.value && model.value[0] === model.value[1] && model.value[0] === max.value && e.relatedTarget !== startThumbRef.value?.$el) {
                                    stopThumbRef.value?.$el.blur();
                                    startThumbRef.value?.$el.focus();
                                }
                            },
                            "onBlur": ()=>{
                                blur();
                                activeThumbRef.value = undefined;
                            },
                            "min": model.value[0],
                            "max": max.value,
                            "position": trackStop.value,
                            "ripple": props.ripple
                        }, inputAttrs), {
                            'thumb-label': slots['thumb-label']
                        })
                    ]);
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({
            focus: ()=>startThumbRef.value?.$el.focus()
        }, inputRef);
    }
});




var $ea93d7a101e32e86$exports = {};

$parcel$export($ea93d7a101e32e86$exports, "VRating", () => $a3369d629842c03f$export$f735a1378bec432);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");











const $a3369d629842c03f$export$6bdd7db3248ebef1 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    name: String,
    itemAriaLabel: {
        type: String,
        default: '$vuetify.rating.ariaLabel.item'
    },
    activeColor: String,
    color: String,
    clearable: Boolean,
    disabled: Boolean,
    emptyIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$ratingEmpty'
    },
    fullIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$ratingFull'
    },
    halfIncrements: Boolean,
    hover: Boolean,
    length: {
        type: [
            Number,
            String
        ],
        default: 5
    },
    readonly: Boolean,
    modelValue: {
        type: [
            Number,
            String
        ],
        default: 0
    },
    itemLabels: Array,
    itemLabelPosition: {
        type: String,
        default: 'top',
        validator: (v)=>[
                'top',
                'bottom'
            ].includes(v)
    },
    ripple: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VRating');
const $a3369d629842c03f$export$f735a1378bec432 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VRating',
    props: $a3369d629842c03f$export$6bdd7db3248ebef1(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const root = (0, $01W3b.ref)();
        const rating = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const normalizedValue = (0, $01W3b.computed)(()=>(0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(parseFloat(rating.value), 0, Number(props.length)));
        const range = (0, $01W3b.computed)(()=>(0, $8590040a7833369a$export$d372f2f3c4d1b8e5)(Number(props.length), 1));
        const increments = (0, $01W3b.computed)(()=>range.value.flatMap((v)=>props.halfIncrements ? [
                    v - 0.5,
                    v
                ] : [
                    v
                ]));
        const hoverIndex = (0, $01W3b.shallowRef)(-1);
        const itemState = (0, $01W3b.computed)(()=>increments.value.map((value)=>{
                const isHovering = props.hover && hoverIndex.value > -1;
                const isFilled = normalizedValue.value >= value;
                const isHovered = hoverIndex.value >= value;
                const isFullIcon = isHovering ? isHovered : isFilled;
                const icon = isFullIcon ? props.fullIcon : props.emptyIcon;
                const activeColor = props.activeColor ?? props.color;
                const color = isFilled || isHovered ? activeColor : props.color;
                return {
                    isFilled: isFilled,
                    isHovered: isHovered,
                    icon: icon,
                    color: color
                };
            }));
        const eventState = (0, $01W3b.computed)(()=>[
                0,
                ...increments.value
            ].map((value)=>{
                function onMouseenter() {
                    hoverIndex.value = value;
                }
                function onMouseleave() {
                    hoverIndex.value = -1;
                }
                function onClick() {
                    if (props.disabled || props.readonly) return;
                    rating.value = normalizedValue.value === value && props.clearable ? 0 : value;
                }
                return {
                    onMouseenter: props.hover ? onMouseenter : undefined,
                    onMouseleave: props.hover ? onMouseleave : undefined,
                    onClick: onClick
                };
            }));
        const currentItemIndex = (0, $01W3b.computed)(()=>{
            return props.halfIncrements ? 1 + Math.floor(Math.max(0, Number(rating.value ?? 0) - 0.5)) * 2 : Math.floor(Math.max(0, Number(rating.value ?? 0) - 1));
        });
        function moveCurrentFocus() {
            const currentItem = root.value?.querySelector('[tabindex="0"]');
            currentItem?.focus();
        }
        function onItemKeydown(event) {
            if (props.disabled || props.readonly) return;
            if (event.ctrlKey || event.altKey) return;
            const step = props.halfIncrements ? 0.5 : 1;
            if (event.key === 'ArrowRight') {
                const newValue = Math.min(Number(props.length), Number(rating.value ?? 0) + step);
                rating.value = newValue;
                (0, $TusQn.nextTick)(()=>moveCurrentFocus());
            }
            if (event.key === 'ArrowLeft') {
                const newValue = Math.max(0, Number(rating.value ?? 0) - step);
                rating.value = newValue;
                (0, $TusQn.nextTick)(()=>moveCurrentFocus());
            }
        }
        const uid = (0, $TusQn.useId)();
        const name = (0, $01W3b.computed)(()=>props.name ?? `v-rating-${uid}`);
        function VRatingItem(_ref2) {
            let { value: value, index: index, showStar: showStar = true } = _ref2;
            const { onMouseenter: onMouseenter, onMouseleave: onMouseleave, onClick: onClick } = eventState.value[index + 1];
            const id = `${name.value}-${String(value).replace('.', '-')}`;
            const isFocusable = index === currentItemIndex.value;
            const btnProps = {
                color: itemState.value[index]?.color,
                density: props.density,
                disabled: props.disabled,
                icon: itemState.value[index]?.icon,
                ripple: props.ripple,
                size: props.size,
                variant: 'plain',
                tabindex: isFocusable ? 0 : -1,
                onKeydown: onItemKeydown
            };
            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                (0, $TusQn.createElementVNode)("label", {
                    "for": id,
                    "class": (0, $8POXm.normalizeClass)({
                        'v-rating__item--half': props.halfIncrements && value % 1 > 0,
                        'v-rating__item--full': props.halfIncrements && value % 1 === 0
                    }),
                    "onMouseenter": onMouseenter,
                    "onMouseleave": onMouseleave,
                    "onClick": onClick
                }, [
                    (0, $TusQn.createElementVNode)("span", {
                        "class": "v-rating__hidden"
                    }, [
                        t(props.itemAriaLabel, value, props.length)
                    ]),
                    !showStar ? undefined : slots.item ? slots.item({
                        ...itemState.value[index],
                        props: btnProps,
                        value: value,
                        index: index,
                        rating: normalizedValue.value
                    }) : (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                        "aria-label": t(props.itemAriaLabel, value, props.length)
                    }, btnProps), null)
                ]),
                (0, $TusQn.createElementVNode)("input", {
                    "class": "v-rating__hidden",
                    "name": name.value,
                    "id": id,
                    "type": "radio",
                    "value": value,
                    "checked": normalizedValue.value === value,
                    "tabindex": -1,
                    "readonly": props.readonly,
                    "disabled": props.disabled
                }, null)
            ]);
        }
        function createLabel(labelProps) {
            if (slots['item-label']) return slots['item-label'](labelProps);
            if (labelProps.label) return (0, $TusQn.createElementVNode)("span", null, [
                labelProps.label
            ]);
            return (0, $TusQn.createElementVNode)("span", null, [
                (0, $TusQn.createTextVNode)("\xA0")
            ]);
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasLabels = !!props.itemLabels?.length || slots['item-label'];
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-rating',
                    {
                        'v-rating--hover': props.hover,
                        'v-rating--readonly': props.readonly
                    },
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style),
                "ref": root
            }, {
                default: ()=>[
                        (0, $TusQn.createVNode)(VRatingItem, {
                            "value": 0,
                            "index": -1,
                            "showStar": false
                        }, null),
                        range.value.map((value, i)=>(0, $TusQn.createElementVNode)("div", {
                                "class": "v-rating__wrapper"
                            }, [
                                hasLabels && props.itemLabelPosition === 'top' ? createLabel({
                                    value: value,
                                    index: i,
                                    label: props.itemLabels?.[i]
                                }) : undefined,
                                (0, $TusQn.createElementVNode)("div", {
                                    "class": "v-rating__item"
                                }, [
                                    props.halfIncrements ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                        (0, $TusQn.createVNode)(VRatingItem, {
                                            "value": value - 0.5,
                                            "index": i * 2
                                        }, null),
                                        (0, $TusQn.createVNode)(VRatingItem, {
                                            "value": value,
                                            "index": i * 2 + 1
                                        }, null)
                                    ]) : (0, $TusQn.createVNode)(VRatingItem, {
                                        "value": value,
                                        "index": i
                                    }, null)
                                ]),
                                hasLabels && props.itemLabelPosition === 'bottom' ? createLabel({
                                    value: value,
                                    index: i,
                                    label: props.itemLabels?.[i]
                                }) : undefined
                            ]))
                    ]
            });
        });
        return {};
    }
});




var $37943bb3476841a8$exports = {};

$parcel$export($37943bb3476841a8$exports, "VResponsive", () => $e95efe0a40ff253f$export$fede2db8a3499569);



var $b6627b8d033bd43c$exports = {};

$parcel$export($b6627b8d033bd43c$exports, "VSelect", () => $118e5e4309583a1b$export$1d8182ee812485f5);



var $e1ee40caca164440$exports = {};

$parcel$export($e1ee40caca164440$exports, "VSelectionControl", () => $6bf6692b535e8488$export$ada18d63da74fb09);



var $12b799518ebb01dc$exports = {};

$parcel$export($12b799518ebb01dc$exports, "VSelectionControlGroup", () => $ad8cfeb89b25efca$export$fbaa479cb0704980);



var $c89fef91b35a2fb0$exports = {};

$parcel$export($c89fef91b35a2fb0$exports, "VSheet", () => $ce059966358db8b1$export$d41b26ce18186ef0);



var $9e573542278d56bd$exports = {};

$parcel$export($9e573542278d56bd$exports, "VSkeletonLoader", () => $b76798106d343750$export$d99330cd6b57c650);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");







const $b76798106d343750$export$6d4dc21e305d5383 = {
    actions: 'button@2',
    article: 'heading, paragraph',
    avatar: 'avatar',
    button: 'button',
    card: 'image, heading',
    'card-avatar': 'image, list-item-avatar',
    chip: 'chip',
    'date-picker': 'list-item, heading, divider, date-picker-options, date-picker-days, actions',
    'date-picker-options': 'text, avatar@2',
    'date-picker-days': 'avatar@28',
    divider: 'divider',
    heading: 'heading',
    image: 'image',
    'list-item': 'text',
    'list-item-avatar': 'avatar, text',
    'list-item-two-line': 'sentences',
    'list-item-avatar-two-line': 'avatar, sentences',
    'list-item-three-line': 'paragraph',
    'list-item-avatar-three-line': 'avatar, paragraph',
    ossein: 'ossein',
    paragraph: 'text@3',
    sentences: 'text@2',
    subtitle: 'text',
    table: 'table-heading, table-thead, table-tbody, table-tfoot',
    'table-heading': 'chip, text',
    'table-thead': 'heading@6',
    'table-tbody': 'table-row-divider@6',
    'table-row-divider': 'table-row, divider',
    'table-row': 'text@6',
    'table-tfoot': 'text@2, avatar@2',
    text: 'text'
};
function $b76798106d343750$var$genBone(type) {
    let children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return (0, $TusQn.createElementVNode)("div", {
        "class": (0, $8POXm.normalizeClass)([
            'v-skeleton-loader__bone',
            `v-skeleton-loader__${type}`
        ])
    }, [
        children
    ]);
}
function $b76798106d343750$var$genBones(bone) {
    // e.g. 'text@3'
    const [type, length] = bone.split('@');
    // Generate a length array based upon
    // value after @ in the bone string
    return Array.from({
        length: length
    }).map(()=>$b76798106d343750$var$genStructure(type));
}
function $b76798106d343750$var$genStructure(type) {
    let children = [];
    if (!type) return children;
    // TODO: figure out a better way to type this
    const bone = $b76798106d343750$export$6d4dc21e305d5383[type];
    // End of recursion, do nothing
    /* eslint-disable-next-line no-empty, brace-style */ if (type === bone) ;
    else if (type.includes(',')) return $b76798106d343750$var$mapBones(type);
    else if (type.includes('@')) return $b76798106d343750$var$genBones(type);
    else if (bone.includes(',')) children = $b76798106d343750$var$mapBones(bone);
    else if (bone.includes('@')) children = $b76798106d343750$var$genBones(bone);
    else if (bone) children.push($b76798106d343750$var$genStructure(bone));
    return [
        $b76798106d343750$var$genBone(type, children)
    ];
}
function $b76798106d343750$var$mapBones(bones) {
    // Remove spaces and return array of structures
    return bones.replace(/\s/g, '').split(',').map($b76798106d343750$var$genStructure);
}
const $b76798106d343750$export$f40f79ca0a20b129 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    boilerplate: Boolean,
    color: String,
    loading: Boolean,
    loadingText: {
        type: String,
        default: '$vuetify.loading'
    },
    type: {
        type: [
            String,
            Array
        ],
        default: 'ossein'
    },
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VSkeletonLoader');
const $b76798106d343750$export$d99330cd6b57c650 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSkeletonLoader',
    inheritAttrs: false,
    props: $b76798106d343750$export$f40f79ca0a20b129(),
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const items = (0, $01W3b.computed)(()=>$b76798106d343750$var$genStructure((0, $8590040a7833369a$export$76411cac38121ecb)(props.type).join(',')));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const isLoading = !slots.default || props.loading;
            const loadingProps = props.boilerplate || !isLoading ? {} : {
                ariaLive: 'polite',
                ariaLabel: t(props.loadingText),
                role: 'alert'
            };
            return isLoading ? (0, $TusQn.createElementVNode)("div", (0, $TusQn.mergeProps)({
                "class": [
                    'v-skeleton-loader',
                    {
                        'v-skeleton-loader--boilerplate': props.boilerplate
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    elevationClasses.value
                ],
                "style": [
                    backgroundColorStyles.value,
                    dimensionStyles.value
                ]
            }, loadingProps, attrs), [
                items.value
            ]) : (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                slots.default?.()
            ]);
        });
        return {};
    }
});




var $8531241b37779169$exports = {};

$parcel$export($8531241b37779169$exports, "VSlideGroup", () => $d5c54c6c3d49c30f$export$f3e025e558a486a4);
$parcel$export($8531241b37779169$exports, "VSlideGroupItem", () => $e29dd3a1cc454f5a$export$69c32988b229b652);

// Composables



const $e29dd3a1cc454f5a$export$69c32988b229b652 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSlideGroupItem',
    props: (0, $0befa53cf46b542b$export$e9e3b570044587e8)(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const slideGroupItem = (0, $0befa53cf46b542b$export$eebde8160f061c26)(props, (0, $d5c54c6c3d49c30f$export$f8d4255bddd9d04c));
        return ()=>slots.default?.({
                isSelected: slideGroupItem.isSelected.value,
                select: slideGroupItem.select,
                toggle: slideGroupItem.toggle,
                selectedClass: slideGroupItem.selectedClass.value
            });
    }
});




var $97e68654b93207bf$exports = {};

$parcel$export($97e68654b93207bf$exports, "VSlider", () => $a0f15d3038334c2f$export$e0368715924ca04f);



var $9a4ff206b6dad5a0$exports = {};

$parcel$export($9a4ff206b6dad5a0$exports, "VSnackbar", () => $2ba33a346730d05c$export$39df4d33ea6db485);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

















function $2ba33a346730d05c$var$useCountdown(milliseconds) {
    const time = (0, $01W3b.shallowRef)(milliseconds());
    let timer = -1;
    function clear() {
        clearInterval(timer);
    }
    function reset() {
        clear();
        (0, $TusQn.nextTick)(()=>time.value = milliseconds());
    }
    function start(el) {
        const style = el ? getComputedStyle(el) : {
            transitionDuration: 0.2
        };
        const interval = parseFloat(style.transitionDuration) * 1000 || 200;
        clear();
        if (time.value <= 0) return;
        const startTime = performance.now();
        timer = window.setInterval(()=>{
            const elapsed = performance.now() - startTime + interval;
            time.value = Math.max(milliseconds() - elapsed, 0);
            if (time.value <= 0) clear();
        }, interval);
    }
    (0, $01W3b.onScopeDispose)(clear);
    return {
        clear: clear,
        time: time,
        start: start,
        reset: reset
    };
}
const $2ba33a346730d05c$export$43333b6e787817d8 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    /* @deprecated */ multiLine: Boolean,
    text: String,
    timer: [
        Boolean,
        String
    ],
    timeout: {
        type: [
            Number,
            String
        ],
        default: 5000
    },
    vertical: Boolean,
    ...(0, $636e88b893afba47$export$2831add577f947cb)({
        location: 'bottom'
    }),
    ...(0, $572b8e75d6c9689d$export$f84374c9369ae887)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $0eb6b57fb5d95344$export$357b25d59a7fb3fa)({
        transition: 'v-snackbar-transition'
    }), [
        'persistent',
        'noClickAnimation',
        'retainFocus',
        'captureFocus',
        'disableInitialFocus',
        'scrim',
        'scrollStrategy',
        'stickToTarget',
        'viewportMargin'
    ])
}, 'VSnackbar');
const $2ba33a346730d05c$export$39df4d33ea6db485 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSnackbar',
    props: $2ba33a346730d05c$export$43333b6e787817d8(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { positionClasses: positionClasses } = (0, $572b8e75d6c9689d$export$8169801eda3f797f)(props);
        const { scopeId: scopeId } = (0, $d897445671465531$export$eeabe5cda932100d)();
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { colorClasses: colorClasses, colorStyles: colorStyles, variantClasses: variantClasses } = (0, $567f01637e3e83ec$export$36ef81613f8f20fc)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const countdown = $2ba33a346730d05c$var$useCountdown(()=>Number(props.timeout));
        const overlay = (0, $01W3b.ref)();
        const timerRef = (0, $01W3b.ref)();
        const isHovering = (0, $01W3b.shallowRef)(false);
        const startY = (0, $01W3b.shallowRef)(0);
        const mainStyles = (0, $01W3b.ref)();
        const hasLayout = (0, $TusQn.inject)((0, $56e08e0125137781$export$6c0af7fe4dd9b19b), undefined);
        (0, $97b67326d41c53e5$export$fa3cd679bf7c4ed)(()=>!!hasLayout, ()=>{
            const layout = (0, $56e08e0125137781$export$f47430f7ffdcc134)();
            (0, $TusQn.watchEffect)(()=>{
                mainStyles.value = layout.mainStyles.value;
            });
        });
        (0, $01W3b.watch)(isActive, startTimeout);
        (0, $01W3b.watch)(()=>props.timeout, startTimeout);
        (0, $TusQn.onMounted)(()=>{
            if (isActive.value) startTimeout();
        });
        let activeTimeout = -1;
        function startTimeout() {
            countdown.reset();
            window.clearTimeout(activeTimeout);
            const timeout = Number(props.timeout);
            if (!isActive.value || timeout === -1) return;
            const element = (0, $8590040a7833369a$export$2bffc57ac06742e2)(timerRef.value);
            countdown.start(element);
            activeTimeout = window.setTimeout(()=>{
                isActive.value = false;
            }, timeout);
        }
        function clearTimeout() {
            countdown.reset();
            window.clearTimeout(activeTimeout);
        }
        function onPointerenter() {
            isHovering.value = true;
            clearTimeout();
        }
        function onPointerleave() {
            isHovering.value = false;
            startTimeout();
        }
        function onTouchstart(event) {
            startY.value = event.touches[0].clientY;
        }
        function onTouchend(event) {
            if (Math.abs(startY.value - event.changedTouches[0].clientY) > 50) isActive.value = false;
        }
        function onAfterLeave() {
            if (isHovering.value) onPointerleave();
        }
        const locationClasses = (0, $01W3b.computed)(()=>{
            return props.location.split(' ').reduce((acc, loc)=>{
                acc[`v-snackbar--${loc}`] = true;
                return acc;
            }, {});
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const overlayProps = (0, $0eb6b57fb5d95344$export$32caf7e8170352aa).filterProps(props);
            const hasContent = !!(slots.default || slots.text || props.text);
            return (0, $TusQn.createVNode)((0, $0eb6b57fb5d95344$export$32caf7e8170352aa), (0, $TusQn.mergeProps)({
                "ref": overlay,
                "class": [
                    'v-snackbar',
                    {
                        'v-snackbar--active': isActive.value,
                        'v-snackbar--multi-line': props.multiLine && !props.vertical,
                        'v-snackbar--timer': !!props.timer,
                        'v-snackbar--vertical': props.vertical
                    },
                    locationClasses.value,
                    positionClasses.value,
                    props.class
                ],
                "style": [
                    mainStyles.value,
                    props.style
                ]
            }, overlayProps, {
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "contentProps": (0, $TusQn.mergeProps)({
                    class: [
                        'v-snackbar__wrapper',
                        themeClasses.value,
                        colorClasses.value,
                        roundedClasses.value,
                        variantClasses.value
                    ],
                    style: [
                        colorStyles.value
                    ],
                    onPointerenter: onPointerenter,
                    onPointerleave: onPointerleave
                }, overlayProps.contentProps),
                "persistent": true,
                "noClickAnimation": true,
                "scrim": false,
                "scrollStrategy": "none",
                "_disableGlobalStack": true,
                "onTouchstartPassive": onTouchstart,
                "onTouchend": onTouchend,
                "onAfterLeave": onAfterLeave
            }, scopeId), {
                default: ()=>[
                        (0, $567f01637e3e83ec$export$e27cd265ed232373)(false, 'v-snackbar'),
                        props.timer && !isHovering.value && (0, $TusQn.createElementVNode)("div", {
                            "key": "timer",
                            "class": "v-snackbar__timer"
                        }, [
                            (0, $TusQn.createVNode)((0, $b256c0debf2f88ca$export$86b13ad59f1a1627), {
                                "ref": timerRef,
                                "color": typeof props.timer === 'string' ? props.timer : 'info',
                                "max": props.timeout,
                                "modelValue": countdown.time.value
                            }, null)
                        ]),
                        hasContent && (0, $TusQn.createElementVNode)("div", {
                            "key": "content",
                            "class": "v-snackbar__content",
                            "role": "status",
                            "aria-live": "polite"
                        }, [
                            slots.text?.() ?? props.text,
                            slots.default?.()
                        ]),
                        slots.actions && (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "defaults": {
                                VBtn: {
                                    variant: 'text',
                                    ripple: false,
                                    slim: true
                                }
                            }
                        }, {
                            default: ()=>[
                                    (0, $TusQn.createElementVNode)("div", {
                                        "class": "v-snackbar__actions"
                                    }, [
                                        slots.actions({
                                            isActive: isActive
                                        })
                                    ])
                                ]
                        })
                    ],
                activator: slots.activator
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, overlay);
    }
});




var $b56ed29f3f154953$exports = {};

$parcel$export($b56ed29f3f154953$exports, "VSnackbarQueue", () => $e35ab29547710eeb$export$17675221b95f643d);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");





const $e35ab29547710eeb$export$4ff8615b6e07e6c0 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    // TODO: Port this to Snackbar on dev
    closable: [
        Boolean,
        String
    ],
    closeText: {
        type: String,
        default: '$vuetify.dismiss'
    },
    modelValue: {
        type: Array,
        default: ()=>[]
    },
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $2ba33a346730d05c$export$43333b6e787817d8)(), [
        'modelValue'
    ])
}, 'VSnackbarQueue');
const $e35ab29547710eeb$export$17675221b95f643d = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSnackbarQueue',
    props: $e35ab29547710eeb$export$4ff8615b6e07e6c0(),
    emits: {
        'update:modelValue': (val)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const isActive = (0, $01W3b.shallowRef)(false);
        const isVisible = (0, $01W3b.shallowRef)(false);
        const current = (0, $01W3b.shallowRef)();
        (0, $01W3b.watch)(()=>props.modelValue.length, (val, oldVal)=>{
            if (!isVisible.value && val > oldVal) showNext();
        });
        (0, $01W3b.watch)(isActive, (val)=>{
            if (val) isVisible.value = true;
        });
        function onAfterLeave() {
            if (props.modelValue.length) showNext();
            else {
                current.value = undefined;
                isVisible.value = false;
            }
        }
        function showNext() {
            const [next, ...rest] = props.modelValue;
            emit('update:modelValue', rest);
            current.value = typeof next === 'string' ? {
                text: next
            } : next;
            (0, $TusQn.nextTick)(()=>{
                isActive.value = true;
            });
        }
        function onClickClose() {
            isActive.value = false;
        }
        const btnProps = (0, $01W3b.computed)(()=>({
                color: typeof props.closable === 'string' ? props.closable : undefined,
                text: t(props.closeText)
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasActions = !!(props.closable || slots.actions);
            const { modelValue: _, ...snackbarProps } = (0, $2ba33a346730d05c$export$39df4d33ea6db485).filterProps(props);
            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                isVisible.value && !!current.value && (slots.default ? (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                    "defaults": {
                        VSnackbar: current.value
                    }
                }, {
                    default: ()=>[
                            slots.default({
                                item: current.value
                            })
                        ]
                }) : (0, $TusQn.createVNode)((0, $2ba33a346730d05c$export$39df4d33ea6db485), (0, $TusQn.mergeProps)(snackbarProps, current.value, {
                    "modelValue": isActive.value,
                    "onUpdate:modelValue": ($event)=>isActive.value = $event,
                    "onAfterLeave": onAfterLeave
                }), {
                    text: slots.text ? ()=>slots.text?.({
                            item: current.value
                        }) : undefined,
                    actions: hasActions ? ()=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                            !slots.actions ? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)(btnProps.value, {
                                "onClick": onClickClose
                            }), null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                "defaults": {
                                    VBtn: btnProps.value
                                }
                            }, {
                                default: ()=>[
                                        slots.actions({
                                            item: current.value,
                                            props: {
                                                onClick: onClickClose
                                            }
                                        })
                                    ]
                            })
                        ]) : undefined
                }))
            ]);
        });
    }
});




var $0a424506ae920269$exports = {};

$parcel$export($0a424506ae920269$exports, "VSparkline", () => $0702d17d55379f44$export$e0136f5b9f4808f4);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
// Utilities

const $d1528dee5748e3d9$export$5c73e4f965147599 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    autoDraw: Boolean,
    autoDrawDuration: [
        Number,
        String
    ],
    autoDrawEasing: {
        type: String,
        default: 'ease'
    },
    color: String,
    gradient: {
        type: Array,
        default: ()=>[]
    },
    gradientDirection: {
        type: String,
        validator: (val)=>[
                'top',
                'bottom',
                'left',
                'right'
            ].includes(val),
        default: 'top'
    },
    height: {
        type: [
            String,
            Number
        ],
        default: 75
    },
    labels: {
        type: Array,
        default: ()=>[]
    },
    labelSize: {
        type: [
            Number,
            String
        ],
        default: 7
    },
    lineWidth: {
        type: [
            String,
            Number
        ],
        default: 4
    },
    id: String,
    itemValue: {
        type: String,
        default: 'value'
    },
    modelValue: {
        type: Array,
        default: ()=>[]
    },
    min: [
        String,
        Number
    ],
    max: [
        String,
        Number
    ],
    padding: {
        type: [
            String,
            Number
        ],
        default: 8
    },
    showLabels: Boolean,
    smooth: [
        Boolean,
        String,
        Number
    ],
    width: {
        type: [
            Number,
            String
        ],
        default: 300
    }
}, 'Line');



const $09f188a674e776ea$export$222ad48f0a9cf741 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    autoLineWidth: Boolean,
    ...(0, $d1528dee5748e3d9$export$5c73e4f965147599)()
}, 'VBarline');
const $09f188a674e776ea$export$6c8d6ade92fb3940 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VBarline',
    props: $09f188a674e776ea$export$222ad48f0a9cf741(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const uid = (0, $TusQn.useId)();
        const id = (0, $01W3b.computed)(()=>props.id || `barline-${uid}`);
        const autoDrawDuration = (0, $01W3b.computed)(()=>Number(props.autoDrawDuration) || 500);
        const hasLabels = (0, $01W3b.computed)(()=>{
            return Boolean(props.showLabels || props.labels.length > 0 || !!slots?.label);
        });
        const lineWidth = (0, $01W3b.computed)(()=>parseFloat(props.lineWidth) || 4);
        const totalWidth = (0, $01W3b.computed)(()=>Math.max(props.modelValue.length * lineWidth.value, Number(props.width)));
        const boundary = (0, $01W3b.computed)(()=>{
            return {
                minX: 0,
                maxX: totalWidth.value,
                minY: 0,
                maxY: parseInt(props.height, 10)
            };
        });
        const items = (0, $01W3b.computed)(()=>props.modelValue.map((item)=>(0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemValue, item)));
        function genBars(values, boundary) {
            const { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = boundary;
            const totalValues = values.length;
            let maxValue = props.max != null ? Number(props.max) : Math.max(...values);
            let minValue = props.min != null ? Number(props.min) : Math.min(...values);
            if (minValue > 0 && props.min == null) minValue = 0;
            if (maxValue < 0 && props.max == null) maxValue = 0;
            const gridX = maxX / (totalValues === 1 ? 2 : totalValues);
            const gridY = (maxY - minY) / (maxValue - minValue || 1);
            const horizonY = maxY - Math.abs(minValue * gridY);
            return values.map((value, index)=>{
                const height = Math.abs(gridY * value);
                return {
                    x: minX + index * gridX,
                    y: horizonY - height + Number(value < 0) * height,
                    height: height,
                    value: value
                };
            });
        }
        const parsedLabels = (0, $01W3b.computed)(()=>{
            const labels = [];
            const points = genBars(items.value, boundary.value);
            const len = points.length;
            for(let i = 0; labels.length < len; i++){
                const item = points[i];
                let value = props.labels[i];
                if (!value) value = typeof item === 'object' ? item.value : item;
                labels.push({
                    x: item.x,
                    value: String(value)
                });
            }
            return labels;
        });
        const bars = (0, $01W3b.computed)(()=>genBars(items.value, boundary.value));
        const offsetX = (0, $01W3b.computed)(()=>bars.value.length === 1 ? (boundary.value.maxX - lineWidth.value) / 2 : (Math.abs(bars.value[0].x - bars.value[1].x) - lineWidth.value) / 2);
        const smooth = (0, $01W3b.computed)(()=>typeof props.smooth === 'boolean' ? props.smooth ? 2 : 0 : Number(props.smooth));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const gradientData = !props.gradient.slice().length ? [
                ''
            ] : props.gradient.slice().reverse();
            return (0, $TusQn.createElementVNode)("svg", {
                "display": "block"
            }, [
                (0, $TusQn.createElementVNode)("defs", null, [
                    (0, $TusQn.createElementVNode)("linearGradient", {
                        "id": id.value,
                        "gradientUnits": "userSpaceOnUse",
                        "x1": props.gradientDirection === 'left' ? '100%' : '0',
                        "y1": props.gradientDirection === 'top' ? '100%' : '0',
                        "x2": props.gradientDirection === 'right' ? '100%' : '0',
                        "y2": props.gradientDirection === 'bottom' ? '100%' : '0'
                    }, [
                        gradientData.map((color, index)=>(0, $TusQn.createElementVNode)("stop", {
                                "offset": index / Math.max(gradientData.length - 1, 1),
                                "stop-color": color || 'currentColor'
                            }, null))
                    ])
                ]),
                (0, $TusQn.createElementVNode)("clipPath", {
                    "id": `${id.value}-clip`
                }, [
                    bars.value.map((item)=>(0, $TusQn.createElementVNode)("rect", {
                            "x": item.x + offsetX.value,
                            "y": item.y,
                            "width": lineWidth.value,
                            "height": item.height,
                            "rx": smooth.value,
                            "ry": smooth.value
                        }, [
                            props.autoDraw && !(0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)() && (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                (0, $TusQn.createElementVNode)("animate", {
                                    "attributeName": "y",
                                    "from": item.y + item.height,
                                    "to": item.y,
                                    "dur": `${autoDrawDuration.value}ms`,
                                    "fill": "freeze"
                                }, null),
                                (0, $TusQn.createElementVNode)("animate", {
                                    "attributeName": "height",
                                    "from": "0",
                                    "to": item.height,
                                    "dur": `${autoDrawDuration.value}ms`,
                                    "fill": "freeze"
                                }, null)
                            ])
                        ]))
                ]),
                hasLabels.value && (0, $TusQn.createElementVNode)("g", {
                    "key": "labels",
                    "style": {
                        textAnchor: 'middle',
                        dominantBaseline: 'mathematical',
                        fill: 'currentColor'
                    }
                }, [
                    parsedLabels.value.map((item, i)=>(0, $TusQn.createElementVNode)("text", {
                            "x": item.x + offsetX.value + lineWidth.value / 2,
                            "y": parseInt(props.height, 10) - 2 + (parseInt(props.labelSize, 10) || 5.25),
                            "font-size": Number(props.labelSize) || 7
                        }, [
                            slots.label?.({
                                index: i,
                                value: item.value
                            }) ?? item.value
                        ]))
                ]),
                (0, $TusQn.createElementVNode)("g", {
                    "clip-path": `url(#${id.value}-clip)`,
                    "fill": `url(#${id.value})`
                }, [
                    (0, $TusQn.createElementVNode)("rect", {
                        "x": 0,
                        "y": 0,
                        "width": Math.max(props.modelValue.length * lineWidth.value, Number(props.width)),
                        "height": props.height
                    }, null)
                ])
            ]);
        });
    }
});


// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

// @ts-nocheck
/* eslint-disable */ // import { checkCollinear, getDistance, moveTo } from './math'
/**
 * From https://github.com/unsplash/react-trend/blob/master/src/helpers/DOM.helpers.js#L18
 */ function $2dcb57c293ca81e7$export$70465fece77953a5(points, radius) {
    let fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 75;
    if (points.length === 0) return '';
    const start = points.shift();
    const end = points[points.length - 1];
    return (fill ? `M${start.x} ${height - start.x + 2} L${start.x} ${start.y}` : `M${start.x} ${start.y}`) + points.map((point, index)=>{
        const next = points[index + 1];
        const prev = points[index - 1] || start;
        const isCollinear = next && $2dcb57c293ca81e7$export$188f7419cae70733(next, point, prev);
        if (!next || isCollinear) return `L${point.x} ${point.y}`;
        const threshold = Math.min($2dcb57c293ca81e7$export$79376507b09a66f(prev, point), $2dcb57c293ca81e7$export$79376507b09a66f(next, point));
        const isTooCloseForRadius = threshold / 2 < radius;
        const radiusForPoint = isTooCloseForRadius ? threshold / 2 : radius;
        const before = $2dcb57c293ca81e7$export$75f1ccd6dc32e80a(prev, point, radiusForPoint);
        const after = $2dcb57c293ca81e7$export$75f1ccd6dc32e80a(next, point, radiusForPoint);
        return `L${before.x} ${before.y}S${point.x} ${point.y} ${after.x} ${after.y}`;
    }).join('') + (fill ? `L${end.x} ${height - start.x + 2} Z` : '');
}
function $2dcb57c293ca81e7$var$int(value) {
    return parseInt(value, 10);
}
function $2dcb57c293ca81e7$export$188f7419cae70733(p0, p1, p2) {
    return $2dcb57c293ca81e7$var$int(p0.x + p2.x) === $2dcb57c293ca81e7$var$int(2 * p1.x) && $2dcb57c293ca81e7$var$int(p0.y + p2.y) === $2dcb57c293ca81e7$var$int(2 * p1.y);
}
function $2dcb57c293ca81e7$export$79376507b09a66f(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}
function $2dcb57c293ca81e7$export$75f1ccd6dc32e80a(to, from, radius) {
    const vector = {
        x: to.x - from.x,
        y: to.y - from.y
    };
    const length = Math.sqrt(vector.x * vector.x + vector.y * vector.y);
    const unitVector = {
        x: vector.x / length,
        y: vector.y / length
    };
    return {
        x: from.x + unitVector.x * radius,
        y: from.y + unitVector.y * radius
    };
}



const $c69ab6c0c157892d$export$90c370e213d9a9b4 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    fill: Boolean,
    ...(0, $d1528dee5748e3d9$export$5c73e4f965147599)()
}, 'VTrendline');
const $c69ab6c0c157892d$export$82fedc3e5dab96c5 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTrendline',
    props: $c69ab6c0c157892d$export$90c370e213d9a9b4(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const uid = (0, $TusQn.useId)();
        const id = (0, $01W3b.computed)(()=>props.id || `trendline-${uid}`);
        const autoDrawDuration = (0, $01W3b.computed)(()=>Number(props.autoDrawDuration) || (props.fill ? 500 : 2000));
        const lastLength = (0, $01W3b.ref)(0);
        const path = (0, $01W3b.ref)(null);
        function genPoints(values, boundary) {
            const { minX: minX, maxX: maxX, minY: minY, maxY: maxY } = boundary;
            if (values.length === 1) values = [
                values[0],
                values[0]
            ];
            const totalValues = values.length;
            const maxValue = props.max != null ? Number(props.max) : Math.max(...values);
            const minValue = props.min != null ? Number(props.min) : Math.min(...values);
            const gridX = (maxX - minX) / (totalValues - 1);
            const gridY = (maxY - minY) / (maxValue - minValue || 1);
            return values.map((value, index)=>{
                return {
                    x: minX + index * gridX,
                    y: maxY - (value - minValue) * gridY,
                    value: value
                };
            });
        }
        const hasLabels = (0, $01W3b.computed)(()=>{
            return Boolean(props.showLabels || props.labels.length > 0 || !!slots?.label);
        });
        const lineWidth = (0, $01W3b.computed)(()=>{
            return parseFloat(props.lineWidth) || 4;
        });
        const totalWidth = (0, $01W3b.computed)(()=>Number(props.width));
        const boundary = (0, $01W3b.computed)(()=>{
            const padding = Number(props.padding);
            return {
                minX: padding,
                maxX: totalWidth.value - padding,
                minY: padding,
                maxY: parseInt(props.height, 10) - padding
            };
        });
        const items = (0, $01W3b.computed)(()=>props.modelValue.map((item)=>(0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemValue, item)));
        const parsedLabels = (0, $01W3b.computed)(()=>{
            const labels = [];
            const points = genPoints(items.value, boundary.value);
            const len = points.length;
            for(let i = 0; labels.length < len; i++){
                const item = points[i];
                let value = props.labels[i];
                if (!value) value = typeof item === 'object' ? item.value : item;
                labels.push({
                    x: item.x,
                    value: String(value)
                });
            }
            return labels;
        });
        (0, $01W3b.watch)(()=>props.modelValue, async ()=>{
            await (0, $TusQn.nextTick)();
            if (!props.autoDraw || !path.value || (0, $90a48ad178b943d3$export$2022ae7bc01fd4dd)()) return;
            const pathRef = path.value;
            const length = pathRef.getTotalLength();
            if (!props.fill) {
                // Initial setup to "hide" the line by using the stroke dash array
                pathRef.style.strokeDasharray = `${length}`;
                pathRef.style.strokeDashoffset = `${length}`;
                // Force reflow to ensure the transition starts from this state
                pathRef.getBoundingClientRect();
                // Animate the stroke dash offset to "draw" the line
                pathRef.style.transition = `stroke-dashoffset ${autoDrawDuration.value}ms ${props.autoDrawEasing}`;
                pathRef.style.strokeDashoffset = '0';
            } else {
                // Your existing logic for filled paths remains the same
                pathRef.style.transformOrigin = 'bottom center';
                pathRef.style.transition = 'none';
                pathRef.style.transform = `scaleY(0)`;
                pathRef.getBoundingClientRect();
                pathRef.style.transition = `transform ${autoDrawDuration.value}ms ${props.autoDrawEasing}`;
                pathRef.style.transform = `scaleY(1)`;
            }
            lastLength.value = length;
        }, {
            immediate: true
        });
        function genPath(fill) {
            const smoothValue = typeof props.smooth === 'boolean' ? props.smooth ? 8 : 0 : Number(props.smooth);
            return (0, $2dcb57c293ca81e7$export$70465fece77953a5)(genPoints(items.value, boundary.value), smoothValue, fill, parseInt(props.height, 10));
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const gradientData = !props.gradient.slice().length ? [
                ''
            ] : props.gradient.slice().reverse();
            return (0, $TusQn.createElementVNode)("svg", {
                "display": "block",
                "stroke-width": parseFloat(props.lineWidth) ?? 4
            }, [
                (0, $TusQn.createElementVNode)("defs", null, [
                    (0, $TusQn.createElementVNode)("linearGradient", {
                        "id": id.value,
                        "gradientUnits": "userSpaceOnUse",
                        "x1": props.gradientDirection === 'left' ? '100%' : '0',
                        "y1": props.gradientDirection === 'top' ? '100%' : '0',
                        "x2": props.gradientDirection === 'right' ? '100%' : '0',
                        "y2": props.gradientDirection === 'bottom' ? '100%' : '0'
                    }, [
                        gradientData.map((color, index)=>(0, $TusQn.createElementVNode)("stop", {
                                "offset": index / Math.max(gradientData.length - 1, 1),
                                "stop-color": color || 'currentColor'
                            }, null))
                    ])
                ]),
                hasLabels.value && (0, $TusQn.createElementVNode)("g", {
                    "key": "labels",
                    "style": {
                        textAnchor: 'middle',
                        dominantBaseline: 'mathematical',
                        fill: 'currentColor'
                    }
                }, [
                    parsedLabels.value.map((item, i)=>(0, $TusQn.createElementVNode)("text", {
                            "x": item.x + lineWidth.value / 2 + lineWidth.value / 2,
                            "y": parseInt(props.height, 10) - 4 + (parseInt(props.labelSize, 10) || 5.25),
                            "font-size": Number(props.labelSize) || 7
                        }, [
                            slots.label?.({
                                index: i,
                                value: item.value
                            }) ?? item.value
                        ]))
                ]),
                (0, $TusQn.createElementVNode)("path", {
                    "ref": path,
                    "d": genPath(props.fill),
                    "fill": props.fill ? `url(#${id.value})` : 'none',
                    "stroke": props.fill ? 'none' : `url(#${id.value})`
                }, null),
                props.fill && (0, $TusQn.createElementVNode)("path", {
                    "d": genPath(false),
                    "fill": "none",
                    "stroke": props.color ?? props.gradient?.[0]
                }, null)
            ]);
        });
    }
});




const $0702d17d55379f44$export$5c280328198e1bda = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    type: {
        type: String,
        default: 'trend'
    },
    ...(0, $09f188a674e776ea$export$222ad48f0a9cf741)(),
    ...(0, $c69ab6c0c157892d$export$90c370e213d9a9b4)()
}, 'VSparkline');
const $0702d17d55379f44$export$e0136f5b9f4808f4 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSparkline',
    props: $0702d17d55379f44$export$5c280328198e1bda(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.color);
        const hasLabels = (0, $01W3b.computed)(()=>{
            return Boolean(props.showLabels || props.labels.length > 0 || !!slots?.label);
        });
        const totalHeight = (0, $01W3b.computed)(()=>{
            let height = parseInt(props.height, 10);
            if (hasLabels.value) height += parseInt(props.labelSize, 10) * 1.5;
            return height;
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const Tag = props.type === 'trend' ? (0, $c69ab6c0c157892d$export$82fedc3e5dab96c5) : (0, $09f188a674e776ea$export$6c8d6ade92fb3940);
            const lineProps = props.type === 'trend' ? (0, $c69ab6c0c157892d$export$82fedc3e5dab96c5).filterProps(props) : (0, $09f188a674e776ea$export$6c8d6ade92fb3940).filterProps(props);
            return (0, $TusQn.createVNode)(Tag, (0, $TusQn.mergeProps)({
                "key": props.type,
                "class": textColorClasses.value,
                "style": textColorStyles.value,
                "viewBox": `0 0 ${props.width} ${parseInt(totalHeight.value, 10)}`
            }, lineProps), slots);
        });
    }
});




var $cf7c23996f7ca02b$exports = {};

$parcel$export($cf7c23996f7ca02b$exports, "VSpeedDial", () => $de7adb47764091f5$export$e8356b230e0f21e3);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");







const $de7adb47764091f5$export$7aa2339d00109abe = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $9208258024e22101$export$d914c5b32001cb2e)({
        offset: 8,
        minWidth: 0,
        openDelay: 0,
        closeDelay: 100,
        location: 'top center',
        transition: 'scale-transition'
    })
}, 'VSpeedDial');
const $de7adb47764091f5$export$e8356b230e0f21e3 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSpeedDial',
    props: $de7adb47764091f5$export$7aa2339d00109abe(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const menuRef = (0, $01W3b.ref)();
        const location = (0, $01W3b.computed)(()=>{
            const [y, x = 'center'] = props.location?.split(' ') ?? [];
            return `${y} ${x}`;
        });
        const locationClasses = (0, $01W3b.computed)(()=>({
                [`v-speed-dial__content--${location.value.replace(' ', '-')}`]: true
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const menuProps = (0, $9208258024e22101$export$a347888d6b8f252a).filterProps(props);
            return (0, $TusQn.createVNode)((0, $9208258024e22101$export$a347888d6b8f252a), (0, $TusQn.mergeProps)(menuProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": props.class,
                "style": props.style,
                "contentClass": [
                    'v-speed-dial__content',
                    locationClasses.value,
                    props.contentClass
                ],
                "location": location.value,
                "ref": menuRef,
                "transition": "fade-transition"
            }), {
                ...slots,
                default: (slotProps)=>(0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                        "defaults": {
                            VBtn: {
                                size: 'small'
                            }
                        }
                    }, {
                        default: ()=>[
                                (0, $TusQn.createVNode)((0, $fcbabbbc201ae8b0$export$dee7d6ab6955c95e), {
                                    "appear": true,
                                    "group": true,
                                    "transition": props.transition
                                }, {
                                    default: ()=>[
                                            slots.default?.(slotProps)
                                        ]
                                })
                            ]
                    })
            });
        });
        return {};
    }
});




var $0b3f7f13b602e34c$exports = {};

$parcel$export($0b3f7f13b602e34c$exports, "VStepper", () => $779be5fd0fabd182$export$d71b89a1c76eeba4);
$parcel$export($0b3f7f13b602e34c$exports, "VStepperActions", () => $f038a0fc69789be8$export$8f37e166a106cb48);
$parcel$export($0b3f7f13b602e34c$exports, "VStepperHeader", () => $fd94bf625abe2bd0$export$5080a7d7bfd22d69);
$parcel$export($0b3f7f13b602e34c$exports, "VStepperItem", () => $357edb8226de1435$export$e96da59f2149afb6);
$parcel$export($0b3f7f13b602e34c$exports, "VStepperWindow", () => $6e1a44e009b79086$export$238a44a6cb5ecb45);
$parcel$export($0b3f7f13b602e34c$exports, "VStepperWindowItem", () => $97b9c70d149bb7f7$export$cb78a3090dfe8671);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

// Types
const $30e7c28f1679dd7b$export$d8ee4ff2bc0a6403 = Symbol.for('vuetify:v-stepper');


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");




const $f038a0fc69789be8$export$3aef26cced4a737 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    disabled: {
        type: [
            Boolean,
            String
        ],
        default: false
    },
    prevText: {
        type: String,
        default: '$vuetify.stepper.prev'
    },
    nextText: {
        type: String,
        default: '$vuetify.stepper.next'
    }
}, 'VStepperActions');
const $f038a0fc69789be8$export$8f37e166a106cb48 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VStepperActions',
    props: $f038a0fc69789be8$export$3aef26cced4a737(),
    emits: {
        'click:prev': ()=>true,
        'click:next': ()=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        function onClickPrev() {
            emit('click:prev');
        }
        function onClickNext() {
            emit('click:next');
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const prevSlotProps = {
                onClick: onClickPrev
            };
            const nextSlotProps = {
                onClick: onClickNext
            };
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-stepper-actions"
            }, [
                (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                    "defaults": {
                        VBtn: {
                            disabled: [
                                'prev',
                                true
                            ].includes(props.disabled),
                            text: t(props.prevText),
                            variant: 'text'
                        }
                    }
                }, {
                    default: ()=>[
                            slots.prev?.({
                                props: prevSlotProps
                            }) ?? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), prevSlotProps, null)
                        ]
                }),
                (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                    "defaults": {
                        VBtn: {
                            color: props.color,
                            disabled: [
                                'next',
                                true
                            ].includes(props.disabled),
                            text: t(props.nextText),
                            variant: 'tonal'
                        }
                    }
                }, {
                    default: ()=>[
                            slots.next?.({
                                props: nextSlotProps
                            }) ?? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), nextSlotProps, null)
                        ]
                })
            ]);
        });
        return {};
    }
});


// Utilities

const $fd94bf625abe2bd0$export$5080a7d7bfd22d69 = (0, $5224ab9d69b8c3e0$export$b3680ae2c271b9f3)('v-stepper-header');


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");









const $357edb8226de1435$export$6f6f2035c111ae02 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    title: String,
    subtitle: String,
    complete: Boolean,
    completeIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$complete'
    },
    editable: Boolean,
    editIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$edit'
    },
    error: Boolean,
    errorIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$error'
    },
    icon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    ripple: {
        type: [
            Boolean,
            Object
        ],
        default: true
    },
    rules: {
        type: Array,
        default: ()=>[]
    }
}, 'StepperItem');
const $357edb8226de1435$export$716df0446fc4d770 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...$357edb8226de1435$export$6f6f2035c111ae02(),
    ...(0, $0befa53cf46b542b$export$e9e3b570044587e8)()
}, 'VStepperItem');
const $357edb8226de1435$export$e96da59f2149afb6 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VStepperItem',
    directives: {
        vRipple: $907916373bf62ceb$export$2e2bcd8739ae039
    },
    props: $357edb8226de1435$export$716df0446fc4d770(),
    emits: {
        'group:selected': (val)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const group = (0, $0befa53cf46b542b$export$eebde8160f061c26)(props, (0, $30e7c28f1679dd7b$export$d8ee4ff2bc0a6403), true);
        const step = (0, $01W3b.computed)(()=>group?.value.value ?? props.value);
        const isValid = (0, $01W3b.computed)(()=>props.rules.every((handler)=>handler() === true));
        const isClickable = (0, $01W3b.computed)(()=>!props.disabled && props.editable);
        const canEdit = (0, $01W3b.computed)(()=>!props.disabled && props.editable);
        const hasError = (0, $01W3b.computed)(()=>props.error || !isValid.value);
        const hasCompleted = (0, $01W3b.computed)(()=>props.complete || props.rules.length > 0 && isValid.value);
        const icon = (0, $01W3b.computed)(()=>{
            if (hasError.value) return props.errorIcon;
            if (hasCompleted.value) return props.completeIcon;
            if (group.isSelected.value && props.editable) return props.editIcon;
            return props.icon;
        });
        const slotProps = (0, $01W3b.computed)(()=>({
                canEdit: canEdit.value,
                hasError: hasError.value,
                hasCompleted: hasCompleted.value,
                title: props.title,
                subtitle: props.subtitle,
                step: step.value,
                value: props.value
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasColor = (!group || group.isSelected.value || hasCompleted.value || canEdit.value) && !hasError.value && !props.disabled;
            const hasTitle = !!(props.title != null || slots.title);
            const hasSubtitle = !!(props.subtitle != null || slots.subtitle);
            function onClick() {
                group?.toggle();
            }
            return (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("button", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-stepper-item',
                    {
                        'v-stepper-item--complete': hasCompleted.value,
                        'v-stepper-item--disabled': props.disabled,
                        'v-stepper-item--error': hasError.value
                    },
                    group?.selectedClass.value
                ]),
                "disabled": !props.editable,
                "type": "button",
                "onClick": onClick
            }, [
                isClickable.value && (0, $567f01637e3e83ec$export$e27cd265ed232373)(true, 'v-stepper-item'),
                (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                    "key": "stepper-avatar",
                    "class": "v-stepper-item__avatar",
                    "color": hasColor ? props.color : undefined,
                    "size": 24
                }, {
                    default: ()=>[
                            slots.icon?.(slotProps.value) ?? (icon.value ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                "icon": icon.value
                            }, null) : step.value)
                        ]
                }),
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-stepper-item__content"
                }, [
                    hasTitle && (0, $TusQn.createElementVNode)("div", {
                        "key": "title",
                        "class": "v-stepper-item__title"
                    }, [
                        slots.title?.(slotProps.value) ?? props.title
                    ]),
                    hasSubtitle && (0, $TusQn.createElementVNode)("div", {
                        "key": "subtitle",
                        "class": "v-stepper-item__subtitle"
                    }, [
                        slots.subtitle?.(slotProps.value) ?? props.subtitle
                    ]),
                    slots.default?.(slotProps.value)
                ])
            ]), [
                [
                    (0, $907916373bf62ceb$export$2e2bcd8739ae039),
                    props.editable && props.ripple,
                    null
                ]
            ]);
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");




const $6e1a44e009b79086$export$d1585806c2c3e337 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $27128a8be1af1448$export$25b8cee22976996f)(), [
        'continuous',
        'nextIcon',
        'prevIcon',
        'showArrows',
        'touch',
        'mandatory'
    ])
}, 'VStepperWindow');
const $6e1a44e009b79086$export$238a44a6cb5ecb45 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VStepperWindow',
    props: $6e1a44e009b79086$export$d1585806c2c3e337(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const group = (0, $TusQn.inject)((0, $30e7c28f1679dd7b$export$d8ee4ff2bc0a6403), null);
        const _model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const model = (0, $01W3b.computed)({
            get () {
                // Always return modelValue if defined
                // or if not within a VStepper group
                if (_model.value != null || !group) return _model.value;
                // If inside of a VStepper, find the currently selected
                // item by id. Item value may be assigned by its index
                return group.items.value.find((item)=>group.selected.value.includes(item.id))?.value;
            },
            set (val) {
                _model.value = val;
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const windowProps = (0, $27128a8be1af1448$export$7e91eb8d1b90c043).filterProps(props);
            return (0, $TusQn.createVNode)((0, $27128a8be1af1448$export$7e91eb8d1b90c043), (0, $TusQn.mergeProps)({
                "_as": "VStepperWindow"
            }, windowProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-stepper-window',
                    props.class
                ],
                "style": props.style,
                "mandatory": false,
                "touch": false
            }), slots);
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");


const $97b9c70d149bb7f7$export$aa1ae043363d1030 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $2441fb35357f80c2$export$7fb6acff7c00736c)()
}, 'VStepperWindowItem');
const $97b9c70d149bb7f7$export$cb78a3090dfe8671 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VStepperWindowItem',
    props: $97b9c70d149bb7f7$export$aa1ae043363d1030(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const windowItemProps = (0, $2441fb35357f80c2$export$5dd5457a16e4a360).filterProps(props);
            return (0, $TusQn.createVNode)((0, $2441fb35357f80c2$export$5dd5457a16e4a360), (0, $TusQn.mergeProps)({
                "_as": "VStepperWindowItem"
            }, windowItemProps, {
                "class": [
                    'v-stepper-window-item',
                    props.class
                ],
                "style": props.style
            }), slots);
        });
        return {};
    }
});









const $779be5fd0fabd182$export$ba77a79bea1d4366 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    altLabels: Boolean,
    bgColor: String,
    completeIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    editIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    editable: Boolean,
    errorIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    hideActions: Boolean,
    items: {
        type: Array,
        default: ()=>[]
    },
    itemTitle: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'title'
    },
    itemValue: {
        type: [
            String,
            Array,
            Function
        ],
        default: 'value'
    },
    itemProps: {
        type: [
            Boolean,
            String,
            Array,
            Function
        ],
        default: 'props'
    },
    nonLinear: Boolean,
    flat: Boolean,
    ...(0, $1444e2cf1a712792$export$d0badecb383b472a)()
}, 'Stepper');
const $779be5fd0fabd182$export$e15706ca8fb34f8d = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...$779be5fd0fabd182$export$ba77a79bea1d4366(),
    ...(0, $0befa53cf46b542b$export$fa4c05b3520340e6)({
        mandatory: 'force',
        selectedClass: 'v-stepper-item--selected'
    }),
    ...(0, $ce059966358db8b1$export$a0ee5621cbdcc362)(),
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $f038a0fc69789be8$export$3aef26cced4a737)(), [
        'prevText',
        'nextText'
    ])
}, 'VStepper');
const $779be5fd0fabd182$export$d71b89a1c76eeba4 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VStepper',
    props: $779be5fd0fabd182$export$e15706ca8fb34f8d(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { items: _items, next: next, prev: prev, selected: selected } = (0, $0befa53cf46b542b$export$bfb6a372146ddc96)(props, (0, $30e7c28f1679dd7b$export$d8ee4ff2bc0a6403));
        const { displayClasses: displayClasses, mobile: mobile } = (0, $1444e2cf1a712792$export$8406b7efc286d284)(props);
        const { completeIcon: completeIcon, editIcon: editIcon, errorIcon: errorIcon, color: color, editable: editable, prevText: prevText, nextText: nextText } = (0, $01W3b.toRefs)(props);
        const items = (0, $01W3b.computed)(()=>props.items.map((item, index)=>{
                const title = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemTitle, item);
                const value = (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemValue, index + 1);
                const itemProps = props.itemProps === true ? item : (0, $8590040a7833369a$export$655f0e681f1365dc)(item, props.itemProps);
                const _props = {
                    title: title,
                    value: value,
                    ...itemProps
                };
                return {
                    title: _props.title,
                    value: _props.value,
                    props: _props,
                    raw: item
                };
            }));
        const activeIndex = (0, $01W3b.computed)(()=>{
            return _items.value.findIndex((item)=>selected.value.includes(item.id));
        });
        const disabled = (0, $01W3b.computed)(()=>{
            if (props.disabled) return props.disabled;
            if (activeIndex.value === 0) return 'prev';
            if (activeIndex.value === _items.value.length - 1) return 'next';
            return false;
        });
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VStepperItem: {
                editable: editable,
                errorIcon: errorIcon,
                completeIcon: completeIcon,
                editIcon: editIcon,
                prevText: prevText,
                nextText: nextText
            },
            VStepperActions: {
                color: color,
                disabled: disabled,
                prevText: prevText,
                nextText: nextText
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const sheetProps = (0, $ce059966358db8b1$export$d41b26ce18186ef0).filterProps(props);
            const hasHeader = !!(slots.header || props.items.length);
            const hasWindow = props.items.length > 0;
            const hasActions = !props.hideActions && !!(hasWindow || slots.actions);
            return (0, $TusQn.createVNode)((0, $ce059966358db8b1$export$d41b26ce18186ef0), (0, $TusQn.mergeProps)(sheetProps, {
                "color": props.bgColor,
                "class": [
                    'v-stepper',
                    {
                        'v-stepper--alt-labels': props.altLabels,
                        'v-stepper--flat': props.flat,
                        'v-stepper--non-linear': props.nonLinear,
                        'v-stepper--mobile': mobile.value
                    },
                    displayClasses.value,
                    props.class
                ],
                "style": props.style
            }), {
                default: ()=>[
                        hasHeader && (0, $TusQn.createVNode)((0, $fd94bf625abe2bd0$export$5080a7d7bfd22d69), {
                            "key": "stepper-header"
                        }, {
                            default: ()=>[
                                    items.value.map((_ref2, index)=>{
                                        let { raw: raw, ...item } = _ref2;
                                        return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                            !!index && (0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), null, null),
                                            (0, $TusQn.createVNode)((0, $357edb8226de1435$export$e96da59f2149afb6), item.props, {
                                                default: slots[`header-item.${item.value}`] ?? slots.header,
                                                icon: slots.icon,
                                                title: slots.title,
                                                subtitle: slots.subtitle
                                            })
                                        ]);
                                    })
                                ]
                        }),
                        hasWindow && (0, $TusQn.createVNode)((0, $6e1a44e009b79086$export$238a44a6cb5ecb45), {
                            "key": "stepper-window"
                        }, {
                            default: ()=>[
                                    items.value.map((item)=>(0, $TusQn.createVNode)((0, $97b9c70d149bb7f7$export$cb78a3090dfe8671), {
                                            "value": item.value
                                        }, {
                                            default: ()=>slots[`item.${item.value}`]?.(item) ?? slots.item?.(item)
                                        }))
                                ]
                        }),
                        slots.default?.({
                            prev: prev,
                            next: next
                        }),
                        hasActions && (slots.actions?.({
                            next: next,
                            prev: prev
                        }) ?? (0, $TusQn.createVNode)((0, $f038a0fc69789be8$export$8f37e166a106cb48), {
                            "key": "stepper-actions",
                            "onClick:prev": prev,
                            "onClick:next": next
                        }, slots))
                    ]
            });
        });
        return {
            prev: prev,
            next: next
        };
    }
});









var $09fdc5b6c80c863b$exports = {};

$parcel$export($09fdc5b6c80c863b$exports, "VSwitch", () => $aad75a4c1c554f1a$export$f4b527597b639fa9);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");












const $aad75a4c1c554f1a$export$7dc4819afbfc762a = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    indeterminate: Boolean,
    inset: Boolean,
    flat: Boolean,
    loading: {
        type: [
            Boolean,
            String
        ],
        default: false
    },
    ...(0, $97e8c489e405a584$export$525655a73981d616)(),
    ...(0, $6bf6692b535e8488$export$a15300eeb449da9c)()
}, 'VSwitch');
const $aad75a4c1c554f1a$export$f4b527597b639fa9 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSwitch',
    inheritAttrs: false,
    props: $aad75a4c1c554f1a$export$7dc4819afbfc762a(),
    emits: {
        'update:focused': (focused)=>true,
        'update:modelValue': (value)=>true,
        'update:indeterminate': (value)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const indeterminate = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'indeterminate');
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { loaderClasses: loaderClasses } = (0, $aec6311fd012b86e$export$14095de704efe3f9)(props);
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $fdb5f7d63722b03f$export$f8168d8dd8fd66e6)(props);
        const control = (0, $01W3b.ref)();
        const inputRef = (0, $01W3b.ref)();
        const isForcedColorsModeActive = (0, $90a48ad178b943d3$export$622094c5d6c3013b) && window.matchMedia('(forced-colors: active)').matches;
        const loaderColor = (0, $01W3b.toRef)(()=>{
            return typeof props.loading === 'string' && props.loading !== '' ? props.loading : props.color;
        });
        const uid = (0, $TusQn.useId)();
        const id = (0, $01W3b.toRef)(()=>props.id || `switch-${uid}`);
        function onChange() {
            if (indeterminate.value) indeterminate.value = false;
        }
        function onTrackClick(e) {
            e.stopPropagation();
            e.preventDefault();
            control.value?.input?.click();
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const [rootAttrs, controlAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            const inputProps = (0, $97e8c489e405a584$export$2aca538d9f87f6ac).filterProps(props);
            const controlProps = (0, $6bf6692b535e8488$export$ada18d63da74fb09).filterProps(props);
            return (0, $TusQn.createVNode)((0, $97e8c489e405a584$export$2aca538d9f87f6ac), (0, $TusQn.mergeProps)({
                "ref": inputRef,
                "class": [
                    'v-switch',
                    {
                        'v-switch--flat': props.flat
                    },
                    {
                        'v-switch--inset': props.inset
                    },
                    {
                        'v-switch--indeterminate': indeterminate.value
                    },
                    loaderClasses.value,
                    props.class
                ]
            }, rootAttrs, inputProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "id": id.value,
                "focused": isFocused.value,
                "style": props.style
            }), {
                ...slots,
                default: (_ref2)=>{
                    let { id: id, messagesId: messagesId, isDisabled: isDisabled, isReadonly: isReadonly, isValid: isValid } = _ref2;
                    const slotProps = {
                        model: model,
                        isValid: isValid
                    };
                    return (0, $TusQn.createVNode)((0, $6bf6692b535e8488$export$ada18d63da74fb09), (0, $TusQn.mergeProps)({
                        "ref": control
                    }, controlProps, {
                        "modelValue": model.value,
                        "onUpdate:modelValue": [
                            ($event)=>model.value = $event,
                            onChange
                        ],
                        "id": id.value,
                        "aria-describedby": messagesId.value,
                        "type": "checkbox",
                        "aria-checked": indeterminate.value ? 'mixed' : undefined,
                        "disabled": isDisabled.value,
                        "readonly": isReadonly.value,
                        "onFocus": focus,
                        "onBlur": blur
                    }, controlAttrs), {
                        ...slots,
                        default: (_ref3)=>{
                            let { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = _ref3;
                            return (0, $TusQn.createElementVNode)("div", {
                                "class": (0, $8POXm.normalizeClass)([
                                    'v-switch__track',
                                    !isForcedColorsModeActive ? backgroundColorClasses.value : undefined
                                ]),
                                "style": (0, $8POXm.normalizeStyle)(backgroundColorStyles.value),
                                "onClick": onTrackClick
                            }, [
                                slots['track-true'] && (0, $TusQn.createElementVNode)("div", {
                                    "key": "prepend",
                                    "class": "v-switch__track-true"
                                }, [
                                    slots['track-true'](slotProps)
                                ]),
                                slots['track-false'] && (0, $TusQn.createElementVNode)("div", {
                                    "key": "append",
                                    "class": "v-switch__track-false"
                                }, [
                                    slots['track-false'](slotProps)
                                ])
                            ]);
                        },
                        input: (_ref4)=>{
                            let { inputNode: inputNode, icon: icon, backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = _ref4;
                            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                inputNode,
                                (0, $TusQn.createElementVNode)("div", {
                                    "class": (0, $8POXm.normalizeClass)([
                                        'v-switch__thumb',
                                        {
                                            'v-switch__thumb--filled': icon || props.loading
                                        },
                                        props.inset || isForcedColorsModeActive ? undefined : backgroundColorClasses.value
                                    ]),
                                    "style": (0, $8POXm.normalizeStyle)(props.inset ? undefined : backgroundColorStyles.value)
                                }, [
                                    slots.thumb ? (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                        "defaults": {
                                            VIcon: {
                                                icon: icon,
                                                size: 'x-small'
                                            }
                                        }
                                    }, {
                                        default: ()=>[
                                                slots.thumb({
                                                    ...slotProps,
                                                    icon: icon
                                                })
                                            ]
                                    }) : (0, $TusQn.createVNode)((0, $7ec1b0ef33b04126$export$5d9397de61546474), null, {
                                        default: ()=>[
                                                !props.loading ? icon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                                    "key": String(icon),
                                                    "icon": icon,
                                                    "size": "x-small"
                                                }, null) : (0, $TusQn.createVNode)((0, $aec6311fd012b86e$export$9a5d46a3538da529), {
                                                    "name": "v-switch",
                                                    "active": true,
                                                    "color": isValid.value === false ? undefined : loaderColor.value
                                                }, {
                                                    default: (slotProps)=>slots.loader ? slots.loader(slotProps) : (0, $TusQn.createVNode)((0, $26f3a281106a205d$export$2b4afd8de42c0c21), {
                                                            "active": slotProps.isActive,
                                                            "color": slotProps.color,
                                                            "indeterminate": true,
                                                            "size": "16",
                                                            "width": "2"
                                                        }, null)
                                                })
                                            ]
                                    })
                                ])
                            ]);
                        }
                    });
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, inputRef);
    }
});




var $4337405fa3cb23e3$exports = {};

$parcel$export($4337405fa3cb23e3$exports, "VSystemBar", () => $23ac8b116bf6cc97$export$a4eb9b0d64886c6d);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");










const $23ac8b116bf6cc97$export$e88cde833a0a933b = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    color: String,
    height: [
        Number,
        String
    ],
    window: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $56e08e0125137781$export$d42abac634ace931)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VSystemBar');
const $23ac8b116bf6cc97$export$a4eb9b0d64886c6d = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VSystemBar',
    props: $23ac8b116bf6cc97$export$e88cde833a0a933b(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props);
        const { ssrBootStyles: ssrBootStyles } = (0, $0f95b8d0184d7fa9$export$f385cca8ac2b2f35)();
        const height = (0, $01W3b.computed)(()=>props.height ?? (props.window ? 32 : 24));
        const { layoutItemStyles: layoutItemStyles } = (0, $56e08e0125137781$export$e2f4c0dffffc8723)({
            id: props.name,
            order: (0, $01W3b.computed)(()=>parseInt(props.order, 10)),
            position: (0, $01W3b.shallowRef)('top'),
            layoutSize: height,
            elementSize: height,
            active: (0, $01W3b.computed)(()=>true),
            absolute: (0, $01W3b.toRef)(()=>props.absolute)
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-system-bar',
                    {
                        'v-system-bar--window': props.window
                    },
                    themeClasses.value,
                    backgroundColorClasses.value,
                    elevationClasses.value,
                    roundedClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    backgroundColorStyles.value,
                    layoutItemStyles.value,
                    ssrBootStyles.value,
                    props.style
                ])
            }, slots));
        return {};
    }
});




var $6e024ab9dc777125$exports = {};

$parcel$export($6e024ab9dc777125$exports, "VTab", () => $8a58410c96f4c687$export$f329ceb9f204f847);
$parcel$export($6e024ab9dc777125$exports, "VTabs", () => $89cc49730c6f5cb0$export$4317eb4b5dc6835);
$parcel$export($6e024ab9dc777125$exports, "VTabsWindow", () => $6d5c3c29491552af$export$9f9d2055cc6c09b8);
$parcel$export($6e024ab9dc777125$exports, "VTabsWindowItem", () => $6c5d664ede6137ad$export$94f5ea3c1db246aa);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");




// Types
const $646860f86828b042$export$df452bc869d6b823 = Symbol.for('vuetify:v-tabs');



const $8a58410c96f4c687$export$8b67f631a6cfcf80 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    fixed: Boolean,
    sliderColor: String,
    sliderTransition: String,
    sliderTransitionDuration: [
        String,
        Number
    ],
    hideSlider: Boolean,
    inset: Boolean,
    direction: {
        type: String,
        default: 'horizontal'
    },
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $a343b25403be30b7$export$64daea74540bd34d)({
        selectedClass: 'v-tab--selected',
        variant: 'text'
    }), [
        'active',
        'block',
        'flat',
        'location',
        'position',
        'symbol'
    ])
}, 'VTab');
const $8a58410c96f4c687$export$f329ceb9f204f847 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTab',
    props: $8a58410c96f4c687$export$8b67f631a6cfcf80(),
    setup (props, _ref) {
        let { slots: slots, attrs: attrs } = _ref;
        const { textColorClasses: sliderColorClasses, textColorStyles: sliderColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.sliderColor);
        const { backgroundColorClasses: insetColorClasses, backgroundColorStyles: insetColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.sliderColor);
        const rootEl = (0, $01W3b.ref)();
        const sliderEl = (0, $01W3b.ref)();
        const isHorizontal = (0, $01W3b.computed)(()=>props.direction === 'horizontal');
        const isSelected = (0, $01W3b.computed)(()=>rootEl.value?.group?.isSelected.value ?? false);
        function fade(nextEl, prevEl) {
            return {
                opacity: [
                    0,
                    1
                ]
            };
        }
        function grow(nextEl, prevEl) {
            return props.direction === 'vertical' ? {
                transform: [
                    'scaleY(0)',
                    'scaleY(1)'
                ]
            } : {
                transform: [
                    'scaleX(0)',
                    'scaleX(1)'
                ]
            };
        }
        function shift(nextEl, prevEl) {
            const prevBox = prevEl.getBoundingClientRect();
            const nextBox = nextEl.getBoundingClientRect();
            const xy = isHorizontal.value ? 'x' : 'y';
            const XY = isHorizontal.value ? 'X' : 'Y';
            const rightBottom = isHorizontal.value ? 'right' : 'bottom';
            const widthHeight = isHorizontal.value ? 'width' : 'height';
            const prevPos = prevBox[xy];
            const nextPos = nextBox[xy];
            const delta = prevPos > nextPos ? prevBox[rightBottom] - nextBox[rightBottom] : prevBox[xy] - nextBox[xy];
            const origin = Math.sign(delta) > 0 ? isHorizontal.value ? 'right' : 'bottom' : Math.sign(delta) < 0 ? isHorizontal.value ? 'left' : 'top' : 'center';
            const size = Math.abs(delta) + (Math.sign(delta) < 0 ? prevBox[widthHeight] : nextBox[widthHeight]);
            const scale = size / Math.max(prevBox[widthHeight], nextBox[widthHeight]) || 0;
            const initialScale = prevBox[widthHeight] / nextBox[widthHeight] || 0;
            const sigma = 1.5;
            return {
                transform: [
                    `translate${XY}(${delta}px) scale${XY}(${initialScale})`,
                    `translate${XY}(${delta / sigma}px) scale${XY}(${(scale - 1) / sigma + 1})`,
                    'none'
                ],
                transformOrigin: Array(3).fill(origin)
            };
        }
        function updateSlider(_ref2) {
            let { value: value } = _ref2;
            if (value) {
                const prevEl = rootEl.value?.$el.parentElement?.querySelector('.v-tab--selected .v-tab__slider');
                const nextEl = sliderEl.value;
                if (!prevEl || !nextEl) return;
                const color = getComputedStyle(prevEl).backgroundColor;
                const keyframes = {
                    fade: fade,
                    grow: grow,
                    shift: shift
                }[props.sliderTransition ?? 'shift'] ?? shift;
                const duration = Number(props.sliderTransitionDuration) || (({
                    fade: 400,
                    grow: 350,
                    shift: 225
                })[props.sliderTransition ?? 'shift'] ?? 225);
                (0, $d14b85b5564a2ed0$export$e3607ec2d7a891c4)(nextEl, {
                    backgroundColor: [
                        color,
                        color
                    ],
                    ...keyframes(nextEl, prevEl)
                }, {
                    duration: duration,
                    easing: (0, $f725c9134abb2fa7$export$bf86e2ccec972a06)
                });
            }
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const btnProps = (0, $a343b25403be30b7$export$657f28cf887b91a6).filterProps(props);
            return (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), (0, $TusQn.mergeProps)({
                "symbol": (0, $646860f86828b042$export$df452bc869d6b823),
                "ref": rootEl,
                "class": [
                    'v-tab',
                    props.class,
                    isSelected.value && props.inset ? insetColorClasses.value : []
                ],
                "style": [
                    props.style,
                    isSelected.value && props.inset ? insetColorStyles.value : [],
                    {
                        backgroundColor: isSelected.value && props.inset ? 'transparent !important' : undefined
                    }
                ],
                "tabindex": isSelected.value ? 0 : -1,
                "role": "tab",
                "aria-selected": String(isSelected.value),
                "active": false
            }, btnProps, attrs, {
                "block": props.fixed,
                "maxWidth": props.fixed ? 300 : undefined,
                "onGroup:selected": updateSlider
            }), {
                ...slots,
                default: ()=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots.default?.() ?? props.text,
                        !props.hideSlider && (0, $TusQn.createElementVNode)("div", {
                            "ref": sliderEl,
                            "class": (0, $8POXm.normalizeClass)([
                                'v-tab__slider',
                                props.inset ? insetColorClasses.value : sliderColorClasses.value
                            ]),
                            "style": (0, $8POXm.normalizeStyle)([
                                sliderColorStyles.value,
                                props.inset ? insetColorStyles.value : sliderColorClasses.value
                            ])
                        }, null)
                    ])
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, rootEl);
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");




const $6d5c3c29491552af$export$4090f644ec641abd = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $27128a8be1af1448$export$25b8cee22976996f)(), [
        'continuous',
        'nextIcon',
        'prevIcon',
        'showArrows',
        'touch',
        'mandatory'
    ])
}, 'VTabsWindow');
const $6d5c3c29491552af$export$9f9d2055cc6c09b8 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTabsWindow',
    props: $6d5c3c29491552af$export$4090f644ec641abd(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const group = (0, $TusQn.inject)((0, $646860f86828b042$export$df452bc869d6b823), null);
        const _model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const model = (0, $01W3b.computed)({
            get () {
                // Always return modelValue if defined
                // or if not within a VTabs group
                if (_model.value != null || !group) return _model.value;
                // If inside of a VTabs, find the currently selected
                // item by id. Item value may be assigned by its index
                return group.items.value.find((item)=>group.selected.value.includes(item.id))?.value;
            },
            set (val) {
                _model.value = val;
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const windowProps = (0, $27128a8be1af1448$export$7e91eb8d1b90c043).filterProps(props);
            return (0, $TusQn.createVNode)((0, $27128a8be1af1448$export$7e91eb8d1b90c043), (0, $TusQn.mergeProps)({
                "_as": "VTabsWindow"
            }, windowProps, {
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-tabs-window',
                    props.class
                ],
                "style": props.style,
                "mandatory": false,
                "touch": false
            }), slots);
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");


const $6c5d664ede6137ad$export$840fb8132a6799ab = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $2441fb35357f80c2$export$7fb6acff7c00736c)()
}, 'VTabsWindowItem');
const $6c5d664ede6137ad$export$94f5ea3c1db246aa = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTabsWindowItem',
    props: $6c5d664ede6137ad$export$840fb8132a6799ab(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const windowItemProps = (0, $2441fb35357f80c2$export$5dd5457a16e4a360).filterProps(props);
            return (0, $TusQn.createVNode)((0, $2441fb35357f80c2$export$5dd5457a16e4a360), (0, $TusQn.mergeProps)({
                "_as": "VTabsWindowItem"
            }, windowItemProps, {
                "class": [
                    'v-tabs-window-item',
                    props.class
                ],
                "style": props.style
            }), slots);
        });
        return {};
    }
});











function $89cc49730c6f5cb0$var$parseItems(items) {
    if (!items) return [];
    return items.map((item)=>{
        if (!(0, $8590040a7833369a$export$a6cdc56e425d0d0a)(item)) return {
            text: item,
            value: item
        };
        return item;
    });
}
const $89cc49730c6f5cb0$export$419b64ceeafc723d = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    alignTabs: {
        type: String,
        default: 'start'
    },
    color: String,
    fixedTabs: Boolean,
    items: {
        type: Array,
        default: ()=>[]
    },
    stacked: Boolean,
    bgColor: String,
    grow: Boolean,
    height: {
        type: [
            Number,
            String
        ],
        default: undefined
    },
    hideSlider: Boolean,
    inset: Boolean,
    insetPadding: [
        String,
        Number
    ],
    insetRadius: [
        String,
        Number
    ],
    sliderColor: String,
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $8a58410c96f4c687$export$8b67f631a6cfcf80)(), [
        'spaced',
        'sliderTransition',
        'sliderTransitionDuration'
    ]),
    ...(0, $d5c54c6c3d49c30f$export$8d9f6ad26ccf07ca)({
        mandatory: 'force',
        selectedClass: 'v-tab-item--selected'
    }),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VTabs');
const $89cc49730c6f5cb0$export$4317eb4b5dc6835 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTabs',
    props: $89cc49730c6f5cb0$export$419b64ceeafc723d(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, slots: slots } = _ref;
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const items = (0, $01W3b.computed)(()=>$89cc49730c6f5cb0$var$parseItems(props.items));
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.bgColor);
        const { scopeId: scopeId } = (0, $d897445671465531$export$eeabe5cda932100d)();
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VTab: {
                color: (0, $01W3b.toRef)(props, 'color'),
                direction: (0, $01W3b.toRef)(props, 'direction'),
                stacked: (0, $01W3b.toRef)(props, 'stacked'),
                fixed: (0, $01W3b.toRef)(props, 'fixedTabs'),
                inset: (0, $01W3b.toRef)(props, 'inset'),
                sliderColor: (0, $01W3b.toRef)(props, 'sliderColor'),
                sliderTransition: (0, $01W3b.toRef)(props, 'sliderTransition'),
                sliderTransitionDuration: (0, $01W3b.toRef)(props, 'sliderTransitionDuration'),
                hideSlider: (0, $01W3b.toRef)(props, 'hideSlider')
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const slideGroupProps = (0, $d5c54c6c3d49c30f$export$f3e025e558a486a4).filterProps(props);
            const hasWindow = !!(slots.window || props.items.length > 0);
            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                (0, $TusQn.createVNode)((0, $d5c54c6c3d49c30f$export$f3e025e558a486a4), (0, $TusQn.mergeProps)(slideGroupProps, {
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "class": [
                        'v-tabs',
                        `v-tabs--${props.direction}`,
                        `v-tabs--align-tabs-${props.alignTabs}`,
                        {
                            'v-tabs--fixed-tabs': props.fixedTabs,
                            'v-tabs--grow': props.grow,
                            'v-tabs--inset': props.inset,
                            'v-tabs--stacked': props.stacked
                        },
                        densityClasses.value,
                        backgroundColorClasses.value,
                        props.class
                    ],
                    "style": [
                        {
                            '--v-tabs-height': (0, $8590040a7833369a$export$286ad215293a0860)(props.height),
                            '--v-tabs-inset-padding': props.inset ? (0, $8590040a7833369a$export$286ad215293a0860)(props.insetPadding) : undefined,
                            '--v-tabs-inset-radius': props.inset ? (0, $8590040a7833369a$export$286ad215293a0860)(props.insetRadius) : undefined
                        },
                        backgroundColorStyles.value,
                        props.style
                    ],
                    "role": "tablist",
                    "symbol": (0, $646860f86828b042$export$df452bc869d6b823)
                }, scopeId, attrs), {
                    default: slots.default ?? (()=>items.value.map((item)=>slots.tab?.({
                                item: item
                            }) ?? (0, $TusQn.createVNode)((0, $8a58410c96f4c687$export$f329ceb9f204f847), (0, $TusQn.mergeProps)(item, {
                                "key": item.text,
                                "value": item.value,
                                "spaced": props.spaced
                            }), {
                                default: slots[`tab.${item.value}`] ? ()=>slots[`tab.${item.value}`]?.({
                                        item: item
                                    }) : undefined
                            }))),
                    prev: slots.prev,
                    next: slots.next
                }),
                hasWindow && (0, $TusQn.createVNode)((0, $6d5c3c29491552af$export$9f9d2055cc6c09b8), (0, $TusQn.mergeProps)({
                    "modelValue": model.value,
                    "onUpdate:modelValue": ($event)=>model.value = $event,
                    "key": "tabs-window"
                }, scopeId), {
                    default: ()=>[
                            items.value.map((item)=>slots.item?.({
                                    item: item
                                }) ?? (0, $TusQn.createVNode)((0, $6c5d664ede6137ad$export$94f5ea3c1db246aa), {
                                    "value": item.value
                                }, {
                                    default: ()=>slots[`item.${item.value}`]?.({
                                            item: item
                                        })
                                })),
                            slots.window?.()
                        ]
                })
            ]);
        });
        return {};
    }
});






var $d998a7169854bd53$exports = {};

$parcel$export($d998a7169854bd53$exports, "VTable", () => $935374c91796546f$export$95f18d4f6bf10502);



var $39d32e51da6e71e1$exports = {};

$parcel$export($39d32e51da6e71e1$exports, "VTextarea", () => $cfe4ae0cbd9a4e3d$export$9bdfdce9e7a0e519);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $eeJ70 = parcelRequire("eeJ70");














const $cfe4ae0cbd9a4e3d$export$3bffc1deba3cd16e = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    autoGrow: Boolean,
    autofocus: Boolean,
    counter: [
        Boolean,
        Number,
        String
    ],
    counterValue: Function,
    prefix: String,
    placeholder: String,
    persistentPlaceholder: Boolean,
    persistentCounter: Boolean,
    noResize: Boolean,
    rows: {
        type: [
            Number,
            String
        ],
        default: 5,
        validator: (v)=>!isNaN(parseFloat(v))
    },
    maxHeight: {
        type: [
            Number,
            String
        ],
        validator: (v)=>!isNaN(parseFloat(v))
    },
    maxRows: {
        type: [
            Number,
            String
        ],
        validator: (v)=>!isNaN(parseFloat(v))
    },
    suffix: String,
    modelModifiers: Object,
    ...(0, $beb849cd8f948406$export$899f6d4fa8e79208)(),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $97e8c489e405a584$export$525655a73981d616)(), [
        'direction'
    ]),
    ...(0, $d4f131cf7ef9c4a9$export$1e13429dc53b9634)()
}, 'VTextarea');
const $cfe4ae0cbd9a4e3d$export$9bdfdce9e7a0e519 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTextarea',
    directives: {
        vIntersect: $8d31333abb7bf4e7$export$2e2bcd8739ae039
    },
    inheritAttrs: false,
    props: $cfe4ae0cbd9a4e3d$export$3bffc1deba3cd16e(),
    emits: {
        'click:control': (e)=>true,
        'mousedown:control': (e)=>true,
        'update:focused': (focused)=>true,
        'update:modelValue': (val)=>true,
        'update:rows': (rows)=>true
    },
    setup (props, _ref) {
        let { attrs: attrs, emit: emit, slots: slots } = _ref;
        const model = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { isFocused: isFocused, focus: focus, blur: blur } = (0, $fdb5f7d63722b03f$export$f8168d8dd8fd66e6)(props);
        const { onIntersect: onIntersect } = (0, $8b87581f7b79111a$export$a9c05560d717b4fe)(props);
        const counterValue = (0, $01W3b.computed)(()=>{
            return typeof props.counterValue === 'function' ? props.counterValue(model.value) : (model.value || '').toString().length;
        });
        const max = (0, $01W3b.computed)(()=>{
            if (attrs.maxlength) return attrs.maxlength;
            if (!props.counter || typeof props.counter !== 'number' && typeof props.counter !== 'string') return undefined;
            return props.counter;
        });
        const vInputRef = (0, $01W3b.ref)();
        const vFieldRef = (0, $01W3b.ref)();
        const controlHeight = (0, $01W3b.shallowRef)('');
        const textareaRef = (0, $01W3b.ref)();
        const scrollbarWidth = (0, $01W3b.ref)(0);
        const { platform: platform } = (0, $1444e2cf1a712792$export$8406b7efc286d284)();
        const autocomplete = (0, $beb849cd8f948406$export$1e40b3ca02d92d21)(props);
        const isActive = (0, $01W3b.computed)(()=>props.persistentPlaceholder || isFocused.value || props.active);
        function onFocus() {
            if (autocomplete.isSuppressing.value) autocomplete.update();
            if (textareaRef.value !== document.activeElement) textareaRef.value?.focus();
            if (!isFocused.value) focus();
        }
        function onControlClick(e) {
            onFocus();
            emit('click:control', e);
        }
        function onControlMousedown(e) {
            emit('mousedown:control', e);
        }
        function onClear(e) {
            e.stopPropagation();
            onFocus();
            (0, $TusQn.nextTick)(()=>{
                model.value = '';
                (0, $8590040a7833369a$export$293b251ea77dc2b7)(props['onClick:clear'], e);
            });
        }
        function onInput(e) {
            const el = e.target;
            if (!props.modelModifiers?.trim) {
                model.value = el.value;
                return;
            }
            const value = el.value;
            const start = el.selectionStart;
            const end = el.selectionEnd;
            model.value = value;
            (0, $TusQn.nextTick)(()=>{
                let offset = 0;
                if (value.trimStart().length === el.value.length) // #22307 - Whitespace has been removed from the
                // start, offset the caret position to compensate
                offset = value.length - el.value.length;
                if (start != null) el.selectionStart = start - offset;
                if (end != null) el.selectionEnd = end - offset;
            });
        }
        const sizerRef = (0, $01W3b.ref)();
        const rows = (0, $01W3b.ref)(Number(props.rows));
        const isPlainOrUnderlined = (0, $01W3b.computed)(()=>[
                'plain',
                'underlined'
            ].includes(props.variant));
        (0, $TusQn.watchEffect)(()=>{
            if (!props.autoGrow) rows.value = Number(props.rows);
        });
        function calculateInputHeight() {
            (0, $TusQn.nextTick)(()=>{
                if (!textareaRef.value) return;
                if (platform.value.firefox) {
                    scrollbarWidth.value = 12;
                    return;
                }
                const { offsetWidth: offsetWidth, clientWidth: clientWidth } = textareaRef.value;
                scrollbarWidth.value = Math.max(0, offsetWidth - clientWidth);
            });
            if (!props.autoGrow) return;
            (0, $TusQn.nextTick)(()=>{
                if (!sizerRef.value || !vFieldRef.value) return;
                const style = getComputedStyle(sizerRef.value);
                const fieldStyle = getComputedStyle(vFieldRef.value.$el);
                const padding = parseFloat(style.getPropertyValue('--v-field-padding-top')) + parseFloat(style.getPropertyValue('--v-input-padding-top')) + parseFloat(style.getPropertyValue('--v-field-padding-bottom'));
                const height = sizerRef.value.scrollHeight;
                const lineHeight = parseFloat(style.lineHeight);
                const minHeight = Math.max(parseFloat(props.rows) * lineHeight + padding, parseFloat(fieldStyle.getPropertyValue('--v-input-control-height')));
                const maxHeight = props.maxHeight ? parseFloat(props.maxHeight) : parseFloat(props.maxRows) * lineHeight + padding || Infinity;
                const newHeight = (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(height ?? 0, minHeight, maxHeight);
                rows.value = Math.floor((newHeight - padding) / lineHeight);
                controlHeight.value = (0, $8590040a7833369a$export$286ad215293a0860)(newHeight);
            });
        }
        (0, $TusQn.onMounted)(calculateInputHeight);
        (0, $01W3b.watch)(model, calculateInputHeight);
        (0, $01W3b.watch)(()=>props.rows, calculateInputHeight);
        (0, $01W3b.watch)(()=>props.maxHeight, calculateInputHeight);
        (0, $01W3b.watch)(()=>props.maxRows, calculateInputHeight);
        (0, $01W3b.watch)(()=>props.density, calculateInputHeight);
        (0, $01W3b.watch)(rows, (val)=>{
            emit('update:rows', val);
        });
        let observer;
        (0, $01W3b.watch)(sizerRef, (val)=>{
            if (val) {
                observer = new ResizeObserver(calculateInputHeight);
                observer.observe(sizerRef.value);
            } else observer?.disconnect();
        });
        (0, $TusQn.onBeforeUnmount)(()=>{
            observer?.disconnect();
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const hasCounter = !!(slots.counter || props.counter || props.counterValue);
            const hasDetails = !!(hasCounter || slots.details);
            const [rootAttrs, inputAttrs] = (0, $8590040a7833369a$export$c46dde8a23cbfcf2)(attrs);
            const { modelValue: _, ...inputProps } = (0, $97e8c489e405a584$export$2aca538d9f87f6ac).filterProps(props);
            const fieldProps = {
                ...(0, $d4f131cf7ef9c4a9$export$3180fb4997e9f72d).filterProps(props),
                'onClick:clear': onClear
            };
            return (0, $TusQn.createVNode)((0, $97e8c489e405a584$export$2aca538d9f87f6ac), (0, $TusQn.mergeProps)({
                "ref": vInputRef,
                "modelValue": model.value,
                "onUpdate:modelValue": ($event)=>model.value = $event,
                "class": [
                    'v-textarea v-text-field',
                    {
                        'v-textarea--prefixed': props.prefix,
                        'v-textarea--suffixed': props.suffix,
                        'v-text-field--prefixed': props.prefix,
                        'v-text-field--suffixed': props.suffix,
                        'v-textarea--auto-grow': props.autoGrow,
                        'v-textarea--no-resize': props.noResize || props.autoGrow,
                        'v-input--plain-underlined': isPlainOrUnderlined.value
                    },
                    props.class
                ],
                "style": [
                    {
                        '--v-textarea-max-height': props.maxHeight ? (0, $8590040a7833369a$export$286ad215293a0860)(props.maxHeight) : undefined,
                        '--v-textarea-scroll-bar-width': (0, $8590040a7833369a$export$286ad215293a0860)(scrollbarWidth.value)
                    },
                    props.style
                ]
            }, rootAttrs, inputProps, {
                "centerAffix": rows.value === 1 && !isPlainOrUnderlined.value,
                "focused": isFocused.value
            }), {
                ...slots,
                default: (_ref2)=>{
                    let { id: id, isDisabled: isDisabled, isDirty: isDirty, isReadonly: isReadonly, isValid: isValid, hasDetails: hasDetails } = _ref2;
                    return (0, $TusQn.createVNode)((0, $d4f131cf7ef9c4a9$export$3180fb4997e9f72d), (0, $TusQn.mergeProps)({
                        "ref": vFieldRef,
                        "style": {
                            '--v-textarea-control-height': controlHeight.value
                        },
                        "onClick": onControlClick,
                        "onMousedown": onControlMousedown,
                        "onClick:prependInner": props['onClick:prependInner'],
                        "onClick:appendInner": props['onClick:appendInner']
                    }, fieldProps, {
                        "id": id.value,
                        "active": isActive.value || isDirty.value,
                        "labelId": `${id.value}-label`,
                        "centerAffix": rows.value === 1 && !isPlainOrUnderlined.value,
                        "dirty": isDirty.value || props.dirty,
                        "disabled": isDisabled.value,
                        "focused": isFocused.value,
                        "details": hasDetails.value,
                        "error": isValid.value === false
                    }), {
                        ...slots,
                        default: (_ref3)=>{
                            let { props: { class: fieldClass, ...slotProps }, controlRef: controlRef } = _ref3;
                            return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                props.prefix && (0, $TusQn.createElementVNode)("span", {
                                    "class": "v-text-field__prefix"
                                }, [
                                    props.prefix
                                ]),
                                (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", (0, $TusQn.mergeProps)({
                                    "ref": (val)=>textareaRef.value = controlRef.value = val,
                                    "class": fieldClass,
                                    "value": model.value,
                                    "onInput": onInput,
                                    "autofocus": props.autofocus,
                                    "readonly": isReadonly.value,
                                    "disabled": isDisabled.value,
                                    "placeholder": props.placeholder,
                                    "rows": props.rows,
                                    "name": autocomplete.fieldName.value,
                                    "autocomplete": autocomplete.fieldAutocomplete.value,
                                    "onFocus": onFocus,
                                    "onBlur": blur,
                                    "aria-labelledby": `${id.value}-label`
                                }, slotProps, inputAttrs), null), [
                                    [
                                        (0, $8d31333abb7bf4e7$export$2e2bcd8739ae039),
                                        {
                                            handler: onIntersect
                                        },
                                        null,
                                        {
                                            once: true
                                        }
                                    ]
                                ]),
                                props.autoGrow && (0, $TusQn.withDirectives)((0, $TusQn.createElementVNode)("textarea", {
                                    "class": (0, $8POXm.normalizeClass)([
                                        fieldClass,
                                        'v-textarea__sizer'
                                    ]),
                                    "id": `${slotProps.id}-sizer`,
                                    "onUpdate:modelValue": ($event)=>model.value = $event,
                                    "ref": sizerRef,
                                    "readonly": true,
                                    "aria-hidden": "true"
                                }, null), [
                                    [
                                        (0, $eeJ70.vModelText),
                                        model.value
                                    ]
                                ]),
                                props.suffix && (0, $TusQn.createElementVNode)("span", {
                                    "class": "v-text-field__suffix"
                                }, [
                                    props.suffix
                                ])
                            ]);
                        }
                    });
                },
                details: hasDetails ? (slotProps)=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        slots.details?.(slotProps),
                        hasCounter && (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                            (0, $TusQn.createElementVNode)("span", null, null),
                            (0, $TusQn.createVNode)((0, $b240aced8b361832$export$45efeae449ff2094), {
                                "active": props.persistentCounter || isFocused.value,
                                "value": counterValue.value,
                                "max": max.value,
                                "disabled": props.disabled
                            }, slots.counter)
                        ])
                    ]) : undefined
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, vInputRef, vFieldRef, textareaRef);
    }
});




var $364d61fce728b12c$exports = {};

$parcel$export($364d61fce728b12c$exports, "VTextField", () => $1df180b07e489866$export$d591c92dea965c28);



var $151921a7bcc114ce$exports = {};

$parcel$export($151921a7bcc114ce$exports, "VThemeProvider", () => $68347c432a6b9c2f$export$dc0f7eaa56e7be3e);
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");





const $68347c432a6b9c2f$export$a2d976d5fd234984 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    withBackground: Boolean,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VThemeProvider');
const $68347c432a6b9c2f$export$dc0f7eaa56e7be3e = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VThemeProvider',
    props: $68347c432a6b9c2f$export$a2d976d5fd234984(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        return ()=>{
            if (!props.withBackground) return slots.default?.();
            return (0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-theme-provider',
                    themeClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, {
                default: ()=>[
                        slots.default?.()
                    ]
            });
        };
    }
});




var $fe2aa3f616bac17d$exports = {};

$parcel$export($fe2aa3f616bac17d$exports, "VTimeline", () => $3368faff42a9f2c9$export$8ba89235f21b4a00);
$parcel$export($fe2aa3f616bac17d$exports, "VTimelineItem", () => $f2ee8f59bd48564e$export$dad0709e56abc8b2);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");








parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");









const $0becb3245bf9d992$export$30ea0189fb602543 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    dotColor: String,
    fillDot: Boolean,
    hideDot: Boolean,
    icon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    iconColor: String,
    lineColor: String,
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)()
}, 'VTimelineDivider');
const $0becb3245bf9d992$export$efdada82bea82bd = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTimelineDivider',
    props: $0becb3245bf9d992$export$30ea0189fb602543(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { sizeClasses: sizeClasses, sizeStyles: sizeStyles } = (0, $b9afb2891b9aa639$export$1ab7ae714698c4b8)(props, 'v-timeline-divider__dot');
        const { backgroundColorStyles: backgroundColorStyles, backgroundColorClasses: backgroundColorClasses } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.dotColor);
        const { roundedClasses: roundedClasses } = (0, $64be4fce992a7084$export$36c3a2ea94409e5e)(props, 'v-timeline-divider__dot');
        const { elevationClasses: elevationClasses } = (0, $b79619148bc437a4$export$617be03f9f20f78c)(props);
        const { backgroundColorClasses: lineColorClasses, backgroundColorStyles: lineColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.lineColor);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-timeline-divider',
                    {
                        'v-timeline-divider--fill-dot': props.fillDot
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-timeline-divider__before',
                        lineColorClasses.value
                    ]),
                    "style": (0, $8POXm.normalizeStyle)(lineColorStyles.value)
                }, null),
                !props.hideDot && (0, $TusQn.createElementVNode)("div", {
                    "key": "dot",
                    "class": (0, $8POXm.normalizeClass)([
                        'v-timeline-divider__dot',
                        elevationClasses.value,
                        roundedClasses.value,
                        sizeClasses.value
                    ]),
                    "style": (0, $8POXm.normalizeStyle)(sizeStyles.value)
                }, [
                    (0, $TusQn.createElementVNode)("div", {
                        "class": (0, $8POXm.normalizeClass)([
                            'v-timeline-divider__inner-dot',
                            backgroundColorClasses.value,
                            roundedClasses.value
                        ]),
                        "style": (0, $8POXm.normalizeStyle)(backgroundColorStyles.value)
                    }, [
                        !slots.default ? (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                            "key": "icon",
                            "color": props.iconColor,
                            "icon": props.icon,
                            "size": props.size
                        }, null) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "key": "icon-defaults",
                            "disabled": !props.icon,
                            "defaults": {
                                VIcon: {
                                    color: props.iconColor,
                                    icon: props.icon,
                                    size: props.size
                                }
                            }
                        }, slots.default)
                    ])
                ]),
                (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)([
                        'v-timeline-divider__after',
                        lineColorClasses.value
                    ]),
                    "style": (0, $8POXm.normalizeStyle)(lineColorStyles.value)
                }, null)
            ]));
        return {};
    }
});










const $f2ee8f59bd48564e$export$ead07d56a29717a5 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    density: String,
    dotColor: String,
    fillDot: Boolean,
    hideDot: Boolean,
    hideOpposite: {
        type: Boolean,
        default: undefined
    },
    icon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    iconColor: String,
    lineInset: [
        Number,
        String
    ],
    side: {
        type: String,
        validator: (v)=>v == null || [
                'start',
                'end'
            ].includes(v)
    },
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $159635b8c4ce014b$export$f37f46640cc8dd75)(),
    ...(0, $b79619148bc437a4$export$858059d20a48304b)(),
    ...(0, $64be4fce992a7084$export$7bbc36c81a352d50)(),
    ...(0, $b9afb2891b9aa639$export$c7a32fb00df3ff20)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)()
}, 'VTimelineItem');
const $f2ee8f59bd48564e$export$dad0709e56abc8b2 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTimelineItem',
    props: $f2ee8f59bd48564e$export$ead07d56a29717a5(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { dimensionStyles: dimensionStyles } = (0, $159635b8c4ce014b$export$2b21de4fc4968be5)(props);
        const dotSize = (0, $01W3b.shallowRef)(0);
        const dotRef = (0, $01W3b.ref)();
        (0, $01W3b.watch)(dotRef, (newValue)=>{
            if (!newValue) return;
            dotSize.value = newValue.$el.querySelector('.v-timeline-divider__dot')?.getBoundingClientRect().width ?? 0;
        }, {
            flush: 'post'
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-timeline-item',
                    {
                        'v-timeline-item--fill-dot': props.fillDot,
                        'v-timeline-item--side-start': props.side === 'start',
                        'v-timeline-item--side-end': props.side === 'end'
                    },
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-timeline-dot-size': (0, $8590040a7833369a$export$286ad215293a0860)(dotSize.value),
                        '--v-timeline-line-inset': props.lineInset ? `calc(var(--v-timeline-dot-size) / 2 + ${(0, $8590040a7833369a$export$286ad215293a0860)(props.lineInset)})` : (0, $8590040a7833369a$export$286ad215293a0860)(0)
                    },
                    props.style
                ])
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-timeline-item__body",
                    "style": (0, $8POXm.normalizeStyle)(dimensionStyles.value)
                }, [
                    slots.default?.()
                ]),
                (0, $TusQn.createVNode)((0, $0becb3245bf9d992$export$efdada82bea82bd), {
                    "ref": dotRef,
                    "hideDot": props.hideDot,
                    "icon": props.icon,
                    "iconColor": props.iconColor,
                    "size": props.size,
                    "elevation": props.elevation,
                    "dotColor": props.dotColor,
                    "fillDot": props.fillDot,
                    "rounded": props.rounded
                }, {
                    default: slots.icon
                }),
                props.density !== 'compact' && (0, $TusQn.createElementVNode)("div", {
                    "class": "v-timeline-item__opposite"
                }, [
                    !props.hideOpposite && slots.opposite?.()
                ])
            ]));
        return {};
    }
});


const $3368faff42a9f2c9$export$4b8690f62a5e29fc = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    align: {
        type: String,
        default: 'center',
        validator: (v)=>[
                'center',
                'start'
            ].includes(v)
    },
    direction: {
        type: String,
        default: 'vertical',
        validator: (v)=>[
                'vertical',
                'horizontal'
            ].includes(v)
    },
    justify: {
        type: String,
        default: 'auto',
        validator: (v)=>[
                'auto',
                'center'
            ].includes(v)
    },
    side: {
        type: String,
        validator: (v)=>v == null || [
                'start',
                'end'
            ].includes(v)
    },
    lineThickness: {
        type: [
            String,
            Number
        ],
        default: 2
    },
    lineColor: String,
    truncateLine: {
        type: String,
        validator: (v)=>[
                'start',
                'end',
                'both'
            ].includes(v)
    },
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $f2ee8f59bd48564e$export$ead07d56a29717a5)({
        lineInset: 0
    }), [
        'dotColor',
        'fillDot',
        'hideOpposite',
        'iconColor',
        'lineInset',
        'size'
    ]),
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)(),
    ...(0, $7339ea6cd3ccffba$export$1e45edda911c93db)(),
    ...(0, $cd59fdf0d9176afa$export$d0fc5ddd543b4149)()
}, 'VTimeline');
const $3368faff42a9f2c9$export$8ba89235f21b4a00 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTimeline',
    props: $3368faff42a9f2c9$export$4b8690f62a5e29fc(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const { themeClasses: themeClasses } = (0, $cd59fdf0d9176afa$export$307b27329074e447)(props);
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const { rtlClasses: rtlClasses } = (0, $13e23564052bdddd$export$b2dd014b6c321cb)();
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VTimelineDivider: {
                lineColor: (0, $01W3b.toRef)(()=>props.lineColor)
            },
            VTimelineItem: {
                density: (0, $01W3b.toRef)(()=>props.density),
                dotColor: (0, $01W3b.toRef)(()=>props.dotColor),
                fillDot: (0, $01W3b.toRef)(()=>props.fillDot),
                hideOpposite: (0, $01W3b.toRef)(()=>props.hideOpposite),
                iconColor: (0, $01W3b.toRef)(()=>props.iconColor),
                lineColor: (0, $01W3b.toRef)(()=>props.lineColor),
                lineInset: (0, $01W3b.toRef)(()=>props.lineInset),
                size: (0, $01W3b.toRef)(()=>props.size)
            }
        });
        const sideClasses = (0, $01W3b.computed)(()=>{
            const side = props.side ? props.side : props.density !== 'default' ? 'end' : null;
            return side && `v-timeline--side-${side}`;
        });
        const truncateClasses = (0, $01W3b.computed)(()=>{
            const classes = [
                'v-timeline--truncate-line-start',
                'v-timeline--truncate-line-end'
            ];
            switch(props.truncateLine){
                case 'both':
                    return classes;
                case 'start':
                    return classes[0];
                case 'end':
                    return classes[1];
                default:
                    return null;
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createVNode)(props.tag, {
                "class": (0, $8POXm.normalizeClass)([
                    'v-timeline',
                    `v-timeline--${props.direction}`,
                    `v-timeline--align-${props.align}`,
                    `v-timeline--justify-${props.justify}`,
                    truncateClasses.value,
                    {
                        'v-timeline--inset-line': !!props.lineInset
                    },
                    themeClasses.value,
                    densityClasses.value,
                    sideClasses.value,
                    rtlClasses.value,
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)([
                    {
                        '--v-timeline-line-thickness': (0, $8590040a7833369a$export$286ad215293a0860)(props.lineThickness)
                    },
                    props.style
                ])
            }, slots));
        return {};
    }
});





var $3be62df099d5442a$exports = {};

$parcel$export($3be62df099d5442a$exports, "VTimePicker", () => $b7fd86d644356012$export$71890c8f1f4c0e46);
$parcel$export($3be62df099d5442a$exports, "VTimePickerClock", () => $f9b8b68b8e0b4aa4$export$c447be6017502228);
$parcel$export($3be62df099d5442a$exports, "VTimePickerControls", () => $c092584fceb7bae6$export$bc5bd0b10348afb9);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");

parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");



const $f9b8b68b8e0b4aa4$export$61f3751d6bc7b864 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    allowedValues: Function,
    ampm: Boolean,
    color: String,
    disabled: Boolean,
    displayedValue: null,
    double: Boolean,
    format: {
        type: Function,
        default: (val)=>val
    },
    max: {
        type: Number,
        required: true
    },
    min: {
        type: Number,
        required: true
    },
    scrollable: Boolean,
    readonly: Boolean,
    rotate: {
        type: Number,
        default: 0
    },
    step: {
        type: Number,
        default: 1
    },
    modelValue: {
        type: Number
    }
}, 'VTimePickerClock');
const $f9b8b68b8e0b4aa4$export$c447be6017502228 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTimePickerClock',
    props: $f9b8b68b8e0b4aa4$export$61f3751d6bc7b864(),
    emits: {
        change: (val)=>true,
        input: (val)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const clockRef = (0, $01W3b.ref)(null);
        const innerClockRef = (0, $01W3b.ref)(null);
        const inputValue = (0, $01W3b.ref)(undefined);
        const isDragging = (0, $01W3b.ref)(false);
        const valueOnMouseDown = (0, $01W3b.ref)(null);
        const valueOnMouseUp = (0, $01W3b.ref)(null);
        const emitChangeDebounced = (0, $8590040a7833369a$export$61fc7d43ac8f84b0)((value)=>emit('change', value), 750);
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.color);
        const { backgroundColorClasses: backgroundColorClasses, backgroundColorStyles: backgroundColorStyles } = (0, $3cd60c4ecc68ec90$export$de4733d8105ed3f2)(()=>props.color);
        const count = (0, $01W3b.computed)(()=>props.max - props.min + 1);
        const roundCount = (0, $01W3b.computed)(()=>props.double ? count.value / 2 : count.value);
        const degreesPerUnit = (0, $01W3b.computed)(()=>360 / roundCount.value);
        const degrees = (0, $01W3b.computed)(()=>degreesPerUnit.value * Math.PI / 180);
        const displayedValue = (0, $01W3b.computed)(()=>props.modelValue == null ? props.min : props.modelValue);
        const innerRadiusScale = (0, $01W3b.computed)(()=>0.62);
        const genChildren = (0, $01W3b.computed)(()=>{
            const children = [];
            for(let value = props.min; value <= props.max; value = value + props.step)children.push(value);
            return children;
        });
        (0, $01W3b.watch)(()=>props.modelValue, (val)=>{
            inputValue.value = val;
        });
        function update(value) {
            if (inputValue.value !== value) inputValue.value = value;
            emit('input', value);
        }
        function isAllowed(value) {
            return !props.allowedValues || props.allowedValues(value);
        }
        function wheel(e) {
            if (!props.scrollable || props.disabled) return;
            e.preventDefault();
            const delta = Math.sign(-e.deltaY || 1);
            let value = displayedValue.value;
            do {
                value = value + delta;
                value = (value - props.min + count.value) % count.value + props.min;
            }while (!isAllowed(value) && value !== displayedValue.value);
            if (value !== props.displayedValue) update(value);
            emitChangeDebounced(value);
        }
        function isInner(value) {
            return props.double && value - props.min >= roundCount.value;
        }
        function handScale(value) {
            return isInner(value) ? innerRadiusScale.value : 1;
        }
        function getPosition(value) {
            const rotateRadians = props.rotate * Math.PI / 180;
            return {
                x: Math.sin((value - props.min) * degrees.value + rotateRadians) * handScale(value),
                y: -Math.cos((value - props.min) * degrees.value + rotateRadians) * handScale(value)
            };
        }
        function angleToValue(angle, insideClick) {
            const value = (Math.round(angle / degreesPerUnit.value) + (insideClick ? roundCount.value : 0)) % count.value + props.min;
            // Necessary to fix edge case when selecting left part of the value(s) at 12 o'clock
            if (angle < 360 - degreesPerUnit.value / 2) return value;
            return insideClick ? props.max - roundCount.value + 1 : props.min;
        }
        function getTransform(i) {
            const { x: x, y: y } = getPosition(i);
            return {
                left: `${Math.round(50 + x * 50)}%`,
                top: `${Math.round(50 + y * 50)}%`
            };
        }
        function euclidean(p0, p1) {
            const dx = p1.x - p0.x;
            const dy = p1.y - p0.y;
            return Math.sqrt(dx * dx + dy * dy);
        }
        function angle(center, p1) {
            const value = 2 * Math.atan2(p1.y - center.y - euclidean(center, p1), p1.x - center.x);
            return Math.abs(value * 180 / Math.PI);
        }
        function setMouseDownValue(value) {
            if (valueOnMouseDown.value === null) valueOnMouseDown.value = value;
            valueOnMouseUp.value = value;
            update(value);
        }
        function onDragMove(e) {
            e.preventDefault();
            if (!isDragging.value && e.type !== 'click' || !clockRef.value) return;
            const { width: width, top: top, left: left } = clockRef.value?.getBoundingClientRect();
            const { width: innerWidth } = innerClockRef.value?.getBoundingClientRect() ?? {
                width: 0
            };
            const { clientX: clientX, clientY: clientY } = 'touches' in e ? e.touches[0] : e;
            const center = {
                x: width / 2,
                y: -width / 2
            };
            const coords = {
                x: clientX - left,
                y: top - clientY
            };
            const handAngle = Math.round(angle(center, coords) - props.rotate + 360) % 360;
            const insideClick = props.double && euclidean(center, coords) < (innerWidth + innerWidth * innerRadiusScale.value) / 4;
            const checksCount = Math.ceil(15 / degreesPerUnit.value);
            let value;
            for(let i = 0; i < checksCount; i++){
                value = angleToValue(handAngle + i * degreesPerUnit.value, insideClick);
                if (isAllowed(value)) return setMouseDownValue(value);
                value = angleToValue(handAngle - i * degreesPerUnit.value, insideClick);
                if (isAllowed(value)) return setMouseDownValue(value);
            }
        }
        function onMouseDown(e) {
            if (props.disabled) return;
            e.preventDefault();
            window.addEventListener('mousemove', onDragMove);
            window.addEventListener('touchmove', onDragMove);
            window.addEventListener('mouseup', onMouseUp);
            window.addEventListener('touchend', onMouseUp);
            valueOnMouseDown.value = null;
            valueOnMouseUp.value = null;
            isDragging.value = true;
            onDragMove(e);
        }
        function onMouseUp(e) {
            e.stopPropagation();
            removeListeners();
            isDragging.value = false;
            if (valueOnMouseUp.value !== null && isAllowed(valueOnMouseUp.value)) emit('change', valueOnMouseUp.value);
        }
        function removeListeners() {
            window.removeEventListener('mousemove', onDragMove);
            window.removeEventListener('touchmove', onDragMove);
            window.removeEventListener('mouseup', onMouseUp);
            window.removeEventListener('touchend', onMouseUp);
        }
        (0, $01W3b.onScopeDispose)(removeListeners);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return (0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    {
                        'v-time-picker-clock': true,
                        'v-time-picker-clock--indeterminate': props.modelValue == null,
                        'v-time-picker-clock--readonly': props.readonly
                    }
                ]),
                "onMousedown": onMouseDown,
                "onTouchstart": onMouseDown,
                "onWheel": wheel,
                "ref": clockRef
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": "v-time-picker-clock__inner",
                    "ref": innerClockRef
                }, [
                    (0, $TusQn.createElementVNode)("div", {
                        "class": (0, $8POXm.normalizeClass)([
                            {
                                'v-time-picker-clock__hand': true,
                                'v-time-picker-clock__hand--inner': isInner(props.modelValue)
                            },
                            textColorClasses.value
                        ]),
                        "style": (0, $8POXm.normalizeStyle)([
                            {
                                transform: `rotate(${props.rotate + degreesPerUnit.value * (displayedValue.value - props.min)}deg) scaleY(${handScale(displayedValue.value)})`
                            },
                            textColorStyles.value
                        ])
                    }, null),
                    genChildren.value.map((value)=>{
                        const isActive = value === displayedValue.value;
                        return (0, $TusQn.createElementVNode)("div", {
                            "class": (0, $8POXm.normalizeClass)([
                                {
                                    'v-time-picker-clock__item': true,
                                    'v-time-picker-clock__item--active': isActive,
                                    'v-time-picker-clock__item--disabled': props.disabled || !isAllowed(value)
                                },
                                isActive && backgroundColorClasses.value
                            ]),
                            "style": (0, $8POXm.normalizeStyle)([
                                getTransform(value),
                                isActive && backgroundColorStyles.value
                            ])
                        }, [
                            (0, $TusQn.createElementVNode)("span", null, [
                                props.format(value)
                            ])
                        ]);
                    })
                ])
            ]);
        });
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");

parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");




const $c2555a2c4422a86d$export$da0c36d050cf3f71 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    active: Boolean,
    color: String,
    disabled: Boolean,
    label: String,
    modelValue: String,
    error: String,
    showHint: Boolean,
    readonly: Boolean
}, 'VTimePickerField');
const $c2555a2c4422a86d$export$41e758f6fe46c15 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTimePickerField',
    props: $c2555a2c4422a86d$export$da0c36d050cf3f71(),
    emits: {
        'update:modelValue': (v)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const { textColorClasses: textColorClasses, textColorStyles: textColorStyles } = (0, $3cd60c4ecc68ec90$export$2eb7f8f6c72160ec)(()=>props.color);
        const vTextInputRef = (0, $01W3b.ref)();
        const isFocused = (0, $01W3b.shallowRef)(false);
        function onKeydown(e) {
            if ([
                'Backspace',
                'Delete'
            ].includes(e.key)) {
                e.preventDefault();
                const target = e.target;
                target.value = '';
                emit('update:modelValue', null);
            }
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return (0, $TusQn.createVNode)((0, $1df180b07e489866$export$d591c92dea965c28), {
                "ref": vTextInputRef,
                "_as": "VTimePickerField",
                "autocomplete": "off",
                "class": (0, $8POXm.normalizeClass)([
                    'v-time-picker-controls__time__field',
                    {
                        'v-time-picker-controls__time__field--active': props.active
                    },
                    props.active ? textColorClasses.value : []
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.active ? textColorStyles.value : []),
                "disabled": props.disabled,
                "variant": "solo-filled",
                "inputmode": "numeric",
                "hideDetails": "auto",
                "aria-label": props.label,
                "aria-invalid": !!props.error,
                "aria-errormessage": props.error,
                "error": !!props.error,
                "hint": props.showHint ? props.label : undefined,
                "persistentHint": true,
                "flat": true,
                "modelValue": props.modelValue ?? (isFocused.value ? '' : '--'),
                "onUpdate:modelValue": (v)=>emit('update:modelValue', v),
                "onKeydown": onKeydown,
                "onFocus": ()=>isFocused.value = true,
                "onBlur": ()=>isFocused.value = false
            }, null);
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, vTextInputRef);
    }
});





// Utilities
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
// Types
function $b9d904146ba009a4$export$5d04458e2a6c373e(n) {
    let length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    return String(n).padStart(length, '0');
}
function $b9d904146ba009a4$export$8041c02ebe2956d0(hour) {
    return hour ? (hour - 1) % 12 + 1 : 12;
}
function $b9d904146ba009a4$export$e40e59a57ec762e4(hour, period) {
    return hour % 12 + (period === 'pm' ? 12 : 0);
}
function $b9d904146ba009a4$export$143e88be9a3b95f1(v) {
    const digits = v.replaceAll(/\D/g, '');
    return digits.length > 0 ? Number(digits) : null;
}
function $b9d904146ba009a4$export$8ceb3bd5e4adfeeb(hour, increment, period) {
    if (period) {
        if (hour === 12 && increment) return {
            value: 1
        };
        if (hour === 11 && increment) return {
            value: 12,
            togglePeriod: true
        };
        if (hour === 12 && !increment) return {
            value: 11,
            togglePeriod: true
        };
        if (hour === 1 && !increment) return {
            value: 12
        };
    } else {
        if (hour === 23 && increment) return {
            value: 0
        };
        if (hour === 0 && !increment) return {
            value: 23
        };
    }
    return {
        value: hour + (increment ? 1 : -1)
    };
}
function $b9d904146ba009a4$export$7717ae9a65318f78(val, increment) {
    if (val === 59 && increment) return 0;
    if (val === 0 && !increment) return 59;
    return val + (increment ? 1 : -1);
}



const $cbcc49751d5d592e$export$8b0bcc8914a216a1 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    allowedHours: [
        Function,
        Array
    ],
    allowedMinutes: [
        Function,
        Array
    ],
    allowedSeconds: [
        Function,
        Array
    ],
    max: String,
    min: String
}, 'time-validation');
function $cbcc49751d5d592e$export$6913080731fabed9(props) {
    const isAllowedHour = (0, $01W3b.computed)(()=>{
        const minHour = props.min ? Number(props.min.split(':')[0]) : 0;
        const maxHour = props.max ? Number(props.max.split(':')[0]) : 23;
        return (val)=>{
            if (val < minHour) return false;
            if (val > maxHour) return false;
            if (Array.isArray(props.allowedHours)) return props.allowedHours.includes(val);
            if (typeof props.allowedHours === 'function') return props.allowedHours(val);
            return true;
        };
    });
    const isAllowedMinute = (0, $01W3b.computed)(()=>{
        const [minHour, minMinute] = props.min ? props.min.split(':').map(Number) : [
            0,
            0
        ];
        const [maxHour, maxMinute] = props.max ? props.max.split(':').map(Number) : [
            23,
            59
        ];
        const minTime = minHour * 60 + minMinute;
        const maxTime = maxHour * 60 + maxMinute;
        return (hour24hr, val)=>{
            if (hour24hr !== null) {
                const time = 60 * hour24hr + val;
                if (time < minTime) return false;
                if (time > maxTime) return false;
            }
            if (Array.isArray(props.allowedMinutes)) return props.allowedMinutes.includes(val);
            if (typeof props.allowedMinutes === 'function') return props.allowedMinutes(val);
            return true;
        };
    });
    const isAllowedSecond = (0, $01W3b.computed)(()=>{
        const [minHour, minMinute, minSecond] = props.min ? props.min.split(':').map(Number) : [
            0,
            0,
            0
        ];
        const [maxHour, maxMinute, maxSecond] = props.max ? props.max.split(':').map(Number) : [
            23,
            59,
            59
        ];
        const minTime = minHour * 3600 + minMinute * 60 + (minSecond || 0);
        const maxTime = maxHour * 3600 + maxMinute * 60 + (maxSecond || 0);
        return (hour24hr, minute, val)=>{
            if (hour24hr !== null && minute !== null) {
                const time = 3600 * hour24hr + 60 * minute + val;
                if (time < minTime) return false;
                if (time > maxTime) return false;
            }
            if (Array.isArray(props.allowedSeconds)) return props.allowedSeconds.includes(val);
            if (typeof props.allowedSeconds === 'function') return props.allowedSeconds(val);
            return true;
        };
    });
    function findNextAllowed(type, value, increment) {
        let currentHour = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        let currentMinute = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
        const isAllowed = type === 'hour' ? isAllowedHour.value : type === 'minute' ? (v)=>isAllowedMinute.value(currentHour, v) : (v)=>isAllowedSecond.value(currentHour, currentMinute, v);
        const nextValue = type === 'hour' ? (v)=>(0, $b9d904146ba009a4$export$8ceb3bd5e4adfeeb)(v, increment, null).value : (v)=>(0, $b9d904146ba009a4$export$7717ae9a65318f78)(v, increment);
        const limit = type === 'hour' ? 24 : 60;
        for(let i = 1; i <= limit; i++){
            value = nextValue(value);
            if (isAllowed(value)) break;
        }
        return value;
    }
    return {
        isAllowedHour: isAllowedHour,
        isAllowedMinute: isAllowedMinute,
        isAllowedSecond: isAllowedSecond,
        findNextAllowed: findNextAllowed
    };
}




const $c092584fceb7bae6$export$97d9b52d5b38b271 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ampm: Boolean,
    color: String,
    disabled: Boolean,
    inputHints: Boolean,
    hour: [
        Number,
        String
    ],
    minute: [
        Number,
        String
    ],
    second: [
        Number,
        String
    ],
    period: String,
    readonly: Boolean,
    useSeconds: Boolean,
    value: Number,
    viewMode: String,
    ...(0, $cbcc49751d5d592e$export$8b0bcc8914a216a1)()
}, 'VTimePickerControls');
const $c092584fceb7bae6$export$bc5bd0b10348afb9 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTimePickerControls',
    props: $c092584fceb7bae6$export$97d9b52d5b38b271(),
    emits: {
        'update:period': (data)=>true,
        'update:viewMode': (data)=>true,
        'update:hour': (v)=>true,
        'update:minute': (v)=>true,
        'update:second': (v)=>true
    },
    setup (props, _ref) {
        let { emit: emit } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { isAllowedHour: isAllowedHour, isAllowedMinute: isAllowedMinute, isAllowedSecond: isAllowedSecond, findNextAllowed: findNextAllowed } = (0, $cbcc49751d5d592e$export$6913080731fabed9)(props);
        const currentHour = (0, $01W3b.computed)(()=>props.hour !== null ? props.ampm ? (0, $b9d904146ba009a4$export$e40e59a57ec762e4)(Number(props.hour), props.period ?? 'am') : Number(props.hour) : null);
        const currentMinute = (0, $01W3b.computed)(()=>props.minute !== null ? Number(props.minute) : null);
        const isHourValid = (0, $01W3b.computed)(()=>{
            if (props.hour === null) return true;
            return isAllowedHour.value?.(Number(currentHour.value)) ?? true;
        });
        const isMinuteValid = (0, $01W3b.computed)(()=>{
            if (props.minute === null) return true;
            return isAllowedMinute.value?.(currentHour.value, Number(props.minute)) ?? true;
        });
        const isSecondValid = (0, $01W3b.computed)(()=>{
            if (props.second === null) return true;
            return isAllowedSecond.value?.(currentHour.value, currentMinute.value, Number(props.second)) ?? true;
        });
        const transformHours = {
            in: (v)=>{
                if (v == null || isNaN(Number(v))) return null;
                const val = Number(v);
                return props.ampm ? (0, $b9d904146ba009a4$export$5d04458e2a6c373e)((0, $b9d904146ba009a4$export$8041c02ebe2956d0)(val)) : (0, $b9d904146ba009a4$export$5d04458e2a6c373e)(val);
            },
            out: (v)=>{
                if (isNaN(Number(v)) || v == null || v === '') return null;
                const val = typeof v === 'string' ? (0, $b9d904146ba009a4$export$143e88be9a3b95f1)(v) : Number(v);
                if (val === null) return null;
                return props.ampm ? (0, $b9d904146ba009a4$export$e40e59a57ec762e4)(val, props.period ?? 'am') : (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(val, 0, 23);
            }
        };
        const hour = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'hour', undefined, transformHours.in, transformHours.out);
        const transformMinutesOrSeconds = {
            in: (v)=>v != null && !isNaN(Number(v)) ? (0, $b9d904146ba009a4$export$5d04458e2a6c373e)(`${v}`) : null,
            out: (v)=>{
                if (isNaN(Number(v)) || v == null || v === '') return null;
                const val = typeof v === 'string' ? (0, $b9d904146ba009a4$export$143e88be9a3b95f1)(v) : Number(v);
                return val !== null ? (0, $8590040a7833369a$export$7d15b64cf5a3a4c4)(val, 0, 59) : null;
            }
        };
        const minute = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'minute', undefined, transformMinutesOrSeconds.in, transformMinutesOrSeconds.out);
        const second = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'second', undefined, transformMinutesOrSeconds.in, transformMinutesOrSeconds.out);
        function onHourFieldKeydown(e) {
            if (![
                'ArrowUp',
                'ArrowDown'
            ].includes(e.key)) return;
            e.preventDefault();
            e.stopPropagation();
            const isAm = props.period === 'am';
            const current = props.ampm ? (0, $b9d904146ba009a4$export$e40e59a57ec762e4)(Number(hour.value ?? 0), isAm ? 'am' : 'pm') : Number(hour.value ?? 0);
            const next = findNextAllowed('hour', current, e.key === 'ArrowUp');
            const togglePeriod = isAm && next >= 12 || !isAm && next < 12;
            if (props.ampm && togglePeriod) {
                emit('update:period', props.period === 'am' ? 'pm' : 'am');
                (0, $TusQn.nextTick)(()=>hour.value = (0, $b9d904146ba009a4$export$5d04458e2a6c373e)(next));
            } else hour.value = (0, $b9d904146ba009a4$export$5d04458e2a6c373e)(next);
        }
        function onMinuteFieldKeydown(e) {
            if (![
                'ArrowUp',
                'ArrowDown'
            ].includes(e.key)) return;
            e.preventDefault();
            e.stopPropagation();
            const current = Number(minute.value ?? 0);
            const next = findNextAllowed('minute', current, e.key === 'ArrowUp', currentHour.value);
            minute.value = (0, $b9d904146ba009a4$export$5d04458e2a6c373e)(next);
        }
        function onSecondFieldKeydown(e) {
            if (![
                'ArrowUp',
                'ArrowDown'
            ].includes(e.key)) return;
            e.preventDefault();
            e.stopPropagation();
            const current = Number(second.value ?? 0);
            const next = findNextAllowed('second', current, e.key === 'ArrowUp', currentHour.value, currentMinute.value);
            second.value = (0, $b9d904146ba009a4$export$5d04458e2a6c373e)(next);
        }
        function createInputInterceptor(valueTransformOut, compare, apply) {
            return (e)=>{
                if (!e.data) return;
                const inputElement = e.target;
                const { value: existingTxt, selectionStart: selectionStart, selectionEnd: selectionEnd } = inputElement ?? {};
                if ((0, $b9d904146ba009a4$export$143e88be9a3b95f1)(e.data) === null) {
                    e.preventDefault();
                    return;
                }
                const potentialNewInputVal = existingTxt ? existingTxt.slice(0, selectionStart) + e.data + existingTxt.slice(selectionEnd) : e.data;
                if (potentialNewInputVal.length > 2) {
                    if (selectionStart === selectionEnd && selectionEnd === 0 && e.data.trim().startsWith('0')) {
                        e.preventDefault();
                        inputElement.value = potentialNewInputVal.trim().substring(0, 2);
                        apply(inputElement.value);
                        if (e.data.trim().length === 1) inputElement.setSelectionRange(1, 1);
                        return;
                    }
                    if (selectionStart === selectionEnd && selectionEnd === 1 && existingTxt.startsWith('0')) {
                        e.preventDefault();
                        inputElement.value = potentialNewInputVal.trim().substring(0, 2);
                        apply(inputElement.value);
                        return;
                    }
                    const maxValue = props.viewMode === 'hour' ? props.ampm ? 12 : 23 : 59;
                    const value = (0, $b9d904146ba009a4$export$143e88be9a3b95f1)(potentialNewInputVal);
                    if (value > maxValue) {
                        e.preventDefault();
                        inputElement.value = (0, $b9d904146ba009a4$export$5d04458e2a6c373e)(String((0, $b9d904146ba009a4$export$143e88be9a3b95f1)(e.data)).substring(0, 2));
                        apply(inputElement.value);
                        return;
                    }
                }
                const potentialNewNumber = valueTransformOut(potentialNewInputVal);
                if (compare(potentialNewNumber)) // ignore input when results in the same number
                // prevents typing more digits
                e.preventDefault();
            };
        }
        function setPeriod(val) {
            emit('update:period', val);
            const next = findNextAllowed('hour', val === 'am' ? 23 : 11, true);
            (0, $TusQn.nextTick)(()=>hour.value = (0, $b9d904146ba009a4$export$5d04458e2a6c373e)(next));
        }
        const hourInputRef = (0, $01W3b.ref)();
        const minuteInputRef = (0, $01W3b.ref)();
        const secondInputRef = (0, $01W3b.ref)();
        (0, $01W3b.watch)(()=>props.viewMode, (_, old)=>{
            switch(old){
                case 'hour':
                    hourInputRef.value.blur();
                    break;
                case 'minute':
                    minuteInputRef.value.blur();
                    break;
                case 'second':
                    secondInputRef.value.blur();
                    break;
            }
        });
        const hourInputFilter = createInputInterceptor(transformHours.out, (v)=>transformHours.in(v) === hour.value, (v)=>hour.value = v);
        const minuteInputFilter = createInputInterceptor(transformMinutesOrSeconds.out, (v)=>transformMinutesOrSeconds.in(v) === minute.value, (v)=>minute.value = v);
        const secondInputFilter = createInputInterceptor(transformMinutesOrSeconds.out, (v)=>transformMinutesOrSeconds.in(v) === second.value, (v)=>second.value = v);
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            return (0, $TusQn.createElementVNode)("div", {
                "class": "v-time-picker-controls"
            }, [
                (0, $TusQn.createElementVNode)("div", {
                    "class": (0, $8POXm.normalizeClass)({
                        'v-time-picker-controls__time': true,
                        'v-time-picker-controls__time--with-ampm': props.ampm,
                        'v-time-picker-controls__time--with-seconds': props.useSeconds
                    })
                }, [
                    (0, $TusQn.createVNode)((0, $c2555a2c4422a86d$export$41e758f6fe46c15), {
                        "ref": hourInputRef,
                        "active": props.viewMode === 'hour',
                        "color": props.color,
                        "disabled": props.disabled,
                        "label": t('$vuetify.timePicker.hour'),
                        "showHint": props.inputHints,
                        "error": isHourValid.value ? undefined : t('$vuetify.timePicker.notAllowed'),
                        "modelValue": hour.value,
                        "onUpdate:modelValue": (v)=>hour.value = v,
                        "onKeydown": onHourFieldKeydown,
                        "onBeforeinput": hourInputFilter,
                        "onFocus": ()=>emit('update:viewMode', 'hour')
                    }, null),
                    (0, $TusQn.createElementVNode)("span", {
                        "class": "v-time-picker-controls__time__separator"
                    }, [
                        (0, $TusQn.createTextVNode)(":")
                    ]),
                    (0, $TusQn.createVNode)((0, $c2555a2c4422a86d$export$41e758f6fe46c15), {
                        "ref": minuteInputRef,
                        "active": props.viewMode === 'minute',
                        "color": props.color,
                        "disabled": props.disabled,
                        "label": t('$vuetify.timePicker.minute'),
                        "showHint": props.inputHints,
                        "error": isMinuteValid.value ? undefined : t('$vuetify.timePicker.notAllowed'),
                        "modelValue": minute.value,
                        "onUpdate:modelValue": (v)=>minute.value = v,
                        "onKeydown": onMinuteFieldKeydown,
                        "onBeforeinput": minuteInputFilter,
                        "onFocus": ()=>emit('update:viewMode', 'minute')
                    }, null),
                    props.useSeconds && (0, $TusQn.createElementVNode)("span", {
                        "key": "secondsDivider",
                        "class": "v-time-picker-controls__time__separator"
                    }, [
                        (0, $TusQn.createTextVNode)(":")
                    ]),
                    props.useSeconds && (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createVNode)((0, $c2555a2c4422a86d$export$41e758f6fe46c15), {
                            "key": "secondsVal",
                            "ref": secondInputRef,
                            "active": props.viewMode === 'second',
                            "color": props.color,
                            "disabled": props.disabled,
                            "label": t('$vuetify.timePicker.second'),
                            "showHint": props.inputHints,
                            "error": isSecondValid.value ? undefined : t('$vuetify.timePicker.notAllowed'),
                            "modelValue": second.value,
                            "onUpdate:modelValue": (v)=>second.value = v,
                            "onKeydown": onSecondFieldKeydown,
                            "onBeforeinput": secondInputFilter,
                            "onFocus": ()=>emit('update:viewMode', 'second')
                        }, null)
                    ]),
                    props.ampm && (0, $TusQn.createElementVNode)("div", {
                        "class": "v-time-picker-controls__ampm"
                    }, [
                        (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                            "active": props.period === 'am',
                            "color": props.period === 'am' ? props.color : undefined,
                            "class": (0, $8POXm.normalizeClass)({
                                'v-time-picker-controls__ampm__am': true,
                                'v-time-picker-controls__ampm__btn': true,
                                'v-time-picker-controls__ampm__btn__active': props.period === 'am'
                            }),
                            "disabled": props.disabled,
                            "text": t('$vuetify.timePicker.am'),
                            "variant": props.disabled && props.period === 'am' ? 'elevated' : 'tonal',
                            "onClick": ()=>props.period !== 'am' ? setPeriod('am') : null
                        }, null),
                        (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                            "active": props.period === 'pm',
                            "color": props.period === 'pm' ? props.color : undefined,
                            "class": (0, $8POXm.normalizeClass)({
                                'v-time-picker-controls__ampm__pm': true,
                                'v-time-picker-controls__ampm__btn': true,
                                'v-time-picker-controls__ampm__btn__active': props.period === 'pm'
                            }),
                            "disabled": props.disabled,
                            "text": t('$vuetify.timePicker.pm'),
                            "variant": props.disabled && props.period === 'pm' ? 'elevated' : 'tonal',
                            "onClick": ()=>props.period !== 'pm' ? setPeriod('pm') : null
                        }, null)
                    ])
                ])
            ]);
        });
        return {};
    }
});









const $b7fd86d644356012$export$8af4c77d07a6a5d7 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    disabled: Boolean,
    format: {
        type: String,
        default: 'ampm'
    },
    viewMode: {
        type: String,
        default: 'hour'
    },
    period: {
        type: String,
        default: 'am',
        validator: (v)=>[
                'am',
                'pm'
            ].includes(v)
    },
    modelValue: null,
    readonly: Boolean,
    scrollable: Boolean,
    useSeconds: Boolean,
    variant: {
        type: String,
        default: 'dial'
    },
    ...(0, $cbcc49751d5d592e$export$8b0bcc8914a216a1)(),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $dbc8d169fef91a15$export$78d2911f7e2f59e2)({
        title: '$vuetify.timePicker.title'
    }), [
        'landscape'
    ]),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)()
}, 'VTimePicker');
const $b7fd86d644356012$export$71890c8f1f4c0e46 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTimePicker',
    props: $b7fd86d644356012$export$8af4c77d07a6a5d7(),
    emits: {
        'update:hour': (val)=>true,
        'update:minute': (val)=>true,
        'update:period': (val)=>true,
        'update:second': (val)=>true,
        'update:modelValue': (val)=>true,
        'update:viewMode': (val)=>true
    },
    setup (props, _ref) {
        let { emit: emit, slots: slots } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { densityClasses: densityClasses } = (0, $667123557e1d36ef$export$29e89a97ff256b5f)(props);
        const inputHour = (0, $01W3b.ref)(null);
        const inputMinute = (0, $01W3b.ref)(null);
        const inputSecond = (0, $01W3b.ref)(null);
        const lazyInputHour = (0, $01W3b.ref)(null);
        const lazyInputMinute = (0, $01W3b.ref)(null);
        const lazyInputSecond = (0, $01W3b.ref)(null);
        const period = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'period', 'am');
        const viewMode = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'viewMode', 'hour');
        const controlsRef = (0, $01W3b.ref)(null);
        const clockRef = (0, $01W3b.ref)(null);
        const isAmPm = (0, $01W3b.computed)(()=>{
            return props.format === 'ampm';
        });
        const { isAllowedHour: isAllowedHour, isAllowedMinute: isAllowedMinute, isAllowedSecond: isAllowedSecond } = (0, $cbcc49751d5d592e$export$6913080731fabed9)(props);
        const shouldClear = (0, $01W3b.toRef)(()=>{
            return props.modelValue !== null && inputHour.value === null && inputMinute.value === null && (!props.useSeconds || inputSecond.value === null);
        });
        function emitValue() {
            const value = genValue();
            if (value !== null && value !== props.modelValue) emit('update:modelValue', value);
            if (shouldClear.value) emit('update:modelValue', null);
        }
        (0, $01W3b.watch)(inputHour, emitValue);
        (0, $01W3b.watch)(inputMinute, emitValue);
        (0, $01W3b.watch)(inputSecond, emitValue);
        (0, $01W3b.watch)(()=>props.modelValue, (val)=>setInputData(val));
        (0, $01W3b.watch)(()=>props.useSeconds, (val, old)=>{
            if (old && !val && viewMode.value === 'second') viewMode.value = 'minute';
            if (!val && inputSecond.value !== null) inputSecond.value = null;
        });
        (0, $TusQn.onMounted)(()=>{
            setInputData(props.modelValue);
        });
        function genValue() {
            if (inputHour.value != null && inputMinute.value != null && (!props.useSeconds || inputSecond.value != null)) return `${(0, $b9d904146ba009a4$export$5d04458e2a6c373e)(inputHour.value)}:${(0, $b9d904146ba009a4$export$5d04458e2a6c373e)(inputMinute.value)}` + (props.useSeconds ? `:${(0, $b9d904146ba009a4$export$5d04458e2a6c373e)(inputSecond.value)}` : '');
            return null;
        }
        function setInputData(value) {
            if (value == null || value === '') {
                inputHour.value = null;
                inputMinute.value = null;
                inputSecond.value = null;
            } else if (value instanceof Date) {
                inputHour.value = value.getHours();
                inputMinute.value = value.getMinutes();
                inputSecond.value = value.getSeconds();
            } else {
                const [hour, , minute, , second, period] = value.trim().toLowerCase().match(/^(\d+):(\d+)(:(\d+))?([ap]m)?$/) || new Array(6);
                inputHour.value = period ? (0, $b9d904146ba009a4$export$e40e59a57ec762e4)(parseInt(hour, 10), period) : parseInt(hour, 10);
                inputMinute.value = parseInt(minute, 10);
                inputSecond.value = parseInt(second || 0, 10);
            }
            period.value = inputHour.value == null || inputHour.value < 12 ? 'am' : 'pm';
        }
        function onInput(value) {
            if (viewMode.value === 'hour') inputHour.value = isAmPm.value ? (0, $b9d904146ba009a4$export$e40e59a57ec762e4)(value, period.value) : value;
            else if (viewMode.value === 'minute') inputMinute.value = value;
            else inputSecond.value = value;
        }
        function onChange(value) {
            switch(viewMode.value || 'hour'){
                case 'hour':
                    emit('update:hour', value);
                    break;
                case 'minute':
                    emit('update:minute', value);
                    break;
                case 'second':
                    emit('update:second', value);
                    break;
                default:
                    break;
            }
            const emitChange = inputHour.value !== null && inputMinute.value !== null && (props.useSeconds ? inputSecond.value !== null : true);
            if (viewMode.value === 'hour') viewMode.value = 'minute';
            else if (props.useSeconds && viewMode.value === 'minute') viewMode.value = 'second';
            if (inputHour.value === lazyInputHour.value && inputMinute.value === lazyInputMinute.value && (!props.useSeconds || inputSecond.value === lazyInputSecond.value)) return;
            const time = genValue();
            if (time === null) return;
            lazyInputHour.value = inputHour.value;
            lazyInputMinute.value = inputMinute.value;
            props.useSeconds && (lazyInputSecond.value = inputSecond.value);
            emitChange && emitValue();
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const pickerProps = (0, $8590040a7833369a$export$30a06c8d3562193f)((0, $dbc8d169fef91a15$export$37f35d9b6bd5d714).filterProps(props), [
                'hideHeader'
            ]);
            const timePickerControlsProps = (0, $c092584fceb7bae6$export$bc5bd0b10348afb9).filterProps(props);
            const timePickerClockProps = (0, $f9b8b68b8e0b4aa4$export$c447be6017502228).filterProps((0, $8590040a7833369a$export$30a06c8d3562193f)(props, [
                'format',
                'modelValue',
                'min',
                'max'
            ]));
            const clockValidation = viewMode.value === 'hour' ? isAllowedHour.value : viewMode.value === 'minute' ? (v)=>isAllowedMinute.value(inputHour.value, v) : (v)=>isAllowedSecond.value(inputHour.value, inputMinute.value, v);
            return (0, $TusQn.createVNode)((0, $dbc8d169fef91a15$export$37f35d9b6bd5d714), (0, $TusQn.mergeProps)(pickerProps, {
                "color": undefined,
                "class": [
                    'v-time-picker',
                    `v-time-picker--variant-${props.variant}`,
                    props.class,
                    densityClasses.value
                ],
                "hideHeader": props.hideHeader && props.variant !== 'input',
                "style": props.style
            }), {
                title: ()=>slots.title?.() ?? (0, $TusQn.createElementVNode)("div", {
                        "class": "v-time-picker__title"
                    }, [
                        t(props.title)
                    ]),
                header: ()=>(0, $TusQn.createVNode)((0, $c092584fceb7bae6$export$bc5bd0b10348afb9), (0, $TusQn.mergeProps)(timePickerControlsProps, {
                        "ampm": isAmPm.value,
                        "hour": inputHour.value,
                        "minute": inputMinute.value,
                        "period": period.value,
                        "second": inputSecond.value,
                        "viewMode": viewMode.value,
                        "inputHints": props.variant === 'input',
                        "onUpdate:hour": (val)=>inputHour.value = val,
                        "onUpdate:minute": (val)=>inputMinute.value = val,
                        "onUpdate:second": (val)=>inputSecond.value = val,
                        "onUpdate:period": (val)=>period.value = val,
                        "onUpdate:viewMode": (value)=>viewMode.value = value,
                        "ref": controlsRef
                    }), null),
                default: ()=>(0, $TusQn.createVNode)((0, $f9b8b68b8e0b4aa4$export$c447be6017502228), (0, $TusQn.mergeProps)(timePickerClockProps, {
                        "allowedValues": clockValidation,
                        "double": viewMode.value === 'hour' && !isAmPm.value,
                        "format": viewMode.value === 'hour' ? isAmPm.value ? (0, $b9d904146ba009a4$export$8041c02ebe2956d0) : (val)=>val : (val)=>(0, $b9d904146ba009a4$export$5d04458e2a6c373e)(val, 2),
                        "max": viewMode.value === 'hour' ? isAmPm.value && period.value === 'am' ? 11 : 23 : 59,
                        "min": viewMode.value === 'hour' && isAmPm.value && period.value === 'pm' ? 12 : 0,
                        "size": 20,
                        "step": viewMode.value === 'hour' ? 1 : 5,
                        "modelValue": viewMode.value === 'hour' ? inputHour.value : viewMode.value === 'minute' ? inputMinute.value : inputSecond.value,
                        "onChange": onChange,
                        "onInput": onInput,
                        "ref": clockRef
                    }), null),
                actions: slots.actions
            });
        });
    }
});






var $128bc05158f847f1$exports = {};

$parcel$export($128bc05158f847f1$exports, "VToolbar", () => $2d6a3d21f95681cf$export$42c906c84e26a6d1);
$parcel$export($128bc05158f847f1$exports, "VToolbarTitle", () => $19fdabc79dfb07a7$export$deaeca9428bfc9a4);
$parcel$export($128bc05158f847f1$exports, "VToolbarItems", () => $e1bf015f829bc742$export$b32291480cbbcf57);


parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");
var $01W3b = parcelRequire("01W3b");




const $e1bf015f829bc742$export$81931f5498198616 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $b1955b9b553f9f53$export$d271552babda0448)(),
    ...(0, $567f01637e3e83ec$export$7c4064f4acce0348)({
        variant: 'text'
    })
}, 'VToolbarItems');
const $e1bf015f829bc742$export$b32291480cbbcf57 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VToolbarItems',
    props: $e1bf015f829bc742$export$81931f5498198616(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VBtn: {
                color: (0, $01W3b.toRef)(()=>props.color),
                height: 'inherit',
                variant: (0, $01W3b.toRef)(()=>props.variant)
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>(0, $TusQn.createElementVNode)("div", {
                "class": (0, $8POXm.normalizeClass)([
                    'v-toolbar-items',
                    props.class
                ]),
                "style": (0, $8POXm.normalizeStyle)(props.style)
            }, [
                slots.default?.()
            ]));
        return {};
    }
});




var $73c99f94e42f596e$exports = {};

$parcel$export($73c99f94e42f596e$exports, "VTooltip", () => $482ba1cc42453374$export$b742615555a86f54);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");







const $482ba1cc42453374$export$9d9be12bfa458eb = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    id: String,
    interactive: Boolean,
    text: String,
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $0eb6b57fb5d95344$export$357b25d59a7fb3fa)({
        closeOnBack: false,
        location: 'end',
        locationStrategy: 'connected',
        eager: true,
        minWidth: 0,
        offset: 10,
        openOnClick: false,
        openOnHover: true,
        origin: 'auto',
        scrim: false,
        scrollStrategy: 'reposition',
        transition: null
    }), [
        'absolute',
        'retainFocus',
        'captureFocus',
        'disableInitialFocus'
    ])
}, 'VTooltip');
const $482ba1cc42453374$export$b742615555a86f54 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTooltip',
    props: $482ba1cc42453374$export$9d9be12bfa458eb(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isActive = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'modelValue');
        const { scopeId: scopeId } = (0, $d897445671465531$export$eeabe5cda932100d)();
        const uid = (0, $TusQn.useId)();
        const id = (0, $01W3b.toRef)(()=>props.id || `v-tooltip-${uid}`);
        const overlay = (0, $01W3b.ref)();
        const location = (0, $01W3b.computed)(()=>{
            return props.location.split(' ').length > 1 ? props.location : props.location + ' center';
        });
        const origin = (0, $01W3b.computed)(()=>{
            return props.origin === 'auto' || props.origin === 'overlap' || props.origin.split(' ').length > 1 || props.location.split(' ').length > 1 ? props.origin : props.origin + ' center';
        });
        const transition = (0, $01W3b.toRef)(()=>{
            if (props.transition != null) return props.transition;
            return isActive.value ? 'scale-transition' : 'fade-transition';
        });
        const activatorProps = (0, $01W3b.computed)(()=>(0, $TusQn.mergeProps)({
                'aria-describedby': id.value
            }, props.activatorProps));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const overlayProps = (0, $0eb6b57fb5d95344$export$32caf7e8170352aa).filterProps(props);
            return (0, $TusQn.createVNode)((0, $0eb6b57fb5d95344$export$32caf7e8170352aa), (0, $TusQn.mergeProps)({
                "ref": overlay,
                "class": [
                    'v-tooltip',
                    {
                        'v-tooltip--interactive': props.interactive
                    },
                    props.class
                ],
                "style": props.style,
                "id": id.value
            }, overlayProps, {
                "modelValue": isActive.value,
                "onUpdate:modelValue": ($event)=>isActive.value = $event,
                "transition": transition.value,
                "absolute": true,
                "location": location.value,
                "origin": origin.value,
                "role": "tooltip",
                "activatorProps": activatorProps.value,
                "_disableGlobalStack": true
            }, scopeId), {
                activator: slots.activator,
                default: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    return slots.default?.(...args) ?? props.text;
                }
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, overlay);
    }
});




var $aba0757fcb8e50be$exports = {};

$parcel$export($aba0757fcb8e50be$exports, "VTreeview", () => $219b678e9509528e$export$73d6d5b920b7a2b0);
$parcel$export($aba0757fcb8e50be$exports, "VTreeviewItem", () => $a26232ea7508b764$export$bf6462de57644853);
$parcel$export($aba0757fcb8e50be$exports, "VTreeviewGroup", () => $cd7a3c163cbeb47d$export$3a3ffd4c206e0c0c);
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");



const $cd7a3c163cbeb47d$export$b959bdd312d83ac6 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $7522211dead698f4$export$4ba1284b16a5c704)({
        collapseIcon: '$treeviewCollapse',
        expandIcon: '$treeviewExpand'
    }), [
        'subgroup'
    ])
}, 'VTreeviewGroup');
const $cd7a3c163cbeb47d$export$3a3ffd4c206e0c0c = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTreeviewGroup',
    props: $cd7a3c163cbeb47d$export$b959bdd312d83ac6(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const vListGroupRef = (0, $01W3b.ref)();
        const toggleIcon = (0, $01W3b.computed)(()=>vListGroupRef.value?.isOpen ? props.collapseIcon : props.expandIcon);
        const activatorDefaults = (0, $01W3b.computed)(()=>({
                VTreeviewItem: {
                    prependIcon: undefined,
                    appendIcon: undefined,
                    toggleIcon: toggleIcon.value
                }
            }));
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const listGroupProps = (0, $7522211dead698f4$export$22fc03a43764dcc7).filterProps(props);
            return (0, $TusQn.createVNode)((0, $7522211dead698f4$export$22fc03a43764dcc7), (0, $TusQn.mergeProps)(listGroupProps, {
                "ref": vListGroupRef,
                "class": [
                    'v-treeview-group',
                    props.class
                ],
                "subgroup": true
            }), {
                ...slots,
                activator: slots.activator ? (slotProps)=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "defaults": activatorDefaults.value
                        }, {
                            default: ()=>[
                                    slots.activator?.(slotProps)
                                ]
                        })
                    ]) : undefined
            });
        });
        return {};
    }
});


parcelRequire("ecd4d");
var $01W3b = parcelRequire("01W3b");
var $TusQn = parcelRequire("TusQn");
var $8POXm = parcelRequire("8POXm");










// Types
const $84aea2ca00118530$export$27ddf0c1fca754de = Symbol.for('vuetify:v-treeview');



const $a26232ea7508b764$export$9bf10ae5b7b202c = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    loading: Boolean,
    hideActions: Boolean,
    hasCustomPrepend: Boolean,
    indentLines: Array,
    toggleIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    ...(0, $3d00ebc3c7505e27$export$b1024b817bbb948b)({
        slim: true
    })
}, 'VTreeviewItem');
const $a26232ea7508b764$export$bf6462de57644853 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTreeviewItem',
    props: $a26232ea7508b764$export$9bf10ae5b7b202c(),
    emits: {
        toggleExpand: (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const visibleIds = (0, $TusQn.inject)((0, $84aea2ca00118530$export$27ddf0c1fca754de), {
            visibleIds: (0, $01W3b.ref)()
        }).visibleIds;
        const vListItemRef = (0, $01W3b.ref)();
        const isActivatableGroupActivator = (0, $01W3b.computed)(()=>vListItemRef.value?.root.activatable.value && vListItemRef.value?.isGroupActivator);
        const vListItemRefIsClickable = (0, $01W3b.computed)(()=>vListItemRef.value?.link.isClickable.value || props.value != null && !!vListItemRef.value?.list);
        const isClickable = (0, $01W3b.computed)(()=>!props.disabled && props.link !== false && (props.link || vListItemRefIsClickable.value || isActivatableGroupActivator.value));
        const isFiltered = (0, $01W3b.computed)(()=>visibleIds.value && !visibleIds.value.has((0, $01W3b.toRaw)(vListItemRef.value?.id)));
        function activateGroupActivator(e) {
            if (isClickable.value && isActivatableGroupActivator.value) vListItemRef.value?.activate(!vListItemRef.value?.isActivated, e);
        }
        function onClickAction(e) {
            e.preventDefault();
            e.stopPropagation();
            emit('toggleExpand', e);
        }
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const listItemProps = (0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146).filterProps(props);
            const hasPrepend = slots.prepend || props.toggleIcon || props.indentLines || props.prependIcon || props.prependAvatar;
            return (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), (0, $TusQn.mergeProps)({
                "ref": vListItemRef
            }, listItemProps, {
                "active": vListItemRef.value?.isActivated || undefined,
                "class": [
                    'v-treeview-item',
                    {
                        'v-treeview-item--activatable-group-activator': isActivatableGroupActivator.value,
                        'v-treeview-item--filtered': isFiltered.value
                    },
                    props.class
                ],
                "role": "treeitem",
                "ripple": false,
                "onClick": activateGroupActivator
            }), {
                ...slots,
                prepend: hasPrepend ? (slotProps)=>{
                    return (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                        props.indentLines && props.indentLines.length > 0 ? (0, $TusQn.createElementVNode)("div", {
                            "key": "indent-lines",
                            "class": "v-treeview-indent-lines",
                            "style": {
                                '--v-indent-parts': props.indentLines.length
                            }
                        }, [
                            props.indentLines.map((type)=>(0, $TusQn.createElementVNode)("div", {
                                    "class": (0, $8POXm.normalizeClass)(`v-treeview-indent-line v-treeview-indent-line--${type}`)
                                }, null))
                        ]) : '',
                        !props.hideActions && (0, $TusQn.createVNode)((0, $1315588cb8db08e1$export$104c1ead9d891c55), {
                            "start": true
                        }, {
                            default: ()=>[
                                    props.toggleIcon ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                                        !slots.toggle ? (0, $TusQn.createVNode)((0, $a343b25403be30b7$export$657f28cf887b91a6), {
                                            "key": "prepend-toggle",
                                            "density": "compact",
                                            "icon": props.toggleIcon,
                                            "loading": props.loading,
                                            "variant": "text",
                                            "onClick": onClickAction
                                        }, {
                                            loader: ()=>(0, $TusQn.createVNode)((0, $26f3a281106a205d$export$2b4afd8de42c0c21), {
                                                    "indeterminate": "disable-shrink",
                                                    "size": "20",
                                                    "width": "2"
                                                }, null)
                                        }) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                                            "key": "prepend-defaults",
                                            "defaults": {
                                                VBtn: {
                                                    density: 'compact',
                                                    icon: props.toggleIcon,
                                                    variant: 'text',
                                                    loading: props.loading
                                                },
                                                VProgressCircular: {
                                                    indeterminate: 'disable-shrink',
                                                    size: 20,
                                                    width: 2
                                                }
                                            }
                                        }, {
                                            default: ()=>[
                                                    slots.toggle({
                                                        ...slotProps,
                                                        loading: props.loading,
                                                        props: {
                                                            onClick: onClickAction
                                                        }
                                                    })
                                                ]
                                        })
                                    ]) : (0, $TusQn.createElementVNode)("div", {
                                        "class": "v-treeview-item__level"
                                    }, null)
                                ]
                        }),
                        !props.hasCustomPrepend ? (0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                            slots.prepend?.(slotProps),
                            props.prependAvatar && (0, $TusQn.createVNode)((0, $acc7f6236cd87eac$export$dbee61bc703cd5ff), {
                                "key": "prepend-avatar",
                                "density": props.density,
                                "image": props.prependAvatar
                            }, null),
                            props.prependIcon && (0, $TusQn.createVNode)((0, $8ebccd09f8e016c4$export$a7d30c6ec4d2d61e), {
                                "key": "prepend-icon",
                                "density": props.density,
                                "icon": props.prependIcon
                            }, null)
                        ]) : (0, $TusQn.createVNode)((0, $d16c59ae67056c43$export$ee4fab30a254e5ee), {
                            "key": "prepend-defaults",
                            "defaults": {
                                VAvatar: {
                                    density: props.density,
                                    image: props.appendAvatar
                                },
                                VIcon: {
                                    density: props.density,
                                    icon: props.appendIcon
                                },
                                VListItemAction: {
                                    start: true
                                }
                            }
                        }, {
                            default: ()=>[
                                    slots.prepend?.(slotProps)
                                ]
                        })
                    ]);
                } : undefined
            });
        });
        return (0, $c1e610bfc2557356$export$e091cd9ead0744b3)({}, vListItemRef);
    }
});







// Types
function $3e79b28185841400$export$af5f0b00e3736160(_ref) {
    let { depth: depth, isLast: isLast, isLastGroup: isLastGroup, leafLinks: leafLinks, separateRoots: separateRoots, parentIndentLines: parentIndentLines, variant: variant } = _ref;
    const isLastLeaf = isLast && (!isLastGroup || separateRoots || depth > 1);
    if (!parentIndentLines || !depth) return {
        leaf: undefined,
        node: undefined,
        children: parentIndentLines,
        footer: parentIndentLines && (!isLastLeaf || variant === 'simple') ? [
            ...parentIndentLines,
            separateRoots ? 'none' : 'line'
        ] : [
            'none'
        ]
    };
    if (variant === 'simple') return {
        leaf: [
            ...parentIndentLines,
            'line'
        ],
        node: [
            ...parentIndentLines,
            'line'
        ],
        children: [
            ...parentIndentLines,
            'line'
        ],
        footer: [
            ...parentIndentLines,
            'line',
            'line'
        ]
    };
    return {
        leaf: [
            ...parentIndentLines,
            isLastLeaf ? 'last-leaf' : 'leaf',
            ...leafLinks ? [
                'leaf-link'
            ] : []
        ],
        node: [
            ...parentIndentLines,
            isLastLeaf ? 'last-leaf' : 'leaf'
        ],
        children: [
            ...parentIndentLines,
            isLastLeaf ? 'none' : 'line'
        ],
        footer: [
            ...parentIndentLines,
            isLastLeaf ? 'none' : 'line'
        ]
    };
}


const $df596297bbc1217a$export$18e1f77dc95ddbb0 = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    fluid: Boolean,
    disabled: Boolean,
    loadChildren: Function,
    loadingIcon: {
        type: String,
        default: '$loading'
    },
    items: Array,
    openOnClick: {
        type: Boolean,
        default: undefined
    },
    indeterminateIcon: {
        type: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
        default: '$checkboxIndeterminate'
    },
    falseIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    trueIcon: (0, $834ffcae3192e85e$export$84527c6e3556c23f),
    returnObject: Boolean,
    activatable: Boolean,
    selectable: Boolean,
    selectedColor: String,
    selectStrategy: [
        String,
        Function,
        Object
    ],
    index: Number,
    isLastGroup: Boolean,
    separateRoots: Boolean,
    parentIndentLines: Array,
    indentLinesVariant: String,
    path: {
        type: Array,
        default: ()=>[]
    },
    ...(0, $8590040a7833369a$export$357523c63a2253b9)((0, $a26232ea7508b764$export$9bf10ae5b7b202c)(), [
        'hideActions'
    ]),
    ...(0, $667123557e1d36ef$export$aac8956235d563cb)()
}, 'VTreeviewChildren');
const $df596297bbc1217a$export$be24f8dd9eaa5474 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTreeviewChildren',
    props: $df596297bbc1217a$export$18e1f77dc95ddbb0(),
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const isLoading = (0, $01W3b.reactive)(new Set());
        const activatorItems = (0, $01W3b.ref)([]);
        const isClickOnOpen = (0, $01W3b.computed)(()=>!props.disabled && (props.openOnClick != null ? props.openOnClick : props.selectable && !props.activatable));
        async function checkChildren(item) {
            try {
                if (!props.items?.length || !props.loadChildren) return;
                if (item?.children?.length === 0) {
                    isLoading.add(item.value);
                    await props.loadChildren(item.raw);
                }
            } finally{
                isLoading.delete(item.value);
            }
        }
        function selectItem(select, isSelected) {
            if (props.selectable) select(isSelected);
        }
        return ()=>slots.default?.() ?? props.items?.map((item, index, items)=>{
                const { children: children, props: itemProps } = item;
                const loading = isLoading.has(item.value);
                const nextItemHasChildren = !!items.at(index + 1)?.children;
                const depth = props.path?.length ?? 0;
                const isLast = items.length - 1 === index;
                const treeItemProps = {
                    index: index,
                    depth: depth,
                    isFirst: index === 0,
                    isLast: isLast,
                    path: [
                        ...props.path,
                        index
                    ],
                    hideAction: props.hideActions
                };
                const indentLines = (0, $3e79b28185841400$export$af5f0b00e3736160)({
                    depth: depth,
                    isLast: isLast,
                    isLastGroup: props.isLastGroup,
                    leafLinks: !props.hideActions && !props.fluid,
                    separateRoots: props.separateRoots,
                    parentIndentLines: props.parentIndentLines,
                    variant: props.indentLinesVariant
                });
                const slotsWithItem = {
                    toggle: slots.toggle ? (slotProps)=>slots.toggle?.({
                            ...slotProps,
                            ...treeItemProps,
                            item: item.raw,
                            internalItem: item,
                            loading: loading
                        }) : undefined,
                    prepend: (slotProps)=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                            props.selectable && (!children || children && ![
                                'leaf',
                                'single-leaf'
                            ].includes(props.selectStrategy)) && (0, $TusQn.createVNode)((0, $1315588cb8db08e1$export$104c1ead9d891c55), {
                                "start": true
                            }, {
                                default: ()=>[
                                        (0, $TusQn.createVNode)((0, $c8f17ec9401c8898$export$2c5503cb3c38fdb6), {
                                            "key": item.value,
                                            "modelValue": slotProps.isSelected,
                                            "disabled": props.disabled || itemProps.disabled,
                                            "loading": loading,
                                            "color": props.selectedColor,
                                            "density": props.density,
                                            "indeterminate": slotProps.isIndeterminate,
                                            "indeterminateIcon": props.indeterminateIcon,
                                            "falseIcon": props.falseIcon,
                                            "trueIcon": props.trueIcon,
                                            "onUpdate:modelValue": (v)=>selectItem(slotProps.select, v),
                                            "onClick": (e)=>e.stopPropagation(),
                                            "onKeydown": (e)=>{
                                                if (![
                                                    'Enter',
                                                    'Space'
                                                ].includes(e.key)) return;
                                                e.stopPropagation();
                                                selectItem(slotProps.select, slotProps.isSelected);
                                            }
                                        }, null)
                                    ]
                            }),
                            slots.prepend?.({
                                ...slotProps,
                                ...treeItemProps,
                                item: item.raw,
                                internalItem: item
                            })
                        ]),
                    append: slots.append ? (slotProps)=>slots.append?.({
                            ...slotProps,
                            ...treeItemProps,
                            item: item.raw,
                            internalItem: item
                        }) : undefined,
                    title: slots.title ? (slotProps)=>slots.title?.({
                            ...slotProps,
                            item: item.raw,
                            internalItem: item
                        }) : undefined,
                    subtitle: slots.subtitle ? (slotProps)=>slots.subtitle?.({
                            ...slotProps,
                            item: item.raw,
                            internalItem: item
                        }) : undefined
                };
                const treeviewGroupProps = (0, $cd7a3c163cbeb47d$export$3a3ffd4c206e0c0c).filterProps(itemProps);
                const treeviewChildrenProps = $df596297bbc1217a$export$be24f8dd9eaa5474.filterProps({
                    ...props,
                    ...treeItemProps
                });
                const footerProps = {
                    hideActions: props.hideActions,
                    indentLines: indentLines.footer
                };
                return children ? (0, $TusQn.createVNode)((0, $cd7a3c163cbeb47d$export$3a3ffd4c206e0c0c), (0, $TusQn.mergeProps)(treeviewGroupProps, {
                    "value": props.returnObject ? item.raw : treeviewGroupProps?.value,
                    "rawId": treeviewGroupProps?.value
                }), {
                    activator: (_ref2)=>{
                        let { props: activatorProps, isOpen: isOpen } = _ref2;
                        const listItemProps = {
                            ...itemProps,
                            ...activatorProps,
                            value: itemProps?.value,
                            hideActions: props.hideActions,
                            indentLines: indentLines.node,
                            ariaExpanded: isOpen,
                            onToggleExpand: [
                                ()=>checkChildren(item),
                                activatorProps.onClick
                            ],
                            onClick: props.disabled || itemProps.disabled ? undefined : isClickOnOpen.value ? [
                                ()=>checkChildren(item),
                                activatorProps.onClick
                            ] : ()=>selectItem(activatorItems.value[index]?.select, !activatorItems.value[index]?.isSelected)
                        };
                        return (0, $8590040a7833369a$export$4abee4c34694ada1)(slots.header, {
                            props: listItemProps,
                            item: item.raw,
                            internalItem: item,
                            loading: loading
                        }, ()=>(0, $TusQn.createVNode)((0, $a26232ea7508b764$export$bf6462de57644853), (0, $TusQn.mergeProps)({
                                "ref": (el)=>activatorItems.value[index] = el
                            }, listItemProps, {
                                "hasCustomPrepend": !!slots.prepend,
                                "value": props.returnObject ? item.raw : itemProps.value,
                                "loading": loading
                            }), slotsWithItem));
                    },
                    default: ()=>(0, $TusQn.createElementVNode)((0, $TusQn.Fragment), null, [
                            (0, $TusQn.createVNode)($df596297bbc1217a$export$be24f8dd9eaa5474, (0, $TusQn.mergeProps)(treeviewChildrenProps, {
                                "items": children,
                                "indentLinesVariant": props.indentLinesVariant,
                                "parentIndentLines": indentLines.children,
                                "isLastGroup": nextItemHasChildren,
                                "returnObject": props.returnObject
                            }), slots),
                            slots.footer?.({
                                props: footerProps,
                                item: item.raw,
                                internalItem: item,
                                loading: loading
                            })
                        ])
                }) : (0, $8590040a7833369a$export$4abee4c34694ada1)(slots.item, {
                    props: itemProps,
                    item: item.raw,
                    internalItem: item
                }, ()=>{
                    if (item.type === 'divider') return (0, $8590040a7833369a$export$4abee4c34694ada1)(slots.divider, {
                        props: item.raw
                    }, ()=>(0, $TusQn.createVNode)((0, $7eecf16f7970712c$export$a2636a5d9a866ca1), item.props, null));
                    if (item.type === 'subheader') return (0, $8590040a7833369a$export$4abee4c34694ada1)(slots.subheader, {
                        props: item.raw
                    }, ()=>(0, $TusQn.createVNode)((0, $96a2eb5e8711f0cc$export$70c4aba7bf48e22a), item.props, null));
                    return (0, $TusQn.createVNode)((0, $a26232ea7508b764$export$bf6462de57644853), (0, $TusQn.mergeProps)(itemProps, {
                        "hasCustomPrepend": !!slots.prepend,
                        "hideActions": props.hideActions,
                        "indentLines": indentLines.leaf,
                        "value": props.returnObject ? (0, $01W3b.toRaw)(item.raw) : itemProps.value
                    }), slotsWithItem);
                });
            });
    }
});










function $219b678e9509528e$var$flatten(items) {
    let flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    for (const item of items){
        flat.push(item);
        if (item.children) $219b678e9509528e$var$flatten(item.children, flat);
    }
    return flat;
}
const $219b678e9509528e$export$ab81edf05d8984fc = (0, $eac50e4c5cfd47f2$export$d5c63d7e6e58d2df)({
    openAll: Boolean,
    indentLines: [
        Boolean,
        String
    ],
    indentLinesColor: String,
    indentLinesOpacity: [
        String,
        Number
    ],
    search: String,
    hideNoData: Boolean,
    noDataText: {
        type: String,
        default: '$vuetify.noDataText'
    },
    ...(0, $06230a510138477a$export$a99bb5c4eecafb96)({
        filterKeys: [
            'title'
        ]
    }),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $df596297bbc1217a$export$18e1f77dc95ddbb0)(), [
        'index',
        'path',
        'indentLinesVariant',
        'parentIndentLines',
        'isLastGroup'
    ]),
    ...(0, $8590040a7833369a$export$30a06c8d3562193f)((0, $8f3cccf9308874bc$export$b385b2bc1ebed11d)({
        collapseIcon: '$treeviewCollapse',
        expandIcon: '$treeviewExpand',
        slim: true
    }), [
        'nav',
        'openStrategy'
    ]),
    modelValue: Array
}, 'VTreeview');
const $219b678e9509528e$export$73d6d5b920b7a2b0 = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VTreeview',
    props: $219b678e9509528e$export$ab81edf05d8984fc(),
    emits: {
        'update:opened': (val)=>true,
        'update:activated': (val)=>true,
        'update:selected': (val)=>true,
        'update:modelValue': (val)=>true,
        'click:open': (value)=>true,
        'click:select': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots, emit: emit } = _ref;
        const { t: t } = (0, $13e23564052bdddd$export$43bb16f9c6d9e3f7)();
        const { items: items } = (0, $8f3cccf9308874bc$export$d0ca4790a6d27133)(props);
        const activeColor = (0, $01W3b.toRef)(()=>props.activeColor);
        const baseColor = (0, $01W3b.toRef)(()=>props.baseColor);
        const color = (0, $01W3b.toRef)(()=>props.color);
        const activated = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'activated');
        const _selected = (0, $9518c0cac3056c0f$export$6f3ae48335514a2)(props, 'selected');
        const selected = (0, $01W3b.computed)({
            get: ()=>props.modelValue ?? _selected.value,
            set (val) {
                _selected.value = val;
                emit('update:modelValue', val);
            }
        });
        const vListRef = (0, $01W3b.ref)();
        const opened = (0, $01W3b.computed)(()=>props.openAll ? openAll(items.value) : props.opened);
        const flatItems = (0, $01W3b.computed)(()=>$219b678e9509528e$var$flatten(items.value));
        const search = (0, $01W3b.toRef)(()=>props.search);
        const { filteredItems: filteredItems } = (0, $06230a510138477a$export$3274cf84b703fff)(props, flatItems, search);
        const visibleIds = (0, $01W3b.computed)(()=>{
            if (!search.value) return null;
            const getPath = vListRef.value?.getPath;
            if (!getPath) return null;
            return new Set(filteredItems.value.flatMap((item)=>{
                const itemVal = props.returnObject ? item.raw : item.props.value;
                return [
                    ...getPath(itemVal),
                    ...getChildren(itemVal)
                ].map((0, $01W3b.toRaw));
            }));
        });
        function getChildren(id) {
            const arr = [];
            const queue = (vListRef.value?.children.get(id) ?? []).slice();
            while(queue.length){
                const child = queue.shift();
                if (!child) continue;
                arr.push(child);
                queue.push(...(vListRef.value?.children.get(child) ?? []).slice());
            }
            return arr;
        }
        function openAll(items) {
            let ids = [];
            for (const i of items){
                if (!i.children) continue;
                ids.push(props.returnObject ? (0, $01W3b.toRaw)(i.raw) : i.value);
                if (i.children) ids = ids.concat(openAll(i.children));
            }
            return ids;
        }
        (0, $TusQn.provide)((0, $84aea2ca00118530$export$27ddf0c1fca754de), {
            visibleIds: visibleIds
        });
        (0, $8b1159e2b202edcf$export$31ed9bd1c7c3a7ee)({
            VTreeviewGroup: {
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                collapseIcon: (0, $01W3b.toRef)(()=>props.collapseIcon),
                expandIcon: (0, $01W3b.toRef)(()=>props.expandIcon)
            },
            VTreeviewItem: {
                activeClass: (0, $01W3b.toRef)(()=>props.activeClass),
                activeColor: activeColor,
                baseColor: baseColor,
                color: color,
                density: (0, $01W3b.toRef)(()=>props.density),
                disabled: (0, $01W3b.toRef)(()=>props.disabled),
                lines: (0, $01W3b.toRef)(()=>props.lines),
                variant: (0, $01W3b.toRef)(()=>props.variant)
            }
        });
        (0, $a006457100ae975f$export$e25bb1e5b53cbdff)(()=>{
            const listProps = (0, $8f3cccf9308874bc$export$3b010b0401837103).filterProps(props);
            const treeviewChildrenProps = (0, $df596297bbc1217a$export$be24f8dd9eaa5474).filterProps(props);
            const indentLinesVariant = typeof props.indentLines === 'boolean' ? 'default' : props.indentLines;
            return (0, $TusQn.createVNode)((0, $8f3cccf9308874bc$export$3b010b0401837103), (0, $TusQn.mergeProps)({
                "ref": vListRef
            }, listProps, {
                "class": [
                    'v-treeview',
                    {
                        'v-treeview--fluid': props.fluid
                    },
                    props.class
                ],
                "role": "tree",
                "openStrategy": "multiple",
                "style": [
                    {
                        '--v-treeview-indent-line-color': props.indentLinesColor,
                        '--v-treeview-indent-line-opacity': props.indentLinesOpacity
                    },
                    props.style
                ],
                "opened": opened.value,
                "activated": activated.value,
                "onUpdate:activated": ($event)=>activated.value = $event,
                "selected": selected.value,
                "onUpdate:selected": ($event)=>selected.value = $event
            }), {
                default: ()=>[
                        visibleIds.value?.size === 0 && !props.hideNoData && (slots['no-data']?.() ?? (0, $TusQn.createVNode)((0, $3d00ebc3c7505e27$export$a6ee5a73ee56a146), {
                            "key": "no-data",
                            "title": t(props.noDataText)
                        }, null)),
                        (0, $TusQn.createVNode)((0, $df596297bbc1217a$export$be24f8dd9eaa5474), (0, $TusQn.mergeProps)(treeviewChildrenProps, {
                            "density": props.density,
                            "returnObject": props.returnObject,
                            "items": items.value,
                            "parentIndentLines": props.indentLines ? [] : undefined,
                            "indentLinesVariant": indentLinesVariant
                        }), slots)
                    ]
            });
        });
        return {};
    }
});






var $15b29837b825f1fd$exports = {};

$parcel$export($15b29837b825f1fd$exports, "VValidation", () => $bbb2308c7822d7be$export$5c8bcd85283afcdb);
// Composables


const $bbb2308c7822d7be$export$5c8bcd85283afcdb = (0, $2b7aafe61499bf6b$export$6925fd0bc332cf90)()({
    name: 'VValidation',
    props: (0, $d31a46cb498bdea9$export$42513dbc731a0133)(),
    emits: {
        'update:modelValue': (value)=>true
    },
    setup (props, _ref) {
        let { slots: slots } = _ref;
        const validation = (0, $d31a46cb498bdea9$export$87fe492f99f25a20)(props, 'validation');
        return ()=>slots.default?.(validation);
    }
});




var $35ce509aab0856e8$exports = {};

$parcel$export($35ce509aab0856e8$exports, "VVirtualScroll", () => $28b14115b5680302$export$bdb136bf2d9028a4);



var $2797b5f506bf3d03$exports = {};

$parcel$export($2797b5f506bf3d03$exports, "VWindow", () => $27128a8be1af1448$export$7e91eb8d1b90c043);
$parcel$export($2797b5f506bf3d03$exports, "VWindowItem", () => $2441fb35357f80c2$export$5dd5457a16e4a360);





$parcel$exportWildcard($38548887993916f0$exports, $ebf0728bf7f44045$exports);
$parcel$exportWildcard($38548887993916f0$exports, $cf858201179e51b0$exports);
$parcel$exportWildcard($38548887993916f0$exports, $96f9927811cb207b$exports);
$parcel$exportWildcard($38548887993916f0$exports, $218d14aecf3c4b8e$exports);
$parcel$exportWildcard($38548887993916f0$exports, $b2b68bd3ae60455a$exports);
$parcel$exportWildcard($38548887993916f0$exports, $ca444c3a57a6644f$exports);
$parcel$exportWildcard($38548887993916f0$exports, $ed0b086061beadb8$exports);
$parcel$exportWildcard($38548887993916f0$exports, $b9cb57178cbe1437$exports);
$parcel$exportWildcard($38548887993916f0$exports, $f08aaa852fcc04ca$exports);
$parcel$exportWildcard($38548887993916f0$exports, $237097937e36c9fd$exports);
$parcel$exportWildcard($38548887993916f0$exports, $7c4f9b0b38ecbcd1$exports);
$parcel$exportWildcard($38548887993916f0$exports, $45e1890342be83db$exports);
$parcel$exportWildcard($38548887993916f0$exports, $2df59982fba7fb16$exports);
$parcel$exportWildcard($38548887993916f0$exports, $04065abceb254e5d$exports);
$parcel$exportWildcard($38548887993916f0$exports, $a8a0907b18bce8e1$exports);
$parcel$exportWildcard($38548887993916f0$exports, $981f2f954f40ddcb$exports);
$parcel$exportWildcard($38548887993916f0$exports, $35a09098ab68b0d7$exports);
$parcel$exportWildcard($38548887993916f0$exports, $2c5f26ff21301e8d$exports);
$parcel$exportWildcard($38548887993916f0$exports, $d173f64cfcf7eae3$exports);
$parcel$exportWildcard($38548887993916f0$exports, $a622aa128c6ec569$exports);
$parcel$exportWildcard($38548887993916f0$exports, $24d72b8d1fbc2286$exports);
$parcel$exportWildcard($38548887993916f0$exports, $419e4a176bc46a1e$exports);
$parcel$exportWildcard($38548887993916f0$exports, $83658c5835b97f53$exports);
$parcel$exportWildcard($38548887993916f0$exports, $bb8e4fdfd979e333$exports);
$parcel$exportWildcard($38548887993916f0$exports, $a9283406b3cdf2dc$exports);
$parcel$exportWildcard($38548887993916f0$exports, $2c7d14fd8421973a$exports);
$parcel$exportWildcard($38548887993916f0$exports, $ec57a60b0ce96d7c$exports);
$parcel$exportWildcard($38548887993916f0$exports, $28280b5efebf89d5$exports);
$parcel$exportWildcard($38548887993916f0$exports, $1bb6ef3684f65d13$exports);
$parcel$exportWildcard($38548887993916f0$exports, $2824664ba134397c$exports);
$parcel$exportWildcard($38548887993916f0$exports, $a77f465cd1dfa7d6$exports);
$parcel$exportWildcard($38548887993916f0$exports, $664b3b93b8737256$exports);
$parcel$exportWildcard($38548887993916f0$exports, $e220c3f8751ffdf3$exports);
$parcel$exportWildcard($38548887993916f0$exports, $b6aef855d25735ca$exports);
$parcel$exportWildcard($38548887993916f0$exports, $791bb0104a400f65$exports);
$parcel$exportWildcard($38548887993916f0$exports, $c5b023e19262b277$exports);
$parcel$exportWildcard($38548887993916f0$exports, $edd26d6e6e16e2aa$exports);
$parcel$exportWildcard($38548887993916f0$exports, $34eecb7f838ad241$exports);
$parcel$exportWildcard($38548887993916f0$exports, $ffcda30d3b202e41$exports);
$parcel$exportWildcard($38548887993916f0$exports, $6c2fb4dff887d405$exports);
$parcel$exportWildcard($38548887993916f0$exports, $d5006c207627f7d0$exports);
$parcel$exportWildcard($38548887993916f0$exports, $5f256f2181c3198b$exports);
$parcel$exportWildcard($38548887993916f0$exports, $d7a101752c573377$exports);
$parcel$exportWildcard($38548887993916f0$exports, $aa3d51ae0888c1b0$exports);
$parcel$exportWildcard($38548887993916f0$exports, $42630e9a38458a70$exports);
$parcel$exportWildcard($38548887993916f0$exports, $7043eac6db1dad1b$exports);
$parcel$exportWildcard($38548887993916f0$exports, $cf25016f1e95f8a5$exports);
$parcel$exportWildcard($38548887993916f0$exports, $6a3feb2b77125fe4$exports);
$parcel$exportWildcard($38548887993916f0$exports, $5387367d23df10db$exports);
$parcel$exportWildcard($38548887993916f0$exports, $0b6aa56d4b334646$exports);
$parcel$exportWildcard($38548887993916f0$exports, $e6d610c14e7962da$exports);
$parcel$exportWildcard($38548887993916f0$exports, $1e4036ee8bee689f$exports);
$parcel$exportWildcard($38548887993916f0$exports, $a0d09cbd97aaf00a$exports);
$parcel$exportWildcard($38548887993916f0$exports, $62cef22972307f7e$exports);
$parcel$exportWildcard($38548887993916f0$exports, $5e0ba0935e986253$exports);
$parcel$exportWildcard($38548887993916f0$exports, $3b4070e8589f8a9d$exports);
$parcel$exportWildcard($38548887993916f0$exports, $0c4922cce1352ab0$exports);
$parcel$exportWildcard($38548887993916f0$exports, $53659e3a889804c7$exports);
$parcel$exportWildcard($38548887993916f0$exports, $2a295c32f6e09300$exports);
$parcel$exportWildcard($38548887993916f0$exports, $00b3abc2ed1b82c6$exports);
$parcel$exportWildcard($38548887993916f0$exports, $13e1e4927af6989b$exports);
$parcel$exportWildcard($38548887993916f0$exports, $99ad08acab55760e$exports);
$parcel$exportWildcard($38548887993916f0$exports, $fbe6f7fcd4976368$exports);
$parcel$exportWildcard($38548887993916f0$exports, $657e986bca5811c5$exports);
$parcel$exportWildcard($38548887993916f0$exports, $1f0b3588c8c287c1$exports);
$parcel$exportWildcard($38548887993916f0$exports, $52ef548014b28330$exports);
$parcel$exportWildcard($38548887993916f0$exports, $ea93d7a101e32e86$exports);
$parcel$exportWildcard($38548887993916f0$exports, $37943bb3476841a8$exports);
$parcel$exportWildcard($38548887993916f0$exports, $b6627b8d033bd43c$exports);
$parcel$exportWildcard($38548887993916f0$exports, $e1ee40caca164440$exports);
$parcel$exportWildcard($38548887993916f0$exports, $12b799518ebb01dc$exports);
$parcel$exportWildcard($38548887993916f0$exports, $c89fef91b35a2fb0$exports);
$parcel$exportWildcard($38548887993916f0$exports, $9e573542278d56bd$exports);
$parcel$exportWildcard($38548887993916f0$exports, $8531241b37779169$exports);
$parcel$exportWildcard($38548887993916f0$exports, $97e68654b93207bf$exports);
$parcel$exportWildcard($38548887993916f0$exports, $9a4ff206b6dad5a0$exports);
$parcel$exportWildcard($38548887993916f0$exports, $b56ed29f3f154953$exports);
$parcel$exportWildcard($38548887993916f0$exports, $0a424506ae920269$exports);
$parcel$exportWildcard($38548887993916f0$exports, $cf7c23996f7ca02b$exports);
$parcel$exportWildcard($38548887993916f0$exports, $0b3f7f13b602e34c$exports);
$parcel$exportWildcard($38548887993916f0$exports, $09fdc5b6c80c863b$exports);
$parcel$exportWildcard($38548887993916f0$exports, $4337405fa3cb23e3$exports);
$parcel$exportWildcard($38548887993916f0$exports, $6e024ab9dc777125$exports);
$parcel$exportWildcard($38548887993916f0$exports, $d998a7169854bd53$exports);
$parcel$exportWildcard($38548887993916f0$exports, $39d32e51da6e71e1$exports);
$parcel$exportWildcard($38548887993916f0$exports, $364d61fce728b12c$exports);
$parcel$exportWildcard($38548887993916f0$exports, $151921a7bcc114ce$exports);
$parcel$exportWildcard($38548887993916f0$exports, $fe2aa3f616bac17d$exports);
$parcel$exportWildcard($38548887993916f0$exports, $3be62df099d5442a$exports);
$parcel$exportWildcard($38548887993916f0$exports, $128bc05158f847f1$exports);
$parcel$exportWildcard($38548887993916f0$exports, $73c99f94e42f596e$exports);
$parcel$exportWildcard($38548887993916f0$exports, $aba0757fcb8e50be$exports);
$parcel$exportWildcard($38548887993916f0$exports, $15b29837b825f1fd$exports);
$parcel$exportWildcard($38548887993916f0$exports, $35ce509aab0856e8$exports);
$parcel$exportWildcard($38548887993916f0$exports, $2797b5f506bf3d03$exports);
$parcel$exportWildcard($38548887993916f0$exports, $7ec1b0ef33b04126$exports);


var $70afc8117e1ccc69$exports = {};

$parcel$export($70afc8117e1ccc69$exports, "ClickOutside", () => $5d336c60fc44541c$export$c16e4f034c84cb3f);
$parcel$export($70afc8117e1ccc69$exports, "Intersect", () => $8d31333abb7bf4e7$export$56a6b724e0c8deeb);
$parcel$export($70afc8117e1ccc69$exports, "Mutate", () => $2493045c9afc0572$export$4a51a50f9614fc39);
$parcel$export($70afc8117e1ccc69$exports, "Resize", () => $a30ddb8f02846b0e$export$76856258f71db1ea);
$parcel$export($70afc8117e1ccc69$exports, "Ripple", () => $907916373bf62ceb$export$9e9146f7e027fdaa);
$parcel$export($70afc8117e1ccc69$exports, "Scroll", () => $839bda94987bf366$export$6ed4a4084f55ee7c);
$parcel$export($70afc8117e1ccc69$exports, "Touch", () => $1f99184c55023168$export$746b04bbf92762fd);
$parcel$export($70afc8117e1ccc69$exports, "Tooltip", () => $66aae560034492e5$export$28c660c63b792dea);


// Types
function $2493045c9afc0572$var$mounted(el, binding) {
    const modifiers = binding.modifiers || {};
    const value = binding.value;
    const { once: once, immediate: immediate, ...modifierKeys } = modifiers;
    const defaultValue = !Object.keys(modifierKeys).length;
    const { handler: handler, options: options } = typeof value === 'object' ? value : {
        handler: value,
        options: {
            attributes: modifierKeys?.attr ?? defaultValue,
            characterData: modifierKeys?.char ?? defaultValue,
            childList: modifierKeys?.child ?? defaultValue,
            subtree: modifierKeys?.sub ?? defaultValue
        }
    };
    const observer = new MutationObserver(function() {
        let mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let observer = arguments.length > 1 ? arguments[1] : undefined;
        handler?.(mutations, observer);
        if (once) $2493045c9afc0572$var$unmounted(el, binding);
    });
    if (immediate) handler?.([], observer);
    el._mutate = Object(el._mutate);
    el._mutate[binding.instance.$.uid] = {
        observer: observer
    };
    observer.observe(el, options);
}
function $2493045c9afc0572$var$unmounted(el, binding) {
    if (!el._mutate?.[binding.instance.$.uid]) return;
    el._mutate[binding.instance.$.uid].observer.disconnect();
    delete el._mutate[binding.instance.$.uid];
}
const $2493045c9afc0572$export$4a51a50f9614fc39 = {
    mounted: $2493045c9afc0572$var$mounted,
    unmounted: $2493045c9afc0572$var$unmounted
};
var $2493045c9afc0572$export$2e2bcd8739ae039 = $2493045c9afc0572$export$4a51a50f9614fc39;




// Types
function $839bda94987bf366$var$mounted(el, binding) {
    const { self: self = false } = binding.modifiers ?? {};
    const value = binding.value;
    const options = typeof value === 'object' && value.options || {
        passive: true
    };
    const handler = typeof value === 'function' || 'handleEvent' in value ? value : value.handler;
    const target = self ? el : binding.arg ? document.querySelector(binding.arg) : window;
    if (!target) return;
    target.addEventListener('scroll', handler, options);
    el._onScroll = Object(el._onScroll);
    el._onScroll[binding.instance.$.uid] = {
        handler: handler,
        options: options,
        // Don't reference self
        target: self ? undefined : target
    };
}
function $839bda94987bf366$var$unmounted(el, binding) {
    if (!el._onScroll?.[binding.instance.$.uid]) return;
    const { handler: handler, options: options, target: target = el } = el._onScroll[binding.instance.$.uid];
    target.removeEventListener('scroll', handler, options);
    delete el._onScroll[binding.instance.$.uid];
}
function $839bda94987bf366$var$updated(el, binding) {
    if (binding.value === binding.oldValue) return;
    $839bda94987bf366$var$unmounted(el, binding);
    $839bda94987bf366$var$mounted(el, binding);
}
const $839bda94987bf366$export$6ed4a4084f55ee7c = {
    mounted: $839bda94987bf366$var$mounted,
    unmounted: $839bda94987bf366$var$unmounted,
    updated: $839bda94987bf366$var$updated
};
var $839bda94987bf366$export$2e2bcd8739ae039 = $839bda94987bf366$export$6ed4a4084f55ee7c;



// Components

// Utilities
parcelRequire("ecd4d");
var $TusQn = parcelRequire("TusQn");
var $eeJ70 = parcelRequire("eeJ70");

function $7a87f84d40b2d900$export$90e2dd3d6933cb6c(component, props) {
    const concreteComponent = typeof component === 'string' ? (0, $TusQn.resolveComponent)(component) : component;
    const hook = $7a87f84d40b2d900$var$mountComponent(concreteComponent, props);
    return {
        mounted: hook,
        updated: hook,
        unmounted (el) {
            (0, $eeJ70.render)(null, el);
        }
    };
}
function $7a87f84d40b2d900$var$mountComponent(component, props) {
    return function(el, binding, vnode) {
        const _props = typeof props === 'function' ? props(binding) : props;
        const text = binding.value?.text ?? binding.value ?? _props?.text;
        const value = (0, $8590040a7833369a$export$a6cdc56e425d0d0a)(binding.value) ? binding.value : {};
        // Get the children from the props or directive value, or the element's children
        const children = ()=>text ?? el.textContent;
        // If vnode.ctx is the same as the instance, then we're bound to a plain element
        // and need to find the nearest parent component instance to inherit provides from
        const provides = (vnode.ctx === binding.instance.$ ? $7a87f84d40b2d900$var$findComponentParent(vnode, binding.instance.$)?.provides : vnode.ctx?.provides) ?? binding.instance.$.provides;
        const node = (0, $TusQn.h)(component, (0, $TusQn.mergeProps)(_props, value), children);
        node.appContext = Object.assign(Object.create(null), binding.instance.$.appContext, {
            provides: provides
        });
        (0, $eeJ70.render)(node, el);
    };
}
function $7a87f84d40b2d900$var$findComponentParent(vnode, root) {
    // Walk the tree from root until we find the child vnode
    const stack = new Set();
    const walk = (children)=>{
        for (const child of children){
            if (!child) continue;
            if (child === vnode || child.el && vnode.el && child.el === vnode.el) return true;
            stack.add(child);
            let result;
            if (child.suspense) result = walk([
                child.ssContent
            ]);
            else if (Array.isArray(child.children)) result = walk(child.children);
            else if (child.component?.vnode) result = walk([
                child.component?.subTree
            ]);
            if (result) return result;
            stack.delete(child);
        }
        return false;
    };
    if (!walk([
        root.subTree
    ])) {
        (0, $5384ffc78a9e124c$export$bf36f23bad3e1069)('Could not find original vnode, component will not inherit provides');
        return root;
    }
    // Return the first component parent
    const result = Array.from(stack).reverse();
    for (const child of result){
        if (child.component) return child.component;
    }
    return root;
}



const $66aae560034492e5$export$28c660c63b792dea = (0, $7a87f84d40b2d900$export$90e2dd3d6933cb6c)((0, $482ba1cc42453374$export$b742615555a86f54), (binding)=>{
    const disabled = (0, $8590040a7833369a$export$a6cdc56e425d0d0a)(binding.value) ? !binding.value.text : [
        '',
        false,
        null
    ].includes(binding.value); // undefined means true
    return {
        activator: disabled ? null : 'parent',
        location: binding.arg?.replace('-', ' '),
        text: typeof binding.value === 'boolean' ? undefined : binding.value
    };
});
var $66aae560034492e5$export$2e2bcd8739ae039 = $66aae560034492e5$export$28c660c63b792dea;







var $22dcfc6d14cd296a$export$2e2bcd8739ae039 = (0, $579bd3b95fd3a255$export$ef34132de12b844b)({
    components: $38548887993916f0$exports,
    directives: $70afc8117e1ccc69$exports,
    icons: {
        defaultSet: 'mdi',
        aliases: $69eac3e379d14be4$export$9af93bb9e9126a2,
        sets: {
            mdi: $69eac3e379d14be4$export$179238ba74376e8c
        }
    },
    theme: {
        defaultTheme: 'light',
        themes: {
            light: {
                colors: {
                    primary: '#203A8F',
                    secondary: '#FFA500',
                    accent: '#82B1FF',
                    error: '#FF5252',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FFC107'
                }
            },
            dark: {
                colors: {
                    primary: '#4C68C4',
                    secondary: '#FFA500',
                    accent: '#FF4081',
                    error: '#FF5252',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FB8C00'
                }
            }
        }
    }
});



const $ad2bcec7a0192558$var$app = (0, $eeJ70.createApp)((0, $ae3de8900c09c2f9$export$2e2bcd8739ae039));
$ad2bcec7a0192558$var$app.use((0, $i0TKe.createPinia)());
$ad2bcec7a0192558$var$app.use((0, $22dcfc6d14cd296a$export$2e2bcd8739ae039));
$ad2bcec7a0192558$var$app.mount('#app');


//# sourceMappingURL=nostr-graph-explorer.6f44181c.js.map
